import * as i0 from '@angular/core';
import { Injectable, Component, ElementRef, Directive, Inject, Input, EventEmitter, Output, HostListener, Pipe, ChangeDetectionStrategy, ViewChild, ViewEncapsulation, forwardRef, InjectionToken, NgModule, Optional, SkipSelf } from '@angular/core';
import * as i1 from '@angular/router';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import * as Rx from 'rxjs';
import { throwError, BehaviorSubject, Subject, catchError as catchError$1, map as map$1, takeUntil as takeUntil$1, combineLatest, from, fromEvent } from 'rxjs';
import { takeUntil, timeout, map, catchError, tap, filter, first } from 'rxjs/operators';
import * as i1$1 from '@angular/common/http';
import { HttpHeaders, HttpEventType, HttpParams, HttpResponseBase, HTTP_INTERCEPTORS } from '@angular/common/http';
import { __awaiter } from 'tslib';
import * as Cookies from 'es-cookie';
import moment_, { now } from 'moment';
import * as i2$1 from '@angular/forms';
import { FormGroup, FormControl, Validators, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i1$2 from '@angular/common';
import { Location as Location$1, LocationStrategy, PathLocationStrategy, DOCUMENT, CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i8 from 'ngx-owl-carousel-o';
import { CarouselModule } from 'ngx-owl-carousel-o';
import * as i5 from 'ngx-international-phone-number';
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import * as i1$3 from '@angular/platform-browser';
import * as i7 from 'primeng/calendar';
import { CalendarModule as CalendarModule$1 } from 'primeng/calendar';
import * as i4 from '@circlon/angular-tree-component';
import { TreeModule } from '@circlon/angular-tree-component';
import { addDays, addWeeks, addMonths, subDays, subWeeks, subMonths, startOfDay, startOfWeek, startOfMonth, endOfDay, endOfWeek, endOfMonth, isSameMonth, isSameDay } from 'date-fns';
import * as i1$4 from 'angular-calendar';
import { CalendarView, CalendarModule, DateAdapter } from 'angular-calendar';
import * as i5$1 from 'ngx-clipboard';
import { ClipboardModule } from 'ngx-clipboard';
import * as d3 from 'd3';
import 'd3-selection-multi';
import d3Tip from 'd3-tip';
import { isNull, isEmpty, isUndefined } from 'lodash';
import moment_time_ from 'moment-timezone';
import * as i4$1 from 'primeng/progressbar';
import { ProgressBarModule } from 'primeng/progressbar';
import * as i2$2 from 'angular-svg-round-progressbar';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { sankey, sankeyLinkHorizontal } from 'd3-sankey';
import * as i2$3 from 'mydatepicker';
import { MyDatePickerModule } from 'mydatepicker';
import jQuery_ from 'jquery';
import * as i4$2 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import * as i6 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i8$1 from '@angular/material/toolbar';
import { MatToolbarModule } from '@angular/material/toolbar';
import * as i4$3 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i5$2 from '@angular/material/divider';
import { MatDividerModule } from '@angular/material/divider';
import * as i11 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import * as i7$1 from '@angular/cdk/scrolling';
import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import * as i4$4 from '@techiediaries/ngx-qrcode';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import Quill from 'quill';
import * as i1$5 from 'ngx-quill';
import { QuillModule } from 'ngx-quill';
import * as noUiSlider from 'nouislider';
import * as i1$6 from '@angular/material/slider';
import { MatSliderModule } from '@angular/material/slider';
import domtoimage from 'dom-to-image';
import jsPDF from 'jspdf';
import * as i9 from '@angular/cdk/bidi';
import html2canvas from 'html2canvas';
import { io } from 'socket.io-client';
import { MatIconModule } from '@angular/material/icon';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import * as i1$7 from 'angularx-flatpickr';
import { FlatpickrModule } from 'angularx-flatpickr';
import { Ng2TelInputModule } from 'ng2-tel-input';
import * as i3 from 'ngx-bootstrap/dropdown';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TagInputModule } from 'ngx-chips';

class ApiConfig {
    constructor(dataService) {
        this.dataService = dataService;
        this.serverBaseUrl = "/api/v1"; /* Base URL for apiserver */
        this.dmsBaseUrl = "api/dms/v3/manage"; /* Base URL for dmsserver */
        this.locationBaseUrl = "/api/location/v1"; /* Base URL for CLE(Cloud Location Engine) server*/
        this.clientBaseUrl = "/client/v1"; /* Base URL for nodeserver */
        this.tmBaseUrl = "/api/tm/v1"; /* Base URL for tenant server */
        this.getDashboardProperties = "/dashboard/properties"; /* Get all properties */
        this.doInteractionLog = "/interaction/doInteractionLog";
        this.tooltipUrl = "/tips/tooltip";
        this.pollTokenURL = "/token/refresh";
        this.verifyTokenURL = "/token/verify";
        this.updateTokenURL = "/user/refreshToken";
        this.mapsBaseUrl = "/api/maps/common/v1";
        this.mapImageBaseUrl = "/api/maps/v1";
        this.iotBaseUrl = "/api/edm/v1";
        this.home = {
            tileConfig: "/home/tiles",
            tileAppConfig: "/home/tile",
            tileCount: "/home/count",
            statsCount: "/home/stats"
        };
        this.tm = {
            loginUser: "/account/local/login",
            shareLoginUser: "/account/report/login?role=",
            sharePinLoginUser: "/account/report/emaillogin?role=",
            selectApp: "/account/services",
            verifyAccount: "/account/verify/token",
            initiateSSOLogin: "/account/login/",
            fetchAccountsSSOLogin: "/account/assigned",
            refreshTokenURL: "/account/refreshToken",
            loginUserstatus: "/account/login/ssostatus",
            sharedLoginTypePreFix: "/report/",
            sharedLoginTypePostFix: "/authtype?role=",
            sharedSSOLoginRedirect: "/account/login/report/",
            oauthAuthenticationURL: "/oauth/authorize",
            tenantCCILogOutURL: "/account/login/logout/"
        };
        this.auth = {
            validate: "/auth/validate" /* validate User */,
            validateAdmin: "/auth/validateAdmin" /* validate User */,
            validateCustomer: "/auth/validateCustomer" /* validate Customer */,
            userActivation: "/user/activateNewUser" /* Activate User */,
            getDemokitContextUrl: "/user/getDemokitContextUrl",
            getActivateUser: "/user/activate" /* Get Activate User */,
            getActivateRedirection: "/user/activateRedirection" /* Get Activate User */,
            getDemokitActivateRedirection: "/user/activateDemokitRedirection",
            forgotPassword: "/user/resetPassword" /* Send Forgot Password User */,
            resetPassword: "/user/resetPassword" /* Reset Password User */,
            getCaptchaTemplate: "/home/recaptcha/get" /* Captcha Template */,
            requestDemo: "/home/requestDemo" /* Request a Demo */,
            logout: "/auth/logout",
            licenseSupport: "/auth/support" /* Trigger License expiry info to support */,
            getTokenForGodDashboard: "/auth/getToken" /* getToken for God Dashboard */,
            redirectUrlForGodDashboard: "/auth/redirectUrl" /* redirect url for God Dashboard */,
            updateTermsStatus: "/user/globalAgreementStatus",
            getLoginHistory: "/user/loginHistory",
            getSuccessLoginHistory: "/user/loginHistory/success",
            getFailureLoginHistory: "/user/loginHistory/failure",
            getFetchUserCustomerUrl: "/user/fetchUserCustomer",
            getValidateSharedSysTokenUrl: "/report/validate/share/sysToken",
            getReportDataBySysTokenUrl: "/report/data",
            extractReportParamUrl: "/report/extract/share/reportToken",
            getProfileInfo: "/user/userDetail",
            updateProfileInfo: "/user/updateUserDetail",
            getRecieveHandshakeDemoKitUrl: "/user/recieveHandshakeDemoKit",
            getInitiateHandshakeDemoKitUrl: "/user/initiateHandshakeDemoKit",
            getDashboardRedirectTokenUrl: "/user/getDashboardRedirectToken",
            getPendingUsersToApproveAccessUrl: "/fetch/pendinglist",
            grantAccessUrl: "/approve/access?approved=",
            viewdReportUrl: "/viewed/report",
            getSenderNameUrl: "/user/report/sender",
            verifyResetPINEmailUrl: "/user/report/verify/resetEmailPin",
            submitSharedFeedbackUrl: "/user/feedback",
            webSocketConnection: "/cameraFeed",
            cameraUserFeed: "/mvcamera/getFeedData",
        };
        this.location = {
            rename: "/location/rename" /* Rename Location */,
            delete: "/location/delete" /* Delete Location */,
            deleteStatus: "/location/deleteStatus" /* Delete Location Status*/,
            list: "/location/list" /* Locations List */,
            timezone: "/location/timezone" /* Location Timezone Update */,
            searchAPs: "/location/search/accesspoints" /* Search APs List */,
            fetchAccessPoint: "/location/accesspoints" /* Get Access Point List */,
            fetchWebexDevices: "/location/webexdevices",
            fetchSensors: "/location/sensorDetails",
            fetchBleBeacon: "/location/bleBeacons" /* Get Ble Beacon List */,
            fetchRulesList: "/rule/list" /* Get Location Details Rules List */,
            fetchEnagementRulesReport: "/rule/report" /* Get Report Details Rules List */,
            getAccessCodeManagerLocations: "/location/accesscode/list" /* Get acc code manager location list for invite users */,
            wirelessProvider: "/location/getUniversalWirelessProvidersList",
            createLocation: "/location/create",
            createMSELocation: "/location/create/mse",
            getAvailableLocations: "/location/getAvailableChildLocations",
            getAvailableLocationsByType: "/getAvailableChildLocations",
            getAvailableAps: "/location/getAvailableAps",
            getMetadataKeys: "/location/getMetadataKeys",
            getMetadataKeyslh2: "/location2/listMetaData",
            authMeraki: "/wirelessprovider/authenticate",
            merakiApiKeysList: "/wirelessprovider/apikeys/list",
            merakiAccessTokensList: "/wirelessprovider/tokens/list",
            disconnectMeraki: "/wirelessprovider/disconnect",
            getMetadata: "/location/getMetaData",
            getLocationMetadata: "/location/getMetaData/",
            addLocationMetadata: "/location/addLocationMetadata",
            addLocationMetadatalh2: "/location2/addLocationMetadata",
            modifyLocationMetadata: "/location/modifyLocationMetadata",
            deleteLocationMetadata: "/location/deleteLocationMetadata",
            getWirelessProviderAuthStatus: "/wirelessprovider/getMerakiWirelessProviderAuthStatus",
            getLocationSyncStatus: "/locationsync/status/all/minimized",
            getWPLocationSyncStatus: "/locationsync/status",
            availableControllerIps: "/location/getAvailableWLCForMSE",
            getEditWLCController: "/location/wlc",
            availableWLCControllerIps: "/location/wlc/controllerips",
            allWLCControllerIps: "/location/connector/controllerips",
            getWLCControllerIps: "/location/wlc/controllers",
            getAvailableWLCNetworks: "/location/wlc/networks",
            getAvailableWLCAPs: "/location/wlc/aps",
            addNetworkLocation: "/location/create",
            getOrganizationFromKey: "/wirelessprovider/authenticate",
            getGroupLocationCreate: "/location/group/create",
            getGroupLocationEdit: "/location/group/edit",
            createGroup: "/location/group/create",
            getMSELocation: "/location",
            updateMSELocation: "/location/update",
            updateWLCController: "/location/update",
            deleteController: "/location/wlc/deleteController",
            getSyncStatus: "/locationsync/status",
            addBleBeacon: "/location/addBleBeacon",
            editBleBeacon: "/location/editBleBeacon",
            deleteBleBeacon: "/location/deleteBleBeacon",
            getBleBeacon: "/location/getBleBeacon",
            getTimeZone: "/location/getTimeZoneIds",
            getMSEImage: "/map/getMSEImageContent",
            getLocationInfo: "/location/getLocationInfo",
            updateLocationInfo: "/location/saveLocationInfo",
            authMSE: "/wirelessprovider/authenticate/mse",
            getManualUploadCampusData: "/location/mse/manual/details",
            getNetworksforOrg: "/location/networks",
            saveMerakiOrganisation: "/location/create/meraki",
            getMerakiLoginNetworkCount: "/location/org/networks/count/login",
            getMerakiAPINetworkCount: "/location/org/networks/count/api",
            getMerakiCameraLoginNetworkCount: "/location/org/cameranetworks/count/login",
            getMerakiCameraAPINetworkCount: "/location/org/cameranetworks/count/api",
            getCMXMapsCount: "/location/mse/count",
            getWLCCount: "/location/wlc/controller/count",
            getCMXLocations: "/location/cmx/locations",
            getCMXLocationsCount: "/location/cmx/locations/count",
            merakiCameraList: "/location/camera/details",
            cameraSnapshot: "/setup/getMerakiCameraSnapshot",
            cameraRetentionDetails: "/setup/getCameraRetentionDetails",
            updateTripWire: "/location/camera",
            prefixList: "/location/wlc/ap/prefixes",
            savePrefix: "/location/update",
            ewlcFeatureFlag: "/featureFlag",
            userCount: "/location/users/count",
            merakiSyncStatus: "/locationsync/status/meraki/minimized",
            fetchDensityRulesList: "/rule/density/list",
            count: "/location/count",
            businessLocationList: "/location/maps/hierarchy",
            getAllMetadata: "/location/metadata"
        };
        this.rules = {
            ruleDetails: "/rule" /* Fetch Rule Details */,
            pauseRule: "/rule/pause" /* Pause Rule */,
            makeLive: "/rule/live" /* Make Rule Live */,
            deleteRule: "/rule/delete" /* Delete a rule */,
            metadataList: "/rule/metadata/fetchAll" /* Fetch metadata list */,
            tagList: "/rule/tags/list" /* Fetch Tag List */,
            saveRule: "/rule/save" /* Save Rule Details */,
            ssidList: "/ssid/list" /* Get SSID List */,
            portalList: "/rule/portal/list" /* Get Portal List */,
            smsGatewayList: "/rule/smsgateway/list" /* Get SMS Gateway List */,
            notificationList: "/rule/notificationchannel/list" /* Get Notifaction Channel List */,
            businessTagsList: "/rule/tags/list/Bizkey" /* Get business tags list */,
            test: "/rule/test" /* Initiate test rule trigger action url */,
            pauseDensityRule: "/rule/density/pause" /* Pause Rule */,
            makeDensityRuleLive: "/rule/density/live" /* Make Rule Live */,
            deleteDensityRule: "/rule/density/delete" /* Delete a rule */,
            saveDensityRule: "/rule/density/save" /* Save Rule Details */,
            engagementRuleList: "/rule/engagements/list",
            engagementRuleSave: "/rule/engagements/save",
            engagementRuleUpdate: "/rule/engagements/update",
            locationPersonasRuleList: "/rule/locationpersonas/list",
            locationPersonasRuleSave: "/rule/locationpersonas/save",
            locationPersonasRuleUpdate: "/rule/locationpersonas/update"
        };
        this.engagementrules = {
            locationList: "/rule/engagements/location/list" /* Engagements Locations List */,
            ruleList: "/rule/engagements/list" /* Engagements Rule List */,
            deleteRule: "/rule/engagements/delete" /* Delete Engagements Rule */,
            pauseRule: "/rule/engagements/pause" /* Pause Engagements Rule */,
            liveRule: "/rule/engagements/live" /* Live Engagements Rule */,
            details: "/rule/engagements" /* Engagements Rule details */
        };
        this.personasrules = {
            locationList: "/rule/locationpersonas/location/list" /* Personas Locations List */,
            ruleList: "/rule/locationpersonas/list" /* Personas Rule List */,
            deleteRule: "/rule/locationpersonas/delete" /* Delete Personas Rule */,
            pauseRule: "/rule/locationpersonas/pause" /* Pause Personas Rule */,
            liveRule: "/rule/locationpersonas/live" /* Live Personas Rule */,
            details: "/rule/locationpersonas" /* Personas Rule details */
        };
        this.sensor = {
            sensorList: "/sensor/list" /* Fetch Sensor List */,
            claimSensor: "/sensor/claim" /* claim sensor */,
            unclaimSensor: "/sensor/unclaim" /* unclaim sensor */,
            getSSIDList: "/sensor" /* get SSID list */,
            connectSSID: "/sensor/connect/ssids" /* connect ssid to sensor */,
            sensorDetail: "/sensor" /* get sensor details */
        };
        this.captiveportalrules = {
            fetchRulesList: "/portal/rule/list" /* Get Location Details Rules List */,
            getRuleCount: "/portal/rule/count",
            ruleDetails: "/portal/rule" /* Fetch Rule Details */,
            pauseRule: "/portal/rule/pause" /* Pause Rule */,
            makeLive: "/portal/rule/live" /* Make Rule Live */,
            deleteRule: "/portal/rule/delete" /* Delete a rule */,
            metadataList: "/portal/rule/metadata/fetchAll" /* Fetch metadata list */,
            tagList: "/portal/rule/tags/list" /* Fetch Tag List */,
            saveRule: "/portal/rule/save" /* Save Rule Details */,
            ssidList: "/ssid/list" /* Get SSID List */,
            portalList: "/portal/rule/portal/list" /* Get Portal List */,
            smsGatewayList: "/portal/rule/smsgateway/list" /* Get SMS Gateway List */,
            notificationList: "/portal/rule/notificationchannel/list" /* Get Notifaction Channel List */,
            businessTagsList: "/portal/rule/tags/list/Bizkey" /* Get business tags list */,
            locationList: "/portal/location/list"
        };
        this.accessCode = {
            locationList: "/location/accesscode/list" /* Access Code Location List */,
            accessCodeList: "/accesscode" /* Get access code list for location details */,
            saveAccessCode: "/accesscode/save" /* Save access code details */,
            updateAccessCode: "/accesscode/update" /* Update Access code details */,
            deleteAccessCode: "/accesscode/delete" /* Update Access code details */,
            deleteAccessCodeTemplate: "/accesscode/deleteTemplate" /* Update Access code details */,
            shareAccessCode: "/accesscode/share/add",
            removeShareEmail: "/accesscode/share/delete",
            toggleAccessCodeStatus: "/accesscode/toggle",
            shareAccessCodeEmail: "/accesscode/share",
            saveAccessCodeTemplate: "/accesscode/template/save" /* Save access code Template details */,
            updateAccessCodeTemplate: "/accesscode/template/update" /* Update Access code Template details */,
            listAccessCodeTemplate: "/accesscode/listTemplate" /* List Access code Template details */,
        };
        this.maps = {
            getApsAndFloorMaps: "/map/getApsAndFloorMap",
            getFloorMaps: "/map/getFloorMapInLocations",
            getImageAsByte: "/map/getByteImage",
            updateMicelloMap: "/map/updateMicelloMap",
            updateMerakiMap: "/map/updateMerakiMap",
            updateMseMap: "/map/updateMseMap",
            updateImageMap: "/map/updateImageMap",
            uploadImageFile: "/map/uploadImage",
            importCmxSites: "/import",
            cmxSitesList: "/basehierarchy",
            uploadPrimeMapsZipFile: "/import/async?comments=",
            uploadDNACMapsZipFile: "/import/dnac?comments=",
            uploadMapsHistoy: "/import/history",
            uploadedStatus: "/import/history/",
            getMapServiceFloorInfo: "/map/getFloorMapInfo",
            getFloorMapImage: "/location/image/"
        };
        this.user = {
            list: "/rbac/admins",
            roleUserList: "/rbac/admin/roles/list",
            getUserInfo: "/rbac/admin/getUserInfo",
            getAdminAppName: "/rbac/admin/role",
            roleApplicationList: "/rbac/applications/list",
            createAdminRole: "/rbac/admin/role/create",
            inviteUser: "/rbac/admin/invite",
            editAdminUser: "/rbac/admin/edit",
            sendInviteUserMail: "/team/sendInviteUserMail",
            sendDemokitInviteUserMail: "/team/sendDemokitInviteUserMail",
            sendInviteSsoUserMail: "/team/sendInviteSsoUserMail",
            deleteUser: "/rbac/admin/delete",
            deleteUserStatus: "/rbac/admin/status/delete",
            deleteUserRole: "/rbac/admin/role/delete",
            deleteAdminRoleStatus: "/rbac/admin/role/status/delete",
            editUser: "/team/editUser",
            changePassword: "/user/changePassword" /* Reset Password User */,
            extractRole: "/user/extractRole",
            fetchRole: "/user/fetchRole",
            resendInvite: "/team/resendInvite",
            editRole: "/rbac/admin/role/update",
            // licensetype: '/user/license/type',
            expiredLicense: "/user/expiredLicense",
            provisionTokenForUser: "/user/provisionTokenForUser",
            createShareReport: "/user/createReport",
            reShareReport: "/reshare",
            fetchULAConfig: "/user/provision",
            loginUser: "/user/loginUser",
            currentUserStatus: "/user/current/status",
            checkEmailPinUrl: "/user/reportEmailPinStatus",
            setEmailPinUrl: "/user/reportSetEmailPin",
            requestAccessUrl: "/user/requestShareReportAccess",
            resetEmailPINUrl: "/user/report/resetEmailPin",
            sharedUsersListUrl: "/shareitem/listusers",
            revokeUsersUrl: "/revoke/users",
            getLoginRequest: "/request/login",
            getSLDetails: "/user/getSmartLicenseDetail",
            registerSmartLicense: "/user/register/smartLicense",
            renewAuthSmartLicense: "/user/renewAuth/smartLicense",
            renewRegistrationSmartLicense: "/user/renewRegistration/smartLicense",
            reRegisterSmartLicense: '/user/reRegister/smartLicense',
            getAuditTrailUrl: '/auditTrail/list',
            getAuditTrailFilteredUrl: '/auditTrail/listFiltered',
            getAuditTrailEnabledAppsUrl: '/auditTrail/auditTrailEnabledApps',
            deRegisterSmartLicense: '/user/deregister/smartLicense',
            changeBaseLicense: '/user/changeLicense/smartLicense',
            listCountry: '/user/list/country',
            updateCountry: "/user/updateCountryDetail"
        };
        this.appuser = {
            list: "/rbac",
            getAppUserInfo: "/rbac/captiveportal/getUserInfo",
            inviteUser: "/rbac",
            resendInviteUser: "/rbac",
            editUser: "/rbac",
            deleteUser: "/rbac",
            rolelist: "/rbac",
            currentAppUserStatus: "/portal/current/status",
            resendCPAppInvite: "/team/resendCPAppInvite",
            ssoRoleList: "/rbac/captiveportal/role/list",
            ssoCreateRole: "/rbac/captiveportal/role/create",
            ssoDeleteRole: "/rbac/captiveportal/role",
            ssoUpdateRole: "/rbac/captiveportal/role/update",
            resendAppInvite: "/team/resendAppInvite"
        };
        this.portal = {
            saveTemplateSetting: "/portal/saveTemplateSetting" /* saveTemplateSetting */,
            getTemplateSetting: "/portal/getTemplateSetting" /* getTemplateSetting */,
            list: "/portal/list" /* Portal List */,
            getPortal: "/portal/getPortal" /* Get Portal */,
            getPortalConfig: "/portal/getConfig" /* Get Portal Config */,
            getDefaultConfig: "/portal/getPortalDefaultConfig",
            createPortal: "/portal/create" /* Create Portal */,
            renamePortal: "/portal/rename" /* Rename Portal */,
            importPortal: "/portal/import" /* Import Portal */,
            deletePortal: "/portal/delete" /* Delete Portal(s) */,
            updatePortal: "/portal/updateConfig" /* Update Portal */,
            publishPortal: "/portal/publish" /* Update Portal */,
            uploadFile: "/portal/uploadFile" /* Upload File */,
            uploadFileForSDK: '/portal/uploadFileForSDK',
            deleteFileForSDK: '/portal/deleteFileForSDK',
            uploadFileForModules: "/portal/uploadFileForModules" /* Upload File */,
            copyAssets: "/portal/copyAssets" /* Copy Assets for Publish Portal */,
            copyCss: "/portal/copyCss" /* Copy CSS for Publish Portal */,
            sendPreviewUrl: "/portal/mail/preview" /* Send Preview Url */,
            addLocation: "/portal/addLocation" /* Add Location */,
            addLocations: "/portal/addLocations" /* Add Locations */,
            updatePortalLanguages: "/portal/updateLanguages" /* Update Portal Languages */,
            extractAndUploadZip: "/portal/extractAndUploadZip",
            updateLanguageAsset: "/portal/uploadLanguageSettings",
            downloadLanguageAsset: "/portal/downloadLanguageSettings",
            exportPortal: "/portal/export",
            checkPortalAvailable: "/portal/checkPortalAvailable",
            locale: "/portal/locale",
            getAppDetails: "/portal/getAppDetails",
            createSamplePortal: "/portal/createSample",
            getAppAccessCodeManagerLocations: "/portal/accesscode/list" /* Get acc code manager location list for invite users */
        };
        this.csseditor = {
            assets: "/portal/assets/list",
            css: "/portal/css/read",
            uploadCss: "/portal/css/upload",
            saveCss: "/portal/css/save",
            extractAndUploadAssetsZip: "/portal/extractAndUploadAssetsZip",
            deleteAsset: "/portal/deleteAsset",
            replaceAsset: "/portal/replaceAsset",
            extractAndUploadAssetsZipByDND: "/portal/extractAndUploadAssetsZipByDND",
            uploadFileByDND: "/portal/uploadFileByDND" /* Upload File */
        };
        this.toolkit = {
            dmsProxy: "/dms/proxy",
            dmsV3Proxy: "/dms/v3/proxy",
            smsGatewayList: "/toolkit/smsgateway/list" /* List SMS Gateways of Customer */,
            smsGatewayTypes: "/toolkit/smsgateway/types" /* List SMS Gateways Types available */,
            socialAppsList: "/toolkit/socialapps/list" /* List Social Apps */,
            updateFacebook: "/toolkit/socialapps/updateFacebook",
            updateTwitter: "/toolkit/socialapps/updateTwitter",
            updateLinkedin: "/toolkit/socialapps/updateLinkedIn",
            notificationChannelsList: "/toolkit/notification/list" /* List Notification Channels */,
            bleUuidsList: "/toolkit/uuids/list" /* UUIDs List */,
            sdkList: "/toolkit/sdk/list",
            saveSMSGateway: "/toolkit/smsgateway/save",
            deleteSMSGateway: "/toolkit/smsgateway/delete",
            updateSMSGateway: "/toolkit/smsgateway/update",
            savePushConfigurationUrl: "/toolkit/notification/savePushConfiguration",
            bleUuidDelete: "/toolkit/uuids/delete",
            bleUuidAdd: "/toolkit/uuids/add",
            cmxConnectorsList: "/connector/list",
            hotspotConfig: "/connector/hotspotConfig",
            cmxConnectorDetails: "config/connector",
            connectorService: "/service",
            connectorUpgrade: "/upgrade",
            cmxControllersList: "/connector/controllers" /* CMX Connector List */,
            cmxConnectorDelete: "/toolkit/cmxconnectors/delete",
            cmxConnectorAdd: "/connector/add",
            cmxControllerAdd: "/connector/controller",
            cmxControllerUpdate: "/connector/controller",
            testCredentials: "/config/device/connectivity/test",
            getCertChain: "/edm/stream/cert/cachain",
            cmxConnectorNameUpdate: "/connector",
            getAccessToken: "/connector/token",
            deleteConnector: "/connector",
            deleteController: "/connector/controller",
            deleteControllerWLC: "/setup/wirelessProvider/directwlc",
            addHotspot: "/connector/hotspot/add",
            getHotspotList: "/connector/hotspot/list",
            deleteNotificationChannel: "/toolkit/notification/delete",
            saveNotificationChannel: "/settings/sendNotificationChannelMail",
            renameNotificationChannel: "/toolkit/notification/rename",
            getSMSLimit: "/toolkit/smslimit/list",
            saveSMSLimit: "/toolkit/smslimit/save",
            getWebexAccountList: "/toolkit/webex/list",
            saveWebexAccount: "/toolkit/webex/save",
            deleteWebexAccount: "/toolkit/webex/delete",
            getWebexAuthenticate: "/webex-team/authenticate",
            getWebexRoomList: "/webex-team/roomList",
            getWebexCheckEmail: "/webex-team/checkEmail",
            getOnPremAccessToken: "/connector",
            getCMXOnPremConnectorsList: "/connector/cmx",
            enableHotspotDebugMode: "config/container",
            hotspotService: "/service/hotspot",
            getSwitchesList: "/connector/switch",
            configureSwitch: "/connector/configureIoT/switch",
            connectorControllers: "/connector/connectorController",
            connectorSwitchs: "/connector/connectorSwitches",
            connectorServices: "/connector/connectorServices",
            addConnectorServices: "/connector/services/add",
            getServicesForConnector: "/dms/connector/:connectorId/service",
            upgradeServices: "/connector/services/upgrade",
            deleteServices: "/connector/services/delete",
            restartServices: "/connector/services/restart",
            restartInstance: "/connector/instance/restart",
            restartInstanceServices: "/connector/instance/services/restart",
            //serviceMetricsStats: "/connector/stats/:connectorId/:service/:instances/:interval/:startTime/:endTime/:sampleRate",//may need to change
            serviceMetricsStats: "/connector/stats/:connectorId/:service/:instances/:interval/:sampleRate",
            connectorInstances: "/connector/instances",
            deleteConnectorInstance: "/connector/instances",
            //instanceServiceStatus: "/connector/service/status", recent
            upgradeConnectorStatus: "/connector/status/upgrade",
            upgradeConnector: "connector/upgrade",
            listSummaryCounts: "/connector/count",
            instanceInfoServiceMetric: "/connector/instance/service/metric/:connectorId/:instances/:service",
            instanceServiceStatus: "/connector/instance/service/status/:connectorId/:instanceId",
            uploadV3logs: "service/:service/upload-log"
        };
        this.dataexport = {
            authenticateSFTP: "/export/authenticate",
            createExport: "/export/create",
            exportDataList: "/export/list",
            deleteExport: "/export/delete"
        };
        this.reportsDataexport = {
            authenticateSFTP: "/reports/export/authenticate",
            createExport: "/reports/export/create",
            exportDataList: "/reports/export/list",
            deleteExport: "/reports/export/delete",
            updateExport: "/reports/export/update",
            uploadKey: "/reports/export/upload"
        };
        this.ssid = {
            ssidList: "/ssid/list",
            ssidListV2: "/ssid/listV2",
            ssidDetail: "/ssid/detail",
            ssidStatus: "/ssid/status",
            deleteSSID: "/ssid/delete",
            deleteSSIDConfig: "/ssid/delete",
            addMSESsid: "/ssid/addmse",
            getImportSSIDOrg: "/ssid/meraki/orgdetails",
            manualConfiguration: "/ssid/manualConfiguration",
            networkSSID: "/ssid/importedSSIDsWithOrg",
            importMerakiSSID: "/ssid/addListOfSSIDs",
            updateSSID: "/ssid/update",
            walledGardenDomains: "/ssid/checkWalledGardenRanges",
            walledGardenRanges: "/ssid/walledGardenRanges",
            networkStatus: "/ssid/merakiSSIDSyncStatus"
        };
        this.impactAnalysis = {
            appCurrentStatusUrl: "/report/ia/current/status",
            getEventListUrl: "/report/ia/events/data",
            getEventDetailstUrl: "/report/ia/events/details",
            addEventUrl: "/report/ia/events/add",
            updateEventUrl: "/report/ia/events/update/",
            deleteEventUrl: "/report/ia/events/delete/id"
        };
        this.energyUtilization = {
            settingsUrl: "/report/ea/customer/settings/",
            poeUrl: "/report/ea/poe/",
            pduUrl: "/report/ea/pdu/",
            historicalPdu: "/report/ea/pdu",
            historicalPoe: "/report/ea/poe"
        };
        this.report = {
            serverUrl: "/report/general/monthly?periodKey=",
            adminServerUrl: "/report/god/product?",
            overallReportsUrl: "/report/overall?",
            reportsUrl: "/report/",
            realTimeReportsUrl: "/report/realtime?",
            locationAnalyticsCheckUrl: "/report/analytics/check?",
            locationAnalyticsListSSIDUrl: "/report/location/analytics/ssid/list?",
            locationAnalyticsDate: "/report/location/analytics/date?",
            locationAnalyticsUrl: "/report/location/analytics/chart?",
            analyticsReportsUrl: "/report/analytics/reports",
            rightNowReportsUrl: "/report/rightnow",
            rightMapViewNowReportsUrl: "/report/rightnow/mapview",
            rightNowCameraReportsUrl: "/report/videorightnow",
            rightNowVideoMapViewUrl: "/report/videomapview",
            rightNowSettingsUrl: "/report/rightnow/settings",
            saveRightNowSettingsUrl: "/report/rightnow/settings/save",
            getRightNowSSIDListUrl: "/report/rightnow/ssidlist",
            saveRightNowSSIDSettingsUrl: "/report/rightnow/settings/excludessid",
            rnowSaveCategoryUrl: "/report/rightnow/settings/visitorcategory",
            analyticsAppCurrentStatusUrl: "/report/location/analytics/current/status",
            rightNowAppCurrentStatusUrl: "/report/rightnow/current/status",
            rnowBLEListUrl: "/device/meta/group",
            rightNowFirstPermittedLocationUrl: "/report/rightnow/location"
        };
        this.locationAnalytics = {
            getDwellUrl: "/setup/locationanalytics/dwell",
            updateDwellUrl: "/setup/locationanalytics/dwell/update?",
            reportsUrl: "/report/la/reports",
            reportsCheckUrl: "/report/la/check?",
            reportsSSIDUrl: "/report/la/ssid/list?",
            reportsDateUrl: "/report/la/date?",
            reportsChartUrl: "/report/la/chart?",
            getAnalyticsTop2LocationsUrl: "/report/la/top2locations",
            getAnalyticsTop2SSIDsUrl: "/report/la/top2ssids",
            reportsDeleteUrl: "/report/la/reports/delete",
            getLocationByTypeUrl: "/report/la/location"
        };
        this.admin = {
            addserviceinto: "/admin/add/service",
            availableServices: "/admin/customer/service",
            customerList: "/admin/customer/list",
            customerCreation: "/admin/customer/create",
            customerUpdation: "/admin/customer/update",
            customerDetails: "/admin/customer/details",
            metadata: "/admin/customer/metadata",
            godDashboardData: "/report/admin/overview",
            godDashboardDataNew: "/report/god/product",
            godCustomerStats: "/report/god/customer/stats",
            demokituserinvite: "/admin/user/invite",
            slTrialDate: '/admin/customer/slTrialDate',
            addSLTrial: '/admin/customer/saveSlTrial',
            getSSOLoginStatus: '/admin/status',
            csmProvisionList: '/admin/customer/provision/list',
            csmCustomerDetails: '/admin/customer/provision/details',
            csmCustomerUpdate: '/admin/customer/provision'
        };
        this.tiles = {
            getRuleCount: "/rule/count"
        };
        this.monitoring = {
            monitor: "/monitor/monitorStatus",
            support: "/monitor/supportStatus",
            appList: "/monitor/appList",
            reportDateAll: "/monitor/reportDateAnomalyAllStatus",
            summary: "/monitor/summary",
            locUpdates: "/monitor/locUpdates",
            oneweekAnomaly: "/monitor/oneweekAnomaly",
            appsDetails: "/monitor/appsDetails",
            enterpriseInteg: "/monitor/enterpriseInteg",
            appLatency: "/monitor/appLatency",
            parternApps: "/monitor/parternApps",
            appsDown: "/monitor/appDownList",
            connectorDetails: "/monitor/connectorDetails",
            partnerAppDetails: "/monitor/partnerAppDetails",
            webExDeviceDetails: "/monitor/webExDeviceDetails"
        };
        this.setup = {
            getSetupList: "/setup/list",
            saveSetupWidget: "/setup/widgets/save",
            getConfiguredWidgets: "/setup/widgets/list",
            getDataForWidgets: "/setup/wirelessProvider",
            deleteWirelessWidgetData: "/setup/widgets/delete",
            getDataForWiredWidgets: "/setup/wiredNetwork/wirelessProvider",
            getBusinessLocationList: "/maps/bl/list",
            addLocation: "/maps/addLocation",
            updateLocationInfo: "/maps/updateLocationInfo",
            getRichMapsLocationList: "/maps/rm/list",
            updateBusinessLocationUrl: "",
            uploadRichMapForLocation: "/rms/v1/workflow/upload",
            uploadCADForLocation: "/rms/v2/workflow/upload",
            confirmCADForLocation: "/rms/v2/workflow/uploadConfirm",
            cancelRichMapForLocation: "/rms/v1/workflow/cancel",
            cancelDigitalMap: "/rms/v2/workflow/cancel",
            deleteRichMapForLocation: "/rms/v1/workflow/delete",
            uploadBusinessLocation: "/maps/uploadLocationExcel",
            updateMetaData: "/maps/updateMetaData",
            mapHierarchy: "/maps/getExcelDataWithHierarchy",
            mapsSummary: "/maps/summary",
            saveBusinessLocations: "/maps/saveLocations",
            importSummary: "/maps/bl/import/summary",
            reviewLocations: "/maps/reviewLocations",
            getWebexSetupStatus: "/wirelessprovider/getWebExAuthStatus",
            getSaveWebExToken: "/wirelessprovider/integrateWebEx",
            getFloorDetails: "/rms/v1/floors",
            getRichmapsHistory: "/rms/v2",
            getFloorIndex: "/rms/v1/floorIndex",
            getCSVFile: "/maps/exportLocations",
            getReviewMapLocationList: "/maps/rm/reviewLocationsList",
            getAddMapLocationList: "/maps/rm/addMapLocationsList",
            getActivatePxGrid: "/pxgrid/activate",
            getPxGridDevice: "/pxgrid/list/device",
            getWebexList: "/wirelessprovider/webexkeys/list",
            getDisconnectWebex: "/wirelessprovider/disconnect",
            updateLocation: "/maps/updateLocationInfo",
            createFloors: "/maps/createFloors",
            addFloor: "/maps/addFloor",
            digitalMapFloorListUrl: "/maps/listFloors",
            digitalMapUpdateFloorsUrl: "/maps/updateFloors",
            digitalMapFloorMappingUrl: "/rms/v2/workflow/floorMapping",
            saveMapUrl: "/rms/v2/workflow/save",
            digitalMapBulkUploadUrl: "/rms/v2/workflow/bulkUpload",
            digitalMapfileUploadUrl: "/rms/v2/workflow/fileUpload",
            deleteDigitalMapForLocation: "/rms/v2/workflow/delete",
        };
        this.openroaming = {
            global: "/report/open/roaming/global",
            chart: "/report/open/roaming/chart",
            visit: "/report/open/roaming/visit/chart",
            dailyChart: "/report/open/roaming/chart/today",
            dailyVisit: "/report/open/roaming/visit/chart/today",
            IDPLabel: "/report/open/roaming/idp",
            getORProfileList: "/or/profile/list",
            saveORProfile: "/or/profile/save",
            deleteORProfile: "/or/profile",
            getORProfile: "/or/profile",
            getSPList: "/or/sp/list",
            getDomainList: "/or/domain/list",
            getSPPartnerList: "/or/sp/partner/list",
            saveCustomServiceProvider: "/or/sp/save",
            saveCustomDomain: "/or/domain/save",
            getAgreementStatus: "/setup/or/agreementStatus",
            saveAgreementStatus: "/setup/or/agreementStatus",
            getConfiguredProfileList: "/or/controllers/profile/list",
            saveProfileToController: "/or/controllers/profile/configure",
            locationList: "/or/location/list",
            // Meraki APIs
            getMerakiNwCount: "/or/msnetworks/count",
            getMerakiNwProfileList: "/or/msnetworks/profile/list",
            createMerakiNwProfile: "/or/msnetworks/profile/configure",
            getMerakiNwProfile: "/or/msnetworks/profile" /* /or/msnetworks/profile/<id> */,
            getMerakiNwOrgList: "/or/msnetworks/orgs/list",
            getMerakiNwList: "/or/msnetworks" /* /or/msnetworks/<orgId>/networks */,
            getMerakiNwActivationStatus: "/or/msnetworks/ssids/status",
            getControllers3Configurations: "/openroaming/controller/config"
        };
        this.density = {
            overall: "/report/density/trigger/overall",
            recentActivity: "/report/density/recent/activity",
            recentActivityCount: "/report/density/recent/activity/count",
            triggerHistoryDay: "/report/density/trigger/history/day",
            triggerHistoryDayCount: "/report/density/trigger/history/day/count",
            triggerHistoryDayLocationCount: "/report/density/trigger/history/day/location/count",
            triggerHistoryMonth: "/report/density/trigger/history/month"
        };
        this.partnerApps = {
            appList: "/appcenter/partnerapps/list",
            getPartner: "/appcenter/partnerapps/partner",
            updatePartner: "/appcenter/partnerapps/save",
            createPartner: "/appcenter/partnerapps/save",
            uploadImageFile: "/partner/uploadImage",
            activatedAppList: "/appcenter/partnerapps/getActivatedApps",
            // partnerAppList: '/appcenter/partnerapps/getPartnerApps',
            partnerAppList: "/appcenter/partnerapps/appCenter",
            getAppDetails: "/appcenter/partnerapps/getApp",
            getAppStatus: "/appcenter/partnerapps/activatedAppStatus",
            activateApp: "/appcenter/partnerapps/activateApp",
            autoActivatePartnerAppUrl: "/appcenter/partnerapps/autoActivateApp",
            deleteAutoActivationUrl: "/appcenter/partnerapps/deleteAutoActivation",
            deleteAutoActivatedAppUrl: "/appcenter/partnerapps/deleteAutoActivatedApp",
            savePartnerCustomerInfo: "/appcenter/partnerapps/savePartnerCustomerInfo",
            getPartnerAppSSOLoginToken: "/appcenter/partnerapps/getPartnerAppSSOLoginToken",
            getSandboxCustomers: "/appcenter/partnerapps/sandboxCustomers",
            sandboxToken: "/partner/token",
            deactivateUrl: "/appcenter/partnerapps/deactivateApp",
            checkPartnerLicenseStatus: "/appcenter/partnerapps/license/status",
            updatePartnerLicense: "/appcenter/partnerapps/license/update",
            licenseAgreement: "/partner/partnerLicense",
            partnerLicenseInfo: "/appcenter/partnerapps/license/info",
            deleteImgUrl: "/partner/deleteImage",
            onPremAppActivation: "/appcenter/partnerapps/generateActivationKey",
            onPremAppToken: "/appcenter/partnerapps/getOnPremiseToken",
            onNewPremAppToken: "/appcenter/partnerapps/getNewOnPremiseToken",
            renewOnPremiseToken: "/appcenter/partnerapps/renewalActivationKey",
            regenOnPremiseToken: "/appcenter/partnerapps/regenerateActivationKey",
            customEventsUrl: "/appcenter/partnerapps/events",
            activatedAppDetails: "/appcenter/partnerapps/getActivatedAppDetails",
            activateOnPremApp: "/appcenter/partnerapps/updateOnPremiseApp",
            pendingActivation: "/appcenter/partnerapps/pendingActivation",
            updatePartnerAppsLocations: "/appcenter/partnerapps/updateLocation",
            deactivateActivationUrl: "/appcenter/partnerapps/deleteActivation",
            activatedPartnerTenantsUrl: "/appcenter/partnerapps/getActivatedPartnerTenants",
            getAdvancePartner: "/appcenter/partnerapps/advancePartner",
            getShowAppCenter: "/appcenter/partnerapps/showAppCenter",
            getAppCenterFilters: "/appcenter/partnerapps/filters",
            getAppActivationLicense: "/partner/getAppActivationLicense",
            getCheckTNCAccepted: "/appcenter/partnerapps/getAppActivationTC",
            saveTNCAccepted: "/appcenter/partnerapps/saveAppActivationTC",
            listEndDevices: "/appcenter/partnerapps/listAllDevices",
            deviceDetail: "/appcenter/partnerapps/device",
            compatibleDevices: "/appcenter/partnerapps/compatibleDevices",
            searchPartner: "/admin/searchPartner",
            getIsPartner: "/appcenter/partnerapps/partner",
            getCheckCustomTNCAccepted: "/appcenter/partnerapps/getAppActivationCustomTC",
            saveCustomTNCAccepted: "/appcenter/partnerapps/saveAppActivationCustomTC",
        };
        this.appCenter = {
            activatedAppList: '/appcenter/partnerapps/activations',
            removeAppActivations: '/appcenter/partnerapps/:appId/activations',
            getAppActivations: '/appcenter/partnerapps/:appId/activations',
            updateAcceptedPermissions: '/appcenter/partnerapps/:appId/activations/permissions'
        };
        this.oauth = {
            getAccessToken: "/appcenter/partnerapps/oauth/accessToken",
            getCustomerInfo: "/partner/partnerInfo",
            validateSSOToken: "/partner/validateSSOToken",
            getPartnerPublicKey: "/partner/partnerPublicKey"
        };
        this.preferences = {
            domainList: "/preference/domain",
            addDomain: "/preference/add/domain/",
            removeDomain: "/preference/domain/",
            getSupportLoginStatus: "/preference/status/support/login",
            enableSupportLogin: "/preference/support/login/"
        };
        this.hubspot = {
            detailByContactId: "/hubspot/customer/outbound",
            submitOutBoundForm: "/hubspot/customer/create"
        };
        this.integrations = {
            createNewActivation: "/dnac/activations/new",
            listActivations: "/dnac/activations/list",
            regenerateToken: "/dnac/activations/regenerate/",
            deleteActivation: "/dnac/activations/",
            knowMoreContent: "/dnac/knowmorecontent/",
            integrationActivationUrl: "/integ/"
        };
        this.cameraMetrics = {
            getReportUrl: "/report/camera/metrics/"
        };
        this.behaviorMetricsApp = {
            biReport: "/report/spaces/businessmetrics/v1/retail/",
            workspacesReport: "/report/bi/workspace/",
            educationReport: "/report/bi/education/",
            locationMetadataUrl: "/locationData"
        };
        this.smsgateway = {
            sendOTP: "/sms/gateway/sendotp",
            verifyOTP: "/sms/gateway/verifyotp"
        };
        this.apps = {
            currentStatus: "/apps/current",
            invite: "/apps/invite/user",
            delete: "/apps/delete/user",
            list: "/apps/user",
            getAppUserInfo: "/apps/getUserInfo",
            getAppDeleteStatus: "/apps/user/delete/status"
        };
        // sdk app
        this.sdk = {
            list: '/sdk/list',
            getSDKDetails: '/sdk',
            createSDK: '/sdk/create',
            updateSDK: '/sdk/update',
            deleteSDK: '/sdk/delete',
            sdkProfile: '/sdk/wifi/profile',
            updateSDKProfile: '/sdk/wifi/update/profile',
            consortiumDetails: '/sdk/consortium/config'
        };
        /* Calendar Service Integrations  Start */
        this.calendarIntegration = {
            calendarServiceDomain: 'https://calendar.dev-dnaspaces.io',
            //calendarServiceDomain: 'http://localhost:8888',
            calendarBaseUrl: '/calendar-service/v1/multitenant',
            calendarBaseUrlForActivation: '/calendar-service/v1/calendar/multitenant/signup',
            getActivationInfo: '/activationinfo',
            removeActivationInfo: '/remove/activation',
            getCalendarActivationInfo: '/calendar/list/activations',
            activateCalendar: '/calendar/activate',
            removeCalendarActivation: '/calendar/activation',
            mappedRooms: '/calendar/mapped/rooms',
            clear: '/calendar/clear'
        };
        /* Calendar Service Integrations  End */
        this.tracer = {
            trace: "/tracer/trace",
            jwtToken: "/trace/generateToken",
            decodeToken: "/trace/decodeToken",
            appInfo: "/tracer/trace/appinfo"
        };
        this.getTraceKey = () => {
            return this.serverBaseUrl + this.tracer.trace;
        };
        this.getTraceJWTToken = () => {
            return this.clientBaseUrl + this.tracer.jwtToken;
        };
        this.getTraceDecodeToken = () => {
            return this.clientBaseUrl + this.tracer.decodeToken;
        };
        this.getTraceAppInfo = () => {
            return this.serverBaseUrl + this.tracer.appInfo;
        };
        this.environmentalMetrics = {
            allFloors: '/envmetrics/floors/',
            floorView: '/envmetrics/floor/',
            overview: '/envmetrics/overview',
            settings: '/envmetrics/settings',
            saveSettings: '/envmetrics/settings/save',
            sensors: '/envmetrics/sensors/',
            month: '/envmetrics/month',
            floorCount: '/envmetrics/floors/count',
            sensorCount: '/envmetrics/available/sensors',
            workspaces: '/envmetrics/workspaces',
            violationSummary: '/envmetrics/summary/violation/',
            workspaceInfo: '/envmetrics/location/workspaceInfo',
            date: '/envmetrics/date',
            envAppCurrentStatusUrl: "/envmetrics/current/status",
        };
        this.businessHierarchy = {
            switchesCount: "/location2/switch/:locationId",
            mapsDetails: "/location2/maps/details",
            apList: "/location2/:locationId/accesspoints",
            sensorList: "/location2/sensorDetails/:locationId",
            apCount: "/location2/:locationId/countInfo",
            searchAps: "/location2/search/accesspoints",
            getLocLicenseType: "/location2/license",
            globalLicenseUsage: "/location2/license/globalUsage",
            saveLocationLicenseInfo: "/location2/saveLocationLicenseInfo",
            updateLocationV2Info: "/location2/updateLocationInfo",
            getFloorImageFromS3: "/businesshierarchy/getFloorImageFromS3",
            getImageAsByte: "/map/getByteImage",
            getFloorImage: "/location2/maps/image",
            getFloorDetails: "/location2/maps/floor",
            // Camera APIs
            getCameraList: "/location2/camera",
            searchCamera: "/location2/search/camera",
            updatePolygonZoneUrl: "/location2/maps/zone/update",
            createPolygonZoneUrl: "/location2/maps/zone/create",
            getLocation2SyncStatusUrl: "/locationsync/status",
            renameLoc2Url: "/location2/rename",
            getLocationViewPreferenceUrl: "/location2/locationViewPreference",
            setLocationViewPreferenceUrl: "/location2/locationViewPreference",
            listApPrefix: "/location/wlc/ap/prefixes",
            recentSearch: "/location2/recentSearch",
            saveRecentSearch: "/location2/save/recentSearch",
            searchMatchingAp: "/location/wlc/aps",
            updateApPrefix: "/location/update",
            deleteLocationV2: "/location/delete",
            deleteLocationStatus: "/location/deleteStatus",
            getMetadataKeys: "/location2/getMetadataKeys",
            getMetadata: "/location2/getMetaData",
            addLocationMetadata: "/location2/addLocationMetadata",
            modifyLocationMetadata: "/location2/modifyLocationMetadata",
            deleteLocationMetadata: "/location2/deleteLocationMetadata",
            locationInfoForBulkUpdate: "/location2/locationInfoForBulkUpdate",
            bulkUpdateLocationMetadata: "/location2/bulkUpdateLocationMetadata",
            bulkUpdateLocationInfo: "/location2/bulkUpdateLocationInfo",
            uncategorisedApCount: "/location2/wlc/uncategorized/apsCount",
            uncategorizedApList: "/location2/wlc/uncategorized",
            autoPrefixStatus: "/location/wlc",
            autoPrefixStatusUpdate: "/location/update",
            webexTPList: "/location2/webexdevices",
            devicesAttached: "/location2/attachedDevice",
            createGroup: "/location2/create",
            getTenantLocationMetadata: "/location2/getTenantLocationMetadata",
            postBrowserDetails: "/location2/capture/BrowserDetails",
            getIndexedDBFlattened: "/indexeddb/list",
            getRMSStatus: "/location2/:locationId/richmaps/status",
            indexedDBVersion: "/location2/indexedDBVersion",
            forceRefreshTenant: "/location2/lh2RefreshStatus",
            permissionChangeStatus: "/location2/userPermissionChange/status"
        };
        this.iotExplorer = {
            uploadSensor: '/iot/upload/devices',
            importSensors: '/iot/import/devices',
            createUseCase: '/iot/usecases',
            updateUseCase: '/iot/usecases/',
            deleteUseCase: '/iot/usecases/',
            getUseCaseList: '/iot/usecases/',
            getUseCaseListCount: "/iot/usecases/list/count",
            getUseCaseDetail: '/iot/usecases/details/',
            getSensorList: '/iot/device/list/',
            locationHierarchy: '/iot/locations',
            locationHierarchyDeviceCount: '/iot/location/device/count',
            floorDetails: '/iot/location/floor/details/',
            configuredCount: '/iot/configure/count/',
            floorAps: '/iot/locations/ap',
            occupancyFloorDetails: '/iot/occupancy/floor/details',
            updateOccupancyFloor: '/iot/occupancy/floor/update/',
            getAttributeList: "/iot/attributes/",
            saveAttributes: "/iot/attributes/",
            validDelAttributes: "/iot/attribute/validate/",
            downloadSensorTemplate: "/iot/download/template/",
            existingDeviceList: "/iot/existing/devices/",
            getSensorCount: "/iot/existing/devices/count/",
            saveExistingSensor: "/iot/existing/devices/save/",
            addAssetManually: "/iot/add/assets/",
            searchMacAddress: '/iot/assets/search/',
            getAssetDetail: '/iot/assets/',
            deleteOccupancySensor: "/iot/occupancy/sensor/delete/",
            deleteManualSensor: "/iot/assets/",
            deviceLastHeard: "/iot/assets/timestamp/",
            filterSearchValue: "/iot/filter/search/",
            filterSearchApply: '/iot/search/doc/',
            locatorList: '/iot/assets/locator/search/',
            defaultViewCount: '/iot/assets/count/',
            updateAssetUrl: '/iot/update/assets/',
            temperatureHistoryUrl: '/iot/device/history/',
            dummyTemperatureHistoryUrl: '/iot/device/history/dummy/',
            minimumDateUrl: '/iot/device/history/date/',
            commonRuleUrl: '/iot/rules/',
            ruleDetailUrl: '/iot/rules/details/',
            locMetadataUrl: '/iot/rules/loc/metadata/',
            assetMetadataUrl: '/iot/rules/asset/metadata/',
            roleUrl: '/iot/roles/',
            manualUserUrl: "/users/iot/",
            usersTokenUrl: '/users/iot/invite/',
            lookUpEmailUrl: '/users/iot/lookup/',
            allUsersList: "/users/iot/all/list",
            sendInviteUserMail: '/iot/sendInviteUserMail',
            sendInviteSsoUserMail: '/iot/sendInviteSsoUserMail',
            sendInviteUsecaseNotifyMail: '/iot/sendInviteUsecaseNotifyMail',
            sendInviteSsoUsecaseNotifyMail: '/iot/sendInviteSsoUsecaseNotifyMail',
            iotCurrentStatus: '/users/iot/status',
            changeRoleForUser: '/users/iot/change/role/',
            assignLocationForUser: '/users/iot/assign/location/',
            commonEvent: '/iot/events/',
            eventDetail: '/iot/device/detail/',
            groupEventList: '/iot/events/details/list/',
            customView: '/iot/custom/tableview/',
            downloadUserTemplate: "/users/iot/download/template",
            uploadUser: "/users/iot/upload/file",
            roleMapDetails: "/users/iot/file/role/mapping/",
            updateRoleDetails: "/users/iot/file/role/update/",
            locationMapDetails: "/users/iot/file/location/mapping/",
            updateLocationDetails: "/users/iot/file/location/update/",
            importUsersViaExcel: "/users/iot/file/import/users/",
            importUserRoleFromUseCaseId: "/users/iot/import/roles/",
            createRoleViaImport: "/users/iot/create/roles/",
            updateUserRoleFromUseCaseId: "/users/iot/import/update/roles/",
            exportDevices: "/iot/export/devices/",
            locHistory: "/iot/location/history",
            occupancyHistory: "/iot/occupancy/history"
        };
        this.signage = {
            launchurl: '/setup/signagedevice/launchurl',
            allDevicesList: '/location/signagedevice/list',
            devicesList: '/location/signagedevices',
            deviceDetails: '/location/signagedevice',
            defaultFloor: '/location/signagedevice',
            addSignageDevice: '/location/signagedevice/add',
            configureSignageDevice: '/location/signagedevice/configure',
            deleteSignageDevice: '/location/signagedevice/delete',
            webexDeviceList: '/location/webexdevices/list',
            metaData: '/location/signagedevice',
            deviceImageFromS3: '/signage/device/image',
            locationList: "/workspaces/manager/location/list",
            workSpacelocationList: "/workspaces/experience/location/list",
            getWorkSpacesDeviceList: {
                get: (locId) => `/workspaces/${locId}/devices`,
            },
            getWorkSpacesDeviceDetails: {
                get: (locId, macAddress) => `/workspaces/${locId}/${macAddress}/details`,
            },
            locRoomList: {
                get: (locId) => `/workspaces/${locId}/list` /* fetch workspaces for the Location */,
            },
            webexRoomList: {
                get: (locId) => `/workspaces/${locId}/webexroom/connect` /* fetch webex for the Location */,
            },
            connectWebexRoom: {
                post: (locId) => `/workspaces/${locId}/webexroom/connect`
            },
            addDevices: {
                post: (locId, workspaceId) => `/workspaces/${locId}/${workspaceId}/devices`
            },
            disassociateDevices: {
                post: (locId, workspaceId) => `/workspaces/${locId}/${workspaceId}/removeDevices`
            },
            disconnectLocRoom: {
                get: (locId, workspaceId) => `/workspaces/${locId}/${workspaceId}/disconnect`
            },
            clearLocRoom: {
                delete: (locId, workspaceId) => `/workspaces/${locId}/${workspaceId}`
            },
            fetchLocRoomDetails: {
                get: (locId, workspaceId) => `/workspaces/${locId}/${workspaceId}`
            },
            fetchLocRoomDevicesList: {
                get: (locId, workspaceId) => `/workspaces/${locId}/${workspaceId}/availableDevices`
            },
            getSpacesSensorDetails: {
                get: (locId, macAddress) => `/workspaces/${locId}/${macAddress}//sensorConfig`
            },
            updateSpacesSensorDetails: {
                post: (locId, macAddress) => `/workspaces/${locId}/${macAddress}//sensorConfig`
            },
            fetchLoc2dMap: {
                get: (locId) => `/map/getFloorMapInLocations?locationId=${locId}`
            },
            byteImage: {
                post: `/map/getByteImage`
            },
            saveOccupancyDetails: {
                post: (locId, locRoomId) => `/workspaces/${locId}/${locRoomId}/updateConfig`
            },
            getCalederServiceList: {
                get: (locId) => `/workspaces/${locId}/calendar/connect`
            },
            updateCalenderService: {
                post: (locId) => `/workspaces/${locId}/calendar/connect`
            },
            removeCalenderService: {
                get: (locId, locRoomId, type) => `/workspaces/${locId}/${locRoomId}/${type}/disconnect`
            },
            getgeneratedToken: {
                post: (locId) => `/location/signagedevice/${locId}/smartworkspacetoken/generate`
            }
        };
        this.roomOccupancyReports = {
            reports: "/spaces/utilization/report/list",
            createReport: "/spaces/utilization/report/create",
            editReport: "/spaces/utilization/report/edit/",
            updateReport: "/spaces/utilization/report/update/",
            viewReport: "/spaces/utilization/report/details/",
            meetingRooms: "/spaces/utilization/meetingRooms/list/",
            deleteReport: "/spaces/utilization/report/delete/",
            workspaceList: "/spaces/history/list/data/",
            download: "/spaces/history/export/",
            roomsCount: "/spaces/utilization/meetingRooms/count/",
            skipEmptyRows: "/spaces/history/people/rows/count/"
        };
        this.plugins = {
            tenantIds: "/plugins/tenants",
            list: "/plugins/list",
            activate: "/plugins/activate",
            deactivate: "/plugins/deactivate"
        };
        this.getCameraMatricsReportsUrl = (duration, dummy) => {
            if (dummy == true) {
                return (this.serverBaseUrl +
                    this.cameraMetrics.getReportUrl +
                    duration +
                    "?dummy=" +
                    dummy);
            }
            else {
                return (this.serverBaseUrl + this.cameraMetrics.getReportUrl + duration);
            }
        };
        this.getUserCurrentStatusUrl = () => {
            return this.clientBaseUrl + this.user.currentUserStatus;
        };
        this.getAppCurrentStatusUrl = () => {
            return this.serverBaseUrl + this.appuser.currentAppUserStatus;
        };
        this.getGodDashboardUrl = () => {
            return this.serverBaseUrl + this.admin.godDashboardData;
        };
        this.getGodCustomerStatsUrl = () => {
            return this.serverBaseUrl + this.admin.godCustomerStats;
        };
        this.getAdminMetadataUrl = () => {
            return this.serverBaseUrl + this.admin.metadata;
        };
        this.getCustomerDetailsUrl = () => {
            return this.serverBaseUrl + this.admin.customerDetails;
        };
        this.getavailableServiceUrl = () => {
            return this.serverBaseUrl + this.admin.availableServices;
        };
        this.getCSMProvisionListURL = () => {
            return this.serverBaseUrl + this.admin.csmProvisionList;
        };
        this.getCSMCustomerDetailURL = () => {
            return this.serverBaseUrl + this.admin.csmCustomerDetails;
        };
        this.getUpdateCSMCustomerDetailURL = () => {
            return this.serverBaseUrl + this.admin.csmCustomerUpdate;
        };
        this.addServiceIntoDNA = () => {
            return this.serverBaseUrl + this.admin.addserviceinto;
        };
        this.inviteDemokitUser = () => {
            return this.serverBaseUrl + this.admin.demokituserinvite;
        };
        this.getCustomerUpdationUrl = () => {
            return this.clientBaseUrl + this.admin.customerUpdation;
        };
        this.getCustomerCreationUrl = () => {
            return this.clientBaseUrl + this.admin.customerCreation;
        };
        this.getCustomerListForAdminUrl = () => {
            return this.serverBaseUrl + this.admin.customerList;
        };
        this.getAdminLoginStatusURL = () => {
            return this.serverBaseUrl + this.admin.getSSOLoginStatus;
        };
        this.getTooltipUrl = () => {
            return this.serverBaseUrl + this.tooltipUrl;
        };
        this.getPollTokenUrl = () => {
            return this.clientBaseUrl + this.pollTokenURL;
        };
        this.getVerifyTokenUrl = () => {
            return this.clientBaseUrl + this.verifyTokenURL;
        };
        this.getRefreshTokenUrl = () => {
            return this.tmBaseUrl + this.tm.refreshTokenURL;
        };
        this.getSharedLoginTypeUrl = (guid, email, role) => {
            return (this.tmBaseUrl +
                this.tm.sharedLoginTypePreFix +
                `${guid}/${email}` +
                this.tm.sharedLoginTypePostFix +
                role);
        };
        this.getUpdateTokenUrl = () => {
            return this.serverBaseUrl + this.updateTokenURL;
        };
        this.getValidateSharedSysTokenUrl = (guid) => {
            return (this.clientBaseUrl +
                `/shared/${guid}` +
                this.auth.getValidateSharedSysTokenUrl);
        };
        this.getReportDataBySysTokenUrl = (guid, role) => {
            return (this.tmBaseUrl +
                this.auth.getReportDataBySysTokenUrl +
                `/${guid}?role=` +
                role);
        };
        this.getExtractReportParamUrl = (guid) => {
            return (this.clientBaseUrl +
                `/shared/${guid}` +
                this.auth.extractReportParamUrl);
        };
        this.getPendingUsersToApproveAccessUrl = (guid) => {
            return (this.serverBaseUrl +
                `/shared/${guid}` +
                this.auth.getPendingUsersToApproveAccessUrl);
        };
        this.getgrantAccessUrl = (approved, guid) => {
            return (this.serverBaseUrl +
                `/shared/${guid}` +
                this.auth.grantAccessUrl +
                approved);
        };
        this.getViewedReportUrl = (guid) => {
            return (this.serverBaseUrl + `/shared/${guid}` + this.auth.viewdReportUrl);
        };
        this.getSenderNameUrl = () => {
            return this.clientBaseUrl + this.auth.getSenderNameUrl;
        };
        this.verifyResetPINEmailUrl = () => {
            return this.clientBaseUrl + this.auth.verifyResetPINEmailUrl;
        };
        this.submitSharedFeedback = () => {
            return this.getAPIServerUrl(this.auth.submitSharedFeedbackUrl);
        };
        this.getLocationMetadataUrl = () => {
            return this.getAPIServerUrl(this.behaviorMetricsApp.locationMetadataUrl);
        };
        this.getBIReportUrl = () => {
            return this.getAPIServerUrl(this.behaviorMetricsApp.biReport);
        };
        this.getBIReportUrlForWorkspaces = () => {
            return this.getAPIServerUrl(this.behaviorMetricsApp.workspacesReport);
        };
        this.getBIReportUrlForEducation = () => {
            return this.getAPIServerUrl(this.behaviorMetricsApp.educationReport);
        };
        this.createShareReportUrl = () => {
            return this.clientBaseUrl + this.user.createShareReport;
        };
        this.reShareReportUrl = () => {
            return this.getAPIServerUrl(this.user.reShareReport);
        };
        this.getSharedUsersListUrl = () => {
            return this.getAPIServerUrl(this.user.sharedUsersListUrl);
        };
        this.getRevokeUsersUrl = (guid) => {
            return `${this.serverBaseUrl}/shared/${guid}${this.user.revokeUsersUrl}`;
        };
        this.getCheckEmailPinUrl = () => {
            return this.clientBaseUrl + this.user.checkEmailPinUrl;
        };
        this.setEmailPinUrl = () => {
            return this.clientBaseUrl + this.user.setEmailPinUrl;
        };
        this.resetEmailPINUrl = () => {
            return this.clientBaseUrl + this.user.resetEmailPINUrl;
        };
        this.getLocationListUrl = () => {
            return this.getAPIServerUrl(this.location.list);
        };
        this.getLoginRequest = () => {
            return this.getAPIServerUrl(this.user.getLoginRequest);
        };
        this.getAPIServerUrl = (path) => {
            if (this.dataService) {
                const sharePluginObj = this.dataService.getSharePluginObject();
                if (sharePluginObj && sharePluginObj.isSharePlugin) {
                    const shareGuid = sharePluginObj.guid;
                    return `${this.serverBaseUrl}/shared/${shareGuid}${path}`;
                }
                else {
                    return `${this.serverBaseUrl}${path}`;
                }
            }
        };
        this.getInteractionLogUrl = () => {
            return this.clientBaseUrl + this.doInteractionLog;
        };
        this.getReportServerUrl = () => {
            return this.serverBaseUrl + this.report.serverUrl;
        };
        this.getReportAdminServerUrl = () => {
            return this.serverBaseUrl + this.report.adminServerUrl;
        };
        this.getReportOverallReportsUrl = () => {
            return this.serverBaseUrl + this.report.overallReportsUrl;
        };
        this.getReportRealTimeReportsUrl = () => {
            return this.serverBaseUrl + this.report.realTimeReportsUrl;
        };
        this.getReportsUrl = () => {
            return this.serverBaseUrl + this.report.reportsUrl;
        };
        this.getLocationAnalyticsDateUrl = () => {
            return this.getAPIServerUrl(this.locationAnalytics.reportsDateUrl);
        };
        this.getLocationAnalyticsUrl = () => {
            return this.getAPIServerUrl(this.locationAnalytics.reportsChartUrl);
        };
        this.getAnalyticsReportsUrl = () => {
            return this.getAPIServerUrl(this.report.analyticsReportsUrl);
        };
        this.getAnalyticsLAReportsUrl = () => {
            return this.getAPIServerUrl(this.locationAnalytics.reportsUrl);
        };
        this.getAnalyticsReportsDeleteUrl = () => {
            return this.getAPIServerUrl(this.locationAnalytics.reportsDeleteUrl);
        };
        this.getAnalyticsDwellUrl = () => {
            return this.serverBaseUrl + this.locationAnalytics.getDwellUrl;
        };
        this.getAnalyticsDwellUpdateUrl = () => {
            return this.serverBaseUrl + this.locationAnalytics.updateDwellUrl;
        };
        this.getAnalyticsCheckUrl = () => {
            return this.serverBaseUrl + this.locationAnalytics.reportsCheckUrl;
        };
        this.getAnalyticsTop2LocationsUrl = () => {
            return this.serverBaseUrl + this.locationAnalytics.getAnalyticsTop2LocationsUrl;
        };
        this.getAnalyticsTop2SSIDsUrl = () => {
            return this.serverBaseUrl + this.locationAnalytics.getAnalyticsTop2SSIDsUrl;
        };
        this.getLocationByTypeUrl = () => {
            return this.serverBaseUrl + this.locationAnalytics.getLocationByTypeUrl;
        };
        this.getAnalyticsSsidsUrl = () => {
            return this.serverBaseUrl + this.locationAnalytics.reportsSSIDUrl;
        };
        this.getLogoutUrl = () => {
            return this.clientBaseUrl + this.auth.logout;
        };
        this.getAuthValidateUrl = () => {
            return this.clientBaseUrl + this.auth.validate;
        };
        this.getAuthAdminValidateUrl = () => {
            return this.clientBaseUrl + this.auth.validateAdmin;
        };
        this.getCustomerValidateUrl = () => {
            return this.clientBaseUrl + this.auth.validateCustomer;
        };
        this.getTenantEndpointUrl = () => {
            return this.tmBaseUrl + this.tm.loginUser;
        };
        this.getShareTenantEndpointUrl = (role) => {
            return this.tmBaseUrl + this.tm.shareLoginUser + role;
        };
        this.getSharePINTenantEndpointUrl = (role) => {
            return this.tmBaseUrl + this.tm.sharePinLoginUser + role;
        };
        this.getFetchUserCustomerUrl = () => {
            return this.clientBaseUrl + this.auth.getFetchUserCustomerUrl;
        };
        this.getFetchAccountsSSOLogintUrl = () => {
            return this.tmBaseUrl + this.tm.fetchAccountsSSOLogin;
        };
        this.getSelectAppEndpointUrl = () => {
            return this.tmBaseUrl + this.tm.selectApp;
        };
        this.getVerifyAccountUrl = () => {
            return this.tmBaseUrl + this.tm.verifyAccount;
        };
        this.getTenantOauthAuthenticationURL = () => {
            return this.tmBaseUrl + this.tm.oauthAuthenticationURL;
        };
        this.getTenantCCISessionLogOut = () => {
            return this.tmBaseUrl + this.tm.tenantCCILogOutURL;
        };
        this.loginUserUrl = () => {
            return this.clientBaseUrl + this.user.loginUser;
        };
        this.provisionTokenForUserUrl = () => {
            return this.clientBaseUrl + this.user.provisionTokenForUser;
        };
        this.getFetchRole = () => {
            return this.clientBaseUrl + this.user.fetchRole;
        };
        this.getExtractRole = () => {
            return this.clientBaseUrl + this.user.extractRole;
        };
        this.getExpiredCustomerLicenseInfo = () => {
            return this.serverBaseUrl + this.user.expiredLicense;
        };
        this.getAccessCodeListUrl = () => {
            return this.serverBaseUrl + this.accessCode.accessCodeList;
        };
        this.getSaveAccessCodeUrl = () => {
            return this.serverBaseUrl + this.accessCode.saveAccessCode;
        };
        this.getDeleteAccessCodeUrl = () => {
            return this.serverBaseUrl + this.accessCode.deleteAccessCode;
        };
        this.getDeleteAccessCodeTemplateUrl = () => {
            return this.serverBaseUrl + this.accessCode.deleteAccessCodeTemplate;
        };
        this.getUpdateAccessCodeUrl = () => {
            return this.serverBaseUrl + this.accessCode.updateAccessCode;
        };
        this.getSaveAccessCodeTemplateUrl = () => {
            return this.serverBaseUrl + this.accessCode.saveAccessCodeTemplate;
        };
        this.getUpdateAccessCodeTemplateUrl = () => {
            return this.serverBaseUrl + this.accessCode.updateAccessCodeTemplate;
        };
        this.getAccessCodeTemplateUrl = () => {
            return this.serverBaseUrl + this.accessCode.listAccessCodeTemplate;
        };
        this.getLocationRenameUrl = () => {
            return this.serverBaseUrl + this.location.rename;
        };
        this.getLocationDeleteUrl = () => {
            return this.serverBaseUrl + this.location.delete;
        };
        this.getDeleteLocationStatus = () => {
            return this.serverBaseUrl + this.location.deleteStatus;
        };
        this.getLocationTimezoneUrl = () => {
            return this.serverBaseUrl + this.location.timezone;
        };
        this.getLocationSearchAPsUrl = () => {
            return this.serverBaseUrl + this.location.searchAPs;
        };
        this.getAccessPointListUrl = () => {
            return this.serverBaseUrl + this.location.fetchAccessPoint;
        };
        this.fetchWebexDevicesUrl = () => {
            return this.serverBaseUrl + this.location.fetchWebexDevices;
        };
        this.fetchSensorDevicesUrl = () => {
            return this.serverBaseUrl + this.location.fetchSensors;
        };
        this.getBleBeaconListUrl = () => {
            return this.serverBaseUrl + this.location.fetchBleBeacon;
        };
        this.getAdminUserListUrl = () => {
            return this.serverBaseUrl + this.user.list;
        };
        this.getRoleUserListUrl = () => {
            return this.serverBaseUrl + this.user.roleUserList;
        };
        this.getUserInfoUrl = () => {
            return this.serverBaseUrl + this.user.getUserInfo;
        };
        this.getAdminAppNameUrl = () => {
            return this.serverBaseUrl + this.user.getAdminAppName;
        };
        this.getInviteUserUrl = () => {
            return this.serverBaseUrl + this.user.inviteUser;
        };
        this.getSendInviteUserMailUrl = () => {
            return this.clientBaseUrl + this.user.sendInviteUserMail;
        };
        this.getDemokitSendInviteUserMailUrl = () => {
            return this.clientBaseUrl + this.user.sendDemokitInviteUserMail;
        };
        this.getSendInviteSsoUserMailUrl = () => {
            return this.clientBaseUrl + this.user.sendInviteSsoUserMail;
        };
        this.getEditAdminUserUrl = () => {
            return this.serverBaseUrl + this.user.editAdminUser;
        };
        this.getEditUserUrl = () => {
            return this.serverBaseUrl + this.user.editUser;
        };
        this.getDeleteUserUrl = () => {
            return this.serverBaseUrl + this.user.deleteUser;
        };
        this.getDeleteUserStatus = () => {
            return this.serverBaseUrl + this.user.deleteUserStatus;
        };
        this.getDeleteUserRoleUrl = () => {
            return this.serverBaseUrl + this.user.deleteUserRole;
        };
        this.getAdminRoleDeleteStatus = () => {
            return this.serverBaseUrl + this.user.deleteAdminRoleStatus;
        };
        // App User api call starts
        this.getAppUserListUrl = () => {
            return this.serverBaseUrl + this.appuser.list;
        };
        this.getAppUserInfoUrl = () => {
            return this.serverBaseUrl + this.appuser.getAppUserInfo;
        };
        this.getInviteAppUserUrl = () => {
            return this.serverBaseUrl + this.appuser.inviteUser;
        };
        this.getResendInviteAppUserUrl = () => {
            return this.serverBaseUrl + this.appuser.resendInviteUser;
        };
        this.getEditAppUserUrl = () => {
            return this.serverBaseUrl + this.appuser.editUser;
        };
        this.getDeleteAppUserUrl = () => {
            return this.serverBaseUrl + this.appuser.deleteUser;
        };
        this.getAppUserDeleteStatusUrl = () => {
            return this.serverBaseUrl + this.appuser.deleteUser;
        };
        this.getAppRoleListUrl = () => {
            return this.serverBaseUrl + this.appuser.rolelist;
        };
        // App User api call ends
        this.getRuleslistUrl = () => {
            return this.serverBaseUrl + this.location.fetchRulesList;
        };
        this.getEngagementRulesReportUrl = () => {
            return this.serverBaseUrl + this.location.fetchEnagementRulesReport;
        };
        // gettting user count from TMS
        this.getLocationCount = () => {
            return this.serverBaseUrl + this.location.count;
        };
        this.getPauseRuleUrl = () => {
            return this.serverBaseUrl + this.rules.pauseRule;
        };
        this.getMakeRuleLiveUrl = () => {
            return this.serverBaseUrl + this.rules.makeLive;
        };
        this.getDeleteRuleUrl = () => {
            return this.serverBaseUrl + this.rules.deleteRule;
        };
        this.getTagListUrl = () => {
            return this.serverBaseUrl + this.rules.tagList;
        };
        this.getSaveRuleUrl = () => {
            return this.serverBaseUrl + this.rules.saveRule;
        };
        this.getMetadataListUrl = () => {
            return this.serverBaseUrl + this.rules.metadataList;
        };
        this.getRulePortalListUrl = () => {
            return this.serverBaseUrl + this.rules.portalList;
        };
        // CaptivePortal Rules api call starts
        this.getCPRuleDetailsUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.ruleDetails;
        };
        this.getCPRuleslistUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.fetchRulesList;
        };
        this.getTileCPRuleCount = () => {
            return this.serverBaseUrl + this.captiveportalrules.getRuleCount;
        };
        this.getCPPauseRuleUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.pauseRule;
        };
        this.getCPMakeRuleLiveUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.makeLive;
        };
        this.getCPDeleteRuleUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.deleteRule;
        };
        this.getCPRuleSmsGatewayListUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.smsGatewayList;
        };
        this.getCPNotificationListUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.notificationList;
        };
        this.getCPSSIDListUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.ssidList;
        };
        this.getCPTagListUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.tagList;
        };
        this.getCPSaveRuleUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.saveRule;
        };
        this.getCPMetadataListUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.metadataList;
        };
        this.getCPRulePortalListUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.portalList;
        };
        this.getCPBusinessTagsListUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.businessTagsList;
        };
        this.getCPLocationListUrl = () => {
            return this.serverBaseUrl + this.captiveportalrules.locationList;
        };
        // CaptivePortal Rules api call ends
        // Personas Rule API call starts here
        this.getPersonasLocationListUrl = () => {
            return this.serverBaseUrl + this.personasrules.locationList;
        };
        this.getPersonasRulelistUrl = () => {
            return this.serverBaseUrl + this.personasrules.ruleList;
        };
        this.getPersonasDeleteRuleUrl = () => {
            return this.serverBaseUrl + this.personasrules.deleteRule;
        };
        this.getPersonasPauseRuleUrl = () => {
            return this.serverBaseUrl + this.personasrules.pauseRule;
        };
        this.getPersonasMakeRuleLiveUrl = () => {
            return this.serverBaseUrl + this.personasrules.liveRule;
        };
        this.getPersonasRuleDetailsUrl = () => {
            return this.serverBaseUrl + this.personasrules.details;
        };
        // Personas Rule API call ends here
        // Engagements Rule API call starts here
        this.getEngagementsLocationListUrl = () => {
            return this.serverBaseUrl + this.engagementrules.locationList;
        };
        this.getEngagementsRulelistUrl = () => {
            return this.serverBaseUrl + this.engagementrules.ruleList;
        };
        this.getEngagementsDeleteRuleUrl = () => {
            return this.serverBaseUrl + this.engagementrules.deleteRule;
        };
        this.getEngagementsPauseRuleUrl = () => {
            return this.serverBaseUrl + this.engagementrules.pauseRule;
        };
        this.getPEngagementsMakeRuleLiveUrl = () => {
            return this.serverBaseUrl + this.engagementrules.liveRule;
        };
        this.getEngagementsRuleDetailsUrl = () => {
            return this.serverBaseUrl + this.engagementrules.details;
        };
        // Engagements Rule API call ends here
        this.getPortalListUrl = () => {
            return this.serverBaseUrl + this.portal.list;
        };
        this.getPortalUrl = () => {
            return this.serverBaseUrl + this.portal.getPortal;
        };
        this.getTemplateSettingsUrl = () => {
            return this.serverBaseUrl + this.portal.getTemplateSetting;
        };
        this.saveTemplateSettingsUrl = () => {
            return this.serverBaseUrl + this.portal.saveTemplateSetting;
        };
        this.getPortalConfigUrl = () => {
            return this.serverBaseUrl + this.portal.getPortalConfig;
        };
        this.getPortalDefaultConfigUrl = () => {
            return this.serverBaseUrl + this.portal.getDefaultConfig;
        };
        this.getCreatePortalUrl = () => {
            return this.serverBaseUrl + this.portal.createPortal;
        };
        this.getCheckPortalAvailableUrl = () => {
            return this.serverBaseUrl + this.portal.checkPortalAvailable;
        };
        this.getRenamePortalUrl = () => {
            return this.serverBaseUrl + this.portal.renamePortal;
        };
        this.getImportPortalUrl = () => {
            return this.clientBaseUrl + this.portal.importPortal;
        };
        this.getCreateSamplePortalUrl = () => {
            return this.clientBaseUrl + this.portal.createSamplePortal;
        };
        this.getDeletePortalUrl = () => {
            return this.serverBaseUrl + this.portal.deletePortal;
        };
        this.getUpdatePortalUrl = () => {
            return this.serverBaseUrl + this.portal.updatePortal;
        };
        this.getPublishPortalUrl = () => {
            return this.serverBaseUrl + this.portal.publishPortal;
        };
        this.getUpdatePortalLanguagesUrl = () => {
            return this.serverBaseUrl + this.portal.updatePortalLanguages;
        };
        this.getUploadFileUrl = () => {
            return this.clientBaseUrl + this.portal.uploadFile;
        };
        this.getUploadFileForModulesUrl = () => {
            return this.clientBaseUrl + this.portal.uploadFileForModules;
        };
        this.getCopyAssetsUrl = () => {
            return this.clientBaseUrl + this.portal.copyAssets;
        };
        this.getCopyCssUrl = () => {
            return this.clientBaseUrl + this.portal.copyCss;
        };
        this.getRuleDetailsUrl = () => {
            return this.serverBaseUrl + this.rules.ruleDetails;
        };
        this.getSmsGatewayListUrl = () => {
            return this.serverBaseUrl + this.toolkit.smsGatewayList;
        };
        this.getRuleSmsGatewayListUrl = () => {
            return this.serverBaseUrl + this.rules.smsGatewayList;
        };
        this.getNotificationListUrl = () => {
            return this.serverBaseUrl + this.rules.notificationList;
        };
        this.getSmsGatewayTypesUrl = () => {
            return this.serverBaseUrl + this.toolkit.smsGatewayTypes;
        };
        this.getSaveSMSGatewayUrl = () => {
            return this.serverBaseUrl + this.toolkit.saveSMSGateway;
        };
        this.getUpdateSMSGatewayUrl = () => {
            return this.serverBaseUrl + this.toolkit.updateSMSGateway;
        };
        this.getDeleteSMSGatewayUrl = () => {
            return this.serverBaseUrl + this.toolkit.deleteSMSGateway;
        };
        this.getSocialAppListUrl = () => {
            return this.serverBaseUrl + this.toolkit.socialAppsList;
        };
        this.getUpdateFacebookAppUrl = () => {
            return this.serverBaseUrl + this.toolkit.updateFacebook;
        };
        this.getUpdateTwitterAppUrl = () => {
            return this.serverBaseUrl + this.toolkit.updateTwitter;
        };
        this.getUpdateLinkedinAppUrl = () => {
            return this.serverBaseUrl + this.toolkit.updateLinkedin;
        };
        this.getNotificationChannelsUrl = () => {
            return this.serverBaseUrl + this.toolkit.notificationChannelsList;
        };
        this.getBleUuidsUrl = () => {
            return this.serverBaseUrl + this.toolkit.bleUuidsList;
        };
        this.deleteBleUuidsUrl = () => {
            return this.serverBaseUrl + this.toolkit.bleUuidDelete;
        };
        this.addBleUuidsUrl = () => {
            return this.serverBaseUrl + this.toolkit.bleUuidAdd;
        };
        this.getHotspotConfigUrl = () => {
            return this.serverBaseUrl + this.toolkit.hotspotConfig;
        };
        this.getCMXConnectorsUrl = () => {
            return this.serverBaseUrl + this.toolkit.cmxConnectorsList;
        };
        this.ewlcFeatureFlagUrl = () => {
            return this.locationBaseUrl + this.location.ewlcFeatureFlag;
        };
        this.getHotspotListUrl = () => {
            return this.serverBaseUrl + this.toolkit.getHotspotList;
        };
        this.getDMSProxyUrl = () => {
            return this.serverBaseUrl + this.toolkit.dmsProxy;
        };
        this.getControllersUrl = () => {
            return this.serverBaseUrl + this.toolkit.cmxControllersList;
        };
        this.deleteCMXConnectorUrl = () => {
            return this.serverBaseUrl + this.toolkit.cmxConnectorDelete;
        };
        this.addCMXConnectorUrl = () => {
            return this.serverBaseUrl + this.toolkit.cmxConnectorAdd;
        };
        this.addHotspotUrl = () => {
            return this.serverBaseUrl + this.toolkit.addHotspot;
        };
        this.addControllerUrl = () => {
            return this.serverBaseUrl + this.toolkit.cmxControllerAdd;
        };
        this.updateControllerUrl = () => {
            return this.serverBaseUrl + this.toolkit.cmxControllerUpdate;
        };
        this.getTestCredentialsURL = () => {
            return this.dmsBaseUrl + this.toolkit.testCredentials;
        };
        this.getConnectivityStatusURL = () => {
            return this.dmsBaseUrl + this.toolkit.testCredentials;
        };
        this.getCertChainUrl = () => {
            return this.dmsBaseUrl + this.toolkit.getCertChain;
        };
        this.verifyConnectivity = () => {
            return this.serverBaseUrl + this.toolkit.cmxControllerUpdate;
        };
        this.updateConnectorNameUrl = () => {
            return this.serverBaseUrl + this.toolkit.cmxConnectorNameUpdate;
        };
        this.getAccessTokenUrl = () => {
            return this.serverBaseUrl + this.toolkit.getAccessToken;
        };
        this.deleteConnectorUrl = () => {
            return this.serverBaseUrl + this.toolkit.deleteConnector;
        };
        this.uploadConnectorLogsUrl = (id) => {
            return (this.toolkit.cmxConnectorDetails +
                "/" +
                id +
                this.toolkit.connectorService);
        };
        this.restartConnectorUrl = (id) => {
            return (this.toolkit.cmxConnectorDetails +
                "/" +
                id +
                this.toolkit.connectorService);
        };
        this.enableDebugUrl = (id) => {
            return (this.toolkit.cmxConnectorDetails +
                "/" +
                id +
                this.toolkit.connectorService);
        };
        this.enableHotspotDebugUrl = (id) => {
            return (this.toolkit.enableHotspotDebugMode +
                "/" +
                id +
                this.toolkit.hotspotService);
        };
        this.autoUpgradeUrl = (id) => {
            return (this.toolkit.cmxConnectorDetails +
                "/" +
                id +
                this.toolkit.connectorUpgrade);
        };
        this.deleteControllerUrl = () => {
            return this.serverBaseUrl + this.toolkit.deleteController;
        };
        this.deleteControllerUrlWLC = () => {
            return this.serverBaseUrl + this.toolkit.deleteControllerWLC;
        };
        this.getSdkUrl = () => {
            return this.serverBaseUrl + this.toolkit.sdkList;
        };
        this.getAssetListUrl = () => {
            return this.clientBaseUrl + this.csseditor.assets;
        };
        this.getSavePushConfigurationUrl = () => {
            return this.serverBaseUrl + this.toolkit.savePushConfigurationUrl;
        };
        this.getCssFileUrl = () => {
            return this.clientBaseUrl + this.csseditor.css;
        };
        this.getSaveCssFileUrl = () => {
            return this.clientBaseUrl + this.csseditor.saveCss;
        };
        this.getUploadCssFileUrl = () => {
            return this.clientBaseUrl + this.csseditor.uploadCss;
        };
        this.getSendPreviewUrl = () => {
            return this.clientBaseUrl + this.portal.sendPreviewUrl;
        };
        this.getSSIDListUrl = () => {
            return this.serverBaseUrl + this.rules.ssidList;
        };
        this.getAddLocationUrl = () => {
            return this.serverBaseUrl + this.portal.addLocation;
        };
        this.getAddLocationsUrl = () => {
            return this.serverBaseUrl + this.portal.addLocations;
        };
        this.getUserActivationUrl = () => {
            return this.clientBaseUrl + this.auth.userActivation;
        };
        this.getDemokitContextUrl = () => {
            return this.clientBaseUrl + this.auth.getDemokitContextUrl;
        };
        this.getActivateUserUrl = () => {
            return this.clientBaseUrl + this.auth.getActivateUser;
        };
        this.getActivateRedirectionUrl = () => {
            return this.clientBaseUrl + this.auth.getActivateRedirection;
        };
        this.getDemokitActivateRedirectionUrl = () => {
            return this.clientBaseUrl + this.auth.getDemokitActivateRedirection;
        };
        this.getForgotPasswordUrl = () => {
            return this.clientBaseUrl + this.auth.forgotPassword;
        };
        this.getResetPasswordUrl = () => {
            return this.clientBaseUrl + this.auth.resetPassword;
        };
        this.getExtractAndUploadZipFileUrl = () => {
            return this.clientBaseUrl + this.portal.extractAndUploadZip;
        };
        this.getPropertiesUrl = () => {
            return this.clientBaseUrl + this.getDashboardProperties;
        };
        this.getExtractAndUploadAssetsZipFileUrl = () => {
            return this.clientBaseUrl + this.csseditor.extractAndUploadAssetsZip;
        };
        this.getExtractAndUploadAssetsZipFileByDNDUrl = () => {
            return (this.clientBaseUrl + this.csseditor.extractAndUploadAssetsZipByDND);
        };
        this.getChangePasswordUrl = () => {
            return this.serverBaseUrl + this.user.changePassword;
        };
        this.getDeleteNotificationChannelUrl = () => {
            return this.serverBaseUrl + this.toolkit.deleteNotificationChannel;
        };
        this.getSaveNotificationChannelUrl = () => {
            return this.clientBaseUrl + this.toolkit.saveNotificationChannel;
        };
        this.getAccesscodeManagerLocationUrl = () => {
            return this.serverBaseUrl + this.location.getAccessCodeManagerLocations;
        };
        this.getAppAccesscodeManagerLocationUrl = () => {
            return (this.serverBaseUrl + this.portal.getAppAccessCodeManagerLocations);
        };
        this.getDeleteAssetUrl = () => {
            return this.clientBaseUrl + this.csseditor.deleteAsset;
        };
        this.getSsidListUrl = () => {
            return this.serverBaseUrl + this.ssid.ssidList;
        };
        this.getSsidDetailUrl = () => {
            return this.serverBaseUrl + this.ssid.ssidDetail;
        };
        this.getSsidDeleteUrl = () => {
            return this.serverBaseUrl + this.ssid.deleteSSID;
        };
        this.getSsidConfigDeleteUrl = () => {
            return this.serverBaseUrl + this.ssid.deleteSSIDConfig;
        };
        this.getReplaceAssetUrl = () => {
            return this.clientBaseUrl + this.csseditor.replaceAsset;
        };
        this.getResendInviteEmailUrl = () => {
            return this.clientBaseUrl + this.user.resendInvite;
        };
        this.getResendCPAppInviteEmailUrl = () => {
            return this.clientBaseUrl + this.appuser.resendCPAppInvite;
        };
        // app user resend url
        this.getResendAppInviteEmailUrl = () => {
            return this.clientBaseUrl + this.appuser.resendAppInvite;
        };
        this.getRenameNotification = () => {
            return this.serverBaseUrl + this.toolkit.renameNotificationChannel;
        };
        this.getSMSLimitUrl = () => {
            return this.serverBaseUrl + this.toolkit.getSMSLimit;
        };
        this.saveSMSLimitUrl = () => {
            return this.serverBaseUrl + this.toolkit.saveSMSLimit;
        };
        this.getWebexAccountListUrl = () => {
            return this.serverBaseUrl + this.toolkit.getWebexAccountList;
        };
        this.getSaveWebexAccountUrl = () => {
            return this.serverBaseUrl + this.toolkit.saveWebexAccount;
        };
        this.getUpdateWebexAccountUrl = () => {
            return this.serverBaseUrl + this.toolkit.saveWebexAccount;
        };
        this.getDeleteWebexAccountUrl = () => {
            return this.serverBaseUrl + this.toolkit.deleteWebexAccount;
        };
        this.getWebexAuthenticateUrl = () => {
            return this.clientBaseUrl + this.toolkit.getWebexAuthenticate;
        };
        this.getWebexRoomListUrl = () => {
            return this.clientBaseUrl + this.toolkit.getWebexRoomList;
        };
        this.getWebexCheckEmailUrl = () => {
            return this.clientBaseUrl + this.toolkit.getWebexCheckEmail;
        };
        this.getWebexSetupStatusUrl = () => {
            return this.serverBaseUrl + this.setup.getWebexSetupStatus;
        };
        this.getSaveWebExTokenUrl = () => {
            return this.serverBaseUrl + this.setup.getSaveWebExToken;
        };
        this.getWebexListUrl = () => {
            return this.serverBaseUrl + this.setup.getWebexList;
        };
        this.getDisconnectWebexUrl = () => {
            return this.serverBaseUrl + this.setup.getDisconnectWebex;
        };
        this.getActivatePxGridUrl = () => {
            return this.serverBaseUrl + this.setup.getActivatePxGrid;
        };
        this.getActivatedPxGridDeviceURL = () => {
            return this.serverBaseUrl + this.setup.getPxGridDevice;
        };
        this.getAddMSESsidUrl = () => {
            return this.serverBaseUrl + this.ssid.addMSESsid;
        };
        this.getAccessCodeLocationListUrl = () => {
            return this.serverBaseUrl + this.accessCode.locationList;
        };
        this.getWirelessProvidersUrl = () => {
            return this.serverBaseUrl + this.location.wirelessProvider;
        };
        this.getCreateLocationUrl = () => {
            return this.serverBaseUrl + this.location.createLocation;
        };
        this.getCreateMSELocationUrl = () => {
            return this.serverBaseUrl + this.location.createMSELocation;
        };
        this.getAvailableLocationsUrl = () => {
            return this.serverBaseUrl + this.location.getAvailableLocations;
        };
        this.getAvailableLocationsByTypeUrl = (menu_type) => {
            console.log(':: getAvailableLocationsByTypeUrl :: menu_type :: ', menu_type);
            return this.serverBaseUrl + '/location/' + menu_type + this.location.getAvailableLocationsByType;
        };
        this.getNetworksforOrgUrl = () => {
            return this.serverBaseUrl + this.location.getNetworksforOrg;
        };
        this.getSaveMerakiOrganisationUrl = () => {
            return this.serverBaseUrl + this.location.saveMerakiOrganisation;
        };
        this.getAvailableApsUrl = () => {
            return this.serverBaseUrl + this.location.getAvailableAps;
        };
        this.getApsAndFloorMapsUrl = () => {
            return this.serverBaseUrl + this.maps.getApsAndFloorMaps;
        };
        this.getFloorMapsUrl = () => {
            return this.serverBaseUrl + this.maps.getFloorMaps;
        };
        this.getMapsImageAsByte = () => {
            return this.serverBaseUrl + this.maps.getImageAsByte;
        };
        this.getMapImageUploadUrl = () => {
            return this.clientBaseUrl + this.maps.uploadImageFile;
        };
        this.importCmxSitesUrl = () => {
            return this.mapsBaseUrl + this.maps.importCmxSites;
        };
        this.getCmxSitesUrl = () => {
            return this.mapsBaseUrl + this.maps.cmxSitesList;
        };
        this.getUploadPrimeMapsZipFileURL = () => {
            return this.mapsBaseUrl + this.maps.uploadPrimeMapsZipFile;
        };
        this.getUploadDNACMapsZipFileURL = () => {
            return this.mapsBaseUrl + this.maps.uploadDNACMapsZipFile;
        };
        this.getUploadHistoyUrl = () => {
            return this.mapsBaseUrl + this.maps.uploadMapsHistoy;
        };
        this.getMapsUploadedStatus = () => {
            return this.mapsBaseUrl + this.maps.uploadedStatus;
        };
        this.updateMicelloMapUrl = () => {
            return this.serverBaseUrl + this.maps.updateMicelloMap;
        };
        this.updateMerakiMapUrl = () => {
            return this.serverBaseUrl + this.maps.updateMerakiMap;
        };
        this.updateMseMapUrl = () => {
            return this.serverBaseUrl + this.maps.updateMseMap;
        };
        this.updateImageMapUrl = () => {
            return this.serverBaseUrl + this.maps.updateImageMap;
        };
        this.getMetadataKeysUrl = () => {
            return this.serverBaseUrl + this.location.getMetadataKeys;
        };
        this.getMetadataKeysLh2Url = () => {
            return this.serverBaseUrl + this.businessHierarchy.getMetadataKeys;
        };
        this.getLocationMetadataUrlLh2 = (locationId) => {
            return this.serverBaseUrl + this.businessHierarchy.getLocationMetadata + locationId;
        };
        this.getMetadataLh2Url = () => {
            return this.serverBaseUrl + this.businessHierarchy.getMetadata;
        };
        this.getTenantLocationMetadata = () => {
            return this.serverBaseUrl + this.businessHierarchy.getTenantLocationMetadata;
        };
        this.getAddLocationMetadataUrllh2 = () => {
            return this.serverBaseUrl + this.businessHierarchy.addLocationMetadata;
        };
        this.getModifyLocationMetadataUrllh2 = () => {
            return this.serverBaseUrl + this.businessHierarchy.modifyLocationMetadata;
        };
        this.getDeleteLocationMetadataUrllh2 = () => {
            return this.serverBaseUrl + this.businessHierarchy.deleteLocationMetadata;
        };
        this.getMetadataUrl = () => {
            return this.serverBaseUrl + this.location.getMetadata;
        };
        this.getAllMetadataUrl = () => {
            return this.serverBaseUrl + this.location.getAllMetadata;
        };
        this.getAddLocationMetadataUrl = () => {
            return this.serverBaseUrl + this.location.addLocationMetadata;
        };
        this.getModifyLocationMetadataUrl = () => {
            return this.serverBaseUrl + this.location.modifyLocationMetadata;
        };
        this.getDeleteLocationMetadataUrl = () => {
            return this.serverBaseUrl + this.location.deleteLocationMetadata;
        };
        this.getAuthenticateMeraki = () => {
            return this.serverBaseUrl + this.location.authMeraki;
        };
        this.getMerakiApiKeysListUrl = () => {
            return this.serverBaseUrl + this.location.merakiApiKeysList;
        };
        this.getMerakiAccessTokensListUrl = () => {
            return this.serverBaseUrl + this.location.merakiAccessTokensList;
        };
        this.getAuthenticateMSEUrl = () => {
            return this.serverBaseUrl + this.location.authMSE;
        };
        this.getManualUploadCampusDataUrl = () => {
            return this.serverBaseUrl + this.location.getManualUploadCampusData;
        };
        this.getDisconnectMeraki = () => {
            return this.serverBaseUrl + this.location.disconnectMeraki;
        };
        this.getWirelessProviderAuthStatusUrl = () => {
            return this.serverBaseUrl + this.location.getWirelessProviderAuthStatus;
        };
        this.getLocationSyncStatusUrl = () => {
            return this.serverBaseUrl + this.location.getLocationSyncStatus;
        };
        this.getWPLocationSyncStatusUrl = () => {
            return this.serverBaseUrl + this.location.getWPLocationSyncStatus;
        };
        this.getImportSSIDOrgUrl = () => {
            return this.serverBaseUrl + this.ssid.getImportSSIDOrg;
        };
        this.getNetworkSSIDUrl = () => {
            return this.serverBaseUrl + this.ssid.networkSSID;
        };
        this.getAvailableControllerIpsUrl = () => {
            return this.serverBaseUrl + this.location.availableControllerIps;
        };
        this.getEditWLCControllerUrl = () => {
            return this.serverBaseUrl + this.location.getEditWLCController;
        };
        this.getAvailableWLCControllerIpsUrl = () => {
            return this.serverBaseUrl + this.location.availableWLCControllerIps;
        };
        this.getAllWLCControllerIpsUrl = () => {
            return this.serverBaseUrl + this.location.allWLCControllerIps;
        };
        this.getWLCControllerIpsUrl = () => {
            return this.serverBaseUrl + this.location.getWLCControllerIps;
        };
        this.getAvailableWLCNetworksUrl = () => {
            return this.serverBaseUrl + this.location.getAvailableWLCNetworks;
        };
        this.getAvailableWLCAPsUrl = () => {
            return this.serverBaseUrl + this.location.getAvailableWLCAPs;
        };
        this.getAddNetworkLocationUrl = () => {
            return this.serverBaseUrl + this.location.addNetworkLocation;
        };
        this.getOrganizationFromKeyUrl = () => {
            return this.serverBaseUrl + this.location.getOrganizationFromKey;
        };
        this.getCaptchaTemplateUrl = () => {
            return this.clientBaseUrl + this.auth.getCaptchaTemplate;
        };
        this.getRequestDemoUrl = () => {
            return this.clientBaseUrl + this.auth.requestDemo;
        };
        this.getImportMerakiSSIDUrl = () => {
            return this.serverBaseUrl + this.ssid.importMerakiSSID;
        };
        this.getSSIDManualConfigInfoUrl = () => {
            return this.serverBaseUrl + this.ssid.manualConfiguration;
        };
        this.getSSIDStatusUrl = () => {
            return this.serverBaseUrl + this.ssid.ssidStatus;
        };
        this.updateSSIDUrl = () => {
            return this.serverBaseUrl + this.ssid.updateSSID;
        };
        this.getSSIDWalledGardenDomainsUrl = () => {
            return this.serverBaseUrl + this.ssid.walledGardenDomains;
        };
        this.getSSIDWalledGardenRangesUrl = () => {
            return this.clientBaseUrl + this.ssid.walledGardenRanges;
        };
        this.getGroupLocationCreateUrl = () => {
            return this.serverBaseUrl + this.location.getGroupLocationCreate;
        };
        this.getGroupLocationEditUrl = () => {
            return this.serverBaseUrl + this.location.getGroupLocationEdit;
        };
        this.getCreateGroupUrl = () => {
            return this.serverBaseUrl + this.location.createGroup;
        };
        this.getMSELocationUrl = () => {
            return this.serverBaseUrl + this.location.getMSELocation;
        };
        this.getupdateMSELocationUrl = () => {
            return this.serverBaseUrl + this.location.updateMSELocation;
        };
        this.getupdateWLCControllerUrl = () => {
            return this.serverBaseUrl + this.location.updateWLCController;
        };
        this.getDeleteControllerUrl = () => {
            return this.serverBaseUrl + this.location.deleteController;
        };
        this.getUploadFileByDNDUrl = () => {
            return this.clientBaseUrl + this.csseditor.uploadFileByDND;
        };
        this.getSyncStatusUrl = () => {
            return this.serverBaseUrl + this.location.getSyncStatus;
        };
        this.getShareAccessCodeUrl = () => {
            return this.serverBaseUrl + this.accessCode.shareAccessCode;
        };
        this.getRemoveShareEmailUrl = () => {
            return this.serverBaseUrl + this.accessCode.removeShareEmail;
        };
        this.getToggleAccessCodeUrl = () => {
            return this.serverBaseUrl + this.accessCode.toggleAccessCodeStatus;
        };
        this.getShareAccessCodeEmailUrl = () => {
            return this.clientBaseUrl + this.accessCode.shareAccessCodeEmail;
        };
        this.getAddBleBeaconUrl = () => {
            return this.serverBaseUrl + this.location.addBleBeacon;
        };
        this.getEditBleBeaconUrl = () => {
            return this.serverBaseUrl + this.location.editBleBeacon;
        };
        this.getDeleteBleBeaconUrl = () => {
            return this.serverBaseUrl + this.location.deleteBleBeacon;
        };
        this.getBleBeaconUrl = () => {
            return this.serverBaseUrl + this.location.getBleBeacon;
        };
        this.updateLanguageAssetUrl = () => {
            return this.serverBaseUrl + this.portal.updateLanguageAsset;
        };
        this.downloadLanguageAssetUrl = () => {
            return this.clientBaseUrl + this.portal.downloadLanguageAsset;
        };
        this.getExportPortalUrl = () => {
            return this.clientBaseUrl + this.portal.exportPortal;
        };
        this.getTimeZoneUrl = () => {
            return this.serverBaseUrl + this.location.getTimeZone;
        };
        this.getLocationInfoUrl = () => {
            return this.serverBaseUrl + this.location.getLocationInfo;
        };
        this.getMerakiLoginNetworkCountUrl = () => {
            return this.serverBaseUrl + this.location.getMerakiLoginNetworkCount;
        };
        this.getMerakiCameraLoginNetworkCountUrl = () => {
            return (this.serverBaseUrl + this.location.getMerakiCameraLoginNetworkCount);
        };
        this.getMerakiAPINetworkCountUrl = () => {
            return this.serverBaseUrl + this.location.getMerakiAPINetworkCount;
        };
        this.getMerakiCameraAPINetworkCountUrl = () => {
            return (this.serverBaseUrl + this.location.getMerakiCameraAPINetworkCount);
        };
        this.getCMXMapsCountUrl = () => {
            return this.serverBaseUrl + this.location.getCMXMapsCount;
        };
        this.getWLCCountUrl = () => {
            return this.serverBaseUrl + this.location.getWLCCount;
        };
        this.getCMXLocationsUrl = () => {
            return this.serverBaseUrl + this.location.getCMXLocations;
        };
        this.getCMXLocationsCountUrl = () => {
            return this.serverBaseUrl + this.location.getCMXLocationsCount;
        };
        this.updateLocationInfoUrl = () => {
            return this.serverBaseUrl + this.location.updateLocationInfo;
        };
        this.getLoginHistoryUrl = () => {
            return this.serverBaseUrl + this.auth.getLoginHistory;
        };
        this.getSuccessLoginHistoryUrl = () => {
            return this.serverBaseUrl + this.auth.getSuccessLoginHistory;
        };
        this.getFailureLoginHistoryUrl = () => {
            return this.serverBaseUrl + this.auth.getFailureLoginHistory;
        };
        this.getMSEImageUrl = () => {
            return this.serverBaseUrl + this.location.getMSEImage;
        };
        this.getPortalLocaleValuesUrl = () => {
            return this.serverBaseUrl + this.portal.locale;
        };
        this.getAppDetailsUrl = () => {
            return this.serverBaseUrl + this.portal.getAppDetails;
        };
        this.getTriggerSupportEmailUrl = () => {
            return this.clientBaseUrl + this.auth.licenseSupport;
        };
        this.getBusinessTagsListUrl = () => {
            return this.serverBaseUrl + this.rules.businessTagsList;
        };
        this.getNetworkStatusInfoUrl = () => {
            return this.serverBaseUrl + this.ssid.networkStatus;
        };
        this.getSetupList = () => {
            return this.serverBaseUrl + this.setup.getSetupList;
        };
        this.getTileRuleCount = () => {
            return this.serverBaseUrl + this.tiles.getRuleCount;
        };
        this.getAuthenticateSFTPUrl = () => {
            return this.serverBaseUrl + this.dataexport.authenticateSFTP;
        };
        this.getCreateExportUrl = () => {
            return this.serverBaseUrl + this.dataexport.createExport;
        };
        this.getExportDataListUrl = () => {
            return this.serverBaseUrl + this.dataexport.exportDataList;
        };
        this.getDeleteExportUrl = () => {
            return this.serverBaseUrl + this.dataexport.deleteExport;
        };
        this.getSsidListV2Url = () => {
            return this.serverBaseUrl + this.ssid.ssidListV2;
        };
        this.getMonitorStatusUrl = () => {
            return this.clientBaseUrl + this.monitoring.monitor;
        };
        this.getMonitoringAppListUrl = () => {
            return this.clientBaseUrl + this.monitoring.appList;
        };
        this.getSupportStatusUrl = () => {
            return this.clientBaseUrl + this.monitoring.support;
        };
        this.getReportDateAnomalyUrl = (reportDate) => {
            return (this.clientBaseUrl +
                this.monitoring.reportDateAll +
                "?reportDate=" +
                reportDate);
        };
        this.getHomeTileConfigUrl = () => {
            return this.serverBaseUrl + this.home.tileConfig;
        };
        this.getHomeTileAppConfigUrl = (appName) => {
            return this.serverBaseUrl + this.home.tileAppConfig + `/${appName}`;
        };
        this.getTileCountUrl = () => {
            return this.serverBaseUrl + this.home.tileCount;
        };
        this.getStatsCount = () => {
            return this.clientBaseUrl + this.home.statsCount;
        };
        this.getRecieveHandshakeDemoKit = () => {
            return this.clientBaseUrl + this.auth.getRecieveHandshakeDemoKitUrl;
        };
        this.getInitiateHandshakeDemoKit = () => {
            return this.clientBaseUrl + this.auth.getInitiateHandshakeDemoKitUrl;
        };
        this.getOnPremTokenUrl = () => {
            return this.serverBaseUrl + this.toolkit.getOnPremAccessToken;
        };
        this.getCMXOnPremConnectorsUrl = () => {
            return this.serverBaseUrl + this.toolkit.getCMXOnPremConnectorsList;
        };
        this.getSwitchBaseUrl = () => {
            return this.serverBaseUrl + this.toolkit.getSwitchesList;
        };
        this.getSwitchCountUrl = () => {
            return this.serverBaseUrl + this.toolkit.getSwitchesCount;
        };
        this.getConfigureSwitchUrl = () => {
            return this.serverBaseUrl + this.toolkit.configureSwitch;
        };
        this.getTermsUpdateUrl = () => {
            return this.serverBaseUrl + this.auth.updateTermsStatus;
        };
        this.getULAConfig = () => {
            return this.serverBaseUrl + this.user.fetchULAConfig;
        };
        this.saveSetupWidget = () => {
            return this.serverBaseUrl + this.setup.saveSetupWidget;
        };
        this.getConfiguredWidgets = () => {
            return this.serverBaseUrl + this.setup.getConfiguredWidgets;
        };
        this.getDataForWidgets = () => {
            return this.serverBaseUrl + this.setup.getDataForWidgets;
        };
        this.getDataForWiredWidgets = () => {
            return this.serverBaseUrl + this.setup.getDataForWiredWidgets;
        };
        this.deleteWirelessWidget = () => {
            return this.serverBaseUrl + this.setup.deleteWirelessWidgetData;
        };
        this.getBusinessLocationsUrl = () => {
            return this.serverBaseUrl + this.setup.getBusinessLocationList;
        };
        this.getReviewMapLocationListUrl = () => {
            return this.serverBaseUrl + this.setup.getReviewMapLocationList;
        };
        this.getAddMapLocationListUrl = () => {
            return this.serverBaseUrl + this.setup.getAddMapLocationList;
        };
        this.addLocationUrl = () => {
            return this.serverBaseUrl + this.setup.addLocation;
        };
        this.updateBusinessLocInfoUrl = () => {
            return this.serverBaseUrl + this.setup.updateLocationInfo;
        };
        this.getRichMapsLocationUrl = () => {
            return this.serverBaseUrl + this.setup.getRichMapsLocationList;
        };
        this.getFloorDetailsUrl = () => {
            return this.setup.getFloorDetails;
        };
        this.getRichmapsHistoryUrl = () => {
            return this.setup.getRichmapsHistory;
        };
        this.getFloorIndexUrl = () => {
            return this.setup.getFloorIndex;
        };
        this.uploadBusinessLocationUrl = () => {
            return this.serverBaseUrl + this.setup.uploadBusinessLocation;
        };
        this.updateLocationUrl = () => {
            return this.serverBaseUrl + this.setup.updateLocation;
        };
        this.getMapsHierarchyUrl = () => {
            return this.serverBaseUrl + this.setup.mapHierarchy;
        };
        this.getMapsSummaryUrl = () => {
            return this.serverBaseUrl + this.setup.mapsSummary;
        };
        this.getImportSummaryUrl = () => {
            return this.serverBaseUrl + this.setup.importSummary;
        };
        this.getReviewLocationsUrl = () => {
            return this.serverBaseUrl + this.setup.reviewLocations;
        };
        this.saveBusinessLocationsUrl = () => {
            return this.serverBaseUrl + this.setup.saveBusinessLocations;
        };
        this.createFloorsUrl = () => {
            return this.serverBaseUrl + this.setup.createFloors;
        };
        this.addFloorUrl = () => {
            return this.serverBaseUrl + this.setup.addFloor;
        };
        this.uploadRichMapForLocationUrl = () => {
            return this.setup.uploadCADForLocation;
        };
        this.uploadCADForLocationUrl = () => {
            return this.setup.uploadCADForLocation;
        };
        this.confirmCADForLocationUrl = () => {
            return this.setup.confirmCADForLocation;
        };
        this.cancelRichMapForLocationUrl = () => {
            return this.setup.cancelRichMapForLocation;
        };
        this.cancelDigitalMapUrl = () => {
            return this.setup.cancelDigitalMap;
        };
        this.deleteRichMapForLocationUrl = () => {
            return this.setup.deleteRichMapForLocation;
        };
        this.deleteDigitalMapForLocationUrl = () => {
            return this.setup.deleteDigitalMapForLocation;
        };
        this.updateBusinessLocationUrl = () => {
            return this.serverBaseUrl + this.setup.updateBusinessLocationUrl;
        };
        this.updateMetaDataUrl = () => {
            return this.serverBaseUrl + this.setup.updateMetaData;
        };
        this.digitalMapFloorList = () => {
            return this.serverBaseUrl + this.setup.digitalMapFloorListUrl;
        };
        this.digitalMapFloorsWithStatus = () => {
        };
        this.digitalMapUpdateFloorList = () => {
            return this.serverBaseUrl + this.setup.digitalMapUpdateFloorsUrl;
        };
        this.digitalMapFloorMapping = () => {
            return this.setup.digitalMapFloorMappingUrl;
        };
        this.saveStandardMap = () => {
            return this.setup.saveMapUrl;
        };
        this.digitalMapBulkUpload = () => {
            return this.setup.digitalMapBulkUploadUrl;
        };
        this.digitalMapfileUpload = () => {
            return this.setup.digitalMapfileUploadUrl;
        };
        this.getCSVFileUrl = () => {
            return this.serverBaseUrl + this.setup.getCSVFile;
        };
        this.getInitiateSSOLoginEndpointUrl = () => {
            return this.tmBaseUrl + this.tm.initiateSSOLogin;
        };
        this.getRoleApplicationListUrl = () => {
            return this.serverBaseUrl + this.user.roleApplicationList;
        };
        this.getCreateAdminRoleUrl = () => {
            return this.serverBaseUrl + this.user.createAdminRole;
        };
        this.getMonitorSummaryUrl = () => {
            return this.clientBaseUrl + this.monitoring.summary;
        };
        this.getMonitorLocUpdateUrl = () => {
            return this.clientBaseUrl + this.monitoring.locUpdates;
        };
        this.getMonitorOneWeekAnomalyUrl = () => {
            return this.clientBaseUrl + this.monitoring.oneweekAnomaly;
        };
        this.getMonitorAppsUrl = () => {
            return this.clientBaseUrl + this.monitoring.appsDetails;
        };
        this.getMonitorEnterpriseIntegUrl = () => {
            return this.clientBaseUrl + this.monitoring.enterpriseInteg;
        };
        this.getMonitorAppLatencyUrl = () => {
            return this.clientBaseUrl + this.monitoring.appLatency;
        };
        this.getMonitorPartnerAppsUrl = () => {
            return this.clientBaseUrl + this.monitoring.parternApps;
        };
        this.getMonitorPartnerAppsDetailsUrl = () => {
            return this.clientBaseUrl + this.monitoring.partnerAppDetails;
        };
        this.getMonitorWebExDeviceDetailsUrl = () => {
            return this.clientBaseUrl + this.monitoring.webExDeviceDetails;
        };
        this.getMonitoringAppsDownUrl = () => {
            return this.clientBaseUrl + this.monitoring.appsDown;
        };
        this.getConnectorDetailsUrl = (connectId) => {
            return (this.clientBaseUrl +
                this.monitoring.connectorDetails +
                "?pathKey=" +
                connectId);
        };
        this.getOpenRoamingGlobalStats = () => {
            return this.serverBaseUrl + this.openroaming.global;
        };
        this.getOpenRoamingChart = () => {
            return this.serverBaseUrl + this.openroaming.chart;
        };
        this.getOpenRoamingVisitStats = () => {
            return this.serverBaseUrl + this.openroaming.visit;
        };
        this.getOpenRoamingDailyChart = () => {
            return this.serverBaseUrl + this.openroaming.dailyChart;
        };
        this.getOpenRoamingDailyVisitStats = () => {
            return this.serverBaseUrl + this.openroaming.dailyVisit;
        };
        // OR profile apis starts
        this.getORProfileListUrl = () => {
            return this.serverBaseUrl + this.openroaming.getORProfileList;
        };
        this.getSaveORProfileUrl = () => {
            return this.serverBaseUrl + this.openroaming.saveORProfile;
        };
        this.getProfileDeleteUrl = () => {
            return this.serverBaseUrl + this.openroaming.deleteORProfile;
        };
        this.getORProfileUrl = () => {
            return this.serverBaseUrl + this.openroaming.getORProfile;
        };
        this.getControllerS3Configurations = () => {
            return this.clientBaseUrl + this.openroaming.getControllers3Configurations;
        };
        this.getSPListUrl = () => {
            return this.serverBaseUrl + this.openroaming.getSPList;
        };
        this.getORDomainListUrl = () => {
            return this.serverBaseUrl + this.openroaming.getDomainList;
        };
        this.getSPPartnerListUrl = () => {
            return this.serverBaseUrl + this.openroaming.getSPPartnerList;
        };
        this.getSaveCustomSPUrl = () => {
            return this.serverBaseUrl + this.openroaming.saveCustomServiceProvider;
        };
        this.getSaveCustomDomainUrl = () => {
            return this.serverBaseUrl + this.openroaming.saveCustomDomain;
        };
        this.getAgreementStatusUrl = () => {
            return this.serverBaseUrl + this.openroaming.getAgreementStatus;
        };
        this.saveAgreementStatusUrl = () => {
            return this.serverBaseUrl + this.openroaming.saveAgreementStatus;
        };
        this.getConfiguredProfileListUrl = () => {
            return this.serverBaseUrl + this.openroaming.getConfiguredProfileList;
        };
        this.saveProfileToControllerUrl = () => {
            return this.serverBaseUrl + this.openroaming.saveProfileToController;
        };
        this.getORLocationListUrl = () => {
            return this.serverBaseUrl + this.openroaming.locationList;
        };
        // OR - Meraki API changes
        this.getMerakiNwCountUrl = () => {
            return this.serverBaseUrl + this.openroaming.getMerakiNwCount;
        };
        this.getMerakiNwProfileListUrl = () => {
            return this.serverBaseUrl + this.openroaming.getMerakiNwProfileList;
        };
        this.createMerakiNwProfileUrl = () => {
            return this.serverBaseUrl + this.openroaming.createMerakiNwProfile;
        };
        this.getMerakiNwProfileUrl = () => {
            return this.serverBaseUrl + this.openroaming.getMerakiNwProfile;
        };
        this.getMerakiNwOrgListUrl = () => {
            return this.serverBaseUrl + this.openroaming.getMerakiNwOrgList;
        };
        this.getMerakiNwListUrl = () => {
            return this.serverBaseUrl + this.openroaming.getMerakiNwList;
        };
        this.getMerakiNwActivationStatusUrl = () => {
            return (this.serverBaseUrl + this.openroaming.getMerakiNwActivationStatus);
        };
        // OR profile apis ends
        this.getAdminEditRoleUrl = () => {
            return this.serverBaseUrl + this.user.editRole;
        };
        this.getPartnerApssListUrl = () => {
            return this.serverBaseUrl + this.partnerApps.appList;
        };
        this.getPartnerUrl = () => {
            return this.serverBaseUrl + this.partnerApps.getPartner;
        };
        this.updatePartnerApps = () => {
            return this.serverBaseUrl + this.partnerApps.updatePartner;
        };
        this.createPartnerApps = () => {
            return this.serverBaseUrl + this.partnerApps.createPartner;
        };
        this.activatePartnerApps = () => {
            return this.serverBaseUrl + this.partnerApps.activateApp;
        };
        this.autoActivatePartnerAppUrl = () => {
            return this.serverBaseUrl + this.partnerApps.autoActivatePartnerAppUrl;
        };
        this.deleteAutoActivationUrl = () => {
            return this.serverBaseUrl + this.partnerApps.deleteAutoActivationUrl;
        };
        this.deleteAutoActivatedAppUrl = () => {
            return this.serverBaseUrl + this.partnerApps.deleteAutoActivatedAppUrl;
        };
        this.activateOnPremPartnerApps = () => {
            return this.serverBaseUrl + this.partnerApps.activateOnPremApp;
        };
        this.getSavePartnerCustomerInfo = () => {
            return this.serverBaseUrl + this.partnerApps.savePartnerCustomerInfo;
        };
        this.getUploadImageFileForPartner = () => {
            return this.clientBaseUrl + this.partnerApps.uploadImageFile;
        };
        this.getDeleteImageFileForPartner = () => {
            return this.clientBaseUrl + this.partnerApps.deleteImageFile;
        };
        this.getActivatedPartnerAppList = () => {
            return this.serverBaseUrl + this.partnerApps.activatedAppList;
        };
        this.getPartnerAppList = () => {
            return this.serverBaseUrl + this.partnerApps.partnerAppList;
        };
        this.getPartnerAppDetailsUrl = () => {
            return this.serverBaseUrl + this.partnerApps.getAppDetails;
        };
        this.getPartnerAppStatusUrl = () => {
            return this.serverBaseUrl + this.partnerApps.getAppStatus;
        };
        this.getOauthAccessToken = () => {
            return this.serverBaseUrl + this.oauth.getAccessToken;
        };
        this.getOauthCustomerInfo = () => {
            return this.clientBaseUrl + this.oauth.getCustomerInfo;
        };
        this.getPartnerAppSSOLoginToken = () => {
            return this.serverBaseUrl + this.partnerApps.getPartnerAppSSOLoginToken;
        };
        this.getPartnerAppsPublicKey = () => {
            return this.serverBaseUrl + this.oauth.getPartnerPublicKey;
        };
        this.validateSSOToken = () => {
            return this.clientBaseUrl + this.oauth.validateSSOToken;
        };
        this.getSandboxCustomers = () => {
            return this.serverBaseUrl + this.partnerApps.getSandboxCustomers;
        };
        this.sandboxTokenUrl = () => {
            return this.clientBaseUrl + this.partnerApps.sandboxToken;
        };
        this.getDeactivateUrl = () => {
            return this.serverBaseUrl + this.partnerApps.deactivateUrl;
        };
        this.checkPartnerLicenseStatusUrl = () => {
            return this.serverBaseUrl + this.partnerApps.checkPartnerLicenseStatus;
        };
        this.getPartnerLicenseInfoUrl = () => {
            return this.serverBaseUrl + this.partnerApps.partnerLicenseInfo;
        };
        this.updatePartnerLicenseApiUrl = () => {
            return this.serverBaseUrl + this.partnerApps.updatePartnerLicense;
        };
        this.getLicenseAgreementUrl = () => {
            return this.clientBaseUrl + this.partnerApps.licenseAgreement;
        };
        this.getDeleteImgUrl = () => {
            return this.clientBaseUrl + this.partnerApps.deleteImgUrl;
        };
        this.getOnPremAppActivationUrl = () => {
            return this.serverBaseUrl + this.partnerApps.onPremAppActivation;
        };
        this.getOnPremAppTokenUrl = () => {
            return this.serverBaseUrl + this.partnerApps.onPremAppToken;
        };
        this.getNewOnPremAppTokenUrl = () => {
            return this.serverBaseUrl + this.partnerApps.onNewPremAppToken;
        };
        this.getRegenOnPremiseTokenUrl = () => {
            return this.serverBaseUrl + this.partnerApps.regenOnPremiseToken;
        };
        this.getRenewOnPremiseTokenUrl = () => {
            return this.serverBaseUrl + this.partnerApps.renewOnPremiseToken;
        };
        this.getCustomEventsUrl = () => {
            return this.serverBaseUrl + this.partnerApps.customEventsUrl;
        };
        this.getActivatedAppDetailsUrl = () => {
            return this.serverBaseUrl + this.partnerApps.activatedAppDetails;
        };
        this.getPendingActivationUrl = () => {
            return this.serverBaseUrl + this.partnerApps.pendingActivation;
        };
        this.getUpdatePartnerAppsLocationsUrl = () => {
            return this.serverBaseUrl + this.partnerApps.updatePartnerAppsLocations;
        };
        this.getDeactivateActivationUrl = () => {
            return this.serverBaseUrl + this.partnerApps.deactivateActivationUrl;
        };
        this.getActivatedPartnerTenantsUrl = () => {
            return this.serverBaseUrl + this.partnerApps.activatedPartnerTenantsUrl;
        };
        this.getAdvancePartnerUrl = () => {
            return this.serverBaseUrl + this.partnerApps.getAdvancePartner;
        };
        this.getShowAppCenterUrl = () => {
            return this.serverBaseUrl + this.partnerApps.getShowAppCenter;
        };
        this.getMerakiCameraListUrl = () => {
            return this.serverBaseUrl + this.location.merakiCameraList;
        };
        this.getMerakiCameraSnapshotUrl = () => {
            return this.serverBaseUrl + this.location.cameraSnapshot;
        };
        this.getMerakiCameraRetentionDetailsUrl = () => {
            return this.serverBaseUrl + this.location.cameraRetentionDetails;
        };
        this.getUpdateTripWireUrl = () => {
            return this.serverBaseUrl + this.location.updateTripWire;
        };
        this.getEmailStatusEndPointUrl = () => {
            return this.tmBaseUrl + this.tm.loginUserstatus;
        };
        this.getAppCenterFiltersUrl = () => {
            return this.serverBaseUrl + this.partnerApps.getAppCenterFilters;
        };
        this.getAppActivationLicenseUrl = () => {
            return this.clientBaseUrl + this.partnerApps.getAppActivationLicense;
        };
        this.getCheckTNCAcceptedUrl = () => {
            return this.serverBaseUrl + this.partnerApps.getCheckTNCAccepted;
        };
        this.getSaveTNCAcceptedUrl = () => {
            return this.serverBaseUrl + this.partnerApps.saveTNCAccepted;
        };
        this.getSSORedirectUrl = (username) => {
            return (this.tmBaseUrl +
                this.tm.initiateSSOLogin +
                username +
                "?app=dnaspaces");
        };
        this.getSSOAdminRedirectUrl = (username) => {
            return this.tmBaseUrl + this.tm.initiateSSOLogin + username + '?app=dnaspaces&adminlogin=' + true + '&continuetoken=admincontinue';
        };
        this.getSharedSSORedirectUrl = (username, shareId, role) => {
            return (this.tmBaseUrl +
                this.tm.sharedSSOLoginRedirect +
                `${username}?shareid=${shareId}&app=dnaspaces&reportlogin=true&role=${role}`);
        };
        this.getRequestAccessUrl = () => {
            return this.clientBaseUrl + this.user.requestAccessUrl;
        };
        this.getDomainListUrl = () => {
            return this.serverBaseUrl + this.preferences.domainList;
        };
        this.addDomainUrl = (domainName) => {
            return this.serverBaseUrl + this.preferences.addDomain + domainName;
        };
        this.removeDomainUrl = (domainName) => {
            return this.serverBaseUrl + this.preferences.removeDomain + domainName;
        };
        this.getSupportLoginStatus = () => {
            return this.serverBaseUrl + this.preferences.getSupportLoginStatus;
        };
        this.updateSupportLoginStatus = (status) => {
            return this.serverBaseUrl + this.preferences.enableSupportLogin + status;
        };
        this.getSsoRoleListUrl = () => {
            return this.serverBaseUrl + this.appuser.ssoRoleList;
        };
        this.getDeleteSsoRoleUrl = () => {
            return this.serverBaseUrl + this.appuser.ssoDeleteRole;
        };
        this.getCreateAdminSsoRoleUrl = () => {
            return this.serverBaseUrl + this.appuser.ssoCreateRole;
        };
        this.getAdminEditSsoRoleUrl = () => {
            return this.serverBaseUrl + this.appuser.ssoUpdateRole;
        };
        this.searchPartnerUrl = () => {
            return this.serverBaseUrl + this.partnerApps.searchPartner;
        };
        this.getCreateNewActivationUrl = () => {
            return this.serverBaseUrl + this.integrations.createNewActivation;
        };
        this.getListActivationUrl = () => {
            return this.serverBaseUrl + this.integrations.listActivations;
        };
        this.getRegenerateTokenUrl = () => {
            return this.serverBaseUrl + this.integrations.regenerateToken;
        };
        this.getDeleteActivationUrl = () => {
            return this.serverBaseUrl + this.integrations.deleteActivation;
        };
        this.getPrefixListUrl = () => {
            return this.serverBaseUrl + this.location.prefixList;
        };
        this.getSavePrefixUrl = () => {
            return this.serverBaseUrl + this.location.savePrefix;
        };
        this.getProfileInfo = (email) => {
            return this.serverBaseUrl + this.auth.getProfileInfo + "/" + email;
        };
        this.updateProfileInfo = () => {
            return this.serverBaseUrl + this.auth.updateProfileInfo;
        };
        this.getDetailsByContactIdUrl = () => {
            return this.serverBaseUrl + this.hubspot.detailByContactId;
        };
        this.getSaveOutboundFormUrl = () => {
            return this.serverBaseUrl + this.hubspot.submitOutBoundForm;
        };
        this.sendOTPToEndUser = () => {
            return this.serverBaseUrl + this.smsgateway.sendOTP;
        };
        this.verifyOTPToEndUser = () => {
            return this.serverBaseUrl + this.smsgateway.verifyOTP;
        };
        this.getChangePasswordUrlViaNode = () => {
            return this.clientBaseUrl + this.user.changePassword;
        };
        this.getRightNowFirstPermittedLocationUrl = () => {
            return this.serverBaseUrl + this.report.rightNowFirstPermittedLocationUrl;
        };
        this.getRightNowTimeReportsUrl = () => {
            return this.serverBaseUrl + this.report.rightNowReportsUrl;
            ;
        };
        this.getRightNowReportsMapViewUrl = () => {
            return this.serverBaseUrl + this.report.rightMapViewNowReportsUrl;
        };
        this.getRightNowsAppCurrentStatusUrl = () => {
            return this.serverBaseUrl + this.report.rightNowAppCurrentStatusUrl;
        };
        this.getRightNowVideoMapUrl = () => {
            return this.serverBaseUrl + this.report.rightNowVideoMapViewUrl;
        };
        // smart license(SL) apis
        this.getSLDetailsUrl = () => {
            return this.serverBaseUrl + this.user.getSLDetails;
        };
        this.deRegisterSmartLicenseUrl = () => {
            return this.serverBaseUrl + this.user.deRegisterSmartLicense;
        };
        this.changeBaseLicenseUrl = () => {
            return this.serverBaseUrl + this.user.changeBaseLicense;
        };
        this.registerSmartLicenseUrl = () => {
            return this.serverBaseUrl + this.user.registerSmartLicense;
        };
        this.renewAuthSmartLicenseUrl = () => {
            return this.serverBaseUrl + this.user.renewAuthSmartLicense;
        };
        this.renewRegistrationSmartLicenseUrl = () => {
            return this.serverBaseUrl + this.user.renewRegistrationSmartLicense;
        };
        this.reRegisterSmartLicenseUrl = () => {
            return this.serverBaseUrl + this.user.reRegisterSmartLicense;
        };
        this.getKnowMoreContentUrl = () => {
            return this.clientBaseUrl + this.integrations.knowMoreContent;
        };
        this.getIntegrationActivationUrl = () => {
            return this.serverBaseUrl + this.integrations.integrationActivationUrl;
        };
        this.getEndDeviceslist = () => {
            return this.serverBaseUrl + this.partnerApps.listEndDevices;
        };
        this.deviceDetailUrl = () => {
            return this.serverBaseUrl + this.partnerApps.deviceDetail;
        };
        this.getCompatibleDevicesUrl = () => {
            return this.serverBaseUrl + this.partnerApps.compatibleDevices;
        };
        this.getRightNowCameraReportsUrl = () => {
            return this.serverBaseUrl + this.report.rightNowCameraReportsUrl;
        };
        this.getRightNowSettingsUrl = () => {
            return this.serverBaseUrl + this.report.rightNowSettingsUrl;
        };
        this.saveRightNowSettingsUrl = () => {
            return this.serverBaseUrl + this.report.saveRightNowSettingsUrl;
        };
        this.getRightNowSSIDListUrl = () => {
            return this.serverBaseUrl + this.report.getRightNowSSIDListUrl;
        };
        this.saveRightNowSSIDSettingsUrl = () => {
            return this.serverBaseUrl + this.report.saveRightNowSSIDSettingsUrl;
        };
        this.saveRightNowCategorySettingsUrl = () => {
            return this.serverBaseUrl + this.report.rnowSaveCategoryUrl;
        };
        this.getRightNowBLEListUrl = () => {
            return this.iotBaseUrl + this.report.rnowBLEListUrl;
        };
        this.getMerakiSyncStatusUrl = () => {
            return this.serverBaseUrl + this.location.merakiSyncStatus;
        };
        this.getDensityOverallUrl = () => {
            return this.serverBaseUrl + this.density.overall;
        };
        this.getDensityRecentActivityUrl = () => {
            return this.serverBaseUrl + this.density.recentActivity;
        };
        this.getDensityRecentActivityCountUrl = () => {
            return this.serverBaseUrl + this.density.recentActivityCount;
        };
        this.getDensityTriggerHistoryDayUrl = () => {
            return this.serverBaseUrl + this.density.triggerHistoryDay;
        };
        this.getDensityTriggerHistoryDayCountUrl = () => {
            return this.serverBaseUrl + this.density.triggerHistoryDayCount;
        };
        this.getDensityTriggerHistoryDayLocationCountUrl = () => {
            return this.serverBaseUrl + this.density.triggerHistoryDayLocationCount;
        };
        this.getDensityTriggerHistoryMonthUrl = () => {
            return this.serverBaseUrl + this.density.triggerHistoryMonth;
        };
        this.getAnalyticsAppCurrentStatusUrl = () => {
            return this.serverBaseUrl + this.report.analyticsAppCurrentStatusUrl;
        };
        this.getEnvAppCurrentStatusUrl = () => {
            return this.serverBaseUrl + this.environmentalMetrics.envAppCurrentStatusUrl;
        };
        this.getImpactAnalysisAppCurrentStatusUrl = () => {
            return this.serverBaseUrl + this.impactAnalysis.appCurrentStatusUrl;
        };
        this.getImpactAnalysisgetEventListUrl = () => {
            return this.serverBaseUrl + this.impactAnalysis.getEventListUrl;
        };
        this.getImpactAnalysisgetEventDetailsUrl = () => {
            return this.serverBaseUrl + this.impactAnalysis.getEventDetailstUrl;
        };
        this.getImpactAnalysisAddEventUrl = () => {
            return this.serverBaseUrl + this.impactAnalysis.addEventUrl;
        };
        this.getImpactAnalysisDeleteEventUrl = () => {
            return this.serverBaseUrl + this.impactAnalysis.deleteEventUrl;
        };
        this.getImpactAnalysisUpdateEventUrl = () => {
            return this.serverBaseUrl + this.impactAnalysis.updateEventUrl;
        };
        this.getDashboardRedirectTokenUrl = () => {
            return this.clientBaseUrl + this.auth.getDashboardRedirectTokenUrl;
        };
        this.getTestRuleUrl = () => {
            return this.serverBaseUrl + this.rules.test;
        };
        this.getWebsocketConnectionURL = () => {
            return this.clientBaseUrl + this.auth.webSocketConnection;
        };
        this.getCameraUserFeedPollingURL = () => {
            return this.clientBaseUrl + this.auth.cameraUserFeed;
        };
        this.getAuditTrailUrl = () => {
            return this.serverBaseUrl + this.user.getAuditTrailUrl;
        };
        this.getAuditTrailFilteredUrl = () => {
            return this.serverBaseUrl + this.user.getAuditTrailFilteredUrl;
        };
        this.getAuditTrailEnabledAppsUrl = () => {
            return this.serverBaseUrl + this.user.getAuditTrailEnabledAppsUrl;
        };
        this.getDensityRuleslistUrl = () => {
            return this.serverBaseUrl + this.location.fetchDensityRulesList;
        };
        this.getPauseDensityRuleUrl = () => {
            return this.serverBaseUrl + this.rules.pauseDensityRule;
        };
        this.getMakeDensityRuleLiveUrl = () => {
            return this.serverBaseUrl + this.rules.makeDensityRuleLive;
        };
        this.getDeleteDensityRuleUrl = () => {
            return this.serverBaseUrl + this.rules.deleteDensityRule;
        };
        this.getSaveDensityRuleUrl = () => {
            return this.serverBaseUrl + this.rules.saveDensityRule;
        };
        this.getMapServiceFloorInfoUrl = () => {
            return this.serverBaseUrl + this.maps.getMapServiceFloorInfo;
        };
        this.getCurrentAppStatusUrl = (appName) => {
            return (this.serverBaseUrl +
                this.apps.currentStatus +
                "/" +
                appName +
                "/status");
        };
        this.getAppInviteUrl = (appName) => {
            return this.serverBaseUrl + this.apps.invite + "/" + appName;
        };
        this.getAppEditUrl = (appName) => {
            return this.serverBaseUrl + this.apps.invite + "/" + appName;
        };
        this.getAppDeleteUrl = (appName) => {
            return this.serverBaseUrl + this.apps.delete + "/" + appName;
        };
        this.getAppDeleteStatusUrl = (appName) => {
            return (this.serverBaseUrl + this.apps.getAppDeleteStatus + "/" + appName);
        };
        this.getRBACAppUserListUrl = (appName) => {
            return this.serverBaseUrl + this.apps.list + "/" + appName;
        };
        this.getRBACAppUserInfoUrl = (appName, email) => {
            return (this.serverBaseUrl +
                this.apps.getAppUserInfo +
                "/" +
                appName +
                "/" +
                email);
        };
        this.getEngagementRuleslistUrl = () => {
            return this.serverBaseUrl + this.rules.engagementRuleList;
        };
        this.getEngagementRulesSaveUrl = () => {
            return this.serverBaseUrl + this.rules.engagementRuleSave;
        };
        this.getEngagementRulesUpdateUrl = () => {
            return this.serverBaseUrl + this.rules.engagementRuleUpdate;
        };
        this.getPersonasRuleslistUrl = () => {
            return this.serverBaseUrl + this.rules.locationPersonasRuleList;
        };
        this.getPersonasRulesSaveUrl = () => {
            return this.serverBaseUrl + this.rules.locationPersonasRuleSave;
        };
        this.getPersonasRulesUpdateUrl = () => {
            return this.serverBaseUrl + this.rules.locationPersonasRuleUpdate;
        };
        this.getOpenRoamingIDPLabels = () => {
            return this.serverBaseUrl + this.openroaming.IDPLabel;
        };
        this.getBusinessLocationListUrl = () => {
            return this.serverBaseUrl + this.location.businessLocationList;
        };
        this.getBusinessMapsDetailsUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.mapsDetails;
        };
        this.getBusinessListApsUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.apList;
        };
        this.getBusinessListSensorUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.sensorList;
        };
        this.getBusinessListSwitchUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.switchesCount;
        };
        this.getBusinessApCountUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.apCount;
        };
        this.getBusinessApSearchUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.searchAps;
        };
        this.getLocLicenseTypeUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.getLocLicenseType;
        };
        this.globalLicenseUsageUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.globalLicenseUsage;
        };
        this.saveLocationLicenseInfoUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.saveLocationLicenseInfo;
        };
        // SDK API calls starts
        this.getSDKlListUrl = () => {
            return this.serverBaseUrl + this.sdk.list;
        };
        this.getSDKProfileDetailsURL = () => {
            return this.serverBaseUrl + this.sdk.sdkProfile;
        };
        this.getUpdateSDKPrfileURL = () => {
            return this.serverBaseUrl + this.sdk.updateSDKProfile;
        };
        this.getConsortiumDetailsURL = () => {
            return this.serverBaseUrl + this.sdk.consortiumDetails;
        };
        this.getSDKDetailsUrl = () => {
            return this.serverBaseUrl + this.sdk.getSDKDetails;
        };
        this.getCreateSDKUrl = () => {
            return this.serverBaseUrl + this.sdk.createSDK;
        };
        this.getUpdateSDKUrl = () => {
            return this.serverBaseUrl + this.sdk.updateSDK;
        };
        this.getDeleteSDKUrl = () => {
            return this.serverBaseUrl + this.sdk.deleteSDK;
        };
        this.getUploadFileForSDKUrl = () => {
            return this.clientBaseUrl + this.portal.uploadFileForSDK;
        };
        this.getDeleteFileForSDKUrl = () => {
            return this.clientBaseUrl + this.portal.deleteFileForSDK;
        };
        // signage urls starts
        this.getSignageLaunchUrl = () => {
            return this.serverBaseUrl + this.signage.launchurl;
        };
        this.getAllSignageDeviceListUrl = () => {
            return this.serverBaseUrl + this.signage.allDevicesList;
        };
        this.getSignageDevicesListUrl = () => {
            return this.serverBaseUrl + this.signage.devicesList;
        };
        this.getSignageDeviceDetailsUrl = () => {
            return this.serverBaseUrl + this.signage.deviceDetails;
        };
        this.getDefaultFloorUrl = () => {
            return this.serverBaseUrl + this.signage.defaultFloor;
        };
        this.addSignageDeviceUrl = () => {
            return this.serverBaseUrl + this.signage.addSignageDevice;
        };
        this.configureSignageDeviceUrl = () => {
            return this.serverBaseUrl + this.signage.configureSignageDevice;
        };
        this.deleteSignageDeviceUrl = () => {
            return this.serverBaseUrl + this.signage.deleteSignageDevice;
        };
        this.getWebexDeviceListUrl = () => {
            return this.serverBaseUrl + this.signage.webexDeviceList;
        };
        this.getSignageMetaDataUrl = () => {
            return this.serverBaseUrl + this.signage.metaData;
        };
        this.getWorkSpaceDeviceDetailsURL = (locationId, macAddress) => {
            return this.serverBaseUrl + this.signage.getWorkSpacesDeviceDetails.get(locationId, macAddress);
        };
        this.getWorkSpaceDeviceListURL = (locationId) => {
            return this.serverBaseUrl + this.signage.getWorkSpacesDeviceList.get(locationId);
        };
        this.getDeviceImageFromS3 = () => {
            return this.clientBaseUrl + this.signage.deviceImageFromS3;
        };
        this.getLocRoomListDataURL = (locationId) => {
            return this.serverBaseUrl + this.signage.locRoomList.get(locationId);
        };
        this.getWebexRoomListDataURL = (locationId) => {
            return this.serverBaseUrl + this.signage.webexRoomList.get(locationId);
        };
        this.connectWebexRoomURL = (locationId) => {
            return this.serverBaseUrl + this.signage.connectWebexRoom.post(locationId);
        };
        this.disconnectLocRoomURL = (workspaceId, locationId) => {
            return this.serverBaseUrl + this.signage.disconnectLocRoom.get(locationId, workspaceId);
        };
        this.clearLocRoomURL = (workspaceId, locationId) => {
            return this.serverBaseUrl + this.signage.clearLocRoom.delete(locationId, workspaceId);
        };
        this.fetchLocRoomDetailsURL = (workspaceId, locationId) => {
            return this.serverBaseUrl + this.signage.fetchLocRoomDetails.get(locationId, workspaceId);
        };
        this.fetchLocRoomDevicesListDataURL = (workspaceId, locationId) => {
            return this.serverBaseUrl + this.signage.fetchLocRoomDevicesList.get(locationId, workspaceId);
        };
        this.getSensorDetailsURL = (locationId, macAddress) => {
            return this.serverBaseUrl + this.signage.getSpacesSensorDetails.get(locationId, macAddress);
        };
        this.updateSensorDetailsURL = (locationId, macAddress) => {
            return this.serverBaseUrl + this.signage.updateSpacesSensorDetails.post(locationId, macAddress);
        };
        this.updateOccupancyDetailsURL = (locationId, locRoomId) => {
            return this.serverBaseUrl + this.signage.saveOccupancyDetails.post(locationId, locRoomId);
        };
        this.getCalenderServiceListURL = (locationId) => {
            return this.serverBaseUrl + this.signage.getCalederServiceList.get(locationId);
        };
        this.saveCalenderServiceURL = (locationId) => {
            return this.serverBaseUrl + this.signage.updateCalenderService.post(locationId);
        };
        this.removeCalenderServiceURL = (locationId, locRoomId, type) => {
            return this.serverBaseUrl + this.signage.removeCalenderService.get(locationId, locRoomId, type);
        };
        this.getTokenForSpacesMangerURL = (locationId) => {
            return this.serverBaseUrl + this.signage.getgeneratedToken.post(locationId);
        };
        this.fetchLoc2dMapUrl = (locationId) => {
            return this.serverBaseUrl + this.signage.fetchLoc2dMap.get(locationId);
        };
        this.get2DMapByteImageUrl = (locationId) => {
            return this.serverBaseUrl + this.signage.byteImage.post;
        };
        this.addLocRoomDevicesListDataURL = (workspaceId, locationId) => {
            return this.serverBaseUrl + this.signage.addDevices.post(locationId, workspaceId);
        };
        this.disassociateLocRoomDevicesListDataURL = (workspaceId, locationId) => {
            return this.serverBaseUrl + this.signage.disassociateDevices.post(locationId, workspaceId);
        };
        // disassociateLocRoomDevicesListDataURL = (workspaceId: string, locationId: string) => {
        // 	return this.serverBaseUrl + this.signage.disassociateDevices.post(locationId, workspaceId);
        // };
        this.connectWebexWorkspaceURL = () => {
            return this.serverBaseUrl + this.signage.connectWorkspaceWebex.post;
        };
        this.disconnectWorkspaceWebexURL = (workspaceId, locationId) => {
            return this.serverBaseUrl + this.signage.disconnectWorkspace.get(locationId, workspaceId);
        };
        this.clearWorkspaceWebexURL = (workspaceId, locationId) => {
            return this.serverBaseUrl + this.signage.deleteWorkspace.delete(locationId, workspaceId);
        };
        this.getSignageLocationListUrl = () => {
            return this.serverBaseUrl + this.signage.locationList;
        };
        this.getWorkSpaceLocationListUrl = () => {
            return this.serverBaseUrl + this.signage.workSpacelocationList;
        };
        // sensor url starts
        this.getSensorListUrl = () => {
            return this.serverBaseUrl + this.sensor.sensorList;
        };
        this.getClaimSensorUrl = () => {
            return this.serverBaseUrl + this.sensor.claimSensor;
        };
        this.getUnclaimSensorUrl = () => {
            return this.serverBaseUrl + this.sensor.unclaimSensor;
        };
        this.getORSSIDListUrl = () => {
            return this.serverBaseUrl + this.sensor.getSSIDList;
        };
        this.getConnectSensorToSSIDUrl = () => {
            return this.serverBaseUrl + this.sensor.connectSSID;
        };
        this.getSensorDetailsUrl = () => {
            return this.serverBaseUrl + this.sensor.sensorDetail;
        };
        this.updateLocationV2InfoUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.updateLocationV2Info;
        };
        this.getSLTrialEndDateUrl = (tenantId) => {
            console.log("url is ", this.serverBaseUrl + this.admin.slTrialDate + '/' + tenantId);
            return this.serverBaseUrl + this.admin.slTrialDate + '/' + tenantId;
        };
        this.setSLTrialDateUrl = () => {
            return this.serverBaseUrl + this.admin.addSLTrial;
        };
        // getOpenRoamingIDPLabels = () => {
        //   return this.serverBaseUrl + this.openroaming.IDPLabel;
        // }
        this.getFloorImageFromS3 = () => {
            return this.serverBaseUrl + this.businessHierarchy.getImageAsByte;
        };
        this.getAppCenterActivatedPartnerAppUrl = (appId) => {
            return (this.serverBaseUrl +
                this.appCenter.getAppActivations.replace(":appId", appId));
        };
        this.getFloorMapDetails = () => {
            return this.mapsBaseUrl;
        };
        this.getFloorMapImage = () => {
            return this.serverBaseUrl + this.businessHierarchy.getFloorImage;
        };
        this.getFloorDetails = () => {
            return this.serverBaseUrl + this.businessHierarchy.getFloorDetails;
        };
        // Business Hierarchy Camera APIs
        this.getCameraListUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.getCameraList;
        };
        this.searchCameraUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.searchCamera;
        };
        this.updatePolygonZoneUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.updatePolygonZoneUrl;
        };
        this.createPolygonZoneUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.createPolygonZoneUrl;
        };
        this.getAppCenterActivatedPartnerAppListUrl = () => {
            return this.serverBaseUrl + this.appCenter.activatedAppList;
        };
        this.getAppCenterRemoveAppActivationsUrl = (appId) => {
            return (this.serverBaseUrl +
                this.appCenter.removeAppActivations.replace(":appId", appId));
        };
        this.getAppCenterUpdateAcceptedPermissionsUrl = (appId) => {
            return (this.serverBaseUrl +
                this.appCenter.updateAcceptedPermissions.replace(":appId", appId));
        };
        /*******************  Environmental lib ***************/
        this.getEUPOEUrl = () => {
            return this.serverBaseUrl + this.energyUtilization.poeUrl;
        };
        this.getEUReportDate = () => {
            return this.serverBaseUrl + this.energyUtilization.settingsUrl;
        };
        this.getMetricsOverviewData = (queryParams) => {
            return this.serverBaseUrl + this.environmentalMetrics.overview + "?" + queryParams;
        };
        this.getEnvMetricsSettings = () => {
            return this.serverBaseUrl + this.environmentalMetrics.settings;
        };
        this.getEnvMetricsFloorCount = (queryParams) => {
            return this.serverBaseUrl + this.environmentalMetrics.floorCount + "?" + queryParams;
        };
        this.getEnvMetricsSensorCount = () => {
            return this.serverBaseUrl + this.environmentalMetrics.sensorCount;
        };
        this.saveEnvMetricsSettings = () => {
            return this.serverBaseUrl + this.environmentalMetrics.saveSettings;
        };
        this.getSensorData = (metric, queryParams) => {
            return this.serverBaseUrl + this.environmentalMetrics.sensors + metric + "?" + queryParams;
        };
        this.getWorkspaceDataFromId = (queryParams) => {
            return this.serverBaseUrl + this.environmentalMetrics.workspaceInfo + "?" + queryParams;
        };
        this.getEnvMonthConfig = () => {
            return this.serverBaseUrl + this.environmentalMetrics.month;
        };
        this.getEnvWorkspaceDetails = () => {
            return this.serverBaseUrl + this.environmentalMetrics.workspaces;
        };
        this.getViolationSummary = (metric) => {
            return this.serverBaseUrl + this.environmentalMetrics.violationSummary + metric;
        };
        this.getEnvReportDate = () => {
            return this.serverBaseUrl + this.environmentalMetrics.date;
        };
        /******************* End Environmental lib  ***************/
        this.getLocation2SyncStatusUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.getLocation2SyncStatusUrl;
        };
        this.renameLoc2 = () => {
            return this.serverBaseUrl + this.businessHierarchy.renameLoc2Url;
        };
        this.getLocationViewPreferenceUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.getLocationViewPreferenceUrl;
        };
        this.setLocationViewPreferenceUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.setLocationViewPreferenceUrl;
        };
        this.listApPrefix = () => {
            return this.serverBaseUrl + this.businessHierarchy.listApPrefix;
        };
        this.searchMatchingAp = () => {
            return this.serverBaseUrl + this.businessHierarchy.searchMatchingAp;
        };
        this.updateApPrefix = () => {
            return this.serverBaseUrl + this.businessHierarchy.updateApPrefix;
        };
        this.recentSearchUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.recentSearch;
        };
        this.saveRecentSearchUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.saveRecentSearch;
        };
        this.getCreateDataExportUrl = () => {
            return this.serverBaseUrl + this.reportsDataexport.createExport;
        };
        this.getDeleteDataExportUrl = () => {
            return this.serverBaseUrl + this.reportsDataexport.deleteExport;
        };
        this.getReportsExportDataListUrl = () => {
            return this.serverBaseUrl + this.reportsDataexport.exportDataList;
        };
        this.getReportsUpdateExportListUrl = () => {
            return this.serverBaseUrl + this.reportsDataexport.updateExport;
        };
        this.getUploadKeyUrl = () => {
            return this.serverBaseUrl + this.reportsDataexport.uploadKey;
        };
        this.getDeleteLocationV2 = (locationId) => {
            return this.serverBaseUrl + this.businessHierarchy.deleteLocationV2 + `/${locationId}`;
        };
        this.getDeleteLocationV2Status = (locationId) => {
            return this.serverBaseUrl + this.businessHierarchy.deleteLocationStatus + `/${locationId}`;
        };
        this.locationInfoForBulkUpdate = () => {
            return this.serverBaseUrl + this.businessHierarchy.locationInfoForBulkUpdate;
        };
        this.bulkUpdateLocationMetadata = () => {
            return this.serverBaseUrl + this.businessHierarchy.bulkUpdateLocationMetadata;
        };
        this.bulkUpdateLocationInfo = () => {
            return this.serverBaseUrl + this.businessHierarchy.bulkUpdateLocationInfo;
        };
        this.uncategorisedApCount = () => {
            return this.serverBaseUrl + this.businessHierarchy.uncategorisedApCount;
        };
        this.uncategorizedApList = () => {
            return this.serverBaseUrl + this.businessHierarchy.uncategorizedApList;
        };
        this.autoPrefixStatus = () => {
            return this.serverBaseUrl + this.businessHierarchy.autoPrefixStatus;
        };
        this.autoPrefixStatusUpdate = () => {
            return this.serverBaseUrl + this.businessHierarchy.autoPrefixStatusUpdate;
        };
        this.webexTPList = () => {
            return this.serverBaseUrl + this.businessHierarchy.webexTPList;
        };
        this.devicesAttached = () => {
            return this.serverBaseUrl + this.businessHierarchy.devicesAttached;
        };
        this.getCreateGroup2Url = () => {
            return this.serverBaseUrl + this.businessHierarchy.createGroup;
        };
        //Data Export API Calls
        this.getReportsAuthenticateSFTPUrl = () => {
            return this.serverBaseUrl + this.reportsDataexport.authenticateSFTP;
        };
        // #####################  IoT Explorer Api's Start ##################
        this.getEUPDUUrl = () => {
            return this.serverBaseUrl + this.energyUtilization.pduUrl;
        };
        this.getEUHistoricalPOEUrl = () => {
            return this.serverBaseUrl + this.energyUtilization.historicalPoe;
        };
        this.getEUHistoricalPduUrl = () => {
            return this.serverBaseUrl + this.energyUtilization.historicalPdu;
        };
        // #####################  IoT Explorer Api's Start ##################
        this.uploadSensorFileUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.uploadSensor;
        };
        this.importSensorsUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.importSensors;
        };
        this.getCreateUSeCaseUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.createUseCase;
        };
        this.getUseCaseListUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.getUseCaseList;
        };
        this.getUseCaseListCountUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.getUseCaseListCount;
        };
        this.getUseCaseDetailUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.getUseCaseDetail + useCaseId;
        };
        this.getIoTSensorListUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.getSensorList + useCaseId;
        };
        this.getDeleteUseCaseUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.deleteUseCase + useCaseId;
        };
        this.getLocationHierarchyUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.locationHierarchy;
        };
        this.getLocationHierarchyDeviceCountUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.locationHierarchyDeviceCount;
        };
        this.getLocationFloorDatailsUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.floorDetails;
        };
        this.getConfiguredCountUrl = (useCaseId, useCaseType) => {
            return this.serverBaseUrl + this.iotExplorer.configuredCount + useCaseId + '?type=' + useCaseType;
        };
        this.getupdateUseCaseUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.updateUseCase + useCaseId;
        };
        this.getFloorsAccessPointsUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.floorAps;
        };
        this.getOccupancyFloorDetailsUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.occupancyFloorDetails;
        };
        this.updateOccupancyFloorUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.updateOccupancyFloor;
        };
        this.getAttributeListUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.getAttributeList + useCaseId;
        };
        this.saveAttributesUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.saveAttributes + useCaseId;
        };
        this.validDelAttributes = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.validDelAttributes + useCaseId;
        };
        this.downloadSensorTemplateUrl = (useCaseId, downloadType) => {
            return this.serverBaseUrl + this.iotExplorer.downloadSensorTemplate + useCaseId + '?type=' + downloadType;
        };
        this.getExisitngDeviceListUrl = (useCaseId, type, usecaseType) => {
            return this.serverBaseUrl + this.iotExplorer.existingDeviceList + useCaseId + '?type=' + type + '&useCaseType=' + usecaseType;
        };
        this.getSensorCountUrl = (useCaseId, usecaseType) => {
            return this.serverBaseUrl + this.iotExplorer.getSensorCount + useCaseId + '?useCaseType=' + usecaseType;
        };
        this.saveExistingSensorUrl = (useCaseId, usecaseType) => {
            return this.serverBaseUrl + this.iotExplorer.saveExistingSensor + useCaseId + '?useCaseType=' + usecaseType;
        };
        this.addSensorManualUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.addAssetManually + useCaseId;
        };
        this.getMacAddress = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.searchMacAddress + useCaseId;
        };
        this.getAssetDetailUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.getAssetDetail + useCaseId;
        };
        this.deleteManualSensorUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.deleteManualSensor + useCaseId;
        };
        this.getDeviceLastHeardUrl = (uid) => {
            return this.serverBaseUrl + this.iotExplorer.deviceLastHeard + uid;
        };
        this.deleteOccupancySensorUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.deleteOccupancySensor;
        };
        this.getSearchValue = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.filterSearchValue + useCaseId;
        };
        this.getSearchSensorList = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.filterSearchApply + useCaseId;
        };
        this.getLocatorListUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.locatorList + useCaseId;
        };
        this.getDefaultViewCountUrl = (useCaseId, useCaseType) => {
            return this.serverBaseUrl + this.iotExplorer.defaultViewCount + useCaseId + '?useCaseType=' + useCaseType;
        };
        this.getUpdateAssetUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.updateAssetUrl + useCaseId;
        };
        this.getTemperatureHistoryDummyUrl = (useCaseId, deviceId, startDate, endDate, barIntervalUnit, barIntervalValue, unit) => {
            return this.serverBaseUrl + this.iotExplorer.dummyTemperatureHistoryUrl + useCaseId + '?deviceId=' + deviceId + '&startDate=' + startDate + '&endDate=' + endDate + '&barIntervalUnit=' + barIntervalUnit + '&barIntervalValue=' + barIntervalValue + '&degree=' + unit;
        };
        this.getTemperatureHistoryUrl = (useCaseId, deviceId, startDate, endDate, barIntervalUnit, barIntervalValue, unit) => {
            return this.serverBaseUrl + this.iotExplorer.temperatureHistoryUrl + useCaseId + '?deviceId=' + deviceId + '&startDate=' + startDate + '&endDate=' + endDate + '&barIntervalUnit=' + barIntervalUnit + '&barIntervalValue=' + barIntervalValue + '&degree=' + unit;
        };
        this.getTemHistoryMinDateUrl = (useCaseId, deviceId) => {
            return this.serverBaseUrl + this.iotExplorer.minimumDateUrl + useCaseId + '?deviceId=' + deviceId;
        };
        this.iotRuleListUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.commonRuleUrl + useCaseId;
        };
        this.iotCreateRuleUrl = (useCaseId, useCaseType) => {
            return this.serverBaseUrl + this.iotExplorer.commonRuleUrl + useCaseId + '?useCaseType=' + useCaseType;
        };
        this.iotUpdateRuleUrl = (ruleId) => {
            return this.serverBaseUrl + this.iotExplorer.commonRuleUrl + ruleId;
        };
        this.iotDeleteRuleUrl = (ruleId) => {
            return this.serverBaseUrl + this.iotExplorer.commonRuleUrl + ruleId;
        };
        this.iotRuleDetailsUrl = (ruleId) => {
            return this.serverBaseUrl + this.iotExplorer.ruleDetailUrl + ruleId;
        };
        this.iotLocationMetadataUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.locMetadataUrl + useCaseId;
        };
        this.iotAssetMetadataUrl = (useCaseId, metadata, metadataType) => {
            return this.serverBaseUrl + this.iotExplorer.assetMetadataUrl + useCaseId + '?metadata=' + metadata + '&metadataType=' + metadataType;
        };
        this.iotListRole = (usecaseId, filterType) => {
            return this.serverBaseUrl + this.iotExplorer.roleUrl + usecaseId + '?filter=' + filterType;
        };
        this.iotRoleListForRuleUrl = (usecaseId, filterType, ruleType) => {
            return this.serverBaseUrl + this.iotExplorer.roleUrl + usecaseId + '?filter=' + filterType + '&rule=' + ruleType;
        };
        this.iotCreateRole = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.roleUrl + usecaseId;
        };
        this.iotUpdateRole = (roleId) => {
            return this.serverBaseUrl + this.iotExplorer.roleUrl + roleId;
        };
        this.iotDeleteRole = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.roleUrl + usecaseId;
        };
        this.iotRoleDropDownUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.roleUrl + usecaseId + '/count';
        };
        this.getIoTUserDropDownUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.manualUserUrl + usecaseId + '/count';
        };
        this.getIoTUserListUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.manualUserUrl + 'list/' + usecaseId;
        };
        this.saveIoTUserUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.manualUserUrl + usecaseId;
        };
        this.updateIoTUserUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.manualUserUrl + usecaseId;
        };
        this.deleteIoTUserUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.manualUserUrl + usecaseId;
        };
        this.getUsersTokenUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.usersTokenUrl + usecaseId;
        };
        this.getIotSendInviteUserMailUrl = () => {
            return this.clientBaseUrl + this.iotExplorer.sendInviteUserMail;
        };
        this.getIotSendInviteSsoUserMailUrl = () => {
            return this.clientBaseUrl + this.iotExplorer.sendInviteSsoUserMail;
        };
        this.getIoTCurrentStatusUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.iotCurrentStatus;
        };
        this.getSendInviteUsecaseNotifyMailUrl = () => {
            return this.clientBaseUrl + this.iotExplorer.sendInviteUsecaseNotifyMail;
        };
        this.getSendInviteSsoUsecaseNotifyMailUrl = () => {
            return this.clientBaseUrl + this.iotExplorer.sendInviteSsoUsecaseNotifyMail;
        };
        this.getChangeRoleUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.changeRoleForUser + usecaseId;
        };
        this.getAssignLocationUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.assignLocationForUser + usecaseId;
        };
        this.getEventsCountUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.commonEvent + usecaseId + '/count';
        };
        this.getIotEventListUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.commonEvent + usecaseId;
        };
        this.getEventsExportUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.commonEvent + usecaseId + '/export';
        };
        this.getDeviceDetailsUrl = (usecaseId, deviceId) => {
            return this.serverBaseUrl + this.iotExplorer.eventDetail + usecaseId + '?deviceId=' + deviceId;
        };
        this.getGroupEventListUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.groupEventList + usecaseId;
        };
        this.getEventChartUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.commonEvent + 'chart/' + usecaseId;
        };
        this.deleteIoTEventsUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.commonEvent + usecaseId;
        };
        this.lookUpEmailUrl = (usecaseId, emailId) => {
            return this.serverBaseUrl + this.iotExplorer.lookUpEmailUrl + usecaseId + '?emailId=' + emailId;
        };
        this.getIoTAppUserList = () => {
            return this.serverBaseUrl + this.iotExplorer.allUsersList;
        };
        this.getSaveCustomViewUrl = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.customView + useCaseId;
        };
        this.getUpdateCustomViewUrl = (viewId) => {
            return this.serverBaseUrl + this.iotExplorer.customView + viewId;
        };
        this.getDeleteCustomViewUrl = (viewId) => {
            return this.serverBaseUrl + this.iotExplorer.customView + viewId;
        };
        this.downloadUserTemplateUrl = (downloadType) => {
            return this.serverBaseUrl + this.iotExplorer.downloadUserTemplate + '?type=' + downloadType;
        };
        this.uploadUserUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.uploadUser;
        };
        this.getRoleMappingDetails = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.roleMapDetails + usecaseId;
        };
        this.updateRoleMappingDetails = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.updateRoleDetails + usecaseId;
        };
        this.locationMappingDetails = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.locationMapDetails + usecaseId;
        };
        this.updateLocMappingDetails = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.updateLocationDetails + usecaseId;
        };
        this.importUsersViaExcel = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.importUsersViaExcel + usecaseId;
        };
        this.importUserRoleFromUseCaseId = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.importUserRoleFromUseCaseId + usecaseId;
        };
        this.createRoleViaImport = (useCaseId) => {
            return this.serverBaseUrl + this.iotExplorer.createRoleViaImport + useCaseId;
        };
        this.updateUserRoleFromUseCaseId = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.updateUserRoleFromUseCaseId + usecaseId;
        };
        this.exportDevicesFileUrl = (usecaseId) => {
            return this.serverBaseUrl + this.iotExplorer.exportDevices + usecaseId;
        };
        this.getImageFromMapService = (imagePath, mimeType) => {
            return this.mapImageBaseUrl + this.maps.getFloorMapImage + imagePath + "?mimeType=" + mimeType;
        };
        this.getLocHistoryUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.locHistory;
        };
        this.getOccupancyHistoryUrl = () => {
            return this.serverBaseUrl + this.iotExplorer.occupancyHistory;
        };
        // #####################  IoT Explorer Api's End ##################
        this.getConnectorSwitches = () => {
            return this.serverBaseUrl + this.toolkit.connectorSwitchs;
        };
        this.getConnectorControllers = () => {
            return this.serverBaseUrl + this.toolkit.connectorControllers;
        };
        this.getConnectorServices = (id) => {
            return this.clientBaseUrl + this.toolkit.getServicesForConnector.replace(":connectorId", id);
        };
        this.addConnectorServicesUrl = () => {
            return this.serverBaseUrl + this.toolkit.addConnectorServices;
        };
        this.upgradeServicesUrl = () => {
            return this.serverBaseUrl + this.toolkit.upgradeServices;
        };
        this.deleteServicesUrl = () => {
            return this.serverBaseUrl + this.toolkit.deleteServices;
        };
        this.restartServicesUrl = () => {
            return this.serverBaseUrl + this.toolkit.restartServices;
        };
        this.restartInstanceServicesUrl = () => {
            return this.serverBaseUrl + this.toolkit.restartInstanceServices;
        };
        this.restartInstanceUrl = () => {
            return this.serverBaseUrl + this.toolkit.restartInstance;
        };
        this.getServiceMetricsStatsUrl = (id, service, instancesIds, interval, sampleRate) => {
            return this.serverBaseUrl + this.toolkit.serviceMetricsStats.replace(":connectorId", id)
                .replace(":service", service)
                .replace(":instances", instancesIds)
                .replace(":interval", interval)
                //.replace(":startTime", startTime)
                //.replace(":endTime", endTime)
                .replace(":sampleRate", sampleRate);
        };
        this.getConnectorInstances = () => {
            return this.serverBaseUrl + this.toolkit.connectorInstances;
        };
        this.deleteConnectorInstance = () => {
            return this.serverBaseUrl + this.toolkit.deleteConnectorInstance;
        };
        this.instanceServiceStatus = (connectorId, instanceId) => {
            return this.serverBaseUrl + "/connector/" + connectorId + "/" + instanceId + this.toolkit.instanceServiceStatus;
        };
        ///connector/:connectorId/refresh/:instances
        this.instanceRefresh = (connectorId, instanceId) => {
            return this.serverBaseUrl + "/connector/" + connectorId + "/refresh/" + instanceId;
        };
        this.checkConnectorUpgrade = (connectorId) => {
            return this.serverBaseUrl + this.toolkit.upgradeConnectorStatus + "/" + connectorId;
        };
        this.connectorUpgrade = (connectorId) => {
            return this.serverBaseUrl + this.toolkit.connectorUpgrade + "/" + connectorId;
        };
        this.listSummaryCounts = (section) => {
            return this.serverBaseUrl + this.toolkit.listSummaryCounts + "/" + section;
        };
        this.instanceInfoServiceMetricUrl = (connectorId, instanceId, service) => {
            return this.serverBaseUrl + this.toolkit.instanceInfoServiceMetric.replace(":connectorId", connectorId)
                .replace(":instances", instanceId).replace(":service", service);
        };
        this.instanceServiceStatusUrl = (connectorId, instanceId) => {
            return this.serverBaseUrl + this.toolkit.instanceServiceStatus.replace(":connectorId", connectorId)
                .replace(":instanceId", instanceId);
        };
        this.uploadConnectorV3LogsUrl = (connectorId, service) => {
            //api/dms/v3/manage/connector/{{CONNECTOR_ID}}/service/{{SERVICE_NAME}}/upload-log POST
            return "manage/connector/" + connectorId + "/" + this.toolkit.uploadV3logs.replace(":service", service);
        };
        this.getCalendarActivationDetails = () => {
            //this.calendarIntegration.calendarServiceDomain
            return this.calendarIntegration.calendarBaseUrl + this.calendarIntegration.getActivationInfo;
        };
        this.doCalendarActivation = () => {
            //this.calendarIntegration.calendarServiceDomain
            return this.calendarIntegration.calendarBaseUrlForActivation;
        };
        this.removeCalendarActivation = () => {
            //this.calendarIntegration.calendarServiceDomain
            return this.calendarIntegration.calendarBaseUrl + this.calendarIntegration.removeActivationInfo;
        };
        /* Calendar Service Integrations  Start */
        this.getCalendarActivationInfoUrl = () => {
            return this.serverBaseUrl + this.calendarIntegration.getCalendarActivationInfo;
        };
        this.activateCalendarUrl = () => {
            return this.serverBaseUrl + this.calendarIntegration.activateCalendar;
        };
        this.removeCalendarActivationUrl = () => {
            return this.serverBaseUrl + this.calendarIntegration.removeCalendarActivation;
        };
        this.clearCalendarActivationUrl = () => {
            return this.serverBaseUrl + this.calendarIntegration.clear;
        };
        this.mappedRoomsUrl = () => {
            return this.serverBaseUrl + this.calendarIntegration.mappedRooms;
        };
        /* Calendar Service Integrations  End */
        this.getDMSV3ProxyUrl = () => {
            return this.serverBaseUrl + this.toolkit.dmsV3Proxy;
        };
        this.postBrowserDetailsUrl = () => {
            return this.serverBaseUrl + this.businessHierarchy.postBrowserDetails;
        };
        this.getIndexedDBFlattened = () => {
            return this.serverBaseUrl + this.businessHierarchy.getIndexedDBFlattened;
        };
        this.getRMSStatus = (locationId) => {
            return this.serverBaseUrl + this.businessHierarchy.getRMSStatus.replace(":locationId", locationId);
        };
        this.indexedDBVersion = () => {
            return this.serverBaseUrl + this.businessHierarchy.indexedDBVersion;
        };
        this.forceRefreshTenant = () => {
            return this.serverBaseUrl + this.businessHierarchy.forceRefreshTenant;
        };
        this.permissionChangeStatus = () => {
            return this.serverBaseUrl + this.businessHierarchy.permissionChangeStatus;
        };
        this.getIsPartnerUrl = () => {
            return this.serverBaseUrl + this.partnerApps.getIsPartner;
        };
        this.getCountryCodesUrl = () => {
            return this.serverBaseUrl + this.user.listCountry;
        };
        this.updateCountryCodeUrl = () => {
            return this.serverBaseUrl + this.user.updateCountry;
        };
        this.getPluginsTenants = () => {
            return this.serverBaseUrl + this.plugins.tenantIds;
        };
        // Room occupancy reports section
        this.getRoomOccupancyReportsUrl = () => {
            return this.serverBaseUrl + this.roomOccupancyReports.reports;
        };
        this.createRoomOccupancyReportUrl = () => {
            return this.serverBaseUrl + this.roomOccupancyReports.createReport;
        };
        this.editRoomOccupancyReportUrl = () => {
            return this.serverBaseUrl + this.roomOccupancyReports.editReport;
        };
        this.updateRoomOccupancyReportUrl = () => {
            return this.serverBaseUrl + this.roomOccupancyReports.updateReport;
        };
        this.viewRoomOccupancyReportUrl = () => {
            return this.serverBaseUrl + this.roomOccupancyReports.viewReport;
        };
        this.getMeetingRoomsUrl = () => {
            return this.serverBaseUrl + this.roomOccupancyReports.meetingRooms;
        };
        this.getDeleteReportUrl = () => {
            return this.serverBaseUrl + this.roomOccupancyReports.deleteReport;
        };
        this.getWorkspaceListUrl = () => {
            return this.serverBaseUrl + this.roomOccupancyReports.workspaceList;
        };
        this.getDownloadReportUrl = () => {
            return this.serverBaseUrl + this.roomOccupancyReports.download;
        };
        this.getRoomsCountByBuildingUrl = () => {
            return this.serverBaseUrl + this.roomOccupancyReports.roomsCount;
        };
        this.updateSkipEmptyRowsUrl = () => {
            return this.serverBaseUrl + this.roomOccupancyReports.skipEmptyRows;
        };
        this.getCheckCustomTNCAcceptedUrl = () => {
            return this.serverBaseUrl + this.partnerApps.getCheckCustomTNCAccepted;
        };
        this.getSaveCustomTNCAcceptedUrl = () => {
            return this.serverBaseUrl + this.partnerApps.saveCustomTNCAccepted;
        };
        this.getPluginsListUrl = () => {
            return this.serverBaseUrl + this.plugins.list;
        };
        this.activatePluginsUrl = () => {
            return this.serverBaseUrl + this.plugins.activate;
        };
        this.deactivatePluginsUrl = () => {
            return this.serverBaseUrl + this.plugins.deactivate;
        };
    }
    /*******************  Environmental lib ***************/
    getAllFloorData(metric) {
        return this.serverBaseUrl + this.environmentalMetrics.allFloors + metric;
    }
    getFloorViewData(metric, queryParams) {
        return this.serverBaseUrl + this.environmentalMetrics.floorView + metric + "?" + queryParams;
    }
    getBuildingViewData(metric, queryParams) {
        return this.serverBaseUrl + this.environmentalMetrics.buildingView + metric + "?" + queryParams;
    }
}

class LocationFlag {
    constructor() {
        this.Flags = {
            ALL_ADD_NETWORK: 0x30e,
            ADD_CMX_ZONE: 0x400000,
            ADD_WLC_NETWORK: 0x200000,
            EDIT_WLC: 0x100000,
            RENAME: 0x80000,
            ADD_METADATA: 0x40000,
            DELETE_FLOOR: 0x20000,
            DELETE_AEROHIVE_LOCATION: 0x10000,
            DELETE_LOCATION: 0x8000,
            ADD_ZONE: 0x4000,
            ADD_FLOOR: 0x2000,
            ADD_AEROHIVE_LOCATION: 0x1000,
            EDIT_ARUBA: 0x800,
            EDIT_RUCKUS: 0x400,
            ADD_NETWORK: 0x200,
            ADD_BUILDING: 0x100,
            ADD_CAMPUS: 0x80,
            EDIT_MSE: 0x40,
            ADD_AEROHIVE: 0x20,
            ADD_ARUBA: 0x10,
            ADD_RUCKUS: 0x8,
            ADD_WIRELESS_NETWORK: 0x4,
            EDIT_GROUP: 0x2,
            ADD_GROUP: 0x1
        };
        /* tslint:disable:no-bitwise */
        this.locationTypeOffFlags = {
            root: 0,
            group: this.Flags.EDIT_MSE |
                this.Flags.EDIT_WLC |
                this.Flags.EDIT_ARUBA |
                this.Flags.EDIT_RUCKUS |
                this.Flags.DELETE_FLOOR,
            meraki: this.Flags.ADD_AEROHIVE |
                this.Flags.ADD_ARUBA |
                this.Flags.ADD_RUCKUS |
                this.Flags.ADD_WIRELESS_NETWORK |
                this.Flags.EDIT_GROUP,
            wlc: this.Flags.ADD_AEROHIVE |
                this.Flags.ADD_ARUBA |
                this.Flags.ADD_RUCKUS |
                this.Flags.ADD_WIRELESS_NETWORK |
                this.Flags.EDIT_GROUP,
            mse: this.Flags.ADD_AEROHIVE |
                this.Flags.ADD_ARUBA |
                this.Flags.ADD_RUCKUS |
                this.Flags.ADD_WIRELESS_NETWORK |
                this.Flags.EDIT_GROUP,
            aerohive: this.Flags.ADD_AEROHIVE |
                this.Flags.ADD_ARUBA |
                this.Flags.ADD_RUCKUS |
                this.Flags.ADD_WIRELESS_NETWORK |
                this.Flags.EDIT_GROUP |
                this.Flags.ADD_GROUP,
            aruba: this.Flags.ADD_AEROHIVE |
                this.Flags.ADD_ARUBA |
                this.Flags.ADD_RUCKUS |
                this.Flags.ADD_WIRELESS_NETWORK |
                this.Flags.EDIT_GROUP,
            ruckus: this.Flags.ADD_AEROHIVE |
                this.Flags.ADD_ARUBA |
                this.Flags.ADD_RUCKUS |
                this.Flags.ADD_WIRELESS_NETWORK |
                this.Flags.EDIT_GROUP,
            aerohiveGeneric: this.Flags.DELETE_LOCATION,
            wlc_network: this.Flags.ADD_AEROHIVE |
                this.Flags.ADD_ARUBA |
                this.Flags.ADD_RUCKUS |
                this.Flags.ADD_WIRELESS_NETWORK |
                this.Flags.EDIT_GROUP |
                this.Flags.ADD_GROUP |
                this.Flags.ADD_FLOOR,
            campus: this.Flags.ADD_CAMPUS |
                this.Flags.EDIT_MSE |
                this.Flags.EDIT_GROUP |
                this.Flags.ADD_AEROHIVE |
                this.Flags.ADD_ARUBA |
                this.Flags.ADD_RUCKUS |
                this.Flags.ADD_WIRELESS_NETWORK,
            network: this.Flags.EDIT_WLC |
                this.Flags.EDIT_ARUBA |
                this.Flags.EDIT_RUCKUS |
                this.Flags.ADD_NETWORK |
                this.Flags.ADD_BUILDING |
                this.Flags.EDIT_GROUP |
                this.Flags.ADD_WLC_NETWORK,
            floor: this.Flags.DELETE_LOCATION |
                this.Flags.ADD_FLOOR |
                this.Flags.EDIT_GROUP,
            zone: this.Flags.ADD_ZONE |
                this.Flags.ADD_FLOOR |
                this.Flags.DELETE_FLOOR |
                this.Flags.EDIT_GROUP |
                this.Flags.ADD_CMX_ZONE,
            cmxzone: this.Flags.DELETE_FLOOR |
                this.Flags.ADD_ZONE |
                this.Flags.ADD_FLOOR |
                this.Flags.EDIT_GROUP |
                this.Flags.ADD_CMX_ZONE,
            meraki_campus: this.Flags.ADD_AEROHIVE |
                this.Flags.ADD_ARUBA |
                this.Flags.ADD_RUCKUS |
                this.Flags.ADD_WIRELESS_NETWORK |
                this.Flags.EDIT_GROUP |
                this.Flags.ADD_CAMPUS |
                this.Flags.EDIT_MSE,
            campus_wlc: this.Flags.ADD_CAMPUS |
                this.Flags.EDIT_MSE |
                this.Flags.EDIT_GROUP |
                this.Flags.ADD_AEROHIVE |
                this.Flags.ADD_ARUBA |
                this.Flags.ADD_RUCKUS |
                this.Flags.ADD_WIRELESS_NETWORK
        };
        this.locationTypeOnFlags = {
            root: 0,
            group: this.Flags.DELETE_LOCATION | this.Flags.EDIT_GROUP,
            meraki: this.Flags.DELETE_LOCATION | this.Flags.ADD_NETWORK,
            wlc: this.Flags.EDIT_WLC |
                this.Flags.DELETE_LOCATION |
                this.Flags.ADD_WLC_NETWORK,
            mse: this.Flags.DELETE_LOCATION |
                this.Flags.ADD_CAMPUS |
                this.Flags.EDIT_MSE,
            aerohive: this.Flags.DELETE_LOCATION | this.Flags.ADD_AEROHIVE_LOCATION,
            aruba: this.Flags.DELETE_LOCATION |
                this.Flags.EDIT_ARUBA |
                this.Flags.ADD_NETWORK,
            ruckus: this.Flags.DELETE_LOCATION |
                this.Flags.EDIT_RUCKUS |
                this.Flags.ADD_NETWORK,
            aerohiveGeneric: this.Flags.DELETE_AEROHIVE_LOCATION | this.Flags.ADD_FLOOR,
            wlc_network: this.Flags.DELETE_LOCATION | this.Flags.ADD_ZONE,
            campus: this.Flags.ADD_BUILDING | this.Flags.DELETE_LOCATION,
            network: this.Flags.ADD_ZONE | this.Flags.ADD_FLOOR | this.Flags.DELETE_LOCATION,
            floor: this.Flags.DELETE_FLOOR | this.Flags.ADD_CMX_ZONE,
            zone: this.Flags.DELETE_LOCATION,
            cmxzone: this.Flags.DELETE_LOCATION,
            meraki_campus: this.Flags.ADD_NETWORK | this.Flags.ADD_BUILDING | this.Flags.DELETE_LOCATION,
            campus_wlc: this.Flags.ADD_BUILDING | this.Flags.EDIT_WLC | this.Flags.ADD_WLC_NETWORK | this.Flags.DELETE_LOCATION
        };
        this.locationAccess = {
            read: ~(this.Flags.RENAME |
                this.Flags.ALL_ADD_NETWORK |
                this.Flags.DELETE_AEROHIVE_LOCATION |
                this.Flags.DELETE_FLOOR |
                this.Flags.DELETE_LOCATION |
                this.Flags.EDIT_ARUBA |
                this.Flags.EDIT_GROUP |
                this.Flags.EDIT_MSE |
                this.Flags.EDIT_RUCKUS |
                this.Flags.ADD_METADATA |
                this.Flags.ADD_GROUP |
                this.Flags.ADD_WIRELESS_NETWORK |
                this.Flags.ADD_FLOOR |
                this.Flags.ADD_ZONE |
                this.Flags.ADD_CMX_ZONE |
                this.Flags.ADD_AEROHIVE_LOCATION |
                this.Flags.ADD_NETWORK |
                this.Flags.ADD_BUILDING |
                this.Flags.ADD_CAMPUS |
                this.Flags.ADD_AEROHIVE |
                this.Flags.ADD_ARUBA |
                this.Flags.ADD_RUCKUS |
                this.Flags.EDIT_WLC |
                this.Flags.ADD_WLC_NETWORK)
        };
        this.whichFlagsAreSet = (flagToDecode) => {
            Object.keys(this.Flags).forEach((flag) => {
                if (flagToDecode & this.Flags[flag]) {
                    console.log(flag);
                }
            });
        };
        /* tslint:enable:no-bitwise */
    }
}

class LocationRow {
    constructor(line) {
        this.pos = 0;
        this.line = line;
    }
    nextString() {
        if (this.pos >= this.line.length) {
            return null;
        }
        let p = this.line.indexOf(LocationRow.FIELD_SEPARATOR, this.pos);
        if (p === -1) {
            p = this.line.length + 1;
        }
        if (p === this.pos) {
            this.pos = p + 1;
            return null;
        }
        const s = this.line.substring(this.pos, p);
        this.pos = p + 1;
        return s;
    }
    nextBool() {
        const s = this.nextString();
        return s ? s === "1" : false;
    }
    nextInt() {
        const s = this.nextString();
        return s ? parseInt(s, 10) : 0;
    }
    nextFloat() {
        const s = this.nextString();
        return s ? parseFloat(s) : 0.0;
    }
    nextJSON() {
        const s = this.nextString();
        try {
            const json = s ? JSON.parse(s.replace(LocationRow.SUB, '"')) : null;
            return json;
        }
        catch (e) {
            console.error(e);
            return null;
        }
    }
    nextPathJSON() {
        const s = this.nextString();
        try {
            const json = s ? JSON.parse(s.replace(/\u001a/g, '"')) : null;
            return json;
        }
        catch (e) {
            console.error(e);
            return null;
        }
    }
}
LocationRow["locTableKey"] = ',"locationTable":"';
LocationRow["RECORD_SEPARATOR"] = "\u001E";
LocationRow["FIELD_SEPARATOR"] = "\u001F";
LocationRow["SUB"] = "\u001a";

class LocationUtils {
    constructor() {
        this.locationFlag = new LocationFlag();
        this.expandDepth = 3;
        this.convertTree = (locationWrapped, locationTableData) => {
            var _a, _b, _c;
            console.log("got locations response", new Date().getTime() - this.startTime);
            //  console.log(locationWrapped);
            // this.location = locationWrapped.location;
            if (!locationTableData || locationTableData === "") {
                return locationWrapped;
            }
            this.startTime = new Date().getTime();
            /* tslint:disable:no-bitwise */
            this.locationFlag.initialMask =
                this.locationFlag.Flags.RENAME |
                    this.locationFlag.Flags.ADD_METADATA |
                    (locationWrapped.productEdition === "AeroHive"
                        ? this.locationFlag.Flags.ADD_AEROHIVE
                        : 0) |
                    (locationWrapped.productEdition === "Aruba"
                        ? this.locationFlag.Flags.ADD_ARUBA
                        : 0) |
                    (locationWrapped.productEdition === "Ruckus"
                        ? this.locationFlag.Flags.ADD_RUCKUS
                        : 0) |
                    (locationWrapped.productEdition === "Meraki" ||
                        locationWrapped.productEdition === "CiscoWireless" ||
                        locationWrapped.productEdition === "Universal"
                        ? this.locationFlag.Flags.ADD_WIRELESS_NETWORK
                        : 0) |
                    this.locationFlag.Flags.ADD_GROUP;
            /* tslint:enable:no-bitwise */
            //  console.log('Going to call create location hierarchy..', new Date().getTime());
            const cusLicenseType = ((_a = locationWrapped.licenseDetails) === null || _a === void 0 ? void 0 : _a.licenseType) === 'Advanced Subscription' ? 'ACT' : ((_b = locationWrapped.licenseDetails) === null || _b === void 0 ? void 0 : _b.licenseType) === 'Base Subscription' ? 'SEE' : (_c = locationWrapped.licenseDetails) === null || _c === void 0 ? void 0 : _c.licenseType;
            const hierarchyObject = this.parseLocationTable(locationTableData, cusLicenseType);
            locationWrapped.location = [hierarchyObject.root];
            locationWrapped.rootLocation = hierarchyObject.rootLocation;
            locationWrapped.locationsMap = hierarchyObject.locationsMap;
            locationWrapped.legend = hierarchyObject.legends;
            //  console.log('location hierarchy done', locationWrapped);
            //  console.log('locations legend::',locationWrapped.legend);
            console.log("(convertTree) locations converted into tree", new Date().getTime() - this.startTime);
            return Object.assign({}, locationWrapped);
        };
        this.parseLocationTable = (data, cusLicenseType) => {
            let p1 = 0;
            let p2 = data.indexOf(LocationRow.RECORD_SEPARATOR);
            let root = null;
            const locations = new Map();
            const locationsMap = new Map();
            const legends = [];
            while (p2 !== -1) {
                const row = new LocationRow(data.substring(p1, p2));
                let location = Object.assign({}, this.getLocation(row));
                //  let location = this.calculateLocationBitFlag(Object.assign({}, this.getLocation(row)),
                // (p1 === 0? this.locationFlag.initialMask));
                if (location.type === "network" &&
                    location.networkDetails &&
                    location.networkDetails.controllerIP) {
                    location.type = "wlc_network"; // oldWlcNetwork
                }
                locations.set(location.id, location);
                // this.setLocationMap(locationsMap, location.id, location);
                if (location.parent !== "-1") {
                    let parent = locations.get(location.parent);
                    if (parent) {
                        location = this.calculateLocationBitFlag(location, parent.locationBit);
                        if (location.networkDetails &&
                            location.networkDetails.type === "WLC_NODE") {
                            /* tslint:disable:no-bitwise */
                            location.locationBit =
                                location.locationBit &
                                    ~this.locationFlag.Flags.ADD_FLOOR;
                            /* tslint:enable:no-bitwise */
                        }
                        if (!parent.children) {
                            parent.children = [];
                        }
                        parent.children.push(location);
                        location.parentNode = parent;
                        if (!location.licenseType) {
                            location.licenseType = parent.licenseType;
                        }
                        const apCount = location.accessPointCount;
                        const camerasCount = location.camerasCount;
                        const proximityCount = location.proximityCount;
                        const networkCount = location.networkCount;
                        if (apCount > 0 ||
                            camerasCount > 0 ||
                            proximityCount > 0 ||
                            networkCount > 0) {
                            while (parent) {
                                if (apCount > 0) {
                                    parent.accessPointCount += apCount;
                                }
                                if (camerasCount > 0) {
                                    parent.camerasCount += camerasCount;
                                }
                                if (proximityCount > 0) {
                                    parent.proximityCount += proximityCount;
                                }
                                if (networkCount > 0) {
                                    parent.networkCount += networkCount;
                                }
                                parent = parent.parentNode;
                            }
                        }
                    }
                    else {
                        console.log("Parent " +
                            location.parent +
                            " not found for location " +
                            location.id, location);
                    }
                }
                else {
                    location = this.calculateLocationBitFlag(location, this.locationFlag.initialMask);
                    if (!location.licenseType) {
                        location.licenseType = cusLicenseType;
                    }
                    root = location;
                }
                this.setLocationMap(locationsMap, location.id, location);
                this.setClickable(location);
                this.setCanDelete(location);
                this.locationLegends(legends, location.type);
                p1 = p2 + 1;
                p2 = data.indexOf(LocationRow.RECORD_SEPARATOR, p1);
            }
            const rootLocation = Object.assign({}, root);
            rootLocation.children = null;
            return { root, locationsMap: locationsMap, legends, rootLocation };
        };
        this.setLocationMap = (locationsMap, locationId, locationFull) => {
            const location = Object.assign({}, locationFull);
            location.children = null;
            locationsMap.set(locationId, location);
        };
        this.getLocation = (row) => {
            // console.log("location row ::: "+JSON.stringify(row))
            const locationId = row.nextString();
            return {
                id: locationId,
                name: row.nextString(),
                type: row.nextString(),
                parent: row.nextString(),
                path: row.nextPathJSON(),
                networkDetails: {
                    networkReference: row.nextString(),
                    useAPI: row.nextBool(),
                    controllerIP: row.nextString(),
                    wirelessProvider: row.nextString(),
                    type: row.nextString()
                },
                productEdition: row.nextString(),
                providerDetails: row.nextJSON(),
                timeZoneId: row.nextString(),
                access: row.nextString(),
                reportAccess: row.nextBool(),
                accessPointCount: row.nextInt(),
                camerasCount: row.nextInt(),
                bleBeaconCount: row.nextInt(),
                userCount: row.nextInt(),
                accessCodeCount: row.nextInt(),
                portalCount: row.nextInt(),
                proximityCount: row.nextInt(),
                networkCount: row.nextInt(),
                mongodbLocId: row.nextInt(),
                geoLng: row.nextFloat(),
                geoLat: row.nextFloat(),
                richMapStatus: row.nextString(),
                total: row.nextInt(),
                permitted: row.nextInt(),
                licenseType: row.nextString()
            };
        };
        this.calculateLocationBitFlag = (locationObj, parentLocationBit) => {
            /* tslint:disable:no-bitwise */
            // Set Flags
            const parentBit = locationObj.type === "root"
                ? this.locationFlag.initialMask
                : parentLocationBit;
            if (this.locationFlag.locationTypeOffFlags[locationObj.type]) {
                locationObj.locationBit =
                    parentBit &
                        ~this.locationFlag.locationTypeOffFlags[locationObj.type];
            }
            else {
                locationObj.locationBit = parentBit;
            }
            locationObj.locationBit |=
                this.locationFlag.locationTypeOnFlags[locationObj.type];
            //  console.log('>>>>> >>>>>> >>>>> >>>')
            //  console.log(locationObj.name, locationObj.locationBit);
            //  this.locationFlag.whichFlagsAreSet(locationObj.locationBit);
            //  console.log('>>>  >>>>> >>>> >>> >>>>')
            return locationObj;
            /* tslint:enable:no-bitwise */
        };
        this.setClickable = (location) => {
            location.accessCodeClickable = location.accessCodeCount > 0;
            location.userClickable = location.userCount > 0;
            location.networkClickable = location.networkCount > 0;
            location.proximityClickable = location.proximityCount > 0;
            location.bleBeaconClickable = location.bleBeaconCount > 0;
            location.accessPointClickable = location.accessPointCount > 0;
            location.camerasClickable = location.camerasCount > 0;
        };
        this.setCanDelete = (location) => {
            // Type has no children: 'group', 'mse', 'meraki', 'ruckus', 'aruba', 'campus', 'aerohive'
            // Type has no children, APs, child does not have APs : 'aerohiveGeneric', 'network'
            const othersDeleteArray = [
                "group",
                "mse",
                "meraki",
                "ruckus",
                "aruba",
                "campus",
                "aerohive",
                "aerohiveGeneric",
                "network"
            ];
            const providerDelete = [
                "group",
                "mse",
                "meraki",
                "ruckus",
                "aruba",
                "campus",
                "aerohive"
            ].includes(location.type) &&
                (!location.children || location.children.length === 0);
            const networkDelete = ["aerohiveGeneric", "network"].includes(location.type) &&
                (!location.children ||
                    location.children.length === 0 ||
                    location.myCountJson.ap === 0);
            const oldWlcNetworkDelete = location.type === "wlc_network" &&
                (!location.children || location.children.length === 0);
            const othersDelete = !othersDeleteArray.includes(location.type) &&
                (!location.children ||
                    location.children.length === 0 ||
                    location.myCountJson.ap === 0);
            location.canDelete =
                providerDelete ||
                    networkDelete ||
                    othersDelete ||
                    oldWlcNetworkDelete;
            // rulesCount is not zero then can not delete
            if (location.proximityCount > 0) {
                location.canDelete = false;
            }
        };
        this.locationLegends = (legends, type) => {
            if (!legends) {
                legends = [];
            }
            if (type && legends.indexOf(type) === -1) {
                legends.push(type);
            }
        };
    }
}
LocationUtils.ɵfac = function LocationUtils_Factory(t) { return new (t || LocationUtils)(); };
LocationUtils.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LocationUtils, factory: LocationUtils.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocationUtils, [{
        type: Injectable
    }], function () { return []; }, null); })();

class ReportUtils {
    constructor() {
        this.countReadable = (numberCount) => {
            if (!numberCount) {
                return 0;
            }
            let i = 0;
            while (numberCount >= 1000) {
                numberCount /= 1000;
                i++;
            }
            return (parseFloat(numberCount.toFixed(1)).toLocaleString() +
                ["", "K", "M", "B"][i]);
        };
        this.roundNumber = (numberCount) => {
            if (!numberCount) {
                return 0;
            }
            let i = 0;
            while (numberCount > 1000) {
                numberCount /= 1000;
                i++;
            }
            let numberVal = parseFloat(numberCount.toFixed(1));
            if (numberVal >= 1000) {
                numberVal /= 1000;
                i++;
            }
            return numberVal.toLocaleString() + ["", "K", "M", "B"][i];
        };
        this.getPercentage = (associated, total, decimalPoint) => {
            if (!decimalPoint || decimalPoint === undefined) {
                return Math.round((associated / total) * 100);
            }
            else {
                return parseFloat(((associated / total) * 100).toFixed(decimalPoint));
            }
        };
        this.adminCountReadable = (numberCount) => {
            if (!numberCount) {
                return 0;
            }
            let i = 0;
            let isDecimal = false;
            if ((numberCount >= 1000 && numberCount <= 9999) ||
                (numberCount >= 1000000 && numberCount <= 9999999) ||
                (numberCount >= 1000000000 && numberCount <= 9999999999)) {
                isDecimal = true;
            }
            while (numberCount > 1000) {
                numberCount /= 1000;
                i++;
            }
            return isDecimal
                ? parseFloat(numberCount.toFixed(1)).toLocaleString() +
                    ["", " K", " MILLION", " BILLION"][i]
                : Math.round(numberCount).toLocaleString() +
                    ["", " K", " MILLION", " BILLION"][i];
        };
        this.adminCountReadableWithoutSpace = (numberCount) => {
            if (!numberCount) {
                return 0;
            }
            let i = 0;
            let isDecimal = false;
            if ((numberCount >= 1000 && numberCount <= 9999) ||
                (numberCount >= 1000000 && numberCount <= 9999999) ||
                (numberCount >= 1000000000 && numberCount <= 9999999999)) {
                isDecimal = true;
            }
            while (numberCount > 1000) {
                numberCount /= 1000;
                i++;
            }
            return isDecimal
                ? parseFloat(numberCount.toFixed(1)).toLocaleString() +
                    ["", "K", "M", "B"][i]
                : Math.round(numberCount).toLocaleString() + ["", "K", "M", "B"][i];
        };
    }
    numberFormatter(value) {
        // Nine Zeroes for Billions
        return Math.abs(Number(value)) >= 1.0e9
            ? parseFloat((Math.abs(Number(value)) / 1.0e9).toFixed(1)).toLocaleString() + "B"
            : // Six Zeroes for Millions
                Math.abs(Number(value)) >= 1.0e6 /* && value >= 1000000 */
                    ? parseFloat((Math.abs(Number(value)) / 1.0e6).toFixed(1)).toLocaleString() + "M"
                    : // Three Zeroes for Thousands
                        Math.abs(Number(value)) >= 1.0e3 && value >= 10000
                            ? parseFloat((Math.abs(Number(value)) / 1.0e3).toFixed(1)).toLocaleString() + "K"
                            : Math.abs(Number(value)).toLocaleString();
    }
}
ReportUtils.ɵfac = function ReportUtils_Factory(t) { return new (t || ReportUtils)(); };
ReportUtils.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ReportUtils, factory: ReportUtils.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportUtils, [{
        type: Injectable
    }], null, null); })();

class Utils {
    constructor(logger) {
        this.logger = logger;
        this.randomString = (maxLength, charString) => {
            let strin = "";
            strin += charString.indexOf("a") > -1 ? this.lowerCharacters : "";
            strin += charString.indexOf("A") > -1 ? this.capitalCharacters : "";
            strin += charString.indexOf("#") > -1 ? this.decimalCharacters : "";
            strin += charString.indexOf("!") > -1 ? this.specialCharacters : "";
            let resultString = "";
            for (let i = maxLength; i > 0; --i) {
                const indexed = Math.floor(Math.random() * strin.length);
                resultString += strin[indexed];
            }
            return resultString;
        };
        /*!
         *
         * Code created with the help of Stack Overflow question
         * https://stackoverflow.com/questions/10726909/random-alpha-numeric-string-in-javascript?lq=1
         * Question by Pavel:
         * https://stackoverflow.com/users/193134/pavel
         * Answer by Nimphious & Iftah:
         * https://stackoverflow.com/users/1391040/nimphious
         * https://stackoverflow.com/users/519995/iftah
         */
        this.tokenizeSearchString = (searchString) => {
            const tempKeys = searchString ? searchString.split(/[^\w'!-:]+/) : [];
            const searchTokens = [];
            for (let index = 0, max = tempKeys.length; index < max; index++) {
                if (tempKeys[index]) {
                    searchTokens.push(tempKeys[index]);
                }
            }
            return searchTokens;
        };
        this.isArrayEqual = (oldArr, newArr) => {
            if (!oldArr && !newArr) {
                return true;
            }
            if ((oldArr && !newArr) || (!oldArr && newArr)) {
                return false;
            }
            if (oldArr.length !== newArr.length) {
                return false;
            }
            if (this.compareArrayEqual(oldArr, newArr) &&
                this.compareArrayEqual(newArr, oldArr)) {
                return true;
            }
            return false;
        };
        this.extractResponse = (res) => {
            try {
                // console.log('errorData', error);
                // console.log( 'extractData', res.json() );
                return res.json();
            }
            catch (e) {
                // an error occurred
                throw throwError(res.json());
            }
        };
        this.locationUtil = new LocationUtils();
        this.reportUtil = new ReportUtils();
    }
    compareArrayEqual(firstArr, secondArr) {
        for (let firstArrIndex = 0, firstArrMax = firstArr.length; firstArrIndex < firstArrMax; firstArrIndex++) {
            const firstArrKey = firstArr[firstArrIndex];
            let matched = false;
            for (let secondArrIndex = 0, secondArrMax = secondArr.length; secondArrIndex < secondArrMax; secondArrIndex++) {
                const secondArrKey = secondArr[secondArrIndex];
                if (typeof firstArrKey === typeof secondArrKey) {
                    switch (typeof firstArrKey) {
                        case "string":
                            if (firstArrKey === secondArrKey) {
                                matched = true;
                            }
                            break;
                        case "boolean":
                            if ((firstArrKey && secondArrKey) ||
                                (!firstArrKey && !secondArrKey)) {
                                matched = true;
                            }
                            break;
                        case "number":
                            if (firstArrKey === secondArrKey) {
                                matched = true;
                            }
                            break;
                        case "object":
                        default:
                            if (JSON.stringify(firstArrKey) ===
                                JSON.stringify(secondArrKey)) {
                                matched = true;
                            }
                            break;
                    }
                }
                if (matched) {
                    break;
                }
            }
            if (!matched) {
                return false;
            }
        }
        return true;
    }
}

class Location {
    constructor() {
        this["showMenu"] = false;
        this["selected"] = false;
        this["apsMatched"] = "";
        this.scrollParam = {
            hasExpanded: false,
            netChild: 0,
            openChild: []
        };
        this.search = {
            foundChild: true,
            timestamp: 0
        };
    }
}

class CircularLoaderStatus {
    constructor() {
        this["delay"] = 5000;
        this["display"] = false;
        this["updatedAt"] = 0;
        this.updatedAt = new Date().getTime();
    }
    setValue(value) {
        this.display = value;
        this.updatedAt = new Date().getTime();
    }
    setValueAndDelay(value, delayInMillis) {
        this.display = value;
        if (delayInMillis > -1) {
            this.delay = delayInMillis;
        }
        this.updatedAt = new Date().getTime();
    }
}

class LicenseDetails {
    constructor() {
        this["duration"] = {
            months: null,
            years: null
        };
        this["warn"] = {
            licenseStatus: null,
            apLimit: false
        };
    }
}

class LocationAction {
    constructor() {
        this["type"] = "";
        this["data"] = {};
    }
}

class LocationWrap {
    constructor() { }
}

class NavToggler {
    constructor(show) {
        this["show"] = false;
        this.show = show;
    }
    setValue(value) {
        this.show = value;
    }
}
class HamburgerPage {
    constructor(type) {
        this.page = "";
        this.page = type;
    }
    setValue(value) {
        this.page = value;
    }
}

class ReportHeader {
    constructor() {
        this.breadCrumb = [];
        this.isBeta = false;
    }
}
class RuleReportHeader {
    constructor() {
        this.breadCrumb = [];
    }
}
class BreadCrumb$1 {
    constructor(name, url) {
        this.name = name;
        this.url = url;
    }
}

class SpacesPeriod {
    constructor(spacesJson) {
        this["type"] = "";
        this["currentYear"] = new Date().getFullYear();
        this["year"] = new Date().getFullYear();
        this["month"] = "";
        this["quarter"] = "";
        this["fromDate"] = "";
        this["toDate"] = "";
        this.type = spacesJson.type;
        this.currentYear = spacesJson.currentYear;
        this.year = spacesJson.year;
        this.month = spacesJson.month;
        this.quarter = spacesJson.quarter;
        this.prevYearLimit = spacesJson.prevYearLimit;
        this.fromDate = spacesJson.fromDate;
        this.toDate = spacesJson.toDate;
    }
}

class ToastMessage {
    constructor(message, displayForMillis, button, callbackKey, type) {
        this.message = message;
        this.displayForMillis = displayForMillis;
        this.button = button;
        this.callbackKey = callbackKey;
        this.type = type ? type : "";
    }
}

class UserRole {
    constructor(appName, appRole, appContext) {
        this.appName = appName;
        this.appRole = appRole;
        this.appContext = appContext;
    }
    isAdmin() {
        return this.appName === "DNASpaces" && this.appRole === "RW";
    }
}

class UserRoleForEngagements {
    constructor(appName, appRole, appContext) {
        this.appName = appName;
        this.appRole = appRole;
        this.appContext = appContext;
    }
    isAdmin() {
        return this.appName === "DNASpaces" && this.appRole === "RW";
    }
}

class UserRoleForIoT {
    constructor(appName, appRole, appContext) {
        this.appName = appName;
        this.appRole = appRole;
        this.appContext = appContext;
    }
    isAdmin() {
        return (this.appName === 'DNASpaces' && this.appRole === 'RW');
    }
}

class UserRoleForOpenRoaming {
    constructor(appName, appRole, appContext) {
        this.appName = appName;
        this.appRole = appRole;
        this.appContext = appContext;
    }
    isAdmin() {
        return this.appName === "DNASpaces" && this.appRole === "RW";
    }
}

class UserRoleForPersonas {
    constructor(appName, appRole, appContext) {
        this.appName = appName;
        this.appRole = appRole;
        this.appContext = appContext;
    }
    isAdmin() {
        return this.appName === "DNASpaces" && this.appRole === "RW";
    }
}

class UserRoleForSignage {
    constructor(appName, appRole, appContext) {
        this.appName = appName;
        this.appRole = appRole;
        this.appContext = appContext;
    }
    isAdmin() {
        return this.appName === "DNASpaces" && this.appRole === "RW";
    }
}

class CookieService {
    constructor() {
        this.setAdminCookie = (cookie) => {
            const domain = window.location.hostname;
            Cookies.set("Connection-Cache", cookie, { domain });
        };
        this.setAdminCookieToDomain = (adminCookieToken) => {
            const domain = window.location.hostname;
            // console.log('cookies, ::', Cookies.getAll());
            // // console.log('cookie, ::', Cookies.get('Connection-Cache'));
            Cookies.set("Connection-Cache", adminCookieToken, { domain });
            // console.log('cookies after, ::', Cookies.getAll());
        };
        this.checkLoginCookie = () => {
            return Cookies.get("tm-cookie") || "";
        };
        this.getCookie = (cookieName) => {
            return Cookies.get(cookieName);
        };
        this.clearAll = () => {
            const domain = window.location.hostname;
            // console.log('cookies before, ::', Cookies.getAll());
            const allCookies = Cookies.getAll();
            Object.keys(allCookies).map((key) => {
                Cookies.remove(key, {
                    domain
                });
            });
            // console.log('cookies after, ::', Cookies.getAll());
        };
        this.checkAdminCookieValid = ($token) => {
            try {
                if (!$token) {
                    return false;
                }
                const adminCookie = Cookies.get("Connection-Cache");
                //  var adminString = new Buffer('isAdmin=true').toString('base64');
                //  var separator = this.randomString(4, 'A#a!');
                //  const tokenLen = token.length;
                //  const base64Token = new Buffer(token + separator).toString('base64');
                //  const newCookie = new Buffer(base64Token + separator + adminString + "#$$#" +
                //    separator + '#$$#' + tokenLen).toString('base64');
                const concatedString = atob(adminCookie || "");
                const concatStrArr = concatedString.split("#$$#");
                if (concatStrArr.length !== 3) {
                    return false;
                }
                const base64TokenWithAdmin = concatStrArr[0];
                const separator = concatStrArr[1];
                //  const tokenLen = concatStrArr[2];
                const base64AdminArr = base64TokenWithAdmin.split(separator);
                const base64Token = base64AdminArr[0];
                const adminValue = base64AdminArr[1];
                if (atob(adminValue) !== "isAdmin=true") {
                    return false;
                }
                const tokenSep = atob(base64Token);
                const tokenSepArr = tokenSep.split(separator);
                const token = tokenSepArr[0];
                if (token !== $token) {
                    return false;
                }
                return true;
            }
            catch (e) {
                console.log("Check Admin Cookie Valid Error;", e);
            }
            return false;
        };
    }
}
CookieService.ɵfac = function CookieService_Factory(t) { return new (t || CookieService)(); };
CookieService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CookieService, factory: CookieService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CookieService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class UserRoleForWorkspace {
    constructor(appName, appRole, appContext) {
        this.appName = appName;
        this.appRole = appRole;
        this.appContext = appContext;
    }
    isAdmin() {
        return this.appName === "DNASpaces" && this.appRole === "RW";
    }
}

class DataService {
    //  singleton changes ends
    constructor(cookieService, router) {
        this.cookieService = cookieService;
        this.router = router;
        this._isTemplateEnabled = new BehaviorSubject(false);
        this.isTemplateEnabled$ = this._isTemplateEnabled.asObservable();
        this._isModalVisible = new BehaviorSubject(false);
        this.isModalVisible$ = this._isModalVisible.asObservable();
        this.windowAccessTime = Number(new Date().getTime() + "" + Math.floor(Math.random() * 10000 + 1));
        this.status = new BehaviorSubject(new CircularLoaderStatus());
        this.searchText = new BehaviorSubject("");
        this.locationArray = new BehaviorSubject({});
        this.locationTreeArray = new BehaviorSubject(new LocationWrap());
        this.locationAction = new BehaviorSubject(new LocationAction());
        this.currentNav = new BehaviorSubject("");
        this.nav = new BehaviorSubject(new NavToggler(false));
        this.hamPage = new BehaviorSubject(new HamburgerPage(""));
        this.setupBanner = new BehaviorSubject(true);
        this.hamburgerBtn = new BehaviorSubject(true);
        this.toastCallBack = new BehaviorSubject("");
        this.reportsHeader = new BehaviorSubject(new ReportHeader());
        this.breadCrumbPath = new BehaviorSubject([]);
        this.showFullScreenView = new BehaviorSubject(false);
        this.merakiLoginAuthenticated = new BehaviorSubject(false);
        this.ruleSummary = new BehaviorSubject(null);
        this.userRole = new UserRole(null, null, null);
        this.userRoleSubscriber = new BehaviorSubject(this.userRole);
        this.authStatus = new BehaviorSubject(false);
        this.currentStatus = new BehaviorSubject(false);
        this.merakiUserName = new BehaviorSubject("");
        this.onWirelessProviderAuthStatusUpdate = new BehaviorSubject(0);
        this.onLocationSyncStatusUpdate = new BehaviorSubject(0);
        this.onSyncStatusUpdate = new BehaviorSubject(0);
        this.licenseDetails = new BehaviorSubject(new LicenseDetails());
        this.apiResponseErrorHandler = new BehaviorSubject(null);
        this.setupTaskObserver = new BehaviorSubject(null);
        //  public ssidFromSetup : BehaviorSubject<any> = new BehaviorSubject<any>(null);
        this.locationAnalyticsFromSetup = new BehaviorSubject(null);
        this.locationTreeArrayExists = false;
        this.personasLocationTreeArrayExists = false;
        this.cpLocationTreeArrayExists = false;
        this.engagementsLocationTreeArrayExists = false;
        this.iotExplorerLocationTreeArrayExists = false;
        this.licenseType = "";
        this.spacesObj = new BehaviorSubject(null);
        this.spaceReportObject = new BehaviorSubject(null);
        this.rightNowObj = new BehaviorSubject(null);
        this.energyUtilObj = new BehaviorSubject(null);
        this.envLocObject = new BehaviorSubject(null);
        this.enviObject = new BehaviorSubject(null);
        this.impactAnalysisObj = new BehaviorSubject(null);
        this.spacesPeriod = new BehaviorSubject(new SpacesPeriod({}));
        this.spacesLocation = new BehaviorSubject(null);
        this.locationNameMap = new BehaviorSubject(null);
        this.spacesLocationList = new BehaviorSubject(null);
        this.rightNowLocationList = new BehaviorSubject(null);
        this.energyUtilLocationList = new BehaviorSubject(null);
        this.metricGroup = new BehaviorSubject("");
        this.metricSubGroup = new BehaviorSubject("");
        this.searchGodDashboard = new BehaviorSubject("");
        this.impactAnalysisSearch = new BehaviorSubject("");
        this.energyUtilSearch = new BehaviorSubject("");
        this.isSampleData = new BehaviorSubject(false);
        this.isCMSampleData = new BehaviorSubject(false);
        this.isEUSampleData = new BehaviorSubject(false);
        this.showNav = new BehaviorSubject(false);
        this.showBITags = new BehaviorSubject(false);
        this.impactObj = new BehaviorSubject(null);
        this.iseventUpdated = new BehaviorSubject(false);
        this.updatedEvent = new BehaviorSubject(null);
        this.videoAnalyticsObj = new BehaviorSubject(null);
        this.isGrantAccess = new BehaviorSubject(false);
        this.resetPINEmailAddress = new BehaviorSubject(null);
        this.shareFeedbackObj = new BehaviorSubject(null);
        this.shareTimer = new BehaviorSubject(0);
        this.shareButtonStatus = new BehaviorSubject(false);
        // private isUnAuthorised: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
        // biTags = {};
        this.biTags = new BehaviorSubject(null);
        this.rightNowTags = new BehaviorSubject(null);
        this.outlierLocations = [];
        this.isMerakiAuth = new BehaviorSubject(false);
        this.dashLandingUrl = new BehaviorSubject('/base');
        this.disconnectMeraki = new BehaviorSubject(false);
        this.disconnectMerakiLogin = new BehaviorSubject(false);
        this.magneticMenu = new BehaviorSubject([]);
        this.selectedApp = new BehaviorSubject({ icon: 'icon-home', name: 'Dashboard' });
        this.disconnectMerakiAPIKey = new BehaviorSubject(false);
        this.loginFromMeraki = new BehaviorSubject(false);
        this.loginAPIFromMeraki = new BehaviorSubject(false);
        this.showSyncStatus = new BehaviorSubject(false);
        this.biExcludedLocObj = new BehaviorSubject(null);
        this.merakiWPAuthResponse = new BehaviorSubject(false);
        this.deleteAnalyticsReports = new BehaviorSubject(null);
        this.updateAnalyticsReports = new BehaviorSubject(null);
        this.updateAnalyticsReportDetails = new BehaviorSubject(null);
        this.editAnalyticsReport = new BehaviorSubject(null);
        this.locAnalyticsPopupOpen = new BehaviorSubject(false);
        this.ruleName = new BehaviorSubject(null);
        this.queryParam = new BehaviorSubject("");
        this.merakiSyncStatus = new BehaviorSubject(false);
        this.isServiceEnableMerakiLogin = new BehaviorSubject(false);
        this.isServiceEnableMerakiAPI = new BehaviorSubject(false);
        this.merakiLoginNetworkCount = new BehaviorSubject(null);
        this.merakiApiNetworkCount = new BehaviorSubject(null);
        this.mapsUploadSessionId = new BehaviorSubject("");
        this.locationLoadingStatus = new BehaviorSubject(null);
        this.i18nLangChange = new BehaviorSubject(new Date().getTime().toString());
        this.webexStatus = new BehaviorSubject(false);
        this.loggedIn = new BehaviorSubject(false);
        this.loggedOut = new BehaviorSubject(false);
        this.spacesLocationId = "";
        this.spacesWSResponse = "";
        this.spacesWSConnectionStatus = false;
        //  isMerakiAuth: boolean;
        //  isMerakiAuth: boolean;
        this.isFreshlogin = false;
        this.isFromMail = false;
        this.isPageRefresh = true;
        this.isBackPressed = false; //test
        this.adminAccess = false;
        this.syncError = {};
        this.mongoDBIds = {};
        this.graphDBIds = {};
        this.locationSyncNotificationsList = [];
        this.canDoInteractionLog = true;
        this.ssidFromRule = false;
        this.ssidFromRuleId = null;
        this.fromSSIDPage = false;
        this.fromSSIDName = null;
        this.showSmsLimitTab = false;
        this.showCMXConnector = false;
        this.webexBaseUrl = null;
        this.hotspotTNCLink = null;
        this.smartLicenseLearnMore = null;
        this.smartLicensePollingMS = 0;
        this.smartLicenseEnableFeature = false;
        this.properties = null;
        this.currentEditLanguage = {};
        this.isUndoPortal = false;
        this.wirelessProviderAuthStatusCallInProgress = false;
        this.deleteLocationStatusCallInProgress = false;
        this.navFromPortalList = false;
        this.totalLocIds = [];
        this.isDashboardAdmin = false;
        this.isDashboardUser = false;
        this.enableWiredNetwork = false;
        this.fromSamplePortal = false;
        //  locationNetworkFromSetup  =  false ;
        this.popUpAditionalParam = null;
        //  ssidFromSetup  =  false;
        this.openPopUpFromSetup = null;
        this.isDummy = false;
        this.isCMDummy = false;
        this.isEUDummy = false;
        this.showDataExportTab = false;
        this.businessLocationList = [];
        this.businessSettings = null;
        this.currentApp = "";
        this.homePageNavigations = [];
        this.cpPageNavigations = [];
        this.dnaSpacesHomeSetup = false;
        this.loginTemp = {};
        this.biTopThreeLocIds = [];
        this.biBottomThreeLocIds = [];
        this.biTopAndBottomLocations = {};
        this.biSignificantRankLocations = {};
        this.selectedTenantId = 0;
        this.magneticMenuRouteUrl = null;
        this.magneticAppIsExpanded = new BehaviorSubject(null);
        this.magneticLAHomeNavIsSelected = new BehaviorSubject(null);
        this.activateUserType = "";
        this.isStorageTriggerAdded = false;
        this.partnerOAuthState = "";
        this.sharePluginObject = {};
        this.rootLocation = new Location();
        this.cciRedirect = false;
        this.cciActivateUserEmail = null;
        this.cciActivateUserToken = null;
        this.activeTimeStampConnection = false;
        this.locationRMSDependenciesLoaded = false;
        this.showMagneticLayout = false;
        this.isDigitalMapReady = new BehaviorSubject(null);
        this.isEnableStandardMap = new BehaviorSubject(null);
        this.hasRoomCount = false;
        this.isAuthSSO = new BehaviorSubject(false);
        this.isManageUser = new BehaviorSubject(true);
        this.customerAccNo = new BehaviorSubject(false);
        this.isAuthSSOForOR = new BehaviorSubject(false);
        this.isAuthSSOForSignage = new BehaviorSubject(false);
        this.isAuthSSOForWorkspace = new BehaviorSubject(false);
        this.isManageUserForOR = new BehaviorSubject(true);
        this.customerAccNoForOR = new BehaviorSubject(false);
        this.userRoleForOR = new UserRoleForOpenRoaming(null, null, null);
        this.userRoleSubscriberForOR = new BehaviorSubject(this.userRoleForOR);
        this.isAuthSSOForPersonas = new BehaviorSubject(false);
        this.isManageUserForPersonas = new BehaviorSubject(true);
        this.customerAccNoForPersonas = new BehaviorSubject(false);
        this.userRoleForPersonas = new UserRoleForPersonas(null, null, null);
        this.userRoleSubscriberForPersonas = new BehaviorSubject(this.userRoleForPersonas);
        this.isAuthSSOForEngagements = new BehaviorSubject(false);
        this.isManageUserForEngagements = new BehaviorSubject(true);
        this.isManageUserForSignage = new BehaviorSubject(true);
        this.isManageUserForWorkspace = new BehaviorSubject(true);
        this.customerAccNoForEngagements = new BehaviorSubject(false);
        this.customerAccNoForSignage = new BehaviorSubject(false);
        this.customerAccNoForWorkspace = new BehaviorSubject(false);
        this.userRoleForEngagements = new UserRoleForEngagements(null, null, null);
        this.userRoleSubscriberForEngagements = new BehaviorSubject(this.userRoleForEngagements);
        this.isAuthSSOForIoT = new BehaviorSubject(false);
        this.isManageUserForIoT = new BehaviorSubject(true);
        this.customerAccNoForIoT = new BehaviorSubject(null);
        this.userRoleForIoT = new UserRoleForIoT(null, null, null);
        this.userRoleSubscriberForIoT = new BehaviorSubject(this.userRoleForIoT);
        this.ioTLocationPath = new BehaviorSubject(null);
        this.ioTMongoIdGraphIdMap = new BehaviorSubject(null);
        this.ioTMongoIdLocationObjMap = new BehaviorSubject(null);
        this.iotEditRuleObj = new BehaviorSubject(null);
        this.userRoleForSignage = new UserRoleForSignage(null, null, null);
        this.userRoleSubscriberForSignage = new BehaviorSubject(this.userRoleForSignage);
        this.userRoleForWorkspace = new UserRoleForWorkspace(null, null, null);
        this.userRoleSubscriberForWorkspace = new BehaviorSubject(this.userRoleForWorkspace);
        this.workspaceUtilObj = new BehaviorSubject(null);
        this.spaceManagerSelectedFloorObj = new BehaviorSubject(null);
        this.workspaceExperienceUtilObj = new BehaviorSubject(null);
        this.envMetricsObj = new BehaviorSubject(null);
        this.workspaceSelectedLocType = null;
        this.showIntegrations = false;
        this.enableServiceNow = false;
        this.serviceNowDefaultTenants = null;
        // singleton condition starts
        this.tilesData = new BehaviorSubject([]);
        this.comingFromSetupPage = false;
        this.userAppsList = [];
        //  singleton condition starts
        this.userCountResponse = {};
        this.isSmartLicenseRegistered = false;
        this.isLicensePage = false;
        this.isRightNowRefresh = false;
        this.isEnergyUtilRefresh = false;
        this.openLocationMenu = false;
        this.enableORSetup = false;
        this.isCountryRequired = false;
        this.isAdminUser = new BehaviorSubject(false);
        this.locationSetStatus = new BehaviorSubject(null);
        this.locationAddEvt = new BehaviorSubject(null);
        this.locationUpdateEvt = new BehaviorSubject(null);
        this.locationRenameUpdateEvt = new BehaviorSubject(null);
        this.locationDeleteEvt = new BehaviorSubject(null);
        this.locationRowMap = new Map(null);
        this.locationRowArray = new Array();
        this.geoLocationRowArray = new Array();
        this.showChangeLogPage = false;
        this.locLoadingStarted = new BehaviorSubject(false);
        this.deltaUpdateEvt = new BehaviorSubject(null);
        this.initialLocationCompletedWS = false;
        this.showSLPage = false;
        this.webexEnableMenu = false;
        this.devicePlacementNavEnabled = false;
        this.iotHomePageTab = new BehaviorSubject(null);
        this.useCasetotalCount = new BehaviorSubject(0);
        this.iotMongoIdLocationNameMap = new BehaviorSubject(null);
        this.selectedLH2Location = null;
        this.setCountryCodeRequired = (value) => {
            this.isCountryRequired = value;
        };
        this.getCountryCodeRequired = () => {
            return this.isCountryRequired;
        };
        this.setLocationRowMap = (key, value) => {
            this.locationRowMap.set(key, value);
        };
        this.getLocationRowMap = () => {
            return this.locationRowMap;
        };
        this.getLocationRowMapByKey = (key) => {
            return this.locationRowMap.get(key);
        };
        this.setLocationRowArray = (value) => {
            if (this.locationRowArray.length === 0) {
                this.locationRowArray.push(value);
            }
            else {
                if (this.getLocationRowArrayByKey("id", value.id).length) {
                    // array item already exists
                }
                else {
                    this.locationRowArray.push(value);
                }
            }
        };
        this.getLocationRowArray = () => {
            return this.locationRowArray;
        };
        this.getLocationRowArrayByKey = (key, value) => {
            return this.locationRowArray.filter((e) => {
                if (key === "name") {
                    return e[key].toLowerCase().includes(value.toLowerCase());
                }
                else {
                    return e[key] === value;
                }
            });
        };
        this.getLocationChildrenByParentId = (key) => {
            let childData = [];
            try {
                this.locationRowMap.forEach((loc) => {
                    if (loc.parentId === key) {
                        childData.push({
                            id: loc.id,
                            name: loc.name
                        });
                    }
                });
                return childData;
            }
            catch (e) {
                return [];
            }
        };
        this.deleteLocationRowArrayByKey = (key) => {
            let index = -1;
            for (let i = 0; i < this.locationRowArray.length; i++) {
                if (this.locationRowArray[i].id === key) {
                    index = i;
                }
                break;
            }
            if (index > -1) {
                this.locationRowArray.splice(index, 1);
            }
        };
        this.setGeoLocationArray = (value) => {
            if (this.geoLocationRowArray.length === 0) {
                this.geoLocationRowArray.push(value);
            }
            else {
                let index = this.getGeoLocationArrayIndex("id", value.id);
                if (index > -1) {
                    // array item already exists
                    this.geoLocationRowArray[index] = value;
                }
                else {
                    this.geoLocationRowArray.push(value);
                }
            }
        };
        this.getGeoLocationRowArray = () => {
            return this.geoLocationRowArray;
        };
        this.getGeoLocationArrayByKey = (key, value) => {
            return this.geoLocationRowArray.filter((e) => {
                return e[key] === value;
            });
        };
        this.getGeoLocationArrayIndex = (key, value) => {
            let index = -1;
            let found = this.geoLocationRowArray.filter((e, i) => {
                if (e[key] === value) {
                    index = i;
                    return true;
                }
            });
            if (found && index > -1)
                return index;
            else
                return -1;
        };
        this.setRightNowObject = (value) => {
            this.setInStorage("rightNowObj", JSON.stringify(value));
            this.rightNowObj.next(value);
        };
        this.getRightNowObject = (unsubscribe$) => {
            if (!this.rightNowObj)
                this.rightNowObj = new BehaviorSubject(null);
            return this.rightNowObj.pipe(takeUntil(unsubscribe$));
        };
        this.setEnvLocObject = (value) => {
            this.setInStorage("envLocationObject", JSON.stringify(value));
            this.envLocObject.next(value);
        };
        this.getEnvLocObject = (unsubscribe$) => {
            if (!this.envLocObject)
                this.envLocObject = new BehaviorSubject(null);
            return this.envLocObject.pipe(takeUntil(unsubscribe$));
        };
        this.setEnvMetricsObject = (value) => {
            this.setInStorage("envMetricsObj", JSON.stringify(value));
            this.envMetricsObj.next(value);
        };
        this.getEnvMetricsObject = (unsubscribe$) => {
            if (!this.envMetricsObj) {
                this.envMetricsObj = new BehaviorSubject(null);
            }
            return this.envMetricsObj.pipe(takeUntil(unsubscribe$));
        };
        this.setEnergyUtilObject = (value) => {
            this.setInStorage("energyUtilObj", JSON.stringify(value));
            this.energyUtilObj.next(value);
        };
        this.getEnergyUtilObject = (unsubscribe$) => {
            if (!this.energyUtilObj)
                this.energyUtilObj = new BehaviorSubject(null);
            return this.energyUtilObj.pipe(takeUntil(unsubscribe$));
        };
        this.setEnviNowObject = (value) => {
            this.setInStorage("enviObject", JSON.stringify(value));
            this.enviObject.next(value);
        };
        this.getEnviObject = (unsubscribe$) => {
            if (!this.enviObject)
                this.enviObject = new BehaviorSubject(null);
            return this.enviObject.pipe(takeUntil(unsubscribe$));
        };
        this.getLoginTemp = () => {
            return this.loginTemp;
        };
        this.setRootLocation = (location) => {
            this.rootLocation = location;
        };
        this.getRootLocation = () => {
            return this.rootLocation;
        };
        this.clearLoginTemp = () => {
            this.loginTemp = {};
        };
        this.addStorageTrigger = () => {
            if (!this.isStorageTriggerAdded) {
                this.addSessionStorageListener();
                this.triggerStorageAccess();
                this.isStorageTriggerAdded = true;
            }
        };
        this.getIsDashboardAdmin = () => {
            return this.isDashboardAdmin;
        };
        this.setIsDashboardAdmin = (isDashboardAdmin = false) => {
            this.isDashboardAdmin = isDashboardAdmin;
        };
        this.getIsDashboardUser = () => {
            return this.isDashboardUser;
        };
        this.setIsDashboardUser = (isDashboardUser = false) => {
            this.isDashboardUser = isDashboardUser;
        };
        this.getEnableWiredNetwork = () => {
            return this.enableWiredNetwork;
        };
        this.setEnableWiredNetwork = (enableWiredNetwork = false) => {
            this.enableWiredNetwork = enableWiredNetwork;
        };
        this.getFromSamplePortal = () => {
            return this.fromSamplePortal;
        };
        this.setFromSamplePortal = (fromSamplePortal) => {
            this.fromSamplePortal = fromSamplePortal;
        };
        this.getCurrentApp = () => {
            return this.currentApp;
        };
        this.setCurrentApp = (currentApp) => {
            this.currentApp = currentApp;
        };
        this.getShowMagneticLayout = () => {
            return this.showMagneticLayout;
        };
        this.setShowMagneticLayout = (showMagneticLayout) => {
            this.showMagneticLayout = showMagneticLayout;
        };
        this.setIsMerakiAuth = (value) => {
            if (!this.isMerakiAuth) {
                this.isMerakiAuth = new BehaviorSubject(null);
            }
            this.isMerakiAuth.next(value);
        };
        this.setDashLandingUrl = (value) => {
            if (!this.dashLandingUrl) {
                this.dashLandingUrl = new BehaviorSubject('/base');
            }
            this.dashLandingUrl.next(value);
        };
        this.getDashLandingUrl = (unsubscribe$) => {
            if (!this.dashLandingUrl) {
                this.dashLandingUrl = new BehaviorSubject('/base');
            }
            return this.dashLandingUrl.pipe(takeUntil(unsubscribe$));
        };
        this.getIsMerakiAuth = (unsubscribe$) => {
            if (!this.isMerakiAuth) {
                this.isMerakiAuth = new BehaviorSubject(null);
            }
            return this.isMerakiAuth.pipe(takeUntil(unsubscribe$));
        };
        this.setSelectedApp = (value) => {
            if (!this.selectedApp) {
                this.selectedApp = new BehaviorSubject({ icon: 'icon-home', name: 'Dashboard' });
            }
            this.selectedApp.next(value);
        };
        this.getSelectedApp = (unsubscribe$) => {
            if (!this.selectedApp) {
                this.selectedApp = new BehaviorSubject({ icon: 'icon-home', name: 'Dashboard' });
            }
            return this.selectedApp.pipe(takeUntil(unsubscribe$));
        };
        this.setMagneticMenu = (value) => {
            if (!this.magneticMenu) {
                this.magneticMenu = new BehaviorSubject([]);
            }
            this.magneticMenu.next(value);
        };
        this.getMagneticMenu = (unsubscribe$) => {
            if (!this.magneticMenu) {
                this.magneticMenu = new BehaviorSubject([]);
            }
            return this.magneticMenu.pipe(takeUntil(unsubscribe$));
        };
        this.setDisconnectFromMerakiLogin = (value) => {
            if (!this.disconnectMerakiLogin) {
                this.disconnectMerakiLogin = new BehaviorSubject(null);
            }
            this.disconnectMerakiLogin.next(value);
        };
        this.getDisconnectFromMerakiLogin = (unsubscribe$) => {
            if (!this.disconnectMerakiLogin) {
                this.disconnectMerakiLogin = new BehaviorSubject(null);
            }
            return this.disconnectMerakiLogin.pipe(takeUntil(unsubscribe$));
        };
        this.setDisconnectFromMeraki = (value) => {
            if (!this.disconnectMeraki) {
                this.disconnectMeraki = new BehaviorSubject(null);
            }
            this.disconnectMeraki.next(value);
        };
        this.getDisconnectFromMeraki = (unsubscribe$) => {
            if (!this.disconnectMeraki) {
                this.disconnectMeraki = new BehaviorSubject(null);
            }
            return this.disconnectMeraki.pipe(takeUntil(unsubscribe$));
        };
        this.setDisconnectFromMerakiAPIKey = (value) => {
            if (!this.disconnectMerakiAPIKey) {
                this.disconnectMerakiAPIKey = new BehaviorSubject(null);
            }
            this.disconnectMerakiAPIKey.next(value);
        };
        this.getDisconnectFromMerakiAPIKey = (unsubscribe$) => {
            if (!this.disconnectMerakiAPIKey) {
                this.disconnectMerakiAPIKey = new BehaviorSubject(null);
            }
            return this.disconnectMerakiAPIKey.pipe(takeUntil(unsubscribe$));
        };
        this.setI18nLangChange = (value) => {
            if (!this.i18nLangChange) {
                this.i18nLangChange = new BehaviorSubject(new Date().getTime().toString());
            }
            this.i18nLangChange.next(value);
        };
        this.getI18nLangChange = (unsubscribe$) => {
            if (!this.i18nLangChange) {
                this.i18nLangChange = new BehaviorSubject(new Date().getTime().toString());
            }
            return this.i18nLangChange.pipe(takeUntil(unsubscribe$));
        };
        this.setLoginFromMeraki = (value) => {
            if (!this.loginFromMeraki) {
                this.loginFromMeraki = new BehaviorSubject(null);
            }
            this.loginFromMeraki.next(value);
        };
        this.getLoginFromMeraki = (unsubscribe$) => {
            if (!this.loginFromMeraki) {
                this.loginFromMeraki = new BehaviorSubject(null);
            }
            return this.loginFromMeraki.pipe(takeUntil(unsubscribe$));
        };
        this.setShowSyncStatus = (value) => {
            if (!this.showSyncStatus) {
                this.showSyncStatus = new BehaviorSubject(null);
            }
            this.showSyncStatus.next(value);
        };
        this.getShowSyncStatus = (unsubscribe$) => {
            if (!this.showSyncStatus) {
                this.showSyncStatus = new BehaviorSubject(null);
            }
            return this.showSyncStatus.pipe(takeUntil(unsubscribe$));
        };
        this.setLoginAPIFromMeraki = (value) => {
            if (!this.loginAPIFromMeraki) {
                this.loginAPIFromMeraki = new BehaviorSubject(null);
            }
            this.loginAPIFromMeraki.next(value);
        };
        this.getLoginAPIFromMeraki = (unsubscribe$) => {
            if (!this.loginAPIFromMeraki) {
                this.loginAPIFromMeraki = new BehaviorSubject(null);
            }
            return this.loginAPIFromMeraki.pipe(takeUntil(unsubscribe$));
        };
        this.setMerakiWPAuthResponse = (value) => {
            if (value) {
                this.merakiWPAuthResponse = new BehaviorSubject(null);
            }
            this.merakiWPAuthResponse.next(value);
        };
        this.getMerakiWPAuthResponse = (unsubscribe$) => {
            if (!this.merakiWPAuthResponse) {
                this.merakiWPAuthResponse = new BehaviorSubject(null);
            }
            return this.merakiWPAuthResponse.pipe(takeUntil(unsubscribe$));
        };
        this.getWirelessProviderAuthStatusCallInProgress = () => {
            return this.wirelessProviderAuthStatusCallInProgress;
        };
        this.setMerakiWirelessProviderAuthStatusCallInProgress = (inProgress = false) => {
            this.wirelessProviderAuthStatusCallInProgress = inProgress;
        };
        this.getDeleteLocationStatusCallInProgress = () => {
            return this.deleteLocationStatusCallInProgress;
        };
        this.setDeleteLocationStatusCallInProgress = (inProgress = false) => {
            this.deleteLocationStatusCallInProgress = inProgress;
        };
        this.getCanDoInteractionLog = () => {
            return this.canDoInteractionLog;
        };
        this.setCanDoInteractionLog = (canDoInteractionLog) => {
            this.canDoInteractionLog = canDoInteractionLog;
        };
        this.getShowSmsLimitTab = () => {
            return this.showSmsLimitTab;
        };
        this.setShowSmsLimitTab = (showSmsLimitTab) => {
            this.showSmsLimitTab = showSmsLimitTab;
        };
        this.getShowCMXConnector = () => {
            return this.showCMXConnector;
        };
        this.setShowCMXConnector = (showCMXConnector) => {
            this.showCMXConnector = showCMXConnector;
        };
        this.getWebexBaseUrl = () => {
            return this.webexBaseUrl;
        };
        this.setWebexBaseUrl = (webexBaseUrl) => {
            this.webexBaseUrl = webexBaseUrl;
        };
        this.getHotspotTNCLinkUrl = () => {
            return this.hotspotTNCLink;
        };
        this.setHotspotTNCLinkUrl = (hotspotTNCLink) => {
            this.hotspotTNCLink = hotspotTNCLink;
        };
        this.getSmartLicenseLearnMore = () => {
            return this.smartLicenseLearnMore;
        };
        this.setSmartLicenseLearnMore = (smartLicenseLearnMore) => {
            this.smartLicenseLearnMore = smartLicenseLearnMore;
        };
        this.getSmartLicensePollingMS = () => {
            return this.smartLicensePollingMS;
        };
        this.setSmartLicensePollingMS = (smartLicensePollingMS) => {
            this.smartLicensePollingMS = smartLicensePollingMS;
        };
        this.getSmartLicenseEnableFeature = () => {
            return this.smartLicenseEnableFeature;
        };
        this.setSmartLicenseEnableFeature = (smartLicenseEnableFeature) => {
            this.smartLicenseEnableFeature = smartLicenseEnableFeature;
        };
        this.getShowSLPage = () => {
            return this.showSLPage;
        };
        this.setShowSLPage = (showSLPage) => {
            this.showSLPage = showSLPage;
        };
        this.getConnector = () => {
            return this.connector;
        };
        this.setConnector = (connector) => {
            this.connector = connector;
        };
        this.getIsUndoPortal = () => {
            return this.isUndoPortal;
        };
        this.setIsUndoPortal = (isUndoPortal) => {
            this.isUndoPortal = isUndoPortal;
        };
        this.getPosition = () => {
            return this.position;
        };
        this.setPosition = (position) => {
            this.position = position;
        };
        this.getSsidFromRule = () => {
            return this.ssidFromRule;
        };
        this.setSsidFromRule = (ssidFromRule) => {
            this.ssidFromRule = ssidFromRule;
        };
        this.getFromSSIDPage = () => {
            return this.fromSSIDPage;
        };
        this.setFromSSIDPage = (fromSSIDPage) => {
            this.fromSSIDPage = fromSSIDPage;
        };
        this.getSsidFromRuleId = () => {
            return this.ssidFromRuleId;
        };
        this.setSsidFromRuleId = (ssidFromRuleId) => {
            this.ssidFromRuleId = ssidFromRuleId;
        };
        this.getFromSSIDName = () => {
            return this.fromSSIDName;
        };
        this.setFromSSIDName = (fromSSIDName) => {
            this.fromSSIDName = fromSSIDName;
        };
        this.getIsRightNowRefresh = () => {
            return this.isRightNowRefresh;
        };
        this.setIsRightNowRefresh = (isRightNowRefresh) => {
            this.isRightNowRefresh = isRightNowRefresh;
        };
        this.getIsEnergyUtilRefresh = () => {
            return this.isEnergyUtilRefresh;
        };
        this.setIsEnergyUtilRefresh = (isEnergyUtilRefresh) => {
            this.isEnergyUtilRefresh = isEnergyUtilRefresh;
        };
        this.display = (value, delayInMillis = -1) => {
            const loader = new CircularLoaderStatus();
            loader.setValueAndDelay(value, delayInMillis);
            // console.log(
            //   "Call for Display status change (true/false)",
            //   value,
            //   loader
            // );
            this.status.next(loader);
        };
        this.enableBITagFiltering = (value) => {
            this.showBITags.next(value);
        };
        this.getShowBITags = (unsubscribe$) => {
            if (!this.showBITags) {
                this.showBITags = new BehaviorSubject(false);
            }
            return this.showBITags.pipe(takeUntil(unsubscribe$));
        };
        this.getStatus = (unsubscribe$) => {
            if (!this.status) {
                this.status = new BehaviorSubject(new CircularLoaderStatus());
            }
            return this.status.pipe(takeUntil(unsubscribe$));
        };
        this.getLoginTime = () => {
            return this.loginTime;
        };
        this.setLoginTime = (time) => {
            this.loginTime = time;
        };
        this.getMagneticMenuRouteUrl = () => {
            if (!this.magneticMenuRouteUrl) {
                this.magneticMenuRouteUrl = this.getFromStorage("magneticMenuRouteUrl");
            }
            return this.magneticMenuRouteUrl;
        };
        this.setMagneticMenuRouteUrl = (routeUrl) => {
            this.magneticMenuRouteUrl = routeUrl;
            this.setInStorage("magneticMenuRouteUrl", routeUrl);
        };
        // getMagneticAppIsExpanded = () => {
        // 	if (!this.magneticAppIsExpanded) {
        // 		this.magneticAppIsExpanded = Boolean(this.getFromStorage("magneticAppIsExpanded"));
        // 	}
        // 	return this.magneticAppIsExpanded;
        // };
        // setMagneticAppIsExpanded = (isExpanded: boolean) => {
        // 	this.magneticAppIsExpanded = isExpanded;
        // 	this.setInStorage("magneticAppIsExpanded", isExpanded);
        // };
        this.getMagneticAppIsExpanded = (unsubscribe$) => {
            if (!this.magneticAppIsExpanded) {
                this.magneticAppIsExpanded = new BehaviorSubject(null);
            }
            return this.magneticAppIsExpanded.pipe(takeUntil(unsubscribe$));
        };
        this.setMagneticAppIsExpanded = (magneticAppIsExpanded) => {
            if (!this.magneticAppIsExpanded) {
                this.magneticAppIsExpanded = new BehaviorSubject(null);
            }
            this.magneticAppIsExpanded.next(magneticAppIsExpanded);
        };
        this.getLAHomeNavIsSelected = (unsubscribe$) => {
            if (!this.magneticLAHomeNavIsSelected) {
                this.magneticLAHomeNavIsSelected = new BehaviorSubject(null);
            }
            return this.magneticLAHomeNavIsSelected.pipe(takeUntil(unsubscribe$));
        };
        this.setLAHomeNavIsSelected = (magneticLAHomeNavIsSelected) => {
            if (!this.magneticLAHomeNavIsSelected) {
                this.magneticLAHomeNavIsSelected = new BehaviorSubject(null);
            }
            this.magneticLAHomeNavIsSelected.next(magneticLAHomeNavIsSelected);
        };
        this.getTenantId = () => {
            if (!this.selectedTenantId) {
                this.selectedTenantId = Number(this.getFromStorage("tenantId"));
            }
            return this.selectedTenantId;
        };
        this.setTenantId = (id) => {
            this.selectedTenantId = id;
            this.setInStorage("tenantId", id);
        };
        // DIGITAL MAP //
        this.getIsDigitalMapReady = (unsubscribe$) => {
            if (!this.isDigitalMapReady) {
                this.isDigitalMapReady = new BehaviorSubject(null);
            }
            return this.isDigitalMapReady.pipe(takeUntil(unsubscribe$));
        };
        this.setIsDigitalMapReady = (isDigitalMapReady) => {
            if (!this.isDigitalMapReady) {
                this.isDigitalMapReady = new BehaviorSubject(null);
            }
            this.isDigitalMapReady.next(isDigitalMapReady);
        };
        // DIGITAL MAP //
        this.getEnableStandardMap = (unsubscribe$) => {
            if (!this.isEnableStandardMap) {
                this.isEnableStandardMap = new BehaviorSubject(null);
            }
            return this.isEnableStandardMap.pipe(takeUntil(unsubscribe$));
        };
        this.setEnableStandardMap = (isEnableStandardMap) => {
            if (!this.isEnableStandardMap) {
                this.isEnableStandardMap = new BehaviorSubject(null);
            }
            this.isEnableStandardMap.next(isEnableStandardMap);
        };
        this.getRMBuildingId = () => {
            if (!this.selectedRMBuildingId) {
                this.selectedRMBuildingId = this.getFromStorage("richMapBuildingId");
            }
            return this.selectedRMBuildingId;
        };
        this.setRMBuildingId = (id) => {
            this.selectedRMBuildingId = id;
            this.setInStorage("richMapBuildingId", id);
        };
        this.setRMBuildingName = (name) => {
            this.selectedRMBuildingName = name;
            this.setInStorage("richMapBuildingName", name);
        };
        this.getRMBuildingName = () => {
            if (!this.selectedRMBuildingName) {
                this.selectedRMBuildingName = this.getFromStorage("richMapBuildingName");
            }
            return this.selectedRMBuildingName;
        };
        this.getSelectedTabOnLocationMapScreen = () => {
            return this.getFromStorage("selectedTabOnLocationMapScreen");
        };
        this.resetRMBuildingId = () => {
            this.selectedRMBuildingId = "";
            this.setInStorage("richMapBuildingId", "");
        };
        this.resetRMBuildingName = () => {
            this.selectedRMBuildingName = "";
            this.setInStorage("richMapBuildingName", "");
        };
        this.setRMBuildingDetails = (data) => {
            this.selectedRMStatus = data;
            this.setInStorage("richMapBuildingStatus", JSON.stringify(data));
        };
        this.getRMBuildingDetails = () => {
            if (!this.selectedRMStatus) {
                this.selectedRMStatus = JSON.parse(this.getFromStorage("richMapBuildingStatus") || "{}");
            }
            return this.selectedRMStatus;
        };
        this.resetRMBuildingDetails = () => {
            this.selectedRMStatus = "";
            this.setInStorage("richMapBuildingStatus", "");
        };
        this.setReviewBuildingDetails = (data) => {
            this.reviewBuildingDetails = data;
            this.setInStorage("reviewBuildingDetails", JSON.stringify(data));
        };
        this.getReviewBuildingDetails = () => {
            if (!this.reviewBuildingDetails) {
                this.reviewBuildingDetails = JSON.parse(this.getFromStorage("reviewBuildingDetails") || "{}");
            }
            return this.reviewBuildingDetails;
        };
        this.resetReviewBuildingDetails = () => {
            this.reviewBuildingDetails = "";
            this.setInStorage("reviewBuildingDetails", "");
        };
        this.setSelectedTabOnLocationMapScreen = (selectedTab) => {
            this.selectedTabOnLocationMapScreen = selectedTab;
            this.setInStorage("selectedTabOnLocationMapScreen", selectedTab);
        };
        this.getORMerakiProfileId = () => {
            if (!this.selectedORMerakiProfileId) {
                this.selectedORMerakiProfileId = Number(this.getFromStorage("selectedORMerakiProfileId"));
            }
            return this.selectedORMerakiProfileId;
        };
        this.setORMerakiProfileId = (id) => {
            this.selectedORMerakiProfileId = id;
            this.setInStorage("selectedORMerakiProfileId", id);
        };
        // cci variables
        this.getCCIRedirect = () => {
            if (!this.cciRedirect) {
                this.cciRedirect = Boolean(this.getFromStorage("cciRedirect"));
            }
            return this.cciRedirect;
        };
        this.setCCIRedirect = (val) => {
            this.cciRedirect = val;
            this.setInStorage("cciRedirect", val);
        };
        this.getCCIActivateUserEmail = () => {
            if (!this.cciActivateUserEmail) {
                this.cciActivateUserEmail = this.getFromStorage("cciActivateUserEmail");
            }
            return this.cciActivateUserEmail;
        };
        this.setCCIActivateUserEmail = (val) => {
            this.cciActivateUserEmail = val;
            this.setInStorage("cciActivateUserEmail", val);
        };
        this.getCCIActivateUserToken = () => {
            if (!this.cciActivateUserToken) {
                this.cciActivateUserToken = this.getFromStorage("cciActivateUserToken");
            }
            return this.cciActivateUserToken;
        };
        this.setCCIActivateUserToken = (val) => {
            this.cciActivateUserToken = val;
            this.setInStorage("cciActivateUserToken", val);
        };
        this.getWebexSetupStatus = () => {
            if (!this.webexSetupStatus) {
                this.webexSetupStatus = this.getFromStorage("webexSetupStatus");
            }
            return this.webexSetupStatus;
        };
        this.setWebexSetupStatus = (val) => {
            this.webexSetupStatus = val;
            this.setInStorage("webexSetupStatus", val);
        };
        this.showFullScreen = (value) => {
            this.showFullScreenView.next(value);
        };
        this.getShowFullScreen = (unsubscribe$) => {
            if (!this.showFullScreenView) {
                this.showFullScreenView = new BehaviorSubject(false);
            }
            return this.showFullScreenView.pipe(takeUntil(unsubscribe$));
        };
        this.withSearchText = (value) => {
            this.searchText.next(value);
        };
        this.getSearchText = (unsubscribe$) => {
            if (!this.searchText) {
                this.searchText = new BehaviorSubject("");
            }
            return this.searchText.pipe(takeUntil(unsubscribe$));
        };
        this.doLocationAction = (value) => {
            this.locationAction.next(value);
        };
        this.getLocationAction = (unsubscribe$) => {
            if (!this.locationAction) {
                this.locationAction = new BehaviorSubject(new LocationAction());
            }
            return this.locationAction.pipe(takeUntil(unsubscribe$));
        };
        this.setPopUpAditionalParam = (fromSetUp) => {
            this.popUpAditionalParam = fromSetUp;
        };
        this.getPopUpAditionalParam = () => {
            return this.popUpAditionalParam;
        };
        this.setOpenPopUpFromSetup = (popUpName) => {
            this.openPopUpFromSetup = popUpName;
        };
        this.getOpenPopUpFromSetup = () => {
            return this.openPopUpFromSetup;
        };
        this.getOnSyncStatusUpdate = (unsubscribe$) => {
            if (!this.onSyncStatusUpdate) {
                this.onSyncStatusUpdate = new BehaviorSubject(0);
            }
            return this.onSyncStatusUpdate.pipe(takeUntil(unsubscribe$));
        };
        this.setOnSyncStatusUpdate = (value) => {
            if (!this.onSyncStatusUpdate) {
                this.onSyncStatusUpdate = new BehaviorSubject(0);
            }
            this.onSyncStatusUpdate.next(value);
        };
        this.getOnLocationSyncStatusUpdate = (unsubscribe$) => {
            if (!this.onLocationSyncStatusUpdate) {
                this.onLocationSyncStatusUpdate = new BehaviorSubject(0);
            }
            return this.onLocationSyncStatusUpdate.pipe(takeUntil(unsubscribe$));
        };
        this.setOnLocationSyncStatusUpdate = (value) => {
            if (!this.onLocationSyncStatusUpdate) {
                this.onLocationSyncStatusUpdate = new BehaviorSubject(0);
            }
            this.onLocationSyncStatusUpdate.next(value);
        };
        this.setLocationTreeArray = (value) => {
            if (!this.locationTreeArray) {
                this.locationTreeArray = new BehaviorSubject(new LocationWrap());
            }
            if (value) {
                this.locationTreeArrayExists = true;
            }
            else {
                this.locationTreeArrayExists = false;
            }
            this.setLocationWrap(value);
            this.locationTreeArray.next(value);
        };
        this.getLocationTreeArray = (unsubscribe$) => {
            if (!this.locationTreeArray) {
                this.locationTreeArray = new BehaviorSubject(new LocationWrap());
            }
            return this.locationTreeArray.pipe(takeUntil(unsubscribe$));
        };
        this.getFloorRoomsMap = () => __awaiter(this, void 0, void 0, function* () {
            return dashboardExtObj.indexedDbRead("webexRoomsWrap");
        });
        this.setFloorRoomsMap = (webexRoomsWrap) => __awaiter(this, void 0, void 0, function* () {
            return dashboardExtObj.indexedDbAdd("webexRoomsWrap", webexRoomsWrap);
        });
        this.getLocationMap = () => {
            return this.locationMap;
        };
        this.getApiResponseErrorHandler = (unsubscribe$) => {
            if (!this.apiResponseErrorHandler) {
                this.apiResponseErrorHandler = new BehaviorSubject(null);
            }
            return this.apiResponseErrorHandler.pipe(takeUntil(unsubscribe$));
        };
        this.setApiResponseErrorHandler = (value) => {
            if (!this.apiResponseErrorHandler) {
                this.apiResponseErrorHandler = new BehaviorSubject(null);
            }
            this.apiResponseErrorHandler.next(value);
        };
        this.getLocationLoadingStatus = (unsubscribe$) => {
            if (!this.locationLoadingStatus) {
                this.locationLoadingStatus = new BehaviorSubject(null);
            }
            return this.locationLoadingStatus.pipe(takeUntil(unsubscribe$));
        };
        this.setLocationLoadingStatus = (locationLoadingStatus) => {
            if (!this.locationLoadingStatus) {
                this.locationLoadingStatus = new BehaviorSubject(null);
            }
            this.locationLoadingStatus.next(locationLoadingStatus);
        };
        this.getWebexStatus = (unsubscribe$) => {
            if (!this.webexStatus) {
                this.webexStatus = new BehaviorSubject(null);
            }
            return this.webexStatus.pipe(takeUntil(unsubscribe$));
        };
        this.setWebexStatus = (webexStatus) => {
            if (!this.webexStatus) {
                this.webexStatus = new BehaviorSubject(null);
            }
            this.webexStatus.next(webexStatus);
        };
        this.getLocationObject = (locationId) => {
            return this.getLocationObjectArray().then((locMap) => {
                return locMap.get(locationId);
            });
        };
        this.getLocationObjectArray = () => __awaiter(this, void 0, void 0, function* () {
            return dashboardExtObj.indexedDbRead("locationObjectArray");
        });
        this.setLocationObjectArray = (locationObjectArray) => __awaiter(this, void 0, void 0, function* () {
            return dashboardExtObj.indexedDbAdd("locationObjectArray", locationObjectArray);
        });
        this.setLocationArray = (value) => {
            if (!this.locationArray) {
                this.locationArray = new BehaviorSubject(new LocationWrap());
            }
            this.locationMap = value;
            this.locationArray.next(value);
        };
        this.setMongoDBIdsMap = (locationsMap) => {
            const getMongoDBIds = {};
            const keys = locationsMap.keys();
            for (let key = null; (key = keys.next());) {
                if (key.done)
                    break;
                const location = locationsMap.get(key.value);
                // Update Map for mongoDBId
                if (location.id && location.mongodbLocId) {
                    getMongoDBIds[location.id] = location.mongodbLocId
                        ? location.mongodbLocId
                        : "";
                }
            }
            if (getMongoDBIds && JSON.stringify(getMongoDBIds) !== "{}") {
                this.mongoDBIds = getMongoDBIds;
            }
            console.log("setMongoDBIdsMap call finished");
        };
        this.setGraphDBIdsMap = (locationsMap) => {
            const getGraphDBIds = {};
            const keys = locationsMap.keys();
            for (let key = null; (key = keys.next());) {
                if (key.done)
                    break;
                const location = locationsMap.get(key.value);
                // Update Map for graphDBId
                if (location.id && location.mongodbLocId) {
                    getGraphDBIds[location.mongodbLocId] = location.id
                        ? location.id
                        : "";
                }
            }
            if (getGraphDBIds && JSON.stringify(getGraphDBIds) !== "{}") {
                this.graphDBIds = getGraphDBIds;
            }
            console.log("setGraphDBIdsMap call finished");
        };
        this.setUserCountResponse = (value) => {
            if (value) {
                this.userCountResponse = value;
                localStorage.setItem("userCountResponse", JSON.stringify(value));
            }
        };
        this.getUserCountResponse = () => {
            if (JSON.stringify(this.userCountResponse) !== "{}") {
                if (typeof this.userCountResponse == "string") {
                    return JSON.parse(this.userCountResponse);
                }
                else if (typeof this.userCountResponse == "object") {
                    return this.userCountResponse;
                }
            }
            else {
                this.userCountResponse = localStorage.getItem("userCountResponse");
                return JSON.parse(this.userCountResponse);
            }
        };
        this.getLocationWrap = () => __awaiter(this, void 0, void 0, function* () {
            return dashboardExtObj.indexedDbRead("locationWrap");
        });
        this.setLocationWrap = (value) => __awaiter(this, void 0, void 0, function* () {
            if (value && value.customerName && value.location) {
                dashboardExtObj.indexedDbAdd("locationWrap", value).then(() => {
                    this.locationTreeArrayExists = true;
                    this.setLocationLoadingStatus({
                        key: "location_hierarchy",
                        status: "done",
                        time: new Date().getTime()
                    });
                });
            }
            else {
                dashboardExtObj.indexedDbAdd("locationWrap", value);
                this.locationTreeArrayExists = false;
            }
        });
        this.getLocationPartial = () => __awaiter(this, void 0, void 0, function* () {
            return dashboardExtObj.indexedDbReadAll("locationPartial");
        });
        this.getLocationPartialRow = (key) => __awaiter(this, void 0, void 0, function* () {
            return dashboardExtObj.indexedDbReadRow("locationPartial", key);
        });
        this.setLocationPartial = (locationDataPartial, key) => __awaiter(this, void 0, void 0, function* () {
            return dashboardExtObj.indexedDbPut("locationPartial", locationDataPartial, key);
        });
        this.getLocationIndexedMap = (key) => __awaiter(this, void 0, void 0, function* () {
            console.log(dashboardExtObj, key);
            return dashboardExtObj.indexedDbReadRow("locationMap", key);
        });
        this.setLocationMap = (locationDataMap, key) => __awaiter(this, void 0, void 0, function* () {
            return dashboardExtObj.indexedDbPut("locationMap", locationDataMap, key);
        });
        this.getLocationDelta = () => __awaiter(this, void 0, void 0, function* () {
            return dashboardExtObj.indexedDbReadAll("locationDelta");
        });
        this.setLocationDelta = (locationDataDelta) => __awaiter(this, void 0, void 0, function* () {
            return dashboardExtObj.indexedDbAdd("locationDelta", locationDataDelta);
        });
        this.setDBIdConversionMap = (locationsMap) => {
            const getMongoDBIds = {};
            const getGraphDBIds = {};
            const keys = locationsMap.keys();
            for (let key = null; (key = keys.next());) {
                if (key.done)
                    break;
                const location = locationsMap.get(key.value);
                // Update Map for mongoDBId
                if (location.id && location.mongodbLocId) {
                    getMongoDBIds[location.id] = location.mongodbLocId
                        ? location.mongodbLocId
                        : "";
                    getGraphDBIds[location.mongodbLocId] = location.id
                        ? location.id
                        : "";
                }
            }
            this.mongoDBIds =
                getMongoDBIds && JSON.stringify(getMongoDBIds) !== "{}"
                    ? getMongoDBIds
                    : {};
            this.graphDBIds =
                getGraphDBIds && JSON.stringify(getGraphDBIds) !== "{}"
                    ? getGraphDBIds
                    : {};
            console.log("setDBIdConversionMap call finished");
        };
        this.getMongoDBIdsMap = () => {
            return this.mongoDBIds;
        };
        this.getGraphDBIdsMap = () => {
            return this.graphDBIds;
        };
        this.getMongoDBId = (graphDBId) => {
            return this.mongoDBIds[graphDBId];
        };
        this.getMongoDBIdsArray = (graphDBIdsArray) => {
            const mongoDBIdsArray = [];
            if (graphDBIdsArray && graphDBIdsArray.length > 0) {
                graphDBIdsArray.forEach((graphDBId) => {
                    if (graphDBId) {
                        mongoDBIdsArray.push(this.mongoDBIds[graphDBId]);
                    }
                });
            }
            return mongoDBIdsArray;
        };
        this.getGraphDBId = (mongoDBId) => {
            return this.graphDBIds[mongoDBId];
        };
        this.getGraphDBIdsArray = (mongoDBIdsArray) => {
            const graphDBIdsArray = [];
            if (mongoDBIdsArray && mongoDBIdsArray.length > 0) {
                mongoDBIdsArray.forEach((mongoDBId) => {
                    if (mongoDBId) {
                        graphDBIdsArray.push(this.graphDBIds[mongoDBId]);
                    }
                });
            }
            return graphDBIdsArray;
        };
        this.getLicenseDetails = (unsubscribe$) => {
            if (!this.licenseDetails) {
                this.licenseDetails = new BehaviorSubject(new LicenseDetails());
            }
            return this.licenseDetails.pipe(takeUntil(unsubscribe$));
        };
        this.setLicenseDetails = (value) => {
            if (!this.licenseDetails) {
                this.licenseDetails = new BehaviorSubject(new LicenseDetails());
            }
            this.licenseDetails.next(value);
        };
        this.setLocationCountResponse = (value) => {
            if (value) {
                this.setInStorage("locationCountResponse", JSON.stringify(value));
            }
        };
        this.getLocationCountResponse = () => {
            // if (JSON.stringify(this.locationCountResponse) !== '{}') {
            //   if (typeof (this.locationCountResponse) == "string") {
            //     return JSON.parse(this.locationCountResponse);
            //   } else if (typeof (this.locationCountResponse) == "object") {
            //     return this.locationCountResponse;
            //   }
            // } else {
            const locationCountResponse = this.getFromStorage("locationCountResponse");
            if (locationCountResponse && locationCountResponse !== "") {
                return JSON.parse(locationCountResponse);
            }
            return null;
            // }
        };
        this.setPrevSelectedNode = (value) => {
            if (value) {
                this.prevSelectedNode = value;
            }
        };
        this.getPrevSelectedNode = () => {
            if (typeof this.prevSelectedNode == "string") {
                return JSON.parse(this.prevSelectedNode);
            }
            else if (typeof this.prevSelectedNode == "object") {
                return this.prevSelectedNode;
            }
        };
        this.setAccountServices = (services) => {
            const data = services.map((s) => s.appName);
            this.setInStorage("accountServices", JSON.stringify(data));
        };
        /**
         * returns boolean based on the service(app Name) requested
         */
        this.getAccountServices = (service) => {
            const value = this.getFromStorage("accountServices") || "[]";
            const services = JSON.parse(value) || [];
            return services.includes(service);
        };
        this.getToastMessage = (unsubscribe$) => {
            if (!DataService.toastMessage) {
                DataService.toastMessage = new BehaviorSubject(new ToastMessage(null, 0, null, null, null));
            }
            return DataService.toastMessage.pipe(takeUntil(unsubscribe$));
        };
        this.setToastMessageStatic = (message, displayForMillis, button, callbackKey, type) => {
            if (!DataService.toastMessage) {
                DataService.toastMessage = new BehaviorSubject(new ToastMessage(null, 0, null, null, null));
            }
            DataService.toastMessage.next(new ToastMessage(message, displayForMillis, button, callbackKey, type));
        };
        this.setToastMessage = (message, displayForMillis, button, callbackKey, type) => {
            if (!DataService.toastMessage) {
                DataService.toastMessage = new BehaviorSubject(new ToastMessage(null, 0, null, null, null));
            }
            DataService.toastMessage.next(new ToastMessage(message, displayForMillis, button, callbackKey, type));
        };
        this.getToastCallBack = (unsubscribe$) => {
            if (!this.toastCallBack) {
                this.toastCallBack = new BehaviorSubject("");
            }
            return this.toastCallBack.pipe(takeUntil(unsubscribe$));
        };
        this.setToastCallBack = (callbackKey) => {
            if (!this.toastCallBack) {
                this.toastCallBack = new BehaviorSubject("");
            }
            this.toastCallBack.next(callbackKey);
        };
        this.navigation = (value) => {
            const navObj = new NavToggler(false);
            navObj.setValue(value);
            this.nav.next(navObj);
        };
        this.setUserAppsList = (userAppsList) => {
            this.userAppsList = userAppsList;
            return this.userAppsList;
        };
        this.getUserAppsList = () => {
            return this.userAppsList;
        };
        this.getUserApp = (app) => {
            return this.userAppsList.includes(app);
        };
        // getAppSwitcherState = (unsubscribe$: Subject<void>) => {
        // 	if (!this.nav) {
        // 		this.nav = new BehaviorSubject<NavToggler>(new NavToggler(false));
        // 	}
        // 	return this.nav.pipe(takeUntil(unsubscribe$));
        // };
        // setAppSwitcherState = (value: string) => {
        // 	const hamObj: HamburgerPage = new HamburgerPage("");
        // 	hamObj.setValue(value);
        // 	this.hamPage.next(hamObj);
        // };
        this.getHamburgerBtnState = (unsubscribe$) => {
            if (!this.hamburgerBtn) {
                this.hamburgerBtn = new BehaviorSubject(true);
            }
            return this.hamburgerBtn.pipe(takeUntil(unsubscribe$));
        };
        this.setHamburgerBtnState = (value) => {
            if (!this.hamburgerBtn) {
                this.hamburgerBtn = new BehaviorSubject(true);
            }
            this.hamburgerBtn.next(value);
        };
        this.getHamburgerState = (unsubscribe$) => {
            if (!this.nav) {
                this.nav = new BehaviorSubject(new NavToggler(false));
            }
            return this.nav.pipe(takeUntil(unsubscribe$));
        };
        this.getHamburgerPage = (unsubscribe$) => {
            if (!this.hamPage) {
                this.hamPage = new BehaviorSubject(new HamburgerPage(""));
            }
            return this.hamPage.pipe(takeUntil(unsubscribe$));
        };
        this.setHamburgerPage = (value) => {
            const hamObj = new HamburgerPage("");
            hamObj.setValue(value);
            this.hamPage.next(hamObj);
        };
        this.setBannerState = (value) => {
            if (!this.setupBanner) {
                this.setupBanner = new BehaviorSubject(true);
            }
            this.setupBanner.next(value);
        };
        this.getBannerState = (unsubscribe$) => {
            if (!this.setupBanner) {
                this.setupBanner = new BehaviorSubject(true);
            }
            return this.setupBanner.pipe(takeUntil(unsubscribe$));
        };
        this.getAccessToken = () => {
            if (!this.accessToken) {
                this.accessToken = this.getFromStorage("accessToken");
            }
            return this.accessToken;
        };
        this.getPartnerSandboxTenantId = () => {
            if (!this.partnerSandboxTenantId) {
                this.partnerSandboxTenantId = this.getFromStorage("partnerSandboxTenantId");
            }
            return this.partnerSandboxTenantId;
        };
        this.getAdminAccess = () => {
            if (!this.adminAccess) {
                this.adminAccess = this.getFromStorage("adminAccess") === "true";
            }
            return this.adminAccess;
        };
        this.setAccessToken = ($token) => {
            this.accessToken = $token;
            this.setInStorage("accessToken", $token);
        };
        this.setUserRole = (userRole) => {
            this.userRole = userRole;
            this.getUserRoleSubscriber(null, userRole, true);
        };
        this.getUserRole = () => {
            return this.userRole;
        };
        this.setPartnerSandboxTenantId = (tenantId) => {
            this.partnerSandboxTenantId = tenantId;
            this.setInStorage("partnerSandboxTenantId", tenantId);
        };
        this.getUserRoleSubscriber = (unsubscribe$, $userRole = null, internal = false) => {
            if (!this.userRoleSubscriber) {
                this.userRoleSubscriber = new BehaviorSubject(this.userRole);
            }
            if ($userRole) {
                this.userRoleSubscriber.next($userRole);
            }
            if (internal) {
                return this.userRoleSubscriber;
            }
            else {
                return this.userRoleSubscriber.pipe(takeUntil(unsubscribe$));
            }
        };
        this.getLicenseType = () => {
            return this.licenseType;
        };
        this.setLicenseType = ($licenseType) => {
            this.licenseType = $licenseType;
            return this.licenseType;
        };
        this.setAdminAccess = ($isAdmin) => {
            this.adminAccess = $isAdmin;
            if ($isAdmin) {
                this.setInStorage("adminAccess", $isAdmin);
            }
            else {
                this.removeFromStorage("adminAccess");
            }
        };
        this.setLocationId = ($locId) => {
            this.locationId = $locId;
            this.setInStorage("locationId", $locId);
        };
        this.getLocationId = () => {
            if (!this.locationId) {
                this.locationId = this.getFromStorage("locationId") || "";
            }
            return this.locationId;
        };
        this.setSpacesLocationId = ($locId) => {
            this.spacesLocationId = $locId;
            this.setInStorage("spacesLocationId", $locId);
        };
        this.getSpacesLocationId = () => {
            if (!this.spacesLocationId) {
                this.spacesLocationId = this.getFromStorage("spacesLocationId") || "";
            }
            return this.spacesLocationId;
        };
        this.setSpacesWSResponse = ($res) => {
            this.spacesWSResponse = $res;
            // this.setInStorage("spacesWSResponse", $res);
        };
        this.getSpacesWSResponse = () => {
            // if (!this.spacesWSResponse) {
            //   this.spacesWSResponse = this.getFromStorage("spacesWSResponse") || "";
            // }
            return this.spacesWSResponse;
        };
        this.setSpacesWSConnectionStatus = (status) => {
            this.spacesWSConnectionStatus = status;
            // this.setInStorage("spacesWSConnectionStatus", status);
        };
        this.getSpacesWSConnectionStatus = () => {
            return this.spacesWSConnectionStatus;
        };
        this.getFromMail = () => {
            if (!this.isFromMail) {
                this.isFromMail = this.getFromStorage("isFromMail") === "true";
            }
            return this.isFromMail;
        };
        this.setFromMail = ($isFromMail) => {
            this.isFromMail = $isFromMail;
            this.setInStorage("isFromMail", $isFromMail);
        };
        this.getCustomerName = () => {
            if (!this.customerName) {
                this.customerName = this.getFromStorage("customerName") || "";
            }
            return this.customerName;
        };
        this.setCustomerName = ($customerName) => {
            this.customerName = $customerName;
            this.setInStorage("customerName", $customerName);
        };
        this.getCustomMenuSelectedIndex = () => {
            //  console.log('getCustomMenuSelectedIndex');
            if (!this.customMenuSelectedIndex) {
                this.customMenuSelectedIndex =
                    this.getFromStorage("customMenuSelectedIndex") || "";
            }
            return this.customMenuSelectedIndex;
        };
        this.setCustomMenuSelectedIndex = (value) => {
            //  console.log('setCustomMenuSelectedIndex'+value);
            this.customMenuSelectedIndex = value;
            this.setInStorage("customMenuSelectedIndex", value);
        };
        this.getDashboardSetupName = () => {
            if (!this.dashboardSetupName) {
                this.dashboardSetupName =
                    this.getFromStorage("dashboardSetupName") || "";
            }
            return this.dashboardSetupName;
        };
        this.setDashboardSetupName = (setupName) => {
            this.dashboardSetupName = setupName;
            this.setInStorage("dashboardSetupName", setupName);
        };
        this.getCustomerLabel = () => {
            if (!this.customerLabel) {
                this.customerLabel = this.getFromStorage("customerLabel") || "";
            }
            return this.customerLabel;
        };
        this.setCustomerLabel = (customerLabel) => {
            this.customerLabel = customerLabel;
            this.setInStorage("customerLabel", customerLabel);
        };
        this.getUserName = () => {
            if (!this.userName) {
                this.userName = this.getFromStorage("userName") || "";
            }
            return this.userName;
        };
        this.setUserName = ($userName) => {
            if ($userName) {
                this.userName = $userName.trim();
            }
            this.setInStorage("userName", $userName);
        };
        this.reSetUserName = () => {
            this.userName = "";
            this.setInStorage("userName", this.userName);
        };
        this.getShareReportSender = () => {
            if (!this.shareReportSender) {
                this.shareReportSender =
                    this.getFromStorage("shareReportSender") || "";
            }
            return this.shareReportSender;
        };
        this.setShareReportSender = ($shareReportSender) => {
            if ($shareReportSender) {
                this.shareReportSender = $shareReportSender.trim();
            }
            this.setInStorage("shareReportSender", $shareReportSender);
        };
        this.getCurrentNav = () => {
            return this.getFromStorage("currentNav");
        };
        this.getCurrentNavObervable = (unsubscribe$) => {
            if (!this.currentNav) {
                this.currentNav = new BehaviorSubject("");
            }
            return this.currentNav.pipe(takeUntil(unsubscribe$));
        };
        this.setCurrentNav = ($currentNav) => {
            if (!this.currentNav) {
                this.currentNav = new BehaviorSubject("");
            }
            if (this.getCurrentNav() !== $currentNav && $currentNav !== "/logout") {
                this.setMagneticMenuRouteUrl($currentNav);
                console.log("set naviagation ", $currentNav);
                this.currentNav.next($currentNav);
                this.setInStorage("currentNav", $currentNav);
            }
        };
        this.getAuthStatus = (unsubscribe$) => {
            if (!this.authStatus) {
                this.authStatus = new BehaviorSubject(false);
            }
            return this.authStatus.pipe(takeUntil(unsubscribe$));
        };
        this.setAuthStatus = (value) => {
            if (!this.authStatus) {
                this.authStatus = new BehaviorSubject(false);
            }
            this.authStatus.next(value);
        };
        this.getCurrentStatus = (unsubscribe$) => {
            if (!this.currentStatus) {
                this.currentStatus = new BehaviorSubject(false);
            }
            return this.currentStatus.pipe(takeUntil(unsubscribe$));
        };
        this.setCurrentStatus = (value) => {
            if (!this.currentStatus) {
                this.currentStatus = new BehaviorSubject(false);
            }
            this.currentStatus.next(value);
        };
        this.getMerakiUserName = (unsubscribe$) => {
            if (!this.merakiUserName) {
                this.merakiUserName = new BehaviorSubject(null);
            }
            return this.merakiUserName.pipe(takeUntil(unsubscribe$));
        };
        this.setMerakiUserName = (value) => {
            if (!this.merakiUserName) {
                this.merakiUserName = new BehaviorSubject(null);
            }
            this.merakiUserName.next(value);
        };
        this.getReportsHeader = (unsubscribe$) => {
            if (!this.reportsHeader) {
                this.reportsHeader = new BehaviorSubject(new ReportHeader());
            }
            return this.reportsHeader.pipe(takeUntil(unsubscribe$));
        };
        this.setReportsHeader = (value) => {
            if (!this.reportsHeader) {
                this.reportsHeader = new BehaviorSubject(new ReportHeader());
            }
            this.reportsHeader.next(value);
        };
        this.getRuleSummary = (unsubscribe$) => {
            if (!this.ruleSummary) {
                this.ruleSummary = new BehaviorSubject(null);
            }
            return this.ruleSummary.pipe(takeUntil(unsubscribe$));
        };
        this.setRuleSummary = (value) => {
            if (!this.ruleSummary) {
                this.ruleSummary = new BehaviorSubject(null);
            }
            this.ruleSummary.next(value);
        };
        this.getBreadcrumbPath = (unsubscribe$) => {
            if (!this.breadCrumbPath) {
                this.breadCrumbPath = new BehaviorSubject([]);
            }
            return this.breadCrumbPath.pipe(takeUntil(unsubscribe$));
        };
        this.setBreadcrumbPath = (value) => {
            if (!this.breadCrumbPath) {
                this.breadCrumbPath = new BehaviorSubject([]);
            }
            this.breadCrumbPath.next(value);
            // console.log('set breadcrumb path ', value);
        };
        this.getTreeState = () => {
            if (!this.treeState) {
                this.treeState = this.getFromStorage("treeState");
            }
            return this.treeState;
        };
        this.setTreeState = ($treeState) => {
            this.treeState = $treeState;
            this.setInStorage("treeState", $treeState);
        };
        this.getTempPortalConfig = () => {
            if (!this.tempPortalConfig) {
                this.tempPortalConfig = this.getFromStorage("tempPortalConfig");
            }
            return this.tempPortalConfig;
        };
        this.setTempPortalConfig = ($tempPortalConfig) => {
            this.tempPortalConfig = $tempPortalConfig;
            this.setInStorage("tempPortalConfig", $tempPortalConfig);
        };
        this.getEditUserEmail = () => {
            if (!this.editUserEmail) {
                this.editUserEmail = this.getFromStorage("editUserEmail");
            }
            return this.editUserEmail;
        };
        this.setEditUserEmail = ($editUserEmail) => {
            this.editUserEmail = $editUserEmail;
            this.setInStorage("editUserEmail", $editUserEmail);
        };
        this.getEditUserConfig = () => {
            if (!this.editUserConfig) {
                this.editUserConfig = this.getFromStorage("editUserConfig");
            }
            return this.editUserConfig;
        };
        this.setEditUserConfig = ($editUser) => {
            this.editUserConfig = $editUser;
            this.setInStorage("editUserConfig", $editUser);
        };
        this.setLocationSyncNotificationsList = (locationSyncNotificationsList) => {
            //  console.log('set syncError :: ', JSON.stringify(syncError));
            this.locationSyncNotificationsList = locationSyncNotificationsList;
        };
        this.getLocationSyncNotificationsList = () => {
            return this.locationSyncNotificationsList;
        };
        this.setSyncError = (syncError) => {
            //  console.log('set syncError :: ', JSON.stringify(syncError));
            if (syncError && JSON.stringify(syncError) !== "{}") {
                this.syncError = syncError;
            }
        };
        this.getSyncError = () => {
            return this.syncError;
        };
        this.setCurrentEditLanguage = (currentEditLanguage) => {
            console.log("set currentEditLanguage :: ", JSON.stringify(currentEditLanguage));
            if (currentEditLanguage &&
                JSON.stringify(currentEditLanguage) !== "{}") {
                this.currentEditLanguage = currentEditLanguage;
            }
        };
        this.getCurrentEditLanguage = () => {
            if (this.currentEditLanguage &&
                JSON.stringify(this.currentEditLanguage) !== "{}") {
                console.log("get syncError :: ", JSON.stringify(this.currentEditLanguage));
            }
            return this.currentEditLanguage;
        };
        this.getDashboardProperties = () => {
            return this.properties;
        };
        this.setDashboardProperties = (properties) => {
            this.properties = properties;
            return this.properties;
        };
        this.setPortalListNavState = (state) => {
            this.navFromPortalList = state;
        };
        this.getPortalListNavState = () => {
            return this.navFromPortalList;
        };
        this.setSpacesPeriod = (value) => {
            this.setInStorage("spacesPeriod", JSON.stringify(value));
            this.spacesPeriod.next(value);
        };
        this.getSpacesPeriod = (unsubscribe$) => {
            if (!this.spacesPeriod) {
                this.spacesPeriod = new BehaviorSubject(null);
            }
            return this.spacesPeriod.pipe(takeUntil(unsubscribe$));
        };
        this.setSpacesObject = (value) => {
            this.setInStorage("spacesObj", JSON.stringify(value));
            this.spacesObj.next(value);
        };
        this.getSpacesObject = (unsubscribe$) => {
            if (!this.spacesObj) {
                this.spacesObj = new BehaviorSubject(null);
            }
            return this.spacesObj.pipe(takeUntil(unsubscribe$));
        };
        this.setSpaceUtilizationReportsObject = (value) => {
            this.setInStorage("spaceReportObject", JSON.stringify(value));
            this.spaceReportObject.next(value);
        };
        this.getSpaceUtilizationReportsObject = (unsubscribe$) => {
            if (!this.spaceReportObject) {
                this.spaceReportObject = new BehaviorSubject(null);
            }
            return this.spaceReportObject.pipe(takeUntil(unsubscribe$));
        };
        this.setVideoAnalyticsObject = (value) => {
            this.setInStorage("videoAnalyticsObj", JSON.stringify(value));
            this.videoAnalyticsObj.next(value);
        };
        this.getVideoAnalyticsObject = (unsubscribe$) => {
            if (!this.videoAnalyticsObj) {
                this.videoAnalyticsObj = new BehaviorSubject(null);
            }
            return this.videoAnalyticsObj.pipe(takeUntil(unsubscribe$));
        };
        this.setIAObject = (value) => {
            this.setInStorage("impactAnalysisObj", JSON.stringify(value));
            this.impactAnalysisObj.next(value);
        };
        this.getIAObject = (unsubscribe$) => {
            if (!this.impactAnalysisObj) {
                this.impactAnalysisObj = new BehaviorSubject(null);
            }
            return this.impactAnalysisObj.pipe(takeUntil(unsubscribe$));
        };
        this.setImpacts = (value) => {
            this.setInStorage("impacts", JSON.stringify(value));
            this.impactObj.next(value);
        };
        this.getImpacts = (unsubscribe$) => {
            if (!this.impactObj) {
                this.impactObj = new BehaviorSubject(null);
            }
            return this.impactObj.pipe(takeUntil(unsubscribe$));
        };
        this.setShareFeedbackStatus = (value) => {
            this.setInStorage("shareFeedback", JSON.stringify(value));
            this.shareFeedbackObj.next(value);
        };
        // getShareFeedbackStatus = (unsubscribe$: Subject<void>) => {
        //     if (!this.shareFeedbackObj) { this.shareFeedbackObj = new BehaviorSubject<any>(null); }
        //     return this.shareFeedbackObj.pipe(takeUntil(unsubscribe$));
        // }
        this.setUpdatedEvent = (value) => {
            this.updatedEvent.next(value);
        };
        this.getUpdatedEvent = (unsubscribe$) => {
            if (!this.updatedEvent) {
                this.updatedEvent = new BehaviorSubject(null);
            }
            return this.updatedEvent.pipe(takeUntil(unsubscribe$));
        };
        this.setShareTimer = (value) => {
            this.shareTimer.next(value);
        };
        this.getShareTimer = (unsubscribe$) => {
            if (!this.shareTimer) {
                this.shareTimer = new BehaviorSubject(0);
            }
            return this.shareTimer.pipe(takeUntil(unsubscribe$));
        };
        // setShareTimer = (value: any) => {
        //     this.shareTimer.next(value);
        // };
        // getShareTimer = (unsubscribe$: Subject<void>) => {
        //     if (!this.shareTimer) { this.shareTimer = new BehaviorSubject<number>(0); }
        //     return this.shareTimer.pipe(takeUntil(unsubscribe$));
        // }
        this.getIsEventUpdated = (unsubscribe$) => {
            if (!this.iseventUpdated) {
                this.iseventUpdated = new BehaviorSubject(false);
            }
            return this.iseventUpdated.pipe(takeUntil(unsubscribe$));
        };
        this.setIsEventUpdated = (eventUpdated) => {
            this.iseventUpdated.next(eventUpdated);
        };
        this.getShareButtonStatus = (unsubscribe$) => {
            if (!this.shareButtonStatus) {
                this.shareButtonStatus = new BehaviorSubject(false);
            }
            return this.shareButtonStatus.pipe(takeUntil(unsubscribe$));
        };
        this.setShareButtonStatus = (shareButtonStatus) => {
            this.shareButtonStatus.next(shareButtonStatus);
        };
        this.setBiExcludedLocObj = (value) => {
            this.setInStorage("biExcludedLocObj", JSON.stringify(value));
            this.biExcludedLocObj.next(value);
        };
        this.getBiExcludedLocObj = (unsubscribe$) => {
            if (!this.biExcludedLocObj) {
                this.biExcludedLocObj = new BehaviorSubject(null);
            }
            return this.biExcludedLocObj.pipe(takeUntil(unsubscribe$));
        };
        this.setSpacesLocation = (value) => {
            this.setInStorage("spacesLocation", JSON.stringify(value));
            this.spacesLocation.next(value);
        };
        this.getSpacesLocation = (unsubscribe$) => {
            if (!this.spacesLocation) {
                this.spacesLocation = new BehaviorSubject(null);
            }
            return this.spacesLocation.pipe(takeUntil(unsubscribe$));
        };
        this.setLocationNameMap = (value) => {
            this.locationNameMap.next(value);
        };
        this.getLocationNameMap = (unsubscribe$) => {
            if (!this.locationNameMap) {
                this.locationNameMap = new BehaviorSubject(null);
            }
            return this.locationNameMap.pipe(takeUntil(unsubscribe$));
        };
        this.setBiTags = (value) => {
            this.biTags.next(value);
        };
        this.getBiTags = (unsubscribe$) => {
            if (!this.biTags) {
                this.biTags = new BehaviorSubject(null);
            }
            return this.biTags.pipe(takeUntil(unsubscribe$));
        };
        this.setRightNowTags = (value) => {
            this.rightNowTags.next(value);
        };
        this.getRightNowTags = (unsubscribe$) => {
            if (!this.rightNowTags)
                this.rightNowTags = new BehaviorSubject(null);
            return this.rightNowTags.pipe(takeUntil(unsubscribe$));
        };
        this.setOutlierLocations = (value) => {
            this.outlierLocations = value;
        };
        this.getOutlierLocations = () => {
            return this.outlierLocations;
        };
        this.setSpacesLocationList = (value) => {
            this.spacesLocationList.next(value);
        };
        this.getSpacesLocationList = (unsubscribe$) => {
            if (!this.spacesLocationList) {
                this.spacesLocationList = new BehaviorSubject(null);
            }
            return this.spacesLocationList.pipe(takeUntil(unsubscribe$));
        };
        this.setRightNowLocationList = (value) => {
            this.rightNowLocationList.next(value);
        };
        this.getRightNowLocationList = (unsubscribe$) => {
            if (!this.rightNowLocationList)
                this.rightNowLocationList = new BehaviorSubject(null);
            return this.rightNowLocationList.pipe(takeUntil(unsubscribe$));
        };
        this.setEnergyUtilLocationList = (value) => {
            this.energyUtilLocationList.next(value);
        };
        this.getEnergyUtilLocationList = (unsubscribe$) => {
            if (!this.energyUtilLocationList)
                this.energyUtilLocationList = new BehaviorSubject(null);
            return this.energyUtilLocationList.pipe(takeUntil(unsubscribe$));
        };
        this.setSetupTaskObserver = (value) => {
            if (!this.setupTaskObserver) {
                this.setupTaskObserver = new BehaviorSubject(null);
            }
            this.setupTaskObserver.next(value);
        };
        this.getSetupTaskObserver = (unsubscribe$) => {
            if (!this.setupTaskObserver) {
                this.setupTaskObserver = new BehaviorSubject(null);
            }
            return this.setupTaskObserver.pipe(takeUntil(unsubscribe$));
        };
        this.setMetricGroup = (value) => {
            this.setInStorage("metricGroup", value);
            this.metricGroup.next(value);
        };
        this.getMetricGroup = (unsubscribe$) => {
            if (!this.metricGroup) {
                this.metricGroup = new BehaviorSubject("");
            }
            return this.metricGroup.pipe(takeUntil(unsubscribe$));
        };
        this.setMetricSubGroup = (value) => {
            this.setInStorage("metricSubGroup", value);
            this.metricSubGroup.next(value);
        };
        this.getMetricSubGroup = (unsubscribe$) => {
            if (!this.metricSubGroup) {
                this.metricSubGroup = new BehaviorSubject("");
            }
            return this.metricSubGroup.pipe(takeUntil(unsubscribe$));
        };
        this.setSearchGodDashboard = (value) => {
            this.searchGodDashboard.next(value);
        };
        this.getSearchGodDashboard = (unsubscribe$) => {
            if (!this.searchGodDashboard) {
                this.searchGodDashboard = new BehaviorSubject("");
            }
            return this.searchGodDashboard.pipe(takeUntil(unsubscribe$));
        };
        this.setImpactAnalysisSearch = (value) => {
            this.impactAnalysisSearch.next(value);
        };
        this.getImpactAnalysisSearch = (unsubscribe$) => {
            if (!this.impactAnalysisSearch) {
                this.impactAnalysisSearch = new BehaviorSubject("");
            }
            return this.impactAnalysisSearch.pipe(takeUntil(unsubscribe$));
        };
        this.setGodDashboardCustomerList = (godDashboardCustomerList) => {
            this.godDashboardCustomerList = godDashboardCustomerList;
        };
        this.getGodDashboardCustomerList = () => {
            return this.godDashboardCustomerList;
        };
        this.getIsDummy = () => {
            return this.isDummy ? this.isDummy : null;
        };
        this.setIsDummy = (dummy) => {
            this.isDummy = dummy;
        };
        this.getIsCameraMetricsDummy = () => {
            return this.isCMDummy ? this.isCMDummy : null;
        };
        this.setIsCameraMetricsDummy = (dummy) => {
            this.isCMDummy = dummy;
        };
        this.getIsEnergyDataDummy = () => {
            return this.isEUDummy ? this.isEUDummy : null;
        };
        this.setIsEnergyDataDummy = (dummy) => {
            this.isEUDummy = dummy;
        };
        this.getIsMenuClicked = (unsubscribe$) => {
            if (!this.showNav) {
                this.showNav = new BehaviorSubject(false);
            }
            return this.showNav.pipe(takeUntil(unsubscribe$));
        };
        this.setIsMenuClicked = (showNav) => {
            this.showNav.next(showNav);
        };
        this.getIsSampleData = (unsubscribe$) => {
            if (!this.isSampleData) {
                this.isSampleData = new BehaviorSubject(false);
            }
            return this.isSampleData.pipe(takeUntil(unsubscribe$));
        };
        this.setIsSampleData = (value) => {
            this.isSampleData.next(value);
        };
        this.setSharePluginObject = (value) => {
            this.sharePluginObject = value;
        };
        this.getSharePluginObject = () => {
            return this.sharePluginObject;
        };
        this.getIsGrantAccess = (unsubscribe$) => {
            if (!this.isGrantAccess) {
                this.isGrantAccess = new BehaviorSubject(false);
            }
            return this.isGrantAccess.pipe(takeUntil(unsubscribe$));
        };
        this.setisGrantAccess = (value) => {
            this.isGrantAccess.next(value);
        };
        // getIsUnAuthorised = (unsubscribe$: Subject<void>) => {
        //     if (!this.isUnAuthorised) { this.isUnAuthorised = new BehaviorSubject<boolean>(null); }
        //     return this.isUnAuthorised.pipe(takeUntil(unsubscribe$));
        // }
        // setIsUnAuthorised = (value: boolean) => {
        //     this.isUnAuthorised.next(value);
        // }
        this.getResetPINEmail = (unsubscribe$) => {
            if (!this.resetPINEmailAddress) {
                this.resetPINEmailAddress = new BehaviorSubject(null);
            }
            return this.resetPINEmailAddress.pipe(takeUntil(unsubscribe$));
        };
        this.setIsResetPIN = (value) => {
            this.resetPINEmailAddress.next(value);
        };
        this.getIsCameraMetricsSampleData = (unsubscribe$) => {
            if (!this.isCMSampleData) {
                this.isCMSampleData = new BehaviorSubject(false);
            }
            return this.isCMSampleData.pipe(takeUntil(unsubscribe$));
        };
        this.setIsCameraMetricsSampleData = (value) => {
            this.isCMSampleData.next(value);
        };
        this.getIsEUSampleData = (unsubscribe$) => {
            if (!this.isEUSampleData) {
                this.isEUSampleData = new BehaviorSubject(false);
            }
            return this.isEUSampleData.pipe(takeUntil(unsubscribe$));
        };
        this.setIsEUSampleData = (value) => {
            this.isEUSampleData.next(value);
        };
        this.getCustomerCategory = () => {
            return this.customerCategory ? this.customerCategory : null;
        };
        this.setCustomerCategory = (customerCategory) => {
            this.customerCategory = customerCategory;
        };
        this.getShowDataExportTab = () => {
            return this.showDataExportTab;
        };
        this.setShowDataExportTab = (value) => {
            this.showDataExportTab = value;
        };
        this.getDnaSpacesHomeSetup = () => {
            return this.dnaSpacesHomeSetup;
        };
        this.setDnaSpacesHomeSetup = (value) => {
            this.dnaSpacesHomeSetup = value;
        };
        this.getBusinessLocationList = () => {
            return this.businessLocationList;
        };
        this.setBusinessLocationList = (value) => {
            this.businessLocationList = value;
        };
        this.getHomePageNavigations = () => {
            return this.homePageNavigations;
        };
        this.setHomePageNavigations = (value) => {
            this.homePageNavigations = value;
        };
        this.getCPPageNavigations = () => {
            return this.cpPageNavigations;
        };
        this.setCPPageNavigations = (value) => {
            this.cpPageNavigations = value;
        };
        this.getBusinessSettings = () => {
            return this.businessSettings;
        };
        this.setBusinessSettings = (value) => {
            this.businessSettings = value;
        };
        this.setLocationAnalyticsFromSetup = (value) => {
            if (!this.locationAnalyticsFromSetup) {
                this.locationAnalyticsFromSetup = new BehaviorSubject(null);
            }
            this.locationAnalyticsFromSetup.next(value);
        };
        this.getLocationAnalyticsFromSetup = (unsubscribe$) => {
            if (!this.locationAnalyticsFromSetup) {
                this.locationAnalyticsFromSetup = new BehaviorSubject(null);
            }
            return this.locationAnalyticsFromSetup.pipe(takeUntil(unsubscribe$));
        };
        this.setBiTopThreeLocIds = (value) => {
            this.biTopThreeLocIds = value;
        };
        this.getBiTopThreeLocIds = () => {
            return this.biTopThreeLocIds;
        };
        this.setBiBottomThreeLocIds = (value) => {
            this.biBottomThreeLocIds = value;
        };
        this.getBiBottomThreeLocIds = () => {
            return this.biBottomThreeLocIds;
        };
        this.setBiTopAndBottomLocations = (value) => {
            this.biTopAndBottomLocations = value;
        };
        this.getBiTopAndBottomLocations = () => {
            return this.biTopAndBottomLocations;
        };
        this.setBiSignificantRankLocations = (value) => {
            this.biSignificantRankLocations = value;
        };
        this.getBiSignificantRankLocations = () => {
            return this.biSignificantRankLocations;
        };
        this.setDeleteAnalyticsReports = (value) => {
            this.deleteAnalyticsReports.next(value);
        };
        this.getDeleteAnalyticsReports = (unsubscribe$) => {
            if (!this.deleteAnalyticsReports) {
                this.deleteAnalyticsReports = new BehaviorSubject(null);
            }
            return this.deleteAnalyticsReports.pipe(takeUntil(unsubscribe$));
        };
        this.setUpdateAnalyticsReports = (value) => {
            this.updateAnalyticsReports.next(value);
        };
        this.getUpdateAnalyticsReports = (unsubscribe$) => {
            if (!this.updateAnalyticsReports) {
                this.updateAnalyticsReports = new BehaviorSubject(null);
            }
            return this.updateAnalyticsReports.pipe(takeUntil(unsubscribe$));
        };
        this.setUpdateAnalyticsReportDetails = (value) => {
            this.updateAnalyticsReportDetails.next(value);
        };
        this.getUpdateAnalyticsReportDetails = (unsubscribe$) => {
            if (!this.updateAnalyticsReportDetails) {
                this.updateAnalyticsReportDetails = new BehaviorSubject(null);
            }
            return this.updateAnalyticsReportDetails.pipe(takeUntil(unsubscribe$));
        };
        this.setEditAnalyticsReport = (value) => {
            this.editAnalyticsReport.next(value);
        };
        this.getEditAnalyticsReport = (unsubscribe$) => {
            if (!this.editAnalyticsReport) {
                this.editAnalyticsReport = new BehaviorSubject(null);
            }
            return this.editAnalyticsReport.pipe(takeUntil(unsubscribe$));
        };
        this.setPartnerOAuthState = (state) => {
            this.partnerOAuthState = state;
            this.setInStorage("state", state);
        };
        this.getPartnerOAuthState = () => {
            if (!this.partnerOAuthState) {
                this.partnerOAuthState = this.getFromStorage("state") || "";
            }
            return this.partnerOAuthState;
        };
        this.setLocAnalyticsPopupOpen = (value) => {
            this.locAnalyticsPopupOpen.next(value);
        };
        this.getLocAnalyticsPopupOpen = (unsubscribe$) => {
            if (!this.locAnalyticsPopupOpen) {
                this.locAnalyticsPopupOpen = new BehaviorSubject(false);
            }
            return this.locAnalyticsPopupOpen.pipe(takeUntil(unsubscribe$));
        };
        this.getIsAuthSSO = (unsubscribe$) => {
            if (!this.isAuthSSO) {
                this.isAuthSSO = new BehaviorSubject(false);
            }
            return this.isAuthSSO.pipe(takeUntil(unsubscribe$));
        };
        this.setIsAuthSSO = (isSSO) => {
            this.isAuthSSO.next(isSSO);
        };
        this.getIsAdminUser = (unsubscribe$) => {
            if (!this.isAdminUser) {
                this.isAdminUser = new BehaviorSubject(false);
            }
            return this.isAdminUser.pipe(takeUntil(unsubscribe$));
        };
        this.setIsAdminUser = (isAdminUser) => {
            this.isAdminUser.next(isAdminUser);
            this.setInStorage("appSwitcherUserStatus", isAdminUser);
        };
        this.getManageUser = (unsubscribe$) => {
            if (!this.isManageUser) {
                this.isManageUser = new BehaviorSubject(false);
            }
            return this.isManageUser.pipe(takeUntil(unsubscribe$));
        };
        this.setIsManageUser = (isManageUser) => {
            this.isManageUser.next(isManageUser);
        };
        this.getComingFromSetupPage = () => {
            return this.comingFromSetupPage;
        };
        this.setComingFromSetupPage = (value) => {
            this.comingFromSetupPage = value;
        };
        this.getMerakiLoginAuthenticated = (unsubscribe$) => {
            if (!this.merakiLoginAuthenticated) {
                this.merakiLoginAuthenticated = new BehaviorSubject(false);
            }
            return this.merakiLoginAuthenticated.pipe(takeUntil(unsubscribe$));
        };
        this.setMerakiLoginAuthenticated = (value) => {
            this.merakiLoginAuthenticated.next(value);
        };
        this.getCustomerAccNo = (unsubscribe$) => {
            if (!this.customerAccNo) {
                this.customerAccNo = new BehaviorSubject(false);
            }
            return this.customerAccNo.pipe(takeUntil(unsubscribe$));
        };
        this.setCustomerAccNo = (customerAccNo) => {
            this.customerAccNo.next(customerAccNo);
        };
        this.getActivationUserType = () => {
            return this.activateUserType;
        };
        this.setActivationUserType = (activateUserType = "") => {
            this.activateUserType = activateUserType;
        };
        this.getShowIntegrations = () => {
            if (this.getFromStorage("showIntegrations") !== null &&
                this.getFromStorage("showIntegrations") !== undefined) {
                this.showIntegrations = this.getFromStorage("showIntegrations");
            }
            return JSON.parse(this.showIntegrations);
        };
        this.setShowIntegrations = (show) => {
            this.showIntegrations = show;
            this.setInStorage("showIntegrations", show);
        };
        this.getEnableServiceNow = () => {
            if (this.getFromStorage("enableServiceNow") !== null &&
                this.getFromStorage("enableServiceNow") !== undefined) {
                this.enableServiceNow = this.getFromStorage("enableServiceNow");
            }
            return JSON.parse(this.enableServiceNow);
        };
        this.setEnableServiceNow = (show) => {
            this.enableServiceNow = show;
            this.setInStorage("enableServiceNow", show);
        };
        this.getServiceNowDefaultTenants = () => {
            if (this.getFromStorage("serviceNowDefaultTenants") !== null &&
                this.getFromStorage("serviceNowDefaultTenants") !== undefined) {
                this.serviceNowDefaultTenants = this.getFromStorage("serviceNowDefaultTenants");
            }
            return this.serviceNowDefaultTenants;
        };
        this.setServiceNowDefaultTenants = (tenants) => {
            this.serviceNowDefaultTenants = tenants;
            this.setInStorage("serviceNowDefaultTenants", tenants);
        };
        this.getTilesData = (unsubscribe$) => {
            if (!this.tilesData) {
                this.tilesData = new BehaviorSubject([]);
            }
            return this.tilesData.pipe(takeUntil(unsubscribe$));
        };
        this.setTilesData = (tilesData) => {
            this.tilesData.next(tilesData);
        };
        this.setMerakiSyncStatus = (value) => {
            if (value) {
                this.merakiSyncStatus = new BehaviorSubject(null);
            }
            this.merakiSyncStatus.next(value);
        };
        this.getMerakiSyncStatus = (unsubscribe$) => {
            if (!this.merakiSyncStatus) {
                this.merakiSyncStatus = new BehaviorSubject(null);
            }
            return this.merakiSyncStatus.pipe(takeUntil(unsubscribe$));
        };
        this.setIsServiceEnableMerakiLogin = (value) => {
            if (!this.isServiceEnableMerakiLogin) {
                this.isServiceEnableMerakiLogin = new BehaviorSubject(null);
            }
            this.isServiceEnableMerakiLogin.next(value);
        };
        this.getServiceEnableMerakiLogin = (unsubscribe$) => {
            if (!this.isServiceEnableMerakiLogin) {
                this.isServiceEnableMerakiLogin = new BehaviorSubject(null);
            }
            return this.isServiceEnableMerakiLogin.pipe(takeUntil(unsubscribe$));
        };
        this.setIsServiceEnableMerakiApi = (value) => {
            if (!this.isServiceEnableMerakiAPI) {
                this.isServiceEnableMerakiAPI = new BehaviorSubject(null);
            }
            this.isServiceEnableMerakiAPI.next(value);
        };
        this.getServiceEnableMerakiApi = (unsubscribe$) => {
            if (!this.isServiceEnableMerakiAPI) {
                this.isServiceEnableMerakiAPI = new BehaviorSubject(null);
            }
            return this.isServiceEnableMerakiAPI.pipe(takeUntil(unsubscribe$));
        };
        this.getRuleName = (unsubscribe$) => {
            if (!this.ruleName) {
                this.ruleName = new BehaviorSubject(null);
            }
            return this.ruleName.pipe(takeUntil(unsubscribe$));
        };
        this.setRuleName = (value) => {
            if (!this.ruleName) {
                this.ruleName = new BehaviorSubject(null);
            }
            this.ruleName.next(value);
        };
        this.setSmartLicenseRegistered = (registered) => {
            this.isSmartLicenseRegistered = registered;
        };
        this.getSmartLicenseRegistered = () => {
            return this.isSmartLicenseRegistered;
        };
        this.setIslicensePage = (isLicensePage) => {
            this.isLicensePage = isLicensePage;
        };
        this.getIslicensePage = () => {
            return this.isLicensePage;
        };
        this.getQueryParam = (unsubscribe$) => {
            if (!this.queryParam) {
                this.queryParam = new BehaviorSubject("");
            }
            return this.queryParam.pipe(takeUntil(unsubscribe$));
        };
        this.setQueryParam = (queryParam) => {
            this.queryParam.next(queryParam);
        };
        this.getOpenLocationMenu = () => {
            return this.openLocationMenu;
        };
        this.setOpenLocationMenu = (openLocationMenu) => {
            this.openLocationMenu = openLocationMenu;
        };
        this.getEnableORSetupWidget = () => {
            return this.enableORSetup;
        };
        this.setEnableORSetupWidget = (enableORSetup) => {
            this.enableORSetup = enableORSetup;
        };
        // ######################### Open-roaming RBAC starting  #########################
        this.getAuthSsoForOR = (unsubscribe$) => {
            if (!this.isAuthSSOForOR) {
                this.isAuthSSOForOR = new BehaviorSubject(false);
            }
            return this.isAuthSSOForOR.pipe(takeUntil(unsubscribe$));
        };
        this.setAuthSsoForOR = (isSSO) => {
            this.isAuthSSOForOR.next(isSSO);
        };
        this.getManageUserForOR = (unsubscribe$) => {
            if (!this.isManageUserForOR) {
                this.isManageUserForOR = new BehaviorSubject(false);
            }
            return this.isManageUserForOR.pipe(takeUntil(unsubscribe$));
        };
        this.setManageUserForOR = (isManageUser) => {
            this.isManageUserForOR.next(isManageUser);
        };
        this.getCustomerAccNoForOR = (unsubscribe$) => {
            if (!this.customerAccNoForOR) {
                this.customerAccNoForOR = new BehaviorSubject(false);
            }
            return this.customerAccNoForOR.pipe(takeUntil(unsubscribe$));
        };
        this.setCustomerAccNoForOR = (customerAccNo) => {
            this.customerAccNoForOR.next(customerAccNo);
        };
        this.setUserRoleForOR = (userRole) => {
            this.userRoleForOR = userRole;
            this.getUserRoleSubscriberForOR(null, userRole, true);
        };
        this.getUserRoleForOR = () => {
            return this.userRoleForOR;
        };
        this.getUserRoleSubscriberForOR = (unsubscribe$, $userRole, internal = false) => {
            if (!this.userRoleSubscriberForOR) {
                this.userRoleSubscriberForOR =
                    new BehaviorSubject(this.userRole);
            }
            if ($userRole) {
                this.userRoleSubscriberForOR.next($userRole);
            }
            if (internal) {
                return this.userRoleSubscriberForOR;
            }
            else {
                return this.userRoleSubscriberForOR.pipe(takeUntil(unsubscribe$));
            }
        };
        // #########################   Open-roaming RBAC ending   #########################
        // ######################### PERSONAS RBAC starting  #########################
        this.getAuthSsoForPersonas = (unsubscribe$) => {
            if (!this.isAuthSSOForPersonas) {
                this.isAuthSSOForPersonas = new BehaviorSubject(false);
            }
            return this.isAuthSSOForPersonas.pipe(takeUntil(unsubscribe$));
        };
        this.setAuthSsoForPersonas = (isSSO) => {
            this.isAuthSSOForPersonas.next(isSSO);
        };
        this.getManageUserForPersonas = (unsubscribe$) => {
            if (!this.isManageUserForPersonas) {
                this.isManageUserForPersonas = new BehaviorSubject(false);
            }
            return this.isManageUserForPersonas.pipe(takeUntil(unsubscribe$));
        };
        this.setManageUserForPersonas = (isManageUser) => {
            this.isManageUserForPersonas.next(isManageUser);
        };
        this.getCustomerAccNoForPersonas = (unsubscribe$) => {
            if (!this.customerAccNoForPersonas) {
                this.customerAccNoForPersonas = new BehaviorSubject(false);
            }
            return this.customerAccNoForPersonas.pipe(takeUntil(unsubscribe$));
        };
        this.setCustomerAccNoForPersonas = (customerAccNo) => {
            this.customerAccNoForPersonas.next(customerAccNo);
        };
        this.getCustomerAccNoForSignage = (unsubscribe$) => {
            if (!this.customerAccNoForSignage) {
                this.customerAccNoForSignage = new BehaviorSubject(false);
            }
            return this.customerAccNoForSignage.pipe(takeUntil(unsubscribe$));
        };
        this.setCustomerAccNoForSignage = (customerAccNo) => {
            this.customerAccNoForSignage.next(customerAccNo);
        };
        this.getCustomerAccNoForWorkspace = (unsubscribe$) => {
            if (!this.customerAccNoForWorkspace) {
                this.customerAccNoForWorkspace = new BehaviorSubject(false);
            }
            return this.customerAccNoForWorkspace.pipe(takeUntil(unsubscribe$));
        };
        this.setCustomerAccNoForWorkspace = (customerAccNo) => {
            this.customerAccNoForWorkspace.next(customerAccNo);
        };
        this.setUserRoleForPersonas = (userRole) => {
            this.userRoleForPersonas = userRole;
            this.getUserRoleSubscriberForPersonas(null, userRole, true);
        };
        this.getUserRoleForPersonas = () => {
            return this.userRoleForPersonas;
        };
        this.getUserRoleSubscriberForPersonas = (unsubscribe$, $userRole, internal = false) => {
            if (!this.userRoleSubscriberForPersonas) {
                this.userRoleSubscriberForPersonas =
                    new BehaviorSubject(this.userRole);
            }
            if ($userRole) {
                this.userRoleSubscriberForPersonas.next($userRole);
            }
            if (internal) {
                return this.userRoleSubscriberForPersonas;
            }
            else {
                return this.userRoleSubscriberForPersonas.pipe(takeUntil(unsubscribe$));
            }
        };
        // #########################   PERSONAS RBAC ending   #########################
        // ######################### Engagements RBAC starting  #########################
        this.getAuthSsoForEngagements = (unsubscribe$) => {
            if (!this.isAuthSSOForEngagements) {
                this.isAuthSSOForEngagements = new BehaviorSubject(false);
            }
            return this.isAuthSSOForEngagements.pipe(takeUntil(unsubscribe$));
        };
        this.setAuthSsoForEngagements = (isSSO) => {
            this.isAuthSSOForEngagements.next(isSSO);
        };
        this.getAuthSsoForSignage = (unsubscribe$) => {
            if (!this.isAuthSSOForSignage) {
                this.isAuthSSOForSignage = new BehaviorSubject(false);
            }
            return this.isAuthSSOForSignage.pipe(takeUntil(unsubscribe$));
        };
        this.setAuthSsoForSignage = (isSSO) => {
            this.isAuthSSOForSignage.next(isSSO);
        };
        this.getAuthSsoForWorkspace = (unsubscribe$) => {
            if (!this.isAuthSSOForWorkspace) {
                this.isAuthSSOForWorkspace = new BehaviorSubject(false);
            }
            return this.isAuthSSOForWorkspace.pipe(takeUntil(unsubscribe$));
        };
        this.setAuthSsoForWorkspace = (isSSO) => {
            this.isAuthSSOForWorkspace.next(isSSO);
        };
        this.getManageUserForEngagements = (unsubscribe$) => {
            if (!this.isManageUserForEngagements) {
                this.isManageUserForEngagements = new BehaviorSubject(false);
            }
            return this.isManageUserForEngagements.pipe(takeUntil(unsubscribe$));
        };
        this.setManageUserForEngagements = (isManageUser) => {
            this.isManageUserForEngagements.next(isManageUser);
        };
        this.getManageUserForSignage = (unsubscribe$) => {
            if (!this.isManageUserForSignage) {
                this.isManageUserForSignage = new BehaviorSubject(false);
            }
            return this.isManageUserForSignage.pipe(takeUntil(unsubscribe$));
        };
        this.setManageUserForSignage = (isManageUser) => {
            this.isManageUserForSignage.next(isManageUser);
        };
        this.getManageUserForWorkspace = (unsubscribe$) => {
            if (!this.isManageUserForWorkspace) {
                this.isManageUserForWorkspace = new BehaviorSubject(false);
            }
            return this.isManageUserForWorkspace.pipe(takeUntil(unsubscribe$));
        };
        this.setManageUserForWorkspace = (isManageUser) => {
            this.isManageUserForWorkspace.next(isManageUser);
        };
        this.getCustomerAccNoForEngagements = (unsubscribe$) => {
            if (!this.customerAccNoForEngagements) {
                this.customerAccNoForEngagements = new BehaviorSubject(false);
            }
            return this.customerAccNoForEngagements.pipe(takeUntil(unsubscribe$));
        };
        this.setCustomerAccNoForEngagements = (customerAccNo) => {
            this.customerAccNoForEngagements.next(customerAccNo);
        };
        this.setUserRoleForEngagements = (userRole) => {
            this.userRoleForEngagements = userRole;
            this.getUserRoleSubscriberForEngagements(null, userRole, true);
        };
        this.getUserRoleForEngagements = () => {
            return this.userRoleForEngagements;
        };
        this.setUserRoleForSignage = (userRole) => {
            this.userRoleForSignage = userRole;
            this.getUserRoleSubscriberForSignage(null, userRole, true);
        };
        this.getUserRoleForSignage = () => {
            return this.userRoleForSignage;
        };
        this.setUserRoleForWorkspace = (userRole) => {
            this.userRoleForWorkspace = userRole;
            this.getUserRoleSubscriberForWorkspace(null, userRole, true);
        };
        this.getUserRoleForWorkspace = () => {
            return this.userRoleForWorkspace;
        };
        // setEnergyUtilSearch = (value: string) => {
        // 	this.energyUtilSearch.next(value);
        // };
        // getEnergyUtilSearch = (unsubscribe$: Subject<void>) => {
        // 	if (!this.energyUtilSearch) {
        // 		this.energyUtilSearch = new BehaviorSubject<string>("");
        // 	}
        // 	return this.energyUtilSearch.pipe(takeUntil(unsubscribe$));
        // };
        this.getUserRoleSubscriberForEngagements = (unsubscribe$, $userRole, internal = false) => {
            if (!this.userRoleSubscriberForEngagements) {
                this.userRoleSubscriberForEngagements =
                    new BehaviorSubject(this.userRole);
            }
            if ($userRole) {
                this.userRoleSubscriberForEngagements.next($userRole);
            }
            if (internal) {
                return this.userRoleSubscriberForEngagements;
            }
            else {
                return this.userRoleSubscriberForEngagements.pipe(takeUntil(unsubscribe$));
            }
        };
        this.getUserRoleSubscriberForSignage = (unsubscribe$, $userRole, internal = false) => {
            if (!this.userRoleSubscriberForSignage) {
                this.userRoleSubscriberForSignage =
                    new BehaviorSubject(this.userRole);
            }
            if ($userRole) {
                this.userRoleSubscriberForSignage.next($userRole);
            }
            if (internal) {
                return this.userRoleSubscriberForSignage;
            }
            else {
                return this.userRoleSubscriberForSignage.pipe(takeUntil(unsubscribe$));
            }
        };
        // #########################   Engagements RBAC ending   #########################
        this.getUserRoleSubscriberForWorkspace = (unsubscribe$, $userRole, internal = false) => {
            if (!this.userRoleSubscriberForWorkspace) {
                this.userRoleSubscriberForWorkspace =
                    new BehaviorSubject(this.userRole);
            }
            if ($userRole) {
                this.userRoleSubscriberForWorkspace.next($userRole);
            }
            if (internal) {
                return this.userRoleSubscriberForWorkspace;
            }
            else {
                return this.userRoleSubscriberForWorkspace.pipe(takeUntil(unsubscribe$));
            }
        };
        this.getLocationSetStatus = (unsubscribe$) => {
            if (!this.locationSetStatus) {
                this.locationSetStatus = new BehaviorSubject(null);
            }
            return this.locationSetStatus.pipe(takeUntil(unsubscribe$));
        };
        this.setLocationSetStatus = (locationSetStatus) => {
            this.locationSetStatus.next(locationSetStatus);
        };
        this.getLocLoadingStarted = (unsubscribe$) => {
            if (!this.locLoadingStarted) {
                this.locLoadingStarted = new BehaviorSubject(false);
            }
            return this.locLoadingStarted.pipe(takeUntil(unsubscribe$));
        };
        this.setLocLoadingStarted = (val) => {
            this.locLoadingStarted.next(val);
        };
        this.getDeltaUpdateEvt = (unsubscribe$) => {
            if (!this.deltaUpdateEvt) {
                this.deltaUpdateEvt = new BehaviorSubject(null);
            }
            return this.deltaUpdateEvt.pipe(takeUntil(unsubscribe$));
        };
        this.setDeltaUpdateEvt = (deltaUpdateEvt) => {
            this.deltaUpdateEvt.next(deltaUpdateEvt);
        };
        this.getLocationAddEvt = (unsubscribe$) => {
            if (!this.locationAddEvt) {
                this.locationAddEvt = new BehaviorSubject(null);
            }
            return this.locationAddEvt.pipe(takeUntil(unsubscribe$));
        };
        this.setLocationAddEvt = (locationAddEvt) => {
            this.locationAddEvt.next(locationAddEvt);
        };
        this.getLocationUpdateEvt = (unsubscribe$) => {
            if (!this.locationUpdateEvt) {
                this.locationUpdateEvt = new BehaviorSubject(null);
            }
            return this.locationUpdateEvt.pipe(takeUntil(unsubscribe$));
        };
        this.setLocationUpdateEvt = (locationUpdateEvt) => {
            this.locationUpdateEvt.next(locationUpdateEvt);
        };
        this.getLocationRenameUpdateEvt = (unsubscribe$) => {
            if (!this.locationRenameUpdateEvt) {
                this.locationRenameUpdateEvt = new BehaviorSubject(null);
            }
            return this.locationRenameUpdateEvt.pipe(takeUntil(unsubscribe$));
        };
        this.setLocationRenameUpdateEvt = (locationRenameUpdateEvt) => {
            this.locationRenameUpdateEvt.next(locationRenameUpdateEvt);
        };
        this.getLocationDeleteEvt = (unsubscribe$) => {
            if (!this.locationDeleteEvt) {
                this.locationDeleteEvt = new BehaviorSubject(null);
            }
            return this.locationDeleteEvt.pipe(takeUntil(unsubscribe$));
        };
        this.setWorkspaceUtilObject = (value) => {
            this.setInStorage("workspaceUtilObj", JSON.stringify(value));
            if (value.workspaceUtilLocation) {
                this.workspaceSelectedLocType = value.workspaceUtilLocation['locType'];
            }
            this.workspaceUtilObj.next(value);
        };
        this.getWorkspaceUtilObject = (unsubscribe$) => {
            if (!this.workspaceUtilObj)
                this.workspaceUtilObj = new BehaviorSubject(null);
            return this.workspaceUtilObj.pipe(takeUntil(unsubscribe$));
        };
        this.setSpaceManagerSelectedFloor = (value) => {
            this.setInStorage("spaceManagerSelectedFloorObj", JSON.stringify(value));
            if (value && value.locType) {
                this.workspaceSelectedLocType = value.locType;
            }
            this.spaceManagerSelectedFloorObj.next(value);
        };
        this.getSpaceManagerSelectedFloor = (unsubscribe$) => {
            if (!this.spaceManagerSelectedFloorObj)
                this.spaceManagerSelectedFloorObj = new BehaviorSubject(null);
            return this.spaceManagerSelectedFloorObj.pipe(takeUntil(unsubscribe$));
        };
        this.getWorkspaceSelectedLocType = () => {
            return this.workspaceSelectedLocType;
        };
        this.setWorkspaceExperienceUtilObject = (value) => {
            this.setInStorage("workspaceExperienceUtilObj", JSON.stringify(value));
            this.workspaceExperienceUtilObj.next(value);
        };
        this.getWorkspaceExperienceUtilObject = (unsubscribe$) => {
            if (!this.workspaceExperienceUtilObj)
                this.workspaceExperienceUtilObj = new BehaviorSubject(null);
            return this.workspaceExperienceUtilObj.pipe(takeUntil(unsubscribe$));
        };
        this.setLocationDeleteEvt = (locationDeleteEvt) => {
            this.locationDeleteEvt.next(locationDeleteEvt);
        };
        this.getActiveTimeStampConnection = () => {
            return this.activeTimeStampConnection;
        };
        this.setActiveTimeStampConnection = (activeTimeStampConnection) => {
            this.activeTimeStampConnection = activeTimeStampConnection;
        };
        this.getLocationRMSDependenciesLoaded = () => {
            return this.locationRMSDependenciesLoaded;
        };
        this.setLocationRMSDependenciesLoaded = (locationRMSDependenciesLoaded) => {
            this.locationRMSDependenciesLoaded = locationRMSDependenciesLoaded;
        };
        //signage room occupancy 
        this.getIsRoomCountUpdated = () => {
            return this.hasRoomCount;
        };
        this.setIsRoomCountUpdated = (hasRoomCount = false) => {
            this.hasRoomCount = hasRoomCount;
        };
        this.clearAll = () => {
            this.setLocationLoadingStatus(null);
            this.setAccessToken(null);
            this.setAdminAccess(false);
            this.setCustomerName("");
            this.setLocationId("");
            this.setSpacesLocationId("");
            this.spacesWSConnectionStatus = false;
            this.setUserName(null);
            this.isFreshlogin = false;
            this.isPageRefresh = false;
            this.isBackPressed = false;
            this.locationTreeArrayExists = false;
            this.personasLocationTreeArrayExists = false;
            this.engagementsLocationTreeArrayExists = false;
            this.cpLocationTreeArrayExists = false;
            this.licenseType = "";
            this.isUndoPortal = false;
            this.isRightNowRefresh = false;
            this.isEnergyUtilRefresh = false;
            this.setFromMail(false);
            this.selectedPeriod = "";
            this.selectedMall = "";
            this.setCurrentNav("");
            this.setMerakiWirelessProviderAuthStatusCallInProgress();
            this.locationAction = new BehaviorSubject(new LocationAction());
            this.setRuleSummary(null);
            this.ruleSummary = new BehaviorSubject("");
            this.ruleName = new BehaviorSubject("");
            this.properties = null;
            this.setTreeState(null);
            this.setTempPortalConfig(null);
            this.setEditUserConfig(null);
            this.setEditUserEmail(null);
            this.setPortalListNavState(false);
            this.setCanDoInteractionLog(false);
            this.setCustomMenuSelectedIndex("");
            this.locationSyncNotificationsList = [];
            this.setLocationTreeArray(new LocationWrap());
            this.setPosition(null);
            this.setLoginTime(0);
            this.setSsidFromRule(null);
            this.setSsidFromRuleId(null);
            this.setFromSSIDPage(false);
            this.setPortalListNavState(false);
            this.setBannerState(false);
            this.setFromSSIDName(null);
            this.setShowSmsLimitTab(false);
            this.setShowCMXConnector(false);
            this.setSetupTaskObserver(null);
            this.syncError = {};
            this.locationObjectArray = new Map();
            this.totalLocIds = [];
            this.currentEditLanguage = {};
            this.setIsMerakiAuth(null);
            this.setIsDashboardAdmin();
            this.setCustomerCategory("");
            this.setIsDummy(null);
            this.setIsMenuClicked(false);
            this.setDeleteLocationStatusCallInProgress(false);
            this.setBusinessSettings(null);
            this.setIsSampleData(false);
            this.loginTemp = {};
            this.setEnableWiredNetwork(false);
            this.setFromSamplePortal(false);
            this.setCurrentApp(null);
            this.setDisconnectFromMeraki(null);
            this.setDisconnectFromMerakiAPIKey(null);
            this.setLoginFromMeraki(null);
            this.setShowSyncStatus(null);
            this.setLoginAPIFromMeraki(null);
            this.setMerakiWPAuthResponse(null);
            this.setWebexBaseUrl(null);
            this.setHotspotTNCLinkUrl(null);
            this.setSmartLicenseLearnMore(null);
            this.setSmartLicensePollingMS(0);
            this.setSmartLicenseEnableFeature(false);
            this.setShowSLPage(false);
            this.setIsUndoPortal(false);
            this.setIsRightNowRefresh(false);
            this.setIsEnergyUtilRefresh(false);
            this.showFullScreen(false);
            this.withSearchText("");
            this.setPopUpAditionalParam("");
            this.setOpenPopUpFromSetup("");
            this.setOnSyncStatusUpdate(0);
            this.setOnLocationSyncStatusUpdate(0);
            this.setLocationObjectArray(new Map());
            this.setFloorRoomsMap(new Map());
            this.setLicenseDetails(new LicenseDetails());
            this.setToastCallBack("");
            this.setAccessToken(null);
            this.setUserRole(new UserRole(null, null, null));
            this.setLicenseType("");
            this.setCustomerLabel(null);
            this.setAuthStatus(false);
            this.setCurrentStatus(null);
            this.setMerakiUserName("");
            this.setReportsHeader(new ReportHeader());
            this.setBreadcrumbPath([]);
            this.setLocationSyncNotificationsList(null);
            this.setSyncError(null);
            this.setCurrentEditLanguage(null);
            this.setDashboardProperties(null);
            this.setSpacesPeriod(new SpacesPeriod({}));
            this.setSpacesObject(null);
            this.setBiExcludedLocObj(null);
            this.setSpacesLocation(null);
            this.setLocationNameMap(null);
            this.setBiTags({});
            this.setOutlierLocations([]);
            this.setSpacesLocationList(null);
            this.setRightNowLocationList(null);
            this.setMetricGroup(null);
            this.setMetricSubGroup(null);
            this.setSearchGodDashboard("");
            this.setGodDashboardCustomerList(null);
            this.setIsSampleData(false);
            this.setCustomerCategory("");
            this.setShowDataExportTab(false);
            this.setDnaSpacesHomeSetup(false);
            this.setBusinessLocationList([]);
            this.setHomePageNavigations([]);
            this.setCPPageNavigations([]);
            this.setLocationAnalyticsFromSetup(null);
            this.setBiTopThreeLocIds([]);
            this.setBiBottomThreeLocIds([]);
            this.setBiTopAndBottomLocations({});
            this.setBiSignificantRankLocations(false);
            this.setLocAnalyticsPopupOpen(false);
            this.navigation(false);
            //  this.status = new BehaviorSubject<boolean>(false);
            this.searchText = new BehaviorSubject("");
            this.locationAction = new BehaviorSubject(new LocationAction());
            this.currentNav = new BehaviorSubject("");
            //  DataService.toastMessage = new BehaviorSubject<ToastMessage>(new ToastMessage(null, 0, null, null, null));
            //  this.toastCallBack = new BehaviorSubject<string>(null);
            this.setPartnerOAuthState("");
            this.setPartnerSandboxTenantId(null);
            this.setTenantId(0);
            this.locationTreeArray = new BehaviorSubject(new LocationWrap());
            this.setORMerakiProfileId(0);
            this.setCCIRedirect(false);
            // this.setCCIActivateUserEmail(null);
            // this.setCCIActivateUserToken(null);
            this.webexSetupStatus = null;
            this.reportsHeader = new BehaviorSubject(new ReportHeader());
            this.breadCrumbPath = new BehaviorSubject([]);
            this.showFullScreenView = new BehaviorSubject(false);
            this.merakiLoginAuthenticated = new BehaviorSubject(false);
            this.ruleSummary = new BehaviorSubject(null);
            this.userRole = new UserRole(null, null, null);
            this.authStatus = new BehaviorSubject(false);
            this.currentStatus = new BehaviorSubject(false);
            this.merakiUserName = new BehaviorSubject("");
            this.onWirelessProviderAuthStatusUpdate = new BehaviorSubject(0);
            this.onLocationSyncStatusUpdate = new BehaviorSubject(0);
            this.onSyncStatusUpdate = new BehaviorSubject(0);
            this.licenseDetails = new BehaviorSubject(new LicenseDetails());
            this.apiResponseErrorHandler = new BehaviorSubject(null);
            this.isMerakiAuth = new BehaviorSubject(null);
            const dashboardSetup = this.getDashboardSetupName();
            const windowAccessTime = this.getLocalStorage().getItem("windowAccessTime") || "0";
            const appTilePreference = this.getUserTilePreferenceFromLocalStorage();
            this.cookieService.clearAll();
            this.getStorage().clear();
            this.getLocalStorage().clear();
            this.getLocalStorage().setItem("windowAccessTime", windowAccessTime);
            this.setUserTilePreferenceToLocalStorage({});
            this.setDashboardSetupName(dashboardSetup);
            this.setComingFromSetupPage(false);
            this.setMerakiLoginAuthenticated(false);
            this.setActivationUserType("");
            this.setShowIntegrations(false);
            this.workspaceSelectedLocType = null;
            this.ruleName = new BehaviorSubject(null);
            this.setSharePluginObject({});
            this.userAppsList = [];
            this.setSmartLicenseRegistered(false);
            this.setIslicensePage(false);
            this.reSetUserName();
            this.setOpenLocationMenu(false);
            this.setEnableORSetupWidget(false);
            this.setIsAuthSSO(false);
            this.setIsManageUser(false);
            this.setCustomerAccNo(null);
            this.setAuthSsoForOR(false);
            this.setManageUserForOR(false);
            this.setCustomerAccNoForOR(null);
            this.setAuthSsoForPersonas(false);
            this.setManageUserForPersonas(false);
            this.setCustomerAccNoForPersonas(null);
            this.setAuthSsoForEngagements(false);
            this.setManageUserForEngagements(false);
            this.setCustomerAccNoForEngagements(null);
            this.setMapsUploadSessionId(null);
            this.setShowChangeLogPage(false);
            this.setMagneticMenuRouteUrl(null);
            //~~~~~~~~~~~~IOT RELATED STARTS~~~~~~~~~~~~//
            this.iotExplorerLocationTreeArrayExists = false;
            this.setAuthSsoForIoT(false);
            this.setManageUserForIoT(false);
            this.setCustomerAccNoForIoT(null);
            this.setIoTLocationPathMap(null);
            this.setMongoIdGraphIdMap(null);
            this.setIotLocationListJson(null);
            this.setIotMongoLocObjMap(null);
            this.setEditIoTRuleObj(null);
            this.iotHomePageTab = new BehaviorSubject(null);
            //~~~~~~~~~~~~IOT RELATED ENDS~~~~~~~~~~~~//
            this.setLocationSetStatus(null);
            this.setDeltaUpdateEvt(null);
            this.setLocLoadingStarted(false);
            this.initialLocationCompletedWS = false;
            this.geoLocationRowArray = new Array();
            this.activeTimeStampConnection = false;
        };
        this.setInStorage = (key, value) => {
            this.getStorage().setItem(key, value);
        };
        this.getFromStorage = (key) => {
            return this.getStorage().getItem(key);
        };
        this.removeFromStorage = (key) => {
            this.getStorage().removeItem(key);
        };
        this.clearStorage = () => {
            this.getStorage().clear();
        };
        this.getStorage = () => {
            return this.getSessionStorage();
        };
        this.getSessionStorage = () => {
            return sessionStorage;
        };
        this.getLocalStorage = () => {
            return localStorage;
        };
        //  transfer the sessionStorage between tabs
        this.sessionStorageTransfer = (event) => {
            // if (!event) {
            //     event = window.event;
            // }
            if (!event.newValue) {
                return;
            }
            if (event.key === "getSessionStorage") {
                console.log("windowAccessTime", this.windowAccessTime);
                const localTime = Number(localStorage.getItem("windowAccessTime"));
                console.log("localStorage.getItem(windowAccessTime)", localTime);
                const otherWindowTime = Number(event.newValue);
                console.log("event.newValue", otherWindowTime);
                if (localStorage.getItem("windowAccessTime") &&
                    otherWindowTime > localTime) {
                    //  another tab which is loaded after me should ask for the sessionStorage, so send it
                    localStorage.setItem("sessionStorage", JSON.stringify(sessionStorage));
                    //  another tab should now have sessionStorage now, so remove from here.
                    const that = this;
                    setTimeout(() => {
                        localStorage.removeItem("sessionStorage");
                        //  clear my session storage to stop me from loading
                        //  sessionStorage.clear();
                        that.clearAll();
                        console.log("Going to invoke router redirect to login page");
                        that.setApiResponseErrorHandler({
                            status: 401,
                            message: "Another Tab is Accessing Dashboard. Exiting from here ... "
                        });
                        //  that.router.navigate(['/logout']);
                        //  that.router.dispose();
                        // close the other opened tabs
                        window.location.href = "about:blank";
                    }, 1000);
                }
            }
            else if (event.key === "sessionStorage") {
                console.log("Got event key as " + sessionStorage);
                if (sessionStorage.length === 0 ||
                    (sessionStorage.length === 1 &&
                        sessionStorage.getItem("dashboardSetupName"))) {
                    //  another tab has sent the data, so get it
                    console.log("Going to fetch all session keys and load in my tab");
                    const data = JSON.parse(event.newValue);
                    data.forEach((key) => {
                        console.log("Going to add key: ", key, data[key]);
                        sessionStorage.setItem(key, data[key]);
                    });
                }
            }
        };
        this.addSessionStorageListener = () => {
            //  listener for the changes to localStorage
            if (window.addEventListener) {
                window.addEventListener("storage", this.sessionStorageTransfer, false);
                //  } else {
                //      window.attachEvent('onstorage', this.sessionStorageTransfer);
            }
        };
        this.triggerStorageAccess = () => {
            let localTime = Number(localStorage.getItem("windowAccessTime"));
            if (!localTime) {
                localStorage.setItem("windowAccessTime", "" + this.windowAccessTime);
                localTime = Number(localStorage.getItem("windowAccessTime"));
            }
            if (localTime && localTime < this.windowAccessTime) {
                //  Should ask other tabs for session storage (this is ONLY to trigger event)
                const windowString = "" + this.windowAccessTime;
                if (sessionStorage.length === 0 ||
                    (sessionStorage.length === 1 &&
                        sessionStorage.getItem("dashboardSetupName"))) {
                    localStorage.setItem("getSessionStorage", windowString);
                    localStorage.removeItem("getSessionStorage");
                }
                localStorage.setItem("windowAccessTime", windowString);
            }
        };
        this.setMerakiLoginNetworkCount = (value) => {
            if (!this.merakiLoginNetworkCount) {
                this.merakiLoginNetworkCount = new BehaviorSubject(null);
            }
            this.merakiLoginNetworkCount.next(value);
        };
        this.getMerakiLoginNetworkCount = (unsubscribe$) => {
            if (!this.merakiLoginNetworkCount) {
                this.merakiLoginNetworkCount = new BehaviorSubject(null);
            }
            return this.merakiLoginNetworkCount.pipe(takeUntil(unsubscribe$));
        };
        this.setMerakiApiNetworkCount = (value) => {
            if (!this.merakiApiNetworkCount) {
                this.merakiApiNetworkCount = new BehaviorSubject(null);
            }
            this.merakiApiNetworkCount.next(value);
        };
        this.getMerakiApiNetworkCount = (unsubscribe$) => {
            if (!this.merakiApiNetworkCount) {
                this.merakiApiNetworkCount = new BehaviorSubject(null);
            }
            return this.merakiApiNetworkCount.pipe(takeUntil(unsubscribe$));
        };
        this.setMapsUploadSessionId = (value) => {
            if (!this.mapsUploadSessionId) {
                this.mapsUploadSessionId = new BehaviorSubject(null);
            }
            this.mapsUploadSessionId.next(value);
        };
        this.getMapsUploadSessionId = (unsubscribe$) => {
            if (!this.mapsUploadSessionId) {
                this.mapsUploadSessionId = new BehaviorSubject(null);
            }
            return this.mapsUploadSessionId.pipe(takeUntil(unsubscribe$));
        };
        this.setUserTilePreferenceToLocalStorage = (data) => {
            localStorage.setItem("userTilePreference", JSON.stringify(data));
        };
        this.getUserTilePreferenceFromLocalStorage = () => {
            const data = JSON.parse(localStorage.getItem("userTilePreference") || "{}");
            return data;
        };
        this.setShowChangeLogPage = (showChangeLogPage) => {
            this.showChangeLogPage = showChangeLogPage;
        };
        this.getShowChangeLogPage = () => {
            return this.showChangeLogPage;
        };
        this.setWebexEnableMenu = (webexEnableMenuValue) => {
            this.webexEnableMenu = webexEnableMenuValue;
        };
        this.getWebexEnableMenu = () => {
            return this.webexEnableMenu;
        };
        this.setDevicePlacementNavEnabled = (devicePlacementNavEnabled) => {
            this.devicePlacementNavEnabled = devicePlacementNavEnabled;
        };
        this.getDevicePlacementNavEnabled = () => {
            return this.devicePlacementNavEnabled;
        };
        // ######################### IoT Explorer starting  #########################
        this.setIotLocationListJson = (json) => __awaiter(this, void 0, void 0, function* () {
            if (json) {
                dashboardExtObj.indexedDbAdd("iotLocationList", json).then(() => {
                    this.iotExplorerLocationTreeArrayExists = true;
                });
            }
            else {
                this.iotExplorerLocationTreeArrayExists = false;
            }
        });
        this.getIoTLocationWrap = () => __awaiter(this, void 0, void 0, function* () {
            return dashboardExtObj.indexedDbRead("iotLocationList");
        });
        this.setIoTLocationPathMap = (value) => {
            this.ioTLocationPath.next(value);
        };
        this.getIoTLocationPathMap = (unsubscribe$) => {
            if (!this.ioTLocationPath) {
                this.ioTLocationPath = new BehaviorSubject(null);
            }
            return this.ioTLocationPath.pipe(takeUntil(unsubscribe$));
        };
        this.setMongoIdGraphIdMap = (value) => {
            this.ioTMongoIdGraphIdMap.next(value);
        };
        this.getMongoIdGraphIdMap = (unsubscribe$) => {
            if (!this.ioTMongoIdGraphIdMap) {
                this.ioTMongoIdGraphIdMap = new BehaviorSubject(null);
            }
            return this.ioTMongoIdGraphIdMap.pipe(takeUntil(unsubscribe$));
        };
        this.setIotMongoLocObjMap = (value) => {
            this.ioTMongoIdLocationObjMap.next(value);
        };
        this.getIotMongoLocObjMap = (unsubscribe$) => {
            if (!this.ioTMongoIdLocationObjMap) {
                this.ioTMongoIdLocationObjMap = new BehaviorSubject(null);
            }
            return this.ioTMongoIdLocationObjMap.pipe(takeUntil(unsubscribe$));
        };
        this.setEditIoTRuleObj = (value) => {
            this.iotEditRuleObj.next(value);
        };
        this.getEditIoTRuleObj = (unsubscribe$) => {
            if (!this.iotEditRuleObj) {
                this.iotEditRuleObj = new BehaviorSubject(null);
            }
            return this.iotEditRuleObj.pipe(takeUntil(unsubscribe$));
        };
        this.setIoTLocationNameMap = (value) => {
            this.iotMongoIdLocationNameMap.next(value);
        };
        this.getIoTLocationNameMap = (unsubscribe$) => {
            if (!this.iotMongoIdLocationNameMap) {
                this.iotMongoIdLocationNameMap = new BehaviorSubject(null);
            }
            return this.iotMongoIdLocationNameMap.pipe(takeUntil(unsubscribe$));
        };
        this.setIoTHomePageTab = (iotHomePageTab) => {
            this.iotHomePageTab.next(iotHomePageTab);
        };
        this.getIoTHomePageTab = (unsubscribe$) => {
            if (!this.iotHomePageTab) {
                this.iotHomePageTab = new BehaviorSubject(null);
            }
            return this.iotHomePageTab.pipe(takeUntil(unsubscribe$));
        };
        this.getLoggedIn = (unsubscribe$) => {
            if (!this.loggedIn) {
                this.loggedIn = new BehaviorSubject(null);
            }
            return this.loggedIn.pipe(takeUntil(unsubscribe$));
        };
        this.setLoggedIn = (loggedIn) => {
            if (!this.loggedIn) {
                this.loggedIn = new BehaviorSubject(null);
            }
            this.loggedIn.next(loggedIn);
        };
        // ######################### IoT RBAC starting  #########################
        this.getAuthSsoForIoT = (unsubscribe$) => {
            if (!this.isAuthSSOForIoT) {
                this.isAuthSSOForIoT = new BehaviorSubject(null);
            }
            return this.isAuthSSOForIoT.pipe(takeUntil(unsubscribe$));
        };
        this.setAuthSsoForIoT = (isSSO) => {
            this.isAuthSSOForIoT.next(isSSO);
        };
        this.getManageUserForIoT = (unsubscribe$) => {
            if (!this.isManageUserForIoT) {
                this.isManageUserForIoT = new BehaviorSubject(null);
            }
            return this.isManageUserForIoT.pipe(takeUntil(unsubscribe$));
        };
        this.setManageUserForIoT = (isManageUser) => {
            this.isManageUserForIoT.next(isManageUser);
        };
        this.getCustomerAccNoForIoT = (unsubscribe$) => {
            if (!this.customerAccNoForIoT) {
                this.customerAccNoForIoT = new BehaviorSubject(null);
            }
            return this.customerAccNoForIoT.pipe(takeUntil(unsubscribe$));
        };
        this.setCustomerAccNoForIoT = (customerAccNo) => {
            this.customerAccNoForIoT.next(customerAccNo);
        };
        this.setUserRoleForIoT = (userRole) => {
            this.userRoleForIoT = userRole;
            this.getUserRoleSubscriberForIoT(null, userRole, true);
        };
        this.getUserRoleForIoT = () => {
            return this.userRoleForIoT;
        };
        this.getUserRoleSubscriberForIoT = (unsubscribe$, $userRole = null, internal = false) => {
            if (!this.userRoleSubscriberForIoT) {
                this.userRoleSubscriberForIoT = new BehaviorSubject(this.userRole);
            }
            if ($userRole) {
                this.userRoleSubscriberForIoT.next($userRole);
            }
            if (internal) {
                return this.userRoleSubscriberForIoT;
            }
            else {
                return this.userRoleSubscriberForIoT.pipe(takeUntil(unsubscribe$));
            }
        };
        // #########################  IoT RBAC ending   #########################
        this.setUseCaseCount = (count) => {
            this.useCasetotalCount.next(count);
        };
        this.getUseCaseCount = (unsubscribe$) => {
            if (!this.useCasetotalCount) {
                this.useCasetotalCount = new BehaviorSubject(0);
            }
            return this.useCasetotalCount.pipe(takeUntil(unsubscribe$));
        };
        // ######################### IoT Explorer Ends  #########################
        this.openMagneticPopup = () => {
            $('.mat-drawer.mat-drawer-side').css('z-index', 0);
            $('.mat-drawer.mat-drawer-side').css('marginTop', '56px');
            $('.appContainer .container-toolbar').css('position', 'fixed');
            $('mat-sidenav-content').css('position', 'initial');
            $('mat-sidenav-content').css('marginTop', '56px');
        };
        this.closeMagneticPopup = () => {
            $('.mat-drawer.mat-drawer-side').css('z-index', 4);
            $('.mat-drawer.mat-drawer-side').css('marginTop', '0px');
            $('.appContainer .container-toolbar').css('position', 'sticky');
            $('mat-sidenav-content').css('position', 'relative');
            $('mat-sidenav-content').css('marginTop', '0px');
        };
        console.log("data service getting constructed");
        this.addStorageTrigger();
    }
    setIsTemplateEnabled(value) {
        this._isTemplateEnabled.next(value);
    }
    setIsModalVisible(value) {
        this._isModalVisible.next(value);
    }
    static getInstance(cookieService, router) {
        if (DataService.instance === null) {
            DataService.instance = new DataService(cookieService, router);
        }
        return DataService.instance;
    }
    hidePendoLauncher() {
        const launcherBadge = document.querySelector('._pendo-resource-center-badge-image');
        const launcherBubble = document.querySelector('.pendo-resource-center-badge-notification-bubble');
        const launcherContainer = document.querySelector('._pendo-resource-center-badge-container');
        if (launcherBadge)
            launcherBadge.style.visibility = 'hidden';
        if (launcherBubble)
            launcherBubble.style.visibility = 'hidden';
        if (launcherContainer)
            launcherContainer.style.visibility = 'hidden';
    }
    showPendoLauncher() {
        const launcherBadge = document.querySelector('._pendo-resource-center-badge-image');
        const launcherBubble = document.querySelector('.pendo-resource-center-badge-notification-bubble');
        const launcherContainer = document.querySelector('._pendo-resource-center-badge-container');
        if (launcherBadge)
            launcherBadge.style.visibility = 'visible';
        if (launcherBubble)
            launcherBubble.style.visibility = 'visible';
        if (launcherContainer)
            launcherContainer.style.visibility = 'visible';
    }
}
DataService.toastMessage = new BehaviorSubject(new ToastMessage(null, 0, null, null, null));
DataService.instance = null;
DataService.ɵfac = function DataService_Factory(t) { return new (t || DataService)(i0.ɵɵinject(CookieService), i0.ɵɵinject(i1.Router)); };
DataService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DataService, factory: DataService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataService, [{
        type: Injectable
    }], function () { return [{ type: CookieService }, { type: i1.Router }]; }, null); })();
//  singleton changes starts
const dataServiceFactory = (cookieService, router) => {
    return DataService.getInstance(cookieService, router);
};
const DATA_SERVICE_PROVIDER = [
    {
        provide: DataService,
        deps: [CookieService, Router],
        useFactory: dataServiceFactory
    }
];

class HttpClientWrapperService {
    // eslint-disable-next-line no-unused-vars
    constructor(http, dataService) {
        this.http = http;
        this.dataService = dataService;
        this.get = (url, options) => {
            let defaultTimeout = 120000;
            if (options && options.timeout) {
                defaultTimeout = options.timeout;
            }
            if (!options) {
                options = {
                    // headers: httpHeaders,
                    // params: httpParams,
                    responseType: "json"
                };
            }
            if (!options.headers) {
                const headersOptions = {
                    "Content-Type": "application/json",
                    Authorization: ""
                };
                if (this.dataService.getAccessToken()) {
                    headersOptions.Authorization =
                        "Bearer " + this.dataService.getAccessToken();
                }
                const headers = new HttpHeaders(headersOptions);
                options.headers = headers;
            }
            else if (this.dataService.getAccessToken()) {
                const headers = options.headers;
                headers["Authorization"] =
                    "Bearer " + this.dataService.getAccessToken();
                headers["Content-Type"] = "application/json";
                options.headers = headers;
            }
            options.withCredentials = true;
            return this.http
                .get(url, options)
                .pipe(timeout(defaultTimeout));
        };
        this.getPlainText = (url, options) => {
            let defaultTimeout = 120000;
            if (options && options.timeout) {
                defaultTimeout = options.timeout;
            }
            return this.http.get(url, options)
                .pipe(timeout(defaultTimeout));
        };
        this.post = (url, postBody, options) => {
            let defaultTimeout = 120000;
            if (options && options.timeout) {
                defaultTimeout = options.timeout;
            }
            if (!options) {
                options = {
                    // headers: httpHeaders,
                    // params: httpParams,
                    responseType: "json"
                };
            }
            if (!options.headers) {
                const headersOptions = {
                    Pragma: "no-cache",
                    Authorization: ""
                };
                if (!options.skipContentType) {
                    headersOptions["Content-Type"] = "application/json";
                }
                if (this.dataService.getAccessToken()) {
                    headersOptions.Authorization =
                        "Bearer " + this.dataService.getAccessToken();
                }
                const headers = new HttpHeaders(headersOptions);
                options.headers = headers;
            }
            else if (this.dataService.getAccessToken()) {
                const headers = options.headers;
                headers["Authorization"] =
                    "Bearer " + this.dataService.getAccessToken();
                if (!options.skipContentType)
                    headers["Content-Type"] = "application/json";
                options.headers = headers;
            }
            options.withCredentials = true;
            return this.http
                .post(url, postBody, options)
                .pipe(timeout(defaultTimeout));
        };
        this.delete = (url, options) => {
            let defaultTimeout = 120000;
            if (options && options.timeout) {
                defaultTimeout = options.timeout;
            }
            if (!options) {
                options = {
                    // headers: httpHeaders,
                    // params: httpParams,
                    responseType: "json"
                };
            }
            if (!options.headers) {
                const headersOptions = {
                    "Content-Type": "application/json",
                    Authorization: ""
                };
                if (this.dataService.getAccessToken()) {
                    headersOptions.Authorization =
                        "Bearer " + this.dataService.getAccessToken();
                }
                const headers = new HttpHeaders(headersOptions);
                options.headers = headers;
            }
            else if (this.dataService.getAccessToken()) {
                const headers = options.headers;
                headers["Authorization"] =
                    "Bearer " + this.dataService.getAccessToken();
                headers["Content-Type"] = "application/json";
                options.headers = headers;
            }
            options.withCredentials = true;
            return this.http.delete(url, options).pipe(timeout(defaultTimeout));
        };
        this.put = (url, putData, options) => {
            let defaultTimeout = 120000;
            if (options && options.timeout) {
                defaultTimeout = options.timeout;
            }
            if (!options) {
                options = {
                    // headers: httpHeaders,
                    // params: httpParams,
                    responseType: "json"
                };
            }
            if (!options.headers) {
                const headersOptions = {
                    "Content-Type": "application/json",
                    Authorization: ""
                };
                if (this.dataService.getAccessToken()) {
                    headersOptions.Authorization =
                        "Bearer " + this.dataService.getAccessToken();
                }
                const headers = new HttpHeaders(headersOptions);
                options.headers = headers;
            }
            else if (this.dataService.getAccessToken()) {
                const headers = options.headers;
                headers["Authorization"] =
                    "Bearer " + this.dataService.getAccessToken();
                headers["Content-Type"] = "application/json";
                options.headers = headers;
            }
            options.withCredentials = true;
            return this.http
                .put(url, putData, options)
                .pipe(timeout(defaultTimeout));
        };
        this.upload = (url, postBody, options) => {
            let defaultTimeout = 120000;
            if (options && options.timeout) {
                defaultTimeout = options.timeout;
            }
            if (!options) {
                options = {
                    // headers: httpHeaders,
                    // params: httpParams,
                    responseType: 'json'
                };
            }
            if (!options.headers) {
                const headersOptions = {
                    Pragma: 'no-cache',
                    Authorization: ''
                };
                if (!options.skipContentType) {
                    headersOptions['Content-Type'] = 'application/json';
                }
                if (this.dataService.getAccessToken()) {
                    headersOptions.Authorization = 'Bearer ' + this.dataService.getAccessToken();
                }
                const headers = new HttpHeaders(headersOptions);
                options.headers = headers;
            }
            else if (this.dataService.getAccessToken()) {
                const headers = options.headers;
                headers["Authorization"] =
                    "Bearer " + this.dataService.getAccessToken();
                if (!options.skipContentType)
                    headers["Content-Type"] = "application/json";
                options.headers = headers;
            }
            options.withCredentials = true;
            return this.http.post(url, postBody, options)
                .pipe(
            // map(event => this.getEventMessage(event, postBody)),
            timeout(defaultTimeout));
        };
    }
    getEventMessage(event, formData) {
        switch (event.type) {
            case HttpEventType.UploadProgress:
                return this.fileUploadProgress(event);
                break;
            case HttpEventType.Response:
                return this.apiResponse(event);
                break;
            default:
                return `File "${formData.get('profile').name}" surprising upload event: ${event.type}.`;
        }
    }
    fileUploadProgress(event) {
        const percentDone = Math.round(100 * event.loaded / event.total);
        return { status: 'progress', message: percentDone };
    }
    apiResponse(event) {
        return event.body;
    }
}
HttpClientWrapperService.ɵfac = function HttpClientWrapperService_Factory(t) { return new (t || HttpClientWrapperService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(DataService)); };
HttpClientWrapperService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HttpClientWrapperService, factory: HttpClientWrapperService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HttpClientWrapperService, [{
        type: Injectable
    }], function () { return [{ type: i1$1.HttpClient }, { type: DataService }]; }, null); })();

const isDebugMode = false;
const noop = () => undefined;
class LoggerService {
    constructor() { }
    get info() {
        if (isDebugMode) {
            return console.log.bind(console);
        }
        else {
            return noop;
        }
    }
    get debug() {
        if (isDebugMode) {
            return console.log.bind(console);
        }
        else {
            return noop;
        }
    }
    get warn() {
        if (isDebugMode) {
            return console.warn.bind(console);
        }
        else {
            return noop;
        }
    }
    get error() {
        if (isDebugMode) {
            return console.error.bind(console);
        }
        else {
            return noop;
        }
    }
    invokeConsoleMethod(type, args) {
        const logFn = () => console[type] || console.log || noop;
        logFn.apply(console, [args]);
    }
}
LoggerService.ɵfac = function LoggerService_Factory(t) { return new (t || LoggerService)(); };
LoggerService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoggerService, factory: LoggerService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoggerService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class AuthService {
    constructor(logger, dataService, injector, httpClientWrapper) {
        this.logger = logger;
        this.dataService = dataService;
        this.injector = injector;
        this.httpClientWrapper = httpClientWrapper;
        this.apiConfig = new ApiConfig();
        this.util = new Utils(this.logger);
        this.extractHttpResponse = (res) => {
            return res;
        };
        //  extractRoleHttpResponse = (res) => {
        //      if (res && res.role) {
        //          this.dataService.setUserRoleString(res.role);
        //      }
        //      return res;
        //  }
        this.handleErrorObservable = (error) => {
            this.dataService.setApiResponseErrorHandler(error);
            return throwError(error);
        };
        this.activateUser = (user) => {
            const serverUrl = this.apiConfig.getUserActivationUrl();
            return this.httpClientWrapper
                .post(serverUrl, user)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.getDemokitContextUrlFn = (user) => {
            const serverUrl = this.apiConfig.getDemokitContextUrl();
            return this.httpClientWrapper
                .post(serverUrl, user)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.checkEmailPIN = (requestBody) => {
            const serverUrl = this.apiConfig.getCheckEmailPinUrl();
            return this.httpClientWrapper
                .post(serverUrl, requestBody)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.setEmailPIN = (requestBody) => {
            const serverUrl = this.apiConfig.setEmailPinUrl();
            return this.httpClientWrapper
                .post(serverUrl, requestBody)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.resetEmailPIN = (requestBody) => {
            const serverUrl = this.apiConfig.resetEmailPINUrl();
            return this.httpClientWrapper
                .post(serverUrl, requestBody)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.getActivateUser = (bodyParams) => {
            const serverUrl = this.apiConfig.getActivateUserUrl();
            return this.httpClientWrapper
                .post(serverUrl, bodyParams)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.getActivateRedirection = (bodyParams) => {
            const serverUrl = this.apiConfig.getActivateRedirectionUrl();
            return this.httpClientWrapper
                .post(serverUrl, bodyParams)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.getDemokitActivateRedirection = (bodyParams) => {
            const serverUrl = this.apiConfig.getDemokitActivateRedirectionUrl();
            return this.httpClientWrapper
                .post(serverUrl, bodyParams)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.forgotPassword = (forgotPasswordEmail) => {
            const serverUrl = this.apiConfig.getForgotPasswordUrl() + "/" + forgotPasswordEmail;
            return this.httpClientWrapper
                .get(serverUrl)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.resetPassword = (user) => {
            const serverUrl = this.apiConfig.getResetPasswordUrl();
            return this.httpClientWrapper
                .post(serverUrl, user)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.changePassword = (user) => {
            const serverUrl = this.apiConfig.getChangePasswordUrl();
            // console.log( serverUrl );
            return this.httpClientWrapper
                .post(serverUrl, user)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.getProperties = (hasAccessCode, unsubscribe$) => {
            const promise = new Promise((resolve, reject) => {
                if (!this.dataService.getDashboardProperties() || !hasAccessCode) {
                    const serverUrl = this.apiConfig.getPropertiesUrl() +
                        "?t=" +
                        new Date().getTime();
                    this.httpClientWrapper
                        .get(serverUrl)
                        .pipe(takeUntil(unsubscribe$))
                        .subscribe({
                        next: (res) => {
                            console.log(">>>>>> properties url response", res);
                            resolve({
                                value: this.fetchDashboardProperties(this.extractDataProperties(res), hasAccessCode)
                            });
                        },
                        error: (err) => {
                            console.log(">>>>>> properties url error", err);
                            reject(err.error || "Server error");
                            return;
                        }
                    });
                    // .subscribe(
                    // 	map((res) => {
                    // 		resolve({
                    // 			value: this.fetchDashboardProperties(
                    // 				this.extractDataProperties(res),
                    // 				hasAccessCode
                    // 			)
                    // 		});
                    // 	}),
                    // 	catchError((err: any, caught: Observable<void>):ObservableInput<any> => {
                    // 		reject(err.error || "Server error");
                    // 		return ;
                    // 	})
                    // );
                }
                else {
                    resolve({
                        value: this.fetchDashboardProperties(this.dataService.getDashboardProperties(), hasAccessCode)
                    });
                }
            });
            return promise;
        };
        this.fetchDashboardProperties = (properties, hasAccessCode) => {
            if (hasAccessCode && !this.dataService.getDashboardProperties()) {
                this.dataService.setDashboardProperties(properties);
            }
            return properties;
        };
        this.extractDataProperties = (res) => {
            if (res && res.data) {
                return res.data;
            }
            return null;
        };
        this.getCustomerListForAdmin = () => {
            const serverUrl = this.apiConfig.getCustomerListForAdminUrl();
            return this.httpClientWrapper
                .get(serverUrl)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.triggerSupportEmail = (license) => {
            const serverUrl = this.apiConfig.getTriggerSupportEmailUrl();
            return this.httpClientWrapper
                .post(serverUrl, license)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.extractDataLicenseType = (res) => {
            if (res.body.status) {
                const licenseType = res.body.data.licenseType;
                this.dataService.setLicenseType(licenseType);
                return this.dataService.licenseType;
            }
            return "Basic Subscription";
        };
        this.extractData = (res) => {
            const array = [];
            const key = 0;
            let count = 0;
            res.body.forEach((element) => {
                array.push(res.body[count++]);
            });
            return array;
        };
        this.getRole = (unsubscribe$) => {
            //  if (this.dataService.getUserRole() != null && this.dataService.getUserRole().appRole !== null) {
            //      return Observable.of({ role: this.dataService.getUserRole().appRole });
            //  } else {
            return this.dataService.getUserRoleSubscriber(unsubscribe$);
            //  }
            //  if (!this.dataService.userRole) {
            //      this.dataService.userRole = new BehaviorSubject<string>(null);
            //  }
            //  return this.httpClientWrapper.get(this.apiConfig.getExtractRole())
            //      .pipe(map(this.extractRoleHttpResponse)
            //      ,catchError(this.handleErrorObservable));
        };
        this.getRoleForOR = (unsubscribe$) => {
            let userRole;
            const interval = true;
            return this.dataService.getUserRoleSubscriberForOR(unsubscribe$, userRole, interval);
        };
        this.getRoleForPersonas = (unsubscribe$) => {
            let userRole;
            const interval = true;
            return this.dataService.getUserRoleSubscriberForPersonas(unsubscribe$, userRole, interval);
        };
        this.getRoleForEngagements = (unsubscribe$) => {
            let userRole;
            const interval = true;
            return this.dataService.getUserRoleSubscriberForEngagements(unsubscribe$, userRole, interval);
        };
        this.getRoleForSignage = (unsubscribe$) => {
            let userRole;
            const interval = true;
            return this.dataService.getUserRoleSubscriberForSignage(unsubscribe$, userRole, interval);
        };
        this.getRoleForWorkspace = (unsubscribe$) => {
            let userRole;
            const interval = true;
            return this.dataService.getUserRoleSubscriberForWorkspace(unsubscribe$, userRole, interval);
        };
        this.getRoleForIoT = (unsubscribe$) => {
            return this.dataService.getUserRoleSubscriberForIoT(unsubscribe$);
        };
        this.getLicenseType = (unsubscribe$) => {
            const promise = new Promise((resolve, reject) => {
                this.dataService
                    .getLicenseDetails(unsubscribe$)
                    .subscribe((val) => {
                    if (val) {
                        resolve({
                            value: val.licenseType ? val.licenseType : val
                        });
                    }
                });
            });
            return promise;
        };
        this.getCaptchaTemplate = () => {
            const serverUrl = this.apiConfig.getCaptchaTemplateUrl();
            return this.httpClientWrapper
                .get(serverUrl)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.requestDemo = (requestData) => {
            const serverUrl = this.apiConfig.getRequestDemoUrl();
            return this.httpClientWrapper
                .post(serverUrl, requestData)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.pollToken = () => {
            const serverUrl = this.apiConfig.getPollTokenUrl() + "/" + new Date().getTime();
            return this.httpClientWrapper
                .get(serverUrl)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.verifyToken = () => {
            const serverUrl = this.apiConfig.getVerifyTokenUrl() + "/" + new Date().getTime();
            return this.httpClientWrapper
                .get(serverUrl)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.refreshToken = () => {
            const serverUrl = this.apiConfig.getRefreshTokenUrl(); //  + '/' + (new Date()).getTime();
            return this.httpClientWrapper
                .post(serverUrl, {})
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.updateToken = (newToken) => {
            const serverUrl = this.apiConfig.getUpdateTokenUrl();
            // console.log( serverUrl );
            // return this.getLocationTree();
            return this.httpClientWrapper
                .post(serverUrl, newToken)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.updateTermsStatus = (status) => {
            const serverUrl = this.apiConfig.getTermsUpdateUrl() + "/" + status;
            return this.httpClientWrapper
                .post(serverUrl, {})
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.getULAConfig = () => {
            const serverUrl = this.apiConfig.getULAConfig();
            return this.httpClientWrapper
                .post(serverUrl, {})
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.getProfile = (email) => {
            const serverUrl = this.apiConfig.getProfileInfo(email);
            return this.httpClientWrapper
                .get(serverUrl)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.changePasswordViaNode = (user) => {
            const serverUrl = this.apiConfig.getChangePasswordUrlViaNode();
            // console.log( serverUrl );
            return this.httpClientWrapper
                .post(serverUrl, user)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.updateProfile = (requestData) => {
            const serverUrl = this.apiConfig.updateProfileInfo();
            return this.httpClientWrapper
                .post(serverUrl, requestData)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.sendOTP = (requestData) => {
            const serverUrl = this.apiConfig.sendOTPToEndUser();
            return this.httpClientWrapper
                .post(serverUrl, requestData)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.recieveHandshakeDemoKit = () => {
            const serverUrl = this.apiConfig.getRecieveHandshakeDemoKit();
            // console.log( serverUrl );
            return this.httpClientWrapper
                .get(serverUrl)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.verifyOTP = (requestData) => {
            const serverUrl = this.apiConfig.verifyOTPToEndUser();
            return this.httpClientWrapper
                .post(serverUrl, requestData)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.initiateHandshakeDemoKit = (sessionStorage) => {
            const serverUrl = this.apiConfig.getInitiateHandshakeDemoKit();
            // console.log( serverUrl );
            return this.httpClientWrapper
                .post(serverUrl, { sessionStorage: sessionStorage })
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.getChangeLog = (filterJson) => {
            const serverUrl = this.apiConfig.getAuditTrailUrl();
            return this.httpClientWrapper.post(serverUrl, filterJson)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.getChangeLogFiltered = (filterJson) => {
            const serverUrl = this.apiConfig.getAuditTrailFilteredUrl();
            return this.httpClientWrapper.post(serverUrl, filterJson)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.getAuditTrailEnabledApps = () => {
            const serverUrl = this.apiConfig.getAuditTrailEnabledAppsUrl();
            return this.httpClientWrapper.get(serverUrl)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.getDashboardRedirectToken = () => {
            const serverUrl = this.apiConfig.getDashboardRedirectTokenUrl();
            // console.log( serverUrl );
            return this.httpClientWrapper
                .post(serverUrl, {})
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
        this.getAdminSSOLoginStatus = () => {
            const serverURL = this.apiConfig.getAdminLoginStatusURL();
            return this.httpClientWrapper
                .get(serverURL)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
    }
    validate(username, password) {
        this.logger.debug("getting locations");
        const auth = btoa('{ "random": "' +
            this.util.randomString(32, "A#a") +
            '", "username": "' +
            username +
            '", "random1": "' +
            this.util.randomString(32, "A#a") +
            '", "password": "' +
            password +
            '", "random3": "' +
            this.util.randomString(32, "A#a") +
            '" }');
        const headers = new HttpHeaders({
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection-Cache": btoa(this.util.randomString(64, "#aA") +
                "." +
                this.util.randomString(64, "#aA") +
                "." +
                auth +
                "." +
                this.util.randomString(64, "#aA") +
                "." +
                this.util.randomString(32, "Aa#"))
        });
        const options = {
            headers
        };
        this.logger.debug("getting locations: headers", options, this.apiConfig.getAuthValidateUrl());
        return this.httpClientWrapper
            .post(this.apiConfig.getAuthValidateUrl(), {}, options)
            .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
    }
    validateAdmin(username, password) {
        this.logger.debug("getting locations");
        const auth = btoa('{ "random": "' +
            this.util.randomString(32, "A#a") +
            '", "username": "' +
            username +
            '", "random1": "' +
            this.util.randomString(32, "A#a") +
            '", "password": "' +
            password +
            '", "random3": "' +
            this.util.randomString(32, "A#a") +
            '" }');
        const headers = new HttpHeaders({
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection-Cache": btoa(this.util.randomString(64, "#aA") +
                "." +
                this.util.randomString(64, "#aA") +
                "." +
                auth +
                "." +
                this.util.randomString(64, "#aA") +
                "." +
                this.util.randomString(32, "Aa#"))
        });
        const options = {
            headers
        };
        this.logger.debug("getting locations: headers", options, this.apiConfig.getAuthAdminValidateUrl());
        return this.httpClientWrapper
            .post(this.apiConfig.getAuthAdminValidateUrl(), {}, options)
            .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
    }
    validateSharedSysToken(guid) {
        return this.httpClientWrapper
            .get(this.apiConfig.getValidateSharedSysTokenUrl(guid))
            .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
    }
    requestAccess(requestBody) {
        const serverUrl = this.apiConfig.getRequestAccessUrl();
        return this.httpClientWrapper
            .post(serverUrl, requestBody)
            .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
    }
    generateCustomerToken(userName, customerName, tempToken) {
        this.logger.debug("generating user customer token");
        const headers = new HttpHeaders({
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Bearer " + tempToken,
            userName,
            customerName
        });
        const options = {
            headers
        };
        this.logger.debug("getting locations: headers", options, this.apiConfig.getCustomerValidateUrl());
        return this.httpClientWrapper
            .post(this.apiConfig.getCustomerValidateUrl(), {}, options)
            .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
    }
}
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(i0.ɵɵinject(LoggerService), i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(HttpClientWrapperService)); };
AuthService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthService, [{
        type: Injectable
    }], function () { return [{ type: LoggerService }, { type: DataService }, { type: i0.Injector }, { type: HttpClientWrapperService }]; }, null); })();

class AbsoluteRedirectComponent {
    // initialize the absolute-redirect component.
    constructor(activatedRoute, router, dataService, authService) {
        this.dataService = dataService;
        this.authService = authService;
        this.unsubscribe$ = new Subject();
        this.router = router;
        this.redirectTo = activatedRoute.snapshot.data.redirectTo;
        this.legacy = activatedRoute.snapshot.data.legacy;
        this.noRouteMessage = activatedRoute.snapshot.data.noRouteMessage;
    }
    // this method is called after the inputs have been found, for the first time.
    ngOnInit() {
        console.log("Absolute Redirect to:", this.redirectTo);
        if (this.noRouteMessage) {
            this.dataService.setToastMessage(this.noRouteMessage, 5000, null, null, "error");
            // this.interactionService.doInteractionLog(
            //   new InteractionLog(TYPE.SUBMIT, this.dataService.getPosition(), "{}", SECTION.LOGIN,
            //     ITEM_TYPE.POPUP, ITEM.SELECT_CUSTOMER, "SAVE: App selected and submitted",
            //     '/login')
            // )
        }
        if (!this.legacy || (this.dataService.getAccessToken() != null)) {
            this.router.navigateByUrl(this.redirectTo);
        }
        else {
            this.readPropertiesForRoute();
        }
    }
    readPropertiesForRoute() {
        this.authService.getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$).then(properties => {
            let useCentralAuth = properties.value['useCentralAuth'];
            if (useCentralAuth) {
                this.router.navigateByUrl(this.redirectTo);
            }
            else {
                this.router.navigateByUrl(this.legacy);
            }
        });
    }
}
AbsoluteRedirectComponent.ɵfac = function AbsoluteRedirectComponent_Factory(t) { return new (t || AbsoluteRedirectComponent)(i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(AuthService)); };
AbsoluteRedirectComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AbsoluteRedirectComponent, selectors: [["lib-absolute-redirect"]], decls: 0, vars: 0, template: function AbsoluteRedirectComponent_Template(rf, ctx) { }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AbsoluteRedirectComponent, [{
        type: Component,
        args: [{
                selector: "lib-absolute-redirect",
                templateUrl: "./absolute-redirect.component.html",
                styleUrls: ["./absolute-redirect.component.scss"]
            }]
    }], function () { return [{ type: i1.ActivatedRoute }, { type: i1.Router }, { type: DataService }, { type: AuthService }]; }, null); })();

var SECTION;
(function (SECTION) {
    SECTION["LOGIN"] = "LOGIN";
    SECTION["HOME_PAGE"] = "HOME_PAGE";
    SECTION["LOCATIONS"] = "LOCATIONS";
    SECTION["PORTAL_EDITOR"] = "PORTAL_EDITOR";
    SECTION["STYLE_SHEET_EDITOR"] = "STYLE_SHEET_EDITOR";
    SECTION["SSID"] = "SSID";
    SECTION["MAP_PAGE"] = "MAP_PAGE";
    SECTION["PROXIMITY_RULES"] = "PROXIMITY_RULES";
    SECTION["ACCESS_CODE"] = "ACCESS_CODE";
    SECTION["ADMIN"] = "ADMIN";
    SECTION["INVITE_USER"] = "INVITE_USER";
    SECTION["TEAM"] = "TEAM";
    SECTION["SETTINGS"] = "SETTINGS";
    SECTION["CMX_ON_PREM"] = "CMX_ON_PREM";
    SECTION["BLE_BEACON"] = "BLE_BEACON";
    SECTION["CUSTOMER"] = "CUSTOMER";
    SECTION["WHIITELIST_URL"] = "WHIITELIST_URL";
    SECTION["SMSGATEWAY"] = "SMSGATEWAY";
    SECTION["LOCATIONMANAGER_PORTAL_EDITOR"] = "LOCATIONMANAGER_PORTAL_EDITOR";
    SECTION["LOCATIONMANAGER_METADATA"] = "LOCATIONMANAGER_METADATA";
    SECTION["LOCATIONMANAGER_ACTIVATELOCATION"] = "LOCATIONMANAGER_ACTIVATELOCATION";
    SECTION["AUTHENTICATION"] = "AUTHENTICATION";
    SECTION["LOCATION_SETTINGS"] = "LOCATION_SETTINGS";
    SECTION["PORTAL"] = "PORTAL";
    SECTION["REPORTS"] = "REPORTS";
    SECTION["CHANGE_PASSWORD"] = "CHANGE_PASSWORD";
    SECTION["ACCOUNT_SETTINGS"] = "ACCOUNT_SETTINGS";
    SECTION["MANAGE_WIRELESS_NETWORK"] = "MANAGE_WIRELESS_NETWORK";
    SECTION["WHATS_NEW"] = "WHATS_NEW";
    SECTION["SIGN_OUT"] = "SIGN_OUT";
    SECTION["ACTIVATE_USER"] = "ACTIVATE_USER";
    SECTION["RESET_PASSWORD"] = "RESET_PASSWORD";
    SECTION["CSS_EDITOR"] = "CSS_EDITOR";
    SECTION["CSS_EDITOR_UPLOAD"] = "CSS_EDITOR_UPLOAD";
    SECTION["CSS_EDITOR_PREVIEW"] = "CSS_EDITOR_PREVIEW";
    SECTION["DATA_EXPORT"] = "DATA_EXPORT";
    SECTION["HOME_SETUP"] = "HOME_SETUP";
    SECTION["LOGIN_PARTNER_HOME"] = "LOGIN_PARTNER_HOME";
    SECTION["PARTNER_APP_CENTER"] = "PARTNER_APP_CENTER";
    SECTION["PARTNER_APP_ACTIVATION"] = "PARTNER_APP_ACTIVATION";
    SECTION["PARTNER_SANDBOX_HOME"] = "PARTNER_HOME";
    SECTION["PARTNER_HOME"] = "PARTNER_HOME";
    SECTION["PARTNER_APP_PREVIEW"] = "PARTNER_APP_PREVIEW";
    SECTION["PARTNER_SSO_LOGIN"] = "PARTNER_SSO_LOGIN";
    SECTION["PARTNER_OAUTH_VALIDATION"] = "PARTNER_OAUTH_VALIDATION";
    SECTION["SETUP_WIRELESS_NETWORKS"] = "SETUP_WIRELESS_NETWORKS";
    SECTION["LOCATION_DETAIL"] = "LOCATION_DETAIL";
    SECTION["CREATE_USER_ROLE"] = "CREATE_USER_ROLE";
    SECTION["UPDATE_PROFILE"] = "UPDATE_PROFILE";
    SECTION["VERIFY_PHONE_NUMBER"] = "VERIFY_PHONE_NUMBER";
    SECTION["RICHMAPS_EDITOR"] = "RICHMAPS_EDITOR";
    SECTION["LOCATION_AND_MAPS"] = "LOCATION_AND_MAPS";
    SECTION["ADD_RICH_MAPS"] = "ADD_RICH_MAPS";
    SECTION["NETWORK_MAPS"] = "NETWORK_MAPS";
    SECTION["RICHMAPS"] = "RICHMAPS";
    SECTION["RICHMAPS_FILTER"] = "RICHMAPS_FILTER";
    SECTION["LOCATIONS_AND_MAPS_IMPORT_LOCATION"] = "LOCATIONS_AND_MAPS_IMPORT_LOCATION";
    SECTION["MERGE_LOCATIONS"] = "MERGE_LOCATIONS";
    SECTION["STANDARD_MAP_PREVIEW"] = "STANDARD_MAP_PREVIEW";
    SECTION["FLOOR_LIST"] = "FLOOR_LIST";
})(SECTION || (SECTION = {}));
var TYPE;
(function (TYPE) {
    TYPE["ACTIVATE"] = "ACTIVATE";
    TYPE["CANCEL"] = "CANCEL";
    TYPE["LOGIN"] = "LOGIN";
    TYPE["VIEW"] = "VIEW";
    TYPE["CREATE"] = "CREATE";
    TYPE["EDIT"] = "EDIT";
    TYPE["RENAME"] = "RENAME";
    TYPE["DELETE"] = "DELETE";
    TYPE["ERROR"] = "ERROR";
    TYPE["LOGOUT"] = "LOGOUT";
    TYPE["REFRESH"] = "REFRESH";
    TYPE["SAVE"] = "SAVE";
    TYPE["PUBLISH"] = "PUBLISH";
    TYPE["UPDATE"] = "UPDATE";
    TYPE["SELECT"] = "SELECT";
    TYPE["DOWNLOAD"] = "DOWNLOAD";
    TYPE["UPLOAD"] = "UPLOAD";
    TYPE["CLOSE"] = "CLOSE";
    TYPE["SUBMIT"] = "SUBMIT";
    TYPE["ADD"] = "ADD";
    TYPE["REMOVE"] = "REMOVE";
    TYPE["ENABLE"] = "ENABLE";
    TYPE["DISABLE"] = "DISABLE";
    TYPE["CONNECT"] = "CONNECT";
    TYPE["DISCONNECT"] = "DISCONNECT";
    TYPE["COPY"] = "COPY";
    TYPE["SEND"] = "SEND";
    TYPE["BACK"] = "BACK";
    TYPE["CLEAR"] = "CLEAR";
    TYPE["DISCARD"] = "DISCARD";
    TYPE["PAUSE"] = "PAUSE";
    TYPE["LIVE"] = "LIVE";
    TYPE["IMPORT"] = "IMPORT";
    TYPE["EXPORT"] = "EXPORT";
    TYPE["SKIP"] = "SKIP";
    TYPE["TRY_AGAIN"] = "TRY_AGAIN";
    TYPE["DO_IT_LATER"] = "DO_IT_LATER";
    TYPE["GET"] = "GET";
    TYPE["NEXT"] = "NEXT";
    TYPE["REVIEW"] = "REVIEW";
    TYPE["APPLY"] = "APPLY";
    TYPE["MERGE"] = "MERGE";
    TYPE["CREATE_NEW"] = "CREATE_NEW";
    TYPE["ACCEPT"] = "ACCEPT";
    TYPE["RESUME_UPLOAD"] = "RESUME_UPLOAD";
})(TYPE || (TYPE = {}));
var ITEM_TYPE;
(function (ITEM_TYPE) {
    ITEM_TYPE["SCREEN"] = "SCREEN";
    ITEM_TYPE["POPUP"] = "POPUP";
})(ITEM_TYPE || (ITEM_TYPE = {}));
var ITEM;
(function (ITEM) {
    ITEM["LOGIN"] = "LOGIN";
    ITEM["HOME_PAGE"] = "HOME_PAGE";
    ITEM["LEARN_MORE"] = "LEARN_MORE";
    ITEM["WHATS_NEW"] = "WHATS_NEW";
    ITEM["READ_CASE_STUDY"] = "READ_CASE_STUDY";
    ITEM["SEE_MORE_CASE_STUDIES"] = "SEE_MORE_CASE_STUDIES";
    ITEM["ADD_BUILDING"] = "ADD_BUILDING";
    ITEM["REQUEST_A_DEMO"] = "REQUEST_A_DEMO";
    ITEM["SELECT_CUSTOMER"] = "SELECT_CUSTOMER";
    ITEM["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    ITEM["SIGN_OUT"] = "SIGN_OUT";
    ITEM["LOCATION_HIERARCHY"] = "LOCATION_HIERARCHY";
    ITEM["MORE_ACTIONS"] = "LOCATION_HIERARCHY";
    ITEM["TEAM"] = "TEAM";
    ITEM["INVITE_USER_CREATE"] = "INVITE_USER_CREATE";
    ITEM["INVITE_USER_EDIT"] = "INVITE_USER_EDIT";
    ITEM["OPEN_ROAMING_INVITE_USER_CREATE"] = "OPEN_ROAMING_INVITE_USER_CREATE";
    ITEM["OPEN_ROAMING_INVITE_USER_EDIT"] = "OPEN_ROAMING_INVITE_USER_EDIT";
    ITEM["INVITE_USER_DELETE"] = "INVITE_USER_DELETE";
    ITEM["USER_ROLE_POPUP"] = "USER_ROLE_POPUP";
    ITEM["LOCATIONS"] = "LOCATIONS";
    ITEM["RESEND"] = "RESEND";
    ITEM["CHANGE_PASSWORD"] = "CHANGE_PASSWORD";
    ITEM["MERAKI_ACCOUNT_SETTINGS"] = "MERAKI_ACCOUNT_SETTINGS";
    ITEM["MERAKI_ACCOUNT_SETTINGS_CONNECT"] = "MERAKI_ACCOUNT_SETTINGS_CONNECT";
    ITEM["SETTINGS"] = "SETINGS";
    ITEM["SMS"] = "SMS";
    ITEM["SMS_ADD"] = "SMS_ADD";
    ITEM["SMS_EDIT"] = "SMS_EDIT";
    ITEM["SMS_DELETE"] = "SMS_DELETE";
    ITEM["SOCIAL_APPS"] = "SOCIAL_APPS";
    ITEM["SOCIAL_APPS_FACEBOOK_APP"] = "SOCIAL_APPS_FACEBOOK_APP";
    ITEM["SOCIAL_APPS_GOOGLE_APP"] = "SOCIAL_APPS_GOOGLE_APP";
    ITEM["SOCIAL_APPS_TWITTER_APP"] = "SOCIAL_APPS_TWITTER_APP";
    ITEM["SOCIAL_APPS_LINKEDIN_APP"] = "SOCIAL_APPS_LINKEDIN_APP";
    ITEM["NOTIFICATION_CHANNELS"] = "NOTIFICATION_CHANNELS";
    ITEM["NOTIFICATION_CHANNELS_ADD"] = "NOTIFICATION_CHANNELS_ADD";
    ITEM["BLE_UUIDS"] = "BLE_UUIDS";
    ITEM["SDK"] = "BLE_UUIDS";
    ITEM["SDK_ANDROID_IOS_COPY_CREDENTIALS"] = "SDK_ANDROID_IOS_COPY_CREDENTIALS";
    ITEM["SDK_HELP_ANDROID_IOS_COPY_CREDENTIALS"] = "SDK_HELP_ANDROID_IOS_COPY_CREDENTIALS";
    ITEM["SDK_HELP_ANDROID_IOS_COPY_CREDENTIALS_DOWNLOAD"] = "SDK_HELP_ANDROID_IOS_COPY_CREDENTIALS_DOWNLOAD";
    ITEM["SSID"] = "SSID";
    ITEM["CONFIGURE_SSIDS_MANUALLY"] = "CONFIGURE_SSIDS_MANUALLY";
    ITEM["IMPORT_CONFIGURE_SSID"] = "IMPORT_CONFIGURE_SSID";
    ITEM["SSID_DETAILS"] = "SSID_DETAILS";
    ITEM["SSID_DETAILS_ACTIVATE"] = "SSID_DETAILS_ACTIVATE";
    ITEM["SSID_DELETE"] = "SSID_DELETE";
    ITEM["ACTIVATE_USER"] = "ACTIVATE_USER";
    ITEM["RESET_PASSWORD"] = "RESET_PASSWORD";
    ITEM["CSS_EDITOR_TAB"] = "CSS_EDITOR_TAB";
    ITEM["CSS_EDITOR_UPLOAD"] = "CSS_EDITOR_UPLOAD";
    ITEM["CSS_EDITOR_SAVE"] = "CSS_EDITOR_SAVE";
    ITEM["CSS_EDITOR_PEWVIEW"] = "CSS_EDITOR_PEWVIEW";
    ITEM["CSS_EDITOR_ASSETS"] = "CSS_EDITOR_ASSETS";
    ITEM["PORTAL"] = "PORTAL";
    ITEM["IMPORT_PORTAL"] = "IMPORT_PORTAL";
    ITEM["CREATE_PORTAL"] = "CREATE_PORTAL";
    ITEM["EDIT_PORTAL"] = "EDIT_PORTAL";
    ITEM["DELETE_PORTAL"] = "DELETE_PORTAL";
    ITEM["ADD_LOCATIONS"] = "ADD_LOCATIONS";
    ITEM["RENAME_PORTAL"] = "RENAME_PORTAL";
    ITEM["EXPORT_PORTAL"] = "EXPORT_PORTAL";
    ITEM["LANGUAGE_SUPPORT"] = "LANGUAGE_SUPPORT";
    ITEM["EDIT_LOCATIONS"] = "EDIT_LOCATIONS";
    ITEM["EDIT_AUTHENTICATION"] = "EDIT_AUTHENTICATION";
    ITEM["EDIT_TERMSANDCONDITIONS"] = "EDIT_TERMSANDCONDITIONS";
    ITEM["ACCESS_CODE"] = "ACCESS_CODE";
    ITEM["ACCESS_CODE_LISTING"] = "ACCESS_CODE_LISTING";
    ITEM["ACCESS_CODE_CREATE"] = "ACCESS_CODE_CREATE";
    ITEM["ACCESS_CODE_EDIT"] = "ACCESS_CODE_EDIT";
    ITEM["ACCESS_CODE_SHARE"] = "ACCESS_CODE_SHARE";
    ITEM["ACCESS_CODE_DELETE"] = "ACCESS_CODE_DELETE";
    ITEM["SFTP_AUTHENTICATION"] = "SFTP_AUTHENTICATION";
    ITEM["GCS_AUTHENTICATION"] = "GCS_AUTHENTICATION";
    ITEM["S3_AUTHENTICATION"] = "S3_AUTHENTICATION";
    ITEM["AZURE_BLOB_AUTHENTICATION"] = "AZURE_BLOB_AUTHENTICATION";
    ITEM["BOX_AUTHENTICATION"] = "BOX_AUTHENTICATION";
    ITEM["CREATE_DATA_EXPORT"] = "CREATE_DATA_EXPORT";
    ITEM["DELETE_DATA_EXPORT"] = "DELETE_DATA_EXPORT";
    ITEM["CMX_ON_PREM"] = "CMX_ON_PREM";
    ITEM["SPACES_CONNECTOR"] = "SPACES_CONNECTOR";
    ITEM["WLC_LIST"] = "WLC_LIST";
    ITEM["PARTNER_LOGIN"] = "PARTNER_LOGIN";
    ITEM["PARTNER_APP_CENTER"] = "PARTNER_APP_CENTER";
    ITEM["PARTNER_APP_ACTIVATION"] = "PARTNER_APP_ACTIVATION";
    ITEM["PARTNER_SANDBOX_HOME"] = "PARTNER_HOME";
    ITEM["PARTNER_HOME"] = "PARTNER_HOME";
    ITEM["PARTNER_SSO_LOGIN"] = "PARTNER_SSO_LOGIN";
    ITEM["PARTNER_OAUTH_VALIDATION"] = "PARTNER_OAUTH_VALIDATION";
    ITEM["SETUP_WIRELESS_NETWORKS"] = "SETUP_WIRELESS_NETWORKS";
    ITEM["LOCATION_DETAIL"] = "LOCATION_DETAIL";
    ITEM["UPDATE_PROFILE"] = "UPDATE_PROFILE";
    ITEM["VERIFY_PHONE_NUMBER"] = "VERIFY_PHONE_NUMBER";
    ITEM["SKIP_THIS_BUILDING"] = "SKIP_THIS_BUILDING";
    ITEM["PUBLISH_RICHMAPS"] = "PUBLISH_RICHMAPS";
    ITEM["MAPPING_FLOORS_WITH_CAD_FILE_LEVELS"] = "MAPPING_FLOORS_WITH_CAD_FILE_LEVELS";
    ITEM["ADD_FLOOR"] = "ADD_FLOOR";
    ITEM["RICHMAPS_LOCATION_LIST"] = "RICHMAPS_LOCATION_LIST";
    ITEM["RICHMAPS_BUILDING_DETAILS"] = "RICHMAPS_BUILDING_DETAILS";
    ITEM["LOCATIONS_AND_MAPS_RECENT_HISTORY"] = "LOCATIONS_AND_MAPS_RECENT_HISTORY";
    ITEM["RICHMAPS_LOCATIONS_LIST"] = "RICHMAPS_LOCATIONS_LIST";
    ITEM["RICHMAPS_UPLOAD_CAD_FILE"] = "RICHMAPS_UPLOAD_CAD_FILE";
    ITEM["RICHMAPS_UPDATE_LOCATION_DETAILS"] = "RICHMAPS_UPDATE_LOCATION_DETAILS";
    ITEM["RICHMAPS_ADD_RICHMAPS_EVENTS"] = "RICHMAPS_ADD_RICHMAPS_EVENTS";
    ITEM["RICHMAPS_ADD"] = "RICHMAPS_ADD";
    ITEM["RICHMAPS_EDIT"] = "RICHMAPS_EDIT";
    ITEM["RICHMAPS_VIEW"] = "RICHMAPS_VIEW";
    ITEM["RICHMAPS_DELETE"] = "RICHMAPS_DELETE";
    ITEM["RICHMAPS_CANCEL"] = "RICHMAPS_CANCEL";
    ITEM["RICHMAPS_REVIEW"] = "RICHMAPS_REVIEW";
    ITEM["RICHMAPS_FILTER_APPLY"] = "RICHMAPS_FILTER_APPLY";
    ITEM["RICHMAPS_FILTER_CLEAR"] = "RICHMAPS_FILTER_CLEAR";
    ITEM["ADD_LOCATION_MANUALLY"] = "ADD_LOCATION_MANUALLY";
    ITEM["CMX_IMPORT"] = "CMX_IMPORT";
    ITEM["DNAC_IMPORT"] = "DNAC_IMPORT";
    ITEM["MERAKI_IMPORT"] = "MERAKI_IMPORT";
    ITEM["PRIME_IMPORT"] = "PRIME_IMPORT";
    ITEM["EXCEL_IMPORT"] = "EXCEL_IMPORT";
    ITEM["IMPORT_TYPE_SELECTION"] = "IMPORT_TYPE_SELECTION";
    ITEM["RICHMAPS"] = "RICHMAPS";
    ITEM["LOCATIONS_AND_MAPS"] = "LOCATIONS_AND_MAPS";
    ITEM["NETWORK_MAP"] = "NETWORK_MAP";
    ITEM["MERGE_LOCATIONS"] = "MERGE_LOCATIONS";
    ITEM["STANDARD_MAP"] = "STANDARD_MAP";
    ITEM["FLOOR_LIST"] = "FLOOR_LIST";
})(ITEM || (ITEM = {}));
class InteractionLog {
    constructor(interactionType, userPosition, additionalInfo, section, itemType, item, details, url) {
        this.interactionType = interactionType;
        this.userPosition = userPosition;
        this.additionalInfo = additionalInfo;
        this.section = section;
        this.itemType = itemType;
        this.item = item;
        this.details = details;
        this.url = url;
    }
}

/* eslint-disable @typescript-eslint/no-floating-promises */
class InteractionService {
    constructor(dataService, authService, httpClientWrapper) {
        this.dataService = dataService;
        this.authService = authService;
        this.httpClientWrapper = httpClientWrapper;
        this.apiConfig = new ApiConfig();
        this.loggedIn = false;
        this.interactionLoggingObserver = null;
        this.doLogWithLicenseType = (url, log, opts) => {
            const unsubscribe$ = new Subject();
            this.authService.getLicenseType(unsubscribe$).then((licenseType) => {
                // this.licenseType = licenseType;
                if (licenseType) {
                    log.licenseType = licenseType.value;
                }
                this.httpClientWrapper
                    .post(url, log, opts)
                    .pipe(takeUntil(unsubscribe$))
                    .subscribe(() => {
                    // console.log(res);
                }, (err) => {
                    console.log("Error while doLogWithLicenseType ", err);
                    this.dataService.setApiResponseErrorHandler(err);
                }, () => {
                    unsubscribe$.next();
                    unsubscribe$.complete();
                });
            });
        };
        this.sendInteractionLog = (log) => {
            const url = this.apiConfig.getInteractionLogUrl();
            this.loggedIn = this.dataService.getAccessToken() != null;
            if (this.loggedIn) {
                this.doLogWithLicenseType(url, log);
            }
        };
        this.doInteractionLog = (log) => {
            if (this.dataService.getCanDoInteractionLog()) {
                setTimeout(() => {
                    // this.getLicenceType();
                    this.sendInteractionLog(log);
                }, 50);
            }
            return;
        };
    }
}
InteractionService.ɵfac = function InteractionService_Factory(t) { return new (t || InteractionService)(i0.ɵɵinject(DataService), i0.ɵɵinject(AuthService), i0.ɵɵinject(HttpClientWrapperService)); };
InteractionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: InteractionService, factory: InteractionService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InteractionService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: AuthService }, { type: HttpClientWrapperService }]; }, null); })();

class BaseService {
    constructor(injector) {
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.logoutObserver = null;
        this.doSignout = () => {
            const userNameForInteractionLog = this.dataService.getUserName();
            const signoutStr = "LOGOUT: User " + userNameForInteractionLog + " has signed out";
            this.interactionService.doInteractionLog(new InteractionLog(TYPE.LOGOUT, this.dataService.getPosition(), "{}", SECTION.SIGN_OUT, ITEM_TYPE.POPUP, ITEM.SIGN_OUT, signoutStr, this.dataService.getCurrentNav()));
            this.dataService.removeFromStorage('smartBannerState');
            this.logoutObserver = this.httpClientWrapper
                .post(this.apiConfig.getLogoutUrl(), {})
                .subscribe({
                next: (data) => {
                    console.log(data);
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {
                    this.onComplete();
                }
            });
        };
        this.onComplete = () => {
            this.doClearSignout();
            if (this.logoutObserver) {
                this.logoutObserver.unsubscribe();
            }
        };
        this.doClearSignout = () => {
            this.cookieService.clearAll();
            this.dataService.clearAll();
            void this.router.navigate(["/logout"]);
            // this.router.dispose();
            // setTimeout(() => {
            //   location.reload(true);
            // }, 1000);
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getPlainText = (url, options) => {
            return this.httpClientWrapper.getPlainText(url, options)
                .pipe(catchError$1((this.handleErrorObservable)));
        };
        this.get = (url, options) => {
            if (this.httpClientWrapper)
                return this.httpClientWrapper
                    .get(url, options)
                    .pipe(catchError$1(this.handleErrorObservable));
        };
        this.post = (url, postBody, options) => {
            return this.httpClientWrapper
                .post(url, postBody, options)
                .pipe(catchError$1(this.handleErrorObservable));
        };
        this.delete = (url, options) => {
            return this.httpClientWrapper
                .delete(url, options)
                .pipe(catchError$1(this.handleErrorObservable));
        };
        this.put = (url, putData, options) => {
            return this.httpClientWrapper
                .put(url, putData, options)
                .pipe(catchError$1(this.handleErrorObservable));
        };
        // formUrlParam = (url, data) => {
        // 	let queryString = "";
        // 	for (const key in data) {
        // 		if (data.hasOwnProperty(key)) {
        // 			if (!queryString) {
        // 				queryString = `?${key}=${data[key]}`;
        // 			} else {
        // 				queryString += `&${key}=${data[key]}`;
        // 			}
        // 		}
        // 	}
        // 	return url + queryString;
        // };
        this.handleErrorObservable = (error) => {
            console.log("Unauthorised?", error.status === 401, JSON.stringify(error), JSON.stringify(error).indexOf("Unauthorized") > -1);
            let unauthorisedAccess = false;
            if (JSON.stringify(error).indexOf("Unauthorized") > -1) {
                unauthorisedAccess = true;
            }
            // console.log('Error message:', JSON.parse(error._body)['message']);
            if (unauthorisedAccess) {
                this.dataService.setToastMessage("Your Session has expired. Please login again.", 4000, null, null, "error");
                setTimeout(() => {
                    this.doSignout();
                }, 1000);
            }
            return throwError(() => error.error);
        };
        if (injector) {
            this.cookieService = injector.get(CookieService);
            this.router = injector.get(Router);
            this.dataService = injector.get(DataService);
            this.interactionService = injector.get(InteractionService);
            this.logger = injector.get(LoggerService);
            this.httpClientWrapper = injector.get(HttpClientWrapperService);
        }
        else {
            console.log("Injector is null");
        }
        this.util = new Utils(this.logger);
    }
}
BaseService.ɵfac = function BaseService_Factory(t) { return new (t || BaseService)(i0.ɵɵinject(i0.Injector)); };
BaseService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BaseService, factory: BaseService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: i0.Injector }]; }, null); })();

class LocationService extends BaseService {
    constructor(dataService, interactionService, injector) {
        super(injector);
        this.dataService = dataService;
        this.interactionService = interactionService;
        this.injector = injector;
        this.locationMap = {};
        this.apiConfig = new ApiConfig(this.dataService);
        this.getLocInfoCountryListUrl = "/assets/data/locInfo-country-list.json?";
        this.getLocInfoCountryStateListUrl = "/assets/data/locInfo-country-state-list.json?";
        this.getGraphDBLocHierarchyUrl = "/assets/data/graphdb-mongodb-loc-list.json?";
        this.extractTreeData = (res) => {
            try {
                this.dataService.setLocationLoadingStatus({
                    key: "location_hierarchy",
                    status: "loading",
                    time: new Date().getTime()
                });
                this.startTime = new Date().getTime();
                const responseString = res; //.text();
                // console.log("responseString :: ", responseString)
                const p1 = responseString.indexOf(LocationRow.locTableKey);
                if (p1 == -1)
                    return JSON.parse(responseString);
                const p2 = p1 + LocationRow.locTableKey.length;
                const p3 = responseString.indexOf('"', p2);
                const locationTableData = responseString.substring(p2, p3);
                const resp = JSON.parse(responseString.substring(0, p1) +
                    responseString.substring(p3 + 1));
                if (resp.status == true && resp.data != null) {
                    const locationWrapper = this.utils.locationUtil.convertTree(resp.data, locationTableData);
                    // setting mongodb ids and graph db ids in dataservice
                    this.dataService.setDBIdConversionMap(locationWrapper.locationsMap);
                    this.dataService.setLocationObjectArray(locationWrapper.locationsMap);
                    // this.dataService.setLicenseDetails(
                    // 	locationWrapper.licenseDetails
                    // );
                    this.dataService.setRootLocation(locationWrapper.rootLocation);
                    delete locationWrapper.locationsMap;
                    delete locationWrapper.licenseDetails;
                    delete locationWrapper.rootLocation;
                    this.dataService.setLocationWrap(locationWrapper);
                    console.log("(extractTreeData) locations converted into tree", new Date().getTime() - this.startTime);
                    return locationWrapper;
                }
                else {
                    throw throwError(res.json().message);
                }
            }
            catch (e) {
                // an error occurred
                this.dataService.setLocationLoadingStatus({
                    key: "location_hierarchy",
                    status: "error",
                    time: new Date().getTime()
                });
                throw throwError(res.json());
            }
        };
        this.extractResponseDatas = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.renameLocation = (locationId, locationName) => {
            const serverUrl = this.apiConfig.getLocationRenameUrl() + "/" + locationId;
            //console.log(serverUrl);
            const locationRenameObj = {
                locationName: locationName
            };
            const options = {
                responseType: "text"
            };
            //return this.getLocationTree();
            return this.post(serverUrl, locationRenameObj, options).pipe(map(this.extractTreeData));
        };
        this.deleteLocation = (locationId) => {
            const serverUrl = this.apiConfig.getLocationDeleteUrl() + "/" + locationId;
            //console.log(serverUrl);
            //return this.getLocationTree();
            const options = {
                responseType: "text"
            };
            return this.delete(serverUrl, options).pipe(map(this.extractResponse));
        };
        this.getDeleteLocationStatus = (locationId) => {
            const serverUrl = this.apiConfig.getDeleteLocationStatus() + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.locationTimezone = (locationId, timezone) => {
            let timezoneId = "";
            if (timezone)
                timezoneId = timezone.split(" ")[0];
            const serverUrl = this.apiConfig.getLocationTimezoneUrl() + "/" + locationId;
            //console.log(serverUrl);
            const locationTimezoneObj = {
                timezone: timezoneId
            };
            const options = {
                responseType: "text"
            };
            //console.log(locationTimezoneObj);
            return this.post(serverUrl, locationTimezoneObj, options).pipe(map(this.extractTreeData));
        };
        this.searchAPs = (token, searchTimestamp) => {
            const serverUrl = this.apiConfig.getLocationSearchAPsUrl() +
                "?token=" +
                encodeURIComponent(token) +
                "&timestamp=" +
                searchTimestamp;
            //console.log(serverUrl);
            return this.get(serverUrl).pipe(map(this.extractSearchData));
        };
        this.getAccessPointList = (locationId) => {
            const serverUrl = this.apiConfig.getAccessPointListUrl() + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.getWebexDeviceList = (locationId) => {
            const serverUrl = this.apiConfig.fetchWebexDevicesUrl() + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.getSensorList = (locationId) => {
            const serverUrl = this.apiConfig.fetchSensorDevicesUrl() + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.getMetadata = (locationId) => {
            const serverUrl = this.apiConfig.getMetadataUrl() + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.addLocationMetadata = (locationId, addMetadataObj) => {
            const serverUrl = this.apiConfig.getAddLocationMetadataUrl() + "/" + locationId;
            const options = {
                responseType: "text"
            };
            return this.post(serverUrl, addMetadataObj, options).pipe(map(this.extractTreeData));
        };
        this.modifyLocationMetadata = (locationId, modifyMetadataObj) => {
            const serverUrl = this.apiConfig.getModifyLocationMetadataUrl() + "/" + locationId;
            const options = {
                responseType: "text"
            };
            return this.post(serverUrl, modifyMetadataObj, options).pipe(map(this.extractTreeData));
        };
        this.deleteLocationMetadata = (locationId, metadataObj) => {
            const serverUrl = this.apiConfig.getDeleteLocationMetadataUrl() + "/" + locationId;
            const options = {
                responseType: "text"
            };
            //console.log(serverUrl);
            return this.post(serverUrl, metadataObj, options).pipe(map(this.extractTreeData));
        };
        this.getBleBeaconList = (locationId) => {
            const serverUrl = this.apiConfig.getBleBeaconListUrl() + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.getRulesList = (locationId, ruleType) => {
            const bodyPayload = {
                locationId: locationId.toString(),
                ruleType: ruleType
            };
            if (ruleType == "Density") {
                const serverUrl = this.apiConfig.getDensityRuleslistUrl();
                return this.post(serverUrl, bodyPayload).pipe(map(this.extractResponseData));
            }
            const serverUrl = this.apiConfig.getRuleslistUrl();
            return this.post(serverUrl, bodyPayload).pipe(map(this.extractResponseData));
        };
        this.getEngagementRulesReport = (locationId, ruleType) => {
            const bodyPayload = {
                locationId: locationId.toString(),
                ruleType: ruleType
            };
            const serverUrl = this.apiConfig.getEngagementRulesReportUrl();
            return this.post(serverUrl, bodyPayload).pipe(map(this.extractResponseData));
        };
        this.getSyncStatus = (id) => {
            const serverUrl = this.apiConfig.getSyncStatusUrl() + "/" + id;
            return this.get(serverUrl).pipe(map(this.extractResponseData), catchError(this.handleErrorObservable));
        };
        this.getWirelessProviders = () => {
            const serverUrl = this.apiConfig.getWirelessProvidersUrl();
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.createLocation = (data) => {
            const serverUrl = this.apiConfig.getCreateLocationUrl();
            const options = {
                responseType: "text"
            };
            return this.post(serverUrl, data, options).pipe(map(this.extractTreeData));
        };
        this.authenticateMSE = (data) => {
            const serverUrl = this.apiConfig.getAuthenticateMSEUrl();
            //console.log(serverUrl);
            // return this.getLocationTree();
            return this.post(serverUrl, data).pipe(map(this.extractResponse));
        };
        this.createMSELocation = (data) => {
            const serverUrl = this.apiConfig.getCreateMSELocationUrl();
            //console.log(serverUrl);
            // return this.getLocationTree();
            const options = {
                responseType: "text"
            };
            return this.post(serverUrl, data, options).pipe(map(this.extractTreeData));
        };
        this.getManualUploadCampusData = (data) => {
            const serverUrl = this.apiConfig.getManualUploadCampusDataUrl();
            //console.log(serverUrl);
            // return this.getLocationTree();
            return this.post(serverUrl, data).pipe(map(this.extractResponse));
        };
        this.addWLCController = (data) => {
            const serverUrl = this.apiConfig.getCreateLocationUrl();
            //console.log(serverUrl);
            // return this.getLocationTree();
            return this.post(serverUrl, data).pipe(map(this.extractResponse));
        };
        this.updateMSELocation = (data) => {
            const serverUrl = this.apiConfig.getupdateMSELocationUrl();
            const options = {
                responseType: "text"
            };
            return this.post(serverUrl, data, options).pipe(map(this.extractTreeData));
        };
        this.updateWLCController = (data) => {
            const serverUrl = this.apiConfig.getupdateWLCControllerUrl();
            //console.log(serverUrl);
            // return this.getLocationTree();
            return this.post(serverUrl, data).pipe(map(this.extractResponse));
        };
        this.deleteController = (data) => {
            const serverUrl = this.apiConfig.getDeleteControllerUrl();
            return this.post(serverUrl, data).pipe(map(this.extractResponse));
        };
        this.getAvailableLocations = (locationId) => {
            const serverUrl = this.apiConfig.getAvailableLocationsUrl() + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getAvailableLocationsByType = (locationId, menu_type) => {
            const serverUrl = this.apiConfig.getAvailableLocationsByTypeUrl(menu_type) + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getNetworksforOrg = (orgId) => {
            const serverUrl = this.apiConfig.getNetworksforOrgUrl() + "/" + orgId;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.saveMerakiOrganisation = (merakiObj) => {
            const serverUrl = this.apiConfig.getSaveMerakiOrganisationUrl();
            const options = {
                responseType: "text"
            };
            return this.post(serverUrl, merakiObj, options).pipe(map(this.extractTreeData));
        };
        this.importMerakiNetworks = (merakiObj) => {
            const serverUrl = this.apiConfig.getSaveMerakiOrganisationUrl();
            return this.post(serverUrl, merakiObj).pipe(map(this.extractResponse));
        };
        this.getAvailableAps = (locationId) => {
            const serverUrl = this.apiConfig.getAvailableApsUrl() + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getMetadataKeys = () => {
            const serverUrl = this.apiConfig.getMetadataKeysUrl();
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.loginToMerakiWireless = (authObj) => {
            const serverUrl = this.apiConfig.getAuthenticateMeraki();
            return this.post(serverUrl, authObj).pipe(map(this.extractResponse));
        };
        this.disconnectMerakiLogin = (authObj) => {
            const serverUrl = this.apiConfig.getDisconnectMeraki();
            return this.post(serverUrl, authObj).pipe(map(this.extractResponse));
        };
        this.getWirelessProviderAuthStatus = () => {
            const serverUrl = this.apiConfig.getWirelessProviderAuthStatusUrl();
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.getLocationSyncStatus = () => {
            const serverUrl = this.apiConfig.getLocationSyncStatusUrl();
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.getWPLocationSyncStatus = (type) => {
            if (type == "Cisco Meraki")
                type = "MERAKI";
            if (type == "CMX On Prem")
                type = "MSE";
            if (type == "WLC Direct Connect")
                type = "WLC";
            const serverUrl = this.apiConfig.getWPLocationSyncStatusUrl() +
                "/" +
                type +
                "/normal";
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.fetchOrganizationsByApi = (data) => {
            const serverUrl = this.apiConfig.getAuthenticateMeraki();
            return this.post(serverUrl, data).pipe(map(this.extractResponse));
        };
        this.getMerakiApiKeysList = () => {
            const serverUrl = this.apiConfig.getMerakiApiKeysListUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getMerakiAccessTokensList = () => {
            const serverUrl = this.apiConfig.getMerakiAccessTokensListUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getAvailableControllerIps = (locationId) => {
            const serverUrl = this.apiConfig.getAvailableControllerIpsUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getAvailableWLCControllerIps = (wlcType) => {
            const serverUrl = this.apiConfig.getAvailableWLCControllerIpsUrl() + "/" + wlcType;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getAllWLCControllerIps = (locationId) => {
            const serverUrl = this.apiConfig.getAllWLCControllerIpsUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getWLCControllerIps = () => {
            const serverUrl = this.apiConfig.getWLCControllerIpsUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getAvailableWLCAPs = (data) => {
            const serverUrl = this.apiConfig.getAvailableWLCAPsUrl();
            return this.post(serverUrl, data).pipe(map(this.extractResponse));
        };
        this.getEditWLCController = (locationId) => {
            const serverUrl = this.apiConfig.getEditWLCControllerUrl() + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getAvailableWLCNetworks = (data) => {
            const serverUrl = this.apiConfig.getAvailableWLCNetworksUrl();
            return this.post(serverUrl, data).pipe(map(this.extractResponse));
        };
        this.createGroup = (data) => {
            const serverUrl = this.apiConfig.getCreateLocationUrl();
            const options = {
                responseType: "text"
            };
            return this.post(serverUrl, data, options).pipe(map(this.extractTreeData));
        };
        this.addNetworkLocation = (data) => {
            const serverUrl = this.apiConfig.getAddNetworkLocationUrl();
            return this.post(serverUrl, data).pipe(map(this.extractResponse));
        };
        this.getGroupLocationCreate = (locationId) => {
            const serverUrl = this.apiConfig.getGroupLocationCreateUrl() + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getGroupLocationEdit = (locationId) => {
            const serverUrl = this.apiConfig.getGroupLocationEditUrl() + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getMSELocation = (locationId) => {
            const serverUrl = this.apiConfig.getMSELocationUrl() + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.extractSearchData = (res) => {
            // console.log('searchAPs', res.json());
            return res.data;
        };
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.signOut = () => {
            this.dataService.display(true);
            this.doSignout();
        };
        this.addBleBeacon = (locationId, addBleBeaconObj) => {
            const serverUrl = this.apiConfig.getAddBleBeaconUrl() + "/" + locationId;
            return this.post(serverUrl, addBleBeaconObj).pipe(map(this.extractResponse));
        };
        this.editBleBeacon = (locationId, addBleBeaconObj) => {
            const serverUrl = this.apiConfig.getEditBleBeaconUrl() + "/" + locationId;
            return this.post(serverUrl, addBleBeaconObj).pipe(map(this.extractResponseData));
        };
        this.getBleBeacon = (locationId, addBleBeaconObj) => {
            const serverUrl = this.apiConfig.getBleBeaconUrl() + "/" + locationId;
            return this.post(serverUrl, addBleBeaconObj).pipe(map(this.extractResponseData));
        };
        this.deleteBleBeacon = (locationId, addBleBeaconObj) => {
            const serverUrl = this.apiConfig.getDeleteBleBeaconUrl() + "/" + locationId;
            return this.post(serverUrl, addBleBeaconObj).pipe(map(this.extractResponseData));
        };
        this.getTimeZones = () => {
            const serverUrl = this.apiConfig.getTimeZoneUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getCountryList = () => {
            return this.get(this.getLocInfoCountryListUrl).pipe(map(this.extractResponse));
        };
        this.getCountryStateList = () => {
            return this.get(this.getLocInfoCountryStateListUrl).pipe(map(this.extractResponse));
        };
        this.getLocationInfo = (locationId) => {
            const serverUrl = this.apiConfig.getLocationInfoUrl() + "/" + locationId;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.updateLocationInfo = (locationInfoObj) => {
            const serverUrl = this.apiConfig.updateLocationInfoUrl();
            return this.post(serverUrl, locationInfoObj).pipe(map(this.extractResponse));
        };
        this.getMerakiLoginNetworkCount = () => {
            const serverUrl = this.apiConfig.getMerakiLoginNetworkCountUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getMerakiCameraLoginNetworkCount = () => {
            const serverUrl = this.apiConfig.getMerakiCameraLoginNetworkCountUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getMerakiAPINetworkCount = () => {
            const serverUrl = this.apiConfig.getMerakiAPINetworkCountUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getMerakiCameraAPINetworkCount = () => {
            const serverUrl = this.apiConfig.getMerakiCameraAPINetworkCountUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getCMXMapsCount = () => {
            const serverUrl = this.apiConfig.getCMXMapsCountUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getWLCCount = () => {
            const serverUrl = this.apiConfig.getWLCCountUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getCMXLocations = () => {
            const serverUrl = this.apiConfig.getCMXLocationsUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getCMXLocationsCount = () => {
            const serverUrl = this.apiConfig.getCMXLocationsCountUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getLoginHistory = () => {
            const serverUrl = this.apiConfig.getLoginHistoryUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getSuccessLoginHistory = () => {
            const serverUrl = this.apiConfig.getSuccessLoginHistoryUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getFailureLoginHistory = () => {
            const serverUrl = this.apiConfig.getFailureLoginHistoryUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getMerakiCameraList = (payload) => {
            const serverUrl = this.apiConfig.getMerakiCameraListUrl();
            return this.post(serverUrl, payload).pipe(map(this.extractResponse));
        };
        this.getCameraSnapshot = (payload) => {
            const serverUrl = this.apiConfig.getMerakiCameraSnapshotUrl();
            return this.post(serverUrl, payload).pipe(map(this.extractResponse));
        };
        this.getCameraQualityAndRetention = (payload) => {
            const serverUrl = this.apiConfig.getMerakiCameraRetentionDetailsUrl();
            return this.post(serverUrl, payload).pipe(map(this.extractResponse));
        };
        this.updateCameraTripWirePoints = (payload) => {
            const serverUrl = this.apiConfig.getUpdateTripWireUrl();
            return this.put(serverUrl, payload).pipe(map(this.extractResponse));
        };
        this.getSSORedirect = (userName) => {
            const serverUrl = this.apiConfig.getSSORedirectUrl(userName);
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getDomainList = () => {
            const serverUrl = this.apiConfig.getDomainListUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.addDomain = (domainName) => {
            const serverUrl = this.apiConfig.addDomainUrl(domainName);
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.removeDomain = (domainName) => {
            const serverUrl = this.apiConfig.removeDomainUrl(domainName);
            return this.delete(serverUrl).pipe(map(this.extractResponse));
        };
        this.getPrefixList = (jsonobj) => {
            const serverUrl = this.apiConfig.getPrefixListUrl();
            return this.post(serverUrl, jsonobj).pipe(map(this.extractResponse));
        };
        this.savePrefix = (prefixListObj) => {
            const serverUrl = this.apiConfig.getSavePrefixUrl();
            return this.post(serverUrl, prefixListObj).pipe(map(this.extractResponse));
        };
        this.getLocationCount = () => {
            const serverUrl = this.apiConfig.getLocationCount();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getMerakiSyncStatus = () => {
            const serverUrl = this.apiConfig.getMerakiSyncStatusUrl();
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.getCameraUserFeed = (payload) => {
            const bodyPayload = payload;
            const serverUrl = this.apiConfig.getCameraUserFeedPollingURL();
            return this.post(serverUrl, bodyPayload).pipe(map(this.extractResponseData));
        };
        this.getMetadataKeyListlh2 = () => {
            let serverUrl = this.apiConfig.getMetadataKeysLh2Url();
            return this.get(serverUrl)
                .pipe(map(this.extractResponse));
        };
        this.getMetadataListLh2 = (locationId) => {
            let serverUrl = this.apiConfig.getMetadataUrl() + "/" + locationId; //existing one
            return this.get(serverUrl)
                .pipe(map(this.extractResponse));
        };
        this.saveLocationMetadata = (locationId, addMetadataObj) => {
            let serverUrl = this.apiConfig.getAddLocationMetadataUrllh2() + "/" + locationId;
            return this.post(serverUrl, addMetadataObj)
                .pipe(map(this.extractResponse));
        };
        this.editLocationMetadata = (locationId, metadataObj) => {
            let serverUrl = this.apiConfig.getModifyLocationMetadataUrl() + "/" + locationId;
            return this.post(serverUrl, metadataObj)
                .pipe(map(this.extractResponse));
        };
        this.deleteLocationMetadataLh2 = (locationId, metadataObj) => {
            let serverUrl = this.apiConfig.getDeleteLocationMetadataUrl() + "/" + locationId;
            return this.post(serverUrl, metadataObj)
                .pipe(map(this.extractResponse));
        };
        this.getAllMetadata = () => {
            const serverUrl = this.apiConfig.getAllMetadataUrl();
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.getSupportLoginStatus = () => {
            const serverUrl = this.apiConfig.getSupportLoginStatus();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.updateSupportLoginStatus = (status) => {
            const serverUrl = this.apiConfig.updateSupportLoginStatus(status);
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.utils = new Utils(this.logger);
    }
    getCPLocationTree() {
        console.log("getting locations, in location service : getLocationTree");
        this.startTime = new Date().getTime();
        const options = {
            responseType: "text"
        };
        return this.get(this.apiConfig.getCPLocationListUrl(), options).pipe(map(this.extractTreeData));
        // testing purpose
        // return this.get(this.getGraphDBLocHierarchyUrl, options)
        //     .pipe(map(this.extractTreeData));
    }
    getORLocationTree() {
        console.log("getting locations, in location service : getLocationTree");
        this.startTime = new Date().getTime();
        const options = {
            responseType: "text"
        };
        return this.get(this.apiConfig.getORLocationListUrl(), options).pipe(map(this.extractTreeData));
        // testing purpose
        // return this.get(this.getGraphDBLocHierarchyUrl, options)
        //     .pipe(map(this.extractTreeData));
    }
    getLocationTree() {
        //   this.logger.debug('getting locations');
        console.log("getting locations, in location service : getLocationTree");
        this.dataService.setLocationLoadingStatus({
            key: "location_hierarchy",
            status: "loading",
            time: new Date().getTime()
        });
        this.startTime = new Date().getTime();
        const options = {
            responseType: "text"
        };
        return this.get(this.apiConfig.getLocationListUrl(), options).pipe(map(this.extractTreeData));
        // testing purpose
        // return this.get(this.getGraphDBLocHierarchyUrl, options)
        //     .pipe(map(this.extractTreeData));
    }
}
LocationService.ɵfac = function LocationService_Factory(t) { return new (t || LocationService)(i0.ɵɵinject(DataService), i0.ɵɵinject(InteractionService), i0.ɵɵinject(i0.Injector)); };
LocationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LocationService, factory: LocationService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocationService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: InteractionService }, { type: i0.Injector }]; }, null); })();

class Tooltip {
    constructor() {
        this["data"] = {
            id: "",
            title: {
                en: ""
            },
            desc: {
                en: ""
            },
            url: {
                en: ""
            }
        };
    }
    setId(id) {
        this.id = id;
        return this;
    }
    setIsFixed(isFixed = false) {
        this.isFixed = isFixed;
        return this;
    }
    setHTML(html) {
        this.html = html;
        return this;
    }
    setData(id, title, desc, url) {
        this.data.id = id;
        this.data.title = title;
        this.data.desc = desc;
        this.data.url = url;
        return this;
    }
    setPosition(position, forcePosition = false) {
        if (!this.id && !this.html && !this.data.id) {
            throw "Either ID, HTML or Data should be set to use position";
        }
        this.position = position;
        this.forcePosition = forcePosition;
        return this;
    }
}
var POSITION;
(function (POSITION) {
    POSITION["TOP_LEFT"] = "TOP_LEFT";
    POSITION["TOP_MIDDLE"] = "TOP_MIDDLE";
    POSITION["TOP_RIGHT"] = "TOP_RIGHT";
    POSITION["RIGHT_TOP"] = "RIGHT_TOP";
    POSITION["RIGHT_MIDDLE"] = "RIGHT_MIDDLE";
    POSITION["RIGHT_BOTTOM"] = "RIGHT_BOTTOM";
    POSITION["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
    POSITION["BOTTOM_MIDDLE"] = "BOTTOM_MIDDLE";
    POSITION["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    POSITION["LEFT_BOTTOM"] = "LEFT_BOTTOM";
    POSITION["LEFT_MIDDLE"] = "LEFT_MIDDLE";
    POSITION["LEFT_TOP"] = "LEFT_TOP";
})(POSITION || (POSITION = {}));

class DateFilter {
    constructor() {
        this.dateFormat = "";
        this.dateFormat = "yyyy-mm-dd";
        this.inline = true;
        this.showTodayBtn = false;
        this.editableDateField = false;
        this.showClearDateBtn = true;
    }
}

class FocusDirective {
    constructor(element, renderer) {
        this.element = element;
        this.renderer = renderer;
        this.unsubscribe$ = new Subject();
    }
    ngOnInit() {
        if (this.focusEvent)
            this.focusEvent
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((event) => {
                if (event)
                    this.element.nativeElement["focus"].apply(this.element.nativeElement, []);
            });
    }
    ngOnDestroy() {
        console.log("destory focus Directive page");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
FocusDirective.ɵfac = function FocusDirective_Factory(t) { return new (t || FocusDirective)(i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); };
FocusDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FocusDirective, selectors: [["", "focusElement", ""]], inputs: { focusEvent: ["focusElement", "focusEvent"] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FocusDirective, [{
        type: Directive,
        args: [{
                // eslint-disable-next-line @angular-eslint/directive-selector
                selector: "[focusElement]"
            }]
    }], function () { return [{ type: i0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: i0.Renderer2 }]; }, { focusEvent: [{
            type: Input,
            args: ["focusElement"]
        }] }); })();

function SearchComponent_ng_template_0_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵlistener("click", function SearchComponent_ng_template_0_div_1_span_4_Template_span_click_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(3); return ctx_r5.clearSearch($event); });
    i0.ɵɵelement(1, "img", 11);
    i0.ɵɵelementEnd();
} }
const _c0$1G = function (a0, a1) { return { "searchSlide": a0, "noSlide": a1 }; };
function SearchComponent_ng_template_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "form", 6);
    i0.ɵɵelementStart(2, "input", 7);
    i0.ɵɵlistener("keyup", function SearchComponent_ng_template_0_div_1_Template_input_keyup_2_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.onSearchKeyUp($event); });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SearchComponent_ng_template_0_div_1_span_4_Template, 2, 0, "span", 8);
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵlistener("click", function SearchComponent_ng_template_0_div_1_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.showSearch(false); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c0$1G, ctx_r3.searchSlide, !ctx_r3.searchSlide));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("placeholder", "", i0.ɵɵpipeBind1(3, 6, "shared-lib.search_component.search_for"), " ", ctx_r3.messageKeys["apps_label"], "");
    i0.ɵɵproperty("value", ctx_r3.searchText)("focusElement", ctx_r3.searchTextFocusTriggeringEventEmitter);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.searchText && ctx_r3.searchText.length > 0);
} }
function SearchComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("click", function SearchComponent_ng_template_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.showSearch(true); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(1, SearchComponent_ng_template_0_div_1_Template, 6, 11, "div", 4);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.searchSlide);
} }
const _c1$G = function (a0) { return { "showCancelLabel": a0 }; };
function SearchComponent_ng_template_1_div_2_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵlistener("click", function SearchComponent_ng_template_1_div_2_span_5_Template_span_click_0_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(3); return ctx_r15.clearSearch($event); });
    i0.ɵɵelement(1, "img", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1$G, ctx_r13.showCancel));
} }
function SearchComponent_ng_template_1_div_2_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵlistener("click", function SearchComponent_ng_template_1_div_2_span_6_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(3); return ctx_r17.showSearch(false); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.header-navigation-home.cancel"));
} }
function SearchComponent_ng_template_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "form", 6);
    i0.ɵɵelement(2, "img", 16);
    i0.ɵɵelementStart(3, "input", 7);
    i0.ɵɵlistener("keyup", function SearchComponent_ng_template_1_div_2_Template_input_keyup_3_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.onSearchKeyUp($event); });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SearchComponent_ng_template_1_div_2_span_5_Template, 2, 3, "span", 17);
    i0.ɵɵtemplate(6, SearchComponent_ng_template_1_div_2_span_6_Template, 3, 3, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c0$1G, ctx_r12.searchSlide, !ctx_r12.searchSlide));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate2("placeholder", "", i0.ɵɵpipeBind1(4, 7, "shared-lib.search_component.search_for"), " ", ctx_r12.messageKeys["apps_label"], "");
    i0.ɵɵproperty("value", ctx_r12.searchText)("focusElement", ctx_r12.searchTextFocusTriggeringEventEmitter);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r12.searchText && ctx_r12.searchText.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.showCancel);
} }
function SearchComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "img", 13);
    i0.ɵɵlistener("click", function SearchComponent_ng_template_1_Template_img_click_1_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.showSearch(true); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, SearchComponent_ng_template_1_div_2_Template, 7, 12, "div", 14);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.searchSlide);
} }
class SearchComponent {
    constructor(dataService, translate) {
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.searchText = "";
        this.searchSlide = false;
        this.showCancel = true;
        this.section = "";
        this.searchTextFocusTriggeringEventEmitter = new EventEmitter();
        this.emitSearch = false;
        this.searchTextChange = new EventEmitter();
        this.isSearchClicked = false;
        this.messageKeys = {};
        this.getStaticText = () => {
            this.translate.get('shared-lib.search_component.search_for').subscribe((res) => {
                this.messageKeys["search_for"] = res;
            });
            this.translate.get('shared-lib.search_component.apps_label').subscribe((res) => {
                if (this.section == 'apps') {
                    this.messageKeys["apps_label"] = res;
                }
                else {
                    this.messageKeys["apps_label"] = this.section;
                }
            });
        };
        this.subscribeSearchText = (val) => {
            console.log("search text", val);
            if (this.searchText === val)
                return;
            this.searchText = val;
            this.showSearch(null);
        };
        this.doSearch = () => {
            if (this.emitSearch) {
                this.searchTextChange.emit(this.searchText);
            }
            else {
                this.dataService.withSearchText(this.searchText);
            }
        };
        this.onSearchKeyUp = ($event) => {
            //    console.log( this.searchText, $event.target.value, ( this.searchText == null && $event.target.value ), ( this.searchText !== $event.target.value ) );
            if ((this.searchText == null && $event.target["value"]) ||
                this.searchText !== $event.target["value"]) {
                this.searchText = $event.target["value"].toLowerCase();
                this.doSearch();
            }
        };
        this.showSearch = (show) => {
            if ((show == undefined || show == null) && this.searchText)
                show = true;
            if (show != undefined && show != null) {
                this.searchSlide = show;
                if (show) {
                    this.isSearchClicked = true;
                    setTimeout(() => {
                        this.isSearchClicked = false;
                    }, 100);
                }
                else {
                    this.clearSearch(show);
                }
            }
        };
        this.clearSearch = ($event) => {
            this.searchText = "";
            this.doSearch();
        };
    }
    set setOptions(options) {
        this.showSearch(options.openSearch);
        this.showCancel = options.showCancel;
    }
    ngOnInit() {
        this.getStaticText();
        this.dataService
            .getSearchText(this.unsubscribe$)
            .subscribe(this.subscribeSearchText);
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
    }
    ngAfterViewChecked() {
        this.searchTextFocusTriggeringEventEmitter.emit(this.isSearchClicked);
    }
    ngOnDestroy() {
        console.log("destory Search page");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
SearchComponent.ɵfac = function SearchComponent_Factory(t) { return new (t || SearchComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
SearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SearchComponent, selectors: [["lib-app-search"]], inputs: { setOptions: ["options", "setOptions"], section: "section", setup: "setup", emitSearch: "emitSearch" }, outputs: { searchTextChange: "searchTextChange" }, decls: 3, vars: 2, consts: [["class", "searchBox", 3, "ngIf", "ngIfElse"], ["class", "searchBox"], ["defaultSetup", ""], [1, "searchBtn", 3, "click"], ["class", "searchBarDivSpaces", 3, "ngClass", 4, "ngIf"], [1, "searchBarDivSpaces", 3, "ngClass"], ["autocomplete", "off"], ["type", "text", 1, "searchInput", 3, "value", "focusElement", "placeholder", "keyup"], ["class", "clearIcon", 3, "click", 4, "ngIf"], [1, "searchBtnInside", 3, "click"], [1, "clearIcon", 3, "click"], ["src", "/assets/images/circular-close.svg"], [1, "searchIcon"], ["src", "/assets/images/search_icon.svg", "alt", "Search Icon", 3, "click"], ["class", "searchBarDiv", 3, "ngClass", 4, "ngIf"], [1, "searchBarDiv", 3, "ngClass"], ["src", "/assets/images/search_icon.svg", "alt", "Search Icon", 1, "searchInputIcon"], ["class", "clearIcon", 3, "ngClass", "click", 4, "ngIf"], ["class", "cancelSearch", 3, "click", 4, "ngIf"], [1, "clearIcon", 3, "ngClass", "click"], [1, "cancelSearch", 3, "click"]], template: function SearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SearchComponent_ng_template_0_Template, 2, 1, "ng-template", 0);
        i0.ɵɵtemplate(1, SearchComponent_ng_template_1_Template, 3, 1, "ng-template", 1, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.setup && ctx.setup === "spaces")("ngIfElse", _r1);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i2$1.NgForm, FocusDirective], pipes: [i2.TranslatePipe], styles: [".searchBox[_ngcontent-%COMP%]{display:inline-block;width:100%;overflow:hidden}.searchBox[_ngcontent-%COMP%]   .searchIcon[_ngcontent-%COMP%]{display:inline-block;width:100%;text-align:right;z-index:1}.searchBox[_ngcontent-%COMP%]   .searchIcon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{cursor:pointer}.searchBarDiv[_ngcontent-%COMP%]{width:0;right:0;top:-34px;background-color:#fff;transition:.2s cubic-bezier(.4,0,.2,1);position:relative;z-index:2;overflow:hidden;float:right}.searchBarDiv.searchSlide[_ngcontent-%COMP%]{width:100%}.searchBarDiv[_ngcontent-%COMP%]   input.searchInput[_ngcontent-%COMP%]{width:100%;padding-left:25px;padding-right:30px;border:none;border-bottom:1px solid #dddfe2;border-radius:0;margin-bottom:0}.searchBarDiv[_ngcontent-%COMP%]   input.searchInput[_ngcontent-%COMP%]:focus{border-bottom:2px solid #049fd9;outline:none}.searchBarDiv[_ngcontent-%COMP%]   input.searchInput[_ngcontent-%COMP%]::-ms-clear{display:none}.searchBarDiv[_ngcontent-%COMP%]   .searchInputIcon[_ngcontent-%COMP%]{position:absolute;left:0;top:0;padding-top:10px;width:16px;height:auto}.searchBarDiv[_ngcontent-%COMP%]   .clearIcon[_ngcontent-%COMP%]{position:absolute;right:0px;padding:2px 6px}.clearIcon.showCancelLabel[_ngcontent-%COMP%]{right:44px!important}.searchBarDiv[_ngcontent-%COMP%]   .clearIcon[_ngcontent-%COMP%]:before{position:absolute;left:100%;content:\"\";height:10px;background-color:#dddfe2;top:8px;width:1px}.searchBarDiv[_ngcontent-%COMP%]   .clearIcon.showCancelLabel[_ngcontent-%COMP%]:before{top:15px}.searchBarDiv[_ngcontent-%COMP%]   .clearIcon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{cursor:pointer;vertical-align:middle}.searchBarDiv[_ngcontent-%COMP%]   .clearIcon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{cursor:pointer}.searchBarDiv[_ngcontent-%COMP%]   .cancelSearch[_ngcontent-%COMP%]{position:absolute;right:0;top:4px;cursor:pointer;font-family:\"ciscoSansLight\";font-size:12px;text-align:left;color:#666}.searchBtn[_ngcontent-%COMP%]{box-shadow:0 0 5px 1px #bfbfbf80;-moz-box-shadow:0px 0px 5px 1px rgba(191,191,191,.5);-webkit-box-shadow:0px 0px 5px 1px rgba(191,191,191,.5);width:60px;height:60px;border-radius:50px;background-color:#fff;background-image:url(/assets/images/basic/search_icon.svg);background-repeat:no-repeat;background-position:center;background-size:20px;float:right;cursor:pointer;transition-property:background;transition-duration:.08s;transition-timing-function:linear;position:absolute;top:0px;right:0px}.searchBtnInside[_ngcontent-%COMP%]{width:40px;height:40px;border-radius:50px;background-color:#7cc242;background-image:url(/assets/images/basic/search_icon_selected.svg);background-repeat:no-repeat;background-position:center;background-size:20px;cursor:pointer;transition-property:background;transition-duration:.08s;transition-timing-function:linear;top:10px;right:10px;position:absolute}.searchBarDivSpaces[_ngcontent-%COMP%]{width:0;right:0;top:0px;background-color:#fff;transition:.2s cubic-bezier(.4,0,.2,1);position:absolute;z-index:2;overflow:hidden;box-shadow:0 0 5px 1px #bfbfbf80;-moz-box-shadow:0px 0px 5px 1px rgba(191,191,191,.5);-webkit-box-shadow:0px 0px 5px 1px rgba(191,191,191,.5);padding:10px;border-radius:50px}.searchBarDivSpaces.searchSlide[_ngcontent-%COMP%]{width:85%;height:60px}.searchBarDivSpaces[_ngcontent-%COMP%]   input.searchInput[_ngcontent-%COMP%]{width:100%;height:40px;border:none;border-radius:0;margin:0}.searchBarDivSpaces[_ngcontent-%COMP%]   input.searchInput[_ngcontent-%COMP%]::-ms-clear{display:none}.searchBarDivSpaces[_ngcontent-%COMP%]   .searchInputIcon[_ngcontent-%COMP%]{position:absolute;left:0;top:0;padding-top:10px;width:16px;height:auto}.searchBarDivSpaces[_ngcontent-%COMP%]   .clearIcon[_ngcontent-%COMP%]{position:absolute;right:54px;top:20px;padding-right:8px}.searchBarDivSpaces[_ngcontent-%COMP%]   .clearIcon[_ngcontent-%COMP%]:before{position:absolute;left:100%;content:\"\";height:10px;background-color:#dddfe2;top:8px;width:1px}.searchBarDivSpaces[_ngcontent-%COMP%]   .clearIcon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{cursor:pointer}.searchBarDivSpaces[_ngcontent-%COMP%]   .cancelSearch[_ngcontent-%COMP%]{position:absolute;right:0;top:4px;cursor:pointer;font-family:\"ciscoSansLight\";font-size:12px;text-align:left;color:#666}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchComponent, [{
        type: Component,
        args: [{
                selector: "lib-app-search",
                templateUrl: "./search.component.html",
                styleUrls: ["./search.component.css"]
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }]; }, { setOptions: [{
            type: Input,
            args: ['options']
        }], section: [{
            type: Input
        }], setup: [{
            type: Input
        }], emitSearch: [{
            type: Input
        }], searchTextChange: [{
            type: Output
        }] }); })();

class TooltipService extends BaseService {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.components = [];
        this.apiConfig = new ApiConfig();
        this.tooltipObserver = null;
        this.getComponents = () => {
            return this.components;
        };
        this.findByIndex = (id) => {
            const idx = this.components.findIndex((t) => {
                return t.id === id;
            });
            return this.components[idx];
        };
        this.removeTooltip = (id) => {
            const idx = this.components.findIndex((t) => {
                return t.id === id;
            });
            this.components.splice(idx, 1);
        };
        this.addToComponents = (tooltip) => {
            // this.components.push(tooltip);
            this.components = [tooltip];
        };
        this.pushTooltip = (id, elem, tooltipInput) => {
            if (!this.findByIndex(id)) {
                if (tooltipInput.id) {
                    this.tooltipObserver = this.getTooltip(tooltipInput.id).subscribe((tooltip) => {
                        // console.log('tooltip from server: ', tooltip);
                        if (tooltip.status && tooltip.data) {
                            this.addToComponents({
                                id: id,
                                ref: elem,
                                tooltipId: tooltip.data.id,
                                title: tooltip.data.title.en,
                                desc: tooltip.data.desc.en,
                                url: tooltip.data.url.en,
                                position: tooltipInput.position,
                                forcePosition: tooltipInput.forcePosition,
                                isFixed: tooltipInput.isFixed,
                                popupMouseOut: true
                            });
                        }
                    }, (error) => {
                        console.log("error while getting tooltip from server", error.status);
                    }, () => {
                        if (this.tooltipObserver)
                            this.tooltipObserver.unsubscribe();
                    });
                }
                else if (tooltipInput.data && tooltipInput.data.id) {
                    this.addToComponents({
                        id: id,
                        ref: elem,
                        tooltipId: tooltipInput.data.id,
                        title: tooltipInput.data.title.en,
                        desc: tooltipInput.data.desc.en,
                        url: tooltipInput.data.url.en,
                        position: tooltipInput.position,
                        forcePosition: tooltipInput.forcePosition,
                        isFixed: tooltipInput.isFixed,
                        popupMouseOut: true
                    });
                }
                else if (tooltipInput.html) {
                    this.addToComponents({
                        id: id,
                        ref: elem,
                        html: tooltipInput.html,
                        position: tooltipInput.position,
                        forcePosition: tooltipInput.forcePosition,
                        isFixed: tooltipInput.isFixed,
                        popupMouseOut: true
                    });
                }
            }
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getTooltip = (id) => {
            const postData = {
                toolId: id,
                setup: "cisco"
            };
            const serverUrl = this.apiConfig.getTooltipUrl();
            //console.log( serverUrl );
            return this.post(serverUrl, postData).pipe(map(this.extractResponse));
        };
    }
}
TooltipService.ɵfac = function TooltipService_Factory(t) { return new (t || TooltipService)(i0.ɵɵinject(i0.Injector)); };
TooltipService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TooltipService, factory: TooltipService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipService, [{
        type: Injectable
    }], function () { return [{ type: i0.Injector }]; }, null); })();

class TooltipDirective {
    constructor(tooltipService, element) {
        this.tooltipService = tooltipService;
        this.element = element;
        this.ngOnMouseOver = () => {
            if (this.element.nativeElement.getAttribute("tooltip-popup-id") &&
                this.id &&
                this.element.nativeElement.getAttribute("tooltip-popup-id") ===
                    this.id) {
                const tooltip = this.tooltipService.findByIndex(this.id);
                if (tooltip) {
                    tooltip["elemMouseOut"] = false;
                }
                else {
                    this.element.nativeElement.setAttribute("tooltip-popup-id", "");
                }
            }
            else {
                setTimeout(() => {
                    this.doCreate();
                }, 10);
            }
        };
        this.doCreate = () => {
            if (!this.id) {
                this.id = Math.random().toString();
            }
            this.element.nativeElement.setAttribute("tooltip-popup-id", this.id);
            this.tooltipService.pushTooltip(this.id, this.element, this.tooltip);
        };
        this.doDestroy = () => {
            setTimeout(() => {
                const tooltip = this.tooltipService.findByIndex(this.id);
                if (tooltip) {
                    tooltip["elemMouseOut"] = true;
                    this.destroy(tooltip);
                }
            }, 100);
        };
    }
    onMouseOver(e) {
        if (this.timeoutObj)
            clearTimeout(this.timeoutObj);
        this.timeoutObj = setTimeout(() => {
            this.ngOnMouseOver();
        }, 1500);
    }
    // @HostListener('document:mousemove', ['$event'])
    // @HostListener('document:mousedown', ['$event'])
    // @HostListener('document:scroll', ['$event'])
    onMouseLeave(e) {
        // console.log('Detected move leave event', e.type);
        this.ngOnDestroy();
    }
    ngOnDestroy() {
        if (this.timeoutObj != undefined)
            clearTimeout(this.timeoutObj);
        this.doDestroy();
    }
    destroy(tooltip) {
        if (tooltip && tooltip["elemMouseOut"] && tooltip["popupMouseOut"]) {
            this.element.nativeElement.setAttribute("tooltip-popup-id", "");
            this.tooltipService.removeTooltip(this.id);
        }
    }
}
TooltipDirective.ɵfac = function TooltipDirective_Factory(t) { return new (t || TooltipDirective)(i0.ɵɵdirectiveInject(TooltipService), i0.ɵɵdirectiveInject(i0.ElementRef)); };
TooltipDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: TooltipDirective, selectors: [["", "pmx-tooltip", ""]], hostBindings: function TooltipDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("mouseenter", function TooltipDirective_mouseenter_HostBindingHandler($event) { return ctx.onMouseOver($event); })("mouseleave", function TooltipDirective_mouseleave_HostBindingHandler($event) { return ctx.onMouseLeave($event); });
    } }, inputs: { tooltip: "tooltip" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipDirective, [{
        type: Directive,
        args: [{
                // eslint-disable-next-line @angular-eslint/directive-selector
                selector: "[pmx-tooltip]"
            }]
    }], function () { return [{ type: TooltipService }, { type: i0.ElementRef }]; }, { tooltip: [{
            type: Input
        }], onMouseOver: [{
            type: HostListener,
            args: ["mouseenter", ["$event"]]
        }], 
    // @HostListener('document:mousemove', ['$event'])
    // @HostListener('document:mousedown', ['$event'])
    // @HostListener('document:scroll', ['$event'])
    onMouseLeave: [{
            type: HostListener,
            args: ["mouseleave", ["$event"]]
        }] }); })();

class UserService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.locationMap = {};
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getUserCurrentStatus = () => {
            return this.get(this.apiConfig.getUserCurrentStatusUrl()).pipe(map(this.extractResponseData));
        };
        this.getAdminUserList = () => {
            return this.get(this.apiConfig.getAdminUserListUrl()).pipe(map(this.extractResponseData));
        };
        this.getRoleUserList = () => {
            return this.get(this.apiConfig.getRoleUserListUrl()).pipe(map(this.extractResponseData));
        };
        this.deleteUser = (user) => {
            const opts = {
                body: user
            };
            const serverUrl = this.apiConfig.getDeleteUserUrl();
            return this.delete(serverUrl, opts).pipe(map(this.extractResponse));
        };
        this.getUserDeleteStatus = (emailArr) => {
            const serverUrl = this.apiConfig.getDeleteUserStatus();
            return this.post(serverUrl, emailArr).pipe(map(this.extractResponse));
        };
        this.deleteUserRole = (config) => {
            const opts = {
                body: config
            };
            const serverUrl = this.apiConfig.getDeleteUserRoleUrl();
            return this.delete(serverUrl, opts).pipe(map(this.extractResponse));
        };
        this.getAdminRoleDeleteStatus = (config) => {
            const serverUrl = this.apiConfig.getAdminRoleDeleteStatus();
            return this.post(serverUrl, config).pipe(map(this.extractResponse));
        };
        this.getUserInfo = (inviteUserEmail) => {
            const getUserInfoUrl = this.apiConfig.getUserInfoUrl() + "/" + inviteUserEmail;
            return this.get(getUserInfoUrl).pipe(map(this.extractResponse));
        };
        this.getAdminAppName = (appId) => {
            const getUserInfoUrl = this.apiConfig.getAdminAppNameUrl() + "/" + appId;
            return this.get(getUserInfoUrl).pipe(map(this.extractResponse));
        };
        this.inviteUser = (userInfo) => {
            const serverUrl = this.apiConfig.getInviteUserUrl();
            return this.post(serverUrl, userInfo).pipe(map(this.extractResponse));
        };
        this.sendInviteUserMail = (userInfo) => {
            const serverUrl = this.apiConfig.getSendInviteUserMailUrl();
            return this.post(serverUrl, userInfo).pipe(map(this.extractResponseData));
        };
        this.sendDemokitInviteUserMail = (userInfo) => {
            const serverUrl = this.apiConfig.getDemokitSendInviteUserMailUrl();
            return this.post(serverUrl, userInfo).pipe(map(this.extractResponseData));
        };
        this.sendInviteSsoUserMail = (userInfo) => {
            const serverUrl = this.apiConfig.getSendInviteSsoUserMailUrl();
            return this.post(serverUrl, userInfo).pipe(map(this.extractResponseData));
        };
        this.editAdminUser = (userInfo) => {
            const serverUrl = this.apiConfig.getEditAdminUserUrl();
            return this.post(serverUrl, userInfo).pipe(map(this.extractResponse));
        };
        this.editUser = (userInfo) => {
            const serverUrl = this.apiConfig.getEditUserUrl();
            return this.put(serverUrl, userInfo).pipe(map(this.extractResponse));
        };
        this.getAccesscodeManagerLocations = () => {
            const getAccLocationUrl = this.apiConfig.getAccesscodeManagerLocationUrl();
            return this.get(getAccLocationUrl).pipe(map(this.extractResponse));
        };
        this.getAppAccesscodeManagerLocations = () => {
            const getAccLocationUrl = this.apiConfig.getAppAccesscodeManagerLocationUrl();
            return this.get(getAccLocationUrl).pipe(map(this.extractResponse));
        };
        this.resendInvite = (userInfo) => {
            const serverUrl = this.apiConfig.getResendInviteEmailUrl();
            return this.post(serverUrl, userInfo).pipe(map(this.extractResponse));
        };
        this.resendCPAppInvite = (userInfo) => {
            const serverUrl = this.apiConfig.getResendCPAppInviteEmailUrl();
            return this.post(serverUrl, userInfo).pipe(map(this.extractResponse));
        };
        this.extractCompleteResponse = (res) => {
            return res;
        };
        // App User API calls
        this.getAppUserList = (appName) => {
            const serverUrl = this.apiConfig.getAppUserListUrl() + "/" + appName + "/users";
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.inviteAppUser = (appName, userInfo) => {
            const serverUrl = this.apiConfig.getInviteAppUserUrl() +
                "/" +
                appName +
                "/user/invite";
            return this.post(serverUrl, userInfo).pipe(map(this.extractResponse));
        };
        this.resendInviteAppUser = (appName, userInfo) => {
            const serverUrl = this.apiConfig.getResendInviteAppUserUrl() +
                "/" +
                appName +
                "/user/resendinvite";
            return this.post(serverUrl, userInfo).pipe(map(this.extractResponse));
        };
        this.getAppUserInfo = (appName, inviteUserEmail) => {
            const getUserInfoUrl = this.apiConfig.getAppUserInfoUrl() + "/" + inviteUserEmail;
            return this.get(getUserInfoUrl).pipe(map(this.extractResponse));
        };
        this.editAppUser = (appName, userInfo) => {
            const serverUrl = this.apiConfig.getEditAppUserUrl() + "/" + appName + "/user/edit";
            return this.post(serverUrl, userInfo).pipe(map(this.extractResponse));
        };
        this.deleteAppUser = (appName, userInfo) => {
            const opts = {
                body: userInfo
            };
            const serverUrl = this.apiConfig.getDeleteAppUserUrl() +
                "/" +
                appName +
                "/user/delete";
            return this.delete(serverUrl, opts).pipe(map(this.extractResponse));
        };
        this.deleteAppUserStatus = (appName, emailArr) => {
            const serverUrl = this.apiConfig.getAppUserDeleteStatusUrl() +
                "/" +
                appName +
                "/delete/status";
            return this.post(serverUrl, emailArr).pipe(map(this.extractResponse));
        };
        this.getAppRoleList = (appName) => {
            const serverUrl = this.apiConfig.getAppRoleListUrl() + "/" + appName + "/role/list";
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getRoleApplicationList = () => {
            const serverUrl = this.apiConfig.getRoleApplicationListUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.createAdminRole = (userInfo) => {
            const serverUrl = this.apiConfig.getCreateAdminRoleUrl();
            return this.post(serverUrl, userInfo).pipe(map(this.extractResponse));
        };
        this.editAdminRole = (roleInfo) => {
            const serverUrl = this.apiConfig.getAdminEditRoleUrl();
            return this.put(serverUrl, roleInfo).pipe(map(this.extractResponse));
        };
        // App User API calls
        this.getSsoRoleList = () => {
            const serverUrl = this.apiConfig.getSsoRoleListUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.deleteSsoRole = (roleName) => {
            const serverUrl = this.apiConfig.getDeleteSsoRoleUrl() + "/" + roleName;
            return this.delete(serverUrl).pipe(map(this.extractResponse));
        };
        this.createAdminSsoRole = (roleInfo) => {
            const serverUrl = this.apiConfig.getCreateAdminSsoRoleUrl();
            return this.post(serverUrl, roleInfo).pipe(map(this.extractResponse));
        };
        this.editAdminSsoRole = (roleInfo) => {
            const serverUrl = this.apiConfig.getAdminEditSsoRoleUrl();
            return this.put(serverUrl, roleInfo).pipe(map(this.extractResponse));
        };
        this.getSmartLicenseDetail = () => {
            const serverUrl = this.apiConfig.getSLDetailsUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.registerSmartLicense = (token) => {
            const serverUrl = this.apiConfig.registerSmartLicenseUrl();
            return this.post(serverUrl, token).pipe(map(this.extractResponse));
        };
        this.renewAuthSmartLicense = () => {
            const serverUrl = this.apiConfig.renewAuthSmartLicenseUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.renewRegistrationSmartLicense = () => {
            const serverUrl = this.apiConfig.renewRegistrationSmartLicenseUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.reRegisterSmartLicense = () => {
            const serverUrl = this.apiConfig.reRegisterSmartLicenseUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.deRegisterSmartLicense = () => {
            const serverUrl = this.apiConfig.deRegisterSmartLicenseUrl();
            return this.delete(serverUrl).pipe(map(this.extractResponse));
        };
        this.changeBaseLicenseSL = (licenseObj) => {
            const serverUrl = this.apiConfig.changeBaseLicenseUrl();
            return this.post(serverUrl, licenseObj).pipe(map(this.extractResponse));
        };
        this.getCountryCodeList = () => {
            const serverUrl = this.apiConfig.getCountryCodesUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.updateCountryDetailToCci = (payload) => {
            const serverUrl = this.apiConfig.updateCountryCodeUrl();
            return this.post(serverUrl, payload).pipe(map(this.extractResponse));
        };
        this.utils = new Utils(this.logger);
    }
}
UserService.ɵfac = function UserService_Factory(t) { return new (t || UserService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
UserService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UserService, factory: UserService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

function SmartLicensePopupComponent_ul_0_li_1_ng_container_9_ng_template_1_div_4_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const slide_r5 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("href", slide_r5.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(slide_r5.linkText);
} }
function SmartLicensePopupComponent_ul_0_li_1_ng_container_9_ng_template_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, SmartLicensePopupComponent_ul_0_li_1_ng_container_9_ng_template_1_div_4_a_2_Template, 2, 2, "a", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const slide_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", slide_r5.sub, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", slide_r5.linkText && slide_r5.link);
} }
function SmartLicensePopupComponent_ul_0_li_1_ng_container_9_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SmartLicensePopupComponent_ul_0_li_1_ng_container_9_ng_template_1_div_4_Template, 3, 2, "div", 26);
} if (rf & 2) {
    const slide_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(slide_r5.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(slide_r5.desc);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", slide_r5.sub);
} }
function SmartLicensePopupComponent_ul_0_li_1_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SmartLicensePopupComponent_ul_0_li_1_ng_container_9_ng_template_1_Template, 5, 3, "ng-template", 23);
    i0.ɵɵelementContainerEnd();
} }
function SmartLicensePopupComponent_ul_0_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelement(2, "div", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵelementStart(4, "span", 9);
    i0.ɵɵlistener("click", function SmartLicensePopupComponent_ul_0_li_1_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.closePopup(); });
    i0.ɵɵtext(5, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 10);
    i0.ɵɵelementStart(7, "div", 11);
    i0.ɵɵelementStart(8, "owl-carousel-o", 12);
    i0.ɵɵtemplate(9, SmartLicensePopupComponent_ul_0_li_1_ng_container_9_Template, 2, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 14);
    i0.ɵɵlistener("click", function SmartLicensePopupComponent_ul_0_li_1_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.openTnc(); });
    i0.ɵɵtext(11, "Let's Do It");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 15);
    i0.ɵɵelement(13, "img", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 17);
    i0.ɵɵelementStart(15, "div", 18);
    i0.ɵɵelementStart(16, "span", 19);
    i0.ɵɵelementStart(17, "input", 20);
    i0.ɵɵlistener("click", function SmartLicensePopupComponent_ul_0_li_1_Template_input_click_17_listener() { i0.ɵɵrestoreView(_r13); const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.showHideSmartWizard(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(18, "label", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "span", 22);
    i0.ɵɵtext(20, "Don't show this to me again");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("options", ctx_r1.customOptions);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.carousalItems);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("checked", ctx_r1.hideWizard);
} }
function SmartLicensePopupComponent_ul_0_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 29);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelement(2, "div", 7);
    i0.ɵɵelementStart(3, "div", 30);
    i0.ɵɵelementStart(4, "div", 31);
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6, "Terms and Conditions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 9);
    i0.ɵɵlistener("click", function SmartLicensePopupComponent_ul_0_li_2_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.closePopup(); });
    i0.ɵɵtext(8, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 32);
    i0.ɵɵelementStart(10, "p");
    i0.ɵɵtext(11, "SMART LICENSING is a Cisco software license management system that allows you to easily track license status and software usage trends. This document describes how Smart Licensing works and includes the terms that govern your use. Please make sure you are authorized by your organization before accepting these terms or using Smart Licensing. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "h3");
    i0.ɵɵtext(13, "What is Smart Licensing?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "ul");
    i0.ɵɵelementStart(15, "li");
    i0.ɵɵtext(16, "Smart Licensing enables you to activate and manage Cisco software licenses. It also allows Cisco to send and receive periodic messages about license usage and entitlement of Cisco devices and software (\u201CSmart Licensing Messages\u201D). These Smart Licensing Messages will be displayed in Smart Software Manager, which is the web portal that shows your organization\u2019s license entitlement information.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "li");
    i0.ɵɵtext(18, "If you choose not to enable Smart Licensing directly over the internet, you can select another method for collecting Smart Licensing Messages, like Smart Software Manager satellite. This must be hosted in your network environment that meets minimum requirements specified by Cisco.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "li");
    i0.ɵɵtext(20, "If the Smart Software Manager or the satellite stops receiving periodic updates for more than 90 days, Cisco assumes the device is no longer functioning properly and those unused licenses will automatically return to your license pool. If after 90 days the device is back in use, it will reacquire the license immediately upon sending its periodic update.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "li");
    i0.ɵɵtext(22, "Smart Call Home is an automated support capability within Smart Licensing that monitors Cisco devices on your network. It flags issues and initiates resolution before your business operations are affected. Smart Call Home is an optional capability that your organization can choose to enable that is included with Smart License enabled products.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "h4");
    i0.ɵɵtext(24, "Information Collected by Cisco");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "ul");
    i0.ɵɵelementStart(26, "li");
    i0.ɵɵtext(27, "Smart Licensing collects software license usage information with associated product identification numbers, serial numbers, unique virtual device identifier, equipment models, license or hardware versions, and host names (host names are sent to aid in troubleshooting unless you disable them).");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "li");
    i0.ɵɵtext(29, "If you enable Smart Call Home, Cisco also may collect \u2013 for support and troubleshooting purposes - additional software version information, IP addresses, system contacts, installed memory, installed flash, boot versions, chassis series, MAC addresses, slot IDs, card types and card families.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 33);
    i0.ɵɵelementStart(31, "div", 14);
    i0.ɵɵlistener("click", function SmartLicensePopupComponent_ul_0_li_2_Template_div_click_31_listener() { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.tncAccepted(); });
    i0.ɵɵtext(32, "Accept Terms and Conditions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 34);
    i0.ɵɵlistener("click", function SmartLicensePopupComponent_ul_0_li_2_Template_div_click_33_listener() { i0.ɵɵrestoreView(_r17); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.closePopup(); });
    i0.ɵɵtext(34, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SmartLicensePopupComponent_ul_0_li_3_div_10_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r32.counterMap.one.count);
} }
function SmartLicensePopupComponent_ul_0_li_3_div_10_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtext(1, "\u2713");
    i0.ɵɵelementEnd();
} }
function SmartLicensePopupComponent_ul_0_li_3_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵtemplate(1, SmartLicensePopupComponent_ul_0_li_3_div_10_div_2_div_1_Template, 2, 1, "div", 50);
    i0.ɵɵtemplate(2, SmartLicensePopupComponent_ul_0_li_3_div_10_div_2_div_2_Template, 2, 0, "div", 50);
    i0.ɵɵelementStart(3, "div", 51);
    i0.ɵɵtext(4, "Create Account in CSSM");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", ctx_r29.counterMap.one.class);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.counterMap.one.class != "tick");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.counterMap.one.class == "tick");
} }
function SmartLicensePopupComponent_ul_0_li_3_div_10_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r30.counterMap.two.count);
} }
function SmartLicensePopupComponent_ul_0_li_3_div_10_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtext(1, "\u2713");
    i0.ɵɵelementEnd();
} }
function SmartLicensePopupComponent_ul_0_li_3_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "div", 47);
    i0.ɵɵtemplate(2, SmartLicensePopupComponent_ul_0_li_3_div_10_div_2_Template, 5, 3, "div", 48);
    i0.ɵɵelementStart(3, "div", 49);
    i0.ɵɵtemplate(4, SmartLicensePopupComponent_ul_0_li_3_div_10_div_4_Template, 2, 1, "div", 50);
    i0.ɵɵtemplate(5, SmartLicensePopupComponent_ul_0_li_3_div_10_div_5_Template, 2, 0, "div", 50);
    i0.ɵɵelementStart(6, "div", 51);
    i0.ɵɵtext(7, "Create Token in CSSM");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 49);
    i0.ɵɵelementStart(9, "div", 52);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 51);
    i0.ɵɵtext(12, "Apply Token");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("@flyInOutRTL", undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r20.selectedCssm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r20.counterMap.two.class);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.counterMap.two.class != "tick");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.counterMap.two.class == "tick");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r20.counterMap.three.class);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r20.counterMap.three.count);
} }
function SmartLicensePopupComponent_ul_0_li_3_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵelementStart(1, "div", 54);
    i0.ɵɵtext(2, " Do you have an account in Cisco Smart Software Manager (CSSM)? ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 55);
    i0.ɵɵelementStart(4, "div", 56);
    i0.ɵɵelement(5, "div", 57);
    i0.ɵɵelementStart(6, "div", 58);
    i0.ɵɵlistener("click", function SmartLicensePopupComponent_ul_0_li_3_div_11_Template_div_click_6_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(3); return ctx_r34.cssmSelect(true); });
    i0.ɵɵelementStart(7, "div", 59);
    i0.ɵɵelementStart(8, "h3");
    i0.ɵɵtext(9, "Yes, I have");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 60);
    i0.ɵɵelement(11, "input", 61);
    i0.ɵɵelement(12, "label", 62);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span");
    i0.ɵɵtext(14, "Choose this option if you already have a Cisco Smart Software Manager account and all you have to do is to register Cisco Spaces with your account.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 56);
    i0.ɵɵelement(16, "div", 57);
    i0.ɵɵelementStart(17, "div", 58);
    i0.ɵɵlistener("click", function SmartLicensePopupComponent_ul_0_li_3_div_11_Template_div_click_17_listener() { i0.ɵɵrestoreView(_r35); const ctx_r36 = i0.ɵɵnextContext(3); return ctx_r36.cssmSelect(false); });
    i0.ɵɵelementStart(18, "div", 59);
    i0.ɵɵelementStart(19, "h3");
    i0.ɵɵtext(20, "No, I dont have");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 60);
    i0.ɵɵelement(22, "input", 61);
    i0.ɵɵelement(23, "label", 62);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "span");
    i0.ɵɵtext(25, "You need a Smart account created in cisco.com to use CSSM. The step by step guide will help you to create register your smart account");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("@flyInOutRTL", undefined);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("checked", ctx_r21.selectedCssm);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("checked", !ctx_r21.selectedCssm);
} }
function SmartLicensePopupComponent_ul_0_li_3_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵelementStart(1, "h3", 64);
    i0.ɵɵtext(2, " Follow the steps below to create the token in CSSM Tool ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 65);
    i0.ɵɵelementStart(4, "div", 66);
    i0.ɵɵelementStart(5, "h3", 67);
    i0.ɵɵtext(6, "Step1 : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 68);
    i0.ɵɵelementStart(8, "h3");
    i0.ɵɵtext(9, "Open Cisco Smart License Manager");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div");
    i0.ɵɵtext(11, "Go to ");
    i0.ɵɵelementStart(12, "a", 69);
    i0.ɵɵtext(13, "https://software.cisco.com");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(14, ". Look for Manage Smart Account and click Manage Account.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 66);
    i0.ɵɵelementStart(16, "h3", 67);
    i0.ɵɵtext(17, "Step2 : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 68);
    i0.ɵɵelementStart(19, "h3");
    i0.ɵɵtext(20, "Create Virtual Account");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div");
    i0.ɵɵtext(22, "Open Virtual Accounts tab, click Create Virtual Account and fill the necessory details and complete the steps to create a virtual account. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div");
    i0.ɵɵtext(24, "Virtual accounts in Smart Software Manager to organize the licenses for your company into logical entities. If you segregate your company into different geographic regions, you can create a virtual account for each region to hold the licenses and product instances for that region.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 66);
    i0.ɵɵelementStart(26, "h3", 67);
    i0.ɵɵtext(27, "Step3 : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 68);
    i0.ɵɵelementStart(29, "h3");
    i0.ɵɵtext(30, "Create Registration Token");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "div");
    i0.ɵɵtext(32, "Go to ");
    i0.ɵɵelementStart(33, "a", 69);
    i0.ɵɵtext(34, "https://software.cisco.com");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(35, ". Look for Smart Software Manager and click Manage Licenses");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div");
    i0.ɵɵtext(37, "Once you open Smart Software Manager, click the inventory tab and create a token");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("@flyInOutRTL", undefined);
} }
function SmartLicensePopupComponent_ul_0_li_3_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵelementStart(1, "h3", 64);
    i0.ɵɵtext(2, " Follow the steps below to create the token in CSSM Tool ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 65);
    i0.ɵɵelementStart(4, "div", 66);
    i0.ɵɵelementStart(5, "h3", 67);
    i0.ɵɵtext(6, "Step1 : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 68);
    i0.ɵɵelementStart(8, "h3");
    i0.ɵɵtext(9, "Open Cisco Smart License Manager");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div");
    i0.ɵɵtext(11, "Go to ");
    i0.ɵɵelementStart(12, "a", 69);
    i0.ɵɵtext(13, "https://software.cisco.com");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(14, ". Look for Manage Smart Account and click Manage Account.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 66);
    i0.ɵɵelementStart(16, "h3", 67);
    i0.ɵɵtext(17, "Step2 : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 68);
    i0.ɵɵelementStart(19, "h3");
    i0.ɵɵtext(20, "Create Virtual Account");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div");
    i0.ɵɵtext(22, "Open Virtual Accounts tab, click Create Virtual Account and fill the necessory details and complete the steps to create a virtual account. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div");
    i0.ɵɵtext(24, "Virtual accounts in Smart Software Manager to organize the licenses for your company into logical entities. If you segregate your company into different geographic regions, you can create a virtual account for each region to hold the licenses and product instances for that region.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 66);
    i0.ɵɵelementStart(26, "h3", 67);
    i0.ɵɵtext(27, "Step3 : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 68);
    i0.ɵɵelementStart(29, "h3");
    i0.ɵɵtext(30, "Create Registration Token");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "div");
    i0.ɵɵtext(32, "Go to ");
    i0.ɵɵelementStart(33, "a", 69);
    i0.ɵɵtext(34, "https://software.cisco.com");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(35, ". Look for Smart Software Manager and click Manage Licenses");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div");
    i0.ɵɵtext(37, "Once you open Smart Software Manager, click the inventory tab and create a token");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("@flyInOutRTL", undefined);
} }
function SmartLicensePopupComponent_ul_0_li_3_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 70);
    i0.ɵɵelementStart(1, "h3", 71);
    i0.ɵɵtext(2, " Copy the product instance registration token from CSSM tool and paste it below. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 72);
    i0.ɵɵelementStart(4, "h4");
    i0.ɵɵtext(5, "Product instance token");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "textarea", 73);
    i0.ɵɵlistener("ngModelChange", function SmartLicensePopupComponent_ul_0_li_3_div_14_Template_textarea_ngModelChange_6_listener($event) { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(3); return ctx_r37.smartLicenseToken = $event; });
    i0.ɵɵtext(7, "              ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("@flyInOutRTL", undefined);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngModel", ctx_r24.smartLicenseToken);
} }
function SmartLicensePopupComponent_ul_0_li_3_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 74);
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHtml", ctx_r25.footerInstruction, i0.ɵɵsanitizeHtml);
} }
function SmartLicensePopupComponent_ul_0_li_3_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 75);
    i0.ɵɵlistener("click", function SmartLicensePopupComponent_ul_0_li_3_div_17_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(3); return ctx_r39.moveBack(); });
    i0.ɵɵtext(1, "Previous");
    i0.ɵɵelementEnd();
} }
function SmartLicensePopupComponent_ul_0_li_3_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("click", function SmartLicensePopupComponent_ul_0_li_3_div_18_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r42); const ctx_r41 = i0.ɵɵnextContext(3); return ctx_r41.moveNext(); });
    i0.ɵɵtext(1, "Next");
    i0.ɵɵelementEnd();
} }
const _c0$1F = function (a0) { return { "disabledElement": a0 }; };
function SmartLicensePopupComponent_ul_0_li_3_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 76);
    i0.ɵɵlistener("click", function SmartLicensePopupComponent_ul_0_li_3_div_19_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r44); const ctx_r43 = i0.ɵɵnextContext(3); return ctx_r43.registerSmartLicense(); });
    i0.ɵɵtext(1, "Register");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$1F, ctx_r28.userRole != "RW"));
} }
function SmartLicensePopupComponent_ul_0_li_3_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelement(2, "div", 7);
    i0.ɵɵelementStart(3, "div", 35);
    i0.ɵɵelementStart(4, "div", 31);
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6, "Smart License Configuration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 9);
    i0.ɵɵlistener("click", function SmartLicensePopupComponent_ul_0_li_3_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r46); const ctx_r45 = i0.ɵɵnextContext(2); return ctx_r45.closePopup(); });
    i0.ɵɵtext(8, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 36);
    i0.ɵɵtemplate(10, SmartLicensePopupComponent_ul_0_li_3_div_10_Template, 13, 7, "div", 37);
    i0.ɵɵtemplate(11, SmartLicensePopupComponent_ul_0_li_3_div_11_Template, 26, 3, "div", 38);
    i0.ɵɵtemplate(12, SmartLicensePopupComponent_ul_0_li_3_div_12_Template, 38, 1, "div", 39);
    i0.ɵɵtemplate(13, SmartLicensePopupComponent_ul_0_li_3_div_13_Template, 38, 1, "div", 39);
    i0.ɵɵtemplate(14, SmartLicensePopupComponent_ul_0_li_3_div_14_Template, 8, 2, "div", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 41);
    i0.ɵɵtemplate(16, SmartLicensePopupComponent_ul_0_li_3_div_16_Template, 1, 1, "div", 42);
    i0.ɵɵtemplate(17, SmartLicensePopupComponent_ul_0_li_3_div_17_Template, 2, 0, "div", 43);
    i0.ɵɵtemplate(18, SmartLicensePopupComponent_ul_0_li_3_div_18_Template, 2, 0, "div", 44);
    i0.ɵɵtemplate(19, SmartLicensePopupComponent_ul_0_li_3_div_19_Template, 2, 3, "div", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngSwitch", ctx_r3.configuationSlide);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.configuationSlide > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", 2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", 3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.footerInstruction);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.configuationSlide > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.tokenGenerated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.tokenGenerated);
} }
function SmartLicensePopupComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 1);
    i0.ɵɵtemplate(1, SmartLicensePopupComponent_ul_0_li_1_Template, 21, 3, "li", 2);
    i0.ɵɵtemplate(2, SmartLicensePopupComponent_ul_0_li_2_Template, 35, 0, "li", 3);
    i0.ɵɵtemplate(3, SmartLicensePopupComponent_ul_0_li_3_Template, 20, 10, "li", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r0.currentSlide);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "welcome");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "tnc");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "configuration");
} }
const defaults = {
    delayEnter: '1ms',
    delayLeave: '0ms',
    timingEnter: '0.4s',
    timingLeave: '0.1s'
};
class SmartLicensePopupComponent {
    constructor(dataService, userService, authService, router, locationService, translate) {
        this.dataService = dataService;
        this.userService = userService;
        this.authService = authService;
        this.router = router;
        this.locationService = locationService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.hideActivationPopup = new EventEmitter();
        this.registerSmartLicenseToken = new EventEmitter();
        this.footerInstruction = null;
        this.slides = [
            { content: "Slide 1" },
            { content: "Slide 2" },
            { content: "Slide 3" },
            { content: "Slide 4" },
            { content: "Slide 5" },
        ];
        this.visibleSlides = [];
        this.configuationSlide = 0;
        this.currentSlide = "welcome";
        this.tokenGenerated = false;
        this.hideWizard = false;
        this.getSmartLicenseStatusCallInProgress = false;
        this.apiRegisterCallStatus = '';
        this.apiGetCallStatus = '';
        this.retryCounter = 0;
        this.isTokenError = false;
        this.fromRefreshCall = false;
        this.licenseType = '';
        this.counterMap = {
            one: {
                count: "1",
                class: null,
            },
            two: {
                count: "2",
                class: null,
            },
            three: {
                count: "3",
                class: null,
            },
        };
        this.carousalItems = [
            {
                title: "What is Smart License?",
                desc: "Cisco Smart License is a flexible licensing model that streamlines how you activate and manage software. The solution allows you to easily track the status of your license and software usage trends.",
            },
            {
                title: "Why should enable Smart License?",
                desc: "Cisco Smart License is a flexible licensing model that streamlines how you activate and manage software",
            },
            {
                title: "Before you continue",
                desc: "In order to enable smart license in Cisco Spaces, please make sure you have a smart account configured with Cisco before proceeding",
                sub: "Visit the documentation to",
                linkText: "Know more",
                link: "https://www.cisco.com/c/en_in/products/software/smart-accounts/software-licensing.html",
            },
        ];
        this.customOptions = {
            autoplay: true,
            autoplayTimeout: 7000,
            autoplayHoverPause: true,
            nav: true,
            loop: true,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            dots: true,
            dotsEach: true,
            navSpeed: 1000,
            navText: ["<", ">"],
            responsive: {
                0: {
                    items: 1,
                },
                400: {
                    items: 1,
                },
                740: {
                    items: 1,
                },
                940: {
                    items: 1,
                },
            },
        };
        this.selectedCssm = true;
        this.userRole = '';
        this.isUserRoleAvailable = false;
        this.messageKeys = {};
        this.getUserRole = () => {
            this.authService.getRole(this.unsubscribe$).subscribe(roleBehavior => {
                if (roleBehavior && roleBehavior.appRole) {
                    this.userRole = roleBehavior.appRole;
                }
                this.isUserRoleAvailable = true;
            }, error => {
                console.log(error);
            });
        };
        this.moveNext = () => {
            switch (this.configuationSlide) {
                case 0:
                    this.resetObj();
                    if (!this.selectedCssm) {
                        this.counterMap.one.count = "1";
                        this.counterMap.two.count = "2";
                        this.counterMap.three.count = "3";
                        this.counterMap.one.class = "active";
                        this.footerInstruction =
                            "Click Next when you’ve created the account in CSSM";
                    }
                    else {
                        this.counterMap.two.count = "1";
                        this.counterMap.three.count = "2";
                        this.counterMap.two.class = "active";
                        this.footerInstruction =
                            "Click Next when you’ve generated the token using above steps";
                    }
                    break;
                case 1:
                    this.resetObj();
                    if (!this.selectedCssm) {
                        this.tokenGenerated = false;
                        this.counterMap.one.class = "tick";
                        this.counterMap.two.class = "active";
                        this.footerInstruction =
                            "Click Next when you’ve generated the token using above steps";
                    }
                    else {
                        this.tokenGenerated = true;
                        this.counterMap.two.class = "tick";
                        this.counterMap.three.class = "active";
                        this.footerInstruction = null;
                    }
                    break;
                case 2:
                    this.resetObj();
                    this.tokenGenerated = true;
                    if (!this.selectedCssm) {
                        this.counterMap.one.class = "tick";
                        this.counterMap.two.class = "tick";
                        this.counterMap.three.class = "active";
                        this.footerInstruction = null;
                    }
                    break;
                case 3:
                    this.resetObj();
                    this.tokenGenerated = true;
                    if (!this.selectedCssm) {
                        this.counterMap.one.class = "tick";
                        this.counterMap.two.class = "tick";
                        this.counterMap.three.class = "active";
                        this.footerInstruction = null;
                    }
                    else {
                        this.counterMap.two.class = "tick";
                        this.counterMap.three.class = "active";
                        this.footerInstruction = null;
                    }
                    break;
                default:
                    break;
            }
            this.visibleSlides = [this.slides[this.configuationSlide]];
            if (this.configuationSlide == 1 && this.selectedCssm) {
                this.configuationSlide = 3;
            }
            else {
                this.configuationSlide = (this.configuationSlide + 1) % 5;
            }
        };
        this.moveBack = () => {
            switch (this.configuationSlide) {
                case 0:
                    this.resetObj();
                    return;
                    break;
                case 1:
                    this.resetObj();
                    if (!this.selectedCssm) {
                        this.counterMap.one.class = "active";
                        this.counterMap.two.class = null;
                        this.footerInstruction = null;
                    }
                    break;
                case 2:
                    this.resetObj();
                    this.tokenGenerated = false;
                    if (!this.selectedCssm) {
                        this.counterMap.one.class = 'active';
                        this.counterMap.two.class = null;
                        this.counterMap.three.class = null;
                        this.footerInstruction = "Click Next when you’ve created the account in CSSM";
                    }
                    break;
                case 3:
                    this.resetObj();
                    this.tokenGenerated = false;
                    if (!this.selectedCssm) {
                        this.counterMap.one.class = "tick";
                        this.counterMap.two.class = "active";
                        this.counterMap.three.class = null;
                        this.footerInstruction = "Click Next when you’ve generated the token using above steps";
                    }
                    else {
                        this.counterMap.two.class = "active";
                        this.counterMap.three.class = null;
                        this.footerInstruction = "Click Next when you’ve generated the token using above steps";
                    }
                    break;
                default:
                    break;
            }
            this.visibleSlides = [this.slides[this.configuationSlide]];
            if (this.configuationSlide == 3 && this.selectedCssm) {
                this.configuationSlide = 1;
            }
            else {
                this.configuationSlide = (this.configuationSlide - 1) % 5;
            }
        };
        this.openTnc = () => {
            this.currentSlide = 'tnc';
        };
        this.tncAccepted = () => {
            this.currentSlide = 'configuration';
        };
        this.cssmSelect = (state) => {
            this.selectedCssm = state;
        };
        this.resetObj = () => {
            this.counterMap.one.class = null;
            this.counterMap.two.class = null;
            this.counterMap.three.class = null;
            this.footerInstruction = null;
        };
        this.showHideSmartWizard = () => {
            this.hideWizard = !this.hideWizard;
            if (this.hideWizard)
                this.dataService.setInStorage('hideSmartWizardCarousal', true);
            else
                this.dataService.removeFromStorage('hideSmartWizardCarousal');
        };
        // registerLicense = () => {
        //   if(this.smartLicenseToken) {
        //     this.registerSmartLicenseToken.emit(this.smartLicenseToken)
        //   } else {
        //     this.dataService.setToastMessage('Please enter a valid token', 4000, null, null, 'error');
        //   }
        // }
        this.registerSmartLicense = () => {
            if (this.smartLicenseToken) {
                this.dataService.display(true, 50000);
                let tokenObj = { 'token': this.smartLicenseToken };
                this.userService.registerSmartLicense(tokenObj).pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                    if (response && response.status && response.data) {
                        if (response.data.status) {
                            // this.dataService.setSmartLicenseRegistered(true);
                            //  this.hideActivationPopup.emit(false);
                            // if (location.pathname.indexOf('smartlicensePopup') > -1) {
                            //this.goToSmartLicesePage();
                            // } else {
                            // this.dataService.display(false);
                            // }
                            if (response.data.status == "completed") {
                                if (this.smartLicenseObj['isRegistered']) {
                                    this.dataService.setSmartLicenseRegistered(true);
                                    this.hideActivationPopup.emit(false);
                                    this.dataService.setToastMessage(this.messageKeys['user.smartLicense.register.success'], 4000, null, null, 'success');
                                    this.dataService.display(false);
                                    if (this.fromPage && (this.fromPage == 'login' || this.fromPage == 'baseComponent')) {
                                    }
                                    if (location.pathname.indexOf('smartlicensePopup') > -1) {
                                        this.goToSmartLicesePage();
                                    }
                                    else {
                                        this.dataService.display(false);
                                    }
                                }
                                else if (!this.smartLicenseObj['isRegistered']) {
                                    this.dataService.setToastMessage(this.messageKeys['user.smartLicense.register.failed'], 4000, null, null, 'error');
                                }
                            }
                            else if (response.data.status == "progress") {
                                this.makeSmartLicenseStatusCall(2000, 'get');
                                this.apiRegisterCallStatus = 'progress';
                            }
                            else {
                                this.isTokenError = true;
                                this.dataService.setToastMessage(this.messageKeys['user.smartLicense.register.failed'], 4000, null, null, 'error');
                            }
                        }
                        else {
                            this.isTokenError = true;
                            this.dataService.setToastMessage(this.messageKeys['user.smartLicense.register.failed'], 4000, null, null, 'error');
                        }
                    }
                    else {
                        this.isTokenError = true;
                        this.dataService.setToastMessage(this.messageKeys['user.smartLicense.register.failed'], 4000, null, null, 'error');
                    }
                    if (response.data.status != "progress") {
                        this.dataService.display(false);
                    }
                }, error => {
                    this.dataService.display(false);
                    console.log("ERROR: registerSmartLicense post call ::: ", error);
                });
            }
            else {
                this.dataService.setToastMessage(this.messageKeys['user.smartLicense.register.no-token'], 4000, null, null, 'error');
            }
        };
        this.goToSmartLicesePage = () => {
            this.dataService.setShowSLPage(true);
            this.router.navigate(['/accountpreference']);
            this.dataService.setCurrentNav('/accountpreference');
        };
        this.getSmartLicenseDetail = (callFrom) => {
            this.getSmartLicenseStatusCallInProgress = false;
            if (this.apiGetCallStatus != 'progress') {
                this.dataService.display(true, 50000);
            }
            if (this.getSmartLicenseStatusCallInProgress) {
                return;
            }
            this.getSmartLicenseStatusCallInProgress = true;
            this.userService.getSmartLicenseDetail().pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                this.getSmartLicenseStatusCallInProgress = false;
                if (response && response.status && response.data) {
                    if (response.data.status) {
                        if (response.data.status === "completed" && response.data.details) {
                            this.apiGetCallStatus = 'completed';
                            this.smartLicenseObj = response.data.details;
                            // license type
                            this.licenseType = response.data.details ? response.data.details.licenseTag : '';
                            if (this.smartLicenseObj && this.smartLicenseObj['isRegistered']) {
                                if (this.configuationSlide == 3 && this.smartLicenseToken) {
                                    this.dataService.setToastMessage(this.messageKeys[response.message.message], 4000, null, null, 'success');
                                    this.dataService.display(false);
                                    this.dataService.setSmartLicenseRegistered(true);
                                    this.hideActivationPopup.emit(false);
                                    if (location.pathname.indexOf('smartlicensePopup') > -1) {
                                        this.goToSmartLicesePage();
                                    }
                                }
                                // 
                                // this.calculateSLRemainingDays();
                                // this.lastUpdated = 0;
                                // this.calculateLastUpdated();
                            }
                            else if (!this.smartLicenseObj || !this.smartLicenseObj['isRegistered']) {
                                this.dataService.setToastMessage(this.messageKeys[response.message], 4000, null, null, 'error');
                            }
                        }
                        else if (response.data.status === "progress") {
                            this.makeSmartLicenseStatusCall(2000, 'get');
                            this.apiGetCallStatus = 'progress';
                        }
                        else {
                            this.apiGetCallStatus = 'progress';
                            this.makeSmartLicenseStatusCall(2000, 'unavailable');
                        }
                    }
                    else {
                        this.smartLicenseObj['isRegistered'] = false;
                    }
                }
                else {
                    this.smartLicenseObj['isRegistered'] = false;
                }
                if (callFrom == 'init') {
                    this.dataService.display(false);
                }
            }, error => {
                this.dataService.display(false);
            });
        };
        this.makeSmartLicenseStatusCall = (delay, type) => {
            if (this.retryCounter > 0) {
                this.retryCounter = 0;
                if (this.smartLicenseObj) {
                    this.smartLicenseObj['isRegistered'] = false;
                }
                if (type == 'unavailable' && this.configuationSlide == 3) {
                    this.apiGetCallStatus = 'completed';
                    this.dataService.setToastMessage('Smart Licensing Registration Failed for the given token', 10000, null, null, 'error');
                    this.dataService.display(false);
                }
                return;
            }
            if (type === 'unavailable') {
                this.retryCounter++;
            }
            else {
                this.retryCounter = 0;
            }
            this.timeoutSmartLicenseStatus = setTimeout(() => {
                if (type === 'get' || type === 'unavailable') {
                    this.getSmartLicenseDetail('sync');
                }
                else if (type === 'register') {
                    this.registerSmartLicense();
                }
            }, delay);
        };
        this.closePopup = () => {
            if (location.pathname.indexOf('smartlicensePopup') > -1) {
                this.dataService.display(true);
                this.locationService.signOut();
            }
            else {
                this.hideActivationPopup.emit(false);
            }
        };
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.user-api-management.smart-license.progress').subscribe((res) => {
                this.messageKeys["user.smartLicense.details.fetch.progress"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.success').subscribe((res) => {
                this.messageKeys["user.smartLicense.details.fetch.success"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.unavailable').subscribe((res) => {
                this.messageKeys["user.smartLicense.details.fetch.unavailable"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.inprogress').subscribe((res) => {
                this.messageKeys["user.smartLicense.details.fetch.inprogress"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.register-success').subscribe((res) => {
                this.messageKeys["user.smartLicense.register.success"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.register-failed').subscribe((res) => {
                this.messageKeys["user.smartLicense.register.failed"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.no-token').subscribe((res) => {
                this.messageKeys["user.smartLicense.register.no-token"] = res;
            });
        };
    }
    set fromPage(value) {
        if (value) {
            this.currentSlide = value;
            const wizardState = this.dataService.getFromStorage('hideSmartWizardCarousal');
            if (this.currentSlide == 'welcome' && wizardState) {
                this.currentSlide = 'tnc';
            }
        }
    }
    ngOnInit() {
        this.getUserRole();
        this.getSmartLicenseDetail('init');
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
    }
    ngOnDestroy() {
        console.log('destory Smart License Base component');
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        clearTimeout(this.timeoutSmartLicenseStatus);
    }
}
SmartLicensePopupComponent.ɵfac = function SmartLicensePopupComponent_Factory(t) { return new (t || SmartLicensePopupComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(UserService), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
SmartLicensePopupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SmartLicensePopupComponent, selectors: [["app-smart-license-popup"]], inputs: { fromPage: "fromPage" }, outputs: { hideActivationPopup: "hideActivationPopup", registerSmartLicenseToken: "registerSmartLicenseToken" }, decls: 1, vars: 1, consts: [[3, "ngSwitch", 4, "ngIf"], [3, "ngSwitch"], ["class", "welcome", 4, "ngSwitchCase"], ["class", "tncContainer", 4, "ngSwitchCase"], [4, "ngSwitchCase"], [1, "welcome"], [1, "modalPopup"], [1, "modalOverlay"], [1, "modalContent"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody", "welcome-container"], [1, "welcome-container_left"], [3, "options"], [4, "ngFor", "ngForOf"], [1, "primaryButton", 3, "click"], [1, "welcome-container_right"], ["src", "/assets/images/smartlicense/configure-smart-account.svg", "width", "700"], [1, "welcome-container_footer"], [1, "check-sel"], [1, "circularCheckbox"], ["type", "checkbox", "name", "showWizard", 3, "checked", "click"], ["for", "showWizard", 1, "checkboxLabel"], [1, "check-label"], ["carouselSlide", ""], [1, "smAccHeading"], [1, "smAccDesc"], ["class", "smAccDesc", 4, "ngIf"], ["class", "link-text", "target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 1, "link-text", 3, "href"], [1, "tncContainer"], [1, "modalContentBasic", "modalContentTnc"], [1, "modalHeader"], [1, "modalBody"], [1, "tncFooterContainer"], [1, "cancelButton", 3, "click"], [1, "modalContentBasic", "modalContentConfig"], [1, "modalBody", 3, "ngSwitch"], ["class", "staticHeader", 4, "ngIf"], ["class", "slide1", 4, "ngSwitchCase"], ["class", "slide2", 4, "ngSwitchCase"], ["class", "slide3", 4, "ngSwitchCase"], [1, "configFooter"], ["class", "footerText", 3, "innerHtml", 4, "ngIf"], ["class", "commonButton", 3, "click", 4, "ngIf"], ["class", "primaryButton", 3, "click", 4, "ngIf"], ["class", "primaryButton", 3, "ngClass", "click", 4, "ngIf"], [1, "staticHeader"], [1, "staticHeader-container"], ["class", "staticHeader-container_counter", 3, "ngClass", 4, "ngIf"], [1, "staticHeader-container_counter", 3, "ngClass"], ["class", "staticHeader-container_counter__circle", 4, "ngIf"], [1, "staticHeader-container_counter__text"], [1, "staticHeader-container_counter__circle"], [1, "slide1"], [1, "slide1-header"], [1, "slide1-container"], [1, "slide1-container_box"], [1, "slide1-container_box__1"], [1, "slide1-container_box__2", 3, "click"], [1, "slide1-container_box__2___radio"], [1, "pmxRadio"], ["type", "radio", "name", "cssmStatus", 1, "pmxRadioButton", 3, "checked"], ["for", "cssmStatus", 1, "pmxRadioButtonLabel"], [1, "slide2"], [1, "slide2-header"], [1, "slide2-c"], [1, "slide2-c_row"], [1, "slide2-c_row__left"], [1, "slide2-c_row__right"], ["href", "https://software.cisco.com", "target", "_blank"], [1, "slide3"], [1, "slide3-header"], [1, "slide3-c"], ["rows", "10", "cols", "80", 1, "slide3-c_textarea", 3, "ngModel", "ngModelChange"], [1, "footerText", 3, "innerHtml"], [1, "commonButton", 3, "click"], [1, "primaryButton", 3, "ngClass", "click"]], template: function SmartLicensePopupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SmartLicensePopupComponent_ul_0_Template, 4, 4, "ul", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isUserRoleAvailable);
    } }, directives: [i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i8.CarouselComponent, i1$2.NgForOf, i8.CarouselSlideDirective, i1$2.NgClass, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel], styles: [".primaryButton[_ngcontent-%COMP%]{transition:all .2s}.modalContentBasic[_ngcontent-%COMP%]{z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden;overflow-y:scroll;-webkit-user-select:none;user-select:none}.modalContentSL[_ngcontent-%COMP%]{top:10vh;height:80vh;bottom:10vh;left:20vw;width:60vw}.modalContentTnc[_ngcontent-%COMP%]{top:15vh;height:70vh;bottom:15vh;left:20vw;width:60vw}.modalContentTnc[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{padding:90px 60px;font-family:\"ciscoSansLight\"}.modalContentTnc[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:16px}.modalContentTnc[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style:disc}.modalContentTnc[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:10px 0}.modalContentTnc[_ngcontent-%COMP%]   .tncFooterContainer[_ngcontent-%COMP%]{display:flex;flex-direction:row;padding:25px 30px;color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:fixed;width:inherit;background:#fff;bottom:inherit;left:inherit;align-content:space-between;justify-content:flex-start;align-items:center;box-shadow:0 -2px 4px #d2d2d280}.modalContentTnc[_ngcontent-%COMP%]   .tncFooterContainer[_ngcontent-%COMP%]   .cancelButton[_ngcontent-%COMP%]{font-size:14px;color:#049fd9;font-family:\"ciscoSansRegular\";padding-left:20px;cursor:pointer}.modalContentConfig[_ngcontent-%COMP%]{top:15vh;height:70vh;bottom:15vh;left:15vw;width:70vw}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:100%;margin:0;display:flex;flex-direction:column}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide1[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:stretch;width:70%;margin:auto;flex-wrap:nowrap}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide1-header[_ngcontent-%COMP%]{width:93%;margin:15px auto;text-align:left;font-family:\"ciscoSansRegular\"}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide1-container[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-evenly;flex-direction:row;align-content:center}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide1-container_box[_ngcontent-%COMP%]{border:1px solid #e9e9e9;width:45%;position:relative;height:300px;transition:all .3s;box-shadow:0 2px 5px #9183830d}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide1-container_box__1[_ngcontent-%COMP%]{height:60px;width:100%;background:#E9E9E9;position:absolute;top:0;left:0}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide1-container_box__2[_ngcontent-%COMP%]{margin-top:70px;padding:10px 30px;cursor:pointer}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide1-container_box__2[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px;-webkit-user-select:none;user-select:none;color:#626469;font-weight:bold;font-family:\"ciscoSansLight\"}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide1-container_box__2___radio[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-content:center;align-items:center;justify-content:space-between}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide1-container_box__2[_ngcontent-%COMP%]   .pmxRadio[_ngcontent-%COMP%]{width:50px}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide1-container_box__3[_ngcontent-%COMP%]{position:absolute;bottom:0;height:50px;line-height:50px;border-top:1px solid #E9E9E9;width:100%}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide1-container_box__3[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#049fd9;font-family:\"ciscoSansRegular\";padding-left:15px;cursor:pointer;font-size:14px;transition:all .5s}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide1-container_box__3[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:none;font-weight:bold;color:#03baff}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide1-container_box[_ngcontent-%COMP%]:hover{transform:scale(.99);border:1px solid #049FD9}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide2[_ngcontent-%COMP%]{width:70%;padding:15px 50px 100px;margin:0 auto;display:flex;flex-direction:column;color:#58585b;font-family:\"ciscoSansRegular\"}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide2-header[_ngcontent-%COMP%]{text-align:center;font-family:\"ciscoSansLight\"}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide2-c[_ngcontent-%COMP%]{border:1px solid #e9e9e9;padding:30px;margin:10px 0;box-shadow:0 0 4px #d2d2d280}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide2-c_row[_ngcontent-%COMP%]{display:flex;flex-direction:row}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide2-c_row__left[_ngcontent-%COMP%]{width:15%}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide2-c_row__right[_ngcontent-%COMP%]{width:80%}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide2-c_row__right[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{font-family:\"ciscoSansThin\"}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide3[_ngcontent-%COMP%]{width:70%;padding:50px 50px 100px;margin:0 auto;display:flex;flex-direction:column;color:#58585b;font-family:\"ciscoSansRegular\"}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide3-header[_ngcontent-%COMP%]{text-align:left;font-family:\"ciscoSansLight\"}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide3-c[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin:10px 0}.modalContentConfig[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .slide3-c_textarea[_ngcontent-%COMP%]{width:100%;height:150px;border:1px solid #edeff1;resize:none;background:#F2F3F5;font-family:\"Courier New\",monospace;font-size:25px;padding:20px}.modalContentConfig[_ngcontent-%COMP%]   .configFooter[_ngcontent-%COMP%]{display:flex;flex-direction:row;padding:15px 30px;color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:fixed;width:inherit;background:#fff;bottom:inherit;left:inherit;justify-content:flex-end;align-items:center;box-shadow:0 -2px 4px #d2d2d280}.modalContentConfig[_ngcontent-%COMP%]   .configFooter[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{min-width:100px;margin-right:15px}.modalContentConfig[_ngcontent-%COMP%]   .configFooter[_ngcontent-%COMP%]   .primaryButton[_ngcontent-%COMP%]{min-width:100px}.modalContentConfig[_ngcontent-%COMP%]   .configFooter[_ngcontent-%COMP%]   .footerText[_ngcontent-%COMP%]{font-family:\"ciscoSansLight\";font-size:14px;text-align:left;align-self:center;position:absolute;left:50px}.modalContentConfig[_ngcontent-%COMP%]   .staticHeader[_ngcontent-%COMP%]{border:1px solid #E9E9E9;height:90px;width:100%;margin-top:60px}.modalContentConfig[_ngcontent-%COMP%]   .staticHeader-container[_ngcontent-%COMP%]{width:55%;margin:0 auto;padding:10px 0;display:flex;align-items:center;justify-content:space-around;flex-direction:row;flex-wrap:nowrap;height:100%}.modalContentConfig[_ngcontent-%COMP%]   .staticHeader-container_counter[_ngcontent-%COMP%]{margin:0;padding:0;display:flex;flex-direction:column;align-items:center}.modalContentConfig[_ngcontent-%COMP%]   .staticHeader-container_counter[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:first-child{color:#58585b;background-color:#e9e9e9}.modalContentConfig[_ngcontent-%COMP%]   .staticHeader-container_counter__circle[_ngcontent-%COMP%]{height:50px;width:50px;border-radius:50%;text-align:center;line-height:50px;font-size:21px}.modalContentConfig[_ngcontent-%COMP%]   .staticHeader-container_counter__text[_ngcontent-%COMP%]{font-size:13px;text-align:center;margin-top:10px;color:#58585b;font-family:\"ciscoSansregular\"}.modalContentConfig[_ngcontent-%COMP%]   .staticHeader-container_counter[_ngcontent-%COMP%]:nth-child(n+2):before{background-color:#d0d0d0;content:\"\";display:inline-flex;height:1px;position:relative;top:27px;right:108px;width:145px}.modalContentConfig[_ngcontent-%COMP%]   .staticHeader-container[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:first-child{color:#fff;background-color:#049fd9;font-family:\"ciscoSansRegular\";box-shadow:0 0 10px #9ecaed}.modalContentConfig[_ngcontent-%COMP%]   .staticHeader-container[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%]:nth-child(n+2):before{background-color:#049fd9;content:\"\";height:2px}.modalContentConfig[_ngcontent-%COMP%]   .staticHeader-container[_ngcontent-%COMP%]   .tick[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:first-child{color:#049fd9;border:1px solid #049FD9;font-family:\"ciscoSansRegular\";background:transparent}.modalContentConfig[_ngcontent-%COMP%]   .staticHeader-container[_ngcontent-%COMP%]   .tick[_ngcontent-%COMP%]:nth-child(n+2):before{background-color:#049fd9;content:\"\";height:2px}.modalBody[_ngcontent-%COMP%]{padding:0}.welcome[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{padding:35px 50px 60px;margin-bottom:0;width:50%}.welcome[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{display:flex}.welcome[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{position:absolute;top:15px;right:20px}.welcome[_ngcontent-%COMP%]   .welcome-container_left[_ngcontent-%COMP%]{display:flex;flex-direction:column;width:50%}.welcome[_ngcontent-%COMP%]   .welcome-container_right[_ngcontent-%COMP%]{display:flex;width:50%}.welcome[_ngcontent-%COMP%]   .welcome-container_footer[_ngcontent-%COMP%]{height:50px;width:100%;background:#F2F3F5;position:absolute;bottom:0;left:0}.welcome[_ngcontent-%COMP%]   .welcome-container_footer[_ngcontent-%COMP%]   .check-label[_ngcontent-%COMP%]{font-size:13px;font-family:ciscoSansLight;color:#565659;position:relative;left:25px;bottom:17px}.welcome[_ngcontent-%COMP%]   .primaryButton[_ngcontent-%COMP%]{width:150px;top:30px;position:relative;left:3%}.modalHeader[_ngcontent-%COMP%]{position:fixed;width:inherit;background:#fff;z-index:99}.smAccHeading[_ngcontent-%COMP%]{font-size:22px;padding-bottom:10px;font-family:ciscoSans;color:#00090d}.smAccDesc[_ngcontent-%COMP%]{font-size:14px;width:80%;color:#77777b;padding-bottom:5px;font-family:\"ciscoSansExtraLight\"}.stepsWrapper[_ngcontent-%COMP%]{padding:20px 0}.prerequisite[_ngcontent-%COMP%]{background-color:#fee6be;font-size:12px;padding:10px;margin-bottom:20px;width:70%}.modalCloseIcon[_ngcontent-%COMP%]{position:absolute;right:0;top:10px;padding:15px 25px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer;z-index:999}[_nghost-%COMP%]  .owl-theme .owl-dots .owl-dot.active span, .owl-theme[_ngcontent-%COMP%]   .owl-dots[_ngcontent-%COMP%]   .owl-dot[_ngcontent-%COMP%]:hover   span[_ngcontent-%COMP%]{background:#049FD9!important}[_nghost-%COMP%]  .owl-theme .owl-prev{top:58px!important;left:15px!important;background:#81cfec!important;border-radius:50%!important;height:20px!important;width:20px!important;display:flex!important;justify-content:space-around!important;align-items:center!important;position:relative!important;font-size:18px!important;cursor:pointer!important;color:#fff!important;padding:0!important}[_nghost-%COMP%]  .owl-theme .owl-next{top:32px!important;left:125px!important;background:#81cfec!important;border-radius:50%!important;height:20px!important;width:20px!important;display:flex!important;justify-content:space-around!important;align-items:center!important;position:relative!important;font-size:18px!important;cursor:pointer!important;color:#fff!important;padding:0!important}[_nghost-%COMP%]  .owl-theme .owl-prev:hover, [_nghost-%COMP%]  .owl-theme .owl-next:hover{background:#049FD9!important}[_nghost-%COMP%]  .owl-theme .owl-nav{position:relative!important;padding:0!important;margin:0!important}[_nghost-%COMP%]  .owl-dots{position:absolute!important;width:100px!important;left:35px!important;top:95%!important}.link-text[_ngcontent-%COMP%]{font-family:\"ciscoSans\";color:#07a0d9;font-size:13px}.circularCheckbox[_ngcontent-%COMP%]{display:inline-block}.circularCheckbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]{opacity:0;height:20px;width:20px;z-index:3;cursor:pointer;display:block!important;position:relative!important;top:20px;left:20px}.circularCheckbox[_ngcontent-%COMP%]   .checkboxLabel[_ngcontent-%COMP%]{bottom:10px;left:25px}"], data: { animation: [
            trigger("flyInOutRTL", [
                state("in", style({ transform: "translate(0)" })),
                transition(":enter", [
                    style({ transform: "translate(100vw)" }),
                    animate("{{timingEnter}} {{delayEnter}} ease-in-out"),
                ], {
                    params: {
                        delayEnter: defaults.delayEnter,
                        timingEnter: defaults.timingEnter,
                    },
                }),
                transition(":leave", [
                    style({ transform: "translate(0)" }),
                    animate("{{timingLeave}} {{delayLeave}} ease-in-out", style({ transform: "translateX(-100vw)" })),
                ], {
                    params: {
                        delayLeave: defaults.delayLeave,
                        timingLeave: defaults.timingLeave,
                    },
                }),
            ]),
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartLicensePopupComponent, [{
        type: Component,
        args: [{
                selector: "app-smart-license-popup",
                templateUrl: "./smart-license-popup.component.html",
                styleUrls: ["./smart-license-popup.component.scss"],
                animations: [
                    trigger("flyInOutRTL", [
                        state("in", style({ transform: "translate(0)" })),
                        transition(":enter", [
                            style({ transform: "translate(100vw)" }),
                            animate("{{timingEnter}} {{delayEnter}} ease-in-out"),
                        ], {
                            params: {
                                delayEnter: defaults.delayEnter,
                                timingEnter: defaults.timingEnter,
                            },
                        }),
                        transition(":leave", [
                            style({ transform: "translate(0)" }),
                            animate("{{timingLeave}} {{delayLeave}} ease-in-out", style({ transform: "translateX(-100vw)" })),
                        ], {
                            params: {
                                delayLeave: defaults.delayLeave,
                                timingLeave: defaults.timingLeave,
                            },
                        }),
                    ]),
                ],
            }]
    }], function () { return [{ type: DataService }, { type: UserService }, { type: AuthService }, { type: i1.Router }, { type: LocationService }, { type: i2.TranslateService }]; }, { fromPage: [{
            type: Input
        }], hideActivationPopup: [{
            type: Output
        }], registerSmartLicenseToken: [{
            type: Output
        }] }); })();

class BusinessHierarchyService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.geoLocationRowArray = new Array();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.mapsDetails = (locationArray) => {
            let url = this.apiConfig.getBusinessMapsDetailsUrl();
            return this.post(url, locationArray)
                .pipe(map$1(this.extractResponse));
        };
        this.listLocationApsDetails = (locationId, start, end) => {
            let url = this.apiConfig.getBusinessListApsUrl().replace(":locationId", locationId) + `?start=${start}&end=${end}`;
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.listLocationSwitchDetails = (locationId, start, end) => {
            let url = this.apiConfig.getBusinessListSwitchUrl().replace(":locationId", locationId) + `?start=${start}&end=${end}`;
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.listLocationSensorDetails = (locationId, start, end) => {
            let url = this.apiConfig.getBusinessListSensorUrl().replace(":locationId", locationId) + `?start=${start}&end=${end}`;
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.locationApCountDetails = (locationId, rootHasChildren) => {
            let url = this.apiConfig.getBusinessApCountUrl().replace(":locationId", locationId);
            if (!rootHasChildren)
                url += '?rootHasChildren=false';
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.searchAps = (locationId, searchText, paramType) => {
            // let queryParam = `?locationId=${locationId}&search=${searchText}`;
            // let url = this.apiConfig.getBusinessApSearchUrl() + queryParam;
            let url = this.apiConfig.getBusinessListApsUrl().replace(":locationId", locationId) + `?start=0&end=0&search=${searchText}`;
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.getLocLicenseType = (locationId) => {
            let url = this.apiConfig.getLocLicenseTypeUrl() + `/${locationId}`;
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.globalLicenseUsage = () => {
            let url = this.apiConfig.globalLicenseUsageUrl();
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.saveLocationLicenseInfo = (locationObj) => {
            // testing
            // locationObj = {
            //     "locationId": "df716871-3c57-4043-b5e0-4c9879675222",
            //     "licType": "ACT"
            // }
            let url = this.apiConfig.saveLocationLicenseInfoUrl();
            return this.post(url, locationObj)
                .pipe(map$1(this.extractResponse));
        };
        this.updateLocationInfo = (loc) => {
            let url = this.apiConfig.updateLocationV2InfoUrl();
            return this.post(url, loc)
                .pipe(map$1(this.extractResponse));
        };
        this.getFloorImageFromS3 = (imageObj) => {
            let url = this.apiConfig.getFloorImageFromS3();
            return this.post(url, imageObj)
                .pipe(map$1(this.extractResponse));
        };
        this.getFloorMapDetails = (id) => {
            let url = this.apiConfig.getFloorMapDetails() + `/${id}`;
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.getFloorDetails = (id) => {
            let url = this.apiConfig.getFloorDetails() + `/${id}`;
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.getFloorMapImage = (imgObj) => {
            let url = this.apiConfig.getFloorMapImage();
            return this.post(url, imgObj)
                .pipe(map$1(this.extractResponse));
        };
        this.getCameraList = (locationId, start, end) => {
            let url = this.apiConfig.getCameraListUrl() + `/${locationId}?start=${start}&end=${end}`;
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.searchCamera = (locationId, searchText, paramType) => {
            let queryParam = '';
            queryParam = `?locationId=${locationId}&search=${searchText}`;
            let url = this.apiConfig.searchCameraUrl() + queryParam;
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.createGroup = (payload) => {
            let url = this.apiConfig.getCreateGroup2Url();
            return this.post(url, payload)
                .pipe(map$1(this.extractResponse));
        };
        this.updatePolygonZone = (zonePayload, zoneId) => {
            let url = this.apiConfig.updatePolygonZoneUrl() + `/${zoneId}`;
            return this.put(url, zonePayload)
                .pipe(map$1(this.extractResponse));
        };
        this.createPolygonZone = (zonePayload, floorId) => {
            let url = this.apiConfig.createPolygonZoneUrl() + `/${floorId}`;
            return this.post(url, zonePayload)
                .pipe(map$1(this.extractResponse));
        };
        this.getLocation2SyncStatus = (locationId) => {
            let url = this.apiConfig.getLocation2SyncStatusUrl() + `/${locationId}`;
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.renameLoc2 = (locationPayload, locationId) => {
            let url = this.apiConfig.renameLoc2() + `/${locationId}`;
            return this.post(url, locationPayload)
                .pipe(map$1(this.extractResponse));
        };
        this.listApPrefix = (payload) => {
            let url = this.apiConfig.listApPrefix();
            return this.post(url, payload)
                .pipe(map$1(this.extractResponse));
        };
        this.searchMatchingAp = (payload) => {
            let url = this.apiConfig.searchMatchingAp();
            return this.post(url, payload)
                .pipe(map$1(this.extractResponse));
        };
        this.updateApPrefix = (payload) => {
            let url = this.apiConfig.updateApPrefix();
            return this.post(url, payload)
                .pipe(map$1(this.extractResponse));
        };
        this.getLocationViewPreference = () => {
            let url = this.apiConfig.getLocationViewPreferenceUrl();
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.setLocationViewPreference = (payload) => {
            let url = this.apiConfig.setLocationViewPreferenceUrl();
            return this.post(url, payload)
                .pipe(map$1(this.extractResponse));
        };
        this.getRecentSearch = () => {
            let url = this.apiConfig.recentSearchUrl();
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.setRecentSearch = (payload) => {
            let url = this.apiConfig.saveRecentSearchUrl();
            return this.post(url, payload)
                .pipe(map$1(this.extractResponse));
        };
        this.getRMSAvailability = (tenantId, floorId) => {
            const url = `https://rms.dnaspaces.io/rmaps/${tenantId}/${floorId}`;
            return this.getPlainText(url)
                .pipe(map$1(this.extractResponse));
        };
        this.deleteLocation = (locationId) => {
            const url = this.apiConfig.getDeleteLocationV2(locationId);
            return this.delete(url).pipe(map$1(this.extractResponse));
        };
        this.getDeleteLocationStatus = (locationId) => {
            const url = this.apiConfig.getDeleteLocationV2Status(locationId);
            return this.get(url)
                .pipe(map$1(this.extractResponse));
        };
        this.getMetadataKeyListLh2 = () => {
            let serverUrl = this.apiConfig.getMetadataKeysLh2Url();
            return this.get(serverUrl)
                .pipe(map$1(this.extractResponse));
        };
        this.getMetadataListLh2 = (locationId) => {
            let serverUrl = this.apiConfig.getMetadataLh2Url() + "/" + locationId; //existing one
            return this.get(serverUrl)
                .pipe(map$1(this.extractResponse));
        };
        this.getTenantLocationMetadata = (locationId) => {
            let serverUrl = this.apiConfig.getTenantLocationMetadata() + "/" + locationId; //existing one
            return this.get(serverUrl)
                .pipe(map$1(this.extractResponse));
        };
        this.saveLocationMetadataLh2 = (locationId, addMetadataObj) => {
            let serverUrl = this.apiConfig.getAddLocationMetadataUrllh2() + "/" + locationId;
            return this.post(serverUrl, addMetadataObj)
                .pipe(map$1(this.extractResponse));
        };
        this.editLocationMetadataLh2 = (locationId, metadataObj) => {
            let serverUrl = this.apiConfig.getModifyLocationMetadataUrllh2() + "/" + locationId;
            return this.post(serverUrl, metadataObj)
                .pipe(map$1(this.extractResponse));
        };
        this.deleteLocationMetadataLh2 = (locationId, metadataObj) => {
            let serverUrl = this.apiConfig.getDeleteLocationMetadataUrllh2() + "/" + locationId;
            return this.post(serverUrl, metadataObj)
                .pipe(map$1(this.extractResponse));
        };
        this.locationInfoForBulkUpdate = (payload) => {
            let url = this.apiConfig.locationInfoForBulkUpdate();
            return this.post(url, payload)
                .pipe(map$1(this.extractResponse));
        };
        this.bulkUpdateLocationMetadata = (payload) => {
            let url = this.apiConfig.bulkUpdateLocationMetadata();
            return this.post(url, payload)
                .pipe(map$1(this.extractResponse));
        };
        this.bulkUpdateLocationInfo = (payload) => {
            let url = this.apiConfig.bulkUpdateLocationInfo();
            return this.post(url, payload)
                .pipe(map$1(this.extractResponse));
        };
        this.uncategorisedApCount = (payload) => {
            let url = this.apiConfig.uncategorisedApCount();
            return this.post(url, payload)
                .pipe(map$1(this.extractResponse));
        };
        this.uncategorizedApList = (locationId) => {
            let serverUrl = this.apiConfig.uncategorizedApList() + "/" + locationId;
            return this.get(serverUrl)
                .pipe(map$1(this.extractResponse));
        };
        this.autoPrefixStatus = (locationId) => {
            let serverUrl = this.apiConfig.autoPrefixStatus() + "/" + locationId;
            return this.get(serverUrl)
                .pipe(map$1(this.extractResponse));
        };
        this.autoPrefixStatusUpdate = (payload) => {
            let url = this.apiConfig.autoPrefixStatusUpdate();
            return this.post(url, payload)
                .pipe(map$1(this.extractResponse));
        };
        this.webexTPList = (locationId) => {
            let serverUrl = this.apiConfig.webexTPList() + "/" + locationId;
            return this.get(serverUrl)
                .pipe(map$1(this.extractResponse));
        };
        this.devicesAttached = (locationId) => {
            let serverUrl = this.apiConfig.devicesAttached() + "/" + locationId;
            return this.get(serverUrl)
                .pipe(map$1(this.extractResponse));
        };
        this.postBrowserDetails = (payload) => {
            let url = this.apiConfig.postBrowserDetailsUrl();
            return this.post(url, payload)
                .pipe(map$1(this.extractResponse));
        };
        this.getIndexedDBFlattened = () => {
            let serverUrl = this.apiConfig.getIndexedDBFlattened() + "?flattenedType=true";
            return this.get(serverUrl)
                .pipe(map$1(this.extractResponse));
        };
        this.getRMSStatus = (locationId) => {
            let serverUrl = this.apiConfig.getRMSStatus(locationId);
            return this.get(serverUrl)
                .pipe(map$1(this.extractResponse));
        };
        this.indexedDBVersion = () => {
            let serverUrl = this.apiConfig.indexedDBVersion();
            return this.get(serverUrl)
                .pipe(map$1(this.extractResponse));
        };
        this.forceRefreshTenant = () => {
            let serverUrl = this.apiConfig.forceRefreshTenant();
            return this.get(serverUrl)
                .pipe(map$1(this.extractResponse));
        };
        this.permissionChangeStatus = () => {
            let serverUrl = this.apiConfig.permissionChangeStatus();
            return this.get(serverUrl)
                .pipe(map$1(this.extractResponse));
        };
        this.setGeoLocationArray = (value) => {
            if (this.geoLocationRowArray.length === 0) {
                this.geoLocationRowArray.push(value);
            }
            else {
                let index = this.getGeoLocationArrayIndex('id', value.id);
                if (index > -1) {
                    // array item already exists
                    this.geoLocationRowArray[index] = value;
                }
                else {
                    this.geoLocationRowArray.push(value);
                }
            }
        };
        this.getGeoLocationRowArray = () => {
            return this.geoLocationRowArray;
        };
        this.getGeoLocationArrayByKey = (key, value) => {
            return this.geoLocationRowArray.filter((e) => {
                return e[key] === value;
            });
        };
        this.getGeoLocationArrayIndex = (key, value) => {
            let index = -1;
            let found = this.geoLocationRowArray.filter((e, i) => {
                if (e[key] === value) {
                    index = i;
                    return true;
                }
            });
            if (found && index > -1)
                return index;
            else
                return -1;
        };
    }
}
BusinessHierarchyService.ɵfac = function BusinessHierarchyService_Factory(t) { return new (t || BusinessHierarchyService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
BusinessHierarchyService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BusinessHierarchyService, factory: BusinessHierarchyService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BusinessHierarchyService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

function SplitLicenseUsageComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelementStart(2, "span", 6);
    i0.ɵɵtext(3, "LICENSE USAGE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SplitLicenseUsageComponent_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1, "You have ");
    i0.ɵɵelementStart(2, "span", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " type under ");
    i0.ɵɵelementStart(5, "span", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r3.licenseTypesCount, " License(s)");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.locationName);
} }
function SplitLicenseUsageComponent_div_0_div_4_th_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 11);
    i0.ɵɵtext(1, "License Units Consumed");
    i0.ɵɵelementEnd();
} }
function SplitLicenseUsageComponent_div_0_div_4_th_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 11);
    i0.ɵɵtext(1, "Compliance Status");
    i0.ɵɵelementEnd();
} }
function SplitLicenseUsageComponent_div_0_div_4_tbody_18_tr_1_td_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.consumedLicenses, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" of ", ctx_r10.totalLicenseCount, "");
} }
function SplitLicenseUsageComponent_div_0_div_4_tbody_18_tr_1_td_15_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const license_r9 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(license_r9.complianceStatus);
} }
function SplitLicenseUsageComponent_div_0_div_4_tbody_18_tr_1_td_15_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1, "Smart license not enabled");
    i0.ɵɵelementEnd();
} }
const _c0$1E = function (a0, a1) { return { "OutOfCompliance": a0, "InCompliance": a1 }; };
function SplitLicenseUsageComponent_div_0_div_4_tbody_18_tr_1_td_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 20);
    i0.ɵɵtemplate(1, SplitLicenseUsageComponent_div_0_div_4_tbody_18_tr_1_td_15_span_1_Template, 2, 1, "span", 2);
    i0.ɵɵtemplate(2, SplitLicenseUsageComponent_div_0_div_4_tbody_18_tr_1_td_15_ng_template_2_Template, 2, 0, "ng-template", null, 21, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r13 = i0.ɵɵreference(3);
    const license_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r11 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c0$1E, license_r9.complianceStatus == "OutOfCompliance", license_r9.complianceStatus == "InCompliance"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.isRegisteredSL)("ngIfElse", _r13);
} }
function SplitLicenseUsageComponent_div_0_div_4_tbody_18_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 15);
    i0.ɵɵelementStart(1, "td", 16);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td");
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, SplitLicenseUsageComponent_div_0_div_4_tbody_18_tr_1_td_14_Template, 4, 2, "td", 18);
    i0.ɵɵtemplate(15, SplitLicenseUsageComponent_div_0_div_4_tbody_18_tr_1_td_15_Template, 4, 6, "td", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const license_r9 = ctx.$implicit;
    const ctx_r8 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r8.getLocationClass(license_r9));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(license_r9.licenseType);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", license_r9.apCount, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", license_r9.webexDeviceCount, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", license_r9.cameraCount, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", license_r9.locCount, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", license_r9.buildingUnitsCount, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r8.isRegisteredSL);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.fromSLPage == "SLPage");
} }
function SplitLicenseUsageComponent_div_0_div_4_tbody_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 9);
    i0.ɵɵtemplate(1, SplitLicenseUsageComponent_div_0_div_4_tbody_18_tr_1_Template, 16, 10, "tr", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r7.licenseCountList);
} }
function SplitLicenseUsageComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "table", 8);
    i0.ɵɵelementStart(2, "thead", 9);
    i0.ɵɵelementStart(3, "tr", 10);
    i0.ɵɵelementStart(4, "th", 11);
    i0.ɵɵtext(5, "License");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 11);
    i0.ɵɵtext(7, "Access Points");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th", 11);
    i0.ɵɵtext(9, "Webex Devices");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 11);
    i0.ɵɵtext(11, "Meraki Camera");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th", 11);
    i0.ɵɵtext(13, "Locations");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "th", 11);
    i0.ɵɵtext(15, "Building Units");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, SplitLicenseUsageComponent_div_0_div_4_th_16_Template, 2, 0, "th", 12);
    i0.ɵɵtemplate(17, SplitLicenseUsageComponent_div_0_div_4_th_17_Template, 2, 0, "th", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, SplitLicenseUsageComponent_div_0_div_4_tbody_18_Template, 2, 1, "tbody", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(16);
    i0.ɵɵproperty("ngIf", !ctx_r4.isRegisteredSL);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.fromSLPage == "SLPage");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.licenseCountList);
} }
function SplitLicenseUsageComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, SplitLicenseUsageComponent_div_0_div_1_Template, 4, 0, "div", 2);
    i0.ɵɵtemplate(2, SplitLicenseUsageComponent_div_0_ng_template_2_Template, 7, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, SplitLicenseUsageComponent_div_0_div_4_Template, 19, 3, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r2 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.fromSLPage == "SLPage")("ngIfElse", _r2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.licenseCountList && ctx_r0.licenseCountList.length > 0);
} }
class SplitLicenseUsageComponent {
    constructor(dataService, businessHierarchyService) {
        this.dataService = dataService;
        this.businessHierarchyService = businessHierarchyService;
        this.unsubscribe$ = new Subject();
        this.messages = [];
        this.destroyed$ = new Subject();
        this.fromSLPage = '';
        this.isRegisteredSL = false;
        this.licenseType = '';
        this.locLicenseObjLoaded = false;
        this.actObject = {};
        this.extendObject = {};
        this.smartvenueObj = {};
        this.smartopsObj = {};
        this.unlimitedObj = {};
        this.licenseTypesCount = 0;
        this.globalLicenseUsage = () => {
            this.licenseTypesCount = 0;
            this.licenseCountList = [];
            this.dataService.display(true);
            this.businessHierarchyService.globalLicenseUsage().subscribe((response) => {
                console.log(JSON.stringify(response));
                // Location License Object
                let licenseCount = 0;
                let licenseObj = response.data;
                this.totalLicenseCount = licenseObj.licenseCount ? licenseObj.licenseCount : 0;
                this.consumedLicenses = licenseObj.consumedLicenses ? licenseObj.consumedLicenses : 0;
                if (licenseObj) {
                    this.seeObject = Object.assign({}, licenseObj.see);
                    this.seeObject["apCount"] = this.seeObject["apCount"] ? this.seeObject["apCount"] : 0;
                    this.seeObject["locCount"] = this.seeObject["locCount"] ? this.seeObject["locCount"] : 0;
                    this.seeObject["cameraCount"] = this.seeObject["cameraCount"] ? this.seeObject["cameraCount"] : 0;
                    this.seeObject["webexDeviceCount"] = this.seeObject["webexDeviceCount"] ? this.seeObject["webexDeviceCount"] : 0;
                    this.seeObject["buildingUnitsCount"] = this.seeObject["buildingUnitsCount"] ? this.seeObject["buildingUnitsCount"] : 0;
                    if (!this.isEmptyObject(licenseObj.see)) {
                        licenseCount++;
                        this.seeObject['isEmptyObject'] = false;
                        this.seeObject['licenseType'] = 'SEE';
                        this.licenseCountList.push(this.seeObject);
                    }
                    else {
                        this.seeObject['isEmptyObject'] = true;
                    }
                    this.actObject = Object.assign({}, licenseObj.act);
                    this.actObject["apCount"] = this.actObject["apCount"] ? this.actObject["apCount"] : 0;
                    this.actObject["locCount"] = this.actObject["locCount"] ? this.actObject["locCount"] : 0;
                    this.actObject["cameraCount"] = this.actObject["cameraCount"] ? this.actObject["cameraCount"] : 0;
                    this.actObject["webexDeviceCount"] = this.actObject["webexDeviceCount"] ? this.actObject["webexDeviceCount"] : 0;
                    this.actObject["buildingUnitsCount"] = this.actObject["buildingUnitsCount"] ? this.actObject["buildingUnitsCount"] : 0;
                    if (!this.isEmptyObject(licenseObj.act)) {
                        licenseCount++;
                        this.actObject['isEmptyObject'] = false;
                        this.actObject['licenseType'] = 'ACT';
                        this.licenseCountList.push(this.actObject);
                    }
                    else {
                        this.actObject['isEmptyObject'] = true;
                    }
                    this.extendObject = Object.assign({}, licenseObj.extend);
                    this.extendObject["apCount"] = this.extendObject["apCount"] ? this.extendObject["apCount"] : 0;
                    this.extendObject["locCount"] = this.extendObject["locCount"] ? this.extendObject["locCount"] : 0;
                    this.extendObject["cameraCount"] = this.extendObject["cameraCount"] ? this.extendObject["cameraCount"] : 0;
                    this.extendObject["webexDeviceCount"] = this.extendObject["webexDeviceCount"] ? this.extendObject["webexDeviceCount"] : 0;
                    this.extendObject["buildingUnitsCount"] = this.extendObject["buildingUnitsCount"] ? this.extendObject["buildingUnitsCount"] : 0;
                    if (!this.isEmptyObject(licenseObj.extend)) {
                        licenseCount++;
                        this.extendObject['isEmptyObject'] = false;
                        this.extendObject['licenseType'] = 'EXTEND';
                        this.licenseCountList.push(this.extendObject);
                    }
                    else {
                        this.extendObject['isEmptyObject'] = true;
                    }
                    this.smartvenueObj = Object.assign({}, licenseObj.smartVenue);
                    this.smartvenueObj["apCount"] = this.smartvenueObj["apCount"] ? this.smartvenueObj["apCount"] : 0;
                    this.smartvenueObj["locCount"] = this.smartvenueObj["locCount"] ? this.smartvenueObj["locCount"] : 0;
                    this.smartvenueObj["cameraCount"] = this.smartvenueObj["cameraCount"] ? this.smartvenueObj["cameraCount"] : 0;
                    this.smartvenueObj["webexDeviceCount"] = this.smartvenueObj["webexDeviceCount"] ? this.smartvenueObj["webexDeviceCount"] : 0;
                    this.smartvenueObj["buildingUnitsCount"] = this.smartvenueObj["buildingUnitsCount"] ? this.smartvenueObj["buildingUnitsCount"] : 0;
                    if (!this.isEmptyObject(licenseObj.smartVenue)) {
                        licenseCount++;
                        this.smartvenueObj['isEmptyObject'] = false;
                        this.smartvenueObj['licenseType'] = 'SMART_VENUES';
                        this.licenseCountList.push(this.smartvenueObj);
                    }
                    else {
                        this.smartvenueObj['isEmptyObject'] = true;
                    }
                    this.smartopsObj = Object.assign({}, licenseObj.smartOps);
                    this.smartopsObj["apCount"] = this.smartopsObj["apCount"] ? this.smartopsObj["apCount"] : 0;
                    this.smartopsObj["locCount"] = this.smartopsObj["locCount"] ? this.smartopsObj["locCount"] : 0;
                    this.smartopsObj["cameraCount"] = this.smartopsObj["cameraCount"] ? this.smartopsObj["cameraCount"] : 0;
                    this.smartopsObj["webexDeviceCount"] = this.smartopsObj["webexDeviceCount"] ? this.smartopsObj["webexDeviceCount"] : 0;
                    this.smartopsObj["buildingUnitsCount"] = this.smartopsObj["buildingUnitsCount"] ? this.smartopsObj["buildingUnitsCount"] : 0;
                    if (!this.isEmptyObject(licenseObj.smartOps)) {
                        licenseCount++;
                        this.smartopsObj['isEmptyObject'] = false;
                        this.smartopsObj['licenseType'] = 'SMART_OPERATIONS';
                        this.licenseCountList.push(this.smartopsObj);
                    }
                    else {
                        this.smartopsObj['isEmptyObject'] = true;
                    }
                    this.unlimitedObj = Object.assign({}, licenseObj.unlimited);
                    this.unlimitedObj["apCount"] = this.unlimitedObj["apCount"] ? this.unlimitedObj["apCount"] : 0;
                    this.unlimitedObj["locCount"] = this.unlimitedObj["locCount"] ? this.unlimitedObj["locCount"] : 0;
                    this.unlimitedObj["cameraCount"] = this.unlimitedObj["cameraCount"] ? this.unlimitedObj["cameraCount"] : 0;
                    this.unlimitedObj["webexDeviceCount"] = this.unlimitedObj["webexDeviceCount"] ? this.unlimitedObj["webexDeviceCount"] : 0;
                    this.unlimitedObj["buildingUnitsCount"] = this.unlimitedObj["buildingUnitsCount"] ? this.unlimitedObj["buildingUnitsCount"] : 0;
                    if (!this.isEmptyObject(licenseObj.unlimited)) {
                        licenseCount++;
                        this.unlimitedObj['isEmptyObject'] = false;
                        this.unlimitedObj['licenseType'] = 'UNLIMITED';
                        this.licenseCountList.push(this.unlimitedObj);
                    }
                    else {
                        this.unlimitedObj['isEmptyObject'] = true;
                    }
                    this.licenseTypesCount = licenseCount;
                    this.locLicenseObjLoaded = true;
                    this.dataService.display(false);
                }
            }, (error) => {
                this.locLicenseObjLoaded = true;
                console.log(JSON.stringify(error));
                this.dataService.display(false);
            });
        };
        this.getLocLicenseType = () => {
            this.licenseTypesCount = 0;
            this.licenseCountList = [];
            let id = this.locationId;
            this.dataService.display(true);
            this.businessHierarchyService.getLocLicenseType(id).subscribe((response) => {
                console.log(JSON.stringify(response));
                // Location License Object
                let licenseCount = 0;
                let licenseObj = response.data;
                if (licenseObj) {
                    this.seeObject = Object.assign({}, licenseObj.see);
                    this.seeObject["apCount"] = this.seeObject["apCount"] ? this.seeObject["apCount"] : 0;
                    this.seeObject["locCount"] = this.seeObject["locCount"] ? this.seeObject["locCount"] : 0;
                    this.seeObject["cameraCount"] = this.seeObject["cameraCount"] ? this.seeObject["cameraCount"] : 0;
                    this.seeObject["webexDeviceCount"] = this.seeObject["webexDeviceCount"] ? this.seeObject["webexDeviceCount"] : 0;
                    this.seeObject["buildingUnitsCount"] = this.seeObject["buildingUnitsCount"] ? this.seeObject["buildingUnitsCount"] : 0;
                    if (!this.isEmptyObject(licenseObj.see)) {
                        licenseCount++;
                        this.seeObject['isEmptyObject'] = false;
                        this.seeObject['licenseType'] = 'SEE';
                        this.licenseCountList.push(this.seeObject);
                    }
                    else {
                        this.seeObject['isEmptyObject'] = true;
                    }
                    this.actObject = Object.assign({}, licenseObj.act);
                    this.actObject["apCount"] = this.actObject["apCount"] ? this.actObject["apCount"] : 0;
                    this.actObject["locCount"] = this.actObject["locCount"] ? this.actObject["locCount"] : 0;
                    this.actObject["cameraCount"] = this.actObject["cameraCount"] ? this.actObject["cameraCount"] : 0;
                    this.actObject["webexDeviceCount"] = this.actObject["webexDeviceCount"] ? this.actObject["webexDeviceCount"] : 0;
                    this.actObject["buildingUnitsCount"] = this.actObject["buildingUnitsCount"] ? this.actObject["buildingUnitsCount"] : 0;
                    if (!this.isEmptyObject(licenseObj.act)) {
                        licenseCount++;
                        this.actObject['isEmptyObject'] = false;
                        this.actObject['licenseType'] = 'ACT';
                        this.licenseCountList.push(this.actObject);
                    }
                    else {
                        this.actObject['isEmptyObject'] = true;
                    }
                    this.extendObject = Object.assign({}, licenseObj.extend);
                    this.extendObject["apCount"] = this.extendObject["apCount"] ? this.extendObject["apCount"] : 0;
                    this.extendObject["locCount"] = this.extendObject["locCount"] ? this.extendObject["locCount"] : 0;
                    this.extendObject["cameraCount"] = this.extendObject["cameraCount"] ? this.extendObject["cameraCount"] : 0;
                    this.extendObject["webexDeviceCount"] = this.extendObject["webexDeviceCount"] ? this.extendObject["webexDeviceCount"] : 0;
                    this.extendObject["buildingUnitsCount"] = this.extendObject["buildingUnitsCount"] ? this.extendObject["buildingUnitsCount"] : 0;
                    if (!this.isEmptyObject(licenseObj.extend)) {
                        licenseCount++;
                        this.extendObject['isEmptyObject'] = false;
                        this.extendObject['licenseType'] = 'EXTEND';
                        this.licenseCountList.push(this.extendObject);
                    }
                    else {
                        this.extendObject['isEmptyObject'] = true;
                    }
                    this.smartvenueObj = Object.assign({}, licenseObj.smartVenue);
                    this.smartvenueObj["apCount"] = this.smartvenueObj["apCount"] ? this.smartvenueObj["apCount"] : 0;
                    this.smartvenueObj["locCount"] = this.smartvenueObj["locCount"] ? this.smartvenueObj["locCount"] : 0;
                    this.smartvenueObj["cameraCount"] = this.smartvenueObj["cameraCount"] ? this.smartvenueObj["cameraCount"] : 0;
                    this.smartvenueObj["webexDeviceCount"] = this.smartvenueObj["webexDeviceCount"] ? this.smartvenueObj["webexDeviceCount"] : 0;
                    this.smartvenueObj["buildingUnitsCount"] = this.smartvenueObj["buildingUnitsCount"] ? this.smartvenueObj["buildingUnitsCount"] : 0;
                    if (!this.isEmptyObject(licenseObj.smartVenue)) {
                        licenseCount++;
                        this.smartvenueObj['isEmptyObject'] = false;
                        this.smartvenueObj['licenseType'] = 'SMART_VENUES';
                        this.licenseCountList.push(this.smartvenueObj);
                    }
                    else {
                        this.smartvenueObj['isEmptyObject'] = true;
                    }
                    this.smartopsObj = Object.assign({}, licenseObj.smartOps);
                    this.smartopsObj["apCount"] = this.smartopsObj["apCount"] ? this.smartopsObj["apCount"] : 0;
                    this.smartopsObj["locCount"] = this.smartopsObj["locCount"] ? this.smartopsObj["locCount"] : 0;
                    this.smartopsObj["cameraCount"] = this.smartopsObj["cameraCount"] ? this.smartopsObj["cameraCount"] : 0;
                    this.smartopsObj["webexDeviceCount"] = this.smartopsObj["webexDeviceCount"] ? this.smartopsObj["webexDeviceCount"] : 0;
                    this.smartopsObj["buildingUnitsCount"] = this.smartopsObj["buildingUnitsCount"] ? this.smartopsObj["buildingUnitsCount"] : 0;
                    if (!this.isEmptyObject(licenseObj.smartOps)) {
                        licenseCount++;
                        this.smartopsObj['isEmptyObject'] = false;
                        this.smartopsObj['licenseType'] = 'SMART_OPERATIONS';
                        this.licenseCountList.push(this.smartopsObj);
                    }
                    else {
                        this.smartopsObj['isEmptyObject'] = true;
                    }
                    this.unlimitedObj = Object.assign({}, licenseObj.unlimited);
                    this.unlimitedObj["apCount"] = this.unlimitedObj["apCount"] ? this.unlimitedObj["apCount"] : 0;
                    this.unlimitedObj["locCount"] = this.unlimitedObj["locCount"] ? this.unlimitedObj["locCount"] : 0;
                    this.unlimitedObj["cameraCount"] = this.unlimitedObj["cameraCount"] ? this.unlimitedObj["cameraCount"] : 0;
                    this.unlimitedObj["webexDeviceCount"] = this.unlimitedObj["webexDeviceCount"] ? this.unlimitedObj["webexDeviceCount"] : 0;
                    this.unlimitedObj["buildingUnitsCount"] = this.unlimitedObj["buildingUnitsCount"] ? this.unlimitedObj["buildingUnitsCount"] : 0;
                    if (!this.isEmptyObject(licenseObj.unlimited)) {
                        licenseCount++;
                        this.unlimitedObj['isEmptyObject'] = false;
                        this.unlimitedObj['licenseType'] = 'UNLIMITED';
                        this.licenseCountList.push(this.unlimitedObj);
                    }
                    else {
                        this.unlimitedObj['isEmptyObject'] = true;
                    }
                    this.licenseTypesCount = licenseCount;
                    this.locLicenseObjLoaded = true;
                    this.dataService.display(false);
                }
            }, (error) => {
                this.locLicenseObjLoaded = true;
                console.log(JSON.stringify(error));
                this.dataService.display(false);
            });
        };
        this.isEmptyObject = (obj) => {
            if (obj !== undefined && obj !== null) {
                const isEmptyObj = obj && Object.keys(obj).length === 0;
                // console.log("Empty Object Check::", obj, isEmptyObj);
                return isEmptyObj;
            }
            else {
                return true;
            }
        };
        this.getLocationClass = (licenseObj) => {
            let classString = '';
            if (licenseObj.licenseType) {
                classString = licenseObj.licenseType.toLowerCase() + '-tag';
                classString = classString.replace(' ', '');
                return classString;
            }
        };
    }
    ngOnInit() {
        // from SL page we need to get tenant id
        if (this.fromSLPage) {
            this.tenantId = this.dataService.getTenantId();
            this.globalLicenseUsage();
        }
        else {
            this.getLocLicenseType();
        }
    }
    ngOnDestroy() {
        console.log('destory Smart License usage component');
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
SplitLicenseUsageComponent.ɵfac = function SplitLicenseUsageComponent_Factory(t) { return new (t || SplitLicenseUsageComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(BusinessHierarchyService)); };
SplitLicenseUsageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SplitLicenseUsageComponent, selectors: [["app-split-license-usage"]], inputs: { locationId: "locationId", locationName: "locationName", fromSLPage: "fromSLPage", isRegisteredSL: "isRegisteredSL" }, decls: 1, vars: 1, consts: [["class", "license-wrappper", 4, "ngIf"], [1, "license-wrappper"], [4, "ngIf", "ngIfElse"], ["nonSLPage", ""], ["class", "userTableContainer", 4, "ngIf"], [1, "license-count-desc"], [1, "cisco-sans"], [1, "userTableContainer"], [1, "table", "userTable"], [1, "table-border"], [1, "rules-list-header"], [1, "h-col"], ["class", "h-col", 4, "ngIf"], ["class", "table-border", 4, "ngIf"], ["class", "tableTr", 4, "ngFor", "ngForOf"], [1, "tableTr"], [1, "license-tag"], [1, "license-label"], [4, "ngIf"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], ["notRegisteredSL", ""], [1, "not-registered-sl"]], template: function SplitLicenseUsageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SplitLicenseUsageComponent_div_0_Template, 5, 3, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.locLicenseObjLoaded);
    } }, directives: [i1$2.NgIf, i1$2.NgForOf, i1$2.NgClass], styles: [".license-wrappper[_ngcontent-%COMP%]{background-color:#fafafa}.firstCell[_ngcontent-%COMP%]{padding-bottom:20px;width:30%}.secondCell[_ngcontent-%COMP%], .thirdCell[_ngcontent-%COMP%]{width:30%}.border-left[_ngcontent-%COMP%]{padding-left:30px;border-left:1px solid #d9d9d9}.liecense-img[_ngcontent-%COMP%]{width:80px}.see-label[_ngcontent-%COMP%]{font-family:Helvetica;font-style:normal;font-weight:normal;font-size:32.73px;line-height:38px;letter-spacing:.000202091px;color:#38a8e3}.extend-label[_ngcontent-%COMP%]{font-family:Helvetica;font-style:normal;font-weight:normal;font-size:32.73px;line-height:38px;letter-spacing:.000202091px;color:#80bb5a}.act-label[_ngcontent-%COMP%]{font-family:Helvetica;font-style:normal;font-weight:normal;font-size:32.73px;line-height:38px;letter-spacing:.000202091px;color:#f8ab19}.count-value[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:18px;line-height:16px;color:#000;padding-bottom:5px}.count-label[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:12px;line-height:14px;color:#49494a}.license-count-desc[_ngcontent-%COMP%]{padding-bottom:15px;font-family:\"CiscoSansLight\";font-style:normal;font-weight:350;font-size:14px;line-height:20px;letter-spacing:.5px;color:#000}.license-count-desc[_ngcontent-%COMP%]   .cisco-sans[_ngcontent-%COMP%]{font-family:\"CiscoSans\"}.table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(even){background-color:#fff}.license-tag[_ngcontent-%COMP%]{display:inline-block;padding:5px 10px;margin:15px;border-radius:50px}.see-tag[_ngcontent-%COMP%]{background-color:#009edc}.act-tag[_ngcontent-%COMP%]{background-color:#f8ab19}.extend-tag[_ngcontent-%COMP%], .ext-tag[_ngcontent-%COMP%]{background-color:#7cc242}.smartvenue-tag[_ngcontent-%COMP%], .smart_venues-tag[_ngcontent-%COMP%]{background-color:#436fb6}.smartops-tag[_ngcontent-%COMP%], .smart_operations-tag[_ngcontent-%COMP%]{background-color:#8750a1}.unlimited-tag[_ngcontent-%COMP%]{background-color:#ff7c33}.license-label[_ngcontent-%COMP%]{font-family:\"ciscoSansLight\";font-style:normal;font-weight:400;font-size:16px;text-align:center;color:#fff}.license-desc[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:12px;line-height:18px;letter-spacing:.5px;color:#565659}.OutOfCompliance[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px;color:#d4371c}.InCompliance[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px;color:#00ab50}.not-registered-sl[_ngcontent-%COMP%]{color:#d08102}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SplitLicenseUsageComponent, [{
        type: Component,
        args: [{
                selector: 'app-split-license-usage',
                templateUrl: './split-license-usage.component.html',
                styleUrls: ['./split-license-usage.component.scss']
            }]
    }], function () { return [{ type: DataService }, { type: BusinessHierarchyService }]; }, { locationId: [{
            type: Input
        }], locationName: [{
            type: Input
        }], fromSLPage: [{
            type: Input
        }], isRegisteredSL: [{
            type: Input
        }] }); })();

function ChangeBaseLicenseComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Terms and Conditions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵlistener("click", function ChangeBaseLicenseComponent_div_3_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.nextStep("warning"); });
    i0.ɵɵtext(4, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ChangeBaseLicenseComponent_ng_template_4_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵlistener("click", function ChangeBaseLicenseComponent_ng_template_4_span_3_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.toggleChangeLicensePopup(false); });
    i0.ɵɵtext(1, "\uE909");
    i0.ɵɵelementEnd();
} }
function ChangeBaseLicenseComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Select License Level");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ChangeBaseLicenseComponent_ng_template_4_span_3_Template, 2, 0, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.step != "success");
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_6_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r18.availableLicenseTypes[0].subtitle, "");
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_6_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.availableLicenseTypes[0].error, "");
} }
const _c0$1D = function (a0) { return { "disabledLicense": a0 }; };
function ChangeBaseLicenseComponent_div_6_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelementStart(2, "div", 19);
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵelementStart(5, "div", 20);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "div", 21);
    i0.ɵɵlistener("click", function ChangeBaseLicenseComponent_div_6_div_1_div_6_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(3); return ctx_r20.changeBaseLicenseCheck(ctx_r20.availableLicenseTypes[0], "upgrade"); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ChangeBaseLicenseComponent_div_6_div_1_div_6_div_9_Template, 2, 1, "div", 22);
    i0.ɵɵelementStart(10, "div", 23);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, ChangeBaseLicenseComponent_div_6_div_1_div_6_div_12_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$1D, ctx_r14.availableLicenseTypes[0].disabled));
    i0.ɵɵadvance(6);
    i0.ɵɵclassMapInterpolate1("license-tag ", ctx_r14.availableLicenseTypes[0].class, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.availableLicenseTypes[0].title, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.availableLicenseTypes[0].subtitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r14.availableLicenseTypes[0].desc, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.availableLicenseTypes[0].error);
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_7_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r22.availableLicenseTypes[1].subtitle, "");
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_7_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.availableLicenseTypes[1].error, "");
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelementStart(2, "div", 19);
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵelementStart(5, "div", 20);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "div", 21);
    i0.ɵɵlistener("click", function ChangeBaseLicenseComponent_div_6_div_1_div_7_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(3); return ctx_r24.changeBaseLicenseCheck(ctx_r24.availableLicenseTypes[1], "upgrade"); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ChangeBaseLicenseComponent_div_6_div_1_div_7_div_9_Template, 2, 1, "div", 22);
    i0.ɵɵelementStart(10, "div", 23);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, ChangeBaseLicenseComponent_div_6_div_1_div_7_div_12_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$1D, ctx_r15.availableLicenseTypes[1].disabled));
    i0.ɵɵadvance(6);
    i0.ɵɵclassMapInterpolate1("license-tag ", ctx_r15.availableLicenseTypes[1].class, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.availableLicenseTypes[1].title, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.availableLicenseTypes[1].subtitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r15.availableLicenseTypes[1].desc, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.availableLicenseTypes[1].error);
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_8_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r26.availableLicenseTypes[2].subtitle, "");
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_8_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r27.availableLicenseTypes[2].error, "");
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelementStart(2, "div", 19);
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵelementStart(5, "div", 20);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "div", 21);
    i0.ɵɵlistener("click", function ChangeBaseLicenseComponent_div_6_div_1_div_8_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(3); return ctx_r28.changeBaseLicenseCheck(ctx_r28.availableLicenseTypes[2], "upgrade"); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ChangeBaseLicenseComponent_div_6_div_1_div_8_div_9_Template, 2, 1, "div", 22);
    i0.ɵɵelementStart(10, "div", 23);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, ChangeBaseLicenseComponent_div_6_div_1_div_8_div_12_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$1D, ctx_r16.availableLicenseTypes[2].disabled));
    i0.ɵɵadvance(6);
    i0.ɵɵclassMapInterpolate1("license-tag ", ctx_r16.availableLicenseTypes[2].class, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.availableLicenseTypes[2].title, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.availableLicenseTypes[2].subtitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r16.availableLicenseTypes[2].desc, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.availableLicenseTypes[2].error);
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_9_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r32.availableLicenseTypes[3].subtitle, "");
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_9_div_1_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r33.availableLicenseTypes[3].error, "");
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelementStart(2, "div", 19);
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵelementStart(5, "div", 20);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "div", 21);
    i0.ɵɵlistener("click", function ChangeBaseLicenseComponent_div_6_div_1_div_9_div_1_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(4); return ctx_r34.changeBaseLicenseCheck(ctx_r34.availableLicenseTypes[3], "upgrade"); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ChangeBaseLicenseComponent_div_6_div_1_div_9_div_1_div_9_Template, 2, 1, "div", 22);
    i0.ɵɵelementStart(10, "div", 23);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, ChangeBaseLicenseComponent_div_6_div_1_div_9_div_1_div_12_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$1D, ctx_r30.availableLicenseTypes[3].disabled));
    i0.ɵɵadvance(6);
    i0.ɵɵclassMapInterpolate1("license-tag ", ctx_r30.availableLicenseTypes[3].class, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r30.availableLicenseTypes[3].title, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r30.availableLicenseTypes[3].subtitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r30.availableLicenseTypes[3].desc, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r30.availableLicenseTypes[3].error);
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_9_div_2_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r36.availableLicenseTypes[4].subtitle, "");
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_9_div_2_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r37.availableLicenseTypes[4].error, "");
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_9_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelementStart(2, "div", 19);
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵelementStart(5, "div", 20);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "div", 21);
    i0.ɵɵlistener("click", function ChangeBaseLicenseComponent_div_6_div_1_div_9_div_2_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(4); return ctx_r38.changeBaseLicenseCheck(ctx_r38.availableLicenseTypes[4], "upgrade"); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ChangeBaseLicenseComponent_div_6_div_1_div_9_div_2_div_9_Template, 2, 1, "div", 22);
    i0.ɵɵelementStart(10, "div", 23);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, ChangeBaseLicenseComponent_div_6_div_1_div_9_div_2_div_12_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$1D, ctx_r31.availableLicenseTypes[4].disabled));
    i0.ɵɵadvance(6);
    i0.ɵɵclassMapInterpolate1("license-tag ", ctx_r31.availableLicenseTypes[4].class, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r31.availableLicenseTypes[4].title, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r31.availableLicenseTypes[4].subtitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r31.availableLicenseTypes[4].desc, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r31.availableLicenseTypes[4].error);
} }
function ChangeBaseLicenseComponent_div_6_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, ChangeBaseLicenseComponent_div_6_div_1_div_9_div_1_Template, 13, 10, "div", 15);
    i0.ɵɵtemplate(2, ChangeBaseLicenseComponent_div_6_div_1_div_9_div_2_Template, 13, 10, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.availableLicenseTypes[3] && ctx_r17.availableLicenseTypes[3].type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.availableLicenseTypes[4] && ctx_r17.availableLicenseTypes[4].type);
} }
function ChangeBaseLicenseComponent_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵtext(3, "Choose the License Tier");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 13);
    i0.ɵɵelementStart(5, "div", 14);
    i0.ɵɵtemplate(6, ChangeBaseLicenseComponent_div_6_div_1_div_6_Template, 13, 10, "div", 15);
    i0.ɵɵtemplate(7, ChangeBaseLicenseComponent_div_6_div_1_div_7_Template, 13, 10, "div", 15);
    i0.ɵɵtemplate(8, ChangeBaseLicenseComponent_div_6_div_1_div_8_Template, 13, 10, "div", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ChangeBaseLicenseComponent_div_6_div_1_div_9_Template, 3, 2, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r9.availableLicenseTypes[0] && ctx_r9.availableLicenseTypes[0].type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.availableLicenseTypes[1] && ctx_r9.availableLicenseTypes[1].type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.availableLicenseTypes[2] && ctx_r9.availableLicenseTypes[2].type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.availableLicenseTypes.length > 3);
} }
const _c1$F = function (a0) { return { "disabledElement": a0 }; };
function ChangeBaseLicenseComponent_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelement(2, "img", 26);
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtext(4, "Warning");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 28);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 29);
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 30);
    i0.ɵɵtext(11, "Please make sure you have sufficient license available on your smart licensing account before you proceed.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵtext(13, "Visit ");
    i0.ɵɵelementStart(14, "a", 31);
    i0.ɵɵtext(15, "Cisco Smart License Manager");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(16, " for More details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 32);
    i0.ɵɵelementStart(18, "span", 33);
    i0.ɵɵelementStart(19, "input", 34);
    i0.ɵɵlistener("ngModelChange", function ChangeBaseLicenseComponent_div_6_div_2_Template_input_ngModelChange_19_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(2); return ctx_r40.acceptTandC = $event; })("change", function ChangeBaseLicenseComponent_div_6_div_2_Template_input_change_19_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(2); return ctx_r42.checkAcceptTandC($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(20, "label", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "span");
    i0.ɵɵelementStart(22, "span");
    i0.ɵɵtext(23, "I Accept the ");
    i0.ɵɵelementStart(24, "span", 36);
    i0.ɵɵlistener("click", function ChangeBaseLicenseComponent_div_6_div_2_Template_span_click_24_listener() { i0.ɵɵrestoreView(_r41); const ctx_r43 = i0.ɵɵnextContext(2); return ctx_r43.nextStep("tnc"); });
    i0.ɵɵtext(25, "terms and conditions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 37);
    i0.ɵɵelementStart(27, "div", 38);
    i0.ɵɵlistener("click", function ChangeBaseLicenseComponent_div_6_div_2_Template_div_click_27_listener() { i0.ɵɵrestoreView(_r41); const ctx_r44 = i0.ɵɵnextContext(2); return ctx_r44.changeBaseLicenseSL(ctx_r44.changeLicenseType); });
    i0.ɵɵtext(28, "Change Plan");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 39);
    i0.ɵɵlistener("click", function ChangeBaseLicenseComponent_div_6_div_2_Template_div_click_29_listener() { i0.ɵɵrestoreView(_r41); const ctx_r45 = i0.ɵɵnextContext(2); return ctx_r45.goToLicenseStep(); });
    i0.ɵɵtext(30, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate2("You are about to change your base plan from \"", ctx_r10.customerLicenseType == "EXT" ? "EXTEND" : ctx_r10.customerLicenseType, "\" to \"", ctx_r10.changeLicenseType, "\" on all your locations. ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("By changing the plan, all your existing locations will be changed to ", ctx_r10.changeLicenseType, " license and you will be charged for the new license count.");
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("href", ctx_r10.slLearnMoreLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r10.acceptTandC);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$F, ctx_r10.acceptTandC == false));
} }
function ChangeBaseLicenseComponent_div_6_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelement(2, "img", 40);
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtext(4, "Success");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 28);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 29);
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtext(9, "Please login again to view the changes.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 37);
    i0.ɵɵelementStart(11, "div", 41);
    i0.ɵɵlistener("click", function ChangeBaseLicenseComponent_div_6_div_3_Template_div_click_11_listener() { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(2); return ctx_r46.signOut(); });
    i0.ɵɵtext(12, "login");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("Your license level changed to ", ctx_r11.changeLicenseType, "");
} }
function ChangeBaseLicenseComponent_div_6_div_4_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtext(1, "\"");
    i0.ɵɵelementStart(2, "span", 45);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, "\u201D proximity rules associated with this location ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r48.ruleCount);
} }
function ChangeBaseLicenseComponent_div_6_div_4_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtext(1, "\"");
    i0.ɵɵelementStart(2, "span", 45);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, "\u201D portals linked with this location or it\u2019s child location. ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r49.portalCount);
} }
function ChangeBaseLicenseComponent_div_6_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelement(2, "img", 26);
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtext(4, "Cannot downgrade the license");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 28);
    i0.ɵɵtext(6, "The selected locations cannot be downgraded because of the following reason(s):");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 42);
    i0.ɵɵelementStart(8, "div", 43);
    i0.ɵɵtext(9, "There are:");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, ChangeBaseLicenseComponent_div_6_div_4_div_10_Template, 5, 1, "div", 44);
    i0.ɵɵtemplate(11, ChangeBaseLicenseComponent_div_6_div_4_div_11_Template, 5, 1, "div", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 29);
    i0.ɵɵtext(13, "Please remove the from to downgrade the license");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 37);
    i0.ɵɵelementStart(15, "div", 41);
    i0.ɵɵlistener("click", function ChangeBaseLicenseComponent_div_6_div_4_Template_div_click_15_listener() { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(2); return ctx_r50.goToLicenseStep(); });
    i0.ɵɵtext(16, "Okay");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 39);
    i0.ɵɵlistener("click", function ChangeBaseLicenseComponent_div_6_div_4_Template_div_click_17_listener() { i0.ɵɵrestoreView(_r51); const ctx_r52 = i0.ɵɵnextContext(2); return ctx_r52.goToLicenseStep(); });
    i0.ɵɵtext(18, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngIf", ctx_r12.ruleCount > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.portalCount > 0);
} }
function ChangeBaseLicenseComponent_div_6_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 46);
    i0.ɵɵelementStart(2, "div", 46);
    i0.ɵɵtext(3, "SMART LICENSING is a Cisco software license management system that allows you to easily track license status and software usage trends. This document describes how Smart Licensing works and includes the terms that govern your use. Please make sure you are authorized by your organization before accepting these terms or using Smart Licensing. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 47);
    i0.ɵɵtext(5, "What is Smart Licensing?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ul");
    i0.ɵɵelementStart(7, "li");
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtext(9, "Smart Licensing enables you to activate and manage Cisco software licenses. It also allows Cisco to send and receive periodic messages about license usage and entitlement of Cisco devices and software (\u201CSmart Licensing Messages\u201D). These Smart Licensing Messages will be displayed in Smart Software Manager, which is the web portal that shows your organization\u2019s license entitlement information. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "li");
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵtext(12, " If you choose not to enable Smart Licensing directly over the internet, you can select another method for collecting Smart Licensing Messages, like Smart Software Manager satellite. This must be hosted in your network environment that meets minimum requirements specified by Cisco. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "li");
    i0.ɵɵelementStart(14, "div");
    i0.ɵɵtext(15, " If the Smart Software Manager or the satellite stops receiving periodic updates for more than 90 days, Cisco assumes the device is no longer functioning properly and those unused licenses will automatically return to your license pool. If after 90 days the device is back in use, it will reacquire the license immediately upon sending its periodic update. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "li");
    i0.ɵɵelementStart(17, "div");
    i0.ɵɵtext(18, " Smart Call Home is an automated support capability within Smart Licensing that monitors Cisco devices on your network. It flags issues and initiates resolution before your business operations are affected. Smart Call Home is an optional capability that your organization can choose to enable that is included with Smart License enabled products. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 47);
    i0.ɵɵtext(20, "Information Collected by Cisco");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "ul");
    i0.ɵɵelementStart(22, "li");
    i0.ɵɵelementStart(23, "div");
    i0.ɵɵtext(24, "Smart Licensing collects software license usage information with associated product identification numbers, serial numbers, unique virtual device identifier, equipment models, license or hardware versions, and host names (host names are sent to aid in troubleshooting unless you disable them). ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "li");
    i0.ɵɵelementStart(26, "div");
    i0.ɵɵtext(27, "If you enable Smart Call Home, Cisco also may collect \u2013 for support and troubleshooting purposes - additional software version information, IP addresses, system contacts, installed memory, installed flash, boot versions, chassis series, MAC addresses, slot IDs, card types and card families. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ChangeBaseLicenseComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, ChangeBaseLicenseComponent_div_6_div_1_Template, 10, 4, "div", 10);
    i0.ɵɵtemplate(2, ChangeBaseLicenseComponent_div_6_div_2_Template, 31, 8, "div", 10);
    i0.ɵɵtemplate(3, ChangeBaseLicenseComponent_div_6_div_3_Template, 13, 1, "div", 10);
    i0.ɵɵtemplate(4, ChangeBaseLicenseComponent_div_6_div_4_Template, 19, 2, "div", 10);
    i0.ɵɵtemplate(5, ChangeBaseLicenseComponent_div_6_div_5_Template, 28, 0, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.step == "license");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.step == "warning");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.step == "success");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.step == "error" && ctx_r3.countValuesLoaded);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.step == "tnc");
} }
class ChangeBaseLicenseComponent {
    constructor(dataService, locationService, userService, translate, businessHierarchyService) {
        this.dataService = dataService;
        this.locationService = locationService;
        this.userService = userService;
        this.translate = translate;
        this.businessHierarchyService = businessHierarchyService;
        this.unsubscribe$ = new Subject();
        this.showChangeLicensePopup = false;
        this.acceptTandC = false;
        this.step = 'license';
        this.closePopup = new EventEmitter();
        this.apiGetCallStatus = '';
        this.retryCounter = 0;
        this.ruleCount = 0;
        this.portalCount = 0;
        this.countValuesLoaded = false;
        this.messageKeys = {};
        this.allowedLicenseTypes = [];
        this.locLicenseObjLoaded = false;
        this.getSmartLicenseDetail = () => {
            this.userService
                .getSmartLicenseDetail()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response && response.status && response.data) {
                    if (response.data.status) {
                        if (response.data.status == "completed") {
                            this.apiGetCallStatus = "completed";
                            this.smartLicenseObj = response.data.details;
                        }
                    }
                }
            }, (error) => {
                console.log("ERROR :: Split License change component getSmartLicenseDetail call ", error);
            });
        };
        this.getLocLicenseType = () => {
            const rootLocation = this.dataService.getRootLocation();
            console.log('rootLocation' + JSON.stringify(rootLocation));
            this.rootLocationId = rootLocation.id;
            this.smartLicenseObj = { 'consumedAps': 0, 'locationsCount': 0 };
            this.dataService.display(true);
            this.businessHierarchyService.getLocLicenseType(this.rootLocationId).subscribe((response) => {
                console.log(JSON.stringify(response));
                // Location License Object 
                let licenseObj = response.data;
                if (licenseObj) {
                    this.allowedLicenseTypes = licenseObj.allowedLicenseTypes ? licenseObj.allowedLicenseTypes : [];
                    this.seeObject = Object.assign({}, licenseObj.see);
                    this.seeObject["apCount"] = this.seeObject["apCount"] ? this.seeObject["apCount"] : 0;
                    this.seeObject["locCount"] = this.seeObject["locCount"] ? this.seeObject["locCount"] : 0;
                    this.seeObject["cameraCount"] = this.seeObject["cameraCount"] ? this.seeObject["cameraCount"] : 0;
                    this.seeObject["webexDeviceCount"] = this.seeObject["webexDeviceCount"] ? this.seeObject["webexDeviceCount"] : 0;
                    this.seeObject["buildingUnitsCount"] = this.seeObject["buildingUnitsCount"] ? this.seeObject["buildingUnitsCount"] : 0;
                    this.actObject = Object.assign({}, licenseObj.act);
                    this.actObject["apCount"] = this.actObject["apCount"] ? this.actObject["apCount"] : 0;
                    this.actObject["locCount"] = this.actObject["locCount"] ? this.actObject["locCount"] : 0;
                    this.actObject["cameraCount"] = this.actObject["cameraCount"] ? this.actObject["cameraCount"] : 0;
                    this.actObject["webexDeviceCount"] = this.actObject["webexDeviceCount"] ? this.actObject["webexDeviceCount"] : 0;
                    this.actObject["buildingUnitsCount"] = this.actObject["buildingUnitsCount"] ? this.actObject["buildingUnitsCount"] : 0;
                    this.extendObject = Object.assign({}, licenseObj.extend);
                    this.extendObject["apCount"] = this.extendObject["apCount"] ? this.extendObject["apCount"] : 0;
                    this.extendObject["locCount"] = this.extendObject["locCount"] ? this.extendObject["locCount"] : 0;
                    this.extendObject["cameraCount"] = this.extendObject["cameraCount"] ? this.extendObject["cameraCount"] : 0;
                    this.extendObject["webexDeviceCount"] = this.extendObject["webexDeviceCount"] ? this.extendObject["webexDeviceCount"] : 0;
                    this.extendObject["buildingUnitsCount"] = this.extendObject["buildingUnitsCount"] ? this.extendObject["buildingUnitsCount"] : 0;
                    this.smartvenueObj = Object.assign({}, licenseObj.smartVenue);
                    this.smartvenueObj["apCount"] = this.smartvenueObj["apCount"] ? this.smartvenueObj["apCount"] : 0;
                    this.smartvenueObj["locCount"] = this.smartvenueObj["locCount"] ? this.smartvenueObj["locCount"] : 0;
                    this.smartvenueObj["cameraCount"] = this.smartvenueObj["cameraCount"] ? this.smartvenueObj["cameraCount"] : 0;
                    this.smartvenueObj["webexDeviceCount"] = this.smartvenueObj["webexDeviceCount"] ? this.smartvenueObj["webexDeviceCount"] : 0;
                    this.smartvenueObj["buildingUnitsCount"] = this.smartvenueObj["buildingUnitsCount"] ? this.smartvenueObj["buildingUnitsCount"] : 0;
                    this.smartopsObj = Object.assign({}, licenseObj.smartOps);
                    this.smartopsObj["apCount"] = this.smartopsObj["apCount"] ? this.smartopsObj["apCount"] : 0;
                    this.smartopsObj["locCount"] = this.smartopsObj["locCount"] ? this.smartopsObj["locCount"] : 0;
                    this.smartopsObj["cameraCount"] = this.smartopsObj["cameraCount"] ? this.smartopsObj["cameraCount"] : 0;
                    this.smartopsObj["webexDeviceCount"] = this.smartopsObj["webexDeviceCount"] ? this.smartopsObj["webexDeviceCount"] : 0;
                    this.smartopsObj["buildingUnitsCount"] = this.smartopsObj["buildingUnitsCount"] ? this.smartopsObj["buildingUnitsCount"] : 0;
                    this.unlimitedObj = Object.assign({}, licenseObj.unlimited);
                    this.unlimitedObj["apCount"] = this.unlimitedObj["apCount"] ? this.unlimitedObj["apCount"] : 0;
                    this.unlimitedObj["locCount"] = this.unlimitedObj["locCount"] ? this.unlimitedObj["locCount"] : 0;
                    this.unlimitedObj["cameraCount"] = this.unlimitedObj["cameraCount"] ? this.unlimitedObj["cameraCount"] : 0;
                    this.unlimitedObj["webexDeviceCount"] = this.unlimitedObj["webexDeviceCount"] ? this.unlimitedObj["webexDeviceCount"] : 0;
                    this.unlimitedObj["buildingUnitsCount"] = this.unlimitedObj["buildingUnitsCount"] ? this.unlimitedObj["buildingUnitsCount"] : 0;
                    this.getAvailableLicenseTypes();
                    this.dataService.display(false);
                }
            }, (error) => {
                this.locLicenseObjLoaded = true;
                console.log(JSON.stringify(error));
                this.dataService.display(false);
            });
        };
        this.isEmptyObject = (obj) => {
            if (obj !== undefined && obj !== null) {
                const isEmptyObj = obj && Object.keys(obj).length === 0;
                // console.log("Empty Object Check::", obj, isEmptyObj);
                return isEmptyObj;
            }
            else {
                return true;
            }
        };
        this.getAvailableLicenseTypes = () => {
            if (this.licenseType) {
                let actObj = { 'type': 'ACT', 'class': 'act-tag', 'title': 'ACT', 'subtitle': '', 'desc': this.messageKeys["actObjDesc"], 'error': '', 'tooltip': '', 'disabled': true };
                let extendObj = { 'type': 'EXTEND', 'class': 'extend-tag', 'title': 'EXTEND', 'subtitle': '', 'desc': this.messageKeys["extendObjDesc"], 'error': '', 'tooltip': '', 'disabled': true };
                let unlimitedObj = { 'type': 'UNLIMITED', 'class': 'unlimited-tag', 'title': 'UNLIMITED', 'subtitle': 'This plan will convert your devices to SQFT metering', 'desc': this.messageKeys["unlimitedObjDesc"], 'error': '', 'tooltip': '', 'disabled': true };
                let smartVenueObj = { 'type': 'SMART_VENUES', 'class': 'smartvenue-tag', 'title': 'SMART_VENUES', 'subtitle': '', 'desc': this.messageKeys["smartVenueObjDesc"], 'error': '', 'tooltip': '', 'disabled': true };
                let smartOpsObj = { 'type': 'SMART_OPERATIONS', 'class': 'smartops-tag', 'title': 'SMART_OPERATIONS', 'subtitle': '', 'desc': this.messageKeys["smartOpsObjDesc"], 'error': '', 'tooltip': '', 'disabled': true };
                // disable logic 
                // ["see", "act", "extend", "extend-sw", "smartVenues", "smartOperations", "unlimited"]
                this.allowedLicenseTypes.forEach(licType => {
                    switch (licType) {
                        case "act": {
                            actObj.disabled = false;
                            break;
                        }
                        case "extend": {
                            extendObj.disabled = false;
                            break;
                        }
                        case "smartVenues": {
                            smartVenueObj.disabled = false;
                            break;
                        }
                        case "smartOperations": {
                            smartOpsObj.disabled = false;
                            break;
                        }
                        case "unlimited": {
                            unlimitedObj.disabled = false;
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                });
                console.log('location license type :: ', this.licenseType);
                let licenseType = this.licenseType == 'EXT' ? 'EXTEND' : this.licenseType;
                switch (licenseType) {
                    case "ACT": {
                        this.availableLicenseTypes = [
                            extendObj, unlimitedObj, smartVenueObj, smartOpsObj
                        ];
                        break;
                    }
                    case "EXTEND": {
                        this.availableLicenseTypes = [
                            actObj, unlimitedObj, smartVenueObj, smartOpsObj
                        ];
                        break;
                    }
                    case "SMART_VENUES": {
                        this.availableLicenseTypes = [
                            actObj, extendObj, unlimitedObj, smartOpsObj
                        ];
                        break;
                    }
                    case "SMART_OPERATIONS": {
                        this.availableLicenseTypes = [
                            actObj, extendObj, unlimitedObj, smartVenueObj
                        ];
                        break;
                    }
                    case "UNLIMITED": {
                        this.availableLicenseTypes = [
                            actObj, extendObj, smartVenueObj, smartOpsObj
                        ];
                        break;
                    }
                    default: {
                        this.availableLicenseTypes = [actObj, extendObj, unlimitedObj, smartVenueObj, smartOpsObj];
                        break;
                    }
                }
                this.locLicenseObjLoaded = true;
            }
        };
        this.toggleChangeLicensePopup = (show) => {
            if (this.step == 'tnc') {
                this.step = 'warning';
            }
            else {
                if (show == false) {
                    this.closePopup.emit();
                }
            }
        };
        this.validateStep = (step) => {
            let validateStatus = 'warning';
            if (step == 'license') {
                this.nextStep(validateStatus);
            }
        };
        this.nextStep = (step) => {
            this.step = step;
            if (step == 'success' && this.changeLicenseType == 'EXT') {
                this.changeLicenseType = 'Extend';
            }
        };
        this.goToLicenseStep = () => {
            this.step = 'license';
            this.acceptTandC = false;
        };
        this.checkAcceptTandC = (event) => {
            console.log(" :: acceptTandC " + this.acceptTandC + " :: event " + event);
        };
        this.changeBaseLicenseCheck = (licType, type) => {
            this.changeLicenseOption = type;
            if (type == 'upgrade' || type == 'downgrade') {
                this.step = 'warning';
                this.changeLicenseType = licType.type;
            }
        };
        this.changeBaseLicenseSL = (licType) => {
            if (this.acceptTandC) {
                this.dataService.display(true);
                this.countValuesLoaded = false;
                let licenseObj = {
                    "licenseType": licType
                };
                this.userService.changeBaseLicenseSL(licenseObj).pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                    if (response && response.status) {
                        if (response.data && response.data.licenseChangeError) {
                            let responseData = response.data;
                            this.step = 'error';
                            this.ruleCount = responseData.captivePortalRulesCount + responseData.engagementCount + responseData.profileCount;
                            this.portalCount = responseData.captivePortalCount;
                            this.countValuesLoaded = true;
                        }
                        else {
                            // this.dataService.setToastMessage(response.message, 4000, null, null, 'success');
                            // this.toggleChangeLicensePopup(false);
                            this.nextStep('success');
                        }
                    }
                    else {
                        this.dataService.setToastMessage(this.messageKeys[response.message], 4000, null, null, 'error');
                    }
                    this.dataService.display(false);
                }, error => {
                    this.dataService.display(false);
                    console.log("ERROR: changeBaseLicense post call ::: ", error);
                });
            }
            else {
                this.dataService.setToastMessage('Please accept the terms and conditions', 4000, null, null, 'error');
            }
        };
        this.signOut = () => {
            this.dataService.display(true);
            this.locationService.signOut();
        };
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.user-api-management.smart-license.change-invalid').subscribe((res) => {
                this.messageKeys["user.licensetype.change.error.invalidtype"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.change-failed').subscribe((res) => {
                this.messageKeys["user.licensetype.change.error.failed"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.change-success').subscribe((res) => {
                this.messageKeys["user.licensetype.change.success"] = res;
            });
            this.translate.get('shared-lib.split-license.actObj.desc').subscribe((res) => {
                this.messageKeys["actObjDesc"] = res;
            });
            this.translate.get('shared-lib.split-license.extendObj.desc').subscribe((res) => {
                this.messageKeys["extendObjDesc"] = res;
            });
            this.translate.get('shared-lib.split-license.unlimitedObj.desc').subscribe((res) => {
                this.messageKeys["unlimitedObjDesc"] = res;
            });
            this.translate.get('shared-lib.split-license.smartVenueObj.desc').subscribe((res) => {
                this.messageKeys["smartVenueObjDesc"] = res;
            });
            this.translate.get('shared-lib.split-license.smartOpsObj.desc').subscribe((res) => {
                this.messageKeys["smartOpsObjDesc"] = res;
            });
        };
    }
    ngOnInit() {
        this.dataService.display(false);
        let slLinkUrl = this.dataService.getSmartLicenseLearnMore();
        this.slLearnMoreLink = slLinkUrl ? slLinkUrl : 'https://www.cisco.com/c/en_in/products/software/smart-accounts/software-licensing.html';
        this.step = 'license';
        this.customerLicenseType = this.licenseType;
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
        this.getSmartLicenseDetail();
        this.getLocLicenseType();
    }
    ngOnDestroy() {
        console.log('destory Change Base License component');
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
ChangeBaseLicenseComponent.ɵfac = function ChangeBaseLicenseComponent_Factory(t) { return new (t || ChangeBaseLicenseComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(UserService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(BusinessHierarchyService)); };
ChangeBaseLicenseComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChangeBaseLicenseComponent, selectors: [["app-change-base-license"]], inputs: { smartLicenseObj: "smartLicenseObj", licenseType: "licenseType" }, outputs: { closePopup: "closePopup" }, decls: 7, vars: 3, consts: [[1, "modalPopup"], [1, "modalOverlay"], [1, "wireless-network-modalContent"], ["class", "modalHeader", 4, "ngIf", "ngIfElse"], ["defaultHeader", ""], ["class", "modalBody", 4, "ngIf"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], ["class", "modalCloseIcon", 3, "click", 4, "ngIf"], [1, "modalBody"], [4, "ngIf"], [1, "license-types-wrapper"], [1, "choose-license-text"], [1, "divTable"], [1, "divTableRow"], ["class", "divTableCell width-33", 3, "ngClass", 4, "ngIf"], ["class", "divTableRow", 4, "ngIf"], [1, "divTableCell", "width-33", 3, "ngClass"], [1, "license-wrapper-border"], [1, "license-header"], [1, "divTableCell"], [1, "license-label", 3, "click"], ["class", "license-subtitle", 4, "ngIf"], [1, "license-desc"], [1, "license-subtitle"], [1, "alertPopupMargin"], ["src", "/assets/images/warning.svg", "width", "60"], [1, "warningLabel"], [1, "alertHeader"], [1, "alertDesc"], [1, "marginTB10"], ["target", "_blank", 1, "link", 3, "href"], [1, "tncMargin"], [1, "marginR10"], ["type", "checkbox", "id", "acceptTandCValue", "name", "acceptTandCValue", 3, "ngModel", "ngModelChange", "change"], ["for", "acceptTandCValue", 1, "checkboxLabel"], [1, "link", 3, "click"], [1, ""], [1, "marginTB10", "primaryButton", 3, "ngClass", "click"], [1, "modalSecondaryButton", 3, "click"], ["src", "/assets/images/dna-spaces/successfull.svg", "width", "60"], [1, "marginTB10", "primaryButton", 3, "click"], [1, "listingWrapper"], [1, "listingTwo"], ["class", "listingTwo", 4, "ngIf"], [2, "color", "#000", "font-weight", "bolder"], [1, "paddingTB20"], [1, "textBold"]], template: function ChangeBaseLicenseComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, ChangeBaseLicenseComponent_div_3_Template, 5, 0, "div", 3);
        i0.ɵɵtemplate(4, ChangeBaseLicenseComponent_ng_template_4_Template, 4, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, ChangeBaseLicenseComponent_div_6_Template, 6, 5, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(5);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.step == "tnc")("ngIfElse", _r1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.locLicenseObjLoaded && ctx.availableLicenseTypes && ctx.availableLicenseTypes.length > 0);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i2$1.CheckboxControlValueAccessor, i2$1.NgControlStatus, i2$1.NgModel], styles: [".wireless-network-modalContent[_ngcontent-%COMP%]{top:40px;bottom:40px;left:40px;right:40px;z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden}.wireless-network-modalContent[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{font-family:\"ciscoSansThin\";font-weight:bolder}.wireless-network-modalContent[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{background-color:#fff;width:100%;height:90%;overflow-y:scroll;margin-bottom:40px}.wireless-network-modalContent[_ngcontent-%COMP%]   .width-33[_ngcontent-%COMP%]{width:33%;vertical-align:top}.wireless-network-modalContent[_ngcontent-%COMP%]   .license-wrapper-border[_ngcontent-%COMP%]{padding:20px;margin:20px 20px 20px 0;border:1px solid #DFDFDF}.wireless-network-modalContent[_ngcontent-%COMP%]   .liecense-img[_ngcontent-%COMP%]{width:80px}.wireless-network-modalContent[_ngcontent-%COMP%]   .cisco-dna-spaces-label[_ngcontent-%COMP%]{font-size:17px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .see-label[_ngcontent-%COMP%]{color:#009edc;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .extend-label[_ngcontent-%COMP%]{color:#7cc242;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .act-label[_ngcontent-%COMP%]{color:#f8ab19;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .scroll-div[_ngcontent-%COMP%]{height:50vh;overflow-y:auto}.wireless-network-modalContent[_ngcontent-%COMP%]   .include-text[_ngcontent-%COMP%]{font-size:14px;font-family:CiscoSansLight;font-weight:bold}.wireless-network-modalContent[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:.5em 0 0 15px}.wireless-network-modalContent[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style-type:none;padding-bottom:10px}.wireless-network-modalContent[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:before{content:\"\";float:left;display:list-item;list-style-type:disc;list-style-position:inside;width:20px;margin-left:-15px}.wireless-network-modalContent[_ngcontent-%COMP%]   .paddingTB20[_ngcontent-%COMP%]{padding:20px 0}.wireless-network-modalContent[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{display:block}.wireless-network-modalContent[_ngcontent-%COMP%]   .alertPopupMargin[_ngcontent-%COMP%]{margin:100px 25%;text-align:center}.wireless-network-modalContent[_ngcontent-%COMP%]   .warningLabel[_ngcontent-%COMP%]{padding:10px;font-size:20px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .alertHeader[_ngcontent-%COMP%]{padding:10px;font-size:18px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .alertDesc[_ngcontent-%COMP%]{padding:10px}.wireless-network-modalContent[_ngcontent-%COMP%]   .listingWrapper[_ngcontent-%COMP%]{border:1px solid rgba(171,172,172,.5);padding:25px 20px;text-align:left;display:block;margin:0 auto;width:-moz-fit-content;width:fit-content}.wireless-network-modalContent[_ngcontent-%COMP%]   .listingTwo[_ngcontent-%COMP%]{font-size:14px;line-height:20px;font-family:ciscoSansLight;color:#6a6b6c}.wireless-network-modalContent[_ngcontent-%COMP%]   .downgrade[_ngcontent-%COMP%]{color:#ff0c0c}.wireless-network-modalContent[_ngcontent-%COMP%]   .downgrade[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{border-color:#ff0c0c;color:#ff0c0c}.wireless-network-modalContent[_ngcontent-%COMP%]   .currentplan[_ngcontent-%COMP%]{color:#7cc242;text-align:center}.wireless-network-modalContent[_ngcontent-%COMP%]   .currentplan-span[_ngcontent-%COMP%]{padding-left:10px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:40%}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:30%}.columnData[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.changeLicenseDesc[_ngcontent-%COMP%]{font-size:12px;padding-top:5px}.link[_ngcontent-%COMP%]{color:#049fd9;font-weight:bold}.marginTop40[_ngcontent-%COMP%]{margin-top:40px}.tncMargin[_ngcontent-%COMP%]{margin-top:10px;margin-bottom:20px}.marginR10[_ngcontent-%COMP%]{margin-right:10px}.wireless-network-modalContent[_ngcontent-%COMP%]{top:40px;bottom:40px;left:40px;right:40px;z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden}.wireless-network-modalContent[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{font-family:\"ciscoSansThin\";font-weight:bolder}.wireless-network-modalContent[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{background-color:#fff;width:100%;height:90%;overflow-y:scroll;margin-bottom:40px}.wireless-network-modalContent[_ngcontent-%COMP%]   .width-33[_ngcontent-%COMP%]{width:33%;vertical-align:top}.wireless-network-modalContent[_ngcontent-%COMP%]   .license-wrapper-border[_ngcontent-%COMP%]{padding:20px;margin:20px 20px 20px 0;background:#FFFFFF;border:2px solid #F1F1F1;border-radius:6px;height:180px}.wireless-network-modalContent[_ngcontent-%COMP%]   .choose-license-text[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:1px;text-transform:uppercase;color:#121212}.wireless-network-modalContent[_ngcontent-%COMP%]   .liecense-img[_ngcontent-%COMP%]{width:80px}.wireless-network-modalContent[_ngcontent-%COMP%]   .cisco-dna-spaces-label[_ngcontent-%COMP%]{font-size:17px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .see-label[_ngcontent-%COMP%]{color:#009edc;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .extend-label[_ngcontent-%COMP%]{color:#7cc242;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .act-label[_ngcontent-%COMP%]{color:#f8ab19;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .smartvenue-label[_ngcontent-%COMP%]{color:#436fb6;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .smartops-label[_ngcontent-%COMP%]{color:#8750a1;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .unlimited-label[_ngcontent-%COMP%]{color:#ff7c33;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .scroll-div[_ngcontent-%COMP%]{height:50vh;overflow-y:auto}.wireless-network-modalContent[_ngcontent-%COMP%]   .include-text[_ngcontent-%COMP%]{font-size:14px;font-family:CiscoSansLight;font-weight:bold}.wireless-network-modalContent[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:.5em 0 0 15px}.wireless-network-modalContent[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style-type:none;padding-bottom:10px}.wireless-network-modalContent[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:before{content:\"\";float:left;display:list-item;list-style-type:disc;list-style-position:inside;width:20px;margin-left:-15px}.wireless-network-modalContent[_ngcontent-%COMP%]   .paddingTB20[_ngcontent-%COMP%]{padding:20px 0}.wireless-network-modalContent[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{display:block}.wireless-network-modalContent[_ngcontent-%COMP%]   .alertPopupMargin[_ngcontent-%COMP%]{margin:100px 25%;text-align:center}.wireless-network-modalContent[_ngcontent-%COMP%]   .warningLabel[_ngcontent-%COMP%]{padding:10px;font-size:20px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .alertHeader[_ngcontent-%COMP%]{padding:10px;font-size:18px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .alertDesc[_ngcontent-%COMP%]{padding:10px}.wireless-network-modalContent[_ngcontent-%COMP%]   .listingWrapper[_ngcontent-%COMP%]{border:1px solid rgba(171,172,172,.5);padding:25px 20px;text-align:left;display:block;margin:0 auto;width:-moz-fit-content;width:fit-content}.wireless-network-modalContent[_ngcontent-%COMP%]   .listingTwo[_ngcontent-%COMP%]{font-size:14px;line-height:20px;font-family:ciscoSansLight;color:#6a6b6c}.wireless-network-modalContent[_ngcontent-%COMP%]   .downgrade[_ngcontent-%COMP%]{color:#ff0c0c}.wireless-network-modalContent[_ngcontent-%COMP%]   .downgrade[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{border-color:#ff0c0c;color:#ff0c0c}.wireless-network-modalContent[_ngcontent-%COMP%]   .currentplan[_ngcontent-%COMP%]{color:#7cc242;text-align:center}.wireless-network-modalContent[_ngcontent-%COMP%]   .currentplan-span[_ngcontent-%COMP%]{padding-left:10px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:40%}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:30%}.columnData[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.changeLicenseDesc[_ngcontent-%COMP%]{font-size:12px;padding-top:5px}.link[_ngcontent-%COMP%]{color:#049fd9;font-weight:bold}.marginTop40[_ngcontent-%COMP%]{margin-top:40px}.tncMargin[_ngcontent-%COMP%]{margin-top:10px;margin-bottom:20px}.marginR10[_ngcontent-%COMP%]{margin-right:10px}.confirmationStep[_ngcontent-%COMP%]   table[_ngcontent-%COMP%], .confirmationStep[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .confirmationStep[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border:1px solid black;border-collapse:collapse;padding:10px;box-shadow:0 2px 5px #0000000d}.confirmationStep[_ngcontent-%COMP%]   .padding16[_ngcontent-%COMP%]{padding:16px}.confirmationStep[_ngcontent-%COMP%]   .bold-text[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:13px;line-height:18px;letter-spacing:.0417px;color:#1d3243}.confirmationStep[_ngcontent-%COMP%]   .red-label[_ngcontent-%COMP%]{color:red}.confirmationStep[_ngcontent-%COMP%]   .green-label[_ngcontent-%COMP%]{color:green}.capitalizeLabel[_ngcontent-%COMP%]{text-transform:capitalize}.loc-split[_ngcontent-%COMP%]{display:table;width:100%;padding:30px}.loc-split[_ngcontent-%COMP%]   .left-split[_ngcontent-%COMP%]{width:75%;display:table-cell;vertical-align:middle}.loc-split[_ngcontent-%COMP%]   .right-split[_ngcontent-%COMP%]{width:25%;display:table-cell;vertical-align:middle}.bh-loc-counts[_ngcontent-%COMP%]{margin:4px 0}.bh-loc-counts[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:inline-block}.bh-loc-counts[_ngcontent-%COMP%]   .bh-count-pattern[_ngcontent-%COMP%]{padding-right:50px;display:inline-block;vertical-align:middle}.bh-loc-counts[_ngcontent-%COMP%]   .bh-count-pattern[_ngcontent-%COMP%]   .count-name[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:24px;line-height:34px;letter-spacing:.5px;color:#121212}.bh-loc-counts[_ngcontent-%COMP%]   .bh-count-pattern[_ngcontent-%COMP%]   .count-label[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;line-height:22px;letter-spacing:.5px;color:#00bceb;opacity:.8}.bh-loc-counts[_ngcontent-%COMP%]   .bh-count-pattern.alert-count[_ngcontent-%COMP%]{cursor:pointer;vertical-align:middle}.bh-loc-counts[_ngcontent-%COMP%]   .bh-count-pattern.alert-count[_ngcontent-%COMP%]   .count-name[_ngcontent-%COMP%]{color:#f5a623}.bh-count-pattern[_ngcontent-%COMP%]{padding-right:50px;display:inline-block;vertical-align:middle}.bh-count-pattern[_ngcontent-%COMP%]   .count-name[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:24px;line-height:34px;letter-spacing:.5px;color:#121212}.bh-count-pattern[_ngcontent-%COMP%]   .count-label[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;line-height:22px;letter-spacing:.5px;color:#00bceb;opacity:.8}.bh-count-pattern.alert-count[_ngcontent-%COMP%]{cursor:pointer;vertical-align:middle}.bh-count-pattern.alert-count[_ngcontent-%COMP%]   .count-name[_ngcontent-%COMP%]{color:#f5a623}.count-loader-container[_ngcontent-%COMP%]{display:inline-block;width:320px;min-height:100px;vertical-align:middle}.placeholder-content[_ngcontent-%COMP%]{height:100px;overflow:hidden;background:#f6f7f8;position:relative;animation-duration:1.7s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-timing-function:linear;animation-name:placeholderAnimate;background:linear-gradient(to right,#eee 2%,#ddd 18%,#eee 33%);background-size:1000px}.placeholder-content_item[_ngcontent-%COMP%]{width:100%;height:20px;position:absolute;background:#fff;z-index:2}.placeholder-content_item[_ngcontent-%COMP%]:after, .placeholder-content_item[_ngcontent-%COMP%]:before{width:inherit;height:inherit;content:\"\";position:absolute}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(1){top:0;left:0}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(2){top:20px;left:0;width:0;height:90px}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(3){top:0;left:0;width:0;height:100%}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(4){top:0;width:15px;left:75px;height:102px}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(5){top:51px;left:80px;height:0}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(6){top:60px;left:90px;height:5px}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(7){top:20px;right:0;width:0;height:20px}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(8){top:0;right:0;width:10%;height:100%}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(9){top:85px;height:100px;left:0}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(10){top:149px;height:60px;left:0}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(11){top:183px;left:0;height:100%}@keyframes placeholderAnimate{0%{background-position:-650px 0}to{background-position:650px 0}}.confirmation-title[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:30px;line-height:41px;text-align:center;color:#39393b}.confirmation-desc[_ngcontent-%COMP%]{font-family:\"CiscoSansTT\";font-style:normal;font-weight:350;font-size:16px;line-height:24px;text-align:center;letter-spacing:.25px;color:#000;padding:10px 0 20px}.license-tag[_ngcontent-%COMP%]{display:inline-block;padding:5px 10px;margin-bottom:10px;border-radius:50px}.see-tag[_ngcontent-%COMP%]{background-color:#009edc}.act-tag[_ngcontent-%COMP%]{background-color:#f8ab19}.extend-tag[_ngcontent-%COMP%], .ext-tag[_ngcontent-%COMP%]{background-color:#7cc242}.smartvenue-tag[_ngcontent-%COMP%], .smart_venues-tag[_ngcontent-%COMP%]{background-color:#436fb6}.smartops-tag[_ngcontent-%COMP%], .smart_operations-tag[_ngcontent-%COMP%]{background-color:#8750a1}.unlimited-tag[_ngcontent-%COMP%]{background-color:#ff7c33}.unlimited-subtitle[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:10px;line-height:16px;letter-spacing:.5px;color:#121212;padding-bottom:15px}.license-label[_ngcontent-%COMP%]{font-family:\"ciscoSansLight\";font-style:normal;font-weight:400;font-size:16px;text-align:center;color:#fff;cursor:pointer}.license-desc[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:12px;line-height:18px;letter-spacing:.5px;color:#565659}.license-subtitle[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:10px;line-height:16px;letter-spacing:.5px;color:#121212;margin-bottom:10px}.disabledLicense[_ngcontent-%COMP%]{opacity:.5;cursor:not-allowed;pointer-events:none}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:50%;margin:10px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:15%}.license-types-wrapper[_ngcontent-%COMP%]{padding:20px 30px;background-color:#f6f6f6}.license-types-wrapper[_ngcontent-%COMP%]   .license-tag[_ngcontent-%COMP%]{display:inline-block;padding:5px 10px;margin-bottom:10px;border-radius:50px}.license-types-wrapper[_ngcontent-%COMP%]   .see-tag[_ngcontent-%COMP%]{background-color:#009edc}.license-types-wrapper[_ngcontent-%COMP%]   .act-tag[_ngcontent-%COMP%]{background-color:#f8ab19}.license-types-wrapper[_ngcontent-%COMP%]   .extend-tag[_ngcontent-%COMP%], .license-types-wrapper[_ngcontent-%COMP%]   .ext-tag[_ngcontent-%COMP%]{background-color:#7cc242}.license-types-wrapper[_ngcontent-%COMP%]   .smartvenue-tag[_ngcontent-%COMP%], .license-types-wrapper[_ngcontent-%COMP%]   .smart_venues-tag[_ngcontent-%COMP%]{background-color:#436fb6}.license-types-wrapper[_ngcontent-%COMP%]   .smartops-tag[_ngcontent-%COMP%], .license-types-wrapper[_ngcontent-%COMP%]   .smart_operations-tag[_ngcontent-%COMP%]{background-color:#8750a1}.license-types-wrapper[_ngcontent-%COMP%]   .unlimited-tag[_ngcontent-%COMP%]{background-color:#ff7c33}.license-types-wrapper[_ngcontent-%COMP%]   .unlimited-subtitle[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:10px;line-height:16px;letter-spacing:.5px;color:#121212;padding-bottom:15px}.license-types-wrapper[_ngcontent-%COMP%]   .license-label[_ngcontent-%COMP%]{font-family:\"ciscoSansLight\";font-style:normal;font-weight:400;font-size:16px;text-align:center;color:#fff;cursor:pointer}.license-types-wrapper[_ngcontent-%COMP%]   .license-desc[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:12px;line-height:18px;letter-spacing:.5px;color:#565659}.license-types-wrapper[_ngcontent-%COMP%]   .license-subtitle[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:10px;line-height:16px;letter-spacing:.5px;color:#121212;margin-bottom:10px}.license-types-wrapper[_ngcontent-%COMP%]   .disabledLicense[_ngcontent-%COMP%]{opacity:.5;cursor:not-allowed;pointer-events:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChangeBaseLicenseComponent, [{
        type: Component,
        args: [{
                selector: 'app-change-base-license',
                templateUrl: './change-base-license.component.html',
                styleUrls: ['./change-base-license.component.scss']
            }]
    }], function () { return [{ type: DataService }, { type: LocationService }, { type: UserService }, { type: i2.TranslateService }, { type: BusinessHierarchyService }]; }, { smartLicenseObj: [{
            type: Input
        }], licenseType: [{
            type: Input
        }], closePopup: [{
            type: Output
        }] }); })();

function SmartLicenseBaseComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "app-smart-license-popup", 2);
    i0.ɵɵlistener("hideActivationPopup", function SmartLicenseBaseComponent_div_0_Template_app_smart_license_popup_hideActivationPopup_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.hideActivationPopup($event); })("registerSmartLicenseToken", function SmartLicenseBaseComponent_div_0_Template_app_smart_license_popup_registerSmartLicenseToken_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.registerSmartLicense($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fromPage", "welcome");
} }
function SmartLicenseBaseComponent_div_1_div_1_div_1_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1, "ACT");
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_1_div_1_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1, "SEE");
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_1_div_1_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1, "EXTEND");
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_1_div_1_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1, "SMART_VENUES");
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_1_div_1_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1, "SMART_OPERATIONS");
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_1_div_1_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1, "UNLIMITED");
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_1_div_1_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "app-split-license-usage", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("locationId", ctx_r17.rootLocationId)("locationName", ctx_r17.rootLocationName)("fromSLPage", ctx_r17.fromSLPage)("isRegisteredSL", ctx_r17.smartLicenseObj["isRegistered"]);
} }
function SmartLicenseBaseComponent_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelementStart(3, "span", 17);
    i0.ɵɵtext(4, "BASE LICENSE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelementStart(6, "span", 18);
    i0.ɵɵtext(7, "Cisco Spaces");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 19);
    i0.ɵɵtemplate(9, SmartLicenseBaseComponent_div_1_div_1_div_1_span_9_Template, 2, 0, "span", 20);
    i0.ɵɵtemplate(10, SmartLicenseBaseComponent_div_1_div_1_div_1_span_10_Template, 2, 0, "span", 20);
    i0.ɵɵtemplate(11, SmartLicenseBaseComponent_div_1_div_1_div_1_span_11_Template, 2, 0, "span", 20);
    i0.ɵɵtemplate(12, SmartLicenseBaseComponent_div_1_div_1_div_1_span_12_Template, 2, 0, "span", 20);
    i0.ɵɵtemplate(13, SmartLicenseBaseComponent_div_1_div_1_div_1_span_13_Template, 2, 0, "span", 20);
    i0.ɵɵtemplate(14, SmartLicenseBaseComponent_div_1_div_1_div_1_span_14_Template, 2, 0, "span", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, SmartLicenseBaseComponent_div_1_div_1_div_1_div_15_Template, 2, 4, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(8);
    i0.ɵɵclassMap(ctx_r10.getLocationNonSLClass(ctx_r10.licenseInfoData.licenseType));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.licenseInfoData.licenseType && ctx_r10.licenseInfoData.licenseType == "Advanced Subscription");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.licenseInfoData.licenseType && ctx_r10.licenseInfoData.licenseType == "Base Subscription");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.licenseInfoData.licenseType && ctx_r10.licenseInfoData.licenseType == "Extend");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.licenseInfoData.licenseType && ctx_r10.licenseInfoData.licenseType == "SMART_VENUES");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.licenseInfoData.licenseType && ctx_r10.licenseInfoData.licenseType == "SMART_OPERATIONS");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.licenseInfoData.licenseType && (ctx_r10.licenseInfoData.licenseType == "UNLIMITED" || ctx_r10.licenseInfoData.licenseType == "Unlimited" || ctx_r10.licenseInfoData.licenseType == "Unlimited Subscription"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.rootLocationLoaded);
} }
const _c0$1C = function (a0) { return { "disabledElement": a0 }; };
function SmartLicenseBaseComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, SmartLicenseBaseComponent_div_1_div_1_div_1_Template, 16, 9, "div", 0);
    i0.ɵɵelementStart(2, "h4", 6);
    i0.ɵɵtext(3, "Smart Software License");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 7);
    i0.ɵɵelement(5, "img", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 9);
    i0.ɵɵelementStart(7, "div", 10);
    i0.ɵɵtext(8, "Cisco Spaces Supports Smart Licensing");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 11);
    i0.ɵɵtext(10, "The flexible licensing model that streamlines how you activate and manage software. The solution allows you to easily track the status of your license and software usage trends");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 12);
    i0.ɵɵelementStart(12, "div", 13);
    i0.ɵɵelementStart(13, "a", 14);
    i0.ɵɵtext(14, "Learn More");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 15);
    i0.ɵɵlistener("click", function SmartLicenseBaseComponent_div_1_div_1_Template_div_click_15_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.toggleSmartAccountWizard(); });
    i0.ɵɵtext(16, " Link your Smart Account");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.licenseInfoData);
    i0.ɵɵadvance(12);
    i0.ɵɵpropertyInterpolate("href", ctx_r7.slLearnMoreLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$1C, ctx_r7.userRole != "RW"));
} }
function SmartLicenseBaseComponent_div_1_div_2_div_12_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "textarea", 36);
    i0.ɵɵlistener("ngModelChange", function SmartLicenseBaseComponent_div_1_div_2_div_12_div_1_Template_textarea_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(4); return ctx_r24.smartLicenseToken = $event; })("change", function SmartLicenseBaseComponent_div_1_div_2_div_12_div_1_Template_textarea_change_1_listener() { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(4); return ctx_r26.onChangeToken(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r22.smartLicenseToken);
} }
function SmartLicenseBaseComponent_div_1_div_2_div_12_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelementStart(1, "div", 38);
    i0.ɵɵelement(2, "img", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 40);
    i0.ɵɵtext(4, "Token Error");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 41);
    i0.ɵɵtext(6, "The Product License Token you have entered is invalid or expired. Please ensure you have pasted the entire token and its valid.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 42);
    i0.ɵɵlistener("click", function SmartLicenseBaseComponent_div_1_div_2_div_12_div_2_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(4); return ctx_r27.tryAgainToken(); });
    i0.ɵɵtext(8, "Try Again");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$1C, ctx_r23.userRole != "RW"));
} }
function SmartLicenseBaseComponent_div_1_div_2_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SmartLicenseBaseComponent_div_1_div_2_div_12_div_1_Template, 2, 1, "div", 0);
    i0.ɵɵtemplate(2, SmartLicenseBaseComponent_div_1_div_2_div_12_div_2_Template, 9, 3, "div", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r20.isTokenError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.isTokenError);
} }
function SmartLicenseBaseComponent_div_1_div_2_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelementStart(1, "div", 44);
    i0.ɵɵelement(2, "div", 45);
    i0.ɵɵelement(3, "div", 45);
    i0.ɵɵelement(4, "div", 45);
    i0.ɵɵelement(5, "div", 45);
    i0.ɵɵelement(6, "div", 45);
    i0.ɵɵelement(7, "div", 45);
    i0.ɵɵelement(8, "div", 45);
    i0.ɵɵelement(9, "div", 45);
    i0.ɵɵelement(10, "div", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵelementStart(2, "div", 27);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "Register for Smart Licensing");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 28);
    i0.ɵɵlistener("click", function SmartLicenseBaseComponent_div_1_div_2_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(2); return ctx_r29.toggleRegPopup(false); });
    i0.ɵɵtext(6, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 29);
    i0.ɵɵtext(8, "Copy the product instance registration token from CSSM tool and paste it below ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 30);
    i0.ɵɵelementStart(10, "div", 31);
    i0.ɵɵtext(11, "PRODUCT INSTANCE TOKEN");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, SmartLicenseBaseComponent_div_1_div_2_div_12_Template, 3, 2, "div", 0);
    i0.ɵɵtemplate(13, SmartLicenseBaseComponent_div_1_div_2_div_13_Template, 11, 0, "div", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 32);
    i0.ɵɵelementStart(15, "div", 33);
    i0.ɵɵelementStart(16, "div", 34);
    i0.ɵɵlistener("click", function SmartLicenseBaseComponent_div_1_div_2_Template_div_click_16_listener() { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(2); return ctx_r31.toggleRegPopup(false); });
    i0.ɵɵtext(17, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("ngIf", ctx_r8.apiRegisterCallStatus != "progress");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.apiRegisterCallStatus == "progress");
} }
function SmartLicenseBaseComponent_div_1_div_3_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "app-split-license-usage", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("locationId", ctx_r32.rootLocationId)("locationName", ctx_r32.rootLocationName)("fromSLPage", ctx_r32.fromSLPage)("isRegisteredSL", ctx_r32.smartLicenseObj["isRegistered"]);
} }
function SmartLicenseBaseComponent_div_1_div_3_span_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 87);
    i0.ɵɵelement(1, "img", 88);
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_3_span_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 87);
    i0.ɵɵelement(1, "img", 89);
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_3_div_32_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 90);
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵelementStart(2, "li", 91);
    i0.ɵɵlistener("click", function SmartLicenseBaseComponent_div_1_div_3_div_32_Template_li_click_2_listener() { i0.ɵɵrestoreView(_r48); const ctx_r47 = i0.ɵɵnextContext(3); return ctx_r47.renewAuthSmartLicense(); });
    i0.ɵɵtext(3, "Renew Authorization");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "li", 91);
    i0.ɵɵlistener("click", function SmartLicenseBaseComponent_div_1_div_3_div_32_Template_li_click_4_listener() { i0.ɵɵrestoreView(_r48); const ctx_r49 = i0.ɵɵnextContext(3); return ctx_r49.renewRegistrationSmartLicense(); });
    i0.ɵɵtext(5, "Renew Smart License");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "li", 91);
    i0.ɵɵlistener("click", function SmartLicenseBaseComponent_div_1_div_3_div_32_Template_li_click_6_listener() { i0.ɵɵrestoreView(_r48); const ctx_r50 = i0.ɵɵnextContext(3); return ctx_r50.toggleRegPopup(true); });
    i0.ɵɵtext(7, "Re-register");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "li", 91);
    i0.ɵɵlistener("click", function SmartLicenseBaseComponent_div_1_div_3_div_32_Template_li_click_8_listener() { i0.ɵɵrestoreView(_r48); const ctx_r51 = i0.ɵɵnextContext(3); return ctx_r51.deRegisterSmartLicense(); });
    i0.ɵɵtext(9, "Deregister");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_3_img_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 92);
} }
function SmartLicenseBaseComponent_div_1_div_3_ng_template_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 63);
} }
function SmartLicenseBaseComponent_div_1_div_3_span_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Out of Compliance");
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_3_span_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "In Compliance");
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_3_span_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r41.smartLicenseObj["enforceMode"]);
} }
function SmartLicenseBaseComponent_div_1_div_3_th_107_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1, "Description");
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_3_td_117_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r43.smartLicenseObj["description"]);
} }
function SmartLicenseBaseComponent_div_1_div_3_span_121_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Out of Compliance");
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_3_span_122_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "In Compliance");
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_1_div_3_span_123_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r46.smartLicenseObj["enforceMode"]);
} }
function SmartLicenseBaseComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "div", 16);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelementStart(4, "span", 17);
    i0.ɵɵtext(5, "BASE LICENSE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 46);
    i0.ɵɵlistener("click", function SmartLicenseBaseComponent_div_1_div_3_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r53); const ctx_r52 = i0.ɵɵnextContext(2); return ctx_r52.toggleChangeLicensePopup(true); });
    i0.ɵɵtext(7, "Change");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵelementStart(9, "span", 18);
    i0.ɵɵtext(10, "Cisco Spaces");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 19);
    i0.ɵɵelementStart(12, "div", 22);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, SmartLicenseBaseComponent_div_1_div_3_div_14_Template, 2, 4, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 47);
    i0.ɵɵelementStart(16, "div", 48);
    i0.ɵɵtext(17, "SMART SOFTWARE LICENSE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 49);
    i0.ɵɵtext(19, "To view and manage Cisco Spaces software license for your Cisco Smart Account, go to ");
    i0.ɵɵelementStart(20, "a", 14);
    i0.ɵɵtext(21, "Smart Software Manager");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 50);
    i0.ɵɵelementStart(23, "div", 51);
    i0.ɵɵelementStart(24, "div", 52);
    i0.ɵɵelementStart(25, "div", 53);
    i0.ɵɵtext(26, "SMART LICENSE STATUS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 54);
    i0.ɵɵelementStart(28, "div", 55);
    i0.ɵɵlistener("click", function SmartLicenseBaseComponent_div_1_div_3_Template_div_click_28_listener() { i0.ɵɵrestoreView(_r53); const ctx_r54 = i0.ɵɵnextContext(2); return ctx_r54.toggleActions(); });
    i0.ɵɵtext(29, "Actions ");
    i0.ɵɵtemplate(30, SmartLicenseBaseComponent_div_1_div_3_span_30_Template, 2, 0, "span", 56);
    i0.ɵɵtemplate(31, SmartLicenseBaseComponent_div_1_div_3_span_31_Template, 2, 0, "span", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(32, SmartLicenseBaseComponent_div_1_div_3_div_32_Template, 10, 0, "div", 57);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 58);
    i0.ɵɵelementStart(34, "div", 52);
    i0.ɵɵelementStart(35, "div", 59);
    i0.ɵɵtext(36, "Registration Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "div", 60);
    i0.ɵɵelementStart(38, "div", 61);
    i0.ɵɵelementStart(39, "span", 62);
    i0.ɵɵelement(40, "img", 63);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "span");
    i0.ɵɵtext(42, "Registered");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "div", 61);
    i0.ɵɵelementStart(44, "span", 64);
    i0.ɵɵtext(45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(46, "div", 52);
    i0.ɵɵelementStart(47, "div", 59);
    i0.ɵɵtext(48, "License Compliance");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "div", 60);
    i0.ɵɵelementStart(50, "div", 61);
    i0.ɵɵelementStart(51, "span", 62);
    i0.ɵɵtemplate(52, SmartLicenseBaseComponent_div_1_div_3_img_52_Template, 1, 0, "img", 65);
    i0.ɵɵtemplate(53, SmartLicenseBaseComponent_div_1_div_3_ng_template_53_Template, 1, 0, "ng-template", null, 66, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(55, "span", 67);
    i0.ɵɵtemplate(56, SmartLicenseBaseComponent_div_1_div_3_span_56_Template, 2, 0, "span", 0);
    i0.ɵɵtemplate(57, SmartLicenseBaseComponent_div_1_div_3_span_57_Template, 2, 0, "span", 0);
    i0.ɵɵtemplate(58, SmartLicenseBaseComponent_div_1_div_3_span_58_Template, 2, 1, "span", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(59, "div", 68);
    i0.ɵɵelementStart(60, "div", 69);
    i0.ɵɵelementStart(61, "div", 30);
    i0.ɵɵelementStart(62, "div", 70);
    i0.ɵɵelementStart(63, "div", 71);
    i0.ɵɵelementStart(64, "span", 72);
    i0.ɵɵtext(65, "Out of compliance");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(66, "br");
    i0.ɵɵelementStart(67, "span", 73);
    i0.ɵɵtext(68);
    i0.ɵɵelementStart(69, "a", 74);
    i0.ɵɵtext(70, "Smart License Manager");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(71, " for more details.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(72, "div", 75);
    i0.ɵɵelementStart(73, "div", 76);
    i0.ɵɵtext(74, "ACCOUNT DETAILS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(75, "div");
    i0.ɵɵelementStart(76, "span", 77);
    i0.ɵɵtext(77, "Smart Account Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(78, "span", 78);
    i0.ɵɵtext(79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(80, "div");
    i0.ɵɵelementStart(81, "span", 77);
    i0.ɵɵtext(82, "Virtual Account");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(83, "span", 78);
    i0.ɵɵtext(84);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(85, "div");
    i0.ɵɵelementStart(86, "span", 77);
    i0.ɵɵtext(87, "Product Instance Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(88, "span", 78);
    i0.ɵɵtext(89);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(90, "div");
    i0.ɵɵelementStart(91, "div", 79);
    i0.ɵɵelementStart(92, "span", 80);
    i0.ɵɵtext(93, "LICENSE INFORMATION");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(94, "span", 81);
    i0.ɵɵtext(95);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(96, "span", 82);
    i0.ɵɵlistener("click", function SmartLicenseBaseComponent_div_1_div_3_Template_span_click_96_listener() { i0.ɵɵrestoreView(_r53); const ctx_r55 = i0.ɵɵnextContext(2); return ctx_r55.refreshSLDetails(); });
    i0.ɵɵelement(97, "img", 83);
    i0.ɵɵtext(98, " Refresh");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(99, "div");
    i0.ɵɵelementStart(100, "div");
    i0.ɵɵelementStart(101, "div", 84);
    i0.ɵɵtext(102, "Smart License Usage");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(103, "table", 85);
    i0.ɵɵelementStart(104, "tr", 86);
    i0.ɵɵelementStart(105, "th");
    i0.ɵɵtext(106, "License (version)");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(107, SmartLicenseBaseComponent_div_1_div_3_th_107_Template, 2, 0, "th", 0);
    i0.ɵɵelementStart(108, "th");
    i0.ɵɵtext(109, "#of License");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(110, "th");
    i0.ɵɵtext(111, "Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(112, "th");
    i0.ɵɵtext(113, "Expiry Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(114, "tr");
    i0.ɵɵelementStart(115, "td");
    i0.ɵɵtext(116);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(117, SmartLicenseBaseComponent_div_1_div_3_td_117_Template, 2, 1, "td", 0);
    i0.ɵɵelementStart(118, "td");
    i0.ɵɵtext(119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(120, "td");
    i0.ɵɵtemplate(121, SmartLicenseBaseComponent_div_1_div_3_span_121_Template, 2, 0, "span", 0);
    i0.ɵɵtemplate(122, SmartLicenseBaseComponent_div_1_div_3_span_122_Template, 2, 0, "span", 0);
    i0.ɵɵtemplate(123, SmartLicenseBaseComponent_div_1_div_3_span_123_Template, 2, 1, "span", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(124, "td");
    i0.ɵɵtext(125);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r37 = i0.ɵɵreference(54);
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(32, _c0$1C, ctx_r9.userRole != "RW"));
    i0.ɵɵadvance(5);
    i0.ɵɵclassMap(ctx_r9.getLocationClass(ctx_r9.smartLicenseObj["licenseTag"]));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r9.smartLicenseObj["licenseTag"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.rootLocationLoaded);
    i0.ɵɵadvance(6);
    i0.ɵɵpropertyInterpolate("href", ctx_r9.slLearnMoreLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(34, _c0$1C, ctx_r9.userRole != "RW"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r9.showActionsDiv);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.showActionsDiv);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.showActionsDiv);
    i0.ɵɵadvance(13);
    i0.ɵɵtextInterpolate(ctx_r9.smartLicenseObj["registeredDate"]);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", ctx_r9.smartLicenseObj["enforceMode"] == "OutOfCompliance")("ngIfElse", _r37);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r9.smartLicenseObj["enforceMode"] == "OutOfCompliance" ? "OutOfCompliance" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.smartLicenseObj["enforceMode"] == "OutOfCompliance");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.smartLicenseObj["enforceMode"] == "InCompliance");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.smartLicenseObj["enforceMode"] != "OutOfCompliance" && ctx_r9.smartLicenseObj["enforceMode"] != "InCompliance");
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate1("There are insufficient \"Cisco Spaces ", ctx_r9.smartLicenseObj["licenseTag"], "\" licenses in the Smart License Virtual Account. Visit ");
    i0.ɵɵadvance(11);
    i0.ɵɵtextInterpolate(ctx_r9.smartLicenseObj["smartAccountName"]);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r9.smartLicenseObj["virtualAccountName"]);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r9.smartLicenseObj["productInstanceName"]);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("Last updated: ", ctx_r9.lastUpdated, " mins ago");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(36, _c0$1C, ctx_r9.userRole != "RW"));
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("ngIf", ctx_r9.smartLicenseObj["description"]);
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate2("", ctx_r9.smartLicenseObj["displayName"], " (", ctx_r9.smartLicenseObj["entitlementVersion"], ")");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.smartLicenseObj["description"]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r9.smartLicenseObj["consumedAps"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.smartLicenseObj["enforceMode"] == "OutOfCompliance");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.smartLicenseObj["enforceMode"] == "InCompliance");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.smartLicenseObj["enforceMode"] != "OutOfCompliance" && ctx_r9.smartLicenseObj["enforceMode"] != "InCompliance");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r9.smartLicenseObj["expiryDate"]);
} }
function SmartLicenseBaseComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SmartLicenseBaseComponent_div_1_div_1_Template, 17, 5, "div", 3);
    i0.ɵɵtemplate(2, SmartLicenseBaseComponent_div_1_div_2_Template, 18, 2, "div", 4);
    i0.ɵɵtemplate(3, SmartLicenseBaseComponent_div_1_div_3_Template, 126, 38, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.smartLicenseObj || ctx_r1.smartLicenseObj && !ctx_r1.smartLicenseObj["isRegistered"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showRegistrationPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.smartLicenseObj && ctx_r1.smartLicenseObj["isRegistered"]);
} }
function SmartLicenseBaseComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelementStart(1, "div", 44);
    i0.ɵɵelement(2, "div", 45);
    i0.ɵɵelement(3, "div", 45);
    i0.ɵɵelement(4, "div", 45);
    i0.ɵɵelement(5, "div", 45);
    i0.ɵɵelement(6, "div", 45);
    i0.ɵɵelement(7, "div", 45);
    i0.ɵɵelement(8, "div", 45);
    i0.ɵɵelement(9, "div", 45);
    i0.ɵɵelement(10, "div", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SmartLicenseBaseComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "app-change-base-license", 93);
    i0.ɵɵlistener("closePopup", function SmartLicenseBaseComponent_div_3_Template_app_change_base_license_closePopup_1_listener() { i0.ɵɵrestoreView(_r57); const ctx_r56 = i0.ɵɵnextContext(); return ctx_r56.toggleChangeLicensePopup(false); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("smartLicenseObj", ctx_r3.smartLicenseObj)("licenseType", ctx_r3.licenseType);
} }
const moment$p = moment_;
class SmartLicenseBaseComponent {
    constructor(router, dataService, userService, authService, locationService, translate) {
        this.router = router;
        this.dataService = dataService;
        this.userService = userService;
        this.authService = authService;
        this.locationService = locationService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.onHideSmartLicensePopup = new EventEmitter();
        this.licenseError = false;
        this.isLicenseInfoReady = false;
        this.progressBarClass = "p-bar";
        this.slLearnMoreLink = '';
        this.showUpgradeToSL = true;
        this.showSmartAccountWizard = false;
        this.showRegistrationPopup = false;
        this.showSmartLicenseDetails = false;
        // license info chart
        this.color = 'green';
        this.smartLicenseToken = '';
        this.smartLicenseObj = {};
        this.showActionsDiv = false;
        this.isTokenError = false;
        this.lastUpdated = 0;
        this.fromRefreshCall = false;
        this.getSmartLicenseStatusCallInProgress = false;
        this.apiGetCallStatus = 'progress';
        this.apiRegisterCallStatus = '';
        this.retryCounter = 0;
        this.smartLicensePopup = false;
        this.changeLicensePopup = false;
        this.licenseType = '';
        this.userRole = '';
        this.isUserRoleAvailable = false;
        this.messageKeys = {};
        this.rootLocationId = '';
        this.rootLocationName = '';
        this.rootLocationLoaded = false;
        this.fromSLPage = 'SLPage';
        this.getUserRole = () => {
            this.authService.getRole(this.unsubscribe$).subscribe(roleBehavior => {
                if (roleBehavior && roleBehavior.appRole) {
                    this.userRole = roleBehavior.appRole;
                }
                this.isUserRoleAvailable = true;
            }, error => {
                console.log(error);
            });
        };
        this.calculateProgressPercentage = () => {
            this.progressPercentage = ((this.licenseInfoData.consumedAps / this.licenseInfoData.totalAps) * 100);
        };
        this.calculateRemainingDays = () => {
            let endDate = this.licenseInfo.endDate;
            endDate = endDate.replace(/(\d+)(st|nd|rd|th)/, "$1");
            let date1 = new Date();
            let date2 = new Date(endDate);
            let diffTime = Math.abs(date2 - date1);
            this.remainingDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (this.remainingDays === 0) {
                this.remainingDaysLabel = this.remainingDays + ' Day left';
            }
            else if (this.remainingDays && this.remainingDays === 1) {
                this.remainingDaysLabel = this.remainingDays + ' Day left';
            }
            else if (this.remainingDays && this.remainingDays > 1) {
                this.remainingDaysLabel = this.remainingDays + ' Days left';
            }
        };
        this.toggleSmartAccountWizard = () => {
            this.showSmartAccountWizard = !this.showSmartAccountWizard;
            this.dataService.closeMagneticPopup();
            if (this.showSmartAccountWizard) {
                this.dataService.openMagneticPopup();
            }
        };
        this.hideActivationPopup = ($event) => {
            this.dataService.closeMagneticPopup();
            this.showSmartAccountWizard = $event;
            this.getSmartLicenseDetail();
        };
        this.toggleRegPopup = (showRegPopup) => {
            this.isTokenError = false;
            this.smartLicenseToken = '';
            this.dataService.closeMagneticPopup();
            if (showRegPopup) {
                this.apiRegisterCallStatus = '';
                this.dataService.openMagneticPopup();
            }
            this.showRegistrationPopup = showRegPopup;
        };
        this.closeRegPopup = () => {
            this.isTokenError = false;
            this.smartLicenseToken = '';
            this.showRegistrationPopup = false;
        };
        this.registerSmartAccount = () => {
            this.showSmartAccountWizard = false;
            this.toggleRegPopup(true);
        };
        this.makeSmartLicenseStatusCall = (delay, type) => {
            if (this.retryCounter > 0) {
                this.retryCounter = 0;
                if (this.smartLicenseObj) {
                    this.smartLicenseObj['isRegistered'] = false;
                }
                this.apiGetCallStatus = 'completed';
                return;
            }
            if (type === 'unavailable') {
                this.retryCounter++;
            }
            else {
                this.retryCounter = 0;
            }
            this.timeoutSmartLicenseStatus = setTimeout(() => {
                if (type === 'get' || type === 'unavailable') {
                    this.getSmartLicenseDetail();
                }
                else if (type === 'register') {
                    // this.registerSmartLicense();
                }
            }, delay);
        };
        this.getSmartLicenseDetail = () => {
            this.getSmartLicenseStatusCallInProgress = false;
            if (this.apiGetCallStatus != 'progress') {
                this.dataService.display(true);
            }
            if (this.getSmartLicenseStatusCallInProgress) {
                return;
            }
            this.getSmartLicenseStatusCallInProgress = true;
            this.userService.getSmartLicenseDetail().pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                this.getSmartLicenseStatusCallInProgress = false;
                if (response && response.status && response.data) {
                    if (response.data.status) {
                        if (response.data.status === "completed" && response.data.details) {
                            this.apiGetCallStatus = 'completed';
                            if (this.fromRefreshCall) {
                                this.dataService.setToastMessage(this.messageKeys[response.message.message], 4000, null, null, 'success');
                            }
                            this.smartLicenseObj = response.data.details;
                            // license type
                            this.licenseType = response.data.details ? response.data.details.licenseTag : '';
                            if (this.smartLicenseObj && this.smartLicenseObj['isRegistered']) {
                                this.calculateSLRemainingDays();
                                this.lastUpdated = 0;
                                this.calculateLastUpdated();
                                if (this.fromPage && (this.fromPage == 'login' || this.fromPage == 'baseComponent')) {
                                    this.onHideSmartLicensePopup.emit();
                                }
                            }
                            else if (!this.smartLicenseObj || !this.smartLicenseObj['isRegistered']) {
                                this.dataService.setToastMessage(this.messageKeys[response.message], 4000, null, null, 'error');
                            }
                        }
                        else if (response.data.status === "progress") {
                            this.makeSmartLicenseStatusCall(2000, 'get');
                            this.apiGetCallStatus = 'progress';
                        }
                        else {
                            this.apiGetCallStatus = 'progress';
                            this.makeSmartLicenseStatusCall(2000, 'unavailable');
                        }
                        this.closeRegPopup();
                    }
                    else {
                        this.smartLicenseObj['isRegistered'] = false;
                    }
                }
                else {
                    this.smartLicenseObj['isRegistered'] = false;
                }
                this.dataService.display(false);
            }, error => {
                this.dataService.display(false);
            });
        };
        this.calculateSLRemainingDays = () => {
            let expiryDays = this.smartLicenseObj['expiryDays'];
            if (expiryDays === 0) {
                this.remainingDaysLabel = expiryDays + ' Day left';
            }
            else if (expiryDays && expiryDays === 1) {
                this.remainingDaysLabel = expiryDays + ' Day left';
            }
            else if (expiryDays && expiryDays > 1) {
                this.remainingDaysLabel = expiryDays + ' Days left';
            }
        };
        this.getSLActivationRates = () => {
            return Math.round(this.smartLicenseObj['activationRate'] * 100);
        };
        this.registerSmartLicense = ($event) => {
            this.smartLicenseToken = $event;
            this.getSmartLicenseStatusCallInProgress = false;
            if (this.apiRegisterCallStatus != 'progress') {
                this.dataService.display(true, 50000);
            }
            if (this.getSmartLicenseStatusCallInProgress) {
                return;
            }
            this.getSmartLicenseStatusCallInProgress = true;
            let tokenObj = { 'token': this.smartLicenseToken };
            if (this.smartLicenseToken) {
                this.userService.registerSmartLicense(tokenObj).pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                    this.getSmartLicenseStatusCallInProgress = false;
                    if (response && response.status && response.data) {
                        if (response.data.status) {
                            if (response.data.status == "completed") {
                                this.apiRegisterCallStatus = 'completed';
                                this.smartLicenseObj = response.data.details;
                                if (this.smartLicenseObj['isRegistered']) {
                                    this.dataService.setSmartLicenseRegistered(true);
                                    this.calculateSLRemainingDays();
                                    this.toggleRegPopup(false);
                                    this.lastUpdated = 0;
                                    this.calculateLastUpdated();
                                    this.dataService.setToastMessage(this.messageKeys['user.smartLicense.register.success'], 4000, null, null, 'success');
                                    if (this.fromPage && (this.fromPage == 'login' || this.fromPage == 'baseComponent')) {
                                        // this.onHideSmartLicensePopup.emit();
                                        this.hideActivationPopup(false);
                                    }
                                }
                                else if (!this.smartLicenseObj['isRegistered']) {
                                    this.dataService.setToastMessage(this.messageKeys['user.smartLicense.register.failed'], 4000, null, null, 'error');
                                }
                            }
                            else if (response.data.status == "progress") {
                                this.makeSmartLicenseStatusCall(2000, 'get');
                                this.apiRegisterCallStatus = 'progress';
                            }
                            else {
                                this.isTokenError = true;
                                this.dataService.setToastMessage(this.messageKeys['user.smartLicense.register.failed'], 4000, null, null, 'error');
                            }
                        }
                        else {
                            this.isTokenError = true;
                            this.dataService.setToastMessage(this.messageKeys['user.smartLicense.register.failed'], 4000, null, null, 'error');
                        }
                    }
                    else {
                        this.isTokenError = true;
                        this.dataService.setToastMessage(this.messageKeys['user.smartLicense.register.failed'], 4000, null, null, 'error');
                    }
                    if (response.data.status != "progress") {
                        this.dataService.display(false);
                    }
                }, error => {
                    this.dataService.display(false);
                    console.log("ERROR: registerSmartLicense post call ::: ", error);
                });
            }
            else {
                this.dataService.setToastMessage(this.messageKeys['user.smartLicense.register.no-token'], 4000, null, null, 'error');
            }
        };
        this.tryAgainToken = () => {
            this.isTokenError = false;
            this.smartLicenseToken = '';
        };
        this.renewAuthSmartLicense = () => {
            this.dataService.display(true);
            this.userService.renewAuthSmartLicense().pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                if (response && response.status) {
                    this.dataService.setToastMessage(this.messageKeys[response.message.message], 4000, null, null, 'success');
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys[response.message], 4000, null, null, 'error');
                }
                this.toggleActions();
                this.dataService.display(false);
                this.refreshSLDetails();
            }, error => {
                this.dataService.display(false);
                console.log("ERROR: registerSmartLicense post call ::: ", error);
            });
        };
        this.renewRegistrationSmartLicense = () => {
            this.dataService.display(true);
            this.userService.renewRegistrationSmartLicense().pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                if (response && response.status) {
                    this.dataService.setToastMessage(this.messageKeys[response.message.message], 4000, null, null, 'success');
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys[response.message], 4000, null, null, 'error');
                }
                this.toggleActions();
                this.dataService.display(false);
                this.refreshSLDetails();
            }, error => {
                this.dataService.display(false);
                console.log("ERROR: registerSmartLicense post call ::: ", error);
            });
        };
        this.reRegisterSmartLicense = () => {
            this.dataService.display(true);
            this.userService.reRegisterSmartLicense().pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                if (response && response.status) {
                    this.dataService.setToastMessage(this.messageKeys["user.smartLicense.renew.authorization.success"], 4000, null, null, 'success');
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["user.smartLicense.renew.authorization.failure"], 4000, null, null, 'error');
                }
                this.toggleActions();
                this.dataService.display(false);
                this.refreshSLDetails();
            }, error => {
                this.dataService.display(false);
                console.log("ERROR: registerSmartLicense post call ::: ", error);
            });
        };
        this.deRegisterSmartLicense = () => {
            this.dataService.display(true);
            this.userService.deRegisterSmartLicense().pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                if (response && response.status) {
                    this.dataService.setToastMessage(this.messageKeys[response.message.message], 4000, null, null, 'success');
                    if (response.data) {
                        let responseData = response.data;
                        if (responseData.deregister) {
                            this.dataService.setSmartLicenseRegistered(false);
                            if (responseData.isExpired || responseData.isLicenseExceeded) {
                                this.router.navigate(['/smartlicensePopup']);
                                this.dataService.setCurrentNav('/smartlicensePopup');
                            }
                            else {
                                this.getSmartLicenseDetail();
                                this.dataService.setCurrentStatus(true);
                            }
                        }
                    }
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys[response.message], 4000, null, null, 'error');
                }
                this.toggleActions();
                this.dataService.display(false);
                this.refreshSLDetails();
            }, error => {
                this.dataService.display(false);
                console.log("ERROR: deRegisterSmartLicense post call ::: ", error);
            });
        };
        this.refreshSLDetails = () => {
            this.fromRefreshCall = true;
            this.getSmartLicenseDetail();
        };
        this.calculateLastUpdated = () => {
            setTimeout(() => {
                this.lastUpdated = this.lastUpdated + 1;
                this.calculateLastUpdated();
            }, 60000);
        };
        this.onChangeToken = () => {
            // console.log("smartLicenseToken :: " + this.smartLicenseToken);
        };
        this.toggleActions = () => {
            this.showActionsDiv = !this.showActionsDiv;
        };
        this.toggleChangeLicensePopup = (show) => {
            if (show) {
                this.dataService.openMagneticPopup();
            }
            else {
                this.dataService.closeMagneticPopup();
            }
            this.changeLicensePopup = show;
            this.getSmartLicenseDetail();
        };
        this.signOut = () => {
            this.dataService.display(true);
            this.locationService.signOut();
        };
        this.getLicenseDates = (data) => {
            // data.licenseDuration = 24;
            // data.consumedAps = 300;
            // data.totalAps = 300;
            let duration = {
                months: null,
                years: null
            };
            let warn = {
                licenseStatus: "active",
                apLimit: false
            };
            let endDate = moment$p(Number(data.startDate)).add(data.licenseDuration, 'M');
            let preMonth = moment$p(endDate).subtract(1, 'M');
            if (moment$p().isAfter(endDate)) {
                this.licenseError = true;
                warn.licenseStatus = "expired";
            }
            else if (moment$p().isAfter(preMonth)) {
                this.licenseError = true;
                warn.licenseStatus = "soon";
            }
            if (data.consumedAps == data.totalAps) {
                this.licenseError = true;
                warn.apLimit = true;
            }
            let formattedEndDate = moment$p(endDate).format("MMM Do, YYYY");
            if (data.licenseDuration > 11) {
                duration.years = (data.licenseDuration / 12).toString().split('.')[0];
                duration.months = Number(Math.round((data.licenseDuration % 12)));
            }
            else {
                duration.years = 0;
                duration.months = data.licenseDuration;
            }
            data.endDate = formattedEndDate;
            data.duration = duration;
            data.warn = warn;
            return data;
        };
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.user-api-management.smart-license.progress').subscribe((res) => {
                this.messageKeys["user.smartLicense.details.fetch.progress"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.success').subscribe((res) => {
                this.messageKeys["user.smartLicense.details.fetch.success"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.unavailable').subscribe((res) => {
                this.messageKeys["user.smartLicense.details.fetch.unavailable"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.inprogress').subscribe((res) => {
                this.messageKeys["user.smartLicense.details.fetch.inprogress"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.register-success').subscribe((res) => {
                this.messageKeys["user.smartLicense.register.success"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.register-failed').subscribe((res) => {
                this.messageKeys["user.smartLicense.register.failed"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.no-token').subscribe((res) => {
                this.messageKeys["user.smartLicense.register.no-token"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.re-register-success').subscribe((res) => {
                this.messageKeys["user.smartLicense.renew.authorization.success"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.re-register-failure').subscribe((res) => {
                this.messageKeys["user.smartLicense.renew.authorization.failure"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.renew-success').subscribe((res) => {
                this.messageKeys["user.smartLicense.renew.registration.success"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.renew-failure').subscribe((res) => {
                this.messageKeys["user.smartLicense.renew.registration.failure"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.smart-license.deregister-success').subscribe((res) => {
                this.messageKeys["user.smartLicense.deregister.success"] = res;
            });
            // user.smartLicense.deregister.success
        };
        this.getLocationClass = (licenseType) => {
            let classString = '';
            licenseType = licenseType == 'EXT' ? 'EXTEND' : licenseType;
            if (licenseType) {
                classString = licenseType.toLowerCase() + '-tag';
                classString = classString.replace(' ', '');
                return classString;
            }
        };
        this.getLocationNonSLClass = (licenseType) => {
            switch (licenseType) {
                case "Base Subscription": {
                    licenseType = 'SEE';
                    break;
                }
                case "Advanced Subscription": {
                    licenseType = 'ACT';
                    break;
                }
                case "Extend": {
                    licenseType = 'EXT';
                    break;
                }
                default: {
                    licenseType = licenseType;
                    break;
                }
            }
            let classString = '';
            licenseType = licenseType == 'EXT' ? 'EXTEND' : licenseType;
            if (licenseType) {
                classString = licenseType.toLowerCase() + '-tag';
                classString = classString.replace(' ', '');
                return classString;
            }
        };
    }
    ngOnInit() {
        this.dataService.getLicenseDetails(this.unsubscribe$).subscribe((val) => {
            if (val.tenantId) {
                if (moment$p(val.startDate, "YYYY-MM-DDTHH:mm:ss.sssZ", true).isValid()) {
                    val.startDate = String(moment$p(val.startDate).valueOf());
                }
                this.licenseInfo = val;
                this.licenseInfoData = this.getLicenseDates(val);
                this.isLicenseInfoReady = true;
            }
            else {
                this.isLicenseInfoReady = false;
            }
        });
        this.getUserRole();
        this.dataService.setIslicensePage(true);
        let slLinkUrl = this.dataService.getSmartLicenseLearnMore();
        this.slLearnMoreLink = slLinkUrl ? slLinkUrl : 'https://www.cisco.com/c/en_in/products/software/smart-accounts/software-licensing.html';
        if (this.licenseInfo && this.licenseInfoData) {
            this.calculateProgressPercentage();
            this.calculateRemainingDays();
            this.progressBarClass = this.licenseInfoData.warn.apLimit == true ? 'p-bar-complete' : 'p-bar';
        }
        // if smart license registered then call get call
        // if (this.dataService.getSmartLicenseRegistered()) {
        this.getSmartLicenseDetail();
        // }
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
        this.dataService
            .getLocationLoadingStatus(this.unsubscribe$)
            .subscribe((locationLoadingStatus) => {
            if (locationLoadingStatus &&
                locationLoadingStatus.status === "done") {
                const rootLocation = this.dataService.getRootLocation();
                console.log('rootLocation' + JSON.stringify(rootLocation));
                this.rootLocationId = rootLocation.id;
                this.rootLocationName = rootLocation.name;
                this.rootLocationLoaded = true;
            }
        });
    }
    ngOnDestroy() {
        console.log('destory Smart License Base component');
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        clearTimeout(this.timeoutSmartLicenseStatus);
        this.dataService.setIslicensePage(false);
    }
}
SmartLicenseBaseComponent.ɵfac = function SmartLicenseBaseComponent_Factory(t) { return new (t || SmartLicenseBaseComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(UserService), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
SmartLicenseBaseComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SmartLicenseBaseComponent, selectors: [["lib-smart-license-base"]], inputs: { licenseInfo: "licenseInfo", licenseInfoData: "licenseInfoData", fromPage: "fromPage" }, outputs: { onHideSmartLicensePopup: "onHideSmartLicensePopup" }, decls: 4, vars: 4, consts: [[4, "ngIf"], ["id", "placeholder", "class", "placeholder stats-container", 4, "ngIf"], [3, "fromPage", "hideActivationPopup", "registerSmartLicenseToken"], ["class", "slDetailsWrapper", 4, "ngIf"], ["class", "modalPopup", 4, "ngIf"], [1, "slDetailsWrapper"], [1, "left", "marginL20"], [1, "smUpgradeImage"], ["src", "/assets/images/smartlicense/upsell-img1.svg", "alt", "Smart License Upsell Image", "width", "610"], [1, "smUpgradeWrapper"], [1, "smUpgradeHeader"], [1, "smUpgradeDesc"], [1, "padding20"], [1, "commonButton", "marginRight10"], ["target", "_blank", 3, "href"], [1, "primaryButton", 3, "ngClass", "click"], [1, "base-license-wrapper"], [1, "title"], [1, "cisco-spaces-label"], [1, "license-tag"], ["class", "license-label", 4, "ngIf"], ["class", "license-usage-wrapper", 4, "ngIf"], [1, "license-label"], [1, "license-usage-wrapper"], [3, "locationId", "locationName", "fromSLPage", "isRegisteredSL"], [1, "modalPopup"], [1, "modalContent-slider"], [1, "modalHeaderSA"], [1, "modalCloseIcon", 3, "click"], [1, "headerDesc"], [1, "modalBody"], [1, "bodyTitle"], [1, "modalFooter"], [1, "rightAlign"], [1, "cancelButton", 3, "click"], ["class", "tokenErrorWrapper", 4, "ngIf"], ["cols", "6 ", "rows", "6 ", "placeholder", "Copy + Paste here", 2, "width", "100%", "padding", "10px", "border", "1px solid #aaaaaa", 3, "ngModel", "ngModelChange", "change"], [1, "tokenErrorWrapper"], [1, "tokenErrorImg"], ["src", "/assets/cisco/images/dashboard/error_icon.svg", 2, "width", "40px", "height", "40px"], [1, "tokenErrorLabel"], [1, "tokenErrorDesc"], [1, "tryAgainButton", 3, "ngClass", "click"], ["id", "placeholder", 1, "placeholder", "stats-container"], [1, "placeholder-content"], [1, "placeholder-content_item"], [1, "change-license-label", 3, "ngClass", "click"], [1, "width50", "paddingTB10", 2, "margin-top", "50px"], [1, "slDetailsTitle"], [1, "slDetailsDesc"], [1, "paddingTB10", "width50"], [1, "divTable", "paddingTB10"], [1, "divTableRow"], [1, "divTableCell", "ciscoSans"], [1, "actionWraper", "divTableCell"], [1, "actionLabelDiv", "ciscoSans", 3, "ngClass", "click"], ["class", "dropdownImage", 4, "ngIf"], ["class", "actionsDiv", 4, "ngIf"], [1, "divTable", "paddingTB10", "font14"], [1, "divTableCell", "width50", "vTop"], [1, "divTableCell", "paddingB20"], [1, "statusLabel"], [1, "statusIconSL"], ["src", "/assets/images/tick_mark_green.svg", 2, "width", "12px", "height", "12px"], [1, "paddingLeftSL"], ["src", "/assets/images/basic/error_red.svg", "style", "width: 12px; height: 12px;", 4, "ngIf", "ngIfElse"], ["inCompliance", ""], [3, "ngClass"], [1, "showDiv-on-Mousehover"], [1, "modalContent-act"], [1, "act-popup-div"], [1, "popup-title-div"], [1, "popup-title-red"], [1, "popup-subtitle"], ["href", "https://www.cisco.com/c/en_in/products/software/smart-accounts/software-licensing.html", "target", "_blank"], [1, "paddingTB10", "width50", "borderTop"], [1, "paddingTB10", "ciscoSans"], [1, "accDetailLabel"], [1, "accDetailLabel", "ciscoSans", "paddingLeftSL"], [1, "apInfoHeader"], [1, "apInfoHeaderLabel"], [1, "apInfoLastUpdate"], [1, "apInfoRefresh", "ciscoSans", 3, "ngClass", "click"], ["src", "/assets/images/smartlicense/refresh.svg", 2, "width", "14px", "height", "14px"], [1, "paddingTB10", "textBold", "ciscoSans"], [1, "apInfoTable"], [1, "ciscoSans"], [1, "dropdownImage"], ["src", "/assets/images/smartlicense/dropdown_arrow_down.svg"], ["src", "/assets/images/smartlicense/dropdown_arrow_up.svg"], [1, "actionsDiv"], [3, "click"], ["src", "/assets/images/basic/error_red.svg", 2, "width", "12px", "height", "12px"], [3, "smartLicenseObj", "licenseType", "closePopup"]], template: function SmartLicenseBaseComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SmartLicenseBaseComponent_div_0_Template, 2, 1, "div", 0);
        i0.ɵɵtemplate(1, SmartLicenseBaseComponent_div_1_Template, 4, 3, "div", 0);
        i0.ɵɵtemplate(2, SmartLicenseBaseComponent_div_2_Template, 11, 0, "div", 1);
        i0.ɵɵtemplate(3, SmartLicenseBaseComponent_div_3_Template, 2, 2, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showSmartAccountWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.apiGetCallStatus == "completed" && ctx.isUserRoleAvailable);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.apiGetCallStatus == "progress");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.changeLicensePopup);
    } }, directives: [i1$2.NgIf, SmartLicensePopupComponent, i1$2.NgClass, SplitLicenseUsageComponent, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, ChangeBaseLicenseComponent], styles: ["@font-face{font-family:\"ciscoSansRegular\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansBold\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansThin\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansExtraLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansCondensed\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.svg) format(\"svg\")}@font-face{font-family:\"ciscoSans\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"icomoon\";font-display:auto;src:url(/assets/fonts/icomoon.eot?llzbkh);src:url(/assets/fonts/icomoon.eot?llzbkh#iefix) format(\"embedded-opentype\"),url(/assets/fonts/icomoon.ttf?llzbkh) format(\"truetype\"),url(/assets/fonts/icomoon.woff?llzbkh) format(\"woff\"),url(/assets/fonts/icomoon.svg?llzbkh#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"icomoon-new\";font-display:auto;src:url(/assets/fonts/icomoonnew/icomoon.eot?-psryvp);src:url(/assets/fonts/icomoonnew/icomoon.eot?#iefix-psryvp) format(\"embedded-opentype\"),url(/assets/fonts/icomoonnew/icomoon.ttf?-psryvp) format(\"truetype\"),url(/assets/fonts/icomoonnew/icomoon.woff?-psryvp) format(\"woff\"),url(/assets/fonts/icomoonnew/icomoon.svg?-psryvp#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"Roboto-Bold\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Bold.eot);src:url(/assets/fonts/Roboto/Roboto-Bold.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Bold.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Bold.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Bold.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Bold.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Light\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Light.eot);src:url(/assets/fonts/Roboto/Roboto-Light.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Light.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Light.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Light.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Light.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Medium\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Medium.eot);src:url(/assets/fonts/Roboto/Roboto-Medium.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Medium.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Medium.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Medium.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Medium.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Regular\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Regular.eot);src:url(/assets/fonts/Roboto/Roboto-Regular.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Regular.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Regular.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Regular.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Regular.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Inter\";font-display:auto;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}.blockElement[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";border-bottom:1px solid #eaeaea;padding:15px 0 0}.blockElement2[_ngcontent-%COMP%]{font-family:ciscoSansRegular;padding-left:50px;padding-top:40px;width:80%;text-align:left}.blockHeader[_ngcontent-%COMP%]{font-size:14px;padding:10px 0;font-family:ciscoSans}.blockValue[_ngcontent-%COMP%]{font-size:12px;padding:5px 0;color:#3e3e3e}.support-block[_ngcontent-%COMP%]{text-align:center}.support-message[_ngcontent-%COMP%]{font-size:12px}.support-email[_ngcontent-%COMP%]{font-size:13px;font-weight:bold}.active-indicator[_ngcontent-%COMP%]{color:#00b58e;font-family:ciscoSansBold;width:80px;display:inline-block}.expiry-indicator[_ngcontent-%COMP%]{color:#f5a623;font-family:ciscoSansBold;width:118px;display:inline-block}.expired-indicator[_ngcontent-%COMP%]{color:red;font-family:ciscoSansBold;width:135px;display:inline-block}.duration-block[_ngcontent-%COMP%]{font-size:12px;color:#787878;padding-top:5px}.notice-block[_ngcontent-%COMP%]{background:#fffdf3;border:1px solid #fddfaf;max-width:400px;padding:10px;margin:10px 0}.notice-img[_ngcontent-%COMP%]{width:10%;height:30px;float:left;background:url(/assets/images/error_icon.svg);background-size:20px;background-repeat:no-repeat;margin:0 5px}.notice-msg[_ngcontent-%COMP%]{font-size:12px;font-family:\"ciscoSansLight\"}.bold-txt[_ngcontent-%COMP%]{font-family:\"ciscoSans\"}[_nghost-%COMP%]    >  >  > .ui-progressbar[_ngcontent-%COMP%]{border:1px solid #d9d9d9!important}.licenseTypeImg[_ngcontent-%COMP%]{width:15%;text-align:center}.licenseDetails[_ngcontent-%COMP%]{width:20%;padding-left:5%}.apLimit[_ngcontent-%COMP%]{width:60%;padding-right:30%;padding-left:5%;border-left:1px solid #d4d4d4}.licenseTypeLabel[_ngcontent-%COMP%]{font-size:36px;font-family:ciscoSans;padding-right:10px}.licenseTypeLabel.see[_ngcontent-%COMP%]{color:#069ddd}.licenseTypeLabel.act[_ngcontent-%COMP%]{color:#fbab18}.licenseTypeLabel.extend[_ngcontent-%COMP%]{color:#6ebe4a}.licenseValidity[_ngcontent-%COMP%]{font-size:14px}.licenseText[_ngcontent-%COMP%]{font-family:ciscoSans}.remainingDays[_ngcontent-%COMP%]{font-size:12px;padding-top:5px}.width100[_ngcontent-%COMP%]{width:100px}.statusDiv[_ngcontent-%COMP%]{border:1px solid #d4d4d4;padding:0 10px;background-color:#fff}span.licenseStatus[_ngcontent-%COMP%]{text-transform:capitalize;font-size:12px;padding-left:10px;font-family:ciscoSans}.userLicenseInfoWrapper[_ngcontent-%COMP%]{padding:40px 0;background-color:#f7f7f7;border-bottom:1px solid #d4d4d4}.smUpgradeImage[_ngcontent-%COMP%]{margin:20px auto 10px}.smUpgradeWrapper[_ngcontent-%COMP%]{margin:auto;padding-bottom:80px;width:50%}.smUpgradeHeader[_ngcontent-%COMP%]{font-size:20px;padding:10px;font-family:ciscoSans}.smUpgradeDesc[_ngcontent-%COMP%]{font-size:16px;padding:10px}.marginRight10[_ngcontent-%COMP%]{margin-right:10px}.modalPopup[_ngcontent-%COMP%]   .modalHeaderSA[_ngcontent-%COMP%]{padding:18px 30px;color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:relative;height:40px;border:none}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:15px 25px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.modalPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{padding:10px 40px;min-height:400px;max-height:500px;overflow-y:auto}.divCellWidth[_ngcontent-%COMP%]{width:49%;padding:1%}.smAccHeading[_ngcontent-%COMP%]{font-size:20px;padding-bottom:30px;font-family:ciscoSans}.smAccDesc[_ngcontent-%COMP%]{font-size:16px;width:80%;padding-bottom:20px}.stepsWrapper[_ngcontent-%COMP%]{padding:20px 0}.prerequisite[_ngcontent-%COMP%]{background-color:#fee6be;font-size:12px;padding:10px;margin-bottom:20px;width:70%}.rightCell[_ngcontent-%COMP%]{height:200px;background-color:#e6edf8}.modalPopup.connectorPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:calc(100vh - 180px);overflow-y:auto;padding-bottom:200px;transition:.5s ease}.modalPopup[_ngcontent-%COMP%] > .modalContent-slider[_ngcontent-%COMP%]{width:30%;right:0;height:100%;z-index:1001;position:absolute;top:0;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #049fd9;animation:.5s forwards slide}@keyframes slide{65%{right:0}}.headerDesc[_ngcontent-%COMP%]{padding:10px 40px 30px;font-size:14px;color:#4e4e4e;border-bottom:1px solid #d8d8d8}.bodyTitle[_ngcontent-%COMP%]{padding:10px 0 20px;color:#606060;font-family:arial}.textEditor[_ngcontent-%COMP%]{width:100%;height:200px;background-color:#d8d8d8;padding:10px}.slDetailsWrapper[_ngcontent-%COMP%]{padding:0 40px}.paddingTB10[_ngcontent-%COMP%]{padding:10px 0}.width50[_ngcontent-%COMP%]{width:50%}.slDetailsTitle[_ngcontent-%COMP%]{font-family:ciscoSansBold;padding-bottom:10px}.slDetailsDesc[_ngcontent-%COMP%]{font-family:ciscoSansThin}.borderTop[_ngcontent-%COMP%]{border-top:1px solid #dddddd}.font14[_ngcontent-%COMP%]{font-size:14px}.actionWraper[_ngcontent-%COMP%]{position:relative}.actionLabelDiv[_ngcontent-%COMP%]{padding:5px 10px;background-color:#fff;border:1px solid #b8b8b8;color:#00bceb;cursor:pointer}.actionLabelDiv[_ngcontent-%COMP%]   .dropdownImage[_ngcontent-%COMP%]{float:right}.actionsDiv[_ngcontent-%COMP%]{position:absolute;border:1px solid #b8b8b8;background-color:#fff;width:100%}.actionsDiv[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin:0!important;padding:10px!important}.actionsDiv[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin:10px 0;color:#00bceb;cursor:pointer}.vTop[_ngcontent-%COMP%]{vertical-align:top}.paddingB20[_ngcontent-%COMP%]{padding-bottom:20px}.statusLabel[_ngcontent-%COMP%]{padding:5px 0;font-family:ciscoSans}.statusLabel[_ngcontent-%COMP%]   .statusIconSL[_ngcontent-%COMP%]{padding:0 10px;width:32px}.statusLabel[_ngcontent-%COMP%]   .paddingLeftSL[_ngcontent-%COMP%]{padding-left:32px}.accDetailLabel[_ngcontent-%COMP%]{width:50%;display:inline-block;padding:5px 0;font-size:14px}.apInfoHeader[_ngcontent-%COMP%]{padding:20px 0}.apInfoHeaderLabel[_ngcontent-%COMP%]{font-family:ciscoSansBold;padding-right:20px}.apInfoLastUpdate[_ngcontent-%COMP%]{font-family:ciscoSansThin;font-size:14px;padding-right:20px}.apInfoRefresh[_ngcontent-%COMP%]{font-size:14px;color:#00bceb;cursor:pointer}.cancelButton[_ngcontent-%COMP%]{text-align:center;cursor:pointer;display:inline-table;vertical-align:middle;font-size:14px;padding:6px 18px;color:#0096d6;outline:none}.rightAlign[_ngcontent-%COMP%]{text-align:right;padding:20px}.ciscoSans[_ngcontent-%COMP%]{font-family:ciscoSans}.paddingLeftSL[_ngcontent-%COMP%]{padding-left:32px}#licenseInfoSpaces[_ngcontent-%COMP%]{padding:20px 20px 20px 0}#licenseInfoSpaces[_ngcontent-%COMP%]   span.label[_ngcontent-%COMP%]{display:inline-block;color:#9c9c9c;font-size:18px;vertical-align:middle;text-align:left}#licenseInfoSpaces[_ngcontent-%COMP%]   span.data[_ngcontent-%COMP%]{display:inline-block;color:#000;font-size:25px;font-weight:bold}.padding20[_ngcontent-%COMP%]{padding:20px}.tokenErrorWrapper[_ngcontent-%COMP%]{text-align:center}.tokenErrorWrapper[_ngcontent-%COMP%]   .tokenErrorImg[_ngcontent-%COMP%]{padding:10px}.tokenErrorWrapper[_ngcontent-%COMP%]   .tokenErrorLabel[_ngcontent-%COMP%]{color:#727272;font-size:20px}.tokenErrorWrapper[_ngcontent-%COMP%]   .tokenErrorDesc[_ngcontent-%COMP%]{padding:10px 0 20px;font-size:14px;color:#646464}.tokenErrorWrapper[_ngcontent-%COMP%]   .tryAgainButton[_ngcontent-%COMP%]{height:34px;border-radius:6px;background-color:#fff;border:1px solid #049fd9;color:#049fd9;font-family:\"ciscoSansRegular\";text-align:center;cursor:pointer;display:inline-table;vertical-align:middle;font-size:14px;padding:6px 18px;outline:none;letter-spacing:1px}.apInfoTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .apInfoTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:10px;border:1px solid #b8b8b8}.placeholder-content[_ngcontent-%COMP%]{height:100px;overflow:hidden;background:#000;position:relative;animation-duration:1.7s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-timing-function:linear;animation-name:placeholderAnimate;background:#f6f7f8;background:linear-gradient(to right,#eee 2%,#ddd 18%,#eee 33%);background-size:1000px}.placeholder-content_item[_ngcontent-%COMP%]{width:100%;height:20px;position:absolute;background:#fff;z-index:2}.placeholder-content_item[_ngcontent-%COMP%]:after, .placeholder-content_item[_ngcontent-%COMP%]:before{width:inherit;height:inherit;content:\"\";position:absolute}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(1){top:0;left:0}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(2){top:20px;left:0;width:0;height:90px}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(3){top:0px;left:0;width:20px;height:100%}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(4){top:0;width:15px;left:75px;height:102px}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(5){top:51px;left:80px;height:0}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(6){top:60px;left:90px;height:5px}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(7){top:20px;right:0;width:0;height:20px}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(8){top:0;right:0;width:10%;height:100%}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(9){top:85px;height:100px;left:0}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(10){top:149px;height:60px;left:0}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(11){top:183px;left:0;height:100%}@keyframes placeholderAnimate{0%{background-position:-650px 0}to{background-position:650px 0}}.smartlicense_info[_ngcontent-%COMP%]{display:flex;flex-direction:row;width:95%;margin:auto;padding:0 20px;border-bottom:1px solid #ddd;justify-content:flex-start}.smartlicense_info__sec[_ngcontent-%COMP%]{width:30%}.smartlicense_info[_ngcontent-%COMP%]   .sec1[_ngcontent-%COMP%]{text-align:left}.smartlicense_info[_ngcontent-%COMP%]   .sec1[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{padding-left:20px}.smartlicense_info[_ngcontent-%COMP%]   .sec1_wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row}.smartlicense_info[_ngcontent-%COMP%]   .sec1_wrapper[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{padding:10px}.smartlicense_info[_ngcontent-%COMP%]   .sec1_wrapper__main[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:0 20px}.smartlicense_info[_ngcontent-%COMP%]   .sec1_wrapper__main[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(1){font-family:\"ciscoSans\";font-size:16px}.smartlicense_info[_ngcontent-%COMP%]   .sec1_wrapper__main[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(2){font-size:25px;font-family:\"ciscoSans\"}.smartlicense_info[_ngcontent-%COMP%]   .sec1_wrapper__main[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(3){font-size:13px}.smartlicense_info[_ngcontent-%COMP%]   .sec1_wrapper__main[_ngcontent-%COMP%]   .actStyle[_ngcontent-%COMP%]{color:#f8ab19}.smartlicense_info[_ngcontent-%COMP%]   .sec1_wrapper__main[_ngcontent-%COMP%]   .seeStyle[_ngcontent-%COMP%]{color:#38a8e3}.smartlicense_info[_ngcontent-%COMP%]   .sec3[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-around}.smartlicense_info[_ngcontent-%COMP%]   .seperator[_ngcontent-%COMP%]{width:1px;background-color:#d4d4d4;height:80px;position:relative;top:30px}.marginL20[_ngcontent-%COMP%]{margin-left:20px}.OutOfCompliance[_ngcontent-%COMP%]{color:red}.showDiv-on-Mousehover[_ngcontent-%COMP%]{display:none}.OutOfCompliance[_ngcontent-%COMP%]:hover + .showDiv-on-Mousehover[_ngcontent-%COMP%]{display:block}.modalContent-act[_ngcontent-%COMP%]{width:360px;left:0;top:-136px;position:absolute;background:white;padding:5px;box-shadow:0 0 20px #0000004d;transform:translate(-50%);-webkit-transform:translateX(-50%);-webkit-box-shadow:0 0 20px rgba(0,0,0,.3);opacity:1}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{margin:0;opacity:1!important}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]{display:flex;height:115px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 10px 10px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-red[_ngcontent-%COMP%]{color:red;font-family:CiscoSans;font-size:18px;line-height:26px;letter-spacing:.5px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#000;font-family:CiscoSansLight;font-size:12px;opacity:.7}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]:hover{opacity:1!important}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]{width:100%;border-top:1px solid #b2a6a6;text-align:center;padding-top:5px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]   .popup-footer-text[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:13px;color:#fff}.license-tag[_ngcontent-%COMP%]{display:inline-block;padding:5px 10px;margin:0 15px;border-radius:50px}.see-tag[_ngcontent-%COMP%]{background-color:#009edc}.act-tag[_ngcontent-%COMP%]{background-color:#f8ab19}.extend-tag[_ngcontent-%COMP%], .ext-tag[_ngcontent-%COMP%]{background-color:#7cc242}.smartvenue-tag[_ngcontent-%COMP%], .smart_venues-tag[_ngcontent-%COMP%]{background-color:#436fb6}.smartops-tag[_ngcontent-%COMP%], .smart_operations-tag[_ngcontent-%COMP%]{background-color:#8750a1}.unlimited-tag[_ngcontent-%COMP%], .unlimitedsubscription-tag[_ngcontent-%COMP%]{background-color:#ff7c33}.license-label[_ngcontent-%COMP%]{font-family:\"ciscoSansLight\";font-style:normal;font-weight:400;font-size:16px;text-align:center;color:#fff}.license-desc[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:12px;line-height:18px;letter-spacing:.5px;color:#565659}.license-usage-wrapper[_ngcontent-%COMP%]{padding:25px;background-color:#fafafa}.base-license-wrapper[_ngcontent-%COMP%]{padding:25px 0}.base-license-wrapper[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{display:inline-block;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:1px;text-transform:uppercase;color:#121212;padding-right:12px;padding-bottom:12px}.base-license-wrapper[_ngcontent-%COMP%]   .change-license-label[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px;color:#00a0d1;cursor:pointer}.base-license-wrapper[_ngcontent-%COMP%]   .cisco-spaces-label[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px;color:#545454;display:inline-block}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartLicenseBaseComponent, [{
        type: Component,
        args: [{
                selector: "lib-smart-license-base",
                templateUrl: "./smart-license-base.component.html",
                styleUrls: ["./smart-license-base.component.scss"]
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: UserService }, { type: AuthService }, { type: LocationService }, { type: i2.TranslateService }]; }, { licenseInfo: [{
            type: Input
        }], licenseInfoData: [{
            type: Input
        }], fromPage: [{
            type: Input
        }], onHideSmartLicensePopup: [{
            type: Output
        }] }); })();

function DropdownSimpleComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function DropdownSimpleComponent_div_1_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.expandDropdown($event); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedItem, " ");
} }
function DropdownSimpleComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function DropdownSimpleComponent_div_2_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.expandDropdown($event); });
    i0.ɵɵtext(1, " Select ");
    i0.ɵɵelementEnd();
} }
function DropdownSimpleComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function DropdownSimpleComponent_div_3_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r12); const item_r10 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.selectItem(item_r10); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r10, " ");
} }
function DropdownSimpleComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, DropdownSimpleComponent_div_3_div_1_Template, 2, 1, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.listItemsArray);
} }
function DropdownSimpleComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1, " List unavilable ");
    i0.ɵɵelementEnd();
} }
function DropdownSimpleComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function DropdownSimpleComponent_div_5_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.expandDropdown($event); });
    i0.ɵɵelementEnd();
} }
const _c0$1B = function (a0) { return { "dropdownExpand": a0 }; };
class DropdownSimpleComponent {
    constructor() {
        this.onDropdownSelect = new EventEmitter();
        this.dropdownExpand = false;
        this.expandDropdown = (event) => {
            this.dropdownExpand = !this.dropdownExpand;
        };
        this.selectItem = (selectedItem) => {
            this.selectedItem = selectedItem;
            this.onDropdownSelect.emit(selectedItem);
            this.expandDropdown(false);
        };
    }
    set listItems(values) {
        this.listItemsArray = values;
    }
}
DropdownSimpleComponent.ɵfac = function DropdownSimpleComponent_Factory(t) { return new (t || DropdownSimpleComponent)(); };
DropdownSimpleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DropdownSimpleComponent, selectors: [["dropdown-simple"]], inputs: { selectedItem: "selectedItem", listItems: "listItems" }, outputs: { onDropdownSelect: "onDropdownSelect" }, decls: 6, vars: 8, consts: [[1, "simpleDropdownContainer", 3, "ngClass"], ["class", "selectedDropdown", 3, "click", 4, "ngIf"], ["class", "simpleDropdownList", 4, "ngIf"], ["class", "dropdownFilterOverlay", 3, "click", 4, "ngIf"], [1, "selectedDropdown", 3, "click"], [1, "simpleDropdownList"], ["class", "eachElement", 3, "click", 4, "ngFor", "ngForOf"], [1, "eachElement", 3, "click"], [1, "dropdownFilterOverlay", 3, "click"]], template: function DropdownSimpleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, DropdownSimpleComponent_div_1_Template, 2, 1, "div", 1);
        i0.ɵɵtemplate(2, DropdownSimpleComponent_div_2_Template, 2, 0, "div", 1);
        i0.ɵɵtemplate(3, DropdownSimpleComponent_div_3_Template, 2, 1, "div", 2);
        i0.ɵɵtemplate(4, DropdownSimpleComponent_div_4_Template, 2, 0, "div", 2);
        i0.ɵɵtemplate(5, DropdownSimpleComponent_div_5_Template, 1, 0, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$1B, ctx.dropdownExpand));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listItemsArray && ctx.listItemsArray.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listItemsArray === undefined || ctx.listItemsArray.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownExpand);
    } }, directives: [i1$2.NgClass, i1$2.NgIf, i1$2.NgForOf], styles: [".simpleDropdownContainer[_ngcontent-%COMP%]{width:100%;display:block;margin:10px 0;position:relative}.simpleDropdownContainer[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{width:12px;height:12px;color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;top:6px;right:4px;padding:4px;font-size:14px;display:block;content:\"\\e905\";z-index:100}.simpleDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{content:\"\\e908\"}.selectedDropdown[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #9E9EA2;width:100%;border-radius:0;cursor:pointer;padding:8px 10px;position:relative}.simpleDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]{border-color:#049fd9}.simpleDropdownList[_ngcontent-%COMP%]{display:none;width:100%;position:absolute;top:38px;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:103;box-shadow:0 0 3px #0000004d}.simpleDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .simpleDropdownList[_ngcontent-%COMP%]{display:block;background-color:#fff}.simpleDropdownContainer[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]{display:block;padding:12px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.simpleDropdownContainer[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]:hover{color:#666;background-color:#39393b1a}.dropdownFilterOverlay[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:100;background-color:#ffffff1a}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownSimpleComponent, [{
        type: Component,
        args: [{
                selector: "dropdown-simple",
                templateUrl: "./dropdown-simple.component.html",
                styleUrls: ["./dropdown-simple.component.css"]
            }]
    }], function () { return []; }, { selectedItem: [{
            type: Input
        }], listItems: [{
            type: Input
        }], onDropdownSelect: [{
            type: Output
        }] }); })();

const _c0$1A = function (a0, a1) { return { "active": a0, "disabled": a1 }; };
function ChangeLogPaginationComponent_div_0_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function ChangeLogPaginationComponent_div_0_button_13_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const pageNum_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return ctx_r3.onPage(pageNum_r2); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const pageNum_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0$1A, pageNum_r2 === ctx_r1.page, ctx_r1.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(pageNum_r2);
} }
const _c1$E = function (a0) { return { "disabled": a0 }; };
function ChangeLogPaginationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵelementStart(5, "span", 5);
    i0.ɵɵtext(6, "Show Records: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "dropdown-simple", 6);
    i0.ɵɵlistener("onDropdownSelect", function ChangeLogPaginationComponent_div_0_Template_dropdown_simple_onDropdownSelect_7_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.onRecordNumSelect($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 7);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 8);
    i0.ɵɵelementStart(11, "button", 9);
    i0.ɵɵlistener("click", function ChangeLogPaginationComponent_div_0_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.onPrev(); });
    i0.ɵɵelement(12, "img", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, ChangeLogPaginationComponent_div_0_button_13_Template, 2, 5, "button", 11);
    i0.ɵɵelementStart(14, "button", 9);
    i0.ɵɵlistener("click", function ChangeLogPaginationComponent_div_0_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r6); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.onNext(); });
    i0.ɵɵelement(15, "img", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.itemOnthisPage, " Records");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("selectedItem", ctx_r0.noOfRecordsToShow)("listItems", ctx_r0.recordNumbersToShow);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("1 - ", ctx_r0.totalPages(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.page === 1 || ctx_r0.loading)("ngClass", i0.ɵɵpureFunction1(9, _c1$E, ctx_r0.page === 1 || ctx_r0.loading));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.getPages());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r0.lastPage() || ctx_r0.loading)("ngClass", i0.ɵɵpureFunction1(11, _c1$E, ctx_r0.lastPage() || ctx_r0.loading));
} }
class ChangeLogPaginationComponent {
    constructor(dataService) {
        this.dataService = dataService;
        // @Output() goPrev = new EventEmitter<boolean>();
        // @Output() goNext = new EventEmitter<boolean>();
        this.clickEvent = new EventEmitter();
        this.currentPage = new EventEmitter();
        this.recordNumChange = new EventEmitter();
        this.getItemsForThisPage = new EventEmitter();
        this.reloadMoreLogs = new EventEmitter();
        this.calculate = () => {
            this.currentPageItems();
        };
        this.recordNumbersToShow = [5, 10, 20, 50, 100, 150, 200, 250];
        this.noOfRecordsToShow = 50;
        this.onRecordNumSelect = ($event) => {
            if ($event != this.noOfRecordsToShow) {
                this.page = 1;
                if ($event > this.noOfRecordsToShow) {
                    //reload data with more rows
                    this.dataService.display(true);
                    console.log("need to reload data with records ", $event);
                    this.reloadMoreLogs.emit($event);
                }
            }
            this.noOfRecordsToShow = $event;
            this.perPage = $event;
            this.getMin();
            this.totalPages();
            this.getMax();
            this.recordNumChange.emit($event);
            this.currentPageItems();
            //back to page no. 1 to make calculations uniform;
        };
        this.currentPageItems = () => {
            let currentPageI = [];
            this.itemOnthisPage = 0;
            if (this.totalItems != null)
                for (var i = (this.getMin() - 1), max = this.getMax(); i < max; i++) { // add per page calculation
                    if (this.totalItems[i]) {
                        currentPageI.push(this.totalItems[i]);
                        this.itemOnthisPage++;
                    }
                }
            this.currentPage.emit(currentPageI);
        };
        this.currentPageItemsAsPerPageItem = () => {
            this.page; // says u r on page
            let currentPageI = [];
            this.currentPage.emit(currentPageI);
        };
    }
    set items(items) {
        this.totalItems = items;
        // this.page = 1;
        this.calculate();
    }
    ngOnInit() {
        this.properties = this.dataService.getDashboardProperties();
        let recordNum = this.properties ? this.properties.changeLogRecordsToShow : '10,20,50,100,200';
        this.recordNumbersToShow = recordNum.split(",").map(function (n) {
            return Number(n);
        });
    }
    getMin() {
        return 1; //((this.perPage * this.page) - this.perPage) + 1;
    }
    totalPages() {
        //return Math.ceil(this.totalItems.length / this.perPage) || 0;
        return Math.ceil(this.totalRecords / this.perPage) || 0;
    }
    lastPage() {
        //return this.perPage * this.page >= this.totalItems.length;
        return this.perPage * this.page >= this.totalRecords;
    }
    getMax() {
        let max = this.perPage * this.page;
        if (this.totalRecords != null && max > this.totalRecords) {
            max = this.totalRecords;
        }
        return max;
    }
    getPages() {
        // const c = Math.ceil(this.totalItems.length / this.perPage);
        const c = Math.ceil(this.totalRecords / this.perPage);
        const p = this.page || 1;
        const pagesToShow = this.pagesToShow || 9;
        const pages = [];
        pages.push(p);
        const times = pagesToShow - 1;
        for (let i = 0; i < times; i++) {
            if (pages.length < pagesToShow) {
                if (Math.min.apply(null, pages) > 1) {
                    pages.push(Math.min.apply(null, pages) - 1);
                }
            }
            if (pages.length < pagesToShow) {
                if (Math.max.apply(null, pages) < c) {
                    pages.push(Math.max.apply(null, pages) + 1);
                }
            }
        }
        pages.sort((a, b) => a - b);
        return pages;
    }
    onPrev() {
        // this.goPrev.emit(true);
        if (this.page !== 1) {
            this.onPage(this.page - 1); // 
            this.clickEvent.emit({ "event": "onPrev", "page": this.page });
        }
    }
    onNext() {
        // this.goNext.emit(next);
        if (this.page !== this.totalPages()) {
            //next logList fetch from offset:calculate based on (pagenum-1)*noOfRecordsToShow and limit:noOfRecordsToShow
            this.onPage(this.page + 1);
            this.clickEvent.emit({ "event": "onNext", "page": this.page });
        }
    }
    /* showLast = () => {
       this.onPage(this.totalPages());
       this.clickEvent.emit({ "event": "showLast", "page": this.page });
     }
     showFirst = () => {
       this.onPage(1);
       this.clickEvent.emit({ "event": "showFirst", "page": this.page });
     }
   */
    onPage(n) {
        this.page = n;
        this.calculate();
        //seperate call to getchangelog with offset and limit;
        let vals = {};
        vals["limit"] = this.noOfRecordsToShow;
        vals["offset"] = this.noOfRecordsToShow * (n - 1);
        vals["thisPage"] = n;
        this.clickEvent.emit({ "event": "onPage", "page": this.page });
        this.getItemsForThisPage.emit(vals);
    }
}
ChangeLogPaginationComponent.ɵfac = function ChangeLogPaginationComponent_Factory(t) { return new (t || ChangeLogPaginationComponent)(i0.ɵɵdirectiveInject(DataService)); };
ChangeLogPaginationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChangeLogPaginationComponent, selectors: [["app-change-log-pagination"]], inputs: { page: "page", perPage: "perPage", items: "items", pagesToShow: "pagesToShow", loading: "loading", totalRecords: "totalRecords" }, outputs: { clickEvent: "clickEvent", currentPage: "currentPage", recordNumChange: "recordNumChange", getItemsForThisPage: "getItemsForThisPage", reloadMoreLogs: "reloadMoreLogs" }, decls: 1, vars: 1, consts: [["class", "pagination", 4, "ngIf"], [1, "pagination"], [1, "page-totals"], [1, "description"], [1, "dropdown_num"], [1, "showRecord"], [1, "dropdown-num", 3, "selectedItem", "listItems", "onDropdownSelect"], [1, "page-counts"], [1, "numbers"], [1, "link", 3, "disabled", "ngClass", "click"], ["src", "/assets/images/basic/arrow_left.svg", "alt", "Arrow Left"], ["class", "numericButton", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["src", "/assets/images/basic/arrow_right.svg", "alt", "Arrow Right"], [1, "numericButton", 3, "ngClass", "click"]], template: function ChangeLogPaginationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ChangeLogPaginationComponent_div_0_Template, 16, 13, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.totalItems && ctx.totalItems.length > 0);
    } }, directives: [i1$2.NgIf, DropdownSimpleComponent, i1$2.NgClass, i1$2.NgForOf], styles: [".pagination[_ngcontent-%COMP%]{margin:15px 0;display:inline-block;width:100%}.description[_ngcontent-%COMP%]{color:#58585b;font-size:13px;float:left;margin:0 0 0 10px;font-family:ciscoSans;display:inline}.simpleDropdownContainer[_ngcontent-%COMP%]{width:20%!important;display:inline-block!important}.dropdown-num[_ngcontent-%COMP%] > .simpleDropdownContainer[_ngcontent-%COMP%] > .selectedDropdown[_ngcontent-%COMP%]{border-bottom:1px solid #9e9ea2!important;width:20%!important}.simpleDropdownContainer[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]{display:block;padding:4px 4px 0 10px;color:#049fd9!important}.page-counts[_ngcontent-%COMP%]{font-weight:bold;margin-left:10px}.numbers[_ngcontent-%COMP%]{background-color:#fff;border:0;border-radius:1.3em;box-shadow:0 0 2px #00000080;width:auto;float:right;margin-top:20px}.numbers[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{margin:6px 0;border:0;background-color:transparent;display:inline-block;height:100%;padding:0 4px 0 10px;outline:none;color:#4d4d4d;font-size:12px}.numbers[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]:last-child{padding-right:10px}.numbers[_ngcontent-%COMP%] > button.disabled[_ngcontent-%COMP%]{color:#ccc;cursor:not-allowed}.numbers[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]:not(:first-child){border-left:1px solid #dddfe2}.numbers[_ngcontent-%COMP%] > button.numericButton[_ngcontent-%COMP%]{padding:0 10px;color:#049fd9}.numbers[_ngcontent-%COMP%] > button.numericButton.active[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;margin:0;padding-top:6px;padding-bottom:6px;border:0;cursor:default}.numbers[_ngcontent-%COMP%] > button.numericButton.active[_ngcontent-%COMP%] + button[_ngcontent-%COMP%]{border-left:0}.numbers[_ngcontent-%COMP%]{border:none!important;box-shadow:none}.dropdown_num[_ngcontent-%COMP%]{display:inline}.dropdown-num[_ngcontent-%COMP%]{display:inline-block;width:70px}.page-totals[_ngcontent-%COMP%]{display:inline-block;margin-top:20px;color:#58585b;font-size:12px;font-family:ciscoSans;float:left}.simpleDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .simpleDropdownList[_ngcontent-%COMP%]{margin:-106px 4px 0 0}.simpleDropdownContainer[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{color:#049fd9!important;padding:5px!important;font-size:14px!important}.showRecord[_ngcontent-%COMP%]{display:inline-block;font-size:13px!important;margin-right:5px}.selectedDropdown[_ngcontent-%COMP%]{border:none!important;padding:9px 22px!important;height:24px!important;color:#049fd9!important;font-size:14px!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChangeLogPaginationComponent, [{
        type: Component,
        args: [{
                selector: 'app-change-log-pagination',
                templateUrl: './change-log-pagination.component.html',
                styleUrls: ['./change-log-pagination.component.scss']
            }]
    }], function () { return [{ type: DataService }]; }, { page: [{
            type: Input
        }], perPage: [{
            type: Input
        }], items: [{
            type: Input
        }], pagesToShow: [{
            type: Input
        }], loading: [{
            type: Input
        }], totalRecords: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], currentPage: [{
            type: Output
        }], recordNumChange: [{
            type: Output
        }], getItemsForThisPage: [{
            type: Output
        }], reloadMoreLogs: [{
            type: Output
        }] }); })();

class SearchBasicComponent {
    constructor(dataService, loggerService) {
        this.dataService = dataService;
        this.loggerService = loggerService;
        this.unsubscribe$ = new Subject();
        this.searchSkeleton = { name: "string" };
        this.useGlobalSearch = true;
        this.filtered = new EventEmitter();
        this.utils = new Utils(this.loggerService);
        this.subscribeGlobalSearchText = () => {
            if (this.useGlobalSearch) {
                this.dataService
                    .getSearchText(this.unsubscribe$)
                    .subscribe(this.subscribeSearchText);
            }
            else {
                this.setTimeoutObj = null;
            }
        };
        this.subscribeSearchText = (val) => {
            // console.log('search basic text', val);
            this.searchText = this.utils.tokenizeSearchString(val);
            this.setTimeoutObj = null;
            this.setTimeoutObj = setTimeout(() => {
                this.filterData();
            }, 300);
        };
        this.filterData = () => {
            if (!this.searchText || this.searchText.length == 0) {
                this.filtered.emit(this.rawData);
                return;
            }
            const filteredData = [];
            if (this.searchSkeleton && this.rawData) {
                this.rawData.forEach((item) => {
                    // console.log('search item', item);
                    switch (typeof item) {
                        case "object":
                            try {
                                if (this.checkMatch(item)) {
                                    filteredData.push(item);
                                }
                            }
                            catch (e) {
                                //ignore
                            }
                            break;
                        case "string":
                            try {
                                if (this.doStringSearch(item)) {
                                    filteredData.push(item);
                                }
                            }
                            catch (e) {
                                //ignore
                            }
                            break;
                        default:
                            try {
                                if (this.doStringSearch(JSON.stringify(item))) {
                                    filteredData.push(item);
                                }
                            }
                            catch (e) {
                                //ignore
                            }
                            break;
                    }
                });
                this.filtered.emit(filteredData);
            }
        };
        this.checkMatch = (item) => {
            if (this.searchSkeleton &&
                this.searchText &&
                this.searchText.length > 0) {
                let matched = false;
                for (const key in this.searchSkeleton) {
                    // console.log("id", key, "this.searchSkeleton", this.searchSkeleton[key], item[key]);
                    if (key === "customMethod") {
                        matched = this.doCustomSearch(this.searchSkeleton[key], item);
                    }
                    else {
                        if (!item[key])
                            continue;
                        switch (this.searchSkeleton[key]) {
                            case "string":
                                try {
                                    matched = this.doStringSearch(item[key]);
                                }
                                catch (e) {
                                    //ignore
                                }
                                break;
                            case "array":
                                try {
                                    matched = this.doArraySearch(item[key]);
                                }
                                catch (e) {
                                    //ignore
                                }
                                break;
                            case "timestamp":
                                try {
                                    matched = this.doTimestampSearch(item[key]);
                                }
                                catch (e) {
                                    //ignore
                                }
                                break;
                            case "number":
                                try {
                                    matched = this.doStringSearch(item[key].toString());
                                }
                                catch (e) {
                                    //ignore
                                }
                                break;
                            default:
                                break;
                        }
                    }
                    if (matched)
                        break;
                }
                // console.log("item", item, "matched", matched);
                return matched;
            }
            return true;
        };
        this.doCustomSearch = (sourceFunction, item) => {
            switch (typeof sourceFunction) {
                case "function":
                    for (let index = 0, max = this.searchText.length; index < max; index++) {
                        if (this.searchText[index] === "")
                            continue;
                        try {
                            const matched = sourceFunction(this.searchText[index], item);
                            if (matched) {
                                return true;
                            }
                        }
                        catch (e) {
                            //ignore
                        }
                    }
                default:
                    break;
            }
            return false;
        };
        this.doStringSearch = (sourceText) => {
            for (let index = 0, max = this.searchText.length; index < max; index++) {
                if (this.searchText[index] === "")
                    continue;
                //console.log("sourceText", sourceText, "match?", sourceText.toLowerCase().indexOf(this.searchText[index]))
                try {
                    const matched = sourceText.toLowerCase().indexOf(this.searchText[index]) >
                        -1;
                    if (matched) {
                        return true;
                    }
                }
                catch (e) {
                    //ignore
                }
            }
            return false;
        };
        this.doArraySearch = (sourceText) => {
            for (let index = 0, max = this.searchText.length; index < max; index++) {
                if (this.searchText[index] === "")
                    continue;
                // console.log("sourceText", sourceText, "match?", sourceText.toLowerCase().indexOf(this.searchText[index]))
                try {
                    const matched = sourceText
                        .join(",")
                        .toLowerCase()
                        .indexOf(this.searchText[index]) > -1;
                    if (matched) {
                        return true;
                    }
                }
                catch (e) {
                    //ignore
                }
            }
            return false;
        };
        this.doTimestampSearch = (sourceText) => {
            for (let index = 0, max = this.searchText.length; index < max; index++) {
                if (this.searchText[index] === "")
                    continue;
                // console.log("sourceText", sourceText, "match?", sourceText.toLowerCase().indexOf(this.searchText[index]))
                const searchToken = this.searchText[index];
                let matched = false;
                switch (searchToken) {
                    case "now":
                    case "today":
                        try {
                            const sourceDate = new Date(sourceText);
                            const searchDate = new Date();
                            matched =
                                sourceDate.getDate() == searchDate.getDate() &&
                                    sourceDate.getMonth() == searchDate.getMonth() &&
                                    sourceDate.getFullYear() ==
                                        searchDate.getFullYear();
                        }
                        catch (e) {
                            //ignore
                        }
                        break;
                    case "yesterday":
                    case "-1":
                        try {
                            const sourceDate = new Date(sourceText);
                            const searchDate = new Date();
                            searchDate.setDate(searchDate.getDate() - 1);
                            matched =
                                sourceDate.getDate() == searchDate.getDate() &&
                                    sourceDate.getMonth() == searchDate.getMonth() &&
                                    sourceDate.getFullYear() ==
                                        searchDate.getFullYear();
                        }
                        catch (e) {
                            //ignore
                        }
                        break;
                    case "tomorrow":
                    case "1":
                    case "+1":
                        try {
                            const sourceDate = new Date(sourceText);
                            const searchDate = new Date();
                            searchDate.setDate(searchDate.getDate() + 1);
                            matched =
                                sourceDate.getDate() == searchDate.getDate() &&
                                    sourceDate.getMonth() == searchDate.getMonth() &&
                                    sourceDate.getFullYear() ==
                                        searchDate.getFullYear();
                        }
                        catch (e) {
                            //ignore
                        }
                        break;
                    default:
                        try {
                            const searchTokenNumber = parseInt(searchToken);
                            matched =
                                sourceText == searchTokenNumber ||
                                    sourceText.toString().indexOf(searchToken) > -1;
                        }
                        catch (e) {
                            //ignore
                        }
                        break;
                }
                if (matched) {
                    return true;
                }
            }
            return false;
        };
    }
    set shouldUseGlobalSearch(useGlobalSearchVal) {
        this.useGlobalSearch = useGlobalSearchVal;
        this.subscribeGlobalSearchText();
    }
    set customSearchText(searchText) {
        this.subscribeSearchText(searchText);
    }
    set data(bulkData) {
        this.rawData = bulkData;
        this.filtered.emit(this.rawData);
        this.filterData();
    }
    ngOnInit() {
        setTimeout(() => {
            this.subscribeGlobalSearchText();
        }, 10);
    }
    ngOnDestroy() {
        console.log("destory Search basic page");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
SearchBasicComponent.ɵfac = function SearchBasicComponent_Factory(t) { return new (t || SearchBasicComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(LoggerService)); };
SearchBasicComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SearchBasicComponent, selectors: [["lib-search-basic"]], inputs: { searchSkeleton: "searchSkeleton", shouldUseGlobalSearch: "shouldUseGlobalSearch", customSearchText: "customSearchText", data: "data" }, outputs: { filtered: "filtered" }, decls: 0, vars: 0, template: function SearchBasicComponent_Template(rf, ctx) { }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchBasicComponent, [{
        type: Component,
        args: [{
                selector: "lib-search-basic",
                templateUrl: "./search-basic.component.html",
                styleUrls: ["./search-basic.component.css"]
            }]
    }], function () { return [{ type: DataService }, { type: LoggerService }]; }, { searchSkeleton: [{
            type: Input
        }], shouldUseGlobalSearch: [{
            type: Input
        }], customSearchText: [{
            type: Input
        }], data: [{
            type: Input
        }], filtered: [{
            type: Output
        }] }); })();

// In content.html use:
class SafeHtmlPipe {
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}
SafeHtmlPipe.ɵfac = function SafeHtmlPipe_Factory(t) { return new (t || SafeHtmlPipe)(i0.ɵɵdirectiveInject(i1$3.DomSanitizer, 16)); };
SafeHtmlPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "safeHtml", type: SafeHtmlPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafeHtmlPipe, [{
        type: Pipe,
        args: [{ name: "safeHtml" }]
    }], function () { return [{ type: i1$3.DomSanitizer }]; }, null); })();

function DropdownWithSubtitleComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function DropdownWithSubtitleComponent_div_0_div_4_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r6); const item_r4 = restoredCtx.$implicit; const ctx_r5 = i0.ɵɵnextContext(2); return ctx_r5.selectItem(item_r4); });
    i0.ɵɵelement(1, "div", 6);
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelement(3, "div", 7);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵclassMapInterpolate1("each-option ", item_r4.css, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 5, item_r4.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 7, item_r4.message), i0.ɵɵsanitizeHtml);
} }
const _c0$1z = function (a1) { return { "selected": true, "dropdownExpand": a1 }; };
const _c1$D = function (a1) { return { "options": true, "display-none": a1 }; };
function DropdownWithSubtitleComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵlistener("click", function DropdownWithSubtitleComponent_div_0_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.showOptions(); });
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵtemplate(4, DropdownWithSubtitleComponent_div_0_div_4_Template, 5, 9, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$1z, ctx_r0.displayOptions))("innerHTML", i0.ɵɵpipeBind1(2, 4, ctx_r0.selectedItem.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$D, !ctx_r0.displayOptions));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.itemList);
} }
function DropdownWithSubtitleComponent_div_1_div_4_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
} }
function DropdownWithSubtitleComponent_div_1_div_4_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "img", 17);
    i0.ɵɵelementEnd();
} }
function DropdownWithSubtitleComponent_div_1_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, DropdownWithSubtitleComponent_div_1_div_4_div_1_div_1_Template, 1, 0, "div", 11);
    i0.ɵɵtemplate(2, DropdownWithSubtitleComponent_div_1_div_4_div_1_div_2_Template, 2, 0, "div", 12);
    i0.ɵɵelement(3, "div", 13);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelement(5, "div", 14);
    i0.ɵɵpipe(6, "safeHtml");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.selectedItem.name !== item_r10.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.selectedItem.name === item_r10.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 4, item_r10.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(6, 6, item_r10.message), i0.ɵɵsanitizeHtml);
} }
const _c2$m = function (a0) { return { "paddingEmpty": a0 }; };
function DropdownWithSubtitleComponent_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function DropdownWithSubtitleComponent_div_1_div_4_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r16); const item_r10 = restoredCtx.$implicit; const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.selectItem(item_r10); });
    i0.ɵɵtemplate(1, DropdownWithSubtitleComponent_div_1_div_4_div_1_Template, 7, 8, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    i0.ɵɵclassMapInterpolate1("each-option ", item_r10.name, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c2$m, item_r10.name === " - SELECT - "));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r10.name !== " - SELECT - ");
} }
function DropdownWithSubtitleComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵlistener("click", function DropdownWithSubtitleComponent_div_1_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.showOptions(); });
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵtemplate(4, DropdownWithSubtitleComponent_div_1_div_4_Template, 2, 7, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$1z, ctx_r1.displayOptions))("innerHTML", i0.ɵɵpipeBind1(2, 4, ctx_r1.selectedItem.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$D, !ctx_r1.displayOptions));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.itemList);
} }
function DropdownWithSubtitleComponent_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function DropdownWithSubtitleComponent_div_2_div_4_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r22); const item_r20 = restoredCtx.$implicit; const ctx_r21 = i0.ɵɵnextContext(2); return ctx_r21.selectItem(item_r20); });
    i0.ɵɵelement(1, "div", 6);
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelement(3, "div", 7);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = ctx.$implicit;
    i0.ɵɵclassMapInterpolate1("each-option ", item_r20.css, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 5, item_r20.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 7, item_r20.countryCode), i0.ɵɵsanitizeHtml);
} }
function DropdownWithSubtitleComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵlistener("click", function DropdownWithSubtitleComponent_div_2_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.showOptions(); });
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵtemplate(4, DropdownWithSubtitleComponent_div_2_div_4_Template, 5, 9, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$1z, ctx_r2.displayOptions))("innerHTML", i0.ɵɵpipeBind1(2, 4, ctx_r2.selectedItem.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$D, !ctx_r2.displayOptions));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.itemList);
} }
class DropdownWithSubtitleComponent {
    constructor() {
        this.displayOptions = false;
        this.emitSelection = new EventEmitter();
        this.selectedItem = { name: "" };
        this.showOptions = () => {
            this.displayOptions = !this.displayOptions;
        };
        this.selectItem = (item) => {
            if (item.selectable || item.selectable == undefined) {
                this.selectedItem = item;
                this.displayOptions = false;
                this.emitSelection.emit(item);
            }
        };
    }
    ngOnInit() {
        // console.log("dropdown with subtitle :: ");
        if (this.type == "authentication") {
            if (this.itemList &&
                this.itemList.length > 0 &&
                this.itemList[0].id == "select") {
                for (const item of this.itemList) {
                    if (item.id == this.selectedItemValue) {
                        this.selectedItem = item;
                    }
                }
            }
        }
    }
}
DropdownWithSubtitleComponent.ɵfac = function DropdownWithSubtitleComponent_Factory(t) { return new (t || DropdownWithSubtitleComponent)(); };
DropdownWithSubtitleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DropdownWithSubtitleComponent, selectors: [["app-dropdown-with-subtitle"]], inputs: { itemList: "itemList", type: "type", selectedItemValue: "selectedItemValue" }, outputs: { emitSelection: "emitSelection" }, decls: 3, vars: 3, consts: [["class", "dropdown", 4, "ngIf"], [1, "dropdown"], [3, "ngClass", "innerHTML", "click"], [3, "ngClass"], [3, "class", "click", 4, "ngFor", "ngForOf"], [3, "click"], [1, "item-name", 3, "innerHTML"], [1, "item-message", 3, "innerHTML"], [3, "class", "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "click"], [4, "ngIf"], ["class", "unSelectedItem", 4, "ngIf"], ["class", "selectedItem", 4, "ngIf"], [1, "item-name", "tableCell", 3, "innerHTML"], [1, "item-message", "paddingLeft", 3, "innerHTML"], [1, "unSelectedItem"], [1, "selectedItem"], ["src", "/assets/images/completed_tick_mark.svg"]], template: function DropdownWithSubtitleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DropdownWithSubtitleComponent_div_0_Template, 5, 10, "div", 0);
        i0.ɵɵtemplate(1, DropdownWithSubtitleComponent_div_1_Template, 5, 10, "div", 0);
        i0.ɵɵtemplate(2, DropdownWithSubtitleComponent_div_2_Template, 5, 10, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.itemList && ctx.type !== "authentication" && ctx.type !== "countrySelection");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.itemList && ctx.type === "authentication");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.itemList && ctx.type === "countrySelection");
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i1$2.NgForOf], pipes: [SafeHtmlPipe], styles: [".dropdown[_ngcontent-%COMP%]{position:relative}.selected[_ngcontent-%COMP%]{border:none;width:100%;height:44px;font-size:16px;padding:10px;font-weight:normal;font-family:\"ciscoSansLight\";color:#7b7b7b;text-align:left;margin-bottom:10px;border:1px solid #dddfe2;cursor:pointer}.selected.dropdownExpand[_ngcontent-%COMP%]{border-color:#049fd9}.selected[_ngcontent-%COMP%]:before{width:12px;height:12px;color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;bottom:12px;right:10px;padding:4px;font-size:14px;display:block;content:\"\\e905\"}.selected.dropdownExpand[_ngcontent-%COMP%]:before{content:\"\\e908\"}.options[_ngcontent-%COMP%]{width:100%;position:absolute;top:100%;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:1003;background-color:#fff;box-shadow:5px 5px 20px #888}.each-option[_ngcontent-%COMP%]{display:block;padding:8px 10px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.each-option[_ngcontent-%COMP%]:hover{background-color:#eaeaea}.item-name[_ngcontent-%COMP%]{font-size:18px}.item-message[_ngcontent-%COMP%]{font-size:x-small;font-style:italic}.active[_ngcontent-%COMP%]{cursor:pointer}.inactive[_ngcontent-%COMP%]{cursor:not-allowed}.active[_ngcontent-%COMP%]   .item-message[_ngcontent-%COMP%]{color:green}.inactive[_ngcontent-%COMP%]   .item-message[_ngcontent-%COMP%]{color:red}.inactive-clickable[_ngcontent-%COMP%]{cursor:pointer}.inactive-clickable[_ngcontent-%COMP%]   .item-message[_ngcontent-%COMP%]{color:red}.selectedItem[_ngcontent-%COMP%]{display:table-cell;width:40px;height:40px;vertical-align:middle}.paddingLeft[_ngcontent-%COMP%]{padding-left:40px}.unSelectedItem[_ngcontent-%COMP%]{display:table-cell;height:40px;vertical-align:middle;padding-left:40px}.tableCell[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.paddingEmpty[_ngcontent-%COMP%]{padding:0!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownWithSubtitleComponent, [{
        type: Component,
        args: [{
                selector: "app-dropdown-with-subtitle",
                templateUrl: "./dropdown-with-subtitle.component.html",
                styleUrls: ["./dropdown-with-subtitle.component.css"]
            }]
    }], function () { return []; }, { itemList: [{
            type: Input
        }], type: [{
            type: Input
        }], selectedItemValue: [{
            type: Input
        }], emitSelection: [{
            type: Output
        }] }); })();

function VerifyPhoneNumberComponent_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.errorMessage, " ");
} }
function VerifyPhoneNumberComponent_div_7_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1, " Mobile number is required and should be valid ");
    i0.ɵɵelementEnd();
} }
const _c0$1y = function () { return []; };
function VerifyPhoneNumberComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, VerifyPhoneNumberComponent_div_7_div_1_Template, 2, 1, "div", 7);
    i0.ɵɵelementStart(2, "div", 8);
    i0.ɵɵelementStart(3, "label", 9);
    i0.ɵɵtext(4, " You have not verfied your mobile number yet. Please verify your mobile number. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10);
    i0.ɵɵelementStart(6, "label", 11);
    i0.ɵɵtext(7, "Mobile Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 12);
    i0.ɵɵelementStart(9, "international-phone-number", 13, 14);
    i0.ɵɵlistener("ngModelChange", function VerifyPhoneNumberComponent_div_7_Template_international_phone_number_ngModelChange_9_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.phoneNumberValue = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, VerifyPhoneNumberComponent_div_7_div_11_Template, 2, 0, "div", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "p", 16);
    i0.ɵɵtext(13, " We will send you a ");
    i0.ɵɵelementStart(14, "b");
    i0.ɵɵtext(15, "One Time Password ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(16, "on this mobile number ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "button", 17);
    i0.ɵɵlistener("click", function VerifyPhoneNumberComponent_div_7_Template_button_click_17_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.sendOtp(); });
    i0.ɵɵtext(18, " Get One Time Password ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r3 = i0.ɵɵreference(10);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.errorMessage.length > 0);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngModel", ctx_r0.phoneNumberValue)("maxlength", 15)("required", true)("allowedCountries", i0.ɵɵpureFunction0(7, _c0$1y));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.phoneNumberValue && !_r3.valid);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("disabled", !_r3.valid);
} }
function VerifyPhoneNumberComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵelementStart(2, "label", 21);
    i0.ɵɵtext(3, " Verify mobile number ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 22);
    i0.ɵɵelementStart(5, "p", 23);
    i0.ɵɵtext(6, " Enter the OTP sent to ");
    i0.ɵɵelementStart(7, "b");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 24);
    i0.ɵɵelementStart(10, "label", 11);
    i0.ɵɵtext(11, "OTP");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "input", 25);
    i0.ɵɵlistener("input", function VerifyPhoneNumberComponent_div_8_Template_input_input_12_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.otp = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 26);
    i0.ɵɵtext(14, "Don\u2019t receive the OTP? ");
    i0.ɵɵelementStart(15, "button", 27);
    i0.ɵɵlistener("click", function VerifyPhoneNumberComponent_div_8_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.sendOtp(); });
    i0.ɵɵtext(16, " Resend OTP ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "button", 28);
    i0.ɵɵlistener("click", function VerifyPhoneNumberComponent_div_8_Template_button_click_17_listener() { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.verifyOtp(); });
    i0.ɵɵtext(18, " Verify ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(ctx_r1.phones);
} }
class VerifyPhoneNumberComponent {
    constructor(dataService, authService, interactionService) {
        this.dataService = dataService;
        this.authService = authService;
        this.interactionService = interactionService;
        this.hideVerificationPopup = new EventEmitter();
        this.errorMessage = "";
        this.sendOtpButton = true;
        this.otp = "";
        this.req = {
            email: "",
            phoneNumber: "",
            otp: ""
        };
        this.phoneForm = new FormGroup({
            phonecontrol: new FormControl(undefined, [Validators.required])
        });
        this.sendOtp = () => {
            const userNameForInteractionLog = this.dataService.getUserName();
            const logStr = "VIEW: User " +
                userNameForInteractionLog +
                " has clicked on send OTP in verify profile number popup";
            this.interactionService.doInteractionLog(new InteractionLog(TYPE.SEND, this.dataService.getPosition(), "{}", SECTION.VERIFY_PHONE_NUMBER, ITEM_TYPE.POPUP, ITEM.VERIFY_PHONE_NUMBER, logStr, this.dataService.getCurrentNav()));
            if (this.phoneNumberValue == null) {
                this.errorMessage = "Invalid mobile number";
            }
            else {
                this.dataService.display(true);
                this.req["email"] = this.email;
                this.req["phoneNumber"] = this.phoneNumberValue;
                this.phones = this.phoneNumberValue;
                this.authService.sendOTP(this.req).subscribe((response) => {
                    if (response != null &&
                        response.message ===
                            "OTP has send to your mobile successfully") {
                        const logStr = "VIEW: User " +
                            userNameForInteractionLog +
                            " OTP has send to user";
                        this.interactionService.doInteractionLog(new InteractionLog(TYPE.VIEW, this.dataService.getPosition(), "{}", SECTION.VERIFY_PHONE_NUMBER, ITEM_TYPE.POPUP, ITEM.VERIFY_PHONE_NUMBER, logStr, this.dataService.getCurrentNav()));
                        this.dataService.setToastMessage(response.message, 4000, null, null, "success");
                        this.errorMessage = "";
                        this.sendOtpButton = false;
                    }
                    else {
                        const logStr = "VIEW: User " +
                            userNameForInteractionLog +
                            " OTP has not send to user";
                        this.interactionService.doInteractionLog(new InteractionLog(TYPE.VIEW, this.dataService.getPosition(), "{}", SECTION.VERIFY_PHONE_NUMBER, ITEM_TYPE.POPUP, ITEM.VERIFY_PHONE_NUMBER, logStr, this.dataService.getCurrentNav()));
                        this.errorMessage =
                            "Error occured while sending OTP to end user";
                    }
                    this.dataService.display(false);
                }, (error) => {
                    this.dataService.display(false);
                    this.errorMessage =
                        "Error occured while sending OTP to end user";
                    console.log(error);
                });
            }
        };
        this.verifyOtp = () => {
            const userNameForInteractionLog = this.dataService.getUserName();
            this.dataService.display(true);
            this.req["email"] = this.email;
            this.req["phoneNumber"] = this.phoneNumberValue;
            this.req["otp"] = this.otp;
            this.authService.verifyOTP(this.req).subscribe((response) => {
                if (response != null && response.message === "OTP verified successfully") {
                    const logStr = "VIEW: User " +
                        userNameForInteractionLog +
                        " OTP has verified successfully";
                    this.interactionService.doInteractionLog(new InteractionLog(TYPE.VIEW, this.dataService.getPosition(), "{}", SECTION.VERIFY_PHONE_NUMBER, ITEM_TYPE.POPUP, ITEM.VERIFY_PHONE_NUMBER, logStr, this.dataService.getCurrentNav()));
                    console.log("verify otp response is:: " + JSON.stringify(response));
                    this.dataService.setToastMessage(response.message, 4000, null, null, "success");
                    this.errorMessage = "";
                    this.onHidePopup(this.phoneNumberValue);
                }
                else {
                    this.dataService.setToastMessage(response.message, 4000, null, null, "error");
                }
                this.dataService.display(false);
            }, (error) => {
                const logStr = "VIEW: User " +
                    userNameForInteractionLog +
                    " OTP has not verified successfully";
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.VIEW, this.dataService.getPosition(), "{}", SECTION.VERIFY_PHONE_NUMBER, ITEM_TYPE.POPUP, ITEM.VERIFY_PHONE_NUMBER, logStr, this.dataService.getCurrentNav()));
                this.dataService.display(false);
                this.errorMessage =
                    "Error occured while verifing OTP to end user";
                console.log(error);
            });
        };
        this.onHidePopup = (number) => {
            this.hideVerificationPopup.emit({ number });
        };
    }
    ngOnInit() {
        const userNameForInteractionLog = this.dataService.getUserName();
        const logStr = "VIEW: User " +
            userNameForInteractionLog +
            " has viewed verify profile number popup";
        this.interactionService.doInteractionLog(new InteractionLog(TYPE.VIEW, this.dataService.getPosition(), "{}", SECTION.VERIFY_PHONE_NUMBER, ITEM_TYPE.POPUP, ITEM.VERIFY_PHONE_NUMBER, logStr, this.dataService.getCurrentNav()));
        this.phoneNumberValue = this.phones;
    }
    ngAfterViewInit() {
        jQuery("div.input-group").css({ width: "120%" });
        jQuery("input[type=text].form-control").css({
            padding: "0px",
            width: "320px"
        });
    }
}
VerifyPhoneNumberComponent.ɵfac = function VerifyPhoneNumberComponent_Factory(t) { return new (t || VerifyPhoneNumberComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(InteractionService)); };
VerifyPhoneNumberComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VerifyPhoneNumberComponent, selectors: [["app-verify-phone-number"]], inputs: { email: "email", phones: "phones" }, outputs: { hideVerificationPopup: "hideVerificationPopup" }, decls: 9, vars: 2, consts: [[1, "modalPopup", "modalPopupSm", "verifyMobilePopup"], [1, "modalOverlay"], [1, "modalContent"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], ["class", "modalBody customModalBody", 4, "ngIf"], [1, "modalBody", "customModalBody"], ["class", "formInlineError", 4, "ngIf"], [1, "mainTest"], [1, "mainTextlabel"], [1, "sectionDiv", "phoneNumberDiv"], [1, "nameLabel"], [1, "intlPhnoDiv"], ["placeholder", "Enter mobile number", "name", "phoneNumberValue", 3, "ngModel", "maxlength", "required", "allowedCountries", "ngModelChange"], ["phoneNumber", "ngModel"], ["class", "errorDiv", 4, "ngIf"], [2, "color", "#58585b"], [1, "primaryButton", "sectionDiv", "otpBtn", 3, "disabled", "click"], [1, "formInlineError"], [1, "errorDiv"], [1, "mainTest", "verifyNumberLabels"], [1, "mainTextlabel", "verifyphoneNumber"], [1, "mainTest", "otpValueTest"], [1, "otpValueLabel"], [1, "sectionDiv"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter OTP", "id", "otp", 1, "textInput", 3, "input"], [1, "otpSpan"], [1, "cancelButton", "verifyNumber", 3, "click"], [1, "primaryButton", "sectionDiv", "verifiedBtn", 3, "click"]], template: function VerifyPhoneNumberComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4, " Verify Mobile Number ");
        i0.ɵɵelementStart(5, "span", 4);
        i0.ɵɵlistener("click", function VerifyPhoneNumberComponent_Template_span_click_5_listener() { return ctx.onHidePopup("null"); });
        i0.ɵɵtext(6, "\uE909");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, VerifyPhoneNumberComponent_div_7_Template, 19, 8, "div", 5);
        i0.ɵɵtemplate(8, VerifyPhoneNumberComponent_div_8_Template, 19, 1, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.sendOtpButton);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.sendOtpButton);
    } }, directives: [i1$2.NgIf, i5.PhoneNumberComponent, i2$1.NgControlStatus, i2$1.NgModel, i2$1.MaxLengthValidator, i2$1.RequiredValidator], styles: [".modalPopup.verifyMobilePopup[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{top:5%;width:95%;bottom:0%}.modalPopup.verifyMobilePopup[_ngcontent-%COMP%] > div.modalContent[_ngcontent-%COMP%] > div.modalBody[_ngcontent-%COMP%]{height:440px}.modalPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{background-color:#fff;margin-bottom:45px}.modalBody[_ngcontent-%COMP%]{margin-left:200px;padding:10px 0!important}.customModalBody[_ngcontent-%COMP%]{padding:5%!important;margin-left:30%!important;margin-top:5%!important;width:35%!important}.sectionDiv[_ngcontent-%COMP%]{margin-top:20px;display:flex;flex-direction:column}.phoneNumberDiv[_ngcontent-%COMP%]{width:310px}.nameLabel[_ngcontent-%COMP%]{font-family:ciscoSansLight;color:#58585b;font-size:16px}.mainTextlabel[_ngcontent-%COMP%]{font-size:20px;color:#58585b}.primaryButton[_ngcontent-%COMP%]{width:100%;text-align:-webkit-center}.verifyNumberLabels[_ngcontent-%COMP%]{text-align:center}.otpValueTest[_ngcontent-%COMP%]{margin-top:10px;text-align:center}.otpValueLabel[_ngcontent-%COMP%]{font-size:20px!important;color:#585849;font-family:ciscoSansLight}.verifyphoneNumber[_ngcontent-%COMP%]{font-size:24px!important}.otpSpan[_ngcontent-%COMP%]{margin-left:50px;font-family:ciscoSansLight;color:#585849}.cancelButton[_ngcontent-%COMP%]{padding:0!important;margin:auto}.intlPhnoDiv[_ngcontent-%COMP%]{padding-top:10px}.errorDiv[_ngcontent-%COMP%]{color:red;font-size:12px}.primaryButton[_ngcontent-%COMP%]:disabled{opacity:.3;cursor:not-allowed;pointer-events:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VerifyPhoneNumberComponent, [{
        type: Component,
        args: [{
                // eslint-disable-next-line @angular-eslint/component-selector
                selector: "app-verify-phone-number",
                templateUrl: "./verify-phone-number.component.html",
                styleUrls: ["./verify-phone-number.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: AuthService }, { type: InteractionService }]; }, { email: [{
            type: Input
        }], phones: [{
            type: Input
        }], hideVerificationPopup: [{
            type: Output
        }] }); })();

function UpdateProfilePopupComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "label", 20);
    i0.ɵɵtext(2, " You have not updated your First Name and Last Name yet, Please update! ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function UpdateProfilePopupComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.errorMessage, " ");
} }
function UpdateProfilePopupComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "label", 10);
    i0.ɵɵtext(2, "Email");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r2.email);
} }
const _c0$1x = function () { return []; };
function UpdateProfilePopupComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "label", 10);
    i0.ɵɵtext(2, "Mobile Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 25);
    i0.ɵɵelementStart(4, "international-phone-number", 26, 27);
    i0.ɵɵlistener("ngModelChange", function UpdateProfilePopupComponent_div_19_Template_international_phone_number_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.phoneNumberModal = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r3.phoneNumberModal)("maxlength", 15)("required", true)("allowedCountries", i0.ɵɵpureFunction0(4, _c0$1x));
} }
function UpdateProfilePopupComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "label", 10);
    i0.ɵɵtext(2, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "app-dropdown-with-subtitle", 29);
    i0.ɵɵlistener("emitSelection", function UpdateProfilePopupComponent_div_20_Template_app_dropdown_with_subtitle_emitSelection_3_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.selectCountry($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", "countrySelection")("selectedItemValue", ctx_r4.countryList[0].name)("itemList", ctx_r4.countryList);
} }
function UpdateProfilePopupComponent_button_24_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵlistener("click", function UpdateProfilePopupComponent_button_24_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onHidePopup($event); });
    i0.ɵɵtext(1, " Cancel ");
    i0.ɵɵelementEnd();
} }
function UpdateProfilePopupComponent_button_25_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵlistener("click", function UpdateProfilePopupComponent_button_25_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.onHidePopup($event); });
    i0.ɵɵtext(1, " Skip & Continue ");
    i0.ɵɵelementEnd();
} }
function UpdateProfilePopupComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "app-verify-phone-number", 32);
    i0.ɵɵlistener("hideVerificationPopup", function UpdateProfilePopupComponent_div_26_Template_app_verify_phone_number_hideVerificationPopup_1_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.onHideVerificationPopup($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("email", ctx_r7.email)("phones", ctx_r7.phoneNumberModal);
} }
class UpdateProfilePopupComponent {
    constructor(dataService, authService, interactionService, translate, userService) {
        this.dataService = dataService;
        this.authService = authService;
        this.interactionService = interactionService;
        this.translate = translate;
        this.userService = userService;
        this.unsubscribe$ = new Subject();
        this.hideProfilePopup = new EventEmitter();
        this.req = {
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: ""
        };
        this.errorMessage = "";
        this.isphoneNumberverify = false;
        this.messageKeys = {};
        this.countrySelected = '';
        this.isCountryRequired = false;
        this.phoneForm = new FormGroup({
            phone: new FormControl(undefined, [Validators.required])
        });
        this.getUserDetail = () => {
            this.dataService.display(true);
            this.authService.getProfile(this.email).subscribe((response) => {
                if (response != null) {
                    this.phoneNumberInput = response.data.phone;
                    this.phoneNumberModal = this.phoneNumberInput;
                }
                this.dataService.display(false);
            }, (error) => {
                this.dataService.display(false);
                console.log(error);
            });
        };
        this.onSave = (event) => {
            if (!this.firstName || !this.lastName || !this.email) {
                this.errorMessage =
                    "Error occured while updating profile information";
                return;
            }
            this.req["firstName"] = this.firstName;
            this.req["lastName"] = this.lastName;
            this.req["email"] = this.email;
            if (this.countrySelected !== '')
                this.req["country"] = this.countrySelected;
            if (this.phoneNumberModal == null) {
                this.req["phoneNumber"] = "";
            }
            else {
                this.req["phoneNumber"] = this.phoneNumberModal;
            }
            this.dataService.display(true);
            this.authService.updateProfile(this.req).subscribe((response) => {
                if (response.status) {
                    const userNameForInteractionLog = this.dataService.getUserName();
                    const logStr = "EDIT:User " +
                        userNameForInteractionLog +
                        " has updated the profile";
                    this.interactionService.doInteractionLog(new InteractionLog(TYPE.EDIT, this.dataService.getPosition(), "{}", SECTION.UPDATE_PROFILE, ITEM_TYPE.POPUP, ITEM.UPDATE_PROFILE, logStr, this.dataService.getCurrentNav()));
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys['user.userdetail.update.success'], 4000, null, null, "success");
                    this.hideProfilePopup.emit();
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys['user.userdetail.update.error.failed'], 4000, null, null, "error");
                }
            }, (error) => {
                this.dataService.display(false);
                this.errorMessage =
                    this.messageKeys["errorOccurred"];
                console.log(error);
            });
        };
        this.onHidePopup = (event) => {
            const userNameForInteractionLog = this.dataService.getUserName();
            const logStr = "User " + userNameForInteractionLog + "Has cancelled the popup ";
            this.interactionService.doInteractionLog(new InteractionLog(TYPE.CLOSE, this.dataService.getPosition(), "{}", SECTION.UPDATE_PROFILE, ITEM_TYPE.POPUP, ITEM.UPDATE_PROFILE, logStr, this.dataService.getCurrentNav()));
            this.hideProfilePopup.emit();
        };
        this.onClickVerification = (event) => {
            this.isphoneNumberverify = true;
        };
        this.onHideVerificationPopup = (event) => {
            this.isphoneNumberverify = false;
            if (event["number"] != null && event["number"] !== "null") {
                this.phoneNumberModal = event["number"];
            }
        };
        this.allowCharacters = ($event) => {
            if (($event.keyCode >= 65 && $event.keyCode <= 90) ||
                $event.keyCode == 8 ||
                $event.keyCode == 32 ||
                $event.keyCode == 190) {
                return true;
            }
            else {
                return false;
            }
        };
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.user-api-management.update-user.email-invalid').subscribe((res) => {
                this.messageKeys["user.userdetail.update.error.email.invalid"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.update-user.name-empty').subscribe((res) => {
                this.messageKeys["user.userdetail.update.error.name.empty"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.update-user.first-name').subscribe((res) => {
                this.messageKeys["user.userdetail.update.error.fname.empty"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.update-user.last-name').subscribe((res) => {
                this.messageKeys["user.userdetail.update.error.lname.empty"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.update-user.success').subscribe((res) => {
                this.messageKeys["user.userdetail.update.success"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.update-user.failed').subscribe((res) => {
                this.messageKeys["user.userdetail.update.error.failed"] = res;
            });
            // errorOccurred
            this.translate.get('dashboard-lib.user-api-management.update-user.error').subscribe((res) => {
                this.messageKeys["errorOccurred"] = res;
            });
        };
        this.selectCountry = ($event) => {
            this.countrySelected = $event.countryCode;
        };
    }
    ngOnInit() {
        const userNameForInteractionLog = this.dataService.getUserName();
        const logStr = "VIEW: User " +
            userNameForInteractionLog +
            " has viewed update profile popup";
        this.interactionService.doInteractionLog(new InteractionLog(TYPE.VIEW, this.dataService.getPosition(), "{}", SECTION.UPDATE_PROFILE, ITEM_TYPE.POPUP, ITEM.UPDATE_PROFILE, logStr, this.dataService.getCurrentNav()));
        if (this.phoneNumberInput == null || this.phoneNumberInput === "") {
            this.getUserDetail();
        }
        else {
            this.phoneNumberModal = this.phoneNumberInput;
        }
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
        this.countrySelected = '';
        this.isCountryRequired = this.dataService.getCountryCodeRequired();
        if (this.isCountryRequired) {
            this.userService.getCountryCodeList().pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                if (response && response.data) {
                    this.countryList = response.data.countryCode;
                    console.log("country list is ", this.countryList);
                    this.dataService.display(false);
                }
                else {
                    //failed to fetch country list continue work flow??
                }
            });
        }
    }
    ngAfterViewInit() {
        jQuery("div.input-group").css({ width: "100%" });
        jQuery("input[type=text].form-control").css({
            padding: "0px",
            width: "240px"
        });
    }
}
UpdateProfilePopupComponent.ɵfac = function UpdateProfilePopupComponent_Factory(t) { return new (t || UpdateProfilePopupComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(InteractionService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(UserService)); };
UpdateProfilePopupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UpdateProfilePopupComponent, selectors: [["lib-update-profile-popup"]], inputs: { email: "email", firstName: "firstName", lastName: "lastName", phoneNumberInput: "phoneNumberInput", fromPage: "fromPage" }, outputs: { hideProfilePopup: "hideProfilePopup" }, decls: 27, vars: 10, consts: [[1, "modalPopup", "modalPopupSm", "updateProfilePopup"], [1, "modalOverlay"], [1, "modalContent"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], ["class", "mainTest", 4, "ngIf"], ["class", "formInlineError", 4, "ngIf"], ["class", "sectionDiv disabled", 4, "ngIf"], [1, "sectionDiv"], [1, "nameLabel"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter your first name", "id", "firstName", 1, "textInput", 3, "value", "input", "keydown"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter your last name", "id", "lastName", 1, "textInput", 3, "value", "input", "keydown"], ["class", "sectionDiv phoneNumberDiv", 4, "ngIf"], ["class", "sectionDiv_country sectionDiv", 4, "ngIf"], [1, "modalFooter"], [1, "primaryButton", 3, "click"], ["class", "cancelButton", 3, "click", 4, "ngIf"], ["class", "updateProfileBox", 4, "ngIf"], [1, "mainTest"], [1, "mainTextlabel"], [1, "formInlineError"], [1, "sectionDiv", "disabled"], ["type", "text", "autofocus", "autofocus", "id", "email", "disabled", "", 1, "textInput", 3, "value"], [1, "sectionDiv", "phoneNumberDiv"], [1, "intlPhnoDiv"], ["placeholder", "Enter mobile number", "name", "phoneNumberModal", 3, "ngModel", "maxlength", "required", "allowedCountries", "ngModelChange"], ["phoneNumber", "ngModel"], [1, "sectionDiv_country", "sectionDiv"], [3, "type", "selectedItemValue", "itemList", "emitSelection"], [1, "cancelButton", 3, "click"], [1, "updateProfileBox"], [3, "email", "phones", "hideVerificationPopup"]], template: function UpdateProfilePopupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4, " Update Profile Information ");
        i0.ɵɵelementStart(5, "span", 4);
        i0.ɵɵlistener("click", function UpdateProfilePopupComponent_Template_span_click_5_listener($event) { return ctx.onHidePopup($event); });
        i0.ɵɵtext(6, "\uE909");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, UpdateProfilePopupComponent_div_8_Template, 3, 0, "div", 6);
        i0.ɵɵtemplate(9, UpdateProfilePopupComponent_div_9_Template, 2, 1, "div", 7);
        i0.ɵɵtemplate(10, UpdateProfilePopupComponent_div_10_Template, 4, 1, "div", 8);
        i0.ɵɵelementStart(11, "div", 9);
        i0.ɵɵelementStart(12, "label", 10);
        i0.ɵɵtext(13, "First Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "input", 11);
        i0.ɵɵlistener("input", function UpdateProfilePopupComponent_Template_input_input_14_listener($event) { return ctx.firstName = $event.target ? $event.target["value"] : ""; })("keydown", function UpdateProfilePopupComponent_Template_input_keydown_14_listener($event) { return ctx.allowCharacters($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 9);
        i0.ɵɵelementStart(16, "label", 10);
        i0.ɵɵtext(17, "Last Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "input", 12);
        i0.ɵɵlistener("input", function UpdateProfilePopupComponent_Template_input_input_18_listener($event) { return ctx.lastName = $event.target ? $event.target["value"] : ""; })("keydown", function UpdateProfilePopupComponent_Template_input_keydown_18_listener($event) { return ctx.allowCharacters($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(19, UpdateProfilePopupComponent_div_19_Template, 6, 5, "div", 13);
        i0.ɵɵtemplate(20, UpdateProfilePopupComponent_div_20_Template, 4, 3, "div", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 15);
        i0.ɵɵelementStart(22, "button", 16);
        i0.ɵɵlistener("click", function UpdateProfilePopupComponent_Template_button_click_22_listener($event) { return ctx.onSave($event); });
        i0.ɵɵtext(23, "Save");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(24, UpdateProfilePopupComponent_button_24_Template, 2, 0, "button", 17);
        i0.ɵɵtemplate(25, UpdateProfilePopupComponent_button_25_Template, 2, 0, "button", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(26, UpdateProfilePopupComponent_div_26_Template, 2, 2, "div", 18);
    } if (rf & 2) {
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", ctx.fromPage === "login");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errorMessage.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fromPage === "account");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("value", ctx.firstName);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("value", ctx.lastName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fromPage === "account");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isCountryRequired && ctx.countryList !== undefined);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.fromPage === "account");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fromPage !== "account");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isphoneNumberverify);
    } }, directives: [i1$2.NgIf, i5.PhoneNumberComponent, i2$1.NgControlStatus, i2$1.NgModel, i2$1.MaxLengthValidator, i2$1.RequiredValidator, DropdownWithSubtitleComponent, VerifyPhoneNumberComponent], styles: [".modalPopup.updateProfilePopup[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{top:20%;width:50%}.modalPopup.updateProfilePopup[_ngcontent-%COMP%] > div.modalContent[_ngcontent-%COMP%] > div.modalBody[_ngcontent-%COMP%]{height:440px}.modalPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{background-color:#fff;margin-bottom:45px}.modalBody[_ngcontent-%COMP%]{margin-left:200px;padding:10px 0!important;margin-top:30px}.mainTest[_ngcontent-%COMP%]{margin-top:25px;margin-bottom:10px;width:50%}label.mainTextlabel[_ngcontent-%COMP%]{display:block;font-size:18px;font-weight:700}.sectionDiv[_ngcontent-%COMP%]{display:flex;flex-direction:column}.sectionDiv[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{max-width:280px}.nameLabel[_ngcontent-%COMP%]{font-family:ciscoSansLight;color:#58585b;font-size:12px}.disabled[_ngcontent-%COMP%]{opacity:.3;cursor:not-allowed;pointer-events:none}.verifyNumber[_ngcontent-%COMP%]{display:flex;margin-left:100px}.phoneNumberDiv[_ngcontent-%COMP%]{width:310px}.textInput[_ngcontent-%COMP%]{font-family:ciscoSansLight;color:#000;font-size:16px;padding:2px}.form-control[_ngcontent-%COMP%]{width:90%!important}.intl-tel-input[_ngcontent-%COMP%]{display:block!important}.intlPhnoDiv[_ngcontent-%COMP%]{padding-top:10px}.errorDiv[_ngcontent-%COMP%]{color:red;font-size:12px}.cancelButton[_ngcontent-%COMP%]:disabled{opacity:.3;cursor:not-allowed;pointer-events:none}.sectionDiv_country[_ngcontent-%COMP%]{width:40%!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateProfilePopupComponent, [{
        type: Component,
        args: [{
                selector: "lib-update-profile-popup",
                templateUrl: "./update-profile-popup.component.html",
                styleUrls: ["./update-profile-popup.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: AuthService }, { type: InteractionService }, { type: i2.TranslateService }, { type: UserService }]; }, { email: [{
            type: Input
        }], firstName: [{
            type: Input
        }], lastName: [{
            type: Input
        }], phoneNumberInput: [{
            type: Input
        }], fromPage: [{
            type: Input
        }], hideProfilePopup: [{
            type: Output
        }] }); })();

function ChangeLogDetailComponent_tbody_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 9);
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵelementStart(2, "td");
    i0.ɵɵelementStart(3, "span", 10);
    i0.ɵɵtext(4, "Time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵelementStart(6, "span", 10);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "tr");
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵelementStart(10, "span", 10);
    i0.ɵɵtext(11, "Activity");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td");
    i0.ɵɵelementStart(13, "span", 10);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "tr");
    i0.ɵɵelementStart(16, "td");
    i0.ɵɵelementStart(17, "span", 10);
    i0.ɵɵtext(18, " App");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "td");
    i0.ɵɵelementStart(20, "span", 10);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "tr");
    i0.ɵɵelementStart(23, "td");
    i0.ɵɵelementStart(24, "span", 10);
    i0.ɵɵtext(25, "Section");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "td");
    i0.ɵɵelementStart(27, "span", 10);
    i0.ɵɵtext(28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "tr");
    i0.ɵɵelementStart(30, "td");
    i0.ɵɵelementStart(31, "span", 10);
    i0.ɵɵtext(32, "Email");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "td");
    i0.ɵɵelementStart(34, "span", 10);
    i0.ɵɵtext(35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "tr");
    i0.ɵɵelementStart(37, "td");
    i0.ɵɵelementStart(38, "span", 10);
    i0.ɵɵtext(39, "Old value");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "td");
    i0.ɵɵelementStart(41, "span", 10);
    i0.ɵɵtext(42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "tr");
    i0.ɵɵelementStart(44, "td");
    i0.ɵɵelementStart(45, "span", 10);
    i0.ɵɵtext(46, "New value");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "td");
    i0.ɵɵelementStart(48, "span", 10);
    i0.ɵɵtext(49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r0.formatDate(ctx_r0.logDetail));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r0.logDetail.activity);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r0.logDetail.app);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r0.logDetail.section);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r0.logDetail.user);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r0.logDetail.sourceval);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r0.logDetail.destval);
} }
const moment$o = moment_;
class ChangeLogDetailComponent {
    constructor(datePipe) {
        this.datePipe = datePipe;
        this.logDetail = {};
        this.onHideViewLogPopup = new EventEmitter();
        this.onHidePopup = ($event) => {
            this.onHideViewLogPopup.emit();
        };
        this.formatDate = (date) => {
            const browserTimeZonedate = new Date(date.time).getTime() - this.timeZoneOffset;
            return moment$o(new Date(browserTimeZonedate)).format('YYYY/MM/DD HH:mm:ss');
        };
    }
    ngOnInit() {
        const currentDate = new Date();
        this.timeZoneOffset = currentDate.getTimezoneOffset() * 60000; // to milliseconds
        const browserTimeZonedate = new Date(currentDate.getTime() - this.timeZoneOffset);
        const formattedDate = this.datePipe.transform(browserTimeZonedate, 'yyyy-MM-dd HH:mm:ss');
        console.log("timezone offset is ", this.timeZoneOffset);
        console.log("formattedDate is ", formattedDate);
        console.log("got details as ", this.logDetail);
    }
}
ChangeLogDetailComponent.ɵfac = function ChangeLogDetailComponent_Factory(t) { return new (t || ChangeLogDetailComponent)(i0.ɵɵdirectiveInject(i1$2.DatePipe)); };
ChangeLogDetailComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChangeLogDetailComponent, selectors: [["app-change-log-detail"]], inputs: { logDetail: "logDetail" }, outputs: { onHideViewLogPopup: "onHideViewLogPopup" }, decls: 11, vars: 1, consts: [[1, "modalPopup"], [1, "modalOverlay"], [1, "modalContent"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], [1, "details_wrapper"], [1, "table", "logTable"], ["class", "table-border", 4, "ngIf"], [1, "table-border"], [1, "userAccess"]], template: function ChangeLogDetailComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4, " View Change Log Details ");
        i0.ɵɵelementStart(5, "span", 4);
        i0.ɵɵlistener("click", function ChangeLogDetailComponent_Template_span_click_5_listener($event) { return ctx.onHidePopup($event); });
        i0.ɵɵtext(6, "\uE909");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "table", 7);
        i0.ɵɵtemplate(10, ChangeLogDetailComponent_tbody_10_Template, 50, 7, "tbody", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngIf", ctx.logDetail);
    } }, directives: [i1$2.NgIf], styles: [".table[_ngcontent-%COMP%]{border:none;background-color:#fff;max-width:100%;border-collapse:collapse;border-spacing:0;width:100%;font-family:\"ciscoSansLight\",sans-serif;font-size:14px;text-align:left}.table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]{border:0;border-bottom:0px}.table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\",sans-serif;font-size:14px;font-weight:400;padding:14px 18px;vertical-align:middle;text-align:left;margin:0}.table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{background:#fff!important}.modalPopup[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{height:575px;z-index:1001;position:absolute;left:50%;top:150px;transform:translate(-50%);width:70%;background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden;margin-bottom:50px}.modalPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{background-color:#fff;padding:18px 30px;margin-bottom:40px;width:100%!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChangeLogDetailComponent, [{
        type: Component,
        args: [{
                selector: 'app-change-log-detail',
                templateUrl: './change-log-detail.component.html',
                styleUrls: ['./change-log-detail.component.scss']
            }]
    }], function () { return [{ type: i1$2.DatePipe }]; }, { logDetail: [{
            type: Input
        }], onHideViewLogPopup: [{
            type: Output
        }] }); })();

class GenericDropdownFilterPipe {
    transform(values, filter) {
        if (!values || !values.length)
            return [];
        if (!filter)
            return values;
        return values.filter((v) => v.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0);
    }
}
GenericDropdownFilterPipe.ɵfac = function GenericDropdownFilterPipe_Factory(t) { return new (t || GenericDropdownFilterPipe)(); };
GenericDropdownFilterPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "genericDropdownFilter", type: GenericDropdownFilterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericDropdownFilterPipe, [{
        type: Pipe,
        args: [{
                name: "genericDropdownFilter"
            }]
    }], null, null); })();

function ChangeLogUserFilterComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵlistener("click", function ChangeLogUserFilterComponent_div_0_div_5_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const item_r2 = restoredCtx.$implicit; const i_r3 = restoredCtx.index; const ctx_r4 = i0.ɵɵnextContext(2); return ctx_r4.selectUser(item_r2, i_r3); });
    i0.ɵɵelement(1, "div", 7);
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵclassMapInterpolate1("each-option ", item_r2, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 4, item_r2.email), i0.ɵɵsanitizeHtml);
} }
const _c0$1w = function (a1) { return { "options": true, "display-none": a1 }; };
function ChangeLogUserFilterComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "span", 2);
    i0.ɵɵlistener("click", function ChangeLogUserFilterComponent_div_0_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.setDisplayOptions(); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 3);
    i0.ɵɵlistener("ngModelChange", function ChangeLogUserFilterComponent_div_0_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.filterString = $event; })("click", function ChangeLogUserFilterComponent_div_0_Template_input_click_3_listener() { i0.ɵɵrestoreView(_r7); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.setDisplayOptions(); })("onfocusout", function ChangeLogUserFilterComponent_div_0_Template_input_onfocusout_3_listener() { i0.ɵɵrestoreView(_r7); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.userNameEntered(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵlistener("onfocusout", function ChangeLogUserFilterComponent_div_0_Template_div_onfocusout_4_listener() { i0.ɵɵrestoreView(_r7); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.hideUserOptions(); });
    i0.ɵɵtemplate(5, ChangeLogUserFilterComponent_div_0_div_5_Template, 3, 6, "div", 5);
    i0.ɵɵpipe(6, "genericDropdownFilter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.displayOptions ? "\uE908" : "\uE905");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r0.placeholder);
    i0.ɵɵproperty("ngModel", ctx_r0.filterString);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$1w, !ctx_r0.displayOptions));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(6, 5, ctx_r0.itemList, ctx_r0.filterString));
} }
class ChangeLogUserFilterComponent {
    constructor() {
        this.filterString = '';
        this.emitSelection = new EventEmitter();
        this.displayOptions = false;
        this.placeholder = 'Select or Enter user email';
        this.dropdownExpand = false;
        this.hideUserOptions = () => {
            console.log("hiding on focusout", this.filterString);
            setTimeout(() => {
                this.displayOptions = false;
            }, 500);
        };
        this.selectUser = (item, i) => {
            console.log("onselect", item.email);
            this.placeholder = item.email;
            console.log("place holder ", this.placeholder);
            this.filterString = "";
            this.displayOptions = false;
            console.log("select user from item list ", this.itemList, "  ", this.itemList[i]);
            this.emitSelection.emit(item.email);
        };
        this.setDisplayOptions = () => {
            this.displayOptions = !this.displayOptions;
        };
        this.userNameEntered = () => {
            this.emitSelection.emit(this.filterString);
            this.placeholder = this.filterString;
        };
    }
    ngOnInit() {
    }
}
ChangeLogUserFilterComponent.ɵfac = function ChangeLogUserFilterComponent_Factory(t) { return new (t || ChangeLogUserFilterComponent)(); };
ChangeLogUserFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChangeLogUserFilterComponent, selectors: [["app-change-log-user-filter"]], inputs: { itemList: "itemList", filterString: "filterString" }, outputs: { emitSelection: "emitSelection" }, decls: 1, vars: 1, consts: [["class", "dropdown-user", 4, "ngIf"], [1, "dropdown-user"], [1, "arrow", 3, "click"], ["id", "users", "type", "text", "name", "dropdownFilter", "autocomplete", "off", 1, "formControl", "inputpadding", 3, "ngModel", "placeholder", "ngModelChange", "click", "onfocusout"], [3, "ngClass", "onfocusout"], [3, "class", "click", 4, "ngFor", "ngForOf"], [3, "click"], [1, "item-name", 3, "innerHTML"]], template: function ChangeLogUserFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ChangeLogUserFilterComponent_div_0_Template, 7, 10, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.itemList);
    } }, directives: [i1$2.NgIf, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$2.NgClass, i1$2.NgForOf], pipes: [GenericDropdownFilterPipe, SafeHtmlPipe], styles: [".dropdown-user[_ngcontent-%COMP%]{position:relative}.arrow[_ngcontent-%COMP%]{color:#6a6b6c;font-family:\"icomoon-new\";font-size:12px;position:absolute;right:-10px;padding:12px;display:block}.options[_ngcontent-%COMP%]{text-align:left;width:100%;position:absolute;top:70%;height:120px!important;overflow-y:auto;padding:0;margin:0;z-index:1003;background-color:#fff;box-shadow:5px 5px 20px #888}.each-option[_ngcontent-%COMP%]{display:block;padding:8px 10px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.each-option[_ngcontent-%COMP%]:hover{background-color:#eaeaea}.item-name[_ngcontent-%COMP%]{font-size:18px}.item-message[_ngcontent-%COMP%]{font-size:x-small;font-style:italic}.selectedItem[_ngcontent-%COMP%]{display:table-cell;width:40px;height:40px;vertical-align:middle}.paddingLeft[_ngcontent-%COMP%]{padding-left:40px}.unSelectedItem[_ngcontent-%COMP%]{display:table-cell;height:40px;vertical-align:middle;padding-left:40px}.tableCell[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.paddingEmpty[_ngcontent-%COMP%]{padding:0!important}input[type=text][_ngcontent-%COMP%], input[type=number][_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";padding:5px;font-size:14px;text-align:left;border:none;border-bottom:1px solid #9e9ea2;color:#00090d!important;border-radius:0;width:100%;max-width:100%;margin-bottom:10px}.inputpadding[_ngcontent-%COMP%]{padding:2px!important}.arrow[_ngcontent-%COMP%]{color:#6a6b6c;font-family:icomoon-new;font-size:10px;position:absolute;right:-10px;padding:5px 15px 0 0;display:block}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChangeLogUserFilterComponent, [{
        type: Component,
        args: [{
                selector: 'app-change-log-user-filter',
                templateUrl: './change-log-user-filter.component.html',
                styleUrls: ['./change-log-user-filter.component.scss']
            }]
    }], null, { itemList: [{
            type: Input
        }], filterString: [{
            type: Input
        }], emitSelection: [{
            type: Output
        }] }); })();

function ChangeLogFilterComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.userFilter_errormsg);
} }
function ChangeLogFilterComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.dateRange_errormsg);
} }
function ChangeLogFilterComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.appFilter_errormsg);
} }
function ChangeLogFilterComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵelementStart(2, "div", 32);
    i0.ɵɵtext(3, " Start Date ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-calendar", 33);
    i0.ɵɵlistener("ngModelChange", function ChangeLogFilterComponent_div_16_Template_p_calendar_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.startDate.date = $event; })("onSelect", function ChangeLogFilterComponent_div_16_Template_p_calendar_onSelect_4_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.startDateSelected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 34);
    i0.ɵɵelementStart(6, "div", 32);
    i0.ɵɵtext(7, " End Date ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "p-calendar", 33);
    i0.ɵɵlistener("ngModelChange", function ChangeLogFilterComponent_div_16_Template_p_calendar_ngModelChange_8_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.endDate.date = $event; })("onSelect", function ChangeLogFilterComponent_div_16_Template_p_calendar_onSelect_8_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.endDateSelected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r3.startDate.date)("minDate", ctx_r3.startDate.disableUntil)("showTime", false)("monthNavigator", true)("yearNavigator", true)("readonlyInput", true)("showIcon", true)("hourFormat", "12");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r3.endDate.date)("minDate", ctx_r3.endDate.disableUntil)("showTime", false)("monthNavigator", true)("yearNavigator", true)("readonlyInput", true)("showIcon", true)("hourFormat", "12");
} }
function ChangeLogFilterComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "div", 36);
    i0.ɵɵlistener("click", function ChangeLogFilterComponent_div_25_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r14); const app_r11 = restoredCtx.$implicit; const i_r12 = restoredCtx.index; const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.selectOrDeselectApp(app_r11, i_r12); });
    i0.ɵɵelementStart(2, "input", 13);
    i0.ɵɵlistener("ngModelChange", function ChangeLogFilterComponent_div_25_Template_input_ngModelChange_2_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r14); const i_r12 = restoredCtx.index; const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.applist[i_r12].selected || (ctx_r15.selectAllApps = $event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 14);
    i0.ɵɵelementStart(4, "span", 15);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const app_r11 = ctx.$implicit;
    const i_r12 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r4.applist[i_r12].selected || ctx_r4.selectAllApps);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(app_r11.appDisplayName);
} }
function ChangeLogFilterComponent_div_40_div_3_img_2_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 44);
    i0.ɵɵlistener("click", function ChangeLogFilterComponent_div_40_div_3_img_2_Template_img_click_0_listener() { i0.ɵɵrestoreView(_r22); const i_r18 = i0.ɵɵnextContext().index; const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.removeEmailFromUserFilter(i_r18); });
    i0.ɵɵelementEnd();
} }
function ChangeLogFilterComponent_div_40_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelementStart(1, "app-change-log-user-filter", 42);
    i0.ɵɵlistener("emitSelection", function ChangeLogFilterComponent_div_40_div_3_Template_app_change_log_user_filter_emitSelection_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r24); const i_r18 = restoredCtx.index; const ctx_r23 = i0.ɵɵnextContext(2); return ctx_r23.onUserFilterSelection($event, i_r18); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, ChangeLogFilterComponent_div_40_div_3_img_2_Template, 1, 0, "img", 43);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r18 = ctx.index;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("filterString", ctx_r16.userFilterObj[i_r18]);
    i0.ɵɵproperty("itemList", ctx_r16.usersList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r18 > 0);
} }
function ChangeLogFilterComponent_div_40_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2, "Search for Users");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ChangeLogFilterComponent_div_40_div_3_Template, 3, 3, "div", 38);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelementStart(5, "button", 39);
    i0.ɵɵlistener("click", function ChangeLogFilterComponent_div_40_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.addMoreuser(); });
    i0.ɵɵelement(6, "img", 40);
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8, " Add Another ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r5.userFilterObj);
} }
const moment$n = moment_;
class ChangeLogFilterComponent {
    constructor(dataService, userService, authService, datePipe) {
        this.dataService = dataService;
        this.userService = userService;
        this.authService = authService;
        this.datePipe = datePipe;
        this.unsubscribe$ = new Subject();
        this.tempAppList = [];
        this.onHideFilterLogPopup = new EventEmitter();
        this.filterData = new EventEmitter();
        this.filterReset = new EventEmitter();
        this.filterParamJson = {};
        this.filterChoosen = false;
        this.filterByUser = false;
        this.dateFilterOptions = ['All', 'Custom Date Range', 'Last week', 'Last month'];
        this.appsToShow = [];
        /*
        Validations for filter
        */
        this.validDateInputs = true;
        this.validUserFilterInputs = true;
        this.validAppFilterInputs = true;
        this.emailError = false;
        this.appFilter = [];
        this.usersList = [];
        this.checkDateValidity = () => {
            if (moment$n(this.endDate.date).isAfter(moment$n(this.startDate.date))) {
                this.validDateInputs = true;
            }
            else {
                this.validDateInputs = false;
                this.dateRange_errormsg = "Please select valid date range.";
            }
        };
        this.startDateSelected = (event) => {
            console.log("start date coming as ", event);
            console.log("formatted start date coming as ", this.startDate);
            this.checkDateValidity();
        };
        this.endDateSelected = (event) => {
            console.log("end date coming as ", event);
            console.log("formatted end date is ", this.endDate);
            this.checkDateValidity();
        };
        this.getUserApps = () => {
            // this.userService.getRoleApplicationList().pipe(takeUntil(this.unsubscribe$)).subscribe(
            this.authService.getAuditTrailEnabledApps().pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                /*if (response.status && response.data != undefined) {
                  this.prepareAppList(response.data.appName);
                  console.log("App data is ", this.applist);
                }*/
                if (!this.filterApplied) {
                    this.prepareAppList(response.data.appName);
                }
                else {
                    this.prepareAppList(this.applist);
                }
            });
        };
        this.prepareAppList = (apps) => {
            //this.applist = [];
            if (this.applist.length == 0) {
                console.log("app data coming as ", apps);
                this.selectAllApps = true;
                apps.forEach(element => {
                    if (element) {
                        this.applist.push({ "appDisplayName": element, "selected": true });
                        this.tempAppList.push(element);
                        this.appsToShow = this.tempAppList;
                        this.selectAllApps = true; // default filter window selects all option for app
                    }
                });
            }
            else { //filter population case;  **** check  *******
                this.appsToShow = [];
                this.tempAppList = [];
                this.selectAllApps = true;
                this.applist.forEach(element => {
                    this.tempAppList.push(element.appDisplayName);
                    if (element.selected == true) {
                        this.appsToShow.push(element.appDisplayName);
                    }
                    else {
                        this.appsToShow.push(null);
                    }
                });
            }
        };
        this.getUsersList = () => {
            this.userService.getAdminUserList().pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
                if (data != undefined) {
                    console.log("user data is ", data);
                    this.prepareUsersList(data);
                }
                else {
                    //admin user list is empty
                }
            });
            console.log("users list is ", this.usersList);
        };
        this.prepareUsersList = (resultData) => {
            this.usersList = [];
            resultData.forEach(element => {
                if (element.firstName)
                    this.usersList.push({ 'id': element.id, 'name': element.firstName, 'email': element.email });
            });
        };
        this.selectOrDeselectApp = (app, index) => {
            this.appFilter = []; //applist
            if (this.applist[index]["selected"] == false) {
                this.applist[index]["selected"] = true;
                this.uncheckedAppsCount--;
                if (this.uncheckedAppsCount == 0) {
                    this.selectAllApps = true;
                    this.appsToShow = this.tempAppList;
                }
                else {
                    this.appsToShow[index] = app.appDisplayName;
                }
            }
            else {
                this.applist[index]["selected"] = false;
                this.appsToShow[index] = null; //''
                this.uncheckedAppsCount++;
                if (this.uncheckedAppsCount == 0) {
                    this.selectAllApps = true;
                    this.appsToShow = this.tempAppList;
                }
                this.selectAllApps = false;
            }
            this.appFilter = this.appsToShow.filter(x => x !== null); //applist
        };
        this.selectOrDeselectAllApp = () => {
            if (this.selectAllApps == false) {
                this.uncheckedAppsCount = 0;
                this.selectAllApps = true;
                this.appsToShow = this.tempAppList;
                this.applist.forEach(e => {
                    e["selected"] = true;
                });
            }
            else {
                this.selectAllApps = false;
                this.uncheckedAppsCount = this.applist.length;
                this.applist.forEach(e => {
                    e["selected"] = false;
                    this.appsToShow[this.appsToShow.indexOf(e["appDisplayName"])] = null;
                });
            }
        };
        this.onUserFilterSelection = ($event, i) => {
            console.log("user filter selected is ", $event);
            this.userFilterObj[i] = $event;
            this.validUserFilterInputs = true;
        };
        this.onDateFilterSelection = (event$) => {
            console.log("on date dropdown selection", event$);
            this.dateFilterType = event$;
        };
        this.addMoreuser = () => {
            this.validateUserInputs();
            if (this.validUserFilterInputs) {
                this.userFilterObj.push('');
                this.emailError = false;
            }
            else {
                this.emailError = true;
                this.userFilter_errormsg = "Plase provide valid email.";
            }
        };
        this.validateUserInputs = () => {
            //validate email from userFilterObj;
            this.validUserFilterInputs = true;
            this.userFilterObj.forEach(userEmail => {
                if (userEmail === "") {
                    this.validUserFilterInputs = false;
                }
                let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
                if (EMAIL_REGEXP.test(userEmail)) {
                    //return false;
                }
                else {
                    this.validUserFilterInputs = false;
                }
            });
        };
        this.removeEmailFromUserFilter = (index) => {
            this.userFilterObj.splice(index, 1);
        };
        this.resetFilter = () => {
            this.filterParamJson = {};
            this.dateFilterType = 'All';
            this.selectAllApps = true;
            this.filterType_user = 'All';
            this.userFilterObj = [''];
            this.uncheckedAppsCount = 0;
            this.startDate = new DateFilter();
            this.startDate.date = new Date();
            this.endDate = new DateFilter();
            this.endDate.date = new Date();
            this.startDate.dateFormat = "DD/MM/YYYY";
            this.endDate.dateFormat = "DD/MM/YYYY";
            this.filterReset.emit();
        };
        this.hideFilter = () => {
            //clear state of filter popup
            //preselect all  $$ traverse applist
            this.validUserFilterInputs = true;
            this.validAppFilterInputs = true;
            /* this.applist.forEach(element => {
               element["selected"] =true;
             });*/
            console.log("filter closed and applist selected all check ", this.applist);
            //  this.filterType_user = 'All';
            //this.userFilterObj = [''];
            this.onHideFilterLogPopup.emit();
        };
        this.applyFilter = () => {
            /*
            API call with data
            filterJson :{"dateFilterType":"all/custom","startdate":"","enddate":"",
                         "appFilterType":"all/custom","app":[''],
                         "userFilterType":"all/custom","users":['','']}
            */
            var curr = new Date;
            this.appFilter = [];
            let filterTypes = [];
            let filterData = {};
            if (this.dateFilterType == 'All') {
                this.filterParamJson['dateFilterType'] = 'All';
                // filterTypes.push(null);
            }
            else {
                this.filterParamJson['dateFilterType'] = 'Custom Date Range';
                this.filterParamJson['startdate'] = this.startDate.date;
                this.filterParamJson['enddate'] = this.endDate.date;
                filterTypes.push('Date');
                if (this.dateFilterType == 'Last week') {
                    this.filterParamJson['dateFilterType'] = 'Last week';
                    /* var  weekend = curr.getDate() - curr.getDay() +1;
                     var weekstart = weekend - 6;       // end day is the first day + 6
                     var monday = new Date(curr.setDate(weekstart));
                     var sunday = new Date(curr.setDate(weekend));
                     var startDate_lastweek  = new Date(curr.setDate(curr.getDate() - (curr.getDay()+1)));
                     var endDate_lastweek = new Date(curr.setDate(curr.getDate() - curr.getDay()+6));*/
                    this.filterParamJson['enddate'] = new Date; //endDate_lastweek;
                    this.filterParamJson['startdate'] = new Date(curr.setDate(curr.getDate() - 7)); //startDate_lastweek;
                }
                else if (this.dateFilterType == 'Last month') {
                    /* var today = new Date()
                     this.filterParamJson['dateFilterType'] = 'Last month';
             
                     var priorDate = new Date().setDate(today.getDate()-30)
                     var firstDay = new Date(curr.getFullYear(), curr.getMonth()-1, 1);
                     var lastDay = new Date(curr.getFullYear(), curr.getMonth(), 0);
                     this.filterParamJson['startdate'] = firstDay;
                     this.filterParamJson['enddate'] = lastDay;*/
                    this.filterParamJson['enddate'] = new Date; //endDate_lastweek;
                    this.filterParamJson['startdate'] = new Date(curr.setDate(curr.getDate() - 30)); //startDate_lastweek;
                }
            }
            if (this.filterType_user == 'select') {
                //validate if user email is entered or not.
                this.filterParamJson['userFilterType'] = 'select';
                this.filterParamJson['users'] = this.userFilterObj;
                this.validateUserInputs();
                //filterTypes.push('App');
            }
            else {
                this.filterParamJson['userFilterType'] = 'All';
                // this.filterParamJson['users'] = [];
                //filterTypes.push(null);
            }
            if (this.selectAllApps == true) {
                this.filterParamJson['appFilterType'] = true;
                //this.filterParamJson['app'] = [];
                // filterTypes.push(null);
            }
            else {
                //filterTypes.push('User');
                this.filterParamJson['appFilterType'] = false;
                this.appFilter = this.appsToShow.filter(x => x !== null); //applist
                if (this.appFilter.length == 0) {
                    this.validAppFilterInputs = false;
                    this.appFilter_errormsg = "No App is selected to show logs.";
                    return;
                }
                this.filterParamJson['app'] = this.appFilter;
            }
            this.filterParamJson['filterTypes'] = filterTypes;
            this.filterParamJson['filter'] = true;
            this.filterParamJson['limit'] = 50;
            this.filterParamJson['offset'] = 0;
            //this.filterData['data'] = CircularJSON.stringify(this.filterParamJson); //recent
            this.filterParamJson['appforWindow'] = this.applist;
            this.filterParamJson['uncheckedAppsCount'] = this.uncheckedAppsCount;
            this.filterData.emit(this.filterParamJson);
            this.hideFilter();
        };
        this.onChangeUserFilter = () => {
            console.log("now filter type is ", this.filterType_user);
            this.validUserFilterInputs = true;
            this.userFilterObj = [''];
        };
        // this.startDate.dateFormat = "DD/MM/YYYY";
        // this.endDate.dateFormat = "DD/MM/YYYY";
    }
    ngOnInit() {
        const currentDate = new Date();
        const timeZoneOffset = currentDate.getTimezoneOffset();
        const browserTimeZonedate = new Date(currentDate.getTime() - timeZoneOffset);
        const formattedDate = this.datePipe.transform(browserTimeZonedate, 'yyyy-MM-dd HH:mm:ss');
        this.filterChoosen = false;
        this.filterByUser = false;
        console.log("user filer is type:", this.filterType_user, this.userFilterObj);
        console.log("filter applied is ", this.filterApplied);
        // this.filterType_user = 'All';
        //this.dateFilterType = 'All';
        //********** */ this.uncheckedAppsCount = 0;
        if (this.dateFilterType == 'All') {
            this.startDate = new DateFilter();
            this.startDate.date = new Date();
            this.endDate = new DateFilter();
            this.endDate.date = new Date();
        }
        this.startDate.dateFormat = "DD/MM/YYYY";
        this.endDate.dateFormat = "DD/MM/YYYY";
        console.log("filter loading");
        this.getUserApps();
        this.getUsersList();
        setTimeout(() => {
            this.dataService.display(false);
        }, 1500);
    }
}
ChangeLogFilterComponent.ɵfac = function ChangeLogFilterComponent_Factory(t) { return new (t || ChangeLogFilterComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(UserService), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(i1$2.DatePipe)); };
ChangeLogFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChangeLogFilterComponent, selectors: [["app-change-log-filter"]], inputs: { users: "users", dateFilterType: "dateFilterType", selectAllApps: "selectAllApps", filterType_user: "filterType_user", startDate: "startDate", endDate: "endDate", applist: "applist", userFilterObj: "userFilterObj", uncheckedAppsCount: "uncheckedAppsCount", filterApplied: "filterApplied" }, outputs: { onHideFilterLogPopup: "onHideFilterLogPopup", filterData: "filterData", filterReset: "filterReset" }, decls: 48, vars: 12, consts: [[1, "modalPopup", "filterPopup"], ["id", "modalContent", 1, "modalContent-filter"], [1, "modalHeader"], [1, "headerLabel"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], [1, "bodyComponent"], ["class", "errormsg", 4, "ngIf"], [1, "dateRange"], [1, "customDropdown", 3, "selectedItem", "listItems", "onDropdownSelect"], ["class", "datePickerWrapper", 4, "ngIf"], [1, "applabel"], [1, "circularCheckbox", "allCheckBox", 3, "click"], ["type", "checkbox", 3, "ngModel", "ngModelChange"], [1, "checkboxLabel"], [1, "labelspan"], ["class", "appList", 4, "ngFor", "ngForOf"], [1, "userlabel"], [1, "user-filter"], [1, "pmxRadio"], ["type", "radio", "name", "user-filter", "value", "All", 1, "pmxRadioButton", 3, "ngModel", "ngModelChange", "change"], ["for", "password-set", 1, "pmxRadioButtonLabel"], [1, "rule-list-header"], ["type", "radio", "name", "user-filter", "value", "select", 1, "pmxRadioButton", 3, "ngModel", "ngModelChange", "change"], ["class", "SearchUser", 4, "ngIf"], [1, "modalFooter"], [1, "primary-btn", "applyFilter", 3, "disabled", "click"], [1, "cancelButton", "resetButton", 3, "click"], [1, "cancelButton", 3, "click"], [1, "errormsg"], [1, "datePickerWrapper"], [1, "datePickerBlock", "startDateInp"], [1, "floatLeft", "dateLabel"], ["yearRange", "2015:2050", 3, "ngModel", "minDate", "showTime", "monthNavigator", "yearNavigator", "readonlyInput", "showIcon", "hourFormat", "ngModelChange", "onSelect"], [1, "datePickerBlock", "endDateInp"], [1, "appList"], [1, "circularCheckbox", 3, "click"], [1, "SearchUser"], ["class", "dropdownDiv", 4, "ngFor", "ngForOf"], [1, "commonButton", 3, "click"], ["src", "/assets/images/add.svg", 1, "deleteUser"], [1, "dropdownDiv"], [1, "dropdownComp", 3, "itemList", "filterString", "emitSelection"], ["src", "/assets/images/delete_user.svg", 3, "click", 4, "ngIf"], ["src", "/assets/images/delete_user.svg", 3, "click"]], template: function ChangeLogFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4, "Filter Log");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "span", 4);
        i0.ɵɵlistener("click", function ChangeLogFilterComponent_Template_span_click_5_listener() { return ctx.hideFilter(); });
        i0.ɵɵtext(6, "\uE909");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "div");
        i0.ɵɵtemplate(10, ChangeLogFilterComponent_div_10_Template, 2, 1, "div", 7);
        i0.ɵɵtemplate(11, ChangeLogFilterComponent_div_11_Template, 2, 1, "div", 7);
        i0.ɵɵtemplate(12, ChangeLogFilterComponent_div_12_Template, 2, 1, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 8);
        i0.ɵɵtext(14, "Date");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "dropdown-simple", 9);
        i0.ɵɵlistener("onDropdownSelect", function ChangeLogFilterComponent_Template_dropdown_simple_onDropdownSelect_15_listener($event) { return ctx.onDateFilterSelection($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, ChangeLogFilterComponent_div_16_Template, 9, 16, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 6);
        i0.ɵɵelementStart(18, "div", 11);
        i0.ɵɵtext(19, "Apps");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 12);
        i0.ɵɵlistener("click", function ChangeLogFilterComponent_Template_div_click_20_listener() { return ctx.selectOrDeselectAllApp(); });
        i0.ɵɵelementStart(21, "input", 13);
        i0.ɵɵlistener("ngModelChange", function ChangeLogFilterComponent_Template_input_ngModelChange_21_listener($event) { return ctx.selectAllApps = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "label", 14);
        i0.ɵɵelementStart(23, "span", 15);
        i0.ɵɵtext(24, "All");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(25, ChangeLogFilterComponent_div_25_Template, 6, 2, "div", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 6);
        i0.ɵɵelementStart(27, "div", 17);
        i0.ɵɵtext(28, "User");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 18);
        i0.ɵɵelementStart(30, "div", 19);
        i0.ɵɵelementStart(31, "input", 20);
        i0.ɵɵlistener("ngModelChange", function ChangeLogFilterComponent_Template_input_ngModelChange_31_listener($event) { return ctx.filterType_user = $event; })("change", function ChangeLogFilterComponent_Template_input_change_31_listener() { return ctx.onChangeUserFilter(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "label", 21);
        i0.ɵɵelementStart(33, "span", 22);
        i0.ɵɵtext(34, "All Users");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "div", 19);
        i0.ɵɵelementStart(36, "input", 23);
        i0.ɵɵlistener("ngModelChange", function ChangeLogFilterComponent_Template_input_ngModelChange_36_listener($event) { return ctx.filterType_user = $event; })("change", function ChangeLogFilterComponent_Template_input_change_36_listener() { return ctx.onChangeUserFilter(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "label", 21);
        i0.ɵɵelementStart(38, "span", 22);
        i0.ɵɵtext(39, "Selected Users");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(40, ChangeLogFilterComponent_div_40_Template, 9, 1, "div", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "div", 25);
        i0.ɵɵelementStart(42, "button", 26);
        i0.ɵɵlistener("click", function ChangeLogFilterComponent_Template_button_click_42_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(43, "Apply");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "button", 27);
        i0.ɵɵlistener("click", function ChangeLogFilterComponent_Template_button_click_44_listener() { return ctx.resetFilter(); });
        i0.ɵɵtext(45, "Reset Filter");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "button", 28);
        i0.ɵɵlistener("click", function ChangeLogFilterComponent_Template_button_click_46_listener() { return ctx.hideFilter(); });
        i0.ɵɵtext(47, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngIf", !ctx.validUserFilterInputs);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.validDateInputs);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.validAppFilterInputs);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("selectedItem", ctx.dateFilterType)("listItems", ctx.dateFilterOptions);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dateFilterType == "Custom Date Range");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngModel", ctx.selectAllApps);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.applist);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngModel", ctx.filterType_user);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngModel", ctx.filterType_user);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.filterType_user == "select");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", !ctx.validDateInputs || ctx.dateFilterType == "All" && ctx.filterType_user == "All" && ctx.appFilter.length == 0);
    } }, directives: [i1$2.NgIf, DropdownSimpleComponent, i2$1.CheckboxControlValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$2.NgForOf, i2$1.RadioControlValueAccessor, i2$1.DefaultValueAccessor, i7.Calendar, ChangeLogUserFilterComponent], styles: [".modalPopup.filterPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;padding-left:25px;transition:.5s ease}.modalPopup.filterPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .noteLabel[_ngcontent-%COMP%]{font-size:12px;font-weight:normal}.modalPopup.filterPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{height:80px}.modalPopup.filterPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]   .headerDesc[_ngcontent-%COMP%]{font-family:ciscoSansThin;font-size:12px;font-weight:normal;padding-top:10px}.headerLabel[_ngcontent-%COMP%]{margin-top:15px}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer;margin-top:15px}.modalPopup[_ngcontent-%COMP%] > .modalContent-filter[_ngcontent-%COMP%]{width:50%;right:0;height:100%;z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid rgba(0,0,0,.1);animation:slide .5s forwards;text-align:left}.modalPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{padding-right:20px;height:80px}button[disabled][_ngcontent-%COMP%]{cursor:not-allowed}button[_ngcontent-%COMP%]:focus{outline:0}.modalFooter[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:24px 0 24px 24px;display:inline-block;width:85px}.resetButton[_ngcontent-%COMP%]{width:135px!important}.cancelButton[_ngcontent-%COMP%]{border:6px;font-size:14px;background-color:transparent;outline:1px;color:#0096d6;font-family:\"ciscoSans\";letter-spacing:1px;padding:0 24px;margin:30px 0 21px 24px;display:inline-block}.mydp[_ngcontent-%COMP%]{width:20%}.mydp[_ngcontent-%COMP%], .mydp[_ngcontent-%COMP%]   .headertodaybtn[_ngcontent-%COMP%]{border-bottom:1px solid #CCC}.datePickerWrapper[_ngcontent-%COMP%]{font-size:14px;font-family:\"ciscoSansThin\";margin-bottom:20px;margin-left:5px}.startDateInp[_ngcontent-%COMP%]{display:inline-block;width:25%}.endDateInp[_ngcontent-%COMP%]{display:inline-block;width:25%;margin-left:40px}.datePickerBlock[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]{width:85%;padding:0}p-calendar[_ngcontent-%COMP%] > span[_ngcontent-%COMP%] > input[type=text][_ngcontent-%COMP%]{margin-bottom:0;width:85%;padding:0}[_nghost-%COMP%]     p-calendar .ui-calendar .ui-calendar-button{display:none!important}.ui-calendar.ui-calendar-w-btn[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border-top-right-radius:0;border-bottom-right-radius:0;padding:10px 0 4px}.dateRange[_ngcontent-%COMP%]{margin:10px 0;font-size:14px;font-family:\"ciscoSansThin\"}.dateLabel[_ngcontent-%COMP%]{font-size:13px;font-family:\"ciscoSansThin\"}.applabel[_ngcontent-%COMP%]{margin:0 0 15px;font-size:14px}.appList[_ngcontent-%COMP%]{font-size:14px;margin:0 0 10px 5px}.labelspan[_ngcontent-%COMP%]{margin-left:25px}.user-filter[_ngcontent-%COMP%]{margin-top:5px;margin-bottom:10px}.customDropdown[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:25%!important}.customDropdown[_ngcontent-%COMP%] > .simpleDropdownContainer[_ngcontent-%COMP%] > .selectedDropdown[_ngcontent-%COMP%]{border:none!important;border-bottom:1px solid #9e9ea2!important}[_nghost-%COMP%]     dropdown-simple .simpleDropdownContainer{width:25%!important}.customDropdown[_ngcontent-%COMP%] > .simpleDropdownList[_ngcontent-%COMP%]{width:25%!important}.Disabled[_ngcontent-%COMP%]{opacity:.6;pointer-events:none;cursor:default}.commonButton[_ngcontent-%COMP%]{border:none;padding:10px 0}commonButton[_ngcontent-%COMP%]:hover{text-decoration:none;opacity:.8}.allCheckBox[_ngcontent-%COMP%]{margin:0 0 10px 5px;font-size:14px}.bodyComponent[_ngcontent-%COMP%]{margin-bottom:25px}.pmxRadio[_ngcontent-%COMP%]   .pmxRadioButtonLabel[_ngcontent-%COMP%]{margin-left:21px;margin-top:4px;font-size:14px}.SearchUser[_ngcontent-%COMP%]{font-size:14px;margin-left:30px}.dropdownDiv[_ngcontent-%COMP%]{margin:12px 0 0;width:50%}.arrow[_ngcontent-%COMP%]{color:#6a6b6c;font-family:icomoon-new;font-size:12px;position:absolute;right:-10px;padding:8px;display:block}.dropdownComp[_ngcontent-%COMP%]{display:inline-block;width:50%;margin-right:20px}.deleteUser[_ngcontent-%COMP%]{width:20px;margin-left:20px}.applyFilter[_ngcontent-%COMP%]:disabled{opacity:.3}.circularCheckbox[_ngcontent-%COMP%]{width:15%!important}.circularCheckbox[_ngcontent-%COMP%]   .checkboxLabel[_ngcontent-%COMP%]{width:150px!important}.errormsg[_ngcontent-%COMP%]{color:red;font-size:14px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChangeLogFilterComponent, [{
        type: Component,
        args: [{
                selector: 'app-change-log-filter',
                templateUrl: './change-log-filter.component.html',
                styleUrls: ['./change-log-filter.component.scss']
            }]
    }], function () { return [{ type: DataService }, { type: UserService }, { type: AuthService }, { type: i1$2.DatePipe }]; }, { users: [{
            type: Input
        }], dateFilterType: [{
            type: Input
        }], selectAllApps: [{
            type: Input
        }], filterType_user: [{
            type: Input
        }], startDate: [{
            type: Input
        }], endDate: [{
            type: Input
        }], applist: [{
            type: Input
        }], userFilterObj: [{
            type: Input
        }], uncheckedAppsCount: [{
            type: Input
        }], filterApplied: [{
            type: Input
        }], onHideFilterLogPopup: [{
            type: Output
        }], filterData: [{
            type: Output
        }], filterReset: [{
            type: Output
        }] }); })();

function AccountPreferenceComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Last Login:", ctx_r0.lastLoginDate, " ");
} }
function AccountPreferenceComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵtext(2, "Account");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 23);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 24);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.licenseInfoData.accountName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" Tenant ID: ", ctx_r1.licenseInfoData.tenantId, " ");
} }
const _c0$1v = function (a0) { return { "selected": a0 }; };
function AccountPreferenceComponent_span_23_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵlistener("click", function AccountPreferenceComponent_span_23_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.switchTab("licenseInformation"); });
    i0.ɵɵtext(1, " License Information ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$1v, ctx_r2.currentSelectedTab === "licenseInformation"));
} }
function AccountPreferenceComponent_div_28_div_1_tbody_13_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 37);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span", 38);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "span", 38);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵelementStart(8, "span", 38);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const loginHistory_r19 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", loginHistory_r19.ipAddress, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(loginHistory_r19.lastLogin);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", loginHistory_r19.userAgent, ". v ", loginHistory_r19.version, "");
} }
function AccountPreferenceComponent_div_28_div_1_tbody_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 29);
    i0.ɵɵtemplate(1, AccountPreferenceComponent_div_28_div_1_tbody_13_tr_1_Template, 10, 4, "tr", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r16.temp_failure_list);
} }
function AccountPreferenceComponent_div_28_div_1_div_14_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵlistener("click", function AccountPreferenceComponent_div_28_div_1_div_14_div_3_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(4); return ctx_r21.showMoreClickFailure(); });
    i0.ɵɵtext(1, " Show More ");
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_28_div_1_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AccountPreferenceComponent_div_28_div_1_div_14_div_3_Template, 2, 0, "div", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" Showing ", ctx_r17.temp_failure_list.length, " of ", ctx_r17.loginFailureHistoryList.length, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.showMoreBtnFailure);
} }
function AccountPreferenceComponent_div_28_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵtext(2, "Failed Attempt");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "lib-app-search", 27);
    i0.ɵɵlistener("searchTextChange", function AccountPreferenceComponent_div_28_div_1_Template_lib_app_search_searchTextChange_3_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(2); return ctx_r23.onSearchFailStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "table", 28);
    i0.ɵɵelementStart(5, "thead", 29);
    i0.ɵɵelementStart(6, "tr", 30);
    i0.ɵɵelementStart(7, "th", 31);
    i0.ɵɵtext(8, "IP Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 32);
    i0.ɵɵtext(10, "Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th", 33);
    i0.ɵɵtext(12, "Browser");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, AccountPreferenceComponent_div_28_div_1_tbody_13_Template, 2, 1, "tbody", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, AccountPreferenceComponent_div_28_div_1_div_14_Template, 4, 3, "div", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("section", "Failed Items")("emitSearch", true);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngIf", ctx_r14.temp_failure_list);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.temp_failure_list !== null && ctx_r14.temp_failure_list.length > 0);
} }
function AccountPreferenceComponent_div_28_div_2_tbody_13_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 37);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span", 38);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "span", 38);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵelementStart(8, "span", 38);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const loginHistory_r28 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", loginHistory_r28.ipAddress, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(loginHistory_r28.lastLogin);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", loginHistory_r28.userAgent, ". v ", loginHistory_r28.version, "");
} }
function AccountPreferenceComponent_div_28_div_2_tbody_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 29);
    i0.ɵɵtemplate(1, AccountPreferenceComponent_div_28_div_2_tbody_13_tr_1_Template, 10, 4, "tr", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r25.temp_success_list);
} }
function AccountPreferenceComponent_div_28_div_2_div_14_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵlistener("click", function AccountPreferenceComponent_div_28_div_2_div_14_div_3_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(4); return ctx_r30.showMoreClickSuccess(); });
    i0.ɵɵtext(1, " Show More ");
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_28_div_2_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AccountPreferenceComponent_div_28_div_2_div_14_div_3_Template, 2, 0, "div", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" Showing ", ctx_r26.temp_success_list.length, " of ", ctx_r26.loginSuccessHistoryList.length, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r26.showMoreBtnSuccess);
} }
function AccountPreferenceComponent_div_28_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵtext(2, "Recent Login");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "lib-app-search", 27);
    i0.ɵɵlistener("searchTextChange", function AccountPreferenceComponent_div_28_div_2_Template_lib_app_search_searchTextChange_3_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.onSearchSuccessStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "table", 28);
    i0.ɵɵelementStart(5, "thead", 29);
    i0.ɵɵelementStart(6, "tr", 30);
    i0.ɵɵelementStart(7, "th", 31);
    i0.ɵɵtext(8, "IP Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 32);
    i0.ɵɵtext(10, "Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th", 33);
    i0.ɵɵtext(12, "Browser");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, AccountPreferenceComponent_div_28_div_2_tbody_13_Template, 2, 1, "tbody", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, AccountPreferenceComponent_div_28_div_2_div_14_Template, 4, 3, "div", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("section", "Success Items")("emitSearch", true);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngIf", ctx_r15.temp_success_list);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.temp_success_list !== null && ctx_r15.temp_success_list.length > 0);
} }
function AccountPreferenceComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AccountPreferenceComponent_div_28_div_1_Template, 15, 4, "div", 18);
    i0.ɵɵtemplate(2, AccountPreferenceComponent_div_28_div_2_Template, 15, 4, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.loginFailureHistoryList && ctx_r3.loginFailureHistoryList.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.loginSuccessHistoryList && ctx_r3.loginSuccessHistoryList.length > 0);
} }
function AccountPreferenceComponent_div_29_div_4_div_1_img_7_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 60);
    i0.ɵɵlistener("click", function AccountPreferenceComponent_div_29_div_4_div_1_img_7_Template_img_click_0_listener() { i0.ɵɵrestoreView(_r44); const domainList_r38 = i0.ɵɵnextContext().$implicit; const ctx_r42 = i0.ɵɵnextContext(3); return ctx_r42.removeDomain(domainList_r38.domain); });
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_29_div_4_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 61);
    i0.ɵɵtext(1, " SSO is enabled for Authentication only ");
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_29_div_4_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 61);
    i0.ɵɵtext(1, " SSO is enabled for Authentication and managing users ");
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_29_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 53);
    i0.ɵɵelementStart(2, "div", 54);
    i0.ɵɵelementStart(3, "div", 55);
    i0.ɵɵelement(4, "br");
    i0.ɵɵelement(5, "input", 56);
    i0.ɵɵelement(6, "input", 57);
    i0.ɵɵtemplate(7, AccountPreferenceComponent_div_29_div_4_div_1_img_7_Template, 1, 0, "img", 58);
    i0.ɵɵtemplate(8, AccountPreferenceComponent_div_29_div_4_div_1_div_8_Template, 2, 0, "div", 59);
    i0.ɵɵtemplate(9, AccountPreferenceComponent_div_29_div_4_div_1_div_9_Template, 2, 0, "div", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const domainList_r38 = ctx.$implicit;
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(6);
    i0.ɵɵpropertyInterpolate("value", domainList_r38.domain);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r37.isUserRoleAvailable && ctx_r37.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", domainList_r38.isSSOEnabled && domainList_r38.authenticateOnly);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", domainList_r38.isSSOEnabled && !domainList_r38.authenticateOnly);
} }
function AccountPreferenceComponent_div_29_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AccountPreferenceComponent_div_29_div_4_div_1_Template, 10, 4, "div", 52);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r34.domainListValues);
} }
function AccountPreferenceComponent_div_29_div_5_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 66);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r45.validationError, " ");
} }
function AccountPreferenceComponent_div_29_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵelementStart(1, "div", 54);
    i0.ɵɵelementStart(2, "div", 55);
    i0.ɵɵelement(3, "br");
    i0.ɵɵelement(4, "input", 56);
    i0.ɵɵelement(5, "input", 62);
    i0.ɵɵelementStart(6, "span", 63);
    i0.ɵɵtext(7, "Domain");
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 64);
    i0.ɵɵlistener("click", function AccountPreferenceComponent_div_29_div_5_Template_div_click_10_listener() { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(2); return ctx_r46.addNewDomain(ctx_r46.domainNameForm.value); });
    i0.ɵɵtext(11, " Add ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, AccountPreferenceComponent_div_29_div_5_div_12_Template, 2, 1, "div", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("formControl", ctx_r35.domainNameForm);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", ctx_r35.validationError);
} }
function AccountPreferenceComponent_div_29_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵlistener("click", function AccountPreferenceComponent_div_29_div_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(2); return ctx_r48.addNewDomain(""); });
    i0.ɵɵelement(1, "img", 68);
    i0.ɵɵtext(2, " Add new domain ");
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵtext(2, " SSO");
    i0.ɵɵelement(3, "img", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, AccountPreferenceComponent_div_29_div_4_Template, 2, 1, "div", 17);
    i0.ɵɵtemplate(5, AccountPreferenceComponent_div_29_div_5_Template, 13, 2, "div", 44);
    i0.ɵɵtemplate(6, AccountPreferenceComponent_div_29_div_6_Template, 3, 0, "div", 45);
    i0.ɵɵelementStart(7, "div", 46);
    i0.ɵɵelementStart(8, "span", 47);
    i0.ɵɵtext(9, "Enable Support Access");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 48);
    i0.ɵɵtext(11, " Support login allows Cisco spaces support team to diagnose and debug in exceptional situations. ");
    i0.ɵɵelement(12, "br");
    i0.ɵɵtext(13, " when enabled, our support team will have full access to your Cisco Spaces account. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 49);
    i0.ɵɵelementStart(15, "input", 50);
    i0.ɵɵlistener("click", function AccountPreferenceComponent_div_29_Template_input_click_15_listener() { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(); return ctx_r50.toggleSupportLogin(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "label", 51);
    i0.ɵɵtext(17, "Enable Support Login");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("tooltip", ctx_r4.tooltips["sso"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.isDomainListEmpty);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.showNewDomainField);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.showNewDomainField && ctx_r4.isUserRoleAvailable && ctx_r4.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("checked", ctx_r4.supportLoginStatus);
} }
function AccountPreferenceComponent_div_30_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 76);
    i0.ɵɵlistener("click", function AccountPreferenceComponent_div_30_span_3_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(2); return ctx_r61.onProfileEditClick(); });
    i0.ɵɵelement(1, "img", 77);
    i0.ɵɵelementStart(2, "div", 78);
    i0.ɵɵtext(3, "Edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_30_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r53.firstName, " ");
} }
function AccountPreferenceComponent_div_30_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵtext(1, " N/A ");
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_30_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r55 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r55.lastName, " ");
} }
function AccountPreferenceComponent_div_30_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵtext(1, " N/A ");
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_30_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r57.userEmail, " ");
} }
function AccountPreferenceComponent_div_30_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵtext(1, " N/A ");
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_30_div_27_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 83);
    i0.ɵɵlistener("click", function AccountPreferenceComponent_div_30_div_27_button_3_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(3); return ctx_r65.onClickVerification($event); });
    i0.ɵɵtext(1, " Verify Mobile Number ");
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_30_div_27_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 84);
    i0.ɵɵelement(1, "img", 85);
    i0.ɵɵtext(2, " Verified ");
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_30_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 80);
    i0.ɵɵelementStart(1, "div", 79);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AccountPreferenceComponent_div_30_div_27_button_3_Template, 2, 0, "button", 81);
    i0.ɵɵtemplate(4, AccountPreferenceComponent_div_30_div_27_div_4_Template, 3, 0, "div", 82);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r59.phoneNumber, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r59.isSSOLogin && !ctx_r59.isVerified);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r59.isSSOLogin && ctx_r59.isVerified);
} }
function AccountPreferenceComponent_div_30_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵtext(1, " N/A ");
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 69);
    i0.ɵɵtext(2, " Profile Information ");
    i0.ɵɵtemplate(3, AccountPreferenceComponent_div_30_span_3_Template, 4, 0, "span", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 71);
    i0.ɵɵelementStart(5, "div", 72);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "div", 73);
    i0.ɵɵtext(8, "FIRST NAME");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, AccountPreferenceComponent_div_30_div_9_Template, 2, 1, "div", 74);
    i0.ɵɵtemplate(10, AccountPreferenceComponent_div_30_div_10_Template, 2, 0, "div", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 72);
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵelementStart(13, "div", 73);
    i0.ɵɵtext(14, "LAST NAME");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, AccountPreferenceComponent_div_30_div_15_Template, 2, 1, "div", 74);
    i0.ɵɵtemplate(16, AccountPreferenceComponent_div_30_div_16_Template, 2, 0, "div", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 72);
    i0.ɵɵelementStart(18, "div");
    i0.ɵɵelementStart(19, "div", 73);
    i0.ɵɵtext(20, "EMAIL");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(21, AccountPreferenceComponent_div_30_div_21_Template, 2, 1, "div", 74);
    i0.ɵɵtemplate(22, AccountPreferenceComponent_div_30_div_22_Template, 2, 0, "div", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 72);
    i0.ɵɵelementStart(24, "div");
    i0.ɵɵelementStart(25, "div", 73);
    i0.ɵɵtext(26, "MOBILE NUMBER");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, AccountPreferenceComponent_div_30_div_27_Template, 5, 3, "div", 75);
    i0.ɵɵtemplate(28, AccountPreferenceComponent_div_30_div_28_Template, 2, 0, "div", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r5.isSSOLogin);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r5.firstName !== null && ctx_r5.firstName !== "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.firstName === null || ctx_r5.firstName === "");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r5.lastName !== null && ctx_r5.lastName !== "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.lastName === null || ctx_r5.lastName === "");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r5.userEmail !== null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.userEmail === null);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r5.phoneNumber !== null && ctx_r5.phoneNumber !== "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.phoneNumber === null || ctx_r5.phoneNumber === "");
} }
function AccountPreferenceComponent_div_31_lib_smart_license_base_1_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-smart-license-base", 87);
    i0.ɵɵlistener("onHideSmartLicensePopup", function AccountPreferenceComponent_div_31_lib_smart_license_base_1_Template_lib_smart_license_base_onHideSmartLicensePopup_0_listener() { i0.ɵɵrestoreView(_r69); const ctx_r68 = i0.ɵɵnextContext(2); return ctx_r68.onHideSmartLicensePopup(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r67 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("licenseInfo", ctx_r67.licenseInfo)("licenseInfoData", ctx_r67.licenseInfoData)("fromPage", ctx_r67.fromPage);
} }
function AccountPreferenceComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AccountPreferenceComponent_div_31_lib_smart_license_base_1_Template, 1, 3, "lib-smart-license-base", 86);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.isLicenseInfoReady);
} }
function AccountPreferenceComponent_div_32_span_4_img_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 97);
} }
function AccountPreferenceComponent_div_32_span_4_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 98);
} }
function AccountPreferenceComponent_div_32_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 93);
    i0.ɵɵlistener("click", function AccountPreferenceComponent_div_32_span_4_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r77); const ctx_r76 = i0.ɵɵnextContext(2); return ctx_r76.onFilterLogClick(); });
    i0.ɵɵtemplate(1, AccountPreferenceComponent_div_32_span_4_img_1_Template, 1, 0, "img", 94);
    i0.ɵɵtemplate(2, AccountPreferenceComponent_div_32_span_4_img_2_Template, 1, 0, "img", 95);
    i0.ɵɵelementStart(3, "div", 96);
    i0.ɵɵelementStart(4, "strong");
    i0.ɵɵtext(5, "Filter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r70 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r70.filterApplied);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r70.filterApplied);
} }
function AccountPreferenceComponent_div_32_div_5_tbody_14_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r83 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 103);
    i0.ɵɵlistener("click", function AccountPreferenceComponent_div_32_div_5_tbody_14_tr_1_Template_tr_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r83); const log_r80 = restoredCtx.$implicit; const ctx_r82 = i0.ɵɵnextContext(4); return ctx_r82.showDetailPopup(log_r80); });
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span", 104);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "span", 38);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵelementStart(8, "span", 38);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵelementStart(11, "span", 38);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "td");
    i0.ɵɵelementStart(14, "span", 38);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const log_r80 = ctx.$implicit;
    const ctx_r79 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(log_r80.activity);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r79.toLocaleTime(log_r80.time), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(log_r80.app);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", log_r80.section, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(log_r80.user);
} }
function AccountPreferenceComponent_div_32_div_5_tbody_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 29);
    i0.ɵɵtemplate(1, AccountPreferenceComponent_div_32_div_5_tbody_14_tr_1_Template, 16, 5, "tr", 102);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r78 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r78.changeLogData_paginated);
} }
function AccountPreferenceComponent_div_32_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 71);
    i0.ɵɵelementStart(1, "table", 99);
    i0.ɵɵelementStart(2, "thead", 29);
    i0.ɵɵelementStart(3, "tr");
    i0.ɵɵelementStart(4, "th", 31);
    i0.ɵɵtext(5, "Activity");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 32);
    i0.ɵɵtext(7, "Time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th", 33);
    i0.ɵɵtext(9, "App");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 100);
    i0.ɵɵtext(11, "Section");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th", 101);
    i0.ɵɵtext(13, "User");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, AccountPreferenceComponent_div_32_div_5_tbody_14_Template, 2, 1, "tbody", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r71 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngIf", ctx_r71.changelogsList);
} }
function AccountPreferenceComponent_div_32_div_6_lib_search_basic_1_Template(rf, ctx) { if (rf & 1) {
    const _r86 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-search-basic", 108);
    i0.ɵɵlistener("filtered", function AccountPreferenceComponent_div_32_div_6_lib_search_basic_1_Template_lib_search_basic_filtered_0_listener($event) { i0.ɵɵrestoreView(_r86); const ctx_r85 = i0.ɵɵnextContext(3); return ctx_r85.onFilter($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r84 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("data", ctx_r84.changelogsList)("shouldUseGlobalSearch", true)("searchSkeleton", ctx_r84.searchSkeleton);
} }
function AccountPreferenceComponent_div_32_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r88 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 105);
    i0.ɵɵtemplate(1, AccountPreferenceComponent_div_32_div_6_lib_search_basic_1_Template, 1, 3, "lib-search-basic", 106);
    i0.ɵɵelementStart(2, "app-change-log-pagination", 107);
    i0.ɵɵlistener("recordNumChange", function AccountPreferenceComponent_div_32_div_6_Template_app_change_log_pagination_recordNumChange_2_listener($event) { i0.ɵɵrestoreView(_r88); const ctx_r87 = i0.ɵɵnextContext(2); return ctx_r87.fetchChangeLogs($event); })("currentPage", function AccountPreferenceComponent_div_32_div_6_Template_app_change_log_pagination_currentPage_2_listener($event) { i0.ɵɵrestoreView(_r88); const ctx_r89 = i0.ɵɵnextContext(2); return ctx_r89.getCurrentItems($event); })("getItemsForThisPage", function AccountPreferenceComponent_div_32_div_6_Template_app_change_log_pagination_getItemsForThisPage_2_listener($event) { i0.ɵɵrestoreView(_r88); const ctx_r90 = i0.ɵɵnextContext(2); return ctx_r90.getCurrentPageItems($event); })("clickEvent", function AccountPreferenceComponent_div_32_div_6_Template_app_change_log_pagination_clickEvent_2_listener($event) { i0.ɵɵrestoreView(_r88); const ctx_r91 = i0.ɵɵnextContext(2); return ctx_r91.clickEvents($event); })("reloadMoreLogs", function AccountPreferenceComponent_div_32_div_6_Template_app_change_log_pagination_reloadMoreLogs_2_listener($event) { i0.ɵɵrestoreView(_r88); const ctx_r92 = i0.ɵɵnextContext(2); return ctx_r92.getMoreChangeLog($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r72 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r72.changelogsList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pagesToShow", 3)("perPage", ctx_r72.loglimit)("page", ctx_r72.logpage)("loading", false)("items", ctx_r72.changelogsList)("totalRecords", ctx_r72.totalLogRecord);
} }
function AccountPreferenceComponent_div_32_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 109);
    i0.ɵɵtext(1, " No Change logs found. ");
    i0.ɵɵelementEnd();
} }
function AccountPreferenceComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 88);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "Change Log");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, AccountPreferenceComponent_div_32_span_4_Template, 6, 2, "span", 89);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, AccountPreferenceComponent_div_32_div_5_Template, 15, 1, "div", 90);
    i0.ɵɵtemplate(6, AccountPreferenceComponent_div_32_div_6_Template, 3, 7, "div", 91);
    i0.ɵɵtemplate(7, AccountPreferenceComponent_div_32_div_7_Template, 2, 0, "div", 92);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r7.noDataFound || ctx_r7.filterApplied);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.noDataFound);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.noDataFound);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.noDataFound);
} }
function AccountPreferenceComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    const _r94 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 110);
    i0.ɵɵelementStart(1, "lib-update-profile-popup", 111);
    i0.ɵɵlistener("hideProfilePopup", function AccountPreferenceComponent_div_33_Template_lib_update_profile_popup_hideProfilePopup_1_listener() { i0.ɵɵrestoreView(_r94); const ctx_r93 = i0.ɵɵnextContext(); return ctx_r93.onHideProfilePopup(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("email", ctx_r8.userEmail)("firstName", ctx_r8.firstName)("lastName", ctx_r8.lastName)("phoneNumberInput", ctx_r8.phoneNumber)("fromPage", ctx_r8.fromPage);
} }
function AccountPreferenceComponent_div_34_Template(rf, ctx) { if (rf & 1) {
    const _r96 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 110);
    i0.ɵɵelementStart(1, "app-verify-phone-number", 112);
    i0.ɵɵlistener("onHideVerificationPopup", function AccountPreferenceComponent_div_34_Template_app_verify_phone_number_onHideVerificationPopup_1_listener($event) { i0.ɵɵrestoreView(_r96); const ctx_r95 = i0.ɵɵnextContext(); return ctx_r95.onHideVerificationPopup($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("email", ctx_r9.userEmail)("phones", ctx_r9.phoneNumber);
} }
function AccountPreferenceComponent_div_35_Template(rf, ctx) { if (rf & 1) {
    const _r98 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 110);
    i0.ɵɵelementStart(1, "app-change-log-detail", 113);
    i0.ɵɵlistener("onHideViewLogPopup", function AccountPreferenceComponent_div_35_Template_app_change_log_detail_onHideViewLogPopup_1_listener() { i0.ɵɵrestoreView(_r98); const ctx_r97 = i0.ɵɵnextContext(); return ctx_r97.closeDetailPopup(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("logDetail", ctx_r10.changelogDetail);
} }
function AccountPreferenceComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    const _r100 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 110);
    i0.ɵɵelementStart(1, "app-change-log-filter", 114);
    i0.ɵɵlistener("onHideFilterLogPopup", function AccountPreferenceComponent_div_36_Template_app_change_log_filter_onHideFilterLogPopup_1_listener() { i0.ɵɵrestoreView(_r100); const ctx_r99 = i0.ɵɵnextContext(); return ctx_r99.onFilterLogClose(); })("filterData", function AccountPreferenceComponent_div_36_Template_app_change_log_filter_filterData_1_listener($event) { i0.ɵɵrestoreView(_r100); const ctx_r101 = i0.ɵɵnextContext(); return ctx_r101.filterLogData($event); })("filterReset", function AccountPreferenceComponent_div_36_Template_app_change_log_filter_filterReset_1_listener() { i0.ɵɵrestoreView(_r100); const ctx_r102 = i0.ɵɵnextContext(); return ctx_r102.filterReset(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("dateFilterType", ctx_r11.dateFilterType)("selectAllApps", ctx_r11.selectAllApps)("applist", ctx_r11.applist)("filterType_user", ctx_r11.filterType_user)("userFilterObj", ctx_r11.userObj)("startDate", ctx_r11.startDate)("endDate", ctx_r11.endDate)("uncheckedAppsCount", ctx_r11.uncheckedAppsCount)("filterApplied", ctx_r11.filterApplied);
} }
const moment$m = moment_;
class AccountPreferenceComponent {
    constructor(locationService, dataService, authService, activatedRoute, translate) {
        this.locationService = locationService;
        this.dataService = dataService;
        this.authService = authService;
        this.activatedRoute = activatedRoute;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.userEmail = "";
        this.customerName = "";
        this.loginSuccessHistoryList = [];
        this.loginFailureHistoryList = [];
        this.failureItems = null;
        this.temp_failure_list = null;
        this.successItems = null;
        this.temp_success_list = null;
        // Pagination
        this.page = 1;
        this.limit = 10;
        this.logpage = 1;
        this.loglimit = 50;
        this.isDomainListEmpty = true;
        this.showNewDomainField = false;
        this.domainListValues = [];
        this.validationError = null;
        this.userRole = null;
        this.isUserRoleAvailable = null;
        this.domainNameForm = new FormControl("");
        this.licenseError = false;
        this.licenseInfoData = {};
        this.isLicenseInfoReady = false;
        this.progressBarClass = "p-bar";
        this.enabledSmartLicense = false;
        this.supportLoginStatus = false;
        this.tooltips = {
            sso: new Tooltip()
                .setHTML('<div><div class="dynamic-tooltip-header"> Enable Single Sign-On </div><div class="dynamic-tooltip-desc">Single Sign On Authentication provides your users with a seamless authentication experience without creating an account in Cisco Spaces.</div></div>')
                .setPosition(POSITION.BOTTOM_RIGHT),
            global: new Tooltip()
                .setId("tip-026")
                .setPosition(POSITION.BOTTOM_RIGHT)
        };
        this.firstName = "";
        this.lastName = "";
        this.phoneNumber = "";
        this.isVerified = false;
        this.isUpdateProfile = false;
        this.fromPage = "account";
        this.isSSOLogin = false;
        this.isphoneNumberverify = false;
        this.countForSuccess = 10;
        this.countForFailure = 10;
        this.showMoreBtnSuccess = false;
        this.showMoreBtnFailure = false;
        this.changeLog = '';
        this.showLogFilterPopup = false;
        // applist: any={};
        this.users = {};
        this.changeLogOffset = 0;
        this.filterApplied = false;
        this.dateFilterType = 'All';
        this.selectAllApps = false;
        this.filterType_user = 'All';
        this.startDate = new DateFilter();
        this.endDate = new DateFilter();
        this.applist = [];
        this.userObj = [''];
        this.uncheckedAppsCount = 0;
        this.changelogsList = [];
        this.actuallogsList = [];
        this.param = { limit: 50, offset: 0 };
        this.filterParam = {};
        this.messageKeys = {};
        this.getLicenseDates = (data) => {
            console.log("getLicenseDates called ***");
            // data.licenseDuration = 24;
            // data.consumedAps = 300;
            // data.totalAps = 300;
            const duration = {
                months: null,
                years: null
            };
            const warn = {
                licenseStatus: "active",
                apLimit: false
            };
            const endDate = moment$m(Number(data.startDate)).add(data.licenseDuration, "M");
            const preMonth = moment$m(endDate).subtract(1, "M");
            if (moment$m().isAfter(endDate)) {
                this.licenseError = true;
                warn.licenseStatus = "expired";
            }
            else if (moment$m().isAfter(preMonth)) {
                this.licenseError = true;
                warn.licenseStatus = "soon";
            }
            if (data.consumedAps == data.totalAps) {
                this.licenseError = true;
                warn.apLimit = true;
            }
            const formattedEndDate = moment$m(endDate).format("MMM Do, YYYY");
            if (data.licenseDuration > 11) {
                duration.years = (data.licenseDuration / 12)
                    .toString()
                    .split(".")[0];
                duration.months = Number(Math.round(data.licenseDuration % 12));
            }
            else {
                duration.years = 0;
                duration.months = data.licenseDuration;
            }
            data.endDate = formattedEndDate;
            data.duration = duration;
            data.warn = warn;
            return data;
        };
        this.getUserRole = () => {
            this.authService.getRole(this.unsubscribe$).subscribe((roleBehavior) => {
                if (roleBehavior && roleBehavior.appRole) {
                    this.userRole = roleBehavior.appRole;
                    this.isUserRoleAvailable = true;
                    if (this.userRole == "RW") {
                        this.userRole = "Admin";
                    }
                    else if (this.userRole == "RO") {
                        this.userRole = "ReadOnlyAccess";
                    }
                }
            }, (error) => {
                this.isUserRoleAvailable = false;
                console.log(error);
            });
        };
        this.switchTab = (selectedTab) => {
            if (selectedTab === "accountActivity") {
                this.showNewDomainField = false;
                this.domainNameForm.setValue("");
                this.getSuccessLoginHistory();
                this.getFailureLoginHistory();
            }
            else if (selectedTab === "preference") {
                this.getdomainList();
                this.supportLoginStatus = false;
                this.getSupportLoginStatus();
            }
            else if (selectedTab === "myProfile") {
                this.getUserDetail();
            }
            else if (selectedTab === 'changeLog') {
                this.filterApplied = false;
                this.getChangeLog(this.param);
                this.changeLogOffset = 0;
            }
            else if (selectedTab === "licenseInformation") {
            }
            this.currentSelectedTab = selectedTab;
        };
        this.getSuccessLoginHistory = () => {
            this.dataService.display(true);
            this.locationService
                .getSuccessLoginHistory()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status && response.data.loginHistory) {
                    this.loginSuccessHistoryList =
                        response.data.loginHistory;
                    if (this.loginSuccessHistoryList &&
                        this.loginSuccessHistoryList.length > 0) {
                        const lastLoginVal = this.loginSuccessHistoryList[0].lastLogin;
                        this.lastLoginDate = moment$m
                            .utc(lastLoginVal)
                            .local()
                            .format("Do MMM YYYY, hh:mm A");
                        this.loginSuccessHistoryList.forEach((loginHistory) => {
                            const lastLoginVal1 = loginHistory.lastLogin;
                            loginHistory.lastLogin = moment$m
                                .utc(lastLoginVal1)
                                .local()
                                .format("Do MMM YYYY, hh:mm A");
                        });
                    }
                    this.initiateSuccessList();
                    this.dataService.display(false);
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys[response.message], 4000, null, null, "error");
                }
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys['loginHistoryError'], 4000, null, null, "error");
            });
        };
        this.initiateSuccessList = () => {
            if (this.loginSuccessHistoryList &&
                this.loginSuccessHistoryList.length > 0) {
                this.countForSuccess = 10;
                this.temp_success_list = [];
                for (let i = 0; i < this.countForSuccess; i++) {
                    if (this.loginSuccessHistoryList[i] != null) {
                        this.temp_success_list.push(this.loginSuccessHistoryList[i]);
                    }
                }
                this.checkShowMoreForSuccess();
            }
        };
        this.checkShowMoreForSuccess = () => {
            if (this.temp_success_list.length == this.loginSuccessHistoryList.length)
                this.showMoreBtnSuccess = false;
            else
                this.showMoreBtnSuccess = true;
        };
        this.showMoreClickSuccess = () => {
            this.countForSuccess = this.countForSuccess + 10;
            this.temp_success_list = [];
            for (let i = 0; i < this.countForSuccess; i++) {
                if (this.loginSuccessHistoryList[i] != null) {
                    this.temp_success_list.push(this.loginSuccessHistoryList[i]);
                }
            }
            this.checkShowMoreForSuccess();
        };
        this.getFailureLoginHistory = () => {
            this.dataService.display(true);
            this.locationService
                .getFailureLoginHistory()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status && response.data.loginHistory) {
                    this.loginFailureHistoryList =
                        response.data.loginHistory;
                    if (this.loginFailureHistoryList &&
                        this.loginFailureHistoryList.length > 0) {
                        this.loginFailureHistoryList.forEach((loginHistory) => {
                            const lastLoginVal1 = loginHistory.lastLogin;
                            loginHistory.lastLogin = moment$m
                                .utc(lastLoginVal1)
                                .local()
                                .format("Do MMM YYYY, hh:mm A");
                        });
                    }
                    this.initiateFailureList();
                    this.dataService.display(false);
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys[response.message], 4000, null, null, "error");
                }
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["loginHistoryError"], 4000, null, null, "error");
            });
        };
        this.initiateFailureList = () => {
            if (this.loginFailureHistoryList &&
                this.loginFailureHistoryList.length > 0) {
                this.countForFailure = 10;
                this.temp_failure_list = [];
                for (let i = 0; i < this.countForFailure; i++) {
                    if (this.loginFailureHistoryList[i] != null) {
                        this.temp_failure_list.push(this.loginFailureHistoryList[i]);
                    }
                }
                this.checkShowMoreForFailure();
            }
        };
        this.checkShowMoreForFailure = () => {
            if (this.temp_failure_list.length == this.loginFailureHistoryList.length)
                this.showMoreBtnFailure = false;
            else
                this.showMoreBtnFailure = true;
        };
        this.showMoreClickFailure = () => {
            this.countForFailure = this.countForFailure + 10;
            this.temp_failure_list = [];
            for (let i = 0; i < this.countForFailure; i++) {
                if (this.loginFailureHistoryList[i] != null) {
                    this.temp_failure_list.push(this.loginFailureHistoryList[i]);
                }
            }
            this.checkShowMoreForFailure();
        };
        this.getdomainList = () => {
            this.dataService.display(true);
            this.locationService
                .getDomainList()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status) {
                    console.log("response is :" + response);
                    this.formDomainresponse(response.data);
                }
                else {
                    this.isDomainListEmpty = true;
                    this.dataService.display(false);
                }
            }, (error) => {
                this.dataService.setToastMessage("An error occurred while getting domain list api", 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        this.getMoreChangeLog = (record) => {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
            this.param = { limit: record, offset: 0 };
            if (this.filterApplied) {
                this.filterdata['limit'] = record;
                this.filterLogData(this.filterdata);
            }
            else {
                this.getChangeLog(this.param);
            }
        };
        this.toLocaleTime = (date) => {
            const browserTimeZonedate = new Date(date).getTime() - this.timeZoneOffset;
            var format = 'YYYY/MM/DD HH:mm:ss';
            return moment$m(new Date(browserTimeZonedate)).format(format);
        };
        this.getChangeLog = (param) => {
            this.dataService.display(true);
            this.actuallogsList = this.changelogsList;
            this.changeLogData_paginated = this.changelogsList;
            this.authService.getChangeLog(param).pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                console.log("response received is ", response);
                if (response.status) {
                    this.changelogsList = response.data.data;
                    this.totalLogRecord = response.data.records;
                    console.log(" Audit trail response", response);
                    setTimeout(() => {
                        this.dataService.display(false);
                    }, 200);
                    if (response.data.data.length == 0) {
                        this.noDataFound = true;
                    }
                    else {
                        this.noDataFound = false;
                    }
                }
                else {
                    //no data found 
                    this.dataService.display(false);
                    this.noDataFound = true;
                }
            });
        };
        this.showLogDetailPopup = false;
        this.changelogDetail = {};
        this.showDetailPopup = (log) => {
            console.log("time is ", log.time);
            this.changelogDetail = log; //{time: "25th Mar 2021, 11:00 am",activity :log.activity ,app:log.app ,section :log.section ,user:log.user ,oldValue:log.sourceval ,newValue :log.destval };
            this.showLogDetailPopup = true;
            this.dataService.openMagneticPopup();
        };
        this.filterReset = () => {
            this.filterApplied = false;
            this.getChangeLog(this.param);
            this.filterParam = {};
            this.changelogsList = this.actuallogsList; //this.temp_success_list;
            this.changeLogData_paginated = this.changelogsList;
        };
        this.filterLogData = (paramJson) => {
            //api call  assign to changelogsList ;
            this.filterApplied = true;
            this.changelogsList = [];
            this.filterParam = paramJson;
            this.dataService.display(true);
            this.authService.getChangeLogFiltered(paramJson).pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                console.log(" Audit trail response", response);
                if (response.status && response.data.data) {
                    // this.logpage = 1;
                    // this.loglimit =50;
                    this.changelogsList = response.data.data;
                    this.totalLogRecord = response.data.records;
                    if (response.data.data.length == 0) {
                        this.noDataFound = true;
                    }
                    else {
                        this.noDataFound = false;
                    }
                    this.dataService.display(false);
                }
                else {
                    this.dataService.display(false);
                    this.noDataFound = true;
                }
            });
            //prepare prepopulated filter fields now
            this.filterdata = paramJson;
            //	var this.filterdata = JSON.parse(paramJson);
            this.dateFilterType = this.filterdata["dateFilterType"];
            this.selectAllApps = this.filterdata["appFilterType"];
            this.filterType_user = this.filterdata["userFilterType"];
            if (this.dateFilterType != 'All') {
                this.startDate.date = new Date(this.filterdata["startdate"]);
                this.endDate.date = new Date(this.filterdata["enddate"]);
            }
            else {
                this.startDate.date = new Date();
                this.endDate.date = new Date();
            }
            if (this.selectAllApps == false) {
                this.applist = paramJson.appforWindow;
            }
            if (this.filterType_user == 'select') {
                this.userObj = this.filterdata["users"];
            }
        };
        this.getCurrentPageItems = ($event) => {
            if (this.filterApplied) {
                this.filterLogData(this.filterParam);
                this.logpage = $event["thisPage"];
            }
            else {
                this.logpage = $event["thisPage"];
                this.getChangeLog($event);
            }
        };
        this.getCurrentItems = ($event) => {
            //console.log('currentl ist of items', $event);
            //here when drop down is selected reload items in changeLogData_paginated
            setTimeout(() => {
                this.changeLogData_paginated = $event;
            }, 100);
        };
        this.onFilter = ($event) => {
            setTimeout(() => {
                this.changeLogData_searched = $event;
            }, 100);
        };
        this.searchSkeleton = { "name": "string" };
        this.closeDetailPopup = () => {
            this.showLogDetailPopup = false;
            this.dataService.closeMagneticPopup();
        };
        this.onFilterLogClick = () => {
            //this.startDate.date = new Date();
            this.startDate.dateFormat = "DD/MM/YYYY";
            // this.endDate.date = new Date();
            this.endDate.dateFormat = "DD/MM/YYYY";
            this.showLogFilterPopup = true;
            this.dataService.openMagneticPopup();
            this.dataService.display(true);
        };
        this.onFilterLogClose = () => {
            this.showLogFilterPopup = false;
            this.dataService.closeMagneticPopup();
        };
        this.fetchChangeLogs = ($event) => {
            this.dataService.display(true);
            // fetch list based on limit $ = event and offset 
            this.loglimit = $event;
            setTimeout(() => {
                this.dataService.display(false);
            }, 100);
        };
        //pagination
        this.clickEvents = ($event) => {
            //console.log('there is a click event', $event);
        };
        this.formDomainresponse = (data) => {
            this.showNewDomainField = false;
            this.validationError = null;
            this.domainNameForm.setValue("");
            if (data && data.length > 0) {
                this.isDomainListEmpty = false;
                this.domainListValues = data;
            }
            else {
                this.isDomainListEmpty = true;
            }
            this.dataService.display(false);
        };
        this.addDomainRequest = (domain) => {
            this.validationError = null;
            this.dataService.display(true);
            this.locationService
                .addDomain(domain)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status) {
                    this.dataService.setToastMessage("Successfully added the domain", 4000, null, null, "success");
                    this.formDomainresponse(response.data);
                }
                else {
                    this.dataService.setToastMessage(response.message, 4000, null, null, "error");
                    this.dataService.display(false);
                }
            }, (error) => {
                this.dataService.setToastMessage("An error occurred while adding domain api", 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        this.removeDomainrequest = (domain) => {
            this.dataService.display(true);
            this.locationService
                .removeDomain(domain)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status) {
                    this.dataService.setToastMessage("Successfully deleted the domain", 4000, null, null, "success");
                    this.formDomainresponse(response.data);
                }
                else {
                    this.dataService.setToastMessage(response.message, 4000, null, null, "error");
                    this.dataService.display(false);
                }
            }, (error) => {
                this.dataService.setToastMessage("An error occurred while removing domain list api", 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        this.onSearchFailStatus = (searchText) => {
            if (searchText !== "") {
                this.failureItems = [];
                const failureList = this.loginFailureHistoryList;
                for (const key in failureList) {
                    if (this.searchInString(searchText, failureList[key].ipAddress, failureList[key].version, failureList[key].deviceType, failureList[key].userAgent, failureList[key].lastLogin)) {
                        if (failureList[key].isHidden === undefined) {
                            this.failureItems.push(failureList[key]);
                        }
                    }
                }
                this.temp_failure_list = this.failureItems;
            }
            else {
                this.temp_failure_list = this.loginFailureHistoryList;
            }
        };
        this.onSearchSuccessStatus = (searchText) => {
            if (searchText !== "") {
                this.successItems = [];
                const successList = this.loginSuccessHistoryList;
                for (const key in successList) {
                    if (this.searchInString(searchText, successList[key].ipAddress, successList[key].version, successList[key].deviceType, successList[key].userAgent, successList[key].lastLogin)) {
                        if (successList[key].isHidden === undefined) {
                            this.successItems.push(successList[key]);
                        }
                    }
                }
                this.temp_success_list = this.successItems;
            }
            else {
                this.temp_success_list = this.loginSuccessHistoryList;
            }
        };
        this.searchInString = (txt, ipAddress, version, deviceType, userAgent, formattedDate) => {
            for (let index = 0; index < ipAddress.length; index++) {
                if (ipAddress.toLowerCase().indexOf(txt) > -1) {
                    return true;
                }
                if (version.toLowerCase().indexOf(txt) > -1) {
                    return true;
                }
                if (deviceType.toLowerCase().indexOf(txt) > -1) {
                    return true;
                }
                if (userAgent.toLowerCase().indexOf(txt) > -1) {
                    return true;
                }
                if (formattedDate.toLowerCase().indexOf(txt) > -1) {
                    return true;
                }
            }
        };
        this.addNewDomain = (domain) => {
            domain = domain.trim();
            if (domain && domain.length != 0) {
                if (domain.indexOf("@") > 0 || /\s/.test(domain)) {
                    this.validationError = "Should not contain special character";
                }
                else {
                    domain =
                        domain.indexOf("@") == 0 ? domain.replace("@", "") : domain;
                    this.addDomainRequest(domain);
                }
            }
            else {
                this.showNewDomainField = true;
            }
        };
        this.removeDomain = (domain) => {
            this.removeDomainrequest(domain);
        };
        this.getUserDetail = () => {
            console.log("for testing :: account preference");
            // this.dataService.display(true);
            this.authService.getProfile(this.userEmail).subscribe((response) => {
                if (response != null) {
                    console.log("respose is :: " + JSON.stringify(response));
                    this.firstName = response.data.firstname;
                    this.lastName = response.data.lastname;
                    this.phoneNumber = response.data.phone;
                    this.isVerified = response.data.phoneverified;
                }
                // this.dataService.display(false);
            }, (error) => {
                this.dataService.display(false);
                console.log(error);
            });
        };
        this.onProfileEditClick = () => {
            this.isUpdateProfile = true;
            this.dataService.openMagneticPopup();
        };
        this.onHideProfilePopup = () => {
            this.getUserDetail();
            this.isUpdateProfile = false;
            this.dataService.closeMagneticPopup();
        };
        this.onClickVerification = ($event) => {
            this.isphoneNumberverify = true;
            this.dataService.openMagneticPopup();
        };
        this.onHideVerificationPopup = (event) => {
            console.log("on hide verfication popup :: " + JSON.stringify(event));
            this.isphoneNumberverify = false;
            this.dataService.closeMagneticPopup();
            this.getUserDetail();
        };
        this.onHideSmartLicensePopup = () => {
            // dummy call for output
        };
        this.getSupportLoginStatus = () => {
            this.dataService.display(true);
            this.locationService
                .getSupportLoginStatus()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status) {
                    console.log("Got the support login status :: " + response.data.supportLoggingStatus);
                    this.supportLoginStatus = response.data.supportLoggingStatus;
                    this.dataService.display(false);
                }
                else {
                    this.supportLoginStatus = false;
                    this.dataService.display(false);
                }
            }, (error) => {
                this.supportLoginStatus = false;
                this.dataService.display(false);
            });
        };
        this.toggleSupportLogin = () => {
            this.supportLoginStatus = !this.supportLoginStatus;
            // console.log("Support logging status going to change to :: " + this.supportLoginStatus)
            this.dataService.display(true);
            this.locationService
                .updateSupportLoginStatus(this.supportLoginStatus)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status) {
                    console.log("Successfully updated the status :: " + response.data.supportLoggingStatus);
                    this.dataService.setToastMessage(this.messageKeys[response.message.message], 4000, null, null, "success");
                    this.dataService.display(false);
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys[response.message], 4000, null, null, "error");
                    this.dataService.display(false);
                }
            }, (error) => {
                this.dataService.setToastMessage(this.messageKeys['dashboard.preference.support.login.status.failure'], 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.user-api-management.login-history.invalid-input').subscribe((res) => {
                this.messageKeys["user.loginhistory.list.input.invalid.error"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.login-history.no-details').subscribe((res) => {
                this.messageKeys["user.loginhistory.list.notavailable.error"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.login-history.error-occured').subscribe((res) => {
                this.messageKeys["loginHistoryError"] = res;
            });
            this.translate.get('dashboard-lib.preference.support_login.success.true').subscribe((res) => {
                this.messageKeys["dashboard.preference.support.login.status.success.true"] = res;
            });
            this.translate.get('dashboard-lib.preference.support_login.success.false').subscribe((res) => {
                this.messageKeys["dashboard.preference.support.login.status.success.false"] = res;
            });
            this.translate.get('dashboard-lib.preference.support_login.failure').subscribe((res) => {
                this.messageKeys["dashboard.preference.support.login.status.failure"] = res;
            });
        };
        this.changeLog = this.activatedRoute.snapshot.params.changeLog;
        console.log("change log coming", this.changeLog);
    }
    ngOnInit() {
        this.dataService.display(true);
        const currentDate = new Date();
        this.timeZoneOffset = currentDate.getTimezoneOffset() * 60000; // to milliseconds
        setTimeout(() => {
            this.enabledSmartLicense = this.dataService.getSmartLicenseEnableFeature();
            this.dataService.display(false);
        }, 3000);
        this.dataService
            .getIsAuthSSO(this.unsubscribe$)
            .subscribe((val) => {
            if (val != null) {
                this.isSSOLogin = val;
            }
        });
        this.userEmail = this.dataService.getUserName();
        this.customerName = this.dataService.getCustomerName();
        this.getUserDetail();
        this.currentSelectedTab = "myProfile";
        this.getUserRole();
        this.dataService
            .getLicenseDetails(this.unsubscribe$)
            .subscribe((val) => {
            if (val.tenantId) {
                if (moment$m(val.startDate, "YYYY-MM-DDTHH:mm:ss.sssZ", true).isValid()) {
                    val.startDate = String(moment$m(val.startDate).valueOf());
                }
                this.licenseInfo = val;
                this.licenseInfoData = this.getLicenseDates(val);
                this.isLicenseInfoReady = true;
            }
            else {
                this.isLicenseInfoReady = false;
            }
        });
        setTimeout(() => {
            if (this.dataService.getShowSLPage()) {
                this.switchTab('licenseInformation');
                this.dataService.setShowSLPage(false);
            }
            else if (this.dataService.getShowChangeLogPage()) {
                this.switchTab('changeLog');
                //this.getChangeLog(this.param);
                this.dataService.setShowChangeLogPage(false);
            }
        }, 100);
        this.filterApplied = false;
        this.startDate.date = new Date();
        this.startDate.dateFormat = "DD/MM/YYYY";
        this.endDate.date = new Date();
        this.endDate.dateFormat = "DD/MM/YYYY";
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
    }
    ngOnDestroy() {
        console.log("destory Account prefrence component");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
AccountPreferenceComponent.ɵfac = function AccountPreferenceComponent_Factory(t) { return new (t || AccountPreferenceComponent)(i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i2.TranslateService)); };
AccountPreferenceComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AccountPreferenceComponent, selectors: [["lib-account-preference"]], decls: 37, vars: 26, consts: [[1, "mainWrapper"], [1, "myAccountLabel"], [1, "subMainWrapper", "boxShadowBlur"], [1, "userDetails"], [1, "divTableAccountPreference"], [1, "divTableCell1"], [1, "userProfileIcon_grey"], [1, "divTableCell2"], [1, "customerName"], [1, "userName"], ["class", "lastLogin", 4, "ngIf"], ["class", "borderLeft divTableCell3", 4, "ngIf"], [1, "tab-wrapper"], [1, "tab-selection-wrapper"], [1, "tab-selection-header"], [1, "tab-header-block", 3, "ngClass", "click"], ["class", "tab-header-block", 3, "ngClass", "click", 4, "ngIf"], [4, "ngIf"], ["class", "userTableWrapper", 4, "ngIf"], ["class", "updateProfileBox", 4, "ngIf"], [1, "lastLogin"], [1, "borderLeft", "divTableCell3"], [1, "accountLabel"], [1, "accountNameDiv"], [1, "tenantIdDiv"], [1, "userTableWrapper"], [1, "loginHeader"], [3, "section", "emitSearch", "searchTextChange"], [1, "table", "userTable"], [1, "table-border"], [1, "rules-list-header"], [1, "h-col-1"], [1, "h-col-2"], [1, "h-col-3"], ["class", "table-border", 4, "ngIf"], ["class", "show_more_div", 4, "ngIf"], ["class", "tableTr", 4, "ngFor", "ngForOf"], [1, "tableTr"], [1, "userAccess"], [1, "show_more_div"], [1, "show_count"], ["class", "show-more", "id", "btn-expiry-showmore", 3, "click", 4, "ngIf"], ["id", "btn-expiry-showmore", 1, "show-more", 3, "click"], ["pmx-tooltip", "", "src", "/assets/images/info.svg", "alt", ".", 1, "info-img", 3, "tooltip"], ["class", "domainForm", 4, "ngIf"], ["class", "addnewtext", 3, "click", 4, "ngIf"], [1, "supportLogin_check", "boxShadowBlur"], [1, "header_supportLogin"], [1, "supportLogin_description"], [1, "enable_button"], ["type", "checkbox", "id", "support_enable", 1, "cmn-toggle", "cmn-toggle-round", 3, "checked", "click"], ["for", "support_enable", 1, "onoffswitch-label"], [4, "ngFor", "ngForOf"], [1, "domainForm"], [1, "user-input-wrp"], [1, ""], ["type", "text", "id", "domainfield", "name", "domainfield", "value", "@", "disabled", "", 1, "input-disabledtext"], ["type", "text", "id", "domainfield", "name", "domainfield", "disabled", "", 1, "inputText", "input-text", 3, "value"], ["class", "deleteicon", "src", "/assets/images/delete_icon_dark.svg", "width", "20", 3, "click", 4, "ngIf"], ["id", "add", "class", "domain_message", 4, "ngIf"], ["src", "/assets/images/delete_icon_dark.svg", "width", "20", 1, "deleteicon", 3, "click"], ["id", "add", 1, "domain_message"], ["type", "text", "id", "domainfield", "name", "domainfield", "required", "", 1, "inputText", 3, "formControl"], [1, "floating-label"], ["id", "add", 1, "btn", 3, "click"], ["id", "add", "class", "validationError", 4, "ngIf"], ["id", "add", 1, "validationError"], [1, "addnewtext", 3, "click"], ["src", "/assets/images/add.svg", "alt", "."], [1, "userName", "profileLable"], ["class", "profileLable", 3, "click", 4, "ngIf"], [1, "details_wrapper"], [1, "data_info_column"], [1, "info_row_title"], ["class", "info_row_value", 4, "ngIf"], ["class", "phone-subdiv", 4, "ngIf"], [1, "profileLable", 3, "click"], ["src", "assets/images/edit_blue.svg", "width", "15", 1, "profile_edit_icon"], [1, "edit_label"], [1, "info_row_value"], [1, "phone-subdiv"], ["class", "cancelButton verifyNumber", 3, "click", 4, "ngIf"], ["class", "verifiedText", 4, "ngIf"], [1, "cancelButton", "verifyNumber", 3, "click"], [1, "verifiedText"], ["src", "/assets/images/tick_mark_green.svg"], [3, "licenseInfo", "licenseInfoData", "fromPage", "onHideSmartLicensePopup", 4, "ngIf"], [3, "licenseInfo", "licenseInfoData", "fromPage", "onHideSmartLicensePopup"], [1, "logLabel"], ["class", "filter_label", 3, "click", 4, "ngIf"], ["class", "details_wrapper", 4, "ngIf"], ["class", "pageDetails", 4, "ngIf"], ["class", "noLogs_found", 4, "ngIf"], [1, "filter_label", 3, "click"], ["class", "filter_icon", "src", "/assets/images/basic/accesscode-manager/filter.svg", "alt", "AccessCodeManager Filter", 4, "ngIf"], ["class", "filter_icon", "src", "/assets/images/basic/filter_tick.svg", 4, "ngIf"], [1, "filter"], ["src", "/assets/images/basic/accesscode-manager/filter.svg", "alt", "AccessCodeManager Filter", 1, "filter_icon"], ["src", "/assets/images/basic/filter_tick.svg", 1, "filter_icon"], [1, "table", "logTable"], [1, "h-col-4"], [1, "h-col-5"], ["class", "logtableTr", 3, "click", 4, "ngFor", "ngForOf"], [1, "logtableTr", 3, "click"], [1, "userAccess", "activity"], [1, "pageDetails"], [3, "data", "shouldUseGlobalSearch", "searchSkeleton", "filtered", 4, "ngIf"], [3, "pagesToShow", "perPage", "page", "loading", "items", "totalRecords", "recordNumChange", "currentPage", "getItemsForThisPage", "clickEvent", "reloadMoreLogs"], [3, "data", "shouldUseGlobalSearch", "searchSkeleton", "filtered"], [1, "noLogs_found"], [1, "updateProfileBox"], [3, "email", "firstName", "lastName", "phoneNumberInput", "fromPage", "hideProfilePopup"], [3, "email", "phones", "onHideVerificationPopup"], [3, "logDetail", "onHideViewLogPopup"], [3, "dateFilterType", "selectAllApps", "applist", "filterType_user", "userFilterObj", "startDate", "endDate", "uncheckedAppsCount", "filterApplied", "onHideFilterLogPopup", "filterData", "filterReset"]], template: function AccountPreferenceComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2, "My Account");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵtext(8, "\uE930");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 9);
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(14, AccountPreferenceComponent_div_14_Template, 2, 1, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, AccountPreferenceComponent_div_15_Template, 7, 2, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 12);
        i0.ɵɵelementStart(17, "div", 13);
        i0.ɵɵelementStart(18, "div", 14);
        i0.ɵɵelementStart(19, "span", 15);
        i0.ɵɵlistener("click", function AccountPreferenceComponent_Template_span_click_19_listener() { return ctx.switchTab("myProfile"); });
        i0.ɵɵtext(20, " My Profile ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "span", 15);
        i0.ɵɵlistener("click", function AccountPreferenceComponent_Template_span_click_21_listener() { return ctx.switchTab("accountActivity"); });
        i0.ɵɵtext(22, " Account Activity ");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(23, AccountPreferenceComponent_span_23_Template, 2, 3, "span", 16);
        i0.ɵɵelementStart(24, "span", 15);
        i0.ɵɵlistener("click", function AccountPreferenceComponent_Template_span_click_24_listener() { return ctx.switchTab("preference"); });
        i0.ɵɵtext(25, " Preferences ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "span", 15);
        i0.ɵɵlistener("click", function AccountPreferenceComponent_Template_span_click_26_listener() { return ctx.switchTab("changeLog"); });
        i0.ɵɵtext(27, " Change Log ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(28, AccountPreferenceComponent_div_28_Template, 3, 2, "div", 17);
        i0.ɵɵtemplate(29, AccountPreferenceComponent_div_29_Template, 18, 5, "div", 18);
        i0.ɵɵtemplate(30, AccountPreferenceComponent_div_30_Template, 29, 9, "div", 18);
        i0.ɵɵtemplate(31, AccountPreferenceComponent_div_31_Template, 2, 1, "div", 17);
        i0.ɵɵtemplate(32, AccountPreferenceComponent_div_32_Template, 8, 4, "div", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(33, AccountPreferenceComponent_div_33_Template, 2, 5, "div", 19);
        i0.ɵɵtemplate(34, AccountPreferenceComponent_div_34_Template, 2, 2, "div", 19);
        i0.ɵɵtemplate(35, AccountPreferenceComponent_div_35_Template, 2, 1, "div", 19);
        i0.ɵɵtemplate(36, AccountPreferenceComponent_div_36_Template, 2, 9, "div", 19);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(11);
        i0.ɵɵtextInterpolate(ctx.customerName);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.userEmail);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.loginSuccessHistoryList && ctx.loginSuccessHistoryList.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isLicenseInfoReady);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c0$1v, ctx.currentSelectedTab === "myProfile"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c0$1v, ctx.currentSelectedTab === "accountActivity"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.enabledSmartLicense);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c0$1v, ctx.currentSelectedTab === "preference"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c0$1v, ctx.currentSelectedTab == "changeLog"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.currentSelectedTab === "accountActivity");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.currentSelectedTab === "preference");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.currentSelectedTab === "myProfile");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.currentSelectedTab === "licenseInformation" && ctx.enabledSmartLicense);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.currentSelectedTab == "changeLog" && ctx.changelogsList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isUpdateProfile);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isphoneNumberverify);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showLogDetailPopup);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showLogFilterPopup);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, SearchComponent, i1$2.NgForOf, TooltipDirective, i2$1.DefaultValueAccessor, i2$1.RequiredValidator, i2$1.NgControlStatus, i2$1.FormControlDirective, SmartLicenseBaseComponent, ChangeLogPaginationComponent, SearchBasicComponent, UpdateProfilePopupComponent, VerifyPhoneNumberComponent, ChangeLogDetailComponent, ChangeLogFilterComponent], styles: ["@font-face{font-family:\"ciscoSansRegular\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansBold\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansThin\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansExtraLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansCondensed\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.svg) format(\"svg\")}@font-face{font-family:\"ciscoSans\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"icomoon\";font-display:auto;src:url(/assets/fonts/icomoon.eot?llzbkh);src:url(/assets/fonts/icomoon.eot?llzbkh#iefix) format(\"embedded-opentype\"),url(/assets/fonts/icomoon.ttf?llzbkh) format(\"truetype\"),url(/assets/fonts/icomoon.woff?llzbkh) format(\"woff\"),url(/assets/fonts/icomoon.svg?llzbkh#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"icomoon-new\";font-display:auto;src:url(/assets/fonts/icomoonnew/icomoon.eot?-psryvp);src:url(/assets/fonts/icomoonnew/icomoon.eot?#iefix-psryvp) format(\"embedded-opentype\"),url(/assets/fonts/icomoonnew/icomoon.ttf?-psryvp) format(\"truetype\"),url(/assets/fonts/icomoonnew/icomoon.woff?-psryvp) format(\"woff\"),url(/assets/fonts/icomoonnew/icomoon.svg?-psryvp#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"Roboto-Bold\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Bold.eot);src:url(/assets/fonts/Roboto/Roboto-Bold.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Bold.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Bold.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Bold.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Bold.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Light\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Light.eot);src:url(/assets/fonts/Roboto/Roboto-Light.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Light.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Light.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Light.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Light.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Medium\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Medium.eot);src:url(/assets/fonts/Roboto/Roboto-Medium.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Medium.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Medium.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Medium.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Medium.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Regular\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Regular.eot);src:url(/assets/fonts/Roboto/Roboto-Regular.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Regular.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Regular.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Regular.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Regular.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Inter\";font-display:auto;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}.setup_Container[_ngcontent-%COMP%]{display:block;position:relative;width:auto;height:auto;margin:1%}.platform_container[_ngcontent-%COMP%]{position:relative}.tab-selection-wrapper[_ngcontent-%COMP%]{background:#fff;border-bottom:1px solid #dee0e1}.tab-selection-header[_ngcontent-%COMP%]{padding:15px 15px 10px 40px;border-bottom:4px solid #ffffff}.tab-header-block[_ngcontent-%COMP%]{padding:20px 20px 10px;font-size:16px;cursor:pointer}.selected[_ngcontent-%COMP%]{font-weight:bold;border-bottom:4px solid #059fd9}.mainWrapper[_ngcontent-%COMP%]{margin:60px}.myAccountLabel[_ngcontent-%COMP%]{padding:10px 0;font-size:20px;font-family:ciscoSansLight}.subMainWrapper[_ngcontent-%COMP%]{padding:20px 50px;background-color:#fff}.userDetails[_ngcontent-%COMP%]{padding-bottom:20px}.loginHeader[_ngcontent-%COMP%]{padding:10px 0;font-size:16px;font-weight:bold}.userTableWrapper[_ngcontent-%COMP%]{padding-top:40px;padding-bottom:400px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:30%;padding-left:15px}.table.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:30%}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%]{text-align:center;display:none}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   div.userActionsMenu[_ngcontent-%COMP%]{display:block}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative;padding:0 10px;text-decoration:none;outline:none}.divTableAccountPreference[_ngcontent-%COMP%]{display:table;width:100%;font-size:12px;padding:2% 0}.divTableCell1[_ngcontent-%COMP%]{display:inline-block;width:110px;vertical-align:middle}.divTableCell2[_ngcontent-%COMP%]   .customerName[_ngcontent-%COMP%]{text-align:left;font-size:16px;font-weight:bold;color:#000;padding-bottom:5px;font-family:ciscoSans}.divTableCell2[_ngcontent-%COMP%]   .userName[_ngcontent-%COMP%]{text-align:left;font-weight:bold;color:#000;padding-bottom:5px;font-size:14px;font-family:ciscoSansThin}.divTableCell2[_ngcontent-%COMP%]   .lastLogin[_ngcontent-%COMP%]{text-align:left;color:#000;padding-bottom:5px;font-size:12px}.divTableCell2[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;width:29%}.divTableCell3[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}.borderLeft[_ngcontent-%COMP%]{border-left:1px solid #d4d4d4;padding-left:5%}.accountLabel[_ngcontent-%COMP%]{padding-bottom:5px;font-size:14px}.accountNameDiv[_ngcontent-%COMP%]{font-size:24px;padding-bottom:5px;font-family:ciscoSans}.userProfileIcon_grey[_ngcontent-%COMP%]{font-size:100px;color:#d8d8d8;margin-bottom:5px;display:inline-block;font-family:icomoon-new}.boxShadowBlur[_ngcontent-%COMP%]{box-shadow:0 0 1px #00000080}.addnewtext[_ngcontent-%COMP%]{padding:10px;color:#049fd9;font-weight:bolder;cursor:pointer;width:15%}.domainForm[_ngcontent-%COMP%]{padding-left:30px;padding-top:10px;clear:left;position:relative}.domainForm[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{text-align:left;font-family:\"ciscoSans\";font-size:14px;padding:15px 0}.domainForm[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{position:relative;top:5px;font-family:ciscoSans;color:#565659;font-size:12px;letter-spacing:.5px}.user-input-wrp[_ngcontent-%COMP%]{position:relative}.user-input-wrp[_ngcontent-%COMP%]   .inputText[_ngcontent-%COMP%]{width:20%;outline:none;border:none;border-bottom:1px solid #a7a9ab;margin-bottom:2px}.user-input-wrp[_ngcontent-%COMP%]   .inputText[_ngcontent-%COMP%]:invalid{box-shadow:none!important}.user-input-wrp[_ngcontent-%COMP%]   .inputText[_ngcontent-%COMP%]:focus{border-bottom:2px solid #059fd9}.user-input-wrp[_ngcontent-%COMP%]   .input-disabledtext[_ngcontent-%COMP%]{width:2%;outline:none;border:none;border-bottom:1px solid #a7a9ab;margin-bottom:2px}.user-input-wrp[_ngcontent-%COMP%]   .floating-label[_ngcontent-%COMP%]{position:absolute;pointer-events:none;top:40px;left:20px;font-family:ciscoSans;color:gray;font-size:14px;transition:.2s ease all}.user-input-wrp[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus ~ .floating-label[_ngcontent-%COMP%], .user-input-wrp[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:not(:focus):valid ~ .floating-label[_ngcontent-%COMP%]{top:0px;left:0;font-family:\"ciscoSans\";color:#000;font-size:12px;opacity:1}.btn[_ngcontent-%COMP%]{font-size:13px;background:#049fd9;display:inline-block;font-family:ciscoSansBold;cursor:pointer;border-radius:6px;letter-spacing:.5px;color:#fff;width:75px;padding:10px;text-align:center;margin-left:10px}.border[_ngcontent-%COMP%]{border-left:2px solid #dee0e1}.validationError[_ngcontent-%COMP%]{font-size:13px;display:inline-block;font-family:ciscoSansBold;letter-spacing:.5px;color:red;padding:10px;text-align:center;margin-left:10px}.info-img[_ngcontent-%COMP%]{margin-left:10px;height:15px}.domain_message[_ngcontent-%COMP%]{display:inline-block;margin-left:20px;font-size:12px;color:#f96969}.deleteicon[_ngcontent-%COMP%]{cursor:pointer}.profile_edit_icon[_ngcontent-%COMP%]{margin-left:25px;margin-top:-1px;cursor:pointer}.edit_label[_ngcontent-%COMP%]{font-family:ciscoSansRegular;color:#049fd9;font-size:15px;margin-left:10px;cursor:pointer;margin-top:3px}.profileLable[_ngcontent-%COMP%]{display:flex;font-family:ciscoSansRegular}.logLabel[_ngcontent-%COMP%]{display:flex;font-family:ciscoSansRegular}.filter_label[_ngcontent-%COMP%]{float:right;cursor:pointer}.filter[_ngcontent-%COMP%]{display:inline;color:#059fd9;padding:5px;font-size:14px}.filter[_ngcontent-%COMP%]:hover{cursor:pointer}.filter_icon[_ngcontent-%COMP%]{display:inline;width:30%}.activity[_ngcontent-%COMP%]{color:#059fd9}.updateProfileBox[_ngcontent-%COMP%]{top:50px;left:0;width:100%;height:450px;background-color:#fff}.details_wrapper[_ngcontent-%COMP%]{margin-top:20px;display:flex}.data_info_column[_ngcontent-%COMP%]{width:25%}.info_row_title[_ngcontent-%COMP%]{font-family:ciscoSansRegular;color:#58585b;font-size:11px}.info_row_value[_ngcontent-%COMP%]{font-family:ciscoSansLight;color:#000;font-size:16px;margin-top:10px}.phone-subdiv[_ngcontent-%COMP%]{display:flex}.verifyNumber[_ngcontent-%COMP%]{margin:12px!important;font-size:12px!important}.verifiedText[_ngcontent-%COMP%]{margin-top:10%;margin-left:-34%;font-size:14px;color:green}.rules-list-header[_ngcontent-%COMP%]{background:#ffffff;border-bottom:1px solid #dddfe2}.table-border[_ngcontent-%COMP%]{box-shadow:0 0 1px #0003}.h-col-1[_ngcontent-%COMP%]{width:25%;padding:0 25px}.h-col-2[_ngcontent-%COMP%]{width:25%}.h-col-3[_ngcontent-%COMP%]{width:25%}.show_more_div[_ngcontent-%COMP%]{display:flex;padding:10px 0 10px 5px}.show_count[_ngcontent-%COMP%]{font-size:12px;color:#000;font-family:\"ciscoSansRegular\"}.show-more[_ngcontent-%COMP%]{color:#049fd9;cursor:pointer;font-size:12px;font-family:\"ciscoSansRegular\";margin-left:40px}.logTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .logTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:20%;padding-left:15px}.table.logTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.logTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .logTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:20%}.logTable[_ngcontent-%COMP%]   .logtableTr[_ngcontent-%COMP%]:hover{background:#f5f5f5;cursor:pointer}.logLabel[_ngcontent-%COMP%]{display:block;font-family:ciscoSansRegular}.pageDetails[_ngcontent-%COMP%]{display:inline}.modalPopup[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{height:575px;z-index:1001;position:absolute;left:50%;top:150px;transform:translate(-50%);width:70%!important;background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden;margin-bottom:50px}.noDataFound[_ngcontent-%COMP%]{margin:289px 321px 93px 525px;font-size:24px;height:160px;color:gray}.logTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\",sans-serif;font-size:14px;font-weight:400;padding:14px 18px;vertical-align:middle;text-align:left;margin:0}.logTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{background:#fff!important;cursor:pointer}.logTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover{background:#cceeff!important;border:1px solid #049FD9}.noLogs_found[_ngcontent-%COMP%]{padding:235px 100px 300px 380px;font-size:31px;color:#6c757d}.logTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{cursor:none}.table-border[_ngcontent-%COMP%]:hover{background:#fff!important;border:none!important}.onoffswitch-label[_ngcontent-%COMP%]{display:block;overflow:hidden;cursor:pointer;border-radius:0;top:20px}.cmn-toggle[_ngcontent-%COMP%]{position:absolute;margin-left:-9999px;visibility:hidden}input.cmn-toggle-round[_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]:before{background-color:#049fd9}input.cmn-toggle-round[_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]:after{margin-left:28px}input.cmn-toggle-round[_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{font-size:14px;padding:2px;width:65px;height:30px;border-radius:10px}input.cmn-toggle-disabled[_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:after{background-color:#fafafa!important}input.cmn-toggle-round[_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:after{width:26px;height:20px;margin:4px;background-color:#fff;border-radius:5px;box-shadow:0 2px 5px #00000080;transition:margin .4s;-webkit-box-shadow:0 2px 5px rgba(0,0,0,.5);-webkit-transition:margin .4s}input.cmn-toggle-round[_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:before, input.cmn-toggle-round[_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:after{display:block;position:absolute;top:1px;left:1px;bottom:1px;content:\"\"}input.cmn-toggle-round[_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:before{right:1px;height:30px;background-color:#dfdfdf;transition:background .4s}.cmn-toggle[_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{display:block;position:relative;cursor:pointer;outline:none;-webkit-user-select:none;user-select:none}.supportLogin_check[_ngcontent-%COMP%]{display:block;width:100%;padding:30px;position:relative;margin-top:10px}span.header_supportLogin[_ngcontent-%COMP%]{display:block;font-family:\"ciscoSansLight\";font-size:20px;margin-bottom:7px}.enable_button[_ngcontent-%COMP%]{display:inline-block;position:absolute;right:53px;top:26px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccountPreferenceComponent, [{
        type: Component,
        args: [{
                selector: "lib-account-preference",
                templateUrl: "./account-preference.component.html",
                styleUrls: ["./account-preference.component.scss"]
            }]
    }], function () { return [{ type: LocationService }, { type: DataService }, { type: AuthService }, { type: i1.ActivatedRoute }, { type: i2.TranslateService }]; }, null); })();

function AnalyticsDropdownComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function AnalyticsDropdownComponent_div_1_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.expandDropdown($event); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", ctx_r0.dropdownId);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedItem.name, " ");
} }
const _c0$1u = function (a0) { return { "placeHolderColor": a0 }; };
function AnalyticsDropdownComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function AnalyticsDropdownComponent_div_2_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.expandDropdown($event); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$1u, ctx_r1.placeHolder !== "Select"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.placeHolder, " ");
} }
function AnalyticsDropdownComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function AnalyticsDropdownComponent_div_3_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const item_r9 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.selectItem(item_r9); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r9.name, " ");
} }
function AnalyticsDropdownComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, AnalyticsDropdownComponent_div_3_div_1_Template, 2, 1, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.listItemsArry);
} }
function AnalyticsDropdownComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵtext(2, "List Unavailable");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c1$C = function (a0) { return { "dropdownExpand": a0 }; };
class AnalyticsDropdownComponent {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() {
        this.dropdownId = "";
        this.dropdownSelect = new EventEmitter();
        this.dropdownSelectRestriction = new EventEmitter();
        this.dropdownExpand = false;
        this.expandDropdown = (event) => {
            this.dropdownExpand = !this.dropdownExpand;
            if (this.dropdownExpand) {
                if (this.dropdownId) {
                    const dropDown = document.getElementById(this.dropdownId);
                    if (dropDown) {
                        setTimeout(() => {
                            dropDown.scrollIntoView();
                        }, 200);
                    }
                }
            }
        };
        this.selectItem = (selectedItem) => {
            if (selectedItem.isSelect == null ||
                selectedItem.isSelect == undefined ||
                selectedItem.isSelect) {
                this.selectedItem = selectedItem;
                this.dropdownSelect.emit(selectedItem);
                this.expandDropdown(false);
            }
            else {
                this.expandDropdown(false);
                this.dropdownSelectRestriction.emit(selectedItem);
            }
        };
    }
    set listItems(listItems) {
        this.listItemsArry = listItems;
    }
    ngOnInit() {
        this.placeHolder = this.placeHolder ? this.placeHolder : "Select";
    }
}
AnalyticsDropdownComponent.ɵfac = function AnalyticsDropdownComponent_Factory(t) { return new (t || AnalyticsDropdownComponent)(); };
AnalyticsDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AnalyticsDropdownComponent, selectors: [["lib-analytics-dropdown"]], inputs: { selectedItem: "selectedItem", placeHolder: "placeHolder", listItems: "listItems", dropdownId: "dropdownId" }, outputs: { dropdownSelect: "dropdownSelect", dropdownSelectRestriction: "dropdownSelectRestriction" }, decls: 5, vars: 7, consts: [[1, "analyticsDropdownContainer", 3, "ngClass"], ["class", "selectedDropdown", 3, "id", "click", 4, "ngIf"], ["class", "selectedDropdown", 3, "ngClass", "click", 4, "ngIf"], ["class", "analyticsDropdownList", 4, "ngIf"], [1, "selectedDropdown", 3, "id", "click"], [1, "selectedDropdown", 3, "ngClass", "click"], [1, "analyticsDropdownList"], ["class", "eachElement", 3, "click", 4, "ngFor", "ngForOf"], [1, "eachElement", 3, "click"], [1, "eachElement"]], template: function AnalyticsDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, AnalyticsDropdownComponent_div_1_Template, 2, 2, "div", 1);
        i0.ɵɵtemplate(2, AnalyticsDropdownComponent_div_2_Template, 2, 4, "div", 2);
        i0.ɵɵtemplate(3, AnalyticsDropdownComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵtemplate(4, AnalyticsDropdownComponent_div_4_Template, 3, 0, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1$C, ctx.dropdownExpand));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listItemsArry && ctx.listItemsArry.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listItemsArry === undefined || ctx.listItemsArry.length === 0);
    } }, directives: [i1$2.NgClass, i1$2.NgIf, i1$2.NgForOf], styles: ["@charset \"UTF-8\";.analyticsDropdownContainer[_ngcontent-%COMP%]{width:100%;display:block;margin:10px 0;position:relative}.analyticsDropdownContainer[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{width:12px;height:12px;color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;top:6px;right:4px;padding:4px;font-size:14px;display:block;content:\"\\e905\";z-index:100}.analyticsDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{content:\"\\e908\"}.selectedDropdown[_ngcontent-%COMP%]{background-color:#fff;border-bottom:1px solid #9E9EA2;width:100%;border-radius:0;cursor:pointer;padding:8px 24px 8px 10px;position:relative;color:#333439;font-family:ciscoSans;font-size:14px}.analyticsDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]{border-color:#049fd9}.analyticsDropdownList[_ngcontent-%COMP%]{display:none;width:100%;position:absolute;top:38px;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:103;box-shadow:0 0 3px #0000004d;overflow:scroll}.analyticsDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .analyticsDropdownList[_ngcontent-%COMP%]{display:block;background-color:#fff;z-index:9999}.analyticsDropdownContainer[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]{display:block;padding:12px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.analyticsDropdownContainer[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]:hover{color:#666;background-color:#39393b1a}.dropdownFilterOverlay[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:100;background-color:#0003}.placeHolderColor[_ngcontent-%COMP%]{color:#898989}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AnalyticsDropdownComponent, [{
        type: Component,
        args: [{
                selector: "lib-analytics-dropdown",
                templateUrl: "./analytics-dropdown.component.html",
                styleUrls: ["./analytics-dropdown.component.scss"]
            }]
    }], function () { return []; }, { selectedItem: [{
            type: Input
        }], placeHolder: [{
            type: Input
        }], listItems: [{
            type: Input
        }], dropdownId: [{
            type: Input
        }], dropdownSelect: [{
            type: Output
        }], dropdownSelectRestriction: [{
            type: Output
        }] }); })();

function RowMenuComponent_li_8_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 26);
    i0.ɵɵlistener("click", function RowMenuComponent_li_8_Template_li_click_0_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.renameLocation($event); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Rename ", ctx_r0.getLocationName(), "");
} }
function RowMenuComponent_li_9_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 28);
    i0.ɵɵlistener("click", function RowMenuComponent_li_9_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.wirelessNetwork("add"); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Connect Wireless Networks");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_10_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 29);
    i0.ɵɵlistener("click", function RowMenuComponent_li_10_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.editWLC(); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 30);
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Connect Wireless Networks");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 31);
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Edit Ruckus");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 32);
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Connect Wireless Networks");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 33);
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Edit Aruba");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_15_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 34);
    i0.ɵɵlistener("click", function RowMenuComponent_li_15_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.createGroup(); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Create Group");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 35);
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Connect Wireless Networks");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_17_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 36);
    i0.ɵɵlistener("click", function RowMenuComponent_li_17_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.editGroup(); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Edit Group");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_18_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 37);
    i0.ɵɵlistener("click", function RowMenuComponent_li_18_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(); return ctx_r31.addCampus(); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Add Campus");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 38);
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Add Location");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_20_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 39);
    i0.ɵɵlistener("click", function RowMenuComponent_li_20_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(); return ctx_r33.addBuilding(); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Add Building");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_21_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 40);
    i0.ɵɵlistener("click", function RowMenuComponent_li_21_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(); return ctx_r35.addMerakiNetwork(); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Add Network");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_22_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 41);
    i0.ɵɵlistener("click", function RowMenuComponent_li_22_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(); return ctx_r37.addWLCNetwork(); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Add Network");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_23_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 42);
    i0.ɵɵlistener("click", function RowMenuComponent_li_23_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(); return ctx_r39.addFloor(); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Add Floor");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_24_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 43);
    i0.ɵɵlistener("click", function RowMenuComponent_li_24_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r42); const ctx_r41 = i0.ɵɵnextContext(); return ctx_r41.addZone(); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Add Zone");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_25_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 43);
    i0.ɵɵlistener("click", function RowMenuComponent_li_25_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r44); const ctx_r43 = i0.ɵɵnextContext(); return ctx_r43.addCMXZone(); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Add CMX Zone");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_26_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 44);
    i0.ɵɵlistener("click", function RowMenuComponent_li_26_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r46); const ctx_r45 = i0.ɵɵnextContext(); return ctx_r45.addMetaDataPopup(); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Add/Edit Metadata");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_27_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 45);
    i0.ɵɵlistener("click", function RowMenuComponent_li_27_Template_li_click_0_listener($event) { i0.ɵɵrestoreView(_r48); const ctx_r47 = i0.ɵɵnextContext(); return ctx_r47.deleteLocation($event); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Delete Location");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function RowMenuComponent_li_28_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 46);
    i0.ɵɵlistener("click", function RowMenuComponent_li_28_Template_li_click_0_listener($event) { i0.ɵɵrestoreView(_r50); const ctx_r49 = i0.ɵɵnextContext(); return ctx_r49.deleteFloor($event); });
    i0.ɵɵelementStart(1, "a", 27);
    i0.ɵɵtext(2, "Delete Location");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class RowMenuComponent {
    constructor(dataService, interactionService) {
        this.dataService = dataService;
        this.interactionService = interactionService;
        this.locationFlag = new LocationFlag();
        this.showRenamePopup = false;
        this.closeMenu = (event) => {
            // console.log('menu close', event, 'this.node', this.node);
            this.dataService.setOpenLocationMenu(false);
            this.node.showMenu = false;
        };
        this.addMenu = (flag) => {
            let locationBitFlag = this.node.locationBit;
            // no restriction for add/edit metadata
            if (flag !== 262144 && this.node.access.toLowerCase() === "read") {
                locationBitFlag &= this.locationFlag.locationAccess.read;
            }
            //   console.log('flag ', flag, 'this.node.locationBit', this.node.locationBit,
            //     'condn', flag == null || this.node.locationBit & flag, 'location Access',
            //     this.node.access, 'locationBitFlag', locationBitFlag);
            // Do not show add floor to meraki network location
            const merakiNetwork = flag === this.locationFlag.Flags.ADD_FLOOR &&
                this.node.networkDetails &&
                this.node.networkDetails.wirelessProvider === "MERAKI";
            // add floor option removed for created source of Webex and excel import
            // const webexSource =
            // 	flag === this.locationFlag.Flags.ADD_FLOOR &&
            // 	this.node.networkDetails &&
            // 	this.node.networkDetails.wirelessProvider === "WEBEX";
            // const excelSource =
            // 	flag === this.locationFlag.Flags.ADD_FLOOR &&
            // 	this.node.networkDetails &&
            // 	this.node.networkDetails.wirelessProvider === "EXCEL";
            const wlcNetwork = flag === this.locationFlag.Flags.ADD_FLOOR &&
                this.node.networkDetails &&
                this.node.networkDetails.type === "WLC_NODE";
            // for root location without children - create group option removed
            let noChildren = this.node && this.node.children
                ? this.node.children.length > 0
                    ? true
                    : false
                : false;
            if (this.node.children == undefined) {
                noChildren = true;
            }
            else if (this.node.children && this.node.children.length == 0) {
                noChildren = true;
            }
            else if (this.node.children && this.node.children.length > 0) {
                noChildren = false;
            }
            const rootWithoutChild = flag === this.locationFlag.Flags.ADD_GROUP && noChildren;
            const manualMSE = flag === this.locationFlag.Flags.EDIT_MSE &&
                !this.node.networkDetails.wirelessProvider &&
                this.node.type === "mse";
            // Campus Inside Campus 
            let campusInsideCampus = false;
            if (this.node.type == 'campus') {
                if (this.node.children && this.node.children.length > 0) {
                    this.node.children.forEach(child => {
                        if (child.type == 'campus') {
                            campusInsideCampus = true;
                        }
                    });
                }
            }
            const nestedCampus = flag === this.locationFlag.Flags.DELETE_LOCATION && campusInsideCampus;
            // Group -> Campus -> Campus 
            let groupCampusCampus = false;
            if (this.node.type == 'group') {
                if (this.node.children && this.node.children.length > 0) {
                    this.node.children.forEach(child => {
                        if (child.type == 'campus') {
                            if (child.children && child.children.length > 0) {
                                child.children.forEach(groupChild => {
                                    if (groupChild.type == 'campus') {
                                        groupCampusCampus = true;
                                    }
                                });
                            }
                        }
                    });
                }
            }
            const nestedGroupCampusCampus = flag === this.locationFlag.Flags.DELETE_LOCATION && groupCampusCampus;
            // Campus -> Group -> Campus 
            let campusGroupCampus = false;
            if (this.node.type == 'campus') {
                if (this.node.children && this.node.children.length > 0) {
                    this.node.children.forEach(child => {
                        if (child.type == 'group') {
                            if (child.children && child.children.length > 0) {
                                child.children.forEach(groupChild => {
                                    if (groupChild.type == 'campus') {
                                        campusGroupCampus = true;
                                    }
                                });
                            }
                        }
                    });
                }
            }
            const nestedCampusGroupCampus = flag === this.locationFlag.Flags.DELETE_LOCATION && campusGroupCampus;
            // Group -> Campus -> Group -> Campus 
            let groupCampusGroupCampus = false;
            if (this.node.type == 'group') {
                if (this.node.children && this.node.children.length > 0) {
                    this.node.children.forEach(child => {
                        if (child.type == 'campus') {
                            if (child.children && child.children.length > 0) {
                                child.children.forEach(campusChild => {
                                    if (campusChild.type == 'group') {
                                        if (campusChild.children && campusChild.children.length > 0) {
                                            campusChild.children.forEach(groupChild => {
                                                if (groupChild.type == 'campus') {
                                                    groupCampusGroupCampus = true;
                                                }
                                            });
                                        }
                                    }
                                });
                            }
                        }
                    });
                }
            }
            const nestedGroupCampusGroupCampus = flag === this.locationFlag.Flags.DELETE_LOCATION && groupCampusGroupCampus;
            if ((flag == null || locationBitFlag & flag) &&
                !merakiNetwork &&
                !rootWithoutChild &&
                !wlcNetwork &&
                !manualMSE &&
                !nestedCampus &&
                !nestedGroupCampusCampus &&
                !nestedCampusGroupCampus &&
                !nestedGroupCampusGroupCampus) {
                return true;
            }
            return false;
        };
        this.renameLocation = (event) => {
            //this.node.showMenu = false;
            //console.log("Rename - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "renameLocation";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.deleteLocation = (event) => {
            //this.node.showMenu = false;
            //console.log("Delete - ", this.node.name);
            //console.log("Can Delete?", this.node);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "deleteLocation";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.changeLocationTimezone = (event) => {
            //console.log("Timezone Update - ", this.node.name);
            //console.log("Current Timezone?", this.node);
            if (this.node.access.toLowerCase() === "read") {
                return;
            }
            const locationActionObj = new LocationAction();
            locationActionObj.type = "timezoneLocation";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.deleteAerohiveLocation = (event) => {
            //this.node.showMenu = false;
            //console.log("Delete - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "deleteLocation";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.deleteFloor = (event) => {
            //this.node.showMenu = false;
            //console.log("Delete - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "deleteLocation";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.wirelessNetwork = (action) => {
            //console.log("Add wireless network - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "wirelessnetwork";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.dnaNetworkSetup = (action) => {
            //console.log("Add wireless network - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "dnanetworksetup";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.editWLC = () => {
            //console.log("Edit CMX - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "editwlc";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.editMSE = () => {
            //console.log("Edit CMX - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "editmse";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.addCampus = () => {
            //console.log("Adding Campus - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "addcampus";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.addBuilding = () => {
            //console.log("Adding Building - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "addbuilding";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.addFloor = () => {
            //console.log("Adding Building - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "addfloor";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.addMerakiNetwork = () => {
            //console.log("Adding Meraki Network - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "addnetwork";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.addWLCNetwork = () => {
            //console.log("Adding Meraki Network - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "addwlcnetwork";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.addZone = () => {
            //console.log("Adding Meraki Network - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "addzone";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.addCMXZone = () => {
            //console.log("Adding Meraki Network - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "addcmxzone";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.addMetaDataPopup = () => {
            console.log("Add Metadata Popup");
            const locationActionObj = new LocationAction();
            locationActionObj.type = "addmetadata";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.showlocationInfoPopup = () => {
            console.log("open location Info Popup");
            const locationActionObj = new LocationAction();
            locationActionObj.type = "showlocationinfo";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.createGroup = () => {
            //console.log("Create Group - ", this.node.name);
            const locationActionObj = new LocationAction();
            locationActionObj.type = "creategroup";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
        this.editGroup = () => {
            const locationActionObj = new LocationAction();
            locationActionObj.type = "editgroup";
            locationActionObj.data = this.node;
            this.dataService.doLocationAction(locationActionObj);
            this.node.showMenu = false;
        };
    }
    ngOnInit() {
        if (this.dataService.getOpenPopUpFromSetup() == "add_wireless_network")
            this.wirelessNetwork("add");
        if (this.dataService.getOpenPopUpFromSetup() == "dna_network_setup")
            this.dnaNetworkSetup("add");
        // console.log(this.locationFlag.Flags);
        if (this.dataService.getOpenLocationMenu()) {
            const userNameForInteractionLog = this.dataService.getUserName();
            const logStr = "VIEW: User " +
                userNameForInteractionLog +
                "  has viewed more actions";
            this.interactionService.doInteractionLog(new InteractionLog(TYPE.VIEW, this.dataService.getPosition(), "{}", SECTION.LOCATIONS, ITEM_TYPE.POPUP, ITEM.MORE_ACTIONS, logStr, this.dataService.getCurrentNav()));
            this.dataService.setOpenLocationMenu(false);
        }
        // console.log(this.node.name, this.node.locationBit);
        // this.locationFlag.whichFlagsAreSet(this.node.locationBit);
    }
    ngOnDestroy() {
        if (this.dataService.getOpenPopUpFromSetup())
            this.dataService.setOpenPopUpFromSetup("");
        this.node.showMenu = false; // wnats to hide more options
    }
    getLocationName() {
        let name = this.node.name;
        let regExp = new RegExp('<span class="highlighted">', "gi");
        if (name != undefined) {
            name = name.replace(regExp, "");
            regExp = new RegExp("</span>", "gi");
            name = name.replace(regExp, "");
        }
        return name.length > 10 ? name.substring(0, 10) + "..." : name;
    }
    getTimezoneId() {
        return this.node.timeZoneId ? this.node.timeZoneId : "GMT +00.00 (UTC)";
    }
}
RowMenuComponent.ɵfac = function RowMenuComponent_Factory(t) { return new (t || RowMenuComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(InteractionService)); };
RowMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RowMenuComponent, selectors: [["lib-row-menu"]], inputs: { node: "node" }, decls: 29, vars: 21, consts: [[1, "menu-l", "show-menu"], [1, "moreactions-div"], [1, "moreactions-title"], ["align", "right", 1, "close-menu", "moreactions-close", "menuIcon", "menuCloseIcon", 3, "click"], ["src", "/assets/images/close_white.png", "alt", ".", 1, "menu-close-img"], [1, "action-list"], ["class", "location-rename", 3, "click", 4, "ngIf"], ["class", "add-wireless-network-universal", 3, "click", 4, "ngIf"], ["class", "edit-wireless-network-wlc", 3, "click", 4, "ngIf"], ["class", "add-wireless-network-ruckus", 4, "ngIf"], ["class", "edit-wireless-network-ruckus", 4, "ngIf"], ["class", "add-wireless-network-aruba", 4, "ngIf"], ["class", "edit-wireless-network-aruba", 4, "ngIf"], ["class", "create-group", 3, "click", 4, "ngIf"], ["class", "add-wireless-network-aerohive", 4, "ngIf"], ["class", "edit-group", 3, "click", 4, "ngIf"], ["class", "add-campus", 3, "click", 4, "ngIf"], ["class", "add-location-aerohive", 4, "ngIf"], ["class", "add-building", 3, "click", 4, "ngIf"], ["class", "add-network", 3, "click", 4, "ngIf"], ["class", "add-wlc-network", 3, "click", 4, "ngIf"], ["class", "add-floor", 3, "click", 4, "ngIf"], ["class", "add-zone", 3, "click", 4, "ngIf"], ["class", "add-edit-metadata", 3, "click", 4, "ngIf"], ["class", "delete-location-node", 3, "click", 4, "ngIf"], ["class", "delete-location-floor", 3, "click", 4, "ngIf"], [1, "location-rename", 3, "click"], ["href", "javascript:void(0);"], [1, "add-wireless-network-universal", 3, "click"], [1, "edit-wireless-network-wlc", 3, "click"], [1, "add-wireless-network-ruckus"], [1, "edit-wireless-network-ruckus"], [1, "add-wireless-network-aruba"], [1, "edit-wireless-network-aruba"], [1, "create-group", 3, "click"], [1, "add-wireless-network-aerohive"], [1, "edit-group", 3, "click"], [1, "add-campus", 3, "click"], [1, "add-location-aerohive"], [1, "add-building", 3, "click"], [1, "add-network", 3, "click"], [1, "add-wlc-network", 3, "click"], [1, "add-floor", 3, "click"], [1, "add-zone", 3, "click"], [1, "add-edit-metadata", 3, "click"], [1, "delete-location-node", 3, "click"], [1, "delete-location-floor", 3, "click"]], template: function RowMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3, "MORE ACTIONS");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵlistener("click", function RowMenuComponent_Template_div_click_4_listener($event) { return ctx.closeMenu($event); });
        i0.ɵɵelement(5, "img", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "ul");
        i0.ɵɵtemplate(8, RowMenuComponent_li_8_Template, 3, 1, "li", 6);
        i0.ɵɵtemplate(9, RowMenuComponent_li_9_Template, 3, 0, "li", 7);
        i0.ɵɵtemplate(10, RowMenuComponent_li_10_Template, 3, 0, "li", 8);
        i0.ɵɵtemplate(11, RowMenuComponent_li_11_Template, 3, 0, "li", 9);
        i0.ɵɵtemplate(12, RowMenuComponent_li_12_Template, 3, 0, "li", 10);
        i0.ɵɵtemplate(13, RowMenuComponent_li_13_Template, 3, 0, "li", 11);
        i0.ɵɵtemplate(14, RowMenuComponent_li_14_Template, 3, 0, "li", 12);
        i0.ɵɵtemplate(15, RowMenuComponent_li_15_Template, 3, 0, "li", 13);
        i0.ɵɵtemplate(16, RowMenuComponent_li_16_Template, 3, 0, "li", 14);
        i0.ɵɵtemplate(17, RowMenuComponent_li_17_Template, 3, 0, "li", 15);
        i0.ɵɵtemplate(18, RowMenuComponent_li_18_Template, 3, 0, "li", 16);
        i0.ɵɵtemplate(19, RowMenuComponent_li_19_Template, 3, 0, "li", 17);
        i0.ɵɵtemplate(20, RowMenuComponent_li_20_Template, 3, 0, "li", 18);
        i0.ɵɵtemplate(21, RowMenuComponent_li_21_Template, 3, 0, "li", 19);
        i0.ɵɵtemplate(22, RowMenuComponent_li_22_Template, 3, 0, "li", 20);
        i0.ɵɵtemplate(23, RowMenuComponent_li_23_Template, 3, 0, "li", 21);
        i0.ɵɵtemplate(24, RowMenuComponent_li_24_Template, 3, 0, "li", 22);
        i0.ɵɵtemplate(25, RowMenuComponent_li_25_Template, 3, 0, "li", 22);
        i0.ɵɵtemplate(26, RowMenuComponent_li_26_Template, 3, 0, "li", 23);
        i0.ɵɵtemplate(27, RowMenuComponent_li_27_Template, 3, 0, "li", 24);
        i0.ɵɵtemplate(28, RowMenuComponent_li_28_Template, 3, 0, "li", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.RENAME));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_WIRELESS_NETWORK));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.EDIT_WLC));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_RUCKUS));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.EDIT_RUCKUS));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_ARUBA));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.EDIT_ARUBA));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_GROUP));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_AEROHIVE));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.EDIT_GROUP));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_CAMPUS));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_AEROHIVE_LOCATION));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_BUILDING));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_NETWORK));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_WLC_NETWORK));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_FLOOR));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_ZONE));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_CMX_ZONE));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.ADD_METADATA));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.DELETE_LOCATION));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addMenu(ctx.locationFlag.Flags.DELETE_FLOOR));
    } }, directives: [i1$2.NgIf], styles: [".action-list[_ngcontent-%COMP%] > ul[_ngcontent-%COMP%]{padding:0;margin:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RowMenuComponent, [{
        type: Component,
        args: [{
                selector: "lib-row-menu",
                templateUrl: "./row-menu.component.html",
                styleUrls: ["./row-menu.component.css"]
            }]
    }], function () { return [{ type: DataService }, { type: InteractionService }]; }, { node: [{
            type: Input
        }] }); })();

const _c0$1t = ["tree"];
function ManageLocationTreeComponent_ng_template_2_lib_row_menu_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-row-menu", 8);
} if (rf & 2) {
    const node_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("node", node_r7);
} }
const _c1$B = function (a0) { return { "row-hover": a0 }; };
function ManageLocationTreeComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "tree-node-wrapper", 5);
    i0.ɵɵtemplate(2, ManageLocationTreeComponent_ng_template_2_lib_row_menu_2_Template, 1, 1, "lib-row-menu", 6);
    i0.ɵɵelement(3, "tree-node-children", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r7 = ctx.$implicit;
    const index_r8 = ctx.index;
    const templates_r9 = ctx.templates;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2.getClass(node_r7));
    i0.ɵɵclassProp("tree-node", true)("tree-node-expanded", ctx_r2.getNodeExpanded(node_r7))("tree-node-collapsed", !node_r7.isExpanded && node_r7.hasChildren)("tree-node-leaf", node_r7.isLeaf)("tree-node-active", node_r7.isActive)("tree-node-focused", node_r7.isFocused);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleMap(ctx_r2.getPadding(node_r7, ctx_r2.isPopup));
    i0.ɵɵproperty("node", node_r7)("index", index_r8)("templates", templates_r9)("ngClass", i0.ɵɵpureFunction1(24, _c1$B, node_r7.data.showMenu));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r7.data.showMenu && !ctx_r2.isPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("node", node_r7)("templates", templates_r9);
} }
function ManageLocationTreeComponent_ng_template_4_Template(rf, ctx) { }
function ManageLocationTreeComponent_ng_template_6_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵlistener("mouseover", function ManageLocationTreeComponent_ng_template_6_span_5_Template_span_mouseover_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); const node_r12 = ctx_r23.$implicit; const index_r13 = ctx_r23.index; const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.onMouseOverNode(node_r12.data, index_r13); })("mouseout", function ManageLocationTreeComponent_ng_template_6_span_5_Template_span_mouseout_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r26 = i0.ɵɵnextContext(); const node_r12 = ctx_r26.$implicit; const index_r13 = ctx_r26.index; const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.onMouseOutNode(node_r12.data, index_r13); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" (", node_r12.data.total, " out of ", node_r12.data.permitted, ") ");
} }
function ManageLocationTreeComponent_ng_template_6_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 31);
} }
function ManageLocationTreeComponent_ng_template_6_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 32);
} }
function ManageLocationTreeComponent_ng_template_6_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵelement(1, "span", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r12.data.apsMatched, i0.ɵɵsanitizeHtml);
} }
function ManageLocationTreeComponent_ng_template_6_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "div", 36);
    i0.ɵɵelementStart(2, "div", 37);
    i0.ɵɵelementStart(3, "div", 38);
    i0.ɵɵelementStart(4, "div", 39);
    i0.ɵɵelementStart(5, "span", 40);
    i0.ɵɵtext(6, "User does not have permission to choose this location");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ManageLocationTreeComponent_ng_template_6_div_46_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵlistener("click", function ManageLocationTreeComponent_ng_template_6_div_46_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r31); const node_r12 = i0.ɵɵnextContext().$implicit; const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.toggleMenu($event, node_r12.data); });
    i0.ɵɵelement(1, "img", 42);
    i0.ɵɵelementEnd();
} }
function ManageLocationTreeComponent_ng_template_6_div_47_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelementStart(1, "input", 44);
    i0.ɵɵlistener("click", function ManageLocationTreeComponent_ng_template_6_div_47_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r34); const node_r12 = i0.ɵɵnextContext().$implicit; const ctx_r32 = i0.ɵɵnextContext(); return ctx_r32.selectNode(node_r12); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r12.data.id, "");
    i0.ɵɵproperty("checked", ctx_r20.selectedLocation && ctx_r20.selectedLocation.length > 0 && node_r12.id === ctx_r20.selectedLocation[0].id)("value", node_r12.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r12.data.id, "");
} }
function ManageLocationTreeComponent_ng_template_6_div_48_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "input", 47);
    i0.ɵɵlistener("click", function ManageLocationTreeComponent_ng_template_6_div_48_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r38); const node_r12 = i0.ɵɵnextContext().$implicit; const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.selectMultipleNode($event, node_r12); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 48);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r12.data.id, "");
    i0.ɵɵproperty("checked", ctx_r21.isNodeSelected)("value", node_r12.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r21.isChildNodeSelectedClass(node_r12));
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r12.data.id, "");
} }
const _c2$l = function (a0) { return { "disabledClick": a0 }; };
const _c3$e = function (a1) { return { "showAccessCode": true, "displayInlineBlock": a1 }; };
function ManageLocationTreeComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("mouseover", function ManageLocationTreeComponent_ng_template_6_Template_div_mouseover_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r41); const node_r12 = restoredCtx.$implicit; const index_r13 = restoredCtx.index; const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.onMouseOverNode(node_r12.data, index_r13); })("mouseout", function ManageLocationTreeComponent_ng_template_6_Template_div_mouseout_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r41); const node_r12 = restoredCtx.$implicit; const index_r13 = restoredCtx.index; const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.onMouseOutNode(node_r12.data, index_r13); });
    i0.ɵɵelementStart(1, "a", 10);
    i0.ɵɵelement(2, "span", 11);
    i0.ɵɵelementStart(3, "span", 12);
    i0.ɵɵlistener("click", function ManageLocationTreeComponent_ng_template_6_Template_span_click_3_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r41); const node_r12 = restoredCtx.$implicit; const ctx_r43 = i0.ɵɵnextContext(); return ctx_r43.showLocationDetailsPage($event, node_r12); });
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ManageLocationTreeComponent_ng_template_6_span_5_Template, 2, 2, "span", 13);
    i0.ɵɵtemplate(6, ManageLocationTreeComponent_ng_template_6_span_6_Template, 1, 0, "span", 14);
    i0.ɵɵtemplate(7, ManageLocationTreeComponent_ng_template_6_span_7_Template, 1, 0, "span", 15);
    i0.ɵɵtemplate(8, ManageLocationTreeComponent_ng_template_6_span_8_Template, 2, 1, "span", 16);
    i0.ɵɵtemplate(9, ManageLocationTreeComponent_ng_template_6_div_9_Template, 8, 0, "div", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 18);
    i0.ɵɵelementStart(11, "span");
    i0.ɵɵelementStart(12, "span", 19);
    i0.ɵɵtext(13);
    i0.ɵɵelementStart(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "span");
    i0.ɵɵelementStart(17, "span", 20);
    i0.ɵɵlistener("click", function ManageLocationTreeComponent_ng_template_6_Template_span_click_17_listener() { const restoredCtx = i0.ɵɵrestoreView(_r41); const node_r12 = restoredCtx.$implicit; const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.navigateToDetails("access-points", node_r12); });
    i0.ɵɵtext(18);
    i0.ɵɵelementStart(19, "span");
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "span");
    i0.ɵɵelementStart(22, "span", 21);
    i0.ɵɵlistener("click", function ManageLocationTreeComponent_ng_template_6_Template_span_click_22_listener() { const restoredCtx = i0.ɵɵrestoreView(_r41); const node_r12 = restoredCtx.$implicit; const ctx_r45 = i0.ɵɵnextContext(); return ctx_r45.navigateToDetails("ble-beacons", node_r12); });
    i0.ɵɵtext(23);
    i0.ɵɵelementStart(24, "span");
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "span");
    i0.ɵɵelementStart(27, "span", 22);
    i0.ɵɵlistener("click", function ManageLocationTreeComponent_ng_template_6_Template_span_click_27_listener() { const restoredCtx = i0.ɵɵrestoreView(_r41); const node_r12 = restoredCtx.$implicit; const ctx_r46 = i0.ɵɵnextContext(); return ctx_r46.navigateToDetails("proximity-rules", node_r12); });
    i0.ɵɵtext(28);
    i0.ɵɵelementStart(29, "span");
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "span");
    i0.ɵɵelementStart(32, "span", 23);
    i0.ɵɵlistener("click", function ManageLocationTreeComponent_ng_template_6_Template_span_click_32_listener() { const restoredCtx = i0.ɵɵrestoreView(_r41); const node_r12 = restoredCtx.$implicit; const ctx_r47 = i0.ɵɵnextContext(); return ctx_r47.navigateToDetails("team", node_r12); });
    i0.ɵɵtext(33);
    i0.ɵɵelementStart(34, "span");
    i0.ɵɵtext(35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "span");
    i0.ɵɵelementStart(37, "span", 24);
    i0.ɵɵlistener("click", function ManageLocationTreeComponent_ng_template_6_Template_span_click_37_listener() { const restoredCtx = i0.ɵɵrestoreView(_r41); const node_r12 = restoredCtx.$implicit; const ctx_r48 = i0.ɵɵnextContext(); return ctx_r48.navigateToDetails("camera", node_r12); });
    i0.ɵɵtext(38);
    i0.ɵɵelementStart(39, "span");
    i0.ɵɵtext(40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "span", 25);
    i0.ɵɵelementStart(42, "span", 26);
    i0.ɵɵlistener("click", function ManageLocationTreeComponent_ng_template_6_Template_span_click_42_listener() { const restoredCtx = i0.ɵɵrestoreView(_r41); const node_r12 = restoredCtx.$implicit; const ctx_r49 = i0.ɵɵnextContext(); return ctx_r49.navigateToDetails("access-codes", node_r12); });
    i0.ɵɵtext(43);
    i0.ɵɵelementStart(44, "span");
    i0.ɵɵtext(45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(46, ManageLocationTreeComponent_ng_template_6_div_46_Template, 2, 0, "div", 27);
    i0.ɵɵtemplate(47, ManageLocationTreeComponent_ng_template_6_div_47_Template, 3, 4, "div", 28);
    i0.ɵɵtemplate(48, ManageLocationTreeComponent_ng_template_6_div_48_Template, 3, 6, "div", 29);
} if (rf & 2) {
    const node_r12 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 30, node_r12.data.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r12.data.permitted != node_r12.data.total);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r12.data.useAPI);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.syncError[node_r12.data.id]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r12.data.apsMatched);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.showTooltip && ctx_r6.showTooltip[node_r12.data.id] && ctx_r6.showTooltip[node_r12.data.id] != null);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(32, _c2$l, !node_r12.data.networkClickable));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.countReadable(node_r12.data.networkCount));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", node_r12.data.networkCount, " Locations");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(34, _c2$l, !node_r12.data.accessPointClickable));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.countReadable(node_r12.data.accessPointCount));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", node_r12.data.accessPointCount, " Access Points");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(36, _c2$l, !node_r12.data.bleBeaconClickable));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.countReadable(node_r12.data.bleBeaconCount));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", node_r12.data.bleBeaconCount, " Ble Beacons");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(38, _c2$l, !node_r12.data.proximityClickable));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.countReadable(node_r12.data.proximityCount));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", node_r12.data.proximityCount, " Proximity Rules");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(40, _c2$l, !node_r12.data.userClickable));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.countReadable(node_r12.data.userCount));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", node_r12.data.userCount, " Users");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r6.countReadable(node_r12.data.camerasCount), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", node_r12.data.camerasCount, " Cameras");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(42, _c3$e, ctx_r6.showAccessCode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(44, _c2$l, !node_r12.data.accessCodeClickable));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.countReadable(node_r12.data.accessCodeCount));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", node_r12.data.accessCodeCount, " Access codes");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.isPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r12.data.access === "Full" && !ctx_r6.multiLocationSelect && ctx_r6.enableCheck(node_r12) || (node_r12.data.access === "Full" || node_r12.data.reportAccess) && ctx_r6.isReportsLocation && !ctx_r6.multiLocationSelect);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r12.data.access === "Full" && ctx_r6.multiLocationSelect && ctx_r6.enableCheck(node_r12) || (node_r12.data.access === "Full" || node_r12.data.reportAccess) && ctx_r6.isReportsLocation && ctx_r6.multiLocationSelect);
} }
class ManageLocationTreeComponent {
    constructor(router, dataService, locationService, cdRef) {
        this.router = router;
        this.dataService = dataService;
        this.locationService = locationService;
        this.cdRef = cdRef;
        this.unsubscribe$ = new Subject();
        this.syncError = {};
        this.activeNetworkNameMap = {};
        this.wpNetworkDetails = {};
        this.erroneousWirelessProviders = {};
        this.makeSearchAPICall = true;
        this.isNodeSelected = false;
        this.showAccessCode = false;
        this.isPopup = false;
        this.isPinnedPopup = false;
        this.setLocationPath = true;
        this.isReportsLocation = false;
        this.isRichMapAvailable = false;
        this.disableLicenseType = null;
        this.showAllLocations = true;
        this.nodeValue = new EventEmitter();
        this.navChange = new EventEmitter();
        this.isTreeInitialised = false;
        this.node = new Location();
        this.locationFlag = new LocationFlag();
        this.prevSearchResults = [];
        this.isOnlyMeraki = false;
        this.selectedLocationEvt = new EventEmitter();
        this.selectedLocation = [];
        this.searchTimestamp = 0;
        this.locationSearchString = "";
        this.totalLocIds = [];
        this.extractLocationearchString = (locationArray, keys, index) => {
            const key = keys.next();
            const delay = Math.round(index / 100);
            if (!key.done) {
                setTimeout(() => {
                    this.extractLocationearchString(locationArray, keys, ++index);
                }, delay);
            }
            else {
                console.log("Loading location search String afer: locationSearchString? ", this.locationSearchString, "totalLocIds::", this.totalLocIds);
            }
            const location = locationArray.get(key.value);
            this.totalLocIds.push("" + key.value);
            this.locationSearchString +=
                (location.parent === "-1" ? " " : "") +
                    "<<" +
                    location.id +
                    "##" +
                    location.name.replace(/ /gi, "_") +
                    (location.type === "root" ? "##" + location.type : "") +
                    ">>";
        };
        this.subscribeSearchText = (val) => {
            // console.log("this.dataService.getCurrentNav() !== '/ location'", this.dataService.getCurrentNav() !== '/location',
            //     "this.isTreeInitialised", this.isTreeInitialised);
            const currentNav = this.dataService.getCurrentNav();
            if (currentNav === null ||
                (currentNav.indexOf("location") === -1 &&
                    currentNav.indexOf("business") === -1 &&
                    currentNav.indexOf("location-analytics") === -1 &&
                    currentNav.indexOf("impactanalysis") === -1 &&
                    currentNav.indexOf("camera-metrics") === -1 &&
                    currentNav.indexOf("right-now") === -1 &&
                    currentNav.indexOf("energy-util") === -1 &&
                    currentNav.indexOf("signage") === -1 &&
                    currentNav.indexOf("space-manager") === -1 &&
                    currentNav.indexOf("workspace-experience") === -1) ||
                !this.isTreeInitialised)
                return;
            // console.log('search text', val);
            this.searchText = val;
            // if (this.searchText != null)
            //     setTimeout(() => {
            //         this.dataService.display(true);
            //     }, 50);
            if (this.searchText &&
                this.searchText.length > 1 &&
                this.isTreeInitialised &&
                this.prevSearchString !== this.searchText) {
                this.dataService.display(true);
                if (this.prevSearchString !== this.searchText) {
                    this.searchTimestamp = new Date().getTime();
                    this.prevSearchString = this.searchText;
                }
                if (this.setTimeoutObj)
                    clearTimeout(this.setTimeoutObj);
                this.setTimeoutObj = setTimeout(() => {
                    // console.log('search', this.searchText);
                    this.searchTree(this.searchTimestamp);
                }, 1200);
                if (currentNav &&
                    currentNav.indexOf("business") === -1 &&
                    currentNav.indexOf("camera-metrics") === -1 &&
                    currentNav.indexOf("right-now") === -1 &&
                    currentNav.indexOf("signage") === -1 &&
                    currentNav.indexOf("space-manager") === -1 &&
                    currentNav.indexOf("workspace-experience") === -1 &&
                    currentNav.indexOf("energy-util") === -1 &&
                    !this.isPinnedPopup)
                    this.dataService.display(false);
            }
            else {
                if (this.searchText != null || this.searchText === "") {
                    this.location = this.locationOrginal;
                    // this.treeComponent.treeModel.clearFilter();
                    // let node: TreeNode = this.treeComponent.treeModel.getNodeById(locId);
                    //         node.data.name = this.removeHightlighting(node.data.name);
                    // if (this.prevSearchResults) {
                    //     this.prevSearchResults.forEach(locId => {
                    //         // this.treeComponent.treeModel.nodes.
                    //         let node: TreeNode = this.treeComponent.treeModel.getNodeById(locId);
                    //         node.data.name = this.removeHightlighting(node.data.name);
                    //         // node.setIsHidden(false);
                    //         node.show();
                    //         node['apsMatched'] = "";
                    //     });
                    // }
                    this.initLocationNodes();
                    if (this.treeComponent) {
                        this.treeComponent.treeModel.setData({
                            nodes: this.locationOrginal,
                            options: this.options,
                            events: null
                        });
                        this.treeComponent.treeModel.roots.forEach((root) => {
                            root.expand();
                        });
                    }
                    this.prevSearchString = "";
                }
                if (currentNav &&
                    currentNav.indexOf("business") === -1 &&
                    currentNav.indexOf("camera-metrics") === -1 &&
                    currentNav.indexOf("impactanalysis/detail") === -1 &&
                    currentNav.indexOf("right-now") === -1 &&
                    currentNav.indexOf("signage") === -1 &&
                    currentNav.indexOf("space-manager") === -1 &&
                    currentNav.indexOf("workspace-experience") === -1 &&
                    currentNav.indexOf("energy-util") === -1 &&
                    !this.isPinnedPopup)
                    this.dataService.display(false);
                // if(this.dataService.getCurrentNav().indexOf("business") > -1 && this.enableCustomSearch && this.dataService.getCurrentNav().indexOf("detail") > -1 )
                //     this.dataService.display(false);
            }
        };
        this.enableCustomSearch = false;
        this.initLocationNodes = () => {
            // To be implemented in child component
        };
        this.resetLocationSearch = (location) => {
            let node;
            if (this.treeComponent) {
                node = this.treeComponent.treeModel.getNodeById(location.id);
                if (node) {
                    node.data.name = this.removeHightlighting(node.data.name);
                    node["isFound"] = false;
                    node["isMatched"] = false;
                    node["apsMatched"] = "";
                    node["isChildFound"] = false;
                    // console.log( 'node.parent.isFound', node );
                    setTimeout(() => {
                        node.setIsExpanded(node.data.expanded);
                    }, 50);
                }
            }
        };
        this.navigateToDetails = (section, nodeSel) => {
            switch (section) {
                case "access-points":
                    if (nodeSel.data.accessPointClickable) {
                        const navUrl = "/location/details/" + nodeSel.data.id + "/" + section;
                        this.router.navigate([navUrl]);
                    }
                    break;
                case "ble-beacons":
                    if (nodeSel.data.bleBeaconClickable) {
                        const navUrl = "/location/details/" + nodeSel.data.id + "/" + section;
                        this.router.navigate([navUrl]);
                    }
                    break;
                case "proximity-rules":
                    if (nodeSel.data.proximityClickable) {
                        const navUrl = "/location/details/" +
                            nodeSel.data.id +
                            "/rules/captive-portal";
                        this.router.navigate([navUrl]);
                    }
                    break;
                case "networks":
                    if (nodeSel.data.networkClickable) {
                        const navUrl = "/location/details/" + nodeSel.data.id + "/" + section;
                        this.router.navigate([navUrl]);
                    }
                    break;
                case "team":
                    if (nodeSel.data.userClickable) {
                        const navUrl = "/location/details/" + nodeSel.data.id + "/" + section;
                        this.router.navigate([navUrl]);
                    }
                    break;
                case "access-codes":
                    if (nodeSel.data.accessCodeClickable) {
                        const navUrl = "/location/details/" + nodeSel.data.id + "/" + section;
                        this.router.navigate([navUrl]);
                    }
                    break;
                case "camera":
                    if (nodeSel.data.camerasClickable) {
                        const navUrl = "/location/details/" + nodeSel.data.id + "/" + section;
                        this.router.navigate([navUrl]);
                    }
                    break;
                default:
                    if (nodeSel.data.accessPointClickable) {
                        const navUrl = "/location/details/" + nodeSel.data.id;
                        this.router.navigate([navUrl]);
                    }
                    break;
            }
        };
        this.removeHightlighting = (name) => {
            let regExp = new RegExp('<span class="highlighted">', "gi");
            if (name != undefined) {
                name = name.replace(regExp, "");
                regExp = new RegExp("</span>", "gi");
                name = name.replace(regExp, "");
            }
            return name;
        };
        this.addHightlighting = (name, tokens) => {
            if (name != undefined) {
                const regex = new RegExp("(" + tokens.join("|") + ")", "gi");
                name = name
                    .replace(/&amp;/g, "&")
                    .replace(/&lt;/g, "<")
                    .replace(/&gt;/g, ">");
                name = name.replace(regex, '<span class="highlighted">$&</span>');
            }
            return name;
        };
        this.validToken = (token) => {
            if (token == "" || token == ".") {
                return false;
            }
            return true;
        };
        this.isNodeMatched = (location, node, tokens, regexp, searchTimestamp) => {
            location.name = this.removeHightlighting(location.name);
            // node['apsMatched'] = null;
            let found = false;
            if (location.type === "root" ||
                regexp.test(location.name.toLowerCase()))
                found = true;
            if (!node)
                return found;
            // console.log( 'node.data.path', node.data.path,
            // node.data.name.toLowerCase(), 'node.parent.isActive', node.parent );
            found = this.setNodeVisibility(found, node, tokens);
            return found;
        };
        this.setNodeVisibility = (found, node, tokens) => {
            if (found) {
                found = true;
                node["isMatched"] = true;
                node["isFound"] = true;
                node.parent["isChildFound"] = true;
                // console.log( 'node matched', node, node.data,
                // node.data.name.toLowerCase(), foundIndex, 'node.hasChildren', node.hasChildren );
                // if (foundIndex > -1)
                setTimeout(() => {
                    node.data.name = this.removeHightlighting(node.data.name);
                    node.data.name = this.addHightlighting(node.data.name, tokens);
                }, 0);
                // let count =  countAP + countSAP;
                // if (count > 0)
                //     node['apsMatched'] = count + ' AP(s) matched';
                setTimeout(() => {
                    node.ensureVisible();
                }, 5);
            }
            else {
                node["isFound"] = false;
                node["isMatched"] = false;
                node["apsMatched"] = null;
                if (node.parent && node.parent["isFound"]) {
                    node["isFound"] = true;
                    // console.log( 'node.parent.isFound', node.parent['isFound'] );
                    found = true;
                    if (!node.parent["isChildFound"]) {
                        setTimeout(() => {
                            node.parent.setIsExpanded(true);
                        }, 5);
                    }
                }
                else if (node.parent) {
                    node.hide();
                }
            }
            return found;
        };
        this.matchLocation = (location, tokens, regexp, searchTimestamp) => {
            if (this.searchTimestamp === searchTimestamp && this.treeComponent) {
                let node;
                // console.log("in matchLocation", location, regexp, searchTimestamp);
                let matched = false;
                node = this.treeComponent.treeModel.getNodeById(location.id);
                if (this.isNodeMatched(location, node, tokens, regexp, searchTimestamp)) {
                    // console.log("MATCHED in matchLocation", location, regexp, searchTimestamp);
                    matched = true;
                }
                console.log(matched, node, tokens);
                // this.setNodeVisibility(matched, node, tokens);
            }
            else
                throw new ReferenceError("old search:this.searchTimestamp::" +
                    this.searchTimestamp +
                    "::searchTimestamp::" +
                    searchTimestamp +
                    ":: OR this.treeComponent may be null" +
                    (this.treeComponent == null));
        };
        this.isNodeMatchedRegex = (tokens, regexp, searchTimestamp) => {
            // location.name = this.removeHightlighting(location.name);
            // node['apsMatched'] = null;
            let myArray, myResult = [];
            if (this.searchTimestamp === searchTimestamp) {
                while ((myArray = regexp.exec(this.locationSearchString)) !== null) {
                    // console.log('myArray::', myArray);
                    myResult.push(myArray[1]);
                }
            }
            // console.log('myResult', myResult);
            return myResult;
            // node.data.name.toLowerCase(), 'node.parent.isActive', node.parent );
            // found = this.setNodeVisibility(found, node, tokens);
            // return found;
        };
        this.filterLocationIds = (filterLocations) => {
            if (filterLocations && filterLocations.length > 0) {
                if (this.locationOrginal) {
                    // let filteredLocations = [];
                    const filteredLocations = new Map();
                    let root = null;
                    root = this.filterLocationTree(this.locationOrginal, filteredLocations, filterLocations, root);
                    this.location = [root];
                    // console.log("this.location after filter", this.location);
                }
                else {
                    console.log("Locations not available", location);
                }
            }
        };
        this.filterLocationTree = (locations, filteredLocations, filterLocations, root) => {
            locations.forEach((location) => {
                if (filterLocations.indexOf(location.id) === -1)
                    return;
                const newLoc = Object.assign({}, location);
                newLoc.children = [];
                filteredLocations.set(newLoc.id, newLoc);
                if (newLoc.parent != "-1") {
                    const parent = filteredLocations.get(newLoc.parent);
                    if (parent) {
                        if (!parent.children)
                            parent.children = [];
                        parent.children.push(newLoc);
                    }
                    else {
                        console.log("Parent " +
                            newLoc.parent +
                            " not found for location " +
                            newLoc.id, newLoc);
                    }
                }
                else {
                    root = newLoc;
                }
                if (location.children)
                    root = this.filterLocationTree(location.children, filteredLocations, filterLocations, root);
            });
            return root;
        };
        this.setSearchResultsOnTree = (searchResults, apMatches, tokens, firstCall, searchTimestamp) => {
            if (this.searchTimestamp === searchTimestamp) {
                if (searchResults) {
                    if (apMatches) {
                        searchResults = searchResults.concat(Object.keys(apMatches));
                    }
                    const start = now();
                    console.log("start of search", start, "tokens", tokens, "firstCall", firstCall);
                    if (this.prevSearchResults && firstCall && this.treeComponent) {
                        this.treeComponent.treeModel.collapseAll();
                        this.treeComponent.treeModel.roots.forEach((root) => {
                            root.expand();
                        });
                    }
                    const one = now();
                    console.log("Not req: hide old of search", one - start);
                    // if (this.prevSearchResults && firstCall) {
                    //     var remPrevSearchResults = (Object.assign([], this.prevSearchResults)).filter(function (n) {
                    //         return !this.has(n)
                    //     }, new Set(searchResults));
                    //     console.log("remPrevSearchResults", remPrevSearchResults);
                    //     setTimeout(() => {
                    //         this.removeHighlghtedItems(remPrevSearchResults, 0, tokens, apMatches);
                    //     }, 10);
                    // }
                    const two = now();
                    console.log("highlight of search", two - one);
                    setTimeout(() => {
                        this.highlightSearchItems(searchResults, 0, tokens, apMatches);
                    }, 10);
                    const three = now();
                    console.log("show new of search", three - two);
                    this.filterLocationIds(searchResults);
                    // this.treeComponent.treeModel.filterNodes(node => {
                    //     if (this.searchTimestamp === searchTimestamp) {
                    //         let index = searchResults.indexOf('' + node.data.id);
                    //         if (index > -1) {
                    //             return true;
                    //         } else {
                    //             return false;
                    //         }
                    //     } else {
                    //         throw new ReferenceError('old search:this.searchTimestamp::' + this.searchTimestamp + '::searchTimestamp::' + searchTimestamp);
                    //     }
                    // });
                    const four = now();
                    console.log("end of search", four - three);
                }
                this.prevSearchResults = searchResults;
            }
        };
        this.removeHighlghtedItems = (remPrevSearchResults, index, tokens, apMatches) => {
            const delay = Math.round(index / 10) * 10;
            if (index < remPrevSearchResults.length) {
                setTimeout(() => {
                    this.removeHighlghtedItems(remPrevSearchResults, index + 1, tokens, apMatches);
                }, delay);
            }
            const locId = remPrevSearchResults[index];
            if (!locId)
                return;
            if (this.treeComponent) {
                const node = this.treeComponent.treeModel.getNodeById(locId);
                node.data.name = this.removeHightlighting(node.data.name);
                node.show();
                this.setNodeVisibility(false, node, tokens);
                if (apMatches && apMatches[locId])
                    node["apsMatched"] = apMatches[locId] + " AP(s) matched";
                else
                    node["apsMatched"] = "";
            }
        };
        this.highlightSearchItems = (searchResults, index, tokens, apMatches) => {
            const delay = Math.round(index / 10) * 10;
            console.log("delay to higlight", delay);
            if (index < searchResults.length && index < 2) {
                setTimeout(() => {
                    this.highlightSearchItems(searchResults, index + 1, tokens, apMatches);
                }, delay);
            }
            const locId = searchResults[index];
            console.log("node locId", locId);
            if (!locId)
                return;
            if (this.treeComponent) {
                const node = this.treeComponent.treeModel.getNodeById(locId);
                if (node) {
                    this.highlightNodeItem(locId, node, tokens, apMatches);
                }
                else {
                    console.log("node object not found", locId);
                }
            }
        };
        this.highlightNodeItem = (locId, node, tokens, apMatches) => {
            if (!locId && !node && !this.treeComponent) {
                console.log("error while highighting node and locId");
                return;
            }
            if (!node)
                node = this.treeComponent.treeModel.getNodeById(locId);
            if (!locId)
                locId = node.data.id;
            console.log("node object  found", locId);
            // node.setIsHidden(false);
            node.show();
            console.log("node show", locId);
            node.setActiveAndVisible();
            console.log("node active and visible", locId);
            // node.loadNodeChildren();
            this.setNodeVisibility(true, node, tokens);
            console.log("node visibility", locId);
            if (apMatches && apMatches[locId])
                node["apsMatched"] = apMatches[locId] + " AP(s) matched";
            else
                node["apsMatched"] = "";
            console.log("node ap macthed", locId);
            if (node.hasChildren &&
                (!node.getVisibleChildren() ||
                    node.getVisibleChildren().length == 0)) {
                // this.showNodeChildren(node);
                node.collapseAll();
            }
            console.log("node collapse all", locId);
            node.ensureVisible();
            console.log("node ensure visible", locId);
        };
        this.showNodeChildren = (node) => {
            if (node && node.children) {
                node.children.forEach((child) => {
                    child.setIsHidden(false);
                    if (child.hasChildren) {
                        this.showNodeChildren(child);
                    }
                });
            }
        };
        this.regexMatchLocation = (tokens, regexp, searchTimestamp, apMatches, firstCall) => {
            if (this.searchTimestamp === searchTimestamp) {
                if (this.treeComponent)
                    this.treeComponent.treeModel.clearFilter();
                // console.log("in matchLocation", location, regexp, searchTimestamp);
                const searchResults = this.isNodeMatchedRegex(tokens, regexp, searchTimestamp);
                this.setSearchResultsOnTree(searchResults, apMatches, tokens, firstCall, searchTimestamp);
            }
            else
                throw new ReferenceError("old search:this.searchTimestamp::" +
                    this.searchTimestamp +
                    "::searchTimestamp::" +
                    searchTimestamp);
        };
        this.matchChildLocations = (locationArray, tokens, regexp, searchTimestamp, hasRoot) => {
            // let counter = (hasRoot ? 1 : 0);
            for (let index = hasRoot ? 1 : 0, max = locationArray.length; index < max; index++) {
                const location = locationArray[index];
                setTimeout(() => {
                    try {
                        this.matchLocation(location, tokens, regexp, searchTimestamp);
                        if (location.location) {
                            setTimeout(() => {
                                this.matchChildLocations(location.location, tokens, regexp, searchTimestamp, false);
                            }, 0);
                        }
                    }
                    catch (e) {
                        // console.log('e', e);
                    }
                }, 0);
            }
            // console.log('searchfind nodes DONE', tokens, regexp, searchTimestamp);
        };
        this.matchToken = (location, searchTokens, apMatches, isParent, searchRegex) => {
            //TODO: implement search
            let found = false;
            // console.log(location.name, location.path, searchRegex.test(location.name.toLowerCase()))
            if (searchRegex.test(location.name.toLowerCase())) {
                found = true;
                // console.log('Location matched:', location.name, location.path);
            }
            const newLoc = Object.assign({}, location);
            newLoc.children = [];
            newLoc.location = [];
            if (apMatches && apMatches[newLoc.id]) {
                found = true;
                newLoc.apsMatched = apMatches[newLoc.id] + " AP(s) matched";
            }
            else
                newLoc.apsMatched = "";
            // let newLoc = location.clone();
            newLoc.expanded = false;
            if (location.type === "root" || found)
                newLoc.expanded = true;
            // if (newLoc.name.indexOf('<span class="highlighted">') > -1) {
            //     var regExp = new RegExp('<span class="highlighted">', 'gi');
            //     newLoc.name = newLoc.name.replace(regExp, "");
            //     regExp = new RegExp("</span>", 'gi');
            //     newLoc.name = newLoc.name.replace(regExp, "");
            // }
            if (found) {
                newLoc.name = newLoc.name
                    .replace(/&amp;/g, "&")
                    .replace(/&lt;/g, "<")
                    .replace(/&gt;/g, ">");
                newLoc.name = newLoc.name.replace(searchRegex, '<span class="highlighted">$&</span>');
            }
            let foundChild = false;
            const currentNav = this.dataService.getCurrentNav();
            if (location.type === "network" &&
                currentNav &&
                (currentNav.indexOf("business") !== -1 ||
                    currentNav.indexOf("impactanalysis") !== -1)) {
                return { location: newLoc, foundChild: foundChild, found: found };
            }
            else {
                if (location.children)
                    for (let index = 0, max = location.children.length; index < max; index++) {
                        const childLoc = location.children[index];
                        const resChild = this.matchToken(childLoc, searchTokens, apMatches, isParent || found, searchRegex);
                        if (resChild["foundChild"] || resChild["found"]) {
                            foundChild = true;
                            // console.log('Location matched:', resChild['location'].name, resChild['location'].path);
                        }
                        if (isParent ||
                            found ||
                            resChild["foundChild"] ||
                            resChild["found"])
                            newLoc.children.push(resChild["location"]);
                    }
                //
                return { location: newLoc, foundChild: foundChild, found: found };
            }
        };
        this.findNodes = (tokens, regexp, searchTimestamp, apMatches, firstCall) => {
            // this.treeComponent.treeModel.clearFilter();
            // this.regexMatchLocation(tokens, regexp, searchTimestamp, apMatches, firstCall);
            let filteredLocation;
            //console.log('searchRegex', regexp, 'firstCall', firstCall);
            if (this.locationOrginal && this.locationOrginal.length > 0)
                filteredLocation = this.matchToken(this.locationOrginal[0], tokens, apMatches, false, regexp);
            if (filteredLocation.location && this.treeComponent) {
                // this.location = [filteredLocation.location];
                this.treeComponent.treeModel.setData({
                    nodes: [filteredLocation.location],
                    options: this.options,
                    events: null
                });
            }
            else {
                // this.location = this.locationOrginal;
                this.treeComponent.treeModel.setData({
                    nodes: this.locationOrginal,
                    options: this.options,
                    events: null
                });
            }
            // let activeNodes: TreeNode[] = this.treeComponent.treeModel.getActiveNodes();
            // for (let index = 0, max = activeNodes.length; index < max; index++) {
            //     const node = activeNodes[index];
            //     this.ensureNodeVisible(node, index);
            // }
            let index = 0;
            setTimeout(() => {
                if (this.treeComponent)
                    this.treeComponent.treeModel.doForAll((node) => {
                        this.ensureNodeVisible(node, ++index);
                        // return true;
                    });
            }, 100);
        };
        this.ensureNodeVisible = (node, index) => {
            const delay = Math.round(index / 10) * 10;
            setTimeout(() => {
                if (node && node.data && node.data.expanded)
                    node.ensureVisible();
            }, delay);
        };
        this.onTreeUpdate = ($event) => {
            console.log("This is called on tree update", $event);
        };
        this.updateSearchAps = (apMatches, newMatches) => {
            //console.log( 'updateSearchAps', apMatches, newMatches );
            Object.keys(newMatches).map((key) => {
                apMatches[key] = newMatches[key];
            });
        };
        this.searchTree = (searchTimestamp) => {
            //console.log('search tree', this.searchText);
            const makeServerCall = true;
            const currentNav = this.dataService.getCurrentNav();
            if ((this.isPopup &&
                currentNav &&
                currentNav.indexOf("location-analytics") === -1 &&
                currentNav.indexOf("business") === -1 &&
                currentNav.indexOf("impactanalysis") === -1 &&
                currentNav.indexOf("camera-metrics") === -1 &&
                currentNav.indexOf("right-now") === -1 &&
                currentNav.indexOf("energy-util") === -1 &&
                currentNav.indexOf("signage") === -1 &&
                currentNav.indexOf("space-manager") === -1 &&
                currentNav.indexOf("workspace-experience") === -1) ||
                !this.prevSearchString)
                return;
            const tokensTemp = this.prevSearchString.trim().split(" ");
            const tokens = [];
            for (let tokCount = 0, max = tokensTemp.length; tokCount < max; tokCount++) {
                if (!this.validToken(tokensTemp[tokCount]))
                    continue;
                tokens.push(tokensTemp[tokCount]);
            }
            if (tokens && tokens.length > 0) {
                const regexTokenStr = "root|" + tokens.join("|");
                //<<(\d*)(##(\w*?\W*?\S*?\s*?(ste|sys|roo|jap|user:2)\s*?\S*?\W*?\w*?)(##)?)>>((?!\W(?=\w))|(?=\s))
                // let regexStr = '<<(\\d*)(##(\\w*?\\W*?\\S*?\\s*?(' + regexTokenStr + ')\\s*?\\S*?\\W*?\\w*?)(##)?)>>((?!\\W(?=\\w))|(?=\\s))'
                const regexStr = "(" + regexTokenStr + ")";
                const regexp = new RegExp(regexStr, "gi");
                // console.log('tokens', tokens, tokens.join('|'), "regexp", regexp, "this.locationSearchString", this.locationSearchString);
                this.findNodes(tokens, regexp, searchTimestamp, null, true);
                const apMatches = [];
                // setTimeout(() => {
                if (makeServerCall && this.makeSearchAPICall) {
                    for (let tokn = 0, max = tokens.length; tokn < max; tokn++) {
                        setTimeout(() => {
                            if (tokens[tokn].length > 2) {
                                this.locationService
                                    .searchAPs(tokens[tokn], this.searchTimestamp)
                                    .pipe(takeUntil(this.unsubscribe$))
                                    .subscribe((searchData) => {
                                    //searchData
                                    // console.log('searchData', searchData, this.searchTimestamp, this.searchTimestamp === searchData.timestamp)
                                    this.dataService.display(true);
                                    if (this.searchTimestamp ===
                                        searchData.timestamp) {
                                        this.updateSearchAps(apMatches, searchData.result);
                                        this.findNodes(tokens, regexp, this.searchTimestamp, apMatches, false);
                                    }
                                    this.dataService.display(false);
                                }, (error) => {
                                    if (error.status == 401) {
                                        this.locationService.signOut();
                                    }
                                    this.dataService.display(false);
                                });
                            }
                        }, 0);
                    }
                    // }, 0);
                }
                this.dataService.display(false);
            }
            else {
                this.dataService.display(false);
            }
        };
        this.getClass = (node) => {
            const selected = this.isSelectedLocation(node);
            let classString = "";
            if (node && (node.data.parent == "-1" || (node.parent && !node.isRoot)))
                classString = node.getClass();
            classString += " type-" + node.data.type;
            // if (selected)
            //   classString += ' tree-node isSelectedNode';
            if (this.isOnlyMeraki && node.data.type != "root") {
                if (node.data.type == "group" &&
                    (node.data.parentNode.type == "root" ||
                        node.data.parentNode.type == "meraki")) {
                    return classString;
                }
                else if (node.data.networkDetails.wirelessProvider != "MERAKI") {
                    return "hideNode";
                }
            }
            return classString;
        };
        this.isChildNodeSelectedClass = (node) => {
            let classString = "checkboxLabel";
            const index = null;
            let parentPath;
            const parentPathArray = [];
            if (this.selectedLocation) {
                this.selectedLocation.filter(function (n, i) {
                    if (n.data && n.data.path) {
                        parentPath = n.data.path.slice(0, n.data.path.length - 1);
                        // pushing path to new array
                        parentPath.forEach((element) => {
                            parentPathArray.push(element);
                        });
                    }
                });
            }
            // remove duplicates
            const uniqueParentPaths = this.removeDuplicates(parentPathArray);
            // check the unique parent paths with node
            if (uniqueParentPaths && uniqueParentPaths.indexOf(node.data.id) > -1) {
                classString += " childSelected";
                return classString;
            }
            else {
                return classString;
            }
        };
        // remove duplicates from array
        this.removeDuplicates = (arr) => {
            const unique_array = [];
            for (let i = 0; i < arr.length; i++) {
                if (unique_array.indexOf(arr[i]) == -1) {
                    unique_array.push(arr[i]);
                }
            }
            return unique_array;
        };
        this.getNodeExpanded = (node) => {
            return node.isExpanded && node.hasChildren;
        };
        this.getPadding = (node, isPopup = false) => {
            if (isPopup) { /*console.log('isPopup vakue :: '+isPopup)*/ }
            const paddingLeft = node.data.path.length > 2 ? 20 * (node.data.path.length - 2) : 0;
            let style;
            if (node.data.licenseType && this.disableLicenseType == node.data.licenseType && !location.pathname.includes('/team') && !location.pathname.includes('/usermanagement/invite')) {
                if (this.showAllLocations) {
                    style = { "padding-left": paddingLeft + "px", "opacity": 0.3, "cursor": "not-allowed", "pointer-events": "none", "position": "relative" };
                }
                else {
                    style = { "display": "none", "padding-left": paddingLeft + "px", "opacity": 0.3, "cursor": "not-allowed", "pointer-events": "none", "position": "relative" };
                }
            }
            else {
                style = { "padding-left": paddingLeft + "px" };
            }
            return style;
        };
        this.onMouseOverNode = (nodeData, index) => {
            if ((this.dataService.getCurrentNav().indexOf('right-now') !== -1) && (nodeData.type === 'zone' || nodeData.type === 'cmxzone' || nodeData.type === 'polygon_zone')) {
                $('#loc_tooltip_' + nodeData.id).addClass('zone-alert-show');
            }
            else {
                console.log('onMouseOverNode ::: ', this.isPopup);
                if (!this.isPopup) {
                    if (!nodeData.showMenu) {
                        nodeData.showMenu = true;
                        setTimeout(() => {
                            nodeData.showMenu = false;
                        }, 2000);
                    }
                }
                else {
                    this.locName = nodeData.name;
                    this.totalLocations = nodeData.total;
                    this.permittedLocations = nodeData.permitted;
                    if (nodeData.total != nodeData.permitted) {
                        this.showTooltip[nodeData.id] = true;
                    }
                    else {
                        this.showTooltip[nodeData.id] = false;
                    }
                    if (nodeData.licenseType && this.disableLicenseType == nodeData.licenseType) {
                        this.showTooltip[nodeData.id] = true;
                    }
                }
            }
        };
        this.onMouseOutNode = (nodeData, index) => {
            setTimeout(() => {
                $('#loc_tooltip_' + nodeData.id).removeClass('zone-alert-show');
            }, 500);
            if (!this.isPopup) {
                nodeData.showMenu = false;
            }
            else {
                this.showTooltip[nodeData.id] = false;
            }
        };
        this.doSelection = (node) => {
            //console.log( "Select node:: manage location:", this.selectedLocation, node );
            if (this.selectedLocation !== undefined &&
                this.selectedLocation.length > 0 &&
                this.selectedLocation[0].data !== undefined &&
                this.selectedLocation[0].data.id === node.data.id) {
                this.selectedLocation = [];
                node.setIsExpanded(true);
            }
            else {
                if (node && node[0] && node[0].id == undefined) {
                    this.selectedLocation = node[0];
                    node.setIsExpanded(true);
                }
                else {
                    this.selectedLocation = [node];
                    node.setIsExpanded(true);
                }
            }
        };
        this.selectNode = (node) => {
            const currentNav = this.dataService.getCurrentNav();
            if ((currentNav &&
                currentNav.indexOf("right-now") !== -1 &&
                (node.data.type === "zone" ||
                    node.data.type === "cmxzone" ||
                    node.data.type === "polygon_zone")) ||
                (currentNav &&
                    currentNav.indexOf("camera-metrics") !== -1 &&
                    node.data.camerasCount === 0)) {
                return;
            }
            this.doSelection(node);
            this.selectedLocationEvt.emit(this.selectedLocation);
        };
        this.onSelectedLocationEvent = ($event) => {
            console.log("selected location ", $event);
        };
        this.unselectNode = () => {
            this.selectedLocation = [];
            //console.log( "unselect node:: manage location:after:", this.selectedLocation );
        };
        this.countReadable = (numberCount) => {
            if (!numberCount)
                return 0;
            let i = 0;
            while (numberCount > 1000) {
                numberCount /= 1000;
                i++;
            }
            return Math.round(numberCount) + ["", "k", "m", "b"][i];
        };
        this.onEvent = ($event) => {
            // console.log('onEvent from tree::', $event);
            switch ($event.eventName) {
                case "initialized":
                    console.log("location loading done", new Date().getTime() - this.startTime);
                    this.dataService.display(false);
                    this.isTreeInitialised = true;
                    //this.treeComponent.treeModel.update();
                    if (this.treeComponent)
                        this.treeComponent.treeModel.roots.forEach((root) => {
                            if (root.isCollapsed)
                                root.expand();
                        });
                    if (!this.enableCustomSearch) {
                        console.log("search text not subscribed");
                        this.dataService
                            .getSearchText(this.unsubscribe$)
                            .subscribe(this.subscribeSearchText);
                    }
                case "toggleExpanded":
                    setTimeout(() => {
                        if (this.treeComponent) {
                            this.treeComponent.sizeChanged();
                        }
                    }, 100);
                    break;
                case "changeFilter":
                    setTimeout(() => {
                        this.dataService.display(false);
                    }, 500);
                    break;
            }
        };
        this.setState = (state) => {
            this.dataService.setTreeState(JSON.stringify(state));
        };
        this.options = {
            displayField: "name",
            isExpandedField: "expanded",
            idField: "id",
            actionMapping: {
                mouse: {
                //dblClick: (tree, node, $event) => {
                //  if (node.hasChildren) TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event);
                //},
                //click:(tree, node, $event) => {
                //this.logger.debug('mouse click', tree, node, $event);
                //}
                }
            },
            allowDrag: (node) => {
                return false;
            },
            allowDrop: (node) => {
                return false;
            },
            useVirtualScroll: true,
            animateExpand: false,
            animateSpeed: 10,
            animateAcceleration: 1.2,
            nodeHeight: 32
            //dropSlotHeight: 3
        };
        this.toggleMenu = ($event, node) => {
            console.log("toggleMenu::", $event, node);
            if (this.node)
                this.node.showMenu = false;
            if (node)
                node.showMenu = !node.showMenu;
            if (node.showMenu) {
                this.dataService.setOpenLocationMenu(true);
            }
            this.node = node;
            this.nodeValue.emit(node);
        };
        this.showLocationDetailsPage = ($event, node) => {
            if (!this.isPopup) {
                this.dataService.display(true);
                this.dataService.setLocationId(node.data.id);
                //this.dataService.setLocationNode(node.data);
                const navUrl = "/location/details/" + node.data.id;
                this.router.navigate([navUrl]);
            }
        };
        this.removeSelectedChildren = (selectedNode) => {
            if (selectedNode && selectedNode.data.path.length > 0) {
                const index = [];
                this.selectedLocation.filter((n, i) => {
                    if (n.data && n.data.path) {
                        const selectedLocParentPath = n.data.path.slice(0, n.data.path.length - 1);
                        if (selectedLocParentPath.indexOf(selectedNode.data.id) > -1) {
                            index.push(i);
                            return i;
                        }
                    }
                    return;
                });
                if (index !== null) {
                    for (let j = index.length - 1; j >= 0; j--) {
                        this.selectedLocation.splice(index[j], 1);
                    }
                }
            }
        };
        this.removeSelectedParent = (selectedNode) => {
            if (selectedNode && selectedNode.data.path.length > 0) {
                const index = [];
                this.selectedLocation.filter((n, i) => {
                    if (selectedNode.data && selectedNode.data.path) {
                        const parentPath = selectedNode.data.path.slice(0, selectedNode.data.path.length - 1);
                        if (parentPath.indexOf(n.data.id) > -1) {
                            index.push(i);
                            return i;
                        }
                    }
                    return;
                });
                if (index !== null) {
                    for (let j = index.length - 1; j >= 0; j--) {
                        this.selectedLocation.splice(index[j], 1);
                    }
                }
            }
        };
        this.isSelectedLocation = (node) => {
            let index = null;
            if (this.selectedLocation)
                this.selectedLocation.filter(function (n, i) {
                    if (n && n.data && n.data.id === node.data.id) {
                        index = i;
                        return i;
                    }
                });
            if (index !== null) {
                // console.log("isSelectedLocation::true::",node.data.name);
                //  node.setIsExpanded( false );
                this.isNodeSelected = true;
                return true;
            }
            else {
                // console.log("isSelectedLocation::false::",node.data.name);
                //  node.setIsExpanded( true );
                this.isNodeSelected = false;
                return false;
            }
        };
        this.enableCheck = (node) => {
            let enableCheck = false;
            if (this.permittedLocationTypes !== undefined &&
                this.permittedLocationTypes !== null &&
                this.permittedLocationTypes.length > 0) {
                // check group or org
                if (this.permittedLocationTypes.indexOf(node.data.type) > -1) {
                    if (node.data.type === "organization" ||
                        node.data.type === "meraki" ||
                        node.data.type === "mse") {
                        enableCheck = true;
                    }
                    else if (node.data.type === "group" &&
                        node.data.locationBit & this.locationFlag.Flags.ADD_NETWORK) {
                        enableCheck = true;
                    }
                    else if (node.data.type !== "organization" &&
                        node.data.type !== "group") {
                        enableCheck = true;
                    }
                    // we need to add the richmap flag check
                }
                else {
                    enableCheck = false;
                }
            }
            else {
                enableCheck = true;
            }
            // rich map check
            if (this.isRichMapAvailable) {
                // need to add the check
                // console.log(' ::: enableCheck method ::: node.data.richMapStatus ::: '+node.data.richMapStatus);
                if (enableCheck) {
                    if (node.data.richMapStatus) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
            else {
                // no need for rich map check
                return enableCheck;
            }
        };
        this.getCount = (location, countType) => {
            if (this.locationCountResponse &&
                this.locationCountResponse[location.id]) {
                if (this.locationCountResponse[location.id][countType]) {
                    return this.locationCountResponse[location.id][countType];
                }
            }
            return 0;
        };
        console.log("Constructing the manage locations ts.");
    }
    // eslint-disable-next-line @angular-eslint/no-input-rename
    set locationUpdate(loc) {
        this.location = loc;
        this.locationOrginal = loc;
        setTimeout(() => {
            if (this.isTreeInitialised && this.treeComponent) {
                this.treeComponent.treeModel.update();
                this.treeComponent.treeModel.roots.forEach((root) => {
                    root.expand();
                });
                this.treeComponent.sizeChanged();
            }
        }, 200);
    }
    // eslint-disable-next-line @angular-eslint/no-input-rename
    set setIsPinnedPopup(isPinnedPopup) {
        this.isPinnedPopup = isPinnedPopup;
    }
    set setSelectedLocation(selectedLocations) {
        //console.log('set selected location', selectedLocations);
        this.selectedLocation = selectedLocations;
        if (!selectedLocations || selectedLocations.length == 0)
            for (const id in this.selectedLocation) {
                try {
                    this.selectedLocation[id].setIsExpanded(true);
                }
                catch (e) {
                    console.log("location id not available", this.selectedLocation[id]);
                }
            }
        else {
            // setTimeout(() => {
            //     for(var i=0;i<selectedLocations.length;i++) {
            //         selectedLocations[i].setIsExpanded( false );
            //         console.log(selectedLocations[i].data.name,": expanded?:",selectedLocations[i].isExpanded, this.selectedLocation[i].isExpanded);
            //     }
            // }, 500);
            setTimeout(() => {
                for (var i = 0; i < this.selectedLocation.length; i++) {
                    try {
                        const nodeF = this.treeComponent.treeModel.getNodeById(this.selectedLocation[i].data.id);
                        this.selectedLocation[i] = nodeF;
                    }
                    catch (e) {
                        console.log("location id not available", this.selectedLocation[i]);
                    }
                    if (!this.selectedLocation[i]) {
                        this.selectedLocation.splice(i, 1);
                    }
                }
                for (var i = 0; i < this.selectedLocation.length; i++) {
                    try {
                        this.selectedLocation[i].setIsExpanded(true);
                    }
                    catch (e) {
                        console.log("location id not available");
                    }
                }
            }, 500);
        }
    }
    ngAfterInit() {
        if (this.treeComponent) {
            const treeModel = this.treeComponent.treeModel;
            const firstNode = treeModel.getFirstRoot();
            firstNode.setActiveAndVisible();
        }
    }
    ngAfterViewChecked() {
        // console.log("called after view checked App Component");
        // this.showLoader = false;
        if (this.cdRef)
            this.cdRef.detectChanges();
    }
    ngOnInit() {
        // console.log('Constructing the manage locations ts in init.');
        this.isOnlyMeraki =
            this.permittedLocationTypes != null &&
                this.permittedLocationTypes.indexOf("onlyMerakiNetworks") > -1
                ? true
                : false;
        this.locationSyncNotificationsList = [];
        this.syncError = {};
        this.locationSyncNotificationErrorsAvailable = false;
        this.erroneousWirelessProviders = {};
        this.erroneousWirelessProviders.list = [];
        this.wpNetworkDetails = {
            status: "pending",
            error: false,
            wirelessProvidersCount: [],
            locationSyncNotificationsList: []
        };
        this.activeNetworkNameMap = {
            Meraki: "MERAKI",
            "CUWN - CMX": "MSE",
            "CUWN - WLC": "WLC",
            Ruckus: "RUCKUS",
            Xirrus: "XIRRUS",
            Aruba: "ARUBA"
        };
        this.wpNetworkDetails.wirelessProvidersCount = [];
        this.wpNetworkDetails.locationSyncNotificationsList = [];
        this.state =
            this.dataService.getTreeState() &&
                JSON.parse(this.dataService.getTreeState());
        this.startTime = new Date().getTime();
        //this.selectedLocation = [];
        this.searchText = "";
        this.dataService.getLocationObjectArray().then((locationArray) => {
            if (!this.dataService.locationTreeArrayExists)
                return;
            // console.log("Loading location search String", locationArray);
            // let keys = Object.keys(locationArray);
            // let keys: IterableIterator<string> = locationArray.keys();
            this.locationSearchString = "";
            // setTimeout(() => {
            //     this.extractLocationearchString(locationArray, locationArray.keys(), 0);
            // }, 0);
            const keys = locationArray.keys();
            let rootLocation;
            for (let key = null; (key = keys.next());) {
                if (key.done)
                    break;
                // console.log(key + ' = ' + locationArray.get(key));
                const location = locationArray.get(key.value);
                this.showTooltip = new Array(locationArray.size + 1);
                //this.showTooltip.fill(false , 0,locationArray.size);
                if (location && location.type == "root") {
                    rootLocation = location;
                    // context menu changes
                    if (!rootLocation.children ||
                        (rootLocation.children &&
                            rootLocation.children.length == 0)) {
                        this.onMouseOverNode(rootLocation, 0);
                    }
                }
                // if (location.id==this.dataService.getLocationNetworkFromSetup()) {
                //     currentLocation = location;
                // }
                this.totalLocIds.push(key.value);
                if (location)
                    this.locationSearchString +=
                        (location.parent === "-1" ? " " : "") +
                            "<<" +
                            location.id +
                            "##" +
                            location.name.replace(/ /gi, "_") +
                            (location.type === "root" ? "##" + location.type : "") +
                            ">>";
            }
            // getting mongodb ids and graph db ids in dataservice
            const mongoDBLocIds = this.dataService.getMongoDBIdsMap();
            const graphDBLocIds = this.dataService.getGraphDBIdsMap();
            this.dataService.totalLocIds = this.totalLocIds;
            // console.log("Loading location search String afer: locationSearchString? ", this.locationSearchString,
            //     "totalLocIds::", this.totalLocIds);
            if (this.dataService.getOpenPopUpFromSetup() ==
                "add_wireless_network") {
                this.toggleMenu(event, rootLocation);
                // currentLocation
            }
            if (this.dataService.getOpenPopUpFromSetup() == "dna_network_setup") {
                this.toggleMenu(event, rootLocation);
                // currentLocation
            }
        });
        this.dataService
            .getOnSyncStatusUpdate(this.unsubscribe$)
            .subscribe((updateTimestamp) => {
            if (!updateTimestamp)
                return;
            this.syncError = this.dataService.getSyncError();
        });
        this.prevSearchString = "";
        setTimeout(() => {
            if (this.setLocationPath && !this.isPopup) {
                const currentNav = this.dataService.getCurrentNav();
                if (currentNav === null ||
                    currentNav === "null" ||
                    (currentNav != "location" &&
                        currentNav.indexOf("right-now") &&
                        currentNav.indexOf("business") === -1)) {
                    this.dataService.setCurrentNav("location");
                }
            }
        }, 700);
    }
    // eslint-disable-next-line @angular-eslint/no-input-rename
    set setCustomSearchText(customSearchText) {
        this.enableCustomSearch = true;
        if (customSearchText) {
            // this.prevSearchString = customSearchText;
            // this.searchTree(new Date().getTime());
            this.subscribeSearchText(customSearchText);
        }
    }
    ngOnDestroy() {
        console.log("destory manageLocations page");
        // this.treeComponent.treeModel.setData({
        // 	nodes: {},
        // 	options: this.options,
        // 	events: null
        // });
        this.treeComponent = null;
        this.subscribeSearchText("");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    selectMultipleNode($event, node) {
        //console.log(node);
        let index = null;
        if (!this.selectedLocation)
            this.selectedLocation = [];
        this.selectedLocation.filter((n, i) => {
            if (n.data.id === node.data.id) {
                index = i;
                return i;
            }
            return;
        });
        if (index !== null) {
            //console.log("Removing::", this.selectedLocation);
            this.selectedLocation.splice(index, 1);
            this.isNodeSelected = false;
            $event.target.checked = false;
            node.setIsExpanded(true);
        }
        else {
            //console.log("Selecting Location::", node);
            this.selectedLocation.push(node);
            node.setIsExpanded(true);
            this.removeSelectedChildren(node);
            this.removeSelectedParent(node);
            this.isNodeSelected = true;
            $event.target.checked = true;
        }
        //console.log(this.selectedLocation);
        this.selectedLocationEvt.emit(this.selectedLocation);
    }
}
ManageLocationTreeComponent.ɵfac = function ManageLocationTreeComponent_Factory(t) { return new (t || ManageLocationTreeComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
ManageLocationTreeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ManageLocationTreeComponent, selectors: [["lib-manage-location-tree"]], viewQuery: function ManageLocationTreeComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1t, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.treeComponent = _t.first);
    } }, inputs: { locationUpdate: ["location", "locationUpdate"], showAccessCode: "showAccessCode", isPopup: "isPopup", setIsPinnedPopup: ["isPinnedPopup", "setIsPinnedPopup"], multiLocationSelect: "multiLocationSelect", locationCountResponse: "locationCountResponse", permittedLocationTypes: "permittedLocationTypes", isReportsLocation: "isReportsLocation", isRichMapAvailable: "isRichMapAvailable", disableLicenseType: "disableLicenseType", showAllLocations: "showAllLocations", setSelectedLocation: "setSelectedLocation", enableCustomSearch: "enableCustomSearch", setCustomSearchText: ["customSearchText", "setCustomSearchText"] }, outputs: { nodeValue: "nodeValue", navChange: "navChange", selectedLocationEvt: "selectedLocationEvt" }, decls: 8, vars: 2, consts: [[3, "nodes", "options", "event", "stateChange"], ["tree", ""], ["treeNodeFullTemplate", ""], ["loadingTemplate", ""], ["treeNodeTemplate", ""], [3, "node", "index", "templates", "ngClass"], [3, "node", 4, "ngIf"], [3, "node", "templates"], [3, "node"], [1, "location-node-name", 3, "mouseover", "mouseout"], ["href", "javascript:void(0);", 1, "location-name-icon"], [1, "loc-type-icon"], ["id", "link-locdetails", 1, "location-name", 3, "innerHTML", "click"], ["class", "location-count", 3, "mouseover", "mouseout", 4, "ngIf"], ["class", "two-factor-icon", 4, "ngIf"], ["class", "sync-error-icon yellow-triangle", 4, "ngIf"], ["class", "matchedApDetails", 4, "ngIf"], ["class", "showDiv-on-Mousehover showDiv-on-Mousehover-eng", 4, "ngIf"], [1, "location-info-list"], [1, "round-icon", "tool-tip-css", "networks-template", 3, "ngClass"], [1, "round-icon", "tool-tip-css", "access-point-template", 3, "ngClass", "click"], [1, "round-icon", "tool-tip-css", "ble-beacons-template", 3, "ngClass", "click"], [1, "round-icon", "tool-tip-css", "proximity-rules-template", 3, "ngClass", "click"], [1, "round-icon", "tool-tip-css", "users-template", 3, "ngClass", "click"], [1, "round-icon", "tool-tip-css", "accesscode-template", 3, "click"], [3, "ngClass"], [1, "round-icon", "tool-tip-css", "accesscode-template", 3, "ngClass", "click"], ["class", "loc-menu-toggle", 3, "click", 4, "ngIf"], ["class", "locationPopupRadio", 4, "ngIf"], ["class", "circularCheckbox", 4, "ngIf"], [1, "location-count", 3, "mouseover", "mouseout"], [1, "two-factor-icon"], [1, "sync-error-icon", "yellow-triangle"], [1, "matchedApDetails"], [3, "innerHTML"], [1, "showDiv-on-Mousehover", "showDiv-on-Mousehover-eng"], [1, "modalContent-beta"], [1, "modalBody1"], [1, "beta-popup-div"], [1, "popup-title-div"], [1, "popup-title"], [1, "loc-menu-toggle", 3, "click"], ["src", "/assets/images/menu-white.svg", "alt", ".", 1, "menu-open-img"], [1, "locationPopupRadio"], ["type", "radio", "name", "locationRadio", 3, "checked", "id", "value", "click"], [1, "radioButtonLabel", 3, "for"], [1, "circularCheckbox"], ["type", "checkbox", "name", "locationChecbox", 3, "checked", "id", "value", "click"], [1, "checkboxLabel", 3, "for"]], template: function ManageLocationTreeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "tree-root", 0, 1);
        i0.ɵɵlistener("event", function ManageLocationTreeComponent_Template_tree_root_event_0_listener($event) { return ctx.onEvent($event); })("stateChange", function ManageLocationTreeComponent_Template_tree_root_stateChange_0_listener($event) { return ctx.setState($event); });
        i0.ɵɵtemplate(2, ManageLocationTreeComponent_ng_template_2_Template, 4, 26, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, ManageLocationTreeComponent_ng_template_4_Template, 0, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, ManageLocationTreeComponent_ng_template_6_Template, 49, 46, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("nodes", ctx.location)("options", ctx.options);
    } }, directives: [i4.TreeComponent, i4.TreeNodeWrapperComponent, i1$2.NgClass, i1$2.NgIf, i4.TreeNodeChildrenComponent, RowMenuComponent], pipes: [SafeHtmlPipe], styles: [".disabledClick[_ngcontent-%COMP%]{cursor:default}input[type=checkbox][_ngcontent-%COMP%]:hover ~ .childSelected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -18px;content:\"\"}input[type=checkbox][_ngcontent-%COMP%] ~ .childSelected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -72px;content:\"\"}.hideNode[_ngcontent-%COMP%]{display:none}.showDiv-on-Mousehover[_ngcontent-%COMP%]{z-index:1001;position:absolute;background-color:#777;width:380px;color:#fff}.modalBody1[_ngcontent-%COMP%]{margin:0;cursor:pointer;opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]{display:flex;height:115px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 10px 10px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:12px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .modalBody1[_ngcontent-%COMP%]:hover{opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]{width:100%;border-top:1px solid #b2a6a6;text-align:center;padding-top:5px}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]   .popup-footer-text[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:13px;color:#fff}.location-count[_ngcontent-%COMP%]{font-size:11px;color:#7a7a7a}.showDiv-on-Mousehover[_ngcontent-%COMP%]{z-index:1001;position:fixed;background-color:#000;margin-top:-125px}.modalContent-beta[_ngcontent-%COMP%]{padding:10px}"], changeDetection: 0 });
ManageLocationTreeComponent.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ManageLocationTreeComponent, factory: ManageLocationTreeComponent.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ManageLocationTreeComponent, [{
        type: Injectable
    }, {
        type: Component,
        args: [{
                selector: "lib-manage-location-tree",
                templateUrl: "./manage-location-tree.component.html",
                styleUrls: ["./manage-location-tree.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: LocationService }, { type: i0.ChangeDetectorRef }]; }, { locationUpdate: [{
            type: Input,
            args: ["location"]
        }], showAccessCode: [{
            type: Input
        }], isPopup: [{
            type: Input
        }], setIsPinnedPopup: [{
            type: Input,
            args: ["isPinnedPopup"]
        }], multiLocationSelect: [{
            type: Input
        }], locationCountResponse: [{
            type: Input
        }], permittedLocationTypes: [{
            type: Input
        }], isReportsLocation: [{
            type: Input
        }], isRichMapAvailable: [{
            type: Input
        }], disableLicenseType: [{
            type: Input
        }], showAllLocations: [{
            type: Input
        }], nodeValue: [{
            type: Output
        }], navChange: [{
            type: Output
        }], selectedLocationEvt: [{
            type: Output
        }], setSelectedLocation: [{
            type: Input
        }], treeComponent: [{
            type: ViewChild,
            args: ["tree", { static: true }]
        }], enableCustomSearch: [{
            type: Input
        }], setCustomSearchText: [{
            type: Input,
            args: ["customSearchText"]
        }] }); })();

const _c0$1s = function (a0) { return { "row-hover": a0 }; };
function AnalyticsLocationHierarchyComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "tree-node-wrapper", 5);
    i0.ɵɵelement(2, "tree-node-children", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r7 = ctx.$implicit;
    const index_r8 = ctx.index;
    const templates_r9 = ctx.templates;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2.getClass(node_r7));
    i0.ɵɵclassProp("tree-node", true)("tree-node-expanded", ctx_r2.getNodeExpanded(node_r7))("tree-node-collapsed", !node_r7.isExpanded && node_r7.hasChildren)("tree-node-leaf", node_r7.isLeaf)("tree-node-active", node_r7.isActive)("tree-node-focused", node_r7.isFocused);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleMap(ctx_r2.getPadding(node_r7, ctx_r2.isPopup));
    i0.ɵɵproperty("node", node_r7)("index", index_r8)("templates", templates_r9)("ngClass", i0.ɵɵpureFunction1(23, _c0$1s, node_r7.data.showMenu));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("node", node_r7)("templates", templates_r9);
} }
function AnalyticsLocationHierarchyComponent_ng_template_4_Template(rf, ctx) { }
function AnalyticsLocationHierarchyComponent_ng_template_6_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵlistener("mouseover", function AnalyticsLocationHierarchyComponent_ng_template_6_span_5_Template_span_mouseover_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); const node_r10 = ctx_r19.$implicit; const index_r11 = ctx_r19.index; const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.onMouseOverNode(node_r10.data, index_r11); })("mouseout", function AnalyticsLocationHierarchyComponent_ng_template_6_span_5_Template_span_mouseout_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r22 = i0.ɵɵnextContext(); const node_r10 = ctx_r22.$implicit; const index_r11 = ctx_r22.index; const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.onMouseOutNode(node_r10.data, index_r11); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" (", node_r10.data.total, " out of ", node_r10.data.permitted, ") ");
} }
function AnalyticsLocationHierarchyComponent_ng_template_6_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵelementStart(2, "input", 16);
    i0.ɵɵlistener("click", function AnalyticsLocationHierarchyComponent_ng_template_6_div_6_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r26); const node_r10 = i0.ɵɵnextContext().$implicit; const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.selectNode(node_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r13.selectedLocation && ctx_r13.selectedLocation.length > 0 && node_r10.id === ctx_r13.selectedLocation[0].id)("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r10.data.id, "");
} }
function AnalyticsLocationHierarchyComponent_ng_template_6_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵelementStart(2, "input", 16);
    i0.ɵɵlistener("click", function AnalyticsLocationHierarchyComponent_ng_template_6_div_7_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r30); const node_r10 = i0.ɵɵnextContext().$implicit; const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.selectNode(node_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r14.selectedLocation && ctx_r14.selectedLocation.length > 0 && node_r10.id === ctx_r14.selectedLocation[0].id)("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r10.data.id, "");
} }
function AnalyticsLocationHierarchyComponent_ng_template_6_div_8_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "input", 19);
    i0.ɵɵlistener("click", function AnalyticsLocationHierarchyComponent_ng_template_6_div_8_span_1_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(3); return ctx_r34.showPopupMessage($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r10.data.id, "");
    i0.ɵɵproperty("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r10.data.id, "");
} }
function AnalyticsLocationHierarchyComponent_ng_template_6_div_8_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "input", 19);
    i0.ɵɵlistener("click", function AnalyticsLocationHierarchyComponent_ng_template_6_div_8_span_2_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r39); const node_r10 = i0.ɵɵnextContext(2).$implicit; const ctx_r37 = i0.ɵɵnextContext(); return ctx_r37.selectNode(node_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r10.data.id, "");
    i0.ɵɵproperty("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r10.data.id, "");
} }
function AnalyticsLocationHierarchyComponent_ng_template_6_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, AnalyticsLocationHierarchyComponent_ng_template_6_div_8_span_1_Template, 3, 3, "span", 18);
    i0.ɵɵtemplate(2, AnalyticsLocationHierarchyComponent_ng_template_6_div_8_span_2_Template, 3, 3, "span", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r10.data.type !== "root" && node_r10.data.type !== "network");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r10.data.type === "root" || node_r10.data.type === "network");
} }
function AnalyticsLocationHierarchyComponent_ng_template_6_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵelementStart(2, "input", 21);
    i0.ɵɵlistener("click", function AnalyticsLocationHierarchyComponent_ng_template_6_div_9_Template_input_click_2_listener($event) { i0.ɵɵrestoreView(_r44); const node_r10 = i0.ɵɵnextContext().$implicit; const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.selectMultipleNode($event, node_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r16.isNodeSelected)("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r10.data.id, "");
} }
function AnalyticsLocationHierarchyComponent_ng_template_6_div_10_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "input", 21);
    i0.ɵɵlistener("click", function AnalyticsLocationHierarchyComponent_ng_template_6_div_10_span_4_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r49); const node_r10 = i0.ɵɵnextContext(2).$implicit; const ctx_r47 = i0.ɵɵnextContext(); return ctx_r47.selectMultipleNode($event, node_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r46 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r46.isNodeSelected)("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r10.data.id, "");
} }
function AnalyticsLocationHierarchyComponent_ng_template_6_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵelementStart(2, "input", 23);
    i0.ɵɵlistener("click", function AnalyticsLocationHierarchyComponent_ng_template_6_div_10_Template_input_click_2_listener($event) { i0.ɵɵrestoreView(_r52); const ctx_r51 = i0.ɵɵnextContext(2); return ctx_r51.showPopupMessage($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, AnalyticsLocationHierarchyComponent_ng_template_6_div_10_span_4_Template, 3, 4, "span", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r10.data.id, "");
    i0.ɵɵproperty("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r10.data.id, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r10.data.type === "root" || node_r10.data.type === "network");
} }
function AnalyticsLocationHierarchyComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "a", 8);
    i0.ɵɵelement(2, "span", 9);
    i0.ɵɵelement(3, "span", 10);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, AnalyticsLocationHierarchyComponent_ng_template_6_span_5_Template, 2, 2, "span", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, AnalyticsLocationHierarchyComponent_ng_template_6_div_6_Template, 4, 4, "div", 12);
    i0.ɵɵtemplate(7, AnalyticsLocationHierarchyComponent_ng_template_6_div_7_Template, 4, 4, "div", 12);
    i0.ɵɵtemplate(8, AnalyticsLocationHierarchyComponent_ng_template_6_div_8_Template, 3, 2, "div", 12);
    i0.ɵɵtemplate(9, AnalyticsLocationHierarchyComponent_ng_template_6_div_9_Template, 4, 4, "div", 13);
    i0.ɵɵtemplate(10, AnalyticsLocationHierarchyComponent_ng_template_6_div_10_Template, 5, 4, "div", 13);
} if (rf & 2) {
    const node_r10 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 7, node_r10.data.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r10.data.permitted != node_r10.data.total);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r6.licenceType === "Advanced Subscription" || ctx_r6.licenceType === "Unlimited Subscription") && (ctx_r6.widgetType === "path" || ctx_r6.widgetType === "correlation") && (node_r10.data.type === "floor" || node_r10.data.type === "zone" || node_r10.data.type === "cmxzone" || node_r10.data.type === "polygon_zone") && (!ctx_r6.multiLocationSelect && ctx_r6.enableCheck(node_r10)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.widgetType !== "path" && ctx_r6.widgetType !== "correlation" && (ctx_r6.licenceType === "Advanced Subscription" || ctx_r6.licenceType === "Unlimited Subscription") && (!ctx_r6.multiLocationSelect && ctx_r6.enableCheck(node_r10)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.widgetType !== "path" && ctx_r6.widgetType !== "correlation" && ctx_r6.licenceType !== "Advanced Subscription" && ctx_r6.licenceType !== "Unlimited Subscription" && node_r10.data.type !== "floor" && node_r10.data.type !== "zone" && node_r10.data.type !== "cmxzone" && node_r10.data.type !== "polygon_zone" && (!ctx_r6.multiLocationSelect && ctx_r6.enableCheck(node_r10)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r6.licenceType === "Advanced Subscription" || ctx_r6.licenceType === "Unlimited Subscription") && (ctx_r6.multiLocationSelect && ctx_r6.enableCheck(node_r10)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.licenceType !== "Advanced Subscription" && ctx_r6.licenceType !== "Unlimited Subscription" && node_r10.data.type !== "floor" && node_r10.data.type !== "zone" && node_r10.data.type !== "cmxzone" && node_r10.data.type !== "polygon_zone" && (ctx_r6.multiLocationSelect && ctx_r6.enableCheck(node_r10)));
} }
class AnalyticsLocationHierarchyComponent extends ManageLocationTreeComponent {
    constructor(router_, dataService_, locationService_, cdRef_) {
        super(router_, dataService_, locationService_, cdRef_);
        this.router_ = router_;
        this.dataService_ = dataService_;
        this.locationService_ = locationService_;
        this.cdRef_ = cdRef_;
        this.atLocationRestriction = new EventEmitter();
        this.showPopupMessage = ($event) => {
            $event.target.checked = false;
            this.atLocationRestriction.emit(true);
        };
    }
    ngOnInit() {
        console.log("init of analytics location heirarchy");
        super.ngOnInit();
    }
    set searchLocation(value) {
        this.enableCustomSearch = true;
        if (value) {
            this.subscribeSearchText(value);
        }
    }
}
AnalyticsLocationHierarchyComponent.ɵfac = function AnalyticsLocationHierarchyComponent_Factory(t) { return new (t || AnalyticsLocationHierarchyComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
AnalyticsLocationHierarchyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AnalyticsLocationHierarchyComponent, selectors: [["lib-analytics-location-hierarchy"]], inputs: { widgetType: "widgetType", licenceType: "licenceType", searchLocation: "searchLocation" }, outputs: { atLocationRestriction: "atLocationRestriction" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 2, consts: [[3, "nodes", "options", "event", "stateChange"], ["tree", ""], ["treeNodeFullTemplate", ""], ["loadingTemplate", ""], ["treeNodeTemplate", ""], [3, "node", "index", "templates", "ngClass"], [3, "node", "templates"], [1, "location-node-name"], ["href", "javascript:void(0);", 1, "location-name-icon"], [1, "loc-type-icon"], [1, "location-name", 3, "innerHTML"], ["class", "location-count", 3, "mouseover", "mouseout", 4, "ngIf"], ["class", "locationPopupRadio", 4, "ngIf"], ["class", "circularCheckbox", 4, "ngIf"], [1, "location-count", 3, "mouseover", "mouseout"], [1, "locationPopupRadio"], ["type", "radio", "name", "locationRadio", 3, "checked", "id", "value", "click"], [1, "radioButtonLabel", 3, "for"], [4, "ngIf"], ["type", "radio", "name", "locationRadio", 3, "id", "value", "click"], [1, "circularCheckbox"], ["type", "checkbox", "name", "locationChecbox", 3, "checked", "id", "value", "click"], [1, "checkboxLabel", 3, "for"], ["type", "checkbox", "name", "locationChecbox", 3, "id", "value", "click"]], template: function AnalyticsLocationHierarchyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "tree-root", 0, 1);
        i0.ɵɵlistener("event", function AnalyticsLocationHierarchyComponent_Template_tree_root_event_0_listener($event) { return ctx.onEvent($event); })("stateChange", function AnalyticsLocationHierarchyComponent_Template_tree_root_stateChange_0_listener($event) { return ctx.setState($event); });
        i0.ɵɵtemplate(2, AnalyticsLocationHierarchyComponent_ng_template_2_Template, 3, 25, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, AnalyticsLocationHierarchyComponent_ng_template_4_Template, 0, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, AnalyticsLocationHierarchyComponent_ng_template_6_Template, 11, 9, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("nodes", ctx.location)("options", ctx.options);
    } }, directives: [i4.TreeComponent, i4.TreeNodeWrapperComponent, i1$2.NgClass, i4.TreeNodeChildrenComponent, i1$2.NgIf], pipes: [SafeHtmlPipe], styles: [".modalContent-beta[_ngcontent-%COMP%]{width:300px;left:47%;top:-50%;position:absolute;background:#fff;padding:5px;box-shadow:0 0 20px #0000004d;transform:translate(-50%);-webkit-transform:translateX(-50%);-webkit-box-shadow:0 0 20px rgba(0,0,0,.3);background:#3c3c3c;opacity:1}.modalBody1[_ngcontent-%COMP%]{margin:0;cursor:pointer;opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]{display:flex;height:115px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 10px 10px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:12px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .modalBody1[_ngcontent-%COMP%]:hover{opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]{width:100%;border-top:1px solid #b2a6a6;text-align:center;padding-top:5px}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]   .popup-footer-text[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:13px;color:#fff}.location-count[_ngcontent-%COMP%]{font-size:11px;color:#7a7a7a}.showDiv-on-Mousehover[_ngcontent-%COMP%]{z-index:1001;position:fixed;background-color:#000;margin-left:-382px;margin-top:-29px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AnalyticsLocationHierarchyComponent, [{
        type: Component,
        args: [{
                selector: "lib-analytics-location-hierarchy",
                templateUrl: "./analytics-location-hierarchy.component.html",
                styleUrls: ["./analytics-location-hierarchy.component.scss"]
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: LocationService }, { type: i0.ChangeDetectorRef }]; }, { atLocationRestriction: [{
            type: Output
        }], widgetType: [{
            type: Input
        }], licenceType: [{
            type: Input
        }], searchLocation: [{
            type: Input
        }] }); })();

const _c0$1r = ["modalContent"];
function AngularCalendarViewComponent_mwl_calendar_month_view_15_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mwl-calendar-month-view", 13);
    i0.ɵɵlistener("dayClicked", function AngularCalendarViewComponent_mwl_calendar_month_view_15_Template_mwl_calendar_month_view_dayClicked_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.dayClicked($event.day); })("eventClicked", function AngularCalendarViewComponent_mwl_calendar_month_view_15_Template_mwl_calendar_month_view_eventClicked_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.handleEvent("Clicked", $event.event); })("eventTimesChanged", function AngularCalendarViewComponent_mwl_calendar_month_view_15_Template_mwl_calendar_month_view_eventTimesChanged_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.eventTimesChanged($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(19);
    i0.ɵɵproperty("viewDate", ctx_r0.viewDate)("events", ctx_r0.events)("refresh", ctx_r0.refresh)("activeDayIsOpen", ctx_r0.activeDayIsOpen)("cellTemplate", _r3);
} }
function AngularCalendarViewComponent_mwl_calendar_week_view_16_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mwl-calendar-week-view", 14);
    i0.ɵɵlistener("eventClicked", function AngularCalendarViewComponent_mwl_calendar_week_view_16_Template_mwl_calendar_week_view_eventClicked_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.handleEvent("Clicked", $event.event); })("eventTimesChanged", function AngularCalendarViewComponent_mwl_calendar_week_view_16_Template_mwl_calendar_week_view_eventTimesChanged_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.eventTimesChanged($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("viewDate", ctx_r1.viewDate)("events", ctx_r1.events)("refresh", ctx_r1.refresh);
} }
function AngularCalendarViewComponent_mwl_calendar_day_view_17_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mwl-calendar-day-view", 14);
    i0.ɵɵlistener("eventClicked", function AngularCalendarViewComponent_mwl_calendar_day_view_17_Template_mwl_calendar_day_view_eventClicked_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.handleEvent("Clicked", $event.event); })("eventTimesChanged", function AngularCalendarViewComponent_mwl_calendar_day_view_17_Template_mwl_calendar_day_view_eventTimesChanged_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.eventTimesChanged($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("viewDate", ctx_r2.viewDate)("events", ctx_r2.events)("refresh", ctx_r2.refresh);
} }
function AngularCalendarViewComponent_ng_template_18_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const day_r15 = i0.ɵɵnextContext().day;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(day_r15.events[0].title);
} }
const _c1$A = function (a0, a1, a2) { return { "background": a0, "color": a1, "border-left": a2 }; };
function AngularCalendarViewComponent_ng_template_18_div_5_span_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const event_r21 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction3(2, _c1$A, event_r21.color.primary, event_r21.color.secondary, "3px solid " + event_r21.color.secondary));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(event_r21.title);
} }
function AngularCalendarViewComponent_ng_template_18_div_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, AngularCalendarViewComponent_ng_template_18_div_5_span_1_span_1_Template, 2, 6, "span", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r22 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r22 > 0);
} }
function AngularCalendarViewComponent_ng_template_18_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, AngularCalendarViewComponent_ng_template_18_div_5_span_1_Template, 2, 1, "span", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const day_r15 = i0.ɵɵnextContext().day;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", day_r15.events);
} }
function AngularCalendarViewComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "span", 16);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "calendarDate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, AngularCalendarViewComponent_ng_template_18_span_4_Template, 2, 1, "span", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, AngularCalendarViewComponent_ng_template_18_div_5_Template, 2, 1, "div", 18);
} if (rf & 2) {
    const day_r15 = ctx.day;
    const locale_r16 = ctx.locale;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(3, 3, day_r15.date, "monthViewDayNumber", locale_r16));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", day_r15.events && day_r15.events.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", day_r15.events && day_r15.events.length > 1);
} }
const moment$l = moment_;
/*const colors: any = {
  count: {
    primary: '#000',
    secondary: '#000',

  },
  building: {
    primary: '#FFF7F2',
    secondary: '#FD9B5B',

  },
  floor: {
    primary: '#F1FBF4',
    secondary: '#58CB7D',
  },
  zone: {
    primary: '#EEF3FE',
    secondary: '#346FF1',
  },
};*/
class AngularCalendarViewComponent {
    /*events: CalendarEvent[] = [
    {
      start: subDays(startOfDay(new Date()), 1),
      end: addDays(new Date(), 1),
      title: '12',
      color: colors.count,
      actions: this.actions,
      allDay: true,
      resizable: {
        beforeStart: false,
        afterEnd: false,
      },
      draggable: true,
    },
    {
      start: subDays(startOfDay(new Date()), 1),
      end: addDays(new Date(), 1),
      title: 'Building',
      color: colors.building,
      actions: this.actions,
      allDay: true,
      resizable: {
        beforeStart: true,
        afterEnd: true,
      },
      draggable: true,
    },
    {
      start: startOfDay(new Date()),
      title: 'Floors',
      color: colors.floor,
      actions: this.actions,
    },

    {
      start: addHours(startOfDay(new Date()), 2),
      end: addHours(new Date(), 2),
      title: 'Zones',
      color: colors.zone,
      actions: this.actions,
      resizable: {
        beforeStart: true,
        afterEnd: true,
      },
      draggable: true,
    },
  ];*/
    // constructor(private modal: NgbModal) { }
    constructor() {
        this.view = CalendarView.Month;
        this.colors = {};
        //  view: CalendarView = CalendarView.Month;
        this.CalendarView = CalendarView;
        this.activeDayIsOpen = false;
        this.viewDate = null;
        this.prevBtnDisabled = false;
        this.nextBtnDisabled = false;
        this.minDate = new Date();
        this.maxDate = new Date();
        this.atDayClicked = new EventEmitter();
        this.atMonthChange = new EventEmitter();
        this.actions = [
            {
                label: '<i class="fas fa-fw fa-pencil-alt"></i>',
                a11yLabel: "Edit",
                onClick: ({ event }) => {
                    this.handleEvent("Edited", event);
                }
            },
            {
                label: '<i class="fas fa-fw fa-trash-alt"></i>',
                a11yLabel: "Delete",
                onClick: ({ event }) => {
                    this.events = this.events.filter((iEvent) => iEvent !== event);
                    this.handleEvent("Deleted", event);
                }
            }
        ];
        this.refresh = new Subject();
        this.dateOrViewChanged();
    }
    set setMaxDate(value) {
        if (value) {
            //if (!this.viewDate){
            // this.viewDate = moment(value).toDate();
            // }
            this.maxDate = moment$l(value).toDate();
            // if(this.maxDate && this.minDate){
            //   this.dateOrViewChanged();
            // }
        }
    }
    set setMinDate(value) {
        if (value) {
            this.minDate = moment$l(value).toDate();
            // if(this.maxDate && this.minDate){
            //   this.dateOrViewChanged();
            // }
        }
    }
    set eventList(value) {
        if (value) {
            this.events = value;
        }
    }
    ngOnInit() {
        console.log("Calendar View :: ngOnInit :: ", this.viewDate);
        this.dateOrViewChanged();
    }
    addPeriod(period, date, amount) {
        return {
            day: addDays,
            week: addWeeks,
            month: addMonths
        }[period](date, amount);
    }
    subPeriod(period, date, amount) {
        return {
            day: subDays,
            week: subWeeks,
            month: subMonths
        }[period](date, amount);
    }
    startOfPeriod(period, date) {
        return {
            day: startOfDay,
            week: startOfWeek,
            month: startOfMonth
        }[period](date);
    }
    endOfPeriod(period, date) {
        return {
            day: endOfDay,
            week: endOfWeek,
            month: endOfMonth
        }[period](date);
    }
    dayClicked({ date, events }) {
        if (isSameMonth(date, this.viewDate)) {
            if ((isSameDay(this.viewDate, date) &&
                this.activeDayIsOpen === true) ||
                events.length === 0)
                this.viewDate = date;
        }
        if (events && events.length > 0)
            this.atDayClicked.emit(date);
    }
    eventTimesChanged({ event, newStart, newEnd }) {
        this.events = this.events.map((iEvent) => {
            if (iEvent === event) {
                return Object.assign(Object.assign({}, event), { start: newStart, end: newEnd });
            }
            return iEvent;
        });
        this.handleEvent("Dropped or resized", event);
    }
    handleEvent(action, event) {
        this.modalData = { event, action };
        //    this.modal.open(this.modalContent, { size: 'lg' });
    }
    /* addEvent(): void {
     this.events = [
       ...this.events,
       {
         title: 'New event',
         start: startOfDay(new Date()),
         end: endOfDay(new Date()),
         color: this.colors.primary,
         draggable: true,
         resizable: {
           beforeStart: true,
           afterEnd: true,
         },
       },
     ];
   }*/
    deleteEvent(eventToDelete) {
        this.events = this.events.filter((event) => event !== eventToDelete);
    }
    setView(view) {
        this.view = view;
    }
    closeOpenMonthViewDay() {
        console.log("closeOpenMonthViewDay :: Month Change :: ", this.viewDate);
        this.activeDayIsOpen = false;
        this.atMonthChange.emit(this.viewDate);
        this.dateOrViewChanged();
    }
    dateOrViewChanged() {
        this.prevBtnDisabled = !this.dateIsValid(this.endOfPeriod(this.view, this.subPeriod(this.view, this.viewDate, 1)));
        this.nextBtnDisabled = !this.dateIsValid(this.startOfPeriod(this.view, this.addPeriod(this.view, this.viewDate, 1)));
        if (this.viewDate < this.minDate) {
            this.changeDate(this.minDate);
        }
        else if (this.viewDate > this.maxDate) {
            this.changeDate(this.maxDate);
        }
    }
    changeDate(date) {
        console.log("changeDate :: ", date);
        this.viewDate = date;
        this.dateOrViewChanged();
    }
    dateIsValid(date) {
        return date >= this.minDate && date <= this.maxDate;
    }
    increment() {
        this.changeDate(this.addPeriod(this.view, this.viewDate, 1));
    }
}
AngularCalendarViewComponent.ɵfac = function AngularCalendarViewComponent_Factory(t) { return new (t || AngularCalendarViewComponent)(); };
AngularCalendarViewComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AngularCalendarViewComponent, selectors: [["lib-angular-calendar-view"]], viewQuery: function AngularCalendarViewComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1r, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modalContent = _t.first);
    } }, inputs: { setMaxDate: "setMaxDate", setMinDate: "setMinDate", eventColors: "eventColors", eventList: "eventList" }, outputs: { atDayClicked: "atDayClicked", atMonthChange: "atMonthChange" }, decls: 20, vars: 18, consts: [[1, "angular-calendar", "row"], [1, "col-md-4"], [1, "month-label"], [1, "btn-group"], ["mwlCalendarPreviousView", "", 3, "view", "viewDate", "disabled", "viewDateChange"], [1, "arrow", "left"], [1, "month-name"], ["mwlCalendarNextView", "", 3, "view", "viewDate", "disabled", "viewDateChange"], [1, "arrow", "right"], [3, "ngSwitch"], [3, "viewDate", "events", "refresh", "activeDayIsOpen", "cellTemplate", "dayClicked", "eventClicked", "eventTimesChanged", 4, "ngSwitchCase"], [3, "viewDate", "events", "refresh", "eventClicked", "eventTimesChanged", 4, "ngSwitchCase"], ["customCellTemplate", ""], [3, "viewDate", "events", "refresh", "activeDayIsOpen", "cellTemplate", "dayClicked", "eventClicked", "eventTimesChanged"], [3, "viewDate", "events", "refresh", "eventClicked", "eventTimesChanged"], [1, "cal-cell-top"], [1, "cal-day-number"], ["class", "cal-day-number-right", 4, "ngIf"], ["class", "cal-cell-bottom", 4, "ngIf"], [1, "cal-day-number-right"], [1, "cal-cell-bottom"], [4, "ngFor", "ngForOf"], ["class", "cal-event", 3, "ngStyle", 4, "ngIf"], [1, "cal-event", 3, "ngStyle"]], template: function AngularCalendarViewComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "p", 2);
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "button", 4);
        i0.ɵɵlistener("viewDateChange", function AngularCalendarViewComponent_Template_button_viewDateChange_6_listener($event) { return ctx.viewDate = $event; })("viewDateChange", function AngularCalendarViewComponent_Template_button_viewDateChange_6_listener() { return ctx.closeOpenMonthViewDay(); });
        i0.ɵɵelement(7, "i", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "p", 6);
        i0.ɵɵtext(9);
        i0.ɵɵpipe(10, "calendarDate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "button", 7);
        i0.ɵɵlistener("viewDateChange", function AngularCalendarViewComponent_Template_button_viewDateChange_11_listener($event) { return ctx.viewDate = $event; })("viewDateChange", function AngularCalendarViewComponent_Template_button_viewDateChange_11_listener() { return ctx.closeOpenMonthViewDay(); });
        i0.ɵɵelement(12, "i", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(13, "br");
        i0.ɵɵelementStart(14, "div", 9);
        i0.ɵɵtemplate(15, AngularCalendarViewComponent_mwl_calendar_month_view_15_Template, 1, 5, "mwl-calendar-month-view", 10);
        i0.ɵɵtemplate(16, AngularCalendarViewComponent_mwl_calendar_week_view_16_Template, 1, 3, "mwl-calendar-week-view", 11);
        i0.ɵɵtemplate(17, AngularCalendarViewComponent_mwl_calendar_day_view_17_Template, 1, 3, "mwl-calendar-day-view", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, AngularCalendarViewComponent_ng_template_18_Template, 6, 7, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 12, "shared-lib.month"), "\t");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("view", ctx.view)("viewDate", ctx.viewDate)("disabled", ctx.prevBtnDisabled);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(10, 14, ctx.viewDate, ctx.view + "ViewTitle", "en"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("view", ctx.view)("viewDate", ctx.viewDate)("disabled", ctx.nextBtnDisabled);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngSwitch", ctx.view);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.CalendarView.Month);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.CalendarView.Week);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.CalendarView.Day);
    } }, directives: [i1$4.ɵf, i1$4.ɵg, i1$2.NgSwitch, i1$2.NgSwitchCase, i1$4.CalendarMonthViewComponent, i1$4.CalendarWeekViewComponent, i1$4.CalendarDayViewComponent, i1$2.NgIf, i1$2.NgForOf, i1$2.NgStyle], pipes: [i2.TranslatePipe, i1$4.ɵi], styles: [".arrow[_ngcontent-%COMP%]{border:solid #626469;border-width:0 2px 2px 0;display:inline-block;padding:5px;margin:3px 10px;cursor:pointer;position:relative}.right[_ngcontent-%COMP%]{transform:rotate(-45deg);-webkit-transform:rotate(-45deg)}.left[_ngcontent-%COMP%]{transform:rotate(135deg);-webkit-transform:rotate(135deg)}.arrow[_ngcontent-%COMP%]:hover{border-color:#049fd9}p.month-name[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:15px;line-height:18px;color:#049fd9;margin:0;width:130px;text-align:center}button[_ngcontent-%COMP%]{margin:5px;padding:0;border:0;background:transparent}p.month-label[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:12px;line-height:13px;color:#626469;font-weight:900}", "[_ngcontent-%COMP%]:root{--blue:#007bff;--indigo:#6610f2;--purple:#6f42c1;--pink:#e83e8c;--red:#dc3545;--orange:#fd7e14;--yellow:#ffc107;--green:#28a745;--teal:#20c997;--cyan:#17a2b8;--white:#fff;--gray:#6c757d;--gray-dark:#343a40;--primary:#007bff;--secondary:#6c757d;--success:#28a745;--info:#17a2b8;--warning:#ffc107;--danger:#dc3545;--light:#f8f9fa;--dark:#343a40;--breakpoint-xs:0;--breakpoint-sm:576px;--breakpoint-md:768px;--breakpoint-lg:992px;--breakpoint-xl:1200px;--font-family-sans-serif:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}*[_ngcontent-%COMP%], [_ngcontent-%COMP%]:after, [_ngcontent-%COMP%]:before{box-sizing:border-box}html[_ngcontent-%COMP%]{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}article[_ngcontent-%COMP%], aside[_ngcontent-%COMP%], figcaption[_ngcontent-%COMP%], figure[_ngcontent-%COMP%], footer[_ngcontent-%COMP%], header[_ngcontent-%COMP%], hgroup[_ngcontent-%COMP%], main[_ngcontent-%COMP%], nav[_ngcontent-%COMP%], section[_ngcontent-%COMP%]{display:block}body[_ngcontent-%COMP%]{margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}[tabindex=\"-1\"][_ngcontent-%COMP%]:focus:not(:focus-visible){outline:0!important}hr[_ngcontent-%COMP%]{box-sizing:content-box;height:0;overflow:visible}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]{margin-top:0;margin-bottom:.5rem}p[_ngcontent-%COMP%]{margin-top:0;margin-bottom:1rem}abbr[data-original-title][_ngcontent-%COMP%], abbr[title][_ngcontent-%COMP%]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address[_ngcontent-%COMP%]{margin-bottom:1rem;font-style:normal;line-height:inherit}dl[_ngcontent-%COMP%], ol[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]{margin-top:0;margin-bottom:1rem}ol[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%], ol[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin-bottom:0}dt[_ngcontent-%COMP%]{font-weight:700}dd[_ngcontent-%COMP%]{margin-bottom:.5rem;margin-left:0}blockquote[_ngcontent-%COMP%]{margin:0 0 1rem}b[_ngcontent-%COMP%], strong[_ngcontent-%COMP%]{font-weight:bolder}small[_ngcontent-%COMP%]{font-size:80%}sub[_ngcontent-%COMP%], sup[_ngcontent-%COMP%]{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub[_ngcontent-%COMP%]{bottom:-.25em}sup[_ngcontent-%COMP%]{top:-.5em}a[_ngcontent-%COMP%]{color:#007bff;text-decoration:none;background-color:transparent}a[_ngcontent-%COMP%]:hover{color:#0056b3;text-decoration:underline}a[_ngcontent-%COMP%]:not([href]){color:inherit;text-decoration:none}a[_ngcontent-%COMP%]:not([href]):hover{color:inherit;text-decoration:none}code[_ngcontent-%COMP%], kbd[_ngcontent-%COMP%], pre[_ngcontent-%COMP%], samp[_ngcontent-%COMP%]{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;font-size:1em}pre[_ngcontent-%COMP%]{margin-top:0;margin-bottom:1rem;overflow:auto}figure[_ngcontent-%COMP%]{margin:0 0 1rem}img[_ngcontent-%COMP%]{vertical-align:middle;border-style:none}svg[_ngcontent-%COMP%]{overflow:hidden;vertical-align:middle}table[_ngcontent-%COMP%]{border-collapse:collapse}caption[_ngcontent-%COMP%]{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}th[_ngcontent-%COMP%]{text-align:inherit}label[_ngcontent-%COMP%]{display:inline-block;margin-bottom:.5rem}button[_ngcontent-%COMP%]{border-radius:0}button[_ngcontent-%COMP%]:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}button[_ngcontent-%COMP%], input[_ngcontent-%COMP%], optgroup[_ngcontent-%COMP%], select[_ngcontent-%COMP%], textarea[_ngcontent-%COMP%]{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button[_ngcontent-%COMP%], input[_ngcontent-%COMP%]{overflow:visible}button[_ngcontent-%COMP%], select[_ngcontent-%COMP%]{text-transform:none}select[_ngcontent-%COMP%]{word-wrap:normal}[type=button][_ngcontent-%COMP%], [type=reset][_ngcontent-%COMP%], [type=submit][_ngcontent-%COMP%], button[_ngcontent-%COMP%]{-webkit-appearance:button}[type=button][_ngcontent-%COMP%]:not(:disabled), [type=reset][_ngcontent-%COMP%]:not(:disabled), [type=submit][_ngcontent-%COMP%]:not(:disabled), button[_ngcontent-%COMP%]:not(:disabled){cursor:pointer}[type=button][_ngcontent-%COMP%]::-moz-focus-inner, [type=reset][_ngcontent-%COMP%]::-moz-focus-inner, [type=submit][_ngcontent-%COMP%]::-moz-focus-inner, button[_ngcontent-%COMP%]::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox][_ngcontent-%COMP%], input[type=radio][_ngcontent-%COMP%]{box-sizing:border-box;padding:0}input[type=date][_ngcontent-%COMP%], input[type=datetime-local][_ngcontent-%COMP%], input[type=month][_ngcontent-%COMP%], input[type=time][_ngcontent-%COMP%]{-webkit-appearance:listbox}textarea[_ngcontent-%COMP%]{overflow:auto;resize:vertical}fieldset[_ngcontent-%COMP%]{min-width:0;padding:0;margin:0;border:0}legend[_ngcontent-%COMP%]{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress[_ngcontent-%COMP%]{vertical-align:baseline}[type=number][_ngcontent-%COMP%]::-webkit-inner-spin-button, [type=number][_ngcontent-%COMP%]::-webkit-outer-spin-button{height:auto}[type=search][_ngcontent-%COMP%]{outline-offset:-2px;-webkit-appearance:none}[type=search][_ngcontent-%COMP%]::-webkit-search-decoration{-webkit-appearance:none}[_ngcontent-%COMP%]::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output[_ngcontent-%COMP%]{display:inline-block}summary[_ngcontent-%COMP%]{display:list-item;cursor:pointer}template[_ngcontent-%COMP%]{display:none}[hidden][_ngcontent-%COMP%]{display:none!important}.h1[_ngcontent-%COMP%], .h2[_ngcontent-%COMP%], .h3[_ngcontent-%COMP%], .h4[_ngcontent-%COMP%], .h5[_ngcontent-%COMP%], .h6[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]{margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1[_ngcontent-%COMP%], h1[_ngcontent-%COMP%]{font-size:2.5rem}.h2[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]{font-size:2rem}.h3[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]{font-size:1.75rem}.h4[_ngcontent-%COMP%], h4[_ngcontent-%COMP%]{font-size:1.5rem}.h5[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]{font-size:1.25rem}.h6[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]{font-size:1rem}.lead[_ngcontent-%COMP%]{font-size:1.25rem;font-weight:300}.display-1[_ngcontent-%COMP%]{font-size:6rem;font-weight:300;line-height:1.2}.display-2[_ngcontent-%COMP%]{font-size:5.5rem;font-weight:300;line-height:1.2}.display-3[_ngcontent-%COMP%]{font-size:4.5rem;font-weight:300;line-height:1.2}.display-4[_ngcontent-%COMP%]{font-size:3.5rem;font-weight:300;line-height:1.2}hr[_ngcontent-%COMP%]{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small[_ngcontent-%COMP%], small[_ngcontent-%COMP%]{font-size:80%;font-weight:400}.mark[_ngcontent-%COMP%], mark[_ngcontent-%COMP%]{padding:.2em;background-color:#fcf8e3}.list-unstyled[_ngcontent-%COMP%]{padding-left:0;list-style:none}.list-inline[_ngcontent-%COMP%]{padding-left:0;list-style:none}.list-inline-item[_ngcontent-%COMP%]{display:inline-block}.list-inline-item[_ngcontent-%COMP%]:not(:last-child){margin-right:.5rem}.initialism[_ngcontent-%COMP%]{font-size:90%;text-transform:uppercase}.blockquote[_ngcontent-%COMP%]{margin-bottom:1rem;font-size:1.25rem}.blockquote-footer[_ngcontent-%COMP%]{display:block;font-size:80%;color:#6c757d}.blockquote-footer[_ngcontent-%COMP%]:before{content:\"\\2014\\a0\"}.img-fluid[_ngcontent-%COMP%]{max-width:100%;height:auto}.img-thumbnail[_ngcontent-%COMP%]{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure[_ngcontent-%COMP%]{display:inline-block}.figure-img[_ngcontent-%COMP%]{margin-bottom:.5rem;line-height:1}.figure-caption[_ngcontent-%COMP%]{font-size:90%;color:#6c757d}code[_ngcontent-%COMP%]{font-size:87.5%;color:#e83e8c;word-wrap:break-word}a[_ngcontent-%COMP%] > code[_ngcontent-%COMP%]{color:inherit}kbd[_ngcontent-%COMP%]{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}kbd[_ngcontent-%COMP%]   kbd[_ngcontent-%COMP%]{padding:0;font-size:100%;font-weight:700}pre[_ngcontent-%COMP%]{display:block;font-size:87.5%;color:#212529}pre[_ngcontent-%COMP%]   code[_ngcontent-%COMP%]{font-size:inherit;color:inherit;word-break:normal}.pre-scrollable[_ngcontent-%COMP%]{max-height:340px;overflow-y:scroll}.container[_ngcontent-%COMP%]{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container[_ngcontent-%COMP%]{max-width:540px}}@media (min-width:768px){.container[_ngcontent-%COMP%]{max-width:720px}}@media (min-width:992px){.container[_ngcontent-%COMP%]{max-width:960px}}@media (min-width:1200px){.container[_ngcontent-%COMP%]{max-width:1140px}}.container-fluid[_ngcontent-%COMP%], .container-lg[_ngcontent-%COMP%], .container-md[_ngcontent-%COMP%], .container-sm[_ngcontent-%COMP%], .container-xl[_ngcontent-%COMP%]{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container[_ngcontent-%COMP%], .container-sm[_ngcontent-%COMP%]{max-width:540px}}@media (min-width:768px){.container[_ngcontent-%COMP%], .container-md[_ngcontent-%COMP%], .container-sm[_ngcontent-%COMP%]{max-width:720px}}@media (min-width:992px){.container[_ngcontent-%COMP%], .container-lg[_ngcontent-%COMP%], .container-md[_ngcontent-%COMP%], .container-sm[_ngcontent-%COMP%]{max-width:960px}}@media (min-width:1200px){.container[_ngcontent-%COMP%], .container-lg[_ngcontent-%COMP%], .container-md[_ngcontent-%COMP%], .container-sm[_ngcontent-%COMP%], .container-xl[_ngcontent-%COMP%]{max-width:1140px}}.row[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.no-gutters[_ngcontent-%COMP%]{margin-right:0;margin-left:0}.no-gutters[_ngcontent-%COMP%] > .col[_ngcontent-%COMP%], .no-gutters[_ngcontent-%COMP%] > [class*=col-][_ngcontent-%COMP%]{padding-right:0;padding-left:0}.col[_ngcontent-%COMP%], .col-1[_ngcontent-%COMP%], .col-10[_ngcontent-%COMP%], .col-11[_ngcontent-%COMP%], .col-12[_ngcontent-%COMP%], .col-2[_ngcontent-%COMP%], .col-3[_ngcontent-%COMP%], .col-4[_ngcontent-%COMP%], .col-5[_ngcontent-%COMP%], .col-6[_ngcontent-%COMP%], .col-7[_ngcontent-%COMP%], .col-8[_ngcontent-%COMP%], .col-9[_ngcontent-%COMP%], .col-auto[_ngcontent-%COMP%], .col-lg[_ngcontent-%COMP%], .col-lg-1[_ngcontent-%COMP%], .col-lg-10[_ngcontent-%COMP%], .col-lg-11[_ngcontent-%COMP%], .col-lg-12[_ngcontent-%COMP%], .col-lg-2[_ngcontent-%COMP%], .col-lg-3[_ngcontent-%COMP%], .col-lg-4[_ngcontent-%COMP%], .col-lg-5[_ngcontent-%COMP%], .col-lg-6[_ngcontent-%COMP%], .col-lg-7[_ngcontent-%COMP%], .col-lg-8[_ngcontent-%COMP%], .col-lg-9[_ngcontent-%COMP%], .col-lg-auto[_ngcontent-%COMP%], .col-md[_ngcontent-%COMP%], .col-md-1[_ngcontent-%COMP%], .col-md-10[_ngcontent-%COMP%], .col-md-11[_ngcontent-%COMP%], .col-md-12[_ngcontent-%COMP%], .col-md-2[_ngcontent-%COMP%], .col-md-3[_ngcontent-%COMP%], .col-md-4[_ngcontent-%COMP%], .col-md-5[_ngcontent-%COMP%], .col-md-6[_ngcontent-%COMP%], .col-md-7[_ngcontent-%COMP%], .col-md-8[_ngcontent-%COMP%], .col-md-9[_ngcontent-%COMP%], .col-md-auto[_ngcontent-%COMP%], .col-sm[_ngcontent-%COMP%], .col-sm-1[_ngcontent-%COMP%], .col-sm-10[_ngcontent-%COMP%], .col-sm-11[_ngcontent-%COMP%], .col-sm-12[_ngcontent-%COMP%], .col-sm-2[_ngcontent-%COMP%], .col-sm-3[_ngcontent-%COMP%], .col-sm-4[_ngcontent-%COMP%], .col-sm-5[_ngcontent-%COMP%], .col-sm-6[_ngcontent-%COMP%], .col-sm-7[_ngcontent-%COMP%], .col-sm-8[_ngcontent-%COMP%], .col-sm-9[_ngcontent-%COMP%], .col-sm-auto[_ngcontent-%COMP%], .col-xl[_ngcontent-%COMP%], .col-xl-1[_ngcontent-%COMP%], .col-xl-10[_ngcontent-%COMP%], .col-xl-11[_ngcontent-%COMP%], .col-xl-12[_ngcontent-%COMP%], .col-xl-2[_ngcontent-%COMP%], .col-xl-3[_ngcontent-%COMP%], .col-xl-4[_ngcontent-%COMP%], .col-xl-5[_ngcontent-%COMP%], .col-xl-6[_ngcontent-%COMP%], .col-xl-7[_ngcontent-%COMP%], .col-xl-8[_ngcontent-%COMP%], .col-xl-9[_ngcontent-%COMP%], .col-xl-auto[_ngcontent-%COMP%]{position:relative;width:100%;padding-right:15px;padding-left:15px}.col[_ngcontent-%COMP%]{flex-basis:0;flex-grow:1;max-width:100%}.row-cols-1[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 100%;max-width:100%}.row-cols-2[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 50%;max-width:50%}.row-cols-3[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 33.333333%;max-width:33.333333%}.row-cols-4[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 25%;max-width:25%}.row-cols-5[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 20%;max-width:20%}.row-cols-6[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 16.666667%;max-width:16.666667%}.col-auto[_ngcontent-%COMP%]{flex:0 0 auto;width:auto;max-width:100%}.col-1[_ngcontent-%COMP%]{flex:0 0 8.333333%;max-width:8.333333%}.col-2[_ngcontent-%COMP%]{flex:0 0 16.666667%;max-width:16.666667%}.col-3[_ngcontent-%COMP%]{flex:0 0 25%;max-width:25%}.col-4[_ngcontent-%COMP%]{flex:0 0 33.333333%;max-width:33.333333%}.col-5[_ngcontent-%COMP%]{flex:0 0 41.666667%;max-width:41.666667%}.col-6[_ngcontent-%COMP%]{flex:0 0 50%;max-width:50%}.col-7[_ngcontent-%COMP%]{flex:0 0 58.333333%;max-width:58.333333%}.col-8[_ngcontent-%COMP%]{flex:0 0 66.666667%;max-width:66.666667%}.col-9[_ngcontent-%COMP%]{flex:0 0 75%;max-width:75%}.col-10[_ngcontent-%COMP%]{flex:0 0 83.333333%;max-width:83.333333%}.col-11[_ngcontent-%COMP%]{flex:0 0 91.666667%;max-width:91.666667%}.col-12[_ngcontent-%COMP%]{flex:0 0 100%;max-width:100%}.order-first[_ngcontent-%COMP%]{order:-1}.order-last[_ngcontent-%COMP%]{order:13}.order-0[_ngcontent-%COMP%]{order:0}.order-1[_ngcontent-%COMP%]{order:1}.order-2[_ngcontent-%COMP%]{order:2}.order-3[_ngcontent-%COMP%]{order:3}.order-4[_ngcontent-%COMP%]{order:4}.order-5[_ngcontent-%COMP%]{order:5}.order-6[_ngcontent-%COMP%]{order:6}.order-7[_ngcontent-%COMP%]{order:7}.order-8[_ngcontent-%COMP%]{order:8}.order-9[_ngcontent-%COMP%]{order:9}.order-10[_ngcontent-%COMP%]{order:10}.order-11[_ngcontent-%COMP%]{order:11}.order-12[_ngcontent-%COMP%]{order:12}.offset-1[_ngcontent-%COMP%]{margin-left:8.333333%}.offset-2[_ngcontent-%COMP%]{margin-left:16.666667%}.offset-3[_ngcontent-%COMP%]{margin-left:25%}.offset-4[_ngcontent-%COMP%]{margin-left:33.333333%}.offset-5[_ngcontent-%COMP%]{margin-left:41.666667%}.offset-6[_ngcontent-%COMP%]{margin-left:50%}.offset-7[_ngcontent-%COMP%]{margin-left:58.333333%}.offset-8[_ngcontent-%COMP%]{margin-left:66.666667%}.offset-9[_ngcontent-%COMP%]{margin-left:75%}.offset-10[_ngcontent-%COMP%]{margin-left:83.333333%}.offset-11[_ngcontent-%COMP%]{margin-left:91.666667%}@media (min-width:576px){.col-sm[_ngcontent-%COMP%]{flex-basis:0;flex-grow:1;max-width:100%}.row-cols-sm-1[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 100%;max-width:100%}.row-cols-sm-2[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 50%;max-width:50%}.row-cols-sm-3[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 33.333333%;max-width:33.333333%}.row-cols-sm-4[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 25%;max-width:25%}.row-cols-sm-5[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 20%;max-width:20%}.row-cols-sm-6[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 16.666667%;max-width:16.666667%}.col-sm-auto[_ngcontent-%COMP%]{flex:0 0 auto;width:auto;max-width:100%}.col-sm-1[_ngcontent-%COMP%]{flex:0 0 8.333333%;max-width:8.333333%}.col-sm-2[_ngcontent-%COMP%]{flex:0 0 16.666667%;max-width:16.666667%}.col-sm-3[_ngcontent-%COMP%]{flex:0 0 25%;max-width:25%}.col-sm-4[_ngcontent-%COMP%]{flex:0 0 33.333333%;max-width:33.333333%}.col-sm-5[_ngcontent-%COMP%]{flex:0 0 41.666667%;max-width:41.666667%}.col-sm-6[_ngcontent-%COMP%]{flex:0 0 50%;max-width:50%}.col-sm-7[_ngcontent-%COMP%]{flex:0 0 58.333333%;max-width:58.333333%}.col-sm-8[_ngcontent-%COMP%]{flex:0 0 66.666667%;max-width:66.666667%}.col-sm-9[_ngcontent-%COMP%]{flex:0 0 75%;max-width:75%}.col-sm-10[_ngcontent-%COMP%]{flex:0 0 83.333333%;max-width:83.333333%}.col-sm-11[_ngcontent-%COMP%]{flex:0 0 91.666667%;max-width:91.666667%}.col-sm-12[_ngcontent-%COMP%]{flex:0 0 100%;max-width:100%}.order-sm-first[_ngcontent-%COMP%]{order:-1}.order-sm-last[_ngcontent-%COMP%]{order:13}.order-sm-0[_ngcontent-%COMP%]{order:0}.order-sm-1[_ngcontent-%COMP%]{order:1}.order-sm-2[_ngcontent-%COMP%]{order:2}.order-sm-3[_ngcontent-%COMP%]{order:3}.order-sm-4[_ngcontent-%COMP%]{order:4}.order-sm-5[_ngcontent-%COMP%]{order:5}.order-sm-6[_ngcontent-%COMP%]{order:6}.order-sm-7[_ngcontent-%COMP%]{order:7}.order-sm-8[_ngcontent-%COMP%]{order:8}.order-sm-9[_ngcontent-%COMP%]{order:9}.order-sm-10[_ngcontent-%COMP%]{order:10}.order-sm-11[_ngcontent-%COMP%]{order:11}.order-sm-12[_ngcontent-%COMP%]{order:12}.offset-sm-0[_ngcontent-%COMP%]{margin-left:0}.offset-sm-1[_ngcontent-%COMP%]{margin-left:8.333333%}.offset-sm-2[_ngcontent-%COMP%]{margin-left:16.666667%}.offset-sm-3[_ngcontent-%COMP%]{margin-left:25%}.offset-sm-4[_ngcontent-%COMP%]{margin-left:33.333333%}.offset-sm-5[_ngcontent-%COMP%]{margin-left:41.666667%}.offset-sm-6[_ngcontent-%COMP%]{margin-left:50%}.offset-sm-7[_ngcontent-%COMP%]{margin-left:58.333333%}.offset-sm-8[_ngcontent-%COMP%]{margin-left:66.666667%}.offset-sm-9[_ngcontent-%COMP%]{margin-left:75%}.offset-sm-10[_ngcontent-%COMP%]{margin-left:83.333333%}.offset-sm-11[_ngcontent-%COMP%]{margin-left:91.666667%}}@media (min-width:768px){.col-md[_ngcontent-%COMP%]{flex-basis:0;flex-grow:1;max-width:100%}.row-cols-md-1[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 100%;max-width:100%}.row-cols-md-2[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 50%;max-width:50%}.row-cols-md-3[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 33.333333%;max-width:33.333333%}.row-cols-md-4[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 25%;max-width:25%}.row-cols-md-5[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 20%;max-width:20%}.row-cols-md-6[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 16.666667%;max-width:16.666667%}.col-md-auto[_ngcontent-%COMP%]{flex:0 0 auto;width:auto;max-width:100%}.col-md-1[_ngcontent-%COMP%]{flex:0 0 8.333333%;max-width:8.333333%}.col-md-2[_ngcontent-%COMP%]{flex:0 0 16.666667%;max-width:16.666667%}.col-md-3[_ngcontent-%COMP%]{flex:0 0 25%;max-width:25%}.col-md-4[_ngcontent-%COMP%]{flex:0 0 33.333333%;max-width:33.333333%}.col-md-5[_ngcontent-%COMP%]{flex:0 0 41.666667%;max-width:41.666667%}.col-md-6[_ngcontent-%COMP%]{flex:0 0 50%;max-width:50%}.col-md-7[_ngcontent-%COMP%]{flex:0 0 58.333333%;max-width:58.333333%}.col-md-8[_ngcontent-%COMP%]{flex:0 0 66.666667%;max-width:66.666667%}.col-md-9[_ngcontent-%COMP%]{flex:0 0 75%;max-width:75%}.col-md-10[_ngcontent-%COMP%]{flex:0 0 83.333333%;max-width:83.333333%}.col-md-11[_ngcontent-%COMP%]{flex:0 0 91.666667%;max-width:91.666667%}.col-md-12[_ngcontent-%COMP%]{flex:0 0 100%;max-width:100%}.order-md-first[_ngcontent-%COMP%]{order:-1}.order-md-last[_ngcontent-%COMP%]{order:13}.order-md-0[_ngcontent-%COMP%]{order:0}.order-md-1[_ngcontent-%COMP%]{order:1}.order-md-2[_ngcontent-%COMP%]{order:2}.order-md-3[_ngcontent-%COMP%]{order:3}.order-md-4[_ngcontent-%COMP%]{order:4}.order-md-5[_ngcontent-%COMP%]{order:5}.order-md-6[_ngcontent-%COMP%]{order:6}.order-md-7[_ngcontent-%COMP%]{order:7}.order-md-8[_ngcontent-%COMP%]{order:8}.order-md-9[_ngcontent-%COMP%]{order:9}.order-md-10[_ngcontent-%COMP%]{order:10}.order-md-11[_ngcontent-%COMP%]{order:11}.order-md-12[_ngcontent-%COMP%]{order:12}.offset-md-0[_ngcontent-%COMP%]{margin-left:0}.offset-md-1[_ngcontent-%COMP%]{margin-left:8.333333%}.offset-md-2[_ngcontent-%COMP%]{margin-left:16.666667%}.offset-md-3[_ngcontent-%COMP%]{margin-left:25%}.offset-md-4[_ngcontent-%COMP%]{margin-left:33.333333%}.offset-md-5[_ngcontent-%COMP%]{margin-left:41.666667%}.offset-md-6[_ngcontent-%COMP%]{margin-left:50%}.offset-md-7[_ngcontent-%COMP%]{margin-left:58.333333%}.offset-md-8[_ngcontent-%COMP%]{margin-left:66.666667%}.offset-md-9[_ngcontent-%COMP%]{margin-left:75%}.offset-md-10[_ngcontent-%COMP%]{margin-left:83.333333%}.offset-md-11[_ngcontent-%COMP%]{margin-left:91.666667%}}@media (min-width:992px){.col-lg[_ngcontent-%COMP%]{flex-basis:0;flex-grow:1;max-width:100%}.row-cols-lg-1[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 100%;max-width:100%}.row-cols-lg-2[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 50%;max-width:50%}.row-cols-lg-3[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 33.333333%;max-width:33.333333%}.row-cols-lg-4[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 25%;max-width:25%}.row-cols-lg-5[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 20%;max-width:20%}.row-cols-lg-6[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 16.666667%;max-width:16.666667%}.col-lg-auto[_ngcontent-%COMP%]{flex:0 0 auto;width:auto;max-width:100%}.col-lg-1[_ngcontent-%COMP%]{flex:0 0 8.333333%;max-width:8.333333%}.col-lg-2[_ngcontent-%COMP%]{flex:0 0 16.666667%;max-width:16.666667%}.col-lg-3[_ngcontent-%COMP%]{flex:0 0 25%;max-width:25%}.col-lg-4[_ngcontent-%COMP%]{flex:0 0 33.333333%;max-width:33.333333%}.col-lg-5[_ngcontent-%COMP%]{flex:0 0 41.666667%;max-width:41.666667%}.col-lg-6[_ngcontent-%COMP%]{flex:0 0 50%;max-width:50%}.col-lg-7[_ngcontent-%COMP%]{flex:0 0 58.333333%;max-width:58.333333%}.col-lg-8[_ngcontent-%COMP%]{flex:0 0 66.666667%;max-width:66.666667%}.col-lg-9[_ngcontent-%COMP%]{flex:0 0 75%;max-width:75%}.col-lg-10[_ngcontent-%COMP%]{flex:0 0 83.333333%;max-width:83.333333%}.col-lg-11[_ngcontent-%COMP%]{flex:0 0 91.666667%;max-width:91.666667%}.col-lg-12[_ngcontent-%COMP%]{flex:0 0 100%;max-width:100%}.order-lg-first[_ngcontent-%COMP%]{order:-1}.order-lg-last[_ngcontent-%COMP%]{order:13}.order-lg-0[_ngcontent-%COMP%]{order:0}.order-lg-1[_ngcontent-%COMP%]{order:1}.order-lg-2[_ngcontent-%COMP%]{order:2}.order-lg-3[_ngcontent-%COMP%]{order:3}.order-lg-4[_ngcontent-%COMP%]{order:4}.order-lg-5[_ngcontent-%COMP%]{order:5}.order-lg-6[_ngcontent-%COMP%]{order:6}.order-lg-7[_ngcontent-%COMP%]{order:7}.order-lg-8[_ngcontent-%COMP%]{order:8}.order-lg-9[_ngcontent-%COMP%]{order:9}.order-lg-10[_ngcontent-%COMP%]{order:10}.order-lg-11[_ngcontent-%COMP%]{order:11}.order-lg-12[_ngcontent-%COMP%]{order:12}.offset-lg-0[_ngcontent-%COMP%]{margin-left:0}.offset-lg-1[_ngcontent-%COMP%]{margin-left:8.333333%}.offset-lg-2[_ngcontent-%COMP%]{margin-left:16.666667%}.offset-lg-3[_ngcontent-%COMP%]{margin-left:25%}.offset-lg-4[_ngcontent-%COMP%]{margin-left:33.333333%}.offset-lg-5[_ngcontent-%COMP%]{margin-left:41.666667%}.offset-lg-6[_ngcontent-%COMP%]{margin-left:50%}.offset-lg-7[_ngcontent-%COMP%]{margin-left:58.333333%}.offset-lg-8[_ngcontent-%COMP%]{margin-left:66.666667%}.offset-lg-9[_ngcontent-%COMP%]{margin-left:75%}.offset-lg-10[_ngcontent-%COMP%]{margin-left:83.333333%}.offset-lg-11[_ngcontent-%COMP%]{margin-left:91.666667%}}@media (min-width:1200px){.col-xl[_ngcontent-%COMP%]{flex-basis:0;flex-grow:1;max-width:100%}.row-cols-xl-1[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 100%;max-width:100%}.row-cols-xl-2[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 50%;max-width:50%}.row-cols-xl-3[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 33.333333%;max-width:33.333333%}.row-cols-xl-4[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 25%;max-width:25%}.row-cols-xl-5[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 20%;max-width:20%}.row-cols-xl-6[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:0 0 16.666667%;max-width:16.666667%}.col-xl-auto[_ngcontent-%COMP%]{flex:0 0 auto;width:auto;max-width:100%}.col-xl-1[_ngcontent-%COMP%]{flex:0 0 8.333333%;max-width:8.333333%}.col-xl-2[_ngcontent-%COMP%]{flex:0 0 16.666667%;max-width:16.666667%}.col-xl-3[_ngcontent-%COMP%]{flex:0 0 25%;max-width:25%}.col-xl-4[_ngcontent-%COMP%]{flex:0 0 33.333333%;max-width:33.333333%}.col-xl-5[_ngcontent-%COMP%]{flex:0 0 41.666667%;max-width:41.666667%}.col-xl-6[_ngcontent-%COMP%]{flex:0 0 50%;max-width:50%}.col-xl-7[_ngcontent-%COMP%]{flex:0 0 58.333333%;max-width:58.333333%}.col-xl-8[_ngcontent-%COMP%]{flex:0 0 66.666667%;max-width:66.666667%}.col-xl-9[_ngcontent-%COMP%]{flex:0 0 75%;max-width:75%}.col-xl-10[_ngcontent-%COMP%]{flex:0 0 83.333333%;max-width:83.333333%}.col-xl-11[_ngcontent-%COMP%]{flex:0 0 91.666667%;max-width:91.666667%}.col-xl-12[_ngcontent-%COMP%]{flex:0 0 100%;max-width:100%}.order-xl-first[_ngcontent-%COMP%]{order:-1}.order-xl-last[_ngcontent-%COMP%]{order:13}.order-xl-0[_ngcontent-%COMP%]{order:0}.order-xl-1[_ngcontent-%COMP%]{order:1}.order-xl-2[_ngcontent-%COMP%]{order:2}.order-xl-3[_ngcontent-%COMP%]{order:3}.order-xl-4[_ngcontent-%COMP%]{order:4}.order-xl-5[_ngcontent-%COMP%]{order:5}.order-xl-6[_ngcontent-%COMP%]{order:6}.order-xl-7[_ngcontent-%COMP%]{order:7}.order-xl-8[_ngcontent-%COMP%]{order:8}.order-xl-9[_ngcontent-%COMP%]{order:9}.order-xl-10[_ngcontent-%COMP%]{order:10}.order-xl-11[_ngcontent-%COMP%]{order:11}.order-xl-12[_ngcontent-%COMP%]{order:12}.offset-xl-0[_ngcontent-%COMP%]{margin-left:0}.offset-xl-1[_ngcontent-%COMP%]{margin-left:8.333333%}.offset-xl-2[_ngcontent-%COMP%]{margin-left:16.666667%}.offset-xl-3[_ngcontent-%COMP%]{margin-left:25%}.offset-xl-4[_ngcontent-%COMP%]{margin-left:33.333333%}.offset-xl-5[_ngcontent-%COMP%]{margin-left:41.666667%}.offset-xl-6[_ngcontent-%COMP%]{margin-left:50%}.offset-xl-7[_ngcontent-%COMP%]{margin-left:58.333333%}.offset-xl-8[_ngcontent-%COMP%]{margin-left:66.666667%}.offset-xl-9[_ngcontent-%COMP%]{margin-left:75%}.offset-xl-10[_ngcontent-%COMP%]{margin-left:83.333333%}.offset-xl-11[_ngcontent-%COMP%]{margin-left:91.666667%}}.table[_ngcontent-%COMP%]{width:100%;margin-bottom:1rem;color:#212529}.table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] + tbody[_ngcontent-%COMP%]{border-top:2px solid #dee2e6}.table-sm[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-sm[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding:.3rem}.table-bordered[_ngcontent-%COMP%]{border:1px solid #dee2e6}.table-bordered[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:1px solid #dee2e6}.table-bordered[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-bottom-width:2px}.table-borderless[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] + tbody[_ngcontent-%COMP%], .table-borderless[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-borderless[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .table-borderless[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:0}.table-striped[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-of-type(odd){background-color:#0000000d}.table-hover[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover{color:#212529;background-color:#00000013}.table-primary[_ngcontent-%COMP%], .table-primary[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .table-primary[_ngcontent-%COMP%] > th[_ngcontent-%COMP%]{background-color:#b8daff}.table-primary[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] + tbody[_ngcontent-%COMP%], .table-primary[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-primary[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .table-primary[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-color:#7abaff}.table-hover[_ngcontent-%COMP%]   .table-primary[_ngcontent-%COMP%]:hover{background-color:#9fcdff}.table-hover[_ngcontent-%COMP%]   .table-primary[_ngcontent-%COMP%]:hover > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]   .table-primary[_ngcontent-%COMP%]:hover > th[_ngcontent-%COMP%]{background-color:#9fcdff}.table-secondary[_ngcontent-%COMP%], .table-secondary[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .table-secondary[_ngcontent-%COMP%] > th[_ngcontent-%COMP%]{background-color:#d6d8db}.table-secondary[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] + tbody[_ngcontent-%COMP%], .table-secondary[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-secondary[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .table-secondary[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-color:#b3b7bb}.table-hover[_ngcontent-%COMP%]   .table-secondary[_ngcontent-%COMP%]:hover{background-color:#c8cbcf}.table-hover[_ngcontent-%COMP%]   .table-secondary[_ngcontent-%COMP%]:hover > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]   .table-secondary[_ngcontent-%COMP%]:hover > th[_ngcontent-%COMP%]{background-color:#c8cbcf}.table-success[_ngcontent-%COMP%], .table-success[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .table-success[_ngcontent-%COMP%] > th[_ngcontent-%COMP%]{background-color:#c3e6cb}.table-success[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] + tbody[_ngcontent-%COMP%], .table-success[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-success[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .table-success[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-color:#8fd19e}.table-hover[_ngcontent-%COMP%]   .table-success[_ngcontent-%COMP%]:hover{background-color:#b1dfbb}.table-hover[_ngcontent-%COMP%]   .table-success[_ngcontent-%COMP%]:hover > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]   .table-success[_ngcontent-%COMP%]:hover > th[_ngcontent-%COMP%]{background-color:#b1dfbb}.table-info[_ngcontent-%COMP%], .table-info[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .table-info[_ngcontent-%COMP%] > th[_ngcontent-%COMP%]{background-color:#bee5eb}.table-info[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] + tbody[_ngcontent-%COMP%], .table-info[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-info[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .table-info[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-color:#86cfda}.table-hover[_ngcontent-%COMP%]   .table-info[_ngcontent-%COMP%]:hover{background-color:#abdde5}.table-hover[_ngcontent-%COMP%]   .table-info[_ngcontent-%COMP%]:hover > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]   .table-info[_ngcontent-%COMP%]:hover > th[_ngcontent-%COMP%]{background-color:#abdde5}.table-warning[_ngcontent-%COMP%], .table-warning[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .table-warning[_ngcontent-%COMP%] > th[_ngcontent-%COMP%]{background-color:#ffeeba}.table-warning[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] + tbody[_ngcontent-%COMP%], .table-warning[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-warning[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .table-warning[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-color:#ffdf7e}.table-hover[_ngcontent-%COMP%]   .table-warning[_ngcontent-%COMP%]:hover{background-color:#ffe8a1}.table-hover[_ngcontent-%COMP%]   .table-warning[_ngcontent-%COMP%]:hover > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]   .table-warning[_ngcontent-%COMP%]:hover > th[_ngcontent-%COMP%]{background-color:#ffe8a1}.table-danger[_ngcontent-%COMP%], .table-danger[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .table-danger[_ngcontent-%COMP%] > th[_ngcontent-%COMP%]{background-color:#f5c6cb}.table-danger[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] + tbody[_ngcontent-%COMP%], .table-danger[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-danger[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .table-danger[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-color:#ed969e}.table-hover[_ngcontent-%COMP%]   .table-danger[_ngcontent-%COMP%]:hover{background-color:#f1b0b7}.table-hover[_ngcontent-%COMP%]   .table-danger[_ngcontent-%COMP%]:hover > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]   .table-danger[_ngcontent-%COMP%]:hover > th[_ngcontent-%COMP%]{background-color:#f1b0b7}.table-light[_ngcontent-%COMP%], .table-light[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .table-light[_ngcontent-%COMP%] > th[_ngcontent-%COMP%]{background-color:#fdfdfe}.table-light[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] + tbody[_ngcontent-%COMP%], .table-light[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-light[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .table-light[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-color:#fbfcfc}.table-hover[_ngcontent-%COMP%]   .table-light[_ngcontent-%COMP%]:hover{background-color:#ececf6}.table-hover[_ngcontent-%COMP%]   .table-light[_ngcontent-%COMP%]:hover > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]   .table-light[_ngcontent-%COMP%]:hover > th[_ngcontent-%COMP%]{background-color:#ececf6}.table-dark[_ngcontent-%COMP%], .table-dark[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .table-dark[_ngcontent-%COMP%] > th[_ngcontent-%COMP%]{background-color:#c6c8ca}.table-dark[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] + tbody[_ngcontent-%COMP%], .table-dark[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-dark[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .table-dark[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-color:#95999c}.table-hover[_ngcontent-%COMP%]   .table-dark[_ngcontent-%COMP%]:hover{background-color:#b9bbbe}.table-hover[_ngcontent-%COMP%]   .table-dark[_ngcontent-%COMP%]:hover > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]   .table-dark[_ngcontent-%COMP%]:hover > th[_ngcontent-%COMP%]{background-color:#b9bbbe}.table-active[_ngcontent-%COMP%], .table-active[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .table-active[_ngcontent-%COMP%] > th[_ngcontent-%COMP%]{background-color:#00000013}.table-hover[_ngcontent-%COMP%]   .table-active[_ngcontent-%COMP%]:hover{background-color:#00000013}.table-hover[_ngcontent-%COMP%]   .table-active[_ngcontent-%COMP%]:hover > td[_ngcontent-%COMP%], .table-hover[_ngcontent-%COMP%]   .table-active[_ngcontent-%COMP%]:hover > th[_ngcontent-%COMP%]{background-color:#00000013}.table[_ngcontent-%COMP%]   .thead-dark[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:#fff;background-color:#343a40;border-color:#454d55}.table[_ngcontent-%COMP%]   .thead-light[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark[_ngcontent-%COMP%]{color:#fff;background-color:#343a40}.table-dark[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-dark[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .table-dark[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-color:#454d55}.table-dark.table-bordered[_ngcontent-%COMP%]{border:0}.table-dark.table-striped[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-of-type(odd){background-color:#ffffff0d}.table-dark.table-hover[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover{color:#fff;background-color:#ffffff13}@media (max-width:575.98px){.table-responsive-sm[_ngcontent-%COMP%]{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-sm[_ngcontent-%COMP%] > .table-bordered[_ngcontent-%COMP%]{border:0}}@media (max-width:767.98px){.table-responsive-md[_ngcontent-%COMP%]{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-md[_ngcontent-%COMP%] > .table-bordered[_ngcontent-%COMP%]{border:0}}@media (max-width:991.98px){.table-responsive-lg[_ngcontent-%COMP%]{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-lg[_ngcontent-%COMP%] > .table-bordered[_ngcontent-%COMP%]{border:0}}@media (max-width:1199.98px){.table-responsive-xl[_ngcontent-%COMP%]{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-xl[_ngcontent-%COMP%] > .table-bordered[_ngcontent-%COMP%]{border:0}}.table-responsive[_ngcontent-%COMP%]{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive[_ngcontent-%COMP%] > .table-bordered[_ngcontent-%COMP%]{border:0}.form-control[_ngcontent-%COMP%]{display:block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control[_ngcontent-%COMP%]{transition:none}}.form-control[_ngcontent-%COMP%]::-ms-expand{background-color:transparent;border:0}.form-control[_ngcontent-%COMP%]:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.form-control[_ngcontent-%COMP%]:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem #007bff40}.form-control[_ngcontent-%COMP%]::placeholder{color:#6c757d;opacity:1}.form-control[_ngcontent-%COMP%]:disabled, .form-control[readonly][_ngcontent-%COMP%]{background-color:#e9ecef;opacity:1}select.form-control[_ngcontent-%COMP%]:focus::-ms-value{color:#495057;background-color:#fff}.form-control-file[_ngcontent-%COMP%], .form-control-range[_ngcontent-%COMP%]{display:block;width:100%}.col-form-label[_ngcontent-%COMP%]{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg[_ngcontent-%COMP%]{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.col-form-label-sm[_ngcontent-%COMP%]{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.form-control-plaintext[_ngcontent-%COMP%]{display:block;width:100%;padding:.375rem 0;margin-bottom:0;font-size:1rem;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg[_ngcontent-%COMP%], .form-control-plaintext.form-control-sm[_ngcontent-%COMP%]{padding-right:0;padding-left:0}.form-control-sm[_ngcontent-%COMP%]{height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.form-control-lg[_ngcontent-%COMP%]{height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}select.form-control[multiple][_ngcontent-%COMP%], select.form-control[size][_ngcontent-%COMP%]{height:auto}textarea.form-control[_ngcontent-%COMP%]{height:auto}.form-group[_ngcontent-%COMP%]{margin-bottom:1rem}.form-text[_ngcontent-%COMP%]{display:block;margin-top:.25rem}.form-row[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.form-row[_ngcontent-%COMP%] > .col[_ngcontent-%COMP%], .form-row[_ngcontent-%COMP%] > [class*=col-][_ngcontent-%COMP%]{padding-right:5px;padding-left:5px}.form-check[_ngcontent-%COMP%]{position:relative;display:block;padding-left:1.25rem}.form-check-input[_ngcontent-%COMP%]{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.form-check-input[_ngcontent-%COMP%]:disabled ~ .form-check-label[_ngcontent-%COMP%], .form-check-input[disabled][_ngcontent-%COMP%] ~ .form-check-label[_ngcontent-%COMP%]{color:#6c757d}.form-check-label[_ngcontent-%COMP%]{margin-bottom:0}.form-check-inline[_ngcontent-%COMP%]{display:inline-flex;align-items:center;padding-left:0;margin-right:.75rem}.form-check-inline[_ngcontent-%COMP%]   .form-check-input[_ngcontent-%COMP%]{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.valid-feedback[_ngcontent-%COMP%]{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.valid-tooltip[_ngcontent-%COMP%]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:#28a745e6;border-radius:.25rem}.is-valid[_ngcontent-%COMP%] ~ .valid-feedback[_ngcontent-%COMP%], .is-valid[_ngcontent-%COMP%] ~ .valid-tooltip[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:valid ~ .valid-feedback[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:valid ~ .valid-tooltip[_ngcontent-%COMP%]{display:block}.form-control.is-valid[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:valid{border-color:#28a745;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid[_ngcontent-%COMP%]:focus, .was-validated[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem #28a74540}.was-validated[_ngcontent-%COMP%]   textarea.form-control[_ngcontent-%COMP%]:valid, textarea.form-control.is-valid[_ngcontent-%COMP%]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.custom-select.is-valid[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .custom-select[_ngcontent-%COMP%]:valid{border-color:#28a745;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem)}.custom-select.is-valid[_ngcontent-%COMP%]:focus, .was-validated[_ngcontent-%COMP%]   .custom-select[_ngcontent-%COMP%]:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem #28a74540}.form-check-input.is-valid[_ngcontent-%COMP%] ~ .form-check-label[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .form-check-input[_ngcontent-%COMP%]:valid ~ .form-check-label[_ngcontent-%COMP%]{color:#28a745}.form-check-input.is-valid[_ngcontent-%COMP%] ~ .valid-feedback[_ngcontent-%COMP%], .form-check-input.is-valid[_ngcontent-%COMP%] ~ .valid-tooltip[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .form-check-input[_ngcontent-%COMP%]:valid ~ .valid-feedback[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .form-check-input[_ngcontent-%COMP%]:valid ~ .valid-tooltip[_ngcontent-%COMP%]{display:block}.custom-control-input.is-valid[_ngcontent-%COMP%] ~ .custom-control-label[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:valid ~ .custom-control-label[_ngcontent-%COMP%]{color:#28a745}.custom-control-input.is-valid[_ngcontent-%COMP%] ~ .custom-control-label[_ngcontent-%COMP%]:before, .was-validated[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:valid ~ .custom-control-label[_ngcontent-%COMP%]:before{border-color:#28a745}.custom-control-input.is-valid[_ngcontent-%COMP%]:checked ~ .custom-control-label[_ngcontent-%COMP%]:before, .was-validated[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:valid:checked ~ .custom-control-label[_ngcontent-%COMP%]:before{border-color:#34ce57;background-color:#34ce57}.custom-control-input.is-valid[_ngcontent-%COMP%]:focus ~ .custom-control-label[_ngcontent-%COMP%]:before, .was-validated[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:valid:focus ~ .custom-control-label[_ngcontent-%COMP%]:before{box-shadow:0 0 0 .2rem #28a74540}.custom-control-input.is-valid[_ngcontent-%COMP%]:focus:not(:checked) ~ .custom-control-label[_ngcontent-%COMP%]:before, .was-validated[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:valid:focus:not(:checked) ~ .custom-control-label[_ngcontent-%COMP%]:before{border-color:#28a745}.custom-file-input.is-valid[_ngcontent-%COMP%] ~ .custom-file-label[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .custom-file-input[_ngcontent-%COMP%]:valid ~ .custom-file-label[_ngcontent-%COMP%]{border-color:#28a745}.custom-file-input.is-valid[_ngcontent-%COMP%]:focus ~ .custom-file-label[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .custom-file-input[_ngcontent-%COMP%]:valid:focus ~ .custom-file-label[_ngcontent-%COMP%]{border-color:#28a745;box-shadow:0 0 0 .2rem #28a74540}.invalid-feedback[_ngcontent-%COMP%]{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.invalid-tooltip[_ngcontent-%COMP%]{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:#dc3545e6;border-radius:.25rem}.is-invalid[_ngcontent-%COMP%] ~ .invalid-feedback[_ngcontent-%COMP%], .is-invalid[_ngcontent-%COMP%] ~ .invalid-tooltip[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:invalid ~ .invalid-feedback[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:invalid ~ .invalid-tooltip[_ngcontent-%COMP%]{display:block}.form-control.is-invalid[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid[_ngcontent-%COMP%]:focus, .was-validated[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem #dc354540}.was-validated[_ngcontent-%COMP%]   textarea.form-control[_ngcontent-%COMP%]:invalid, textarea.form-control.is-invalid[_ngcontent-%COMP%]{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.custom-select.is-invalid[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .custom-select[_ngcontent-%COMP%]:invalid{border-color:#dc3545;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem)}.custom-select.is-invalid[_ngcontent-%COMP%]:focus, .was-validated[_ngcontent-%COMP%]   .custom-select[_ngcontent-%COMP%]:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem #dc354540}.form-check-input.is-invalid[_ngcontent-%COMP%] ~ .form-check-label[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .form-check-input[_ngcontent-%COMP%]:invalid ~ .form-check-label[_ngcontent-%COMP%]{color:#dc3545}.form-check-input.is-invalid[_ngcontent-%COMP%] ~ .invalid-feedback[_ngcontent-%COMP%], .form-check-input.is-invalid[_ngcontent-%COMP%] ~ .invalid-tooltip[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .form-check-input[_ngcontent-%COMP%]:invalid ~ .invalid-feedback[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .form-check-input[_ngcontent-%COMP%]:invalid ~ .invalid-tooltip[_ngcontent-%COMP%]{display:block}.custom-control-input.is-invalid[_ngcontent-%COMP%] ~ .custom-control-label[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:invalid ~ .custom-control-label[_ngcontent-%COMP%]{color:#dc3545}.custom-control-input.is-invalid[_ngcontent-%COMP%] ~ .custom-control-label[_ngcontent-%COMP%]:before, .was-validated[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:invalid ~ .custom-control-label[_ngcontent-%COMP%]:before{border-color:#dc3545}.custom-control-input.is-invalid[_ngcontent-%COMP%]:checked ~ .custom-control-label[_ngcontent-%COMP%]:before, .was-validated[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:invalid:checked ~ .custom-control-label[_ngcontent-%COMP%]:before{border-color:#e4606d;background-color:#e4606d}.custom-control-input.is-invalid[_ngcontent-%COMP%]:focus ~ .custom-control-label[_ngcontent-%COMP%]:before, .was-validated[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:invalid:focus ~ .custom-control-label[_ngcontent-%COMP%]:before{box-shadow:0 0 0 .2rem #dc354540}.custom-control-input.is-invalid[_ngcontent-%COMP%]:focus:not(:checked) ~ .custom-control-label[_ngcontent-%COMP%]:before, .was-validated[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:invalid:focus:not(:checked) ~ .custom-control-label[_ngcontent-%COMP%]:before{border-color:#dc3545}.custom-file-input.is-invalid[_ngcontent-%COMP%] ~ .custom-file-label[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .custom-file-input[_ngcontent-%COMP%]:invalid ~ .custom-file-label[_ngcontent-%COMP%]{border-color:#dc3545}.custom-file-input.is-invalid[_ngcontent-%COMP%]:focus ~ .custom-file-label[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .custom-file-input[_ngcontent-%COMP%]:invalid:focus ~ .custom-file-label[_ngcontent-%COMP%]{border-color:#dc3545;box-shadow:0 0 0 .2rem #dc354540}.form-inline[_ngcontent-%COMP%]{display:flex;flex-flow:row wrap;align-items:center}.form-inline[_ngcontent-%COMP%]   .form-check[_ngcontent-%COMP%]{width:100%}@media (min-width:576px){.form-inline[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;margin-bottom:0}.form-inline[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]{display:flex;flex:0 0 auto;flex-flow:row wrap;align-items:center;margin-bottom:0}.form-inline[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{display:inline-block;width:auto;vertical-align:middle}.form-inline[_ngcontent-%COMP%]   .form-control-plaintext[_ngcontent-%COMP%]{display:inline-block}.form-inline[_ngcontent-%COMP%]   .custom-select[_ngcontent-%COMP%], .form-inline[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]{width:auto}.form-inline[_ngcontent-%COMP%]   .form-check[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;width:auto;padding-left:0}.form-inline[_ngcontent-%COMP%]   .form-check-input[_ngcontent-%COMP%]{position:relative;flex-shrink:0;margin-top:0;margin-right:.25rem;margin-left:0}.form-inline[_ngcontent-%COMP%]   .custom-control[_ngcontent-%COMP%]{align-items:center;justify-content:center}.form-inline[_ngcontent-%COMP%]   .custom-control-label[_ngcontent-%COMP%]{margin-bottom:0}}.btn[_ngcontent-%COMP%]{display:inline-block;font-weight:400;color:#212529;text-align:center;vertical-align:middle;cursor:pointer;-webkit-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn[_ngcontent-%COMP%]{transition:none}}.btn[_ngcontent-%COMP%]:hover{color:#212529;text-decoration:none}.btn.focus[_ngcontent-%COMP%], .btn[_ngcontent-%COMP%]:focus{outline:0;box-shadow:0 0 0 .2rem #007bff40}.btn.disabled[_ngcontent-%COMP%], .btn[_ngcontent-%COMP%]:disabled{opacity:.65}a.btn.disabled[_ngcontent-%COMP%], fieldset[_ngcontent-%COMP%]:disabled   a.btn[_ngcontent-%COMP%]{pointer-events:none}.btn-primary[_ngcontent-%COMP%]{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary[_ngcontent-%COMP%]:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}.btn-primary.focus[_ngcontent-%COMP%], .btn-primary[_ngcontent-%COMP%]:focus{color:#fff;background-color:#0069d9;border-color:#0062cc;box-shadow:0 0 0 .2rem #268fff80}.btn-primary.disabled[_ngcontent-%COMP%], .btn-primary[_ngcontent-%COMP%]:disabled{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-primary[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-primary.dropdown-toggle[_ngcontent-%COMP%]{color:#fff;background-color:#0062cc;border-color:#005cbf}.btn-primary[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-primary[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-primary.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #268fff80}.btn-secondary[_ngcontent-%COMP%]{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary[_ngcontent-%COMP%]:hover{color:#fff;background-color:#5a6268;border-color:#545b62}.btn-secondary.focus[_ngcontent-%COMP%], .btn-secondary[_ngcontent-%COMP%]:focus{color:#fff;background-color:#5a6268;border-color:#545b62;box-shadow:0 0 0 .2rem #828a9180}.btn-secondary.disabled[_ngcontent-%COMP%], .btn-secondary[_ngcontent-%COMP%]:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-secondary[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-secondary.dropdown-toggle[_ngcontent-%COMP%]{color:#fff;background-color:#545b62;border-color:#4e555b}.btn-secondary[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-secondary[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-secondary.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #828a9180}.btn-success[_ngcontent-%COMP%]{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success[_ngcontent-%COMP%]:hover{color:#fff;background-color:#218838;border-color:#1e7e34}.btn-success.focus[_ngcontent-%COMP%], .btn-success[_ngcontent-%COMP%]:focus{color:#fff;background-color:#218838;border-color:#1e7e34;box-shadow:0 0 0 .2rem #48b46180}.btn-success.disabled[_ngcontent-%COMP%], .btn-success[_ngcontent-%COMP%]:disabled{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-success[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-success.dropdown-toggle[_ngcontent-%COMP%]{color:#fff;background-color:#1e7e34;border-color:#1c7430}.btn-success[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-success[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-success.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #48b46180}.btn-info[_ngcontent-%COMP%]{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info[_ngcontent-%COMP%]:hover{color:#fff;background-color:#138496;border-color:#117a8b}.btn-info.focus[_ngcontent-%COMP%], .btn-info[_ngcontent-%COMP%]:focus{color:#fff;background-color:#138496;border-color:#117a8b;box-shadow:0 0 0 .2rem #3ab0c380}.btn-info.disabled[_ngcontent-%COMP%], .btn-info[_ngcontent-%COMP%]:disabled{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-info[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-info.dropdown-toggle[_ngcontent-%COMP%]{color:#fff;background-color:#117a8b;border-color:#10707f}.btn-info[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-info[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-info.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #3ab0c380}.btn-warning[_ngcontent-%COMP%]{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning[_ngcontent-%COMP%]:hover{color:#212529;background-color:#e0a800;border-color:#d39e00}.btn-warning.focus[_ngcontent-%COMP%], .btn-warning[_ngcontent-%COMP%]:focus{color:#212529;background-color:#e0a800;border-color:#d39e00;box-shadow:0 0 0 .2rem #deaa0c80}.btn-warning.disabled[_ngcontent-%COMP%], .btn-warning[_ngcontent-%COMP%]:disabled{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-warning[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-warning.dropdown-toggle[_ngcontent-%COMP%]{color:#212529;background-color:#d39e00;border-color:#c69500}.btn-warning[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-warning[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-warning.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #deaa0c80}.btn-danger[_ngcontent-%COMP%]{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger[_ngcontent-%COMP%]:hover{color:#fff;background-color:#c82333;border-color:#bd2130}.btn-danger.focus[_ngcontent-%COMP%], .btn-danger[_ngcontent-%COMP%]:focus{color:#fff;background-color:#c82333;border-color:#bd2130;box-shadow:0 0 0 .2rem #e1536180}.btn-danger.disabled[_ngcontent-%COMP%], .btn-danger[_ngcontent-%COMP%]:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-danger[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-danger.dropdown-toggle[_ngcontent-%COMP%]{color:#fff;background-color:#bd2130;border-color:#b21f2d}.btn-danger[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-danger[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-danger.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #e1536180}.btn-light[_ngcontent-%COMP%]{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light[_ngcontent-%COMP%]:hover{color:#212529;background-color:#e2e6ea;border-color:#dae0e5}.btn-light.focus[_ngcontent-%COMP%], .btn-light[_ngcontent-%COMP%]:focus{color:#212529;background-color:#e2e6ea;border-color:#dae0e5;box-shadow:0 0 0 .2rem #d8d9db80}.btn-light.disabled[_ngcontent-%COMP%], .btn-light[_ngcontent-%COMP%]:disabled{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-light[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-light.dropdown-toggle[_ngcontent-%COMP%]{color:#212529;background-color:#dae0e5;border-color:#d3d9df}.btn-light[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-light[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-light.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #d8d9db80}.btn-dark[_ngcontent-%COMP%]{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark[_ngcontent-%COMP%]:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.btn-dark.focus[_ngcontent-%COMP%], .btn-dark[_ngcontent-%COMP%]:focus{color:#fff;background-color:#23272b;border-color:#1d2124;box-shadow:0 0 0 .2rem #52585d80}.btn-dark.disabled[_ngcontent-%COMP%], .btn-dark[_ngcontent-%COMP%]:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-dark[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-dark.dropdown-toggle[_ngcontent-%COMP%]{color:#fff;background-color:#1d2124;border-color:#171a1d}.btn-dark[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-dark[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-dark.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #52585d80}.btn-outline-primary[_ngcontent-%COMP%]{color:#007bff;border-color:#007bff}.btn-outline-primary[_ngcontent-%COMP%]:hover{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary.focus[_ngcontent-%COMP%], .btn-outline-primary[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #007bff80}.btn-outline-primary.disabled[_ngcontent-%COMP%], .btn-outline-primary[_ngcontent-%COMP%]:disabled{color:#007bff;background-color:transparent}.btn-outline-primary[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-outline-primary[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-outline-primary.dropdown-toggle[_ngcontent-%COMP%]{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-outline-primary[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-outline-primary.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #007bff80}.btn-outline-secondary[_ngcontent-%COMP%]{color:#6c757d;border-color:#6c757d}.btn-outline-secondary[_ngcontent-%COMP%]:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary.focus[_ngcontent-%COMP%], .btn-outline-secondary[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #6c757d80}.btn-outline-secondary.disabled[_ngcontent-%COMP%], .btn-outline-secondary[_ngcontent-%COMP%]:disabled{color:#6c757d;background-color:transparent}.btn-outline-secondary[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-outline-secondary[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-outline-secondary.dropdown-toggle[_ngcontent-%COMP%]{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-outline-secondary[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-outline-secondary.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #6c757d80}.btn-outline-success[_ngcontent-%COMP%]{color:#28a745;border-color:#28a745}.btn-outline-success[_ngcontent-%COMP%]:hover{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success.focus[_ngcontent-%COMP%], .btn-outline-success[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #28a74580}.btn-outline-success.disabled[_ngcontent-%COMP%], .btn-outline-success[_ngcontent-%COMP%]:disabled{color:#28a745;background-color:transparent}.btn-outline-success[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-outline-success[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-outline-success.dropdown-toggle[_ngcontent-%COMP%]{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-outline-success[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-outline-success.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #28a74580}.btn-outline-info[_ngcontent-%COMP%]{color:#17a2b8;border-color:#17a2b8}.btn-outline-info[_ngcontent-%COMP%]:hover{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info.focus[_ngcontent-%COMP%], .btn-outline-info[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #17a2b880}.btn-outline-info.disabled[_ngcontent-%COMP%], .btn-outline-info[_ngcontent-%COMP%]:disabled{color:#17a2b8;background-color:transparent}.btn-outline-info[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-outline-info[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-outline-info.dropdown-toggle[_ngcontent-%COMP%]{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-outline-info[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-outline-info.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #17a2b880}.btn-outline-warning[_ngcontent-%COMP%]{color:#ffc107;border-color:#ffc107}.btn-outline-warning[_ngcontent-%COMP%]:hover{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning.focus[_ngcontent-%COMP%], .btn-outline-warning[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #ffc10780}.btn-outline-warning.disabled[_ngcontent-%COMP%], .btn-outline-warning[_ngcontent-%COMP%]:disabled{color:#ffc107;background-color:transparent}.btn-outline-warning[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-outline-warning[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-outline-warning.dropdown-toggle[_ngcontent-%COMP%]{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-outline-warning[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-outline-warning.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #ffc10780}.btn-outline-danger[_ngcontent-%COMP%]{color:#dc3545;border-color:#dc3545}.btn-outline-danger[_ngcontent-%COMP%]:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger.focus[_ngcontent-%COMP%], .btn-outline-danger[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #dc354580}.btn-outline-danger.disabled[_ngcontent-%COMP%], .btn-outline-danger[_ngcontent-%COMP%]:disabled{color:#dc3545;background-color:transparent}.btn-outline-danger[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-outline-danger[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-outline-danger.dropdown-toggle[_ngcontent-%COMP%]{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-outline-danger[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-outline-danger.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #dc354580}.btn-outline-light[_ngcontent-%COMP%]{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light[_ngcontent-%COMP%]:hover{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light.focus[_ngcontent-%COMP%], .btn-outline-light[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #f8f9fa80}.btn-outline-light.disabled[_ngcontent-%COMP%], .btn-outline-light[_ngcontent-%COMP%]:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-light[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-outline-light[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-outline-light.dropdown-toggle[_ngcontent-%COMP%]{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-outline-light[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-outline-light.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #f8f9fa80}.btn-outline-dark[_ngcontent-%COMP%]{color:#343a40;border-color:#343a40}.btn-outline-dark[_ngcontent-%COMP%]:hover{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark.focus[_ngcontent-%COMP%], .btn-outline-dark[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #343a4080}.btn-outline-dark.disabled[_ngcontent-%COMP%], .btn-outline-dark[_ngcontent-%COMP%]:disabled{color:#343a40;background-color:transparent}.btn-outline-dark[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active, .btn-outline-dark[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active, .show[_ngcontent-%COMP%] > .btn-outline-dark.dropdown-toggle[_ngcontent-%COMP%]{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark[_ngcontent-%COMP%]:not(:disabled):not(.disabled).active:focus, .btn-outline-dark[_ngcontent-%COMP%]:not(:disabled):not(.disabled):active:focus, .show[_ngcontent-%COMP%] > .btn-outline-dark.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 0 .2rem #343a4080}.btn-link[_ngcontent-%COMP%]{font-weight:400;color:#007bff;text-decoration:none}.btn-link[_ngcontent-%COMP%]:hover{color:#0056b3;text-decoration:underline}.btn-link.focus[_ngcontent-%COMP%], .btn-link[_ngcontent-%COMP%]:focus{text-decoration:underline;box-shadow:none}.btn-link.disabled[_ngcontent-%COMP%], .btn-link[_ngcontent-%COMP%]:disabled{color:#6c757d;pointer-events:none}.btn-group-lg[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%], .btn-lg[_ngcontent-%COMP%]{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.btn-group-sm[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%], .btn-sm[_ngcontent-%COMP%]{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.btn-block[_ngcontent-%COMP%]{display:block;width:100%}.btn-block[_ngcontent-%COMP%] + .btn-block[_ngcontent-%COMP%]{margin-top:.5rem}input[type=button].btn-block[_ngcontent-%COMP%], input[type=reset].btn-block[_ngcontent-%COMP%], input[type=submit].btn-block[_ngcontent-%COMP%]{width:100%}.fade[_ngcontent-%COMP%]{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade[_ngcontent-%COMP%]{transition:none}}.fade[_ngcontent-%COMP%]:not(.show){opacity:0}.collapse[_ngcontent-%COMP%]:not(.show){display:none}.collapsing[_ngcontent-%COMP%]{position:relative;height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing[_ngcontent-%COMP%]{transition:none}}.dropdown[_ngcontent-%COMP%], .dropleft[_ngcontent-%COMP%], .dropright[_ngcontent-%COMP%], .dropup[_ngcontent-%COMP%]{position:relative}.dropdown-toggle[_ngcontent-%COMP%]{white-space:nowrap}.dropdown-toggle[_ngcontent-%COMP%]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle[_ngcontent-%COMP%]:empty:after{margin-left:0}.dropdown-menu[_ngcontent-%COMP%]{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu-left[_ngcontent-%COMP%]{right:auto;left:0}.dropdown-menu-right[_ngcontent-%COMP%]{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-left[_ngcontent-%COMP%]{right:auto;left:0}.dropdown-menu-sm-right[_ngcontent-%COMP%]{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-left[_ngcontent-%COMP%]{right:auto;left:0}.dropdown-menu-md-right[_ngcontent-%COMP%]{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-left[_ngcontent-%COMP%]{right:auto;left:0}.dropdown-menu-lg-right[_ngcontent-%COMP%]{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-left[_ngcontent-%COMP%]{right:auto;left:0}.dropdown-menu-xl-right[_ngcontent-%COMP%]{right:0;left:auto}}.dropup[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:empty:after{margin-left:0}.dropright[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropright[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropright[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:empty:after{margin-left:0}.dropright[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{vertical-align:0}.dropleft[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropleft[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\"}.dropleft[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.dropleft[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropleft[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:empty:after{margin-left:0}.dropleft[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:before{vertical-align:0}.dropdown-menu[x-placement^=bottom][_ngcontent-%COMP%], .dropdown-menu[x-placement^=left][_ngcontent-%COMP%], .dropdown-menu[x-placement^=right][_ngcontent-%COMP%], .dropdown-menu[x-placement^=top][_ngcontent-%COMP%]{right:auto;bottom:auto}.dropdown-divider[_ngcontent-%COMP%]{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item[_ngcontent-%COMP%]{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item[_ngcontent-%COMP%]:focus, .dropdown-item[_ngcontent-%COMP%]:hover{color:#16181b;text-decoration:none;background-color:#f8f9fa}.dropdown-item.active[_ngcontent-%COMP%], .dropdown-item[_ngcontent-%COMP%]:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled[_ngcontent-%COMP%], .dropdown-item[_ngcontent-%COMP%]:disabled{color:#6c757d;pointer-events:none;background-color:transparent}.dropdown-menu.show[_ngcontent-%COMP%]{display:block}.dropdown-header[_ngcontent-%COMP%]{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text[_ngcontent-%COMP%]{display:block;padding:.25rem 1.5rem;color:#212529}.btn-group[_ngcontent-%COMP%], .btn-group-vertical[_ngcontent-%COMP%]{position:relative;display:inline-flex;vertical-align:middle}.btn-group-vertical[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%], .btn-group[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]{position:relative;flex:1 1 auto}.btn-group-vertical[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]:hover, .btn-group[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]:hover{z-index:1}.btn-group-vertical[_ngcontent-%COMP%] > .btn.active[_ngcontent-%COMP%], .btn-group-vertical[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]:active, .btn-group-vertical[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]:focus, .btn-group[_ngcontent-%COMP%] > .btn.active[_ngcontent-%COMP%], .btn-group[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]:active, .btn-group[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]:focus{z-index:1}.btn-toolbar[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;justify-content:flex-start}.btn-toolbar[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]{width:auto}.btn-group[_ngcontent-%COMP%] > .btn-group[_ngcontent-%COMP%]:not(:first-child), .btn-group[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]:not(:first-child){margin-left:-1px}.btn-group[_ngcontent-%COMP%] > .btn-group[_ngcontent-%COMP%]:not(:last-child) > .btn[_ngcontent-%COMP%], .btn-group[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group[_ngcontent-%COMP%] > .btn-group[_ngcontent-%COMP%]:not(:first-child) > .btn[_ngcontent-%COMP%], .btn-group[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split[_ngcontent-%COMP%]{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split[_ngcontent-%COMP%]:after, .dropright[_ngcontent-%COMP%]   .dropdown-toggle-split[_ngcontent-%COMP%]:after, .dropup[_ngcontent-%COMP%]   .dropdown-toggle-split[_ngcontent-%COMP%]:after{margin-left:0}.dropleft[_ngcontent-%COMP%]   .dropdown-toggle-split[_ngcontent-%COMP%]:before{margin-right:0}.btn-group-sm[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%] + .dropdown-toggle-split[_ngcontent-%COMP%], .btn-sm[_ngcontent-%COMP%] + .dropdown-toggle-split[_ngcontent-%COMP%]{padding-right:.375rem;padding-left:.375rem}.btn-group-lg[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%] + .dropdown-toggle-split[_ngcontent-%COMP%], .btn-lg[_ngcontent-%COMP%] + .dropdown-toggle-split[_ngcontent-%COMP%]{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;justify-content:center}.btn-group-vertical[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%], .btn-group-vertical[_ngcontent-%COMP%] > .btn-group[_ngcontent-%COMP%]{width:100%}.btn-group-vertical[_ngcontent-%COMP%] > .btn-group[_ngcontent-%COMP%]:not(:first-child), .btn-group-vertical[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]:not(:first-child){margin-top:-1px}.btn-group-vertical[_ngcontent-%COMP%] > .btn-group[_ngcontent-%COMP%]:not(:last-child) > .btn[_ngcontent-%COMP%], .btn-group-vertical[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical[_ngcontent-%COMP%] > .btn-group[_ngcontent-%COMP%]:not(:first-child) > .btn[_ngcontent-%COMP%], .btn-group-vertical[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.btn-group-toggle[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%], .btn-group-toggle[_ngcontent-%COMP%] > .btn-group[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]{margin-bottom:0}.btn-group-toggle[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%], .btn-group-toggle[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%], .btn-group-toggle[_ngcontent-%COMP%] > .btn-group[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%], .btn-group-toggle[_ngcontent-%COMP%] > .btn-group[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group[_ngcontent-%COMP%]{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group[_ngcontent-%COMP%] > .custom-file[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .custom-select[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .form-control[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .form-control-plaintext[_ngcontent-%COMP%]{position:relative;flex:1 1 0%;min-width:0;margin-bottom:0}.input-group[_ngcontent-%COMP%] > .custom-file[_ngcontent-%COMP%] + .custom-file[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .custom-file[_ngcontent-%COMP%] + .custom-select[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .custom-file[_ngcontent-%COMP%] + .form-control[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .custom-select[_ngcontent-%COMP%] + .custom-file[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .custom-select[_ngcontent-%COMP%] + .custom-select[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .custom-select[_ngcontent-%COMP%] + .form-control[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .form-control[_ngcontent-%COMP%] + .custom-file[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .form-control[_ngcontent-%COMP%] + .custom-select[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .form-control[_ngcontent-%COMP%] + .form-control[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .form-control-plaintext[_ngcontent-%COMP%] + .custom-file[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .form-control-plaintext[_ngcontent-%COMP%] + .custom-select[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .form-control-plaintext[_ngcontent-%COMP%] + .form-control[_ngcontent-%COMP%]{margin-left:-1px}.input-group[_ngcontent-%COMP%] > .custom-file[_ngcontent-%COMP%]   .custom-file-input[_ngcontent-%COMP%]:focus ~ .custom-file-label[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .custom-select[_ngcontent-%COMP%]:focus, .input-group[_ngcontent-%COMP%] > .form-control[_ngcontent-%COMP%]:focus{z-index:3}.input-group[_ngcontent-%COMP%] > .custom-file[_ngcontent-%COMP%]   .custom-file-input[_ngcontent-%COMP%]:focus{z-index:4}.input-group[_ngcontent-%COMP%] > .custom-select[_ngcontent-%COMP%]:not(:last-child), .input-group[_ngcontent-%COMP%] > .form-control[_ngcontent-%COMP%]:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group[_ngcontent-%COMP%] > .custom-select[_ngcontent-%COMP%]:not(:first-child), .input-group[_ngcontent-%COMP%] > .form-control[_ngcontent-%COMP%]:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group[_ngcontent-%COMP%] > .custom-file[_ngcontent-%COMP%]{display:flex;align-items:center}.input-group[_ngcontent-%COMP%] > .custom-file[_ngcontent-%COMP%]:not(:last-child)   .custom-file-label[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .custom-file[_ngcontent-%COMP%]:not(:last-child)   .custom-file-label[_ngcontent-%COMP%]:after{border-top-right-radius:0;border-bottom-right-radius:0}.input-group[_ngcontent-%COMP%] > .custom-file[_ngcontent-%COMP%]:not(:first-child)   .custom-file-label[_ngcontent-%COMP%]{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-append[_ngcontent-%COMP%], .input-group-prepend[_ngcontent-%COMP%]{display:flex}.input-group-append[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%], .input-group-prepend[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{position:relative;z-index:2}.input-group-append[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:focus, .input-group-prepend[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:focus{z-index:3}.input-group-append[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] + .btn[_ngcontent-%COMP%], .input-group-append[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] + .input-group-text[_ngcontent-%COMP%], .input-group-append[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%] + .btn[_ngcontent-%COMP%], .input-group-append[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%] + .input-group-text[_ngcontent-%COMP%], .input-group-prepend[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] + .btn[_ngcontent-%COMP%], .input-group-prepend[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] + .input-group-text[_ngcontent-%COMP%], .input-group-prepend[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%] + .btn[_ngcontent-%COMP%], .input-group-prepend[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%] + .input-group-text[_ngcontent-%COMP%]{margin-left:-1px}.input-group-prepend[_ngcontent-%COMP%]{margin-right:-1px}.input-group-append[_ngcontent-%COMP%]{margin-left:-1px}.input-group-text[_ngcontent-%COMP%]{display:flex;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-text[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%], .input-group-text[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]{margin-top:0}.input-group-lg[_ngcontent-%COMP%] > .custom-select[_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%] > .form-control[_ngcontent-%COMP%]:not(textarea){height:calc(1.5em + 1rem + 2px)}.input-group-lg[_ngcontent-%COMP%] > .custom-select[_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%] > .form-control[_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%] > .input-group-append[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%] > .input-group-append[_ngcontent-%COMP%] > .input-group-text[_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%] > .input-group-prepend[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%], .input-group-lg[_ngcontent-%COMP%] > .input-group-prepend[_ngcontent-%COMP%] > .input-group-text[_ngcontent-%COMP%]{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.input-group-sm[_ngcontent-%COMP%] > .custom-select[_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%] > .form-control[_ngcontent-%COMP%]:not(textarea){height:calc(1.5em + .5rem + 2px)}.input-group-sm[_ngcontent-%COMP%] > .custom-select[_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%] > .form-control[_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%] > .input-group-append[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%] > .input-group-append[_ngcontent-%COMP%] > .input-group-text[_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%] > .input-group-prepend[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%] > .input-group-prepend[_ngcontent-%COMP%] > .input-group-text[_ngcontent-%COMP%]{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.input-group-lg[_ngcontent-%COMP%] > .custom-select[_ngcontent-%COMP%], .input-group-sm[_ngcontent-%COMP%] > .custom-select[_ngcontent-%COMP%]{padding-right:1.75rem}.input-group[_ngcontent-%COMP%] > .input-group-append[_ngcontent-%COMP%]:last-child > .btn[_ngcontent-%COMP%]:not(:last-child):not(.dropdown-toggle), .input-group[_ngcontent-%COMP%] > .input-group-append[_ngcontent-%COMP%]:last-child > .input-group-text[_ngcontent-%COMP%]:not(:last-child), .input-group[_ngcontent-%COMP%] > .input-group-append[_ngcontent-%COMP%]:not(:last-child) > .btn[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .input-group-append[_ngcontent-%COMP%]:not(:last-child) > .input-group-text[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .input-group-prepend[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .input-group-prepend[_ngcontent-%COMP%] > .input-group-text[_ngcontent-%COMP%]{border-top-right-radius:0;border-bottom-right-radius:0}.input-group[_ngcontent-%COMP%] > .input-group-append[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .input-group-append[_ngcontent-%COMP%] > .input-group-text[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .input-group-prepend[_ngcontent-%COMP%]:first-child > .btn[_ngcontent-%COMP%]:not(:first-child), .input-group[_ngcontent-%COMP%] > .input-group-prepend[_ngcontent-%COMP%]:first-child > .input-group-text[_ngcontent-%COMP%]:not(:first-child), .input-group[_ngcontent-%COMP%] > .input-group-prepend[_ngcontent-%COMP%]:not(:first-child) > .btn[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%] > .input-group-prepend[_ngcontent-%COMP%]:not(:first-child) > .input-group-text[_ngcontent-%COMP%]{border-top-left-radius:0;border-bottom-left-radius:0}.custom-control[_ngcontent-%COMP%]{position:relative;display:block;min-height:1.5rem;padding-left:1.5rem}.custom-control-inline[_ngcontent-%COMP%]{display:inline-flex;margin-right:1rem}.custom-control-input[_ngcontent-%COMP%]{position:absolute;left:0;z-index:-1;width:1rem;height:1.25rem;opacity:0}.custom-control-input[_ngcontent-%COMP%]:checked ~ .custom-control-label[_ngcontent-%COMP%]:before{color:#fff;border-color:#007bff;background-color:#007bff}.custom-control-input[_ngcontent-%COMP%]:focus ~ .custom-control-label[_ngcontent-%COMP%]:before{box-shadow:0 0 0 .2rem #007bff40}.custom-control-input[_ngcontent-%COMP%]:focus:not(:checked) ~ .custom-control-label[_ngcontent-%COMP%]:before{border-color:#80bdff}.custom-control-input[_ngcontent-%COMP%]:not(:disabled):active ~ .custom-control-label[_ngcontent-%COMP%]:before{color:#fff;background-color:#b3d7ff;border-color:#b3d7ff}.custom-control-input[_ngcontent-%COMP%]:disabled ~ .custom-control-label[_ngcontent-%COMP%], .custom-control-input[disabled][_ngcontent-%COMP%] ~ .custom-control-label[_ngcontent-%COMP%]{color:#6c757d}.custom-control-input[_ngcontent-%COMP%]:disabled ~ .custom-control-label[_ngcontent-%COMP%]:before, .custom-control-input[disabled][_ngcontent-%COMP%] ~ .custom-control-label[_ngcontent-%COMP%]:before{background-color:#e9ecef}.custom-control-label[_ngcontent-%COMP%]{position:relative;margin-bottom:0;vertical-align:top}.custom-control-label[_ngcontent-%COMP%]:before{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;pointer-events:none;content:\"\";background-color:#fff;border:#adb5bd solid 1px}.custom-control-label[_ngcontent-%COMP%]:after{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;content:\"\";background:no-repeat 50%/50% 50%}.custom-checkbox[_ngcontent-%COMP%]   .custom-control-label[_ngcontent-%COMP%]:before{border-radius:.25rem}.custom-checkbox[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:checked ~ .custom-control-label[_ngcontent-%COMP%]:after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\")}.custom-checkbox[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:indeterminate ~ .custom-control-label[_ngcontent-%COMP%]:before{border-color:#007bff;background-color:#007bff}.custom-checkbox[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:indeterminate ~ .custom-control-label[_ngcontent-%COMP%]:after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\")}.custom-checkbox[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:disabled:checked ~ .custom-control-label[_ngcontent-%COMP%]:before{background-color:#007bff80}.custom-checkbox[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:disabled:indeterminate ~ .custom-control-label[_ngcontent-%COMP%]:before{background-color:#007bff80}.custom-radio[_ngcontent-%COMP%]   .custom-control-label[_ngcontent-%COMP%]:before{border-radius:50%}.custom-radio[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:checked ~ .custom-control-label[_ngcontent-%COMP%]:after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}.custom-radio[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:disabled:checked ~ .custom-control-label[_ngcontent-%COMP%]:before{background-color:#007bff80}.custom-switch[_ngcontent-%COMP%]{padding-left:2.25rem}.custom-switch[_ngcontent-%COMP%]   .custom-control-label[_ngcontent-%COMP%]:before{left:-2.25rem;width:1.75rem;pointer-events:all;border-radius:.5rem}.custom-switch[_ngcontent-%COMP%]   .custom-control-label[_ngcontent-%COMP%]:after{top:calc(.25rem + 2px);left:calc(-2.25rem + 2px);width:calc(1rem - 4px);height:calc(1rem - 4px);background-color:#adb5bd;border-radius:.5rem;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-switch[_ngcontent-%COMP%]   .custom-control-label[_ngcontent-%COMP%]:after{transition:none}}.custom-switch[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:checked ~ .custom-control-label[_ngcontent-%COMP%]:after{background-color:#fff;transform:translate(.75rem)}.custom-switch[_ngcontent-%COMP%]   .custom-control-input[_ngcontent-%COMP%]:disabled:checked ~ .custom-control-label[_ngcontent-%COMP%]:before{background-color:#007bff80}.custom-select[_ngcontent-%COMP%]{display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem 1.75rem .375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;vertical-align:middle;background:#fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px;border:1px solid #ced4da;border-radius:.25rem;appearance:none}.custom-select[_ngcontent-%COMP%]:focus{border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem #007bff40}.custom-select[_ngcontent-%COMP%]:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple][_ngcontent-%COMP%], .custom-select[size][_ngcontent-%COMP%]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.custom-select[_ngcontent-%COMP%]:disabled{color:#6c757d;background-color:#e9ecef}.custom-select[_ngcontent-%COMP%]::-ms-expand{display:none}.custom-select[_ngcontent-%COMP%]:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.custom-select-sm[_ngcontent-%COMP%]{height:calc(1.5em + .5rem + 2px);padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem}.custom-select-lg[_ngcontent-%COMP%]{height:calc(1.5em + 1rem + 2px);padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem}.custom-file[_ngcontent-%COMP%]{position:relative;display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);margin-bottom:0}.custom-file-input[_ngcontent-%COMP%]{position:relative;z-index:2;width:100%;height:calc(1.5em + .75rem + 2px);margin:0;opacity:0}.custom-file-input[_ngcontent-%COMP%]:focus ~ .custom-file-label[_ngcontent-%COMP%]{border-color:#80bdff;box-shadow:0 0 0 .2rem #007bff40}.custom-file-input[_ngcontent-%COMP%]:disabled ~ .custom-file-label[_ngcontent-%COMP%], .custom-file-input[disabled][_ngcontent-%COMP%] ~ .custom-file-label[_ngcontent-%COMP%]{background-color:#e9ecef}.custom-file-input[_ngcontent-%COMP%]:lang(en) ~ .custom-file-label[_ngcontent-%COMP%]:after{content:\"Browse\"}.custom-file-input[_ngcontent-%COMP%] ~ .custom-file-label[data-browse][_ngcontent-%COMP%]:after{content:attr(data-browse)}.custom-file-label[_ngcontent-%COMP%]{position:absolute;top:0;right:0;left:0;z-index:1;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.custom-file-label[_ngcontent-%COMP%]:after{position:absolute;top:0;right:0;bottom:0;z-index:3;display:block;height:calc(1.5em + .75rem);padding:.375rem .75rem;line-height:1.5;color:#495057;content:\"Browse\";background-color:#e9ecef;border-left:inherit;border-radius:0 .25rem .25rem 0}.custom-range[_ngcontent-%COMP%]{width:100%;height:1.4rem;padding:0;background-color:transparent;appearance:none}.custom-range[_ngcontent-%COMP%]:focus{outline:0}.custom-range[_ngcontent-%COMP%]:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem #007bff40}.custom-range[_ngcontent-%COMP%]:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem #007bff40}.custom-range[_ngcontent-%COMP%]:focus::-ms-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem #007bff40}.custom-range[_ngcontent-%COMP%]::-moz-focus-outer{border:0}.custom-range[_ngcontent-%COMP%]::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#007bff;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range[_ngcontent-%COMP%]::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.custom-range[_ngcontent-%COMP%]::-webkit-slider-thumb:active{background-color:#b3d7ff}.custom-range[_ngcontent-%COMP%]::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range[_ngcontent-%COMP%]::-moz-range-thumb{width:1rem;height:1rem;background-color:#007bff;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range[_ngcontent-%COMP%]::-moz-range-thumb{-moz-transition:none;transition:none}}.custom-range[_ngcontent-%COMP%]::-moz-range-thumb:active{background-color:#b3d7ff}.custom-range[_ngcontent-%COMP%]::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range[_ngcontent-%COMP%]::-ms-thumb{width:1rem;height:1rem;margin-top:0;margin-right:.2rem;margin-left:.2rem;background-color:#007bff;border:0;border-radius:1rem;-ms-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range[_ngcontent-%COMP%]::-ms-thumb{-ms-transition:none;transition:none}}.custom-range[_ngcontent-%COMP%]::-ms-thumb:active{background-color:#b3d7ff}.custom-range[_ngcontent-%COMP%]::-ms-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:transparent;border-color:transparent;border-width:.5rem}.custom-range[_ngcontent-%COMP%]::-ms-fill-lower{background-color:#dee2e6;border-radius:1rem}.custom-range[_ngcontent-%COMP%]::-ms-fill-upper{margin-right:15px;background-color:#dee2e6;border-radius:1rem}.custom-range[_ngcontent-%COMP%]:disabled::-webkit-slider-thumb{background-color:#adb5bd}.custom-range[_ngcontent-%COMP%]:disabled::-webkit-slider-runnable-track{cursor:default}.custom-range[_ngcontent-%COMP%]:disabled::-moz-range-thumb{background-color:#adb5bd}.custom-range[_ngcontent-%COMP%]:disabled::-moz-range-track{cursor:default}.custom-range[_ngcontent-%COMP%]:disabled::-ms-thumb{background-color:#adb5bd}.custom-control-label[_ngcontent-%COMP%]:before, .custom-file-label[_ngcontent-%COMP%], .custom-select[_ngcontent-%COMP%]{transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-control-label[_ngcontent-%COMP%]:before, .custom-file-label[_ngcontent-%COMP%], .custom-select[_ngcontent-%COMP%]{transition:none}}.nav[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link[_ngcontent-%COMP%]{display:block;padding:.5rem 1rem}.nav-link[_ngcontent-%COMP%]:focus, .nav-link[_ngcontent-%COMP%]:hover{text-decoration:none}.nav-link.disabled[_ngcontent-%COMP%]{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs[_ngcontent-%COMP%]{border-bottom:1px solid #dee2e6}.nav-tabs[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]{margin-bottom:-1px}.nav-tabs[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]:focus, .nav-tabs[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]:hover{border-color:#e9ecef #e9ecef #dee2e6}.nav-tabs[_ngcontent-%COMP%]   .nav-link.disabled[_ngcontent-%COMP%]{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs[_ngcontent-%COMP%]   .nav-item.show[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%], .nav-tabs[_ngcontent-%COMP%]   .nav-link.active[_ngcontent-%COMP%]{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{border-radius:.25rem}.nav-pills[_ngcontent-%COMP%]   .nav-link.active[_ngcontent-%COMP%], .nav-pills[_ngcontent-%COMP%]   .show[_ngcontent-%COMP%] > .nav-link[_ngcontent-%COMP%]{color:#fff;background-color:#007bff}.nav-fill[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]{flex:1 1 auto;text-align:center}.nav-justified[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]{flex-basis:0;flex-grow:1;text-align:center}.tab-content[_ngcontent-%COMP%] > .tab-pane[_ngcontent-%COMP%]{display:none}.tab-content[_ngcontent-%COMP%] > .active[_ngcontent-%COMP%]{display:block}.navbar[_ngcontent-%COMP%]{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding:.5rem 1rem}.navbar[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%], .navbar[_ngcontent-%COMP%]   .container-fluid[_ngcontent-%COMP%], .navbar[_ngcontent-%COMP%]   .container-lg[_ngcontent-%COMP%], .navbar[_ngcontent-%COMP%]   .container-md[_ngcontent-%COMP%], .navbar[_ngcontent-%COMP%]   .container-sm[_ngcontent-%COMP%], .navbar[_ngcontent-%COMP%]   .container-xl[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between}.navbar-brand[_ngcontent-%COMP%]{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.navbar-brand[_ngcontent-%COMP%]:focus, .navbar-brand[_ngcontent-%COMP%]:hover{text-decoration:none}.navbar-nav[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{padding-right:0;padding-left:0}.navbar-nav[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{position:static;float:none}.navbar-text[_ngcontent-%COMP%]{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse[_ngcontent-%COMP%]{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler[_ngcontent-%COMP%]{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.navbar-toggler[_ngcontent-%COMP%]:focus, .navbar-toggler[_ngcontent-%COMP%]:hover{text-decoration:none}.navbar-toggler-icon[_ngcontent-%COMP%]{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:no-repeat center center;background-size:100% 100%}@media (max-width:575.98px){.navbar-expand-sm[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%], .navbar-expand-sm[_ngcontent-%COMP%] > .container-fluid[_ngcontent-%COMP%], .navbar-expand-sm[_ngcontent-%COMP%] > .container-lg[_ngcontent-%COMP%], .navbar-expand-sm[_ngcontent-%COMP%] > .container-md[_ngcontent-%COMP%], .navbar-expand-sm[_ngcontent-%COMP%] > .container-sm[_ngcontent-%COMP%], .navbar-expand-sm[_ngcontent-%COMP%] > .container-xl[_ngcontent-%COMP%]{padding-right:0;padding-left:0}}@media (min-width:576px){.navbar-expand-sm[_ngcontent-%COMP%]{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-sm[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]{flex-direction:row}.navbar-expand-sm[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{position:absolute}.navbar-expand-sm[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%], .navbar-expand-sm[_ngcontent-%COMP%] > .container-fluid[_ngcontent-%COMP%], .navbar-expand-sm[_ngcontent-%COMP%] > .container-lg[_ngcontent-%COMP%], .navbar-expand-sm[_ngcontent-%COMP%] > .container-md[_ngcontent-%COMP%], .navbar-expand-sm[_ngcontent-%COMP%] > .container-sm[_ngcontent-%COMP%], .navbar-expand-sm[_ngcontent-%COMP%] > .container-xl[_ngcontent-%COMP%]{flex-wrap:nowrap}.navbar-expand-sm[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%]{display:flex!important;flex-basis:auto}.navbar-expand-sm[_ngcontent-%COMP%]   .navbar-toggler[_ngcontent-%COMP%]{display:none}}@media (max-width:767.98px){.navbar-expand-md[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%], .navbar-expand-md[_ngcontent-%COMP%] > .container-fluid[_ngcontent-%COMP%], .navbar-expand-md[_ngcontent-%COMP%] > .container-lg[_ngcontent-%COMP%], .navbar-expand-md[_ngcontent-%COMP%] > .container-md[_ngcontent-%COMP%], .navbar-expand-md[_ngcontent-%COMP%] > .container-sm[_ngcontent-%COMP%], .navbar-expand-md[_ngcontent-%COMP%] > .container-xl[_ngcontent-%COMP%]{padding-right:0;padding-left:0}}@media (min-width:768px){.navbar-expand-md[_ngcontent-%COMP%]{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-md[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]{flex-direction:row}.navbar-expand-md[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{position:absolute}.navbar-expand-md[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%], .navbar-expand-md[_ngcontent-%COMP%] > .container-fluid[_ngcontent-%COMP%], .navbar-expand-md[_ngcontent-%COMP%] > .container-lg[_ngcontent-%COMP%], .navbar-expand-md[_ngcontent-%COMP%] > .container-md[_ngcontent-%COMP%], .navbar-expand-md[_ngcontent-%COMP%] > .container-sm[_ngcontent-%COMP%], .navbar-expand-md[_ngcontent-%COMP%] > .container-xl[_ngcontent-%COMP%]{flex-wrap:nowrap}.navbar-expand-md[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%]{display:flex!important;flex-basis:auto}.navbar-expand-md[_ngcontent-%COMP%]   .navbar-toggler[_ngcontent-%COMP%]{display:none}}@media (max-width:991.98px){.navbar-expand-lg[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%], .navbar-expand-lg[_ngcontent-%COMP%] > .container-fluid[_ngcontent-%COMP%], .navbar-expand-lg[_ngcontent-%COMP%] > .container-lg[_ngcontent-%COMP%], .navbar-expand-lg[_ngcontent-%COMP%] > .container-md[_ngcontent-%COMP%], .navbar-expand-lg[_ngcontent-%COMP%] > .container-sm[_ngcontent-%COMP%], .navbar-expand-lg[_ngcontent-%COMP%] > .container-xl[_ngcontent-%COMP%]{padding-right:0;padding-left:0}}@media (min-width:992px){.navbar-expand-lg[_ngcontent-%COMP%]{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-lg[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]{flex-direction:row}.navbar-expand-lg[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{position:absolute}.navbar-expand-lg[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%], .navbar-expand-lg[_ngcontent-%COMP%] > .container-fluid[_ngcontent-%COMP%], .navbar-expand-lg[_ngcontent-%COMP%] > .container-lg[_ngcontent-%COMP%], .navbar-expand-lg[_ngcontent-%COMP%] > .container-md[_ngcontent-%COMP%], .navbar-expand-lg[_ngcontent-%COMP%] > .container-sm[_ngcontent-%COMP%], .navbar-expand-lg[_ngcontent-%COMP%] > .container-xl[_ngcontent-%COMP%]{flex-wrap:nowrap}.navbar-expand-lg[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%]{display:flex!important;flex-basis:auto}.navbar-expand-lg[_ngcontent-%COMP%]   .navbar-toggler[_ngcontent-%COMP%]{display:none}}@media (max-width:1199.98px){.navbar-expand-xl[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%], .navbar-expand-xl[_ngcontent-%COMP%] > .container-fluid[_ngcontent-%COMP%], .navbar-expand-xl[_ngcontent-%COMP%] > .container-lg[_ngcontent-%COMP%], .navbar-expand-xl[_ngcontent-%COMP%] > .container-md[_ngcontent-%COMP%], .navbar-expand-xl[_ngcontent-%COMP%] > .container-sm[_ngcontent-%COMP%], .navbar-expand-xl[_ngcontent-%COMP%] > .container-xl[_ngcontent-%COMP%]{padding-right:0;padding-left:0}}@media (min-width:1200px){.navbar-expand-xl[_ngcontent-%COMP%]{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand-xl[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]{flex-direction:row}.navbar-expand-xl[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{position:absolute}.navbar-expand-xl[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%], .navbar-expand-xl[_ngcontent-%COMP%] > .container-fluid[_ngcontent-%COMP%], .navbar-expand-xl[_ngcontent-%COMP%] > .container-lg[_ngcontent-%COMP%], .navbar-expand-xl[_ngcontent-%COMP%] > .container-md[_ngcontent-%COMP%], .navbar-expand-xl[_ngcontent-%COMP%] > .container-sm[_ngcontent-%COMP%], .navbar-expand-xl[_ngcontent-%COMP%] > .container-xl[_ngcontent-%COMP%]{flex-wrap:nowrap}.navbar-expand-xl[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%]{display:flex!important;flex-basis:auto}.navbar-expand-xl[_ngcontent-%COMP%]   .navbar-toggler[_ngcontent-%COMP%]{display:none}}.navbar-expand[_ngcontent-%COMP%]{flex-flow:row nowrap;justify-content:flex-start}.navbar-expand[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%], .navbar-expand[_ngcontent-%COMP%] > .container-fluid[_ngcontent-%COMP%], .navbar-expand[_ngcontent-%COMP%] > .container-lg[_ngcontent-%COMP%], .navbar-expand[_ngcontent-%COMP%] > .container-md[_ngcontent-%COMP%], .navbar-expand[_ngcontent-%COMP%] > .container-sm[_ngcontent-%COMP%], .navbar-expand[_ngcontent-%COMP%] > .container-xl[_ngcontent-%COMP%]{padding-right:0;padding-left:0}.navbar-expand[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]{flex-direction:row}.navbar-expand[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{position:absolute}.navbar-expand[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{padding-right:.5rem;padding-left:.5rem}.navbar-expand[_ngcontent-%COMP%] > .container[_ngcontent-%COMP%], .navbar-expand[_ngcontent-%COMP%] > .container-fluid[_ngcontent-%COMP%], .navbar-expand[_ngcontent-%COMP%] > .container-lg[_ngcontent-%COMP%], .navbar-expand[_ngcontent-%COMP%] > .container-md[_ngcontent-%COMP%], .navbar-expand[_ngcontent-%COMP%] > .container-sm[_ngcontent-%COMP%], .navbar-expand[_ngcontent-%COMP%] > .container-xl[_ngcontent-%COMP%]{flex-wrap:nowrap}.navbar-expand[_ngcontent-%COMP%]   .navbar-collapse[_ngcontent-%COMP%]{display:flex!important;flex-basis:auto}.navbar-expand[_ngcontent-%COMP%]   .navbar-toggler[_ngcontent-%COMP%]{display:none}.navbar-light[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%]{color:#000000e6}.navbar-light[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%]:focus, .navbar-light[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%]:hover{color:#000000e6}.navbar-light[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{color:#00000080}.navbar-light[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]:focus, .navbar-light[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]:hover{color:#000000b3}.navbar-light[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link.disabled[_ngcontent-%COMP%]{color:#0000004d}.navbar-light[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%] > .nav-link[_ngcontent-%COMP%], .navbar-light[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link.active[_ngcontent-%COMP%], .navbar-light[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link.show[_ngcontent-%COMP%], .navbar-light[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .show[_ngcontent-%COMP%] > .nav-link[_ngcontent-%COMP%]{color:#000000e6}.navbar-light[_ngcontent-%COMP%]   .navbar-toggler[_ngcontent-%COMP%]{color:#00000080;border-color:#0000001a}.navbar-light[_ngcontent-%COMP%]   .navbar-toggler-icon[_ngcontent-%COMP%]{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(0, 0, 0, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-light[_ngcontent-%COMP%]   .navbar-text[_ngcontent-%COMP%]{color:#00000080}.navbar-light[_ngcontent-%COMP%]   .navbar-text[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#000000e6}.navbar-light[_ngcontent-%COMP%]   .navbar-text[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus, .navbar-light[_ngcontent-%COMP%]   .navbar-text[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#000000e6}.navbar-dark[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%]{color:#fff}.navbar-dark[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%]:focus, .navbar-dark[_ngcontent-%COMP%]   .navbar-brand[_ngcontent-%COMP%]:hover{color:#fff}.navbar-dark[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{color:#ffffff80}.navbar-dark[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]:focus, .navbar-dark[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]:hover{color:#ffffffbf}.navbar-dark[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link.disabled[_ngcontent-%COMP%]{color:#ffffff40}.navbar-dark[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%] > .nav-link[_ngcontent-%COMP%], .navbar-dark[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link.active[_ngcontent-%COMP%], .navbar-dark[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-link.show[_ngcontent-%COMP%], .navbar-dark[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .show[_ngcontent-%COMP%] > .nav-link[_ngcontent-%COMP%]{color:#fff}.navbar-dark[_ngcontent-%COMP%]   .navbar-toggler[_ngcontent-%COMP%]{color:#ffffff80;border-color:#ffffff1a}.navbar-dark[_ngcontent-%COMP%]   .navbar-toggler-icon[_ngcontent-%COMP%]{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-dark[_ngcontent-%COMP%]   .navbar-text[_ngcontent-%COMP%]{color:#ffffff80}.navbar-dark[_ngcontent-%COMP%]   .navbar-text[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#fff}.navbar-dark[_ngcontent-%COMP%]   .navbar-text[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus, .navbar-dark[_ngcontent-%COMP%]   .navbar-text[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#fff}.card[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card[_ngcontent-%COMP%] > hr[_ngcontent-%COMP%]{margin-right:0;margin-left:0}.card[_ngcontent-%COMP%] > .list-group[_ngcontent-%COMP%]:first-child   .list-group-item[_ngcontent-%COMP%]:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.card[_ngcontent-%COMP%] > .list-group[_ngcontent-%COMP%]:last-child   .list-group-item[_ngcontent-%COMP%]:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.card-body[_ngcontent-%COMP%]{flex:1 1 auto;min-height:1px;padding:1.25rem}.card-title[_ngcontent-%COMP%]{margin-bottom:.75rem}.card-subtitle[_ngcontent-%COMP%]{margin-top:-.375rem;margin-bottom:0}.card-text[_ngcontent-%COMP%]:last-child{margin-bottom:0}.card-link[_ngcontent-%COMP%]:hover{text-decoration:none}.card-link[_ngcontent-%COMP%] + .card-link[_ngcontent-%COMP%]{margin-left:1.25rem}.card-header[_ngcontent-%COMP%]{padding:.75rem 1.25rem;margin-bottom:0;background-color:#00000008;border-bottom:1px solid rgba(0,0,0,.125)}.card-header[_ngcontent-%COMP%]:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-header[_ngcontent-%COMP%] + .list-group[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:first-child{border-top:0}.card-footer[_ngcontent-%COMP%]{padding:.75rem 1.25rem;background-color:#00000008;border-top:1px solid rgba(0,0,0,.125)}.card-footer[_ngcontent-%COMP%]:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs[_ngcontent-%COMP%]{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.card-header-pills[_ngcontent-%COMP%]{margin-right:-.625rem;margin-left:-.625rem}.card-img-overlay[_ngcontent-%COMP%]{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem}.card-img[_ngcontent-%COMP%], .card-img-bottom[_ngcontent-%COMP%], .card-img-top[_ngcontent-%COMP%]{flex-shrink:0;width:100%}.card-img[_ngcontent-%COMP%], .card-img-top[_ngcontent-%COMP%]{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img[_ngcontent-%COMP%], .card-img-bottom[_ngcontent-%COMP%]{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-deck[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{margin-bottom:15px}@media (min-width:576px){.card-deck[_ngcontent-%COMP%]{display:flex;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.card-deck[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{flex:1 0 0%;margin-right:15px;margin-bottom:0;margin-left:15px}}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]{margin-bottom:15px}@media (min-width:576px){.card-group[_ngcontent-%COMP%]{display:flex;flex-flow:row wrap}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]{flex:1 0 0%;margin-bottom:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%] + .card[_ngcontent-%COMP%]{margin-left:0;border-left:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:last-child)   .card-header[_ngcontent-%COMP%], .card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:last-child)   .card-img-top[_ngcontent-%COMP%]{border-top-right-radius:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:last-child)   .card-footer[_ngcontent-%COMP%], .card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:last-child)   .card-img-bottom[_ngcontent-%COMP%]{border-bottom-right-radius:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:first-child)   .card-header[_ngcontent-%COMP%], .card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:first-child)   .card-img-top[_ngcontent-%COMP%]{border-top-left-radius:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:first-child)   .card-footer[_ngcontent-%COMP%], .card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:first-child)   .card-img-bottom[_ngcontent-%COMP%]{border-bottom-left-radius:0}}.card-columns[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{margin-bottom:.75rem}@media (min-width:576px){.card-columns[_ngcontent-%COMP%]{column-count:3;-webkit-column-gap:1.25rem;-moz-column-gap:1.25rem;grid-column-gap:1.25rem;column-gap:1.25rem;orphans:1;widows:1}.card-columns[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{display:inline-block;width:100%}}.accordion[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]{overflow:hidden}.accordion[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:last-of-type){border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.accordion[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:first-of-type){border-top-left-radius:0;border-top-right-radius:0}.accordion[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%] > .card-header[_ngcontent-%COMP%]{border-radius:0;margin-bottom:-1px}.breadcrumb[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.breadcrumb-item[_ngcontent-%COMP%] + .breadcrumb-item[_ngcontent-%COMP%]{padding-left:.5rem}.breadcrumb-item[_ngcontent-%COMP%] + .breadcrumb-item[_ngcontent-%COMP%]:before{display:inline-block;padding-right:.5rem;color:#6c757d;content:\"/\"}.breadcrumb-item[_ngcontent-%COMP%] + .breadcrumb-item[_ngcontent-%COMP%]:hover:before{text-decoration:underline}.breadcrumb-item[_ngcontent-%COMP%] + .breadcrumb-item[_ngcontent-%COMP%]:hover:before{text-decoration:none}.breadcrumb-item.active[_ngcontent-%COMP%]{color:#6c757d}.pagination[_ngcontent-%COMP%]{display:flex;padding-left:0;list-style:none;border-radius:.25rem}.page-link[_ngcontent-%COMP%]{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.page-link[_ngcontent-%COMP%]:hover{z-index:2;color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.page-link[_ngcontent-%COMP%]:focus{z-index:3;outline:0;box-shadow:0 0 0 .2rem #007bff40}.page-item[_ngcontent-%COMP%]:first-child   .page-link[_ngcontent-%COMP%]{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item[_ngcontent-%COMP%]:last-child   .page-link[_ngcontent-%COMP%]{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.page-item.active[_ngcontent-%COMP%]   .page-link[_ngcontent-%COMP%]{z-index:3;color:#fff;background-color:#007bff;border-color:#007bff}.page-item.disabled[_ngcontent-%COMP%]   .page-link[_ngcontent-%COMP%]{color:#6c757d;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.pagination-lg[_ngcontent-%COMP%]   .page-link[_ngcontent-%COMP%]{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.pagination-lg[_ngcontent-%COMP%]   .page-item[_ngcontent-%COMP%]:first-child   .page-link[_ngcontent-%COMP%]{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg[_ngcontent-%COMP%]   .page-item[_ngcontent-%COMP%]:last-child   .page-link[_ngcontent-%COMP%]{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm[_ngcontent-%COMP%]   .page-link[_ngcontent-%COMP%]{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.pagination-sm[_ngcontent-%COMP%]   .page-item[_ngcontent-%COMP%]:first-child   .page-link[_ngcontent-%COMP%]{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm[_ngcontent-%COMP%]   .page-item[_ngcontent-%COMP%]:last-child   .page-link[_ngcontent-%COMP%]{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge[_ngcontent-%COMP%]{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.badge[_ngcontent-%COMP%]{transition:none}}a.badge[_ngcontent-%COMP%]:focus, a.badge[_ngcontent-%COMP%]:hover{text-decoration:none}.badge[_ngcontent-%COMP%]:empty{display:none}.btn[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{position:relative;top:-1px}.badge-pill[_ngcontent-%COMP%]{padding-right:.6em;padding-left:.6em;border-radius:10rem}.badge-primary[_ngcontent-%COMP%]{color:#fff;background-color:#007bff}a.badge-primary[_ngcontent-%COMP%]:focus, a.badge-primary[_ngcontent-%COMP%]:hover{color:#fff;background-color:#0062cc}a.badge-primary.focus[_ngcontent-%COMP%], a.badge-primary[_ngcontent-%COMP%]:focus{outline:0;box-shadow:0 0 0 .2rem #007bff80}.badge-secondary[_ngcontent-%COMP%]{color:#fff;background-color:#6c757d}a.badge-secondary[_ngcontent-%COMP%]:focus, a.badge-secondary[_ngcontent-%COMP%]:hover{color:#fff;background-color:#545b62}a.badge-secondary.focus[_ngcontent-%COMP%], a.badge-secondary[_ngcontent-%COMP%]:focus{outline:0;box-shadow:0 0 0 .2rem #6c757d80}.badge-success[_ngcontent-%COMP%]{color:#fff;background-color:#28a745}a.badge-success[_ngcontent-%COMP%]:focus, a.badge-success[_ngcontent-%COMP%]:hover{color:#fff;background-color:#1e7e34}a.badge-success.focus[_ngcontent-%COMP%], a.badge-success[_ngcontent-%COMP%]:focus{outline:0;box-shadow:0 0 0 .2rem #28a74580}.badge-info[_ngcontent-%COMP%]{color:#fff;background-color:#17a2b8}a.badge-info[_ngcontent-%COMP%]:focus, a.badge-info[_ngcontent-%COMP%]:hover{color:#fff;background-color:#117a8b}a.badge-info.focus[_ngcontent-%COMP%], a.badge-info[_ngcontent-%COMP%]:focus{outline:0;box-shadow:0 0 0 .2rem #17a2b880}.badge-warning[_ngcontent-%COMP%]{color:#212529;background-color:#ffc107}a.badge-warning[_ngcontent-%COMP%]:focus, a.badge-warning[_ngcontent-%COMP%]:hover{color:#212529;background-color:#d39e00}a.badge-warning.focus[_ngcontent-%COMP%], a.badge-warning[_ngcontent-%COMP%]:focus{outline:0;box-shadow:0 0 0 .2rem #ffc10780}.badge-danger[_ngcontent-%COMP%]{color:#fff;background-color:#dc3545}a.badge-danger[_ngcontent-%COMP%]:focus, a.badge-danger[_ngcontent-%COMP%]:hover{color:#fff;background-color:#bd2130}a.badge-danger.focus[_ngcontent-%COMP%], a.badge-danger[_ngcontent-%COMP%]:focus{outline:0;box-shadow:0 0 0 .2rem #dc354580}.badge-light[_ngcontent-%COMP%]{color:#212529;background-color:#f8f9fa}a.badge-light[_ngcontent-%COMP%]:focus, a.badge-light[_ngcontent-%COMP%]:hover{color:#212529;background-color:#dae0e5}a.badge-light.focus[_ngcontent-%COMP%], a.badge-light[_ngcontent-%COMP%]:focus{outline:0;box-shadow:0 0 0 .2rem #f8f9fa80}.badge-dark[_ngcontent-%COMP%]{color:#fff;background-color:#343a40}a.badge-dark[_ngcontent-%COMP%]:focus, a.badge-dark[_ngcontent-%COMP%]:hover{color:#fff;background-color:#1d2124}a.badge-dark.focus[_ngcontent-%COMP%], a.badge-dark[_ngcontent-%COMP%]:focus{outline:0;box-shadow:0 0 0 .2rem #343a4080}.jumbotron[_ngcontent-%COMP%]{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width:576px){.jumbotron[_ngcontent-%COMP%]{padding:4rem 2rem}}.jumbotron-fluid[_ngcontent-%COMP%]{padding-right:0;padding-left:0;border-radius:0}.alert[_ngcontent-%COMP%]{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading[_ngcontent-%COMP%]{color:inherit}.alert-link[_ngcontent-%COMP%]{font-weight:700}.alert-dismissible[_ngcontent-%COMP%]{padding-right:4rem}.alert-dismissible[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{position:absolute;top:0;right:0;padding:.75rem 1.25rem;color:inherit}.alert-primary[_ngcontent-%COMP%]{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert-primary[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border-top-color:#9fcdff}.alert-primary[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%]{color:#002752}.alert-secondary[_ngcontent-%COMP%]{color:#383d41;background-color:#e2e3e5;border-color:#d6d8db}.alert-secondary[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border-top-color:#c8cbcf}.alert-secondary[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%]{color:#202326}.alert-success[_ngcontent-%COMP%]{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert-success[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border-top-color:#b1dfbb}.alert-success[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%]{color:#0b2e13}.alert-info[_ngcontent-%COMP%]{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.alert-info[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border-top-color:#abdde5}.alert-info[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%]{color:#062c33}.alert-warning[_ngcontent-%COMP%]{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.alert-warning[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border-top-color:#ffe8a1}.alert-warning[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%]{color:#533f03}.alert-danger[_ngcontent-%COMP%]{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert-danger[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border-top-color:#f1b0b7}.alert-danger[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%]{color:#491217}.alert-light[_ngcontent-%COMP%]{color:#818182;background-color:#fefefe;border-color:#fdfdfe}.alert-light[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border-top-color:#ececf6}.alert-light[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%]{color:#686868}.alert-dark[_ngcontent-%COMP%]{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.alert-dark[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border-top-color:#b9bbbe}.alert-dark[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%]{color:#040505}@keyframes progress-bar-stripes{0%{background-position:1rem 0}to{background-position:0 0}}.progress[_ngcontent-%COMP%]{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#007bff;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar[_ngcontent-%COMP%]{transition:none}}.progress-bar-striped[_ngcontent-%COMP%]{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-size:1rem 1rem}.progress-bar-animated[_ngcontent-%COMP%]{animation:progress-bar-stripes 1s linear infinite}@media (prefers-reduced-motion:reduce){.progress-bar-animated[_ngcontent-%COMP%]{animation:none}}.media[_ngcontent-%COMP%]{display:flex;align-items:flex-start}.media-body[_ngcontent-%COMP%]{flex:1}.list-group[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding-left:0;margin-bottom:0}.list-group-item-action[_ngcontent-%COMP%]{width:100%;color:#495057;text-align:inherit}.list-group-item-action[_ngcontent-%COMP%]:focus, .list-group-item-action[_ngcontent-%COMP%]:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action[_ngcontent-%COMP%]:active{color:#212529;background-color:#e9ecef}.list-group-item[_ngcontent-%COMP%]{position:relative;display:block;padding:.75rem 1.25rem;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item[_ngcontent-%COMP%]:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.list-group-item[_ngcontent-%COMP%]:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.list-group-item.disabled[_ngcontent-%COMP%], .list-group-item[_ngcontent-%COMP%]:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active[_ngcontent-%COMP%]{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.list-group-item[_ngcontent-%COMP%] + .list-group-item[_ngcontent-%COMP%]{border-top-width:0}.list-group-item[_ngcontent-%COMP%] + .list-group-item.active[_ngcontent-%COMP%]{margin-top:-1px;border-top-width:1px}.list-group-horizontal[_ngcontent-%COMP%]{flex-direction:row}.list-group-horizontal[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal[_ngcontent-%COMP%]   .list-group-item.active[_ngcontent-%COMP%]{margin-top:0}.list-group-horizontal[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%] + .list-group-item[_ngcontent-%COMP%]{border-top-width:1px;border-left-width:0}.list-group-horizontal[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%] + .list-group-item.active[_ngcontent-%COMP%]{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm[_ngcontent-%COMP%]{flex-direction:row}.list-group-horizontal-sm[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm[_ngcontent-%COMP%]   .list-group-item.active[_ngcontent-%COMP%]{margin-top:0}.list-group-horizontal-sm[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%] + .list-group-item[_ngcontent-%COMP%]{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%] + .list-group-item.active[_ngcontent-%COMP%]{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md[_ngcontent-%COMP%]{flex-direction:row}.list-group-horizontal-md[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md[_ngcontent-%COMP%]   .list-group-item.active[_ngcontent-%COMP%]{margin-top:0}.list-group-horizontal-md[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%] + .list-group-item[_ngcontent-%COMP%]{border-top-width:1px;border-left-width:0}.list-group-horizontal-md[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%] + .list-group-item.active[_ngcontent-%COMP%]{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg[_ngcontent-%COMP%]{flex-direction:row}.list-group-horizontal-lg[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg[_ngcontent-%COMP%]   .list-group-item.active[_ngcontent-%COMP%]{margin-top:0}.list-group-horizontal-lg[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%] + .list-group-item[_ngcontent-%COMP%]{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%] + .list-group-item.active[_ngcontent-%COMP%]{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl[_ngcontent-%COMP%]{flex-direction:row}.list-group-horizontal-xl[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl[_ngcontent-%COMP%]   .list-group-item.active[_ngcontent-%COMP%]{margin-top:0}.list-group-horizontal-xl[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%] + .list-group-item[_ngcontent-%COMP%]{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%] + .list-group-item.active[_ngcontent-%COMP%]{margin-left:-1px;border-left-width:1px}}.list-group-flush[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]{border-right-width:0;border-left-width:0;border-radius:0}.list-group-flush[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:first-child{border-top-width:0}.list-group-flush[_ngcontent-%COMP%]:last-child   .list-group-item[_ngcontent-%COMP%]:last-child{border-bottom-width:0}.list-group-item-primary[_ngcontent-%COMP%]{color:#004085;background-color:#b8daff}.list-group-item-primary.list-group-item-action[_ngcontent-%COMP%]:focus, .list-group-item-primary.list-group-item-action[_ngcontent-%COMP%]:hover{color:#004085;background-color:#9fcdff}.list-group-item-primary.list-group-item-action.active[_ngcontent-%COMP%]{color:#fff;background-color:#004085;border-color:#004085}.list-group-item-secondary[_ngcontent-%COMP%]{color:#383d41;background-color:#d6d8db}.list-group-item-secondary.list-group-item-action[_ngcontent-%COMP%]:focus, .list-group-item-secondary.list-group-item-action[_ngcontent-%COMP%]:hover{color:#383d41;background-color:#c8cbcf}.list-group-item-secondary.list-group-item-action.active[_ngcontent-%COMP%]{color:#fff;background-color:#383d41;border-color:#383d41}.list-group-item-success[_ngcontent-%COMP%]{color:#155724;background-color:#c3e6cb}.list-group-item-success.list-group-item-action[_ngcontent-%COMP%]:focus, .list-group-item-success.list-group-item-action[_ngcontent-%COMP%]:hover{color:#155724;background-color:#b1dfbb}.list-group-item-success.list-group-item-action.active[_ngcontent-%COMP%]{color:#fff;background-color:#155724;border-color:#155724}.list-group-item-info[_ngcontent-%COMP%]{color:#0c5460;background-color:#bee5eb}.list-group-item-info.list-group-item-action[_ngcontent-%COMP%]:focus, .list-group-item-info.list-group-item-action[_ngcontent-%COMP%]:hover{color:#0c5460;background-color:#abdde5}.list-group-item-info.list-group-item-action.active[_ngcontent-%COMP%]{color:#fff;background-color:#0c5460;border-color:#0c5460}.list-group-item-warning[_ngcontent-%COMP%]{color:#856404;background-color:#ffeeba}.list-group-item-warning.list-group-item-action[_ngcontent-%COMP%]:focus, .list-group-item-warning.list-group-item-action[_ngcontent-%COMP%]:hover{color:#856404;background-color:#ffe8a1}.list-group-item-warning.list-group-item-action.active[_ngcontent-%COMP%]{color:#fff;background-color:#856404;border-color:#856404}.list-group-item-danger[_ngcontent-%COMP%]{color:#721c24;background-color:#f5c6cb}.list-group-item-danger.list-group-item-action[_ngcontent-%COMP%]:focus, .list-group-item-danger.list-group-item-action[_ngcontent-%COMP%]:hover{color:#721c24;background-color:#f1b0b7}.list-group-item-danger.list-group-item-action.active[_ngcontent-%COMP%]{color:#fff;background-color:#721c24;border-color:#721c24}.list-group-item-light[_ngcontent-%COMP%]{color:#818182;background-color:#fdfdfe}.list-group-item-light.list-group-item-action[_ngcontent-%COMP%]:focus, .list-group-item-light.list-group-item-action[_ngcontent-%COMP%]:hover{color:#818182;background-color:#ececf6}.list-group-item-light.list-group-item-action.active[_ngcontent-%COMP%]{color:#fff;background-color:#818182;border-color:#818182}.list-group-item-dark[_ngcontent-%COMP%]{color:#1b1e21;background-color:#c6c8ca}.list-group-item-dark.list-group-item-action[_ngcontent-%COMP%]:focus, .list-group-item-dark.list-group-item-action[_ngcontent-%COMP%]:hover{color:#1b1e21;background-color:#b9bbbe}.list-group-item-dark.list-group-item-action.active[_ngcontent-%COMP%]{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.close[_ngcontent-%COMP%]{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close[_ngcontent-%COMP%]:hover{color:#000;text-decoration:none}.close[_ngcontent-%COMP%]:not(:disabled):not(.disabled):focus, .close[_ngcontent-%COMP%]:not(:disabled):not(.disabled):hover{opacity:.75}button.close[_ngcontent-%COMP%]{padding:0;background-color:transparent;border:0;appearance:none}a.close.disabled[_ngcontent-%COMP%]{pointer-events:none}.toast[_ngcontent-%COMP%]{max-width:350px;overflow:hidden;font-size:.875rem;background-color:#ffffffd9;background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .25rem .75rem #0000001a;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);opacity:0;border-radius:.25rem}.toast[_ngcontent-%COMP%]:not(:last-child){margin-bottom:.75rem}.toast.showing[_ngcontent-%COMP%]{opacity:1}.toast.show[_ngcontent-%COMP%]{display:block;opacity:1}.toast.hide[_ngcontent-%COMP%]{display:none}.toast-header[_ngcontent-%COMP%]{display:flex;align-items:center;padding:.25rem .75rem;color:#6c757d;background-color:#ffffffd9;background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05)}.toast-body[_ngcontent-%COMP%]{padding:.75rem}.modal-open[_ngcontent-%COMP%]{overflow:hidden}.modal-open[_ngcontent-%COMP%]   .modal[_ngcontent-%COMP%]{overflow-x:hidden;overflow-y:auto}.modal[_ngcontent-%COMP%]{position:fixed;top:0;left:0;z-index:1050;display:none;width:100%;height:100%;overflow:hidden;outline:0}.modal-dialog[_ngcontent-%COMP%]{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{transition:transform .3s ease-out;transform:translateY(-50px)}@media (prefers-reduced-motion:reduce){.modal.fade[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{transition:none}}.modal.show[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{transform:none}.modal.modal-static[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{transform:scale(1.02)}.modal-dialog-scrollable[_ngcontent-%COMP%]{display:flex;max-height:calc(100% - 1rem)}.modal-dialog-scrollable[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{max-height:calc(100vh - 1rem);overflow:hidden}.modal-dialog-scrollable[_ngcontent-%COMP%]   .modal-footer[_ngcontent-%COMP%], .modal-dialog-scrollable[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%]{flex-shrink:0}.modal-dialog-scrollable[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%]{overflow-y:auto}.modal-dialog-centered[_ngcontent-%COMP%]{display:flex;align-items:center;min-height:calc(100% - 1rem)}.modal-dialog-centered[_ngcontent-%COMP%]:before{display:block;height:calc(100vh - 1rem);content:\"\"}.modal-dialog-centered.modal-dialog-scrollable[_ngcontent-%COMP%]{flex-direction:column;justify-content:center;height:100%}.modal-dialog-centered.modal-dialog-scrollable[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{max-height:none}.modal-dialog-centered.modal-dialog-scrollable[_ngcontent-%COMP%]:before{content:none}.modal-content[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop[_ngcontent-%COMP%]{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade[_ngcontent-%COMP%]{opacity:0}.modal-backdrop.show[_ngcontent-%COMP%]{opacity:.5}.modal-header[_ngcontent-%COMP%]{display:flex;align-items:flex-start;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{padding:1rem;margin:-1rem -1rem -1rem auto}.modal-title[_ngcontent-%COMP%]{margin-bottom:0;line-height:1.5}.modal-body[_ngcontent-%COMP%]{position:relative;flex:1 1 auto;padding:1rem}.modal-footer[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin:.25rem}.modal-scrollbar-measure[_ngcontent-%COMP%]{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.modal-dialog[_ngcontent-%COMP%]{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable[_ngcontent-%COMP%]{max-height:calc(100% - 3.5rem)}.modal-dialog-scrollable[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{max-height:calc(100vh - 3.5rem)}.modal-dialog-centered[_ngcontent-%COMP%]{min-height:calc(100% - 3.5rem)}.modal-dialog-centered[_ngcontent-%COMP%]:before{height:calc(100vh - 3.5rem)}.modal-sm[_ngcontent-%COMP%]{max-width:300px}}@media (min-width:992px){.modal-lg[_ngcontent-%COMP%], .modal-xl[_ngcontent-%COMP%]{max-width:800px}}@media (min-width:1200px){.modal-xl[_ngcontent-%COMP%]{max-width:1140px}}.tooltip[_ngcontent-%COMP%]{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show[_ngcontent-%COMP%]{opacity:.9}.tooltip[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[x-placement^=top][_ngcontent-%COMP%], .bs-tooltip-top[_ngcontent-%COMP%]{padding:.4rem 0}.bs-tooltip-auto[x-placement^=top][_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-top[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]{bottom:0}.bs-tooltip-auto[x-placement^=top][_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before, .bs-tooltip-top[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[x-placement^=right][_ngcontent-%COMP%], .bs-tooltip-right[_ngcontent-%COMP%]{padding:0 .4rem}.bs-tooltip-auto[x-placement^=right][_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-right[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=right][_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before, .bs-tooltip-right[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[x-placement^=bottom][_ngcontent-%COMP%], .bs-tooltip-bottom[_ngcontent-%COMP%]{padding:.4rem 0}.bs-tooltip-auto[x-placement^=bottom][_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-bottom[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]{top:0}.bs-tooltip-auto[x-placement^=bottom][_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before, .bs-tooltip-bottom[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[x-placement^=left][_ngcontent-%COMP%], .bs-tooltip-left[_ngcontent-%COMP%]{padding:0 .4rem}.bs-tooltip-auto[x-placement^=left][_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-left[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=left][_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before, .bs-tooltip-left[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner[_ngcontent-%COMP%]{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover[_ngcontent-%COMP%]{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}.popover[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:after, .popover[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[x-placement^=top][_ngcontent-%COMP%], .bs-popover-top[_ngcontent-%COMP%]{margin-bottom:.5rem}.bs-popover-auto[x-placement^=top][_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%], .bs-popover-top[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]{bottom:calc(-.5rem - 1px)}.bs-popover-auto[x-placement^=top][_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:before, .bs-popover-top[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:before{bottom:0;border-width:.5rem .5rem 0;border-top-color:#00000040}.bs-popover-auto[x-placement^=top][_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:after, .bs-popover-top[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[x-placement^=right][_ngcontent-%COMP%], .bs-popover-right[_ngcontent-%COMP%]{margin-left:.5rem}.bs-popover-auto[x-placement^=right][_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%], .bs-popover-right[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]{left:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=right][_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:before, .bs-popover-right[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:#00000040}.bs-popover-auto[x-placement^=right][_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:after, .bs-popover-right[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[x-placement^=bottom][_ngcontent-%COMP%], .bs-popover-bottom[_ngcontent-%COMP%]{margin-top:.5rem}.bs-popover-auto[x-placement^=bottom][_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%], .bs-popover-bottom[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]{top:calc(-.5rem - 1px)}.bs-popover-auto[x-placement^=bottom][_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:before, .bs-popover-bottom[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:before{top:0;border-width:0 .5rem .5rem .5rem;border-bottom-color:#00000040}.bs-popover-auto[x-placement^=bottom][_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:after, .bs-popover-bottom[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:after{top:1px;border-width:0 .5rem .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[x-placement^=bottom][_ngcontent-%COMP%]   .popover-header[_ngcontent-%COMP%]:before, .bs-popover-bottom[_ngcontent-%COMP%]   .popover-header[_ngcontent-%COMP%]:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.bs-popover-auto[x-placement^=left][_ngcontent-%COMP%], .bs-popover-left[_ngcontent-%COMP%]{margin-right:.5rem}.bs-popover-auto[x-placement^=left][_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%], .bs-popover-left[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]{right:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=left][_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:before, .bs-popover-left[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:#00000040}.bs-popover-auto[x-placement^=left][_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:after, .bs-popover-left[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header[_ngcontent-%COMP%]{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header[_ngcontent-%COMP%]:empty{display:none}.popover-body[_ngcontent-%COMP%]{padding:.5rem .75rem;color:#212529}.carousel[_ngcontent-%COMP%]{position:relative}.carousel.pointer-event[_ngcontent-%COMP%]{touch-action:pan-y}.carousel-inner[_ngcontent-%COMP%]{position:relative;width:100%;overflow:hidden}.carousel-inner[_ngcontent-%COMP%]:after{display:block;clear:both;content:\"\"}.carousel-item[_ngcontent-%COMP%]{position:relative;display:none;float:left;width:100%;margin-right:-100%;backface-visibility:hidden;transition:transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item[_ngcontent-%COMP%]{transition:none}}.carousel-item-next[_ngcontent-%COMP%], .carousel-item-prev[_ngcontent-%COMP%], .carousel-item.active[_ngcontent-%COMP%]{display:block}.active.carousel-item-right[_ngcontent-%COMP%], .carousel-item-next[_ngcontent-%COMP%]:not(.carousel-item-left){transform:translate(100%)}.active.carousel-item-left[_ngcontent-%COMP%], .carousel-item-prev[_ngcontent-%COMP%]:not(.carousel-item-right){transform:translate(-100%)}.carousel-fade[_ngcontent-%COMP%]   .carousel-item[_ngcontent-%COMP%]{opacity:0;transition-property:opacity;transform:none}.carousel-fade[_ngcontent-%COMP%]   .carousel-item-next.carousel-item-left[_ngcontent-%COMP%], .carousel-fade[_ngcontent-%COMP%]   .carousel-item-prev.carousel-item-right[_ngcontent-%COMP%], .carousel-fade[_ngcontent-%COMP%]   .carousel-item.active[_ngcontent-%COMP%]{z-index:1;opacity:1}.carousel-fade[_ngcontent-%COMP%]   .active.carousel-item-left[_ngcontent-%COMP%], .carousel-fade[_ngcontent-%COMP%]   .active.carousel-item-right[_ngcontent-%COMP%]{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade[_ngcontent-%COMP%]   .active.carousel-item-left[_ngcontent-%COMP%], .carousel-fade[_ngcontent-%COMP%]   .active.carousel-item-right[_ngcontent-%COMP%]{transition:none}}.carousel-control-next[_ngcontent-%COMP%], .carousel-control-prev[_ngcontent-%COMP%]{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next[_ngcontent-%COMP%], .carousel-control-prev[_ngcontent-%COMP%]{transition:none}}.carousel-control-next[_ngcontent-%COMP%]:focus, .carousel-control-next[_ngcontent-%COMP%]:hover, .carousel-control-prev[_ngcontent-%COMP%]:focus, .carousel-control-prev[_ngcontent-%COMP%]:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev[_ngcontent-%COMP%]{left:0}.carousel-control-next[_ngcontent-%COMP%]{right:0}.carousel-control-next-icon[_ngcontent-%COMP%], .carousel-control-prev-icon[_ngcontent-%COMP%]{display:inline-block;width:20px;height:20px;background:no-repeat 50%/100% 100%}.carousel-control-prev-icon[_ngcontent-%COMP%]{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\")}.carousel-control-next-icon[_ngcontent-%COMP%]{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\")}.carousel-indicators[_ngcontent-%COMP%]{position:absolute;right:0;bottom:0;left:0;z-index:15;display:flex;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.carousel-indicators[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{transition:none}}.carousel-indicators[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%]{opacity:1}.carousel-caption[_ngcontent-%COMP%]{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}@keyframes spinner-border{to{transform:rotate(360deg)}}.spinner-border[_ngcontent-%COMP%]{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;animation:spinner-border .75s linear infinite}.spinner-border-sm[_ngcontent-%COMP%]{width:1rem;height:1rem;border-width:.2em}@keyframes spinner-grow{0%{transform:scale(0)}50%{opacity:1}}.spinner-grow[_ngcontent-%COMP%]{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;background-color:currentColor;border-radius:50%;opacity:0;animation:spinner-grow .75s linear infinite}.spinner-grow-sm[_ngcontent-%COMP%]{width:1rem;height:1rem}.align-baseline[_ngcontent-%COMP%]{vertical-align:baseline!important}.align-top[_ngcontent-%COMP%]{vertical-align:top!important}.align-middle[_ngcontent-%COMP%]{vertical-align:middle!important}.align-bottom[_ngcontent-%COMP%]{vertical-align:bottom!important}.align-text-bottom[_ngcontent-%COMP%]{vertical-align:text-bottom!important}.align-text-top[_ngcontent-%COMP%]{vertical-align:text-top!important}.bg-primary[_ngcontent-%COMP%]{background-color:#007bff!important}a.bg-primary[_ngcontent-%COMP%]:focus, a.bg-primary[_ngcontent-%COMP%]:hover, button.bg-primary[_ngcontent-%COMP%]:focus, button.bg-primary[_ngcontent-%COMP%]:hover{background-color:#0062cc!important}.bg-secondary[_ngcontent-%COMP%]{background-color:#6c757d!important}a.bg-secondary[_ngcontent-%COMP%]:focus, a.bg-secondary[_ngcontent-%COMP%]:hover, button.bg-secondary[_ngcontent-%COMP%]:focus, button.bg-secondary[_ngcontent-%COMP%]:hover{background-color:#545b62!important}.bg-success[_ngcontent-%COMP%]{background-color:#28a745!important}a.bg-success[_ngcontent-%COMP%]:focus, a.bg-success[_ngcontent-%COMP%]:hover, button.bg-success[_ngcontent-%COMP%]:focus, button.bg-success[_ngcontent-%COMP%]:hover{background-color:#1e7e34!important}.bg-info[_ngcontent-%COMP%]{background-color:#17a2b8!important}a.bg-info[_ngcontent-%COMP%]:focus, a.bg-info[_ngcontent-%COMP%]:hover, button.bg-info[_ngcontent-%COMP%]:focus, button.bg-info[_ngcontent-%COMP%]:hover{background-color:#117a8b!important}.bg-warning[_ngcontent-%COMP%]{background-color:#ffc107!important}a.bg-warning[_ngcontent-%COMP%]:focus, a.bg-warning[_ngcontent-%COMP%]:hover, button.bg-warning[_ngcontent-%COMP%]:focus, button.bg-warning[_ngcontent-%COMP%]:hover{background-color:#d39e00!important}.bg-danger[_ngcontent-%COMP%]{background-color:#dc3545!important}a.bg-danger[_ngcontent-%COMP%]:focus, a.bg-danger[_ngcontent-%COMP%]:hover, button.bg-danger[_ngcontent-%COMP%]:focus, button.bg-danger[_ngcontent-%COMP%]:hover{background-color:#bd2130!important}.bg-light[_ngcontent-%COMP%]{background-color:#f8f9fa!important}a.bg-light[_ngcontent-%COMP%]:focus, a.bg-light[_ngcontent-%COMP%]:hover, button.bg-light[_ngcontent-%COMP%]:focus, button.bg-light[_ngcontent-%COMP%]:hover{background-color:#dae0e5!important}.bg-dark[_ngcontent-%COMP%]{background-color:#343a40!important}a.bg-dark[_ngcontent-%COMP%]:focus, a.bg-dark[_ngcontent-%COMP%]:hover, button.bg-dark[_ngcontent-%COMP%]:focus, button.bg-dark[_ngcontent-%COMP%]:hover{background-color:#1d2124!important}.bg-white[_ngcontent-%COMP%]{background-color:#fff!important}.bg-transparent[_ngcontent-%COMP%]{background-color:transparent!important}.border[_ngcontent-%COMP%]{border:1px solid #dee2e6!important}.border-top[_ngcontent-%COMP%]{border-top:1px solid #dee2e6!important}.border-right[_ngcontent-%COMP%]{border-right:1px solid #dee2e6!important}.border-bottom[_ngcontent-%COMP%]{border-bottom:1px solid #dee2e6!important}.border-left[_ngcontent-%COMP%]{border-left:1px solid #dee2e6!important}.border-0[_ngcontent-%COMP%]{border:0!important}.border-top-0[_ngcontent-%COMP%]{border-top:0!important}.border-right-0[_ngcontent-%COMP%]{border-right:0!important}.border-bottom-0[_ngcontent-%COMP%]{border-bottom:0!important}.border-left-0[_ngcontent-%COMP%]{border-left:0!important}.border-primary[_ngcontent-%COMP%]{border-color:#007bff!important}.border-secondary[_ngcontent-%COMP%]{border-color:#6c757d!important}.border-success[_ngcontent-%COMP%]{border-color:#28a745!important}.border-info[_ngcontent-%COMP%]{border-color:#17a2b8!important}.border-warning[_ngcontent-%COMP%]{border-color:#ffc107!important}.border-danger[_ngcontent-%COMP%]{border-color:#dc3545!important}.border-light[_ngcontent-%COMP%]{border-color:#f8f9fa!important}.border-dark[_ngcontent-%COMP%]{border-color:#343a40!important}.border-white[_ngcontent-%COMP%]{border-color:#fff!important}.rounded-sm[_ngcontent-%COMP%]{border-radius:.2rem!important}.rounded[_ngcontent-%COMP%]{border-radius:.25rem!important}.rounded-top[_ngcontent-%COMP%]{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-right[_ngcontent-%COMP%]{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom[_ngcontent-%COMP%]{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-left[_ngcontent-%COMP%]{border-top-left-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-lg[_ngcontent-%COMP%]{border-radius:.3rem!important}.rounded-circle[_ngcontent-%COMP%]{border-radius:50%!important}.rounded-pill[_ngcontent-%COMP%]{border-radius:50rem!important}.rounded-0[_ngcontent-%COMP%]{border-radius:0!important}.clearfix[_ngcontent-%COMP%]:after{display:block;clear:both;content:\"\"}.d-none[_ngcontent-%COMP%]{display:none!important}.d-inline[_ngcontent-%COMP%]{display:inline!important}.d-inline-block[_ngcontent-%COMP%]{display:inline-block!important}.d-block[_ngcontent-%COMP%]{display:block!important}.d-table[_ngcontent-%COMP%]{display:table!important}.d-table-row[_ngcontent-%COMP%]{display:table-row!important}.d-table-cell[_ngcontent-%COMP%]{display:table-cell!important}.d-flex[_ngcontent-%COMP%]{display:flex!important}.d-inline-flex[_ngcontent-%COMP%]{display:inline-flex!important}@media (min-width:576px){.d-sm-none[_ngcontent-%COMP%]{display:none!important}.d-sm-inline[_ngcontent-%COMP%]{display:inline!important}.d-sm-inline-block[_ngcontent-%COMP%]{display:inline-block!important}.d-sm-block[_ngcontent-%COMP%]{display:block!important}.d-sm-table[_ngcontent-%COMP%]{display:table!important}.d-sm-table-row[_ngcontent-%COMP%]{display:table-row!important}.d-sm-table-cell[_ngcontent-%COMP%]{display:table-cell!important}.d-sm-flex[_ngcontent-%COMP%]{display:flex!important}.d-sm-inline-flex[_ngcontent-%COMP%]{display:inline-flex!important}}@media (min-width:768px){.d-md-none[_ngcontent-%COMP%]{display:none!important}.d-md-inline[_ngcontent-%COMP%]{display:inline!important}.d-md-inline-block[_ngcontent-%COMP%]{display:inline-block!important}.d-md-block[_ngcontent-%COMP%]{display:block!important}.d-md-table[_ngcontent-%COMP%]{display:table!important}.d-md-table-row[_ngcontent-%COMP%]{display:table-row!important}.d-md-table-cell[_ngcontent-%COMP%]{display:table-cell!important}.d-md-flex[_ngcontent-%COMP%]{display:flex!important}.d-md-inline-flex[_ngcontent-%COMP%]{display:inline-flex!important}}@media (min-width:992px){.d-lg-none[_ngcontent-%COMP%]{display:none!important}.d-lg-inline[_ngcontent-%COMP%]{display:inline!important}.d-lg-inline-block[_ngcontent-%COMP%]{display:inline-block!important}.d-lg-block[_ngcontent-%COMP%]{display:block!important}.d-lg-table[_ngcontent-%COMP%]{display:table!important}.d-lg-table-row[_ngcontent-%COMP%]{display:table-row!important}.d-lg-table-cell[_ngcontent-%COMP%]{display:table-cell!important}.d-lg-flex[_ngcontent-%COMP%]{display:flex!important}.d-lg-inline-flex[_ngcontent-%COMP%]{display:inline-flex!important}}@media (min-width:1200px){.d-xl-none[_ngcontent-%COMP%]{display:none!important}.d-xl-inline[_ngcontent-%COMP%]{display:inline!important}.d-xl-inline-block[_ngcontent-%COMP%]{display:inline-block!important}.d-xl-block[_ngcontent-%COMP%]{display:block!important}.d-xl-table[_ngcontent-%COMP%]{display:table!important}.d-xl-table-row[_ngcontent-%COMP%]{display:table-row!important}.d-xl-table-cell[_ngcontent-%COMP%]{display:table-cell!important}.d-xl-flex[_ngcontent-%COMP%]{display:flex!important}.d-xl-inline-flex[_ngcontent-%COMP%]{display:inline-flex!important}}@media print{.d-print-none[_ngcontent-%COMP%]{display:none!important}.d-print-inline[_ngcontent-%COMP%]{display:inline!important}.d-print-inline-block[_ngcontent-%COMP%]{display:inline-block!important}.d-print-block[_ngcontent-%COMP%]{display:block!important}.d-print-table[_ngcontent-%COMP%]{display:table!important}.d-print-table-row[_ngcontent-%COMP%]{display:table-row!important}.d-print-table-cell[_ngcontent-%COMP%]{display:table-cell!important}.d-print-flex[_ngcontent-%COMP%]{display:flex!important}.d-print-inline-flex[_ngcontent-%COMP%]{display:inline-flex!important}}.embed-responsive[_ngcontent-%COMP%]{position:relative;display:block;width:100%;padding:0;overflow:hidden}.embed-responsive[_ngcontent-%COMP%]:before{display:block;content:\"\"}.embed-responsive[_ngcontent-%COMP%]   .embed-responsive-item[_ngcontent-%COMP%], .embed-responsive[_ngcontent-%COMP%]   embed[_ngcontent-%COMP%], .embed-responsive[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%], .embed-responsive[_ngcontent-%COMP%]   object[_ngcontent-%COMP%], .embed-responsive[_ngcontent-%COMP%]   video[_ngcontent-%COMP%]{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9[_ngcontent-%COMP%]:before{padding-top:42.857143%}.embed-responsive-16by9[_ngcontent-%COMP%]:before{padding-top:56.25%}.embed-responsive-4by3[_ngcontent-%COMP%]:before{padding-top:75%}.embed-responsive-1by1[_ngcontent-%COMP%]:before{padding-top:100%}.flex-row[_ngcontent-%COMP%]{flex-direction:row!important}.flex-column[_ngcontent-%COMP%]{flex-direction:column!important}.flex-row-reverse[_ngcontent-%COMP%]{flex-direction:row-reverse!important}.flex-column-reverse[_ngcontent-%COMP%]{flex-direction:column-reverse!important}.flex-wrap[_ngcontent-%COMP%]{flex-wrap:wrap!important}.flex-nowrap[_ngcontent-%COMP%]{flex-wrap:nowrap!important}.flex-wrap-reverse[_ngcontent-%COMP%]{flex-wrap:wrap-reverse!important}.flex-fill[_ngcontent-%COMP%]{flex:1 1 auto!important}.flex-grow-0[_ngcontent-%COMP%]{flex-grow:0!important}.flex-grow-1[_ngcontent-%COMP%]{flex-grow:1!important}.flex-shrink-0[_ngcontent-%COMP%]{flex-shrink:0!important}.flex-shrink-1[_ngcontent-%COMP%]{flex-shrink:1!important}.justify-content-start[_ngcontent-%COMP%]{justify-content:flex-start!important}.justify-content-end[_ngcontent-%COMP%]{justify-content:flex-end!important}.justify-content-center[_ngcontent-%COMP%]{justify-content:center!important}.justify-content-between[_ngcontent-%COMP%]{justify-content:space-between!important}.justify-content-around[_ngcontent-%COMP%]{justify-content:space-around!important}.align-items-start[_ngcontent-%COMP%]{align-items:flex-start!important}.align-items-end[_ngcontent-%COMP%]{align-items:flex-end!important}.align-items-center[_ngcontent-%COMP%]{align-items:center!important}.align-items-baseline[_ngcontent-%COMP%]{align-items:baseline!important}.align-items-stretch[_ngcontent-%COMP%]{align-items:stretch!important}.align-content-start[_ngcontent-%COMP%]{align-content:flex-start!important}.align-content-end[_ngcontent-%COMP%]{align-content:flex-end!important}.align-content-center[_ngcontent-%COMP%]{align-content:center!important}.align-content-between[_ngcontent-%COMP%]{align-content:space-between!important}.align-content-around[_ngcontent-%COMP%]{align-content:space-around!important}.align-content-stretch[_ngcontent-%COMP%]{align-content:stretch!important}.align-self-auto[_ngcontent-%COMP%]{align-self:auto!important}.align-self-start[_ngcontent-%COMP%]{align-self:flex-start!important}.align-self-end[_ngcontent-%COMP%]{align-self:flex-end!important}.align-self-center[_ngcontent-%COMP%]{align-self:center!important}.align-self-baseline[_ngcontent-%COMP%]{align-self:baseline!important}.align-self-stretch[_ngcontent-%COMP%]{align-self:stretch!important}@media (min-width:576px){.flex-sm-row[_ngcontent-%COMP%]{flex-direction:row!important}.flex-sm-column[_ngcontent-%COMP%]{flex-direction:column!important}.flex-sm-row-reverse[_ngcontent-%COMP%]{flex-direction:row-reverse!important}.flex-sm-column-reverse[_ngcontent-%COMP%]{flex-direction:column-reverse!important}.flex-sm-wrap[_ngcontent-%COMP%]{flex-wrap:wrap!important}.flex-sm-nowrap[_ngcontent-%COMP%]{flex-wrap:nowrap!important}.flex-sm-wrap-reverse[_ngcontent-%COMP%]{flex-wrap:wrap-reverse!important}.flex-sm-fill[_ngcontent-%COMP%]{flex:1 1 auto!important}.flex-sm-grow-0[_ngcontent-%COMP%]{flex-grow:0!important}.flex-sm-grow-1[_ngcontent-%COMP%]{flex-grow:1!important}.flex-sm-shrink-0[_ngcontent-%COMP%]{flex-shrink:0!important}.flex-sm-shrink-1[_ngcontent-%COMP%]{flex-shrink:1!important}.justify-content-sm-start[_ngcontent-%COMP%]{justify-content:flex-start!important}.justify-content-sm-end[_ngcontent-%COMP%]{justify-content:flex-end!important}.justify-content-sm-center[_ngcontent-%COMP%]{justify-content:center!important}.justify-content-sm-between[_ngcontent-%COMP%]{justify-content:space-between!important}.justify-content-sm-around[_ngcontent-%COMP%]{justify-content:space-around!important}.align-items-sm-start[_ngcontent-%COMP%]{align-items:flex-start!important}.align-items-sm-end[_ngcontent-%COMP%]{align-items:flex-end!important}.align-items-sm-center[_ngcontent-%COMP%]{align-items:center!important}.align-items-sm-baseline[_ngcontent-%COMP%]{align-items:baseline!important}.align-items-sm-stretch[_ngcontent-%COMP%]{align-items:stretch!important}.align-content-sm-start[_ngcontent-%COMP%]{align-content:flex-start!important}.align-content-sm-end[_ngcontent-%COMP%]{align-content:flex-end!important}.align-content-sm-center[_ngcontent-%COMP%]{align-content:center!important}.align-content-sm-between[_ngcontent-%COMP%]{align-content:space-between!important}.align-content-sm-around[_ngcontent-%COMP%]{align-content:space-around!important}.align-content-sm-stretch[_ngcontent-%COMP%]{align-content:stretch!important}.align-self-sm-auto[_ngcontent-%COMP%]{align-self:auto!important}.align-self-sm-start[_ngcontent-%COMP%]{align-self:flex-start!important}.align-self-sm-end[_ngcontent-%COMP%]{align-self:flex-end!important}.align-self-sm-center[_ngcontent-%COMP%]{align-self:center!important}.align-self-sm-baseline[_ngcontent-%COMP%]{align-self:baseline!important}.align-self-sm-stretch[_ngcontent-%COMP%]{align-self:stretch!important}}@media (min-width:768px){.flex-md-row[_ngcontent-%COMP%]{flex-direction:row!important}.flex-md-column[_ngcontent-%COMP%]{flex-direction:column!important}.flex-md-row-reverse[_ngcontent-%COMP%]{flex-direction:row-reverse!important}.flex-md-column-reverse[_ngcontent-%COMP%]{flex-direction:column-reverse!important}.flex-md-wrap[_ngcontent-%COMP%]{flex-wrap:wrap!important}.flex-md-nowrap[_ngcontent-%COMP%]{flex-wrap:nowrap!important}.flex-md-wrap-reverse[_ngcontent-%COMP%]{flex-wrap:wrap-reverse!important}.flex-md-fill[_ngcontent-%COMP%]{flex:1 1 auto!important}.flex-md-grow-0[_ngcontent-%COMP%]{flex-grow:0!important}.flex-md-grow-1[_ngcontent-%COMP%]{flex-grow:1!important}.flex-md-shrink-0[_ngcontent-%COMP%]{flex-shrink:0!important}.flex-md-shrink-1[_ngcontent-%COMP%]{flex-shrink:1!important}.justify-content-md-start[_ngcontent-%COMP%]{justify-content:flex-start!important}.justify-content-md-end[_ngcontent-%COMP%]{justify-content:flex-end!important}.justify-content-md-center[_ngcontent-%COMP%]{justify-content:center!important}.justify-content-md-between[_ngcontent-%COMP%]{justify-content:space-between!important}.justify-content-md-around[_ngcontent-%COMP%]{justify-content:space-around!important}.align-items-md-start[_ngcontent-%COMP%]{align-items:flex-start!important}.align-items-md-end[_ngcontent-%COMP%]{align-items:flex-end!important}.align-items-md-center[_ngcontent-%COMP%]{align-items:center!important}.align-items-md-baseline[_ngcontent-%COMP%]{align-items:baseline!important}.align-items-md-stretch[_ngcontent-%COMP%]{align-items:stretch!important}.align-content-md-start[_ngcontent-%COMP%]{align-content:flex-start!important}.align-content-md-end[_ngcontent-%COMP%]{align-content:flex-end!important}.align-content-md-center[_ngcontent-%COMP%]{align-content:center!important}.align-content-md-between[_ngcontent-%COMP%]{align-content:space-between!important}.align-content-md-around[_ngcontent-%COMP%]{align-content:space-around!important}.align-content-md-stretch[_ngcontent-%COMP%]{align-content:stretch!important}.align-self-md-auto[_ngcontent-%COMP%]{align-self:auto!important}.align-self-md-start[_ngcontent-%COMP%]{align-self:flex-start!important}.align-self-md-end[_ngcontent-%COMP%]{align-self:flex-end!important}.align-self-md-center[_ngcontent-%COMP%]{align-self:center!important}.align-self-md-baseline[_ngcontent-%COMP%]{align-self:baseline!important}.align-self-md-stretch[_ngcontent-%COMP%]{align-self:stretch!important}}@media (min-width:992px){.flex-lg-row[_ngcontent-%COMP%]{flex-direction:row!important}.flex-lg-column[_ngcontent-%COMP%]{flex-direction:column!important}.flex-lg-row-reverse[_ngcontent-%COMP%]{flex-direction:row-reverse!important}.flex-lg-column-reverse[_ngcontent-%COMP%]{flex-direction:column-reverse!important}.flex-lg-wrap[_ngcontent-%COMP%]{flex-wrap:wrap!important}.flex-lg-nowrap[_ngcontent-%COMP%]{flex-wrap:nowrap!important}.flex-lg-wrap-reverse[_ngcontent-%COMP%]{flex-wrap:wrap-reverse!important}.flex-lg-fill[_ngcontent-%COMP%]{flex:1 1 auto!important}.flex-lg-grow-0[_ngcontent-%COMP%]{flex-grow:0!important}.flex-lg-grow-1[_ngcontent-%COMP%]{flex-grow:1!important}.flex-lg-shrink-0[_ngcontent-%COMP%]{flex-shrink:0!important}.flex-lg-shrink-1[_ngcontent-%COMP%]{flex-shrink:1!important}.justify-content-lg-start[_ngcontent-%COMP%]{justify-content:flex-start!important}.justify-content-lg-end[_ngcontent-%COMP%]{justify-content:flex-end!important}.justify-content-lg-center[_ngcontent-%COMP%]{justify-content:center!important}.justify-content-lg-between[_ngcontent-%COMP%]{justify-content:space-between!important}.justify-content-lg-around[_ngcontent-%COMP%]{justify-content:space-around!important}.align-items-lg-start[_ngcontent-%COMP%]{align-items:flex-start!important}.align-items-lg-end[_ngcontent-%COMP%]{align-items:flex-end!important}.align-items-lg-center[_ngcontent-%COMP%]{align-items:center!important}.align-items-lg-baseline[_ngcontent-%COMP%]{align-items:baseline!important}.align-items-lg-stretch[_ngcontent-%COMP%]{align-items:stretch!important}.align-content-lg-start[_ngcontent-%COMP%]{align-content:flex-start!important}.align-content-lg-end[_ngcontent-%COMP%]{align-content:flex-end!important}.align-content-lg-center[_ngcontent-%COMP%]{align-content:center!important}.align-content-lg-between[_ngcontent-%COMP%]{align-content:space-between!important}.align-content-lg-around[_ngcontent-%COMP%]{align-content:space-around!important}.align-content-lg-stretch[_ngcontent-%COMP%]{align-content:stretch!important}.align-self-lg-auto[_ngcontent-%COMP%]{align-self:auto!important}.align-self-lg-start[_ngcontent-%COMP%]{align-self:flex-start!important}.align-self-lg-end[_ngcontent-%COMP%]{align-self:flex-end!important}.align-self-lg-center[_ngcontent-%COMP%]{align-self:center!important}.align-self-lg-baseline[_ngcontent-%COMP%]{align-self:baseline!important}.align-self-lg-stretch[_ngcontent-%COMP%]{align-self:stretch!important}}@media (min-width:1200px){.flex-xl-row[_ngcontent-%COMP%]{flex-direction:row!important}.flex-xl-column[_ngcontent-%COMP%]{flex-direction:column!important}.flex-xl-row-reverse[_ngcontent-%COMP%]{flex-direction:row-reverse!important}.flex-xl-column-reverse[_ngcontent-%COMP%]{flex-direction:column-reverse!important}.flex-xl-wrap[_ngcontent-%COMP%]{flex-wrap:wrap!important}.flex-xl-nowrap[_ngcontent-%COMP%]{flex-wrap:nowrap!important}.flex-xl-wrap-reverse[_ngcontent-%COMP%]{flex-wrap:wrap-reverse!important}.flex-xl-fill[_ngcontent-%COMP%]{flex:1 1 auto!important}.flex-xl-grow-0[_ngcontent-%COMP%]{flex-grow:0!important}.flex-xl-grow-1[_ngcontent-%COMP%]{flex-grow:1!important}.flex-xl-shrink-0[_ngcontent-%COMP%]{flex-shrink:0!important}.flex-xl-shrink-1[_ngcontent-%COMP%]{flex-shrink:1!important}.justify-content-xl-start[_ngcontent-%COMP%]{justify-content:flex-start!important}.justify-content-xl-end[_ngcontent-%COMP%]{justify-content:flex-end!important}.justify-content-xl-center[_ngcontent-%COMP%]{justify-content:center!important}.justify-content-xl-between[_ngcontent-%COMP%]{justify-content:space-between!important}.justify-content-xl-around[_ngcontent-%COMP%]{justify-content:space-around!important}.align-items-xl-start[_ngcontent-%COMP%]{align-items:flex-start!important}.align-items-xl-end[_ngcontent-%COMP%]{align-items:flex-end!important}.align-items-xl-center[_ngcontent-%COMP%]{align-items:center!important}.align-items-xl-baseline[_ngcontent-%COMP%]{align-items:baseline!important}.align-items-xl-stretch[_ngcontent-%COMP%]{align-items:stretch!important}.align-content-xl-start[_ngcontent-%COMP%]{align-content:flex-start!important}.align-content-xl-end[_ngcontent-%COMP%]{align-content:flex-end!important}.align-content-xl-center[_ngcontent-%COMP%]{align-content:center!important}.align-content-xl-between[_ngcontent-%COMP%]{align-content:space-between!important}.align-content-xl-around[_ngcontent-%COMP%]{align-content:space-around!important}.align-content-xl-stretch[_ngcontent-%COMP%]{align-content:stretch!important}.align-self-xl-auto[_ngcontent-%COMP%]{align-self:auto!important}.align-self-xl-start[_ngcontent-%COMP%]{align-self:flex-start!important}.align-self-xl-end[_ngcontent-%COMP%]{align-self:flex-end!important}.align-self-xl-center[_ngcontent-%COMP%]{align-self:center!important}.align-self-xl-baseline[_ngcontent-%COMP%]{align-self:baseline!important}.align-self-xl-stretch[_ngcontent-%COMP%]{align-self:stretch!important}}.float-left[_ngcontent-%COMP%]{float:left!important}.float-right[_ngcontent-%COMP%]{float:right!important}.float-none[_ngcontent-%COMP%]{float:none!important}@media (min-width:576px){.float-sm-left[_ngcontent-%COMP%]{float:left!important}.float-sm-right[_ngcontent-%COMP%]{float:right!important}.float-sm-none[_ngcontent-%COMP%]{float:none!important}}@media (min-width:768px){.float-md-left[_ngcontent-%COMP%]{float:left!important}.float-md-right[_ngcontent-%COMP%]{float:right!important}.float-md-none[_ngcontent-%COMP%]{float:none!important}}@media (min-width:992px){.float-lg-left[_ngcontent-%COMP%]{float:left!important}.float-lg-right[_ngcontent-%COMP%]{float:right!important}.float-lg-none[_ngcontent-%COMP%]{float:none!important}}@media (min-width:1200px){.float-xl-left[_ngcontent-%COMP%]{float:left!important}.float-xl-right[_ngcontent-%COMP%]{float:right!important}.float-xl-none[_ngcontent-%COMP%]{float:none!important}}.overflow-auto[_ngcontent-%COMP%]{overflow:auto!important}.overflow-hidden[_ngcontent-%COMP%]{overflow:hidden!important}.position-static[_ngcontent-%COMP%]{position:static!important}.position-relative[_ngcontent-%COMP%]{position:relative!important}.position-absolute[_ngcontent-%COMP%]{position:absolute!important}.position-fixed[_ngcontent-%COMP%]{position:fixed!important}.position-sticky[_ngcontent-%COMP%]{position:sticky!important}.fixed-top[_ngcontent-%COMP%]{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom[_ngcontent-%COMP%]{position:fixed;right:0;bottom:0;left:0;z-index:1030}@supports (position:sticky){.sticky-top[_ngcontent-%COMP%]{position:sticky;top:0;z-index:1020}}.sr-only[_ngcontent-%COMP%]{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.sr-only-focusable[_ngcontent-%COMP%]:active, .sr-only-focusable[_ngcontent-%COMP%]:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal}.shadow-sm[_ngcontent-%COMP%]{box-shadow:0 .125rem .25rem #00000013!important}.shadow[_ngcontent-%COMP%]{box-shadow:0 .5rem 1rem #00000026!important}.shadow-lg[_ngcontent-%COMP%]{box-shadow:0 1rem 3rem #0000002d!important}.shadow-none[_ngcontent-%COMP%]{box-shadow:none!important}.w-25[_ngcontent-%COMP%]{width:25%!important}.w-50[_ngcontent-%COMP%]{width:50%!important}.w-75[_ngcontent-%COMP%]{width:75%!important}.w-100[_ngcontent-%COMP%]{width:100%!important}.w-auto[_ngcontent-%COMP%]{width:auto!important}.h-25[_ngcontent-%COMP%]{height:25%!important}.h-50[_ngcontent-%COMP%]{height:50%!important}.h-75[_ngcontent-%COMP%]{height:75%!important}.h-100[_ngcontent-%COMP%]{height:100%!important}.h-auto[_ngcontent-%COMP%]{height:auto!important}.mw-100[_ngcontent-%COMP%]{max-width:100%!important}.mh-100[_ngcontent-%COMP%]{max-height:100%!important}.min-vw-100[_ngcontent-%COMP%]{min-width:100vw!important}.min-vh-100[_ngcontent-%COMP%]{min-height:100vh!important}.vw-100[_ngcontent-%COMP%]{width:100vw!important}.vh-100[_ngcontent-%COMP%]{height:100vh!important}.stretched-link[_ngcontent-%COMP%]:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;pointer-events:auto;content:\"\";background-color:#0000}.m-0[_ngcontent-%COMP%]{margin:0!important}.mt-0[_ngcontent-%COMP%], .my-0[_ngcontent-%COMP%]{margin-top:0!important}.mr-0[_ngcontent-%COMP%], .mx-0[_ngcontent-%COMP%]{margin-right:0!important}.mb-0[_ngcontent-%COMP%], .my-0[_ngcontent-%COMP%]{margin-bottom:0!important}.ml-0[_ngcontent-%COMP%], .mx-0[_ngcontent-%COMP%]{margin-left:0!important}.m-1[_ngcontent-%COMP%]{margin:.25rem!important}.mt-1[_ngcontent-%COMP%], .my-1[_ngcontent-%COMP%]{margin-top:.25rem!important}.mr-1[_ngcontent-%COMP%], .mx-1[_ngcontent-%COMP%]{margin-right:.25rem!important}.mb-1[_ngcontent-%COMP%], .my-1[_ngcontent-%COMP%]{margin-bottom:.25rem!important}.ml-1[_ngcontent-%COMP%], .mx-1[_ngcontent-%COMP%]{margin-left:.25rem!important}.m-2[_ngcontent-%COMP%]{margin:.5rem!important}.mt-2[_ngcontent-%COMP%], .my-2[_ngcontent-%COMP%]{margin-top:.5rem!important}.mr-2[_ngcontent-%COMP%], .mx-2[_ngcontent-%COMP%]{margin-right:.5rem!important}.mb-2[_ngcontent-%COMP%], .my-2[_ngcontent-%COMP%]{margin-bottom:.5rem!important}.ml-2[_ngcontent-%COMP%], .mx-2[_ngcontent-%COMP%]{margin-left:.5rem!important}.m-3[_ngcontent-%COMP%]{margin:1rem!important}.mt-3[_ngcontent-%COMP%], .my-3[_ngcontent-%COMP%]{margin-top:1rem!important}.mr-3[_ngcontent-%COMP%], .mx-3[_ngcontent-%COMP%]{margin-right:1rem!important}.mb-3[_ngcontent-%COMP%], .my-3[_ngcontent-%COMP%]{margin-bottom:1rem!important}.ml-3[_ngcontent-%COMP%], .mx-3[_ngcontent-%COMP%]{margin-left:1rem!important}.m-4[_ngcontent-%COMP%]{margin:1.5rem!important}.mt-4[_ngcontent-%COMP%], .my-4[_ngcontent-%COMP%]{margin-top:1.5rem!important}.mr-4[_ngcontent-%COMP%], .mx-4[_ngcontent-%COMP%]{margin-right:1.5rem!important}.mb-4[_ngcontent-%COMP%], .my-4[_ngcontent-%COMP%]{margin-bottom:1.5rem!important}.ml-4[_ngcontent-%COMP%], .mx-4[_ngcontent-%COMP%]{margin-left:1.5rem!important}.m-5[_ngcontent-%COMP%]{margin:3rem!important}.mt-5[_ngcontent-%COMP%], .my-5[_ngcontent-%COMP%]{margin-top:3rem!important}.mr-5[_ngcontent-%COMP%], .mx-5[_ngcontent-%COMP%]{margin-right:3rem!important}.mb-5[_ngcontent-%COMP%], .my-5[_ngcontent-%COMP%]{margin-bottom:3rem!important}.ml-5[_ngcontent-%COMP%], .mx-5[_ngcontent-%COMP%]{margin-left:3rem!important}.p-0[_ngcontent-%COMP%]{padding:0!important}.pt-0[_ngcontent-%COMP%], .py-0[_ngcontent-%COMP%]{padding-top:0!important}.pr-0[_ngcontent-%COMP%], .px-0[_ngcontent-%COMP%]{padding-right:0!important}.pb-0[_ngcontent-%COMP%], .py-0[_ngcontent-%COMP%]{padding-bottom:0!important}.pl-0[_ngcontent-%COMP%], .px-0[_ngcontent-%COMP%]{padding-left:0!important}.p-1[_ngcontent-%COMP%]{padding:.25rem!important}.pt-1[_ngcontent-%COMP%], .py-1[_ngcontent-%COMP%]{padding-top:.25rem!important}.pr-1[_ngcontent-%COMP%], .px-1[_ngcontent-%COMP%]{padding-right:.25rem!important}.pb-1[_ngcontent-%COMP%], .py-1[_ngcontent-%COMP%]{padding-bottom:.25rem!important}.pl-1[_ngcontent-%COMP%], .px-1[_ngcontent-%COMP%]{padding-left:.25rem!important}.p-2[_ngcontent-%COMP%]{padding:.5rem!important}.pt-2[_ngcontent-%COMP%], .py-2[_ngcontent-%COMP%]{padding-top:.5rem!important}.pr-2[_ngcontent-%COMP%], .px-2[_ngcontent-%COMP%]{padding-right:.5rem!important}.pb-2[_ngcontent-%COMP%], .py-2[_ngcontent-%COMP%]{padding-bottom:.5rem!important}.pl-2[_ngcontent-%COMP%], .px-2[_ngcontent-%COMP%]{padding-left:.5rem!important}.p-3[_ngcontent-%COMP%]{padding:1rem!important}.pt-3[_ngcontent-%COMP%], .py-3[_ngcontent-%COMP%]{padding-top:1rem!important}.pr-3[_ngcontent-%COMP%], .px-3[_ngcontent-%COMP%]{padding-right:1rem!important}.pb-3[_ngcontent-%COMP%], .py-3[_ngcontent-%COMP%]{padding-bottom:1rem!important}.pl-3[_ngcontent-%COMP%], .px-3[_ngcontent-%COMP%]{padding-left:1rem!important}.p-4[_ngcontent-%COMP%]{padding:1.5rem!important}.pt-4[_ngcontent-%COMP%], .py-4[_ngcontent-%COMP%]{padding-top:1.5rem!important}.pr-4[_ngcontent-%COMP%], .px-4[_ngcontent-%COMP%]{padding-right:1.5rem!important}.pb-4[_ngcontent-%COMP%], .py-4[_ngcontent-%COMP%]{padding-bottom:1.5rem!important}.pl-4[_ngcontent-%COMP%], .px-4[_ngcontent-%COMP%]{padding-left:1.5rem!important}.p-5[_ngcontent-%COMP%]{padding:3rem!important}.pt-5[_ngcontent-%COMP%], .py-5[_ngcontent-%COMP%]{padding-top:3rem!important}.pr-5[_ngcontent-%COMP%], .px-5[_ngcontent-%COMP%]{padding-right:3rem!important}.pb-5[_ngcontent-%COMP%], .py-5[_ngcontent-%COMP%]{padding-bottom:3rem!important}.pl-5[_ngcontent-%COMP%], .px-5[_ngcontent-%COMP%]{padding-left:3rem!important}.m-n1[_ngcontent-%COMP%]{margin:-.25rem!important}.mt-n1[_ngcontent-%COMP%], .my-n1[_ngcontent-%COMP%]{margin-top:-.25rem!important}.mr-n1[_ngcontent-%COMP%], .mx-n1[_ngcontent-%COMP%]{margin-right:-.25rem!important}.mb-n1[_ngcontent-%COMP%], .my-n1[_ngcontent-%COMP%]{margin-bottom:-.25rem!important}.ml-n1[_ngcontent-%COMP%], .mx-n1[_ngcontent-%COMP%]{margin-left:-.25rem!important}.m-n2[_ngcontent-%COMP%]{margin:-.5rem!important}.mt-n2[_ngcontent-%COMP%], .my-n2[_ngcontent-%COMP%]{margin-top:-.5rem!important}.mr-n2[_ngcontent-%COMP%], .mx-n2[_ngcontent-%COMP%]{margin-right:-.5rem!important}.mb-n2[_ngcontent-%COMP%], .my-n2[_ngcontent-%COMP%]{margin-bottom:-.5rem!important}.ml-n2[_ngcontent-%COMP%], .mx-n2[_ngcontent-%COMP%]{margin-left:-.5rem!important}.m-n3[_ngcontent-%COMP%]{margin:-1rem!important}.mt-n3[_ngcontent-%COMP%], .my-n3[_ngcontent-%COMP%]{margin-top:-1rem!important}.mr-n3[_ngcontent-%COMP%], .mx-n3[_ngcontent-%COMP%]{margin-right:-1rem!important}.mb-n3[_ngcontent-%COMP%], .my-n3[_ngcontent-%COMP%]{margin-bottom:-1rem!important}.ml-n3[_ngcontent-%COMP%], .mx-n3[_ngcontent-%COMP%]{margin-left:-1rem!important}.m-n4[_ngcontent-%COMP%]{margin:-1.5rem!important}.mt-n4[_ngcontent-%COMP%], .my-n4[_ngcontent-%COMP%]{margin-top:-1.5rem!important}.mr-n4[_ngcontent-%COMP%], .mx-n4[_ngcontent-%COMP%]{margin-right:-1.5rem!important}.mb-n4[_ngcontent-%COMP%], .my-n4[_ngcontent-%COMP%]{margin-bottom:-1.5rem!important}.ml-n4[_ngcontent-%COMP%], .mx-n4[_ngcontent-%COMP%]{margin-left:-1.5rem!important}.m-n5[_ngcontent-%COMP%]{margin:-3rem!important}.mt-n5[_ngcontent-%COMP%], .my-n5[_ngcontent-%COMP%]{margin-top:-3rem!important}.mr-n5[_ngcontent-%COMP%], .mx-n5[_ngcontent-%COMP%]{margin-right:-3rem!important}.mb-n5[_ngcontent-%COMP%], .my-n5[_ngcontent-%COMP%]{margin-bottom:-3rem!important}.ml-n5[_ngcontent-%COMP%], .mx-n5[_ngcontent-%COMP%]{margin-left:-3rem!important}.m-auto[_ngcontent-%COMP%]{margin:auto!important}.mt-auto[_ngcontent-%COMP%], .my-auto[_ngcontent-%COMP%]{margin-top:auto!important}.mr-auto[_ngcontent-%COMP%], .mx-auto[_ngcontent-%COMP%]{margin-right:auto!important}.mb-auto[_ngcontent-%COMP%], .my-auto[_ngcontent-%COMP%]{margin-bottom:auto!important}.ml-auto[_ngcontent-%COMP%], .mx-auto[_ngcontent-%COMP%]{margin-left:auto!important}@media (min-width:576px){.m-sm-0[_ngcontent-%COMP%]{margin:0!important}.mt-sm-0[_ngcontent-%COMP%], .my-sm-0[_ngcontent-%COMP%]{margin-top:0!important}.mr-sm-0[_ngcontent-%COMP%], .mx-sm-0[_ngcontent-%COMP%]{margin-right:0!important}.mb-sm-0[_ngcontent-%COMP%], .my-sm-0[_ngcontent-%COMP%]{margin-bottom:0!important}.ml-sm-0[_ngcontent-%COMP%], .mx-sm-0[_ngcontent-%COMP%]{margin-left:0!important}.m-sm-1[_ngcontent-%COMP%]{margin:.25rem!important}.mt-sm-1[_ngcontent-%COMP%], .my-sm-1[_ngcontent-%COMP%]{margin-top:.25rem!important}.mr-sm-1[_ngcontent-%COMP%], .mx-sm-1[_ngcontent-%COMP%]{margin-right:.25rem!important}.mb-sm-1[_ngcontent-%COMP%], .my-sm-1[_ngcontent-%COMP%]{margin-bottom:.25rem!important}.ml-sm-1[_ngcontent-%COMP%], .mx-sm-1[_ngcontent-%COMP%]{margin-left:.25rem!important}.m-sm-2[_ngcontent-%COMP%]{margin:.5rem!important}.mt-sm-2[_ngcontent-%COMP%], .my-sm-2[_ngcontent-%COMP%]{margin-top:.5rem!important}.mr-sm-2[_ngcontent-%COMP%], .mx-sm-2[_ngcontent-%COMP%]{margin-right:.5rem!important}.mb-sm-2[_ngcontent-%COMP%], .my-sm-2[_ngcontent-%COMP%]{margin-bottom:.5rem!important}.ml-sm-2[_ngcontent-%COMP%], .mx-sm-2[_ngcontent-%COMP%]{margin-left:.5rem!important}.m-sm-3[_ngcontent-%COMP%]{margin:1rem!important}.mt-sm-3[_ngcontent-%COMP%], .my-sm-3[_ngcontent-%COMP%]{margin-top:1rem!important}.mr-sm-3[_ngcontent-%COMP%], .mx-sm-3[_ngcontent-%COMP%]{margin-right:1rem!important}.mb-sm-3[_ngcontent-%COMP%], .my-sm-3[_ngcontent-%COMP%]{margin-bottom:1rem!important}.ml-sm-3[_ngcontent-%COMP%], .mx-sm-3[_ngcontent-%COMP%]{margin-left:1rem!important}.m-sm-4[_ngcontent-%COMP%]{margin:1.5rem!important}.mt-sm-4[_ngcontent-%COMP%], .my-sm-4[_ngcontent-%COMP%]{margin-top:1.5rem!important}.mr-sm-4[_ngcontent-%COMP%], .mx-sm-4[_ngcontent-%COMP%]{margin-right:1.5rem!important}.mb-sm-4[_ngcontent-%COMP%], .my-sm-4[_ngcontent-%COMP%]{margin-bottom:1.5rem!important}.ml-sm-4[_ngcontent-%COMP%], .mx-sm-4[_ngcontent-%COMP%]{margin-left:1.5rem!important}.m-sm-5[_ngcontent-%COMP%]{margin:3rem!important}.mt-sm-5[_ngcontent-%COMP%], .my-sm-5[_ngcontent-%COMP%]{margin-top:3rem!important}.mr-sm-5[_ngcontent-%COMP%], .mx-sm-5[_ngcontent-%COMP%]{margin-right:3rem!important}.mb-sm-5[_ngcontent-%COMP%], .my-sm-5[_ngcontent-%COMP%]{margin-bottom:3rem!important}.ml-sm-5[_ngcontent-%COMP%], .mx-sm-5[_ngcontent-%COMP%]{margin-left:3rem!important}.p-sm-0[_ngcontent-%COMP%]{padding:0!important}.pt-sm-0[_ngcontent-%COMP%], .py-sm-0[_ngcontent-%COMP%]{padding-top:0!important}.pr-sm-0[_ngcontent-%COMP%], .px-sm-0[_ngcontent-%COMP%]{padding-right:0!important}.pb-sm-0[_ngcontent-%COMP%], .py-sm-0[_ngcontent-%COMP%]{padding-bottom:0!important}.pl-sm-0[_ngcontent-%COMP%], .px-sm-0[_ngcontent-%COMP%]{padding-left:0!important}.p-sm-1[_ngcontent-%COMP%]{padding:.25rem!important}.pt-sm-1[_ngcontent-%COMP%], .py-sm-1[_ngcontent-%COMP%]{padding-top:.25rem!important}.pr-sm-1[_ngcontent-%COMP%], .px-sm-1[_ngcontent-%COMP%]{padding-right:.25rem!important}.pb-sm-1[_ngcontent-%COMP%], .py-sm-1[_ngcontent-%COMP%]{padding-bottom:.25rem!important}.pl-sm-1[_ngcontent-%COMP%], .px-sm-1[_ngcontent-%COMP%]{padding-left:.25rem!important}.p-sm-2[_ngcontent-%COMP%]{padding:.5rem!important}.pt-sm-2[_ngcontent-%COMP%], .py-sm-2[_ngcontent-%COMP%]{padding-top:.5rem!important}.pr-sm-2[_ngcontent-%COMP%], .px-sm-2[_ngcontent-%COMP%]{padding-right:.5rem!important}.pb-sm-2[_ngcontent-%COMP%], .py-sm-2[_ngcontent-%COMP%]{padding-bottom:.5rem!important}.pl-sm-2[_ngcontent-%COMP%], .px-sm-2[_ngcontent-%COMP%]{padding-left:.5rem!important}.p-sm-3[_ngcontent-%COMP%]{padding:1rem!important}.pt-sm-3[_ngcontent-%COMP%], .py-sm-3[_ngcontent-%COMP%]{padding-top:1rem!important}.pr-sm-3[_ngcontent-%COMP%], .px-sm-3[_ngcontent-%COMP%]{padding-right:1rem!important}.pb-sm-3[_ngcontent-%COMP%], .py-sm-3[_ngcontent-%COMP%]{padding-bottom:1rem!important}.pl-sm-3[_ngcontent-%COMP%], .px-sm-3[_ngcontent-%COMP%]{padding-left:1rem!important}.p-sm-4[_ngcontent-%COMP%]{padding:1.5rem!important}.pt-sm-4[_ngcontent-%COMP%], .py-sm-4[_ngcontent-%COMP%]{padding-top:1.5rem!important}.pr-sm-4[_ngcontent-%COMP%], .px-sm-4[_ngcontent-%COMP%]{padding-right:1.5rem!important}.pb-sm-4[_ngcontent-%COMP%], .py-sm-4[_ngcontent-%COMP%]{padding-bottom:1.5rem!important}.pl-sm-4[_ngcontent-%COMP%], .px-sm-4[_ngcontent-%COMP%]{padding-left:1.5rem!important}.p-sm-5[_ngcontent-%COMP%]{padding:3rem!important}.pt-sm-5[_ngcontent-%COMP%], .py-sm-5[_ngcontent-%COMP%]{padding-top:3rem!important}.pr-sm-5[_ngcontent-%COMP%], .px-sm-5[_ngcontent-%COMP%]{padding-right:3rem!important}.pb-sm-5[_ngcontent-%COMP%], .py-sm-5[_ngcontent-%COMP%]{padding-bottom:3rem!important}.pl-sm-5[_ngcontent-%COMP%], .px-sm-5[_ngcontent-%COMP%]{padding-left:3rem!important}.m-sm-n1[_ngcontent-%COMP%]{margin:-.25rem!important}.mt-sm-n1[_ngcontent-%COMP%], .my-sm-n1[_ngcontent-%COMP%]{margin-top:-.25rem!important}.mr-sm-n1[_ngcontent-%COMP%], .mx-sm-n1[_ngcontent-%COMP%]{margin-right:-.25rem!important}.mb-sm-n1[_ngcontent-%COMP%], .my-sm-n1[_ngcontent-%COMP%]{margin-bottom:-.25rem!important}.ml-sm-n1[_ngcontent-%COMP%], .mx-sm-n1[_ngcontent-%COMP%]{margin-left:-.25rem!important}.m-sm-n2[_ngcontent-%COMP%]{margin:-.5rem!important}.mt-sm-n2[_ngcontent-%COMP%], .my-sm-n2[_ngcontent-%COMP%]{margin-top:-.5rem!important}.mr-sm-n2[_ngcontent-%COMP%], .mx-sm-n2[_ngcontent-%COMP%]{margin-right:-.5rem!important}.mb-sm-n2[_ngcontent-%COMP%], .my-sm-n2[_ngcontent-%COMP%]{margin-bottom:-.5rem!important}.ml-sm-n2[_ngcontent-%COMP%], .mx-sm-n2[_ngcontent-%COMP%]{margin-left:-.5rem!important}.m-sm-n3[_ngcontent-%COMP%]{margin:-1rem!important}.mt-sm-n3[_ngcontent-%COMP%], .my-sm-n3[_ngcontent-%COMP%]{margin-top:-1rem!important}.mr-sm-n3[_ngcontent-%COMP%], .mx-sm-n3[_ngcontent-%COMP%]{margin-right:-1rem!important}.mb-sm-n3[_ngcontent-%COMP%], .my-sm-n3[_ngcontent-%COMP%]{margin-bottom:-1rem!important}.ml-sm-n3[_ngcontent-%COMP%], .mx-sm-n3[_ngcontent-%COMP%]{margin-left:-1rem!important}.m-sm-n4[_ngcontent-%COMP%]{margin:-1.5rem!important}.mt-sm-n4[_ngcontent-%COMP%], .my-sm-n4[_ngcontent-%COMP%]{margin-top:-1.5rem!important}.mr-sm-n4[_ngcontent-%COMP%], .mx-sm-n4[_ngcontent-%COMP%]{margin-right:-1.5rem!important}.mb-sm-n4[_ngcontent-%COMP%], .my-sm-n4[_ngcontent-%COMP%]{margin-bottom:-1.5rem!important}.ml-sm-n4[_ngcontent-%COMP%], .mx-sm-n4[_ngcontent-%COMP%]{margin-left:-1.5rem!important}.m-sm-n5[_ngcontent-%COMP%]{margin:-3rem!important}.mt-sm-n5[_ngcontent-%COMP%], .my-sm-n5[_ngcontent-%COMP%]{margin-top:-3rem!important}.mr-sm-n5[_ngcontent-%COMP%], .mx-sm-n5[_ngcontent-%COMP%]{margin-right:-3rem!important}.mb-sm-n5[_ngcontent-%COMP%], .my-sm-n5[_ngcontent-%COMP%]{margin-bottom:-3rem!important}.ml-sm-n5[_ngcontent-%COMP%], .mx-sm-n5[_ngcontent-%COMP%]{margin-left:-3rem!important}.m-sm-auto[_ngcontent-%COMP%]{margin:auto!important}.mt-sm-auto[_ngcontent-%COMP%], .my-sm-auto[_ngcontent-%COMP%]{margin-top:auto!important}.mr-sm-auto[_ngcontent-%COMP%], .mx-sm-auto[_ngcontent-%COMP%]{margin-right:auto!important}.mb-sm-auto[_ngcontent-%COMP%], .my-sm-auto[_ngcontent-%COMP%]{margin-bottom:auto!important}.ml-sm-auto[_ngcontent-%COMP%], .mx-sm-auto[_ngcontent-%COMP%]{margin-left:auto!important}}@media (min-width:768px){.m-md-0[_ngcontent-%COMP%]{margin:0!important}.mt-md-0[_ngcontent-%COMP%], .my-md-0[_ngcontent-%COMP%]{margin-top:0!important}.mr-md-0[_ngcontent-%COMP%], .mx-md-0[_ngcontent-%COMP%]{margin-right:0!important}.mb-md-0[_ngcontent-%COMP%], .my-md-0[_ngcontent-%COMP%]{margin-bottom:0!important}.ml-md-0[_ngcontent-%COMP%], .mx-md-0[_ngcontent-%COMP%]{margin-left:0!important}.m-md-1[_ngcontent-%COMP%]{margin:.25rem!important}.mt-md-1[_ngcontent-%COMP%], .my-md-1[_ngcontent-%COMP%]{margin-top:.25rem!important}.mr-md-1[_ngcontent-%COMP%], .mx-md-1[_ngcontent-%COMP%]{margin-right:.25rem!important}.mb-md-1[_ngcontent-%COMP%], .my-md-1[_ngcontent-%COMP%]{margin-bottom:.25rem!important}.ml-md-1[_ngcontent-%COMP%], .mx-md-1[_ngcontent-%COMP%]{margin-left:.25rem!important}.m-md-2[_ngcontent-%COMP%]{margin:.5rem!important}.mt-md-2[_ngcontent-%COMP%], .my-md-2[_ngcontent-%COMP%]{margin-top:.5rem!important}.mr-md-2[_ngcontent-%COMP%], .mx-md-2[_ngcontent-%COMP%]{margin-right:.5rem!important}.mb-md-2[_ngcontent-%COMP%], .my-md-2[_ngcontent-%COMP%]{margin-bottom:.5rem!important}.ml-md-2[_ngcontent-%COMP%], .mx-md-2[_ngcontent-%COMP%]{margin-left:.5rem!important}.m-md-3[_ngcontent-%COMP%]{margin:1rem!important}.mt-md-3[_ngcontent-%COMP%], .my-md-3[_ngcontent-%COMP%]{margin-top:1rem!important}.mr-md-3[_ngcontent-%COMP%], .mx-md-3[_ngcontent-%COMP%]{margin-right:1rem!important}.mb-md-3[_ngcontent-%COMP%], .my-md-3[_ngcontent-%COMP%]{margin-bottom:1rem!important}.ml-md-3[_ngcontent-%COMP%], .mx-md-3[_ngcontent-%COMP%]{margin-left:1rem!important}.m-md-4[_ngcontent-%COMP%]{margin:1.5rem!important}.mt-md-4[_ngcontent-%COMP%], .my-md-4[_ngcontent-%COMP%]{margin-top:1.5rem!important}.mr-md-4[_ngcontent-%COMP%], .mx-md-4[_ngcontent-%COMP%]{margin-right:1.5rem!important}.mb-md-4[_ngcontent-%COMP%], .my-md-4[_ngcontent-%COMP%]{margin-bottom:1.5rem!important}.ml-md-4[_ngcontent-%COMP%], .mx-md-4[_ngcontent-%COMP%]{margin-left:1.5rem!important}.m-md-5[_ngcontent-%COMP%]{margin:3rem!important}.mt-md-5[_ngcontent-%COMP%], .my-md-5[_ngcontent-%COMP%]{margin-top:3rem!important}.mr-md-5[_ngcontent-%COMP%], .mx-md-5[_ngcontent-%COMP%]{margin-right:3rem!important}.mb-md-5[_ngcontent-%COMP%], .my-md-5[_ngcontent-%COMP%]{margin-bottom:3rem!important}.ml-md-5[_ngcontent-%COMP%], .mx-md-5[_ngcontent-%COMP%]{margin-left:3rem!important}.p-md-0[_ngcontent-%COMP%]{padding:0!important}.pt-md-0[_ngcontent-%COMP%], .py-md-0[_ngcontent-%COMP%]{padding-top:0!important}.pr-md-0[_ngcontent-%COMP%], .px-md-0[_ngcontent-%COMP%]{padding-right:0!important}.pb-md-0[_ngcontent-%COMP%], .py-md-0[_ngcontent-%COMP%]{padding-bottom:0!important}.pl-md-0[_ngcontent-%COMP%], .px-md-0[_ngcontent-%COMP%]{padding-left:0!important}.p-md-1[_ngcontent-%COMP%]{padding:.25rem!important}.pt-md-1[_ngcontent-%COMP%], .py-md-1[_ngcontent-%COMP%]{padding-top:.25rem!important}.pr-md-1[_ngcontent-%COMP%], .px-md-1[_ngcontent-%COMP%]{padding-right:.25rem!important}.pb-md-1[_ngcontent-%COMP%], .py-md-1[_ngcontent-%COMP%]{padding-bottom:.25rem!important}.pl-md-1[_ngcontent-%COMP%], .px-md-1[_ngcontent-%COMP%]{padding-left:.25rem!important}.p-md-2[_ngcontent-%COMP%]{padding:.5rem!important}.pt-md-2[_ngcontent-%COMP%], .py-md-2[_ngcontent-%COMP%]{padding-top:.5rem!important}.pr-md-2[_ngcontent-%COMP%], .px-md-2[_ngcontent-%COMP%]{padding-right:.5rem!important}.pb-md-2[_ngcontent-%COMP%], .py-md-2[_ngcontent-%COMP%]{padding-bottom:.5rem!important}.pl-md-2[_ngcontent-%COMP%], .px-md-2[_ngcontent-%COMP%]{padding-left:.5rem!important}.p-md-3[_ngcontent-%COMP%]{padding:1rem!important}.pt-md-3[_ngcontent-%COMP%], .py-md-3[_ngcontent-%COMP%]{padding-top:1rem!important}.pr-md-3[_ngcontent-%COMP%], .px-md-3[_ngcontent-%COMP%]{padding-right:1rem!important}.pb-md-3[_ngcontent-%COMP%], .py-md-3[_ngcontent-%COMP%]{padding-bottom:1rem!important}.pl-md-3[_ngcontent-%COMP%], .px-md-3[_ngcontent-%COMP%]{padding-left:1rem!important}.p-md-4[_ngcontent-%COMP%]{padding:1.5rem!important}.pt-md-4[_ngcontent-%COMP%], .py-md-4[_ngcontent-%COMP%]{padding-top:1.5rem!important}.pr-md-4[_ngcontent-%COMP%], .px-md-4[_ngcontent-%COMP%]{padding-right:1.5rem!important}.pb-md-4[_ngcontent-%COMP%], .py-md-4[_ngcontent-%COMP%]{padding-bottom:1.5rem!important}.pl-md-4[_ngcontent-%COMP%], .px-md-4[_ngcontent-%COMP%]{padding-left:1.5rem!important}.p-md-5[_ngcontent-%COMP%]{padding:3rem!important}.pt-md-5[_ngcontent-%COMP%], .py-md-5[_ngcontent-%COMP%]{padding-top:3rem!important}.pr-md-5[_ngcontent-%COMP%], .px-md-5[_ngcontent-%COMP%]{padding-right:3rem!important}.pb-md-5[_ngcontent-%COMP%], .py-md-5[_ngcontent-%COMP%]{padding-bottom:3rem!important}.pl-md-5[_ngcontent-%COMP%], .px-md-5[_ngcontent-%COMP%]{padding-left:3rem!important}.m-md-n1[_ngcontent-%COMP%]{margin:-.25rem!important}.mt-md-n1[_ngcontent-%COMP%], .my-md-n1[_ngcontent-%COMP%]{margin-top:-.25rem!important}.mr-md-n1[_ngcontent-%COMP%], .mx-md-n1[_ngcontent-%COMP%]{margin-right:-.25rem!important}.mb-md-n1[_ngcontent-%COMP%], .my-md-n1[_ngcontent-%COMP%]{margin-bottom:-.25rem!important}.ml-md-n1[_ngcontent-%COMP%], .mx-md-n1[_ngcontent-%COMP%]{margin-left:-.25rem!important}.m-md-n2[_ngcontent-%COMP%]{margin:-.5rem!important}.mt-md-n2[_ngcontent-%COMP%], .my-md-n2[_ngcontent-%COMP%]{margin-top:-.5rem!important}.mr-md-n2[_ngcontent-%COMP%], .mx-md-n2[_ngcontent-%COMP%]{margin-right:-.5rem!important}.mb-md-n2[_ngcontent-%COMP%], .my-md-n2[_ngcontent-%COMP%]{margin-bottom:-.5rem!important}.ml-md-n2[_ngcontent-%COMP%], .mx-md-n2[_ngcontent-%COMP%]{margin-left:-.5rem!important}.m-md-n3[_ngcontent-%COMP%]{margin:-1rem!important}.mt-md-n3[_ngcontent-%COMP%], .my-md-n3[_ngcontent-%COMP%]{margin-top:-1rem!important}.mr-md-n3[_ngcontent-%COMP%], .mx-md-n3[_ngcontent-%COMP%]{margin-right:-1rem!important}.mb-md-n3[_ngcontent-%COMP%], .my-md-n3[_ngcontent-%COMP%]{margin-bottom:-1rem!important}.ml-md-n3[_ngcontent-%COMP%], .mx-md-n3[_ngcontent-%COMP%]{margin-left:-1rem!important}.m-md-n4[_ngcontent-%COMP%]{margin:-1.5rem!important}.mt-md-n4[_ngcontent-%COMP%], .my-md-n4[_ngcontent-%COMP%]{margin-top:-1.5rem!important}.mr-md-n4[_ngcontent-%COMP%], .mx-md-n4[_ngcontent-%COMP%]{margin-right:-1.5rem!important}.mb-md-n4[_ngcontent-%COMP%], .my-md-n4[_ngcontent-%COMP%]{margin-bottom:-1.5rem!important}.ml-md-n4[_ngcontent-%COMP%], .mx-md-n4[_ngcontent-%COMP%]{margin-left:-1.5rem!important}.m-md-n5[_ngcontent-%COMP%]{margin:-3rem!important}.mt-md-n5[_ngcontent-%COMP%], .my-md-n5[_ngcontent-%COMP%]{margin-top:-3rem!important}.mr-md-n5[_ngcontent-%COMP%], .mx-md-n5[_ngcontent-%COMP%]{margin-right:-3rem!important}.mb-md-n5[_ngcontent-%COMP%], .my-md-n5[_ngcontent-%COMP%]{margin-bottom:-3rem!important}.ml-md-n5[_ngcontent-%COMP%], .mx-md-n5[_ngcontent-%COMP%]{margin-left:-3rem!important}.m-md-auto[_ngcontent-%COMP%]{margin:auto!important}.mt-md-auto[_ngcontent-%COMP%], .my-md-auto[_ngcontent-%COMP%]{margin-top:auto!important}.mr-md-auto[_ngcontent-%COMP%], .mx-md-auto[_ngcontent-%COMP%]{margin-right:auto!important}.mb-md-auto[_ngcontent-%COMP%], .my-md-auto[_ngcontent-%COMP%]{margin-bottom:auto!important}.ml-md-auto[_ngcontent-%COMP%], .mx-md-auto[_ngcontent-%COMP%]{margin-left:auto!important}}@media (min-width:992px){.m-lg-0[_ngcontent-%COMP%]{margin:0!important}.mt-lg-0[_ngcontent-%COMP%], .my-lg-0[_ngcontent-%COMP%]{margin-top:0!important}.mr-lg-0[_ngcontent-%COMP%], .mx-lg-0[_ngcontent-%COMP%]{margin-right:0!important}.mb-lg-0[_ngcontent-%COMP%], .my-lg-0[_ngcontent-%COMP%]{margin-bottom:0!important}.ml-lg-0[_ngcontent-%COMP%], .mx-lg-0[_ngcontent-%COMP%]{margin-left:0!important}.m-lg-1[_ngcontent-%COMP%]{margin:.25rem!important}.mt-lg-1[_ngcontent-%COMP%], .my-lg-1[_ngcontent-%COMP%]{margin-top:.25rem!important}.mr-lg-1[_ngcontent-%COMP%], .mx-lg-1[_ngcontent-%COMP%]{margin-right:.25rem!important}.mb-lg-1[_ngcontent-%COMP%], .my-lg-1[_ngcontent-%COMP%]{margin-bottom:.25rem!important}.ml-lg-1[_ngcontent-%COMP%], .mx-lg-1[_ngcontent-%COMP%]{margin-left:.25rem!important}.m-lg-2[_ngcontent-%COMP%]{margin:.5rem!important}.mt-lg-2[_ngcontent-%COMP%], .my-lg-2[_ngcontent-%COMP%]{margin-top:.5rem!important}.mr-lg-2[_ngcontent-%COMP%], .mx-lg-2[_ngcontent-%COMP%]{margin-right:.5rem!important}.mb-lg-2[_ngcontent-%COMP%], .my-lg-2[_ngcontent-%COMP%]{margin-bottom:.5rem!important}.ml-lg-2[_ngcontent-%COMP%], .mx-lg-2[_ngcontent-%COMP%]{margin-left:.5rem!important}.m-lg-3[_ngcontent-%COMP%]{margin:1rem!important}.mt-lg-3[_ngcontent-%COMP%], .my-lg-3[_ngcontent-%COMP%]{margin-top:1rem!important}.mr-lg-3[_ngcontent-%COMP%], .mx-lg-3[_ngcontent-%COMP%]{margin-right:1rem!important}.mb-lg-3[_ngcontent-%COMP%], .my-lg-3[_ngcontent-%COMP%]{margin-bottom:1rem!important}.ml-lg-3[_ngcontent-%COMP%], .mx-lg-3[_ngcontent-%COMP%]{margin-left:1rem!important}.m-lg-4[_ngcontent-%COMP%]{margin:1.5rem!important}.mt-lg-4[_ngcontent-%COMP%], .my-lg-4[_ngcontent-%COMP%]{margin-top:1.5rem!important}.mr-lg-4[_ngcontent-%COMP%], .mx-lg-4[_ngcontent-%COMP%]{margin-right:1.5rem!important}.mb-lg-4[_ngcontent-%COMP%], .my-lg-4[_ngcontent-%COMP%]{margin-bottom:1.5rem!important}.ml-lg-4[_ngcontent-%COMP%], .mx-lg-4[_ngcontent-%COMP%]{margin-left:1.5rem!important}.m-lg-5[_ngcontent-%COMP%]{margin:3rem!important}.mt-lg-5[_ngcontent-%COMP%], .my-lg-5[_ngcontent-%COMP%]{margin-top:3rem!important}.mr-lg-5[_ngcontent-%COMP%], .mx-lg-5[_ngcontent-%COMP%]{margin-right:3rem!important}.mb-lg-5[_ngcontent-%COMP%], .my-lg-5[_ngcontent-%COMP%]{margin-bottom:3rem!important}.ml-lg-5[_ngcontent-%COMP%], .mx-lg-5[_ngcontent-%COMP%]{margin-left:3rem!important}.p-lg-0[_ngcontent-%COMP%]{padding:0!important}.pt-lg-0[_ngcontent-%COMP%], .py-lg-0[_ngcontent-%COMP%]{padding-top:0!important}.pr-lg-0[_ngcontent-%COMP%], .px-lg-0[_ngcontent-%COMP%]{padding-right:0!important}.pb-lg-0[_ngcontent-%COMP%], .py-lg-0[_ngcontent-%COMP%]{padding-bottom:0!important}.pl-lg-0[_ngcontent-%COMP%], .px-lg-0[_ngcontent-%COMP%]{padding-left:0!important}.p-lg-1[_ngcontent-%COMP%]{padding:.25rem!important}.pt-lg-1[_ngcontent-%COMP%], .py-lg-1[_ngcontent-%COMP%]{padding-top:.25rem!important}.pr-lg-1[_ngcontent-%COMP%], .px-lg-1[_ngcontent-%COMP%]{padding-right:.25rem!important}.pb-lg-1[_ngcontent-%COMP%], .py-lg-1[_ngcontent-%COMP%]{padding-bottom:.25rem!important}.pl-lg-1[_ngcontent-%COMP%], .px-lg-1[_ngcontent-%COMP%]{padding-left:.25rem!important}.p-lg-2[_ngcontent-%COMP%]{padding:.5rem!important}.pt-lg-2[_ngcontent-%COMP%], .py-lg-2[_ngcontent-%COMP%]{padding-top:.5rem!important}.pr-lg-2[_ngcontent-%COMP%], .px-lg-2[_ngcontent-%COMP%]{padding-right:.5rem!important}.pb-lg-2[_ngcontent-%COMP%], .py-lg-2[_ngcontent-%COMP%]{padding-bottom:.5rem!important}.pl-lg-2[_ngcontent-%COMP%], .px-lg-2[_ngcontent-%COMP%]{padding-left:.5rem!important}.p-lg-3[_ngcontent-%COMP%]{padding:1rem!important}.pt-lg-3[_ngcontent-%COMP%], .py-lg-3[_ngcontent-%COMP%]{padding-top:1rem!important}.pr-lg-3[_ngcontent-%COMP%], .px-lg-3[_ngcontent-%COMP%]{padding-right:1rem!important}.pb-lg-3[_ngcontent-%COMP%], .py-lg-3[_ngcontent-%COMP%]{padding-bottom:1rem!important}.pl-lg-3[_ngcontent-%COMP%], .px-lg-3[_ngcontent-%COMP%]{padding-left:1rem!important}.p-lg-4[_ngcontent-%COMP%]{padding:1.5rem!important}.pt-lg-4[_ngcontent-%COMP%], .py-lg-4[_ngcontent-%COMP%]{padding-top:1.5rem!important}.pr-lg-4[_ngcontent-%COMP%], .px-lg-4[_ngcontent-%COMP%]{padding-right:1.5rem!important}.pb-lg-4[_ngcontent-%COMP%], .py-lg-4[_ngcontent-%COMP%]{padding-bottom:1.5rem!important}.pl-lg-4[_ngcontent-%COMP%], .px-lg-4[_ngcontent-%COMP%]{padding-left:1.5rem!important}.p-lg-5[_ngcontent-%COMP%]{padding:3rem!important}.pt-lg-5[_ngcontent-%COMP%], .py-lg-5[_ngcontent-%COMP%]{padding-top:3rem!important}.pr-lg-5[_ngcontent-%COMP%], .px-lg-5[_ngcontent-%COMP%]{padding-right:3rem!important}.pb-lg-5[_ngcontent-%COMP%], .py-lg-5[_ngcontent-%COMP%]{padding-bottom:3rem!important}.pl-lg-5[_ngcontent-%COMP%], .px-lg-5[_ngcontent-%COMP%]{padding-left:3rem!important}.m-lg-n1[_ngcontent-%COMP%]{margin:-.25rem!important}.mt-lg-n1[_ngcontent-%COMP%], .my-lg-n1[_ngcontent-%COMP%]{margin-top:-.25rem!important}.mr-lg-n1[_ngcontent-%COMP%], .mx-lg-n1[_ngcontent-%COMP%]{margin-right:-.25rem!important}.mb-lg-n1[_ngcontent-%COMP%], .my-lg-n1[_ngcontent-%COMP%]{margin-bottom:-.25rem!important}.ml-lg-n1[_ngcontent-%COMP%], .mx-lg-n1[_ngcontent-%COMP%]{margin-left:-.25rem!important}.m-lg-n2[_ngcontent-%COMP%]{margin:-.5rem!important}.mt-lg-n2[_ngcontent-%COMP%], .my-lg-n2[_ngcontent-%COMP%]{margin-top:-.5rem!important}.mr-lg-n2[_ngcontent-%COMP%], .mx-lg-n2[_ngcontent-%COMP%]{margin-right:-.5rem!important}.mb-lg-n2[_ngcontent-%COMP%], .my-lg-n2[_ngcontent-%COMP%]{margin-bottom:-.5rem!important}.ml-lg-n2[_ngcontent-%COMP%], .mx-lg-n2[_ngcontent-%COMP%]{margin-left:-.5rem!important}.m-lg-n3[_ngcontent-%COMP%]{margin:-1rem!important}.mt-lg-n3[_ngcontent-%COMP%], .my-lg-n3[_ngcontent-%COMP%]{margin-top:-1rem!important}.mr-lg-n3[_ngcontent-%COMP%], .mx-lg-n3[_ngcontent-%COMP%]{margin-right:-1rem!important}.mb-lg-n3[_ngcontent-%COMP%], .my-lg-n3[_ngcontent-%COMP%]{margin-bottom:-1rem!important}.ml-lg-n3[_ngcontent-%COMP%], .mx-lg-n3[_ngcontent-%COMP%]{margin-left:-1rem!important}.m-lg-n4[_ngcontent-%COMP%]{margin:-1.5rem!important}.mt-lg-n4[_ngcontent-%COMP%], .my-lg-n4[_ngcontent-%COMP%]{margin-top:-1.5rem!important}.mr-lg-n4[_ngcontent-%COMP%], .mx-lg-n4[_ngcontent-%COMP%]{margin-right:-1.5rem!important}.mb-lg-n4[_ngcontent-%COMP%], .my-lg-n4[_ngcontent-%COMP%]{margin-bottom:-1.5rem!important}.ml-lg-n4[_ngcontent-%COMP%], .mx-lg-n4[_ngcontent-%COMP%]{margin-left:-1.5rem!important}.m-lg-n5[_ngcontent-%COMP%]{margin:-3rem!important}.mt-lg-n5[_ngcontent-%COMP%], .my-lg-n5[_ngcontent-%COMP%]{margin-top:-3rem!important}.mr-lg-n5[_ngcontent-%COMP%], .mx-lg-n5[_ngcontent-%COMP%]{margin-right:-3rem!important}.mb-lg-n5[_ngcontent-%COMP%], .my-lg-n5[_ngcontent-%COMP%]{margin-bottom:-3rem!important}.ml-lg-n5[_ngcontent-%COMP%], .mx-lg-n5[_ngcontent-%COMP%]{margin-left:-3rem!important}.m-lg-auto[_ngcontent-%COMP%]{margin:auto!important}.mt-lg-auto[_ngcontent-%COMP%], .my-lg-auto[_ngcontent-%COMP%]{margin-top:auto!important}.mr-lg-auto[_ngcontent-%COMP%], .mx-lg-auto[_ngcontent-%COMP%]{margin-right:auto!important}.mb-lg-auto[_ngcontent-%COMP%], .my-lg-auto[_ngcontent-%COMP%]{margin-bottom:auto!important}.ml-lg-auto[_ngcontent-%COMP%], .mx-lg-auto[_ngcontent-%COMP%]{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0[_ngcontent-%COMP%]{margin:0!important}.mt-xl-0[_ngcontent-%COMP%], .my-xl-0[_ngcontent-%COMP%]{margin-top:0!important}.mr-xl-0[_ngcontent-%COMP%], .mx-xl-0[_ngcontent-%COMP%]{margin-right:0!important}.mb-xl-0[_ngcontent-%COMP%], .my-xl-0[_ngcontent-%COMP%]{margin-bottom:0!important}.ml-xl-0[_ngcontent-%COMP%], .mx-xl-0[_ngcontent-%COMP%]{margin-left:0!important}.m-xl-1[_ngcontent-%COMP%]{margin:.25rem!important}.mt-xl-1[_ngcontent-%COMP%], .my-xl-1[_ngcontent-%COMP%]{margin-top:.25rem!important}.mr-xl-1[_ngcontent-%COMP%], .mx-xl-1[_ngcontent-%COMP%]{margin-right:.25rem!important}.mb-xl-1[_ngcontent-%COMP%], .my-xl-1[_ngcontent-%COMP%]{margin-bottom:.25rem!important}.ml-xl-1[_ngcontent-%COMP%], .mx-xl-1[_ngcontent-%COMP%]{margin-left:.25rem!important}.m-xl-2[_ngcontent-%COMP%]{margin:.5rem!important}.mt-xl-2[_ngcontent-%COMP%], .my-xl-2[_ngcontent-%COMP%]{margin-top:.5rem!important}.mr-xl-2[_ngcontent-%COMP%], .mx-xl-2[_ngcontent-%COMP%]{margin-right:.5rem!important}.mb-xl-2[_ngcontent-%COMP%], .my-xl-2[_ngcontent-%COMP%]{margin-bottom:.5rem!important}.ml-xl-2[_ngcontent-%COMP%], .mx-xl-2[_ngcontent-%COMP%]{margin-left:.5rem!important}.m-xl-3[_ngcontent-%COMP%]{margin:1rem!important}.mt-xl-3[_ngcontent-%COMP%], .my-xl-3[_ngcontent-%COMP%]{margin-top:1rem!important}.mr-xl-3[_ngcontent-%COMP%], .mx-xl-3[_ngcontent-%COMP%]{margin-right:1rem!important}.mb-xl-3[_ngcontent-%COMP%], .my-xl-3[_ngcontent-%COMP%]{margin-bottom:1rem!important}.ml-xl-3[_ngcontent-%COMP%], .mx-xl-3[_ngcontent-%COMP%]{margin-left:1rem!important}.m-xl-4[_ngcontent-%COMP%]{margin:1.5rem!important}.mt-xl-4[_ngcontent-%COMP%], .my-xl-4[_ngcontent-%COMP%]{margin-top:1.5rem!important}.mr-xl-4[_ngcontent-%COMP%], .mx-xl-4[_ngcontent-%COMP%]{margin-right:1.5rem!important}.mb-xl-4[_ngcontent-%COMP%], .my-xl-4[_ngcontent-%COMP%]{margin-bottom:1.5rem!important}.ml-xl-4[_ngcontent-%COMP%], .mx-xl-4[_ngcontent-%COMP%]{margin-left:1.5rem!important}.m-xl-5[_ngcontent-%COMP%]{margin:3rem!important}.mt-xl-5[_ngcontent-%COMP%], .my-xl-5[_ngcontent-%COMP%]{margin-top:3rem!important}.mr-xl-5[_ngcontent-%COMP%], .mx-xl-5[_ngcontent-%COMP%]{margin-right:3rem!important}.mb-xl-5[_ngcontent-%COMP%], .my-xl-5[_ngcontent-%COMP%]{margin-bottom:3rem!important}.ml-xl-5[_ngcontent-%COMP%], .mx-xl-5[_ngcontent-%COMP%]{margin-left:3rem!important}.p-xl-0[_ngcontent-%COMP%]{padding:0!important}.pt-xl-0[_ngcontent-%COMP%], .py-xl-0[_ngcontent-%COMP%]{padding-top:0!important}.pr-xl-0[_ngcontent-%COMP%], .px-xl-0[_ngcontent-%COMP%]{padding-right:0!important}.pb-xl-0[_ngcontent-%COMP%], .py-xl-0[_ngcontent-%COMP%]{padding-bottom:0!important}.pl-xl-0[_ngcontent-%COMP%], .px-xl-0[_ngcontent-%COMP%]{padding-left:0!important}.p-xl-1[_ngcontent-%COMP%]{padding:.25rem!important}.pt-xl-1[_ngcontent-%COMP%], .py-xl-1[_ngcontent-%COMP%]{padding-top:.25rem!important}.pr-xl-1[_ngcontent-%COMP%], .px-xl-1[_ngcontent-%COMP%]{padding-right:.25rem!important}.pb-xl-1[_ngcontent-%COMP%], .py-xl-1[_ngcontent-%COMP%]{padding-bottom:.25rem!important}.pl-xl-1[_ngcontent-%COMP%], .px-xl-1[_ngcontent-%COMP%]{padding-left:.25rem!important}.p-xl-2[_ngcontent-%COMP%]{padding:.5rem!important}.pt-xl-2[_ngcontent-%COMP%], .py-xl-2[_ngcontent-%COMP%]{padding-top:.5rem!important}.pr-xl-2[_ngcontent-%COMP%], .px-xl-2[_ngcontent-%COMP%]{padding-right:.5rem!important}.pb-xl-2[_ngcontent-%COMP%], .py-xl-2[_ngcontent-%COMP%]{padding-bottom:.5rem!important}.pl-xl-2[_ngcontent-%COMP%], .px-xl-2[_ngcontent-%COMP%]{padding-left:.5rem!important}.p-xl-3[_ngcontent-%COMP%]{padding:1rem!important}.pt-xl-3[_ngcontent-%COMP%], .py-xl-3[_ngcontent-%COMP%]{padding-top:1rem!important}.pr-xl-3[_ngcontent-%COMP%], .px-xl-3[_ngcontent-%COMP%]{padding-right:1rem!important}.pb-xl-3[_ngcontent-%COMP%], .py-xl-3[_ngcontent-%COMP%]{padding-bottom:1rem!important}.pl-xl-3[_ngcontent-%COMP%], .px-xl-3[_ngcontent-%COMP%]{padding-left:1rem!important}.p-xl-4[_ngcontent-%COMP%]{padding:1.5rem!important}.pt-xl-4[_ngcontent-%COMP%], .py-xl-4[_ngcontent-%COMP%]{padding-top:1.5rem!important}.pr-xl-4[_ngcontent-%COMP%], .px-xl-4[_ngcontent-%COMP%]{padding-right:1.5rem!important}.pb-xl-4[_ngcontent-%COMP%], .py-xl-4[_ngcontent-%COMP%]{padding-bottom:1.5rem!important}.pl-xl-4[_ngcontent-%COMP%], .px-xl-4[_ngcontent-%COMP%]{padding-left:1.5rem!important}.p-xl-5[_ngcontent-%COMP%]{padding:3rem!important}.pt-xl-5[_ngcontent-%COMP%], .py-xl-5[_ngcontent-%COMP%]{padding-top:3rem!important}.pr-xl-5[_ngcontent-%COMP%], .px-xl-5[_ngcontent-%COMP%]{padding-right:3rem!important}.pb-xl-5[_ngcontent-%COMP%], .py-xl-5[_ngcontent-%COMP%]{padding-bottom:3rem!important}.pl-xl-5[_ngcontent-%COMP%], .px-xl-5[_ngcontent-%COMP%]{padding-left:3rem!important}.m-xl-n1[_ngcontent-%COMP%]{margin:-.25rem!important}.mt-xl-n1[_ngcontent-%COMP%], .my-xl-n1[_ngcontent-%COMP%]{margin-top:-.25rem!important}.mr-xl-n1[_ngcontent-%COMP%], .mx-xl-n1[_ngcontent-%COMP%]{margin-right:-.25rem!important}.mb-xl-n1[_ngcontent-%COMP%], .my-xl-n1[_ngcontent-%COMP%]{margin-bottom:-.25rem!important}.ml-xl-n1[_ngcontent-%COMP%], .mx-xl-n1[_ngcontent-%COMP%]{margin-left:-.25rem!important}.m-xl-n2[_ngcontent-%COMP%]{margin:-.5rem!important}.mt-xl-n2[_ngcontent-%COMP%], .my-xl-n2[_ngcontent-%COMP%]{margin-top:-.5rem!important}.mr-xl-n2[_ngcontent-%COMP%], .mx-xl-n2[_ngcontent-%COMP%]{margin-right:-.5rem!important}.mb-xl-n2[_ngcontent-%COMP%], .my-xl-n2[_ngcontent-%COMP%]{margin-bottom:-.5rem!important}.ml-xl-n2[_ngcontent-%COMP%], .mx-xl-n2[_ngcontent-%COMP%]{margin-left:-.5rem!important}.m-xl-n3[_ngcontent-%COMP%]{margin:-1rem!important}.mt-xl-n3[_ngcontent-%COMP%], .my-xl-n3[_ngcontent-%COMP%]{margin-top:-1rem!important}.mr-xl-n3[_ngcontent-%COMP%], .mx-xl-n3[_ngcontent-%COMP%]{margin-right:-1rem!important}.mb-xl-n3[_ngcontent-%COMP%], .my-xl-n3[_ngcontent-%COMP%]{margin-bottom:-1rem!important}.ml-xl-n3[_ngcontent-%COMP%], .mx-xl-n3[_ngcontent-%COMP%]{margin-left:-1rem!important}.m-xl-n4[_ngcontent-%COMP%]{margin:-1.5rem!important}.mt-xl-n4[_ngcontent-%COMP%], .my-xl-n4[_ngcontent-%COMP%]{margin-top:-1.5rem!important}.mr-xl-n4[_ngcontent-%COMP%], .mx-xl-n4[_ngcontent-%COMP%]{margin-right:-1.5rem!important}.mb-xl-n4[_ngcontent-%COMP%], .my-xl-n4[_ngcontent-%COMP%]{margin-bottom:-1.5rem!important}.ml-xl-n4[_ngcontent-%COMP%], .mx-xl-n4[_ngcontent-%COMP%]{margin-left:-1.5rem!important}.m-xl-n5[_ngcontent-%COMP%]{margin:-3rem!important}.mt-xl-n5[_ngcontent-%COMP%], .my-xl-n5[_ngcontent-%COMP%]{margin-top:-3rem!important}.mr-xl-n5[_ngcontent-%COMP%], .mx-xl-n5[_ngcontent-%COMP%]{margin-right:-3rem!important}.mb-xl-n5[_ngcontent-%COMP%], .my-xl-n5[_ngcontent-%COMP%]{margin-bottom:-3rem!important}.ml-xl-n5[_ngcontent-%COMP%], .mx-xl-n5[_ngcontent-%COMP%]{margin-left:-3rem!important}.m-xl-auto[_ngcontent-%COMP%]{margin:auto!important}.mt-xl-auto[_ngcontent-%COMP%], .my-xl-auto[_ngcontent-%COMP%]{margin-top:auto!important}.mr-xl-auto[_ngcontent-%COMP%], .mx-xl-auto[_ngcontent-%COMP%]{margin-right:auto!important}.mb-xl-auto[_ngcontent-%COMP%], .my-xl-auto[_ngcontent-%COMP%]{margin-bottom:auto!important}.ml-xl-auto[_ngcontent-%COMP%], .mx-xl-auto[_ngcontent-%COMP%]{margin-left:auto!important}}.text-monospace[_ngcontent-%COMP%]{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace!important}.text-justify[_ngcontent-%COMP%]{text-align:justify!important}.text-wrap[_ngcontent-%COMP%]{white-space:normal!important}.text-nowrap[_ngcontent-%COMP%]{white-space:nowrap!important}.text-truncate[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-left[_ngcontent-%COMP%]{text-align:left!important}.text-right[_ngcontent-%COMP%]{text-align:right!important}.text-center[_ngcontent-%COMP%]{text-align:center!important}@media (min-width:576px){.text-sm-left[_ngcontent-%COMP%]{text-align:left!important}.text-sm-right[_ngcontent-%COMP%]{text-align:right!important}.text-sm-center[_ngcontent-%COMP%]{text-align:center!important}}@media (min-width:768px){.text-md-left[_ngcontent-%COMP%]{text-align:left!important}.text-md-right[_ngcontent-%COMP%]{text-align:right!important}.text-md-center[_ngcontent-%COMP%]{text-align:center!important}}@media (min-width:992px){.text-lg-left[_ngcontent-%COMP%]{text-align:left!important}.text-lg-right[_ngcontent-%COMP%]{text-align:right!important}.text-lg-center[_ngcontent-%COMP%]{text-align:center!important}}@media (min-width:1200px){.text-xl-left[_ngcontent-%COMP%]{text-align:left!important}.text-xl-right[_ngcontent-%COMP%]{text-align:right!important}.text-xl-center[_ngcontent-%COMP%]{text-align:center!important}}.text-lowercase[_ngcontent-%COMP%]{text-transform:lowercase!important}.text-uppercase[_ngcontent-%COMP%]{text-transform:uppercase!important}.text-capitalize[_ngcontent-%COMP%]{text-transform:capitalize!important}.font-weight-light[_ngcontent-%COMP%]{font-weight:300!important}.font-weight-lighter[_ngcontent-%COMP%]{font-weight:lighter!important}.font-weight-normal[_ngcontent-%COMP%]{font-weight:400!important}.font-weight-bold[_ngcontent-%COMP%]{font-weight:700!important}.font-weight-bolder[_ngcontent-%COMP%]{font-weight:bolder!important}.font-italic[_ngcontent-%COMP%]{font-style:italic!important}.text-white[_ngcontent-%COMP%]{color:#fff!important}.text-primary[_ngcontent-%COMP%]{color:#007bff!important}a.text-primary[_ngcontent-%COMP%]:focus, a.text-primary[_ngcontent-%COMP%]:hover{color:#0056b3!important}.text-secondary[_ngcontent-%COMP%]{color:#6c757d!important}a.text-secondary[_ngcontent-%COMP%]:focus, a.text-secondary[_ngcontent-%COMP%]:hover{color:#494f54!important}.text-success[_ngcontent-%COMP%]{color:#28a745!important}a.text-success[_ngcontent-%COMP%]:focus, a.text-success[_ngcontent-%COMP%]:hover{color:#19692c!important}.text-info[_ngcontent-%COMP%]{color:#17a2b8!important}a.text-info[_ngcontent-%COMP%]:focus, a.text-info[_ngcontent-%COMP%]:hover{color:#0f6674!important}.text-warning[_ngcontent-%COMP%]{color:#ffc107!important}a.text-warning[_ngcontent-%COMP%]:focus, a.text-warning[_ngcontent-%COMP%]:hover{color:#ba8b00!important}.text-danger[_ngcontent-%COMP%]{color:#dc3545!important}a.text-danger[_ngcontent-%COMP%]:focus, a.text-danger[_ngcontent-%COMP%]:hover{color:#a71d2a!important}.text-light[_ngcontent-%COMP%]{color:#f8f9fa!important}a.text-light[_ngcontent-%COMP%]:focus, a.text-light[_ngcontent-%COMP%]:hover{color:#cbd3da!important}.text-dark[_ngcontent-%COMP%]{color:#343a40!important}a.text-dark[_ngcontent-%COMP%]:focus, a.text-dark[_ngcontent-%COMP%]:hover{color:#121416!important}.text-body[_ngcontent-%COMP%]{color:#212529!important}.text-muted[_ngcontent-%COMP%]{color:#6c757d!important}.text-black-50[_ngcontent-%COMP%]{color:#00000080!important}.text-white-50[_ngcontent-%COMP%]{color:#ffffff80!important}.text-hide[_ngcontent-%COMP%]{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.text-decoration-none[_ngcontent-%COMP%]{text-decoration:none!important}.text-break[_ngcontent-%COMP%]{word-break:break-word!important;overflow-wrap:break-word!important}.text-reset[_ngcontent-%COMP%]{color:inherit!important}.visible[_ngcontent-%COMP%]{visibility:visible!important}.invisible[_ngcontent-%COMP%]{visibility:hidden!important}@media print{*[_ngcontent-%COMP%], [_ngcontent-%COMP%]:after, [_ngcontent-%COMP%]:before{text-shadow:none!important;box-shadow:none!important}a[_ngcontent-%COMP%]:not(.btn){text-decoration:underline}abbr[title][_ngcontent-%COMP%]:after{content:\" (\" attr(title) \")\"}pre[_ngcontent-%COMP%]{white-space:pre-wrap!important}blockquote[_ngcontent-%COMP%], pre[_ngcontent-%COMP%]{border:1px solid #adb5bd;page-break-inside:avoid}thead[_ngcontent-%COMP%]{display:table-header-group}img[_ngcontent-%COMP%], tr[_ngcontent-%COMP%]{page-break-inside:avoid}h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{orphans:3;widows:3}h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]{page-break-after:avoid}@page{size:a3}body[_ngcontent-%COMP%]{min-width:992px!important}.container[_ngcontent-%COMP%]{min-width:992px!important}.navbar[_ngcontent-%COMP%]{display:none}.badge[_ngcontent-%COMP%]{border:1px solid #000}.table[_ngcontent-%COMP%]{border-collapse:collapse!important}.table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{background-color:#fff!important}.table-bordered[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-bordered[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:1px solid #dee2e6!important}.table-dark[_ngcontent-%COMP%]{color:inherit}.table-dark[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] + tbody[_ngcontent-%COMP%], .table-dark[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table-dark[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .table-dark[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border-color:#dee2e6}.table[_ngcontent-%COMP%]   .thead-dark[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:inherit;border-color:#dee2e6}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AngularCalendarViewComponent, [{
        type: Component,
        args: [{
                selector: "lib-angular-calendar-view",
                templateUrl: "./angular-calendar-view.component.html",
                styleUrls: [
                    "./angular-calendar-view.component.scss",
                    "../../common/bootstrap.min.css"
                ]
            }]
    }], function () { return []; }, { modalContent: [{
            type: ViewChild,
            args: ["modalContent", { static: true }]
        }], atDayClicked: [{
            type: Output
        }], atMonthChange: [{
            type: Output
        }], setMaxDate: [{
            type: Input
        }], setMinDate: [{
            type: Input
        }], eventColors: [{
            type: Input
        }], eventList: [{
            type: Input
        }] }); })();

class HomeService extends BaseService {
    constructor(injector, dataService) {
        super(injector);
        this.injector = injector;
        this.dataService = dataService;
        this.apiConfig = new ApiConfig();
        this.homeTileConfigService = () => {
            const serverUrl = this.apiConfig.getHomeTileConfigUrl();
            return this.get(serverUrl).pipe(map(this.extractCompleteResponse));
        };
        this.homeTileAppConfigService = (appName) => {
            const serverUrl = this.apiConfig.getHomeTileAppConfigUrl(appName);
            return this.get(serverUrl).pipe(map(this.extractCompleteResponse));
        };
        this.homeTileCountService = (type) => {
            const serverUrl = this.apiConfig.getTileCountUrl() + "/" + type;
            return this.get(serverUrl).pipe(map(this.extractCompleteResponse));
        };
        this.statsCountService = (locId, statsPollTime) => {
            const serverUrl = this.apiConfig.getStatsCount();
            const body = {
                locationId: locId
            };
            const options = {
                responseType: "json",
                timeout: statsPollTime
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractCompleteResponse));
        };
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractCompleteResponse = (res) => {
            return res;
        };
    }
}
HomeService.ɵfac = function HomeService_Factory(t) { return new (t || HomeService)(i0.ɵɵinject(i0.Injector), i0.ɵɵinject(DataService)); };
HomeService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HomeService, factory: HomeService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HomeService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: i0.Injector }, { type: DataService }]; }, null); })();

const _c0$1q = function (a0) { return [a0, "linkContainer"]; };
function AppSwitcherComponent_div_0_li_10_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 7);
    i0.ɵɵlistener("click", function AppSwitcherComponent_div_0_li_10_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const app_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return ctx_r3.tileClicked(app_r2); });
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵelement(2, "img", 9);
    i0.ɵɵelementStart(3, "div", 10);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const app_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$1q, app_r2.isDisabled || ctx_r1.checkIfSameApp(app_r2.contextUrl) ? "disabledLink" : ""));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("src", "/assets/images/basic/app-switcher/", app_r2.iconName, ".svg??64tqqn", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 3, app_r2.displayTitle));
} }
function AppSwitcherComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "ul");
    i0.ɵɵtemplate(10, AppSwitcherComponent_div_0_li_10_Template, 6, 7, "li", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 3, "shared-lib.app-switcher.header"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 5, "shared-lib.app-switcher.subheader"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.appConfig);
} }
class AppSwitcherComponent {
    constructor(dataService, router, homeService, translate) {
        this.dataService = dataService;
        this.router = router;
        this.homeService = homeService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.hiddenKeys = [
            "location_analytics_engine",
            "calendar",
            "experience_manager"
        ];
        this.configReady = false;
        this.messageKeys = {};
        this.emitState = new EventEmitter();
        this.init = () => {
            setTimeout(() => {
                this.dataService
                    .getTilesData(this.unsubscribe$)
                    .subscribe((data) => {
                    // this.getLocalizationText(data);
                    this.appConfig = data;
                    console.log("app switcher", JSON.stringify(this.appConfig));
                    (this.appConfig && this.appConfig.length == 0)
                        ? this.getTileConfig()
                        : this.filterAppConfig();
                });
            }, 500);
            this.currentNav = this.dataService.getCurrentNav();
            if (this.currentNav && this.currentNav[0] != "/") {
                this.currentNav = "/" + this.currentNav;
            }
        };
        this.getTileConfig = () => {
            this.homeService
                .homeTileConfigService()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data) {
                    const config = data.data;
                    this.dataService.setTilesData(config.myApps);
                    this.filterAppConfig();
                }
            }, (error) => {
                console.log("ERROR, Failed to fetch home tile config");
            });
        };
        this.filterAppConfig = () => {
            const that = this;
            that.appConfig = that.appConfig.filter((e) => {
                return that.hiddenKeys.indexOf(e.key) === -1;
            });
            that.configReady = true;
        };
        // for OpenRoaming app checks
        this.checkIfSameApp = (contextUrl) => {
            if (this.currentNav == contextUrl) {
                return true;
            }
            else if (this.currentNav == "/captiveportal/portal" &&
                contextUrl == "/captiveportal") {
                return true;
            }
            else if ((this.currentNav == "/openroaming/statistics" ||
                this.currentNav == "/openroaming/getstarted") &&
                contextUrl == "/openroaming/statistics") {
                return true;
            }
            return false;
        };
        this.tileClicked = ($event) => {
            if ($event.contactSupportPopup || $event.isDisabled) {
                this.dataService.setToastMessage("You do not have access to " +
                    $event.title +
                    " app. Please contact your administrator to request access.", 5000, null, null, "error");
            }
            else if (this.currentNav == $event.contextUrl) {
                this.dataService.setToastMessage("You are already in " + $event.title + " app page", 5000, null, null, "error");
            }
            else if (this.currentNav == "/captiveportal/portal" &&
                $event.contextUrl == "/captiveportal") {
                this.dataService.setToastMessage("You are already in " + $event.title + " app page", 5000, null, null, "error");
            }
            else if ((this.currentNav == "/openroaming/statistics" ||
                this.currentNav == "/openroaming/getstarted") &&
                $event.contextUrl == "/openroaming/statistics") {
                this.dataService.setToastMessage("You are already in " + $event.title + " app page", 5000, null, null, "error");
            }
            else {
                if ($event.isDashboardApp) {
                    this.emitState.emit(false);
                    this.dataService.display(true);
                    switch ($event.contextUrl) {
                        case "/location-analytics":
                            sessionStorage.removeItem("analyticsFilter");
                            break;
                        case "/location-analytics-v2":
                            sessionStorage.removeItem("analyticsFilter");
                            break;
                        case "/business":
                            localStorage.removeItem("spacesObj");
                            break;
                        case "/rules/engagement":
                        case "/rules/profile":
                        case "/apps":
                            break;
                    }
                    let urlValue;
                    if ($event.contextUrl === "/captiveportalapp/portal") {
                        urlValue = "/captiveportal";
                    }
                    else {
                        urlValue = $event.contextUrl;
                    }
                    this.dataService.setCurrentNav(urlValue);
                    this.router.navigate([urlValue]);
                }
                else {
                    if ($event.contextUrl) {
                        setTimeout(() => {
                            const getUrl = window.location;
                            window.location.href =
                                getUrl.protocol +
                                    "//" +
                                    getUrl.host +
                                    $event.contextUrl;
                        }, 5);
                    }
                    else {
                        console.log("Context url is not found. Please contact support to access this app.", $event.title);
                        this.dataService.setToastMessage("Please contact support to access " +
                            $event.title +
                            " app.", 5000, null, null, "error");
                    }
                }
            }
        };
        this.getStaticText = () => {
            // business_insights starts
            this.translate.get('dashboard-lib.homepage.tiles.business_insights.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.business_insights.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.business_insights.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.business_insights.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.business_insights.upgradelicense.license').subscribe((res) => {
                this.messageKeys["homepage.tiles.business_insights.upgradelicense.license"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.business_insights.upgradelicense.footertext').subscribe((res) => {
                this.messageKeys["homepage.tiles.business_insights.upgradelicense.footertext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.business_insights.upgradelicense.features.roommetrics.displayTitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.business_insights.upgradelicense.features.roommetrics.displayTitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.business_insights.upgradelicense.features.roommetrics.desc').subscribe((res) => {
                this.messageKeys["homepage.tiles.business_insights.upgradelicense.features.roommetrics.desc"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.business_insights.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.business_insights.footer.main.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.business_insights.footer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.business_insights.footer.sub.title"] = res;
            });
            // business_insights starts
            // right_now starts
            this.translate.get('dashboard-lib.homepage.tiles.right_now.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.upgradelicense.license').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.upgradelicense.license"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.upgradelicense.footertext').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.upgradelicense.footertext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.upgradelicense.features.densityrule.displayTitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.upgradelicense.features.densityrule.displayTitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.upgradelicense.features.densityrule.desc').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.upgradelicense.features.densityrule.desc"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.footer.main.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.footer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.footer.sub.title"] = res;
            });
            // right_now starts
            // camera_metrics starts
            this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.camera_metrics.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.camera_metrics.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.tilecap.bannerdisplaytext').subscribe((res) => {
                this.messageKeys["homepage.tiles.camera_metrics.tilecap.bannerdisplaytext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.camera_metrics.footer.main.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.footer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.camera_metrics.footer.sub.title"] = res;
            });
            // camera_metrics starts
            // open_roaming starts
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradelicense.license').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradelicense.license"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradelicense.footertext').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradelicense.footertext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradelicense.features.orsdk.displayTitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradelicense.features.orsdk.displayTitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradelicense.features.orsdk.desc').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradelicense.features.orsdk.desc"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradeextlicense.license').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradeextlicense.license"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradeextlicense.footertext').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradeextlicense.footertext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradeextlicense.features.carrier-offloading.displayTitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradeextlicense.features.carrier-offloading.displayTitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradeextlicense.features.carrier-offloading.desc').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradeextlicense.features.carrier-offloading.desc"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.footer.main.title"] = res;
            });
            // open_roaming starts
            // location_analytics starts
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.upgradelicense.license').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.upgradelicense.license"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.upgradelicense.footertext').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.upgradelicense.footertext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.upgradelicense.features.floors.displayTitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.upgradelicense.features.floors.displayTitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.upgradelicense.features.floors.desc').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.upgradelicense.features.floors.desc"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.tilecap.bannerdisplaytext').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.tilecap.bannerdisplaytext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.footer.main.title"] = res;
            });
            // location_analytics starts
            // detect_locate starts
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.upgradelicense.license').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.upgradelicense.license"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.upgradelicense.footertext').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.upgradelicense.footertext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.upgradelicense.features.floors.displayTitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.upgradelicense.features.floors.displayTitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.upgradelicense.features.floors.desc').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.upgradelicense.features.floors.desc"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.footer.main.title"] = res;
            });
            // detect_locate starts
            // impact_analysis starts
            this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.impact_analysis.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.impact_analysis.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.tilecap.subtitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.impact_analysis.tilecap.subtitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.tilecap.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.impact_analysis.tilecap.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.impact_analysis.footer.main.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.footer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.impact_analysis.footer.sub.title"] = res;
            });
            // impact_analysis starts
            // captive_portal starts
            this.translate.get('dashboard-lib.homepage.tiles.captive_portal.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.captive_portal.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.captive_portal.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.captive_portal.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.captive_portal.tilecap.subtitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.captive_portal.tilecap.subtitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.captive_portal.tilecap.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.captive_portal.tilecap.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.captive_portal.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.captive_portal.footer.main.title"] = res;
            });
            // captive_portal starts
            // engagements starts
            this.translate.get('dashboard-lib.homepage.tiles.engagements.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.engagements.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.engagements.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.engagements.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.engagements.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.engagements.footer.main.title"] = res;
            });
            // engagements starts
            // profile_rules starts
            this.translate.get('dashboard-lib.homepage.tiles.profile_rules.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.profile_rules.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.profile_rules.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.profile_rules.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.profile_rules.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.profile_rules.footer.main.title"] = res;
            });
            // profile_rules starts
            // operational_insights starts
            this.translate.get('dashboard-lib.homepage.tiles.operational_insights.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.operational_insights.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.operational_insights.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.operational_insights.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.operational_insights.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.operational_insights.footer.main.title"] = res;
            });
            // operational_insights ends
            // iot_explorer starts
            this.translate.get('dashboard-lib.homepage.tiles.iot_explorer.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.iot_explorer.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.iot_explorer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.iot_explorer.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.iot_explorer.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.iot_explorer.footer.main.title"] = res;
            });
            // iot_explorer ends
            // calendar starts
            this.translate.get('dashboard-lib.homepage.tiles.calendar.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.calendar.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.calendar.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.calendar.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.calendar.footer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.calendar.footer.sub.title"] = res;
            });
            // calendar ends
            // experience_manager starts
            this.translate.get('dashboard-lib.homepage.tiles.experience_manager.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.experience_manager.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.experience_manager.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.experience_manager.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.experience_manager.footer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.experience_manager.footer.sub.title"] = res;
            });
            // experience_manager ends
            // location_analytics_engine starts
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics_engine.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics_engine.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics_engine.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics_engine.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics_engine.tilecap.bannerdisplaytext').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics_engine.tilecap.bannerdisplaytext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics_engine.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics_engine.footer.main.title"] = res;
            });
            // location_analytics_engine ends
            // proximity_tracing starts
            this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.proximity_tracing.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.proximity_tracing.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.tilecap.subtitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.proximity_tracing.tilecap.subtitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.tilecap.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.proximity_tracing.tilecap.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.proximity_tracing.footer.main.title"] = res;
            });
            // proximity_tracing ends
            // device_market_place starts
            this.translate.get('dashboard-lib.homepage.tiles.device_market_place.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.device_market_place.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.device_market_place.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.device_market_place.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.device_market_place.tilecap.bannerdisplaytext').subscribe((res) => {
                this.messageKeys["homepage.tiles.device_market_place.tilecap.bannerdisplaytext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.device_market_place.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.device_market_place.footer.main.title"] = res;
            });
            // device_market_place ends
            // partner_apps starts
            this.translate.get('dashboard-lib.homepage.tiles.partner_apps.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.partner_apps.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.partner_apps.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.partner_apps.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.partner_apps.tilecap.bannerdisplaytext').subscribe((res) => {
                this.messageKeys["homepage.tiles.partner_apps.tilecap.bannerdisplaytext"] = res;
            });
            // partner_apps ends
            // signage starts
            this.translate.get('dashboard-lib.homepage.tiles.signage.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.signage.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.signage.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.signage.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.signage.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.signage.footer.main.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.signage.tilecap.bannerdisplaytext').subscribe((res) => {
                this.messageKeys["homepage.tiles.signage.titlecap.bannerdisplaytext"] = res;
            });
            //Signage ends
            // workspace_experience starts
            this.translate.get('dashboard-lib.homepage.tiles.workspace_experience.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.workspace_experience.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.workspace_experience.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.workspace_experience.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.workspace_experience.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.workspace_experience.footer.main.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.workspace_experience.tilecap.bannerdisplaytext').subscribe((res) => {
                this.messageKeys["homepage.tiles.workspace_experience.titlecap.bannerdisplaytext"] = res;
            });
            //workspace experience ends
        };
        this.getLocalizationText = (tile) => {
            if (tile && tile.displayTitle && tile.displayTitle.indexOf("dashboard-lib.") === -1) {
                return `dashboard-lib.${tile.displayTitle}`;
            }
            else {
                return tile.displayTitle;
            }
        };
        router.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
                this.currentNav = this.dataService.getCurrentNav();
            }
        });
    }
    ngOnInit() {
        this.getStaticText();
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
            setTimeout(() => {
                this.init();
            }, 100);
        });
    }
}
AppSwitcherComponent.ɵfac = function AppSwitcherComponent_Factory(t) { return new (t || AppSwitcherComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(HomeService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
AppSwitcherComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AppSwitcherComponent, selectors: [["lib-app-switcher"]], outputs: { emitState: "emitState" }, decls: 1, vars: 1, consts: [["class", "switcher", 4, "ngIf"], [1, "switcher"], [1, "switcher_wrapper"], [1, "switcher_header"], [1, "switcher_header_1"], [1, "switcher_header_2"], [3, "click", 4, "ngFor", "ngForOf"], [3, "click"], [3, "ngClass"], ["width", "50", 3, "src"], [1, "link_name"]], template: function AppSwitcherComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, AppSwitcherComponent_div_0_Template, 11, 7, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.configReady);
    } }, directives: [i1$2.NgIf, i1$2.NgForOf, i1$2.NgClass], pipes: [i2.TranslatePipe], styles: [".switcher[_ngcontent-%COMP%]{position:absolute;font-family:ciscoSans;top:76px;right:125px;width:400px;background:#fff;color:#323b48;padding:10px 15px;box-shadow:0 1px 3px 1px #bdbdbd3d}.switcher_header[_ngcontent-%COMP%]{border-bottom:1px solid #E5E5E5;padding:10px 0 10px 10px}.switcher_header_1[_ngcontent-%COMP%]{font-size:22px;padding:5px 0}.switcher_header_2[_ngcontent-%COMP%]{font-size:12px}.switcher[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;height:250px;padding:10px 0;overflow-y:auto;border-radius:5px;box-shadow:inset 0 1px 3px 2px #bdbdbd3d}.switcher[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;cursor:pointer;transition:.2s linear;border-radius:2px;flex:0 0 33%;text-align:center;width:120px;justify-content:center;padding:10px 0}.switcher[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .link_name[_ngcontent-%COMP%]{padding:0 20px;font-size:12px}.switcher[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{background:#dfdfdf}.linkContainer[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center}.switcher[_ngcontent-%COMP%]:before{content:\"\";position:absolute;bottom:100%;right:0;width:30px;height:0;border-bottom:5px solid #049FD9}.disabledLink[_ngcontent-%COMP%]{opacity:.5;pointer-events:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppSwitcherComponent, [{
        type: Component,
        args: [{
                selector: "lib-app-switcher",
                templateUrl: "./app-switcher.component.html",
                styleUrls: ["./app-switcher.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: i1.Router }, { type: HomeService }, { type: i2.TranslateService }]; }, { emitState: [{
            type: Output
        }] }); })();

const _c0$1p = ["nodeRef"];
function BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 15);
} }
function BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 16);
} }
function BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵlistener("click", function BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_3_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(4); return ctx_r9.slideLeft(); });
    i0.ɵɵtext(1, "\uE906");
    i0.ɵɵelementEnd();
} }
function BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵlistener("click", function BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_4_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(4); return ctx_r11.slideRight(); });
    i0.ɵɵtext(1, "\uE907");
    i0.ɵɵelementEnd();
} }
function BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "span", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 20);
    i0.ɵɵelement(4, "img", 7);
    i0.ɵɵtext(5, " Time zone data not available ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 21);
    i0.ɵɵelementStart(7, "p");
    i0.ɵɵtext(8, " Time zone is not updated in this location. Any analytics information for this location will be incorrect and scheduled rules associated with this location will trigger at incorrect times. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p");
    i0.ɵɵtext(10, " Click the location name and click \u201CEdit location data\u201D to update the time zone ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.node.data.name, " ");
} }
function BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_5_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "span", 20);
    i0.ɵɵelement(2, "img", 7);
    i0.ɵɵtext(3, " Uncategorized APS ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 21);
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" There are ", ctx_r15.wlcCount.apsCount, " uncategorized access points in this controller. Please use appropriate prefixes for your access points names to import them. ");
} }
function BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_5_span_1_Template, 11, 1, "span", 0);
    i0.ɵɵtemplate(2, BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_5_span_2_Template, 7, 1, "span", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const alert_r13 = ctx.$implicit;
    const ctx_r8 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", alert_r13 == "timezone" && ctx_r8.currentSlide === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", alert_r13 == "wlcCount" && ctx_r8.currentSlide === 2);
} }
const _c1$z = function (a0) { return { "bottom": a0 }; };
function BusinessHierarchyNodeComponent_div_0_span_5_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtemplate(1, BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_1_Template, 1, 0, "span", 10);
    i0.ɵɵtemplate(2, BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_2_Template, 1, 0, "span", 11);
    i0.ɵɵtemplate(3, BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_3_Template, 2, 0, "span", 12);
    i0.ɵɵtemplate(4, BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_4_Template, 2, 0, "span", 13);
    i0.ɵɵtemplate(5, BusinessHierarchyNodeComponent_div_0_span_5_span_4_span_5_Template, 3, 2, "span", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$z, !ctx_r3.getPosition()));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.getPosition());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.getPosition());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.alerts.length > 1 && ctx_r3.currentSlide === 2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.alerts.length > 1 && ctx_r3.currentSlide === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.alerts);
} }
function BusinessHierarchyNodeComponent_div_0_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵelementStart(1, "span", 5, 6);
    i0.ɵɵlistener("mouseover", function BusinessHierarchyNodeComponent_div_0_span_5_Template_span_mouseover_1_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.hoverOnFunc($event, ctx_r16.node.data); })("mouseout", function BusinessHierarchyNodeComponent_div_0_span_5_Template_span_mouseout_1_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.hoverOutFunc($event, ctx_r18.node.data); });
    i0.ɵɵelement(3, "img", 7);
    i0.ɵɵtemplate(4, BusinessHierarchyNodeComponent_div_0_span_5_span_4_Template, 6, 8, "span", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.showToolTip && ctx_r1.alerts);
} }
function BusinessHierarchyNodeComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "span", 1);
    i0.ɵɵelementStart(3, "span", 2);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, BusinessHierarchyNodeComponent_div_0_span_5_Template, 5, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("node-template ", ctx_r0.getClassName(ctx_r0.node), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.node.data.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.alerts && ctx_r0.alerts.length);
} }
class BusinessHierarchyNodeComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.showDefaultNode = true;
        this.node = null;
        this.showToolTip = false;
        this.onhover = new EventEmitter();
        this.onout = new EventEmitter();
        this.wlcLocationData = [];
        this.wlcCount = {
            apsCount: 0,
            locationId: null,
            locationName: null,
            wlcLocationId: null
        };
        this.alerts = [];
        this.currentSlide = 1;
        this.getClassName = (node) => {
            if (node && node.data && node.data.type && node.data.type.length) {
                return "type-" + node.data.type[0].toLowerCase();
            }
            else {
                return "";
            }
        };
        this.toggleToolTip = (e) => {
            if (e) {
                this.showToolTip = e;
            }
            else {
                setTimeout(() => {
                    this.showToolTip = e;
                }, 1000);
            }
        };
        this.prepareWlcLocationData = () => {
            this.wlcCount = {
                apsCount: 0,
                locationId: null,
                locationName: null,
                wlcLocationId: null
            };
            const locationId = this.node.data.id;
            if (this.wlcLocationData && this.wlcLocationData.length) {
                const wlcCount = this.wlcLocationData.filter((e) => {
                    if (e.wlcLocationId === locationId) {
                        return e;
                    }
                });
                if (wlcCount && wlcCount.length) {
                    this.wlcCount = wlcCount[0];
                    if (this.alerts.indexOf('wlcCount') === -1) {
                        this.alerts.push('wlcCount');
                    }
                }
            }
        };
        this.slideRight = () => {
            this.currentSlide = 2;
        };
        this.slideLeft = () => {
            this.currentSlide = 1;
        };
        this.getPosition = () => {
            if (this.nodeRef
                && this.nodeRef.nativeElement
                && this.nodeRef.nativeElement.offsetTop) {
                const offsetTop = this.nodeRef.nativeElement.offsetTop;
                if (offsetTop < 500) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        };
        this.hoverOnFunc = (event, n) => {
            let e = {
                evt: event,
                node: n,
                alerts: this.alerts,
                wlcCount: this.wlcCount
            };
            this.onhover.emit(e);
            // console.log(event);
            // console.log(l);
        };
        this.hoverOutFunc = (event, n) => {
            this.onout.emit(n);
            // console.log(event);
        };
        this.canShowTimeZoneAlert = () => {
            const restrictedLocationTypes = [
                'FLOOR',
                'POLYGON_ZONE',
                'GROUP',
                'AP_ZONE'
            ];
            if (this.node.data.type
                && this.node.data.type[0]
                && restrictedLocationTypes.indexOf(this.node.data.type[0]) > -1) {
                return false;
            }
            return true;
        };
    }
    set setNode(value) {
        this.node = value;
        if (this.node
            && this.node.data) {
            if (!this.node.data.inferredTimeZoneId) {
                if (this.canShowTimeZoneAlert()) {
                    if (this.alerts.indexOf('timezone') === -1) {
                        this.alerts.push('timezone');
                    }
                }
            }
            if (this.node.data.id
                && this.node.data.type
                && this.node.data.type[0] === 'WLC') {
                if (this.wlcLocationData) {
                    this.prepareWlcLocationData();
                }
            }
        }
    }
    set setWlcLocationData(value) {
        if (value) {
            this.wlcLocationData = value;
            if (this.node && this.node.data
                && this.node.data.id
                && this.node.data.type
                && this.node.data.type[0] === 'WLC') {
                this.prepareWlcLocationData();
            }
        }
    }
    ngOnInit() {
    }
}
BusinessHierarchyNodeComponent.ɵfac = function BusinessHierarchyNodeComponent_Factory(t) { return new (t || BusinessHierarchyNodeComponent)(i0.ɵɵdirectiveInject(DataService)); };
BusinessHierarchyNodeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BusinessHierarchyNodeComponent, selectors: [["business-hierarchy-node"]], viewQuery: function BusinessHierarchyNodeComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1p, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nodeRef = _t.first);
    } }, inputs: { setNode: "setNode", setWlcLocationData: "setWlcLocationData" }, outputs: { onhover: "onhover", onout: "onout" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "type"], [1, "node-name"], ["class", "locationv2-alert", 4, "ngIf"], [1, "locationv2-alert"], [1, "alert-icon", 3, "mouseover", "mouseout"], ["nodeRef", ""], ["src", "/assets/images/hierarchy-icons/yellow-alert.svg", "alt", "Alert", 1, "alert-icon"], ["class", "locationv2-tooltip", 3, "ngClass", 4, "ngIf"], [1, "locationv2-tooltip", 3, "ngClass"], ["class", "up-arrow", 4, "ngIf"], ["class", "down-arrow", 4, "ngIf"], ["class", "arrow-left", 3, "click", 4, "ngIf"], ["class", "arrow-right", 3, "click", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "up-arrow"], [1, "down-arrow"], [1, "arrow-left", 3, "click"], [1, "arrow-right", 3, "click"], [1, "lt-heading"], [1, "lt-warning"], [1, "lt-desc"]], template: function BusinessHierarchyNodeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, BusinessHierarchyNodeComponent_div_0_Template, 6, 5, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showDefaultNode && ctx.node && ctx.node.data);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i1$2.NgForOf], styles: [".node-name[_ngcontent-%COMP%]{font-size:12px;white-space:nowrap;max-width:160px;overflow:hidden;text-overflow:ellipsis;display:inline-block;vertical-align:middle}.node-template[_ngcontent-%COMP%]{white-space:nowrap}.locationv2-alert[_ngcontent-%COMP%]{display:inline-block}.alert-icon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:16px;vertical-align:middle;cursor:default}.locationv2-tooltip[_ngcontent-%COMP%]{position:absolute;bottom:100%;left:100%;width:280px;height:auto;padding:23px;background:#FFFFFF;border:1px solid #DFDFDF;box-shadow:0 4px 8px #0000001a;border-radius:2px;z-index:10}.locationv2-tooltip.bottom[_ngcontent-%COMP%]{top:100%;bottom:auto}.locationv2-tooltip[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{display:block}.locationv2-tooltip[_ngcontent-%COMP%]   .lt-heading[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:18px;line-height:28px;letter-spacing:.75px;color:#58585b;display:block}.locationv2-tooltip[_ngcontent-%COMP%]   .lt-warning[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;line-height:20px;letter-spacing:.5px;color:#f5a623;display:block}.locationv2-tooltip[_ngcontent-%COMP%]   .lt-warning[_ngcontent-%COMP%]   .alert-icon[_ngcontent-%COMP%]{width:14px;padding-left:0}.locationv2-tooltip[_ngcontent-%COMP%]   .lt-desc[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:13px;line-height:15px;letter-spacing:.464286px;color:#565659}.locationv2-tooltip[_ngcontent-%COMP%]   .lt-desc[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:10px 0 20px;white-space:pre-wrap}.alert-icon[_ngcontent-%COMP%]{width:12px;padding-left:5px}.down-arrow[_ngcontent-%COMP%]{content:\"\";position:absolute;top:100%;left:50%;margin-left:-6px;width:0;height:0;border-top:solid 6px #fff;border-left:solid 6px transparent;border-right:solid 6px transparent}.up-arrow[_ngcontent-%COMP%]{content:\"\";position:absolute;bottom:100%;left:50%;margin-left:-6px;width:0;height:0;border-bottom:solid 6px #fff;border-left:solid 6px transparent;border-right:solid 6px transparent}.arrow-left[_ngcontent-%COMP%]{position:absolute;top:40%;left:5px;font-family:\"icomoon-new\";color:#565659;font-size:14px;cursor:pointer}.arrow-right[_ngcontent-%COMP%]{position:absolute;top:40%;right:5px;font-family:\"icomoon-new\";color:#565659;font-size:14px;cursor:pointer}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BusinessHierarchyNodeComponent, [{
        type: Component,
        args: [{
                selector: 'business-hierarchy-node',
                templateUrl: './business-hierarchy-node.component.html',
                styleUrls: ['./business-hierarchy-node.component.scss']
            }]
    }], function () { return [{ type: DataService }]; }, { onhover: [{
            type: Output
        }], onout: [{
            type: Output
        }], setNode: [{
            type: Input
        }], setWlcLocationData: [{
            type: Input
        }], nodeRef: [{
            type: ViewChild,
            args: ["nodeRef", { static: true }]
        }] }); })();

const _c0$1o = ["tree"];
function BusinessHierarchyComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "tree-node-wrapper", 5);
    i0.ɵɵelement(2, "tree-node-children", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r5 = ctx.$implicit;
    const index_r6 = ctx.index;
    const templates_r7 = ctx.templates;
    i0.ɵɵclassMap(node_r5.getClass());
    i0.ɵɵclassProp("tree-node", true)("tree-node-expanded", node_r5.isExpanded && node_r5.hasChildren)("tree-node-collapsed", node_r5.isCollapsed && node_r5.hasChildren)("tree-node-leaf", node_r5.isLeaf)("tree-node-active", node_r5.isActive)("tree-node-focused", node_r5.isFocused);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("node", node_r5)("index", index_r6)("templates", templates_r7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("node", node_r5)("templates", templates_r7);
} }
function BusinessHierarchyComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "business-hierarchy-node", 7);
    i0.ɵɵlistener("onhover", function BusinessHierarchyComponent_ng_template_5_Template_business_hierarchy_node_onhover_0_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.hoverOnFunc($event); })("onout", function BusinessHierarchyComponent_ng_template_5_Template_business_hierarchy_node_onout_0_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.hoverOutFunc($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r8 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("setNode", node_r8)("setWlcLocationData", ctx_r4.wlcLocationData);
} }
class BusinessHierarchyComponent {
    constructor(dataService, authService) {
        this.dataService = dataService;
        this.authService = authService;
        this.unsubscribe$ = new Subject();
        this.propUnsubscribe$ = new Subject();
        this.deltaUnsubscribe1$ = new Subject();
        this.deltaUnsubscribe2$ = new Subject();
        this.deltaUnsubscribe3$ = new Subject();
        this.messages = [];
        this.destroyed$ = new Subject();
        this.emptyChild = [
            {
                "name": "Data Unavailable",
                "hasChildren": false
            }
        ];
        // constructor() { }
        this.treeComponent = null;
        this.activeNode = new EventEmitter();
        this.onhover = new EventEmitter();
        this.onout = new EventEmitter();
        this.nodes = [{}];
        this.wlcLocationData = [];
        this.options = {
            getChildren: this.getChildren.bind(this),
            displayField: 'name',
            isExpandedField: 'expanded',
            idField: 'id',
            actionMapping: {
                mouse: {
                //dblClick: (tree, node, $event) => {
                //  if (node.hasChildren) TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event);
                //},
                //click:(tree, node, $event) => {
                //this.logger.debug('mouse click', tree, node, $event);
                //}
                }
            },
            allowDrag: (node) => {
                return false;
            },
            allowDrop: (node) => {
                return false;
            },
            useVirtualScroll: false,
            animateExpand: false,
            animateSpeed: 10,
            animateAcceleration: 1.2,
            nodeHeight: 32,
            dropSlotHeight: 3
        };
        this.deltaAddSub = this.dataService.getLocationAddEvt(this.deltaUnsubscribe1$);
        this.deltaUpdateSub = this.dataService.getLocationUpdateEvt(this.deltaUnsubscribe2$);
        this.deltaDeleteSub = this.dataService.getLocationDeleteEvt(this.deltaUnsubscribe3$);
        this.localProperty = null;
        this.resetTree = () => {
            try {
                setTimeout(() => {
                    let rootLocationId = this.dataService.getFromStorage("rootLocationId");
                    if (rootLocationId) {
                        this.dataService.display(true);
                        let t1 = new Date().getTime();
                        console.log('Initial Data Loading Started::', t1);
                        let rootData = this.dataService.getLocationRowMapByKey(rootLocationId);
                        if (rootData
                            && rootData !== undefined) {
                            this.nodes = [rootData];
                            setTimeout(() => {
                                if (this.treeComponent && this.treeComponent.treeModel) {
                                    this.treeComponent.treeModel.update();
                                    let t2 = new Date().getTime();
                                    let timeDiff = (t2 - t1) / 1000;
                                    console.log('Initial Tree UI Loaded::', t2, timeDiff + ' seconds');
                                    this.dataService.display(false);
                                    if (rootData
                                        && (rootData['hasChildren']
                                            || (rootData['childData']
                                                && rootData['childData'].length))) {
                                        let children = [];
                                        const childData = this.getSortedNames(rootData['childData']);
                                        childData.map((locObj, i) => {
                                            let childLoc = this.dataService.getLocationRowMapByKey(locObj.id);
                                            children.push(childLoc);
                                            if (i + 1 === rootData['childData'].length) {
                                                this.prepareRootChildren(children, rootLocationId);
                                                this.prepareTree();
                                                this.dataService.display(false);
                                            }
                                        });
                                    }
                                    else {
                                        this.prepareTree();
                                        this.dataService.display(false);
                                    }
                                }
                            });
                        }
                        else {
                            this.nodes = [{}];
                        }
                    }
                    else {
                        this.nodes = [{}];
                        // this.dataService.setToastMessage("Location Hierarchy is unable to load. Root location unavailable.",
                        //       5000, null, null, 'error');
                    }
                }, 200);
            }
            catch (e) {
                this.nodes = [{}];
                console.log('Tree update failed', e);
            }
        };
        this.prepareTree = () => {
            setTimeout(() => {
                let t3 = new Date().getTime();
                console.log('Initial tree preparation started::', t3);
                // try {
                if (this.treeComponent) {
                    this.treeComponent.treeModel.roots.forEach(root => {
                        root.expand();
                    });
                    const treeModel = this.treeComponent.treeModel;
                    const firstNode = treeModel.getFirstRoot();
                    this.activeNode.emit(firstNode);
                    this.treeComponent.treeModel.roots.forEach(root => {
                        if (root.isCollapsed)
                            root.expand();
                    });
                    firstNode.setActiveAndVisible();
                    // this.activeNode = firstNode;
                }
                let t4 = new Date().getTime();
                let timeDiff = (t4 - t3) / 1000;
                console.log('Initial tree prepared with 1st level nodes expanded::', t4, timeDiff + ' seconds');
                this.treeComponent.treeModel.update();
                this.dataService.display(false);
                const selectedLocation = this.dataService.selectedLH2Location;
                if (selectedLocation) {
                    this.showPrevSelectedLocation(selectedLocation);
                }
                // } catch(e) {
                //   console.log('Error Initializing Tree::');
                // }
            }, 800);
        };
        this.selectNode = (node) => {
            // this.activeNode = node;
            if (node.hasChildren) {
            }
            else {
                let parentId = node.data.id;
                if (parentId) {
                    this.fetchChildren(node);
                }
            }
            console.log(node);
        };
        this.prepareChildren = (partialData, isLastIndex, t7) => {
            const id = partialData.parentId;
            let nodeF = this.treeComponent.treeModel.getNodeById(id);
            nodeF.data.children = partialData.children;
            if (isLastIndex) {
                let t8 = new Date().getTime();
                let timeDiff = (t8 - t7) / 1000;
                this.treeComponent.treeModel.update();
                console.log('Partial Data Tree Finished::', t8, timeDiff + ' seconds');
            }
        };
        this.prepareRootChildren = (childrenData, rootId) => {
            if (this.treeComponent && this.treeComponent.treeModel) {
                let nodeF = this.treeComponent.treeModel.getNodeById(rootId);
                if (nodeF && nodeF.data) {
                    nodeF.data.children = childrenData;
                }
            }
            // if(isLastIndex) {
            //   let t8 = new Date().getTime(); 
            //   let timeDiff = (t8-t7)/1000;
            //   this.treeComponent.treeModel.update();
            //   console.log('Partial Data Tree Finished::', t8, timeDiff + ' seconds');
            // }
        };
        this.getNodeExpanded = (node) => {
            return (node.isExpanded) && node.data.childCount;
        };
        this.fetchChildren = (node) => {
            let id = node.data.id;
            this.dataService.getLocationPartialRow(id).then(childData => {
                let children = [];
                const sortedChildData = this.getSortedNames(childData);
                sortedChildData.forEach((child, id) => {
                    children.push(child);
                });
                this.prepareRootChildren(children, id);
                this.treeComponent.treeModel.update();
                setTimeout(() => {
                    node.expand();
                });
            });
        };
        this.expandNode = (node) => {
            let nodeId = node.data.id;
            // if((!node.data.children || node.data.children.length === 0) && node.data.childCount) {
            this.dataService.getLocationPartialRow(nodeId).then(childData => {
                let children = [];
                const sortedChildData = this.getSortedNames(childData);
                sortedChildData.forEach((child, id) => {
                    children.push(child);
                });
                let nodeF = this.treeComponent.treeModel.getNodeById(nodeId);
                nodeF.data.children = children;
                node.expand();
                this.treeComponent.treeModel.update();
            });
            // }
        };
        this.collapseNode = (node) => {
            node.collapse();
        };
        this.onSelectedNode = (node) => {
            console.log("Active Node", node);
            this.activeNode.emit(node);
        };
        this.hoverOnFunc = (e) => {
            this.onhover.emit(e);
            // console.log(event);
            // console.log(l);
        };
        this.hoverOutFunc = (e) => {
            this.onout.emit(e);
            // console.log(event);
        };
        this.getProperties = () => {
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.propUnsubscribe$)
                .then((properties) => {
                this.localProperty = properties["value"];
                if (this.localProperty
                    && (this.localProperty['useVirtualScroll'] !== null
                        || this.localProperty['useVirtualScroll'] !== undefined)) {
                    this.options.useVirtualScroll = this.localProperty['useVirtualScroll'];
                }
            });
        };
        // case insensitive sorting of child data based on location names
        this.getSortedNames = (childData) => {
            const sortedChildData = childData.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
            return sortedChildData;
        };
    }
    ngOnDestroy() {
        console.log('destory manageLocations page');
        this.treeComponent = null;
        this.destroyed$.next(true);
    }
    set setSearchedLocation(value) {
        if (value) {
            if (this.treeComponent) {
                this.treeComponent.treeModel.roots.forEach(root => {
                    if (root.isCollapsed)
                        root.expand();
                });
                const nodeF = this.treeComponent.treeModel.getNodeById(value);
                if (nodeF && nodeF.data) {
                    // nodeF.focus();
                    this.treeComponent.treeModel.setActiveNode(nodeF, true);
                }
                else {
                    let nodeS = this.dataService.getLocationRowMapByKey(value);
                    if (nodeS) {
                        let lastAvailableParent = nodeS['parentId'];
                        while (!this.treeComponent.treeModel.getNodeById(lastAvailableParent)) {
                            lastAvailableParent = this.dataService.getLocationRowMapByKey(lastAvailableParent)['parentId'];
                        }
                        console.log('lastAvailableParent::', lastAvailableParent);
                        if (lastAvailableParent) {
                            // const nodeP: TreeNode = this.treeComponent.treeModel.getNodeById(lastAvailableParent);
                            // nodeP.expand();
                            if (nodeS['locationPath']) {
                                nodeS['locationPath'].map((parentId, i) => {
                                    if (i >= 0) {
                                        setTimeout(() => {
                                            let nodeE = this.treeComponent.treeModel.getNodeById(parentId);
                                            // if(nodeS['locationPath'].length - 1 === i) {
                                            //   this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                            // } else {
                                            nodeE.expand();
                                            if (nodeS['locationPath'].length - 1 === i) {
                                                setTimeout(() => {
                                                    // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                    const searchedNode = this.treeComponent.treeModel.getNodeById(nodeS['id']);
                                                    searchedNode.setIsActive(true, true);
                                                });
                                            }
                                        }, 100);
                                        // }
                                    }
                                    else {
                                        let nodeE = this.treeComponent.treeModel.getNodeById(parentId);
                                        // if(nodeS['locationPath'].length - 1 === i) {
                                        //   this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                        // } else {
                                        nodeE.expand();
                                        if (nodeS['locationPath'].length - 1 === i) {
                                            setTimeout(() => {
                                                // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                const searchedNode = this.treeComponent.treeModel.getNodeById(nodeS['id']);
                                                searchedNode.setIsActive(true, true);
                                            });
                                        }
                                        // }
                                    }
                                });
                                // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                            }
                        }
                    }
                }
            }
        }
    }
    set setWlcLocationData(value) {
        if (value) {
            this.wlcLocationData = value;
        }
    }
    ngOnInit() {
        this.getProperties();
        this.dataService.getLocLoadingStarted(this.unsubscribe$).subscribe(status => {
            if (status && this.treeComponent) {
                // this.options.useVirtualScroll = false;
                setTimeout(() => {
                    // this.options.useVirtualScroll = true;
                    this.treeComponent.sizeChanged();
                }, 100);
                let rootLocationId = this.dataService.getFromStorage("rootLocationId");
                if (rootLocationId) {
                    this.dataService.display(true);
                    let t1 = new Date().getTime();
                    console.log('Initial Data Loading Started::', t1);
                    let rootData = {};
                    rootData = this.dataService.getLocationRowMapByKey(rootLocationId);
                    if (rootData && rootData['children']) {
                        rootData['children'] = null;
                    }
                    this.nodes = [Object.assign({}, rootData)];
                    setTimeout(() => {
                        if (this.treeComponent) {
                            this.treeComponent.treeModel.update();
                            let t2 = new Date().getTime();
                            let timeDiff = (t2 - t1) / 1000;
                            console.log('Initial Tree UI Loaded::', t2, timeDiff + ' seconds');
                            // this.dataService.display(false);
                            if (rootData
                                && (rootData['hasChildren']
                                    || (rootData['childData']
                                        && rootData['childData'].length))) {
                                let children = [];
                                const childData = this.getSortedNames(rootData['childData']);
                                childData.map((locObj, i) => {
                                    let childLoc = this.dataService.getLocationRowMapByKey(locObj.id);
                                    children.push(childLoc);
                                    if (i + 1 === rootData['childData'].length) {
                                        this.prepareRootChildren(children, rootLocationId);
                                        this.prepareTree();
                                        // this.dataService.display(false);
                                    }
                                });
                            }
                            else {
                                this.prepareTree();
                                // this.dataService.display(false);
                            }
                        }
                    }, 100);
                }
                else {
                    // this.dataService.setToastMessage("Location Hierarchy is unable to load. Root location unavailable.",
                    //       5000, null, null, 'error');
                }
            }
        });
        // Event that checks for location updates
        setTimeout(() => {
            this.dataService.getLocationSetStatus(this.unsubscribe$).subscribe(parentLocId => {
                if (parentLocId && this.treeComponent && this.treeComponent.treeModel) {
                    let nodeF = this.treeComponent.treeModel.getNodeById(parentLocId);
                    if (nodeF && nodeF.data) {
                        console.log("Evnt::", parentLocId);
                        let parentLoc = this.dataService.getLocationRowMapByKey(parentLocId);
                        if (parentLoc['childData'] && parentLoc['childData'].length) {
                            let children = [];
                            const childData = this.getSortedNames(parentLoc['childData']);
                            childData.map((loc, i) => {
                                let childData = this.dataService.getLocationRowMapByKey(loc.id);
                                children.push(childData);
                                if (i + 1 === parentLoc['childData'].length) {
                                    nodeF.data.children = children;
                                    this.treeComponent.treeModel.update();
                                    const eventEnd = new Date().getTime();
                                    console.log("Location Event Called for Expanded Node::", parentLoc['name'], eventEnd);
                                    // setTimeout(() => {
                                    //   
                                    // },100)
                                    // this.prepareTree();
                                }
                            });
                        }
                    }
                }
            });
        }, 100);
        // Add Location Delta Update
        // this.deltaAddSub.subscribe(
        //   // location => {
        //   //   if(location) {
        //   //     try {
        //   //       let parentLocId = location.id;
        //   //       if(parentLocId && this.treeComponent && this.treeComponent.treeModel) {
        //   //         // this.treeComponent.treeModel.collapseAll();
        //   //         let nodeF = this.treeComponent.treeModel.getNodeById(parentLocId);
        //   //         if(nodeF && nodeF.data) {
        //   //           console.log("Add Evnt::",parentLocId)
        //   //           let children = nodeF.data.children;
        //   //           if(children) {
        //   //             children.push(location);
        //   //           } else {
        //   //             children = [location];
        //   //           }
        //   //           nodeF.data.children = children;
        //   //           setTimeout(() => {
        //   //             this.treeComponent.treeModel.update();
        //   //           }, 200)
        //   //         }
        //   //       }
        //   //     } catch(e) {
        //   //       console.log("An error occured in parsing delta update", e);
        //   //     }
        //   //   }
        //   // }
        //   location => {
        //     if(location) {
        //       this.resetTree();
        //     }
        //   }
        // )
        // Update Location Delta Update
        // this.deltaUpdateSub.subscribe(
        //   // location => {
        //   //   if(location) {
        //   //     try {
        //   //       let parentLocId = location.id;
        //   //       if(parentLocId && this.treeComponent && this.treeComponent.treeModel) {
        //   //         // this.treeComponent.treeModel.collapseAll();
        //   //         let nodeF = this.treeComponent.treeModel.getNodeById(location.id);
        //   //         if(nodeF && nodeF.data) {
        //   //           console.log("Update Evnt::",location.id)
        //   //           nodeF.data = location;
        //   //           setTimeout(() => {
        //   //             this.treeComponent.treeModel.update();
        //   //           }, 200)
        //   //         }
        //   //       }
        //   //     } catch(e) {
        //   //       console.log("An error occured in parsing delta update", e);
        //   //     }
        //   //   }
        //   // }
        //   location => {
        //     if(location) {
        //       this.resetTree();
        //     }
        //   }
        // )
        // Delete Location Delta Update
        //   this.deltaDeleteSub.subscribe(
        //     location => {
        //       if(location) {
        //         try {
        //           let parentLocId = location.parentId;
        //           if(parentLocId && this.treeComponent && this.treeComponent.treeModel) {
        //             // this.treeComponent.treeModel.collapseAll();
        //             let nodeF = this.treeComponent.treeModel.getNodeById(parentLocId);
        //             if(nodeF && nodeF.data) {
        //               if(nodeF.data.children
        //                 && nodeF.data.children.length) {
        //                 for(let i = 0; i < nodeF.data.children.length; i++) {
        //                   if(nodeF.data.children[i].id === location.id) {
        //                     nodeF.data.children.splice(i, 1);
        //                     break;
        //                   }
        //                 }
        //                 if(nodeF.data.children.length === 0)
        //                   nodeF.data.hasChildren = false;
        //                 setTimeout(() => {
        //                   this.treeComponent.treeModel.update();
        //                   this.treeComponent.treeModel.setActiveNode(nodeF, true);
        //                 }, 200)
        //               }
        //             }
        //           }
        //         } catch(e) {
        //           console.log("An error occured in parsing delta update", e);
        //         }
        //       }
        //     }
        //     // location => {
        //     //   if(location) {
        //     //     this.nodes = [{}];
        //     //     this.treeComponent.treeModel.update();
        //     //     setTimeout(() => {
        //     //       this.resetTree();
        //     //     });
        //     //   }
        //     // }
        //   )
    }
    getChildren(node) {
        return new Promise((resolve, reject) => {
            let start = new Date().getTime();
            console.log('Node expansion started::', start);
            if (node.data && node.data['childData'] && node.data['childData'].length) {
                let children = [];
                const nodeChildData = this.getSortedNames(node.data['childData']);
                nodeChildData.map((child, i) => {
                    let id = child.id;
                    let childData = this.dataService.getLocationRowMapByKey(id);
                    childData['children'] = null;
                    if (childData)
                        children.push(childData);
                    if (i + 1 === node.data['childData'].length) {
                        let end = new Date().getTime();
                        let timeDiff = (end - start) / 1000;
                        console.log('Node expansion finished::', timeDiff + ' seconds');
                        setTimeout(() => {
                            this.treeComponent.sizeChanged();
                        }, 100);
                        resolve(children);
                    }
                });
            }
        });
    }
    showPrevSelectedLocation(value) {
        if (value) {
            if (this.treeComponent) {
                this.treeComponent.treeModel.roots.forEach(root => {
                    if (root.isCollapsed)
                        root.expand();
                });
                const nodeF = this.treeComponent.treeModel.getNodeById(value);
                if (nodeF && nodeF.data) {
                    // nodeF.focus();
                    this.treeComponent.treeModel.setActiveNode(nodeF, true);
                }
                else {
                    let nodeS = this.dataService.getLocationRowMapByKey(value);
                    if (nodeS) {
                        let lastAvailableParent = nodeS['parentId'];
                        while (!this.treeComponent.treeModel.getNodeById(lastAvailableParent)) {
                            lastAvailableParent = this.dataService.getLocationRowMapByKey(lastAvailableParent)['parentId'];
                        }
                        console.log('lastAvailableParent::', lastAvailableParent);
                        if (lastAvailableParent) {
                            // const nodeP: TreeNode = this.treeComponent.treeModel.getNodeById(lastAvailableParent);
                            // nodeP.expand();
                            if (nodeS['locationPath']) {
                                nodeS['locationPath'].map((parentId, i) => {
                                    if (i >= 0) {
                                        setTimeout(() => {
                                            let nodeE = this.treeComponent.treeModel.getNodeById(parentId);
                                            // if(nodeS['locationPath'].length - 1 === i) {
                                            //   this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                            // } else {
                                            nodeE.expand();
                                            if (nodeS['locationPath'].length - 1 === i) {
                                                setTimeout(() => {
                                                    // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                    const searchedNode = this.treeComponent.treeModel.getNodeById(nodeS['id']);
                                                    searchedNode.setIsActive(true, true);
                                                });
                                            }
                                        }, 100);
                                        // }
                                    }
                                    else {
                                        let nodeE = this.treeComponent.treeModel.getNodeById(parentId);
                                        // if(nodeS['locationPath'].length - 1 === i) {
                                        //   this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                        // } else {
                                        nodeE.expand();
                                        if (nodeS['locationPath'].length - 1 === i) {
                                            setTimeout(() => {
                                                // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                const searchedNode = this.treeComponent.treeModel.getNodeById(nodeS['id']);
                                                searchedNode.setIsActive(true, true);
                                            });
                                        }
                                        // }
                                    }
                                });
                                // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                            }
                        }
                    }
                }
            }
        }
    }
}
BusinessHierarchyComponent.ɵfac = function BusinessHierarchyComponent_Factory(t) { return new (t || BusinessHierarchyComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(AuthService)); };
BusinessHierarchyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BusinessHierarchyComponent, selectors: [["business-hierarchy"]], viewQuery: function BusinessHierarchyComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1o, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.treeComponent = _t.first);
    } }, inputs: { setSearchedLocation: "setSearchedLocation", setWlcLocationData: "setWlcLocationData" }, outputs: { activeNode: "activeNode", onhover: "onhover", onout: "onout" }, decls: 7, vars: 2, consts: [[1, "lhv2"], [3, "nodes", "options", "activate"], ["tree", ""], ["treeNodeFullTemplate", ""], ["treeNodeTemplate", ""], [3, "node", "index", "templates"], [3, "node", "templates"], [3, "setNode", "setWlcLocationData", "onhover", "onout"]], template: function BusinessHierarchyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "tree-root", 1, 2);
        i0.ɵɵlistener("activate", function BusinessHierarchyComponent_Template_tree_root_activate_1_listener($event) { return ctx.onSelectedNode($event); });
        i0.ɵɵtemplate(3, BusinessHierarchyComponent_ng_template_3_Template, 3, 19, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, BusinessHierarchyComponent_ng_template_5_Template, 1, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("nodes", ctx.nodes)("options", ctx.options);
    } }, directives: [i4.TreeComponent, i4.TreeNodeWrapperComponent, i4.TreeNodeChildrenComponent, BusinessHierarchyNodeComponent], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BusinessHierarchyComponent, [{
        type: Component,
        args: [{
                selector: 'business-hierarchy',
                templateUrl: './business-hierarchy.component.html',
                styleUrls: ['./business-hierarchy.component.scss']
            }]
    }], function () { return [{ type: DataService }, { type: AuthService }]; }, { treeComponent: [{
            type: ViewChild,
            args: ['tree', { static: true }]
        }], activeNode: [{
            type: Output
        }], onhover: [{
            type: Output
        }], onout: [{
            type: Output
        }], setSearchedLocation: [{
            type: Input
        }], setWlcLocationData: [{
            type: Input
        }] }); })();

function ChangePasswordComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵlistener("click", function ChangePasswordComponent_span_5_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.changePasswordClose(); });
    i0.ɵɵtext(1, "\uE909");
    i0.ɵɵelementEnd();
} }
function ChangePasswordComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "label", 23);
    i0.ɵɵtext(2, " Your password has expired. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 24);
    i0.ɵɵtext(4, " You must change your password to login to Cisco Spaces. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ChangePasswordComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.changePasswordError, " ");
} }
function ChangePasswordComponent_img_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 26);
} }
function ChangePasswordComponent_img_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 27);
} }
function ChangePasswordComponent_img_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 26);
} }
function ChangePasswordComponent_img_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 27);
} }
function ChangePasswordComponent_img_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 26);
} }
function ChangePasswordComponent_img_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 27);
} }
function ChangePasswordComponent_img_47_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 26);
} }
function ChangePasswordComponent_img_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 27);
} }
function ChangePasswordComponent_img_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 26);
} }
function ChangePasswordComponent_img_54_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 27);
} }
function ChangePasswordComponent_button_60_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function ChangePasswordComponent_button_60_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.changePasswordClose(); });
    i0.ɵɵtext(1, " Cancel ");
    i0.ɵɵelementEnd();
} }
const _c0$1n = function (a0, a1) { return { changePassCriteriaFailure: a0, changePassCriteriaSuccess: a1 }; };
class ChangePasswordComponent {
    constructor(logger, activatedRoute, dataService, router, authService, interactionService) {
        this.logger = logger;
        this.activatedRoute = activatedRoute;
        this.dataService = dataService;
        this.router = router;
        this.authService = authService;
        this.interactionService = interactionService;
        this.unsubscribe$ = new Subject();
        this.onHideChangePassword = new EventEmitter();
        this.changePasswordError = "";
        this.user = {
            email: "",
            currPassword: "",
            newPassword: "",
            confirmPassword: "",
            hasLength: false,
            hasUpperCase: false,
            hasLowerCase: false,
            hasNumbers: false,
            hasSymbols: false,
            exceptColon: false
        };
        this.viaEmail = false;
        this.userEmail = "";
        this.expiryDetails = {};
        this.changePasswordClose = () => {
            this.onHideChangePassword.emit(false);
            const logStr = "CLOSE: User " + this.user.email + " has closed change password";
            this.interactionService.doInteractionLog(new InteractionLog(TYPE.CLOSE, this.dataService.getPosition(), "{}", SECTION.CHANGE_PASSWORD, ITEM_TYPE.POPUP, ITEM.CHANGE_PASSWORD, logStr, "/changePassword"));
        };
        this.changePassword = () => {
            if (this.validChangePassForm()) {
                this.dataService.display(true);
                this.authService
                    .changePassword(this.user)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((data) => {
                    if (data.status) {
                        this.changePasswordError = "";
                        const logStr = "UPDATE: User " +
                            this.user.email +
                            " has changed password";
                        this.interactionService.doInteractionLog(new InteractionLog(TYPE.UPDATE, this.dataService.getPosition(), "{}", SECTION.CHANGE_PASSWORD, ITEM_TYPE.POPUP, ITEM.CHANGE_PASSWORD, logStr, "/changePassword"));
                        if (this.expiryDetails.expired ||
                            this.expiryDetails.isNotification)
                            this.dataService.setToastMessage(data.message + ", Please login again", 4000, null, null, "success");
                        else
                            this.dataService.setToastMessage(data.message, 4000, null, null, "success");
                        setTimeout(() => {
                            this.dataService.display(false);
                            this.changePasswordClose();
                        }, 4000);
                    }
                    else {
                        this.dataService.display(false);
                        this.changePasswordError = data.message;
                        this.dataService.setToastMessage(data.message, 4000, null, null, "error");
                        const logStr = "ERROR: While changing password by user " +
                            this.user.email;
                        this.interactionService.doInteractionLog(new InteractionLog(TYPE.ERROR, this.dataService.getPosition(), "{}", SECTION.CHANGE_PASSWORD, ITEM_TYPE.POPUP, ITEM.CHANGE_PASSWORD, logStr, "/changePassword"));
                    }
                }, (error) => {
                    this.changePasswordError =
                        "An error occurred. Please try again.";
                    console.log("Forgot password link error", error.status);
                    this.dataService.display(false);
                });
            }
        };
        this.checkPasswordCriteria = () => {
            if (this.user.newPassword.length < 8) {
                this.user.hasLength = false;
            }
            else {
                this.user.hasLength = true;
            }
            const hasUpperCaseRegx = /[A-Z]/;
            if (!hasUpperCaseRegx.test(this.user.newPassword)) {
                this.user.hasUpperCase = false;
            }
            else {
                this.user.hasUpperCase = true;
            }
            const hasLowerCaseRegx = /[a-z]/;
            if (!hasLowerCaseRegx.test(this.user.newPassword)) {
                this.user.hasLowerCase = false;
            }
            else {
                this.user.hasLowerCase = true;
            }
            const hasNumbersRegx = /\d/;
            if (!hasNumbersRegx.test(this.user.newPassword)) {
                this.user.hasNumbers = false;
            }
            else {
                this.user.hasNumbers = true;
            }
            // change regex to add, underscore with existing special characters
            let hasNonalphasRegx = /[\W_]+/;
            if (!hasNonalphasRegx.test(this.user.newPassword)) {
                this.user.hasSymbols = false;
            }
            else {
                this.user.hasSymbols = true;
            }
            // except colon symbol check
            if (this.user.hasSymbols) {
                if (this.user.newPassword.indexOf(":") == -1) {
                    this.user.exceptColon = true;
                    this.user.hasSymbols = true;
                }
                else {
                    console.log("password has colon symbol. please remove colon(:) and try again");
                    this.user.exceptColon = false;
                    this.user.hasSymbols = false;
                }
            }
        };
        this.validChangePassForm = () => {
            if (this.user.email === "") {
                this.changePasswordError = "User email unavailable";
                this.dataService.setToastMessage(this.changePasswordError, 4000, null, null, "error");
                return false;
            }
            if (this.user.currPassword === "") {
                this.changePasswordError = "Please enter current password";
                this.dataService.setToastMessage(this.changePasswordError, 4000, null, null, "error");
                return false;
            }
            if (this.user.newPassword === "") {
                this.changePasswordError = "Please enter new password";
                this.dataService.setToastMessage(this.changePasswordError, 4000, null, null, "error");
                return false;
            }
            if (this.user.confirmPassword === "") {
                this.changePasswordError = "Please enter confirm password";
                this.dataService.setToastMessage(this.changePasswordError, 4000, null, null, "error");
                return false;
            }
            if (this.user.newPassword !== this.user.confirmPassword) {
                this.changePasswordError =
                    "Please ensure new and confirm passwords match";
                this.dataService.setToastMessage(this.changePasswordError, 4000, null, null, "error");
                return false;
            }
            if (this.user.hasLength &&
                this.user.hasUpperCase &&
                this.user.hasLowerCase &&
                this.user.hasNumbers &&
                this.user.hasSymbols &&
                this.user.exceptColon) {
                return true;
            }
            else {
                this.changePasswordError =
                    "The password you entered doesn't meet password policy requirements";
                this.dataService.setToastMessage(this.changePasswordError, 4000, null, null, "error");
                return false;
            }
        };
    }
    ngOnInit() {
        console.log("change password check");
        this.dataService.display(false);
        this.user.email = this.getUserEmail()
            ? this.getUserEmail()
            : this.userName;
        this.expiryDetails = this.expirydData;
        if (this.expiryDetails == null ||
            (this.expiryDetails != null && this.expiryDetails.expired == null)) {
            if (this.expiryDetails == undefined) {
                this.expiryDetails = {};
            }
            this.expiryDetails.expired = false;
        }
        const logStr = "VIEW: User " + this.user.email + " has viewed change password";
        this.interactionService.doInteractionLog(new InteractionLog(TYPE.VIEW, this.dataService.getPosition(), "{}", SECTION.CHANGE_PASSWORD, ITEM_TYPE.POPUP, ITEM.CHANGE_PASSWORD, logStr, "/changePassword"));
    }
    getUserEmail() {
        this.userEmail = this.dataService.getUserName();
        return this.userEmail;
    }
    ngOnDestroy() {
        console.log("destory change Password page");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
ChangePasswordComponent.ɵfac = function ChangePasswordComponent_Factory(t) { return new (t || ChangePasswordComponent)(i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(InteractionService)); };
ChangePasswordComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChangePasswordComponent, selectors: [["lib-change-password"]], inputs: { expirydData: "expirydData", userName: "userName", viaEmail: "viaEmail" }, outputs: { onHideChangePassword: "onHideChangePassword" }, decls: 61, vars: 37, consts: [[1, "modalPopup", "modalPopupSm", "changePasswordPopup"], [1, "modalOverlay"], [1, "modalContent"], [1, "modalHeader"], ["class", "modalCloseIcon", 3, "click", 4, "ngIf"], ["class", "passwordExpiry", 4, "ngIf"], [1, "modalBody"], [1, "changePassFormParentGroup"], ["class", "formInlineError", 4, "ngIf"], [1, "changePassFormGroup"], [1, "changePassFormLabel"], ["type", "password", "name", "password", "placeholder", "Current Password", 1, "formControl", 3, "value", "input"], ["type", "password", "name", "password", "placeholder", "New Password", 1, "formControl", 3, "value", "input", "keyup"], ["type", "password", "name", "password", "placeholder", "Confirm Password", 1, "formControl", 3, "value", "input"], [1, "changePassCriteria"], [3, "ngClass"], ["src", "assets/cisco/assets/images/desktop/tick_authenticated.svg", "width", "15", 4, "ngIf"], ["src", "assets/cisco/assets/images/desktop/close_error.svg", "width", "15", 4, "ngIf"], [1, "modalFooter"], [1, "primaryButton", 3, "click"], ["class", "commonButton", 3, "click", 4, "ngIf"], [1, "modalCloseIcon", 3, "click"], [1, "passwordExpiry"], [1, "passwordExpired"], [1, "passwordExpiredSub"], [1, "formInlineError"], ["src", "assets/cisco/assets/images/desktop/tick_authenticated.svg", "width", "15"], ["src", "assets/cisco/assets/images/desktop/close_error.svg", "width", "15"], [1, "commonButton", 3, "click"]], template: function ChangePasswordComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4, " Change Password ");
        i0.ɵɵtemplate(5, ChangePasswordComponent_span_5_Template, 2, 0, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, ChangePasswordComponent_div_6_Template, 5, 0, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵtemplate(9, ChangePasswordComponent_div_9_Template, 2, 1, "div", 8);
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵelementStart(11, "label", 10);
        i0.ɵɵtext(12, "CURRENT PASSWORD");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "input", 11);
        i0.ɵɵlistener("input", function ChangePasswordComponent_Template_input_input_13_listener($event) { return ctx.user.currPassword = $event.target ? $event.target["value"] : ""; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 9);
        i0.ɵɵelementStart(15, "label", 10);
        i0.ɵɵtext(16, "NEW PASSWORD");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "input", 12);
        i0.ɵɵlistener("input", function ChangePasswordComponent_Template_input_input_17_listener($event) { return ctx.user.newPassword = $event.target ? $event.target["value"] : ""; })("keyup", function ChangePasswordComponent_Template_input_keyup_17_listener() { return ctx.checkPasswordCriteria(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 9);
        i0.ɵɵelementStart(19, "label", 10);
        i0.ɵɵtext(20, "CONFIRM PASSWORD");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "input", 13);
        i0.ɵɵlistener("input", function ChangePasswordComponent_Template_input_input_21_listener($event) { return ctx.user.confirmPassword = $event.target ? $event.target["value"] : ""; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div");
        i0.ɵɵelementStart(23, "div", 14);
        i0.ɵɵelementStart(24, "div");
        i0.ɵɵtext(25, "Your password must have");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "ul");
        i0.ɵɵelementStart(27, "li");
        i0.ɵɵelementStart(28, "div", 15);
        i0.ɵɵtemplate(29, ChangePasswordComponent_img_29_Template, 1, 0, "img", 16);
        i0.ɵɵtemplate(30, ChangePasswordComponent_img_30_Template, 1, 0, "img", 17);
        i0.ɵɵelementStart(31, "span");
        i0.ɵɵtext(32, "At least 8 characters");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "li");
        i0.ɵɵelementStart(34, "div", 15);
        i0.ɵɵtemplate(35, ChangePasswordComponent_img_35_Template, 1, 0, "img", 16);
        i0.ɵɵtemplate(36, ChangePasswordComponent_img_36_Template, 1, 0, "img", 17);
        i0.ɵɵelementStart(37, "span");
        i0.ɵɵtext(38, "At least 1 upper case letter (A\u2026Z)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "li");
        i0.ɵɵelementStart(40, "div", 15);
        i0.ɵɵtemplate(41, ChangePasswordComponent_img_41_Template, 1, 0, "img", 16);
        i0.ɵɵtemplate(42, ChangePasswordComponent_img_42_Template, 1, 0, "img", 17);
        i0.ɵɵelementStart(43, "span");
        i0.ɵɵtext(44, "At least 1 lower case letter (A\u2026Z)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "li");
        i0.ɵɵelementStart(46, "div", 15);
        i0.ɵɵtemplate(47, ChangePasswordComponent_img_47_Template, 1, 0, "img", 16);
        i0.ɵɵtemplate(48, ChangePasswordComponent_img_48_Template, 1, 0, "img", 17);
        i0.ɵɵelementStart(49, "span");
        i0.ɵɵtext(50, "At least 1 special character (except colon[:] symbol)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(51, "li");
        i0.ɵɵelementStart(52, "div", 15);
        i0.ɵɵtemplate(53, ChangePasswordComponent_img_53_Template, 1, 0, "img", 16);
        i0.ɵɵtemplate(54, ChangePasswordComponent_img_54_Template, 1, 0, "img", 17);
        i0.ɵɵelementStart(55, "span");
        i0.ɵɵtext(56, "At least 1 number (0\u20269)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(57, "div", 18);
        i0.ɵɵelementStart(58, "button", 19);
        i0.ɵɵlistener("click", function ChangePasswordComponent_Template_button_click_58_listener() { return ctx.changePassword(); });
        i0.ɵɵtext(59, " Change Password ");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(60, ChangePasswordComponent_button_60_Template, 2, 0, "button", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", !ctx.expiryDetails.expired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.expiryDetails.expired && !ctx.viaEmail);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.changePasswordError.length > 0);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("value", ctx.user.currPassword);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("value", ctx.user.newPassword);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("value", ctx.user.confirmPassword);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(22, _c0$1n, !ctx.user.hasLength, ctx.user.hasLength));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.user.hasLength);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.user.hasLength);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(25, _c0$1n, !ctx.user.hasUpperCase, ctx.user.hasUpperCase));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.user.hasUpperCase);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.user.hasUpperCase);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(28, _c0$1n, !ctx.user.hasLowerCase, ctx.user.hasLowerCase));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.user.hasLowerCase);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.user.hasLowerCase);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(31, _c0$1n, !ctx.user.hasSymbols, ctx.user.hasSymbols));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.user.hasSymbols);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.user.hasSymbols);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(34, _c0$1n, !ctx.user.hasNumbers, ctx.user.hasNumbers));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.user.hasNumbers);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.user.hasNumbers);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", !ctx.expiryDetails.expired);
    } }, directives: [i1$2.NgIf, i1$2.NgClass], styles: [".modalPopup.changePasswordPopup[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{top:20%;width:60%}.modalPopup.changePasswordPopup[_ngcontent-%COMP%] > div.modalContent[_ngcontent-%COMP%] > div.modalBody[_ngcontent-%COMP%]{display:flex;height:360px}.changePassFormParentGroup[_ngcontent-%COMP%]{min-width:360px}.changePassCriteria[_ngcontent-%COMP%]{border:1px solid #e5e5e5;background-color:#f1f4f9;margin:20px;padding:20px;min-width:360px}.changePassCriteria[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding-left:0}.changePassFormLabel[_ngcontent-%COMP%]{text-transform:uppercase;font-size:12px!important;color:#969798;padding-bottom:5px;line-height:1.42857143;font-family:\"ciscoSansLight\";display:block}.changePassFormGroup[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{max-width:280px}.changePassCriteriaSuccess[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#32a205}.changePassCriteriaSuccess[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin:0 5px}.changePassCriteriaFailure[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:red}.changePassCriteriaFailure[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin:0 5px}label.passwordExpired[_ngcontent-%COMP%]{display:block;font-size:22px;font-weight:700;font-family:\"ciscoSansLight\";color:#00090d}label.passwordExpiredSub[_ngcontent-%COMP%]{font-size:14px;width:80%;display:inline-block;font-family:\"ciscoSansRegular\";color:#5f5f5f}.passwordExpiry[_ngcontent-%COMP%]{margin:1%;text-align:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChangePasswordComponent, [{
        type: Component,
        args: [{
                selector: "lib-change-password",
                templateUrl: "./change-password.component.html",
                styleUrls: ["./change-password.component.css"]
            }]
    }], function () { return [{ type: LoggerService }, { type: i1.ActivatedRoute }, { type: DataService }, { type: i1.Router }, { type: AuthService }, { type: InteractionService }]; }, { onHideChangePassword: [{
            type: Output
        }], expirydData: [{
            type: Input
        }], userName: [{
            type: Input
        }], viaEmail: [{
            type: Input
        }] }); })();

function CircularLoaderComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 8);
    i0.ɵɵelementStart(10, "button", 9);
    i0.ɵɵlistener("click", function CircularLoaderComponent_div_4_Template_button_click_10_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.reloadPage($event); });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "button", 10);
    i0.ɵɵlistener("click", function CircularLoaderComponent_div_4_Template_button_click_13_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.closeLoader($event); });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "button", 11);
    i0.ɵɵlistener("click", function CircularLoaderComponent_div_4_Template_button_click_16_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.navigateToHome($event); });
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, "shared-lib.circular-loader.page-load-delay.header"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 7, "shared-lib.circular-loader.page-load-delay.body"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 9, "shared-lib.circular-loader.page-load-delay.reload"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 11, "shared-lib.circular-loader.page-load-delay.close-loader"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 13, "shared-lib.circular-loader.page-load-delay.navigate-home"), " ");
} }
class CircularLoaderComponent {
    constructor(dataService, router) {
        this.dataService = dataService;
        this.router = router;
        this.unsubscribe$ = new Subject();
        this.showCloseMessage = false;
        this.getDelay = (delay) => {
            if (this.dataService.getDashboardProperties()) {
                const delayConfiguredString = this.dataService.getDashboardProperties()["loaderMessageDelay"] || "5000|diverse";
                const delayConfiguredValues = delayConfiguredString.split("|");
                const force = delayConfiguredValues.length > 1
                    ? delayConfiguredValues[1]
                    : "diverse";
                const delayConfigured = Number(delayConfiguredValues[0]);
                if (delay <= 0 || force) {
                    delay = delayConfigured * 1000;
                }
            }
            return delay;
        };
        this.initVariables = () => {
            this.timer = new Date().getTime();
            this.showCloseMessage = false;
            if (this.setTimeoutObj)
                clearTimeout(this.setTimeoutObj);
            // console.log("initVariables :: ", this.setTimeoutObj);
        };
        this.closeLoader = ($event) => {
            this.dataService.display(false);
        };
        this.reloadPage = ($event) => {
            window.location.reload();
        };
        this.navigateToHome = ($event) => {
            this.dataService.setCurrentNav("/base");
            this.router.navigate(["/base"]);
            window.location.pathname = "/base";
        };
        console.log("CircularLoaderComponent::constructor");
        this.initVariables();
    }
    ngOnInit() {
        this.initVariables();
        this.dataService
            .getStatus(this.unsubscribe$)
            .pipe(tap((v) => console.log("CircularLoaderComponent::ngOnInit::getStatus", v)))
            .subscribe((val) => {
            // console.log("value inside circular loader", val);
            if (val && val.display) {
                this.setTimeoutObj = setTimeout(() => {
                    // console.log(
                    // 	"showCloseMessage circular loader when loader is loading?",
                    // 	val,
                    // 	" this.showCloseMessage:: ",
                    // 	this.showCloseMessage
                    // );
                    this.showCloseMessage = true;
                }, this.getDelay(val.delay));
                // console.log(
                // 	"value of this.setTimeoutObj inside circular loader",
                // 	this.setTimeoutObj
                // );
            }
            else {
                this.initVariables();
            }
        });
    }
    ngOnDestroy() {
        this.initVariables();
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        console.log("destory CircularLoaderComponent");
        if (this.timer)
            this.timer = null;
    }
}
CircularLoaderComponent.ɵfac = function CircularLoaderComponent_Factory(t) { return new (t || CircularLoaderComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i1.Router)); };
CircularLoaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CircularLoaderComponent, selectors: [["app-circular-loader"]], decls: 5, vars: 1, consts: [[1, "loader-container"], [1, "loader"], ["class", "modalPopup", 4, "ngIf"], [1, "modalPopup"], [1, "modalContent", "messageContent"], [1, "modalHeader"], [1, "modalBody"], [1, "messageBody"], [1, "modalFooter"], [1, "squareButtonPrimary", "modalPrimaryButton", 3, "click"], [1, "commonButton", 3, "click"], [1, "modalSecondaryButton", 3, "click"]], template: function CircularLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "div");
        i0.ɵɵelement(3, "div");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, CircularLoaderComponent_div_4_Template, 19, 15, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.showCloseMessage);
    } }, directives: [i1$2.NgIf], pipes: [i2.TranslatePipe], styles: [".loader-container[_ngcontent-%COMP%]{position:fixed;top:0;left:0;background:rgba(0,0,0,.45);height:100vh;width:100vw;overflow:hidden;z-index:100001}.messageBody[_ngcontent-%COMP%]{height:85px}.messageContent[_ngcontent-%COMP%]{bottom:5px;top:auto}.display-message[_ngcontent-%COMP%]{color:#fff;position:relative;width:75px;height:75px;top:45%;left:47%}.loader[_ngcontent-%COMP%]{position:relative;width:75px;height:75px;top:45%;left:47%}.loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{position:absolute;border:4px solid #fff;opacity:1;border-radius:50%;animation:lds-ripple 1s cubic-bezier(0,.2,.8,1) infinite}.loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(2){animation-delay:-.5s}@keyframes lds-ripple{0%{top:38px;left:38px;width:0;height:0;opacity:1}to{top:-1px;left:-1px;width:75px;height:75px;opacity:0}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CircularLoaderComponent, [{
        type: Component,
        args: [{
                selector: "app-circular-loader",
                templateUrl: "./circular-loader.component.html",
                styleUrls: ["./circular-loader.component.css"]
            }]
    }], function () { return [{ type: DataService }, { type: i1.Router }]; }, null); })();

class CmxOnpremService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getCMXOnPremConnectors = () => {
            const getCMXOnPremConnectorsUrl = this.apiConfig.getCMXOnPremConnectorsUrl();
            return this.get(getCMXOnPremConnectorsUrl).pipe(map(this.extractResponseData));
        };
        this.addCMXOnPremConnector = (cmxOnPremConnector) => {
            const serverUrl = this.apiConfig.getCMXOnPremConnectorsUrl();
            return this.post(serverUrl, cmxOnPremConnector).pipe(map(this.extractResponse));
        };
        this.editCMXOnPremConnector = (cmxOnPremConnector) => {
            const id = cmxOnPremConnector.id;
            const serverUrl = this.apiConfig.getCMXOnPremConnectorsUrl() + "/" + id;
            return this.put(serverUrl, cmxOnPremConnector).pipe(map(this.extractResponse));
        };
        this.deleteCMXConnector = (cmxOnPremConnector) => {
            const id = cmxOnPremConnector.id;
            const serverUrl = this.apiConfig.getCMXOnPremConnectorsUrl() + "/" + id;
            return this.delete(serverUrl, cmxOnPremConnector).pipe(map(this.extractResponse));
        };
        this.getAccessToken = (obj, url) => {
            console.log("=============url===========", url);
            const serverUrl = this.apiConfig.getOnPremTokenUrl() + url;
            return this.post(serverUrl, obj).pipe(map(this.extractResponse));
        };
    }
}
CmxOnpremService.ɵfac = function CmxOnpremService_Factory(t) { return new (t || CmxOnpremService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
CmxOnpremService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CmxOnpremService, factory: CmxOnpremService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmxOnpremService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

const _c0$1m = function (a0, a1) { return { "active": a0, "disabled": a1 }; };
function PaginationComponent_div_0_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function PaginationComponent_div_0_button_8_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const pageNum_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return ctx_r3.onPage(pageNum_r2); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const pageNum_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0$1m, pageNum_r2 === ctx_r1.page, ctx_r1.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", pageNum_r2, " ");
} }
const _c1$y = function (a0) { return { "disabled": a0 }; };
function PaginationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "button", 3);
    i0.ɵɵlistener("click", function PaginationComponent_div_0_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.showFirst(); });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 3);
    i0.ɵɵlistener("click", function PaginationComponent_div_0_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.onPrev(); });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, PaginationComponent_div_0_button_8_Template, 2, 5, "button", 4);
    i0.ɵɵelementStart(9, "button", 3);
    i0.ɵɵlistener("click", function PaginationComponent_div_0_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r6); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.onNext(); });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 3);
    i0.ɵɵlistener("click", function PaginationComponent_div_0_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r6); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.showLast(); });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 5);
    i0.ɵɵelementStart(16, "span", 6);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "span", 7);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.page === 1 || ctx_r0.loading)("ngClass", i0.ɵɵpureFunction1(31, _c1$y, ctx_r0.page === 1 || ctx_r0.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 19, "dashboard-lib.setup.pagination.first"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.page === 1 || ctx_r0.loading)("ngClass", i0.ɵɵpureFunction1(33, _c1$y, ctx_r0.page === 1 || ctx_r0.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 21, "dashboard-lib.setup.pagination.prev"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.getPages());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r0.lastPage() || ctx_r0.loading)("ngClass", i0.ɵɵpureFunction1(35, _c1$y, ctx_r0.lastPage() || ctx_r0.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 23, "dashboard-lib.setup.pagination.next"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.lastPage() || ctx_r0.loading)("ngClass", i0.ɵɵpureFunction1(37, _c1$y, ctx_r0.lastPage() || ctx_r0.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 25, "dashboard-lib.setup.pagination.last"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate4("(", ctx_r0.getMin(), " - ", ctx_r0.getMax(), " ", i0.ɵɵpipeBind1(18, 27, "dashboard-lib.setup.pagination.of"), " ", ctx_r0.totalItems.length, ")");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" : ", ctx_r0.totalPages(), " ", i0.ɵɵpipeBind1(21, 29, "dashboard-lib.setup.pagination.pages"), "");
} }
class PaginationComponent {
    constructor(translate, dataService) {
        this.translate = translate;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.page = 1;
        this.perPage = 18;
        // @Output() goPrev = new EventEmitter<boolean>();
        // @Output() goNext = new EventEmitter<boolean>();
        this.clickEvent = new EventEmitter();
        this.currentPage = new EventEmitter();
        this.messageKeys = {};
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.setup.pagination.first').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.pagination.first"] = res;
            });
            this.translate.get('dashboard-lib.setup.pagination.next').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.pagination.next"] = res;
            });
            this.translate.get('dashboard-lib.setup.pagination.last').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.pagination.last"] = res;
            });
            this.translate.get('dashboard-lib.setup.pagination.prev').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.pagination.prev"] = res;
            });
        };
        this.showLast = () => {
            this.onPage(this.totalPages());
            this.clickEvent.emit({ event: "showLast", page: this.page });
        };
        this.showFirst = () => {
            this.onPage(1);
            this.clickEvent.emit({ event: "showFirst", page: this.page });
        };
        this.calculate = () => {
            this.currentPageItems();
        };
        this.currentPageItems = () => {
            const currentPageI = [];
            if (this.totalItems != null)
                for (let i = this.getMin() - 1, max = this.getMax(); i < max; i++) {
                    if (this.totalItems[i]) {
                        currentPageI.push(this.totalItems[i]);
                    }
                }
            // console.log('currentPageI  items', currentPageI);
            this.currentPage.emit(currentPageI);
        };
    }
    set items(items) {
        this.totalItems = items;
        this.page = 1;
        this.calculate();
    }
    ngOnInit() {
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
    }
    getMin() {
        return this.perPage * this.page - this.perPage + 1;
    }
    totalPages() {
        return Math.ceil(this.totalItems.length / this.perPage) || 0;
    }
    lastPage() {
        return this.perPage * this.page >= this.totalItems.length;
    }
    getMax() {
        let max = this.perPage * this.page;
        if (this.totalItems != null && max > this.totalItems.length) {
            max = this.totalItems.length;
        }
        return max;
    }
    getPages() {
        const c = Math.ceil(this.totalItems.length / this.perPage);
        const p = this.page || 1;
        const pagesToShow = this.pagesToShow || 9;
        const pages = [];
        pages.push(p);
        const times = pagesToShow - 1;
        for (let i = 0; i < times; i++) {
            if (pages.length < pagesToShow) {
                if (Math.min.apply(null, pages) > 1) {
                    pages.push(Math.min.apply(null, pages) - 1);
                }
            }
            if (pages.length < pagesToShow) {
                if (Math.max.apply(null, pages) < c) {
                    pages.push(Math.max.apply(null, pages) + 1);
                }
            }
        }
        pages.sort((a, b) => a - b);
        return pages;
    }
    onPrev() {
        // this.goPrev.emit(true);
        if (this.page !== 1) {
            this.onPage(this.page - 1);
            this.clickEvent.emit({ event: "onPrev", page: this.page });
        }
    }
    onNext() {
        // this.goNext.emit(next);
        if (this.page !== this.totalPages()) {
            this.onPage(this.page + 1);
            this.clickEvent.emit({ event: "onNext", page: this.page });
        }
    }
    onPage(n) {
        this.page = n;
        this.calculate();
        this.clickEvent.emit({ event: "onPage", page: this.page });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
PaginationComponent.ɵfac = function PaginationComponent_Factory(t) { return new (t || PaginationComponent)(i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(DataService)); };
PaginationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaginationComponent, selectors: [["lib-pagination"]], inputs: { page: "page", perPage: "perPage", items: "items", pagesToShow: "pagesToShow", loading: "loading" }, outputs: { clickEvent: "clickEvent", currentPage: "currentPage" }, decls: 1, vars: 1, consts: [["class", "pagination", 4, "ngIf"], [1, "pagination"], [1, "numbers"], [1, "link", 3, "disabled", "ngClass", "click"], ["class", "numericButton", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "description"], [1, "page-counts"], [1, "page-totals"], [1, "numericButton", 3, "ngClass", "click"]], template: function PaginationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PaginationComponent_div_0_Template, 22, 39, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.totalItems && ctx.totalItems.length > 0);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i1$2.NgForOf], pipes: [i2.TranslatePipe], styles: [".pagination[_ngcontent-%COMP%]{margin:15px 0}.description[_ngcontent-%COMP%]{color:#58585b;font-size:12px;float:right;clear:right;margin:5px 0;font-family:ciscoSans}.page-counts[_ngcontent-%COMP%]{font-weight:bold}.numbers[_ngcontent-%COMP%]{background-color:#fff;border:0;border-radius:1.3em;box-shadow:0 0 2px #00000080;width:auto;display:inline-block}.numbers[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{margin:6px 0;border:0;background-color:transparent;display:inline-block;height:100%;padding:0 4px 0 10px;outline:none;color:#4d4d4d;font-size:12px}.numbers[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]:last-child{padding-right:10px}.numbers[_ngcontent-%COMP%] > button.disabled[_ngcontent-%COMP%]{color:#ccc;cursor:not-allowed}.numbers[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]:not(:first-child){border-left:1px solid #dddfe2}.numbers[_ngcontent-%COMP%] > button.numericButton[_ngcontent-%COMP%]{padding:0 10px;color:#049fd9}.numbers[_ngcontent-%COMP%] > button.numericButton.active[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;margin:0;padding-top:6px;padding-bottom:6px;border:0;cursor:default}.numbers[_ngcontent-%COMP%] > button.numericButton.active[_ngcontent-%COMP%] + button[_ngcontent-%COMP%]{border-left:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationComponent, [{
        type: Component,
        args: [{
                selector: "lib-pagination",
                templateUrl: "./pagination.component.html",
                styleUrls: ["./pagination.component.css"]
            }]
    }], function () { return [{ type: i2.TranslateService }, { type: DataService }]; }, { page: [{
            type: Input
        }], perPage: [{
            type: Input
        }], items: [{
            type: Input
        }], pagesToShow: [{
            type: Input
        }], loading: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], currentPage: [{
            type: Output
        }] }); })();

function TokenGenerationComponent_div_0_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.accessCodeValue, " ");
} }
function TokenGenerationComponent_div_0_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function TokenGenerationComponent_div_0_button_15_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(2); return ctx_r3.copyAccessToken(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cbContent", ctx_r2.accessCodeValue);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.setup.tokenGeneration.copyTokenv2"), " ");
} }
function TokenGenerationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 4);
    i0.ɵɵlistener("click", function TokenGenerationComponent_div_0_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.hidePopup(); });
    i0.ɵɵtext(6, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 5);
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 6);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, TokenGenerationComponent_div_0_div_13_Template, 3, 1, "div", 7);
    i0.ɵɵelementStart(14, "div", 8);
    i0.ɵɵtemplate(15, TokenGenerationComponent_div_0_button_15_Template, 3, 4, "button", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.title);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(10, 5, "dashboard-lib.setup.tokenGeneration.tokenv1"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.accessTokenError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showAccessCodeString === true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showAccessCodeString === true);
} }
class TokenGenerationComponent {
    constructor(cmxOnPremService, dataService, translate) {
        this.cmxOnPremService = cmxOnPremService;
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.accessTokenFlag = false;
        this.id = "";
        this.url = "";
        this.idParam = "";
        this.hideAccessToken = new EventEmitter();
        this.accessTokenError = "";
        this.accessCodeValue = "";
        this.showAccessCodeString = false;
        this.messageKeys = {};
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.setup.tokenGeneration.tokenv1').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.tokenGeneration.tokenv1"] = res;
            });
            this.translate.get('dashboard-lib.setup.tokenGeneration.copyTokenv2').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.tokenGeneration.copyTokenv2"] = res;
            });
            this.translate.get('dashboard-lib.setup.tokenGeneration.errorMessage').subscribe((res) => {
                this.messageKeys["errorMessage"] = res;
            });
        };
        this.hidePopup = () => {
            this.showAccessCodeString = false;
            this.accessCodeValue = "";
            this.hideAccessToken.emit();
        };
        this.getAccessTokenWithoutCredentials = () => {
            this.dataService.display(true);
            const obj = { [this.idParam]: this.id };
            this.cmxOnPremService
                .getAccessToken(obj, this.url)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.data) {
                    this.accessCodeValue =
                        response.data.token || response.data;
                    this.showAccessCodeString = true;
                    this.dataService.display(false);
                }
                else {
                    this.dataService.setToastMessage(response.message, 4000, null, null, "error");
                    this.dataService.display(false);
                    this.hidePopup();
                }
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["errorMessage"], 4000, null, null, "error");
                this.hidePopup();
            });
        };
        this.copyAccessToken = () => {
            //this.hidePopup(); //7june
            this.dataService.setToastMessage("Token copied.", 2000, null, null, "success");
        };
    }
    ngOnInit() {
        this.getAccessTokenWithoutCredentials();
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
TokenGenerationComponent.ɵfac = function TokenGenerationComponent_Factory(t) { return new (t || TokenGenerationComponent)(i0.ɵɵdirectiveInject(CmxOnpremService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
TokenGenerationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TokenGenerationComponent, selectors: [["lib-token-generation"]], inputs: { accessTokenFlag: "accessTokenFlag", id: "id", url: "url", idParam: "idParam", title: "title" }, outputs: { hideAccessToken: "hideAccessToken" }, decls: 1, vars: 1, consts: [["class", "modalPopup modalPopupLg tokenGeneration", 4, "ngIf"], [1, "modalPopup", "modalPopupLg", "tokenGeneration"], ["id", "modalContent", 1, "modalContent-ssid"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], [1, "fieldWrapper", "error"], [4, "ngIf"], [1, "modalFooter"], ["class", "commonButton", "ngxClipboard", "", 3, "cbContent", "click", 4, "ngIf"], ["id", "accessCode", 1, "accessTokenValue"], ["ngxClipboard", "", 1, "commonButton", 3, "cbContent", "click"]], template: function TokenGenerationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, TokenGenerationComponent_div_0_Template, 16, 7, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.accessTokenFlag);
    } }, directives: [i1$2.NgIf, i5$1.ClipboardDirective], pipes: [i2.TranslatePipe], styles: [".fieldLabel[_ngcontent-%COMP%], .fieldWrapper[_ngcontent-%COMP%]{padding:10px 0}.fieldLabel[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans}input[type=password][_ngcontent-%COMP%], .userPassword[_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}input[type=text][_ngcontent-%COMP%]:focus, input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}.modalPopup.tokenGeneration[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease}.modalPopup[_ngcontent-%COMP%] > .modalContent-ssid[_ngcontent-%COMP%]{width:65%;right:0;height:100%;z-index:1001;position:absolute;top:0px;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #abc233;animation:slide .5s forwards}@keyframes slide{65%{right:0}}.modalPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0 30px;color:#545454;font-size:26px;height:100px;line-height:100px}.modalPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{align-items:center;background-color:#ffffffe6;z-index:9999}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{padding:0 30px}.modalContent-ssid[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{border:none}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;border:none;border-radius:10px}.primaryButton[_ngcontent-%COMP%]{height:34px;border-radius:6px;background-color:#0096d6;color:#fff;font-family:\"ciscoSansRegular\";text-align:center;cursor:pointer;display:inline-table;vertical-align:middle;font-size:14px;padding:6px 18px;outline:none;border:none}.disabledButton[_ngcontent-%COMP%]{background-color:#81cfec;border-color:#81cfec;cursor:not-allowed;opacity:.65}.disabledField[_ngcontent-%COMP%]{background-color:#f2f2f2}.commonButton[_ngcontent-%COMP%]:focus, .commonButton[_ngcontent-%COMP%]:hover, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:hover{background-color:#026e97;color:#fff;border:none}.commonButton[_ngcontent-%COMP%]:active, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:active{background-color:#014f6c;color:#fff;border:none}.showPassword[_ngcontent-%COMP%]{padding-left:5px;bottom:10px;position:absolute;font-size:12px;font-weight:bold;font-family:ciscoSans;color:#6674c3;cursor:pointer}.showPasswordAT[_ngcontent-%COMP%]{bottom:30px!important}input[type=password][_ngcontent-%COMP%] > span[_ngcontent-%COMP%] + .showPassword[_ngcontent-%COMP%]{color:#6674c3}.width35[_ngcontent-%COMP%]{min-width:35px;display:inline-block;height:20px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0;height:30px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:auto;margin-bottom:0}.warningPopupHeading[_ngcontent-%COMP%]{margin-bottom:15px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{padding:0 20px 20px;border-top:none;position:relative;height:auto}.accessTokenValue[_ngcontent-%COMP%]{padding:40px 20px;border:1px solid #c4c4c4;margin:20px 0;word-break:break-all;-webkit-user-select:all;user-select:all}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TokenGenerationComponent, [{
        type: Component,
        args: [{
                selector: "lib-token-generation",
                templateUrl: "./token-generation.component.html",
                styleUrls: ["./token-generation.component.scss"]
            }]
    }], function () { return [{ type: CmxOnpremService }, { type: DataService }, { type: i2.TranslateService }]; }, { accessTokenFlag: [{
            type: Input
        }], id: [{
            type: Input
        }], url: [{
            type: Input
        }], idParam: [{
            type: Input
        }], title: [{
            type: Input
        }], hideAccessToken: [{
            type: Output
        }] }); })();

function CiscoCmxComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function CiscoCmxComponent_div_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.handleCMXOnPremModalClick(true, "Add", {}); });
    i0.ɵɵelement(1, "img", 10);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, " Create New Connector ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CiscoCmxComponent_div_7_tr_15_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "a", 24);
    i0.ɵɵlistener("click", function CiscoCmxComponent_div_7_tr_15_div_16_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r13); const connector_r8 = i0.ɵɵnextContext().$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.viewAccessToken(connector_r8); });
    i0.ɵɵelement(2, "img", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "a", 24);
    i0.ɵɵlistener("click", function CiscoCmxComponent_div_7_tr_15_div_16_Template_a_click_3_listener() { i0.ɵɵrestoreView(_r13); const connector_r8 = i0.ɵɵnextContext().$implicit; const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.handleCMXOnPremModalClick(true, "Edit", connector_r8); });
    i0.ɵɵelement(4, "img", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "a", 27);
    i0.ɵɵelementStart(6, "img", 28);
    i0.ɵɵlistener("click", function CiscoCmxComponent_div_7_tr_15_div_16_Template_img_click_6_listener() { i0.ɵɵrestoreView(_r13); const connector_r8 = i0.ɵɵnextContext().$implicit; const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.handleDeleteConnectorClick(connector_r8); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CiscoCmxComponent_div_7_tr_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 17);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "span", 19);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵelementStart(8, "span", 20);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵelementStart(12, "span", 21);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td");
    i0.ɵɵtemplate(16, CiscoCmxComponent_div_7_tr_15_div_16_Template, 7, 0, "div", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r8 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", connector_r8 == null ? null : connector_r8.name, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", connector_r8 == null ? null : connector_r8.description, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(10, 5, connector_r8 == null ? null : connector_r8.lastHeard, "medium"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(14, 8, connector_r8 == null ? null : connector_r8.updatedAt, "medium"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r7.userRole !== "ReadOnlyAccess");
} }
function CiscoCmxComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "table", 12);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr", 13);
    i0.ɵɵelementStart(4, "th");
    i0.ɵɵtext(5, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th");
    i0.ɵɵtext(7, "Description");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9, "Last Heard");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th");
    i0.ɵɵtext(11, "First Heard");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th");
    i0.ɵɵtext(13, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "tbody");
    i0.ɵɵtemplate(15, CiscoCmxComponent_div_7_tr_15_Template, 17, 11, "tr", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "lib-search-basic", 15);
    i0.ɵɵlistener("filtered", function CiscoCmxComponent_div_7_Template_lib_search_basic_filtered_16_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.onConnectorFilter($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "lib-pagination", 16);
    i0.ɵɵlistener("clickEvent", function CiscoCmxComponent_div_7_Template_lib_pagination_clickEvent_17_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.clickEvents($event); })("currentPage", function CiscoCmxComponent_div_7_Template_lib_pagination_currentPage_17_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.getCurrentConnectorItems($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngForOf", ctx_r1.currentConnectorItems);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", ctx_r1.cmxOnPremList)("shouldUseGlobalSearch", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pagesToShow", 3)("perPage", ctx_r1.limit)("page", ctx_r1.page)("loading", false)("items", ctx_r1.connectorList_searched);
} }
function CiscoCmxComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵtext(2, " No Cisco CMX Connectors available. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0$1l = function (a0) { return { "disabledButton": a0 }; };
function CiscoCmxComponent_div_9_button_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 46);
    i0.ɵɵtext(1, " Save ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$1l, ctx_r23.toggleSaveButton()));
} }
function CiscoCmxComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵelement(2, "div", 33);
    i0.ɵɵelementStart(3, "div", 34);
    i0.ɵɵelementStart(4, "div", 35);
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 36);
    i0.ɵɵlistener("click", function CiscoCmxComponent_div_9_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.handleCMXOnPremModalClick(false, null, null); });
    i0.ɵɵtext(8, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "form", 37, 38);
    i0.ɵɵlistener("ngSubmit", function CiscoCmxComponent_div_9_Template_form_ngSubmit_9_listener() { i0.ɵɵrestoreView(_r25); const _r22 = i0.ɵɵreference(10); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.onSubmit(_r22); });
    i0.ɵɵelementStart(11, "div", 39);
    i0.ɵɵelementStart(12, "div", 40);
    i0.ɵɵelementStart(13, "div", 41);
    i0.ɵɵtext(14, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div");
    i0.ɵɵelementStart(16, "input", 42);
    i0.ɵɵlistener("ngModelChange", function CiscoCmxComponent_div_9_Template_input_ngModelChange_16_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.cmxOnPremObj.name = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 40);
    i0.ɵɵelementStart(18, "div", 41);
    i0.ɵɵtext(19, "Description");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div");
    i0.ɵɵelementStart(21, "input", 43);
    i0.ɵɵlistener("ngModelChange", function CiscoCmxComponent_div_9_Template_input_ngModelChange_21_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.cmxOnPremObj.description = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 44);
    i0.ɵɵtemplate(23, CiscoCmxComponent_div_9_button_23_Template, 2, 3, "button", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("", ctx_r3.mode, " Cisco CMX");
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngModel", ctx_r3.cmxOnPremObj.name);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r3.cmxOnPremObj.description);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.userRole !== "ReadOnlyAccess");
} }
function CiscoCmxComponent_lib_token_generation_10_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-token-generation", 47);
    i0.ɵɵlistener("hideAccessToken", function CiscoCmxComponent_lib_token_generation_10_Template_lib_token_generation_hideAccessToken_0_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.hideAccessToken(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("accessTokenFlag", ctx_r4.showAccessTokenPopup)("id", ctx_r4.selectedId)("url", "/cmx/token")("idParam", "cmxId")("title", "Token");
} }
class CiscoCmxComponent {
    constructor(cmxOnPremService, dataService, interactionService) {
        this.cmxOnPremService = cmxOnPremService;
        this.dataService = dataService;
        this.interactionService = interactionService;
        this.unsubscribe$ = new Subject();
        this.name = "";
        this.description = "";
        this.cmxOnPremList = [];
        this.showOnPremPopup = false;
        this.showAccessTokenPopup = false;
        this.mode = "Add";
        this.accessCodeValue = "";
        this.showAccessCodeString = false;
        this.selectedId = "";
        this.cmxOnPremObj = {};
        // Pagination
        this.page = 1;
        this.limit = 10;
        this.currentConnectorItems = null;
        this.connectorList_searched = null;
        this.currentControllerItems = null;
        this.controllerList_searched = null;
        this.getCMXOnPremConnectors = () => {
            this.dataService.display(true);
            this.cmxOnPremService
                .getCMXOnPremConnectors()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data) {
                    this.cmxOnPremList = data;
                }
                this.dataService.display(false);
            }, (error) => {
                this.dataService.display(false);
                console.log("CMX on Prem Connector list fetch error", error.status);
            });
        };
        this.clickEvents = ($event) => {
            //console.log('there is an click event', $event);
        };
        this.onConnectorFilter = ($event) => {
            setTimeout(() => {
                this.connectorList_searched = $event;
            }, 100);
        };
        this.handleCMXOnPremModalClick = (flag, action, connector) => {
            this.cmxOnPremObj = connector;
            this.mode = action;
            console.log(connector);
            this.showOnPremPopup = flag;
        };
        this.getCurrentConnectorItems = ($event) => {
            //console.log('currentl ist of items', $event);
            setTimeout(() => {
                this.currentConnectorItems = $event;
            }, 100);
        };
        this.validateForDuplicateRecord = () => {
            const { name } = this.cmxOnPremObj;
            const list = this.cmxOnPremList;
            return list.find((l) => l.name.toLowerCase() === name.toLowerCase().trim());
        };
        this.onSubmit = (form) => {
            this.dataService.display(true);
            const action = this.mode === "Add"
                ? this.cmxOnPremService.addCMXOnPremConnector
                : this.cmxOnPremService.editCMXOnPremConnector;
            if (this.mode === "Add") {
                const duplicateRecord = this.validateForDuplicateRecord();
                if (duplicateRecord) {
                    this.dataService.setToastMessage("CMX Token already exists", 4000, null, null, "error");
                    this.dataService.display(false);
                    return false;
                }
            }
            const userNameForInteractionLog = this.dataService.getUserName();
            console.log(this.cmxOnPremObj);
            action(this.cmxOnPremObj)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.data) {
                    this.dataService.setToastMessage("CMX Connector Added Successfully.", 4000, null, null, "success");
                    this.showOnPremPopup = false;
                    this.dataService.display(false);
                    this.getCMXOnPremConnectors();
                    form.reset();
                }
                const logStr = this.mode === "Add"
                    ? "ADD"
                    : "UPDATE" +
                        ": User " +
                        userNameForInteractionLog +
                        " has added on prem cmxConnector " +
                        this.cmxOnPremObj.name;
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.ADD, this.dataService.getPosition(), "{}", SECTION.CMX_ON_PREM, ITEM_TYPE.POPUP, ITEM.CMX_ON_PREM, logStr, this.dataService.getCurrentNav()));
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage("An error occurred while adding CMX On Prem Connector.", 4000, null, null, "error");
                const logStr = "ERROR: While adding on prem cmxConnector " +
                    this.cmxOnPremObj.name +
                    " by user " +
                    userNameForInteractionLog;
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.VIEW, this.dataService.getPosition(), "{}", SECTION.CMX_ON_PREM, ITEM_TYPE.POPUP, ITEM.CMX_ON_PREM, logStr, this.dataService.getCurrentNav()));
            });
        };
        this.viewAccessToken = (cmxOnPremConnector) => {
            this.showAccessTokenPopup = true;
            this.selectedConnector = cmxOnPremConnector
                ? Object.assign({}, cmxOnPremConnector)
                : {};
            this.selectedId = this.selectedConnector.id;
        };
        this.hideAccessToken = () => {
            this.showAccessTokenPopup = false;
            this.showAccessCodeString = false;
        };
        this.toggleSaveButton = () => {
            const name = this.cmxOnPremObj.name;
            return !(name && name.length > 0);
        };
    }
    ngOnInit() {
        // RBAC changes starts
        if (this.userRole == "RW") {
            this.userRole = "Admin";
        }
        else if (this.userRole == "RO") {
            this.userRole = "ReadOnlyAccess";
        }
        this.getCMXOnPremConnectors();
    }
    handleDeleteConnectorClick(connector) {
        this.dataService.display(true);
        this.cmxOnPremService
            .deleteCMXConnector(connector)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((response) => {
            if (response.data) {
                this.dataService.setToastMessage("Connector deleted successfully", 4000, null, null, "success");
                this.getCMXOnPremConnectors();
            }
            this.dataService.display(false);
        }, (error) => {
            this.dataService.display(false);
            this.dataService.setToastMessage("An error occurred while deleting CMX On Prem Connector.", 4000, null, null, "error");
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
CiscoCmxComponent.ɵfac = function CiscoCmxComponent_Factory(t) { return new (t || CiscoCmxComponent)(i0.ɵɵdirectiveInject(CmxOnpremService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(InteractionService)); };
CiscoCmxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CiscoCmxComponent, selectors: [["app-cisco-cmx"]], inputs: { userRole: "userRole" }, decls: 11, vars: 5, consts: [[1, "cmx-onprem"], [1, "cmxConnectorAdd"], [1, "cmxConnectorHeading"], [1, "addUuidDiv"], ["id", "btn-connector-create", "class", "addUuidDiv", 3, "click", 4, "ngIf"], ["class", "userTableContainer", 4, "ngIf"], ["class", "emptyState", 4, "ngIf"], ["class", "modalPopup modalPopupSm", 4, "ngIf"], [3, "accessTokenFlag", "id", "url", "idParam", "title", "hideAccessToken", 4, "ngIf"], ["id", "btn-connector-create", 1, "addUuidDiv", 3, "click"], ["src", "/assets/images/add.svg", "width", "20"], [1, "userTableContainer"], [1, "table", "userTable"], [1, "tableTr", "textUppercase"], ["class", "tableTr", 4, "ngFor", "ngForOf"], [3, "data", "shouldUseGlobalSearch", "filtered"], [3, "pagesToShow", "perPage", "page", "loading", "items", "clickEvent", "currentPage"], [1, "tableTr"], [1, "userListName"], [1, "userListDescription"], [1, "userAccess"], [1, "userLocations"], ["class", "userActionsMenu", 4, "ngIf"], [1, "userActionsMenu"], ["href", "javascript:void(0)", 1, "userEditIcon", 3, "click"], ["src", "/assets/images/view-token.svg", "alt", "view Token"], ["src", "/assets/images/edit.svg", "alt", "Edit"], ["href", "javascript:void(0)", 1, "userDeleteIcon"], ["src", "/assets/images/delete_icon_dark.svg", "alt", "Delete", 3, "click"], [1, "emptyState"], [1, "emptyStateHeading"], [1, "modalPopup", "modalPopupSm"], [1, "modalPopup", "wlcConnectorPopup"], [1, "modalOverlay"], [1, "modalContent"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [3, "ngSubmit"], ["cmxOnPremForm", "ngForm"], [1, "modalBody"], [1, "fieldWrapper"], [1, "fieldLabel"], ["id", "name", "name", "name", "type", "text", "placeholder", "Enter Name", "autofocus", "autofocus", 1, "portalNameInput", 3, "ngModel", "ngModelChange"], ["id", "description", "name", "description", "type", "text", "placeholder", "Enter Description", "autofocus", "autofocus", 1, "portalNameInput", 3, "ngModel", "ngModelChange"], [1, "modalFooter"], ["id", "btn-cmxconnector-save", "class", "commonButton", 3, "ngClass", 4, "ngIf"], ["id", "btn-cmxconnector-save", 1, "commonButton", 3, "ngClass"], [3, "accessTokenFlag", "id", "url", "idParam", "title", "hideAccessToken"]], template: function CiscoCmxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div");
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵtext(4, "Cisco CMX");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵtemplate(6, CiscoCmxComponent_div_6_Template, 4, 0, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, CiscoCmxComponent_div_7_Template, 18, 8, "div", 5);
        i0.ɵɵtemplate(8, CiscoCmxComponent_div_8_Template, 3, 0, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, CiscoCmxComponent_div_9_Template, 24, 4, "div", 7);
        i0.ɵɵtemplate(10, CiscoCmxComponent_lib_token_generation_10_Template, 1, 5, "lib-token-generation", 8);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.userRole !== "ReadOnlyAccess");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.cmxOnPremList.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.cmxOnPremList.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showOnPremPopup);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showAccessTokenPopup);
    } }, directives: [i1$2.NgIf, i1$2.NgForOf, SearchBasicComponent, PaginationComponent, i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i2$1.NgForm, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$2.NgClass, TokenGenerationComponent], pipes: [i1$2.DatePipe], styles: [".cmx-onprem[_ngcontent-%COMP%]{padding:30px 40px;margin:0}.cmxConnectorWrapper[_ngcontent-%COMP%]{padding:30px 80px;margin:0}.cmxConnectorAdd[_ngcontent-%COMP%]{display:block;margin:0 0 30px}.cmxConnectorHeading[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";font-size:16px;color:#4d4d4d;display:inline-block;margin-top:10px}.addUuidDiv[_ngcontent-%COMP%]{float:right;clear:right;font-size:14px;color:#0096d6;cursor:pointer}.saveUUID[_ngcontent-%COMP%]{width:auto;padding:8px 18px;height:34px;border:1px solid #049fd9;margin-right:20px}.cmxConnectorName[_ngcontent-%COMP%]{max-width:280px;margin-bottom:0;margin-right:20px}.cmxConnectorListWrapper[_ngcontent-%COMP%]{margin:20px 0}.cmxConnectorBox[_ngcontent-%COMP%]{padding:20px 30px;background-color:#fff;border-bottom:1px solid #dddfe2;font-size:16px;font-family:\"ciscoSansLight\";color:#4d4d4d}.cmxConnectorBox[_ngcontent-%COMP%]:hover{background-color:#f6f8f9}.cmxConnectorDeleteBtn[_ngcontent-%COMP%]{float:right;clear:right;margin-top:-8px}.wlcConnectorPopup[_ngcontent-%COMP%]   .modelContent[_ngcontent-%COMP%]{width:80%!important;top:10%!important;height:600px!important}.wlcConnectorPopup[_ngcontent-%COMP%]   .modelBody[_ngcontent-%COMP%]{overflow-y:auto;height:480px}.select-menu[_ngcontent-%COMP%]{height:30px;min-width:100px;padding-left:0;border-bottom:1px solid #ddd;background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_down.svg) no-repeat right center;float:left;margin:0 10px;cursor:pointer}.select-menu[_ngcontent-%COMP%]   .first[_ngcontent-%COMP%]{padding:5px 10px;z-index:2;width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:inline-block;box-sizing:border-box;max-width:200px}.select-item-container[_ngcontent-%COMP%]{width:100%;border:1px solid #ddd;background:#ffffff;max-height:150px;overflow:auto;position:relative;z-index:999}.select-item[_ngcontent-%COMP%]{padding:10px}.select-item-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:not(.first):hover{background:#09f;color:#fff}.select-item-container[_ngcontent-%COMP%] > .selected[_ngcontent-%COMP%]{display:none}.select-item[_ngcontent-%COMP%]   .first[_ngcontent-%COMP%]{cursor:pointer}.select-custom-2[_ngcontent-%COMP%]{width:200px!important;margin:10px 0!important;font-size:15px}.fieldLabel[_ngcontent-%COMP%], .fieldWrapper[_ngcontent-%COMP%]{padding:10px 0}.fieldLabel[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans}.cmxConnectorForm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .cmxConnectorForm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}.cmxConnectorForm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .select-menu[_ngcontent-%COMP%]{background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_up.svg) no-repeat right center;font-size:14px}.cmxConnectorForm[_ngcontent-%COMP%]   .menuActive[_ngcontent-%COMP%]{background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_down.svg) no-repeat right center!important}.cmxConnectorForm[_ngcontent-%COMP%]   .select-item-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:hover{background:#DFDFDF;color:#000}.cmxConnectorForm[_ngcontent-%COMP%]   .menuActive[_ngcontent-%COMP%] > .select-item.first[_ngcontent-%COMP%]{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .select-item.first[_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;border:none;border-radius:10px}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:hover, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:hover{background-color:#026e97;color:#fff;border:none}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:active, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:active{background-color:#014f6c;color:#fff;border:none}.showPassword[_ngcontent-%COMP%]{padding-left:5px;bottom:10px;position:absolute;font-size:12px;font-weight:bold;font-family:ciscoSans;color:#6674c3;cursor:pointer}.showPasswordAT[_ngcontent-%COMP%]{bottom:30px!important}input[type=password][_ngcontent-%COMP%] > span[_ngcontent-%COMP%] + .showPassword[_ngcontent-%COMP%]{color:#6674c3}.select-item-container[_ngcontent-%COMP%]{margin-bottom:40px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:22%;padding-left:15px}.table.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:20%}.circularCheckbox[_ngcontent-%COMP%]{vertical-align:middle;padding-right:15px;display:inline-block}.userDetailLabel[_ngcontent-%COMP%]{display:inline-block}.userNameLink[_ngcontent-%COMP%]{font-size:12px;color:#000;font-family:\"ciscoSansRegular\"}.userListEmail[_ngcontent-%COMP%]{opacity:.8;font-family:\"ciscoSansRegular\";font-size:11px;color:#333;display:block}.userAccess[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.userLocations[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.statusPending[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;font-weight:600;color:#f86969}.confirmResendLink[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";font-size:12px;font-weight:600;color:#049fd9;text-decoration:underline}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%]{text-align:center;display:none}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   div.userActionsMenu[_ngcontent-%COMP%]{display:block}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative;padding:0 10px;text-decoration:none;outline:none}.userEditIcon[_ngcontent-%COMP%]:after{position:absolute;left:100%;height:17px;width:1px;background-color:#c7c7c7;top:0;content:\"\"}.userListLabel[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}.userListName[_ngcontent-%COMP%], .userListDescription[_ngcontent-%COMP%]{display:block;cursor:pointer}.userPendingStatus[_ngcontent-%COMP%]{display:block}.modalPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{min-height:300px}.width35[_ngcontent-%COMP%]{min-width:35px;display:inline-block;height:20px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0;height:30px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:auto;margin-bottom:0}.warningPopupHeading[_ngcontent-%COMP%]{margin-bottom:15px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{padding:0 20px 20px;border-top:none;position:relative;height:auto}.accessTokenValue[_ngcontent-%COMP%]{padding:40px 20px;border:1px solid #c4c4c4;margin:20px 0;word-break:break-all;-webkit-user-select:all;user-select:all}.createNewWrapper[_ngcontent-%COMP%]{color:#079fd9;font-family:sans-serif;font-size:14px;cursor:pointer;display:inline-block}.createNewWrapper[_ngcontent-%COMP%]:hover{color:#007199}.paddingR10[_ngcontent-%COMP%]{padding-right:10px}.createNewWrapper.vertical[_ngcontent-%COMP%]{padding-right:20px;margin-right:20px;border-right:1px solid #c4c4c4}span.userAccess.active[_ngcontent-%COMP%]{color:green}span.userAccess.inactive[_ngcontent-%COMP%]{color:#cd5c5c}.customerNameDropdown[_ngcontent-%COMP%]{width:180px!important;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.modalPopup.modalPopupSm[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{width:40%;min-width:360px}.disabledButton[_ngcontent-%COMP%]{background-color:#81cfec;border-color:#81cfec;cursor:not-allowed;opacity:.65}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CiscoCmxComponent, [{
        type: Component,
        args: [{
                selector: "app-cisco-cmx",
                templateUrl: "./cisco-cmx.component.html",
                styleUrls: ["./cisco-cmx.component.scss"]
            }]
    }], function () { return [{ type: CmxOnpremService }, { type: DataService }, { type: InteractionService }]; }, { userRole: [{
            type: Input
        }] }); })();

const moment$k = moment_;
class CMXConnectorsService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getHotspotConfig = () => {
            const getHotspotConfigUrl = this.apiConfig.getHotspotConfigUrl();
            return this.get(getHotspotConfigUrl).pipe(map(this.extractResponse));
        };
        /*getCMXConnectors = () => {
            const getCMXConnectorsUrl = this.apiConfig.getCMXConnectorsUrl();
            return this.get(getCMXConnectorsUrl).pipe(
                map(this.extractResponseData)
            );
        };*/
        this.getCMXConnectorDetails = (id) => {
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSProxyUrl();
            const getConnectorDetailsObj = {
                method: "GET",
                path: `config/connector/${id}`,
                responseType: "object"
            };
            return this.post(getCMXConnectorProxyUrl, getConnectorDetailsObj).pipe(map(this.extractResponseData));
        };
        this.getCMXConnectorChartStatistics = (id) => {
            const getCMXConnectorChartStatisticsUrl = this.apiConfig.getDMSProxyUrl();
            const getConnectorDetailsObj = {
                method: "GET",
                path: `config/connector/${id}/statistics`,
                responseType: "array",
                params: '{"sampleRate":60,"duration":720}'
            };
            return this.post(getCMXConnectorChartStatisticsUrl, getConnectorDetailsObj).pipe(map(this.extractResponseData));
        };
        this.getControllers = (cmxConnector = null) => {
            //let getCMXConnectorsUrl = (cmxConnector) ? this.apiConfig.getControllersUrl()+"?connectorId="+cmxConnector.id : this.apiConfig.getControllersUrl();
            const getCMXConnectorsUrl = this.apiConfig.getControllersUrl();
            return this.get(getCMXConnectorsUrl).pipe(map(this.extractResponseData));
        };
        this.getControllersdirectWLC = (cmxConnector = null) => {
            //let getCMXConnectorsUrl = (cmxConnector) ? this.apiConfig.getControllersUrl()+"?connectorId="+cmxConnector.id : this.apiConfig.getControllersUrl();
            const getCMXConnectorsUrl = this.apiConfig.getWLCControllerIpsUrl();
            return this.get(getCMXConnectorsUrl).pipe(map(this.extractResponseData));
        };
        this.deleteCMXConnector = (cmxConnector) => {
            const serverUrl = this.apiConfig.deleteCMXConnectorUrl();
            const deleteUUID = {
                cmxConnector: cmxConnector
            };
            const opts = {
                body: deleteUUID
            };
            return this.delete(serverUrl, opts).pipe(map(this.extractResponse));
        };
        this.addCMXConnector = (cmxConnector) => {
            const serverUrl = this.apiConfig.addCMXConnectorUrl();
            return this.post(serverUrl, cmxConnector).pipe(map(this.extractResponse));
        };
        this.addController = (cmxConnectorObject) => {
            const cmxConnector = JSON.parse(JSON.stringify(cmxConnectorObject));
            const { login } = cmxConnector;
            if (login && Object.keys(login).length) {
                const { enablePassword } = login;
                cmxConnector.login.cliCredentialsAvailable = true;
                //CSCwc85375
                //cmxConnector.login.username = cmxConnector.login.netconfUsername;
                //cmxConnector.login.password = cmxConnector.login.netconfPassword;
                if (!enablePassword.length)
                    delete cmxConnector.login.enablePassword;
            }
            const version = cmxConnector.connectorVersion;
            if (version === "" || (version && version.length > 0))
                delete cmxConnector.connectorVersion;
            const proxyObject = JSON.stringify(cmxConnector);
            const addControllerProxyUrl = this.apiConfig.getDMSProxyUrl();
            const paramObject = {
                method: "POST",
                path: "config/controller",
                responseType: "object",
                params: proxyObject
            };
            return this.post(addControllerProxyUrl, paramObject).pipe(map(this.extractResponse));
        };
        this.testCredentials = (cmxConnectorObject) => {
            const cmxConnector = JSON.parse(JSON.stringify(cmxConnectorObject));
            const { login } = cmxConnector;
            if (login && Object.keys(login).length) {
                const { enablePassword } = login;
                cmxConnector.login.cliCredentialsAvailable = true;
                //CSCwc85375
                /*if(cmxConnector.login.username == "")
                cmxConnector.login.username = cmxConnector.login.netconfUsername;
                if(cmxConnector.login.password == "")
                cmxConnector.login.password = cmxConnector.login.netconfPassword;*/
                if (!enablePassword.length)
                    delete cmxConnector.login.enablePassword;
            }
            cmxConnector.tenantId = this.dataService.getTenantId();
            cmxConnector.host = cmxConnector.controllerIp;
            const proxyObject = JSON.stringify(cmxConnector);
            const proxyURL = this.apiConfig.getDMSProxyUrl();
            const paramObject = {
                method: "POST",
                path: "config/device/connectivity/test",
                responseType: "object",
                params: proxyObject
            };
            return this.post(proxyURL, paramObject).pipe(map(this.extractResponse));
        };
        this.verifyConnectivity = (testRequestId, tenantId) => {
            const proxyURL = this.apiConfig.getDMSProxyUrl();
            const paramObject = {
                method: "GET",
                path: `config/device/connectivity/test/${tenantId}/${testRequestId}`,
                responseType: "object"
            };
            return this.post(proxyURL, paramObject).pipe(map(this.extractResponse));
        };
        this.updateController = (controllerId, cmxConnectorObject) => {
            const cmxConnector = JSON.parse(JSON.stringify(cmxConnectorObject));
            const { login } = cmxConnector;
            if (login && Object.keys(login).length) {
                const { enablePassword } = login;
                cmxConnector.login.cliCredentialsAvailable = true;
                //CSCwc85375
                /*if(cmxConnector.login.username == "")
                cmxConnector.login.username = cmxConnector.login.netconfUsername;
                if(cmxConnector.login.password == "")
                cmxConnector.login.password = cmxConnector.login.netconfPassword;*/
                if (!enablePassword.length)
                    delete cmxConnector.login.enablePassword;
            }
            cmxConnector.tenantId = this.dataService.getTenantId();
            cmxConnector.host = cmxConnector.controllerIp;
            const serverUrl = this.apiConfig.updateControllerUrl() + "/" + controllerId;
            return this.put(serverUrl, cmxConnector).pipe(map(this.extractResponse));
        };
        this.updateConnectorName = (connectorId, cmxConnector) => {
            const serverUrl = this.apiConfig.updateConnectorNameUrl() + "/" + connectorId;
            console.log("connectorId :: " +
                connectorId +
                " :: cmxConnector :: " +
                JSON.stringify(cmxConnector));
            return this.put(serverUrl, cmxConnector).pipe(map(this.extractResponse));
        };
        this.getAccessToken = (obj) => {
            const serverUrl = this.apiConfig.getAccessTokenUrl();
            return this.post(serverUrl, obj).pipe(map(this.extractResponse));
        };
        this.getCertificateChain = () => {
            const proxyUrl = this.apiConfig.getDMSProxyUrl();
            const paramObject = {
                method: "GET",
                path: "edm/stream/config/connector/cachain",
                responseType: "object"
            };
            return this.post(proxyUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.getManageStreamAuthKey = (connectorId) => {
            const proxyUrl = this.apiConfig.getDMSProxyUrl();
            const proxyObject = JSON.stringify({ connectorId });
            const paramObject = {
                method: "POST",
                path: `edm/stream/config/connector/auth/${connectorId}`,
                responseType: "object",
                params: proxyObject
            };
            return this.post(proxyUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.getConfigStatus = (connectorId) => {
            const proxyUrl = this.apiConfig.getDMSProxyUrl();
            const paramObject = {
                method: "GET",
                path: `edm/stream/config/connector/status/${connectorId}`,
                responseType: "object"
            };
            return this.post(proxyUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.getAllEwlcStreamStatus = (connectorId) => {
            const proxyUrl = this.apiConfig.getDMSProxyUrl();
            const paramObject = {
                method: "GET",
                path: `edm/stream/config/wlc/status/${connectorId}`,
                responseType: "object"
            };
            return this.post(proxyUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.getAllSwitchesStatus = (connectorId) => {
            const proxyUrl = this.apiConfig.getDMSProxyUrl();
            const paramObject = {
                method: "GET",
                path: `edm/iotservice/config/switch/status/${connectorId}`,
                responseType: "object"
            };
            return this.post(proxyUrl, paramObject).pipe(map(this.extractResponseData));
        };
        /**
         * Enable(push config)/Disable stream status
         * @param connectorId
         * @param wlcIdList
         * @param status
         */
        this.toggleStreamStatus = (wlcIdList, connectorId, status, state) => {
            const proxyUrl = this.apiConfig.getDMSProxyUrl();
            const proxyObject = JSON.stringify({ wlcIdList, profile: state });
            const paramObject = {
                method: "POST",
                path: `edm/stream/config/wlc/${connectorId}/${status}`,
                responseType: "object",
                params: proxyObject
            };
            return this.post(proxyUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.toggleConfigurationStatus = (connectorId) => {
            const proxyUrl = this.apiConfig.getDMSProxyUrl();
            const proxyObject = JSON.stringify({ connectorId });
            const paramObject = {
                method: "POST",
                path: `edm/stream/config/connector/${connectorId}`,
                responseType: "object",
                params: proxyObject
            };
            return this.post(proxyUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.toggleConfigurationStatusV3 = (connectorId, serviceName) => {
            const proxyUrl = this.apiConfig.getDMSProxyUrl();
            const proxyObject = JSON.stringify({ connectorId, service: serviceName });
            const paramObject = {
                method: "POST",
                path: `edm/stream/config/connector/${connectorId}`,
                responseType: "object",
                params: proxyObject
            };
            return this.post(proxyUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.geteWLCcommands = (id) => {
            const geteWLCcommandsProxyUrl = this.apiConfig.getDMSProxyUrl();
            const paramObject = {
                method: "GET",
                path: `config/connector/${id}/ewlcCommands`,
                responseType: "object"
            };
            return this.post(geteWLCcommandsProxyUrl, paramObject).pipe(map(this.extractResponse));
        };
        this.configureSwitch = (connectorId, payload) => {
            const proxyUrl = this.apiConfig.getDMSProxyUrl();
            const switchObject = JSON.stringify(payload);
            const paramObject = {
                method: "POST",
                path: `edm/iotservice/config/switch/${connectorId}/enable`,
                responseType: "object",
                params: switchObject
            };
            return this.post(proxyUrl, paramObject).pipe(map(this.extractResponse));
        };
        this.disableSwitch = (connectorId, switchId, saveConfig) => {
            const proxyUrl = this.apiConfig.getDMSProxyUrl();
            const obj = {
                switchIdList: [],
                saveConfig: false
            };
            obj.switchIdList.push(switchId);
            obj.saveConfig = saveConfig;
            const payload = JSON.stringify(obj);
            const paramObject = {
                method: "POST",
                path: `edm/iotservice/config/switch/${connectorId}/disable`,
                responseType: "object",
                params: payload
            };
            return this.post(proxyUrl, paramObject).pipe(map(this.extractResponse));
        };
        this.deleteConnector = (connectorId) => {
            const serverUrl = this.apiConfig.deleteConnectorUrl() + "/" + connectorId;
            return this.delete(serverUrl).pipe(map(this.extractResponse));
        };
        this.deleteController = (controllerId) => {
            const serverUrl = this.apiConfig.deleteControllerUrl() + "/" + controllerId;
            console.log(serverUrl);
            return this.delete(serverUrl).pipe(map(this.extractResponse));
        };
        this.deleteControllerdirectWLC = (deleteObj) => {
            console.log("Method Test");
            const serverUrl = this.apiConfig.deleteControllerUrlWLC();
            const options = {
                body: deleteObj
            };
            console.log(serverUrl);
            return this.delete(serverUrl, options).pipe(map(this.extractResponse));
        };
        this.uploadConnectorLogs = (connectorId) => {
            const uploadConnectorLogUrl = this.apiConfig.getDMSProxyUrl();
            const serverUrl = this.apiConfig.uploadConnectorLogsUrl(connectorId);
            const paramObject = {
                method: "PUT",
                path: serverUrl,
                responseType: "object",
                params: `{\"uploadLog\":true}`
            };
            return this.post(uploadConnectorLogUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.uploadConnectorV3Logs = (connectorId, service) => {
            const uploadConnectorLogUrl = this.apiConfig.getDMSV3ProxyUrl();
            const serverUrl = this.apiConfig.uploadConnectorV3LogsUrl(connectorId, service);
            const paramObject = {
                method: "POST",
                path: serverUrl,
                responseType: "object",
                params: `{\"uploadLog\":true}`
            };
            return this.post(uploadConnectorLogUrl, paramObject).pipe(map(this.extractResponse));
        };
        this.upgradeConnector = (connectorId) => {
            const upgradeConnectorUrl = this.apiConfig.getDMSProxyUrl();
            const serverUrl = this.apiConfig.uploadConnectorLogsUrl(connectorId);
            const paramObject = {
                method: "PUT",
                path: serverUrl,
                responseType: "object",
                params: `{\"manualUpgrade\":true}`
            };
            return this.post(upgradeConnectorUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.restartConnector = (connectorId) => {
            const restartConnectorUrl = this.apiConfig.getDMSProxyUrl();
            const serverUrl = this.apiConfig.restartConnectorUrl(connectorId);
            const paramObject = {
                method: "PUT",
                path: serverUrl,
                responseType: "object",
                params: `{\"restart\":true}`
            };
            return this.post(restartConnectorUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.enableDebug = (connectorId, mode) => {
            const enableDebugUrl = this.apiConfig.getDMSProxyUrl();
            const serverUrl = this.apiConfig.enableDebugUrl(connectorId);
            const paramObject = {
                method: "PUT",
                path: serverUrl,
                responseType: "object",
                params: `{\"enableDebug\":${mode}}`
            };
            return this.post(enableDebugUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.enableHotspotDebug = (connectorId, mode) => {
            const enableDebugUrl = this.apiConfig.getDMSProxyUrl();
            const serverUrl = this.apiConfig.enableHotspotDebugUrl(connectorId);
            // serverUrl = 'config/container/'+connectorId+'/service/hotspot';
            const paramObject = {
                method: "PUT",
                path: serverUrl,
                responseType: "object",
                params: `{\"enableDebug\":${mode}}`
            };
            return this.post(enableDebugUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.autoUpgrade = (connectorId, upgradeObj) => {
            const autoUpgradeUrl = this.apiConfig.getDMSProxyUrl();
            const serverUrl = this.apiConfig.autoUpgradeUrl(connectorId);
            const { autoUpgradeTimeRange } = upgradeObj;
            const { startVal, dayVal } = autoUpgradeTimeRange;
            let startTime = startVal;
            // change the startTime to be a utc timestamp, start and end time should be same for api to work
            if (startVal != null && dayVal != null) {
                startTime = moment$k()
                    .day(dayVal)
                    .hour(startVal)
                    .minute(0)
                    .second(0)
                    .utc()
                    .unix();
            }
            const paramObject = {
                method: "PUT",
                path: serverUrl,
                responseType: "object",
                params: `{\"autoUpgrade\":${upgradeObj.autoUpgrade},\"autoUpgradeTimeRange\":{\"startVal\":${upgradeObj.autoUpgradeTimeRange.startVal},\"endVal\":${upgradeObj.autoUpgradeTimeRange.endVal},\"dayVal\":${upgradeObj.autoUpgradeTimeRange.dayVal},\"endTime\":${startTime},\"startTime\":${startTime}}}`
            };
            return this.post(autoUpgradeUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.addHotspot = (hotspotObject) => {
            const serverUrl = this.apiConfig.addHotspotUrl();
            return this.post(serverUrl, hotspotObject).pipe(map(this.extractResponse));
        };
        this.ewlcFeatureFlag = () => {
            const ewlcFeatureFlagUrl = this.apiConfig.ewlcFeatureFlagUrl();
            return this.get(ewlcFeatureFlagUrl).pipe(map(this.extractResponseData));
        };
        this.getHotspotList = () => {
            const getHotspotListUrl = this.apiConfig.getHotspotListUrl();
            return this.get(getHotspotListUrl).pipe(map(this.extractResponse));
        };
        this.getConfiguredProfileList = () => {
            const serverUrl = this.apiConfig.getConfiguredProfileListUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.saveProfileToController = (controllerObj) => {
            const serverUrl = this.apiConfig.saveProfileToControllerUrl();
            return this.post(serverUrl, controllerObj).pipe(map(this.extractResponse));
        };
        this.getSwitchesList = () => {
            const url = this.apiConfig.getSwitchBaseUrl();
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getSwitchesCount = () => {
            const url = this.apiConfig.getSwitchCountUrl();
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.createSwitch = (payload) => {
            const url = this.apiConfig.getSwitchBaseUrl();
            return this.post(url, payload).pipe(map(this.extractResponse));
        };
        this.updateSwitch = (id, payload) => {
            const url = this.apiConfig.getSwitchBaseUrl() + "/" + id;
            return this.put(url, payload).pipe(map(this.extractResponse));
        };
        this.deleteSwitch = (id) => {
            const url = this.apiConfig.getSwitchBaseUrl() + "/" + id;
            return this.delete(url).pipe(map(this.extractResponse));
        };
        this.getConnectorSwitches = (id) => {
            const url = this.apiConfig.getConnectorSwitches() + "/" + id;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getConnectorControllers = (id) => {
            const url = this.apiConfig.getConnectorControllers() + "/" + id;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getConnectorServices = (id) => {
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const getConnectorServiceObj = {
                method: "GET",
                path: `manage/connector/${id}/service`,
                responseType: "object"
            };
            return this.post(getCMXConnectorProxyUrl, getConnectorServiceObj).pipe(map(this.extractResponse));
            //const url = this.apiConfig.getConnectorServices(id);
            //return this.get(url).pipe(map(this.extractResponse));
        };
        this.getCMXConnectors = () => {
            const getConnectorProxyUrl = this.apiConfig.getDMSProxyUrl();
            const paramObject = {
                method: "GET",
                path: "config/connector",
                responseType: "array",
            };
            return this.post(getConnectorProxyUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.addConnectorServices = (connectorId, payload) => {
            //	const url = this.apiConfig.addConnectorServicesUrl();
            //	return this.post(url,payload).pipe(map(this.extractResponse));
            const getConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const url = `manage/connector/` + connectorId + `/service`;
            const paramObject = {
                method: "POST",
                path: url,
                responseType: "object",
                params: payload
            };
            return this.post(getConnectorProxyUrl, paramObject).pipe(map(this.extractResponseData));
        };
        this.upgradeServices = (connectorId, serviceName, configType) => {
            //	const url = this.apiConfig.upgradeServicesUrl();
            //	return this.put(url, payload).pipe(map(this.extractResponse));
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const serverUrl = `manage/connector/` + connectorId + `/service/` + serviceName + `/` + configType;
            const getConnectorServiceObj = {
                method: "PUT",
                path: serverUrl,
                responseType: "object",
                params: `{\"configType\":\"latest\"}`
            };
            return this.post(getCMXConnectorProxyUrl, getConnectorServiceObj).pipe(map(this.extractResponse));
        };
        this.deleteServices = (payload) => {
            const url = this.apiConfig.deleteServicesUrl();
            const options = {
                body: payload
            };
            return this.delete(url, options).pipe(map(this.extractResponse));
        };
        this.restartAllServices = (payload) => {
            const url = this.apiConfig.restartServicesUrl();
            return this.put(url, payload).pipe(map(this.extractResponse));
        };
        this.restartServices = (service, connectorId, configType) => {
            //PUT: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/service/{{SERVICE_NAME}}/{{CONFIG_TYPE}}/restart
            //const url = this.apiConfig.restartServicesUrl();
            //	return this.put(url,payload).pipe(map(this.extractResponse));
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const serverUrl = `manage/connector/` + connectorId + `/service/` + service + `/` + configType + `/restart`;
            const getConnectorServiceObj = {
                method: "PUT",
                path: serverUrl,
                responseType: "object",
                params: `{\"configType\":\"latest\"}`
            };
            return this.post(getCMXConnectorProxyUrl, getConnectorServiceObj).pipe(map(this.extractResponse));
        };
        this.stopService = (connectorId, serviceName) => {
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const serverUrl = `manage/connector/` + connectorId + `/service/` + serviceName + `/stop`;
            const getConnectorServiceObj = {
                method: "PUT",
                path: serverUrl,
                responseType: "object",
                params: `{\"configType\":\"latest\"}`
            };
            return this.post(getCMXConnectorProxyUrl, getConnectorServiceObj).pipe(map(this.extractResponse));
        };
        this.restartInstanceServices = (connectorId, instance, serviceName, configType) => {
            //const url = this.apiConfig.restartInstanceServicesUrl();
            //return this.put(url,payload).pipe(map(this.extractResponse));
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const serverUrl = `manage/connector/` + connectorId + `/service/` + instance + `/` + serviceName + `/` + configType + `/restart`;
            const getConnectorServiceObj = {
                method: "PUT",
                path: serverUrl,
                responseType: "object",
                params: `{}` //params: `{\"configType\":\"latest\"}`
            };
            return this.post(getCMXConnectorProxyUrl, getConnectorServiceObj).pipe(map(this.extractResponse));
        };
        this.restartInstance = (connectorId, instance) => {
            //const url = this.apiConfig.restartInstanceUrl();
            //return this.put(url,payload).pipe(map(this.extractResponse));/
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const serverUrl = `manage/connector/` + connectorId + `/` + instance + `/restart`;
            const getConnectorServiceObj = {
                method: "PUT",
                path: serverUrl,
                responseType: "object",
                params: `{}` //params: `{\"configType\":\"latest\"}`
            };
            return this.post(getCMXConnectorProxyUrl, getConnectorServiceObj).pipe(map(this.extractResponse));
        };
        this.getMetricsStatsForService = (id, services, instancesIds, interval, sampleRate) => {
            const url = this.apiConfig.getServiceMetricsStatsUrl(id, services, instancesIds, interval, sampleRate); // startdate, enddate ,
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getConnectorInstances = (id) => {
            const url = this.apiConfig.getConnectorInstances() + "/" + id;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.deleteConnectorInstance = (connectorId, instanceId) => {
            //const url = this.apiConfig.deleteConnectorInstance() + "/" + connectorId + "/"+ instanceId;
            //	return this.delete(url).pipe(map(this.extractResponse));
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const serverUrl = `manage/connector/` + connectorId + `/instance/` + instanceId;
            const getConnectorServiceObj = {
                method: "DELETE",
                path: serverUrl,
                responseType: "object",
                params: `{\"configType\":\"latest\"}`
            };
            return this.post(getCMXConnectorProxyUrl, getConnectorServiceObj).pipe(map(this.extractResponse));
        };
        this.upgradeConnectorV3 = (connectorId) => {
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const serverUrl = `manage/connector/` + connectorId;
            const getConnectorServiceObj = {
                method: "PUT",
                path: serverUrl,
                responseType: "object",
                params: `{\"configType\":\"latest\"}`
            };
            return this.post(getCMXConnectorProxyUrl, getConnectorServiceObj).pipe(map(this.extractResponse));
        };
        this.getConnecInstanceServiceStatus = (connectorId, instanceId, service) => {
            const url = this.apiConfig.instanceInfoServiceMetricUrl(connectorId, instanceId, service);
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getInstanceServiceStatus = (connectorId, instanceId) => {
            const url = this.apiConfig.instanceServiceStatusUrl(connectorId, instanceId);
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.refreshInstance = (connectorId, instanceId) => {
            //const url = this.apiConfig.instanceRefresh(connectorId, instanceId);
            //return this.get(url).pipe(map(this.extractResponse));
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const serverUrl = `manage/connector/` + connectorId + `/` + instanceId + `/refresh`;
            const getConnectorServiceObj = {
                method: "PUT",
                path: serverUrl,
                responseType: "object",
                params: `{\"configType\":\"latest\"}`
            };
            return this.post(getCMXConnectorProxyUrl, getConnectorServiceObj).pipe(map(this.extractResponse));
        };
        this.checkConnectorUpgrade = (connectorId) => {
            const url = this.apiConfig.checkConnectorUpgrade(connectorId);
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.connectorUpgrade = (connectorId) => {
            const url = this.apiConfig.connectorUpgrade(connectorId);
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getConnectorListSummary = (section) => {
            const url = this.apiConfig.listSummaryCounts(section);
            return this.get(url).pipe(map(this.extractResponse));
        };
        //POST: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/upgrade
        this.upgradeV2ToV3 = (connectorId) => {
            const serverUrl = 'manage/connector/' + connectorId + '/upgrade';
            const cMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const connectorServiceObj = {
                method: "POST",
                path: serverUrl,
                responseType: "object",
                params: JSON.stringify({ "migrate": "yes" })
            };
            return this.post(cMXConnectorProxyUrl, connectorServiceObj).pipe(map(this.extractResponse));
        };
        //GET: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/{{INSTANCE_ID}}/verification/reset // Reset Password Token --QUERY
        this.getResetPasswordKey = (connctorId, instanceId) => {
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const getResetKeyObj = {
                method: "GET",
                path: `manage/connector/${connctorId}/${instanceId}/verification/reset`,
                responseType: "object"
            };
            return this.post(getCMXConnectorProxyUrl, getResetKeyObj).pipe(map(this.extractResponse));
        };
        //POST: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/service/debug
        /*{
        "services": [
            "service-manager",
            "location"
             ],
            "logLevel": "DEBUG" -- DEBUG|INFO|WARNING|ERROR
        }
        */
        this.enableDebugForServices = (connectorId, payload) => {
            const pathUrl = 'manage/connector/' + connectorId + '/service/debug';
            const cMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const jsonPayload = JSON.stringify(payload);
            const connectorServiceObj = {
                method: "POST",
                path: pathUrl,
                responseType: "object",
                params: jsonPayload
            };
            return this.post(cMXConnectorProxyUrl, connectorServiceObj).pipe(map(this.extractResponse));
        };
        //POST: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/service/upload-log
        /*{
        "services": [
            "location"
           ]
        }
        */
        this.uploadLogForServices = (connectorId, payload) => {
            const pathUrl = 'manage/connector/' + connectorId + '/service/upload-log';
            const cMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const jsonPayload = JSON.stringify(payload);
            const connectorServiceObj = {
                method: "POST",
                path: pathUrl,
                responseType: "object",
                params: jsonPayload
            };
            return this.post(cMXConnectorProxyUrl, connectorServiceObj).pipe(map(this.extractResponse));
        };
        //GET: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/{{INSTANCE_ID}}/list-logs -to list logs file
        //GET: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/{{INSTANCE_ID}}/download-log?fileName=<file_name_from_above_list> get file from above list
        //GET: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/{{INSTANCE_ID}}/service/history/ --not needed now
        this.getServiceConfigHistory = (connectorId, instanceId) => {
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const getConfigObj = {
                method: "GET",
                path: `manage/connector/${connectorId}/${instanceId}/service/history`,
                responseType: "object"
            };
            return this.post(getCMXConnectorProxyUrl, getConfigObj).pipe(map(this.extractResponse));
        };
        //GET: {{DMS_ENDPOINT}}/api/dms/v1/config/connector/list?serviceName=hotspot
        this.getHotspotEnabledConnectors = (hotSpotServiceName) => {
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSProxyUrl();
            const paramObject = JSON.stringify({ serviceName: hotSpotServiceName });
            const getConfigObj = {
                method: "GET",
                path: `config/connector/list?serviceName=${hotSpotServiceName}`,
                //	params: paramObject,
                responseType: "array"
            };
            return this.post(getCMXConnectorProxyUrl, getConfigObj).pipe(map(this.extractResponse));
        };
        //POST: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/serviceDrivenConfig/{{SERVICE_NAME}}
        this.saveServiceDrivenConfig = (connectorId, hotSpotServiceName, payload) => {
            const pathUrl = 'manage/connector/' + connectorId + '/serviceDrivenConfig/' + hotSpotServiceName;
            const cMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const jsonPayload = JSON.stringify(payload);
            const connectorServiceObj = {
                method: "POST",
                path: pathUrl,
                responseType: "object",
                params: jsonPayload
            };
            return this.post(cMXConnectorProxyUrl, connectorServiceObj).pipe(map(this.extractResponse));
        };
        //GET: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/serviceDrivenConfig/{{SERVICE_NAME}}
        this.getServiceDrivenConfig = (connectorId, hotSpotServiceName) => {
            const pathUrl = 'manage/connector/' + connectorId + '/serviceDrivenConfig/' + hotSpotServiceName;
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const getConfigObj = {
                method: "GET",
                path: pathUrl,
                responseType: "object"
            };
            return this.post(getCMXConnectorProxyUrl, getConfigObj).pipe(map(this.extractResponse));
        };
        //DELETE: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/serviceDrivenConfig/{{SERVICE_NAME}}
        this.deleteServiceDrivenConfig = (connectorId, hotSpotServiceName) => {
        };
        //PUT: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/service/debug
        this.disableDebugForServices = (connectorId, payload) => {
            const pathUrl = 'manage/connector/' + connectorId + '/service/debug';
            const cMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const jsonPayload = JSON.stringify(payload);
            const connectorServiceObj = {
                method: "PUT",
                path: pathUrl,
                responseType: "object",
                params: jsonPayload
            };
            return this.post(cMXConnectorProxyUrl, connectorServiceObj).pipe(map(this.extractResponse));
        };
        //GET: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/service/debug
        this.getServiceDebugInfo = (connectorId) => {
            const pathUrl = 'manage/connector/' + connectorId + '/service/debug';
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const getConfigObj = {
                method: "GET",
                path: pathUrl,
                responseType: "object"
            };
            return this.post(getCMXConnectorProxyUrl, getConfigObj).pipe(map(this.extractResponse));
        };
        //Controller: POST: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{TO_CONNECTOR_ID}}/import/controller/{{FROM_CONNECTOR_ID}}
        /*
        {
                "deviceList": ["deviceId"]
        }
        */
        this.importControllersForConnector = (fromConnectorId, toConnectorId, deviceIds) => {
            const pathUrl = 'manage/connector/' + toConnectorId + '/import/controller/' + fromConnectorId;
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const jsonPayload = {
                "deviceList": deviceIds
            }; //JSON.stringify(deviceIds); 
            const connectorServiceObj = {
                method: "POST",
                path: pathUrl,
                responseType: "object",
                params: JSON.stringify(jsonPayload)
            };
            return this.post(getCMXConnectorProxyUrl, connectorServiceObj).pipe(map(this.extractResponse));
        };
        /**
         * Switch:
            POST: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{TO_CONNECTOR_ID}}/import/switch/{{FROM_CONNECTOR_ID}}
            
            Request:
            {
            "deviceList": ["deviceId"]
            }
         *
        */
        this.importSwitchesForConnector = (fromConnectorId, toConnectorId, deviceIds) => {
            const pathUrl = 'manage/connector/' + toConnectorId + '/import/switch/' + fromConnectorId;
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const jsonPayload = { "deviceList": deviceIds };
            const connectorServiceObj = {
                method: "POST",
                path: pathUrl,
                responseType: "object",
                params: JSON.stringify(jsonPayload)
            };
            return this.post(getCMXConnectorProxyUrl, connectorServiceObj).pipe(map(this.extractResponse));
        };
        /**
         * POST: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/device/connectivity/test
        */
        this.testV3Credentials = (cmxControllerObject) => {
            const pathUrl = 'manage/connector/' + cmxControllerObject.connectorId + '/device/connectivity/test';
            const cmxConnector = JSON.parse(JSON.stringify(cmxControllerObject));
            const { login } = cmxConnector;
            if (login && Object.keys(login).length) {
                const { enablePassword } = login;
                cmxConnector.login.cliCredentialsAvailable = true;
                //CSCwc85375
                /*if(cmxConnector.login.username == "")
                cmxConnector.login.username = cmxConnector.login.netconfUsername;
                if(cmxConnector.login.password == "")
                cmxConnector.login.password = cmxConnector.login.netconfPassword;*/
                if (!enablePassword.length)
                    delete cmxConnector.login.enablePassword;
            }
            cmxConnector.tenantId = this.dataService.getTenantId();
            cmxConnector.host = cmxConnector.controllerIp;
            const proxyObject = JSON.stringify(cmxConnector);
            const proxyURL = this.apiConfig.getDMSV3ProxyUrl();
            const paramObject = {
                method: "POST",
                path: pathUrl,
                responseType: "object",
                params: proxyObject
            };
            return this.post(proxyURL, paramObject).pipe(map(this.extractResponse));
        };
        /**
         * GET: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/device/connectivity/test/{{TEST_ID}}
        */
        this.verifyV3Connectivity = (connector_id, test_request_id) => {
            const pathUrl = 'manage/connector/' + connector_id + '/device/connectivity/test/' + test_request_id;
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const getConfigObj = {
                method: "GET",
                path: pathUrl,
                responseType: "object"
            };
            return this.post(getCMXConnectorProxyUrl, getConfigObj).pipe(map(this.extractResponse));
        };
        //GET: {{DMS_ENDPOINT}}/api/dms/v1/config/connector/:id/controllers
        this.getControllersForConnectors = (connectorId) => {
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSProxyUrl();
            const getConfigObj = {
                method: "GET",
                path: `config/connector/${connectorId}/controllers`,
                //	params: paramObject,
                responseType: "array"
            };
            return this.post(getCMXConnectorProxyUrl, getConfigObj).pipe(map(this.extractResponse));
        };
        //GET: {{DMS_ENDPOINT}}/api/dms/v1/config/connector/:id/switch
        this.getSwitchesForConnectors = (connectroId) => {
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSProxyUrl();
            //const paramObject = JSON.stringify({ serviceName: hotSpotServiceName });
            const getConfigObj = {
                method: "GET",
                path: `config/connector/${connectroId}/switches`,
                //	params: paramObject,
                responseType: "array"
            };
            return this.post(getCMXConnectorProxyUrl, getConfigObj).pipe(map(this.extractResponse));
        };
        //API: POST  https://dev-dnaspaces.io/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/paired-ha
        /*Body:
        {
            "vip": "<VIP_ADDRESS>"
        }*/
        this.addVirtualIp = (ipAddress, instanceInterface, toConnectorId) => {
            const pathUrl = 'manage/connector/' + toConnectorId + '/paired-ha';
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            let jsonPayload = { "vip": ipAddress };
            if (instanceInterface !== undefined) {
                jsonPayload['interface'] = instanceInterface;
            }
            const connectorServiceObj = {
                method: "POST",
                path: pathUrl,
                responseType: "object",
                params: JSON.stringify(jsonPayload)
            };
            return this.post(getCMXConnectorProxyUrl, connectorServiceObj).pipe(map(this.extractResponse));
        };
        //PUT {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/paired-ha-disable
        this.disableHAPairing = (connectorId) => {
            const pathUrl = 'manage/connector/' + connectorId + '/paired-ha-disable';
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            let jsonPayload = { "connectorId": connectorId };
            const connectorServiceObj = {
                method: "PUT",
                path: pathUrl,
                responseType: "object",
                params: JSON.stringify(jsonPayload)
            };
            return this.post(getCMXConnectorProxyUrl, connectorServiceObj).pipe(map(this.extractResponse));
        };
        //System Upgrade: Get details
        //GET: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/system/package-info
        this.getSystemUpgradeStatus = (connectroId) => {
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            //const paramObject = JSON.stringify({ serviceName: hotSpotServiceName });
            const getConfigObj = {
                method: "GET",
                path: `manage/connector/${connectroId}/system/package-info`,
                //	params: paramObject,
                responseType: "object"
            };
            return this.post(getCMXConnectorProxyUrl, getConfigObj).pipe(map(this.extractResponse));
        };
        //Details: List cloud commands sent to connector and their status.
        //POST {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/{{INSTANCE_ID}}/system/upgrade
        this.upgradeSystemInstance = (connectorId, instanceId) => {
            const pathUrl = 'manage/connector/' + connectorId + '/' + instanceId + '/system/upgrade';
            const getCMXConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const jsonPayload = { "connectorId": connectorId };
            const connectorServiceObj = {
                method: "POST",
                path: pathUrl,
                responseType: "object",
                params: JSON.stringify(jsonPayload)
            };
            return this.post(getCMXConnectorProxyUrl, connectorServiceObj).pipe(map(this.extractResponse));
        };
        // Hotspot
        // POST: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{TO_CONNECTOR_ID}}/import/hotspot/{{FROM_CONNECTOR_ID}}
        this.copyHotSotConfig = (fromConnecorId, toConnectorId) => {
            const pathUrl = 'manage/connector/' + toConnectorId + '/import/hotspot/' + fromConnecorId;
            const cmxConnectorProxyUrl = this.apiConfig.getDMSV3ProxyUrl();
            const jsonPayload = { "connectorId": toConnectorId };
            const connectorServiceObj = {
                method: "POST",
                path: pathUrl,
                responseType: "object",
                params: JSON.stringify(jsonPayload)
            };
            return this.post(cmxConnectorProxyUrl, connectorServiceObj)
                .pipe(map(this.extractResponse));
        };
    }
}
CMXConnectorsService.ɵfac = function CMXConnectorsService_Factory(t) { return new (t || CMXConnectorsService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
CMXConnectorsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CMXConnectorsService, factory: CMXConnectorsService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CMXConnectorsService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

function CmxConnectorInstancesComponent_div_0_div_18_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_status_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Summary: ", instance_status_r16.summary, " ");
} }
function CmxConnectorInstancesComponent_div_0_div_18_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_status_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Description: ", instance_status_r16.Description, " ");
} }
function CmxConnectorInstancesComponent_div_0_div_18_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_status_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Notes: ", instance_status_r16.note, " ");
} }
function CmxConnectorInstancesComponent_div_0_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br");
    i0.ɵɵtemplate(4, CmxConnectorInstancesComponent_div_0_div_18_span_4_Template, 2, 1, "span", 0);
    i0.ɵɵelement(5, "br");
    i0.ɵɵtemplate(6, CmxConnectorInstancesComponent_div_0_div_18_span_6_Template, 2, 1, "span", 0);
    i0.ɵɵelement(7, "br");
    i0.ɵɵtemplate(8, CmxConnectorInstancesComponent_div_0_div_18_span_8_Template, 2, 1, "span", 0);
    i0.ɵɵelement(9, "br");
    i0.ɵɵelement(10, "br");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_status_r16 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" ", instance_status_r16.nodeId, ": System Upgrade ", instance_status_r16.packageName, " | ", instance_status_r16.status, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", instance_status_r16.summary);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", instance_status_r16.Description);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", instance_status_r16.note);
} }
function CmxConnectorInstancesComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelement(3, "img", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵelementStart(5, "div", 16);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementStart(8, "span", 17);
    i0.ɵɵelement(9, "img", 18);
    i0.ɵɵelementStart(10, "span", 19);
    i0.ɵɵelementStart(11, "span");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "br");
    i0.ɵɵelement(15, "br");
    i0.ɵɵelement(16, "br");
    i0.ɵɵelementStart(17, "div");
    i0.ɵɵtemplate(18, CmxConnectorInstancesComponent_div_0_div_18_Template, 11, 6, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 21);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementStart(22, "a", 22);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 23);
    i0.ɵɵelementStart(28, "button", 24);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_0_Template_button_click_28_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.showSystemUpgradePopupScreen(); });
    i0.ɵɵtext(29);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 8, "dashboard-lib.setup.connectorInstances.upgrade_available"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 10, "dashboard-lib.setup.connectorInstances.upgrade_available"));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r0.systemUpgradeStatus);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 12, "dashboard-lib.setup.connectorInstances.upgrade_confirmation"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r0.connectorConfigureGuide, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 14, "dashboard-lib.setup.connectorInstances.clickHere"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 16, "dashboard-lib.setup.connectorInstances.upgrade_confirm_section2"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(30, 18, "dashboard-lib.setup.connectorInstances.upgrade"), " ");
} }
function CmxConnectorInstancesComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_5_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.configureVIP(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("ngClass", "disabled");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, "dashboard-lib.setup.connectorInstances.configureVipPairing"));
} }
function CmxConnectorInstancesComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.configureVIP(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.setup.connectorInstances.configureVipPairing"));
} }
function CmxConnectorInstancesComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_7_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.disableHAVip_pairing(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.setup.connectorInstances.disableVipPairing"));
} }
function CmxConnectorInstancesComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_8_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(); return ctx_r32.configureVIP(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.setup.connectorInstances.configureVipPairing"));
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 62);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_r36 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.setup.connectorInstances.sysVersion"), ": ", instance_r36.buildInfo.system.packageName, "");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 62);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.setup.connectorInstances.sysVersion"), ": NA");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_a_16_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 63);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_9_div_1_div_2_a_16_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r58); const instance_r36 = i0.ɵɵnextContext().$implicit; const ctx_r56 = i0.ɵɵnextContext(3); return ctx_r56.openMoreOptions(instance_r36); });
    i0.ɵɵelement(1, "img", 64);
    i0.ɵɵelementEnd();
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "div", 66);
    i0.ɵɵelement(2, "div", 67);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 68);
    i0.ɵɵelementStart(4, "ul");
    i0.ɵɵelementStart(5, "li", 69);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_9_div_1_div_2_div_17_Template_li_click_5_listener() { i0.ɵɵrestoreView(_r61); const ctx_r60 = i0.ɵɵnextContext(); const instance_r36 = ctx_r60.$implicit; const i_r37 = ctx_r60.index; const ctx_r59 = i0.ɵɵnextContext(3); return ctx_r59.restartServices(instance_r36, i_r37); });
    i0.ɵɵelementStart(6, "a", 70);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "li", 69);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_9_div_1_div_2_div_17_Template_li_click_9_listener() { i0.ɵɵrestoreView(_r61); const ctx_r63 = i0.ɵɵnextContext(); const instance_r36 = ctx_r63.$implicit; const i_r37 = ctx_r63.index; const ctx_r62 = i0.ɵɵnextContext(3); return ctx_r62.restartConnector(instance_r36, i_r37); });
    i0.ɵɵelementStart(10, "a", 70);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "li", 69);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_9_div_1_div_2_div_17_Template_li_click_13_listener() { i0.ɵɵrestoreView(_r61); const ctx_r65 = i0.ɵɵnextContext(); const instance_r36 = ctx_r65.$implicit; const i_r37 = ctx_r65.index; const ctx_r64 = i0.ɵɵnextContext(3); return ctx_r64.refreshInstance(instance_r36, i_r37); });
    i0.ɵɵelementStart(14, "a", 70);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "li", 69);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_9_div_1_div_2_div_17_Template_li_click_17_listener() { i0.ɵɵrestoreView(_r61); const ctx_r67 = i0.ɵɵnextContext(); const instance_r36 = ctx_r67.$implicit; const i_r37 = ctx_r67.index; const ctx_r66 = i0.ɵɵnextContext(3); return ctx_r66.removeInstanceConfirmPopup(instance_r36, i_r37); });
    i0.ɵɵelementStart(18, "a", 70);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "li", 69);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_9_div_1_div_2_div_17_Template_li_click_21_listener() { i0.ɵɵrestoreView(_r61); const ctx_r69 = i0.ɵɵnextContext(); const instance_r36 = ctx_r69.$implicit; const i_r37 = ctx_r69.index; const ctx_r68 = i0.ɵɵnextContext(3); return ctx_r68.viewServiceHistory(instance_r36, i_r37); });
    i0.ɵɵelementStart(22, "a", 70);
    i0.ɵɵtext(23, " Configuration history ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 4, "dashboard-lib.setup.connectorInstances.resServices"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 6, "dashboard-lib.setup.connectorInstances.resConn"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 8, "dashboard-lib.setup.connectorInstances.refresh"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 10, "dashboard-lib.setup.connectorInstances.remove"), " ");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_r36 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.setup.connectorInstances.ip_address"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(instance_r36.primaryIP);
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 51);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_r36 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.setup.connectorInstances.instance_primary"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(instance_r36.primaryIP);
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 51);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_r36 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.setup.connectorInstances.instance_secondary"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(instance_r36.secondaryIP);
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_span_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 55);
    i0.ɵɵelement(1, "img", 71);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_r36 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", instance_r36.status, " ");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_span_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 55);
    i0.ɵɵelement(1, "img", 72);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_r36 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", instance_r36.status, " ");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_span_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 73);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_r36 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", instance_r36.CTRL_CHANNEL_WS.status, " ");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_span_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 73);
    i0.ɵɵtext(1, " NA ");
    i0.ɵɵelementEnd();
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_44_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 73);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_r36 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" VIP Paired | ", instance_r36.HA_STATE.state, " ");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_44_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 73);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.setup.connectorInstances.not_paired"), " ");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 51);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_44_span_5_Template, 2, 1, "span", 56);
    i0.ɵɵtemplate(6, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_44_span_6_Template, 3, 3, "span", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_r36 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "dashboard-lib.setup.connectorInstances.instance_ha"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", instance_r36.ha && instance_r36.ha.ha_mode === "vip-paired");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", instance_r36.ha && instance_r36.ha.ha_mode !== "vip-paired");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_span_50_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 73);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_r36 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", instance_r36.vip, " ");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_span_51_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 73);
    i0.ɵɵtext(1, " NA ");
    i0.ɵɵelementEnd();
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 85);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r81 = i0.ɵɵnextContext().$implicit;
    const ctx_r83 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r83.serviceNameDisplayName.get(details_r81.name));
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 85);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r81 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(details_r81.name);
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 86);
    i0.ɵɵelement(1, "img", 71);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r81 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", details_r81.status === "Up" ? "active" : "inactive");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", details_r81.status, " ");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 87);
    i0.ɵɵelement(1, "img", 72);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r81 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", details_r81.status == "Up" ? "active" : "inactive");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", details_r81.status, " ");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 87);
    i0.ɵɵelement(1, "img", 71);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r81 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", details_r81.status === "Up" ? "active" : "inactive");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", details_r81.status, " ");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 87);
    i0.ɵɵelement(1, "img", 72);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r81 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", details_r81.status == "Up" ? "active" : "inactive");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", details_r81.status, " ");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 81);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r81 = i0.ɵɵnextContext().$implicit;
    const ctx_r89 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.setup.connectorInstances.upTime"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r89.getDurationFromTimestamp(details_r81.uptime));
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 51);
    i0.ɵɵelementStart(1, "div", 74);
    i0.ɵɵtemplate(2, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_div_2_Template, 2, 1, "div", 75);
    i0.ɵɵtemplate(3, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_div_3_Template, 2, 1, "div", 75);
    i0.ɵɵelementStart(4, "div", 76);
    i0.ɵɵtemplate(5, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_span_5_Template, 3, 2, "span", 77);
    i0.ɵɵtemplate(6, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_span_6_Template, 3, 2, "span", 78);
    i0.ɵɵelementStart(7, "div", 79);
    i0.ɵɵelementStart(8, "div", 80);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵtemplate(14, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_span_14_Template, 3, 2, "span", 78);
    i0.ɵɵtemplate(15, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_span_15_Template, 3, 2, "span", 78);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 81);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementStart(19, "span", 82);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_div_22_Template, 5, 4, "div", 83);
    i0.ɵɵelementStart(23, "div", 81);
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementStart(26, "span");
    i0.ɵɵtext(27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 84);
    i0.ɵɵelementStart(29, "span");
    i0.ɵɵtext(30);
    i0.ɵɵpipe(31, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(32, " |");
    i0.ɵɵelementStart(33, "span");
    i0.ɵɵtext(34);
    i0.ɵɵpipe(35, "translate");
    i0.ɵɵpipe(36, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r81 = ctx.$implicit;
    const i_r82 = ctx.index;
    const ctx_r54 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i_r82 === 0 ? "service-details-first" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r54.serviceNameDisplayName.get(details_r81.name) !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r54.serviceNameDisplayName.get(details_r81.name) == undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", details_r81.status === "Up");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", details_r81.status !== "Up");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 18, "dashboard-lib.setup.connectorInstances.serviceStatus"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(13, 20, "dashboard-lib.setup.connectorInstances.instanceServiceStatus"), ": ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", details_r81.status === "Up");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", details_r81.status !== "Up");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(18, 22, "dashboard-lib.setup.connectorInstances.lastHeard"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(21, 24, details_r81.updatetime, "medium"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r54.currentConnector.connectorStatus === "Active");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(25, 27, "dashboard-lib.setup.connectorInstances.lastUpgraded"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(details_r81.message);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(31, 29, "dashboard-lib.setup.connectorInstances.version"), ": ", details_r81.version, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(35, 31, "dashboard-lib.setup.connectorInstances.lastHeardOn"), " ", i0.ɵɵpipeBind2(36, 33, details_r81.updatetime, "medium"), "");
} }
function CmxConnectorInstancesComponent_div_9_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r98 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "div", 34);
    i0.ɵɵelementStart(2, "div", 35);
    i0.ɵɵelement(3, "img", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 37);
    i0.ɵɵelementStart(5, "div", 38);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CmxConnectorInstancesComponent_div_9_div_1_div_2_div_7_Template, 3, 4, "div", 39);
    i0.ɵɵtemplate(8, CmxConnectorInstancesComponent_div_9_div_1_div_2_div_8_Template, 3, 3, "div", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 40);
    i0.ɵɵelementStart(10, "div", 41);
    i0.ɵɵelementStart(11, "a", 42);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_9_div_1_div_2_Template_a_click_11_listener() { const restoredCtx = i0.ɵɵrestoreView(_r98); const instance_r36 = restoredCtx.$implicit; const i_r37 = restoredCtx.index; const ctx_r97 = i0.ɵɵnextContext(3); return ctx_r97.viewInfo(instance_r36, i_r37); });
    i0.ɵɵelement(12, "img", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "span", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 45);
    i0.ɵɵelementStart(15, "div", 46);
    i0.ɵɵtemplate(16, CmxConnectorInstancesComponent_div_9_div_1_div_2_a_16_Template, 2, 0, "a", 47);
    i0.ɵɵtemplate(17, CmxConnectorInstancesComponent_div_9_div_1_div_2_div_17_Template, 24, 12, "div", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 49);
    i0.ɵɵelementStart(19, "table", 50);
    i0.ɵɵelementStart(20, "tbody");
    i0.ɵɵelementStart(21, "tr", 51);
    i0.ɵɵelementStart(22, "td");
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "td");
    i0.ɵɵtext(26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_27_Template, 6, 4, "tr", 0);
    i0.ɵɵtemplate(28, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_28_Template, 6, 4, "tr", 52);
    i0.ɵɵtemplate(29, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_29_Template, 6, 4, "tr", 52);
    i0.ɵɵelementStart(30, "tr", 51);
    i0.ɵɵelementStart(31, "td");
    i0.ɵɵtext(32);
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "td");
    i0.ɵɵtemplate(35, CmxConnectorInstancesComponent_div_9_div_1_div_2_span_35_Template, 3, 1, "span", 53);
    i0.ɵɵtemplate(36, CmxConnectorInstancesComponent_div_9_div_1_div_2_span_36_Template, 3, 1, "span", 54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "tr", 51);
    i0.ɵɵelementStart(38, "td");
    i0.ɵɵtext(39);
    i0.ɵɵpipe(40, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "td", 55);
    i0.ɵɵtemplate(42, CmxConnectorInstancesComponent_div_9_div_1_div_2_span_42_Template, 2, 1, "span", 56);
    i0.ɵɵtemplate(43, CmxConnectorInstancesComponent_div_9_div_1_div_2_span_43_Template, 2, 0, "span", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(44, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_44_Template, 7, 5, "tr", 52);
    i0.ɵɵelementStart(45, "tr", 57);
    i0.ɵɵelementStart(46, "td");
    i0.ɵɵtext(47);
    i0.ɵɵpipe(48, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "td");
    i0.ɵɵtemplate(50, CmxConnectorInstancesComponent_div_9_div_1_div_2_span_50_Template, 2, 1, "span", 56);
    i0.ɵɵtemplate(51, CmxConnectorInstancesComponent_div_9_div_1_div_2_span_51_Template, 2, 0, "span", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "div", 58);
    i0.ɵɵelementStart(53, "table", 59);
    i0.ɵɵelementStart(54, "thead");
    i0.ɵɵelementStart(55, "tr", 51);
    i0.ɵɵelementStart(56, "th");
    i0.ɵɵelementStart(57, "div", 60);
    i0.ɵɵtext(58);
    i0.ɵɵpipe(59, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(60, "tbody");
    i0.ɵɵtemplate(61, CmxConnectorInstancesComponent_div_9_div_1_div_2_tr_61_Template, 37, 36, "tr", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_r36 = ctx.$implicit;
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", instance_r36.nodeId, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", instance_r36.buildInfo.system && instance_r36.buildInfo.system.packageName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", instance_r36.buildInfo.system == undefined || instance_r36.buildInfo.system.packageName == undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r35.showMoreOptions ? "selected" : "");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", ctx_r35.showMoreOptions ? "selected" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.selectedCustomerName === instance_r36.nodeId);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 24, "dashboard-lib.setup.connectorInstances.instance_mac"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(instance_r36.macAddress);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r35.instanceDualEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.instanceDualEnabled && instance_r36.primaryIP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.instanceDualEnabled && instance_r36.secondaryIP);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(33, 26, "dashboard-lib.setup.connectorInstances.instance_status"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", instance_r36.status === "Up");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", instance_r36.status !== "Up");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(40, 28, "dashboard-lib.setup.connectorInstances.instance_control"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", instance_r36.CTRL_CHANNEL_WS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", instance_r36.CTRL_CHANNEL_WS == undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", instance_r36.ha);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(48, 30, "dashboard-lib.setup.connectorInstances.vip_address"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", instance_r36.vip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", instance_r36.vip == undefined);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(59, 32, "dashboard-lib.setup.connectorInstances.servicesHeader"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", instance_r36.serviceDetails);
} }
function CmxConnectorInstancesComponent_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵtemplate(2, CmxConnectorInstancesComponent_div_9_div_1_div_2_Template, 62, 34, "div", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r34.instances);
} }
function CmxConnectorInstancesComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, CmxConnectorInstancesComponent_div_9_div_1_Template, 3, 1, "div", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.instances && ctx_r5.instances.length > 0);
} }
function CmxConnectorInstancesComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 88);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "span", 89);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelementStart(6, "div", 90);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 91);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 91);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div");
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 91);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div");
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementStart(27, "a", 22);
    i0.ɵɵtext(28, "documentation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 9, "dashboard-lib.setup.connectorInstances.config"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 11, "dashboard-lib.setup.connectorInstances.setup"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 13, "dashboard-lib.setup.connectorInstances.step1"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 15, "dashboard-lib.setup.connectorInstances.step1-desc"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 17, "dashboard-lib.setup.connectorInstances.step2"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 19, "dashboard-lib.setup.connectorInstances.step2-desc"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 21, "dashboard-lib.setup.connectorInstances.step3"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(26, 23, "dashboard-lib.setup.connectorInstances.step3-desc"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r6.connectorConfigureGuide, i0.ɵɵsanitizeUrl);
} }
function CmxConnectorInstancesComponent_div_14_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 107);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r99 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r99.instancerestartError, " ");
} }
function CmxConnectorInstancesComponent_div_14_div_21_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 115);
} if (rf & 2) {
    const service_r102 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r106 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r106.serviceNameDisplayName.get(service_r102.name), i0.ɵɵsanitizeHtml);
} }
function CmxConnectorInstancesComponent_div_14_div_21_div_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 115);
} if (rf & 2) {
    const service_r102 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHtml", service_r102.name, i0.ɵɵsanitizeHtml);
} }
function CmxConnectorInstancesComponent_div_14_div_21_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r112 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 110);
    i0.ɵɵelementStart(1, "span", 111);
    i0.ɵɵelementStart(2, "input", 112);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_14_div_21_div_1_Template_input_click_2_listener($event) { i0.ɵɵrestoreView(_r112); const ctx_r111 = i0.ɵɵnextContext(); const service_r102 = ctx_r111.$implicit; const i_r103 = ctx_r111.index; const ctx_r110 = i0.ɵɵnextContext(2); return ctx_r110.onServiceSelection($event, service_r102, i_r103); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 113);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CmxConnectorInstancesComponent_div_14_div_21_div_1_span_4_Template, 1, 1, "span", 114);
    i0.ɵɵtemplate(5, CmxConnectorInstancesComponent_div_14_div_21_div_1_span_5_Template, 1, 1, "span", 114);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r102 = i0.ɵɵnextContext().$implicit;
    const ctx_r104 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "appCheck-", service_r102.name, "");
    i0.ɵɵproperty("checked", ctx_r104.selectedServiceToRestart.indexOf(service_r102) > -1)("ngClass", "disabled");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "appCheck-", service_r102.name, "");
    i0.ɵɵproperty("ngClass", "disabled");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r104.serviceNameDisplayName.get(service_r102.name) !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r104.serviceNameDisplayName.get(service_r102.name) == undefined);
} }
function CmxConnectorInstancesComponent_div_14_div_21_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 118);
} if (rf & 2) {
    const service_r102 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r114 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r114.serviceNameDisplayName.get(service_r102.name), i0.ɵɵsanitizeHtml);
} }
function CmxConnectorInstancesComponent_div_14_div_21_div_2_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 118);
} if (rf & 2) {
    const service_r102 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHtml", service_r102.name, i0.ɵɵsanitizeHtml);
} }
const _c0$1k = function (a0) { return { "disabled": a0 }; };
function CmxConnectorInstancesComponent_div_14_div_21_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r120 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 110);
    i0.ɵɵelementStart(1, "span", 111);
    i0.ɵɵelementStart(2, "input", 116);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_14_div_21_div_2_Template_input_click_2_listener($event) { i0.ɵɵrestoreView(_r120); const ctx_r119 = i0.ɵɵnextContext(); const service_r102 = ctx_r119.$implicit; const i_r103 = ctx_r119.index; const ctx_r118 = i0.ɵɵnextContext(2); return ctx_r118.onServiceSelection($event, service_r102, i_r103); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 113);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CmxConnectorInstancesComponent_div_14_div_21_div_2_span_4_Template, 1, 1, "span", 117);
    i0.ɵɵtemplate(5, CmxConnectorInstancesComponent_div_14_div_21_div_2_span_5_Template, 1, 1, "span", 117);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r102 = i0.ɵɵnextContext().$implicit;
    const ctx_r105 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "appCheck-", service_r102.name, "");
    i0.ɵɵproperty("checked", ctx_r105.selectedServiceToRestart.indexOf(service_r102) > -1);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "appCheck-", service_r102.name, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$1k, service_r102.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r105.serviceNameDisplayName.get(service_r102.name) !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r105.serviceNameDisplayName.get(service_r102.name) == undefined);
} }
function CmxConnectorInstancesComponent_div_14_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 108);
    i0.ɵɵtemplate(1, CmxConnectorInstancesComponent_div_14_div_21_div_1_Template, 6, 7, "div", 109);
    i0.ɵɵtemplate(2, CmxConnectorInstancesComponent_div_14_div_21_div_2_Template, 6, 8, "div", 109);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r102 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", service_r102.name == "service-manager" || service_r102.name !== "service-manager" && service_r102.status == "DISABLED");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", service_r102.name != "service-manager" && service_r102.status == "ENABLED");
} }
function CmxConnectorInstancesComponent_div_14_button_23_Template(rf, ctx) { if (rf & 1) {
    const _r123 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_14_button_23_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r123); const ctx_r122 = i0.ɵɵnextContext(2); return ctx_r122.restartSelectedServices(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.setup.connectorInstances.res"), " ");
} }
function CmxConnectorInstancesComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r125 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelementStart(1, "div", 93);
    i0.ɵɵelementStart(2, "div", 94);
    i0.ɵɵelementStart(3, "div", 95);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 96);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_14_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r125); const ctx_r124 = i0.ɵɵnextContext(); return ctx_r124.closeRestartServices(); });
    i0.ɵɵtext(8, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 97);
    i0.ɵɵtemplate(10, CmxConnectorInstancesComponent_div_14_div_10_Template, 2, 1, "div", 98);
    i0.ɵɵelementStart(11, "div", 99);
    i0.ɵɵelementStart(12, "div", 100);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "br");
    i0.ɵɵelementStart(16, "div", 101);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "ul", 102);
    i0.ɵɵelementStart(20, "li");
    i0.ɵɵtemplate(21, CmxConnectorInstancesComponent_div_14_div_21_Template, 3, 2, "div", 103);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 104);
    i0.ɵɵtemplate(23, CmxConnectorInstancesComponent_div_14_button_23_Template, 3, 3, "button", 105);
    i0.ɵɵelementStart(24, "button", 106);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_14_Template_button_click_24_listener() { i0.ɵɵrestoreView(_r125); const ctx_r126 = i0.ɵɵnextContext(); return ctx_r126.closeRestartServices(); });
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate2("", ctx_r7.currentInstance, ": ", i0.ɵɵpipeBind1(6, 8, "dashboard-lib.setup.connectorInstances.resServices"), "");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r7.instancerestartError !== "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 10, "dashboard-lib.setup.connectorInstances.select"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 12, "dashboard-lib.setup.connectorInstances.note"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r7.availableServices);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.selectedServiceToRestart.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 14, "dashboard-lib.setup.connectorInstances.cancel"), " ");
} }
function CmxConnectorInstancesComponent_div_15_div_7_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 126);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r131 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("\u00A0", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.setup.connectorInstances.package"), "", ctx_r131.thisInstance.buildInfo.system.packageName, " \u00A0");
} }
function CmxConnectorInstancesComponent_div_15_div_7_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 126);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("\u00A0", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.setup.connectorInstances.package"), "", i0.ɵɵpipeBind1(3, 4, "dashboard-lib.setup.connectorInstances.package"), " NA \u00A0");
} }
function CmxConnectorInstancesComponent_div_15_div_7_span_10_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r135 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(".", ctx_r135.thisInstance.buildInfo.system.buildNumber, "");
} }
function CmxConnectorInstancesComponent_div_15_div_7_span_10_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function CmxConnectorInstancesComponent_div_15_div_7_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 126);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, CmxConnectorInstancesComponent_div_15_div_7_span_10_span_3_Template, 2, 1, "span", 0);
    i0.ɵɵtemplate(4, CmxConnectorInstancesComponent_div_15_div_7_span_10_span_4_Template, 1, 0, "span", 0);
    i0.ɵɵtext(5, "\u00A0 ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r133 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 4, "dashboard-lib.setup.connectorInstances.sysVer"), "", ctx_r133.thisInstance.buildInfo.system.release, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r133.thisInstance.buildInfo.system.buildNumber);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r133.thisInstance.buildInfo.system.buildNumber == undefined);
} }
function CmxConnectorInstancesComponent_div_15_div_7_span_11_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r137 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(".", ctx_r137.thisInstance.buildInfo.agent.buildNumber, "");
} }
function CmxConnectorInstancesComponent_div_15_div_7_span_11_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function CmxConnectorInstancesComponent_div_15_div_7_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 127);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, CmxConnectorInstancesComponent_div_15_div_7_span_11_span_3_Template, 2, 1, "span", 0);
    i0.ɵɵtemplate(4, CmxConnectorInstancesComponent_div_15_div_7_span_11_span_4_Template, 1, 0, "span", 0);
    i0.ɵɵtext(5, " \u00A0 ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r134 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" \u00A0", i0.ɵɵpipeBind1(2, 4, "dashboard-lib.setup.connectorInstances.agentVer"), "", ctx_r134.thisInstance.buildInfo.agent.release, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r134.thisInstance.buildInfo.agent.buildNumber);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r134.thisInstance.buildInfo.agent.buildNumber == undefined);
} }
function CmxConnectorInstancesComponent_div_15_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 122);
    i0.ɵɵelementStart(1, "span", 123);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 123);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CmxConnectorInstancesComponent_div_15_div_7_span_7_Template, 3, 4, "span", 124);
    i0.ɵɵtemplate(8, CmxConnectorInstancesComponent_div_15_div_7_span_8_Template, 4, 6, "span", 124);
    i0.ɵɵelement(9, "br");
    i0.ɵɵtemplate(10, CmxConnectorInstancesComponent_div_15_div_7_span_10_Template, 6, 6, "span", 124);
    i0.ɵɵtemplate(11, CmxConnectorInstancesComponent_div_15_div_7_span_11_Template, 6, 6, "span", 125);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r127 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(3, 8, "dashboard-lib.setup.connectorInstances.rel"), "", ctx_r127.thisInstance.connectorVersion, "\u00A0");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("\u00A0", i0.ɵɵpipeBind1(6, 10, "dashboard-lib.setup.connectorInstances.mac"), "", ctx_r127.thisInstance.macAddress, "\u00A0");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r127.thisInstance.buildInfo.system.packageName !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r127.thisInstance.buildInfo.system.packageName == undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r127.thisInstance.buildInfo && ctx_r127.thisInstance.buildInfo.system && ctx_r127.thisInstance.buildInfo.system.release);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r127.thisInstance.buildInfo && ctx_r127.thisInstance.buildInfo.agent && ctx_r127.thisInstance.buildInfo.agent.release);
} }
function CmxConnectorInstancesComponent_div_15_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 122);
    i0.ɵɵelementStart(1, "span", 123);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 123);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 127);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "br");
    i0.ɵɵelementStart(11, "span", 123);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "span", 126);
    i0.ɵɵtext(15, "Services Enabled: NA \u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "span", 126);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "span", 126);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "span", 127);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 7, "dashboard-lib.setup.connectorInstances.rel"), " NA \u00A0");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("\u00A0\u00A0", i0.ɵɵpipeBind1(6, 9, "dashboard-lib.setup.connectorInstances.mac"), "NA \u00A0");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("\u00A0\u00A0", i0.ɵɵpipeBind1(9, 11, "dashboard-lib.setup.connectorInstances.ip"), " NA \u00A0");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(13, 13, "dashboard-lib.setup.connectorInstances.lastHeard"), "NA \u00A0");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(18, 15, "dashboard-lib.setup.connectorInstances.package"), " NA \u00A0");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(21, 17, "dashboard-lib.setup.connectorInstances.sysVer"), " NA \u00A0");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(24, 19, "dashboard-lib.setup.connectorInstances.agentVer"), " NA \u00A0");
} }
function CmxConnectorInstancesComponent_div_15_div_11_li_3_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 136);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r141 = i0.ɵɵnextContext().$implicit;
    const ctx_r143 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r143.serviceNameDisplayName.get(service_r141.name));
} }
function CmxConnectorInstancesComponent_div_15_div_11_li_3_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 136);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r141 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(service_r141.name);
} }
const _c1$x = function (a0) { return { "active-block": a0 }; };
function CmxConnectorInstancesComponent_div_15_div_11_li_3_Template(rf, ctx) { if (rf & 1) {
    const _r148 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 134);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_15_div_11_li_3_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r148); const i_r142 = restoredCtx.index; const ctx_r147 = i0.ɵɵnextContext(3); return ctx_r147.showServiceTabDetails(i_r142); });
    i0.ɵɵtemplate(1, CmxConnectorInstancesComponent_div_15_div_11_li_3_span_1_Template, 2, 1, "span", 135);
    i0.ɵɵtemplate(2, CmxConnectorInstancesComponent_div_15_div_11_li_3_span_2_Template, 2, 1, "span", 135);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r141 = ctx.$implicit;
    const ctx_r139 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$x, service_r141.name === ctx_r139.selectedTab));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r139.serviceNameDisplayName.get(service_r141.name) !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r139.serviceNameDisplayName.get(service_r141.name) == undefined);
} }
function CmxConnectorInstancesComponent_div_15_div_11_tbody_6_td_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r149 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r149.serviceNameDisplayName.get(ctx_r149.currentInstanceServiceInfo.service));
} }
function CmxConnectorInstancesComponent_div_15_div_11_tbody_6_td_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r150 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r150.currentInstanceServiceInfo.service);
} }
function CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_3_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "%");
    i0.ɵɵelementEnd();
} }
function CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_3_span_2_Template, 2, 0, "span", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const detail_r152 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", detail_r152.value, "\u00A0");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", detail_r152.value != "NA");
} }
function CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "img", 139);
    i0.ɵɵtext(2, "Up");
    i0.ɵɵelementEnd();
} }
function CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "img", 140);
    i0.ɵɵtext(2, "Down");
    i0.ɵɵelementEnd();
} }
function CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_4_span_1_Template, 3, 0, "span", 0);
    i0.ɵɵtemplate(2, CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_4_span_2_Template, 3, 0, "span", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const detail_r152 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", detail_r152.value == 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", detail_r152.value == -1);
} }
function CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_5_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const detail_r152 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(detail_r152.unit);
} }
function CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_5_span_2_Template, 2, 1, "span", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const detail_r152 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", detail_r152.value, "\u00A0");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", detail_r152.value != "NA");
} }
function CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 137);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_3_Template, 3, 2, "td", 0);
    i0.ɵɵtemplate(4, CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_4_Template, 3, 2, "td", 0);
    i0.ɵɵtemplate(5, CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_td_5_Template, 3, 2, "td", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const detail_r152 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", detail_r152.displayName, ":");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", detail_r152.unit == "Percentage");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", detail_r152.unit == "Status" || detail_r152.unit == "status");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", detail_r152.unit !== "Percentage" && detail_r152.unit != "Status");
} }
function CmxConnectorInstancesComponent_div_15_div_11_tbody_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵelementStart(1, "tr", 137);
    i0.ɵɵelementStart(2, "td");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CmxConnectorInstancesComponent_div_15_div_11_tbody_6_td_5_Template, 2, 1, "td", 0);
    i0.ɵɵtemplate(6, CmxConnectorInstancesComponent_div_15_div_11_tbody_6_td_6_Template, 2, 1, "td", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CmxConnectorInstancesComponent_div_15_div_11_tbody_6_tr_7_Template, 6, 4, "tr", 138);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r140 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "dashboard-lib.setup.connectorInstances.serviceName"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r140.serviceNameDisplayName.get(ctx_r140.currentInstanceServiceInfo.service) !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r140.serviceNameDisplayName.get(ctx_r140.currentInstanceServiceInfo.service) == undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r140.currentInstanceServiceInfo.details);
} }
function CmxConnectorInstancesComponent_div_15_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 128);
    i0.ɵɵelementStart(1, "div", 129);
    i0.ɵɵelementStart(2, "ul", 130);
    i0.ɵɵtemplate(3, CmxConnectorInstancesComponent_div_15_div_11_li_3_Template, 3, 5, "li", 131);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 132);
    i0.ɵɵelementStart(5, "table", 133);
    i0.ɵɵtemplate(6, CmxConnectorInstancesComponent_div_15_div_11_tbody_6_Template, 8, 6, "tbody", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r129 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r129.availableServices);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r129.currentInstanceServiceInfo.details);
} }
function CmxConnectorInstancesComponent_div_15_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 141);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "img", 142);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.setup.connectorInstances.noInst"), " ");
} }
function CmxConnectorInstancesComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r166 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelementStart(1, "div", 93);
    i0.ɵɵelementStart(2, "div", 94);
    i0.ɵɵelementStart(3, "div", 95);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtemplate(7, CmxConnectorInstancesComponent_div_15_div_7_Template, 12, 12, "div", 119);
    i0.ɵɵtemplate(8, CmxConnectorInstancesComponent_div_15_div_8_Template, 25, 21, "div", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 96);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_15_Template_span_click_9_listener() { i0.ɵɵrestoreView(_r166); const ctx_r165 = i0.ɵɵnextContext(); return ctx_r165.closeViewInfo(); });
    i0.ɵɵtext(10, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, CmxConnectorInstancesComponent_div_15_div_11_Template, 7, 2, "div", 120);
    i0.ɵɵtemplate(12, CmxConnectorInstancesComponent_div_15_div_12_Template, 4, 3, "div", 121);
    i0.ɵɵelement(13, "div", 104);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(6, 6, "dashboard-lib.setup.connectorInstances.instance"), "", ctx_r8.instanceNameToShow, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.thisInstance !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.thisInstance === undefined);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r8.noInstanceInfoFound);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.noInstanceInfoFound);
} }
function CmxConnectorInstancesComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r168 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 143);
    i0.ɵɵelement(1, "div", 144);
    i0.ɵɵelementStart(2, "div", 145);
    i0.ɵɵelementStart(3, "div", 146);
    i0.ɵɵelement(4, "img", 147);
    i0.ɵɵelementStart(5, "div", 148);
    i0.ɵɵelementStart(6, "div", 149);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 150);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 104);
    i0.ɵɵelementStart(13, "button", 151);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_16_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r168); const ctx_r167 = i0.ɵɵnextContext(); return ctx_r167.restartConnectorConfirm(); });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "button", 106);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_16_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r168); const ctx_r169 = i0.ɵɵnextContext(); return ctx_r169.cancelRestart(); });
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 4, "dashboard-lib.setup.connectorInstances.resConnector"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 6, "dashboard-lib.setup.connectorInstances.noteVM"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 8, "dashboard-lib.setup.connectorInstances.res"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 10, "dashboard-lib.setup.connectorInstances.cancel"), " ");
} }
function CmxConnectorInstancesComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r171 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 143);
    i0.ɵɵelement(1, "div", 144);
    i0.ɵɵelementStart(2, "div", 145);
    i0.ɵɵelementStart(3, "div", 146);
    i0.ɵɵelement(4, "img", 147);
    i0.ɵɵelementStart(5, "h4", 148);
    i0.ɵɵtext(6);
    i0.ɵɵelement(7, "br");
    i0.ɵɵtext(8, " Note: It may take up to 5 minutes to remove an Instance. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 104);
    i0.ɵɵelementStart(10, "button", 151);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_17_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r171); const ctx_r170 = i0.ɵɵnextContext(); return ctx_r170.removeInstance(ctx_r170.thisInstance); });
    i0.ɵɵtext(11, " Remove ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 106);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_17_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r171); const ctx_r172 = i0.ɵɵnextContext(); return ctx_r172.cancelRremoveInstance(); });
    i0.ɵɵtext(13, " Cancel ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" Are you sure you want to Remove ", ctx_r10.thisInstance.name, " Instance?");
} }
function CmxConnectorInstancesComponent_div_18_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 157);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const history_r175 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, history_r175.initTime, "medium"));
} }
function CmxConnectorInstancesComponent_div_18_div_11_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 158);
    i0.ɵɵelementStart(1, "div", 159);
    i0.ɵɵelementStart(2, "div", 160);
    i0.ɵɵelement(3, "span", 161);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 162);
    i0.ɵɵtext(5, "Operation:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 163);
    i0.ɵɵelementStart(7, "div", 164);
    i0.ɵɵtext(8, "Service:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 165);
    i0.ɵɵtext(10, "Status:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r176 = i0.ɵɵnextContext().index;
    const ctx_r178 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngClass", ctx_r178.serviceConfigHistory.length - 1 > i_r176 ? "withBorder" : "");
} }
function CmxConnectorInstancesComponent_div_18_div_11_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 166);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 166);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const history_r175 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(history_r175.formattedData.operationName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", history_r175.formattedData.data[0].service, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", history_r175.formattedData.data[0].status, " ");
} }
function CmxConnectorInstancesComponent_div_18_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵtemplate(1, CmxConnectorInstancesComponent_div_18_div_11_div_1_Template, 3, 4, "div", 154);
    i0.ɵɵtemplate(2, CmxConnectorInstancesComponent_div_18_div_11_div_2_Template, 11, 1, "div", 155);
    i0.ɵɵtemplate(3, CmxConnectorInstancesComponent_div_18_div_11_div_3_Template, 7, 3, "div", 156);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const history_r175 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", history_r175.formattedData && history_r175.formattedData.data[0]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", history_r175.formattedData && history_r175.formattedData.data[0]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", history_r175.formattedData && history_r175.formattedData.data[0]);
} }
function CmxConnectorInstancesComponent_div_18_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2, " No Service configuration history found. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CmxConnectorInstancesComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r184 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelementStart(1, "div", 93);
    i0.ɵɵelementStart(2, "div", 94);
    i0.ɵɵelementStart(3, "div", 95);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 96);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_18_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r184); const ctx_r183 = i0.ɵɵnextContext(); return ctx_r183.closeServiceConfigPopup(); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 152);
    i0.ɵɵelementStart(9, "div", 99);
    i0.ɵɵelementStart(10, "div");
    i0.ɵɵtemplate(11, CmxConnectorInstancesComponent_div_18_div_11_Template, 4, 3, "div", 153);
    i0.ɵɵtemplate(12, CmxConnectorInstancesComponent_div_18_div_12_Template, 3, 0, "div", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", ctx_r11.currentInstance, ": Service configuration history");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r11.serviceConfigHistory);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.serviceConfigHistory && ctx_r11.serviceConfigHistory.length == 0);
} }
function CmxConnectorInstancesComponent_div_19_div_9_small_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 172);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.setup.connectorInstances.invalidIp"), " ");
} }
function CmxConnectorInstancesComponent_div_19_div_9_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r190 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 99);
    i0.ɵɵelementStart(1, "div", 173);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 173);
    i0.ɵɵelementStart(5, "div", 174);
    i0.ɵɵelementStart(6, "input", 175);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_19_div_9_div_10_Template_input_click_6_listener() { i0.ɵɵrestoreView(_r190); const ctx_r189 = i0.ɵɵnextContext(3); return ctx_r189.instanceInterfaceSelection(0); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "label", 176);
    i0.ɵɵelementStart(8, "span", 177);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 174);
    i0.ɵɵelementStart(12, "input", 175);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_19_div_9_div_10_Template_input_click_12_listener() { i0.ɵɵrestoreView(_r190); const ctx_r191 = i0.ɵɵnextContext(3); return ctx_r191.instanceInterfaceSelection(1); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "label", 176);
    i0.ɵɵelementStart(14, "span", 177);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r187 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "dashboard-lib.setup.connectorInstances.dual_primary_secondary"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", ctx_r187.instanceInterface == "PRIMARY");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 7, "dashboard-lib.setup.connectorInstances.primary"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("checked", ctx_r187.instanceInterface == "SECONDARY");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 9, "dashboard-lib.setup.connectorInstances.secondary"), " ");
} }
function CmxConnectorInstancesComponent_div_19_div_9_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r193 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_19_div_9_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r193); const ctx_r192 = i0.ɵɵnextContext(3); return ctx_r192.addVirtualIp(ctx_r192.connectorVIP, ctx_r192.instanceInterface); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.setup.connectorInstances.save"), " ");
} }
function CmxConnectorInstancesComponent_div_19_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r195 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 128);
    i0.ɵɵelementStart(1, "div", 99);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 167);
    i0.ɵɵtext(6, "Virtual IP");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 168);
    i0.ɵɵelementStart(8, "input", 169);
    i0.ɵɵlistener("keyup", function CmxConnectorInstancesComponent_div_19_div_9_Template_input_keyup_8_listener($event) { i0.ɵɵrestoreView(_r195); const ctx_r194 = i0.ɵɵnextContext(2); return ctx_r194.onKey($event); })("input", function CmxConnectorInstancesComponent_div_19_div_9_Template_input_input_8_listener($event) { i0.ɵɵrestoreView(_r195); const ctx_r196 = i0.ɵɵnextContext(2); return ctx_r196.connectorVIP = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CmxConnectorInstancesComponent_div_19_div_9_small_9_Template, 3, 3, "small", 170);
    i0.ɵɵtemplate(10, CmxConnectorInstancesComponent_div_19_div_9_div_10_Template, 17, 11, "div", 171);
    i0.ɵɵelementStart(11, "div", 104);
    i0.ɵɵtemplate(12, CmxConnectorInstancesComponent_div_19_div_9_button_12_Template, 3, 3, "button", 105);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r185 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, "dashboard-lib.setup.connectorInstances.vipDescription"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("value", ctx_r185.connectorVIP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r185.validVIP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r185.instanceDualEnabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r185.validVIP);
} }
function CmxConnectorInstancesComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r198 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelementStart(1, "div", 93);
    i0.ɵɵelementStart(2, "div", 94);
    i0.ɵɵelementStart(3, "div", 95);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 96);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_19_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r198); const ctx_r197 = i0.ɵɵnextContext(); return ctx_r197.closeConfigureVIP(); });
    i0.ɵɵtext(8, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CmxConnectorInstancesComponent_div_19_div_9_Template, 13, 7, "div", 120);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(6, 3, "dashboard-lib.setup.connectorInstances.configureVip"), ": ", ctx_r12.currentConnector.name, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r12.noInstanceInfoFound);
} }
function CmxConnectorInstancesComponent_div_20_div_12_div_2_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r203 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" (", node_r203.HAState, ")");
} }
function CmxConnectorInstancesComponent_div_20_div_12_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r208 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 174);
    i0.ɵɵelementStart(2, "input", 186);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_20_div_12_div_2_Template_input_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r208); const i_r204 = restoredCtx.index; const ctx_r207 = i0.ɵɵnextContext(3); return ctx_r207.instanceSelection(i_r204); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 176);
    i0.ɵɵelementStart(4, "span", 177);
    i0.ɵɵtext(5);
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtemplate(7, CmxConnectorInstancesComponent_div_20_div_12_div_2_span_7_Template, 2, 1, "span", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r203 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", node_r203.value)("ngClass", node_r203.sysUpgradeStatus !== "InProgress" ? "" : "disabled");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", node_r203.nodeId, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r203.HAState !== undefined);
} }
function CmxConnectorInstancesComponent_div_20_div_12_small_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "small", 172);
} }
function CmxConnectorInstancesComponent_div_20_div_12_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r210 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_20_div_12_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r210); const ctx_r209 = i0.ɵɵnextContext(3); return ctx_r209.upgradeSystemInstance(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.setup.connectorInstances.instance_upgrade"), " ");
} }
function CmxConnectorInstancesComponent_div_20_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 183);
    i0.ɵɵelementStart(1, "div", 184);
    i0.ɵɵtemplate(2, CmxConnectorInstancesComponent_div_20_div_12_div_2_Template, 9, 4, "div", 20);
    i0.ɵɵtemplate(3, CmxConnectorInstancesComponent_div_20_div_12_small_3_Template, 1, 0, "small", 170);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 185);
    i0.ɵɵtemplate(5, CmxConnectorInstancesComponent_div_20_div_12_button_5_Template, 3, 3, "button", 105);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r199 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r199.instances);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r199.validVIP);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r199.validVIP);
} }
function CmxConnectorInstancesComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r212 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelementStart(1, "div", 93);
    i0.ɵɵelementStart(2, "div", 178);
    i0.ɵɵelementStart(3, "div", 179);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelement(6, "img", 180);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 15);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 181);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_20_Template_span_click_10_listener() { i0.ɵɵrestoreView(_r212); const ctx_r211 = i0.ɵɵnextContext(); return ctx_r211.closeSystemUpgradePopup(); });
    i0.ɵɵtext(11, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, CmxConnectorInstancesComponent_div_20_div_12_Template, 6, 3, "div", 182);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 2, "dashboard-lib.setup.connectorInstances.select_instance_up"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r13.instances);
} }
function CmxConnectorInstancesComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r214 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelementStart(1, "div", 93);
    i0.ɵɵelementStart(2, "div", 178);
    i0.ɵɵelementStart(3, "div", 179);
    i0.ɵɵelementStart(4, "span", 181);
    i0.ɵɵlistener("click", function CmxConnectorInstancesComponent_div_21_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r214); const ctx_r213 = i0.ɵɵnextContext(); return ctx_r213.closeSystemUpgradeInit(); });
    i0.ɵɵtext(5, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 183);
    i0.ɵɵelementStart(7, "div", 184);
    i0.ɵɵelement(8, "img", 187);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 188);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 1, "dashboard-lib.setup.connectorInstances.success_init_upgrade"), " ");
} }
class CmxConnectorInstancesComponent {
    constructor(cmxConnectorsService, dataService, translate) {
        this.cmxConnectorsService = cmxConnectorsService;
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.emitInstanceRemoval = new EventEmitter();
        /*@Input()
        set serviceUpgradeErrorInfo(info: any){
            this.serviceUpgradeErrorInfo = info;
            console.log("All available services :: " + this.serviceUpgradeErrorInfo);
    
        }*/
        this.help = true;
        this.availableServices = [];
        this.showMoreOptions = false;
        this.selectedCustomerName = "";
        this.showServicesPopup = false;
        this.showServiceConfigPopup = false;
        this.instancerestartError = "";
        this.selectedServiceToRestart = [];
        this.showInstanceInfo = false;
        this.instanceServices = [];
        this.noInstanceInfoFound = false;
        this.currentInstance = "";
        this.servicesEnabled = 0;
        this.selectedTab = "service-manager";
        this.actualInstanceDetails = [];
        this.messageKeys = {};
        this.showRestartConfirm = false;
        this.removeInstanceConfirm = false;
        this.connectorVIP = "";
        this.validVIP = true;
        this.showSystemUpgrade = false;
        this.showSystemUpgradePopup = false;
        this.confirmUpgradeInit = false;
        this.instanceDualEnabled = false;
        this.isHAPaired = false;
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.setup.connectorInstances.title').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.title"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.name').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.name"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.ip').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.ip"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.status').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.status"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.channel').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.channel"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.actions').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.actions"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.resServices').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.resServices"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.resConn').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.resConn"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.refresh').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.refresh"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.remove').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.remove"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.serviceName').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.serviceName"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.ver').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.ver"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.lastHeard').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.lastHeard"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.upTime').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.upTime"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.upgrade').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.upgrade"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.avail').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.avail"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.config').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.config"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.setup').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.setup"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.step1').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.step1"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.step1-desc').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.step1-desc"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.step2').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.step2"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.step2-desc').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.step2-desc"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.step3').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.step3"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.step3-desc').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.step3-desc"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.select').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.select"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.note').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.note"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.instance').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.instance"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.rel').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.rel"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.mac').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.mac"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.sysVer').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.sysVer"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.package').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.package"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.agentVer').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.agentVer"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.noInst').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.noInst"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.resConnector').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.resConnector"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.noteVM').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.noteVM"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.res').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.res"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.cancel').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorInstances.cancel"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.failedInstance').subscribe((res) => {
                this.messageKeys["failedInstance"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.noServ').subscribe((res) => {
                this.messageKeys["noServ"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.resSuccess').subscribe((res) => {
                this.messageKeys["resSuccess"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.resFailed').subscribe((res) => {
                this.messageKeys["resFailed"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.delSuccess').subscribe((res) => {
                this.messageKeys["delSuccess"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.delFailed').subscribe((res) => {
                this.messageKeys["delFailed"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.connRes').subscribe((res) => {
                this.messageKeys["connRes"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.instanceRef').subscribe((res) => {
                this.messageKeys["instanceRef"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.instanceFail').subscribe((res) => {
                this.messageKeys["instanceFail"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorInstances.confFailed').subscribe((res) => {
                this.messageKeys["confFailed"] = res;
            });
        };
        this.getConnectorInstance = (connectorId) => {
            this.instances = [];
            this.actualInstanceDetails = [];
            this.isHAPaired = false;
            this.dataService.display(true);
            this.cmxConnectorsService.getConnectorInstances(connectorId).pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response && response.status) {
                    if (response.data && response.data.connectorNodes) {
                        this.instances = response.data.connectorNodes;
                        var currentTime = new Date().getTime();
                        var durationDays = 0;
                        var durationHours = 0;
                        var durationMinutes = 0;
                        this.instances.forEach((instance, index) => {
                            var _a;
                            instance.connectionDuration = "";
                            const connectionDuration = "";
                            var timestamp = (_a = instance.controlChannelStatus) === null || _a === void 0 ? void 0 : _a.connectedTime;
                            console.log("Current time is ", currentTime);
                            durationDays = currentTime - timestamp / (1000 * 3600 * 24);
                            durationHours = currentTime - (timestamp % (1000 * 3600 * 24)) * 24;
                            if (durationDays == 0) {
                            }
                            else {
                                instance.connectionDuration += "{durationDays} days ";
                            }
                            if (durationHours == 0) {
                            }
                            else {
                                instance.connectionDuration = "{durationHours} Hours ";
                            }
                            //	 this.instancesNodeIds.push(instance.nodeId);
                            //this.actualInstanceDetails.push(node);
                            this.getInstanceServiceStatus(this.currentConnector.id, instance);
                            //here add ha status/ (primary/secondary)
                            instance.value = false;
                            if (instance.ha !== undefined && instance.ha.ha_mode === 'vip-paired' && instance.HA_STATE !== undefined) {
                                this.isHAPaired = true;
                                instance.HAState = instance.HA_STATE.state;
                                instance.vip = instance.ha.vip;
                                if (instance.HAState === 'BACKUP') {
                                    instance.value = true;
                                }
                            }
                            else {
                                if (index == 0) {
                                    instance.value = true;
                                }
                            }
                            if (instance.advanceNetworkConfig !== undefined) {
                                if (instance.advanceNetworkConfig.interfaceMode == 'DUAL') {
                                    this.instanceDualEnabled = true;
                                    instance.primaryIP = instance.advanceNetworkConfig.primaryInterface.ipAddress;
                                    instance.secondaryIP = instance.advanceNetworkConfig.secondaryInterface.ipAddress;
                                }
                                else {
                                    instance.primaryIP = instance.advanceNetworkConfig.primaryInterface.ipAddress;
                                }
                            }
                        });
                        this.dataService.display(false);
                        // this.emitNodeIds.emit(this.instancesNodeIds);
                        if (this.instances && this.instances.length > 0) {
                            this.instances.forEach((node) => {
                                //this.actualInstanceDetails.push(node);
                                this.getInstanceServiceStatus(this.currentConnector.id, node);
                            });
                            console.log("actualInstanceDetails", this.actualInstanceDetails);
                        }
                    }
                    else {
                        //either no Instance is found or some error
                        this.dataService.display(false);
                    }
                }
                else {
                    //either no Instance is found or some error
                    this.dataService.setToastMessage(this.messageKeys["failedInstance"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        this.clickInstance = (instance, i) => {
            i = i / 2;
            $($(".fold-table tr.view")[i]).toggleClass("open").next(".fold").toggleClass("open");
            $($(".icon-arrow")[i]).toggleClass("down");
        };
        this.getInstanceServiceStatus = (connectorId, node) => {
            this.instanceServiceDetails = [];
            this.dataService.display(true);
            this.cmxConnectorsService.getInstanceServiceStatus(connectorId, node.nodeId).pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response && response.data) {
                    const details = response.data;
                    if (details && details.length > 0) {
                        details.forEach((service) => {
                            if (service.service && response.instance == node.nodeId) {
                                if (service.runningStatus && service.runningStatus.status) {
                                    if (service.deployConfig && service.deployConfig.imageConfig && service.deployConfig.imageConfig.latest) {
                                        if (service.connectorDeployStatus && service.connectorDeployStatus.version != undefined && service.connectorDeployStatus.version != service.deployConfig.imageConfig.latest.version) {
                                            this.instanceServiceDetails.push({ "name": service.service, "version": service.runningStatus.currentVersion, "status": service.runningStatus.status,
                                                "uptime": service.runningStatus.upTime, "updatetime": service.runningStatus.updateTime, "message": service.connectorDeployMessage, "upgrade": "yes" });
                                            //can emit service name from here as well;
                                        }
                                        else {
                                            this.instanceServiceDetails.push({ "name": service.service, "version": service.runningStatus.currentVersion, "status": service.runningStatus.status,
                                                "uptime": service.runningStatus.upTime, "updatetime": service.runningStatus.updateTime, "message": service.connectorDeployMessage, "upgrade": "no" });
                                        }
                                    }
                                    else {
                                        this.instanceServiceDetails.push({ "name": service.service, "version": service.runningStatus.currentVersion, "status": service.runningStatus.status,
                                            "uptime": service.runningStatus.upTime, "updatetime": service.runningStatus.updateTime, "message": service.connectorDeployMessage, "upgrade": "no" });
                                    }
                                }
                                else {
                                    if (service.deployConfig && service.deployConfig.imageConfig && service.deployConfig.imageConfig.latest) {
                                        this.instanceServiceDetails.push({ "name": service.service, "version": service.runningStatus.currentVersion, "status": "NA",
                                            "uptime": service.runningStatus.upTime, "updatetime": service.runningStatus.updateTime, "message": service.connectorDeployMessage, "upgrade": "no" });
                                    }
                                    else {
                                        this.instanceServiceDetails.push({ "name": service.service, "version": "NA", "status": "NA",
                                            "uptime": service.runningStatus.upTime, "updatetime": service.runningStatus.updateTime, "message": service.connectorDeployMessage, "upgrade": "no" });
                                    }
                                }
                            }
                        });
                        /* Redesign Instance page -start
                        this.actualInstanceDetails.push(node);
                        this.actualInstanceDetails.push({"serviceDetails": JSON.parse(JSON.stringify(this.instanceServiceDetails))});
                        End*/
                        node.serviceDetails = JSON.parse(JSON.stringify(this.instanceServiceDetails));
                        this.actualInstanceDetails.push(node);
                        this.instanceServiceDetails.length = 0;
                    }
                    this.dataService.display(false);
                }
            });
        };
        this.openMoreOptions = (entity) => {
            // this.showMoreOptions = entity;
            this.selectedCustomerName = entity.nodeId;
            $("body").unbind("click");
            setTimeout(() => {
                $("body").bind("click", (event) => {
                    this.closeMenu(event);
                    $("body").unbind("click");
                });
            }, 1);
        };
        this.closeMenu = (event) => {
            this.showMoreOptions = null;
            this.selectedCustomerName = "";
        };
        this.toSwitchTab = "service-manager";
        this.showServiceTabDetails = (index) => {
            this.currentInstanceServiceInfo["service"] = this.availableServices[index].name;
            this.selectedTab = this.availableServices[index].name;
            this.toSwitchTab = this.availableServices[index].name;
            this.currentInstanceServiceInfo["details"] = this.instanceInfoMap[this.selectedTab];
            console.log(" selected tab is ", this.selectedTab);
            /*	var listItems = $("ul li");
                listItems.each(function(idx, li) {
                    const that = this;
                if($(li).text() === that.selectedTab){
        
                }
            });*/
        };
        //GET: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/{{INSTANCE_ID}}/service/status
        this.viewInfo = (instance, index) => {
            this.dataService.display(true);
            this.showInstanceInfo = true;
            this.instanceNameToShow = instance.nodeId; //recent24
            this.noInstanceInfoFound = true;
            this.thisInstance = instance;
            console.log("this Instance ", this.thisInstance);
            if (this.availableServices)
                this.servicesEnabled = this.availableServices.length;
            this.currentInstanceServiceInfo = {};
            this.instanceInfoMap = {};
            this.availableServices.forEach((service, index) => {
                if (index == 0) {
                    this.selectedTab = service.name;
                }
                this.cmxConnectorsService.getConnecInstanceServiceStatus(this.currentConnector.id, instance.nodeId, service.name).pipe(takeUntil(this.unsubscribe$)).
                    subscribe((response) => {
                    if (response && response.data) {
                        const serviceMetricArray = [];
                        //this.instanceInfoMap = {};
                        console.log("instance services status is ", response);
                        this.instanceServices = response.data;
                        if (this.instanceServices && this.instanceServices.length > 0) {
                            const serviceMetricObject = {};
                            this.instanceServices.forEach((stats, index) => {
                                if (stats.metric && stats.metric.ui && stats.stats.displayValue) {
                                    //	&& stats.stats.displayValue !== "NA"){
                                    serviceMetricArray.push({ "displayName": stats.metric.ui.displayName,
                                        "value": stats.stats.displayValue,
                                        "unit": stats.metric.ui.unit });
                                }
                                else if (stats.metric && stats.metric.ui && stats.stats.value) {
                                    //	&& stats.stats.value !== "NA"){
                                    serviceMetricArray.push({ "displayName": stats.metric.ui.displayName,
                                        "value": stats.stats.value,
                                        "unit": stats.metric.ui.unit });
                                }
                            });
                            if (serviceMetricArray.length > 0) {
                                this.instanceInfoMap[service.name] = serviceMetricArray;
                            }
                            //metric.ui.displayName
                            //stats.displayValue  //stats.value  // unit is metric.ui.unit
                            //this.servicesEnabled = this.instanceServices.length;
                        }
                        this.dataService.display(false);
                        if (Object.keys(this.instanceInfoMap) && Object.keys(this.instanceInfoMap).length > 0) {
                            this.currentInstanceServiceInfo["details"] = this.instanceInfoMap['service-manager'];
                            this.noInstanceInfoFound = false;
                        }
                    }
                    else {
                        //this.noInstanceInfoFound = true;
                        this.dataService.display(false);
                    }
                });
            });
            this.showServiceTabDetails(0);
        };
        this.closeViewInfo = () => {
            this.showInstanceInfo = false;
        };
        this.restartServices = (instance, index) => {
            this.showServicesPopup = true;
            this.currentInstance = instance.nodeKey;
            this.thisInstance = instance;
            this.selectedServiceToRestart = [];
            //instance name need to add;to show on popup;
        };
        this.closeRestartServices = () => {
            this.showServicesPopup = false;
            this.selectedServiceToRestart = [];
        };
        this.restartAllServices = () => {
            const services = [];
            this.availableServices.forEach((service) => {
                if (service.status == 'ENABLED')
                    services.push(service.name);
            });
            const postBody = {
                "services": services,
                "connectorId": this.currentConnector.id,
                "configType": "latest",
                "instance": this.thisInstance.nodeId
            };
            if (services.length == 0) {
                var message = this.messageKeys["noServ"];
                message += " service";
                this.dataService.setToastMessage(message, 4000, null, null, "Failure");
            }
            this.dataService.display(true);
            this.cmxConnectorsService.restartAllServices(postBody).pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response && response.status) {
                    if (response.data.failure.length == 0) {
                        const message = this.messageKeys["resSuccess"];
                        this.dataService.setToastMessage(message, 4000, null, null, "success");
                    }
                    else {
                        var message = this.messageKeys["resFailed"];
                        const failureServices = response.data.failure;
                        failureServices.forEach((service) => {
                            message += " " + service;
                        });
                        message += " service";
                        this.dataService.setToastMessage(message, 4000, null, null, "error");
                    }
                    this.showServicesPopup = false;
                    this.dataService.display(false);
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["resFailed"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        this.restartSelectedServices = () => {
            this.dataService.display(true);
            const postBody = {
                "services": this.selectedServiceToRestart,
                "connectorId": this.currentConnector.id,
                "configType": "latest",
                "instance": this.thisInstance.nodeId
            };
            if (this.selectedServiceToRestart && this.selectedServiceToRestart.length > 0) {
                this.selectedServiceToRestart.forEach((service) => {
                    this.cmxConnectorsService.restartInstanceServices(this.currentConnector.id, this.thisInstance.nodeId, service, "latest")
                        .pipe(takeUntil(this.unsubscribe$)).
                        subscribe((response) => {
                        if (response && response.status) {
                            const message = this.messageKeys["resSuccess"];
                            this.dataService.setToastMessage(message, 4000, null, null, "success");
                            this.showServicesPopup = false;
                            this.dataService.display(false);
                        }
                        else {
                            this.dataService.setToastMessage(this.messageKeys["resFailed"], 4000, null, null, "error");
                            this.dataService.display(false);
                        }
                    });
                });
            }
        };
        this.onServiceSelection = (event, service, index) => {
            if (event.currentTarget.checked) {
                this.selectedServiceToRestart.push(this.availableServices[index].name);
            }
            else {
                this.availableServices.forEach((item, index) => {
                    if (item.name == service.name) {
                        this.selectedServiceToRestart = this.selectedServiceToRestart.splice(1);
                    }
                });
            }
        };
        this.removeInstanceConfirmPopup = (instance, index) => {
            this.removeInstanceConfirm = true;
            this.thisInstance = instance;
        };
        this.cancelRremoveInstance = () => {
            this.removeInstanceConfirm = false;
        };
        //#To Test
        this.removeInstance = (instance) => {
            const postBody = {
                "instancesId": instance.nodeId,
                "connectorId": this.currentConnector.id
            };
            this.cmxConnectorsService.deleteConnectorInstance(this.currentConnector.id, instance.nodeId).pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status && response.status) {
                    const message = this.messageKeys["delSuccess"];
                    this.dataService.setToastMessage(message, 4000, null, null, "success");
                    const connId = this.currentConnector.id;
                    this.emitInstanceRemoval.emit(connId);
                    this.getConnectorInstance(connId);
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["delFailed"], 4000, null, null, "error");
                }
                this.dataService.display(false);
                this.removeInstanceConfirm = false;
            });
        };
        this.restartConnector = (instance, index) => {
            this.showRestartConfirm = true;
            this.thisInstance = instance;
        };
        this.restartConnectorConfirm = () => {
            this.showRestartConfirm = false;
            this.dataService.display(true);
            const connId = this.currentConnector.id;
            /*
              .restartServices(postBody).
              Removed this part due to some confusion
                    this.cmxConnectorsService.restartConnectorAtInstance(this.currentConnector.id , this.thisInstance.nodeId).
                    pipe(takeUntil(this.unsubscribe$)).
            */
            const postBody = {
                "instance": this.thisInstance.nodeId,
                "connectorId": this.currentConnector.id,
                "configType": "latest" //this.allServices[index].currentConfig.version
            };
            this.cmxConnectorsService.restartInstance(connId, this.thisInstance.nodeId).pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response && response.status) {
                    this.dataService.display(false);
                    const message = this.messageKeys["connRes"];
                    this.dataService.setToastMessage(message, 4000, null, null, "success");
                    this.getConnectorInstance(connId);
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys["resFailed"], 4000, null, null, "error");
                }
            });
        };
        this.refreshInstance = (instance, index) => {
            this.dataService.display(true);
            const connId = this.currentConnector.id;
            if (instance.nodeId == undefined) {
                instance.nodeId = instance.nodeKey;
            }
            this.cmxConnectorsService.refreshInstance(connId, instance.nodeId).pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response && response.status) {
                    const message = this.messageKeys["instanceRef"];
                    this.dataService.setToastMessage(message, 4000, null, null, "success");
                    this.dataService.display(false);
                    //reload all details here
                    this.actualInstanceDetails = [];
                    this.instanceServiceDetails = [];
                    this.getConnectorInstance(connId);
                    if (this.instances && this.instances.length > 0) {
                        this.instances.forEach((node) => {
                            //this.actualInstanceDetails.push(node);
                            this.getInstanceServiceStatus(this.currentConnector.id, node);
                        });
                        console.log("actualInstanceDetails", this.actualInstanceDetails);
                    }
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys["instanceFail"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        this.cancelRestart = () => {
            this.showRestartConfirm = false;
        };
        // /api/dms/v3/manage/connector/{{CONNECTOR_ID}}/service/{{SERVICE_NAME}}/{{CONFIG_TYPE[latest|gold]}}
        ///services/upgrade  put
        //C3 Test
        /* upgradeService = (instance ,index) =>{
             this.dataService.display(true);
             const payload= {
               connectorId : this.currentConnector.id,
               services: this.availableServices,
               configType: "latest"
             }
           this.cmxConnectorsService.upgradeServices(this.currentConnector.id , ).pipe(takeUntil(this.unsubscribe$)).
           subscribe((response) =>{
             if(response && response.status){
                 this.dataService.display(true);
                 const message = "Service upgraded successfully";
                     this.dataService.setToastMessage(
                         message,
                         4000,
                         null,
                         null,
                         "success"
                     );
       
             }else{
                 this.dataService.display(false);
                 this.dataService.setToastMessage(
                     "Failed to upgrade Service",
                     4000,
                     null,
                     null,
                     "error"
                 );
             }
           });
         }*/
        this.now = null;
        this.getDurationFromTimestamp = (endTimeStamp) => {
            if (endTimeStamp) {
                this.now = new Date();
                const nowTime = this.now.getTime();
                const timeDiff = nowTime - endTimeStamp;
                const seconds = Math.floor(timeDiff / 1000);
                const minutes = Math.floor(seconds / 60);
                const hours = Math.floor(minutes / 60);
                const days = Math.floor(hours / 24);
                return `${days > 0 ? `${days} days ` : ""}${hours % 24 > 0 ? `${hours % 24} hours ` : ""}${minutes % 60 > 0 ? `${minutes % 60} minutes ` : ""}`;
                //${seconds % 60 > 0 ? `${seconds % 60} seconds ` : ""}
            }
            else {
                return 'NA';
            }
        };
        this.getDurationFromTimestampService = (endTimeStamp) => {
            if (endTimeStamp) {
                this.now = new Date();
                const nowTime = this.now.getTime();
                const timeDiff = nowTime - endTimeStamp;
                const seconds = Math.floor(timeDiff / 1000);
                const minutes = Math.floor(seconds / 60);
                const hours = Math.floor(minutes / 60);
                const days = Math.floor(hours / 24);
                return `${days > 0 ? `${days} days ` : ""}${hours % 24 > 0 ? `${hours % 24} hours ` : ""}${minutes % 60 > 0 ? `${minutes % 60} minutes ` : ""}${seconds % 60 > 0 ? `${seconds % 60} seconds ` : ""}`;
            }
            else {
                return 'NA';
            }
        };
        this.toggleHelp = () => {
            this.help = !this.help;
        };
        this.closeServiceConfigPopup = () => {
            this.showServiceConfigPopup = false;
            this.serviceConfigHistory = {};
        };
        this.viewServiceHistory = (instance, index) => {
            this.currentInstance = instance.nodeKey;
            this.showServiceConfigPopup = true;
            this.dataService.display(true);
            this.serviceConfigHistory = {};
            console.log("service configuration history");
            this.cmxConnectorsService.getServiceConfigHistory(this.currentConnector.id, instance.nodeKey).pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response && response.status && response.data) {
                    console.log("service config is ", response.data);
                    this.serviceConfigHistory = response.data.serviceHistory;
                    this.dataService.display(false);
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["confFailed"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        this.onKey = ($event) => {
            if (/^((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))$/.test(
            /*/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/*/
            this.connectorVIP)) {
                this.validVIP = true;
                return true;
            }
            else {
                this.validVIP = false;
                return false;
            }
        };
        this.getSystemUpgraeStatus = (connectorId) => {
            this.showSystemUpgradePopup = false;
            this.systemUpgradeStatus = [];
            this.cmxConnectorsService.getSystemUpgradeStatus(connectorId).pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response && response.status) {
                    //this.nodeIds = ['005056879b96', '00505687be7c'];
                    let result = response.data;
                    /*	{
                            "00505687be7c": {
                                "systemPackageInfoList": [
                                    {
                                        "systemUpgradeStatusInfo": {
                                            "status": "Available",
                                            "displayStatus": "Available"
                                        },
                                        "systemPackageInfo": {
                                            "id": 19,
                                            "tenantId": "2156",
                                            "packageType": "OVA",
                                            "packageVersion": "8.4.4.6",
                                            "installationType": "UPGRADE",
                                            "basePackageVersion": "8.4.0.88",
                                            "details": {
                                                "imageInfo": {
                                                    "buildType": "DEV",
                                                    "imageSize": "2529720320",
                                                    "dependency": {
                                                        "service-agent": "8.4.4.1",
                                                        "service-manager": "3.1.0.68"
                                                    },
                                                    "packageName": "connector3-p88-mar2023",
                                                    "packageSHA256": "62f9cf9b4f0174535475e38cbb17724a53144a85f5fecfd4a8b9781ad66dfecb"
                                                },
                                                "releaseInfo": {
                                                    "notes": "Testing upgrade - N",
                                                    "summary": "Testing upgrade",
                                                    "description": "Testing upgrade - D",
                                                    "restartRequired": "NO"
                                                }
                                            },
                                            "miscDetails": {},
                                            "createdTime": 1679630914526,
                                            "updatedTime": 1679630914526
                                        }
                                    }
                                ],
                                "upgradeState": "ALLOWED"
                            },
                            "005056879b96": {
                                "systemPackageInfoList": [
                                    {
                                        "systemUpgradeStatusInfo": {
                                            "status": "Available",
                                            "displayStatus": "Available"
                                        },
                                        "systemPackageInfo": {
                                            "id": 19,
                                            "tenantId": "2156",
                                            "packageType": "OVA",
                                            "packageVersion": "8.4.4.6",
                                            "installationType": "UPGRADE",
                                            "basePackageVersion": "8.4.0.88",
                                            "details": {
                                                "imageInfo": {
                                                    "buildType": "DEV",
                                                    "imageSize": "2529720320",
                                                    "dependency": {
                                                        "service-agent": "8.4.4.1",
                                                        "service-manager": "3.1.0.68"
                                                    },
                                                    "packageName": "connector3-p88-mar2023",
                                                    "packageSHA256": "62f9cf9b4f0174535475e38cbb17724a53144a85f5fecfd4a8b9781ad66dfecb"
                                                },
                                                "releaseInfo": {
                                                    "notes": "Testing upgrade - N",
                                                    "summary": "Testing upgrade",
                                                    "description": "Testing upgrade - D",
                                                    "restartRequired": "NO"
                                                }
                                            },
                                            "miscDetails": {},
                                            "createdTime": 1679630914526,
                                            "updatedTime": 1679630914526
                                        }
                                    }
                                ],
                                "upgradeState": "ALLOWED"
                            }
                        };*/
                    let resultObj = {};
                    //this.nodeIds.forEach(nodeId => {
                    this.instances.forEach(instance => {
                        resultObj = { nodeId: instance.nodeId, upgradeStatus: result[instance.nodeId].upgradeState };
                        if (result[instance.nodeId].systemPackageInfoList && result[instance.nodeId].systemPackageInfoList[0]
                            && result[instance.nodeId].systemPackageInfoList[0].systemPackageInfo && result[instance.nodeId].systemPackageInfoList[0].systemPackageInfo.details) {
                            if (result[instance.nodeId].systemPackageInfoList[0] && result[instance.nodeId].systemPackageInfoList[0].systemUpgradeStatusInfo) {
                                resultObj['status'] = result[instance.nodeId].systemPackageInfoList[0].systemUpgradeStatusInfo.displayStatus; //InProgress, Available, Failed 
                                instance.sysUpgradeStatus = resultObj['status'];
                            }
                            if (result[instance.nodeId].systemPackageInfoList[0].systemPackageInfo.details.releaseInfo) {
                                const detailInfoUpgrade = result[instance.nodeId].systemPackageInfoList[0].systemPackageInfo.details.releaseInfo;
                                resultObj['summary'] = detailInfoUpgrade.summary;
                                resultObj['Description'] = detailInfoUpgrade.description;
                                resultObj['note'] = detailInfoUpgrade.notes;
                            }
                            if (result[instance.nodeId].systemPackageInfoList[0].systemPackageInfo.details.imageInfo) {
                                resultObj['packageName'] = result[instance.nodeId].systemPackageInfoList[0].systemPackageInfo.details.imageInfo.packageName;
                            }
                        }
                        else {
                        }
                        this.systemUpgradeStatus.push(resultObj);
                        //result[nodeId].systemPackageInfoList && result[nodeId].systemPackageInfoList.length > 0
                        //if(result[instance.nodeId].upgradeState == 'ALLOWED'){ // check for pending as well
                        //if(result[nodeId].systemPackageInfoList && result[nodeId].systemPackageInfoList[0] && 
                        if (result[instance.nodeId].systemPackageInfoList && result[instance.nodeId].systemPackageInfoList[0] &&
                            result[instance.nodeId].systemPackageInfoList[0].systemUpgradeStatusInfo &&
                            result[instance.nodeId].systemPackageInfoList[0].systemUpgradeStatusInfo.status == 'Available') {
                            this.showSystemUpgrade = true;
                        }
                    });
                }
            });
        };
        this.instanceInterfaceSelection = (index) => {
            if (index == 0) {
                this.instanceInterface = 'PRIMARY';
            }
            else {
                this.instanceInterface = 'SECONDARY';
            }
        };
        this.disableHAVip_pairing = () => {
            this.dataService.display(true);
            this.cmxConnectorsService.disableHAPairing(this.currentConnector.id).pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response && response.status) {
                    /*
                    data
                        :
                        result
                        :
                        status
                        :
                        "SUCCESS"*/
                    if (response.data && response.data.result && response.data.result.status
                        && response.data.result.status == 'SUCCESS') {
                        //	this.emitInstanceRemoval.emit(this.currentConnector.id);
                        this.instances = [];
                        this.getConnectorInstance(this.currentConnector.id);
                    }
                }
            });
        };
        this.addVirtualIp = (ipAddress, instanceInterface) => {
            if (ipAddress === undefined || ipAddress == "") {
                this.validVIP = true;
                return;
            }
            this.dataService.display(true);
            this.cmxConnectorsService.addVirtualIp(ipAddress, instanceInterface, this.currentConnector.id).pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response && response.status && response.data) {
                    const result = response.data.result;
                    if (result.status == 'FAILED') {
                        const message = result.errMessage; //"virtual IP address added successfuly.";
                        this.dataService.setToastMessage(message, 4000, null, null, "error");
                    }
                    else {
                        const message = "virtual IP address added successfully."; //this.messageKeys["resSuccess"];
                        this.dataService.setToastMessage(message, 4000, null, null, "success");
                        //this.emitInstanceRemoval.emit(this.currentConnector.id);
                        this.instances = [];
                        this.getConnectorInstance(this.currentConnector.id);
                    }
                    this.dataService.display(false);
                }
                else {
                    this.dataService.display(false);
                    const message = "Failed to configure Virtual IP.";
                    this.dataService.setToastMessage(message, 4000, null, null, "error");
                }
                this.closeConfigureVIP();
            });
        };
        this.showSystemUpgradePopupScreen = () => {
            this.showSystemUpgradePopup = true;
            this.instances.forEach((node, i) => {
                if (this.instances[i].HAState == 'BACKUP') {
                    this.instances[i].value = true;
                }
                else {
                    this.instances[i].value = false;
                }
            });
        };
        this.closeSystemUpgradePopup = () => {
            this.showSystemUpgradePopup = false;
        };
        this.closeSystemUpgradeInit = () => {
            this.confirmUpgradeInit = false;
        };
        this.instanceSelection = (index) => {
            this.instanceToUpgrade = this.instances[index].nodeId;
            this.instances.forEach((node, i) => {
                this.instances[i].value = false;
            });
            this.instances[index].value = true;
        };
        this.upgradeSystemInstance = () => {
            this.dataService.display(true);
            this.cmxConnectorsService.upgradeSystemInstance(this.currentConnector.id, this.instanceToUpgrade).pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response && response.status) { //to be removed
                    this.confirmUpgradeInit = true;
                    this.showSystemUpgradePopup = false;
                    this.dataService.display(false);
                }
                else {
                    this.confirmUpgradeInit = false;
                    this.dataService.display(false);
                    const message = "Failed to Upgrade the Instance.";
                    this.dataService.setToastMessage(message, 4000, null, null, "error");
                }
            });
        };
        this.showConfigureVIPPopup = false;
        this.configureVIP = () => {
            this.showConfigureVIPPopup = true;
            this.connectorVIP = "";
        };
        this.closeConfigureVIP = () => {
            this.showConfigureVIPPopup = false;
            this.connectorVIP = "";
            this.instanceInterface = 'PRIMARY';
            this.validVIP = true;
        };
    }
    set availableInstances(instances) {
        this.instances = instances;
        console.log("instances are  :: " + this.instances);
    }
    set allAvailableServices(services) {
        this.availableServices = services;
        console.log("All available services :: " + this.availableServices);
    }
    /*ngOnChanges(changes: SimpleChanges) {
      setTimeout(() => {
          if (
              changes.availableInstances &&
              changes.availableInstances.currentValue != undefined
          ) {
              this.instances = changes.availableInstances.currentValue;
              this.ngOnInit();
          }
      }, 1000);
      }*/
    ngOnInit() {
        this.getConnectorInstance(this.currentConnector.id);
        this.connectorVIP = "";
        this.showSystemUpgrade = false;
        this.showSystemUpgradePopup = false;
        console.log("map for services is ", this.serviceNameDisplayName);
        console.log("specific value", this.serviceNameDisplayName.get('service-manager'));
        console.log("node Ids are ", this.nodeIds);
        /* const nodes = this.currentConnector.connectorNodes;
             const keys= Object.keys(nodes);
                 Object.keys(nodes).forEach(key => {
                    this.instances.push(nodes[key]);
                 });*/
        // this.instances = this.currentConnector.connectorNodes;
        var connectorId = this.currentConnector.id;
        console.log("available services ::", this.availableServices);
        //call {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/{{INSTANCE_ID}}/service/status API for all instances
        //structure , show .
        this.actualInstanceDetails = [];
        this.instanceServiceDetails = [];
        this.isHAPaired = false;
        if (this.instances && this.instances.length > 0) {
            this.instanceDualEnabled = false;
            this.instanceInterface = undefined;
            this.instances.forEach((node, index) => {
                //this.actualInstanceDetails.push(node);
                this.getInstanceServiceStatus(this.currentConnector.id, node);
                //here add ha status/ (primary/secondary)
                node.value = false;
                if (node.ha !== undefined && node.ha.ha_mode === 'vip-paired' && node.HA_STATE !== undefined) {
                    this.isHAPaired = true;
                    node.HAState = node.HA_STATE.state;
                    node.vip = node.ha.vip;
                    if (node.HAState === 'BACKUP') {
                        node.value = true;
                    }
                }
                else {
                    if (index == 0) {
                        node.value = true;
                    }
                }
                if (node.advanceNetworkConfig !== undefined) {
                    if (node.advanceNetworkConfig.interfaceMode == 'DUAL') {
                        this.instanceDualEnabled = true;
                        node.primaryIP = node.advanceNetworkConfig.primaryInterface.ipAddress;
                        node.secondaryIP = node.advanceNetworkConfig.secondaryInterface.ipAddress;
                    }
                    else {
                        node.primaryIP = node.advanceNetworkConfig.primaryInterface.ipAddress;
                    }
                }
            });
            console.log("actualInstanceDetails", this.actualInstanceDetails);
        }
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
            //get system upgrade status
        });
        this.confirmUpgradeInit = false;
        this.getSystemUpgraeStatus(this.currentConnector.id);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
CmxConnectorInstancesComponent.ɵfac = function CmxConnectorInstancesComponent_Factory(t) { return new (t || CmxConnectorInstancesComponent)(i0.ɵɵdirectiveInject(CMXConnectorsService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
CmxConnectorInstancesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CmxConnectorInstancesComponent, selectors: [["app-cmx-connector-instances"]], inputs: { userRole: "userRole", availableInstances: "availableInstances", allServices: "allServices", currentConnector: "currentConnector", nodeIds: "nodeIds", allAvailableServices: "allAvailableServices", connectorConfigureGuide: "connectorConfigureGuide", serviceNameDisplayName: "serviceNameDisplayName" }, outputs: { emitInstanceRemoval: "emitInstanceRemoval" }, decls: 22, vars: 18, consts: [[4, "ngIf"], [1, "subHeader"], [1, "headerSection"], ["class", "rightHeaderSection", 3, "ngClass", "click", 4, "ngIf"], ["class", "rightHeaderSection", 3, "click", 4, "ngIf"], ["class", "rightHeaderSection disabled", 3, "click", 4, "ngIf"], ["class", "connector-table-instance", 4, "ngIf"], [1, "connector-table", "help"], ["class", "help-desc", 4, "ngIf"], [1, "help_img"], ["src", "/assets/images/setupConnector/Checklist.png", 2, "width", "575px", "float", "right", "padding", "71px 59px 30px 0px"], ["class", "cmxConnectorForm controllerForm", 4, "ngIf"], ["class", "modalPopup modalPopupSm", 4, "ngIf"], [1, "update-note"], ["src", "/assets/images/setupConnector/upgrade_orange.svg", 2, "display", "inline", "float", "left", "margin-top", "10px", "width", "2%"], [1, "upgradeHeader"], [1, ""], [1, "tooltip-info"], ["src", "/assets/images/info.svg", 2, "cursor", "pointer", "width", "5%", "margin-left", "5px"], [1, "tooltiptext-info"], [4, "ngFor", "ngForOf"], [1, "upgradeMessage"], ["target", "_blank", 2, "color", "#0096d6", 3, "href"], [1, "upgradebutton"], ["id", "btn-connector-save", 1, "commonButton", 3, "click"], [1, "rightHeaderSection", 3, "ngClass", "click"], [1, "rightHeaderSection", 3, "click"], [1, "rightHeaderSection", "disabled", 3, "click"], [1, "connector-table-instance"], ["class", "userTableContainer", 4, "ngIf"], [1, "userTableContainer"], [1, "parent"], ["class", "child", 4, "ngFor", "ngForOf"], [1, "child"], [1, "instance-header"], [1, "connector_instanceSetting"], ["src", "/assets/images/setupConnector/trouble_connector.svg", 2, "display", "inline", "float", "left", "margin-top", "10px", "width", "80%"], [2, "display", "inline-block", "width", "40%", "float", "left"], [1, "instance-section", 2, "display", "block"], ["class", "ins-version-div", 4, "ngIf"], [1, "instance-rightSection"], [1, "userActionsMenu", 3, "ngClass"], ["href", "javascript:void(0)", 1, "userEditIcon", "info-pipes", 3, "click"], ["src", "/assets/images/setupConnector/info.svg", "alt", "Info Icon"], [1, "info-icon-border"], [1, "columnData_header"], [1, "userActionsMenu_instance", 3, "ngClass"], ["href", "javascript:void(0)", "class", "userEditIcon showMoreIcon", 3, "click", 4, "ngIf"], ["class", "menu-l show-menu", 4, "ngIf"], [1, "instance-details"], [1, "table", "userTable", "fold-table", "instance-table"], [1, "tableTr", "textUppercase"], ["class", "tableTr textUppercase", 4, "ngIf"], ["class", "columnData userAccess active", "class", "instance-column", 4, "ngIf"], ["class", "columnData userAccess inactive", "class", "instance-column", 4, "ngIf"], [1, "instance-column"], ["class", "columnData", 4, "ngIf"], [1, "tableTr", "textUppercase", 2, "border-bottom", "1px solid #eee !important"], [1, "instance-services"], [1, "table", "userTable", "tableSection", "instance-table"], [1, "service_detHeader"], ["class", "tableTr textUppercase", 4, "ngFor", "ngForOf"], [1, "ins-version-div"], ["href", "javascript:void(0)", 1, "userEditIcon", "showMoreIcon", 3, "click"], ["src", "/assets/images/setupConnector/more.svg", 1, "menu-open-img"], [1, "menu-l", "show-menu"], [1, "show-menu-notch"], [1, "inner"], [1, "action-list"], [1, "", 3, "click"], ["href", "javascript:void(0)", 1, "userEditIcon"], ["src", "/assets/images/setupConnector/up.svg", 1, "statusAsset"], ["src", "/assets/images/setupConnector/down.svg", 1, "statusAsset"], [1, "columnData"], [1, "service-details", 3, "ngClass"], ["class", "service-name", 4, "ngIf"], [1, "service-status", "tooltip"], ["class", "columnData userAccess", "style", "margin-right: 17px;", 3, "ngClass", 4, "ngIf"], ["class", "columnData userAccess", 3, "ngClass", 4, "ngIf"], [1, "tooltiptext"], [1, "service-header"], [1, "service_status_details"], [1, "detail_value"], ["class", "service_status_details", 4, "ngIf"], [1, "service-version"], [1, "service-name"], [1, "columnData", "userAccess", 2, "margin-right", "17px", 3, "ngClass"], [1, "columnData", "userAccess", 3, "ngClass"], [1, "help-desc"], [2, "font-family", "CiscoSans", "font-style", "normal", "font-weight", "300", "font-size", "24px", "line-height", "33px", "letter-spacing", "0.5px", "color", "#121212"], [2, "font-family", "CiscoSans", "font-size", "16px", "font-style", "normal", "font-weight", "350", "line-height", "19px", "letter-spacing", "0.5px", "text-align", "left", "margin-top", "30px"], [1, "steps1"], [1, "cmxConnectorForm", "controllerForm"], [1, "modalPopup", "modalPopupLg", "wlcConnectorPopup"], [1, "modalContent-connector"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody", 2, "overflow-y", "auto", "margin-left", "58px"], ["class", "fieldWrapper error", 4, "ngIf"], [1, "fieldWrapper"], [1, "fieldLabel"], [1, "fieldLabel-note"], [2, "padding", "0"], ["class", "am-appselector", 4, "ngFor", "ngForOf"], [1, "modalFooter"], ["id", "btn-connector-save", "class", "commonButton", 3, "click", 4, "ngIf"], [1, "cancelButton", 3, "click"], [1, "fieldWrapper", "error"], [1, "am-appselector"], ["class", "check-sel", 4, "ngIf"], [1, "check-sel"], [1, "circularCheckbox"], ["type", "checkbox", "name", "expires", 3, "checked", "id", "ngClass", "click"], [1, "checkboxLabel", 3, "ngClass", "for"], ["class", "check-label-disabled", 3, "innerHtml", 4, "ngIf"], [1, "check-label-disabled", 3, "innerHtml"], ["type", "checkbox", "name", "expires", 3, "checked", "id", "click"], ["class", "check-label", 3, "innerHtml", 4, "ngIf"], [1, "check-label", 3, "innerHtml"], ["class", "subHeader-detail", 4, "ngIf"], ["class", "modalBody body_detail", "style", "overflow-y: auto;", 4, "ngIf"], ["class", "modalBody", "style", "overflow-y: auto; padding-left: 270px !important; padding-top: 220px !important;", 4, "ngIf"], [1, "subHeader-detail"], [1, "endPipe", "align"], ["class", "align endPipe", 4, "ngIf"], ["class", "align", 4, "ngIf"], [1, "align", "endPipe"], [1, "align"], [1, "modalBody", "body_detail", 2, "overflow-y", "auto"], [1, "header"], [1, "header-inner"], ["id", "link-locdetails-aps", "class", "header-blocks noselect", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "info-div"], [1, "table", "userTable", "instanceInfoTable"], ["id", "link-locdetails-aps", 1, "header-blocks", "noselect", 3, "ngClass", "click"], ["class", "active-name", 4, "ngIf"], [1, "active-name"], [1, "tableTr", "detailInstance"], ["class", "tableTr detailInstance", 4, "ngFor", "ngForOf"], ["src", "/assets/images/setupConnector/up.svg", 1, "statusAsset", 2, "margin-right", "5px"], ["src", "/assets/images/setupConnector/down.svg", 1, "statusAsset", 2, "margin-right", "5px"], [1, "modalBody", 2, "overflow-y", "auto", "padding-left", "270px !important", "padding-top", "220px !important"], ["src", "/assets/images/setupConnector/not_configured.svg", 1, "image-img"], [1, "modalPopup", "modalPopupSm"], [1, "modalOverlay"], [1, "modalContent", "textCenter"], [1, "modalBody"], ["src", "/assets/images/warning.svg", "width", "50", 1, "warningIcon"], [1, "warningPopupHeading"], [1, "conf-main-text"], [1, "conf-sub-text"], [1, "primaryButton", 3, "click"], [1, "modalBody", 2, "overflow-y", "auto", "margin-left", "36px", "margin-top", "25px"], ["class", "parent", 4, "ngFor", "ngForOf"], ["class", "child_time", 4, "ngIf"], ["class", "steps-reset child", 4, "ngIf"], ["class", "child", 4, "ngIf"], [1, "child_time"], [1, "steps-reset", "child"], [1, "step-header"], [1, "step_index"], [2, "width", "8px", "height", "8px", "left", "765px", "top", "2671px", "background", "#838383"], [1, "config-header", "step1"], [1, "step_content", 3, "ngClass"], [1, "config-header", "step2"], [1, "config-header", "step2", 2, "padding-top", "10px"], [2, "margin-top", "10px"], ["_ngcontent-yts-c185", "", 1, "fieldLabel", "virtaul-ip"], [1, "ng-star-inserted"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter VIP ", 1, "portalNameInput", 3, "value", "keyup", "input"], ["class", "error", 4, "ngIf"], ["class", "fieldWrapper", 4, "ngIf"], [1, "error"], [1, "dual-interface-option"], [1, "pmxRadio", "pmxRadio-upgrade"], ["type", "radio", "value", "thisinstance", "name", "value", 1, "pmxRadioButton", "ac-radio", "nodeInstanceRadio", 3, "checked", "click"], ["for", "accessOption", 1, "pmxRadioButtonLabel", "ac-radio-label"], [1, "ac-sel-header"], [1, "modalContent-connector", "modalContent", "textCenter", "popupUpgrades"], [1, "modalHeader", "modalHeader-upgrade"], ["src", "/assets/images/setupConnector/upgrade_orange.svg", 1, "upgrade-img"], [1, "modalCloseIcon", "modalCloseIcon", 3, "click"], ["class", "modalBody body_detail modalBody-upgrade", "style", "overflow-y: auto;", 4, "ngIf"], [1, "modalBody", "body_detail", "modalBody-upgrade", 2, "overflow-y", "auto"], [1, "instances-upgrade"], [1, "modalFooter", "modalFooter-upgrade"], ["type", "radio", "value", "thisinstance", "name", "value", 1, "pmxRadioButton", "ac-radio", "nodeInstanceRadio", 3, "checked", "ngClass", "click"], ["src", "/assets/images/setupConnector/success_upgrade.svg", 1, "upgrade-doneImg"], [1, "upgrade-init"]], template: function CmxConnectorInstancesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CmxConnectorInstancesComponent_div_0_Template, 31, 20, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, CmxConnectorInstancesComponent_div_5_Template, 3, 4, "div", 3);
        i0.ɵɵtemplate(6, CmxConnectorInstancesComponent_div_6_Template, 3, 3, "div", 4);
        i0.ɵɵtemplate(7, CmxConnectorInstancesComponent_div_7_Template, 3, 3, "div", 4);
        i0.ɵɵtemplate(8, CmxConnectorInstancesComponent_div_8_Template, 3, 3, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, CmxConnectorInstancesComponent_div_9_Template, 2, 1, "div", 6);
        i0.ɵɵelementStart(10, "div", 7);
        i0.ɵɵtemplate(11, CmxConnectorInstancesComponent_div_11_Template, 29, 25, "div", 8);
        i0.ɵɵelementStart(12, "div", 9);
        i0.ɵɵelement(13, "img", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(14, CmxConnectorInstancesComponent_div_14_Template, 27, 16, "div", 11);
        i0.ɵɵtemplate(15, CmxConnectorInstancesComponent_div_15_Template, 14, 8, "div", 11);
        i0.ɵɵtemplate(16, CmxConnectorInstancesComponent_div_16_Template, 19, 12, "div", 12);
        i0.ɵɵtemplate(17, CmxConnectorInstancesComponent_div_17_Template, 14, 1, "div", 12);
        i0.ɵɵtemplate(18, CmxConnectorInstancesComponent_div_18_Template, 13, 3, "div", 11);
        i0.ɵɵtemplate(19, CmxConnectorInstancesComponent_div_19_Template, 10, 5, "div", 11);
        i0.ɵɵtemplate(20, CmxConnectorInstancesComponent_div_20_Template, 13, 4, "div", 11);
        i0.ɵɵtemplate(21, CmxConnectorInstancesComponent_div_21_Template, 12, 3, "div", 11);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showSystemUpgrade);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 16, "dashboard-lib.setup.connectorInstances.title"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.instances && ctx.instances.length == 1 && ctx.currentConnector.connectorRelease === "3.1" && !ctx.isHAPaired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.instances && ctx.instances.length > 1 && ctx.currentConnector.connectorRelease === "3.1" && !ctx.isHAPaired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.instances && ctx.instances.length > 1 && ctx.currentConnector.connectorRelease === "3.1" && ctx.isHAPaired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.instances && ctx.instances.length > 1 && ctx.currentConnector.connectorRelease !== "3.1");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.instances && ctx.instances.length > 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.help);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showServicesPopup);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showInstanceInfo);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showRestartConfirm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.removeInstanceConfirm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showServiceConfigPopup);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showConfigureVIPPopup);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showSystemUpgradePopup);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.confirmUpgradeInit);
    } }, directives: [i1$2.NgIf, i1$2.NgForOf, i1$2.NgClass], pipes: [i2.TranslatePipe, i1$2.DatePipe], styles: [".cmxConnectorWrapper[_ngcontent-%COMP%]{margin:0;position:relative;height:100%;overflow-y:hidden}.cmxConnectorAdd[_ngcontent-%COMP%]{display:block;margin:0 0 30px;height:100%;position:relative}.cmxConnectorHeading[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";font-size:14px;color:#4d4d4d;display:inline-block;margin-top:10px;min-width:100%}.addUuidDiv[_ngcontent-%COMP%]{float:right;clear:right;font-size:16px;font-family:ciscoSansRegular;color:#049fd9;cursor:pointer}.saveUUID[_ngcontent-%COMP%]{width:auto;padding:8px 18px;height:34px;border:1px solid #049fd9;margin-right:20px}.cmxConnectorName[_ngcontent-%COMP%]{max-width:280px;margin-bottom:0;margin-right:20px}.cmxConnectorListWrapper[_ngcontent-%COMP%]{margin:20px 0}.cmxConnectorBox[_ngcontent-%COMP%]{padding:20px 30px;background-color:#fff;border-bottom:1px solid #dddfe2;font-size:16px;font-family:\"ciscoSansLight\";color:#4d4d4d}.cmxConnectorBox[_ngcontent-%COMP%]:hover{background-color:#f6f8f9}.cmxConnectorDeleteBtn[_ngcontent-%COMP%]{float:right;clear:right;margin-top:-8px}.modalPopup.connectorPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease}.modalPopup[_ngcontent-%COMP%] > .modalContent-connector[_ngcontent-%COMP%]{width:60%;right:0;height:100%;z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #abc233;animation:slide .5s forwards}@keyframes slide{65%{right:0}}.modalPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:24px 1px 3px 50px!important;color:#545454;font-size:24px;height:initial}.modalPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:8px 0}.modalPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{height:initial;align-items:center;padding:0;background-color:#ffffffe6;z-index:9999}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{padding:24px 30px;height:24px;line-height:32px}.select-menu[_ngcontent-%COMP%]{height:30px;min-width:100px;padding-left:0;border-bottom:1px solid #ddd;background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_down.svg) no-repeat right center;float:left;margin:0 10px;cursor:pointer}.select-menu[_ngcontent-%COMP%]   .first[_ngcontent-%COMP%]{padding:5px 10px;z-index:2;width:100%}.select-item-container[_ngcontent-%COMP%]{width:100%;border:1px solid #ddd;background:#ffffff;max-height:150px;overflow:auto;position:relative;z-index:999}.select-item[_ngcontent-%COMP%]{padding:10px}.select-item-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:not(.first):hover{background:#09f;color:#fff}.select-item-container[_ngcontent-%COMP%] > .selected[_ngcontent-%COMP%]{display:none}.select-item[_ngcontent-%COMP%]   .first[_ngcontent-%COMP%]{cursor:pointer}.select-custom-2[_ngcontent-%COMP%]{width:60%!important;margin:10px 0!important;font-size:15px;outline:none}.fieldWrapper[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px}.fieldLabel[_ngcontent-%COMP%], .fieldValue[_ngcontent-%COMP%], .fieldWrapper[_ngcontent-%COMP%]{padding:10px 0}.fieldWrapper[_ngcontent-%COMP%]:not(:last-child){border-bottom:1px solid #e5e5e5}.accessToken[_ngcontent-%COMP%]   .fieldWrapper[_ngcontent-%COMP%]{border-bottom:none}.controllerForm[_ngcontent-%COMP%]   .fieldWrapper[_ngcontent-%COMP%]{border-bottom:none}.fieldLabel[_ngcontent-%COMP%]{font-family:ciscoSans;width:50%;display:inline-block;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:16px;line-height:20px;letter-spacing:.5px;color:#121212}.fieldValue[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans;width:50%;display:inline-block;font-weight:bold}.modalBody[_ngcontent-%COMP%]   .controllerName[_ngcontent-%COMP%]{font-size:24px;font-weight:bold}.boxWrapper[_ngcontent-%COMP%]{border:1px solid #e5e5e5;padding:10px 20px}.fieldDescriptiveLabel[_ngcontent-%COMP%]{width:80%;display:inline-block;padding:10px 0}.fieldDescriptiveLabel[_ngcontent-%COMP%]   .fieldTitle[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans}.fieldDescriptiveLabel[_ngcontent-%COMP%]   .fieldDescription[_ngcontent-%COMP%]{font-size:12px}.fieldPicker[_ngcontent-%COMP%]{display:inline-block}.fieldPickerTitle[_ngcontent-%COMP%]{font-size:12px;color:#3e3e3e;font-family:ciscoSans;padding:10px 0}.fieldSwitch[_ngcontent-%COMP%]{width:20%;display:inline-block;position:relative;top:-10px;text-align:right}.switch[_ngcontent-%COMP%]{position:relative;display:inline-block;width:60px;height:34px}.switch[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{opacity:0;width:0;height:0}.slider[_ngcontent-%COMP%]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;transition:.4s}.slider[_ngcontent-%COMP%]   ges[_ngcontent-%COMP%]{padding:10px 27px}.slider[_ngcontent-%COMP%]:before{position:absolute;content:\"\";height:26px;width:26px;left:4px;bottom:4px;background-color:#fff;transition:.4s}input[_ngcontent-%COMP%]:checked + .slider[_ngcontent-%COMP%]{background-color:#049fd9}input[_ngcontent-%COMP%]:focus + .slider[_ngcontent-%COMP%]{box-shadow:0 0 1px #049fd9}input[_ngcontent-%COMP%]:checked + .slider[_ngcontent-%COMP%]:before{transform:translate(26px)}.slider.round[_ngcontent-%COMP%]{border-radius:5px}.slider.round[_ngcontent-%COMP%]:before{border-radius:5px}.cmxConnectorForm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .cmxConnectorForm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}.cmxConnectorForm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .select-menu[_ngcontent-%COMP%]{background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_up.svg) no-repeat right center;font-size:14px}.cmxConnectorForm[_ngcontent-%COMP%]   .menuActive[_ngcontent-%COMP%]{background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_down.svg) no-repeat right center!important}.cmxConnectorForm[_ngcontent-%COMP%]   .select-item-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:hover{background:#dfdfdf;color:#000}.cmxConnectorForm[_ngcontent-%COMP%]   .menuActive[_ngcontent-%COMP%] > .select-item.first[_ngcontent-%COMP%]{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .select-item.first[_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;border:none;border-radius:10px}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:hover, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:hover{background-color:#026e97;color:#fff;border:none}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:active, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:active{background-color:#014f6c;color:#fff;border:none}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]{background-color:#fff;color:#049fd9;border-radius:10px;border:1px solid #049fd9;margin-right:10px}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:hover, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:hover{background-color:#026e97;color:#fff;border:none}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:active, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:active{background-color:#014f6c;color:#fff;border:none}.showPassword[_ngcontent-%COMP%]{padding-left:5px;bottom:1px;font-size:12px;font-weight:bold;font-family:ciscoSans;color:#6674c3;cursor:pointer}.showPasswordAT[_ngcontent-%COMP%]{bottom:30px!important}input[type=password][_ngcontent-%COMP%] > span[_ngcontent-%COMP%] + .showPassword[_ngcontent-%COMP%]{color:#6674c3}.select-item-container[_ngcontent-%COMP%]{margin-bottom:40px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:20%;padding-left:30px}.table.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:11.66%}.circularCheckbox[_ngcontent-%COMP%]{vertical-align:middle;padding-right:15px;display:inline-block}.userDetailLabel[_ngcontent-%COMP%]{display:inline-block}.userNameLink[_ngcontent-%COMP%]{font-size:12px;color:#414f5f!important;font-family:\"ciscoSansRegular\";font-weight:bold}.version[_ngcontent-%COMP%], .ipAddress[_ngcontent-%COMP%]{opacity:.8;font-family:\"ciscoSansRegular\";font-size:11px;color:#333;display:block}.userListEmail[_ngcontent-%COMP%]{opacity:.8;font-family:\"ciscoSansRegular\";font-size:11px;color:#333;display:block}.userAccess[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.columnData[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b;width:20%}.statusPending[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;font-weight:600;color:#f86969}.confirmResendLink[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";font-size:12px;font-weight:600;color:#049fd9;text-decoration:underline}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%]{text-align:center;display:none;width:115px}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   div.userActionsMenu[_ngcontent-%COMP%]{display:inline;border-right:1px solid #dee0e1}.userTable[_ngcontent-%COMP%]   div.userActionsMenu_instance[_ngcontent-%COMP%]{text-align:center;display:none;width:115px;padding-left:4px}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   div.userActionsMenu_instance[_ngcontent-%COMP%]{display:inline}.userTable.fold-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(even):hover{background:#fff!important}.userTable.fold-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd):hover{background:#fff}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover{background:#fff}.userTable[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]:hover{background:#fff!important}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative;padding:0 10px;text-decoration:none;outline:none}.userTable[_ngcontent-%COMP%]   div.userActionsMenu_instance[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative;padding:0 10px;text-decoration:none;outline:none}.userListLabel[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}.userListName[_ngcontent-%COMP%]{display:block;cursor:pointer}.userPendingStatus[_ngcontent-%COMP%]{display:block}.width35[_ngcontent-%COMP%]{min-width:35px;display:inline-block;height:20px}.controllerForm[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:calc(100% - 165px)}.controllerForm[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{height:78px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{min-width:600px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0;height:30px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:auto;margin-bottom:0}.warningPopupHeading[_ngcontent-%COMP%]{margin-bottom:15px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{padding:0 20px 20px;border-top:none;position:relative;height:auto}.accessTokenValue[_ngcontent-%COMP%]{padding:40px 20px;border:1px solid #c4c4c4;margin:20px 0;word-break:break-all;-webkit-user-select:all;user-select:all}.disabledField[_ngcontent-%COMP%]{background-color:#f2f2f2}.createNewWrapper[_ngcontent-%COMP%]{color:#079fd9;font-family:sans-serif;font-size:14px;cursor:pointer;display:inline-block}.createNewWrapper[_ngcontent-%COMP%]:hover{color:#007199}.paddingR10[_ngcontent-%COMP%]{padding-right:10px}.createNewWrapper.vertical[_ngcontent-%COMP%]{padding-right:20px;margin-right:20px;border-right:1px solid #c4c4c4}span.userAccess.active[_ngcontent-%COMP%]{color:green}span.userAccess.inactive[_ngcontent-%COMP%]{color:#cd5c5c}.customerNameDropdown[_ngcontent-%COMP%]{width:180px!important;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.modalPopup.modalPopupSm[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{width:45%;min-width:360px;padding:20px}.paddingB40[_ngcontent-%COMP%]{padding-bottom:40px}.controllerIPInput[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:disabled, .disabled[_ngcontent-%COMP%]{opacity:.3;cursor:not-allowed;pointer-events:none}.userActionsMenu[_ngcontent-%COMP%]{position:relative;white-space:nowrap;float:left;display:inline}.userActionsMenu_instance[_ngcontent-%COMP%]{position:relative;white-space:nowrap;display:inline}.showMoreIcon[_ngcontent-%COMP%]{margin-left:-15px}.userEditIcon.configure[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:20px}.controllerEditIcon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:14px}.menu-l[_ngcontent-%COMP%]{position:absolute;right:20px;top:35px;border-radius:0;box-shadow:0 0 3px #0000004d}.menu-open-img[_ngcontent-%COMP%]{height:16px;padding-left:4px}.action-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0;margin:0}select[_ngcontent-%COMP%]{border:none;background:none}.upgrade-icon[_ngcontent-%COMP%]{width:15px;transform:rotate(-90deg);margin-left:10px}.connector-graph[_ngcontent-%COMP%]{margin-top:50px}.connector-graph[_ngcontent-%COMP%]   .connector-graph-loading[_ngcontent-%COMP%]{text-align:center}.chart-legend-count[_ngcontent-%COMP%]{white-space:nowrap}.show-menu-notch[_ngcontent-%COMP%]{position:absolute;right:-1px;background:transparent;top:-10px;width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid #dfdfdf}.show-menu-notch[_ngcontent-%COMP%]   .inner[_ngcontent-%COMP%]{position:relative;right:9px;background:transparent;top:2px;width:0;height:0;border-left:9px solid transparent;border-right:9px solid transparent;border-bottom:9px solid white}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0;height:30px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:auto;margin-bottom:0}.warningPopupHeading[_ngcontent-%COMP%]{margin-bottom:15px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{padding:0 20px 20px;border-top:none;position:relative;height:auto;color:#373737}.manageStreamsContent[_ngcontent-%COMP%]{width:60%!important}.lineChartTitle[_ngcontent-%COMP%]{fill:#111;color:#111;font-size:14px;font-weight:700;font-family:ciscoSans;padding:10px;text-align:center}span.outgoing[_ngcontent-%COMP%]{background-color:#2f7ebb;border:1px solid #4059aa}span.incoming[_ngcontent-%COMP%]{background-color:#be60a6;border:1px solid #be60a6}.legendName[_ngcontent-%COMP%]{font-size:12px;color:#abacac;font-weight:600;font-family:ciscoSansLight}.legendRect[_ngcontent-%COMP%]{display:inline-block;padding:6px;border-radius:3px}.legendTitle[_ngcontent-%COMP%]{font-size:12px;color:#000;font-family:CiscoSans;padding-left:3px;font-weight:300;letter-spacing:.43px}.cli[_ngcontent-%COMP%]{padding-top:15px}.cli[_ngcontent-%COMP%]   .cli-heading[_ngcontent-%COMP%]{font-family:ciscoSansRegular}.cli[_ngcontent-%COMP%]   .messages[_ngcontent-%COMP%]{padding:10px 27px}.cli[_ngcontent-%COMP%]   .cli-commands[_ngcontent-%COMP%]{margin-top:10px;border:1px dashed black;border-radius:15px;padding:20px}.cli[_ngcontent-%COMP%]   .cli-commands[_ngcontent-%COMP%]   .copy-command[_ngcontent-%COMP%]{text-align:right}.cli[_ngcontent-%COMP%]   .cli-commands[_ngcontent-%COMP%]   .copy-command[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-family:FontAwesome!important;cursor:pointer}.cli[_ngcontent-%COMP%]   .cli-commands[_ngcontent-%COMP%]   .commands[_ngcontent-%COMP%]{padding:10px}.success[_ngcontent-%COMP%]{color:green}.error[_ngcontent-%COMP%]{color:#f86969}.warning[_ngcontent-%COMP%]{color:#efa741}.spinner[_ngcontent-%COMP%]{width:1.5rem;height:1.5rem;margin:10px;animation:spinner .7s linear infinite;border-style:solid;border-width:2px;border-radius:50%;box-sizing:border-box;display:inline-block;vertical-align:middle;border-color:#049fd9 #049fd9 #049fd9 transparent}@keyframes spinner{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.wlcRadioLabel[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\"}.wlcRadioButton[_ngcontent-%COMP%]{font-size:20px}.wlcRadioButtonLabel[_ngcontent-%COMP%]{top:2px;position:relative;margin:12px}.pingStats[_ngcontent-%COMP%]{padding:5px 0}.pingStats[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-family:FontAwesome!important}.connectivity-messages[_ngcontent-%COMP%]{border:2px dashed #945454;background-color:#d8d8d8;border-radius:10px;padding:15px}.connectivity-messages[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{padding:2px 0}.manage-connector[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]{margin:20px 0}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]{display:flex}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]{width:100%}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{display:flex}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .primary-heading[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .primary-heading[_ngcontent-%COMP%]{flex:1;font-size:20px;font-weight:bold}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .primary-heading[_ngcontent-%COMP%]   .operation-status[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .primary-heading[_ngcontent-%COMP%]   .operation-status[_ngcontent-%COMP%]{font-size:14px;padding:4px;border-radius:5px;color:#fff}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .fieldSwitch[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .fieldSwitch[_ngcontent-%COMP%]{top:0px}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .secondary-heading[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .secondary-heading[_ngcontent-%COMP%]{padding:10px 0}.manage-connector[_ngcontent-%COMP%]   .controllers[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .controllers[_ngcontent-%COMP%]{margin:20px 0}.manage-connector[_ngcontent-%COMP%]   .no-support[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .no-support[_ngcontent-%COMP%]{color:#ff4500;border-radius:5px;border:1px dotted black;padding:10px}.manage-controller[_ngcontent-%COMP%]   .controllers[_ngcontent-%COMP%]   .noData[_ngcontent-%COMP%]{padding:10px;border:1px solid #eee;text-align:center}.manage-controller[_ngcontent-%COMP%]   .controllers[_ngcontent-%COMP%]   .disable-row[_ngcontent-%COMP%]{pointer-events:none;background-color:#f2f2f2;opacity:.7}.streamAuth[_ngcontent-%COMP%]   .keys[_ngcontent-%COMP%], .certificate[_ngcontent-%COMP%]   .keys[_ngcontent-%COMP%]{border:2px solid #eee;border-radius:5px;padding:20px;height:20vh;overflow-y:scroll;word-break:break-word;white-space:break-spaces}.streamAuth[_ngcontent-%COMP%]   .copyContent[_ngcontent-%COMP%], .certificate[_ngcontent-%COMP%]   .copyContent[_ngcontent-%COMP%]{cursor:pointer;color:#0096d6;float:right}.streamAuth[_ngcontent-%COMP%]   .copyContent[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .certificate[_ngcontent-%COMP%]   .copyContent[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-family:FontAwesome!important}a.iot-stream[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:unset!important}.config-steps[_ngcontent-%COMP%]{padding:20px 0}.config-steps[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{padding:3px 10px}.config-steps[_ngcontent-%COMP%]   .step.command[_ngcontent-%COMP%]{border:1px dashed black;margin:3px 10px;background-color:#d3d3d3;border-radius:3px;font-weight:bold}.config-steps[_ngcontent-%COMP%]   .step.command[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{float:right;cursor:pointer;font-family:FontAwesome!important}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{align-items:center;justify-content:flex-end;background-color:#ffffffe6;z-index:9999}.fullscreenlPopup[_ngcontent-%COMP%]   .fullscreenCloseIcon[_ngcontent-%COMP%]{padding:0 30px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease}.fullscreenPopup.wnPopup[_ngcontent-%COMP%]   .fullscreenContent[_ngcontent-%COMP%]{top:70px;width:440px;overflow:visible;position:relative}.fullscreenPopup.wnPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{height:75vh;overflow-y:auto;margin-top:20px;padding:18px 60px 100px}.fullscreenPopup.wnPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{position:relative;padding:0;border-top:none}@media all and (max-width: 640px){.fullscreenPopup.wnPopup[_ngcontent-%COMP%]   .fullscreenContent[_ngcontent-%COMP%]{width:100%}}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenHeader[_ngcontent-%COMP%]{padding:0 30px;color:#39393b;font-size:24px;height:60px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{align-items:center;justify-content:flex-end;background-color:#ffffffe6;z-index:9999}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenCloseIcon[_ngcontent-%COMP%]{padding:0 30px}.fullscreenPopup.importSsidPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease}.fullscreenPopup[_ngcontent-%COMP%] > .fullscreenContent-ssid[_ngcontent-%COMP%]{width:65%;right:5px;height:78.2%;z-index:1001;position:absolute;top:105px;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #abc233;animation:slide .5s forwards}.fullscreenHeader[_ngcontent-%COMP%]{background-color:#fff!important}.fullscreenPopup[_ngcontent-%COMP%]{background:rgba(0,0,0,.8)!important}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{background-color:#fff;padding:18px 30px}.fullscreenPopup[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;top:0;left:0;z-index:99999;overflow:auto}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenOverlay[_ngcontent-%COMP%]{position:absolute;top:5%;left:5%;width:90%;height:85vh;background:rgba(0,0,0,.7);z-index:1000}.fullscreenPopup[_ngcontent-%COMP%] > .fullscreenContent[_ngcontent-%COMP%]{z-index:1001;position:absolute;left:50%;top:150px;transform:translate(-50%);width:60%;background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden;margin-bottom:50px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenHeader[_ngcontent-%COMP%]{padding:18px 30px;color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:relative;height:60px;border-bottom:1px solid #eaeaea}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{background-color:#fff;padding:18px 30px;margin-bottom:40px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]   .fullscreenBodyLeft[_ngcontent-%COMP%]{width:49%;float:left}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]   .fullscreenBodyRight[_ngcontent-%COMP%]{width:49%;float:right}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:relative;position:absolute;bottom:0;left:0;width:100%;border-top:1px solid #eaeaea;background-color:#fff;text-align:left}.fullscreenFooter[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:24px 0 24px 24px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenCloseIcon[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenPrimaryButton[_ngcontent-%COMP%]{margin-right:20px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenSecondaryButton[_ngcontent-%COMP%]{border:0;font-family:\"ciscoSans\";background-color:transparent;font-size:14px;color:#0096d6;outline:none}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenSecondaryButton[_ngcontent-%COMP%]:hover{color:#007199}.fullscreenPopup[_ngcontent-%COMP%]   .squareButtonPrimary[_ngcontent-%COMP%]{padding:10px 18px}.fullscreenPopup.fullscreenPopupSm[_ngcontent-%COMP%] > .fullscreenContent[_ngcontent-%COMP%]{width:30%;min-width:360px}.fullscreenPopup.fullscreenPopupMd[_ngcontent-%COMP%] > .fullscreenContent[_ngcontent-%COMP%]{width:50%;min-width:360px}.fullscreenPopup.fullscreenPopupLg[_ngcontent-%COMP%] > .fullscreenContent[_ngcontent-%COMP%]{width:90%;min-width:360px;top:70px}.fullscreenPopup.warningPopup[_ngcontent-%COMP%]   .fullscreenContent[_ngcontent-%COMP%]{overflow:visible}.fullscreenPopup.warningPopup[_ngcontent-%COMP%]   .fullscreenHeader[_ngcontent-%COMP%]{position:relative;padding-top:66px;border-bottom:none}.fullscreenPopup.warningPopup[_ngcontent-%COMP%]   .fullscreenHeader[_ngcontent-%COMP%]:before{position:absolute;width:80px;height:80px;content:\"\";background:transparent url(/assets/images/notification_icon.svg) no-repeat center;background-size:80px;box-shadow:0 0 3px #0003;border:5px solid #fff;border-radius:50%;left:50%;transform:translate(-50%);top:-40px}.fullscreenPopup.warningPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{padding:40px;border-top:none}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{z-index:1001;position:absolute;left:50%;top:30%;transform:translate(-50%);background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .warningIcon[_ngcontent-%COMP%]{margin-top:5%}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .streamWarningIcon[_ngcontent-%COMP%]{margin-left:45%!important}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .modalHeaders[_ngcontent-%COMP%]{padding:25px 0 5px;color:#000;font-size:20px;font-family:ciscoSansRegular;position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-top:5px;margin-bottom:25px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .circularCheckbox[_ngcontent-%COMP%]{position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:checked:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]{display:flex;justify-content:center}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]   .pmxRadioButtonLabel[_ngcontent-%COMP%]{margin-left:5px!important;font-size:14px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{display:flex;justify-content:center;position:relative!important;border-top:none!important}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]   .secondary-btn-box[_ngcontent-%COMP%]{display:flex;justify-content:center;border:none!important;background:#fff;color:#07a0d9}.warningPopupHeading[_ngcontent-%COMP%]{margin:25px 0 0!important}.modalPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{margin-bottom:0!important;margin-top:55px;margin-left:65px}.paddingTop20[_ngcontent-%COMP%]{padding-top:20px}.connector-path-start[_ngcontent-%COMP%]{display:inline;margin-left:15px}.connector-path[_ngcontent-%COMP%]{display:inline;margin-left:5px;color:#09c}.connectorHeader[_ngcontent-%COMP%]{display:inline-block;cursor:pointer;width:1986px;background:#ffffff;padding:25px 180px 10px 50px}.headerinfo[_ngcontent-%COMP%]{display:inline;float:right}.summary[_ngcontent-%COMP%]{display:flex;width:100%;height:125px;background:#ffff;padding:18px 27px 25px 52px;font-size:20px;box-shadow:0 0 1px #bdbdbd}.imageStyle[_ngcontent-%COMP%]{width:75px}.summarySection[_ngcontent-%COMP%]{height:25px;width:100%;float:left;margin-bottom:25px}.leftSummary[_ngcontent-%COMP%]{width:5%;height:100px;float:left}.rightSummary[_ngcontent-%COMP%]{height:100px;display:inline-block;width:65%}.floatleft[_ngcontent-%COMP%]{display:inline-block;float:left;width:10%;font-size:14px}.parameter-text[_ngcontent-%COMP%]{display:inherit}.border[_ngcontent-%COMP%]{border-right:1px solid #dee0e1}.grayDiv[_ngcontent-%COMP%]{height:55%;background:#fafafa}.subHeader[_ngcontent-%COMP%]{padding:0 0 15px 65px;font-size:20px;margin-right:100px;width:97%}.connector-table[_ngcontent-%COMP%]{background:#fff;height:400px;overflow-y:auto;margin:0 60.5px 10px 62.5px}.connector-table-instance[_ngcontent-%COMP%]{height:630px;margin:0 60.5px 40px 62.5px}.headerSection[_ngcontent-%COMP%]{font-size:18px!important;font-family:\"ciscoSans\";color:#4d4d4d;letter-spacing:.5px;display:inline}.rightHeaderSection[_ngcontent-%COMP%]{font-size:18px!important;font-family:\"ciscoSans\";color:#4d4d4d;display:inline;float:right;color:#09c!important;cursor:pointer;height:24px;left:82.99%;right:4.67%;top:449.13px;font-style:normal;font-weight:350;font-size:16px!important;line-height:24px;letter-spacing:.5px}.createConnector[_ngcontent-%COMP%]{font-size:14px;float:right;font-family:\"ciscoSansRegular\";color:#07a0d9}.showHideColumns[_ngcontent-%COMP%]{font-size:14px!important;float:right;font-family:\"ciscoSansRegular\";color:#07a0d9}.header-inner[_ngcontent-%COMP%]{display:inline-block;font-size:14px;padding-left:65px!important}.header[_ngcontent-%COMP%]{display:inline-block;font-size:18px;width:100%;height:61px}#link-locdetails-aps[_ngcontent-%COMP%]{display:inline;margin-right:25px}#link-locdetails-metrics[_ngcontent-%COMP%]{display:inline;margin-right:25px}.tokenDiv[_ngcontent-%COMP%]{display:inline;float:right;padding:15px;color:#07a0d9;font-size:14px}.cursorP[_ngcontent-%COMP%]{cursor:pointer;padding:8px}.active-block[_ngcontent-%COMP%]   .active-name[_ngcontent-%COMP%]{color:#059fd9;font-weight:bold;font-family:\"ciscoSansBold\";vertical-align:middle}.active-block[_ngcontent-%COMP%]{border-bottom:2px solid #059fd9!important;animation:border-animation .1s ease-in-out}.confirmation-popup-wrapper[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:99999;left:0;top:0}.popup-overlay[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:999999;background-color:#0009}.confirmation-popup[_ngcontent-%COMP%]{position:absolute;top:33%;left:50%;transform:translate(-50%);width:40%;height:30%;margin:0 auto;background-color:#fff;box-shadow:0 4px 8px #0000001a;border:0;z-index:1001;display:flex;justify-content:center;flex-direction:column;border-radius:5px}.confirmation-button-wrapper[_ngcontent-%COMP%]{margin:0 auto;width:40%;text-align:center}.confirmation-primary-button[_ngcontent-%COMP%]{border-radius:1.3em;background-color:#09c;color:#fff;font-family:ciscoSansLight;padding:0 18px;font-size:14px;height:34px;line-height:34px;cursor:pointer;float:left}.confirmation-primary-button[_ngcontent-%COMP%]:hover{opacity:.8}.confirmation-cancel[_ngcontent-%COMP%]{color:#848484!important;font-size:14px;text-decoration:none;cursor:pointer;line-height:30px;font-family:\"ciscoSansRegular\"}.confirmation-cancel[_ngcontent-%COMP%]:hover{font-weight:bold}.confirmation-popup-close[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.confirmation-popup-close[_ngcontent-%COMP%]:hover{opacity:.8}.exclamation-icon[_ngcontent-%COMP%]{min-height:70px;min-width:70px;text-align:center;padding:0;position:absolute;left:50%;transform:translate(-50%);top:-20%;border:5px solid #fff;border-radius:50%;background:#fff;box-shadow:0 0 2px #84848480}.confirmation-message[_ngcontent-%COMP%]{text-align:center;padding:25px 0;font-size:15px;display:block;width:82%;margin:0 auto;color:#848484;font-family:\"ciscoSansRegular\"}.info-icon[_ngcontent-%COMP%]{width:20px;height:20px;display:inline-block;cursor:pointer;text-align:center}.btn-connector-create[_ngcontent-%COMP%]{font-size:14px}.emptyStateHeading[_ngcontent-%COMP%]{padding:54px;font-size:14px;font-family:\"ciscoSansRegular\";background:#FFFF}.leftMargin[_ngcontent-%COMP%]{margin-left:25px}.connector-pat-start[_ngcontent-%COMP%]{margin-left:20px;color:#09c}.breadcrumbSeparator[_ngcontent-%COMP%]{color:#09c}.am-appselector-wrapper[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0}.am-appselector-wrapper[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border:1px solid #eae9e9;padding:10px 20px}.am-appselector-wrapper[_ngcontent-%COMP%]   .am-appselector[_ngcontent-%COMP%]{display:flex;align-items:center}.am-appselector-wrapper[_ngcontent-%COMP%]   .check-sel[_ngcontent-%COMP%]{width:80%}.am-appselector-wrapper[_ngcontent-%COMP%]   .am-appselector-dropdown[_ngcontent-%COMP%]{width:20%}.am-appselector-wrapper[_ngcontent-%COMP%]   .check-label[_ngcontent-%COMP%]{font-weight:bold!important;color:#656565!important;padding-left:5px;font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:14px;line-height:20px;letter-spacing:.5px;color:#121212}.check-label[_ngcontent-%COMP%]{font-weight:bold!important;font-size:15px;padding-left:5px}.check-label-disabled[_ngcontent-%COMP%]{color:#656565!important}.services[_ngcontent-%COMP%]{font-size:16px;font-family:\"ciscoSansRegular\";padding:10px}.subHeader-detail[_ngcontent-%COMP%]{font-size:12px}.header-wrapper[_ngcontent-%COMP%]{margin-top:10px;min-height:60px;background:#fff;position:relative;border:1px solid #979797;border-bottom:none}.header-inner[_ngcontent-%COMP%]{padding-left:50px!important;bottom:0;left:0;right:0;width:100%;border-bottom:1px solid #eee}.header-blocks[_ngcontent-%COMP%]{padding:10px;float:left;text-align:center;cursor:pointer;margin-bottom:0!important}.header-blocks[_ngcontent-%COMP%]:hover{opacity:.8}.active-block[_ngcontent-%COMP%]   .active-name[_ngcontent-%COMP%]{color:#000;font-family:\"ciscoSansRegular\"}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:20%;padding-left:33.8px}.table.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:20%}.circularCheckbox[_ngcontent-%COMP%]{vertical-align:middle;padding-right:15px;display:inline-block}.userDetailLabel[_ngcontent-%COMP%]{display:inline-block}.userNameLink[_ngcontent-%COMP%]{font-size:12px;color:#09c!important;font-family:\"ciscoSansRegular\"}.userListEmail[_ngcontent-%COMP%]{opacity:.8;font-family:\"ciscoSansRegular\";font-size:11px;color:#333;display:block}.userAccess[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.userLocations[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.statusPending[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.confirmResendLink[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";font-size:12px;font-weight:600;color:#049fd9;text-decoration:underline}.modalPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{background-color:#fff;padding:10px 0!important;margin-bottom:40px}.body_detail[_ngcontent-%COMP%]{margin-top:0;margin-left:0;height:75%!important}.table[_ngcontent-%COMP%]{border:1px solid #eee!important;background-color:#fff;max-width:100%;border-collapse:collapse;border-spacing:0;width:100%;font-family:\"ciscoSansLight\",sans-serif;font-size:14px;color:#505050;text-align:left}.table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]{margin-left:30px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:10%!important}.confirmation-cancel[_ngcontent-%COMP%]{color:#848484!important;font-size:14px;text-decoration:none;cursor:pointer;line-height:30px;font-family:\"ciscoSansRegular\";display:inline;float:left;margin:0 35px 0 250px}.pagination[_ngcontent-%COMP%]{margin:25px 100px 8px 55px!important}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:20%;padding-left:15px}.table.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:11.66%}.image-img[_ngcontent-%COMP%]{width:55%}.fieldLabel-note[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:12px;line-height:16px;letter-spacing:.5px;color:#545454}.endPipe[_ngcontent-%COMP%]{border-right:1px solid #dee0e1}.info-div[_ngcontent-%COMP%]{padding-left:50px;padding-top:20px;overflow-y:auto;height:75%}span.userAccess.active[_ngcontent-%COMP%]{color:green;cursor:auto}span.userAccess.inactive[_ngcontent-%COMP%]{color:#cd5c5c;cursor:auto}.inner-table[_ngcontent-%COMP%]{margin-left:45px;width:96%}table.fold-table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr.view[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], table.fold-table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr.view[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{cursor:pointer}table.fold-table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr.view[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child, table.fold-table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr.view[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child{position:relative;padding-left:20px}table.fold-table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr.view[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child:before, table.fold-table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr.view[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child:before{position:absolute;top:50%;left:5px;width:9px;height:16px;margin-top:-8px;font:16px fontawesome;color:#999;content:\"\";transition:all .3s ease}table.fold-table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr.view[_ngcontent-%COMP%]:hover{background:#000}table.fold-table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr.view.open[_ngcontent-%COMP%]{color:#fff}table.fold-table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr.view.open[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child:before, table.fold-table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr.view.open[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child:before{transform:rotate(-180deg);color:#333}table.fold-table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr.fold[_ngcontent-%COMP%]{display:none}table.fold-table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr.fold.open[_ngcontent-%COMP%]{display:table-row}.fold-content[_ngcontent-%COMP%]{padding:.5em}.fold-content[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{margin-top:0}.fold-content[_ngcontent-%COMP%] > table[_ngcontent-%COMP%]{border:2px solid #ccc}.fold-content[_ngcontent-%COMP%] > table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(even){background:#eee}.nav-arrow[_ngcontent-%COMP%]{transform:rotate(0);transition:transform .5s}.activeParentNode[_ngcontent-%COMP%]{transform:rotate(90deg)}.nav-arrow[_ngcontent-%COMP%]{display:flex;align-items:center}.nav-arrow[_ngcontent-%COMP%]   .icon-arrow[_ngcontent-%COMP%]:before{font-size:15px}.nav-arrow[_ngcontent-%COMP%]   .icon-arrow[_ngcontent-%COMP%]:after{font-size:15px;transform:rotate(90deg)}.down[_ngcontent-%COMP%]{transform:rotate(90deg)!important}.help[_ngcontent-%COMP%]{margin-bottom:100px;background:#FFFF;padding:0!important;height:450px!important;overflow-y:hidden;width:90%;margin-top:45px}.help-desc[_ngcontent-%COMP%]{background:#fff;padding:45px;margin-top:20px;display:inline;width:55%;float:left;color:#121212}.help_img[_ngcontent-%COMP%]{display:inline;width:40%;float:right}.click-pointer[_ngcontent-%COMP%]{cursor:pointer}.userEditIcon[_ngcontent-%COMP%]{color:#07a0d9!important;font-family:\"CiscoSans\";font-size:14px;letter-spacing:.5px;text-align:left}.info-pipes[_ngcontent-%COMP%]{margin-right:20px}.table[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]{background-color:none;border-bottom:1px solid #eee!important}.modalPopupSm[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{width:28%!important}.instanceInfoTable[_ngcontent-%COMP%]{border:none!important;width:75%!important}.instanceInfoTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover{background:#fff!important}.steps1[_ngcontent-%COMP%]{font-size:16px;font-family:CiscoSans;font-weight:bold;padding-bottom:6px;padding-top:15px}.border_r[_ngcontent-%COMP%]{border-right:1px solid #dee0e1}.check-sel[_ngcontent-%COMP%]{padding:5px}.tooltip[_ngcontent-%COMP%]{position:relative;display:inline-block}.tooltip[_ngcontent-%COMP%]   .tooltiptext[_ngcontent-%COMP%]{visibility:hidden;width:380px;height:auto;overflow-y:auto;background-color:#fff;color:#58585b;border:1px solid #efefef;padding:32px;position:absolute;z-index:999;top:-235px;left:20px;box-shadow:0 4px 8px #0000001a;border-radius:2px}.tooltip[_ngcontent-%COMP%]:hover   .tooltiptext[_ngcontent-%COMP%]{visibility:visible}.table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]{height:60px;border:1px solid #DEDEDE}thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]{border-bottom:1px solid #DEDEDE;box-shadow:0 1px 3px #00000040}.table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(even){background:#fff}.tableTr[_ngcontent-%COMP%]{width:50px!important;border:none!important}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:14px;line-height:20px;letter-spacing:.5px}.detailInstance[_ngcontent-%COMP%]{height:38px!important}.parent[_ngcontent-%COMP%]{padding:0 20px 0 0;width:100%}.child[_ngcontent-%COMP%]{display:inline-block;vertical-align:top;padding:0 20px}.child_time[_ngcontent-%COMP%]{display:inline-block;vertical-align:top;width:250px}.steps-reset[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:14px;line-height:19px;letter-spacing:.5px}.step-header[_ngcontent-%COMP%]{display:inline-block}.step-header[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:inline-block}.step-header[_ngcontent-%COMP%]   .step_index[_ngcontent-%COMP%]{border:1px solid #979797;width:25px;height:25px;border-radius:50%;text-align:center;line-height:30px;font-size:12px;font-family:CiscoSans;font-weight:bold;margin-right:20px}.step-header[_ngcontent-%COMP%]   span.tile_header[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;font-weight:300;letter-spacing:.83px;line-height:18px;display:inline}.withBorder[_ngcontent-%COMP%]{border-left:1px solid #DFDFDF;height:180px;margin-left:14px}.config-header[_ngcontent-%COMP%]{vertical-align:top;color:#000}.step2[_ngcontent-%COMP%]{padding-left:32px}.update-note[_ngcontent-%COMP%]{border:1px solid #FFA000;border-radius:4px;padding:15px;font-size:14px;font-family:CiscoSans;line-height:144.6%;background:#FFFF;color:#202020;display:inline-block;width:94%;margin-left:65px;margin-bottom:20px}.upgradeHeader[_ngcontent-%COMP%]{font-size:18px!important;font-family:\"ciscoSans\";padding:10px 10px 10px 20px;width:85%;display:inline-block}.upgradeMessage[_ngcontent-%COMP%]{font-size:12px!important;font-family:\"ciscoSans\"}.upgradebutton[_ngcontent-%COMP%]{font-size:12px!important;font-family:\"ciscoSans\";display:inline;vertical-align:super}.parent[_ngcontent-%COMP%]{display:inline-block;text-align:center}.child[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;background:white;width:45%;float:left;margin-top:20px;padding-bottom:30px;margin-right:25px}table.tableSection[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]{border-bottom:none!important;height:0px!important}.tableSection[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:10px}.instance-each[_ngcontent-%COMP%]{display:inline-block;width:60%;float:left}.instance-section[_ngcontent-%COMP%]{height:27px;left:10.88%;right:81.86%;top:511.68px;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:20px;line-height:27px;color:#00a0d1;float:left;padding:5px 30px 0 18px}.ins-version-div[_ngcontent-%COMP%]{float:left;padding:5px 30px 0 18px;font-size:12px}.right-pipe[_ngcontent-%COMP%]{width:20px;height:0px;left:1216.42px;top:529.68px;opacity:.1;border:1px solid #000000;transform:rotate(90deg)}.instance-header[_ngcontent-%COMP%]{height:100px;padding:30px;border-bottom:1px solid #eee}.instance-rightSection[_ngcontent-%COMP%]{width:92px;float:right;display:inline-block}.info-icon-border[_ngcontent-%COMP%]{opacity:.1;border:1px solid #000000;transform:rotate(90deg)}.instance-table[_ngcontent-%COMP%]{height:15px!important;border:none!important}.instance-details[_ngcontent-%COMP%]{padding:0 20px;border:none!important}.instance-services[_ngcontent-%COMP%]{padding:0 20px}.instance-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{border:none!important;height:12px!important;box-shadow:none!important}.instance-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:10px 18px!important}.service-details[_ngcontent-%COMP%]{display:inline-block;width:350px;padding-top:25px;height:20px;left:745.26px;top:834.25px;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px;color:#545454;padding-left:15px}.service-details-first[_ngcontent-%COMP%]{padding-top:0!important}.service-name[_ngcontent-%COMP%]{display:inline}.service-status[_ngcontent-%COMP%]{display:inline;float:right;cursor:pointer}.service-version[_ngcontent-%COMP%]{width:390px;height:18px;left:723.61px;top:861.2px;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:13px;line-height:18px;color:gray;padding:5px 0 0 15px;width:100%}.instance-table[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]{background-color:none;border-bottom:none!important}.instance-column[_ngcontent-%COMP%]{float:left}.popupUpgrades[_ngcontent-%COMP%]{height:400px!important;width:185px!important;margin-top:44px!important;margin-left:45px!important;margin-right:40px}.nodeInstanceRadio[_ngcontent-%COMP%]{width:42%}.pmxRadio[_ngcontent-%COMP%]   .pmxRadioButtonLabel[_ngcontent-%COMP%]{margin-left:none!important}.instances-upgrade[_ngcontent-%COMP%]{width:360px;height:124px;background-color:#eee;margin-left:40px;padding:20px}.columnData_header[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;color:#58585b;width:20%;display:inline}.modalPopup[_ngcontent-%COMP%]   .modalHeader-upgrade[_ngcontent-%COMP%]{padding:32px 0 3px 10px!important;border-bottom:none!important}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon-upgrade[_ngcontent-%COMP%]{padding:38px 30px!important}.upgrade-img[_ngcontent-%COMP%]{width:6%}.modalPopup[_ngcontent-%COMP%]   .modalFooter-upgrade[_ngcontent-%COMP%]{margin-left:175px!important;justify-content:left!important}.modalPopup[_ngcontent-%COMP%]   .modalBody-upgrade[_ngcontent-%COMP%]{margin-top:5px!important}.upgradeHeader[_ngcontent-%COMP%]{padding-top:10px;left:537.9px;top:645.38px;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:16px;color:#373737}.pmxRadio-upgrade[_ngcontent-%COMP%]{height:41px;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px;color:#000;width:225px}.connector_instanceSetting[_ngcontent-%COMP%]{display:inline-block;width:5%;float:left}.service_detHeader[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px;text-transform:uppercase;color:#545454;opacity:.5;float:left}.service-header[_ngcontent-%COMP%]{width:100%;margin-bottom:10px!important;height:auto;font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:18px;line-height:25px;letter-spacing:.5px;color:#545454;height:25px;margin-bottom:18px}.service_status_details[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:14px;line-height:31px;letter-spacing:.5px;color:#545454}.detail_value[_ngcontent-%COMP%]{padding-left:5px;font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:14px;line-height:31px;letter-spacing:.5px;color:#545454}.upgrade-init[_ngcontent-%COMP%]{height:113px;left:36.92%;right:38.84%;top:2603.08px;font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:24px;line-height:33px;letter-spacing:.5px;color:#00050d;padding-top:115px;text-align:center}.dual-interface-option[_ngcontent-%COMP%]{padding-top:25px}.virtaul-ip[_ngcontent-%COMP%]{padding-top:20px}.tooltip-info[_ngcontent-%COMP%]{position:relative;display:inline-block;top:-5px;width:20%!important}.tooltip-info[_ngcontent-%COMP%]   .tooltiptext-info[_ngcontent-%COMP%]{visibility:hidden;width:525px;height:auto;overflow-y:auto;background-color:#fff;color:#58585b;border:1px solid #efefef;padding:32px;position:absolute;z-index:999;left:20px;box-shadow:0 4px 8px #0000001a;border-radius:2px}.tooltip-info[_ngcontent-%COMP%]:hover   .tooltiptext-info[_ngcontent-%COMP%]{visibility:visible}.disablePairing[_ngcontent-%COMP%]{float:right;cursor:pointer;color:#07a0d9}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmxConnectorInstancesComponent, [{
        type: Component,
        args: [{
                selector: 'app-cmx-connector-instances',
                templateUrl: './cmx-connector-instances.component.html',
                styleUrls: ['./cmx-connector-instances.component.scss']
            }]
    }], function () { return [{ type: CMXConnectorsService }, { type: DataService }, { type: i2.TranslateService }]; }, { userRole: [{
            type: Input
        }], availableInstances: [{
            type: Input
        }, {
            type: Input
        }], allServices: [{
            type: Input
        }], currentConnector: [{
            type: Input
        }], nodeIds: [{
            type: Input
        }], allAvailableServices: [{
            type: Input
        }], connectorConfigureGuide: [{
            type: Input
        }], serviceNameDisplayName: [{
            type: Input
        }], emitInstanceRemoval: [{
            type: Output
        }] }); })();

class WsService {
    constructor() { }
    connect(url) {
        if (!this.subject) {
            this.subject = this.create(url);
            console.log("Successfully connected: " + url);
        }
        return this.subject;
    }
    disconnect() {
        if (this.subject) {
            this.subject.complete();
            this.subject = null;
        }
    }
    create(url) {
        let ws = new WebSocket(url);
        let observable = Rx.Observable.create((obs) => {
            ws.onmessage = obs.next.bind(obs);
            ws.onerror = obs.error.bind(obs);
            ws.onclose = obs.complete.bind(obs);
            return ws.close.bind(ws);
        });
        let observer = {
            next: (data) => {
                if (ws.readyState === WebSocket.OPEN) {
                    ws.send(JSON.stringify(data));
                }
            }
        };
        return Rx.Subject.create(observer, observable);
    }
}
WsService.ɵfac = function WsService_Factory(t) { return new (t || WsService)(); };
WsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WsService, factory: WsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class WsconnectService {
    constructor(wsService) {
        this.wsService = wsService;
        this.ws_url = "";
        this.disconnect = () => {
            if (this.messages)
                this.messages.unsubscribe();
            if (this.wsService)
                this.wsService.disconnect();
            this.messages = null;
        };
        this.connect = (baseUrl, sysToken, timestamp, isLocal) => {
            // this.ws_url = baseUrl + '?sys-token='+sysToken;
            this.ws_url = baseUrl;
            if (timestamp) {
                this.ws_url += '?timestamp=' + timestamp;
            }
            if (isLocal) {
                if (timestamp) {
                    this.ws_url += '&sys-token=' + sysToken;
                }
                else {
                    this.ws_url += '?sys-token=' + sysToken;
                }
            }
            this.messages = this.wsService.connect(this.ws_url).pipe(map$1((response) => {
                // console.log('Message', response);
                try {
                    if (typeof response.data === "string") {
                        let data = JSON.parse(response.data);
                        // console.log('JSON Parse Message', data);
                        return data;
                    }
                }
                catch (err) {
                    // console.log(err);
                }
            }));
        };
        // this.messages = <Subject<Message>>wsService.connect(this.ws_url).map(
        //   (response: MessageEvent): Message => {
        //     // console.log('Message', response);
        //     let data = JSON.parse(response.data);
        //     // console.log('JSON Parse Message', data);
        //     return data
        //   }
        // );
    }
}
WsconnectService.ɵfac = function WsconnectService_Factory(t) { return new (t || WsconnectService)(i0.ɵɵinject(WsService)); };
WsconnectService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WsconnectService, factory: WsconnectService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WsconnectService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: WsService }]; }, null); })();

class NewlocationUtils {
    constructor() {
        this.prepareLocationRow = (parentId, data) => {
            let rowdata = data ? data : [];
            let fields = {
                parentId: null,
                childCount: null,
                id: null,
                name: null,
                mongoId: null,
                mongoLocationId: null,
                type: null,
                inferredLocationTypes: null,
                hasChildren: false,
                children: null,
                childData: [],
                isChildrenLoading: true,
                nodesBelow: 0
            };
            let locRow = {};
            if (rowdata.length) {
                fields.parentId = parentId;
                fields.childCount = rowdata[1];
                fields.hasChildren = fields.childCount > 0 ? true : false;
                fields.isChildrenLoading = fields.childCount > 0 ? true : false;
                fields.id = rowdata[2];
                fields.name = rowdata[3];
                fields.mongoId = rowdata[4];
                fields.mongoLocationId = rowdata[4];
                fields.type = rowdata[5];
                fields.inferredLocationTypes = rowdata[5];
                locRow = Object.assign(Object.assign({}, fields), rowdata[0]);
            }
            return locRow;
        };
        this.getBrowserDetails = () => {
            var nVer = navigator.appVersion;
            var nAgt = navigator.userAgent;
            var browserName = navigator.appName;
            var fullVersion = '' + parseFloat(navigator.appVersion);
            var majorVersion = parseInt(navigator.appVersion, 10);
            var nameOffset, verOffset, ix;
            // In Opera, the true version is after "Opera" or after "Version"
            if ((verOffset = nAgt.indexOf("Opera")) != -1) {
                browserName = "Opera";
                fullVersion = nAgt.substring(verOffset + 6);
                if ((verOffset = nAgt.indexOf("Version")) != -1)
                    fullVersion = nAgt.substring(verOffset + 8);
            }
            // In MSIE, the true version is after "MSIE" in userAgent
            else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
                browserName = "Microsoft Internet Explorer";
                fullVersion = nAgt.substring(verOffset + 5);
            }
            // In Chrome, the true version is after "Chrome" 
            else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
                browserName = "Chrome";
                fullVersion = nAgt.substring(verOffset + 7);
            }
            // In Safari, the true version is after "Safari" or after "Version" 
            else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
                browserName = "Safari";
                fullVersion = nAgt.substring(verOffset + 7);
                if ((verOffset = nAgt.indexOf("Version")) != -1)
                    fullVersion = nAgt.substring(verOffset + 8);
            }
            // In Firefox, the true version is after "Firefox" 
            else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
                browserName = "Firefox";
                fullVersion = nAgt.substring(verOffset + 8);
            }
            // In most other browsers, "name/version" is at the end of userAgent 
            else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
                (verOffset = nAgt.lastIndexOf('/'))) {
                browserName = nAgt.substring(nameOffset, verOffset);
                fullVersion = nAgt.substring(verOffset + 1);
                if (browserName.toLowerCase() == browserName.toUpperCase()) {
                    browserName = navigator.appName;
                }
            }
            // trim the fullVersion string at semicolon/space if present
            if ((ix = fullVersion.indexOf(";")) != -1)
                fullVersion = fullVersion.substring(0, ix);
            if ((ix = fullVersion.indexOf(" ")) != -1)
                fullVersion = fullVersion.substring(0, ix);
            majorVersion = parseInt('' + fullVersion, 10);
            if (isNaN(majorVersion)) {
                fullVersion = '' + parseFloat(navigator.appVersion);
                majorVersion = parseInt(navigator.appVersion, 10);
            }
            // console.log(''
            // +'Browser name  = '+browserName+'<br>'
            // +'Full version  = '+fullVersion+'<br>'
            // +'Major version = '+majorVersion+'<br>'
            // +'navigator.appName = '+navigator.appName+'<br>'
            // +'navigator.userAgent = '+navigator.userAgent+'<br>'
            // )
            const browserString = `Browser name = ${browserName}'; Full version  = ${fullVersion}; Major version = ${majorVersion}; navigator.appName = ${navigator.appName}; navigator.userAgent = ${navigator.userAgent};`;
            const browserDetails = {
                browserName: browserName,
                fullVersion: fullVersion,
                majorVersion: majorVersion,
                appName: navigator.appName,
                userAgent: navigator.userAgent,
                browserString: browserString
            };
            return browserDetails;
        };
        this.getGeoLocationDataFromLocation = (location) => {
            if (location) {
                if (location.geoLocation
                    && location.geoLocation.length
                    && location.geoLocation.split(",")[0] != "0.0"
                    && location.geoLocation.split(",")[1] != "0.0") {
                    const geoLocation = {
                        id: location.id,
                        parentId: location.parentId,
                        parentTimeZoneId: location.parentTimeZoneId,
                        inferredTimeZoneId: location.inferredTimeZoneId,
                        name: location.name,
                        mongoLocationId: location.mongoId,
                        inferredLocationTypes: location.type,
                        networkId: location.networkId,
                        address: location.address,
                        totalArea: location.totalArea,
                        totalAreaUnit: location.totalAreaUnit,
                        totalCapacity: location.totalCapacity,
                        locationPath: location.locationPath,
                        childCount: location.childCount,
                        hierarchyMapSources: location.hierarchyMapSources,
                        latitude: parseFloat(location.geoLocation.split(",")[0]),
                        longitude: parseFloat(location.geoLocation.split(",")[1])
                    };
                    console.log("GeoLocation", geoLocation);
                    return geoLocation;
                }
            }
        };
    }
}
NewlocationUtils.ɵfac = function NewlocationUtils_Factory(t) { return new (t || NewlocationUtils)(); };
NewlocationUtils.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NewlocationUtils, factory: NewlocationUtils.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NewlocationUtils, [{
        type: Injectable
    }], function () { return []; }, null); })();

class Lh2Service extends BaseService {
    constructor(dataService, injector, authService, userService, businessHierarchyService, wsService, wsconnectService) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.authService = authService;
        this.userService = userService;
        this.businessHierarchyService = businessHierarchyService;
        this.wsService = wsService;
        this.wsconnectService = wsconnectService;
        this.unsubscribe$ = new Subject();
        this.properties = null;
        this.newlocationUtils = new NewlocationUtils();
        this.keepAliveInterval = null;
        this.deltaUpdateWaitInterval = null;
        this.browserDetails = {
            websocketConnection: false,
            websocketAvailable: false
        };
        this.indexedDBVersion = null;
        this.incomingMessages = false;
        this.propertiesLoaded = false;
        this.locTimestamp = null;
        this.lh2LicenseType = '';
        this.init = () => {
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$)
                .then((properties) => {
                this.properties = properties['value'];
            });
            this.userService.getUserCurrentStatus().pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                if (response) {
                    if (response.licenseDetails) {
                        this.dataService.setLicenseDetails(response.licenseDetails);
                        if (response.licenseDetails.licenseType) {
                            this.dataService.setLicenseType(response.licenseDetails.licenseType);
                        }
                    }
                    this.prepareLH2();
                }
            });
        };
        this.destroy = () => {
            this.unsubscribe$.next();
            this.unsubscribe$.complete();
            this.wsconnectService.disconnect();
            if (this.keepAliveInterval)
                clearInterval(this.keepAliveInterval);
            if (this.deltaUpdateWaitInterval)
                clearInterval(this.deltaUpdateWaitInterval);
        };
        this.prepareLH2 = () => {
            this.lh2LicenseType = '';
            if (this.dataService.licenseType) {
                const lType = this.dataService.licenseType;
                if (lType.indexOf('Base') > -1) {
                    this.lh2LicenseType = 'SEE';
                }
                else if (lType.indexOf('Advanced') > -1) {
                    this.lh2LicenseType = 'ACT';
                }
                else if (lType.indexOf('SMART_OP') > -1) {
                    this.lh2LicenseType = 'SMART_OPS';
                }
                else if (lType.indexOf('Unlimited') > -1) {
                    this.lh2LicenseType = 'UNLIMITED';
                }
                else if (lType.indexOf('SMART_VE') > -1) {
                    this.lh2LicenseType = 'SMART_VENUES';
                }
                else {
                    this.lh2LicenseType = lType;
                }
            }
            const locationMapKey = this.dataService.getTenantId() + this.dataService.getUserName();
            const locationMapGeoKey = this.dataService.getTenantId() + this.dataService.getUserName() + '-geolocation';
            this.browserDetails = {
                websocketConnection: false,
                websocketAvailable: false
            };
            let browserVersionInfo = this.newlocationUtils.getBrowserDetails();
            this.browserDetails = Object.assign(Object.assign({}, this.browserDetails), browserVersionInfo);
            let lhFallbackApiTimeDelay = 10000;
            if (this.properties && this.properties["lhFallbackApiTimeDelay"]) {
                lhFallbackApiTimeDelay = parseInt(this.properties["lhFallbackApiTimeDelay"]);
            }
            setTimeout(() => {
                let logBrowserDetails = false;
                this.dataService.getLocationIndexedMap(locationMapKey).then((locationMap) => {
                    const locations = locationMap;
                    if (locations
                        && locations['data']
                        && locations['data'].size) {
                        if (this.browserDetails.websocketConnection) {
                            logBrowserDetails = false;
                            // location data available in indexeddb
                            // browserDetails.id = locationMapKey;
                            // browserDetails.indexedDBCount = locations['data']
                            // 								&& locations['data'].length ? locations['data'].length : 0;
                            // browserDetails['timestamp'] = new Date().getTime();
                        }
                        else {
                            logBrowserDetails = true;
                        }
                    }
                    else {
                        // location data unavailable in indexeddb
                        logBrowserDetails = true;
                        this.browserDetails['userId'] = locationMapKey;
                        this.browserDetails['indexedDBCount'] = 0;
                        this.browserDetails['timestamp'] = new Date().getTime();
                    }
                    const activeTimeStampConnection = this.dataService.getActiveTimeStampConnection();
                    if (!activeTimeStampConnection
                        && logBrowserDetails
                        && !this.incomingMessages) {
                        this.businessHierarchyService.postBrowserDetails(this.browserDetails).subscribe(data => {
                            if (data && data.status) {
                                console.log('Browser details logged successfully');
                            }
                            else {
                                console.log('An error occurred while logging browser details');
                            }
                        }, error => {
                            console.log('An error occurred while logging browser details');
                        });
                        this.getFlattenedStructure();
                    }
                });
            }, lhFallbackApiTimeDelay);
            if (locationMapGeoKey) {
                this.dataService.getLocationIndexedMap(locationMapGeoKey).then((geoLocationMap) => {
                    // set local geo location array from indexedDB
                    if (geoLocationMap) {
                        this.setLocationMapGeoLocation(locationMapGeoKey);
                        this.dataService.getLocationIndexedMap(locationMapKey).then((locationMap) => {
                            // set local location map from indexedDB
                            const locations = locationMap;
                            if (locations && locations['data']) {
                                setTimeout(() => {
                                    this.dataService.setLocLoadingStarted(true);
                                }, 100);
                                let permissionChangeLoading = true;
                                setTimeout(() => {
                                    if (permissionChangeLoading) {
                                        this.dataService.setLocationMap({}, locationMapKey);
                                        this.dataService.locationRowArray = [];
                                        this.locationWebSocket();
                                    }
                                }, 10000);
                                this.businessHierarchyService.permissionChangeStatus().subscribe(permissionData => {
                                    if (permissionData.status
                                        && permissionData.data) {
                                        permissionChangeLoading = false;
                                        this.dataService.setLocationMap({}, locationMapKey);
                                        this.dataService.locationRowArray = [];
                                        this.locationWebSocket();
                                    }
                                    else {
                                        permissionChangeLoading = false;
                                        const indexedDBVersion = locations['version'];
                                        this.businessHierarchyService.indexedDBVersion().subscribe(data => {
                                            if (data.status
                                                && data.data
                                                && data.data.version) {
                                                const version = data.data.version;
                                                this.indexedDBVersion = version;
                                                if (version !== indexedDBVersion) {
                                                    // create indexedDB locationMap entry for tenant+userId
                                                    this.dataService.setLocationMap({}, locationMapKey);
                                                    this.dataService.locationRowArray = [];
                                                    this.locationWebSocket();
                                                }
                                                else {
                                                    const timestamp = locations['timestamp'];
                                                    let nowtime = new Date().getTime();
                                                    const timeDiffInHours = this.getTimeDiffInHours(timestamp, nowtime);
                                                    const lhRefreshLimitHours = this.properties['lhRefreshLimitHours'];
                                                    if (lhRefreshLimitHours && timeDiffInHours < lhRefreshLimitHours) {
                                                        this.businessHierarchyService.forceRefreshTenant().subscribe(tenantData => {
                                                            if (tenantData.status && tenantData.data) {
                                                                const refreshData = tenantData.data;
                                                                const refreshTimeStamp = parseInt(refreshData.timestamp + "000");
                                                                if (timestamp < refreshTimeStamp) {
                                                                    // create indexedDB locationMap entry for tenant+userId
                                                                    this.dataService.setLocationMap({}, locationMapKey);
                                                                    this.dataService.locationRowArray = [];
                                                                    this.locationWebSocket();
                                                                }
                                                                else {
                                                                    this.dataService.locationRowMap = locations['data'];
                                                                    const locId = locations['rootLocationId'];
                                                                    this.dataService.setInStorage("rootLocationId", locId);
                                                                    // connect WebSocket for timestamp delta updates
                                                                    const activeTimeStampConnection = this.dataService.getActiveTimeStampConnection();
                                                                    if (!activeTimeStampConnection) {
                                                                        this.locationTimeStampWebSocket(timestamp);
                                                                        this.prepareLocationRowArray();
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                this.dataService.locationRowMap = locations['data'];
                                                                const locId = locations['rootLocationId'];
                                                                this.dataService.setInStorage("rootLocationId", locId);
                                                                // connect WebSocket for timestamp delta updates
                                                                const activeTimeStampConnection = this.dataService.getActiveTimeStampConnection();
                                                                if (!activeTimeStampConnection) {
                                                                    this.locationTimeStampWebSocket(timestamp);
                                                                    this.prepareLocationRowArray();
                                                                }
                                                            }
                                                        }, error => {
                                                            this.dataService.locationRowMap = locations['data'];
                                                            const locId = locations['rootLocationId'];
                                                            this.dataService.setInStorage("rootLocationId", locId);
                                                            // connect WebSocket for timestamp delta updates
                                                            const activeTimeStampConnection = this.dataService.getActiveTimeStampConnection();
                                                            if (!activeTimeStampConnection) {
                                                                this.locationTimeStampWebSocket(timestamp);
                                                                this.prepareLocationRowArray();
                                                            }
                                                        });
                                                    }
                                                    else {
                                                        // create indexedDB locationMap entry for tenant+userId
                                                        this.dataService.setLocationMap({}, locationMapKey);
                                                        this.dataService.locationRowArray = [];
                                                        this.locationWebSocket();
                                                    }
                                                }
                                            }
                                            else {
                                                // create indexedDB locationMap entry for tenant+userId
                                                this.dataService.setLocationMap({}, locationMapKey);
                                                this.dataService.locationRowArray = [];
                                                this.locationWebSocket();
                                            }
                                        }, error => {
                                            // create indexedDB locationMap entry for tenant+userId
                                            this.dataService.setLocationMap({}, locationMapKey);
                                            this.dataService.locationRowArray = [];
                                            this.locationWebSocket();
                                        });
                                    }
                                }, error => {
                                    permissionChangeLoading = false;
                                    this.dataService.setLocationMap({}, locationMapKey);
                                    this.dataService.locationRowArray = [];
                                    this.locationWebSocket();
                                });
                            }
                            else {
                                // create indexedDB locationMap entry for tenant+userId
                                this.dataService.setLocationMap({}, locationMapKey);
                                this.dataService.locationRowArray = [];
                                this.locationWebSocket();
                            }
                        }).catch(() => {
                            // create indexedDB locationMap entry for tenant+userId
                            this.dataService.setLocationMap({}, locationMapKey);
                            this.dataService.locationRowArray = [];
                            this.locationWebSocket();
                        });
                    }
                    else {
                        // create indexedDB locationMap entry for tenant+userId
                        this.dataService.setLocationMap({}, locationMapKey);
                        this.dataService.locationRowArray = [];
                        this.locationWebSocket();
                    }
                });
            }
        };
        this.setLocationMapGeoLocation = (geoLocationKey) => {
            this.dataService.getLocationIndexedMap(geoLocationKey).then((geoLocationMap) => {
                // set local geo location array from indexedDB
                if (geoLocationMap
                    && geoLocationMap.data
                    && geoLocationMap.data.length) {
                    this.businessHierarchyService.geoLocationRowArray = geoLocationMap.data;
                }
                else {
                    // create indexedDB geo location map entry for tenant+userId+geolocation
                    this.businessHierarchyService.geoLocationRowArray = [];
                    this.dataService.setLocationMap({}, geoLocationKey);
                }
            }).catch(() => {
                // create indexedDB geo location map entry for tenant+userId+geolocation
                this.businessHierarchyService.geoLocationRowArray = [];
                this.dataService.setLocationMap({}, geoLocationKey);
            });
        };
        this.locationWebSocket = () => {
            const sysToken = this.dataService.getAccessToken();
            this.authService.getProperties(sysToken != null, this.unsubscribe$).then(properties => {
                const ENDPOINT = properties['value'] && properties['value']['locationWSEndpoint'] ? properties['value']['locationWSEndpoint'] : null;
                const isLocal = properties['value'] && properties['value']['isLocalForLHWebsocket'] ? properties['value']['isLocalForLHWebsocket'] : false;
                // console.log('Websocket ENDPOINT::', ENDPOINT);
                this.wsconnectService.connect(ENDPOINT, sysToken, null, isLocal);
                setTimeout(() => {
                    this.getMessages();
                });
                this.keepAliveInterval = setInterval(() => {
                    if (this.wsconnectService
                        && this.wsconnectService.messages) {
                        this.wsconnectService.messages.next('keep-alive message');
                    }
                }, 30000);
            });
        };
        this.locationTimeStampWebSocket = (timestamp) => {
            const locationMapKey = this.dataService.getTenantId() + this.dataService.getUserName();
            if (timestamp) {
                const sysToken = this.dataService.getAccessToken();
                this.authService.getProperties(sysToken != null, this.unsubscribe$).then(properties => {
                    const ENDPOINT = properties['value'] && properties['value']['locationWSTimeStampEndpoint'] ? properties['value']['locationWSTimeStampEndpoint'] : null;
                    const isLocal = properties['value'] && properties['value']['isLocalForLHWebsocket'] ? properties['value']['isLocalForLHWebsocket'] : false;
                    // console.log('Websocket ENDPOINT::', ENDPOINT);
                    this.wsconnectService.connect(ENDPOINT, sysToken, timestamp, isLocal);
                    setTimeout(() => {
                        this.getTimestampMessages();
                    });
                    this.keepAliveInterval = setInterval(() => {
                        if (this.wsconnectService
                            && this.wsconnectService.messages) {
                            this.wsconnectService.messages.next('keep-alive message');
                        }
                    }, 30000);
                });
            }
        };
        this.getMessages = () => {
            let messageSubscriber = this.wsconnectService.messages;
            messageSubscriber.subscribe(msg => {
                //  console.log(msg);
                // if session is logged out, then ignore incoming messages
                if (!this.dataService.getAccessToken())
                    return;
                // else proceed to consume incoming messages
                if (msg && msg.event) {
                    let evt = msg.event;
                    this.browserDetails.websocketConnection = true;
                    this.incomingMessages = true;
                    switch (evt) {
                        case "Initial-Loading Setup": // console.log('initial', msg.data);
                            // const msgTime = new Date().getTime();
                            // console.log("New Socket Message::", msgTime);
                            if (!this.dataService.initialLocationCompletedWS) {
                                this.parseLocationData(msg.data);
                            }
                            // this.dataService.setLocationInitial(msg.data);
                            break;
                        case "Initial-Loading Completed":
                            // console.log('initial', msg.data);
                            // this.dataService.setLocationInitial(msg.data);
                            this.dataService.initialLocationCompletedWS = true;
                            // store location map data in indexedDB
                            setTimeout(() => {
                                const locationMapKey = this.dataService.getTenantId() + this.dataService.getUserName();
                                const rootLocationId = this.dataService.getFromStorage('rootLocationId');
                                if (rootLocationId) {
                                    const rootObj = this.dataService.getLocationRowMapByKey(rootLocationId);
                                    if (rootObj) {
                                        // const timestamp = rootObj['lastUpdateTimestamp'] ? rootObj['lastUpdateTimestamp'] : rootObj['timestamp'];
                                        const timestamp = new Date().getTime();
                                        let locationMapTimestampObj = {};
                                        locationMapTimestampObj['data'] = this.dataService.getLocationRowMap();
                                        locationMapTimestampObj['timestamp'] = timestamp;
                                        locationMapTimestampObj['version'] = this.indexedDBVersion;
                                        locationMapTimestampObj['rootLocationId'] = rootLocationId;
                                        if (!this.indexedDBVersion) {
                                            this.businessHierarchyService.indexedDBVersion().subscribe(data => {
                                                if (data.status
                                                    && data.data
                                                    && data.data.version) {
                                                    this.indexedDBVersion = data.data.version;
                                                    locationMapTimestampObj['version'] = this.indexedDBVersion;
                                                    if (timestamp) {
                                                        this.dataService.setLocationMap(locationMapTimestampObj, locationMapKey);
                                                    }
                                                }
                                            });
                                        }
                                        else {
                                            if (timestamp) {
                                                this.dataService.setLocationMap(locationMapTimestampObj, locationMapKey);
                                            }
                                        }
                                    }
                                    this.moveGeoLocationToIndexedDB();
                                }
                            }, 1000);
                            // store geolocation into indexedDB
                            setTimeout(() => {
                                this.moveGeoLocationToIndexedDB();
                            }, 1000);
                            break;
                        case "Permission Change":
                            // create indexedDB locationMap entry for tenant+userId
                            const locationMapKey = this.dataService.getTenantId() + this.dataService.getUserName();
                            this.dataService.setLocationMap({}, locationMapKey);
                            this.dataService.locationRowArray = [];
                            this.dataService.setToastMessage("There are some incoming changes to your Location hierarchy. Page will reload now.", 5000, null, null, "error");
                            this.dataService.display(true);
                            setTimeout(() => {
                                window.location.reload();
                            }, 5000);
                            break;
                        case "ADD":
                            // Delta Update - ADD
                            // console.log("Delta Update - ADD::", msg.data);
                            // this.dataService.setLocationPartial(msg.data, msg.data.parentId);
                            this.prepareDeltaAdd(msg.data);
                            break;
                        case "UPDATE":
                            // Delta Update - UPDATE
                            // console.log("Delta Update - UPDATE::", msg.data);
                            // this.dataService.setLocationPartial(msg.data, msg.data.parentId);
                            this.prepareDeltaUpdate(msg.data);
                            break;
                        case "DELETE":
                            // Delta Update - DELETE
                            // console.log("Delta Update - DELETE::", msg.data);
                            // this.dataService.setLocationPartial(msg.data, msg.data.parentId);
                            this.prepareDeltaDelete(msg.data);
                            break;
                        case 'Timestamp-Complete': // Timestamp-Complete Event
                            // store location map data in indexedDB
                            setTimeout(() => {
                                const locationMapKey = this.dataService.getTenantId() + this.dataService.getUserName();
                                const rootLocationId = this.dataService.getFromStorage('rootLocationId');
                                if (rootLocationId) {
                                    const rootObj = this.dataService.getLocationRowMapByKey(rootLocationId);
                                    if (rootObj) {
                                        // const timestamp = rootObj['lastUpdateTimestamp'] ? rootObj['lastUpdateTimestamp'] : rootObj['timestamp'];
                                        const timestamp = new Date().getTime();
                                        let locationMapTimestampObj = {};
                                        locationMapTimestampObj['data'] = this.dataService.getLocationRowMap();
                                        locationMapTimestampObj['timestamp'] = timestamp;
                                        locationMapTimestampObj['version'] = this.indexedDBVersion;
                                        locationMapTimestampObj['rootLocationId'] = rootLocationId;
                                        if (!this.indexedDBVersion) {
                                            this.businessHierarchyService.indexedDBVersion().subscribe(data => {
                                                if (data.status
                                                    && data.data
                                                    && data.data.version) {
                                                    this.indexedDBVersion = data.data.version;
                                                    locationMapTimestampObj['version'] = this.indexedDBVersion;
                                                    if (timestamp) {
                                                        this.dataService.setLocationMap(locationMapTimestampObj, locationMapKey);
                                                    }
                                                    this.prepareLocationRowArray();
                                                }
                                            });
                                        }
                                        else {
                                            if (timestamp) {
                                                this.dataService.setLocationMap(locationMapTimestampObj, locationMapKey);
                                            }
                                            this.prepareLocationRowArray();
                                        }
                                    }
                                }
                            }, 1000);
                            break;
                    }
                }
            });
        };
        this.getTimestampMessages = () => {
            let messageSubscriber = this.wsconnectService.messages;
            this.locTimestamp = null;
            let timestamp = new Date().getTime();
            messageSubscriber.subscribe(msg => {
                //  console.log(msg);
                // if session is logged out, then ignore incoming messages
                if (!this.dataService.getAccessToken())
                    return;
                // else proceed to consume incoming messages
                if (msg && msg.event) {
                    this.browserDetails.websocketConnection = true;
                    this.dataService.setActiveTimeStampConnection(true);
                    let evt = msg.event;
                    this.incomingMessages = true;
                    switch (evt) {
                        case "Permission Change":
                            // create indexedDB locationMap entry for tenant+userId
                            const locationMapKey = this.dataService.getTenantId() + this.dataService.getUserName();
                            this.dataService.setLocationMap({}, locationMapKey);
                            this.dataService.locationRowArray = [];
                            this.dataService.setToastMessage("There are some incoming changes to your Location hierarchy. Page will reload now.", 5000, null, null, "error");
                            this.dataService.display(true);
                            setTimeout(() => {
                                window.location.reload();
                            }, 5000);
                            break;
                        case "ADD":
                            // Delta Update - ADD
                            // console.log("Delta Update - ADD::", msg.data);
                            // this.dataService.setLocationPartial(msg.data, msg.data.parentId);
                            this.prepareDeltaAdd(msg.data);
                            this.browserDetails.websocketAvailable = true;
                            // if (msg.data && msg.data.timestamp) {
                            // 	this.locTimestamp = msg.data.timestamp;
                            // }
                            timestamp = new Date().getTime();
                            this.locTimestamp = timestamp;
                            break;
                        case "UPDATE":
                            // Delta Update - UPDATE
                            // console.log("Delta Update - UPDATE::", msg.data);
                            // this.dataService.setLocationPartial(msg.data, msg.data.parentId);
                            this.prepareDeltaUpdate(msg.data);
                            this.browserDetails.websocketAvailable = true;
                            // if (msg.data && msg.data.timestamp) {
                            // 	this.locTimestamp = msg.data.timestamp;
                            // }
                            timestamp = new Date().getTime();
                            this.locTimestamp = timestamp;
                            break;
                        case "DELETE":
                            // Delta Update - DELETE
                            // console.log("Delta Update - DELETE::", msg.data);
                            // this.dataService.setLocationPartial(msg.data, msg.data.parentId);
                            this.prepareDeltaDelete(msg.data);
                            this.browserDetails.websocketAvailable = true;
                            // if (msg.data && msg.data.timestamp) {
                            // 	this.locTimestamp = msg.data.timestamp;
                            // }
                            timestamp = new Date().getTime();
                            this.locTimestamp = timestamp;
                            break;
                        case 'Timestamp-Complete': // Timestamp-Complete Event
                            // store location map data in indexedDB
                            this.browserDetails.websocketAvailable = true;
                            if (this.deltaUpdateWaitInterval)
                                clearInterval(this.deltaUpdateWaitInterval);
                            setTimeout(() => {
                                setTimeout(() => {
                                    this.dataService.setLocLoadingStarted(true);
                                }, 1000);
                                this.moveToIndexedDB();
                                this.prepareLocationRowArray();
                            }, 1000);
                            // store geolocation into indexedDB
                            setTimeout(() => {
                                this.moveGeoLocationToIndexedDB();
                            }, 1000);
                            break;
                    }
                }
            });
        };
        this.moveGeoLocationToIndexedDB = () => {
            const geoLocationMapKey = this.dataService.getTenantId() + this.dataService.getUserName() + '-geolocation';
            if (this.businessHierarchyService.geoLocationRowArray
                && this.businessHierarchyService.geoLocationRowArray.length) {
                let geoLocationMapObj = {};
                geoLocationMapObj['data'] = this.businessHierarchyService.geoLocationRowArray;
                this.dataService.setLocationMap(geoLocationMapObj, geoLocationMapKey);
            }
            else {
                this.dataService.setLocationMap({}, geoLocationMapKey);
            }
        };
        this.moveToIndexedDB = () => {
            const locationMapKey = this.dataService.getTenantId() + this.dataService.getUserName();
            const rootLocationId = this.dataService.getFromStorage('rootLocationId');
            if (rootLocationId) {
                const rootObj = this.dataService.getLocationRowMapByKey(rootLocationId);
                if (rootObj) {
                    // const timestamp = rootObj['lastUpdateTimestamp'] ? rootObj['lastUpdateTimestamp'] : rootObj['timestamp'];
                    const timestamp = new Date().getTime();
                    let locationMapTimestampObj = {};
                    locationMapTimestampObj['data'] = this.dataService.getLocationRowMap();
                    if (locationMapTimestampObj['data'] && locationMapTimestampObj['data'].size) {
                        this.browserDetails.websocketAvailable = true;
                    }
                    locationMapTimestampObj['timestamp'] = this.locTimestamp ? this.locTimestamp : timestamp;
                    locationMapTimestampObj['rootLocationId'] = rootLocationId;
                    locationMapTimestampObj['version'] = this.indexedDBVersion;
                    if (!this.indexedDBVersion) {
                        this.businessHierarchyService.indexedDBVersion().subscribe(data => {
                            if (data.status
                                && data.data
                                && data.data.version) {
                                this.indexedDBVersion = data.data.version;
                                locationMapTimestampObj['version'] = this.indexedDBVersion;
                                if (timestamp) {
                                    this.dataService.setLocationMap(locationMapTimestampObj, locationMapKey);
                                    clearInterval(this.deltaUpdateWaitInterval);
                                }
                                else {
                                    clearInterval(this.deltaUpdateWaitInterval);
                                }
                            }
                            else {
                                clearInterval(this.deltaUpdateWaitInterval);
                            }
                        }, error => {
                            clearInterval(this.deltaUpdateWaitInterval);
                        });
                    }
                    else {
                        if (timestamp) {
                            this.dataService.setLocationMap(locationMapTimestampObj, locationMapKey);
                            clearInterval(this.deltaUpdateWaitInterval);
                        }
                        else {
                            clearInterval(this.deltaUpdateWaitInterval);
                        }
                    }
                }
                else {
                    clearInterval(this.deltaUpdateWaitInterval);
                }
            }
            else {
                clearInterval(this.deltaUpdateWaitInterval);
            }
        };
        this.resetDeltaInterval = () => {
            clearInterval(this.deltaUpdateWaitInterval);
            this.deltaUpdateWaitInterval = setInterval(() => {
                this.moveToIndexedDB();
                this.prepareLocationRowArray();
            }, 2000);
        };
        this.parseLocationData = (evtData) => {
            if (evtData[0] === 'LH' && evtData[1].length) {
                this.browserDetails.websocketAvailable = true;
                evtData[1].map((rowData, i) => {
                    if (rowData.length > 1) {
                        setTimeout(() => {
                            let parentLocMap = [];
                            for (let i = 1; i < rowData.length; i++) {
                                let loc = this.prepareLocationRow(rowData, i);
                                parentLocMap.push(loc);
                            }
                            let parentKey = rowData[0];
                            if (rowData[0] !== '-1') {
                                let parentLoc = this.dataService.getLocationRowMapByKey(parentKey);
                                parentLoc['childData'] = [...parentLoc['childData'], ...parentLocMap];
                                this.dataService.setLocationRowMap(parentKey, parentLoc);
                            }
                            if (i + 1 === evtData[1].length) {
                                const mapPreparedTime = new Date().getTime();
                                console.log("Locations Map :: ", this.dataService.getLocationRowMap(), "Map Updated At::", mapPreparedTime);
                                this.dataService.setLocationSetStatus(parentKey);
                            }
                        });
                    }
                });
            }
        };
        this.prepareLocationRow = (rowData, i) => {
            if (rowData[i]) {
                let locRow = this.newlocationUtils.prepareLocationRow(rowData[0], rowData[i]);
                let locId = locRow['id'];
                if (locId) {
                    if (rowData[0] === "-1") {
                        this.dataService.setInStorage("rootLocationId", locId);
                        setTimeout(() => {
                            this.dataService.setLocLoadingStarted(true);
                        }, 1000);
                    }
                    try {
                        if ((locRow['geoLocation']
                            && locRow['geoLocation'].length
                            && locRow['geoLocation'].split(",")[0] != "0.0"
                            && locRow['geoLocation'].split(",")[1] != "0.0")) {
                            const ifGeolocationExists = this.businessHierarchyService.getGeoLocationArrayByKey("id", locRow['id']);
                            if (!ifGeolocationExists || ifGeolocationExists.length == 0)
                                this.businessHierarchyService.geoLocationRowArray.push(this.newlocationUtils.getGeoLocationDataFromLocation(locRow));
                        }
                    }
                    catch (err) {
                        console.log("Geolocation Errored", err);
                    }
                    let immediateParentLoc = '';
                    if (locRow['parentId']) {
                        immediateParentLoc = this.dataService.getLocationRowMapByKey(locRow['parentId']);
                    }
                    if (locRow['licenseInfo']
                        && locRow['licenseInfo'].licenseTypes
                        && locRow['licenseInfo'].licenseTypes.length) {
                        locRow['licenseType'] = locRow['licenseInfo'].licenseTypes[0];
                    }
                    else if (immediateParentLoc && immediateParentLoc['licenseType']) {
                        locRow['licenseType'] = immediateParentLoc['licenseType'];
                    }
                    else {
                        locRow['licenseType'] = this.lh2LicenseType;
                    }
                    const shortKey = this.getLicenseShortKey(locRow['licenseType']);
                    if (shortKey) {
                        if (locRow['licenses']) {
                            if (locRow['licenses'].indexOf(shortKey) === -1) {
                                locRow['licenses'].push(shortKey);
                            }
                            else {
                                // license already added
                            }
                        }
                        else {
                            locRow['licenses'] = [];
                            locRow['licenses'].push(shortKey);
                        }
                    }
                    // preparing location full path
                    if (locRow['locationPath'] && locRow['locationPath'].length) {
                        locRow['locationPathFull'] = [...locRow['locationPath']];
                    }
                    this.dataService.setLocationRowMap(locId, locRow);
                    if (locRow['locationPath'] && locRow['locationPath'].length) {
                        const locationPath = locRow['locationPath'];
                        locationPath.map((locId) => {
                            let parentLoc = this.dataService.getLocationRowMapByKey(locId);
                            parentLoc["apCnt"] = parentLoc["apCnt"] + locRow["apCnt"];
                            parentLoc["cameraCnt"] = parentLoc["cameraCnt"] + locRow["cameraCnt"];
                            parentLoc["accessCodeCnt"] = parentLoc["accessCodeCnt"] + locRow["accessCodeCnt"];
                            parentLoc["portalCnt"] = parentLoc["portalCnt"] + locRow["portalCnt"];
                            if (rowData[0] !== "-1" && i === 1) {
                                if (parentLoc['nodesBelow'] < locRow['locationPath'].length) {
                                    parentLoc['nodesBelow'] += 1;
                                }
                                console.log(parentLoc['name'], ' nodes below:: ', parentLoc['nodesBelow']);
                            }
                            this.dataService.setLocationRowMap(locId, parentLoc);
                        });
                    }
                    this.dataService.setLocationRowArray({
                        id: locRow['id'],
                        name: locRow['name'],
                        path: locRow['locationPath'],
                        type: locRow['type']
                    });
                    return { id: locId, name: locRow['name'] };
                }
                else {
                    // return null;
                }
            }
            else {
                return null;
            }
        };
        this.prepareLocationRowArray = () => {
            this.dataService.locationRowArray = [];
            this.dataService.getLocationRowMap().forEach(locRow => {
                this.dataService.setLocationRowArray({
                    id: locRow['id'],
                    name: locRow['name'],
                    path: locRow['locationPath'],
                    type: locRow['type']
                });
            });
        };
        this.prepareDeltaAdd = (location) => {
            if (location.id) {
                try {
                    location['type'] = location['inferredLocationTypes'];
                    delete location['inferredLocationTypes'];
                    const childData = this.dataService.getLocationChildrenByParentId(location.id);
                    if (childData
                        && childData.length) {
                        // not a new location. adding child locations back to its children.
                        location.childData = childData;
                        location.hasChildren = true;
                    }
                    // license check and update
                    let immediateParentLoc = '';
                    if (location['parentId']) {
                        immediateParentLoc = this.dataService.getLocationRowMapByKey(location['parentId']);
                    }
                    if (location['licenseInfo']
                        && location['licenseInfo'].licenseTypes
                        && location['licenseInfo'].licenseTypes.length) {
                        location['licenseType'] = location['licenseInfo'].licenseTypes[0];
                    }
                    else if (immediateParentLoc && immediateParentLoc['licenseType']) {
                        location['licenseType'] = immediateParentLoc['licenseType'];
                    }
                    else {
                        location['licenseType'] = this.lh2LicenseType;
                    }
                    location.children = null;
                    this.dataService.setLocationRowMap(location.id, location);
                    let oldParentLocData = this.dataService.getLocationRowMapByKey(location.parentId);
                    if (oldParentLocData) {
                        if (oldParentLocData.childData
                            && oldParentLocData.childData.length) {
                            let locFound = false;
                            oldParentLocData.childData.map((child) => {
                                if (child.id
                                    && child.id === location.id) {
                                    locFound = true;
                                }
                            });
                            if (!locFound) {
                                oldParentLocData['hasChildren'] = true;
                                oldParentLocData.childData.push({ id: location.id, name: location.name });
                                oldParentLocData.childCount = oldParentLocData.childData.length;
                                oldParentLocData.children = null;
                            }
                        }
                        else {
                            oldParentLocData.childData = [];
                            let locFound = false;
                            oldParentLocData.childData.map((child) => {
                                if (child.id
                                    && child.id === location.id) {
                                    locFound = true;
                                }
                            });
                            if (!locFound) {
                                oldParentLocData['hasChildren'] = true;
                                oldParentLocData.childData.push({ id: location.id, name: location.name });
                                oldParentLocData.childCount = oldParentLocData.childData.length;
                                oldParentLocData.children = null;
                            }
                        }
                        this.dataService.setLocationRowMap(location.parentId, oldParentLocData);
                        this.dataService.setLocationAddEvt(location);
                        this.prepareGeoLocationDataForAdd(location);
                        this.resetDeltaInterval();
                    }
                    else {
                        console.log('Parent Location Missing');
                    }
                }
                catch (e) {
                    console.log('Delta update failed');
                }
            }
            else
                return;
        };
        this.prepareDeltaUpdate = (location) => {
            if (location.id) {
                try {
                    location['type'] = location['inferredLocationTypes'];
                    delete location['inferredLocationTypes'];
                    let oldLocData = this.dataService.getLocationRowMapByKey(location.id);
                    if (oldLocData) {
                        let newLocData = Object.assign(Object.assign({}, oldLocData), location);
                        newLocData.children = null;
                        let oldParentLocData = this.dataService.getLocationRowMapByKey(oldLocData.parentId);
                        if (oldParentLocData) {
                            if (oldParentLocData.childData
                                && oldParentLocData.childData.length) {
                                oldParentLocData.childData.map((child) => {
                                    if (child.id === location.id) {
                                        child.name = location.name;
                                    }
                                });
                            }
                        }
                        oldParentLocData.children = null;
                        this.dataService.setLocationRowMap(oldParentLocData.id, oldParentLocData);
                        console.log('New location data::', newLocData);
                        if (newLocData.childCount)
                            newLocData.hasChildren = true;
                        else
                            newLocData.hasChildren = false;
                        // license check and update
                        if (newLocData['licenseInfo']
                            && newLocData['licenseInfo'].licenseTypes
                            && newLocData['licenseInfo'].licenseTypes.length) {
                            newLocData['licenseType'] = newLocData['licenseInfo'].licenseTypes[0];
                        }
                        else if (oldParentLocData && oldParentLocData['licenseType']) {
                            newLocData['licenseType'] = oldParentLocData['licenseType'];
                        }
                        else {
                            newLocData['licenseType'] = this.lh2LicenseType;
                        }
                        this.dataService.setLocationRowMap(location.id, newLocData);
                        setTimeout(() => {
                            this.resetDeltaInterval();
                        });
                        this.dataService.setLocationUpdateEvt(location);
                        this.prepareGeoLocationDataForUpdate(location);
                    }
                    else {
                        console.log('Previous Location Data Missing');
                    }
                }
                catch (e) {
                    console.log('Delta update failed');
                }
            }
            else
                return;
        };
        this.prepareDeltaDelete = (location) => {
            if (location.locationId) {
                try {
                    let locMap = this.dataService.locationRowMap;
                    const oldLocData = this.dataService.getLocationRowMapByKey(location.locationId);
                    if (oldLocData) {
                        // delete the location from locationRowMap in dataservice
                        locMap.delete(location.locationId);
                        this.dataService.locationRowMap = locMap;
                        this.resetDeltaInterval();
                        // delete location also from geolocation indexeddb
                        this.deleteGeoLocationIndexedDb(location.locationId);
                        // delete child data in parent
                        if (oldLocData.parentId) {
                            let parentData = this.dataService.getLocationRowMapByKey(oldLocData.parentId);
                            let locIndex = -1;
                            if (parentData
                                && parentData.childData
                                && parentData.childData.length) {
                                let parentChildren = parentData.childData;
                                for (let i = 0; i < parentChildren.length; i++) {
                                    if (parentChildren[i].id === location.locationId) {
                                        locIndex = i;
                                        break;
                                    }
                                }
                                if (locIndex > -1) {
                                    parentData.childData.splice(locIndex, 1);
                                    if (parentData
                                        && parentData.children
                                        && parentData.children.length) {
                                        parentData.children.splice(locIndex, 1);
                                    }
                                    if (parentData.children
                                        && parentData.children.length === 0) {
                                        parentData.children = null;
                                    }
                                    // parentData.childCount = parentData.childCount - 1 > -1 ? parentData.childCount - 1 : 0;
                                    if (parentData.nodesBelow)
                                        parentData.nodesBelow = parentData.nodesBelow - 1 > -1 ? parentData.nodesBelow - 1 : 0;
                                    if (!parentData.childCount || parentData.childCount === 0) {
                                        parentData.hasChildren = false;
                                        parentData.nodesBelow = 0;
                                    }
                                }
                                this.dataService.setLocationRowMap(parentData.id, parentData);
                            }
                        }
                        // delete location from locationRowArray
                        this.dataService.deleteLocationRowArrayByKey(location.locationId);
                        // publish location delete event
                        this.dataService.setLocationDeleteEvt({ id: location.locationId, parentId: oldLocData.parentId });
                    }
                    else {
                        console.log('Previous Location Data Missing');
                    }
                }
                catch (e) {
                    console.log('Delta update failed');
                }
            }
            else
                return;
        };
        this.prepareGeoLocationData = (location) => {
            if (location.latitude && location.longitude) {
                location.latitude = parseFloat(location.latitude);
                location.longitude = parseFloat(location.longitude);
                if (location.latitude != 0.0 && location.longitude != 0.0) {
                    this.businessHierarchyService.setGeoLocationArray(location);
                    this.updateGeoLocationIndexedDb();
                }
            }
        };
        this.updateGeoLocationIndexedDb = () => {
            this.moveGeoLocationToIndexedDB();
        };
        this.deleteGeoLocationIndexedDb = (locId) => {
            try {
                const locationMapGeoKey = this.dataService.getTenantId() + this.dataService.getUserName() + '-geolocation';
                // delete geolocation from data service local array
                if (this.businessHierarchyService.geoLocationRowArray
                    && this.businessHierarchyService.geoLocationRowArray.length) {
                    const locIndex = this.businessHierarchyService.geoLocationRowArray.indexOf(locId);
                    if (locIndex > -1) {
                        this.businessHierarchyService.geoLocationRowArray.splice(locIndex, 1);
                    }
                }
                // delete geo location from indexeddb
                this.dataService.getLocationIndexedMap(locationMapGeoKey).then((geoLocationMap) => {
                    if (geoLocationMap
                        && geoLocationMap.data
                        && geoLocationMap.data.length) {
                        let geoLocData = geoLocationMap.data;
                        const locIndex = geoLocData.indexOf(locId);
                        if (locIndex > -1) {
                            geoLocData.splice(locIndex, 1);
                        }
                        this.businessHierarchyService.geoLocationRowArray = geoLocData;
                        this.moveGeoLocationToIndexedDB();
                    }
                    else {
                        this.businessHierarchyService.geoLocationRowArray = [];
                    }
                });
            }
            catch (e) {
                console.log("Error in deleting geo location from indexeddn");
            }
        };
        this.getFlattenedStructure = () => {
            this.businessHierarchyService.getIndexedDBFlattened().subscribe(data => {
                try {
                    if (data && data.status) {
                        const indexedDBData = data.data;
                        if (indexedDBData) {
                            this.parseLocationData(indexedDBData);
                            setTimeout(() => {
                                this.moveToIndexedDB();
                                this.prepareLocationRowArray();
                            }, 2000);
                        }
                    }
                }
                catch (err) {
                    console.log("Error fetching flattened indexedDB data", err);
                }
            }, error => {
                console.log("Error fetching flattened indexedDB data", error);
            });
        };
        this.getTimeDiffInHours = (start, end) => {
            let difference = Math.abs(end - start);
            let resultInMinutes = difference / 60000;
            let resultInHours = Math.round(resultInMinutes / 60);
            // console.log(difference)
            // console.log(resultInMinutes)
            return resultInHours;
        };
        this.prepareGeoLocationDataForAdd = (locRow) => {
            try {
                if ((locRow['geoLocation']
                    && locRow['geoLocation'].length
                    && locRow['geoLocation'].split(",")[0] != "0.0"
                    && locRow['geoLocation'].split(",")[1] != "0.0")) {
                    const ifGeolocationExists = this.businessHierarchyService.getGeoLocationArrayByKey("id", locRow['id']);
                    if (!ifGeolocationExists || ifGeolocationExists.length == 0) {
                        this.businessHierarchyService.geoLocationRowArray.push(this.newlocationUtils.getGeoLocationDataFromLocation(locRow));
                        setTimeout(() => {
                            this.moveGeoLocationToIndexedDB();
                        }, 100);
                    }
                }
            }
            catch (err) {
                console.log("Geolocation Errored", err);
            }
        };
        this.prepareGeoLocationDataForUpdate = (locRow) => {
            try {
                if ((locRow['geoLocation']
                    && locRow['geoLocation'].length)) {
                    if (locRow['geoLocation'].split(",")[0] != "0.0"
                        && locRow['geoLocation'].split(",")[1] != "0.0") {
                        const geoLocationIndex = this.businessHierarchyService.getGeoLocationArrayIndex("id", locRow['id']);
                        let loc = this.newlocationUtils.getGeoLocationDataFromLocation(locRow);
                        if (geoLocationIndex > -1) {
                            this.businessHierarchyService.geoLocationRowArray[geoLocationIndex] = loc;
                            setTimeout(() => {
                                this.moveGeoLocationToIndexedDB();
                            }, 100);
                        }
                        else {
                            this.prepareGeoLocationDataForAdd(locRow);
                        }
                    }
                    else {
                        this.prepareGeoLocationDataForDelete(locRow);
                    }
                }
                else {
                    console.log("Geolocation Data Missing for location update", locRow);
                }
            }
            catch (err) {
                console.log("Geolocation Errored", err);
            }
        };
        this.prepareGeoLocationDataForDelete = (locRow) => {
            try {
                const geoLocationIndex = this.businessHierarchyService.getGeoLocationArrayIndex("id", locRow['id']);
                if (geoLocationIndex > -1) {
                    this.businessHierarchyService.geoLocationRowArray.splice(geoLocationIndex, 1);
                }
            }
            catch (err) {
                console.log("Geolocation Errored", err);
            }
        };
        this.getLicenseShortKey = (license) => {
            license = license.toLowerCase();
            let l = '';
            switch (license) {
                case 'see':
                    l = 's';
                    break;
                case 'extend':
                    l = 'e';
                    break;
                case 'smart_venues':
                    l = 'v';
                    break;
                case 'smart_ops':
                    l = 'o';
                    break;
                case 'smart_operations':
                    l = 'o';
                    break;
                case 'act':
                    l = 'a';
                    break;
                case 'unlimited':
                    l = 'u';
                    break;
                default: break;
            }
            return l;
        };
    }
}
Lh2Service.ɵfac = function Lh2Service_Factory(t) { return new (t || Lh2Service)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(AuthService), i0.ɵɵinject(UserService), i0.ɵɵinject(BusinessHierarchyService), i0.ɵɵinject(WsService), i0.ɵɵinject(WsconnectService)); };
Lh2Service.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: Lh2Service, factory: Lh2Service.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Lh2Service, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DataService }, { type: i0.Injector }, { type: AuthService }, { type: UserService }, { type: BusinessHierarchyService }, { type: WsService }, { type: WsconnectService }]; }, null); })();

const _c0$1j = ["tree"];
function ManageLh2TreeComponent_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("click", function ManageLh2TreeComponent_div_2_div_5_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.clearInput(); });
    i0.ɵɵelementStart(1, "span", 15);
    i0.ɵɵtext(2, "\uE906");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "business-hierarchy-lib.business-location-details.back-text"), " ");
} }
function ManageLh2TreeComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "input", 11);
    i0.ɵɵlistener("focus", function ManageLh2TreeComponent_div_2_Template_input_focus_1_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.showRecentSearch(); })("focusout", function ManageLh2TreeComponent_div_2_Template_input_focusout_1_listener() { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.searchFocusOut(); })("keydown", function ManageLh2TreeComponent_div_2_Template_input_keydown_1_listener() { i0.ɵɵrestoreView(_r12); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.inputChanged(); })("keydown.enter", function ManageLh2TreeComponent_div_2_Template_input_keydown_enter_1_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.onSearch($event); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 12);
    i0.ɵɵlistener("click", function ManageLh2TreeComponent_div_2_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r12); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.clearInput(); });
    i0.ɵɵtext(4, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ManageLh2TreeComponent_div_2_div_5_Template, 5, 3, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(2, 2, "business-hierarchy-lib.hierarchy-base.search-text"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.searchActive);
} }
function ManageLh2TreeComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "business-hierarchy-lib.hierarchy-base.enter-atleast-four-letters-to-search-text"), " ");
} }
function ManageLh2TreeComponent_div_3_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r19.searchResults && ctx_r19.searchResults.length ? ctx_r19.searchResults.length : ctx_r19.matchingText, " ", i0.ɵɵpipeBind1(2, 2, "business-hierarchy-lib.hierarchy-base.results-found-text"), " ");
} }
function ManageLh2TreeComponent_div_3_div_2_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "div", 27);
    i0.ɵɵlistener("click", function ManageLh2TreeComponent_div_3_div_2_div_2_div_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r24); const item_r22 = restoredCtx.$implicit; const ctx_r23 = i0.ɵɵnextContext(4); return ctx_r23.goToLocation(item_r22); });
    i0.ɵɵelement(2, "div", 28);
    i0.ɵɵelementStart(3, "div", 29);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r22 = ctx.$implicit;
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r21.getHighlightedName(item_r22.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.getLocationPath(item_r22), " ");
} }
function ManageLh2TreeComponent_div_3_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, ManageLh2TreeComponent_div_3_div_2_div_2_div_1_Template, 5, 2, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r20.searchResults);
} }
function ManageLh2TreeComponent_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, ManageLh2TreeComponent_div_3_div_2_div_1_Template, 3, 4, "div", 21);
    i0.ɵɵtemplate(2, ManageLh2TreeComponent_div_3_div_2_div_2_Template, 2, 1, "div", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.fourCharTyped());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.searchResults && ctx_r18.searchResults.length);
} }
function ManageLh2TreeComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, ManageLh2TreeComponent_div_3_div_1_Template, 3, 3, "div", 17);
    i0.ɵɵtemplate(2, ManageLh2TreeComponent_div_3_div_2_Template, 3, 2, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.fourCharTyped());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.showRecent && !ctx_r1.newInput);
} }
function ManageLh2TreeComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵelementStart(2, "input", 32);
    i0.ɵɵlistener("click", function ManageLh2TreeComponent_div_5_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.toggleAllLocations(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 34);
    i0.ɵɵtext(5, " Show all locations ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r2.showAllLocations);
} }
const _c1$w = function (a0) { return { "hide-location": a0 }; };
function ManageLh2TreeComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "tree-node-wrapper", 35);
    i0.ɵɵelement(2, "tree-node-children", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r27 = ctx.$implicit;
    const index_r28 = ctx.index;
    const templates_r29 = ctx.templates;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(node_r27.getClass());
    i0.ɵɵclassProp("tree-node", true)("tree-node-expanded", node_r27.isExpanded && node_r27.hasChildren)("tree-node-collapsed", node_r27.isCollapsed && node_r27.hasChildren)("tree-node-leaf", node_r27.isLeaf)("tree-node-active", node_r27.isActive)("tree-node-focused", node_r27.isFocused);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c1$w, !ctx_r5.canShowLocation(node_r27)))("node", node_r27)("index", index_r28)("templates", templates_r29);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("node", node_r27)("templates", templates_r29);
} }
function ManageLh2TreeComponent_ng_template_10_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 42);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r32.messageKeys["location-permission-error"], " ");
} }
function ManageLh2TreeComponent_ng_template_10_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r30 = i0.ɵɵnextContext().$implicit;
    const ctx_r33 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r33.getAppData(node_r30.data.id), " ");
} }
function ManageLh2TreeComponent_ng_template_10_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelementStart(1, "input", 49);
    i0.ɵɵlistener("click", function ManageLh2TreeComponent_ng_template_10_div_4_div_1_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r41); const node_r30 = i0.ɵɵnextContext(2).$implicit; const ctx_r39 = i0.ɵɵnextContext(); return ctx_r39.selectSingleNode(node_r30); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r30 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r36 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationTick-", node_r30.data.id, "");
    i0.ɵɵproperty("checked", ctx_r36.selectedLocation && ctx_r36.selectedLocation.length > 0 && node_r30.id === ctx_r36.selectedLocation[0].id)("value", node_r30.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationTick-", node_r30.data.id, "");
} }
function ManageLh2TreeComponent_ng_template_10_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelementStart(1, "input", 49);
    i0.ɵɵlistener("click", function ManageLh2TreeComponent_ng_template_10_div_4_div_2_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r45); const node_r30 = i0.ɵɵnextContext(2).$implicit; const ctx_r43 = i0.ɵɵnextContext(); return ctx_r43.selectSingleNode(node_r30); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 52);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r30 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r37 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r30.data.id, "");
    i0.ɵɵproperty("checked", ctx_r37.selectedLocation && ctx_r37.selectedLocation.length > 0 && node_r30.id === ctx_r37.selectedLocation[0].id)("value", node_r30.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r30.data.id, "");
} }
const _c2$k = function (a0, a1) { return { "location-selected": a0, "child-selected": a1 }; };
function ManageLh2TreeComponent_ng_template_10_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵelementStart(1, "input", 54);
    i0.ɵɵlistener("click", function ManageLh2TreeComponent_ng_template_10_div_4_div_3_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r49); const node_r30 = i0.ɵɵnextContext(2).$implicit; const ctx_r47 = i0.ɵɵnextContext(); return ctx_r47.selectMultipleNode($event, node_r30); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 55);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r30 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r38 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r30.data.id, "");
    i0.ɵɵproperty("value", node_r30.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r30.data.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c2$k, ctx_r38.isLocationSelected(node_r30), ctx_r38.isParentOfSelectedLocation(node_r30)));
} }
function ManageLh2TreeComponent_ng_template_10_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵtemplate(1, ManageLh2TreeComponent_ng_template_10_div_4_div_1_Template, 3, 4, "div", 45);
    i0.ɵɵtemplate(2, ManageLh2TreeComponent_ng_template_10_div_4_div_2_Template, 3, 4, "div", 46);
    i0.ɵɵtemplate(3, ManageLh2TreeComponent_ng_template_10_div_4_div_3_Template, 3, 7, "div", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r30 = i0.ɵɵnextContext().$implicit;
    const ctx_r34 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r30.data.access === "Full" && ctx_r34.treeConf.type === "tick" && ctx_r34.enableCheck(node_r30) || (node_r30.data.access === "Full" || node_r30.data.reportAccess) && ctx_r34.isReportsLocation && ctx_r34.treeConf.type === "tick");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r30.data.access === "Full" && ctx_r34.treeConf.type === "radio" && ctx_r34.enableCheck(node_r30) || (node_r30.data.access === "Full" || node_r30.data.reportAccess) && ctx_r34.isReportsLocation && ctx_r34.treeConf.type === "radio");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r30.data.access === "Full" && ctx_r34.treeConf.type === "checkbox" && ctx_r34.enableCheck(node_r30) || (node_r30.data.access === "Full" || node_r30.data.reportAccess) && ctx_r34.isReportsLocation && ctx_r34.treeConf.type === "checkbox");
} }
const _c3$d = function (a0) { return { "disabled-location": a0 }; };
function ManageLh2TreeComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtemplate(1, ManageLh2TreeComponent_ng_template_10_span_1_Template, 2, 1, "span", 38);
    i0.ɵɵelementStart(2, "business-hierarchy-node", 39);
    i0.ɵɵlistener("onhover", function ManageLh2TreeComponent_ng_template_10_Template_business_hierarchy_node_onhover_2_listener($event) { i0.ɵɵrestoreView(_r53); const ctx_r52 = i0.ɵɵnextContext(); return ctx_r52.hoverOnFunc($event); })("onout", function ManageLh2TreeComponent_ng_template_10_Template_business_hierarchy_node_onout_2_listener($event) { i0.ɵɵrestoreView(_r53); const ctx_r54 = i0.ɵɵnextContext(); return ctx_r54.hoverOutFunc($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ManageLh2TreeComponent_ng_template_10_div_3_Template, 2, 1, "div", 40);
    i0.ɵɵtemplate(4, ManageLh2TreeComponent_ng_template_10_div_4_Template, 4, 3, "div", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r30 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c3$d, !ctx_r7.checkActionAllowed(node_r30)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.showPermissionError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("setNode", node_r30)("setWlcLocationData", ctx_r7.wlcLocationData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.hasAppData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.checkActionAllowed(node_r30));
} }
const _c4$8 = function (a0) { return { "hide-tree": a0 }; };
class ManageLh2TreeComponent {
    constructor(router, dataService, lh2Service, authService, translate, cdRef) {
        this.router = router;
        this.dataService = dataService;
        this.lh2Service = lh2Service;
        this.authService = authService;
        this.translate = translate;
        this.cdRef = cdRef;
        this.unsubscribe$ = new Subject();
        this.propUnsubscribe$ = new Subject();
        this.deltaUnsubscribe1$ = new Subject();
        this.deltaUnsubscribe2$ = new Subject();
        this.deltaUnsubscribe3$ = new Subject();
        this.messages = [];
        this.destroyed$ = new Subject();
        this.showPermissionError = true;
        this.emptyChild = [
            {
                name: "Data Unavailable",
                hasChildren: false,
            },
        ];
        this.searchActive = false;
        this.showRecent = false;
        this.searchResults = [];
        this.recentSearch = [];
        this.searchedLocation = null;
        this.newInput = false;
        this.hideTree = false;
        this.matchingText = "No matching";
        // constructor() { }
        this.treeComponent = null;
        this.activeNode = new EventEmitter();
        this.locationInitialLoaded = new EventEmitter();
        this.onhover = new EventEmitter();
        this.onout = new EventEmitter();
        this.nodes = [{}];
        this.wlcLocationData = [];
        this.options = {
            getChildren: this.getChildren.bind(this),
            displayField: "name",
            isExpandedField: "expanded",
            idField: "id",
            actionMapping: {
                mouse: {
                //dblClick: (tree, node, $event) => {
                //  if (node.hasChildren) TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event);
                //},
                //click:(tree, node, $event) => {
                //this.logger.debug('mouse click', tree, node, $event);
                //}
                },
            },
            allowDrag: (node) => {
                return false;
            },
            allowDrop: (node) => {
                return false;
            },
            useVirtualScroll: false,
            animateExpand: false,
            animateSpeed: 10,
            animateAcceleration: 1.2,
            nodeHeight: 32,
            dropSlotHeight: 3,
        };
        this.deltaAddSub = this.dataService.getLocationAddEvt(this.deltaUnsubscribe1$);
        this.deltaUpdateSub = this.dataService.getLocationUpdateEvt(this.deltaUnsubscribe2$);
        this.deltaDeleteSub = this.dataService.getLocationDeleteEvt(this.deltaUnsubscribe3$);
        this.localProperty = null;
        this.isReportsLocation = false;
        this.isRichMapAvailable = false;
        this.isNodeSelected = false;
        this.selectedLocation = [];
        this.selectedLocationEvt = new EventEmitter();
        this.isPopup = false;
        this.popupOpened = false;
        this.treeConf = {
            type: "plain",
            selectedLocationIds: [],
            requiredLicenses: [
                "UNLIMITED",
                "ACT",
                "SMART_OPS",
                "SMART_VENUES",
                "EXTEND",
                "SEE",
            ],
            enableSearch: false,
            isPopup: true,
            isReportsLocation: false,
            isDataId: true,
            appData: {},
            restrictedLocations: [],
            popupOpened: false,
        };
        this.selectedParentLocations = [];
        this.selectedLocationIds = [];
        this.selectedParentIds = [];
        this.requiredLicenses = [];
        this.treeLicenses = [];
        this.enableSearch = false;
        this.tickSelect = false;
        this.plainSelect = false;
        this.messageKeys = [];
        this.noSelect = false;
        this.appName = "";
        this.hasAppData = false;
        this.showAllLocationsSwitch = false;
        this.showAllLocations = true;
        this.treeLoading = true;
        this.locationRowMap = new Map(null);
        // preselectLocations = (selectedLocations) => {
        //   //console.log('set selected location', selectedLocations);
        // 	// this.selectedLocation = selectedLocations;
        // 	if (!selectedLocations || selectedLocations.length == 0)
        // 		for (const id in this.selectedLocation) {
        // 			try {
        // 				this.selectedLocation[id].setIsExpanded(true);
        // 			} catch (e) {
        // 				console.log(
        // 					"location id not available",
        // 					this.selectedLocation[id]
        // 				);
        // 			}
        // 		}
        // 	else {
        // 		// setTimeout(() => {
        // 		//     for(var i=0;i<selectedLocations.length;i++) {
        // 		//         selectedLocations[i].setIsExpanded( false );
        // 		//         console.log(selectedLocations[i].data.name,": expanded?:",selectedLocations[i].isExpanded, this.selectedLocation[i].isExpanded);
        // 		//     }
        // 		// }, 500);
        // 		setTimeout(() => {
        // 			for (var i = 0; i < this.selectedLocation.length; i++) {
        // 				try {
        // 					const nodeF = this.treeComponent.treeModel.getNodeById(
        // 						this.selectedLocation[i].data.id
        // 					);
        //           nodeF.data['selected'] = true;
        // 					this.selectedLocation[i] = nodeF;
        // 				} catch (e) {
        // 					console.log(
        // 						"location id not available",
        // 						this.selectedLocation[i]
        // 					);
        // 				}
        // 				if (!this.selectedLocation[i]) {
        // 					this.selectedLocation.splice(i, 1);
        // 				}
        // 			}
        // 			for (var i = 0; i < this.selectedLocation.length; i++) {
        // 				try {
        // 					this.selectedLocation[i].setIsExpanded(true);
        // 				} catch (e) {
        // 					console.log("location id not available");
        // 				}
        // 			}
        // 		}, 10000);
        // 	}
        // }
        this.preselectLocations = (selectedLocations) => {
            this.selectedLocation = [];
            if (selectedLocations && selectedLocations.length) {
                selectedLocations.map((location) => {
                    let value = location.data.id;
                    if (value) {
                        if (this.treeComponent) {
                            this.treeComponent.treeModel.roots.forEach((root) => {
                                if (root.isCollapsed)
                                    root.expand();
                            });
                            const nodeF = this.treeComponent.treeModel.getNodeById(value);
                            if (nodeF && nodeF.data) {
                                // nodeF.focus();
                                // this.treeComponent.treeModel.setActiveNode(nodeF, true);
                                // nodeF.data['selected'] = true;
                                this.selectedLocation.push(nodeF);
                                this.prepareSelectedLocationDeps();
                            }
                            else {
                                const nodeSCopy = this.getLocationRowMapByKey(value);
                                let nodeS = Object.assign({}, nodeSCopy);
                                if (nodeS) {
                                    let lastAvailableParent = nodeS["parentId"];
                                    let selectedLocationPath = nodeS["locationPath"] && nodeS["locationPath"].length
                                        ? nodeS["locationPath"]
                                        : [];
                                    for (let j = selectedLocationPath.length - 1; j >= 0; j--) {
                                        lastAvailableParent = selectedLocationPath[j];
                                        if (this.treeComponent.treeModel.getNodeById(lastAvailableParent)) {
                                            break;
                                        }
                                    }
                                    console.log("lastAvailableParent::", lastAvailableParent);
                                    if (lastAvailableParent) {
                                        // const nodeP: TreeNode = this.treeComponent.treeModel.getNodeById(lastAvailableParent);
                                        // nodeP.expand();
                                        if (nodeS["locationPath"]) {
                                            nodeS["locationPath"].map((parentId, i) => {
                                                if (i >= 0) {
                                                    setTimeout(() => {
                                                        let nodeE = this.treeComponent.treeModel.getNodeById(parentId);
                                                        // if(nodeS['locationPath'].length - 1 === i) {
                                                        //   this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                        // } else {
                                                        if (nodeE)
                                                            nodeE.expand();
                                                        if (nodeS["locationPath"].length - 1 === i) {
                                                            setTimeout(() => {
                                                                // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                                const searchedNode = this.treeComponent.treeModel.getNodeById(nodeS["id"]);
                                                                // searchedNode.setIsActive(true, true);
                                                                // searchedNode.data['selected'] = true;
                                                                this.selectedLocation.push(searchedNode);
                                                                this.prepareSelectedLocationDeps();
                                                            });
                                                        }
                                                    }, 100);
                                                    // }
                                                }
                                                else {
                                                    let nodeE = this.treeComponent.treeModel.getNodeById(parentId);
                                                    // if(nodeS['locationPath'].length - 1 === i) {
                                                    //   this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                    // } else {
                                                    if (nodeE)
                                                        nodeE.expand();
                                                    if (nodeS["locationPath"].length - 1 === i) {
                                                        setTimeout(() => {
                                                            // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                            const searchedNode = this.treeComponent.treeModel.getNodeById(nodeS["id"]);
                                                            // searchedNode.setIsActive(true, true);
                                                            // searchedNode.data['selected'] = true;
                                                            this.selectedLocation.push(searchedNode);
                                                            this.prepareSelectedLocationDeps();
                                                        });
                                                    }
                                                    // }
                                                }
                                            });
                                            // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        console.log("Invalid location for preselection");
                    }
                });
            }
            else {
                this.selectedLocationIds = [];
                this.selectedParentLocations = [];
            }
            setTimeout(() => {
                this.treeLoading = false;
            }, 100);
        };
        this.lhTreeData = () => {
            if (this.treeComponent) {
                // this.options.useVirtualScroll = false;
                setTimeout(() => {
                    // this.options.useVirtualScroll = true;
                    this.treeComponent.sizeChanged();
                }, 100);
                let rootLocationId = this.dataService.getFromStorage("rootLocationId");
                if (rootLocationId) {
                    this.dataService.display(true);
                    let t1 = new Date().getTime();
                    console.log("Initial Data Loading Started::", t1);
                    let rootData = {};
                    rootData = this.getLocationRowMapByKey(rootLocationId);
                    if (rootData && rootData["children"]) {
                        rootData["children"] = null;
                    }
                    if (rootData["selected"]) {
                        delete rootData["selected"];
                    }
                    rootData["showLocation"] = true;
                    this.nodes = [Object.assign({}, rootData)];
                    setTimeout(() => {
                        if (this.treeComponent) {
                            this.treeComponent.treeModel.update();
                            let t2 = new Date().getTime();
                            let timeDiff = (t2 - t1) / 1000;
                            console.log("Initial Tree UI Loaded::", t2, timeDiff + " seconds");
                            // this.dataService.display(false);
                            if (this.treeConf.restrictedLocationId) {
                                const restrictedLocation = this.getLocationRowMapByKey(this.treeConf.restrictedLocationId);
                                if (restrictedLocation) {
                                    restrictedLocation['showLocation'] = true;
                                    this.nodes[0]['children'] = [restrictedLocation];
                                    this.nodes[0]['childData'] = [restrictedLocation];
                                    this.nodes[0]['hasChildren'] = true;
                                }
                                else {
                                    // restrictedLocation unavailable
                                }
                                this.prepareTree();
                            }
                            else if (rootData &&
                                (rootData["hasChildren"] ||
                                    (rootData["childData"] && rootData["childData"].length))) {
                                let children = [];
                                const childData = this.getSortedNames(rootData["childData"]);
                                childData.map((locObj, i) => {
                                    let childLoc = this.getLocationRowMapByKey(locObj.id);
                                    if (childLoc["selected"]) {
                                        delete childLoc["selected"];
                                    }
                                    if (this.showAllLocationsSwitch &&
                                        this.treeConf.restrictedLocations &&
                                        this.treeConf.restrictedLocations.length) {
                                        this.prepareShowLocation(childLoc).then((child) => {
                                            childLoc = child;
                                            children.push(childLoc);
                                            if (i + 1 === rootData["childData"].length) {
                                                this.prepareRootChildren(children, rootLocationId);
                                                this.prepareTree();
                                                // this.dataService.display(false);
                                            }
                                        });
                                    }
                                    else {
                                        children.push(childLoc);
                                        if (i + 1 === rootData["childData"].length) {
                                            this.prepareRootChildren(children, rootLocationId);
                                            this.prepareTree();
                                            // this.dataService.display(false);
                                        }
                                    }
                                });
                            }
                            else {
                                this.prepareTree();
                                // this.dataService.display(false);
                            }
                        }
                    }, 100);
                }
                else {
                    // this.dataService.setToastMessage("Location Hierarchy is unable to load. Root location unavailable.",
                    //       5000, null, null, 'error');
                }
            }
        };
        this.resetTree = () => {
            try {
                setTimeout(() => {
                    let rootLocationId = this.dataService.getFromStorage("rootLocationId");
                    if (rootLocationId) {
                        this.dataService.display(true);
                        let t1 = new Date().getTime();
                        console.log("Initial Data Loading Started::", t1);
                        let rootData = this.getLocationRowMapByKey(rootLocationId);
                        if (rootData && rootData !== undefined) {
                            this.nodes = [rootData];
                            setTimeout(() => {
                                if (this.treeComponent && this.treeComponent.treeModel) {
                                    this.treeComponent.treeModel.update();
                                    let t2 = new Date().getTime();
                                    let timeDiff = (t2 - t1) / 1000;
                                    console.log("Initial Tree UI Loaded::", t2, timeDiff + " seconds");
                                    this.dataService.display(false);
                                    if (rootData &&
                                        (rootData["hasChildren"] ||
                                            (rootData["childData"] && rootData["childData"].length))) {
                                        let children = [];
                                        const childData = this.getSortedNames(rootData["childData"]);
                                        childData.map((locObj, i) => {
                                            let childLoc = this.getLocationRowMapByKey(locObj.id);
                                            children.push(childLoc);
                                            if (i + 1 === rootData["childData"].length) {
                                                this.prepareRootChildren(children, rootLocationId);
                                                this.prepareTree();
                                                this.dataService.display(false);
                                            }
                                        });
                                    }
                                    else {
                                        this.prepareTree();
                                        this.dataService.display(false);
                                    }
                                }
                            });
                        }
                        else {
                            this.nodes = [{}];
                        }
                    }
                    else {
                        this.nodes = [{}];
                        // this.dataService.setToastMessage("Location Hierarchy is unable to load. Root location unavailable.",
                        //       5000, null, null, 'error');
                    }
                }, 200);
            }
            catch (e) {
                this.nodes = [{}];
                console.log("Tree update failed", e);
            }
        };
        this.prepareTree = () => {
            setTimeout(() => {
                let t3 = new Date().getTime();
                console.log("Initial tree preparation started::", t3);
                // try {
                if (this.treeComponent) {
                    this.treeComponent.treeModel.roots.forEach((root) => {
                        root.expand();
                    });
                    const treeModel = this.treeComponent.treeModel;
                    const firstNode = treeModel.getFirstRoot();
                    if (!this.popupOpened) {
                        this.activeNode.emit(firstNode);
                    }
                    this.treeComponent.treeModel.roots.forEach((root) => {
                        if (root.isCollapsed)
                            root.expand();
                    });
                    if (this.popupOpened ||
                        (this.treeConf.selectedLocation &&
                            this.treeConf.selectedLocation.length !== 0)) {
                        //doNothing
                    }
                    else {
                        firstNode.setActiveAndVisible();
                    }
                    // this.activeNode = firstNode;
                }
                let t4 = new Date().getTime();
                let timeDiff = (t4 - t3) / 1000;
                console.log("Initial tree prepared with 1st level nodes expanded::", t4, timeDiff + " seconds");
                this.treeComponent.treeModel.update();
                this.dataService.display(false);
                setTimeout(() => {
                    this.locationInitialLoaded.emit(true);
                    if (this.selectedLocation && this.selectedLocation.length) {
                        if (this.treeComponent && this.treeComponent.treeModel) {
                            this.preselectLocations(this.selectedLocation);
                        }
                    }
                    else {
                        this.treeLoading = false;
                    }
                }, 500);
                // } catch(e) {
                //   console.log('Error Initializing Tree::');
                // }
            }, 800);
        };
        this.selectNode = (node) => {
            // this.activeNode = node;
            if (node.hasChildren) {
            }
            else {
                let parentId = node.data.id;
                if (parentId) {
                    this.fetchChildren(node);
                }
            }
            console.log(node);
        };
        this.prepareChildren = (partialData, isLastIndex, t7) => {
            const id = partialData.parentId;
            let nodeF = this.treeComponent.treeModel.getNodeById(id);
            nodeF.data.children = partialData.children;
            if (isLastIndex) {
                let t8 = new Date().getTime();
                let timeDiff = (t8 - t7) / 1000;
                this.treeComponent.treeModel.update();
                console.log("Partial Data Tree Finished::", t8, timeDiff + " seconds");
            }
        };
        this.prepareRootChildren = (childrenData, rootId) => {
            if (this.treeComponent && this.treeComponent.treeModel) {
                let nodeF = this.treeComponent.treeModel.getNodeById(rootId);
                if (nodeF && nodeF.data) {
                    nodeF.data.children = childrenData;
                }
            }
            // if(isLastIndex) {
            //   let t8 = new Date().getTime();
            //   let timeDiff = (t8-t7)/1000;
            //   this.treeComponent.treeModel.update();
            //   console.log('Partial Data Tree Finished::', t8, timeDiff + ' seconds');
            // }
        };
        this.getNodeExpanded = (node) => {
            return node.isExpanded && node.data.childCount;
        };
        this.fetchChildren = (node) => {
            let id = node.data.id;
            this.dataService.getLocationPartialRow(id).then((childData) => {
                let children = [];
                const sortedChildData = this.getSortedNames(childData);
                sortedChildData.forEach((child, id) => {
                    children.push(child);
                });
                this.prepareRootChildren(children, id);
                this.treeComponent.treeModel.update();
                setTimeout(() => {
                    node.expand();
                });
            });
        };
        this.expandNode = (node) => {
            let nodeId = node.data.id;
            // if((!node.data.children || node.data.children.length === 0) && node.data.childCount) {
            this.dataService.getLocationPartialRow(nodeId).then((childData) => {
                let children = [];
                const sortedChildData = this.getSortedNames(childData);
                sortedChildData.forEach((child, id) => {
                    children.push(child);
                });
                let nodeF = this.treeComponent.treeModel.getNodeById(nodeId);
                nodeF.data.children = children;
                node.expand();
                this.treeComponent.treeModel.update();
            });
            // }
        };
        this.collapseNode = (node) => {
            node.collapse();
        };
        this.onSelectedNode = (node) => {
            console.log("Active Node", node);
            if (this.treeConf.type === "checkbox" ||
                this.treeConf.type === "radio" ||
                this.treeConf.type === "noselect") {
                // do nothing
            }
            else {
                // for types tick and plain select -> do single selection
                if (node &&
                    node.node &&
                    node.node.data &&
                    node.node.data["licenseType"] &&
                    this.requiredLicenses.indexOf(node.node.data["licenseType"].toLowerCase()) > -1) {
                    this.selectSingleNode(node.node);
                }
            }
            // this.activeNode.emit(node);
        };
        this.hoverOnFunc = (e) => {
            this.onhover.emit(e);
            // console.log(event);
            // console.log(l);
        };
        this.hoverOutFunc = (e) => {
            this.onout.emit(e);
            // console.log(event);
        };
        this.getProperties = () => {
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.propUnsubscribe$)
                .then((properties) => {
                this.localProperty = properties["value"];
                if (this.localProperty &&
                    (this.localProperty["useVirtualScroll"] !== null ||
                        this.localProperty["useVirtualScroll"] !== undefined)) {
                    this.options.useVirtualScroll =
                        this.localProperty["useVirtualScroll"];
                }
            });
        };
        // case insensitive sorting of child data based on location names
        this.getSortedNames = (childData) => {
            const sortedChildData = childData.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
            return sortedChildData;
        };
        this.enableCheck = (node) => {
            return true;
            /*
            let enableCheck = false;
            if (
                this.permittedLocationTypes !== undefined &&
                this.permittedLocationTypes !== null &&
                this.permittedLocationTypes.length > 0
            ) {
                // check group or org
                if (this.permittedLocationTypes.indexOf(node.data.type) > -1) {
                    if (
                        node.data.type === "organization" ||
                        node.data.type === "meraki" ||
                        node.data.type === "mse"
                    ) {
                        enableCheck = true;
                    } else if (
                        node.data.type === "group"
                    ) {
                        enableCheck = true;
                    } else if (
                        node.data.type !== "organization" &&
                        node.data.type !== "group"
                    ) {
                        enableCheck = true;
                    }
                    // we need to add the richmap flag check
                } else {
                    enableCheck = false;
                }
            } else {
                enableCheck = true;
            }
        
            // rich map check
            if (this.isRichMapAvailable) {
                // need to add the check
                // console.log(' ::: enableCheck method ::: node.data.richMapStatus ::: '+node.data.richMapStatus);
                if (enableCheck) {
                    if (node.data.richMapStatus) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                // no need for rich map check
                return enableCheck;
            }
        */
        };
        this.removeSelectedChildren = (locSelectedNode) => {
            let selectedNode = Object.assign({}, locSelectedNode);
            if (selectedNode && selectedNode.data.locationPath.length > 0) {
                const index = [];
                this.selectedLocation.map((n, i) => {
                    let selectedLoc = { data: {} };
                    if (n.data) {
                        if (n.data.locationPath) {
                            selectedLoc = n;
                        }
                        else {
                            selectedLoc.data = this.getLocationRowMapByKey(n.data.id);
                        }
                        const selectedLocParentPath = selectedLoc.data.locationPath.slice(0, selectedLoc.data.locationPath.length - 1);
                        if (selectedLocParentPath.indexOf(selectedNode.data.id) > -1) {
                            index.push(i);
                        }
                    }
                });
                if (index !== null && index.length) {
                    for (let j = index.length - 1; j >= 0; j--) {
                        this.selectedLocation.splice(index[j], 1);
                    }
                }
            }
        };
        this.removeSelectedParent = (locSelectedNode) => {
            let selectedNode = Object.assign({}, locSelectedNode);
            if (selectedNode && selectedNode.data.locationPath.length > 0) {
                const index = [];
                this.selectedLocation.map((n, i) => {
                    let selectedLoc = { data: {} };
                    if (n.data) {
                        if (n.data.locationPath) {
                            selectedLoc = n;
                        }
                        else {
                            selectedLoc.data = this.getLocationRowMapByKey(n.data.id);
                        }
                        const parentPath = selectedLoc.data.locationPath.slice(0, selectedLoc.data.locationPath.length - 1);
                        if (parentPath.indexOf(n.data.id) > -1) {
                            index.push(i);
                        }
                    }
                });
                if (index !== null) {
                    for (let j = index.length - 1; j >= 0; j--) {
                        this.selectedLocation.splice(index[j], 1);
                    }
                }
            }
        };
        this.selectSingleNode = (node) => {
            const currentNav = this.dataService.getCurrentNav();
            if ((currentNav &&
                currentNav.indexOf("right-now") !== -1 &&
                (node.data.type === "zone" ||
                    node.data.type === "cmxzone" ||
                    node.data.type === "polygon_zone")) ||
                (currentNav &&
                    currentNav.indexOf("camera-metrics") !== -1 &&
                    node.data.camerasCount === 0)) {
                return;
            }
            this.doSelection(node);
            if (!this.popupOpened)
                this.selectedLocationEvt.emit(this.selectedLocation);
        };
        this.onSelectedLocationEvent = ($event) => {
            console.log("selected location ", $event);
        };
        this.unselectNode = () => {
            this.selectedLocation = [];
            //console.log( "unselect node:: manage location:after:", this.selectedLocation );
        };
        this.doSelection = (node) => {
            //console.log( "Select node:: manage location:", this.selectedLocation, node );
            let canSelectNode = false;
            if (this.treeConf.permittedLocationTypes &&
                this.treeConf.permittedLocationTypes.length) {
                if (node && node.data && node.data.type && node.data.type[0]) {
                    if (this.treeConf.permittedLocationTypes.indexOf(node.data.type[0].toLowerCase()) > -1) {
                        canSelectNode = true;
                    }
                    else {
                        canSelectNode = false;
                    }
                }
            }
            if (!canSelectNode)
                return;
            if (this.selectedLocation !== undefined &&
                this.selectedLocation.length > 0 &&
                this.selectedLocation[0].data !== undefined) {
                const nodeF = this.treeComponent.treeModel.getNodeById(this.selectedLocation[0].data.id);
            }
            if (this.selectedLocation !== undefined &&
                this.selectedLocation.length > 0 &&
                this.selectedLocation[0].data !== undefined &&
                this.selectedLocation[0].data.id === node.data.id) {
                this.selectedLocation = [];
                node.setIsExpanded(true);
            }
            else {
                if (node && node[0] && node[0].id == undefined) {
                    this.selectedLocation = node[0];
                    node.setIsExpanded(true);
                }
                else {
                    this.selectedLocation = [node];
                    node.setIsExpanded(true);
                }
            }
        };
        this.isChildNodeSelectedClass = (node) => {
            let classString = "checkboxLabel";
            const index = null;
            let parentPath;
            const parentPathArray = [];
            if (this.selectedLocation) {
                this.selectedLocation.filter(function (n, i) {
                    if (n.data && n.data.locationPath) {
                        parentPath = n.data.locationPath.slice(0, n.data.locationPath.length - 1);
                        // pushing path to new array
                        parentPath.forEach((element) => {
                            parentPathArray.push(element);
                        });
                    }
                });
            }
            // remove duplicates
            const uniqueParentPaths = this.removeDuplicates(parentPathArray);
            // check the unique parent paths with node
            if (uniqueParentPaths && uniqueParentPaths.indexOf(node.data.id) > -1) {
                classString += " childSelected";
                return classString;
            }
            else {
                return classString;
            }
        };
        // remove duplicates from array
        this.removeDuplicates = (arr) => {
            const unique_array = [];
            for (let i = 0; i < arr.length; i++) {
                if (unique_array.indexOf(arr[i]) == -1) {
                    unique_array.push(arr[i]);
                }
            }
            return unique_array;
        };
        this.getStaticText = () => {
            this.translate
                .get("business-hierarchy-lib.hierarchy-base.error-ocurred-switching-ui-msg")
                .subscribe((res) => {
                this.messageKeys["error-ocurred-switching-ui-msg"] = res;
            });
            this.translate
                .get("business-hierarchy-lib.hierarchy-base.search-text")
                .subscribe((res) => {
                this.messageKeys["search-text"] = res;
            });
            this.translate
                .get("business-hierarchy-lib.hierarchy-base.enter-return-search-text")
                .subscribe((res) => {
                this.messageKeys["enter-return-search-text"] = res;
            });
            this.translate
                .get("business-hierarchy-lib.hierarchy-base.no-matching-found-text")
                .subscribe((res) => {
                this.messageKeys["no-matching-found-text"] = res;
            });
            this.translate
                .get("business-hierarchy-lib.lh2-tree.location-permission-error")
                .subscribe((res) => {
                this.messageKeys["location-permission-error"] = res;
            });
        };
        this.inputChanged = () => {
            this.newInput = true;
        };
        this.onSearch = (event) => {
            this.searchResults = [];
            this.searchActive = true;
            this.showRecent = false;
            if (event.target.value && event.target.value.length > 2) {
                this.newInput = false;
                console.log("Search Result:: ");
                const results = this.dataService.getLocationRowArrayByKey("name", event.target.value);
                if (results && results.length) {
                    this.searchResults = results;
                }
            }
            else if (event.target.value.length === 0) {
                this.newInput = true;
                this.showRecent = true;
            }
        };
        this.showRecentSearch = () => {
            const searchInput = document.getElementById("search-input");
            searchInput["placeholder"] = this.messageKeys["enter-return-search-text"];
            if (searchInput["value"] && searchInput["value"].length) {
                this.searchActive = true;
                this.showRecent = false;
            }
            else {
                this.searchActive = true;
                this.showRecent = true;
            }
        };
        this.searchFocusOut = () => {
            setTimeout(() => {
                this.showRecent = false;
                const searchInput = document.getElementById("search-input");
                searchInput["placeholder"] = this.messageKeys["search-text"];
                if (searchInput["value"] && searchInput["value"].length) {
                }
                else {
                    this.searchActive = false;
                }
            }, 200);
        };
        this.getLocationPath = (item) => {
            const locPathIds = item.path;
            const locNameArr = [];
            let locNameStr = "";
            if (locPathIds && locPathIds.length) {
                locPathIds.map((id) => {
                    const loc = this.getLocationRowMapByKey(id);
                    if (loc) {
                        locNameArr.push(loc["name"]);
                    }
                });
            }
            locNameStr = locNameArr.length ? locNameArr.join(" > ") : "";
            return locNameStr;
        };
        this.goToLocation = (item) => {
            // logic to go to the location
            this.updateRecentSearchItem(item);
            this.searchedLocation = null;
            this.hideTree = true;
            this.searchActive = false;
            this.showRecent = false;
            this.hideTree = false;
            setTimeout(() => {
                this.searchedLocation = item.id;
                this.searchLocation(this.searchedLocation);
            }, 300);
        };
        this.getHighlightedName = (name) => {
            // name.substring()
            let searchInput = document.getElementById("search-input")["value"];
            searchInput = searchInput.toLowerCase();
            const highlight = name.toLowerCase();
            if (searchInput) {
                const index = highlight.indexOf(searchInput);
                let hightlightHTML = "";
                if (index > -1) {
                    hightlightHTML =
                        name.substring(0, index) +
                            "<span class='search-highlight'>" +
                            name.substring(index, index + searchInput.length) +
                            "</span>" +
                            name.substring(index + searchInput.length);
                    return hightlightHTML;
                }
                else {
                    return name;
                }
            }
        };
        this.getRecentSearchItems = () => { };
        this.updateRecentSearchItem = (item) => { };
        this.fourCharTyped = () => {
            const searchInput = document.getElementById("search-input");
            if (searchInput["value"] &&
                searchInput["value"].length &&
                searchInput["value"].length > 3) {
                return true;
            }
            else {
                return false;
            }
        };
        this.clearInput = () => {
            const searchInput = document.getElementById("search-input");
            searchInput["value"] = "";
            this.searchFocusOut();
        };
        this.getAppData = (id) => {
            return this.treeConf.appData[id] ? this.treeConf.appData[id] : "";
        };
        this.toggleAllLocations = () => {
            this.showAllLocations = !this.showAllLocations;
        };
        this.prepareSelectedLocations = (value) => {
            if (value) {
                if (this.treeComponent) {
                    this.treeComponent.treeModel.roots.forEach((root) => {
                        if (root.isCollapsed)
                            root.expand();
                    });
                    const nodeF = this.treeComponent.treeModel.getNodeById(value);
                    if (nodeF && nodeF.data) {
                        // nodeF.focus();
                        this.treeComponent.treeModel.setActiveNode(nodeF, true);
                    }
                    else {
                        let nodeS = this.getLocationRowMapByKey(value);
                        if (nodeS) {
                            let lastAvailableParent = nodeS["parentId"];
                            while (!this.treeComponent.treeModel.getNodeById(lastAvailableParent)) {
                                lastAvailableParent =
                                    this.getLocationRowMapByKey(lastAvailableParent)["parentId"];
                            }
                            console.log("lastAvailableParent::", lastAvailableParent);
                            if (lastAvailableParent) {
                                // const nodeP: TreeNode = this.treeComponent.treeModel.getNodeById(lastAvailableParent);
                                // nodeP.expand();
                                if (nodeS["locationPath"]) {
                                    nodeS["locationPath"].map((parentId, i) => {
                                        if (i >= 0) {
                                            setTimeout(() => {
                                                let nodeE = this.treeComponent.treeModel.getNodeById(parentId);
                                                // if(nodeS['locationPath'].length - 1 === i) {
                                                //   this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                // } else {
                                                nodeE.expand();
                                                if (nodeS["locationPath"].length - 1 === i) {
                                                    setTimeout(() => {
                                                        // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                        const searchedNode = this.treeComponent.treeModel.getNodeById(nodeS["id"]);
                                                        searchedNode.setIsActive(true, true);
                                                    });
                                                }
                                            }, 100);
                                            // }
                                        }
                                        else {
                                            let nodeE = this.treeComponent.treeModel.getNodeById(parentId);
                                            // if(nodeS['locationPath'].length - 1 === i) {
                                            //   this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                            // } else {
                                            nodeE.expand();
                                            if (nodeS["locationPath"].length - 1 === i) {
                                                setTimeout(() => {
                                                    // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                    const searchedNode = this.treeComponent.treeModel.getNodeById(nodeS["id"]);
                                                    searchedNode.setIsActive(true, true);
                                                });
                                            }
                                            // }
                                        }
                                    });
                                    // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                }
                            }
                        }
                    }
                }
            }
        };
        this.canShowLocation = (node) => {
            if (this.treeLoading) {
                return true;
            }
            if (this.showAllLocations) {
                return true;
            }
            if (!this.showAllLocationsSwitch)
                return true;
            if (node.data.showLocation) {
                return true;
            }
            return false;
        };
        //   canShowLocation = (node) => {
        //     // if(this.treeLoading) {
        //     //   return true;
        //     // }
        //     // if(this.showAllLocations) {
        //     //   return true;
        //     // }
        //     // if(!this.showAllLocationsSwitch)
        //     //   return true;
        //     if (
        //       node &&
        //       node.data &&
        //       node.data.licenses &&
        //       node.data.licenses.length &&
        //       this.treeLicenses &&
        //       this.treeLicenses.length
        //     ) {
        //       let allowed = false;
        //       this.treeLicenses.map((lic) => {
        //         if (node.data.licenses.indexOf(lic) > -1) {
        //           allowed = true;
        //         }
        //       });
        //       return allowed;
        //     } else {
        //       return true;
        //     }
        //   };
        this.getLicenseShortKey = (license) => {
            license = license.toLowerCase();
            let l = "";
            switch (license) {
                case "see":
                    l = "s";
                    break;
                case "extend":
                    l = "e";
                    break;
                case "smart_venues":
                    l = "v";
                    break;
                case "smart_ops":
                    l = "o";
                    break;
                case "smart_operations":
                    l = "o";
                    break;
                case "act":
                    l = "a";
                    break;
                case "unlimited":
                    l = "u";
                    break;
                default:
                    break;
            }
            return l;
        };
        this.checkActionAllowed = (node) => {
            if (this.treeLoading) {
                return false;
            }
            // if(this.showAllLocationsSwitch)
            //   return true;
            if (!node
                || !node.data)
                return false;
            if (!this.requiredLicenses
                || this.requiredLicenses.length === 0)
                return true;
            if (node.data["licenseType"] &&
                this.requiredLicenses.length &&
                this.requiredLicenses.indexOf(node.data["licenseType"].toLowerCase()) > -1) {
                if (this.treeConf.permittedLocationTypes &&
                    this.treeConf.permittedLocationTypes.length) {
                    if (node.data.type && node.data.type[0]) {
                        if (this.treeConf.permittedLocationTypes.indexOf(node.data.type[0].toLowerCase()) > -1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                }
                else if (this.treeConf.restrictedLocations &&
                    this.treeConf.restrictedLocations.length) {
                    if (this.treeConf.restrictedLocations.indexOf(node.data.id) > -1) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        };
        //   checkActionAllowed = (node: any) => {
        //     // if(this.treeLoading) {
        //     //   return true;
        //     // }
        //     // if(!this.showAllLocationsSwitch)
        //     //   return true;
        //     if (
        //       node &&
        //       node.data &&
        //       node.data["licenseType"] &&
        //       this.requiredLicenses.indexOf(node.data["licenseType"].toLowerCase()) > -1
        //     ) {
        //       return true;
        //     } else {
        //       return false;
        //     }
        //   };
        this.isLocationSelected = (node) => {
            if (this.selectedLocationIds.indexOf(node.data.id) > -1)
                return true;
            else
                return false;
        };
        this.prepareSelectedParentLocations = () => {
            this.selectedParentLocations = [];
            this.selectedLocation.map((loc, i) => {
                if (loc.data.locationPath && loc.data.locationPath.length) {
                    for (let j = 0; j < loc.data.locationPath.length - 1; j++) {
                        this.selectedParentLocations.push(loc.data.locationPath[j]);
                    }
                }
            });
        };
        this.prepareSelectedLocationDeps = () => {
            this.selectedLocationIds = [];
            this.selectedLocation.map((loc) => {
                if (loc.data.id) {
                    this.selectedLocationIds.push(loc.data.id);
                }
            });
            this.prepareSelectedParentLocations();
        };
        this.isParentOfSelectedLocation = (node) => {
            if (this.selectedParentLocations.indexOf(node.data.id) > -1)
                return true;
            else
                return false;
        };
        this.getLocationRowMapByKey = (key) => {
            return this.locationRowMap.get(key);
        };
    }
    ngOnDestroy() {
        console.log("destory manageLocations page");
        this.treeComponent = null;
        this.destroyed$.next(true);
        this.lh2Service.destroy();
    }
    set setSearchedLocation(value) {
        if (value) {
            if (this.treeComponent) {
                this.treeComponent.treeModel.roots.forEach((root) => {
                    if (root.isCollapsed)
                        root.expand();
                });
                const nodeF = this.treeComponent.treeModel.getNodeById(value);
                if (nodeF && nodeF.data) {
                    // nodeF.focus();
                    this.treeComponent.treeModel.setActiveNode(nodeF, true);
                }
                else {
                    let nodeS = this.getLocationRowMapByKey(value);
                    if (nodeS) {
                        let lastAvailableParent = nodeS["parentId"];
                        while (!this.treeComponent.treeModel.getNodeById(lastAvailableParent)) {
                            lastAvailableParent =
                                this.getLocationRowMapByKey(lastAvailableParent)["parentId"];
                        }
                        console.log("lastAvailableParent::", lastAvailableParent);
                        if (lastAvailableParent) {
                            // const nodeP: TreeNode = this.treeComponent.treeModel.getNodeById(lastAvailableParent);
                            // nodeP.expand();
                            if (nodeS["locationPath"]) {
                                nodeS["locationPath"].map((parentId, i) => {
                                    if (i >= 0) {
                                        setTimeout(() => {
                                            let nodeE = this.treeComponent.treeModel.getNodeById(parentId);
                                            // if(nodeS['locationPath'].length - 1 === i) {
                                            //   this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                            // } else {
                                            nodeE.expand();
                                            if (nodeS["locationPath"].length - 1 === i) {
                                                setTimeout(() => {
                                                    // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                    const searchedNode = this.treeComponent.treeModel.getNodeById(nodeS["id"]);
                                                    searchedNode.setIsActive(true, true);
                                                });
                                            }
                                        }, 100);
                                        // }
                                    }
                                    else {
                                        let nodeE = this.treeComponent.treeModel.getNodeById(parentId);
                                        // if(nodeS['locationPath'].length - 1 === i) {
                                        //   this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                        // } else {
                                        nodeE.expand();
                                        if (nodeS["locationPath"].length - 1 === i) {
                                            setTimeout(() => {
                                                // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                const searchedNode = this.treeComponent.treeModel.getNodeById(nodeS["id"]);
                                                searchedNode.setIsActive(true, true);
                                            });
                                        }
                                        // }
                                    }
                                });
                                // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                            }
                        }
                    }
                }
            }
        }
    }
    set setWlcLocationData(value) {
        if (value) {
            this.wlcLocationData = value;
        }
    }
    set setTreeConf(conf) {
        this.treeConf = Object.assign({}, conf);
        this.treeConf.type = conf.type ? conf.type : "plain";
        // this.treeConf.popupOpened = conf.popupOpened;
        switch (this.treeConf.type) {
            case "checkbox":
                this.multiLocationSelect = true;
                break;
            case "radio":
                this.multiLocationSelect = false;
                break;
            case "tick":
                this.tickSelect = true;
                break;
            case "plain":
                this.plainSelect = true;
                break;
            case "noselect":
                this.noSelect = true;
                break;
            default:
                this.plainSelect = true;
                break;
        }
        this.appName = this.treeConf.appName ? this.treeConf.appName : "";
        this.selectedLocation = [];
        let selectedLoc = this.treeConf.selectedLocation && this.treeConf.selectedLocation.length
            ? this.treeConf.selectedLocation
            : [];
        setTimeout(() => {
            this.selectedLocation = [];
            if (selectedLoc.length) {
                selectedLoc.map((loc) => {
                    if (!this.treeConf.isDataId) {
                        this.selectedLocation.push({
                            data: loc
                        });
                    }
                    else {
                        this.selectedLocation.push(loc);
                    }
                });
            }
            const locationMapKey = this.dataService.getTenantId() + this.dataService.getUserName();
            if (this.locationRowMap
                && this.locationRowMap.size) {
                this.preselectLocations(this.selectedLocation);
            }
            else {
                this.dataService.getLocationIndexedMap(locationMapKey).then((locationMap) => {
                    if (locationMap
                        && locationMap['data']
                        && locationMap['data'].size) {
                        this.locationRowMap = locationMap['data'];
                        this.preselectLocations(this.selectedLocation);
                    }
                });
            }
        });
        const requiredLicenses = this.treeConf.requiredLicenses
            ? this.treeConf.requiredLicenses
            : ["see"];
        this.requiredLicenses = [];
        requiredLicenses.map((license) => {
            this.requiredLicenses.push(license.toLowerCase());
        });
        this.treeLicenses = [];
        this.requiredLicenses.map((license) => {
            this.treeLicenses.push(this.getLicenseShortKey(license));
        });
        this.enableSearch = this.treeConf.enableSearch
            ? this.treeConf.enableSearch
            : false;
        this.isPopup = this.treeConf.isPopup ? this.treeConf.isPopup : false;
        this.isReportsLocation = this.treeConf.isReportsLocation
            ? this.treeConf.isReportsLocation
            : false;
        this.permittedLocationTypes = this.treeConf.permittedLocationTypes
            ? this.treeConf.permittedLocationTypes
            : [];
        this.treeConf.isDataId = this.treeConf.isDataId
            ? this.treeConf.isDataId
            : false;
        this.treeConf.restrictedLocations =
            this.treeConf.restrictedLocations &&
                this.treeConf.restrictedLocations.length
                ? this.treeConf.restrictedLocations
                : [];
        if (this.treeConf.restrictedLocations &&
            this.treeConf.restrictedLocations.length) {
            this.showAllLocationsSwitch = true;
            this.showAllLocations = false;
        }
        else {
            this.showAllLocationsSwitch = false;
            this.showAllLocations = true;
        }
        if (this.treeConf.appData && Object.keys(this.treeConf.appData).length) {
            this.hasAppData = true;
            this.treeConf.appData = this.treeConf.appData;
        }
        else {
            this.hasAppData = false;
            this.treeConf.appData = {};
        }
        if (this.treeConf.showPermissionError !== undefined && !this.treeConf.showPermissionError) {
            this.showPermissionError = false;
        }
    }
    set setSelectedLocation(selectedLocations) {
        this.preselectLocations(selectedLocations);
    }
    ngOnInit() {
        this.lh2Service.init();
        this.getProperties();
        this.dataService
            .getI18nLangChange(this.unsubscribe$)
            .subscribe((langChange) => {
            this.getStaticText();
        });
        this.treeLoading = true;
        const locationMapKey = this.dataService.getTenantId() + this.dataService.getUserName();
        if (this.locationRowMap
            && this.locationRowMap.size) {
            this.lhTreeData();
        }
        else {
            this.dataService.getLocationIndexedMap(locationMapKey).then((locationMap) => {
                if (locationMap
                    && locationMap['data']
                    && locationMap['data'].size) {
                    this.locationRowMap = locationMap['data'];
                    this.lhTreeData();
                }
            });
        }
        // this.dataService
        //   .getLocLoadingStarted(this.unsubscribe$)
        //   .subscribe((status) => {
        //     this.treeLoading = true;
        //   });
    }
    getChildren(node) {
        return new Promise((resolve, reject) => {
            let start = new Date().getTime();
            console.log("Node expansion started::", start);
            if (node.data &&
                node.data["childData"] &&
                node.data["childData"].length) {
                let children = [];
                const nodeChildData = this.getSortedNames(node.data["childData"]);
                nodeChildData.map((child, i) => {
                    let id = child.id;
                    let childData = this.getLocationRowMapByKey(id);
                    childData["children"] = null;
                    this.prepareShowLocation(childData).then(() => {
                        if (childData)
                            children.push(Object.assign({}, childData));
                        if (i + 1 === node.data["childData"].length) {
                            let end = new Date().getTime();
                            let timeDiff = (end - start) / 1000;
                            console.log("Node expansion finished::", timeDiff + " seconds");
                            setTimeout(() => {
                                this.treeComponent.sizeChanged();
                            }, 100);
                            resolve(children);
                        }
                    });
                });
            }
        });
    }
    selectMultipleNode($event, node) {
        //console.log(node);
        $event.preventDefault();
        let index = null;
        if (!this.selectedLocation)
            this.selectedLocation = [];
        this.selectedLocation.filter((n, i) => {
            if (n.data.id === node.data.id) {
                index = i;
                return i;
            }
            return;
        });
        if (index !== null) {
            //console.log("Removing::", this.selectedLocation);
            this.selectedLocation.splice(index, 1);
            node.setIsExpanded(true);
            this.prepareSelectedLocationDeps();
        }
        else {
            // Location doesn't exist already, action -> toggleOn: add to selectedLocations
            // Get list of children locations in existing selected locations-
            // -which have selected location in its location path
            let childrenObjIndex = [];
            let selectLocCopy = [...this.selectedLocation];
            selectLocCopy.map((n, i) => {
                if (n.data.locationPath && n.data.locationPath.length) {
                    if (n.data.locationPath.indexOf(node.id) > -1) {
                        childrenObjIndex.push(i);
                    }
                }
            });
            for (let j = childrenObjIndex.length - 1; j >= 0; j--) {
                selectLocCopy.splice(childrenObjIndex[j], 1);
            }
            // Remove any of the selected location's parent location from selectedlocationdata
            let parentIndex = -1;
            if (node.data.locationPath && node.data.locationPath.length) {
                for (let i = 0; i < node.data.locationPath.length - 1; i++) {
                    const pIndex = selectLocCopy.findIndex((n) => n.id === node.data.locationPath[i]);
                    if (pIndex > -1) {
                        parentIndex = pIndex;
                        break;
                    }
                }
            }
            if (parentIndex > -1) {
                selectLocCopy.splice(parentIndex, 1);
            }
            // add selected location to selectedlocationsdata object array
            selectLocCopy.push(node);
            this.selectedLocation = selectLocCopy;
            this.prepareSelectedLocationDeps();
            // //console.log("Selecting Location::", node);
            // this.selectedLocation.push(node);
            // node.data['selected'] = true;
            // let parentNode = node.parent;
            // while(parentNode) {
            //   parentNode.data['selected'] = false;
            //   parentNode = parentNode.parent;
            // }
            // let childrenNode = node.children;
            // if(childrenNode && childrenNode.length) {
            //   childrenNode.map((child) => {
            //     if(child.data.children) {
            //       child.data.children = null;
            //       child.setIsExpanded(false);
            //       setTimeout(() => {
            //         // this.options.useVirtualScroll = true;
            //         this.treeComponent.treeModel.update()
            //         this.treeComponent.sizeChanged();
            //       }, 100)
            //     }
            //     if(child.data
            //       && child.data['selected'])
            //       child.data['selected'] = false;
            //   })
            // }
            // node.setIsExpanded(true);
            // this.removeSelectedChildren(node);
            // this.removeSelectedParent(node);
            // this.isNodeSelected = true;
        }
        //console.log(this.selectedLocation);
        if (this.treeConf.isDataId) {
            this.selectedLocationEvt.emit(this.selectedLocation);
        }
        else {
            let selectedLocs = [];
            this.selectedLocation.map((loc) => {
                if (loc.data) {
                    selectedLocs.push(loc.data);
                }
            });
            this.selectedLocationEvt.emit(selectedLocs);
        }
    }
    searchLocation(value) {
        if (value) {
            if (this.treeComponent) {
                this.treeComponent.treeModel.roots.forEach((root) => {
                    if (root.isCollapsed)
                        root.expand();
                });
                const nodeF = this.treeComponent.treeModel.getNodeById(value);
                if (nodeF && nodeF.data) {
                    // nodeF.focus();
                    if (nodeF.data["locationPath"]) {
                        nodeF.data["locationPath"].map((parentId, i) => {
                            if (i >= 0) {
                                setTimeout(() => {
                                    let nodeP1 = this.treeComponent.treeModel.getNodeById(parentId);
                                    // if(nodeS['locationPath'].length - 1 === i) {
                                    //   this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                    // } else {
                                    nodeP1.expand();
                                    this.treeComponent.treeModel.setActiveNode(nodeF, true);
                                });
                            }
                        });
                    }
                    // setTimeout(() => {
                    //   this.treeComponent.treeModel.setActiveNode(nodeF, true);
                    // }, 100);
                }
                else {
                    let nodeS = this.getLocationRowMapByKey(value);
                    if (nodeS) {
                        let lastAvailableParent = nodeS["parentId"];
                        while (!this.treeComponent.treeModel.getNodeById(lastAvailableParent)) {
                            lastAvailableParent =
                                this.getLocationRowMapByKey(lastAvailableParent)["parentId"];
                        }
                        console.log("lastAvailableParent::", lastAvailableParent);
                        if (lastAvailableParent) {
                            // const nodeP: TreeNode = this.treeComponent.treeModel.getNodeById(lastAvailableParent);
                            // nodeP.expand();
                            if (nodeS["locationPath"]) {
                                nodeS["locationPath"].map((parentId, i) => {
                                    if (i >= 0) {
                                        setTimeout(() => {
                                            let nodeE = this.treeComponent.treeModel.getNodeById(parentId);
                                            // if(nodeS['locationPath'].length - 1 === i) {
                                            //   this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                            // } else {
                                            nodeE.expand();
                                            if (nodeS["locationPath"].length - 1 === i) {
                                                setTimeout(() => {
                                                    // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                    // const searchedNode: TreeNode = this.treeComponent.treeModel.getNodeById(nodeS['id']);
                                                    // searchedNode.setIsActive(true, true);
                                                });
                                            }
                                        }, 100);
                                        // }
                                    }
                                    else {
                                        let nodeE = this.treeComponent.treeModel.getNodeById(parentId);
                                        // if(nodeS['locationPath'].length - 1 === i) {
                                        //   this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                        // } else {
                                        nodeE.expand();
                                        if (nodeS["locationPath"].length - 1 === i) {
                                            setTimeout(() => {
                                                // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                                                // const searchedNode: TreeNode = this.treeComponent.treeModel.getNodeById(nodeS['id']);
                                                // searchedNode.setIsActive(true, true);
                                            });
                                        }
                                        // }
                                    }
                                });
                                // this.treeComponent.treeModel.setActiveNode(nodeS, true);
                            }
                        }
                    }
                }
            }
        }
    }
    prepareShowLocation(childLoc) {
        return new Promise((resolve) => {
            if (this.treeConf.restrictedLocationId) {
                if (childLoc['locationPath'].indexOf(this.treeConf.restrictedLocationId) > -1) {
                    childLoc["showLocation"] = true;
                }
                resolve(childLoc);
            }
            else if (!this.showAllLocationsSwitch ||
                !this.treeConf.restrictedLocations ||
                this.treeConf.restrictedLocations.length <= 0) {
                resolve(childLoc);
            }
            else if (this.showAllLocationsSwitch &&
                this.treeConf.restrictedLocations &&
                this.treeConf.restrictedLocations.length) {
                if (this.treeConf.restrictedLocations.indexOf(childLoc.id) > -1) {
                    childLoc["showLocation"] = true;
                    if (childLoc["parentId"]) {
                        let parent = this.treeComponent.treeModel.getNodeById(childLoc["parentId"]);
                        if (parent) {
                            parent.data["showLocation"] = true;
                        }
                        while (parent) {
                            parent = this.treeComponent.treeModel.getNodeById(parent.data["parentId"]);
                            if (parent) {
                                parent.data["showLocation"] = true;
                            }
                            else {
                                parent = null;
                            }
                        }
                    }
                }
                else {
                    childLoc["showLocation"] = false;
                }
                resolve(childLoc);
            }
            else {
                resolve(childLoc);
            }
        });
    }
}
ManageLh2TreeComponent.ɵfac = function ManageLh2TreeComponent_Factory(t) { return new (t || ManageLh2TreeComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(Lh2Service), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
ManageLh2TreeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ManageLh2TreeComponent, selectors: [["app-manage-lh2-tree"]], viewQuery: function ManageLh2TreeComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1j, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.treeComponent = _t.first);
    } }, inputs: { setSearchedLocation: "setSearchedLocation", setWlcLocationData: "setWlcLocationData", multiLocationSelect: "multiLocationSelect", permittedLocationTypes: "permittedLocationTypes", isReportsLocation: "isReportsLocation", isRichMapAvailable: "isRichMapAvailable", isPopup: "isPopup", popupOpened: "popupOpened", setTreeConf: "setTreeConf", setSelectedLocation: "setSelectedLocation" }, outputs: { activeNode: "activeNode", locationInitialLoaded: "locationInitialLoaded", onhover: "onhover", onout: "onout", selectedLocationEvt: "selectedLocationEvt" }, decls: 12, vars: 8, consts: [[1, "lhv2"], [1, "tree-wrapper"], ["class", "tree-search search-input", 4, "ngIf"], ["class", "tree-search-results search-box", 4, "ngIf"], [1, "lh2-tree", 3, "ngClass"], ["class", "all-location-switch", 4, "ngIf"], [3, "nodes", "options", "activate"], ["tree", ""], ["treeNodeFullTemplate", ""], ["treeNodeTemplate", ""], [1, "tree-search", "search-input"], ["type", "text", "id", "search-input", "autocomplete", "off", 3, "placeholder", "focus", "focusout", "keydown", "keydown.enter"], [1, "clear-input", 3, "click"], ["class", "back-link", 3, "click", 4, "ngIf"], [1, "back-link", 3, "click"], [1, "left-arrow"], [1, "tree-search-results", "search-box"], ["class", "search-count-min", 4, "ngIf"], ["class", "search-results", 4, "ngIf"], [1, "search-count-min"], [1, "search-results"], ["class", "search-count", 4, "ngIf"], ["class", "search-items-list", 4, "ngIf"], [1, "search-count"], [1, "search-items-list"], ["class", "search-item", 4, "ngFor", "ngForOf"], [1, "search-item"], [3, "click"], [1, "search-name", 3, "innerHTML"], [1, "search-path"], [1, "all-location-switch"], [1, "circularCheckbox", "displayInlineBlock", "verticalAlignMiddle"], ["type", "checkbox", "id", "all-location-checkbox", "name", "locationChecbox", 3, "checked", "click"], ["for", "all-location-checkbox", 1, "checkboxLabel"], [1, "displayInlineBlock"], [3, "ngClass", "node", "index", "templates"], [3, "node", "templates"], [1, "lh2-node-wrapper", 3, "ngClass"], ["class", "disabled-location-tooltip", 4, "ngIf"], [1, "lh2-loc-name", 3, "setNode", "setWlcLocationData", "onhover", "onout"], ["class", "app-data", 4, "ngIf"], ["class", "location-action", 4, "ngIf"], [1, "disabled-location-tooltip"], [1, "app-data"], [1, "location-action"], ["class", "locationPopupTick loc-selection-box", 4, "ngIf"], ["class", "locationPopupRadio loc-selection-box", 4, "ngIf"], ["class", "circularCheckbox loc-selection-box", 4, "ngIf"], [1, "locationPopupTick", "loc-selection-box"], ["type", "radio", "name", "locationRadio", 3, "checked", "id", "value", "click"], [1, "radioTickLabel", 3, "for"], [1, "locationPopupRadio", "loc-selection-box"], [1, "radioButtonLabel", 3, "for"], [1, "circularCheckbox", "loc-selection-box"], ["type", "checkbox", "name", "locationChecbox", 3, "id", "value", "click"], [1, "checkboxLabel", 3, "ngClass", "for"]], template: function ManageLh2TreeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, ManageLh2TreeComponent_div_2_Template, 6, 4, "div", 2);
        i0.ɵɵtemplate(3, ManageLh2TreeComponent_div_3_Template, 3, 2, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, ManageLh2TreeComponent_div_5_Template, 6, 1, "div", 5);
        i0.ɵɵelementStart(6, "tree-root", 6, 7);
        i0.ɵɵlistener("activate", function ManageLh2TreeComponent_Template_tree_root_activate_6_listener($event) { return ctx.onSelectedNode($event); });
        i0.ɵɵtemplate(8, ManageLh2TreeComponent_ng_template_8_Template, 3, 22, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(10, ManageLh2TreeComponent_ng_template_10_Template, 5, 8, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.enableSearch);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.enableSearch && ctx.searchActive);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c4$8, ctx.searchActive));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showAllLocationsSwitch);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("nodes", ctx.nodes)("options", ctx.options);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i4.TreeComponent, i1$2.NgForOf, i4.TreeNodeWrapperComponent, i4.TreeNodeChildrenComponent, BusinessHierarchyNodeComponent], pipes: [i2.TranslatePipe], styles: ["@charset \"UTF-8\";.lh2-loc-name[_ngcontent-%COMP%]{display:table-cell;width:calc(100% - 40px)}.loc-selection-box[_ngcontent-%COMP%]{display:table-cell;width:40px;vertical-align:middle}input[type=checkbox][_ngcontent-%COMP%]:hover ~ .childSelected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -18px;content:\"\"}input[type=checkbox][_ngcontent-%COMP%] ~ .childSelected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -72px;content:\"\"}.locationPopupRadio[_ngcontent-%COMP%]{position:relative}.search-input[_ngcontent-%COMP%]{padding:10px 0;background-color:#fff;font-family:CiscoSans;font-size:14px;line-height:16px;letter-spacing:.5px;color:#000;border-bottom:1px solid #DFDFDF;position:relative}.search-input[_ngcontent-%COMP%]:before{position:absolute;left:12px;top:20px;content:\"\\e915\";font-family:icomoon-new;font-size:16px;width:16px;height:16px;z-index:1;color:#999}.search-input[_ngcontent-%COMP%]   .clear-input[_ngcontent-%COMP%]{position:absolute;right:32px;top:20px;font-family:icomoon-new;font-size:7px;width:15px;height:15px;border-radius:50%;z-index:1;color:#fff;cursor:pointer;padding:0 4px;background:#999;line-height:14px}.search-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{margin:0;background-color:#f7f7f7;border-radius:16.5px;padding:7px 30px 7px 35px;border:1px solid #DFDFDF;position:relative}.search-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{border:1px solid #049fd9}.search-input[_ngcontent-%COMP%]   .press-enter-text[_ngcontent-%COMP%]{margin:5px 0 2px;font-size:10px;line-height:14px;font-family:CiscoSans;text-align:right;color:#444;display:block}.hide-tree[_ngcontent-%COMP%]{display:none;visibility:hidden;opacity:0;height:0}.search-box[_ngcontent-%COMP%]{padding:25px}.search-box[_ngcontent-%COMP%]   .recent-search[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;line-height:16px;letter-spacing:.5px;color:#121212;margin:0}.search-box[_ngcontent-%COMP%]   .recent-search[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:12px;line-height:20px;letter-spacing:.5px;color:#545454;margin:20px 0}.search-items-list[_ngcontent-%COMP%]   .search-item[_ngcontent-%COMP%]{margin:15px 0;cursor:pointer}.search-items-list[_ngcontent-%COMP%]   .search-item[_ngcontent-%COMP%]:hover{background:#dfdfdf}.search-items-list[_ngcontent-%COMP%]   .search-item[_ngcontent-%COMP%]   .search-count[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;line-height:18px;letter-spacing:.5px;color:#121212}.search-items-list[_ngcontent-%COMP%]   .search-item[_ngcontent-%COMP%]   .search-name[_ngcontent-%COMP%]{font-family:\"ciscoSansBold\";font-size:12px;line-height:20px;letter-spacing:.5px;color:#545454}.search-items-list[_ngcontent-%COMP%]   .search-item[_ngcontent-%COMP%]   .search-path[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:10px;line-height:18px;letter-spacing:.5px;color:#545454}.back-link[_ngcontent-%COMP%]{padding:15px 10px;font-size:14px;font-family:CiscoSans;line-height:24px;letter-spacing:.5px;color:#00a0d1;cursor:pointer}.back-link[_ngcontent-%COMP%]   .left-arrow[_ngcontent-%COMP%]{color:#00a0d1;font-size:14px;line-height:24px;letter-spacing:.5px;font-family:\"icomoon-new\";padding-right:5px}.app-data[_ngcontent-%COMP%]{text-align:right;padding-right:14px!important;font-family:\"ciscoSansLight\";font-weight:normal}.lh2-node-wrapper[_ngcontent-%COMP%]{vertical-align:middle;display:table;width:100%}.all-location-switch[_ngcontent-%COMP%]{margin:20px 0 10px;font-size:14px;font-family:\"ciscoSans\"}.hide-location[_ngcontent-%COMP%]{height:0!important;opacity:0!important;visibility:hidden!important}.disabled-location-tooltip[_ngcontent-%COMP%]{display:none;position:absolute;font-size:12px;background:#fff;top:35px;padding:4px 10px;opacity:1!important;z-index:1}.disabled-location-tooltip[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:-8px;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-bottom:8px solid #fff}.disabled-location[_ngcontent-%COMP%]:hover   .disabled-location-tooltip[_ngcontent-%COMP%]{display:block}.disabled-location[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{opacity:.5;cursor:default}.disabled-location[_ngcontent-%COMP%] > *.location-action[_ngcontent-%COMP%]{display:none}.location-action[_ngcontent-%COMP%]{display:table-cell;width:40px;vertical-align:middle}input[type=checkbox][_ngcontent-%COMP%] ~ .location-selected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -36px!important;content:\"\"}input[type=checkbox][_ngcontent-%COMP%]:hover ~ .location-selected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -36px!important;content:\"\"}input[type=checkbox][_ngcontent-%COMP%]:hover ~ .child-selected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -72px!important;content:\"\"}input[type=checkbox][_ngcontent-%COMP%] ~ .child-selected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -72px!important;content:\"\"}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ManageLh2TreeComponent, [{
        type: Component,
        args: [{
                selector: "app-manage-lh2-tree",
                templateUrl: "./manage-lh2-tree.component.html",
                styleUrls: ["./manage-lh2-tree.component.scss"],
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: Lh2Service }, { type: AuthService }, { type: i2.TranslateService }, { type: i0.ChangeDetectorRef }]; }, { treeComponent: [{
            type: ViewChild,
            args: ["tree", { static: true }]
        }], activeNode: [{
            type: Output
        }], locationInitialLoaded: [{
            type: Output
        }], onhover: [{
            type: Output
        }], onout: [{
            type: Output
        }], setSearchedLocation: [{
            type: Input
        }], setWlcLocationData: [{
            type: Input
        }], multiLocationSelect: [{
            type: Input
        }], permittedLocationTypes: [{
            type: Input
        }], isReportsLocation: [{
            type: Input
        }], isRichMapAvailable: [{
            type: Input
        }], selectedLocationEvt: [{
            type: Output
        }], isPopup: [{
            type: Input
        }], popupOpened: [{
            type: Input
        }], setTreeConf: [{
            type: Input
        }], setSelectedLocation: [{
            type: Input
        }] }); })();

function LocationPopupComponent_lib_manage_location_tree_25_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-manage-location-tree", 24);
    i0.ɵɵlistener("selectedLocationEvt", function LocationPopupComponent_lib_manage_location_tree_25_Template_lib_manage_location_tree_selectedLocationEvt_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.onSelectedLocation($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("permittedLocationTypes", ctx_r0.permittedLocationTypes)("isRichMapAvailable", ctx_r0.isRichMapAvailable)("multiLocationSelect", ctx_r0.multiSelect)("location", ctx_r0.locationTreeArray.location)("showAccessCode", false)("setSelectedLocation", ctx_r0.selectedLocation)("isPopup", true)("isReportsLocation", ctx_r0.isReportsLocation)("disableLicenseType", ctx_r0.disableLicenseType)("showAllLocations", ctx_r0.showAllLocations);
} }
function LocationPopupComponent_app_manage_lh2_tree_26_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-manage-lh2-tree", 25);
    i0.ɵɵlistener("selectedLocationEvt", function LocationPopupComponent_app_manage_lh2_tree_26_Template_app_manage_lh2_tree_selectedLocationEvt_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.onSelectedLocation($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("setTreeConf", ctx_r1.treeConf);
} }
function LocationPopupComponent_div_31_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "span", 32);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 33);
    i0.ɵɵlistener("click", function LocationPopupComponent_div_31_div_1_div_1_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r13); const location_r9 = i0.ɵɵnextContext().$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.removeSelectedLocation(location_r9); });
    i0.ɵɵtext(4, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const location_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(location_r9.data.name);
} }
function LocationPopupComponent_div_31_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, LocationPopupComponent_div_31_div_1_div_1_Template, 5, 1, "div", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const location_r9 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", location_r9.data && location_r9.data.name);
} }
function LocationPopupComponent_div_31_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" - ", i0.ɵɵpipeBind1(2, 1, "shared-lib.location-popup.any"), " - ");
} }
function LocationPopupComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, LocationPopupComponent_div_31_div_1_Template, 2, 1, "div", 27);
    i0.ɵɵtemplate(2, LocationPopupComponent_div_31_div_2_Template, 3, 3, "div", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.selectedLocation);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r2.selectedLocation !== undefined && ctx_r2.selectedLocation !== null && ctx_r2.selectedLocation.length > 0 && ctx_r2.selectedLocation[0].data));
} }
class LocationPopupComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.isLocationPopupShown = false;
        this.treeConf = {};
        this.requiredLicenses = ['UNLIMITED', 'ACT', 'EXTEND'];
        this.locLoadingStarted = false;
        this.locationHierarchy2_0 = false;
        this.permittedLocationTypes = ['root', 'building', 'campus', 'group', 'network', 'floor', 'zone', 'wlc', 'org', 'ap_zone', 'polygon_zone', 'cmx'];
        this.preselectedLocation = [];
        // split license changes
        this.disableLicenseType = 'SEE';
        this.showAllLocations = true;
        this.removeLocationEvt = new EventEmitter();
        this.selectLocationPopupEvt = new EventEmitter();
        this.cancelLocationPopupEvt = new EventEmitter();
        this.setMultiSelect = (multiSelect) => {
            this.multiSelect = multiSelect;
        };
        this.onSelectedLocation = ($event) => {
            //console.log( "Selected Location:: location popup::", $event );
            this.selectedLocation = $event;
            //console.log("Preselected after change::",this.preselectedLocation);
        };
        this.removeSelectedLocation = (node) => {
            let index = null;
            this.selectedLocation.filter(function (n, i) {
                if (n.data.id === node.data.id) {
                    index = i;
                    return i;
                }
                return null;
            });
            if (index !== null) {
                //console.log("Removing::",this.selectedLocation);
                this.selectedLocation.splice(index, 1);
                node.setIsExpanded(true);
            }
            else {
                //console.log("Selecting Location::",node);
                this.selectedLocation.push(node);
                node.setIsExpanded(false);
            }
            //console.log("Preselected after change::",this.preselectedLocation);
        };
        this.isEmptyObject = (obj) => {
            if (obj !== undefined && obj !== null) {
                const isEmptyObj = obj && Object.keys(obj).length === 0;
                //console.log( "Empty Object Check::", obj, isEmptyObj );
                return isEmptyObj;
            }
            else {
                return false;
            }
        };
        this.applySelectedLocations = () => {
            //console.log('applying selected locations',this.selectedLocation);
            this.selectLocationPopupEvt.emit(this.selectedLocation);
            // this.dataService.closeMagneticPopup();
            // this.dataService.openMagneticPopup()
        };
        this.hideLocationPopup = () => {
            this.selectedLocation = [];
            //console.log('hiding locations popup',this.preselectedLocation);
            if (!this.isReportsLocation) {
                this.selectLocationPopupEvt.emit(this.preselectedLocation);
                this.dataService.openMagneticPopup();
            }
            else {
                this.cancelLocationPopupEvt.emit(this.preselectedLocation);
                this.dataService.openMagneticPopup();
            }
            this.dataService.closeMagneticPopup();
        };
        this.selectAllLocTypes = ($event) => {
            this.showAllLocations = $event.target.checked;
        };
    }
    set setAppName(value) {
        this.appName = value;
        this.checkSplitLicense();
    }
    set preSelectLocation($event) {
        this.selectedLocation = $event;
        this.preselectedLocation = $event.map((x) => Object.assign({}, x));
    }
    ngOnInit() {
        //console.log( 'location popup initialisation done',this.preselectedLocation );
        this.dataService.getLocationWrap().then((val) => {
            //console.log(val);
            this.locationTreeArray = val;
            this.setMultiSelect(this.multiLocationSelect);
        });
        //this.checkSplitLicense();
        this.dataService.getLocLoadingStarted(this.unsubscribe$).subscribe(status => {
            if (status) {
                this.locLoadingStarted = true;
            }
            else {
                this.locLoadingStarted = false;
            }
        });
        if (this.appName === 'captivePortal' || this.appName === 'engagement') {
            this.requiredLicenses = ['UNLIMITED', 'ACT', 'SMART_VENUES'];
            this.treeConf = {
                type: 'radio',
                appName: 'app-center',
                selectedLocation: this.selectedLocation,
                requiredLicenses: this.requiredLicenses,
                enableSearch: false,
                isPopup: true,
                isDataId: true,
                isReportsLocation: this.isReportsLocation,
                permittedLocationTypes: ['root', 'building', 'campus', 'group', 'network', 'floor', 'zone', 'wlc', 'org', 'ap_zone', 'polygon_zone', 'cmx']
            };
        }
        else if (this.appName === 'rightNow') {
            this.requiredLicenses = ['UNLIMITED', 'ACT'];
            this.treeConf = {
                type: 'checkbox',
                appName: 'rightNow',
                selectedLocation: this.selectedLocation,
                requiredLicenses: this.requiredLicenses,
                enableSearch: false,
                isPopup: true,
                isDataId: true,
                isReportsLocation: this.isReportsLocation,
                permittedLocationTypes: ['root', 'building', 'campus', 'group', 'network', 'floor', 'zone', 'wlc', 'org', 'ap_zone', 'polygon_zone', 'cmx']
            };
        }
    }
    ngOnDestroy() {
        this.isLocationPopupShown = false;
        this.locationTreeArray = null;
        this.selectedLocation = [];
        this.removeLocation = null;
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    checkSplitLicense() {
        if (this.appName === 'captivePortal' || this.appName === 'engagement' || this.appName === 'rightNow') {
            this.locationHierarchy2_0 = true;
        }
    }
    ;
}
LocationPopupComponent.ɵfac = function LocationPopupComponent_Factory(t) { return new (t || LocationPopupComponent)(i0.ɵɵdirectiveInject(DataService)); };
LocationPopupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LocationPopupComponent, selectors: [["lib-location-popup"]], inputs: { permittedLocationTypes: "permittedLocationTypes", isRichMapAvailable: "isRichMapAvailable", isReportsLocation: "isReportsLocation", showPopUp: "showPopUp", multiLocationSelect: "multiLocationSelect", setAppName: "setAppName", preSelectLocation: "preSelectLocation" }, outputs: { removeLocationEvt: "removeLocationEvt", selectLocationPopupEvt: "selectLocationPopupEvt", cancelLocationPopupEvt: "cancelLocationPopupEvt" }, decls: 39, vars: 23, consts: [[1, "locationsPopupModal"], [1, "popupOverlay"], [1, "locationPopupContent"], [1, "locationPopupHeader"], [1, "locationPopupClose", 3, "click"], [1, "locationPopupBody"], [1, "locationPopupLeft"], [1, "divTable"], [1, "divTableCell"], [1, "divTableCell", 2, "text-align", "-webkit-right"], [1, "divTableCell", 2, "width", "20px"], [1, "circularCheckbox"], ["type", "checkbox", "id", "portalCheckbox-showAllLocations", 3, "checked", "click"], ["for", "portalCheckbox-showAllLocations", 1, "checkboxLabel"], [1, "portalNameLabel", "enableLabel"], [3, "ngClass"], ["class", "locPopup", 3, "permittedLocationTypes", "isRichMapAvailable", "multiLocationSelect", "location", "showAccessCode", "setSelectedLocation", "isPopup", "isReportsLocation", "disableLicenseType", "showAllLocations", "selectedLocationEvt", 4, "ngIf"], [3, "setTreeConf", "selectedLocationEvt", 4, "ngIf"], [1, "locationPopupRight"], [1, "selectedLocationsLabel"], ["class", "selectedLocationsList", 4, "ngIf"], [1, "locationPopupFooter"], [1, "squareButtonPrimary", 3, "click"], [1, "cancelButton", 3, "click"], [1, "locPopup", 3, "permittedLocationTypes", "isRichMapAvailable", "multiLocationSelect", "location", "showAccessCode", "setSelectedLocation", "isPopup", "isReportsLocation", "disableLicenseType", "showAllLocations", "selectedLocationEvt"], [3, "setTreeConf", "selectedLocationEvt"], [1, "selectedLocationsList"], ["style", "display: inline-block", 4, "ngFor", "ngForOf"], ["class", "emptyLabel", 4, "ngIf"], [2, "display", "inline-block"], ["class", "labelChip", 4, "ngIf"], [1, "labelChip"], [1, "labelName"], [1, "labelClose", 3, "click"], [1, "emptyLabel"]], template: function LocationPopupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4);
        i0.ɵɵpipe(5, "translate");
        i0.ɵɵelementStart(6, "span", 4);
        i0.ɵɵlistener("click", function LocationPopupComponent_Template_span_click_6_listener() { return ctx.hideLocationPopup(); });
        i0.ɵɵtext(7, "\uE909");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 5);
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelementStart(10, "div", 7);
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "h4");
        i0.ɵɵtext(13);
        i0.ɵɵpipe(14, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 9);
        i0.ɵɵelementStart(16, "div", 10);
        i0.ɵɵelementStart(17, "span", 11);
        i0.ɵɵelementStart(18, "input", 12);
        i0.ɵɵlistener("click", function LocationPopupComponent_Template_input_click_18_listener($event) { return ctx.selectAllLocTypes($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "label", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 8);
        i0.ɵɵelementStart(21, "span", 14);
        i0.ɵɵtext(22);
        i0.ɵɵpipe(23, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 15);
        i0.ɵɵtemplate(25, LocationPopupComponent_lib_manage_location_tree_25_Template, 1, 10, "lib-manage-location-tree", 16);
        i0.ɵɵtemplate(26, LocationPopupComponent_app_manage_lh2_tree_26_Template, 1, 1, "app-manage-lh2-tree", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 18);
        i0.ɵɵelementStart(28, "h4", 19);
        i0.ɵɵtext(29);
        i0.ɵɵpipe(30, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(31, LocationPopupComponent_div_31_Template, 3, 2, "div", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 21);
        i0.ɵɵelementStart(33, "button", 22);
        i0.ɵɵlistener("click", function LocationPopupComponent_Template_button_click_33_listener() { return ctx.applySelectedLocations(); });
        i0.ɵɵtext(34);
        i0.ɵɵpipe(35, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "button", 23);
        i0.ɵɵlistener("click", function LocationPopupComponent_Template_button_click_36_listener() { return ctx.hideLocationPopup(); });
        i0.ɵɵtext(37);
        i0.ɵɵpipe(38, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 11, "shared-lib.location-popup.choose-locs"), " ");
        i0.ɵɵadvance(9);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 13, "shared-lib.location-popup.loc-hierarchy"));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("checked", ctx.showAllLocations);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 15, "shared-lib.location-popup.show-all-locs"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.locationHierarchy2_0 ? "lh2Container" : "locationHierarchyContainer");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.locationTreeArray && ctx.locationTreeArray.location && ctx.locationTreeArray.location.length > 0 && !ctx.locationHierarchy2_0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.locationHierarchy2_0);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(30, 17, "shared-lib.location-popup.selected-locs"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selectedLocation);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(35, 19, "shared-lib.location-popup.done"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(38, 21, "shared-lib.location-popup.cancel"), " ");
    } }, directives: [i1$2.NgClass, i1$2.NgIf, ManageLocationTreeComponent, ManageLh2TreeComponent, i1$2.NgForOf], pipes: [i2.TranslatePipe], styles: ["[_nghost-%COMP%]{display:inline-block}.locationsPopupModal[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:1000;left:0;top:0}.popupOverlay[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:1000;background-color:#0009}.locationPopupContent[_ngcontent-%COMP%]{position:absolute;top:60px;left:50%;transform:translate(-50%);width:90%;height:80%;margin:0 auto;background-color:#fff;box-shadow:0 4px 8px #0000001a;border-radius:5px;border:0;z-index:1001}.locationPopupHeader[_ngcontent-%COMP%]{padding:18px 30px;color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:relative;height:60px;border-bottom:1px solid #EAEAEA}.locationPopupFooter[_ngcontent-%COMP%]{padding:7px 30px;color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:relative;height:60px;position:absolute;bottom:0;left:0;width:100%;border-top:1px solid #EAEAEA;background-color:#fff}.locationPopupClose[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.locationPopupLeft[_ngcontent-%COMP%]{width:60%;display:inline-block;padding:0 30px 10px}.locationPopupRight[_ngcontent-%COMP%]{width:39%;display:inline-block;padding:0 10px 10px 0;vertical-align:top}.locationPopupRight[_ngcontent-%COMP%]   .labelChip[_ngcontent-%COMP%]{margin-bottom:15px}.locationHierarchyContainer[_ngcontent-%COMP%]{overflow-y:scroll}.lh2Container[_ngcontent-%COMP%]{height:600px;overflow-y:scroll}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocationPopupComponent, [{
        type: Component,
        args: [{
                selector: "lib-location-popup",
                templateUrl: "./location-popup.component.html",
                styleUrls: ["./location-popup.component.css"]
            }]
    }], function () { return [{ type: DataService }]; }, { permittedLocationTypes: [{
            type: Input
        }], isRichMapAvailable: [{
            type: Input
        }], isReportsLocation: [{
            type: Input
        }], showPopUp: [{
            type: Input
        }], multiLocationSelect: [{
            type: Input
        }], setAppName: [{
            type: Input
        }], preSelectLocation: [{
            type: Input
        }], removeLocationEvt: [{
            type: Output
        }], selectLocationPopupEvt: [{
            type: Output
        }], cancelLocationPopupEvt: [{
            type: Output
        }] }); })();

function CmxConnectorSwitchesComponent_div_0_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.switchModuleError, " ");
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "input", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r6.switchConnector.name);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_14_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_0_div_1_div_14_div_3_div_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const connector_r15 = restoredCtx.$implicit; const ctx_r16 = i0.ɵɵnextContext(5); return ctx_r16.connectorSelected(connector_r15); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r15 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", connector_r15.name, " ");
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_14_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵtemplate(1, CmxConnectorSwitchesComponent_div_0_div_1_div_14_div_3_div_1_Template, 3, 1, "div", 39);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r13.spacesConnectorList);
} }
const _c0$1i = function (a0) { return { "menuActive": a0 }; };
function CmxConnectorSwitchesComponent_div_0_div_1_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_0_div_1_div_14_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(3); return ctx_r18.toggleDropDown("connectorList"); });
    i0.ɵɵelementStart(1, "div", 36);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CmxConnectorSwitchesComponent_div_0_div_1_div_14_div_3_Template, 2, 1, "div", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$1i, ctx_r7.showConnectorList === true));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.connectorName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.showConnectorList === true);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 64);
    i0.ɵɵelementStart(1, "div", 65);
    i0.ɵɵelementStart(2, "span", 62);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const location_r27 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(location_r27);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 62);
    i0.ɵɵtemplate(1, CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_div_1_div_1_div_1_Template, 4, 1, "div", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r25.locationNames);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_div_1_div_1_Template, 2, 1, "div", 61);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r22.preSelectedLocations.length == 0);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "span", 62);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 66);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_div_4_Template_span_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r31); const location_r28 = restoredCtx.$implicit; const ctx_r30 = i0.ɵɵnextContext(5); return ctx_r30.removeSelectedLocation(location_r28); });
    i0.ɵɵtext(4, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const location_r28 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(location_r28.data.name);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "lib-location-popup", 68);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_div_9_Template_lib_location_popup_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(5); return ctx_r32.switchObject.locationId = $event; })("selectLocationPopupEvt", function CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_div_9_Template_lib_location_popup_selectLocationPopupEvt_1_listener($event) { i0.ɵɵrestoreView(_r33); const ctx_r34 = i0.ɵɵnextContext(5); return ctx_r34.fromLocationPopUp($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r24.switchObject.locationId)("preSelectLocation", ctx_r24.preSelectedLocations)("multiLocationSelect", false);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵtemplate(1, CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_div_1_Template, 2, 1, "div", 19);
    i0.ɵɵelementStart(2, "span", 55);
    i0.ɵɵelementStart(3, "div", 56);
    i0.ɵɵtemplate(4, CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_div_4_Template, 5, 1, "div", 57);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 58);
    i0.ɵɵelementStart(6, "button", 59);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(4); return ctx_r35.toggleLocationPopUp(); });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_div_9_Template, 2, 3, "div", 60);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.isEdit);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r20.preSelectedLocations);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 4, "dashboard-lib.dashboard_admin_user_management.invite_admin.add_location"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r20.showLocationPopUp);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_33_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 64);
    i0.ɵɵelementStart(1, "div", 65);
    i0.ɵɵelementStart(2, "span", 62);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const location_r38 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", location_r38.data.name, " ");
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵelementStart(1, "div", 70);
    i0.ɵɵelementStart(2, "div", 71);
    i0.ɵɵelementStart(3, "div", 14);
    i0.ɵɵelementStart(4, "div", 72);
    i0.ɵɵelementStart(5, "div", 73);
    i0.ɵɵelementStart(6, "span", 74);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 75);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelement(13, "img", 76);
    i0.ɵɵelementStart(14, "span", 77);
    i0.ɵɵelementStart(15, "span", 78);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_33_div_18_Template, 4, 1, "div", 79);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 5, "dashboard-lib.dashboard_admin_user_management.invite_admin.rule_restricted"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 7, "dashboard-lib.dashboard_admin_user_management.invite_admin.location_label"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 9, "dashboard-lib.dashboard_admin_user_management.invite_admin.rule_restricted"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r21.preSelectedLocations)("ngForFirst", true);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_38_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelementStart(1, "div", 42);
    i0.ɵɵelementStart(2, "div", 18);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelementStart(6, "input", 43);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorSwitchesComponent_div_0_div_1_div_38_Template_input_ngModelChange_6_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(3); return ctx_r40.switchObject.name = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 42);
    i0.ɵɵelementStart(8, "div", 18);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵelementStart(12, "input", 44);
    i0.ɵɵlistener("blur", function CmxConnectorSwitchesComponent_div_0_div_1_div_38_Template_input_blur_12_listener() { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(3); return ctx_r42.validateIPAddress(); })("ngModelChange", function CmxConnectorSwitchesComponent_div_0_div_1_div_38_Template_input_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r43 = i0.ɵɵnextContext(3); return ctx_r43.switchObject.switchIp = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 42);
    i0.ɵɵelementStart(14, "div", 18);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div");
    i0.ɵɵelementStart(18, "input", 45);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorSwitchesComponent_div_0_div_1_div_38_Template_input_ngModelChange_18_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r44 = i0.ɵɵnextContext(3); return ctx_r44.switchObject.login.username = $event; });
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 42);
    i0.ɵɵelementStart(21, "div", 18);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 46);
    i0.ɵɵelementStart(25, "input", 47);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorSwitchesComponent_div_0_div_1_div_38_Template_input_ngModelChange_25_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r45 = i0.ɵɵnextContext(3); return ctx_r45.switchObject.login.password = $event; });
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 48);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_0_div_1_div_38_Template_div_click_27_listener() { i0.ɵɵrestoreView(_r41); const ctx_r46 = i0.ɵɵnextContext(3); return ctx_r46.togglePasswordDisplay(); });
    i0.ɵɵelementStart(28, "span");
    i0.ɵɵelement(29, "img", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(30, "span", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "div", 51);
    i0.ɵɵtemplate(32, CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_32_Template, 10, 6, "div", 52);
    i0.ɵɵtemplate(33, CmxConnectorSwitchesComponent_div_0_div_1_div_38_div_33_Template, 19, 11, "div", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 17, "dashboard-lib.setup.connectorSwitches.sName"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r8.switchObject.name)("value", ctx_r8.switchObject.name);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 19, "dashboard-lib.setup.connectorSwitches.ip"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r8.switchObject.switchIp)("value", ctx_r8.switchObject.switchIp);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 21, "dashboard-lib.setup.connectorSwitches.netName"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(19, 23, "dashboard-lib.setup.connectorSwitches.netName"));
    i0.ɵɵproperty("ngModel", ctx_r8.switchObject.login.username)("value", ctx_r8.switchObject.login.username);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 25, "dashboard-lib.setup.connectorSwitches.netPass"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(26, 27, "dashboard-lib.setup.connectorSwitches.netPass"));
    i0.ɵɵproperty("ngModel", ctx_r8.switchObject.login.password)("value", ctx_r8.switchObject.login.password);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("innerHTML", ctx_r8.showPassword ? "HIDE" : "SHOW", i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.roleBasedLocationRestriction == false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.roleBasedLocationRestriction == true);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_1_div_7_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 87);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_1_div_7_div_1_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r59); const connector_r54 = i0.ɵɵnextContext().$implicit; const ctx_r57 = i0.ɵɵnextContext(6); return ctx_r57.connectorImportFromSelected(connector_r54); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r54 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", connector_r54.importNotAllowed ? "disabled" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", connector_r54.name, " ");
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_1_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 85);
    i0.ɵɵtemplate(1, CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_1_div_7_div_1_div_1_Template, 2, 2, "div", 86);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r54 = ctx.$implicit;
    const ctx_r53 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r53.switchObject.connectorId !== connector_r54.id);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 83);
    i0.ɵɵtemplate(1, CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_1_div_7_div_1_Template, 2, 1, "div", 84);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r52.spacesConnectorImportAllowed);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 35);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_1_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(4); return ctx_r61.toggleDropDown("importConnectorList"); });
    i0.ɵɵelementStart(5, "div", 36);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_1_div_7_Template, 2, 1, "div", 82);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "dashboard-lib.spaces-connector.create-connector.choose_connector"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$1i, ctx_r47.showImportFromConnectorList === true));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r47.importFromConnector.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.showImportFromConnectorList === true);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 88);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2, "No connector available to import switch");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 88);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2, "No connector available to import switches");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 92);
    i0.ɵɵelementStart(1, "input", 99);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_ng_template_9_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r67); const ctx_r66 = i0.ɵɵnextContext(5); return ctx_r66.selectAll = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 100);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r64 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r64.selectAll);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_tr_21_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r74 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 92);
    i0.ɵɵelementStart(1, "input", 107);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_tr_21_ng_template_5_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r74); const switch_r68 = i0.ɵɵnextContext().$implicit; return switch_r68.selected = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 100);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const switch_r68 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", switch_r68.selected);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_tr_21_Template(rf, ctx) { if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 101);
    i0.ɵɵelementStart(1, "td", 102);
    i0.ɵɵelementStart(2, "span", 92);
    i0.ɵɵelementStart(3, "input", 103);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_tr_21_Template_input_ngModelChange_3_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r77); const switch_r68 = restoredCtx.$implicit; return switch_r68.selected = $event; })("change", function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_tr_21_Template_input_change_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r77); const switch_r68 = restoredCtx.$implicit; const ctx_r78 = i0.ɵɵnextContext(5); return ctx_r78.selectThisSwitch(switch_r68); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "label", 104);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_tr_21_ng_template_5_Template, 3, 1, "ng-template", null, 105, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 106);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 106);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td", 106);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const switch_r68 = ctx.$implicit;
    const i_r69 = ctx.index;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "selectController-", i_r69, "");
    i0.ɵɵproperty("ngModel", switch_r68.selected)("checked", switch_r68.selected);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "selectController-", i_r69, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(switch_r68.switchId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(switch_r68.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(switch_r68.switchIp);
} }
const _c1$v = function (a0) { return { "partial-select": a0 }; };
function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r80 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "table", 89);
    i0.ɵɵelementStart(3, "thead");
    i0.ɵɵelementStart(4, "tr", 90);
    i0.ɵɵelementStart(5, "th", 91);
    i0.ɵɵelementStart(6, "span", 92);
    i0.ɵɵelementStart(7, "input", 93);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_Template_input_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r80); const ctx_r79 = i0.ɵɵnextContext(4); return ctx_r79.selectAll = $event; })("change", function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_Template_input_change_7_listener() { i0.ɵɵrestoreView(_r80); const ctx_r81 = i0.ɵɵnextContext(4); return ctx_r81.selectAllSwitches(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "label", 94);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_ng_template_9_Template, 3, 1, "ng-template", null, 95, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th", 96);
    i0.ɵɵelementStart(12, "span", 97);
    i0.ɵɵtext(13, "Id");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "th", 96);
    i0.ɵɵelementStart(15, "span", 97);
    i0.ɵɵtext(16, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th", 96);
    i0.ɵɵelementStart(18, "span", 97);
    i0.ɵɵtext(19, "IP Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "tbody");
    i0.ɵɵtemplate(21, CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_tr_21_Template, 13, 7, "tr", 98);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngModel", ctx_r50.selectAll);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$v, !ctx_r50.selectAll && ctx_r50.deviceIdsToImport.length > 0));
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("ngForOf", ctx_r50.listOfSwitches);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, " No switches are associated to this connector. ");
    i0.ɵɵelementEnd();
} }
function CmxConnectorSwitchesComponent_div_0_div_1_div_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtemplate(1, CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_1_Template, 8, 8, "div", 80);
    i0.ɵɵtemplate(2, CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_2_Template, 3, 0, "div", 81);
    i0.ɵɵtemplate(3, CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_3_Template, 3, 0, "div", 81);
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵtemplate(5, CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_5_Template, 22, 5, "div", 19);
    i0.ɵɵtemplate(6, CmxConnectorSwitchesComponent_div_0_div_1_div_39_div_6_Template, 2, 0, "div", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.spacesConnectorImportAllowed.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.spacesConnectorImportAllowed.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.spacesConnectorImportAllowed.length === 1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.listOfSwitches.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.importFromConnector.name !== "-- Select --" && ctx_r9.listOfSwitches.length == 0);
} }
function CmxConnectorSwitchesComponent_div_0_div_1_button_41_Template(rf, ctx) { if (rf & 1) {
    const _r83 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 108);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_0_div_1_button_41_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r83); const ctx_r82 = i0.ɵɵnextContext(3); return ctx_r82.switchAction(1); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r10.switchObject.connectorId === null || ctx_r10.switchObject.login.username === null || ctx_r10.switchObject.login.password === null ? "disableOverlay" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.setup.connectorSwitches.saveClose"), " ");
} }
function CmxConnectorSwitchesComponent_div_0_div_1_button_42_Template(rf, ctx) { if (rf & 1) {
    const _r85 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 108);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_0_div_1_button_42_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r85); const ctx_r84 = i0.ɵɵnextContext(3); return ctx_r84.switchAction(2); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r11.switchObject.connectorId === null || ctx_r11.switchObject.login.username === null || ctx_r11.switchObject.login.password === null ? "disableOverlay" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.setup.connectorSwitches.saveAdd"), " ");
} }
function CmxConnectorSwitchesComponent_div_0_div_1_button_43_Template(rf, ctx) { if (rf & 1) {
    const _r87 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 108);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_0_div_1_button_43_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r87); const ctx_r86 = i0.ɵɵnextContext(3); return ctx_r86.importSwitch(ctx_r86.importFromConnector.id, ctx_r86.switchObject.connectorId, ctx_r86.deviceIdsToImport); });
    i0.ɵɵtext(1, " Add ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", !ctx_r12.toggleSaveButton() ? "disabledElement" : "");
} }
function CmxConnectorSwitchesComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r89 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 13);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_0_div_1_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r89); const ctx_r88 = i0.ɵɵnextContext(2); return ctx_r88.closeSpacesModal(); });
    i0.ɵɵtext(5, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 14);
    i0.ɵɵelementStart(7, "div", 15);
    i0.ɵɵtemplate(8, CmxConnectorSwitchesComponent_div_0_div_1_div_8_Template, 2, 1, "div", 16);
    i0.ɵɵelementStart(9, "div", 17);
    i0.ɵɵelementStart(10, "div", 18);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, CmxConnectorSwitchesComponent_div_0_div_1_div_13_Template, 2, 1, "div", 19);
    i0.ɵɵtemplate(14, CmxConnectorSwitchesComponent_div_0_div_1_div_14_Template, 4, 5, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 21);
    i0.ɵɵelementStart(16, "div", 22);
    i0.ɵɵelementStart(17, "div", 23);
    i0.ɵɵelementStart(18, "div", 24);
    i0.ɵɵelementStart(19, "input", 25);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorSwitchesComponent_div_0_div_1_Template_input_ngModelChange_19_listener() { i0.ɵɵrestoreView(_r89); const ctx_r90 = i0.ɵɵnextContext(2); return ctx_r90.switchCreationSelection(0); })("ngModelChange", function CmxConnectorSwitchesComponent_div_0_div_1_Template_input_ngModelChange_19_listener($event) { i0.ɵɵrestoreView(_r89); const ctx_r91 = i0.ɵɵnextContext(2); return ctx_r91.switchCreateType.value = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "label", 26);
    i0.ɵɵelementStart(21, "span", 27);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelement(24, "br");
    i0.ɵɵelementStart(25, "span", 28);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 24);
    i0.ɵɵelementStart(29, "input", 29);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorSwitchesComponent_div_0_div_1_Template_input_ngModelChange_29_listener() { i0.ɵɵrestoreView(_r89); const ctx_r92 = i0.ɵɵnextContext(2); return ctx_r92.switchCreationSelection(1); })("ngModelChange", function CmxConnectorSwitchesComponent_div_0_div_1_Template_input_ngModelChange_29_listener($event) { i0.ɵɵrestoreView(_r89); const ctx_r93 = i0.ɵɵnextContext(2); return ctx_r93.switchCreateType.value = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "label", 26);
    i0.ɵɵelementStart(31, "span", 27);
    i0.ɵɵtext(32);
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵelement(34, "br");
    i0.ɵɵelementStart(35, "span", 28);
    i0.ɵɵtext(36);
    i0.ɵɵpipe(37, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(38, CmxConnectorSwitchesComponent_div_0_div_1_div_38_Template, 34, 29, "div", 30);
    i0.ɵɵtemplate(39, CmxConnectorSwitchesComponent_div_0_div_1_div_39_Template, 7, 5, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 31);
    i0.ɵɵtemplate(41, CmxConnectorSwitchesComponent_div_0_div_1_button_41_Template, 3, 4, "button", 32);
    i0.ɵɵtemplate(42, CmxConnectorSwitchesComponent_div_0_div_1_button_42_Template, 3, 4, "button", 32);
    i0.ɵɵtemplate(43, CmxConnectorSwitchesComponent_div_0_div_1_button_43_Template, 2, 1, "button", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.isEdit ? "Edit Switch" : "Add Switch");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r4.switchModuleError !== "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 17, "dashboard-lib.setup.connectorSwitches.title"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.pageFrom === "spacesConnector");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.pageFrom !== "spacesConnector");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r4.switchObject.connectorId === null ? "disableOverlay" : "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r4.switchCreateType.value);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 19, "dashboard-lib.setup.connectorSwitches.add_new_switch"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(27, 21, "dashboard-lib.setup.connectorSwitches.add_new_subheading"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r4.switchCreateType.value);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(33, 23, "dashboard-lib.setup.connectorSwitches.choose_import"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(37, 25, "dashboard-lib.setup.connectorSwitches.choose_import_subheading"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.switchCreateType.name == "new");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.switchCreateType.name == "import");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.switchCreateType.name == "new");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.isEdit && ctx_r4.switchCreateType.name == "new");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.switchCreateType.name == "import");
} }
function CmxConnectorSwitchesComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, CmxConnectorSwitchesComponent_div_0_div_1_Template, 44, 27, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.spacesConnectorList.length > 0);
} }
function CmxConnectorSwitchesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r95 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 109);
    i0.ɵɵelementStart(1, "div", 110);
    i0.ɵɵelementStart(2, "div", 111);
    i0.ɵɵelementStart(3, "div", 112);
    i0.ɵɵelement(4, "img", 113);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 114);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_1_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r95); const ctx_r94 = i0.ɵɵnextContext(); return ctx_r94.showHideConfirmation(false); });
    i0.ɵɵtext(6, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 115);
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵelementStart(9, "div");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 116);
    i0.ɵɵelementStart(13, "div", 117);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_1_Template_div_click_13_listener() { i0.ɵɵrestoreView(_r95); const ctx_r96 = i0.ɵɵnextContext(); return ctx_r96.deleteSwitch(); });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 118);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_1_Template_div_click_16_listener() { i0.ɵɵrestoreView(_r95); const ctx_r97 = i0.ɵɵnextContext(); return ctx_r97.showHideConfirmation(false); });
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(11, 4, "dashboard-lib.setup.connectorSwitches.confirm"), " '", ctx_r1.switchToDelete.name, "'? ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 6, "dashboard-lib.setup.connectorSwitches.delete"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 8, "dashboard-lib.setup.connectorSwitches.cancel"), " ");
} }
function CmxConnectorSwitchesComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "div", 120);
    i0.ɵɵelementStart(2, "div", 121);
    i0.ɵɵelementStart(3, "div", 122);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 122);
    i0.ɵɵelement(10, "img", 123);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 2, "dashboard-lib.setup.connectorSwitches.notAdded"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 4, "dashboard-lib.setup.connectorSwitches.clickAdd"));
} }
function CmxConnectorSwitchesComponent_div_13_table_1_tr_19_Template(rf, ctx) { if (rf & 1) {
    const _r104 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 134);
    i0.ɵɵelementStart(1, "td", 131);
    i0.ɵɵelementStart(2, "span", 135);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 131);
    i0.ɵɵelementStart(5, "span", 135);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 131);
    i0.ɵɵelementStart(8, "span", 135);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td", 131);
    i0.ɵɵelementStart(11, "span", 135);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td", 132);
    i0.ɵɵelementStart(15, "div", 136);
    i0.ɵɵelementStart(16, "a", 137);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_13_table_1_tr_19_Template_a_click_16_listener() { const restoredCtx = i0.ɵɵrestoreView(_r104); const switch_r101 = restoredCtx.$implicit; const ctx_r103 = i0.ɵɵnextContext(3); return ctx_r103.editSwitch(switch_r101); });
    i0.ɵɵelement(17, "img", 138);
    i0.ɵɵelementStart(18, "span");
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "a", 139);
    i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_div_13_table_1_tr_19_Template_a_click_21_listener() { const restoredCtx = i0.ɵɵrestoreView(_r104); const switch_r101 = restoredCtx.$implicit; const ctx_r105 = i0.ɵɵnextContext(3); return ctx_r105.deleteSwitchConfirm(switch_r101); });
    i0.ɵɵelement(22, "img", 140);
    i0.ɵɵelementStart(23, "span");
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(26, "td");
    i0.ɵɵelement(27, "td");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const switch_r101 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", switch_r101.name, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", switch_r101.switchIp, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", switch_r101.connectorName ? switch_r101.connectorName : "----NA----", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(13, 6, switch_r101.updatedAt, "medium"), " ");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(20, 9, "dashboard-lib.setup.connectorSwitches.edit"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(25, 11, "dashboard-lib.setup.connectorSwitches.delete"), " ");
} }
function CmxConnectorSwitchesComponent_div_13_table_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 129);
    i0.ɵɵelementStart(1, "thead");
    i0.ɵɵelementStart(2, "tr", 130);
    i0.ɵɵelementStart(3, "th", 131);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 131);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 131);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th", 131);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "th", 132);
    i0.ɵɵelement(16, "th");
    i0.ɵɵelement(17, "th");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "tbody");
    i0.ɵɵtemplate(19, CmxConnectorSwitchesComponent_div_13_table_1_tr_19_Template, 28, 13, "tr", 133);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r98 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "dashboard-lib.setup.connectorSwitches.name"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 7, "dashboard-lib.setup.connectorSwitches.ipaddr"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 9, "dashboard-lib.setup.connectorSwitches.conn"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 11, "dashboard-lib.setup.connectorSwitches.lastUp"));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r98.currentSwitchItems);
} }
function CmxConnectorSwitchesComponent_div_13_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 141);
    i0.ɵɵelementStart(1, "div", 119);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "dashboard-lib.setup.connectorSwitches.noAvail"));
} }
function CmxConnectorSwitchesComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r107 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 124);
    i0.ɵɵtemplate(1, CmxConnectorSwitchesComponent_div_13_table_1_Template, 20, 13, "table", 125);
    i0.ɵɵelementStart(2, "div", 126);
    i0.ɵɵelementStart(3, "lib-pagination", 127);
    i0.ɵɵlistener("clickEvent", function CmxConnectorSwitchesComponent_div_13_Template_lib_pagination_clickEvent_3_listener($event) { i0.ɵɵrestoreView(_r107); const ctx_r106 = i0.ɵɵnextContext(); return ctx_r106.clickEvents($event); })("currentPage", function CmxConnectorSwitchesComponent_div_13_Template_lib_pagination_currentPage_3_listener($event) { i0.ɵɵrestoreView(_r107); const ctx_r108 = i0.ɵɵnextContext(); return ctx_r108.getCurrentSwitchesItems($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CmxConnectorSwitchesComponent_div_13_div_4_Template, 4, 3, "div", 128);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.switchesList && ctx_r3.switchesList.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pagesToShow", 3)("perPage", 10)("page", 1)("loading", false)("items", ctx_r3.switchesList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.switchesList.length === 0);
} }
class CmxConnectorSwitchesComponent {
    constructor(dataService, cmxConnectorsService, router, translate) {
        this.dataService = dataService;
        this.cmxConnectorsService = cmxConnectorsService;
        this.router = router;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.messageKeys = {};
        this.closeModal = new EventEmitter();
        this.showConnectorListPage = new EventEmitter();
        this.showSwitchCount = new EventEmitter(); //C3 IOT
        this.preSelectedLocations = [];
        this.showLocationPopUp = false;
        this.isLocationsAdded = false;
        this.roleBasedLocationRestriction = false;
        this.userBasedLocationRestriction = false;
        this.switchModuleError = "";
        this.showConnectorList = false;
        this.spacesConnectorList = [];
        this.switchObject = {};
        this.showPassword = false;
        this.switchesList = [];
        this.fullSwitchList = [];
        this.currentSwitchItems = [];
        this.locationNames = [];
        this.displaySection = {
            list: false,
            popup: false
        };
        this.isEdit = false;
        this.confirmationVisible = false;
        this.connectorName = "";
        this.switchToDelete = {
            name: null,
            id: null
        };
        //c3 IOT
        this.switchCount = 0;
        //C3
        this.spacesConnectorImportAllowed = []; // only connector (2.x && 3.0 not having hotspot enabled in this list)
        this.switchCreateType = { "name": "new", "value": "Add new switch" };
        this.switchCreateTypes = [{ "name": "new", "value": "Add new switch" }, { "name": "import", "value": "Choose switch from another connector" }];
        this.showImportFromConnectorList = false;
        this.importFromConnector = {};
        this.listOfSwitches = [];
        this.deviceIdsToImport = [];
        this.disableImportButton = true;
        this.copyHotspotConfig = false;
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.setup.connectorSwitches.title').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.title"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.sName').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.sName"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.ip').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.ip"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.netName').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.netName"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.netPass').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.netPass"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.saveClose').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.saveClose"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.saveAdd').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.saveAdd"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.confirm').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.confirm"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.delete').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.delete"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.cancel').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.cancel"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.switches').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.switches"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.add').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.add"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.notAdded').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.notAdded"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.clickAdd').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.clickAdd"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.name').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.name"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.ipaddr').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.ipaddr"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.conn').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.conn"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.lastUp').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.lastUp"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.edit').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.edit"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.noAvail').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorSwitches.noAvail"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.createdSuccess').subscribe((res) => {
                this.messageKeys["createdSuccess"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.createFail').subscribe((res) => {
                this.messageKeys["createFail"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.confUpdate').subscribe((res) => {
                this.messageKeys["confUpdate"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.confFail').subscribe((res) => {
                this.messageKeys["confFail"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.upFail').subscribe((res) => {
                this.messageKeys["upFail"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.delSuccess').subscribe((res) => {
                this.messageKeys["delSuccess"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorSwitches.delFail').subscribe((res) => {
                this.messageKeys["delFail"] = res;
            });
        };
        this.getSwitchesList = () => {
            this.switchCount = 0;
            this.dataService.display(true);
            this.cmxConnectorsService
                .getSwitchesList()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response && response.data) {
                    this.switchesList = response.data;
                    this.fullSwitchList = response.data;
                    for (let item of response.data) {
                        this.locationNames.push(item.locationName);
                    }
                    console.log("Location Names: ", this.locationNames);
                    if ((this.pageFrom = "spacesConnector")) {
                        const tempList = [];
                        this.switchesList.forEach((switchObj) => {
                            if (switchObj.connectorId ==
                                this.switchConnector.id) {
                                tempList.push(switchObj);
                            }
                        });
                        this.switchesList = [];
                        this.switchesList = tempList;
                        this.getConnectorNameUsingID();
                        this.switchCount = this.switchesList.length;
                    }
                    else {
                        this.getConnectorNameUsingID();
                        this.switchCount = 0;
                    }
                }
                this.showSwitchCount.emit(this.switchCount);
            }, (error) => {
                this.dataService.display(false);
                console.log("ERROR:: Failed to fetch switch list", error);
            });
        };
        this.closeSpacesModal = () => {
            this.dataService.closeMagneticPopup();
            if (this.isEdit) {
                this.isEdit = false;
            }
            this.locationNames = [];
            this.preSelectedLocations = [];
            this.displaySection.popup = false;
            this.closeModal.emit();
        };
        this.goBackConnectorList = () => {
            this.showConnectorListPage.emit();
        };
        this.toggleDropDown = (type) => {
            if (type == "connectorList") {
                this.showConnectorList = !this.showConnectorList;
            }
            else if (type == "importConnectorList") {
                this.showImportFromConnectorList = !this.showImportFromConnectorList;
                console.log('list to import from is ::', this.spacesConnectorImportAllowed);
            }
        };
        this.getConnectorNameUsingID = () => {
            this.cmxConnectorsService
                .getCMXConnectors()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data && data.length > 0) {
                    this.spacesConnectorList = data;
                    this.switchesList.forEach((switchEl) => {
                        this.spacesConnectorList.map((connector) => {
                            if (switchEl.connectorId == connector.id) {
                                switchEl["connectorName"] = connector.name;
                            }
                        });
                    });
                }
                this.dataService.display(false);
            }, (error) => {
                this.dataService.display(false);
                console.log("Connector list fetch error", error.status);
            });
        };
        this.getSpacesConnectors = () => {
            this.dataService.display(true);
            this.spacesConnectorImportAllowed = [];
            // this.copyHotspotConfig = true;
            this.cmxConnectorsService
                .getCMXConnectors()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data && data.length > 0) {
                    this.spacesConnectorList = data;
                    this.identifyConnectors_importFrom(this.spacesConnectorList);
                    /*this.spacesConnectorList.forEach((connector, index) => {
                      if (connector.version == "V3") {
                        this.spacesConnectorImportAllowed.push(connector);
                        if(connector.serviceDeployConfig && connector.serviceDeployConfig['hotspot']) { // "hotspot" service is enabled for this connector
                          connector.showHotSpotConfigCheck = true;
                        }
                      }
                    });*/
                }
                this.dataService.display(false);
            }, (error) => {
                this.dataService.display(false);
                console.log("Connector list fetch error", error.status);
            });
        };
        this.initializeSwitchObject = () => {
            this.connectorName = "-- Select --";
            this.switchObject["switchIp"] = null;
            this.switchObject["name"] = null;
            this.switchObject["connectorId"] = null;
            this.switchObject.login = {
                username: null,
                password: null
            };
            this.importFromConnector.name = '-- Select --';
        };
        this.connectorSelected = (connector) => {
            this.switchObject.connectorId = connector.id;
            this.connectorName = connector.name;
            //on each change of connector selection switch/reset import drop down and list selection;
            this.importFromConnector = { id: 0, name: "-- Select --" };
            this.deviceIdsToImport = [];
            this.listOfSwitches = [];
            this.selectAll = false;
        };
        this.validateIPAddress = () => {
            if (/^((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))$/.test(
            /*/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/*/
            this.switchObject.switchIp)) {
                if (this.switchModuleError == "Please enter a valid IP address") {
                    this.switchModuleError = "";
                }
                return true;
            }
            this.switchModuleError = "Please enter a valid IP address";
            return false;
        };
        this.togglePasswordDisplay = () => {
            this.showPassword = !this.showPassword;
            if (this.showPassword) {
                $("#passwordField").attr("type", "text");
            }
            else {
                $("#passwordField").attr("type", "password");
            }
        };
        this.switchAction = (action) => {
            if (!this.validateConfig(this.switchObject)) {
                this.dataService.setToastMessage(this.switchModuleError, 4000, null, null, "error");
            }
            else {
                this.dataService.display(true);
                if (!this.isEdit) {
                    this.cmxConnectorsService
                        .createSwitch(this.switchObject)
                        .pipe(takeUntil(this.unsubscribe$))
                        .subscribe((response) => {
                        if (response && response.status) {
                            this.dataService.display(false);
                            const message = this.messageKeys["createdSuccess"];
                            this.dataService.setToastMessage(message, 4000, null, null, "success");
                            this.getSwitchesList();
                            if (action == 1) {
                                this.locationNames = [];
                                this.preSelectedLocations = [];
                                this.closeSpacesModal();
                            }
                            else {
                                this.initializeSwitchObject();
                                this.switchObject.connectorId = this.switchConnector.id;
                            }
                        }
                        else {
                            this.dataService.display(false);
                            const message = this.messageKeys["createFail"];
                            this.dataService.setToastMessage(message, 4000, null, null, "error");
                        }
                    }, (error) => {
                        this.dataService.display(false);
                        const message = this.messageKeys["createFail"];
                        this.dataService.setToastMessage(message, 4000, null, null, "error");
                        console.log("ERROR:: Failed to create switch", error);
                    });
                }
                else {
                    this.cmxConnectorsService
                        .updateSwitch(this.switchObject.switchId, this.switchObject)
                        .pipe(takeUntil(this.unsubscribe$))
                        .subscribe((response) => {
                        if (response && response.status) {
                            this.dataService.display(false);
                            const message = this.messageKeys["confUpdate"];
                            this.dataService.setToastMessage(message, 4000, null, null, "success");
                            this.displaySection.popup = false;
                            this.getSwitchesList();
                            this.closeSpacesModal();
                        }
                        else {
                            this.dataService.display(false);
                            const message = this.messageKeys["confFail"];
                            this.dataService.setToastMessage(message, 4000, null, null, "error");
                        }
                        this.isEdit = false;
                        delete this.switchObject.switchId;
                    }, (error) => {
                        this.dataService.display(false);
                        const message = this.messageKeys["upFail"];
                        this.dataService.setToastMessage(message, 4000, null, null, "error");
                        console.log("ERROR:: Failed to update switch", error);
                    });
                }
            }
        };
        this.validateConfig = (config) => {
            this.switchModuleError = "";
            if (!config.connectorId) {
                this.switchModuleError = "Please select the connector";
                return false;
            }
            else if (!config.name) {
                this.switchModuleError = "Please enter the switch name";
                return false;
            }
            else if (!config.switchIp) {
                this.switchModuleError = "Please enter the switch ip";
                return false;
            }
            else if (!this.validateIPAddress()) {
                return false;
            }
            else if (!config.login.username) {
                this.switchModuleError = "Please enter the netconfig username";
                return false;
            }
            else if (!config.login.password) {
                this.switchModuleError = "Please enter the netconfig password";
                return false;
            }
            return true;
        };
        this.goBackToSetup = () => {
            if ((this.pageFrom = "spacesConnector")) {
                this.goBackConnectorList();
            }
            else {
                const navigateUrl = "/setup/wirednetwork";
                this.dataService.setCurrentNav(navigateUrl);
                this.router.navigate([navigateUrl]);
            }
        };
        this.openNewSwitchPopup = () => {
            this.dataService.openMagneticPopup();
            this.initializeSwitchObject();
            if ((this.pageFrom = "spacesConnector")) {
                this.connectorSelected(this.switchConnector);
            }
            this.displaySection.popup = true;
            this.importFromConnector = { id: 0, name: "-- Select --" };
            this.switchCreateType = { "name": "new", "value": "Add new switch" };
            this.selectAll = false;
            this.deviceIdsToImport = [];
        };
        this.editSwitch = (switchObj) => {
            this.dataService.openMagneticPopup();
            this.locationNames = [];
            this.isEdit = true;
            this.connectorName = switchObj.connectorName
                ? switchObj.connectorName
                : "-- Select --";
            this.switchObject["switchIp"] = switchObj.switchIp;
            this.switchObject["name"] = switchObj.name;
            this.switchObject["connectorId"] =
                switchObj.connectorId == -1 ? null : switchObj.connectorId;
            this.switchObject["switchId"] = switchObj.switchId;
            this.switchObject.login = {
                username: null,
                password: null
            };
            this.locationNames.push(switchObj.locationName);
            this.displaySection.popup = true;
        };
        this.deleteSwitchConfirm = (switchObj) => {
            this.dataService.openMagneticPopup();
            this.switchToDelete.name = switchObj.name;
            this.switchToDelete.id = switchObj.switchId;
            this.showHideConfirmation(true);
        };
        this.deleteSwitch = () => {
            this.dataService.display(true);
            //this.dataService.openMagneticPopup();
            this.cmxConnectorsService
                .deleteSwitch(this.switchToDelete.id)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response && response.status) {
                    this.dataService.display(false);
                    const message = this.messageKeys["delSuccess"];
                    this.dataService.setToastMessage(message, 4000, null, null, "success");
                    this.showHideConfirmation(false);
                    this.getSwitchesList();
                    this.closeSpacesModal();
                }
                else {
                    this.dataService.display(false);
                    const message = this.messageKeys["delFail"];
                    this.dataService.setToastMessage(message, 4000, null, null, "error");
                }
            }, (error) => {
                this.dataService.display(false);
                const message = this.messageKeys["delFail"];
                this.dataService.setToastMessage(message, 4000, null, null, "error");
                console.log("ERROR:: Failed to delete switch", error);
            });
        };
        this.getCurrentSwitchesItems = ($event) => {
            setTimeout(() => {
                this.currentSwitchItems = $event;
            }, 100);
        };
        this.clickEvents = ($event) => {
        };
        this.showHideConfirmation = (state) => {
            if (state != true) {
                this.dataService.closeMagneticPopup();
            }
            this.confirmationVisible = state;
            if (!state) {
                this.switchToDelete.name = null;
                this.switchToDelete.id = null;
            }
        };
        //C3
        this.switchCreationSelection = ($event) => {
            this.switchCreateType = this.switchCreateTypes[$event];
            this.toggleSaveButton();
            this.importFromConnector = { id: 0, name: "-- Select --" };
            this.deviceIdsToImport = [];
            this.listOfSwitches = [];
            this.selectAll = false;
            this.identifyConnectors_importFrom(this.spacesConnectorList);
        };
        this.connectorImportFromSelected = (connector) => {
            this.dataService.display(true);
            this.importFromConnector.id = connector.id;
            this.importFromConnector.name = connector.name;
            this.importFromConnector.showHotSpotConfigCheck = connector.showHotSpotConfigCheck;
            this.deviceIdsToImport = [];
            this.disableImportButton = true;
            this.listOfSwitches = [];
            const tempList = [];
            this.fullSwitchList.forEach((switchObj) => {
                if (switchObj.connectorId == connector.id) {
                    tempList.push(switchObj);
                }
            });
            this.listOfSwitches = tempList;
            this.dataService.display(false);
        };
        this.selectAll = false;
        this.selectAllSwitches = () => {
            this.deviceIdsToImport = [];
            if (this.selectAll === true) {
                this.listOfSwitches.forEach((controller) => {
                    controller.selected = true;
                    this.deviceIdsToImport.push(controller.switchId);
                });
            }
            else {
                this.listOfSwitches.forEach((controller) => {
                    controller.selected = false;
                });
            }
        };
        this.selectThisSwitch = (thisController) => {
            if (thisController.selected == true) {
                //remove this id from deviceIdsToimport;
                this.deviceIdsToImport.push(thisController.switchId);
            }
            else {
                const index = this.deviceIdsToImport.indexOf(thisController.switchId);
                if (index > -1) {
                    this.deviceIdsToImport.splice(index, 1);
                }
                //make this id as true
            }
            if (this.deviceIdsToImport.length === this.listOfSwitches.length) {
                this.selectAll = true;
            }
            else {
                this.selectAll = false;
            }
        };
        this.importSwitch = (fromConnector, toConnector, deviceIdsToImport) => {
            this.dataService.display(true);
            this.cmxConnectorsService.importSwitchesForConnector(fromConnector, toConnector, deviceIdsToImport)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response && response.status) {
                    this.dataService.setToastMessage(response.data.message, 4000, null, null, "success");
                    this.displaySection.popup = false;
                    this.getSwitchesList();
                }
                else {
                    this.dataService.setToastMessage(response.data.message, 8000, null, null, "error");
                }
                this.dataService.display(false);
            });
        };
        this.identifyConnectors_importFrom = (connectorList) => {
            var hotspotVersion2List = [];
            this.dataService.display(true);
            this.spacesConnectorImportAllowed = [];
            var found;
            this.cmxConnectorsService
                .getHotspotList()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.data !== "" && response.data !== null) {
                    hotspotVersion2List = response.data;
                    connectorList.forEach(connector => {
                        if (connector.version !== 'V3' && this.switchObject.connectorId && this.switchObject.connectorId !== connector.id) {
                            found = hotspotVersion2List.find((hs) => hs.id === connector.id);
                            if (found) {
                                connector.showHotSpotConfigCheck = true;
                            }
                            this.spacesConnectorImportAllowed.push(connector);
                            found = undefined;
                        }
                        /* hotspotVersion2List.forEach(hotspotConnector =>{
                         if (connector.version !== 'V3' &&
                         this.controllerObj.connectorId && this.controllerObj.connectorId !== connector.id) {
                           if(hotspotConnector.id == connector.id){
                             connector.showHotSpotConfigCheck = true;
                           }
                           this.spacesConnectorImportAllowed.push(connector);
                         }
                       });*/
                        if (connector.version == 'V3' &&
                            this.switchObject.connectorId && this.switchObject.connectorId !== connector.id) {
                            if (connector.serviceDeployConfig && connector.serviceDeployConfig['hotspot']) { // "hotspot" service is enabled for this connector
                                connector.showHotSpotConfigCheck = true;
                            }
                            this.spacesConnectorImportAllowed.push(connector);
                        }
                    });
                }
                else {
                    connectorList.forEach(connector => {
                        if (connector.version !== 'V3') {
                            if (this.switchObject.connectorId && this.switchObject.connectorId !== connector.id) {
                                this.spacesConnectorImportAllowed.push(connector);
                            }
                        }
                        if (connector.version == 'V3') {
                            if (connector.serviceDeployConfig && connector.serviceDeployConfig['hotspot'] &&
                                this.switchObject.connectorId && this.switchObject.connectorId !== connector.id) { // "hotspot" service is enabled for this connector
                                connector.showHotSpotConfigCheck = true;
                            }
                            this.spacesConnectorImportAllowed.push(connector);
                        }
                    });
                }
                this.dataService.display(false);
            });
        };
        this.toggleSaveButton = () => {
            if (this.switchCreateType.name == 'import') {
                if (this.switchObject.connectorId && this.importFromConnector.id && this.deviceIdsToImport.length > 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
        };
        this.toggleLocationPopUp = () => {
            this.showLocationPopUp = !this.showLocationPopUp;
        };
        this.cancelLocationPopup = () => {
            this.toggleLocationPopUp();
        };
        this.fromLocationPopUp = (list) => {
            console.log("The selected locations :: " + list);
            if (list.length > 0) {
                if (list[0].displayField != undefined) {
                    this.getLocationIds(list, 1);
                }
                else if (list[0].data) {
                    this.getLocationIds(list, 2);
                }
            }
            else {
                this.preSelectedLocations = [];
            }
            this.toggleLocationPopUp();
            // todo: need to set locations
        };
        this.getLocationIds = (data, mode) => {
            if (data != null) {
                let locations = [];
                let locationNames = [];
                this.preSelectedLocations = [];
                if (mode == 1) {
                    for (var i = 0; i < data.length; i++) {
                        locations.push(data[i].id);
                        locationNames.push(data[i].displayField);
                        console.log("The Location Names: ", locationNames);
                        this.switchObject.locationId = data[i].id;
                        this.switchObject.locationName = data[i].displayField;
                        this.preSelectedLocations[i] = {
                            "data": {
                                "id": data[i].id,
                                "mongoLocId": data[i].data.mongodbLocId == undefined ? 0 : +data[i].data.mongodbLocId,
                                "name": data[i].displayField
                            }
                        };
                    }
                }
                else if (mode == 2) {
                    for (var i = 0; i < data.length; i++) {
                        locations.push(data[i].data.id);
                        locationNames.push(data[i].data.name);
                        this.switchObject.locationId = data[i].id;
                        this.switchObject.locationName = data[i].displayField;
                        this.preSelectedLocations[i] = {
                            "data": {
                                "id": data[i].data.id,
                                "mongoLocId": data[i].data.mongodbLocId == undefined ? 0 : +data[i].data.mongodbLocId,
                                "name": data[i].data.name
                            }
                        };
                    }
                }
            }
        };
        this.removeSelectedLocation = (node) => {
            var existingNodeId = null;
            var index = null;
            existingNodeId = this.preSelectedLocations.filter(function (n, i) {
                if (n.data.id === node.data.id) {
                    index = i;
                    return i;
                }
            });
            if (index !== null) {
                this.preSelectedLocations.splice(index, 1);
            }
            else {
                this.preSelectedLocations.push(node);
            }
        };
        this.doCopyHotspotConfig = () => {
            this.copyHotspotConfig = !this.copyHotspotConfig;
        };
        this.initializeSwitchObject();
    }
    //C3
    ngOnInit() {
        if (location.pathname.indexOf("setup/switches") > -1 ||
            location.pathname.indexOf("setup/wirednetwork/connectors") > -1 ||
            location.pathname.indexOf("setup/connectors") > -1 ||
            this.pageFrom == "connectro3.0" //iot-wired
        ) {
            this.getSpacesConnectors();
            this.getSwitchesList();
            this.displaySection.list = true;
        }
        else {
            this.getSpacesConnectors();
            this.displaySection.popup = true;
        }
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
CmxConnectorSwitchesComponent.ɵfac = function CmxConnectorSwitchesComponent_Factory(t) { return new (t || CmxConnectorSwitchesComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(CMXConnectorsService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.TranslateService)); };
CmxConnectorSwitchesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CmxConnectorSwitchesComponent, selectors: [["lib-cmx-connector-switches"]], inputs: { type: "type", modalTitle: "modalTitle", pageFrom: "pageFrom", switchConnector: "switchConnector" }, outputs: { closeModal: "closeModal", showConnectorListPage: "showConnectorListPage", showSwitchCount: "showSwitchCount" }, decls: 14, vars: 10, consts: [["class", "modalPopup modalPopupLg connectorPopup", 4, "ngIf"], ["class", "confirmation-popup-wrapper", 4, "ngIf"], [1, "subHeader"], [1, "headerSection"], ["id", "btn-connector-create", 1, "addUuidDiv", "createConnector", 3, "click"], ["src", "/assets/images/add.svg", "width", "20"], [1, "connector-table"], ["class", "emptyStateHeading", 4, "ngIf"], ["class", "userTableContainer", 4, "ngIf"], [1, "modalPopup", "modalPopupLg", "connectorPopup"], ["class", "modalContent-connector", "id", "modalContent", 4, "ngIf"], ["id", "modalContent", 1, "modalContent-connector"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], [1, "modalbodyWrapper"], ["class", "fieldWrapper error", 4, "ngIf"], [1, "fieldWrapper", "clear"], [1, "fieldLabel"], [4, "ngIf"], ["class", "select-menu select-custom-2", 3, "ngClass", "click", 4, "ngIf"], [1, "clear", 3, "ngClass"], [1, "selector-tab", "fieldWrapper", "clear", "flex-b"], [1, "selector"], [1, "pmxRadio"], ["type", "radio", "value", "Add new switch", "name", "value", 1, "pmxRadioButton", "ac-radio", 3, "ngModel", "ngModelChange"], ["for", "accessOption", 1, "pmxRadioButtonLabel", "ac-radio-label"], [1, "ac-sel-header"], [2, "font-size", "10px"], ["type", "radio", "value", "Choose switch from another connector", "name", "value", 1, "pmxRadioButton", "ac-radio", 3, "ngModel", "ngModelChange"], ["class", "clear", 4, "ngIf"], [1, "modalFooter"], ["class", "commonButton", 3, "ngClass", "click", 4, "ngIf"], [1, "fieldWrapper", "error"], ["type", "text", 1, "portalNameInput", "disabledElement", 2, "width", "auto", 3, "value"], [1, "select-menu", "select-custom-2", 3, "ngClass", "click"], [1, "select-item", "first"], ["class", "select-item-container", 4, "ngIf"], [1, "select-item-container"], [4, "ngFor", "ngForOf"], [1, "select-item", 3, "click"], [1, "clear"], [1, "fieldWrapper"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter Switch name", 1, "portalNameInput", 3, "ngModel", "value", "ngModelChange"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter Switch IP", 1, "portalNameInput", 3, "ngModel", "value", "blur", "ngModelChange"], ["type", "text", "autofocus", "autofocus", 1, "portalNameInput", 3, "placeholder", "ngModel", "value", "ngModelChange"], [1, "password-wrapper"], ["id", "passwordField", "type", "password", "autofocus", "autofocus", 1, "portalNameInput", 3, "placeholder", "ngModel", "value", "ngModelChange"], ["id", "passwordWrapper", 1, "show-password-wrapper", 3, "click"], ["src", "/assets/images/basic/password_switch.svg", "width", "30"], [3, "innerHTML"], [1, "locationSelection", "am-block"], ["class", "locationSelectionSection", 4, "ngIf"], ["class", "locationSelectionContainer", 4, "ngIf"], [1, "locationSelectionSection"], [1, "selectedLocations"], [1, "selectedLocationsList"], ["class", "labelChip", 4, "ngFor", "ngForOf"], [1, "addLocationButton"], [1, "commonButton", "commonAddButton", "addButton", 3, "click"], ["class", "userLocationPopup", 4, "ngIf"], ["class", "labelName", 4, "ngIf"], [1, "labelName"], ["style", "display: inline-block;margin-top: 10px;", 4, "ngFor", "ngForOf"], [2, "display", "inline-block", "margin-top", "10px"], [1, "labelChip"], [1, "labelClose", 3, "click"], [1, "userLocationPopup"], [3, "ngModel", "preSelectLocation", "multiLocationSelect", "ngModelChange", "selectLocationPopupEvt"], [1, "locationSelectionContainer"], [1, "showDiv-on-Mousehover"], [1, "modalContent-beta"], [1, "beta-popup-div"], [1, "popup-title-div"], [1, "popup-title"], [1, "tooltip", "moreText"], ["src", "/assets/images/basic/lock.svg", 1, "tooltip-p"], [1, "tooltiptext"], [1, "toolTipBody"], ["style", "display: inline-block;margin-top: 10px;", 4, "ngFor", "ngForOf", "ngForFirst"], ["class", "fieldWrapper clear", 4, "ngIf"], ["class", "table-wrapper fieldWrapper clear", 4, "ngIf"], ["class", "select-item-container webexListContainer", 4, "ngIf"], [1, "select-item-container", "webexListContainer"], ["class", "hover", 4, "ngFor", "ngForOf"], [1, "hover"], ["class", "select-item", 3, "ngClass", "click", 4, "ngIf"], [1, "select-item", 3, "ngClass", "click"], [1, "table-wrapper", "fieldWrapper", "clear"], ["id", "normal-active", 1, "table-box", "selectable"], [1, "table-header"], [1, "w10", "pl20"], [1, "circularCheckbox"], ["type", "checkbox", "name", "accessCodeSelectCheckbox", "id", "selectAllSwitches", 3, "ngModel", "ngModelChange", "change"], ["for", "selectAllSwitches", 1, "checkboxLabel", 3, "ngClass"], ["noAllCheckBox", ""], [1, "w10", "headerAlign"], [1, "th-text"], ["class", "table-tr", 4, "ngFor", "ngForOf"], ["type", "checkbox", "disabled", "", 3, "ngModel", "ngModelChange"], [1, "checkboxLabel", "disabledElement"], [1, "table-tr"], [1, "w10", "pl20", "activeStatusColumn"], ["type", "checkbox", "name", "selectCheckboxController", 1, "checkboxStatusTD", 3, "ngModel", "id", "checked", "ngModelChange", "change"], [1, "checkboxLabel", 3, "for"], ["noCheckBox", ""], [1, "w10", "pl20", "activeColumn"], ["type", "checkbox", 3, "ngModel", "ngModelChange"], [1, "commonButton", 3, "ngClass", "click"], [1, "confirmation-popup-wrapper"], [1, "popup-overlay"], [1, "confirmation-popup"], [1, "exclamation-icon"], ["src", "/assets/images/notification_icon.svg", "width", "70", "alt", "exclamation-icon"], [1, "confirmation-popup-close", 3, "click"], [1, "confirmation-message"], [1, "confirmation-button-wrapper"], [1, "confirmation-primary-button", 3, "click"], [1, "confirmation-cancel", 3, "click"], [1, "emptyStateHeading"], [1, "divTable"], [1, "divTableRow"], [1, "divTableCell"], ["src", "/assets/images/setupConnector/not_configured.svg", 1, "image-img"], [1, "userTableContainer"], ["class", "table userTable", 4, "ngIf"], [1, "pagination-div"], [3, "pagesToShow", "perPage", "page", "loading", "items", "clickEvent", "currentPage"], ["class", "emptyState", 4, "ngIf"], [1, "table", "userTable"], [1, "tableTr", "textUppercase"], [1, "name"], [1, "action"], ["class", "tableTr", 4, "ngFor", "ngForOf"], [1, "tableTr"], [1, "userListLabel"], [1, "userActionsMenu"], ["href", "javascript:void(0)", 1, "userEditIcon", "tool-tip-css", 3, "click"], ["src", "/assets/images/setupConnector/edit.svg", "alt", ".", "width", "18"], ["href", "javascript:void(0)", 1, "userDeleteIcon", "tool-tip-css", 3, "click"], ["src", "/assets/images/setupConnector/delete.svg", "alt", ".", "width", "13"], [1, "emptyState"]], template: function CmxConnectorSwitchesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CmxConnectorSwitchesComponent_div_0_Template, 2, 1, "div", 0);
        i0.ɵɵtemplate(1, CmxConnectorSwitchesComponent_div_1_Template, 19, 10, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵtext(4);
        i0.ɵɵpipe(5, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵlistener("click", function CmxConnectorSwitchesComponent_Template_div_click_6_listener() { return ctx.openNewSwitchPopup(); });
        i0.ɵɵelement(7, "img", 5);
        i0.ɵɵelementStart(8, "span");
        i0.ɵɵtext(9);
        i0.ɵɵpipe(10, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 6);
        i0.ɵɵtemplate(12, CmxConnectorSwitchesComponent_div_12_Template, 11, 6, "div", 7);
        i0.ɵɵtemplate(13, CmxConnectorSwitchesComponent_div_13_Template, 5, 7, "div", 8);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.displaySection.popup);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.confirmationVisible);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 6, "dashboard-lib.setup.connectorSwitches.switches"));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 8, "dashboard-lib.setup.connectorSwitches.add"), "");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.switchesList !== undefined && ctx.switchesList.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.switchesList && ctx.switchesList.length > 0);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i2$1.RadioControlValueAccessor, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$2.NgForOf, LocationPopupComponent, i2$1.CheckboxControlValueAccessor, PaginationComponent], pipes: [i2.TranslatePipe, i1$2.DatePipe], styles: [".modalPopup.connectorPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:calc(100vh - 180px);overflow-y:auto;padding-bottom:50px;transition:.5s ease}.modalPopup[_ngcontent-%COMP%] > .modalContent-connector[_ngcontent-%COMP%]{width:45%;right:0;height:100%;z-index:1001;position:absolute;top:0px;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #abc233;animation:slide .5s forwards}@keyframes slide{65%{right:0}}.modalPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0 30px;color:#545454;font-size:26px;height:100px;line-height:100px}.modalPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{align-items:center;background-color:#ffffffe6;z-index:9999}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{padding:0 30px}.select-menu[_ngcontent-%COMP%]{height:30px;min-width:100px;padding-left:0;border-bottom:1px solid #ddd;background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_down.svg) no-repeat right center;float:left;margin:0 10px;cursor:pointer}.select-menu[_ngcontent-%COMP%]   .first[_ngcontent-%COMP%]{padding:5px 10px;z-index:2;width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:inline-block;box-sizing:border-box;max-width:200px}.select-menu[_ngcontent-%COMP%]{background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_up.svg) no-repeat right center;font-size:14px}.menuActive[_ngcontent-%COMP%]{background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_down.svg) no-repeat right center!important}.fieldLabel[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans}.fieldLabel[_ngcontent-%COMP%], .fieldWrapper[_ngcontent-%COMP%]{padding:8px 0}.fieldLabel[_ngcontent-%COMP%]{padding-bottom:3px}.success[_ngcontent-%COMP%]{color:green}.error[_ngcontent-%COMP%]{color:#f86969}.warning[_ngcontent-%COMP%]{color:#efa741}.select-item[_ngcontent-%COMP%]{padding:10px;font-family:\"ciscoSansLight\"}.select-item-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:not(.first):hover{background:#DFDFDF;color:#000}.select-item-container[_ngcontent-%COMP%] > .selected[_ngcontent-%COMP%]{display:none}.select-item[_ngcontent-%COMP%]   .first[_ngcontent-%COMP%]{cursor:pointer}.select-custom-2[_ngcontent-%COMP%]{width:350px!important;margin:10px 0!important;font-size:15px;border-bottom:1px solid #c5c3c3!important}.modalbodyWrapper[_ngcontent-%COMP%]{width:90%}.select-item-container[_ngcontent-%COMP%]{width:100%;border:1px solid #ddd;background:#ffffff;max-height:150px;overflow:auto;position:relative;z-index:999;margin-bottom:40px;bottom:6px;border-top:1px solid #079fd9}.select-item-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:hover{background:#DFDFDF;color:#000}.commonButton[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;border:none;border-radius:5px}.commonButton[_ngcontent-%COMP%]:hover{background-color:#049fd9!important;color:#fff!important;opacity:.8}input[type=text][_ngcontent-%COMP%], input[type=password][_ngcontent-%COMP%]{padding:10px 0!important;margin-bottom:8px!important;border-bottom:1px solid #c5c3c3;width:335px}.password-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;flex-direction:row}.show-password-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;padding:4px 0;border-bottom:1px solid #c5c3c3;align-items:center;cursor:pointer}.show-password-wrapper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(1){margin-right:5px;width:17px}.show-password-wrapper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(1):hover{opacity:.8;transition:all .3s ease-in;transition-delay:.2s}.show-password-wrapper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(2){font-size:11px;font-family:ciscoSans;color:#049fd9;font-weight:normal;letter-spacing:.4px;width:35px}.show-password-wrapper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(2):hover{opacity:.8;transition:all .2s ease-in;transition-delay:.1s}.userCheckbox[_ngcontent-%COMP%]{position:relative;bottom:13px}.circularCheckbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]{position:relative!important;top:25px;left:-5px}.circularCheckbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]{opacity:0;height:20px;width:20px;position:absolute;z-index:3;cursor:pointer}input[type=text][_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.certify-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:flex-end}.certify-wrapper[_ngcontent-%COMP%]   .list-header-text[_ngcontent-%COMP%]{font-size:14px;font-family:\"ciscoSans\";color:#3e3e3e}.secondaryButton[_ngcontent-%COMP%]{padding:5px 0;width:100px;font-size:13px;display:flex;align-items:center;justify-content:center;margin:0 auto;color:#049fd9;border:1px solid #049fd9;border-radius:5px!important;position:relative;right:95px;top:10px}.secondaryButton[_ngcontent-%COMP%]:hover{opacity:.8}.cmxSwitchListWrapper[_ngcontent-%COMP%]{padding:30px 100px;margin:0}.cmxControllerAdd[_ngcontent-%COMP%]{display:block;margin:0 0 30px}.cmxControllerHeading[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";font-size:16px;color:#4d4d4d;display:inline-block;margin-top:10px}.addControllerDiv[_ngcontent-%COMP%]{float:right;clear:right}.controllerTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .controllerTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:30%;padding-left:35px}.table.controllerTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.controllerTable[_ngcontent-%COMP%]   th.name[_ngcontent-%COMP%], .controllerTable[_ngcontent-%COMP%]   td.name[_ngcontent-%COMP%]{width:40%}.controllerTable[_ngcontent-%COMP%]   th.action[_ngcontent-%COMP%], .controllerTable[_ngcontent-%COMP%]   td.action[_ngcontent-%COMP%]{width:100%}.controllerTable[_ngcontent-%COMP%]   td.action[_ngcontent-%COMP%]{display:block}.controllerTable[_ngcontent-%COMP%]   th.aps[_ngcontent-%COMP%], .controllerTable[_ngcontent-%COMP%]   td.aps[_ngcontent-%COMP%]{width:8%}.controllerTable[_ngcontent-%COMP%]   th.status[_ngcontent-%COMP%], .controllerTable[_ngcontent-%COMP%]   td.status[_ngcontent-%COMP%]{width:12%}.controllerTable[_ngcontent-%COMP%]   th.date[_ngcontent-%COMP%], .controllerTable[_ngcontent-%COMP%]   td.date[_ngcontent-%COMP%]{width:16%}.controllerTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%]{text-align:center;display:none;width:115px}.controllerTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   .userActionsMenu[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-evenly}.controllerTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative;padding:0 7px;text-decoration:none;outline:none}.disableOverlay[_ngcontent-%COMP%]{cursor:not-allowed;pointer-events:none;opacity:.4;-webkit-user-select:none;user-select:none}.confirmation-popup-wrapper[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:99999;left:0;top:0}.popup-overlay[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:999999;background-color:#0009}.confirmation-popup[_ngcontent-%COMP%]{position:absolute;top:33%;left:50%;transform:translate(-50%);width:33%;height:30%;margin:0 auto;background-color:#fff;box-shadow:0 4px 8px #0000001a;border:0;z-index:1001;display:flex;justify-content:center;flex-direction:column;border-radius:5px}.confirmation-button-wrapper[_ngcontent-%COMP%]{margin:0 auto;width:40%;display:flex;justify-content:space-around;align-items:center}.confirmation-primary-button[_ngcontent-%COMP%]{border-radius:1.3em;background-color:#09c;color:#fff;font-family:ciscoSansLight;padding:0 18px;font-size:14px;height:34px;line-height:34px;cursor:pointer;float:left}.confirmation-primary-button[_ngcontent-%COMP%]:hover{opacity:.8}.confirmation-cancel[_ngcontent-%COMP%]{color:#848484!important;font-size:14px;text-decoration:none;cursor:pointer;line-height:30px;font-family:\"ciscoSansRegular\"}.confirmation-cancel[_ngcontent-%COMP%]:hover{font-weight:bold}.confirmation-popup-close[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.confirmation-popup-close[_ngcontent-%COMP%]:hover{opacity:.8}.exclamation-icon[_ngcontent-%COMP%]{min-height:70px;min-width:70px;text-align:center;padding:0;position:absolute;left:50%;transform:translate(-50%);top:-20%;border:5px solid #fff;border-radius:50%;background:#fff;box-shadow:0 0 2px #84848480}.confirmation-message[_ngcontent-%COMP%]{text-align:center;padding:25px 0;font-size:15px;display:block;width:82%;margin:0 auto;color:#848484;font-family:\"ciscoSansRegular\"}.subHeader[_ngcontent-%COMP%]{padding:30px 0 15px 65px;font-size:20px;margin-right:60px}.connector-table[_ngcontent-%COMP%]{background:#FFFFFF;height:auto;margin:0 65px 50px 60px}.headerSection[_ngcontent-%COMP%]{font-size:18px!important;font-family:\"ciscoSansRegular\";color:#4d4d4d}.info-icon[_ngcontent-%COMP%]{width:20px;height:20px;display:inline-block;cursor:pointer;text-align:center}.btn-connector-create[_ngcontent-%COMP%]{font-size:14px}.emptyStateHeading[_ngcontent-%COMP%]{padding:20px;font-size:14px;font-family:\"ciscoSansRegular\";background:#FFFF;display:inline-block}.userTableContainer[_ngcontent-%COMP%]{overflow-y:auto}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{padding-left:33.8px}.table.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:434px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:14px;line-height:20px;letter-spacing:.5px}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%]{text-align:center;display:none;width:115px}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   div.userActionsMenu[_ngcontent-%COMP%]{display:inline}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover{background:#ebf7f9!important}.userTable[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]:hover{background:#fff!important}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   div.userActionsMenu.selected[_ngcontent-%COMP%]{display:block}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative;padding:0 5px;text-decoration:none;outline:none}.pagination-div[_ngcontent-%COMP%]{padding:8px}.addUuidDiv[_ngcontent-%COMP%]{float:right;clear:right;font-size:16px;font-family:ciscoSansRegular;color:#049fd9;cursor:pointer}.createConnector[_ngcontent-%COMP%]{font-size:14px;float:right;font-family:\"ciscoSansRegular\";color:#07a0d9}.table-box[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd){background:#fff}.table-box[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(even){background:#f9f9f9}.table-box[_ngcontent-%COMP%]{display:table;width:100%;border-bottom:1px solid #dee0e1;border-spacing:0;box-shadow:0 0 5px #0000001a;font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:14px;line-height:20px;letter-spacing:.5px}.table-header[_ngcontent-%COMP%]{background:#fff;border-bottom:1px solid #dee0e1}.vertical-seperator[_ngcontent-%COMP%]{height:20px;background:#acacac;width:1px;display:inline-block}.th-text-date[_ngcontent-%COMP%]{left:30px!important}.last-td[_ngcontent-%COMP%]{font-size:13px!important}.w25[_ngcontent-%COMP%]{width:25%}.w18[_ngcontent-%COMP%]{width:18%}.w20[_ngcontent-%COMP%]{width:20%}.w15[_ngcontent-%COMP%]{width:15%}.w11[_ngcontent-%COMP%]{width:11%}.w5[_ngcontent-%COMP%]{width:5%}.w10[_ngcontent-%COMP%]{width:10%}.w12[_ngcontent-%COMP%]{width:10%}.pl20[_ngcontent-%COMP%]{padding-left:30px}.deleteCheckbox[_ngcontent-%COMP%]{position:relative;top:-12px;vertical-align:middle;padding-right:30px;display:inline-block}.partial-select[_ngcontent-%COMP%]{border:1px solid #039fd9;width:16px;height:16px}.partial-select[_ngcontent-%COMP%]:before{background:#039fd9!important;top:2px!important;left:2px!important;height:10px!important;width:10px!important}.checkboxStatusTD[_ngcontent-%COMP%]{margin-top:10px}.table-wrapper[_ngcontent-%COMP%]{width:75%;margin:0 auto}.th-text[_ngcontent-%COMP%]{display:inline-block;position:relative;left:15px}.activeColumn[_ngcontent-%COMP%]{padding-left:15px!important}.hover[_ngcontent-%COMP%]{position:relative}.toolTip[_ngcontent-%COMP%]{position:absolute;color:#000;bottom:calc(100% - 38px);left:-6.4em;transform:translateY(-50%);width:auto;height:auto;min-width:240px;background-color:#fff;padding:10px;display:none;font-size:14px;border-radius:4px;filter:drop-shadow(0px 0px 1px #b2b2b2)}.toolTip[_ngcontent-%COMP%]:after{position:absolute;left:41%;bottom:-1em;transform:translateY(-50%);width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-top:10px solid #fff;content:\"\"}.hover[_ngcontent-%COMP%]:hover   .toolTip[_ngcontent-%COMP%]{display:block}.toolTipHeading[_ngcontent-%COMP%]{font-family:ciscoSansThin;font-size:16px;color:#000;padding-bottom:5px;font-weight:bold}.tooltip-desc[_ngcontent-%COMP%]{font-size:13px}.showDiv-on-Mousehover[_ngcontent-%COMP%]{background-color:#777;position:sticky;bottom:auto;top:auto;width:340px;height:auto;padding:5px;border:1px solid #DFDFDF;box-shadow:0 4px 8px #0000001a;border-radius:2px;z-index:10;width:380px;color:#4d4d4d}.modalBody1[_ngcontent-%COMP%]{margin:0;cursor:pointer;opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]{display:flex;height:115px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 10px 10px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:12px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .modalBody1[_ngcontent-%COMP%]:hover{opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]{width:100%;border-top:1px solid #b2a6a6;text-align:center;padding-top:5px}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]   .popup-footer-text[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:13px;color:#fff}.headerAlign[_ngcontent-%COMP%]{text-align:left}.selectable[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{border-bottom:1px solid #DEDEDE;box-shadow:0 1px 3px #00000040;height:45px}.selectable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd){background:none!important;height:45px}.selectable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(even){background:none!important;height:45px}.circularCheckbox[_ngcontent-%COMP%]   .checkboxLabel[_ngcontent-%COMP%]{margin-left:20px;top:-7px}.table[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]{border-bottom:2px solid #dfdfdf!important}.table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]{border-bottom:1px solid #dfdfdf}.table-tr[_ngcontent-%COMP%]{border-bottom:1px solid #dfdfdf}.table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(even){background-color:#fff!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmxConnectorSwitchesComponent, [{
        type: Component,
        args: [{
                selector: "lib-cmx-connector-switches",
                templateUrl: "./cmx-connector-switches.component.html",
                styleUrls: ["./cmx-connector-switches.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: CMXConnectorsService }, { type: i1.Router }, { type: i2.TranslateService }]; }, { type: [{
            type: Input
        }], modalTitle: [{
            type: Input
        }], closeModal: [{
            type: Output
        }], showConnectorListPage: [{
            type: Output
        }], showSwitchCount: [{
            type: Output
        }], pageFrom: [{
            type: Input
        }], switchConnector: [{
            type: Input
        }] }); })();

class ChartRangeSelector {
    constructor() {
        this.size = 100;
        this.serieType = "column";
        this.padding = { top: 10, bottom: 0 };
        this.backgroundColor = "#fff";
        this.showGridLines = false;
        this.columnsGapPercent = 100;
    }
}
class ChartBand {
    constructor() {
        this.minValue = 0;
        this.maxValue = 0;
        this.fillColor = "#FF0000";
        this.lineWidth = 1;
        this.dashStyle = "0";
    }
}
class Annotations {
    constructor() {
        this.yValue = 0;
        this.xValue = 0;
        this.offset = { x: 0, y: 0 };
        this.text = {
            value: "",
            offset: {
                x: 2,
                y: 2
            },
            fillColor: "",
            class: "redLabel",
            angle: 0
        };
    }
}

class XAxis {
    constructor() {
        this.displayText = null;
        this.visible = true;
        this.angle = 0;
        this.type = "default";
        this.dateFormat = "d MMM";
        this.baseUnit = "month";
        this.showGridLines = false;
        this.gridLinesColor = "transparent";
        this.title = { visible: false };
        this.labels = { visible: true };
        this.showRangeSelector = false;
        this.rangeSelector = new ChartRangeSelector();
        this.sufix = null;
    }
    setFields(dataField, angle) {
        this.dataField = dataField;
        this.angle = angle;
        return this;
    }
    setDataField(dataField) {
        this.dataField = dataField;
        return this;
    }
}

class YAxis {
    constructor() {
        this.visible = true;
        this.showGridLines = true;
        this.gridLinesColor = "#cacaca";
        this.gridLines = { color: "#cacaca", dashStyle: "0,0" };
        this.minValue = 0;
        this.title = { visible: false };
        this.labels = { visible: true, class: "yAxisLabels" };
        this.pureValue = false;
    }
}

class LineChart {
    constructor() {
        this.padding = { left: 0, top: 10, right: 10, bottom: 0 };
        this.sourceData = [];
        this.series = [];
        this.title = "";
        this.chartUpdate = true;
        this.showLegend = false;
        this.units = null;
        this.height = 400;
        this.xAxis = new XAxis();
        this.yAxis = new YAxis();
        this.showThreshold = false;
        this.threshold = new ChartBand();
        this.thresholds = [];
        this.showLineMarker = false;
        this.showAnnotation = false;
        this.annotations = new Annotations();
    }
}
class DonutChart {
    constructor() {
        this.sourceData = [];
        this.innerText = "";
        this.height = "300";
        this.width = "auto";
        this.colors = [];
        this.innerTextOffsetX = 2;
        this.innerTextOffsetY = 0;
        this.showLabels = false;
        this.chartUpdate = true;
    }
}
class BarChart {
    constructor() {
        this.sourceData = [];
        this.series = [];
        this.seriesGroups = [];
        this.colors = [];
        this.defaultColor = "#00bf9a";
        this.height = 300;
        this.chartUpdate = true;
        // this.columnsGapPercent = 60;
        // this.seriesGapPercent = 4
        this.type = "stackedcolumn";
        this.width = "'auto'";
        this.xAxis = new XAxis();
        this.yAxis = new YAxis();
        this.showToolTips = true;
        this.backgroundColor = "#fff";
        this.labels = {
            visible: false,
            verticalAlignment: "top",
            offset: { x: 0, y: -20 }
        };
        this.showThreshold = false;
        this.threshold = new ChartBand();
        this.thresholds = [];
        this.columnSeriesOverlap = false;
        this.multiStackedBar = false;
        this.hideXAxisLabelByIndex = [];
        this.adjustBarWithIndexList = [];
        this.adjustLocBarWidth = [];
        this.showAnnotation = false;
        this.annotations = new Annotations();
    }
}

class ChartSeriesGroup {
    constructor() {
        this.type = "column";
        this.columnsGapPercent = 25;
        this.columnsMaxWidth = 90;
        this.seriesGapPercent = 10;
        this.useGradientColors = false;
        this.series = [];
    }
    setType(type) {
        this.type = type;
        return this;
    }
}
class ChartSeries {
    constructor() {
        this.labelRadius = 40;
        this.initialAngle = 15;
        this.radius = 30;
        this.innerRadius = 27;
        this.centerOffset = 0;
        this.useGradientColors = false;
        this.enableSelection = false;
        this.type = "line";
        this.formatPureValue = false;
        this.opacity = 1;
        this.formatSettings = null;
    }
    setFields(dataField, displayText, color) {
        this.dataField = dataField;
        this.displayText = displayText;
        this.color = color;
        return this;
    }
    setOpacity(opacity) {
        this.opacity = opacity;
        return this;
    }
    setType(type) {
        this.type = type;
        return this;
    }
    setBorderAndOpacity(opacity, lineColor) {
        this.opacity = opacity;
        this.lineColor = lineColor;
        return this;
    }
}

const transformToSIUnit = (num) => {
    const units = ["", "K", "M", "B", "T", "Qd", "Qt"];
    if (!num) {
        return `0`;
    }
    else if (1e3 > num) {
        // for numbers less than to 1k
        return `${num}`;
    }
    const i = Math.floor(Math.log(num) / Math.log(1000));
    return `${(+(num / Math.pow(1000, i)).toFixed(1)).toLocaleString()}${units[i]}`;
};
const transformToDataUnit = (bytes) => {
    const sizes = ["B", "KB", "MB", "GB", "TB", "PB"];
    if (!bytes || 0 === bytes) {
        return `0`;
    }
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
    if (0 >= i) {
        return `${(+bytes.toFixed(2)).toLocaleString()}${sizes[0]}`;
    }
    return `${(+(bytes / (Math.pow(1024, i))).toFixed(2)).toLocaleString()}${sizes[i]}`;
};
const YAxisTickFormatter = {
    SI: transformToSIUnit,
    Floating_Number: d3.format(".2f"),
    Date: d3.timeFormat("%Y-%m-%d"),
    Day: d3.timeFormat("%d %a"),
    Time: d3.timeFormat("%H:%M %p"),
    Data: transformToDataUnit,
    Percent: d3.format("%"),
    Default: (d) => `${d}`
};
class ChartOptions {
    constructor() {
        this.chartType = "column";
        this.barPadding = 0.3;
        this.barWidth = 20;
        this.barSpacing = 10;
        this.sectionSpacing = 40;
        this.singleXAxis = "";
        this.defaultTooltipPos = "";
        this.isPosTooltip = true;
        this.anotationLineColor = "";
        this.outerPadding = 20;
        this.margin = { top: 30, right: 25, bottom: 30, left: 25 };
        this.backgroundColor = "#fff";
        this.defaultColor = "#A0BFD9";
        this.axisLineColor = "#cacaca";
        this.tickColor = "#F5F5F5";
        this.valueColor = "#485967";
        this.groupTitleColor = "#1D3243";
        this.yAxisLabel = "";
        this.xAxisLabel = "";
        this.chartHeight = 350;
        this.yAxisTickFormat = "";
        this.xAxisTickFormat = "";
        this.lineColor = "#457FAD";
        this.isYaxisReadable = false;
        this.yAxisTickFormatter = YAxisTickFormatter.Default;
        this.xAxisDateFormat = "%Y-%m-%d";
        this.xAxisFormat = "date";
        this.setReadableNumber = false;
        this.customXaxis = false;
        this.drawVerticalLine = false;
        this.customTooltip = false;
        this.showAllTicks = false;
        this.hideMouseOverEffects = false;
        this.xTranslate = "";
        this.isPopup = false;
        this.app = "";
        this.showValue = true;
        this.subVertical = "";
        this.sortedTicks = false;
        this.yTickValues = [];
        this.drawAvgLine = false;
        this.rangeColors = [];
        this.toolTipIcons = {};
        this.rotateXaxis = false;
        this.excludeZeroDataPointsDisplay = false;
    }
}

function MigrateConnectorComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵtext(2, " Introducing Connector 3.0 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵtext(4, " A new version of the connector is available for OnPrem installations. AMI based connectors are currently not supported. Follow the steps below to migrate your connector ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 13);
    i0.ɵɵelementStart(6, "div", 14);
    i0.ɵɵelementStart(7, "div", 15);
    i0.ɵɵtext(8, "1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div");
    i0.ɵɵelementStart(10, "span", 16);
    i0.ɵɵtext(11, "Download Cisco Spaces Connector OVA ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "div", 17);
    i0.ɵɵelementStart(13, "div", 14);
    i0.ɵɵelementStart(14, "div", 15);
    i0.ɵɵtext(15, "2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div");
    i0.ɵɵelementStart(17, "span", 16);
    i0.ɵɵtext(18, "Install Cisco Spaces Connector OVA ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 18);
    i0.ɵɵelementStart(20, "span", 19);
    i0.ɵɵelementStart(21, "input", 20);
    i0.ɵɵlistener("click", function MigrateConnectorComponent_div_0_div_8_Template_input_click_21_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return ctx_r5.onMigrateConfirm(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(22, "label", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(23, "span", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 23);
    i0.ɵɵtext(25, "Note: Once you click \u201CMigrate\u201D button below, you cannot revert.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(21);
    i0.ɵɵpropertyInterpolate1("id", "appCheck-", ctx_r1.connector.name, "");
    i0.ɵɵproperty("checked", ctx_r1.migrateConfirmation);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "appCheck-", ctx_r1.connector.name, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", "I acknowledge that I have completed above steps.", i0.ɵɵsanitizeHtml);
} }
function MigrateConnectorComponent_div_0_div_9_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵlistener("click", function MigrateConnectorComponent_div_0_div_9_div_7_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(3); return ctx_r9.copyToken(ctx_r9.keyCopy); });
    i0.ɵɵtext(1, "Copy Token");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("cbContent", ctx_r7.generatedToken);
} }
function MigrateConnectorComponent_div_0_div_9_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtext(1, "Copied ");
    i0.ɵɵelementEnd();
} }
function MigrateConnectorComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵtext(2, "Great!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 26);
    i0.ɵɵtext(4, "Configure the token below on your new connector instance to complete the migration.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 27);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, MigrateConnectorComponent_div_0_div_9_div_7_Template, 2, 1, "div", 28);
    i0.ɵɵtemplate(8, MigrateConnectorComponent_div_0_div_9_div_8_Template, 2, 0, "div", 29);
    i0.ɵɵelementStart(9, "div", 30);
    i0.ɵɵelementStart(10, "div");
    i0.ɵɵtext(11, "To set up your connector instance, follow the steps below.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 13);
    i0.ɵɵelementStart(13, "div", 14);
    i0.ɵɵelementStart(14, "div", 15);
    i0.ɵɵtext(15, "1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div");
    i0.ɵɵelementStart(17, "div", 16);
    i0.ɵɵtext(18, "Copy the generated token above. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(19, "div", 17);
    i0.ɵɵelementStart(20, "div", 14);
    i0.ɵɵelementStart(21, "div", 15);
    i0.ɵɵtext(22, "2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div");
    i0.ɵɵelementStart(24, "div", 16);
    i0.ɵɵtext(25, "Login to your connector UI and configure the token. For more details follow the documentation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r2.generatedToken);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.keyCopy["isCopied"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.keyCopy["isCopied"]);
} }
function MigrateConnectorComponent_div_0_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "button", 34);
    i0.ɵɵlistener("click", function MigrateConnectorComponent_div_0_div_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.migrateConnector(); });
    i0.ɵɵtext(2, " Migrate ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", !ctx_r3.migrateConfirmation ? "disabled" : "");
} }
function MigrateConnectorComponent_div_0_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "button", 35);
    i0.ɵɵlistener("click", function MigrateConnectorComponent_div_0_div_11_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.DoneMigration(); });
    i0.ɵɵtext(2, " Done ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function MigrateConnectorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementStart(5, "span", 5);
    i0.ɵɵlistener("click", function MigrateConnectorComponent_div_0_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.closePopup(); });
    i0.ɵɵtext(6, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 6);
    i0.ɵɵtemplate(8, MigrateConnectorComponent_div_0_div_8_Template, 26, 4, "div", 7);
    i0.ɵɵtemplate(9, MigrateConnectorComponent_div_0_div_9_Template, 26, 3, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, MigrateConnectorComponent_div_0_div_10_Template, 3, 1, "div", 9);
    i0.ɵɵtemplate(11, MigrateConnectorComponent_div_0_div_11_Template, 3, 0, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("Migrate Connector: ", ctx_r0.connector.name, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.initialStep);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.initialStep);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.initialStep);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.initialStep);
} }
class MigrateConnectorComponent {
    constructor(cmxConnectorsService, dataService) {
        this.cmxConnectorsService = cmxConnectorsService;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.closeMigratePopup = new EventEmitter();
        this.doneMigratePopup = new EventEmitter();
        this.initialStep = true;
        this.generatedToken = '';
        this.migrateConfirmation = false;
        this.closePopup = () => {
            this.showMigratecomponent = false;
            this.closeMigratePopup.emit();
            this.initialStep = true;
            this.migrateConfirmation = false;
        };
        this.DoneMigration = () => {
            this.showMigratecomponent = false;
            this.doneMigratePopup.emit(this.connector);
            this.initialStep = true;
            this.migrateConfirmation = false;
        };
        this.keyCopy = {};
        this.copyToken = (keyCopy) => {
            keyCopy["isCopied"] = true;
            setTimeout(() => {
                keyCopy["isCopied"] = false;
            }, 3000);
        };
        this.migrateConnector = () => {
            this.dataService.display(true);
            if (this.connector && this.connector.id) {
                this.cmxConnectorsService.upgradeV2ToV3(this.connector.id).pipe(takeUntil$1(this.unsubscribe$)).
                    subscribe(response => {
                    if (response && response.status) {
                        /*  this.dataService.setToastMessage(
                            "Connector Migrated .",
                            4000,
                            null,
                            null,
                            "success"
                          );*/
                        this.generatedToken = response.data.jwttoken;
                        this.dataService.display(false);
                        this.initialStep = false;
                    }
                    else {
                        this.dataService.display(false);
                        this.dataService.setToastMessage(response.message, 4000, null, null, "error");
                    }
                });
            }
        };
        this.onMigrateConfirm = () => {
            this.migrateConfirmation = !this.migrateConfirmation;
        };
    }
    ngOnInit() {
        this.initialStep = true;
        this.generatedToken = '';
        this.migrateConfirmation = false;
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
MigrateConnectorComponent.ɵfac = function MigrateConnectorComponent_Factory(t) { return new (t || MigrateConnectorComponent)(i0.ɵɵdirectiveInject(CMXConnectorsService), i0.ɵɵdirectiveInject(DataService)); };
MigrateConnectorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MigrateConnectorComponent, selectors: [["lib-migrate-connector"]], inputs: { showMigratecomponent: "showMigratecomponent", connector: "connector" }, outputs: { closeMigratePopup: "closeMigratePopup", doneMigratePopup: "doneMigratePopup" }, decls: 1, vars: 1, consts: [["class", "modalPopup modalPopupSm wlcConnectorPopup", 4, "ngIf"], [1, "modalPopup", "modalPopupSm", "wlcConnectorPopup"], [1, "modalOverlay"], [1, "modalContent_rename"], [1, "modalHeader_edit"], [1, "modalCloseIcon_edit", 3, "click"], [1, "modalBody"], ["class", "migrateContainer", 4, "ngIf"], ["class", "migrate_container", 4, "ngIf"], ["class", "modalFooter_migrate", 4, "ngIf"], [1, "migrateContainer"], [1, "fieldWrapper"], [1, "migrate_subheader"], [1, "steps-reset"], [1, "step-header"], [1, "step_index"], [1, "tile_header"], [1, "step_content", "withBorder"], [1, "migrate-acknowledge"], [1, "circularCheckbox"], ["type", "checkbox", "name", "expires", 3, "checked", "id", "click"], [1, "checkboxLabel", 3, "for"], [1, "check-label", 3, "innerHtml"], [1, "warning"], [1, "migrate_container"], [1, "migrate_msg"], [1, "migrate_step1"], [1, "accessTokenValue"], ["class", "copy", "ngxClipboard", "", 3, "cbContent", "click", 4, "ngIf"], ["class", "copy", 4, "ngIf"], [1, "migrate_step2"], ["ngxClipboard", "", 1, "copy", 3, "cbContent", "click"], [1, "copy"], [1, "modalFooter_migrate"], [1, "commonButton", 3, "ngClass", "click"], [1, "commonButton", 3, "click"]], template: function MigrateConnectorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MigrateConnectorComponent_div_0_Template, 12, 5, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showMigratecomponent);
    } }, directives: [i1$2.NgIf, i5$1.ClipboardDirective, i1$2.NgClass], styles: [".modalPopup.connectorPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease;margin-bottom:0!important}.modalPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{background-color:#fff;padding:18px 30px;margin-bottom:20px;height:440px;overflow-y:auto}.modalPopup[_ngcontent-%COMP%] > .modalContent-connector[_ngcontent-%COMP%]{width:60%;right:0;height:100%;z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;animation:slide .5s forwards}@keyframes slide{65%{right:0}}.modalPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0 30px;color:#545454;font-size:24px;height:initial}.modalPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:24px 0}.modalPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{height:initial;align-items:center;padding:0;background-color:#ffffffe6;z-index:9999}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{padding:24px 30px;height:24px;line-height:32px}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon_edit[_ngcontent-%COMP%]{height:24px;line-height:14px;float:right}.modalCloseIcon_edit[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.modalPopup[_ngcontent-%COMP%]   .modalHeader_edit[_ngcontent-%COMP%]{padding:15px 30px;color:#545454;font-size:24px;height:53px;border-bottom:1px solid #eaeaea;font-family:\"CiscoSans\";font-style:normal;font-size:18px;line-height:33px;letter-spacing:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{z-index:1001;position:absolute;left:50%;top:30%;transform:translate(-50%);background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .warningIcon[_ngcontent-%COMP%]{margin-top:5%}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .streamWarningIcon[_ngcontent-%COMP%]{margin-left:45%!important}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .modalHeaders[_ngcontent-%COMP%]{padding:25px 0 5px;color:#000;font-size:20px;font-family:ciscoSansRegular;position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-top:5px;margin-bottom:25px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .circularCheckbox[_ngcontent-%COMP%]{position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:checked:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]{display:flex;justify-content:center}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]   .pmxRadioButtonLabel[_ngcontent-%COMP%]{margin-left:5px!important;font-size:14px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{display:flex;position:relative!important}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]   .secondary-btn-box[_ngcontent-%COMP%]{display:flex;justify-content:center;border:none!important;background:#fff;color:#07a0d9}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]{z-index:1001;position:absolute;left:50%;top:20%;transform:translate(-50%);background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .warningIcon[_ngcontent-%COMP%]{margin-top:5%}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .streamWarningIcon[_ngcontent-%COMP%]{margin-left:45%!important}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .modalHeaders[_ngcontent-%COMP%]{padding:25px 0 5px;color:#000;font-size:20px;font-family:ciscoSansRegular;position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-top:5px;margin-bottom:25px}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .circularCheckbox[_ngcontent-%COMP%]{position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:checked:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]{display:flex;justify-content:center}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]   .pmxRadioButtonLabel[_ngcontent-%COMP%]{margin-left:5px!important;font-size:14px}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{display:flex;justify-content:center;position:relative!important;border-top:none!important}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]   .secondary-btn-box[_ngcontent-%COMP%]{display:flex;justify-content:center;border:none!important;background:#fff;color:#07a0d9}.steps-reset[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:14px;line-height:19px;letter-spacing:.5px;margin-top:20px;margin-bottom:11px}.step-header[_ngcontent-%COMP%]{display:inline-block}.step-header[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:inline-block}.step-header[_ngcontent-%COMP%]   .step_index[_ngcontent-%COMP%]{border:1px solid #979797;width:30px;height:30px;border-radius:50%;text-align:center;line-height:30px;font-size:12px;font-family:CiscoSans;font-weight:bold;margin-right:20px}.step-header[_ngcontent-%COMP%]   span.tile_header[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;font-weight:300;letter-spacing:.83px;line-height:18px;display:inline}.withBorder[_ngcontent-%COMP%]{border-left:1px solid #979797;height:10px;margin-left:14px}.accessTokenValue[_ngcontent-%COMP%]{padding:20px;border:1px solid #c4c4c4;margin:20px 0;word-break:break-all;-webkit-user-select:all;user-select:all;border-style:dashed;font-family:\"CiscoSans\";font-size:12px;line-height:16px;letter-spacing:.5px;background:#F5F5F5;border:1px dashed #979797;border-radius:12px}.migrateContainer[_ngcontent-%COMP%]{margin:20px 0 0}.fieldWrapper[_ngcontent-%COMP%]{height:25px;left:23.44%;right:59.13%;top:calc(50% - 25px/2 - 789.42px);font-family:\"CiscoSansTT\";font-style:normal;font-weight:350;font-size:18px;line-height:25px;letter-spacing:.458333px;margin-bottom:5px}.migrate_subheader[_ngcontent-%COMP%]{height:36px;width:95%;left:23.63%;right:35.42%;top:calc(50% - 36px/2 - 756.48px);font-family:\"CiscoSansTT\";font-style:normal;font-weight:350;font-size:13px;line-height:18px;letter-spacing:.458333px}.migrate-acknowledge[_ngcontent-%COMP%]{height:19px;left:25.16%;right:48.66%;top:calc(50% - 19px/2 - 404.52px);font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:12px;line-height:19px;letter-spacing:.5px;margin-top:160px}.warning[_ngcontent-%COMP%]{box-sizing:border-box;left:23.59%;top:40.52%;bottom:58.66%;border:1px solid #FFA000;border-radius:4px;margin-top:10px;padding:10px;left:330.91px;top:1672.77px;font-style:normal;font-weight:350;font-size:13px;line-height:18px;letter-spacing:.458333px;width:auto;width:65%}.modalFooter_migrate[_ngcontent-%COMP%]{padding:20px 0 15px 37px;border:1px solid #e5e5e5}.migrate_container[_ngcontent-%COMP%]{padding:0 40px}.migrate_msg[_ngcontent-%COMP%]{font-family:\"CiscoSansTT\";font-style:normal;font-weight:350;font-size:30px;line-height:41px;letter-spacing:.458333px;color:#32a205;padding:20px;text-align:center}.migrate_step1[_ngcontent-%COMP%]{font-family:\"CiscoSansTT\";font-style:normal;font-weight:350;font-size:18px;line-height:25px;letter-spacing:.458333px;color:#000}.migrate_step2[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:14px;line-height:19px;letter-spacing:.5px;color:#121212;margin:20px 0 30px}.copy[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:500;font-size:14px;line-height:19px;letter-spacing:.5px;color:#049fd9;cursor:pointer}.circularCheckbox[_ngcontent-%COMP%]   .checkboxLabel[_ngcontent-%COMP%]{display:inline!important}.check-label[_ngcontent-%COMP%]{display:inline;padding-left:25px;font-size:14px}.disabled[_ngcontent-%COMP%]{opacity:.5;cursor:none}.commonButton[_ngcontent-%COMP%]{border:1px solid #049fd9;border-radius:6px;text-align:center;cursor:pointer;display:inline-table;vertical-align:middle;font-size:18px!important;padding:6px 18px;color:#0096d6;outline:none;background-color:transparent}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MigrateConnectorComponent, [{
        type: Component,
        args: [{
                selector: 'lib-migrate-connector',
                templateUrl: './migrate-connector.component.html',
                styleUrls: ['./migrate-connector.component.scss']
            }]
    }], function () { return [{ type: CMXConnectorsService }, { type: DataService }]; }, { showMigratecomponent: [{
            type: Input
        }], connector: [{
            type: Input
        }], closeMigratePopup: [{
            type: Output
        }], doneMigratePopup: [{
            type: Output
        }] }); })();

const _c0$1h = function (a0, a1, a2, a3) { return { "disabledForAdded": a0, "newlyAdded": a1, "pointer-events": a2, "opacity": a3 }; };
const _c1$u = function (a0) { return { "disabled": a0 }; };
class ConnectorServiceItemComponent {
    constructor() {
        this.onSelect = new EventEmitter();
        this.onDeselect = new EventEmitter();
        this.title = "";
        this.description = "";
        this.extraInfo = "";
        this.services = [];
        this.isAlreadyAdded = (item) => {
            if (item && item.currentConfig) {
                if (item.currentConfig.status == "ENABLED") {
                    item.isAddedAlready = true;
                }
                else if (item.currentConfig.status == "DISABLED") {
                    if (item.organizeInfo && item.organizeInfo.default == 'yes' && item.organizeInfo.removeAllowed == 'yes') {
                        item.isNewlyAdded = true;
                    }
                }
                else {
                    item.isAddedAlready = false;
                    item.isNewlyAdded = false;
                }
                console.log("service detail is ", item);
                if (item.organizeInfo && item.organizeInfo.default == 'yes'
                    && item.organizeInfo.removeAllowed == 'no') {
                    item.isAddedAlready = true;
                    this.onSelect.emit(item);
                }
                if (item.organizeInfo && item.organizeInfo.default == 'yes'
                    && item.organizeInfo.removeAllowed == 'yes') {
                    item.isNewlyAdded = true;
                    this.onSelect.emit(item);
                }
            }
            this.services = item;
        };
    }
    ngOnInit() {
        const services = this.itemData;
        this.isAlreadyAdded(services);
    }
    handleSelectClick(service) {
        if (service.isNewlyAdded == true) {
            this.onDeselect.emit(service);
            service.isNewlyAdded = false;
        }
        else if (service.isAddedAlready == true && service.organizeInfo && service.organizeInfo.default == 'yes'
            && service.organizeInfo.removeAllowed == 'yes') {
        }
        else {
            service.isNewlyAdded = true;
            this.onSelect.emit(service);
        }
    }
}
ConnectorServiceItemComponent.ɵfac = function ConnectorServiceItemComponent_Factory(t) { return new (t || ConnectorServiceItemComponent)(); };
ConnectorServiceItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConnectorServiceItemComponent, selectors: [["lib-connector-service-item"]], inputs: { itemData: "itemData", selectedServices: "selectedServices" }, outputs: { onSelect: "onSelect", onDeselect: "onDeselect" }, decls: 10, vars: 13, consts: [[1, "containerWrapper"], [1, "widgetContainer", "tileBoxShadow", 3, "ngClass"], [1, "setup-title"], [1, "circularCheckbox", 3, "ngClass"], ["type", "checkbox", "name", "setAccess", 3, "checked", "disabled", "click"], ["for", "setAccess", 1, "checkboxLabel"], [1, "bold-text", "check-label", 2, "margin-left", "30px"], [1, "recommendedText"]], template: function ConnectorServiceItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "h2", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵelementStart(4, "input", 4);
        i0.ɵɵlistener("click", function ConnectorServiceItemComponent_Template_input_click_4_listener() { return ctx.handleSelectClick(ctx.itemData); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "label", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "span", 6);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(6, _c0$1h, ctx.itemData.isAddedAlready, ctx.itemData.isNewlyAdded, ctx.itemData.serviceName == "service-manager" || ctx.itemData.isAddedAlready == true ? "none" : "all", ctx.itemData.isAddedAlready == true || ctx.itemData.isNewlyAdded == true ? "0.5" : 1));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1$u, ctx.itemData.isAddedAlready));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("checked", ctx.itemData.isAddedAlready || ctx.itemData.isNewlyAdded)("disabled", ctx.itemData.isAddedAlready);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.itemData.displayName);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.itemData.description, " ");
    } }, directives: [i1$2.NgClass], styles: ["@charset \"UTF-8\";.tileBoxShadow[_ngcontent-%COMP%]{box-shadow:1.5px 2px 5px 1px\\a0rgb 189 189 189 / 55%;border-radius:5px}.setup-select-button[_ngcontent-%COMP%]{width:100%;display:flex;align-items:center;justify-content:center;margin:0 auto}.setup-title[_ngcontent-%COMP%]{font-weight:bolder;font-size:20px!important;text-align:left;margin:0}.setup-description[_ngcontent-%COMP%]{text-align:left;margin:2.5% 3% 3% 0;font-size:15px}.setup-guide[_ngcontent-%COMP%]{padding:10px 0;text-align:left}.setup-guide[_ngcontent-%COMP%]   .planningLink[_ngcontent-%COMP%]{color:#049fd9;font-weight:bold;cursor:pointer}.disabled[_ngcontent-%COMP%]{opacity:.4;cursor:not-allowed}.disabledForAdded[_ngcontent-%COMP%]{opacity:.8;cursor:not-allowed;border:2px solid #049FD9}.newlyAdded[_ngcontent-%COMP%]{border:2px solid #049FD9}.widgetContainer[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between;margin:2%;background-color:#fff;border-radius:0!important;padding:12px;width:30%;height:205px!important}.recommendedText[_ngcontent-%COMP%]{text-align:left;font-size:13px!important}.already_added[_ngcontent-%COMP%]{position:relative;top:-107px;margin-left:142px;width:24%}.already_added[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-size:15px;color:#6dc04b;font-weight:bolder}.alreadyAddeButton[_ngcontent-%COMP%]{display:block}.widgetContainer[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between;margin:0 2% 2%;background-color:#fff;border-radius:0!important;padding:8% 7%;width:95%;height:125px}.hidden-div[_ngcontent-%COMP%]{visibility:hidden}.visible-div[_ngcontent-%COMP%]{visibility:visible}.circularCheckbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]{opacity:0;height:20px;width:20px;position:absolute;z-index:3;cursor:pointer;display:block!important}.circularCheckbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]{position:relative!important;top:25px}.circularCheckbox[_ngcontent-%COMP%]   .checkboxLabel[_ngcontent-%COMP%]{top:5px;display:inline!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConnectorServiceItemComponent, [{
        type: Component,
        args: [{
                selector: 'lib-connector-service-item',
                templateUrl: './connector-service-item.component.html',
                styleUrls: ['./connector-service-item.component.scss']
            }]
    }], function () { return []; }, { itemData: [{
            type: Input
        }], selectedServices: [{
            type: Input
        }], onSelect: [{
            type: Output
        }], onDeselect: [{
            type: Output
        }] }); })();

class SafeUrlPipe {
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    transform(value) {
        return this.sanitized.bypassSecurityTrustResourceUrl(value);
    }
}
SafeUrlPipe.ɵfac = function SafeUrlPipe_Factory(t) { return new (t || SafeUrlPipe)(i0.ɵɵdirectiveInject(i1$3.DomSanitizer, 16)); };
SafeUrlPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "safeUrl", type: SafeUrlPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafeUrlPipe, [{
        type: Pipe,
        args: [{
                name: "safeUrl"
            }]
    }], function () { return [{ type: i1$3.DomSanitizer }]; }, null); })();

function ConnectorServicesComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_4_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.showCMXConnectorServiceAdd(ctx_r5.currentConnector); });
    i0.ɵɵelement(1, "img", 9);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "dashboard-lib.setup.connectorServices.addService"));
} }
function ConnectorServicesComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 13);
    i0.ɵɵelement(11, "img", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 2, "dashboard-lib.setup.connectorServices.desc"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(9, 4, "dashboard-lib.setup.connectorServices.clickAdd"), " ");
} }
function ConnectorServicesComponent_div_7_tr_20_span_9_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵelement(2, "img", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵelementStart(4, "a", 31);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_7_tr_20_span_9_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r24); const service_r8 = i0.ɵɵnextContext().$implicit; const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.triggerUpgradePopup(service_r8); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 32);
    i0.ɵɵtext(7, "(upgrade failed)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(service_r8.currentConfig.version);
} }
function ConnectorServicesComponent_div_7_tr_20_span_10_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵelement(2, "img", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵelementStart(4, "a", 31);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_7_tr_20_span_10_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r28); const service_r8 = i0.ɵɵnextContext().$implicit; const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.triggerUpgradePopup(service_r8); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(service_r8.currentConfig.version);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(7, 2, "dashboard-lib.setup.connectorServices.queue"), "");
} }
function ConnectorServicesComponent_div_7_tr_20_span_11_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵelementStart(2, "a", 31);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_7_tr_20_span_11_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r32); const service_r8 = i0.ɵɵnextContext().$implicit; const ctx_r30 = i0.ɵɵnextContext(2); return ctx_r30.triggerUpgradePopup(service_r8); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(service_r8.currentConfig.version);
} }
function ConnectorServicesComponent_div_7_tr_20_span_12_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵelement(2, "img", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵelementStart(4, "a", 31);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_7_tr_20_span_12_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r36); const service_r8 = i0.ɵɵnextContext().$implicit; const ctx_r34 = i0.ɵɵnextContext(2); return ctx_r34.triggerUpgradePopup(service_r8); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(service_r8.currentConfig.version);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(7, 2, "dashboard-lib.setup.connectorServices.progress"), "");
} }
function ConnectorServicesComponent_div_7_tr_20_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", service_r8.currentConfig.version, "");
} }
function ConnectorServicesComponent_div_7_tr_20_span_14_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 37);
    i0.ɵɵelement(1, "span");
    i0.ɵɵelement(2, "br");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r8 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" Version ", service_r8.upgrade_to_version, " is available ");
} }
function ConnectorServicesComponent_div_7_tr_20_span_14_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 37);
    i0.ɵɵelement(1, "span");
    i0.ɵɵelement(2, "br");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "dashboard-lib.setup.connectorServices.available"), " ");
} }
function ConnectorServicesComponent_div_7_tr_20_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵelement(1, "img", 35);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, ConnectorServicesComponent_div_7_tr_20_span_14_span_3_Template, 4, 1, "span", 36);
    i0.ɵɵtemplate(4, ConnectorServicesComponent_div_7_tr_20_span_14_span_4_Template, 5, 3, "span", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0 ", service_r8.currentConfig.version, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", service_r8.upgrade_to_version !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", service_r8.upgrade_to_version == undefined);
} }
function ConnectorServicesComponent_div_7_tr_20_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, service_r8.currentConfig.upgradeTime, "medium"), " ");
} }
function ConnectorServicesComponent_div_7_tr_20_span_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " NA ");
    i0.ɵɵelementEnd();
} }
function ConnectorServicesComponent_div_7_tr_20_a_20_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 38);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_7_tr_20_a_20_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r46); const ctx_r45 = i0.ɵɵnextContext(); const service_r8 = ctx_r45.$implicit; const i_r9 = ctx_r45.index; const ctx_r44 = i0.ɵɵnextContext(2); return ctx_r44.upgradeServices(service_r8, i_r9); });
    i0.ɵɵelement(1, "img", 39);
    i0.ɵɵelementStart(2, "span", 37);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "dashboard-lib.setup.connectorServices.upgrade"));
} }
function ConnectorServicesComponent_div_7_tr_20_a_21_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 38);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_7_tr_20_a_21_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(); const service_r8 = ctx_r48.$implicit; const i_r9 = ctx_r48.index; const ctx_r47 = i0.ɵɵnextContext(2); return ctx_r47.triggerManageIOTStream(service_r8, i_r9); });
    i0.ɵɵelement(1, "img", 40);
    i0.ɵɵelementStart(2, "span", 37);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "dashboard-lib.setup.connectorServices.stream"));
} }
function ConnectorServicesComponent_div_7_tr_20_a_22_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 38);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_7_tr_20_a_22_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r52); const ctx_r51 = i0.ɵɵnextContext(); const service_r8 = ctx_r51.$implicit; const i_r9 = ctx_r51.index; const ctx_r50 = i0.ɵɵnextContext(2); return ctx_r50.triggerManageIOTService(service_r8, i_r9); });
    i0.ɵɵelement(1, "img", 40);
    i0.ɵɵelementStart(2, "span", 37);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "dashboard-lib.setup.connectorServices.service"));
} }
function ConnectorServicesComponent_div_7_tr_20_a_23_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 41);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_7_tr_20_a_23_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r55); const service_r8 = i0.ɵɵnextContext().$implicit; const ctx_r53 = i0.ɵɵnextContext(2); return ctx_r53.ConfirmRemoveServices(service_r8); });
    i0.ɵɵelement(1, "img", 42);
    i0.ɵɵelementEnd();
} }
function ConnectorServicesComponent_div_7_tr_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 19);
    i0.ɵɵelementStart(1, "td", 20);
    i0.ɵɵelementStart(2, "span", 21);
    i0.ɵɵelementStart(3, "span", 22);
    i0.ɵɵelement(4, "img", 23);
    i0.ɵɵpipe(5, "safeUrl");
    i0.ɵɵelementStart(6, "span", 24);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtemplate(9, ConnectorServicesComponent_div_7_tr_20_span_9_Template, 8, 1, "span", 25);
    i0.ɵɵtemplate(10, ConnectorServicesComponent_div_7_tr_20_span_10_Template, 8, 4, "span", 25);
    i0.ɵɵtemplate(11, ConnectorServicesComponent_div_7_tr_20_span_11_Template, 4, 1, "span", 25);
    i0.ɵɵtemplate(12, ConnectorServicesComponent_div_7_tr_20_span_12_Template, 8, 4, "span", 25);
    i0.ɵɵtemplate(13, ConnectorServicesComponent_div_7_tr_20_span_13_Template, 3, 1, "span", 25);
    i0.ɵɵtemplate(14, ConnectorServicesComponent_div_7_tr_20_span_14_Template, 5, 3, "span", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td");
    i0.ɵɵtemplate(16, ConnectorServicesComponent_div_7_tr_20_span_16_Template, 3, 4, "span", 25);
    i0.ɵɵtemplate(17, ConnectorServicesComponent_div_7_tr_20_span_17_Template, 2, 0, "span", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td");
    i0.ɵɵelementStart(19, "div", 27);
    i0.ɵɵtemplate(20, ConnectorServicesComponent_div_7_tr_20_a_20_Template, 5, 3, "a", 28);
    i0.ɵɵtemplate(21, ConnectorServicesComponent_div_7_tr_20_a_21_Template, 5, 3, "a", 28);
    i0.ɵɵtemplate(22, ConnectorServicesComponent_div_7_tr_20_a_22_Template, 5, 3, "a", 28);
    i0.ɵɵtemplate(23, ConnectorServicesComponent_div_7_tr_20_a_23_Template, 2, 0, "a", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(24, "td");
    i0.ɵɵelement(25, "td");
    i0.ɵɵelement(26, "td");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r8 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("src", i0.ɵɵpipeBind1(5, 15, "data:image/svg+xml;base64," + service_r8.icon), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", service_r8.displayName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !service_r8.upgrade_allowed && service_r8.connectorUpgradeStatus !== undefined && service_r8.connectorUpgradeStatus.upgradeStatus == "Failed");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !service_r8.upgrade_allowed && service_r8.connectorUpgradeStatus !== undefined && service_r8.connectorUpgradeStatus.upgradeStatus == "Queued");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !service_r8.upgrade_allowed && service_r8.connectorUpgradeStatus !== undefined && service_r8.connectorUpgradeStatus.upgradeStatus == "Successful");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !service_r8.upgrade_allowed && service_r8.connectorUpgradeStatus !== undefined && service_r8.connectorUpgradeStatus.upgradeStatus == "In Progress");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !service_r8.upgrade_allowed && service_r8.connectorUpgradeStatus !== undefined && service_r8.connectorUpgradeStatus.upgradeStatus == "NA");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", service_r8.upgrade_allowed);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", service_r8.currentConfig && service_r8.currentConfig.upgradeTime);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", service_r8.currentConfig == undefined || service_r8.currentConfig.upgradeTime == undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r7.showMoreOptions ? "selected" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", service_r8.upgrade_allowed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", service_r8.manageIOTStream && service_r8.manageIOTStream == true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", service_r8.manageWiredStream && service_r8.manageWiredStream == true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", service_r8.serviceName != "service-manager");
} }
function ConnectorServicesComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "table", 16);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr", 17);
    i0.ɵɵelementStart(4, "th");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "th");
    i0.ɵɵelement(17, "th");
    i0.ɵɵelement(18, "th");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "tbody");
    i0.ɵɵtemplate(20, ConnectorServicesComponent_div_7_tr_20_Template, 27, 17, "tr", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(6, 5, "dashboard-lib.setup.connectorServices.name"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 7, "dashboard-lib.setup.connectorServices.ver"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 9, "dashboard-lib.setup.connectorServices.lastUp"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 11, "dashboard-lib.setup.connectorServices.actions"));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r2.selectedServices);
} }
function ConnectorServicesComponent_div_8_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵelementStart(1, "div", 58);
    i0.ɵɵelement(2, "img", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 60);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r56.warningOnServiceRemoval, " ");
} }
const _c0$1g = function () { return { "display": "inline-block", "width": "350px", "height": "225px" }; };
function ConnectorServicesComponent_div_8_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 61);
    i0.ɵɵelementStart(1, "lib-connector-service-item", 62);
    i0.ɵɵlistener("onSelect", function ConnectorServicesComponent_div_8_div_16_Template_lib_connector_service_item_onSelect_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r61); const service_r58 = restoredCtx.$implicit; const i_r59 = restoredCtx.index; const ctx_r60 = i0.ɵɵnextContext(2); return ctx_r60.onServiceSelection(service_r58, i_r59); })("onDeselect", function ConnectorServicesComponent_div_8_div_16_Template_lib_connector_service_item_onDeselect_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r61); const service_r58 = restoredCtx.$implicit; const i_r59 = restoredCtx.index; const ctx_r62 = i0.ɵɵnextContext(2); return ctx_r62.onServiceSelectionrevert(service_r58, i_r59); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r58 = ctx.$implicit;
    const ctx_r57 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(3, _c0$1g));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("itemData", service_r58)("selectedServices", ctx_r57.selectedServices);
} }
const _c1$t = function (a0) { return { "disabled": a0 }; };
function ConnectorServicesComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelementStart(1, "div", 44);
    i0.ɵɵelementStart(2, "div", 45);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 46);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_8_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r64); const ctx_r63 = i0.ɵɵnextContext(); return ctx_r63.closeAddServicePopup(); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 47);
    i0.ɵɵelementStart(9, "div", 48);
    i0.ɵɵelementStart(10, "div", 49);
    i0.ɵɵelementStart(11, "div", 50);
    i0.ɵɵelementStart(12, "div", 51);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, ConnectorServicesComponent_div_8_div_15_Template, 5, 1, "div", 52);
    i0.ɵɵtemplate(16, ConnectorServicesComponent_div_8_div_16_Template, 2, 4, "div", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 54);
    i0.ɵɵelementStart(18, "button", 55);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_8_Template_button_click_18_listener() { i0.ɵɵrestoreView(_r64); const ctx_r65 = i0.ɵɵnextContext(); return ctx_r65.addServicesToConnector(); });
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "button", 56);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_8_Template_button_click_21_listener() { i0.ɵɵrestoreView(_r64); const ctx_r66 = i0.ɵɵnextContext(); return ctx_r66.closeAddServicePopup(); });
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 7, "dashboard-lib.setup.connectorServices.add"));
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 9, "dashboard-lib.setup.connectorServices.selectService"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.showServiceRemovalWarning);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.allServices);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c1$t, ctx_r3.servicesToAdd && ctx_r3.servicesToAdd.length == 0));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 11, "dashboard-lib.setup.connectorServices.add"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 13, "dashboard-lib.setup.connectorServices.cancel"), " ");
} }
function ConnectorServicesComponent_div_9_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r67 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r67.serviceToRemove.organizeInfo.warnMessage);
} }
function ConnectorServicesComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵelement(1, "div", 64);
    i0.ɵɵelementStart(2, "div", 65);
    i0.ɵɵelementStart(3, "div", 47);
    i0.ɵɵelement(4, "img", 66);
    i0.ɵɵelementStart(5, "div", 67);
    i0.ɵɵtext(6);
    i0.ɵɵelement(7, "br");
    i0.ɵɵtemplate(8, ConnectorServicesComponent_div_9_span_8_Template, 2, 1, "span", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 54);
    i0.ɵɵelementStart(10, "button", 68);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_9_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r69); const ctx_r68 = i0.ɵɵnextContext(); return ctx_r68.removeServices(ctx_r68.serviceToRemove); });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "button", 56);
    i0.ɵɵlistener("click", function ConnectorServicesComponent_div_9_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r69); const ctx_r70 = i0.ɵɵnextContext(); return ctx_r70.cancelRemoveService(); });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" Are you sure you want to Remove ", ctx_r4.serviceToRemove.serviceName, " service ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.serviceToRemove.organizeInfo && ctx_r4.serviceToRemove.organizeInfo.warnMessage);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 4, "dashboard-lib.setup.connectorServices.remove"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 6, "dashboard-lib.setup.connectorServices.cancel"), " ");
} }
class ConnectorServicesComponent {
    constructor(dataService, cmxConnectorsService, domSanitizerService, translate) {
        this.dataService = dataService;
        this.cmxConnectorsService = cmxConnectorsService;
        this.domSanitizerService = domSanitizerService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.connectorServices = new EventEmitter();
        this.triggerManageIOTStreams = new EventEmitter();
        this.showServiceUpgrade = new EventEmitter();
        this.triggerManageIOTServices = new EventEmitter();
        this.showAddServicePopup = false;
        this.connectorNameForService = '';
        this.showMoreOptions = false;
        this.selectedCustomerName = "";
        this.removeServiceConfirm = false;
        this.showServiceRemovalWarning = false;
        this.warningOnServiceRemoval = '';
        // Pagination
        this.page = 1;
        this.limit = 10;
        this.now = null;
        this.messageKeys = {};
        this.currentConnectorItems = null;
        this.connectorService_searched = null;
        this.currentControllerItems = null;
        this.controllerList_searched = null;
        this.controllerStream_searched = null;
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.setup.connectorServices.title').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.title"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.addService').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.addService"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.desc').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.desc"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.clickAdd').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.clickAdd"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.name').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.name"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.ver').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.ver"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.lastUp').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.lastUp"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.actions').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.actions"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.queue').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.queue"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.progress').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.progress"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.available').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.available"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.upgrade').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.upgrade"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.stream').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.stream"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.service').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.service"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.selectService').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.selectService"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.add').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.add"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.cancel').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.cancel"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.remove').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connectorServices.remove"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.noServ').subscribe((res) => {
                this.messageKeys["noServ"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.remSuccess').subscribe((res) => {
                this.messageKeys["remSuccess"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.remFail').subscribe((res) => {
                this.messageKeys["remFail"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.resSuccess').subscribe((res) => {
                this.messageKeys["resSuccess"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.resFail').subscribe((res) => {
                this.messageKeys["resFail"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.stopSuccess').subscribe((res) => {
                this.messageKeys["stopSuccess"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.stopFail').subscribe((res) => {
                this.messageKeys["stopFail"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.addSuccess').subscribe((res) => {
                this.messageKeys["addSuccess"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.addFail').subscribe((res) => {
                this.messageKeys["addFail"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.select').subscribe((res) => {
                this.messageKeys["select"] = res;
            });
            this.translate.get('dashboard-lib.setup.connectorServices.queueUp').subscribe((res) => {
                this.messageKeys["queueUp"] = res;
            });
        };
        this.openMoreOptions = (entity) => {
            // this.showMoreOptions = entity;
            this.selectedCustomerName = entity.name;
            $("body").unbind("click");
            setTimeout(() => {
                $("body").bind("click", (event) => {
                    this.closeMenu(event);
                    $("body").unbind("click");
                });
            }, 1);
        };
        this.closeMenu = (event) => {
            this.showMoreOptions = null;
            this.selectedCustomerName = "";
        };
        this.getAvailableServices = (connector) => {
            this.dataService.display(true);
            this.cmxConnectorsService.getConnectorServices(this.currentConnector.id).
                pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response && response.status) {
                    if (response.data && response.data.services) {
                        this.selectedServices = [];
                        this.dataService.display(false);
                        this.allServices = response.data.services;
                        this.allServices.forEach((service, index) => {
                            /*if (service.organizeInfo == undefined) {

                            }else{
                                if(service.organizeInfo.default == 'yes'){
                                    this.selectedServices.push(service);
                                }
                            }*/
                        });
                    }
                    this.dataService.display(false);
                }
                else {
                    this.dataService.display(false);
                    const message = this.messageKeys["noServ"];
                    this.dataService.setToastMessage(message, 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        this.closeAddServicePopup = () => {
            this.showAddServicePopup = false;
            this.dataService.closeMagneticPopup();
            this.servicesToAdd = [];
        };
        this.showCMXConnectorServiceAdd = (connector) => {
            this.dataService.display(true);
            //this.selectedServices = [];
            //this.getAvailableServices(connector);  --can unvomment later;
            this.connectorNameForService = connector.name;
            this.showAddServicePopup = true;
            this.dataService.openMagneticPopup();
            this.dataService.display(false);
        };
        this.ConfirmRemoveServices = (service) => {
            this.serviceToRemove = service;
            this.removeServiceConfirm = true;
            this.dataService.openMagneticPopup();
        };
        this.cancelRemoveService = () => {
            this.removeServiceConfirm = false;
            this.dataService.closeMagneticPopup();
        };
        this.removeServices = (service) => {
            const postBody = {
                "services": [service.serviceName],
                "connectorId": this.currentConnector.id
            };
            this.dataService.display(true);
            this.cmxConnectorsService.deleteServices(postBody).pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response.status && response.status) {
                    const message = this.messageKeys["remSuccess"];
                    this.dataService.setToastMessage(message, 4000, null, null, "success");
                    //	this.getAvailableServices(this.currentConnector);
                    this.connectorServices.emit();
                    //	this.dataService.display(false);
                    this.removeServiceConfirm = false;
                    this.dataService.closeMagneticPopup();
                    //fetch list of associated services
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["remFail"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        //Service End
        this.restartServices = (service, index) => {
            /*const postBody = {
                //"services" : [this.selectedServices[index]],
                "service" : service.serviceName,
                "connectorId" : this.currentConnector.id,
                "configType" : 'latest'//this.allServices[index].currentConfig.version
            };*/
            this.dataService.display(true);
            this.cmxConnectorsService.restartServices(service.serviceName, this.currentConnector.id, 'latest').pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response.status && response.status) {
                    const message = this.messageKeys["resSuccess"];
                    this.dataService.setToastMessage(message, 4000, null, null, "success");
                    //fetch list of associated services
                    this.connectorServices.emit();
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["resFail"], 4000, null, null, "error");
                }
                this.dataService.display(false);
            });
        };
        this.stopService = (service, index) => {
            //PUT: {{DMS_ENDPOINT}}/api/dms/v3/manage/connector/{{CONNECTOR_ID}}/service/{{SERVICE_NAME}}/stop
            this.dataService.display(true);
            this.cmxConnectorsService.stopService(this.currentConnector.id, service.serviceName).pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response.status && response.status) {
                    const message = this.messageKeys["stopSuccess"];
                    this.dataService.setToastMessage(message, 4000, null, null, "success");
                    //fetch list of associated services
                    this.connectorServices.emit();
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["stopFail"], 4000, null, null, "error");
                }
                this.dataService.display(false);
            });
        };
        this.hotspotConfig = { "name": "", config: {}, "ports": {}, "containerType": "", "connectorId": "" };
        this.getHotspotConfig = () => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .getHotspotConfig()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.data !== "" && response.data !== null) {
                    this.hotspotConfig = response.data;
                }
                else {
                    console.log("getHotspotConfig api call giving empty data");
                }
                this.dataService.display(false);
            }, (_error) => {
                this.dataService.display(false);
                console.log("getHotspotConfig api call giving error");
            });
        };
        //New start
        this.saveHSDefaultConfig = (connectorId) => {
            let serviceDrivenConfig = this.hotspotConfig.config;
            const payloadV3 = { "serviceDrivenConfig": serviceDrivenConfig };
            this.cmxConnectorsService.saveServiceDrivenConfig(connectorId, 'hotspot', payloadV3).
                pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response && response.status) {
                    this.dataService.display(false);
                    this.dataService.setToastMessage("Hotspot created Successfully", 4000, null, null, "success");
                    // this.viewAccessToken();
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(response.message, 4000, null, null, "error");
                }
            });
        };
        //New End
        this.addServicesToConnector = () => {
            if (this.servicesToAdd && this.servicesToAdd.length > 0) {
                //get the names from selected services []
                const postBody = {
                    "services": this.servicesToAdd,
                    "connectorId": this.currentConnector.id
                };
                this.dataService.display(true);
                this.cmxConnectorsService.addConnectorServices(this.currentConnector.id, JSON.stringify(postBody)).
                    pipe(takeUntil(this.unsubscribe$))
                    .subscribe((response) => {
                    if (response.status && response.status) {
                        const message = this.messageKeys["addSuccess"];
                        this.dataService.setToastMessage(message, 4000, null, null, "success");
                        this.showAddServicePopup = false;
                        this.dataService.closeMagneticPopup();
                        //this.getAvailableServices(this.currentConnector);
                        this.connectorServices.emit();
                        //fetch list of associated services
                        //Platform specific configs saving into DB
                        if (this.servicesToAdd.includes('hotspot')) {
                            this.saveHSDefaultConfig(this.currentConnector.id);
                        }
                        this.servicesToAdd = [];
                        //END
                    }
                    else {
                        this.dataService.setToastMessage(this.messageKeys["addFail"], 4000, null, null, "error");
                        this.servicesToAdd = [];
                        this.dataService.display(false);
                    }
                });
            }
            else {
                //this.showAddServicePopup = false;
                this.dataService.setToastMessage(this.messageKeys["select"], 4000, null, null, "error");
            }
        };
        this.upgradeServices = (service, index) => {
            const postBody = {
                "services": [this.selectedServices[index]],
                "connectorId": this.currentConnector.id,
                "configType": "latest" //this.allServices[index].currentConfig.version
            };
            this.dataService.display(true);
            this.cmxConnectorsService.upgradeServices(this.currentConnector.id, service.serviceName, "latest").pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response.status && response.status) {
                    const message = this.messageKeys["queueUp"];
                    this.dataService.setToastMessage(message, 4000, null, null, "success");
                    //fetch list of associated services
                    this.connectorServices.emit();
                }
                else {
                    this.dataService.setToastMessage("Failed to upgrade ${service.serviceName} Service.", 4000, null, null, "error");
                }
                this.dataService.display(false);
            });
        };
        this.clickEvents = ($event) => {
            //console.log('there is an click event', $event);
        };
        this.getCurrentConnectorItems = ($event) => {
            //console.log('currentl ist of items', $event);
            setTimeout(() => {
                this.currentConnectorItems = $event;
            }, 100);
        };
        this.onConnectorFilter = ($event) => {
            setTimeout(() => {
                this.connectorService_searched = $event;
            }, 100);
        };
        this.onKey = (event) => {
            if (event.key != undefined) {
                if (event.key.charCodeAt(0) >= 32 &&
                    event.key.charCodeAt(0) <= 10175)
                    return true;
                else {
                    event.preventDefault();
                    return false;
                }
            }
        };
        this.servicesToAdd = [];
        this.onServiceSelection = (serviceName, index) => {
            //	const tempService = this.allServices[index];
            //	tempService.currentConfig.status = "ENABLED";
            //this.allServices[index] = tempService;
            //	this.selectedServices.push(tempService);
            const serviceToAdd = this.allServices[index];
            if (!this.selectedServices.includes(serviceToAdd)) {
                this.servicesToAdd.push(this.allServices[index].serviceName);
                if (serviceToAdd.organizeInfo && serviceToAdd.organizeInfo.default == 'yes'
                    && serviceToAdd.organizeInfo.removeAllowed == 'yes') {
                    this.showServiceRemovalWarning = false;
                    this.warningOnServiceRemoval = serviceToAdd.organizeInfo.warnMessage;
                }
            } /*else{
                this.servicesToAdd = this.servicesToAdd.splice(index,1);
    
            }*/
            /*else{
                this.selectedServices.every((item, index) => {
                    if (item.serviceName == serviceName) {
                        this.selectedServices.splice(index,1);
                        this.servicesToAdd.splice(index,1);
                        const tempService = this.allServices[index];
                        tempService.currentConfig.status = "NOT_ENABLED";
                        this.allServices[index] = tempService;
                    }
                });
            }*/
        };
        this.onServiceSelectionrevert = (service, index) => {
            if (this.servicesToAdd.includes(service.serviceName)) {
                const indexToRemove = this.servicesToAdd.indexOf(service.serviceName);
                this.servicesToAdd.splice(indexToRemove, 1);
                if (service.organizeInfo && service.organizeInfo.default == 'yes'
                    && service.organizeInfo.removeAllowed == 'yes') {
                    this.showServiceRemovalWarning = true;
                }
            }
        };
        this.triggerManageIOTStream = (service, index) => {
            this.triggerManageIOTStreams.emit(service);
        };
        this.triggerManageIOTService = (service, index) => {
            this.triggerManageIOTServices.emit(service);
        };
        this.triggerUpgradePopup = (service) => {
            this.showServiceUpgrade.emit(service);
        };
    }
    ngOnInit() {
        //	this.getAvailableServices(this.currentConnector);
        console.log("services are ", this.selectedServices);
        this.showServiceRemovalWarning = false;
        this.warningOnServiceRemoval = '';
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
            this.getHotspotConfig();
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
ConnectorServicesComponent.ɵfac = function ConnectorServicesComponent_Factory(t) { return new (t || ConnectorServicesComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(CMXConnectorsService), i0.ɵɵdirectiveInject(i1$3.DomSanitizer), i0.ɵɵdirectiveInject(i2.TranslateService)); };
ConnectorServicesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConnectorServicesComponent, selectors: [["app-connector-services"]], inputs: { selectedServices: "selectedServices", userRole: "userRole", allServices: "allServices", currentConnector: "currentConnector", isConnectorAvailable: "isConnectorAvailable" }, outputs: { connectorServices: "connectorServices", triggerManageIOTStreams: "triggerManageIOTStreams", showServiceUpgrade: "showServiceUpgrade", triggerManageIOTServices: "triggerManageIOTServices" }, decls: 10, vars: 8, consts: [[1, "subHeader"], [1, "headerSection"], ["id", "btn-connector-create", "class", "addUuidDiv createConnector", 3, "click", 4, "ngIf"], [1, "connector-table"], ["class", "emptyStateHeading-metric", 4, "ngIf"], ["class", "userTableContainer", 4, "ngIf"], ["class", "modalPopup modalPopupLg connectorPopup", 4, "ngIf"], ["class", "modalPopup modalPopupSm", 4, "ngIf"], ["id", "btn-connector-create", 1, "addUuidDiv", "createConnector", 3, "click"], ["src", "/assets/images/add.svg", "width", "20"], [1, "emptyStateHeading-metric"], [1, "divTable"], [1, "divTableRow", "empty_metric_msg"], [1, "divTableCell"], ["src", "/assets/images/setupConnector/not_configured.svg", 1, "image-img"], [1, "userTableContainer"], [1, "table", "userTable", 2, "overflow-y", "auto", "overflow-x", "hidden"], [1, "tableTr", "textUppercase"], ["class", "tableTr", 4, "ngFor", "ngForOf"], [1, "tableTr"], [2, "white-space", "nowrap"], [1, "userListLabel"], [1, "userListName"], [1, "maps-image", 3, "src"], [1, "userNameLink"], [4, "ngIf"], ["class", " tooltip", 4, "ngIf"], [1, "userActionsMenu", 3, "ngClass"], ["href", "javascript:void(0)", "class", "userEditIcon tooltip", 3, "click", 4, "ngIf"], ["href", "javascript:void(0)", "class", "userEditIcon", 3, "click", 4, "ngIf"], ["src", "/assets/images/setupConnector/down.svg", 1, "statusAsset"], [1, "version-link", 3, "click"], [1, "inactive"], ["src", "/assets/images/setupConnector/in-progress.svg", 1, "statusAsset"], [1, "tooltip"], ["src", "/assets/images/setupConnector/upgrade_orange.svg", 1, "click-pointer", 2, "width", "18px", "display", "inline"], ["class", "tooltiptext", 4, "ngIf"], [1, "tooltiptext"], ["href", "javascript:void(0)", 1, "userEditIcon", "tooltip", 3, "click"], ["src", "/assets/images/setupConnector/upgrade.svg", "alt", ".", 1, "img_icon"], ["src", "/assets/images/setupConnector/trouble_connector.svg", "alt", ".", 1, "img_icon"], ["href", "javascript:void(0)", 1, "userEditIcon", 3, "click"], ["src", "/assets/images/setupConnector/delete.svg", "alt", ".", 1, "img_icon"], [1, "modalPopup", "modalPopupLg", "connectorPopup"], ["id", "modalContent", 1, "modalContent-connector"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], [1, "modalbodyWrapper"], [1, "fieldWrapper"], [1, "am-appselector-wrapper"], [1, "services"], ["class", "warning-note", 4, "ngIf"], [3, "ngStyle", 4, "ngFor", "ngForOf"], [1, "modalFooter"], ["id", "btn-connector-save", 1, "commonButton", 3, "ngClass", "click"], [1, "cancelButton", 3, "click"], [1, "warning-note"], [2, "display", "inline", "float", "left", "margin-top", "10px"], ["src", "/assets/images/warning.svg", 2, "width", "30px"], [2, "font-weight", "bold", "font-size", "14px", "padding", "8px", "display", "inline", "float", "left", "width", "85%"], [3, "ngStyle"], [3, "itemData", "selectedServices", "onSelect", "onDeselect"], [1, "modalPopup", "modalPopupSm"], [1, "modalOverlay"], [1, "modalContent", "textCenter"], ["src", "/assets/images/warning.svg", "width", "50", 1, "warningIcon"], [1, "warningPopupHeading"], [1, "primaryButton", 3, "click"]], template: function ConnectorServicesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "span", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, ConnectorServicesComponent_div_4_Template, 5, 3, "div", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵtemplate(6, ConnectorServicesComponent_div_6_Template, 12, 6, "div", 4);
        i0.ɵɵtemplate(7, ConnectorServicesComponent_div_7_Template, 21, 13, "div", 5);
        i0.ɵɵtemplate(8, ConnectorServicesComponent_div_8_Template, 24, 17, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, ConnectorServicesComponent_div_9_Template, 16, 8, "div", 7);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 6, "dashboard-lib.setup.connectorServices.title"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.userRole !== "ReadOnlyAccess");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selectedServices !== undefined && ctx.selectedServices.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedServices && ctx.selectedServices.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showAddServicePopup);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.removeServiceConfirm);
    } }, directives: [i1$2.NgIf, i1$2.NgForOf, i1$2.NgClass, i1$2.NgStyle, ConnectorServiceItemComponent], pipes: [i2.TranslatePipe, SafeUrlPipe, i1$2.DatePipe], styles: [".cmxConnectorWrapper[_ngcontent-%COMP%]{margin:0;position:relative;height:100%;overflow-y:hidden}.cmxConnectorAdd[_ngcontent-%COMP%]{display:block;margin:0 0 30px;height:100%;position:relative}.cmxConnectorHeading[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";font-size:14px;color:#4d4d4d;display:inline-block;margin-top:10px;min-width:100%}.addUuidDiv[_ngcontent-%COMP%]{float:right;clear:right;font-size:16px;font-family:ciscoSansRegular;color:#049fd9;cursor:pointer}.saveUUID[_ngcontent-%COMP%]{width:auto;padding:8px 18px;height:34px;border:1px solid #049fd9;margin-right:20px}.cmxConnectorName[_ngcontent-%COMP%]{max-width:280px;margin-bottom:0;margin-right:20px}.cmxConnectorListWrapper[_ngcontent-%COMP%]{margin:20px 0}.cmxConnectorBox[_ngcontent-%COMP%]{padding:20px 30px;background-color:#fff;border-bottom:1px solid #dddfe2;font-size:16px;font-family:\"ciscoSansLight\";color:#4d4d4d}.cmxConnectorBox[_ngcontent-%COMP%]:hover{background-color:#f6f8f9}.cmxConnectorDeleteBtn[_ngcontent-%COMP%]{float:right;clear:right;margin-top:-8px}.modalPopup.connectorPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease}.modalPopup[_ngcontent-%COMP%] > .modalContent-connector[_ngcontent-%COMP%]{width:60%;right:0;height:100%;z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #abc233;animation:slide .5s forwards}@keyframes slide{65%{right:0}}.modalPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0 30px;color:#545454;font-size:24px;height:initial}.modalPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:24px 0}.modalPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{height:initial;align-items:center;padding:0;background-color:#ffffffe6;z-index:9999}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{padding:24px 30px;height:24px;line-height:32px}.select-menu[_ngcontent-%COMP%]{height:30px;min-width:100px;padding-left:0;border-bottom:1px solid #ddd;background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_down.svg) no-repeat right center;float:left;margin:0 10px;cursor:pointer}.select-menu[_ngcontent-%COMP%]   .first[_ngcontent-%COMP%]{padding:5px 10px;z-index:2;width:100%}.select-item-container[_ngcontent-%COMP%]{width:100%;border:1px solid #ddd;background:#ffffff;max-height:150px;overflow:auto;position:relative;z-index:999}.select-item[_ngcontent-%COMP%]{padding:10px}.select-item-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:not(.first):hover{background:#09f;color:#fff}.select-item-container[_ngcontent-%COMP%] > .selected[_ngcontent-%COMP%]{display:none}.select-item[_ngcontent-%COMP%]   .first[_ngcontent-%COMP%]{cursor:pointer}.select-custom-2[_ngcontent-%COMP%]{width:60%!important;margin:10px 0!important;font-size:15px;outline:none}.fieldLabel[_ngcontent-%COMP%], .fieldValue[_ngcontent-%COMP%], .fieldWrapper[_ngcontent-%COMP%]{padding:10px 0}.fieldWrapper[_ngcontent-%COMP%]:not(:last-child){border-bottom:1px solid #e5e5e5}.accessToken[_ngcontent-%COMP%]   .fieldWrapper[_ngcontent-%COMP%]{border-bottom:none}.controllerForm[_ngcontent-%COMP%]   .fieldWrapper[_ngcontent-%COMP%]{border-bottom:none}.fieldLabel[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans;width:50%;display:inline-block}.fieldValue[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans;width:50%;display:inline-block;font-weight:bold}.modalBody[_ngcontent-%COMP%]   .controllerName[_ngcontent-%COMP%]{font-size:24px;font-weight:bold}.boxWrapper[_ngcontent-%COMP%]{border:1px solid #e5e5e5;padding:10px 20px}.fieldDescriptiveLabel[_ngcontent-%COMP%]{width:80%;display:inline-block;padding:10px 0}.fieldDescriptiveLabel[_ngcontent-%COMP%]   .fieldTitle[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans}.fieldDescriptiveLabel[_ngcontent-%COMP%]   .fieldDescription[_ngcontent-%COMP%]{font-size:12px}.fieldPicker[_ngcontent-%COMP%]{display:inline-block}.fieldPickerTitle[_ngcontent-%COMP%]{font-size:12px;color:#3e3e3e;font-family:ciscoSans;padding:10px 0}.fieldSwitch[_ngcontent-%COMP%]{width:20%;display:inline-block;position:relative;top:-10px;text-align:right}.switch[_ngcontent-%COMP%]{position:relative;display:inline-block;width:60px;height:34px}.switch[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{opacity:0;width:0;height:0}.slider[_ngcontent-%COMP%]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;transition:.4s}.slider[_ngcontent-%COMP%]   ges[_ngcontent-%COMP%]{padding:10px 27px}.slider[_ngcontent-%COMP%]:before{position:absolute;content:\"\";height:26px;width:26px;left:4px;bottom:4px;background-color:#fff;transition:.4s}input[_ngcontent-%COMP%]:checked + .slider[_ngcontent-%COMP%]{background-color:#049fd9}input[_ngcontent-%COMP%]:focus + .slider[_ngcontent-%COMP%]{box-shadow:0 0 1px #049fd9}input[_ngcontent-%COMP%]:checked + .slider[_ngcontent-%COMP%]:before{transform:translate(26px)}.slider.round[_ngcontent-%COMP%]{border-radius:5px}.slider.round[_ngcontent-%COMP%]:before{border-radius:5px}.cmxConnectorForm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .cmxConnectorForm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}.cmxConnectorForm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .select-menu[_ngcontent-%COMP%]{background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_up.svg) no-repeat right center;font-size:14px}.cmxConnectorForm[_ngcontent-%COMP%]   .menuActive[_ngcontent-%COMP%]{background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_down.svg) no-repeat right center!important}.cmxConnectorForm[_ngcontent-%COMP%]   .select-item-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:hover{background:#dfdfdf;color:#000}.cmxConnectorForm[_ngcontent-%COMP%]   .menuActive[_ngcontent-%COMP%] > .select-item.first[_ngcontent-%COMP%]{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .select-item.first[_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;border:none;border-radius:10px}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:hover, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:hover{background-color:#026e97;color:#fff;border:none}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:active, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:active{background-color:#014f6c;color:#fff;border:none}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]{background-color:#fff;color:#049fd9;border-radius:10px;border:1px solid #049fd9;margin-right:10px}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:hover, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:hover{background-color:#026e97;color:#fff;border:none}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:active, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:active{background-color:#014f6c;color:#fff;border:none}.showPassword[_ngcontent-%COMP%]{padding-left:5px;bottom:1px;font-size:12px;font-weight:bold;font-family:ciscoSans;color:#6674c3;cursor:pointer}.showPasswordAT[_ngcontent-%COMP%]{bottom:30px!important}input[type=password][_ngcontent-%COMP%] > span[_ngcontent-%COMP%] + .showPassword[_ngcontent-%COMP%]{color:#6674c3}.select-item-container[_ngcontent-%COMP%]{margin-bottom:40px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{padding-left:33.8px}.table.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:434px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:14px;line-height:20px;letter-spacing:.5px}.circularCheckbox[_ngcontent-%COMP%]{vertical-align:middle;padding-right:15px;display:inline-block}.userDetailLabel[_ngcontent-%COMP%]{display:inline-block}.userNameLink[_ngcontent-%COMP%]{font-size:12px;font-family:\"ciscoSansRegular\";font-weight:bold}.version[_ngcontent-%COMP%], .ipAddress[_ngcontent-%COMP%]{opacity:.8;font-family:\"ciscoSansRegular\";font-size:11px;color:#333;display:block}.userListEmail[_ngcontent-%COMP%]{opacity:.8;font-family:\"ciscoSansRegular\";font-size:11px;color:#333;display:block}.userAccess[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.columnData[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.statusPending[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;font-weight:600;color:#f86969}.confirmResendLink[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";font-size:12px;font-weight:600;color:#049fd9;text-decoration:underline}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%]{text-align:center;display:none;width:115px}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   div.userActionsMenu[_ngcontent-%COMP%]{display:inline}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover{background:#ebf7f9!important}.userTable[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]:hover{background:#fff!important}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   div.userActionsMenu.selected[_ngcontent-%COMP%]{display:block}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative;padding:0 5px;text-decoration:none;outline:none}.userListLabel[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}.userListName[_ngcontent-%COMP%]{display:block;cursor:auto}.userPendingStatus[_ngcontent-%COMP%]{display:block}.width35[_ngcontent-%COMP%]{min-width:35px;display:inline-block;height:20px}.controllerForm[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:calc(100% - 165px)}.controllerForm[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{height:78px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{min-width:600px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0;height:30px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:auto;margin-bottom:0}.warningPopupHeading[_ngcontent-%COMP%]{margin-bottom:15px;font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:16px;line-height:27px;text-align:center;color:#373737}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{padding:0 20px 20px;border-top:none;position:relative;height:auto}.accessTokenValue[_ngcontent-%COMP%]{padding:40px 20px;border:1px solid #c4c4c4;margin:20px 0;word-break:break-all;-webkit-user-select:all;user-select:all}.disabledField[_ngcontent-%COMP%]{background-color:#f2f2f2}.createNewWrapper[_ngcontent-%COMP%]{color:#079fd9;font-family:sans-serif;font-size:14px;cursor:pointer;display:inline-block}.createNewWrapper[_ngcontent-%COMP%]:hover{color:#007199}.paddingR10[_ngcontent-%COMP%]{padding-right:10px}.createNewWrapper.vertical[_ngcontent-%COMP%]{padding-right:20px;margin-right:20px;border-right:1px solid #c4c4c4}span.userAccess.active[_ngcontent-%COMP%]{color:green}span.userAccess.inactive[_ngcontent-%COMP%]{color:#cd5c5c}.customerNameDropdown[_ngcontent-%COMP%]{width:180px!important;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.modalPopup.modalPopupSm[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{width:40%;min-width:360px}.paddingB40[_ngcontent-%COMP%]{padding-bottom:40px}.controllerIPInput[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:disabled, .disabled[_ngcontent-%COMP%]{opacity:.3;cursor:not-allowed;pointer-events:none}.userActionsMenu[_ngcontent-%COMP%]{position:relative;white-space:nowrap}.showMoreIcon[_ngcontent-%COMP%]{margin-left:-15px}.userEditIcon.configure[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:20px}.controllerEditIcon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:14px}.menu-l[_ngcontent-%COMP%]{position:absolute;right:20px;top:35px;border-radius:0;box-shadow:0 0 3px #0000004d}.menu-open-img[_ngcontent-%COMP%]{height:34px}.action-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0;margin:0}select[_ngcontent-%COMP%]{border:none;background:none}.upgrade-icon[_ngcontent-%COMP%]{width:15px;transform:rotate(-90deg);margin-left:10px}.connector-graph[_ngcontent-%COMP%]{margin-top:50px}.connector-graph[_ngcontent-%COMP%]   .connector-graph-loading[_ngcontent-%COMP%]{text-align:center}.chart-legend-count[_ngcontent-%COMP%]{white-space:nowrap}.show-menu-notch[_ngcontent-%COMP%]{position:absolute;right:-1px;background:transparent;top:-10px;width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid #dfdfdf}.show-menu-notch[_ngcontent-%COMP%]   .inner[_ngcontent-%COMP%]{position:relative;right:9px;background:transparent;top:2px;width:0;height:0;border-left:9px solid transparent;border-right:9px solid transparent;border-bottom:9px solid white}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0;height:30px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:auto;margin-bottom:0}.warningPopupHeading[_ngcontent-%COMP%]{margin-bottom:15px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{padding:0 20px 20px;border-top:none;position:relative;height:auto}.manageStreamsContent[_ngcontent-%COMP%]{width:60%!important}.lineChartTitle[_ngcontent-%COMP%]{fill:#111;color:#111;font-size:14px;font-weight:700;font-family:ciscoSans;padding:10px;text-align:center}span.outgoing[_ngcontent-%COMP%]{background-color:#2f7ebb;border:1px solid #4059aa}span.incoming[_ngcontent-%COMP%]{background-color:#be60a6;border:1px solid #be60a6}.legendName[_ngcontent-%COMP%]{font-size:12px;color:#abacac;font-weight:600;font-family:ciscoSansLight}.legendRect[_ngcontent-%COMP%]{display:inline-block;padding:6px;border-radius:3px}.legendTitle[_ngcontent-%COMP%]{font-size:12px;color:#000;font-family:CiscoSans;padding-left:3px;font-weight:300;letter-spacing:.43px}.cli[_ngcontent-%COMP%]{padding-top:15px}.cli[_ngcontent-%COMP%]   .cli-heading[_ngcontent-%COMP%]{font-family:ciscoSansRegular}.cli[_ngcontent-%COMP%]   .messages[_ngcontent-%COMP%]{padding:10px 27px}.cli[_ngcontent-%COMP%]   .cli-commands[_ngcontent-%COMP%]{margin-top:10px;border:1px dashed black;border-radius:15px;padding:20px}.cli[_ngcontent-%COMP%]   .cli-commands[_ngcontent-%COMP%]   .copy-command[_ngcontent-%COMP%]{text-align:right}.cli[_ngcontent-%COMP%]   .cli-commands[_ngcontent-%COMP%]   .copy-command[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-family:FontAwesome!important;cursor:pointer}.cli[_ngcontent-%COMP%]   .cli-commands[_ngcontent-%COMP%]   .commands[_ngcontent-%COMP%]{padding:10px}.success[_ngcontent-%COMP%]{color:green}.error[_ngcontent-%COMP%]{color:#f86969}.warning[_ngcontent-%COMP%]{color:#efa741}.spinner[_ngcontent-%COMP%]{width:1.5rem;height:1.5rem;margin:10px;animation:spinner .7s linear infinite;border-style:solid;border-width:2px;border-radius:50%;box-sizing:border-box;display:inline-block;vertical-align:middle;border-color:#049fd9 #049fd9 #049fd9 transparent}@keyframes spinner{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.wlcRadioLabel[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\"}.wlcRadioButton[_ngcontent-%COMP%]{font-size:20px}.wlcRadioButtonLabel[_ngcontent-%COMP%]{top:2px;position:relative;margin:12px}.pingStats[_ngcontent-%COMP%]{padding:5px 0}.pingStats[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-family:FontAwesome!important}.connectivity-messages[_ngcontent-%COMP%]{border:2px dashed #945454;background-color:#d8d8d8;border-radius:10px;padding:15px}.connectivity-messages[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{padding:2px 0}.manage-connector[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]{margin:20px 0}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]{display:flex}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]{width:100%}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{display:flex}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .primary-heading[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .primary-heading[_ngcontent-%COMP%]{flex:1;font-size:20px;font-weight:bold}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .primary-heading[_ngcontent-%COMP%]   .operation-status[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .primary-heading[_ngcontent-%COMP%]   .operation-status[_ngcontent-%COMP%]{font-size:14px;padding:4px;border-radius:5px;color:#fff}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .fieldSwitch[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .fieldSwitch[_ngcontent-%COMP%]{top:0px}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .secondary-heading[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .secondary-heading[_ngcontent-%COMP%]{padding:10px 0}.manage-connector[_ngcontent-%COMP%]   .controllers[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .controllers[_ngcontent-%COMP%]{margin:20px 0}.manage-connector[_ngcontent-%COMP%]   .no-support[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .no-support[_ngcontent-%COMP%]{color:#ff4500;border-radius:5px;border:1px dotted black;padding:10px}.manage-controller[_ngcontent-%COMP%]   .controllers[_ngcontent-%COMP%]   .noData[_ngcontent-%COMP%]{padding:10px;border:1px solid #eee;text-align:center}.manage-controller[_ngcontent-%COMP%]   .controllers[_ngcontent-%COMP%]   .disable-row[_ngcontent-%COMP%]{pointer-events:none;background-color:#f2f2f2;opacity:.7}.streamAuth[_ngcontent-%COMP%]   .keys[_ngcontent-%COMP%], .certificate[_ngcontent-%COMP%]   .keys[_ngcontent-%COMP%]{border:2px solid #eee;border-radius:5px;padding:20px;height:20vh;overflow-y:scroll;word-break:break-word;white-space:break-spaces}.streamAuth[_ngcontent-%COMP%]   .copyContent[_ngcontent-%COMP%], .certificate[_ngcontent-%COMP%]   .copyContent[_ngcontent-%COMP%]{cursor:pointer;color:#0096d6;float:right}.streamAuth[_ngcontent-%COMP%]   .copyContent[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .certificate[_ngcontent-%COMP%]   .copyContent[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-family:FontAwesome!important}a.iot-stream[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:unset!important}.config-steps[_ngcontent-%COMP%]{padding:20px 0}.config-steps[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{padding:3px 10px}.config-steps[_ngcontent-%COMP%]   .step.command[_ngcontent-%COMP%]{border:1px dashed black;margin:3px 10px;background-color:#d3d3d3;border-radius:3px;font-weight:bold}.config-steps[_ngcontent-%COMP%]   .step.command[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{float:right;cursor:pointer;font-family:FontAwesome!important}.fullscreenlPopup[_ngcontent-%COMP%]   .fullscreenCloseIcon[_ngcontent-%COMP%]{padding:0 30px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease}.fullscreenPopup.wnPopup[_ngcontent-%COMP%]   .fullscreenContent[_ngcontent-%COMP%]{top:70px;width:440px;overflow:visible;position:relative}.fullscreenPopup.wnPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{height:75vh;overflow-y:auto;margin-top:20px;padding:18px 60px 100px}.fullscreenPopup.wnPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{position:relative;padding:0;border-top:none}@media all and (max-width: 640px){.fullscreenPopup.wnPopup[_ngcontent-%COMP%]   .fullscreenContent[_ngcontent-%COMP%]{width:100%}}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenHeader[_ngcontent-%COMP%]{padding:0 30px;color:#39393b;font-size:24px;height:60px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{align-items:center;justify-content:flex-end;background-color:#ffffffe6;z-index:9999}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenCloseIcon[_ngcontent-%COMP%]{padding:0 30px}.fullscreenPopup.importSsidPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease}.fullscreenPopup[_ngcontent-%COMP%] > .fullscreenContent-ssid[_ngcontent-%COMP%]{width:65%;right:5px;height:78.2%;z-index:1001;position:absolute;top:105px;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #abc233;animation:slide .5s forwards}.fullscreenHeader[_ngcontent-%COMP%]{background-color:#fff!important}.fullscreenPopup[_ngcontent-%COMP%]{background:rgba(0,0,0,.8)!important}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{background-color:#fff;padding:18px 30px}.fullscreenPopup[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;top:0;left:0;z-index:99999;overflow:auto}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenOverlay[_ngcontent-%COMP%]{position:absolute;top:5%;left:5%;width:90%;height:85vh;background:rgba(0,0,0,.7);z-index:1000}.fullscreenPopup[_ngcontent-%COMP%] > .fullscreenContent[_ngcontent-%COMP%]{z-index:1001;position:absolute;left:50%;top:150px;transform:translate(-50%);width:60%;background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden;margin-bottom:50px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenHeader[_ngcontent-%COMP%]{padding:18px 30px;color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:relative;height:60px;border-bottom:1px solid #eaeaea}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{background-color:#fff;padding:18px 30px;margin-bottom:40px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]   .fullscreenBodyLeft[_ngcontent-%COMP%]{width:49%;float:left}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]   .fullscreenBodyRight[_ngcontent-%COMP%]{width:49%;float:right}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:relative;position:absolute;bottom:0;left:0;width:100%;border-top:1px solid #eaeaea;background-color:#fff;text-align:left}.fullscreenFooter[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:24px 0 24px 24px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenCloseIcon[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenPrimaryButton[_ngcontent-%COMP%]{margin-right:20px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenSecondaryButton[_ngcontent-%COMP%]{border:0;font-family:\"ciscoSans\";background-color:transparent;font-size:14px;color:#0096d6;outline:none}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenSecondaryButton[_ngcontent-%COMP%]:hover{color:#007199}.fullscreenPopup[_ngcontent-%COMP%]   .squareButtonPrimary[_ngcontent-%COMP%]{padding:10px 18px}.fullscreenPopup.fullscreenPopupSm[_ngcontent-%COMP%] > .fullscreenContent[_ngcontent-%COMP%]{width:30%;min-width:360px}.fullscreenPopup.fullscreenPopupMd[_ngcontent-%COMP%] > .fullscreenContent[_ngcontent-%COMP%]{width:50%;min-width:360px}.fullscreenPopup.fullscreenPopupLg[_ngcontent-%COMP%] > .fullscreenContent[_ngcontent-%COMP%]{width:90%;min-width:360px;top:70px}.fullscreenPopup.warningPopup[_ngcontent-%COMP%]   .fullscreenContent[_ngcontent-%COMP%]{overflow:visible}.fullscreenPopup.warningPopup[_ngcontent-%COMP%]   .fullscreenHeader[_ngcontent-%COMP%]{position:relative;padding-top:66px;border-bottom:none}.fullscreenPopup.warningPopup[_ngcontent-%COMP%]   .fullscreenHeader[_ngcontent-%COMP%]:before{position:absolute;width:80px;height:80px;content:\"\";background:transparent url(/assets/images/notification_icon.svg) no-repeat center;background-size:80px;box-shadow:0 0 3px #0003;border:5px solid #fff;border-radius:50%;left:50%;transform:translate(-50%);top:-40px}.fullscreenPopup.warningPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{padding:40px;border-top:none}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{z-index:1001;position:absolute;left:50%;top:30%;transform:translate(-50%);background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .warningIcon[_ngcontent-%COMP%]{margin-top:5%}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .streamWarningIcon[_ngcontent-%COMP%]{margin-left:45%!important}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .modalHeaders[_ngcontent-%COMP%]{padding:25px 0 5px;color:#000;font-size:20px;font-family:ciscoSansRegular;position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-top:5px;margin-bottom:25px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .circularCheckbox[_ngcontent-%COMP%]{position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:checked:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]{display:flex;justify-content:center}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]   .pmxRadioButtonLabel[_ngcontent-%COMP%]{margin-left:5px!important;font-size:14px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{display:flex;justify-content:center;position:relative!important;border-top:none!important}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]   .secondary-btn-box[_ngcontent-%COMP%]{display:flex;justify-content:center;border:none!important;background:#fff;color:#07a0d9}.warningPopupHeading[_ngcontent-%COMP%]{margin:25px 0 0!important}.modalPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{margin-bottom:0!important}.paddingTop20[_ngcontent-%COMP%]{padding-top:20px}.connector-path-start[_ngcontent-%COMP%]{display:inline;margin-left:15px}.connector-path[_ngcontent-%COMP%]{display:inline;margin-left:5px;color:#09c}.connectorHeader[_ngcontent-%COMP%]{display:inline-block;cursor:pointer;width:1986px;background:#ffffff;padding:25px 180px 10px 50px}.headerinfo[_ngcontent-%COMP%]{display:inline;float:right}.summary[_ngcontent-%COMP%]{display:flex;width:100%;height:125px;background:#ffff;padding:18px 27px 25px 52px;font-size:20px;box-shadow:0 0 1px #bdbdbd}.imageStyle[_ngcontent-%COMP%]{width:75px}.summarySection[_ngcontent-%COMP%]{height:25px;width:100%;float:left;margin-bottom:25px}.leftSummary[_ngcontent-%COMP%]{width:5%;height:100px;float:left}.rightSummary[_ngcontent-%COMP%]{height:100px;display:inline-block;width:65%}.floatleft[_ngcontent-%COMP%]{display:inline-block;float:left;width:10%;font-size:14px}.parameter-text[_ngcontent-%COMP%]{display:inherit}.border[_ngcontent-%COMP%]{border-right:1px solid #dee0e1}.grayDiv[_ngcontent-%COMP%]{height:50%;background:#fafafa}.subHeader[_ngcontent-%COMP%]{padding:0 0 10px 62.5px;font-size:20px;margin-right:49.5px;left:61.5px;top:298.44px;font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:18px;line-height:26px;letter-spacing:.5px;width:100%}.connector-table[_ngcontent-%COMP%]{background:#FFFFFF;margin:0 62.5px}.headerSection[_ngcontent-%COMP%]{font-size:18px!important;font-family:\"ciscoSansRegular\";color:#4d4d4d}.createConnector[_ngcontent-%COMP%]{font-size:14px;float:right;font-family:\"ciscoSansRegular\";color:#07a0d9;margin-right:62.5px}.showHideColumns[_ngcontent-%COMP%]{font-size:14px!important;float:right;font-family:\"ciscoSansRegular\";color:#07a0d9}.header-inner[_ngcontent-%COMP%]{display:inline-block;font-size:16px;padding-left:65px}.header[_ngcontent-%COMP%]{display:inline-block;font-size:18px;width:95%}#link-locdetails-aps[_ngcontent-%COMP%]{display:inline;margin-right:25px}#link-locdetails-metrics[_ngcontent-%COMP%]{display:inline;margin-right:25px}.tokenDiv[_ngcontent-%COMP%]{display:inline;float:right;padding:15px;color:#07a0d9;font-size:14px}.cursorP[_ngcontent-%COMP%]{cursor:pointer;padding:8px}.active-block[_ngcontent-%COMP%]   .active-name[_ngcontent-%COMP%]{color:#059fd9;font-weight:bold;font-family:\"ciscoSansBold\";vertical-align:middle}.active-block[_ngcontent-%COMP%]{border-bottom:5px solid #059fd9;animation:border-animation .1s ease-in-out}.confirmation-popup-wrapper[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:99999;left:0;top:0}.popup-overlay[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:999999;background-color:#0009}.confirmation-popup[_ngcontent-%COMP%]{position:absolute;top:33%;left:50%;transform:translate(-50%);width:40%;height:30%;margin:0 auto;background-color:#fff;box-shadow:0 4px 8px #0000001a;border:0;z-index:1001;display:flex;justify-content:center;flex-direction:column;border-radius:5px}.confirmation-button-wrapper[_ngcontent-%COMP%]{margin:0 auto;width:40%;text-align:center}.confirmation-primary-button[_ngcontent-%COMP%]{border-radius:1.3em;background-color:#09c;color:#fff;font-family:ciscoSansLight;padding:0 18px;font-size:14px;height:34px;line-height:34px;cursor:pointer;float:left}.confirmation-primary-button[_ngcontent-%COMP%]:hover{opacity:.8}.confirmation-cancel[_ngcontent-%COMP%]{color:#848484!important;font-size:14px;text-decoration:none;cursor:pointer;line-height:30px;font-family:\"ciscoSansRegular\"}.confirmation-cancel[_ngcontent-%COMP%]:hover{font-weight:bold}.confirmation-popup-close[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.confirmation-popup-close[_ngcontent-%COMP%]:hover{opacity:.8}.exclamation-icon[_ngcontent-%COMP%]{min-height:70px;min-width:70px;text-align:center;padding:0;position:absolute;left:50%;transform:translate(-50%);top:-20%;border:5px solid #fff;border-radius:50%;background:#fff;box-shadow:0 0 2px #84848480}.confirmation-message[_ngcontent-%COMP%]{text-align:center;padding:25px 0;font-size:15px;display:block;width:82%;margin:0 auto;color:#848484;font-family:\"ciscoSansRegular\"}.info-icon[_ngcontent-%COMP%]{width:20px;height:20px;display:inline-block;cursor:pointer;text-align:center}.btn-connector-create[_ngcontent-%COMP%]{font-size:14px}.emptyStateHeading[_ngcontent-%COMP%]{padding:45px;font-size:14px;font-family:\"ciscoSansRegular\";background:#FFFF;display:inline-block}.leftMargin[_ngcontent-%COMP%]{margin-left:25px}.connector-pat-start[_ngcontent-%COMP%]{margin-left:20px;color:#09c}.breadcrumbSeparator[_ngcontent-%COMP%]{color:#09c}.am-appselector-wrapper[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0}.am-appselector-wrapper[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border:1px solid #eae9e9;padding:10px 20px}.am-appselector-wrapper[_ngcontent-%COMP%]   .am-appselector[_ngcontent-%COMP%]{display:flex;align-items:center}.am-appselector-wrapper[_ngcontent-%COMP%]   .check-sel[_ngcontent-%COMP%]{width:80%}.am-appselector-wrapper[_ngcontent-%COMP%]   .am-appselector-dropdown[_ngcontent-%COMP%]{width:20%}.am-appselector-wrapper[_ngcontent-%COMP%]   .check-label[_ngcontent-%COMP%]{font-weight:bold!important;color:#656565!important;font-size:15px;padding-left:5px}.services[_ngcontent-%COMP%]{font-size:16px;font-family:\"ciscoSansRegular\";padding:5px}.userTableContainer[_ngcontent-%COMP%]{overflow-y:auto}.pagination[_ngcontent-%COMP%]{margin:25px 100px 8px 55px!important}.image-img[_ngcontent-%COMP%]{padding-left:308px;float:right;display:inline}.img_icon[_ngcontent-%COMP%]{width:14px}.click_pointer[_ngcontent-%COMP%]{width:15px}.red-msg[_ngcontent-%COMP%]{color:red}.tooltip[_ngcontent-%COMP%]{position:relative;display:inline}.tooltip[_ngcontent-%COMP%]   .tooltiptext[_ngcontent-%COMP%]{visibility:hidden;width:180px;background-color:#fff;color:#000;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;bottom:125%;left:50%;margin-left:-60px;opacity:0;transition:opacity .3s}.tooltip[_ngcontent-%COMP%]   .tooltiptext[_ngcontent-%COMP%]:after{content:\"\";position:absolute;top:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent transparent transparent}.tooltip[_ngcontent-%COMP%]:hover   .tooltiptext[_ngcontent-%COMP%]{visibility:visible;opacity:1}.disabled[_ngcontent-%COMP%]{opacity:.4;cursor:not-allowed}.table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]{height:50px!important;border:1px solid #DEDEDE;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px}thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]{border-bottom:1px solid #DEDEDE;box-shadow:0 1px 3px #00000040}.table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(even){background:#fff}.inactive[_ngcontent-%COMP%]{color:#cd5c5c}.version-link[_ngcontent-%COMP%]{color:#09c;cursor:pointer;padding:5px}.showServiceRemovalWarning[_ngcontent-%COMP%]{background:#FFFFFF;border:1px solid #FC9D03;box-shadow:0 4px 8px #0000001a;border-radius:2px;padding:15px;margin:5px 5px 15px;width:900px;font-size:14px;font-family:\"ciscoSans\"}.warning-note[_ngcontent-%COMP%]{border:1px solid #FFA000;border-radius:4px;padding:15px;font-size:14px;font-family:CiscoSans;line-height:144.6%;background:#FFFF;color:#202020;width:85%;margin:10px 114px 20px 33px;display:inline-block}.warning-note[_ngcontent-%COMP%]:after, .warning-note[_ngcontent-%COMP%]:before{top:100%;left:50%;border:solid transparent;content:\"\";height:0;width:0;position:absolute;pointer-events:none}.warning-note[_ngcontent-%COMP%]:after{border-color:#88b7d500;border-top-color:#ffa000;border-width:11px;margin-left:-11px}.warning-note[_ngcontent-%COMP%]:before{border-color:#c2e1f500;border-top-color:#ffa000;border-width:17px;margin-left:-17px}.empty_metric_msg[_ngcontent-%COMP%]{font-size:18px;color:#4d4d4d;width:620px;height:400px;padding:40px 0 0 30px;clear:none;float:left}.emptyStateHeading-metric[_ngcontent-%COMP%]{padding:85px!important;font-size:14px;font-family:\"ciscoSans\";background:#FFFF;height:500px;width:100%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConnectorServicesComponent, [{
        type: Component,
        args: [{
                selector: 'app-connector-services',
                templateUrl: './connector-services.component.html',
                styleUrls: ['./connector-services.component.scss']
            }]
    }], function () { return [{ type: DataService }, { type: CMXConnectorsService }, { type: i1$3.DomSanitizer }, { type: i2.TranslateService }]; }, { selectedServices: [{
            type: Input
        }], userRole: [{
            type: Input
        }], allServices: [{
            type: Input
        }], currentConnector: [{
            type: Input
        }], isConnectorAvailable: [{
            type: Input
        }], connectorServices: [{
            type: Output
        }], triggerManageIOTStreams: [{
            type: Output
        }], showServiceUpgrade: [{
            type: Output
        }], triggerManageIOTServices: [{
            type: Output
        }] }); })();

const _c0$1f = function (a0) { return { "showError": a0 }; };
function GenericDropdownComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function GenericDropdownComponent_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.expandDropdown(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$1f, ctx_r0.isError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedItem.name, " ");
} }
const _c1$s = function (a0, a1) { return { "placeHolderColor": a0, "showError": a1 }; };
function GenericDropdownComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function GenericDropdownComponent_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.expandDropdown(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c1$s, ctx_r1.placeHolder !== "Select", ctx_r1.isError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.placeHolderValue, " ");
} }
function GenericDropdownComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function GenericDropdownComponent_div_3_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r12); const item_r10 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.selectItem(item_r10); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r10.name, " ");
} }
function GenericDropdownComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, GenericDropdownComponent_div_3_div_1_Template, 2, 1, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.listItems);
} }
function GenericDropdownComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "dashboard-lib.setup.generic-dropdown.unavailable"));
} }
function GenericDropdownComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function GenericDropdownComponent_div_5_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.expandDropdown(); });
    i0.ɵɵelementEnd();
} }
const _c2$j = function (a0) { return { "dropdownExpand": a0 }; };
class GenericDropdownComponent {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor(dataService, translate) {
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.atDropdownSelect = new EventEmitter();
        this.messageKeys = {};
        this.dropdownExpand = false;
        this.expandDropdown = () => {
            this.dropdownExpand = !this.dropdownExpand;
        };
        this.selectItem = (selectedItem) => {
            this.selectedItem = selectedItem;
            this.atDropdownSelect.emit(selectedItem);
            this.expandDropdown();
        };
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.setup.generic-dropdown.unavailable').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.generic-dropdown.unavailable"] = res;
            });
            this.translate.get('dashboard-lib.setup.generic-dropdown.select').subscribe((res) => {
                this.messageKeys["select"] = res;
            });
        };
    }
    ngOnInit() {
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            this.getStaticText();
        });
        this.placeHolder = this.placeHolder ? this.placeHolder : this.messageKeys["select"];
        if (this.isError == undefined) {
            this.isError = false;
        }
        this.placeHolder = this.placeHolder ? this.placeHolder : this.messageKeys["select"];
        this.placeHolderValue = this.messageKeys["select"] ? this.messageKeys["select"] : this.placeHolder;
        if (this.isError == undefined) {
            this.isError = false;
        }
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
GenericDropdownComponent.ɵfac = function GenericDropdownComponent_Factory(t) { return new (t || GenericDropdownComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
GenericDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GenericDropdownComponent, selectors: [["lib-generic-dropdown"]], inputs: { selectedItem: "selectedItem", placeHolder: "placeHolder", listItems: "listItems", isError: "isError" }, outputs: { atDropdownSelect: "atDropdownSelect" }, decls: 6, vars: 8, consts: [[1, "genericDropdownContainer", 3, "ngClass"], ["class", "selectedDropdown", 3, "ngClass", "click", 4, "ngIf"], ["class", "genericDropdownList", 4, "ngIf"], ["class", "dropdownFilterOverlay", 3, "click", 4, "ngIf"], [1, "selectedDropdown", 3, "ngClass", "click"], [1, "genericDropdownList"], ["class", "eachElement", 3, "click", 4, "ngFor", "ngForOf"], [1, "eachElement", 3, "click"], [1, "eachElement"], [1, "dropdownFilterOverlay", 3, "click"]], template: function GenericDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, GenericDropdownComponent_div_1_Template, 2, 4, "div", 1);
        i0.ɵɵtemplate(2, GenericDropdownComponent_div_2_Template, 2, 5, "div", 1);
        i0.ɵɵtemplate(3, GenericDropdownComponent_div_3_Template, 2, 1, "div", 2);
        i0.ɵɵtemplate(4, GenericDropdownComponent_div_4_Template, 4, 3, "div", 2);
        i0.ɵɵtemplate(5, GenericDropdownComponent_div_5_Template, 1, 0, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c2$j, ctx.dropdownExpand));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listItems && ctx.listItems.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listItems === undefined || ctx.listItems.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownExpand);
    } }, directives: [i1$2.NgClass, i1$2.NgIf, i1$2.NgForOf], pipes: [i2.TranslatePipe], styles: [".genericDropdownContainer[_ngcontent-%COMP%]{width:200px;display:block;margin:10px 0;position:relative}.genericDropdownContainer[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{width:12px;height:12px;color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;top:6px;right:4px;padding:4px;font-size:14px;display:block;content:\"\\e905\";z-index:100}.genericDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{content:\"\\e908\"}.selectedDropdown[_ngcontent-%COMP%]{background-color:#fff;border-bottom:2px solid #dddfe2;width:100%;border-radius:0;cursor:pointer;padding:8px 24px 8px 10px;z-index:101;position:relative;color:#333439;font-family:ciscoSans;font-size:14px}.genericDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]{border-color:#049fd9}.genericDropdownList[_ngcontent-%COMP%]{display:none;width:100%;position:absolute;top:38px;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:103;border-bottom:1px solid rgba(0,0,0,.3);box-shadow:0 0 3px #0000004d}.genericDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .genericDropdownList[_ngcontent-%COMP%]{display:block;background-color:#fff}.genericDropdownContainer[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]{display:block;padding:12px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.genericDropdownContainer[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]:hover{color:#666;background-color:#39393b1a}.dropdownFilterOverlay[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:100;background-color:#ffffff1a}.placeHolderColor[_ngcontent-%COMP%]{color:#898989}.showError[_ngcontent-%COMP%]{border-bottom:2px solid red!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericDropdownComponent, [{
        type: Component,
        args: [{
                selector: "lib-generic-dropdown",
                templateUrl: "./generic-dropdown.component.html",
                styleUrls: ["./generic-dropdown.component.css"]
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }]; }, { selectedItem: [{
            type: Input
        }], placeHolder: [{
            type: Input
        }], listItems: [{
            type: Input
        }], isError: [{
            type: Input
        }], atDropdownSelect: [{
            type: Output
        }] }); })();

/* eslint-disable @typescript-eslint/unbound-method */
const _c0$1e = ["chart"];
const moment$j = moment_;
//import { Any } from 'ng-intercom/src/app/ng-intercom/types/boot-input';
class D3MultilineChartComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.sourceData = [];
        this.bmData = [];
        this.sData = [];
        this.ticks = [];
        this.dateTickValues = [];
        this.tickValues = [];
        window.addEventListener("resize", this.reDraw.bind(this));
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (this.tooltip) {
            this.tooltip.remove();
        }
        if ((!value || value.length == 0))
            return;
        this.sourceData = value;
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    reDraw() {
        // this.chartContainer.nativeElement.remove()
        if (this.tooltip) {
            this.tooltip.remove();
        }
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngAfterViewInit() {
        this.dataService.getMagneticAppIsExpanded(this.unsubscribe$).subscribe((val) => {
            setTimeout(() => {
                // console.log("getMagneticAppIsExpanded", val);
                if (this.sourceData && this.sourceData.length > 0)
                    this.reDraw();
            }, 500);
        });
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => e["style"].opacity = 0);
        });
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg)
            this.svg.remove();
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("transform", `translate(0,
					${this.chartOptions.margin.top - 20})`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg.append("g").attr("transform", `translate(10,20)`);
        this.getxScale();
        this.getyScale();
        this.getLine();
        this.getArea();
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(function (d) {
            return "<div id='bi-tooltip line-chart'></div>";
        });
        this.svg.call(this.tip);
        const body = d3.select(element.closest("body"));
        const container = d3.select(element);
        this.scr = {
            x: window.scrollX,
            y: window.scrollY,
            w: window.innerWidth,
            h: window.innerHeight
        };
        if (!this.chartOptions.isPosTooltip) {
            this.elementAttr = {
                w: isNull(body.node()) ? 0 : body.node().offsetWidth,
                h: body.node().offsetHeight
            };
            this.svgpos = this.getNodePos(this.svg.node(), body);
        }
        else {
            this.elementAttr = {
                w: isNull(container.node()) ? 0 : container.node().offsetWidth,
                h: container.node().offsetHeight
            };
            this.svgpos = this.getNodePos(this.svg.node(), container);
        }
    }
    getNodePos(el, element) {
        var body = element.node();
        for (var lx = 0, ly = 0; el != null && el != body; lx += el.offsetLeft || el.clientLeft,
            ly += el.offsetTop || el.clientTop,
            el = el.offsetParent || el.parentNode)
            ;
        return { x: lx, y: ly };
    }
    draw() {
        let dateArray = [];
        let self = this;
        if (this.chartOptions.xAxisFormat == "date") {
            if (this.chartOptions.xAxisTickFormat != "th" &&
                this.chartOptions.xAxisTickFormat != "") {
                if (this.chartOptions.xTranslate) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left + 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)))
                        .selectAll("text")
                        .style("text-anchor", "end")
                        .attr("dx", "-.8em")
                        .attr("dy", "-.55em")
                        .attr("transform", this.chartOptions.xTranslate);
                }
                else {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)));
                }
            }
            else {
                if (this.dateTickValues.length > 3 &&
                    this.dateTickValues.length <= 8) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(4)
                        .tickFormat(d3.timeFormat("%d %b")));
                }
                else if (this.dateTickValues.length < 3) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(1)
                        .tickFormat(d3.timeFormat("%d %b")));
                }
                else if (this.dateTickValues.length === 3) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(2)
                        .tickFormat(d3.timeFormat("%d %b")));
                }
                else {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .tickFormat(d3.timeFormat("%d %b")));
                }
            }
        }
        else if (this.chartOptions.xAxisFormat == "hour_of_day") {
            const sortedTicks = this.preparexAxisTicks();
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
							${this.chartOptions.margin.left - 15},${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickValues(sortedTicks)
                .tickFormat(d3.timeFormat("%I %p")));
        }
        else if (this.chartOptions.xAxisFormat == "time") {
            let timeFormat = d3.timeFormat("%I %p");
            console.log("D3 multiline :: draw :: hour of day ", this.xScale);
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
							${this.chartOptions.margin.left - 15},${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .ticks(24)
                .tickFormat(d3.timeFormat("%I %p"))
                .tickValues(this.tickValues.filter(function (d) {
                if (dateArray.length > 0 &&
                    dateArray.indexOf(timeFormat(d)) != -1) {
                    return false;
                }
                else {
                    dateArray.push(timeFormat(d));
                    return true;
                }
            })));
        }
        else if (this.chartOptions.xAxisFormat == "day") {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
							${this.chartOptions.margin.left - 15},${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickFormat(d3.timeFormat("%A"))
                .ticks(7));
        }
        else if (this.chartOptions.xAxisFormat === "dateTime") {
            if (this.dateTickValues.length <= 8) {
                const sortedTicks = this.nonRepeativeTicks();
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr("transform", `translate(
								${this.chartOptions.margin.left - 15},${this.height})`)
                    .call(d3
                    .axisBottom(this.xScale)
                    .scale(this.xScale)
                    .tickValues(sortedTicks)
                    .tickFormat(d3.timeFormat("%d %b, %I %p")));
            }
            else {
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr("transform", `translate(
								${this.chartOptions.margin.left - 15},${this.height})`)
                    .call(d3
                    .axisBottom(this.xScale)
                    .scale(this.xScale)
                    .tickFormat(d3.timeFormat("%d %b, %I %p")));
            }
        }
        else if (this.chartOptions.xAxisFormat === "dateTimeMetrics") {
            if (this.chartOptions.yTickValues.length > 0) {
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr("transform", `translate(
						${this.chartOptions.margin.left + 15},${this.height})`)
                    .call(d3
                    .axisBottom(this.xScale)
                    .scale(this.xScale)
                    .ticks(d3.timeHour.every(4))
                    .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)))
                    .selectAll("text")
                    .style("text-anchor", "end")
                    .attr("dx", "-.8em")
                    .attr("dy", "-.55em")
                    .attr("transform", this.chartOptions.xTranslate);
                /* 10 june this.getStatusYScale();
                this.chart.append("g")
                .call(
                        d3.axisLeft(this.yScale)
                        .scale(this.yScale)
                        .tickValues(this.chartOptions.yTickValues)
                    );*/
            }
            else {
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr("transform", `translate(
						${this.chartOptions.margin.left + 15},${this.height})`)
                    .call(d3
                    .axisBottom(this.xScale)
                    .scale(this.xScale)
                    .ticks(d3.timeHour.every(4))
                    .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)))
                    .selectAll("text")
                    .style("text-anchor", "end")
                    .attr("dx", "-.8em")
                    .attr("dy", "-.55em")
                    .attr("transform", this.chartOptions.xTranslate);
            }
        }
        else if (this.chartOptions.xAxisFormat === "time_of_hour") {
            if (this.chartOptions.xAxisTickFormat != "th" &&
                this.chartOptions.xAxisTickFormat != "") {
                if (this.chartOptions.xTranslate) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left + 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(d3.timeMinute.every(10))
                        /*.tickFormat(
                            d3.timeFormat(
                                this.chartOptions.xAxisTickFormat
                            )
                        )*/ .tickFormat(d3.timeFormat("%H:%M %p")))
                        .selectAll("text")
                        .style("text-anchor", "end")
                        .attr("dx", "-.8em")
                        .attr("dy", "-.55em")
                        .attr("transform", this.chartOptions.xTranslate);
                }
                else {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)));
                }
            }
            else {
                if (this.dateTickValues.length > 3 &&
                    this.dateTickValues.length <= 8) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(4)
                        .tickFormat(d3.timeFormat("%H:%M %p")));
                }
                else if (this.dateTickValues.length < 3) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(1)
                        .tickFormat(d3.timeFormat("%H:%M %p")));
                }
                else if (this.dateTickValues.length === 3) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(2)
                        .tickFormat(d3.timeFormat("%H:%M %p")));
                }
                else {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .tickFormat(d3.timeFormat("%H:%M %p")));
                }
            }
            /*	let timeFormat = d3.timeFormat("%H:%M %p");
                console.log("D3 multiline :: draw :: hour of day ", this.xScale);
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr(
                        "transform",
                        `translate(
                                ${this.chartOptions.margin.left - 15},${this.height})`
                    )
                    .call(
                        d3
                            .axisBottom(this.xScale)
                            .scale(this.xScale)
                            .ticks(6)
                            //.ticks(24)
                            .tickFormat(d3.timeFormat("%H:%M %p"))
                            .tickValues(
                                this.tickValues.filter(function (d ,index) {
                                    if (
                                        dateArray.length > 0 &&
                                        dateArray.indexOf(timeFormat(d)) != -1
                                    ) {
                                        return false;
                                    } else {
                                        if(index % 2 == 0)
                                        dateArray.push(timeFormat(d));
                                        return true;
                                    }
                                })
                            )
                    )*/
            //.attr("transform", this.chartOptions.xTranslate);
        }
        else if (this.chartOptions.xAxisFormat == "week_day") {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
							${this.chartOptions.margin.left - 15},${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .ticks(d3.timeDay.every(1))
                .scale(this.xScale)
                .tickFormat(d3.timeFormat("%a"))
            //.ticks(7)
            );
        }
        else {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                /*.attr(
                    "transform",
                    `translate(
                            ${this.chartOptions.margin.left - 15},${this.height})`
                )*/ .attr("transform", this.chartOptions.xTranslate)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickFormat(d3.timeFormat("%d %b")));
        }
        this.chart
            .append("g")
            .attr("class", "y axis")
            .attr("transform", `translate(
						${(this.chartOptions.margin.left + 5)},0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(this.width + 35))
            .tickFormat((d) => this.readableNumber(d, 2)));
        this.chart
            .selectAll(".axis .tick text")
            .attr("fill", "#1d3243")
            .attr("font-size", "9px");
        this.chart.selectAll(".y.axis .tick line").attr("stroke", "#f9f0f0");
        this.chart
            .selectAll(".x.axis .tick line")
            .attr("stroke", "transparent");
        this.chart.selectAll(".axis .domain").attr("stroke", "transparent");
        this.chart
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - (this.chartOptions.margin.left - 15))
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .attr("fill", "#000000")
            .attr("text-anchor", "middle")
            .attr("font-size", "10px")
            .attr("font-family", "ciscoSans")
            .attr("text-transform", "uppercase")
            .style("font-weight", "700")
            .style("line-height", "1.5")
            .text(this.chartOptions.yAxisLabel);
        // this.chart.append("text")
        //   .attr("class", "xAxis-label")
        //   .attr("transform", "translate(" + ((this.width / 2) + 40) + "," + (this.height + 40) + ")")
        //   .attr("fill", "#000000")
        //   .style("text-anchor", "middle")
        //   .text(this.chartOptions.xAxisLabel);
        this.chart
            .append("g")
            .attr("class", "grid")
            .attr("transform", `translate(
						${(this.chartOptions.margin.left + 6)},0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(this.width + 35))
            .tickFormat(() => this.chartOptions.yAxisTickFormat));
        this.chart.selectAll(".grid .tick line").attr("stroke", "transparent");
        this.chart.selectAll(".grid .domain").attr("stroke", "transparent");
        this.chart
            .append("g")
            .attr("class", "x-axis-label")
            .append("text")
            .text(this.chartOptions.xAxisLabel)
            .attr("transform", `translate( 
					${((this.width / 2) + 40)} 
					, ${(this.height + 40)})`)
            .attr("text-anchor", "middle");
        const lines = this.chart.append("g").attr("class", "lines");
        lines
            .selectAll(".line-group")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "line-group")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left - 15)},0)`)
            .append("path")
            .attr("class", "line")
            .attr("d", function (d) {
            return self.valueline(d.values);
        })
            .attr("stroke", function (d) {
            return d.color;
        })
            .attr("fill", "none");
        if (this.chartOptions.drawAvgLine) {
            const avgCnt = this.sourceData[0].avgCnt;
            lines
                .append("line")
                .attr("class", "avg-line")
                .attr("transform", `translate(
							${(this.chartOptions.margin.left + 6)} 
							,0)`)
                .attr("x1", -3)
                .attr("y1", this.yScale(avgCnt))
                .attr("x2", this.width)
                .attr("y2", this.yScale(avgCnt))
                .style("stroke-width", 1)
                .style("stroke", "#005E7D");
        }
        if (this.chartOptions.chartType == "circle") {
            lines
                .selectAll("circle-group")
                .data(this.sourceData)
                .enter()
                .append("g")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left - 15)},0)`)
                .attr("fill", (d) => d.color)
                .selectAll("circle")
                .data((d) => d.values)
                .enter()
                .append("g")
                .attr("class", "circle")
                .append("circle")
                .attr("cx", (d) => this.xScale(d.date))
                .attr("cy", (d) => this.yScale(d.count))
                .attr("r", 4)
                .on("mouseover", function (d, i) {
                if (i.showCustomTooltip) {
                    self.showCustomTooltip(i);
                    self.tip.show(d, this);
                }
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
            if (this.chartOptions.drawVerticalLine) {
                var currentDate = this.sourceData[0].values[this.sourceData[0].values.length - 1].date;
                var currentTime = moment$j(currentDate).format("h A"); // moment.default(currentDate).format("h A");
                lines
                    .append("line")
                    .attr("transform", `translate(
								${(this.chartOptions.margin.left - 15)},0)`)
                    .attr("x1", this.xScale(currentDate))
                    .attr("y1", -8)
                    .attr("x2", this.xScale(currentDate))
                    .attr("y2", this.height)
                    .attr("stroke-width", 1)
                    .attr("stroke", "#049FD9")
                    .attr("stroke-dasharray", 3)
                    .attr("fill", "none");
                lines
                    .append("text")
                    .attr("transform", `translate(
							${(this.chartOptions.margin.left - 15)},0)`)
                    .attr("fill", "#049FD9")
                    .attr("font-size", "11px")
                    .attr("x", this.xScale(currentDate))
                    .attr("y", -10)
                    .attr("text-anchor", "middle")
                    .text(currentTime);
            }
        }
        /*.on("mouseover", function (d) {
      d3.select(this).attr('fill', d.color);
      self.showTooltip(d);
      self.tip.show(d, this);
    })
    .on("mouseout", function (d) {
      d3.select(this).attr('fill', 'transparent');
      self.tip.hide();
    })*/
        if (this.chartOptions.chartType == "area") {
            let areaGroup = this.chart
                .append("g")
                .attr("class", "area-group");
            areaGroup
                .selectAll(".area-group")
                .data(this.sourceData)
                .enter()
                .append("g")
                .attr("class", "area-group")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left - 15)},0)`)
                .append("path")
                .attr("class", "area")
                .attr("d", (d) => this.area(d["values"]))
                .attr("fill", (d) => d.areaColor)
                .style("fill", (d) => d.areaColor)
                .attr("opacity", 0.1);
        }
        if (!self.chartOptions.hideMouseOverEffects) {
            self.showMouseOverTooltip();
        }
    }
    showTooltip(value) {
        let self = this;
        let tipContainer = "";
        // const suffix = value.suffix ? value.suffix : "";
        self.tip.html(function (d) {
            tipContainer += "<div class = 'multiLine-tooltip'>";
            tipContainer +=
                "<div class='multiLine-top'>" + d.displayDate + "</div>";
            tipContainer += "<div class='daily-info'>";
            tipContainer +=
                "<span style='vertical-align:middle; display:table; padding:6px; border-radius: 3px; background-color:" +
                    d.color +
                    "'></span><span class='multiLine-left'>" +
                    d.name +
                    "</span><span class = 'multiLine-right'>" +
                    d.count +
                    "</span>";
            tipContainer += "</div></div>";
            return tipContainer;
        });
    }
    showCustomTooltip(i) {
        let self = this;
        let tipContainer = "";
        // const suffix = value.suffix ? value.suffix : "";
        self.tip.html(function (d) {
            tipContainer += "<div class = 'multiLine-custom-tip'>";
            tipContainer +=
                "<div class='top-left'>" +
                    i.displayKey +
                    "</div><div class='top-right'>" +
                    i.count +
                    "</div>";
            tipContainer += "</div>";
            return tipContainer;
        });
    }
    getxScale() {
        // var parseTime = d3.timeParse("%Y-%m-%dT%H:%M:%SZ"); // "2019-10-23T14:00:00.000Z
        let completeData = [];
        let keyValues = [];
        var self = this;
        this.ticks = [];
        this.dateTickValues = [];
        this.sourceData.forEach(function (d) {
            keyValues = [];
            d["values"].forEach(function (obj) {
                if (self.chartOptions.xAxisFormat === "date" ||
                    self.chartOptions.xAxisFormat === "dateTime" ||
                    self.chartOptions.xAxisFormat === "dateTimeMetrics" ||
                    self.chartOptions.xAxisFormat === "time_of_hour" ||
                    self.chartOptions.xAxisFormat === "week_day") {
                    const parseTime = d3.timeParse(self.chartOptions.xAxisDateFormat);
                    const formatedDate = parseTime(obj.date);
                    if (formatedDate)
                        obj.date = parseTime(obj.date);
                    keyValues.push(obj.date);
                }
                else {
                    keyValues.push(obj.date);
                }
                //obj.count = +obj.count;
                self.ticks.push(obj.date);
                if (self.tickValues.findIndex((i) => i.toString() == obj.date) == -1) {
                    self.tickValues.push(obj.date);
                }
                completeData.push(obj);
            });
        });
        this.dateTickValues = keyValues;
        this.xScale = d3
            .scaleTime()
            .range([
            this.chartOptions.margin.left,
            this.width - this.chartOptions.margin.right
        ])
            .domain(d3.extent(keyValues, function (d) {
            return d;
        }));
    }
    getyScale() {
        if (this.chartOptions.drawAvgLine) {
            const avgCnt = this.sourceData[0].avgCnt;
            this.yScale = d3
                .scaleLinear()
                .range([this.height, 0])
                .domain([
                0,
                d3.max(this.sourceData, function (d) {
                    return d3.max(d["values"], function (obj) {
                        return parseFloat(obj["count"]) > parseFloat(avgCnt)
                            ? parseFloat(obj["count"])
                            : parseFloat(avgCnt);
                    });
                })
            ])
                .nice();
        }
        else {
            this.yScale = d3
                .scaleLinear()
                .range([this.height, 0])
                .domain([
                0,
                d3.max(this.sourceData, function (d) {
                    return d3.max(d["values"], function (obj) {
                        return parseFloat(obj["count"]) > 10
                            ? parseFloat(obj["count"])
                            : 10;
                    });
                })
            ])
                .nice();
        }
    }
    getStatusYScale() {
        this.yScale = d3
            .scaleLinear()
            .range([this.height, 0])
            .domain([
            0,
            1
        ])
            .nice();
    }
    getLine() {
        let self = this;
        this.valueline = d3
            .line()
            .x(function (d) {
            return self.xScale(d["date"]);
        })
            .y(function (d) {
            return self.yScale(d["count"]);
        });
        //.curve(d3.curveMonotoneX)
    }
    getArea() {
        this.area = d3
            .area()
            .x(d => this.xScale(d["date"]))
            .y0(this.height)
            .y1(d => this.yScale(d["count"]));
    }
    readableNumber(value, decimalPoint) {
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return "0";
        }
        decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
        var numCount = value.toPrecision(2).split("e"), // get power
        noOfK = numCount.length === 1
            ? 0
            : Math.floor(Math.min(numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        dividedValue = noOfK < 1
            ? value.toFixed(0 + decimalPoint)
            : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
        finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
        suffix = `${finalValue + ["", "K", "M", "B", "T"][noOfK]}`; // append power
        return suffix;
    }
    // to display alernative ticks
    preparexAxisTicks() {
        this.ticks.forEach((obj, i) => {
            this.ticks.splice(i + 1, 1);
        });
        return this.ticks;
    }
    // to display all ticks for 8 data points
    nonRepeativeTicks() {
        this.ticks.forEach((obj, i) => {
            this.ticks.splice(i, 0);
        });
        return this.ticks;
    }
    showMouseOverTooltip() {
        var self = this;
        const element = self.chartContainer.nativeElement;
        // CREATE HOVER TOOLTIP WITH VERTICAL LINE //
        self.tooltip = d3
            .select(element)
            .append("div")
            .attr("id", "tooltip")
            .style("position", "absolute")
            .style("background-color", "#263b4c")
            .style("padding", 6)
            .style("display", "none");
        self.tooltip
            .transition()
            .duration(300)
            .style("opacity", 0);
        this.mouseG = this.chart
            .append("g")
            .attr("class", "mouse-over-effects");
        /* this.mouseG.append("path") // create vertical line to follow mouse
       .attr("class", "mouse-line")
       .style("stroke", "#A9A9A9")
       .style("stroke-width", lineStroke)
       .style("opacity", "0");*/
        //  var lines = document.getElementsByClassName('line');
        //var data = this.tooltipValues.filter(d => d.name == name);
        // const res_nested = d3
        // 	.nest() // necessary to nest data so self keys represent each vehicle category
        // 	.key((d) => d["name"])
        // 	.entries(this.sourceData);
        var res_nested = d3.group(this.sourceData, (d) => d["name"]);
        var mousePerLine = this.mouseG
            .selectAll(".mouse-per-line")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "mouse-per-line");
        mousePerLine
            .append("circle")
            .attr("r", 4)
            .attr("stroke", function (d) {
            return d.color;
        })
            .attr("fill", "none")
            .style("opacity", "0");
        this.mouseG
            .append("svg:rect") // append a rect to catch mouse movements on canvas
            .attr("width", this.width)
            .attr("height", this.height)
            .attr("transform", `translate(
					${this.chartOptions.margin.left - 15},0)`)
            .attr("fill", "none")
            .attr("pointer-events", "all")
            .on("mouseout", function () {
            // on mouse out hide line, circles and text
            d3.select(element).select(".mouse-line").style("opacity", "0");
            d3.select(element)
                .selectAll(".mouse-per-line circle")
                .style("opacity", "0");
            d3.select(element)
                .selectAll(".mouse-per-line text")
                .style("opacity", "0");
            setTimeout(() => {
                var displayAtrr = d3
                    .select(element)
                    .select("#tooltip")
                    .style("display");
                if (displayAtrr && displayAtrr === "block")
                    d3.select(element)
                        .select("#tooltip")
                        .style("display", "none");
                self.tooltip.style('opacity', 0);
            }, 100);
        })
            .on("mouseover", function () {
            // on mouse in show line, circles and text
            d3.select(element).select(".mouse-line").style("opacity", "1");
            d3.select(element)
                .selectAll(".mouse-per-line circle")
                .style("opacity", "1");
            d3.select(element).select("#tooltip").style("display", "block");
            self.tooltip
                .transition()
                .duration(300)
                .style("opacity", 1);
        })
            .on("mousemove", function (d) {
            // update tooltip content, line, circles and text when mouse moves
            const mouse = d3.pointer(d, this);
            d3.select(element)
                .selectAll(".mouse-per-line")
                .attr("transform", function (d) {
                const xDate = self.xScale.invert(mouse[0]); // use 'invert' to get date corresponding to distance from mouse position relative to svg
                const bisect = d3.bisector(function (d) {
                    return d["date"];
                }).left; // retrieve row index of date on parsed csv
                const idx = bisect(d["values"], xDate);
                d3.select(element)
                    .select(".mouse-line")
                    .attr("d", function () {
                    var data = "M" + self.xScale(d["values"][idx]["date"]) + "," + (self.height);
                    data += " " + self.xScale(d["values"][idx]["date"]) + "," + 0;
                    return data;
                });
                let xTrans;
                let yTrans = 0.0;
                if (d["values"][idx]) {
                    xTrans =
                        parseFloat(self.xScale(d["values"][idx]["date"])) +
                            (self.chartOptions.margin.left - 15);
                    yTrans = self.yScale(d["values"][idx]["count"]);
                }
                else {
                    d3.select(element)
                        .selectAll(".mouse-per-line circle")
                        .style("opacity", "0");
                    xTrans = self.chartOptions.margin.left;
                }
                return `translate(${xTrans},${yTrans})`;
            });
            if (self.chartOptions.defaultTooltipPos) {
                self.defaultTooltip(d, mouse);
            }
            else {
                self.updateTooltipContent(d, mouse);
            }
        })
            .on("mouseout", function (d, i) {
            self.tooltip.style('opacity', 0);
            self.tooltip.style('display', "none");
        });
    }
    defaultTooltip(event, mouse) {
        var self = this;
        self.tooltip.selectAll("div").remove();
        var pageX = `${(event.pageX + 20) / 2}px`;
        var pageY = `${(event.pageY - 20) / 10}px`;
        let index = 0;
        self.tooltip
            .style("display", "block")
            .style("left", pageX)
            .style("top", pageY)
            .style("font-size", 11.5)
            .style("z-index", "1000")
            // .style('min-width', '220px')
            .selectAll()
            .data(self.sourceData)
            .enter()
            .append("div")
            .style("color", (d) => {
            // return d.color
            return "#fff";
        })
            .style("font-size", 10)
            .html(d => {
            var xDate = self.xScale.invert(mouse[0]);
            var bisect = d3.bisector(function (d) {
                return d["date"];
            }).left;
            var idx = bisect(d.values, xDate);
            idx = idx - 1;
            if (d.values[idx]) {
                console.log(`line chart :: tool tip :: if value    ${idx}   ,
						${d.values[idx]}`);
                self.tooltip.style("min-width", "220px");
                self.tooltip.style("display", "block");
                // self.tooltip.style("padding", "10px 15px");
                index += 1;
                const values = index == 1
                    ? `<div class='multiLine-top'> ${d.values[idx].displayDate} </div>`
                    : ``;
                return `<div class = 'multiLine-tooltip'>${values}
					<div class='daily-info'> 
					<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:
					${d.values[idx].color}
					'></span><span class='multiLine-left'> 
					${d.values[idx].name}
					</span><span class = 'multiLine-right'> 
					${d.values[idx].count}
					</span> 
					</div></div>`;
            }
            else {
                self.tooltip.style("min-width", "0");
                self.tooltip.style("padding", "0");
            }
        });
    }
    updateTooltipContent(event, mouse) {
        var self = this;
        var dist = { x: 10, y: 10 };
        var m = d3.pointer(event, self.svg.node());
        self.scr.x = window.scrollX;
        self.scr.y = window.scrollY;
        m[0] += self.svgpos.x;
        m[1] += self.svgpos.y;
        self.tooltip.selectAll("div").remove();
        var index = 0;
        self.tooltip.style("right", "");
        self.tooltip.style("left", "");
        self.tooltip.style("bottom", "");
        self.tooltip.style("top", "");
        if (self.chartOptions.isPopup) {
            if (m[0] > self.scr.x + self.elementAttr.w / 2) {
                self.tooltip.style("right", (self.elementAttr.w - m[0] + dist.x) + "px");
            }
            else {
                self.tooltip.style("left", (m[0] + dist.x) + "px");
            }
        }
        else {
            if (m[0] > self.scr.x + self.scr.w / 2) {
                self.tooltip.style("right", (self.elementAttr.w - m[0] + dist.x) + "px");
            }
            else {
                self.tooltip.style("left", (m[0] + dist.x) + "px");
            }
        }
        self.tooltip.style("top", "0px");
        self.tooltip
            .style('display', 'block')
            .style('font-size', 11.5)
            .style('z-index', "1000")
            .style('padding', '10px 15px')
            .style('min-width', '220px')
            .selectAll()
            .data(self.sourceData).enter() // for each vehicle category, list out name and price of premium
            .append('div')
            .style('color', d => {
            return "#fff";
        })
            .style('font-size', 10)
            .html(d => {
            let tipContainer = '';
            var xDate = self.xScale.invert(mouse[0]);
            var bisect = d3.bisector(function (d) { return d["date"]; }).left;
            var idx = bisect(d.values, xDate);
            if (d.values[idx]) {
                index += 1;
                return "<div class = 'multiLine-tooltip'>" + ((index == 1) ? "<div class='multiLine-top'>" + d.values[idx].displayDate + "</div>" : "")
                    + "<div class='daily-info'>" + "<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:" + d.values[idx].color + "'></span><span class='multiLine-left'>" + d.values[idx].name + "</span><span class = 'multiLine-right'>" + d.values[idx].count + "</span>"
                    + "</div></div>";
            }
            else {
                self.tooltip.style("display", "none");
            }
            return "";
        });
    }
}
D3MultilineChartComponent.ɵfac = function D3MultilineChartComponent_Factory(t) { return new (t || D3MultilineChartComponent)(i0.ɵɵdirectiveInject(DataService)); };
D3MultilineChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3MultilineChartComponent, selectors: [["lib-d3-multiline-chart"]], viewQuery: function D3MultilineChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1e, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart"], ["chart", ""]], template: function D3MultilineChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3MultilineChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-multiline-chart",
                templateUrl: "./d3-multiline-chart.component.html",
                styleUrls: ["./d3-multiline-chart.component.scss"]
            }]
    }], function () { return [{ type: DataService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

function TokenGenerationV3Component_div_0_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.accessCodeValue, " ");
} }
function TokenGenerationV3Component_div_0_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function TokenGenerationV3Component_div_0_div_15_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(2); return ctx_r3.copyAccessToken(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cbContent", ctx_r2.accessCodeValue);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.setup.tokenGeneration.copy"), " ");
} }
function TokenGenerationV3Component_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 4);
    i0.ɵɵlistener("click", function TokenGenerationV3Component_div_0_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.hidePopup(); });
    i0.ɵɵtext(6, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 5);
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 6);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, TokenGenerationV3Component_div_0_div_13_Template, 3, 1, "div", 7);
    i0.ɵɵelementStart(14, "div", 8);
    i0.ɵɵtemplate(15, TokenGenerationV3Component_div_0_div_15_Template, 3, 4, "div", 9);
    i0.ɵɵelementStart(16, "div", 10);
    i0.ɵɵelementStart(17, "a", 11);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div");
    i0.ɵɵelementStart(21, "div", 12);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "span", 13);
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(27, "br");
    i0.ɵɵelementStart(28, "div", 14);
    i0.ɵɵtext(29);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "span", 13);
    i0.ɵɵtext(32);
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(34, "br");
    i0.ɵɵelementStart(35, "div", 14);
    i0.ɵɵtext(36, "Login to your connector UI and configure the token. Follow the ");
    i0.ɵɵelementStart(37, "a", 11);
    i0.ɵɵtext(38, " documentation");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(39, " if you haven't setup your connector yet.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.title);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 12, "dashboard-lib.setup.tokenGeneration.config"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.accessTokenError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showAccessCodeString === true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showAccessCodeString === true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r0.connectorConfigureGuide, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 14, "dashboard-lib.setup.tokenGeneration.documentation"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 16, "dashboard-lib.setup.tokenGeneration.desc"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 18, "dashboard-lib.setup.tokenGeneration.step1"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(30, 20, "dashboard-lib.setup.tokenGeneration.step1-desc"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(33, 22, "dashboard-lib.setup.tokenGeneration.step2"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("href", ctx_r0.connectorConfigureGuide, i0.ɵɵsanitizeUrl);
} }
class TokenGenerationV3Component {
    constructor(cmxOnPremService, dataService, authService, translate) {
        this.cmxOnPremService = cmxOnPremService;
        this.dataService = dataService;
        this.authService = authService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.accessTokenFlag = false;
        this.id = "";
        this.url = "";
        this.idParam = "";
        this.hideAccessToken = new EventEmitter();
        this.accessTokenError = "";
        this.accessCodeValue = "";
        this.showAccessCodeString = false;
        this.connectorConfigureGuide = "";
        this.messageKeys = {};
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.setup.tokenGeneration.config').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.tokenGeneration.config"] = res;
            });
            this.translate.get('dashboard-lib.setup.tokenGeneration.documentation').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.tokenGeneration.documentation"] = res;
            });
            this.translate.get('dashboard-lib.setup.tokenGeneration.desc').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.tokenGeneration.desc"] = res;
            });
            this.translate.get('dashboard-lib.setup.tokenGeneration.step1').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.tokenGeneration.step1"] = res;
            });
            this.translate.get('dashboard-lib.setup.tokenGeneration.step1-desc').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.tokenGeneration.step1-desc"] = res;
            });
            this.translate.get('dashboard-lib.setup.tokenGeneration.step2').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.tokenGeneration.step2"] = res;
            });
            this.translate.get('dashboard-lib.setup.tokenGeneration.copy').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.tokenGeneration.copy"] = res;
            });
            this.translate.get('dashboard-lib.setup.tokenGeneration.errorMessage').subscribe((res) => {
                this.messageKeys["errorMessage"] = res;
            });
        };
        this.getProperties = () => {
            this.authService.getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$).then(properties => {
                this.connectorConfigureGuide = properties['value'].connectorConfigureGuide;
            });
        };
        this.hidePopup = () => {
            this.showAccessCodeString = false;
            this.accessCodeValue = "";
            this.hideAccessToken.emit();
        };
        this.getAccessTokenWithoutCredentials = () => {
            this.dataService.display(true);
            const obj = { [this.idParam]: this.id };
            this.cmxOnPremService
                .getAccessToken(obj, this.url)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.data) {
                    this.accessCodeValue =
                        response.data.token || response.data;
                    this.accessCodeValue = this.accessCodeValue.trim();
                    this.showAccessCodeString = true;
                    this.accessCodeValue = this.accessCodeValue.trim();
                    this.dataService.display(false);
                }
                else {
                    this.dataService.setToastMessage(response.message, 4000, null, null, "error");
                    this.dataService.display(false);
                    this.hidePopup();
                }
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["errorMessage"], 4000, null, null, "error");
                this.hidePopup();
            });
        };
        this.copyAccessToken = () => {
            //this.hidePopup(); //7june
            this.dataService.setToastMessage("Token copied.", 2000, null, null, "success");
        };
    }
    ngOnInit() {
        this.getAccessTokenWithoutCredentials();
        this.getProperties();
        console.log("Doc link is ", this.connectorConfigureGuide);
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
TokenGenerationV3Component.ɵfac = function TokenGenerationV3Component_Factory(t) { return new (t || TokenGenerationV3Component)(i0.ɵɵdirectiveInject(CmxOnpremService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
TokenGenerationV3Component.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TokenGenerationV3Component, selectors: [["app-token-generation-v3"]], inputs: { accessTokenFlag: "accessTokenFlag", id: "id", url: "url", idParam: "idParam", title: "title" }, outputs: { hideAccessToken: "hideAccessToken" }, decls: 1, vars: 1, consts: [["class", "modalPopup modalPopupLg tokenGeneration", 4, "ngIf"], [1, "modalPopup", "modalPopupLg", "tokenGeneration"], ["id", "modalContent", 1, "modalContent-ssid"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], [1, "fieldWrapper", "error"], ["style", "background: #eee;", 4, "ngIf"], [1, "copy-token"], ["class", "commonButton_hollow border_r", "ngxClipboard", "", 3, "cbContent", "click", 4, "ngIf"], [1, "doc_link"], ["target", "_blank", 2, "color", "#0096d6", 3, "href"], [1, "line1"], [1, "step"], [1, "line2"], [2, "background", "#eee"], ["id", "accessCode", 1, "accessTokenValue"], ["ngxClipboard", "", 1, "commonButton_hollow", "border_r", 3, "cbContent", "click"]], template: function TokenGenerationV3Component_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, TokenGenerationV3Component_div_0_Template, 40, 24, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.accessTokenFlag);
    } }, directives: [i1$2.NgIf, i5$1.ClipboardDirective], pipes: [i2.TranslatePipe], styles: [".fieldLabel[_ngcontent-%COMP%], .fieldWrapper[_ngcontent-%COMP%]{padding:10px 0}.fieldLabel[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans}input[type=password][_ngcontent-%COMP%], .userPassword[_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}input[type=text][_ngcontent-%COMP%]:focus, input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}.modalPopup.tokenGeneration[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease}.modalPopup[_ngcontent-%COMP%] > .modalContent-ssid[_ngcontent-%COMP%]{width:65%;right:0;height:100%;z-index:1001;position:absolute;top:0px;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #abc233;animation:slide .5s forwards}@keyframes slide{65%{right:0}}.modalPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0 30px;color:#545454;font-size:26px;height:100px;line-height:100px}.modalPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{align-items:center;background-color:#ffffffe6;z-index:9999}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{padding:0 30px}.modalContent-ssid[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{border:none}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;border:none;border-radius:10px}.primaryButton[_ngcontent-%COMP%]{height:34px;border-radius:6px;background-color:#0096d6;color:#fff;font-family:\"ciscoSansRegular\";text-align:center;cursor:pointer;display:inline-table;vertical-align:middle;font-size:14px;padding:6px 18px;outline:none;border:none}.disabledButton[_ngcontent-%COMP%]{background-color:#81cfec;border-color:#81cfec;cursor:not-allowed;opacity:.65}.disabledField[_ngcontent-%COMP%]{background-color:#f2f2f2}.commonButton[_ngcontent-%COMP%]:focus, .commonButton[_ngcontent-%COMP%]:hover, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:hover{background-color:#026e97;color:#fff;border:none}.commonButton[_ngcontent-%COMP%]:active, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:active{background-color:#014f6c;color:#fff;border:none}.showPassword[_ngcontent-%COMP%]{padding-left:5px;bottom:10px;position:absolute;font-size:12px;font-weight:bold;font-family:ciscoSans;color:#6674c3;cursor:pointer}.showPasswordAT[_ngcontent-%COMP%]{bottom:30px!important}input[type=password][_ngcontent-%COMP%] > span[_ngcontent-%COMP%] + .showPassword[_ngcontent-%COMP%]{color:#6674c3}.width35[_ngcontent-%COMP%]{min-width:35px;display:inline-block;height:20px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0;height:30px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:auto;margin-bottom:0}.warningPopupHeading[_ngcontent-%COMP%]{margin-bottom:15px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{padding:0 20px 20px;border-top:none;position:relative;height:auto}.accessTokenValue[_ngcontent-%COMP%]{padding:40px 20px;border:1px solid #c4c4c4;margin:20px 0;word-break:break-all;-webkit-user-select:all;user-select:all;border-style:dashed}.commonButton_hollow[_ngcontent-%COMP%]{text-align:center;cursor:pointer;display:inline-table;vertical-align:middle;font-size:16px;font-weight:bold;color:#0096d6;outline:none;background-color:transparent;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;display:inline}.border_r[_ngcontent-%COMP%]{border-right:1px solid #efefef}.copy-token[_ngcontent-%COMP%]{display:inline-block}.doc_link[_ngcontent-%COMP%]{display:inline;color:#0096d6;outline:none;background-color:transparent;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;padding-left:14px}.line1[_ngcontent-%COMP%]{padding:20px 0 10px;top:646.24px;font-family:\"ciscoSansThin\";font-size:14px;line-height:19px;letter-spacing:.5px}.line2[_ngcontent-%COMP%]{padding:5px 8px 24px 0;font-size:14px;font-family:\"ciscoSansThin\"}.step[_ngcontent-%COMP%]{font-family:\"CiscoSans\";margin-top:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TokenGenerationV3Component, [{
        type: Component,
        args: [{
                selector: 'app-token-generation-v3',
                templateUrl: './token-generation-v3.component.html',
                styleUrls: ['./token-generation-v3.component.scss']
            }]
    }], function () { return [{ type: CmxOnpremService }, { type: DataService }, { type: AuthService }, { type: i2.TranslateService }]; }, { accessTokenFlag: [{
            type: Input
        }], id: [{
            type: Input
        }], url: [{
            type: Input
        }], idParam: [{
            type: Input
        }], title: [{
            type: Input
        }], hideAccessToken: [{
            type: Output
        }] }); })();

function ConnectorTroubleshootComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.title);
} }
function ConnectorTroubleshootComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.setup.connTroubleshoot.title"));
} }
function ConnectorTroubleshootComponent_div_0_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.cmxConnectorError, " ");
} }
function ConnectorTroubleshootComponent_div_0_div_7_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("click", function ConnectorTroubleshootComponent_div_0_div_7_div_11_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(3); return ctx_r8.upgradeConnector(ctx_r8.selectedConnector); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.setup.connTroubleshoot.upgrade"), " ");
} }
function ConnectorTroubleshootComponent_div_0_div_7_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 18);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 19);
    i0.ɵɵelementStart(9, "label", 20);
    i0.ɵɵelementStart(10, "input", 21);
    i0.ɵɵlistener("click", function ConnectorTroubleshootComponent_div_0_div_7_div_24_Template_input_click_10_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(3); return ctx_r10.enableHotspotDebug(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "span", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "dashboard-lib.setup.connTroubleshoot.orDebug"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 5, "dashboard-lib.setup.connTroubleshoot.orDebugDesc"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", ctx_r7.selectedConnector.hotspot.service.enableDebug);
} }
function ConnectorTroubleshootComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, ConnectorTroubleshootComponent_div_0_div_7_div_1_Template, 2, 1, "div", 9);
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 11);
    i0.ɵɵelementStart(5, "div", 12);
    i0.ɵɵlistener("click", function ConnectorTroubleshootComponent_div_0_div_7_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.restartConnector(ctx_r12.selectedConnector); });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 13);
    i0.ɵɵlistener("click", function ConnectorTroubleshootComponent_div_0_div_7_Template_div_click_8_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.uploadConnectorLogs(ctx_r14.selectedConnector); });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, ConnectorTroubleshootComponent_div_0_div_7_div_11_Template, 3, 3, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 15);
    i0.ɵɵelementStart(13, "div", 16);
    i0.ɵɵelementStart(14, "div", 17);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 18);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 19);
    i0.ɵɵelementStart(21, "label", 20);
    i0.ɵɵelementStart(22, "input", 21);
    i0.ɵɵlistener("click", function ConnectorTroubleshootComponent_div_0_div_7_Template_input_click_22_listener() { i0.ɵɵrestoreView(_r13); const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.enableDebug(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(23, "span", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(24, ConnectorTroubleshootComponent_div_0_div_7_div_24_Template, 12, 7, "div", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.cmxConnectorError !== "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.selectedConnector.name);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 9, "dashboard-lib.setup.connTroubleshoot.restart"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 11, "dashboard-lib.setup.connTroubleshoot.upload"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.selectedConnector.report && ctx_r3.selectedConnector.report.current_version !== ctx_r3.selectedConnector.report.upgrade.latest);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 13, "dashboard-lib.setup.connTroubleshoot.debug"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 15, "dashboard-lib.setup.connTroubleshoot.desc"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", ctx_r3.selectedConnector.service.enableDebug);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.title !== "Troubleshoot Connector");
} }
function ConnectorTroubleshootComponent_div_0_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.cmxConnectorError, " ");
} }
function ConnectorTroubleshootComponent_div_0_div_8_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 36);
    i0.ɵɵelementStart(5, "div", 37);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 38);
    i0.ɵɵlistener("click", function ConnectorTroubleshootComponent_div_0_div_8_div_11_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(3); return ctx_r20.copyToken(ctx_r20.keyCopy); });
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div");
    i0.ɵɵelementStart(11, "span", 39);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 40);
    i0.ɵɵelementStart(15, "div", 41);
    i0.ɵɵelementStart(16, "div", 42);
    i0.ɵɵtext(17, "1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div");
    i0.ɵɵelementStart(19, "span", 39);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(22, "div", 43);
    i0.ɵɵelementStart(23, "div", 41);
    i0.ɵɵelementStart(24, "div", 42);
    i0.ɵɵtext(25, "2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div");
    i0.ɵɵelementStart(27, "span", 39);
    i0.ɵɵtext(28);
    i0.ɵɵpipe(29, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(30, "div", 43);
    i0.ɵɵelementStart(31, "div", 41);
    i0.ɵɵelementStart(32, "div", 42);
    i0.ɵɵtext(33, "3");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div");
    i0.ɵɵelementStart(35, "span", 39);
    i0.ɵɵtext(36);
    i0.ɵɵpipe(37, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(38, "div", 43);
    i0.ɵɵelementStart(39, "div", 41);
    i0.ɵɵelementStart(40, "div", 42);
    i0.ɵɵtext(41, "4");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div");
    i0.ɵɵelementStart(43, "span", 39);
    i0.ɵɵtext(44);
    i0.ɵɵpipe(45, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 9, "dashboard-lib.setup.connTroubleshoot.reset"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r17.pwdResetKey);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("cbContent", ctx_r17.pwdResetKey);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 11, "dashboard-lib.setup.connTroubleshoot.keyCopy"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 13, "dashboard-lib.setup.connTroubleshoot.steps"));
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 15, "dashboard-lib.setup.connTroubleshoot.login"));
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(29, 17, "dashboard-lib.setup.connTroubleshoot.forgot"));
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(37, 19, "dashboard-lib.setup.connTroubleshoot.key"));
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(45, 21, "dashboard-lib.setup.connTroubleshoot.newPass"));
} }
function ConnectorTroubleshootComponent_div_0_div_8_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelement(1, "img", 45);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "dashboard-lib.setup.connTroubleshoot.title"), " ");
} }
function ConnectorTroubleshootComponent_div_0_div_8_div_17_div_1_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 53);
    i0.ɵɵlistener("click", function ConnectorTroubleshootComponent_div_0_div_8_div_17_div_1_span_7_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r28); const service_r23 = i0.ɵɵnextContext().$implicit; const ctx_r27 = i0.ɵɵnextContext(4); return ctx_r27.enableDebugForServices(ctx_r27.selectedConnector.id, service_r23.service); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span", 54);
    i0.ɵɵelement(4, "img", 55);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.setup.connTroubleshoot.debug"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "dashboard-lib.setup.connTroubleshoot.debugRun"), " ");
} }
function ConnectorTroubleshootComponent_div_0_div_8_div_17_div_1_span_8_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 56);
    i0.ɵɵlistener("click", function ConnectorTroubleshootComponent_div_0_div_8_div_17_div_1_span_8_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r31); const service_r23 = i0.ɵɵnextContext().$implicit; const ctx_r30 = i0.ɵɵnextContext(4); return ctx_r30.disableDebugForServices(ctx_r30.selectedConnector.id, service_r23.service); });
    i0.ɵɵtext(1, "Disable Debug Mode");
    i0.ɵɵelementEnd();
} }
function ConnectorTroubleshootComponent_div_0_div_8_div_17_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "span", 49);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 50);
    i0.ɵɵlistener("click", function ConnectorTroubleshootComponent_div_0_div_8_div_17_div_1_Template_span_click_4_listener() { const restoredCtx = i0.ɵɵrestoreView(_r34); const service_r23 = restoredCtx.$implicit; const ctx_r33 = i0.ɵɵnextContext(4); return ctx_r33.uploadLogForServices(ctx_r33.selectedConnector.id, service_r23.service); });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, ConnectorTroubleshootComponent_div_0_div_8_div_17_div_1_span_7_Template, 7, 6, "span", 51);
    i0.ɵɵtemplate(8, ConnectorTroubleshootComponent_div_0_div_8_div_17_div_1_span_8_Template, 2, 0, "span", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r23 = ctx.$implicit;
    const ctx_r22 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r22.serviceNameDisplayName.get(service_r23.service));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "dashboard-lib.setup.connTroubleshoot.upload"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", service_r23.logState !== "ENABLED");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", service_r23.logState === "ENABLED");
} }
function ConnectorTroubleshootComponent_div_0_div_8_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵtemplate(1, ConnectorTroubleshootComponent_div_0_div_8_div_17_div_1_Template, 9, 6, "div", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r19.debugStatus);
} }
const _c0$1d = function (a0) { return { "subheader_action_click": a0 }; };
const _c1$r = function (a0) { return { "imageRotate": a0 }; };
function ConnectorTroubleshootComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, ConnectorTroubleshootComponent_div_0_div_8_div_1_Template, 2, 1, "div", 9);
    i0.ɵɵelementStart(2, "div", 26);
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 28);
    i0.ɵɵlistener("click", function ConnectorTroubleshootComponent_div_0_div_8_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(2); return ctx_r35.toggleResetPwdKey(ctx_r35.selectedConnector.id); });
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 29);
    i0.ɵɵelement(10, "img", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, ConnectorTroubleshootComponent_div_0_div_8_div_11_Template, 46, 23, "div", 31);
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵelementStart(13, "div", 32);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, ConnectorTroubleshootComponent_div_0_div_8_div_16_Template, 4, 3, "div", 33);
    i0.ɵɵtemplate(17, ConnectorTroubleshootComponent_div_0_div_8_div_17_Template, 2, 1, "div", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.cmxConnectorError !== "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" Connector Name: ", ctx_r4.selectedConnector.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c0$1d, ctx_r4.imageState == true));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 9, "dashboard-lib.setup.connTroubleshoot.reset"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c1$r, ctx_r4.imageState == true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.showResetPwdKey);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 11, "dashboard-lib.setup.connTroubleshoot.service"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.serviceList == undefined || ctx_r4.serviceList.length == 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.debugStatus && ctx_r4.debugStatus.length > 0);
} }
function ConnectorTroubleshootComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, ConnectorTroubleshootComponent_div_0_div_3_Template, 2, 1, "div", 4);
    i0.ɵɵtemplate(4, ConnectorTroubleshootComponent_div_0_div_4_Template, 3, 3, "div", 4);
    i0.ɵɵelementStart(5, "span", 5);
    i0.ɵɵlistener("click", function ConnectorTroubleshootComponent_div_0_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(); return ctx_r37.openManageConnectorPopup(false, {}); });
    i0.ɵɵtext(6, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, ConnectorTroubleshootComponent_div_0_div_7_Template, 25, 17, "div", 6);
    i0.ɵɵtemplate(8, ConnectorTroubleshootComponent_div_0_div_8_Template, 18, 17, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.title);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.title == undefined);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedConnector.version !== "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedConnector.version == "V3");
} }
class ConnectorTroubleshootComponent {
    constructor(dataService, translate, cmxConnectorsService) {
        this.dataService = dataService;
        this.translate = translate;
        this.cmxConnectorsService = cmxConnectorsService;
        this.unsubscribe$ = new Subject();
        this.refreshConnectorList = new EventEmitter();
        this.emitClosePopup = new EventEmitter();
        this.cmxConnectorError = '';
        this.showResetPwdKey = false;
        this.dateStrings = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ];
        this.timeStrings = [
            "12:00",
            "1:00",
            "2:00",
            "3:00",
            "4:00",
            "5:00",
            "6:00",
            "7:00",
            "8:00",
            "9:00",
            "10:00",
            "11:00"
        ];
        this.amPmStrings = ["am", "pm"];
        this.imageState = false;
        this.messageKeys = {};
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.setup.connTroubleshoot.title').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.title"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.restart').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.restart"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.upload').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.upload"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.upgrade').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.upgrade"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.debug').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.debug"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.desc').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.desc"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.autoUpdate').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.autoUpdate"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.autodesc').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.autodesc"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.window').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.window"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.day').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.day"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.time').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.time"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.reset').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.reset"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.keyCopy').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.keyCopy"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.cpy').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.cpy"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.steps').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.steps"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.login').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.login"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.newPass').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.newPass"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.forgot').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.forgot"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.key').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.key"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.service').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.service"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.noService').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.noService"] = res;
            });
            this.translate.get('dashboard-lib.setup.connTroubleshoot.debugRun').subscribe((res) => {
                this.messageKeys["dashboard-lib.setup.connTroubleshoot.debugRun"] = res;
            });
        };
        this.keyCopy = {};
        this.copyToken = (keyCopy) => {
            this.dataService.setToastMessage("Token copied", 4000, null, null, "success");
            /* keyCopy["isCopied"] = true;
             setTimeout(() => {
               keyCopy["isCopied"] = false;
             }, 3000);*/
        };
        this.getDebugModeStatus = () => {
            this.dataService.display(true);
            this.cmxConnectorsService.getServiceDebugInfo(this.selectedConnector.id).pipe(takeUntil(this.unsubscribe$)).
                subscribe((response) => {
                if (response && response.status && response.data) {
                    this.debugStatus = response.data.data;
                    this.dataService.display(false);
                }
                else {
                    this.dataService.display(false);
                }
            });
        };
        this.openManageConnectorPopup = (show, connector) => {
            this.showManageConnectorPopup = show;
            this.cmxConnectorError = "";
            this.showResetPwdKey = false;
            this.pwdResetKey = '';
            console.log(connector, show);
            if (show == true) {
                //this.selectedConnector = connector;
                this.selectedConnector.twelveHourTime =
                    connector.service.autoUpgradeConfig.autoUpgradeTimeRange
                        .startVal % 12;
                this.selectedConnector.amPmTime =
                    connector.service.autoUpgradeConfig.autoUpgradeTimeRange
                        .startVal < 12;
                // If v3 check for upgrade available & for v3 give option to restart Connector
            }
            else if (show == false) {
                //this.selectedConnector = {};
                this.emitClosePopup.emit();
            }
        };
        this.restartConnector = (connector) => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .restartConnector(connector.id)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data === "" || data === null) {
                    this.dataService.display(false);
                    this.dataService.setToastMessage("Connector restart failed", 4000, null, null, "error");
                }
                else {
                    this.dataService.setToastMessage("Connector restarted successfully", 4000, null, null, "success");
                    //	this.getCMXConnectors();
                    this.refreshConnectorList.emit();
                }
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage("Connector restart failed", 4000, null, null, "error");
            });
        };
        this.uploadConnectorLogs = (connector) => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .uploadConnectorLogs(connector.id)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data === "" || data === null) {
                    this.dataService.setToastMessage("Connector logs upload failed", 4000, null, null, "error");
                    this.dataService.display(false);
                }
                else {
                    this.dataService.setToastMessage("Connector logs uploaded successfully", 4000, null, null, "success");
                    this.dataService.display(false);
                }
            }, (error) => {
                this.dataService.setToastMessage("Connector logs upload failed", 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        this.upgradeConnector = (connector) => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .upgradeConnector(connector.id)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data === "" || data === null) {
                    this.dataService.setToastMessage("Connector upgrade initialization failed", 4000, null, null, "error");
                    this.dataService.display(false);
                }
                else {
                    this.dataService.setToastMessage("Connector upgrade initialized successfully. Please allow sometime for upgrade to complete. Check back later for the updated version.", 4000, null, null, "success");
                    this.dataService.display(false);
                }
            }, (error) => {
                this.dataService.setToastMessage("Connector upgrade initialization failed", 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        this.autoUpgrade = () => {
            this.selectedConnector.service.autoUpgradeConfig.autoUpgrade =
                !this.selectedConnector.service.autoUpgradeConfig.autoUpgrade;
            this.saveUpgradeChanges(!this.selectedConnector.service.autoUpgradeConfig.autoUpgrade);
        };
        this.saveUpgradeChanges = (disabled) => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .autoUpgrade(this.selectedConnector.id, this.selectedConnector.service.autoUpgradeConfig)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data === "" || data === null) {
                    if (disabled) {
                        this.dataService.setToastMessage("Attempt to disable auto upgrade has failed", 4000, null, null, "error");
                    }
                    else {
                        this.dataService.setToastMessage("Attempt to enable auto upgrade has failed", 4000, null, null, "error");
                    }
                    this.selectedConnector.service.autoUpgradeConfig.autoUpgrade =
                        !this.selectedConnector.service.autoUpgradeConfig
                            .autoUpgrade;
                    this.dataService.display(false);
                }
                else {
                    if (disabled) {
                        this.dataService.setToastMessage("Auto upgrade disabled successfully", 4000, null, null, "success");
                    }
                    else {
                        this.dataService.setToastMessage("Auto upgrade enabled successfully", 4000, null, null, "success");
                    }
                    this.dataService.display(false);
                    //this.getCMXConnectors();
                    this.refreshConnectorList.emit();
                }
            }, (error) => {
                if (disabled) {
                    this.dataService.setToastMessage("Attempt to disable auto upgrade has failed", 4000, null, null, "error");
                }
                else {
                    this.dataService.setToastMessage("Attempt to enable auto upgrade has failed", 4000, null, null, "error");
                }
                this.selectedConnector.service.autoUpgradeConfig.autoUpgrade =
                    !this.selectedConnector.service.autoUpgradeConfig
                        .autoUpgrade;
                this.dataService.display(false);
            });
        };
        this.onChangeUpgradeTime = () => {
            let tempTime = this.selectedConnector.twelveHourTime;
            if (tempTime === 12) {
                tempTime = tempTime - 12;
            }
            this.selectedConnector.service.autoUpgradeConfig.autoUpgradeTimeRange.startVal =
                this.selectedConnector.amPmTime ? tempTime : tempTime + 12;
        };
        this.toggleResetPwdKey = (connectorId) => {
            if (this.instancesNodeIds && this.instancesNodeIds.length == 0) {
                this.dataService.setToastMessage("Failed to generate Password reset key. There's no instance configured with this connector.", 4000, null, null, "error");
            }
            else {
                this.imageState = !this.imageState;
                if (this.showResetPwdKey == true) {
                    this.showResetPwdKey = false;
                }
                else {
                    this.showResetPwdKey = true;
                    this.getResetPasswordKey(connectorId);
                }
            }
        };
        this.getResetPasswordKey = (connectorid) => {
            this.dataService.display(true);
            //this.showResetPwdKey = false;
            if (this.instancesNodeIds && this.instancesNodeIds.length > 0) {
                this.cmxConnectorsService.getResetPasswordKey(connectorid, this.instancesNodeIds[0]).pipe(takeUntil(this.unsubscribe$)).
                    subscribe(response => {
                    if (response && response.status && response.data.data) {
                        this.pwdResetKey = response.data.data;
                        this.showResetPwdKey = true;
                    }
                    else {
                        this.showResetPwdKey = false;
                        this.dataService.setToastMessage("Failed to generate Password reset key.", 4000, null, null, "error");
                    }
                    this.dataService.display(false);
                });
            }
            else {
                this.dataService.display(false);
                this.dataService.setToastMessage("Failed to generate Password reset key. There's no instance configured with this connector.", 4000, null, null, "error");
                this.showResetPwdKey = false;
            }
        };
        this.closeResetPwd = () => {
            this.showResetPwdKey = false;
            this.pwdResetKey = '';
        };
        this.uploadLogForServices = (connectorId, serviceName) => {
            this.dataService.display(true);
            const payload = {
                "services": [
                    serviceName
                ]
            };
            this.cmxConnectorsService.uploadLogForServices(connectorId, payload).pipe(takeUntil(this.unsubscribe$)).
                subscribe(response => {
                if (response && response.status) {
                    this.dataService.display(false);
                    const message = "Logs uploaded successfully.";
                    this.dataService.setToastMessage(message, 4000, null, null, "success");
                    this.dataService.display(false);
                }
                else {
                    this.dataService.setToastMessage("Failed to upload logs to cloud for service - " + serviceName, 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        this.enableDebugForServices = (connectorId, serviceName) => {
            this.dataService.display(true);
            const payload = {
                "services": [
                    serviceName
                ],
                "logLevel": "DEBUG"
            };
            this.cmxConnectorsService.enableDebugForServices(connectorId, payload).pipe(takeUntil(this.unsubscribe$)).
                subscribe(response => {
                if (response && response.status) {
                    this.dataService.display(false);
                    const message = "Debug mode initiated successfully for " + this.serviceNameDisplayName.get(serviceName) + ".";
                    this.dataService.setToastMessage(message, 4000, null, null, "success");
                    this.dataService.display(false);
                    this.getDebugModeStatus();
                }
                else {
                    this.dataService.setToastMessage("Failed to initiate debug mode for service - " + this.serviceNameDisplayName.get(serviceName) + ".", 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        this.disableDebugForServices = (connectorId, serviceName) => {
            this.dataService.display(true);
            const payload = {
                "services": [
                    serviceName
                ],
                //  "logLevel": "INFO"
            };
            this.cmxConnectorsService.disableDebugForServices(connectorId, payload).pipe(takeUntil(this.unsubscribe$)).
                subscribe(response => {
                if (response && response.status) {
                    this.dataService.display(false);
                    const message = "Disabled debug mode successfully for " + this.serviceNameDisplayName.get(serviceName) + ".";
                    this.dataService.setToastMessage(message, 4000, null, null, "success");
                    this.dataService.display(false);
                    this.getDebugModeStatus();
                }
                else {
                    this.dataService.setToastMessage("Failed to disable debug mode for service - " + this.serviceNameDisplayName.get(serviceName) + ".", 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        this.onChangeUpgradeDate = (event) => {
            console.log("on change", event);
        };
        /*enableDebug = () => {
          this.dataService.display(true);
          if(this.title == "Troubleshoot Connector"){
            this.selectedConnector.service.enableDebug =
            !this.selectedConnector.service.enableDebug;
            this.cmxConnectorsService
            .enableDebug(
              this.selectedConnector.id,
              this.selectedConnector.service.enableDebug
            )
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
              (data) => {
                if (data === "" || data === null) {
                  this.dataService.setToastMessage(
                    "Connector debug toggle failed",
                    4000,
                    null,
                    null,
                    "error"
                  );
                  this.selectedConnector.service.enableDebug =
                    !this.selectedConnector.service.enableDebug;
                  this.dataService.display(false);
                } else {
                  if (this.selectedConnector.service.enableDebug) {
                    this.dataService.setToastMessage(
                      "Connector debug enabled successfully",
                      4000,
                      null,
                      null,
                      "success"
                    );
                  } else {
                    this.dataService.setToastMessage(
                      "Connector debug disabled successfully",
                      4000,
                      null,
                      null,
                      "success"
                    );
                  }
                  this.dataService.display(false);
                        //this.refreshConnectorList.emit();
                }
              },
              (error) => {
                this.dataService.setToastMessage(
                  "Connector debug toggle failed",
                  4000,
                  null,
                  null,
                  "error"
                );
                this.selectedConnector.service.enableDebug =
                  !this.selectedConnector.service.enableDebug;
                this.dataService.display(false);
              }
            );
          }else {
            this.selectedConnector.hotspot.service.enableDebug =
            !this.selectedConnector.hotspot.service.enableDebug;
          this.dataService.display(true);
          this.cmxConnectorsService
            .enableHotspotDebug(
              this.selectedConnector.id,
              this.selectedConnector.hotspot.service.enableDebug
            )
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
              (data) => {
                if (data === "" || data === null) {
                  this.dataService.setToastMessage(
                    "Hotspot debug mode toggle failed",
                    4000,
                    null,
                    null,
                    "error"
                  );
                  this.selectedConnector.hotspot.service.enableDebug =
                    !this.selectedConnector.hotspot.service.enableDebug;
                  this.dataService.display(false);
                } else {
                  if (
                    this.selectedConnector.hotspot.service.enableDebug
                  ) {
                    this.dataService.setToastMessage(
                      "Hotspot debug mode enabled successfully",
                      4000,
                      null,
                      null,
                      "success"
                    );
                  } else {
                    this.dataService.setToastMessage(
                      "Hotspot debug mode disabled successfully",
                      4000,
                      null,
                      null,
                      "success"
                    );
                  }
                  this.dataService.display(false);
                  //this.refreshConnectorList.emit();
                }
              },
              (_error) => {
                this.dataService.setToastMessage(
                  "Hotspot debug mode toggle failed",
                  4000,
                  null,
                  null,
                  "error"
                );
                this.selectedConnector.hotspot.service.enableDebug =
                  !this.selectedConnector.hotspot.service.enableDebug;
                this.dataService.display(false);
              }
            );
          }
        };*/
        this.enableDebug = () => {
            this.dataService.display(true);
            this.selectedConnector.service.enableDebug =
                !this.selectedConnector.service.enableDebug;
            if (this.title == 'Troubleshoot Connector') {
                this.cmxConnectorsService
                    .enableDebug(this.selectedConnector.id, this.selectedConnector.service.enableDebug)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((data) => {
                    if (data === "" || data === null) {
                        this.dataService.setToastMessage("Connector debug toggle failed", 4000, null, null, "error");
                        this.selectedConnector.service.enableDebug =
                            !this.selectedConnector.service.enableDebug;
                        this.dataService.display(false);
                    }
                    else {
                        if (this.selectedConnector.service.enableDebug) {
                            this.dataService.setToastMessage("Connector debug enabled successfully", 4000, null, null, "success");
                        }
                        else {
                            this.dataService.setToastMessage("Connector debug disabled successfully", 4000, null, null, "success");
                        }
                        this.dataService.display(false);
                        //this.refreshConnectorList.emit();
                    }
                }, (error) => {
                    this.dataService.setToastMessage("Connector debug toggle failed", 4000, null, null, "error");
                    this.selectedConnector.service.enableDebug =
                        !this.selectedConnector.service.enableDebug;
                    this.dataService.display(false);
                });
            }
            else {
                this.cmxConnectorsService
                    .enableHotspotDebug(this.selectedConnector.id, this.selectedConnector.hotspot.service.enableDebug)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((data) => {
                    if (data === "" || data === null) {
                        this.dataService.setToastMessage("Hotspot debug mode toggle failed", 4000, null, null, "error");
                        this.selectedConnector.hotspot.service.enableDebug =
                            !this.selectedConnector.hotspot.service.enableDebug;
                        this.dataService.display(false);
                    }
                    else {
                        if (this.selectedConnector.hotspot.service.enableDebug) {
                            this.dataService.setToastMessage("Hotspot debug mode enabled successfully", 4000, null, null, "success");
                        }
                        else {
                            this.dataService.setToastMessage("Hotspot debug mode disabled successfully", 4000, null, null, "success");
                        }
                        this.dataService.display(false);
                        //this.getCMXConnectors();
                    }
                }, (_error) => {
                    this.dataService.setToastMessage("Hotspot debug mode toggle failed", 4000, null, null, "error");
                    this.selectedConnector.hotspot.service.enableDebug =
                        !this.selectedConnector.hotspot.service.enableDebug;
                    this.dataService.display(false);
                });
            }
        };
        this.enableHotspotDebug = () => {
            this.selectedConnector.hotspot.service.enableDebug =
                !this.selectedConnector.hotspot.service.enableDebug;
            this.dataService.display(true);
            this.cmxConnectorsService
                .enableHotspotDebug(this.selectedConnector.id, this.selectedConnector.hotspot.service.enableDebug)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data === "" || data === null) {
                    this.dataService.setToastMessage("Hotspot debug mode toggle failed", 4000, null, null, "error");
                    this.selectedConnector.hotspot.service.enableDebug =
                        !this.selectedConnector.hotspot.service.enableDebug;
                    this.dataService.display(false);
                }
                else {
                    if (this.selectedConnector.hotspot.service.enableDebug) {
                        this.dataService.setToastMessage("Hotspot debug mode enabled successfully", 4000, null, null, "success");
                    }
                    else {
                        this.dataService.setToastMessage("Hotspot debug mode disabled successfully", 4000, null, null, "success");
                    }
                    this.dataService.display(false);
                    //this.refreshConnectorList.emit();
                }
            }, (_error) => {
                this.dataService.setToastMessage("Hotspot debug mode toggle failed", 4000, null, null, "error");
                this.selectedConnector.hotspot.service.enableDebug =
                    !this.selectedConnector.hotspot.service.enableDebug;
                this.dataService.display(false);
            });
        };
        this.getConnectorUpdateString = (serviceObj) => {
            if (!serviceObj.autoUpgradeConfig.autoUpgrade) {
                return "Not scheduled";
            }
            const timeObj = serviceObj.autoUpgradeConfig.autoUpgradeTimeRange;
            const twelveHourString = timeObj.startVal % 12;
            const amPM = timeObj.startVal < 12 ? "am" : "pm";
            return (this.dateStrings[timeObj.dayVal] +
                " at " +
                (twelveHourString === 0 ? "12" : twelveHourString) +
                ":00" +
                amPM);
        };
    }
    ngOnInit() {
        this.getDebugModeStatus();
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
    }
}
ConnectorTroubleshootComponent.ɵfac = function ConnectorTroubleshootComponent_Factory(t) { return new (t || ConnectorTroubleshootComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(CMXConnectorsService)); };
ConnectorTroubleshootComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConnectorTroubleshootComponent, selectors: [["lib-connector-troubleshoot"]], inputs: { showManageConnectorPopup: "showManageConnectorPopup", selectedConnector: "selectedConnector", serviceList: "serviceList", instancesNodeIds: "instancesNodeIds", title: "title", serviceNameDisplayName: "serviceNameDisplayName" }, outputs: { refreshConnectorList: "refreshConnectorList", emitClosePopup: "emitClosePopup" }, decls: 1, vars: 1, consts: [["class", "modalPopup modalPopupLg connectorPopup wlcConnectorPopup", 4, "ngIf"], [1, "modalPopup", "modalPopupLg", "connectorPopup", "wlcConnectorPopup"], [1, "modalContent-connector"], [1, "modalHeader"], [4, "ngIf"], [1, "modalCloseIcon", 3, "click"], ["class", "modalBody cmxConnectorForm ", 4, "ngIf"], ["class", "modalBody cmxConnectorForm troubleshootV3", "style", " color: #545454;", 4, "ngIf"], [1, "modalBody", "cmxConnectorForm"], ["class", "fieldWrapper error", 4, "ngIf"], [1, "controllerName"], [1, "fieldWrapper"], [1, "commonButton_hollow", 3, "click"], [1, "commonButton_hollow", "border_l", 3, "click"], ["class", "commonButton_hollow border_l", 3, "click", 4, "ngIf"], [1, "fieldWrapper", 2, "border", "none", "margin-right", "20px"], [1, "fieldDescriptiveLabel"], [1, "fieldTitle"], [1, "fieldDescription"], [1, "fieldSwitch", 2, "top", "-20px"], [1, "switch"], ["type", "checkbox", 3, "checked", "click"], [1, "slider", "round"], ["class", "fieldWrapper", "style", "border: none; margin-right: 20px", 4, "ngIf"], [1, "fieldWrapper", "error"], [1, "modalBody", "cmxConnectorForm", "troubleshootV3", 2, "color", "#545454"], [1, "truobleshoot_subheader"], [1, "subheader_name"], [1, "subheader_action", 3, "ngClass", "click"], [1, "nav-arrow"], ["src", "/assets/images/TileRedesign/arrow.svg", "alt", "Tile Info - Arrow", "width", "15", 3, "ngClass"], ["class", "pwd-reset-container", 4, "ngIf"], [1, "service-logs"], ["class", "troubleshoot_service", 4, "ngIf"], ["class", "service_debug", 4, "ngIf"], [1, "pwd-reset-container"], [1, "token-wrapper"], [1, "token-container"], ["ngxClipboard", "", 1, "copy-key", 3, "cbContent", "click"], [1, "tile_header"], [1, "steps-reset"], [1, "step-header"], [1, "step_index"], [1, "step_content", "withBorder"], [1, "troubleshoot_service"], ["src", "/assets/images/warning.svg", 1, "warningIcon", "streamWarningIcon", 2, "width", "23px", "padding-right", "5px"], [1, "service_debug"], ["class", "service-log", 4, "ngFor", "ngForOf"], [1, "service-log"], [1, "log-serviceName"], [1, "log-type", 3, "click"], ["class", " tooltip log-type log-pipe", 3, "click", 4, "ngIf"], ["class", "log-type log-pipe", 3, "click", 4, "ngIf"], [1, "tooltip", "log-type", "log-pipe", 3, "click"], [1, "tooltiptext"], ["src", "/assets/images/warning.svg", "width", "50", 1, "warningIcon"], [1, "log-type", "log-pipe", 3, "click"]], template: function ConnectorTroubleshootComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ConnectorTroubleshootComponent_div_0_Template, 9, 4, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showManageConnectorPopup === true);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i5$1.ClipboardDirective, i1$2.NgForOf], pipes: [i2.TranslatePipe], styles: [".modalPopup.connectorPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease}.modalPopup[_ngcontent-%COMP%] > .modalContent-connector[_ngcontent-%COMP%]{width:60%;right:0;height:100%;z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #abc233;animation:slide .5s forwards}@keyframes slide{65%{right:0}}.modalPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0 30px;color:#545454;font-size:24px;height:initial}.modalPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:24px 0}.modalPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{background-color:#fff;padding:18px 30px;margin-bottom:40px}.modalPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{height:initial;align-items:center;padding:0;background-color:#ffffffe6;z-index:9999}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{padding:24px 30px;height:24px;line-height:32px}.appsPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{height:20px}.appsPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.select-menu[_ngcontent-%COMP%]{height:30px;min-width:100px;padding-left:0;border-bottom:1px solid #ddd;background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_down.svg) no-repeat right center;float:left;margin:0 10px;cursor:pointer}.select-menu[_ngcontent-%COMP%]   .first[_ngcontent-%COMP%]{padding:5px 10px;z-index:2;width:100%}.select-item-container[_ngcontent-%COMP%]{width:100%;border:1px solid #ddd;background:#ffffff;max-height:150px;overflow:auto;position:relative;z-index:999}.select-item[_ngcontent-%COMP%]{padding:10px}.select-item-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:not(.first):hover{background:#09f;color:#fff}.select-item-container[_ngcontent-%COMP%] > .selected[_ngcontent-%COMP%]{display:none}.select-item[_ngcontent-%COMP%]   .first[_ngcontent-%COMP%]{cursor:pointer}.select-custom-2[_ngcontent-%COMP%]{width:60%!important;margin:10px 0!important;font-size:15px;outline:none}.fieldLabel[_ngcontent-%COMP%], .fieldValue[_ngcontent-%COMP%], .fieldWrapper[_ngcontent-%COMP%]{padding:10px 0}.fieldWrapper[_ngcontent-%COMP%]:not(:last-child){border-bottom:1px solid #e5e5e5}.accessToken[_ngcontent-%COMP%]   .fieldWrapper[_ngcontent-%COMP%]{border-bottom:none}.controllerForm[_ngcontent-%COMP%]   .fieldWrapper[_ngcontent-%COMP%]{border-bottom:none}.fieldLabel[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans;width:50%;display:inline-block}.fieldValue[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans;width:50%;display:inline-block;font-weight:bold}.modalBody[_ngcontent-%COMP%]   .controllerName[_ngcontent-%COMP%]{font-size:24px;font-weight:bold}.boxWrapper[_ngcontent-%COMP%]{border:1px solid #e5e5e5;padding:10px 20px}.fieldDescriptiveLabel[_ngcontent-%COMP%]{width:80%;display:inline-block;padding:10px 0}.fieldDescriptiveLabel[_ngcontent-%COMP%]   .fieldTitle[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans}.fieldDescriptiveLabel[_ngcontent-%COMP%]   .fieldDescription[_ngcontent-%COMP%]{font-size:12px}.fieldPicker[_ngcontent-%COMP%]{display:inline-block}.fieldPickerTitle[_ngcontent-%COMP%]{font-size:12px;color:#3e3e3e;font-family:ciscoSans;padding:10px 0}.fieldSwitch[_ngcontent-%COMP%]{width:20%;display:inline-block;position:relative;top:-10px;text-align:right}.switch[_ngcontent-%COMP%]{position:relative;display:inline-block;width:60px;height:34px}.switch[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{opacity:0;width:0;height:0}.slider[_ngcontent-%COMP%]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;transition:.4s}.slider[_ngcontent-%COMP%]   ges[_ngcontent-%COMP%]{padding:10px 27px}.slider[_ngcontent-%COMP%]:before{position:absolute;content:\"\";height:26px;width:26px;left:4px;bottom:4px;background-color:#fff;transition:.4s}input[_ngcontent-%COMP%]:checked + .slider[_ngcontent-%COMP%]{background-color:#049fd9}input[_ngcontent-%COMP%]:focus + .slider[_ngcontent-%COMP%]{box-shadow:0 0 1px #049fd9}input[_ngcontent-%COMP%]:checked + .slider[_ngcontent-%COMP%]:before{transform:translate(26px)}.slider.round[_ngcontent-%COMP%]{border-radius:5px}.slider.round[_ngcontent-%COMP%]:before{border-radius:5px}.cmxConnectorForm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .cmxConnectorForm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}.cmxConnectorForm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .select-menu[_ngcontent-%COMP%]{background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_up.svg) no-repeat right center;font-size:14px}.cmxConnectorForm[_ngcontent-%COMP%]   .menuActive[_ngcontent-%COMP%]{background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_down.svg) no-repeat right center!important}.cmxConnectorForm[_ngcontent-%COMP%]   .select-item-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:hover{background:#dfdfdf;color:#000}.cmxConnectorForm[_ngcontent-%COMP%]   .menuActive[_ngcontent-%COMP%] > .select-item.first[_ngcontent-%COMP%]{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .select-item.first[_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;border:none;border-radius:10px}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:hover, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:hover{background-color:#026e97;color:#fff;border:none}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:active, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:active{background-color:#014f6c;color:#fff;border:none}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]{background-color:#fff;color:#049fd9;border-radius:10px;border:1px solid #049fd9;margin-right:10px}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:hover, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:hover{background-color:#026e97;color:#fff;border:none}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:active, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:active{background-color:#014f6c;color:#fff;border:none}.showPassword[_ngcontent-%COMP%]{padding-left:5px;bottom:1px;font-size:12px;font-weight:bold;font-family:ciscoSans;color:#6674c3;cursor:pointer}.showPasswordAT[_ngcontent-%COMP%]{bottom:30px!important}input[type=password][_ngcontent-%COMP%] > span[_ngcontent-%COMP%] + .showPassword[_ngcontent-%COMP%]{color:#6674c3}.select-item-container[_ngcontent-%COMP%]{margin-bottom:40px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{padding-left:33.8px}.table.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:434px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:14px;line-height:20px;letter-spacing:.5px}.circularCheckbox[_ngcontent-%COMP%]{vertical-align:middle;padding-right:15px;display:inline-block}.commonButton_hollow[_ngcontent-%COMP%]{text-align:center;cursor:pointer;display:inline-table;vertical-align:middle;font-size:16px;font-weight:bold;padding:6px 10px;color:#0096d6;outline:none;background-color:transparent;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px}.border_l[_ngcontent-%COMP%]{border-left:1px solid #dee0e1}.fieldLabel[_ngcontent-%COMP%], .fieldValue[_ngcontent-%COMP%], .fieldWrapper[_ngcontent-%COMP%]{padding:10px 0}.fieldWrapper[_ngcontent-%COMP%]:not(:last-child){border-bottom:1px solid #e5e5e5}.accessToken[_ngcontent-%COMP%]   .fieldWrapper[_ngcontent-%COMP%]{border-bottom:none}.controllerForm[_ngcontent-%COMP%]   .fieldWrapper[_ngcontent-%COMP%]{border-bottom:none}.fieldDescriptiveLabel[_ngcontent-%COMP%]{width:80%;display:inline-block;padding:10px 0}.fieldDescriptiveLabel[_ngcontent-%COMP%]   .fieldTitle[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans}.fieldDescriptiveLabel[_ngcontent-%COMP%]   .fieldDescription[_ngcontent-%COMP%]{font-size:12px}.fieldPicker[_ngcontent-%COMP%]{display:inline-block}.fieldPickerTitle[_ngcontent-%COMP%]{font-size:12px;color:#3e3e3e;font-family:ciscoSans;padding:10px 0}.fieldSwitch[_ngcontent-%COMP%]{width:20%;display:inline-block;position:relative;top:-10px;text-align:right}.fieldPicker[_ngcontent-%COMP%]{display:inline-block}.fieldPickerTitle[_ngcontent-%COMP%]{font-size:12px;color:#3e3e3e;font-family:ciscoSans;padding:10px 0}.truobleshoot_subheader[_ngcontent-%COMP%]{display:inline-block;width:950px}.troubleshootV3[_ngcontent-%COMP%]{padding:44px 51px 0;font-family:\"CiscoSans\";font-style:normal}.service-logs[_ngcontent-%COMP%]{padding:25px 0 12.5px;font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:18px;line-height:20px;letter-spacing:.5px;border-bottom:2px solid #DEDEDE;color:#000;width:920px}.service-log[_ngcontent-%COMP%]{height:65px;padding:20px 0 0;border-bottom:1px solid #DEDEDE}.log-type[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;text-align:center;letter-spacing:.5px;color:#049fd9;float:right;cursor:pointer}.log-pipe[_ngcontent-%COMP%]{padding-right:10px;margin-right:10px;border-right:1px solid #DEDEDE}.log-serviceName[_ngcontent-%COMP%]{margin-left:5px}.pwd-reset-container[_ngcontent-%COMP%]{border-left:1px solid #DEDEDE;border-right:1px solid #DEDEDE;border-bottom:1px solid #DEDEDE;padding:10px 0 20px 31.5px;display:inline-block;width:933px}.token-wrapper[_ngcontent-%COMP%]{margin-top:10px}.token-container[_ngcontent-%COMP%]{margin-right:40px;height:auto;background:#EFF8FC;border:1px dashed #049FD9;border-radius:12px;text-align:left;padding:20px;margin-top:10px;overflow-wrap:break-word}.copy-key[_ngcontent-%COMP%]{cursor:pointer;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:19px;letter-spacing:.5px;color:#049fd9;width:100px;margin-top:15px;margin-bottom:15px}.steps-reset[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:14px;line-height:19px;letter-spacing:.5px;margin-top:18px;margin-bottom:11px}.step-header[_ngcontent-%COMP%]{display:inline-block}.step-header[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:inline-block}.step-header[_ngcontent-%COMP%]   .step_index[_ngcontent-%COMP%]{border:1px solid #979797;width:30px;height:30px;border-radius:50%;text-align:center;line-height:30px;font-size:12px;font-family:CiscoSans;font-weight:bold;margin-right:20px}.step-header[_ngcontent-%COMP%]   span.tile_header[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;font-weight:300;letter-spacing:.83px;line-height:18px;display:inline}.withBorder[_ngcontent-%COMP%]{border-left:1px solid #979797;height:10px;margin-left:14px}.subheader_name[_ngcontent-%COMP%]{display:inline;border-bottom:1px solid #DEDEDE;padding-bottom:20px;width:720px;float:left;color:#000}.subheader_action[_ngcontent-%COMP%]{display:inline;text-align:center;letter-spacing:.5px;color:#049fd9;cursor:pointer;border-bottom:1px solid #DEDEDE;padding:12px 14px 20px 12px}.subheader_action_click[_ngcontent-%COMP%]{border:1px solid #DEDEDE;border-bottom:none!important}.troubleshoot_service[_ngcontent-%COMP%]{padding:20px 0 0;font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:14px;line-height:19px;letter-spacing:.5px;width:920px}.nav-arrow[_ngcontent-%COMP%]{display:inline;align-items:center;padding:5px}.nav-arrow[_ngcontent-%COMP%]   .icon-arrow[_ngcontent-%COMP%]:before{font-size:15px}.nav-arrow[_ngcontent-%COMP%]   .icon-arrow[_ngcontent-%COMP%]:after{font-size:15px;transform:rotate(90deg)}.service_debug[_ngcontent-%COMP%]{width:920px}.imageRotate[_ngcontent-%COMP%]{transform:rotate(180deg)}.tooltip[_ngcontent-%COMP%]{position:relative;display:inline-block}.tooltip[_ngcontent-%COMP%]   .tooltiptext[_ngcontent-%COMP%]{visibility:hidden;width:615px;height:43px;overflow-y:auto;background-color:#fff;color:#58585b;border-radius:6px;border:1px solid #efefef;padding:9px;position:absolute;z-index:9999;top:-45px;right:48%}.tooltip[_ngcontent-%COMP%]:hover   .tooltiptext[_ngcontent-%COMP%]{visibility:visible}.warningIcon[_ngcontent-%COMP%]{width:15px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConnectorTroubleshootComponent, [{
        type: Component,
        args: [{
                selector: 'lib-connector-troubleshoot',
                templateUrl: './connector-troubleshoot.component.html',
                styleUrls: ['./connector-troubleshoot.component.scss']
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }, { type: CMXConnectorsService }]; }, { showManageConnectorPopup: [{
            type: Input
        }], selectedConnector: [{
            type: Input
        }], serviceList: [{
            type: Input
        }], instancesNodeIds: [{
            type: Input
        }], title: [{
            type: Input
        }], serviceNameDisplayName: [{
            type: Input
        }], refreshConnectorList: [{
            type: Output
        }], emitClosePopup: [{
            type: Output
        }] }); })();

function CmxConnectorComponent_div_0_div_1_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 42);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.connectors-label"));
} }
function CmxConnectorComponent_div_0_div_1_span_10_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 43);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_span_10_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(3); return ctx_r44.showConnectorListView(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.connectors-label"));
} }
function CmxConnectorComponent_div_0_div_1_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1, ">");
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r26.currentConnector.name);
} }
function CmxConnectorComponent_div_0_div_1_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span", 45);
    i0.ɵɵtext(4, "|");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵpipe(7, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 4, "dashboard-lib.cmx-connector.id-label"), " : ", ctx_r27.currentConnector.id, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(6, 6, "dashboard-lib.cmx-connector.last-modified-label"), " : ", i0.ɵɵpipeBind2(7, 8, ctx_r27.currentConnector.updatedAt, "medium"), "");
} }
function CmxConnectorComponent_div_0_div_1_div_16_div_30_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵelementStart(1, "span", 61);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 62);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r48 = ctx.$implicit;
    const ctx_r47 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r47.servicesConnectorEnabled[item_r48], "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", item_r48, " ", i0.ɵɵpipeBind1(5, 3, "dashboard-lib.cmx-connector.summary.label.enabled"), "");
} }
function CmxConnectorComponent_div_0_div_1_div_16_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_16_div_30_div_1_Template, 6, 5, "div", 59);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r46.servicesConnectorCountsKey);
} }
function CmxConnectorComponent_div_0_div_1_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "div", 47);
    i0.ɵɵelement(2, "img", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 49);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementStart(7, "div", 50);
    i0.ɵɵelementStart(8, "div", 51);
    i0.ɵɵelementStart(9, "span", 52);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "br");
    i0.ɵɵelementStart(12, "span", 53);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 51);
    i0.ɵɵelementStart(16, "span", 54);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(18, "br");
    i0.ɵɵelementStart(19, "span", 53);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 55);
    i0.ɵɵelementStart(23, "span", 56);
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(25, "br");
    i0.ɵɵelementStart(26, "span", 53);
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 57);
    i0.ɵɵtemplate(30, CmxConnectorComponent_div_0_div_1_div_16_div_30_Template, 2, 1, "div", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 8, "dashboard-lib.cmx-connector.summary.label.header"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r28.totalConnectors);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 10, "dashboard-lib.cmx-connector.connectors-label"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r28.connectorsUpCount);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 12, "dashboard-lib.cmx-connector.summary.label.up"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r28.connectorsDownCount);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(28, 14, "dashboard-lib.cmx-connector.summary.label.down"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r28.servicesConnectorCountsKey.length > 0);
} }
function CmxConnectorComponent_div_0_div_1_div_17_span_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 53);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.summary.label.services-enabled"));
} }
function CmxConnectorComponent_div_0_div_1_div_17_span_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 53);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.summary.label.service-enabled"));
} }
function CmxConnectorComponent_div_0_div_1_div_17_span_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 53);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.summary.label.controllers"));
} }
function CmxConnectorComponent_div_0_div_1_div_17_span_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 53);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.summary.label.controller"));
} }
function CmxConnectorComponent_div_0_div_1_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "div", 47);
    i0.ɵɵelement(2, "img", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 49);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 50);
    i0.ɵɵelementStart(7, "div", 63);
    i0.ɵɵelementStart(8, "span", 52);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 53);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 63);
    i0.ɵɵelementStart(14, "span", 54);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "span", 53);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 64);
    i0.ɵɵelementStart(20, "span", 56);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "span", 53);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 65);
    i0.ɵɵelementStart(26, "span", 52);
    i0.ɵɵtext(27);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(28, CmxConnectorComponent_div_0_div_1_div_17_span_28_Template, 3, 3, "span", 66);
    i0.ɵɵtemplate(29, CmxConnectorComponent_div_0_div_1_div_17_span_29_Template, 3, 3, "span", 66);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 63);
    i0.ɵɵelementStart(31, "span", 52);
    i0.ɵɵtext(32);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(33, CmxConnectorComponent_div_0_div_1_div_17_span_33_Template, 3, 3, "span", 66);
    i0.ɵɵtemplate(34, CmxConnectorComponent_div_0_div_1_div_17_span_34_Template, 3, 3, "span", 66);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "div", 67);
    i0.ɵɵelementStart(36, "span", 52);
    i0.ɵɵtext(37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "span", 53);
    i0.ɵɵtext(39);
    i0.ɵɵpipe(40, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 15, "dashboard-lib.cmx-connector.summary.label.header"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r29.connectorInstance_count);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 17, "dashboard-lib.cmx-connector.summary.label.instances"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r29.connectorInstance_count_active);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 19, "dashboard-lib.cmx-connector.summary.label.active"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r29.connectorInstance_count_down);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 21, "dashboard-lib.cmx-connector.summary.label.inactive"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r29.connectorServicesEnabled_count);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.connectorServicesEnabled_count != 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.connectorServicesEnabled_count == 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r29.connectorControllersCount);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.connectorControllersCount != 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.connectorControllersCount == 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r29.connectorSwitchesCount);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(40, 23, "dashboard-lib.cmx-connector.summary.label.switches"));
} }
function CmxConnectorComponent_div_0_div_1_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "div", 47);
    i0.ɵɵelement(2, "img", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 49);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 50);
    i0.ɵɵelementStart(7, "div", 63);
    i0.ɵɵelementStart(8, "span", 52);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 53);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 63);
    i0.ɵɵelementStart(14, "span", 54);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "span", 53);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 63);
    i0.ɵɵelementStart(20, "span", 56);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "span", 53);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 7, "dashboard-lib.cmx-connector.summary.label.header"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r30.connectorControllersCount);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 9, "dashboard-lib.cmx-connector.summary.label.controllers"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r30.connectorControllersCount_active);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 11, "dashboard-lib.cmx-connector.summary.label.active"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r30.connectorControllersCount_down);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 13, "dashboard-lib.cmx-connector.summary.label.inactive"));
} }
function CmxConnectorComponent_div_0_div_1_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "div", 47);
    i0.ɵɵelement(2, "img", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 49);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 50);
    i0.ɵɵelementStart(7, "div", 63);
    i0.ɵɵelementStart(8, "span", 52);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 53);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 3, "dashboard-lib.cmx-connector.summary.label.header"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r31.wiredconnectorSwitchesCount);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 5, "dashboard-lib.cmx-connector.summary.label.switches"));
} }
const _c0$1c = function (a0) { return { "active-block": a0 }; };
function CmxConnectorComponent_div_0_div_1_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵelementStart(1, "ul", 69);
    i0.ɵɵelementStart(2, "li", 70);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_20_Template_li_click_2_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(3); return ctx_r53.showTabDetails("configuration"); });
    i0.ɵɵelementStart(3, "span", 71);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "li", 70);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_20_Template_li_click_6_listener() { i0.ɵɵrestoreView(_r54); const ctx_r55 = i0.ɵɵnextContext(3); return ctx_r55.showTabDetails("instances"); });
    i0.ɵɵelementStart(7, "span", 71);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "li", 70);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_20_Template_li_click_10_listener() { i0.ɵɵrestoreView(_r54); const ctx_r56 = i0.ɵɵnextContext(3); return ctx_r56.showTabDetails("metrics"); });
    i0.ɵɵelementStart(11, "span", 71);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 72);
    i0.ɵɵelementStart(15, "span", 73);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_20_Template_span_click_15_listener() { i0.ɵɵrestoreView(_r54); const ctx_r57 = i0.ɵɵnextContext(3); return ctx_r57.refreshPage(ctx_r57.currentConnector, ctx_r57.selectedTab); });
    i0.ɵɵelement(16, "img", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "span", 73);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_20_Template_span_click_17_listener() { i0.ɵɵrestoreView(_r54); const ctx_r58 = i0.ɵɵnextContext(3); return ctx_r58.viewAccessToken(ctx_r58.currentConnector, "/token", "username", "Token"); });
    i0.ɵɵelement(18, "img", 75);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "span", 76);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_20_Template_span_click_21_listener() { i0.ɵɵrestoreView(_r54); const ctx_r59 = i0.ɵɵnextContext(3); return ctx_r59.openManageConnectorPopup(true, ctx_r59.currentConnector); });
    i0.ɵɵelement(22, "img", 77);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c0$1c, ctx_r32.selectedTab === "configuration"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 8, "dashboard-lib.cmx-connector.connector-details.label.configuration"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c0$1c, ctx_r32.selectedTab === "instances"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 10, "dashboard-lib.cmx-connector.connector-details.label.instances"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c0$1c, ctx_r32.selectedTab === "metrics"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 12, "dashboard-lib.cmx-connector.connector-details.label.metrics"));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 14, "dashboard-lib.cmx-connector.connector-details.label.generate-token"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 16, "dashboard-lib.cmx-connector.connector-details.label.troubleshoot-connector"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_21_span_15_Template(rf, ctx) { if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 76);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_21_span_15_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r63); const ctx_r62 = i0.ɵɵnextContext(4); return ctx_r62.viewManageStreams(ctx_r62.currentConnector, null); });
    i0.ɵɵelement(1, "img", 77);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "dashboard-lib.cmx-connector.connector-details.label.iot-streams"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_21_span_16_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 76);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_21_span_16_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(4); return ctx_r64.viewSwitchesList(ctx_r64.currentConnector, null); });
    i0.ɵɵelement(1, "img", 77);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "dashboard-lib.cmx-connector.connector-details.label.iot-services"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵelementStart(1, "ul", 69);
    i0.ɵɵelementStart(2, "li", 78);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_21_Template_li_click_2_listener() { i0.ɵɵrestoreView(_r67); const ctx_r66 = i0.ɵɵnextContext(3); return ctx_r66.showTabDetails("configuration"); });
    i0.ɵɵelementStart(3, "span", 71);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 72);
    i0.ɵɵelementStart(7, "span", 73);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_21_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r67); const ctx_r68 = i0.ɵɵnextContext(3); return ctx_r68.viewAccessToken(ctx_r68.currentConnector, "/token", "username", "Token"); });
    i0.ɵɵelement(8, "img", 75);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 73);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_21_Template_span_click_11_listener() { i0.ɵɵrestoreView(_r67); const ctx_r69 = i0.ɵɵnextContext(3); return ctx_r69.openManageConnectorPopup(true, ctx_r69.currentConnector); });
    i0.ɵɵelement(12, "img", 77);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, CmxConnectorComponent_div_0_div_1_div_21_span_15_Template, 4, 3, "span", 79);
    i0.ɵɵtemplate(16, CmxConnectorComponent_div_0_div_1_div_21_span_16_Template, 4, 3, "span", 79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "dashboard-lib.cmx-connector.connector-details.label.configuration"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 7, "dashboard-lib.cmx-connector.connector-details.label.generate-token"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 9, "dashboard-lib.cmx-connector.connector-details.label.troubleshoot-connector"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r33.fromWiredNetwork && ctx_r33.currentConnector.version === "V2");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r33.fromWiredNetwork && ctx_r33.currentConnector.version === "V2");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 88);
    i0.ɵɵelementStart(1, "div", 89);
    i0.ɵɵelement(2, "img", 90);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 91);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "a", 92);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "br");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r70 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 4, "dashboard-lib.spaces-connector.create-connector.connector-version.connector_2_migrationnotice"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r70.connectorMigrationGuide, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 6, "dashboard-lib.spaces-connector.create-connector.connector-version.migrationnoticelink"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 8, "dashboard-lib.spaces-connector.create-connector.connector-version.connector_2_migrationlist_sup"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 93);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.connectors-label"));
} }
function CmxConnectorComponent_div_0_div_1_div_23_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 93);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 94);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_5_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r77); const ctx_r76 = i0.ɵɵnextContext(4); return ctx_r76.createNewConnector(); });
    i0.ɵɵelement(1, "img", 95);
    i0.ɵɵelementStart(2, "div", 96);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "dashboard-lib.cmx-connector.create-new-connector-label"), "");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_7_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 104);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.no-spaces-connectors"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_7_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 104);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.no-cmx-connectors"));
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵelementStart(1, "div", 98);
    i0.ɵɵelementStart(2, "div", 99);
    i0.ɵɵelementStart(3, "div", 100);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_1_div_23_div_7_div_4_Template, 3, 3, "div", 101);
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_1_div_23_div_7_ng_template_5_Template, 3, 3, "ng-template", null, 102, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 100);
    i0.ɵɵelement(8, "img", 103);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r79 = i0.ɵɵreference(6);
    const ctx_r74 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r74.dashboardSetupName == "Spaces")("ngIfElse", _r79);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r109 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 127);
    i0.ɵɵelementStart(1, "span", 128);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_2_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r109); const connector_r84 = i0.ɵɵnextContext().$implicit; const ctx_r107 = i0.ɵɵnextContext(6); return ctx_r107.viewConnector(connector_r84, connector_r84.name, connector_r84.connectorNodes); });
    i0.ɵɵelementStart(2, "a", 129);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", connector_r84.name, " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r113 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 127);
    i0.ɵɵelementStart(1, "span", 128);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_3_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r113); const connector_r84 = i0.ɵɵnextContext().$implicit; const ctx_r111 = i0.ɵɵnextContext(6); return ctx_r111.viewConnectorV2Controller(connector_r84, connector_r84.name); });
    i0.ɵɵelementStart(2, "a", 129);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", connector_r84.name, "");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(connector_r84.release);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_5_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(connector_r84.ovaVersion);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_5_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-header.na"));
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 130);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_5_span_1_Template, 2, 1, "span", 58);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_5_span_2_Template, 2, 1, "span", 58);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_5_span_3_Template, 3, 3, "span", 58);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.release);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !connector_r84.release && connector_r84.ovaVersion);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !connector_r84.release && !connector_r84.ovaVersion);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(connector_r84.release);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(connector_r84.ovaVersion);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-header.na"));
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_span_4_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 136);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.upgrade-available"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_span_4_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 137);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate3(" ", i0.ɵɵpipeBind1(2, 3, "dashboard-lib.cmx-connector.table-header.release"), " ", connector_r84.upgrade_to, " ", i0.ɵɵpipeBind1(3, 5, "dashboard-lib.cmx-connector.table-label.is-available"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 132);
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelement(2, "img", 133);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_span_4_span_3_Template, 3, 3, "span", 134);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_span_4_span_4_Template, 4, 7, "span", 135);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", connector_r84.upgrade_to == undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.upgrade_to != undefined);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_span_1_Template, 2, 1, "span", 58);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_span_2_Template, 2, 1, "span", 58);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_span_3_Template, 3, 3, "span", 58);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_span_4_Template, 5, 2, "span", 131);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.release);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !connector_r84.release && connector_r84.ovaVersion);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !connector_r84.release && !connector_r84.ovaVersion);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.upgrade_allowed == true && connector_r84.version == "V3");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 142);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", connector_r84.release, " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 142);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(connector_r84.ovaVersion);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 142);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-header.na"), "");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_5_div_3_div_2_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r143 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 151);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_5_div_3_div_2_a_5_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r143); const connector_r84 = i0.ɵɵnextContext(5).$implicit; const ctx_r141 = i0.ɵɵnextContext(6); return ctx_r141.confirmV2Upgrade(true, connector_r84); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.click-here"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_5_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 148);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 149);
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_5_div_3_div_2_a_5_Template, 3, 3, "a", 150);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "dashboard-lib.cmx-connector.table-label.upgrade-to-2x"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", connector_r84.version == "V2" && connector_r84.report != undefined && connector_r84.report.upgrade != undefined && connector_r84.report.current_version !== connector_r84.report.upgrade.latest);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(7, 6, "dashboard-lib.cmx-connector.table-label.to-upgrade"), " ", connector_r84.report.upgrade.latest, ". ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r147 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 146);
    i0.ɵɵlistener("mouseleave", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_5_div_3_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r147); const i_r85 = i0.ɵɵnextContext(3).index; const ctx_r145 = i0.ɵɵnextContext(6); return ctx_r145.onMouseLeaveEvent(i_r85); });
    i0.ɵɵelementStart(1, "div", 147);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_5_div_3_div_2_Template, 8, 8, "div", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r84.report && connector_r84.report.current_version !== connector_r84.report.upgrade.latest);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r151 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 143);
    i0.ɵɵtext(1, "\u00A0 ");
    i0.ɵɵelementStart(2, "img", 144);
    i0.ɵɵlistener("mouseover", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_5_Template_img_mouseover_2_listener() { i0.ɵɵrestoreView(_r151); const i_r85 = i0.ɵɵnextContext(2).index; const ctx_r149 = i0.ɵɵnextContext(6); return ctx_r149.onMouseOverEvent(i_r85); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_5_div_3_Template, 3, 1, "div", 145);
    i0.ɵɵelement(4, "div");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r85 = i0.ɵɵnextContext(2).index;
    const ctx_r135 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r135.migrateHover[i_r85]);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 138);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_1_Template, 2, 1, "div", 139);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_2_Template, 2, 1, "div", 139);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_3_Template, 3, 3, "div", 139);
    i0.ɵɵelementStart(4, "div", 140);
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_div_5_Template, 5, 1, "div", 141);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.release);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !connector_r84.release && connector_r84.ovaVersion);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !connector_r84.release && !connector_r84.ovaVersion);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (connector_r84.version == "V2" || connector_r84.version == undefined) && (connector_r84.report && connector_r84.report.upgrade !== undefined && connector_r84.report.current_version !== connector_r84.report.upgrade.latest));
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(connector_r84.instanceCount);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-header.na"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", connector_r84.associatedControllers.length, " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1, " 0 ");
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 152);
    i0.ɵɵelement(1, "img", 153);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", connector_r84.connectorStatus === "Active" ? "active" : "inactive");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.summary.label.up"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 152);
    i0.ɵɵelement(1, "img", 154);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", connector_r84.connectorStatus === "Active" ? "active" : "inactive");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.summary.label.down"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 155);
    i0.ɵɵelement(1, "img", 156);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "span", 157);
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "br");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 3, "dashboard-lib.cmx-connector.table-label.degraded"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 5, "dashboard-lib.cmx-connector.table-label.status"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", connector_r84.connectorStatusDescription, " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, connector_r84.updatedAt, "medium"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.never"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(2, 1, connector_r84.lastHeard, "medium"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.never"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_a_33_Template(rf, ctx) { if (rf & 1) {
    const _r163 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 158);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_a_33_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r163); const connector_r84 = i0.ɵɵnextContext().$implicit; const ctx_r161 = i0.ɵɵnextContext(6); return ctx_r161.openConnectorDetailsPopup(true, connector_r84); });
    i0.ɵɵelement(1, "img", 159);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_a_34_Template(rf, ctx) { if (rf & 1) {
    const _r166 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 158);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_a_34_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r166); const connector_r84 = i0.ɵɵnextContext().$implicit; const ctx_r164 = i0.ɵɵnextContext(6); return ctx_r164.updgradeConnector(connector_r84.id, ctx_r164.currentConnector.version); });
    i0.ɵɵelement(1, "img", 160);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_a_35_Template(rf, ctx) { if (rf & 1) {
    const _r169 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 158);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_a_35_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r169); const connector_r84 = i0.ɵɵnextContext().$implicit; const ctx_r167 = i0.ɵɵnextContext(6); return ctx_r167.viewConnector(connector_r84, connector_r84.name, connector_r84.connectorNodes); });
    i0.ɵɵelement(1, "img", 161);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_a_37_Template(rf, ctx) { if (rf & 1) {
    const _r172 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 162);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_a_37_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r172); const connector_r84 = i0.ɵɵnextContext().$implicit; const ctx_r170 = i0.ɵɵnextContext(6); return ctx_r170.openMoreOptions(connector_r84); });
    i0.ɵɵelement(1, "img", 163);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_38_Template(rf, ctx) { if (rf & 1) {
    const _r175 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 164);
    i0.ɵɵelementStart(1, "div", 165);
    i0.ɵɵelement(2, "div", 166);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 167);
    i0.ɵɵelementStart(4, "ul");
    i0.ɵɵelementStart(5, "li", 168);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_38_Template_li_click_5_listener() { i0.ɵɵrestoreView(_r175); const connector_r84 = i0.ɵɵnextContext().$implicit; const ctx_r173 = i0.ɵɵnextContext(6); return ctx_r173.openRenameConnectorPopup(true, connector_r84); });
    i0.ɵɵelementStart(6, "a", 169);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "li", 168);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_38_Template_li_click_9_listener() { i0.ɵɵrestoreView(_r175); const connector_r84 = i0.ɵɵnextContext().$implicit; const ctx_r176 = i0.ɵɵnextContext(6); return ctx_r176.deleteConnectorConfirmPopup(connector_r84); });
    i0.ɵɵelementStart(10, "a", 169);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 2, "dashboard-lib.cmx-connector.table-label.edit-connector"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 4, "dashboard-lib.cmx-connector.table-label.delete-connector"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 112);
    i0.ɵɵelementStart(1, "td", 113);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_2_Template, 4, 1, "span", 114);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_3_Template, 4, 1, "span", 114);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_5_Template, 4, 3, "div", 115);
    i0.ɵɵtemplate(6, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_6_Template, 5, 4, "div", 58);
    i0.ɵɵtemplate(7, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_7_Template, 6, 4, "div", 116);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_9_Template, 2, 1, "span", 58);
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_10_Template, 3, 3, "span", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td", 117);
    i0.ɵɵelementStart(12, "span", 118);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td");
    i0.ɵɵtemplate(15, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_15_Template, 2, 1, "span", 119);
    i0.ɵɵtemplate(16, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_16_Template, 2, 0, "span", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "td");
    i0.ɵɵelementStart(18, "span", 118);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "td");
    i0.ɵɵtemplate(21, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_21_Template, 4, 4, "span", 120);
    i0.ɵɵtemplate(22, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_22_Template, 4, 4, "span", 120);
    i0.ɵɵtemplate(23, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_23_Template, 10, 7, "span", 121);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "td");
    i0.ɵɵtemplate(25, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_25_Template, 3, 4, "span", 119);
    i0.ɵɵtemplate(26, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_26_Template, 3, 3, "span", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "td");
    i0.ɵɵtemplate(28, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_28_Template, 3, 4, "span", 119);
    i0.ɵɵtemplate(29, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_span_29_Template, 3, 3, "span", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "td");
    i0.ɵɵelementStart(31, "span", 118);
    i0.ɵɵelementStart(32, "span", 122);
    i0.ɵɵtemplate(33, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_a_33_Template, 2, 0, "a", 123);
    i0.ɵɵtemplate(34, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_a_34_Template, 2, 0, "a", 123);
    i0.ɵɵtemplate(35, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_a_35_Template, 2, 0, "a", 123);
    i0.ɵɵelementStart(36, "span", 124);
    i0.ɵɵtemplate(37, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_a_37_Template, 2, 0, "a", 125);
    i0.ɵɵtemplate(38, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_div_38_Template, 13, 6, "div", 126);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r84 = ctx.$implicit;
    const ctx_r83 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r84.version === "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.version === "V2" || connector_r84.version == undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r83.isUpgradeLoaded && connector_r84.version == "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r83.isUpgradeLoaded && connector_r84.version == "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.version == "V2");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r84.version == "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.version == "V2");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", connector_r84.switchesSize, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r84.associatedControllers !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.associatedControllers === undefined);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", connector_r84.report && connector_r84.report.connector && connector_r84.report.connector.numberOfAps ? connector_r84.report.connector.numberOfAps : "0", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r84.connectorStatus === "Active");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.connectorStatus !== "Active" && connector_r84.connectorStatus !== "Degraded");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.connectorStatus === "Degraded");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r84.updatedAt !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.updatedAt === undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r84.lastHeard !== null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.lastHeard === null || connector_r84.lastHeard == undefined);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", connector_r84.version !== "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.version == "V3" && connector_r84.upgrade_allowed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r84.version == "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r83.showMoreOptions ? "selected" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r83.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r83.selectedCustomerName === connector_r84.name);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_tr_1_Template, 39, 24, "tr", 111);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r81 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r81.currentConnectorItems);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r203 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 127);
    i0.ɵɵelementStart(1, "span", 128);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_2_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r203); const connector_r179 = i0.ɵɵnextContext().$implicit; const ctx_r201 = i0.ɵɵnextContext(6); return ctx_r201.viewConnector(connector_r179, connector_r179.name, connector_r179.connectorNodes); });
    i0.ɵɵelementStart(2, "a", 129);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r179 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(connector_r179.name);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r207 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 127);
    i0.ɵɵelementStart(1, "span", 128);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_3_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r207); const connector_r179 = i0.ɵɵnextContext().$implicit; const ctx_r205 = i0.ɵɵnextContext(6); return ctx_r205.viewConnectorV2Controller(connector_r179, connector_r179.name); });
    i0.ɵɵelementStart(2, "a", 129);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r179 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(connector_r179.name);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r179 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(connector_r179.release);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r179 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(connector_r179.ovaVersion);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "NA");
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelement(2, "img", 174);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r179 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(connector_r179.instanceCount);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " NA ");
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r179 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", connector_r179.associatedControllers.length, " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1, " 0 ");
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 152);
    i0.ɵɵelement(1, "img", 153);
    i0.ɵɵtext(2, "Up ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r179 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", connector_r179.connectorStatus === "Active" ? "active" : "inactive");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 152);
    i0.ɵɵelement(1, "img", 154);
    i0.ɵɵtext(2, "Down ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r179 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", connector_r179.connectorStatus === "Active" ? "active" : "inactive");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 155);
    i0.ɵɵelement(1, "img", 156);
    i0.ɵɵtext(2, "Degraded ");
    i0.ɵɵelementStart(3, "span", 157);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5, "Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "br");
    i0.ɵɵelement(7, "br");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r179 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", connector_r179.connectorStatusDescription, " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r179 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, connector_r179.updatedAt, "medium"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1, " Never ");
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r179 = i0.ɵɵnextContext().$implicit;
    const ctx_r196 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r196.getDurationFromTimestamp(connector_r179.lastHeard), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1, " Never ");
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_a_33_Template(rf, ctx) { if (rf & 1) {
    const _r220 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 172);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_a_33_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r220); const connector_r179 = i0.ɵɵnextContext().$implicit; const ctx_r218 = i0.ɵɵnextContext(6); return ctx_r218.openConnectorDetailsPopup(true, connector_r179); });
    i0.ɵɵelement(1, "img", 159);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_a_36_Template(rf, ctx) { if (rf & 1) {
    const _r223 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 175);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_a_36_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r223); const connector_r179 = i0.ɵɵnextContext().$implicit; const ctx_r221 = i0.ɵɵnextContext(6); return ctx_r221.openRenameConnectorPopup(true, connector_r179); });
    i0.ɵɵelement(1, "img", 176);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_a_37_Template(rf, ctx) { if (rf & 1) {
    const _r226 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 175);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_a_37_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r226); const connector_r179 = i0.ɵɵnextContext().$implicit; const ctx_r224 = i0.ɵɵnextContext(6); return ctx_r224.deleteConnectorConfirmPopup(connector_r179); });
    i0.ɵɵelement(1, "img", 177);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r228 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 112);
    i0.ɵɵelementStart(1, "td", 113);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_2_Template, 4, 1, "span", 114);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_3_Template, 4, 1, "span", 114);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_5_Template, 2, 1, "span", 58);
    i0.ɵɵtemplate(6, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_6_Template, 2, 1, "span", 58);
    i0.ɵɵtemplate(7, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_7_Template, 2, 0, "span", 58);
    i0.ɵɵtemplate(8, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_8_Template, 3, 0, "span", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_10_Template, 2, 1, "span", 58);
    i0.ɵɵtemplate(11, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_11_Template, 2, 0, "span", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td", 117);
    i0.ɵɵelementStart(13, "span", 118);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td");
    i0.ɵɵtemplate(16, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_16_Template, 2, 1, "span", 119);
    i0.ɵɵtemplate(17, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_17_Template, 2, 0, "span", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td");
    i0.ɵɵelementStart(19, "span", 118);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "td");
    i0.ɵɵtemplate(22, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_22_Template, 3, 1, "span", 120);
    i0.ɵɵtemplate(23, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_23_Template, 3, 1, "span", 120);
    i0.ɵɵtemplate(24, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_24_Template, 9, 1, "span", 121);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "td");
    i0.ɵɵtemplate(26, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_26_Template, 3, 4, "span", 119);
    i0.ɵɵtemplate(27, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_27_Template, 2, 0, "span", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "td");
    i0.ɵɵtemplate(29, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_29_Template, 2, 1, "span", 119);
    i0.ɵɵtemplate(30, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_span_30_Template, 2, 0, "span", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "td");
    i0.ɵɵelementStart(32, "span", 170);
    i0.ɵɵtemplate(33, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_a_33_Template, 2, 0, "a", 171);
    i0.ɵɵelementStart(34, "a", 172);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_Template_a_click_34_listener() { const restoredCtx = i0.ɵɵrestoreView(_r228); const connector_r179 = restoredCtx.$implicit; const ctx_r227 = i0.ɵɵnextContext(6); return ctx_r227.viewConnector(connector_r179, connector_r179.name, connector_r179.connectorNodes); });
    i0.ɵɵelement(35, "img", 161);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(36, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_a_36_Template, 2, 0, "a", 173);
    i0.ɵɵtemplate(37, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_a_37_Template, 2, 0, "a", 173);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r179 = ctx.$implicit;
    const ctx_r178 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r179.version === "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r179.version === "V2" || connector_r179.version == undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r179.release);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !connector_r179.release && connector_r179.ovaVersion);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !connector_r179.release && !connector_r179.ovaVersion);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r179.upgrade_allowed);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r179.version == "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r179.version == "V2");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(connector_r179.switchesSize);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r179.associatedControllers !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r179.associatedControllers === undefined);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", connector_r179.report && connector_r179.report.connector && connector_r179.report.connector.numberOfAps ? connector_r179.report.connector.numberOfAps : "0", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r179.connectorStatus === "Active");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r179.connectorStatus !== "Active" && connector_r179.connectorStatus !== "Degraded");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r179.connectorStatus === "Degraded");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r179.updatedAt !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r179.updatedAt === undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", connector_r179.lastHeard !== null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r179.lastHeard === null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r178.showMoreOptions ? "selected" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", connector_r179.version !== "V3");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r178.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r178.userRole !== "ReadOnlyAccess");
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_tr_1_Template, 38, 23, "tr", 111);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r82 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r82.currentConnectorItems);
} }
function CmxConnectorComponent_div_0_div_1_div_23_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r230 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 105);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "table", 106);
    i0.ɵɵelementStart(3, "thead");
    i0.ɵɵelementStart(4, "tr", 107);
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "th");
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th");
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "th");
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "th");
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "th");
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "th");
    i0.ɵɵtext(30);
    i0.ɵɵpipe(31, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "th");
    i0.ɵɵtext(33);
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(35, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_35_Template, 2, 1, "tbody", 58);
    i0.ɵɵtemplate(36, CmxConnectorComponent_div_0_div_1_div_23_div_8_tbody_36_Template, 2, 1, "tbody", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "lib-search-basic", 108);
    i0.ɵɵlistener("filtered", function CmxConnectorComponent_div_0_div_1_div_23_div_8_Template_lib_search_basic_filtered_37_listener($event) { i0.ɵɵrestoreView(_r230); const ctx_r229 = i0.ɵɵnextContext(4); return ctx_r229.onConnectorFilter($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "div", 109);
    i0.ɵɵelementStart(39, "lib-pagination", 110);
    i0.ɵɵlistener("clickEvent", function CmxConnectorComponent_div_0_div_1_div_23_div_8_Template_lib_pagination_clickEvent_39_listener($event) { i0.ɵɵrestoreView(_r230); const ctx_r231 = i0.ɵɵnextContext(4); return ctx_r231.clickEvents($event); })("currentPage", function CmxConnectorComponent_div_0_div_1_div_23_div_8_Template_lib_pagination_currentPage_39_listener($event) { i0.ɵɵrestoreView(_r230); const ctx_r232 = i0.ɵɵnextContext(4); return ctx_r232.getCurrentConnectorItems($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 20, "dashboard-lib.cmx-connector.table-header.name"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(10, 22, "dashboard-lib.cmx-connector.table-header.release"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 24, "dashboard-lib.cmx-connector.table-header.instances"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 26, "dashboard-lib.cmx-connector.table-header.switches"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 28, "dashboard-lib.cmx-connector.table-header.controllers"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(22, 30, "dashboard-lib.cmx-connector.table-header.aps"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(25, 32, "dashboard-lib.cmx-connector.table-header.status"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(28, 34, "dashboard-lib.cmx-connector.table-header.last-modified"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(31, 36, "dashboard-lib.cmx-connector.table-header.last-heard"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(34, 38, "dashboard-lib.cmx-connector.table-header.actions"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r75.currentConnectorItems && !ctx_r75.fromWiredNetwork);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r75.currentConnectorItems && ctx_r75.fromWiredNetwork);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", ctx_r75.cmxConnectorList)("shouldUseGlobalSearch", true)("searchSkeleton", ctx_r75.searchSkeleton);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pagesToShow", 3)("perPage", ctx_r75.limit)("page", ctx_r75.page)("loading", false)("items", ctx_r75.connectorList_searched);
} }
function CmxConnectorComponent_div_0_div_1_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 80);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_23_div_1_Template, 12, 10, "div", 81);
    i0.ɵɵelementStart(2, "div", 82);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_1_div_23_span_3_Template, 3, 3, "span", 83);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_1_div_23_span_4_Template, 1, 0, "span", 83);
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_1_div_23_div_5_Template, 5, 3, "div", 84);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 85);
    i0.ɵɵtemplate(7, CmxConnectorComponent_div_0_div_1_div_23_div_7_Template, 9, 2, "div", 86);
    i0.ɵɵtemplate(8, CmxConnectorComponent_div_0_div_1_div_23_div_8_Template, 40, 40, "div", 87);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r34.migrationNotice == true ? "grayDiv_list" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r34.migrationNotice);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r34.cmxConnectorList.length !== 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r34.cmxConnectorList.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r34.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r34.cmxConnectorList.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r34.cmxConnectorList && ctx_r34.cmxConnectorList.length > 0 && !ctx_r34.showConnectorDetails);
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 88);
    i0.ɵɵelementStart(1, "div", 89);
    i0.ɵɵelement(2, "img", 90);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 91);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "a", 92);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "br");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r233 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 4, "dashboard-lib.spaces-connector.create-connector.connector-version.connector_2_migrationnotice"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r233.connectorMigrationGuide, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 6, "dashboard-lib.spaces-connector.create-connector.connector-version.migrationnoticelink"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 8, "dashboard-lib.spaces-connector.create-connector.connector-version.connector_2_migrationsupport"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r238 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 188);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_24_div_11_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r238); const ctx_r237 = i0.ɵɵnextContext(4); return ctx_r237.showCMXConnectorAdd(true, true, false); });
    i0.ɵɵelement(1, "img", 189);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "dashboard-lib.cmx-connector.controllers.add-controller"));
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵelementStart(1, "div", 190);
    i0.ɵɵelementStart(2, "div", 99);
    i0.ɵɵelementStart(3, "div", 100);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 100);
    i0.ɵɵelement(11, "img", 103);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 2, "dashboard-lib.cmx-connector.controllers.not-added"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 4, "dashboard-lib.cmx-connector.controllers.click-desc"));
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r241 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, controller_r241.updatedAt, "medium"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.never"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_span_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r241 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, controller_r241.lastHeard, "medium"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_span_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.never"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_span_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 152);
    i0.ɵɵelement(1, "img", 154);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r241 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", controller_r241.connectionStatus === "Active" ? "active" : "inactive");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", controller_r241.connectionStatus, " ");
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_span_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 152);
    i0.ɵɵelement(1, "img", 153);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r241 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", controller_r241.connectionStatus === "Active" ? "active" : "inactive");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", controller_r241.connectionStatus, " ");
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_a_26_Template(rf, ctx) { if (rf & 1) {
    const _r257 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 175);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_a_26_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r257); const controller_r241 = i0.ɵɵnextContext().$implicit; const ctx_r255 = i0.ɵɵnextContext(6); return ctx_r255.editController(controller_r241); });
    i0.ɵɵelement(1, "img", 200);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_a_27_Template(rf, ctx) { if (rf & 1) {
    const _r260 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 175);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_a_27_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r260); const controller_r241 = i0.ɵɵnextContext().$implicit; const ctx_r258 = i0.ɵɵnextContext(6); return ctx_r258.deleteControllerConfirmPopup(controller_r241); });
    i0.ɵɵelement(1, "img", 201);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r262 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 194);
    i0.ɵɵelementStart(1, "td", 195);
    i0.ɵɵelementStart(2, "span", 127);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵelementStart(4, "span", 196);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 197);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵelementStart(11, "span", 198);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "td");
    i0.ɵɵtemplate(14, CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_span_14_Template, 3, 4, "span", 119);
    i0.ɵɵtemplate(15, CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_span_15_Template, 3, 3, "span", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td");
    i0.ɵɵtemplate(17, CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_span_17_Template, 3, 4, "span", 119);
    i0.ɵɵtemplate(18, CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_span_18_Template, 3, 3, "span", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "td");
    i0.ɵɵtemplate(20, CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_span_20_Template, 3, 2, "span", 120);
    i0.ɵɵtemplate(21, CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_span_21_Template, 3, 2, "span", 120);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "td");
    i0.ɵɵelementStart(23, "span", 170);
    i0.ɵɵelementStart(24, "a", 172);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_Template_a_click_24_listener() { const restoredCtx = i0.ɵɵrestoreView(_r262); const controller_r241 = restoredCtx.$implicit; const ctx_r261 = i0.ɵɵnextContext(6); return ctx_r261.openControllerDetailsPopup(true, controller_r241); });
    i0.ɵɵelement(25, "img", 199);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(26, CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_a_26_Template, 2, 0, "a", 173);
    i0.ɵɵtemplate(27, CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_a_27_Template, 2, 0, "a", 173);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r241 = ctx.$implicit;
    const ctx_r240 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", controller_r241.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", controller_r241.type === "ewlc" ? "Catalyst 9800 Wireless Controller" : controller_r241.type === "WLC" ? "AireOS Controller" : controller_r241.type, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", controller_r241.controllerIp, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", controller_r241.accessPointsCount > 0 ? controller_r241.accessPointsCount : 0, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", controller_r241.updatedAt !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", controller_r241.updatedAt === undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", controller_r241.lastHeard !== undefined && controller_r241.lastHeard !== -1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", controller_r241.lastHeard === undefined || controller_r241.lastHeard === -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", controller_r241.connectionStatus != "Active");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", controller_r241.connectionStatus == "Active");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r240.showMoreOptions ? "selected" : "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r240.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r240.userRole !== "ReadOnlyAccess");
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_tr_1_Template, 28, 13, "tr", 193);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r239 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r239.currentControllerItemsV2);
} }
function CmxConnectorComponent_div_0_div_1_div_24_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r264 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 191);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "table", 192);
    i0.ɵɵelementStart(3, "thead");
    i0.ɵɵelementStart(4, "tr", 107);
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "th");
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th");
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "th");
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "th");
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(26, CmxConnectorComponent_div_0_div_1_div_24_div_14_tbody_26_Template, 2, 1, "tbody", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "lib-search-basic", 108);
    i0.ɵɵlistener("filtered", function CmxConnectorComponent_div_0_div_1_div_24_div_14_Template_lib_search_basic_filtered_27_listener($event) { i0.ɵɵrestoreView(_r264); const ctx_r263 = i0.ɵɵnextContext(4); return ctx_r263.onControllerFilterV2($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 109);
    i0.ɵɵelementStart(29, "lib-pagination", 110);
    i0.ɵɵlistener("clickEvent", function CmxConnectorComponent_div_0_div_1_div_24_div_14_Template_lib_pagination_clickEvent_29_listener($event) { i0.ɵɵrestoreView(_r264); const ctx_r265 = i0.ɵɵnextContext(4); return ctx_r265.clickEvents($event); })("currentPage", function CmxConnectorComponent_div_0_div_1_div_24_div_14_Template_lib_pagination_currentPage_29_listener($event) { i0.ɵɵrestoreView(_r264); const ctx_r266 = i0.ɵɵnextContext(4); return ctx_r266.getCurrentControllerItemsV2($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r236 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 16, "dashboard-lib.cmx-connector.table-header.name"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 18, "dashboard-lib.cmx-connector.table-header.ip-address"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 20, "dashboard-lib.cmx-connector.table-header.no-of-aps"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 22, "dashboard-lib.cmx-connector.table-header.last-modified"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 24, "dashboard-lib.cmx-connector.table-header.last-heard"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(22, 26, "dashboard-lib.cmx-connector.table-header.status"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(25, 28, "dashboard-lib.cmx-connector.table-header.actions"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r236.currentControllerItemsV2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", ctx_r236.controllerList)("shouldUseGlobalSearch", true)("searchSkeleton", ctx_r236.searchSkeleton);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pagesToShow", 3)("perPage", ctx_r236.limit)("page", ctx_r236.page)("loading", false)("items", ctx_r236.controllerList_searchedV2);
} }
function CmxConnectorComponent_div_0_div_1_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r268 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 178);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_24_div_1_Template, 12, 10, "div", 81);
    i0.ɵɵelementStart(2, "div", 179);
    i0.ɵɵelementStart(3, "span", 93);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 180);
    i0.ɵɵelementStart(7, "div", 181);
    i0.ɵɵelement(8, "span", 182);
    i0.ɵɵelementStart(9, "input", 183);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_1_div_24_Template_input_ngModelChange_9_listener($event) { i0.ɵɵrestoreView(_r268); const ctx_r267 = i0.ɵɵnextContext(3); return ctx_r267.searchInController = $event; })("keyup", function CmxConnectorComponent_div_0_div_1_div_24_Template_input_keyup_9_listener() { i0.ɵɵrestoreView(_r268); const ctx_r269 = i0.ɵɵnextContext(3); return ctx_r269.onControllerSearchKeyUp(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "lib-search-basic", 184);
    i0.ɵɵlistener("filtered", function CmxConnectorComponent_div_0_div_1_div_24_Template_lib_search_basic_filtered_10_listener($event) { i0.ɵɵrestoreView(_r268); const ctx_r270 = i0.ɵɵnextContext(3); return ctx_r270.onControllerSearchFilter($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, CmxConnectorComponent_div_0_div_1_div_24_div_11_Template, 5, 3, "div", 185);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 186);
    i0.ɵɵtemplate(13, CmxConnectorComponent_div_0_div_1_div_24_div_13_Template, 12, 6, "div", 86);
    i0.ɵɵtemplate(14, CmxConnectorComponent_div_0_div_1_div_24_div_14_Template, 30, 30, "div", 187);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.migrationNotice);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 10, "dashboard-lib.cmx-connector.controllers.title"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r35.searchInController);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", ctx_r35.controllerList)("customSearchText", ctx_r35.searchText)("shouldUseGlobalSearch", false)("searchSkeleton", ctx_r35.controllerSearchSkeleton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r35.controllerList.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.controllerList && ctx_r35.controllerList.length > 0);
} }
function CmxConnectorComponent_div_0_div_1_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r272 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 202);
    i0.ɵɵelementStart(1, "app-cmx-connector-instances", 203);
    i0.ɵɵlistener("emitInstanceRemoval", function CmxConnectorComponent_div_0_div_1_div_25_Template_app_cmx_connector_instances_emitInstanceRemoval_1_listener($event) { i0.ɵɵrestoreView(_r272); const ctx_r271 = i0.ɵɵnextContext(3); return ctx_r271.reloadConnectorDetail($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("userRole", ctx_r36.userRole)("availableInstances", ctx_r36.instances)("currentConnector", ctx_r36.currentConnector)("allAvailableServices", ctx_r36.serviceList)("nodeIds", ctx_r36.instancesNodeIds)("connectorConfigureGuide", ctx_r36.connectorConfigureGuide)("serviceNameDisplayName", ctx_r36.serviceNameDisplayName);
} }
function CmxConnectorComponent_div_0_div_1_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r274 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 204);
    i0.ɵɵelementStart(1, "lib-cmx-connector-switches", 205);
    i0.ɵɵlistener("closeModal", function CmxConnectorComponent_div_0_div_1_div_26_Template_lib_cmx_connector_switches_closeModal_1_listener() { i0.ɵɵrestoreView(_r274); const ctx_r273 = i0.ɵɵnextContext(3); return ctx_r273.closeModal(); })("showConnectorListPage", function CmxConnectorComponent_div_0_div_1_div_26_Template_lib_cmx_connector_switches_showConnectorListPage_1_listener() { i0.ɵɵrestoreView(_r274); const ctx_r275 = i0.ɵɵnextContext(3); return ctx_r275.showConnectorListPage(); })("showSwitchCount", function CmxConnectorComponent_div_0_div_1_div_26_Template_lib_cmx_connector_switches_showSwitchCount_1_listener($event) { i0.ɵɵrestoreView(_r274); const ctx_r276 = i0.ɵɵnextContext(3); return ctx_r276.loadSwitchCount($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pageFrom", ctx_r37.pageFrom)("switchConnector", ctx_r37.currentConnector)("modalTitle", ctx_r37.modalTitle)("type", ctx_r37.actionType);
} }
function CmxConnectorComponent_div_0_div_1_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r278 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 206);
    i0.ɵɵelementStart(1, "span", 207);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "span", 208);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_27_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r278); const ctx_r277 = i0.ɵɵnextContext(3); return ctx_r277.updgradeConnector(ctx_r277.currentConnector.id, ctx_r277.currentConnector.version); });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementStart(8, "span", 209);
    i0.ɵɵtext(9, "|");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "a", 210);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 5, "dashboard-lib.cmx-connector.table-label.connector-updates-available"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 7, "dashboard-lib.cmx-connector.table-label.upgrade-connector"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("href", ctx_r38.connectorReleaseNote, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 9, "dashboard-lib.cmx-connector.table-label.click-here"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 11, "dashboard-lib.cmx-connector.table-label.upgrade-desc"));
} }
function CmxConnectorComponent_div_0_div_1_div_28_app_connector_services_1_Template(rf, ctx) { if (rf & 1) {
    const _r281 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-connector-services", 213);
    i0.ɵɵlistener("connectorServices", function CmxConnectorComponent_div_0_div_1_div_28_app_connector_services_1_Template_app_connector_services_connectorServices_0_listener() { i0.ɵɵrestoreView(_r281); const ctx_r280 = i0.ɵɵnextContext(4); return ctx_r280.reloadServices(); })("triggerManageIOTStreams", function CmxConnectorComponent_div_0_div_1_div_28_app_connector_services_1_Template_app_connector_services_triggerManageIOTStreams_0_listener($event) { i0.ɵɵrestoreView(_r281); const ctx_r282 = i0.ɵɵnextContext(4); return ctx_r282.viewManageStreams(ctx_r282.currentConnector, $event); })("showServiceUpgrade", function CmxConnectorComponent_div_0_div_1_div_28_app_connector_services_1_Template_app_connector_services_showServiceUpgrade_0_listener($event) { i0.ɵɵrestoreView(_r281); const ctx_r283 = i0.ɵɵnextContext(4); return ctx_r283.showServiceUpgrade($event); })("triggerManageIOTServices", function CmxConnectorComponent_div_0_div_1_div_28_app_connector_services_1_Template_app_connector_services_triggerManageIOTServices_0_listener($event) { i0.ɵɵrestoreView(_r281); const ctx_r284 = i0.ɵɵnextContext(4); return ctx_r284.viewSwitchesList(ctx_r284.currentConnector, $event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r279 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("selectedServices", ctx_r279.selectedServices)("userRole", ctx_r279.userRole)("allServices", ctx_r279.allServices)("currentConnector", ctx_r279.currentConnector)("isConnectorAvailable", ctx_r279.isConnectorAvailable);
} }
function CmxConnectorComponent_div_0_div_1_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 211);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_28_app_connector_services_1_Template, 1, 5, "app-connector-services", 212);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r39.currentConnector.upgrade_allowed == true ? "grayDiv-service-upgrade" : "grayDiv-service");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.selectedServices);
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r289 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 188);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_29_div_10_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r289); const ctx_r288 = i0.ɵɵnextContext(4); return ctx_r288.showCMXConnectorAdd(true, true, false); });
    i0.ɵɵelement(1, "img", 189);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "dashboard-lib.cmx-connector.controllers.add-controller"));
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_12_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵelementStart(1, "div", 98);
    i0.ɵɵelementStart(2, "div", 99);
    i0.ɵɵelementStart(3, "div", 100);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 100);
    i0.ɵɵelement(11, "img", 103);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 2, "dashboard-lib.cmx-connector.controllers.not-added"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 4, "dashboard-lib.cmx-connector.controllers.click-desc"));
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_29_div_12_div_1_Template, 12, 6, "div", 86);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r286 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r286.controllerList.length === 0);
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r293 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, controller_r293.updatedAt, "medium"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.never"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r293 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, controller_r293.lastHeard, "medium"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.never"), " ");
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_20_Template(rf, ctx) { if (rf & 1) {
    const _r308 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 223);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_20_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r308); const controller_r293 = i0.ɵɵnextContext().$implicit; const ctx_r306 = i0.ɵɵnextContext(6); return ctx_r306.showServiceStatus(controller_r293); });
    i0.ɵɵelement(1, "img", 224);
    i0.ɵɵelementStart(2, "a", 129);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r293 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", controller_r293.connectionStatus === "Active" ? "active" : "inactive");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(controller_r293.connectionStatus);
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_21_Template(rf, ctx) { if (rf & 1) {
    const _r312 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 223);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_21_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r312); const controller_r293 = i0.ɵɵnextContext().$implicit; const ctx_r310 = i0.ɵɵnextContext(6); return ctx_r310.showServiceStatus(controller_r293); });
    i0.ɵɵelement(1, "img", 153);
    i0.ɵɵelementStart(2, "a", 129);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r293 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", controller_r293.connectionStatus === "Active" ? "active" : "inactive");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(controller_r293.connectionStatus);
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_22_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r293 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(controller_r293.report.controllerStatusDescription);
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_22_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-header.na"));
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_22_Template(rf, ctx) { if (rf & 1) {
    const _r319 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 225);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_22_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r319); const controller_r293 = i0.ɵɵnextContext().$implicit; const ctx_r317 = i0.ɵɵnextContext(6); return ctx_r317.showServiceStatus(controller_r293); });
    i0.ɵɵelement(1, "img", 156);
    i0.ɵɵelementStart(2, "a", 129);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 157);
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "br");
    i0.ɵɵelement(10, "br");
    i0.ɵɵtemplate(11, CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_22_span_11_Template, 2, 1, "span", 58);
    i0.ɵɵtemplate(12, CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_22_span_12_Template, 3, 3, "span", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r293 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", controller_r293.connectionStatus === "Active" ? "active" : "inactive");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 5, "dashboard-lib.cmx-connector.table-label.degraded"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 7, "dashboard-lib.cmx-connector.table-label.status"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", controller_r293.report);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", controller_r293.report == undefined);
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_a_27_Template(rf, ctx) { if (rf & 1) {
    const _r323 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 175);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_a_27_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r323); const controller_r293 = i0.ɵɵnextContext().$implicit; const ctx_r321 = i0.ɵɵnextContext(6); return ctx_r321.editController(controller_r293); });
    i0.ɵɵelement(1, "img", 200);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_a_28_Template(rf, ctx) { if (rf & 1) {
    const _r326 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 175);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_a_28_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r326); const controller_r293 = i0.ɵɵnextContext().$implicit; const ctx_r324 = i0.ɵɵnextContext(6); return ctx_r324.deleteControllerConfirmPopup(controller_r293); });
    i0.ɵɵelement(1, "img", 201);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r328 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 194);
    i0.ɵɵelementStart(1, "td", 195);
    i0.ɵɵelementStart(2, "span", 127);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵelementStart(4, "span", 196);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 197);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵelementStart(11, "span", 198);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "td");
    i0.ɵɵtemplate(14, CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_14_Template, 3, 4, "span", 119);
    i0.ɵɵtemplate(15, CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_15_Template, 3, 3, "span", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td");
    i0.ɵɵtemplate(17, CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_17_Template, 3, 4, "span", 119);
    i0.ɵɵtemplate(18, CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_18_Template, 3, 3, "span", 119);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "td");
    i0.ɵɵtemplate(20, CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_20_Template, 4, 2, "span", 221);
    i0.ɵɵtemplate(21, CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_21_Template, 4, 2, "span", 221);
    i0.ɵɵtemplate(22, CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_span_22_Template, 13, 9, "span", 222);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "td");
    i0.ɵɵelementStart(24, "span", 170);
    i0.ɵɵelementStart(25, "a", 172);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_Template_a_click_25_listener() { const restoredCtx = i0.ɵɵrestoreView(_r328); const controller_r293 = restoredCtx.$implicit; const ctx_r327 = i0.ɵɵnextContext(6); return ctx_r327.openControllerDetailsPopup(true, controller_r293); });
    i0.ɵɵelement(26, "img", 199);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_a_27_Template, 2, 0, "a", 173);
    i0.ɵɵtemplate(28, CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_a_28_Template, 2, 0, "a", 173);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r293 = ctx.$implicit;
    const ctx_r292 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", controller_r293.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", controller_r293.type === "ewlc" ? "Catalyst 9800 Wireless Controller" : controller_r293.type === "WLC" ? "AireOS Controller" : controller_r293.type, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", controller_r293.controllerIp, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", controller_r293.accessPointsCount > 0 ? controller_r293.accessPointsCount : 0, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", controller_r293.updatedAt !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", controller_r293.updatedAt === undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", controller_r293.lastHeard !== undefined && controller_r293.lastHeard !== -1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", controller_r293.lastHeard === undefined || controller_r293.lastHeard === -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", controller_r293.connectionStatus == "Inactive");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", controller_r293.connectionStatus == "Active");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", controller_r293.connectionStatus == "Degraded");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r292.showMoreOptions ? "selected" : "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r292.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r292.userRole !== "ReadOnlyAccess");
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_tr_1_Template, 29, 14, "tr", 193);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r291 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r291.currentControllerItems);
} }
function CmxConnectorComponent_div_0_div_1_div_29_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r330 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 218);
    i0.ɵɵelementStart(1, "div", 219);
    i0.ɵɵelementStart(2, "table", 220);
    i0.ɵɵelementStart(3, "thead");
    i0.ɵɵelementStart(4, "tr", 107);
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "th");
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th");
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "th");
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "th");
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(26, CmxConnectorComponent_div_0_div_1_div_29_div_13_tbody_26_Template, 2, 1, "tbody", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "lib-search-basic", 108);
    i0.ɵɵlistener("filtered", function CmxConnectorComponent_div_0_div_1_div_29_div_13_Template_lib_search_basic_filtered_27_listener($event) { i0.ɵɵrestoreView(_r330); const ctx_r329 = i0.ɵɵnextContext(4); return ctx_r329.onControllerFilter($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 109);
    i0.ɵɵelementStart(29, "lib-pagination", 110);
    i0.ɵɵlistener("clickEvent", function CmxConnectorComponent_div_0_div_1_div_29_div_13_Template_lib_pagination_clickEvent_29_listener($event) { i0.ɵɵrestoreView(_r330); const ctx_r331 = i0.ɵɵnextContext(4); return ctx_r331.clickEvents($event); })("currentPage", function CmxConnectorComponent_div_0_div_1_div_29_div_13_Template_lib_pagination_currentPage_29_listener($event) { i0.ɵɵrestoreView(_r330); const ctx_r332 = i0.ɵɵnextContext(4); return ctx_r332.getCurrentControllerItems($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r287 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 16, "dashboard-lib.cmx-connector.table-header.name"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 18, "dashboard-lib.cmx-connector.table-header.ip-address"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 20, "dashboard-lib.cmx-connector.table-header.no-of-aps"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 22, "dashboard-lib.cmx-connector.table-header.last-modified"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 24, "dashboard-lib.cmx-connector.table-header.last-heard"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(22, 26, "dashboard-lib.cmx-connector.table-header.status"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(25, 28, "dashboard-lib.cmx-connector.table-header.actions"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r287.currentControllerItems);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", ctx_r287.controllerList)("shouldUseGlobalSearch", true)("searchSkeleton", ctx_r287.searchSkeleton);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pagesToShow", 3)("perPage", ctx_r287.limit)("page", ctx_r287.page)("loading", false)("items", ctx_r287.controllerList_searched);
} }
function CmxConnectorComponent_div_0_div_1_div_29_Template(rf, ctx) { if (rf & 1) {
    const _r334 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 214);
    i0.ɵɵelementStart(1, "div", 215);
    i0.ɵɵelementStart(2, "span", 93);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 180);
    i0.ɵɵelementStart(6, "div", 181);
    i0.ɵɵelement(7, "span", 182);
    i0.ɵɵelementStart(8, "input", 183);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_1_div_29_Template_input_ngModelChange_8_listener($event) { i0.ɵɵrestoreView(_r334); const ctx_r333 = i0.ɵɵnextContext(3); return ctx_r333.searchInController = $event; })("keyup", function CmxConnectorComponent_div_0_div_1_div_29_Template_input_keyup_8_listener() { i0.ɵɵrestoreView(_r334); const ctx_r335 = i0.ɵɵnextContext(3); return ctx_r335.onControllerSearchKeyUp(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "lib-search-basic", 184);
    i0.ɵɵlistener("filtered", function CmxConnectorComponent_div_0_div_1_div_29_Template_lib_search_basic_filtered_9_listener($event) { i0.ɵɵrestoreView(_r334); const ctx_r336 = i0.ɵɵnextContext(3); return ctx_r336.onControllerSearchV3Filter($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_1_div_29_div_10_Template, 5, 3, "div", 185);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 216);
    i0.ɵɵtemplate(12, CmxConnectorComponent_div_0_div_1_div_29_div_12_Template, 2, 1, "div", 86);
    i0.ɵɵtemplate(13, CmxConnectorComponent_div_0_div_1_div_29_div_13_Template, 30, 30, "div", 217);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 9, "dashboard-lib.cmx-connector.controllers.title"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r40.searchInController);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", ctx_r40.controllerList)("customSearchText", ctx_r40.searchText)("shouldUseGlobalSearch", false)("searchSkeleton", ctx_r40.controllerSearchSkeleton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r40.controllerList.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.controllerList && ctx_r40.controllerList.length > 0);
} }
function CmxConnectorComponent_div_0_div_1_div_30_Template(rf, ctx) { if (rf & 1) {
    const _r338 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 226);
    i0.ɵɵelementStart(1, "lib-cmx-connector-switches", 205);
    i0.ɵɵlistener("closeModal", function CmxConnectorComponent_div_0_div_1_div_30_Template_lib_cmx_connector_switches_closeModal_1_listener() { i0.ɵɵrestoreView(_r338); const ctx_r337 = i0.ɵɵnextContext(3); return ctx_r337.closeModal(); })("showConnectorListPage", function CmxConnectorComponent_div_0_div_1_div_30_Template_lib_cmx_connector_switches_showConnectorListPage_1_listener() { i0.ɵɵrestoreView(_r338); const ctx_r339 = i0.ɵɵnextContext(3); return ctx_r339.showConnectorListPage(); })("showSwitchCount", function CmxConnectorComponent_div_0_div_1_div_30_Template_lib_cmx_connector_switches_showSwitchCount_1_listener($event) { i0.ɵɵrestoreView(_r338); const ctx_r340 = i0.ɵɵnextContext(3); return ctx_r340.loadSwitchCount($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pageFrom", ctx_r41.pageFrom)("switchConnector", ctx_r41.currentConnector)("modalTitle", ctx_r41.modalTitle)("type", ctx_r41.actionType);
} }
function CmxConnectorComponent_div_0_div_1_div_31_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 232);
    i0.ɵɵelementStart(1, "div", 98);
    i0.ɵɵelementStart(2, "div", 99);
    i0.ɵɵelementStart(3, "div", 100);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 100);
    i0.ɵɵelement(11, "img", 103);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 2, "dashboard-lib.cmx-connector.services.not-added"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(9, 4, "dashboard-lib.cmx-connector.services.click-here"), "");
} }
function CmxConnectorComponent_div_0_div_1_div_31_div_2_div_16_li_7_Template(rf, ctx) { if (rf & 1) {
    const _r350 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "span", 250);
    i0.ɵɵelementStart(2, "input", 251);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_31_div_2_div_16_li_7_Template_input_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r350); const instance_r347 = restoredCtx.$implicit; const i_r348 = restoredCtx.index; const ctx_r349 = i0.ɵɵnextContext(6); return ctx_r349.filterMetrics(instance_r347, i_r348); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 252);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 127);
    i0.ɵɵelementStart(5, "span", 253);
    i0.ɵɵelementStart(6, "span", 254);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_r347 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "userCheckbox-", instance_r347.name, "");
    i0.ɵɵproperty("checked", instance_r347.checked);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "userCheckbox-", instance_r347.name, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", instance_r347.name, " ");
} }
function CmxConnectorComponent_div_0_div_1_div_31_div_2_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r352 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 244);
    i0.ɵɵelementStart(1, "div", 245);
    i0.ɵɵelementStart(2, "span", 246);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_31_div_2_div_16_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r352); const ctx_r351 = i0.ɵɵnextContext(5); return ctx_r351.showInstancesPopup(); });
    i0.ɵɵtext(3, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 247);
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelementStart(6, "ul", 248);
    i0.ɵɵtemplate(7, CmxConnectorComponent_div_0_div_1_div_31_div_2_div_16_li_7_Template, 8, 4, "li", 249);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r345 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", ctx_r345.instanceList);
} }
const _c1$q = function (a0) { return { "disabledElement": a0 }; };
function CmxConnectorComponent_div_0_div_1_div_31_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r354 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 233);
    i0.ɵɵelementStart(1, "div", 234);
    i0.ɵɵelementStart(2, "label", 235);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "lib-generic-dropdown", 236);
    i0.ɵɵlistener("atDropdownSelect", function CmxConnectorComponent_div_0_div_1_div_31_div_2_Template_lib_generic_dropdown_atDropdownSelect_5_listener($event) { i0.ɵɵrestoreView(_r354); const ctx_r353 = i0.ɵɵnextContext(4); return ctx_r353.onMetricServiceSelection($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "lib-generic-dropdown", 237);
    i0.ɵɵlistener("atDropdownSelect", function CmxConnectorComponent_div_0_div_1_div_31_div_2_Template_lib_generic_dropdown_atDropdownSelect_6_listener($event) { i0.ɵɵrestoreView(_r354); const ctx_r355 = i0.ɵɵnextContext(4); return ctx_r355.onMetricIntervalSelection($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 238);
    i0.ɵɵtext(8, "Graphs of all services are in UTC timezone");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 239);
    i0.ɵɵelementStart(10, "div", 240);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_div_31_div_2_Template_div_click_10_listener() { i0.ɵɵrestoreView(_r354); const ctx_r356 = i0.ɵɵnextContext(4); return ctx_r356.showInstancesPopup(); });
    i0.ɵɵelement(11, "img", 241);
    i0.ɵɵelementStart(12, "span");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "img", 242);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, CmxConnectorComponent_div_0_div_1_div_31_div_2_div_16_Template, 8, 1, "div", 243);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r342 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 8, "dashboard-lib.cmx-connector.services.title"), ":");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("selectedItem", ctx_r342.selectedService)("listItems", ctx_r342.serviceMetricList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("selectedItem", ctx_r342.selectedInterval)("listItems", ctx_r342.intervalList);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c1$q, ctx_r342.disableInstanceFilter == true));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 10, "dashboard-lib.cmx-connector.services.show-hide"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r342.showInstancePopupBox);
} }
function CmxConnectorComponent_div_0_div_1_div_31_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 255);
    i0.ɵɵelementStart(1, "span", 104);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "img", 103);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "dashboard-lib.cmx-connector.services.no-stats"));
} }
function CmxConnectorComponent_div_0_div_1_div_31_div_4_lib_d3_multiline_chart_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-d3-multiline-chart", 262);
} if (rf & 2) {
    const stat_r357 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("data", stat_r357.chartdata)("options", stat_r357.chartOptions);
} }
function CmxConnectorComponent_div_0_div_1_div_31_div_4_div_6_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 269);
} }
function CmxConnectorComponent_div_0_div_1_div_31_div_4_div_6_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 270);
} }
function CmxConnectorComponent_div_0_div_1_div_31_div_4_div_6_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 271);
} }
function CmxConnectorComponent_div_0_div_1_div_31_div_4_div_6_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 272);
} }
function CmxConnectorComponent_div_0_div_1_div_31_div_4_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_31_div_4_div_6_div_1_span_1_Template, 1, 0, "span", 264);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_1_div_31_div_4_div_6_div_1_span_2_Template, 1, 0, "span", 265);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_1_div_31_div_4_div_6_div_1_span_3_Template, 1, 0, "span", 266);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_1_div_31_div_4_div_6_div_1_span_4_Template, 1, 0, "span", 267);
    i0.ɵɵelementStart(5, "span", 268);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r370 = i0.ɵɵnextContext();
    const i_r363 = ctx_r370.index;
    const instance_r362 = ctx_r370.$implicit;
    const stat_r357 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", stat_r357.chartdata[i_r363] && stat_r357.chartdata[i_r363].color === "#8038B2");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", stat_r357.chartdata[i_r363] && stat_r357.chartdata[i_r363].color === "#1B109B");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", stat_r357.chartdata[i_r363] && stat_r357.chartdata[i_r363].color === "#3B9EDF");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", stat_r357.chartdata[i_r363] && stat_r357.chartdata[i_r363].color === "#DF3B8F");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(instance_r362.name);
} }
function CmxConnectorComponent_div_0_div_1_div_31_div_4_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 263);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_31_div_4_div_6_div_1_Template, 7, 5, "div", 58);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const instance_r362 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", instance_r362.checked);
} }
function CmxConnectorComponent_div_0_div_1_div_31_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 256);
    i0.ɵɵelementStart(1, "div", 257);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_1_div_31_div_4_lib_d3_multiline_chart_3_Template, 1, 2, "lib-d3-multiline-chart", 258);
    i0.ɵɵelementStart(4, "div", 259);
    i0.ɵɵelementStart(5, "div", 260);
    i0.ɵɵtemplate(6, CmxConnectorComponent_div_0_div_1_div_31_div_4_div_6_Template, 2, 1, "div", 261);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const stat_r357 = ctx.$implicit;
    const ctx_r344 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(stat_r357.metricName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r344.selectedService);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r344.instanceList);
} }
function CmxConnectorComponent_div_0_div_1_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 227);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_div_31_div_1_Template, 12, 6, "div", 228);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_1_div_31_div_2_Template, 17, 14, "div", 229);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_1_div_31_div_3_Template, 5, 3, "div", 230);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_1_div_31_div_4_Template, 7, 3, "div", 231);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r42.serviceList.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r42.serviceMetricList.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r42.tempMetricsStats && ctx_r42.tempMetricsStats.length == 0 && ctx_r42.serviceList.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r42.tempMetricsStats);
} }
function CmxConnectorComponent_div_0_div_1_div_32_Template(rf, ctx) { if (rf & 1) {
    const _r372 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 273);
    i0.ɵɵelementStart(1, "lib-cmx-connector-switches", 274);
    i0.ɵɵlistener("closeModal", function CmxConnectorComponent_div_0_div_1_div_32_Template_lib_cmx_connector_switches_closeModal_1_listener() { i0.ɵɵrestoreView(_r372); const ctx_r371 = i0.ɵɵnextContext(3); return ctx_r371.closeModal(); })("showConnectorListPage", function CmxConnectorComponent_div_0_div_1_div_32_Template_lib_cmx_connector_switches_showConnectorListPage_1_listener() { i0.ɵɵrestoreView(_r372); const ctx_r373 = i0.ɵɵnextContext(3); return ctx_r373.showConnectorListPage(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pageFrom", ctx_r43.pageFrom)("switchConnector", ctx_r43.switchConnector)("modalTitle", ctx_r43.modalTitle)("type", ctx_r43.actionType);
} }
function CmxConnectorComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r375 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelementStart(2, "div", 19);
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵelementStart(4, "span", 21);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_1_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r375); const ctx_r374 = i0.ɵɵnextContext(2); return ctx_r374.goBackToSetup(); });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 22);
    i0.ɵɵtext(8, ">");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_1_span_9_Template, 3, 3, "span", 23);
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_1_span_10_Template, 3, 3, "span", 24);
    i0.ɵɵtemplate(11, CmxConnectorComponent_div_0_div_1_span_11_Template, 2, 0, "span", 25);
    i0.ɵɵtemplate(12, CmxConnectorComponent_div_0_div_1_div_12_Template, 2, 1, "div", 23);
    i0.ɵɵtemplate(13, CmxConnectorComponent_div_0_div_1_div_13_Template, 8, 11, "div", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 27);
    i0.ɵɵelement(15, "div", 28);
    i0.ɵɵtemplate(16, CmxConnectorComponent_div_0_div_1_div_16_Template, 31, 16, "div", 29);
    i0.ɵɵtemplate(17, CmxConnectorComponent_div_0_div_1_div_17_Template, 41, 25, "div", 29);
    i0.ɵɵtemplate(18, CmxConnectorComponent_div_0_div_1_div_18_Template, 25, 15, "div", 29);
    i0.ɵɵtemplate(19, CmxConnectorComponent_div_0_div_1_div_19_Template, 13, 7, "div", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(20, CmxConnectorComponent_div_0_div_1_div_20_Template, 25, 24, "div", 30);
    i0.ɵɵtemplate(21, CmxConnectorComponent_div_0_div_1_div_21_Template, 17, 11, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 31);
    i0.ɵɵtemplate(23, CmxConnectorComponent_div_0_div_1_div_23_Template, 9, 7, "div", 32);
    i0.ɵɵtemplate(24, CmxConnectorComponent_div_0_div_1_div_24_Template, 15, 12, "div", 33);
    i0.ɵɵtemplate(25, CmxConnectorComponent_div_0_div_1_div_25_Template, 2, 7, "div", 34);
    i0.ɵɵtemplate(26, CmxConnectorComponent_div_0_div_1_div_26_Template, 2, 4, "div", 35);
    i0.ɵɵtemplate(27, CmxConnectorComponent_div_0_div_1_div_27_Template, 16, 13, "div", 36);
    i0.ɵɵtemplate(28, CmxConnectorComponent_div_0_div_1_div_28_Template, 2, 2, "div", 37);
    i0.ɵɵtemplate(29, CmxConnectorComponent_div_0_div_1_div_29_Template, 14, 11, "div", 38);
    i0.ɵɵtemplate(30, CmxConnectorComponent_div_0_div_1_div_30_Template, 2, 4, "div", 39);
    i0.ɵɵtemplate(31, CmxConnectorComponent_div_0_div_1_div_31_Template, 5, 4, "div", 40);
    i0.ɵɵtemplate(32, CmxConnectorComponent_div_0_div_1_div_32_Template, 2, 4, "div", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 22, "dashboard-lib.cmx-connector.setup-label"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r1.showConnectorDetails);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.showConnectorDetails);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails && ctx_r1.currentConnector.version === "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails && ctx_r1.currentConnector.version === "V2" && !ctx_r1.fromWiredNetwork);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails && ctx_r1.currentConnector.version === "V2" && ctx_r1.fromWiredNetwork);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails && ctx_r1.currentConnector.version === "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails && ctx_r1.currentConnector.version === "V2");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.showConnectorDetails);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails && ctx_r1.currentConnector.version === "V2" && !ctx_r1.fromWiredNetwork);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails && ctx_r1.selectedTab === "instances" && ctx_r1.currentConnector.version === "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails && ctx_r1.currentConnector.version === "V2" && ctx_r1.fromWiredNetwork);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails && ctx_r1.currentConnector.version === "V3" && ctx_r1.currentConnector.upgrade_allowed == true && ctx_r1.selectedTab === "configuration");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails && ctx_r1.selectedTab === "configuration" && ctx_r1.currentConnector.version === "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails && ctx_r1.selectedTab === "configuration" && ctx_r1.currentConnector.version === "V3" && ctx_r1.showControllerSection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails && ctx_r1.selectedTab === "configuration" && ctx_r1.currentConnector.version === "V3" && ctx_r1.showSwitchSection == true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showConnectorDetails && ctx_r1.selectedTab === "metrics" && ctx_r1.currentConnector.version === "V3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showSwitchList === true);
} }
function CmxConnectorComponent_div_0_div_2_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 285);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r376 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r376.cmxConnectorError, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r383 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "input", 286);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_14_Template_input_keyup_1_listener($event) { i0.ɵɵrestoreView(_r383); const ctx_r382 = i0.ɵɵnextContext(3); return ctx_r382.onKey($event); })("input", function CmxConnectorComponent_div_0_div_2_div_14_Template_input_input_1_listener($event) { i0.ɵɵrestoreView(_r383); const ctx_r384 = i0.ɵɵnextContext(3); return ctx_r384.controllerObj.connectorName = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r377 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r377.isConnectorAvailable === true)("value", ctx_r377.controllerObj.connectorName);
} }
function CmxConnectorComponent_div_0_div_2_div_15_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r389 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 291);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_15_div_4_div_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r389); const connector_r387 = restoredCtx.$implicit; const ctx_r388 = i0.ɵɵnextContext(5); return ctx_r388.connectorSelected(connector_r387); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const connector_r387 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", connector_r387.name, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_15_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 290);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_2_div_15_div_4_div_1_Template, 3, 1, "div", 249);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r385 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r385.cmxConnectorList);
} }
const _c2$i = function (a0) { return { "menuActive": a0 }; };
function CmxConnectorComponent_div_0_div_2_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r391 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 287);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_15_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r391); const ctx_r390 = i0.ɵɵnextContext(3); return ctx_r390.toggleDropDown("connectorList"); });
    i0.ɵɵelementStart(2, "div", 288);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_2_div_15_div_4_Template, 2, 1, "div", 289);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r378 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c2$i, ctx_r378.showConnnectorList == true));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r378.controllerObj.connectorName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r378.showConnnectorList === true);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_small_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 310);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r394 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r394.regex.controllerIp.error, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_small_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 310);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r395 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r395.regex.name.error, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_22_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r402 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 291);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_22_div_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r402); const controllerType_r400 = restoredCtx.$implicit; const ctx_r401 = i0.ɵɵnextContext(6); return ctx_r401.controllerTypeSelected(controllerType_r400); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controllerType_r400 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", controllerType_r400 === "ewlc" ? "Catalyst 9800 Wireless Controller" : controllerType_r400 === "WLC" ? "AireOS Controller" : controllerType_r400, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 311);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_22_div_1_Template, 3, 1, "div", 249);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r396 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r396.controllerTypeList);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_small_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 310);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r403 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r403.regex.username.error, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_small_50_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 310);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r408 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r408.regex.netconfUsername.error, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_64_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 342);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r420 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(message_r420);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_64_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 335);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.add-edit-popup.cli-commands"), " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_64_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 343);
    i0.ɵɵelementStart(1, "div", 344);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const command_r422 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", command_r422, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_64_Template(rf, ctx) { if (rf & 1) {
    const _r425 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 334);
    i0.ɵɵelementStart(1, "div", 335);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_64_div_4_Template, 3, 1, "div", 336);
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_64_div_5_Template, 3, 3, "div", 337);
    i0.ɵɵelementStart(6, "div", 338);
    i0.ɵɵelementStart(7, "div", 339);
    i0.ɵɵelementStart(8, "i", 340);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_64_Template_i_click_8_listener() { i0.ɵɵrestoreView(_r425); const ctx_r424 = i0.ɵɵnextContext(6); return ctx_r424.copyCLIcommands(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_64_div_9_Template, 3, 1, "div", 341);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r411 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "dashboard-lib.cmx-connector.add-edit-popup.wlc-cli-commands"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r411.ewlcMessages);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r411.ewlcMessages.length > 0);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r411.ewlcCommandsList);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_65_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 348);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_65_Template(rf, ctx) { if (rf & 1) {
    const _r428 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 305);
    i0.ɵɵelementStart(1, "button", 345);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_65_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r428); const ctx_r427 = i0.ɵɵnextContext(6); return ctx_r427.testCredentials(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_65_span_4_Template, 1, 0, "span", 346);
    i0.ɵɵelementStart(5, "span", 347);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r412 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", !ctx_r412.toggleSaveButton() ? "disabled" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "dashboard-lib.cmx-connector.add-edit-popup.test-connectivity"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r412.showSpinner);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r412.status[ctx_r412.displayTaskStatus]);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r412.taskStatus[ctx_r412.displayTaskStatus] || "");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_66_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 351);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r430 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(message_r430);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_66_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 305);
    i0.ɵɵelementStart(1, "div", 349);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_66_div_2_Template, 3, 1, "div", 350);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r413 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r413.connectivityMessages);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_67_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 349);
    i0.ɵɵelementStart(2, "div", 351);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r414 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r414.snmpReadOnlyMsg, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_68_th_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 354);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const result_r433 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", result_r433, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_68_tr_8_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 359);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachInstanceResult_r438 = ctx.$implicit;
    const j_r439 = ctx.index;
    i0.ɵɵproperty("ngClass", j_r439 != 0 ? "testresultStyle" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", eachInstanceResult_r438, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_68_tr_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 357);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_68_tr_8_td_1_Template, 2, 2, "td", 358);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const result_r435 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", result_r435);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_68_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 305);
    i0.ɵɵelementStart(1, "table", 352);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr", 353);
    i0.ɵɵelementStart(4, "th", 354);
    i0.ɵɵtext(5, " Instance ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_68_th_6_Template, 2, 1, "th", 355);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "tbody");
    i0.ɵɵtemplate(8, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_68_tr_8_Template, 2, 1, "tr", 356);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r415 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r415.connectivityTestResult.services);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r415.connectivityTestResult.result);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_69_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 360);
    i0.ɵɵtext(1, " Success ");
    i0.ɵɵelementEnd();
} }
const _c3$c = function (a0) { return { "disabled": a0 }; };
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r441 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 305);
    i0.ɵɵelementStart(2, "div", 281);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 312);
    i0.ɵɵelementStart(6, "input", 313);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_input_keyup_6_listener($event) { i0.ɵɵrestoreView(_r441); const ctx_r440 = i0.ɵɵnextContext(5); return ctx_r440.onKeysshUser($event); })("input", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_input_input_6_listener($event) { i0.ɵɵrestoreView(_r441); const ctx_r442 = i0.ɵɵnextContext(5); return ctx_r442.setFieldData($event, "username"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_small_7_Template, 2, 1, "small", 303);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 305);
    i0.ɵɵelementStart(9, "div", 281);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 312);
    i0.ɵɵelementStart(13, "input", 314, 315);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_input_keyup_13_listener($event) { i0.ɵɵrestoreView(_r441); const ctx_r443 = i0.ɵɵnextContext(5); return ctx_r443.onKeysshPassword($event); })("input", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_input_input_13_listener($event) { i0.ɵɵrestoreView(_r441); const ctx_r444 = i0.ɵɵnextContext(5); return ctx_r444.controllerObj.login.password = $event.target.value; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "span");
    i0.ɵɵelement(16, "img", 316);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "span", 317, 318);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_span_click_17_listener() { i0.ɵɵrestoreView(_r441); const _r404 = i0.ɵɵreference(14); const _r405 = i0.ɵɵreference(18); const ctx_r445 = i0.ɵɵnextContext(5); return ctx_r445.showPassword(_r404, _r405); });
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 305);
    i0.ɵɵelementStart(22, "div", 281);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 312);
    i0.ɵɵelementStart(26, "input", 314, 319);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_input_keyup_26_listener($event) { i0.ɵɵrestoreView(_r441); const ctx_r446 = i0.ɵɵnextContext(5); return ctx_r446.onKey($event); })("input", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_input_input_26_listener($event) { i0.ɵɵrestoreView(_r441); const ctx_r447 = i0.ɵɵnextContext(5); return ctx_r447.controllerObj.login.enablePassword = $event.target.value; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "span");
    i0.ɵɵelement(29, "img", 316);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "span", 317, 320);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_span_click_30_listener() { i0.ɵɵrestoreView(_r441); const _r406 = i0.ɵɵreference(27); const _r407 = i0.ɵɵreference(31); const ctx_r448 = i0.ɵɵnextContext(5); return ctx_r448.showPassword(_r406, _r407); });
    i0.ɵɵtext(32);
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 321);
    i0.ɵɵelementStart(35, "div", 322);
    i0.ɵɵelementStart(36, "span", 323);
    i0.ɵɵelementStart(37, "input", 324);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_input_click_37_listener($event) { i0.ɵɵrestoreView(_r441); const ctx_r449 = i0.ɵɵnextContext(5); return ctx_r449.toggleNetconf($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(38, "label", 325);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 100);
    i0.ɵɵelementStart(40, "span", 281);
    i0.ɵɵtext(41);
    i0.ɵɵpipe(42, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "div", 305);
    i0.ɵɵelementStart(44, "div", 305);
    i0.ɵɵelementStart(45, "div", 281);
    i0.ɵɵtext(46);
    i0.ɵɵpipe(47, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "div", 312);
    i0.ɵɵelementStart(49, "input", 326);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_input_keyup_49_listener($event) { i0.ɵɵrestoreView(_r441); const ctx_r450 = i0.ɵɵnextContext(5); return ctx_r450.onKey($event); })("input", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_input_input_49_listener($event) { i0.ɵɵrestoreView(_r441); const ctx_r451 = i0.ɵɵnextContext(5); return ctx_r451.setFieldData($event, "netconfUsername"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(50, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_small_50_Template, 2, 1, "small", 303);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(51, "div", 305);
    i0.ɵɵelementStart(52, "div", 281);
    i0.ɵɵtext(53);
    i0.ɵɵpipe(54, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(55, "div", 312);
    i0.ɵɵelementStart(56, "input", 327, 328);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_input_keyup_56_listener($event) { i0.ɵɵrestoreView(_r441); const ctx_r452 = i0.ɵɵnextContext(5); return ctx_r452.onKey($event); })("input", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_input_input_56_listener($event) { i0.ɵɵrestoreView(_r441); const ctx_r453 = i0.ɵɵnextContext(5); return ctx_r453.controllerObj.login.netconfPassword = $event.target.value; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(58, "span");
    i0.ɵɵelement(59, "img", 329);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(60, "span", 317, 330);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template_span_click_60_listener() { i0.ɵɵrestoreView(_r441); const _r409 = i0.ɵɵreference(57); const _r410 = i0.ɵɵreference(61); const ctx_r454 = i0.ɵɵnextContext(5); return ctx_r454.showPassword(_r409, _r410); });
    i0.ɵɵtext(62);
    i0.ɵɵpipe(63, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(64, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_64_Template, 10, 6, "div", 331);
    i0.ɵɵtemplate(65, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_65_Template, 7, 7, "div", 332);
    i0.ɵɵtemplate(66, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_66_Template, 3, 1, "div", 332);
    i0.ɵɵtemplate(67, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_67_Template, 4, 1, "div", 58);
    i0.ɵɵtemplate(68, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_68_Template, 9, 2, "div", 332);
    i0.ɵɵtemplate(69, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_div_69_Template, 2, 0, "div", 333);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r397 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 26, "dashboard-lib.cmx-connector.add-edit-popup.ssh-username"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r397.controllerObj.login.username);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r397.netconfUsername_error.length > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 28, "dashboard-lib.cmx-connector.add-edit-popup.ssh-password"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r397.controllerObj.login.password);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 30, "dashboard-lib.cmx-connector.add-edit-popup.show-label"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 32, "dashboard-lib.cmx-connector.add-edit-popup.enable-password"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r397.controllerObj.login.enablePassword);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(33, 34, "dashboard-lib.cmx-connector.add-edit-popup.show-label"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("checked", ctx_r397.controllerObj.login.provideNetconf);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(42, 36, "dashboard-lib.cmx-connector.add-edit-popup.provideNetconf"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(47, 38, "dashboard-lib.cmx-connector.add-edit-popup.netconf-username"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r397.controllerObj.login.netconfUsername)("ngClass", i0.ɵɵpureFunction1(44, _c3$c, !ctx_r397.controllerObj.login.provideNetconf));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r397.netconfUsername_error.length > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(54, 40, "dashboard-lib.cmx-connector.add-edit-popup.netconf-password"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r397.controllerObj.login.netconfPassword)("ngClass", i0.ɵɵpureFunction1(46, _c3$c, !ctx_r397.controllerObj.login.provideNetconf));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(48, _c3$c, !ctx_r397.controllerObj.login.provideNetconf));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(63, 42, "dashboard-lib.cmx-connector.add-edit-popup.show-label"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r397.configPage === "controller");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r397.configPage !== "connector" && ctx_r397.displayTestConnectivity);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r397.connectivityMessages.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r397.snmpReadOnlyMsg.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r397.connectivityTestResult.instances !== undefined && ctx_r397.connectivityTestResult.services !== undefined && ctx_r397.showV3TestConnectivityStatus === false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r397.showV3TestConnectivityStatus);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_8_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r469 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 291);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_8_div_7_div_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r469); const snmpVersion_r467 = restoredCtx.$implicit; const ctx_r468 = i0.ɵɵnextContext(8); return ctx_r468.snmpVersionSelected(snmpVersion_r467); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const snmpVersion_r467 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", snmpVersion_r467, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_8_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 290);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_8_div_7_div_1_Template, 3, 1, "div", 249);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r465 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r465.snmpVersionList);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r471 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 305);
    i0.ɵɵelementStart(1, "div", 306);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 287);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_8_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r471); const ctx_r470 = i0.ɵɵnextContext(6); return ctx_r470.toggleDropDown("snmpVersion"); });
    i0.ɵɵelementStart(5, "div", 308);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_8_div_7_Template, 2, 1, "div", 366);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r455 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "dashboard-lib.cmx-connector.add-edit-popup.controller-snmp-version"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c2$i, ctx_r455.showSNMPVersionList === true));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r455.controllerObj.snmp.version, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r455.showSNMPVersionList === true);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r475 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 305);
    i0.ɵɵelementStart(2, "div", 281);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 312);
    i0.ɵɵelementStart(6, "input", 367, 368);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_9_Template_input_keyup_6_listener($event) { i0.ɵɵrestoreView(_r475); const ctx_r474 = i0.ɵɵnextContext(6); return ctx_r474.onKey($event); })("input", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_9_Template_input_input_6_listener($event) { i0.ɵɵrestoreView(_r475); const ctx_r476 = i0.ɵɵnextContext(6); return ctx_r476.controllerObj.snmp.community = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵelement(9, "img", 316);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 317, 369);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_9_Template_span_click_10_listener() { i0.ɵɵrestoreView(_r475); const _r472 = i0.ɵɵreference(7); const _r473 = i0.ɵɵreference(11); const ctx_r477 = i0.ɵɵnextContext(6); return ctx_r477.showPassword(_r472, _r473); });
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r456 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, "dashboard-lib.cmx-connector.add-edit-popup.snmp-rw-community"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r456.controllerObj.snmp.community);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 5, "dashboard-lib.cmx-connector.add-edit-popup.show-label"));
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_14_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r485 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 291);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_14_div_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r485); const authProtocol_r483 = restoredCtx.$implicit; const ctx_r484 = i0.ɵɵnextContext(8); return ctx_r484.authProtocolSelected(authProtocol_r483); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const authProtocol_r483 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", authProtocol_r483, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 290);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_14_div_1_Template, 3, 1, "div", 249);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r478 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r478.authProtocolList);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r489 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 305);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 312);
    i0.ɵɵelementStart(5, "input", 314, 371);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_15_Template_input_keyup_5_listener($event) { i0.ɵɵrestoreView(_r489); const ctx_r488 = i0.ɵɵnextContext(7); return ctx_r488.onKey($event); })("input", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_15_Template_input_input_5_listener($event) { i0.ɵɵrestoreView(_r489); const ctx_r490 = i0.ɵɵnextContext(7); return ctx_r490.controllerObj.snmp.password = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵelement(8, "img", 316);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 317, 372);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_15_Template_span_click_9_listener() { i0.ɵɵrestoreView(_r489); const _r486 = i0.ɵɵreference(6); const _r487 = i0.ɵɵreference(10); const ctx_r491 = i0.ɵɵnextContext(7); return ctx_r491.showPassword(_r486, _r487); });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r479 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "dashboard-lib.cmx-connector.add-edit-popup.password"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r479.controllerObj.snmp.password);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 5, "dashboard-lib.cmx-connector.add-edit-popup.show-label"));
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_23_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r495 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 291);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_23_div_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r495); const privacyProtocol_r493 = restoredCtx.$implicit; const ctx_r494 = i0.ɵɵnextContext(8); return ctx_r494.privacyProtocolSelected(privacyProtocol_r493); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const privacyProtocol_r493 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", privacyProtocol_r493, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 290);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_23_div_1_Template, 3, 1, "div", 249);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r480 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r480.privacyProtocolList);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r499 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 305);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 312);
    i0.ɵɵelementStart(5, "input", 373, 374);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_24_Template_input_keyup_5_listener($event) { i0.ɵɵrestoreView(_r499); const ctx_r498 = i0.ɵɵnextContext(7); return ctx_r498.onKey($event); })("input", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_24_Template_input_input_5_listener($event) { i0.ɵɵrestoreView(_r499); const ctx_r500 = i0.ɵɵnextContext(7); return (ctx_r500.controllerObj.snmp["privacy-password"] = $event.target ? $event.target["value"] : ""); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵelement(8, "img", 316);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 317, 375);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_24_Template_span_click_9_listener() { i0.ɵɵrestoreView(_r499); const _r496 = i0.ɵɵreference(6); const _r497 = i0.ɵɵreference(10); const ctx_r501 = i0.ɵɵnextContext(7); return ctx_r501.showPassword(_r496, _r497); });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r481 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "dashboard-lib.cmx-connector.add-edit-popup.privacy-password"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r481.controllerObj.snmp["privacy-password"]);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 5, "dashboard-lib.cmx-connector.add-edit-popup.show-label"));
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r503 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 305);
    i0.ɵɵelementStart(2, "div", 281);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 312);
    i0.ɵɵelementStart(6, "input", 313);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_Template_input_keyup_6_listener($event) { i0.ɵɵrestoreView(_r503); const ctx_r502 = i0.ɵɵnextContext(6); return ctx_r502.onKey($event); })("input", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_Template_input_input_6_listener($event) { i0.ɵɵrestoreView(_r503); const ctx_r504 = i0.ɵɵnextContext(6); return ctx_r504.controllerObj.snmp.userName = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 305);
    i0.ɵɵelementStart(8, "div", 281);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 287);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_Template_div_click_11_listener() { i0.ɵɵrestoreView(_r503); const ctx_r505 = i0.ɵɵnextContext(6); return ctx_r505.toggleDropDown("authProtocol"); });
    i0.ɵɵelementStart(12, "div", 308);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_14_Template, 2, 1, "div", 370);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_15_Template, 13, 7, "div", 332);
    i0.ɵɵelementStart(16, "div", 305);
    i0.ɵɵelementStart(17, "div", 281);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 287);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_Template_div_click_20_listener() { i0.ɵɵrestoreView(_r503); const ctx_r506 = i0.ɵɵnextContext(6); return ctx_r506.toggleDropDown("privacyProtocol"); });
    i0.ɵɵelementStart(21, "div", 308);
    i0.ɵɵtext(22);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(23, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_23_Template, 2, 1, "div", 370);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(24, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_div_24_Template, 13, 7, "div", 332);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r457 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 12, "dashboard-lib.cmx-connector.add-edit-popup.username"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r457.controllerObj.snmp.userName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 14, "dashboard-lib.cmx-connector.add-edit-popup.authentication-protocol"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c2$i, ctx_r457.showAuthProtocolList === true));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r457.controllerObj.snmp["auth-protocol"], " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r457.showAuthProtocolList === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r457.controllerObj.snmp["auth-protocol"] !== "-- Select --" && ctx_r457.controllerObj.snmp["auth-protocol"] !== "None");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 16, "dashboard-lib.cmx-connector.add-edit-popup.privacy-protocol"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c2$i, ctx_r457.showPrivacyProtocolList === true));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r457.controllerObj.snmp["privacy-protocol"], " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r457.showPrivacyProtocolList === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r457.controllerObj.snmp["privacy-protocol"] !== "-- Select --" && ctx_r457.controllerObj.snmp["privacy-protocol"] !== "None");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_11_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r510 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 305);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 312);
    i0.ɵɵelementStart(5, "input", 379);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_11_div_10_Template_input_keyup_5_listener($event) { i0.ɵɵrestoreView(_r510); const ctx_r509 = i0.ɵɵnextContext(7); return ctx_r509.onKey($event); })("input", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_11_div_10_Template_input_input_5_listener($event) { i0.ɵɵrestoreView(_r510); const ctx_r511 = i0.ɵɵnextContext(7); return ctx_r511.controllerObj.aireOSLogin.username = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r507 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.cli-username"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r507.controllerObj.aireOSLogin.username);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_11_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r515 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 305);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 312);
    i0.ɵɵelementStart(5, "input", 380, 368);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_11_div_11_Template_input_keyup_5_listener($event) { i0.ɵɵrestoreView(_r515); const ctx_r514 = i0.ɵɵnextContext(7); return ctx_r514.onKey($event); })("input", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_11_div_11_Template_input_input_5_listener($event) { i0.ɵɵrestoreView(_r515); const ctx_r516 = i0.ɵɵnextContext(7); return ctx_r516.controllerObj.aireOSLogin.password = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵelement(8, "img", 316);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 317, 369);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_11_div_11_Template_span_click_9_listener() { i0.ɵɵrestoreView(_r515); const _r512 = i0.ɵɵreference(6); const _r513 = i0.ɵɵreference(10); const ctx_r517 = i0.ɵɵnextContext(7); return ctx_r517.showPassword(_r512, _r513); });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r508 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "dashboard-lib.cmx-connector.add-edit-popup.cli-password"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r508.controllerObj.aireOSLogin.password);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 5, "dashboard-lib.cmx-connector.add-edit-popup.show-label"));
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r519 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 376);
    i0.ɵɵelementStart(2, "div", 322);
    i0.ɵɵelementStart(3, "span", 323);
    i0.ɵɵelementStart(4, "input", 377);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_11_Template_input_click_4_listener($event) { i0.ɵɵrestoreView(_r519); const ctx_r518 = i0.ɵɵnextContext(6); return ctx_r518.toggleWSA($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "label", 378);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 100);
    i0.ɵɵelementStart(7, "span", 281);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_11_div_10_Template, 6, 4, "div", 332);
    i0.ɵɵtemplate(11, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_11_div_11_Template, 13, 7, "div", 332);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r458 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", ctx_r458.controllerObj.aireOSLogin.cliCredentialsAvailable);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 4, "dashboard-lib.cmx-connector.add-edit-popup.enable-wsa-controller"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r458.controllerObj.aireOSLogin && ctx_r458.controllerObj.aireOSLogin.cliCredentialsAvailable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r458.controllerObj.aireOSLogin && ctx_r458.controllerObj.aireOSLogin.cliCredentialsAvailable);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_12_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 348);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r522 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 305);
    i0.ɵɵelementStart(1, "button", 345);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_12_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r522); const ctx_r521 = i0.ɵɵnextContext(6); return ctx_r521.testCredentials(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_12_span_4_Template, 1, 0, "span", 346);
    i0.ɵɵelementStart(5, "span", 347);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r459 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", !ctx_r459.toggleSaveButton() ? "disabled" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "dashboard-lib.cmx-connector.add-edit-popup.test-connectivity"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r459.showSpinner);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r459.status[ctx_r459.displayTaskStatus]);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r459.taskStatus[ctx_r459.displayTaskStatus] || "");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_13_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 351);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r524 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(message_r524);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 305);
    i0.ɵɵelementStart(1, "div", 349);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_13_div_2_Template, 3, 1, "div", 350);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r460 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r460.connectivityMessages);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 349);
    i0.ɵɵelementStart(2, "div", 351);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r461 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r461.snmpReadOnlyMsg, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_15_th_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 354);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const result_r527 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", result_r527, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_15_tr_8_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 359);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const eachInstanceResult_r532 = ctx.$implicit;
    const j_r533 = ctx.index;
    i0.ɵɵproperty("ngClass", j_r533 != 0 ? "testresultStyle" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", eachInstanceResult_r532, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_15_tr_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 357);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_15_tr_8_td_1_Template, 2, 2, "td", 358);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const result_r529 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", result_r529);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 305);
    i0.ɵɵelementStart(1, "table", 352);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr", 353);
    i0.ɵɵelementStart(4, "th", 354);
    i0.ɵɵtext(5, " Instance ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_15_th_6_Template, 2, 1, "th", 355);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "tbody");
    i0.ɵɵtemplate(8, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_15_tr_8_Template, 2, 1, "tr", 356);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r462 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r462.connectivityTestResult.services);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r462.connectivityTestResult.result);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 360);
    i0.ɵɵtext(1, " Success ");
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_23_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 342);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r538 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(message_r538);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_23_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 335);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.add-edit-popup.cli-commands"), " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_23_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 343);
    i0.ɵɵelementStart(1, "div", 344);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const command_r540 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", command_r540, " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_23_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r543 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 334);
    i0.ɵɵelementStart(1, "div", 335);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_23_div_1_div_4_Template, 3, 1, "div", 336);
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_23_div_1_div_5_Template, 3, 3, "div", 337);
    i0.ɵɵelementStart(6, "div", 338);
    i0.ɵɵelementStart(7, "div", 339);
    i0.ɵɵelementStart(8, "i", 340);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_23_div_1_Template_i_click_8_listener() { i0.ɵɵrestoreView(_r543); const ctx_r542 = i0.ɵɵnextContext(7); return ctx_r542.copyCLIcommands(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_23_div_1_div_9_Template, 3, 1, "div", 341);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r534 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "dashboard-lib.cmx-connector.add-edit-popup.wlc-aireos-cli-commands"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r534.ewlcMessages);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r534.ewlcMessages.length > 0);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r534.ewlcCommandsList);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 381);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_23_div_1_Template, 10, 6, "div", 331);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r464 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r464.configPage === "controller");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r545 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 361);
    i0.ɵɵelementStart(2, "input", 362);
    i0.ɵɵlistener("change", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_Template_input_change_2_listener() { i0.ɵɵrestoreView(_r545); const ctx_r544 = i0.ɵɵnextContext(5); return ctx_r544.onChangeWLCConfig("auto"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 363);
    i0.ɵɵelementStart(4, "span", 364);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtemplate(8, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_8_Template, 8, 8, "div", 332);
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_9_Template, 14, 7, "div", 58);
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_10_Template, 25, 22, "div", 58);
    i0.ɵɵtemplate(11, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_11_Template, 12, 6, "div", 58);
    i0.ɵɵtemplate(12, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_12_Template, 7, 7, "div", 332);
    i0.ɵɵtemplate(13, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_13_Template, 3, 1, "div", 332);
    i0.ɵɵtemplate(14, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_14_Template, 4, 1, "div", 58);
    i0.ɵɵtemplate(15, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_15_Template, 9, 2, "div", 332);
    i0.ɵɵtemplate(16, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_16_Template, 2, 0, "div", 333);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 361);
    i0.ɵɵelementStart(18, "input", 362);
    i0.ɵɵlistener("change", function CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_Template_input_change_18_listener() { i0.ɵɵrestoreView(_r545); const ctx_r546 = i0.ɵɵnextContext(5); return ctx_r546.onChangeWLCConfig("manual"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "label", 363);
    i0.ɵɵelementStart(20, "span", 364);
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(23, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_div_23_Template, 2, 1, "div", 365);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r398 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r398.wlcConfigType);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 14, "dashboard-lib.cmx-connector.add-edit-popup.auto-configuration"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r398.controllerObj.snmp && ctx_r398.controllerObj.snmp.controllerType === "WLC");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r398.controllerObj.snmp && ctx_r398.controllerObj.snmp.version === "v2c");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r398.controllerObj.snmp && ctx_r398.controllerObj.snmp.version === "v3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r398.controllerObj.aireOSLogin);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r398.configPage !== "connector" && ctx_r398.displayTestConnectivity);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r398.connectivityMessages.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r398.snmpReadOnlyMsg.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r398.connectivityTestResult.instances !== undefined && ctx_r398.connectivityTestResult.services !== undefined && ctx_r398.showV3TestConnectivityStatus === false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r398.showV3TestConnectivityStatus);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r398.wlcConfigType);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(22, 16, "dashboard-lib.cmx-connector.add-edit-popup.manual-configuration"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r398.wlcConfigType === "manual");
} }
const _c4$7 = function (a0, a1) { return { "menuActive": a0, "disabled": a1 }; };
function CmxConnectorComponent_div_0_div_2_div_17_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r548 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 292);
    i0.ɵɵelementStart(1, "div", 301);
    i0.ɵɵelementStart(2, "div", 281);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelementStart(6, "input", 302);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_17_div_23_Template_input_keyup_6_listener($event) { i0.ɵɵrestoreView(_r548); const ctx_r547 = i0.ɵɵnextContext(4); return ctx_r547.onKey($event); })("input", function CmxConnectorComponent_div_0_div_2_div_17_div_23_Template_input_input_6_listener($event) { i0.ɵɵrestoreView(_r548); const ctx_r549 = i0.ɵɵnextContext(4); return ctx_r549.setFieldData($event, "controllerIp"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CmxConnectorComponent_div_0_div_2_div_17_div_23_small_7_Template, 2, 1, "small", 303);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 280);
    i0.ɵɵelementStart(9, "div", 281);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵelementStart(13, "input", 304);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_2_div_17_div_23_Template_input_keyup_13_listener($event) { i0.ɵɵrestoreView(_r548); const ctx_r550 = i0.ɵɵnextContext(4); return ctx_r550.onKey($event); })("input", function CmxConnectorComponent_div_0_div_2_div_17_div_23_Template_input_input_13_listener($event) { i0.ɵɵrestoreView(_r548); const ctx_r551 = i0.ɵɵnextContext(4); return ctx_r551.setFieldData($event, "name"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, CmxConnectorComponent_div_0_div_2_div_17_div_23_small_14_Template, 2, 1, "small", 303);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 305);
    i0.ɵɵelementStart(16, "div", 306);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 307);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_23_Template_div_click_19_listener() { i0.ɵɵrestoreView(_r548); const ctx_r552 = i0.ɵɵnextContext(4); return ctx_r552.toggleDropDown("controllerType"); });
    i0.ɵɵelementStart(20, "div", 308);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_22_Template, 2, 1, "div", 309);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(23, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_23_Template, 70, 50, "div", 58);
    i0.ɵɵtemplate(24, CmxConnectorComponent_div_0_div_2_div_17_div_23_div_24_Template, 24, 18, "div", 58);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r392 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 13, "dashboard-lib.cmx-connector.add-edit-popup.controller-ip"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r392.editControllerPopup === true)("value", ctx_r392.controllerObj.controllerIp);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r392.controllerIp_error.length > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 15, "dashboard-lib.cmx-connector.add-edit-popup.controller-name"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r392.controllerObj.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r392.name_error.length > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 17, "dashboard-lib.cmx-connector.add-edit-popup.controller-type"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(19, _c4$7, ctx_r392.showControllerTypeList === true, ctx_r392.editControllerPopup === true));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r392.controllerObj.type === "ewlc" ? "Catalyst 9800 Wireless Controller" : ctx_r392.controllerObj.type === "WLC" ? "AireOS Controller" : ctx_r392.controllerObj.snmp.controllerType, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r392.showControllerTypeList === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r392.controllerObj.type === "ewlc");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r392.controllerObj.type === "WLC");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_1_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r563 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 389);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_1_div_10_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r563); const item_r561 = restoredCtx.$implicit; const ctx_r562 = i0.ɵɵnextContext(6); return ctx_r562.selectCustomerItem(item_r561); });
    i0.ɵɵelement(1, "div", 390);
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelement(3, "div", 391);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r561 = ctx.$implicit;
    i0.ɵɵclassMapInterpolate1("each-option ", item_r561.css, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 5, item_r561.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 7, item_r561.message), i0.ɵɵsanitizeHtml);
} }
const _c5$2 = function (a1) { return { "options": true, "display-none": a1 }; };
function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r565 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 305);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "div", 385);
    i0.ɵɵelementStart(6, "span", 386);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_1_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r565); const ctx_r564 = i0.ɵɵnextContext(5); return ctx_r564.showCustomerOptions(); });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "input", 387);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_1_Template_input_ngModelChange_8_listener($event) { i0.ɵɵrestoreView(_r565); const ctx_r566 = i0.ɵɵnextContext(5); return ctx_r566.filterString = $event; })("click", function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_1_Template_input_click_8_listener() { i0.ɵɵrestoreView(_r565); const ctx_r567 = i0.ɵɵnextContext(5); return ctx_r567.showCustomerOptions(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 211);
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_2_div_17_div_24_div_1_div_10_Template, 5, 9, "div", 388);
    i0.ɵɵpipe(11, "genericDropdownFilter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r553 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, "dashboard-lib.spaces-connector.create-connector.choose_connector"), "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r553.displayOptions ? "\uE908" : "\uE905");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r553.placeholder);
    i0.ɵɵproperty("ngModel", ctx_r553.filterString);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c5$2, !ctx_r553.displayOptions));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(11, 8, ctx_r553.spacesConnectorImportAllowed, ctx_r553.filterString));
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r569 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 392);
    i0.ɵɵelementStart(2, "input", 393);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_2_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r569); const ctx_r568 = i0.ɵɵnextContext(5); return ctx_r568.doCopyHotspotConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 394);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r554 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r554.copyHotspotConfig);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 2, "dashboard-lib.spaces-connector.create-connector.connector-version.copy_hotsot_label"));
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 395);
    i0.ɵɵelementStart(1, "div", 89);
    i0.ɵɵelement(2, "img", 396);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 397);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "br");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 2, "dashboard-lib.spaces-connector.create-connector.connector-version.hotspotConfig_warning"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 4, "dashboard-lib.spaces-connector.create-connector.connector-version.hotspotConfig_notice"), " ");
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 398);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2, "No connector available to import controllers");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 398);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2, "No connector available to import controllers");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r574 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 323);
    i0.ɵɵelementStart(1, "input", 404);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_ng_template_9_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r574); const ctx_r573 = i0.ɵɵnextContext(6); return ctx_r573.selectAll = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 405);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r571 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r571.selectAll);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_tr_21_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r581 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 323);
    i0.ɵɵelementStart(1, "input", 411);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_tr_21_ng_template_5_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r581); const controller_r575 = i0.ɵɵnextContext().$implicit; return controller_r575.selected = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 405);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r575 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", controller_r575.selected);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_tr_21_Template(rf, ctx) { if (rf & 1) {
    const _r584 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 357);
    i0.ɵɵelementStart(1, "td", 406);
    i0.ɵɵelementStart(2, "span", 323);
    i0.ɵɵelementStart(3, "input", 407);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_tr_21_Template_input_ngModelChange_3_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r584); const controller_r575 = restoredCtx.$implicit; return controller_r575.selected = $event; })("change", function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_tr_21_Template_input_change_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r584); const controller_r575 = restoredCtx.$implicit; const ctx_r585 = i0.ɵɵnextContext(6); return ctx_r585.selectThisController(controller_r575); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "label", 252);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_tr_21_ng_template_5_Template, 3, 1, "ng-template", null, 408, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 409);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 410);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td", 410);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r575 = ctx.$implicit;
    const i_r576 = ctx.index;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "selectController-", i_r576, "");
    i0.ɵɵproperty("ngModel", controller_r575.selected)("checked", controller_r575.selected);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "selectController-", i_r576, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(controller_r575.host);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(controller_r575.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(controller_r575.type);
} }
const _c6 = function (a0) { return { "partial-select": a0 }; };
function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r587 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "table", 352);
    i0.ɵɵelementStart(3, "thead");
    i0.ɵɵelementStart(4, "tr", 353);
    i0.ɵɵelementStart(5, "th", 399);
    i0.ɵɵelementStart(6, "span", 323);
    i0.ɵɵelementStart(7, "input", 400);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_Template_input_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r587); const ctx_r586 = i0.ɵɵnextContext(5); return ctx_r586.selectAll = $event; })("change", function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_Template_input_change_7_listener() { i0.ɵɵrestoreView(_r587); const ctx_r588 = i0.ɵɵnextContext(5); return ctx_r588.selectAllControllers(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "label", 401);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_ng_template_9_Template, 3, 1, "ng-template", null, 402, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th", 399);
    i0.ɵɵelementStart(12, "span", 403);
    i0.ɵɵtext(13, "IP Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "th", 399);
    i0.ɵɵelementStart(15, "span", 403);
    i0.ɵɵtext(16, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th", 399);
    i0.ɵɵelementStart(18, "span", 403);
    i0.ɵɵtext(19, "type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "tbody");
    i0.ɵɵtemplate(21, CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_tr_21_Template, 13, 7, "tr", 356);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r558 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngModel", ctx_r558.selectAll);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c6, !ctx_r558.selectAll && ctx_r558.deviceIdsToImport.length > 0));
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("ngForOf", ctx_r558.listOfControllers);
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_24_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 412);
    i0.ɵɵtext(1, " No controllers are associated to this connector. ");
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_2_div_17_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 292);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_2_div_17_div_24_div_1_Template, 12, 13, "div", 332);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_2_div_17_div_24_div_2_Template, 7, 4, "div", 58);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_2_div_17_div_24_div_3_Template, 9, 6, "div", 382);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_2_div_17_div_24_div_4_Template, 3, 0, "div", 383);
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_2_div_17_div_24_div_5_Template, 3, 0, "div", 383);
    i0.ɵɵelementStart(6, "div", 305);
    i0.ɵɵtemplate(7, CmxConnectorComponent_div_0_div_2_div_17_div_24_div_7_Template, 22, 5, "div", 58);
    i0.ɵɵtemplate(8, CmxConnectorComponent_div_0_div_2_div_17_div_24_div_8_Template, 2, 0, "div", 384);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r393 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r393.spacesConnectorImportAllowed.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r393.importFromConnector.showHotSpotConfigCheck && ctx_r393.currentConnector.version !== "V2");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r393.copyHotspotConfig);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r393.spacesConnectorImportAllowed.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r393.spacesConnectorImportAllowed.length === 1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r393.listOfControllers.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r393.importFromConnector.name !== "-- Select --" && ctx_r393.listOfControllers.length == 0);
} }
function CmxConnectorComponent_div_0_div_2_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r590 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 292);
    i0.ɵɵelementStart(1, "div", 293);
    i0.ɵɵelementStart(2, "div", 294);
    i0.ɵɵelementStart(3, "div", 295);
    i0.ɵɵelementStart(4, "input", 296);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_2_div_17_Template_input_ngModelChange_4_listener() { i0.ɵɵrestoreView(_r590); const ctx_r589 = i0.ɵɵnextContext(3); return ctx_r589.controllerCreationSelection(0); })("ngModelChange", function CmxConnectorComponent_div_0_div_2_div_17_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r590); const ctx_r591 = i0.ɵɵnextContext(3); return ctx_r591.controllerCreateType.value = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 297);
    i0.ɵɵelementStart(6, "span", 298);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelement(9, "br");
    i0.ɵɵelementStart(10, "span", 299);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 295);
    i0.ɵɵelementStart(14, "input", 300);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_2_div_17_Template_input_ngModelChange_14_listener() { i0.ɵɵrestoreView(_r590); const ctx_r592 = i0.ɵɵnextContext(3); return ctx_r592.controllerCreationSelection(1); })("ngModelChange", function CmxConnectorComponent_div_0_div_2_div_17_Template_input_ngModelChange_14_listener($event) { i0.ɵɵrestoreView(_r590); const ctx_r593 = i0.ɵɵnextContext(3); return ctx_r593.controllerCreateType.value = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "label", 297);
    i0.ɵɵelementStart(16, "span", 298);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelement(19, "br");
    i0.ɵɵelementStart(20, "span", 299);
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(23, CmxConnectorComponent_div_0_div_2_div_17_div_23_Template, 25, 22, "div", 283);
    i0.ɵɵtemplate(24, CmxConnectorComponent_div_0_div_2_div_17_div_24_Template, 9, 7, "div", 283);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r379 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r379.controllerCreateType.value);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 8, "dashboard-lib.spaces-connector.create-connector.controller-creation.add_new_controller"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(12, 10, "dashboard-lib.spaces-connector.create-connector.controller-creation.add_new_subheading"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r379.controllerCreateType.value);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 12, "dashboard-lib.spaces-connector.create-connector.controller-creation.choose_import"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(22, 14, "dashboard-lib.spaces-connector.create-connector.controller-creation.choose_import_subheading"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r379.controllerCreateType.name == "new");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r379.controllerCreateType.name == "import");
} }
function CmxConnectorComponent_div_0_div_2_div_18_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r598 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 417);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_18_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r598); const ctx_r597 = i0.ɵɵnextContext(4); return ctx_r597.addCMXConnector(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r594 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", !ctx_r594.toggleSaveButton() ? "disabled" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.cmx-connector.button.save"), " ");
} }
function CmxConnectorComponent_div_0_div_2_div_18_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r600 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 345);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_18_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r600); const ctx_r599 = i0.ɵɵnextContext(4); return ctx_r599.addController(ctx_r599.selectedConnector.id, false); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r595 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", !ctx_r595.toggleSaveButton() ? "disabled" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.cmx-connector.button.save"), " ");
} }
function CmxConnectorComponent_div_0_div_2_div_18_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r602 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 345);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_18_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r602); const ctx_r601 = i0.ɵɵnextContext(4); return ctx_r601.importController(ctx_r601.importFromConnector.id, ctx_r601.selectedConnector.id, ctx_r601.deviceIdsToImport); });
    i0.ɵɵtext(1, " Add ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r596 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", !ctx_r596.toggleSaveButton() ? "disabled" : "");
} }
function CmxConnectorComponent_div_0_div_2_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r604 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 413);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_2_div_18_button_1_Template, 3, 4, "button", 414);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_2_div_18_button_2_Template, 3, 4, "button", 415);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_2_div_18_button_3_Template, 2, 1, "button", 415);
    i0.ɵɵelementStart(4, "button", 416);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_18_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r604); const ctx_r603 = i0.ɵɵnextContext(3); return ctx_r603.showCMXConnectorAdd(false, ctx_r603.isConnectorAvailable, false); });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r380 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r380.isConnectorAvailable === false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r380.isConnectorAvailable === true && ctx_r380.controllerCreateType.name == "new");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r380.controllerCreateType.name == "import");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "dashboard-lib.cmx-connector.button.cancel"), " ");
} }
function CmxConnectorComponent_div_0_div_2_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r606 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 413);
    i0.ɵɵelementStart(1, "button", 416);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_19_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r606); const ctx_r605 = i0.ɵɵnextContext(3); return ctx_r605.showCMXConnectorAdd(false, ctx_r605.isConnectorAvailable, false); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 345);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_div_19_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r606); const ctx_r607 = i0.ɵɵnextContext(3); return ctx_r607.updateController(ctx_r607.selectedController.id); });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r381 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "dashboard-lib.cmx-connector.button.cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", !ctx_r381.toggleSaveButton() ? "disabled" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 5, "dashboard-lib.cmx-connector.button.update"), " ");
} }
function CmxConnectorComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r609 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 275);
    i0.ɵɵelementStart(1, "div", 276);
    i0.ɵɵelementStart(2, "div", 277);
    i0.ɵɵelementStart(3, "div", 245);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 246);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_2_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r609); const ctx_r608 = i0.ɵɵnextContext(2); return ctx_r608.showCMXConnectorAdd(false, ctx_r608.isConnectorAvailable, false); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 278);
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_2_div_9_Template, 2, 1, "div", 279);
    i0.ɵɵelementStart(10, "div", 280);
    i0.ɵɵelementStart(11, "div", 281);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, CmxConnectorComponent_div_0_div_2_div_14_Template, 2, 2, "div", 58);
    i0.ɵɵtemplate(15, CmxConnectorComponent_div_0_div_2_div_15_Template, 5, 5, "div", 58);
    i0.ɵɵelementStart(16, "input", 282);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_2_Template_input_ngModelChange_16_listener($event) { i0.ɵɵrestoreView(_r609); const ctx_r610 = i0.ɵɵnextContext(2); return ctx_r610.controllerObj.connectorId = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, CmxConnectorComponent_div_0_div_2_div_17_Template, 25, 16, "div", 283);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, CmxConnectorComponent_div_0_div_2_div_18_Template, 7, 6, "div", 284);
    i0.ɵɵtemplate(19, CmxConnectorComponent_div_0_div_2_div_19_Template, 7, 7, "div", 284);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r2.popupTitle);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2.cmxConnectorError !== "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 9, "dashboard-lib.cmx-connector.add-edit-popup.spaces-connector-name"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.editControllerPopup === false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.editControllerPopup === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r2.controllerObj.connectorId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.editControllerPopup === true || ctx_r2.controllerObj.isAssociateController === true || ctx_r2.isConnectorAvailable === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.editControllerPopup === false && ctx_r2.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.editControllerPopup === true && ctx_r2.userRole !== "ReadOnlyAccess");
} }
function CmxConnectorComponent_div_0_div_3_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 285);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r611 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r611.cmxConnectorError, " ");
} }
function CmxConnectorComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r613 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 418);
    i0.ɵɵelement(1, "div", 419);
    i0.ɵɵelementStart(2, "div", 420);
    i0.ɵɵelementStart(3, "div", 421);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "span", 422);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_3_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r613); const ctx_r612 = i0.ɵɵnextContext(2); return ctx_r612.openRenameConnectorPopup(false, ctx_r612.selectedConnector); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 247);
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_3_div_9_Template, 2, 1, "div", 279);
    i0.ɵɵelementStart(10, "div", 423);
    i0.ɵɵelementStart(11, "div", 281);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div");
    i0.ɵɵelementStart(15, "input", 424);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_3_Template_input_keyup_15_listener($event) { i0.ɵɵrestoreView(_r613); const ctx_r614 = i0.ɵɵnextContext(2); return ctx_r614.onKey($event); })("input", function CmxConnectorComponent_div_0_div_3_Template_input_input_15_listener($event) { i0.ɵɵrestoreView(_r613); const ctx_r615 = i0.ɵɵnextContext(2); return ctx_r615.controllerObj.connectorName = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 413);
    i0.ɵɵelementStart(17, "button", 345);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_3_Template_button_click_17_listener() { i0.ɵɵrestoreView(_r613); const ctx_r616 = i0.ɵɵnextContext(2); return ctx_r616.updateConnectorName(); });
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(5, 6, "dashboard-lib.cmx-connector.add-edit-popup.rename-connector"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r3.cmxConnectorError !== "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 8, "dashboard-lib.cmx-connector.add-edit-popup.connector-name"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r3.controllerObj.connectorName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r3.controllerObj.connectorName ? "" : "disabled");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 10, "dashboard-lib.cmx-connector.button.update"), " ");
} }
function CmxConnectorComponent_div_0_div_4_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 247);
    i0.ɵɵelementStart(1, "div", 285);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "dashboard-lib.cmx-connector.add-edit-popup.error-connector-details"), " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 285);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r619 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r619.cmxConnectorError, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r620 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.connector-version"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r620.selectedConnector.report.current_version, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r621 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.no-associate-controllers"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r621.selectedConnector.controllerSize, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵelementStart(5, "span", 432);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r622 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "dashboard-lib.cmx-connector.add-edit-popup.control-channel-connection-status"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r622.selectedConnector.controlChannelConnectorStatus === "Active" ? "active" : "inactive");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r622.selectedConnector.controlChannelConnectorStatus);
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r623 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.control-channel-connection-duration"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r623.getDurationFromTimestamp(ctx_r623.selectedConnector.report.controlChannel.connectionTime), " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵelementStart(5, "span", 432);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r624 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "dashboard-lib.cmx-connector.add-edit-popup.data-channel-connection-status"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r624.selectedConnector.dataChannelConnectorStatus === "Active" ? "active" : "inactive");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r624.selectedConnector.dataChannelConnectorStatus);
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r625 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.data-channel-connection-duration"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r625.getDurationFromTimestamp(ctx_r625.selectedConnector.report.dataChannel.connectionTime), " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 428);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r626 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r626.selectedConnector.updatedAt, "medium"), " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 428);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.never"), " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 428);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r628 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r628.selectedConnector.lastHeard, "medium"), " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 428);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.never"), " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r630 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.mac-address"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r630.selectedConnector.report.connector.macAddress, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r631 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.is-address"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r631.selectedConnector.report.connector.ipAddress, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r632 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.ova-version"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r632.selectedConnector.ovaVersion, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r633 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.data-channel-nmsp-messages"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r633.selectedConnector.report.dataChannel.connectionMetrics.nmspMessages.count, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r634 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.nmsp-messages-received"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r634.selectedConnector.report.controllerStats.nmspMessageReceived.count, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r635 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.firehose-status"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r635.selectedConnector.firehoseStatus, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r636 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.ha-active"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r636.selectedConnector.haActiveKeys.join(", "), " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_39_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r639 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.grpc-active-connections"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r639.selectedConnector.activeApConnections, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_39_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r640 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.grpc-incoming-message-count"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r640.selectedConnector.in_count, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_39_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r641 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.grpc-incoming-message-rate"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r641.selectedConnector.in_m1, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_39_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r642 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.grpc-outgoing-message-count"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r642.selectedConnector.out_count, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_39_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r643 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.grpc-outgoing-message-rate"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r643.selectedConnector.out_m1, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_39_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r644 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.tdl-incoming-message-count"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r644.selectedConnector.tdl_count, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_39_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r645 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.tdl-incoming-message-rate"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r645.selectedConnector.tdl_m1, " ");
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_4_div_9_div_39_div_1_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_4_div_9_div_39_div_2_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_4_div_9_div_39_div_3_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_4_div_9_div_39_div_4_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_4_div_9_div_39_div_5_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(6, CmxConnectorComponent_div_0_div_4_div_9_div_39_div_6_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(7, CmxConnectorComponent_div_0_div_4_div_9_div_39_div_7_Template, 6, 4, "div", 429);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r637 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r637.selectedConnector.activeApConnections);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r637.selectedConnector.in_count);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r637.selectedConnector.in_m1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r637.selectedConnector.out_count);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r637.selectedConnector.out_m1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r637.selectedConnector.tdl_count);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r637.selectedConnector.tdl_m1);
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_40_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 441);
    i0.ɵɵelement(1, "img", 442);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_40_lib_d3_multiline_chart_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-d3-multiline-chart", 262);
} if (rf & 2) {
    const ctx_r647 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("data", ctx_r647.connectorDetailsD3Chart)("options", ctx_r647.chartOptions);
} }
function CmxConnectorComponent_div_0_div_4_div_9_div_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 433);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_4_div_9_div_40_div_1_Template, 2, 0, "div", 434);
    i0.ɵɵelementStart(2, "div", 435);
    i0.ɵɵelementStart(3, "div", 436);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 259);
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵelement(8, "span", 437);
    i0.ɵɵelementStart(9, "span", 438);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span");
    i0.ɵɵelement(13, "span", 439);
    i0.ɵɵelement(14, "span", 440);
    i0.ɵɵelementStart(15, "span", 438);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, CmxConnectorComponent_div_0_div_4_div_9_div_40_lib_d3_multiline_chart_18_Template, 1, 2, "lib-d3-multiline-chart", 258);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r638 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r638.showLoaderChartLoader);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 5, "dashboard-lib.cmx-connector.add-edit-popup.message-rates-24-hours"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 7, "dashboard-lib.cmx-connector.add-edit-popup.outgoing"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 9, "dashboard-lib.cmx-connector.add-edit-popup.incoming"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r638.showLoaderChartLoader);
} }
function CmxConnectorComponent_div_0_div_4_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 247);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_4_div_9_div_1_Template, 2, 1, "div", 279);
    i0.ɵɵelementStart(2, "div", 280);
    i0.ɵɵelementStart(3, "div", 281);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 428);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, CmxConnectorComponent_div_0_div_4_div_9_div_8_Template, 6, 4, "div", 429);
    i0.ɵɵelementStart(9, "div", 280);
    i0.ɵɵelementStart(10, "div", 281);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 428);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, CmxConnectorComponent_div_0_div_4_div_9_div_15_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(16, CmxConnectorComponent_div_0_div_4_div_9_div_16_Template, 7, 5, "div", 429);
    i0.ɵɵtemplate(17, CmxConnectorComponent_div_0_div_4_div_9_div_17_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(18, CmxConnectorComponent_div_0_div_4_div_9_div_18_Template, 7, 5, "div", 429);
    i0.ɵɵtemplate(19, CmxConnectorComponent_div_0_div_4_div_9_div_19_Template, 6, 4, "div", 429);
    i0.ɵɵelementStart(20, "div", 280);
    i0.ɵɵelementStart(21, "div", 281);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(24, CmxConnectorComponent_div_0_div_4_div_9_div_24_Template, 3, 4, "div", 430);
    i0.ɵɵtemplate(25, CmxConnectorComponent_div_0_div_4_div_9_div_25_Template, 3, 3, "div", 430);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 280);
    i0.ɵɵelementStart(27, "div", 281);
    i0.ɵɵtext(28);
    i0.ɵɵpipe(29, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(30, CmxConnectorComponent_div_0_div_4_div_9_div_30_Template, 3, 4, "div", 430);
    i0.ɵɵtemplate(31, CmxConnectorComponent_div_0_div_4_div_9_div_31_Template, 3, 3, "div", 430);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(32, CmxConnectorComponent_div_0_div_4_div_9_div_32_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(33, CmxConnectorComponent_div_0_div_4_div_9_div_33_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(34, CmxConnectorComponent_div_0_div_4_div_9_div_34_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(35, CmxConnectorComponent_div_0_div_4_div_9_div_35_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(36, CmxConnectorComponent_div_0_div_4_div_9_div_36_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(37, CmxConnectorComponent_div_0_div_4_div_9_div_37_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(38, CmxConnectorComponent_div_0_div_4_div_9_div_38_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(39, CmxConnectorComponent_div_0_div_4_div_9_div_39_Template, 8, 7, "div", 58);
    i0.ɵɵtemplate(40, CmxConnectorComponent_div_0_div_4_div_9_div_40_Template, 19, 11, "div", 431);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r618 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.cmxConnectorError !== "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(5, 26, "dashboard-lib.cmx-connector.add-edit-popup.connector-name"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r618.selectedConnector.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.report);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(12, 28, "dashboard-lib.cmx-connector.add-edit-popup.connector-id"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r618.selectedConnector.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.controllerSize);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.controlChannelConnectorStatus);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.report && ctx_r618.selectedConnector.controlChannelConnectorStatus === "Active");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.dataChannelConnectorStatus);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.report && ctx_r618.selectedConnector.dataChannelConnectorStatus === "Active");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(23, 30, "dashboard-lib.cmx-connector.table-header.last-modified"), ":");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.updatedAt !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.updatedAt === undefined);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(29, 32, "dashboard-lib.cmx-connector.table-header.last-heard"), ":");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.lastHeard !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.lastHeard === undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.report);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.report);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.ovaVersion);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.report);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.report);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.firehoseStatus);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.haActiveKeys && ctx_r618.selectedConnector.haActiveKeys.length > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.selectedConnector.edm_status === "ENABLED");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r618.showLoaderChartLoader || ctx_r618.connectorDetailsD3Chart && ctx_r618.connectorDetailsD3Chart.length > 0);
} }
function CmxConnectorComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r649 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 425);
    i0.ɵɵelementStart(1, "div", 426);
    i0.ɵɵelementStart(2, "div", 245);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 246);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_4_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r649); const ctx_r648 = i0.ɵɵnextContext(2); return ctx_r648.openConnectorDetailsPopup(false, ctx_r648.selectedConnector); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, CmxConnectorComponent_div_0_div_4_div_8_Template, 4, 3, "div", 427);
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_4_div_9_Template, 41, 34, "div", 427);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 3, "dashboard-lib.cmx-connector.add-edit-popup.connector-details"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r4.cmxConnectorDetailsLoaded && !ctx_r4.selectedConnector.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.cmxConnectorDetailsLoaded && ctx_r4.selectedConnector.id);
} }
function CmxConnectorComponent_div_0_div_5_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 448);
    i0.ɵɵelementStart(1, "div", 285);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "dashboard-lib.cmx-connector.add-edit-popup.error-connector-details"), " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 285);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r652 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r652.cmxConnectorError, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r653 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.connector-version"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r653.selectedConnector.report.current_version, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r654 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.no-associate-controllers"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r654.selectedConnector.controllerSize, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵelementStart(5, "span", 432);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r655 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "dashboard-lib.cmx-connector.add-edit-popup.control-channel-connection-status"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r655.selectedConnector.controlChannelConnectorStatus === "Active" ? "active" : "inactive");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r655.selectedConnector.controlChannelConnectorStatus);
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r656 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.control-channel-connection-duration"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r656.getDurationFromTimestamp(ctx_r656.selectedConnector.report.controlChannel.connectionTime), " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵelementStart(5, "span", 432);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r657 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "dashboard-lib.cmx-connector.add-edit-popup.data-channel-connection-status"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r657.selectedConnector.dataChannelConnectorStatus === "Active" ? "active" : "inactive");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r657.selectedConnector.dataChannelConnectorStatus);
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r658 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.data-channel-connection-duration"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r658.getDurationFromTimestamp(ctx_r658.selectedConnector.report.dataChannel.connectionTime), " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 428);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r659 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r659.selectedConnector.updatedAt, "medium"), " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 428);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.never"), " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 428);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r661 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r661.selectedConnector.lastHeard, "medium"), " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 428);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.never"), " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r663 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.mac-address"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r663.selectedConnector.report.connector.macAddress, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r664 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.ip-address"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r664.selectedConnector.report.connector.ipAddress, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r665 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.ova-version"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r665.selectedConnector.ovaVersion, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r666 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.data-channel-nmsp-messages"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r666.selectedConnector.report.dataChannel.connectionMetrics.nmspMessages.count, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r667 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.nmsp-messages-received"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r667.selectedConnector.report.controllerStats.nmspMessageReceived.count, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r668 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.firehose-status"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r668.selectedConnector.firehoseStatus, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r669 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.ha-active"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r669.selectedConnector.haActiveKeys.join(", "), " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_40_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r672 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.grpc-active-connections"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r672.selectedConnector.activeApConnections, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_40_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r673 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.grpc-incoming-message-count"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r673.selectedConnector.in_count, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_40_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r674 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.grpc-incoming-message-rate"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r674.selectedConnector.in_m1, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_40_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r675 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.grpc-outgoing-message-count"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r675.selectedConnector.out_count, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_40_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r676 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.grpc-outgoing-message-rate"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r676.selectedConnector.out_m1, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_40_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r677 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.tdl-incoming-message-count"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r677.selectedConnector.tdl_count, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_40_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r678 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.tdl-incoming-message-rate"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r678.selectedConnector.tdl_m1, " ");
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_5_div_9_div_40_div_1_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_5_div_9_div_40_div_2_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_5_div_9_div_40_div_3_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_5_div_9_div_40_div_4_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_5_div_9_div_40_div_5_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(6, CmxConnectorComponent_div_0_div_5_div_9_div_40_div_6_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(7, CmxConnectorComponent_div_0_div_5_div_9_div_40_div_7_Template, 6, 4, "div", 429);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r670 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r670.selectedConnector.activeApConnections);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r670.selectedConnector.in_count);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r670.selectedConnector.in_m1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r670.selectedConnector.out_count);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r670.selectedConnector.out_m1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r670.selectedConnector.tdl_count);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r670.selectedConnector.tdl_m1);
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_42_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 441);
    i0.ɵɵelement(1, "img", 442);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_42_lib_d3_multiline_chart_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-d3-multiline-chart", 262);
} if (rf & 2) {
    const ctx_r680 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("data", ctx_r680.connectorDetailsD3Chart)("options", ctx_r680.chartOptions);
} }
function CmxConnectorComponent_div_0_div_5_div_9_div_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 433);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_5_div_9_div_42_div_1_Template, 2, 0, "div", 434);
    i0.ɵɵelementStart(2, "div", 435);
    i0.ɵɵelementStart(3, "div", 436);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 259);
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵelement(8, "span", 437);
    i0.ɵɵelementStart(9, "span", 438);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span");
    i0.ɵɵelement(13, "span", 439);
    i0.ɵɵelement(14, "span", 440);
    i0.ɵɵelementStart(15, "span", 438);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, CmxConnectorComponent_div_0_div_5_div_9_div_42_lib_d3_multiline_chart_18_Template, 1, 2, "lib-d3-multiline-chart", 258);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r671 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r671.showLoaderChartLoader);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 5, "dashboard-lib.cmx-connector.add-edit-popup.message-rates-30-days"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 7, "dashboard-lib.cmx-connector.add-edit-popup.outgoing"), ": ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 9, "dashboard-lib.cmx-connector.add-edit-popup.incoming"), ": ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r671.showLoaderChartLoader);
} }
function CmxConnectorComponent_div_0_div_5_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 448);
    i0.ɵɵelementStart(1, "div", 449);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_5_div_9_div_2_Template, 2, 1, "div", 279);
    i0.ɵɵelementStart(3, "div", 280);
    i0.ɵɵelementStart(4, "div", 281);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 428);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_5_div_9_div_9_Template, 6, 4, "div", 429);
    i0.ɵɵelementStart(10, "div", 280);
    i0.ɵɵelementStart(11, "div", 281);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 428);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, CmxConnectorComponent_div_0_div_5_div_9_div_16_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(17, CmxConnectorComponent_div_0_div_5_div_9_div_17_Template, 7, 5, "div", 429);
    i0.ɵɵtemplate(18, CmxConnectorComponent_div_0_div_5_div_9_div_18_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(19, CmxConnectorComponent_div_0_div_5_div_9_div_19_Template, 7, 5, "div", 429);
    i0.ɵɵtemplate(20, CmxConnectorComponent_div_0_div_5_div_9_div_20_Template, 6, 4, "div", 429);
    i0.ɵɵelementStart(21, "div", 280);
    i0.ɵɵelementStart(22, "div", 281);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(25, CmxConnectorComponent_div_0_div_5_div_9_div_25_Template, 3, 4, "div", 430);
    i0.ɵɵtemplate(26, CmxConnectorComponent_div_0_div_5_div_9_div_26_Template, 3, 3, "div", 430);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 280);
    i0.ɵɵelementStart(28, "div", 281);
    i0.ɵɵtext(29);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(31, CmxConnectorComponent_div_0_div_5_div_9_div_31_Template, 3, 4, "div", 430);
    i0.ɵɵtemplate(32, CmxConnectorComponent_div_0_div_5_div_9_div_32_Template, 3, 3, "div", 430);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(33, CmxConnectorComponent_div_0_div_5_div_9_div_33_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(34, CmxConnectorComponent_div_0_div_5_div_9_div_34_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(35, CmxConnectorComponent_div_0_div_5_div_9_div_35_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(36, CmxConnectorComponent_div_0_div_5_div_9_div_36_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(37, CmxConnectorComponent_div_0_div_5_div_9_div_37_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(38, CmxConnectorComponent_div_0_div_5_div_9_div_38_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(39, CmxConnectorComponent_div_0_div_5_div_9_div_39_Template, 6, 4, "div", 429);
    i0.ɵɵtemplate(40, CmxConnectorComponent_div_0_div_5_div_9_div_40_Template, 8, 7, "div", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "div", 450);
    i0.ɵɵtemplate(42, CmxConnectorComponent_div_0_div_5_div_9_div_42_Template, 19, 11, "div", 431);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r651 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r651.cmxConnectorError !== "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(6, 26, "dashboard-lib.cmx-connector.add-edit-popup.connector-name"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r651.selectedConnector.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.report);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(13, 28, "dashboard-lib.cmx-connector.add-edit-popup.connector-id"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r651.selectedConnector.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.controllerSize);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.controlChannelConnectorStatus);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.report && ctx_r651.selectedConnector.controlChannelConnectorStatus === "Active");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.dataChannelConnectorStatus);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.report && ctx_r651.selectedConnector.dataChannelConnectorStatus === "Active");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(24, 30, "dashboard-lib.cmx-connector.table-header.last-modified"), ":");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.updatedAt !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.updatedAt === undefined);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(30, 32, "dashboard-lib.cmx-connector.table-header.last-heard"), ":");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.lastHeard !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.lastHeard === undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.report);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.report);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.ovaVersion);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.report);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.report);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.firehoseStatus);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.haActiveKeys && ctx_r651.selectedConnector.haActiveKeys.length > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r651.selectedConnector.edm_status === "ENABLED");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r651.showLoaderChartLoader || ctx_r651.connectorDetailsD3Chart && ctx_r651.connectorDetailsD3Chart.length > 0);
} }
function CmxConnectorComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r682 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 443);
    i0.ɵɵelementStart(1, "div", 444);
    i0.ɵɵelementStart(2, "div", 445);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 446);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_5_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r682); const ctx_r681 = i0.ɵɵnextContext(2); return ctx_r681.openConnectorDetailsPopup(false, ctx_r681.selectedConnector); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, CmxConnectorComponent_div_0_div_5_div_8_Template, 4, 3, "div", 447);
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_5_div_9_Template, 43, 34, "div", 447);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 3, "dashboard-lib.cmx-connector.add-edit-popup.connector-details"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r5.cmxConnectorDetailsLoaded && !ctx_r5.selectedConnector.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.cmxConnectorDetailsLoaded && ctx_r5.selectedConnector.id);
} }
function CmxConnectorComponent_div_0_div_6_div_46_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 280);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 428);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r683 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.controller-snmp-version"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r683.selectedController.snmp.version, " ");
} }
function CmxConnectorComponent_div_0_div_6_div_51_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 428);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r684 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r684.selectedController.updatedAt, "medium"), " ");
} }
function CmxConnectorComponent_div_0_div_6_div_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 428);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.never"), " ");
} }
function CmxConnectorComponent_div_0_div_6_div_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 428);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r686 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r686.selectedController.lastHeard, "medium"), " ");
} }
function CmxConnectorComponent_div_0_div_6_div_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 428);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.table-label.never"), " ");
} }
function CmxConnectorComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r689 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 451);
    i0.ɵɵelementStart(1, "div", 277);
    i0.ɵɵelementStart(2, "div", 245);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 246);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_6_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r689); const ctx_r688 = i0.ɵɵnextContext(2); return ctx_r688.openControllerDetailsPopup(false, ctx_r688.selectedController); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 247);
    i0.ɵɵelementStart(9, "div", 280);
    i0.ɵɵelementStart(10, "div", 281);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 428);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 280);
    i0.ɵɵelementStart(16, "div", 281);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 428);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 280);
    i0.ɵɵelementStart(22, "div", 281);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 428);
    i0.ɵɵtext(26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 280);
    i0.ɵɵelementStart(28, "div", 281);
    i0.ɵɵtext(29);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "div", 428);
    i0.ɵɵelementStart(32, "span", 432);
    i0.ɵɵtext(33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 280);
    i0.ɵɵelementStart(35, "div", 281);
    i0.ɵɵtext(36);
    i0.ɵɵpipe(37, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "div", 428);
    i0.ɵɵtext(39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 280);
    i0.ɵɵelementStart(41, "div", 281);
    i0.ɵɵtext(42);
    i0.ɵɵpipe(43, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "div", 428);
    i0.ɵɵtext(45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(46, CmxConnectorComponent_div_0_div_6_div_46_Template, 6, 4, "div", 429);
    i0.ɵɵelementStart(47, "div", 280);
    i0.ɵɵelementStart(48, "div", 281);
    i0.ɵɵtext(49);
    i0.ɵɵpipe(50, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(51, CmxConnectorComponent_div_0_div_6_div_51_Template, 3, 4, "div", 430);
    i0.ɵɵtemplate(52, CmxConnectorComponent_div_0_div_6_div_52_Template, 3, 3, "div", 430);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(53, "div", 280);
    i0.ɵɵelementStart(54, "div", 281);
    i0.ɵɵtext(55);
    i0.ɵɵpipe(56, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(57, CmxConnectorComponent_div_0_div_6_div_57_Template, 3, 4, "div", 430);
    i0.ɵɵtemplate(58, CmxConnectorComponent_div_0_div_6_div_58_Template, 3, 3, "div", 430);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(5, 21, "dashboard-lib.cmx-connector.add-edit-popup.controller-details"), ":");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(12, 23, "dashboard-lib.cmx-connector.add-edit-popup.controller-name"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r6.selectedController.name);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(18, 25, "dashboard-lib.cmx-connector.add-edit-popup.controller-ip"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.selectedController.controllerIp, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(24, 27, "dashboard-lib.cmx-connector.add-edit-popup.spaces-connector-name"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r6.selectedConnector.name);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(30, 29, "dashboard-lib.cmx-connector.add-edit-popup.controller-status"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r6.selectedController.connectionStatus === "Active" ? "active" : "inactive");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.selectedController.connectionStatus);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(37, 31, "dashboard-lib.cmx-connector.add-edit-popup.number-of-aps"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.selectedController.accessPointsCount > 0 ? ctx_r6.selectedController.accessPointsCount : 0, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(43, 33, "dashboard-lib.cmx-connector.add-edit-popup.controller-type"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.selectedController.type === "ewlc" ? "Catalyst 9800 Wireless Controller" : ctx_r6.selectedController.type === "WLC" ? "AireOS Controller" : ctx_r6.selectedController.type, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.selectedController.snmp);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(50, 35, "dashboard-lib.cmx-connector.table-header.last-modified"), ":");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.selectedController.updatedAt !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.selectedController.updatedAt === undefined);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(56, 37, "dashboard-lib.cmx-connector.table-header.last-heard"), ":");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.selectedController.lastHeard !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.selectedController.lastHeard === undefined);
} }
function CmxConnectorComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r691 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 452);
    i0.ɵɵelement(1, "div", 419);
    i0.ɵɵelementStart(2, "div", 453);
    i0.ɵɵelementStart(3, "div", 247);
    i0.ɵɵelement(4, "img", 454);
    i0.ɵɵelementStart(5, "h4", 455);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 413);
    i0.ɵɵelementStart(9, "button", 456);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_7_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r691); const ctx_r690 = i0.ɵɵnextContext(2); return ctx_r690.deleteControllerConfirm(); });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 416);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_7_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r691); const ctx_r692 = i0.ɵɵnextContext(2); return ctx_r692.closeDeleteControllerPopup(); });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(7, 4, "dashboard-lib.cmx-connector.add-edit-popup.warning-delete-controller"), " ", ctx_r7.controllerToBeDeleted.name, "? ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 6, "dashboard-lib.cmx-connector.button.delete"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 8, "dashboard-lib.cmx-connector.button.cancel"), " ");
} }
function CmxConnectorComponent_div_0_div_8_h4_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 455);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r693 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.cmx-connector.add-edit-popup.warning-delete-connector"), " ", ctx_r693.connectorToBeDeleted.name, "? ");
} }
function CmxConnectorComponent_div_0_div_8_h4_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h4");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.add-edit-popup.warning-delete-connector-desc"), " ");
} }
function CmxConnectorComponent_div_0_div_8_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r697 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 456);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_8_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r697); const ctx_r696 = i0.ɵɵnextContext(3); return ctx_r696.deleteConnectorConfirm(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.button.delete"), " ");
} }
function CmxConnectorComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r699 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 452);
    i0.ɵɵelement(1, "div", 419);
    i0.ɵɵelementStart(2, "div", 453);
    i0.ɵɵelementStart(3, "div", 247);
    i0.ɵɵelement(4, "img", 454);
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_8_h4_5_Template, 3, 4, "h4", 457);
    i0.ɵɵtemplate(6, CmxConnectorComponent_div_0_div_8_h4_6_Template, 3, 3, "h4", 58);
    i0.ɵɵelementStart(7, "div", 413);
    i0.ɵɵtemplate(8, CmxConnectorComponent_div_0_div_8_button_8_Template, 3, 3, "button", 458);
    i0.ɵɵelementStart(9, "button", 416);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_8_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r699); const ctx_r698 = i0.ɵɵnextContext(2); return ctx_r698.closeDeleteConnectorConfirmPopup(); });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r8.connectorToBeDeleted.associatedControllers == undefined || ctx_r8.connectorToBeDeleted.associatedControllers.length == 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.connectorToBeDeleted.associatedControllers && ctx_r8.connectorToBeDeleted.associatedControllers.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.connectorToBeDeleted.associatedControllers == undefined || ctx_r8.connectorToBeDeleted.associatedControllers.length == 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 4, "dashboard-lib.cmx-connector.button.cancel"), " ");
} }
function CmxConnectorComponent_div_0_div_9_div_9_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 471);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.add-edit-popup.no_support_manual"), " ");
} }
function CmxConnectorComponent_div_0_div_9_div_9_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 471);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.add-edit-popup.no_support_not_configured"), " ");
} }
function CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_tr_1_span_22_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r716 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 483);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_tr_1_span_22_a_1_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r716); const controller_r709 = i0.ɵɵnextContext(2).$implicit; const ctx_r714 = i0.ɵɵnextContext(6); return ctx_r714.openMoreOptions(controller_r709); });
    i0.ɵɵelement(1, "img", 484);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_tr_1_span_22_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r719 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 164);
    i0.ɵɵelementStart(1, "div", 165);
    i0.ɵɵelement(2, "div", 166);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 167);
    i0.ɵɵelementStart(4, "ul");
    i0.ɵɵelementStart(5, "li", 168);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_tr_1_span_22_div_2_Template_li_click_5_listener() { i0.ɵɵrestoreView(_r719); const controller_r709 = i0.ɵɵnextContext(2).$implicit; const ctx_r717 = i0.ɵɵnextContext(6); return ctx_r717.openStreamConfirmation(controller_r709, "disable", ""); });
    i0.ɵɵelementStart(6, "a", 169);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "li", 168);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_tr_1_span_22_div_2_Template_li_click_9_listener() { i0.ɵɵrestoreView(_r719); const controller_r709 = i0.ɵɵnextContext(2).$implicit; const ctx_r720 = i0.ɵɵnextContext(6); return ctx_r720.openStreamConfirmation(controller_r709, "enable", ""); });
    i0.ɵɵelementStart(10, "a", 169);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 2, "dashboard-lib.cmx-connector.add-edit-popup.disable_stream"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 4, "dashboard-lib.cmx-connector.add-edit-popup.enable_stream"), " ");
} }
function CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_tr_1_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 481);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_tr_1_span_22_a_1_Template, 2, 0, "a", 482);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_tr_1_span_22_div_2_Template, 13, 6, "div", 126);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r709 = i0.ɵɵnextContext().$implicit;
    const ctx_r711 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", ctx_r711.showMoreOptions ? "selected" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r711.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r711.selectedCustomerName === controller_r709.name);
} }
function CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r724 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 479);
    i0.ɵɵelementStart(1, "td", 195);
    i0.ɵɵelementStart(2, "span", 128);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_tr_1_Template_span_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r724); const controller_r709 = restoredCtx.$implicit; const ctx_r723 = i0.ɵɵnextContext(6); return ctx_r723.onControllerStreamLogsClick(controller_r709); });
    i0.ɵɵelementStart(3, "a", 129);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵelementStart(6, "span", 118);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵelementStart(9, "span", 118);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵelementStart(12, "span", 118);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td");
    i0.ɵɵelementStart(15, "span", 118);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "td");
    i0.ɵɵelementStart(18, "span", 118);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "td");
    i0.ɵɵtemplate(22, CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_tr_1_span_22_Template, 3, 3, "span", 480);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r709 = ctx.$implicit;
    const ctx_r708 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", controller_r709.configStatus && controller_r709.configStatus.configurableState !== "AUTO" ? "disable-row" : "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", controller_r709.name, " ", controller_r709.configStatus && controller_r709.configStatus.configurableState !== "AUTO" ? "*" : "", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", controller_r709.configStatus && controller_r709.configStatus.info ? controller_r709.configStatus.info.connectorIpAddress : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", controller_r709.controllerIp, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", controller_r709.configStatus ? controller_r709.configStatus.operationStatus.split("_").join(" ") : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", controller_r709.configStatus && controller_r709.configStatus.operationLog ? controller_r709.configStatus.operationLog : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", controller_r709.configStatus && controller_r709.configStatus.initTime ? i0.ɵɵpipeBind2(20, 9, controller_r709.configStatus.initTime, "medium") : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r708.configurableState === "AUTO");
} }
function CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_tr_1_Template, 23, 12, "tr", 478);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r706 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r706.controllerStreams);
} }
function CmxConnectorComponent_div_0_div_9_div_9_div_19_div_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 485);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.add-edit-popup.no_data_found"), " ");
} }
function CmxConnectorComponent_div_0_div_9_div_9_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r726 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 472);
    i0.ɵɵelementStart(1, "div", 462);
    i0.ɵɵelementStart(2, "div", 463);
    i0.ɵɵelementStart(3, "div", 468);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 468);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 473);
    i0.ɵɵelementStart(10, "table", 474);
    i0.ɵɵelementStart(11, "thead");
    i0.ɵɵelementStart(12, "tr", 107);
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "th");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "th");
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "th");
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "th");
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "th");
    i0.ɵɵtext(29);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(31, "th");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(32, CmxConnectorComponent_div_0_div_9_div_9_div_19_tbody_32_Template, 2, 1, "tbody", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 475);
    i0.ɵɵelementStart(34, "lib-pagination", 110);
    i0.ɵɵlistener("clickEvent", function CmxConnectorComponent_div_0_div_9_div_9_div_19_Template_lib_pagination_clickEvent_34_listener($event) { i0.ɵɵrestoreView(_r726); const ctx_r725 = i0.ɵɵnextContext(4); return ctx_r725.clickEvents($event); })("currentPage", function CmxConnectorComponent_div_0_div_9_div_9_div_19_Template_lib_pagination_currentPage_34_listener($event) { i0.ɵɵrestoreView(_r726); const ctx_r727 = i0.ɵɵnextContext(4); return ctx_r727.getControllerStreamItems($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(35, CmxConnectorComponent_div_0_div_9_div_9_div_19_div_35_Template, 3, 3, "div", 476);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 462);
    i0.ɵɵelementStart(37, "div", 463);
    i0.ɵɵelementStart(38, "div", 464);
    i0.ɵɵelementStart(39, "div", 465);
    i0.ɵɵtext(40);
    i0.ɵɵpipe(41, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div", 467);
    i0.ɵɵelementStart(43, "button", 477);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_9_div_19_Template_button_click_43_listener() { i0.ɵɵrestoreView(_r726); const ctx_r728 = i0.ɵɵnextContext(4); return ctx_r728.handleViewKeysClick(); });
    i0.ɵɵtext(44);
    i0.ɵɵpipe(45, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(46, "div", 468);
    i0.ɵɵtext(47);
    i0.ɵɵpipe(48, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "div", 468);
    i0.ɵɵtext(50);
    i0.ɵɵpipe(51, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r705 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 19, "dashboard-lib.cmx-connector.add-edit-popup.iot_auto_header1"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 21, "dashboard-lib.cmx-connector.add-edit-popup.iot_auto_header2"), " ");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 23, "dashboard-lib.cmx-connector.add-edit-popup.controller"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 25, "dashboard-lib.cmx-connector.add-edit-popup.connector_ip"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 27, "dashboard-lib.cmx-connector.add-edit-popup.controller-ip"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 29, "dashboard-lib.cmx-connector.add-edit-popup.operation_status"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 31, "dashboard-lib.cmx-connector.add-edit-popup.operation_log"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(30, 33, "dashboard-lib.cmx-connector.add-edit-popup.last_updated"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r705.controllerStreams.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pagesToShow", 3)("perPage", 5)("page", ctx_r705.page)("loading", false)("items", ctx_r705.controllerStream_searched);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r705.controllerStreams.length === 0);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(41, 35, "dashboard-lib.cmx-connector.add-edit-popup.manage_controller"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(45, 37, "dashboard-lib.cmx-connector.add-edit-popup.sample_configuration"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(48, 39, "dashboard-lib.cmx-connector.add-edit-popup.iot_controller_step1"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(51, 41, "dashboard-lib.cmx-connector.add-edit-popup.iot_controller_step2"), " ");
} }
const _c7 = function (a0) { return { "background-color": a0 }; };
function CmxConnectorComponent_div_0_div_9_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r730 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 461);
    i0.ɵɵelementStart(2, "div", 462);
    i0.ɵɵelementStart(3, "div", 463);
    i0.ɵɵelementStart(4, "div", 464);
    i0.ɵɵelementStart(5, "div", 465);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementStart(8, "span", 466);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 467);
    i0.ɵɵelementStart(11, "button", 345);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_9_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r730); const ctx_r729 = i0.ɵɵnextContext(3); return ctx_r729.toggleConfigStatus(); });
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 468);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, CmxConnectorComponent_div_0_div_9_div_9_div_17_Template, 3, 3, "div", 469);
    i0.ɵɵtemplate(18, CmxConnectorComponent_div_0_div_9_div_9_div_18_Template, 3, 3, "div", 469);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, CmxConnectorComponent_div_0_div_9_div_9_div_19_Template, 52, 43, "div", 470);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r700 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 9, "dashboard-lib.cmx-connector.add-edit-popup.manage_connector"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(15, _c7, ctx_r700.getConfigOperationColor()));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r700.configOperationStatus);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c3$c, ctx_r700.configurableState !== "AUTO"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 11, "dashboard-lib.cmx-connector.add-edit-popup.configure_to_enable"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 13, "dashboard-lib.cmx-connector.add-edit-popup.enable_iot_streams"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r700.configurableState === "MANUAL");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r700.configurableState === "NOT_ALLOWED");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r700.configurableState === "AUTO");
} }
function CmxConnectorComponent_div_0_div_9_div_10_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r734 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 493);
    i0.ɵɵelementStart(1, "h3");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 494);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_div_3_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r734); const ctx_r733 = i0.ɵɵnextContext(4); return ctx_r733.copyToken(); });
    i0.ɵɵelement(5, "i", 495);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "div", 496);
    i0.ɵɵelementStart(9, "div", 497);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r731 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "dashboard-lib.cmx-connector.add-edit-popup.stream_authentication_key"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", ctx_r731.authToken);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(7, 6, "dashboard-lib.cmx-connector.add-edit-popup.copy_to_clipboard"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r731.authToken);
} }
function CmxConnectorComponent_div_0_div_9_div_10_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r736 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 498);
    i0.ɵɵelementStart(1, "h3");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 494);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_div_4_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r736); const ctx_r735 = i0.ɵɵnextContext(4); return ctx_r735.copyToken(); });
    i0.ɵɵelement(5, "i", 495);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "div", 496);
    i0.ɵɵelementStart(9, "div", 497);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r732 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "dashboard-lib.cmx-connector.add-edit-popup.certificate"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", ctx_r732.certificate);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(7, 6, "dashboard-lib.cmx-connector.add-edit-popup.copy_to_clipboard"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r732.certificate);
} }
function CmxConnectorComponent_div_0_div_9_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r738 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 486);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r738); const ctx_r737 = i0.ɵɵnextContext(3); return ctx_r737.hideCertificates(); });
    i0.ɵɵtext(2, "\u00D7");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_9_div_10_div_3_Template, 11, 8, "div", 487);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_9_div_10_div_4_Template, 11, 8, "div", 488);
    i0.ɵɵelementStart(5, "div", 489);
    i0.ɵɵelementStart(6, "h3");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "h4");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 490);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 490);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 491);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementStart(21, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_Template_i_click_21_listener() { i0.ɵɵrestoreView(_r738); const ctx_r739 = i0.ɵɵnextContext(3); return ctx_r739.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 490);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 491);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementStart(29, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_Template_i_click_29_listener() { i0.ɵɵrestoreView(_r738); const ctx_r740 = i0.ɵɵnextContext(3); return ctx_r740.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 490);
    i0.ɵɵtext(31);
    i0.ɵɵpipe(32, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 490);
    i0.ɵɵtext(34);
    i0.ɵɵpipe(35, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 490);
    i0.ɵɵtext(37);
    i0.ɵɵpipe(38, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 491);
    i0.ɵɵtext(40);
    i0.ɵɵpipe(41, "translate");
    i0.ɵɵelementStart(42, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_Template_i_click_42_listener() { i0.ɵɵrestoreView(_r738); const ctx_r741 = i0.ɵɵnextContext(3); return ctx_r741.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "div", 490);
    i0.ɵɵtext(44);
    i0.ɵɵpipe(45, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(46, "div", 490);
    i0.ɵɵtext(47);
    i0.ɵɵpipe(48, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "div", 490);
    i0.ɵɵtext(50);
    i0.ɵɵpipe(51, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "div", 490);
    i0.ɵɵtext(53);
    i0.ɵɵpipe(54, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(55, "div", 490);
    i0.ɵɵtext(56);
    i0.ɵɵpipe(57, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(58, "div", 490);
    i0.ɵɵtext(59);
    i0.ɵɵpipe(60, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(61, "div", 491);
    i0.ɵɵtext(62);
    i0.ɵɵpipe(63, "translate");
    i0.ɵɵelementStart(64, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_Template_i_click_64_listener() { i0.ɵɵrestoreView(_r738); const ctx_r742 = i0.ɵɵnextContext(3); return ctx_r742.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(65, "h4");
    i0.ɵɵtext(66);
    i0.ɵɵpipe(67, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(68, "div", 490);
    i0.ɵɵtext(69);
    i0.ɵɵpipe(70, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(71, "div", 491);
    i0.ɵɵtext(72);
    i0.ɵɵpipe(73, "translate");
    i0.ɵɵelementStart(74, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_Template_i_click_74_listener() { i0.ɵɵrestoreView(_r738); const ctx_r743 = i0.ɵɵnextContext(3); return ctx_r743.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(75, "div", 490);
    i0.ɵɵtext(76);
    i0.ɵɵpipe(77, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(78, "div", 491);
    i0.ɵɵtext(79);
    i0.ɵɵpipe(80, "translate");
    i0.ɵɵelementStart(81, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_Template_i_click_81_listener() { i0.ɵɵrestoreView(_r738); const ctx_r744 = i0.ɵɵnextContext(3); return ctx_r744.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(82, "div", 490);
    i0.ɵɵtext(83);
    i0.ɵɵpipe(84, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(85, "div", 491);
    i0.ɵɵtext(86);
    i0.ɵɵpipe(87, "translate");
    i0.ɵɵelementStart(88, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_Template_i_click_88_listener() { i0.ɵɵrestoreView(_r738); const ctx_r745 = i0.ɵɵnextContext(3); return ctx_r745.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(89, "div", 490);
    i0.ɵɵtext(90);
    i0.ɵɵpipe(91, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(92, "div", 491);
    i0.ɵɵtext(93);
    i0.ɵɵpipe(94, "translate");
    i0.ɵɵelementStart(95, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_Template_i_click_95_listener() { i0.ɵɵrestoreView(_r738); const ctx_r746 = i0.ɵɵnextContext(3); return ctx_r746.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(96, "div", 491);
    i0.ɵɵtext(97);
    i0.ɵɵpipe(98, "translate");
    i0.ɵɵelementStart(99, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_Template_i_click_99_listener() { i0.ɵɵrestoreView(_r738); const ctx_r747 = i0.ɵɵnextContext(3); return ctx_r747.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(100, "div", 490);
    i0.ɵɵtext(101);
    i0.ɵɵpipe(102, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(103, "div", 490);
    i0.ɵɵtext(104);
    i0.ɵɵpipe(105, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(106, "div", 491);
    i0.ɵɵtext(107);
    i0.ɵɵpipe(108, "translate");
    i0.ɵɵelementStart(109, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_Template_i_click_109_listener() { i0.ɵɵrestoreView(_r738); const ctx_r748 = i0.ɵɵnextContext(3); return ctx_r748.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(110, "div", 490);
    i0.ɵɵtext(111);
    i0.ɵɵpipe(112, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(113, "div", 490);
    i0.ɵɵtext(114, " ----------------------------------------------------------------------------------- ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(115, "div", 490);
    i0.ɵɵtext(116);
    i0.ɵɵpipe(117, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(118, "div", 490);
    i0.ɵɵtext(119);
    i0.ɵɵpipe(120, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(121, "div", 490);
    i0.ɵɵtext(122);
    i0.ɵɵpipe(123, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(124, "div", 491);
    i0.ɵɵtext(125);
    i0.ɵɵpipe(126, "translate");
    i0.ɵɵelementStart(127, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_10_Template_i_click_127_listener() { i0.ɵɵrestoreView(_r738); const ctx_r749 = i0.ɵɵnextContext(3); return ctx_r749.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(128, "div", 490);
    i0.ɵɵtext(129);
    i0.ɵɵpipe(130, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(131, "div", 490);
    i0.ɵɵtext(132, " ---------------------------------- ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(133, "div", 490);
    i0.ɵɵtext(134);
    i0.ɵɵpipe(135, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r701 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r701.authToken.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r701.certificate.length > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(8, 52, "dashboard-lib.cmx-connector.add-edit-popup.configuration_steps"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 54, "dashboard-lib.cmx-connector.add-edit-popup.configuration_header"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 56, "dashboard-lib.cmx-connector.add-edit-popup.configuration_step1"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 58, "dashboard-lib.cmx-connector.add-edit-popup.configuration_step2"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 60, "dashboard-lib.cmx-connector.add-edit-popup.configure_terminal"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "# configure terminal");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 62, "dashboard-lib.cmx-connector.add-edit-popup.configuration_step3"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(27, 64, "dashboard-lib.cmx-connector.add-edit-popup.config_token0"), " <", i0.ɵɵpipeBind1(28, 66, "dashboard-lib.cmx-connector.add-edit-popup.stream_auth_key"), "> ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cbContent", "(config)# ap cisco-dna token 0 <stream-authentication-key>");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(32, 68, "dashboard-lib.cmx-connector.add-edit-popup.example_config_token0"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(35, 70, "dashboard-lib.cmx-connector.add-edit-popup.configuration_step4"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(38, 72, "dashboard-lib.cmx-connector.add-edit-popup.push_enter"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(41, 74, "dashboard-lib.cmx-connector.add-edit-popup.config_crypto"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config)# crypto pki trustpool\u00A0import\u00A0terminal");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(45, 76, "dashboard-lib.cmx-connector.add-edit-popup.config_pem_formatted"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(48, 78, "dashboard-lib.cmx-connector.add-edit-popup.config_end_blank"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" <", i0.ɵɵpipeBind1(51, 80, "dashboard-lib.cmx-connector.add-edit-popup.paste_certificate"), "> ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" <", i0.ɵɵpipeBind1(54, 82, "dashboard-lib.cmx-connector.add-edit-popup.press_enter_twice"), "> ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(57, 84, "dashboard-lib.cmx-connector.add-edit-popup.pem_succeeded"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(60, 86, "dashboard-lib.cmx-connector.add-edit-popup.configuration_step5"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(63, 88, "dashboard-lib.cmx-connector.add-edit-popup.config_no_ap"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config)#no ap dot15 shutdown");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(67, 90, "dashboard-lib.cmx-connector.add-edit-popup.steps_6_9"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(70, 92, "dashboard-lib.cmx-connector.add-edit-popup.configuration_step6"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(73, 94, "dashboard-lib.cmx-connector.add-edit-popup.config_ap_profile"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config)#ap profile\u00A0default-ap-profile");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(77, 96, "dashboard-lib.cmx-connector.add-edit-popup.configuration_step7"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(80, 98, "dashboard-lib.cmx-connector.add-edit-popup.config_grpc"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-ap-profile)#cisco-dna grpc");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(84, 100, "dashboard-lib.cmx-connector.add-edit-popup.configuration_step8"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(87, 102, "dashboard-lib.cmx-connector.add-edit-popup.config_apphost"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-ap-profile)#apphost");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(91, 104, "dashboard-lib.cmx-connector.add-edit-popup.configuration_step9"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(94, 106, "dashboard-lib.cmx-connector.add-edit-popup.config_ap_profile_exit"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-ap-profile)# exit");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(98, 108, "dashboard-lib.cmx-connector.add-edit-popup.config_exit"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config)# exit");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(102, 110, "dashboard-lib.cmx-connector.add-edit-popup.verification_grpc_status"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(105, 112, "dashboard-lib.cmx-connector.add-edit-popup.configuration_step10"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(108, 114, "dashboard-lib.cmx-connector.add-edit-popup.show_grpc_summary"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "#show ap grpc summary");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(112, 116, "dashboard-lib.cmx-connector.add-edit-popup.grpc_header"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(117, 118, "dashboard-lib.cmx-connector.add-edit-popup.grpc_value"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(120, 120, "dashboard-lib.cmx-connector.add-edit-popup.verification_hosting_enabled"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(123, 122, "dashboard-lib.cmx-connector.add-edit-popup.configuration_step11"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(126, 124, "dashboard-lib.cmx-connector.add-edit-popup.show_apphost_summary"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "#show ap apphost summary");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(130, 126, "dashboard-lib.cmx-connector.add-edit-popup.apphost_header"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(135, 128, "dashboard-lib.cmx-connector.add-edit-popup.apphost_value"), " ");
} }
function CmxConnectorComponent_div_0_div_9_div_11_div_4_tbody_22_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 112);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span", 118);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "span", 118);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵelementStart(8, "span", 118);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵelementStart(11, "span", 118);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td");
    i0.ɵɵelementStart(15, "span", 118);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const log_r755 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", log_r755.displayLabel, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", log_r755.status.split("_").join(" "), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", log_r755.message, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(13, 5, log_r755.initTime, "medium" || "--"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(17, 8, log_r755.finishTime, "medium" || "--"), " ");
} }
function CmxConnectorComponent_div_0_div_9_div_11_div_4_tbody_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_9_div_11_div_4_tbody_22_tr_1_Template, 18, 11, "tr", 111);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const stream_r751 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", stream_r751.value);
} }
function CmxConnectorComponent_div_0_div_9_div_11_div_4_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 500);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.add-edit-popup.no_data_found"), " ");
} }
function CmxConnectorComponent_div_0_div_9_div_11_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h3");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 473);
    i0.ɵɵelementStart(4, "table", 474);
    i0.ɵɵelementStart(5, "thead");
    i0.ɵɵelementStart(6, "tr", 107);
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "th");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "th");
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, CmxConnectorComponent_div_0_div_9_div_11_div_4_tbody_22_Template, 2, 1, "tbody", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(23, CmxConnectorComponent_div_0_div_9_div_11_div_4_div_23_Template, 3, 3, "div", 499);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const stream_r751 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(stream_r751.label);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 8, "dashboard-lib.cmx-connector.add-edit-popup.action"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 10, "dashboard-lib.cmx-connector.add-edit-popup.status"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 12, "dashboard-lib.cmx-connector.add-edit-popup.message"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 14, "dashboard-lib.cmx-connector.add-edit-popup.start_time"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 16, "dashboard-lib.cmx-connector.add-edit-popup.finish_time"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", stream_r751.value.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", stream_r751.value.length === 0);
} }
function CmxConnectorComponent_div_0_div_9_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r759 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 486);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_div_11_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r759); const ctx_r758 = i0.ɵɵnextContext(3); return ctx_r758.onControllerStreamLogsClick(""); });
    i0.ɵɵtext(2, "\u00D7");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "section");
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_9_div_11_div_4_Template, 24, 18, "div", 249);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r702 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r702.controllerLogs);
} }
function CmxConnectorComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r761 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 418);
    i0.ɵɵelementStart(1, "div", 459);
    i0.ɵɵelementStart(2, "div", 245);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 246);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r761); const ctx_r760 = i0.ɵɵnextContext(2); return ctx_r760.hideManageStreams(); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 460);
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_9_div_9_Template, 20, 19, "div", 58);
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_9_div_10_Template, 136, 130, "div", 58);
    i0.ɵɵtemplate(11, CmxConnectorComponent_div_0_div_9_div_11_Template, 5, 1, "div", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 413);
    i0.ɵɵelementStart(13, "button", 416);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_9_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r761); const ctx_r762 = i0.ɵɵnextContext(2); return ctx_r762.hideManageStreams(); });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "dashboard-lib.cmx-connector.add-edit-popup.manage_iot_streams"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", !ctx_r9.displayTokens && !ctx_r9.displayStreamLogs);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.displayTokens && !ctx_r9.displayStreamLogs);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.displayStreamLogs);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 7, "dashboard-lib.cmx-connector.button.cancel"), " ");
} }
function CmxConnectorComponent_div_0_div_10_div_9_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 471);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.add-edit-popup.no_support_manual"), " ");
} }
function CmxConnectorComponent_div_0_div_10_div_9_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 471);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.add-edit-popup.no_support_not_configured"), " ");
} }
function CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_tr_1_span_22_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r779 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 483);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_tr_1_span_22_a_1_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r779); const controller_r772 = i0.ɵɵnextContext(2).$implicit; const ctx_r777 = i0.ɵɵnextContext(6); return ctx_r777.openMoreOptions(controller_r772); });
    i0.ɵɵelement(1, "img", 484);
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_tr_1_span_22_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r782 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 164);
    i0.ɵɵelementStart(1, "div", 165);
    i0.ɵɵelement(2, "div", 166);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 167);
    i0.ɵɵelementStart(4, "ul");
    i0.ɵɵelementStart(5, "li", 168);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_tr_1_span_22_div_2_Template_li_click_5_listener() { i0.ɵɵrestoreView(_r782); const controller_r772 = i0.ɵɵnextContext(2).$implicit; const ctx_r780 = i0.ɵɵnextContext(6); return ctx_r780.openStreamConfirmation(controller_r772, "disable", "switch"); });
    i0.ɵɵelementStart(6, "a", 169);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "li", 168);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_tr_1_span_22_div_2_Template_li_click_9_listener() { i0.ɵɵrestoreView(_r782); const ctx_r784 = i0.ɵɵnextContext(2); const controller_r772 = ctx_r784.$implicit; const i_r773 = ctx_r784.index; const ctx_r783 = i0.ɵɵnextContext(6); return ctx_r783.toggleConfigureSwitchPopup(true, controller_r772, i_r773); });
    i0.ɵɵelementStart(10, "a", 169);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 2, "dashboard-lib.cmx-connector.add-edit-popup.disable_service"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 4, "dashboard-lib.cmx-connector.add-edit-popup.enable_service"), " ");
} }
function CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_tr_1_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 481);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_tr_1_span_22_a_1_Template, 2, 0, "a", 501);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_tr_1_span_22_div_2_Template, 13, 6, "div", 126);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r772 = i0.ɵɵnextContext().$implicit;
    const ctx_r774 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", ctx_r774.showMoreOptions ? "selected" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r774.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r774.selectedCustomerName === controller_r772.name);
} }
function CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r787 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 479);
    i0.ɵɵelementStart(1, "td", 195);
    i0.ɵɵelementStart(2, "span", 128);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_tr_1_Template_span_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r787); const controller_r772 = restoredCtx.$implicit; const ctx_r786 = i0.ɵɵnextContext(6); return ctx_r786.onSwitchStreamLogsClick(controller_r772); });
    i0.ɵɵelementStart(3, "a", 129);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵelementStart(6, "span", 118);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵelementStart(9, "span", 118);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵelementStart(12, "span", 118);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td");
    i0.ɵɵelementStart(15, "span", 118);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "td");
    i0.ɵɵelementStart(18, "span", 118);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "td");
    i0.ɵɵtemplate(22, CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_tr_1_span_22_Template, 3, 3, "span", 480);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const controller_r772 = ctx.$implicit;
    const ctx_r771 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", controller_r772.configStatus && controller_r772.configStatus.configurableState !== "AUTO" ? "disable-row" : "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", controller_r772.name, " ", controller_r772.configStatus && controller_r772.configStatus.configurableState !== "AUTO" ? "*" : "", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", controller_r772.configStatus && controller_r772.configStatus.info ? controller_r772.configStatus.info.connectorIpAddress : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", controller_r772.switchIp, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", controller_r772.configStatus ? controller_r772.configStatus.operationStatus.split("_").join(" ") : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", controller_r772.configStatus && controller_r772.configStatus.operationLog ? controller_r772.configStatus.operationLog : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", controller_r772.configStatus && controller_r772.configStatus.initTime ? i0.ɵɵpipeBind2(20, 9, controller_r772.configStatus.initTime, "medium") : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r771.configurableState === "AUTO");
} }
function CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_tr_1_Template, 23, 12, "tr", 478);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r769 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r769.controllerStreams);
} }
function CmxConnectorComponent_div_0_div_10_div_9_div_19_div_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 485);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.add-edit-popup.no_data_found"), " ");
} }
function CmxConnectorComponent_div_0_div_10_div_9_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r789 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 472);
    i0.ɵɵelementStart(1, "div", 462);
    i0.ɵɵelementStart(2, "div", 463);
    i0.ɵɵelementStart(3, "div", 468);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 468);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 473);
    i0.ɵɵelementStart(10, "table", 474);
    i0.ɵɵelementStart(11, "thead");
    i0.ɵɵelementStart(12, "tr", 107);
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "th");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "th");
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "th");
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "th");
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "th");
    i0.ɵɵtext(29);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(31, "th");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(32, CmxConnectorComponent_div_0_div_10_div_9_div_19_tbody_32_Template, 2, 1, "tbody", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "lib-pagination", 110);
    i0.ɵɵlistener("clickEvent", function CmxConnectorComponent_div_0_div_10_div_9_div_19_Template_lib_pagination_clickEvent_33_listener($event) { i0.ɵɵrestoreView(_r789); const ctx_r788 = i0.ɵɵnextContext(4); return ctx_r788.clickEvents($event); })("currentPage", function CmxConnectorComponent_div_0_div_10_div_9_div_19_Template_lib_pagination_currentPage_33_listener($event) { i0.ɵɵrestoreView(_r789); const ctx_r790 = i0.ɵɵnextContext(4); return ctx_r790.getControllerStreamItems($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(34, CmxConnectorComponent_div_0_div_10_div_9_div_19_div_34_Template, 3, 3, "div", 476);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "div", 462);
    i0.ɵɵelementStart(36, "div", 463);
    i0.ɵɵelementStart(37, "div", 464);
    i0.ɵɵelementStart(38, "div", 465);
    i0.ɵɵtext(39);
    i0.ɵɵpipe(40, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "div", 467);
    i0.ɵɵelementStart(42, "button", 477);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_9_div_19_Template_button_click_42_listener() { i0.ɵɵrestoreView(_r789); const ctx_r791 = i0.ɵɵnextContext(4); return ctx_r791.handleViewKeysClick(); });
    i0.ɵɵtext(43);
    i0.ɵɵpipe(44, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(45, "div", 468);
    i0.ɵɵtext(46);
    i0.ɵɵpipe(47, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "div", 468);
    i0.ɵɵtext(49);
    i0.ɵɵpipe(50, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r768 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 19, "dashboard-lib.cmx-connector.add-edit-popup.iot_switches_header1"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 21, "dashboard-lib.cmx-connector.add-edit-popup.iot_switches_header2"), " ");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 23, "dashboard-lib.cmx-connector.add-edit-popup.switch_name"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 25, "dashboard-lib.cmx-connector.add-edit-popup.connector_ip"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 27, "dashboard-lib.cmx-connector.add-edit-popup.switch_ip"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 29, "dashboard-lib.cmx-connector.add-edit-popup.operation_status"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 31, "dashboard-lib.cmx-connector.add-edit-popup.operation_log"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(30, 33, "dashboard-lib.cmx-connector.add-edit-popup.last_updated"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r768.controllerStreams.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pagesToShow", 3)("perPage", 5)("page", ctx_r768.page)("loading", false)("items", ctx_r768.controllerStream_searched);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r768.controllerStreams.length === 0);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(40, 35, "dashboard-lib.cmx-connector.add-edit-popup.manage_switch"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(44, 37, "dashboard-lib.cmx-connector.add-edit-popup.sample_configuration"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(47, 39, "dashboard-lib.cmx-connector.add-edit-popup.iot_services_step1"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(50, 41, "dashboard-lib.cmx-connector.add-edit-popup.iot_services_step2"), " ");
} }
function CmxConnectorComponent_div_0_div_10_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r793 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 461);
    i0.ɵɵelementStart(2, "div", 462);
    i0.ɵɵelementStart(3, "div", 463);
    i0.ɵɵelementStart(4, "div", 464);
    i0.ɵɵelementStart(5, "div", 465);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementStart(8, "span", 466);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 467);
    i0.ɵɵelementStart(11, "button", 345);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_9_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r793); const ctx_r792 = i0.ɵɵnextContext(3); return ctx_r792.toggleConfigStatus(); });
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 468);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, CmxConnectorComponent_div_0_div_10_div_9_div_17_Template, 3, 3, "div", 469);
    i0.ɵɵtemplate(18, CmxConnectorComponent_div_0_div_10_div_9_div_18_Template, 3, 3, "div", 469);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, CmxConnectorComponent_div_0_div_10_div_9_div_19_Template, 51, 43, "div", 470);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r763 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 9, "dashboard-lib.cmx-connector.add-edit-popup.manage_connector"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(15, _c7, ctx_r763.getConfigOperationColor()));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r763.configOperationStatus);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c3$c, ctx_r763.configurableState !== "AUTO"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 11, "dashboard-lib.cmx-connector.add-edit-popup.configure_to_enable"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 13, "dashboard-lib.cmx-connector.add-edit-popup.enable_iot_services"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r763.configurableState === "MANUAL");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r763.configurableState === "NOT_ALLOWED");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r763.configurableState === "AUTO");
} }
function CmxConnectorComponent_div_0_div_10_div_10_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r796 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 493);
    i0.ɵɵelementStart(1, "h3");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 494);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_div_3_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r796); const ctx_r795 = i0.ɵɵnextContext(4); return ctx_r795.copyToken(); });
    i0.ɵɵelement(5, "i", 495);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "div", 496);
    i0.ɵɵelementStart(9, "div", 497);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r794 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "dashboard-lib.cmx-connector.add-edit-popup.stream_authentication_key"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", ctx_r794.authToken);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0", i0.ɵɵpipeBind1(7, 6, "dashboard-lib.cmx-connector.add-edit-popup.copy_to_clipboard"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r794.authToken);
} }
function CmxConnectorComponent_div_0_div_10_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r798 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 486);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r798); const ctx_r797 = i0.ɵɵnextContext(3); return ctx_r797.hideCertificates(); });
    i0.ɵɵtext(2, "\u00D7");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_10_div_10_div_3_Template, 11, 8, "div", 487);
    i0.ɵɵelementStart(4, "div", 489);
    i0.ɵɵelementStart(5, "h3");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "h4");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 490);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 490);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 491);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementStart(20, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_20_listener() { i0.ɵɵrestoreView(_r798); const ctx_r799 = i0.ɵɵnextContext(3); return ctx_r799.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 490);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 491);
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementStart(27, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_27_listener() { i0.ɵɵrestoreView(_r798); const ctx_r800 = i0.ɵɵnextContext(3); return ctx_r800.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "h4");
    i0.ɵɵtext(29);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "div", 490);
    i0.ɵɵtext(32);
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 491);
    i0.ɵɵtext(35);
    i0.ɵɵpipe(36, "translate");
    i0.ɵɵelementStart(37, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_37_listener() { i0.ɵɵrestoreView(_r798); const ctx_r801 = i0.ɵɵnextContext(3); return ctx_r801.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "div", 490);
    i0.ɵɵtext(39);
    i0.ɵɵpipe(40, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "div", 490);
    i0.ɵɵtext(42);
    i0.ɵɵpipe(43, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "div", 491);
    i0.ɵɵtext(45);
    i0.ɵɵpipe(46, "translate");
    i0.ɵɵelement(47, "br");
    i0.ɵɵtext(48);
    i0.ɵɵpipe(49, "translate");
    i0.ɵɵelementStart(50, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_50_listener() { i0.ɵɵrestoreView(_r798); const ctx_r802 = i0.ɵɵnextContext(3); return ctx_r802.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(51, "div", 490);
    i0.ɵɵtext(52);
    i0.ɵɵpipe(53, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(54, "h4");
    i0.ɵɵtext(55);
    i0.ɵɵpipe(56, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(57, "div", 490);
    i0.ɵɵtext(58);
    i0.ɵɵpipe(59, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(60, "div", 491);
    i0.ɵɵtext(61);
    i0.ɵɵpipe(62, "translate");
    i0.ɵɵelement(63, "br");
    i0.ɵɵtext(64);
    i0.ɵɵpipe(65, "translate");
    i0.ɵɵelement(66, "br");
    i0.ɵɵtext(67);
    i0.ɵɵpipe(68, "translate");
    i0.ɵɵelementStart(69, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_69_listener() { i0.ɵɵrestoreView(_r798); const ctx_r803 = i0.ɵɵnextContext(3); return ctx_r803.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(70, "h4");
    i0.ɵɵtext(71);
    i0.ɵɵpipe(72, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(73, "div", 490);
    i0.ɵɵtext(74);
    i0.ɵɵpipe(75, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(76, "div", 491);
    i0.ɵɵtext(77);
    i0.ɵɵpipe(78, "translate");
    i0.ɵɵpipe(79, "translate");
    i0.ɵɵelementStart(80, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_80_listener() { i0.ɵɵrestoreView(_r798); const ctx_r804 = i0.ɵɵnextContext(3); return ctx_r804.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(81, "div", 490);
    i0.ɵɵtext(82);
    i0.ɵɵpipe(83, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(84, "div", 490);
    i0.ɵɵtext(85);
    i0.ɵɵpipe(86, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(87, "div", 491);
    i0.ɵɵtext(88);
    i0.ɵɵpipe(89, "translate");
    i0.ɵɵpipe(90, "translate");
    i0.ɵɵelementStart(91, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_91_listener() { i0.ɵɵrestoreView(_r798); const ctx_r805 = i0.ɵɵnextContext(3); return ctx_r805.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(92, "div", 490);
    i0.ɵɵtext(93);
    i0.ɵɵpipe(94, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(95, "div", 490);
    i0.ɵɵtext(96);
    i0.ɵɵpipe(97, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(98, "div", 491);
    i0.ɵɵtext(99);
    i0.ɵɵpipe(100, "translate");
    i0.ɵɵelementStart(101, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_101_listener() { i0.ɵɵrestoreView(_r798); const ctx_r806 = i0.ɵɵnextContext(3); return ctx_r806.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(102, "div", 490);
    i0.ɵɵtext(103);
    i0.ɵɵpipe(104, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(105, "div", 491);
    i0.ɵɵtext(106);
    i0.ɵɵpipe(107, "translate");
    i0.ɵɵpipe(108, "translate");
    i0.ɵɵelementStart(109, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_109_listener() { i0.ɵɵrestoreView(_r798); const ctx_r807 = i0.ɵɵnextContext(3); return ctx_r807.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(110, "div", 490);
    i0.ɵɵtext(111);
    i0.ɵɵpipe(112, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(113, "div", 490);
    i0.ɵɵtext(114);
    i0.ɵɵpipe(115, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(116, "div", 491);
    i0.ɵɵtext(117);
    i0.ɵɵpipe(118, "translate");
    i0.ɵɵelementStart(119, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_119_listener() { i0.ɵɵrestoreView(_r798); const ctx_r808 = i0.ɵɵnextContext(3); return ctx_r808.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(120, "div", 490);
    i0.ɵɵtext(121);
    i0.ɵɵpipe(122, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(123, "div", 490);
    i0.ɵɵtext(124);
    i0.ɵɵpipe(125, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(126, "div", 491);
    i0.ɵɵtext(127);
    i0.ɵɵpipe(128, "translate");
    i0.ɵɵpipe(129, "translate");
    i0.ɵɵelement(130, "br");
    i0.ɵɵtext(131);
    i0.ɵɵpipe(132, "translate");
    i0.ɵɵelement(133, "br");
    i0.ɵɵtext(134);
    i0.ɵɵpipe(135, "translate");
    i0.ɵɵelementStart(136, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_136_listener() { i0.ɵɵrestoreView(_r798); const ctx_r809 = i0.ɵɵnextContext(3); return ctx_r809.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(137, "div", 490);
    i0.ɵɵtext(138);
    i0.ɵɵpipe(139, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(140, "h4");
    i0.ɵɵtext(141);
    i0.ɵɵpipe(142, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(143, "div", 490);
    i0.ɵɵtext(144);
    i0.ɵɵpipe(145, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(146, "div", 491);
    i0.ɵɵtext(147);
    i0.ɵɵpipe(148, "translate");
    i0.ɵɵpipe(149, "translate");
    i0.ɵɵelementStart(150, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_150_listener() { i0.ɵɵrestoreView(_r798); const ctx_r810 = i0.ɵɵnextContext(3); return ctx_r810.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(151, "div", 490);
    i0.ɵɵtext(152);
    i0.ɵɵpipe(153, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(154, "div", 491);
    i0.ɵɵtext(155);
    i0.ɵɵpipe(156, "translate");
    i0.ɵɵelement(157, "br");
    i0.ɵɵtext(158);
    i0.ɵɵpipe(159, "translate");
    i0.ɵɵpipe(160, "translate");
    i0.ɵɵelementStart(161, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_161_listener() { i0.ɵɵrestoreView(_r798); const ctx_r811 = i0.ɵɵnextContext(3); return ctx_r811.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(162, "div", 490);
    i0.ɵɵtext(163);
    i0.ɵɵpipe(164, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(165, "div", 491);
    i0.ɵɵtext(166);
    i0.ɵɵpipe(167, "translate");
    i0.ɵɵpipe(168, "translate");
    i0.ɵɵpipe(169, "translate");
    i0.ɵɵelement(170, "br");
    i0.ɵɵtext(171);
    i0.ɵɵpipe(172, "translate");
    i0.ɵɵelementStart(173, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_173_listener() { i0.ɵɵrestoreView(_r798); const ctx_r812 = i0.ɵɵnextContext(3); return ctx_r812.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(174, "div", 490);
    i0.ɵɵtext(175);
    i0.ɵɵpipe(176, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(177, "div", 490);
    i0.ɵɵtext(178);
    i0.ɵɵpipe(179, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(180, "div", 491);
    i0.ɵɵtext(181);
    i0.ɵɵpipe(182, "translate");
    i0.ɵɵpipe(183, "translate");
    i0.ɵɵelementStart(184, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_184_listener() { i0.ɵɵrestoreView(_r798); const ctx_r813 = i0.ɵɵnextContext(3); return ctx_r813.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(185, "div", 490);
    i0.ɵɵtext(186);
    i0.ɵɵpipe(187, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(188, "div", 490);
    i0.ɵɵtext(189);
    i0.ɵɵpipe(190, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(191, "div", 491);
    i0.ɵɵtext(192);
    i0.ɵɵpipe(193, "translate");
    i0.ɵɵpipe(194, "translate");
    i0.ɵɵpipe(195, "translate");
    i0.ɵɵelement(196, "br");
    i0.ɵɵtext(197);
    i0.ɵɵpipe(198, "translate");
    i0.ɵɵelement(199, "br");
    i0.ɵɵtext(200);
    i0.ɵɵpipe(201, "translate");
    i0.ɵɵelementStart(202, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_202_listener() { i0.ɵɵrestoreView(_r798); const ctx_r814 = i0.ɵɵnextContext(3); return ctx_r814.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(203, "div", 490);
    i0.ɵɵtext(204);
    i0.ɵɵpipe(205, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(206, "div", 490);
    i0.ɵɵtext(207);
    i0.ɵɵpipe(208, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(209, "div", 491);
    i0.ɵɵtext(210);
    i0.ɵɵpipe(211, "translate");
    i0.ɵɵelementStart(212, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_212_listener() { i0.ɵɵrestoreView(_r798); const ctx_r815 = i0.ɵɵnextContext(3); return ctx_r815.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(213, "div", 490);
    i0.ɵɵtext(214);
    i0.ɵɵpipe(215, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(216, "h4");
    i0.ɵɵtext(217);
    i0.ɵɵpipe(218, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(219, "div", 490);
    i0.ɵɵtext(220);
    i0.ɵɵpipe(221, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(222, "div", 491);
    i0.ɵɵtext(223);
    i0.ɵɵpipe(224, "translate");
    i0.ɵɵelementStart(225, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_225_listener() { i0.ɵɵrestoreView(_r798); const ctx_r816 = i0.ɵɵnextContext(3); return ctx_r816.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(226, "div", 490);
    i0.ɵɵtext(227);
    i0.ɵɵpipe(228, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(229, "div", 491);
    i0.ɵɵtext(230);
    i0.ɵɵpipe(231, "translate");
    i0.ɵɵelementStart(232, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_232_listener() { i0.ɵɵrestoreView(_r798); const ctx_r817 = i0.ɵɵnextContext(3); return ctx_r817.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(233, "div", 490);
    i0.ɵɵtext(234);
    i0.ɵɵpipe(235, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(236, "div", 490);
    i0.ɵɵtext(237);
    i0.ɵɵpipe(238, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(239, "div", 491);
    i0.ɵɵtext(240);
    i0.ɵɵpipe(241, "translate");
    i0.ɵɵelementStart(242, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_242_listener() { i0.ɵɵrestoreView(_r798); const ctx_r818 = i0.ɵɵnextContext(3); return ctx_r818.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(243, "div", 490);
    i0.ɵɵtext(244);
    i0.ɵɵpipe(245, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(246, "div", 491);
    i0.ɵɵtext(247);
    i0.ɵɵpipe(248, "translate");
    i0.ɵɵelementStart(249, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_249_listener() { i0.ɵɵrestoreView(_r798); const ctx_r819 = i0.ɵɵnextContext(3); return ctx_r819.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(250, "div", 490);
    i0.ɵɵtext(251);
    i0.ɵɵpipe(252, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(253, "div", 490);
    i0.ɵɵtext(254);
    i0.ɵɵpipe(255, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(256, "div", 491);
    i0.ɵɵtext(257);
    i0.ɵɵpipe(258, "translate");
    i0.ɵɵelementStart(259, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_259_listener() { i0.ɵɵrestoreView(_r798); const ctx_r820 = i0.ɵɵnextContext(3); return ctx_r820.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(260, "div", 490);
    i0.ɵɵtext(261);
    i0.ɵɵpipe(262, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(263, "div", 490);
    i0.ɵɵtext(264);
    i0.ɵɵpipe(265, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(266, "div", 491);
    i0.ɵɵtext(267);
    i0.ɵɵpipe(268, "translate");
    i0.ɵɵelement(269, "br");
    i0.ɵɵtext(270);
    i0.ɵɵpipe(271, "translate");
    i0.ɵɵelementStart(272, "i", 492);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_10_Template_i_click_272_listener() { i0.ɵɵrestoreView(_r798); const ctx_r821 = i0.ɵɵnextContext(3); return ctx_r821.copyConfig(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(273, "div", 490);
    i0.ɵɵtext(274);
    i0.ɵɵpipe(275, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r764 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r764.authToken.length > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 114, "dashboard-lib.cmx-connector.add-edit-popup.configuration_steps"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 116, "dashboard-lib.cmx-connector.add-edit-popup.steps_1_3"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 118, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step1"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 120, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step2"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 122, "dashboard-lib.cmx-connector.add-edit-popup.configure_terminal"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "# configure terminal");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 124, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step3"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 126, "dashboard-lib.cmx-connector.add-edit-popup.config_iox"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config)# iox");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(30, 128, "dashboard-lib.cmx-connector.add-edit-popup.steps_4_5"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(33, 130, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step4"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(36, 132, "dashboard-lib.cmx-connector.add-edit-popup.config_vlan"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config)# interface Vlan <erspan-vlan-id>");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(40, 134, "dashboard-lib.cmx-connector.add-edit-popup.example_config_vlan"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(43, 136, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step5"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(46, 138, "dashboard-lib.cmx-connector.add-edit-popup.config_ipaddress"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(49, 140, "dashboard-lib.cmx-connector.add-edit-popup.config_if_exit"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-if)# ip address <erspan-ip> <erspan-subnet-mask> (config-if)# exit");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(53, 142, "dashboard-lib.cmx-connector.add-edit-popup.example_config_ipaddress"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(56, 144, "dashboard-lib.cmx-connector.add-edit-popup.step_6_desc"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(59, 146, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step6"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(62, 148, "dashboard-lib.cmx-connector.add-edit-popup.config_interface"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(65, 150, "dashboard-lib.cmx-connector.add-edit-popup.config_switchport"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(68, 152, "dashboard-lib.cmx-connector.add-edit-popup.config_if_exit"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config)# interface AppGigabitEthernet 1/0/1\n              (config-if)# switchport mode trunk\n              (config-if)# exit");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(72, 154, "dashboard-lib.cmx-connector.add-edit-popup.steps_7_11"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(75, 156, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step7"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(78, 158, "dashboard-lib.cmx-connector.add-edit-popup.config_monitor"), " ", i0.ɵɵpipeBind1(79, 160, "dashboard-lib.cmx-connector.add-edit-popup.config_erspan_source"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cbContent", "(config)# monitor session <monitor-session-id> type erspan-source");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(83, 162, "dashboard-lib.cmx-connector.add-edit-popup.example_erspan_source"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(86, 164, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step8"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(89, 166, "dashboard-lib.cmx-connector.add-edit-popup.config_mon_erspan"), " ", i0.ɵɵpipeBind1(90, 168, "dashboard-lib.cmx-connector.add-edit-popup.source_vlan"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cbContent", "(config-mon-erspan-src)# source vlan <source-vlan-id>");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(94, 170, "dashboard-lib.cmx-connector.add-edit-popup.example_source_valn"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(97, 172, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step9"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(100, 174, "dashboard-lib.cmx-connector.add-edit-popup.config_mon_erspan_src"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-mon-erspan-src)# destination");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(104, 176, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step10"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(107, 178, "dashboard-lib.cmx-connector.add-edit-popup.config_erspan_dst"), " ", i0.ɵɵpipeBind1(108, 180, "dashboard-lib.cmx-connector.add-edit-popup.config_erspan_id"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cbContent", "(config-mon-erspan-src-dst)# erspan-id <erspan-id>");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(112, 182, "dashboard-lib.cmx-connector.add-edit-popup.example_config_erspan_id"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(115, 184, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step11"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(118, 186, "dashboard-lib.cmx-connector.add-edit-popup.config_erspan_ipaddr"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-mon-erspan-src-dst)# ip address <erspan-dest-ip>");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(122, 188, "dashboard-lib.cmx-connector.add-edit-popup.example_config_erspan_ipaddr"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(125, 190, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step12"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(128, 192, "dashboard-lib.cmx-connector.add-edit-popup.config_erspan_origin_ip"), " ", i0.ɵɵpipeBind1(129, 194, "dashboard-lib.cmx-connector.add-edit-popup.config_origin_ip"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(132, 196, "dashboard-lib.cmx-connector.add-edit-popup.config_dst_exit"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(135, 198, "dashboard-lib.cmx-connector.add-edit-popup.config_src_exit"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-mon-erspan-src-dst)# origin ip address <erspan-origin-ip>\n                (config-mon-erspan-src-dst)# exit\n                (config-mon-erspan-src)# exit");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(139, 200, "dashboard-lib.cmx-connector.add-edit-popup.example_origin_ip"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(142, 202, "dashboard-lib.cmx-connector.add-edit-popup.steps_13_18"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(145, 204, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step13"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(148, 206, "dashboard-lib.cmx-connector.add-edit-popup.config_13_1"), " ", i0.ɵɵpipeBind1(149, 208, "dashboard-lib.cmx-connector.add-edit-popup.config_13_2"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cbContent", "(config)# app-hosting appid cisco_dnas_wired_iox_app");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(153, 210, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step14"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(156, 212, "dashboard-lib.cmx-connector.add-edit-popup.config_14_1"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(159, 214, "dashboard-lib.cmx-connector.add-edit-popup.config_14_2"), " ", i0.ɵɵpipeBind1(160, 216, "dashboard-lib.cmx-connector.add-edit-popup.config_14_3"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cbContent", "(config-app-hosting)# app-vnic AppGigabitEthernet trunk\n                (config-config-app-hosting-trunk)# vlan <dna-spaces-connector-vlan> guest-interface 0");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(164, 218, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step15"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate3(" ", i0.ɵɵpipeBind1(167, 220, "dashboard-lib.cmx-connector.add-edit-popup.config_15_1"), " ", i0.ɵɵpipeBind1(168, 222, "dashboard-lib.cmx-connector.add-edit-popup.config_15_2"), " ", i0.ɵɵpipeBind1(169, 224, "dashboard-lib.cmx-connector.add-edit-popup.config_15_3"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(172, 226, "dashboard-lib.cmx-connector.add-edit-popup.config_15_4"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", " (config-config-app-hosting-vlan-access-ip)# guest-ipaddress <iox-app-ip> netmask <iox-app-subnet-mask>\n              (config-config-app-hosting-vlan-access-ip)# exit");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(176, 228, "dashboard-lib.cmx-connector.add-edit-popup.example_config_15"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(179, 230, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step16"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(182, 232, "dashboard-lib.cmx-connector.add-edit-popup.config_16_1"), " ", i0.ɵɵpipeBind1(183, 234, "dashboard-lib.cmx-connector.add-edit-popup.config_16_2"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cbContent", "(config-config-app-hosting-trunk)# vlan <erspan-vlan-id> guest-interface 1\n              ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(187, 236, "dashboard-lib.cmx-connector.add-edit-popup.example_config_16"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(190, 238, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step17"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate3(" ", i0.ɵɵpipeBind1(193, 240, "dashboard-lib.cmx-connector.add-edit-popup.config_17_1"), " ", i0.ɵɵpipeBind1(194, 242, "dashboard-lib.cmx-connector.add-edit-popup.config_17_2"), " ", i0.ɵɵpipeBind1(195, 244, "dashboard-lib.cmx-connector.add-edit-popup.config_17_3"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(198, 246, "dashboard-lib.cmx-connector.add-edit-popup.config_17_4"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(201, 248, "dashboard-lib.cmx-connector.add-edit-popup.config_17_5"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-config-app-hosting-vlan-access-ip)# guest-ipaddress <erspan-dest-ip> netmask <erspan-dest-subnet-mask>\n              (config-config-app-hosting-vlan-access-ip)# exit\n              (config-config-app-hosting-trunk)# exit");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(205, 250, "dashboard-lib.cmx-connector.add-edit-popup.example_config_17"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(208, 252, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step18"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(211, 254, "dashboard-lib.cmx-connector.add-edit-popup.config_18_1"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-app-hosting)# app-default-gateway <dna-spaces-connector-vlan-gateway> guest-interface 0\n              ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(215, 256, "dashboard-lib.cmx-connector.add-edit-popup.example_config_18"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(218, 258, "dashboard-lib.cmx-connector.add-edit-popup.steps_19_24"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(221, 260, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step19"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(224, 262, "dashboard-lib.cmx-connector.add-edit-popup.config_19_1"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-app-hosting)# app-resource docker");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(228, 264, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step20"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(231, 266, "dashboard-lib.cmx-connector.add-edit-popup.config_20_1"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-app-hosting-docker)# run-opts 1 \"-e GRPC_SERVER_IP= <dna-spaces-connector-ip>\"");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(235, 268, "dashboard-lib.cmx-connector.add-edit-popup.example_config_20"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(238, 270, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step21"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(241, 272, "dashboard-lib.cmx-connector.add-edit-popup.config_21_1"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-app-hosting-docker)# run-opts 2 \"-e GRPC_SERVER_PORT=8003\"");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(245, 274, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step22"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(248, 276, "dashboard-lib.cmx-connector.add-edit-popup.config_22_1"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-app-hosting-docker)# run-opts 3 \"-e GRPC_SERVER_TOKEN=<stream-authentication-key>\"");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(252, 278, "dashboard-lib.cmx-connector.add-edit-popup.example_config_22"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(255, 280, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step23"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(258, 282, "dashboard-lib.cmx-connector.add-edit-popup.config_23_1"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-app-hosting-docker)# run-opts 4 \"-e APP_HOST_ID=<switch-base-mac-address>\"\n              ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(262, 284, "dashboard-lib.cmx-connector.add-edit-popup.example_config_23"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(265, 286, "dashboard-lib.cmx-connector.add-edit-popup.switch_config_step24"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(268, 288, "dashboard-lib.cmx-connector.add-edit-popup.config_24_1"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(271, 290, "dashboard-lib.cmx-connector.add-edit-popup.config_24_2"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cbContent", "(config-app-hosting-docker)# run-opts 5 \"-e APP_HOST_IP=<switch-ip-address>\"\n                (config-app-hosting-docker)# end");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(275, 292, "dashboard-lib.cmx-connector.add-edit-popup.example_config_24"), " ");
} }
function CmxConnectorComponent_div_0_div_10_div_11_div_4_tbody_22_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 112);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span", 118);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "span", 118);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵelementStart(8, "span", 118);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵelementStart(11, "span", 118);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td");
    i0.ɵɵelementStart(15, "span", 118);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const log_r827 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", log_r827.displayLabel, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", log_r827.status.split("_").join(" "), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", log_r827.message, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(13, 5, log_r827.initTime, "medium" || "--"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(17, 8, log_r827.finishTime, "medium" || "--"), " ");
} }
function CmxConnectorComponent_div_0_div_10_div_11_div_4_tbody_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_10_div_11_div_4_tbody_22_tr_1_Template, 18, 11, "tr", 111);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const stream_r823 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", stream_r823.value);
} }
function CmxConnectorComponent_div_0_div_10_div_11_div_4_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 485);
    i0.ɵɵtext(1, " No Data Found ");
    i0.ɵɵelementEnd();
} }
function CmxConnectorComponent_div_0_div_10_div_11_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h3");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 473);
    i0.ɵɵelementStart(4, "table", 474);
    i0.ɵɵelementStart(5, "thead");
    i0.ɵɵelementStart(6, "tr", 107);
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "th");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "th");
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, CmxConnectorComponent_div_0_div_10_div_11_div_4_tbody_22_Template, 2, 1, "tbody", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(23, CmxConnectorComponent_div_0_div_10_div_11_div_4_div_23_Template, 2, 0, "div", 476);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const stream_r823 = ctx.$implicit;
    const ctx_r822 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(stream_r823.label);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 8, "dashboard-lib.cmx-connector.add-edit-popup.action"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 10, "dashboard-lib.cmx-connector.add-edit-popup.status"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 12, "dashboard-lib.cmx-connector.add-edit-popup.message"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 14, "dashboard-lib.cmx-connector.add-edit-popup.start_time"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 16, "dashboard-lib.cmx-connector.add-edit-popup.finish_time"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", stream_r823.value.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r822.controllerStreams.length === 0);
} }
function CmxConnectorComponent_div_0_div_10_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r831 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 486);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_div_11_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r831); const ctx_r830 = i0.ɵɵnextContext(3); return ctx_r830.onControllerStreamLogsClick(""); });
    i0.ɵɵtext(2, "\u00D7");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "section");
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_10_div_11_div_4_Template, 24, 18, "div", 249);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r765 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r765.controllerLogs);
} }
function CmxConnectorComponent_div_0_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r833 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 418);
    i0.ɵɵelementStart(1, "div", 459);
    i0.ɵɵelementStart(2, "div", 245);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 246);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r833); const ctx_r832 = i0.ɵɵnextContext(2); return ctx_r832.hideManageServices(); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 460);
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_10_div_9_Template, 20, 19, "div", 58);
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_10_div_10_Template, 276, 294, "div", 58);
    i0.ɵɵtemplate(11, CmxConnectorComponent_div_0_div_10_div_11_Template, 5, 1, "div", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 413);
    i0.ɵɵelementStart(13, "button", 416);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_10_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r833); const ctx_r834 = i0.ɵɵnextContext(2); return ctx_r834.hideManageServices(); });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "dashboard-lib.cmx-connector.add-edit-popup.manage_iot_services"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", !ctx_r10.displayTokens && !ctx_r10.displayStreamLogs);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.displayTokens && !ctx_r10.displayStreamLogs);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.displayStreamLogs);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 7, "dashboard-lib.cmx-connector.button.cancel"), " ");
} }
function CmxConnectorComponent_div_0_div_11_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 508);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r839 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate3(" ", i0.ɵɵpipeBind1(2, 3, "dashboard-lib.cmx-connector.add-edit-popup.about_to"), " ", ctx_r839.confirmationEl.action, " ", i0.ɵɵpipeBind1(3, 5, "dashboard-lib.cmx-connector.add-edit-popup.the_stream"), " ");
} }
function CmxConnectorComponent_div_0_div_11_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 508);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.add-edit-popup.disable_services"), " ");
} }
function CmxConnectorComponent_div_0_div_11_div_3_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r844 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h4", 509);
    i0.ɵɵelementStart(2, "div", 510);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 511);
    i0.ɵɵelementStart(6, "span", 323);
    i0.ɵɵelementStart(7, "input", 512);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_11_div_3_div_4_Template_input_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r844); const ctx_r843 = i0.ɵɵnextContext(4); return ctx_r843.profileOptInType = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "label", 513);
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 323);
    i0.ɵɵelementStart(12, "input", 512);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_11_div_3_div_4_Template_input_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r844); const ctx_r845 = i0.ɵɵnextContext(4); return ctx_r845.profileOptInType = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "label", 513);
    i0.ɵɵelementStart(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r841 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, "dashboard-lib.cmx-connector.add-edit-popup.select_option"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r841.profileOptInType)("value", "ALL");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r841.confirmationEl.action === "enable" ? "Enable" : "Disable", " all profile(s)");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r841.profileOptInType)("value", "DEFAULT");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r841.confirmationEl.action === "enable" ? "Enable" : "Disable", " only default profile(s)");
} }
function CmxConnectorComponent_div_0_div_11_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r847 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 376);
    i0.ɵɵelementStart(2, "div", 322);
    i0.ɵɵelementStart(3, "span", 323);
    i0.ɵɵelementStart(4, "input", 514);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_11_div_3_div_5_Template_input_click_4_listener($event) { i0.ɵɵrestoreView(_r847); const ctx_r846 = i0.ɵɵnextContext(4); return ctx_r846.togglePersistConfDisable($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "label", 515);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 100);
    i0.ɵɵelementStart(7, "span", 516);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "br");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r842 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", ctx_r842.switchObj.saveConfig == "false");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 3, "dashboard-lib.cmx-connector.add-edit-popup.persist_conf"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 5, "dashboard-lib.cmx-connector.add-edit-popup.persist_conf_desc"), " ");
} }
function CmxConnectorComponent_div_0_div_11_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 247);
    i0.ɵɵelement(1, "img", 506);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_11_div_3_div_2_Template, 4, 7, "div", 507);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_11_div_3_div_3_Template, 3, 3, "div", 507);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_11_div_3_div_4_Template, 16, 9, "div", 58);
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_11_div_3_div_5_Template, 14, 7, "div", 58);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r835 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r835.showManageStreams);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r835.showSwitchesList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r835.confirmationEl.isController === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r835.currentConnector.version == "V3" && ctx_r835.confirmationEl.isController !== true);
} }
function CmxConnectorComponent_div_0_div_11_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 508);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r848 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate3(" ", i0.ɵɵpipeBind1(2, 3, "dashboard-lib.cmx-connector.add-edit-popup.about_to"), " ", ctx_r848.confirmationEl.action, " ", i0.ɵɵpipeBind1(3, 5, "dashboard-lib.cmx-connector.add-edit-popup.the_stream"), " ");
} }
function CmxConnectorComponent_div_0_div_11_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 508);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.add-edit-popup.disable_services"), " ");
} }
function CmxConnectorComponent_div_0_div_11_div_4_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r853 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h4", 509);
    i0.ɵɵelementStart(2, "div", 510);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelementStart(6, "div", 511);
    i0.ɵɵelementStart(7, "span", 323);
    i0.ɵɵelementStart(8, "input", 512);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_11_div_4_div_4_Template_input_ngModelChange_8_listener($event) { i0.ɵɵrestoreView(_r853); const ctx_r852 = i0.ɵɵnextContext(4); return ctx_r852.profileOptInType = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "label", 513);
    i0.ɵɵelementStart(10, "span");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span", 323);
    i0.ɵɵelementStart(13, "input", 512);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_11_div_4_div_4_Template_input_ngModelChange_13_listener($event) { i0.ɵɵrestoreView(_r853); const ctx_r854 = i0.ɵɵnextContext(4); return ctx_r854.profileOptInType = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "label", 513);
    i0.ɵɵelementStart(15, "span");
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r850 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, "dashboard-lib.cmx-connector.add-edit-popup.select_option"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r850.profileOptInType)("value", "ALL");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r850.confirmationEl.action === "enable" ? "Enable" : "Disable", " all profile(s)");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r850.profileOptInType)("value", "DEFAULT");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r850.confirmationEl.action === "enable" ? "Enable" : "Disable", " only default profile(s)");
} }
function CmxConnectorComponent_div_0_div_11_div_4_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r856 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 376);
    i0.ɵɵelementStart(2, "div", 322);
    i0.ɵɵelementStart(3, "span", 323);
    i0.ɵɵelementStart(4, "input", 514);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_11_div_4_div_5_Template_input_click_4_listener($event) { i0.ɵɵrestoreView(_r856); const ctx_r855 = i0.ɵɵnextContext(4); return ctx_r855.togglePersistConfDisable($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "label", 515);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 100);
    i0.ɵɵelementStart(7, "span", 516);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "br");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r851 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", ctx_r851.switchObj.saveConfig == "false");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 3, "dashboard-lib.cmx-connector.add-edit-popup.persist_conf"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 5, "dashboard-lib.cmx-connector.add-edit-popup.persist_conf_desc"), " ");
} }
function CmxConnectorComponent_div_0_div_11_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 247);
    i0.ɵɵelement(1, "img", 506);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_11_div_4_div_2_Template, 4, 7, "div", 507);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_11_div_4_div_3_Template, 3, 3, "div", 507);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_11_div_4_div_4_Template, 17, 9, "div", 58);
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_11_div_4_div_5_Template, 14, 7, "div", 58);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r836 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r836.showManageStreams);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r836.showSwitchesList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r836.confirmationEl.isController === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r836.currentConnector.version == "V3" && ctx_r836.confirmationEl.isController !== true);
} }
function CmxConnectorComponent_div_0_div_11_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r858 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 517);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_11_button_9_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r858); const ctx_r857 = i0.ɵɵnextContext(3); return ctx_r857.toggleStream(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.button.confirm"), " ");
} }
function CmxConnectorComponent_div_0_div_11_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r860 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 517);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_11_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r860); const ctx_r859 = i0.ɵɵnextContext(3); return ctx_r859.disableSwitch(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.button.confirm"), " ");
} }
function CmxConnectorComponent_div_0_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r862 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 502);
    i0.ɵɵelementStart(1, "div", 419);
    i0.ɵɵelementStart(2, "div", 503);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_11_div_3_Template, 6, 4, "div", 427);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_11_div_4_Template, 6, 4, "div", 427);
    i0.ɵɵelementStart(5, "div", 413);
    i0.ɵɵelementStart(6, "button", 504);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_11_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r862); const ctx_r861 = i0.ɵɵnextContext(2); return ctx_r861.closeStreamConfirmation(); });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_11_button_9_Template, 3, 3, "button", 505);
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_11_button_10_Template, 3, 3, "button", 505);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r11.fromWiredNetwork);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.fromWiredNetwork);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 5, "dashboard-lib.cmx-connector.button.cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r11.showManageStreams);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.showSwitchesList);
} }
function CmxConnectorComponent_div_0_div_12_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 285);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r863 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r863.configureSwitchError, " ");
} }
function CmxConnectorComponent_div_0_div_12_div_61_Template(rf, ctx) { if (rf & 1) {
    const _r869 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 301);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelementStart(5, "input", 527);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_12_div_61_Template_input_keyup_5_listener($event) { i0.ɵɵrestoreView(_r869); const ctx_r868 = i0.ɵɵnextContext(3); return ctx_r868.onKey($event); })("input", function CmxConnectorComponent_div_0_div_12_div_61_Template_input_input_5_listener($event) { i0.ɵɵrestoreView(_r869); const ctx_r870 = i0.ɵɵnextContext(3); return ctx_r870.switchObj.appIpAddress = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r864 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.iox_app_ip"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r864.switchObj.appIpAddress);
} }
function CmxConnectorComponent_div_0_div_12_div_62_Template(rf, ctx) { if (rf & 1) {
    const _r872 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 301);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelementStart(5, "input", 528);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_12_div_62_Template_input_keyup_5_listener($event) { i0.ɵɵrestoreView(_r872); const ctx_r871 = i0.ɵɵnextContext(3); return ctx_r871.onKey($event); })("input", function CmxConnectorComponent_div_0_div_12_div_62_Template_input_input_5_listener($event) { i0.ɵɵrestoreView(_r872); const ctx_r873 = i0.ɵɵnextContext(3); return ctx_r873.switchObj.appNetmask = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r865 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.iox_app_netmask"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r865.switchObj.appNetmask);
} }
function CmxConnectorComponent_div_0_div_12_div_63_Template(rf, ctx) { if (rf & 1) {
    const _r875 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 301);
    i0.ɵɵelementStart(1, "div", 281);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelementStart(5, "input", 529);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_12_div_63_Template_input_keyup_5_listener($event) { i0.ɵɵrestoreView(_r875); const ctx_r874 = i0.ɵɵnextContext(3); return ctx_r874.onKey($event); })("input", function CmxConnectorComponent_div_0_div_12_div_63_Template_input_input_5_listener($event) { i0.ɵɵrestoreView(_r875); const ctx_r876 = i0.ɵɵnextContext(3); return ctx_r876.switchObj.appGatewayAddress = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r866 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.cmx-connector.add-edit-popup.iox_app_gateway"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r866.switchObj.appGatewayAddress);
} }
function CmxConnectorComponent_div_0_div_12_div_64_Template(rf, ctx) { if (rf & 1) {
    const _r878 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 98);
    i0.ɵɵelementStart(2, "div", 322);
    i0.ɵɵelementStart(3, "span", 323);
    i0.ɵɵelementStart(4, "input", 514);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_12_div_64_Template_input_click_4_listener($event) { i0.ɵɵrestoreView(_r878); const ctx_r877 = i0.ɵɵnextContext(3); return ctx_r877.togglePersistConf($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "label", 515);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 100);
    i0.ɵɵelementStart(7, "div", 530);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 531);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r867 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", ctx_r867.switchObj.saveConfig === "false");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 3, "dashboard-lib.cmx-connector.add-edit-popup.persist_conf"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 5, "dashboard-lib.cmx-connector.add-edit-popup.persist_conf_desc"), " ");
} }
function CmxConnectorComponent_div_0_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r880 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 275);
    i0.ɵɵelementStart(1, "div", 276);
    i0.ɵɵelementStart(2, "div", 277);
    i0.ɵɵelementStart(3, "div", 245);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 246);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_12_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r880); const ctx_r879 = i0.ɵɵnextContext(2); return ctx_r879.toggleConfigureSwitchPopup(false, {}, 0); });
    i0.ɵɵtext(8, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 278);
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_12_div_10_Template, 2, 1, "div", 279);
    i0.ɵɵelementStart(11, "div", 292);
    i0.ɵɵelementStart(12, "div", 301);
    i0.ɵɵelementStart(13, "div", 281);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div");
    i0.ɵɵelementStart(17, "input", 518);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_12_Template_input_keyup_17_listener($event) { i0.ɵɵrestoreView(_r880); const ctx_r881 = i0.ɵɵnextContext(2); return ctx_r881.onKey($event); })("input", function CmxConnectorComponent_div_0_div_12_Template_input_input_17_listener($event) { i0.ɵɵrestoreView(_r880); const ctx_r882 = i0.ɵɵnextContext(2); return ctx_r882.switchObj.destSpanVlan = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 301);
    i0.ɵɵelementStart(19, "div", 281);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div");
    i0.ɵɵelementStart(23, "input", 519);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_12_Template_input_keyup_23_listener($event) { i0.ɵɵrestoreView(_r880); const ctx_r883 = i0.ɵɵnextContext(2); return ctx_r883.onKey($event); })("input", function CmxConnectorComponent_div_0_div_12_Template_input_input_23_listener($event) { i0.ɵɵrestoreView(_r880); const ctx_r884 = i0.ɵɵnextContext(2); return ctx_r884.switchObj.destSpanVlanIpAddress = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 301);
    i0.ɵɵelementStart(25, "div", 281);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div");
    i0.ɵɵelementStart(29, "input", 520);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_12_Template_input_keyup_29_listener($event) { i0.ɵɵrestoreView(_r880); const ctx_r885 = i0.ɵɵnextContext(2); return ctx_r885.onKey($event); })("input", function CmxConnectorComponent_div_0_div_12_Template_input_input_29_listener($event) { i0.ɵɵrestoreView(_r880); const ctx_r886 = i0.ɵɵnextContext(2); return ctx_r886.switchObj.sourceSpanVlanList = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "small");
    i0.ɵɵtext(31);
    i0.ɵɵpipe(32, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 301);
    i0.ɵɵelementStart(34, "div", 281);
    i0.ɵɵtext(35);
    i0.ɵɵpipe(36, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "div");
    i0.ɵɵelementStart(38, "input", 521);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_12_Template_input_keyup_38_listener($event) { i0.ɵɵrestoreView(_r880); const ctx_r887 = i0.ɵɵnextContext(2); return ctx_r887.onKey($event); })("input", function CmxConnectorComponent_div_0_div_12_Template_input_input_38_listener($event) { i0.ɵɵrestoreView(_r880); const ctx_r888 = i0.ɵɵnextContext(2); return ctx_r888.switchObj.monitorOriginIpAddress = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 301);
    i0.ɵɵelementStart(40, "div", 281);
    i0.ɵɵtext(41);
    i0.ɵɵpipe(42, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "div");
    i0.ɵɵelementStart(44, "input", 522);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_12_Template_input_keyup_44_listener($event) { i0.ɵɵrestoreView(_r880); const ctx_r889 = i0.ɵɵnextContext(2); return ctx_r889.onKey($event); })("input", function CmxConnectorComponent_div_0_div_12_Template_input_input_44_listener($event) { i0.ɵɵrestoreView(_r880); const ctx_r890 = i0.ɵɵnextContext(2); return ctx_r890.switchObj.appSpanIpAddress = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(45, "div", 301);
    i0.ɵɵelementStart(46, "div", 281);
    i0.ɵɵtext(47);
    i0.ɵɵpipe(48, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "div");
    i0.ɵɵelementStart(50, "input", 523);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_12_Template_input_keyup_50_listener($event) { i0.ɵɵrestoreView(_r880); const ctx_r891 = i0.ɵɵnextContext(2); return ctx_r891.onKey($event); })("input", function CmxConnectorComponent_div_0_div_12_Template_input_input_50_listener($event) { i0.ɵɵrestoreView(_r880); const ctx_r892 = i0.ɵɵnextContext(2); return ctx_r892.switchObj.appDnasVlan = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(51, "div");
    i0.ɵɵelementStart(52, "div", 376);
    i0.ɵɵelementStart(53, "div", 322);
    i0.ɵɵelementStart(54, "span", 323);
    i0.ɵɵelementStart(55, "input", 524);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_12_Template_input_click_55_listener($event) { i0.ɵɵrestoreView(_r880); const ctx_r893 = i0.ɵɵnextContext(2); return ctx_r893.toggleUseDhcp($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(56, "label", 525);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(57, "div", 100);
    i0.ɵɵelementStart(58, "span", 281);
    i0.ɵɵtext(59);
    i0.ɵɵpipe(60, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(61, CmxConnectorComponent_div_0_div_12_div_61_Template, 6, 4, "div", 526);
    i0.ɵɵtemplate(62, CmxConnectorComponent_div_0_div_12_div_62_Template, 6, 4, "div", 526);
    i0.ɵɵtemplate(63, CmxConnectorComponent_div_0_div_12_div_63_Template, 6, 4, "div", 526);
    i0.ɵɵtemplate(64, CmxConnectorComponent_div_0_div_12_div_64_Template, 13, 7, "div", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(65, "div", 413);
    i0.ɵɵelementStart(66, "button", 416);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_12_Template_button_click_66_listener() { i0.ɵɵrestoreView(_r880); const ctx_r894 = i0.ɵɵnextContext(2); return ctx_r894.toggleConfigureSwitchPopup(false, {}, 0); });
    i0.ɵɵtext(67);
    i0.ɵɵpipe(68, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(69, "button", 477);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_12_Template_button_click_69_listener() { i0.ɵɵrestoreView(_r880); const ctx_r895 = i0.ɵɵnextContext(2); return ctx_r895.configureSwitch(); });
    i0.ɵɵtext(70);
    i0.ɵɵpipe(71, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 23, "dashboard-lib.cmx-connector.add-edit-popup.configure_switch"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r12.configureSwitchError !== "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 25, "dashboard-lib.cmx-connector.add-edit-popup.destn_span_vlan"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r12.switchObj.destSpanVlan);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 27, "dashboard-lib.cmx-connector.add-edit-popup.span_vlan_ip"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r12.switchObj.destSpanVlanIpAddress);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 29, "dashboard-lib.cmx-connector.add-edit-popup.source_span_vlan"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r12.switchObj.sourceSpanVlanList);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(32, 31, "dashboard-lib.cmx-connector.add-edit-popup.use_comma"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(36, 33, "dashboard-lib.cmx-connector.add-edit-popup.monitor_span_ip"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r12.switchObj.monitorOriginIpAddress);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(42, 35, "dashboard-lib.cmx-connector.add-edit-popup.iox_span_ip"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r12.switchObj.appSpanIpAddress);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(48, 37, "dashboard-lib.cmx-connector.add-edit-popup.dna_vlan"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r12.switchObj.appDnasVlan);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("checked", ctx_r12.switchObj.useDhcp === "true");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(60, 39, "dashboard-lib.cmx-connector.add-edit-popup.use_dhcp"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r12.switchObj.useDhcp === "false");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.switchObj.useDhcp === "false");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.switchObj.useDhcp === "false");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.currentConnector.version == "V3");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(68, 41, "dashboard-lib.cmx-connector.button.cancel"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(71, 43, "dashboard-lib.cmx-connector.button.configure"), " ");
} }
function CmxConnectorComponent_div_0_div_13_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 285);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r896 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r896.cmxConnectorError, " ");
} }
function CmxConnectorComponent_div_0_div_13_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r902 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "input", 533);
    i0.ɵɵlistener("keyup", function CmxConnectorComponent_div_0_div_13_div_15_Template_input_keyup_1_listener($event) { i0.ɵɵrestoreView(_r902); const ctx_r901 = i0.ɵɵnextContext(3); return ctx_r901.onKey($event); })("input", function CmxConnectorComponent_div_0_div_13_div_15_Template_input_input_1_listener($event) { i0.ɵɵrestoreView(_r902); const ctx_r903 = i0.ɵɵnextContext(3); return ctx_r903.controllerObj.connectorName = $event.target ? $event.target["value"] : ""; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r897 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r897.controllerObj.connectorName);
} }
function CmxConnectorComponent_div_0_div_13_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r905 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 534);
    i0.ɵɵelementStart(2, "div", 294);
    i0.ɵɵelementStart(3, "div", 295);
    i0.ɵɵelementStart(4, "input", 535);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_13_div_21_Template_input_ngModelChange_4_listener() { i0.ɵɵrestoreView(_r905); const ctx_r904 = i0.ɵɵnextContext(3); return ctx_r904.connectorTypeChanged(1); })("ngModelChange", function CmxConnectorComponent_div_0_div_13_div_21_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r905); const ctx_r906 = i0.ɵɵnextContext(3); return ctx_r906.connectorVersion.value = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 297);
    i0.ɵɵelementStart(6, "span", 536);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 537);
    i0.ɵɵelementStart(9, "ul", 538);
    i0.ɵɵelementStart(10, "li");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "li");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "li");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "li");
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementStart(22, "a", 92);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div");
    i0.ɵɵelementStart(28, "span", 539);
    i0.ɵɵelementStart(29, "input", 540);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_13_div_21_Template_input_ngModelChange_29_listener($event) { i0.ɵɵrestoreView(_r905); const ctx_r907 = i0.ɵɵnextContext(3); return ctx_r907.selectDefaultService = $event; })("change", function CmxConnectorComponent_div_0_div_13_div_21_Template_input_change_29_listener($event) { i0.ɵɵrestoreView(_r905); const ctx_r908 = i0.ɵɵnextContext(3); return ctx_r908.defaultServiceCheck($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "label", 541);
    i0.ɵɵtext(31, "Enable Location Services ");
    i0.ɵɵelementStart(32, "span", 143);
    i0.ɵɵelement(33, "img", 542);
    i0.ɵɵelementStart(34, "span", 543);
    i0.ɵɵtext(35, " Location service is needed by most of application in Cisco Spaces. Deselecting could result into suboptimal experience in those applications ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(36, "div");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "div", 544);
    i0.ɵɵelementStart(38, "input", 545);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_13_div_21_Template_input_ngModelChange_38_listener() { i0.ɵɵrestoreView(_r905); const ctx_r909 = i0.ɵɵnextContext(3); return ctx_r909.connectorTypeChanged(0); })("ngModelChange", function CmxConnectorComponent_div_0_div_13_div_21_Template_input_ngModelChange_38_listener($event) { i0.ɵɵrestoreView(_r905); const ctx_r910 = i0.ɵɵnextContext(3); return ctx_r910.connectorVersion.value = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "label", 297);
    i0.ɵɵelementStart(40, "span", 536);
    i0.ɵɵtext(41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div");
    i0.ɵɵelementStart(43, "ul", 546);
    i0.ɵɵelementStart(44, "li");
    i0.ɵɵtext(45);
    i0.ɵɵpipe(46, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "li");
    i0.ɵɵtext(48);
    i0.ɵɵpipe(49, "translate");
    i0.ɵɵelementStart(50, "a", 92);
    i0.ɵɵtext(51);
    i0.ɵɵpipe(52, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r898 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r898.connectorVersion.value);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r898.connectorVersions[1].name, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 17, "dashboard-lib.spaces-connector.create-connector.connector-version.version-3-desc-1"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 19, "dashboard-lib.spaces-connector.create-connector.connector-version.version-3-desc-2"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 21, "dashboard-lib.spaces-connector.create-connector.connector-version.version-3-desc-3"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 23, "dashboard-lib.spaces-connector.create-connector.connector-version.version-3-desc-4"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r898.connectorConfigureGuide, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 25, "dashboard-lib.spaces-connector.create-connector.connector-version.config-guide"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 27, "dashboard-lib.spaces-connector.create-connector.connector-version.more-detail"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r898.selectDefaultService)("checked", ctx_r898.selectDefaultService);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngModel", ctx_r898.connectorVersion.value);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r898.connectorVersions[0].name);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(46, 29, "dashboard-lib.spaces-connector.create-connector.connector-version.version-2-desc"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(49, 31, "dashboard-lib.spaces-connector.create-connector.connector-version.version-2-desc1"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r898.connectorMigrationGuide, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(52, 33, "dashboard-lib.spaces-connector.create-connector.connector-version.version_readmore"), " ");
} }
function CmxConnectorComponent_div_0_div_13_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 547);
} }
function CmxConnectorComponent_div_0_div_13_button_27_Template(rf, ctx) { if (rf & 1) {
    const _r912 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 417);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_13_button_27_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r912); const ctx_r911 = i0.ɵɵnextContext(3); return ctx_r911.addCMXConnector(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r900 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", !ctx_r900.toggleSaveButton() ? "disabled" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.cmx-connector.button.save"), " ");
} }
function CmxConnectorComponent_div_0_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r914 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 275);
    i0.ɵɵelementStart(1, "div", 276);
    i0.ɵɵelementStart(2, "div", 277);
    i0.ɵɵelementStart(3, "div", 245);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 246);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_13_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r914); const ctx_r913 = i0.ɵɵnextContext(2); return ctx_r913.closeCreateConnectorPopup(); });
    i0.ɵɵtext(8, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 278);
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_13_div_10_Template, 2, 1, "div", 279);
    i0.ɵɵelementStart(11, "div", 280);
    i0.ɵɵelementStart(12, "div", 281);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, CmxConnectorComponent_div_0_div_13_div_15_Template, 2, 1, "div", 58);
    i0.ɵɵelementStart(16, "input", 282);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_13_Template_input_ngModelChange_16_listener($event) { i0.ɵɵrestoreView(_r914); const ctx_r915 = i0.ɵɵnextContext(2); return ctx_r915.controllerObj.connectorId = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 280);
    i0.ɵɵelementStart(18, "div", 281);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(21, CmxConnectorComponent_div_0_div_13_div_21_Template, 53, 35, "div", 58);
    i0.ɵɵtemplate(22, CmxConnectorComponent_div_0_div_13_div_22_Template, 1, 0, "div", 532);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 413);
    i0.ɵɵelementStart(24, "button", 416);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_13_Template_button_click_24_listener() { i0.ɵɵrestoreView(_r914); const ctx_r916 = i0.ɵɵnextContext(2); return ctx_r916.closeCreateConnectorPopup(); });
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, CmxConnectorComponent_div_0_div_13_button_27_Template, 3, 4, "button", 414);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 10, "dashboard-lib.cmx-connector.add-edit-popup.create_connector"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r13.cmxConnectorError !== "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 12, "dashboard-lib.cmx-connector.add-edit-popup.spaces-connector-name"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.editControllerPopup === false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r13.controllerObj.connectorId);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 14, "dashboard-lib.cmx-connector.add-edit-popup.connector-version"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.editControllerPopup === false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.editControllerPopup === false && ctx_r13.isConnectorAvailable === false);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 16, "dashboard-lib.cmx-connector.button.cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.isConnectorAvailable === false);
} }
function CmxConnectorComponent_div_0_div_14_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 285);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r917 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r917.switchModuleError, " ");
} }
function CmxConnectorComponent_div_0_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r919 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 548);
    i0.ɵɵelementStart(1, "div", 549);
    i0.ɵɵelementStart(2, "div", 245);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 246);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_14_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r919); const ctx_r918 = i0.ɵɵnextContext(2); return ctx_r918.closeAddSwitch(); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 247);
    i0.ɵɵelementStart(9, "div", 550);
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_14_div_10_Template, 2, 1, "div", 279);
    i0.ɵɵelementStart(11, "div", 551);
    i0.ɵɵelementStart(12, "div", 280);
    i0.ɵɵelementStart(13, "div", 281);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div");
    i0.ɵɵelementStart(17, "input", 552);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_14_Template_input_ngModelChange_17_listener($event) { i0.ɵɵrestoreView(_r919); const ctx_r920 = i0.ɵɵnextContext(2); return ctx_r920.switchObject.name = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 280);
    i0.ɵɵelementStart(19, "div", 281);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div");
    i0.ɵɵelementStart(23, "input", 553);
    i0.ɵɵlistener("blur", function CmxConnectorComponent_div_0_div_14_Template_input_blur_23_listener() { i0.ɵɵrestoreView(_r919); const ctx_r921 = i0.ɵɵnextContext(2); return ctx_r921.validateIPAddress(); })("ngModelChange", function CmxConnectorComponent_div_0_div_14_Template_input_ngModelChange_23_listener($event) { i0.ɵɵrestoreView(_r919); const ctx_r922 = i0.ɵɵnextContext(2); return ctx_r922.switchObject.switchIp = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 280);
    i0.ɵɵelementStart(25, "div", 281);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div");
    i0.ɵɵelementStart(29, "input", 554);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_14_Template_input_ngModelChange_29_listener($event) { i0.ɵɵrestoreView(_r919); const ctx_r923 = i0.ɵɵnextContext(2); return ctx_r923.switchObject.login.username = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 280);
    i0.ɵɵelementStart(31, "div", 281);
    i0.ɵɵtext(32);
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 555);
    i0.ɵɵelementStart(35, "input", 556);
    i0.ɵɵlistener("ngModelChange", function CmxConnectorComponent_div_0_div_14_Template_input_ngModelChange_35_listener($event) { i0.ɵɵrestoreView(_r919); const ctx_r924 = i0.ɵɵnextContext(2); return ctx_r924.switchObject.login.password = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 557);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_14_Template_div_click_36_listener() { i0.ɵɵrestoreView(_r919); const ctx_r925 = i0.ɵɵnextContext(2); return ctx_r925.togglePasswordDisplay(); });
    i0.ɵɵelementStart(37, "span");
    i0.ɵɵelement(38, "img", 558);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(39, "span", 559);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 413);
    i0.ɵɵelementStart(41, "button", 345);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_14_Template_button_click_41_listener() { i0.ɵɵrestoreView(_r919); const ctx_r926 = i0.ɵɵnextContext(2); return ctx_r926.addSwitchToConnector(); });
    i0.ɵɵtext(42);
    i0.ɵɵpipe(43, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 18, "dashboard-lib.cmx-connector.add-edit-popup.add_switch"));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r14.switchModuleError !== "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r14.switchObject.connectorId === null ? "disableOverlay" : "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 20, "dashboard-lib.cmx-connector.add-edit-popup.switch_name"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r14.switchObject.name)("value", ctx_r14.switchObject.name);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 22, "dashboard-lib.cmx-connector.add-edit-popup.switch_ip"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r14.switchObject.switchIp)("value", ctx_r14.switchObject.switchIp);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 24, "dashboard-lib.cmx-connector.add-edit-popup.netconfig_username"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r14.switchObject.login.username)("value", ctx_r14.switchObject.login.username);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(33, 26, "dashboard-lib.cmx-connector.add-edit-popup.netconfig_password"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r14.switchObject.login.password)("value", ctx_r14.switchObject.login.password);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("innerHTML", ctx_r14.showPassword ? "HIDE" : "SHOW", i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r14.switchObject.connectorId === null || ctx_r14.switchObject.login.username === null || ctx_r14.switchObject.login.password === null ? "disableOverlay" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(43, 28, "dashboard-lib.cmx-connector.button.save-close"), " ");
} }
function CmxConnectorComponent_div_0_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r928 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 560);
    i0.ɵɵelementStart(1, "div", 561);
    i0.ɵɵelementStart(2, "div", 562);
    i0.ɵɵelementStart(3, "div", 563);
    i0.ɵɵelement(4, "img", 564);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 565);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_15_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r928); const ctx_r927 = i0.ɵɵnextContext(2); return ctx_r927.showHideConfirmation(false); });
    i0.ɵɵtext(6, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 566);
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵelementStart(9, "div");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 567);
    i0.ɵɵelementStart(13, "div", 568);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_15_Template_div_click_13_listener() { i0.ɵɵrestoreView(_r928); const ctx_r929 = i0.ɵɵnextContext(2); return ctx_r929.deleteSwitch(); });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 569);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_15_Template_div_click_16_listener() { i0.ɵɵrestoreView(_r928); const ctx_r930 = i0.ɵɵnextContext(2); return ctx_r930.showHideConfirmation(false); });
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(11, 4, "dashboard-lib.cmx-connector.add-edit-popup.warning-delete"), " '", ctx_r15.switchToDelete.name, "'? ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 6, "dashboard-lib.cmx-connector.button.delete-switch"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 8, "dashboard-lib.cmx-connector.button.cancel"), " ");
} }
function CmxConnectorComponent_div_0_div_16_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.add-edit-popup.sure-upgrade-connector-v3"));
} }
function CmxConnectorComponent_div_0_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r933 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 452);
    i0.ɵɵelement(1, "div", 419);
    i0.ɵɵelementStart(2, "div", 570);
    i0.ɵɵelementStart(3, "div", 247);
    i0.ɵɵelement(4, "img", 454);
    i0.ɵɵelementStart(5, "h4", 455);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelement(8, "br");
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_16_span_9_Template, 3, 3, "span", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 413);
    i0.ɵɵelementStart(11, "button", 456);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_16_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r933); const ctx_r932 = i0.ɵɵnextContext(2); return ctx_r932.doUpgradeConnector(); });
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "button", 416);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_16_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r933); const ctx_r934 = i0.ɵɵnextContext(2); return ctx_r934.closeUpgradeConnector(); });
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 4, "dashboard-lib.cmx-connector.add-edit-popup.sure-upgrade-connector"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r16.connectorVersionToUpgrade == "V3");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 6, "dashboard-lib.cmx-connector.button.upgrade"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 8, "dashboard-lib.cmx-connector.button.cancel"), " ");
} }
function CmxConnectorComponent_div_0_div_17_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 577);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r935 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r935.thisController.connectionStatus);
} }
function CmxConnectorComponent_div_0_div_17_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r936 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r936.thisController.connectionStatus);
} }
function CmxConnectorComponent_div_0_div_17_div_16_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 581);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.summary.label.inactive"), "");
} }
function CmxConnectorComponent_div_0_div_17_div_16_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 582);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "dashboard-lib.cmx-connector.summary.label.active"));
} }
function CmxConnectorComponent_div_0_div_17_div_16_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 582);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const report_r938 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(report_r938.status);
} }
function CmxConnectorComponent_div_0_div_17_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 578);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_17_div_16_span_5_Template, 3, 3, "span", 579);
    i0.ɵɵtemplate(6, CmxConnectorComponent_div_0_div_17_div_16_span_6_Template, 3, 3, "span", 580);
    i0.ɵɵtemplate(7, CmxConnectorComponent_div_0_div_17_div_16_span_7_Template, 2, 1, "span", 580);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const report_r938 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(report_r938.serviceName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", report_r938.status == "INACTIVE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", report_r938.status == "ACTIVE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", report_r938.status !== "INACTIVE" && report_r938.status !== "ACTIVE");
} }
function CmxConnectorComponent_div_0_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r944 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 571);
    i0.ɵɵelementStart(1, "div", 277);
    i0.ɵɵelementStart(2, "div", 245);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 246);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_17_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r944); const ctx_r943 = i0.ɵɵnextContext(2); return ctx_r943.closeServiceStatus(); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 572);
    i0.ɵɵelementStart(9, "div", 573);
    i0.ɵɵelementStart(10, "span");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, CmxConnectorComponent_div_0_div_17_span_13_Template, 2, 1, "span", 574);
    i0.ɵɵtemplate(14, CmxConnectorComponent_div_0_div_17_span_14_Template, 2, 1, "span", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 575);
    i0.ɵɵtemplate(16, CmxConnectorComponent_div_0_div_17_div_16_Template, 8, 4, "div", 576);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 413);
    i0.ɵɵelementStart(18, "button", 416);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_17_Template_button_click_18_listener() { i0.ɵɵrestoreView(_r944); const ctx_r945 = i0.ɵɵnextContext(2); return ctx_r945.closeServiceStatus(); });
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(5, 7, "dashboard-lib.cmx-connector.table-header.status"), ": ", ctx_r17.thisController.name, "");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(12, 9, "dashboard-lib.cmx-connector.add-edit-popup.service"), ": ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r17.thisController.connectionStatus == "Degraded");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.thisController.connectionStatus != "Degraded");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r17.reportMap);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 11, "dashboard-lib.cmx-connector.button.cancel"), " ");
} }
function CmxConnectorComponent_div_0_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r947 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 451);
    i0.ɵɵelementStart(1, "div", 277);
    i0.ɵɵelementStart(2, "div", 245);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 246);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_18_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r947); const ctx_r946 = i0.ɵɵnextContext(2); return ctx_r946.closeServiceUpgrade(); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 583);
    i0.ɵɵelementStart(9, "div", 584);
    i0.ɵɵelementStart(10, "span", 585);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 586);
    i0.ɵɵelementStart(16, "span", 587);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(19, "br");
    i0.ɵɵelementStart(20, "div", 588);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(22, "div");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 413);
    i0.ɵɵelementStart(24, "button", 416);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_18_Template_button_click_24_listener() { i0.ɵɵrestoreView(_r947); const ctx_r948 = i0.ɵɵnextContext(2); return ctx_r948.closeServiceUpgrade(); });
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", ctx_r18.thisService.serviceName, "- ", i0.ɵɵpipeBind1(5, 7, "dashboard-lib.cmx-connector.add-edit-popup.upgarde-status"), "");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(12, 9, "dashboard-lib.cmx-connector.add-edit-popup.upgarde-status"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r18.thisService.connectorUpgradeStatus.upgradeStatus);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(18, 11, "dashboard-lib.cmx-connector.add-edit-popup.message"), ":");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r18.thisService.connectorUpgradeStatus.upgradeMessage, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 13, "dashboard-lib.cmx-connector.button.cancel"), " ");
} }
function CmxConnectorComponent_div_0_app_token_generation_v3_19_Template(rf, ctx) { if (rf & 1) {
    const _r950 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-token-generation-v3", 589);
    i0.ɵɵlistener("hideAccessToken", function CmxConnectorComponent_div_0_app_token_generation_v3_19_Template_app_token_generation_v3_hideAccessToken_0_listener() { i0.ɵɵrestoreView(_r950); const ctx_r949 = i0.ɵɵnextContext(2); return ctx_r949.hideAccessToken(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", "Token")("idParam", "connectorId")("url", "/token")("accessTokenFlag", ctx_r19.showAccessTokenPopupV3)("id", ctx_r19.selectedId);
} }
function CmxConnectorComponent_div_0_lib_token_generation_20_Template(rf, ctx) { if (rf & 1) {
    const _r952 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-token-generation", 590);
    i0.ɵɵlistener("hideAccessToken", function CmxConnectorComponent_div_0_lib_token_generation_20_Template_lib_token_generation_hideAccessToken_0_listener() { i0.ɵɵrestoreView(_r952); const ctx_r951 = i0.ɵɵnextContext(2); return ctx_r951.hideAccessToken(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("idParam", "connectorId")("url", ctx_r20.url)("title", ctx_r20.tokenTitle)("accessTokenFlag", ctx_r20.showAccessTokenPopup)("id", ctx_r20.selectedId);
} }
function CmxConnectorComponent_div_0_lib_connector_troubleshoot_22_Template(rf, ctx) { if (rf & 1) {
    const _r954 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-connector-troubleshoot", 591);
    i0.ɵɵlistener("refreshConnectorList", function CmxConnectorComponent_div_0_lib_connector_troubleshoot_22_Template_lib_connector_troubleshoot_refreshConnectorList_0_listener() { i0.ɵɵrestoreView(_r954); const ctx_r953 = i0.ɵɵnextContext(2); return ctx_r953.getCMXConnectors(); })("emitClosePopup", function CmxConnectorComponent_div_0_lib_connector_troubleshoot_22_Template_lib_connector_troubleshoot_emitClosePopup_0_listener() { i0.ɵɵrestoreView(_r954); const ctx_r955 = i0.ɵɵnextContext(2); return ctx_r955.openManageConnectorPopup(false, ctx_r955.selectedConnector); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("showManageConnectorPopup", ctx_r21.showManageConnectorPopup)("selectedConnector", ctx_r21.selectedConnector)("serviceList", ctx_r21.serviceList)("instancesNodeIds", ctx_r21.instancesNodeIds)("title", "Troubleshoot Connector")("serviceNameDisplayName", ctx_r21.serviceNameDisplayName);
} }
function CmxConnectorComponent_div_0_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r957 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 452);
    i0.ɵɵelement(1, "div", 419);
    i0.ɵɵelementStart(2, "div", 453);
    i0.ɵɵelementStart(3, "div", 247);
    i0.ɵɵelement(4, "img", 454);
    i0.ɵɵelementStart(5, "h4", 455);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 413);
    i0.ɵɵelementStart(9, "button", 456);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_23_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r957); const ctx_r956 = i0.ɵɵnextContext(2); return ctx_r956.upgradeConnector(ctx_r956.connectorToUpgrade); });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 416);
    i0.ɵɵlistener("click", function CmxConnectorComponent_div_0_div_23_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r957); const ctx_r958 = i0.ɵɵnextContext(2); return ctx_r958.confirmV2Upgrade(false, ctx_r958.connectorToUpgrade); });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(7, 4, "dashboard-lib.cmx-connector.add-edit-popup.warning-upgrade-connector"), " ", ctx_r22.connectorToUpgrade.name, "? ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 6, "dashboard-lib.cmx-connector.button.confirm"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 8, "dashboard-lib.cmx-connector.button.cancel"), " ");
} }
function CmxConnectorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r960 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, CmxConnectorComponent_div_0_div_1_Template, 33, 24, "div", 2);
    i0.ɵɵtemplate(2, CmxConnectorComponent_div_0_div_2_Template, 20, 11, "div", 3);
    i0.ɵɵtemplate(3, CmxConnectorComponent_div_0_div_3_Template, 20, 12, "div", 4);
    i0.ɵɵtemplate(4, CmxConnectorComponent_div_0_div_4_Template, 10, 5, "div", 5);
    i0.ɵɵtemplate(5, CmxConnectorComponent_div_0_div_5_Template, 10, 5, "div", 6);
    i0.ɵɵtemplate(6, CmxConnectorComponent_div_0_div_6_Template, 59, 39, "div", 7);
    i0.ɵɵtemplate(7, CmxConnectorComponent_div_0_div_7_Template, 15, 10, "div", 8);
    i0.ɵɵtemplate(8, CmxConnectorComponent_div_0_div_8_Template, 12, 6, "div", 8);
    i0.ɵɵtemplate(9, CmxConnectorComponent_div_0_div_9_Template, 16, 9, "div", 4);
    i0.ɵɵtemplate(10, CmxConnectorComponent_div_0_div_10_Template, 16, 9, "div", 4);
    i0.ɵɵtemplate(11, CmxConnectorComponent_div_0_div_11_Template, 11, 7, "div", 9);
    i0.ɵɵtemplate(12, CmxConnectorComponent_div_0_div_12_Template, 72, 45, "div", 3);
    i0.ɵɵtemplate(13, CmxConnectorComponent_div_0_div_13_Template, 28, 18, "div", 3);
    i0.ɵɵtemplate(14, CmxConnectorComponent_div_0_div_14_Template, 44, 30, "div", 10);
    i0.ɵɵtemplate(15, CmxConnectorComponent_div_0_div_15_Template, 19, 10, "div", 11);
    i0.ɵɵtemplate(16, CmxConnectorComponent_div_0_div_16_Template, 17, 10, "div", 8);
    i0.ɵɵtemplate(17, CmxConnectorComponent_div_0_div_17_Template, 21, 13, "div", 12);
    i0.ɵɵtemplate(18, CmxConnectorComponent_div_0_div_18_Template, 27, 15, "div", 7);
    i0.ɵɵtemplate(19, CmxConnectorComponent_div_0_app_token_generation_v3_19_Template, 1, 5, "app-token-generation-v3", 13);
    i0.ɵɵtemplate(20, CmxConnectorComponent_div_0_lib_token_generation_20_Template, 1, 5, "lib-token-generation", 14);
    i0.ɵɵelementStart(21, "lib-migrate-connector", 15);
    i0.ɵɵlistener("closeMigratePopup", function CmxConnectorComponent_div_0_Template_lib_migrate_connector_closeMigratePopup_21_listener() { i0.ɵɵrestoreView(_r960); const ctx_r959 = i0.ɵɵnextContext(); return ctx_r959.hideMigrateScreen(); })("doneMigratePopup", function CmxConnectorComponent_div_0_Template_lib_migrate_connector_doneMigratePopup_21_listener($event) { i0.ɵɵrestoreView(_r960); const ctx_r961 = i0.ɵɵnextContext(); return ctx_r961.completeMigration($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, CmxConnectorComponent_div_0_lib_connector_troubleshoot_22_Template, 1, 6, "lib-connector-troubleshoot", 16);
    i0.ɵɵtemplate(23, CmxConnectorComponent_div_0_div_23_Template, 15, 10, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showConnectors === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showCMXConnectorPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showRenameConnectorPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showConnectorDetailsPopup === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showControllerDetailsPopup === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showDeleteControllerConfirmPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showDeleteConnectorConfirmPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showManageStreams);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showSwitchesList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.confirmationEl.display);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showConfigureSwitchPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showCreateConnectorPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showAddSwitchPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.confirmationVisible);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.confirmUpgrade);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showServiceControllerStatus === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showServiceUpgradePopup === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showAccessTokenPopupV3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showAccessTokenPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showMigratecomponent", ctx_r0.showMigratecomponent)("connector", ctx_r0.connectorToMigrate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showManageConnectorPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showV2UpgradePopup);
} }
const moment$i = moment_;
class CmxConnectorComponent {
    constructor(authService, dataService, cmxConnectorsService, locationService, interactionService, router, cmxOnPremService, translate) {
        this.authService = authService;
        this.dataService = dataService;
        this.cmxConnectorsService = cmxConnectorsService;
        this.locationService = locationService;
        this.interactionService = interactionService;
        this.router = router;
        this.cmxOnPremService = cmxOnPremService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.showCMXConnectorPopup = false;
        this.showDeleteControllerConfirmPopup = false;
        this.showDeleteConnectorConfirmPopup = false;
        this.cmxConnectorList = [];
        this.cmxConnectorListV2 = []; //C3 IOT
        this.controllerList = [];
        this.controllerObj = {};
        this.cmxConnectorError = "";
        this.cmxConnectorListLoaded = false;
        this.cmxConnectorDetailsLoaded = false;
        this.cmxControllerDetailsLoaded = false;
        this.showControllerTypeList = false;
        this.controllerTypeList = ["WLC", "ewlc"];
        this.showSNMPVersionList = false;
        this.snmpVersionList = ["v2c", "v3"];
        this.showPrivacyProtocolList = false;
        this.privacyProtocolList = ['CBC-DES', 'CFB-AES-128', 'CFB-AES-192', 'CFB-AES-256', 'None'];
        this.showAuthProtocolList = false;
        this.authProtocolList = ['HMAC-MD5', 'HMAC-SHA', 'None'];
        this.showAccessTokenPopup = false;
        this.showAccessTokenPopupV3 = false;
        this.showConnectorDetailsPopup = false;
        this.showControllerDetailsPopup = false;
        this.showManageConnectorPopup = false;
        this.accessTokenEmail = "";
        this.accessTokenPassword = "";
        this.accessTokenError = "";
        this.accessCodeValue = "";
        this.showAccessCodeString = false;
        this.showConnectors = true;
        this.isConnectorAvailable = false;
        this.wlcIps = [];
        this.editControllerPopup = false;
        this.popupTitle = "";
        this.showConnnectorList = false;
        this.showRenameConnectorPopup = false;
        this.controllerListLoaded = false;
        this.showMoreOptions = false;
        this.selectedCustomerName = "";
        this.disableInstanceFilter = false;
        this.connectorDetailsChart = new LineChart();
        this.showLoaderChartLoader = true;
        this.selectedId = "";
        this.url = "";
        this.payloadAttr = "";
        this.tokenTitle = "";
        this.noIPAddressBanner = false;
        this.connectorDetailsD3Chart = [];
        this.ewlcCommandsList = [];
        this.ewlcMessages = [];
        // Pagination
        this.page = 1;
        this.limit = 10;
        this.now = null;
        this.connectorToBeDeleted = null;
        this.controllerToBeDeleted = null;
        this.currentConnectorItems = null;
        this.connectorList_searched = null;
        this.currentControllerItems = null;
        this.currentControllerItemsV2 = null;
        this.controllerList_searched = null;
        this.controllerList_searchedV2 = null;
        this.controllerStream_searched = null;
        this.fromHomePageSetup = false;
        this.showSwitchesList = false;
        this.dateStrings = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ];
        this.timeStrings = [
            "12:00",
            "1:00",
            "2:00",
            "3:00",
            "4:00",
            "5:00",
            "6:00",
            "7:00",
            "8:00",
            "9:00",
            "10:00",
            "11:00"
        ];
        this.amPmStrings = ["am", "pm"];
        this.chartOptions = new ChartOptions();
        // properties for test connectivity results
        this.displayTaskStatus = "";
        this.status = {
            IN_PROGRESS: "warning",
            COMPLETED: "success",
            TIMED_OUT: "error",
            ERROR_COULDNT_PROCESS: "error"
        };
        this.taskStatus = {
            IN_PROGRESS: "Connectivity test in progress",
            COMPLETED: "Connectivity test completed",
            TIMED_OUT: "Connectivity test timed out",
            ERROR_COULDNT_PROCESS: "Failed to process the test request"
        };
        this.showSpinner = false;
        this.showV3TestConnectivityStatus = false;
        this.displayTestConnectivity = false;
        this.connectivityMessages = [];
        this.snmpReadOnlyMsg = "";
        this.showManageStreams = false;
        this.displayTokens = false;
        this.tooltips = {
            netconfuser: new Tooltip()
                .setHTML('<div><div class="dynamic-tooltip-header"> Netconf username</div><div class="dynamic-tooltip-desc">Steps to get netconf username</div></div>')
                .setPosition(POSITION.BOTTOM_MIDDLE),
            netconfpassword: new Tooltip()
                .setHTML('<div><div class="dynamic-tooltip-header"> Netconf password</div><div class="dynamic-tooltip-desc">Steps to get netconf password</div></div>')
                .setPosition(POSITION.BOTTOM_MIDDLE)
        };
        this.wlcConfigType = "";
        // let us know which page we are in connector or controller
        this.configPage = "";
        // Manage Streams
        this.certificate = "";
        this.authToken = "";
        this.configOperationName = "";
        this.configurableState = "";
        this.configOperationStatus = "";
        this.controllerStreams = [];
        this.ewlcInterval = null;
        this.switchInterval = null;
        this.toggleConfigStatusflag = false;
        this.configStatusTimeout = null;
        this.enableControllerStreamLogs = [];
        this.disableControllerStreamLogs = [];
        this.displayStreamLogs = false;
        this.toggleLogsTable = true;
        this.controllerLogs = [
            { label: "Enable Stream Logs", value: [] },
            { label: "Disable Stream Logs", value: [] }
        ];
        // IoT Access
        this.hasIoTAccess = false;
        // validations
        this.regex = {
            netconfUsername: {
                error: "Netconf User name consists of 1-128 characters, alphanumeric,-,_are only allowed",
                expression: /^[^\?\:\s]*$/
            },
            username: {
                error: "User name consists of 1-128 characters, alphanumeric,-,_are only allowed",
                expression: /^[^\?\:\s]*$/
            },
            controllerIp: {
                expression: /^((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))$/
                /*/^(?:(?:2[0-4]\d|25[0-5]|1\d{2}|[1-9]?\d)\.){3}(?:2[0-4]\d|25[0-5]|1\d{2}|[1-9]?\d)$/*/ ,
                error: "Controller IP is not valid"
            },
            name: {
                expression: /^[0-9A-Za-z._-]+$/,
                error: "Controller name consists of 1-128 characters, alphanumeric, -, _, . are only allowed"
            }
        };
        this.netconfUsername_error = "";
        this.controllerIp_error = "";
        this.name_error = "";
        this.confirmationEl = {
            display: false,
            action: null,
            selectedController: {},
            isController: true
        };
        this.profileOptInType = 'ALL';
        // wired network - configure switch
        this.fromWiredNetwork = false;
        this.showConfigureSwitchPopup = false;
        this.configureSwitchError = "";
        this.switchObj = {};
        this.switchObjTemp = {};
        this.selectedSwitchID = null;
        this.switchStreamInfo = []; // 9-5
        this.infoObj = {};
        this.instanceNodeIds = [];
        this.showControllers = new EventEmitter();
        this.showSwitchList = false;
        this.pageFrom = "spacesConnector";
        this.actionType = "connectorList";
        this.modalTitle = "";
        this.showAdvancedSettings = false;
        this.showConnectorDetails = false;
        this.cmxConnectorServices = [];
        //controllerList : any =[];
        this.cmxConnectorSwitches = [];
        this.currentConnector = {};
        //C3
        //noServiceAdded = true;
        this.showV2UpgradePopup = false;
        this.serviceToConfigure = null;
        this.isUpgradeLoaded = false;
        this.instances = [];
        this.instancesNodeIds = [];
        this.serviceUpgradeErrorInfo = {};
        this.serviceVersionError = [];
        this.showUploadLogsForV3 = false;
        this.selectedTab = "configuration";
        this.connectorServicesEnabled_count = 0;
        this.connectorInstance_count = 0;
        this.connectorInstance_count_active = 0;
        this.connectorInstance_count_down = 0;
        this.connectorVersion = { "name": "V3", "value": "V3" };
        this.connectorVersions = [{ "name": "Version 2.x(Note: End of support October-31-2024)", "value": "V2" }, { "name": "Version 3.x(Recommended Version)", "value": "V3" }];
        this.showMetricInstance = false;
        this.showServiceControllerStatus = false;
        this.showServiceUpgradePopup = false;
        this.serviceMetricList = [];
        this.showMigratecomponent = false;
        this.serviceNameDisplayName = new Map();
        this.metricLoaded = false;
        this.alreadyLoadedMetric = [];
        this.metricsColours = ["#8038B2", "#1B109B", "#3B9EDF", "#DF3B8F", "#D15D24", "#24D1CC", "#C21056"];
        this.tempMetricsColours = ["#8038B2", "#1B109B", "#3B9EDF", "#DF3B8F", "#D15D24", "#24D1CC", "#C21056"];
        this.instanceList = [];
        this.startDate = 0;
        this.endDate = 0;
        this.metricsListToShow = [];
        this.totalConnectors = 0;
        this.totalV2Connectors = 0;
        this.connectorsUpCount = 0;
        this.connectorsUpCountV2 = 0;
        this.connectorsDownCount = 0;
        this.connectorsDownCountV2 = 0;
        this.servicesConnectorCountsKey = [];
        this.confirmationVisible = false;
        this.connectorSwitchesCount = 0;
        this.switchObject = {};
        this.showAddSwitchPopup = false;
        this.switchModuleError = "";
        this.switchesList = [];
        this.showCreateConnectorPopup = false;
        this.connectorControllersCount = 0;
        this.connectorControllersCount_active = 0;
        this.connectorControllersCount_down = 0;
        this.updateMessage = "";
        this.showConnectorConfirmPopUp = false;
        this.showPasswordV = false;
        this.associatedServices = [];
        this.allServices = [];
        this.showAddServicePopup = false;
        this.connectorServices = [];
        this.serviceList = [];
        this.metrics = [];
        this.chartData = [];
        this.eachInstanceDataForThisMetric = [];
        this.metricsChartOptions = new ChartOptions();
        this.selectedInterval = { "name": "Last 1 Hour" };
        this.intervalList = [{ "name": "Last 1 Hour" }, { "name": "Last 24 Hours" }, { "name": "Last 1 Week" }, { "name": "Last 2 Week" }]; //{"name":"Select a date Range"}
        this.networkDependencyForService = new Set();
        this.intervalValue = 0;
        this.showCalendarPopup = false;
        this.sampleRate = 3600;
        this.tempMetricsStats = [];
        this.metricsStats = [];
        this.removedColours = [];
        this.removedInstanceStats = new Map();
        this.confirmUpgrade = false;
        this.showSoftUpdatePopup = false;
        this.showV2Controllers = false;
        this.wiredconnectorSwitchesCount = 0;
        this.showPopup = false;
        this.reportMap = [];
        this.showResetPwdKey = false;
        this.accountControllerList = [];
        //for controller import and testconnectivity
        this.spacesConnectorToAddController = []; //on select check getAvailable service and network dependency;
        // can add controllers to connector(2.x && 3.0 with service enabled with networkdependency as controller)
        this.spacesConnectorImportAllowed = []; // only connector (2.x && 3.0 not having hotspot enabled in this list)
        this.controllerCreateType = { "name": "new", "value": "Add new controller" };
        this.controllerCreateTypes = [{ "name": "new", "value": "Add new controller" }, { "name": "import", "value": "Choose controller from another connector" }];
        this.showImportFromConnectorList = false;
        this.importFromConnector = {};
        this.listOfControllers = [];
        this.deviceIdsToImport = [];
        this.disableImportButton = true;
        this.allowControllerCreation = true;
        //C3
        // localization
        this.messageKeys = {};
        this.copyHotspotConfig = false;
        this.migrationNotice = false;
        this.showTooltip_hotspot = false;
        this.displayOptions = false;
        this.filterString = "";
        this.placeholder = "Select Connector";
        this.showTabDetails = (tab) => {
            this.selectedTab = tab;
            if (tab == 'metrics') {
                this.tempMetricsStats = [];
                //this.metricsServiceList = this.serviceList;
                //this.metricsServiceList.push({"name":"System","status":null});
                this.tempMetricsColours = this.metricsColours;
                if (this.alreadyLoadedMetric && this.alreadyLoadedMetric['service-manager']) {
                    this.prepareMetricsChart(this.alreadyLoadedMetric['service-manager'], 'service-manager', this.selectedInterval.name, false);
                }
                else {
                    this.onMetricServiceSelection({ "name": "service-manager", "systemName": "service-manager" });
                }
            }
            else if (tab == 'configuration') {
                this.viewConnector(this.currentConnector, this.currentConnector.name, this.currentConnector.connectorNodes);
            }
            else if (tab == 'instances') {
                setTimeout(() => {
                    this.refreshPage(this.currentConnector, this.selectedTab);
                }, 100);
            }
        };
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.cmx-connector.controllers.add-controller').subscribe((res) => {
                this.messageKeys['add-controller'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.controllers.edit-controller').subscribe((res) => {
                this.messageKeys['edit-controller'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.create-new-connector-label').subscribe((res) => {
                this.messageKeys['create-new-connector'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.added_connector_success').subscribe((res) => {
                this.messageKeys['added_connector_success'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.error_occurred_adding_conn').subscribe((res) => {
                this.messageKeys['error_occurred_adding_conn'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.controller_associates_conn').subscribe((res) => {
                this.messageKeys['controller_associates_conn'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.controller_created').subscribe((res) => {
                this.messageKeys['controller_created'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.error_occurred_contr').subscribe((res) => {
                this.messageKeys['error_occurred_contr'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.controller_updated_success').subscribe((res) => {
                this.messageKeys['controller_updated_success'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.error_occurred_updating_contr').subscribe((res) => {
                this.messageKeys['error_occurred_updating_contr'] = res;
            });
            this.translate.get('dashboard-lib.spaces-connector.toss_message.enter_controller_ip').subscribe((res) => {
                this.messageKeys['enter_controller_ip'] = res;
            });
            this.translate.get('dashboard-lib.spaces-connector.toss_message.enter_valid_ip').subscribe((res) => {
                this.messageKeys['enter_valid_ip'] = res;
            });
            this.translate.get('dashboard-lib.spaces-connector.toss_message.enter_controller_name').subscribe((res) => {
                this.messageKeys['enter_controller_name'] = res;
            });
            this.translate.get('dashboard-lib.spaces-connector.toss_message.select_controller_type').subscribe((res) => {
                this.messageKeys['select_controller_type'] = res;
            });
            this.translate.get('dashboard-lib.spaces-connector.toss_message.select_snmp').subscribe((res) => {
                this.messageKeys['select_snmp'] = res;
            });
            this.translate.get('dashboard-lib.spaces-connector.toss_message.select_snmp_rw').subscribe((res) => {
                this.messageKeys['select_snmp_rw'] = res;
            });
            this.translate.get('dashboard-lib.spaces-connector.toss_message.enter_username').subscribe((res) => {
                this.messageKeys['enter_username'] = res;
            });
            this.translate.get('dashboard-lib.spaces-connector.toss_message.enter_password').subscribe((res) => {
                this.messageKeys['enter_password'] = res;
            });
            this.translate.get('dashboard-lib.spaces-connector.toss_message.select_auth').subscribe((res) => {
                this.messageKeys['select_auth'] = res;
            });
            this.translate.get('dashboard-lib.spaces-connector.toss_message.select_privacy').subscribe((res) => {
                this.messageKeys['select_privacy'] = res;
            });
            this.translate.get('dashboard-lib.spaces-connector.toss_message.enter_privacy_pass').subscribe((res) => {
                this.messageKeys['enter_privacy_pass'] = res;
            });
            this.translate.get('dashboard-lib.spaces-connector.toss_message.enter_airos_username').subscribe((res) => {
                this.messageKeys['enter_airos_username'] = res;
            });
            this.translate.get('dashboard-lib.spaces-connector.toss_message.enter_airos_password').subscribe((res) => {
                this.messageKeys['enter_airos_password'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.connector_deleted').subscribe((res) => {
                this.messageKeys['connector_deleted'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.delete_connector_failed').subscribe((res) => {
                this.messageKeys['delete_connector_failed'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.controller_deleted').subscribe((res) => {
                this.messageKeys['controller_deleted'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.controller_delete_failed').subscribe((res) => {
                this.messageKeys['controller_delete_failed'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.restart_connector_failed').subscribe((res) => {
                this.messageKeys['restart_connector_failed'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.connector_restart_success').subscribe((res) => {
                this.messageKeys['connector_restart_success'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.connector_logs_failed').subscribe((res) => {
                this.messageKeys['connector_logs_failed'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.connector_logs_uploaded').subscribe((res) => {
                this.messageKeys['connector_logs_uploaded'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.no_service_upload_connector').subscribe((res) => {
                this.messageKeys['no_service_upload_connector'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.upgrade_failed').subscribe((res) => {
                this.messageKeys['upgrade_failed'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.upgrade_successful').subscribe((res) => {
                this.messageKeys['upgrade_successful'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.connector_debug_failed').subscribe((res) => {
                this.messageKeys['connector_debug_failed'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.connector_debug_success').subscribe((res) => {
                this.messageKeys['connector_debug_success'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.connector_debug_disabled').subscribe((res) => {
                this.messageKeys['connector_debug_disabled'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.connector_toggle_failed').subscribe((res) => {
                this.messageKeys['connector_toggle_failed'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.auto_upgrade_failed').subscribe((res) => {
                this.messageKeys['auto_upgrade_failed'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.enable_auto_upgrade_failed').subscribe((res) => {
                this.messageKeys['enable_auto_upgrade_failed'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.auto_upgrade_enabled').subscribe((res) => {
                this.messageKeys['auto_upgrade_enabled'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.unable_fetch_status').subscribe((res) => {
                this.messageKeys['unable_fetch_status'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.unable_controller_details').subscribe((res) => {
                this.messageKeys['unable_controller_details'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.unable_switch_details').subscribe((res) => {
                this.messageKeys['unable_switch_details'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.configuration_success').subscribe((res) => {
                this.messageKeys['configuration_success'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.unable_fetch_catalyst').subscribe((res) => {
                this.messageKeys['unable_fetch_catalyst'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.token_copied').subscribe((res) => {
                this.messageKeys['token_copied'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.config_copied').subscribe((res) => {
                this.messageKeys['config_copied'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.cli_comm_copied').subscribe((res) => {
                this.messageKeys['cli_comm_copied'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.failed_access_token').subscribe((res) => {
                this.messageKeys['failed_access_token'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.connector_update_success').subscribe((res) => {
                this.messageKeys['connector_update_success'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.connector_failed').subscribe((res) => {
                this.messageKeys['connector_failed'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.unable_connect').subscribe((res) => {
                this.messageKeys['unable_connect'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.auth_key_success').subscribe((res) => {
                this.messageKeys['auth_key_success'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.error_occured_toke').subscribe((res) => {
                this.messageKeys['error_occured_toke'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.confi_deails_success').subscribe((res) => {
                this.messageKeys['confi_deails_success'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.unable_fetch_conf').subscribe((res) => {
                this.messageKeys['unable_fetch_conf'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.stream_queued').subscribe((res) => {
                this.messageKeys['stream_queued'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.select_option').subscribe((res) => {
                this.messageKeys['select_option'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.switch_disabled').subscribe((res) => {
                this.messageKeys['switch_disabled'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.failed_disable_switch').subscribe((res) => {
                this.messageKeys['failed_disable_switch'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.switch_enable_success').subscribe((res) => {
                this.messageKeys['switch_enable_success'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.switch_enable_failed').subscribe((res) => {
                this.messageKeys['switch_enable_failed'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.error_config_switch').subscribe((res) => {
                this.messageKeys['error_config_switch'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.switch_created').subscribe((res) => {
                this.messageKeys['switch_created'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.switch_failed').subscribe((res) => {
                this.messageKeys['switch_failed'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.switch_deleted').subscribe((res) => {
                this.messageKeys['switch_deleted'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.failed_switch_delete').subscribe((res) => {
                this.messageKeys['failed_switch_delete'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.no_services_available').subscribe((res) => {
                this.messageKeys['no_services_available'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.connector_upgraded').subscribe((res) => {
                this.messageKeys['connector_upgraded'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.failed_connect_upgrade').subscribe((res) => {
                this.messageKeys['failed_connect_upgrade'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.failed_password_reset').subscribe((res) => {
                this.messageKeys['failed_password_reset'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.no_instance_pass_reset').subscribe((res) => {
                this.messageKeys['no_instance_pass_reset'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.logs_uploaded').subscribe((res) => {
                this.messageKeys['logs_uploaded'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.failed_logs_upload').subscribe((res) => {
                this.messageKeys['failed_logs_upload'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.enable_debug_log').subscribe((res) => {
                this.messageKeys['enable_debug_log'] = res;
            });
            this.translate.get('dashboard-lib.cmx-connector.toass_messages_shared_lib.failed_enable_debug').subscribe((res) => {
                this.messageKeys['failed_enable_debug'] = res;
            });
            // failed_enable_debug
        };
        this.getProperties = () => {
            this.authService.getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$).then(properties => {
                this.connectorConfigureGuide = properties['value'].connectorConfigureGuide;
                this.connectorReleaseNote = properties['value'].connectorReleaseNotes;
                this.connectorMigrationGuide = properties['value'].connectorMigrationguide;
            });
        };
        this.prepareChartOptions = () => {
            const options = Object.assign(Object.assign({}, this.chartOptions), { chartType: "line", barWidth: 20, barSpacing: 10, sectionSpacing: 40, outerPadding: 20, margin: { top: 30, right: 25, bottom: 50, left: 25 }, backgroundColor: "#fff", defaultColor: "#A0BFD9", axisLineColor: "#cacaca", tickColor: "#F5F5F5", valueColor: "#485967", groupTitleColor: "#1D3243", yAxisLabel: "Messages / Second", xAxisLabel: "Hour", chartHeight: 350, yAxisTickFormat: "", xAxisTickFormat: "%b %d, %I %p", lineColor: "#457FAD", isYaxisReadable: false, xAxisDateFormat: "%Y-%m-%dT%H:%M:%S.%fZ", xAxisFormat: "date", xTranslate: "rotate(-45)", isPosTooltip: true, isPopup: true });
            this.chartOptions = options;
            // if(type === 'dailyTrend') this.chartOptions['yAxisLabel'] = '';
        };
        this.initializeSwitchObj = () => {
            this.switchObj.switchIdList = []; // number array
            this.switchObj.destSpanVlan = "";
            this.switchObj.destSpanVlanIpAddress = "";
            this.switchObj.sourceSpanVlanList = []; // string array
            this.switchObj.monitorOriginIpAddress = "";
            this.switchObj.useDhcp = "false";
            this.switchObj.appSpanIpAddress = "";
            this.switchObj.appDnasVlan = "";
            this.switchObj.appIpAddress = "";
            this.switchObj.appNetmask = "";
            this.switchObj.appGatewayAddress = "";
            this.switchObj.destSpanVlanIpAddress = "";
            this.switchObj.appSpanIpAddress = "";
            this.switchObj.name = "";
            this.switchObj.saveConfig = false;
        };
        this.initializeControllerObj = () => {
            this.controllerObj.connectorName = "";
            this.controllerObj.connectorId;
            this.controllerObj.connectorVersion = "";
            this.controllerObj.isAssociateController = false;
            this.controllerObj.controllerIp = "";
            this.controllerObj.name = "";
            this.controllerObj.type = "";
            this.controllerObj.connectorVersion = "";
            this.initializeSNMP();
            this.initializeEWLC();
            this.initializeWSAConfig();
            this.initializeAireOSLogin();
            this.importFromConnector.name = '-- Select --';
            this.connectivityTestResult = {};
        };
        this.initializeEWLC = () => {
            this.controllerObj.login = {};
            this.controllerObj.login.username = "";
            this.controllerObj.login.password = "";
            this.controllerObj.login.cliCredentialsAvailable = false;
            this.controllerObj.login.enablePassword = "";
            this.controllerObj.login.netconfUsername = "";
            this.controllerObj.login.netconfPassword = "";
            this.controllerObj.login.provideNetconf = false;
        };
        this.initializeSNMP = () => {
            this.controllerObj.snmp = {};
            this.controllerObj.snmp.controllerType = "-- Select --";
            this.controllerObj.snmp.version = "-- Select --";
            this.controllerObj.snmp.userName = "";
            this.controllerObj.snmp.password = "";
            this.controllerObj.snmp["auth-protocol"] = "-- Select --";
            this.controllerObj.snmp["privacy-protocol"] = "-- Select --";
            this.controllerObj.snmp["privacy-password"] = "";
            this.controllerObj.snmp.community = "";
        };
        this.initializeWSAConfig = () => {
            this.controllerObj.wsaConfig = {};
            this.controllerObj.wsaConfig.isSubscribed = true;
            this.controllerObj.wsaConfig.subscriptions = ["all"];
        };
        this.initializeAireOSLogin = () => {
            this.controllerObj.aireOSLogin = {};
            this.controllerObj.aireOSLogin.username = "";
            this.controllerObj.aireOSLogin.password = "";
            this.controllerObj.aireOSLogin.cliCredentialsAvailable = false;
        };
        this.toggleWSA = ($event) => {
            this.controllerObj.aireOSLogin.cliCredentialsAvailable =
                $event.target.checked;
        };
        this.toggleUseDhcp = ($event) => {
            this.switchObj.useDhcp = $event.target.checked.toString();
            this.validateSwitchObj();
        };
        this.togglePersistConf = ($event) => {
            this.switchObj.saveConfig = $event.target.checked.toString();
            this.validateSwitchObj();
        };
        this.togglePersistConfDisable = ($event) => {
            this.switchObj.saveConfig = $event.target.checked.toString();
        };
        this.geteWLCfeatureFlag = () => {
            this.dataService.display(true);
            this.cmxConnectorsService.ewlcFeatureFlag().subscribe((data) => {
                if (data.eWLC)
                    this.controllerTypeList.push("ewlc");
                this.dataService.display(false);
            }, (error) => {
                this.dataService.display(false);
                console.log("Unable to fetch feature flag for eWLC", error.status);
            });
        };
        this.getCMXConnectors = () => {
            this.dataService.display(true);
            this.totalConnectors = 0;
            this.totalV2Connectors = 0;
            this.spacesConnectorImportAllowed = [];
            this.connectorsUpCount = 0;
            this.connectorsUpCountV2 = 0;
            this.connectorsDownCount = 0;
            this.connectorsDownCountV2 = 0;
            this.servicesConnectorEnabled = new Map();
            this.cmxConnectorsService
                .getCMXConnectors()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data != "" && data != null) {
                    // store the spaces connector count
                    const totalCount = data.length;
                    //this.totalConnectors = totalCount;
                    localStorage.setItem("spacesConnectorCount", JSON.stringify(totalCount));
                    this.cmxConnectorList = data.sort((a, b) => {
                        const c1 = +new Date(a.updatedAt);
                        const c2 = +new Date(b.updatedAt);
                        return c2 - c1;
                    });
                    this.connectorsUpCount = 0;
                    this.connectorsUpCountV2 = 0;
                    this.connectorsDownCount = 0;
                    this.connectorsDownCountV2 = 0;
                    this.totalConnectors = this.cmxConnectorList.length;
                    this.migrateHover = new Array(this.totalConnectors).fill(false);
                    this.servicesConnectorEnabled = new Map();
                    this.servicesConnectorCountsKey = [];
                    this.cmxConnectorListV2 = [];
                    this.spacesConnectorToAddController = data;
                    this.identifyConnectors_importFrom(this.cmxConnectorList);
                    this.cmxConnectorList.forEach((connector, index) => {
                        var _a;
                        if (connector.version == undefined) {
                            connector.version = 'V2';
                        }
                        if (connector.version == 'V2') {
                            this.totalV2Connectors++;
                            this.cmxConnectorListV2.push(connector);
                        }
                        if (connector.serviceDeployConfig != undefined) {
                            connector.release = (_a = connector.serviceDeployConfig['service-manager']) === null || _a === void 0 ? void 0 : _a.imageConfig.latest.version;
                            if (connector.connectorRelease) {
                                connector.release = connector.connectorRelease;
                            }
                            const services = connector.serviceDeployConfig;
                            Object.keys(services).forEach(key => {
                                if (key !== 'service-manager') {
                                    if (this.servicesConnectorEnabled[key] == undefined) {
                                        this.servicesConnectorEnabled[key] = 1;
                                    }
                                    else {
                                        this.servicesConnectorEnabled[key] = this.servicesConnectorEnabled[key] + 1;
                                    }
                                }
                            });
                        }
                        if (connector.name == undefined) {
                            if (index != 0) {
                                connector.name = "Connector " + index;
                            }
                            else {
                                connector.name = "Connector";
                            }
                        }
                        if (connector.associatedControllers != undefined) {
                            connector.controllerSize =
                                connector.associatedControllers.length;
                        }
                        else {
                            connector.controllerSize = 0;
                        }
                        // switches count
                        if (connector.associatedSwitches != undefined) {
                            connector.switchesSize =
                                connector.associatedSwitches.length;
                        }
                        else {
                            connector.switchesSize = 0;
                        }
                        if (connector.connectorNodes != undefined) {
                            connector.instanceCount = Object.keys(connector.connectorNodes).length;
                        }
                        else {
                            connector.instanceCount = 0;
                        }
                        //status end
                        if (connector.version == 'V2') {
                            if (connector.status == "Connected") {
                                connector.connectorStatus = "Active";
                                this.connectorsUpCount = this.connectorsUpCount + 1;
                                this.connectorsUpCountV2 = this.connectorsUpCountV2 + 1;
                            }
                            else {
                                connector.connectorStatus = "Inactive";
                                this.connectorsDownCount = this.connectorsDownCount + 1;
                                this.connectorsDownCountV2 = this.connectorsDownCountV2 + 1;
                            }
                        }
                        if (connector.version == 'V3') {
                            if (connector.connectorStatus == 'Degraded') {
                                connector.connectorStatus = "Degraded";
                                this.connectorsUpCount = this.connectorsUpCount + 1;
                            }
                            else if (connector.connectorStatus == 'Up') {
                                connector.connectorStatus = "Active";
                                this.connectorsUpCount = this.connectorsUpCount + 1;
                            }
                            else {
                                connector.connectorStatus = "Inactive";
                                this.connectorsDownCount = this.connectorsDownCount + 1;
                            }
                        }
                        /*if (connector.version == "V3") {
                          if(connector.serviceDeployConfig && connector.serviceDeployConfig['hotspot']) { // "hotspot" service is enabled for this connector
                            connector.showHotSpotConfigCheck = true;
                          }
                          if(this.currentConnector && this.currentConnector.id !== connector.id){
                            this.spacesConnectorImportAllowed.push(connector);
                          }
                        }*/
                    });
                    this.showTooltip = new Array(this.spacesConnectorImportAllowed.length + 1);
                    if (Object.keys(this.servicesConnectorEnabled).length > 0)
                        this.servicesConnectorCountsKey = Object.keys(this.servicesConnectorEnabled);
                    console.log("services found are ", this.servicesConnectorCountsKey);
                }
                else {
                    this.cmxConnectorList = [];
                    this.cmxConnectorListV2 = [];
                    localStorage.setItem("spacesConnectorCount", JSON.stringify(0));
                }
                this.cmxConnectorListLoaded = true;
                this.dataService.display(false);
                this.checkConnectorsUpgrade(this.cmxConnectorList);
                if (this.connectorsDownCountV2 + this.connectorsUpCountV2 > 0) {
                    this.migrationNotice = true;
                }
            }, (error) => {
                this.dataService.display(false);
                console.log("CMX Connector list fetch error", error.status);
            });
            this.now = new Date();
        };
        this.identifyConnectors_importFrom = (connectorList) => {
            var hotspotVersion2List = [];
            this.dataService.display(true);
            this.spacesConnectorImportAllowed = [];
            var found;
            this.cmxConnectorsService
                .getHotspotList()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.data !== "" && response.data !== null) {
                    hotspotVersion2List = response.data;
                    connectorList.forEach(connector => {
                        if (connector.version !== 'V3' && this.controllerObj.connectorId && this.controllerObj.connectorId !== connector.id) {
                            found = hotspotVersion2List.find((hs) => hs.id === connector.id);
                            if (found) {
                                connector.showHotSpotConfigCheck = true;
                            }
                            this.spacesConnectorImportAllowed.push(connector);
                            found = undefined;
                        }
                        /* hotspotVersion2List.forEach(hotspotConnector =>{
                         if (connector.version !== 'V3' &&
                         this.controllerObj.connectorId && this.controllerObj.connectorId !== connector.id) {
                           if(hotspotConnector.id == connector.id){
                             connector.showHotSpotConfigCheck = true;
                           }
                           this.spacesConnectorImportAllowed.push(connector);
                         }
                       });*/
                        if (connector.version == 'V3' &&
                            this.controllerObj.connectorId && this.controllerObj.connectorId !== connector.id) {
                            if (connector.serviceDeployConfig && connector.serviceDeployConfig['hotspot']) { // "hotspot" service is enabled for this connector
                                connector.showHotSpotConfigCheck = true;
                            }
                            this.spacesConnectorImportAllowed.push(connector);
                        }
                    });
                }
                else {
                    connectorList.forEach(connector => {
                        if (connector.version !== 'V3') {
                            if (this.controllerObj.connectorId && this.controllerObj.connectorId !== connector.id) {
                                this.spacesConnectorImportAllowed.push(connector);
                            }
                        }
                        if (connector.version == 'V3') {
                            if (connector.serviceDeployConfig && connector.serviceDeployConfig['hotspot'] &&
                                this.controllerObj.connectorId && this.controllerObj.connectorId !== connector.id) { // "hotspot" service is enabled for this connector
                                connector.showHotSpotConfigCheck = true;
                            }
                            this.spacesConnectorImportAllowed.push(connector);
                        }
                    });
                }
                this.dataService.display(false);
            });
        };
        this.getDurationFromTimestamp = (endTimeStamp) => {
            this.now = new Date();
            const nowTime = this.now.getTime();
            const timeDiff = nowTime - endTimeStamp;
            const seconds = Math.floor(timeDiff / 1000);
            const minutes = Math.floor(seconds / 60);
            const hours = Math.floor(minutes / 60);
            const days = Math.floor(hours / 24);
            if (minutes == 0) {
                return `1 minute`;
            }
            else
                return `${days > 0 ? `${days} days ` : ""}${hours % 24 > 0 ? `${hours % 24} hours ` : ""}${minutes % 60 > 0 ? `${minutes % 60} minutes ` : ""}
		${seconds % 60 > 0 ? `${seconds % 60} seconds ` : ""}`;
        };
        this.getConnectorDetails = (id, show) => {
            //	this.dataService.display(true);
            this.cmxConnectorDetailsLoaded = false;
            this.cmxConnectorsService
                .getCMXConnectorDetails(id)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data != "" && data != null) {
                    console.log("connector version is ", this.selectedConnector.version);
                    this.selectedConnector = data;
                    if (data.version && data.version == 'V3') {
                        this.selectedConnector.version = 'V3';
                    }
                    else {
                        this.selectedConnector.version = 'V2';
                    }
                    if (this.selectedConnector.version == 'V2') {
                        if (this.selectedConnector.status == "Connected") {
                            this.selectedConnector.connectorStatus = "Active";
                        }
                        else {
                            this.selectedConnector.connectorStatus = "Inactive";
                        }
                    }
                    if (this.selectedConnector.version == 'V3') {
                        if (this.selectedConnector.connectorStatus == 'Degraded') {
                            this.selectedConnector.connectorStatus = "Degraded";
                        }
                        else if (this.selectedConnector.connectorStatus == 'Up') {
                            this.selectedConnector.connectorStatus = "Active";
                        }
                        else {
                            this.selectedConnector.connectorStatus = "Inactive";
                        }
                    }
                    if (this.selectedConnector.associatedControllers !=
                        undefined) {
                        this.selectedConnector.controllerSize =
                            this.selectedConnector.associatedControllers.length;
                    }
                    else {
                        this.selectedConnector.controllerSize = 0;
                    }
                    if (this.selectedConnector.report != undefined) {
                        const { haActive = {}, firehoseStatus = {}, edmStatus = {} } = this.selectedConnector.report;
                        const { status } = firehoseStatus;
                        const haActiveKeys = Object.keys(haActive);
                        this.selectedConnector.haActiveKeys = haActiveKeys;
                        this.selectedConnector.firehoseStatus = status;
                        const { status: edm_status, grpcStats = {}, tdlStats = {}, activeApConnections = 0 } = edmStatus;
                        const { grpcInPackets = {}, grpcOutPackets = {} } = grpcStats;
                        const { count: in_count, m1_rate: in_m1 } = grpcInPackets;
                        const { count: out_count, m1_rate: out_m1 } = grpcOutPackets;
                        const tdl_all_rate = tdlStats["incoming-global-tdl-all-rate"] || {};
                        this.selectedConnector.activeApConnections =
                            activeApConnections;
                        this.selectedConnector.edm_status = edm_status;
                        this.selectedConnector.in_count = in_count;
                        this.selectedConnector.in_m1 = in_m1;
                        this.selectedConnector.out_count = out_count;
                        this.selectedConnector.out_m1 = out_m1;
                        this.selectedConnector.tdl_count =
                            tdl_all_rate.count;
                        this.selectedConnector.tdl_m1 =
                            tdl_all_rate.m1_rate;
                        if (this.selectedConnector.report.controlChannel !=
                            undefined) {
                            if (this.selectedConnector.report.controlChannel
                                .connectionStatus == "Connected") {
                                this.selectedConnector.controlChannelConnectorStatus =
                                    "Active";
                            }
                            else {
                                this.selectedConnector.controlChannelConnectorStatus =
                                    "Inactive";
                            }
                        }
                        else {
                            this.selectedConnector.controlChannelConnectorStatus =
                                "Inactive";
                        }
                    }
                    else {
                        this.selectedConnector.controlChannelConnectorStatus =
                            "Inactive";
                    }
                    if (this.selectedConnector.report != undefined) {
                        if (this.selectedConnector.report.dataChannel !=
                            undefined) {
                            if (this.selectedConnector.report.dataChannel
                                .connectionStatus == "Connected") {
                                this.selectedConnector.dataChannelConnectorStatus =
                                    "Active";
                            }
                            else {
                                this.selectedConnector.dataChannelConnectorStatus =
                                    "Inactive";
                            }
                        }
                        else {
                            this.selectedConnector.dataChannelConnectorStatus =
                                "Inactive";
                        }
                    }
                    else {
                        this.selectedConnector.dataChannelConnectorStatus =
                            "Inactive";
                    }
                    this.cmxConnectorDetailsLoaded = true;
                    this.now = new Date();
                    if (this.selectedConnector.version == 'V2') {
                        this.connectorDetailsD3Chart = [];
                        setTimeout(() => {
                            // var res = [[{ "time": "2019-10-23T14:00:00.000Z", "mean": 12.310252526539745 }, { "time": "2019-10-23T15:00:00.000Z", "mean": 12.47446815168291 }, { "time": "2019-10-23T16:00:00.000Z", "mean": 12.475981689885591 }, { "time": "2019-10-23T17:00:00.000Z", "mean": 12.470089696972478 }, { "time": "2019-10-23T18:00:00.000Z", "mean": 13.557466351480976 }, { "time": "2019-10-23T19:00:00.000Z", "mean": 11.865137079196254 }, { "time": "2019-10-23T20:00:00.000Z", "mean": 10.265075021063513 }, { "time": "2019-10-23T21:00:00.000Z", "mean": 10.457496704230323 }, { "time": "2019-10-23T22:00:00.000Z", "mean": 10.348617078767132 }, { "time": "2019-10-23T23:00:00.000Z", "mean": 10.143440422232004 }, { "time": "2019-10-24T00:00:00.000Z", "mean": 9.945915511054555 }, { "time": "2019-10-24T01:00:00.000Z", "mean": 9.966123604546842 }, { "time": "2019-10-24T02:00:00.000Z", "mean": 9.876326679062725 }, { "time": "2019-10-24T03:00:00.000Z", "mean": 9.981212344039129 }, { "time": "2019-10-24T04:00:00.000Z", "mean": 9.716277946214694 }, { "time": "2019-10-24T05:00:00.000Z", "mean": 9.63228581304596 }, { "time": "2019-10-24T06:00:00.000Z", "mean": 9.608390789664295 }, { "time": "2019-10-24T07:00:00.000Z", "mean": 9.678327061805314 }, { "time": "2019-10-24T08:00:00.000Z", "mean": 9.602305441364901 }, { "time": "2019-10-24T09:00:00.000Z", "mean": 9.824032350000143 }, { "time": "2019-10-24T10:00:00.000Z", "mean": 9.685810098639214 }, { "time": "2019-10-24T11:00:00.000Z", "mean": 9.721534813027278 }, { "time": "2019-10-24T12:00:00.000Z", "mean": 9.847154140723752 }, { "time": "2019-10-24T13:00:00.000Z", "mean": 9.640435512143508 }, { "time": "2019-10-24T14:00:00.000Z", "mean": 9.65871173557131 }], [{ "time": "2019-10-23T14:00:00.000Z", "mean": 13.1769895511636 }, { "time": "2019-10-23T15:00:00.000Z", "mean": 13.352781313648812 }, { "time": "2019-10-23T16:00:00.000Z", "mean": 13.445744959539145 }, { "time": "2019-10-23T17:00:00.000Z", "mean": 13.406484842851054 }, { "time": "2019-10-23T18:00:00.000Z", "mean": 14.54462383876633 }, { "time": "2019-10-23T19:00:00.000Z", "mean": 12.640054787577226 }, { "time": "2019-10-23T20:00:00.000Z", "mean": 10.827484575582881 }, { "time": "2019-10-23T21:00:00.000Z", "mean": 11.007844083541242 }, { "time": "2019-10-23T22:00:00.000Z", "mean": 10.854309950744112 }, { "time": "2019-10-23T23:00:00.000Z", "mean": 10.639808945043974 }, { "time": "2019-10-24T00:00:00.000Z", "mean": 10.693665409264362 }, { "time": "2019-10-24T01:00:00.000Z", "mean": 10.488466581555047 }, { "time": "2019-10-24T02:00:00.000Z", "mean": 10.310466676988364 }, { "time": "2019-10-24T03:00:00.000Z", "mean": 10.41764224055215 }, { "time": "2019-10-24T04:00:00.000Z", "mean": 10.179343196592596 }, { "time": "2019-10-24T05:00:00.000Z", "mean": 10.037498428144158 }, { "time": "2019-10-24T06:00:00.000Z", "mean": 10.049262399161881 }, { "time": "2019-10-24T07:00:00.000Z", "mean": 10.087394650364416 }, { "time": "2019-10-24T08:00:00.000Z", "mean": 10.009167214903306 }, { "time": "2019-10-24T09:00:00.000Z", "mean": 10.232104960289746 }, { "time": "2019-10-24T10:00:00.000Z", "mean": 10.083902402177054 }, { "time": "2019-10-24T11:00:00.000Z", "mean": 10.12054223619354 }, { "time": "2019-10-24T12:00:00.000Z", "mean": 10.25924389154615 }, { "time": "2019-10-24T13:00:00.000Z", "mean": 10.060926890770324 }, { "time": "2019-10-24T14:00:00.000Z", "mean": 10.090107493351821 }]];
                            // this.setD3ConnectorDetailsChart(res);
                            this.cmxConnectorsService
                                .getCMXConnectorChartStatistics(id)
                                .pipe(takeUntil(this.unsubscribe$))
                                .subscribe((data) => {
                                console.log("HERE!!!", data);
                                //  var res = [[{ "time": "2019-10-23T10:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T11:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T12:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T13:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T14:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T15:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T16:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T17:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T18:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T19:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T20:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T21:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T22:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T23:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T00:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T01:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T02:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T03:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T04:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T05:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T06:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T07:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T08:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T09:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T10:00:00.000Z", "mean": 0 }], [{ "time": "2019-10-23T10:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T11:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T12:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T13:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T14:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T15:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T16:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T17:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T18:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T19:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T20:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T21:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T22:00:00.000Z", "mean": 0 }, { "time": "2019-10-23T23:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T00:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T01:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T02:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T03:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T04:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T05:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T06:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T07:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T08:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T09:00:00.000Z", "mean": 0 }, { "time": "2019-10-24T10:00:00.000Z", "mean": 0 }]];
                                this.setD3ConnectorDetailsChart(data);
                                //this.dataService.display(false);
                            }, (error) => {
                                //	this.dataService.display(false);
                                console.log("ERROR", error);
                            });
                        }, 1);
                    }
                }
                else {
                    this.selectedConnector = {};
                }
                this.selectedConnector.upgrade_allowed = this.currentConnector.upgrade_allowed; // retain upgrade status from listing
                this.currentConnector = this.selectedConnector;
            }, (error) => {
                this.selectedConnector = {};
                this.cmxConnectorDetailsLoaded = true;
                this.showConnectorDetailsPopup = show;
                //this.dataService.display(false);
                console.log("CMX Connector details fetch error", error.status);
            });
        };
        this.showCMXConnectorAdd = (event, isConnectorAvailable, editController) => {
            this.cmxConnectorError = "";
            this.netconfUsername_error = "";
            this.controllerIp_error = "";
            this.name_error = "";
            this.connectivityMessages = [];
            this.snmpReadOnlyMsg = "";
            this.displayTaskStatus = "";
            this.controllerCreateType = { "name": "new", "value": "Add new controller" };
            this.showSpinner = false;
            this.showV3TestConnectivityStatus = false;
            this.copyHotspotConfig = false;
            if (editController == false) {
                if (isConnectorAvailable == true) {
                    this.configPage = "controller";
                    //C3 start
                    this.controllerCreateType = { "name": "new", "value": "Add new controller" };
                    this.listOfControllers = [];
                    this.deviceIdsToImport = [];
                    this.selectAll = false;
                    //C3 end
                    this.popupTitle = this.messageKeys['add-controller'];
                    this.controllerObj.connectorName = this.selectedConnector.name
                        ? this.selectedConnector.name
                        : "Connector";
                    this.controllerObj.connectorId = this.selectedConnector.id
                        ? this.selectedConnector.id
                        : null;
                    this.controllerObj.connectorVersion = this.selectedConnector.version ? this.selectedConnector.version : "V2";
                    this.displayeWLCcommands(this.controllerObj.connectorId);
                    this.displayTestConnectivity =
                        this.selectedConnector.connectorStatus === "Active" &&
                            this.validateConnectorVersion(this.selectedConnector);
                    if (this.selectedConnector.version && this.selectedConnector.version === 'V3') {
                        this.displayTestConnectivity = true;
                    }
                }
                else if (isConnectorAvailable == false) {
                    this.configPage = "connector";
                    this.popupTitle = this.messageKeys['create-new-connector']; //C3
                    this.initializeControllerObj();
                }
            }
            else if (editController == true) {
                this.configPage = "controller";
                this.popupTitle = this.messageKeys['edit-controller'];
            }
            this.showCMXConnectorPopup = event;
            if (event) {
                this.dataService.openMagneticPopup();
            }
            else {
                this.dataService.closeMagneticPopup();
            }
            // Reset all values
            if (event == false) {
                this.initializeControllerObj();
                clearTimeout(this.testV3Timeout);
            }
            this.isConnectorAvailable = isConnectorAvailable;
            this.editControllerPopup = editController;
            this.placeholder = "Select Connector";
            this.identifyConnectors_importFrom(this.cmxConnectorList);
        };
        this.toggleDropDown = (type) => {
            if (type == "controllerType") {
                this.showControllerTypeList = !this.showControllerTypeList;
                this.connectivityTestResult = {};
                clearTimeout(this.testV3Timeout);
            }
            else if (type == "snmpVersion") {
                this.showSNMPVersionList = !this.showSNMPVersionList;
                this.connectivityTestResult = {};
            }
            else if (type == "privacyProtocol") {
                this.showPrivacyProtocolList = !this.showPrivacyProtocolList;
                this.connectivityTestResult = {};
            }
            else if (type == "authProtocol") {
                this.showAuthProtocolList = !this.showAuthProtocolList;
                this.connectivityTestResult = {};
            }
            else if (type == "connectorList") {
                this.showConnnectorList = !this.showConnnectorList;
                this.connectivityTestResult = {};
                clearTimeout(this.testV3Timeout);
            }
            else if (type == "importConnectorList") {
                this.showImportFromConnectorList = !this.showImportFromConnectorList;
                console.log('list to import from is ::', this.spacesConnectorImportAllowed);
            }
        };
        this.controllerTypeSelected = (controllerType) => {
            this.displayTaskStatus = "";
            this.wlcConfigType = "";
            this.connectivityMessages = [];
            this.snmpReadOnlyMsg = "";
            if (controllerType === "ewlc") {
                this.initializeEWLC();
                this.controllerObj.type = controllerType;
                this.controllerObj.snmp.controllerType = "";
                this.controllerObj.snmp.version = "-- Select --";
            }
            else {
                this.initializeSNMP();
                this.initializeWSAConfig();
                this.initializeAireOSLogin();
                this.controllerObj.snmp.controllerType = controllerType;
                this.controllerObj.type = controllerType;
            }
            this.removeAttributes();
        };
        this.snmpVersionSelected = (snmpVersion) => {
            this.controllerObj.snmp.version = snmpVersion;
            this.controllerObj.snmp.userName = "";
            this.controllerObj.snmp.password = "";
            this.controllerObj.snmp["privacy-password"] = "";
        };
        this.privacyProtocolSelected = (privacyProtocol) => {
            this.controllerObj.snmp["privacy-password"] = "";
            this.controllerObj.snmp["privacy-protocol"] = privacyProtocol;
        };
        this.authProtocolSelected = (authProtocol) => {
            this.controllerObj.snmp.password = "";
            this.controllerObj.snmp["auth-protocol"] = authProtocol;
        };
        this.connectorSelected = (connector) => {
            this.connectivityMessages = [];
            this.snmpReadOnlyMsg = "";
            this.displayTaskStatus = "";
            // this.selectedConnector = connector ? Object.assign({}, connector) : {};
            this.controllerObj.connectorId = connector.id;
            this.controllerObj.connectorName = connector.name;
            this.controllerObj.connectorVersion = connector.version;
            this.displayeWLCcommands(connector.id);
            this.displayTestConnectivity =
                connector.connectorStatus === "Active" &&
                    this.validateConnectorVersion(connector);
            if (connector.version && connector.version === 'V3') {
                this.displayTestConnectivity = true;
            }
            /**
             * get service and networkdependency detail with this id calling getAailable service call
             *
            */ //C3 on each drop down selection;
            this.getAvailableServices(connector);
            //on each change of connector selection switch/reset import drop down and list selection;
            this.importFromConnector = { id: 0, name: "-- Select --" };
            this.deviceIdsToImport = [];
            this.listOfControllers = [];
            this.selectAll = false;
        };
        this.showAddController = (connectrorId) => {
            this.cmxConnectorList.forEach((connector) => {
                if (connector.id === connectrorId) {
                }
            });
        };
        this.showPassword = (input, text) => {
            input.type = input.type === "password" ? "text" : "password";
            if (text.textContent == "SHOW") {
                text.textContent = "HIDE";
            }
            else if (text.textContent == "HIDE") {
                text.textContent = "SHOW";
            }
        };
        this.connectorTypeChanged = ($event) => {
            this.connectorVersion = this.connectorVersions[$event];
        };
        this.addCMXConnector = () => {
            this.removeAttributes();
            if (this.checkConnectorNameExist() == true) {
                return false;
            }
            else {
                if (this.validateUI() == false) {
                    return false;
                }
            }
            let nameExists = false;
            let nameLength = false;
            this.cmxConnectorList.forEach((connector, index) => {
                if (connector.name != undefined) {
                    if (connector.name == this.controllerObj.connectorName.trim()) {
                        this.cmxConnectorError =
                            "A connector with this name already exists. try another";
                        nameExists = true;
                        return !nameExists;
                    }
                }
            });
            if (nameExists) {
                return false;
            }
            if (this.controllerObj.connectorName.trim().length > 64) {
                this.cmxConnectorError =
                    "Please enter a name with less than 64 characters";
                nameLength = true;
                return !nameLength;
            }
            if (nameLength) {
                return false;
            }
            this.dataService.display(true);
            const createConnectorObj = {
                connectorName: this.controllerObj.connectorName,
                version: this.connectorVersion.value
            };
            //Release 3.1 defaultservice add/not -start
            if (createConnectorObj.version === 'V3') {
                if (this.selectDefaultService === true) {
                    createConnectorObj['v3DefaultServiceFlag'] = 'ALLOWED';
                }
                else {
                    createConnectorObj['v3DefaultServiceFlag'] = 'NOT_ALLOWED';
                }
            }
            //Release 3.1 defaultservice add/not -start
            this.cmxConnectorsService
                .addCMXConnector(createConnectorObj)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.data != "" && response.data != null) {
                    if (this.controllerObj.isAssociateController == true) {
                        this.dataService.setToastMessage(this.messageKeys["added_connector_success"], 4000, null, null, "success");
                        this.addController(response.data.id, true);
                        this.showCreateConnectorPopup = false;
                        this.dataService.closeMagneticPopup();
                    }
                    else {
                        this.dataService.setToastMessage(this.messageKeys["added_connector_success"], 4000, null, null, "success");
                        this.showCMXConnectorAdd(false, false, false);
                        this.getCMXConnectors();
                        this.initializeControllerObj();
                        this.showCreateConnectorPopup = false;
                        this.dataService.closeMagneticPopup();
                    }
                    this.showConnectorDetails = true; //recent
                    this.viewConnector(response.data, response.data.name, []); //recent
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys["error_occurred_adding_conn"], 4000, null, null, "error");
                }
                const userNameForInteractionLog = this.dataService.getUserName();
                const logStr = "ADD: User " +
                    userNameForInteractionLog +
                    " has added Spaces Connector" +
                    this.controllerObj.connectorName;
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.ADD, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.POPUP, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["error_occurred_adding_conn"], 4000, null, null, "error");
                console.log("UUID Add error", error.status);
                const userNameForInteractionLog = this.dataService.getUserName();
                const logStr = "ERROR: While adding Spaces Connector " +
                    this.controllerObj.connectorName +
                    " by user " +
                    userNameForInteractionLog;
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.ERROR, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.POPUP, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
            });
        };
        this.addController = (connectorId, fromConnectorAdd) => {
            var _a, _b;
            this.controllerObj.connectorId = connectorId
                ? connectorId
                : this.selectedConnector.id;
            this.removeAttributes();
            if (fromConnectorAdd == false) {
                if (this.validateUI() == false) {
                    return false;
                }
                //here add more check if provided IP address is already added; one-one connector-controller then doable
            }
            //controllerList has ip available .controllerIp 20sep
            let that = this;
            let nameAlreaydExist = this.accountControllerList.some(function (controller) {
                return controller.name === that.controllerObj.name;
            });
            if (nameAlreaydExist) {
                this.cmxConnectorError =
                    "A controller with same name already exists.";
                return false;
            }
            this.accountControllerList.forEach((controller, index) => {
                if (controller.controllerIp === this.controllerObj.controllerIp) {
                    this.cmxConnectorError =
                        "A controller with same Ip address already exists.";
                    return false;
                }
            }); //20sep
            this.dataService.display(true);
            clearTimeout(this.testV3Timeout);
            (_b = (_a = this.controllerObj) === null || _a === void 0 ? void 0 : _a.login) === null || _b === void 0 ? true : delete _b.provideNetconf;
            this.cmxConnectorsService
                .addController(this.controllerObj)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.data != "" && response.data != null) {
                    if (fromConnectorAdd == true) {
                        this.dataService.setToastMessage(this.messageKeys["controller_associates_conn"], 4000, null, null, "success");
                    }
                    else {
                        if (response.data.connectorId) {
                            this.dataService.setToastMessage(this.messageKeys["controller_created"], 4000, null, null, "success");
                        }
                        else {
                            this.dataService.setToastMessage(this.messageKeys["error_occurred_contr"], 8000, null, null, "error");
                        }
                    }
                    this.showCMXConnectorAdd(false, false, false);
                    this.initializeControllerObj();
                    this.getConnectorAssociatedControllers(this.currentConnector);
                    /*if (fromConnectorAdd == true) {
                      this.getCMXConnectors();
                    } else {
                      this.onShowControllerList(this.selectedConnector);
                    }*/
                    //C3
                    /*	if(this.showConnectorDetails ==true){
                        this.getConnectorAssociatedControllers(this.currentConnector);
                      }*/
                    //C3
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys["error_occurred_contr"], 4000, null, null, "error");
                    if (fromConnectorAdd == true) {
                        this.showCMXConnectorAdd(false, false, false);
                        this.getCMXConnectors();
                        this.initializeControllerObj();
                    }
                }
                const userNameForInteractionLog = this.dataService.getUserName();
                const logStr = "ADD: User " +
                    userNameForInteractionLog +
                    " has added Controller " +
                    this.controllerObj.controllerIp;
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.ADD, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.POPUP, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["error_occurred_contr"], 4000, null, null, "error");
                console.log("UUID Add error", error.status);
                const userNameForInteractionLog = this.dataService.getUserName();
                const logStr = "ERROR: While adding Controller " +
                    this.controllerObj.controllerIp +
                    " by user " +
                    userNameForInteractionLog;
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.ERROR, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.POPUP, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
            });
        };
        this.editController = (controller) => {
            this.showCMXConnectorAdd(true, false, true);
            this.selectedController = controller;
            this.controllerObj.connectorName = this.selectedConnector.name;
            this.controllerObj.connectorId = this.selectedConnector.id;
            this.controllerObj.connectorVersion = this.selectedConnector.version;
            this.displayeWLCcommands(this.controllerObj.connectorId);
            //added as fix for CSCwd71299
            this.displayTestConnectivity =
                this.selectedConnector.connectorStatus === "Active" &&
                    this.validateConnectorVersion(this.selectedConnector);
            if (this.selectedConnector.version && this.selectedConnector.version === 'V3') {
                this.displayTestConnectivity = true;
            }
            //CSCwd71299 end
            this.controllerObj.isAssociateController = true;
            this.controllerObj.controllerIp = this.selectedController.controllerIp;
            this.controllerObj.name = this.selectedController.name;
            this.controllerObj.snmp = Object.assign({}, this.selectedController.snmp);
            this.controllerObj.type = this.selectedController.type;
            if (this.selectedController.type === "ewlc") {
                this.controllerObj.type = this.selectedController.type;
                this.controllerObj.login = Object.assign({}, this.selectedController.login);
                this.controllerObj.login.password = "";
                this.controllerObj.login.enablePassword = "";
                this.controllerObj.login.netconfPassword = "";
            }
            else {
                if (!this.controllerObj.wsaConfig) {
                    this.initializeWSAConfig();
                }
                else if (this.controllerObj.wsaConfig) {
                    this.controllerObj.wsaConfig = Object.assign({}, this.selectedController.wsaConfig);
                }
                if (!this.controllerObj.aireOSLogin) {
                    this.initializeAireOSLogin();
                }
                else if (this.controllerObj.aireOSLogin) {
                    this.controllerObj.aireOSLogin = Object.assign({}, this.selectedController.aireOSLogin);
                    this.controllerObj.aireOSLogin.username = "";
                    this.controllerObj.aireOSLogin.password = "";
                }
            }
            // making password field(s) empty
            if (this.controllerObj.snmp.version == "v2c") {
                this.controllerObj.snmp.community = "";
            }
            else if (this.controllerObj.snmp.version == "v3") {
                this.controllerObj.snmp.userName = "";
                this.controllerObj.snmp.password = "";
                this.controllerObj.snmp["privacy-password"] = "";
            }
        };
        this.updateController = (controllerId) => {
            if (this.validateUI() == false) {
                return false;
            }
            this.removeAttributes();
            this.dataService.display(true);
            // adding new ojects - wsaConfig and initializeAireOSLogin
            if (this.controllerObj.wsaConfig &&
                this.controllerObj.wsaConfig.isSubscribed == undefined) {
                this.initializeWSAConfig();
            }
            if (this.controllerObj.aireOSLogin &&
                this.controllerObj.aireOSLogin.cliCredentialsAvailable == undefined) {
                this.initializeAireOSLogin();
            }
            this.cmxConnectorsService
                .updateController(controllerId, this.controllerObj)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.data != "" && response.data != null) {
                    this.dataService.setToastMessage(this.messageKeys["controller_updated_success"], 4000, null, null, "success");
                    this.showCMXConnectorAdd(false, false, false);
                    //this.onShowControllerList(this.selectedConnector);
                    this.getConnectorAssociatedControllers(this.currentConnector);
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys["error_occurred_updating_contr"], 4000, null, null, "error");
                }
                const userNameForInteractionLog = this.dataService.getUserName();
                const logStr = "Update: User " +
                    userNameForInteractionLog +
                    " has updated controller " +
                    this.controllerObj.name;
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.UPDATE, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.POPUP, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["error_occurred_updating_contr"], 4000, null, null, "error");
                console.log("update controller api error :: ", error.status);
                const userNameForInteractionLog = this.dataService.getUserName();
                const logStr = "ERROR: Update: User " +
                    userNameForInteractionLog +
                    " has updated controller " +
                    this.controllerObj.name;
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.ERROR, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.POPUP, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
            });
        };
        this.checkConnectorNameExist = () => {
            let nameExists = false;
            let nameLength = false;
            this.cmxConnectorList.forEach((connector, index) => {
                if (connector.name != undefined) {
                    if (connector.name == this.controllerObj.connectorName.trim()) {
                        this.cmxConnectorError =
                            "A connector with this name already exists. try another";
                        nameExists = true;
                        return nameExists;
                    }
                }
            });
            if (this.controllerObj.connectorName.trim().length > 64) {
                this.cmxConnectorError =
                    "Please enter a name with less than 64 characters";
                nameLength = true;
                return nameLength;
            }
        };
        this.validateUI = () => {
            this.cmxConnectorError = "";
            if (this.controllerObj.connectorName == "" ||
                this.controllerObj.connectorName == null) {
                this.cmxConnectorError = "Please enter connector name";
            }
            else if (this.editControllerPopup == true ||
                this.isConnectorAvailable == true ||
                this.controllerObj.isAssociateController == true) {
                if (this.cmxConnectorError == "" &&
                    (this.controllerObj.controllerIp == "" ||
                        this.controllerObj.controllerIp == null)) {
                    this.cmxConnectorError = "Please enter controller ip";
                }
                else if (!this.validateIPAddress()) {
                    this.cmxConnectorError =
                        "Please enter valid controller ip address";
                }
                else if (this.cmxConnectorError == "" &&
                    (this.controllerObj.name == "" ||
                        this.controllerObj.name == null)) {
                    this.cmxConnectorError = "Please enter controller name";
                }
                else if (this.cmxConnectorError == "" &&
                    this.controllerObj.type == "" &&
                    (this.controllerObj.snmp.controllerType == "" ||
                        this.controllerObj.snmp.controllerType == "-- Select --")) {
                    this.cmxConnectorError = "Please select controller type";
                }
                else if (this.controllerObj.type === "ewlc") {
                    // if (this.cmxConnectorError == "" && (this.controllerObj.login.netconfUsername == "")) {
                    //   this.cmxConnectorError = "Please enter netconf username";
                    // } else if (this.cmxConnectorError == "" && (this.controllerObj.login.netconfPassword == "")) {
                    //   this.cmxConnectorError = "Please enter netconf password";
                    // }
                    if (this.cmxConnectorError == "" &&
                        this.controllerObj.login.username == "") {
                        this.cmxConnectorError =
                            "Please select ssh username";
                    }
                    else if (this.cmxConnectorError == "" &&
                        this.controllerObj.login.password == "") {
                        this.cmxConnectorError =
                            "Please select ssh password";
                    }
                }
                else if (this.cmxConnectorError == "" &&
                    (this.controllerObj.snmp.version == "" ||
                        this.controllerObj.snmp.version == "-- Select --")) {
                    this.cmxConnectorError = "Please select snmp version";
                }
                else if (this.controllerObj.snmp.version == "v2c") {
                    if (this.cmxConnectorError == "" &&
                        (this.controllerObj.snmp.community == "" ||
                            this.controllerObj.snmp.community == null)) {
                        this.cmxConnectorError = "Please enter snmp RW Community";
                    }
                }
                else if (this.controllerObj.snmp.version == "v3") {
                    if (this.cmxConnectorError == "" &&
                        (this.controllerObj.snmp.userName == "" ||
                            this.controllerObj.snmp.userName == null)) {
                        this.cmxConnectorError = "Please enter username";
                    }
                    else if (this.cmxConnectorError == "" &&
                        this.controllerObj.snmp["auth-protocol"] != "None" &&
                        (this.controllerObj.snmp.password == "" ||
                            this.controllerObj.snmp.password == null)) {
                        this.cmxConnectorError = "Please enter password";
                    }
                    else if (this.cmxConnectorError == "" &&
                        (this.controllerObj.snmp["auth-protocol"] == "" ||
                            this.controllerObj.snmp["auth-protocol"] ==
                                "-- Select --")) {
                        this.cmxConnectorError = "Please select auth protocol type";
                    }
                    else if (this.cmxConnectorError == "" &&
                        (this.controllerObj.snmp["privacy-protocol"] == "" ||
                            this.controllerObj.snmp["privacy-protocol"] ==
                                "-- Select --")) {
                        this.cmxConnectorError =
                            "Please select privacy protocol type";
                    }
                    else if (this.cmxConnectorError == "" &&
                        this.controllerObj.snmp["privacy-protocol"] != "None" &&
                        (this.controllerObj.snmp["privacy-password"] == "" ||
                            this.controllerObj.snmp["privacy-password"] == null)) {
                        this.cmxConnectorError = "Please enter privacy password";
                    }
                }
                // type is wlc then check new object
                if (this.controllerObj.type == "WLC") {
                    // aireOSLogin object validation
                    if (this.controllerObj.aireOSLogin.cliCredentialsAvailable) {
                        if (this.cmxConnectorError == "" &&
                            (this.controllerObj.aireOSLogin.username == "" ||
                                this.controllerObj.aireOSLogin.username == null)) {
                            this.cmxConnectorError =
                                "Please enter aireOSLogin username";
                        }
                        else if (this.cmxConnectorError == "" &&
                            (this.controllerObj.aireOSLogin.password == "" ||
                                this.controllerObj.aireOSLogin.password == null)) {
                            this.cmxConnectorError =
                                "Please enter aireOSLogin password";
                        }
                    }
                }
            }
            if (this.cmxConnectorError == "") {
                return true;
            }
            else {
                this.dataService.setToastMessage(this.messageKeys[this.cmxConnectorError], 6000, null, null, "error");
                return false;
            }
        };
        this.onShowControllerList = (connector) => {
            this.selectedConnector = connector ? Object.assign({}, connector) : {};
            this.dataService.display(true);
            this.controllerListLoaded = false;
            let controllerListForTenant = [];
            this.controllerList = [];
            this.cmxConnectorsService
                .getControllers(connector)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                console.log(data);
                if (data != "" && data != null) {
                    // getting all controller of tenant(customer)
                    controllerListForTenant = data;
                    this.accountControllerList = controllerListForTenant;
                    // getting controllers for the corresponding connector (using connctorId)
                    if (controllerListForTenant &&
                        controllerListForTenant.length > 0) {
                        controllerListForTenant.forEach((controllerTenant) => {
                            if (controllerTenant.connectorId ==
                                this.selectedConnector.id) {
                                this.controllerList.push(controllerTenant);
                            }
                        });
                    }
                    console.log(this.controllerList);
                    if (this.controllerList &&
                        this.controllerList.length > 0) {
                        this.connectorsDownCountV2 = 0;
                        this.connectorsDownCount = 0;
                        this.connectorsUpCount = 0;
                        this.connectorsUpCountV2 = 0;
                        this.controllerList.forEach((controller, index) => {
                            if (controller.name == undefined) {
                                if (index != 0) {
                                    controller.name = "Controller " + index;
                                }
                                else {
                                    controller.name = "Controller";
                                }
                            }
                            // access point size calculation
                            controller.accessPointsCount = 0;
                            // numberOfAps from controller oject - new response format
                            if (controller.report &&
                                controller.report.numberOfAps) {
                                controller.accessPointsCount =
                                    controller.report.numberOfAps;
                            }
                            // Old Code
                            // if (this.selectedConnector.connectorStatus == "Active" && controller.accessPointsCount > 0) {
                            //   controller.connectionStatus = "Active";
                            // } else {
                            //   controller.connectionStatus = "Inactive";
                            // }
                            // New Code as per the report status
                            if (this.selectedConnector.connectorStatus ==
                                "Active") {
                                if (controller.report != undefined) {
                                    if (controller.report.status !=
                                        undefined) {
                                        if (controller.report.status ==
                                            "ACTIVE") {
                                            controller.connectionStatus =
                                                "Up"; //"Active";
                                        }
                                        else {
                                            controller.connectionStatus =
                                                "Down"; //"Inactive";
                                        }
                                    }
                                    else {
                                        controller.connectionStatus =
                                            "Down"; //"Inactive";
                                    }
                                }
                                else {
                                    controller.connectionStatus =
                                        "Down"; //"Inactive";
                                }
                            }
                            else {
                                controller.connectionStatus = "Down"; //"Inactive";
                            }
                            if (controller.connectionStatus == "Down") {
                                if (this.fromWiredNetwork) {
                                    this.connectorsDownCountV2 = this.connectorsDownCountV2 + 1;
                                }
                                else {
                                    this.connectorsDownCount = this.connectorsDownCount + 1;
                                }
                            }
                            else {
                                if (this.fromWiredNetwork) {
                                    this.connectorsUpCountV2 = this.connectorsUpCountV2 + 1;
                                }
                                else {
                                    this.connectorsUpCount = this.connectorsUpCount + 1;
                                }
                            }
                        });
                    }
                    setTimeout(() => {
                        this.dataService.display(false);
                    }, 100);
                    this.controllerListLoaded = true;
                }
                else {
                    this.dataService.display(false);
                    // this.dataService.setToastMessage(data.message, 4000, null, null, 'error');
                    console.log("Controller List is empty");
                    this.controllerListLoaded = true;
                }
            }, (error) => {
                this.dataService.display(false);
                this.controllerListLoaded = true;
            });
            this.showControllers.emit();
            if (location.pathname.indexOf("setup/connector") > -1 ||
                location.pathname.indexOf("setup/wirednetwork/connectors") > -1) {
                this.showConnectors = true; //C3
            }
        };
        this.onShowSwitchList = (connector) => {
            this.showConnectors = false;
            this.showSwitchList = true;
            this.switchConnector = connector;
        };
        this.deleteConnector = (connectorId) => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .deleteConnector(connectorId)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                /*if (data != "" && data != null) {
                  this.dataService.setToastMessage(
                    "Connector deleted successfully",
                    4000,
                    null,
                    null,
                    "success"
                  ); june 8*/
                if (response.status == true) {
                    this.dataService.setToastMessage(this.messageKeys["connector_deleted"], 4000, null, null, "success");
                    this.getCMXConnectors();
                }
                else if (response.status == false) {
                    this.dataService.setToastMessage(this.messageKeys["delete_connector_failed"], 4000, null, null, "error");
                }
                else {
                    this.dataService.display(false);
                    // this.dataService.setToastMessage(data.message, 4000, null, null, 'error');
                    console.log("Controller List is empty");
                }
                const userNameForInteractionLog = this.dataService.getUserName();
                const logStr = "Delete: User " +
                    userNameForInteractionLog +
                    " has deleted Spaces Connector " +
                    connectorId;
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.DELETE, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.SCREEN, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
            }, (error) => {
                this.dataService.display(false);
                const userNameForInteractionLog = this.dataService.getUserName();
                const logStr = "ERROR: Delete: User " +
                    userNameForInteractionLog +
                    " has deleted Spaces Connector " +
                    connectorId;
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.ERROR, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.SCREEN, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
            });
        };
        this.deleteController = (controllerId) => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .deleteController(controllerId)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data != "" && data != null && data.status == true) {
                    this.dataService.setToastMessage(this.messageKeys["controller_deleted"], 4000, null, null, "success");
                    //	this.onShowControllerList(this.selectedConnector);
                    this.getConnectorAssociatedControllers(this.currentConnector);
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys["controller_delete_failed"], 4000, null, null, 'error');
                    console.log("Controller List is empty");
                }
                const userNameForInteractionLog = this.dataService.getUserName();
                const logStr = "Delete: User " +
                    userNameForInteractionLog +
                    " has deleted controller " +
                    controllerId;
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.DELETE, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.SCREEN, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
            }, (error) => {
                this.dataService.display(false);
                const userNameForInteractionLog = this.dataService.getUserName();
                const logStr = "ERROR: Delete: User " +
                    userNameForInteractionLog +
                    " has deleted controller " +
                    controllerId;
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.ERROR, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.SCREEN, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
            });
        };
        //TR
        this.restartConnector = (connector) => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .restartConnector(connector.id)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data === "" || data === null) {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys["restart_connector_failed"], 4000, null, null, "error");
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["connector_restart_success"], 4000, null, null, "success");
                    this.getCMXConnectors();
                }
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["restart_connector_failed"], 4000, null, null, "error");
            });
        };
        this.uploadConnectorLogs = (connector) => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .uploadConnectorLogs(connector.id)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data === "" || data === null) {
                    this.dataService.setToastMessage(this.messageKeys["connector_logs_failed"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["connector_logs_uploaded"], 4000, null, null, "success");
                    this.dataService.display(false);
                }
            }, (error) => {
                this.dataService.setToastMessage(this.messageKeys["connector_logs_failed"], 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        //TR
        this.uploadConnectorV3Logs = (connector) => {
            this.dataService.display(true);
            var seuccessVerify = 0;
            if (this.serviceList && this.serviceList.length > 0) {
                const count = this.serviceList.length;
                this.serviceList.forEach(service => {
                    if (service.status == 'ENABLED')
                        this.cmxConnectorsService
                            .uploadConnectorV3Logs(connector.id, service.name)
                            .pipe(takeUntil(this.unsubscribe$))
                            .subscribe((response) => {
                            if (response.status != true) {
                                this.dataService.setToastMessage(this.messageKeys["connector_logs_failed"], 4000, null, null, "error");
                                this.dataService.display(false);
                            }
                            else {
                                this.dataService.setToastMessage(this.messageKeys["connector_logs_uploaded"], 4000, null, null, "success");
                                this.dataService.display(false);
                            }
                        }, (error) => {
                            this.dataService.setToastMessage(this.messageKeys["connector_logs_failed"], 4000, null, null, "error");
                            this.dataService.display(false);
                        });
                });
            }
            else {
                this.dataService.setToastMessage(this.messageKeys["no_service_upload_connector"], 4000, null, null, "error");
                this.dataService.display(false);
            }
        };
        this.confirmV2Upgrade = (show, connector) => {
            if (show) {
                this.showV2UpgradePopup = show;
                this.dataService.openMagneticPopup();
                this.connectorToUpgrade = connector;
            }
            else {
                this.dataService.closeMagneticPopup();
                this.showV2UpgradePopup = show;
            }
        };
        this.upgradeConnector = (connector) => {
            this.confirmV2Upgrade(false, connector);
            this.dataService.display(true);
            this.cmxConnectorsService
                .upgradeConnector(connector.id)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data === "" || data === null) {
                    this.dataService.setToastMessage(this.messageKeys["upgrade_failed"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["upgrade_successful"], 4000, null, null, "success");
                    this.dataService.display(false);
                }
            }, (error) => {
                this.dataService.setToastMessage(this.messageKeys["upgrade_failed"], 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        this.enableDebug = () => {
            this.selectedConnector.service.enableDebug =
                !this.selectedConnector.service.enableDebug;
            this.dataService.display(true);
            this.cmxConnectorsService
                .enableDebug(this.selectedConnector.id, this.selectedConnector.service.enableDebug)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data === "" || data === null) {
                    this.dataService.setToastMessage(this.messageKeys["connector_debug_failed"], 4000, null, null, "error");
                    this.selectedConnector.service.enableDebug =
                        !this.selectedConnector.service.enableDebug;
                    this.dataService.display(false);
                }
                else {
                    if (this.selectedConnector.service.enableDebug) {
                        this.dataService.setToastMessage(this.messageKeys["connector_debug_success"], 4000, null, null, "success");
                    }
                    else {
                        this.dataService.setToastMessage(this.messageKeys["connector_debug_disabled"], 4000, null, null, "success");
                    }
                    this.dataService.display(false);
                    this.getCMXConnectors();
                }
            }, (error) => {
                this.dataService.setToastMessage(this.messageKeys["connector_toggle_failed"], 4000, null, null, "error");
                this.selectedConnector.service.enableDebug =
                    !this.selectedConnector.service.enableDebug;
                this.dataService.display(false);
            });
        };
        //TR
        this.autoUpgrade = () => {
            this.selectedConnector.service.autoUpgradeConfig.autoUpgrade =
                !this.selectedConnector.service.autoUpgradeConfig.autoUpgrade;
            this.saveUpgradeChanges(!this.selectedConnector.service.autoUpgradeConfig.autoUpgrade);
        };
        this.saveUpgradeChanges = (disabled) => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .autoUpgrade(this.selectedConnector.id, this.selectedConnector.service.autoUpgradeConfig)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data === "" || data === null) {
                    if (disabled) {
                        this.dataService.setToastMessage(this.messageKeys["auto_upgrade_failed"], 4000, null, null, "error");
                    }
                    else {
                        this.dataService.setToastMessage(this.messageKeys["enable_auto_upgrade_failed"], 4000, null, null, "error");
                    }
                    this.selectedConnector.service.autoUpgradeConfig.autoUpgrade =
                        !this.selectedConnector.service.autoUpgradeConfig
                            .autoUpgrade;
                    this.dataService.display(false);
                }
                else {
                    if (disabled) {
                        this.dataService.setToastMessage(this.messageKeys["auto_upgrade_success"], 4000, null, null, "success");
                    }
                    else {
                        this.dataService.setToastMessage(this.messageKeys["auto_upgrade_enabled"], 4000, null, null, "success");
                    }
                    this.dataService.display(false);
                    this.getCMXConnectors();
                }
            }, (error) => {
                if (disabled) {
                    this.dataService.setToastMessage(this.messageKeys["auto_upgrade_failed"], 4000, null, null, "error");
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["enable_auto_upgrade_failed"], 4000, null, null, "error");
                }
                this.selectedConnector.service.autoUpgradeConfig.autoUpgrade =
                    !this.selectedConnector.service.autoUpgradeConfig
                        .autoUpgrade;
                this.dataService.display(false);
            });
        };
        this.onChangeUpgradeTime = () => {
            let tempTime = this.selectedConnector.twelveHourTime;
            if (tempTime === 12) {
                tempTime = tempTime - 12;
            }
            this.selectedConnector.service.autoUpgradeConfig.autoUpgradeTimeRange.startVal =
                this.selectedConnector.amPmTime ? tempTime : tempTime + 12;
        };
        //TR
        this.viewManageStreams = (cmxConnector, service) => {
            this.showManageStreams = true;
            this.dataService.openMagneticPopup();
            this.selectedConnector = cmxConnector
                ? Object.assign({}, cmxConnector)
                : {};
            this.selectedId = this.selectedConnector.id;
            this.getConfigStatusDetails(this.selectedId);
            this.serviceToConfigure = service;
        };
        this.viewSwitchesList = (connector, service) => {
            this.toggleSwitchesPopup(true);
            this.selectedConnector = connector ? Object.assign({}, connector) : {};
            this.selectedId = this.selectedConnector.id;
            this.getConfigStatusDetails(this.selectedId);
            this.serviceToConfigure = service;
        };
        this.toggleSwitchesPopup = (state) => {
            this.showSwitchesList = state;
            if (this.showSwitchesList) {
                this.dataService.openMagneticPopup();
            }
            else {
                this.dataService.closeMagneticPopup();
            }
        };
        /**
         * Get Manage Stream Configuration Status
         * @param connectorId
         */
        this.getConfigStatusDetails = (connectorId) => {
            this.infoObj = {};
            this.dataService.display(true);
            this.cmxConnectorsService
                .getConfigStatus(connectorId)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                const { configurableState, operationName, operationStatus, info } = response;
                const opStatus = operationStatus.split("_").join(" ");
                this.configOperationName = operationName;
                this.configurableState = configurableState;
                this.configOperationStatus = opStatus;
                this.toggleConfigStatusflag = false;
                if (this.showManageStreams) {
                    this.getAllEwlcStreamStatus(connectorId);
                }
                else if (this.showSwitchesList) {
                    this.getAllSwitchesStreamStatus(connectorId);
                }
                // configure switch changes
                setTimeout(() => {
                    this.dataService.display(false);
                }, 2000);
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["unable_fetch_status"], 4000, null, null, "error");
            });
        };
        /**
         * Get Manage Streams Controllers associated with connector
         * @param connectorId
         */
        this.getAllEwlcStreamStatus = (connectorId) => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .getAllEwlcStreamStatus(connectorId)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                this.dataService.display(false);
                const { configStatusList = [] } = response;
                this.controllerStreams = configStatusList;
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["unable_controller_details"], 4000, null, null, "error");
            });
        };
        this.getAllSwitchesStreamStatus = (connectorId) => {
            this.cmxConnectorsService
                .getAllSwitchesStatus(connectorId)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                this.switchStreamInfo = [];
                const { configStatusList = [] } = response;
                this.controllerStreams = configStatusList;
                this.controllerStreams.forEach(streamInfo => {
                    const values = streamInfo.configStatus;
                    this.switchObjTemp = {};
                    if (values !== undefined && values.info && values.info.operationType) {
                        const switchInfo = values.info;
                        this.switchObjTemp.destSpanVlan = switchInfo.destSpanVlan;
                        this.switchObjTemp.destSpanVlanIpAddress = switchInfo.destSpanVlanIpAddress; // this.infoObj["destSpanVlanIpAddress"] ? this.infoObj["destSpanVlanIpAddress"] : "124.124.124.1";
                        this.switchObjTemp.sourceSpanVlanList = switchInfo.sourceSpanVlanList; //this.infoObj["sourceSpanVlanList"] ? this.infoObj["sourceSpanVlanList"] : ["50"];
                        this.switchObjTemp.monitorOriginIpAddress = switchInfo.monitorOriginIpAddress; //this.infoObj["monitorOriginIpAddress"] ? this.infoObj["monitorOriginIpAddress"] : "124.124.124.1";
                        this.switchObjTemp.appSpanIpAddress = switchInfo.appSpanIpAddress; //this.infoObj["appSpanIpAddress"] ? this.infoObj["appSpanIpAddress"] : "124.124.124.2";
                        this.switchObjTemp.appDnasVlan = switchInfo.appDnasVlan; //this.infoObj["appDnasVlan"] ? this.infoObj["appDnasVlan"] : "243";
                        this.switchObjTemp.appIpAddress = switchInfo.appIpAddress; //this.infoObj["appIpAddress"] ? this.infoObj["appIpAddress"] : "10.22.243.66";
                        this.switchObjTemp.appNetmask = switchInfo.appNetmask; //this.infoObj["appNetmask"] ? this.infoObj["appNetmask"] : "255.255.255.0";
                        this.switchObjTemp.appGatewayAddress = switchInfo.appGatewayAddress; //this.infoObj["appGatewayAddress"] ? this.infoObj["appGatewayAddress"] : "10.22.243.1";
                        this.switchObjTemp.useDhcp = switchInfo.useDhcp;
                        this.switchObjTemp.name = streamInfo.name;
                        this.switchObjTemp.saveConfig = false; //switchInfo.saveConfig; let the user exclusively select this option rather than remembering the decision
                    }
                    else {
                        this.switchObjTemp.destSpanVlan = '';
                        this.switchObjTemp.destSpanVlanIpAddress = ''; // this.infoObj["destSpanVlanIpAddress"] ? this.infoObj["destSpanVlanIpAddress"] : "124.124.124.1";
                        this.switchObjTemp.sourceSpanVlanList = ''; //this.infoObj["sourceSpanVlanList"] ? this.infoObj["sourceSpanVlanList"] : ["50"];
                        this.switchObjTemp.monitorOriginIpAddress = ''; //this.infoObj["monitorOriginIpAddress"] ? this.infoObj["monitorOriginIpAddress"] : "124.124.124.1";
                        this.switchObjTemp.appSpanIpAddress = ''; //this.infoObj["appSpanIpAddress"] ? this.infoObj["appSpanIpAddress"] : "124.124.124.2";
                        this.switchObjTemp.appDnasVlan = ''; //this.infoObj["appDnasVlan"] ? this.infoObj["appDnasVlan"] : "243";
                        this.switchObjTemp.appIpAddress = ''; //this.infoObj["appIpAddress"] ? this.infoObj["appIpAddress"] : "10.22.243.66";
                        this.switchObjTemp.appNetmask = ''; //this.infoObj["appNetmask"] ? this.infoObj["appNetmask"] : "255.255.255.0";
                        this.switchObjTemp.appGatewayAddress = ''; //this.infoObj["appGatewayAddress"] ? this.infoObj["appGatewayAddress"] : "10.22.243.1";
                        this.switchObjTemp.useDhcp = 'false';
                        this.switchObjTemp.name = '';
                        this.switchObjTemp.saveConfig = false;
                    }
                    this.switchStreamInfo.push(this.switchObjTemp);
                    this.dataService.display(false);
                });
            }, (error) => {
                this.dataService.setToastMessage(this.messageKeys["unable_switch_details"], 4000, null, null, "error");
            });
        };
        /**
         * Display Manage Streams Controller Enable/disable logs
         * @param controller
         */
        this.onControllerStreamLogsClick = (controller) => {
            this.getConfigStatusDetails(this.currentConnector.id);
            if (controller) {
                this.displayStreamLogs = true;
                const { configStatus = {} } = controller;
                const { uiInfo = {} } = configStatus;
                const { disableFlow = {}, enableFlow = {} } = uiInfo;
                const { data: enableData = [] } = enableFlow;
                const { data: disableData = [] } = disableFlow;
                this.enableControllerStreamLogs = enableData;
                this.disableControllerStreamLogs = disableData;
                if (this.toggleLogsTable) {
                    this.controllerLogs = [
                        { label: "Enable Stream Logs", value: enableData },
                        { label: "Disable Stream Logs", value: disableData }
                    ];
                }
                else {
                    this.controllerLogs = [
                        { label: "Disable Stream Logs", value: disableData },
                        { label: "Enable Stream Logs", value: enableData }
                    ];
                }
            }
            else {
                this.controllerLogs = [
                    { label: "Enable Stream Logs", value: [] },
                    { label: "Disable Stream Logs", value: [] }
                ];
                this.displayStreamLogs = false;
            }
        };
        this.onSwitchStreamLogsClick = (controller) => {
            this.getConfigStatusDetails(this.currentConnector.id);
            if (controller) {
                this.displayStreamLogs = true;
                const { configStatus = {} } = controller;
                const { uiInfo = {} } = configStatus;
                const { disableFlow = {}, enableFlow = {} } = uiInfo;
                const { data: enableData = [] } = enableFlow;
                const { data: disableData = [] } = disableFlow;
                this.enableControllerStreamLogs = enableData;
                this.disableControllerStreamLogs = disableData;
                if (this.toggleLogsTable) {
                    this.controllerLogs = [
                        { label: "Enable Stream Logs", value: enableData },
                        { label: "Disable Stream Logs", value: disableData }
                    ];
                }
                else {
                    this.controllerLogs = [
                        { label: "Disable Stream Logs", value: disableData },
                        { label: "Enable Stream Logs", value: enableData }
                    ];
                }
            }
            else {
                this.controllerLogs = [
                    { label: "Enable Stream Logs", value: [] },
                    { label: "Disable Stream Logs", value: [] }
                ];
                this.displayStreamLogs = false;
            }
        };
        /**
         * Toggle Manage Stream Configuration status.
         */
        this.toggleConfigStatus = () => {
            const connectorId = this.selectedConnector.id;
            if (this.selectedConnector.version == 'V2') {
                this.cmxConnectorsService
                    .toggleConfigurationStatus(connectorId)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((response) => {
                    this.toggleConfigStatusflag = true;
                    this.getConfigStatusDetails(connectorId);
                    this.configStatusTimeout = setTimeout(() => this.getConfigStatusDetails(connectorId), 10000);
                    this.dataService.setToastMessage(this.messageKeys["configuration_success"], 4000, null, null, "success");
                }, (error) => {
                    this.dataService.setToastMessage(this.messageKeys["unable_fetch_status"], 4000, null, null, "error");
                });
            }
            else {
                if (this.serviceToConfigure) {
                    this.cmxConnectorsService
                        .toggleConfigurationStatusV3(connectorId, this.serviceToConfigure.serviceName)
                        .pipe(takeUntil(this.unsubscribe$))
                        .subscribe((response) => {
                        this.toggleConfigStatusflag = true;
                        this.getConfigStatusDetails(connectorId);
                        this.configStatusTimeout = setTimeout(() => this.getConfigStatusDetails(connectorId), 10000);
                        this.dataService.setToastMessage(this.messageKeys["configuration_success"], 4000, null, null, "success");
                    }, (error) => {
                        this.dataService.setToastMessage(this.messageKeys["unable_fetch_status"], 4000, null, null, "error");
                    });
                }
            }
        };
        this.hideManageStreams = () => {
            clearInterval(this.ewlcInterval);
            clearTimeout(this.configStatusTimeout);
            clearInterval(this.switchInterval);
            this.toggleConfigStatusflag = false;
            this.showManageStreams = false;
            this.dataService.closeMagneticPopup();
            this.displayTokens = false;
            this.displayStreamLogs = false;
            this.toggleLogsTable = true;
            this.controllerLogs = [
                { label: "Enable Stream Logs", value: [] },
                { label: "Disable Stream Logs", value: [] }
            ];
        };
        this.hideManageServices = () => {
            clearInterval(this.ewlcInterval);
            clearTimeout(this.configStatusTimeout);
            clearInterval(this.switchInterval);
            this.showSwitchesList = false;
            this.dataService.closeMagneticPopup();
            this.displayTokens = false;
            this.displayStreamLogs = false;
            this.toggleLogsTable = true;
            this.controllerLogs = [
                { label: "Enable Stream Logs", value: [] },
                { label: "Disable Stream Logs", value: [] }
            ];
        };
        this.hideCertificates = () => {
            this.displayTokens = false;
            this.authToken = "";
            this.certificate = "";
            this.getConfigStatusDetails(this.currentConnector.id); //added as a fix for ManageIOT popup 27 Oct 2022
        };
        this.viewAccessToken = (cmxConnector, url, payloadAttr, tokenTitle) => {
            const { report = {} } = cmxConnector;
            const { connector = {} } = report;
            const { ipAddress } = connector;
            if (!ipAddress && tokenTitle === "Stream Auth Key") {
                this.noIPAddressBanner = true;
            }
            else {
                this.selectedConnector = cmxConnector
                    ? Object.assign({}, cmxConnector)
                    : {};
                this.selectedId = this.selectedConnector.id;
                this.url = url;
                this.payloadAttr = payloadAttr;
                this.tokenTitle = tokenTitle;
                if (this.selectedConnector.version == 'V3') {
                    this.showAccessTokenPopupV3 = true;
                }
                else {
                    this.showAccessTokenPopup = true;
                }
                this.dataService.openMagneticPopup();
            }
        };
        this.displayeWLCcommands = (id) => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .geteWLCcommands(id)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                const data = response.data;
                const { message = [], commands = [] } = data;
                if (message.length > 0 || commands.length > 0) {
                    this.ewlcMessages = message;
                    this.ewlcCommandsList = commands;
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["unable_fetch_catalyst"], 4000, null, null, "error");
                }
                this.dataService.display(false);
            }, (error) => {
                this.dataService.setToastMessage(this.messageKeys["unable_fetch_catalyst"], 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        this.copyToken = () => {
            this.dataService.setToastMessage(this.messageKeys["token_copied"], 4000, null, null, "success");
        };
        this.copyConfig = () => {
            this.dataService.setToastMessage(this.messageKeys["config_copied"], 4000, null, null, "success");
        };
        this.copyCLIcommands = () => {
            const text = this.ewlcCommandsList.join("\n");
            const canCopy = document.queryCommandSupported("copy");
            if (canCopy) {
                // create input element
                const tokenInput = document.createElement("textarea");
                // set input value to text
                tokenInput.value = text;
                // append input to document body
                document.body.appendChild(tokenInput);
                // select the input dom node
                tokenInput.select();
                // copy the value of the selected node
                // to the clipboard
                document.execCommand("copy");
                // remove the input from the dom
                document.body.removeChild(tokenInput);
            }
            this.dataService.setToastMessage(this.messageKeys["cli_comm_copied"], 4000, null, null, "success");
        };
        this.hideAccessToken = () => {
            this.showAccessTokenPopup = false;
            this.showAccessTokenPopupV3 = false;
            this.dataService.closeMagneticPopup();
        };
        this.openMoreOptions = (entity) => {
            // this.showMoreOptions = entity;
            this.selectedCustomerName = entity.name;
            $("body").unbind("click");
            setTimeout(() => {
                $("body").bind("click", (event) => {
                    this.closeMenu(event);
                    $("body").unbind("click");
                });
            }, 1);
        };
        this.closeMenu = (event) => {
            this.showMoreOptions = null;
            this.selectedCustomerName = "";
        };
        this.validateForAccessToken = (selectedConnector) => {
            this.accessTokenError = "";
            if (this.accessTokenEmail == "" || this.accessTokenEmail == null) {
                this.accessTokenError = "Please enter email";
            }
            else if ((this.accessTokenError =
                "" &&
                    (this.accessTokenPassword == "" ||
                        this.accessTokenPassword == null))) {
                this.accessTokenError = "Please enter password";
            }
            if (this.accessTokenError == "") {
                this.dataService.display(true);
                const obj = {
                    username: this.accessTokenEmail,
                    password: this.accessTokenPassword,
                    connectorId: selectedConnector.id
                };
                this.cmxConnectorsService
                    .getAccessToken(obj)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((response) => {
                    if (response.data != "" && response.data != null) {
                        this.accessCodeValue = response.data;
                        this.showAccessCodeString = true;
                        this.dataService.display(false);
                    }
                    else {
                        this.dataService.display(false);
                        this.dataService.setToastMessage(this.messageKeys["failed_access_token"], 4000, null, null, "error");
                    }
                    const userNameForInteractionLog = this.dataService.getUserName();
                    const logStr = "User " +
                        userNameForInteractionLog +
                        " has validated access token for Spaces Connector :: " +
                        selectedConnector.name;
                    this.interactionService.doInteractionLog(new InteractionLog(TYPE.DELETE, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.SCREEN, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
                });
            }
        };
        this.copyAccessToken = () => {
            this.hideAccessTokenPopup();
            // let accessCodeVal:any = document.getElementById("accessCode");
            // accessCodeVal.select();
            // document.execCommand("copy");
            // alert("copied text :: "+accessCodeVal.value);
        };
        this.hideAccessTokenPopup = () => {
            this.showAccessTokenPopup = false;
            this.showAccessTokenPopupV3 = false;
            this.showAccessCodeString = false;
            this.dataService.closeMagneticPopup();
        };
        this.editCMXConnector = (cmxConnector) => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .getControllers(cmxConnector)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data != "" && data != null) {
                }
                this.dataService.display(false);
            });
        };
        this.removeAttributes = () => {
            const { type } = this.controllerObj;
            if (type === "ewlc") {
                delete this.controllerObj.snmp;
                delete this.controllerObj.wsaConfig;
                delete this.controllerObj.aireOSLogin;
            }
            else if (this.controllerObj.snmp.controllerType === "WLC") {
                // delete this.controllerObj.type;
                delete this.controllerObj.login;
            }
            if (this.controllerObj.snmp &&
                this.controllerObj.snmp.version == "v2c") {
                delete this.controllerObj.snmp.userName;
                delete this.controllerObj.snmp.password;
                delete this.controllerObj.snmp["auth-protocol"];
                delete this.controllerObj.snmp["privacy-protocol"];
                delete this.controllerObj.snmp["privacy-password"];
            }
            else if (this.controllerObj.snmp &&
                this.controllerObj.snmp.version == "v3") {
                delete this.controllerObj.snmp.community;
            }
        };
        this.validateIPAddress = () => {
            if (/^((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))$/.test(
            /*/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/*/
            this.controllerObj.controllerIp)) {
                return true;
            }
            else {
                return false;
            }
        };
        this.validateIPGeneric = (address) => {
            if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(address)) {
                return true;
            }
            else {
                return false;
            }
        };
        this.validateSwitchIPAddress = () => {
            if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(this.switchObject.switchIp)) {
                if (this.switchModuleError == "Please enter a valid IP address") {
                    this.switchModuleError = "";
                }
                return true;
            }
            this.switchModuleError = "Please enter a valid IP address";
            return false;
        };
        this.onKey = (event) => {
            if (event.key != undefined) {
                if (event.key.charCodeAt(0) >= 32 &&
                    event.key.charCodeAt(0) <= 10175)
                    return true;
                else {
                    event.preventDefault();
                    return false;
                }
            }
        };
        this.clickEvents = ($event) => {
            //console.log('there is an click event', $event);
        };
        this.getCurrentConnectorItems = ($event) => {
            //console.log('currentl ist of items', $event);
            setTimeout(() => {
                this.currentConnectorItems = $event;
            }, 100);
        };
        this.onConnectorFilter = ($event) => {
            setTimeout(() => {
                this.connectorList_searched = $event;
            }, 100);
        };
        this.getCurrentControllerItems = ($event) => {
            //console.log('currentl ist of items', $event);
            this.dataService.display(true);
            setTimeout(() => {
                this.currentControllerItems = $event;
                this.dataService.display(false);
            }, 100);
        };
        this.getCurrentControllerItemsV2 = ($event) => {
            //console.log('currentl ist of items', $event);
            this.dataService.display(true);
            console.log("controller list items", this.controllerList);
            setTimeout(() => {
                this.currentControllerItemsV2 = $event;
                this.dataService.display(false);
            }, 100);
        };
        this.getControllerStreamItems = ($event) => {
            setTimeout(() => {
                this.controllerStreams = $event;
            }, 100);
        };
        this.onControllerFilter = ($event) => {
            this.dataService.display(true);
            setTimeout(() => {
                this.controllerList_searched = $event;
                this.dataService.display(false);
            }, 100);
        };
        this.onControllerFilterV2 = ($event) => {
            this.dataService.display(true);
            setTimeout(() => {
                console.log("controller list filter", this.controllerList);
                this.controllerList_searchedV2 = $event;
                this.dataService.display(false);
            }, 100);
        };
        this.onControllerStreamsFilter = ($event) => {
            setTimeout(() => {
                this.controllerStream_searched = $event;
            }, 100);
        };
        this.openRenameConnectorPopup = (show, connector) => {
            this.showRenameConnectorPopup = show;
            this.cmxConnectorError = "";
            this.initializeControllerObj();
            if (show == true) {
                this.dataService.openMagneticPopup();
                this.selectedConnector = connector
                    ? Object.assign({}, connector)
                    : {};
                this.controllerObj.connectorName = connector.name;
            }
            else if (show == false) {
                this.selectedConnector = {};
                this.dataService.closeMagneticPopup();
            }
        };
        this.openConnectorDetailsPopup = (show, connector) => {
            this.cmxConnectorError = "";
            this.viewConnector(connector, connector.name, null);
            if (show == true) {
                this.showConnectorDetailsPopup = show;
                this.dataService.openMagneticPopup();
            }
            else if (show == false) {
                this.selectedConnector = {};
                this.showConnectorDetailsPopup = show;
                this.connectorDetailsChart = new LineChart();
                this.showLoaderChartLoader = true;
                this.showConnectorDetails = false;
                this.dataService.closeMagneticPopup();
            }
        };
        this.openControllerDetailsPopup = (show, controller) => {
            if (show == true) {
                this.selectedController = controller;
                this.dataService.openMagneticPopup();
            }
            else if (show == false) {
                this.selectedController = {};
                this.dataService.closeMagneticPopup();
            }
            this.showControllerDetailsPopup = show;
        };
        this.getConnectorUpdateString = (serviceObj) => {
            if (!serviceObj.autoUpgradeConfig.autoUpgrade) {
                return "Not scheduled";
            }
            const timeObj = serviceObj.autoUpgradeConfig.autoUpgradeTimeRange;
            const twelveHourString = timeObj.startVal % 12;
            const amPM = timeObj.startVal < 12 ? "am" : "pm";
            return (this.dateStrings[timeObj.dayVal] +
                " at " +
                (twelveHourString === 0 ? "12" : twelveHourString) +
                ":00" +
                amPM);
        };
        this.onChangeUpgradeDate = (event) => {
            console.log("on change", event);
        };
        //TR
        this.openManageConnectorPopup = (show, connector) => {
            this.showManageConnectorPopup = show;
            this.cmxConnectorError = "";
            this.showResetPwdKey = false;
            this.pwdResetKey = '';
            console.log(connector, show);
            if (show == true) {
                this.dataService.openMagneticPopup();
                //this.selectedConnector = connector;
                this.selectedConnector.twelveHourTime =
                    connector.service.autoUpgradeConfig.autoUpgradeTimeRange
                        .startVal % 12;
                this.selectedConnector.amPmTime =
                    connector.service.autoUpgradeConfig.autoUpgradeTimeRange
                        .startVal < 12;
                // If v3 check for upgrade available & for v3 give option to restart Connector
            }
            else if (show == false) {
                this.dataService.closeMagneticPopup();
                //this.selectedConnector = {};
            }
        };
        //TR
        this.updateConnectorName = () => {
            this.cmxConnectorError = "";
            if (this.controllerObj.connectorName == "" ||
                this.controllerObj.connectorName == null) {
                this.cmxConnectorError = "Please enter connector name";
                return false;
            }
            else if (this.checkConnectorNameExist() == true) {
                return false;
            }
            else {
                let nameExists = false;
                let nameLength = false;
                this.cmxConnectorList.forEach((connector, index) => {
                    if (connector.name != undefined) {
                        if (connector.name == this.controllerObj.connectorName.trim()) {
                            this.cmxConnectorError =
                                "A connector with this name already exists. try another";
                            nameExists = true;
                            return !nameExists;
                        }
                    }
                });
                if (this.controllerObj.connectorName.trim().length > 64) {
                    this.cmxConnectorError =
                        "Please enter a name with less than 64 characters";
                    nameLength = true;
                    return !nameLength;
                }
            }
            if (this.cmxConnectorError == "") {
                this.dataService.display(true);
                const obj = {
                    associatedControllers: this.selectedConnector.associatedControllers,
                    name: this.controllerObj.connectorName
                };
                this.cmxConnectorsService
                    .updateConnectorName(this.selectedConnector.id, obj)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((response) => {
                    if (response.data != "" && response.data != null) {
                        this.dataService.setToastMessage(this.messageKeys["connector_update_success"], 4000, null, null, "success");
                        this.openRenameConnectorPopup(false, {});
                        this.getCMXConnectors();
                    }
                    else {
                        this.dataService.display(false);
                        this.dataService.setToastMessage(this.messageKeys["connector_failed"], 4000, null, null, "error");
                    }
                    const userNameForInteractionLog = this.dataService.getUserName();
                    const logStr = "User " +
                        userNameForInteractionLog +
                        " has updated Spaces Connector :: " +
                        this.controllerObj.connectorName;
                    this.interactionService.doInteractionLog(new InteractionLog(TYPE.UPDATE, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.SCREEN, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
                }, (error) => {
                    this.dataService.display(false);
                    console.log("updateConnectorName api error", error.status);
                    const userNameForInteractionLog = this.dataService.getUserName();
                    const logStr = "ERROR: User " +
                        userNameForInteractionLog +
                        " has updated Spaces Connector :: " +
                        this.controllerObj.connectorName;
                    this.interactionService.doInteractionLog(new InteractionLog(TYPE.ERROR, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.SCREEN, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
                });
            }
        };
        this.deleteControllerConfirmPopup = (controller) => {
            this.controllerToBeDeleted = controller;
            this.showDeleteControllerConfirmPopup = true;
            this.dataService.openMagneticPopup();
        };
        this.deleteControllerConfirm = () => {
            this.deleteController(this.controllerToBeDeleted.id);
            this.closeDeleteControllerPopup();
        };
        this.closeDeleteControllerPopup = () => {
            this.controllerToBeDeleted = null;
            this.showDeleteControllerConfirmPopup = false;
            this.dataService.closeMagneticPopup();
        };
        this.deleteConnectorConfirmPopup = (connector) => {
            this.connectorToBeDeleted = connector;
            this.showDeleteConnectorConfirmPopup = true;
            this.dataService.openMagneticPopup();
        };
        this.deleteConnectorConfirm = () => {
            this.deleteConnector(this.connectorToBeDeleted.id);
            this.closeDeleteConnectorConfirmPopup();
        };
        this.closeDeleteConnectorConfirmPopup = () => {
            this.connectorToBeDeleted = null;
            this.showDeleteConnectorConfirmPopup = false;
            this.dataService.closeMagneticPopup();
        };
        this.goBackToConnector = () => {
            this.showConnectors = true;
            this.getCMXConnectors();
        };
        this.toggleSaveButton = () => {
            const { connectorName, isAssociateController, controllerIp, name, snmp = {}, login = {}, type } = this.controllerObj;
            const { controllerType, version, community, userName, password } = snmp;
            const { netconfUsername, netconfPassword: pwd, username } = login;
            if (this.controllerCreateType.name == 'import') {
                if (this.controllerObj.connectorId && this.importFromConnector.id &&
                    (this.deviceIdsToImport.length || this.copyHotspotConfig === true) > 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
            if (isAssociateController || this.configPage === "controller") {
                if (type === "ewlc") {
                    return (connectorName &&
                        controllerIp &&
                        name &&
                        type &&
                        netconfUsername &&
                        pwd);
                }
                if (type === "WLC") {
                    if (version === "v2c") {
                        return (connectorName &&
                            controllerIp &&
                            name &&
                            controllerType !== "-- Select --" &&
                            community);
                    }
                    else if (version === "v3") {
                        return (connectorName &&
                            controllerIp &&
                            name &&
                            controllerType !== "-- Select --" &&
                            userName &&
                            snmp["auth-protocol"] &&
                            (snmp["auth-protocol"] === "None" || password) &&
                            snmp["privacy-protocol"] &&
                            (snmp["privacy-protocol"] === "None" ||
                                snmp["privacy-password"]));
                    }
                    else {
                        return false;
                    }
                }
            }
            else if (!isAssociateController) {
                return connectorName;
            }
            //C3 start
            /*if(!this.allowControllerCreation){
              return false;
            }*/
            if (this.controllerCreateType.name == 'import') {
                if (this.controllerObj.connectorId && this.importFromConnector.id &&
                    (this.deviceIdsToImport.length || this.copyHotspotConfig === true) > 0) {
                    return true;
                }
                else {
                    return false;
                }
            }
            //C3 end
        };
        this.goBack = () => {
            /*	if (this.fromWiredNetwork && this.showConnectorDetails ==false) {
                this.router.navigate(["/setup/wirednetwork"]);
              } else if(this.showConnectorDetails ==false) {
                this.router.navigate(["/setup/wirelessnetwork"]);
              }*/
            if (this.showConnectorDetails) {
                this.showConnectorDetails = !this.showConnectorDetails;
            }
            else {
                if (this.fromWiredNetwork && this.showConnectorDetails == false) {
                    this.router.navigate(["/setup/wirednetwork"]);
                }
                else if (this.showConnectorDetails == false) {
                    this.router.navigate(["/setup/wirelessnetwork"]);
                }
            }
        };
        this.goBackToSetup = () => {
            if (this.fromWiredNetwork) { //&& this.showConnectorDetails == false 21 nov 2022
                this.router.navigate(["/setup/wirednetwork"]);
                this.currentNav = "/setup/wirednetwork";
            }
            else { //if (this.showConnectorDetails == false) 21 nov 2022
                this.currentNav = "/setup/wirelessnetwork";
                this.router.navigate(["/setup/wirelessnetwork"]);
            }
            this.dataService.setCurrentNav(this.currentNav);
        };
        this.displayConnectivityMessages = (type, ping, ssh, snmp, snmpReadOnly) => {
            const pingStatus = ping.success;
            this.connectivityMessages = [];
            this.snmpReadOnlyMsg = "";
            // Check controller type
            if (type === "ewlc") {
                // Both ping and SSH success or SSH is success and ping failed
                if ((pingStatus && ssh) || (ssh && !pingStatus)) {
                    this.taskStatus["COMPLETED"] =
                        "Connectivity test completed successfully.";
                    this.status["COMPLETED"] = "success";
                }
                else if (pingStatus && !ssh) {
                    // Ping is success and SSH failed
                    this.status["COMPLETED"] = "error";
                    this.taskStatus["COMPLETED"] =
                        "Successfully pinged the Cisco Wireless Controller. SSH could not be established.";
                    this.connectivityMessages = [
                        "1. Please check if SSH is enabled on the Cisco Wireless Controller.",
                        "2. Please check if Cisco Spaces Connector is able to reach SSH port 22 on the Cisco Wireless Controller.",
                        "3. Please check if the SSH credentials provided are correct."
                    ];
                }
                else if (!pingStatus && !ssh) {
                    // Both ping and SSH failed
                    this.status["COMPLETED"] = "error";
                    this.taskStatus["COMPLETED"] =
                        "Could not ping  or establish SSH connection with the Cisco Wireless Controller.";
                    this.connectivityMessages = [
                        "1. Check if IP Connectivity exists between the Cisco Spaces Connector and the Cisco Wireless Controller.",
                        "2. Please check if SSH is enabled on the Cisco Wireless Controller.",
                        "3. Please check if Cisco Spaces Connector is able to reach SSH port 22 on the Cisco Wireless Controller.",
                        "4. Please check if the SSH credentials provided are correct.",
                        "5. Check if AAA is enabled on the controller with local authentication.",
                        "6. Check if an interface other than Gig0 interface is used for NMSP and SSH connectivity."
                    ];
                }
            }
            else if (type === "WLC") {
                // Both ping and SNMP success or SNMP is success and ping failed
                if ((pingStatus && snmp) || (!pingStatus && snmp)) {
                    this.status["COMPLETED"] = "success";
                    this.taskStatus["COMPLETED"] =
                        "Connectivity test completed successfully.";
                }
                else if (pingStatus && !snmp) {
                    // Ping is success and SNMP failed
                    if (snmpReadOnly) {
                        this.snmpReadOnlyMsg =
                            "Credentials provided are read only. Read Write access is required.";
                    }
                    this.status["COMPLETED"] = "error";
                    this.taskStatus["COMPLETED"] =
                        "Successfully pinged the Cisco Wireless Controller. SNMP connection could not be established.";
                    this.connectivityMessages = [
                        "1. Could not ping  or establish SNMP connectivity with the Cisco Wireless Controller.",
                        "2. Please check if Cisco Spaces Connector is able to reach SNMP port 161 on the Cisco Wireless Controller.",
                        "3. Please check if the SNMP credentials provided are correct."
                    ];
                }
                else if (!pingStatus && !snmp) {
                    // Both ping and SNMP failed
                    if (snmpReadOnly) {
                        this.snmpReadOnlyMsg =
                            "Credentials provided are read only. Read Write access is required.";
                    }
                    this.status["COMPLETED"] = "error";
                    this.taskStatus["COMPLETED"] =
                        "Ping and SNMP test to the AireOS Controller failed.";
                    this.connectivityMessages = [
                        "1. Check if IP Connectivity exists between the Cisco Spaces Connector and the Cisco Wireless Controller.",
                        "2. Could not ping  or establish SNMP connectivity with the Cisco Wireless Controller.",
                        "3. Please check if Cisco Spaces Connector is able to reach SNMP port 161 on the Cisco Wireless Controller.",
                        "4. Please check if the SNMP credentials provided are correct."
                    ];
                }
            }
        };
        this.connectivityTestResult = {};
        this.verifyV3Connectivity = (testId) => {
            this.connectivityTestResult = {};
            const tempresult = [];
            this.cmxConnectorsService
                .verifyV3Connectivity(this.controllerObj.connectorId, testId)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status && response.data) {
                    /*response = {"status":true,
                    "message":"API Response Successful",
                    "data":{"tenantId":"5","connectorId":"73892651670752950000","testId":"ConnectivityTest-725e17225da9bbc31b82000fe7cd0a9e",
                    "status":"Success","startedOn":1674022930491,
                    "instances":["0050568cc5c7","0050568cc5c0"],
                    "servicesToIgnore": ['hotspot'],
                    "services":["hotspot","hotspot1","hotspot2","location"],
                    "device":{"connectorName":"hotspot-certpath","connectorVersion":"V3","isAssociateController":false,"controllerIp":"23.34.5.6","name":"asdfgdg","type":"WLC","connectorId":"73892651670752950000","tenantId":5,"host":"23.34.5.6"},
                    "results":{
                          "0050568cc5c7":
                          {
                            "hotspot":  {"status":"Requested","testResults":[]},
                            "hotspot1":  {"status":"Requested","testResults":[]},
                            "hotspot2":  {"status":"Requested","testResults":[]},
                            "location": {"testResults":
                                        [{
                                          "name":"Ping Test","updateOn":1674022933878,
                                          "results":"PingResponse [statistics=[PING 23.34.5.6 (23.34.5.6) 56(84) bytes of data., 64 bytes from 23.34.5.6: icmp_seq=1 ttl=44 time=119 ms, 64 bytes from 23.34.5.6: icmp_seq=2 ttl=44 time=119 ms, 64 bytes from 23.34.5.6: icmp_seq=3 ttl=44 time=120 ms, --- 23.34.5.6 ping statistics ---, 3 packets transmitted, 3 received, 0% packet loss, time 2002ms, rtt min/avg/max/mdev = 119.698/120.047/120.457/0.312 ms], success=true]"
                                        }],
                                        "testId":"ConnectivityTest-725e17225da9bbc31b82000fe7cd0a9e","status":"Success","updatedOn":1674022933984
                                  },
                          "status":"Success"
                          },
                          "0050568cc5c0":
                          {
                            "hotspot":  {"status":"Requested","testResults":[]},
                            "hotspot1":  {"status":"Requested","testResults":[]},
                            "hotspot2":  {"status":"Requested","testResults":[]},
                            "location": {"testResults":
                                        [{
                                          "name":"Ping Test","updateOn":1674022933878,
                                          "results":"PingResponse [statistics=[PING 23.34.5.6 (23.34.5.6) 56(84) bytes of data., 64 bytes from 23.34.5.6: icmp_seq=1 ttl=44 time=119 ms, 64 bytes from 23.34.5.6: icmp_seq=2 ttl=44 time=119 ms, 64 bytes from 23.34.5.6: icmp_seq=3 ttl=44 time=120 ms, --- 23.34.5.6 ping statistics ---, 3 packets transmitted, 3 received, 0% packet loss, time 2002ms, rtt min/avg/max/mdev = 119.698/120.047/120.457/0.312 ms], success=true]"
                                        }],
                                        "testId":"ConnectivityTest-725e17225da9bbc31b82000fe7cd0a9e","status":"Success","updatedOn":1674022933984
                                  },
                          "status":"Success"
                          },
                          "status":"Success"
                          }
                      }
                      };*/
                    const data = response.data;
                    /*dummy data::
        
                    */
                    /*
                     * InProgress:
                      waiting for results from services
                      Timeout:
                      all service instances are timeout
                      Success:
                      at least one service instance of all services are all success
                      Failed:
                      test requests cannot be sent to all service
                      at least one service in all instances is failing
                     *
                    */
                    //for success / in progress
                    /*
                    prepare complete row from result
                    array =[{instaneId,service1status,service2status},{}];
                    */
                    if (data.status == "Success") {
                        this.connectivityTestResult = data;
                        const instances = data.instances;
                        const services = data.services;
                        var actualResult = data.results;
                        if (actualResult) {
                            let row = [];
                            delete actualResult.status;
                            Object.keys(actualResult).forEach(key => {
                                row = [];
                                row.push(key);
                                if (key !== 'status') {
                                    const temp1 = actualResult[key];
                                    Object.keys(temp1).forEach(key1 => {
                                        if (data.servicesToIgnore.includes(key1)) {
                                            row.push("Not Applicable");
                                        }
                                        else {
                                            if (key1 !== 'status') {
                                                let eachservice = temp1[key1];
                                                row.push(eachservice.status);
                                            }
                                        }
                                    });
                                }
                                console.log(`row is ${row}`);
                                tempresult.push(row);
                                //delete actualResult[key].status;
                                /*const valueresult = actualResult[key];
                                const array = [];
                                Object.keys(valueresult).forEach(keyService => {
                                  console.log(`inside key is ${keyService}`);
                                  //array.push(valueresult[keyService]);
                                });
                                const arr = [...actualResult[key]];
                                console.log(`array prepared is :: ${arr}`);
                                tempresult[key] =Array.from(actualResult[key], function (entry: any) {
                                  return { key: entry[0], value: entry[1] };
                                  });*/
                            });
                        }
                        this.connectivityTestResult.result = tempresult;
                        console.log(`connectivityTestResult is ${this.connectivityTestResult}`);
                        //data.result = actualResult;
                        this.showSpinner = false;
                        this.showV3TestConnectivityStatus = false;
                    }
                    else if (data.status === "In Progress") {
                        this.testV3Timeout = setTimeout(() => this.verifyV3Connectivity(testId), 5000);
                        this.connectivityTestResult = data;
                        const instances = data.instances;
                        const services = data.services;
                        var actualResult = data.results;
                        /*if(actualResult) {
                          actualResult.forEach((key, value)=> {
                            tempresult[key] = Array.from(value);
                          });
                        }
                        actualResult= tempresult;
                        data.result = actualResult;*/
                    }
                    else if (data.status === "Timeout") {
                        this.dataService.setToastMessage("all service instances are timeout.", 4000, null, null, status);
                        this.showSpinner = false;
                        this.showV3TestConnectivityStatus = false;
                    }
                    else if (data.status === "Failed") {
                        this.dataService.setToastMessage("test requests cannot be sent to all service, at least one service in all instances is failing.", 4000, null, null, status);
                        this.showSpinner = false;
                    }
                }
            });
        };
        this.verifyConnectivity = (testRequestId, tenantId) => {
            this.cmxConnectorsService
                .verifyConnectivity(testRequestId, tenantId)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                const data = response.data;
                if (data.taskStatus) {
                    const { taskStatus } = data;
                    if (taskStatus === "IN_PROGRESS") {
                        setTimeout(() => this.verifyConnectivity(testRequestId, tenantId), 5000);
                    }
                    else {
                        const { connectionTestResult = {}, type } = data;
                        const { pingResponse: ping = {}, sshSuccess: ssh, snmpSuccess: snmp, snmpReadOnly } = connectionTestResult;
                        if (taskStatus === "COMPLETED") {
                            this.displayConnectivityMessages(type, ping, ssh, snmp, snmpReadOnly);
                        }
                        this.displayTaskStatus = taskStatus;
                        const message = this.taskStatus[taskStatus];
                        const status = this.status[taskStatus];
                        this.dataService.setToastMessage(message, 4000, null, null, status);
                        this.showSpinner = false;
                        this.showV3TestConnectivityStatus = false;
                    }
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["unable_connect"], 4000, null, null, "error");
                    this.showSpinner = false;
                    this.showV3TestConnectivityStatus = false;
                }
            }, (error) => {
                this.showSpinner = false;
                this.dataService.setToastMessage(this.messageKeys["unable_connect"], 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        this.testCredentials = () => {
            this.removeAttributes();
            if (this.validateUI() == false) {
                return false;
            }
            this.showSpinner = true;
            this.showV3TestConnectivityStatus = false;
            this.displayTaskStatus = "";
            this.connectivityMessages = [];
            this.snmpReadOnlyMsg = "";
            if (this.controllerObj.connectorVersion == 'V3') {
                this.cmxConnectorsService.testV3Credentials(this.controllerObj)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((response) => {
                    //response = {"status":true,"message":"API Response Successfully","data":{"tenantId":"129","connectorId":"71852863070890270000","status":"Success","message":"No service on the connector needs to perform connectivity test for device:CONTROLLER"}};
                    const data = response.data;
                    if (data.testId) {
                        const testId = data.testId;
                        setTimeout(() => this.verifyV3Connectivity(testId), 5000);
                    }
                    //<!--hotfix-->
                    else if (data.status == 'Success' && data.message) {
                        this.showSpinner = false;
                        this.showV3TestConnectivityStatus = true;
                    }
                    //<!--hotfix-->
                    else {
                        this.dataService.setToastMessage(this.messageKeys["unable_fetch_catalyst"], 4000, null, null, "error");
                    }
                }, (error) => {
                    this.showSpinner = false;
                    this.showV3TestConnectivityStatus = false;
                    this.dataService.setToastMessage(this.messageKeys["unable_fetch_catalyst"], 4000, null, null, "error");
                });
            }
            else {
                this.cmxConnectorsService
                    .testCredentials(this.controllerObj) // need to add version info into controllerObj
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((response) => {
                    const data = response.data;
                    const { testRequestId, tenantId, taskStatus } = data;
                    this.displayTaskStatus = taskStatus;
                    setTimeout(() => this.verifyConnectivity(testRequestId, tenantId), 5000);
                }, (error) => {
                    this.showSpinner = false;
                    this.showV3TestConnectivityStatus = false;
                    this.dataService.setToastMessage(this.messageKeys["unable_fetch_catalyst"], 4000, null, null, "error");
                });
            }
        };
        this.disableSwitch = () => {
            this.dataService.display(true);
            const selectedSwitchId = this.confirmationEl.selectedController["switchId"];
            this.cmxConnectorsService
                .disableSwitch(this.selectedConnector.id, selectedSwitchId, this.switchObj.saveConfig)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response && response.status) {
                    this.dataService.setToastMessage(this.messageKeys["switch_disabled"], 4000, null, null, "success");
                    this.switchInterval = setInterval(() => {
                        this.getAllSwitchesStreamStatus(this.selectedConnector.id);
                    }, 10000);
                    this.dataService.display(false);
                    this.confirmationEl.display = false;
                    this.dataService.closeMagneticPopup();
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["failed_disable_switch"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
            }, (error) => {
                // const errorMsg = "Failed to disable switch";
                if (error.error) {
                    this.dataService.setToastMessage(this.messageKeys["failed_disable_switch"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        this.configureSwitch = () => {
            if (this.validateSwitchObj() == false) {
                return false;
            }
            this.switchObj.switchIdList = [];
            this.switchObj.switchIdList.push(this.selectedSwitchID);
            this.dataService.display(true);
            this.cmxConnectorsService
                .configureSwitch(this.selectedConnector.id, this.switchObj)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response && response.status) {
                    if (response.data != "" && response.data != null) {
                        this.dataService.setToastMessage(this.messageKeys["switch_enable_success"], 4000, null, null, "success");
                        this.toggleConfigureSwitchPopup(false, {}, 0);
                        this.switchInterval = setInterval(() => {
                            this.getAllSwitchesStreamStatus(this.selectedConnector.id);
                        }, 10000);
                        this.dataService.display(false);
                    }
                    else {
                        this.dataService.display(false);
                        this.dataService.setToastMessage(this.messageKeys["switch_enable_failed"], 4000, null, null, "error");
                    }
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys["switch_enable_failed"], 4000, null, null, "error");
                }
            }, (error) => {
                let errorMsg = "";
                if (error.error) {
                    console.log("if error.error is available :: error:: configureSwitch API call", JSON.stringify(error));
                    if (error.error.message) {
                        errorMsg = error.error.message;
                    }
                    else {
                        errorMsg = "Failed to configure switch";
                    }
                    this.dataService.setToastMessage(this.messageKeys["error_config_switch"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
                else {
                    console.log("error:: configureSwitch API call", JSON.stringify(error));
                    errorMsg = "Failed to configure switch";
                    this.dataService.setToastMessage(this.messageKeys["error_config_switch"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        this.validateSwitchObj = () => {
            this.configureSwitchError = "";
            if (typeof this.switchObj.sourceSpanVlanList == "string") {
                if (this.switchObj.sourceSpanVlanList) {
                    this.switchObj.sourceSpanVlanList =
                        this.switchObj.sourceSpanVlanList.split(",");
                }
                else {
                    this.switchObj.sourceSpanVlanList = [];
                }
            }
            if (this.configureSwitchError == "" && this.showAdvancedSettings &&
                (this.switchObj.destSpanVlan == "" ||
                    this.switchObj.destSpanVlan == null)) {
                this.configureSwitchError = "Please enter Destination SPAN VLAN";
                return false;
            }
            else if (this.configureSwitchError == "" && this.showAdvancedSettings &&
                (this.switchObj.destSpanVlanIpAddress == "" ||
                    this.switchObj.destSpanVlanIpAddress == null)) {
                this.configureSwitchError =
                    "Please enter Destination SPAN VLAN IP address";
                return false;
            }
            else if (this.configureSwitchError == "" && this.showAdvancedSettings &&
                (this.switchObj.sourceSpanVlanList == undefined ||
                    this.switchObj.sourceSpanVlanList.length == 0)) {
                this.configureSwitchError = "Please enter Source SPAN VLAN list";
                return false;
            }
            else if (this.configureSwitchError == "" && this.showAdvancedSettings &&
                (this.switchObj.monitorOriginIpAddress == "" ||
                    this.switchObj.monitorOriginIpAddress == null)) {
                this.configureSwitchError =
                    "Please enter Monitor SPAN origin IP address";
                return false;
            }
            else if (this.configureSwitchError == "" && this.showAdvancedSettings &&
                (this.switchObj.appSpanIpAddress == "" ||
                    this.switchObj.appSpanIpAddress == null)) {
                this.configureSwitchError =
                    "Please enter IOx application SPAN IP address";
                return false;
            }
            else if (this.configureSwitchError == "" &&
                (this.switchObj.appDnasVlan == "" ||
                    this.switchObj.appDnasVlan == null)) {
                this.configureSwitchError =
                    "Please enter Application Cisco Spaces Connector VLAN";
                return false;
            }
            else if (this.configureSwitchError == "" &&
                this.switchObj.useDhcp == "false") {
                if (this.configureSwitchError == "" &&
                    (this.switchObj.appIpAddress == "" ||
                        this.switchObj.appIpAddress == null)) {
                    this.configureSwitchError =
                        "Please enter IOx application IP address";
                    return false;
                }
                else if (this.configureSwitchError == "" &&
                    (this.switchObj.appNetmask == "" ||
                        this.switchObj.appNetmask == null)) {
                    this.configureSwitchError =
                        "Please enter IOx application netmask";
                    return false;
                }
                else if (this.configureSwitchError == "" &&
                    (this.switchObj.appGatewayAddress == "" ||
                        this.switchObj.appGatewayAddress == null)) {
                    this.configureSwitchError =
                        "Please enter IOx application gateway address";
                    return false;
                }
            }
            const switcjObjIPs = [
                {
                    key: this.switchObj.destSpanVlanIpAddress,
                    value: "Destination SPAN VLAN IP address",
                    consider: this.showAdvancedSettings
                },
                {
                    key: this.switchObj.monitorOriginIpAddress,
                    value: "Monitor SPAN origin IP address",
                    consider: this.showAdvancedSettings
                },
                {
                    key: this.switchObj.appSpanIpAddress,
                    value: "IOx application SPAN IP address",
                    consider: this.showAdvancedSettings
                },
                {
                    key: this.switchObj.appNetmask,
                    value: "IOx application netmask",
                    consider: !this.switchObj.useDhcp
                },
                {
                    key: this.switchObj.appGatewayAddress,
                    value: "IOx application gateway address",
                    consider: !this.switchObj.useDhcp
                }
            ];
            switcjObjIPs.forEach((fieldObj) => {
                if (fieldObj.consider) {
                    if (!this.validateIPGeneric(fieldObj.key)) {
                        this.configureSwitchError =
                            "Please enter a valid " + fieldObj.value;
                        return false;
                    }
                }
                else {
                    this.configureSwitchError = "";
                    return true;
                }
            });
            if (this.configureSwitchError == "") {
                return true;
            }
            else {
                this.dataService.setToastMessage(this.configureSwitchError, 6000, null, null, "error");
                return false;
            }
        };
        this.toggleConfigureSwitchPopup = (show, connector, index) => {
            this.showConfigureSwitchPopup = show;
            this.getAllSwitchesStreamStatus(this.selectedConnector.id);
            if (show) {
                this.dataService.openMagneticPopup();
                this.initializeSwitchObj();
                this.selectedSwitchID = connector.switchId;
                this.configureSwitchConnector = connector;
                this.switchObj = this.switchStreamInfo[index]; //this.switchStreamInfo[index];
                if (this.switchObj.useDhcp === undefined || this.switchObj.useDhcp === ''
                    || this.switchObj.useDhcp === false) {
                    this.switchObj.useDhcp = "false";
                    this.validateSwitchObj();
                }
                this.switchObj.name = connector.name;
                this.configureSwitchError = "";
                setTimeout(() => {
                    clearInterval(this.switchInterval);
                }, 100);
            }
            else {
                this.configureSwitchConnector = {};
                this.dataService.closeMagneticPopup();
                this.initializeSwitchObj();
            }
        };
        this.closeModal = () => {
            // for connector switch component
        };
        this.showConnectorListPage = () => {
            this.showConnectors = true;
            this.showSwitchList = false;
        };
        this.toggleAdvancedSettings = (showAdvancedSettings) => {
            this.showAdvancedSettings = !showAdvancedSettings;
            if (this.showAdvancedSettings == false)
                this.validateSwitchObj();
        };
        this.viewConnectorV2Controller = (connector, connectorName) => {
            this.dataService.display(true);
            if (connector.name == undefined) {
                connector.name = connectorName;
            }
            this.currentConnector = connector;
            this.selectedConnector = connector;
            this.isConnectorAvailable = true;
            this.showConnectorDetails = true;
            this.getConnectorDetails(this.currentConnector.id, false);
            this.getConnectorAssociatedControllers(connector);
            //this.dataService.display(false); 14june
        };
        this.viewConnector = (connector, connectorName, connectorNodes) => {
            //this.router.navigate([connector.id]);
            /*this.currentNav = "/setup/connectors/"+this.currentConnector.id;
            this.router.navigate([this.currentNav]);
            this.dataService.setCurrentNav(this.currentNav);
            this.dataService.display(true);*/
            if (connector.name == undefined) {
                connector.name = connectorName;
            }
            this.currentConnector = connector;
            this.selectedConnector = connector;
            this.isConnectorAvailable = true;
            this.serviceToConfigure = null;
            this.getConnectorDetails(this.currentConnector.id, false);
            if (this.currentConnector.version == 'V3') {
                this.showConnectorDetails = true; //recent
                this.selectedTab = "configuration";
                this.showControllerSection = false;
                this.instanceNodeIds = []; //new instances will be loaded here;
                this.metricsStats = [];
                this.metricLoaded = false;
                this.controllerList = [];
                this.showConnectorDetails = true;
                this.showUpdateNote = false;
                this.getAvailableServices(connector);
                this.connectorInstance_count_active = 0;
                this.connectorInstance_count = 0;
                this.connectorInstance_count_down = 0;
                setTimeout(() => {
                    this.instances = [];
                    this.getinsatancesDetails(connectorNodes);
                }, 100);
            }
            else {
                this.showConnectorDetails = true;
                this.controllerList = [];
                this.connectorControllersCount = 0;
                this.connectorControllersCount_active = 0;
                this.connectorControllersCount_down = 0;
                this.wiredconnectorSwitchesCount = 0;
            }
            if (connector.name == undefined) {
                this.currentConnector.name = connectorName;
                this.selectedConnector.name = connectorName;
            }
        };
        this.getinsatancesDetails = (connectorNodes) => {
            this.serviceUpgradeErrorInfo = {};
            this.serviceVersionError = [];
            this.instances = [];
            this.showUploadLogsForV3 = false;
            this.instances = [];
            if (connectorNodes) {
                const nodes = Object.keys(connectorNodes);
                var currentTime = new Date().getTime();
                var durationDays = 0;
                var durationHours = 0;
                var durationMinutes = 0;
                this.instancesNodeIds = [];
                //this.instances = connectorNodes;
                this.connectorInstance_count = nodes.length;
                if (nodes) {
                    nodes.forEach(key => {
                        var _a;
                        const instance = connectorNodes[key];
                        if (instance.status == 'Up') {
                            this.connectorInstance_count_active++;
                            this.showUploadLogsForV3 = true;
                        }
                        else {
                            this.connectorInstance_count_down++;
                        }
                        instance.connectionDuration = "";
                        const connectionDuration = "";
                        if (instance.CTRL_CHANNEL_WS) {
                            var timestamp = (_a = instance.CTRL_CHANNEL_WS) === null || _a === void 0 ? void 0 : _a.connectedTime;
                            console.log("Current time is ", currentTime);
                            durationDays = currentTime - timestamp / (1000 * 3600 * 24);
                            durationHours = currentTime - (timestamp % (1000 * 3600 * 24)) * 24;
                            if (durationDays == 0) {
                            }
                            else {
                                instance.connectionDuration += "{durationDays} days ";
                            }
                            if (durationHours == 0) {
                            }
                            else {
                                instance.connectionDuration = "{durationHours} Hours ";
                            }
                        }
                        else {
                            instance.connectionDuration = 'NA';
                        }
                        this.instancesNodeIds.push(instance.nodeId);
                        this.instances.push(instance);
                        setTimeout(() => {
                            if (this.selectedServices && this.selectedServices.length > 0) {
                                this.selectedServices.forEach((service) => {
                                    const key = "connectorDeployStatus_" + service.serviceName;
                                    const deploy_key = "serviceStatus_" + service.serviceName;
                                    if (instance[key] && instance[key].version && instance[deploy_key]) {
                                        var image = instance[deploy_key].image; //connector/location:2.8.0.223
                                        if (instance[key].version != image.split(':')[1]) {
                                            this.serviceUpgradeErrorInfo[instance.nodeId] = service.serviceName;
                                            this.serviceVersionError.push(service.serviceName);
                                            service["hasVersionError"] = true;
                                        }
                                        else {
                                            service["hasVersionError"] = false;
                                        }
                                    }
                                });
                            }
                        }, 200);
                        //recent21 check done for version error;
                    });
                }
            }
            /*this.cmxConnectorsService.getConnectorInstances(this.currentConnector.id).pipe(takeUntil(this.unsubscribe$)).
            subscribe((response: { status: any ,data: any})=>{
               if (response && response.status) {
               if(response.data && response.data.instances){
               this.instances = response.data.instances;
               var currentTime = new Date().getTime();
               var durationDays = 0;
               var durationHours = 0;
               var durationMinutes = 0;
               this.instancesNodeIds = []
               this.connectorInstance_count = this.instances.length;
               this.instances.forEach(instance=>{
                 if(instance.haStatus == 'ACTIVE'){
                  this.connectorInstance_count_active++;
                 }else{
                   this.connectorInstance_count_down++;
                 }
                 instance.connectionDuration = "";
                 const connectionDuration ="";
                 var timestamp = instance.controlChannelStatus?.connectedTime;
        
                 console.log("Current time is ",currentTime);
                 durationDays = currentTime - timestamp/(1000*3600*24);
                 durationHours = currentTime - (timestamp % (1000*3600*24)) * 24;
                 if(durationDays == 0){
        
                 }else{
                   instance.connectionDuration += "{durationDays} days "
                 }
                 if(durationHours == 0){
        
                 }else{
                   instance.connectionDuration = "{durationHours} Hours "
                 }
                 this.instancesNodeIds.push(instance.nodeId);
        
               });
               this.dataService.display(false);
               }else{
               //either no Instance is found or some error
               this.dataService.display(false);
               }
             }else{
               //either no Instance is found or some error
               this.dataService.setToastMessage(
                 "Failed to get Insance Information.",
                 4000,
                 null,
                 null,
                 "error"
               );
               this.dataService.display(false);
               }
              });*/
        };
        this.showConnectorListView = () => {
            this.showConnectorDetails = false;
            this.isConnectorAvailable = false;
            if (this.fromWiredNetwork) {
                this.currentNav = "/setup/wirednetwork/connectors";
                this.router.navigate([this.currentNav]);
            }
            else {
                this.currentNav = "/setup/connectors";
                this.router.navigate([this.currentNav]);
            }
            this.dataService.setCurrentNav(this.currentNav);
            //refresh list ??
            this.getCMXConnectors(); //recent 6 Aprl
        };
        this.getConnectorAssociatedControllers = (connector) => {
            this.selectedConnector = connector ? Object.assign({}, connector) : {};
            this.dataService.display(true);
            this.controllerList = [];
            this.controllerListLoaded = false;
            let controllerListForTenant = [];
            this.connectorControllersCount = 0;
            this.connectorControllersCount_active = 0;
            this.connectorControllersCount_down = 0;
            this.cmxConnectorsService
                .getControllers(connector)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                console.log(data);
                if (data != "" && data != null) {
                    // getting all controller of tenant(customer)
                    controllerListForTenant = data;
                    this.accountControllerList = controllerListForTenant;
                    // getting controllers for the corresponding connector (using connctorId)
                    if (controllerListForTenant &&
                        controllerListForTenant.length > 0) {
                        controllerListForTenant.forEach((controllerTenant) => {
                            if (controllerTenant.connectorId ==
                                this.selectedConnector.id) {
                                this.controllerList.push(controllerTenant);
                            }
                        });
                    }
                    console.log(this.controllerList);
                    if (this.controllerList &&
                        this.controllerList.length > 0) {
                        this.connectorControllersCount = 0;
                        this.connectorControllersCount_active = 0;
                        this.connectorControllersCount_down = 0;
                        this.controllerList.forEach((controller, index) => {
                            this.connectorControllersCount = this.connectorControllersCount + 1;
                            if (controller.name == undefined) {
                                if (index != 0) {
                                    controller.name = "Controller " + index;
                                }
                                else {
                                    controller.name = "Controller";
                                }
                            }
                            // access point size calculation
                            controller.accessPointsCount = 0;
                            const { report = {} } = controller;
                            // numberOfAps from controller oject - new response format
                            if (report &&
                                report.numberOfAps) {
                                controller.accessPointsCount =
                                    controller.report.numberOfAps;
                            }
                            // New Code as per the report status
                            if (this.currentConnector.version !== 'V3') {
                                controller.connectionStatus =
                                    report.status === "ACTIVE"
                                        ? "Active"
                                        : "Inactive";
                            }
                            else {
                                controller.connectionStatus =
                                    report.controllerStatus === "Up"
                                        ? "Active"
                                        : (report.controllerStatus === "Down" ? "Inactive" : "Degraded");
                            }
                            if (controller.connectionStatus == 'Inactive') {
                                this.connectorControllersCount_down++;
                            }
                            else {
                                this.connectorControllersCount_active++;
                            }
                        });
                    }
                    this.dataService.display(false);
                    this.controllerListLoaded = true;
                }
                else {
                    this.dataService.display(false);
                    // this.dataService.setToastMessage(data.message, 4000, null, null, 'error');
                    console.log("Controller List is empty");
                    this.controllerListLoaded = true;
                }
            }, (error) => {
                this.dataService.display(false);
                this.controllerListLoaded = true;
            });
        };
        this.createNewConnector = () => {
            this.isConnectorAvailable = false;
            this.showCreateConnectorPopup = true;
            this.dataService.openMagneticPopup();
            this.configPage = "connector";
        };
        this.closeCreateConnectorPopup = () => {
            this.showCreateConnectorPopup = false;
            this.dataService.closeMagneticPopup();
            this.connectorVersion = this.connectorVersions[1];
            this.initializeControllerObj();
            this.cmxConnectorError = "";
        };
        this.initializeSwitchObject = () => {
            //this.connectorName = "-- Select --";
            this.switchObject["switchIp"] = null;
            this.switchObject["name"] = null;
            this.switchObject["connectorId"] = null;
            this.switchObject.login = {
                username: null,
                password: null
            };
        };
        this.openNewSwitchPopup = (connector) => {
            this.initializeSwitchObject();
            this.showAddSwitchPopup = true;
            this.dataService.openMagneticPopup();
            this.currentConnector = connector;
        };
        this.closeAddSwitch = () => {
            this.showAddSwitchPopup = false;
            this.dataService.closeMagneticPopup();
        };
        this.validateConfig = (config) => {
            this.switchModuleError = "";
            if (!config.connectorId) {
                this.switchModuleError = "Please select the connector";
                return false;
            }
            else if (!config.name) {
                this.switchModuleError = "Please enter the switch name";
                return false;
            }
            else if (!config.switchIp) {
                this.switchModuleError = "Please enter the switch ip";
                return false;
            }
            else if (!this.validateSwitchIPAddress()) {
                return false;
            }
            else if (!config.login.username) {
                this.switchModuleError = "Please enter the netconfig username";
                return false;
            }
            else if (!config.login.password) {
                this.switchModuleError = "Please enter the netconfig password";
                return false;
            }
            return true;
        };
        this.addSwitchToConnector = () => {
            this.switchObject.connectorId = this.currentConnector.id;
            if (!this.validateConfig(this.switchObject)) {
                this.dataService.setToastMessage(this.switchModuleError, 4000, null, null, "error");
            }
            else {
                this.cmxConnectorsService
                    .createSwitch(this.switchObject)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((response) => {
                    if (response && response.status) {
                        this.dataService.display(false);
                        const message = "Switch created successfully";
                        this.dataService.setToastMessage(this.messageKeys["switch_created"], 4000, null, null, "success");
                        this.getConnectorSwitchesList();
                        this.initializeSwitchObject();
                        this.showAddSwitchPopup = false;
                        this.dataService.closeMagneticPopup();
                    }
                    else {
                        this.dataService.display(false);
                        const message = "Failed to create switch";
                        this.dataService.setToastMessage(this.messageKeys["switch_failed"], 4000, null, null, "error");
                    }
                }, (error) => {
                    this.dataService.display(false);
                    const message = "Failed to create switch";
                    this.dataService.setToastMessage(this.messageKeys["switch_failed"], 4000, null, null, "error");
                    console.log("ERROR:: Failed to create switch", error);
                });
            }
        };
        this.getConnectorSwitchesList = () => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .getSwitchesList()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response && response.data) {
                    this.switchesList = response.data;
                    if ((this.pageFrom = "spacesConnector")) {
                        const tempList = [];
                        this.connectorSwitchesCount = 0;
                        this.switchesList.forEach((switchObj) => {
                            if (switchObj.connectorId ==
                                this.currentConnector.id) {
                                tempList.push(switchObj);
                                this.connectorSwitchesCount = this.connectorSwitchesCount + 1;
                            }
                        });
                        this.switchesList = [];
                        this.switchesList = tempList;
                        //	this.getConnectorNameUsingID();
                    } /*else {
                                    this.getConnectorNameUsingID();
                                }*/
                }
            }, (error) => {
                this.dataService.display(false);
                console.log("ERROR:: Failed to fetch switch list", error);
            });
        };
        this.editSwitch = (switchObj) => {
            /*this.isEdit = true;
            this.connectorName = switchObj.connectorName
              ? switchObj.connectorName
              : "-- Select --";
            this.switchObject["switchIp"] = switchObj.switchIp;
            this.switchObject["name"] = switchObj.name;
            this.switchObject["connectorId"] =
              switchObj.connectorId == -1 ? null : switchObj.connectorId;
            this.switchObject["switchId"] = switchObj.switchId;
            this.switchObject.login = {
              username: null,
              password: null
            };
            this.displaySection.popup = true;*/
        };
        this.switchToDelete = {
            name: null,
            id: null
        };
        this.deleteSwitchConfirm = (switchObj) => {
            this.switchToDelete.name = switchObj.name;
            this.switchToDelete.id = switchObj.switchId;
            this.showHideConfirmation(true);
        };
        this.deleteSwitch = () => {
            this.dataService.display(true);
            this.cmxConnectorsService
                .deleteSwitch(this.switchToDelete.id)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response && response.status) {
                    this.dataService.display(false);
                    const message = "Switch deleted successfully";
                    this.dataService.setToastMessage(this.messageKeys["switch_deleted"], 4000, null, null, "success");
                    this.showHideConfirmation(false);
                    this.getConnectorSwitchesList();
                    //	this.closeSpacesModal();
                }
                else {
                    this.dataService.display(false);
                    const message = "Failed to delete switch";
                    this.dataService.setToastMessage(this.messageKeys["failed_switch_delete"], 4000, null, null, "error");
                }
            }, (error) => {
                this.dataService.display(false);
                const message = "Failed to delete switch";
                this.dataService.setToastMessage(this.messageKeys["failed_switch_delete"], 4000, null, null, "error");
                console.log("ERROR:: Failed to delete switch", error);
            });
        };
        this.showHideConfirmation = (state) => {
            this.confirmationVisible = state;
            this.dataService.openMagneticPopup();
            if (!state) {
                this.switchToDelete.name = null;
                this.switchToDelete.id = null;
                this.dataService.closeMagneticPopup();
            }
        };
        this.togglePasswordDisplay = () => {
            this.showPasswordV = !this.showPasswordV;
            if (this.showPasswordV) {
                $("#passwordField").attr("type", "text");
            }
            else {
                $("#passwordField").attr("type", "password");
            }
        };
        this.goToORProfileSetUpPage = (controller) => {
            const currentNav = "/openroaming/setup";
            this.dataService.setCurrentNav("/" + currentNav);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.router.navigate(["/" + currentNav]);
        };
        this.prepareMetricChartOptions = (unit, interval) => {
            const options = Object.assign(Object.assign({}, this.chartOptions), { chartType: "line", barWidth: 20, barSpacing: 10, sectionSpacing: 40, outerPadding: 20, margin: { top: 30, right: 25, bottom: 50, left: 25 }, backgroundColor: "#fff", defaultColor: "#A0BFD9", axisLineColor: "#cacaca", tickColor: "#F5F5F5", tickValues: [0, 1], valueColor: "#485967", groupTitleColor: "#1D3243", yAxisLabel: unit, xAxisLabel: "", chartHeight: 350, yAxisTickFormat: "", xAxisTickFormat: "%b %d, %I %p", lineColor: "#457FAD", isYaxisReadable: false, xAxisDateFormat: "%Y-%m-%dT%H:%M:%S.%fZ", xAxisFormat: "dateTimeMetrics", xTranslate: "rotate(-20)", 
                //chartStatusType: unit == 'Status'? true : false,
                //isPosTooltip: true,
                isPopup: true });
            if (unit == 'Status') {
                // options.showAllTicks = false;
                options.yTickValues = ["0", "1"];
            }
            else {
                options.tickValues = [];
            }
            if (interval == 'Last 1 Week') {
                options.xAxisFormat = "week_day";
            }
            if (interval == 'Last 2 Week') {
                options.xAxisFormat = "week_day";
            }
            if (interval == 'Last 24 Hours') {
                options.xAxisFormat = "dateTimeMetrics";
            }
            if (interval == 'Last 1 Hour') {
                options.xAxisFormat = "time_of_hour";
            }
            //this.metricsChartOptions = options;
            // if(type === 'dailyTrend') this.chartOptions['yAxisLabel'] = '';
            return options;
        };
        this.getAvailableServices = (connector) => {
            this.dataService.display(true);
            this.networkDependencyForService = new Set();
            this.cmxConnectorsService.getConnectorServices(this.currentConnector.id).
                pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response && response.status) {
                    if (response.data && response.data.services) {
                        this.selectedServices = [];
                        this.serviceList = [];
                        this.serviceMetricList = [];
                        this.dataService.display(false);
                        this.allServices = response.data.services;
                        this.connectorServicesEnabled_count = 0;
                        this.allServices.forEach((service, index) => {
                            if (service.currentConfig == undefined) {
                            }
                            else {
                                if (service.currentConfig.status == 'ENABLED' || service.currentConfig.status == 'DISABLED') {
                                    if (service.upgradeConfig.status == 'ALLOWED') {
                                        service["upgrade_allowed"] = true;
                                        service["upgrade_to_version"] = service.upgradeConfig.version;
                                    }
                                    else {
                                        service["upgrade_allowed"] = false;
                                    }
                                    //************************************ */
                                    //	service["upgrade_allowed"] = true;
                                    //************************************ */
                                    service.networkDependencies.forEach((networkD, index) => {
                                        if (!this.networkDependencyForService.has(networkD.name)) {
                                            this.networkDependencyForService.add(networkD.name);
                                            //  service["networkDependencies"] = { name: networkD.name, statusCheckAllowed: networkD.statusCheckAllowed };
                                        }
                                    });
                                    this.selectedServices.push(service);
                                    this.serviceNameDisplayName.set(service.serviceName, service.displayName);
                                    this.serviceList.push({
                                        "name": service.serviceName, "status": service.currentConfig.status, "displayName": service.displayName,
                                        "icon": service.icon
                                    }); // 29
                                    this.serviceMetricList.push({ "name": service.displayName, "status": service.currentConfig.status, "systemName": service.serviceName });
                                    this.connectorServicesEnabled_count = this.selectedServices.length;
                                }
                                if (service.configuratorDependencies && service.configuratorDependencies.length > 0) {
                                    const config = service.configuratorDependencies;
                                    config.forEach(conf => {
                                        if (conf.name == "IotStream") {
                                            service.manageIOTStream = true;
                                        }
                                        else if (conf.name == "IotWiredStream") {
                                            service.manageWiredStream = true;
                                        }
                                    });
                                }
                            }
                        });
                        if (this.serviceMetricList.length > 0) {
                            this.serviceMetricList.push({ "name": "system", "status": null, "systemName": "system" });
                        }
                        this.dataService.display(false);
                        this.connectorControllersCount = 0;
                        if (this.networkDependencyForService.has('CONTROLLER')) {
                            this.showControllerSection = true;
                            this.getConnectorAssociatedControllers(connector);
                        }
                        //iot-wired
                        else {
                            this.showControllerSection = false;
                        }
                        this.connectorSwitchesCount = 0;
                        if (this.networkDependencyForService.has('SWITCH')) {
                            this.showSwitchSection = true;
                            this.pageFrom = "connectro3.0";
                            this.getConnectorSwitchesList();
                            //this.getConnectorAssociatedControllers(connector);
                        }
                        else {
                            this.showSwitchSection = false;
                            this.pageFrom = "spacesConnector";
                        } //iot-wired
                        //call to check version error ?
                        //call to check version error ?
                    }
                }
                else {
                    this.dataService.display(false);
                    const message = "No services are available.";
                    this.dataService.setToastMessage(this.messageKeys["no_services_available"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        this.onMetricServiceSelection = (event) => {
            this.selectedService = event;
            this.chartData = [];
            this.metricsStats = [];
            this.startDate = 0;
            this.endDate = 0;
            this.intervalValue = 1; // one sample each 5 mins
            this.sampleRate = 5 * 60;
            this.disableInstanceFilter = false;
            this.selectedInterval = { "name": 'Last 1 Hour' };
            //switch charts based on service selected make a server call
            if (this.instancesNodeIds && this.instancesNodeIds.length > 0) {
                this.dataService.display(true);
                this.cmxConnectorsService.getMetricsStatsForService(this.currentConnector.id, this.selectedService.systemName, this.instancesNodeIds, this.intervalValue, this.sampleRate). //	this.startDate , this.endDate, this.sampleRate).
                    pipe(takeUntil(this.unsubscribe$))
                    .subscribe((response) => {
                    if (response && response.status) {
                        console.log("metrics response is ", response.data);
                        this.metrics = response.data;
                        this.dataService.display(false);
                        const charts_count = this.metrics.length;
                        /*
                        * Each metric having different chartOptions
                        * metric.ui.unit
                        *
                        */
                        this.metrics.forEach((metric, i) => {
                            this.instanceList = [];
                            var instances = [];
                            instances = metric.instances;
                            instances.forEach((inst, index) => {
                                this.instanceList.push({ "name": inst.name, "checked": true });
                            });
                        });
                        if (this.instanceList.length < 2) {
                            this.disableInstanceFilter = true;
                        }
                        if (charts_count > 0) {
                            this.metricsListToShow = [];
                            this.prepareMetricsChart(this.metrics, this.selectedService.name, this.selectedInterval.name, false);
                        }
                    }
                });
            }
            else {
            }
        };
        this.onMetricIntervalSelection = (event) => {
            //Last 7 Days"},{"name":"Last 30 Days"},{"name":"Select a date Range"}]
            if (event.name == 'Last 24 Hours') {
                this.intervalValue = 1 * 24;
                this.sampleRate = 60 * 60; // one sample each hour /60mins
            }
            else if (event.name == 'Last 1 Hour') {
                this.intervalValue = 1; // one sample each 5 mins
                this.sampleRate = 5 * 60;
            }
            else if (event.name == 'Last 1 Week') {
                this.intervalValue = 7 * 24; // one week 7 days
                this.sampleRate = 24 * 60 * 60; //one sample each 12 hour
            }
            else if (event.name == 'Last 2 Week') {
                this.intervalValue = 14 * 24; // one week 7 days
                this.sampleRate = 24 * 60 * 60; //one sample each 12 hour
            }
            else {
                this.showCalendarPopup = true;
            }
            //this.selectedService = event;
            this.selectedInterval = { "name": event.name };
            this.chartData = [];
            this.metricsStats = [];
            this.startDate = 0;
            this.endDate = 0;
            //this.intervalValue = 1*24;
            //this.sampleRate = 3600//120;
            //switch charts based on service selected make a server call
            if (this.instancesNodeIds && this.instancesNodeIds.length > 0) {
                this.dataService.display(true);
                this.cmxConnectorsService.getMetricsStatsForService(this.currentConnector.id, this.selectedService.systemName, this.instancesNodeIds, this.intervalValue, this.sampleRate).
                    //this.startDate , this.endDate, this.sampleRate).
                    pipe(takeUntil(this.unsubscribe$))
                    .subscribe((response) => {
                    if (response && response.status) {
                        console.log("metrics response is ", response.data);
                        this.metrics = response.data;
                        this.dataService.display(false);
                        const charts_count = this.metrics.length;
                        /*
                        * Each metric having different chartOptions
                        * metric.ui.unit
                        *
                        */
                        this.metrics.forEach((metric, i) => {
                            this.instanceList = [];
                            var instances = [];
                            instances = metric.instances;
                            instances.forEach((instance, index) => {
                                this.instanceList.push({ "name": instance.name, "checked": true });
                            });
                        });
                        if (charts_count > 0) {
                            this.metricsListToShow = [];
                            this.prepareMetricsChart(this.metrics, this.selectedService.name, event.name, false);
                        }
                    }
                });
            }
            else {
            }
        };
        this.prepareMetricsChart = (metrics, selectedServiceName, interval, filter) => {
            this.metricsStats = [];
            metrics.forEach((metric, i) => {
                this.chartData = [];
                var instances = [];
                var unit = "";
                instances = metric.instances;
                unit = metric.ui.unit;
                this.metricNameForChart = metric.ui.displayName;
                instances.forEach((instance, index) => {
                    const instanceStats = [];
                    var displaydate;
                    if (instance.stats && instance.stats.length > 0) {
                        instance.stats.forEach((stat, i) => {
                            if (interval == "Last 1 Hour") {
                                displaydate = moment$i
                                    .utc(stat.time)
                                    .format("h:mm A");
                                console.log('display date is ', displaydate);
                            }
                            else {
                                displaydate = moment$i
                                    .utc(stat.time)
                                    .format("MMM DD h:mm A");
                                console.log('display date is ', displaydate);
                            }
                            instanceStats.push({
                                name: this.metricNameForChart,
                                date: stat.time,
                                displayDate: displaydate,
                                count: stat.value,
                                color: this.tempMetricsColours[index]
                            });
                        });
                        if (instanceStats.length > 0)
                            this.chartData.push({
                                name: instance.name,
                                color: this.tempMetricsColours[index],
                                values: instanceStats
                            });
                    }
                    this.metricsChartOptions = this.prepareMetricChartOptions(unit, interval);
                    console.log("chart options are ", this.metricsChartOptions);
                });
                if (this.chartData.length > 0) {
                    this.metricsStats.push({
                        "metricName": this.metricNameForChart,
                        "chartdata": this.chartData,
                        "chartOptions": this.metricsChartOptions,
                    });
                    if (filter == false)
                        this.metricsListToShow.push(this.metricNameForChart);
                }
                else {
                    if (filter && this.metricsListToShow.includes(this.metricNameForChart)) {
                        this.metricsStats.push({
                            "metricName": this.metricNameForChart,
                            "chartdata": this.chartData,
                            "chartOptions": this.metricsChartOptions
                        });
                    }
                }
            });
            console.log("metric stats are ", this.metricsStats);
            this.tempMetricsStats = this.metricsStats;
            this.metricLoaded = true;
            this.alreadyLoadedMetric.push({ selectedServiceName: this.metricsStats });
            this.dataService.display(false);
            //recent7
        };
        this.filterMetrics = (instance, ind) => {
            //from each metric remove this instance data from chart data in tempMetricsStats
            instance.checked = !instance.checked; //recent16
            this.dataService.display(true);
            if (!instance.checked) {
                const removed = [];
                var removedChartData;
                /*	this.tempMetricsStats.forEach((metricStat , index) =>{
                    const chartDataFor_metric = metricStat.chartdata;
                     chartDataFor_metric.forEach((element ,i)=> {
                       if(element.name == instance.name){
                        removedChartData =  chartDataFor_metric[i];
                          chartDataFor_metric.splice(i,1);
                       }
          
                     });
                     this.tempMetricsStats[index].chartdata = chartDataFor_metric;
                     removed.push({"name": metricStat.metricName , "data": removedChartData});
                  });
                  this.removedInstanceStats.push({"instance":instance.name ,"removedChartdata": removed});*/
                var removedStats = [];
                this.metrics.forEach((metricStat, index) => {
                    const chartDataFor_instances = metricStat.instances;
                    chartDataFor_instances.forEach((inst, i) => {
                        if (instance.name == chartDataFor_instances[i].name) {
                            removedStats.push({ "name": metricStat.name, "data": chartDataFor_instances[i] });
                            metricStat.instances.splice(i, 1);
                        }
                    });
                    this.removedColours[index] = this.tempMetricsColours[index];
                    this.tempMetricsColours.splice(index, 1);
                });
                //	this.removedInstanceStats[instance.name] =removedStats; //what should be the key?? instsance name // metrics name
                this.removedInstanceStats.set(instance.name, removedStats);
                console.log("with removed stats are ", this.metrics);
            }
            else {
                var thisInstanceChart;
                this.removedInstanceStats.forEach((value, key) => {
                    if (instance.name == key) {
                        thisInstanceChart = value; // name , data stat
                        //thisInstanceChart = element.removedChartdata;
                        this.metrics.forEach((metricStat, index) => {
                            const chartDataFor_instances = metricStat.instances;
                            metricStat.instances.push({ "name": instance.name, "stats": value[index].data.stats });
                        });
                    }
                });
                this.removedInstanceStats.delete(instance.name);
                this.tempMetricsColours.push(this.removedColours[ind]);
                console.log("with added stats are ", this.metrics);
            }
            //this.tempMetricsStats = this.metrics;
            this.prepareMetricsChart(this.metrics, this.selectedService.name, this.selectedInterval.name, true);
        };
        this.showInstancePopupBox = false;
        this.showInstancesPopup = () => {
            this.showInstancePopupBox = !this.showInstancePopupBox;
        };
        this.onConnectorVersionSelection = (event) => {
        };
        this.updgradeConnector = (connectorId, connectorVersion) => {
            this.confirmUpgrade = true;
            this.dataService.openMagneticPopup();
            this.connectorIdToUpgrade = connectorId;
            this.connectorVersionToUpgrade = connectorVersion;
            this.showManageConnectorPopup = false;
        };
        this.closeUpgradeConnector = () => {
            this.confirmUpgrade = false;
            this.dataService.closeMagneticPopup();
        };
        this.doUpgradeConnector = () => {
            this.dataService.display(true);
            this.confirmUpgrade = false;
            this.dataService.closeMagneticPopup();
            this.cmxConnectorsService.upgradeConnectorV3(this.connectorIdToUpgrade).
                pipe(takeUntil(this.unsubscribe$)).
                subscribe(response => {
                if (response && response.status) {
                    this.dataService.display(false);
                    const message = "Connector upgraded successfully";
                    this.dataService.setToastMessage(this.messageKeys["connector_upgraded"], 4000, null, null, "success");
                    this.getCMXConnectors();
                }
                else {
                    this.dataService.display(false);
                    const message = "Failed to upgrade connector";
                    this.dataService.setToastMessage(this.messageKeys["failed_connect_upgrade"], 4000, null, null, "error");
                }
            });
        };
        this.showConnectorUpgradeMessage = () => {
        };
        this.openSoftwareUpdatePopup = (show, connector) => {
            this.showSoftUpdatePopup = true;
            this.selectedConnector = connector;
            this.currentConnector = connector;
        };
        this.closeSoftwareUpdatePopup = () => {
            this.showSoftUpdatePopup = false;
        };
        this.instanceNodeIdsLoaded = (nodeIds) => {
            this.instanceNodeIds = nodeIds;
        };
        this.reloadServices = () => {
            this.getAvailableServices(this.currentConnector);
        };
        this.checkConnectorsUpgrade = (connectors) => {
            this.isUpgradeLoaded = false;
            this.showUpdateNote = false;
            if (connectors) {
                connectors.forEach(con => {
                    if (con.version == 'V3') {
                        this.cmxConnectorsService.checkConnectorUpgrade(con.id).pipe(takeUntil(this.unsubscribe$)).
                            subscribe(response => {
                            if (response && response.status) {
                                this.upgradeData = response.data;
                                if (this.upgradeData && this.upgradeData.upgradeConfig &&
                                    this.upgradeData.upgradeConfig.status == 'ALLOWED') {
                                    this.showUpdateNote = true;
                                    this.updateMessage = this.upgradeData.message;
                                    con["upgrade_allowed"] = true;
                                    con["upgrade_to"] = this.upgradeData.upgradeConfig.releaseName;
                                }
                                else {
                                    this.showUpdateNote = false;
                                    con["upgrade_allowed"] = false;
                                }
                            }
                            else {
                                con["upgrade_allowed"] = false;
                                this.showUpdateNote = false;
                            }
                        });
                    }
                });
                this.isUpgradeLoaded = true;
            }
        };
        this.showCMXConController = (connector) => {
            this.showV2Controllers = true;
        };
        this.loadSwitchCount = ($event) => {
            this.wiredconnectorSwitchesCount = $event;
            this.connectorSwitchesCount = $event;
        };
        this.reloadConnectorDetail = (connectorId) => {
            setTimeout(() => {
                this.getCMXConnectors();
                this.cmxConnectorList.forEach((connector, index) => {
                    if (connector.id == connectorId) {
                        this.getinsatancesDetails(connector.connectorNodes);
                        return;
                    }
                });
            }, 5000);
        };
        this.showServiceStatus = (controller) => {
            this.reportMap = [];
            this.showServiceControllerStatus = true;
            this.dataService.openMagneticPopup();
            //this.showPopup = true;
            this.thisController = controller;
            const serviceName = this.selectedServices[1].serviceName;
            this.selectedServices.forEach(service => {
                if (service.networkDependencies != undefined && service.networkDependencies.length > 0) {
                    let networkDep = service.networkDependencies;
                    if (networkDep.length > 0) {
                        networkDep.forEach(dependency => {
                            if (dependency.name == 'CONTROLLER' && dependency.statusCheckAllowed == 'NO') {
                                this.reportMap.push({ "serviceName": service.serviceName, "status": 'Not Applicable' });
                            }
                            else {
                                if (this.thisController.report[service.serviceName] !== undefined && service.serviceName !== "iot-wired") {
                                    this.reportMap.push({ "serviceName": service.serviceName, "status": this.thisController.report[service.serviceName].status });
                                }
                                else {
                                    if (service.serviceName !== 'service-manager' && service.serviceName !== "iot-wired" && service.serviceName !== "local-firehose") {
                                        this.reportMap.push({ "serviceName": service.serviceName, "status": 'INACTIVE' });
                                    }
                                }
                            }
                        });
                    }
                }
                else {
                    if (this.thisController.report[service.serviceName] !== undefined && service.serviceName !== "iot-wired") {
                        this.reportMap.push({ "serviceName": service.serviceName, "status": this.thisController.report[service.serviceName].status });
                    }
                    else {
                        if (service.serviceName !== 'service-manager' && service.serviceName !== "iot-wired" && service.serviceName !== "local-firehose") {
                            this.reportMap.push({ "serviceName": service.serviceName, "status": 'INACTIVE' });
                        }
                    }
                }
            });
        };
        this.closeServiceStatus = () => {
            this.showServiceControllerStatus = false;
            this.dataService.closeMagneticPopup();
        };
        this.showServiceUpgrade = (service) => {
            this.showServiceUpgradePopup = true;
            this.dataService.openMagneticPopup();
            this.thisService = service;
        };
        this.closeServiceUpgrade = () => {
            this.showServiceUpgradePopup = false;
            this.dataService.closeMagneticPopup();
        };
        //TR
        this.toggleResetPwdKey = (connectorId) => {
            if (this.showResetPwdKey == true) {
                this.showResetPwdKey = false;
            }
            else {
                this.showResetPwdKey = true;
                this.getResetPasswordKey(connectorId);
            }
        };
        this.getResetPasswordKey = (connectorid) => {
            this.dataService.display(true);
            //this.showResetPwdKey = false;
            if (this.instancesNodeIds && this.instancesNodeIds.length > 0) {
                this.cmxConnectorsService.getResetPasswordKey(connectorid, this.instancesNodeIds[0]).pipe(takeUntil(this.unsubscribe$)).
                    subscribe(response => {
                    if (response && response.status && response.data.data) {
                        this.pwdResetKey = response.data.data;
                        this.showResetPwdKey = true;
                    }
                    else {
                        this.showResetPwdKey = false;
                        this.dataService.setToastMessage(this.messageKeys["failed_password_reset"], 4000, null, null, "error");
                    }
                    this.dataService.display(false);
                });
            }
            else {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["no_instance_pass_reset"], 4000, null, null, "error");
                this.showResetPwdKey = false;
            }
        };
        this.closeResetPwd = () => {
            this.showResetPwdKey = false;
            this.pwdResetKey = '';
        };
        this.uploadLogForServices = (connectorId, serviceName) => {
            this.dataService.display(true);
            const payload = {
                "services": [
                    serviceName
                ]
            };
            this.cmxConnectorsService.uploadLogForServices(connectorId, payload).pipe(takeUntil(this.unsubscribe$)).
                subscribe(response => {
                if (response && response.status) {
                    this.dataService.display(false);
                    const message = "Logs uploaded successfully.";
                    this.dataService.setToastMessage(this.messageKeys["logs_uploaded"], 4000, null, null, "success");
                    this.dataService.display(false);
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["failed_logs_upload"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        this.enableDebugForServices = (connectorId, serviceName) => {
            this.dataService.display(true);
            const payload = {
                "services": [
                    serviceName
                ],
                "logLevel": "DEBUG"
            };
            this.cmxConnectorsService.enableDebugForServices(connectorId, payload).pipe(takeUntil(this.unsubscribe$)).
                subscribe(response => {
                if (response && response.status) {
                    this.dataService.display(false);
                    const message = "Enabled debug logs successfully.";
                    this.dataService.setToastMessage(this.messageKeys["enable_debug_log"], 4000, null, null, "success");
                    this.dataService.display(false);
                }
                else {
                    this.dataService.setToastMessage(this.messageKeys["failed_enable_debug"], 4000, null, null, "error");
                    this.dataService.display(false);
                }
            });
        };
        //TR
        this.initiateMigrate = (connector) => {
            this.showMigratecomponent = true;
            this.dataService.openMagneticPopup();
            this.connectorToMigrate = connector;
        };
        this.hideMigrateScreen = () => {
            this.showMigratecomponent = false;
            this.dataService.closeMagneticPopup();
        };
        this.completeMigration = (connector) => {
            this.showMigratecomponent = false;
            this.dataService.closeMagneticPopup();
            connector.version = 'V3';
            this.viewConnector(connector, connector.name, connector.connectorNodes);
        };
        this.refreshPage = (connector, tab) => {
            if (connector.version == 'V3') {
                if (tab == 'configuration') {
                    this.viewConnector(connector, connector.name, connector.connectorNodes);
                }
                if (tab == 'instances') {
                    this.dataService.display(true);
                    if (this.cmxConnectorInstancesComponent) {
                        this.instances = [];
                        this.cmxConnectorInstancesComponent.getConnectorInstance(this.currentConnector.id);
                    }
                }
                if (tab == 'metrics') {
                    this.showTabDetails('metrics');
                }
            }
            else {
                this.viewConnectorV2Controller(connector, connector.name);
            }
        };
        this.onMouseOverEvent = (index) => {
            if (this.lastHover)
                this.migrateHover[this.lastHover] = false;
            this.migrateHover[index] = true;
            this.lastHover = index;
        };
        this.onMouseLeaveEvent = (index) => {
            this.migrateHover[index] = false;
        };
        //C3 start
        /*
        connectorTypeChanged = ($event) => {
          this.controllerCreateType = this.controllerCreateTypes[$event];
        }*/
        this.controllerCreationSelection = ($event) => {
            this.controllerCreateType = this.controllerCreateTypes[$event];
            this.toggleSaveButton();
            const selectedConnectorId = this.controllerObj.connectorId;
            const selectedConnectorName = this.controllerObj.connectorName;
            const selectedConnectorVersion = this.controllerObj.connectorVersion;
            this.initializeControllerObj();
            this.controllerObj.connectorName = selectedConnectorName;
            this.controllerObj.connectorId = selectedConnectorId;
            this.importFromConnector = { id: 0, name: "-- Select --" };
            this.deviceIdsToImport = [];
            this.listOfControllers = [];
            this.selectAll = false;
            this.placeholder = "Select Connector";
            this.identifyConnectors_importFrom(this.cmxConnectorList);
            //this.createOrImport = "";
        };
        this.connectorImportFromSelected = (connector) => {
            this.dataService.display(true);
            this.importFromConnector.id = connector.id;
            this.importFromConnector.name = connector.name;
            this.importFromConnector.showHotSpotConfigCheck = connector.showHotSpotConfigCheck;
            this.deviceIdsToImport = [];
            this.selectAll = false;
            this.disableImportButton = true;
            this.listOfControllers = [];
            //populate list now
            this.cmxConnectorsService
                .getControllersForConnectors(connector.id)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                this.dataService.display(false);
                console.log(`response for list of controller for connector is ${response}`);
                const tempController = response.data;
                if (tempController.length > 0) {
                    tempController.forEach((controller) => {
                        controller.selected = false;
                        this.listOfControllers.push(controller);
                    });
                }
                else {
                }
            });
        };
        this.selectAll = false;
        this.selectAllControllers = () => {
            this.deviceIdsToImport = [];
            if (this.selectAll === true) {
                //make all selected as false;
                this.listOfControllers.forEach((controller) => {
                    controller.selected = true;
                    this.deviceIdsToImport.push(controller.id);
                });
            }
            else {
                this.listOfControllers.forEach((controller) => {
                    controller.selected = false;
                });
            }
            //this.selectAll = !this.selectAll;
        };
        this.selectThisController = (thisController) => {
            if (thisController.selected == true) {
                //remove this id from deviceIdsToimport;
                this.deviceIdsToImport.push(thisController.id);
            }
            else {
                const index = this.deviceIdsToImport.indexOf(thisController.id);
                if (index > -1) {
                    this.deviceIdsToImport.splice(index, 1);
                }
                //make this id as true
            }
            if (this.deviceIdsToImport.length === this.listOfControllers.length) {
                this.selectAll = true;
            }
            else {
                this.selectAll = false;
            }
        };
        this.onMouseOverCheck = () => {
            this.showTooltip_hotspot = true;
        };
        this.onMouseOutCheck = () => {
            this.showTooltip_hotspot = false;
        };
        this.importController = (fromConnector, toConnector, deviceIdsToImport) => {
            this.dataService.display(true);
            const combinedresult = { "import": false, "hotspotConfig": false, "importToast": "", "configToast": "" };
            if (this.copyHotspotConfig) { //(this.importFromConnector.showHotSpotConfigCheck){
                this.cmxConnectorsService.copyHotSotConfig(fromConnector, toConnector).pipe(takeUntil(this.unsubscribe$))
                    .subscribe((response) => {
                    combinedresult.hotspotConfig = true;
                    if (response.status) {
                        combinedresult.configToast = response.data.message;
                        //check and add hotspot service to this connector?? -TBD
                    }
                    else {
                        combinedresult.configToast = response.data.message;
                    }
                    this.copyHotspotConfig = false;
                });
            }
            this.cmxConnectorsService.importControllersForConnector(fromConnector, toConnector, deviceIdsToImport)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                combinedresult.import = true;
                if (response && response.status) {
                    combinedresult.import = true;
                    combinedresult.importToast = response.data.message;
                    this.showCMXConnectorPopup = false;
                    //#pending call controllerlist ;
                    this.getConnectorAssociatedControllers(toConnector);
                    this.refreshPage(this.currentConnector, this.selectedTab);
                    if (!this.copyHotspotConfig) {
                        this.dataService.setToastMessage(
                        // "Import: "+ 
                        combinedresult.importToast, 8000, null, null, "success");
                    }
                }
                else {
                    combinedresult.importToast = response.data.message;
                }
            });
            var interval = setInterval(() => {
                if (combinedresult.import && combinedresult.hotspotConfig) {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(
                    // "Import: "+ 
                    combinedresult.importToast + "\n" + combinedresult.configToast, 8000, null, null, "success");
                    clearInterval(interval);
                    this.showCMXConnectorAdd(false, this.isConnectorAvailable, false);
                }
            }, 10);
        };
        /* onMouseOverConnector = (connector, index) => {
           if (connector.importNotAllowed) {
             this.showTooltip[index] = true;
           } else {
             this.showTooltip[index] = false;
           }
         }
         onMouseOutConnector = (connector, index) => {
           this.showTooltip[index] = false;
         }*/
        this.selectDefaultService = true;
        this.defaultServiceCheck = (event) => {
            console.log("default service flag selected is ::", this.selectDefaultService);
            /*if(event.returnValue == true){
                this.selectDefaultService = false;
            } else {
                this.selectDefaultService = true;
            }*/
            //this.selectDefaultService = (this.selectDefaultService !== true);//v3DefaultServiceFlag(selected = ALLOWED, not =NOT_ALLOWED)
        };
        this.onControllerSearchKeyUp = () => {
            this.searchText = this.searchInController.toLowerCase();
        };
        this.controllerSearchSkeleton = {
            email: "string",
            firstName: "string",
            lastName: "string",
            name: "string",
            controllerIp: "string"
        };
        this.onControllerSearchFilter = (data) => {
            //if (this.searchText && this.searchText.length > 0) {
            this.controllerList_searchedV2 = data;
            //	}
        };
        this.onControllerSearchV3Filter = (data) => {
            //	if (this.searchText && this.searchText.length > 0) {
            this.controllerList_searched = data;
            //	}
        };
        this.doCopyHotspotConfig = () => {
            this.copyHotspotConfig = !this.copyHotspotConfig;
        };
        this.showCustomerOptions = () => {
            this.displayOptions = !this.displayOptions;
        };
        this.selectCustomerItem = (item) => {
            if (item.selectable || item.selectable == undefined) {
                this.placeholder = item.name;
                this.filterString = "";
                this.displayOptions = false;
                this.connectorImportFromSelected(item);
            }
        };
        this.toggleNetconf = ($event) => {
            this.controllerObj.login.provideNetconf =
                $event.target.checked;
            if (this.controllerObj.login.provideNetconf == true) {
                this.controllerObj.login.netconfUsername = "";
                this.controllerObj.login.netconfPassword = "";
            }
            else {
                this.controllerObj.login.netconfUsername = this.controllerObj.login.username;
                this.controllerObj.login.netconfPassword = this.controllerObj.login.password;
            }
        };
        this.onKeysshUser = (event) => {
            this.controllerObj.login.netconfUsername = this.controllerObj.login.username;
            if (event.key != undefined) {
                if (event.key.charCodeAt(0) >= 32 &&
                    event.key.charCodeAt(0) <= 10175)
                    return true;
                else {
                    event.preventDefault();
                    return false;
                }
            }
        };
        this.onKeysshPassword = (event) => {
            this.controllerObj.login.netconfPassword = this.controllerObj.login.password;
            if (event.key != undefined) {
                if (event.key.charCodeAt(0) >= 32 &&
                    event.key.charCodeAt(0) <= 10175)
                    return true;
                else {
                    event.preventDefault();
                    return false;
                }
            }
        };
    }
    // migrationNotice = false;
    //connectorMigrationGuide: any;
    set showConnectorsUpdate(show) {
        this.showConnectors = show; // C3
        if (show == true) {
            this.getCMXConnectors();
        }
        console.log("showConnectors :: " + this.showConnectors);
    }
    ngOnInit() {
        this.placeholder = "Select Connector";
        this.getStaticText();
        this.alreadyLoadedMetric = [];
        this.removedInstanceStats = new Map(); //each entry is {"instanceName" : [{metric,data}]}
        this.getProperties();
        if (location.pathname.indexOf("setup/wirednetwork/connectors") > -1) {
            this.fromWiredNetwork = true;
            this.initializeSwitchObj();
            this.wiredconnectorSwitchesCount = 0;
            this.connectorSwitchesCount = 0;
        }
        else {
            this.fromWiredNetwork = false;
        }
        if (this.fromWiredNetwork) {
            this.currentNav = "/setup/wirednetwork/connectors";
        }
        else {
            this.currentNav = "/setup/connectors";
        }
        this.dataService.setCurrentNav(this.currentNav);
        /*if(location.pathname.includes("/setup/connector")){
          this.fromWiredNetwork = false;
          this.showConnectorDetails = true;
          this.viewConnector(this.dataService.getConnectorId());
        }
        else if(location.pathname.includes("/setup/wirednetwork/connector")){
          this.fromWiredNetwork = true;
          this.showConnectorDetails = true;
          this.viewConnector(this.dataService.getConnectorId());
        }else{
          this.showConnectorDetails = false;
        }*/
        // RBAC changes starts
        if (this.userRole == "RW") {
            this.userRole = "Admin";
        }
        else if (this.userRole == "RO") {
            this.userRole = "ReadOnlyAccess";
        }
        this.setupName = this.dataService.getDashboardSetupName();
        this.hasIoTAccess =
            this.dataService.getAccountServices("EdgeDeviceManager");
        console.log("setupName :: " + this.setupName);
        if (this.setupName == "dnaspaces") {
            this.dashboardSetupName = "Spaces";
        }
        this.initializeControllerObj();
        this.toggleSaveButton();
        // Remove of getting wlc controllers
        // this.getAvailableControllerIps();
        // this.geteWLCfeatureFlag();
        if (location.pathname.indexOf("setup/connectors") > -1 ||
            location.pathname.indexOf("setup/wirednetwork/connectors") > -1) {
            this.fromHomePageSetup = true;
            this.getCMXConnectors();
            this.tempMetricsColours = this.metricsColours;
            /*setTimeout(() => {
              this.cmxConnectorsService.getConnectorListSummary('connector').pipe(takeUntil(this.unsubscribe$)).
              subscribe(response =>{
                if(response && response.status){
                  console.log("connector list counts are ", response.data);
                  if(response.data ){
                    this.connectorsUpCount = response.data.up;
                    this.connectorsDownCount = response.data.down;
                    this.totalConnectors = response.data.connectorCount
                  }
                }
      
              });
            }, 200);*/
            /*setTimeout(() => {
              this.cmxConnectorsService.getConnectorListSummary('service').pipe(takeUntil(this.unsubscribe$)).
              subscribe(response =>{
                if(response && response.status){
                  console.log("connector list counts are ", response.data);
                  if(response.data ){
                    this.connectorsUpCount = response.data.up;
                    this.connectorsDownCount = response.data.down;
                    this.totalConnectors = response.data.connectorCount
                  }
                }
              });
            }, 200);*/
        }
        this.controllerList = [];
        const userNameForInteractionLog = this.dataService.getUserName();
        const logStr = "VIEW: User " +
            userNameForInteractionLog +
            " has viewed Spaces Connector List";
        this.interactionService.doInteractionLog(new InteractionLog(TYPE.VIEW, this.dataService.getPosition(), "{}", SECTION.HOME_SETUP, ITEM_TYPE.SCREEN, ITEM.SPACES_CONNECTOR, logStr, this.dataService.getCurrentNav()));
        this.showConnectorDetails = false;
        const connector = this.dataService.getConnector();
        if (connector && connector != null) {
            this.showConnectorDetails = true;
            this.viewConnector(connector, connector.name, []);
            this.dataService.setConnector(null);
        }
        this.showMigratecomponent = false;
        this.dataService.closeMagneticPopup();
        // localization
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
    }
    setConnectorDetailsChart(data) {
        this.connectorDetailsChart = new LineChart();
        const outgoingMessageData = data[0];
        const incomingMessageData = data[1];
        console.log(outgoingMessageData, incomingMessageData);
        if (outgoingMessageData.length === 0 &&
            incomingMessageData.length === 0) {
            // Empty data set returned
            this.showLoaderChartLoader = false;
            return;
        }
        const sourceData = [];
        const xAxis = new XAxis();
        xAxis.type = "date";
        xAxis.dateFormat = "MMM d, hh tt";
        xAxis.baseUnit = "hour";
        xAxis.showGridLines = false;
        xAxis.angle = 45;
        xAxis.gridLinesColor = "transparent";
        xAxis.title = { visible: false };
        xAxis.labels = { visible: false };
        xAxis.displayText = null;
        this.connectorDetailsChart.xAxis = xAxis;
        for (let d = 0; d < outgoingMessageData.length; d++) {
            sourceData.push({
                date: outgoingMessageData[d].time,
                outgoing: outgoingMessageData[d].mean.toFixed(2),
                incoming: incomingMessageData[d].mean.toFixed(2)
            });
        }
        const yAxis = new YAxis();
        yAxis.title = { visible: true, text: "Messages / Second" };
        const chartSeries = new ChartSeries().setFields("outgoing", "Outgoing", "#4059AA");
        const chartSeries2 = new ChartSeries().setFields("incoming", "Incoming", "#BE60A6");
        chartSeries.type = "line";
        chartSeries2.type = "line";
        this.connectorDetailsChart.title = "Message Rates in Last 24 Hours";
        this.connectorDetailsChart.units = "msg/s";
        this.connectorDetailsChart.chartUpdate = false;
        this.connectorDetailsChart.showLegend = true;
        this.connectorDetailsChart.xAxisDateField = "date";
        this.connectorDetailsChart.sourceData = sourceData;
        this.connectorDetailsChart.yAxis = yAxis;
        this.connectorDetailsChart.series.push(chartSeries);
        this.connectorDetailsChart.series.push(chartSeries2);
        this.showLoaderChartLoader = false;
    }
    setD3ConnectorDetailsChart(resData) {
        this.prepareChartOptions();
        //  var resData1= [[{ "time": "2019-10-23T14:00:00.000Z", "mean": 12.310252526539745 }, { "time": "2019-10-23T15:00:00.000Z", "mean": 12.47446815168291 }, { "time": "2019-10-23T16:00:00.000Z", "mean": 12.475981689885591 }, { "time": "2019-10-23T17:00:00.000Z", "mean": 12.470089696972478 }, { "time": "2019-10-23T18:00:00.000Z", "mean": 13.557466351480976 }, { "time": "2019-10-23T19:00:00.000Z", "mean": 11.865137079196254 }, { "time": "2019-10-23T20:00:00.000Z", "mean": 10.265075021063513 }, { "time": "2019-10-23T21:00:00.000Z", "mean": 10.457496704230323 }, { "time": "2019-10-23T22:00:00.000Z", "mean": 10.348617078767132 }, { "time": "2019-10-23T23:00:00.000Z", "mean": 10.143440422232004 }, { "time": "2019-10-24T00:00:00.000Z", "mean": 9.945915511054555 }, { "time": "2019-10-24T01:00:00.000Z", "mean": 9.966123604546842 }, { "time": "2019-10-24T02:00:00.000Z", "mean": 9.876326679062725 }, { "time": "2019-10-24T03:00:00.000Z", "mean": 9.981212344039129 }, { "time": "2019-10-24T04:00:00.000Z", "mean": 9.716277946214694 }, { "time": "2019-10-24T05:00:00.000Z", "mean": 9.63228581304596 }, { "time": "2019-10-24T06:00:00.000Z", "mean": 9.608390789664295 }, { "time": "2019-10-24T07:00:00.000Z", "mean": 9.678327061805314 }, { "time": "2019-10-24T08:00:00.000Z", "mean": 9.602305441364901 }, { "time": "2019-10-24T09:00:00.000Z", "mean": 9.824032350000143 }, { "time": "2019-10-24T10:00:00.000Z", "mean": 9.685810098639214 }, { "time": "2019-10-24T11:00:00.000Z", "mean": 9.721534813027278 }, { "time": "2019-10-24T12:00:00.000Z", "mean": 9.847154140723752 }, { "time": "2019-10-24T13:00:00.000Z", "mean": 9.640435512143508 }, { "time": "2019-10-24T14:00:00.000Z", "mean": 9.65871173557131 }], [{ "time": "2019-10-23T14:00:00.000Z", "mean": 13.1769895511636 }, { "time": "2019-10-23T15:00:00.000Z", "mean": 13.352781313648812 }, { "time": "2019-10-23T16:00:00.000Z", "mean": 13.445744959539145 }, { "time": "2019-10-23T17:00:00.000Z", "mean": 13.406484842851054 }, { "time": "2019-10-23T18:00:00.000Z", "mean": 14.54462383876633 }, { "time": "2019-10-23T19:00:00.000Z", "mean": 12.640054787577226 }, { "time": "2019-10-23T20:00:00.000Z", "mean": 10.827484575582881 }, { "time": "2019-10-23T21:00:00.000Z", "mean": 11.007844083541242 }, { "time": "2019-10-23T22:00:00.000Z", "mean": 10.854309950744112 }, { "time": "2019-10-23T23:00:00.000Z", "mean": 10.639808945043974 }, { "time": "2019-10-24T00:00:00.000Z", "mean": 10.693665409264362 }, { "time": "2019-10-24T01:00:00.000Z", "mean": 10.488466581555047 }, { "time": "2019-10-24T02:00:00.000Z", "mean": 10.310466676988364 }, { "time": "2019-10-24T03:00:00.000Z", "mean": 10.41764224055215 }, { "time": "2019-10-24T04:00:00.000Z", "mean": 10.179343196592596 }, { "time": "2019-10-24T05:00:00.000Z", "mean": 10.037498428144158 }, { "time": "2019-10-24T06:00:00.000Z", "mean": 10.049262399161881 }, { "time": "2019-10-24T07:00:00.000Z", "mean": 10.087394650364416 }, { "time": "2019-10-24T08:00:00.000Z", "mean": 10.009167214903306 }, { "time": "2019-10-24T09:00:00.000Z", "mean": 10.232104960289746 }, { "time": "2019-10-24T10:00:00.000Z", "mean": 10.083902402177054 }, { "time": "2019-10-24T11:00:00.000Z", "mean": 10.12054223619354 }, { "time": "2019-10-24T12:00:00.000Z", "mean": 10.25924389154615 }, { "time": "2019-10-24T13:00:00.000Z", "mean": 10.060926890770324 }, { "time": "2019-10-24T14:00:00.000Z", "mean": 10.090107493351821 }]];
        const outgoingMessageData = resData[0];
        const incomingMessageData = resData[1];
        console.log(outgoingMessageData, incomingMessageData);
        if (outgoingMessageData.length === 0 &&
            incomingMessageData.length === 0) {
            // Empty data set returned
            this.showLoaderChartLoader = false;
            return;
        }
        const outgoingSourceData = [];
        const incomingSourceData = [];
        const xAxis = new XAxis();
        xAxis.type = "date";
        xAxis.dateFormat = "MMM d, hh A";
        xAxis.baseUnit = "hour";
        xAxis.showGridLines = false;
        xAxis.angle = 45;
        xAxis.gridLinesColor = "transparent";
        xAxis.title = { visible: false };
        xAxis.labels = { visible: false };
        xAxis.displayText = null;
        for (let d = 0; d < outgoingMessageData.length; d++) {
            // let outgoingDate = moment(outgoingMessageData[d].time).format("YYYY-MM-DD");
            //let outgoingDisplayDate = moment(outgoingMessageData[d].time).format("MMM d, hh A");
            const outgoingDisplayDate = moment$i
                .utc(outgoingMessageData[d].time)
                .format("MMM DD h:mm A");
            // sourceData.push({ "date": outgoingMessageData[d].time, "outgoing": outgoingMessageData[d].mean.toFixed(2), "incoming": incomingMessageData[d].mean.toFixed(2) });
            outgoingSourceData.push({
                name: "outgoing",
                date: outgoingMessageData[d].time,
                displayDate: outgoingDisplayDate,
                count: outgoingMessageData[d].mean.toFixed(2),
                color: "#4059AA"
            });
        }
        for (let d = 0; d < incomingMessageData.length; d++) {
            // let incomingDate = moment(incomingMessageData[d].time).format("YYYY-MM-DD");
            //let incomingDisplayDate = moment(incomingMessageData[d].time).format("MMM d, hh A");
            const incomingDisplayDate = moment$i
                .utc(incomingMessageData[d].time)
                .format("MMM DD h:mm A");
            incomingSourceData.push({
                name: "incoming",
                date: incomingMessageData[d].time,
                displayDate: incomingDisplayDate,
                count: incomingMessageData[d].mean.toFixed(2),
                color: "#BE60A6"
            });
        }
        const yAxis = new YAxis();
        yAxis.title = { visible: true, text: "Messages / Second" };
        const chartSeries = new ChartSeries().setFields("outgoing", "Outgoing", "#4059AA");
        const chartSeries2 = new ChartSeries().setFields("incoming", "Incoming", "#BE60A6");
        chartSeries.type = "line";
        chartSeries2.type = "line";
        if (outgoingSourceData && outgoingSourceData.length > 0)
            this.connectorDetailsD3Chart.push({
                name: "outgoing",
                values: outgoingSourceData,
                color: "#4059AA"
            });
        if (incomingSourceData && incomingSourceData.length > 0)
            this.connectorDetailsD3Chart.push({
                name: "incoming",
                values: incomingSourceData,
                color: "#BE60A6"
            });
        this.showLoaderChartLoader = false;
    }
    validateConnectorVersion(connector) {
        const { report } = connector;
        if (!report)
            return false;
        const { current_version = "" } = report;
        if (current_version.includes("grpc-drop"))
            return false;
        const version = current_version.split(".")[2];
        // compare to version above 2.0.225
        return version && Number(version) > 225;
    }
    setFieldData(e, key) {
        const { value } = e.target;
        const hasErrors = this.validateFields(value, key);
        this[`${key}_error`] = "";
        if (hasErrors) {
            this[`${key}_error`] = this.regex[key].error;
            return;
        }
        if (key === "netconfUsername") {
            this.controllerObj.login[key] = value;
        }
        else if (key === "username") {
            this.controllerObj.login[key] = value;
            if (this.controllerObj.login.provideNetconf)
                this.controllerObj.login['netconfUsername'] = value;
        }
        else {
            this.controllerObj[key] = value;
        }
    }
    validateFields(value, key) {
        return !this.regex[key].expression.test(value);
    }
    onChangeWLCConfig(type) {
        this.wlcConfigType = type;
    }
    handleViewKeysClick() {
        this.displayTokens = true;
        this.dataService.display(true);
        this.cmxConnectorsService
            .getManageStreamAuthKey(this.selectedId)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((response) => {
            this.authToken = response.streamAuthKey;
            this.dataService.display(false);
            this.dataService.setToastMessage(this.messageKeys["auth_key_success"], 4000, null, null, "success");
        }, (error) => {
            this.dataService.display(false);
            this.dataService.setToastMessage(this.messageKeys["error_occured_toke"], 4000, null, null, "error");
        });
        if (this.configurableState === "AUTO") {
            this.cmxConnectorsService
                .getCertificateChain()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                const { caCert } = response;
                this.certificate = caCert;
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["confi_deails_success"], 4000, null, null, "success");
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["unable_fetch_conf"], 4000, null, null, "error");
            });
        }
    }
    /**
     *
     * @param controller
     * @param action
     * Enable(push config) or disable stream
     */
    toggleStream() {
        const state = this.profileOptInType;
        if (state) {
            this.dataService.display(true);
            const connectorId = this.confirmationEl.selectedController["connectorId"];
            const id = this.confirmationEl.selectedController["id"];
            const isEnable = this.confirmationEl.action === "enable";
            this.cmxConnectorsService
                .toggleStreamStatus([id], connectorId, this.confirmationEl.action, state)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                this.closeStreamConfirmation();
                this.toggleLogsTable = isEnable;
                this.dataService.display(false);
                this.ewlcInterval = setInterval(() => {
                    this.getAllEwlcStreamStatus(connectorId);
                }, 10000);
                this.dataService.setToastMessage(this.messageKeys["stream_queued"], 4000, null, null, "success");
            }, (error) => {
                this.closeStreamConfirmation();
                this.dataService.display(false);
                this.dataService.setToastMessage(`Error ${this.confirmationEl.action === "enable"
                    ? "enabling"
                    : "disabling"} stream`, 4000, null, null, "error");
            });
        }
        else {
            this.dataService.setToastMessage(this.messageKeys["select_option"], 4000, null, null, "error");
        }
    }
    /**
     *
     * @param controller
     * @param action
     * Enable(push config) or disable stream
     */
    openStreamConfirmation(controller, action, type) {
        this.confirmationEl.selectedController = controller;
        if (type === 'switch') {
            this.confirmationEl.isController = false;
        }
        this.switchObj.saveConfig = false; //7 june
        this.confirmationEl.action = action;
        this.confirmationEl.display = true;
        this.dataService.openMagneticPopup();
    }
    closeStreamConfirmation() {
        this.confirmationEl.display = false;
        this.dataService.closeMagneticPopup();
    }
    getConfigOperationColor() {
        const status = this.configOperationStatus;
        let color = "";
        switch (status) {
            case "NOT INITIATED":
            case "IN PROGRESS":
                color = "#EFA741";
                break;
            case "TIMEOUT":
            case "FAILURE":
                color = "#F86969";
                break;
            case "SUCCESS":
                color = "#008000";
                break;
        }
        return color;
    }
    /*closeCofirmPopup = () =>{
      this.showConnectorConfirmPopUp =false;
    }
  
    showConnectorDetailsPage = () => {
      const getUrl = window.location;
      this.router.navigate(["/setup/connectors"]);
    }*/
    ngOnDestroy() {
        console.log("destory cmxConnectors page");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
CmxConnectorComponent.ɵfac = function CmxConnectorComponent_Factory(t) { return new (t || CmxConnectorComponent)(i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(CMXConnectorsService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(InteractionService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(CmxOnpremService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
CmxConnectorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CmxConnectorComponent, selectors: [["app-cmx-connector"]], viewQuery: function CmxConnectorComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(CmxConnectorInstancesComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cmxConnectorInstancesComponent = _t.first);
    } }, inputs: { userRole: "userRole", showConnectorsUpdate: "showConnectorsUpdate" }, outputs: { showControllers: "showControllers" }, decls: 1, vars: 1, consts: [["class", "cmxConnectorWrapper", 4, "ngIf"], [1, "cmxConnectorWrapper"], ["style", "height: 100%;", 4, "ngIf"], ["class", "cmxConnectorForm controllerForm", 4, "ngIf"], ["class", "modalPopup modalPopupSm wlcConnectorPopup", 4, "ngIf"], ["class", "modalPopup", 4, "ngIf"], ["class", "fullscreenPopup", 4, "ngIf"], ["class", "modalPopup modalPopupLg connectorPopup wlcConnectorPopup", 4, "ngIf"], ["class", "modalPopup modalPopupSm", 4, "ngIf"], ["class", "modalPopup confirmationPopup", 4, "ngIf"], ["class", "modalPopup modalPopupLg connectorPopup", 4, "ngIf"], ["class", "confirmation-popup-wrapper", 4, "ngIf"], ["class", "modalPopup modalPopup-controller connectorPopup wlcConnectorPopup", 4, "ngIf"], [3, "title", "idParam", "url", "accessTokenFlag", "id", "hideAccessToken", 4, "ngIf"], [3, "idParam", "url", "title", "accessTokenFlag", "id", "hideAccessToken", 4, "ngIf"], [3, "showMigratecomponent", "connector", "closeMigratePopup", "doneMigratePopup"], [3, "showManageConnectorPopup", "selectedConnector", "serviceList", "instancesNodeIds", "title", "serviceNameDisplayName", "refreshConnectorList", "emitClosePopup", 4, "ngIf"], [2, "height", "100%"], [1, "cmxConnectorAdd"], [1, "cmxConnectorHeading"], [1, "connectorHeader"], [1, "connector-pat-start", "setup", 3, "click"], [1, "breadcrumbSeparator"], ["class", "connector-path1", 4, "ngIf"], ["class", "connector-path", 3, "click", 4, "ngIf"], ["class", "breadcrumbSeparator", 4, "ngIf"], ["class", "headerinfo", 4, "ngIf"], [1, "summary"], [1, "leftSummary"], ["class", "rightSummary", 4, "ngIf"], ["class", "header", 4, "ngIf"], [1, "modalBody-connector"], ["class", "grayDiv", 3, "ngClass", 4, "ngIf"], ["class", "grayDiv", "style", "margin-top: 25px;", 4, "ngIf"], ["class", "grayDiv instance-dv", 4, "ngIf"], ["class", "grayDiv", 4, "ngIf"], ["class", "update-note", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], ["class", "grayDiv-controller top-margin", 4, "ngIf"], ["class", "grayDiv-switch top-margin", 4, "ngIf"], ["class", "grayDiv metricDiv", 4, "ngIf"], ["class", "switchdiv", 4, "ngIf"], [1, "connector-path1"], [1, "connector-path", 3, "click"], [1, "headerinfo"], [2, "color", "#D8D8D8"], [1, "rightSummary"], [1, "summary-icon"], ["src", "/assets/images/setupConnector/connectors_summary_icon.svg"], [1, "summarySection"], [1, "summary-detail"], [1, "floatleft"], [1, "num-summary"], [1, "parameter-text"], [1, "up-green", "num-summary"], [1, "floatleft", "border", 2, "width", "auto !important", "padding-right", "33px"], [1, "down-red", "num-summary"], [1, "summary-sub-detail"], [4, "ngIf"], ["class", "floatleft service-summmary", 4, "ngFor", "ngForOf"], [1, "floatleft", "service-summmary"], [1, "leftMargin", "num-summary"], [1, "parameter-text", "leftMargin"], [1, "floatleft-detail"], [1, "floatleft-detail", "border", 2, "width", "auto !important", "padding-right", "33px"], [1, "floatleft-detail", "leftMargin", "service-enabled"], ["class", "parameter-text", 4, "ngIf"], [1, "floatleft-detail", "border"], [1, "header"], [1, "header-inner"], ["id", "link-locdetails-aps", 1, "header-blocks", "noselect", 3, "ngClass", "click"], [1, "active-name"], [1, "tokenDiv"], [1, "cursorP", "border", 2, "padding-right", "18px", 3, "click"], ["src", "/assets/images/setupConnector/refresh.svg", 1, "statusAsset"], ["src", "/assets/images/setupConnector/generate_token.svg", 1, "statusAsset"], [1, "cursorP", 3, "click"], ["src", "/assets/images/setupConnector/trouble_connector.svg", 1, "statusAsset"], ["id", "link-locdetails-aps", 1, "header-blocks", "noselect", 3, "click"], ["class", "cursorP", 3, "click", 4, "ngIf"], [1, "grayDiv", 3, "ngClass"], ["class", "migration-note", 4, "ngIf"], [1, "subHeader"], ["class", "headerSection", 4, "ngIf"], ["id", "btn-connector-create", "class", "addUuidDiv createConnector", 3, "click", 4, "ngIf"], [1, "connector-table", "list", "noScroll"], ["class", "emptyStateHeading", 4, "ngIf"], ["class", "userTableContainer listContainer", 4, "ngIf"], [1, "migration-note"], [2, "display", "inline", "float", "left", "margin-top", "10px"], ["src", "/assets/images/setupConnector/alerts.svg", 2, "width", "30px"], [2, "font-weight", "bold", "font-size", "14px", "padding", "8px", "display", "inline", "float", "left", "width", "84%"], ["target", "_blank", 2, "color", "#0096d6", 3, "href"], [1, "headerSection"], ["id", "btn-connector-create", 1, "addUuidDiv", "createConnector", 3, "click"], ["src", "/assets/images/add.svg", "width", "20", 2, "display", "inline"], [1, "Connector-seperator", 2, "display", "inline"], [1, "emptyStateHeading"], [1, "divTable"], [1, "divTableRow"], [1, "divTableCell"], ["style", "display: inline;  color:#4d4d4d;", 4, "ngIf", "ngIfElse"], ["cmxengage", ""], ["src", "/assets/images/setupConnector/not_configured.svg", 1, "image-img"], [2, "display", "inline", "color", "#4d4d4d"], [1, "userTableContainer", "listContainer"], [1, "table", "userTable", "userTable_con"], [1, "tableTr", "textUppercase"], [3, "data", "shouldUseGlobalSearch", "searchSkeleton", "filtered"], [1, "pagination-div"], [3, "pagesToShow", "perPage", "page", "loading", "items", "clickEvent", "currentPage"], ["class", "tableTr", 4, "ngFor", "ngForOf"], [1, "tableTr"], [2, "width", "20%"], ["class", "userListLabel", 4, "ngIf"], ["class", "loader", 4, "ngIf"], ["class", "loader", "style", "display:inline-block;", 4, "ngIf"], [2, "width", "8%"], [1, "columnData"], ["class", "columnData", 4, "ngIf"], ["class", "userAccess", 3, "ngClass", 4, "ngIf"], ["class", "userAccess tooltip inactive", 4, "ngIf"], [1, "userActionsMenu"], ["style", "display: inline;", "href", "javascript:void(0)", "class", "userEditIcon", 3, "click", 4, "ngIf"], [1, "actionMenu", 3, "ngClass"], ["href", "javascript:void(0)", "class", "userEditIcon showMoreIcon", 3, "click", 4, "ngIf"], ["class", "menu-l show-menu", 4, "ngIf"], [1, "userListLabel"], [1, "userListName", 3, "click"], [1, "userNameLink"], [1, "loader"], ["class", "tooltip upgrade-image", 4, "ngIf"], [1, "tooltip", "upgrade-image"], ["src", "/assets/images/setupConnector/upgrade_orange.svg", 2, "cursor", "pointer"], ["class", "tooltiptext1", 4, "ngIf"], ["class", "tooltiptext2", 4, "ngIf"], [1, "tooltiptext1"], [1, "tooltiptext2"], [1, "loader", 2, "display", "inline-block"], ["class", "release-div", 4, "ngIf"], [1, "upgrade-arrow"], ["class", "tooltip", 4, "ngIf"], [1, "release-div"], [1, "tooltip"], ["src", "/assets/images/setupConnector/upgrade_orange.svg", 2, "cursor", "pointer", 3, "mouseover"], [3, "mouseleave", 4, "ngIf"], [3, "mouseleave"], [1, "tooltiptext3"], [1, "migrate-header", "marginTopheader"], [1, "migrate-text"], ["href", "javascript:void(0)", "class", "userEditIcon", "style", "color: #09c!important;", 3, "click", 4, "ngIf"], ["href", "javascript:void(0)", 1, "userEditIcon", 2, "color", "#09c!important", 3, "click"], [1, "userAccess", 3, "ngClass"], ["src", "/assets/images/setupConnector/up.svg", 1, "statusAsset"], ["src", "/assets/images/setupConnector/down.svg", 1, "statusAsset"], [1, "userAccess", "tooltip", "inactive"], ["src", "/assets/images/setupConnector/degrade.svg", 1, "statusAsset"], [1, "tooltiptext"], ["href", "javascript:void(0)", 1, "userEditIcon", 2, "display", "inline", 3, "click"], ["src", "/assets/images/setupConnector/info.svg", "alt", ".", 1, "img-icon"], ["src", "/assets/images/setupConnector/upgrade.svg", "alt", ".", 1, "img-icon"], ["src", "/assets/images/setupConnector/manage.svg", 1, "img-icon"], ["href", "javascript:void(0)", 1, "userEditIcon", "showMoreIcon", 3, "click"], ["src", "/assets/images/setupConnector/more.svg", 1, "menu-open-img"], [1, "menu-l", "show-menu"], [1, "show-menu-notch"], [1, "inner"], [1, "action-list"], [1, "", 3, "click"], ["href", "javascript:void(0)", 1, "userEditIcon"], [1, "userActionsMenu", 3, "ngClass"], ["href", "javascript:void(0)", "class", "userEditIcon", 3, "click", 4, "ngIf"], ["href", "javascript:void(0)", 1, "userEditIcon", 3, "click"], ["href", "javascript:void(0)", "class", "controllerEditIcon configure", 3, "click", 4, "ngIf"], ["src", "/assets/images/setupConnector/upgrade_orange.svg"], ["href", "javascript:void(0)", 1, "controllerEditIcon", "configure", 3, "click"], ["src", "/assets/images/setupConnector/edit.svg", "alt", ".", 1, "img-icon"], ["src", "/assets/images/setupConnector/delete.svg", "alt", ".", 1, "img-icon"], [1, "grayDiv", 2, "margin-top", "25px"], [1, "subHeader", 2, "padding", "20px 0 15px 62.5px"], [1, "controllerSearchAdd"], [1, "controller-search-container"], [1, "user-search-icon"], ["name", "userSearch", "placeholder", "Controller Name / Controller IP", 1, "searchInput", 3, "ngModel", "ngModelChange", "keyup"], [3, "data", "customSearchText", "shouldUseGlobalSearch", "searchSkeleton", "filtered"], ["id", "btn-connector-create", "class", "addUuidDiv createConnector addController", 3, "click", 4, "ngIf"], [1, "connector-table-V2"], ["class", "userTableContainer_controller", 4, "ngIf"], ["id", "btn-connector-create", 1, "addUuidDiv", "createConnector", "addController", 3, "click"], ["src", "/assets/images/add.svg", "width", "20"], [1, "empty_metric_msg"], [1, "userTableContainer_controller"], [1, "table", "userTable", "controller-tbl"], ["class", "tableTr controllerTr", 4, "ngFor", "ngForOf"], [1, "tableTr", "controllerTr"], [2, "white-space", "nowrap"], [1, "userListName_base"], [1, "userListEmail"], [1, "userAccess"], ["src", "/assets/images/setupConnector/info.svg", "alt", "."], ["src", "/assets/images/setupConnector/edit.svg", "alt", "."], ["src", "/assets/images/setupConnector/delete.svg", "alt", "."], [1, "grayDiv", "instance-dv"], [3, "userRole", "availableInstances", "currentConnector", "allAvailableServices", "nodeIds", "connectorConfigureGuide", "serviceNameDisplayName", "emitInstanceRemoval"], [1, "grayDiv"], [3, "pageFrom", "switchConnector", "modalTitle", "type", "closeModal", "showConnectorListPage", "showSwitchCount"], [1, "update-note"], [1, "update-message"], [1, "updateLink", "clickpointer", 3, "click"], [1, "line-sep"], ["target", "_blank", 1, "updateLink", "clickpointer", 2, "color", "#0096d6", 3, "href"], [3, "ngClass"], [3, "selectedServices", "userRole", "allServices", "currentConnector", "isConnectorAvailable", "connectorServices", "triggerManageIOTStreams", "showServiceUpgrade", "triggerManageIOTServices", 4, "ngIf"], [3, "selectedServices", "userRole", "allServices", "currentConnector", "isConnectorAvailable", "connectorServices", "triggerManageIOTStreams", "showServiceUpgrade", "triggerManageIOTServices"], [1, "grayDiv-controller", "top-margin"], [1, "subHeader_controller"], [1, "connector-table_controller"], ["class", "userTableContainer userTableContainer_controller", 4, "ngIf"], [1, "userTableContainer", "userTableContainer_controller"], [1, "table-structure"], [1, "table", "userTable"], ["class", "userAccess clickable", 3, "ngClass", "click", 4, "ngIf"], ["class", "userAccess tooltip inactive clickable", 3, "ngClass", "click", 4, "ngIf"], [1, "userAccess", "clickable", 3, "ngClass", "click"], ["src", "/assets/images/setupConnector/down.svg", 1, "statusAsset", "clickable"], [1, "userAccess", "tooltip", "inactive", "clickable", 3, "ngClass", "click"], [1, "grayDiv-switch", "top-margin"], [1, "grayDiv", "metricDiv"], ["class", "emptyStateHeading-metric", 4, "ngIf"], ["class", "form-group selectedDropdown", 4, "ngIf"], ["class", "emptyStateHeading", "style", "margin-top: 25px;", 4, "ngIf"], ["class", "metric-chart", 4, "ngFor", "ngForOf"], [1, "emptyStateHeading-metric"], [1, "form-group", "selectedDropdown"], [1, "metricHeader"], ["for", "", 1, "readWriteField"], [1, "metricSerHeader", 3, "selectedItem", "listItems", "atDropdownSelect"], [1, "metricInterval", 3, "selectedItem", "listItems", "atDropdownSelect"], [1, "utcmsg"], [1, "metricInstanceoption", 3, "ngClass"], [1, "list-column", 3, "click"], ["src", "/assets/images/TileRedesign/view.svg", 2, "padding", "6px"], ["src", "/assets/images/TileRedesign/arrow.svg", "alt", "Tile Info - Arrow", 2, "padding", "0 4px 0 7px", "width", "22px"], ["class", "appsPopup modalContentInstance", "id", "act-popup-div-id", 4, "ngIf"], ["id", "act-popup-div-id", 1, "appsPopup", "modalContentInstance"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], [1, "list-div"], [4, "ngFor", "ngForOf"], [1, "circularCheckbox", "userCheckbox"], ["type", "checkbox", 3, "id", "checked", "click"], [1, "checkboxLabel", 3, "for"], [1, "userListName"], [1, "app-popup-values"], [1, "emptyStateHeading", 2, "margin-top", "25px"], [1, "metric-chart"], [1, "metric-param"], [3, "data", "options", 4, "ngIf"], [1, "legendDetails"], [1, "legendInfo"], ["class", "legendContainer", 4, "ngFor", "ngForOf"], [3, "data", "options"], [1, "legendContainer"], ["class", "legendColor bestInClassVisits legend-rect", "style", "background-color: #8038B2;", 4, "ngIf"], ["class", "legendColor bestInClassVisits legend-rect", "style", "background-color: #1B109B;", 4, "ngIf"], ["class", "legendColor bestInClassVisits legend-rect", "style", "background-color: #3B9EDF;", 4, "ngIf"], ["class", "legendColor bestInClassVisits legend-rect", "style", "background-color: #DF3B8F;", 4, "ngIf"], [1, "legendName", "bestInClassVisitsText"], [1, "legendColor", "bestInClassVisits", "legend-rect", 2, "background-color", "#8038B2"], [1, "legendColor", "bestInClassVisits", "legend-rect", 2, "background-color", "#1B109B"], [1, "legendColor", "bestInClassVisits", "legend-rect", 2, "background-color", "#3B9EDF"], [1, "legendColor", "bestInClassVisits", "legend-rect", 2, "background-color", "#DF3B8F"], [1, "switchdiv"], [3, "pageFrom", "switchConnector", "modalTitle", "type", "closeModal", "showConnectorListPage"], [1, "cmxConnectorForm", "controllerForm"], [1, "modalPopup", "modalPopupLg", "wlcConnectorPopup"], [1, "modalContent-connector"], [1, "modalBody", 2, "overflow-y", "auto"], ["class", "fieldWrapper error", 4, "ngIf"], [1, "fieldWrapper"], [1, "fieldLabel"], ["type", "hidden", 3, "ngModel", "ngModelChange"], ["class", "clear", 4, "ngIf"], ["class", "modalFooter", 4, "ngIf"], [1, "fieldWrapper", "error"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the spaces connector name", 1, "portalNameInput", 3, "disabled", "value", "keyup", "input"], [1, "select-menu", "select-custom-2", 3, "ngClass", "click"], [1, "select-item", "first", "customerNameDropdown"], ["class", "\n\t\t\t\t\t\t\t\t\t\tselect-item-container\n\t\t\t\t\t\t\t\t\t\twebexListContainer\n\t\t\t\t\t\t\t\t\t", 4, "ngIf"], [1, "select-item-container", "webexListContainer"], [1, "select-item", 3, "click"], [1, "clear"], [1, "selector-tab", "fieldWrapper", "clear", "flex-b"], [1, "selector"], [1, "pmxRadio"], ["type", "radio", "value", "Add new controller", "name", "value", 1, "pmxRadioButton", "ac-radio", 3, "ngModel", "ngModelChange"], ["for", "accessOption", 1, "pmxRadioButtonLabel", "ac-radio-label"], [1, "ac-sel-header"], [2, "font-size", "10px"], ["type", "radio", "value", "Choose controller from another connector", "name", "value", 1, "pmxRadioButton", "ac-radio", 3, "ngModel", "ngModelChange"], [1, "fieldWrapper", "controllerIPInput"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the controller ip", 1, "portalNameInput", "ctlrIp", 3, "disabled", "value", "keyup", "input"], ["class", "error", 4, "ngIf"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the controller name", 1, "portalNameInput", "ctlrName", 3, "value", "keyup", "input"], [1, "fieldWrapper", "clear"], [1, "fieldLabel", 2, "float", "left"], ["tabindex", "0", 1, "select-menu", "select-custom-2", 3, "ngClass", "click"], [1, "select-item", "first"], ["tabindex", "0", "class", "select-item-container webexListContainer", 4, "ngIf"], [1, "error"], ["tabindex", "0", 1, "select-item-container", "webexListContainer"], [1, "positionRelative"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the username", 1, "portalNameInput", 3, "value", "keyup", "input"], ["type", "password", "autofocus", "autofocus", "placeholder", "Enter the password", 1, "portalNameInput", 3, "value", "keyup", "input"], ["sshPwd", ""], ["src", "/assets/images/basic/password_switch.svg", "width", "15"], [1, "showPassword", 3, "click"], ["sshPwdText", ""], ["enablePwd", ""], ["enablePwdText", ""], [1, "paddingTop20", "divTable", 2, "padding-bottom", "20px"], [1, "divTableCell", 2, "width", "35px"], [1, "circularCheckbox"], ["type", "checkbox", "id", "provide-netconf", 3, "checked", "click"], ["for", "provide-netconf", 1, "checkboxLabel"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the username", 1, "portalNameInput", 3, "value", "ngClass", "keyup", "input"], ["type", "password", "autofocus", "autofocus", "placeholder", "Enter the password", 1, "portalNameInput", 3, "value", "ngClass", "keyup", "input"], ["netconfPwd", ""], ["src", "/assets/images/basic/password_switch.svg", "width", "15", 3, "ngClass"], ["netconfPwdText", ""], ["class", "cli", 4, "ngIf"], ["class", "fieldWrapper clear", 4, "ngIf"], ["class", "fieldWrapper clear testsuccess", 4, "ngIf"], [1, "cli"], [1, "cli-heading"], ["class", "messages", 4, "ngFor", "ngForOf"], ["class", "cli-heading", 4, "ngIf"], [1, "cli-commands"], [1, "copy-command"], ["aria-hidden", "true", 1, "fa", "fa-clipboard", 3, "click"], ["class", "commands", 4, "ngFor", "ngForOf"], [1, "messages"], [1, "commands"], [1, "cli-command"], [1, "commonButton", 3, "ngClass", "click"], ["class", "spinner", 4, "ngIf"], [2, "margin", "5px", 3, "ngClass"], [1, "spinner"], [1, "connectivity-messages"], ["class", "message", 4, "ngFor", "ngForOf"], [1, "message"], ["id", "normal-active", 1, "table-box", "selectable"], [1, "table-header"], [1, "w10", "pl20", 2, "text-align", "left"], ["class", "w10 pl20", "style", "text-align:left;", 4, "ngFor", "ngForOf"], ["class", "table-tr", 4, "ngFor", "ngForOf"], [1, "table-tr"], ["class", "w10 pl20", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "w10", "pl20", 3, "ngClass"], [1, "fieldWrapper", "clear", "testsuccess"], [1, "fieldWrapper", "clear", 2, "display", "none"], ["type", "radio", "name", "wlc-radio", 1, "wlcRadioButton", 3, "value", "change"], ["for", "wlc-radio", 1, "wlcRadioButtonLabel"], [1, "wlcRadioLabel"], ["style", "padding: 0px 25px; display: none", 4, "ngIf"], ["class", "\n\t\t\t\t\t\t\t\t\t\t\t\tselect-item-container\n\t\t\t\t\t\t\t\t\t\t\t\twebexListContainer\n\t\t\t\t\t\t\t\t\t\t\t", 4, "ngIf"], ["type", "password", "autofocus", "autofocus", "placeholder", "Enter the snmp RW Community", 1, "portalNameInput", 3, "value", "keyup", "input"], ["inputCommunity", ""], ["inputCommunityText", ""], ["class", "\n\t\t\t\t\t\t\t\t\t\t\t\t\tselect-item-container\n\t\t\t\t\t\t\t\t\t\t\t\t\twebexListContainer\n\t\t\t\t\t\t\t\t\t\t\t\t", 4, "ngIf"], ["inputPwd", ""], ["inputPwdText", ""], ["type", "password", "autofocus", "autofocus", "placeholder", "Enter the privacy password", 1, "portalNameInput", 3, "value", "keyup", "input"], ["inputPrivacy", ""], ["inputPrivacyText", ""], [1, "paddingTop20", "divTable"], ["type", "checkbox", "id", "enable-wsa", 3, "checked", "click"], ["for", "enable-wsa", 1, "checkboxLabel"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the CLI Username", 1, "portalNameInput", 3, "value", "keyup", "input"], ["type", "password", "autofocus", "autofocus", "placeholder", "Enter the CLI Password", 1, "portalNameInput", 3, "value", "keyup", "input"], [2, "padding", "0px 25px", "display", "none"], ["class", "migrate-note", 4, "ngIf"], ["class", "table-wrapper fieldWrapper clear", 4, "ngIf"], ["class", "noImportdevice", 4, "ngIf"], [1, "dropdown_con"], [1, "arrow", 3, "click"], ["type", "text", "name", "dropdownFilter", "autocomplete", "off", 1, "formControl", 3, "ngModel", "placeholder", "ngModelChange", "click"], [3, "class", "click", 4, "ngFor", "ngForOf"], [3, "click"], [1, "item-name", 3, "innerHTML"], [1, "item-message", 3, "innerHTML"], [1, "circularCheckbox", "divTableCell", 2, "margin", "20px 0px"], ["type", "checkbox", "id", "hotspotCheckbox", 3, "checked", "click"], ["for", "hotspotCheckbox", 1, "checkboxLabel"], [1, "migrate-note"], ["src", "/assets/images/setupConnector/alerts.svg", 2, "width", "22px"], [2, "font-weight", "bold", "font-size", "12px", "padding", "8px", "display", "inline", "float", "left", "width", "70%", "margin-top", "4px"], [1, "table-wrapper", "fieldWrapper", "clear"], [1, "w10", "pl20", "headerAlign"], ["type", "checkbox", "name", "accessCodeSelectCheckbox", "id", "selectAllControllers", 3, "ngModel", "ngModelChange", "change"], ["for", "selectAllControllers", 1, "checkboxLabel", 3, "ngClass"], ["noAllCheckBox", ""], [1, ""], ["type", "checkbox", "disabled", "", 3, "ngModel", "ngModelChange"], [1, "checkboxLabel", "disabledElement"], [1, "w10", "pl20", "activeStatusColumn"], ["type", "checkbox", "name", "selectCheckboxController", 1, "checkboxStatusTD", 3, "ngModel", "id", "checked", "ngModelChange", "change"], ["noCheckBox", ""], [1, "w10", "pl20", "ac-name-wrap"], [1, "w10", "pl20", "activeColumn"], ["type", "checkbox", 3, "ngModel", "ngModelChange"], [1, "noImportdevice"], [1, "modalFooter"], ["id", "btn-connector-save", "class", "commonButton", 3, "ngClass", "click", 4, "ngIf"], ["class", "commonButton", 3, "ngClass", "click", 4, "ngIf"], [1, "cancelButton", 3, "click"], ["id", "btn-connector-save", 1, "commonButton", 3, "ngClass", "click"], [1, "modalPopup", "modalPopupSm", "wlcConnectorPopup"], [1, "modalOverlay"], [1, "modalContent_rename"], [1, "modalHeader_edit"], [1, "modalCloseIcon_edit", 3, "click"], [1, "fieldWrapper", "paddingB40"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the connector name", 1, "portalNameInput", 3, "value", "keyup", "input"], [1, "modalPopup"], ["id", "modalContent", 1, "modalOverlay"], ["class", "modalBody", 4, "ngIf"], [1, "fieldValue"], ["class", "fieldWrapper", 4, "ngIf"], ["class", "fieldValue", 4, "ngIf"], ["class", "connector-graph", 4, "ngIf"], [1, "userAccess", 2, "font-size", "14px", 3, "ngClass"], [1, "connector-graph"], ["class", "connector-graph-loading", 4, "ngIf"], [1, "chart"], [1, "lineChartTitle"], [1, "legendRect", "outgoing"], [1, "legendTitle"], [2, "padding-left", "5px"], [1, "legendRect", "incoming"], [1, "connector-graph-loading"], ["height", "50px", "src", "/assets/images/reports/analytics_report_loader.svg"], [1, "fullscreenPopup"], ["id", "fullscreenContent", 1, "fullscreenOverlay"], [1, "fullscreenHeader"], [1, "fullscreenCloseIcon", 3, "click"], ["class", "fullscreenBody", 4, "ngIf"], [1, "fullscreenBody"], [1, "fullscreenBodyLeft"], [1, "fullscreenBodyRight"], [1, "modalPopup", "modalPopupLg", "connectorPopup", "wlcConnectorPopup"], [1, "modalPopup", "modalPopupSm"], [1, "modalContent_delete", "textCenter"], ["src", "/assets/images/warning.svg", "width", "50", 1, "warningIcon"], [1, "warningPopupHeading"], [1, "primaryButton", 3, "click"], ["class", "warningPopupHeading", 4, "ngIf"], ["class", "primaryButton", 3, "click", 4, "ngIf"], [1, "modalContent-connector", "manageStreamsContent"], [1, "modalBody", 2, "overflow-y", "auto", "height", "calc(100% - 165px)"], [1, "manage-connector"], [1, "manage-stream-steps"], [1, "manage-stream-content"], [1, "heading"], [1, "primary-heading"], [1, "operation-status", 3, "ngStyle"], [1, "fieldSwitch"], [1, "secondary-heading"], ["class", "no-support", 4, "ngIf"], ["class", "manage-controller", 4, "ngIf"], [1, "no-support"], [1, "manage-controller"], [1, "controllers"], [1, "table"], [1, "pagination", 2, "display", "none"], ["class", "noData", 4, "ngIf"], [1, "commonButton", 3, "click"], ["class", "tableTr", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "tableTr", 3, "ngClass"], ["class", "userActionsMenu", "style", "display: block !important;", 3, "ngClass", 4, "ngIf"], [1, "userActionsMenu", 2, "display", "block !important", 3, "ngClass"], ["href", "javascript:void(0)", "class", "userEditIcon\tiot-stream\tshowMoreIcon", 3, "click", 4, "ngIf"], ["href", "javascript:void(0)", 1, "userEditIcon", "iot-stream", "showMoreIcon", 3, "click"], ["src", "/assets/images/menu.svg", 1, "menu-open-img"], [1, "noData"], [2, "float", "right", "cursor", "pointer", "font-size", "30px", 3, "click"], ["class", "streamAuth", 4, "ngIf"], ["class", "certificate", 4, "ngIf"], [1, "config-steps"], [1, "step"], [1, "step", "command"], ["ngxClipboard", "", "aria-hidden", "true", 1, "fa", "fa-clipboard", 3, "cbContent", "click"], [1, "streamAuth"], ["ngxClipboard", "", 1, "copyContent", 3, "cbContent", "click"], ["aria-hidden", "true", 1, "fa", "fa-clipboard"], [2, "clear", "right"], [1, "keys"], [1, "certificate"], ["class", "noData", "style", "text-align: center", 4, "ngIf"], [1, "noData", 2, "text-align", "center"], ["href", "javascript:void(0)", "class", "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tuserEditIcon iot-stream showMoreIcon", 3, "click", 4, "ngIf"], [1, "modalPopup", "confirmationPopup"], [1, "modalContent"], [1, "secondary-btn-box", 3, "click"], ["class", "squareButtonPrimary modalPrimaryButton", 3, "click", 4, "ngIf"], ["src", "/assets/images/warning.svg", "width", "50", 1, "warningIcon", "streamWarningIcon"], ["class", "modalHeaders textCenter", 4, "ngIf"], [1, "modalHeaders", "textCenter"], [1, "textCenter"], [1, "conf-subheader"], [1, "radioButtonContainer"], ["name", "profileState", "type", "radio", 1, "pmxRadioButton", 3, "ngModel", "value", "ngModelChange"], ["for", "profileState", 1, "pmxRadioButtonLabel"], ["type", "checkbox", "id", "persist_conf", 3, "checked", "click"], ["for", "persist_conf", 1, "checkboxLabel"], [1, "fieldLabel-disable"], [1, "squareButtonPrimary", "modalPrimaryButton", 3, "click"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the destination SPAN VLAN", 1, "portalNameInput", "ctlrIp", 3, "value", "keyup", "input"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the destination SPAN VLAN IP address", 1, "portalNameInput", "ctlrIp", 3, "value", "keyup", "input"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the source SPAN VLAN list", 1, "portalNameInput", "ctlrIp", 3, "value", "keyup", "input"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the Monitor SPAN origin IP address", 1, "portalNameInput", "ctlrIp", 3, "value", "keyup", "input"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the IOx application SPAN IP address", 1, "portalNameInput", "ctlrIp", 3, "value", "keyup", "input"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the application Cisco Spaces Connector VLAN", 1, "portalNameInput", "ctlrIp", 3, "value", "keyup", "input"], ["type", "checkbox", "id", "useDhcp", 3, "checked", "click"], ["for", "useDhcp", 1, "checkboxLabel"], ["class", "fieldWrapper controllerIPInput", 4, "ngIf"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the IOx application IP address", 1, "portalNameInput", "ctlrIp", 3, "value", "keyup", "input"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the IOx application netmask", 1, "portalNameInput", "ctlrIp", 3, "value", "keyup", "input"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the IOx application gateway address", 1, "portalNameInput", "ctlrIp", 3, "value", "keyup", "input"], [1, "persistlable"], [2, "font-size", "12px"], ["class", "fieldWrapper divTable", 4, "ngIf"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter the spaces connector name", 1, "portalNameInput", 3, "value", "keyup", "input"], [1, "selector-tab", "flex-b"], ["type", "radio", "value", "V3", "name", "value", 1, "pmxRadioButton", "ac-radio", 3, "ngModel", "ngModelChange"], [1, "ac-sel-header", "radio-label"], [2, "margin-left", "10px"], [1, "text-desc", 2, "list-style-type", "disc", "margin-bottom", "4px"], [1, "circularCheckbox-default"], ["type", "checkbox", "name", "defaultServiceSelection", "id", "selectdefaultService", 3, "ngModel", "checked", "ngModelChange", "change"], ["for", "selectdefaultService", 1, "checkboxLabel"], ["src", "/assets/images/info.svg", 2, "cursor", "pointer", "width", "6%", "margin-left", "5px"], [1, "tooltiptext-default-service"], [1, "pmxRadio", 2, "margin-top", "10px"], ["type", "radio", "value", "V2", "name", "value", 1, "pmxRadioButton", "ac-radio", 3, "ngModel", "ngModelChange"], [1, "text-desc"], [1, "fieldWrapper", "divTable"], [1, "modalPopup", "modalPopupLg", "connectorPopup"], ["id", "modalContent", 1, "modalContent-connector"], [1, "modalbodyWrapper"], [1, "clear", 3, "ngClass"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter Switch name", 1, "portalNameInput", 3, "ngModel", "value", "ngModelChange"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter Switch IP", 1, "portalNameInput", 3, "ngModel", "value", "blur", "ngModelChange"], ["type", "text", "autofocus", "autofocus", "placeholder", "Enter Netconfig username", 1, "portalNameInput", 3, "ngModel", "value", "ngModelChange"], [1, "password-wrapper"], ["id", "passwordField", "type", "password", "autofocus", "autofocus", "placeholder", "Enter Netconfig Password", 1, "portalNameInput", 3, "ngModel", "value", "ngModelChange"], ["id", "passwordWrapper", 1, "show-password-wrapper", 3, "click"], ["src", "/assets/images/basic/password_switch.svg", "width", "30"], [3, "innerHTML"], [1, "confirmation-popup-wrapper"], [1, "popup-overlay"], [1, "confirmation-popup"], [1, "exclamation-icon"], ["src", "/assets/images/notification_icon.svg", "width", "70", "alt", "exclamation-icon"], [1, "confirmation-popup-close", 3, "click"], [1, "confirmation-message"], [1, "confirmation-button-wrapper"], [1, "confirmation-primary-button", 3, "click"], [1, "confirmation-cancel", 3, "click"], [1, "modalContent", "textCenter"], [1, "modalPopup", "modalPopup-controller", "connectorPopup", "wlcConnectorPopup"], [1, "modalBody", 2, "overflow-y", "auto", "height", "calc(100% - 165px)", "padding", "0px !important"], [2, "height", "50px", "border-bottom", "1px solid #DEDEDE", "box-shadow", "1px 0px 3px rgb(0 0 0 / 25%)", "padding", "14px 0px 0px 30px"], ["style", "color: #FFA000;font-family: 'CiscoSans';\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 400;", 4, "ngIf"], [1, "scrollServiceList", 2, "width", "100%"], ["style", "padding: 22px 0px 17px 30px;border-bottom: 1px solid #DEDEDE;", 4, "ngFor", "ngForOf"], [2, "color", "#FFA000", "font-family", "CiscoSans", "font-style", "normal", "font-weight", "400"], [2, "padding", "22px 0px 17px 30px", "border-bottom", "1px solid #DEDEDE"], ["class", "inactive", "style", "font-weight: 350;font-family: 'ciscoSans';font-style: normal;", 4, "ngIf"], ["class", "active", "style", "font-weight: 350;font-family: 'ciscoSans';font-style: normal;", 4, "ngIf"], [1, "inactive", 2, "font-weight", "350", "font-family", "ciscoSans", "font-style", "normal"], [1, "active", 2, "font-weight", "350", "font-family", "ciscoSans", "font-style", "normal"], [1, "modalBody", "popupBody", 2, "overflow-y", "auto", "height", "calc(100% - 165px)"], [2, "margin-top", "45.47px", "border-bottom", "1px solid #dee0e1", "height", "40px"], [2, "margin-right", "71px", "font-family", "ciscoSans"], [2, "margin-top", "15px"], [2, "margin-right", "71px", "height", "40px", "font-family", "ciscoSans"], [2, "margin-top", "12px", "overflow-x", "hidden", "word-wrap", "break-word", "padding-right", "186px", "white-space", "pre-line"], [3, "title", "idParam", "url", "accessTokenFlag", "id", "hideAccessToken"], [3, "idParam", "url", "title", "accessTokenFlag", "id", "hideAccessToken"], [3, "showManageConnectorPopup", "selectedConnector", "serviceList", "instancesNodeIds", "title", "serviceNameDisplayName", "refreshConnectorList", "emitClosePopup"]], template: function CmxConnectorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CmxConnectorComponent_div_0_Template, 24, 24, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.cmxConnectorListLoaded);
    } }, directives: [i1$2.NgIf, MigrateConnectorComponent, i1$2.NgForOf, i1$2.NgClass, SearchBasicComponent, PaginationComponent, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, CmxConnectorInstancesComponent, CmxConnectorSwitchesComponent, ConnectorServicesComponent, GenericDropdownComponent, D3MultilineChartComponent, i2$1.RadioControlValueAccessor, i2$1.CheckboxControlValueAccessor, i1$2.NgStyle, i5$1.ClipboardDirective, TokenGenerationV3Component, TokenGenerationComponent, ConnectorTroubleshootComponent], pipes: [i2.TranslatePipe, i1$2.DatePipe, GenericDropdownFilterPipe, SafeHtmlPipe], styles: [".main[_ngcontent-%COMP%]{overflow:hidden!important}.appContainer[_ngcontent-%COMP%]{overflow:hidden!important}.cmxConnectorWrapper[_ngcontent-%COMP%]{margin:0;height:100%;width:100%;font-family:\"ciscoSans\";overflow-y:hidden}.cmxConnectorAdd[_ngcontent-%COMP%]{display:block;margin:0 0 30px;height:100%;background:#E5E5E5;overflow-x:hidden;overflow-y:hidden;position:relative}.cmxConnectorHeading[_ngcontent-%COMP%]{font-family:\"ciscoSans\";font-size:14px;color:#4d4d4d;display:inline-block;width:-webkit-fill-available;height:221px;z-index:110;min-width:100%}.addUuidDiv[_ngcontent-%COMP%]{float:right;clear:right;font-size:16px;font-family:ciscoSansRegular;color:#049fd9;cursor:pointer}.saveUUID[_ngcontent-%COMP%]{width:auto;padding:8px 18px;height:34px;border:1px solid #049fd9;margin-right:20px}.cmxConnectorName[_ngcontent-%COMP%]{max-width:280px;margin-bottom:0;margin-right:20px}.cmxConnectorListWrapper[_ngcontent-%COMP%]{margin:20px 0}.cmxConnectorBox[_ngcontent-%COMP%]{padding:20px 30px;background-color:#fff;border-bottom:1px solid #dddfe2;font-size:16px;font-family:\"ciscoSansLight\";color:#4d4d4d}.cmxConnectorBox[_ngcontent-%COMP%]:hover{background-color:#f6f8f9}.cmxConnectorDeleteBtn[_ngcontent-%COMP%]{float:right;clear:right;margin-top:-8px}.modalPopup.connectorPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease}.modalPopup[_ngcontent-%COMP%] > .modalContent-connector[_ngcontent-%COMP%]{width:60%;right:0;height:100%;z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;animation:slide .5s forwards}@keyframes slide{65%{right:0}}.modalPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0 30px;color:#545454;font-size:24px;height:initial}.modalPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:24px 0}.modalPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{height:initial;align-items:center;padding:0;background-color:#ffffffe6;z-index:9999}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{padding:24px 30px;height:24px;line-height:32px}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon_edit[_ngcontent-%COMP%]{height:24px;line-height:15px;float:right}.modalCloseIcon_edit[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.modalPopup[_ngcontent-%COMP%]   .modalHeader_edit[_ngcontent-%COMP%]{padding:15px 30px;color:#545454;font-size:24px;height:53px;border-bottom:1px solid #e5e5e5}.select-menu[_ngcontent-%COMP%]{height:30px;min-width:100px;padding-left:0;border-bottom:1px solid #ddd;background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_down.svg) no-repeat right center;float:left;margin:0 10px;cursor:pointer}.select-menu[_ngcontent-%COMP%]   .first[_ngcontent-%COMP%]{padding:5px 10px;z-index:2;width:100%}.select-item-container[_ngcontent-%COMP%]{width:100%;border:1px solid #ddd;background:#ffffff;max-height:150px;overflow:auto;position:relative;z-index:999}.select-item[_ngcontent-%COMP%]{padding:10px}.select-item-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:not(.first):hover{background:#09f;color:#fff}.select-item-container[_ngcontent-%COMP%] > .selected[_ngcontent-%COMP%]{display:none}.select-item[_ngcontent-%COMP%]   .first[_ngcontent-%COMP%]{cursor:pointer}.select-custom-2[_ngcontent-%COMP%]{width:60%!important;margin:10px 0!important;font-size:15px;outline:none}.fieldLabel[_ngcontent-%COMP%], .fieldValue[_ngcontent-%COMP%], .fieldWrapper[_ngcontent-%COMP%]{padding:10px 0}.fieldWrapper[_ngcontent-%COMP%]:not(:last-child){border-bottom:1px solid #e5e5e5}.accessToken[_ngcontent-%COMP%]   .fieldWrapper[_ngcontent-%COMP%]{border-bottom:none}.controllerForm[_ngcontent-%COMP%]   .fieldWrapper[_ngcontent-%COMP%]{border-bottom:none}.fieldLabel[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans;width:50%;display:inline-block}.fieldLabel-disable[_ngcontent-%COMP%]{padding:10px 0;font-size:14px;color:#3e3e3e;font-family:ciscoSans;display:inline-block}.fieldValue[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans;width:50%;display:inline-block;font-weight:bold}.modalBody[_ngcontent-%COMP%]   .controllerName[_ngcontent-%COMP%]{font-size:24px;font-weight:bold}.boxWrapper[_ngcontent-%COMP%]{border:1px solid #e5e5e5;padding:10px 20px}.fieldDescriptiveLabel[_ngcontent-%COMP%]{width:80%;display:inline-block;padding:10px 0}.fieldDescriptiveLabel[_ngcontent-%COMP%]   .fieldTitle[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans}.fieldDescriptiveLabel[_ngcontent-%COMP%]   .fieldDescription[_ngcontent-%COMP%]{font-size:12px}.fieldPicker[_ngcontent-%COMP%]{display:inline-block}.fieldPickerTitle[_ngcontent-%COMP%]{font-size:12px;color:#3e3e3e;font-family:ciscoSans;padding:10px 0}.fieldSwitch[_ngcontent-%COMP%]{width:20%;display:inline-block;position:relative;top:-10px;text-align:right}.switch[_ngcontent-%COMP%]{position:relative;display:inline-block;width:60px;height:34px}.switch[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{opacity:0;width:0;height:0}.slider[_ngcontent-%COMP%]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;transition:.4s}.slider[_ngcontent-%COMP%]   ges[_ngcontent-%COMP%]{padding:10px 27px}.slider[_ngcontent-%COMP%]:before{position:absolute;content:\"\";height:26px;width:26px;left:4px;bottom:4px;background-color:#fff;transition:.4s}input[_ngcontent-%COMP%]:checked + .slider[_ngcontent-%COMP%]{background-color:#049fd9}input[_ngcontent-%COMP%]:focus + .slider[_ngcontent-%COMP%]{box-shadow:0 0 1px #049fd9}input[_ngcontent-%COMP%]:checked + .slider[_ngcontent-%COMP%]:before{transform:translate(26px)}.slider.round[_ngcontent-%COMP%]{border-radius:5px}.slider.round[_ngcontent-%COMP%]:before{border-radius:5px}.cmxConnectorForm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .cmxConnectorForm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}.cmxConnectorForm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]{margin:0;border:none;border-bottom:1px solid #e5e5e5;width:300px}.modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   input[type=password][_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .select-menu[_ngcontent-%COMP%]{background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_up.svg) no-repeat right center;font-size:14px}.cmxConnectorForm[_ngcontent-%COMP%]   .menuActive[_ngcontent-%COMP%]{background:url(/assets/cisco/assets/images/desktop/dropdown_arrow_down.svg) no-repeat right center!important}.cmxConnectorForm[_ngcontent-%COMP%]   .select-item-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:hover{background:#dfdfdf;color:#000}.cmxConnectorForm[_ngcontent-%COMP%]   .menuActive[_ngcontent-%COMP%] > .select-item.first[_ngcontent-%COMP%]{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .select-item.first[_ngcontent-%COMP%]:focus{border-bottom:1px solid #079fd9}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;border:none;border-radius:10px}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:hover, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:hover{background-color:#026e97;color:#fff;border:none}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:active, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]:active{background-color:#014f6c;color:#fff;border:none}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%], .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]{background-color:#fff;color:#049fd9;border-radius:10px;border:1px solid #049fd9;margin-right:10px}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:focus, .cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:hover, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:hover{background-color:#026e97;color:#fff;border:none}.cmxConnectorForm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:active, .modalPopup.modalPopupSm[_ngcontent-%COMP%]   .commonButton.hollow[_ngcontent-%COMP%]:active{background-color:#014f6c;color:#fff;border:none}.showPassword[_ngcontent-%COMP%]{padding-left:5px;bottom:1px;font-size:12px;font-weight:bold;font-family:ciscoSans;color:#6674c3;cursor:pointer}.showPasswordAT[_ngcontent-%COMP%]{bottom:30px!important}input[type=password][_ngcontent-%COMP%] > span[_ngcontent-%COMP%] + .showPassword[_ngcontent-%COMP%]{color:#6674c3}.select-item-container[_ngcontent-%COMP%]{margin-bottom:40px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{padding-left:33.8px}.controller-tbl[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:nth-child(2), .controller-tbl[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(2){width:8%;padding-left:33.8px}.controller-tbl[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:nth-child(3), .controller-tbl[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(3){width:8%;padding-left:33.8px}.controller-tbl[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:nth-child(5), .controller-tbl[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(5){width:8%;padding-left:33.8px}.controller-tbl[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:nth-child(6), .controller-tbl[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(6){width:8%;padding-left:33.8px}.table.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:11.66%;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px}.ControllerTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .ControllerTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{padding-left:15px}.table.ControllerTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.ControllerTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .ControllerTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:11.66%;font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:14px;line-height:20px;letter-spacing:.5px}.noScroll[_ngcontent-%COMP%]{overflow-y:hidden!important}.userTable_con[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable_con[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:10%!important;font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:14px;line-height:20px;letter-spacing:.5px}.userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-child{width:20%}.circularCheckbox[_ngcontent-%COMP%]{vertical-align:middle;padding-right:15px;display:inline-block}.userDetailLabel[_ngcontent-%COMP%]{display:inline-block}.userNameLink[_ngcontent-%COMP%]{font-size:12px;color:#09c!important;font-family:\"ciscoSansRegular\";font-weight:bold;cursor:pointer}.userNameLink_basic[_ngcontent-%COMP%]{font-size:12px;font-family:\"ciscoSansRegular\";font-weight:bold}.version[_ngcontent-%COMP%], .ipAddress[_ngcontent-%COMP%]{opacity:.8;font-family:\"ciscoSansRegular\";font-size:11px;color:#333;display:block}.userListEmail[_ngcontent-%COMP%]{opacity:.8;font-family:\"ciscoSansRegular\";font-size:11px;color:#333;display:block}.userAccess[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.columnData[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.statusPending[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;font-weight:600;color:#f86969}.confirmResendLink[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";font-size:12px;font-weight:600;color:#049fd9;text-decoration:underline}.userTable[_ngcontent-%COMP%]   span.userActionsMenu[_ngcontent-%COMP%]{text-align:center;display:none;width:115px;margin-left:15px}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   span.userActionsMenu[_ngcontent-%COMP%]{display:inline}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover{background:#ebf7f9!important}.userTable[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]:hover{background:#fff!important}thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]{border-bottom:1px solid #DEDEDE;box-shadow:0 1px 3px #00000040}.userTable[_ngcontent-%COMP%]   span.userActionsMenu[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative;padding:0 6px;text-decoration:none;outline:none}.userListLabel[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}.userListName[_ngcontent-%COMP%]{display:block;cursor:pointer;color:#049fd9}.userListName_base[_ngcontent-%COMP%]{display:block}.userPendingStatus[_ngcontent-%COMP%]{display:block}.width35[_ngcontent-%COMP%]{min-width:35px;display:inline-block;height:20px}.controllerForm[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:calc(100% - 165px)}.controllerForm[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{height:78px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{min-width:600px}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]{min-width:600px}.modalPopup[_ngcontent-%COMP%]   .modalContent_delete[_ngcontent-%COMP%]{min-width:600px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0;height:30px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:auto;margin-bottom:0}.warningPopupHeading[_ngcontent-%COMP%]{margin-bottom:15px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{padding:0 20px 20px;border-top:none;position:relative;height:auto}.accessTokenValue[_ngcontent-%COMP%]{padding:40px 20px;border:1px solid #c4c4c4;margin:20px 0;word-break:break-all;-webkit-user-select:all;user-select:all}.disabledField[_ngcontent-%COMP%]{background-color:#f2f2f2}.createNewWrapper[_ngcontent-%COMP%]{color:#079fd9;font-family:sans-serif;font-size:14px;cursor:pointer;display:inline-block}.createNewWrapper[_ngcontent-%COMP%]:hover{color:#007199}.paddingR10[_ngcontent-%COMP%]{padding-right:10px}.createNewWrapper.vertical[_ngcontent-%COMP%]{padding-right:20px;margin-right:20px;border-right:1px solid #c4c4c4}span.userAccess.active[_ngcontent-%COMP%]{color:green;cursor:auto}span.userAccess.inactive[_ngcontent-%COMP%]{color:#cd5c5c;cursor:auto}.customerNameDropdown[_ngcontent-%COMP%]{width:180px!important;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.modalPopup.modalPopupSm[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{width:40%;min-width:360px}.modalPopup.modalPopupSm[_ngcontent-%COMP%] > .modalContent_delete[_ngcontent-%COMP%]{width:33%;min-width:360px}.modalPopup.modalPopupSm[_ngcontent-%COMP%] > .modalContent_rename[_ngcontent-%COMP%]{width:25%;min-width:360px}.paddingB40[_ngcontent-%COMP%]{padding-bottom:40px}.controllerIPInput[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:disabled, .disabled[_ngcontent-%COMP%]{opacity:.3;cursor:not-allowed;pointer-events:none}.userActionsMenu[_ngcontent-%COMP%]{position:relative;white-space:nowrap}.showMoreIcon[_ngcontent-%COMP%]{margin-left:-15px}.userEditIcon.configure[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:20px}.userEditIcon[_ngcontent-%COMP%]{color:#07a0d9!important;font-family:\"CiscoSans\";font-size:14px;letter-spacing:.5px;text-align:left}.controllerEditIcon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:14px}.menu-l[_ngcontent-%COMP%]{position:absolute;right:20px;top:35px;border-radius:0;box-shadow:0 0 3px #0000004d}.menu-open-img[_ngcontent-%COMP%]{height:16px}.action-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0;margin:0}select[_ngcontent-%COMP%]{border:none;background:none}.upgrade-icon[_ngcontent-%COMP%]{width:15px;transform:rotate(-90deg);margin-left:10px}.connector-graph[_ngcontent-%COMP%]{margin-top:50px}.connector-graph[_ngcontent-%COMP%]   .connector-graph-loading[_ngcontent-%COMP%]{text-align:center}.chart-legend-count[_ngcontent-%COMP%]{white-space:nowrap}.show-menu-notch[_ngcontent-%COMP%]{position:absolute;right:-1px;background:transparent;top:-10px;width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid #dfdfdf}.show-menu-notch[_ngcontent-%COMP%]   .inner[_ngcontent-%COMP%]{position:relative;right:9px;background:transparent;top:2px;width:0;height:0;border-left:9px solid transparent;border-right:9px solid transparent;border-bottom:9px solid white}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0;height:30px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:auto;margin-bottom:0}.warningPopupHeading[_ngcontent-%COMP%]{margin-bottom:15px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{padding:0 20px 20px;border-top:none;position:relative;height:auto}.manageStreamsContent[_ngcontent-%COMP%]{width:60%!important}.lineChartTitle[_ngcontent-%COMP%]{fill:#111;color:#111;font-size:14px;font-weight:700;font-family:ciscoSans;padding:10px;text-align:center}span.outgoing[_ngcontent-%COMP%]{background-color:#2f7ebb;border:1px solid #4059aa}span.incoming[_ngcontent-%COMP%]{background-color:#be60a6;border:1px solid #be60a6}.legendName[_ngcontent-%COMP%]{font-size:12px;color:#abacac;font-weight:600;font-family:ciscoSansLight}.legendRect[_ngcontent-%COMP%]{display:inline-block;padding:6px;border-radius:3px}.legendTitle[_ngcontent-%COMP%]{font-size:12px;color:#000;font-family:CiscoSans;padding-left:3px;font-weight:300;letter-spacing:.43px}.cli[_ngcontent-%COMP%]{padding-top:15px}.cli[_ngcontent-%COMP%]   .cli-heading[_ngcontent-%COMP%]{font-family:ciscoSansRegular}.cli[_ngcontent-%COMP%]   .messages[_ngcontent-%COMP%]{padding:10px 27px}.cli[_ngcontent-%COMP%]   .cli-commands[_ngcontent-%COMP%]{margin-top:10px;border:1px dashed black;border-radius:15px;padding:20px}.cli[_ngcontent-%COMP%]   .cli-commands[_ngcontent-%COMP%]   .copy-command[_ngcontent-%COMP%]{text-align:right}.cli[_ngcontent-%COMP%]   .cli-commands[_ngcontent-%COMP%]   .copy-command[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-family:FontAwesome!important;cursor:pointer}.cli[_ngcontent-%COMP%]   .cli-commands[_ngcontent-%COMP%]   .commands[_ngcontent-%COMP%]{padding:10px}.success[_ngcontent-%COMP%]{color:green}.error[_ngcontent-%COMP%]{color:#f86969;font-family:CiscoSans;font-size:12px;font-style:normal;font-weight:400;line-height:15px;letter-spacing:.5px}.warning[_ngcontent-%COMP%]{color:#efa741}.spinner[_ngcontent-%COMP%]{width:1.5rem;height:1.5rem;margin:10px;animation:spinner .7s linear infinite;border-style:solid;border-width:2px;border-radius:50%;box-sizing:border-box;display:inline-block;vertical-align:middle;border-color:#049fd9 #049fd9 #049fd9 transparent}@keyframes spinner{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.wlcRadioLabel[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\"}.wlcRadioButton[_ngcontent-%COMP%]{font-size:20px}.wlcRadioButtonLabel[_ngcontent-%COMP%]{top:2px;position:relative;margin:12px}.pingStats[_ngcontent-%COMP%]{padding:5px 0}.pingStats[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-family:FontAwesome!important}.connectivity-messages[_ngcontent-%COMP%]{border:2px dashed #945454;background-color:#d8d8d8;border-radius:10px;padding:15px}.connectivity-messages[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{padding:2px 0}.manage-connector[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]{margin:20px 0}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]{display:flex}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]{width:100%}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]{display:flex}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .primary-heading[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .primary-heading[_ngcontent-%COMP%]{flex:1;font-size:20px;font-weight:bold}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .primary-heading[_ngcontent-%COMP%]   .operation-status[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .primary-heading[_ngcontent-%COMP%]   .operation-status[_ngcontent-%COMP%]{font-size:14px;padding:4px;border-radius:5px;color:#fff}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .fieldSwitch[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .heading[_ngcontent-%COMP%]   .fieldSwitch[_ngcontent-%COMP%]{top:0px}.manage-connector[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .secondary-heading[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .manage-stream-steps[_ngcontent-%COMP%]   .manage-stream-content[_ngcontent-%COMP%]   .secondary-heading[_ngcontent-%COMP%]{padding:10px 0}.manage-connector[_ngcontent-%COMP%]   .controllers[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .controllers[_ngcontent-%COMP%]{margin:20px 0}.manage-connector[_ngcontent-%COMP%]   .no-support[_ngcontent-%COMP%], .manage-controller[_ngcontent-%COMP%]   .no-support[_ngcontent-%COMP%]{color:#ff4500;border-radius:5px;border:1px dotted black;padding:10px}.manage-controller[_ngcontent-%COMP%]   .controllers[_ngcontent-%COMP%]   .noData[_ngcontent-%COMP%]{padding:10px;border:1px solid #eee;text-align:center}.manage-controller[_ngcontent-%COMP%]   .controllers[_ngcontent-%COMP%]   .disable-row[_ngcontent-%COMP%]{pointer-events:none;background-color:#f2f2f2;opacity:.7}.streamAuth[_ngcontent-%COMP%]   .keys[_ngcontent-%COMP%], .certificate[_ngcontent-%COMP%]   .keys[_ngcontent-%COMP%]{border:2px solid #eee;border-radius:5px;padding:20px;height:20vh;overflow-y:scroll;word-break:break-word;white-space:break-spaces}.streamAuth[_ngcontent-%COMP%]   .copyContent[_ngcontent-%COMP%], .certificate[_ngcontent-%COMP%]   .copyContent[_ngcontent-%COMP%]{cursor:pointer;color:#0096d6;float:right}.streamAuth[_ngcontent-%COMP%]   .copyContent[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .certificate[_ngcontent-%COMP%]   .copyContent[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-family:FontAwesome!important}a.iot-stream[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:unset!important}.config-steps[_ngcontent-%COMP%]{padding:20px 0}.config-steps[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{padding:3px 10px}.config-steps[_ngcontent-%COMP%]   .step.command[_ngcontent-%COMP%]{border:1px dashed black;margin:3px 10px;background-color:#d3d3d3;border-radius:3px;font-weight:bold}.config-steps[_ngcontent-%COMP%]   .step.command[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{float:right;cursor:pointer;font-family:FontAwesome!important}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{align-items:center;justify-content:flex-end;background-color:#ffffffe6;z-index:9999}.fullscreenlPopup[_ngcontent-%COMP%]   .fullscreenCloseIcon[_ngcontent-%COMP%]{padding:0 30px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease}.fullscreenPopup.wnPopup[_ngcontent-%COMP%]   .fullscreenContent[_ngcontent-%COMP%]{top:70px;width:440px;overflow:visible;position:relative}.fullscreenPopup.wnPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{height:75vh;overflow-y:auto;margin-top:20px;padding:18px 60px 100px}.fullscreenPopup.wnPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{position:relative;padding:0;border-top:none}@media all and (max-width: 640px){.fullscreenPopup.wnPopup[_ngcontent-%COMP%]   .fullscreenContent[_ngcontent-%COMP%]{width:100%}}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenHeader[_ngcontent-%COMP%]{padding:0 30px;color:#39393b;font-size:24px;height:60px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{align-items:center;justify-content:flex-end;background-color:#ffffffe6;z-index:9999}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenCloseIcon[_ngcontent-%COMP%]{padding:0 30px}.fullscreenPopup.importSsidPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease}.fullscreenPopup[_ngcontent-%COMP%] > .fullscreenContent-ssid[_ngcontent-%COMP%]{width:65%;right:5px;height:78.2%;z-index:1001;position:absolute;top:105px;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #abc233;animation:slide .5s forwards}.fullscreenHeader[_ngcontent-%COMP%]{background-color:#fff!important}.fullscreenPopup[_ngcontent-%COMP%]{background:rgba(0,0,0,.8)!important}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{background-color:#fff;padding:18px 30px}.fullscreenPopup[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;top:0;left:0;z-index:99999;overflow:auto}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenOverlay[_ngcontent-%COMP%]{position:absolute;top:5%;left:5%;width:90%;height:85vh;background:rgba(0,0,0,.7);z-index:1000}.fullscreenPopup[_ngcontent-%COMP%] > .fullscreenContent[_ngcontent-%COMP%]{z-index:1001;position:absolute;left:50%;top:150px;transform:translate(-50%);width:60%;background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden;margin-bottom:50px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenHeader[_ngcontent-%COMP%]{padding:18px 30px;color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:relative;height:60px;border-bottom:1px solid #eaeaea}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]{background-color:#fff;padding:18px 30px;margin-bottom:40px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]   .fullscreenBodyLeft[_ngcontent-%COMP%]{width:49%;float:left}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenBody[_ngcontent-%COMP%]   .fullscreenBodyRight[_ngcontent-%COMP%]{width:49%;float:right}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:relative;position:absolute;bottom:0;left:0;width:100%;border-top:1px solid #eaeaea;background-color:#fff;text-align:left}.fullscreenFooter[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:24px 0 24px 24px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenCloseIcon[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenPrimaryButton[_ngcontent-%COMP%]{margin-right:20px}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenSecondaryButton[_ngcontent-%COMP%]{border:0;font-family:\"ciscoSans\";background-color:transparent;font-size:14px;color:#0096d6;outline:none}.fullscreenPopup[_ngcontent-%COMP%]   .fullscreenSecondaryButton[_ngcontent-%COMP%]:hover{color:#007199}.fullscreenPopup[_ngcontent-%COMP%]   .squareButtonPrimary[_ngcontent-%COMP%]{padding:10px 18px}.fullscreenPopup.fullscreenPopupSm[_ngcontent-%COMP%] > .fullscreenContent[_ngcontent-%COMP%]{width:30%;min-width:360px}.fullscreenPopup.fullscreenPopupMd[_ngcontent-%COMP%] > .fullscreenContent[_ngcontent-%COMP%]{width:50%;min-width:360px}.fullscreenPopup.fullscreenPopupLg[_ngcontent-%COMP%] > .fullscreenContent[_ngcontent-%COMP%]{width:90%;min-width:360px;top:70px}.fullscreenPopup.warningPopup[_ngcontent-%COMP%]   .fullscreenContent[_ngcontent-%COMP%]{overflow:visible}.fullscreenPopup.warningPopup[_ngcontent-%COMP%]   .fullscreenHeader[_ngcontent-%COMP%]{position:relative;padding-top:66px;border-bottom:none}.fullscreenPopup.warningPopup[_ngcontent-%COMP%]   .fullscreenHeader[_ngcontent-%COMP%]:before{position:absolute;width:80px;height:80px;content:\"\";background:transparent url(/assets/images/notification_icon.svg) no-repeat center;background-size:80px;box-shadow:0 0 3px #0003;border:5px solid #fff;border-radius:50%;left:50%;transform:translate(-50%);top:-40px}.fullscreenPopup.warningPopup[_ngcontent-%COMP%]   .fullscreenFooter[_ngcontent-%COMP%]{padding:40px;border-top:none}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{z-index:1001;position:absolute;left:50%;top:30%;transform:translate(-50%);background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .warningIcon[_ngcontent-%COMP%]{margin-top:5%}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .streamWarningIcon[_ngcontent-%COMP%]{margin-left:45%!important}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .modalHeaders[_ngcontent-%COMP%]{padding:25px 0 5px;color:#000;font-size:20px;font-family:ciscoSansRegular;position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-top:5px;margin-bottom:25px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .circularCheckbox[_ngcontent-%COMP%]{position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:checked:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]{display:flex;justify-content:center}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]   .pmxRadioButtonLabel[_ngcontent-%COMP%]{margin-left:5px!important;font-size:14px}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{display:flex;justify-content:center;position:relative!important;border-top:none!important}.modalPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]   .secondary-btn-box[_ngcontent-%COMP%]{display:flex;justify-content:center;border:none!important;background:#fff;color:#07a0d9}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]{z-index:1001;position:absolute;left:50%;top:30%;transform:translate(-50%);background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .warningIcon[_ngcontent-%COMP%]{margin-top:5%}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .streamWarningIcon[_ngcontent-%COMP%]{margin-left:45%!important}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .modalHeaders[_ngcontent-%COMP%]{padding:25px 0 5px;color:#000;font-size:20px;font-family:ciscoSansRegular;position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-top:5px;margin-bottom:25px}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .circularCheckbox[_ngcontent-%COMP%]{position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:checked:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]{display:flex;justify-content:center}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]   .pmxRadioButtonLabel[_ngcontent-%COMP%]{margin-left:5px!important;font-size:14px}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{display:flex;justify-content:center;position:relative!important;border-top:none!important}.modalPopup[_ngcontent-%COMP%]   .modalContent_rename[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]   .secondary-btn-box[_ngcontent-%COMP%]{display:flex;justify-content:center;border:none!important;background:#fff;color:#07a0d9}.modalPopup[_ngcontent-%COMP%]   .modalContent_delete[_ngcontent-%COMP%]{z-index:1001;position:absolute;left:50%;top:30%;transform:translate(-50%);background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden}.modalPopup[_ngcontent-%COMP%]   .modalContent_delete[_ngcontent-%COMP%]   .warningIcon[_ngcontent-%COMP%]{margin-top:5%}.modalPopup[_ngcontent-%COMP%]   .modalContent_delete[_ngcontent-%COMP%]   .streamWarningIcon[_ngcontent-%COMP%]{margin-left:45%!important}.modalPopup[_ngcontent-%COMP%]   .modalContent_delete[_ngcontent-%COMP%]   .modalHeaders[_ngcontent-%COMP%]{padding:25px 0 5px;color:#000;font-size:20px;font-family:ciscoSansRegular;position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent_delete[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-top:5px;margin-bottom:25px}.modalPopup[_ngcontent-%COMP%]   .modalContent_delete[_ngcontent-%COMP%]   .circularCheckbox[_ngcontent-%COMP%]{position:relative}.modalPopup[_ngcontent-%COMP%]   .modalContent_delete[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:checked:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent_delete[_ngcontent-%COMP%]   .pmxRadioButton[_ngcontent-%COMP%]:after{left:3px;top:1px}.modalPopup[_ngcontent-%COMP%]   .modalContent_delete[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]{display:flex;justify-content:center}.modalPopup[_ngcontent-%COMP%]   .modalContent_delete[_ngcontent-%COMP%]   .radioButtonContainer[_ngcontent-%COMP%]   .pmxRadioButtonLabel[_ngcontent-%COMP%]{margin-left:5px!important;font-size:14px}.modalPopup[_ngcontent-%COMP%]   .modalContent_delete[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{display:flex;justify-content:center;position:relative!important;border-top:none!important}.modalPopup[_ngcontent-%COMP%]   .modalContent_delete[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]   .secondary-btn-box[_ngcontent-%COMP%]{display:flex;justify-content:center;border:none!important;background:#fff;color:#07a0d9}.warningPopupHeading[_ngcontent-%COMP%]{margin:25px 0 0!important}.modalPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{margin-bottom:0!important}.paddingTop20[_ngcontent-%COMP%]{padding-top:20px}.divTableWrapper[_ngcontent-%COMP%]{padding:20px;border:1px solid #d8d8d8}.divTableWrapper[_ngcontent-%COMP%]   .fieldLabel[_ngcontent-%COMP%]{width:100%}.onoffswitch[_ngcontent-%COMP%]{display:block;position:relative;width:80px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;margin-bottom:30px;transform:scale(.8);-webkit-transform:scale(.8)}.onoffswitch-checkbox[_ngcontent-%COMP%]{display:none}.onoffswitch-label[_ngcontent-%COMP%]{display:block;overflow:hidden;cursor:pointer;border-radius:0}.onoffswitch[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.cmn-toggle[_ngcontent-%COMP%]{position:absolute;margin-left:-9999px;visibility:hidden}input.cmn-toggle-round[_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]:before{background-color:#03b88c}input.cmn-toggle-round[_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]:after{margin-left:28px}input.cmn-toggle-round[_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{font-size:14px;padding:2px;width:54px;height:27px;border-radius:60px}input.cmn-toggle-round[_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:after{width:26px;background-color:#fff;border-radius:100%;box-shadow:0 2px 5px #00000080;transition:margin .4s}input.cmn-toggle-round[_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:before, input.cmn-toggle-round[_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:after{display:block;position:absolute;top:1px;left:1px;bottom:1px;content:\"\"}input.cmn-toggle-round[_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:before{right:1px;height:16px;top:6px;background-color:#f75a5a;border-radius:60px;transition:background .4s}.cmn-toggle[_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{display:block;position:relative;cursor:pointer;outline:none;-webkit-user-select:none;user-select:none}.width60[_ngcontent-%COMP%]{width:60px}.connector-path-start[_ngcontent-%COMP%]{display:inline;margin-left:15px}.connector-path[_ngcontent-%COMP%]{font-size:12px;display:inline;margin-left:5px;color:#09c;cursor:pointer}.connector-path1[_ngcontent-%COMP%]{font-size:12px;display:inline;margin-left:5px;cursor:pointer}.connectorHeader[_ngcontent-%COMP%]{display:inline-block;width:100%;background:#ffffff;padding:10px 60.5px 10px 50px}.headerinfo[_ngcontent-%COMP%]{display:inline;float:right;font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:12px;line-height:18px;letter-spacing:.5px;color:#545454}.summary[_ngcontent-%COMP%]{width:100%;height:135px;background:#ffff;padding:18px 27px 25px 52px;font-size:20px;box-shadow:0 0 1px #bdbdbd}.imageStyle[_ngcontent-%COMP%]{width:75px}.summarySection[_ngcontent-%COMP%]{display:inline;margin-bottom:25px;width:77px;height:20px;left:176px;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:18px;line-height:20px;letter-spacing:1px;text-transform:uppercase;color:#545454;padding-left:28px}.rightSummary[_ngcontent-%COMP%]{height:100px;display:inline-block;width:100%}.floatleft[_ngcontent-%COMP%]{display:inline-block;float:left;width:102px;font-size:14px;margin-top:5px}.floatleft-up[_ngcontent-%COMP%]{width:38px!important}.floatleft-service[_ngcontent-%COMP%]{display:inline-block;float:left;width:15%;font-size:14px;margin-top:30px}.floatleft-detail[_ngcontent-%COMP%]{display:inline-block;float:left;width:102px;font-size:14px;margin-top:14px}.service-enabled[_ngcontent-%COMP%]{width:9%!important}.parameter-text[_ngcontent-%COMP%]{display:inherit;height:20px;left:0px;top:33px;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px}.service-summmary[_ngcontent-%COMP%]{width:170px!important}.num-summary[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:24px;line-height:30px;letter-spacing:.5px}.border[_ngcontent-%COMP%]{border-right:1px solid #dee0e1}.grayDiv[_ngcontent-%COMP%]{background:#E5E5E5;padding-top:40px}.grayDiv-service[_ngcontent-%COMP%]{background:#E5E5E5;display:inline-block;width:100%;padding-top:40px}.grayDiv-switch[_ngcontent-%COMP%]{background:#E5E5E5;display:inline-block;width:100%}.grayDiv-service-upgrade[_ngcontent-%COMP%]{background:#E5E5E5;display:inline-block;width:100%;padding-top:45px}.grayDiv-controller[_ngcontent-%COMP%]{background:#E5E5E5;display:inline-block;width:100%}.subHeader[_ngcontent-%COMP%]{padding:0 0 10px 62.5px;font-size:20px;margin-right:100px;display:inline-block;width:100%;left:61.5px;top:298.44px;font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:18px;line-height:26px;letter-spacing:.5px}.subHeader_controller[_ngcontent-%COMP%]{font-size:20px;display:inline-block;padding:38px 0 10px 62.5px;width:100%}.connector-table[_ngcontent-%COMP%]{background:#FFFFFF;height:350px;overflow-y:auto;margin:0 60.5px 62.5px 62.5px}.connector-table-V2[_ngcontent-%COMP%]{background:#FFFFFF;height:auto;margin:0 60.5px 0 62.5px}.controller-tbl[_ngcontent-%COMP%]{overflow-y:auto}.connector-table_controller[_ngcontent-%COMP%]{background:#FFFFFF;height:auto;margin:0 60px 10px}.fullscreenBody[_ngcontent-%COMP%]{background:#FFFFFF}.headerSection[_ngcontent-%COMP%]{font-size:18px!important;font-family:\"ciscoSansRegular\";color:#4d4d4d;display:inline}.createConnector[_ngcontent-%COMP%]{font-size:14px;float:right;font-family:\"ciscoSansRegular\";color:#07a0d9;cursor:pointer;display:inline-block;padding-right:62.5px}.showHideColumns[_ngcontent-%COMP%]{font-size:14px!important;float:right;font-family:\"ciscoSansRegular\";color:#07a0d9}.header-inner[_ngcontent-%COMP%]{display:inline-block;font-size:16px;padding-left:62.5px}.header[_ngcontent-%COMP%]{display:inline-block;font-size:18px;width:100%;border-bottom:1px solid #E5E5E5;border-top:1px solid #E5E5E5;background:#FFFF;height:50px}#link-locdetails-aps[_ngcontent-%COMP%]{display:inline;margin-right:25px;color:#565659}#link-locdetails-metrics[_ngcontent-%COMP%]{display:inline;margin-right:25px}.tokenDiv[_ngcontent-%COMP%]{display:inline;float:right;padding:15px 0;color:#07a0d9;font-size:14px;margin-right:60.5px}.cursorP[_ngcontent-%COMP%]{cursor:pointer;padding:8px 8px 8px 18px}.active-name[_ngcontent-%COMP%]{cursor:pointer}.active-block[_ngcontent-%COMP%]   .active-name[_ngcontent-%COMP%]{vertical-align:middle}.active-block[_ngcontent-%COMP%]{border-bottom:2px solid #059fd9;animation:border-animation .1s ease-in-out}.confirmation-popup-wrapper[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:99999;left:0;top:0}.popup-overlay[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:999999;background-color:#0009}.confirmation-popup[_ngcontent-%COMP%]{position:absolute;top:33%;left:50%;transform:translate(-50%);width:40%;height:30%;margin:0 auto;background-color:#fff;box-shadow:0 4px 8px #0000001a;border:0;z-index:1001;display:flex;justify-content:center;flex-direction:column;border-radius:5px;align-items:center}.confirmation-button[_ngcontent-%COMP%]{display:inline-block!important}.confirmation-button-wrapper[_ngcontent-%COMP%]{margin:0 auto;width:40%;text-align:center}.confirmation-primary-button[_ngcontent-%COMP%]{border-radius:1.3em;background-color:#09c;color:#fff;font-family:ciscoSansLight;padding:0 18px;font-size:14px;height:34px;line-height:34px;cursor:pointer;float:left;display:inline;margin-right:20px}.confirmation-primary-button[_ngcontent-%COMP%]:hover{opacity:.8}.confirmation-cancel[_ngcontent-%COMP%]{color:#848484!important;font-size:14px;text-decoration:none;cursor:pointer;line-height:30px;font-family:\"ciscoSansRegular\";display:inline!important}.confirmation-cancel[_ngcontent-%COMP%]:hover{font-weight:bold}.confirmation-popup-close[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.confirmation-popup-close[_ngcontent-%COMP%]:hover{opacity:.8}.exclamation-icon[_ngcontent-%COMP%]{min-height:70px;min-width:70px;text-align:center;padding:0;position:absolute;left:50%;transform:translate(-50%);top:-20%;border:5px solid #fff;border-radius:50%;background:#fff;box-shadow:0 0 2px #84848480}.confirmation-message[_ngcontent-%COMP%]{text-align:center;padding:25px 0;font-size:15px;display:block;width:82%;margin:0 auto;color:#848484;font-family:\"ciscoSansRegular\"}.info-icon[_ngcontent-%COMP%]{width:20px;height:20px;display:inline-block;cursor:pointer;text-align:center}.btn-connector-create[_ngcontent-%COMP%]{font-size:14px}.emptyStateHeading[_ngcontent-%COMP%]{padding:45px!important;font-size:14px;font-family:\"ciscoSansRegular\";background:#FFFF;height:435px;display:inline-block;width:100%}.emptyStateHeading-metric[_ngcontent-%COMP%]{padding:85px!important;font-size:14px;font-family:\"ciscoSans\";background:#FFFF;height:500px;width:100%;margin-top:40px}.leftMargin[_ngcontent-%COMP%]{margin-left:25px}.empty_text[_ngcontent-%COMP%]{display:inline;font-size:14px;color:#4d4d4d;font-family:\"ciscoSans\"}.connector-pat-start[_ngcontent-%COMP%]{color:#09c;cursor:pointer}.setup[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:12px;line-height:18px;letter-spacing:.5px;color:#00a0d1}.breadcrumbSeparator[_ngcontent-%COMP%]{color:#545454;font-family:icomoon-new;font-size:16px;vertical-align:unset;padding:0 5px;font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:14px;line-height:18px}.am-appselector-wrapper[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0}.am-appselector-wrapper[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border:1px solid #eae9e9;padding:1px 2px!important}.am-appselector-wrapper[_ngcontent-%COMP%]   .am-appselector[_ngcontent-%COMP%]{display:flex;align-items:center}.am-appselector-wrapper[_ngcontent-%COMP%]   .check-sel[_ngcontent-%COMP%]{width:80%}.am-appselector-wrapper[_ngcontent-%COMP%]   .am-appselector-dropdown[_ngcontent-%COMP%]{width:20%}.am-appselector-wrapper[_ngcontent-%COMP%]   .check-label[_ngcontent-%COMP%]{font-weight:bold!important;color:#656565!important;font-size:15px;padding-left:5px}.services[_ngcontent-%COMP%]{font-size:16px;font-family:\"ciscoSansRegular\";padding:10px}.d3-chart[_ngcontent-%COMP%]{height:350px;float:left;width:33%!important}.scatter-chart[_ngcontent-%COMP%]   .d3-chart[_ngcontent-%COMP%]{height:380px}.d3-chart[_ngcontent-%COMP%]   g.tick[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{stroke:transparent}.d3-chart[_ngcontent-%COMP%]   .y-axis[_ngcontent-%COMP%]   .domain[_ngcontent-%COMP%], .x-axis[_ngcontent-%COMP%]   .domain[_ngcontent-%COMP%], .grid[_ngcontent-%COMP%]   .domain[_ngcontent-%COMP%]{display:none}.d3-chart[_ngcontent-%COMP%]   .x-axis-tick[_ngcontent-%COMP%]   .domain[_ngcontent-%COMP%], .x-axis-tick[_ngcontent-%COMP%]   .tick[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{display:none}.d3-chart[_ngcontent-%COMP%]   .grid[_ngcontent-%COMP%]   .tick[_ngcontent-%COMP%]   line[_ngcontent-%COMP%], .x-axis[_ngcontent-%COMP%]   .domain[_ngcontent-%COMP%], .y-axis[_ngcontent-%COMP%]   .tick[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{stroke:#f9f0f0}.d3-chart[_ngcontent-%COMP%]   .y-axis[_ngcontent-%COMP%]   .tick[_ngcontent-%COMP%]   text[_ngcontent-%COMP%], .axis-labels[_ngcontent-%COMP%]{font-family:\"ciscoSansBold\";font-size:10px;fill:#1d3243}.valuesOnTop[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";font-size:11px}.valuesOnTop.historical[_ngcontent-%COMP%]{fill:#dfa73e}.d3-chart[_ngcontent-%COMP%]   text.groupTitle[_ngcontent-%COMP%]{color:#1d3243;font-family:CiscoSansBold;font-size:10px}.d3-chart[_ngcontent-%COMP%]   text.yAxis-label[_ngcontent-%COMP%], text.xAxis-label[_ngcontent-%COMP%]{font-family:ciscoSansBold;font-size:10px;font-weight:700;line-height:1.5;text-align:center;color:#1d3243;text-transform:uppercase}.bi-tooltip[_ngcontent-%COMP%]{white-space:nowrap;color:#fff;display:table;background-color:#1d3243;border-radius:3px;padding:3px;z-index:10000}.bi-tooltip[_ngcontent-%COMP%]:before{left:46%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none;border-color:#fff0;border-top-color:#1d3243;border-width:9px;top:100%}.top-section[_ngcontent-%COMP%], .top-section-labelList[_ngcontent-%COMP%]{font-family:CiscoSansBold;font-size:17px;background-color:#263b4c;text-align:left;display:flex;justify-content:space-between}.top-section-labelList[_ngcontent-%COMP%]{justify-content:left!important;align-items:center;padding:10px 15px 0}.top-section[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:table-cell;padding:5px 10px;vertical-align:middle}.top-section[_ngcontent-%COMP%]   .ranking-list[_ngcontent-%COMP%]{display:block;width:100%}.top-section.align-center[_ngcontent-%COMP%]{justify-content:center;padding-top:7px;padding-bottom:5px}.left-label[_ngcontent-%COMP%]{padding:0 0 5px;font-size:13px}.meta-data-section[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:10px;text-transform:uppercase}.top-right[_ngcontent-%COMP%]{text-align:right!important;font-size:14px}.top-right-value[_ngcontent-%COMP%]{text-align:right!important;font-size:15px;padding-left:80px}.top-section[_ngcontent-%COMP%] > span.loc-name[_ngcontent-%COMP%]{text-align:center;display:block}.suffix[_ngcontent-%COMP%]{font-size:12px;font-family:CiscoSans}.d3-chart[_ngcontent-%COMP%]   text.bar-label[_ngcontent-%COMP%]{color:#1d3243;font-family:CiscoSansBold;font-size:10px}.d3-chart[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke-width:2;fill:none}.d3-chart[_ngcontent-%COMP%]   .axis[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .d3-chart[_ngcontent-%COMP%]   .axis[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{fill:none;stroke:#f5f5f500;stroke-width:1;shape-rendering:crispEdges}.negative-bar-chart[_ngcontent-%COMP%]   g.y.axis[_ngcontent-%COMP%]   .tick[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{stroke:#f5f5f5}g.text-group[_ngcontent-%COMP%]   text.bar-value[_ngcontent-%COMP%]{color:#485967;font-family:CiscoSans;font-size:10px;line-height:16px;text-align:center}.d3-chart[_ngcontent-%COMP%]   g.tick[_ngcontent-%COMP%]   text[_ngcontent-%COMP%]{fill:#1d3243;font-family:CiscoSansBold;font-size:9px}.d3-chart[_ngcontent-%COMP%]   .bar-line-xaxis-group[_ngcontent-%COMP%]   g.tick[_ngcontent-%COMP%]   text[_ngcontent-%COMP%]{fill:#565659;font-size:10px;font-family:CiscoSansRegular}.d3-chart[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{position:absolute}.d3-chart[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{cursor:pointer}circle[_ngcontent-%COMP%]{cursor:pointer}.scatter-chart[_ngcontent-%COMP%]   .dot[_ngcontent-%COMP%]{cursor:auto!important}.normalized-dot[_ngcontent-%COMP%]{background-color:#000!important}.normalized-text[_ngcontent-%COMP%]{color:#000!important}.chart-container[_ngcontent-%COMP%]{padding:20px 10px}.chart-container.m10[_ngcontent-%COMP%]{margin-bottom:10px}.d3-chart[_ngcontent-%COMP%]   g.x-axis-label[_ngcontent-%COMP%] > text[_ngcontent-%COMP%]{color:#1d3243;font-family:CiscoSansBold;font-size:10px;fill:#1d3243;text-transform:uppercase}.top-right[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:12px}.axis-value[_ngcontent-%COMP%]{font-size:9px;font-family:CiscoSansBold}.userSelectEnabled[_ngcontent-%COMP%]{-webkit-user-select:text;user-select:text}.historical-text[_ngcontent-%COMP%]{font-size:9px;color:#9e9ea2;font-family:CiscoSans}.label-list[_ngcontent-%COMP%]{width:100%}.label-list[_ngcontent-%COMP%], .label-list-count[_ngcontent-%COMP%]{font-size:13px}.label-list-count[_ngcontent-%COMP%]{padding-left:15px}.label-list[_ngcontent-%COMP%]   .label-name[_ngcontent-%COMP%]{padding-bottom:5px}.label-list-count[_ngcontent-%COMP%]   span.count[_ngcontent-%COMP%]{display:block;padding-bottom:5px}.location-info-block[_ngcontent-%COMP%]{border-bottom:1px solid #335167}.stacked-bar-metadata[_ngcontent-%COMP%]{padding:5px 10px}.location-info-block[_ngcontent-%COMP%]   .top-right-value[_ngcontent-%COMP%]{font-size:13px}.stacked-bar-metadata[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{display:inline-block;padding-right:4px}.legend-list[_ngcontent-%COMP%]{padding-right:12px!important}.legend-indicator[_ngcontent-%COMP%]{width:10px;height:10px;margin-bottom:13px;margin-top:3px}.event-from[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .event-to[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{width:100%}.event-from[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .event-to[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:80%;border-color:#a7a9ab}.event-from[_ngcontent-%COMP%], .event-to[_ngcontent-%COMP%]{width:48%;display:inline-block;vertical-align:middle}span.from-date[_ngcontent-%COMP%], .event-to[_ngcontent-%COMP%]   span.to-date[_ngcontent-%COMP%]{display:block;color:#565659;font-size:12px}.event-from[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%], .event-to[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%]{display:block}.event-to[_ngcontent-%COMP%]{float:right}.event-from[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   .ui-calendar-button[_ngcontent-%COMP%], .event-to[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   .ui-calendar-button[_ngcontent-%COMP%]{right:0;background-color:transparent;border:0 none;background-image:url(../assets/images/impact-analysis/calendar-blue.svg);background-repeat:no-repeat;background-position:center;width:3em}.event-from[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   .ui-calendar-button[_ngcontent-%COMP%]:hover, .event-to[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   .ui-calendar-button[_ngcontent-%COMP%]:hover, .event-from[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   .ui-widget.ui-button[_ngcontent-%COMP%]:enabled:hover, .event-from[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   .ui-button[_ngcontent-%COMP%]:enabled:hover, .event-to[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   .ui-widget.ui-button[_ngcontent-%COMP%]:enabled:hover, .event-to[_ngcontent-%COMP%]   p-calendar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   .ui-button[_ngcontent-%COMP%]:enabled:hover{background-color:transparent;border:0 none!important;background-image:url(../assets/images/impact-analysis/calendar-blue.svg);background-repeat:no-repeat;background-position:center;width:3em}.event-from[_ngcontent-%COMP%]   p-calendar.is-invalidDate[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .event-to[_ngcontent-%COMP%]   p-calendar.is-invalidDate[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:80%!important;border-bottom:1px solid #EE0000!important}.impact-chart-container[_ngcontent-%COMP%]   path.domain[_ngcontent-%COMP%]{stroke:none}.bar-count[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:15px;font-weight:bold;line-height:20px}.multiLine-tooltip[_ngcontent-%COMP%], .horizontalBar-tooltip[_ngcontent-%COMP%], .groupChart-tooltip[_ngcontent-%COMP%], .columnChart-top[_ngcontent-%COMP%]{font-size:12px;font-family:CiscoSansBold;background-color:#263b4c;padding:10px}.multiLine-top[_ngcontent-%COMP%], .groupChart-top[_ngcontent-%COMP%], .columnChart-top[_ngcontent-%COMP%]{text-align:center;padding:0 5px}.daily-info[_ngcontent-%COMP%]{width:100%;display:table;padding-top:15px}.multiLine-left[_ngcontent-%COMP%], .multiLine-right[_ngcontent-%COMP%], .horizontalBar-left[_ngcontent-%COMP%], .horizontalBar-right[_ngcontent-%COMP%], .groupChart-left[_ngcontent-%COMP%], .groupChart-right[_ngcontent-%COMP%]{display:table-cell}.multiLine-right[_ngcontent-%COMP%], .horizontalBar-right[_ngcontent-%COMP%], .groupChart-right[_ngcontent-%COMP%]{text-align:right}.multiLine-left[_ngcontent-%COMP%], .horizontalBar-left[_ngcontent-%COMP%], .groupChart-left[_ngcontent-%COMP%]{padding-right:30px}@-moz-document url-prefix(){.pmxRadio input.pmxRadioButton{width:initial!important}}.update-note[_ngcontent-%COMP%]{border:1px solid #FFA000;border-radius:4px;padding:15px;font-size:14px;font-family:CiscoSans;line-height:144.6%;background:#FFFF;color:#202020;display:inline-block;width:94%;margin:85px 122px 0 65px}.updateLink[_ngcontent-%COMP%]{color:#09c;font-size:12px;font-weight:200}.line-sep[_ngcontent-%COMP%]{margin:5px;color:gray}.clickpointer[_ngcontent-%COMP%]{cursor:pointer}.d3-chart[_ngcontent-%COMP%]{height:350px;float:left;width:33%!important}.metric-chart[_ngcontent-%COMP%]{position:relative;float:left;display:inline;margin:38px;width:466px;background:#FFFF}.metricDiv[_ngcontent-%COMP%]{min-height:1000px;position:absolute;padding:25px 60.5px 250px 62.5px}.pagination[_ngcontent-%COMP%]{margin:25px 100px 8px 55px!important;display:\"none\"}.statusAsset[_ngcontent-%COMP%]{margin-right:5px;width:15px}.summary-icon[_ngcontent-%COMP%]{width:95px;display:inline;float:left}.numConnector[_ngcontent-%COMP%]{margin-left:-64px}.numConnector-v2[_ngcontent-%COMP%]{margin-left:-64px}.numConnector1[_ngcontent-%COMP%]{margin-left:125px}.Connector-seperator[_ngcontent-%COMP%]{display:inline;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:16px;line-height:19px;letter-spacing:.0417px;color:#049fd9}.list[_ngcontent-%COMP%]{height:auto}.listContainer[_ngcontent-%COMP%]{height:875px}.image-img[_ngcontent-%COMP%]{padding-left:308px;float:right;display:inline}.modalBody-connector[_ngcontent-%COMP%]{position:relative;overflow-y:auto;overflow-x:hidden;background:#E5E5E5;padding-bottom:300px;margin-bottom:66.5px;color:#545454;height:100%}.metric-param[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:18px;color:#121212;padding:10px 0 10px 26px}.appsPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{height:20px}.appsPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.modalContentInstance[_ngcontent-%COMP%]{width:14%;left:92%;z-index:1;position:absolute;background:#fff;padding:10px;box-shadow:0 0 20px #0000004d;transform:translate(-50%);-webkit-box-shadow:0 0 20px rgba(0,0,0,.3);-webkit-transform:translateX(-50%);height:auto}.metricHeader[_ngcontent-%COMP%]{display:inline;position:absolute;height:6%;width:94%;background:#E5E5E5}.metricSerHeader[_ngcontent-%COMP%]{display:inline;position:absolute;margin-left:70px}.metricInterval[_ngcontent-%COMP%]{display:inline;position:absolute;margin-left:300px}.metricInstanceoption[_ngcontent-%COMP%]{display:inline;float:right;color:#09c;font-size:14px;font-family:\"ciscoSansRegular\";padding-top:20px}.readWriteField[_ngcontent-%COMP%]{display:inline;position:absolute;margin-top:17px;color:#09c;font-size:14px;font-family:\"ciscoSansRegular\"}.appsPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:12px;cursor:pointer}.emptyStateHeading-1[_ngcontent-%COMP%]{padding:60px 0 39px!important;font-size:14px;font-family:\"ciscoSansRegular\";background:#FFFF;height:350px}.legendDetails[_ngcontent-%COMP%]   .legendInfo[_ngcontent-%COMP%]{width:100%;margin:10px;padding-top:10px;text-align:center}.legendInfo[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{margin-bottom:10px;padding-top:15px}.widgetInfo[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{margin-bottom:10px}.infoLabel[_ngcontent-%COMP%]{font-family:\"ciscosansBold\"}.infoSublabel[_ngcontent-%COMP%]{color:#737376;width:90%;font-size:10px}.subheadDes[_ngcontent-%COMP%]{margin:0;font-size:11px}.widgetInfo[_ngcontent-%COMP%]{border-top:1px solid rgba(0,0,0,.08);color:#565659;font-family:CiscoSans;font-size:12px;line-height:20px;padding-left:45px}.legendContainer[_ngcontent-%COMP%]{display:inline-block;margin-right:40px}.legendColor[_ngcontent-%COMP%]{display:inline-block;width:10px;height:10px;border-radius:radius-4;padding-left:5px}.legendName[_ngcontent-%COMP%]{margin-left:8px;font-family:ciscoSans;font-size:11px}.legendContainer[_ngcontent-%COMP%]   .universalVisits[_ngcontent-%COMP%]{background-color:#000}.instance-dv[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-top:85px}.update-img[_ngcontent-%COMP%]{display:inline}.upgrade-msg[_ngcontent-%COMP%]{display:inline;padding-left:2px;font-size:16px}.commonButton_hollow[_ngcontent-%COMP%]{text-align:center;cursor:pointer;display:inline-table;vertical-align:middle;font-size:16px;font-weight:bold;padding:6px 10px;color:#0096d6;outline:none;background-color:transparent;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px}.border_r[_ngcontent-%COMP%]{border-right:1px solid #dee0e1}.border_l[_ngcontent-%COMP%]{border-left:1px solid #dee0e1}.img-icon[_ngcontent-%COMP%]{width:14px}.tooltip[_ngcontent-%COMP%]{position:relative;display:inline-block}.tooltip[_ngcontent-%COMP%]   .tooltiptext[_ngcontent-%COMP%]{display:none;width:359px;height:100px;overflow-y:auto;background-color:#fff;color:#58585b;border-radius:6px;border:1px solid #efefef;padding:10px;position:absolute;z-index:9999;top:-5px;right:105%}.tooltip[_ngcontent-%COMP%]:hover   .tooltiptext[_ngcontent-%COMP%]{display:block}.tooltip[_ngcontent-%COMP%]   .tooltiptext[_ngcontent-%COMP%]:not(:hover){display:none;transition:visibility 5s}.selectedDropdown[_ngcontent-%COMP%]{width:100%;height:48px;z-index:1!important;margin-top:25px}.up-green[_ngcontent-%COMP%]{color:#32a205}.down-red[_ngcontent-%COMP%]{color:#d4371c}.lds-loader[_ngcontent-%COMP%]{display:inline-block;position:relative;width:64px;height:34px}.lds-loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{display:inline-block;position:absolute;left:6px;width:13px;background:#adb1b4;animation:lds-loader 1.2s cubic-bezier(0,.5,.5,1) infinite}.lds-loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(1){left:6px;animation-delay:-.24s}.lds-loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(2){left:26px;animation-delay:-.12s}.lds-loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(3){left:45px;animation-delay:0}@keyframes lds-loader{0%{top:6px;height:45px}50%,to{top:15px;height:20px}}.tooltip[_ngcontent-%COMP%]{position:relative;display:inline}.tooltip[_ngcontent-%COMP%]   .tooltiptext1[_ngcontent-%COMP%]{display:block;width:150px;background-color:#fff;color:#000;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;bottom:125%;left:50%;margin-left:-60px;opacity:0;transition:opacity .3s}.tooltip[_ngcontent-%COMP%]   .tooltiptext1[_ngcontent-%COMP%]:after{content:\"\";position:absolute;top:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent transparent transparent}.tooltip[_ngcontent-%COMP%]:hover   .tooltiptext1[_ngcontent-%COMP%]{display:block;opacity:1}.tooltip[_ngcontent-%COMP%]   .tooltiptext2[_ngcontent-%COMP%]{display:block;width:250px;background-color:#fff;color:#000;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;bottom:125%;left:50%;margin-left:-60px;opacity:0;transition:opacity .3s}.tooltip[_ngcontent-%COMP%]   .tooltiptext2[_ngcontent-%COMP%]:after{content:\"\";position:absolute;top:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent transparent transparent}.tooltip[_ngcontent-%COMP%]:hover   .tooltiptext2[_ngcontent-%COMP%]{display:block;opacity:1}.tooltip[_ngcontent-%COMP%]   .tooltiptext3[_ngcontent-%COMP%]{display:block;width:500px;height:120px;background-color:#fff;color:#000;text-align:center;border-radius:6px;position:absolute;z-index:9999;padding:20px;left:20px;top:0px;border:1px solid #DFDFDF;transition:opacity .3s}.tooltip[_ngcontent-%COMP%]   .tooltiptext3[_ngcontent-%COMP%]:after{content:\"\";position:absolute;top:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent transparent transparent}.table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]{height:60px!important;border:1px solid #DEDEDE}.table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(even){background:#fff}th[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:300;font-size:14px;line-height:20px;letter-spacing:.5px}.active-block[_ngcontent-%COMP%]{padding:0 0 10px;color:#000!important}.pagination-div[_ngcontent-%COMP%]{padding:8px}.ac-radio-label[_ngcontent-%COMP%]{padding-top:5px}.update-note1[_ngcontent-%COMP%]{border:1px solid #FFA000;border-radius:4px;padding:15px;font-size:14px;font-family:CiscoSans;line-height:144.6%;background:#FFFF;color:#202020;width:89.5%;margin:10px 114px 20px 33px;display:inline-block}.switchdiv[_ngcontent-%COMP%]{margin-top:15px}.disabledElement[_ngcontent-%COMP%]{opacity:.3;cursor:not-allowed;pointer-events:none}.clickable[_ngcontent-%COMP%]{font-size:12px;color:#09c!important;font-family:\"ciscoSansRegular\";font-weight:bold;cursor:pointer!important}.inactive[_ngcontent-%COMP%]{color:#cd5c5c}.active[_ngcontent-%COMP%]{color:green}.summary-detail[_ngcontent-%COMP%]{display:inline;width:90%;float:left;position:relative;padding-left:28px}.summary-sub-detail[_ngcontent-%COMP%]{display:inline;width:90%;float:left;position:absolute;padding-left:28px}.userTableContainer[_ngcontent-%COMP%]{min-height:280px;height:auto;overflow-y:auto}.userTableContainer_controller[_ngcontent-%COMP%]{height:auto;overflow-y:hidden!important}.table-structure[_ngcontent-%COMP%]{height:auto;overflow-y:auto}.popupBody[_ngcontent-%COMP%]{overflow-y:auto;height:calc(100% - 165px);font-family:\"CiscoSansTT\";font-style:normal;font-size:14px;line-height:19px;letter-spacing:.458333px;color:#000}.centerPopUp[_ngcontent-%COMP%]{width:900px!important;height:450px!important;right:auto;z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;overflow-y:auto;margin:16% 24% 20% 25%;animation:none!important}.controllerTr[_ngcontent-%COMP%]{height:82px!important}.down-arrow[_ngcontent-%COMP%]{position:absolute;height:5.85px;left:73.65%;right:25.41%;top:calc(50% - 5.85px/2 - 1742.44px);border:1.5px solid #049FD9}.subheader_name[_ngcontent-%COMP%]{display:inline;border-bottom:1px solid #DEDEDE;padding-bottom:20px;width:80%;float:left;color:#000}.subheader_action[_ngcontent-%COMP%]{display:inline;text-align:center;letter-spacing:.5px;color:#049fd9;cursor:pointer;border-bottom:1px solid #DEDEDE;padding:12px 14px 20px 12px}.truobleshoot_subheader[_ngcontent-%COMP%]{display:inline-block;width:100%}.troubleshootV3[_ngcontent-%COMP%]{padding:44px 51px 0;font-family:\"CiscoSans\";font-style:normal}.service-logs[_ngcontent-%COMP%]{padding:25px 0 12.5px;font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:18px;line-height:20px;letter-spacing:.5px;border-bottom:2px solid #DEDEDE;color:#000}.service-log[_ngcontent-%COMP%]{height:65px;padding:20px 0 0;border-bottom:1px solid #DEDEDE}.log-type[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;text-align:center;letter-spacing:.5px;color:#049fd9;float:right;cursor:pointer}.log-pipe[_ngcontent-%COMP%]{padding-right:10px;margin-right:10px;border-right:1px solid #DEDEDE}.log-serviceName[_ngcontent-%COMP%]{margin-left:5px}.pwd-reset-container[_ngcontent-%COMP%]{border-left:1px solid #DEDEDE;border-right:1px solid #DEDEDE;border-bottom:1px solid #DEDEDE;padding:10px 0 20px 31.5px;display:inline-block;width:100%}.token-wrapper[_ngcontent-%COMP%]{margin-top:10px}.token-container[_ngcontent-%COMP%]{margin-right:40px;height:auto;background:#EFF8FC;border:1px dashed #049FD9;border-radius:12px;text-align:left;padding:20px;margin-top:10px;overflow-wrap:break-word}.copy-key[_ngcontent-%COMP%]{cursor:pointer;font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:19px;letter-spacing:.5px;color:#049fd9;width:100px;margin-top:15px;margin-bottom:15px}.steps-reset[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:14px;line-height:19px;letter-spacing:.5px;margin-top:18px;margin-bottom:11px}.step-header[_ngcontent-%COMP%]{display:inline-block}.step-header[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:inline-block}.step-header[_ngcontent-%COMP%]   .step_index[_ngcontent-%COMP%]{border:1px solid #979797;width:30px;height:30px;border-radius:50%;text-align:center;line-height:30px;font-size:12px;font-family:CiscoSans;font-weight:bold;margin-right:20px}.step-header[_ngcontent-%COMP%]   span.tile_header[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;font-weight:300;letter-spacing:.83px;line-height:18px;display:inline}.withBorder[_ngcontent-%COMP%]{border-left:1px solid #979797;height:10px;margin-left:14px}.nav-arrow[_ngcontent-%COMP%]{display:inline;align-items:center}.nav-arrow[_ngcontent-%COMP%]   .icon-arrow[_ngcontent-%COMP%]:before{font-size:15px}.nav-arrow[_ngcontent-%COMP%]   .icon-arrow[_ngcontent-%COMP%]:after{font-size:15px;transform:rotate(90deg)}.activePNodeWithChild[_ngcontent-%COMP%]{background:#FFFF;font-weight:bold;border:1px solid #DEDEDE;border-bottom:none;width:20%;font-size:14px;display:inherit;height:42px}.activePNode[_ngcontent-%COMP%]{background:#FFFF;border-left:5px solid #00A0D1;color:#000;font-weight:bold}.activePNode[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:before{color:#312f2f}.migrate_click[_ngcontent-%COMP%]{cursor:pointer;color:#09c!important}.migrate-header[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:18px;line-height:25px;letter-spacing:.5px;color:#545454;float:left;margin-bottom:5px;width:100%;text-align:left}.marginTopheader[_ngcontent-%COMP%]{margin-top:10px}.migrate-text[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:14px;line-height:20px;letter-spacing:.5px;color:#545454;float:left;text-align:left}.header-blocks[_ngcontent-%COMP%]{letter-spacing:.5px}.empty_metric_msg[_ngcontent-%COMP%]{font-size:18px;color:#4d4d4d;height:400px;padding:85px 0 0 30px;clear:none;float:left}.actionMenu[_ngcontent-%COMP%]{margin-left:15px}.userTable[_ngcontent-%COMP%]   span.userActionsMenu[_ngcontent-%COMP%]{text-align:center;display:none;width:115px;margin-left:15px}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   span.userActionsMenu[_ngcontent-%COMP%]{display:inline}.userTable[_ngcontent-%COMP%]   div.userActionsMenu_instance[_ngcontent-%COMP%]{text-align:center;display:none;width:115px;padding-left:4px}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   span.userActionsMenu[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   span.userActionsMenu.selected[_ngcontent-%COMP%]{display:inline}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   div.userActionsMenu_instance[_ngcontent-%COMP%]{display:inline}.userTable.fold-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(even):hover{background:#fff!important}.userTable.fold-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd):hover{background:#ebf7f9!important}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover{background:#ebf7f9!important}.userTable[_ngcontent-%COMP%] > thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%]:hover{background:#fff!important}.userTable[_ngcontent-%COMP%]   span.userActionsMenu[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative;padding:0 10px;text-decoration:none;outline:none}.userTable[_ngcontent-%COMP%]   div.userActionsMenu_instance[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative;padding:0 10px;text-decoration:none;outline:none}.userListLabel[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;overflow-wrap:break-word;width:75%}.upgrade-arrow[_ngcontent-%COMP%]{display:inline}.release-div[_ngcontent-%COMP%]{display:inline}.table-box[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd){background:#fff}.table-box[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(even){background:#f9f9f9}.table-box[_ngcontent-%COMP%]{display:table;width:100%;border-bottom:1px solid #dee0e1;border-spacing:0;box-shadow:0 0 5px #0000001a}.table-header[_ngcontent-%COMP%]{background:#fff;border-bottom:1px solid #dee0e1}.vertical-seperator[_ngcontent-%COMP%]{height:20px;background:#acacac;width:1px;display:inline-block}.th-text-date[_ngcontent-%COMP%]{left:30px!important}.last-td[_ngcontent-%COMP%]{font-size:13px!important}.w25[_ngcontent-%COMP%]{width:25%}.w18[_ngcontent-%COMP%]{width:18%}.w20[_ngcontent-%COMP%]{width:20%}.w15[_ngcontent-%COMP%]{width:15%}.w11[_ngcontent-%COMP%]{width:11%}.w5[_ngcontent-%COMP%]{width:5%}.w10[_ngcontent-%COMP%]{width:10%}.w12[_ngcontent-%COMP%]{width:10%}.pl20[_ngcontent-%COMP%]{padding-left:30px}.deleteCheckbox[_ngcontent-%COMP%]{position:relative;top:-12px;vertical-align:middle;padding-right:30px;display:inline-block}.partial-select[_ngcontent-%COMP%]{border:1px solid #039fd9;width:16px;height:16px}.partial-select[_ngcontent-%COMP%]:before{background:#039fd9!important;top:2px!important;left:2px!important;height:10px!important;width:10px!important}.checkboxStatusTD[_ngcontent-%COMP%]{margin-top:10px}.table-wrapper[_ngcontent-%COMP%]{width:75%;margin:0 auto}.th-text[_ngcontent-%COMP%]{display:inline-block;position:relative;left:15px}.activeColumn[_ngcontent-%COMP%]{padding-left:15px!important}.hover[_ngcontent-%COMP%]{position:relative}.toolTip[_ngcontent-%COMP%]{position:absolute;color:#000;bottom:calc(100% - 38px);left:-6.4em;transform:translateY(-50%);width:auto;height:auto;min-width:240px;background-color:#fff;padding:10px;display:none;font-size:14px;border-radius:4px;filter:drop-shadow(0px 0px 1px #b2b2b2)}.toolTip[_ngcontent-%COMP%]:after{position:absolute;left:41%;bottom:-1em;transform:translateY(-50%);width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-top:10px solid #fff;content:\"\"}.hover[_ngcontent-%COMP%]:hover   .toolTip[_ngcontent-%COMP%]{display:block}.toolTipHeading[_ngcontent-%COMP%]{font-family:ciscoSansThin;font-size:16px;color:#000;padding-bottom:5px;font-weight:bold}.tooltip-desc[_ngcontent-%COMP%]{font-size:13px}.showDiv-on-Mousehover[_ngcontent-%COMP%]{background-color:#777;position:sticky;bottom:auto;top:auto;width:340px;height:auto;padding:5px;border:1px solid #DFDFDF;box-shadow:0 4px 8px #0000001a;border-radius:2px;z-index:10;width:380px;color:#4d4d4d}.modalBody1[_ngcontent-%COMP%]{margin:0;cursor:pointer;opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]{display:flex;height:115px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 10px 10px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:12px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .modalBody1[_ngcontent-%COMP%]:hover{opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]{width:100%;border-top:1px solid #b2a6a6;text-align:center;padding-top:5px}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]   .popup-footer-text[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:13px;color:#fff}.selectable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd){background:none!important;height:45px}.selectable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(even){background:none!important;height:45px}.selectable[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{border-bottom:1px solid #DEDEDE;box-shadow:0 1px 3px #00000040;height:45px}.select-custom-2-2[_ngcontent-%COMP%]{width:28%!important}.headerAlign[_ngcontent-%COMP%]{text-align:left}.radio-label[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px}.text-desc[_ngcontent-%COMP%]{font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px}.upgrade-image[_ngcontent-%COMP%]{border:none!important;box-shadow:none!important;padding:0!important}.circularCheckbox-default[_ngcontent-%COMP%]{padding-left:26px;vertical-align:middle;padding-right:15px;display:inline-block}.circularCheckbox-default[_ngcontent-%COMP%]   .checkboxLabel[_ngcontent-%COMP%]{padding-left:10px;height:20px;cursor:pointer;position:relative}.tooltip[_ngcontent-%COMP%]   .tooltiptext-default-service[_ngcontent-%COMP%]{display:none;width:359px;height:auto;overflow-y:auto;background-color:#fff;color:#58585b;border-radius:6px;border:1px solid #efefef;padding:21px;position:absolute;z-index:9999;top:-51px;left:23px;right:105%}.tooltip[_ngcontent-%COMP%]:hover   .tooltiptext-default-service[_ngcontent-%COMP%]{display:block}.disablePairing[_ngcontent-%COMP%]{float:right;cursor:pointer;color:#07a0d9}.controller-search-container[_ngcontent-%COMP%]{margin:0 10px;display:inline-block}.controller-search-container[_ngcontent-%COMP%]   .searchInput[_ngcontent-%COMP%]{width:200px;height:35px;padding:5px 15px 0 8px;border:none;border-bottom:1px solid #ccc;font-size:12px;background:none;letter-spacing:.1px}.controller-search-container[_ngcontent-%COMP%]   input.searchInput[_ngcontent-%COMP%]:focus{color:#000;border-color:#049fd9;border-width:2px}.controller-search-container[_ngcontent-%COMP%]   .user-search-icon[_ngcontent-%COMP%]{background:url(/assets/images/search_dropdown.svg);width:24px;height:24px;display:inline-block;background-repeat:no-repeat;background-position:center;vertical-align:middle;bottom:0;top:0;margin:auto}.addController[_ngcontent-%COMP%]{display:inline!important;width:200px}.controllerSearchAdd[_ngcontent-%COMP%]{display:flex;float:right}.migration-note[_ngcontent-%COMP%]{border:1px solid #FFA000;border-radius:4px;padding:15px;font-size:14px;font-family:CiscoSans;line-height:144.6%;background:#FFFF;color:#202020;display:inline-block;width:93%;margin:0 65px 15px}.grayDiv_list[_ngcontent-%COMP%]{padding-top:0!important}.testsuccess[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.5px;color:#32a205}.utcmsg[_ngcontent-%COMP%]{margin-left:37em;padding:1.5em 0;color:#abacac;position:absolute;font-size:14px}.hotspot_config_div[_ngcontent-%COMP%]{display:inline-flex;margin:30px 0}.migratelabel[_ngcontent-%COMP%]{margin-left:10px}.tooltiptext_msg[_ngcontent-%COMP%]{width:420px;height:auto;overflow-y:auto;background-color:#fff;color:#58585b;border-radius:6px;border:1px solid #efefef;padding:10px;position:absolute;z-index:9999;top:370px}.noImportdevice[_ngcontent-%COMP%]{color:#d4371c;font-weight:800}.migrate-note[_ngcontent-%COMP%]{border:1px solid #FFA000;border-radius:4px;padding:0 5px;font-size:14px;font-family:CiscoSans;line-height:144.6%;background:#FFFF;color:#202020;display:inline-block;margin:15px 0;width:80%}.dropdown_con[_ngcontent-%COMP%]{position:relative;width:25%}.dropdown[_ngcontent-%COMP%]{position:relative}.arrow[_ngcontent-%COMP%]{color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;right:0;padding:8px;display:block}.options[_ngcontent-%COMP%]{width:100%;position:absolute;top:70%;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:1003;background-color:#fff;box-shadow:5px 5px 20px #888}.each-option[_ngcontent-%COMP%]{display:block;padding:8px 10px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.each-option[_ngcontent-%COMP%]:hover{background-color:#eaeaea}.item-name[_ngcontent-%COMP%]{font-size:18px}.item-message[_ngcontent-%COMP%]{font-size:x-small;font-style:italic}.active[_ngcontent-%COMP%]{cursor:pointer}.inactive[_ngcontent-%COMP%]{cursor:not-allowed}.active[_ngcontent-%COMP%]   .item-message[_ngcontent-%COMP%]{color:green}.inactive[_ngcontent-%COMP%]   .item-message[_ngcontent-%COMP%]{color:red}.inactive-clickable[_ngcontent-%COMP%]{cursor:pointer}.inactive-clickable[_ngcontent-%COMP%]   .item-message[_ngcontent-%COMP%]{color:red}.selectedItem[_ngcontent-%COMP%]{display:table-cell;width:40px;height:40px;vertical-align:middle}.paddingLeft[_ngcontent-%COMP%]{padding-left:40px}.unSelectedItem[_ngcontent-%COMP%]{display:table-cell;height:40px;vertical-align:middle;padding-left:40px}.tableCell[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.paddingEmpty[_ngcontent-%COMP%]{padding:0!important}.circularCheckbox-default[_ngcontent-%COMP%]   .checkboxLabe[_ngcontent-%COMP%]{padding-left:6px!important;height:20px;cursor:pointer;position:relative}.persistlable[_ngcontent-%COMP%]{padding-top:14px;font-family:ciscoSans;font-size:14px}.persistlable[_ngcontent-%COMP%]   .hotspot_config_div[_ngcontent-%COMP%]{display:inline-flex;margin:30px 0}.persistlable[_ngcontent-%COMP%]   .migratelabel[_ngcontent-%COMP%]{margin-left:10px}.persistlable[_ngcontent-%COMP%]   .tooltiptext_msg[_ngcontent-%COMP%]{width:420px;height:auto;overflow-y:auto;background-color:#fff;color:#58585b;border-radius:6px;border:1px solid #efefef;padding:10px;position:absolute;z-index:9999;top:370px}.persistlable[_ngcontent-%COMP%]   .noImportdevice[_ngcontent-%COMP%]{color:#d4371c;font-weight:800}.persistlable[_ngcontent-%COMP%]   .migrate-note[_ngcontent-%COMP%]{border:1px solid #FFA000;border-radius:4px;padding:0 5px;font-size:14px;font-family:CiscoSans;line-height:144.6%;background:#FFFF;color:#202020;display:inline-block;margin:15px 0;width:80%}.persistlable[_ngcontent-%COMP%]   .dropdown_con[_ngcontent-%COMP%]{position:relative;width:25%}.persistlable[_ngcontent-%COMP%]   .dropdown[_ngcontent-%COMP%]{position:relative}.persistlable[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]{color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;right:0;padding:8px;display:block}.persistlable[_ngcontent-%COMP%]   .options[_ngcontent-%COMP%]{width:100%;position:absolute;top:70%;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:1003;background-color:#fff;box-shadow:5px 5px 20px #888}.persistlable[_ngcontent-%COMP%]   .each-option[_ngcontent-%COMP%]{display:block;padding:8px 10px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.persistlable[_ngcontent-%COMP%]   .each-option[_ngcontent-%COMP%]:hover{background-color:#eaeaea}.persistlable[_ngcontent-%COMP%]   .item-name[_ngcontent-%COMP%]{font-size:18px}.persistlable[_ngcontent-%COMP%]   .item-message[_ngcontent-%COMP%]{font-size:x-small;font-style:italic}.persistlable[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%]{cursor:pointer}.persistlable[_ngcontent-%COMP%]   .inactive[_ngcontent-%COMP%]{cursor:not-allowed}.persistlable[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%]   .item-message[_ngcontent-%COMP%]{color:green}.persistlable[_ngcontent-%COMP%]   .inactive[_ngcontent-%COMP%]   .item-message[_ngcontent-%COMP%]{color:red}.persistlable[_ngcontent-%COMP%]   .inactive-clickable[_ngcontent-%COMP%]{cursor:pointer}.persistlable[_ngcontent-%COMP%]   .inactive-clickable[_ngcontent-%COMP%]   .item-message[_ngcontent-%COMP%]{color:red}.persistlable[_ngcontent-%COMP%]   .selectedItem[_ngcontent-%COMP%]{display:table-cell;width:40px;height:40px;vertical-align:middle}.persistlable[_ngcontent-%COMP%]   .paddingLeft[_ngcontent-%COMP%]{padding-left:40px}.persistlable[_ngcontent-%COMP%]   .unSelectedItem[_ngcontent-%COMP%]{display:table-cell;height:40px;vertical-align:middle;padding-left:40px}.persistlable[_ngcontent-%COMP%]   .tableCell[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.persistlable[_ngcontent-%COMP%]   .paddingEmpty[_ngcontent-%COMP%]{padding:0!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmxConnectorComponent, [{
        type: Component,
        args: [{
                selector: "app-cmx-connector",
                templateUrl: "./cmx-connector.component.html",
                styleUrls: ["./cmx-connector.component.scss"]
            }]
    }], function () { return [{ type: AuthService }, { type: DataService }, { type: CMXConnectorsService }, { type: LocationService }, { type: InteractionService }, { type: i1.Router }, { type: CmxOnpremService }, { type: i2.TranslateService }]; }, { cmxConnectorInstancesComponent: [{
            type: ViewChild,
            args: [CmxConnectorInstancesComponent, { static: false }]
        }], showControllers: [{
            type: Output
        }], userRole: [{
            type: Input
        }], showConnectorsUpdate: [{
            type: Input
        }] }); })();

class NavigationHomeModel {
    constructor(id, type, label, iconClassName, clickable, selected, routeUrl, dataNode, childNodes, externalUrl = false) {
        this._id = id;
        this.type = type;
        this.label = label;
        this.iconClassName = iconClassName;
        this.clickable = clickable;
        this.selected = selected;
        this.routeUrl = routeUrl;
        this.dataNode = dataNode;
        this.externalUrl = externalUrl;
        this.childNodes = childNodes;
    }
}

class SetupPlatformAppService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.setupConfigUrl = "/assets/data/setup/setup-config.json?v=1";
        this.setupDataUrl = "/assets/data/setup/setup-pageData.json?";
        this.setupStepsDataUrl = "/assets/data/setup-cmx-flow.json?";
        this.wiredSetupDataUrl = "/assets/data/setup/wired-setup-pageData.json?";
        this.getSetupList = () => {
            const serverUrl = this.apiConfig.getSetupList();
            return this.get(serverUrl).pipe(map$1(this.extractResponseData));
        };
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getSetupConfigData = () => {
            return this.get(this.setupConfigUrl).pipe(map$1(this.extractResponse));
        };
        this.getSetupPageData = () => {
            return this.get(this.setupDataUrl).pipe(map$1(this.extractResponse));
        };
        this.getWiredSetupPageData = () => {
            return this.get(this.wiredSetupDataUrl).pipe(map$1(this.extractResponse));
        };
        /**
         * Makes an API request to save the widget name
         * @param name
         * @returns Observable<any>
         */
        this.saveSetupWidget = (name, serviceAccount) => {
            const serverUrl = this.apiConfig.saveSetupWidget();
            return this.post(serverUrl, { widgets: name, serviceAccount }).pipe(map$1(this.extractResponse));
        };
        this.getConfiguredWidgets = () => {
            const serverUrl = this.apiConfig.getConfiguredWidgets();
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getWidgetData = (widget) => {
            const serverUrl = this.apiConfig.getDataForWidgets();
            return this.get(`${serverUrl}/${widget}`).pipe(map$1(this.extractResponse));
        };
        this.getWiredWidgetData = (widget) => {
            const serverUrl = this.apiConfig.getDataForWiredWidgets();
            return this.get(`${serverUrl}/${widget}`).pipe(map$1(this.extractResponse));
        };
        this.getsetUpStepsData = () => {
            return this.get(this.setupStepsDataUrl).pipe(map$1(this.extractResponse));
        };
        this.deleteWirelessWidgetData = (type) => {
            const serverUrl = this.apiConfig.deleteWirelessWidget();
            const deleteWidget = {
                widgets: type
            };
            const opts = {
                body: deleteWidget
            };
            return this.delete(serverUrl, opts).pipe(map$1(this.extractResponse));
        };
        this.getBusinessLocationList = (req) => {
            // const serverUrl = "/assets/data/bl-list.json";
            // return this.get(serverUrl).pipe(map(this.extractResponse));
            const serverUrl = this.apiConfig.getBusinessLocationsUrl();
            return this.post(serverUrl, req).pipe(map$1(this.extractResponse));
        };
        this.getReviewMapLocationList = (isPreview) => {
            const serverUrl = this.apiConfig.getReviewMapLocationListUrl() + '?preview=' + isPreview;
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getAddMapLocationList = () => {
            const serverUrl = this.apiConfig.getAddMapLocationListUrl();
            // const serverUrl = "/assets/data/add-list.json";
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.addLocation = (req) => {
            const serverUrl = this.apiConfig.addLocationUrl();
            return this.post(serverUrl, req).pipe(map$1(this.extractResponse));
        };
        this.updateBusinessLocInfo = (req) => {
            const serverUrl = this.apiConfig.updateBusinessLocInfoUrl();
            return this.post(serverUrl, req).pipe(map$1(this.extractResponse));
        };
        this.getRichMapBusinessLocationList = (req) => {
            const serverUrl = this.apiConfig.getRichMapsLocationUrl();
            return this.post(serverUrl, req).pipe(map$1(this.extractResponse));
        };
        this.uploadCADForLocationUrl = (formData, domain) => {
            const headersOptions = {
                Pragma: "no-cache",
                Authorization: ""
            };
            // TODO: move to httpclient wraper
            if (this.dataService.getAccessToken()) {
                headersOptions.Authorization =
                    "Bearer " + this.dataService.getAccessToken();
            }
            let headers = new HttpHeaders(headersOptions);
            headers.append('Content-Type', 'multipart/form-data');
            headers.append('Accept', 'application/json');
            let options = { headers: headers };
            let apiUrl = `${domain}${this.apiConfig.uploadRichMapForLocationUrl()}`;
            return this.post(apiUrl, formData, options).pipe(map$1(this.extractResponse));
        };
        this.digitalMapfileUpload = (formData, domain, isBulkUpload) => {
            const headersOptions = {
                Pragma: "no-cache",
                Authorization: ""
            };
            // TODO: move to httpclient wraper
            if (this.dataService.getAccessToken()) {
                headersOptions.Authorization =
                    "Bearer " + this.dataService.getAccessToken();
            }
            let headers = new HttpHeaders(headersOptions);
            headers.append('Content-Type', 'multipart/form-data');
            headers.append('Accept', 'application/json');
            let options = { headers: headers };
            let apiUrl = isBulkUpload ? `${domain}${this.apiConfig.digitalMapBulkUpload()}` : `${domain}${this.apiConfig.digitalMapfileUpload()}`;
            return this.post(apiUrl, formData, options).pipe(map$1(this.extractResponse));
        };
        this.confirmCADForLocation = (formData, domain) => {
            const headersOptions = {
                Pragma: "no-cache",
                Authorization: ""
            };
            // TODO: move to httpclient wraper
            if (this.dataService.getAccessToken()) {
                headersOptions.Authorization =
                    "Bearer " + this.dataService.getAccessToken();
            }
            let headers = new HttpHeaders(headersOptions);
            headers.append('Content-Type', 'multipart/form-data');
            headers.append('Accept', 'application/json');
            let options = { headers: headers };
            const apiUrl = `${domain}${this.apiConfig.confirmCADForLocationUrl()}`;
            return this.post(apiUrl, formData, options).pipe(map$1(this.extractResponse));
        };
        this.cancelRichMap = (payload, domain) => {
            const headersOptions = {
                Pragma: "no-cache",
                Authorization: ""
            };
            if (this.dataService.getAccessToken()) {
                headersOptions.Authorization =
                    "Bearer " + this.dataService.getAccessToken();
            }
            let headers = new HttpHeaders(headersOptions);
            headers.append('Accept', 'application/json');
            const options = { headers: headers };
            const serverUrl = `${domain}${this.apiConfig.cancelRichMapForLocationUrl()}`;
            return this.post(serverUrl, payload, options).pipe(map$1(this.extractResponse));
        };
        this.cancelDigitalMap = (payload, domain) => {
            const headersOptions = {
                Pragma: "no-cache",
                Authorization: ""
            };
            if (this.dataService.getAccessToken()) {
                headersOptions.Authorization =
                    "Bearer " + this.dataService.getAccessToken();
            }
            let headers = new HttpHeaders(headersOptions);
            headers.append('Accept', 'application/json');
            const options = { headers: headers };
            const serverUrl = `${domain}${this.apiConfig.cancelDigitalMapUrl()}`;
            return this.post(serverUrl, payload, options).pipe(map$1(this.extractResponse));
        };
        this.deleteRichMap = (payload, domain) => {
            const headersOptions = {
                Pragma: "no-cache",
                Authorization: ""
            };
            if (this.dataService.getAccessToken()) {
                headersOptions.Authorization =
                    "Bearer " + this.dataService.getAccessToken();
            }
            let headers = new HttpHeaders(headersOptions);
            headers.append('Accept', 'application/json');
            const options = { headers: headers };
            const serverUrl = `${domain}${this.apiConfig.deleteRichMapForLocationUrl()}`;
            return this.post(serverUrl, payload, options).pipe(map$1(this.extractResponse));
        };
        this.deleteDigitalMap = (payload, domain) => {
            const headersOptions = {
                Pragma: "no-cache",
                Authorization: ""
            };
            if (this.dataService.getAccessToken()) {
                headersOptions.Authorization =
                    "Bearer " + this.dataService.getAccessToken();
            }
            let headers = new HttpHeaders(headersOptions);
            headers.append('Accept', 'application/json');
            const options = { headers: headers };
            const serverUrl = `${domain}${this.apiConfig.deleteDigitalMapForLocationUrl()}`;
            return this.post(serverUrl, payload, options).pipe(map$1(this.extractResponse));
        };
        this.getFloorsMisMatchForBuilding = ({ tenantId, buildingId, domain }) => {
            const headersOptions = {
                Pragma: "no-cache",
                Authorization: ""
            };
            if (this.dataService.getAccessToken()) {
                headersOptions.Authorization =
                    "Bearer " + this.dataService.getAccessToken();
            }
            let headers = new HttpHeaders(headersOptions);
            headers.append('Accept', 'application/json');
            const options = { headers: headers };
            const serverUrl = `${domain}${this.apiConfig.getFloorDetailsUrl()}/${tenantId}/${buildingId}`;
            return this.get(serverUrl, options).pipe(map$1(this.extractResponse));
        };
        this.saveFloorsDetails = ({ floorDetails, tenantId, buildingId, domain }) => {
            const headersOptions = {
                Pragma: "no-cache",
                Authorization: ""
            };
            if (this.dataService.getAccessToken()) {
                headersOptions.Authorization =
                    "Bearer " + this.dataService.getAccessToken();
            }
            let headers = new HttpHeaders(headersOptions);
            headers.append('Accept', 'application/json');
            const options = { headers: headers };
            const serverUrl = `${domain}${this.apiConfig.getFloorDetailsUrl()}/${tenantId}/${buildingId}`;
            return this.post(serverUrl, floorDetails, options).pipe(map$1(this.extractResponse));
        };
        this.updateLocation = (payload) => {
            const serverUrl = this.apiConfig.updateLocationUrl();
            return this.post(serverUrl, payload).pipe(map$1(this.extractResponse));
        };
        this.uploadBusinessLocation = (formData) => {
            const headersOptions = {
                Pragma: "no-cache",
                Authorization: ""
            };
            // TODO: move to httpclient wraper
            if (this.dataService.getAccessToken()) {
                headersOptions.Authorization =
                    "Bearer " + this.dataService.getAccessToken();
            }
            const headers = new HttpHeaders(headersOptions);
            headers.append('Content-Type', 'multipart/form-data');
            headers.append('Accept', 'application/json');
            let options = { headers: headers };
            const serverUrl = this.apiConfig.uploadBusinessLocationUrl();
            return this.post(serverUrl, formData, options).pipe(map$1(this.extractResponse));
        };
        this.updateMetaDataUrl = (payLoad) => {
            const serverUrl = this.apiConfig.updateMetaDataUrl();
            return this.post(serverUrl, payLoad).pipe(map$1(this.extractResponse));
        };
        this.getMapsHierarchy = (req) => {
            // const serverUrl = "/assets/data/newHierarchy.json";
            // return this.get(serverUrl).pipe(map(this.extractResponse));
            const serverUrl = this.apiConfig.getMapsHierarchyUrl();
            return this.post(serverUrl, req).pipe(map$1(this.extractResponse));
        };
        this.getMapsSummary = (req) => {
            const serverUrl = this.apiConfig.getMapsSummaryUrl();
            return this.post(serverUrl, req).pipe(map$1(this.extractResponse));
        };
        this.saveBusinessLocations = (req) => {
            const serverUrl = this.apiConfig.saveBusinessLocationsUrl();
            return this.post(serverUrl, req).pipe(map$1(this.extractResponse));
        };
        this.createFloors = (req) => {
            const serverUrl = this.apiConfig.createFloorsUrl();
            return this.post(serverUrl, req).pipe(map$1(this.extractResponse));
        };
        this.addFloor = (req) => {
            const serverUrl = this.apiConfig.addFloorUrl();
            return this.post(serverUrl, req).pipe(map$1(this.extractResponse));
        };
        this.uploadPrimeMapsFile = (formData) => {
            const serverUrl = this.apiConfig.getUploadPrimeMapsZipFileURL();
            const option = {
                skipContentType: true,
                headers: new HttpHeaders({
                    responseType: "json"
                })
            };
            return this.post(serverUrl, formData, option).pipe(map$1(this.extractResponse));
        };
        this.uploadStatus = (sessionId) => {
            const serverUrl = '/api/maps/v1/sync/map/status/' + sessionId;
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.reviewLocations = () => {
            // const serverUrl = '/assets/data/reviewLocsResponse.json'
            const serverUrl = this.apiConfig.getReviewLocationsUrl();
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getImportSummary = (type) => {
            const serverUrl = this.apiConfig.getImportSummaryUrl();
            return this.post(serverUrl, type).pipe(map$1(this.extractResponse));
        };
        this.getUploadHistory = () => {
            // const serverUrl = '/assets/data/uploadhistory.json'
            const serverUrl = this.apiConfig.getUploadHistoyUrl();
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getRichmapsHistory = (req) => {
            // const serverUrl = '/assets/data/recent-activity.json'
            const serverUrl = `${req.domain}${this.apiConfig.getRichmapsHistoryUrl()}/${req.tenantId}/history`;
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getBuildingRichmapsHistory = (req) => {
            // const serverUrl = '/assets/data/richmapshistory.json'
            const serverUrl = `${req.domain}${this.apiConfig.getRichmapsHistoryUrl()}/${req.tenantId}/${req.buildingId}/history`;
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getCSVFile = () => {
            // const serverUrl = this.apiConfig.getCSVFileUrl();
            // return this.get(serverUrl).pipe(map(this.extractResponse));
            const options = {
                responseType: "blob"
            };
            const serverUrl = this.apiConfig.getCSVFileUrl();
            return this.get(serverUrl, options).pipe(map$1(this.extractResponse));
        };
        this.getFloorIndex = (req) => {
            const serverUrl = `${req.domain}${this.apiConfig.getRichmapsHistoryUrl()}/${req.tenantId}/${req.buildingId}/floors`;
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.digitalMapFloorList = (reqObj) => {
            // const serverUrl = "/assets/data/floorList.json";
            // return this.get(serverUrl).pipe(map(this.extractResponse));
            const serverUrl = this.apiConfig.digitalMapFloorList();
            return this.post(serverUrl, reqObj).pipe(map$1(this.extractResponse));
        };
        this.digitalMapFloorMapping = (reqObj, domain) => {
            const headersOptions = {
                Pragma: "no-cache",
                Authorization: ""
            };
            if (this.dataService.getAccessToken()) {
                headersOptions.Authorization =
                    "Bearer " + this.dataService.getAccessToken();
            }
            let headers = new HttpHeaders(headersOptions);
            headers.append('Accept', 'application/json');
            const options = { headers: headers };
            const apiUrl = `${domain}${this.apiConfig.digitalMapFloorMapping()}`;
            return this.post(apiUrl, reqObj, options).pipe(map$1(this.extractResponse));
        };
        this.digitalMapUpdateFloorList = (reqObj) => {
            // const serverUrl = "/assets/data/updatedfloors.json";
            // return this.get(serverUrl).pipe(map(this.extractResponse));
            const serverUrl = this.apiConfig.digitalMapUpdateFloorList();
            return this.post(serverUrl, reqObj).pipe(map$1(this.extractResponse));
        };
        this.saveStandardMap = (reqObj, domain) => {
            const headersOptions = {
                Pragma: "no-cache",
                Authorization: ""
            };
            if (this.dataService.getAccessToken()) {
                headersOptions.Authorization =
                    "Bearer " + this.dataService.getAccessToken();
            }
            let headers = new HttpHeaders(headersOptions);
            headers.append('Accept', 'application/json');
            const options = { headers: headers };
            const apiUrl = `${domain}${this.apiConfig.saveStandardMap()}`;
            return this.post(apiUrl, reqObj, options).pipe(map$1(this.extractResponse));
        };
    }
}
SetupPlatformAppService.ɵfac = function SetupPlatformAppService_Factory(t) { return new (t || SetupPlatformAppService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
SetupPlatformAppService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SetupPlatformAppService, factory: SetupPlatformAppService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SetupPlatformAppService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
function SetupNotifyComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "img", 2);
    i0.ɵɵtext(3, " You have not connected to any wireless network yet. ");
    i0.ɵɵelementStart(4, "span", 3);
    i0.ɵɵlistener("click", function SetupNotifyComponent_div_0_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.goToSetupPage(); });
    i0.ɵɵtext(5, "Click here");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, " to connect your wireless network with Cisco Spaces. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵelementStart(8, "span", 4);
    i0.ɵɵlistener("click", function SetupNotifyComponent_div_0_Template_span_click_8_listener() { i0.ɵɵrestoreView(_r2); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.hideNotification(); });
    i0.ɵɵtext(9, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class SetupNotifyComponent {
    constructor(router, dataService, setupPlatformService) {
        this.router = router;
        this.dataService = dataService;
        this.setupPlatformService = setupPlatformService;
        this.unsubscribe$ = new Subject();
        this.role = "";
        this.isSetupConfigured = false;
        this.visible = false;
        this.currentState = false;
        this.initializeNotification = (state) => {
            if (state) {
                let currentUrl = this.dataService.getCurrentNav();
                if (currentUrl == undefined) {
                    currentUrl = this.router.url;
                }
                const urlIncluded = this.checkForUrl(currentUrl);
                urlIncluded ? this.show() : this.hide();
            }
            else {
                this.hide();
            }
        };
        this.getConfiguredWidgets = () => {
            this.setupPlatformService
                .getConfiguredWidgets()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response) {
                    const data = response.data || {};
                    let networkTypes = data["widgets"]
                        ? data["widgets"]
                        : [];
                    networkTypes = networkTypes.filter((type) => type !== "test");
                    if (networkTypes && networkTypes.length === 0) {
                        this.isSetupConfigured = false;
                        this.dataService
                            .getBannerState(this.unsubscribe$)
                            .subscribe((value) => {
                            this.currentState = value;
                            this.initializeNotification(value);
                        });
                        this.router.events
                            .pipe(takeUntil(this.unsubscribe$))
                            .subscribe((val) => {
                            if (val instanceof NavigationEnd)
                                this.initializeNotification(this.currentState);
                        });
                    }
                }
            }, (error) => {
                console.log("Unable to get configured Wireless networks list");
                // this.dataService.setToastMessage('An error occurred while getting configured Wireless networks.', 4000, null, null, 'error');
            });
        };
        this.hideNotification = () => {
            // this.dataService.setBannerState(false);
            this.initializeNotification(false);
        };
        this.show = () => {
            this.visible = true;
            setTimeout(() => {
                $("#setupBanner").slideDown("slow");
                $("#spacesRootNode").addClass("heightAdjuster");
            }, 100);
        };
        this.hide = () => {
            $("#setupBanner").hide();
            this.visible = false;
            setTimeout(() => {
                $("#spacesRootNode").removeClass("heightAdjuster");
            }, 100);
        };
        this.checkForUrl = (urlParams) => {
            if (urlParams)
                if (urlParams.includes("/captiveportal/cssEditor")) {
                    return false;
                }
                else if (urlParams.includes("/portal/edit")) {
                    return false;
                }
                else if (urlParams.includes("/captive-portal/create")) {
                    return false;
                }
                else if (urlParams.includes("/captive-portal/edit")) {
                    return false;
                }
                else if (urlParams.includes("/reports/engagement-rule")) {
                    return false;
                }
                else if (urlParams.includes("/rules/engagement/create")) {
                    return false;
                }
                else if (urlParams.includes("/rules/engagement/edit")) {
                    return false;
                }
                else if (urlParams.includes("captiveportal/rules/captive-portal/edit")) {
                    return false;
                }
                else if (urlParams.includes("/captiveportal/reports/profile-rule")) {
                    return false;
                }
                else if (urlParams.includes("/reports/profile-rule")) {
                    return false;
                }
                else if (urlParams.includes("/rules/profile/create")) {
                    return false;
                }
                else if (urlParams.includes("/rules/profile/edit")) {
                    return false;
                }
                else if (urlParams.includes("/business")) {
                    return false;
                }
                else if (urlParams.includes("/setup/wirelessnetwork")) {
                    return false;
                }
                else if (urlParams.includes("/setup/camera")) {
                    return false;
                }
                else if (urlParams.includes("/setup/maps")) {
                    return false;
                }
                else if (urlParams.includes("/captive-portal/create")) {
                    return false;
                }
                else if (urlParams.includes("/captiveportal/usermanagement/invite")) {
                    return false;
                }
                else if (urlParams.includes("/captiveportal/usermanagement/edit")) {
                    return false;
                }
                else if (urlParams.includes("/team/invite")) {
                    return false;
                }
                else if (urlParams.includes("/team/edit")) {
                    return false;
                }
                else {
                    return true;
                }
            else
                return false;
        };
        this.goToSetupPage = () => {
            const currentNav = "/setup/wirelessnetwork";
            this.dataService.setCurrentNav(currentNav);
            this.router.navigate([currentNav]);
        };
    }
    ngOnInit() {
        this.role = this.dataService.getUserRole().appRole;
        if (this.role == undefined || this.role == null) {
            setTimeout(() => {
                this.role = this.dataService.getUserRole().appRole;
                this.ngOnInit();
            }, 1000);
        }
        else {
            if (this.role == "RW") {
                this.getConfiguredWidgets();
            }
        }
    }
    ngOnDestroy() {
        $("#spacesRootNode").removeClass("heightAdjuster");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
SetupNotifyComponent.ɵfac = function SetupNotifyComponent_Factory(t) { return new (t || SetupNotifyComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(SetupPlatformAppService)); };
SetupNotifyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SetupNotifyComponent, selectors: [["lib-setup-notify"]], decls: 1, vars: 1, consts: [["id", "setupBanner", "class", "connectWirelessNetworks", 4, "ngIf"], ["id", "setupBanner", 1, "connectWirelessNetworks"], ["src", "/assets/images/warning_icon.svg"], [1, "clickhere", 3, "click"], [1, "closeIcon", 3, "click"]], template: function SetupNotifyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SetupNotifyComponent_div_0_Template, 10, 0, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.isSetupConfigured && ctx.visible);
    } }, directives: [i1$2.NgIf], styles: [".connectWirelessNetworks[_ngcontent-%COMP%]{text-align:center;font-size:14px;padding:20px;background-color:#fff;border-bottom:2px solid #f6a623;height:60px;top:0;position:fixed;z-index:9999;width:100%;display:none;color:#000}.connectWirelessNetworks[_ngcontent-%COMP%]   .clickhere[_ngcontent-%COMP%]{color:#00bceb;cursor:pointer;font-family:ciscoSans}.connectWirelessNetworks[_ngcontent-%COMP%]   .closeIcon[_ngcontent-%COMP%]{position:absolute;right:30px;top:0;margin:23px 0;font-family:icomoon-new;color:#999;font-size:14px;cursor:pointer}.connectWirelessNetworks[_ngcontent-%COMP%]   #setupBanner[_ngcontent-%COMP%]{display:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SetupNotifyComponent, [{
        type: Component,
        args: [{
                selector: "lib-setup-notify",
                templateUrl: "./setup-notify.component.html",
                styleUrls: ["./setup-notify.component.scss"]
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: SetupPlatformAppService }]; }, null); })();

function NavigationHomeComponent_div_0_div_4_li_5_div_1_i_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 24);
} if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r10.calculateClass(node_r6.iconClassName));
} }
function NavigationHomeComponent_div_0_div_4_li_5_div_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵelement(1, "i", 26);
    i0.ɵɵelementEnd();
} }
const _c0$1b = function (a0, a1) { return { "notAllowed": a0, "activeNode": a1 }; };
const _c1$p = function (a0, a1) { return { "selected": a0, "disabled": a1 }; };
function NavigationHomeComponent_div_0_div_4_li_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵlistener("click", function NavigationHomeComponent_div_0_div_4_li_5_div_1_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r15); const node_r6 = i0.ɵɵnextContext().$implicit; const ctx_r13 = i0.ɵɵnextContext(3); return ctx_r13.navClicked(node_r6); });
    i0.ɵɵelementStart(2, "span", 20);
    i0.ɵɵtemplate(3, NavigationHomeComponent_div_0_div_4_li_5_div_1_i_3_Template, 1, 1, "i", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 22);
    i0.ɵɵtemplate(5, NavigationHomeComponent_div_0_div_4_li_5_div_1_span_5_Template, 2, 0, "span", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c0$1b, !node_r6.clickable, node_r6.clickable && node_r6.selected));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c1$p, node_r6.selected, !node_r6.clickable));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r6.iconClassName !== null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", node_r6.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r6.childNodes.length > 0);
} }
function NavigationHomeComponent_div_0_div_4_li_5_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 27);
} }
function NavigationHomeComponent_div_0_div_4_li_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, NavigationHomeComponent_div_0_div_4_li_5_div_1_Template, 6, 11, "div", 16);
    i0.ɵɵtemplate(2, NavigationHomeComponent_div_0_div_4_li_5_div_2_Template, 1, 0, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    i0.ɵɵclassMapInterpolate1("nav-li-", i_r7, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r6.type == "nav");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r6.type == "separator");
} }
function NavigationHomeComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵlistener("mouseover", function NavigationHomeComponent_div_0_div_4_Template_div_mouseover_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return ctx_r17.togglePanel(true); })("mouseout", function NavigationHomeComponent_div_0_div_4_Template_div_mouseout_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.togglePanel(false); });
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelement(2, "img", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵelementStart(4, "ul", 14);
    i0.ɵɵtemplate(5, NavigationHomeComponent_div_0_div_4_li_5_Template, 3, 5, "li", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r1.parent);
} }
function NavigationHomeComponent_div_0_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵlistener("click", function NavigationHomeComponent_div_0_div_5_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(3); return ctx_r22.dockNavigation(true); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵelement(2, "i", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 32);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 1, "shared-lib.navigation-home.pinMenu"));
} }
function NavigationHomeComponent_div_0_div_5_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.navigation-home.close"));
} }
function NavigationHomeComponent_div_0_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵlistener("click", function NavigationHomeComponent_div_0_div_5_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(3); return ctx_r25.dockNavigation(false); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵelement(2, "i", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, NavigationHomeComponent_div_0_div_5_div_2_span_3_Template, 3, 3, "span", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r21.dockHoverActive);
} }
function NavigationHomeComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, NavigationHomeComponent_div_0_div_5_div_1_Template, 6, 3, "div", 29);
    i0.ɵɵtemplate(2, NavigationHomeComponent_div_0_div_5_div_2_Template, 4, 1, "div", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isDocked);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isDocked);
} }
function NavigationHomeComponent_div_0_div_7_i_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 24);
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r27.calculateClass(ctx_r27.child.parent.iconClassName));
} }
function NavigationHomeComponent_div_0_div_7_li_11_div_2_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 24);
} if (rf & 2) {
    const node_r29 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r33.calculateClass(node_r29.iconClassName));
} }
function NavigationHomeComponent_div_0_div_7_li_11_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵelement(1, "i", 26);
    i0.ɵɵelementEnd();
} }
const _c2$h = function (a0, a1, a2) { return { "selected": a0, "disabled": a1, "create-new": a2 }; };
function NavigationHomeComponent_div_0_div_7_li_11_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function NavigationHomeComponent_div_0_div_7_li_11_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r38); const node_r29 = i0.ɵɵnextContext().$implicit; const ctx_r36 = i0.ɵɵnextContext(3); return ctx_r36.navClicked(node_r29); });
    i0.ɵɵelementStart(1, "span", 20);
    i0.ɵɵtemplate(2, NavigationHomeComponent_div_0_div_7_li_11_div_2_i_2_Template, 1, 1, "i", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 22);
    i0.ɵɵtemplate(4, NavigationHomeComponent_div_0_div_7_li_11_div_2_span_4_Template, 2, 0, "span", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r29 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(4, _c2$h, node_r29.selected, !node_r29.clickable, node_r29.dataNode && node_r29.dataNode["action"] && node_r29.dataNode["action"] === "create"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r29.iconClassName !== null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", node_r29.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r29.childNodes.length > 0);
} }
function NavigationHomeComponent_div_0_div_7_li_11_div_3_i_2_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 52);
    i0.ɵɵlistener("click", function NavigationHomeComponent_div_0_div_7_li_11_div_3_i_2_Template_i_click_0_listener() { i0.ɵɵrestoreView(_r44); const node_r29 = i0.ɵɵnextContext(2).$implicit; const ctx_r42 = i0.ɵɵnextContext(3); return ctx_r42.navClicked(node_r29); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r29 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r40.calculateClass(node_r29.iconClassName));
} }
function NavigationHomeComponent_div_0_div_7_li_11_div_3_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 53);
    i0.ɵɵlistener("click", function NavigationHomeComponent_div_0_div_7_li_11_div_3_span_4_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r48); const node_r29 = i0.ɵɵnextContext(2).$implicit; const ctx_r46 = i0.ɵɵnextContext(3); return ctx_r46.navClicked(node_r29); });
    i0.ɵɵelement(1, "i", 26);
    i0.ɵɵelementEnd();
} }
function NavigationHomeComponent_div_0_div_7_li_11_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelementStart(1, "span", 20);
    i0.ɵɵtemplate(2, NavigationHomeComponent_div_0_div_7_li_11_div_3_i_2_Template, 1, 1, "i", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 47);
    i0.ɵɵlistener("click", function NavigationHomeComponent_div_0_div_7_li_11_div_3_Template_div_click_3_listener() { i0.ɵɵrestoreView(_r51); const node_r29 = i0.ɵɵnextContext().$implicit; const ctx_r49 = i0.ɵɵnextContext(3); return ctx_r49.navClicked(node_r29); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NavigationHomeComponent_div_0_div_7_li_11_div_3_span_4_Template, 2, 0, "span", 48);
    i0.ɵɵelementStart(5, "span", 49);
    i0.ɵɵlistener("click", function NavigationHomeComponent_div_0_div_7_li_11_div_3_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r51); const node_r29 = i0.ɵɵnextContext().$implicit; const ctx_r52 = i0.ɵɵnextContext(3); return ctx_r52.navActionClicked(node_r29["dataNode"], "edit"); });
    i0.ɵɵelement(6, "img", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 49);
    i0.ɵɵlistener("click", function NavigationHomeComponent_div_0_div_7_li_11_div_3_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r51); const node_r29 = i0.ɵɵnextContext().$implicit; const ctx_r54 = i0.ɵɵnextContext(3); return ctx_r54.navActionClicked(node_r29["dataNode"], "delete"); });
    i0.ɵɵelement(8, "img", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r29 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c1$p, node_r29.selected || node_r29.dataNode["selected"], !node_r29.clickable));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r29.iconClassName !== null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", node_r29.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r29.childNodes.length > 0);
} }
function NavigationHomeComponent_div_0_div_7_li_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "div", 42);
    i0.ɵɵtemplate(2, NavigationHomeComponent_div_0_div_7_li_11_div_2_Template, 5, 8, "div", 43);
    i0.ɵɵtemplate(3, NavigationHomeComponent_div_0_div_7_li_11_div_3_Template, 9, 7, "div", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r29 = ctx.$implicit;
    const i_r30 = ctx.index;
    i0.ɵɵclassMapInterpolate1("nav-li-", i_r30, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c0$1b, !node_r29.clickable, node_r29.clickable && node_r29.selected));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !node_r29.dataNode || node_r29.dataNode && (!node_r29.dataNode["action"] || node_r29.dataNode["action"] !== "link"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r29["dataNode"] && node_r29.dataNode["action"] && node_r29.dataNode["action"] === "link");
} }
const _c3$b = function (a0) { return { "hideBlock": a0 }; };
function NavigationHomeComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵlistener("mouseover", function NavigationHomeComponent_div_0_div_7_Template_div_mouseover_0_listener() { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(2); return ctx_r57.togglePanel(true); })("mouseout", function NavigationHomeComponent_div_0_div_7_Template_div_mouseout_0_listener() { i0.ɵɵrestoreView(_r58); const ctx_r59 = i0.ɵɵnextContext(2); return ctx_r59.togglePanel(false); });
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵelementStart(2, "ul", 36);
    i0.ɵɵelementStart(3, "li", 37);
    i0.ɵɵlistener("click", function NavigationHomeComponent_div_0_div_7_Template_li_click_3_listener() { i0.ɵɵrestoreView(_r58); const ctx_r60 = i0.ɵɵnextContext(2); return ctx_r60.childClicked(); });
    i0.ɵɵelementStart(4, "div", 38);
    i0.ɵɵelementStart(5, "span", 20);
    i0.ɵɵtemplate(6, NavigationHomeComponent_div_0_div_7_i_6_Template, 1, 1, "i", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "div", 22);
    i0.ɵɵelementStart(8, "span", 39);
    i0.ɵɵelement(9, "i", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "ul", 41);
    i0.ɵɵtemplate(11, NavigationHomeComponent_div_0_div_7_li_11_Template, 4, 9, "li", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r3.child.parent.iconClassName !== null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", ctx_r3.child.parent.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3$b, ctx_r3.isDocked && !ctx_r3.dockHoverActive));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r3.child.data);
} }
function NavigationHomeComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵlistener("click", function NavigationHomeComponent_div_0_div_8_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(2); return ctx_r61.closeHamburger(); });
    i0.ɵɵelementEnd();
} }
const _c4$6 = function (a0, a1) { return [a0, a1]; };
function NavigationHomeComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "nav", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, NavigationHomeComponent_div_0_div_4_Template, 6, 1, "div", 5);
    i0.ɵɵtemplate(5, NavigationHomeComponent_div_0_div_5_Template, 3, 2, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtemplate(7, NavigationHomeComponent_div_0_div_7_Template, 12, 6, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, NavigationHomeComponent_div_0_div_8_Template, 1, 0, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c4$6, ctx_r0.isDocked ? "dockActive" : "dockInactive", ctx_r0.dockHoverActive ? "dockInactive" : "dockActive"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.renderLevel === "parent");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.renderLevel == "parent");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.renderLevel === "child");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isDocked);
} }
function getBaseUrl$6() {
    return document.getElementsByTagName("base")[0].href;
}
class NavigationHomeComponent {
    constructor(dataService, router, baseUrl) {
        this.dataService = dataService;
        this.router = router;
        this.unsubscribe$ = new Subject();
        this.licenseType = "";
        this.showLicenseAdoption = false;
        this.onNavigationChanged = new EventEmitter();
        this.atReportNavigationChange = new EventEmitter();
        this.child = {
            parent: null,
            data: []
        };
        this.visible = false;
        this.renderLevel = "parent";
        this.baseUrl = "/";
        this.prevChildNodeIndex = -1;
        this.dockHoverActive = false;
        this.getLicenseType = () => {
            this.dataService
                .getLicenseDetails(this.unsubscribe$)
                .subscribe((data) => {
                if (data && data.licenseType) {
                    this.licenseType = data.licenseType;
                }
            });
        };
        this.slideRight = () => {
            $("#navHandle").css({ transform: "translateX(-50%)" });
            $("#parentUl").removeClass("parentSlide");
            setTimeout(() => {
                $("#childUl").addClass("childSlide");
                setTimeout(() => {
                    $("#navChildWrapper").css({ opacity: 1 });
                }, 100);
            }, 5);
        };
        this.slideLeft = () => {
            $("#navHandle").css({ transform: "translateX(0)" });
            $("#childUl").removeClass("childSlide");
            setTimeout(() => {
                $("#navHeader").css({ transform: "translateX(0)" });
                $("#parentUl").addClass("parentSlide");
                setTimeout(() => {
                    $("#navParentWrapper").css({ opacity: 1 });
                }, 100);
            }, 5);
        };
        this.addTransitionDelay = () => {
            let arr;
            let el;
            let value = 0.0;
            if (this.renderLevel == "parent") {
                arr = this.parent;
                el = "#parentUl";
            }
            else {
                arr = this.child.data;
                el = "#childUl";
            }
            arr.forEach((e, i) => {
                value = value + 0.06;
                $(el + " .nav-li-" + i).css("transition-delay", value + "s");
            });
        };
        this.openNavSlider = (isVisible) => {
            const currentUrl = this.dataService.getCurrentNav();
            this.updateCurrentSelection(currentUrl);
            if (!isVisible) {
                this.visible = true;
                setTimeout(() => {
                    $("#navPanelHandle").css({ transform: "translateX(0)" });
                    this.addTransitionDelay();
                    this.renderLevel == "parent"
                        ? this.slideLeft()
                        : this.slideRight();
                }, 10);
            }
        };
        this.closeNavSlider = (isVisible) => {
            if (isVisible) {
                $("#navPanelHandle").css({ transform: "translateX(-300px)" });
                setTimeout(() => {
                    this.visible = false;
                }, 200);
            }
        };
        this.closeHamburger = () => {
            if (!this.isDocked || this.renderLevel == 'child') {
                this.dataService.navigation(false);
            }
        };
        this.removeDuplicates = (arr) => {
            const list = [];
            const aux = [];
            arr.map((e, i) => {
                const index = list.indexOf(e._id);
                if (index > -1) {
                    aux[index] = e;
                }
                else {
                    list.push(e._id);
                    aux.push(e);
                }
            });
            return aux;
        };
        this.calculateClass = (className) => {
            if (className == null) {
                return "cp-rule";
            }
            else {
                const type = className.split("-")[0];
                if (type != "icon") {
                    // to handle for custom images
                }
                else {
                    return className;
                }
            }
        };
        this.navClicked = (data) => {
            // to handle route based redirection
            if (data.childNodes && data.childNodes.length > 0) {
                this.child.data = data.childNodes;
                this.child.parent = data;
                this.renderLevel = "child";
                if (this.prevChildNodeIndex > -1 &&
                    this.prevChildNodeParentID != null &&
                    this.prevChildNodeParentID === this.child.parent._id) {
                    this.child.data[this.prevChildNodeIndex].selected = true;
                }
                setTimeout(() => {
                    this.addTransitionDelay();
                    this.slideRight();
                }, 10);
            }
            else {
                this.prevChildNodeIndex = -1;
                this.prevChildNodeParentID = null;
                this.currentNav = data.routeUrl;
                if (!this.isDocked) {
                    this.closeHamburger();
                }
                // this.dataService.setInStorage('isNavDocked', false);
                // this.dataService.setHamburgerBtnState(true);
                // this.adjustContainerLeft();
                if (data.routeUrl) {
                    this.dataService.setCurrentNav(this.currentNav);
                    window.history.pushState({}, data.label, this.baseUrl + this.currentNav.substring(1));
                    this.router.navigateByUrl(data.routeUrl);
                }
                else {
                    this.onNavigationChanged.emit(data.dataNode);
                }
            }
        };
        // code needs to be reviewed
        this.navActionClicked = (data, action) => {
            if (data && action) {
                if (action === "edit" || action === "delete") {
                    data["action"] = action;
                }
                else {
                    data["action"] = "link";
                }
                this.closeHamburger();
                this.onNavigationChanged.emit(data);
            }
        };
        this.childClicked = () => {
            if (this.child.data.length > 0) {
                const selectedNodeIndex = this.child.data.findIndex((obj) => obj.selected == true);
                selectedNodeIndex > -1
                    ? (this.child.data[selectedNodeIndex].selected = false)
                    : false;
                this.prevChildNodeIndex = selectedNodeIndex;
                this.prevChildNodeParentID = this.child.parent._id;
            }
            else {
                this.prevChildNodeIndex = -1;
                this.prevChildNodeParentID = null;
            }
            this.child.data = [];
            this.child.parent = null;
            this.renderLevel = "parent";
            setTimeout(() => {
                this.addTransitionDelay();
                this.slideLeft();
            }, 10);
        };
        this.updateCurrentSelection = (currentUrl) => {
            const arr = this.renderLevel == "parent" ? this.parent : this.child.data;
            const selectedNodeIndex = this.parent.findIndex((obj) => obj.selected == true);
            selectedNodeIndex > -1
                ? (this.parent[selectedNodeIndex].selected = false)
                : false;
            if (this.child.data && this.child.data.length > 0) {
                const selectedChildNodeIndex = this.child.data.findIndex((obj) => obj.selected == true);
                selectedChildNodeIndex > -1
                    ? (this.child.data[selectedChildNodeIndex].selected = false)
                    : false;
            }
            arr.forEach((e) => {
                if (e.routeUrl != null) {
                    if (e.routeUrl.endsWith(currentUrl)) {
                        e.selected = true;
                    }
                    else {
                        e.selected = false;
                    }
                }
                else if (e.childNodes.length > 0) {
                    const childArr = e.childNodes;
                    childArr.forEach((c) => {
                        if (c.routeUrl.endsWith(currentUrl)) {
                            this.child.data = childArr;
                            c.selected = true;
                            this.child.parent = e;
                            this.renderLevel = "child";
                        }
                    });
                }
            });
        };
        this.dockNavigation = (state) => {
            this.isDocked = state;
            if (state) {
                this.adjustContainerRight();
                this.dataService.setHamburgerBtnState(false);
                this.dataService.setInStorage('isNavDocked', true);
            }
            else {
                this.adjustContainerLeft();
                this.closeHamburger();
                this.dataService.setHamburgerBtnState(true);
                this.dataService.setInStorage('isNavDocked', false);
            }
        };
        this.adjustContainerRight = () => {
            $('#appContainer').css('margin-left', '4%');
            $('#spacesHeader').css('width', '96%');
            setTimeout(() => {
                $('#navPanelHandle').css('width', 'inherit');
            }, 100);
        };
        this.adjustContainerLeft = () => {
            $('#appContainer').css('margin-left', '0');
            $('#spacesHeader').css('width', '100%');
            setTimeout(() => {
                $('#navPanelHandle').css('width', '100%');
            }, 100);
        };
        this.togglePanel = (state) => {
            if (this.isDocked) {
                this.dockHoverActive = state;
            }
        };
        this.onCloseLicensePopup = () => {
            this.showLicenseAdoption = false;
        };
        this.baseUrl = baseUrl;
    }
    ngOnInit() {
        const state = this.dataService.getFromStorage('isNavDocked');
        const isNavDocked = (/true/i).test(state);
        if (isNavDocked) {
            this.dockNavigation(true);
        }
        this.dataService
            .getHamburgerState(this.unsubscribe$)
            .subscribe((navObject) => {
            navObject.show === true
                ? this.openNavSlider(!navObject.show)
                : this.closeNavSlider(!navObject.show);
        });
        this.getLicenseType();
    }
    ngOnChanges(changes) {
        // after adding the updated node to config array, reassign the same array in parent component for the changes to get reflected in hamburger component
        if (changes.config && changes.config.currentValue) {
            if (this.renderLevel == "parent") {
                this.parent = this.removeDuplicates(changes.config.currentValue);
            }
            else {
                changes.config.currentValue.forEach((el) => {
                    if (el._id == this.child.parent._id) {
                        this.child.data = el.childNodes;
                    }
                });
                this.parent = this.removeDuplicates(changes.config.currentValue);
            }
        }
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
NavigationHomeComponent.ɵfac = function NavigationHomeComponent_Factory(t) { return new (t || NavigationHomeComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject("BASE_URL")); };
NavigationHomeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NavigationHomeComponent, selectors: [["navigation-home"]], inputs: { config: "config" }, outputs: { onNavigationChanged: "onNavigationChanged", atReportNavigationChange: "atReportNavigationChange" }, features: [i0.ɵɵProvidersFeature([{ provide: "BASE_URL", useFactory: getBaseUrl$6 }]), i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "nav-panel", "id", "navPanelHandle", 3, "ngClass", 4, "ngIf"], ["id", "navPanelHandle", 1, "nav-panel", 3, "ngClass"], [1, "nav-left-panel"], ["id", "navHandle"], ["id", "leftNav", 1, "parent"], ["class", "nav-wrapper", "id", "navParentWrapper", 3, "mouseover", "mouseout", 4, "ngIf"], ["class", "footer", 4, "ngIf"], ["id", "rightNav", 1, "child"], ["class", "nav-wrapper", "id", "navChildWrapper", 3, "mouseover", "mouseout", 4, "ngIf"], ["class", "nav-right-panel", 3, "click", 4, "ngIf"], ["id", "navParentWrapper", 1, "nav-wrapper", 3, "mouseover", "mouseout"], ["id", "navHeader", 1, "nav-header"], ["src", "/assets/images/basic/nav/generic/logo_dnaspaces.svg", "width", "121", 1, "logo"], [1, "nav-main"], ["id", "parentUl", 1, "nav-list", "nav-parent-list"], [3, "class", 4, "ngFor", "ngForOf"], ["class", "nav-node-parent", 3, "ngClass", 4, "ngIf"], ["class", "separator", 4, "ngIf"], [1, "nav-node-parent", 3, "ngClass"], [1, "nav-node", 3, "ngClass", "click"], [1, "nav-icon"], [3, "ngClass", 4, "ngIf"], [1, "nav-item", 3, "innerHtml"], ["class", "nav-arrow", 4, "ngIf"], [3, "ngClass"], [1, "nav-arrow"], [1, "icon-arrow"], [1, "separator"], [1, "footer"], ["class", "dock-handle", 3, "click", 4, "ngIf"], [1, "dock-handle", 3, "click"], [1, "icon-dockarrow"], [1, "footer-text"], [1, "icon-close"], ["class", "footer-text", 4, "ngIf"], ["id", "navChildWrapper", 1, "nav-wrapper", 3, "mouseover", "mouseout"], [1, "nav-list", "nav-child-header"], [3, "click"], [1, "nav-node"], [1, "nav-arrow", 3, "ngClass"], [1, "icon-back"], ["id", "childUl", 1, "nav-list", "nav-child-list"], [1, "nav-node-child", 3, "ngClass"], ["class", "nav-node", 3, "ngClass", "click", 4, "ngIf"], ["class", "nav-node", 3, "ngClass", 4, "ngIf"], [1, "nav-node", 3, "ngClass"], [3, "ngClass", "click", 4, "ngIf"], [1, "nav-item", 3, "innerHtml", "click"], ["class", "nav-arrow", 3, "click", 4, "ngIf"], [1, "nav-arrow", "action-option", 3, "click"], ["src", "/assets/images/loc-analytics/edit_white.svg"], ["src", "/assets/images/loc-analytics/delete_white.svg"], [3, "ngClass", "click"], [1, "nav-arrow", 3, "click"], [1, "nav-right-panel", 3, "click"]], template: function NavigationHomeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NavigationHomeComponent_div_0_Template, 9, 8, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.visible);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i1$2.NgForOf], pipes: [i2.TranslatePipe], styles: ["@charset \"UTF-8\";@font-face{font-family:\"icomoon-nav\";src:url(/assets/fonts/icomoonnav/icomoon-nav.eot?64tqqn);src:url(/assets/fonts/icomoonnav/icomoon-nav.eot?64tqqn#iefix) format(\"embedded-opentype\"),url(/assets/fonts/icomoonnav/icomoon-nav.ttf?64tqqn) format(\"truetype\"),url(/assets/fonts/icomoonnav/icomoon-nav.woff?64tqqn) format(\"woff\"),url(/assets/fonts/icomoonnav/icomoon-nav.svg?64tqqn#icomoon-nav) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"icomoon\";src:url(/assets/fonts/icomoonconfigure/icomoon.eot?uaz206);src:url(/assets/fonts/icomoonconfigure/icomoon.eot?uaz206#iefix) format(\"embedded-opentype\"),url(/assets/fonts/icomoonconfigure/icomoon.ttf?uaz206) format(\"truetype\"),url(/assets/fonts/icomoonconfigure/icomoon.woff?uaz206) format(\"woff\"),url(/assets/fonts/icomoonconfigure/icomoon.svg?uaz206#icomoon) format(\"svg\");font-weight:normal;font-style:normal;font-display:block}i[_ngcontent-%COMP%]{font-family:\"icomoon-nav\"!important;speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-dockarrow[_ngcontent-%COMP%]:before{content:\"\\e901\";color:#9a9a9a;font-size:23px}.icon-report[_ngcontent-%COMP%]:before{content:\"\\e909\";color:#9a9a9a;font-size:20px}.icon-app_header[_ngcontent-%COMP%]:before{content:\"\\e90a\";color:#9a9a9a;font-size:17px}.icon-hamburger[_ngcontent-%COMP%]:before{content:\"\\e904\";color:#9a9a9a;font-size:20px}.icon-accesscode[_ngcontent-%COMP%]:before{content:\"\\e900\";color:#9a9a9a;font-size:30px}.icon-admin[_ngcontent-%COMP%]:before{content:\"\\e928\";color:#9a9a9a;font-size:30px}.icon-arrow[_ngcontent-%COMP%]:before{content:\"\\e906\";color:#9a9a9a;font-size:23px}.icon-back[_ngcontent-%COMP%]:before{content:\"\\e907\";color:#9a9a9a;font-size:30px}.icon-captive-portal[_ngcontent-%COMP%]:before{content:\"\\e914\";color:#9a9a9a;font-size:30px}.icon-close[_ngcontent-%COMP%]:before{content:\"\\e915\";color:#9a9a9a;font-size:23px;font-weight:bold}.icon-cp-rule[_ngcontent-%COMP%]:before{content:\"\\e916\";color:#9a9a9a;font-size:23px}.icon-delete[_ngcontent-%COMP%]:before{content:\"\\e919\";color:#9a9a9a;font-size:30px}.icon-engagement-rule[_ngcontent-%COMP%]:before{content:\"\\e91d\";color:#9a9a9a;font-size:30px}.icon-home[_ngcontent-%COMP%]:before{content:\"\\e91e\";color:#9a9a9a;font-size:30px}.icon-location[_ngcontent-%COMP%]:before{content:\"\\e91f\";color:#9a9a9a;font-size:23px}.icon-mobile-apps[_ngcontent-%COMP%]:before{content:\"\\e920\";color:#9a9a9a;font-size:23px}.icon-monitoring[_ngcontent-%COMP%]:before{content:\"\\e921\";color:#9a9a9a;font-size:23px}.icon-more[_ngcontent-%COMP%]:before{content:\"\\e923\";color:#9a9a9a;font-size:30px}.icon-profile-rule[_ngcontent-%COMP%]:before{content:\"\\e924\";color:#9a9a9a;font-size:30px}.icon-reports[_ngcontent-%COMP%]:before{content:\"\\e925\";color:#9a9a9a;font-size:30px}.icon-right-now[_ngcontent-%COMP%]:before{content:\"\\e926\";color:#9a9a9a;font-size:30px}.icon-settings[_ngcontent-%COMP%]:before{content:\"\\e927\";color:#9a9a9a;font-size:23px}.icon-user[_ngcontent-%COMP%]:before{content:\"\\e928\";color:#9a9a9a;font-size:17px}.icon-wifi[_ngcontent-%COMP%]:before{content:\"\\e929\";color:#9a9a9a;font-size:23px}.icon-camera[_ngcontent-%COMP%]:before{content:\"\\e902\";color:#9a9a9a;font-size:23px}.icon-edge-device[_ngcontent-%COMP%]:before{content:\"\\e905\";color:#9a9a9a;font-size:23px}.icon-integrations[_ngcontent-%COMP%]:before{content:\"\\e908\";color:#9a9a9a;font-size:30px}.icon-workspace-devices[_ngcontent-%COMP%]:before{content:\"\\e931\";color:#9a9a9a;font-size:30px}.icon-workspace-home[_ngcontent-%COMP%]:before{content:\"\\e932\";color:#9a9a9a;font-size:30px}.icon-workspace-management[_ngcontent-%COMP%]:before{content:\"\\e933\";color:#9a9a9a;font-size:30px}.icon-configure[_ngcontent-%COMP%]:before{content:\"\\e500\";color:#9a9a9a;font-size:21px;font-family:\"icomoon\"!important}.icon-density[_ngcontent-%COMP%]:before{content:\"\\e903\";color:#9a9a9a;font-size:23px}.icon-all-metrics[_ngcontent-%COMP%]:before{content:\"\\e949\";color:#9a9a9a;font-size:23px}.icon-history[_ngcontent-%COMP%]:before{content:\"\\e950\";color:#9a9a9a;font-size:23px}.icon-eu-app-icon[_ngcontent-%COMP%]:before{content:\"\\e951\";color:#9a9a9a;font-size:23px;font-size:30px}.icon-ambient[_ngcontent-%COMP%]:before{content:\"\\e944\";color:#9a9a9a;font-size:30px}.icon-tvoc[_ngcontent-%COMP%]:before{content:\"\\e945\";color:#9a9a9a;font-size:30px}.icon-temp[_ngcontent-%COMP%]:before{content:\"\\e946\";color:#9a9a9a;font-size:30px}.icon-humidity[_ngcontent-%COMP%]:before{content:\"\\e947\";color:#9a9a9a;font-size:30px}.icon-co2[_ngcontent-%COMP%]:before{content:\"\\e948\";color:#9a9a9a;font-size:30px}#navHandle[_ngcontent-%COMP%]{transition:transform .3s cubic-bezier(.4,0,.2,1)}#navHandle[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{transition:transform .5s ease-in-out}.nav-panel[_ngcontent-%COMP%]{height:100%;width:100%;position:fixed;top:0;left:0;display:flex;flex-direction:row;z-index:99999;transform:translate(-300px);transition:transform .3s cubic-bezier(.4,0,.2,1);will-change:transform}.nav-left-panel[_ngcontent-%COMP%]{height:100%;display:block;overflow:hidden;background:#3B3B3B;transition:transform 1s ease-in-out}.nav-right-panel[_ngcontent-%COMP%]{height:100%;width:81%}nav[_ngcontent-%COMP%]{box-shadow:6px 0 4px -5px #0000006e;height:100%;width:200%;transform:translate(0);display:flex}nav[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{flex:1;-webkit-box-flex:1;width:50%}.nav-wrapper[_ngcontent-%COMP%]{transition:opacity .5s ease-in-out;height:100%;opacity:0}.nav-wrapper[_ngcontent-%COMP%]   .nav-header[_ngcontent-%COMP%]{height:90px;width:100%;display:flex;justify-content:left;align-items:left;transform:translate(-16%)}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]{margin-top:10px}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-parent-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{opacity:0;transform:translate(-16%)}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-child-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{opacity:0;transform:translate(16%)}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]{margin:0;padding:0 0 0 13px}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{user-select:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;transition:transform .6s cubic-bezier(.7,0,.3,1),opacity .6s cubic-bezier(.7,0,.3,1);display:flex;flex-direction:column;padding:0 10px}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .nav-node[_ngcontent-%COMP%]{display:flex;flex-direction:row;width:95%;cursor:pointer}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .nav-node-parent[_ngcontent-%COMP%]{min-height:51px}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .nav-node-child[_ngcontent-%COMP%]{min-height:40px}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]{width:80%;display:flex;align-items:center;color:#b2b2b2;font-family:ciscoSansLight;font-weight:bold;font-size:15px;padding:0 5px 0 17px;letter-spacing:.5px;transition:color .5s}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:before{transition:color .5s}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .nav-arrow[_ngcontent-%COMP%]{display:flex;align-items:center}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .nav-arrow[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]:before{transition:color .5s}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .nav-arrow[_ngcontent-%COMP%]   .icon-arrow[_ngcontent-%COMP%]:before{font-size:15px}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .action-option[_ngcontent-%COMP%]{visibility:hidden}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .create-new[_ngcontent-%COMP%]{border-top:1px solid #adadad;padding-top:20px}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]{cursor:not-allowed!important;pointer-events:none!important;opacity:.5}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{pointer-events:none!important}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{pointer-events:none!important}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:hover:not(.disabled):not(.selected):not(.notAllowed):not(.activeNode)   .nav-item[_ngcontent-%COMP%]{color:#fff}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:hover:not(.disabled):not(.selected):not(.notAllowed):not(.activeNode)   .nav-icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:before{color:#fff}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:hover:not(.disabled):not(.selected):not(.notAllowed):not(.activeNode)   .nav-arrow[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:before{color:#fff}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:hover:not(.disabled):not(.selected):not(.notAllowed):not(.activeNode)   .action-option[_ngcontent-%COMP%]{visibility:visible}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .selected[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]{color:#07c1e4}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .selected[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:before{color:#07c1e4}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .selected[_ngcontent-%COMP%]   .nav-arrow[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:before{color:#07c1e4}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-child-list[_ngcontent-%COMP%]{padding-top:15px}.nav-wrapper[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]   ul.nav-child-header[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]{font-size:20px!important}.child[_ngcontent-%COMP%]   .nav-main[_ngcontent-%COMP%]{padding-top:15px}.parentSlide[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{transform:translate(0)!important;opacity:1!important}.childSlide[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{transform:translate(0)!important;opacity:1!important}.notAllowed[_ngcontent-%COMP%]{cursor:not-allowed!important}.activeNode[_ngcontent-%COMP%]{cursor:pointer!important}.dockActive[_ngcontent-%COMP%]   .nav-left-panel[_ngcontent-%COMP%]{width:78px}.dockActive[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]{visibility:hidden}.dockActive[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]{visibility:hidden}.dockActive[_ngcontent-%COMP%]   .nav-arrow[_ngcontent-%COMP%]{position:relative;right:28px;bottom:2px}.dockInactive[_ngcontent-%COMP%]   .nav-left-panel[_ngcontent-%COMP%]{width:300px}.dockInactive[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]{visibility:visible}.dockInactive[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]{visibility:visible}.dockInactive[_ngcontent-%COMP%]   .nav-arrow[_ngcontent-%COMP%]{position:relative;right:0;bottom:0}.footer[_ngcontent-%COMP%]{height:80px;width:300px;border-top:1px solid #4e4e4e;position:absolute;bottom:0;box-shadow:1px 0 2px 2px #252525}.footer[_ngcontent-%COMP%]   .dock-handle[_ngcontent-%COMP%]{display:flex;align-items:center;position:relative;left:25px;height:100%;width:100%}.footer[_ngcontent-%COMP%]   .dock-handle[_ngcontent-%COMP%]   .icon-dockarrow[_ngcontent-%COMP%]:before{transition:color .5s}.footer[_ngcontent-%COMP%]   .dock-handle[_ngcontent-%COMP%]   .icon-close[_ngcontent-%COMP%]:before{font-size:18px!important;transition:color .5s}.footer[_ngcontent-%COMP%]   .footer-text[_ngcontent-%COMP%]{color:#b2b2b2;font-family:ciscoSansLight;letter-spacing:.5px;padding-left:15px;transition:color .5s}.footer[_ngcontent-%COMP%]   .dock-handle[_ngcontent-%COMP%]:hover   .footer-text[_ngcontent-%COMP%]{color:#fff}.footer[_ngcontent-%COMP%]   .dock-handle[_ngcontent-%COMP%]:hover   .icon-dockarrow[_ngcontent-%COMP%]:before{color:#fff}.footer[_ngcontent-%COMP%]   .dock-handle[_ngcontent-%COMP%]:hover   .icon-close[_ngcontent-%COMP%]:before{color:#fff}.footer[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{cursor:pointer}.logo[_ngcontent-%COMP%]{position:relative;left:23px}.hamburger-icon[_ngcontent-%COMP%]{cursor:pointer;position:absolute;left:28px}.separator[_ngcontent-%COMP%]{position:relative;left:-22px;width:300px;margin-bottom:20px;border-bottom:1px solid #5d5c5c}.hideBlock[_ngcontent-%COMP%]{display:none!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationHomeComponent, [{
        type: Component,
        args: [{
                selector: "navigation-home",
                providers: [{ provide: "BASE_URL", useFactory: getBaseUrl$6 }],
                templateUrl: './navigation-home.component.html',
                styleUrls: ['./navigation-home.component.scss']
            }]
    }], function () { return [{ type: DataService }, { type: i1.Router }, { type: undefined, decorators: [{
                type: Inject,
                args: ["BASE_URL"]
            }] }]; }, { config: [{
            type: Input
        }], onNavigationChanged: [{
            type: Output
        }], atReportNavigationChange: [{
            type: Output
        }] }); })();

function LicenseInfoComponent_div_0_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1, " SEE ");
    i0.ɵɵelementEnd();
} }
function LicenseInfoComponent_div_0_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1, " ACT ");
    i0.ɵɵelementEnd();
} }
function LicenseInfoComponent_div_0_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1, " EXTEND ");
    i0.ɵɵelementEnd();
} }
function LicenseInfoComponent_div_0_span_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵtext(1, "Active until");
    i0.ɵɵelementEnd();
} }
function LicenseInfoComponent_div_0_span_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1, "Expiring soon on");
    i0.ɵɵelementEnd();
} }
function LicenseInfoComponent_div_0_span_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵtext(1, "License expired on");
    i0.ɵɵelementEnd();
} }
function LicenseInfoComponent_div_0_div_29_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r11.data.duration.years, " ", ctx_r11.data.duration.years === 1 ? "Year" : "Years", " ");
} }
function LicenseInfoComponent_div_0_div_29_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "&");
    i0.ɵɵelementEnd();
} }
function LicenseInfoComponent_div_0_div_29_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r13.data.duration.months, " ", ctx_r13.data.duration.months === 1 ? "Month" : "Months", " ");
} }
function LicenseInfoComponent_div_0_div_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "img", 25);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtemplate(3, LicenseInfoComponent_div_0_div_29_span_3_Template, 2, 2, "span", 26);
    i0.ɵɵtemplate(4, LicenseInfoComponent_div_0_div_29_span_4_Template, 2, 0, "span", 26);
    i0.ɵɵtemplate(5, LicenseInfoComponent_div_0_div_29_span_5_Template, 2, 2, "span", 26);
    i0.ɵɵtext(6, " license ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r7.data.duration.years !== 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.data.duration.months !== 0 && ctx_r7.data.duration.years > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.data.duration.months !== 0);
} }
function LicenseInfoComponent_div_0_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "div", 28);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵtext(3, " Your access will be blocked post license expiry. Contact support to renew license. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LicenseInfoComponent_div_0_div_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "div", 28);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵtext(3, " You have reached your AP limit. You cannot import new APs. Contact support to upgrade. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LicenseInfoComponent_div_0_div_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵtext(2, " For any enquiry please contact: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 32);
    i0.ɵɵelementStart(4, "a", 33);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate1("href", "mailto:", ctx_r10.supportMail, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r10.supportMail);
} }
function LicenseInfoComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtext(4, " License Information ");
    i0.ɵɵelementStart(5, "span", 5);
    i0.ɵɵlistener("click", function LicenseInfoComponent_div_0_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.closeWindow(); });
    i0.ɵɵtext(6, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, "\u00A0\u0330 ");
    i0.ɵɵelementStart(8, "div", 6);
    i0.ɵɵelementStart(9, "div", 7);
    i0.ɵɵelementStart(10, "div", 8);
    i0.ɵɵtext(11, "Account Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 9);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 10);
    i0.ɵɵelementStart(15, "div", 8);
    i0.ɵɵtext(16, "License Type");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, LicenseInfoComponent_div_0_div_17_Template, 2, 0, "div", 11);
    i0.ɵɵtemplate(18, LicenseInfoComponent_div_0_div_18_Template, 2, 0, "div", 11);
    i0.ɵɵtemplate(19, LicenseInfoComponent_div_0_div_19_Template, 2, 0, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 7);
    i0.ɵɵelementStart(21, "div", 8);
    i0.ɵɵtext(22, "License Validity");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 9);
    i0.ɵɵtemplate(24, LicenseInfoComponent_div_0_span_24_Template, 2, 0, "span", 12);
    i0.ɵɵtemplate(25, LicenseInfoComponent_div_0_span_25_Template, 2, 0, "span", 13);
    i0.ɵɵtemplate(26, LicenseInfoComponent_div_0_span_26_Template, 2, 0, "span", 14);
    i0.ɵɵelementStart(27, "span");
    i0.ɵɵtext(28);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(29, LicenseInfoComponent_div_0_div_29_Template, 7, 3, "div", 15);
    i0.ɵɵtemplate(30, LicenseInfoComponent_div_0_div_30_Template, 4, 0, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "div");
    i0.ɵɵelementStart(32, "div", 8);
    i0.ɵɵtext(33, "Access Points Limit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 9);
    i0.ɵɵelementStart(35, "span", 17);
    i0.ɵɵtext(36);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(37);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(38, "p-progressBar", 18);
    i0.ɵɵtemplate(39, LicenseInfoComponent_div_0_div_39_Template, 4, 0, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 19);
    i0.ɵɵtemplate(41, LicenseInfoComponent_div_0_div_41_Template, 6, 2, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(13);
    i0.ɵɵtextInterpolate(ctx_r0.data.accountName);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.data.licenseType === "Base Subscription");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.data.licenseType === "Advanced Subscription");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.data.licenseType === "Extend");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r0.data.warn.licenseStatus === "active");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.data.warn.licenseStatus === "soon");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.data.warn.licenseStatus === "expired");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.endDate, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.data.warn.licenseStatus === "soon");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.data.warn.licenseStatus === "soon");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("blockElement ", ctx_r0.progressBarClass, " hidden");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.data.consumedAps);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" out of ", ctx_r0.data.totalAps, " used ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("styleClass", ctx_r0.progressBarClass);
    i0.ɵɵproperty("value", ctx_r0.progressPercentage)("showValue", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.data.warn.apLimit === true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.supportMail !== undefined);
} }
class LicenseInfoComponent {
    constructor(dataService, authService) {
        this.dataService = dataService;
        this.authService = authService;
        this.unsubscribe$ = new Subject();
        this.close = new EventEmitter();
        this.progressBarClass = "p-bar";
        this.calculateProgressPercentage = () => {
            this.progressPercentage =
                (this.data.consumedAps / this.data.totalAps) * 100;
        };
        this.getLoginPageLinks = () => {
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$)
                .then((properties) => {
                this.supportMail = properties["value"]["supportMail"];
            });
        };
        this.closeWindow = () => {
            this.close.emit();
        };
    }
    ngOnInit() {
        console.log(this.data);
        this.getLoginPageLinks();
        this.calculateProgressPercentage();
        this.progressBarClass =
            this.data.warn.apLimit == true ? "p-bar-complete" : "p-bar";
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
LicenseInfoComponent.ɵfac = function LicenseInfoComponent_Factory(t) { return new (t || LicenseInfoComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(AuthService)); };
LicenseInfoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LicenseInfoComponent, selectors: [["app-license-info"]], inputs: { data: "data" }, outputs: { close: "close" }, decls: 1, vars: 1, consts: [["class", "modalPopup modalPopupSm licenseInfoPopup", 4, "ngIf"], [1, "modalPopup", "modalPopupSm", "licenseInfoPopup"], [1, "modalOverlay"], [1, "modalContent"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], [1, "blockElement"], [1, "blockHeader"], [1, "blockValue"], [1, "blockElement", "hidden"], ["class", "blockValue", 4, "ngIf"], ["class", "active-indicator", 4, "ngIf"], ["class", "expiry-indicator", 4, "ngIf"], ["class", "expired-indicator", 4, "ngIf"], ["class", "duration-block", 4, "ngIf"], ["class", "notice-block", 4, "ngIf"], [1, "bold-txt"], [3, "value", "showValue", "styleClass"], [1, "modalFooter"], ["class", "support-block", 4, "ngIf"], [1, "active-indicator"], [1, "expiry-indicator"], [1, "expired-indicator"], [1, "duration-block"], ["src", "/assets/cisco/images/dashboard/time_icon.svg", "width", "18"], [4, "ngIf"], [1, "notice-block"], [1, "notice-img"], [1, "notice-msg"], [1, "support-block"], [1, "support-message"], [1, "support-email"], [3, "href"]], template: function LicenseInfoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LicenseInfoComponent_div_0_Template, 42, 20, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.data);
    } }, directives: [i1$2.NgIf, i4$1.ProgressBar], styles: [".modalPopup.licenseInfoPopup[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.blockElement[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";border-bottom:1px solid #EAEAEA;padding:15px 0 0}.blockHeader[_ngcontent-%COMP%]{font-size:13px}.blockValue[_ngcontent-%COMP%]{font-size:16px;padding:10px 0;color:#000}.support-block[_ngcontent-%COMP%]{text-align:center;padding:20px}.support-message[_ngcontent-%COMP%]{font-size:12px}.support-email[_ngcontent-%COMP%]{font-size:13px;font-weight:bold}.modalFooter[_ngcontent-%COMP%]{line-height:20px}.modalPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{padding:10px 35px;min-height:360px;max-height:500px;overflow-y:auto;margin-bottom:50px}.active-indicator[_ngcontent-%COMP%]{color:#00b58e;font-family:ciscoSansBold;font-size:17px}.expiry-indicator[_ngcontent-%COMP%]{color:#f5a623;font-family:ciscoSansBold;font-size:17px}.expired-indicator[_ngcontent-%COMP%]{color:red;font-family:ciscoSansBold;font-size:17px}.duration-block[_ngcontent-%COMP%]{font-size:12px;color:#787878;padding-top:5px}.notice-block[_ngcontent-%COMP%]{background:#fffdf3;border:1px solid #FDDFAF;max-width:400px;padding:10px;margin:10px 0}.notice-img[_ngcontent-%COMP%]{width:10%;height:30px;float:left;background:url(/assets/images/error_icon.svg);background-size:20px;background-repeat:no-repeat;margin:0 5px}.notice-msg[_ngcontent-%COMP%]{font-size:12px;font-family:\"ciscoSansLight\"}.bold-txt[_ngcontent-%COMP%]{font-family:\"ciscoSansBold\"}[_nghost-%COMP%]     .ui-progressbar{border:1px solid #d9d9d9!important}.hidden[_ngcontent-%COMP%]{display:none!important}.modalPopup.modalPopupSm[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{width:400px!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LicenseInfoComponent, [{
        type: Component,
        args: [{
                selector: "app-license-info",
                templateUrl: "./license-info.component.html",
                styleUrls: ["./license-info.component.css"]
            }]
    }], function () { return [{ type: DataService }, { type: AuthService }]; }, { data: [{
            type: Input
        }], close: [{
            type: Output
        }] }); })();

function SupportSectionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "ul", 4);
    i0.ɵɵelementStart(2, "li", 5);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "li", 6);
    i0.ɵɵlistener("click", function SupportSectionComponent_div_1_Template_li_click_5_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.openLink(ctx_r2.data.supportLinkOneUrl); });
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵelement(7, "img", 8);
    i0.ɵɵelementStart(8, "a", 9);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "img", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "li", 6);
    i0.ɵɵlistener("click", function SupportSectionComponent_div_1_Template_li_click_12_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.openLink(ctx_r4.data.supportLinkTwoUrl); });
    i0.ɵɵelementStart(13, "div", 7);
    i0.ɵɵelement(14, "img", 11);
    i0.ɵɵelementStart(15, "a", 9);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(18, "img", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "li", 6);
    i0.ɵɵlistener("click", function SupportSectionComponent_div_1_Template_li_click_19_listener() { i0.ɵɵrestoreView(_r3); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.toggleSupport(); });
    i0.ɵɵelementStart(20, "div", 7);
    i0.ɵɵelement(21, "img", 12);
    i0.ɵɵelementStart(22, "span");
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "li");
    i0.ɵɵelement(26, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "li", 6);
    i0.ɵɵlistener("click", function SupportSectionComponent_div_1_Template_li_click_27_listener() { i0.ɵɵrestoreView(_r3); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.openLink(ctx_r6.data.supportLinkFourUrl); });
    i0.ɵɵelementStart(28, "div", 7);
    i0.ɵɵelement(29, "img", 14);
    i0.ɵɵelementStart(30, "span");
    i0.ɵɵtext(31);
    i0.ɵɵpipe(32, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(33, "img", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "li", 6);
    i0.ɵɵlistener("click", function SupportSectionComponent_div_1_Template_li_click_34_listener() { i0.ɵɵrestoreView(_r3); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.openLink(ctx_r7.data.supportLinkFiveUrl); });
    i0.ɵɵelementStart(35, "div", 7);
    i0.ɵɵelement(36, "img", 15);
    i0.ɵɵelementStart(37, "span");
    i0.ɵɵtext(38);
    i0.ɵɵpipe(39, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(40, "img", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, "shared-lib.support-section.ciscoDNASpacesSupport"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 8, "shared-lib.support-section.supportLinkOneLabel"));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 10, "shared-lib.support-section.supportLinkTwoLabel"));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 12, "shared-lib.support-section.supportLinkThreeLabel"));
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(32, 14, "shared-lib.support-section.supportLinkFourLabel"));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(39, 16, "shared-lib.support-section.supportLinkFiveLabel"));
} }
function SupportSectionComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "div", 17);
    i0.ɵɵelementStart(2, "div", 18);
    i0.ɵɵelementStart(3, "div", 19);
    i0.ɵɵelementStart(4, "div", 20);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 21);
    i0.ɵɵelementStart(8, "span", 22);
    i0.ɵɵlistener("click", function SupportSectionComponent_div_3_Template_span_click_8_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.toggleSupport(); });
    i0.ɵɵtext(9, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 23);
    i0.ɵɵelementStart(11, "p");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementStart(14, "a", 24);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 25);
    i0.ɵɵelementStart(18, "div", 26);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "ul", 27);
    i0.ɵɵelementStart(22, "li", 28);
    i0.ɵɵelement(23, "img", 29);
    i0.ɵɵelementStart(24, "div", 30);
    i0.ɵɵtext(25, "Phone");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "p");
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "a", 31);
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "a", 31);
    i0.ɵɵtext(32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "a", 24);
    i0.ɵɵtext(34);
    i0.ɵɵpipe(35, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "li", 32);
    i0.ɵɵtext(37);
    i0.ɵɵpipe(38, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "li", 28);
    i0.ɵɵelement(40, "img", 33);
    i0.ɵɵelementStart(41, "div", 30);
    i0.ɵɵtext(42, "Email");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "p");
    i0.ɵɵtext(44);
    i0.ɵɵpipe(45, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(46, "a", 31);
    i0.ɵɵtext(47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "a", 24);
    i0.ɵɵtext(49);
    i0.ɵɵpipe(50, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(51, "li", 32);
    i0.ɵɵtext(52);
    i0.ɵɵpipe(53, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(54, "li", 28);
    i0.ɵɵelement(55, "img", 34);
    i0.ɵɵelementStart(56, "div", 30);
    i0.ɵɵtext(57);
    i0.ɵɵpipe(58, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(59, "p");
    i0.ɵɵtext(60);
    i0.ɵɵpipe(61, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(62, "a", 24);
    i0.ɵɵtext(63);
    i0.ɵɵpipe(64, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(65, "a", 24);
    i0.ɵɵtext(66);
    i0.ɵɵpipe(67, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(68, "div", 35);
    i0.ɵɵelementStart(69, "span", 36);
    i0.ɵɵtext(70);
    i0.ɵɵpipe(71, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(72, "p");
    i0.ɵɵtext(73);
    i0.ɵɵpipe(74, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(75, "a", 31);
    i0.ɵɵtext(76);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 29, "shared-lib.support-section.support"));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 31, "shared-lib.support-section.subscriptionCharge"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r1.data.supportPopupNoticeUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 33, "shared-lib.support-section.subscriptionChargeClickHereKnow"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 35, "shared-lib.support-section.ciscoTechinicalAssist"), " ");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(28, 37, "shared-lib.support-section.callTac"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("href", "tel:", ctx_r1.data.supportPopupPhoneOne, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.data.supportPopupPhoneOne);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("href", "tel:", ctx_r1.data.supportPopupPhoneTwo, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.data.supportPopupPhoneTwo);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("href", ctx_r1.data.supportPopupPhoneKnowmore, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(35, 39, "shared-lib.support-section.knowMore"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(38, 41, "shared-lib.support-section.or"));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(45, 43, "shared-lib.support-section.sendEmail"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("href", "mailto:", ctx_r1.data.supportPopupEmailId, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.data.supportPopupEmailId);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("href", ctx_r1.data.supportPopupEmailKnowmoreUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(50, 45, "shared-lib.support-section.knowMore"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(53, 47, "shared-lib.support-section.or"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(58, 49, "shared-lib.support-section.raiseATicket"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(61, 51, "shared-lib.support-section.raiseATicketDesc"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r1.data.supportPopupTicketUrlOne, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(64, 53, "shared-lib.support-section.openACase"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r1.data.supportPopupTicketKnowmoreUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(67, 55, "shared-lib.support-section.knowMore"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(71, 57, "shared-lib.support-section.contactEmailOther"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(74, 59, "shared-lib.support-section.contactEmailOtherDesc"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("href", "mailto:", ctx_r1.data.supportPopupContactEmail, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.data.supportPopupContactEmail);
} }
class SupportSectionComponent {
    constructor(dataService, authService) {
        this.dataService = dataService;
        this.authService = authService;
        this.unsubscribe$ = new Subject();
        this.selectorVisible = true;
        this.popupVisible = false;
        this.toggleSupport = () => {
            this.popupVisible = !this.popupVisible;
        };
        this.openLink = ($link) => {
            this.selectorVisible = false;
            window.open($link, "_blank");
        };
        this.getProperties = () => {
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$)
                .then((properties) => {
                this.data = properties["value"];
            });
        };
    }
    ngOnInit() {
        this.getProperties();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
SupportSectionComponent.ɵfac = function SupportSectionComponent_Factory(t) { return new (t || SupportSectionComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(AuthService)); };
SupportSectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SupportSectionComponent, selectors: [["lib-support-section"]], decls: 4, vars: 2, consts: [[1, "tac-wrapper", "supportWrapper"], [4, "ngIf"], [1, "tac-mpopup"], ["class", "modalPopup", 4, "ngIf"], [1, "tac-spopup"], [1, "tac-spopup-header"], [1, "tac-spopup-item", 3, "click"], [1, "tac-spopup-item-wrapper"], ["src", "/assets/images/basic/support/help.svg", "width", "30", 1, "tac-spopup-item_icon"], ["href", "javascript:void(0)"], ["src", "/assets/images/basic/support/external_link.svg", "width", "13", 1, "tac-spopup-item_externalLink"], ["src", "/assets/images/basic/support/documentation.svg", "width", "30", 1, "tac-spopup-item_icon"], ["src", "/assets/images/basic/support/support.svg", "width", "30", 1, "tac-spopup-item_icon"], [1, "tac-spopup-seperator"], ["src", "/assets/images/basic/support/release_notes.svg", "width", "30", 1, "tac-spopup-item_icon"], ["src", "/assets/images/basic/support/release_notes_history.svg", "width", "30", 1, "tac-spopup-item_icon"], [1, "modalPopup"], [1, "modalOverlay"], [1, "modalContent"], [1, "tac-mpopup-header"], [1, "tac-mpopup-header_left"], [1, "tac-mpopup-header_right"], [1, "close-btn", 3, "click"], [1, "tac-mpopup-notice"], ["target", "_blank", 3, "href"], [1, "tac-mpopup-body"], [1, "tac-mpopup-body_header"], [1, "tac-mpopup-body_ul"], [1, "tac-mpopup-body_li"], ["src", "/assets/images/basic/support/phone.svg", "width", "50"], [1, "tac-mpopup-body_li_header"], [3, "href"], [1, "tac-mpopup-body_li_or"], ["src", "/assets/images/basic/support/email.svg", "width", "50"], ["src", "/assets/images/basic/support/ticket.svg", "width", "50"], [1, "tac-mpopup-body_footer"], [1, "tac-mpopup-body_footer_header"]], template: function SupportSectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, SupportSectionComponent_div_1_Template, 41, 18, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, SupportSectionComponent_div_3_Template, 77, 61, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectorVisible);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.popupVisible);
    } }, directives: [i1$2.NgIf], pipes: [i2.TranslatePipe], styles: [".tac-spopup[_ngcontent-%COMP%]:before{content:\"\";position:absolute;bottom:100%;right:0;width:45px;height:0;border-bottom:5px solid #049fd9}.tac-spopup[_ngcontent-%COMP%]{width:300px;padding:20px;background:#fff;z-index:999;position:absolute;left:calc(100% - 370px);top:60px;box-shadow:0 0 3px #85858580;color:#323b48;-webkit-user-select:none;user-select:none}.tac-spopup-header[_ngcontent-%COMP%]{text-align:center;font-size:18px;font-family:ciscoSans;padding-bottom:15px;margin-bottom:15px;border-bottom:1px solid #DFDFDF}.tac-spopup-item[_ngcontent-%COMP%]{padding:8px;font-family:ciscoSans;display:flex;cursor:pointer;transition:.2s linear}.tac-spopup-item_icon[_ngcontent-%COMP%]{padding-right:5px}.tac-spopup-item_externalLink[_ngcontent-%COMP%]{margin-left:8px}.tac-spopup-item[_ngcontent-%COMP%]:hover{background:#dfdfdf}.tac-spopup[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none;color:#323b48}.tac-spopup[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:none;color:#323b48}.tac-spopup-seperator[_ngcontent-%COMP%]{border-top:1px solid #ddd;margin:10px}.tac-mpopup[_ngcontent-%COMP%]   .modalPopup[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;top:0;left:0;z-index:99999;background:rgba(0,0,0,.5);overflow:auto}.tac-mpopup[_ngcontent-%COMP%]   .modalOverlay[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.7);z-index:99999}.tac-mpopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{z-index:999999;position:absolute;width:1280px;background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:4px;overflow:hidden;left:50%;top:5%}.tac-mpopup[_ngcontent-%COMP%]   .close-btn[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.tac-mpopup-header[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:20px;border-bottom:1px solid #b9b9b980}.tac-mpopup-header_left[_ngcontent-%COMP%]{width:80%;font-family:ciscoSans;font-size:20px;padding:0 20px}.tac-mpopup-body[_ngcontent-%COMP%]{padding:40px 0}.tac-mpopup-body[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#049fd9;font-size:15px;font-family:ciscoSans;padding:5px 0;text-decoration:none}.tac-mpopup-body[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:none;opacity:.8}.tac-mpopup-body_header[_ngcontent-%COMP%]{font-size:20px;font-family:ciscoSansLight;padding:0 130px;text-align:left}.tac-mpopup-body_ul[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:center}.tac-mpopup-body_li[_ngcontent-%COMP%]{min-height:400px;width:300px;border:1px solid #ddd;border-radius:5px;margin:0 30px;display:flex;justify-content:center;flex-direction:column;padding:30px}.tac-mpopup-body_li_header[_ngcontent-%COMP%]{font-size:20px;font-family:ciscoSansRegular;text-align:center}.tac-mpopup-body_li[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{display:flex;align-self:center;margin:20px}.tac-mpopup-body_li[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-family:ciscoSansLight}.tac-mpopup-body_li_or[_ngcontent-%COMP%]{display:flex;align-items:center;color:#000;font-family:ciscoSansLight}.tac-mpopup-body_footer[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:20px 130px}.tac-mpopup-body_footer[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-family:ciscoSansLight;font-size:19px}.tac-mpopup-notice[_ngcontent-%COMP%]{padding:10px 150px;background:#FAFAFA;font-size:15px;font-family:ciscoSansLight}.tac-mpopup-notice[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#049fd9;font-size:15px;font-family:ciscoSans;text-decoration:none}.tac-mpopup-notice[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:none;opacity:.8}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SupportSectionComponent, [{
        type: Component,
        args: [{
                selector: "lib-support-section",
                templateUrl: "./support-section.component.html",
                styleUrls: ["./support-section.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: AuthService }]; }, null); })();

// import { Location } from '@angular/common';
function NavigationUserInfoComponent_div_1_li_29_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 30);
    i0.ɵɵelement(1, "img", 38);
    i0.ɵɵelementStart(2, "div", 32);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_1_li_29_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.toggleLicenseInfo(); });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "shared-lib.navigation-user-info.licenseInformation"), " ");
} }
function NavigationUserInfoComponent_div_1_li_35_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 30);
    i0.ɵɵelement(1, "img", 38);
    i0.ɵɵelementStart(2, "div", 32);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_1_li_35_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.goToSmartLicesePopup(); });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "shared-lib.navigation-user-info.activateSmartLicense"));
} }
function NavigationUserInfoComponent_div_1_li_36_span_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r18.smartLicenseObj["licenseTag"]);
} }
function NavigationUserInfoComponent_div_1_li_36_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 30);
    i0.ɵɵelement(1, "img", 38);
    i0.ɵɵelementStart(2, "div", 39);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_1_li_36_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.goToSmartLicesePage(); });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 40);
    i0.ɵɵelementStart(6, "div", 41);
    i0.ɵɵelementStart(7, "div", 42);
    i0.ɵɵelementStart(8, "div", 43);
    i0.ɵɵelementStart(9, "div", 44);
    i0.ɵɵelementStart(10, "span", 45);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "br");
    i0.ɵɵelementStart(14, "span", 46);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵtemplate(17, NavigationUserInfoComponent_div_1_li_36_span_17_Template, 2, 1, "span", 3);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementStart(21, "a", 47);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r13.smartLicenseObj["enforceMode"] == "OutOfCompliance" ? "OutOfCompliance" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 9, "shared-lib.navigation-user-info.licenseInfo"));
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 11, "shared-lib.navigation-user-info.outOfCompliance"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 13, "shared-lib.navigation-user-info.outOfComplianceMsg"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.smartLicenseObj);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(19, 15, "shared-lib.navigation-user-info.outOfComplianceMsg00"), " ", i0.ɵɵpipeBind1(20, 17, "shared-lib.navigation-user-info.outOfComplianceMsg01"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 19, "shared-lib.navigation-user-info.outOfComplianceMsg02"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(25, 21, "shared-lib.navigation-user-info.outOfComplianceMsg03"), "");
} }
const _c0$1a = function (a0) { return { "signOutVisible": a0 }; };
function NavigationUserInfoComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵelementStart(3, "div", 18);
    i0.ɵɵelementStart(4, "div", 19);
    i0.ɵɵtext(5, "\uE930");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 20);
    i0.ɵɵelementStart(7, "span", 21);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 21);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 22);
    i0.ɵɵelementStart(12, "div", 23);
    i0.ɵɵelementStart(13, "div", 24);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 25);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(18, "div", 26);
    i0.ɵɵelementStart(19, "div", 27);
    i0.ɵɵelementStart(20, "div", 28);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_1_Template_div_click_20_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.viewLoginHistory(); });
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "ul", 29);
    i0.ɵɵelementStart(24, "li", 30);
    i0.ɵɵelement(25, "img", 31);
    i0.ɵɵelementStart(26, "div", 32);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_1_Template_div_click_26_listener() { i0.ɵɵrestoreView(_r22); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.showAccountPreferences(); });
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(29, NavigationUserInfoComponent_div_1_li_29_Template, 5, 3, "li", 33);
    i0.ɵɵelementStart(30, "li", 30);
    i0.ɵɵelement(31, "img", 34);
    i0.ɵɵelementStart(32, "div", 32);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_1_Template_div_click_32_listener() { i0.ɵɵrestoreView(_r22); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.goToChangeLogPage(); });
    i0.ɵɵtext(33);
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(35, NavigationUserInfoComponent_div_1_li_35_Template, 5, 3, "li", 33);
    i0.ɵɵtemplate(36, NavigationUserInfoComponent_div_1_li_36_Template, 26, 23, "li", 33);
    i0.ɵɵelementStart(37, "li", 35);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_1_Template_li_click_37_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.signOut($event); });
    i0.ɵɵelement(38, "img", 36);
    i0.ɵɵelementStart(39, "span", 37);
    i0.ɵɵtext(40);
    i0.ɵɵpipe(41, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c0$1a, ctx_r0.isSignOutVisible));
    i0.ɵɵadvance(7);
    i0.ɵɵpropertyInterpolate("title", ctx_r0.customerName);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.customerName);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", ctx_r0.getUserEmail());
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.getUserEmail());
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 14, "shared-lib.navigation-user-info.lastLogin"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.lastLogin);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(22, 16, "shared-lib.navigation-user-info.viewHistory"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(28, 18, "shared-lib.navigation-user-info.myAccount"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.smartLicenseEnableFeature && ctx_r0.isLicenseInfoReady && !ctx_r0.isAdminUser && ctx_r0.userRole !== "AccessCodeManager");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(34, 20, "shared-lib.navigation-user-info.viewChangeLog"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.smartLicenseEnableFeature && ctx_r0.userRole == "Admin" && !ctx_r0.isSmartLicenseRegistered);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.smartLicenseEnableFeature && ctx_r0.userRole == "Admin" && ctx_r0.isSmartLicenseRegistered);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(41, 22, "shared-lib.navigation-user-info.logout"));
} }
function NavigationUserInfoComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelementStart(1, "lib-change-password", 49);
    i0.ɵɵlistener("onHideChangePassword", function NavigationUserInfoComponent_div_2_Template_lib_change_password_onHideChangePassword_1_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.onHideChangePassword($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavigationUserInfoComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "app-license-info", 50);
    i0.ɵɵlistener("close", function NavigationUserInfoComponent_div_3_Template_app_license_info_close_1_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.toggleLicenseInfo(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", ctx_r2.licenseInfoData);
} }
function NavigationUserInfoComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "lib-support-section");
    i0.ɵɵelementEnd();
} }
function NavigationUserInfoComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelementStart(1, "div", 52);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_6_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.toggleAppSwitcher(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NavigationUserInfoComponent_ng_template_12_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 59);
} }
const _c1$o = function (a0) { return { "rotateDiv": a0 }; };
function NavigationUserInfoComponent_ng_template_12_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 60);
    i0.ɵɵtext(1, "\uE905");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1$o, ctx_r33.isSignOutVisible));
} }
function NavigationUserInfoComponent_ng_template_12_img_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 9);
} }
function NavigationUserInfoComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵelementStart(1, "div", 54);
    i0.ɵɵelementStart(2, "span", 55);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NavigationUserInfoComponent_ng_template_12_img_4_Template, 1, 0, "img", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, NavigationUserInfoComponent_ng_template_12_span_5_Template, 2, 3, "span", 57);
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtemplate(7, NavigationUserInfoComponent_ng_template_12_img_7_Template, 1, 0, "img", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", ctx_r6.getUserEmail());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r6.getUserEmail());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.licenseError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.licenseError);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.licenseError);
} }
function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 78);
} }
function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 79);
} }
function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 80);
} }
function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_5_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 85);
    i0.ɵɵelementStart(1, "span", 86);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_5_div_4_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r52); const ctx_r51 = i0.ɵɵnextContext(6); return ctx_r51.showMerakiPopupFn(true); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r48.merakiUserName);
} }
function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_5_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 87);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_5_div_5_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(6); return ctx_r53.showMerakiPopupFn(true); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "shared-lib.navigation-user-info.disconnected"));
} }
function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_5_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 88);
    i0.ɵɵelementStart(1, "span", 89);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "shared-lib.navigation-user-info.connected"));
} }
function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 81);
    i0.ɵɵelementStart(1, "a", 82);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_5_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(5); return ctx_r55.showMerakiPopupFn(true); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_5_div_4_Template, 3, 1, "div", 83);
    i0.ɵɵtemplate(5, NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_5_div_5_Template, 4, 3, "div", 3);
    i0.ɵɵtemplate(6, NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_5_div_6_Template, 4, 3, "div", 84);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "shared-lib.navigation-user-info.ciscoMeraki"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r44.merakiAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r44.merakiAuthenticated && !ctx_r44.merakiAPIAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r44.merakiAuthenticated && ctx_r44.merakiAPIAuthenticated);
} }
function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 90);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const network_r40 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", network_r40.name, " ");
} }
function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 90);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const network_r40 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", network_r40.name, " ");
} }
function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 91);
    i0.ɵɵelementStart(1, "div", 92);
    i0.ɵɵelement(2, "img", 93);
    i0.ɵɵelementStart(3, "div", 94);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 95);
    i0.ɵɵtext(6, "|");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 96);
    i0.ɵɵelement(8, "img", 97);
    i0.ɵɵelementStart(9, "div", 98);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const network_r40 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", network_r40.success, " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", network_r40.failed, " ");
} }
function NavigationUserInfoComponent_div_16_div_2_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 70);
    i0.ɵɵelementStart(1, "div", 71);
    i0.ɵɵtemplate(2, NavigationUserInfoComponent_div_16_div_2_div_1_div_4_img_2_Template, 1, 0, "img", 72);
    i0.ɵɵtemplate(3, NavigationUserInfoComponent_div_16_div_2_div_1_div_4_img_3_Template, 1, 0, "img", 73);
    i0.ɵɵtemplate(4, NavigationUserInfoComponent_div_16_div_2_div_1_div_4_img_4_Template, 1, 0, "img", 74);
    i0.ɵɵtemplate(5, NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_5_Template, 7, 6, "div", 75);
    i0.ɵɵtemplate(6, NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_6_Template, 2, 1, "div", 76);
    i0.ɵɵtemplate(7, NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_7_Template, 2, 1, "div", 76);
    i0.ɵɵtemplate(8, NavigationUserInfoComponent_div_16_div_2_div_1_div_4_div_8_Template, 11, 2, "div", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const network_r40 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", network_r40.name === "Cisco Meraki");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", network_r40.name === "CMX On Prem");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", network_r40.name === "Cisco AireOS Controller Direct Connect");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", network_r40.name === "Cisco Meraki");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", network_r40.name === "CMX On Prem");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", network_r40.name === "Cisco AireOS Controller Direct Connect");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", network_r40.success > 0 || network_r40.failed > 0);
} }
function NavigationUserInfoComponent_div_16_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "div", 66);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NavigationUserInfoComponent_div_16_div_2_div_1_div_4_Template, 9, 7, "div", 67);
    i0.ɵɵelementStart(5, "div", 68);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_16_div_2_div_1_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r61); const ctx_r60 = i0.ɵɵnextContext(3); return ctx_r60.toggleNetworkStatPopup(true); });
    i0.ɵɵelementStart(6, "a", 69);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 3, "shared-lib.navigation-user-info.wirelessNetworks"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r37.wpNetworkDetails.wirelessProvidersCount);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 5, "shared-lib.navigation-user-info.wirelessNetworkStatus"));
} }
function NavigationUserInfoComponent_div_16_div_2_div_2_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 101);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_16_div_2_div_2_div_11_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(4); return ctx_r65.showMerakiPopupFn(true); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r62 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r62.merakiUserName);
} }
function NavigationUserInfoComponent_div_16_div_2_div_2_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r68 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 87);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_16_div_2_div_2_div_12_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r68); const ctx_r67 = i0.ɵɵnextContext(4); return ctx_r67.showMerakiPopupFn(true); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "shared-lib.navigation-user-info.disconnected"));
} }
function NavigationUserInfoComponent_div_16_div_2_div_2_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 89);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "shared-lib.navigation-user-info.connected"));
} }
function NavigationUserInfoComponent_div_16_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 99);
    i0.ɵɵelementStart(1, "div", 66);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 70);
    i0.ɵɵelementStart(5, "div", 71);
    i0.ɵɵelement(6, "img", 78);
    i0.ɵɵelementStart(7, "div", 81);
    i0.ɵɵelementStart(8, "a", 82);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_16_div_2_div_2_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r70); const ctx_r69 = i0.ɵɵnextContext(3); return ctx_r69.showMerakiPopupFn(true); });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, NavigationUserInfoComponent_div_16_div_2_div_2_div_11_Template, 3, 1, "div", 3);
    i0.ɵɵtemplate(12, NavigationUserInfoComponent_div_16_div_2_div_2_div_12_Template, 4, 3, "div", 3);
    i0.ɵɵtemplate(13, NavigationUserInfoComponent_div_16_div_2_div_2_div_13_Template, 4, 3, "div", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 91);
    i0.ɵɵelementStart(15, "div", 92);
    i0.ɵɵelement(16, "img", 93);
    i0.ɵɵelementStart(17, "div", 94);
    i0.ɵɵtext(18, "0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "span", 95);
    i0.ɵɵtext(20, "|");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 96);
    i0.ɵɵelement(22, "img", 97);
    i0.ɵɵelementStart(23, "div", 98);
    i0.ɵɵtext(24, "0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 100);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_16_div_2_div_2_Template_div_click_25_listener() { i0.ɵɵrestoreView(_r70); const ctx_r71 = i0.ɵɵnextContext(3); return ctx_r71.toggleNetworkStatPopup(true); });
    i0.ɵɵelementStart(26, "a", 69);
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 6, "shared-lib.navigation-user-info.wirelessNetworks"), " ");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 8, "shared-lib.navigation-user-info.ciscoMeraki"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r38.merakiAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r38.merakiAuthenticated && !ctx_r38.merakiAPIAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r38.merakiAuthenticated && ctx_r38.merakiAPIAuthenticated);
    i0.ɵɵadvance(14);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(28, 10, "shared-lib.navigation-user-info.wirelessNetworkStatus"));
} }
function NavigationUserInfoComponent_div_16_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NavigationUserInfoComponent_div_16_div_2_div_1_Template, 9, 7, "div", 63);
    i0.ɵɵtemplate(2, NavigationUserInfoComponent_div_16_div_2_div_2_Template, 29, 12, "div", 64);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.wpNetworkDetails.wirelessProvidersCount.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.wpNetworkDetails.wirelessProvidersCount.length === 0);
} }
function NavigationUserInfoComponent_div_16_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 99);
    i0.ɵɵelementStart(2, "div", 66);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 70);
    i0.ɵɵelementStart(6, "div", 71);
    i0.ɵɵelement(7, "img", 78);
    i0.ɵɵelementStart(8, "div", 81);
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵelementStart(13, "span", 102);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 91);
    i0.ɵɵelementStart(17, "div", 103);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 100);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_16_div_3_Template_div_click_20_listener() { i0.ɵɵrestoreView(_r73); const ctx_r72 = i0.ɵɵnextContext(2); return ctx_r72.toggleNetworkStatPopup(true); });
    i0.ɵɵelementStart(21, "a", 69);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 5, "shared-lib.navigation-user-info.wirelessNetworks"), " ");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 7, "shared-lib.navigation-user-info.ciscoMeraki"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 9, "shared-lib.navigation-user-info.disconnected"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 11, "shared-lib.navigation-user-info.connecting"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 13, "shared-lib.navigation-user-info.wirelessNetworkStatus"));
} }
function NavigationUserInfoComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 61);
    i0.ɵɵelementStart(1, "div", 62);
    i0.ɵɵtemplate(2, NavigationUserInfoComponent_div_16_div_2_Template, 3, 2, "div", 3);
    i0.ɵɵtemplate(3, NavigationUserInfoComponent_div_16_div_3_Template, 24, 15, "div", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r7.disableStatus);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.disableStatus);
} }
function NavigationUserInfoComponent_div_17_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r82 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 121);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_17_div_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r82); const ctx_r81 = i0.ɵɵnextContext(2); return ctx_r81.goBackToConnectors(); });
    i0.ɵɵelement(1, "img", 122);
    i0.ɵɵelementEnd();
} }
function NavigationUserInfoComponent_div_17_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r84 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 123);
    i0.ɵɵelement(1, "img", 124);
    i0.ɵɵelementStart(2, "div", 125);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 126);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "ol", 127);
    i0.ɵɵelementStart(9, "li");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementStart(12, "a", 128);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_17_div_12_Template_a_click_12_listener() { i0.ɵɵrestoreView(_r84); const ctx_r83 = i0.ɵɵnextContext(2); return ctx_r83.navigateToLocation(); });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "li");
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "li");
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "li");
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "li");
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 129);
    i0.ɵɵelementStart(28, "a", 130);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_17_div_12_Template_a_click_28_listener() { i0.ɵɵrestoreView(_r84); const ctx_r85 = i0.ɵɵnextContext(2); return ctx_r85.navigateToLocation(); });
    i0.ɵɵtext(29);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 9, "shared-lib.navigation-user-info.noNetworksConfigured"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 11, "shared-lib.navigation-user-info.noNetworksConfiguredMessage"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 13, "shared-lib.navigation-user-info.manageLocationSteps00"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 15, "shared-lib.navigation-user-info.manageLocation"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 17, "shared-lib.navigation-user-info.manageLocationSteps01"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 19, "shared-lib.navigation-user-info.manageLocationSteps02"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 21, "shared-lib.navigation-user-info.manageLocationSteps03"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 23, "shared-lib.navigation-user-info.manageLocationSteps04"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(30, 25, "shared-lib.navigation-user-info.gotoManageLocation"), "");
} }
function NavigationUserInfoComponent_div_17_div_16_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r90 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 132);
    i0.ɵɵelementStart(1, "div", 133);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_17_div_16_div_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r90); const network1_r87 = restoredCtx.$implicit; const ctx_r89 = i0.ɵɵnextContext(3); return ctx_r89.changeSelectedNetwork(network1_r87.name); });
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const network1_r87 = ctx.$implicit;
    const ctx_r86 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r86.activeNetworkName === network1_r87.name ? "active-network" : "default-network");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(network1_r87.name);
} }
function NavigationUserInfoComponent_div_17_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NavigationUserInfoComponent_div_17_div_16_div_1_Template, 5, 2, "div", 131);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r76 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r76.wpNetworkDetails.wirelessProvidersCount);
} }
function NavigationUserInfoComponent_div_17_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r92 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 117);
    i0.ɵɵelementStart(1, "div", 134);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_17_div_17_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r92); const ctx_r91 = i0.ɵɵnextContext(2); return ctx_r91.selectCMXConnector(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r77 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r77.activeNetworkName === "connector" ? "active-network" : "default-network");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r77.dashboardSetupName, " ", i0.ɵɵpipeBind1(3, 3, "shared-lib.navigation-user-info.connectors"), " ");
} }
function NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_2_img_1_Template(rf, ctx) { if (rf & 1) {
    const _r108 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 158);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_2_img_1_Template_img_click_0_listener() { i0.ɵɵrestoreView(_r108); const n_r97 = i0.ɵɵnextContext(2).index; const ctx_r106 = i0.ɵɵnextContext(4); return ctx_r106.expandOrganizationNode(n_r97); });
    i0.ɵɵelementEnd();
} }
function NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_2_img_2_Template(rf, ctx) { if (rf & 1) {
    const _r111 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 159);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_2_img_2_Template_img_click_0_listener() { i0.ɵɵrestoreView(_r111); const n_r97 = i0.ɵɵnextContext(2).index; const ctx_r109 = i0.ɵɵnextContext(4); return ctx_r109.collapseOrganizationNode(n_r97); });
    i0.ɵɵelementEnd();
} }
function NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 155);
    i0.ɵɵtemplate(1, NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_2_img_1_Template, 1, 0, "img", 156);
    i0.ɵɵtemplate(2, NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_2_img_2_Template, 1, 0, "img", 157);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r98 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r98.expandIconState);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r98.expandIconState);
} }
function NavigationUserInfoComponent_div_17_div_22_div_1_li_15_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 160);
} }
function NavigationUserInfoComponent_div_17_div_22_div_1_li_15_img_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 79);
} }
function NavigationUserInfoComponent_div_17_div_22_div_1_li_15_img_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 80);
} }
function NavigationUserInfoComponent_div_17_div_22_div_1_li_15_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 161);
    i0.ɵɵelement(1, "img", 162);
    i0.ɵɵelementEnd();
} }
function NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_14_li_2_img_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 171);
} }
function NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_14_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 166);
    i0.ɵɵtemplate(1, NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_14_li_2_img_1_Template, 1, 0, "img", 167);
    i0.ɵɵelementStart(2, "div", 168);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 169);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 152);
    i0.ɵɵelement(7, "span", 170);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const networkInfo_r113 = ctx.$implicit;
    const networkStatus_r94 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", networkStatus_r94.name === "Cisco Meraki");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", networkInfo_r113.locationName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", networkInfo_r113.errorMessage, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", networkInfo_r113.errorMessage ? "netStat-failure" : "netStat-success");
} }
function NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 163);
    i0.ɵɵelementStart(1, "ul", 164);
    i0.ɵɵtemplate(2, NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_14_li_2_Template, 8, 4, "li", 165);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r116 = i0.ɵɵnextContext();
    const n_r97 = ctx_r116.index;
    const location_r96 = ctx_r116.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "innerNetworkUl_", n_r97, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", location_r96.networks);
} }
function NavigationUserInfoComponent_div_17_div_22_div_1_li_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 144);
    i0.ɵɵelementStart(1, "div", 145);
    i0.ɵɵtemplate(2, NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_2_Template, 3, 2, "div", 146);
    i0.ɵɵelementStart(3, "div", 147);
    i0.ɵɵtemplate(4, NavigationUserInfoComponent_div_17_div_22_div_1_li_15_img_4_Template, 1, 0, "img", 148);
    i0.ɵɵtemplate(5, NavigationUserInfoComponent_div_17_div_22_div_1_li_15_img_5_Template, 1, 0, "img", 73);
    i0.ɵɵtemplate(6, NavigationUserInfoComponent_div_17_div_22_div_1_li_15_img_6_Template, 1, 0, "img", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 149);
    i0.ɵɵtext(8);
    i0.ɵɵtemplate(9, NavigationUserInfoComponent_div_17_div_22_div_1_li_15_span_9_Template, 2, 0, "span", 150);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 151);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 152);
    i0.ɵɵelement(13, "span", 153);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, NavigationUserInfoComponent_div_17_div_22_div_1_li_15_div_14_Template, 3, 2, "div", 154);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const location_r96 = ctx.$implicit;
    const n_r97 = ctx.index;
    const networkStatus_r94 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "org_", n_r97, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", networkStatus_r94.name === "Cisco Meraki");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", networkStatus_r94.name === "Cisco Meraki");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", networkStatus_r94.name === "CMX On Prem");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", networkStatus_r94.name === "Cisco AireOS Controller Direct Connect");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", location_r96.locationName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", networkStatus_r94.name === "Cisco Meraki" && location_r96.useAPI);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", networkStatus_r94.name === "Cisco Meraki" ? "errorWidth" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", location_r96.errorMessage, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", location_r96.errorMessage ? "netStat-failure" : "netStat-success");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", networkStatus_r94.name === "Cisco Meraki" && location_r96.networks.length > 0);
} }
function NavigationUserInfoComponent_div_17_div_22_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 137);
    i0.ɵɵelementStart(1, "div", 138);
    i0.ɵɵelementStart(2, "div", 139);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "span", 140);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementStart(11, "span", 140);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 141);
    i0.ɵɵelementStart(14, "ul", 142);
    i0.ɵɵtemplate(15, NavigationUserInfoComponent_div_17_div_22_div_1_li_15_Template, 15, 11, "li", 143);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const networkStatus_r94 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 5, "shared-lib.navigation-user-info.wirelessNetwork"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", networkStatus_r94.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 7, "shared-lib.navigation-user-info.status"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", networkStatus_r94.syncStatus, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", networkStatus_r94.data);
} }
function NavigationUserInfoComponent_div_17_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 135);
    i0.ɵɵtemplate(1, NavigationUserInfoComponent_div_17_div_22_div_1_Template, 16, 9, "div", 136);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r78 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r78.wpNetworkDetails.locationSyncNotificationsList);
} }
function NavigationUserInfoComponent_div_17_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r119 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 172);
    i0.ɵɵelementStart(1, "app-cmx-connector", 173);
    i0.ɵɵlistener("showControllers", function NavigationUserInfoComponent_div_17_div_23_Template_app_cmx_connector_showControllers_1_listener() { i0.ɵɵrestoreView(_r119); const ctx_r118 = i0.ɵɵnextContext(2); return ctx_r118.showControllers(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("userRole", ctx_r79.userRole)("showConnectorsUpdate", ctx_r79.showConnectors);
} }
function NavigationUserInfoComponent_div_17_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 172);
    i0.ɵɵelement(1, "app-cisco-cmx", 174);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r80 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("userRole", ctx_r80.userRole);
} }
function NavigationUserInfoComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r121 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 104);
    i0.ɵɵelement(2, "div", 105);
    i0.ɵɵelementStart(3, "div", 106);
    i0.ɵɵelementStart(4, "div", 107);
    i0.ɵɵelementStart(5, "div", 108);
    i0.ɵɵtemplate(6, NavigationUserInfoComponent_div_17_div_6_Template, 2, 0, "div", 109);
    i0.ɵɵelementStart(7, "div", 108);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 110);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_17_Template_span_click_9_listener() { i0.ɵɵrestoreView(_r121); const ctx_r120 = i0.ɵɵnextContext(); return ctx_r120.toggleNetworkStatPopup(false); });
    i0.ɵɵtext(10, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 111);
    i0.ɵɵtemplate(12, NavigationUserInfoComponent_div_17_div_12_Template, 31, 27, "div", 112);
    i0.ɵɵelementStart(13, "div", 113);
    i0.ɵɵelementStart(14, "div", 114);
    i0.ɵɵelementStart(15, "div", 115);
    i0.ɵɵtemplate(16, NavigationUserInfoComponent_div_17_div_16_Template, 2, 1, "div", 3);
    i0.ɵɵtemplate(17, NavigationUserInfoComponent_div_17_div_17_Template, 4, 5, "div", 116);
    i0.ɵɵelementStart(18, "div", 117);
    i0.ɵɵelementStart(19, "div", 118);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_17_Template_div_click_19_listener() { i0.ɵɵrestoreView(_r121); const ctx_r122 = i0.ɵɵnextContext(); return ctx_r122.selectCMXOnPrem(); });
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, NavigationUserInfoComponent_div_17_div_22_Template, 2, 1, "div", 119);
    i0.ɵɵtemplate(23, NavigationUserInfoComponent_div_17_div_23_Template, 2, 2, "div", 120);
    i0.ɵɵtemplate(24, NavigationUserInfoComponent_div_17_div_24_Template, 2, 1, "div", 120);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r8.networkStatusHeader === "Controllers");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r8.networkStatusHeader);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r8.showCMXConnector === false && ctx_r8.showCMXOnPrem === true && ctx_r8.wpNetworkDetails.wirelessProvidersCount.length === 0);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r8.wpNetworkDetails.wirelessProvidersCount.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.displayCMXConnector === true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r8.activeNetworkName === "cmxOnPrem" ? "active-network" : "default-network");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r8.dashboardSetupName, " ", i0.ɵɵpipeBind1(21, 11, "shared-lib.navigation-user-info.ciscoCMX"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.showCMXConnector === false && ctx_r8.showCMXOnPrem === false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.displayCMXConnectorContent === true && ctx_r8.showCMXConnector === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.showCMXOnPrem === true);
} }
function NavigationUserInfoComponent_div_18_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 185);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r125 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r125.merakiFormError, " ");
} }
function NavigationUserInfoComponent_div_18_div_3_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h4", 186);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 187);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "shared-lib.navigation-user-info.unableToConnectMeraki"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "shared-lib.navigation-user-info.unableToConnectMerakiPasswordIssue"), " ");
} }
function NavigationUserInfoComponent_div_18_div_3_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 188);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 189);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "shared-lib.navigation-user-info.unableToConnectMerakiAllowCiscoAccount"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "shared-lib.navigation-user-info.unableToConnectMerakiCiscoAccountInfo"), " ");
} }
function NavigationUserInfoComponent_div_18_div_3_div_13_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r133 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 197);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_18_div_3_div_13_div_8_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r133); const ctx_r132 = i0.ɵɵnextContext(4); return ctx_r132.doMerakiAuthentication(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared-lib.navigation-user-info.connectAccount"), " ");
} }
function NavigationUserInfoComponent_div_18_div_3_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r135 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 190);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵelement(2, "input", 191);
    i0.ɵɵelementStart(3, "input", 192);
    i0.ɵɵlistener("ngModelChange", function NavigationUserInfoComponent_div_18_div_3_div_13_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r134 = i0.ɵɵnextContext(3); return ctx_r134.merakiFormData.userName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵelement(5, "input", 193);
    i0.ɵɵelementStart(6, "input", 194);
    i0.ɵɵlistener("ngModelChange", function NavigationUserInfoComponent_div_18_div_3_div_13_Template_input_ngModelChange_6_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r136 = i0.ɵɵnextContext(3); return ctx_r136.merakiFormData.password = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "p");
    i0.ɵɵtemplate(8, NavigationUserInfoComponent_div_18_div_3_div_13_div_8_Template, 3, 3, "div", 195);
    i0.ɵɵelementStart(9, "div", 196);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_18_div_3_div_13_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r135); const ctx_r137 = i0.ɵɵnextContext(3); return ctx_r137.showMerakiPopupFn(false); });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "p");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r128 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r128.merakiFormData.userName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r128.merakiFormData.password);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r128.isUserRoleAvailable && ctx_r128.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 4, "shared-lib.navigation-user-info.cancel"), " ");
} }
function NavigationUserInfoComponent_div_18_div_3_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r139 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 198);
    i0.ɵɵelementStart(1, "label", 199);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 200);
    i0.ɵɵelement(4, "img", 201);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 202);
    i0.ɵɵelementStart(8, "button", 203);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_18_div_3_div_14_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r139); const ctx_r138 = i0.ɵɵnextContext(3); return ctx_r138.disconnectFromMeraki(); });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r129 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r129.merakiUserName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(6, 3, "shared-lib.navigation-user-info.isConnected"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 5, "shared-lib.navigation-user-info.disconnected"), " ");
} }
function NavigationUserInfoComponent_div_18_div_3_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r141 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 204);
    i0.ɵɵelementStart(1, "a", 82);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_18_div_3_div_15_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r141); const ctx_r140 = i0.ɵɵnextContext(3); return ctx_r140.showRemoveMerakiFormFn(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "shared-lib.navigation-user-info.clickHere"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 4, "shared-lib.navigation-user-info.toRemoveCredentials"), " Spaces. ");
} }
function NavigationUserInfoComponent_div_18_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r143 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 177);
    i0.ɵɵelementStart(1, "div", 107);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "span", 110);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_18_div_3_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r143); const ctx_r142 = i0.ɵɵnextContext(2); return ctx_r142.showMerakiPopupFn(false); });
    i0.ɵɵtext(5, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 42);
    i0.ɵɵtemplate(7, NavigationUserInfoComponent_div_18_div_3_div_7_Template, 2, 1, "div", 178);
    i0.ɵɵelementStart(8, "div", 179);
    i0.ɵɵelement(9, "img", 180);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, NavigationUserInfoComponent_div_18_div_3_div_10_Template, 7, 6, "div", 3);
    i0.ɵɵtemplate(11, NavigationUserInfoComponent_div_18_div_3_div_11_Template, 7, 6, "div", 3);
    i0.ɵɵelementStart(12, "form", 181);
    i0.ɵɵtemplate(13, NavigationUserInfoComponent_div_18_div_3_div_13_Template, 13, 6, "div", 182);
    i0.ɵɵtemplate(14, NavigationUserInfoComponent_div_18_div_3_div_14_Template, 11, 7, "div", 183);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, NavigationUserInfoComponent_div_18_div_3_div_15_Template, 6, 6, "div", 184);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r123 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 7, "shared-lib.navigation-user-info.ciscoMerakiAccountSettings"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r123.merakiFormError !== "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r123.isShowRemoveLabel());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r123.isShowRemoveLabel());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r123.merakiAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r123.merakiAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r123.isShowRemoveLabel());
} }
function NavigationUserInfoComponent_div_18_div_4_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 185);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r146 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r146.merakiFormError, " ");
} }
function NavigationUserInfoComponent_div_18_div_4_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r148 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 210);
    i0.ɵɵtemplate(1, NavigationUserInfoComponent_div_18_div_4_div_9_div_1_Template, 2, 1, "div", 178);
    i0.ɵɵelementStart(2, "div", 211);
    i0.ɵɵelement(3, "img", 212);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 213);
    i0.ɵɵelementStart(5, "h4");
    i0.ɵɵtext(6, "Are you sure you want to remove");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "h4", 214);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "h5");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 215);
    i0.ɵɵelementStart(13, "button", 216);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_18_div_4_div_9_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r148); const ctx_r147 = i0.ɵɵnextContext(3); return ctx_r147.removeFromMerakiFn(); });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 215);
    i0.ɵɵelementStart(17, "button", 217);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_18_div_4_div_9_Template_button_click_17_listener() { i0.ɵɵrestoreView(_r148); const ctx_r149 = i0.ɵɵnextContext(3); return ctx_r149.hideRemoveMerakiFormFn(); });
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r144 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r144.merakiFormError !== "");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" \"", ctx_r144.userNameToRemove, "\" ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 5, "shared-lib.navigation-user-info.networksWillStopSyncing"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 7, "shared-lib.navigation-user-info.confirm"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 9, "shared-lib.navigation-user-info.cancel"), " ");
} }
function NavigationUserInfoComponent_div_18_div_4_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r151 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 218);
    i0.ɵɵelementStart(1, "div", 219);
    i0.ɵɵelement(2, "img", 220);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 221);
    i0.ɵɵelementStart(4, "h4");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "h5");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 215);
    i0.ɵɵelementStart(10, "button", 216);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_18_div_4_div_10_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r151); const ctx_r150 = i0.ɵɵnextContext(3); return ctx_r150.hideRemoveMerakiFormFn(); });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r145 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("\"", ctx_r145.removedMerakiUsername, "\"");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 3, "shared-lib.navigation-user-info.removedSuccess"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 5, "shared-lib.navigation-user-info.continue"), " ");
} }
function NavigationUserInfoComponent_div_18_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r153 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 205);
    i0.ɵɵelementStart(1, "div", 107);
    i0.ɵɵelementStart(2, "span", 206);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_18_div_4_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r153); const ctx_r152 = i0.ɵɵnextContext(2); return ctx_r152.hideRemoveMerakiFormFn(); });
    i0.ɵɵelement(3, "img", 207);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "span", 110);
    i0.ɵɵlistener("click", function NavigationUserInfoComponent_div_18_div_4_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r153); const ctx_r154 = i0.ɵɵnextContext(2); return ctx_r154.showMerakiPopupFn(false); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 42);
    i0.ɵɵtemplate(9, NavigationUserInfoComponent_div_18_div_4_div_9_Template, 20, 11, "div", 208);
    i0.ɵɵtemplate(10, NavigationUserInfoComponent_div_18_div_4_div_10_Template, 13, 7, "div", 209);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r124 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 3, "shared-lib.navigation-user-info.removeCredentials"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", !ctx_r124.showConfirm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r124.showConfirm);
} }
function NavigationUserInfoComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 104);
    i0.ɵɵelement(2, "div", 105);
    i0.ɵɵtemplate(3, NavigationUserInfoComponent_div_18_div_3_Template, 16, 9, "div", 175);
    i0.ɵɵtemplate(4, NavigationUserInfoComponent_div_18_div_4_Template, 11, 5, "div", 176);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r9.removeFromMeraki);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.removeFromMeraki);
} }
function NavigationUserInfoComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r156 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "app-smart-license-popup", 222);
    i0.ɵɵlistener("hideActivationPopup", function NavigationUserInfoComponent_div_19_Template_app_smart_license_popup_hideActivationPopup_1_listener($event) { i0.ɵɵrestoreView(_r156); const ctx_r155 = i0.ɵɵnextContext(); return ctx_r155.hideActivationPopup($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fromPage", "welcome");
} }
const _c2$g = function (a1) { return ["appSwitcher", a1]; };
const moment$h = moment_;
const momentTz$1 = moment_time_;
class NavigationUserInfoComponent {
    constructor(logger, router, 
    // private _location: Location,
    locationService, 
    // private userService: UserService,
    dataService, authService, userService, interactionService, translate) {
        this.logger = logger;
        this.router = router;
        this.locationService = locationService;
        this.dataService = dataService;
        this.authService = authService;
        this.userService = userService;
        this.interactionService = interactionService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.merakiFormError = "";
        this.showMerakiPopup = false;
        this.merakiAuthenticated = false;
        this.merakiAPIAuthenticated = false;
        this.merakiUserName = "";
        this.activeNetworkName = "";
        this.activeNetworkNameMap = {};
        this.networkStatusDiv = {};
        this.showNetworkStatus = false;
        this.wpNetworkDetails = {};
        this.erroneousWirelessProviders = {};
        this.disableStatus = false;
        this.merakiFormData = {};
        this.userNameToRemove = "";
        this.currentNav = "/dashboard";
        this.isSignOutVisible = false;
        this.userEmail = "";
        this.customerName = "";
        this.loginHistoryList = [];
        this.userRole = null;
        this.isUserRoleAvailable = null;
        this.licenseType = null;
        this.removeFromMeraki = false;
        this.showConfirm = false;
        this.removedMerakiUsername = "";
        this.properties = null;
        this.licenseError = false;
        this.licenseInfoVisible = false;
        this.licenseInfoData = {};
        this.isLicenseInfoReady = false;
        this.isAdminUser = false;
        this.isAdminForAppSwitcher = false;
        this.isShowChangePassword = false;
        this.showCMXConnector = false;
        this.showCMXOnPrem = false;
        this.networkStatusHeader = "WIRELESS NETWORK STATUS";
        this.showConnectors = true;
        this.displayCMXConnector = false;
        this.displayCMXConnectorContent = false;
        this.showSettingsPopup = false;
        this.selectedTabIndex = 0;
        this.appType = "CaptivePortal";
        this.disconnectFromDataService = false;
        this.merakiLoginFromDataService = false;
        this.showSyncStatusFromSetup = false;
        this.appSwitcherVisible = false;
        this.supportSectionVisible = false;
        this.appSwitcherBtnVisible = true;
        this.tilesData = [];
        this.navChange = new EventEmitter();
        this.onSettingsShow = new EventEmitter();
        this.onChangePasswordShow = new EventEmitter();
        this.isDashboardAdmin = false;
        this.isSSOLogin = false;
        this.smartLicensePopupVisible = false;
        this.messageKeys = {};
        this.makeWirelessProviderAuthStatusCall = (delay) => {
            this.timeoutWirelessProviderStatus = setTimeout(() => {
                if (this.dataService.locationTreeArrayExists)
                    this.getWirelessProviderAuthStatus();
                else
                    this.makeWirelessProviderAuthStatusCall(5000);
            }, delay);
        };
        this.getProperties = () => {
            this.authService.getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$).then(properties => {
                this.smartLicenseEnableFeature = properties['value'].smartLicenseEnableFeature;
            });
        };
        this.getSmartLicenseDetail = () => {
            this.userService.getSmartLicenseDetail().pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                if (response && response.status && response.data) {
                    if (response.data.status) {
                        if (response.data.status == "completed") {
                            this.smartLicenseObj = response.data.details;
                        }
                    }
                }
                this.smartLicenseObjLoaded = true;
            }, error => {
                console.log('ERROR :: Base component getSmartLicenseDetail call ', error);
            });
        };
        this.goToSmartLicesePopup = () => {
            this.smartLicensePopupVisible = true;
        };
        this.hideActivationPopup = ($event) => {
            this.smartLicensePopupVisible = $event;
        };
        this.goToSmartLicesePage = () => {
            this.isSignOutVisible = false;
            this.dataService.setShowSLPage(true);
            this.router.navigate(['/accountpreference']);
            this.dataService.setCurrentNav('/accountpreference');
        };
        this.getLicenseDates = (data) => {
            // data.licenseDuration = 24;
            // data.consumedAps = 300;
            // data.totalAps = 300;
            const duration = {
                months: null,
                years: null
            };
            const warn = {
                licenseStatus: "active",
                apLimit: false
            };
            const endDate = moment$h(Number(data.startDate)).add(data.licenseDuration, "M");
            const preMonth = moment$h(endDate).subtract(1, "M");
            if (moment$h().isAfter(endDate)) {
                this.licenseError = true;
                warn.licenseStatus = "expired";
            }
            else if (moment$h().isAfter(preMonth)) {
                this.licenseError = true;
                warn.licenseStatus = "soon";
            }
            if (data.consumedAps == data.totalAps) {
                this.licenseError = true;
                warn.apLimit = true;
            }
            const formattedEndDate = moment$h(endDate).format("MMM Do, YYYY");
            if (data.licenseDuration > 11) {
                duration.years = (data.licenseDuration / 12)
                    .toString()
                    .split(".")[0];
                duration.months = Number(Math.round(data.licenseDuration % 12));
            }
            else {
                duration.years = 0;
                duration.months = data.licenseDuration;
            }
            data.endDate = formattedEndDate;
            data.duration = duration;
            data.warn = warn;
            return data;
        };
        this.toggleLicenseInfo = () => {
            this.licenseInfoVisible = !this.licenseInfoVisible;
            this.closeLogoutPopupIfOpen(true);
            this.closeHelpPopupIfOpen();
        };
        this.toggleHelpSection = () => {
            this.supportSectionVisible = !this.supportSectionVisible;
            this.closeLogoutPopupIfOpen(true);
            this.appSwitcherVisible = false;
        };
        this.appSwitcherStateEmitted = ($event) => {
            this.appSwitcherVisible = $event;
        };
        this.getWirelessProviderAuthStatus = () => {
            if (this.dataService.getWirelessProviderAuthStatusCallInProgress()) {
                return;
            }
            this.dataService.setMerakiWirelessProviderAuthStatusCallInProgress(true);
            this.locationService
                .getWirelessProviderAuthStatus()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                this.dataService.setMerakiWirelessProviderAuthStatusCallInProgress(false);
                if (data.status == "completed" ||
                    data.status == "unavailable") {
                    this.disableStatus = false;
                    // this.getLocationSyncStatus();
                    if (data.authStatus && data.isUserAuthenticated) {
                        if (data.wirelessUserName == null ||
                            data.wirelessUserName == "" ||
                            data.wirelessUserName == undefined) {
                            data.wirelessUserName = this.merakiUserName;
                        }
                    }
                    this.dataService.setMerakiWPAuthResponse(data);
                    // data.authStatus = false;
                    if (data.authStatus) {
                        if (data.isUserAuthenticated) {
                            this.merakiAuthenticated = true;
                            this.merakiUserName = data.wirelessUserName;
                            this.merakiFormData.userName =
                                this.merakiUserName;
                            this.dataService.setLoginFromMeraki(true);
                            this.dataService.setMerakiUserName(this.merakiUserName);
                        }
                        else {
                            this.merakiAuthenticated = false;
                        }
                        if (data.isAPIKeyAuthenticated) {
                            this.merakiAPIAuthenticated = true;
                            this.dataService.setLoginAPIFromMeraki(true);
                        }
                        else {
                            this.merakiAPIAuthenticated = false;
                        }
                        this.dataService.setIsMerakiAuth(true);
                        this.dataService.setMerakiLoginAuthenticated(true);
                    }
                    else {
                        this.userNameToRemove = data.wirelessUserName;
                        this.merakiFormData.userName =
                            data.wirelessUserName;
                        this.merakiAuthenticated = false;
                        this.merakiAPIAuthenticated = false;
                    }
                }
                if (data.status == "progress") {
                    this.disableStatus = true;
                    this.makeWirelessProviderAuthStatusCall(5000);
                }
            }, (error) => {
                console.log("getWirelessProviderAuthStatus :: error:: " +
                    error.status);
            });
        };
        this.getLocationSyncStatus = () => {
            this.locationService
                .getLocationSyncStatus()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                this.wpNetworkDetails.wirelessProvidersCount = data
                    ? data.wirelessProvidersCount
                        ? data.wirelessProvidersCount
                        : []
                    : [];
                this.erroneousWirelessProviders.list = [];
                this.wpNetworkDetails.wirelessProvidersCount.forEach((value) => {
                    if (value.failed > 0) {
                        //  this.networkSyncStatus = false;
                        this.erroneousWirelessProviders.list.push(value.name);
                    }
                    if (value.success > 0) {
                        //  this.networkSyncStatus = false;
                        //  this.activeWirelessProviders.push(value.name);
                    }
                });
                // this.activeNetworkName = this.erroneousWirelessProviders.list.length > 0 ?this.erroneousWirelessProviders.list[0] : this.activeWirelessProviders[0];
                if (!this.wpNetworkDetails.wirelessProvidersCount) {
                    // this.networkSyncStatus = true;
                    this.wpNetworkDetails.wirelessProvidersCount = [];
                    //  $rootScope.locationSyncNotificationsList = [];
                }
                else if (this.wpNetworkDetails.wirelessProvidersCount.length > 0) {
                    if (this.locationSyncNotificationErrorsAvailable ==
                        false)
                        this.getLocationSyncNotificationErrors();
                }
                // console.log("getLocationSyncStatus :: data:: " + JSON.stringify(data));
            }, (error) => {
                console.log("getLocationSyncStatus :: error:: " + error.status);
            });
        };
        this.getLocationSyncNotificationErrors = () => {
            this.locationSyncNotificationErrorsAvailable = true;
            let notificationListResponse = null;
            this.locationSyncNotificationsList = [];
            this.syncError = {};
            if (this.erroneousWirelessProviders.list.length > 0) {
                this.erroneousWirelessProviders.list.forEach((value) => {
                    this.locationService
                        .getWPLocationSyncStatus(this.activeNetworkNameMap[value])
                        .pipe(takeUntil(this.unsubscribe$))
                        .subscribe((data) => {
                        if (data && data.locationSyncNotificationsList) {
                            if (data.locationSyncNotificationsList[0]
                                .name == "Meraki")
                                notificationListResponse =
                                    data.locationSyncNotificationsList[0]
                                        .data[0].networks;
                            else
                                notificationListResponse =
                                    data.locationSyncNotificationsList[0]
                                        .data;
                            notificationListResponse.forEach((value1) => {
                                if (value1.errorMessage) {
                                    this.locationSyncNotificationsList.push(value1);
                                }
                            });
                            this.dataService.setLocationSyncNotificationsList(this.locationSyncNotificationsList);
                            this.dataService.setOnLocationSyncStatusUpdate(new Date().getTime());
                            // SyncError Object assigning here
                            if (this.locationSyncNotificationsList !=
                                undefined &&
                                this.locationSyncNotificationsList.length >
                                    0) {
                                this.locationSyncNotificationsList.forEach((obj) => {
                                    this.syncError[obj.locationId] =
                                        true;
                                });
                                this.dataService.setSyncError(this.syncError);
                                this.dataService.setOnSyncStatusUpdate(new Date().getTime());
                            }
                        }
                    }, (error) => {
                        console.log("getLocationSyncNotificationError :: error:: " +
                            error.status);
                    });
                });
            }
        };
        this.getUserRole = () => {
            this.authService.getRole(this.unsubscribe$).subscribe((roleBehavior) => {
                if (roleBehavior && roleBehavior.appRole) {
                    this.userRole = roleBehavior.appRole;
                    this.isUserRoleAvailable = true;
                    // RBAC changes starts
                    if (this.userRole == "RW") {
                        this.userRole = "Admin";
                        if (this.isAdminForAppSwitcher) {
                            this.appSwitcherBtnVisible = true;
                        }
                        else {
                            this.appSwitcherBtnVisible = false;
                        }
                    }
                    else if (this.userRole == "RO") {
                        this.userRole = "ReadOnlyAccess";
                        if (this.isAdminForAppSwitcher) {
                            this.appSwitcherBtnVisible = true;
                        }
                        else {
                            this.appSwitcherBtnVisible = false;
                        }
                    }
                    else if (this.userRole == "AccessCodeManager") {
                        this.appSwitcherBtnVisible = false;
                    }
                    else if (this.userRole == "CreativeUser") {
                        this.appSwitcherBtnVisible = false;
                    }
                }
                else {
                    this.appSwitcherBtnVisible = false;
                }
            }, (error) => {
                console.log(error);
            });
        };
        this.getLicenseType = () => {
            this.authService
                .getLicenseType(this.unsubscribe$)
                .then((licenseType) => {
                this.licenseType = licenseType["value"];
                //console.log("this.licenseType " + this.licenseType);
            });
        };
        this.toggleNav = ($event, elementId) => {
            const expandNavLink = document.getElementById(elementId);
            this.logger.info(elementId, expandNavLink);
            expandNavLink.classList.toggle("navLinkClose");
            expandNavLink.classList.toggle("navLinkOpen");
        };
        this.isMatchingAlias = (navAliasArr, pageNav) => {
            for (const index in navAliasArr) {
                if (pageNav.indexOf(navAliasArr[index]) > -1) {
                    return true;
                }
            }
        };
        this.emitNavObj = () => {
            let found = false;
            for (const id in this.navigations) {
                this.navigations[id].isOpened = false;
                this.navigations[id].selected = false;
                if (!found) {
                    let matching = this.navigations[id].id === this.currentNav;
                    if (!matching &&
                        this.navigations[id].alias &&
                        this.currentNav) {
                        // this.navigations[id].alias.find(
                        //     val => {
                        //         // console.log('val', val, "this.currentNav", this.currentNav,
                        //         //     'this.currentNav.indexOf(val)', this.currentNav.indexOf(val));
                        //         if (this.currentNav.indexOf(val) > -1) {
                        //             matching = true;
                        //         }
                        //     });
                        if (this.isMatchingAlias(this.navigations[id].alias, this.currentNav)) {
                            matching = true;
                        }
                    }
                    // console.log('matching', matching);
                    if (matching) {
                        this.navChange.emit(this.navigations[id]);
                        found = true;
                        this.navigations[id].selected = true;
                    }
                    else if (this.navigations[id].children) {
                        for (const i in this.navigations[id].children) {
                            this.navigations[id].children[i].selected = false;
                            if (!found) {
                                if (!found &&
                                    this.navigations[id].children[i].id ===
                                        this.currentNav) {
                                    this.navChange.emit(this.navigations[id].children[i]);
                                    found = true;
                                }
                                if (!found &&
                                    this.navigations[id].children[i].alias &&
                                    this.currentNav) {
                                    // this.navigations[id].children[i].alias.find(
                                    //     val => {
                                    //         // console.log('val', val, "this.currentNav", this.currentNav,
                                    //         // 'this.currentNav.indexOf(val)', this.currentNav.indexOf(val));
                                    //         if (this.currentNav.indexOf(val) > -1) {
                                    //             found = true;
                                    //             matching = true;
                                    //         }
                                    //     });
                                    if (this.isMatchingAlias(this.navigations[id].children[i].alias, this.currentNav)) {
                                        found = true;
                                        matching = true;
                                    }
                                }
                                if (found) {
                                    found = true;
                                    this.navigations[id].isOpened = true;
                                    this.navigations[id].children[i].selected =
                                        true;
                                    this.navChange.emit(this.navigations[id].children[i]);
                                }
                            }
                        }
                    }
                }
            }
        };
        this.selectNav = (nav) => {
            console.log("select nav", nav, "-- curret nav", this.currentNav);
            if (!nav.children) {
                if (this.currentNav != nav.id && nav.clickable) {
                    this.dataService.display(true);
                    this.currentNav = nav.id;
                    this.dataService.setCurrentNav(this.currentNav);
                    // this.emitNavObj();
                    this.router.navigate([nav.id]);
                }
            }
            else {
                nav.isOpened = !nav.isOpened;
            }
        };
        this.signOut = ($event) => {
            this.dataService.display(true);
            const userNameForInteractionLog = this.dataService.getUserName();
            const logStr = "LOGOUT: User " + userNameForInteractionLog + " has signed out";
            // set value as null in dataservice
            this.dataService.setSetupTaskObserver(null);
            this.interactionService.doInteractionLog(new InteractionLog(TYPE.LOGOUT, this.dataService.getPosition(), "{}", SECTION.SIGN_OUT, ITEM_TYPE.POPUP, ITEM.SIGN_OUT, logStr, this.dataService.getCurrentNav()));
            // app user's logout issue - fixed
            try {
                if (pendo) {
                    pendo.setGuidesDisabled(true);
                    pendo.loadGuides();
                }
            }
            catch (e) {
                console.log(e);
            }
            finally {
                this.locationService.signOut();
            }
        };
        this.showSignOut = ($event) => {
            this.isSignOutVisible == false
                ? (this.isSignOutVisible = true)
                : (this.isSignOutVisible = false);
            this.isSmartLicenseRegistered = this.dataService.getSmartLicenseRegistered();
            console.log(" :: isSmartLicenseRegistered :: " + this.isSmartLicenseRegistered);
            this.appSwitcherVisible = false;
            this.closeHelpPopupIfOpen();
        };
        this.closeLogoutPopupIfOpen = ($event) => {
            this.isSignOutVisible == true ? (this.isSignOutVisible = false) : false;
        };
        this.closeHelpPopupIfOpen = () => {
            this.supportSectionVisible == true
                ? (this.supportSectionVisible = false)
                : false;
        };
        this.showToolkitSettings = () => {
            if (this.appSwitcherVisible)
                this.appSwitcherVisible = false;
            this.onSettingsShow.emit(true);
        };
        this.toggleAppSwitcher = () => {
            this.licenseInfoVisible = false;
            this.supportSectionVisible = false;
            this.appSwitcherVisible = !this.appSwitcherVisible;
        };
        this.toggleNetworkStatus = () => {
            // if (!this.disableStatus) {
            this.showNetworkStatus = !this.showNetworkStatus;
            if (this.showNetworkStatus) {
                this.closeLogoutPopupIfOpen(true);
                this.closeHelpPopupIfOpen();
                const userNameForInteractionLog = this.dataService.getUserName();
                const logStr = "VIEW: User " +
                    userNameForInteractionLog +
                    " has viewed resend invite to the user";
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.VIEW, this.dataService.getPosition(), "{}", SECTION.ACCOUNT_SETTINGS, ITEM_TYPE.POPUP, ITEM.MERAKI_ACCOUNT_SETTINGS, logStr, this.dataService.getCurrentNav()));
            }
            else {
                const userNameForInteractionLog = this.dataService.getUserName();
                const logStr = "CLOSE: User " +
                    userNameForInteractionLog +
                    " has closedmeraki account settings popup";
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.CLOSE, this.dataService.getPosition(), "{}", SECTION.ACCOUNT_SETTINGS, ITEM_TYPE.POPUP, ITEM.MERAKI_ACCOUNT_SETTINGS, logStr, this.dataService.getCurrentNav()));
            }
            // }
        };
        this.toggleNetworkStatPopup = (e) => {
            if (this.showNetworkStatus)
                this.showNetworkStatus = false;
            this.expandIconState = true;
            this.wpNetworkDetails.status = "updating";
            if (e) {
                this.dataService.display(true);
                this.locationService
                    .getLocationSyncStatus()
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((data) => {
                    this.wpNetworkDetails.wirelessProvidersCount =
                        data.wirelessProvidersCount;
                    this.activeNetworkName =
                        this.wpNetworkDetails.wirelessProvidersCount !=
                            null &&
                            this.wpNetworkDetails.wirelessProvidersCount
                                .length > 0
                            ? this.wpNetworkDetails
                                .wirelessProvidersCount[0].name
                            : "";
                    if (this.activeNetworkName) {
                        this.showCMXConnector = false;
                        this.showCMXOnPrem = false;
                        // this.dataService.display(true);
                        this.locationService
                            .getWPLocationSyncStatus(this.activeNetworkName)
                            .pipe(takeUntil(this.unsubscribe$))
                            .subscribe((data) => {
                            // console.log("getWPLocationSyncStatus :: data :: " + JSON.stringify(data));
                            this.wpNetworkDetails.locationSyncNotificationsList =
                                data.locationSyncNotificationsList;
                            this.dataService.display(false);
                            this.wpNetworkDetails.error = false;
                            this.wpNetworkDetails.status =
                                "updated";
                            this.networkStatusDiv.visible = e;
                        }, (error) => {
                            console.log("getWPLocationSyncStatus :: error :: " +
                                error.status);
                            this.dataService.display(false);
                        });
                        if (this.wpNetworkDetails.status == "updating") {
                            this.wpNetworkDetails.error = true;
                            this.wpNetworkDetails.status = "updated";
                        }
                    }
                    else {
                        this.networkStatusDiv.visible = e;
                        if (this.wpNetworkDetails.wirelessProvidersCount
                            .length == 0) {
                            this.dataService.display(false);
                            this.selectCMXConnector();
                        }
                    }
                    this.dataService.setShowSyncStatus(false);
                }, (error) => {
                    console.log("getLocationSyncStatus :: error :: " + error.status);
                    this.dataService.display(false);
                });
            }
            else {
                this.networkStatusDiv.visible = e;
                this.showSyncStatusFromSetup = false;
                this.dataService.setShowSyncStatus(false);
            }
        };
        this.changeSelectedNetwork = (networkName) => {
            this.showCMXConnector = false;
            this.showCMXOnPrem = false;
            this.networkStatusHeader = "WIRELESS NETWORK STATUS";
            this.wpNetworkDetails.status = "updating";
            this.activeNetworkName = networkName;
            if (this.activeNetworkName) {
                this.dataService.display(true);
                this.locationService
                    .getWPLocationSyncStatus(this.activeNetworkName)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((data) => {
                    // console.log("getWPLocationSyncStatus :: data :: " + JSON.stringify(data));
                    this.wpNetworkDetails.locationSyncNotificationsList =
                        data.locationSyncNotificationsList;
                    this.dataService.display(false);
                    this.wpNetworkDetails.error = false;
                    this.wpNetworkDetails.status = "updated";
                    // Reset to meraki location as collapsed state
                    if (this.activeNetworkName == "Meraki") {
                        if (this.wpNetworkDetails
                            .locationSyncNotificationsList &&
                            this.wpNetworkDetails
                                .locationSyncNotificationsList[0].data) {
                            this.wpNetworkDetails.locationSyncNotificationsList[0].data.forEach((element, index) => {
                                this.collapseOrganizationNode(index);
                            });
                        }
                    }
                }, (error) => {
                    console.log("getWPLocationSyncStatus :: error :: " +
                        error.status);
                    this.dataService.display(false);
                });
                if (this.wpNetworkDetails.status == "updating") {
                    this.wpNetworkDetails.error = true;
                    this.wpNetworkDetails.status = "updated";
                }
            }
        };
        this.expandOrganizationNode = function (id) {
            this.expandIconState = false;
            $("#innerNetworkUl_" + id).css("display", "block");
        };
        this.collapseOrganizationNode = function (id) {
            this.expandIconState = true;
            $("#innerNetworkUl_" + id).css("display", "none");
        };
        this.showChangePassword = () => {
            this.onChangePasswordShow.emit(true);
            this.isShowChangePassword = true;
            this.closeLogoutPopupIfOpen(true);
            this.closeHelpPopupIfOpen();
        };
        this.showMerakiPopupFn = (show) => {
            this.showMerakiPopup = show;
            this.appSwitcherVisible = false;
            this.removedMerakiUsername = "";
            this.hideRemoveMerakiFormFn();
        };
        this.validCredentialInput = () => {
            if (this.merakiFormData.userName == "") {
                this.merakiFormError = "Please enter email";
                return false;
            }
            if (this.merakiFormData.userName) {
                const filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                if (!filter.test(this.merakiFormData.userName)) {
                    this.merakiFormError = "Please enter valid email";
                    return false;
                }
            }
            if (this.merakiFormData.password == "") {
                this.merakiFormError = "Please enter password";
                return false;
            }
            return true;
        };
        this.doMerakiAuthentication = () => {
            const valid = this.validCredentialInput();
            if (valid) {
                this.dataService.display(true, 50000);
                const authObj = {
                    type: "meraki",
                    userName: this.merakiFormData.userName,
                    password: this.merakiFormData.password,
                    useAPI: false
                };
                this.locationService
                    .loginToMerakiWireless(authObj)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((authResp) => {
                    if (authResp.status) {
                        this.dataService.display(false);
                        this.makeWirelessProviderAuthStatusCall(1000);
                        this.showMerakiPopup = false;
                        this.showNetworkStatus = true;
                        this.dataService.setMerakiLoginAuthenticated(true);
                        this.dataService.setToastMessage("Successfully meraki authenticated", 4000, null, null, "success");
                        const userNameForInteractionLog = this.dataService.getUserName();
                        const logStr = "CONNECT: User " +
                            userNameForInteractionLog +
                            " has connected to meraki account";
                        this.interactionService.doInteractionLog(new InteractionLog(TYPE.CONNECT, this.dataService.getPosition(), "{}", SECTION.ACCOUNT_SETTINGS, ITEM_TYPE.POPUP, ITEM.MERAKI_ACCOUNT_SETTINGS_CONNECT, logStr, this.dataService.getCurrentNav()));
                    }
                    else {
                        this.dataService.setToastMessage(this.messageKeys[authResp.message], 4000, null, null, "error");
                        this.dataService.display(false);
                        const userNameForInteractionLog = this.dataService.getUserName();
                        const logStr = "ERROR: While connecting meraki account by User " +
                            userNameForInteractionLog;
                        this.interactionService.doInteractionLog(new InteractionLog(TYPE.ERROR, this.dataService.getPosition(), "{}", SECTION.ACCOUNT_SETTINGS, ITEM_TYPE.POPUP, ITEM.MERAKI_ACCOUNT_SETTINGS_CONNECT, logStr, this.dataService.getCurrentNav()));
                    }
                }, (error) => {
                    console.log("Error", error);
                    this.dataService.setToastMessage(this.messageKeys[error.status], 4000, null, null, "error");
                    this.dataService.display(false);
                });
            }
        };
        this.goToProductUpdates = () => {
            const whatsNewLink = this.properties["whatsNewLink"];
            if (whatsNewLink !== undefined &&
                whatsNewLink !== null &&
                whatsNewLink !== "") {
                window.open(whatsNewLink, "_blank");
                this.interactionService.doInteractionLog(new InteractionLog(TYPE.VIEW, this.dataService.getPosition(), "{}", SECTION.LOGIN, ITEM_TYPE.SCREEN, ITEM.WHATS_NEW, "VIEW: What's New page", "/whats-new"));
            }
        };
        this.loginMerakiFromDataService = () => {
            this.erroneousWirelessProviders.list = [];
            this.merakiAuthenticated = true;
        };
        this.disconnectFromMeraki = () => {
            this.dataService.display(true);
            const authObj = {
                type: "meraki"
            };
            this.locationService
                .disconnectMerakiLogin(authObj)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((authResp) => {
                if (authResp.status) {
                    this.dataService.display(false);
                    this.makeWirelessProviderAuthStatusCall(1000);
                    if (this.removeFromMeraki) {
                        this.removedMerakiUsername = this.userNameToRemove;
                        this.showConfirm = true;
                    }
                    else {
                        this.showMerakiPopup = false;
                        if (!this.disconnectFromDataService) {
                            this.showNetworkStatus = true;
                            this.dataService.setDisconnectFromMerakiLogin(true);
                            this.merakiAuthenticated = false;
                            this.merakiAPIAuthenticated = false;
                        }
                        else {
                            this.merakiAuthenticated = false;
                            this.merakiAPIAuthenticated = false;
                        }
                        this.dataService.setToastMessage("Successfully meraki authenticated", 4000, null, null, "success");
                        this.dataService.setIsMerakiAuth(false);
                    }
                    this.dataService.setMerakiLoginAuthenticated(false);
                }
                else {
                    if (this.removeFromMeraki) {
                        this.merakiFormError = authResp.message;
                        this.showConfirm = false;
                    }
                    this.dataService.setToastMessage(authResp.message, 4000, null, null, "error");
                    this.dataService.display(false);
                }
                if (this.disconnectFromDataService) {
                    this.disconnectFromDataService = false;
                }
            }, (error) => {
                console.log("Error", error);
                this.dataService.setToastMessage(error.status, 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        this.disconnectFromMerakiLogin = () => {
            this.dataService.display(true);
            const authObj = {
                type: "MERAKI_LOGIN"
            };
            this.locationService
                .disconnectMerakiLogin(authObj)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((authResp) => {
                if (authResp.status) {
                    this.dataService.display(false);
                    this.makeWirelessProviderAuthStatusCall(1000);
                    if (this.removeFromMeraki) {
                        this.removedMerakiUsername = this.userNameToRemove;
                        this.showConfirm = true;
                    }
                    else {
                        this.showMerakiPopup = false;
                        if (!this.disconnectFromDataService) {
                            this.showNetworkStatus = true;
                        }
                        else {
                            this.merakiAuthenticated = false;
                        }
                        this.dataService.setToastMessage("Successfully removed meraki", 4000, null, null, "success");
                        this.dataService.setIsMerakiAuth(false);
                    }
                }
                else {
                    if (this.removeFromMeraki) {
                        this.merakiFormError = authResp.message;
                        this.showConfirm = false;
                    }
                    this.dataService.setToastMessage("Failed to disconnect", 4000, null, null, "error");
                    this.dataService.display(false);
                }
                if (this.disconnectFromDataService) {
                    this.disconnectFromDataService = false;
                    this.dataService.setDisconnectFromMeraki(false);
                }
            }, (error) => {
                console.log("Error", error);
                this.dataService.setToastMessage(error.status, 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        this.disconnectFromMerakiAPIKey = () => {
            this.dataService.display(true);
            const authObj = {
                type: "MERAKI_APIKEY"
            };
            this.locationService
                .disconnectMerakiLogin(authObj)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((authResp) => {
                if (authResp.status) {
                    this.dataService.display(false);
                    this.makeWirelessProviderAuthStatusCall(1000);
                    if (this.removeFromMeraki) {
                        this.removedMerakiUsername = this.userNameToRemove;
                        this.showConfirm = true;
                    }
                    else {
                        this.showMerakiPopup = false;
                        if (!this.disconnectFromDataService) {
                            this.showNetworkStatus = true;
                        }
                        else {
                            this.merakiAPIAuthenticated = false;
                        }
                        this.dataService.setToastMessage("Successfully removed meraki", 4000, null, null, "success");
                        this.dataService.setIsMerakiAuth(false);
                    }
                }
                else {
                    if (this.removeFromMeraki) {
                        this.merakiFormError = authResp.message;
                        this.showConfirm = false;
                    }
                    this.dataService.setToastMessage("Failed to disconnect", 4000, null, null, "error");
                    this.dataService.display(false);
                }
                if (this.disconnectFromDataService) {
                    this.disconnectFromDataService = false;
                    this.dataService.setDisconnectFromMerakiAPIKey(false);
                }
            }, (error) => {
                console.log("Error", error);
                this.dataService.setToastMessage(error.status, 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        this.isShowRemoveLabel = () => {
            if (!this.merakiAuthenticated &&
                this.userNameToRemove &&
                this.userNameToRemove.length > 0) {
                return true;
            }
            else {
                return false;
            }
        };
        this.showRemoveMerakiFormFn = () => {
            this.removeFromMeraki = true;
        };
        this.hideRemoveMerakiFormFn = () => {
            this.removeFromMeraki = false;
            this.showConfirm = false;
        };
        this.removeFromMerakiFn = () => {
            this.disconnectFromMeraki();
        };
        this.navigateToLocation = () => {
            this.currentNav = "/location";
            this.router.navigate([this.currentNav]);
            this.dataService.setCurrentNav(this.currentNav);
            this.networkStatusDiv.visible = !this.networkStatusDiv.visible;
            this.toggleNetworkStatPopup(false);
        };
        this.navigateToMonitoring = () => {
            this.currentNav = "/monitor";
            this.dataService.setCurrentNav(this.currentNav);
            this.router.navigate([this.currentNav]);
        };
        this.getLoginPageLinks = () => {
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$)
                .then((properties) => {
                this.properties = properties["value"];
                // this.dataService.display(false);
                this.dataService.setCanDoInteractionLog(this.properties.canDoInteractionLog);
            });
        };
        this.onHideChangePassword = (event) => {
            this.isShowChangePassword = false;
        };
        this.showConfigurePopup = ($event) => { };
        this.selectCMXConnector = () => {
            this.showCMXOnPrem = false;
            this.showCMXConnector = true;
            this.displayCMXConnectorContent = true;
            this.activeNetworkName = "connector";
            this.goBackToConnectors();
        };
        this.selectCMXOnPrem = () => {
            this.showCMXOnPrem = true;
            this.displayCMXConnectorContent = false;
            this.activeNetworkName = "cmxOnPrem";
        };
        this.showControllers = () => {
            this.networkStatusHeader = "Controllers";
            this.showConnectors = false;
        };
        this.goBackToConnectors = () => {
            this.showConnectors = true;
            this.networkStatusHeader = "WIRELESS NETWORK STATUS";
        };
        this.toggleSettingsPopup = (show) => {
            this.showSettingsPopup = show;
        };
        this.onSpacesSettingsHide = ($event) => {
            this.showSettingsPopup = $event;
        };
        this.viewLoginHistory = () => {
            this.closeLogoutPopupIfOpen(true);
            this.closeHelpPopupIfOpen();
            if (location.pathname.indexOf("/captiveportal/") == -1 &&
                location.pathname.indexOf("/openroaming/") == -1 &&
                location.pathname.indexOf("/personas/") == -1 &&
                location.pathname.indexOf("/engagements/") == -1 &&
                location.pathname.indexOf("/iotexplorer/") == -1 &&
                location.pathname.indexOf("/business/") == -1 &&
                location.pathname.indexOf("/impactanalysis") == -1 &&
                location.pathname.indexOf("/camera-metrics") == -1 &&
                location.pathname.indexOf("/right-now") == -1 &&
                location.pathname.indexOf("/partner/") == -1 &&
                location.pathname.indexOf("/location-analytics-v2") == -1 &&
                location.pathname.indexOf("/environmental-metrics") == -1) {
                this.currentNav = "/loginhistory";
            }
            else if (location.pathname.indexOf("/captiveportal/") >= 0) {
                this.currentNav = "/captiveportal/loginhistory";
            }
            else if (location.pathname.indexOf("/openroaming/") >= 0) {
                this.currentNav = "/openroaming/loginhistory";
            }
            else if (location.pathname.indexOf("/personas/") >= 0) {
                this.currentNav = "/personas/loginhistory";
            }
            else if (location.pathname.indexOf("/engagements/") >= 0) {
                this.currentNav = "/engagements/loginhistory";
            }
            else if (location.pathname.indexOf("/iotexplorer/") >= 0) {
                this.currentNav = "/iotexplorer/loginhistory";
            }
            else if (location.pathname.indexOf("/business/") >= 0) {
                this.currentNav = "/business/loginhistory";
            }
            else if (location.pathname.indexOf("/impactanalysis") >= 0) {
                this.currentNav = "/impactanalysis/loginhistory";
            }
            else if (location.pathname.indexOf("/camera-metrics") >= 0) {
                this.currentNav = "/camera-metrics/loginhistory";
            }
            else if (location.pathname.indexOf("/partner/") >= 0) {
                this.currentNav = "/partner/loginhistory";
            }
            else if (location.pathname.indexOf("/location-analytics-v2") >= 0) {
                this.currentNav = "/location-analytics-v2/loginhistory";
            }
            else if (location.pathname.indexOf("/right-now") >= 0) {
                this.currentNav = "/right-now/loginhistory";
            }
            else if (location.pathname.indexOf("/environmental-metrics") >= 0) {
                this.currentNav = "/environmental-metrics/loginhistory";
            }
            this.router.navigate([this.currentNav]);
        };
        this.showAccountPreferences = () => {
            if (location.pathname.indexOf("/captiveportal/") == -1 &&
                location.pathname.indexOf("/openroaming/") == -1 &&
                location.pathname.indexOf("/personas/") == -1 &&
                location.pathname.indexOf("/engagements/") == -1 &&
                location.pathname.indexOf("/iotexplorer/") == -1 &&
                location.pathname.indexOf("/business/") == -1 &&
                location.pathname.indexOf("/impactanalysis/") == -1 &&
                location.pathname.indexOf("/camera-metrics/") == -1 &&
                location.pathname.indexOf("/partner/") == -1 &&
                location.pathname.indexOf("/location-analytics-v2/") == -1 &&
                location.pathname.indexOf("/right-now/") == -1 &&
                location.pathname.indexOf("/environmental-metrics") == -1) {
                this.currentNav = "/accountpreference";
            }
            else if (location.pathname.indexOf("/captiveportal/") >= 0) {
                this.currentNav = "/captiveportal/accountpreference";
            }
            else if (location.pathname.indexOf("/openroaming/") == 0) {
                this.currentNav = "/openroaming/accountpreference";
            }
            else if (location.pathname.indexOf("/personas/") == 0) {
                this.currentNav = "/personas/accountpreference";
            }
            else if (location.pathname.indexOf("/engagements/") == 0) {
                this.currentNav = "/engagements/accountpreference";
            }
            else if (location.pathname.indexOf("/iotexplorer/") == 0) {
                this.currentNav = "/iotexplorer/accountpreference";
            }
            else if (location.pathname.indexOf("/business/") >= 0) {
                this.currentNav = "/business/accountpreference";
            }
            else if (location.pathname.indexOf("/impactanalysis/") >= 0) {
                this.currentNav = "/impactanalysis/accountpreference";
            }
            else if (location.pathname.indexOf("/camera-metrics/") >= 0) {
                this.currentNav = "/camera-metrics/accountpreference";
            }
            else if (location.pathname.indexOf("/partner/") >= 0) {
                this.currentNav = "/partner/accountpreference";
            }
            else if (location.pathname.indexOf("/location-analytics-v2/") >= 0) {
                this.currentNav = "/location-analytics-v2/accountpreference";
            }
            else if (location.pathname.indexOf("/right-now/") >= 0) {
                this.currentNav = "/right-now/accountpreference";
            }
            else if (location.pathname.indexOf("/environmental-metrics/") >= 0) {
                this.currentNav = "/environmental-metrics/accountpreference";
            }
            this.dataService.setCurrentNav(this.currentNav);
            this.router.navigate([this.currentNav]);
            this.closeLogoutPopupIfOpen(true);
        };
        this.showChangeLog = () => {
        };
        this.goToChangeLogPage = () => {
            this.isSignOutVisible = false;
            this.dataService.setShowChangeLogPage(true);
            if (location.pathname.indexOf("/iotexplorer/") == 0) {
                this.router.navigate(['/iotexplorer/accountpreference']);
                this.dataService.setCurrentNav('/iotexplorer/accountpreference');
            }
            else {
                this.router.navigate(['/accountpreference']);
                this.dataService.setCurrentNav('/accountpreference');
            }
        };
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-success').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.meraki.success"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-failed').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.meraki.error.failed"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-empty').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.error.input.empty"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-invalid').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.error.input.invalid"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-empty').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.meraki.error.input.empty"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-exists').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.meraki.error.exists"] = res;
            });
        };
    }
    ngOnInit() {
        this.isSmartLicenseRegistered = this.dataService.getSmartLicenseRegistered();
        this.smartLicenseObj = { 'enforceMode': '' };
        this.getSmartLicenseDetail();
        this.getProperties();
        this.setupName = this.dataService.getDashboardSetupName();
        console.log("setupName :: " + this.setupName);
        this.dataService
            .getIsAuthSSO(this.unsubscribe$)
            .subscribe((val) => {
            if (val != null) {
                this.isSSOLogin = val;
            }
        });
        if (this.setupName == "dnaspaces") {
            this.dashboardSetupName = "Spaces";
        }
        else {
            this.dashboardSetupName = "Cisco CMX";
        }
        if (!this.isDashboardAdmin) {
            this.disableStatus = false;
            this.locationSyncNotificationsList = [];
            this.isShowNotificationList = false;
            this.syncError = {};
            this.locationSyncNotificationErrorsAvailable = false;
            this.erroneousWirelessProviders = {};
            this.erroneousWirelessProviders.list = [];
            this.merakiFormData.userName = "";
            this.merakiFormData.password = "";
            this.makeWirelessProviderAuthStatusCall(10000);
            this.wpNetworkDetails = {
                status: "pending",
                error: false,
                wirelessProvidersCount: [],
                locationSyncNotificationsList: []
            };
            this.networkStatusDiv = { visible: false, showPageLoader: false };
            this.activeNetworkNameMap = {
                "Cisco Meraki": "Cisco Meraki",
                "CMX On Prem": "CMX On Prem",
                "Cisco AireOS Controller Direct Connect": "Cisco AireOS Controller Direct Connect",
                Ruckus: "RUCKUS",
                Xirrus: "XIRRUS",
                Aruba: "ARUBA"
            };
            this.wpNetworkDetails.wirelessProvidersCount = [];
            this.wpNetworkDetails.locationSyncNotificationsList = [];
        }
        this.isAdminUser = this.dataService.getIsDashboardAdmin();
        this.expandIconState = true;
        this.currentNav = this.dataService.getCurrentNav();
        // this.emitNavObj();
        this.getUserRole();
        this.timeoutCMXConnector = setTimeout(() => {
            if (this.userRole != "SuperAdmin") {
                // for showing liecence details
                this.getLoginPageLinks();
            }
            this.displayCMXConnector = this.dataService.getShowCMXConnector();
            this.displayCMXConnectorContent = this.displayCMXConnector;
            console.log("displayCMXConnector :: from dna-spaces : " +
                this.displayCMXConnector);
        }, 3000);
        this.dataService.getAuthStatus(this.unsubscribe$).subscribe((val) => {
            this.makeWirelessProviderAuthStatusCall(1000);
        });
        if (!this.isAdminUser) {
            this.dataService
                .getLicenseDetails(this.unsubscribe$)
                .subscribe((val) => {
                if (val.tenantId) {
                    if (moment$h(val.startDate, "YYYY-MM-DDTHH:mm:ss.sssZ", true).isValid()) {
                        val.startDate = String(moment$h(val.startDate).valueOf());
                    }
                    this.licenseInfo = val;
                    this.licenseInfoData = this.getLicenseDates(val);
                    this.isLicenseInfoReady = true;
                }
                else {
                    this.isLicenseInfoReady = false;
                }
            });
        }
        // console.log("Browser Agent:: ", this.browserAgent);
        // appSwitcherBtnVisible - changes
        const userStatus = this.dataService.getFromStorage('appSwitcherUserStatus') ? true : false;
        this.isAdminForAppSwitcher = userStatus;
        if (this.isAdminForAppSwitcher) {
            this.appSwitcherBtnVisible = true;
        }
        this.customerName = this.dataService.getCustomerName();
        // login History
        this.locationService
            .getLoginHistory()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((response) => {
            if (response && response.data && response.data.loginHistory) {
                this.loginHistoryList = response.data.loginHistory;
                if (this.loginHistoryList &&
                    this.loginHistoryList.length > 0) {
                    const lastLoginVal = this.loginHistoryList[this.loginHistoryList.length - 1].lastLogin;
                    this.lastLogin = moment$h
                        .utc(lastLoginVal)
                        .local()
                        .format("Do MMM YYYY, hh:mm A");
                    const zone = momentTz$1.tz.guess();
                    const timezoneName = momentTz$1.tz(zone).zoneAbbr();
                    this.lastLogin = this.lastLogin + " " + timezoneName;
                }
            }
        });
        this.dataService
            .getDisconnectFromMeraki(this.unsubscribe$)
            .subscribe((val) => {
            if (val) {
                this.disconnectFromDataService = true;
                this.disconnectFromMerakiLogin();
            }
        });
        this.dataService
            .getDisconnectFromMerakiAPIKey(this.unsubscribe$)
            .subscribe((val) => {
            if (val) {
                this.disconnectFromDataService = true;
                this.disconnectFromMerakiAPIKey();
            }
        });
        this.dataService
            .getLoginFromMeraki(this.unsubscribe$)
            .subscribe((val) => {
            if (val) {
                this.merakiLoginFromDataService = true;
                this.dataService
                    .getMerakiUserName(this.unsubscribe$)
                    .subscribe((data) => {
                    if (data) {
                        this.merakiUserName = data;
                    }
                });
                this.loginMerakiFromDataService();
                this.dataService.setLoginFromMeraki(false);
            }
        });
        this.dataService
            .getShowSyncStatus(this.unsubscribe$)
            .subscribe((val) => {
            console.log('getShowSyncStatus>>>', val);
            if (val) {
                this.showSyncStatusFromSetup = true;
                this.toggleNetworkStatPopup(true);
            }
        });
        // disable app switcher for app users
        setTimeout(() => {
            this.dataService
                .getTilesData(this.unsubscribe$)
                .subscribe((data) => {
                this.tilesData = data;
                console.log("nav user info", JSON.stringify(this.tilesData));
            });
        }, 500);
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
    }
    getUserEmail() {
        this.userEmail = this.dataService.getUserName();
        return this.userEmail ? this.userEmail : "";
    }
    // Click outside popup
    clickEvent(event) {
        const elementClicked = event.target;
        if (!elementClicked)
            return;
        if (jQuery(elementClicked).hasClass("settingsLink")) {
            return;
        }
        else if (jQuery(elementClicked).parents(".userNameSpaces") != undefined &&
            jQuery(elementClicked).parents(".userNameSpaces").length > 0) {
            return;
        }
        else {
            if (jQuery(elementClicked).parents(".switcher") != undefined &&
                jQuery(elementClicked).parents(".switcher").length == 0) {
                this.appSwitcherVisible = false;
            }
            if (jQuery(elementClicked).parents(".signOutPopupContainer") !=
                undefined &&
                jQuery(elementClicked).parents(".signOutPopupContainer")
                    .length == 0) {
                this.isSignOutVisible = false;
            }
            if (jQuery(elementClicked).parents(".supportWrapper") !=
                undefined &&
                jQuery(elementClicked).parents(".supportWrapper").length == 0) {
                this.supportSectionVisible = false;
            }
        }
    }
    ngOnDestroy() {
        console.log("destory navigation page");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        clearTimeout(this.timeoutCMXConnector);
        clearTimeout(this.timeoutWirelessProviderStatus);
    }
}
NavigationUserInfoComponent.ɵfac = function NavigationUserInfoComponent_Factory(t) { return new (t || NavigationUserInfoComponent)(i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(UserService), i0.ɵɵdirectiveInject(InteractionService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
NavigationUserInfoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NavigationUserInfoComponent, selectors: [["app-navigation-user-info"]], hostBindings: function NavigationUserInfoComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function NavigationUserInfoComponent_click_HostBindingHandler($event) { return ctx.clickEvent($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { setup: "setup", isDashboardAdmin: "isDashboardAdmin" }, outputs: { navChange: "navChange", onSettingsShow: "onSettingsShow", onChangePasswordShow: "onChangePasswordShow" }, decls: 20, vars: 13, consts: [[1, "navigationWidth"], ["class", "signOutPopup", 3, "ngClass", 4, "ngIf"], ["class", "changePasswordPopup", 4, "ngIf"], [4, "ngIf"], [1, "settingsDisplayIcons"], ["class", "settingsNavigationWidth app-switcher", 4, "ngIf"], [1, "settingsNavigationWidth", "help-icon-wrap"], [1, "settingsLink", "help-icon", 3, "click"], [1, "userNameSpaces", "userNameWidth", 3, "title", "click"], ["src", "/assets/images/basic/profile.svg", "width", "20", "alt", "."], ["class", "userName userNameWidth"], ["defaultSetup", ""], [3, "ngClass"], [3, "emitState"], ["class", "networkProvider", 4, "ngIf"], [1, "signOutPopup", 3, "ngClass"], [1, "signOutPopupContainer"], [1, "signOutPopupInner"], [1, "userInfoWrapper"], [1, "userProfileIcon_grey"], [1, "userProfile"], [1, "userEmailPopup", 3, "title"], [1, "divTableLoginHistory"], [1, "divTableCell1LocHistory"], [1, "title"], [1, "lastLogin"], [1, "vertical-line"], [1, "divTableCell2LocHistory"], [1, "viewHistory", 3, "click"], [1, "navUserActions"], [1, "navPopupButton"], ["src", "/assets/images/account_preferences.svg", "alt", "Account Preferences", "width", "13"], [1, "navPopupLinks", 3, "click"], ["class", "navPopupButton", 4, "ngIf"], ["src", "/assets/images/view_change_log.svg", "alt", "View Change Log", "width", "13"], [1, "logOutBtn", 3, "click"], ["src", "/assets/images/logout.svg", "alt", "Logout", "width", "15"], [1, "navPopupLinks"], ["src", "/assets/images/license_info.svg", "width", "13"], [1, "navPopupLinks", 3, "ngClass", "click"], [1, "showDiv-on-Mousehover"], [1, "modalContent-act"], [1, "modalBody"], [1, "act-popup-div"], [1, "popup-title-div"], [1, "popup-title-red"], [1, "popup-subtitle"], ["href", "https://www.cisco.com/c/en_in/products/software/smart-accounts/software-licensing.html", "target", "_blank"], [1, "changePasswordPopup"], [3, "onHideChangePassword"], [3, "data", "close"], [1, "settingsNavigationWidth", "app-switcher"], [1, "settingsLink", "app-switcher-icon", 3, "click"], ["click)", "showSignOut($event)", 3, "title"], [1, "userEmailContainer"], [1, "userEmail"], ["src", "/assets/images/error_icon.svg", "width", "15", 4, "ngIf"], ["class", "userProfileArrow", 3, "ngClass", 4, "ngIf"], ["src", "/assets/images/basic/profile.svg", "width", "20", "alt", ".", 4, "ngIf"], ["src", "/assets/images/error_icon.svg", "width", "15"], [1, "userProfileArrow", 3, "ngClass"], [1, "networkProvider"], [1, "arrow_box_spaces"], ["class", "wirnet-active-status-block", 4, "ngIf"], ["class", "wirnet-active-status-block", "style", "min-height: 90px", 4, "ngIf"], [1, "wirnet-active-status-block"], [1, "wirnet-active-header"], ["class", "wirnet-list", 4, "ngFor", "ngForOf"], ["id", "btn-wirelessnetwork-status", 1, "connectBtnWNS", "wirnet-active-button", 3, "click"], ["href", "javascript:void(0);"], [1, "wirnet-list"], [1, "wirnet-list-inner"], ["style", "float: left", "src", "/assets/images/meraki.svg", 4, "ngIf"], ["src", "/assets/images/cuwn.svg", 4, "ngIf"], ["src", "/assets/images/wlc.svg", 4, "ngIf"], ["class", "wirnet-active-name", "style", "height: 30px", 4, "ngIf"], ["class", "wirnet-active-name", 4, "ngIf"], ["class", "wirnet-active-counter-block", 4, "ngIf"], ["src", "/assets/images/meraki.svg", 2, "float", "left"], ["src", "/assets/images/cuwn.svg"], ["src", "/assets/images/wlc.svg"], [1, "wirnet-active-name", 2, "height", "30px"], ["href", "javascript:void(0);", 3, "click"], ["class", "merakiAuthenticated", 4, "ngIf"], ["class", "merakiAPIAuthenticated", 4, "ngIf"], [1, "merakiAuthenticated"], [2, "font-size", "10px", "color", "#03b88c", "cursor", "pointer", "display", "block", "width", "100%", "white-space", "nowrap", "overflow", "hidden", "text-overflow", "ellipsis", 3, "click"], [2, "font-size", "10px", "color", "#f96969", "cursor", "pointer", 3, "click"], [1, "merakiAPIAuthenticated"], [2, "font-size", "10px", "color", "#03b88c", "cursor", "pointer", "display", "block", "width", "100px", "white-space", "nowrap", "overflow", "hidden", "text-overflow", "ellipsis"], [1, "wirnet-active-name"], [1, "wirnet-active-counter-block"], [1, "wirnet-active-success-count-block"], ["src", "/assets/images/tick_mark_green.svg", 1, "paddingRight5"], [1, "wirnet-active-success-count"], [1, "vertical-seperator", "paddingLR5"], [1, "wirnet-active-fail-count-block"], ["src", "/assets/images/notification_icon.svg", 1, "paddingRight5"], [1, "wirnet-active-fail-count"], [1, "wirnet-active-status-block", 2, "min-height", "90px"], [1, "connectBtnWNS", "wirnet-active-button", 3, "click"], [2, "font-size", "10px", "color", "#03b88c", "cursor", "pointer", "display", "block", "width", "100px", "white-space", "nowrap", "overflow", "hidden", "text-overflow", "ellipsis", 3, "click"], [2, "font-size", "10px", "color", "#f96969"], [1, "syncProgressLabel"], [1, "modalPopup"], [1, "modalOverlay"], [1, "modalContent", "netStat-container"], [1, "modalHeader"], [1, "divTable"], ["class", "divTableCell", "style", "width: 30px", 3, "click", 4, "ngIf"], [1, "modalCloseIcon", 3, "click"], ["id", "padding0", 1, "modalBody"], ["class", "netStat-nonet-container", 4, "ngIf"], [1, "netStat-active-container"], [1, "netStat-active-header-container"], [1, "netStat-active-header"], ["class", "netStat-network-names", 4, "ngIf"], [1, "netStat-network-names"], ["id", "navlink-wirelessnetwork-cmxconnector", 3, "ngClass", "click"], ["style", "height: 90vh; overflow-y: auto; text-align: left", "class", "netStat-block", 4, "ngIf"], ["style", "height: 90vh; overflow-y: auto", 4, "ngIf"], [1, "divTableCell", 2, "width", "30px", 3, "click"], ["src", "/assets/images/god-dashboard/go-back-left-arrow.svg", 2, "padding-right", "10px"], [1, "netStat-nonet-container"], ["src", "/assets/images/network_status_wifi_icon_grey.svg"], [1, "netStat-nonet-header"], [1, "netStat-nonet-notice"], [1, "netStat-nonet-message-box"], ["href", "javascript:void(0)", 2, "text-decoration", "underline", 3, "click"], [1, "connectBtn", "wirnet-active-button", 2, "width", "40%", "margin", "20px auto", "border", "2px solid #a9a9a9"], ["href", "javascript:void(0)", 1, "goto-loc", 2, "text-decoration", "none", "color", "#333", 3, "click"], ["class", "netStat-network noselect", 4, "ngFor", "ngForOf"], [1, "netStat-network", "noselect"], [1, "netStat-network-names", 3, "click"], ["id", "navlink-wirelessnetwork-connector", 3, "ngClass", "click"], [1, "netStat-block", 2, "height", "90vh", "overflow-y", "auto", "text-align", "left"], ["class", "netStat-a", 4, "ngFor", "ngForOf"], [1, "netStat-a"], [1, "netStat-active-block"], [1, "netStat-network-header"], [2, "font-weight", "bold", "text-transform", "uppercase", "color", "#000", "font-size", "13px"], [1, "netStat-network-list-container"], [2, "padding-left", "0px"], ["class", "netStat-network-list", 4, "ngFor", "ngForOf"], [1, "netStat-network-list"], [1, "organization-wrapper", 3, "id"], ["class", "org-expcol-wrapper", 4, "ngIf"], [1, "netStat-network-list-wipr-logo"], ["src", "/assets/images/meraki.svg", 4, "ngIf"], [1, "netStat-network-list-wipr-name"], ["style", "margin-left: 5px", 4, "ngIf"], [1, "netStat-network-list-wipr-error-message", 3, "ngClass"], [1, "netStat-network-status-indicator"], [1, "netStat-network-status-icon", 3, "ngClass"], ["class", "\n\t\t\t\t\t\t\t\t\t\t\t\t\t  netStat-inner-network-container\n\t\t\t\t\t\t\t\t\t\t\t\t  ", 4, "ngIf"], [1, "org-expcol-wrapper"], ["src", "/assets/images/expand_plus.svg", "height", "25", 3, "click", 4, "ngIf"], ["ng-mouseover", "highlightUl(n,true);", "ng-mouseleave", "highlightUl(n,false);", "src", "/assets/images/collapse_minus.svg", "height", "25", 3, "click", 4, "ngIf"], ["src", "/assets/images/expand_plus.svg", "height", "25", 3, "click"], ["ng-mouseover", "highlightUl(n,true);", "ng-mouseleave", "highlightUl(n,false);", "src", "/assets/images/collapse_minus.svg", "height", "25", 3, "click"], ["src", "/assets/images/meraki.svg"], [2, "margin-left", "5px"], ["src", "/assets/images/two_factor_icon.svg", "height", "15"], [1, "netStat-inner-network-container"], [1, "wir-network-list", 2, "display", "none", 3, "id"], ["class", "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  netStat-inner-network-wrapper\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t  ", 4, "ngFor", "ngForOf"], [1, "netStat-inner-network-wrapper"], ["src", "/assets/images/building_icon.svg", "style", "float: left", 4, "ngIf"], [1, "innerNetwork-name"], [1, "netStat-network-list-wipr-error-message", "innerNetwork-errorMessage"], [1, "netStat-network-status-icon", "innerIconRight", 3, "ngClass"], ["src", "/assets/images/building_icon.svg", 2, "float", "left"], [2, "height", "90vh", "overflow-y", "auto"], [3, "userRole", "showConnectorsUpdate", "showControllers"], [3, "userRole"], ["class", "modalContent merakiAuthPopup", 4, "ngIf"], ["class", "modalContent merakiAuthPopup textCenter", 4, "ngIf"], [1, "modalContent", "merakiAuthPopup"], ["class", "alertMsg", 4, "ngIf"], [1, "textCenter"], ["src", "/assets/images/dnaspaces_meraki.svg", "alt", "", "width", "312px"], [1, "ng-pristine", "ng-valid", "ng-valid-email", 2, "text-align", "center"], ["class", "ng-scope", 4, "ngIf"], ["style", "border: 1px solid rgb(169, 169, 169)", 4, "ngIf"], ["class", "removeMerakiLabel", 4, "ngIf"], [1, "alertMsg"], [1, "redErrorLabel"], [1, "removedMessage"], [2, "font-weight", "bold", "margin-top", "20px"], [2, "margin-top", "10px", "margin-bottom", "20px"], [1, "ng-scope"], ["type", "text", "id", "userdummy", "autocomplete", "off", 2, "display", "none"], ["type", "email", "id", "userName", "name", "userName", "autocomplete", "off", "placeholder", "Email", 1, "ng-pristine", "ng-valid", "ng-valid-email", 2, "text-align", "center", "background-color", "#fff !important", "color", "#000", 3, "ngModel", "ngModelChange"], ["type", "password", "id", "pwd", "autocomplete", "off", "placeholder", "", 2, "display", "none"], ["type", "password", "id", "passpwd", "name", "password", "autocomplete", "off", "placeholder", "Password", 1, "ng-pristine", "ng-valid", 2, "text-align", "center", "background-color", "#fff !important", "color", "#000", 3, "ngModel", "ngModelChange"], ["class", "primaryButton", "style", "display: inline-block", 3, "click", 4, "ngIf"], [1, "secondaryButton", 2, "display", "inline-block", 3, "click"], [1, "primaryButton", 2, "display", "inline-block", 3, "click"], [2, "border", "1px solid rgb(169, 169, 169)"], [2, "padding", "0", "margin-bottom", "0", "margin-left", "10px"], [2, "margin-top", "10px", "margin-bottom", "15px", "width", "auto"], ["src", "/assets/images/configure.png", 2, "float", "left", "width", "20px", "margin-left", "10px"], [2, "display", "inline-block", "margin-bottom", "10px"], [1, "primaryButton", 3, "click"], [1, "removeMerakiLabel"], [1, "modalContent", "merakiAuthPopup", "textCenter"], [1, "backArrowIcon", 3, "click"], ["src", "/assets/images/back_arrow_btn.svg", "alt", "Back"], ["class", "confirmContent", 4, "ngIf"], ["class", "successContent", 4, "ngIf"], [1, "confirmContent"], [1, "warningImage"], ["src", "/assets/images/notification_icon.svg", "alt", "Warning"], [1, "removeWarningMessage"], [1, "usernameToRemove"], [1, "removeAction"], [1, "primaryButton2", 3, "click"], [1, "cancelButton", 3, "click"], [1, "successContent"], [1, "successImage"], ["src", "/assets/images/successf_icon.svg", "alt", "Success"], [1, "successMessage"], [3, "fromPage", "hideActivationPopup"]], template: function NavigationUserInfoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, NavigationUserInfoComponent_div_1_Template, 42, 26, "div", 1);
        i0.ɵɵtemplate(2, NavigationUserInfoComponent_div_2_Template, 2, 0, "div", 2);
        i0.ɵɵtemplate(3, NavigationUserInfoComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵtemplate(4, NavigationUserInfoComponent_div_4_Template, 2, 0, "div", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtemplate(6, NavigationUserInfoComponent_div_6_Template, 2, 0, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵlistener("click", function NavigationUserInfoComponent_Template_div_click_8_listener() { return ctx.toggleHelpSection(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵlistener("click", function NavigationUserInfoComponent_Template_div_click_9_listener($event) { return ctx.showSignOut($event); });
        i0.ɵɵelementStart(10, "span");
        i0.ɵɵelement(11, "img", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, NavigationUserInfoComponent_ng_template_12_Template, 8, 5, "ng-template", 10, 11, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 12);
        i0.ɵɵelementStart(15, "lib-app-switcher", 13);
        i0.ɵɵlistener("emitState", function NavigationUserInfoComponent_Template_lib_app_switcher_emitState_15_listener($event) { return ctx.appSwitcherStateEmitted($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, NavigationUserInfoComponent_div_16_Template, 4, 2, "div", 14);
        i0.ɵɵtemplate(17, NavigationUserInfoComponent_div_17_Template, 25, 13, "div", 3);
        i0.ɵɵtemplate(18, NavigationUserInfoComponent_div_18_Template, 5, 2, "div", 3);
        i0.ɵɵtemplate(19, NavigationUserInfoComponent_div_19_Template, 2, 1, "div", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.smartLicenseObjLoaded);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isShowChangePassword);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.licenseInfoVisible);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.supportSectionVisible);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.appSwitcherBtnVisible);
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("title", ctx.getUserEmail());
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c2$g, !ctx.appSwitcherVisible ? "hideDiv" : "showDiv"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showNetworkStatus);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.networkStatusDiv.visible);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showMerakiPopup);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.smartLicensePopupVisible);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, AppSwitcherComponent, ChangePasswordComponent, LicenseInfoComponent, SupportSectionComponent, i1$2.NgForOf, CmxConnectorComponent, CiscoCmxComponent, i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i2$1.NgForm, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, SmartLicensePopupComponent], pipes: [i2.TranslatePipe], styles: ["@charset \"UTF-8\";.navigation[_ngcontent-%COMP%]{height:100%;background-color:#059fd9}.navigationWidth[_ngcontent-%COMP%]{display:flex;flex-direction:row;width:100%}div.navigation[_ngcontent-%COMP%]::-webkit-scrollbar{width:8px}div.navigation[_ngcontent-%COMP%]::-webkit-scrollbar-track{box-shadow:none;border-radius:10px;background-color:#088cbe}div.navigation[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{border-radius:10px;box-shadow:none;background-color:#fff6;border:1px solid rgba(0,0,0,0);background-clip:padding-box}.brandLogo[_ngcontent-%COMP%]{text-align:center;font-size:18px;font-weight:bold;background-color:#088cbe;color:#097dbc}.brandLogo[_ngcontent-%COMP%]   a.brandLink[_ngcontent-%COMP%]{display:block;padding:14px 0;height:65px;text-align:center;color:#e2eff7;font-family:\"ciscoSansRegular\";font-size:16px;text-decoration:none;border-bottom:1px solid rgba(255,255,255,.2);cursor:pointer}.brandImg[_ngcontent-%COMP%]{height:35px}.userProfile[_ngcontent-%COMP%]{display:block;box-shadow:inset 0 0 39px 66px #0000}.userName[_ngcontent-%COMP%]{cursor:pointer}.userName[_ngcontent-%COMP%]{display:table-cell;width:230px}.settingsDisplayIcons[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;justify-content:center;width:150px;position:relative;left:6px;top:-5px}.settingsDisplayIcons[_ngcontent-%COMP%]   .help-icon-wrap[_ngcontent-%COMP%]{position:relative;top:4px;right:8px}.settingsDisplayIcons[_ngcontent-%COMP%]   .app-switcher[_ngcontent-%COMP%]{position:relative;right:35px;top:6px}.settingsDisplayIcons[_ngcontent-%COMP%]   .userNameSpaces[_ngcontent-%COMP%]{position:relative;top:4px;left:20px;cursor:pointer}.userEmailContainer[_ngcontent-%COMP%]{display:inline;padding-right:10px}.userProfileIcon[_ngcontent-%COMP%]{font-size:28px;vertical-align:middle;display:inline;color:#fff;font-family:\"icomoon-new\";padding:5px 5px 5px 6px}.userEmail[_ngcontent-%COMP%]{font-size:16px;vertical-align:middle;display:inline-block;color:#999;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100px;font-family:\"ciscoSansRegular\"}.userProfileArrow[_ngcontent-%COMP%]{font-size:12px;vertical-align:middle;display:inline-block;color:#fff;font-family:\"icomoon-new\";padding:0 12px}.userSettings[_ngcontent-%COMP%]{display:table;width:100%;cursor:pointer;position:relative;height:60px;background-color:#059fd9;border-bottom:1px solid rgba(255,255,255,.2)}.userConnect[_ngcontent-%COMP%]{cursor:pointer;display:table-cell;vertical-align:middle;width:50%;text-align:center;padding:10px 0}.userConnect[_ngcontent-%COMP%]:first-of-type{border-right:1px solid rgba(255,255,255,.2)}.userConnectIcon[_ngcontent-%COMP%]{position:relative;width:100%;color:#fff;font-size:30px;font-family:\"icomoon-new\"}.userSettingIcon[_ngcontent-%COMP%]{position:relative;width:100%;color:#fff;font-size:30px;font-family:\"icomoon\"}.navigationList[_ngcontent-%COMP%]{max-height:80%;overflow-y:auto;background:#059fd9;margin-top:0;padding-bottom:60px}.navigationLink[_ngcontent-%COMP%]{display:block;font-weight:300;border-bottom:1px solid rgba(255,255,255,.2)}.selectedLink[_ngcontent-%COMP%]{font-weight:600;opacity:1;background:#088cbe;border-left:4px solid #FFFFFF}.navigationLink[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{opacity:.75;display:block;color:#fff;height:60px;font-size:16px;cursor:pointer;padding:18px 20px}.navigationLink[_ngcontent-%COMP%]   .boldLinks[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\"}.navigationLink[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#fff;opacity:1;text-decoration:none;background:rgba(8,140,190,.42)}.expandNavList[_ngcontent-%COMP%]{border-left:2px solid rgba(255,255,255,.2);margin-left:20px}.expandNavList[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{border-bottom:none;padding:8px 0 8px 20px;color:#fff;border-left:4px solid #059fd9;display:block;cursor:pointer;opacity:.75;font-size:14px;font-weight:300;height:auto}.expandNavLink[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative}.expandNavLink[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:before{position:absolute;right:10px;top:20px;font-size:12px;color:#fff;font-family:\"icomoon-new\"}.navLinkClose.expandNavLink[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:before{content:\"\\e905\"}.navLinkOpen.expandNavLink[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:before{content:\"\\e908\"}.navLinkClose[_ngcontent-%COMP%]   .expandNavList[_ngcontent-%COMP%]{display:none}.navLinkOpen[_ngcontent-%COMP%]   .expandNavList[_ngcontent-%COMP%]{display:block}.expandNavList[_ngcontent-%COMP%]   a.selectedSubLink[_ngcontent-%COMP%]{font-weight:600;opacity:1;background:#088cbe;border-left:4px solid #FFFFFF}.pageHeadingLink[_ngcontent-%COMP%]{color:#6a6b6c;font-weight:normal;font-size:16px;font-family:\"ciscoSansLight\"}.signOutPopup[_ngcontent-%COMP%]{display:none}.signOutVisible[_ngcontent-%COMP%]{display:block}.signOutPopupContainer[_ngcontent-%COMP%]{height:auto;width:300px;background:#fff;position:absolute;top:77px;box-shadow:0 0 3px #00000080;left:calc(100% - 320px);z-index:1;padding-top:15px}.signOutPopupContainer[_ngcontent-%COMP%]:before{content:\"\";position:absolute;bottom:100%;right:0;width:45px;height:0;border-bottom:5px solid #049fd9}.userProfileIcon_grey[_ngcontent-%COMP%]{font-size:60px;color:#d8d8d8;display:block;font-family:\"icomoon-new\"}.signOutButton[_ngcontent-%COMP%]{font-size:14px;font-weight:bold;cursor:pointer;border:1px solid #d2d2d2;width:75%;margin:0 auto;border-radius:20px;position:relative;top:10px;height:30px;line-height:30px}.signOutPopupInner[_ngcontent-%COMP%]{text-align:center}.userEmailPopup[_ngcontent-%COMP%]{font-size:13px;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:calc(100% - 34px);font-family:\"ciscoSansRegular\";margin:0 auto;color:#414f5f}.navUserActions[_ngcontent-%COMP%]{width:90%;margin:0 auto;padding:15px 0;border-top:1px solid #dfdfdf}.vertical-line[_ngcontent-%COMP%]{height:25px;width:1px;background-color:#9a9a9a;position:relative;top:15px}.rotateDiv[_ngcontent-%COMP%]{transform:rotate(180deg);-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg)}.navigationLink.cursorDisabled[_ngcontent-%COMP%], .navigationLink.cursorDisabled[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{cursor:not-allowed}.has-children-open[_ngcontent-%COMP%]{background:url(/assets/images/navigation_collapse_icon.svg) no-repeat 96% center!important;background-size:30px;opacity:.75}.has-children-closed[_ngcontent-%COMP%]{background:url(/assets/images/navigation_expand_icon.svg) no-repeat 96% center!important;background-size:30px;opacity:.75}.children[_ngcontent-%COMP%]{padding-bottom:10px;border-bottom:1px solid rgba(255,255,255,.2);overflow:hidden;border-bottom:none;width:100%}.location-border-left[_ngcontent-%COMP%]{border-left:2px solid rgba(255,255,255,.2);margin-left:20px}a.child-label[_ngcontent-%COMP%]{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;font-size:14px!important;line-height:40px;padding:0 24px!important;height:40px!important}.settingsNavigation[_ngcontent-%COMP%]{height:60px;display:table;width:100%;background-color:#059fd9;text-align:center;border-bottom:1px solid rgba(255,255,255,.2)}.settingsNavigationWidth[_ngcontent-%COMP%]   .monitor-ico[_ngcontent-%COMP%]{cursor:pointer;position:relative;top:5px;right:5px}.app-switcher-icon[_ngcontent-%COMP%]{background:url(/assets/images/app_switcher.svg) no-repeat center!important;background-size:contain!important;height:17px;width:17px;margin:0 auto;border-left:none;cursor:pointer}.help-icon[_ngcontent-%COMP%]{background:url(/assets/images/basic/support/help_icon.svg) no-repeat center!important;background-size:contain!important;height:21px;width:21px;border-left:none;cursor:pointer}.network-error-status-icon[_ngcontent-%COMP%]{background:url(/assets/images/wifi_off.svg) no-repeat center!important;background-size:contain!important;height:26px;width:26px;margin:0 auto;border-left:none}.network-success-status-icon[_ngcontent-%COMP%]{background:url(/assets/images/wifi_on.svg) no-repeat center!important;background-size:contain!important;height:26px;width:26px;margin:0 auto;border-left:none}.settingsLink[_ngcontent-%COMP%]:hover{opacity:.9;background:rgba(8,140,190,.42)}.changePasswordBtn[_ngcontent-%COMP%]{display:block;width:75%;margin:20px auto;height:44px}.navPopupButton[_ngcontent-%COMP%]{background-color:#fff;text-align:left;display:flex;vertical-align:middle;font-size:15px;font-family:\"ciscoSansLight\";padding:10px 18px;color:#414f5f;outline:none;width:100%}.navPopupButton[_ngcontent-%COMP%]:hover{opacity:.8}.navPopupLinks[_ngcontent-%COMP%]{padding-left:10px;cursor:pointer}.logOutBtn[_ngcontent-%COMP%]{height:35px;line-height:35px;width:85%;background:#00a1df;color:#fff;margin:10px auto 15px;font-family:ciscoSansLight;font-weight:700;font-size:14px;border-radius:5px;cursor:pointer}.logOutBtn[_ngcontent-%COMP%]:hover{opacity:.8}.logOutBtn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#fff}.networkProvider[_ngcontent-%COMP%]{position:absolute;top:75px;left:calc(100% - 490px);width:400px!important;overflow:visible!important;z-index:9999}.arrow_box[_ngcontent-%COMP%]{z-index:1001;background:#fff;border:1px solid #fff;border-radius:10px;box-shadow:-1px 1px 5px #000000bf;text-align:center;padding:20px}.arrow_box[_ngcontent-%COMP%]:after, .arrow_box[_ngcontent-%COMP%]:before{bottom:100%;left:20%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.wirnet-active-status-block[_ngcontent-%COMP%]{min-height:150px}.wirnet-active-header[_ngcontent-%COMP%]{text-transform:uppercase;font-size:12px;text-align:left;padding-bottom:7px;border-bottom:1px solid #ccc;font-weight:bold}.wirnet-list[_ngcontent-%COMP%]{text-align:left;border-bottom:1px solid #ccc;height:50px}.wirnet-list-inner[_ngcontent-%COMP%]{padding:12px 0}.wirnet-active-name[_ngcontent-%COMP%]{display:inline-block;font-weight:bold;font-size:13px;padding-left:5px;width:50%}.wirnet-active-counter-block[_ngcontent-%COMP%]{display:inline-block;float:right}.connectBtnWNS[_ngcontent-%COMP%]{border:1px solid #c4c4c4;padding:10px 0;width:80%;margin:30px auto 0;border-radius:20px;font-size:14px;font-weight:bold;cursor:pointer}.wirnet-active-success-count-block[_ngcontent-%COMP%], .wirnet-active-fail-count-block[_ngcontent-%COMP%]{display:inline-block}.wirnet-active-success-count-block[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{display:inline-block;height:15px}.wirnet-active-success-count[_ngcontent-%COMP%], .wirnet-active-fail-count[_ngcontent-%COMP%]{display:inline-block;font-weight:bold;font-size:12px}.wirnet-active-fail-count-block[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{height:17px;display:inline-block}.netStat-container[_ngcontent-%COMP%]{height:96vh;width:98%;background:#f7f9fb;margin:2vh auto auto;top:0}.wirnet-error-status-icon[_ngcontent-%COMP%]{background:url(/assets/images/network_status_wifi_icon_white.svg) no-repeat center!important;height:50px;width:50px;margin:0 auto}.wirnet-nonet-status-block[_ngcontent-%COMP%]{min-height:200px}.wirnet-nonet-status-message[_ngcontent-%COMP%]{padding:10px 10px 20px;font-weight:bold;border-bottom:1px solid #ccc}.wirnet-nonet-icon[_ngcontent-%COMP%]{background:url(/assets/images/network_status_wifi_icon_grey.svg) no-repeat center!important;height:50px;width:50px;margin:20px auto}a#switchAccount[_ngcontent-%COMP%]{padding:13px;color:#000}#switchAccount[_ngcontent-%COMP%]{text-decoration:none!important}.wirnet-active-status-block[_ngcontent-%COMP%]{min-height:150px}.wirnet-active-header[_ngcontent-%COMP%]{text-transform:uppercase;font-size:12px;text-align:left;padding-bottom:7px;border-bottom:1px solid #ccc;font-weight:bold}.arrow_box[_ngcontent-%COMP%]{padding:20px}.wirnet-list[_ngcontent-%COMP%]{text-align:left;border-bottom:1px solid #ccc;height:50px}.wirnet-list-inner[_ngcontent-%COMP%]{padding:12px 0}.wirnet-active-name[_ngcontent-%COMP%]{display:inline-block;font-weight:bold;font-size:13px;padding-left:5px;width:50%}.wirnet-active-counter-block[_ngcontent-%COMP%]{display:inline-block;float:right}.wirnet-active-success-count-block[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{display:inline-block;height:15px}.wirnet-active-fail-count-block[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{height:17px;display:inline-block}.wirnet-active-success-count-block[_ngcontent-%COMP%], .wirnet-active-fail-count-block[_ngcontent-%COMP%]{display:inline-block}.wirnet-active-success-count[_ngcontent-%COMP%], .wirnet-active-fail-count[_ngcontent-%COMP%]{display:inline-block;font-weight:bold;font-size:12px}.vertical-seperator[_ngcontent-%COMP%]{color:#ccc}.img-hidden[_ngcontent-%COMP%]{display:none}#blackOverlay[_ngcontent-%COMP%]{z-index:9999}.netStat-popup[_ngcontent-%COMP%]{display:block}.netStat-active-container[_ngcontent-%COMP%]{height:85vh;width:100%;display:table}.netStat-container[_ngcontent-%COMP%]{height:96vh;width:98%;background:#f7f9fb;margin:2vh auto auto}.netStat-header[_ngcontent-%COMP%]{background:#fff;border-bottom:1px solid #e6e6e6;height:10vh}.netStat-header-left[_ngcontent-%COMP%]{line-height:80px;width:50%;float:left;font-size:20px;font-weight:bold;padding-left:30px}.netStat-header-right[_ngcontent-%COMP%]{text-align:right}.netStat-header-right[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{position:relative;right:25px;top:20px;line-height:5vh;font-size:15px;color:#6a6b6c;font-family:\"icomoon-new\";padding:12px;cursor:pointer}.netStat-header-right[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:none}.netStat-nonet-container[_ngcontent-%COMP%]{width:50%;margin:10px auto;text-align:center;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.netStat-nonet-container[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{margin:0 auto;height:80px;border:none}.netStat-nonet-header[_ngcontent-%COMP%]{font-size:27px;font-weight:bold}.netStat-nonet-notice[_ngcontent-%COMP%]{font-weight:bold;padding:17px 100px;font-size:14px}.netStat-nonet-message-box[_ngcontent-%COMP%]{text-align:left;border:2px solid #a9a9a9;padding:20px 40px;width:80%;margin:0 auto}.netStat-nonet-message-box[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{font-size:13px;list-style-type:decimal;font-weight:bold;padding:3px}.netStat-active-header-container[_ngcontent-%COMP%]{background-color:#f6f9fb;width:20%;display:table-cell;vertical-align:top;box-shadow:0 0 2px #00000080}.netStat-network-names[_ngcontent-%COMP%]{font-size:15px;font-weight:bold;cursor:pointer;border-bottom:1px solid #c4c4c4}.netStat-network-names[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:18px}.default-network[_ngcontent-%COMP%]{padding:20px 30px}.active-network[_ngcontent-%COMP%]{padding:20px 30px;background-color:#fff;color:#009eea;border-left:4px solid #009eea}.noselect[_ngcontent-%COMP%]{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.netStat-block[_ngcontent-%COMP%]{height:72vh;width:80%;display:flex}.netStat-a[_ngcontent-%COMP%]{width:100%}.netStat-active-block[_ngcontent-%COMP%]{padding:50px 10px;height:100%;width:100%;margin:0 auto;overflow-y:auto}.netStat-network-list-container[_ngcontent-%COMP%]{background:#fff;border:1px solid #e4e4e4;overflow-y:auto;width:80%;margin:0 auto;max-height:calc(100vh - 200px)}.netStat-network-header[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:50%;float:left;color:#939494}.netStat-network-header[_ngcontent-%COMP%]{padding-bottom:30px;font-size:13px;width:80%;margin:0 auto}.netStat-network-header[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-of-type(2){text-align:right}.netStat-network-list-wipr-logo[_ngcontent-%COMP%]{width:3%;float:left;text-align:center}.netStat-network-list-wipr-name[_ngcontent-%COMP%]{width:45%;float:left;font-weight:bold;line-height:25px}.netStat-network-list[_ngcontent-%COMP%]{width:100%;padding:14px;overflow:auto}.netStat-network-list-wipr-error-message[_ngcontent-%COMP%]{width:49%;height:25px;line-height:25px;float:left;color:#f26968;font-size:14px;font-weight:bold;text-align:right;padding-right:20px;overflow:hidden}.netStat-network-status-indicator[_ngcontent-%COMP%]{width:2%;float:right}.netStat-network-status-icon[_ngcontent-%COMP%]{width:13px;height:13px;border-radius:100px;-webkit-border-radius:100px;-moz-border-radius:100px;float:right;position:relative;top:3px;right:10px}.netStat-success[_ngcontent-%COMP%]{background:url(/assets/images/tick_mark_green.svg) center no-repeat;background-size:contain;height:17px;width:17px}.netStat-failure[_ngcontent-%COMP%]{background:url(/assets/images/notification_icon.svg) center no-repeat;background-size:contain;height:17px;width:17px}.netStat-error-icon[_ngcontent-%COMP%]{position:relative;top:-10px;left:27px;z-index:999}.netStat-wipr-icon[_ngcontent-%COMP%]{position:relative;left:-10px}.netStat-hide-error-icon[_ngcontent-%COMP%]{visibility:hidden}.netStat-loader[_ngcontent-%COMP%]{position:absolute;text-align:center;z-index:10011;width:70%;height:100%}.organization-wrapper[_ngcontent-%COMP%]{overflow:auto}.netStat-inner-network-wrapper[_ngcontent-%COMP%]{width:98%;border:1px solid #e4e4e4;padding:10px;height:43px;margin:10px 5% 10px 26px}.org-expcol-wrapper[_ngcontent-%COMP%]{width:6%;text-align:right;float:left}.org-expcol-wrapper[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{cursor:pointer}.org-expcol-wrapper[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]:hover{cursor:pointer;opacity:.8}.innerNetwork-name[_ngcontent-%COMP%]{display:inline-block;width:43%;float:left;font-weight:bold;padding-left:10px}.innerNetwork-errorMessage[_ngcontent-%COMP%]{width:52%}.innerIconRight[_ngcontent-%COMP%]{right:4px}.errorWidth[_ngcontent-%COMP%]{width:43%}.wir-network-list[_ngcontent-%COMP%]{display:none;border-left:1px solid #138cd2;margin-left:50px;padding-left:10px;transition-duration:.1s;transition-timing-function:linear;margin-top:-2px;background-image:url(/assets/images/lh-hline-hover.svg);background-repeat:no-repeat;background-position-y:bottom}.activeLine[_ngcontent-%COMP%]{background:url(/assets/images/lh-hline-hover.svg) no-repeat left bottom;border-left:1px solid #138cd2}.inActiveLine[_ngcontent-%COMP%]{background-image:url(/assets/images/lh-line.svg);background-repeat:no-repeat;background-position-y:bottom;border-left:1px solid #e4e4e4}.notification-error-overlay[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;background:rgba(0,0,0,.3);display:none;z-index:9999}.notification-error-overlay.show[_ngcontent-%COMP%]{display:block}.notification-errors.slide-in[_ngcontent-%COMP%]{animation:slide-in .5s forwards;-webkit-animation:slide-in .5s forwards}@keyframes slide-in{to{transform:translate(0)}}.notification-errors.slide-out[_ngcontent-%COMP%]{animation:slide-out .5s forwards}@keyframes slide-out{to{transform:translate(100%)}}.notification-errors[_ngcontent-%COMP%]{width:30%;position:absolute;right:0;top:0;height:100%;overflow-y:auto;background-color:#fff;transform:translate(100%)}.notification-error-header[_ngcontent-%COMP%]{background-color:#414f5f;width:100%;padding:20px}.notification-error-heading[_ngcontent-%COMP%]{color:#fff;font-weight:500}.notification-error-close[_ngcontent-%COMP%]{font-size:14px;color:#eaeaea;float:right;cursor:pointer}.notification-error-list[_ngcontent-%COMP%]{padding:20px}.notification-name[_ngcontent-%COMP%]{color:#000;margin:5px 0}.notification-time[_ngcontent-%COMP%]{color:#ccc;float:right;font-size:12px;font-weight:normal}.notification-path[_ngcontent-%COMP%]{color:#ccc;margin:5px 0}.notification-path[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{position:relative;display:inline-block}.notification-desc[_ngcontent-%COMP%]{color:#666;line-height:18px}.notification-right-arrow[_ngcontent-%COMP%]{padding-right:5px}.notification-path[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:last-child   .notification-right-arrow[_ngcontent-%COMP%]{display:none}.notification-list-item[_ngcontent-%COMP%]{padding-bottom:10px;margin-bottom:10px;border-bottom:1px solid #dddfe2}.disabledBtn[_ngcontent-%COMP%]{cursor:not-allowed!important;opacity:.5}.disabledBtn[_ngcontent-%COMP%]:hover, .disabledBtn[_ngcontent-%COMP%]:focus{text-decoration:none}.syncErrorDiv[_ngcontent-%COMP%]{position:fixed;top:0;right:146px;margin-top:4px;height:45px}.floatRight[_ngcontent-%COMP%]{float:right}.notification-sync[_ngcontent-%COMP%]{padding:10px}.notification-link[_ngcontent-%COMP%]{padding:12px 15px;display:inline;position:relative}.syncProgress[_ngcontent-%COMP%], .syncComplete[_ngcontent-%COMP%], .syncCheck[_ngcontent-%COMP%]{display:none}.notification-link[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{padding:10px 0;position:relative}.notification-error-number[_ngcontent-%COMP%]{background-color:#f86969;position:relative;top:-50px;display:block!important;right:-30px;color:#fff;font-weight:normal;font-size:10px;width:28px;height:28px;border-radius:50%;text-align:center;padding:5px 4px;border:2px solid #fff}.notification-error-number[_ngcontent-%COMP%]:hover{color:#fff;font-weight:bold}.vertical-line-left[_ngcontent-%COMP%]{height:18px;position:relative;top:5px;left:-10px;width:1px;background-color:#cecece;display:inline-block}.vertical-line-right[_ngcontent-%COMP%]{height:18px;position:relative;top:5px;right:-15px;width:1px;background-color:#cecece;display:inline-block}@keyframes rotating{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.rotating[_ngcontent-%COMP%]{animation:rotating 3s linear infinite}.notification-error-overlay[_ngcontent-%COMP%]{position:fixed;top:0;width:100%;height:100%;background:rgba(0,0,0,.3);display:none;z-index:9999}.show[_ngcontent-%COMP%]{display:block!important}.notification-error-empty[_ngcontent-%COMP%]{width:70%;height:100%}.merakiAuthPopup[_ngcontent-%COMP%]{width:40%;left:50%;top:80px}.alertMsg[_ngcontent-%COMP%]{padding:10px 0;color:red;font-size:12px}.redErrorLabel[_ngcontent-%COMP%]{color:#f26968;font-family:\"ciscoSansRegular\";font-size:14px;text-align:center}.removedMessage[_ngcontent-%COMP%]{color:#6a6b6c;font-size:12px;font-family:\"ciscoSansLight\"}.removeMerakiLabel[_ngcontent-%COMP%]{font-size:12px;text-align:center;font-family:\"ciscoSansRegular\";margin-top:20px;color:#4d4d4d}.removeMerakiLabel[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:underline;color:#4d4d4d}.backArrowIcon[_ngcontent-%COMP%]{position:absolute;cursor:pointer;top:12px;left:30px}.warningImage[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:60px;margin-top:20px;height:auto}.removeWarningMessage[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-bottom:0;margin-top:5px;color:#000;font-family:\"ciscoSansLight\";font-size:14px}.removeWarningMessage[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin-bottom:20px;margin-top:5px;font-size:12px;color:#6a6b6c;font-family:\"ciscoSansLight\"}.removeWarningMessage[_ngcontent-%COMP%]   h4.usernameToRemove[_ngcontent-%COMP%]{font-weight:bold;font-family:\"ciscoSansRegular\"}.successMessage[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-bottom:0;font-family:\"ciscoSansRegular\";font-weight:bold}.successMessage[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin-top:5px;margin-bottom:20px;font-family:\"ciscoSansLight\"}.syncProgressLabel[_ngcontent-%COMP%]{font-size:12px;margin-top:5px}.arrow_box_spaces[_ngcontent-%COMP%]{z-index:1001;background:#fff;border:1px solid #fff;border-radius:10px;box-shadow:-1px 1px 5px #000000bf;text-align:center;padding:20px}.arrow_box_spaces[_ngcontent-%COMP%]:after, .arrow_box_spaces[_ngcontent-%COMP%]:before{bottom:100%;right:35px;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.arrow_box_spaces[_ngcontent-%COMP%]:before, .arrow_box_userAccount[_ngcontent-%COMP%]:before{border-color:#c2e1f500;border-bottom-color:#000;border-width:20px;margin-left:-20px}.arrow_box_spaces[_ngcontent-%COMP%]:after, .arrow_box_userAccount[_ngcontent-%COMP%]:after{border-color:#88b7d500;border-bottom-color:#fff;border-width:20px;margin-left:-20px}.paddingRight5[_ngcontent-%COMP%]{padding-right:5px}.paddingLR5[_ngcontent-%COMP%]{padding:0 5px}#padding0[_ngcontent-%COMP%]{padding:0}.divTableLoginHistory[_ngcontent-%COMP%]{display:table;width:100%;font-size:12px;padding:2% 5%}.divTableCell1LocHistory[_ngcontent-%COMP%]{display:table-cell;width:65%;vertical-align:middle;padding:10px}.divTableCell1LocHistory[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:11px;padding-bottom:5px;text-align:left;color:#939393;font-family:ciscoSans}.divTableCell1LocHistory[_ngcontent-%COMP%]   .lastLogin[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:11px;text-align:left;color:#353535}.divTableCell2LocHistory[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.divTableCell2LocHistory[_ngcontent-%COMP%]   .viewHistory[_ngcontent-%COMP%]{font-weight:bold;color:#3986e2;font-family:ciscoSans;cursor:pointer}.userInfoWrapper[_ngcontent-%COMP%]{text-align:left;padding:10px;display:flex;flex-direction:row}.userInfoWrapper[_ngcontent-%COMP%]   .userProfile[_ngcontent-%COMP%]{width:80%}.userInfoWrapper[_ngcontent-%COMP%]   .userProfile[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(1){font-size:20px}.userInfoWrapper[_ngcontent-%COMP%]   .userProfile[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(2){font-family:\"ciscoSansLight\";color:#606060}.userLicenseInfoWrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;padding:15px;border-top:1px solid #DFDFDF;width:95%;margin:0 auto}.userLicenseInfoWrapper[_ngcontent-%COMP%]   .licenseText[_ngcontent-%COMP%]{padding:0 20px;display:flex;flex-direction:column;text-align:left}.userLicenseInfoWrapper[_ngcontent-%COMP%]   .licenseText[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(1){font-size:12px;font-family:\"ciscoSansLight\"}.userLicenseInfoWrapper[_ngcontent-%COMP%]   .licenseText[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(2){font-size:15px;font-family:\"ciscoSans\"}.userLicenseInfoWrapper[_ngcontent-%COMP%]   .licenseText[_ngcontent-%COMP%]   .see[_ngcontent-%COMP%]{color:#069ddd}.userLicenseInfoWrapper[_ngcontent-%COMP%]   .licenseText[_ngcontent-%COMP%]   .act[_ngcontent-%COMP%]{color:#fbab18}.userLicenseInfoWrapper[_ngcontent-%COMP%]   .licenseText[_ngcontent-%COMP%]   .extend[_ngcontent-%COMP%]{color:#6ebe4a}.appSwitcher[_ngcontent-%COMP%]{animation:fadein .5s}.hideDiv[_ngcontent-%COMP%]{display:none}.showDiv[_ngcontent-%COMP%]{display:block}@keyframes fadein{0%{opacity:0}to{opacity:1}}.OutOfCompliance[_ngcontent-%COMP%]{color:red}.showDiv-on-Mousehover[_ngcontent-%COMP%]{display:none}.OutOfCompliance[_ngcontent-%COMP%]:hover + .showDiv-on-Mousehover[_ngcontent-%COMP%]{display:block}.modalContent-act[_ngcontent-%COMP%]{width:360px;left:-180px;top:180px;position:absolute;background:white;padding:5px;box-shadow:0 0 20px #0000004d;transform:translate(-50%);-webkit-transform:translateX(-50%);-webkit-box-shadow:0 0 20px rgba(0,0,0,.3);opacity:1}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{margin:0;opacity:1!important}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]{display:flex;height:115px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 10px 10px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-red[_ngcontent-%COMP%]{color:red;font-family:CiscoSans;font-size:18px;line-height:26px;letter-spacing:.5px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#000;font-family:CiscoSansLight;font-size:12px;opacity:.7}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]:hover{opacity:1!important}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]{width:100%;border-top:1px solid #b2a6a6;text-align:center;padding-top:5px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]   .popup-footer-text[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:13px;color:#fff}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationUserInfoComponent, [{
        type: Component,
        args: [{
                selector: "app-navigation-user-info",
                templateUrl: "./navigation-user-info.component.html",
                styleUrls: ["./navigation-user-info.component.scss"]
            }]
    }], function () { return [{ type: LoggerService }, { type: i1.Router }, { type: LocationService }, { type: DataService }, { type: AuthService }, { type: UserService }, { type: InteractionService }, { type: i2.TranslateService }]; }, { setup: [{
            type: Input
        }], navChange: [{
            type: Output
        }], onSettingsShow: [{
            type: Output
        }], onChangePasswordShow: [{
            type: Output
        }], isDashboardAdmin: [{
            type: Input
        }], clickEvent: [{
            type: HostListener,
            args: ["window:click", ["$event"]]
        }] }); })();

class OpenRoamingService extends BaseService {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.globalStats = new BehaviorSubject({});
        this.withSampleData = new BehaviorSubject(false);
        this.getSampleStatusResponse = "/assets/data/open-roaming-status.json?"; // for testing needs to remove this line and also file
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getAppCurrentStatus = (appName) => {
            const url = this.apiConfig.getCurrentAppStatusUrl(appName);
            return this.get(url).pipe(map$1(this.extractResponse));
            // testing purpose
            // return this.get(this.getSampleStatusResponse)
            //     .pipe(map(this.extractResponse));
        };
        this.inviteAppUser = (appName, userInfo) => {
            const serverUrl = this.apiConfig.getAppInviteUrl(appName);
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.deleteAppUser = (appName, userInfo) => {
            const opts = {
                body: userInfo
            };
            const serverUrl = this.apiConfig.getAppDeleteUrl(appName);
            return this.delete(serverUrl, opts).pipe(map$1(this.extractResponse));
        };
        this.getAppUserDeleteStatus = (appName, emailArr) => {
            const serverUrl = this.apiConfig.getAppDeleteStatusUrl(appName);
            return this.post(serverUrl, emailArr).pipe(map$1(this.extractResponse));
        };
        this.editAppUser = (appName, userInfo) => {
            const serverUrl = this.apiConfig.getAppEditUrl(appName);
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.getAppUserList = (appName) => {
            const serverUrl = this.apiConfig.getRBACAppUserListUrl(appName);
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getAppUserInfo = (appName, inviteUserEmail) => {
            const getUserInfoUrl = this.apiConfig.getRBACAppUserInfoUrl(appName, inviteUserEmail);
            return this.get(getUserInfoUrl).pipe(map$1(this.extractResponse));
        };
        this.resendAppInvite = (userInfo) => {
            const serverUrl = this.apiConfig.getResendAppInviteEmailUrl();
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
    }
    static getInstance() {
        if (OpenRoamingService.instance === null) {
            OpenRoamingService.instance = new OpenRoamingService(null);
        }
        return OpenRoamingService.instance;
    }
    setGlobalStats(value) {
        if (!this.globalStats)
            this.globalStats = new BehaviorSubject(null);
        this.globalStats.next(value);
    }
    getGlobalStats() {
        if (!this.globalStats)
            this.globalStats = new BehaviorSubject(null);
        return this.globalStats;
    }
    setWithSampleData(value) {
        if (!this.withSampleData)
            this.withSampleData = new BehaviorSubject(false);
        this.withSampleData.next(value);
    }
    getWithSampleData() {
        if (!this.withSampleData)
            this.withSampleData = new BehaviorSubject(false);
        return this.withSampleData;
    }
}
OpenRoamingService.instance = null;
OpenRoamingService.ɵfac = function OpenRoamingService_Factory(t) { return new (t || OpenRoamingService)(i0.ɵɵinject(i0.Injector)); };
OpenRoamingService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: OpenRoamingService, factory: OpenRoamingService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OpenRoamingService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: i0.Injector }]; }, null); })();
const openRoamingServiceFactory = () => {
    return OpenRoamingService.getInstance();
};
const OPEN_ROAMING_SERVICE_PROVIDER = [
    {
        provide: OpenRoamingService,
        deps: [],
        useFactory: openRoamingServiceFactory
    }
];

var dummyGlobalStats = {
    overall: {
        devices: { all: 1275497, returning: 0 },
        traffic: { all: 1216293 }
    },
    startDate: "2019-05-26"
};

class OpenRoamingGlobalStateService extends BaseService {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.extractResponse = (res) => {
            return res;
        };
        this.getGlobalStatistics = (params) => {
            const serverUrl = this.apiConfig.getOpenRoamingGlobalStats();
            return this.get(serverUrl, { params }).pipe(map$1(this.extractResponse));
        };
    }
}
OpenRoamingGlobalStateService.ɵfac = function OpenRoamingGlobalStateService_Factory(t) { return new (t || OpenRoamingGlobalStateService)(i0.ɵɵinject(i0.Injector)); };
OpenRoamingGlobalStateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: OpenRoamingGlobalStateService, factory: OpenRoamingGlobalStateService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OpenRoamingGlobalStateService, [{
        type: Injectable
    }], function () { return [{ type: i0.Injector }]; }, null); })();

/**
 * JS Commarization, Number to words from Million, Billion, Trillion
 */
class Commarize {
    transform(num) {
        const units = [
            "",
            "k",
            "Million",
            "Billion",
            "Trillion",
            "Quadrillion",
            "Quintillion"
        ];
        if (!num) {
            return `0`;
        }
        else if (1e3 > num) {
            //for numbers less than to 1k
            return `${num.toLocaleString()}`;
        }
        const i = Math.floor(Math.log(num) / Math.log(1000));
        return `${(+(num / Math.pow(1000, i)).toFixed(0)).toLocaleString()}<span>${units[i]}</span>`;
    }
}
Commarize.ɵfac = function Commarize_Factory(t) { return new (t || Commarize)(); };
Commarize.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "commarize", type: Commarize, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Commarize, [{
        type: Pipe,
        args: [{ name: "commarize" }]
    }], null, null); })();

const sizes = ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
const _byteToUnit = (bytes) => {
    if (!bytes || 0 === bytes) {
        return `0`;
    }
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
    if (0 >= i) {
        return `${(+bytes.toFixed(1)).toLocaleString()}<span> ${sizes[0]}</span>`;
    }
    return `${(+(bytes / Math.pow(1024, i)).toFixed(2)).toLocaleString()}<span> ${sizes[i]}</span>`;
};
class ByteToUnit {
    constructor(translate, dataService) {
        this.translate = translate;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.translateKeys = [];
        this.getTextKeys = () => {
            this.translate.get('shared-lib.byte-unit.Bytes').subscribe((res) => {
                this.translateKeys["Bytes"] = res;
            });
            this.translate.get('shared-lib.byte-unit.KiB').subscribe((res) => {
                this.translateKeys["KiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.MiB').subscribe((res) => {
                this.translateKeys["MiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.GiB').subscribe((res) => {
                this.translateKeys["GiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.TiB').subscribe((res) => {
                this.translateKeys["TiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.PiB').subscribe((res) => {
                this.translateKeys["PiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.EiB').subscribe((res) => {
                this.translateKeys["EiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.ZiB').subscribe((res) => {
                this.translateKeys["ZiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.YiB').subscribe((res) => {
                this.translateKeys["YiB"] = res;
            });
        };
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe(() => {
            // Add all fetching of localized string here
            this.getTextKeys();
        });
    }
    transform(bytes) {
        if (!bytes || 0 === bytes) {
            return `0`;
        }
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
        if (0 >= i) {
            return `${(+bytes.toFixed(1)).toLocaleString()}<span>${this.translateKeys[sizes[0]]}</span>`;
        }
        return `${(+(bytes / Math.pow(1024, i)).toFixed(2)).toLocaleString()}<span>${this.translateKeys[sizes[i]]}</span>`;
    }
}
ByteToUnit.ɵfac = function ByteToUnit_Factory(t) { return new (t || ByteToUnit)(i0.ɵɵdirectiveInject(i2.TranslateService, 16), i0.ɵɵdirectiveInject(DataService, 16)); };
ByteToUnit.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "byteToUnit", type: ByteToUnit, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ByteToUnit, [{
        type: Pipe,
        args: [{ name: "byteToUnit" }]
    }], function () { return [{ type: i2.TranslateService }, { type: DataService }]; }, null); })();
class ByteToUnitWithRoundOff {
    constructor(translate, dataService) {
        this.translate = translate;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.translateKeys = [];
        this.getTextKeys = () => {
            this.translate.get('shared-lib.byte-unit.Bytes').subscribe((res) => {
                this.translateKeys["Bytes"] = res;
            });
            this.translate.get('shared-lib.byte-unit.KiB').subscribe((res) => {
                this.translateKeys["KiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.MiB').subscribe((res) => {
                this.translateKeys["MiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.GiB').subscribe((res) => {
                this.translateKeys["GiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.TiB').subscribe((res) => {
                this.translateKeys["TiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.PiB').subscribe((res) => {
                this.translateKeys["PiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.EiB').subscribe((res) => {
                this.translateKeys["EiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.ZiB').subscribe((res) => {
                this.translateKeys["ZiB"] = res;
            });
            this.translate.get('shared-lib.byte-unit.YiB').subscribe((res) => {
                this.translateKeys["YiB"] = res;
            });
        };
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe(() => {
            // Add all fetching of localized string here
            this.getTextKeys();
        });
    }
    transform(bytes) {
        if (!bytes || 0 === bytes) {
            return `0`;
        }
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
        if (0 >= i) {
            return `${(+bytes.toFixed(0)).toLocaleString()}<span>${this.translateKeys[sizes[0]]}</span>`;
        }
        return `${(+(bytes / Math.pow(1024, i)).toFixed(0)).toLocaleString()}<span>${this.translateKeys[sizes[i]]}</span>`;
    }
}
ByteToUnitWithRoundOff.ɵfac = function ByteToUnitWithRoundOff_Factory(t) { return new (t || ByteToUnitWithRoundOff)(i0.ɵɵdirectiveInject(i2.TranslateService, 16), i0.ɵɵdirectiveInject(DataService, 16)); };
ByteToUnitWithRoundOff.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "byteToUnitWithRoundOff", type: ByteToUnitWithRoundOff, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ByteToUnitWithRoundOff, [{
        type: Pipe,
        args: [{ name: "byteToUnitWithRoundOff" }]
    }], function () { return [{ type: i2.TranslateService }, { type: DataService }]; }, null); })();

function OpenRoamingGlobalStatsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 3);
    i0.ɵɵelement(5, "span", 4);
    i0.ɵɵpipe(6, "commarize");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 3);
    i0.ɵɵelement(10, "span", 4);
    i0.ɵɵpipe(11, "byteToUnit");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "shared-lib.reports.global-stats.text"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(6, 7, ctx_r0.statistics.overall.devices.all), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 9, "shared-lib.reports.global-stats.total-dev"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(11, 11, ctx_r0.statistics.overall.traffic.all), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 13, "shared-lib.reports.global-stats.data-transferred"), " ");
} }
class OpenRoamingGlobalStatsComponent {
    constructor(
    // eslint-disable-next-line no-unused-vars
    router, 
    // private route: ActivatedRoute,
    // eslint-disable-next-line no-unused-vars
    dataService, 
    // eslint-disable-next-line no-unused-vars
    openRoamingGlobalStateService, 
    // eslint-disable-next-line no-unused-vars
    locationService, 
    // eslint-disable-next-line no-unused-vars
    openRoamingService, 
    // eslint-disable-next-line no-unused-vars
    authService) {
        this.router = router;
        this.dataService = dataService;
        this.openRoamingGlobalStateService = openRoamingGlobalStateService;
        this.locationService = locationService;
        this.openRoamingService = openRoamingService;
        this.authService = authService;
        this.unsubscribe$ = new Subject();
        this.userRole = "";
        this.isUserRoleAvailable = false;
        this.subscribeLocationHierarchy = () => {
            this.locationService
                .getORLocationTree()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((locationTreeArray) => {
                // this.locationTreeArray = locationTreeArray;
                console.log("this.locationTreeArray::", locationTreeArray);
                this.doOpenRoaming();
            }, (error) => {
                console.log("error:: loading base component", error);
                if (error.status == 401) {
                    this.locationService.signOut();
                }
            });
        };
        this.doOpenRoaming = () => {
            combineLatest(this.openRoamingService.getWithSampleData(), from(this.dataService.getLocationWrap()), (withSampleData, { location }) => {
                return { withSampleData, location };
            }).subscribe(({ withSampleData, location }) => {
                if (withSampleData && true === withSampleData) {
                    this.statistics = dummyGlobalStats;
                    this.openRoamingService.setGlobalStats(dummyGlobalStats);
                }
                else if (location) {
                    this.location = location[0];
                    this.fetchGlobalStatistics();
                }
            });
        };
        this.getUserRole = () => {
            this.authService.getRoleForOR(this.unsubscribe$).subscribe((roleBehavior) => {
                if (roleBehavior && roleBehavior.appRole) {
                    this.userRole = roleBehavior.appRole;
                    this.isUserRoleAvailable = true;
                }
            }, (error) => {
                console.log(error);
            });
        };
    }
    ngOnInit() {
        this.getUserRole();
        if (!this.dataService.locationTreeArrayExists) {
            this.subscribeLocationHierarchy();
        }
        else {
            this.doOpenRoaming();
        }
    }
    fetchGlobalStatistics() {
        const { id } = this.location;
        const mongoLocId = this.dataService.getMongoDBId(id);
        this.openRoamingGlobalStateService.getGlobalStatistics({ locationId: mongoLocId })
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(({ data }) => __awaiter(this, void 0, void 0, function* () {
            if (data && !isEmpty(data.overall)) {
                const locationMap = yield this.dataService.getLocationObjectArray();
                const locations = Array.from(locationMap.values());
                this.statistics = data;
                this.openRoamingService.setGlobalStats({ data, locations });
            }
            else {
                if (window.location.href.includes('statistics')) {
                    this.redirectToGetStarted();
                }
            }
        }));
    }
    redirectToGetStarted() {
        void this.router.navigate(["/openroaming/getstarted"], {
            replaceUrl: true
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
OpenRoamingGlobalStatsComponent.ɵfac = function OpenRoamingGlobalStatsComponent_Factory(t) { return new (t || OpenRoamingGlobalStatsComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(OpenRoamingGlobalStateService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(OpenRoamingService), i0.ɵɵdirectiveInject(AuthService)); };
OpenRoamingGlobalStatsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OpenRoamingGlobalStatsComponent, selectors: [["lib-app-open-roaming-global-stats"]], decls: 1, vars: 1, consts: [["class", "openroaming__global-statistics", 4, "ngIf"], [1, "openroaming__global-statistics"], [1, "openroaming__global-statistics__label"], [1, "openroaming__global-statistics__stat"], [3, "innerHtml"]], template: function OpenRoamingGlobalStatsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, OpenRoamingGlobalStatsComponent_div_0_Template, 14, 15, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.statistics && ctx.statistics.overall && ctx.isUserRoleAvailable);
    } }, directives: [i1$2.NgIf], pipes: [i2.TranslatePipe, Commarize, ByteToUnit], styles: [".openroaming__global-statistics[_ngcontent-%COMP%]{display:flex;color:#5c5c5c;font-family:ciscoSansTT;justify-content:center;align-items:center;align-content:center}.openroaming__global-statistics__label[_ngcontent-%COMP%]{font-size:12px;font-weight:bold;line-height:18px;width:110px}.openroaming__global-statistics__stat[_ngcontent-%COMP%]{font-size:10px;line-height:14px;display:flex;flex-direction:column;flex-wrap:wrap;width:130px;align-items:center}.openroaming__global-statistics__stat[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{font-size:20px;font-weight:bold;line-height:27px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OpenRoamingGlobalStatsComponent, [{
        type: Component,
        args: [{
                selector: "lib-app-open-roaming-global-stats",
                templateUrl: "./open-roaming-global-stats.component.html",
                styleUrls: ["./open-roaming-global-stats.component.scss"]
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: OpenRoamingGlobalStateService }, { type: LocationService }, { type: OpenRoamingService }, { type: AuthService }]; }, null); })();

function LicenseInfoSpacesPopupComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "round-progress", 2);
    i0.ɵɵelementStart(2, "span", 3);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "br");
    i0.ɵɵelementStart(6, "span", 4);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "img", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("current", ctx_r0.progressPercentage)("max", 100)("color", ctx_r0.color)("background", "#eaeaea")("radius", 30)("stroke", 12)("semicircle", false)("rounded", false)("clockwise", true)("responsive", false)("duration", 800)("animation", "easeInOutQuart")("animationDelay", 5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 16, "shared-lib.license-info-spaces-popup.active-aps"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", ctx_r0.data.consumedAps, " of ", ctx_r0.data.totalAps, "");
} }
class LicenseInfoSpacesPopupComponent {
    constructor() {
        this.color = "green";
        this.calculateProgressPercentage = () => {
            this.progressPercentage =
                (this.data.consumedAps / this.data.totalAps) * 100;
            if (this.progressPercentage <= 80) {
                this.color = "green";
            }
            else if (this.progressPercentage <= 90) {
                this.color = "orange";
            }
            else if (this.progressPercentage > 90) {
                this.color = "red";
            }
        };
    }
    ngOnInit() {
        this.calculateProgressPercentage();
    }
}
LicenseInfoSpacesPopupComponent.ɵfac = function LicenseInfoSpacesPopupComponent_Factory(t) { return new (t || LicenseInfoSpacesPopupComponent)(); };
LicenseInfoSpacesPopupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LicenseInfoSpacesPopupComponent, selectors: [["app-license-info-spaces-popup"]], inputs: { data: "data" }, decls: 1, vars: 1, consts: [["id", "licenseInfoSpaces", 4, "ngIf"], ["id", "licenseInfoSpaces"], [2, "width", "60px", "height", "60px", 3, "current", "max", "color", "background", "radius", "stroke", "semicircle", "rounded", "clockwise", "responsive", "duration", "animation", "animationDelay"], [1, "label"], [1, "data"], ["src", ""]], template: function LicenseInfoSpacesPopupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LicenseInfoSpacesPopupComponent_div_0_Template, 9, 18, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.progressPercentage !== undefined);
    } }, directives: [i1$2.NgIf, i2$2.RoundProgressComponent], pipes: [i2.TranslatePipe], styles: ["@font-face{font-family:\"ciscoSansRegular\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansBold\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansThin\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansExtraLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansCondensed\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.svg) format(\"svg\")}@font-face{font-family:\"ciscoSans\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"icomoon\";font-display:auto;src:url(/assets/fonts/icomoon.eot?llzbkh);src:url(/assets/fonts/icomoon.eot?llzbkh#iefix) format(\"embedded-opentype\"),url(/assets/fonts/icomoon.ttf?llzbkh) format(\"truetype\"),url(/assets/fonts/icomoon.woff?llzbkh) format(\"woff\"),url(/assets/fonts/icomoon.svg?llzbkh#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"icomoon-new\";font-display:auto;src:url(/assets/fonts/icomoonnew/icomoon.eot?-psryvp);src:url(/assets/fonts/icomoonnew/icomoon.eot?#iefix-psryvp) format(\"embedded-opentype\"),url(/assets/fonts/icomoonnew/icomoon.ttf?-psryvp) format(\"truetype\"),url(/assets/fonts/icomoonnew/icomoon.woff?-psryvp) format(\"woff\"),url(/assets/fonts/icomoonnew/icomoon.svg?-psryvp#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"Roboto-Bold\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Bold.eot);src:url(/assets/fonts/Roboto/Roboto-Bold.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Bold.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Bold.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Bold.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Bold.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Light\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Light.eot);src:url(/assets/fonts/Roboto/Roboto-Light.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Light.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Light.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Light.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Light.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Medium\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Medium.eot);src:url(/assets/fonts/Roboto/Roboto-Medium.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Medium.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Medium.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Medium.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Medium.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Regular\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Regular.eot);src:url(/assets/fonts/Roboto/Roboto-Regular.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Regular.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Regular.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Regular.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Regular.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Inter\";font-display:auto;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}#licenseInfoSpaces[_ngcontent-%COMP%]{text-align:center}#licenseInfoSpaces[_ngcontent-%COMP%]   span.label[_ngcontent-%COMP%]{display:inline-block;color:#9c9c9c;font-size:18px;vertical-align:middle;text-align:left}#licenseInfoSpaces[_ngcontent-%COMP%]   span.data[_ngcontent-%COMP%]{display:inline-block;color:#000;font-size:25px;font-weight:bold}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LicenseInfoSpacesPopupComponent, [{
        type: Component,
        args: [{
                selector: "app-license-info-spaces-popup",
                templateUrl: "./license-info-spaces-popup.component.html",
                styleUrls: ["./license-info-spaces-popup.component.scss"]
            }]
    }], function () { return []; }, { data: [{
            type: Input
        }] }); })();

function LicenceInfoSpacesComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵlistener("click", function LicenceInfoSpacesComponent_div_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.showLicenseInfoSpacesPopupFn(true); });
    i0.ɵɵelementStart(1, "round-progress", 3);
    i0.ɵɵlistener("onRender", function LicenceInfoSpacesComponent_div_0_Template_round_progress_onRender_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.onRender($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "br");
    i0.ɵɵelementStart(6, "span", 5);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "img", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("current", ctx_r0.progressPercentage)("max", 100)("color", ctx_r0.color)("background", "#eaeaea")("radius", 15)("stroke", 5)("semicircle", false)("rounded", false)("clockwise", true)("responsive", false)("duration", 800)("animation", "easeInOutQuart")("animationDelay", 5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 16, "shared-lib.license-info-spaces-popup.active-aps"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", ctx_r0.data.consumedAps, " of ", ctx_r0.data.totalAps, "");
} }
function LicenceInfoSpacesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵelementStart(2, "div", 9);
    i0.ɵɵelement(3, "app-license-info-spaces-popup", 10);
    i0.ɵɵelementStart(4, "div", 11);
    i0.ɵɵelementStart(5, "button", 12);
    i0.ɵɵlistener("click", function LicenceInfoSpacesComponent_div_1_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.goToSetupPage(); });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("data", ctx_r1.data);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 2, "shared-lib.license-info-spaces-popup.setup"), " ");
} }
class LicenceInfoSpacesComponent {
    constructor(dataService, router) {
        this.dataService = dataService;
        this.router = router;
        this.unsubscribe$ = new Subject();
        this.showLicenseInfoSpacesPopup = false;
        this.color = "green";
        this.onRenderData = new EventEmitter();
        this.calculateProgressPercentage = () => {
            this.progressPercentage =
                (this.data.consumedAps / this.data.totalAps) * 100;
            if (this.progressPercentage <= 80) {
                this.color = "green";
            }
            else if (this.progressPercentage <= 90) {
                this.color = "orange";
            }
            else if (this.progressPercentage > 90) {
                this.color = "red";
            }
        };
        this.onRender = ($event) => {
            this.onRenderData.emit(this.data);
        };
        this.showLicenseInfoSpacesPopupFn = (show) => {
            this.showLicenseInfoSpacesPopup = show;
        };
        this.goToSetupPage = () => {
            this.currentNav = "setup/wirelessnetwork";
            this.dataService.setCurrentNav("/" + this.currentNav);
            this.router.navigate(["/" + this.currentNav]);
            this.showLicenseInfoSpacesPopupFn(false);
            this.revertPage();
        };
        this.revertPage = () => {
            // $('#right80').removeClass('showFullPage');
            // $('#left20').show();
        };
    }
    ngOnInit() {
        this.dataService
            .getLicenseDetails(this.unsubscribe$)
            .subscribe((val) => {
            if (val) {
                this.data = val;
                this.calculateProgressPercentage();
            }
        });
        fromEvent(document, "click")
            .pipe(takeUntil(this.unsubscribe$), filter((ev) => jQuery(ev.target).parents(".licenseInfoOnClick")
            .length === 0))
            .subscribe((_) => {
            this.showLicenseInfoSpacesPopup = false;
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
LicenceInfoSpacesComponent.ɵfac = function LicenceInfoSpacesComponent_Factory(t) { return new (t || LicenceInfoSpacesComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i1.Router)); };
LicenceInfoSpacesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LicenceInfoSpacesComponent, selectors: [["app-licence-info-spaces"]], outputs: { onRenderData: "onRenderData" }, decls: 2, vars: 2, consts: [["id", "licenseInfoSpaces", "class", "licenseInfoOnClick", 3, "click", 4, "ngIf"], ["class", "licenseInfoPopup", 4, "ngIf"], ["id", "licenseInfoSpaces", 1, "licenseInfoOnClick", 3, "click"], [3, "current", "max", "color", "background", "radius", "stroke", "semicircle", "rounded", "clockwise", "responsive", "duration", "animation", "animationDelay", "onRender"], [1, "label"], [1, "data"], ["src", ""], [1, "licenseInfoPopup"], [1, "modalContent"], [1, "modalBody"], [3, "data"], [1, "popupFooter"], ["id", "link-activeaps-setup", 1, "primaryButton", 3, "click"]], template: function LicenceInfoSpacesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LicenceInfoSpacesComponent_div_0_Template, 9, 18, "div", 0);
        i0.ɵɵtemplate(1, LicenceInfoSpacesComponent_div_1_Template, 8, 4, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.progressPercentage != undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showLicenseInfoSpacesPopup);
    } }, directives: [i1$2.NgIf, i2$2.RoundProgressComponent, LicenseInfoSpacesPopupComponent], pipes: [i2.TranslatePipe], styles: ["@font-face{font-family:\"ciscoSansRegular\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansBold\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansThin\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansExtraLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansCondensed\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.svg) format(\"svg\")}@font-face{font-family:\"ciscoSans\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"icomoon\";font-display:auto;src:url(/assets/fonts/icomoon.eot?llzbkh);src:url(/assets/fonts/icomoon.eot?llzbkh#iefix) format(\"embedded-opentype\"),url(/assets/fonts/icomoon.ttf?llzbkh) format(\"truetype\"),url(/assets/fonts/icomoon.woff?llzbkh) format(\"woff\"),url(/assets/fonts/icomoon.svg?llzbkh#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"icomoon-new\";font-display:auto;src:url(/assets/fonts/icomoonnew/icomoon.eot?-psryvp);src:url(/assets/fonts/icomoonnew/icomoon.eot?#iefix-psryvp) format(\"embedded-opentype\"),url(/assets/fonts/icomoonnew/icomoon.ttf?-psryvp) format(\"truetype\"),url(/assets/fonts/icomoonnew/icomoon.woff?-psryvp) format(\"woff\"),url(/assets/fonts/icomoonnew/icomoon.svg?-psryvp#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"Roboto-Bold\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Bold.eot);src:url(/assets/fonts/Roboto/Roboto-Bold.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Bold.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Bold.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Bold.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Bold.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Light\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Light.eot);src:url(/assets/fonts/Roboto/Roboto-Light.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Light.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Light.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Light.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Light.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Medium\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Medium.eot);src:url(/assets/fonts/Roboto/Roboto-Medium.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Medium.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Medium.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Medium.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Medium.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Regular\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Regular.eot);src:url(/assets/fonts/Roboto/Roboto-Regular.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Regular.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Regular.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Regular.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Regular.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Inter\";font-display:auto;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}#licenseInfoSpaces[_ngcontent-%COMP%]   span.label[_ngcontent-%COMP%]{display:inline-block;color:#898989;font-size:12px;vertical-align:middle;cursor:pointer;font-family:ciscoSans;text-align:left}#licenseInfoSpaces[_ngcontent-%COMP%]   span.data[_ngcontent-%COMP%]{display:inline-block;color:#000;font-size:14px;cursor:pointer;font-weight:bold}#licenseInfoSpaces[_ngcontent-%COMP%]{cursor:pointer}.modalContent[_ngcontent-%COMP%]{width:300px;left:0;top:55px;border-radius:15px;position:absolute;background:#FFF;padding:25px;box-shadow:0 0 20px #0000004d;transform:translate(-50%)}.modalContent[_ngcontent-%COMP%]:before{position:absolute;content:\"\";bottom:100%;right:20%;width:0;height:0;border:0;border-bottom:12px solid #fff;border-left:12px solid transparent;border-right:12px solid transparent;z-index:2}.modalContent[_ngcontent-%COMP%]:after{position:absolute;content:\"\";bottom:100%;right:20%;width:0;height:0;border:0;border-bottom:13px solid #fff;border-left:13px solid transparent;border-right:13px solid transparent;z-index:1}.modalBody[_ngcontent-%COMP%]{margin:0}.popupFooter[_ngcontent-%COMP%]{width:100%;height:50px;border-top:1px solid #eaeaea;margin-top:10px;padding-top:20px;text-align:center}.primaryButton[_ngcontent-%COMP%]{width:47%;margin-right:5px;background-color:#049fd9}.commonButton[_ngcontent-%COMP%]{width:47%;margin-left:5px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LicenceInfoSpacesComponent, [{
        type: Component,
        args: [{
                selector: "app-licence-info-spaces",
                templateUrl: "./licence-info-spaces.component.html",
                styleUrls: ["./licence-info-spaces.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: i1.Router }]; }, { onRenderData: [{
            type: Output
        }] }); })();

function HeaderSpacesComponent_div_1_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵlistener("click", function HeaderSpacesComponent_div_1_a_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.toggleNav(); });
    i0.ɵɵelementEnd();
} }
function HeaderSpacesComponent_div_1_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 16);
} }
function HeaderSpacesComponent_div_1_img_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 17);
} }
function HeaderSpacesComponent_div_1_img_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 18);
} }
function HeaderSpacesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵtemplate(2, HeaderSpacesComponent_div_1_a_2_Template, 1, 0, "a", 10);
    i0.ɵɵelementStart(3, "img", 11);
    i0.ɵɵlistener("click", function HeaderSpacesComponent_div_1_Template_img_click_3_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.goToHomePage(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, HeaderSpacesComponent_div_1_img_4_Template, 1, 0, "img", 12);
    i0.ɵɵtemplate(5, HeaderSpacesComponent_div_1_img_5_Template, 1, 0, "img", 13);
    i0.ɵɵtemplate(6, HeaderSpacesComponent_div_1_img_6_Template, 1, 0, "img", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isToggleVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.licenseInfo && ctx_r0.licenseInfo.licenseType === "Base Subscription");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.licenseInfo && ctx_r0.licenseInfo.licenseType === "Advanced Subscription");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.licenseInfo && ctx_r0.licenseInfo.licenseType === "Extend");
} }
function HeaderSpacesComponent_div_2_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵlistener("click", function HeaderSpacesComponent_div_2_a_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.toggleNav(); });
    i0.ɵɵelementEnd();
} }
function HeaderSpacesComponent_div_2_img_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 16);
} }
function HeaderSpacesComponent_div_2_img_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 17);
} }
function HeaderSpacesComponent_div_2_img_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 18);
} }
function HeaderSpacesComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵtemplate(2, HeaderSpacesComponent_div_2_a_2_Template, 1, 0, "a", 10);
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵelementStart(4, "img", 11);
    i0.ɵɵlistener("click", function HeaderSpacesComponent_div_2_Template_img_click_4_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.goToHomePage(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, HeaderSpacesComponent_div_2_img_5_Template, 1, 0, "img", 12);
    i0.ɵɵtemplate(6, HeaderSpacesComponent_div_2_img_6_Template, 1, 0, "img", 13);
    i0.ɵɵtemplate(7, HeaderSpacesComponent_div_2_img_7_Template, 1, 0, "img", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.isOpenRoamingEnable ? "mainHeader mainHeader50" : "mainHeader");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isToggleVisible);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.licenseInfo && ctx_r1.licenseInfo.licenseType === "Base Subscription");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.licenseInfo && ctx_r1.licenseInfo.licenseType === "Advanced Subscription");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.licenseInfo && ctx_r1.licenseInfo.licenseType === "Extend");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", ctx_r1.headerTitle, i0.ɵɵsanitizeHtml);
} }
function HeaderSpacesComponent_lib_app_open_roaming_global_stats_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-app-open-roaming-global-stats");
} }
function HeaderSpacesComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "app-licence-info-spaces", 23);
    i0.ɵɵlistener("onRenderData", function HeaderSpacesComponent_div_5_Template_app_licence_info_spaces_onRenderData_1_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.setLicenseInfo($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class HeaderSpacesComponent {
    constructor(authService, dataService, router, locationPlatform, businessHierarchyService, translate) {
        this.authService = authService;
        this.dataService = dataService;
        this.router = router;
        this.locationPlatform = locationPlatform;
        this.businessHierarchyService = businessHierarchyService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.headerUrlMap = {
            location: {
                title: "Location Hierarchy"
            },
            business: {
                title: "Location Hierarchy - Beta"
            },
            engagement: {
                title: "Engagements"
            },
            profile: {
                title: "Location Personas"
            },
            portal: {
                title: "Captive Portals"
            },
            apps: {
                title: "Partner Apps"
            },
            monitor: {
                title: "Monitor"
            },
            accesscode: {
                title: "Access Code"
            },
            dnac: {
                title: "Integrations"
            },
            integrations: {
                title: "Integrations"
            },
            mysignages: {
                title: "Smart Workspaces"
            },
            webex: {
                title: "Webex"
            }
        };
        this.headerTitle = null;
        this.isToggleVisible = true;
        this.toggleIncludeParams = ['home', 'location', 'monitor', 'team', 'setup', 'integrations'];
        this.isOpenRoamingEnable = false;
        this.titleSet = false;
        this.showLicenceInfo = false;
        this.showReports = false;
        // for smart license
        this.isSmartLicenseRegistered = false;
        this.baseUrl = "/";
        this.messageKeys = [];
        this.isAdminUser = false;
        // setheaderUrlMap = () =>{
        //   this.headerUrlMap = {
        //     location: {
        //       title:  this.message_map["locHierarchy"]
        //     },
        //     business: {
        //       title:  this.message_map["locHierarchyBeta"]
        //     },
        //     engagement: {
        //       title: this.message_map["engagements"]
        //     },
        //     profile: {
        //       title: this.message_map["locPersonas"]
        //     },
        //     portal: {
        //       title: this.message_map["captive"]
        //     },
        //     apps: {
        //       title: this.message_map["partnerApps"]
        //     },
        //     monitor: {
        //       title: this.message_map["monitor"]
        //     },
        //     accesscode: {
        //       title: this.message_map["access"]
        //     },
        //     dnac: {
        //       title: this.message_map["integrations"]
        //     }
        //   };
        // }
        this.getStaticText = () => {
            this.translate.get("shared-lib").subscribe((res) => {
                this.message_map["locHierarchy"] = res.locHierarchy;
                this.message_map["locHierarchyBeta"] = res.locHierarchyBeta;
                this.message_map["integrations"] = res.integrations;
                this.message_map["access"] = res.access;
                this.message_map["monitor"] = res.monitor;
                this.message_map["partnerApps"] = res.partnerApps;
                this.message_map["locPersonas"] = res.locPersonas;
                this.message_map["captive"] = res.captive;
                this.message_map["engagements"] = res.engagements;
                this.message_map["webex"] = res.webex;
                this.message_map["signage"] = res.webex;
            });
        };
        this.getTextKeys = () => {
            this.translate.get('shared-lib.header-spaces.openroaming').subscribe((res) => {
                this.messageKeys["openroaming"] = res;
            });
            this.translate.get('business-hierarchy-lib.business-location-details.location-hierarchy-beta').subscribe((res) => {
                this.messageKeys['location-hierarchy-beta'] = res;
            });
        };
        // getTextKeys = () => {
        //       this.translate.get('shared-lib.header-spaces.openroaming').subscribe((res: any) => {
        //               this.messageKeys["openroaming"] = res;
        //       });
        //       this.translate.get('business-hierarchy-lib.business-location-details.location-hierarchy-beta').subscribe((res: any) => {
        //         this.messageKeys['location-hierarchy-beta'] = res;
        //        });
        //   }
        this.getDashboardProperties = () => {
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$)
                .then((properties) => {
                this.properties = properties['value'];
                this.initialiseDashboardProperties(properties["value"]);
            });
        };
        this.initialiseDashboardProperties = (properties) => {
            try {
                // if the pendoDisableFeature property false then pendo.initialize
                if (this.properties && !this.properties["pendoDisableFeature"]) {
                    if (!pendo.accountId) {
                        this.setPendoSnippetValues();
                    }
                }
            }
            catch (e) {
                console.log(e);
            }
        };
        this.setPendoSnippetValues = () => {
            let isSet = false;
            this.dataService
                .getLicenseDetails(this.unsubscribe$)
                .subscribe((val) => {
                if (val && val.accountName && !isSet) {
                    isSet = true;
                    let licenseObj = {};
                    const accountObj = {
                        accountName: "accountName",
                        accountType: "accountType",
                        licenseCount: "licenseCount",
                        licenseDuration: "licenseDuration",
                        startDate: "startDate",
                        licenseType: "licenseType",
                        customerAccountNo: "customerAccountNo",
                        totalAps: "totalAps",
                        consumedAps: "consumedAps",
                        tenantId: "tenantId"
                    };
                    licenseObj = val;
                    const userId = this.dataService.getUserName();
                    const customerName = licenseObj[accountObj.accountName];
                    const accountType = licenseObj[accountObj.accountType];
                    const licenseCount = licenseObj[accountObj.licenseCount];
                    const licenseDuration = licenseObj[accountObj.licenseDuration];
                    const startDate = licenseObj[accountObj.startDate];
                    const licenseType = licenseObj[accountObj.licenseType];
                    const customerAccountNo = licenseObj[accountObj.customerAccountNo];
                    const totalAps = licenseObj[accountObj.totalAps];
                    const consumedAps = licenseObj[accountObj.consumedAps];
                    const tenantId = licenseObj[accountObj.tenantId];
                    const baseUrl = this.getHostName(this.baseUrl);
                    const params = {
                        visitor: {
                            id: userId + "_" + tenantId + "_" + baseUrl
                        },
                        account: {
                            id: tenantId + "_" + baseUrl,
                            licenseType: licenseType,
                            customerName: customerName,
                            accountType: accountType,
                            licenseCount: licenseCount,
                            licenseDuration: licenseDuration,
                            startDate: startDate,
                            customerAccountNo: customerAccountNo,
                            totalAps: totalAps,
                            consumedAps: consumedAps
                        }
                    };
                    // console.log(" ::: header-spaces component ::: pendo params ::: ", JSON.stringify(params));
                    pendo.initialize(params);
                }
            });
        };
        this.getHostName = (url) => {
            const tmp = document.createElement("a");
            tmp.href = url;
            return tmp.hostname;
        };
        this.checkHamburgerBtnState = () => {
            this.dataService.getHamburgerBtnState(this.unsubscribe$).subscribe((state) => {
                this.isToggleVisible = state;
            });
        };
        this.setHeaderFromNav = () => {
            this.isOpenRoamingEnable =
                location.pathname.indexOf("openroaming") > -1 ? true : false;
            const currentNav = this.router.url.split("/").pop();
            const state = this.dataService.getFromStorage('isNavDocked');
            const isNavDocked = (/true/i).test(state);
            if (!isNavDocked) {
                this.toggleIncludeParams.forEach(element => {
                    if (this.router.url.indexOf(element) > 0) {
                        this.dataService.setHamburgerBtnState(true);
                    }
                });
                $('#spacesHeader').css('width', '100%');
            }
            else {
                $('#spacesHeader').css('width', '96%');
            }
            if (currentNav === "statistics" || currentNav === "getstarted") {
                this.showReports = true;
            }
            if (this.isMenuOptionNeed != null && !this.isMenuOptionNeed) {
                this.dataService.setHamburgerBtnState(false);
            }
            if (this.titleSet) {
                return;
            }
            if (this.headerUrlMap.hasOwnProperty(currentNav)) {
                this.headerTitle = this.headerUrlMap[currentNav].title;
            }
            else {
                const currentApp = this.dataService.getCurrentApp();
                if (location.pathname.indexOf("captiveportalapp") > -1) {
                    this.headerTitle = "Captive Portals";
                }
                else if (this.isOpenRoamingEnable) {
                    this.headerTitle = this.messageKeys["openroaming"];
                }
                else {
                    this.headerTitle = null;
                }
            }
        };
        this.getUserRole = () => {
            this.authService.getRole(this.unsubscribe$).subscribe((roleBehavior) => {
                if (roleBehavior && roleBehavior.appRole) {
                    this.isAdminUser = true;
                    this.userRole = roleBehavior.appRole;
                    if (this.userRole == "Installer" ||
                        this.userRole == "CreativeUser" ||
                        this.userRole == "AccessCodeManager") {
                        this.isToggleVisible = false;
                    }
                }
                else {
                    this.isAdminUser = false;
                }
            }, (error) => {
                console.log(error);
            });
        };
        this.toggleNav = () => {
            this.dataService.navigation(true);
        };
        this.setLicenseInfo = ($event) => {
            this.licenseInfo = $event;
        };
        this.goToHomePage = () => {
            if (this.userRole == "AccessCodeManager") {
                this.currentNav = "captiveportal/accesscode";
            }
            else if (this.userRole == "CreativeUser") {
                this.currentNav = "captiveportal/portal";
            }
            else if (this.userRole != "AccessCodeManager") {
                this.currentNav = "base";
            }
            else {
                this.currentNav = "base";
            }
            // app user navigation: we are commenting this section for to show app selection popup
            // if (!this.isAdminUser) {
            //   if (location.pathname.indexOf("/personas/") > -1) {
            //     this.currentNav = '/personas/rules/profile';
            //   } else if (location.pathname.indexOf("/engagements/") > -1) {
            //     this.currentNav = '/engagements/rules/engagement';
            //   } else if (location.pathname.indexOf("/openroaming/") > -1) {
            //     this.currentNav = '/openroaming/getstarted';
            //   }
            // }
            this.router.navigate(["/" + this.currentNav]);
            this.dataService.setCurrentNav(this.currentNav);
        };
        this.refreshSmartLicensePoll = () => {
            this.isSmartLicenseRegistered = this.dataService.getSmartLicenseRegistered();
            // smart license check
            if (this.isSmartLicenseRegistered == false) {
                this.showLicenceInfo = false;
                // console.log("current val", currentNavPage);
                let showPages = ['base', 'home', 'location', 'hierarchy/business', 'team', 'team/invite', 'team/edit', 'setup/wirelessnetwork', 'setup/camera'];
                showPages.forEach(page => {
                    if (this.showLicenceInfo == false) {
                        if (page === location.pathname) {
                            this.showLicenceInfo = true;
                        }
                        else if (location.pathname && location.pathname.indexOf(page) > -1) {
                            this.showLicenceInfo = true;
                        }
                        else {
                            this.showLicenceInfo = false;
                        }
                    }
                });
            }
            else if (this.isSmartLicenseRegistered == true) {
                this.showLicenceInfo = false;
            }
            setTimeout(() => {
                this.refreshSmartLicensePoll();
            }, 3000);
        };
        locationPlatform.onPopState(() => {
            this.currentNav = location.pathname;
            this.dataService.setCurrentNav(this.currentNav);
            this.router.navigate([this.currentNav]);
        });
    }
    set role(value) {
        this.userRole = value;
    }
    set setHeaderTitle(value) {
        this.headerTitle = value;
        this.titleSet = true;
    }
    ngOnInit() {
        this.getStaticText();
        this.headerUrlMap.business.title = this.message_map["locHierarchyBeta"];
        this.headerUrlMap.location.title = this.message_map["locHierarchy"];
        this.headerUrlMap.engagement.title = this.message_map["engagements"];
        this.headerUrlMap.monitor.title = this.message_map["monitor"];
        this.headerUrlMap.accesscode.title = this.message_map["access"];
        this.headerUrlMap.dnac.title = this.message_map["integrations"];
        this.headerUrlMap.portal.title = this.message_map["captive"];
        this.headerUrlMap.profile.title = this.message_map["locPersonas"];
        this.headerUrlMap.apps.title = this.message_map["partnerApps"];
        this.headerUrlMap.mysignages.title = this.message_map["signage"];
        this.headerUrlMap.webex.title = this.message_map["webex"];
        // this.setheaderUrlMap()
        this.refreshSmartLicensePoll();
        this.isSmartLicenseRegistered = this.dataService.getSmartLicenseRegistered();
        this.setHeaderFromNav();
        this.checkHamburgerBtnState();
        this.getUserRole();
        // show Licence Info implementation starts
        this.dataService
            .getCurrentNavObervable(this.unsubscribe$)
            .subscribe((val) => {
            // Active Aps link got disappeared when we refresh the page in browser - Fixed - CSCvv60285
            let currentNavPage = val ? val : this.router.url;
            if (currentNavPage && currentNavPage.charAt(0) === "/") {
                currentNavPage = currentNavPage.slice(0);
            }
            // smart license check
            if (this.isSmartLicenseRegistered == false) {
                this.showLicenceInfo = false;
                // console.log("current val", currentNavPage);
                let showPages = ['base', 'home', 'location', 'team', 'team/invite', 'team/edit', 'setup/wirelessnetwork', 'setup/camera'];
                showPages.forEach(page => {
                    if (this.showLicenceInfo == false) {
                        if (page === currentNavPage) {
                            this.showLicenceInfo = true;
                        }
                        else if (currentNavPage && currentNavPage.indexOf(page) > -1) {
                            this.showLicenceInfo = true;
                        }
                        else {
                            this.showLicenceInfo = false;
                        }
                    }
                });
            }
        });
        // show Licence Info implementation ends
        this.dataService
            .getIsAdminUser(this.unsubscribe$)
            .subscribe((val) => {
            if (val != null) {
                this.isAdminUser = val;
            }
        });
        this.getDashboardProperties();
        // disable based upon dashboard property
        setTimeout(() => {
            if (this.properties && this.properties["pendoDisableFeature"] && pendo) {
                try {
                    if (pendo) {
                        pendo.setGuidesDisabled(true);
                        pendo.loadGuides();
                    }
                }
                catch (e) {
                    console.log(e);
                }
            }
        }, 2000);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
HeaderSpacesComponent.ɵfac = function HeaderSpacesComponent_Factory(t) { return new (t || HeaderSpacesComponent)(i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i1$2.PlatformLocation), i0.ɵɵdirectiveInject(BusinessHierarchyService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
HeaderSpacesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HeaderSpacesComponent, selectors: [["app-header-spaces"]], inputs: { role: "role", setHeaderTitle: "setHeaderTitle", isMenuOptionNeed: "isMenuOptionNeed" }, decls: 8, vars: 6, consts: [["id", "spacesHeader", 1, "header"], ["class", "mainHeader", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], [4, "ngIf"], ["class", "apsLogo", 4, "ngIf"], [1, "logoContainer", "rightCol-flexStart"], [3, "setup"], [1, "mainHeader"], ["id", "link-logo", 1, "logoContainer", "leftLogo"], ["class", "nav-toggler", 3, "click", 4, "ngIf"], ["src", "/assets/images/dna-spaces/latest/cisco_dnaspaces_logo.svg", "alt", "Cisco Spaces logo", "alt", "Cisco Spaces logo", 1, "img1", 3, "click"], ["class", "license-ico hidden", "src", "/assets/images/basic/see_ico.svg", "width", "30", 4, "ngIf"], ["class", "license-ico hidden", "src", "/assets/images/basic/act_ico.svg", "width", "30", 4, "ngIf"], ["class", "license-ico hidden", "src", "/assets/images/basic/extend_ico.svg", "width", "30", 4, "ngIf"], [1, "nav-toggler", 3, "click"], ["src", "/assets/images/basic/see_ico.svg", "width", "30", 1, "license-ico", "hidden"], ["src", "/assets/images/basic/act_ico.svg", "width", "30", 1, "license-ico", "hidden"], ["src", "/assets/images/basic/extend_ico.svg", "width", "30", 1, "license-ico", "hidden"], [1, "logoContainer", "leftLogo"], ["id", "link-logo"], [1, "subHeader", 3, "innerHtml"], [1, "apsLogo"], [3, "onRenderData"]], template: function HeaderSpacesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, HeaderSpacesComponent_div_1_Template, 7, 4, "div", 1);
        i0.ɵɵtemplate(2, HeaderSpacesComponent_div_2_Template, 9, 6, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, HeaderSpacesComponent_lib_app_open_roaming_global_stats_4_Template, 1, 0, "lib-app-open-roaming-global-stats", 4);
        i0.ɵɵtemplate(5, HeaderSpacesComponent_div_5_Template, 2, 0, "div", 5);
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelement(7, "app-navigation-user-info", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.headerTitle === null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.headerTitle !== null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isOpenRoamingEnable ? "logoContainer rightSection rightSection50" : "logoContainer rightSection");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isOpenRoamingEnable && ctx.showReports);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showLicenceInfo && ctx.userRole !== "AccessCodeManager" && ctx.userRole !== "CreativeUser" && ctx.userRole !== "BusinessUser" && ctx.userRole !== "AccessCodeManager");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("setup", "spaces");
    } }, directives: [i1$2.NgIf, i1$2.NgClass, NavigationUserInfoComponent, OpenRoamingGlobalStatsComponent, LicenceInfoSpacesComponent], styles: ["@font-face{font-family:\"ciscoSansRegular\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansBold\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansThin\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansExtraLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansCondensed\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.svg) format(\"svg\")}@font-face{font-family:\"ciscoSans\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"icomoon\";font-display:auto;src:url(/assets/fonts/icomoon.eot?llzbkh);src:url(/assets/fonts/icomoon.eot?llzbkh#iefix) format(\"embedded-opentype\"),url(/assets/fonts/icomoon.ttf?llzbkh) format(\"truetype\"),url(/assets/fonts/icomoon.woff?llzbkh) format(\"woff\"),url(/assets/fonts/icomoon.svg?llzbkh#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"icomoon-new\";font-display:auto;src:url(/assets/fonts/icomoonnew/icomoon.eot?-psryvp);src:url(/assets/fonts/icomoonnew/icomoon.eot?#iefix-psryvp) format(\"embedded-opentype\"),url(/assets/fonts/icomoonnew/icomoon.ttf?-psryvp) format(\"truetype\"),url(/assets/fonts/icomoonnew/icomoon.woff?-psryvp) format(\"woff\"),url(/assets/fonts/icomoonnew/icomoon.svg?-psryvp#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"Roboto-Bold\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Bold.eot);src:url(/assets/fonts/Roboto/Roboto-Bold.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Bold.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Bold.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Bold.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Bold.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Light\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Light.eot);src:url(/assets/fonts/Roboto/Roboto-Light.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Light.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Light.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Light.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Light.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Medium\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Medium.eot);src:url(/assets/fonts/Roboto/Roboto-Medium.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Medium.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Medium.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Medium.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Medium.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Regular\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Regular.eot);src:url(/assets/fonts/Roboto/Roboto-Regular.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Regular.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Regular.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Regular.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Regular.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Inter\";font-display:auto;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}.header[_ngcontent-%COMP%]{box-shadow:0 1px 3px 1px #bdbdbd3d;display:flex;height:75px;background:#ffffff;position:fixed;width:100%;z-index:999}.header[_ngcontent-%COMP%]   .mainHeader50[_ngcontent-%COMP%]{min-width:55%}.header[_ngcontent-%COMP%]   .rightSection50[_ngcontent-%COMP%]{min-width:45%}.mainHeader[_ngcontent-%COMP%]{min-width:65%;display:flex}.mainHeader[_ngcontent-%COMP%]   .leftLogo[_ngcontent-%COMP%]{min-width:12%;padding:1em}.mainHeader[_ngcontent-%COMP%]   .img1[_ngcontent-%COMP%]{cursor:pointer}.mainHeader[_ngcontent-%COMP%]   .centerLogo[_ngcontent-%COMP%]{min-width:55%;justify-content:flex-start;cursor:pointer}.mainHeader[_ngcontent-%COMP%]   .subHeader[_ngcontent-%COMP%]{color:#6a6a6a;width:68%;text-align:left;line-height:75px;font-family:ciscoSansLight;font-size:18px;padding-left:20px}.mainHeader[_ngcontent-%COMP%]   .subHeader[_ngcontent-%COMP%]:before{content:\"\";right:17px;position:relative;border-left:1px solid #dbdbdb}.nav-toggler[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;padding:20px;background:url(/assets/images/business/menu_icon.svg);background-position:center;width:16px;height:16px;background-repeat:no-repeat;cursor:pointer;position:relative}.nav-toggler[_ngcontent-%COMP%]:hover{opacity:.9}.nav-toggler[_ngcontent-%COMP%]:active{transform:translateY(4px);transition:transform .3s linear}.innerHeader[_ngcontent-%COMP%]{min-width:65%;display:flex}.innerHeader[_ngcontent-%COMP%]   .logoContainer[_ngcontent-%COMP%]{display:flex;padding:1em;cursor:pointer;width:31%}.innerHeader[_ngcontent-%COMP%]   .subHeader[_ngcontent-%COMP%]{color:#6a6a6a;width:68%;text-align:left;line-height:75px;font-family:ciscoSansLight;font-size:18px;padding-left:10px}.innerHeader[_ngcontent-%COMP%]   .subHeader[_ngcontent-%COMP%]:before{content:\"\";right:17px;position:relative;border-left:1px solid #dbdbdb}.logoContainer[_ngcontent-%COMP%]{display:flex;height:100%;align-items:center;justify-content:center}.logoContainer[_ngcontent-%COMP%]   .img2[_ngcontent-%COMP%]{position:relative;left:15px}.rightCol-flexStart[_ngcontent-%COMP%]{width:190px;justify-content:flex-center!important}.rightSection[_ngcontent-%COMP%]{min-width:35%;justify-content:flex-end}.apsLogo[_ngcontent-%COMP%]{padding-right:20px;border-right:1px solid #eaeaea;position:relative;top:2px}.wifiLogo[_ngcontent-%COMP%]{width:10%}.alphaImgDiv[_ngcontent-%COMP%]{margin-right:20px}.license-ico[_ngcontent-%COMP%]{border-radius:50px;position:relative;top:0;cursor:not-allowed;pointer-events:none}.disabledClick[_ngcontent-%COMP%]{-webkit-user-select:none;user-select:none;pointer-events:none}.hidden[_ngcontent-%COMP%]{display:none!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderSpacesComponent, [{
        type: Component,
        args: [{
                selector: "app-header-spaces",
                templateUrl: "./header-spaces.component.html",
                styleUrls: ["./header-spaces.component.scss"]
            }]
    }], function () { return [{ type: AuthService }, { type: DataService }, { type: i1.Router }, { type: i1$2.PlatformLocation }, { type: BusinessHierarchyService }, { type: i2.TranslateService }]; }, { role: [{
            type: Input
        }], setHeaderTitle: [{
            type: Input
        }], isMenuOptionNeed: [{
            type: Input
        }] }); })();

function FooterIcpLogoComponent_div_0_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵlistener("click", function FooterIcpLogoComponent_div_0_div_1_span_1_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(3); return ctx_r7.openLink(ctx_r7.properties.icpLogoFirstUrl); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r5.properties.icpLogoFirstText, i0.ɵɵsanitizeHtml);
} }
function FooterIcpLogoComponent_div_0_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r6.properties.icpLogoFirstText, i0.ɵɵsanitizeHtml);
} }
function FooterIcpLogoComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, FooterIcpLogoComponent_div_0_div_1_span_1_Template, 1, 1, "span", 5);
    i0.ɵɵtemplate(2, FooterIcpLogoComponent_div_0_div_1_span_2_Template, 1, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.properties.icpLogoFirstText != false && ctx_r1.properties.icpLogoFirstUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.properties.icpLogoFirstText != false && ctx_r1.properties.icpLogoFirstUrl === false);
} }
function FooterIcpLogoComponent_div_0_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 9);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r2.properties["icpLogoLink"], i0.ɵɵsanitizeUrl);
} }
function FooterIcpLogoComponent_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵlistener("click", function FooterIcpLogoComponent_div_0_span_4_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.openLink(ctx_r9.properties.icpLogoSecondUrl); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r3.properties.icpLogoSecondText, i0.ɵɵsanitizeHtml);
} }
function FooterIcpLogoComponent_div_0_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r4.properties.icpLogoSecondText, i0.ɵɵsanitizeHtml);
} }
function FooterIcpLogoComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, FooterIcpLogoComponent_div_0_div_1_Template, 3, 2, "div", 2);
    i0.ɵɵtemplate(2, FooterIcpLogoComponent_div_0_img_2_Template, 1, 1, "img", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, FooterIcpLogoComponent_div_0_span_4_Template, 1, 1, "span", 5);
    i0.ɵɵtemplate(5, FooterIcpLogoComponent_div_0_span_5_Template, 1, 1, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.properties.icpLogoVisible != undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.properties.icpLogoLink != false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.properties.icpLogoSecondText != false && ctx_r0.properties.icpLogoSecondUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.properties.icpLogoSecondText != false && ctx_r0.properties.icpLogoSecondUrl === false);
} }
class FooterIcpLogoComponent {
    constructor() {
        this.openLink = ($link) => {
            window.open($link, '_blank');
        };
    }
    ngOnInit() {
    }
}
FooterIcpLogoComponent.ɵfac = function FooterIcpLogoComponent_Factory(t) { return new (t || FooterIcpLogoComponent)(); };
FooterIcpLogoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FooterIcpLogoComponent, selectors: [["app-footer-icp-logo"]], inputs: { properties: "properties" }, decls: 1, vars: 1, consts: [["class", "footer-logo-wrapper", 4, "ngIf"], [1, "footer-logo-wrapper"], ["class", "footer-link-texts", 4, "ngIf"], ["height", "25", 3, "src", 4, "ngIf"], [1, "footer-link-texts"], [3, "innerHTML", "click", 4, "ngIf"], ["class", "no-pointer", 3, "innerHTML", 4, "ngIf"], [3, "innerHTML", "click"], [1, "no-pointer", 3, "innerHTML"], ["height", "25", 3, "src"]], template: function FooterIcpLogoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FooterIcpLogoComponent_div_0_Template, 6, 4, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.properties);
    } }, directives: [i1$2.NgIf], styles: [".footer-logo-wrapper[_ngcontent-%COMP%]{height:40px;width:100%;position:relative;padding-top:7px;text-align:center;bottom:0;left:0;display:flex;justify-content:center;align-items:center}.footer-link-texts[_ngcontent-%COMP%]{font-size:13px;color:#0e274d;font-weight:bold;padding:0 20px;cursor:pointer}.no-pointer[_ngcontent-%COMP%]{cursor:default!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterIcpLogoComponent, [{
        type: Component,
        args: [{
                selector: 'app-footer-icp-logo',
                templateUrl: './footer-icp-logo.component.html',
                styleUrls: ['./footer-icp-logo.component.scss']
            }]
    }], function () { return []; }, { properties: [{
            type: Input
        }] }); })();

const _c0$19 = ["triggerNav"];
function CommonBaseComponent_header_2_app_header_spaces_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "app-header-spaces", null, 7);
} }
function CommonBaseComponent_header_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "header");
    i0.ɵɵtemplate(1, CommonBaseComponent_header_2_app_header_spaces_1_Template, 2, 0, "app-header-spaces", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isUserCurrentStatusLoaded);
} }
function CommonBaseComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "app-footer-icp-logo", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("properties", ctx_r1.properties);
} }
const _c1$n = function (a0) { return { "showFullScreen": a0 }; };
function getBaseUrl$5() {
    return document.getElementsByTagName("base")[0].href;
}
class CommonBaseComponent {
    constructor(dataService, setupPlatformService, translate, _location, authService, browserlocation, router, baseUrl) {
        this.dataService = dataService;
        this.setupPlatformService = setupPlatformService;
        this.translate = translate;
        this._location = _location;
        this.authService = authService;
        this.browserlocation = browserlocation;
        this.router = router;
        this.unsubscribe$ = new Subject();
        this.baseUrl = "/";
        this.navigations = [];
        this.messageKeys = {};
        this.isDashboardUser = false;
        this.previousState = null;
        this.enableWiredNetwork = false;
        this.isBackPressed = false;
        this.properties = null;
        this.getLocaleText = () => {
            this.translate.get('dashboard-lib.base-component.menu.menuHome').subscribe((res) => {
                this.messageKeys["menuHomeKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuLocationHierarchy').subscribe((res) => {
                this.messageKeys["menuLocationHierarchyKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuMonitor').subscribe((res) => {
                this.messageKeys["menuMonitorKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuAdminManagement').subscribe((res) => {
                this.messageKeys["menuAdminManagementKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuWirelessNetwork').subscribe((res) => {
                this.messageKeys["menuWirelessNetworkKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuWiredNetwork').subscribe((res) => {
                this.messageKeys["menuWiredNetworkKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuWiredNetwork').subscribe((res) => {
                this.messageKeys["menuWiredNetworkKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuMapService').subscribe((res) => {
                this.messageKeys["menuMapServiceKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.locationsMaps').subscribe((res) => {
                this.messageKeys["locationsMapsKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuCamera').subscribe((res) => {
                this.messageKeys["menuCameraKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuSensors').subscribe((res) => {
                this.messageKeys["menuSensorsKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuWebex').subscribe((res) => {
                this.messageKeys["menuWebexKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuPxGridCloud').subscribe((res) => {
                this.messageKeys["menuPxGridCloud"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.dataExport').subscribe((res) => {
                this.messageKeys["dataExportKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuSetup').subscribe((res) => {
                this.messageKeys["menuSetupKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuIoTGateways').subscribe((res) => {
                this.messageKeys["menuIoTGatewaysKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuDeviceManagement').subscribe((res) => {
                this.messageKeys["menuDeviceManagementKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuDeviceMonitoring').subscribe((res) => {
                this.messageKeys["menuDeviceMonitoringKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuIoTServices').subscribe((res) => {
                this.messageKeys["menuIoTServicesKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuCiscoDNACenter').subscribe((res) => {
                this.messageKeys["menuCiscoDNACenterKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuCiscoDNASpacesSDK').subscribe((res) => {
                this.messageKeys["menuCiscoDNASpacesSDKKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuServiceNow').subscribe((res) => {
                this.messageKeys["menuServiceNowKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuIntegrations').subscribe((res) => {
                this.messageKeys["menuIntegrationsKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuEngagementRules').subscribe((res) => {
                this.messageKeys["menuEngagementRulesKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuVisitorEngagement').subscribe((res) => {
                this.messageKeys["menuVisitorEngagementKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuIntegrationsBase').subscribe((res) => {
                this.messageKeys["menuIntegrationsBaseKey"] = res;
            });
            this.translate.get('dashboard-lib.base-component.menu.menuConfigure').subscribe((res) => {
                this.messageKeys["menuConfigureKey"] = res;
            });
        };
        this.setMenu = () => {
            this.dataService.setHamburgerPage("base");
            // if (!this.dataService.locationTreeArrayExists) {
            // 	this.subscribeLocationHierarchy();
            // } else {
            if (!this.calculateNavigation()) {
                // if (this.isDashboardUser) {
                const currentNav = this.dataService.getCurrentNav();
                if (currentNav == null ||
                    currentNav == "base" ||
                    currentNav.indexOf("base") > -1) {
                    this.currentNav = this.navigations[0].routeUrl;
                }
                else {
                    this.currentNav = currentNav;
                }
                this.dataService.setCurrentNav(this.currentNav);
                this.router.navigate([this.currentNav]);
                // }
            }
            // }
        };
        this.changeOfRoutes = () => {
            if (this.triggerNavChange)
                this.triggerNavChange.setHeaderFromNav();
        };
        this.initializeEngagementNav = () => {
            this.navigations = [];
            let engagement = new NavigationHomeModel('engagement-rule', 'nav', this.messageKeys["menuEngagementRulesKey"], 'icon-engagement-rule', true, true, '/rules/engagement', {}, []);
            let visitor_engagement = new NavigationHomeModel('visitor-engagement', 'nav', this.messageKeys["menuVisitorEngagementKey"], 'icon-right-now', true, false, '/reports/visitor-engagement', {}, []);
            this.navigations.push(engagement, visitor_engagement);
            this.currentNav = this.navigations[0];
        };
        this.initializeBaseNav = () => {
            this.navigations = [];
            let home = new NavigationHomeModel('home', 'nav', this.messageKeys["menuHomeKey"], 'icon-home', true, true, '/home', {}, []);
            let location = new NavigationHomeModel('location', 'nav', this.messageKeys["menuLocationHierarchyKey"], 'icon-location', true, false, '/location', {}, []);
            let monitor = new NavigationHomeModel('monitoring', 'nav', this.messageKeys["menuMonitorKey"], 'icon-monitoring', true, false, '/monitor', {}, []);
            let admin_management = new NavigationHomeModel('admin-management', 'nav', this.messageKeys["menuAdminManagementKey"], 'icon-user', true, false, '/team', {}, []);
            let integrations_base = new NavigationHomeModel('integrations', 'nav', this.messageKeys["menuIntegrationsBaseKey"], 'integrations-icon-plug', true, false, '/integrations', null, []);
            let wireless = new NavigationHomeModel('wireless', 'nav', this.messageKeys["menuWirelessNetworkKey"], "", true, false, '/setup/wirelessnetwork', {}, []);
            let wired = new NavigationHomeModel('wired', 'nav', this.messageKeys["menuWiredNetworkKey"], "", true, false, '/setup/wirednetwork', {}, []);
            let maps = new NavigationHomeModel('maps', 'nav', this.messageKeys["menuMapServiceKey"], "", true, false, '/setup/maps', {}, []);
            let locations_maps = new NavigationHomeModel('locations-maps', 'nav', this.messageKeys["locationsMapsKey"], "", true, false, '/setup/locations-maps', {}, []);
            let meraki_camera = new NavigationHomeModel('meraki-camera', 'nav', this.messageKeys["menuCameraKey"], "", true, false, '/setup/camera', {}, []);
            let sensors = new NavigationHomeModel('sensors', 'nav', this.messageKeys["menuSensorsKey"], "", true, false, '/setup/sensors', {}, []);
            let data_export = new NavigationHomeModel('data-export', 'nav', this.messageKeys["dataExportKey"], "", true, false, '/setup/dataexport', {}, []);
            let webex = new NavigationHomeModel('webex', 'nav', this.messageKeys["menuWebexKey"], "", true, false, '/setup/webex', {}, []);
            let pxGrid = new NavigationHomeModel('pxgrid', 'nav', this.messageKeys["menuPxGridCloud"], "", true, false, '/setup/pxgrid', {}, []);
            let devicePlacement = new NavigationHomeModel('device-placement', 'nav', 'Device Placement', null, true, false, '/setup/device-placement', null, []);
            const setup_sub_menu = [];
            setup_sub_menu.push(wireless);
            // only for enable customers
            if (this.enableWiredNetwork) {
                setup_sub_menu.push(wired);
            }
            console.log("User authorised apps", this.dataService.getUserAppsList());
            if (this.dataService.getUserApp("MapService")) {
                setup_sub_menu.push(maps);
            }
            setup_sub_menu.push(locations_maps);
            setup_sub_menu.push(meraki_camera);
            // adding sensors menu
            setup_sub_menu.push(sensors);
            // Adding Data Export menu
            setup_sub_menu.push(data_export);
            if (this.dataService.getWebexEnableMenu()) {
                // adding webex menu
                setup_sub_menu.push(webex);
            }
            setup_sub_menu.push(pxGrid);
            // adding device placement navigation link
            if (this.dataService.getDevicePlacementNavEnabled()) {
                setup_sub_menu.push(devicePlacement);
            }
            let setup = new NavigationHomeModel('setup', 'nav', this.messageKeys["menuSetupKey"], 'icon-settings', true, false, "", {}, setup_sub_menu);
            let iot_about = new NavigationHomeModel('iot_about', 'nav', 'About IoT Services', null, true, false, '/devices/about', null, []);
            let iot_gateways = new NavigationHomeModel('iot_gateways', 'nav', this.messageKeys["menuIoTGatewaysKey"], "", true, false, '/devices/iot-gateway-management', {}, []);
            let device_management = new NavigationHomeModel('device_management', 'nav', this.messageKeys["menuDeviceManagementKey"], "", true, false, '/devices/device_management', {}, []);
            let device_monitoring = new NavigationHomeModel('device_monitoring', 'nav', this.messageKeys["menuDeviceMonitoringKey"], "", true, false, '/devices/device_monitoring', {}, []);
            let iot_services = new NavigationHomeModel('devices', 'nav', this.messageKeys["menuIoTServicesKey"], 'icon-edge-device', true, false, "", {}, [iot_about, iot_gateways, device_management, device_monitoring]);
            let dnac = new NavigationHomeModel('dnac', 'nav', this.messageKeys["menuCiscoDNACenterKey"], "", true, false, '/integrations/dnac', {}, []);
            let sdk = new NavigationHomeModel('sdk', 'nav', this.messageKeys["menuCiscoDNASpacesSDKKey"], null, true, false, '/configure/sdk', null, []);
            this.navigations.push(home);
            this.navigations.push(location);
            let configureLinksArray = [];
            configureLinksArray.push(sdk);
            if (this.dataService.getShowIntegrations()) {
                let configure = new NavigationHomeModel('configure', 'nav', this.messageKeys["menuConfigureKey"], 'icon-configure-bar', true, false, null, null, configureLinksArray);
                this.navigations.push(integrations_base);
                this.navigations.push(configure);
            }
            this.navigations.push(monitor);
            this.navigations.push(admin_management);
            if (this.dataService.getAccountServices("EdgeDeviceManager")) {
                this.navigations.push(iot_services);
            }
            this.navigations.push(setup);
            this.currentNav = this.navigations[0];
        };
        this.getDashboardProperties = () => {
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$)
                .then((properties) => {
                this.properties = properties['value'];
                this.initialiseDashboardProperties(properties["value"]);
            });
        };
        this.initialiseDashboardProperties = (properties) => {
            if (properties && properties["dnacEnableIntegration"]) {
                let sdk = new NavigationHomeModel('sdk', 'nav', this.messageKeys["menuCiscoDNASpacesSDKKey"], null, true, false, '/configure/sdk', null, []);
                let configureLinksArray = [];
                configureLinksArray.push(sdk);
                if (this.dataService.getShowIntegrations()) {
                    let configure = new NavigationHomeModel('configure', 'nav', this.messageKeys["menuConfigureKey"], 'icon-configure-bar', true, false, null, null, configureLinksArray);
                    this.navigations.push(configure);
                }
            }
            if (properties && properties['webexEnableMenu']) {
                this.dataService.setWebexEnableMenu(properties["webexEnableMenu"]);
            }
        };
        this.calculateNavigation = () => {
            // if (!this.isDashboardUser)
            //   return false;
            if (!!this._location &&
                (this._location.path() === "" || this._location.path() === "/")) {
                console.log("this _location is null and location path is empty or /");
                this.dataService.isPageRefresh = false;
                return false;
            }
            console.log("this.dataService.isPageRefresh ", this.dataService.isPageRefresh, "this.isBackPressed", this.isBackPressed, "this._location", this._location, "this._location.path()", this._location.path());
            if ((this.dataService.isPageRefresh || this.isBackPressed) &&
                !!this._location &&
                !!this._location.path()) {
                this.isBackPressed = false;
                this.dataService.isPageRefresh = false;
                let navURL = this._location.path();
                if (this._location.path().indexOf("/") == 0) {
                    navURL = this._location.path().substring(1);
                }
                console.log("Navigation url decided as: ", navURL);
                setTimeout(() => {
                    this.router.navigate([navURL]);
                    this.dataService.setCurrentNav(navURL);
                });
                return true;
            }
            const currentNav = this.dataService.getCurrentNav();
            console.log("currentNav found to be:", currentNav);
            if (currentNav !== null &&
                currentNav !== "null" &&
                !!this._location &&
                this._location.path() !== currentNav) {
                this.router.navigate([currentNav]);
                this.dataService.setCurrentNav(currentNav);
                this.isBackPressed = false;
                this.dataService.isPageRefresh = false;
            }
            this.dataService.isPageRefresh = false;
            console.log("Failed to calculate current Nav, falling back to navigation list");
            return false;
        };
        this.navChange = ($event) => {
            this.currentNav = $event;
            this.currentNavLabel = $event.label;
            if (this.previousState !== this.currentNav.id &&
                this._location.path() === this.currentNav.id) {
                let currentNavValue = this.currentNav.id;
                if (location.pathname.indexOf("captiveportal") > -1 &&
                    currentNavValue.toString().startsWith("/")) {
                    currentNavValue = this.currentNav.id
                        .toString()
                        .substring(1, this.currentNav.id.length);
                }
                if (location.pathname.indexOf("setup/wirelessnetwork") > -1 &&
                    currentNavValue.toString().startsWith("/")) {
                    currentNavValue = this.currentNav.id
                        .toString()
                        .substring(1, this.currentNav.id.length);
                }
                window.history.pushState({}, this.currentNavLabel, this.baseUrl + currentNavValue);
                this.previousState = this.currentNav.id;
                console.log("nav changed", $event);
            }
        };
        console.log("CommonBaseComponent::constructor");
        this.baseUrl = baseUrl;
    }
    ngOnInit() {
        this.initializeBaseNav();
        this.getLocaleText();
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getLocaleText();
        });
        this.isUserLoggedIn = this.dataService.getAccessToken() != null;
        this.getDashboardProperties();
        // this.isDashboardUser = this.dataService.getIsDashboardAdmin();
        this.dataService.setHamburgerPage("base");
        this.dataService
            .getHamburgerPage(this.unsubscribe$)
            .subscribe((hamObj) => {
            switch (hamObj.page) {
                case "": {
                    this.initializeBaseNav();
                    break;
                }
                case "base": {
                    this.initializeBaseNav();
                    break;
                }
                case "engagement": {
                    this.initializeEngagementNav();
                    break;
                }
                default: {
                    this.initializeBaseNav();
                    break;
                }
            }
        });
        this.enableWiredNetwork = this.dataService.getEnableWiredNetwork();
        this.browserlocation.onPopState(() => {
            console.log("pressed back!");
            this.isBackPressed = true;
        });
        setTimeout(() => {
            this.setMenu();
        }, 500);
    }
    ngAfterViewInit() {
        this.dataService
            .getShowFullScreen(this.unsubscribe$)
            .subscribe((val) => {
            setTimeout(() => {
                console.log("showFullScreen", val);
                this.showFullScreen = val;
            });
            // this.cdRef.detectChanges();
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        console.log("destory Common Base");
    }
}
CommonBaseComponent.ɵfac = function CommonBaseComponent_Factory(t) { return new (t || CommonBaseComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(SetupPlatformAppService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i1$2.Location), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(i1$2.PlatformLocation), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject("BASE_URL")); };
CommonBaseComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CommonBaseComponent, selectors: [["app-common-base"]], viewQuery: function CommonBaseComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$19, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.triggerNavChange = _t.first);
    } }, inputs: { isUserCurrentStatusLoaded: "isUserCurrentStatusLoaded" }, features: [i0.ɵɵProvidersFeature([
            Location$1,
            { provide: LocationStrategy, useClass: PathLocationStrategy },
            { provide: "BASE_URL", useFactory: getBaseUrl$5 }
        ])], decls: 8, vars: 6, consts: [["id", "appContainer", 1, "appContainer", 3, "ngClass"], [4, "ngIf"], ["id", "mainSection"], ["id", "baseNav", 3, "config"], ["id", "baseSection", 1, "base90"], [3, "activate"], ["class", "footerICPLogo", 4, "ngIf"], ["triggerNav", ""], [1, "footerICPLogo"], [3, "properties"]], template: function CommonBaseComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "lib-setup-notify");
        i0.ɵɵtemplate(2, CommonBaseComponent_header_2_Template, 2, 1, "header", 1);
        i0.ɵɵelementStart(3, "main", 2);
        i0.ɵɵelement(4, "navigation-home", 3);
        i0.ɵɵelementStart(5, "section", 4);
        i0.ɵɵelementStart(6, "router-outlet", 5);
        i0.ɵɵlistener("activate", function CommonBaseComponent_Template_router_outlet_activate_6_listener() { return ctx.changeOfRoutes(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, CommonBaseComponent_div_7_Template, 2, 1, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1$n, ctx.showFullScreen));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isUserLoggedIn);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("config", ctx.navigations);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.properties && ctx.properties.icpLogoVisible);
    } }, directives: [i1$2.NgClass, SetupNotifyComponent, i1$2.NgIf, NavigationHomeComponent, i1.RouterOutlet, HeaderSpacesComponent, FooterIcpLogoComponent], styles: ["@font-face{font-family:\"ciscoSansRegular\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansBold\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansThin\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansExtraLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansCondensed\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.svg) format(\"svg\")}@font-face{font-family:\"ciscoSans\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"icomoon\";font-display:auto;src:url(/assets/fonts/icomoon.eot?llzbkh);src:url(/assets/fonts/icomoon.eot?llzbkh#iefix) format(\"embedded-opentype\"),url(/assets/fonts/icomoon.ttf?llzbkh) format(\"truetype\"),url(/assets/fonts/icomoon.woff?llzbkh) format(\"woff\"),url(/assets/fonts/icomoon.svg?llzbkh#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"icomoon-new\";font-display:auto;src:url(/assets/fonts/icomoonnew/icomoon.eot?-psryvp);src:url(/assets/fonts/icomoonnew/icomoon.eot?#iefix-psryvp) format(\"embedded-opentype\"),url(/assets/fonts/icomoonnew/icomoon.ttf?-psryvp) format(\"truetype\"),url(/assets/fonts/icomoonnew/icomoon.woff?-psryvp) format(\"woff\"),url(/assets/fonts/icomoonnew/icomoon.svg?-psryvp#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"Roboto-Bold\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Bold.eot);src:url(/assets/fonts/Roboto/Roboto-Bold.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Bold.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Bold.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Bold.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Bold.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Light\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Light.eot);src:url(/assets/fonts/Roboto/Roboto-Light.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Light.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Light.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Light.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Light.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Medium\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Medium.eot);src:url(/assets/fonts/Roboto/Roboto-Medium.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Medium.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Medium.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Medium.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Medium.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Regular\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Regular.eot);src:url(/assets/fonts/Roboto/Roboto-Regular.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Regular.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Regular.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Regular.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Regular.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Inter\";font-display:auto;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}.appContainer[_ngcontent-%COMP%]{display:block;padding:0;margin:0;height:100%;overflow-y:auto}main[_ngcontent-%COMP%]{width:100%;height:100%;padding-top:75px}header[_ngcontent-%COMP%]{height:90px;position:fixed;z-index:999}section.base100[_ngcontent-%COMP%]{display:block;width:100%;margin:0 auto;height:100vh;background:#fafafa}section.base90[_ngcontent-%COMP%]{display:block;width:100%;margin:0 auto;height:calc(90vh - 40px);background:#fafafa}.bgColorWhite[_ngcontent-%COMP%]{background-color:#fff}.showFullScreen[_ngcontent-%COMP%]   header[_ngcontent-%COMP%]{display:none}.showFullScreen[_ngcontent-%COMP%]   nav[_ngcontent-%COMP%]{display:none}.footerICPLogo[_ngcontent-%COMP%]{width:100%;background-color:#262e39;position:fixed;bottom:0;left:50%;transform:translate(-50%)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CommonBaseComponent, [{
        type: Component,
        args: [{
                selector: "app-common-base",
                providers: [
                    Location$1,
                    { provide: LocationStrategy, useClass: PathLocationStrategy },
                    { provide: "BASE_URL", useFactory: getBaseUrl$5 }
                ],
                templateUrl: "./common-base.component.html",
                styleUrls: ["./common-base.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: SetupPlatformAppService }, { type: i2.TranslateService }, { type: i1$2.Location }, { type: AuthService }, { type: i1$2.PlatformLocation }, { type: i1.Router }, { type: undefined, decorators: [{
                type: Inject,
                args: ["BASE_URL"]
            }] }]; }, { triggerNavChange: [{
            type: ViewChild,
            args: ["triggerNav", { static: false }]
        }], isUserCurrentStatusLoaded: [{
            type: Input
        }] }); })();

const _c0$18 = function (a0, a1) { return { "row-hover": a0, "displayNone": a1 }; };
function ConfigureLocationHierarchyComponent_ng_template_2_tree_node_wrapper_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tree-node-wrapper", 9);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    const node_r7 = ctx_r13.$implicit;
    const index_r8 = ctx_r13.index;
    const templates_r9 = ctx_r13.templates;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r10.getPadding(node_r7, ctx_r10.isPopup));
    i0.ɵɵproperty("node", node_r7)("index", index_r8)("templates", templates_r9)("ngClass", i0.ɵɵpureFunction2(7, _c0$18, node_r7.data.showMenu, node_r7.data.type === "zone" || node_r7.data.type === "cmxzone" || node_r7.data.type === "polygon_zone"));
} }
const _c1$m = function (a0) { return { "row-hover": a0 }; };
function ConfigureLocationHierarchyComponent_ng_template_2_tree_node_wrapper_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tree-node-wrapper", 9);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    const node_r7 = ctx_r14.$implicit;
    const index_r8 = ctx_r14.index;
    const templates_r9 = ctx_r14.templates;
    i0.ɵɵproperty("node", node_r7)("index", index_r8)("templates", templates_r9)("ngClass", i0.ɵɵpureFunction1(4, _c1$m, node_r7.data.showMenu));
} }
function ConfigureLocationHierarchyComponent_ng_template_2_lib_row_menu_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-row-menu", 10);
} if (rf & 2) {
    const node_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("node", node_r7);
} }
const _c2$f = function (a0) { return { "displayNone": a0 }; };
function ConfigureLocationHierarchyComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ConfigureLocationHierarchyComponent_ng_template_2_tree_node_wrapper_1_Template, 1, 10, "tree-node-wrapper", 5);
    i0.ɵɵtemplate(2, ConfigureLocationHierarchyComponent_ng_template_2_tree_node_wrapper_2_Template, 1, 6, "tree-node-wrapper", 6);
    i0.ɵɵtemplate(3, ConfigureLocationHierarchyComponent_ng_template_2_lib_row_menu_3_Template, 1, 1, "lib-row-menu", 7);
    i0.ɵɵelement(4, "tree-node-children", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r7 = ctx.$implicit;
    const templates_r9 = ctx.templates;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2.getClass(node_r7));
    i0.ɵɵclassProp("tree-node", true)("tree-node-expanded", node_r7.isExpanded && node_r7.hasChildren)("tree-node-collapsed", node_r7.isCollapsed && node_r7.hasChildren)("tree-node-leaf", node_r7.isLeaf)("tree-node-active", node_r7.isActive)("tree-node-focused", node_r7.isFocused);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r7.data.showMenu);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("node", ctx_r2.sortChildren(node_r7))("templates", templates_r9)("ngClass", i0.ɵɵpureFunction1(20, _c2$f, node_r7.data.type === "floor"));
} }
function ConfigureLocationHierarchyComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "Loading, please hold....");
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_0_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵlistener("mouseover", function ConfigureLocationHierarchyComponent_ng_template_6_div_0_span_6_Template_span_mouseover_0_listener() { i0.ɵɵrestoreView(_r30); const node_r16 = i0.ɵɵnextContext(2).$implicit; const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.onMouseOverNodeFn(node_r16.data); })("mouseout", function ConfigureLocationHierarchyComponent_ng_template_6_div_0_span_6_Template_span_mouseout_0_listener() { i0.ɵɵrestoreView(_r30); const node_r16 = i0.ɵɵnextContext(2).$implicit; const ctx_r31 = i0.ɵɵnextContext(); return ctx_r31.onMouseOutNodeFn(node_r16.data); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" (", node_r16.data.total, " out of ", node_r16.data.permitted, ") ");
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_0_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵelement(1, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r16.apsMatched, i0.ɵɵsanitizeHtml);
} }
const _c3$a = function (a0) { return { "disable-location": a0 }; };
const _c4$5 = function (a0) { return { "highlightLocation": a0 }; };
function ConfigureLocationHierarchyComponent_ng_template_6_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function ConfigureLocationHierarchyComponent_ng_template_6_div_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r37); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r35 = i0.ɵɵnextContext(); return ctx_r35.selectNodeFn(node_r16); })("mouseover", function ConfigureLocationHierarchyComponent_ng_template_6_div_0_Template_div_mouseover_0_listener() { i0.ɵɵrestoreView(_r37); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r38 = i0.ɵɵnextContext(); return ctx_r38.onMouseOverNodeFn(node_r16.data); })("mouseout", function ConfigureLocationHierarchyComponent_ng_template_6_div_0_Template_div_mouseout_0_listener() { i0.ɵɵrestoreView(_r37); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.onMouseOutNodeFn(node_r16.data); });
    i0.ɵɵelementStart(1, "a", 20);
    i0.ɵɵelement(2, "span", 21);
    i0.ɵɵelementStart(3, "span", 22);
    i0.ɵɵlistener("click", function ConfigureLocationHierarchyComponent_ng_template_6_div_0_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r37); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.clickedLocation(node_r16.data); });
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ConfigureLocationHierarchyComponent_ng_template_6_div_0_span_6_Template, 2, 2, "span", 23);
    i0.ɵɵtemplate(7, ConfigureLocationHierarchyComponent_ng_template_6_div_0_span_7_Template, 2, 1, "span", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$a, !ctx_r18.multiLocationSelect && ctx_r18.showCameraCountAlert(node_r16) || ctx_r18.rightNowPage && (node_r16.data.type === "zone" || node_r16.data.type === "cmxzone" || node_r16.data.type === "polygon_zone")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 5, node_r16.data.name), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(9, _c4$5, ctx_r18.reportType === "REAL_TIME"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", node_r16.data.permitted != node_r16.data.total);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r16.apsMatched);
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_1_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵlistener("mouseover", function ConfigureLocationHierarchyComponent_ng_template_6_div_1_span_6_Template_span_mouseover_0_listener() { i0.ɵɵrestoreView(_r49); const node_r16 = i0.ɵɵnextContext(2).$implicit; const ctx_r47 = i0.ɵɵnextContext(); return ctx_r47.onMouseOverNodeFn(node_r16.data); })("mouseout", function ConfigureLocationHierarchyComponent_ng_template_6_div_1_span_6_Template_span_mouseout_0_listener() { i0.ɵɵrestoreView(_r49); const node_r16 = i0.ɵɵnextContext(2).$implicit; const ctx_r50 = i0.ɵɵnextContext(); return ctx_r50.onMouseOutNodeFn(node_r16.data); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" (", node_r16.data.total, " out of ", node_r16.data.permitted, ") ");
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_1_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵelement(1, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r16.apsMatched, i0.ɵɵsanitizeHtml);
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "a", 20);
    i0.ɵɵelement(2, "span", 21);
    i0.ɵɵelement(3, "span", 29);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelement(5, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ConfigureLocationHierarchyComponent_ng_template_6_div_1_span_6_Template, 2, 2, "span", 23);
    i0.ɵɵtemplate(7, ConfigureLocationHierarchyComponent_ng_template_6_div_1_span_7_Template, 2, 1, "span", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$a, !ctx_r19.multiLocationSelect && ctx_r19.showCameraCountAlert(node_r16) || ctx_r19.rightNowPage && (node_r16.data.type === "zone" || node_r16.data.type === "cmxzone" || node_r16.data.type === "polygon_zone")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 5, node_r16.data.name), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(9, _c4$5, ctx_r19.reportType === "REAL_TIME"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", node_r16.data.permitted != node_r16.data.total);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r16.apsMatched);
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵtext(2, " Right now analytics not available at zone level. Please select a floor/building/campus. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "loc_tooltip_", node_r16.data.id, "");
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelementStart(1, "div", 33);
    i0.ɵɵelementStart(2, "img", 34);
    i0.ɵɵlistener("mouseover", function ConfigureLocationHierarchyComponent_ng_template_6_div_3_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r58); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r56 = i0.ɵɵnextContext(); return ctx_r56.cameraCountAlertMouseOver($event, node_r16.data.id); })("mouseover", function ConfigureLocationHierarchyComponent_ng_template_6_div_3_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r58); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r59 = i0.ɵɵnextContext(); return ctx_r59.cameraCountAlertMouseOut($event, node_r16.data.id); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 35);
    i0.ɵɵtext(4, " No camera(s) available at this location ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "camera-count_", node_r16.data.id, "");
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_4_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵelement(1, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r16.apsMatched, i0.ɵɵsanitizeHtml);
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelementStart(1, "a", 20);
    i0.ɵɵelement(2, "span", 21);
    i0.ɵɵelement(3, "span", 29);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ConfigureLocationHierarchyComponent_ng_template_6_div_4_span_5_Template, 2, 1, "span", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 3, node_r16.data.name), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(5, _c4$5, ctx_r22.reportType === "REAL_TIME"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r16.apsMatched);
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelementStart(1, "input", 38);
    i0.ɵɵlistener("click", function ConfigureLocationHierarchyComponent_ng_template_6_div_5_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r67); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r65 = i0.ɵɵnextContext(); return ctx_r65.selectNodeFn(node_r16); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r23 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r16.data.id, "");
    i0.ɵɵproperty("checked", ctx_r23.selectedLocation && ctx_r23.selectedLocation.length > 0 && node_r16.data.id === ctx_r23.selectedLocation[0].id)("value", node_r16.data.id);
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r71 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelementStart(1, "input", 38);
    i0.ɵɵlistener("click", function ConfigureLocationHierarchyComponent_ng_template_6_div_6_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r71); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r69 = i0.ɵɵnextContext(); return ctx_r69.selectNodeFn(node_r16); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r24 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r16.data.id, "");
    i0.ɵɵproperty("checked", ctx_r24.selectedLocation && ctx_r24.selectedLocation.length > 0 && node_r16.data.id === ctx_r24.selectedLocation[0].id)("value", node_r16.data.id);
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_7_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "label", 45);
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r16.data.id, "");
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_7_label_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "label", 46);
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r16.data.id, "");
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_7_label_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "label", 47);
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r16.data.id, "");
} }
function ConfigureLocationHierarchyComponent_ng_template_6_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelement(1, "input", 41);
    i0.ɵɵtemplate(2, ConfigureLocationHierarchyComponent_ng_template_6_div_7_label_2_Template, 1, 1, "label", 42);
    i0.ɵɵtemplate(3, ConfigureLocationHierarchyComponent_ng_template_6_div_7_label_3_Template, 1, 1, "label", 43);
    i0.ɵɵtemplate(4, ConfigureLocationHierarchyComponent_ng_template_6_div_7_label_4_Template, 1, 1, "label", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r25 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r16.data.id, "");
    i0.ɵɵproperty("checked", ctx_r25.selectedLocation && ctx_r25.selectedLocation.length > 0 && node_r16.data.id === ctx_r25.selectedLocation[0].id)("value", node_r16.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r16.data.type == "root");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r25.permittedLocType == "building" && (node_r16.data.type == "network" || node_r16.data.type == "building"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r25.permittedLocType == "floor" && node_r16.data.type == "floor");
} }
function ConfigureLocationHierarchyComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ConfigureLocationHierarchyComponent_ng_template_6_div_0_Template, 8, 11, "div", 11);
    i0.ɵɵtemplate(1, ConfigureLocationHierarchyComponent_ng_template_6_div_1_Template, 8, 11, "div", 12);
    i0.ɵɵtemplate(2, ConfigureLocationHierarchyComponent_ng_template_6_div_2_Template, 3, 1, "div", 13);
    i0.ɵɵtemplate(3, ConfigureLocationHierarchyComponent_ng_template_6_div_3_Template, 5, 1, "div", 14);
    i0.ɵɵtemplate(4, ConfigureLocationHierarchyComponent_ng_template_6_div_4_Template, 6, 7, "div", 15);
    i0.ɵɵtemplate(5, ConfigureLocationHierarchyComponent_ng_template_6_div_5_Template, 2, 3, "div", 16);
    i0.ɵɵtemplate(6, ConfigureLocationHierarchyComponent_ng_template_6_div_6_Template, 2, 3, "div", 17);
    i0.ɵɵtemplate(7, ConfigureLocationHierarchyComponent_ng_template_6_div_7_Template, 5, 6, "div", 18);
} if (rf & 2) {
    const node_r16 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && (node_r16.data.access === "Full" || node_r16.data.reportAccess));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && node_r16.data.access !== "Full" && !node_r16.data.reportAccess);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.rightNowPage && (node_r16.data.type === "zone" || node_r16.data.type === "cmxzone" || node_r16.data.type === "polygon_zone"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && ctx_r6.showCameraCountAlert(node_r16));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.multiLocationSelect);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r16.data.access === "Full" && (!ctx_r6.multiLocationSelect && ctx_r6.workspacePage && ctx_r6.permittedLocType == "building" && (node_r16.data.type == "network" || node_r16.data.type == "building") && node_r16.data.id != ctx_r6.selectedLocation[0].id));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r16.data.access === "Full" && (!ctx_r6.multiLocationSelect && ctx_r6.workspacePage && ctx_r6.permittedLocType == "floor" && node_r16.data.type == "floor" && node_r16.data.id != ctx_r6.selectedLocation[0].id));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r16.data.access === "Full" && (!ctx_r6.multiLocationSelect && ctx_r6.workspacePage && node_r16.data.id == ctx_r6.selectedLocation[0].id));
} }
class ConfigureLocationHierarchyComponent extends ManageLocationTreeComponent {
    constructor(router_, dataService_, locationService_, cdRef_) {
        super(router_, dataService_, locationService_, cdRef_);
        this.router_ = router_;
        this.dataService_ = dataService_;
        this.locationService_ = locationService_;
        this.cdRef_ = cdRef_;
        this.rightNowPage = false;
        this.energyUtilPage = false;
        this.mysignagePage = false;
        this.workspacePage = false;
        this.rootLocationObj = {};
        this.maxSelectionNumber = 3;
        this.prevSearchString = "";
        this.excludedLocs = [];
        this.dataExportPage = false;
        this.permittedLocType = 'building';
        this.onEvent = ($event) => {
            console.log('onEvent from tree::', $event);
            switch ($event.eventName) {
                case "initialized":
                    console.log("location loading done", new Date().getTime() - this.startTime);
                    this.isTreeInitialised = true;
                    this.treeComponent.treeModel.roots.forEach((root) => {
                        this.rootLocationObj = root.data;
                        if (root.isCollapsed)
                            root.expand();
                    });
                    this.initLocationNodes();
                    setTimeout(() => {
                        if (this.treeComponent) {
                            this.treeComponent.sizeChanged();
                        }
                    }, 100);
                    break;
                case "toggleExpanded":
                    setTimeout(() => {
                        if (this.treeComponent) {
                            this.treeComponent.sizeChanged();
                        }
                    }, 100);
                    break;
            }
            // this.searchTree(this.searchTimestamp);
        };
        this.initLocationNodes = () => {
            if (this.currentFilterLocations &&
                this.currentFilterLocations.length > 0) {
                this.filterLocationIds(this.currentFilterLocations);
            }
            else {
                this.location = this.locationOrginal;
            }
            this.prevFilterLocations = this.currentFilterLocations;
        };
        this.sortChildren = (node) => {
            return node;
        };
        this.clickedLocation = (data) => {
            // if (this.reportType == "REAL_TIME"){
            //   let spacesObj = JSON.parse(sessionStorage.getItem('spacesObj'));
            //   if(data.type == "network" || data.type == "root"){
            //     delete spacesObj['realtimeLocation'];
            //     spacesObj['spacesLocation'] = {id: data.id, name: data.name, type: data.type == "root" ? 'all' : data.type};
            //   }else{
            //     spacesObj['realtimeLocation'] = {id: data.id};
            //     spacesObj['spacesLocation'] = {id: this.rootLocationObj["id"], name: this.rootLocationObj["name"], type: 'all'};
            //   }
            //   this.dataService.setSpacesObject(spacesObj);
            // }
        };
        this.isIncluded = (node) => {
            if (this.excludedLocs && this.excludedLocs.length > 0) {
                if (this.excludedLocs.indexOf(node.data.id) != -1)
                    return false;
                else
                    return true;
            }
            return true;
        };
        this.checkFloorZoneDisabling = (node) => {
            if (this.exportDisableNode && this.exportDisableNode !== '') {
                if (this.exportDisableNode === 'network' && (node.data.type === 'floor' || node.data.type === 'zone' || node.data.type === 'cmxzone' || node.data.type === 'polygon_zone')) {
                    return false;
                }
                else if (this.exportDisableNode === 'floor' && (node.data.type === 'zone' || node.data.type === 'cmxzone' || node.data.type === 'polygon_zone')) {
                    return false;
                }
                else if (this.exportDisableNode === 'network_floor' && (node.data.type === 'zone' || node.data.type === 'cmxzone' || node.data.type === 'polygon_zone')) {
                    return false;
                }
                else {
                    return true;
                }
            }
            return true;
        };
        this.locationInfoMouseOver = (event, id) => {
            $("#loc_info_" + id).addClass("loc-info-show");
        };
        this.locationInfoMouseOut = (event, id) => {
            setTimeout(() => {
                $("#loc_info_" + id).removeClass("loc-info-show");
            }, 2000);
        };
        this.showCameraCountAlert = (node) => {
            const currentNav = this.dataService.getCurrentNav();
            if (node.data.camerasCount === 0 &&
                currentNav != null &&
                currentNav.indexOf("camera-metrics") !== -1) {
                return true;
            }
            else {
                return false;
            }
        };
        this.cameraCountAlertMouseOver = (event, id) => {
            $("#camera-count_" + id).addClass("camera-count-alert-show");
        };
        this.onMouseOverNodeFn = (nodeData) => {
            this.onMouseOverNode(nodeData, 0);
        };
        this.onMouseOutNodeFn = (nodeData) => {
            this.onMouseOutNode(nodeData, 0);
        };
        this.cameraCountAlertMouseOut = (event, id) => {
            setTimeout(() => {
                $("#camera-count_" + id).removeClass("camera-count-alert-show");
            }, 2000);
        };
        this.isRichMapStatus = (node) => {
            let enableCheck = false;
            if (this.permittedLocationTypes !== undefined &&
                this.permittedLocationTypes !== null &&
                this.permittedLocationTypes.length > 0) {
                // check group or org
                if (this.permittedLocationTypes.indexOf(node.data.type) > -1) {
                    if (node.data.type === "organization" ||
                        node.data.type === "meraki" ||
                        node.data.type === "mse") {
                        enableCheck = true;
                    }
                    else if (node.data.type === "group" &&
                        node.data.locationBit & this.locationFlag.Flags.ADD_NETWORK) {
                        enableCheck = true;
                    }
                    else if (node.data.type !== "organization" &&
                        node.data.type !== "group") {
                        enableCheck = true;
                    }
                    // we need to add the richmap flag check
                }
                else {
                    enableCheck = false;
                }
            }
            else {
                enableCheck = true;
            }
            if (this.isRichMapAvailable) {
                if (enableCheck) {
                    if (node.data.richMapStatus) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
            else {
                return enableCheck;
            }
        };
        this.selectNodeFn = (node) => {
            const currentNav = this.dataService.getCurrentNav();
            // workspace manager
            if (currentNav &&
                currentNav.indexOf("workspace-experience") !== -1) {
                if (this.permittedLocType == 'building' && (node.data.type === "network" || node.data.type === "building")) {
                    this.selectNode(node);
                }
                else if (this.permittedLocType == 'floor' && node.data.type === 'floor') {
                    this.selectNode(node);
                }
                else {
                    return;
                }
            }
        };
    }
    ngOnInit() {
        if (this.permittedLocationTypes && this.permittedLocationTypes.length > 0) {
            this.permittedLocType = this.permittedLocationTypes[0];
        }
        console.log("::: this.permittedLocType ::: ", this.permittedLocType);
        this.makeSearchAPICall = false;
        super.ngOnInit();
        if (this.dataService.getCurrentNav().indexOf('right-now') !== -1) {
            this.rightNowPage = true;
        }
        else {
            this.rightNowPage = false;
        }
        if (this.dataService.getCurrentNav().indexOf('energy-util') !== -1) {
            this.energyUtilPage = true;
        }
        else {
            this.energyUtilPage = false;
        }
        if (this.dataService.getCurrentNav().indexOf('dataexport') !== -1) {
            this.dataExportPage = true;
        }
        else {
            this.dataExportPage = false;
        }
        if (this.dataService.getCurrentNav().indexOf('mysignage') !== -1) {
            this.mysignagePage = true;
        }
        else {
            this.mysignagePage = false;
        }
        if (this.dataService.getCurrentNav().indexOf('workspace-experience') !== -1) {
            this.workspacePage = true;
        }
        else {
            this.workspacePage = false;
        }
    }
    set disableNode(value) {
        if (value) {
            if (this.dataService.getCurrentNav().indexOf('dataexport') !== -1) {
                this.dataExportPage = true;
            }
            else {
                this.dataExportPage = false;
            }
            this.exportDisableNode = value;
        }
    }
    set searchLocation(value) {
        // this.searchTimestamp = new Date().getTime();
        // if (!value || value.trim() == "")
        //   this.prevSearchString = "";
        // else
        //   this.prevSearchString = value;
        // this.searchTree(this.searchTimestamp);
        // this.subscribeSearchText(value);
        this.enableCustomSearch = true;
        if (value) {
            // this.prevSearchString = customSearchText;
            // this.searchTree(new Date().getTime());
            this.subscribeSearchText(value);
        }
    }
    set filterLocations(filterLocations) {
        this.currentFilterLocations = filterLocations;
        if (this.isTreeInitialised)
            this.initLocationNodes();
    }
    set excludedLocations(excludedLocs) {
        if (excludedLocs)
            this.excludedLocs = excludedLocs;
        else
            this.excludedLocs = [];
    }
    ngOnDestroy() {
        console.log("destory spaces location hierarchy page");
        super.ngOnDestroy();
    }
    selectMultipleNode($event, node) {
        if (this.selectedLocation) {
            // var existingNodeId: number[] = null;
            let index = null;
            this.selectedLocation.filter(function (n, i) {
                if (n.data.id === node.data.id) {
                    index = i;
                    return;
                }
            });
            if (index !== null) {
                super.selectMultipleNode($event, node);
            }
            else {
                if (this.dataExportPage) {
                    super.selectMultipleNode($event, node);
                }
                else if (this.selectedLocation.length < this.maxSelectionNumber) {
                    super.selectMultipleNode($event, node);
                }
                else {
                    // Show error message to user about max selected
                    this.dataService.setToastMessage("You can pin a maximum of 3 locations", 2000, null, null, "error");
                    this.isNodeSelected = false;
                    $event.target["checked"] = false;
                }
            }
        }
        else {
            super.selectMultipleNode($event, node);
        }
    }
}
ConfigureLocationHierarchyComponent.ɵfac = function ConfigureLocationHierarchyComponent_Factory(t) { return new (t || ConfigureLocationHierarchyComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
ConfigureLocationHierarchyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConfigureLocationHierarchyComponent, selectors: [["lib-configure-location-hierarchy"]], inputs: { disableRootCheckbox: "disableRootCheckbox", isRichMapAvailable: "isRichMapAvailable", permittedLocationTypes: "permittedLocationTypes", disableNode: "disableNode", searchLocation: "searchLocation", filterLocations: "filterLocations", excludedLocations: "excludedLocations" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 2, consts: [[3, "nodes", "options", "event", "stateChange"], ["tree", ""], ["treeNodeFullTemplate", ""], ["loadingTemplate", ""], ["treeNodeTemplate", ""], ["class", "pointer", 3, "node", "index", "templates", "ngClass", "style", 4, "ngIf"], ["class", "pointer", 3, "node", "index", "templates", "ngClass", 4, "ngIf"], [3, "node", 4, "ngIf"], [3, "node", "templates", "ngClass"], [1, "pointer", 3, "node", "index", "templates", "ngClass"], [3, "node"], ["class", "location-node-name", 3, "ngClass", "click", "mouseover", "mouseout", 4, "ngIf"], ["class", "location-node-name", 3, "ngClass", 4, "ngIf"], ["class", "zone-alert", 4, "ngIf"], ["class", "camera-count-alert", 4, "ngIf"], ["class", "location-node-name", 4, "ngIf"], ["class", "repotLocationPopupRadio workspacePageRadio network-loc-radio", 4, "ngIf"], ["class", "repotLocationPopupRadio workspacePageRadio floor-loc-radio", 4, "ngIf"], ["class", "repotLocationPopupRadio", 4, "ngIf"], [1, "location-node-name", 3, "ngClass", "click", "mouseover", "mouseout"], ["href", "javascript:void(0);", 1, "location-name-icon"], [1, "loc-type-icon"], [1, "location-name", 3, "innerHTML", "ngClass", "click"], ["class", "location-count", 3, "mouseover", "mouseout", 4, "ngIf"], ["class", "matchedApDetails", 4, "ngIf"], [1, "location-count", 3, "mouseover", "mouseout"], [1, "matchedApDetails"], [3, "innerHTML"], [1, "location-node-name", 3, "ngClass"], [1, "location-name", 3, "innerHTML", "ngClass"], [1, "zone-alert"], [1, "zone-alert-message", 3, "id"], [1, "camera-count-alert"], [1, "locationInfo"], ["src", "/assets/images/notification_icon.svg", 3, "mouseover"], [1, "camera-count-alert-message", 3, "id"], [1, "location-node-name"], [1, "repotLocationPopupRadio", "workspacePageRadio", "network-loc-radio"], ["type", "radio", "name", "locationRadio", 3, "checked", "id", "value", "click"], [1, "repotLocationPopupRadio", "workspacePageRadio", "floor-loc-radio"], [1, "repotLocationPopupRadio"], ["type", "radio", "name", "locationRadio", 3, "checked", "id", "value"], ["class", "radioButtonLabel test-root", 3, "for", 4, "ngIf"], ["class", "radioButtonLabel test-network", 3, "for", 4, "ngIf"], ["class", "radioButtonLabel  test-floor", 3, "for", 4, "ngIf"], [1, "radioButtonLabel", "test-root", 3, "for"], [1, "radioButtonLabel", "test-network", 3, "for"], [1, "radioButtonLabel", "test-floor", 3, "for"]], template: function ConfigureLocationHierarchyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "tree-root", 0, 1);
        i0.ɵɵlistener("event", function ConfigureLocationHierarchyComponent_Template_tree_root_event_0_listener($event) { return ctx.onEvent($event); })("stateChange", function ConfigureLocationHierarchyComponent_Template_tree_root_stateChange_0_listener($event) { return ctx.setState($event); });
        i0.ɵɵtemplate(2, ConfigureLocationHierarchyComponent_ng_template_2_Template, 5, 22, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, ConfigureLocationHierarchyComponent_ng_template_4_Template, 1, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, ConfigureLocationHierarchyComponent_ng_template_6_Template, 8, 8, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("nodes", ctx.location)("options", ctx.options);
    } }, directives: [i4.TreeComponent, i1$2.NgIf, i4.TreeNodeChildrenComponent, i1$2.NgClass, i4.TreeNodeWrapperComponent, RowMenuComponent], pipes: [SafeHtmlPipe], styles: ["@charset \"UTF-8\";.locationInfo[_ngcontent-%COMP%]{width:20px}.locationInfo[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:15px}.loc-info[_ngcontent-%COMP%], .camera-count-alert-message[_ngcontent-%COMP%], .zone-alert-message[_ngcontent-%COMP%]{display:none;position:absolute;right:0;left:20px;font-size:12px;color:#fff;background:#565659;width:180px;padding:5px 8px;font-family:CiscoSans;text-transform:initial;z-index:9;margin:5px auto auto}.camera-count-alert-message[_ngcontent-%COMP%]{left:-13em}.zone-alert-message[_ngcontent-%COMP%]{left:-30em}.loc-info[_ngcontent-%COMP%]:before, .camera-count-alert-message[_ngcontent-%COMP%]:before{content:\"\";border-left:7px solid transparent;border-bottom:7px solid #565659;border-right:7px solid transparent;position:absolute;right:11px;top:-7px}.loc-info-show[_ngcontent-%COMP%], .camera-count-alert-show[_ngcontent-%COMP%], .zone-alert-show[_ngcontent-%COMP%]{display:block}.camera-count-alert[_ngcontent-%COMP%], .zone-alert[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle;position:relative}.location-node-name.disable-location[_ngcontent-%COMP%], .location-node-name.disable-location[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:default!important}.location-node-name.disable-location[_ngcontent-%COMP%]   .location-name[_ngcontent-%COMP%]:hover{border:0 none!important;font-family:ciscoSansRegular!important}.location-node-name.disable-location[_ngcontent-%COMP%]{opacity:.5}.modalContent-beta[_ngcontent-%COMP%]{width:300px;left:47%;top:-50%;position:absolute;padding:5px;box-shadow:0 0 20px #0000004d;transform:translate(-50%);-webkit-transform:translateX(-50%);-webkit-box-shadow:0 0 20px rgba(0,0,0,.3);background:#7a7a7a;opacity:1}.modalBody1[_ngcontent-%COMP%]{margin:0;cursor:pointer;opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]{display:flex;height:115px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 10px 10px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:12px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .modalBody1[_ngcontent-%COMP%]:hover{opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]{width:100%;border-top:1px solid #b2a6a6;text-align:center;padding-top:5px}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]   .popup-footer-text[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:13px;color:#fff}.location-count[_ngcontent-%COMP%]{font-size:11px;color:#7a7a7a}.showDiv-on-Mousehover[_ngcontent-%COMP%]{z-index:1001;position:fixed;background-color:#000;margin-left:-75px;margin-top:-85px}.circularCheckbox[_ngcontent-%COMP%]{padding-right:20px;position:relative;float:right;display:block}.richMapRadio[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]{opacity:1!important}.richMapRadio[_ngcontent-%COMP%]{float:right!important}.repotLocationPopupRadio[_ngcontent-%COMP%]{float:right!important}.repotLocationPopupRadio[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]:checked ~ .radioButtonLabel[_ngcontent-%COMP%]:before{left:0;display:inline-block;vertical-align:middle;background-position:0px 0px;position:absolute;right:0px;top:-20px;bottom:5px;margin:auto;width:auto;height:20px;font-size:24px;content:\"\\e93b\";font-family:icomoon-new;text-align:right;padding-right:20px}.workspacePageRadio[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]{opacity:1!important}.displayNone[_ngcontent-%COMP%]{display:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigureLocationHierarchyComponent, [{
        type: Component,
        args: [{
                selector: 'lib-configure-location-hierarchy',
                templateUrl: './configure-location-hierarchy.component.html',
                styleUrls: ['./configure-location-hierarchy.component.scss']
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: LocationService }, { type: i0.ChangeDetectorRef }]; }, { disableRootCheckbox: [{
            type: Input
        }], isRichMapAvailable: [{
            type: Input
        }], permittedLocationTypes: [{
            type: Input
        }], disableNode: [{
            type: Input
        }], searchLocation: [{
            type: Input
        }], filterLocations: [{
            type: Input
        }], excludedLocations: [{
            type: Input
        }] }); })();

class CurrentUserStatusComponent {
    // initialize the absolute-redirect component.
    constructor(activatedRoute, router, dataService, route) {
        this.dataService = dataService;
        this.route = route;
        this.message = "Not able to find current session. Please login again.";
        this.router = router;
        this.redirectTo = activatedRoute.snapshot.data.redirectTo;
        this.noRouteMessage = activatedRoute.snapshot.data.noRouteMessage;
        try {
            // const decodedURIMessage = decodeURIComponent(this.route.snapshot.params.message);
            this.message = this.noRouteMessage;
        }
        catch (e) {
            console.log("no error message send for user current status");
            this.message = this.noRouteMessage;
        }
    }
    // this method is called after the inputs have been found, for the first time.
    ngOnInit() {
        console.warn("Current User Status Error Redirect to:", this.redirectTo);
        if (this.message) {
            this.dataService.setToastMessage(this.message, 5000, null, null, "error");
            this.dataService.clearAll();
            // this.interactionService.doInteractionLog(
            //   new InteractionLog(TYPE.SUBMIT, this.dataService.getPosition(), "{}", SECTION.LOGIN,
            //     ITEM_TYPE.POPUP, ITEM.SELECT_CUSTOMER, "SAVE: App selected and submitted",
            //     '/login')
            // )
        }
        this.router.navigateByUrl(this.redirectTo);
    }
}
CurrentUserStatusComponent.ɵfac = function CurrentUserStatusComponent_Factory(t) { return new (t || CurrentUserStatusComponent)(i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i1.ActivatedRoute)); };
CurrentUserStatusComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CurrentUserStatusComponent, selectors: [["app-current-user-status"]], decls: 4, vars: 1, template: function CurrentUserStatusComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "em");
        i0.ɵɵtext(1, "Redirecting to ");
        i0.ɵɵelementStart(2, "code");
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.redirectTo);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CurrentUserStatusComponent, [{
        type: Component,
        args: [{
                selector: "app-current-user-status",
                templateUrl: "./current-user-status.component.html",
                styleUrls: ["./current-user-status.component.scss"]
            }]
    }], function () { return [{ type: i1.ActivatedRoute }, { type: i1.Router }, { type: DataService }, { type: i1.ActivatedRoute }]; }, null); })();

function CustomLocationHierarchyFilterComponent_ng_template_2_lib_row_menu_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-row-menu", 8);
} if (rf & 2) {
    const node_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("node", node_r7);
} }
const _c0$17 = function (a0) { return { "row-hover": a0 }; };
function CustomLocationHierarchyFilterComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "tree-node-wrapper", 5);
    i0.ɵɵtemplate(2, CustomLocationHierarchyFilterComponent_ng_template_2_lib_row_menu_2_Template, 1, 1, "lib-row-menu", 6);
    i0.ɵɵelement(3, "tree-node-children", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r7 = ctx.$implicit;
    const index_r8 = ctx.index;
    const templates_r9 = ctx.templates;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2.getClass(node_r7));
    i0.ɵɵclassProp("tree-node", true)("tree-node-expanded", node_r7.isExpanded && node_r7.hasChildren)("tree-node-collapsed", node_r7.isCollapsed && node_r7.hasChildren)("tree-node-leaf", node_r7.isLeaf)("tree-node-active", node_r7.isActive)("tree-node-focused", node_r7.isFocused);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleMap(ctx_r2.getPadding(node_r7, ctx_r2.isPopup));
    i0.ɵɵproperty("node", node_r7)("index", index_r8)("templates", templates_r9)("ngClass", i0.ɵɵpureFunction1(24, _c0$17, node_r7.data.showMenu));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r7.data.showMenu);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("node", ctx_r2.getChildren(node_r7))("templates", templates_r9);
} }
function CustomLocationHierarchyFilterComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "Loading, please hold....");
} }
function CustomLocationHierarchyFilterComponent_ng_template_6_div_0_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵelement(1, "span", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r12.apsMatched, i0.ɵɵsanitizeHtml);
} }
const _c1$l = function (a0) { return { "disable-location": a0 }; };
const _c2$e = function (a0) { return { "highlightLocation": a0 }; };
function CustomLocationHierarchyFilterComponent_ng_template_6_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵlistener("click", function CustomLocationHierarchyFilterComponent_ng_template_6_div_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r25); const node_r12 = i0.ɵɵnextContext().$implicit; const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.selectNode(node_r12); });
    i0.ɵɵelementStart(1, "a", 17);
    i0.ɵɵelement(2, "span", 18);
    i0.ɵɵelementStart(3, "span", 19);
    i0.ɵɵlistener("click", function CustomLocationHierarchyFilterComponent_ng_template_6_div_0_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r25); const node_r12 = i0.ɵɵnextContext().$implicit; const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.clickedLocation(node_r12.data); });
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CustomLocationHierarchyFilterComponent_ng_template_6_div_0_span_5_Template, 2, 1, "span", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$l, !ctx_r14.multiLocationSelect && ctx_r14.showCameraCountAlert(node_r12)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 4, node_r12.data.name), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(8, _c2$e, ctx_r14.reportType === "REAL_TIME"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r12.apsMatched);
} }
function CustomLocationHierarchyFilterComponent_ng_template_6_div_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵelement(1, "span", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r12.apsMatched, i0.ɵɵsanitizeHtml);
} }
function CustomLocationHierarchyFilterComponent_ng_template_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "a", 17);
    i0.ɵɵelement(2, "span", 18);
    i0.ɵɵelement(3, "span", 24);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CustomLocationHierarchyFilterComponent_ng_template_6_div_1_span_5_Template, 2, 1, "span", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$l, !ctx_r15.multiLocationSelect && ctx_r15.showCameraCountAlert(node_r12)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 4, node_r12.data.name), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(8, _c2$e, ctx_r15.reportType === "REAL_TIME"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r12.apsMatched);
} }
function CustomLocationHierarchyFilterComponent_ng_template_6_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵelementStart(2, "img", 27);
    i0.ɵɵlistener("mouseover", function CustomLocationHierarchyFilterComponent_ng_template_6_div_2_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r34); const node_r12 = i0.ɵɵnextContext().$implicit; const ctx_r32 = i0.ɵɵnextContext(); return ctx_r32.cameraCountAlertMouseOver($event, node_r12.data.id); })("mouseover", function CustomLocationHierarchyFilterComponent_ng_template_6_div_2_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r34); const node_r12 = i0.ɵɵnextContext().$implicit; const ctx_r35 = i0.ɵɵnextContext(); return ctx_r35.cameraCountAlertMouseOut($event, node_r12.data.id); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 28);
    i0.ɵɵtext(4, " No camera(s) available at this location ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "camera-count_", node_r12.data.id, "");
} }
function CustomLocationHierarchyFilterComponent_ng_template_6_div_3_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵelement(1, "span", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r12.apsMatched, i0.ɵɵsanitizeHtml);
} }
function CustomLocationHierarchyFilterComponent_ng_template_6_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "a", 17);
    i0.ɵɵelement(2, "span", 18);
    i0.ɵɵelement(3, "span", 24);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CustomLocationHierarchyFilterComponent_ng_template_6_div_3_span_5_Template, 2, 1, "span", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 3, node_r12.data.name), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(5, _c2$e, ctx_r17.reportType === "REAL_TIME"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r12.apsMatched);
} }
function CustomLocationHierarchyFilterComponent_ng_template_6_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "input", 31);
    i0.ɵɵlistener("click", function CustomLocationHierarchyFilterComponent_ng_template_6_div_4_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r43); const node_r12 = i0.ɵɵnextContext().$implicit; const ctx_r41 = i0.ɵɵnextContext(); return ctx_r41.selectNode(node_r12); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r12.data.id, "");
    i0.ɵɵproperty("checked", ctx_r18.selectedLocation && ctx_r18.selectedLocation.length > 0 && node_r12.id === ctx_r18.selectedLocation[0].id)("value", node_r12.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r12.data.id, "");
} }
function CustomLocationHierarchyFilterComponent_ng_template_6_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "input", 34);
    i0.ɵɵlistener("click", function CustomLocationHierarchyFilterComponent_ng_template_6_div_5_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r47); const node_r12 = i0.ɵɵnextContext().$implicit; const ctx_r45 = i0.ɵɵnextContext(); return ctx_r45.selectMultipleNode($event, node_r12); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r12.data.id, "");
    i0.ɵɵproperty("checked", ctx_r19.isNodeSelected)("value", node_r12.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r12.data.id, "");
} }
function CustomLocationHierarchyFilterComponent_ng_template_6_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵelementStart(2, "img", 27);
    i0.ɵɵlistener("mouseover", function CustomLocationHierarchyFilterComponent_ng_template_6_div_6_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r51); const node_r12 = i0.ɵɵnextContext().$implicit; const ctx_r49 = i0.ɵɵnextContext(); return ctx_r49.locationInfoMouseOver($event, node_r12.data.id); })("mouseover", function CustomLocationHierarchyFilterComponent_ng_template_6_div_6_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r51); const node_r12 = i0.ɵɵnextContext().$implicit; const ctx_r52 = i0.ɵɵnextContext(); return ctx_r52.locationInfoMouseOut($event, node_r12.data.id); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 37);
    i0.ɵɵtext(4, " Location does not have sufficient data ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "loc_info_", node_r12.data.id, "");
} }
function CustomLocationHierarchyFilterComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CustomLocationHierarchyFilterComponent_ng_template_6_div_0_Template, 6, 10, "div", 9);
    i0.ɵɵtemplate(1, CustomLocationHierarchyFilterComponent_ng_template_6_div_1_Template, 6, 10, "div", 10);
    i0.ɵɵtemplate(2, CustomLocationHierarchyFilterComponent_ng_template_6_div_2_Template, 5, 1, "div", 11);
    i0.ɵɵtemplate(3, CustomLocationHierarchyFilterComponent_ng_template_6_div_3_Template, 6, 7, "div", 12);
    i0.ɵɵtemplate(4, CustomLocationHierarchyFilterComponent_ng_template_6_div_4_Template, 3, 4, "div", 13);
    i0.ɵɵtemplate(5, CustomLocationHierarchyFilterComponent_ng_template_6_div_5_Template, 3, 4, "div", 14);
    i0.ɵɵtemplate(6, CustomLocationHierarchyFilterComponent_ng_template_6_div_6_Template, 5, 1, "div", 15);
} if (rf & 2) {
    const node_r12 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && (node_r12.data.access === "Full" || node_r12.data.reportAccess));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && node_r12.data.access !== "Full" && !node_r12.data.reportAccess);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && ctx_r6.showCameraCountAlert(node_r12));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.multiLocationSelect);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && (node_r12.data.access === "Full" || node_r12.data.reportAccess));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.multiLocationSelect && (node_r12.data.access === "Full" || node_r12.data.reportAccess) && node_r12.data.type === "network" && ctx_r6.isIncluded(node_r12));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.multiLocationSelect && node_r12.data.type === "network" && !ctx_r6.isIncluded(node_r12));
} }
class CustomLocationHierarchyFilterComponent extends ManageLocationTreeComponent {
    constructor(router_, dataService_, locationService_, cdRef_) {
        super(router_, dataService_, locationService_, cdRef_);
        this.router_ = router_;
        this.dataService_ = dataService_;
        this.locationService_ = locationService_;
        this.cdRef_ = cdRef_;
        this.rootLocationObj = {};
        this.maxSelectionNumber = 3;
        this.prevSearchString = "";
        this.excludedLocs = [];
        this.onEvent = ($event) => {
            // console.log('onEvent from tree::', $event);
            switch ($event.eventName) {
                case "initialized":
                    console.log("location loading done", new Date().getTime() - this.startTime);
                    this.isTreeInitialised = true;
                    this.treeComponent.treeModel.roots.forEach((root) => {
                        this.rootLocationObj = root.data;
                        if (root.isCollapsed)
                            root.expand();
                    });
                    this.initLocationNodes();
                    setTimeout(() => {
                        if (this.treeComponent) {
                            this.treeComponent.sizeChanged();
                        }
                    }, 100);
                    break;
                case "toggleExpanded":
                    setTimeout(() => {
                        if (this.treeComponent) {
                            this.treeComponent.sizeChanged();
                        }
                    }, 100);
                    break;
            }
            // this.searchTree(this.searchTimestamp);
        };
        this.initLocationNodes = () => {
            if (this.currentFilterLocations &&
                this.currentFilterLocations.length > 0) {
                this.filterLocationIds(this.currentFilterLocations);
            }
            else {
                this.location = this.locationOrginal;
            }
            this.prevFilterLocations = this.currentFilterLocations;
        };
        this.getChildren = (node) => {
            return node;
        };
        this.clickedLocation = (data) => {
            // if (this.reportType == "REAL_TIME"){
            //   let spacesObj = JSON.parse(sessionStorage.getItem('spacesObj'));
            //   if(data.type == "network" || data.type == "root"){
            //     delete spacesObj['realtimeLocation'];
            //     spacesObj['spacesLocation'] = {id: data.id, name: data.name, type: data.type == "root" ? 'all' : data.type};
            //   }else{
            //     spacesObj['realtimeLocation'] = {id: data.id};
            //     spacesObj['spacesLocation'] = {id: this.rootLocationObj["id"], name: this.rootLocationObj["name"], type: 'all'};
            //   }
            //   this.dataService.setSpacesObject(spacesObj);
            // }
        };
        this.isIncluded = (node) => {
            if (this.excludedLocs && this.excludedLocs.length > 0) {
                if (this.excludedLocs.indexOf(node.data.id) != -1)
                    return false;
                else
                    return true;
            }
            return true;
        };
        this.locationInfoMouseOver = (event, id) => {
            $("#loc_info_" + String(id)).addClass("loc-info-show");
        };
        this.locationInfoMouseOut = (event, id) => {
            setTimeout(() => {
                $("#loc_info_" + String(id)).removeClass("loc-info-show");
            }, 2000);
        };
        this.showCameraCountAlert = (node) => {
            if (node.data.camerasCount === 0 &&
                this.dataService.getCurrentNav().indexOf("camera-metrics") !== -1) {
                return true;
            }
            else {
                return false;
            }
        };
        this.cameraCountAlertMouseOver = (event, id) => {
            $("#camera-count_" + String(id)).addClass("camera-count-alert-show");
        };
        this.cameraCountAlertMouseOut = (event, id) => {
            setTimeout(() => {
                $("#camera-count_" + String(id)).removeClass("camera-count-alert-show");
            }, 2000);
        };
        this.selectNode = (node) => {
            if ((this.dataService.getCurrentNav() &&
                this.dataService.getCurrentNav().indexOf("right-now") !== -1 &&
                (node.data.type === "zone" ||
                    node.data.type === "cmxzone" ||
                    node.data.type === "polygon_zone")) ||
                (this.dataService.getCurrentNav().indexOf("camera-metrics") !==
                    -1 &&
                    node.data.camerasCount === 0))
                return;
            if (this.dataService.getCurrentNav() &&
                this.dataService.getCurrentNav().indexOf("right-now") !== -1 &&
                node.data.path.indexOf(this.selRightNowLocation.id) == -1) {
                return;
            }
            this.doSelection(node);
            this.selectedLocationEvt.emit(this.selectedLocation);
        };
    }
    ngOnInit() {
        this.makeSearchAPICall = false;
        super.ngOnInit();
    }
    set selectedRightNowLocation(value) {
        this.selRightNowLocation = value;
    }
    set searchLocation(value) {
        // this.searchTimestamp = new Date().getTime();
        // if (!value || value.trim() == "")
        //   this.prevSearchString = "";
        // else
        //   this.prevSearchString = value;
        // this.searchTree(this.searchTimestamp);
        // this.subscribeSearchText(value);
        this.enableCustomSearch = true;
        if (value) {
            // this.prevSearchString = customSearchText;
            // this.searchTree(new Date().getTime());
            this.subscribeSearchText(value);
        }
    }
    set filterLocations(filterLocations) {
        this.currentFilterLocations = filterLocations;
        if (this.isTreeInitialised)
            this.initLocationNodes();
    }
    set excludedLocations(excludedLocs) {
        if (excludedLocs)
            this.excludedLocs = excludedLocs;
        else
            this.excludedLocs = [];
    }
    ngOnDestroy() {
        console.log("destory spaces location hierarchy page");
        super.ngOnDestroy();
    }
    selectMultipleNode($event, node) {
        if (this.selectedLocation) {
            let existingNodeId = null;
            let index = null;
            existingNodeId = this.selectedLocation.filter(function (n, i) {
                if (n.data.id === node.data.id) {
                    index = i;
                    return i;
                }
            });
            if (index !== null) {
                super.selectMultipleNode($event, node);
            }
            else {
                if (this.selectedLocation.length < this.maxSelectionNumber) {
                    super.selectMultipleNode($event, node);
                }
                else {
                    // Show error message to user about max selected
                    this.dataService.setToastMessage("You can pin a maximum of 3 locations", 2000, null, null, "error");
                    this.isNodeSelected = false;
                    $event.target.checked = false;
                }
            }
        }
        else {
            super.selectMultipleNode($event, node);
        }
    }
}
CustomLocationHierarchyFilterComponent.ɵfac = function CustomLocationHierarchyFilterComponent_Factory(t) { return new (t || CustomLocationHierarchyFilterComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
CustomLocationHierarchyFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomLocationHierarchyFilterComponent, selectors: [["lib-custom-location-hierarchy-filter"]], inputs: { selectedRightNowLocation: "selectedRightNowLocation", disableRootCheckbox: "disableRootCheckbox", searchLocation: "searchLocation", filterLocations: "filterLocations", excludedLocations: "excludedLocations" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 2, consts: [[3, "nodes", "options", "event", "stateChange"], ["tree", ""], ["treeNodeFullTemplate", ""], ["loadingTemplate", ""], ["treeNodeTemplate", ""], [1, "pointer", 3, "node", "index", "templates", "ngClass"], [3, "node", 4, "ngIf"], [3, "node", "templates"], [3, "node"], ["class", "location-node-name", 3, "ngClass", "click", 4, "ngIf"], ["class", "location-node-name", 3, "ngClass", 4, "ngIf"], ["class", "camera-count-alert", 4, "ngIf"], ["class", "location-node-name", 4, "ngIf"], ["class", "repotLocationPopupRadio", 4, "ngIf"], ["class", "circularCheckbox", 4, "ngIf"], ["class", "location-info", 4, "ngIf"], [1, "location-node-name", 3, "ngClass", "click"], ["href", "javascript:void(0);", 1, "location-name-icon"], [1, "loc-type-icon"], [1, "location-name", 3, "innerHTML", "ngClass", "click"], ["class", "matchedApDetails", 4, "ngIf"], [1, "matchedApDetails"], [3, "innerHTML"], [1, "location-node-name", 3, "ngClass"], [1, "location-name", 3, "innerHTML", "ngClass"], [1, "camera-count-alert"], [1, "locationInfo"], ["src", "/assets/images/notification_icon.svg", 3, "mouseover"], [1, "camera-count-alert-message", 3, "id"], [1, "location-node-name"], [1, "repotLocationPopupRadio"], ["type", "radio", "name", "locationRadio", 3, "checked", "id", "value", "click"], [1, "radioButtonLabel", 3, "for"], [1, "circularCheckbox"], ["type", "checkbox", "name", "locationChecbox", 3, "checked", "id", "value", "click"], [1, "checkboxLabel", 3, "for"], [1, "location-info"], [1, "loc-info", 3, "id"]], template: function CustomLocationHierarchyFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "tree-root", 0, 1);
        i0.ɵɵlistener("event", function CustomLocationHierarchyFilterComponent_Template_tree_root_event_0_listener($event) { return ctx.onEvent($event); })("stateChange", function CustomLocationHierarchyFilterComponent_Template_tree_root_stateChange_0_listener($event) { return ctx.setState($event); });
        i0.ɵɵtemplate(2, CustomLocationHierarchyFilterComponent_ng_template_2_Template, 4, 26, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, CustomLocationHierarchyFilterComponent_ng_template_4_Template, 1, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, CustomLocationHierarchyFilterComponent_ng_template_6_Template, 7, 7, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("nodes", ctx.location)("options", ctx.options);
    } }, directives: [i4.TreeComponent, i4.TreeNodeWrapperComponent, i1$2.NgClass, i1$2.NgIf, i4.TreeNodeChildrenComponent, RowMenuComponent], pipes: [SafeHtmlPipe], styles: [".locationInfo[_ngcontent-%COMP%]{width:20px}.locationInfo[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:15px}.loc-info[_ngcontent-%COMP%], .camera-count-alert-message[_ngcontent-%COMP%]{display:none;position:absolute;right:0;left:20px;font-size:12px;color:#fff;background:#565659;width:180px;padding:5px 8px;font-family:CiscoSans;text-transform:initial;z-index:9;margin:5px auto auto}.camera-count-alert-message[_ngcontent-%COMP%]{left:-13em}.loc-info[_ngcontent-%COMP%]:before, .camera-count-alert-message[_ngcontent-%COMP%]:before{content:\"\";border-left:7px solid transparent;border-bottom:7px solid #565659;border-right:7px solid transparent;position:absolute;right:11px;top:-7px}.loc-info-show[_ngcontent-%COMP%], .camera-count-alert-show[_ngcontent-%COMP%]{display:block}.camera-count-alert[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle;position:relative}.location-node-name.disable-location[_ngcontent-%COMP%], .location-node-name.disable-location[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:default!important}.location-node-name.disable-location[_ngcontent-%COMP%]   .location-name[_ngcontent-%COMP%]:hover{border:0 none!important;font-family:ciscoSansRegular!important}.location-node-name.disable-location[_ngcontent-%COMP%]{opacity:.5}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomLocationHierarchyFilterComponent, [{
        type: Component,
        args: [{
                selector: "lib-custom-location-hierarchy-filter",
                templateUrl: "./custom-location-hierarchy-filter.component.html",
                styleUrls: ["./custom-location-hierarchy-filter.component.scss"]
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: LocationService }, { type: i0.ChangeDetectorRef }]; }, { selectedRightNowLocation: [{
            type: Input
        }], disableRootCheckbox: [{
            type: Input
        }], searchLocation: [{
            type: Input
        }], filterLocations: [{
            type: Input
        }], excludedLocations: [{
            type: Input
        }] }); })();

const _c0$16 = function (a0, a1) { return { "active": a0, "disabled": a1 }; };
function CustomPaginationComponent_div_0_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function CustomPaginationComponent_div_0_button_8_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const pageNum_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return ctx_r3.onPage(pageNum_r2); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const pageNum_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0$16, pageNum_r2 === ctx_r1.page, ctx_r1.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", pageNum_r2, " ");
} }
const _c1$k = function (a0) { return { "disabled": a0 }; };
function CustomPaginationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "button", 3);
    i0.ɵɵlistener("click", function CustomPaginationComponent_div_0_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.showFirst(); });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 3);
    i0.ɵɵlistener("click", function CustomPaginationComponent_div_0_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.onPrev(); });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, CustomPaginationComponent_div_0_button_8_Template, 2, 5, "button", 4);
    i0.ɵɵelementStart(9, "button", 3);
    i0.ɵɵlistener("click", function CustomPaginationComponent_div_0_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r6); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.onNext(); });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 3);
    i0.ɵɵlistener("click", function CustomPaginationComponent_div_0_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r6); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.showLast(); });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 5);
    i0.ɵɵelementStart(16, "span", 6);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "span", 7);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.page === 1 || ctx_r0.loading)("ngClass", i0.ɵɵpureFunction1(31, _c1$k, ctx_r0.page === 1 || ctx_r0.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 19, "shared-lib.custom-pagination.first"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.page === 1 || ctx_r0.loading)("ngClass", i0.ɵɵpureFunction1(33, _c1$k, ctx_r0.page === 1 || ctx_r0.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 21, "shared-lib.custom-pagination.previous"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.getPages());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r0.lastPage() || ctx_r0.loading)("ngClass", i0.ɵɵpureFunction1(35, _c1$k, ctx_r0.lastPage() || ctx_r0.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 23, "shared-lib.custom-pagination.next"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.lastPage() || ctx_r0.loading)("ngClass", i0.ɵɵpureFunction1(37, _c1$k, ctx_r0.lastPage() || ctx_r0.loading));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 25, "shared-lib.custom-pagination.last"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate4("(", ctx_r0.getMin(), " - ", ctx_r0.getMax(), " ", i0.ɵɵpipeBind1(18, 27, "shared-lib.custom-pagination.of"), " ", ctx_r0.itemsCount, ")");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" : ", ctx_r0.totalPages(), " ", i0.ɵɵpipeBind1(21, 29, "shared-lib.custom-pagination.pages"), "");
} }
class CustomPaginationComponent {
    constructor() {
        this.page = 1;
        this.perPage = 18;
        this.itemsCount = 1;
        // @Output() goPrev = new EventEmitter<boolean>();
        // @Output() goNext = new EventEmitter<boolean>();
        this.clickEvent = new EventEmitter();
        this.currentPage = new EventEmitter();
        this.showLast = () => {
            this.onPage(this.totalPages());
            this.clickEvent.emit({ event: "showLast", page: this.page });
        };
        this.showFirst = () => {
            this.onPage(1);
            this.clickEvent.emit({ event: "showFirst", page: this.page });
        };
        this.calculate = () => {
            this.currentPageItems();
        };
        this.currentPageItems = () => {
            const currentPageI = [];
            if (this.totalItems != null)
                for (let i = this.getMin() - 1, max = this.getMax(); i < max; i++) {
                    if (this.totalItems[i]) {
                        currentPageI.push(this.totalItems[i]);
                    }
                }
            // console.log('currentPageI  items', currentPageI);
            this.currentPage.emit(currentPageI);
        };
    }
    set items(items) {
        this.totalItems = items;
        // this.page = 1;
        this.calculate();
    }
    getMin() {
        return this.perPage * this.page - this.perPage + 1;
    }
    totalPages() {
        return Math.ceil(this.itemsCount / this.perPage) || 0;
    }
    lastPage() {
        return this.perPage * this.page >= this.itemsCount;
    }
    getMax() {
        let max = this.perPage * this.page;
        max = this.itemsCount;
        return max;
    }
    getPages() {
        const c = Math.ceil(this.itemsCount / this.perPage);
        const p = this.page || 1;
        const pagesToShow = this.pagesToShow || 9;
        const pages = [];
        pages.push(p);
        const times = pagesToShow - 1;
        for (let i = 0; i < times; i++) {
            if (pages.length < pagesToShow) {
                if (Math.min.apply(null, pages) > 1) {
                    pages.push(Math.min.apply(null, pages) - 1);
                }
            }
            if (pages.length < pagesToShow) {
                if (Math.max.apply(null, pages) < c) {
                    pages.push(Math.max.apply(null, pages) + 1);
                }
            }
        }
        pages.sort((a, b) => a - b);
        return pages;
    }
    onPrev() {
        // this.goPrev.emit(true);
        if (this.page !== 1) {
            this.onPage(this.page - 1);
            this.clickEvent.emit({ event: "onPrev", page: this.page });
        }
    }
    onNext() {
        // this.goNext.emit(next);
        if (this.page !== this.totalPages()) {
            this.onPage(this.page + 1);
            this.clickEvent.emit({ event: "onNext", page: this.page });
        }
    }
    onPage(n) {
        this.page = n;
        this.calculate();
        this.clickEvent.emit({ event: "onPage", page: this.page });
    }
}
CustomPaginationComponent.ɵfac = function CustomPaginationComponent_Factory(t) { return new (t || CustomPaginationComponent)(); };
CustomPaginationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomPaginationComponent, selectors: [["lib-custom-pagination"]], inputs: { page: "page", perPage: "perPage", itemsCount: "itemsCount", items: "items", pagesToShow: "pagesToShow", loading: "loading" }, outputs: { clickEvent: "clickEvent", currentPage: "currentPage" }, decls: 1, vars: 1, consts: [["class", "pagination", 4, "ngIf"], [1, "pagination"], [1, "numbers"], [1, "link", 3, "disabled", "ngClass", "click"], ["class", "numericButton", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "description"], [1, "page-counts"], [1, "page-totals"], [1, "numericButton", 3, "ngClass", "click"]], template: function CustomPaginationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CustomPaginationComponent_div_0_Template, 22, 39, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.totalItems && ctx.totalItems.length > 0);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i1$2.NgForOf], pipes: [i2.TranslatePipe], styles: [".pagination[_ngcontent-%COMP%]{margin:15px 0}.description[_ngcontent-%COMP%]{color:#58585b;font-size:12px;float:right;clear:right;margin:5px 0;font-family:ciscoSans}.page-counts[_ngcontent-%COMP%]{font-weight:bold}.numbers[_ngcontent-%COMP%]{background-color:#fff;border:0;border-radius:1.3em;box-shadow:0 0 2px #00000080;width:auto;display:inline-block}.numbers[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{margin:6px 0;border:0;background-color:transparent;display:inline-block;height:100%;padding:0 4px 0 10px;outline:none;color:#4d4d4d;font-size:12px}.numbers[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]:last-child{padding-right:10px}.numbers[_ngcontent-%COMP%] > button.disabled[_ngcontent-%COMP%]{color:#ccc;cursor:not-allowed}.numbers[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]:not(:first-child){border-left:1px solid #dddfe2}.numbers[_ngcontent-%COMP%] > button.numericButton[_ngcontent-%COMP%]{padding:0 10px;color:#049fd9}.numbers[_ngcontent-%COMP%] > button.numericButton.active[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;margin:0;padding-top:6px;padding-bottom:6px;border:0;cursor:default}.numbers[_ngcontent-%COMP%] > button.numericButton.active[_ngcontent-%COMP%] + button[_ngcontent-%COMP%]{border-left:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomPaginationComponent, [{
        type: Component,
        args: [{
                selector: "lib-custom-pagination",
                templateUrl: "./custom-pagination.component.html",
                styleUrls: ["./custom-pagination.component.scss"]
            }]
    }], function () { return []; }, { page: [{
            type: Input
        }], perPage: [{
            type: Input
        }], itemsCount: [{
            type: Input
        }], items: [{
            type: Input
        }], pagesToShow: [{
            type: Input
        }], loading: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], currentPage: [{
            type: Output
        }] }); })();

class CustomTooltipComponent {
    constructor() { }
}
CustomTooltipComponent.ɵfac = function CustomTooltipComponent_Factory(t) { return new (t || CustomTooltipComponent)(); };
CustomTooltipComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomTooltipComponent, selectors: [["app-custom-tooltip"]], inputs: { message: "message" }, decls: 3, vars: 1, consts: [["id", "tooltiptext", 1, "tooltiptext"]], template: function CustomTooltipComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "span");
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.message);
    } }, styles: [".tooltiptext[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background:#FFFFFF;position:relative;display:inline-block;background-color:#fff;color:#58595b;font-weight:600;border:1px solid #a9a9a9;line-height:19px;border-radius:0;padding:15px;visibility:visible;opacity:1;width:170%;transition:opacity .3s;margin-top:12px}.tooltiptext[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:before{content:\"\";position:absolute;bottom:100%;left:5%;border-width:7px;border-bottom:11px solid #a9a9a9;border-right:9px solid transparent;border-left:9px solid transparent;margin-left:-1px}.tooltiptext[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:after{content:\"\";position:absolute;bottom:100%;left:5%;border-width:7px;border-bottom:10px solid #FFFFFF;border-right:8px solid transparent;border-left:8px solid transparent}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomTooltipComponent, [{
        type: Component,
        args: [{
                selector: "app-custom-tooltip",
                templateUrl: "./custom-tooltip.component.html",
                styleUrls: ["./custom-tooltip.component.scss"]
            }]
    }], function () { return []; }, { message: [{
            type: Input
        }] }); })();

const _c0$15 = ["chart"];
class D3ChartComponent {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor(dataService) {
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.chartOptions = {};
        this.sourceData = [];
        this.readableNumber = (value, decimalPoint) => {
            if (value === null) {
                return null;
            }
            if (value === 0) {
                return "0";
            }
            decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
            const numCount = value.toPrecision(2).split("e"), // get power
            noOfK = numCount.length === 1
                ? 0
                : Math.floor(Math.min(+numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
            dividedValue = noOfK < 1
                ? value.toFixed(0 + decimalPoint)
                : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
            finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
            suffix = finalValue + ["", "K", "M", "B", "T"][noOfK]; // append power
            return suffix;
        };
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        isUndefined(this.chartOptions.showValue) &&
            (this.chartOptions.showValue = true);
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.x = this.getxScale();
            this.y = this.getScaleY();
            this.draw();
        }
    }
    set data(value) {
        if (!value || value.length == 0)
            return;
        this.sourceData = value;
        this.numSections = value.length;
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.x = this.getxScale();
            this.y = this.getScaleY();
            this.draw();
        }
    }
    ngAfterViewInit() {
        this.dataService.getMagneticAppIsExpanded(this.unsubscribe$).subscribe((val) => {
            setTimeout(() => {
                // console.log("getMagneticAppIsExpanded", val);
                if (this.sourceData && this.sourceData.length > 0)
                    this.reDraw();
            }, 500);
        });
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        if (this.svg)
            this.svg.remove();
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%");
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg
            .append("g")
            .attr("transform", `translate(${this.chartOptions.margin.left + 20},${this.chartOptions.margin.top})`);
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(function () {
            return "<div id='bi-tooltip'></div>";
        });
        this.svg.call(this.tip);
    }
    getScaleY() {
        return null;
    }
    getxScale() {
        return null;
    }
    draw() {
        //yAxis Label
        this.chart
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", `${0 - (this.chartOptions.margin.left + 10)}`)
            .attr("x", 0 - (this.height / 2))
            .attr("dy", "1em")
            .style("fill", "#000000")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
        this.chart
            .append("g")
            .attr("transform", `translate(${this.chartOptions.margin.left - 10},0)`)
            .attr("class", "axis y-axis");
        // .call(d3.axisLeft(this.y).ticks(null, "s"));
        if (this.chartOptions.app && this.chartOptions.app === "iot") {
            this.chart
                .append("g")
                .attr("class", "grid")
                .attr("transform", `translate(${this.chartOptions.margin.left - 15},0)`)
                .call(d3
                .axisLeft(this.y)
                .scale(this.y)
                .ticks(3)
                .tickSize(-this.width)
                .tickFormat((d) => { return ""; }));
        }
        else {
            this.chart
                .append("g")
                .attr("class", "grid")
                .attr("transform", `translate(${this.chartOptions.margin.left - 15},0)`)
                .call(d3
                .axisLeft(this.y)
                .scale(this.y)
                .tickSize(-this.width)
                .tickFormat((d) => this.setYaxis(d)));
        }
    }
    setYaxis(d) {
        if (this.chartOptions.setReadableNumber) {
            return `${this.readableNumber(d, 1) +
                this.chartOptions.yAxisTickFormat}`;
        }
        else {
            return `${(d + this.chartOptions.yAxisTickFormat)}`;
        }
    }
    update(data) {
        this.data = data;
        const elm = document.querySelector(this.element);
        elm.removeChild(elm.firstChild);
        this.createSvg();
        this.y = this.getScaleY();
    }
    // reDraw() {
    //   this.element = this.chartContainer.nativeElement;
    //   var elm = document.querySelector(this.element);
    //   elm.removeChild(elm.firstChild);
    //   this.createSvg();
    // }
    reDraw() {
        this.element.removeChild(this.element.firstChild);
        this.createSvg();
    }
}
D3ChartComponent.ɵfac = function D3ChartComponent_Factory(t) { return new (t || D3ChartComponent)(i0.ɵɵdirectiveInject(DataService)); };
D3ChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3ChartComponent, selectors: [["lib-d3-chart"]], viewQuery: function D3ChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$15, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, decls: 0, vars: 0, template: function D3ChartComponent_Template(rf, ctx) { }, styles: [""] });
D3ChartComponent.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: D3ChartComponent, factory: D3ChartComponent.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3ChartComponent, [{
        type: Injectable
    }, {
        type: Component,
        args: [{
                selector: "lib-d3-chart",
                templateUrl: "./d3-chart.component.html",
                styleUrls: ["./d3-chart.component.scss"]
            }]
    }], function () { return [{ type: DataService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

class D3ColumnChartComponent extends D3ChartComponent {
    constructor(dataService) {
        super(dataService);
        this.dataService = dataService;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    onResize() {
        if (this.sourceData && this.sourceData.length > 0)
            this.reDraw();
    }
    getScaleY() {
        return d3
            .scaleLinear()
            .range([this.height, 0])
            .domain([
            0,
            d3.max(this.sourceData, function (d) {
                return d3.max(d["values"], function (obj) {
                    return parseFloat(obj["count"]) > 10
                        ? parseFloat(obj["count"])
                        : 10;
                });
            })
        ])
            .nice();
    }
    getSectionWidth(bars, barWidth, barSpacing) {
        return bars.length * barWidth + (bars.length - 1) * barSpacing;
    }
    getSectionSpacing() {
        let totalBarWidth = 0;
        this.sourceData.forEach((section) => {
            const bars = section.values;
            const barSpacing = section.barSpacing
                ? section.barSpacing
                : this.chartOptions.barSpacing;
            let barWidth = section.barWidth
                ? section.barWidth
                : this.chartOptions.barWidth;
            if (section.type !== "average")
                barWidth = section.barWidth
                    ? section.barWidth
                    : this.chartOptions.barWidth * 3;
            totalBarWidth += this.getSectionWidth(bars, barWidth, barSpacing);
        });
        const remainingWidth = this.width - this.chartOptions.outerPadding * 2 - totalBarWidth;
        let gSpacing = 0;
        if (this.chartOptions.centreAlign && this.numSections < 3)
            gSpacing = Math.floor(remainingWidth / 4);
        else if (this.chartOptions.section === "rightnow")
            gSpacing = Math.floor(remainingWidth / 3);
        else if (this.chartOptions.sectionCentre && this.numSections < 3)
            gSpacing = Math.floor(remainingWidth / 2);
        else
            gSpacing = Math.floor(remainingWidth / (this.numSections - 1));
        return Math.max(this.chartOptions.sectionSpacing, gSpacing);
    }
    draw() {
        super.draw();
        const sectionSpacing = this.getSectionSpacing();
        const tl = this.chart.append("g").attr("class", "threshold");
        const sectionGroup = this.chart.append("g").attr("class", "section");
        let xPos = this.chartOptions.outerPadding;
        if (this.chartOptions.peakPoint) {
            if (this.chartOptions.app && this.chartOptions.app === "iot") {
                let lines = this.chart.append('g');
                lines.append("line")
                    .attr("x1", 10)
                    .attr("y1", this.y(this.chartOptions.peakPoint))
                    .attr("x2", this.width)
                    .attr("y2", this.y(this.chartOptions.peakPoint))
                    .attr("stroke-width", 1)
                    .attr("stroke", "#ccc");
            }
            else {
                let lines = this.chart.append('g');
                lines.append("line")
                    .attr("x1", 10)
                    .attr("y1", this.y(this.chartOptions.peakPoint))
                    .attr("x2", this.width)
                    .attr("y2", this.y(this.chartOptions.peakPoint))
                    .attr("stroke-width", 2)
                    .attr("stroke", "#121212");
            }
        }
        if (this.chartOptions.centreAlign) {
            if (this.numSections === 1) {
                xPos = this.width / 2;
            }
            else if (this.numSections === 2) {
                xPos = this.width / 3;
            }
        }
        if (this.chartOptions.centreAlign &&
            this.chartOptions.section === "rightnow") {
            xPos = this.width / 4;
        }
        let titleYPos = 0;
        const self = this;
        let enableLocAdjustment = false;
        let adjustLocBar = false;
        this.sourceData.forEach((section) => {
            if (section.alignPosition === "center") {
                sectionGroup.attr("transform", `translate(${(this.chart._groups[0][0].getBBox().width / 5)},0)`);
            }
            let benchmarkDataCount = 0;
            const bars = section.values;
            const barSpacing = section.barSpacing
                ? section.barSpacing
                : this.chartOptions.barSpacing;
            const barWidth = section.barWidth
                ? section.barWidth
                : this.chartOptions.barWidth;
            const sectionWidth = this.getSectionWidth(bars, barWidth, barSpacing);
            const barGroup = sectionGroup.append("g");
            if (section.barPlacing) {
                sectionGroup.attr("transform", `translate(${(this.chartOptions.margin.left + 45)},0)`);
            }
            if (section.dataType == "benchmark") {
                benchmarkDataCount = section.values.length;
                if (benchmarkDataCount <= 4)
                    enableLocAdjustment = true;
            }
            if (section.dataType == "currentLocation" ||
                section.barPlacing ||
                section.dataType == "group" ||
                section.alignPosition === "center") {
                if (enableLocAdjustment)
                    adjustLocBar = true;
            }
            titleYPos =
                barGroup._groups[0][0].nearestViewportElement.clientHeight;
            bars.forEach((value, i) => {
                if (adjustLocBar) {
                    if (section.alignPosition === "center")
                        xPos = xPos / 2 + sectionWidth - section.barSpacing;
                    else
                        xPos = xPos / 2 + section.barWidth;
                }
                const tlXPos = xPos;
                barGroup
                    .append("rect")
                    // .attrs({
                    // 	x: xPos,
                    // 	y: this.y(value.count),
                    // 	width: section.barWidth,
                    // 	height: this.height - this.y(value.count),
                    // 	fill: value.color ? value.color : section.color,
                    // 	class: "bar"
                    // })
                    .attr("width", section.barWidth)
                    .attr("height", this.height - this.y(value.count))
                    .attr("x", xPos)
                    .attr("y", this.y(value.count))
                    .attr("fill", value.color ? value.color : section.color)
                    .attr("class", "bar")
                    .on("mouseover", function (d) {
                    if (value.formatTooltip) {
                        self.setFormatTooltip(value);
                    }
                    else {
                        let tipContainer = "";
                        const suffix = value.suffix ? value.suffix : "";
                        self.tip.html(function () {
                            tipContainer +=
                                "<div class='top-section'><div class='top-left'>";
                            if (value.tooltipLabel)
                                tipContainer += `<span class='left-label'> 
										${value.tooltipLabel} 
										</span>`;
                            else
                                tipContainer += `<span class='left-label'> 
										${value.label} 
										</span>`;
                            tipContainer += `<span class='top-right-value'> ${value.count}`;
                            if (suffix)
                                tipContainer += `<span class='suffix'>
										${suffix} 
										</span>`;
                            tipContainer += "</span>";
                            if (value.brand || value.city || value.state) {
                                tipContainer +=
                                    "<div class='meta-data-section'>";
                                if (value.brand)
                                    tipContainer += `<div class='brand'>
											${value.brand}
											, </div>`;
                                if (value.city)
                                    tipContainer += `<div class='city'>
											${value.city} , </div>`;
                                if (value.state)
                                    tipContainer += `<div class='state'>
											${value.state} </div>`;
                                tipContainer += "</div>";
                            }
                            tipContainer += "</div>";
                            tipContainer += "</div>";
                            // tipContainer += "<div class='top-right-value'>" + value.count
                            // if(suffix)
                            //   tipContainer += " <span class='suffix'>" + suffix + "</span>"
                            // tipContainer += "</div>"
                            const rankList = value.rankList;
                            if (rankList) {
                                tipContainer += "<div class='top-section'>";
                                tipContainer +=
                                    "<div class='ranking-list'>";
                                rankList.forEach((rank) => {
                                    tipContainer += `<div class='location-position'> 
											${rank} 
											</div>`;
                                });
                                tipContainer += "</div>";
                            }
                            tipContainer += "</div>";
                            return tipContainer;
                        });
                    }
                    self.tip
                        .style("opacity", 1);
                    self.tip.show(d, this);
                })
                    .on("mouseout", function () {
                    self.tip
                        .style("opacity", 0);
                    self.tip.hide();
                });
                if (value.labelVisible) {
                    if (value.labelWrap) {
                        barGroup
                            .append("text")
                            .attr("x", tlXPos + barWidth / 2)
                            .attr("y", titleYPos - 55)
                            .attr("text-anchor", "middle")
                            .attr("class", "bar-label")
                            .text(value.shortLabel
                            ? value.shortLabel
                            : value.label)
                            // eslint-disable-next-line @typescript-eslint/unbound-method
                            .call(self.wrap, 100);
                    }
                    else {
                        barGroup
                            .append("text")
                            .attr("x", tlXPos + barWidth / 2)
                            .attr("y", titleYPos - 45)
                            .attr("text-anchor", "middle")
                            .attr("class", "bar-label")
                            .text(value.shortLabel
                            ? value.shortLabel
                            : value.label);
                    }
                }
                xPos += section.barWidth;
                if (i < bars.length - 1)
                    xPos += section.barSpacing;
                if (value.threshold)
                    this.drawThresholdLine(value, tl, tlXPos); // to draw threshold line
                if (this.chartOptions.showValue)
                    this.drawValue(value, barGroup, tlXPos, section.barWidth); // to draw value on top of the bar
            });
            this.drawTitle(section, barGroup, titleYPos);
            xPos += sectionSpacing;
        });
    }
    setFormatTooltip(value) {
        const self = this;
        let tipContainer = "";
        self.tip.html(function () {
            tipContainer += "<div class = 'columnChart-tooltip'>";
            if (value.displayDate)
                tipContainer += `<div class='columnChart-top'>
					${value.displayDate} </div>`;
            else
                tipContainer += `<div class='columnChart-top'>${value.label}</div>`;
            tipContainer += "<div class='daily-info'>";
            tipContainer += `<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:
				${value.color}'></span><span class='multiLine-left'><span class='columnChart-left'>
				${value.tooltipLabel}
				</span><span class = 'columnChart-right'>
				${value.count}
				</span>`;
            tipContainer += "</div></div>";
            return tipContainer;
        });
    }
    drawThresholdLine(value, tl, x) {
        tl.append("line")
            // .attrs({
            // 	x1: value.historicalThreshold ? x - 10 : x,
            // 	y1: this.y(value.count),
            // 	x2: this.width,
            // 	y2: this.y(value.count),
            // 	stroke: value.color,
            // 	"stroke-width": 2
            // });
            .attr("x1", value.historicalThreshold ? x - 10 : x)
            .attr("y1", this.y(value.count))
            .attr("x2", this.width)
            .attr("y2", this.y(value.count))
            .attr("stroke", value.color)
            .attr("stroke-width", 2);
    }
    drawValue(value, bar, x, barWidth) {
        const valueGroup = bar.append("g").attr("class", "barValue");
        valueGroup.append("rect")
            // .attrs({
            // 	x: x - 5,
            // 	y: this.y(value.count) - 25,
            // 	width: +barWidth + 10,
            // 	height: 23,
            // 	fill: "#fff"
            // });
            .attr("x", x - 5)
            .attr("y", this.y(value.count) - 25)
            .attr("width", barWidth + 10)
            .attr("height", 23)
            .attr("fill", "#fff");
        valueGroup
            .append("text")
            .attr("x", value.thresholdCount ? x + 25 : (x + barWidth / 2))
            .attr("y", this.y(value.count) - 5)
            .attr("text-anchor", "middle")
            .attr("class", value.thresholdCount
            ? "valuesOnTop historical"
            : "valuesOnTop")
            .attr("fill", this.chartOptions.valueColor)
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .text(() => this.setBarValue(value));
    }
    setBarValue(count) {
        if (this.chartOptions.setReadableNumber) {
            if (count.thresholdCount)
                return this.readableNumber(count.thresholdCount, 0);
            else
                return this.readableNumber(count.count, 0);
        }
        else {
            return count.thresholdCount ? count.thresholdCount : count.count;
        }
    }
    drawTitle(value, barGroup, y) {
        let groupX = barGroup._groups[0][0].getBBox().x;
        const groupWidth = barGroup._groups[0][0].getBBox().width;
        const xPos = groupX = groupX + (groupWidth / 2);
        const valueGroup = barGroup
            .append("g")
            .attr("class", "barGroupTitle")
            .attr("transform", `translate(${xPos},0)`);
        valueGroup;
        valueGroup
            .append("text")
            // .attrs({
            // 	y: y - 40,
            // 	"text-anchor": "middle",
            // 	class: "groupTitle",
            // 	fill: this.chartOptions.groupTitleColor
            // })
            .attr("y", y - 40)
            .attr("text-anchor", "middle")
            .attr("class", "groupTitle")
            .attr("fill", this.chartOptions.groupTitleColor)
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .text(() => value.label);
    }
    update(data) {
        super.update(data);
        this.y = this.getScaleY();
        this.numSections = data.length;
        this.draw();
    }
    reDraw() {
        super.reDraw();
        this.y = this.getScaleY();
        this.draw();
    }
    wrap(text, width) {
        text.each(function () {
            const text = d3.select(this), words = text.text().split("~").reverse();
            let word, line = [], lineNumber = 0, lineHeight = 1; // ems
            const x = text.attr("x"), y = text.attr("y"), dy = 1.1;
            let tspan = text
                .text(null)
                .append("tspan")
                .attr("x", x)
                .attr("y", y)
                .attr("dy", `${dy}em`);
            while ((word = words.pop())) {
                line.push(word);
                tspan.text(line.join(" "));
                if (tspan.node().getComputedTextLength() > width) {
                    line.pop();
                    tspan.text(line.join(" "));
                    line = [word];
                    (lineHeight = 1.1), // ems
                        (tspan = text
                            .append("tspan")
                            .attr("x", x)
                            .attr("y", y)
                            .attr("dy", `${(lineNumber += 1 * lineHeight + dy)}em`)
                            .text(word));
                }
            }
        });
    }
}
D3ColumnChartComponent.ɵfac = function D3ColumnChartComponent_Factory(t) { return new (t || D3ColumnChartComponent)(i0.ɵɵdirectiveInject(DataService)); };
D3ColumnChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3ColumnChartComponent, selectors: [["lib-d3-column-chart"]], hostBindings: function D3ColumnChartComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function D3ColumnChartComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 0, consts: [[1, "d3-chart"], ["chart", ""]], template: function D3ColumnChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3ColumnChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-column-chart",
                templateUrl: "./d3-column-chart.component.html",
                styleUrls: ["./d3-column-chart.component.scss"]
            }]
    }], function () { return [{ type: DataService }]; }, { onResize: [{
            type: HostListener,
            args: ["window:resize", ["$event"]]
        }] }); })();

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const _c0$14 = ["chart"];
const moment$g = moment_;
class D3CumulativeChartComponent {
    constructor(dataService, translate) {
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.chartOptions = {};
        this.sourceData = [];
        this.bmData = [];
        this.sData = [];
        this.ticks = [];
        this.dateTickValues = [];
        this.tickValues = [];
        this.midnightValues = [];
        this.xAxisTicks = [];
        this.dateValuesObj = [];
        this.dateValues = [];
        this.dateTicks = [];
        this.uniqueDates = [];
        this.tooltipData = [];
        this.labelKeys = [];
        this.getStaticText = () => {
            this.translate.get('shared-lib.d3-components.cumulative-chart').subscribe((res) => {
                this.labelKeys = res;
            });
        };
        window.addEventListener("resize", this.reDraw.bind(this));
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (this.tooltip) {
            this.tooltip.remove();
        }
        if (!value || value.length == 0)
            return;
        this.sourceData = value;
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    reDraw() {
        // this.chartContainer.nativeElement.remove()
        if (this.tooltip) {
            this.tooltip.remove();
        }
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localized string here
            this.getStaticText();
        });
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg)
            this.svg.remove();
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("transform", `translate(0,${this.chartOptions.margin.top - 20})`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg
            .append("g")
            .attr("transform", `translate(10,20)`);
        this.getxScale();
        this.getyScale();
        this.getLine();
        this.getArea();
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(function () {
            return "<div id='bi-tooltip line-chart'></div>";
        });
        this.svg.call(this.tip);
        const body = d3.select(element.closest("body"));
        const container = d3.select(element);
        this.scr = {
            x: window.scrollX,
            y: window.scrollY,
            w: window.innerWidth,
            h: window.innerHeight
        };
        if (!this.chartOptions.isPosTooltip) {
            this.elementAttr = {
                w: isNull(body.node()) ? 0 : body.node().offsetWidth,
                h: isNull(body.node()) ? 0 : body.node().offsetHeight
            };
            this.svgpos = this.getNodePos(this.svg.node(), body);
        }
        else {
            this.elementAttr = {
                w: isNull(container.node()) ? 0 : container.node().offsetWidth,
                h: isNull(container.node()) ? 0 : container.node().offsetHeight
            };
            this.svgpos = this.getNodePos(this.svg.node(), container);
        }
    }
    getNodePos(el, element) {
        const body = element.node();
        for (var lx = 0, ly = 0; el != null && el != body; lx += (el.offsetLeft || el.clientLeft),
            ly += (el.offsetTop || el.clientTop),
            el = (el.offsetParent || el.parentNode))
            ;
        return { x: lx, y: ly };
    }
    draw() {
        const self = this;
        this.chart
            .append("g")
            .attr("class", "y axis")
            .attr("transform", `translate(${(this.chartOptions.margin.left + 5)}, 0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(`${(this.width + 35)}`))
            .tickFormat((d) => this.readableNumber(d, 2)));
        this.chart
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - (this.chartOptions.margin.left - 15))
            .attr("x", 0 - (this.height / 2))
            .attr("dy", "1em")
            .style("fill", "#000000")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
        this.chart
            .append("g")
            .attr("class", "grid")
            .attr("transform", `translate(${(this.chartOptions.margin.left + 6)}, 0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(`${(this.width + 35)}`))
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .tickFormat(() => this.chartOptions.yAxisTickFormat));
        this.chart
            .append("g")
            .attr("class", "x-axis-label")
            .append("text")
            .text(this.chartOptions.xAxisLabel)
            .attr("transform", `translate(
					${((this.width / 2) + 40)}, 
					${(this.height + 40)})`)
            .attr("text-anchor", "middle");
        const lines = this.chart.append("g").attr("class", "lines");
        lines
            .selectAll(".line-group")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "line-group")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left - 15)} 
					,0)`)
            .append("path")
            .attr("class", "line")
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .attr("d", (d) => this.valueline(d.values))
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .style("stroke", (d) => d.color);
        if (this.chartOptions.chartType == "circle") {
            lines
                .selectAll("circle-group")
                .data(this.sourceData)
                .enter()
                .append("g")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left - 15)} 
						,0)`)
                .attr("fill", (d) => d.color)
                .selectAll("circle")
                .data((d) => d.values)
                .enter()
                .append("g")
                .attr("class", "circle")
                .append("circle")
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                .attr("cx", (d) => this.xScale(d.date))
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                .attr("cy", (d) => this.yScale(d.count))
                .attr("r", 4)
                .on("mouseover", function (d, i) {
                if (i.showDefaultTooltip) {
                    self.showTooltip(i);
                    self.tip.show(d, this);
                }
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
        }
        // Adding location capacity line
        if (this.sourceData[0].locationCapacity > 0) {
            const locationCapacity = this.sourceData[0].locationCapacity;
            lines
                .append("line")
                .attr("class", "capacity-line")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left + 6)} 
						,0)`)
                .attr("x1", -3)
                .attr("y1", this.yScale(locationCapacity))
                .attr("x2", this.width)
                .attr("y2", this.yScale(locationCapacity))
                .style("stroke-width", 2)
                .style("stroke", "#000000")
                .style("stroke-dasharray", 5)
                .style("fill", "none");
            lines
                .append("rect")
                .attr("rx", 20)
                .attr("ry", 20)
                .attr("width", 120)
                .attr("height", 17)
                .attr("x", 45)
                .attr("y", this.yScale(locationCapacity) - 10)
                .style("fill", "#26292b");
            lines
                .append("text")
                //.attr("transform", "translate(" + (this.chartOptions.margin.left + 6) + "," + 0 + ")")
                .attr("x", 100)
                .attr("y", this.yScale(locationCapacity))
                .style("font-size", "11px")
                .style("font-family", "CiscoSansLight")
                .style("font-weight", "bold")
                .attr("text-anchor", "middle")
                .text(this.labelKeys.locationCapacity)
                .style("fill", "#fff");
        }
        // to display max data available line
        const currentDay = this.sourceData.length - 1;
        const currentDate = this.sourceData[currentDay].values[this.sourceData[currentDay].values.length - 1].date;
        // creating midnight value ticks with date & rest of the time with hourly format
        if (self.chartOptions.singleXAxis) {
            this.midnightValues = [];
            this.xAxisTicks = [];
            this.dateValues = [];
            this.dateTicks = [];
            this.dateValuesObj = this.sourceData[currentDay].xAxisValues;
            this.dateValuesObj.forEach((obj) => {
                const date = obj.date;
                const time = moment$g(date).format("h:mm A");
                if (time === "12:00 AM") {
                    this.midnightValues.push(date);
                    this.xAxisTicks.push(moment$g(date).format("DD MMM, h A"));
                }
                else {
                    this.xAxisTicks.push(time);
                }
            });
            const histDateObj = this.sourceData[1].xAxisValues;
            histDateObj.forEach((obj) => {
                const date = obj.date;
                this.dateValues.push(date);
            });
            // get the unique dates from an array
            this.uniqueDates = [];
            for (let i = 0; i < this.dateValues.length; i++) {
                if (!this.isDateInArray(this.dateValues[i], this.uniqueDates)) {
                    this.uniqueDates.push(this.dateValues[i]);
                }
            }
            // to display every three hour ticks
            this.uniqueDates.forEach((d, i) => {
                if (i % 3 === 0) {
                    this.dateTicks.push(d);
                }
            });
        }
        if (this.chartOptions.xAxisFormat === "dateTime") {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left - 15)} 
						, ${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickValues(this.midnightValues)
                // .tickValues(this.dateTicks)
                .tickFormat(d3.timeFormat("%d %b, %I %p")));
        }
        else if (this.chartOptions.xAxisFormat === "time") {
            //  console.log("D3 multiline :: draw :: hour of day ", this.xScale)
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left - 15)} 
						,${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                //.ticks(25)
                .tickFormat(d3.timeFormat("%I:%M %p"))
            //.tickValues(this.tickValues)
            // .tickValues((this.tickValues).filter(function (d, i) {
            //   if (dateArray.length > 0 && dateArray.indexOf(timeFormat(d)) != -1) {
            //     return false;
            //   } else {
            //     dateArray.push(timeFormat(d));
            //     return true;
            //   }
            // }))
            );
        }
        else if (this.chartOptions.xAxisFormat === "hour") {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left - 15)}, 
						${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .ticks(25)
                .tickFormat(d3.timeFormat("%I %p"))
                .tickValues(this.tickValues)
            // .tickValues((this.tickValues).filter(function (d, i) {
            //   if (dateArray.length > 0 && dateArray.indexOf(timeFormat(d)) != -1) {
            //     return false;
            //   } else {
            //     dateArray.push(timeFormat(d));
            //     return true;
            //   }
            // }))
            );
        }
        if (this.chartOptions.drawVerticalLine) {
            lines
                .append("line")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left - 15)} 
						,0)`)
                .attr("x1", this.xScale(currentDate))
                .attr("y1", -8)
                .attr("x2", this.xScale(currentDate))
                .attr("y2", this.height)
                .style("stroke-width", 1)
                .style("stroke", this.chartOptions.lineColor)
                .style("stroke-dasharray", 3)
                .style("fill", "none");
        }
        // Adding gray line for 12 AM for the second day
        if (this.chartOptions.singleXAxis) {
            const midnightDate = this.midnightValues[1];
            lines
                .append("line")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left - 15)} 
						,0)`)
                .attr("x1", this.xScale(midnightDate))
                .attr("y1", -8)
                .attr("x2", this.xScale(midnightDate))
                .attr("y2", this.height)
                .style("stroke-width", 1)
                .style("stroke", "#565659")
                .style("stroke", 3)
                .style("opacity", 0.1)
                .style("fill", "none");
        }
        if (this.chartOptions.chartType == "area") {
            const areaGroup = this.chart
                .append("g")
                .attr("class", "area-group");
            areaGroup
                .selectAll(".area-group")
                .data(this.sourceData)
                .enter()
                .append("g")
                .attr("class", "area-group")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left - 15)} 
						,0)`)
                .append("path")
                .attr("class", "area")
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                .attr("d", (d) => this.area(d.values))
                .style("fill", (d) => d.areaColor)
                .style("opacity", 0.1);
        }
        if (!this.chartOptions.hideMouseOverEffects) {
            self.showMouseOverTooltip();
        }
    }
    showTooltip(i) {
        const self = this;
        let tipContainer = "";
        self.tip.html(function (d) {
            tipContainer += "<div class = 'multiLine-tooltip'>";
            tipContainer += `<div class='multiLine-top'>${i.displayDate}</div>`;
            tipContainer += "<div class='daily-info'>";
            tipContainer += `<span style='vertical-align:middle; display:table; padding:6px; border-radius: 3px; background-color:
			${i.color}'></span><span class='multiLine-left'>
			${i.name}</span><span class = 'multiLine-right'>
			${i.count} 
			</span>`;
            tipContainer += "</div></div>";
            return tipContainer;
        });
    }
    getxScale() {
        const completeData = [];
        let keyValues = [];
        const self = this;
        this.ticks = [];
        this.dateTickValues = [];
        this.tickValues = [];
        if (self.chartOptions.singleXAxis) {
            keyValues = [];
            this.sourceData[1]["xAxisValues"].forEach(function (obj) {
                if (self.chartOptions.xAxisFormat === "date" ||
                    self.chartOptions.xAxisFormat === "dateTime") {
                    const parseTime = d3.timeParse(self.chartOptions.xAxisDateFormat);
                    const formatedDate = parseTime(obj.date);
                    if (formatedDate)
                        obj.date = parseTime(obj.date);
                    keyValues.push(obj.date);
                }
                else {
                    keyValues.push(obj.date);
                }
                //obj.count = +obj.count;
                self.ticks.push(obj.date);
                if (self.tickValues.findIndex((i) => i.toString() == obj.date) == -1) {
                    self.tickValues.push(obj.date);
                }
                completeData.push(obj);
            });
        }
        else {
            // this.sourceData.forEach(function (d) {
            keyValues = [];
            this.sourceData[0]["values"].forEach(function (obj) {
                if (self.chartOptions.xAxisFormat === "date" ||
                    self.chartOptions.xAxisFormat === "dateTime") {
                    const parseTime = d3.timeParse(self.chartOptions.xAxisDateFormat);
                    const formatedDate = parseTime(obj.date);
                    if (formatedDate)
                        obj.date = parseTime(obj.date);
                    keyValues.push(obj.date);
                }
                else {
                    keyValues.push(obj.date);
                }
                //obj.count = +obj.count;
                self.ticks.push(obj.date);
                if (self.tickValues.findIndex((i) => i.toString() == obj.date) == -1) {
                    self.tickValues.push(obj.date);
                }
                completeData.push(obj);
            });
            // });
        }
        this.dateTickValues = keyValues;
        this.xScale = d3
            .scaleTime()
            .range([
            this.chartOptions.margin.left,
            this.width - this.chartOptions.margin.right
        ])
            .domain(d3.extent(keyValues, function (d) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return d;
        }));
    }
    getyScale() {
        if (this.sourceData[0].locationCapacity > 0) {
            const capacityValue = this.sourceData[0].locationCapacity;
            this.yScale = d3
                .scaleLinear()
                .range([this.height, 0])
                .domain([
                0,
                d3.max(this.sourceData, function (d) {
                    return d3.max(d["values"], function (obj) {
                        return parseFloat(obj["count"]) > capacityValue
                            ? parseFloat(obj["count"])
                            : parseFloat(capacityValue);
                    });
                })
            ])
                .nice();
        }
        else {
            this.yScale = d3
                .scaleLinear()
                .range([this.height, 0])
                .domain([
                0,
                d3.max(this.sourceData, function (d) {
                    return d3.max(d["values"], function (obj) {
                        return parseFloat(obj["count"]) > 10
                            ? parseFloat(obj["count"])
                            : 10;
                    });
                })
            ])
                .nice();
        }
    }
    getLine() {
        this.valueline = d3
            .line()
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .x((d) => this.xScale(d["date"]))
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .y((d) => this.yScale(d["count"]));
        //.curve(d3.curveMonotoneX)
    }
    getArea() {
        this.area = d3
            .area()
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .x((d) => this.xScale(d["date"]))
            .y0(this.height)
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .y1((d) => this.yScale(d["count"]));
    }
    readableNumber(value, decimalPoint) {
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return "0";
        }
        decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
        const numCount = value.toPrecision(2).split("e"), // get power
        noOfK = numCount.length === 1
            ? 0
            : Math.floor(Math.min(numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        dividedValue = noOfK < 1
            ? value.toFixed(0 + decimalPoint)
            : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
        finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
        suffix = finalValue + ["", "K", "M", "B", "T"][noOfK]; // append power
        return suffix;
    }
    nonRepeativeTicks() {
        this.ticks.forEach((i) => {
            this.ticks.splice(i + 3, 1);
        });
        return this.ticks;
    }
    isDateInArray(needle, haystack) {
        for (let i = 0; i < haystack.length; i++) {
            if (needle.getTime() === haystack[i].getTime()) {
                return true;
            }
        }
        return false;
    }
    showMouseOverTooltip() {
        const self = this;
        const element = this.chartContainer.nativeElement;
        // CREATE HOVER TOOLTIP WITH VERTICAL LINE //
        this.tooltip = d3
            .select(element)
            .append("div")
            .attr("id", "tooltip")
            .style("position", "absolute")
            .style("background-color", "#263b4c")
            .style("padding", 6)
            .style("display", "none");
        this.mouseG = this.chart
            .append("g")
            .attr("class", "mouse-over-effects");
        /* this.mouseG.append("path") // create vertical line to follow mouse
       .attr("class", "mouse-line")
       .style("stroke", "#A9A9A9")
       .style("stroke-width", lineStroke)
       .style("opacity", "0");*/
        //  var lines = document.getElementsByClassName('line');
        // For not repeating the values in tooltip
        if (self.chartOptions.singleXAxis) {
            const dailyHistValues = [];
            const dailyValues = [];
            this.tooltipData = [];
            this.combinedDailyValues = [];
            this.combinedHistValues = [];
            this.sourceData.forEach((obj) => {
                if (obj.label.toString() === "Historical") {
                    dailyHistValues.push(obj.values);
                    this.histColor = obj.color;
                    this.histTooltip = obj.name;
                }
                else {
                    dailyValues.push(obj.values);
                    this.dailyColor = obj.color;
                    this.rightNowTooltip = obj.name;
                }
            });
            if (dailyHistValues && dailyHistValues.length > 0) {
                this.combinedHistValues = dailyHistValues[0].concat(dailyHistValues[1]);
                this.tooltipData.push({
                    name: this.histTooltip,
                    values: this.combinedHistValues,
                    color: this.histColor
                });
            }
            if (dailyValues && dailyValues.length > 0) {
                this.combinedDailyValues =
                    dailyValues.length == 1
                        ? dailyValues[0]
                        : dailyValues[0].concat(dailyValues[1]);
                this.tooltipData.push({
                    name: this.rightNowTooltip,
                    values: this.combinedDailyValues,
                    color: this.dailyColor
                });
            }
            this.sourceData = this.tooltipData;
        }
        //var data = this.tooltipValues.filter(d => d.name == name);
        // const res_nested = d3
        // 	.nest() // necessary to nest data so that keys represent each vertical category
        // 	.key((d) => d["name"])
        // 	.entries(this.sourceData);
        const mousePerLine = this.mouseG
            .selectAll(".mouse-per-line")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "mouse-per-line");
        mousePerLine
            .append("circle")
            .attr("r", 4)
            .style("stroke", function (d) {
            return d.color;
        })
            .style("fill", "none")
            .style("opacity", "0");
        this.mouseG
            .append("svg:rect") // append a rect to catch mouse movements on canvas
            .attr("width", this.width)
            .attr("height", this.height)
            .attr("transform", `translate(
					${(this.chartOptions.margin.left - 15)} 
					,0)`)
            .attr("fill", "none")
            .attr("pointer-events", "all")
            .on("mouseout", function () {
            // on mouse out hide line, circles and text
            d3.select(element).select(".mouse-line").style("opacity", "0");
            d3.select(element)
                .selectAll(".mouse-per-line circle")
                .style("opacity", "0");
            d3.select(element)
                .selectAll(".mouse-per-line text")
                .style("opacity", "0");
            self.tooltip.style('opacity', 0);
            self.tooltip.style('display', "none");
            setTimeout(() => {
                const displayAtrr = d3
                    .select(element)
                    .select("#tooltip")
                    .style("display");
                if (displayAtrr && displayAtrr === "block")
                    d3.select(element)
                        .select("#tooltip")
                        .style("display", "none");
            }, 100);
        })
            .on("mouseover", function () {
            // on mouse in show line, circles and text
            d3.select(element).select(".mouse-line").style("opacity", "1");
            d3.select(element)
                .selectAll(".mouse-per-line circle")
                .style("opacity", "1");
            d3.select(element).select("#tooltip").style("display", "block");
            self.tooltip
                .transition()
                .duration(300)
                .style("opacity", 1);
        })
            .on("mousemove", function (event) {
            // update tooltip content, line, circles and text when mouse moves
            const mouse = d3.pointer(event, this);
            d3.select(element)
                .selectAll(".mouse-per-line")
                .attr("transform", function (d) {
                const xDate = self.xScale.invert(mouse[0]); // use 'invert' to get date corresponding to distance from mouse position relative to svg
                // eslint-disable-next-line @typescript-eslint/unbound-method
                const bisect = d3.bisector(function (d) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                    return d["date"];
                }).left; // retrieve row index of date on parsed csv
                const idx = bisect(d["values"], xDate);
                d3.select(element)
                    .select(".mouse-line")
                    .attr("d", function () {
                    var data = "M" + self.xScale(d["values"][idx]["date"]) + "," + (self.height);
                    data += ` ${self.xScale(d["values"][idx]["date"])}
								,0`;
                    return data;
                });
                let xTrans;
                let yTrans = 0.0;
                if (d["values"][idx]) {
                    xTrans =
                        parseFloat(self.xScale(d["values"][idx]["date"])) +
                            (self.chartOptions.margin.left - 15);
                    yTrans = self.yScale(d["values"][idx]["count"]);
                }
                else {
                    // d3.select(element).selectAll(".mouse-per-line circle")
                    //   .style("opacity", "0");
                    xTrans = -120;
                }
                return `translate(${xTrans},${yTrans})`;
            });
            if (self.chartOptions.defaultTooltipPos) {
                self.defaultTooltip(event, mouse);
            }
            else {
                self.updateTooltipContent(event, mouse);
            }
        });
    }
    defaultTooltip(event, mouse) {
        const self = this;
        self.tooltip.selectAll("div").remove();
        const pageX = `${(+event.pageX + 20) / 2}px`;
        const pageY = `${(+event.pageY - 20) / 10}px`;
        let index = 0;
        self.tooltip
            .style("display", "block")
            .style("left", pageX)
            .style("top", pageY)
            .style("font-size", 11.5)
            .style("z-index", "1000")
            // .style('min-width', '220px')
            .selectAll()
            .data(self.sourceData)
            .enter() // for each vehicle category, list out name and price of premium
            .append("div")
            .style("color", () => {
            // return d.color
            return "#fff";
        })
            .style("font-size", 10)
            .html((d) => {
            const xDate = self.xScale.invert(mouse[0]);
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const bisect = d3.bisector(function (d) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return d["date"];
            }).left;
            const idx = bisect(d.values, xDate);
            if (d.values[idx]) {
                // console.log("line chart :: tool tip :: if value  " + idx + " ", d.values[idx])
                self.tooltip.style("min-width", "220px");
                self.tooltip.style("display", "block");
                self.tooltip.style("padding", "10px 15px");
                index += 1;
                return "<div class = 'multiLine-tooltip'>" + ((index == 1) ? "<div class='multiLine-top'>" + d.values[idx].displayDate + "</div>" : "")
                    + "<div class='daily-info'>" + "<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:" + d.values[idx].color + "'></span><span class='multiLine-left'>" + d.values[idx].name + "</span><span class = 'multiLine-right'>" + d.values[idx].count + "</span>"
                    + "</div></div>";
                // return `<div class = 'multiLine-tooltip'>
                // 	<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:
                // 	${d.values[idx].color}
                // 	'></span><span class='multiLine-left'>
                // 	${d.values[idx].name}</span><span class = 'multiLine-right'>
                // 	${d.values[idx].count} 
                // 	</span></div></div>`;
            }
            else {
                self.tooltip.style("min-width", "0");
                self.tooltip.style("padding", "0");
            }
        });
    }
    updateTooltipContent(event, mouse) {
        const self = this;
        const dist = { x: 10, y: 10 };
        const m = d3.pointer(event, self.svg.node());
        self.scr.x = window.scrollX;
        self.scr.y = window.scrollY;
        m[0] += self.svgpos.x;
        m[1] += self.svgpos.y;
        self.tooltip.selectAll("div").remove();
        let index = 0;
        self.tooltip.style("right", "");
        self.tooltip.style("left", "");
        self.tooltip.style("bottom", "");
        self.tooltip.style("top", "");
        if (m[0] > self.scr.x + self.scr.w / 2) {
            self.tooltip.style("right", (self.elementAttr.w - m[0] + dist.x) + "px");
        }
        else {
            self.tooltip.style("left", (m[0] + dist.x) + "px");
        }
        self.tooltip.style("top", "0px");
        self.tooltip
            .style("display", "block")
            .style("font-size", 11.5)
            .style("z-index", "1000")
            .style("padding", "10px 15px")
            .style("min-width", "220px")
            .selectAll()
            .data(self.sourceData)
            .enter() // for each vehicle category, list out name and price of premium
            .append("div")
            .style("color", () => {
            return "#fff";
        })
            .style("font-size", 10)
            .html((d) => {
            const xDate = self.xScale.invert(mouse[0]);
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const bisect = d3.bisector(function (d) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return d["date"];
            }).left;
            const idx = bisect(d.values, xDate);
            if (d.values[idx]) {
                console.log(d.values[idx], "::::; idx values");
                self.tooltip.style("display", "block");
                index += 1;
                const values = index == 1
                    ? `<div class='multiLine-top'> ${d.values[idx].displayDate} </div>`
                    : ``;
                return `<div class = 'multiLine-tooltip'>${values}
						<div class='daily-info'> 
						<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:
						${d.values[idx].color}
						'></span><span class='multiLine-left'> 
						${d.values[idx].name}
						</span><span class = 'multiLine-right'> 
						${d.values[idx].count}
						</span> 
						</div></div>`;
                //	);
            }
            else {
                self.tooltip.style("min-width", "0");
                self.tooltip.style("padding", "0");
                self.tooltip.style("display", "none");
            }
            return "";
        });
    }
}
D3CumulativeChartComponent.ɵfac = function D3CumulativeChartComponent_Factory(t) { return new (t || D3CumulativeChartComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
D3CumulativeChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3CumulativeChartComponent, selectors: [["lib-d3-cumulative-chart"]], viewQuery: function D3CumulativeChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$14, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart"], ["chart", ""]], template: function D3CumulativeChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3CumulativeChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-cumulative-chart",
                templateUrl: "./d3-cumulative-chart.component.html",
                styleUrls: ["./d3-cumulative-chart.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const _c0$13 = ["chart"];
class D3CustomColumnChartComponent {
    constructor() {
        this.sourceData = [];
        this.chartOptions = {};
        this.barPadding = 0.3;
    }
    set options(value) {
        if (!value) {
            return;
        }
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (!value || value.length === 0) {
            return;
        }
        this.sourceData = value;
        this.dataLength = this.sourceData.length;
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => e["style"].opacity = 0);
        });
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg) {
            this.svg.remove();
        }
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("transform", `translate(0,${this.chartOptions.margin.top - 20})`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg
            .append("g")
            .attr("transform", 'translate(' + 25 + ',' + 20 + ')');
        this.getxScale();
        this.getyScale();
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(() => {
            return '<div id="bi-tooltip line-chart"></div>';
        });
        this.svg.call(this.tip);
    }
    getxScale() {
        const keyValues = [];
        let paddingInner = 0.5;
        this.sourceData.forEach((d) => {
            d.values.forEach((obj) => {
                keyValues.push(obj.label);
            });
        });
        if (this.chartOptions.handleBarWidth) {
            if (this.dataLength === 1) {
                paddingInner = 0.9;
            }
            else if (this.dataLength < 1 && this.dataLength < 4) {
                paddingInner = 0.7;
            }
            if (this.dataLength < 8) {
                this.xScale = d3
                    .scaleBand()
                    .range([0, this.width])
                    .padding(this.barPadding)
                    .paddingInner(paddingInner)
                    .domain(keyValues.map((d) => {
                    return d;
                }));
            }
            else {
                this.xScale = d3
                    .scaleBand()
                    .range([0, this.width])
                    .padding(this.barPadding)
                    .domain(keyValues.map((d) => {
                    return d;
                }));
            }
        }
        else {
            this.xScale = d3
                .scaleBand()
                .range([0, this.width])
                .padding(0.1)
                .domain(keyValues.map((d) => {
                return d;
            }));
        }
    }
    getyScale() {
        this.yScale = d3
            .scaleLinear()
            .range([this.height, 0])
            .domain([
            0,
            d3.max(this.sourceData, (d) => {
                return d3.max(d.values, (obj) => {
                    return parseFloat(obj.count.high);
                });
            })
        ])
            .nice();
    }
    draw() {
        const self = this;
        // x-axis
        this.chart
            .append("g")
            .attr("class", "x axis")
            .attr("width", "100%")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left - 15)} 
					, ${this.height})`)
            .call(d3.axisBottom(this.xScale).scale(this.xScale));
        // y axis
        this.chart
            .append("g")
            .attr("class", "y axis")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left - 15)} 
					,0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-`${(this.width + 35)}`)
            .tickFormat((d) => this.readableNumber(d, 2)));
        // grid
        this.chart
            .append("g")
            .attr("class", "grid")
            .attr("transform", `translate(
					${this.chartOptions.margin.left} 
					,0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-this.width)
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .tickFormat(() => this.chartOptions.yAxisTickFormat));
        // yAxis Label
        this.chart
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", `translate(
					${this.chartOptions.margin.left} 
					,0)`)
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - this.chartOptions.margin.left)
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .style("fill", "#000000")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
        // xAxis Label
        this.chart
            .append("text")
            .attr("class", "xAxis-label")
            .text(this.chartOptions.xAxisLabel)
            .style("fill", "#1D3243")
            .style("text-anchor", "middle")
            .attr("transform", `translate(
					${(this.width / 2)},
					${(this.height + 30)})`);
        // Add bars
        const sectionGroup = this.chart
            .append("g")
            .attr("class", "section")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left - 15)} 
					,0)`);
        this.sourceData.forEach((section) => {
            const bars = section.values;
            const barGroup = sectionGroup.append("g");
            bars.forEach((value) => {
                barGroup
                    .append("rect")
                    .attr("class", "bar")
                    .attr("x", self.xScale(value.label))
                    .attr("width", self.xScale.bandwidth())
                    .attr("y", self.yScale(value.count.high))
                    .attr("height", self.yScale(value.count.low) -
                    self.yScale(value.count.high))
                    .style("fill", value.color)
                    .on("mouseover", function (d) {
                    self.showTooltip(value);
                    self.tip.show(d, this);
                })
                    .on("mouseout", function () {
                    self.tip.hide();
                });
            });
        });
    }
    readableNumber(value, decimalPoint) {
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return "0";
        }
        decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
        const numCount = value.toPrecision(2).split("e"); // get power
        // floor at decimals, ceiling at trillions
        const noOfK = numCount.length === 1
            ? 0
            : Math.floor(Math.min(numCount[1].slice(1), 14) / 3);
        // divide by power
        const dividedValue = noOfK < 1
            ? value.toFixed(0 + decimalPoint)
            : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint);
        const finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue); // enforce -0 is 0
        const suffix = finalValue + ["", "K", "M", "B", "T"][noOfK]; // append power
        return suffix;
    }
    showTooltip(value) {
        const self = this;
        let tipContainer = "";
        self.tip.html(() => {
            tipContainer += '<div class = "columnChart-tooltip">';
            if (value.displayDate) {
                tipContainer += `<div class="columnChart-top">
					${value.displayDate}</div>`;
            }
            else {
                tipContainer += `<div class="columnChart-top"> ${value.label}</div>`;
            }
            if (value.tooltipLabelHigh || value.tooltipLabelLow) {
                if (value.tooltipHourLabel) {
                    tipContainer += '<div class="daily-info">';
                    tipContainer += `<span class="columnChart-left">
						${value.tooltipLabelHigh} 
						 : 
						 ${value.tooltipHourLabel.highHour} 
						 </span><span class = "columnChart-right">
						 ${value.count.high}
						</span>`;
                    tipContainer += "</div></div>";
                    // tipContainer += '<div class="daily-info">'
                    // tipContainer += '<span class="columnChart-left">' + value.tooltipLabelLow + ' : ' + value.tooltipHourLabel.lowHour +
                    // '</span><span class = "columnChart-right">' + value.count.low + '</span>'
                    // tipContainer += '</div>';
                }
                else {
                    tipContainer += '<div class="daily-info">';
                    tipContainer += `<span class="columnChart-left">
						${value.tooltipLabelHigh}
						'</span><span class = "columnChart-right">
						${value.count.high}  
						</span>`;
                    tipContainer += "</div></div>";
                    // tipContainer += '<div class="daily-info">'
                    // tipContainer += '<span class="columnChart-left">' + value.tooltipLabelLow + '</span><span class = "columnChart-right">' +
                    // value.count.low + '</span>'
                    // tipContainer += '</div></div>';
                }
            }
            return tipContainer;
        });
    }
}
D3CustomColumnChartComponent.ɵfac = function D3CustomColumnChartComponent_Factory(t) { return new (t || D3CustomColumnChartComponent)(); };
D3CustomColumnChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3CustomColumnChartComponent, selectors: [["lib-d3-custom-column-chart"]], viewQuery: function D3CustomColumnChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$13, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart"], ["chart", ""]], template: function D3CustomColumnChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3CustomColumnChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-custom-column-chart",
                templateUrl: "./d3-custom-column-chart.component.html",
                styleUrls: ["./d3-custom-column-chart.component.scss"]
            }]
    }], null, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

class D3StackedBarChartOptions$1 {
    constructor() {
        this.margin = { top: 20, right: 30, bottom: 20, left: 30 };
        this.rangeColors = ["#1777c3", "#ff5df3", "#1f776f"];
        this.toolTipIcons = {
            SMS: "#1777c3",
            Email: "#ff5df3",
            "Push Notification": "#1f776f"
        };
        this.isXAxisTime = false;
        this.showLegend = false;
        this.tooltip = {
            isEnable: true,
            className: "",
            suffix: ""
        };
    }
}

/* eslint-disable @typescript-eslint/no-unsafe-return */
const _c0$12 = ["stacked_chart"];
class D3CustomStackedBarChartComponent {
    constructor() {
        this.keys = [];
    }
    set options(value) {
        this.chartOptions = value || new D3StackedBarChartOptions$1();
    }
    set data(value) {
        if (isEmpty(value))
            return;
        this.sourceData = value;
    }
    ngOnInit() {
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
        ;
    }
    /**
     * A callback method
     * @param changes
     */
    ngOnChanges(changes) {
        const { currentValue } = changes.data;
        if (!currentValue)
            return;
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0 && this.sourceData && Object.keys(this.sourceData).length > 0) {
            this.initSvg();
            this.drawChart();
        }
    }
    /**
     * Initialization of the svg
     */
    initSvg() {
        this.element = this.chartContainer.nativeElement;
        if (!this.chartOptions)
            this.chartOptions = new D3StackedBarChartOptions$1();
        /*this.sourceData = {
      keys: ["sms", "push", "email"],
      values: [{
        "name": "2019-10-02",
        "sms": 2,
        "push": 2,
        "email": "0",
        "count": 4
      },
      {
        "name": "2019-10-03",
        "sms": 1,
        "push": 1,
        "email": 0,
        "count": 2
      },
      {
        "name": "2019-10-04",
        "sms": 1,
        "push": 0,
        "email": 0,
        "count": 1
      }]
    }*/
        if (this.chartOptions.isXAxisTime) {
            this.parseDate = d3.timeParse("%Y-%m-%dT%H:%M:%S");
        }
        else {
            this.parseDate = d3.timeParse("%Y-%m-%d");
        }
        const { margin, rangeColors, paddingInner } = this.chartOptions;
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(function () {
            return "<div id='bi-tooltip line-chart'></div>";
        });
        if (this.svg) {
            this.svg.remove();
        }
        const svg = d3.select(this.element).append("svg");
        this.svg = svg.attr("width", "100%").attr("height", "100%");
        this.width = this.element.clientWidth - margin.left - margin.right;
        this.height = this.element.clientHeight - margin.top - margin.bottom;
        this.g = this.svg.append("g");
        this.g.attr("transform", `translate(${margin.left},${margin.top})`);
        this.svg.call(this.tip);
        // set x scale
        if (paddingInner)
            this.x = d3
                .scaleBand()
                .range([0, this.width])
                .padding(paddingInner);
        else if (this.chartOptions.barWidth)
            this.x = d3
                .scaleBand()
                .range([0, this.width])
                .padding(this.chartOptions.barWidth % 7);
        else
            this.x = d3
                .scaleBand()
                .range([0, this.width])
                .padding(0.5);
        // set y scale
        this.y = d3.scaleLinear().rangeRound([this.height, 0]);
        this.barColors = d3.scaleOrdinal().range(rangeColors);
        //var series = d3.keys(this.sourceData.keys);
        //  this.parseDate = d3.timeParse("%Y-%m-%d"),
        this.keys = this.sourceData.keys;
        // this.sourceData["values"].sort((a, b) => b.date - a.date);
        this.x.domain(this.sourceData["values"].map(({ date }) => this.parseDate(date)));
        this.y
            .domain([
            0,
            d3.max(this.sourceData["values"], function (d) {
                return d["count"];
            })
        ])
            .nice();
        this.barColors.domain(this.keys);
        //   var keys = this.date.columns.slice(1);
    }
    drawChart() {
        const self = this;
        const dateArray = [];
        this.dataLength = this.sourceData["values"].length;
        this.g
            .append("g")
            .attr("class", "grid")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left - 15)} 
					,0)`)
            .call(d3.axisLeft(this.y).scale(this.y).tickSize(-this.width));
        if (this.chartOptions.barWidth) {
            this.g
                .append("g")
                .selectAll("g")
                .data(d3.stack().keys(this.keys)(this.sourceData["values"]))
                .enter()
                .append("g")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left - 5)} 
						,0)`)
                .attr("fill", (d) => this.barColors(d.key))
                .selectAll("rect")
                .data((d) => d)
                .enter()
                .append("rect")
                .attr("x", (d) => this.x(this.parseDate(d.data.date)))
                .attr("y", (d) => this.y(d[1]))
                .attr("height", (d) => this.y(d[0]) - this.y(d[1]) - 1)
                .attr("width", this.chartOptions.barWidth)
                .on("mouseover", function (d, i) {
                self.showStackedToolTip(d, i, self.keys, self.sourceData["values"], self.chartOptions.toolTipIcons);
                self.tip.show(d, this);
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
        }
        else {
            this.g
                .append("g")
                .selectAll("g")
                .data(d3.stack().keys(this.keys)(this.sourceData["values"]))
                .enter()
                .append("g")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left - 5)} 
						,0)`)
                .attr("fill", (d) => this.barColors(d.key))
                .selectAll("rect")
                .data((d) => d)
                .enter()
                .append("rect")
                .attr("x", (d) => this.x(this.parseDate(d.data.date)))
                .attr("y", (d) => this.y(d[1]))
                .attr("height", (d) => this.y(d[0]) - this.y(d[1]))
                .attr("width", this.x.bandwidth())
                .on("mouseover", function (d, i) {
                self.showStackedToolTip(d, i, self.keys, self.sourceData["values"], self.chartOptions.toolTipIcons);
                self.tip.show(d, this);
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
        }
        // if (this.dataLength > 25) {
        // 	const sortedTicks = this.preparexAxisTicks();
        // 	this.xAxis = d3
        // 		.axisBottom(this.x)
        // 		// .tickFormat(d3.timeFormat("%d %b"))
        // 		.scale(this.x)
        // 		.tickValues(sortedTicks)
        // 		.tickFormat(d3.timeFormat("%d %b"));
        // } else {
        this.xAxis = d3
            .axisBottom(this.x)
            .tickFormat(d3.timeFormat("%d %b"))
            .scale(this.x);
        this.g
            .append("g")
            .attr("class", "x-axis")
            .attr("transform", `translate(30, ${this.height})`)
            .attr("text-anchor", "middle")
            .attr("y", 5)
            .call(this.xAxis);
        this.g
            .append("g")
            .attr("class", "y-axis")
            .attr("transform", `translate(
					${this.chartOptions.margin.left - 15} 
					,0)`)
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - this.chartOptions.margin.left - 10)
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .style("fill", "#1D3243")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
        if (this.chartOptions.showLegend) {
            const legend = this.g
                .append("g")
                .attr("font-family", "ciscoSans")
                .attr("font-size", 11)
                .attr("text-anchor", "end")
                .selectAll("g")
                .data(this.keys.slice().reverse())
                .enter()
                .append("g")
                .attr("transform", function (d, i) {
                return `translate(0,${(i * 20)})`;
            });
            legend
                .append("rect")
                .attr("x", this.width - 19)
                .attr("width", 19)
                .attr("height", 19)
                .attr("fill", this.barColors);
            legend
                .append("text")
                .attr("x", this.width - 24)
                .attr("y", 9.5)
                .attr("dy", "0.32em")
                .text(function (d) {
                return d;
            });
        }
    }
    preparexAxisTicks() {
        // const ticks = this.sourceData.map(function (d) {
        // 	return d.date;
        // });
        const self = this;
        const tickValues = this.sourceData["values"];
        const ticks = tickValues.map(function (d) {
            return d.date;
        });
        // Object.keys(this.sourceData).map(function(key, index) {
        // 	if(key === "values"){
        // 		const name = self.sourceData[key].name
        // 		ticks.push(name) 
        // 	}			
        // });
        for (let i = 0; i < ticks.length; i++) {
            ticks.splice(i + 1, 5);
        }
        return ticks;
    }
    showStackedToolTip(d, i, keys, values, icons) {
        const self = this;
        const suffix = i.data.suffix ? i.data.suffix : "";
        let tipContainer = "";
        self.tip.html(() => {
            tipContainer += "<div class = 'multiLine-tooltip'>";
            tipContainer += `<div class='multiLine-top'>
				${i.data.displayDate}
				</div>`;
            keys.forEach((key) => {
                tipContainer += "<div class='daily-info'>";
                tipContainer += `<span style='display: table;padding: 6px;border-radius: 3px;background-color:
				${icons[key]}'></span><span class='multiLine-left'>
				${key}</span><span class = 'multiLine-right'>
				${i.data[key]}
				</span><span class='suffix'>${suffix}</span>`;
                tipContainer += "</div>";
            });
            tipContainer += "</div>";
            return tipContainer;
        });
    }
}
D3CustomStackedBarChartComponent.ɵfac = function D3CustomStackedBarChartComponent_Factory(t) { return new (t || D3CustomStackedBarChartComponent)(); };
D3CustomStackedBarChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3CustomStackedBarChartComponent, selectors: [["lib-d3-custom-stacked-bar-chart"]], viewQuery: function D3CustomStackedBarChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$12, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [[1, "d3-chart"], ["stacked_chart", ""]], template: function D3CustomStackedBarChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [".axis[_ngcontent-%COMP%]   .domain[_ngcontent-%COMP%]{display:none}.axis-x[_ngcontent-%COMP%], .axis-y[_ngcontent-%COMP%]{color:#333;font-family:ciscoSans;font-size:11px}.d3-stacked-chart[_ngcontent-%COMP%]{height:100%;font-family:ciscoSans}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3CustomStackedBarChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-custom-stacked-bar-chart",
                templateUrl: "./d3-custom-stacked-bar-chart.component.html",
                styleUrls: ["./d3-custom-stacked-bar-chart.component.scss"]
            }]
    }], function () { return []; }, { chartContainer: [{
            type: ViewChild,
            args: ["stacked_chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

class D3DonutChartOptions {
    constructor() {
        this.margin = 0;
        this.donutWidth = 15;
        this.rangeColors = [
            "#5783D6",
            "#BB6DD9",
            "#C2AE59",
            "#5B6470",
            "#585123",
            "#772F1A",
            "#F34213",
            "#2E2E3A",
            "#FFD275",
            "#E3A587",
            "#0D3B66",
            "#BAD4AA",
            "#D5573B"
        ];
        this.bgColor = "#eaeaea";
        this.text = false;
        this.textSize = 18;
        this.textYPos = 5;
        this.isCustomerTooltip = false;
        this.tooltip = {
            isEnable: true,
            className: "",
            suffix: ""
        };
    }
}

/* eslint-disable @typescript-eslint/no-unsafe-return */
const _c0$11 = ["donut_chart"];
class D3DonutChartComponent {
    constructor() { }
    set options(value) {
        this.chartOptions = value || new D3DonutChartOptions();
    }
    set data(value) {
        if (isEmpty(value))
            return;
        this.sourceData = value;
    }
    /**
     * A callback method
     * @param changes
     */
    ngOnChanges(changes) {
        if (changes && changes.data != undefined) {
            const { currentValue } = changes.data;
            if (!currentValue)
                return;
            this.initSvg();
            this.drawChart();
        }
    }
    /*constructor() {
        window.addEventListener("resize", this.reDraw.bind(this));
    }

    reDraw(): void {
        // this.chartContainer.nativeElement.remove()
        if (this.tooltip) {
            this.tooltip.remove();
        }
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }*/
    /**
     * Initialization of the svg
     */
    initSvg() {
        this.element = this.chartContainer.nativeElement;
        if (!this.chartOptions) {
            this.chartOptions = new D3DonutChartOptions();
        }
        const { clientWidth, clientHeight } = this.element;
        const { tooltip, margin, donutWidth, rangeColors } = this.chartOptions;
        if (this.svg) {
            this.svg.remove();
        }
        const svg = d3.select(this.element).append("svg");
        this.svg = svg.attr("width", clientWidth).attr("height", clientHeight);
        this.width = this.svg.attr("width");
        this.height = this.svg.attr("height");
        this.radius = Math.min(this.width, this.height) / 2;
        this.color = d3.scaleOrdinal().range(rangeColors);
        this.arc = d3
            .arc()
            .outerRadius(this.radius - margin)
            .innerRadius(this.radius - margin - donutWidth);
        this.pie = d3
            .pie()
            .sort(null)
            .value((d) => d.value);
        this.svg.append("g").attr("transform", `translate(
					${(this.width / 2)}, 
					${(this.height / 2)})`);
        if (tooltip.isEnable) {
            this.tip = d3
                .select("body")
                .append("div")
                .attr("class", `d3-donut-tooltip ${this.chartOptions.tooltip.className}`)
                .style("opacity", 0);
        }
        if (this.chartOptions.isCustomerTooltip) {
            this.customToolTip = d3Tip()
                .attr("class", "bi-tooltip")
                .offset([-10, 0])
                .html(function (d) {
                return "<div id='bi-tooltip line-chart'></div>";
            });
            this.svg.call(this.customToolTip);
        }
        if (this.chartOptions.isOpenRoamingTooltip) {
            this.tooltip = d3
                .select("body")
                .append("div")
                .style("position", "absolute")
                .style("z-index", "10")
                .style("visibility", "hidden")
                .style("background", "#fff")
                .style("color", "#58585B")
                .style("padding", "5px")
                .style("font-size", "14px")
                .style("box-shadow", " 0 3px 6px rgba(0, 0, 0, 0.1)");
        }
        if (this.chartOptions.widgetType === 'environmentalMetrics') {
            this.tooltip = d3
                .select("body")
                .append("div")
                .style("position", "absolute")
                .style("z-index", "10")
                .style("visibility", "hidden")
                .style("background", "#fff")
                .style("color", "#58585B")
                .style("padding", "10px")
                .style("font-size", "13px")
                .style("border-radius", "8px")
                .style("box-shadow", " 0 3px 6px rgba(0, 0, 0, 0.1)");
        }
    }
    /**
     * Draw Donut Chart in the svg
     */
    drawChart() {
        const self = this;
        this.g = this.svg.select("g").selectAll(".arc");
        const g = this.g.data(this.pie(this.sourceData)).enter().append("g");
        g.append("g")
            .data(this.pie([{ value: 1 }]))
            .enter()
            .append("g")
            .attr("class", "d3-donut-arc-wrapper")
            .append("path")
            .attr("d", this.arc)
            .style("fill", this.chartOptions.bgColor);
        if (this.chartOptions.text) {
            if (this.chartOptions.textYPos) {
                g.append("text")
                    .attr("text-anchor", "middle")
                    .attr("font-size", this.chartOptions.textSize)
                    .attr("y", this.chartOptions.textYPos)
                    .text((d) => d.data.text);
            }
            else {
                g.append("text")
                    .attr("text-anchor", "middle")
                    .attr("font-size", this.chartOptions.textSize)
                    .attr("y", this.radius / 12)
                    .text((d) => d.data.text);
            }
        }
        if (this.chartOptions.widgetType === 'environmentalMetrics') {
            g.append("text")
                .attr("class", "count-text")
                .text((d) => d.data.displayValue)
                .attr("text-anchor", "middle")
                .style("font-size", "13px")
                .style("color", "#000")
                .style("font-family", 'CiscoSansRegular')
                .style("fill", "#58585B")
                .attr("dy", "-0.1em");
            g.append("text")
                .attr("class", "name-text")
                .text((d) => d.data.text)
                .attr("text-anchor", "middle")
                .style("word-break", "break-all")
                .style("font-size", "12px")
                .style("fill", "#58585B")
                .attr("dy", "1.4em");
        }
        if (this.chartOptions.isCustomerTooltip) {
            g.attr("class", "d3-donut-arc")
                .append("path")
                .attr("d", this.arc)
                .style("fill", (d) => this.color(d.data.label))
                .on("mouseover", function (d, i) {
                self.showCustomToolTip(i);
                self.customToolTip.show(d, this);
            })
                .on("mouseout", function (d) {
                self.customToolTip.hide();
            })
                .transition()
                .ease(d3.easeCircleInOut)
                .duration(2000)
                .attrTween("d", this.tweenPie.bind(this));
        }
        else if (this.chartOptions.isOpenRoamingTooltip) {
            g.attr("class", "d3-donut-arc")
                .append("path")
                .attr("d", this.arc)
                .style("fill", (d) => this.color(d.data.label));
            g.on("mouseover", this.onMouseOverOR.bind(this));
            g.on("mousemove", function (event) {
                return self.tooltip
                    .style("top", `${event.pageY - 10}px`)
                    .style("left", `${event.pageX + 10}px`);
            });
            g.on("mouseout", this.onMouseOutOR.bind(this));
        }
        else {
            g.attr("class", "d3-donut-arc")
                .append("path")
                .attr("d", this.arc)
                .style("fill", (d) => this.color(d.data.label))
                .on("mouseover", this.onMouseOver.bind(this))
                .on("mousemove", this.onMouseMove.bind(this))
                .on("mouseout", this.onMouseOut.bind(this))
                .transition()
                .ease(d3.easeCircleInOut)
                .duration(2000)
                .attrTween("d", this.tweenPie.bind(this));
        }
        /*this.g.append('text')
      .attr('transform', d => 'translate(' + this.arc.centroid(d) + ')')
      .attr('dy', '.35em')
      .text(d => d.data.label);*/
    }
    // Open roaming mouse over tooltip
    // eslint-disable-next-line no-unused-vars
    onMouseOverOR(event, d, i) {
        const { currentTarget } = event; // d3.event;
        const { suffix } = this.chartOptions.tooltip;
        const g = d3
            .select(currentTarget)
            .append("g")
            .attr("class", "text-group");
        g.append("text")
            .attr("class", "count-text")
            .text(`${d.data.value}`)
            .attr("text-anchor", "middle")
            .style("font-size", "34px")
            .style("fill", "#58585B")
            .attr("dy", "-0.1em");
        g.append("text")
            .attr("class", "name-text")
            .text(`${d.data.displayText}` + ' ' + suffix)
            .attr("text-anchor", "middle")
            .style("word-break", "break-all")
            .style("font-size", "12px")
            .style("fill", "#58585B")
            .attr("dy", "1.4em");
        this.tooltip.text(`${d.data.label} : ${d.data.percentage}`);
        this.tooltip.style("visibility", "visible");
    }
    // Open roaming mouse out tooltip
    // eslint-disable-next-line no-unused-vars
    onMouseOutOR(event, d, i) {
        d3.select(event.currentTarget)
            .select(".text-group")
            .style("cursor", "none")
            .remove();
        this.tooltip.style("visibility", "hidden");
    }
    //mouseover callback
    // eslint-disable-next-line no-unused-vars
    onMouseOver(event, d, i) {
        const { currentTarget } = event;
        let { suffix } = this.chartOptions.tooltip;
        if (this.chartOptions.widgetType === 'environmentalMetrics') {
            suffix = d.data.value > 1 ? 'Floors' : 'Floor';
        }
        if (this.tip && this.chartOptions.widgetType !== 'environmentalMetrics') {
            d3.select(currentTarget)
                .transition()
                .duration(50)
                .attr("opacity", "0.80");
            this.tip.transition().duration(50).style("opacity", 1);
        }
        else {
            this.tooltip
                .html("<div class= 'env-tooltip'> <span style='height:10px; width:10px;border-radius:50%; display:inline-block; padding-right:7px; background-color:" +
                d.data.rangeColor + "'></span><span style='font-family:CiscoSansRegular;padding-left:5px'>" + d.data.label + "</span><span style='font-family:CiscoSans;padding-left:10px;color:#000'>" + d.data.value + " " + suffix + "<span></div>");
            this.tooltip.style("visibility", "visible");
        }
    }
    // mousemove callback
    onMouseMove(event, d, i) {
        if (this.tip) {
            const { pageX, pageY } = event;
            const { suffix } = this.chartOptions.tooltip;
            const value = isNaN(+d.value)
                ? d.value
                : (+d.value).toLocaleString();
            if (this.chartOptions.widgetType === 'environmentalMetrics') {
                this.tooltip
                    .style("top", `${event.pageY - 10}px`)
                    .style("left", `${event.pageX + 10}px`);
            }
            else {
                this.tip
                    .html(`${value}<span class='tooltip__suffix'>${d.suffix || suffix}</span>`)
                    .style("left", `${pageX + 10}px`)
                    .style("top", `${pageY - 15}px`);
            }
        }
    }
    //mouseout callback
    onMouseOut(event, d, i) {
        d3.select(event.currentTarget)
            .transition()
            .duration(50)
            .attr("opacity", 1);
        if (this.tip && this.chartOptions.widgetType !== 'environmentalMetrics') {
            this.tip.transition().duration(50).style("opacity", 0);
        }
        else {
            d3.select(event.currentTarget)
                .select(".text-group")
                .style("cursor", "none")
                .remove();
            this.tooltip.style("visibility", "hidden");
        }
    }
    showCustomToolTip(obj) {
        const self = this;
        let tipContainer = "";
        self.customToolTip.html((d) => {
            tipContainer += "<div class = 'multiLine-tooltip'>";
            obj.data.tipList.forEach((value) => {
                tipContainer += "<div class='daily-info'>";
                tipContainer += `</span><span class='multiLine-left'>
					${value["name"]}
					</span><span class = 'multiLine-right'>
					${value["percentage"]} 
					</span>`;
                tipContainer += "</div>";
            });
            tipContainer += "</div>";
            return tipContainer;
        });
    }
    /**
     * tween interpolator factory for d3 transition.attrTween
     * @param b
     */
    tweenPie(b) {
        const i = d3.interpolate({ startAngle: 0, endAngle: 0 }, b);
        return (t) => {
            return this.arc(i(t));
        };
    }
}
D3DonutChartComponent.ɵfac = function D3DonutChartComponent_Factory(t) { return new (t || D3DonutChartComponent)(); };
D3DonutChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3DonutChartComponent, selectors: [["lib-d3-donut-chart"]], viewQuery: function D3DonutChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$11, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [[1, "d3-donut-chart"], ["donut_chart", ""]], template: function D3DonutChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [".d3-donut-chart[_ngcontent-%COMP%]{height:100%}.d3-arc[_ngcontent-%COMP%]   text[_ngcontent-%COMP%]{text-anchor:middle}.d3-arc[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:#fff;stroke-width:3px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3DonutChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-donut-chart",
                templateUrl: "./d3-donut-chart.component.html",
                styleUrls: ["./d3-donut-chart.component.scss"]
            }]
    }], function () { return []; }, { chartContainer: [{
            type: ViewChild,
            args: ["donut_chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

/* eslint-disable @typescript-eslint/no-unsafe-return */
const _c0$10 = ["donut_chart"];
class D3DoubleDonutChartComponent {
    constructor() { }
    set options(value) {
        this.chartOptions = value || new D3DonutChartOptions();
    }
    set data(value) {
        if (!value || value.length === 0) {
            return;
        }
        this.sourceData = value;
    }
    ngOnChanges(changes) {
        const { currentValue } = changes.data;
        if (!currentValue) {
            return;
        }
        this.createSvg();
        this.draw();
    }
    createSvg() {
        this.element = this.chartContainer.nativeElement;
        if (!this.chartOptions) {
            this.chartOptions = new D3DonutChartOptions();
        }
        const { clientWidth, clientHeight } = this.element;
        const { rangeColors } = this.chartOptions;
        const { suffix } = this.chartOptions.tooltip;
        if (this.svg) {
            this.svg.remove();
        }
        const svg = d3.select(this.element).append("svg");
        this.svg = svg.attr("width", clientWidth).attr("height", clientHeight);
        this.width = this.svg.attr("width");
        this.height = this.svg.attr("height");
        this.radius = Math.min(this.width, this.height) / 3;
        this.svg.append("g").attr("transform", `translate(
					${(this.width / 2)}, 
					${(this.height / 2)})`);
        this.colorRange = rangeColors;
        this.suffix = suffix;
        this.partition = d3.partition().size([2 * Math.PI, this.radius]);
        // this.root = d3.hierarchy(this.sourceData, d =>  d.children )
        //   .sum(d => {
        //     if (d.children) {
        //       return 0
        //     } else {
        //       return 1
        //     }
        //   })
        this.root = d3
            .hierarchy(this.sourceData)
            .sum((d) => d.count);
        this.partition(this.root);
        this.arc = d3
            .arc()
            .startAngle((d) => d.x0)
            .endAngle((d) => d.x1)
            // .startAngle(d => { return Math.max(0, Math.min(2 * Math.PI, d['x0'])); })
            // .endAngle(d => { return Math.max(0, Math.min(2 * Math.PI, (d['x0'] + d['x1']))); })
            // .startAngle(d => { return d['x0'] })
            // .endAngle(fd => { return d['x1'] })
            // .innerRadius(d => { return d['y0'];  })
            // .outerRadius(d => { return  ['y0'] + d['y1'] });
            .innerRadius((d) => {
            if (d.depth === 1) {
                return Math.sqrt(d.y0) + 80;
            }
            else {
                return Math.sqrt(d.y0) + 95;
            }
        })
            .outerRadius((d) => {
            if (d.depth === 1) {
                return Math.sqrt(d.y0 + d.y1) + 90;
            }
            else {
                return Math.sqrt(d.y0 + d.y1) + 115;
            }
        });
    }
    draw() {
        const self = this;
        // color scale
        const color = function (d) {
            let colors;
            if (!d.parent) {
                colors = d3.scaleOrdinal().range(self.colorRange);
                d.color = "#fff";
            }
            else if (d.children) {
                // this.startColor = d3.hcl(d.color)
                //   .darker(),
                (this.startColor = d.color),
                    (this.endColor = d3.hcl(d.color).brighter());
                // Create the scale
                colors = d3
                    .scaleLinear()
                    .domain([0, (d.children.length + 1)])
                    .range([this.startColor, this.endColor])
                    .interpolate(d3.interpolateHcl);
            }
            if (d.children) {
                d.children
                    .map((child, i) => {
                    return { value: child.count, idx: i };
                })
                    .sort((a, b) => {
                    return b.value - a.value;
                })
                    .forEach((child, i) => {
                    d.children[child.idx].color = colors(i);
                });
            }
            return d.color;
        };
        // tooltip css
        this.tooltip = d3
            .select("body")
            .append("div")
            .style("position", "absolute")
            .style("z-index", "10")
            .style("visibility", "hidden")
            .style("background", "#fff")
            .style("color", "#58585B")
            .style("padding", "5px")
            .style("font-size", "14px")
            .style("box-shadow", " 0 3px 6px rgba(0, 0, 0, 0.1)");
        // Put it all together
        this.g = this.svg.select("g").selectAll("path");
        const g = this.g.data(this.root.descendants()).enter().append("g");
        g.append("path")
            .attr("display", (d) => (d.depth === 1 ? null : "none"))
            // .attr('display', d =>  d.depth ? null : 'none'; )
            .attr("d", this.arc)
            .on("click", click)
            .style("stroke", (d) => {
            if (d.depth === 1) {
                return "#fff";
            }
            else {
                return "none";
            }
        })
            .style("fill", color)
            // .style('fill', d => { return color((d.children ? d : d.parent).data.name); })
            .attr("class", (d) => (d.children ? d : d.parent).data.name.replace(/\s+/, ""));
        g.on("mouseover", onMouseOver);
        g.on("mousemove", (event) => {
            return self.tooltip
                .style("top", `${event.pageY - 10}px`)
                .style("left", `${+event.pageX + 10}px`);
        });
        g.on("mouseout", onMouseOut);
        // displays children
        function click(d) {
            const selectorName = (d.children ? d : d.parent).data.name.replace(/\s+/, "");
            g.selectAll("path").style("display", (d1) => d1.depth === 1 ? null : "none");
            g.selectAll(`path.${selectorName}`).style("display", (d2) => {
                if (d2.depth === 0) {
                    return "none";
                }
                else {
                    return "block";
                }
            });
        }
        // tooltip
        function onMouseOver(d) {
            const g1 = d3
                .select(this)
                .style("cursor", "pointer")
                .append("g")
                .attr("class", "text-group");
            g1.append("text")
                .attr("class", "count-text")
                .text(`${d.data.totalCount}`)
                .attr("text-anchor", "middle")
                .style("font-size", "34px")
                .style("fill", "#58585B")
                .attr("dy", "-0.1em");
            g1.append("text")
                .attr("class", "name-text")
                .text(`${d.data.displayText}` + ' ' + self.suffix)
                .attr("text-anchor", "middle")
                .style("word-break", "break-all")
                .style("font-size", "12px")
                .style("fill", "#58585B")
                .attr("dy", "1.4em");
            self.tooltip.text(`${d.data.label} : ${d.data.percentage}`);
            self.tooltip.style("visibility", "visible");
        }
        function onMouseOut() {
            d3.select(this).select("g").remove();
            self.tooltip.style("visibility", "hidden");
        }
    }
}
D3DoubleDonutChartComponent.ɵfac = function D3DoubleDonutChartComponent_Factory(t) { return new (t || D3DoubleDonutChartComponent)(); };
D3DoubleDonutChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3DoubleDonutChartComponent, selectors: [["lib-d3-double-donut-chart"]], viewQuery: function D3DoubleDonutChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$10, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [[1, "d3-donut-chart"], ["donut_chart", ""]], template: function D3DoubleDonutChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [".d3-donut-chart[_ngcontent-%COMP%]{height:100%}.d3-arc[_ngcontent-%COMP%]   text[_ngcontent-%COMP%]{text-anchor:middle}.d3-arc[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:#fff;stroke-width:3px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3DoubleDonutChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-double-donut-chart",
                templateUrl: "./d3-double-donut-chart.component.html",
                styleUrls: ["./d3-double-donut-chart.component.scss"]
            }]
    }], function () { return []; }, { chartContainer: [{
            type: ViewChild,
            args: ["donut_chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

/* eslint-disable @typescript-eslint/no-unsafe-return */
const _c0$$ = ["chart"];
class D3GroupChartComponent {
    constructor(logger, dataService, translate) {
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.sourceData = [];
        this.barPadding = 0.3;
        this.labelKeys = [];
        this.messageKeys = {};
        this.nFormatter = (num, decimalPoint) => {
            if (num >= 1000000000) {
                return (num / 1000000000).toFixed(decimalPoint).replace(/\.0$/, '') + 'G';
            }
            if (num >= 1000000) {
                return (num / 1000000).toFixed(decimalPoint).replace(/\.0$/, '') + 'M';
            }
            if (num >= 1000) {
                return (num / 1000).toFixed(decimalPoint).replace(/\.0$/, '') + 'K';
            }
            return num;
        };
        this.getTruncated = (str, size, limit) => {
            if (str && str.lastIndexOf("...") === -1 && str.length > size) {
                return str.substring(0, limit) + "...";
            }
            else {
                return str;
            }
        };
        this.getTooltipValue = (value) => {
            if (this.sourceData[0].customTickFormat && this.sourceData[0].customTickValues) {
                return this.sourceData[0].customTickValues.filter((obj) => obj.value === value)[0] ? this.sourceData[0].customTickValues.filter((obj) => obj.value === value)[0].name : "";
            }
            else {
                return value;
            }
        };
        this.getUnit = () => {
            switch (this.widgetType) {
                case "visitDurationByVisitNumber":
                    return this.labelKeys.minValue; //"min";
                case "unique_devices":
                case "traffic":
                case "customerAcq":
                case "presenceIndexByZone":
                case "visitsByFloors":
                    return "";
                case "visitsByZones":
                    return "";
                case "envMetrics":
                    return "";
                case "laTrendWidgets":
                    return "";
                default:
                    return "%";
            }
        };
        this.setPrefix = () => {
            let prefix = "";
            if (this.widgetType === "visitDurationDistribution")
                prefix = this.labelKeys.visitDurationDistribution; //"Visit Duration";
            else if (this.widgetType === "visitFrequencyDistribution")
                prefix = this.labelKeys.visitFrequencyDistribution; //"Visit Frequency";
            else if (this.widgetType === "visitDurationByVisitNumber")
                prefix = this.labelKeys.visitDurationByVisitNumber; //"Visit Number";
            else if (this.widgetType === "hourOfDay")
                prefix = this.labelKeys.hourOfDay; // "Hour of Day";
            else if (this.widgetType === "dayOfWeek")
                prefix = this.labelKeys.dayOfWeek; // "Day of Week";
            else if (this.widgetType === "entryTimeDistribution")
                prefix = this.labelKeys.entryTimeDistribution; //"Entry Time Distribution";
            else if (this.widgetType === "exitTimeDistribution")
                prefix = this.labelKeys.exitTimeDistribution; // "Exit Time Distribution";
            else if (this.widgetType === "empPresenceHOD")
                prefix = (this.chartOptions.subVertical == "students") ? this.labelKeys.stdPresenceHOD : this.labelKeys.empPresenceHOD; // "Student Presence: Hour of Day" : "Employee Presence: Hour of Day";
            else if (this.widgetType === "empPresenceDOW")
                prefix = (this.chartOptions.subVertical == "students") ? this.labelKeys.stdPresenceDOW : this.labelKeys.empPresenceDOW; // "Student Presence: Day of Week" : "Employee Presence: Day of Week";
            else if (this.widgetType === "visitorsHOD")
                prefix = this.labelKeys.visitorsHOD;
            else if (this.widgetType === "visitorsDOW")
                prefix = this.labelKeys.visitorsDOW;
            else if (this.widgetType === "workdayDurationDistribution")
                prefix = (this.chartOptions.subVertical == "students") ? this.labelKeys.visitDurationDistribution : this.labelKeys.workdayDurationDistribution;
            else if (this.widgetType === "employeeFrequencyDistribution")
                prefix = this.labelKeys.employeeFrequencyDistribution;
            return prefix;
        };
        this.setPrefix1 = () => {
            let prefix = "";
            if (this.widgetType === "visitDurationDistribution" ||
                this.widgetType === "visitFrequencyDistribution" ||
                this.widgetType === "workdayDurationDistribution")
                prefix = this.labelKeys.percentageOfVisits;
            else if (this.widgetType === "visitDurationByVisitNumber")
                prefix = this.labelKeys.visitDurationDistribution;
            else if (this.widgetType === "hourOfDay" ||
                this.widgetType === "dayOfWeek" ||
                this.widgetType === "unique_devices_hourOfDay" ||
                this.widgetType == "dwellTime")
                prefix = this.labelKeys.visits;
            else if (this.widgetType === "entryTimeDistribution" ||
                this.widgetType === "exitTimeDistribution" ||
                this.widgetType === "employeeFrequencyDistribution")
                prefix = (this.chartOptions.subVertical == "students") ? this.labelKeys.stdSubVertical : this.labelKeys.empSubVertical;
            else if (this.widgetType == "visitsByFloors" ||
                this.widgetType == "visitsByZones")
                prefix = this.labelKeys.visitors;
            else if (this.widgetType === "empPresenceHOD" ||
                this.widgetType === "empPresenceDOW" ||
                this.widgetType === "visitorsHOD" ||
                this.widgetType === "visitorsDOW")
                prefix = this.labelKeys.visitMH;
            return prefix;
        };
        this.utils = new Utils(logger);
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (!value || value.length == 0)
            return;
        this.sourceData = value;
        this.dataLength = this.sourceData.length;
        this.widgetType = this.sourceData[0].widgetType;
        if (this.tip) {
            this.tip.hide();
        }
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        if (this.tip) {
            this.tip.hide();
        }
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localized string here
            this.translate.get('shared-lib.d3-components.group-chart').subscribe((res) => {
                this.labelKeys = res;
            });
            this.translate.get('shared-lib.d3-components.group-chart.sensor').subscribe((res) => {
                this.messageKeys['sensor'] = res;
            });
            this.translate.get('shared-lib.d3-components.group-chart.sensors').subscribe((res) => {
                this.messageKeys['sensors'] = res;
            });
        });
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        const bottom = this.chartOptions.margin.bottom;
        if (this.svg)
            this.svg.remove();
        const keyValues = [];
        let sourceValue = 0;
        this.sourceData.forEach((d) => {
            if (d.rotateXaxis) {
                keyValues.push(d.rotateXaxis);
            }
            sourceValue = d.values.length;
        });
        if (keyValues.length >= 1) {
            this.chartOptions.margin.bottom = 80;
        }
        else {
            this.chartOptions.margin.bottom = bottom;
        }
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("transform", `translate(0,
					${this.chartOptions.margin.top - 20} 
					)`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg.append("g").attr("transform", `translate(25,20)`);
        if (this.chartOptions.barPadding) {
            this.barPadding = this.chartOptions.barPadding;
        }
        this.getxScale();
        this.getyScale();
        if (this.widgetType === 'envMetrics') {
            this.tip = d3Tip()
                .attr("class", "custom-tooltip")
                .offset([-10, 0])
                .html(function () {
                return "<div id='custom-tooltip line-chart'></div>";
            });
        }
        else {
            this.tip = d3Tip()
                .attr("class", "bi-tooltip")
                .offset([-10, 0])
                .html(function () {
                return "<div id='bi-tooltip line-chart'></div>";
            });
        }
        this.svg.call(this.tip);
    }
    preparexAxisTicks() {
        const ticks = this.sourceData.map(function (d) {
            return d.key;
        });
        if (ticks.length > 31) {
            for (let i = 0; i < ticks.length; i++) {
                ticks.splice(i + 1, 5);
            }
        }
        else {
            if (this.widgetType.toLocaleString() !== "dwellTime") {
                for (let i = 0; i < ticks.length; i++) {
                    ticks.splice(i + 1, 1);
                }
            }
        }
        return ticks;
    }
    reDraw() {
        this.createSvg();
        this.draw();
    }
    onResize() {
        if (this.sourceData && this.sourceData.length > 0)
            this.reDraw();
    }
    ngAfterViewInit() {
        this.dataService.getMagneticAppIsExpanded(this.unsubscribe$).subscribe((val) => {
            setTimeout(() => {
                // console.log("getMagneticAppIsExpanded", val);
                if (this.sourceData && this.sourceData.length > 0)
                    this.reDraw();
            }, 500);
        });
    }
    draw() {
        const self = this;
        this.sourceData.map(function (d) {
            return d.key;
        });
        const categoryNames = this.sourceData.map(function (d) {
            return d["values"].map(function (obj) {
                return obj["category"];
            });
        });
        let maxlen = 0;
        let catArray = [];
        for (let i = 0; i < categoryNames.length; i++) {
            if (categoryNames[i].length > maxlen) {
                maxlen = categoryNames[i].length;
                catArray = categoryNames[i];
            }
        }
        const keyValues = [];
        let sourceValues = 0;
        this.sourceData.forEach((d) => {
            if (d.rotateXaxis) {
                keyValues.push(d.rotateXaxis);
            }
            sourceValues = d.values.length;
        });
        if (this.chartOptions.showAllTicks) {
            this.xAxis = d3.axisBottom(this.xScale0).scale(this.xScale0);
        }
        else {
            let showRNTicks = false;
            if (this.chartOptions.app && this.chartOptions.app == "RightNow") {
                this.sourceData.forEach((section) => {
                    const bars = section.values;
                    if (section.rotateXaxis) {
                        showRNTicks = true;
                    }
                });
                if (showRNTicks) {
                    this.xAxis = d3
                        .axisBottom(this.xScale0)
                        .scale(this.xScale0);
                }
                else {
                    this.xAxis = d3
                        .axisBottom(this.xScale0)
                        .scale(this.xScale0)
                        .tickValues([]);
                }
            }
            else {
                if (this.dataLength > 30) {
                    const sortedTicks = this.preparexAxisTicks();
                    this.xAxis = d3
                        .axisBottom(this.xScale0)
                        .scale(this.xScale0)
                        .tickValues(sortedTicks);
                }
                else if (this.dataLength > 10) {
                    const sortedTicks = this.preparexAxisTicks();
                    this.xAxis = d3
                        .axisBottom(this.xScale0)
                        .scale(this.xScale0)
                        .tickValues(sortedTicks);
                }
                else {
                    this.xAxis = d3
                        .axisBottom(this.xScale0)
                        .scale(this.xScale0);
                }
                this.prepareTicks();
            }
        }
        this.yAxis = d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-this.width);
        // this.xScale0.domain(keyValues);
        this.xScale1 = d3
            .scaleBand()
            .domain(catArray)
            .range([0, this.xScale0.bandwidth()]);
        this.yScale = d3
            .scaleLinear()
            .range([this.height, 0])
            .domain([
            0,
            d3.max(this.sourceData, function (d) {
                return d3.max(d["values"], function (obj) {
                    return parseFloat(obj["count"]) > 10 || self.widgetType == 'envMetrics' ? parseFloat(obj["count"]) : 10;
                });
            })
        ])
            .nice();
        if (this.chartOptions.rotateXaxis) {
            let size = 12;
            let limit = 12;
            if (sourceValues > 10) {
                size = 16;
                limit = 16;
            }
            else if (sourceValues < 10) {
                size = 18;
                limit = 18;
            }
            let xAxisGroup = this.chart
                .append("g")
                .attr("class", "x axis");
            // if(this.widgetType === "occupancyDistributionByRoom" && this.dataLength <= 6){
            // 	xAxisGroup.attr(
            // 		"transform",
            // 		`translate(
            // 				${this.width/3} 
            // 				,${this.height})`,
            // 		"rotate(90)"
            // 	)
            // }else{
            xAxisGroup.attr("transform", `translate(
						${this.chartOptions.margin.left} 
						,${this.height})`, "rotate(90)");
            //}
            xAxisGroup.call(this.xAxis)
                .selectAll("text")
                .attr("transform", `rotate(65)`)
                .attr("text-anchor", "start")
                .attr("dx", "0.82em")
                .attr("dy", ".1em")
                .text((d) => { return this.getTruncated(d, size, limit); });
            //.call(this.d3TextWrap, 100);
        }
        else {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("transform", `translate(
						${this.chartOptions.margin.left} 
						,${this.height})`, "rotate(90)")
                .call(this.xAxis)
                .append("text")
                .attr("class", "xAxis-label")
                .text(this.chartOptions.xAxisLabel)
                .style("fill", "#1D3243")
                .style("text-anchor", "middle")
                .attr("transform", `translate(
				${this.width / 2}, 
				${30})`);
        }
        // Add the Y Axis
        this.chart
            .append("g")
            .attr("class", "y axis")
            .attr("transform", `translate(
					${this.chartOptions.margin.left - 15} 
					,0)`)
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - this.chartOptions.margin.left)
            .attr("y", 0 - (this.chartOptions.margin.left + 12.5)) // fixes for  y-axis label overlap issue with other locale
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .style("fill", "#1D3243")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-`${(this.width + 35)}`)
            .tickFormat(() => this.chartOptions.yAxisTickFormat));
        if (self.widgetType == 'envMetrics') {
            this.chart
                .append("g")
                .attr("class", "grid")
                .attr("transform", `translate(
					${this.chartOptions.margin.left} 
					,0)`)
                .call(d3
                .axisLeft(this.yScale)
                .scale(this.yScale)
                .tickSize(-this.width)
                .tickValues(this.yScale.ticks().filter(tick => Number.isInteger(tick)))
                .tickFormat((d) => {
                if (self.sourceData[0].customTickFormat) {
                    return self.sourceData[0].customTickValues[d] ? self.sourceData[0].customTickValues[d].name : "";
                }
                else {
                    if (this.chartOptions.setReadableNumber) {
                        if (this.widgetType === "historicalEUConsumptionByDay")
                            return this.nFormatter(d, 0);
                        else
                            return this.readableNumber(d, 2);
                    }
                    else {
                        if (this.chartOptions.isYaxisReadable)
                            return this.chartOptions.yAxisTickFormatter(d);
                        else
                            return `${d + this.chartOptions.yAxisTickFormat}`;
                    }
                }
            })
            // .tickFormat(d => this.chartOptions.isYaxisReadable ? this.chartOptions.yAxisTickFormatter(d) : d + this.chartOptions.yAxisTickFormat)
            );
        }
        else {
            this.chart
                .append("g")
                .attr("class", "grid")
                .attr("transform", `translate(
					${this.chartOptions.margin.left} 
					,0)`)
                .call(d3
                .axisLeft(this.yScale)
                .scale(this.yScale)
                .tickSize(-this.width)
                .tickFormat((d) => {
                if (self.sourceData[0].customTickFormat) {
                    return self.sourceData[0].customTickValues[d]
                        ? self.sourceData[0].customTickValues[d].name
                        : "";
                }
                else {
                    if (this.chartOptions.setReadableNumber) {
                        if (this.widgetType ===
                            "historicalEUConsumptionByDay")
                            return this.nFormatter(d, 0);
                        else
                            return this.readableNumber(d, 2);
                    }
                    else {
                        if (this.chartOptions.isYaxisReadable)
                            return this.chartOptions.yAxisTickFormatter(d);
                        else
                            return `${d + this.chartOptions.yAxisTickFormat}`;
                    }
                }
            })
            // .tickFormat(d => this.chartOptions.isYaxisReadable ? this.chartOptions.yAxisTickFormatter(d) : d + this.chartOptions.yAxisTickFormat)
            );
        }
        this.chart
            .select(".y")
            .transition()
            .duration(500)
            .delay(1300)
            .style("opacity", "1");
        let barGrid = this.chart
            .append("g")
            .attr("class", "bar-grid")
            .attr("transform", `translate(
					${this.chartOptions.margin.left} 
					,0)`);
        if (this.widgetType === "occupancyDistributionByRoom" && this.dataLength <= 6) {
            barGrid = this.chart
                .append("g")
                .attr("class", "bar-grid")
                .attr("transform", `translate(
    			   ${this.width / 3} 
    			   ,0)`);
        }
        const slice = barGrid
            .selectAll(".slice")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "g")
            .attr("transform", function (d) {
            return `translate(
					${self.xScale0(d.key)} 
					,0)`;
        });
        slice
            .selectAll("rect")
            .data(function (d) {
            return d.values;
        })
            .enter()
            .append("rect")
            // .attr("width", this.xScale1.bandwidth())
            .attr("width", function (d) {
            if (d.barWidth)
                return d.barWidth;
            else
                return self.xScale1.bandwidth();
        })
            .attr("x", function (d) {
            return self.xScale1(d.category);
        })
            .style("fill", function (d) {
            return d.fillColor;
        })
            .attr("y", function () {
            return self.yScale(0);
        })
            .attr("height", function () {
            return self.height - self.yScale(0);
        })
            .on("mouseover", function (d, i) {
            if (i.formatTooltip)
                self.setFormatTooltip(d, i);
            else
                self.showTooltip(d, i);
            self.tip.show(d, this);
        })
            .on("mouseout", function () {
            self.tip.hide();
        });
        slice
            .selectAll("rect")
            .attr("y", function (d) {
            return self.yScale(d.count);
        })
            .attr("height", function (d) {
            if (isNaN(+d.count)) {
                return 0;
            }
            return self.height - self.yScale(d.count);
        });
    }
    d3TextWrap(text, width, paddingRightLeft, paddingTopBottom) {
        paddingRightLeft = paddingRightLeft || 5;
        paddingTopBottom = (paddingTopBottom || 5) - 2;
        var maxWidth = width;
        width = width - (paddingRightLeft * 2);
        var arrLineCreatedCount = [];
        text.each(function () {
            var text = d3.select(this), words = text.text().split(/[ \f\n\r\t\v]+/).reverse(), word, line = [], lineNumber = 0, lineHeight = 1.1, x;
            let y;
            y = text.attr("y");
            let dy = parseFloat(text.attr("dy")), createdLineCount = 1, textAlign = text.style('text-anchor') || 'start';
            if (isNaN(dy))
                dy = 0;
            var wrapTickLabels = d3.select(text.node().parentNode).classed('tick'); //Don't wrap the 'normal untranslated' <text> element and the translated <g class='tick'><text></text></g> elements the same way..
            if (wrapTickLabels) {
                switch (textAlign) {
                    case 'start':
                        x = -width / 2;
                        break;
                    case 'middle':
                        x = 0;
                        break;
                    case 'end':
                        x = width / 2;
                        break;
                    default:
                }
            }
            else {
                switch (textAlign) {
                    case 'start':
                        x = paddingRightLeft;
                        break;
                    case 'middle':
                        x = maxWidth / 2;
                        break;
                    case 'end':
                        x = maxWidth - paddingRightLeft;
                        break;
                    default:
                }
            }
            y = +((null === y) ? paddingTopBottom : y);
            var tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", dy + "em");
            while (word = words.pop()) {
                line.push(word);
                tspan.text(line.join(" "));
                if (tspan.node().getComputedTextLength() > width && line.length > 1) {
                    line.pop();
                    tspan.text(line.join(" "));
                    line = [word];
                    tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
                    ++createdLineCount;
                }
            }
            arrLineCreatedCount.push(createdLineCount);
        });
        return arrLineCreatedCount;
    }
    prepareTicks() {
        if (this.dataLength > 30) {
            const sortedTicks = this.preparexAxisTicks();
            this.xAxis = d3
                .axisBottom(this.xScale0)
                .scale(this.xScale0)
                .tickValues(sortedTicks);
        }
        else if (this.dataLength > 10) {
            const sortedTicks = this.preparexAxisTicks();
            this.xAxis = d3
                .axisBottom(this.xScale0)
                .scale(this.xScale0)
                .tickValues(sortedTicks);
        }
        else {
            this.xAxis = d3
                .axisBottom(this.xScale0)
                .scale(this.xScale0);
        }
    }
    showTooltip(event, i) {
        const self = this;
        let tipContainer = "";
        const suffix = i.suffix ? i.suffix : "";
        const prefix = i.prefix || self.setPrefix();
        const prefix1 = i.prefix1 || self.setPrefix1();
        const count = i.displayValue ||
            (i.isLocale ? i.count.toLocaleString() : i.count);
        if (this.widgetType === 'occupancyDistributionByRoom') {
            self.tip.html(function () {
                tipContainer +=
                    '<div class="top-section" style="background-color: #1d3243 !important;"><div class="top-left">';
                tipContainer += '<div class="left-label">' + i.displayText + i.suffix + '</div>';
                tipContainer += "</div>";
                tipContainer += '<div class="top-right">' + i.count + i.unit + '</div>';
                tipContainer += "</div>";
                return tipContainer;
            });
        }
        else if (this.widgetType === 'envMetrics') {
            self.setEnvCustomTooltip(i);
        }
        else {
            self.tip.html(function () {
                if (i.displayDate) {
                    tipContainer += `<div class='groupChart-top'>
						${i.displayDate}
						</div>`;
                }
                if (self.widgetType == "visitsByFloors" ||
                    self.widgetType == "visitsByZones" ||
                    self.widgetType == "dwellTime") {
                    tipContainer += `<div class='top-center'>${i.displayText}</div>`;
                }
                else {
                    tipContainer += "<div class='top-section'>";
                    if (prefix) {
                        tipContainer += "<div class='top-left'>";
                        tipContainer += `<div class='left-label'>${prefix}</div>`;
                        tipContainer += "</div>";
                    }
                    if (i.displayText) {
                        tipContainer += `<div class='top-right'>${i.displayText}`;
                        if (suffix)
                            tipContainer += `<span class='suffix'>${suffix}</span>`;
                        tipContainer += "</div>";
                    }
                    tipContainer += "</div>";
                }
                tipContainer += "<div class='top-section'><div class='top-left'>";
                tipContainer += `<div class='left-label'>${prefix1}</div>`;
                tipContainer += "</div>";
                if (i.unit) {
                    tipContainer += `<div class='top-right'> 
						${count}
						<span>
						${i.unit}
						</span>`;
                }
                else {
                    tipContainer += `<div class='top-right'> 
						${count}
						<span>
						${self.getUnit()}
						</span>`;
                }
                tipContainer += "</div>";
                tipContainer += "</div>";
                return tipContainer;
            });
        }
    }
    setEUCustomTooltip(value) {
        const self = this;
        let tipContainer = "";
        self.tip.html(function () {
            tipContainer += "<div class = 'multiLine-tooltip'>";
            tipContainer += `<div class='multiLine-top'>${value.displayDate}</div>`;
            tipContainer += "<div class='daily-info'>";
            tipContainer += `<span style='vertical-align:middle; display:table; padding:8px; border-radius: 2px; background-color:${value.color}'></span><span class='multiLine-left'>
			${value.tooltipLabel}</span><span class = 'multiLine-right'>
			${value.countString}</span>`;
            tipContainer += "</div></div>";
            return tipContainer;
        });
    }
    setEnvCustomTooltip(i) {
        const self = this;
        let tipContainer = "";
        const count = self.getTooltipValue(i.count);
        let envSuffix = i.sensorsCnt > 1 ? this.messageKeys['sensors'] : this.messageKeys['sensor'];
        self.tip.html(function () {
            tipContainer += "<div class = 'streamLine-tooltip'>";
            tipContainer += "<div class='streamLine-info'>";
            if (i.unit || i.unit === "") {
                tipContainer += `<span class='streamLine-left'>
				${i.prefix1}
				</span><span class = 'streamLine-right'>
				${count} ${i.unit}</span>
				</div>`;
                if (i.displayText) {
                    tipContainer += `<div class='streamLine-bottom'>
					${i.displayText}
					</div>`;
                }
                tipContainer += "</div>";
            }
            else {
                tipContainer += `<span class='streamLine-left'>
				${i.prefix1}
				</span><span class = 'streamLine-right'>
				${i.displayValue} (${i.sensorsCnt} ${envSuffix})</span>
				</div>`;
                if (i.displayText) {
                    tipContainer += `<div class='streamLine-bottom'>
					${i.displayText}
					</div>`;
                }
                tipContainer += "</div>";
            }
            return tipContainer;
        });
    }
    setFormatTooltip(value, i) {
        const self = this;
        let tipContainer = "";
        let category = "";
        if (i.categoryTooltip) {
            category = i.categoryTooltip;
        }
        else {
            category = i.category;
        }
        self.tip.html(function () {
            const count = i.displayValue ||
                (i.isLocale ? i.count.toLocaleString() : i.count);
            tipContainer += "<div class = 'groupChart-tooltip'>";
            tipContainer += `<div class='groupChart-top'>${i.displayDate}</div>`;
            tipContainer += "<div class='daily-info'>";
            tipContainer += `<span style='vertical-align: middle;display: table;padding: 6px;border-radius: 3px;background-color:
				${i.fillColor}
				'></span><span class='groupChart-left'>
				${category}
				</span><span class = 'groupChart-right'>
				${count}</span>`;
            tipContainer += "</div></div>";
            return tipContainer;
        });
    }
    readableNumber(value, decimalPoint) {
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return "0";
        }
        decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
        const numCount = value.toPrecision(2).split("e"), // get power
        noOfK = numCount.length === 1
            ? 0
            : Math.floor(Math.min(numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        dividedValue = noOfK < 1
            ? value.toFixed(0 + decimalPoint)
            : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
        finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
        suffix = finalValue + ["", "K", "M", "B", "T"][noOfK]; // append power
        return suffix;
    }
    getxScale() {
        let paddingInner = 0.5;
        if (this.widgetType === "occupancyDistributionByRoom")
            this.chartOptions.handleBarWidth = true;
        if (this.chartOptions.handleBarWidth) {
            if (this.widgetType === "occupancyDistributionByRoom" && this.dataLength <= 6) {
                this.xScale0 = d3
                    .scaleBand()
                    //.range([0, ((this.width-this.chartOptions.margin.left -
                    //	this.chartOptions.margin.right)/6)])
                    .range([0, this.width / 3])
                    .domain(this.sourceData.map((d) => d.key))
                    // .padding(this.barPadding)
                    .paddingInner(0.76)
                    .paddingOuter(0.15);
                //.align(1)
                // .domain(this.sourceData.map((d) => d.key));
            }
            else {
                if (this.dataLength == 1) {
                    paddingInner = 0.9;
                }
                else if (this.dataLength > 1 && this.dataLength < 8) {
                    paddingInner = 0.77;
                }
                if (this.dataLength < 8) {
                    this.xScale0 = d3
                        .scaleBand()
                        .range([0, this.width])
                        .padding(this.barPadding)
                        .paddingInner(paddingInner)
                        .domain(this.sourceData.map((d) => d.key));
                }
                else {
                    this.xScale0 = d3
                        .scaleBand()
                        .range([0, this.width])
                        .padding(this.barPadding)
                        .domain(this.sourceData.map((d) => d.key));
                }
            }
        }
        else {
            this.xScale0 = d3
                .scaleBand()
                .range([
                0,
                this.width -
                    this.chartOptions.margin.left -
                    this.chartOptions.margin.right
            ])
                .padding(this.barPadding)
                .domain(this.sourceData.map((d) => d.key));
        }
        this.xScale1 = d3.scaleBand();
    }
    getyScale() {
        this.yScale = d3.scaleLinear().range([this.height, 0]);
    }
}
D3GroupChartComponent.ɵfac = function D3GroupChartComponent_Factory(t) { return new (t || D3GroupChartComponent)(i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
D3GroupChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3GroupChartComponent, selectors: [["lib-d3-group-chart"]], viewQuery: function D3GroupChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$$, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, hostBindings: function D3GroupChartComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function D3GroupChartComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { options: "options", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart"], ["chart", ""]], template: function D3GroupChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3GroupChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-group-chart",
                templateUrl: "./d3-group-chart.component.html",
                styleUrls: ["./d3-group-chart.component.scss"]
            }]
    }], function () { return [{ type: LoggerService }, { type: DataService }, { type: i2.TranslateService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ["window:resize", ["$event"]]
        }] }); })();

/* eslint-disable @typescript-eslint/no-unsafe-return */
const _c0$_ = ["chart"];
class D3GroupNewChartComponent {
    constructor(logger, dataService, translate) {
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.sourceData = [];
        this.barPadding = 0.3;
        this.labelKeys = [];
        this.expandedWidget = false;
        this.getUnit = () => {
            switch (this.widgetType) {
                case "visitDurationByVisitNumber":
                    return this.labelKeys.minValue;
                case "unique_devices":
                case "traffic":
                case "customerAcq":
                case "presenceIndexByZone":
                case "visitsByFloors":
                    return "";
                case "visitsByZones":
                    return "";
                case "laTrendWidgets":
                    return "";
                default:
                    return "%";
            }
        };
        this.setPrefix = () => {
            let prefix = "";
            if (this.widgetType === "visitDurationDistribution")
                prefix = this.labelKeys.visitDurationDistribution; //"Visit Duration";
            else if (this.widgetType === "visitFrequencyDistribution")
                prefix = this.labelKeys.visitFrequencyDistribution; //"Visit Frequency";
            else if (this.widgetType === "visitDurationByVisitNumber")
                prefix = this.labelKeys.visitDurationByVisitNumber; //"Visit Number";
            else if (this.widgetType === "hourOfDay")
                prefix = this.labelKeys.hourOfDay; // "Hour of Day";
            else if (this.widgetType === "dayOfWeek")
                prefix = this.labelKeys.dayOfWeek; // "Day of Week";
            else if (this.widgetType === "entryTimeDistribution")
                prefix = this.labelKeys.entryTimeDistribution; //"Entry Time Distribution";
            else if (this.widgetType === "exitTimeDistribution")
                prefix = this.labelKeys.exitTimeDistribution; // "Exit Time Distribution";
            else if (this.widgetType === "empPresenceHOD")
                prefix = (this.chartOptions.subVertical == "students") ? this.labelKeys.stdPresenceHOD : this.labelKeys.empPresenceHOD; // "Student Presence: Hour of Day" : "Employee Presence: Hour of Day";
            else if (this.widgetType === "empPresenceDOW")
                prefix = (this.chartOptions.subVertical == "students") ? this.labelKeys.stdPresenceDOW : this.labelKeys.empPresenceDOW; // "Student Presence: Day of Week" : "Employee Presence: Day of Week";
            else if (this.widgetType === "visitorsHOD")
                prefix = this.labelKeys.visitorsHOD;
            else if (this.widgetType === "visitorsDOW")
                prefix = this.labelKeys.visitorsDOW;
            else if (this.widgetType === "workdayDurationDistribution")
                prefix = (this.chartOptions.subVertical == "students") ? this.labelKeys.visitDurationDistribution : this.labelKeys.workdayDurationDistribution;
            else if (this.widgetType === "employeeFrequencyDistribution")
                prefix = this.labelKeys.employeeFrequencyDistribution;
            return prefix;
        };
        this.setPrefix1 = () => {
            let prefix = "";
            if (this.widgetType === "visitDurationDistribution" ||
                this.widgetType === "visitFrequencyDistribution" ||
                this.widgetType === "workdayDurationDistribution")
                prefix = this.labelKeys.percentageOfVisits;
            else if (this.widgetType === "visitDurationByVisitNumber")
                prefix = this.labelKeys.visitDurationDistribution;
            else if (this.widgetType === "hourOfDay" ||
                this.widgetType === "dayOfWeek" ||
                this.widgetType === "unique_devices_hourOfDay" ||
                this.widgetType == "dwellTime")
                prefix = this.labelKeys.visits;
            else if (this.widgetType === "entryTimeDistribution" ||
                this.widgetType === "exitTimeDistribution" ||
                this.widgetType === "employeeFrequencyDistribution")
                prefix = (this.chartOptions.subVertical == "students") ? this.labelKeys.stdSubVertical : this.labelKeys.empSubVertical;
            else if (this.widgetType == "visitsByFloors" ||
                this.widgetType == "visitsByZones")
                prefix = this.labelKeys.visitors;
            else if (this.widgetType === "empPresenceHOD" ||
                this.widgetType === "empPresenceDOW" ||
                this.widgetType === "visitorsHOD" ||
                this.widgetType === "visitorsDOW")
                prefix = this.labelKeys.visitMH;
            return prefix;
        };
        this.utils = new Utils(logger);
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set setExpandedWidget(value) {
        this.expandedWidget = value;
    }
    set data(value) {
        if (!value || value.length == 0)
            return;
        this.sourceData = value;
        this.dataLength = this.sourceData.length;
        this.widgetType = this.sourceData[0].widgetType;
        if (this.tip) {
            this.tip.hide();
        }
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        if (this.tip) {
            this.tip.hide();
        }
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localized string here
            this.translate.get('shared-lib.d3-components.group-chart').subscribe((res) => {
                this.labelKeys = res;
            });
        });
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg)
            this.svg.remove();
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("transform", `translate(0,
					0
					)`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg.append("g").attr("transform", `translate(25,10)`);
        if (this.chartOptions.barPadding) {
            this.barPadding = this.chartOptions.barPadding;
        }
        this.getxScale();
        this.getyScale();
        this.tip = d3Tip()
            .attr("class", "group-tooltip")
            .offset([-10, 0])
            .html(function () {
            return "<div id='group-tooltip line-chart'></div>";
        });
        this.svg.call(this.tip);
    }
    preparexAxisTicks() {
        const ticks = this.sourceData.map(function (d) {
            return d.key;
        });
        if (ticks.length > 31) {
            for (let i = 0; i < ticks.length; i++) {
                ticks.splice(i + 1, 5);
            }
        }
        else {
            if (this.widgetType.toLocaleString() !== "dwellTime" && !this.expandedWidget) {
                for (let i = 0; i < ticks.length; i++) {
                    ticks.splice(i + 1, 1);
                }
            }
        }
        return ticks;
    }
    draw() {
        this.sourceData.map(function (d) {
            return d.key;
        });
        const categoryNames = this.sourceData.map(function (d) {
            return d["values"].map(function (obj) {
                return obj["category"];
            });
        });
        let maxlen = 0;
        let catArray = [];
        for (let i = 0; i < categoryNames.length; i++) {
            if (categoryNames[i].length > maxlen) {
                maxlen = categoryNames[i].length;
                catArray = categoryNames[i];
            }
        }
        if (this.chartOptions.showAllTicks) {
            this.xAxis = d3.axisBottom(this.xScale0).scale(this.xScale0);
        }
        else {
            if (this.chartOptions.app && this.chartOptions.app == "RightNow") {
                this.xAxis = d3
                    .axisBottom(this.xScale0)
                    .scale(this.xScale0)
                    .tickValues([]);
            }
            else {
                if (this.dataLength > 30) {
                    const sortedTicks = this.preparexAxisTicks();
                    this.xAxis = d3
                        .axisBottom(this.xScale0)
                        .scale(this.xScale0)
                        .tickValues(sortedTicks);
                }
                else if (this.dataLength > 10) {
                    const sortedTicks = this.preparexAxisTicks();
                    this.xAxis = d3
                        .axisBottom(this.xScale0)
                        .scale(this.xScale0)
                        .tickValues(sortedTicks);
                }
                else {
                    var sortedTicks = [];
                    if (this.expandedWidget)
                        sortedTicks = this.preparexAxisTicks();
                    if (this.widgetType.toLocaleString() !== "dwellTime") {
                        this.xAxis = d3
                            .axisBottom(this.xScale0)
                            .scale(this.xScale0)
                            .tickValues(sortedTicks);
                    }
                    else {
                        this.xAxis = d3
                            .axisBottom(this.xScale0)
                            .scale(this.xScale0);
                    }
                }
            }
        }
        this.yAxis = d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-this.width)
            .ticks(3);
        // this.xScale0.domain(keyValues);
        this.xScale1 = d3
            .scaleBand()
            .domain(catArray)
            .range([0, this.xScale0.bandwidth()]);
        this.yScale = d3
            .scaleLinear()
            .range([this.height, 0])
            .domain([
            0,
            d3.max(this.sourceData, function (d) {
                return d3.max(d["values"], function (obj) {
                    return parseFloat(obj["count"]) > 10
                        ? parseFloat(obj["count"])
                        : 10;
                });
            })
        ])
            .nice();
        const xaxis = this.chart
            .append("g")
            .attr("class", "x axis")
            .attr("transform", `translate(
						${this.chartOptions.margin.left} 
						,${this.height})`, "rotate(90)")
            .call(this.xAxis);
        xaxis.selectAll("line").remove();
        xaxis.selectAll("text")
            .style("text-anchor", "end")
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
            .attr("transform", (d) => {
            return "rotate(-30)";
        })
            .append("text")
            .attr("class", "xAxis-label")
            .text(this.chartOptions.xAxisLabel)
            .style("fill", "#1D3243")
            .style("text-anchor", "middle")
            .attr("transform", `translate(
				${this.width / 2}, 
				${30})`);
        //	this.chart.selectAll(".x axis .tick line").attr("stroke", "transparent");
        // Add the Y Axis
        this.chart
            .append("g")
            .attr("class", "y axis")
            .attr("transform", `translate(
					${this.chartOptions.margin.left - 15} 
					,0)`)
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - this.chartOptions.margin.left)
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .style("fill", "#1D3243")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-`${(this.width + 35)}`)
            .tickFormat(() => this.chartOptions.yAxisTickFormat)
            .ticks(3)
            .tickSizeOuter(0));
        this.chart.selectAll(".y axis .tick line").attr("stroke", "transaprent");
        this.chart
            .append("g")
            .attr("class", "grid-custom")
            .attr("transform", `translate(
					${this.chartOptions.margin.left} 
					,0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-this.width)
            .ticks(3)
            .tickFormat((d) => {
            if (this.chartOptions.setReadableNumber) {
                return this.readableNumber(d, 2);
            }
            else {
                if (this.chartOptions.isYaxisReadable)
                    return this.chartOptions.yAxisTickFormatter(d);
                else
                    return `${d + this.chartOptions.yAxisTickFormat}`;
            }
        })
        // .tickFormat(d => this.chartOptions.isYaxisReadable ? this.chartOptions.yAxisTickFormatter(d) : d + this.chartOptions.yAxisTickFormat)
        );
        this.chart.selectAll(".grid-custom .tick line").attr("stroke", "#dedede");
        this.chart.selectAll(".x axis .tick line").attr("stroke", "transparent");
        this.chart.selectAll(".grid-custom .domain").attr("stroke", "transparent");
        this.chart
            .select(".y")
            .transition()
            .duration(500)
            .delay(1300)
            .style("opacity", "1");
        const self = this;
        const barGrid = this.chart
            .append("g")
            .attr("class", "bar-grid")
            .attr("transform", `translate(
					${this.chartOptions.margin.left} 
					,0)`);
        const slice = barGrid
            .selectAll(".slice")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "g")
            .attr("transform", function (d) {
            return `translate(
					${self.xScale0(d.key)} 
					,0)`;
        });
        slice
            .selectAll("rect")
            .data(function (d) {
            return d.values;
        })
            .enter()
            .append("rect")
            // .attr("width", this.xScale1.bandwidth())
            .attr("width", function (d) {
            if (d.barWidth)
                return d.barWidth;
            else
                return self.xScale1.bandwidth();
        })
            .attr("x", function (d) {
            return self.xScale1(d.category);
        })
            .style("fill", function (d) {
            return d.fillColor;
        })
            .attr("y", function () {
            return self.yScale(0);
        })
            .attr("height", function () {
            return self.height - self.yScale(0);
        })
            .on("mouseover", function (d, i) {
            if (i.formatTooltip)
                self.setFormatTooltip(d, i);
            else
                self.showTooltip(d, i);
            self.tip.show(d, this);
        })
            .on("mouseout", function () {
            self.tip.hide();
        });
        slice
            .selectAll("rect")
            .attr("y", function (d) {
            return self.yScale(d.count);
        })
            .attr("height", function (d) {
            if (isNaN(+d.count)) {
                return 0;
            }
            return self.height - self.yScale(d.count);
        });
    }
    showTooltip(event, i) {
        const self = this;
        let tipContainer = "";
        const suffix = i.suffix ? i.suffix : "";
        self.tip.html(function () {
            const prefix = i.prefix || self.setPrefix();
            const prefix1 = i.prefix1 || self.setPrefix1();
            const count = i.displayValue ||
                (i.isLocale ? i.count.toLocaleString() : i.count);
            if (i.displayDate) {
                tipContainer += `<div class='groupChart-top'>
					${i.displayDate}
					</div>`;
            }
            if (self.widgetType == "visitsByFloors" ||
                self.widgetType == "visitsByZones" ||
                self.widgetType == "dwellTime") {
                tipContainer += `<div class='top-center'>${i.displayText}</div>`;
            }
            else {
                tipContainer += "<div class='top-section'>";
                if (prefix) {
                    tipContainer += "<div class='top-left'>";
                    tipContainer += `<div class='left-label'>${prefix}</div>`;
                    tipContainer += "</div>";
                }
                if (i.displayText) {
                    tipContainer += `<div class='top-right'>${i.displayText}`;
                    if (suffix)
                        tipContainer += `<span class='suffix'>${suffix}</span>`;
                    tipContainer += "</div>";
                }
                tipContainer += "</div>";
            }
            tipContainer += "<div class='top-section'><div class='top-left'>";
            tipContainer += `<div class='left-label'>${prefix1}</div>`;
            tipContainer += "</div>";
            tipContainer += `<div class='top-right'> 
				${count}
				<span>
				${self.getUnit()}
				</span>`;
            tipContainer += "</div>";
            tipContainer += "</div>";
            return tipContainer;
        });
    }
    setFormatTooltip(value, i) {
        const self = this;
        let tipContainer = "";
        self.tip.html(function () {
            const count = i.displayValue ||
                (i.isLocale ? i.count.toLocaleString() : i.count);
            tipContainer += "<div class = 'groupChart-tooltip'>";
            tipContainer += `<div class='groupChart-top'>${i.displayDate}</div>`;
            tipContainer += "<div class='daily-info'>";
            tipContainer += `<span style='vertical-align: middle;display: table;padding: 6px;border-radius: 3px;background-color:
				${i.fillColor}
				'></span><span class='groupChart-left'>
				${i.category}
				</span><span class = 'groupChart-right'>
				${count}</span>`;
            tipContainer += "</div></div>";
            return tipContainer;
        });
    }
    readableNumber(value, decimalPoint) {
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return "0";
        }
        decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
        const numCount = value.toPrecision(2).split("e"), // get power
        noOfK = numCount.length === 1
            ? 0
            : Math.floor(Math.min(numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        dividedValue = noOfK < 1
            ? value.toFixed(0 + decimalPoint)
            : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
        finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
        suffix = finalValue + ["", "K", "M", "B", "T"][noOfK]; // append power
        return suffix;
    }
    getxScale() {
        let paddingInner = 0.5;
        if (this.chartOptions.handleBarWidth) {
            if (this.dataLength == 1) {
                paddingInner = 0.9;
            }
            else if (this.dataLength < 1 && this.dataLength < 4) {
                paddingInner = 0.7;
            }
            if (this.dataLength < 8) {
                this.xScale0 = d3
                    .scaleBand()
                    .range([0, this.width])
                    .padding(this.barPadding)
                    .paddingInner(paddingInner)
                    .domain(this.sourceData.map((d) => d.key));
            }
            else {
                this.xScale0 = d3
                    .scaleBand()
                    .range([0, this.width])
                    .padding(this.barPadding)
                    .domain(this.sourceData.map((d) => d.key));
            }
        }
        else {
            this.xScale0 = d3
                .scaleBand()
                .range([
                0,
                this.width
            ])
                .padding(this.barPadding)
                .domain(this.sourceData.map((d) => d.key));
        }
        this.xScale1 = d3.scaleBand();
    }
    getyScale() {
        this.yScale = d3.scaleLinear().range([this.height, 0]);
    }
}
D3GroupNewChartComponent.ɵfac = function D3GroupNewChartComponent_Factory(t) { return new (t || D3GroupNewChartComponent)(i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
D3GroupNewChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3GroupNewChartComponent, selectors: [["lib-d3-group-new-chart"]], viewQuery: function D3GroupNewChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$_, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", setExpandedWidget: "setExpandedWidget", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart-new"], ["chart", ""]], template: function D3GroupNewChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3GroupNewChartComponent, [{
        type: Component,
        args: [{
                selector: 'lib-d3-group-new-chart',
                templateUrl: './d3-group-new-chart.component.html',
                styleUrls: ['./d3-group-new-chart.component.scss']
            }]
    }], function () { return [{ type: LoggerService }, { type: DataService }, { type: i2.TranslateService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], setExpandedWidget: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

/* eslint-disable @typescript-eslint/no-unsafe-return */
const _c0$Z = ["chart"];
class D3HorizontalBarChartComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.chartOptions = {};
        this.sourceData = [];
        this.bmData = [];
        this.sData = [];
        this.widgetType = [];
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (!value || value.length == 0)
            return;
        this.sourceData = value;
        if (this.chartOptions) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    ngAfterViewInit() {
        this.dataService.getMagneticAppIsExpanded(this.unsubscribe$).subscribe((val) => {
            setTimeout(() => {
                // console.log("getMagneticAppIsExpanded", val);
                if (this.sourceData && this.sourceData.length > 0)
                    this.reDraw();
            }, 500);
        });
    }
    reDraw() {
        this.createSvg();
        this.draw();
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg)
            this.svg.remove();
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "90%")
            .attr("height", "100%")
            .attr("transform", `translate(5,${this.chartOptions.margin.top - 20})`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg.append("g").attr("transform", `translate(50,0)`);
        this.getxScale();
        this.getyScale();
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(function () {
            return "<div id='bi-tooltip line-chart'></div>";
        });
        this.svg.call(this.tip);
    }
    getxScale() {
        this.xScale = d3
            .scaleLinear()
            //.domain([0, 500])         // This is what is written on the Axis: from 0 to 100
            // .range([100, 800]);
            .range([0, this.width])
            .domain([
            0,
            d3.max(this.sourceData, function (d) {
                return d.count;
            })
        ]);
    }
    getyScale() {
        this.sourceData = this.sourceData.sort(function (a, b) {
            return d3.ascending(a.order, b.order);
        });
        this.yScale = d3
            .scaleBand()
            .range([this.height, 0])
            .padding(0.1)
            .domain(this.sourceData.map(function (d) {
            return d.xAxiskey;
        }));
    }
    // getyScale() {
    //   var barSize = 20;
    //   var xScaleRange = this.sourceData.length * 20
    //   this.sourceData = this.sourceData.sort(function (a, b) {
    //     return d3.ascending(a.order, b.order);
    //   })
    //   this.yScale = d3.scaleBand()
    //     // .range([this.height, 0])
    //     .range([barSize * this.sourceData.length, 0])
    //     .padding(0.1)
    //     // .rangeRound([this.width / 2 + xScaleRange, this.width / 2 - xScaleRange])
    //     .domain(this.sourceData.map(function (d) { return d.xAxiskey; }));
    // }
    draw() {
        const self = this;
        function make_x_gridlines() {
            return d3.axisBottom(self.xScale);
        }
        // add the x gridlines
        this.chart
            .append("g")
            .attr("class", "grid")
            .style("stroke", "#E9E9E9")
            .style("fill", "#E9E9E9")
            .style("stroke-width", "1px")
            .style("shape-rendering", "crispEdges")
            .attr("transform", `translate(70,${this.height})`)
            .call(make_x_gridlines()
            .tickSize(-this.height)
            .tickFormat(() => ""));
        this.chart
            .append("g")
            .attr("class", "x axis")
            .attr("width", "100%")
            .attr("transform", `translate(70,${this.height})`)
            .call(d3
            .axisBottom(this.xScale)
            .scale(this.xScale)
        // .tickFormat((d) => this.readableNumber(d, 0))
        );
        // this.chart
        // 	.append("g")
        // 	.attr("class", "y axis")
        // 	// .attr("transform", "translate(" + (this.chartOptions.margin.left - 2) + "," + 0 + ")")
        // 	.attr("transform", `translate(${this.chartOptions.margin.left},0)`)
        // 	.call(d3.axisLeft(this.yScale).scale(this.yScale))
        //     .selectAll("text")
        //     .attr("class", "cateName")
        //     .style("text-anchor", "start");
        this.chart.append("g")
            .attr("transform", "translate(" + this.chartOptions.margin.left + ", 0)")
            .attr("class", "y axis")
            // .call(d3.axisLeft(this.y).scale(this.y))
            .call(d3.axisLeft(this.yScale).scale(this.yScale))
            .selectAll("text")
            .attr("class", "cateName")
            .style("text-anchor", "start")
            .call(this.wrap, this.chartOptions.margin.left - 13);
        const bars = this.chart
            .append("g")
            .attr("class", "bar-group")
            .attr("transform", `translate(70,0)`);
        this.chart
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - (this.chartOptions.margin.left))
            .attr("x", 0 - (this.height / 2))
            .attr("dy", "1em")
            .style("fill", "#000000")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
        //append rects
        bars.selectAll(".bar")
            .data(this.sourceData)
            .enter()
            .append("rect")
            .attr("class", "bar")
            .attr("y", function (d) {
            return self.yScale(d.xAxiskey);
        })
            // .attr("height", this.yScale.bandwidth())
            .attr("height", function (d) {
            return d.barWidth;
        })
            .attr("transform", `translate(0,${this.yScale.bandwidth() / 2 - 7.5})`)
            .attr("x", 0)
            .attr("width", function (d) {
            return self.xScale(d.count);
        })
            .style("fill", (d) => d.color)
            .on("mouseover", function (d, i) {
            self.showTooltip(i);
            self.tip.show(d, this);
        })
            .on("mouseout", function () {
            self.tip.hide();
        });
        // add a value label to the right of each bar
        bars.selectAll(".val-label")
            .data(this.sourceData)
            .enter()
            .append("text")
            .attr("class", "label")
            .style("fill", "#545454")
            .style("font-size", "10px")
            .style("font-family", "CiscoSans")
            .attr("y", function (d) {
            return self.yScale(d.xAxiskey) + self.yScale.bandwidth() / 2 + 1;
            ;
        })
            // .attr("y", function (d) { return self.yScale(d.xAxiskey) + self.yScale.bandwidth() / 2 + 4;})
            .attr("x", function (d) {
            if (d.count > this.width)
                return self.xScale(d.count) - 60;
            else
                return +self.xScale(d.count) + 3;
        })
            .text((d) => this.readableNumber(d.count, 0))
            .append("text")
            .attr("x", function (d) {
            if (d.count > this.width)
                return self.xScale(d.count) - 5;
            else
                return +self.xScale(d.count) + 3;
        })
            .attr("y", function (d) {
            return self.yScale(d.xAxiskey) + self.yScale.bandwidth() / 2 + 1;
        })
            .attr("text-anchor", "middle")
            .attr("class", "bar-label")
            .text((d) => d.xAxiskey);
    }
    wrap(text, width) {
        text.each(function () {
            var text = d3.select(this);
            //words = text.text().split(/\s+/).reverse(),
            const numChunks = Math.ceil(text.text().length / 10);
            const chunks = new Array(numChunks);
            for (let i = 0, o = 0; i < numChunks; ++i, o += 10) {
                chunks[i] = text.text().substr(o, 10);
            }
            let words = chunks.reverse(), word, line = [], lineNumber = 0, lineHeight = 0.25, // ems
            y = text.attr("y"), dy = parseFloat(text.attr("dy")), tspan = text.text(null); //.append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
            while (word = words.pop()) {
                line.push(word);
                tspan.text(line.join(" "));
                if (tspan.node().getComputedTextLength() > width) {
                    line.pop();
                    tspan.text(line.join(" "));
                    line = [word]; // String((lineNumber += 1) * lineHeight + dy) +
                    tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", String((lineNumber += 1) * lineHeight + dy + "em")).text(word);
                }
            }
        });
    }
    readableNumber(value, decimalPoint) {
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return "0";
        }
        decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
        const numCount = value.toPrecision(2).split("e"), // get power
        noOfK = numCount.length === 1
            ? 0
            : Math.floor(Math.min(numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        dividedValue = noOfK < 1
            ? value.toFixed(0 + decimalPoint)
            : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
        finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
        suffix = finalValue + ["", "K", "M", "B", "T"][noOfK]; // append power
        return suffix;
    }
    // eslint-disable-next-line no-unused-vars
    showTooltip(i) {
        const self = this;
        let tipContainer = "";
        self.tip.html(function (d) {
            tipContainer += "<div class = 'horizontalBar-tooltip'>";
            tipContainer += `<span class='horizontalBar-left'>
				${i.xAxiskey}
				</span><span class = 'horizontalBar-right'>
				${i.count}
				</span>`;
            tipContainer += "</div>";
            return tipContainer;
        });
    }
}
D3HorizontalBarChartComponent.ɵfac = function D3HorizontalBarChartComponent_Factory(t) { return new (t || D3HorizontalBarChartComponent)(i0.ɵɵdirectiveInject(DataService)); };
D3HorizontalBarChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3HorizontalBarChartComponent, selectors: [["lib-d3-horizontal-bar-chart"]], viewQuery: function D3HorizontalBarChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$Z, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart"], ["chart", ""]], template: function D3HorizontalBarChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3HorizontalBarChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-horizontal-bar-chart",
                templateUrl: "./d3-horizontal-bar-chart.component.html",
                styleUrls: ["./d3-horizontal-bar-chart.component.scss"]
            }]
    }], function () { return [{ type: DataService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

/* eslint-disable @typescript-eslint/unbound-method */
const _c0$Y = ["chart"];
const moment$f = moment_;
class D3LineBarChartComponent {
    constructor(dataService, translate) {
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.sourceData = [];
        this.bmData = [];
        this.sData = [];
        this.ticks = [];
        this.dateTickValues = [];
        this.tickValues = [];
        this.midnightValues = [];
        this.xAxisTicks = [];
        this.dateValuesObj = [];
        this.dateValues = [];
        this.dateTicks = [];
        this.uniqueDates = [];
        this.tooltipData = [];
        this.labelKeys = [];
        this.getStaticText = () => {
            this.translate.get('shared-lib.d3-components.cumulative-chart').subscribe((res) => {
                this.labelKeys = res;
            });
        };
        window.addEventListener("resize", this.reDraw.bind(this));
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        this.sourceData = this.initialSourceData;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (this.tooltip) {
            this.tooltip.remove();
        }
        if (!value || value.length == 0)
            return;
        this.sourceData = value;
        this.initialSourceData = value;
        if (this.chartOptions) {
            this.createSvg();
            this.draw();
        }
    }
    reDraw() {
        // this.chartContainer.nativeElement.remove()
        if (this.tooltip) {
            this.tooltip.remove();
        }
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    ngAfterViewInit() {
        this.dataService.getMagneticAppIsExpanded(this.unsubscribe$).subscribe((val) => {
            setTimeout(() => {
                console.log("getMagneticAppIsExpanded", val);
                this.sourceData = this.initialSourceData;
                if (this.sourceData && this.sourceData.length > 0)
                    this.reDraw();
            }, 500);
        });
    }
    createSvg() {
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localized string here
            this.getStaticText();
        });
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg)
            this.svg.remove();
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("transform", `translate(0,
					${this.chartOptions.margin.top - 20} 
					)`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg.append("g").attr("transform", `translate(10,20)`);
        this.getxScale();
        this.getyScale();
        this.getLine();
        this.getArea();
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(function (d) {
            return "<div id='bi-tooltip line-chart'></div>";
        });
        this.svg.call(this.tip);
        const body = d3.select(element.closest("body"));
        const container = d3.select(element);
        this.scr = {
            x: window.scrollX,
            y: window.scrollY,
            w: window.innerWidth,
            h: window.innerHeight
        };
        if (!this.chartOptions.isPosTooltip) {
            this.elementAttr = {
                w: isNull(body.node()) ? 0 : body.node().offsetWidth,
                h: isNull(body.node()) ? 0 : body.node().offsetHeight
            };
            this.svgpos = this.getNodePos(this.svg.node(), body);
        }
        else {
            this.elementAttr = {
                w: isNull(container.node()) ? 0 : container.node().offsetWidth,
                h: isNull(container.node()) ? 0 : container.node().offsetHeight
            };
            this.svgpos = this.getNodePos(this.svg.node(), container);
        }
    }
    getNodePos(el, element) {
        const body = element.node();
        for (var lx = 0, ly = 0; el != null && el != body; lx += (el.offsetLeft || el.clientLeft), ly += (el.offsetTop || el.clientTop), el = (el.offsetParent || el.parentNode))
            ;
        return { x: lx, y: ly };
    }
    draw() {
        // const dateArray = [];
        const self = this;
        this.chart
            .append("g")
            .attr("class", "y axis")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left + 5)}
					,
					0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(this.width + 35))
            .tickFormat((d) => this.readableNumber(d, 2)));
        this.chart
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - (this.chartOptions.margin.left - 15))
            .attr("x", 0 - (this.height / 2))
            .attr("dy", "1em")
            .style("fill", "#000000")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
        this.chart
            .append("g")
            .attr("class", "grid")
            .attr("transform", "translate(" + (this.chartOptions.margin.left + 6) + "," + 0 + ")")
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(this.width + 35))
            .tickFormat(d => this.chartOptions.yAxisTickFormat));
        this.chart
            .append("g")
            .attr("class", "x-axis-label")
            .append("text")
            .text(this.chartOptions.xAxisLabel)
            .attr("transform", "translate(" + ((this.width / 2) + 40) + "," + (this.height + 40) + ")")
            .attr("text-anchor", "middle");
        const sectionGroup = this.chart
            .append("g")
            .attr("class", "section")
            .attr('transform', 'translate(' + (this.chartOptions.margin.left - 15) + ',' + 0 + ')');
        const dataLength = this.sourceData[0].xAxisValues.length;
        let barWidth = "5px";
        if (dataLength > 145) {
            barWidth = "2px";
        }
        this.sourceData.forEach((obj) => {
            let bars = [];
            if (obj.label.toString() === "Right Now") {
                bars = obj.values;
                const barGroup = sectionGroup.append("g");
                bars.forEach((value) => {
                    barGroup
                        .append("rect")
                        .attr("class", "bar")
                        .attr("x", this.xScale(value.date))
                        .attr("width", barWidth)
                        .attr("y", this.yScale(value.count))
                        .attr("height", this.height - this.yScale(value.count))
                        .style("fill", value.color);
                });
            }
        });
        let lines = this.chart.append("g").attr("class", "lines");
        this.sourceData.forEach((obj) => {
            const lineChartData = [];
            lines = lines.append("g");
            if (obj.label.toString() === "Historical") {
                lineChartData.push(obj);
                lines
                    .selectAll(".line-group")
                    .data(lineChartData)
                    .enter()
                    .append("g")
                    .attr("class", "border-line")
                    .attr("transform", "translate(" + (this.chartOptions.margin.left - 15) + "," + 0 + ")")
                    .append("path")
                    .attr("class", "line")
                    .attr("d", (d) => this.valueline(d.values))
                    .style("stroke", "#fff")
                    .style("stroke-width", 5);
                lines
                    .selectAll(".line-group")
                    .data(lineChartData)
                    .enter()
                    .append("g")
                    .attr("class", "line-group")
                    .attr("transform", "translate(" + (this.chartOptions.margin.left - 15) + "," + 0 + ")")
                    .append("path")
                    .attr("class", "line")
                    .attr("d", (d) => this.valueline(d.values))
                    .style("stroke", (d) => d.color);
            }
        });
        // Adding location capacity line
        if (this.sourceData[0].locationCapacity > 0) {
            const locationCapacity = this.sourceData[0].locationCapacity;
            lines
                .append("line")
                .attr("class", "capacity-line")
                .attr("transform", "translate(" + (this.chartOptions.margin.left + 6) + "," + 0 + ")")
                .attr("x1", -3)
                .attr("y1", this.yScale(locationCapacity))
                .attr("x2", this.width)
                .attr("y2", this.yScale(locationCapacity))
                .style("stroke-width", 2)
                .style("stroke", "#000000")
                .style("stroke-dasharray", 5)
                .style("fill", "none");
            lines
                .append("rect")
                .attr("rx", 20)
                .attr("ry", 20)
                .attr("width", 120)
                .attr("height", 17)
                .attr("x", 45)
                .attr("y", this.yScale(locationCapacity) - 10)
                .style("fill", "#26292b");
            lines
                .append("text")
                //.attr("transform", "translate(" + (this.chartOptions.margin.left + 6) + "," + 0 + ")")
                .attr("x", 100)
                .attr("y", this.yScale(locationCapacity))
                .style("font-size", "11px")
                .style("font-family", "CiscoSansLight")
                .style("font-weight", "bold")
                .attr("text-anchor", "middle")
                .text(this.labelKeys.locationCapacity)
                .style("fill", "#fff");
        }
        // to display max data available line
        const currentDay = this.sourceData.length - 1;
        const currentDate = this.sourceData[currentDay].values[this.sourceData[currentDay].values.length - 1].date;
        // creating midnight value ticks with date & rest of the time with hourly format
        if (self.chartOptions.singleXAxis) {
            this.midnightValues = [];
            this.xAxisTicks = [];
            this.dateValues = [];
            this.dateTicks = [];
            this.dateValuesObj = this.sourceData[currentDay].xAxisValues;
            this.dateValuesObj.forEach((obj) => {
                const date = obj.date;
                const time = moment$f(date).format("h:mm A");
                if (time === "12:00 AM") {
                    this.midnightValues.push(date);
                    this.xAxisTicks.push(moment$f(date).format("DD MMM, h A"));
                }
                else {
                    this.xAxisTicks.push(time);
                }
            });
            const histDateObj = this.sourceData[1].xAxisValues;
            histDateObj.forEach((obj) => {
                const date = obj.date;
                this.dateValues.push(date);
            });
            // get the unique dates from an array
            this.uniqueDates = [];
            for (let i = 0; i < this.dateValues.length; i++) {
                if (!this.isDateInArray(this.dateValues[i], this.uniqueDates)) {
                    this.uniqueDates.push(this.dateValues[i]);
                }
            }
            // to display every three hour ticks
            this.uniqueDates.forEach((d, i) => {
                if (i % 3 === 0) {
                    this.dateTicks.push(d);
                }
            });
        }
        if (this.chartOptions.xAxisFormat === "dateTime") {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", "translate(" + (this.chartOptions.margin.left - 15) + "," + this.height + ")")
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickValues(this.midnightValues)
                // .tickValues(this.dateTicks)
                .tickFormat(d3.timeFormat("%d %b, %I %p")));
        }
        else if (this.chartOptions.xAxisFormat === "time") {
            // const timeFormat = d3.timeFormat("%I %p");
            //  console.log("D3 multiline :: draw :: hour of day ", this.xScale)
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", "translate(" + (this.chartOptions.margin.left - 15) + "," + this.height + ")")
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                //.ticks(25)
                .tickFormat(d3.timeFormat("%I:%M %p"))
            //.tickValues(this.tickValues)
            // .tickValues((this.tickValues).filter(function (d, i) {
            //   if (dateArray.length > 0 && dateArray.indexOf(timeFormat(d)) != -1) {
            //     return false;
            //   } else {
            //     dateArray.push(timeFormat(d));
            //     return true;
            //   }
            // }))
            );
        }
        else if (this.chartOptions.xAxisFormat === "hour") {
            // const timeFormat = d3.timeFormat("%I %p");
            //console.log("D3 multiline :: draw :: hour of day ", this.xScale);
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", "translate(" + (this.chartOptions.margin.left - 15) + "," + this.height + ")")
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .ticks(25)
                .tickFormat(d3.timeFormat("%I %p"))
                .tickValues(this.tickValues)
            // .tickValues((this.tickValues).filter(function (d, i) {
            //   if (dateArray.length > 0 && dateArray.indexOf(timeFormat(d)) != -1) {
            //     return false;
            //   } else {
            //     dateArray.push(timeFormat(d));
            //     return true;
            //   }
            // }))
            );
        }
        if (this.chartOptions.drawVerticalLine) {
            lines
                .append("line")
                .attr("transform", "translate(" + (this.chartOptions.margin.left - 15) + "," + 0 + ")")
                .attr("x1", this.xScale(currentDate))
                .attr("y1", -8)
                .attr("x2", this.xScale(currentDate))
                .attr("y2", this.height)
                .style("stroke-width", 1)
                .style("stroke", this.chartOptions.lineColor)
                .style("stroke-dasharray", 3)
                .style("fill", "none");
        }
        // Adding gray line for 12 AM for the second day
        if (this.chartOptions.singleXAxis) {
            const midnightDate = this.midnightValues[1];
            lines
                .append("line")
                .attr("transform", "translate(" + (this.chartOptions.margin.left - 15) + "," + 0 + ")")
                .attr("x1", this.xScale(midnightDate))
                .attr("y1", -8)
                .attr("x2", this.xScale(midnightDate))
                .attr("y2", this.height)
                .style("stroke-width", 1)
                .style("stroke", "#565659")
                .style("stroke", 3)
                .style("opacity", 0.1)
                .style("fill", "none");
        }
        if (!this.chartOptions.hideMouseOverEffects) {
            self.showMouseOverTooltip();
        }
    }
    showTooltip(value, i) {
        const self = this;
        let tipContainer = "";
        // const suffix = value.suffix ? value.suffix : "";
        self.tip.html(function (d) {
            tipContainer += "<div class = 'multiLine-tooltip'>";
            tipContainer += "<div class='multiLine-top'>" + i.displayDate + "</div>";
            tipContainer += "<div class='daily-info'>";
            tipContainer += "<span style='vertical-align:middle; display:table; padding:6px; border-radius: 3px; background-color:" + i.color + "'></span><span class='multiLine-left'>" + i.name + "</span><span class = 'multiLine-right'>" + i.count + "</span>";
            tipContainer += "</div></div>";
            return tipContainer;
        });
    }
    getxScale() {
        let completeData = [];
        let keyValues = [];
        const self = this;
        this.ticks = [];
        this.dateTickValues = [];
        this.tickValues = [];
        if (self.chartOptions.singleXAxis) {
            keyValues = [];
            this.sourceData[1]["xAxisValues"].forEach(function (obj) {
                if (self.chartOptions.xAxisFormat === "date" ||
                    self.chartOptions.xAxisFormat === "dateTime") {
                    var parseTime = d3.timeParse(self.chartOptions.xAxisDateFormat);
                    var formatedDate = parseTime(obj.date);
                    if (formatedDate)
                        obj.date = parseTime(obj.date);
                    keyValues.push(obj.date);
                }
                else {
                    keyValues.push(obj.date);
                }
                self.ticks.push(obj.date);
                if (self.tickValues.findIndex((i) => i.toString() == obj.date) == -1) {
                    self.tickValues.push(obj.date);
                }
                completeData.push(obj);
            });
        }
        else {
            keyValues = [];
            this.sourceData[0]["values"].forEach(function (obj) {
                if (self.chartOptions.xAxisFormat === "date" ||
                    self.chartOptions.xAxisFormat === "dateTime") {
                    var parseTime = d3.timeParse(self.chartOptions.xAxisDateFormat);
                    var formatedDate = parseTime(obj.date);
                    if (formatedDate)
                        obj.date = parseTime(obj.date);
                    keyValues.push(obj.date);
                }
                else {
                    keyValues.push(obj.date);
                }
                self.ticks.push(obj.date);
                if (self.tickValues.findIndex((i) => i.toString() == obj.date) == -1) {
                    self.tickValues.push(obj.date);
                }
                completeData.push(obj);
            });
        }
        this.dateTickValues = keyValues;
        this.xScale = d3
            .scaleTime()
            .range([
            this.chartOptions.margin.left,
            this.width - this.chartOptions.margin.right
        ])
            .domain(d3.extent(keyValues, function (d) {
            return d;
        }));
    }
    getyScale() {
        if (this.sourceData[0].locationCapacity > 0) {
            let capacityValue = this.sourceData[0].locationCapacity;
            this.yScale = d3
                .scaleLinear()
                .range([this.height, 0])
                .domain([
                0,
                d3.max(this.sourceData, function (d) {
                    return d3.max(d["values"], function (obj) {
                        return parseFloat(obj["count"]) > capacityValue
                            ? parseFloat(obj["count"])
                            : parseFloat(capacityValue);
                    });
                })
            ])
                .nice();
        }
        else {
            this.yScale = d3
                .scaleLinear()
                .range([this.height, 0])
                .domain([
                0,
                d3.max(this.sourceData, function (d) {
                    return d3.max(d["values"], function (obj) {
                        return parseFloat(obj["count"]) > 10
                            ? parseFloat(obj["count"])
                            : 10;
                    });
                })
            ])
                .nice();
        }
    }
    getLine() {
        // const self.= this;
        this.valueline = d3
            .line()
            .x((d) => this.xScale(d["date"]))
            .y((d) => this.yScale(d["count"]));
        //.curve(d3.curveMonotoneX)
    }
    getArea() {
        this.area = d3
            .area()
            .x((d) => this.xScale(d["date"]))
            .y0(this.height)
            .y1((d) => this.yScale(d["count"]));
    }
    readableNumber(value, decimalPoint) {
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return "0";
        }
        decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
        var numCount = value.toPrecision(2).split("e"), // get power
        noOfK = numCount.length === 1
            ? 0
            : Math.floor(Math.min(numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        dividedValue = noOfK < 1
            ? value.toFixed(0 + decimalPoint)
            : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
        finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
        suffix = finalValue + ["", "K", "M", "B", "T"][noOfK]; // append power
        return suffix;
    }
    nonRepeativeTicks() {
        this.ticks.forEach((obj, i) => {
            this.ticks.splice(i + 3, 1);
        });
        return this.ticks;
    }
    isDateInArray(needle, haystack) {
        for (var i = 0; i < haystack.length; i++) {
            if (needle.getTime() === haystack[i].getTime()) {
                return true;
            }
        }
        return false;
    }
    showMouseOverTooltip() {
        var self = this;
        const element = this.chartContainer.nativeElement;
        // CREATE HOVER TOOLTIP WITH VERTICAL LINE //
        this.tooltip = d3
            .select(element)
            .append("div")
            .attr("id", "tooltip")
            .style("position", "absolute")
            .style("background-color", "#263b4c")
            .style("padding", 6)
            .style("display", "none");
        this.mouseG = this.chart
            .append("g")
            .attr("class", "mouse-over-effects");
        /* this.mouseG.append("path") // create vertical line to follow mouse
       .attr("class", "mouse-line")
       .style("stroke", "#A9A9A9")
       .style("stroke-width", lineStroke)
       .style("opacity", "0");*/
        //  var lines = document.getElementsByClassName('line');
        // For not repeating the values in tooltip
        if (self.chartOptions.singleXAxis) {
            let dailyHistValues = [];
            let dailyValues = [];
            this.tooltipData = [];
            this.combinedDailyValues = [];
            this.combinedHistValues = [];
            this.sourceData.forEach((obj) => {
                if (obj.label.toString() === "Historical") {
                    dailyHistValues.push(obj.values);
                    this.histColor = obj.color;
                    this.histTooltip = obj.name;
                }
                else {
                    dailyValues.push(obj.values);
                    this.dailyColor = obj.color;
                    this.rightNowTooltip = obj.name;
                }
            });
            if (dailyHistValues && dailyHistValues.length > 0) {
                this.combinedHistValues = dailyHistValues[0].concat(dailyHistValues[1]);
                this.tooltipData.push({
                    name: this.histTooltip,
                    values: this.combinedHistValues,
                    color: this.histColor
                });
            }
            if (dailyValues && dailyValues.length > 0) {
                this.combinedDailyValues =
                    dailyValues.length == 1
                        ? dailyValues[0]
                        : dailyValues[0].concat(dailyValues[1]);
                this.tooltipData.push({
                    name: this.rightNowTooltip,
                    values: this.combinedDailyValues,
                    color: this.dailyColor
                });
            }
            this.sourceData = this.tooltipData;
        }
        //var data = this.tooltipValues.filter(d => d.name == name);
        var res_nested = d3.group(this.sourceData, (d) => d["name"]);
        var mousePerLine = this.mouseG
            .selectAll(".mouse-per-line")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "mouse-per-line");
        mousePerLine
            .append("circle")
            .attr("r", 4)
            .style("stroke", function (d) {
            return d.color;
        })
            .style("fill", "none")
            .style("opacity", "0");
        this.mouseG
            .append("svg:rect") // append a rect to catch mouse movements on canvas
            .attr("width", this.width)
            .attr("height", this.height)
            .attr("transform", "translate(" + (this.chartOptions.margin.left - 15) + "," + 0 + ")")
            .attr("fill", "none")
            .attr("pointer-events", "all")
            .on("mouseout", function () {
            // on mouse out hide line, circles and text
            d3.select(element).select(".mouse-line").style("opacity", "0");
            d3.select(element)
                .selectAll(".mouse-per-line circle")
                .style("opacity", "0");
            d3.select(element)
                .selectAll(".mouse-per-line text")
                .style("opacity", "0");
            setTimeout(() => {
                const displayAtrr = d3
                    .select(element)
                    .select("#tooltip")
                    .style("display");
                // if (displayAtrr && displayAtrr === "block")
                d3.select(element)
                    .select("#tooltip")
                    .style("display", "none");
                self.tooltip.style('opacity', 0);
            }, 100);
        })
            .on("mouseover", function (d, i) {
            // on mouse in show line, circles and text
            d3.select(element).select(".mouse-line").style("opacity", "1");
            d3.select(element)
                .selectAll(".mouse-per-line circle")
                .style("opacity", "1");
            d3.select(element).select("#tooltip").style("display", "block");
            self.tooltip.style("opacity", 1);
        })
            .on("mousemove", function (event) {
            // update tooltip content, line, circles and text when mouse moves
            const mouse = d3.pointer(event, this);
            d3.select(element)
                .selectAll(".mouse-per-line")
                .attr("transform", function (d) {
                const xDate = self.xScale.invert(mouse[0]); // use 'invert' to get date corresponding to distance from mouse position relative to svg
                const bisect = d3.bisector(function (d) {
                    return d["date"];
                }).left; // retrieve row index of date on parsed csv
                const idx = bisect(d["values"], xDate);
                d3.select(element)
                    .select(".mouse-line")
                    .attr("d", function () {
                    var data = "M" + self.xScale(d["values"][idx]["date"]) + "," + (self.height);
                    data += " " + self.xScale(d["values"][idx]["date"]) + "," + 0;
                    return data;
                });
                var xTrans;
                var yTrans = 0.0;
                if (d["values"][idx]) {
                    xTrans =
                        parseFloat(self.xScale(d["values"][idx]["date"])) +
                            (self.chartOptions.margin.left - 15);
                    yTrans = self.yScale(d["values"][idx]["count"]);
                }
                else {
                    // d3.select(element).selectAll(".mouse-per-line circle")
                    //   .style("opacity", "0");
                    xTrans = -120;
                }
                return `translate(${xTrans},${yTrans})`;
            });
            if (self.chartOptions.defaultTooltipPos) {
                self.defaultTooltip(event, mouse);
            }
            else {
                self.updateTooltipContent(event, mouse, res_nested);
            }
        })
            .on("mouseout", function (d, i) {
            self.tooltip.style('opacity', 0);
            self.tooltip.style('display', "none");
        });
    }
    defaultTooltip(event, mouse) {
        var self = this;
        self.tooltip.selectAll("div").remove();
        var pageX = `${(event.pageX + 20) / 2}px`;
        var pageY = `${(event.pageY - 20) / 10}px`;
        var index = 0;
        self.tooltip
            .style("display", "block")
            .style("left", pageX)
            .style("top", pageY)
            .style("font-size", 11.5)
            .style("z-index", "1000")
            // .style('min-width', '220px')
            .selectAll()
            .data(self.sourceData)
            .enter() // for each vehicle category, list out name and price of premium
            .append("div")
            .style("color", () => {
            // return d.color
            return "#fff";
        })
            .style("font-size", 10)
            .html((d) => {
            const xDate = self.xScale.invert(mouse[0]);
            const bisect = d3.bisector(function (d) {
                return d["date"];
            }).left;
            var idx = bisect(d.values, xDate);
            if (d.values[idx]) {
                // console.log("line chart :: tool tip :: if value  " + idx + " ", d.values[idx])
                self.tooltip.style("min-width", "220px");
                self.tooltip.style("display", "block");
                self.tooltip.style("padding", "10px 15px");
                index += 1;
                return "<div class = 'multiLine-tooltip'>" + ((index == 1) ? "<div class='multiLine-top'>" + d.values[idx].displayDate + "</div>" : "")
                    + "<div class='daily-info'>" + "<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:" + d.values[idx].color + "'></span><span class='multiLine-left'>" + d.values[idx].name + "</span><span class = 'multiLine-right'>" + d.values[idx].count + "</span>"
                    + "</div></div>";
            }
            else {
                self.tooltip.style("min-width", "0");
                self.tooltip.style("padding", "0");
            }
        });
    }
    updateTooltipContent(event, mouse, res_nested) {
        var self = this;
        var dist = { x: 10, y: 10 };
        var m = d3.pointer(event, self.svg.node());
        self.scr.x = window.scrollX;
        self.scr.y = window.scrollY;
        m[0] += self.svgpos.x;
        m[1] += self.svgpos.y;
        self.tooltip.selectAll("div").remove();
        var index = 0;
        self.tooltip.style("right", "");
        self.tooltip.style("left", "");
        self.tooltip.style("bottom", "");
        self.tooltip.style("top", "");
        if (m[0] > parseInt(self.scr.x) + parseInt(self.scr.w) / 2) {
            self.tooltip.style("right", (self.elementAttr.w - m[0] + dist.x) + "px");
        }
        else {
            self.tooltip.style("left", (m[0] + dist.x) + "px");
        }
        self.tooltip.style("top", "0px");
        self.tooltip
            .style("display", "block")
            .style("font-size", 11.5)
            .style("z-index", "1000")
            .style("padding", "10px 15px")
            .style("min-width", "220px")
            .selectAll()
            .data(self.sourceData)
            .enter() // for each vehicle category, list out name and price of premium
            .append("div")
            .style("color", () => {
            return "#fff";
        })
            .style("font-size", 10)
            .html((d) => {
            // const tipContainer = "";
            var xDate = self.xScale.invert(mouse[0]);
            var bisect = d3.bisector(function (d) {
                return d["date"];
            }).left;
            var idx = bisect(d.values, xDate);
            if (d.values[idx]) {
                //console.log(d.values[idx], '::::; idx values');
                self.tooltip.style("display", "block");
                index += 1;
                return "<div class = 'multiLine-tooltip'>" + ((index == 1) ? "<div class='multiLine-top'>" + d.values[idx].displayDate + "</div>" : "")
                    + "<div class='daily-info'>" + "<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:" + d.values[idx].color + "'></span><span class='multiLine-left'>" + d.values[idx].name + "</span><span class = 'multiLine-right'>" + d.values[idx].count + "</span>"
                    + "</div></div>";
            }
            else {
                self.tooltip.style("min-width", "0");
                self.tooltip.style("padding", "0");
                // self.tooltip.style("display", "none");
                // self.tooltip.style("opacity", 0);
            }
            return "";
        });
    }
}
D3LineBarChartComponent.ɵfac = function D3LineBarChartComponent_Factory(t) { return new (t || D3LineBarChartComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
D3LineBarChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3LineBarChartComponent, selectors: [["lib-d3-line-bar-chart"]], viewQuery: function D3LineBarChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$Y, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart"], ["chart", ""]], template: function D3LineBarChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3LineBarChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-line-bar-chart",
                templateUrl: "./d3-line-bar-chart.component.html",
                styleUrls: ["./d3-line-bar-chart.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

/* eslint-disable @typescript-eslint/no-unsafe-return */
const _c0$X = ["chart"];
class D3LineComponent {
    constructor(dataService, translate) {
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.sourceData = [];
        this.bmData = [];
        this.sData = [];
        this.messageKeys = [];
        this.readableNumber = (value, decimalPoint) => {
            if (value === null) {
                return null;
            }
            if (value === 0) {
                return "0";
            }
            // number of decimal places to show
            decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint;
            const numCount = value.toPrecision(2).split("e"); // get power
            // floor at decimals, ceiling at trillions
            const noOfK = numCount.length === 1
                ? 0
                : Math.floor(Math.min(numCount[1].slice(1), 14) / 3);
            // divide by power
            const dividedValue = noOfK < 1
                ? value.toFixed(0 + decimalPoint)
                : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint);
            // enforce -0 is 0
            const finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue);
            const suffix = finalValue + ["", "K", "M", "B", "T"][noOfK]; // append power
            return suffix;
        };
    }
    set options(value) {
        if (!value) {
            return;
        }
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (!value || value.length === 0) {
            return;
        }
        this.sourceData = value.data;
        this.hasNegative = value.hasNegative ? value.hasNegative : false;
        this.bmData = value.threshold;
        this.displayDate = value.displayDate;
        this.sData = this.prepareYaxisSourcedata();
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localized string here
            this.translate.get('shared-lib.d3-components.line-component').subscribe((res) => {
                this.messageKeys = res;
                if (this.sourceData && this.sourceData.length > 0) {
                    this.reDraw();
                }
            });
        });
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    onResize() {
        if (this.sourceData && this.sourceData.length > 0) {
            this.reDraw();
        }
    }
    ngAfterViewInit() {
        this.dataService.getMagneticAppIsExpanded(this.unsubscribe$).subscribe((val) => {
            setTimeout(() => {
                // console.log("getMagneticAppIsExpanded", val);
                if (this.sourceData && this.sourceData.length > 0)
                    this.reDraw();
            }, 500);
        });
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg) {
            this.svg.remove();
        }
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("transform", `translate(0,${this.chartOptions.margin.top - 20})`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg.append("g").attr("transform", `translate(10,20)`);
        this.getxScale();
        this.getyScale();
        this.getLine();
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(function () {
            return '<div id="bi-tooltip line-chart"></div>';
        });
        this.svg.call(this.tip);
    }
    draw() {
        const xPos = this.chartOptions.outerPadding;
        const thresholdPos = xPos;
        const dataset = this.sourceData;
        const self = this;
        if (this.hasNegative) {
            // eslint-disable-next-line no-unused-vars
            const y0 = Math.max(Math.abs(d3.min(this.sourceData, (d) => {
                return d.count;
            })), Math.abs(d3.max(this.sourceData, (d) => {
                return d.count;
            })));
            this.yScale = d3
                .scaleLinear()
                .domain([
                d3.min(this.sourceData, (d) => {
                    return d.count;
                }),
                d3.max(this.sourceData, (d) => {
                    return d.count;
                })
            ])
                .range([this.height, 0])
                .nice();
        }
        if (!this.hasNegative) {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(${(this.chartOptions.margin.left + 5)},${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickFormat((d) => `${d + this.chartOptions.xAxisTickFormat}`)
                .ticks(6));
        }
        this.chart
            .append("g")
            .attr("class", "y axis")
            .attr("transform", 'translate(' + (this.chartOptions.tooltipType === 'impactAnalysisGroupLine'
            ? (this.chartOptions.margin.left + this.chartOptions.margin.left / 2)
            : this.chartOptions.margin.left - 2) + ',' + 0 + ')')
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(this.width + 35))
            .tickFormat(d => this.setYaxis(d)));
        this.chart
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", this.chartOptions.tooltipType === "impactAnalysisGroupLine"
            ? 0
            : 0 - (this.chartOptions.margin.left - 15))
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .style("fill", "#000000")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
        this.chart
            .append("g")
            .attr("class", "grid")
            .attr("transform", 'translate(' +
            (this.chartOptions.tooltipType === 'impactAnalysisGroupLine'
                ? (this.chartOptions.margin.left + this.chartOptions.margin.left / 2)
                : this.chartOptions.margin.left + 6) + ',' + 0 + ')')
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(this.width + 35))
            .tickFormat((d) => ""));
        if (this.chartOptions.tooltipType === "impactAnalysisGroupLine") {
            this.chart
                .append("line")
                .attr("class", "zero-axisline")
                .attr('transform', 'translate(' + (this.chartOptions.margin.left + 10) + ',' + 0 + ')')
                .attr("y1", this.yScale(-1))
                .attr("y2", this.yScale(-1))
                .attr("x1", 5)
                .attr('x2', this.width + 43)
                .style("stroke", this.chartOptions.anotationLineColor)
                .style("stroke-width", 2);
        }
        const labelGroup = this.chart.append("g").attr("class", "x-axis-label");
        labelGroup
            .append("text")
            .text(this.chartOptions.xAxisLabel)
            .attr('transform', 'translate(' + ((this.width / 2) + 40) + ',' + (this.height + 35) + ')')
            .attr("text-anchor", "middle");
        const tl = this.chart
            .append("g")
            .attr("class", "threshold")
            .attr('x2', this.width + 45)
            .attr('width', this.width + 45)
            .attr('transform', 'translate(' +
            (this.chartOptions.tooltipType === 'impactAnalysisGroupLine'
                ? (this.chartOptions.margin.left)
                : this.chartOptions.margin.left - 10) + ',' + 0 + ')');
        if (this.bmData && this.bmData.length > 0) {
            this.bmData.forEach((value) => {
                if (value.showThreshold) {
                    this.drawThresholdLine(value, tl, thresholdPos); // to draw threshold line
                }
                if (value.showAnnotation) {
                    this.drawAnnotationText(value, tl, thresholdPos);
                }
            });
        }
        const circleGroup = this.chart
            .append("g")
            .attr("class", "circle-group")
            .attr("transform", 'translate(' + (this.chartOptions.tooltipType === 'impactAnalysisGroupLine'
            ? (this.chartOptions.margin.left * 2)
            : this.chartOptions.margin.left + 5) + ',' + 0 + ')');
        circleGroup
            .append("path")
            .datum(dataset)
            .attr("class", "line")
            .attr("stroke", this.chartOptions.lineColor)
            .attr("fill", this.chartOptions.lineColor)
            .attr("d", this.valueline);
        circleGroup
            .selectAll(".dot")
            .data(dataset)
            .enter()
            .append("circle")
            .attr("class", "dot")
            .attr("cx", (d) => self.xScale(d.percentile))
            .attr("cy", (d) => self.yScale(d.count))
            .attr("r", (d) => d.radius)
            .attr("fill", (d) => d.color ? d.color : this.chartOptions.lineColor)
            .on("mouseover", function (d, i) {
            if (self.chartOptions.tooltipType === "impactAnalysisGroupLine") {
                self.showImpactAnalysisGroupLineTooltip(d, i);
            }
            else if (self.chartOptions.customTooltip) {
                self.showCustomTooltip(d, i);
            }
            else {
                self.showTooltip(d, i);
            }
            self.tip.show(d, this);
        })
            .on("mouseout", function () {
            self.tip.hide();
        });
        if (this.chartOptions.drawVerticalLine) {
            const today = new Date();
            const dd = today.getDate();
            this.displayDatePosition = dataset[dataset.length - 1].percentile;
            if (this.displayDate) {
                circleGroup
                    .append("text")
                    .text(this.displayDate)
                    .attr('transform', 'translate(' + (this.xScale(this.displayDatePosition)) + ',' + (-10) + ')')
                    .attr("text-anchor", "middle")
                    .style("fill", this.chartOptions.lineColor)
                    .style("font-size", "9px")
                    .style("font-family", "CiscoSansBold");
            }
            circleGroup
                .append("line")
                .attr("x1", this.xScale(this.displayDatePosition))
                .attr("y1", -8)
                .attr("x2", this.xScale(this.displayDatePosition))
                .attr("y2", this.height)
                .style("stroke-width", 1)
                .style("stroke", this.chartOptions.lineColor)
                .style("fill", "none")
                .style("stroke-dasharray", 3);
        }
    }
    setYaxis(d) {
        if (this.chartOptions.setReadableNumber) {
            return this.readableNumber(d, 1) +
                this.chartOptions.yAxisTickFormat;
        }
        else {
            return d + this.chartOptions.yAxisTickFormat;
        }
    }
    drawAnnotationText(value, tl, x) {
        const self = this;
        tl.append("text")
            .attr("class", "annotation-text")
            .style("fill", value.color)
            .text(value.annotationText)
            .style("text-anchor", "middle")
            .attr('transform', 'translate(' + (x + 6) + ',' + (self.yScale(value.count) - 5) + ')');
    }
    drawThresholdLine(value, tl, x) {
        const self = this;
        tl.append("line")
            // .attrs({
            // 	x1: value.historicalThreshold ? x : x - 5,
            // 	y1: this.yScale(value.count),
            // 	x2: +this.width + 45,
            // 	y2: this.yScale(value.count),
            // 	stroke: value.color,
            // 	"stroke-width":
            // 		this.chartOptions.tooltipType === "impactAnalysisGroupLine"
            // 			? 1
            // 			: 2
            // })
            .attr("x1", value.historicalThreshold ? x : x - 5)
            .attr("y1", this.yScale(value.count))
            .attr("x2", `${(this.width + 45)}`)
            .attr("y2", this.yScale(value.count))
            .attr("stroke", value.color)
            .attr("stroke-width", this.chartOptions.tooltipType === "impactAnalysisGroupLine" ? 1 : 2)
            .on("mouseover", function (d, i) {
            let tipContainer = "";
            const suffix = value.suffix ? value.suffix : "";
            const getCount = value.count.toFixed(2);
            self.tip.html((e) => {
                tipContainer += '<div class="top-section"><div class="top-left">';
                tipContainer += '<span class="left-label">' + value.displayText + '</span>';
                tipContainer += '<span class="top-right-value">' + getCount;
                if (suffix) {
                    tipContainer += '<span class="suffix">' + suffix + '</span>';
                }
                tipContainer += '</span>';
                tipContainer += '</div>';
                tipContainer += '</div>';
                if (self.chartOptions.tooltipType === 'impactAnalysisGroupLine') {
                    tipContainer += '<div class="top-section"><div class="top-left">';
                    tipContainer += '<div class="left-label">' + value.comparedToLabel + ' </div>';
                    tipContainer += '<div class="left-label">' + value.comparedToEventcount + ' </div>';
                    tipContainer += '</div>';
                    tipContainer += '<div class="top-right">';
                    tipContainer += '<div class="left-label">' + value.currentEventLabel + ' </div>';
                    tipContainer += '<div class="left-label">' + value.duringEventcount + ' </div>';
                    tipContainer += '</div>';
                    tipContainer += '</div>';
                }
                tipContainer += '</div>';
                return tipContainer;
            });
            self.tip.show(d, this);
        })
            .on("mouseout", function () {
            self.tip.hide();
        });
    }
    showTooltip(value, i) {
        const self = this;
        let tipContainer = "";
        const suffix = i.suffix ? i.suffix : "";
        self.tip.html(() => {
            tipContainer += '<div class="top-section"><div class="top-left">';
            tipContainer += '<div class="left-label">' + i.label + "</div>";
            tipContainer += "</div>";
            tipContainer += '<div class="top-right">' + i.count;
            if (suffix) {
                tipContainer += '<span class="suffix">' + suffix + '</span>';
            }
            tipContainer += "</div>";
            tipContainer += "</div>";
            tipContainer += '<div class="top-section"><div class="top-left">';
            tipContainer += '<div class="left-label">' + this.messageKeys["percentileTxt"] + '</div>';
            tipContainer += "</div>";
            tipContainer +=
                '<div class="top-right">' +
                    i.percentile +
                    '<span class="suffix">' +
                    self.percentileSuffix(i.percentile) +
                    "</span>";
            tipContainer += "</div>";
            tipContainer += "</div>";
            return tipContainer;
        });
    }
    // eslint-disable-next-line no-unused-vars
    showImpactAnalysisGroupLineTooltip(d, i) {
        const self = this;
        let tipContainer = "";
        const suffix = d.suffix ? d.suffix : "";
        self.tip.html((k) => {
            tipContainer +=
                '<div class="top-section custom-tooltip"><div class="top-left">';
            tipContainer += '<div class="left-label">' + i.key + '</div>';
            tipContainer += "</div>";
            if (i.count > 0) {
                tipContainer += '<div class="top-right positive">' + i.count + i.suffix + '</div>';
            }
            else {
                tipContainer += '<div class="top-right negative">' + i.count + i.suffix + '</div>';
            }
            tipContainer += "</div>";
            tipContainer += '<div class="top-section custom-tooltip"><div class="top-left">';
            tipContainer += '<div class="left-label custom-tip-label">' + i.comparedToLabel + ' </div>';
            tipContainer += '<div class="left-label custom-tip-value">' + i.comparedToEventcount + ' </div>';
            tipContainer += "</div>";
            tipContainer += '<div class="top-right">';
            tipContainer += '<div class="left-label custom-tip-label">' + i.currentEventLabel + ' </div>';
            tipContainer += '<div class="left-label custom-tip-value">' + i.duringEventcount + ' </div>';
            tipContainer += "</div>";
            tipContainer += "</div>";
            return tipContainer;
        });
    }
    showCustomTooltip(value, i) {
        const self = this;
        let tipContainer = "";
        const suffix = i.suffix ? i.suffix : "";
        self.tip.html((d) => {
            tipContainer += '<div class="top-section align-center small-font">' + i.key + '</div>';
            tipContainer += '<div class="top-section"><div class="top-left">';
            tipContainer += '<div class="left-label">' + suffix + '</div>';
            tipContainer += '</div>';
            tipContainer += '<div class="top-right">' + i.count + '</div>';
            tipContainer += '</div>';
            return tipContainer;
        });
    }
    percentileSuffix(value) {
        const j = value % 10;
        const k = value % 100;
        if (j === 1 && k !== 11) {
            return this.messageKeys["percentileSuffix_st"];
        }
        if (j === 2 && k !== 12) {
            return this.messageKeys["percentileSuffix_nd"];
        }
        if (j === 3 && k !== 13) {
            return this.messageKeys["percentileSuffix_rd"];
        }
        return this.messageKeys["percentileSuffix_th"];
    }
    getLine() {
        const self = this;
        this.valueline = d3
            .line()
            .x((d) => self.xScale(d.percentile))
            .y((d) => self.yScale(d.count))
            .curve(d3.curveMonotoneX);
    }
    getxScale() {
        const self = this;
        if (this.chartOptions.customXaxis) {
            this.xScale = d3
                .scaleLinear()
                .range([
                this.chartOptions.margin.left,
                this.width - this.chartOptions.margin.right
            ])
                .domain([1, 30]);
            // .domain([d3.min(this.sourceData, (d) => {
            //   return d.percentile;
            // }), d3.max(this.sourceData, (d) => {
            //   return d.percentile;
            // })])
        }
        else if (this.hasNegative) {
            this.xScale = d3
                .scaleBand()
                .range([
                this.chartOptions.margin.left,
                this.width - this.chartOptions.margin.right
            ])
                .domain(this.sourceData.map((d) => d.percentile));
        }
        else {
            this.xScale = d3
                .scaleLinear()
                .range([
                this.chartOptions.margin.left,
                this.width - this.chartOptions.margin.right
            ])
                .domain([0, 100]);
        }
        // .domain([0, d3.max(this.sourceData, (d) => {
        //     return d.percentile;
        // })])
    }
    getyScale() {
        const y0 = Math.max(Math.abs(d3.min(this.sourceData, (d) => {
            return d.count;
        })), Math.abs(d3.max(this.sourceData, (d) => {
            return d.count;
        })));
        if (this.hasNegative) {
            this.yScale = d3
                .scaleLinear()
                .range([this.height, 0])
                .domain([-y0 - y0 / 2, y0 + y0 / 2])
                .nice();
        }
        this.yScale = d3
            .scaleLinear()
            .range([this.height, 0])
            .domain([
            0,
            d3.max(this.sData, (d) => {
                return d.count;
            })
        ])
            .nice();
    }
    prepareYaxisSourcedata() {
        const allData = [];
        Object.keys(this.bmData).map((i) => {
            if (this.bmData[i].count) {
                allData.push(this.bmData[i]);
            }
        });
        Object.keys(this.sourceData).map((i) => {
            if (this.sourceData[i].count) {
                allData.push(this.sourceData[i]);
            }
        });
        return allData;
    }
    reDraw() {
        this.createSvg();
        this.draw();
    }
}
D3LineComponent.ɵfac = function D3LineComponent_Factory(t) { return new (t || D3LineComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
D3LineComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3LineComponent, selectors: [["lib-d3-line"]], viewQuery: function D3LineComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$X, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, hostBindings: function D3LineComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function D3LineComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { options: "options", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart"], ["chart", ""]], template: function D3LineComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: ["path[_ngcontent-%COMP%]{stroke:#4682b4;stroke-width:2;fill:none}.axis[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .axis[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{fill:none;stroke:gray;stroke-width:1;shape-rendering:crispEdges}.label[_ngcontent-%COMP%]{position:absolute}circle[_ngcontent-%COMP%]{cursor:pointer;fill:#4682b4}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3LineComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-line",
                templateUrl: "./d3-line.component.html",
                styleUrls: ["./d3-line.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ["window:resize", ["$event"]]
        }] }); })();

/* eslint-disable @typescript-eslint/unbound-method */
const _c0$W = ["chart"];
const moment$e = moment_;
class D3MultilineNewChartComponent {
    constructor() {
        this.sourceData = [];
        this.bmData = [];
        this.sData = [];
        this.ticks = [];
        this.dateTickValues = [];
        this.tickValues = [];
        window.addEventListener("resize", this.reDraw.bind(this));
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (this.tooltip) {
            this.tooltip.remove();
        }
        if (!value || value.length == 0)
            return;
        this.sourceData = value;
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    reDraw() {
        // this.chartContainer.nativeElement.remove()
        if (this.tooltip) {
            this.tooltip.remove();
        }
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg)
            this.svg.remove();
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("transform", `translate(0,
					${this.chartOptions.margin.top - 25})`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg.append("g").attr("transform", `translate(10,20)`);
        this.getxScale();
        this.getyScale();
        this.getLine();
        this.getArea();
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(function (d) {
            return "<div id='bi-tooltip line-chart'></div>";
        });
        this.svg.call(this.tip);
        const body = d3.select(element.closest("body"));
        const container = d3.select(element);
        this.scr = {
            x: window.scrollX,
            y: window.scrollY,
            w: window.innerWidth,
            h: window.innerHeight
        };
        if (!this.chartOptions.isPosTooltip) {
            this.elementAttr = {
                w: isNull(body.node()) ? 0 : body.node().offsetWidth,
                h: body.node().offsetHeight
            };
            this.svgpos = this.getNodePos(this.svg.node(), body);
        }
        else {
            this.elementAttr = {
                w: isNull(container.node()) ? 0 : container.node().offsetWidth,
                h: container.node().offsetHeight
            };
            this.svgpos = this.getNodePos(this.svg.node(), container);
        }
    }
    getNodePos(el, element) {
        var body = element.node();
        for (var lx = 0, ly = 0; el != null && el != body; lx += el.offsetLeft || el.clientLeft,
            ly += el.offsetTop || el.clientTop,
            el = el.offsetParent || el.parentNode)
            ;
        return { x: lx, y: ly };
    }
    draw() {
        let dateArray = [];
        let self = this;
        if (this.chartOptions.xAxisFormat == "date") {
            if (this.chartOptions.xAxisTickFormat != "th" &&
                this.chartOptions.xAxisTickFormat != "") {
                if (this.chartOptions.xTranslate) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left + 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)))
                        .selectAll("text")
                        .style("text-anchor", "end")
                        .attr("dx", "-.8em")
                        .attr("dy", "-.55em")
                        .attr("transform", this.chartOptions.xTranslate);
                }
                else {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left - 5},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)));
                }
            }
            else {
                if (this.dateTickValues.length > 3 &&
                    this.dateTickValues.length <= 8) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left - 5},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(4)
                        .tickFormat(d3.timeFormat("%d %b")));
                }
                else if (this.dateTickValues.length < 3) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 5},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(1)
                        .tickFormat(d3.timeFormat("%d %b")));
                }
                else if (this.dateTickValues.length === 3) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 5},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(2)
                        .tickFormat(d3.timeFormat("%d %b")));
                }
                else {
                    if (self.tickMonths.size > 1 && self.tickMonths.size < 8) {
                        this.chart
                            .append("g")
                            .attr("class", "x axis")
                            .attr("width", "100%")
                            .attr("transform", `translate(
									${this.chartOptions.margin.left - 5},${this.height})`)
                            .call(d3
                            .axisBottom(this.xScale)
                            .scale(this.xScale)
                            .ticks(d3.timeMonth.every(1))
                            .tickFormat(d3.timeFormat("%d %b")));
                    }
                    else if (self.tickMonths.size > 7) {
                        let xaxis = this.chart
                            .append("g")
                            .attr("class", "x axis")
                            .attr("width", "100%")
                            .attr("transform", `translate(
									${this.chartOptions.margin.left - 5},${this.height})`, "rotate(90)")
                            .call(d3
                            .axisBottom(this.xScale)
                            .scale(this.xScale)
                            .ticks(d3.timeMonth.every(2))
                            .tickFormat(d3.timeFormat("%d %b")));
                        xaxis.selectAll("text")
                            .style("text-anchor", "end")
                            .attr("dx", "-.8em")
                            .attr("dy", ".15em")
                            .attr("transform", (d) => {
                            return "rotate(-30)";
                        });
                    }
                    else {
                        this.chart
                            .append("g")
                            .attr("class", "x axis")
                            .attr("width", "100%")
                            .attr("transform", `translate(
									${this.chartOptions.margin.left - 5},${this.height})`)
                            .call(d3
                            .axisBottom(this.xScale)
                            .scale(this.xScale)
                            .ticks(4)
                            .tickFormat(d3.timeFormat("%d %b"))
                            .tickSizeOuter(0));
                    }
                }
            }
        }
        else if (this.chartOptions.xAxisFormat == "hour_of_day") {
            const sortedTicks = this.preparexAxisTicks();
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
							${this.chartOptions.margin.left - 5},${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickValues(sortedTicks)
                .tickFormat(d3.timeFormat("%I %p")));
        }
        else if (this.chartOptions.xAxisFormat == "time") {
            let timeFormat = d3.timeFormat("%I %p");
            console.log("D3 multiline :: draw :: hour of day ", this.xScale);
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
							${this.chartOptions.margin.left - 5},${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .ticks(24)
                .tickFormat(d3.timeFormat("%I %p"))
                .tickValues(this.tickValues.filter(function (d) {
                if (dateArray.length > 0 &&
                    dateArray.indexOf(timeFormat(d)) != -1) {
                    return false;
                }
                else {
                    dateArray.push(timeFormat(d));
                    return true;
                }
            })));
        }
        else if (this.chartOptions.xAxisFormat == "day") {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
							${this.chartOptions.margin.left - 5},${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickFormat(d3.timeFormat("%a"))
                .ticks(7));
        }
        else if (this.chartOptions.xAxisFormat === "dateTime") {
            if (this.dateTickValues.length <= 8) {
                const sortedTicks = this.nonRepeativeTicks();
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr("transform", `translate(
								${this.chartOptions.margin.left - 5},${this.height})`)
                    .call(d3
                    .axisBottom(this.xScale)
                    .scale(this.xScale)
                    .tickValues(sortedTicks)
                    .tickFormat(d3.timeFormat("%d %b, %I %p")));
            }
            else {
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr("transform", `translate(
								${this.chartOptions.margin.left - 5},${this.height})`)
                    .call(d3
                    .axisBottom(this.xScale)
                    .scale(this.xScale)
                    .tickFormat(d3.timeFormat("%d %b, %I %p")));
            }
        }
        else if (this.chartOptions.xAxisFormat === "dateTimeMetrics") {
            if (this.chartOptions.yTickValues.length > 0) {
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr("transform", `translate(
						${this.chartOptions.margin.left + 15},${this.height})`)
                    .call(d3
                    .axisBottom(this.xScale)
                    .scale(this.xScale)
                    .ticks(d3.timeHour.every(4))
                    .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)))
                    .selectAll("text")
                    .style("text-anchor", "end")
                    .attr("dx", "-.8em")
                    .attr("dy", "-.55em")
                    .attr("transform", this.chartOptions.xTranslate);
                /* 10 june this.getStatusYScale();
                this.chart.append("g")
                .call(
                        d3.axisLeft(this.yScale)
                        .scale(this.yScale)
                        .tickValues(this.chartOptions.yTickValues)
                    );*/
            }
            else {
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr("transform", `translate(
						${this.chartOptions.margin.left + 15},${this.height})`)
                    .call(d3
                    .axisBottom(this.xScale)
                    .scale(this.xScale)
                    .ticks(d3.timeHour.every(4))
                    .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)))
                    .selectAll("text")
                    .style("text-anchor", "end")
                    .attr("dx", "-.8em")
                    .attr("dy", "-.55em")
                    .attr("transform", this.chartOptions.xTranslate);
            }
        }
        else if (this.chartOptions.xAxisFormat === "time_of_hour") {
            if (this.chartOptions.xAxisTickFormat != "th" &&
                this.chartOptions.xAxisTickFormat != "") {
                if (this.chartOptions.xTranslate) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left + 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(d3.timeMinute.every(10))
                        /*.tickFormat(
                            d3.timeFormat(
                                this.chartOptions.xAxisTickFormat
                            )
                        )*/ .tickFormat(d3.timeFormat("%H:%M %p")))
                        .selectAll("text")
                        .style("text-anchor", "end")
                        .attr("dx", "-.8em")
                        .attr("dy", "-.55em")
                        .attr("transform", this.chartOptions.xTranslate);
                }
                else {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left - 5},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)));
                }
            }
            else {
                if (this.dateTickValues.length > 3 &&
                    this.dateTickValues.length <= 8) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left - 5},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(4)
                        .tickFormat(d3.timeFormat("%H:%M %p")));
                }
                else if (this.dateTickValues.length < 3) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 5},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(1)
                        .tickFormat(d3.timeFormat("%H:%M %p")));
                }
                else if (this.dateTickValues.length === 3) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 5},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(2)
                        .tickFormat(d3.timeFormat("%H:%M %p")));
                }
                else {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 5},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .tickFormat(d3.timeFormat("%H:%M %p")));
                }
            }
            /*	let timeFormat = d3.timeFormat("%H:%M %p");
                console.log("D3 multiline :: draw :: hour of day ", this.xScale);
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr(
                        "transform",
                        `translate(
                                ${this.chartOptions.margin.left - 5},${this.height})`
                    )
                    .call(
                        d3
                            .axisBottom(this.xScale)
                            .scale(this.xScale)
                            .ticks(6)
                            //.ticks(24)
                            .tickFormat(d3.timeFormat("%H:%M %p"))
                            .tickValues(
                                this.tickValues.filter(function (d ,index) {
                                    if (
                                        dateArray.length > 0 &&
                                        dateArray.indexOf(timeFormat(d)) != -1
                                    ) {
                                        return false;
                                    } else {
                                        if(index % 2 == 0)
                                        dateArray.push(timeFormat(d));
                                        return true;
                                    }
                                })
                            )
                    )*/
            //.attr("transform", this.chartOptions.xTranslate);
        }
        else if (this.chartOptions.xAxisFormat == "week_day") {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
							${this.chartOptions.margin.left - 5},${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .ticks(d3.timeDay.every(1))
                .scale(this.xScale)
                .tickFormat(d3.timeFormat("%a"))
            //.ticks(7)
            );
        }
        else {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                /*.attr(
                    "transform",
                    `translate(
                            ${this.chartOptions.margin.left - 5},${this.height})`
                )*/ .attr("transform", this.chartOptions.xTranslate)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickFormat(d3.timeFormat("%d %b")));
        }
        this.chart
            .append("g")
            .attr("class", "y axis")
            .attr("transform", `translate(
						${this.chartOptions.margin.left + 5},0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(this.width + 35))
            .tickFormat((d) => this.readableNumber(d, 2))
            .ticks(3)
            .tickSizeOuter(0));
        this.chart
            .selectAll(".axis .tick text")
            .attr("fill", "#1d3243")
            .attr("font-size", "9px");
        this.chart.selectAll(".y.axis .tick line").attr("stroke", "transparent");
        this.chart
            .selectAll(".x.axis .tick line")
            .attr("stroke", "transparent");
        this.chart.selectAll(".axis .domain").attr("stroke", "#dedede");
        this.chart
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0)
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .attr("fill", "#545454")
            .attr("text-anchor", "middle")
            .attr("font-size", "10px")
            .attr("font-family", "ciscoSans")
            .attr("text-transform", "uppercase")
            .style("font-weight", "700")
            .style("line-height", "1.5")
            .text(this.chartOptions.yAxisLabel);
        // this.chart.append("text")
        //   .attr("class", "xAxis-label")
        //   .attr("transform", "translate(" + ((this.width / 2) + 40) + "," + (this.height + 40) + ")")
        //   .attr("fill", "#000000")
        //   .style("text-anchor", "middle")
        //   .text(this.chartOptions.xAxisLabel);
        this.chart
            .append("g")
            .attr("class", "grid-custom")
            .attr("transform", `translate(
						${this.chartOptions.margin.left + 6},0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(this.width + 35))
            .tickFormat(() => this.chartOptions.yAxisTickFormat));
        this.chart
            .append("g")
            .attr("class", "x-axis-label")
            .append("text")
            .text(this.chartOptions.xAxisLabel)
            .attr("transform", `translate( 
					${this.width / 2 + 40} 
					, ${this.height + 40})`)
            .attr("text-anchor", "middle");
        this.chart.selectAll(".grid-custom .tick line").attr("stroke", "transparent");
        const gridLines = this.chart.selectAll(".grid-custom .tick line");
        gridLines._groups[0][0].setAttribute("stroke", "#dedede");
        this.chart.selectAll(".grid-custom .domain").attr("stroke", "transparent");
        const lines = this.chart.append("g").attr("class", "lines");
        lines
            .selectAll(".line-group")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "line-group")
            .attr("transform", `translate(
					${this.chartOptions.margin.left - 5},0)`)
            .append("path")
            .attr("class", "line")
            .attr("d", function (d) {
            return self.valueline(d.values);
        })
            .attr("stroke", function (d) {
            return d.color;
        })
            .attr("fill", "none")
            .style("stroke-width", 2);
        if (this.chartOptions.drawAvgLine) {
            const avgCnt = this.sourceData[0].avgCnt;
            lines
                .append("line")
                .attr("class", "avg-line")
                .attr("transform", `translate(
							${this.chartOptions.margin.left + 6} 
							,0)`)
                .attr("x1", -3)
                .attr("y1", this.yScale(avgCnt))
                .attr("x2", this.width)
                .attr("y2", this.yScale(avgCnt))
                .style("stroke-width", 1)
                .style("stroke", "#005E7D");
        }
        if (this.chartOptions.chartType == "circle") {
            lines
                .selectAll("circle-group")
                .data(this.sourceData)
                .enter()
                .append("g")
                .attr("transform", `translate(
						${this.chartOptions.margin.left - 5},0)`)
                .attr("fill", (d) => d.color)
                .selectAll("circle")
                .data((d) => d.values)
                .enter()
                .append("g")
                .attr("class", "circle")
                .append("circle")
                .attr("cx", (d) => this.xScale(d.date))
                .attr("cy", (d) => this.yScale(d.count))
                .attr("r", 4)
                .on("mouseover", function (d, i) {
                if (i.showCustomTooltip) {
                    self.showCustomTooltip(i);
                    self.tip.show(d, this);
                }
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
            if (this.chartOptions.drawVerticalLine) {
                var currentDate = this.sourceData[0].values[this.sourceData[0].values.length - 1].date;
                var currentTime = moment$e(currentDate).format("h A"); // moment.default(currentDate).format("h A");
                lines
                    .append("line")
                    .attr("transform", `translate(
								${this.chartOptions.margin.left - 5},0)`)
                    .attr("x1", this.xScale(currentDate))
                    .attr("y1", -8)
                    .attr("x2", this.xScale(currentDate))
                    .attr("y2", this.height)
                    .attr("stroke-width", 2)
                    .attr("stroke", "#049FD9")
                    .attr("stroke-dasharray", 3)
                    .attr("fill", "none");
                lines
                    .append("text")
                    .attr("transform", `translate(
							${this.chartOptions.margin.left - 5},0)`)
                    .attr("fill", "#049FD9")
                    .attr("font-size", "11px")
                    .attr("x", this.xScale(currentDate))
                    .attr("y", -10)
                    .attr("text-anchor", "middle")
                    .text(currentTime);
            }
        }
        /*.on("mouseover", function (d) {
      d3.select(this).attr('fill', d.color);
      self.showTooltip(d);
      self.tip.show(d, this);
    })
    .on("mouseout", function (d) {
      d3.select(this).attr('fill', 'transparent');
      self.tip.hide();
    })*/
        if (this.chartOptions.chartType == "area") {
            let areaGroup = this.chart.append("g").attr("class", "area-group");
            areaGroup
                .selectAll(".area-group")
                .data(this.sourceData)
                .enter()
                .append("g")
                .attr("class", "area-group")
                .attr("transform", `translate(
						${this.chartOptions.margin.left - 5},0)`)
                .append("path")
                .attr("class", "area")
                .attr("d", (d) => this.area(d["values"]))
                .attr("fill", (d) => d.areaColor)
                .style("fill", (d) => d.areaColor)
                .attr("opacity", 0.1);
        }
        if (!self.chartOptions.hideMouseOverEffects) {
            self.showMouseOverTooltip();
        }
    }
    showTooltip(value) {
        let self = this;
        let tipContainer = "";
        // const suffix = value.suffix ? value.suffix : "";
        self.tip.html(function (d) {
            tipContainer += "<div class = 'multiLine-tooltip'>";
            tipContainer +=
                "<div class='multiLine-top'>" + d.displayDate + "</div>";
            tipContainer += "<div class='daily-info'>";
            tipContainer +=
                "<span style='vertical-align:middle; display:table; padding:6px; border-radius: 3px; background-color:" +
                    d.color +
                    "'></span><span class='multiLine-left'>" +
                    d.name +
                    "</span><span class = 'multiLine-right'>" +
                    d.count +
                    "</span>";
            tipContainer += "</div></div>";
            return tipContainer;
        });
    }
    showCustomTooltip(i) {
        let self = this;
        let tipContainer = "";
        // const suffix = value.suffix ? value.suffix : "";
        self.tip.html(function (d) {
            tipContainer += "<div class = 'multiLine-custom-tip'>";
            tipContainer +=
                "<div class='top-left'>" +
                    i.displayKey +
                    "</div><div class='top-right'>" +
                    i.count +
                    "</div>";
            tipContainer += "</div>";
            return tipContainer;
        });
    }
    getxScale() {
        // var parseTime = d3.timeParse("%Y-%m-%dT%H:%M:%SZ"); // "2019-10-23T14:00:00.000Z
        let completeData = [];
        let keyValues = [];
        var self = this;
        this.ticks = [];
        this.dateTickValues = [];
        let tickMonthArray = new Set();
        this.tickMonths = new Set();
        this.sourceData.forEach(function (d) {
            keyValues = [];
            d["values"].forEach(function (obj) {
                if (self.chartOptions.xAxisFormat === "date" ||
                    self.chartOptions.xAxisFormat === "dateTime" ||
                    self.chartOptions.xAxisFormat === "dateTimeMetrics" ||
                    self.chartOptions.xAxisFormat === "time_of_hour" ||
                    self.chartOptions.xAxisFormat === "week_day") {
                    const parseTime = d3.timeParse(self.chartOptions.xAxisDateFormat);
                    const formatedDate = parseTime(obj.date);
                    if (formatedDate)
                        obj.date = parseTime(obj.date);
                    keyValues.push(obj.date);
                }
                else {
                    keyValues.push(obj.date);
                }
                tickMonthArray.add(obj.date.getMonth());
                //obj.count = +obj.count;
                self.ticks.push(obj.date);
                if (self.tickValues.findIndex((i) => i.toString() == obj.date) == -1) {
                    self.tickValues.push(obj.date);
                }
                completeData.push(obj);
            });
        });
        this.tickMonths = tickMonthArray;
        console.log(" ################# . :: tickMonths::  ", this.tickMonths);
        this.dateTickValues = keyValues;
        this.xScale = d3
            .scaleTime()
            .range([
            this.chartOptions.margin.left,
            this.width - this.chartOptions.margin.right
        ])
            .domain(d3.extent(keyValues, function (d) {
            return d;
        }));
    }
    getyScale() {
        if (this.chartOptions.drawAvgLine) {
            const avgCnt = this.sourceData[0].avgCnt;
            this.yScale = d3
                .scaleLinear()
                .range([this.height, 0])
                .domain([
                0,
                d3.max(this.sourceData, function (d) {
                    return d3.max(d["values"], function (obj) {
                        return parseFloat(obj["count"]) > parseFloat(avgCnt)
                            ? parseFloat(obj["count"])
                            : parseFloat(avgCnt);
                    });
                })
            ])
                .nice();
        }
        else {
            this.yScale = d3
                .scaleLinear()
                .range([this.height, 0])
                .domain([
                0,
                d3.max(this.sourceData, function (d) {
                    return d3.max(d["values"], function (obj) {
                        return parseFloat(obj["count"]) > 10
                            ? parseFloat(obj["count"])
                            : 10;
                    });
                })
            ])
                .nice();
        }
    }
    getStatusYScale() {
        this.yScale = d3
            .scaleLinear()
            .range([this.height, 0])
            .domain([0, 1])
            .nice();
    }
    getLine() {
        let self = this;
        this.valueline = d3
            .line()
            .x(function (d) {
            return self.xScale(d["date"]);
        })
            .y(function (d) {
            return self.yScale(d["count"]);
        });
        //.curve(d3.curveMonotoneX)
    }
    getArea() {
        this.area = d3
            .area()
            .x((d) => this.xScale(d["date"]))
            .y0(this.height)
            .y1((d) => this.yScale(d["count"]));
    }
    readableNumber(value, decimalPoint) {
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return "0";
        }
        decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
        var numCount = value.toPrecision(2).split("e"), // get power
        noOfK = numCount.length === 1
            ? 0
            : Math.floor(Math.min(numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        dividedValue = noOfK < 1
            ? value.toFixed(0 + decimalPoint)
            : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
        finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
        suffix = `${finalValue + ["", "K", "M", "B", "T"][noOfK]}`; // append power
        return suffix;
    }
    // to display alernative ticks
    preparexAxisTicks() {
        this.ticks.forEach((obj, i) => {
            this.ticks.splice(i + 1, 1);
        });
        return this.ticks;
    }
    // to display all ticks for 8 data points
    nonRepeativeTicks() {
        this.ticks.forEach((obj, i) => {
            this.ticks.splice(i, 0);
        });
        return this.ticks;
    }
    showMouseOverTooltip() {
        var self = this;
        const element = self.chartContainer.nativeElement;
        // CREATE HOVER TOOLTIP WITH VERTICAL LINE //
        self.tooltip = d3
            .select(element)
            .append("div")
            .attr("id", "tooltip")
            .style("position", "absolute")
            .style("background-color", "#263b4c")
            .style("padding", 6)
            .style("display", "none");
        self.tooltip.transition().duration(300).style("opacity", 0);
        this.mouseG = this.chart
            .append("g")
            .attr("class", "mouse-over-effects");
        /* this.mouseG.append("path") // create vertical line to follow mouse
       .attr("class", "mouse-line")
       .style("stroke", "#A9A9A9")
       .style("stroke-width", lineStroke)
       .style("opacity", "0");*/
        //  var lines = document.getElementsByClassName('line');
        //var data = this.tooltipValues.filter(d => d.name == name);
        // const res_nested = d3
        // 	.nest() // necessary to nest data so self keys represent each vehicle category
        // 	.key((d) => d["name"])
        // 	.entries(this.sourceData);
        var res_nested = d3.group(this.sourceData, (d) => d["name"]);
        var mousePerLine = this.mouseG
            .selectAll(".mouse-per-line")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "mouse-per-line");
        mousePerLine
            .append("circle")
            .attr("r", 4)
            .attr("stroke", function (d) {
            return d.color;
        })
            .attr("fill", "none")
            .style("opacity", "0");
        this.mouseG
            .append("svg:rect") // append a rect to catch mouse movements on canvas
            .attr("width", this.width)
            .attr("height", this.height)
            .attr("transform", `translate(
					${this.chartOptions.margin.left - 5},0)`)
            .attr("fill", "none")
            .attr("pointer-events", "all")
            .on("mouseout", function () {
            // on mouse out hide line, circles and text
            d3.select(element).select(".mouse-line").style("opacity", "0");
            d3.select(element)
                .selectAll(".mouse-per-line circle")
                .style("opacity", "0");
            d3.select(element)
                .selectAll(".mouse-per-line text")
                .style("opacity", "0");
            setTimeout(() => {
                var displayAtrr = d3
                    .select(element)
                    .select("#tooltip")
                    .style("display");
                if (displayAtrr && displayAtrr === "block")
                    d3.select(element)
                        .select("#tooltip")
                        .style("display", "none");
                self.tooltip.style('opacity', 0);
            }, 100);
        })
            .on("mouseover", function () {
            // on mouse in show line, circles and text
            d3.select(element).select(".mouse-line").style("opacity", "1");
            d3.select(element)
                .selectAll(".mouse-per-line circle")
                .style("opacity", "1");
            d3.select(element).select("#tooltip").style("display", "block");
            self.tooltip
                .transition()
                .duration(300)
                .style("opacity", 1);
        })
            .on("mousemove", function (d) {
            // update tooltip content, line, circles and text when mouse moves
            const mouse = d3.pointer(d, this);
            d3.select(element)
                .selectAll(".mouse-per-line")
                .attr("transform", function (d) {
                const xDate = self.xScale.invert(mouse[0]); // use 'invert' to get date corresponding to distance from mouse position relative to svg
                const bisect = d3.bisector(function (d) {
                    return d["date"];
                }).left; // retrieve row index of date on parsed csv
                const idx = bisect(d["values"], xDate);
                d3.select(element)
                    .select(".mouse-line")
                    .attr("d", function () {
                    var data = "M" + self.xScale(d["values"][idx]["date"]) + "," + (self.height);
                    data += " " + self.xScale(d["values"][idx]["date"]) + "," + 0;
                    return data;
                });
                let xTrans;
                let yTrans = 0.0;
                if (d["values"][idx]) {
                    xTrans =
                        parseFloat(self.xScale(d["values"][idx]["date"])) +
                            (self.chartOptions.margin.left - 5);
                    yTrans = self.yScale(d["values"][idx]["count"]);
                }
                else {
                    d3.select(element)
                        .selectAll(".mouse-per-line circle")
                        .style("opacity", "0");
                    xTrans = self.chartOptions.margin.left;
                }
                return `translate(${xTrans},${yTrans})`;
            });
            if (self.chartOptions.defaultTooltipPos) {
                self.defaultTooltip(d, mouse);
            }
            else {
                self.updateTooltipContent(d, mouse);
            }
        })
            .on("mouseout", function (d, i) {
            self.tooltip.style('opacity', 0);
            self.tooltip.style('display', "none");
        });
    }
    defaultTooltip(event, mouse) {
        var self = this;
        self.tooltip.selectAll("div").remove();
        var pageX = `${(event.pageX + 20) / 2}px`;
        var pageY = `${(event.pageY - 20) / 10}px`;
        let index = 0;
        self.tooltip
            .style("display", "block")
            .style("left", pageX)
            .style("top", pageY)
            .style("font-size", 11.5)
            .style("z-index", "1000")
            // .style('min-width', '220px')
            .selectAll()
            .data(self.sourceData)
            .enter()
            .append("div")
            .style("color", (d) => {
            // return d.color
            return "#fff";
        })
            .style("font-size", 10)
            .html((d) => {
            var xDate = self.xScale.invert(mouse[0]);
            var bisect = d3.bisector(function (d) {
                return d["date"];
            }).left;
            var idx = bisect(d.values, xDate);
            idx = idx - 1;
            if (d.values[idx]) {
                console.log(`line chart :: tool tip :: if value    ${idx}   ,
						${d.values[idx]}`);
                self.tooltip.style("min-width", "220px");
                self.tooltip.style("display", "block");
                // self.tooltip.style("padding", "10px 15px");
                index += 1;
                const values = index == 1
                    ? `<div class='multiLine-top'> ${d.values[idx].displayDate} </div>`
                    : ``;
                return `<div class = 'multiLine-tooltip'>${values}
					<div class='daily-info'> 
					<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:
					${d.values[idx].color}
					'></span><span class='multiLine-left'> 
					${d.values[idx].name}
					</span><span class = 'multiLine-right'> 
					${d.values[idx].count}
					</span> 
					</div></div>`;
            }
            else {
                self.tooltip.style("min-width", "0");
                self.tooltip.style("padding", "0");
            }
        });
    }
    updateTooltipContent(event, mouse) {
        var self = this;
        var dist = { x: 40, y: 40 };
        var m = d3.pointer(event, self.svg.node());
        self.scr.x = window.scrollX;
        self.scr.y = window.scrollY;
        m[0] += self.svgpos.x;
        m[1] += self.svgpos.y;
        self.tooltip.selectAll("div").remove();
        var index = 0;
        self.tooltip.style("right", "");
        self.tooltip.style("left", "");
        self.tooltip.style("bottom", "");
        self.tooltip.style("top", "");
        if (m[0] > self.scr.x + self.elementAttr.w / 2) {
            self.tooltip.style("right", (self.elementAttr.w - m[0] + dist.x) + "px");
        }
        else {
            self.tooltip.style("left", (m[0] + dist.x) + "px");
        }
        self.tooltip.style("bottom", (m[1] + dist.y) + "px");
        self.tooltip
            .style("display", "block")
            .style("font-size", 11.5)
            .style("z-index", "1000")
            .style("padding", "10px 15px")
            .style("min-width", "220px")
            .selectAll()
            .data(self.sourceData)
            .enter() // for each vehicle category, list out name and price of premium
            .append("div")
            .style("color", (d) => {
            return "#fff";
        })
            .style("font-size", 10)
            .html((d) => {
            let tipContainer = "";
            var xDate = self.xScale.invert(mouse[0]);
            var bisect = d3.bisector(function (d) {
                return d["date"];
            }).left;
            var idx = bisect(d.values, xDate);
            if (d.values[idx]) {
                index += 1;
                return ("<div class = 'multiLine-tooltip'>" +
                    (index == 1
                        ? "<div class='multiLine-top'>" +
                            d.values[idx].displayDate +
                            "</div>"
                        : "") +
                    "<div class='daily-info'>" +
                    "<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:" +
                    d.values[idx].color +
                    "'></span><span class='multiLine-left'>" +
                    d.values[idx].name +
                    "</span><span class = 'multiLine-right'>" +
                    d.values[idx].count +
                    "</span>" +
                    "</div></div>");
            }
            else {
                self.tooltip.style("display", "none");
            }
            return "";
        });
    }
}
D3MultilineNewChartComponent.ɵfac = function D3MultilineNewChartComponent_Factory(t) { return new (t || D3MultilineNewChartComponent)(); };
D3MultilineNewChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3MultilineNewChartComponent, selectors: [["lib-d3-multiline-new-chart"]], viewQuery: function D3MultilineNewChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$W, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart-new"], ["chart", ""]], template: function D3MultilineNewChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3MultilineNewChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-multiline-new-chart",
                templateUrl: "./d3-multiline-new-chart.component.html",
                styleUrls: ["./d3-multiline-new-chart.component.scss"]
            }]
    }], function () { return []; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

/* eslint-disable no-unused-vars */
const _c0$V = ["chart"];
class D3NegativeBarChartComponent {
    constructor(dataService, translate) {
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.sourceData = [];
        this.thresholdData = [];
        this.sData = [];
        this.showAnnotation = true;
        this.annotationText = "";
        this.hasNegative = false;
        this.showTrend = false;
        this.showCurrent = false;
        this.showPrevious = false;
        this.showOthers = false;
        this.showAvgBar = false;
        this.labelKeys = [];
        this.getStaticText = () => {
            this.translate.get('shared-lib.d3-components.negative-bar-chart').subscribe((res) => {
                this.labelKeys = res;
                this.draw();
            });
        };
    }
    set options(value) {
        if (!value) {
            return;
        }
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (!value || value.length === 0) {
            return;
        }
        this.sourceData = value.data;
        this.avgData = value.avgData;
        this.thresholdData = value.annotationData;
        this.showTrend = value.showTrend ? value.showTrend : this.showTrend;
        this.showCurrent = value.showCurrent ? value.showCurrent : false;
        this.showPrevious = value.showPrevious ? value.showPrevious : false;
        this.showOthers = value.showOthers ? value.showOthers : false;
        if (this.avgData && this.avgData.length > 0) {
            this.showAvgBar = true;
        }
        if (this.thresholdData && this.showAnnotation) {
            this.annotationText = this.getAnnotationText(this.thresholdData);
        }
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localized string here
            this.getStaticText();
        });
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    hasNegativeData() {
        this.sourceData.forEach((element) => {
            if (element.count < 0) {
                this.hasNegative = true;
            }
        });
    }
    createSvg() {
        if (!this.sourceData || this.sourceData.length === 0) {
            return;
        }
        this.hasNegativeData();
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg) {
            this.svg.remove();
        }
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr('transform', 'translate(0,' + (this.chartOptions.margin.top - 20) + ')');
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg.append('g').attr('transform', 'translate(' + 10 + ',' + 20 + ')');
        this.getxScale();
        this.getyScale();
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(() => {
            return '<div id="bi-tooltip line-chart"></div>';
        });
        this.svg.call(this.tip);
    }
    ngAfterViewInit() {
        this.dataService.getMagneticAppIsExpanded(this.unsubscribe$).subscribe((val) => {
            setTimeout(() => {
                // console.log("getMagneticAppIsExpanded", val);
                if (this.sourceData && this.sourceData.length > 0)
                    this.reDraw();
            }, 500);
        });
    }
    draw() {
        if (!this.sourceData || this.sourceData.length === 0) {
            return;
        }
        if (!this.labelKeys || this.labelKeys.length === 0) {
            return;
        }
        const dataLength = this.sourceData.length;
        const barWidth = this.setBarWidth(dataLength);
        const self = this;
        const keyValues = this.sourceData.map((d) => d.key);
        const y0 = Math.max(Math.abs(d3.min(this.sourceData, (d) => {
            return d.count;
        })), Math.abs(d3.max(this.sourceData, (d) => {
            return d.count;
        })));
        if (this.hasNegative) {
            if (this.showAvgBar) {
                let yKey = Math.max(-d3.min(this.sourceData, (d) => {
                    return d.count;
                }), d3.max(this.sourceData, (d) => {
                    return d.count;
                }));
                this.yScale = d3
                    .scaleLinear()
                    .domain([-yKey, yKey])
                    .range([this.height, 0])
                    .nice();
            }
            else {
                this.yScale = d3
                    .scaleLinear()
                    .domain([-y0 - y0 / 2, y0 + y0 / 2])
                    .range([this.height, 0])
                    .nice();
            }
        }
        else {
            this.yScale = d3
                .scaleLinear()
                .domain([0, y0 + y0 / 2])
                .range([this.height, 0])
                .nice();
        }
        let rangeValue = this.width;
        if (this.showAvgBar) {
            rangeValue = this.width - 80;
        }
        this.xScale = d3
            .scaleBand()
            .domain(this.sourceData.map((d) => d.key))
            .range([0, rangeValue])
            .padding(0.5);
        this.yAxis = d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-this.width);
        this.xAxis = d3
            .axisBottom(this.xScale)
            .scale(this.xScale)
            .tickValues(this.sourceData.filter((d, i) => {
            if (d.isTruncated) {
                return d.key.substr(0, 6) + "..";
            }
            return d.key;
        }));
        if (this.showTrend) {
            // ADDING TEXT FOR CURRENT, PREVIOUS AND TRENDING PERIOD
            const bgGroup = this.chart
                .append("g")
                .attr("class", "bg-layout")
                .attr('transform', 'translate(' + (this.chartOptions.margin.left + 35) + ',' + 0 + ')');
            const periodTextGroup = bgGroup
                .append("g")
                .attr("class", "monthly-trend-text");
            if (this.showPrevious) {
                periodTextGroup
                    .append("text")
                    .attr("class", "historical-text")
                    .attr("fill", "#F9F9F9")
                    .attr("x", this.xScale(keyValues[0]) - 25)
                    .attr("y", "-3")
                    .attr("fill", "#9E9EA2")
                    .text(this.labelKeys.prevPeriod);
                bgGroup
                    .append("rect")
                    .attr("fill", "#F9F9F9")
                    .attr("height", this.height)
                    .attr("width", "27")
                    .attr("x", this.xScale(keyValues[0]) - 15);
            }
            if (this.showOthers) {
                periodTextGroup
                    .append("text")
                    .attr("class", "historical-text")
                    .attr("fill", "#F9F9F9")
                    .attr("x", keyValues.length === 2
                    ? this.xScale(keyValues[0]) - 15
                    : this.width / 2 - Number(barWidth) * 3)
                    .attr("y", "-3")
                    .attr("fill", "#9E9EA2")
                    .text(this.labelKeys.trendPeriod);
            }
            if (this.showCurrent) {
                periodTextGroup
                    .append("text")
                    .attr("class", "historical-text")
                    .attr("fill", "#F9F9F9")
                    .attr("x", this.xScale(keyValues[keyValues.length - 1]) - 48)
                    .attr("y", "-3")
                    .attr("fill", "#9E9EA2")
                    .text(this.labelKeys.currentPeriod);
                bgGroup
                    .append("rect")
                    .attr("fill", "#F9F9F9")
                    .attr("height", this.height)
                    .attr("width", "27")
                    .attr("x", this.xScale(keyValues[keyValues.length - 1]) - 15);
            }
            // ENDS
        }
        const yAxisGroup = this.chart
            .append("g")
            .attr("class", "y axis")
            .attr("transform", 'translate(' + (this.showAvgBar ?
            this.chartOptions.margin.left + this.chartOptions.margin.left / 2
            : this.chartOptions.margin.left - 2) + ',' + 0 + ')');
        yAxisGroup.call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(`${(this.width + 35)}`)));
        this.chart
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", this.showAvgBar ? 0 : 0 - (this.chartOptions.margin.left - 15))
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .style("fill", "#1D3243")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
        this.chart
            .append("g")
            .attr("class", "grid")
            .attr("transform", 'translate(' + (this.showAvgBar
            ? this.chartOptions.margin.left + 23
            : this.chartOptions.margin.left + 6) + ',' + 0 + ')')
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(this.width + 35))
            .tickFormat(() => this.chartOptions.yAxisTickFormat));
        this.chart
            .append("line")
            .attr("y1", this.yScale(0))
            .attr("y2", this.yScale(0))
            .attr('x1', (this.showAvgBar ?
            this.chartOptions.margin.left + this.chartOptions.margin.left / 2 + 5
            : this.chartOptions.margin.left - 2))
            .attr('x2', this.width + 73)
            .style("stroke", this.chartOptions.anotationLineColor)
            .style("stroke-width", 2);
        // yGroup.append('text')
        //   .attr('class', 'yAxis-label')
        //   .attr('transform', 'rotate(-90)')
        //   .attr('y', 0 - this.chartOptions.margin.left)
        //   .attr('x', 0 - (this.height / 2))
        //   .attr('dy', '1em')
        //   .style('fill', '#1D3243')
        //   .style('text-anchor', 'middle')
        //   .text(this.chartOptions.yAxisLabel)
        this.chart
            .append("g")
            .attr("class", "annotation-group")
            .attr('transform', 'translate(' + (this.chartOptions.margin.left + 25) + ',' + this.yScale(0) + ')')
            .append("text")
            .attr("class", "annotation-text")
            .style("fill", "#DFA73E")
            .text(this.annotationText)
            .style("text-anchor", "middle")
            .attr("transform", `translate(0 , -5)`);
        const group = this.chart.append("g")
            .attr('transform', 'translate(' + (this.chartOptions.margin.left + 25) + ',' + 0 + ')');
        const xGroup = group
            .append("g")
            .attr("class", "x axis")
            .attr('transform', 'translate(' + 0 + ',' + (this.height) + ')');
        xGroup
            .append("text")
            .attr("class", "xAxis-label")
            .text(this.chartOptions.xAxisLabel)
            .style("fill", "#1D3243")
            .style("text-anchor", "middle")
            .attr('transform', 'translate(' + this.width / 2 + ',' + 40 + ')');
        if (this.showAvgBar) {
            const avgBarGroup = group
                .append("g")
                .attr("class", "avg-bar-group")
                .attr("transform", "translate(20,0)");
            avgBarGroup
                .selectAll(".bar")
                .data(this.avgData)
                .enter()
                .append("rect")
                .attr("fill", (d) => d.color)
                .attr("class", (d) => d.count < 0 ? "bar negative" : "bar positive")
                .attr("y", (d) => {
                return d.count === 0
                    ? this.yScale(Math.max(0, d.count) + 2)
                    : this.yScale(Math.max(0, d.count));
            })
                .attr("height", (d) => d.count === 0
                ? Math.abs(this.yScale(d.count) - this.yScale(0)) + 2
                : Math.abs(this.yScale(d.count) - this.yScale(0)))
                .attr("width", (d) => d.barWidth)
                .on("mouseover", function (d, i) {
                if (self.chartOptions.tooltipType ===
                    "impactAnalysisGroupLine") {
                    self.showImpactAnalysisGroupLineTooltip(d, i);
                }
                else {
                    self.showTooltip(d, i);
                }
                self.tip.show(d, this);
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
            avgBarGroup
                .append("text")
                .attr("class", "bar-value")
                .style("fill", this.avgData[0].textColor)
                .text(this.avgData[0].count)
                .attr("y", this.avgData[0].count < 0
                ? this.yScale(Math.min(0, this.avgData[0].count)) + 15
                : this.yScale(Math.max(0, this.avgData[0].count)) - 10)
                .attr("x", 25);
            avgBarGroup
                .append("line")
                .attr("y1", () => {
                if (this.avgData[0].count < 0) {
                    return this.yScale(this.avgData[0].count) - 1;
                }
                else if (this.avgData[0].count === 0) {
                    return this.yScale(this.avgData[0].count + 1);
                }
                else {
                    return this.yScale(this.avgData[0].count) + 1;
                }
            })
                .attr("y2", () => {
                if (this.avgData[0].count < 0) {
                    return this.yScale(this.avgData[0].count) - 1;
                }
                else if (this.avgData[0].count === 0) {
                    return this.yScale(this.avgData[0].count + 1);
                }
                else {
                    return this.yScale(this.avgData[0].count) + 1;
                }
            })
                // .attrs({
                // 	x1: this.avgData[0].barWidth,
                // 	x2: this.width,
                // 	stroke: this.avgData[0].color,
                // 	"stroke-width": 1
                // });
                .attr("x1", this.avgData[0].barWidth)
                .attr("x2", this.width)
                .attr("stroke", this.avgData[0].color)
                .attr("stroke-width", 1);
        }
        const barGroup = group
            .append("g")
            .attr("class", "bar-group")
            .attr("transform", this.showAvgBar ? "translate(100,0)" : "translate(0,0)");
        barGroup
            .selectAll(".bar")
            .data(this.sourceData)
            .enter()
            .append("rect")
            .attr("fill", (d) => d.color)
            .attr("class", (d) => d.count < 0 ? "bar negative" : "bar positive")
            .attr("y", (d) => {
            return this.showAvgBar && d.count === 0
                ? this.yScale(d.count) - 2
                : this.yScale(Math.max(0, d.count));
        })
            .attr('x', (d, i) => this.showAvgBar ? (this.xScale(d.key)) : (this.xScale(d.key) + 4))
            .attr("height", (d) => this.showAvgBar && d.count === 0
            ? Math.abs(this.yScale(d.count) - this.yScale(0)) + 2
            : Math.abs(this.yScale(d.count) - this.yScale(0)))
            .attr("width", barWidth)
            .on("mouseover", function (d, i, n) {
            if (self.chartOptions.tooltipType === "impactAnalysisGroupLine") {
                self.showImpactAnalysisGroupLineTooltip(d, i);
            }
            else {
                self.showTooltip(d, i);
            }
            self.tip.show(d, this);
        })
            .on("mouseout", function () {
            self.tip.hide();
        });
        const textGroup = group
            .append("g")
            .attr("class", "text-group")
            .attr("transform", this.showAvgBar ? "translate(100,0)" : "translate(0,0)");
        const valueGroup = textGroup.append("g").attr("class", "barValue");
        if (this.showAvgBar) {
            valueGroup
                .selectAll(".bar")
                .data(this.sourceData)
                .enter()
                .append("rect")
                .attr("y", (d) => {
                return d.count < 0 ? this.yScale(Math.min(0, d.count)) + 2 : this.yScale(Math.max(0, d.count)) - 20;
            })
                .attr("x", (d) => this.xScale(d.key))
                .attr("fill", "#ffffff")
                .attr("width", barWidth)
                .attr("height", 15);
        }
        valueGroup
            .selectAll(".bar")
            .data(this.sourceData)
            .enter()
            .append("text")
            .attr("class", "bar-value")
            .style("fill", (d) => d.textColor ? d.textColor : "#485967")
            .text((d) => {
            return this.showAvgBar ? d.count : d.count + d.suffix;
        })
            .attr("y", (d) => {
            return this.showAvgBar
                ? d.count < 0
                    ? (this.yScale(Math.min(0, d.count)) + 15)
                    : this.yScale(Math.max(0, d.count)) - 5
                : d.count < 0
                    ? (this.yScale(Math.min(0, d.count)) + 15)
                    : this.yScale(Math.max(0, d.count)) - 10;
        })
            .attr("x", (d) => this.showAvgBar
            ? d.count < 0
                ? this.xScale(d.key)
                : this.xScale(d.key)
            : this.xScale(d.key) - 5)
            .attr("fill", this.chartOptions.valueColor);
        if (!this.showAvgBar) {
            const xaxisTextGroup = group
                .append("g")
                .attr("class", "axis-group")
                .attr('transform', 'translate(' + 0 + ',' + (this.height + 20) + ')');
            xaxisTextGroup
                .selectAll(".bar")
                .data(this.sourceData)
                .enter()
                .append("text")
                .attr("class", "axis-value")
                .text((d) => {
                if (d.isTruncated) {
                    return d.key.substr(0, 6) + "..";
                }
                return d.key;
            })
                .attr("y", (d) => 0)
                .attr("x", (d) => {
                return d.key.length >= 6
                    ? self.xScale(d.key) - 9
                    : self.xScale(d.key) - 3;
            })
                .attr("fill", this.chartOptions.valueColor);
        }
    }
    showTooltip(value, i) {
        const self = this;
        let tipContainer = "";
        const suffix = i.suffix ? i.suffix : "";
        self.tip.html((d) => {
            tipContainer += '<div class="top-section"><div class="top-left">';
            tipContainer += '<div class="left-label">' + i.displayText + '</div>';
            tipContainer += '</div>';
            tipContainer += '<div class="top-right">' + i.count;
            if (suffix) {
                tipContainer += '<span class="suffix">' + suffix + '</span>';
            }
            tipContainer += '</div>';
            tipContainer += '</div>';
            return tipContainer;
        });
    }
    showImpactAnalysisGroupLineTooltip(d, i) {
        const self = this;
        let tipContainer = "";
        // const suffix = d.suffix ? d.suffix : "";
        self.tip.html((d) => {
            tipContainer += '<div class="top-section custom-tooltip"><div class="top-left">';
            tipContainer += '<div class="left-label">' + i.displayText + '</div>';
            tipContainer += '</div>';
            if (i.count > 0) {
                tipContainer += '<div class="top-right positive">' + i.count + i.suffix + '</div>';
            }
            else {
                tipContainer += '<div class="top-right negative">' + i.count + i.suffix + '</div>';
            }
            tipContainer += '</div>';
            tipContainer += '<div class="top-section custom-tooltip"><div class="top-left">';
            tipContainer += '<div class="left-label custom-tip-label">' + i.comparedToLabel + ' </div>';
            tipContainer += '<div class="left-label custom-tip-label">' + i.comparedToEventcount + ' </div>';
            tipContainer += '</div>';
            tipContainer += '<div class="top-right">';
            tipContainer += '<div class="left-label custom-tip-label">' + i.currentEventLabel + ' </div>';
            tipContainer += '<div class="left-label custom-tip-label">' + i.duringEventcount + ' </div>';
            tipContainer += '</div>';
            tipContainer += '</div>';
            return tipContainer;
        });
    }
    setBarWidth(Length) {
        if (this.showAvgBar) {
            return 25;
        }
        else {
            return 12;
        }
    }
    getxScale() {
        const keyValues = this.sourceData.map((d) => d.key);
        const self = this;
        let rangeValue = this.width;
        if (this.showAvgBar) {
            rangeValue = this.width - 80;
        }
        this.xScale = d3.scaleBand().domain(keyValues).range([0, rangeValue]);
    }
    getyScale() {
        this.yScale = d3
            .scaleLinear()
            .range([this.height, 0])
            .domain([
            0,
            d3.max(this.sData, (d) => {
                return d.count;
            })
        ])
            .nice();
    }
    reDraw() {
        this.createSvg();
        this.draw();
    }
    getAnnotationText(data) {
        let annotationText = "";
        // solved lint issue - Expected a 'for-of' loop instead of a 'for' loop with this simple iteration
        for (const d of data) {
            if (d.annotationText) {
                annotationText = d.annotationText;
            }
        }
        return annotationText;
    }
}
D3NegativeBarChartComponent.ɵfac = function D3NegativeBarChartComponent_Factory(t) { return new (t || D3NegativeBarChartComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
D3NegativeBarChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3NegativeBarChartComponent, selectors: [["lib-d3-negative-bar-chart"]], viewQuery: function D3NegativeBarChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$V, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart", "negative-bar-chart"], ["chart", ""]], template: function D3NegativeBarChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3NegativeBarChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-negative-bar-chart",
                templateUrl: "./d3-negative-bar-chart.component.html",
                styleUrls: ["./d3-negative-bar-chart.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

class D3NewStackedBarChartOptions {
    constructor() {
        this.margin = { top: 20, right: 30, bottom: 30, left: 30 };
        this.paddingInner = 0.9;
        this.rangeColors = ["#1777c3", "#ff5df3", "#1f776f"];
        this.toolTipIcons = {
            SMS: "#1777c3",
            Email: "#ff5df3",
            "Push Notification": "#1f776f"
        };
        this.isXAxisTime = false;
        this.showLegend = false;
        this.tooltip = {
            isEnable: true,
            className: "",
            suffix: ""
        };
    }
}

/* eslint-disable @typescript-eslint/no-unsafe-return */
const _c0$U = ["stacked_chart"];
class D3NewCustomStackedBarChartComponent {
    constructor() {
        this.keys = [];
    }
    ngOnInit() {
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    set options(value) {
        this.chartOptions = value || new D3NewStackedBarChartOptions();
    }
    set data(value) {
        if (isEmpty(value))
            return;
        this.sourceData = value;
    }
    // ngOnInit() {}
    /**
     * A callback method
     * @param changes
     */
    ngOnChanges(changes) {
        const { currentValue } = changes.data;
        if (!currentValue)
            return;
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0 && this.sourceData && Object.keys(this.sourceData).length > 0) {
            this.initSvg();
            this.drawChart();
        }
    }
    /**
     * Initialization of the svg
     */
    initSvg() {
        this.element = this.chartContainer.nativeElement;
        if (!this.chartOptions)
            this.chartOptions = new D3NewStackedBarChartOptions();
        /*this.sourceData = {
      keys: ["sms", "push", "email"],
      values: [{
        "name": "2019-10-02",
        "sms": 2,
        "push": 2,
        "email": "0",
        "count": 4
      },
      {
        "name": "2019-10-03",
        "sms": 1,
        "push": 1,
        "email": 0,
        "count": 2
      },
      {
        "name": "2019-10-04",
        "sms": 1,
        "push": 0,
        "email": 0,
        "count": 1
      }]
    }*/
        if (this.chartOptions.isXAxisTime) {
            this.parseDate = d3.timeParse("%Y-%m-%dT%H:%M:%S");
        }
        else {
            this.parseDate = d3.timeParse("%Y-%m-%d");
        }
        const { margin, rangeColors, paddingInner } = this.chartOptions;
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(function () {
            return "<div id='bi-tooltip line-chart'></div>";
        });
        if (this.svg) {
            this.svg.remove();
        }
        const svg = d3.select(this.element).append("svg");
        this.svg = svg.attr("width", "100%").attr("height", "100%");
        this.width = this.element.clientWidth - margin.left - margin.right;
        this.height = this.element.clientHeight - margin.top - margin.bottom;
        this.g = this.svg.append("g");
        this.g.attr("transform", `translate(${margin.left},${margin.top})`);
        this.svg.call(this.tip);
        // set x scale
        if (paddingInner)
            this.x = d3
                .scaleBand()
                .range([0, this.width])
                .padding(paddingInner);
        else if (this.chartOptions.barWidth)
            this.x = d3
                .scaleBand()
                .range([0, this.width])
                .padding(this.chartOptions.barWidth % 7);
        else
            this.x = d3
                .scaleBand()
                .range([0, this.width])
                .padding(0.5);
        // set y scale
        this.y = d3.scaleLinear().rangeRound([this.height, 0]);
        this.barColors = d3.scaleOrdinal().range(rangeColors);
        //var series = d3.keys(this.sourceData.keys);
        //  this.parseDate = d3.timeParse("%Y-%m-%d"),
        this.keys = this.sourceData.keys;
        // this.sourceData["values"].sort((a, b) => b.date - a.date);
        this.x.domain(this.sourceData["values"].map(({ date }) => this.parseDate(date)));
        this.y
            .domain([
            0,
            d3.max(this.sourceData["values"], function (d) {
                return d["count"];
            })
        ])
            .nice();
        this.barColors.domain(this.keys);
        //   var keys = this.date.columns.slice(1);
    }
    drawChart() {
        const self = this;
        const dateArray = [];
        this.dataLength = this.sourceData["values"].length;
        this.g
            .append("g")
            .attr("class", "grid")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left - 15)} 
					,0)`)
            .call(d3.axisLeft(this.y).scale(this.y).ticks(3).tickSize(-this.width));
        if (this.chartOptions.barWidth) {
            this.g
                .append("g")
                .selectAll("g")
                .data(d3.stack().keys(this.keys)(this.sourceData["values"]))
                .enter()
                .append("g")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left - 5)} 
						,0)`)
                .attr("fill", (d) => this.barColors(d.key))
                .selectAll("rect")
                .data((d) => d)
                .enter()
                .append("rect")
                .attr("x", (d) => this.x(this.parseDate(d.data.date)))
                .attr("y", (d) => this.y(d[1]))
                .attr("height", (d) => this.y(d[0]) - this.y(d[1]) - 1)
                .attr("width", this.chartOptions.barWidth)
                .on("mouseover", function (d, i) {
                self.showStackedToolTip(d, i, self.keys, self.sourceData["values"], self.chartOptions.toolTipIcons);
                self.tip.show(d, this);
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
        }
        else {
            this.g
                .append("g")
                .selectAll("g")
                .data(d3.stack().keys(this.keys)(this.sourceData["values"]))
                .enter()
                .append("g")
                .attr("transform", `translate(
						${(this.chartOptions.margin.left - 5)} 
						,0)`)
                .attr("fill", (d) => this.barColors(d.key))
                .selectAll("rect")
                .data((d) => d)
                .enter()
                .append("rect")
                .attr("x", (d) => this.x(this.parseDate(d.data.date)))
                .attr("y", (d) => this.y(d[1]))
                .attr("height", (d) => this.y(d[0]) - this.y(d[1]))
                .attr("width", this.x.bandwidth())
                .on("mouseover", function (d, i) {
                self.showStackedToolTip(d, i, self.keys, self.sourceData["values"], self.chartOptions.toolTipIcons);
                self.tip.show(d, this);
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
        }
        this.g.selectAll(".grid .tick line").attr("stroke", "#dedede");
        // if (this.dataLength > 25) {
        // 	const sortedTicks = this.preparexAxisTicks();
        // 	this.xAxis = d3
        // 		.axisBottom(this.x)
        // 		// .tickFormat(d3.timeFormat("%d %b"))
        // 		.scale(this.x)
        // 		.tickValues(sortedTicks)
        // 		.tickFormat(d3.timeFormat("%d %b"));
        // } else {
        this.xAxis = d3
            .axisBottom(this.x)
            .tickFormat(d3.timeFormat("%d %b"))
            .scale(this.x);
        this.g
            .append("g")
            .attr("class", "x-axis")
            .attr("transform", `translate(30, ${this.height})`)
            .attr("text-anchor", "middle")
            .attr("y", 5)
            .call(this.xAxis);
        this.g
            .append("g")
            .attr("class", "y-axis")
            .attr("transform", `translate(
					${this.chartOptions.margin.left - 15} 
					,0)`)
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - this.chartOptions.margin.left - 10)
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .style("fill", "#1D3243")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
        if (this.chartOptions.showLegend) {
            const legend = this.g
                .append("g")
                .attr("font-family", "ciscoSans")
                .attr("font-size", 11)
                .attr("text-anchor", "end")
                .selectAll("g")
                .data(this.keys.slice().reverse())
                .enter()
                .append("g")
                .attr("transform", function (d, i) {
                return `translate(0,${(i * 20)})`;
            });
            legend
                .append("rect")
                .attr("x", this.width - 19)
                .attr("width", 19)
                .attr("height", 19)
                .attr("fill", this.barColors);
            legend
                .append("text")
                .attr("x", this.width - 24)
                .attr("y", 9.5)
                .attr("dy", "0.32em")
                .text(function (d) {
                return d;
            });
        }
    }
    preparexAxisTicks() {
        // const ticks = this.sourceData.map(function (d) {
        // 	return d.date;
        // });
        const self = this;
        const tickValues = this.sourceData["values"];
        const ticks = tickValues.map(function (d) {
            return d.date;
        });
        // Object.keys(this.sourceData).map(function(key, index) {
        // 	if(key === "values"){
        // 		const name = self.sourceData[key].name
        // 		ticks.push(name) 
        // 	}			
        // });
        for (let i = 0; i < ticks.length; i++) {
            ticks.splice(i + 1, 5);
        }
        return ticks;
    }
    showStackedToolTip(d, i, keys, values, icons) {
        const self = this;
        const suffix = i.data.suffix ? i.data.suffix : "";
        let tipContainer = "";
        self.tip.html(() => {
            tipContainer += "<div class = 'multiLine-tooltip'>";
            tipContainer += `<div class='multiLine-top'>
				${i.data.displayDate}
				</div>`;
            keys.forEach((key) => {
                tipContainer += "<div class='daily-info'>";
                tipContainer += `<span style='display: table;padding: 6px;border-radius: 3px;background-color:
				${icons[key]}'></span><span class='multiLine-left'>
				${key}</span><span class = 'multiLine-right'>
				${i.data[key]}
				</span><span class='suffix'>${suffix}</span>`;
                tipContainer += "</div>";
            });
            tipContainer += "</div>";
            return tipContainer;
        });
    }
}
D3NewCustomStackedBarChartComponent.ɵfac = function D3NewCustomStackedBarChartComponent_Factory(t) { return new (t || D3NewCustomStackedBarChartComponent)(); };
D3NewCustomStackedBarChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3NewCustomStackedBarChartComponent, selectors: [["lib-d3-new-custom-stacked-bar-chart"]], viewQuery: function D3NewCustomStackedBarChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$U, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [[1, "d3-chart-new"], ["stacked_chart", ""]], template: function D3NewCustomStackedBarChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [".axis[_ngcontent-%COMP%]   .domain[_ngcontent-%COMP%]{display:none}.axis-x[_ngcontent-%COMP%], .axis-y[_ngcontent-%COMP%]{color:#333;font-family:ciscoSans;font-size:11px}.d3-stacked-chart[_ngcontent-%COMP%]{height:100%;font-family:ciscoSans}g.tick[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{stroke:#dedede}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3NewCustomStackedBarChartComponent, [{
        type: Component,
        args: [{
                selector: 'lib-d3-new-custom-stacked-bar-chart',
                templateUrl: './d3-new-custom-stacked-bar-chart.component.html',
                styleUrls: ['./d3-new-custom-stacked-bar-chart.component.scss']
            }]
    }], function () { return []; }, { chartContainer: [{
            type: ViewChild,
            args: ["stacked_chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

class D3PieChartOptions {
    constructor() {
        this.margin = 20;
        this.width = 100;
        this.rangeColors = ["#5783D6", "#BB6DD9", "#C2AE59", "#5B6470"];
        this.bgColor = "#eaeaea";
        this.tooltip = {
            isEnable: true,
            className: "",
            suffix: ""
        };
    }
}

/* eslint-disable @typescript-eslint/no-this-alias */
const _c0$T = ["pie_chart"];
class D3PieChartComponent {
    // constructor() {}
    set options(value) {
        this.chartOptions = value || new D3PieChartOptions();
    }
    set data(value) {
        if (isEmpty(value))
            return;
        this.sourceData = value;
    }
    /**
     * A callback method
     * @param changes
     */
    ngOnChanges(changes) {
        const { currentValue } = changes.data;
        if (!currentValue)
            return;
        this.initSvg();
        this.drawChart();
    }
    /**
     * Initialization of the svg
     */
    initSvg() {
        this.element = this.chartContainer.nativeElement;
        if (!this.chartOptions) {
            this.chartOptions = new D3PieChartOptions();
        }
        const { clientHeight } = this.element;
        const { tooltip, margin, width, rangeColors } = this.chartOptions;
        if (this.svg) {
            this.svg.remove();
        }
        this.svg = d3
            .select(this.element)
            .append("svg")
            .attr("width", width)
            .attr("height", clientHeight);
        this.g = this.svg.append("g").attr("transform", `translate(
					${(width / 2)},${(clientHeight / 2)})`);
        this.g.append("defs");
        this.color = d3.scaleOrdinal().range(rangeColors);
        this.pie = d3.pie().padAngle(0.02);
        /* this.pie = d3.pie()
       .sort(null)
       .value((d: any) => d.value);
 */
        this.outerRadius = Math.min(width, clientHeight) / 2;
        //  this.outerRadius = this.height / 2 - 20;
        const innerRadius = 0;
        this.arc = d3
            .arc()
            .padRadius(this.outerRadius - margin)
            .innerRadius(innerRadius);
        /* this.arc = d3.arc()
       .outerRadius(this.radius - margin)
 
     this.arcOnHover = d3.arc()
       .outerRadius(this.radius * 0.08)*/
        /* this.pie = d3.pie()
       .sort(null)
       .value((d: any) => d.value);*/
        // if (tooltip.isEnable) {
        // }
        if (tooltip.isEnable) {
            this.tip = d3.select("body").append("div")
                .attr("class", `d3-donut-tooltip ${this.chartOptions.tooltip.className}`)
                .style("opacity", 0);
        }
    }
    /**
     * Draw Pie Chart in the svg
     */
    drawChart() {
        const self = this;
        const gradients = this.g
            .select("defs")
            .selectAll("radialGradient")
            .data(this.pie(this.sourceData));
        const radialGradient = gradients
            .enter()
            .append("radialGradient")
            .attr("gradientUnits", "userSpaceOnUse")
            .attr("id", function (d, i) {
            return `grad${+i}`;
        })
            .attr("cx", 0)
            .attr("cy", 0)
            .attr("r", 90);
        radialGradient
            .append("stop")
            .attr("offset", "0%")
            .style("stop-opacity", function () {
            return 1;
        })
            .style("stop-color", function (d, i) {
            return d3.rgb(self.color(i)).darker(0.2);
        });
        radialGradient
            .append("stop")
            .attr("offset", "90%")
            .style("stop-opacity", function () {
            return 0.5;
        })
            .style("stop-color", function (d, i) {
            return d3.rgb(self.color(i)).darker(0.2);
        });
        radialGradient
            .append("stop")
            .attr("offset", "100%")
            .style("stop-opacity", function () {
            return 1;
        })
            .style("stop-color", function (d, i) {
            return d3.rgb(self.color(i)).darker(0.5);
        });
        this.g
            .selectAll("path")
            .data(this.pie(self.sourceData))
            .enter()
            .append("path")
            .each(function (d) {
            d.outerRadius = self.outerRadius - 5;
        })
            .attr("d", this.arc)
            //.attr("fill", function (d, i) { return "url(#grad" + i + ")"; })
            .style("fill", function (d, i) {
            return `url(#grad${+i}`;
        })
            .style("stroke", function (d, i) {
            return d3.rgb(self.color(i));
        })
            .on("mouseover", self.arcTween(self.outerRadius, 0))
            .on("mouseout", self.arcTween(self.outerRadius - 5, 150));
        // .ease(d3.easeCircleInOut)
        //  .duration(2000)
    }
    arcTween(outerRadius, delay) {
        const self = this;
        return function () {
            d3.select(this)
                .transition()
                .delay(delay)
                .attrTween("d", function (d) {
                console.log("arcTween :: ", d);
                const i = d3.interpolate(d["outerRadius"], outerRadius);
                return function (t) {
                    d["outerRadius"] = i(t);
                    return self.arc(d);
                };
            });
        };
    }
}
D3PieChartComponent.ɵfac = function D3PieChartComponent_Factory(t) { return new (t || D3PieChartComponent)(); };
D3PieChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3PieChartComponent, selectors: [["lib-d3-pie-chart"]], viewQuery: function D3PieChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$T, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [[1, "d3-pie-chart"], ["pie_chart", ""]], template: function D3PieChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [".d3-pie-chart[_ngcontent-%COMP%]{height:100%;float:left}.d3-arc[_ngcontent-%COMP%]   text[_ngcontent-%COMP%]{text-anchor:middle}.d3-arc[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke-width:1.5px;transition:fill .25s linear;transition-delay:.15s}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3PieChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-pie-chart",
                templateUrl: "./d3-pie-chart.component.html",
                styleUrls: ["./d3-pie-chart.component.scss"]
            }]
    }], null, { chartContainer: [{
            type: ViewChild,
            args: ["pie_chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

class D3StackedBarChartOptions {
    constructor() {
        this.outerPadding = 0;
        this.margin = { top: 20, right: 30, bottom: 20, left: 30 };
        this.rangeColors = ["#1777c3", "#ff5df3", "#1f776f"];
        this.toolTipIcons = {
            SMS: "#1777c3",
            Email: "#ff5df3",
            "Push Notification": "#1f776f"
        };
        this.isXAxisTime = false;
        this.showLegend = false;
        this.valueColor = "#485967";
        this.tooltip = {
            isEnable: true,
            className: "",
            suffix: ""
        };
    }
}

/* eslint-disable prefer-const */
const _c0$S = ["stacked_chart"];
class D3RightnowStackedbarComponent {
    constructor() {
        this.keys = [];
        this.readableNumber = (value, decimalPoint) => {
            if (value === null) {
                return null;
            }
            if (value === 0) {
                return "0";
            }
            decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
            let numCount = value.toPrecision(2).split("e"), // get power
            noOfK = numCount.length === 1
                ? 0
                : Math.floor(Math.min(numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
            dividedValue = noOfK < 1
                ? value.toFixed(0 + decimalPoint)
                : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
            finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
            suffix = finalValue + ["", "K", "M", "B", "T"][noOfK]; // append power
            return suffix;
        };
        window.addEventListener("resize", this.reDraw.bind(this));
    }
    set options(value) {
        this.chartOptions = value || new D3StackedBarChartOptions();
    }
    set data(value) {
        if (isEmpty(value))
            return;
        this.sourceData = value;
        this.numSections = this.sourceData.length;
        if (this.tip) {
            this.tip.hide();
        }
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.initSvg();
            this.drawChart();
        }
    }
    reDraw() {
        // this.chartContainer.nativeElement.remove()
        // if (this.tip) {
        // 	this.tip.remove();
        // }
        if (this.sourceData && this.sourceData.length > 0) {
            this.initSvg();
            this.drawChart();
        }
    }
    ngOnInit() {
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => e["style"].opacity = 0);
        });
        // if (this.tip) {
        // 	this.tip.remove();
        // }
    }
    ngOnChanges(changes) {
        let { currentValue } = changes.data;
        if (!currentValue)
            return;
        if (this.tip) {
            this.tip.hide();
        }
        this.numSections = this.sourceData.length;
        this.initSvg();
        this.drawChart();
    }
    // }
    /**
     * Initialization of the svg
     */
    initSvg() {
        this.element = this.chartContainer.nativeElement;
        if (!this.chartOptions)
            this.chartOptions = new D3StackedBarChartOptions();
        // this.sourceData = {
        //   keys: ["sms", "push", "email"],
        //   values: [{
        //     "name": 'A',
        //     "sms": 2,
        //     "push": 2,
        //     "email": "0",
        //     "count": 4
        //   }]
        // } 
        let { clientWidth, clientHeight } = this.element;
        let { margin, paddingInner } = this.chartOptions;
        if (!this.chartOptions.margin)
            this.chartOptions.margin = { top: 20, right: 30, bottom: 20, left: 30 };
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(function () {
            return "<div id='bi-tooltip line-chart'></div>";
        });
        if (this.svg) {
            this.svg.remove();
        }
        let svg = d3.select(this.element).append("svg");
        this.svg = svg.attr("width", "100%").attr("height", "100%");
        this.width = this.element.clientWidth - margin.left - margin.right;
        this.height = this.element.clientHeight - margin.top - margin.bottom;
        this.g = this.svg.append("g");
        this.g.attr("transform", `translate(
				${(margin.left + 10)},${margin.top})`);
        this.svg.call(this.tip);
        //set x scale
        if (paddingInner)
            this.x = d3
                .scaleBand()
                .range([0, this.width])
                .padding(paddingInner);
        else if (this.chartOptions.barWidth)
            this.x = d3
                .scaleBand()
                .range([0, this.width])
                .padding(this.chartOptions.barWidth % 7);
        else
            this.x = d3.scaleBand().range([0, this.width]).padding(0.1);
        this.x.domain(this.sourceData[0]["values"].map(({ name }) => name));
        // set y scale
        this.y = d3.scaleLinear().rangeRound([this.height, 0]);
        this.y
            .domain([
            0,
            d3.max(this.sourceData, function (d) {
                return d3.max(d["values"], function (obj) {
                    return parseFloat(obj["count"]) > 10
                        ? parseFloat(obj["count"])
                        : 10;
                });
            })
        ])
            .nice();
        //grid lines
        this.g
            .append("g")
            .attr("class", "grid")
            .attr("transform", `translate(
						${(this.chartOptions.margin.left - 15)},0)`)
            .call(d3
            .axisLeft(this.y)
            .scale(this.y)
            .tickSize(-this.width)
            .tickFormat((d) => this.setYaxis(d)));
        //yAxis Label
        this.g
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - (+`${(this.chartOptions.margin.left + 10)}`))
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .style("fill", "#000000")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
    }
    getSectionSpacing() {
        let totalBarWidth = 0;
        this.sourceData.forEach((section) => {
            let bars = section.values;
            let barSpacing = section.barSpacing
                ? section.barSpacing
                : this.chartOptions.barSpacing;
            let barWidth = section.barWidth
                ? section.barWidth
                : this.chartOptions.barWidth;
            if (section.type !== "average")
                barWidth = section.barWidth
                    ? section.barWidth
                    : this.chartOptions.barWidth * 3;
            totalBarWidth += this.getSectionWidth(bars, barWidth, barSpacing);
        });
        let remainingWidth = this.width - this.chartOptions.outerPadding * 2 - totalBarWidth;
        let gSpacing = 0;
        gSpacing = Math.floor(remainingWidth / (this.numSections - 1));
        return Math.max(this.chartOptions.sectionSpacing, gSpacing);
    }
    getSectionWidth(bars, barWidth, barSpacing) {
        return bars.length * barWidth + (bars.length - 1) * barSpacing;
    }
    setYaxis(d) {
        if (this.chartOptions.setReadableNumber) {
            return (this.readableNumber(d, 1) + this.chartOptions.yAxisTickFormat);
        }
        else {
            return `${(d + this.chartOptions.yAxisTickFormat)}`;
        }
    }
    drawChart() {
        let self = this;
        let sectionSpacing = this.getSectionSpacing();
        let sectionGroup = this.g.append("g").attr("class", "section");
        let xPos = this.chartOptions.outerPadding;
        let enableLocAdjustment = false;
        let adjustLocBar = false;
        // if (!this.chartOptions) {
        // 	return;
        // }
        this.sourceData.forEach((section) => {
            let bars = section.values;
            let barSpacing = section.barSpacing
                ? section.barSpacing
                : this.chartOptions.barSpacing;
            let barWidth = section.barWidth
                ? section.barWidth
                : this.chartOptions.barWidth;
            let sectionWidth = this.getSectionWidth(bars, barWidth, barSpacing);
            let barGroup = sectionGroup.append("g");
            this.keys = section.keys;
            let benchmarkDataCount = 0;
            if (section.dataType == "benchmark") {
                benchmarkDataCount = section.values.length;
                if (benchmarkDataCount <= 4)
                    enableLocAdjustment = true;
            }
            if (section.barPlacing || section.dataType == "group") {
                if (enableLocAdjustment)
                    adjustLocBar = true;
            }
            if (adjustLocBar) {
                if (section.alignPosition === "center")
                    xPos = xPos / 2 + sectionWidth - section.barSpacing;
                else
                    xPos = xPos / 2 + section.barWidth;
            }
            //Bar colors
            this.barColors = d3.scaleOrdinal().range(section.values[0].color);
            this.barColors.domain(this.keys);
            if (section.barPlacing) {
                sectionGroup.attr("transform", `translate(
							${(this.chartOptions.margin.left + 45)},0)`);
            }
            let tlXPos = xPos;
            console.log("::::: Refreshed");
            barGroup
                .selectAll("g")
                .data(d3.stack().keys(this.keys)(bars))
                .enter()
                .append("g")
                .attr("fill", (d) => this.barColors(d.key))
                .selectAll("rect")
                .data((d) => d)
                .enter()
                .append("rect")
                .attr("x", xPos)
                .attr("y", (d) => this.y(d[1]))
                .attr("height", (d) => this.y(d[0]) - this.y(d[1]))
                .attr("width", section.barWidth)
                .on("mouseover", function (d) {
                if (section.customTooltip) {
                    self.showCustomStackedToolTip(section.keys, bars[0].displayCnt, bars[0].toolTipIcons, bars[0].tooltTipLabels);
                }
                else {
                    self.showStackedToolTip(section.keys, bars[0].displayCnt, bars[0].toolTipIcons);
                }
                self.tip.show(d, this);
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
            if (this.chartOptions.showValue)
                this.drawValue(bars, barGroup, tlXPos, section.barWidth);
            xPos += sectionSpacing;
        });
        this.g
            .append("g")
            .attr("class", "x-axis")
            .attr("transform", `translate(30, ${this.height})`)
            .attr("text-anchor", "middle")
            .attr("y", 5)
            .call(d3.axisBottom(this.x).scale(this.x));
    }
    showStackedToolTip(keys, values, icons) {
        let self = this;
        let tipContainer = "";
        self.tip.html(() => {
            tipContainer += "<div class = 'multiLine-tooltip'>";
            keys.forEach((key) => {
                tipContainer += "<div class='daily-info'>";
                tipContainer += `<span style='display: table; margin:10px; padding: 2px;border-radius: 50%;width: 10px; height: 10px;background-color:
					${icons[key]} 
					'></span><span class='stacked-left'>
					${values[key]}
					</span><span class = 'stacked-left'  style='text-align:left'>
					${key}
					</span>`;
                tipContainer += "</div>";
            });
            tipContainer += "</div>";
            return tipContainer;
        });
    }
    showCustomStackedToolTip(keys, values, icons, tooltTipLabels) {
        let self = this;
        let tipContainer = "";
        self.tip.html(() => {
            tipContainer += "<div class = 'multiLine-tooltip'>";
            keys.forEach((key) => {
                tipContainer += "<div class='daily-info'>";
                tipContainer += `<span style='display: table; margin:10px; padding: 2px;border-radius: 50%;width: 10px; height: 10px;background-color:
					${icons[key]} 
					'></span><span class='stacked-left'>
					${values[key]}
					</span><span class = 'stacked-left'  style='text-align:left'>
					${tooltTipLabels[key]}
					</span>`;
                tipContainer += "</div>";
            });
            tipContainer += "</div>";
            return tipContainer;
        });
    }
    drawValue(value, bar, x, barWidth) {
        let valueGroup = bar.append("g").attr("class", "barValue");
        valueGroup.append("rect")
            // .attrs({
            // 	x: x - 5,
            // 	y: this.y(value[0].count) - 25,
            // 	width: +barWidth + 10,
            // 	height: 23,
            // 	fill: "#fff"
            // });
            .attr("x", x - 5)
            .attr("y", this.y(value[0].count) - 25)
            .attr("width", barWidth + 10)
            .attr("height", 23)
            .attr("fill", "#fff");
        valueGroup
            .append("text")
            // .attrs({
            // 	x: +x + barWidth / 2,
            // 	y: this.y(value[0].count) - 5,
            // 	"text-anchor": "middle",
            // 	class: "valuesOnTop",
            // 	fill: this.chartOptions.valueColor
            // })
            .attr("x", x + barWidth / 2)
            .attr("y", this.y(value[0].count) - 5)
            .attr("text-anchor", "middle")
            .attr("class", "valuesOnTop")
            .attr("fill", this.chartOptions.valueColor)
            .text(() => this.setBarValue(value));
    }
    setBarValue(count) {
        if (this.chartOptions.setReadableNumber) {
            if (count.thresholdCount)
                return this.readableNumber(count.thresholdCount, 0);
            else
                return this.readableNumber(count[0].count, 0);
        }
        else {
            return count.thresholdCount ? count.thresholdCount : count[0].count;
        }
    }
    wrap(text, width) {
        text.each(function () {
            let text = d3.select(this), words = text.text().split("~").reverse(), word, line = [], lineNumber = 0, lineHeight = 1, // ems
            x = text.attr("x"), y = text.attr("y"), dy = 1.1, tspan = text
                .text(null)
                .append("tspan")
                .attr("x", x)
                .attr("y", y)
                .attr("dy", `${dy}em`);
            while ((word = words.pop())) {
                line.push(word);
                tspan.text(line.join(" "));
                if (tspan.node().getComputedTextLength() > width) {
                    line.pop();
                    tspan.text(line.join(" "));
                    line = [word];
                    (lineHeight = 1.1), // ems
                        (tspan = text
                            .append("tspan")
                            .attr("x", x)
                            .attr("y", y)
                            .attr("dy", String((lineNumber += 1) * lineHeight + dy) +
                            "em")
                            .text(word));
                }
            }
        });
    }
}
D3RightnowStackedbarComponent.ɵfac = function D3RightnowStackedbarComponent_Factory(t) { return new (t || D3RightnowStackedbarComponent)(); };
D3RightnowStackedbarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3RightnowStackedbarComponent, selectors: [["lib-d3-rightnow-stackedbar"]], viewQuery: function D3RightnowStackedbarComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$S, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [[1, "d3-chart"], ["stacked_chart", ""]], template: function D3RightnowStackedbarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3RightnowStackedbarComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-rightnow-stackedbar",
                templateUrl: "./d3-rightnow-stackedbar.component.html",
                styleUrls: ["./d3-rightnow-stackedbar.component.scss"]
            }]
    }], function () { return []; }, { chartContainer: [{
            type: ViewChild,
            args: ["stacked_chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

class D3SankeyDiagramV2ChartOptions {
    constructor() {
        this.margin = { top: 30, right: 180, bottom: 90, left: 130 };
        this.nodeWidth = 58;
        this.nodePadding = 0;
        this.pathWidth = 2;
    }
}

const _c0$R = ["sankey_diagram"];
//declare var sankey: any;
class D3SankeyDiagramV2Component {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor(dataService, translate) {
        this.dataService = dataService;
        this.translate = translate;
        this.padding = 40;
        this.marginLeft = 30;
        this.marginRight = 30;
        this.cameFromFocusNodeHeight = 0;
        this.nodePadding = 20;
        this.wentToFocusNodeHeight = 0;
        this.unsubscribe$ = new Subject();
        this.labelKeys = [];
        /*drawPathLeavingDiagram(link) {
            const x0 = parseInt(link.source.x) + parseInt(link.source.width),
                x1 = x0 + link.source.width / 4,
                x2 = x1 + link.source.width / 2,
                y0 =
                    parseInt(link.source.y) +
                    parseInt(link.sourceY) +
                    parseInt(link.thickness) / 2,
                y1 = y0 - link.source.width / 2,
                rx = link.source.width / 2,
                ry = link.source.width / 2;
            return (
                "M" +
                x0 +
                "," +
                y0 +
                "L" +
                x1 +
                "," +
                y0 +
                "A" +
                rx +
                "," +
                ry +
                "," +
                0 +
                "," +
                0 +
                "," +
                0 +
                "," +
                x2 +
                "," +
                y1 +
                "V" +
                0
            );
        }*/
        /**
         * Draw Donut Chart in the svg
         */
        this.drawChart = () => {
            const self = this;
            // add in the links
            const link = this.svg
                .append("g")
                .selectAll(".link")
                .data(this.sourceData.links)
                .enter()
                .append("path")
                .attr("class", "link")
                .attr("d", function link(d) {
                return `M${d.source.x1},${Math.round(d.source.y0) + (d.source.y1 - Math.round(d.source.y0)) / 2}C${(d.source.x0 + d.target.x1) / 2},${d.target.y1 / 2} ${(d.source.x0 + d.target.x1) / 2},${d.source.y1 / 2} ${d.target.x0},${d.target.y0 + ((d.target.y1 - d.target.y0) / 2)}`;
            })
                .style("stroke-width", function (d) {
                return Math.max(1, d.dy);
            })
                .attr("stroke", (d) => {
                return d.focusColor;
            })
                // .sort((a, b) => { return b.y1 - a.y1 });
                .sort(null);
            // add the link titles
            /*link.append('title')
          .text((d) => {
            return d.source.name + ' → ' +
              d.target.name + '\n' + self.format(d.value);
          });*/
            // add in the nodes
            const node = this.svg
                .append("g")
                .selectAll(".node")
                .data(this.sourceData.nodes)
                .enter()
                .append("g")
                .attr("class", "node")
                .attr("transform", (d) => {
                if (d.focus && d.path == "from") {
                    self.cameFromFocusNodeHeight = d.percentage;
                }
                if (d.focus && d.path == "to") {
                    self.wentToFocusNodeHeight = d.percentage;
                }
                if (d.width) {
                    return ("translate(" +
                        String(d.x0 -
                            (d.width -
                                (this.sankeyObj.nodeWidth() + 15))) +
                        "," +
                        String(d.y0) +
                        ")");
                }
                else {
                    return ("translate(" + String(d.x0) + "," + String(d.y0) + ")");
                }
            })
                .call(d3
                .drag()
                .subject((d) => {
                return d;
            })
                .on("start", function () {
                this.parentNode.appendChild(this);
            })
            // .on('drag', this.dragmove)
            );
            // add the rectangles for the nodes
            node.append("rect")
                .filter(function (d) { return d.selected === false; })
                .attr("height", (d) => d.selected
                ? parseInt(d.y1)
                : d.y1 - d.y0 < 10
                    ? 10
                    : (parseInt(d.y1) - parseInt(d.y0) + 4))
                .attr("width", (d) => {
                return d.width
                    ? parseInt(d.width)
                    : parseInt(this.sankeyObj.nodeWidth());
            })
                .style("fill", (d) => {
                return d.color;
            })
                .style("stroke", (d) => {
                return d.color;
            })
                .on("mouseover", function (ev, i) {
                self.showTooltip(ev, i);
                self.tip.show(ev, this);
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
            node.append("circle")
                .filter(function (d) { return d.selected === true; })
                .attr("cx", function (d, i) { return (i + 1) * 25; })
                .attr("cy", function (d) {
                return (d.y1 - d.y0) / 2;
            })
                .style("fill", (d) => {
                // return d.color = color(d.name.replace(/ .*/, ''));
                return d.color;
            })
                .style("stroke", (d) => {
                return d.color;
            })
                .attr("r", 40)
                .on("mouseover", function (ev, i) {
                self.showTooltip(ev, i);
                self.tip.show(ev, this);
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
            if (this.cameFromFocusNodeHeight < 100) {
                this.svg
                    .append("g")
                    .append("text")
                    .attr("x", this.height / 2 -
                    this.height -
                    this.cameFromFocusNodeHeight -
                    this.nodePadding)
                    .attr("y", -155)
                    .attr("dy", ".35em")
                    .attr("transform", "rotate(-90)")
                    .attr("text-anchor", "middle")
                    .attr("dy", ".35em")
                    .attr("class", "nodeTitle")
                    //   .attr('text-anchor', 'start')
                    //   .attr('transform', null)
                    .attr("fill", "#000")
                    .text(function (d) {
                    return "CAME FROM";
                });
            }
            /*this.svg.append("g").append("text")
          .attr('x', self.width / 2)
          .attr('y', (0 - this.padding))
          .attr("dy", ".35em")
          .attr('class', 'nodeTitle')
          .attr('text-anchor', 'start')
          .attr('transform', null)
          .attr('fill', '#000')
          .text(function (d) { return "VIA" })*/
            if (this.wentToFocusNodeHeight < 100) {
                this.svg
                    .append("g")
                    .append("text")
                    /* .attr('x', self.width - this.padding)
             .attr('y', (0 - this.padding))*/
                    .attr("x", this.height / 2 -
                    this.height -
                    this.wentToFocusNodeHeight -
                    this.nodePadding)
                    .attr("y", parseInt(this.width) + (this.marginRight - 60))
                    .attr("dy", ".35em")
                    .attr("class", "nodeTitle")
                    // .attr('text-anchor', 'start')
                    //  .attr('transform', null)
                    .attr("transform", "rotate(-90)")
                    .attr("text-anchor", "middle")
                    .attr("fill", "#000")
                    .text(function (d) {
                    return "WENT TO";
                });
            }
            node.append("text")
                .attr("x", (d) => {
                return d.x0 < this.width / 2
                    ? 6 + parseInt(this.sankeyObj.nodeWidth())
                    : -6;
            })
                .attr("y", (d) => {
                return ((d.y1 - d.y0) / 2) - 8;
            })
                .attr("dy", ".35em")
                .attr("text-anchor", (d) => {
                return d.x0 < this.width / 2 ? "start" : "end";
            })
                .attr("transform", null)
                .attr("fill", "#5C5C5D")
                .attr("class", "nodeValue")
                .text((d) => {
                return d.percentage + "%";
            })
                //   .filter((d) => { return d.x0 < self.width / 2; })
                //  .attr('fill', '#5C5C5D')
                //  .attr('x', 6 + this.sankeyObj.nodeWidth())
                //  .attr('text-anchor', 'start')
                .filter((d) => {
                return d.selected === true;
            })
                .attr("display", "none");
            // add in the title for the nodes
            node.append("text")
                .attr("x", (d) => {
                return d.x0 < this.width / 2
                    ? -16
                    : 6 + parseInt(this.sankeyObj.nodeWidth());
            })
                .attr("y", (d) => {
                return (d.y1 - d.y0) / 2;
            })
                .attr("class", (d) => {
                return d.focus === true ? "focus" : "normal";
            })
                .attr("dy", ".35em")
                .attr("text-anchor", (d) => {
                return d.x0 < this.width / 2 ? "end" : "start";
            })
                .attr("transform", null)
                .text((d) => {
                return d.prefix
                    ? String(d.prefix)
                    : this.getTruncated(d.name, 12, 9);
            })
                .call(this.wrap, 100)
                // .filter((d) => { return d.x0 < self.width / 2; })
                // .attr("x", -16)
                //  .attr('text-anchor', 'end')
                //.filter((d) => { return d.focus === true; })
                //.attr('class', 'focus')
                //.attr('fill', '#5C5C5D')
                .filter(function (d) {
                return d.selected === true;
            })
                .text((d) => {
                return this.getTruncated(d.name, 8, 8);
            })
                .attr("x", 25)
                .attr("y", (d) => (d.y1 - d.y0) / 2)
                .attr("class", "middle")
                //.attr("transform", "rotate(-90)")
                .attr("text-anchor", "middle");
            node.append("text")
                .filter(function (d) { return d.selected === true; })
                .text((d) => {
                return d.count;
            })
                .style("fill", "#000000")
                .attr("x", 25)
                .attr("y", (d) => (d.y1 - d.y0) / 2 - 80)
                .attr("class", "middle")
                //.attr("transform", "rotate(-90)")
                .attr("text-anchor", "middle");
            node.append("text")
                .filter(function (d) { return d.selected === true; })
                .text((d) => {
                return this.labelKeys.totalVis;
            })
                .style("fill", "#949494")
                .attr("x", 25)
                .attr("y", (d) => (d.y1 - d.y0) / 2 - 50)
                .attr("class", "middle")
                //.attr("transform", "rotate(-90)")
                .attr("text-anchor", "middle");
        };
        this.getTruncated = (str, size, limit) => {
            if (str && str.length > size) {
                return str.substring(0, limit) + "...";
            }
            else {
                return str;
            }
        };
        this.format = (d) => {
            return d3.format(",.0f").toString() + " " + "Widgets";
        };
        // the function for moving the nodes
        /*  dragmove =(d, node) =>{
          d3.select(node)
            .attr('transform',
              'translate('
              + d.x + ','
              + (d.y = Math.max(
                0, Math.min(this.height - (d.y1-d.y0), d3.event.y))
              ) + ')');
          sankey.relayout();
          link.attr('d', path);
        }*/
        this.wrap = (text, width) => {
            text.each(function () {
                const text = d3.select(this), words = text.text().split("~").reverse(), x = text.attr("x"), y = text.attr("y"), dy = 0.1;
                let line = [], lineNumber = 0, lineHeight = 1, // ems
                tspan = text
                    .text(null)
                    .append("tspan")
                    .attr("x", x)
                    .attr("y", y)
                    .attr("dy", String(dy) + "em");
                let word;
                while ((word = words.pop())) {
                    line.push(word);
                    tspan.text(line.join(" "));
                    if (tspan.node().getComputedTextLength() > width) {
                        line.pop();
                        tspan.text(line.join(" "));
                        line = [word];
                        (lineHeight = 1.1), // ems
                            (tspan = text
                                .append("tspan")
                                .attr("x", x)
                                .attr("y", y)
                                .attr("dy", String((lineNumber += 1) * lineHeight + dy) +
                                "em")
                                .text(word));
                    }
                }
            });
        };
    }
    onResize(event) {
        // this.chartContainer.nativeElement.remove()
        if (this.tip) {
            this.tip.hide();
        }
        if (this.sourceData && Object.keys(this.sourceData).length > 0) {
            this.initSvg();
            this.drawChart();
        }
    }
    set options(value) {
        this.chartOptions = value || new D3SankeyDiagramV2ChartOptions();
    }
    set data(value) {
        if (isEmpty(value))
            return;
        this.sourceData = value;
        if (this.tip) {
            this.tip.hide();
        }
        this.cameFromFocusNodeHeight = 0;
        this.wentToFocusNodeHeight = 0;
    }
    ngOnInit() {
        if (this.tip) {
            this.tip.hide();
        }
        this.cameFromFocusNodeHeight = 0;
        this.wentToFocusNodeHeight = 0;
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localized string here
            this.translate.get('shared-lib.d3-components.group-chart').subscribe((res) => {
                this.labelKeys = res;
                this.initSvg();
                this.drawChart();
            });
        });
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    /**
     * A callback method
     * @param changes
     */
    ngOnChanges(changes) {
        const { currentValue } = changes.data;
        if (!currentValue)
            return;
        this.initSvg();
        this.drawChart();
        if (this.tip) {
            this.tip.hide();
        }
        this.cameFromFocusNodeHeight = 0;
        this.wentToFocusNodeHeight = 0;
    }
    /**
     * Initialization of the svg
     */
    initSvg() {
        this.element = this.chartContainer.nativeElement;
        if (this.element) {
            this.element.innerHTML = "";
        }
        if (!this.chartOptions)
            this.chartOptions = new D3SankeyDiagramV2ChartOptions();
        const { margin, nodeWidth, nodePadding } = this.chartOptions;
        // set the dimensions and margins of the gra
        this.width = this.element.clientWidth - margin.left - margin.right;
        this.height = this.element.clientHeight - margin.top - margin.bottom;
        // format variables
        // zero decimal places
        this.color = d3.scaleOrdinal(d3.schemeCategory10);
        if (this.svg) {
            this.svg.remove();
        }
        this.marginLeft = margin.left;
        this.marginRight = margin.right;
        this.nodePadding = nodePadding;
        // append the svg object to the body of the page
        this.svg = d3
            .select(this.element)
            .append("svg")
            .attr("width", parseInt(this.width) +
            parseInt(margin.left) +
            parseInt(margin.right))
            .attr("height", parseInt(this.height) +
            parseInt(margin.top) +
            parseInt(margin.bottom))
            .append("g")
            .attr("transform", "translate(" +
            String(parseInt(margin.left) + parseInt(this.padding)) +
            "," +
            String(parseInt(margin.top) + parseInt(this.padding)) +
            ")");
        // Set the sankey diagram properties
        this.sankeyObj = sankey()
            .nodeWidth(nodeWidth)
            .nodePadding(nodePadding)
            .size([this.width, this.height])
            .nodeSort(null);
        this.sankeyObj(this.sourceData);
        //this.sankeyFn(this.sourceData)
        this.path = sankeyLinkHorizontal();
        this.sankeyObj
            .nodes(this.sourceData.nodes)
            .links(this.sourceData.links)
            .extent([
            [1, 1],
            [this.width - 1, this.height - 5]
        ])
            .nodeSort(null)
            .linkSort(null);
        // .iterations(32)
        //  .extent(this.sourceData.length);
        // .layout(32);
        this.tip = d3Tip()
            .attr("class", "group-tooltip")
            .offset([-10, 0])
            .html((d) => {
            return '<div id="group-tooltip line-chart"></div>';
        });
        this.svg.call(this.tip);
    }
    link(d) {
        return "M" + d.source.y + "," + d.source.x
            + "C" + (d.source.y + d.target.y) / 2 + "," + d.source.x
            + " " + (d.source.y + d.target.y) / 2 + "," + d.target.x
            + " " + d.target.y + "," + d.target.x;
    }
    showTooltip(d, i) {
        const self = this;
        self.tip.hide();
        const tipContainer = "";
        self.tip.html(() => {
            if (i.headerName.indexOf("Others") > -1 &&
                i.headerName.indexOf("+") > -1) {
                return ("<div class = 'multiLine-tooltip'>" +
                    "<div class='tooltip-title'> <span class='sankeyTooltipIcon' style='background-color:" +
                    String(i.color) +
                    "'></span>" +
                    String(i.headerName) +
                    "</div>" +
                    "<div class='tooltip-info'>" +
                    "<span>" +
                    String(i.displayName) +
                    "</span>" +
                    "</div></div>");
            }
            else {
                return ("<div class = 'multiLine-tooltip'>" +
                    "<div class='tooltip-title'> <span class='sankeyTooltipIcon' style='border: 1px solid " +
                    (i.focus && !d.selected ? String(i.color) : "transparent") +
                    ";" +
                    "background-color:" +
                    (i.focus && !i.selected ? "transparent" : String(i.color)) +
                    "'></span>" +
                    String(i.headerName) +
                    "</div>" +
                    "<div class='tooltip-info'>" +
                    "<span>" +
                    String(i.count) +
                    "(" +
                    String(i.tooltipPercentage) +
                    "%) " +
                    String(i.suffix) +
                    " " +
                    String(i.displayName) +
                    "</span>" +
                    "</div></div>");
            }
        });
    }
    ;
}
D3SankeyDiagramV2Component.ɵfac = function D3SankeyDiagramV2Component_Factory(t) { return new (t || D3SankeyDiagramV2Component)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
D3SankeyDiagramV2Component.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3SankeyDiagramV2Component, selectors: [["lib-d3-sankey-diagram-v2"]], viewQuery: function D3SankeyDiagramV2Component_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$R, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, hostBindings: function D3SankeyDiagramV2Component_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function D3SankeyDiagramV2Component_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { options: "options", data: "data" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [[1, "d3-chart-sankey"], ["sankey_diagram", ""]], template: function D3SankeyDiagramV2Component_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [".node[_ngcontent-%COMP%]   text[_ngcontent-%COMP%]{pointer-events:none;text-shadow:0 1px 0 #fff}.link[_ngcontent-%COMP%]{fill:none;stroke:#000;stroke-opacity:.2}.link[_ngcontent-%COMP%]:hover{stroke-opacity:.5}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3SankeyDiagramV2Component, [{
        type: Component,
        args: [{
                selector: 'lib-d3-sankey-diagram-v2',
                templateUrl: './d3-sankey-diagram-v2.component.html',
                styleUrls: ['./d3-sankey-diagram-v2.component.scss']
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["sankey_diagram", { static: true }]
        }], onResize: [{
            type: HostListener,
            args: ["window:resize", ["$event"]]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

class D3SankeyDiagramChartOptions {
    constructor() {
        this.margin = { top: 30, right: 180, bottom: 90, left: 130 };
        this.nodeWidth = 16;
        this.nodePadding = 20;
        this.pathWidth = 2;
    }
}

const _c0$Q = ["sankey_diagram"];
//declare var sankey: any;
class D3SankeyDiagramComponent {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() {
        this.padding = 40;
        this.marginLeft = 30;
        this.marginRight = 30;
        this.cameFromFocusNodeHeight = 0;
        this.nodePadding = 20;
        this.wentToFocusNodeHeight = 0;
        /*drawPathLeavingDiagram(link) {
            const x0 = parseInt(link.source.x) + parseInt(link.source.width),
                x1 = x0 + link.source.width / 4,
                x2 = x1 + link.source.width / 2,
                y0 =
                    parseInt(link.source.y) +
                    parseInt(link.sourceY) +
                    parseInt(link.thickness) / 2,
                y1 = y0 - link.source.width / 2,
                rx = link.source.width / 2,
                ry = link.source.width / 2;
            return (
                "M" +
                x0 +
                "," +
                y0 +
                "L" +
                x1 +
                "," +
                y0 +
                "A" +
                rx +
                "," +
                ry +
                "," +
                0 +
                "," +
                0 +
                "," +
                0 +
                "," +
                x2 +
                "," +
                y1 +
                "V" +
                0
            );
        }*/
        /**
         * Draw Donut Chart in the svg
         */
        this.drawChart = () => {
            const self = this;
            // add in the links
            const link = this.svg
                .append("g")
                .selectAll(".link")
                .data(this.sourceData.links)
                .enter()
                .append("path")
                .attr("class", "link")
                .attr("d", this.path)
                .style("stroke-width", this.chartOptions.pathWidth)
                .attr("stroke", (d) => {
                return d.focusColor;
            })
                // .sort((a, b) => { return b.y1 - a.y1 });
                .sort(null);
            // add the link titles
            /*link.append('title')
          .text((d) => {
            return d.source.name + ' → ' +
              d.target.name + '\n' + self.format(d.value);
          });*/
            // add in the nodes
            const node = this.svg
                .append("g")
                .selectAll(".node")
                .data(this.sourceData.nodes)
                .enter()
                .append("g")
                .attr("class", "node")
                .attr("transform", (d) => {
                if (d.focus && d.path == "from") {
                    self.cameFromFocusNodeHeight = d.percentage;
                }
                if (d.focus && d.path == "to") {
                    self.wentToFocusNodeHeight = d.percentage;
                }
                if (d.width) {
                    return ("translate(" +
                        String(d.x0 -
                            (d.width -
                                (this.sankeyObj.nodeWidth() * 2 + 15))) +
                        "," +
                        String(d.y0) +
                        ")");
                }
                else {
                    return ("translate(" + String(d.x0) + "," + String(d.y0) + ")");
                }
            })
                .call(d3
                .drag()
                .subject((d) => {
                return d;
            })
                .on("start", function () {
                this.parentNode.appendChild(this);
            })
            // .on('drag', this.dragmove)
            );
            // add the rectangles for the nodes
            node.append("rect")
                .attr("height", (d) => d.selected
                ? parseInt(d.y1)
                : d.y1 - d.y0 < 1
                    ? 1
                    : parseInt(d.y1) - parseInt(d.y0))
                //.attr("width", d => d.x1 - d.x0)
                .attr("width", (d) => {
                // return d.color = color(d.name.replace(/ .*/, ""));
                return d.width
                    ? parseInt(d.width)
                    : parseInt(this.sankeyObj.nodeWidth());
            })
                .style("fill", (d) => {
                // return d.color = color(d.name.replace(/ .*/, ''));
                return d.focus && !d.selected
                    ? "transparent"
                    : d.color;
            })
                .style("stroke", (d) => {
                return d.focus && !d.selected ? d.color : "none";
            })
                .on("mouseover", function (ev, i) {
                self.showTooltip(ev, i);
                self.tip.show(ev, this);
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
            if (this.cameFromFocusNodeHeight < 100) {
                this.svg
                    .append("g")
                    .append("text")
                    .attr("x", this.height / 2 -
                    this.height -
                    this.cameFromFocusNodeHeight -
                    this.nodePadding)
                    .attr("y", -155)
                    .attr("dy", ".35em")
                    .attr("transform", "rotate(-90)")
                    .attr("text-anchor", "middle")
                    .attr("dy", ".35em")
                    .attr("class", "nodeTitle")
                    //   .attr('text-anchor', 'start')
                    //   .attr('transform', null)
                    .attr("fill", "#000")
                    .text(function (d) {
                    return "CAME FROM";
                });
            }
            /*this.svg.append("g").append("text")
          .attr('x', self.width / 2)
          .attr('y', (0 - this.padding))
          .attr("dy", ".35em")
          .attr('class', 'nodeTitle')
          .attr('text-anchor', 'start')
          .attr('transform', null)
          .attr('fill', '#000')
          .text(function (d) { return "VIA" })*/
            if (this.wentToFocusNodeHeight < 100) {
                this.svg
                    .append("g")
                    .append("text")
                    /* .attr('x', self.width - this.padding)
             .attr('y', (0 - this.padding))*/
                    .attr("x", this.height / 2 -
                    this.height -
                    this.wentToFocusNodeHeight -
                    this.nodePadding)
                    .attr("y", parseInt(this.width) + (this.marginRight - 60))
                    .attr("dy", ".35em")
                    .attr("class", "nodeTitle")
                    // .attr('text-anchor', 'start')
                    //  .attr('transform', null)
                    .attr("transform", "rotate(-90)")
                    .attr("text-anchor", "middle")
                    .attr("fill", "#000")
                    .text(function (d) {
                    return "WENT TO";
                });
            }
            node.append("text")
                .attr("x", (d) => {
                return d.x0 < this.width / 2
                    ? 6 + parseInt(this.sankeyObj.nodeWidth())
                    : -6;
            })
                .attr("y", (d) => {
                return (d.y1 - d.y0) / 2;
            })
                .attr("dy", ".35em")
                .attr("text-anchor", (d) => {
                return d.x0 < this.width / 2 ? "start" : "end";
            })
                .attr("transform", null)
                .attr("fill", "#5C5C5D")
                .attr("class", "nodeValue")
                .text((d) => {
                return d.percentage + "%";
            })
                //   .filter((d) => { return d.x0 < self.width / 2; })
                //  .attr('fill', '#5C5C5D')
                //  .attr('x', 6 + this.sankeyObj.nodeWidth())
                //  .attr('text-anchor', 'start')
                .filter((d) => {
                return d.selected === true;
            })
                .attr("display", "none");
            // add in the title for the nodes
            node.append("text")
                .attr("x", (d) => {
                return d.x0 < this.width / 2
                    ? -16
                    : 6 + parseInt(this.sankeyObj.nodeWidth());
            })
                .attr("y", (d) => {
                return (d.y1 - d.y0) / 2;
            })
                .attr("class", (d) => {
                return d.focus === true ? "focus" : "normal";
            })
                .attr("dy", ".35em")
                .attr("text-anchor", (d) => {
                return d.x0 < this.width / 2 ? "end" : "start";
            })
                .attr("transform", null)
                .text((d) => {
                return d.prefix
                    ? String(d.prefix) + this.getTruncated(d.name, 12, 9)
                    : this.getTruncated(d.name, 12, 9);
            })
                .call(this.wrap, 100)
                // .filter((d) => { return d.x0 < self.width / 2; })
                // .attr("x", -16)
                //  .attr('text-anchor', 'end')
                //.filter((d) => { return d.focus === true; })
                //.attr('class', 'focus')
                //.attr('fill', '#5C5C5D')
                .filter(function (d) {
                return d.selected === true;
            })
                .text((d) => {
                return this.getTruncated(d.name, 10, 10);
            })
                .attr("x", (d) => (d.y0 - d.y1) / 2)
                .attr("y", (d) => d.width ? d.width / 2 : this.sankeyObj.nodeWidth() / 2)
                .attr("class", "middle")
                .attr("transform", "rotate(-90)")
                .attr("text-anchor", "middle");
        };
        this.getTruncated = (str, size, limit) => {
            if (str && str.length > size) {
                return str.substring(0, limit) + "...";
            }
            else {
                return str;
            }
        };
        this.format = (d) => {
            return d3.format(",.0f").toString() + " " + "Widgets";
        };
        // the function for moving the nodes
        /*  dragmove =(d, node) =>{
          d3.select(node)
            .attr('transform',
              'translate('
              + d.x + ','
              + (d.y = Math.max(
                0, Math.min(this.height - (d.y1-d.y0), d3.event.y))
              ) + ')');
          sankey.relayout();
          link.attr('d', path);
        }*/
        this.wrap = (text, width) => {
            text.each(function () {
                const text = d3.select(this), words = text.text().split("~").reverse(), x = text.attr("x"), y = text.attr("y"), dy = 0.1;
                let line = [], lineNumber = 0, lineHeight = 1, // ems
                tspan = text
                    .text(null)
                    .append("tspan")
                    .attr("x", x)
                    .attr("y", y)
                    .attr("dy", String(dy) + "em");
                let word;
                while ((word = words.pop())) {
                    line.push(word);
                    tspan.text(line.join(" "));
                    if (tspan.node().getComputedTextLength() > width) {
                        line.pop();
                        tspan.text(line.join(" "));
                        line = [word];
                        (lineHeight = 1.1), // ems
                            (tspan = text
                                .append("tspan")
                                .attr("x", x)
                                .attr("y", y)
                                .attr("dy", String((lineNumber += 1) * lineHeight + dy) +
                                "em")
                                .text(word));
                    }
                }
            });
        };
    }
    onResize(event) {
        // this.chartContainer.nativeElement.remove()
        if (this.tip) {
            this.tip.hide();
        }
        if (this.sourceData && Object.keys(this.sourceData).length > 0) {
            this.initSvg();
            this.drawChart();
        }
    }
    set options(value) {
        this.chartOptions = value || new D3SankeyDiagramChartOptions();
    }
    set data(value) {
        if (isEmpty(value))
            return;
        this.sourceData = value;
        if (this.tip) {
            this.tip.hide();
        }
        this.cameFromFocusNodeHeight = 0;
        this.wentToFocusNodeHeight = 0;
    }
    ngOnInit() {
        if (this.tip) {
            this.tip.hide();
        }
        this.cameFromFocusNodeHeight = 0;
        this.wentToFocusNodeHeight = 0;
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    /**
     * A callback method
     * @param changes
     */
    ngOnChanges(changes) {
        const { currentValue } = changes.data;
        if (!currentValue)
            return;
        this.initSvg();
        this.drawChart();
        if (this.tip) {
            this.tip.hide();
        }
        this.cameFromFocusNodeHeight = 0;
        this.wentToFocusNodeHeight = 0;
    }
    /**
     * Initialization of the svg
     */
    initSvg() {
        this.element = this.chartContainer.nativeElement;
        if (this.element) {
            this.element.innerHTML = "";
        }
        if (!this.chartOptions)
            this.chartOptions = new D3SankeyDiagramChartOptions();
        const { margin, nodeWidth, nodePadding } = this.chartOptions;
        // set the dimensions and margins of the gra
        this.width = this.element.clientWidth - margin.left - margin.right;
        this.height = this.element.clientHeight - margin.top - margin.bottom;
        // format variables
        // zero decimal places
        this.color = d3.scaleOrdinal(d3.schemeCategory10);
        if (this.svg) {
            this.svg.remove();
        }
        this.marginLeft = margin.left;
        this.marginRight = margin.right;
        this.nodePadding = nodePadding;
        // append the svg object to the body of the page
        this.svg = d3
            .select(this.element)
            .append("svg")
            .attr("width", parseInt(this.width) +
            parseInt(margin.left) +
            parseInt(margin.right))
            .attr("height", parseInt(this.height) +
            parseInt(margin.top) +
            parseInt(margin.bottom))
            .append("g")
            .attr("transform", "translate(" +
            String(parseInt(margin.left) + parseInt(this.padding)) +
            "," +
            String(parseInt(margin.top) + parseInt(this.padding)) +
            ")");
        // Set the sankey diagram properties
        this.sankeyObj = sankey()
            .nodeWidth(nodeWidth)
            .nodePadding(nodePadding)
            .size([this.width, this.height])
            .nodeSort(null);
        this.sankeyObj(this.sourceData);
        //this.sankeyFn(this.sourceData)
        this.path = sankeyLinkHorizontal();
        this.sankeyObj
            .nodes(this.sourceData.nodes)
            .links(this.sourceData.links)
            .extent([
            [1, 1],
            [this.width - 1, this.height - 5]
        ])
            .nodeSort(null)
            .linkSort(null);
        // .iterations(32)
        //  .extent(this.sourceData.length);
        // .layout(32);
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html((d) => {
            return '<div id="bi-tooltip line-chart"></div>';
        });
        this.svg.call(this.tip);
    }
    showTooltip(d, i) {
        const self = this;
        self.tip.hide();
        const tipContainer = "";
        self.tip.html(() => {
            if (i.headerName.indexOf("Others") > -1 &&
                i.headerName.indexOf("+") > -1) {
                return ("<div class = 'multiLine-tooltip'>" +
                    "<div class='tooltip-title'> <span class='sankeyTooltipIcon' style='background-color:" +
                    String(i.color) +
                    "'></span>" +
                    String(i.headerName) +
                    "</div>" +
                    "<div class='tooltip-info'>" +
                    "<span>" +
                    String(i.displayName) +
                    "</span>" +
                    "</div></div>");
            }
            else {
                return ("<div class = 'multiLine-tooltip'>" +
                    "<div class='tooltip-title'> <span class='sankeyTooltipIcon' style='border: 1px solid " +
                    (i.focus && !d.selected ? String(i.color) : "transparent") +
                    ";" +
                    "background-color:" +
                    (i.focus && !i.selected ? "transparent" : String(i.color)) +
                    "'></span>" +
                    String(i.headerName) +
                    "</div>" +
                    "<div class='tooltip-info'>" +
                    "<span>" +
                    String(i.value) +
                    "(" +
                    String(i.tooltipPercentage) +
                    "%) " +
                    String(i.suffix) +
                    " " +
                    String(i.displayName) +
                    "</span>" +
                    "</div></div>");
            }
        });
    }
    ;
}
D3SankeyDiagramComponent.ɵfac = function D3SankeyDiagramComponent_Factory(t) { return new (t || D3SankeyDiagramComponent)(); };
D3SankeyDiagramComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3SankeyDiagramComponent, selectors: [["lib-d3-sankey-diagram"]], viewQuery: function D3SankeyDiagramComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$Q, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, hostBindings: function D3SankeyDiagramComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function D3SankeyDiagramComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { options: "options", data: "data" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [[1, "d3-chart"], ["sankey_diagram", ""]], template: function D3SankeyDiagramComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [".node[_ngcontent-%COMP%]   text[_ngcontent-%COMP%]{pointer-events:none;text-shadow:0 1px 0 #fff}.link[_ngcontent-%COMP%]{fill:none;stroke:#000;stroke-opacity:.2}.link[_ngcontent-%COMP%]:hover{stroke-opacity:.5}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3SankeyDiagramComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-sankey-diagram",
                templateUrl: "./d3-sankey-diagram.component.html",
                styleUrls: ["./d3-sankey-diagram.component.scss"]
            }]
    }], function () { return []; }, { chartContainer: [{
            type: ViewChild,
            args: ["sankey_diagram", { static: true }]
        }], onResize: [{
            type: HostListener,
            args: ["window:resize", ["$event"]]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

/* eslint-disable @typescript-eslint/no-this-alias */
const _c0$P = ["chart"];
class D3ScatterPlotComponent {
    constructor(dataService, translate) {
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.chartOptions = {};
        this.sourceData = [];
        this.allData = [];
        this.hasPinned = false;
        this.pinnedData = [];
        this.labelKeys = [];
    }
    set options(value) {
        if (!value) {
            return;
        }
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (!value || value.length === 0) {
            return;
        }
        if (this.tip) {
            this.tip.hide();
        }
        this.sourceData = value.data ? value.data : null;
        this.hasPinned = value.pinned;
        this.pinnedData = value.pinnedData ? value.pinnedData : [];
        this.widgetType = value.widgetType ? value.widgetType : "";
        if (this.sourceData && this.pinnedData) {
            this.allData = this.sourceData.concat(this.pinnedData);
        }
        if (value.xAvg) {
            this.xAvgValue = value.xAvg;
        }
        if (value.yAvg) {
            this.yAvgValue = value.yAvg;
        }
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localized string here
            this.translate.get('shared-lib.d3-components.group-chart').subscribe((res) => {
                this.labelKeys = res;
                if (this.sourceData && this.sourceData.length > 0) {
                    this.reDraw();
                }
            });
        });
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    ngOnChanges(changes) {
        if (this.tip) {
            console.log("ngOnChanges :::" + this.tip);
            this.tip.hide();
        }
    }
    onResize() {
        if (this.sourceData && this.sourceData.length > 0) {
            this.reDraw();
        }
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg) {
            this.svg.remove();
        }
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("transform", `translate(
					0,${this.chartOptions.margin.top - 20})`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg
            .append("g")
            .attr("transform", `translate(10, 20)`);
        this.getxScale();
        this.getyScale();
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(() => {
            return '<div id="bi-tooltip line-chart"></div>';
        });
        this.svg.call(this.tip);
    }
    draw() {
        const dataset = this.allData;
        const self = this;
        this.chart
            .append("g")
            .attr("class", "x axis")
            .attr("width", "100%")
            .attr("transform", `translate(
						${(this.chartOptions.margin.left + 5)},${this.height})`)
            .call(d3
            .axisBottom(this.xScale)
            .scale(this.xScale)
            .tickFormat((d) => this.readableNumber(d, 0)));
        this.chart
            .append("g")
            .attr("class", "y axis")
            .attr("transform", `translate(
						${(this.chartOptions.margin.left + 9)},0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-`${(this.width + 35)}`)
            .tickFormat((d) => this.chartOptions.drawAvgLine
            ? `${d} `
            : this.readableNumber(d, 0)));
        this.chart
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - (this.chartOptions.margin.left - 15))
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .style("fill", "#000000")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
        this.chart
            .append("g")
            .attr("class", "grid")
            .attr("transform", `translate(
						${(this.chartOptions.margin.left + 5)},0)`)
            .call(d3
            .axisLeft(this.yScale)
            .tickSize(-`${(this.width + 35)}`)
            .tickFormat(() => ""));
        this.chart.append("g").attr("class", "x-axis-label")
            .append("text")
            .text(this.chartOptions.xAxisLabel)
            .style("fill", "#1D3243")
            // .attr('transform',function(d,i){
            // 	return 'translate('+(self.width / 2 + 40)+','+(self.height + 10)+')';
            // })
            .attr("transform", `translate(${(this.width / 2 + 40)},${(this.height + 35)})`)
            .attr("text-anchor", "middle");
        //.d3-chart text.yAxis-label, text.xAxis-label
        const circleGroup = this.chart
            .append("g")
            .attr("class", "circle-group")
            .attr("transform", `translate(
						${(this.chartOptions.margin.left + 5)},0)`);
        circleGroup
            .selectAll(".dot")
            .data(dataset)
            .enter()
            .append("circle")
            .attr("class", (d) => d.position === "top" ||
            d.position === "bottom" ||
            d.type === "dailyDensity"
            ? "pointer-dot"
            : "dot")
            .attr("cx", (d) => self.xScale(d.xAxisKey))
            .attr("cy", (d) => self.yScale(d.count))
            .attr("r", (d) => d.radius)
            .attr("fill", (d) => d.color)
            .on("mouseover", function (d, i) {
            if (i.showTooltip) {
                self.showTooltip(i);
                self.tip.show(d, this);
            }
        })
            .on("mouseout", function (d, i) {
            if (i.showTooltip) {
                self.tip.hide();
            }
        });
        if (this.chartOptions.drawAvgLine) {
            this.drawAvgLine();
        }
        if (this.hasPinned && this.pinnedData.length > 0) {
            circleGroup
                .selectAll(".outer-dot")
                .data(this.pinnedData)
                .enter()
                .append("circle")
                .attr("class", "outer-dot")
                .attr("cx", (d) => self.xScale(d.xAxisKey))
                .attr("cy", (d) => self.yScale(d.count))
                .attr("r", (d) => (d.outerRadius ? d.outerRadius : 0))
                .attr("fill", (d) => d.outerColor ? d.outerColor : "transparent")
                .attr("stroke", (d) => (d.stroke ? d.stroke : 0))
                .attr("stroke-width", 1)
                .on("mouseover", function (d, i) {
                if (i.showTooltip) {
                    self.showTooltip(i);
                    self.tip.show(d, this);
                }
            })
                .on("mouseout", function (d, i) {
                if (i.showTooltip) {
                    self.tip.hide();
                }
            });
            circleGroup
                .selectAll(".inner-dot")
                .data(this.pinnedData)
                .enter()
                .append("circle")
                .attr("class", "inner-dot")
                .attr("cx", (d) => self.xScale(d.xAxisKey))
                .attr("cy", (d) => self.yScale(d.count))
                .attr("r", (d) => (d.radius ? d.radius : 0))
                .attr("fill", (d) => (d.color ? d.color : "transparent"))
                .on("mouseover", function (d, i) {
                self.showTooltip(i);
                self.tip.show(d, this);
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
        }
    }
    drawAvgLine() {
        this.chart.append("line")
            // .attrs({
            // 	x1: 27,
            // 	y1: this.yScale(this.yAvgValue),
            // 	x2: +this.width + 45,
            // 	y2: this.yScale(this.yAvgValue),
            // 	stroke: "#1d324366",
            // 	"stroke-width": 1
            // });
            .attr("x1", 27)
            .attr("y1", this.yScale(this.yAvgValue))
            .attr("x2", `${(this.width + 45)}`)
            .attr("y2", this.yScale(this.yAvgValue))
            .attr("stroke", "#1d324366")
            .attr("stroke-width", 1);
        this.chart.append("line")
            // .attrs({
            // 	x1: this.xScale(this.xAvgValue),
            // 	y1: 0,
            // 	x2: this.xScale(this.xAvgValue),
            // 	y2: this.height,
            // 	stroke: "#1d324366",
            // 	"stroke-width": 1
            // });
            .attr("x1", this.xScale(this.xAvgValue))
            .attr("y1", 0)
            .attr("x2", this.xScale(this.xAvgValue))
            .attr("y2", this.height)
            .attr("stroke", "#1d324366")
            .attr("stroke-width", 1);
    }
    drawThresholdLine(value, tl, x) {
        tl.append("line")
            // .attrs({
            // 	x1: value.historicalThreshold ? x : x - 5,
            // 	y1: this.yScale(value.count),
            // 	x2: +this.width + 45,
            // 	y2: this.yScale(value.count),
            // 	stroke: value.color,
            // 	"stroke-width": 2
            // });
            .attr("x1", value.historicalThreshold ? x : x - 5)
            .attr("y1", this.yScale(value.count))
            .attr("x2", `${(this.width + 45)}`)
            .attr("y2", this.yScale(value.count))
            .attr("stroke", "#1d324366")
            .attr("stroke-width", 1);
    }
    showTooltip(value) {
        const self = this;
        let tipContainer = "";
        const suffix = value.suffix ? value.suffix : this.labelKeys.minValue;
        const prefix = value.prefix ? value.prefix : this.labelKeys.visitDurationDistribution;
        self.tip.html(() => {
            if (self.widgetType === "dailyDensity") {
                tipContainer = self.dailyDensityTooltip(value);
            }
            else if (self.widgetType === "storeGridExperience") {
                tipContainer += `<div class="top-section align-center">
					${value.locationName}
					</div>`;
                tipContainer +=
                    '<div class="top-section"><div class="top-left">';
                tipContainer +=
                    '<div class="left-label"> ' + this.labelKeys.visitFrequencyDistribution + '</div>';
                tipContainer += "</div>";
                tipContainer += `<div class="top-right">${value.count}`.trim();
                tipContainer += "</div></div>";
                tipContainer +=
                    '<div class="top-section"><div class="top-left">';
                tipContainer += `<div class="left-label">${prefix}</div>`;
                tipContainer += "</div>";
                tipContainer += `<div class="top-right">
					${value.xAxisKey}`.trim();
                tipContainer += `<span>
					${suffix}
					</span>`;
                tipContainer += "</div>";
                tipContainer += "</div>";
            }
            else {
                tipContainer +=
                    '<div class="top-section"><div class="top-left">';
                tipContainer += `<div class="left-label">
					${value.locationName}
					</div>`;
                tipContainer += "</div>";
                tipContainer += `<div class="top-right">
				${value.xAxisKey}`.trim();
                tipContainer += `<span> ` + this.labelKeys.sqftTxt + `</span>`;
                tipContainer += "</div>";
                tipContainer += "</div>";
                tipContainer +=
                    '<div class="top-section"><div class="top-left">';
                tipContainer += `<div class="left-label">${prefix}</div>`;
                if (value.brand || value.city || value.state) {
                    tipContainer += '<div class="meta-data-section">';
                    if (value.brand) {
                        tipContainer += `<div class="brand"> ${value.brand}, </div>`;
                    }
                    if (value.city) {
                        tipContainer += `<div class="city">${value.city}, </div>`;
                    }
                    if (value.state) {
                        tipContainer += `<div class="state">${value.state}</div>`;
                    }
                    tipContainer += "</div>";
                }
                tipContainer += "</div>";
                tipContainer += `<div class="top-right">
					${value.count}`.trim();
                tipContainer += `<span> 
					${suffix}
					</span>`;
                tipContainer += "</div>";
                tipContainer += "</div>";
                const rankList = value.rankList;
                if (rankList) {
                    tipContainer += '<div class="top-section">';
                    tipContainer += '<div class="ranking-list">';
                    rankList.forEach((rank) => {
                        tipContainer += `<div class="location-position"> ${rank}</div>`;
                    });
                    tipContainer += "</div>";
                }
                tipContainer += "</div>";
            }
            return tipContainer;
        });
    }
    dailyDensityTooltip(value) {
        let tipContainer = "";
        if (value.date) {
            tipContainer += `<div class="top-section"><div class="top-left"><div class="left-label">
				${value.date}`;
            tipContainer += `</div></div><div class="top-right">
				${value.day}`.trim();
            tipContainer += `</div></div>`;
        }
        tipContainer += '<div class="top-section"><div class="top-left">';
        tipContainer += `<div class="left-label">${value.prefix}</div>`;
        tipContainer += "</div>";
        tipContainer += `<div class="top-right">${value.count}`.trim();
        tipContainer += `<span>${value.suffix}</span>`;
        tipContainer += "</div>";
        tipContainer += "</div>";
        tipContainer += '<div class="top-section"><div class="top-left">';
        tipContainer += '<div class="left-label">' + this.labelKeys.visitCount_title + '</div>';
        tipContainer += "</div>";
        tipContainer += `<div class="top-right">${value.xAxisKey}</div>`;
        tipContainer += "</div>";
        tipContainer += "</div>";
        return tipContainer;
    }
    readableNumber(value, decimalPoint) {
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return "0";
        }
        // number of decimal places to show
        decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint;
        // get power
        const numCount = value.toPrecision(2).split("e");
        // floor at decimals, ceiling at trillions
        const noOfK = numCount.length === 1
            ? 0
            : Math.floor(Math.min(numCount[1].slice(1), 14) / 3);
        // divide by power
        const dividedValue = noOfK < 1
            ? value.toFixed(0 + decimalPoint)
            : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint);
        const finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue); // enforce -0 is 0
        const suffix = finalValue + ["", "K", "M", "B", "T"][noOfK]; // append power
        return suffix;
    }
    getxScale() {
        this.xScale = d3
            .scaleLinear()
            .range([
            this.chartOptions.margin.left,
            this.width - this.chartOptions.margin.right
        ])
            .domain([
            0,
            d3.max(this.allData, (d) => {
                return d.xAxisKey;
            })
        ]);
    }
    getyScale() {
        if (this.chartOptions.drawAvgLine) {
            this.yScale = d3
                .scaleLinear()
                .range([this.height, 0])
                .domain([
                d3.min(this.allData, (d) => {
                    return d.count;
                }) - 0.1,
                d3.max(this.allData, (d) => {
                    return d.count;
                })
            ])
                .nice();
        }
        else {
            this.yScale = d3
                .scaleLinear()
                .range([this.height, 0])
                .domain([
                0,
                d3.max(this.allData, (d) => {
                    return d.count;
                })
            ])
                .nice();
        }
    }
    reDraw() {
        this.createSvg();
        this.draw();
    }
}
D3ScatterPlotComponent.ɵfac = function D3ScatterPlotComponent_Factory(t) { return new (t || D3ScatterPlotComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
D3ScatterPlotComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3ScatterPlotComponent, selectors: [["lib-d3-scatter-plot"]], viewQuery: function D3ScatterPlotComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$P, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, hostBindings: function D3ScatterPlotComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function D3ScatterPlotComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { options: "options", data: "data" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [[1, "d3-chart"], ["chart", ""]], template: function D3ScatterPlotComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: ["path[_ngcontent-%COMP%]{stroke:#4682b4;stroke-width:2;fill:none}.axis[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .axis[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{fill:none;stroke:gray;stroke-width:1;shape-rendering:crispEdges}.label[_ngcontent-%COMP%]{position:absolute}circle[_ngcontent-%COMP%]{cursor:pointer;fill:#4682b4}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3ScatterPlotComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-scatter-plot",
                templateUrl: "./d3-scatter-plot.component.html",
                styleUrls: ["./d3-scatter-plot.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ["window:resize", ["$event"]]
        }] }); })();

const _c0$O = ["chart"];
class D3ScrollbarChartComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.chartOptions = {};
        this.sourceData = [];
        this.readableNumber = (value, decimalPoint) => {
            if (value === null) {
                return null;
            }
            if (value === 0) {
                return "0";
            }
            //if(this.sourceData[0].dataType === "noOfOccupantsByRoom" || this.sourceData[0].dataType === "timeOccupiedByRoom")
            //value = Number(value);
            decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
            const numCount = (value).toPrecision(2).split("e"), // get power
            noOfK = numCount.length === 1
                ? 0
                : Math.floor(Math.min(numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
            dividedValue = noOfK < 1
                ? value.toFixed(0 + decimalPoint)
                : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
            finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
            suffix = finalValue + ["", "K", "M", "B", "T"][noOfK]; // append power
            return suffix;
        };
        this.getTruncated = (str, size, limit) => {
            if (str && str.lastIndexOf("...") === -1 && str.length > size) {
                return str.substring(0, limit) + "...";
            }
            else {
                return str;
            }
        };
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        isUndefined(this.chartOptions.showValue) &&
            (this.chartOptions.showValue = true);
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (!value || value.length == 0)
            return;
        this.sourceData = value;
        this.numSections = value.length;
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        const bottom = this.chartOptions.margin.bottom;
        if (this.svg)
            this.svg.remove();
        const keyValues = [];
        let sourceValue = 0;
        this.sourceData.forEach((d) => {
            if (d.rotateXaxis)
                keyValues.push(d.rotateXaxis);
            sourceValue = d.values.length;
        });
        if (keyValues.length >= 1 && sourceValue > 1) {
            this.chartOptions.margin.bottom = 60;
        }
        else {
            this.chartOptions.margin.bottom = bottom;
        }
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%");
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg
            .append("g")
            .attr("transform", "translate(" +
            (this.chartOptions.margin.left + 20) +
            "," +
            this.chartOptions.margin.top +
            ")");
        this.xScale = this.getxScale();
        this.y = this.getScaleY();
        //this.z = this.getScaleZ();
        // this.line = d3.line()
        // .x(function(d) { return this.xScale(d["xPos"]); })
        // .y(function(d) { return this.y(d["peakOccupancy"]); })
        this.getLine();
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(function (d) {
            return "<div id='bi-tooltip'></div>";
        });
        this.svg.call(this.tip);
    }
    getLine() {
        const self = this;
        this.valueline = d3
            .line()
            .x((d, i) => d.xpos + 5)
            .y((d) => this.y(d.peakOccupancy))
            .curve(d3.curveMonotoneX);
    }
    // getLine(xPos) {
    // 	const self = this;
    // 	return d3
    // 		.line()
    // 		.x((d: any) => xPos)
    // 		.y((d: any) => self.y(d.peakOccupancy))
    // 		.curve(d3.curveMonotoneX);
    // }
    getlineCal(d) {
        let self = this;
        console.log("::::::::::::::getlineCal:::::::::::", d);
        return self.xScale(d.label);
    }
    setYaxis(d) {
        if (this.chartOptions.setReadableNumber) {
            return (this.readableNumber(d, 1) + this.chartOptions.yAxisTickFormat);
        }
        else {
            return d + this.chartOptions.yAxisTickFormat;
        }
    }
    onResize(event) {
        if (this.sourceData && this.sourceData.length > 0)
            this.reDraw();
    }
    ngAfterViewInit() {
        this.dataService.getMagneticAppIsExpanded(this.unsubscribe$).subscribe((val) => {
            setTimeout(() => {
                // console.log("getMagneticAppIsExpanded", val);
                if (this.sourceData && this.sourceData.length > 0)
                    this.reDraw();
            }, 500);
        });
    }
    getxScale() {
        //if(this.sourceData[0].dataType === "noOfOccupantsByRoom"){
        let keyValues = [];
        this.sourceData.forEach((d) => {
            d.values.forEach((obj) => {
                keyValues.push(obj);
            });
        });
        return d3.scaleBand()
            .range([
            this.chartOptions.margin.left,
            this.width - this.chartOptions.margin.right
        ])
            .domain(keyValues.map(function (d) {
            if (d) {
                return d.label;
            }
        }));
        // return d3
        // 	.scaleLinear()
        // 	.range([
        // 		this.chartOptions.margin.left,
        // 		this.width - this.chartOptions.margin.right
        // 	])
        // 	.domain([0, 100]);
        //}
    }
    getScaleY() {
        return d3
            .scaleLinear()
            .range([this.height, 0])
            .domain([
            0,
            d3.max(this.sourceData, function (d) {
                return d3.max(d["values"], function (obj) {
                    if (d.dataType === "noOfOccupantsByRoom") {
                        if (obj["peakOccupancy"] && obj["peakOccupancy"] > 0) {
                            let count = parseFloat(obj["count"]) > 10 ? parseFloat(obj["count"]) : 10;
                            return Math.max(count, obj["peakOccupancy"]);
                        }
                        else {
                            return parseFloat(obj["count"]) > 10
                                ? Number(parseFloat(obj["count"]))
                                : 10;
                        }
                    }
                    else {
                        return parseFloat(obj["count"]) > 10
                            ? parseFloat(obj["count"])
                            : 10;
                    }
                });
            })
        ])
            .nice();
    }
    getScaleZ() {
        return d3
            .scaleLinear()
            .range([this.height, 0])
            .domain([
            0,
            d3.max(this.sourceData, function (d) {
                return d3.max(d["values"], function (obj) {
                    return parseFloat(obj["count"]);
                });
            })
        ])
            .nice();
    }
    getSectionWidth(bars, barWidth, barSpacing) {
        return bars.length * barWidth + (bars.length - 1) * barSpacing;
    }
    getSectionSpacing() {
        let totalBarWidth = 0;
        this.sourceData.forEach((section, index) => {
            const bars = section.values;
            const barSpacing = section.barSpacing
                ? section.barSpacing
                : this.chartOptions.barSpacing;
            let barWidth = section.barWidth
                ? section.barWidth
                : this.chartOptions.barWidth;
            if (section.type !== "average")
                barWidth = section.barWidth
                    ? section.barWidth
                    : this.chartOptions.barWidth * 3;
            totalBarWidth += this.getSectionWidth(bars, barWidth, barSpacing);
        });
        const remainingWidth = this.width - this.chartOptions.outerPadding * 2 - totalBarWidth;
        let gSpacing = 0;
        if (this.chartOptions.centreAlign && this.numSections < 3)
            gSpacing = Math.floor(remainingWidth / 4);
        else if (this.chartOptions.section === "rightnow")
            gSpacing = Math.floor(remainingWidth / 3);
        else if (this.chartOptions.sectionCentre && this.numSections < 3)
            gSpacing = Math.floor(remainingWidth / 2);
        else
            gSpacing = Math.floor(remainingWidth / (this.numSections - 1));
        return Math.max(this.chartOptions.sectionSpacing, gSpacing);
    }
    draw() {
        let requiredWidth = 0;
        const self = this;
        this.sourceData.forEach((section, index) => {
            const barSpacing = section.barSpacing
                ? section.barSpacing
                : this.chartOptions.barSpacing;
            const barWidth = section.barWidth
                ? section.barWidth
                : this.chartOptions.barWidth;
            requiredWidth =
                (section.values.length + 10) * (barWidth + barSpacing);
        });
        if ((this.sourceData[1] && this.sourceData[1].values.length > 20) ||
            (this.sourceData.length == 1 &&
                this.sourceData[0].values.length > 20)) {
            requiredWidth = Math.max(requiredWidth, this.width);
        }
        else {
            requiredWidth = this.width;
        }
        //yAxis Label
        this.chart
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - (this.chartOptions.margin.left + 10))
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .style("fill", "#000000")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
        this.chart
            .append("g")
            .attr("transform", "translate(" +
            (this.chartOptions.margin.left - 10) +
            "," +
            0 +
            ")")
            .attr("class", "axis y-axis");
        // .call(d3.axisLeft(this.y).ticks(null, "s"));
        this.chart
            .append("g")
            .attr("class", "grid")
            .attr("transform", "translate(" +
            (this.chartOptions.margin.left - 15) +
            "," +
            0 +
            ")")
            .call(d3
            .axisLeft(this.y)
            .scale(this.y)
            .tickSize(-requiredWidth)
            .tickFormat((d) => this.setYaxis(d)))
            .append("text")
            .attr("class", "xAxis-label")
            .attr("transform", "translate(" +
            this.width / 2 +
            "," +
            (this.height + 30 - 15) +
            ")")
            .style("fill", "#000000")
            .attr("dx", "1em")
            .style("text-anchor", "middle")
            .text(this.chartOptions.xAxisLabel);
        const sectionSpacing = this.getSectionSpacing();
        const tl = this.chart.append("g").attr("class", "threshold");
        const sectionGroup = this.chart.append("g").attr("class", "section");
        const groupLabels = this.chart
            .append("g")
            .attr("class", "x-axis-labels");
        let xPos = this.chartOptions.outerPadding;
        if (this.chartOptions.centreAlign) {
            if (this.numSections === 1) {
                xPos = this.width / 2;
            }
            else if (this.numSections === 2) {
                xPos = this.width / 3;
            }
        }
        if (this.chartOptions.centreAlign &&
            this.chartOptions.section === "rightnow") {
            xPos = this.width / 4;
        }
        let titleYPos = 0;
        let enableLocAdjustment = false;
        let adjustLocBar = false;
        this.sourceData.forEach((section, index) => {
            if (section.alignPosition === "center") {
                sectionGroup.attr("transform", "translate(" +
                    this.chart._groups[0][0].getBBox().width / 5 +
                    ", 0)");
            }
            let benchmarkDataCount = 0;
            const bars = section.values;
            const barSpacing = section.barSpacing
                ? section.barSpacing
                : this.chartOptions.barSpacing;
            const barWidth = section.barWidth
                ? section.barWidth
                : this.chartOptions.barWidth;
            const sectionWidth = this.getSectionWidth(bars, barWidth, barSpacing);
            const barGroup = sectionGroup.append("g").attr("id", "section");
            if (section.barPlacing) {
                sectionGroup.attr("transform", "translate(" +
                    (this.chartOptions.margin.left + 45) +
                    "," +
                    0 +
                    ")");
            }
            //const d3Chart = $(".d3-scrollbar-chart")[index];
            if (requiredWidth > this.width) {
                this.chart._groups[0][0].parentNode.parentNode.style.overflowX = "auto";
                this.chart._groups[0][0].parentNode.parentNode.style.overflowY = "hidden";
                this.chart._groups[0][0].parentNode.parentNode.style.background = "linear-gradient(270deg, #a697972e 0%, rgba(196, 196, 196, 0) 4%)";
                this.svg.style("min-width", requiredWidth.toString() + "px");
                this.svg.style("height", "420px !important");
            }
            else {
                this.chart._groups[0][0].parentNode.parentNode.style.overflowX = "";
                this.chart._groups[0][0].parentNode.parentNode.style.overflowY = "";
                this.chart._groups[0][0].parentNode.parentNode.style.background = "";
            }
            if (section.dataType == "benchmark") {
                benchmarkDataCount = section.values.length;
                if (benchmarkDataCount <= 4)
                    enableLocAdjustment = true;
            }
            if (section.dataType == "currentLocation" ||
                section.barPlacing ||
                section.dataType == "group" ||
                section.alignPosition === "center") {
                if (enableLocAdjustment)
                    adjustLocBar = true;
            }
            titleYPos =
                barGroup._groups[0][0].nearestViewportElement.clientHeight;
            bars.forEach((value, i) => {
                if (adjustLocBar) {
                    if (section.alignPosition === "center")
                        xPos = xPos / 2 + sectionWidth - section.barSpacing;
                    else
                        xPos = xPos / 2 + section.barWidth;
                }
                const tlXPos = xPos;
                barGroup
                    .append("rect")
                    .attr("x", xPos)
                    .attr("y", this.y(value.count))
                    .attr("width", section.barWidth)
                    .attr("height", this.height - this.y(value.count))
                    .attr("class", "bar")
                    .attr("fill", value.color ? value.color : section.color)
                    .on("mouseover", function (d) {
                    scrollbarUpdateTooltipContent(value, d, self, this);
                })
                    .on("mousemove", function (d) {
                    scrollbarUpdateTooltipContent(value, d, self, this);
                })
                    .on("mouseout", function (d) {
                    self.tip.hide();
                });
                if (section.rotateXaxis) {
                    $(".xAxis-label").hide();
                    if (bars.length > 1) {
                        barGroup
                            .append("text")
                            .attr("transform", `translate(${(tlXPos - 3 + barWidth / 2)}, ${(275)}) rotate(30)`)
                            .attr("text-anchor", "start")
                            .attr("class", "bar-label")
                            .text((d) => {
                            return this.getTruncated(value.shortLabel
                                ? value.shortLabel
                                : value.label, 15, 13);
                        });
                        //.call(self.wrap, 100);
                    }
                    else if (bars.length === 1) {
                        barGroup
                            .append("text")
                            .attr("x", tlXPos + barWidth / 2 + 40)
                            .attr("y", (titleYPos - 55))
                            .attr("text-anchor", "middle")
                            .attr("class", "bar-label")
                            .text(value.shortLabel
                            ? value.shortLabel
                            : value.label)
                            .call(self.wrap, 100);
                    }
                }
                else if (value.labelVisible) {
                    if (value.labelWrap) {
                        barGroup
                            .append("text")
                            .attr("x", tlXPos + barWidth / 2)
                            .attr("y", titleYPos - 55)
                            .attr("text-anchor", "middle")
                            .attr("class", "bar-label")
                            .text(value.shortLabel
                            ? value.shortLabel
                            : value.label)
                            .call(self.wrap, 100);
                    }
                    else {
                        barGroup
                            .append("text")
                            // .attrs({
                            // 	x: tlXPos + barWidth / 2,
                            // 	y: titleYPos - 45,
                            // 	"text-anchor": "middle",
                            // 	class: "bar-label"
                            // })
                            .attr("x", tlXPos + barWidth / 2)
                            .attr("y", titleYPos - 45)
                            .attr("text-anchor", "middle")
                            .attr("class", "bar-label")
                            .text(value.shortLabel
                            ? value.shortLabel
                            : value.label);
                    }
                }
                xPos += section.barWidth;
                if (i < bars.length - 1)
                    xPos += section.barSpacing;
                if (value.threshold)
                    this.drawThresholdLine(value, tl, tlXPos, requiredWidth); // to draw threshold line
                if (this.sourceData[0].dataType === "noOfOccupantsByRoom") {
                    this.sourceData[0].values[i]["xpos"] = tlXPos;
                }
                if (this.chartOptions.showValue)
                    this.drawValue(value, barGroup, tlXPos, section); // to draw value on top of the bar
            });
            if (this.sourceData[0].dataType === "noOfOccupantsByRoom") {
                const circleGroup = barGroup
                    .append("g")
                    .attr("class", "circle-group")
                    .attr("transform", 'translate(' + (this.chartOptions.tooltipType === 'impactAnalysisGroupLine'
                    ? (this.chartOptions.margin.left * 2)
                    : 0) + ',' + 0 + ')');
                circleGroup
                    .append("path")
                    .datum(this.sourceData[0].values)
                    .attr("class", "line")
                    .style("stroke", "#F1A43A")
                    .style("stroke-width", 2)
                    .attr("d", this.valueline);
                circleGroup
                    .selectAll("circle")
                    .data(this.sourceData[0].values)
                    .enter()
                    .append("circle")
                    .attr("class", "circle")
                    .attr("cx", (d, i) => (d.xpos) + 5)
                    .attr("cy", (d) => self.y(d.peakOccupancy))
                    .attr("r", 3)
                    .attr("fill", "#F1A43A")
                    .on("mouseover", function (d, i) {
                    self.showTooltip(d, i);
                    self.tip.show(d, this);
                })
                    .on("mouseout", function () {
                    self.tip.hide();
                });
            }
            this.drawTitle(section, barGroup, xPos, titleYPos, section.barWidth);
            if (this.sourceData[0].dataType === "timeOccupiedByRoom") {
                // barGroup.append("line") // Dont delete. its working fine
                // .attr("x1", tlXPos + barWidth / 2 + 40)
                // .attr("y1", this.y(section.avgVal))
                // .attr("x2",tlXPos + barWidth / 2 + 40)//x - 10 : x
                // .attr("y2", this.y(section.avgVal))
                // .attr("stroke", "#F1A43A")
                // .attr("stroke-width", 2);
                barGroup.append("line")
                    .attr("x1", 25)
                    .attr("y1", this.y(section.avgVal))
                    .attr("x2", xPos)
                    .attr("y2", this.y(section.avgVal))
                    .attr("stroke", "#F1A43A")
                    .attr("stroke-width", 2);
            }
            xPos += sectionSpacing;
        });
    }
    showTooltip(d, i) {
        const self = this;
        let tipContainer = "";
        self.tip.html(function (d) {
            tipContainer += "<div class = 'multiLine-tooltip'>";
            tipContainer += `<div class='multiLine-top'>Peak Occupancy</div>`;
            tipContainer += "<div class='daily-info'>";
            tipContainer += `<span style='vertical-align:middle; display:table; padding:8px; border-radius: 2px; background-color:#FFA000'></span><span class='multiLine-left'>
			${i.label}</span><span class = 'multiLine-right'>
			${i.peakOccupancy}</span>`;
            tipContainer += "</div></div>";
            return tipContainer;
        });
    }
    setFormatTooltip(value) {
        const self = this;
        let tipContainer = "";
        self.tip.html(function (d) {
            tipContainer += "<div class = 'columnChart-tooltip'>";
            if (value.displayDate)
                tipContainer +=
                    "<div class='columnChart-top'>" +
                        value.displayDate +
                        "</div>";
            else
                tipContainer +=
                    "<div class='columnChart-top'>" + value.label + "</div>";
            tipContainer += "<div class='daily-info'>";
            tipContainer +=
                "<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:" +
                    value.color +
                    "'></span><span class='multiLine-left'><span class='columnChart-left'>" +
                    value.tooltipLabel +
                    "</span><span class = 'columnChart-right'>" +
                    value.count +
                    "</span>";
            tipContainer += "</div></div>";
            return tipContainer;
        });
    }
    drawThresholdLine(value, tl, x, requiredWidth) {
        tl.append("line")
            // .attrs({
            // 	x1: value.historicalThreshold ? x - 10 : x,
            // 	y1: this.y(value.count),
            // 	x2: requiredWidth > this.width ? requiredWidth : this.width,
            // 	y2: this.y(value.count),
            // 	stroke: value.color,
            // 	"stroke-width": 2
            // });
            .attr("x1", value.historicalThreshold ? x - 10 : x)
            .attr("y1", this.y(value.count))
            .attr("x2", requiredWidth > this.width ? requiredWidth : this.width)
            .attr("y2", this.y(value.count))
            .attr("stroke", value.color)
            .attr("stroke-width", 2);
    }
    drawValue(value, bar, x, section) {
        var valueGroup = bar.append("g").attr("class", "barValue");
        valueGroup.append("rect")
            .attr("x", x - 5)
            .attr("y", this.y(value.count) - 25)
            .attr("width", section.barWidth + 10)
            .attr("height", 23)
            .attr("fill", "#fff");
        valueGroup
            .append("text")
            .attr("x", value.thresholdCount ? x + 25 : x + section.barWidth / 2)
            .attr("y", this.y(value.count) - 5)
            .attr("text-anchor", "middle")
            .attr("class", value.thresholdCount
            ? "valuesOnTop historical"
            : "valuesOnTop")
            .attr("fill", this.chartOptions.valueColor)
            // .attrs({
            // 	x: value.thresholdCount ? x + 25 : x + barWidth / 2,
            // 	y: this.y(value.count) - 5,
            // 	"text-anchor": "middle",
            // 	class: value.thresholdCount
            // 		? "valuesOnTop historical"
            // 		: "valuesOnTop",
            // 	fill: this.chartOptions.valueColor
            // })
            .text((d) => this.setBarValue(value));
    }
    setBarValue(count) {
        if (this.chartOptions.setReadableNumber) {
            if (count.thresholdCount)
                return this.readableNumber(count.thresholdCount, 0);
            else
                return this.readableNumber(Number(count.count), 1);
        }
        else {
            return count.thresholdCount ? count.thresholdCount : count.count;
        }
    }
    drawTitle(value, barGroup, x, y, barWidth) {
        let barCount = value.values.length;
        let groupX = barGroup._groups[0][0].getBBox().x;
        let groupWidth = barGroup._groups[0][0].getBBox().width;
        var xPos = groupX = groupX + (groupWidth / 2);
        var valueGroup = barGroup
            .append("g")
            .attr("class", "barGroupTitle")
            .attr("transform", "translate(" + xPos + "," + 0 + ")");
        valueGroup;
        valueGroup
            .append("text")
            .attr("y", y - 40)
            .attr("text-anchor", "middle")
            .attr("class", "groupTitle")
            // .attrs({
            // 	y: y - 40,
            // 	"text-anchor": "middle",
            // 	class: "groupTitle",
            // 	fill: this.chartOptions.groupTitleColor
            // })
            .text((d) => value.label);
    }
    update(data) {
        this.data = data;
        var elm = document.querySelector(this.element);
        elm.removeChild(elm.firstChild);
        this.createSvg();
        this.numSections = data.length;
        this.draw();
    }
    reDraw() {
        this.element.removeChild(this.element.firstChild);
        this.createSvg();
        this.draw();
    }
    wrap(text, width) {
        text.each(function () {
            var text = d3.select(this), words = text.text().split("~").reverse(), word, line = [], lineNumber = 0, lineHeight = 1, // ems
            x = text.attr("x"), y = text.attr("y"), dy = 1.1, tspan = text
                .text(null)
                .append("tspan")
                .attr("x", x)
                .attr("y", y)
                .attr("dy", dy + "em");
            while ((word = words.pop())) {
                line.push(word);
                tspan.text(line.join(" "));
                if (tspan.node().getComputedTextLength() > width) {
                    line.pop();
                    tspan.text(line.join(" "));
                    line = [word];
                    (lineHeight = 1.1), // ems
                        (tspan = text
                            .append("tspan")
                            .attr("x", x)
                            .attr("y", y)
                            .attr("dy", String((lineNumber += 1) * lineHeight + dy) +
                            "em")
                            .text(word));
                }
            }
        });
    }
}
D3ScrollbarChartComponent.ɵfac = function D3ScrollbarChartComponent_Factory(t) { return new (t || D3ScrollbarChartComponent)(i0.ɵɵdirectiveInject(DataService)); };
D3ScrollbarChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3ScrollbarChartComponent, selectors: [["lib-d3-scrollbar-chart"]], viewQuery: function D3ScrollbarChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$O, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, hostBindings: function D3ScrollbarChartComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function D3ScrollbarChartComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { options: "options", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart", "d3-scrollbar-chart"], ["chart", ""]], template: function D3ScrollbarChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: ["[_ngcontent-%COMP%]::-webkit-scrollbar-track{box-shadow:none;border-radius:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3ScrollbarChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-scrollbar-chart",
                templateUrl: "./d3-scrollbar-chart.component.html",
                styleUrls: ["./d3-scrollbar-chart.component.scss"]
            }]
    }], function () { return [{ type: DataService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ["window:resize", ["$event"]]
        }] }); })();
function scrollbarUpdateTooltipContent(value, d, self, t) {
    if (value.formatTooltip) {
        self.setFormatTooltip(value);
    }
    else {
        let tipContainer = "";
        const suffix = value.suffix ? value.suffix : "";
        self.tip.html(function (d) {
            tipContainer +=
                "<div class='top-section'><div class='top-left'>";
            if (value.tooltipLabel)
                tipContainer +=
                    "<span class='left-label'>" +
                        value.tooltipLabel +
                        "</span>";
            else
                tipContainer +=
                    "<span class='left-label'>" +
                        value.label +
                        "</span>";
            tipContainer +=
                "<span class='top-right-value'>" +
                    value.count;
            if (suffix)
                tipContainer +=
                    " <span class='suffix'>" +
                        suffix +
                        "</span>";
            tipContainer += "</span>";
            if (value.brand || value.city || value.state) {
                tipContainer +=
                    "<div class='meta-data-section'>";
                if (value.brand)
                    tipContainer +=
                        "<div class='brand'>" +
                            value.brand +
                            ", </div>";
                if (value.city)
                    tipContainer +=
                        "<div class='city'>" +
                            value.city +
                            ", </div>";
                if (value.state)
                    tipContainer +=
                        "<div class='state'>" +
                            value.state +
                            "</div>";
                tipContainer += "</div>";
            }
            tipContainer += "</div>";
            tipContainer += "</div>";
            // tipContainer += "<div class='top-right-value'>" + value.count
            // if(suffix)
            //   tipContainer += " <span class='suffix'>" + suffix + "</span>"
            // tipContainer += "</div>"
            const rankList = value.rankList;
            if (rankList) {
                tipContainer += "<div class='top-section'>";
                tipContainer +=
                    "<div class='ranking-list'>";
                rankList.forEach((rank) => {
                    tipContainer +=
                        "<div class='location-position'>" +
                            rank +
                            "</div>";
                });
                tipContainer += "</div>";
            }
            tipContainer += "</div>";
            return tipContainer;
        });
    }
    self.tip.show(d, t);
}

class D3SimplePieChartOptions {
    constructor() {
        this.margin = 20;
        this.width = 100;
        this.rangeColors = ["#5783D6", "#BB6DD9", "#C2AE59", "#5B6470"];
        this.bgColor = "#eaeaea";
        this.tooltip = {
            isEnable: true,
            className: "",
            suffix: ""
        };
    }
}

/* eslint-disable @typescript-eslint/no-this-alias */
const _c0$N = ["pie_chart"];
class D3SimplePieChartComponent {
    constructor() { }
    set options(value) {
        this.chartOptions = value || new D3SimplePieChartOptions();
    }
    set data(value) {
        if (isEmpty(value))
            return;
        this.sourceData = value;
    }
    /**
     * A callback method
     * @param changes
     */
    ngOnChanges(changes) {
        const { currentValue } = changes.data;
        if (!currentValue)
            return;
        this.initSvg();
        this.drawChart();
    }
    /**
     * Initialization of the svg
     */
    initSvg() {
        this.element = this.chartContainer.nativeElement;
        if (!this.chartOptions) {
            this.chartOptions = new D3SimplePieChartOptions();
        }
        const { clientHeight } = this.element;
        const { tooltip, margin, width, rangeColors } = this.chartOptions;
        if (this.svg) {
            this.svg.remove();
        }
        this.svg = d3
            .select(this.element)
            .append("svg")
            .attr("width", width)
            .attr("height", clientHeight);
        this.g = this.svg
            .append("g")
            .attr("transform", `translate(${(width / 2)} ,  ${(clientHeight / 2)})`);
        this.g.append("defs");
        this.color = d3.scaleOrdinal().range(rangeColors);
        this.pie = d3.pie().padAngle(0.02);
        /* this.pie = d3.pie()
       .sort(null)
       .value((d: any) => d.value);
 */
        this.outerRadius = Math.min(width, clientHeight) / 2;
        //  this.outerRadius = this.height / 2 - 20;
        const innerRadius = 0;
        this.arc = d3
            .arc()
            .padRadius(this.outerRadius - margin)
            .innerRadius(innerRadius);
        /* this.arc = d3.arc()
       .outerRadius(this.radius - margin)
 
     this.arcOnHover = d3.arc()
       .outerRadius(this.radius * 0.08)*/
        /* this.pie = d3.pie()
       .sort(null)
       .value((d: any) => d.value);*/
        if (tooltip.isEnable) {
            this.tip = d3.select("body").append("div")
                .attr("class", `d3-donut-tooltip ${this.chartOptions.tooltip.className}`)
                .style("opacity", 0);
        }
    }
    /**
     * Draw Pie Chart in the svg
     */
    drawChart() {
        const self = this;
        this.g
            .selectAll("path")
            .data(this.pie(self.sourceData))
            .enter()
            .append("path")
            .each(function (d) {
            d.outerRadius = self.outerRadius - 5;
        })
            .attr("d", this.arc)
            //.attr("fill", function (d, i) { return "url(#grad" + i + ")"; })
            .attr("fill", function (d, i) {
            return d3.rgb(self.color(i));
        })
            .attr("stroke", function (d, i) {
            return d3.rgb(self.color(i));
        });
        //  .on("mouseover", self.arcTween(self.outerRadius, 0))
        //  .on("mouseout", self.arcTween(self.outerRadius - 5, 150));
    }
    arcTween(outerRadius, delay) {
        const self = this;
        return function () {
            d3.select(this)
                .transition()
                .delay(delay)
                .attrTween("d", function (d) {
                console.log("arcTween :: ", d);
                const i = d3.interpolate(d["outerRadius"], outerRadius);
                return function (t) {
                    d["outerRadius"] = i(t);
                    return self.arc(d);
                };
            });
        };
    }
}
D3SimplePieChartComponent.ɵfac = function D3SimplePieChartComponent_Factory(t) { return new (t || D3SimplePieChartComponent)(); };
D3SimplePieChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3SimplePieChartComponent, selectors: [["lib-d3-simple-pie-chart"]], viewQuery: function D3SimplePieChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$N, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [[1, "d3-pie-chart"], ["pie_chart", ""]], template: function D3SimplePieChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [".d3-pie-chart[_ngcontent-%COMP%]{height:100%;float:left}.d3-arc[_ngcontent-%COMP%]   text[_ngcontent-%COMP%]{text-anchor:middle}.d3-arc[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke-width:1.5px;transition:fill .25s linear;transition-delay:.15s}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3SimplePieChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-simple-pie-chart",
                templateUrl: "./d3-simple-pie-chart.component.html",
                styleUrls: ["./d3-simple-pie-chart.component.scss"]
            }]
    }], function () { return []; }, { chartContainer: [{
            type: ViewChild,
            args: ["pie_chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

/* eslint-disable @typescript-eslint/unbound-method */
class D3StackedBarComponent extends D3ChartComponent {
    constructor(dataService) {
        super(dataService);
        this.dataService = dataService;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    getScaleY() {
        return d3
            .scaleLinear()
            .range([this.height, 0])
            .domain([
            0,
            d3.max(this.sourceData, function (d) {
                return d3.max(d["values"], function (obj) {
                    return (parseFloat(obj["count"]) +
                        parseFloat(obj["remaining"]));
                });
            })
        ])
            .nice();
    }
    getSectionWidth(bars, barWidth, barSpacing) {
        return bars.length * barWidth + (bars.length - 1) * barSpacing;
    }
    getSectionSpacing() {
        let totalBarWidth = 0;
        this.sourceData.forEach((section) => {
            const bars = section.values;
            const barSpacing = section.barSpacing
                ? section.barSpacing
                : this.chartOptions.barSpacing;
            let barWidth = section.barWidth
                ? section.barWidth
                : this.chartOptions.barWidth;
            if (section.type !== "average")
                barWidth = section.barWidth
                    ? section.barWidth
                    : this.chartOptions.barWidth * 3;
            totalBarWidth += this.getSectionWidth(bars, barWidth, barSpacing);
        });
        const remainingWidth = this.width - this.chartOptions.outerPadding * 2 - totalBarWidth;
        // let gSpacing = Math.floor(remainingWidth / (this.numSections - 1));
        //  return Math.max(this.chartOptions.sectionSpacing, gSpacing);
        let gSpacing = 0;
        if (this.chartOptions.centreAlign && this.numSections < 3)
            gSpacing = Math.floor(remainingWidth / 4);
        else if (this.chartOptions.section === "rightnow")
            gSpacing = Math.floor(remainingWidth / 4);
        else
            gSpacing = Math.floor(remainingWidth / (this.numSections - 1));
        return Math.max(this.chartOptions.sectionSpacing, gSpacing);
    }
    draw() {
        super.draw();
        // this.drawOuterBar(); 
        const sectionSpacing = this.getSectionSpacing();
        const tl = this.chart.append("g").attr("class", "threshold");
        const sectionGroup = this.chart.append("g").attr("class", "section");
        let xPos = this.chartOptions.outerPadding;
        let titleYPos = 0;
        const self = this;
        let enableLocAdjustment = false;
        let adjustLocBar = false;
        let adjustGroupBar = false;
        if (this.chartOptions.centreAlign) {
            if (this.numSections === 1) {
                xPos = this.width / 2;
            }
            else if (this.numSections === 2) {
                xPos = this.width / 3;
            }
        }
        this.sourceData.forEach((section) => {
            let benchmarkDataCount = 0;
            const bars = section.values;
            const barWidth = section.barWidth
                ? section.barWidth
                : this.chartOptions.barWidth;
            const barGroup = sectionGroup.append("g");
            benchmarkDataCount = section.values.length;
            if (section.barPlacing)
                sectionGroup.attr("transform", `translate(
							${(this.chartOptions.margin.left + 45)},0)`);
            if (section.dataType == "benchmark") {
                // benchmarkDataCount = section.values.length;
                if (benchmarkDataCount <= 4)
                    enableLocAdjustment = true;
            }
            if (section.dataType == "currentLocation" || section.barPlacing) {
                if (enableLocAdjustment)
                    adjustLocBar = true;
            }
            if (section.dataType == "currentGroup") {
                if (benchmarkDataCount == 1) {
                    enableLocAdjustment = true;
                    if (enableLocAdjustment)
                        adjustLocBar = true;
                }
                if (benchmarkDataCount == 2) {
                    enableLocAdjustment = true;
                    if (enableLocAdjustment)
                        adjustGroupBar = true;
                }
            }
            titleYPos =
                barGroup._groups[0][0].nearestViewportElement.clientHeight;
            bars.forEach((value, i) => {
                if (adjustLocBar)
                    xPos = xPos / 2 + section.barWidth;
                if (adjustGroupBar)
                    xPos = xPos / 2 + (section.barWidth + 50);
                const tlXPos = xPos;
                if (value.count || value.remaining) {
                    barGroup
                        .append("rect")
                        .attr("x", xPos)
                        .attr("y", 0)
                        .attr("width", section.barWidth)
                        .attr("height", this.height)
                        .attr("fill", value.bgColor ? value.bgColor : section.color)
                        .attr("class", "outer-bar")
                        .on("mouseover", function (d) {
                        self.prepareTooltip(value);
                        self.tip.show(d, this);
                    })
                        .on("mouseout", function () {
                        self.tip.hide();
                    });
                }
                else {
                    barGroup
                        .append("rect")
                        .attr("x", xPos)
                        .attr("y", 0)
                        .attr("width", section.barWidth)
                        .attr("height", 0)
                        .attr("fill", value.bgColor ? value.bgColor : section.color)
                        .attr("class", "outer-bar")
                        .on("mouseover", function (d) {
                        self.prepareTooltip(value);
                        self.tip.show(d, this);
                    })
                        .on("mouseout", function () {
                        self.tip.hide();
                    });
                }
                if (value.count || value.remaining) {
                    barGroup
                        .append("rect")
                        .attr("x", xPos)
                        .attr("y", this.y(value.count))
                        .attr("width", section.barWidth)
                        .attr("height", this.height - this.y(value.count))
                        .attr("fill", value.color ? value.color : section.color)
                        .attr("class", "bar")
                        .on("mouseover", function (d) {
                        self.prepareTooltip(value);
                        self.tip.show(d, this);
                    })
                        .on("mouseout", function () {
                        self.tip.hide();
                    });
                }
                else {
                    barGroup
                        .append("rect")
                        .attr("x", xPos)
                        .attr("y", this.y(0))
                        .attr("width", section.barWidth)
                        .attr("height", 0)
                        .attr("fill", value.bgColor ? value.bgColor : section.color)
                        .attr("class", "bar")
                        .on("mouseover", function (d) {
                        self.prepareTooltip(value);
                        self.tip.show(d, this);
                    })
                        .on("mouseout", function () {
                        self.tip.hide();
                    });
                }
                if (value.labelVisible) {
                    if (value.labelWrap) {
                        barGroup
                            .append("text")
                            // .attrs({
                            // 	x: +tlXPos + barWidth / 2,
                            // 	y: titleYPos - 55,
                            // 	"text-anchor": "middle",
                            // 	class: "bar-label"
                            // })
                            .attr("x", tlXPos + barWidth / 2)
                            .attr("y", titleYPos - 55)
                            .attr("text-anchor", "middle")
                            .attr("class", "bar-label")
                            .text(value.shortLabel
                            ? value.shortLabel
                            : value.label)
                            .call(self.wrap, 100);
                    }
                    else {
                        barGroup
                            .append("text")
                            // .attrs({
                            // 	x: +tlXPos + barWidth / 2,
                            // 	y: titleYPos - 45,
                            // 	"text-anchor": "middle",
                            // 	class: "bar-label"
                            // })
                            .attr("x", tlXPos + barWidth / 2)
                            .attr("y", titleYPos - 45)
                            .attr("text-anchor", "middle")
                            .attr("class", "bar-label")
                            .text(value.shortLabel
                            ? value.shortLabel
                            : value.label);
                    }
                }
                xPos += section.barWidth;
                if (i < bars.length - 1)
                    xPos += section.barSpacing;
                if (value.threshold)
                    this.drawThresholdLine(value, tl, tlXPos); // to draw threshold line
                // if (this.chartOptions.showValue)
                //   this.drawValue(value, barGroup, tlXPos, section.barWidth); // to draw value on top of the bar
            });
            this.drawTitle(section, barGroup, titleYPos);
            xPos += sectionSpacing;
        });
    }
    prepareTooltip(value) {
        let tipContainer = '';
        let suffix = value.suffix ? value.suffix : '';
        this.tip.html(function (d) {
            tipContainer += "<div class='top-section location-info-block'><div class='top-left'>";
            if (value.hideTitleValue) {
                if (value.displayText) {
                    tipContainer += "<span class='left-label'>" + value.displayText + "</span>";
                }
                else {
                    tipContainer += "<span class='left-label'>" + value.label + "</span>";
                }
            }
            else {
                if (value.displayText) {
                    tipContainer += "<span class='left-label'>" + value.displayText + "</span>";
                }
                else {
                    tipContainer += "<span class='left-label'>" + value.label + "</span>";
                }
                tipContainer += "</div>";
                tipContainer += "<div class='top-right'>";
                tipContainer += "<span class='top-right-value'>" + value.remaining;
                if (suffix)
                    tipContainer += " <span class='suffix'>" + suffix + "</span>";
                tipContainer += "</span>";
            }
            tipContainer += "</div>";
            tipContainer += "</div>";
            let labelList = value.labelList ? value.labelList : [];
            if (labelList) {
                tipContainer += "<div class='top-section-labelList'>";
                tipContainer += "<div class='legend-list'>";
                tipContainer += "<div class='legend-indicator' style='background-color: " + value.color + "; border-color: " + value.color + ";'></div>";
                tipContainer += "<div class='legend-indicator' style='background-color: " + value.bgColor + "; border-color: " + value.bgColor + ";'></div>";
                tipContainer += "</div>";
                tipContainer += "<div class='label-list'>";
                labelList.forEach(label => {
                    tipContainer += "<div class='label-name'>" + label + "</div>";
                });
                tipContainer += "</div>";
                tipContainer += "<div class='label-list-count'>";
                tipContainer += " <span class='count'>" + value.count + suffix + "</span>";
                tipContainer += " <span class='count'>" + value.remaining + suffix + "</span>";
                tipContainer += "</div>";
                tipContainer += "</div>";
            }
            if (value.brand || value.city || value.state) {
                tipContainer += "<div class='meta-data-section stacked-bar-metadata'>";
                if (value.brand)
                    tipContainer += "<div class='brand'>" + value.brand + ", </div>";
                if (value.city)
                    tipContainer += "<div class='city'>" + value.city + ", </div>";
                if (value.state)
                    tipContainer += "<div class='state'>" + value.state + "</div>";
                tipContainer += "</div>";
            }
            let rankList = value.rankList;
            if (rankList) {
                tipContainer += "<div class='top-section'>";
                tipContainer += "<div class='ranking-list'>";
                rankList.forEach(rank => {
                    tipContainer += "<div class='location-position'>" + rank + "</div>";
                });
                tipContainer += "</div>";
            }
            tipContainer += "</div>";
            return tipContainer;
        });
    }
    drawThresholdLine(value, tl, x) {
        tl.append("line")
            // .attrs({
            // 	x1: value.historicalThreshold ? x - 10 : x,
            // 	y1: this.y(value.count),
            // 	x2: this.width,
            // 	y2: this.y(value.count),
            // 	stroke: value.color,
            // 	"stroke-width": 2
            // });
            .attr("x1", value.historicalThreshold ? x - 10 : x)
            .attr("y1", this.y(value.count))
            .attr("x2", this.width)
            .attr("y2", this.y(value.count))
            .attr("stroke", value.color)
            .attr("stroke-width", 2);
    }
    drawValue(value, bar, x, barWidth) {
        const valueGroup = bar.append("g").attr("class", "barValue");
        valueGroup.append("rect")
            // .attrs({
            // 	x: x - 5,
            // 	y: this.y(value.count) - 25,
            // 	width: +barWidth + 10,
            // 	height: 23,
            // 	fill: "#fff"
            // });
            .attr("x", x - 5)
            .attr("y", this.y(value.count) - 25)
            .attr("width", barWidth + 10)
            .attr("height", 23)
            .attr("fill", "#fff");
        valueGroup
            .append("text")
            // .attrs({
            // 	x: value.thresholdCount ? +x + 25 : +x + barWidth / 2,
            // 	y: this.y(value.count) - 5,
            // 	"text-anchor": "middle",
            // class: value.thresholdCount
            // 	? "valuesOnTop historical"
            // 	: "valuesOnTop",
            // 	fill: this.chartOptions.valueColor
            // })
            .attr("x", value.thresholdCount ? +x + 25 : +x + barWidth / 2)
            .attr("y", this.y(value.count) - 5)
            .attr("text-anchor", "middle")
            .attr("class", value.thresholdCount ? "valuesOnTop historical" : "valuesOnTop")
            .attr("fill", this.chartOptions.valueColor)
            .text(() => {
            const values = value.thresholdCount
                ? value.thresholdCount
                : value.count;
            return values;
        });
    }
    drawTitle(value, barGroup, y) {
        let groupX = barGroup._groups[0][0].getBBox().x;
        const groupWidth = barGroup._groups[0][0].getBBox().width;
        const xPos = groupX = groupX + (groupWidth / 2);
        const valueGroup = barGroup
            .append("g")
            .attr("class", "barGroupTitle")
            .attr("transform", `translate(${xPos}, 0)`);
        valueGroup;
        valueGroup
            .append("text")
            // .attrs({
            // 	y: y - 40,
            // 	"text-anchor": "middle",
            // 	class: "groupTitle",
            // 	fill: this.chartOptions.groupTitleColor
            // })
            .attr("y", y - 40)
            .attr("text-anchor", "middle")
            .attr("class", "groupTitle")
            .attr("fill", this.chartOptions.groupTitleColor)
            .text(() => {
            return value.label;
        });
    }
    update(data) {
        super.update(data);
        this.y = this.getScaleY();
        this.numSections = data.length;
        // super.draw();
        this.draw();
    }
    reDraw() {
        super.reDraw();
        this.y = this.getScaleY();
        // super.draw();
        this.draw();
    }
    wrap(text, width) {
        text.each(function () {
            const text = d3.select(this), words = text.text().split("~").reverse();
            let word, line = [], lineNumber = 0, lineHeight = 1; // ems
            const x = text.attr("x"), y = text.attr("y"), dy = 1.1;
            let tspan = text
                .text(null)
                .append("tspan")
                .attr("x", x)
                .attr("y", y)
                .attr("dy", `${dy}em`);
            while ((word = words.pop())) {
                line.push(word);
                tspan.text(line.join(" "));
                if (tspan.node().getComputedTextLength() > width) {
                    line.pop();
                    tspan.text(line.join(" "));
                    line = [word];
                    (lineHeight = 1.1), // ems
                        (tspan = text
                            .append("tspan")
                            .attr("x", x)
                            .attr("y", y)
                            .attr("dy", String((lineNumber += 1) * lineHeight + dy) +
                            "em")
                            .text(word));
                }
            }
        });
    }
}
D3StackedBarComponent.ɵfac = function D3StackedBarComponent_Factory(t) { return new (t || D3StackedBarComponent)(i0.ɵɵdirectiveInject(DataService)); };
D3StackedBarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3StackedBarComponent, selectors: [["lib-d3-stacked-bar"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 0, consts: [[1, "d3-chart"], ["chart", ""]], template: function D3StackedBarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3StackedBarComponent, [{
        type: Component,
        args: [{
                selector: "lib-d3-stacked-bar",
                templateUrl: "./d3-stacked-bar.component.html",
                styleUrls: ["./d3-stacked-bar.component.scss"]
            }]
    }], function () { return [{ type: DataService }]; }, null); })();

const _c0$M = ["chart"];
const moment$d = moment_;
class D3StackedLineChartComponent {
    constructor() {
        this.sourceData = [];
        this.bmData = [];
        this.sData = [];
        this.ticks = [];
        this.dateTickValues = [];
        this.tickValues = [];
        this.updateTooltipContent = (event, mouse) => {
            var self = this;
            var dist = { x: 40, y: 40 };
            var m = d3.pointer(event, self.svg.node());
            self.scr.x = window.scrollX;
            self.scr.y = window.scrollY;
            m[0] += self.svgpos.x;
            m[1] += self.svgpos.y;
            self.tooltip.selectAll("div").remove();
            var index = 0;
            self.tooltip.style("right", "");
            self.tooltip.style("left", "");
            self.tooltip.style("bottom", "");
            self.tooltip.style("top", "");
            if (m[0] > self.scr.x + self.elementAttr.w / 2) {
                self.tooltip.style("right", (self.elementAttr.w - m[0] + dist.x) + "px");
            }
            else {
                self.tooltip.style("left", (m[0] + dist.x) + "px");
            }
            self.tooltip.style("bottom", (m[1] + dist.y) + "px");
            self.tooltip
                .style('display', 'block')
                .style('font-size', 11.5)
                .style('z-index', "1000")
                .style('padding', '10px 15px')
                .style('min-width', '220px')
                .selectAll()
                .data(self.sourceData).enter() // for each vehicle category, list out name and price of premium
                .append('div')
                .style('color', d => {
                return "#fff";
            })
                .style('font-size', 10)
                .html(d => {
                let tipContainer = '';
                var xDate = self.xScale.invert(mouse[0]);
                var bisect = d3.bisector(function (d) { return d["date"]; }).left;
                var idx = bisect(d.values, xDate);
                const icons = this.chartOptions.toolTipIcons;
                const suffix = '%';
                if (d.values[idx]) {
                    index += 1;
                    let tooltipText = "<div class = 'multiLine-tooltip'>" + ((index == 1) ? "<div class='multiLine-top'>" + d.values[idx].displayDate + "</div>" : "");
                    self.keys.forEach((key) => {
                        tooltipText = tooltipText + "<div class='daily-info'>"
                            + `<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:${icons[key]}'></span>
               <span class='multiLine-left'>
              ${key}</span><span class = 'multiLine-right'>
              ${d.values[idx][key]}
              </span><span class='suffix'>${suffix}</span>`
                            + "</div>";
                    })
                        + "</div>";
                    // + "<div class='daily-info'>" + "<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:" + d.values[idx].color + "'></span><span class='multiLine-left'>" + d.values[idx].key + "</span><span class = 'multiLine-right'>" + d.values[idx].count + "</span>"
                    // + "</div></div>";
                    return tooltipText;
                }
                else {
                    self.tooltip.style("display", "none");
                }
                return "";
            });
        };
        window.addEventListener("resize", this.reDraw.bind(this));
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (this.tooltip) {
            this.tooltip.remove();
        }
        if ((!value || value.length == 0))
            return;
        this.sourceData = value;
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    reDraw() {
        // this.chartContainer.nativeElement.remove()
        if (this.tooltip) {
            this.tooltip.remove();
        }
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg)
            this.svg.remove();
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("transform", `translate(0,
					${this.chartOptions.margin.top - 20})`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg.append("g").attr("transform", `translate(10,20)`);
        this.getxScale();
        this.getyScale();
        // this.getLine();
        this.getArea();
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(function (d) {
            return "<div id='bi-tooltip line-chart'></div>";
        });
        this.svg.call(this.tip);
        const body = d3.select(element.closest("body"));
        const container = d3.select(element);
        this.scr = {
            x: window.scrollX,
            y: window.scrollY,
            w: window.innerWidth,
            h: window.innerHeight
        };
        if (!this.chartOptions.isPosTooltip) {
            this.elementAttr = {
                w: isNull(body.node()) ? 0 : body.node().offsetWidth,
                h: body.node().offsetHeight
            };
            this.svgpos = this.getNodePos(this.svg.node(), body);
        }
        else {
            this.elementAttr = {
                w: isNull(container.node()) ? 0 : container.node().offsetWidth,
                h: container.node().offsetHeight
            };
            this.svgpos = this.getNodePos(this.svg.node(), container);
        }
        this.streamColors = d3.scaleOrdinal().range(this.chartOptions.rangeColors);
        this.keys = this.sourceData.map(function (d) {
            return d.keys;
        });
        this.keys = this.keys[0];
        this.streamColors.domain(this.keys);
    }
    getNodePos(el, element) {
        var body = element.node();
        for (var lx = 0, ly = 0; el != null && el != body; lx += el.offsetLeft || el.clientLeft,
            ly += el.offsetTop || el.clientTop,
            el = el.offsetParent || el.parentNode)
            ;
        return { x: lx, y: ly };
    }
    draw() {
        let dateArray = [];
        let self = this;
        if (this.chartOptions.xAxisFormat == "date") {
            if (this.chartOptions.xAxisTickFormat != "th" &&
                this.chartOptions.xAxisTickFormat != "") {
                if (this.chartOptions.xTranslate) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left + 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)))
                        .selectAll("text")
                        .style("text-anchor", "end")
                        .attr("dx", "-.8em")
                        .attr("dy", "-.55em")
                        .attr("transform", this.chartOptions.xTranslate);
                }
                else {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)));
                }
            }
            else {
                if (this.dateTickValues.length > 3 &&
                    this.dateTickValues.length <= 8) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(4)
                        .tickFormat(d3.timeFormat("%d %b")));
                }
                else if (this.dateTickValues.length < 3) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(1)
                        .tickFormat(d3.timeFormat("%d %b")));
                }
                else if (this.dateTickValues.length === 3) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(2)
                        .tickFormat(d3.timeFormat("%d %b")));
                }
                else {
                    if (self.tickMonths.size > 1 && self.tickMonths.size < 8) {
                        this.chart
                            .append("g")
                            .attr("class", "x axis")
                            .attr("width", "100%")
                            .attr("transform", `translate(
                    ${this.chartOptions.margin.left - 5},${this.height})`)
                            .call(d3
                            .axisBottom(this.xScale)
                            .scale(this.xScale)
                            .ticks(d3.timeMonth.every(1))
                            .tickFormat(d3.timeFormat("%d %b")));
                    }
                    else if (self.tickMonths.size > 7) {
                        let xaxis = this.chart
                            .append("g")
                            .attr("class", "x axis")
                            .attr("width", "100%")
                            .attr("transform", `translate(
                    ${this.chartOptions.margin.left - 5},${this.height})`, "rotate(90)")
                            .call(d3
                            .axisBottom(this.xScale)
                            .scale(this.xScale)
                            .ticks(d3.timeMonth.every(1))
                            .tickFormat(d3.timeFormat("%d %b")));
                        xaxis.selectAll("text")
                            .style("text-anchor", "end")
                            .attr("dx", "-.8em")
                            .attr("dy", ".15em")
                            .attr("transform", (d) => {
                            return "rotate(-30)";
                        });
                    }
                    else {
                        this.chart
                            .append("g")
                            .attr("class", "x axis")
                            .attr("width", "100%")
                            .attr("transform", `translate(
                        ${this.chartOptions.margin.left - 15},${this.height})`)
                            .call(d3
                            .axisBottom(this.xScale)
                            .scale(this.xScale)
                            .ticks(d3.timeMonth.every(1))
                            .tickFormat(d3.timeFormat("%d %b")));
                    }
                }
            }
        }
        else if (this.chartOptions.xAxisFormat == "hour_of_day") {
            const sortedTicks = this.preparexAxisTicks();
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
							${this.chartOptions.margin.left - 15},${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickValues(sortedTicks)
                .tickFormat(d3.timeFormat("%I %p")));
        }
        else if (this.chartOptions.xAxisFormat == "time") {
            let timeFormat = d3.timeFormat("%I %p");
            console.log("D3 multiline :: draw :: hour of day ", this.xScale);
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
							${this.chartOptions.margin.left - 15},${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .ticks(24)
                .tickFormat(d3.timeFormat("%I %p"))
                .tickValues(this.tickValues.filter(function (d) {
                if (dateArray.length > 0 &&
                    dateArray.indexOf(timeFormat(d)) != -1) {
                    return false;
                }
                else {
                    dateArray.push(timeFormat(d));
                    return true;
                }
            })));
        }
        else if (this.chartOptions.xAxisFormat == "day") {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
							${this.chartOptions.margin.left - 15},${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickFormat(d3.timeFormat("%A"))
                .ticks(7));
        }
        else if (this.chartOptions.xAxisFormat === "dateTime") {
            if (this.dateTickValues.length <= 8) {
                const sortedTicks = this.nonRepeativeTicks();
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr("transform", `translate(
								${this.chartOptions.margin.left - 15},${this.height})`)
                    .call(d3
                    .axisBottom(this.xScale)
                    .scale(this.xScale)
                    .tickValues(sortedTicks)
                    .tickFormat(d3.timeFormat("%d %b, %I %p")));
            }
            else {
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr("transform", `translate(
								${this.chartOptions.margin.left - 15},${this.height})`)
                    .call(d3
                    .axisBottom(this.xScale)
                    .scale(this.xScale)
                    .tickFormat(d3.timeFormat("%d %b, %I %p")));
            }
        }
        else if (this.chartOptions.xAxisFormat === "dateTimeMetrics") {
            if (this.chartOptions.yTickValues.length > 0) {
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr("transform", `translate(
						${this.chartOptions.margin.left + 15},${this.height})`)
                    .call(d3
                    .axisBottom(this.xScale)
                    .scale(this.xScale)
                    .ticks(d3.timeHour.every(4))
                    .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)))
                    .selectAll("text")
                    .style("text-anchor", "end")
                    .attr("dx", "-.8em")
                    .attr("dy", "-.55em")
                    .attr("transform", this.chartOptions.xTranslate);
            }
            else {
                this.chart
                    .append("g")
                    .attr("class", "x axis")
                    .attr("width", "100%")
                    .attr("transform", `translate(
						${this.chartOptions.margin.left + 15},${this.height})`)
                    .call(d3
                    .axisBottom(this.xScale)
                    .scale(this.xScale)
                    .ticks(d3.timeHour.every(4))
                    .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)))
                    .selectAll("text")
                    .style("text-anchor", "end")
                    .attr("dx", "-.8em")
                    .attr("dy", "-.55em")
                    .attr("transform", this.chartOptions.xTranslate);
            }
        }
        else if (this.chartOptions.xAxisFormat === "time_of_hour") {
            if (this.chartOptions.xAxisTickFormat != "th" &&
                this.chartOptions.xAxisTickFormat != "") {
                if (this.chartOptions.xTranslate) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left + 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(d3.timeMinute.every(10))
                        /*.tickFormat(
                            d3.timeFormat(
                                this.chartOptions.xAxisTickFormat
                            )
                        )*/ .tickFormat(d3.timeFormat("%H:%M %p")))
                        .selectAll("text")
                        .style("text-anchor", "end")
                        .attr("dx", "-.8em")
                        .attr("dy", "-.55em")
                        .attr("transform", this.chartOptions.xTranslate);
                }
                else {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .tickFormat(d3.timeFormat(this.chartOptions.xAxisTickFormat)));
                }
            }
            else {
                if (this.dateTickValues.length > 3 &&
                    this.dateTickValues.length <= 8) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
								${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(4)
                        .tickFormat(d3.timeFormat("%H:%M %p")));
                }
                else if (this.dateTickValues.length < 3) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(1)
                        .tickFormat(d3.timeFormat("%H:%M %p")));
                }
                else if (this.dateTickValues.length === 3) {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .ticks(2)
                        .tickFormat(d3.timeFormat("%H:%M %p")));
                }
                else {
                    this.chart
                        .append("g")
                        .attr("class", "x axis")
                        .attr("width", "100%")
                        .attr("transform", `translate(
									${this.chartOptions.margin.left - 15},${this.height})`)
                        .call(d3
                        .axisBottom(this.xScale)
                        .scale(this.xScale)
                        .tickFormat(d3.timeFormat("%H:%M %p")));
                }
            }
        }
        else if (this.chartOptions.xAxisFormat == "week_day") {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                .attr("transform", `translate(
							${this.chartOptions.margin.left - 15},${this.height})`)
                .call(d3
                .axisBottom(this.xScale)
                .ticks(d3.timeDay.every(1))
                .scale(this.xScale)
                .tickFormat(d3.timeFormat("%a"))
            //.ticks(7)
            );
        }
        else {
            this.chart
                .append("g")
                .attr("class", "x axis")
                .attr("width", "100%")
                /*.attr(
                    "transform",
                    `translate(
                            ${this.chartOptions.margin.left - 15},${this.height})`
                )*/ .attr("transform", this.chartOptions.xTranslate)
                .call(d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickFormat(d3.timeFormat("%d %b")));
        }
        this.chart
            .append("g")
            .attr("class", "y axis")
            .attr("transform", `translate(
						${(this.chartOptions.margin.left + 5)},0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(this.width + 35))
            .ticks(3)
            .tickFormat((d) => this.readableNumber(d, 2)));
        this.chart
            .selectAll(".axis .tick text")
            .attr("fill", "#1d3243")
            .attr("font-size", "9px");
        this.chart.selectAll(".y.axis .tick line").attr("stroke", "#f9f0f0");
        this.chart
            .selectAll(".x.axis .tick line")
            .attr("stroke", "transparent");
        this.chart.selectAll(".axis .domain").attr("stroke", "transparent");
        this.chart
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - (this.chartOptions.margin.left - 15))
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .attr("fill", "#000000")
            .attr("text-anchor", "middle")
            .attr("font-size", "10px")
            .attr("font-family", "ciscoSans")
            .attr("text-transform", "uppercase")
            .style("font-weight", "700")
            .style("line-height", "1.5")
            .text(this.chartOptions.yAxisLabel);
        this.chart
            .append("g")
            .attr("class", "grid")
            .attr("transform", `translate(
						${(this.chartOptions.margin.left + 6)},0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(this.width + 35))
            .tickFormat(() => this.chartOptions.yAxisTickFormat));
        this.chart.selectAll(".grid .tick line").attr("stroke", "transparent");
        this.chart.selectAll(".grid .domain").attr("stroke", "transparent");
        this.chart
            .append("g")
            .attr("class", "x-axis-label")
            .append("text")
            .text(this.chartOptions.xAxisLabel)
            .attr("transform", `translate( 
					${((this.width / 2) + 40)} 
					, ${(this.height + 40)})`)
            .attr("text-anchor", "middle");
        /*	lines
            .selectAll(".line-group")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "line-group")
            .attr(
              "transform",
              `translate(
                ${(this.chartOptions.margin.left - 15)},0)`
            )
            .append("path")
            .attr("class", "line")
            .attr("d", function (d) {
              return self.valueline(d.values);
            })
            .attr("stroke", function (d) {
              return d.color;
            })
            .attr("fill", "none");
      
      */
        const streamLines = this.chart.append("g").attr("class", "area-group");
        streamLines
            .selectAll(".area-group")
            .data(d3.stack().keys(this.keys)(this.sourceData[0].values))
            .enter()
            .append("g")
            .attr("class", "area-group")
            .attr("transform", `translate(
            ${(this.chartOptions.margin.left - 15)},0)`)
            .append('path')
            .attr("class", "area")
            .attr("d", d3.area()
            .x(function (d) { return self.xScale(d["data"].date); })
            .y0(function (d) { return self.yScale(d[0]); })
            .y1(function (d) { return self.yScale(d[1]); }))
            .style("fill", (d) => this.streamColors(d.key));
        if (!self.chartOptions.hideMouseOverEffects) {
            self.showMouseOverTooltip();
        }
    }
    getxScale() {
        let completeData = [];
        let keyValues = [];
        var self = this;
        this.ticks = [];
        this.dateTickValues = [];
        let tickMonthArray = new Set();
        this.tickMonths = new Set();
        this.sourceData.forEach(function (d) {
            keyValues = [];
            d["values"].forEach(function (obj) {
                if (self.chartOptions.xAxisFormat === "date" ||
                    self.chartOptions.xAxisFormat === "dateTime" ||
                    self.chartOptions.xAxisFormat === "dateTimeMetrics" ||
                    self.chartOptions.xAxisFormat === "time_of_hour" ||
                    self.chartOptions.xAxisFormat === "week_day") {
                    const parseTime = d3.timeParse(self.chartOptions.xAxisDateFormat);
                    const formatedDate = parseTime(obj.date);
                    if (formatedDate)
                        obj.date = parseTime(obj.date);
                    keyValues.push(obj.date);
                }
                else {
                    keyValues.push(obj.date);
                }
                tickMonthArray.add(obj.date.getMonth());
                //obj.count = +obj.count;
                self.ticks.push(obj.date);
                if (self.tickValues.findIndex((i) => i.toString() == obj.date) == -1) {
                    self.tickValues.push(obj.date);
                }
                completeData.push(obj);
            });
        });
        this.tickMonths = tickMonthArray;
        console.log(" ################# . :: tickMonths::  ", this.tickMonths);
        this.dateTickValues = keyValues;
        this.xScale = d3
            .scaleTime()
            .range([
            this.chartOptions.margin.left,
            this.width - this.chartOptions.margin.right
        ])
            .domain(d3.extent(keyValues, function (d) {
            return d;
        }));
    }
    getyScale() {
        this.yScale = d3
            .scaleLinear()
            .range([this.height, 0])
            .domain([
            0,
            d3.max(this.sourceData, function (d) {
                return d3.max(d["values"], function (obj) {
                    return parseFloat(obj["count"]) > 10
                        ? parseFloat(obj["count"])
                        : 10;
                });
            })
        ])
            .nice();
    }
    // getStatusYScale(): void {
    // 	this.yScale = d3
    // 		.scaleLinear()
    // 		.range([this.height, 0])
    // 		.domain([
    // 			0,
    // 			1
    // 		])
    // 		.nice();
    // }
    getLine() {
        let self = this;
        this.valueline = d3
            .line()
            .x(function (d) {
            return self.xScale(d["date"]);
        })
            .y(function (d) {
            return self.yScale(d["count"]);
        });
        //.curve(d3.curveMonotoneX)
    }
    getArea() {
        this.area = d3
            .area()
            .x(d => this.xScale(d["date"]))
            .y0(d => this.yScale(d[0]))
            .y1(d => this.yScale(d[1]));
    }
    readableNumber(value, decimalPoint) {
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return "0";
        }
        decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
        var numCount = value.toPrecision(2).split("e"), // get power
        noOfK = numCount.length === 1
            ? 0
            : Math.floor(Math.min(numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        dividedValue = noOfK < 1
            ? value.toFixed(0 + decimalPoint)
            : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
        finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
        suffix = `${finalValue + ["", "K", "M", "B", "T"][noOfK]}`; // append power
        return suffix;
    }
    // to display alernative ticks
    preparexAxisTicks() {
        this.ticks.forEach((obj, i) => {
            this.ticks.splice(i + 1, 1);
        });
        return this.ticks;
    }
    // to display all ticks for 8 data points
    nonRepeativeTicks() {
        this.ticks.forEach((obj, i) => {
            this.ticks.splice(i, 0);
        });
        return this.ticks;
    }
    showMouseOverTooltip() {
        var self = this;
        const element = self.chartContainer.nativeElement;
        // CREATE HOVER TOOLTIP WITH VERTICAL LINE //
        self.tooltip = d3
            .select(element)
            .append("div")
            .attr("id", "tooltip")
            .style("position", "absolute")
            .style("background-color", "#263b4c")
            .style("padding", 6)
            .style("display", "none");
        self.tooltip
            .transition()
            .duration(300)
            .style("opacity", 0);
        this.mouseG = this.chart
            .append("g")
            .attr("class", "mouse-over-effects");
        var res_nested = d3.group(this.sourceData, (d) => d["name"]);
        var mousePerLine = this.mouseG
            .selectAll(".mouse-per-line")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "mouse-per-line");
        mousePerLine
            .append("circle")
            .attr("r", 4)
            .attr("stroke", function (d) {
            return d.color;
        })
            .attr("fill", "none")
            .style("opacity", "0");
        this.mouseG
            .append("svg:rect") // append a rect to catch mouse movements on canvas
            .attr("width", this.width)
            .attr("height", this.height)
            .attr("transform", `translate(
					${this.chartOptions.margin.left - 15},0)`)
            .attr("fill", "none")
            .attr("pointer-events", "all")
            .on("mouseout", function () {
            // on mouse out hide line, circles and text
            d3.select(element).select(".mouse-line").style("opacity", "0");
            d3.select(element)
                .selectAll(".mouse-per-line circle")
                .style("opacity", "0");
            d3.select(element)
                .selectAll(".mouse-per-line text")
                .style("opacity", "0");
            setTimeout(() => {
                var displayAtrr = d3
                    .select(element)
                    .select("#tooltip")
                    .style("display");
                if (displayAtrr && displayAtrr === "block")
                    d3.select(element)
                        .select("#tooltip")
                        .style("display", "none");
                self.tooltip.style('opacity', 0);
            }, 100);
        })
            .on("mouseover", function () {
            // on mouse in show line, circles and text
            d3.select(element).select(".mouse-line").style("opacity", "1");
            d3.select(element)
                .selectAll(".mouse-per-line circle")
                .style("opacity", "1");
            d3.select(element).select("#tooltip").style("display", "block");
            self.tooltip
                .transition()
                .duration(300)
                .style("opacity", 1);
        })
            .on("mousemove", function (d) {
            // update tooltip content, line, circles and text when mouse moves
            const mouse = d3.pointer(d, this);
            d3.select(element)
                .selectAll(".mouse-per-line")
                .attr("transform", function (d) {
                const xDate = self.xScale.invert(mouse[0]); // use 'invert' to get date corresponding to distance from mouse position relative to svg
                const bisect = d3.bisector(function (d) {
                    return d["date"];
                }).left; // retrieve row index of date on parsed csv
                const idx = bisect(d["values"], xDate);
                d3.select(element)
                    .select(".mouse-line")
                    .attr("d", function () {
                    var data = "M" + self.xScale(d["values"][idx]["date"]) + "," + (self.height);
                    data += " " + self.xScale(d["values"][idx]["date"]) + "," + 0;
                    return data;
                });
                let xTrans;
                let yTrans = 0.0;
                if (d["values"][idx]) {
                    xTrans =
                        parseFloat(self.xScale(d["values"][idx]["date"])) +
                            (self.chartOptions.margin.left - 15);
                    yTrans = self.yScale(d["values"][idx]["count"]);
                }
                else {
                    d3.select(element)
                        .selectAll(".mouse-per-line circle")
                        .style("opacity", "0");
                    xTrans = self.chartOptions.margin.left;
                }
                return `translate(${xTrans},${yTrans})`;
            });
            if (self.chartOptions.defaultTooltipPos) {
                self.defaultTooltip(d, mouse);
            }
            else {
                self.updateTooltipContent(d, mouse);
            }
        })
            .on("mouseout", function (d, i) {
            self.tooltip.style('opacity', 0);
            self.tooltip.style('display', "none");
        });
    }
    defaultTooltip(event, mouse) {
        var self = this;
        self.tooltip.selectAll("div").remove();
        var pageX = `${(event.pageX + 20) / 2}px`;
        var pageY = `${(event.pageY - 20) / 10}px`;
        let index = 0;
        self.tooltip
            .style("display", "block")
            .style("left", pageX)
            .style("top", pageY)
            .style("font-size", 11.5)
            .style("z-index", "1000")
            // .style('min-width', '220px')
            .selectAll()
            .data(self.sourceData)
            .enter()
            .append("div")
            .style("color", (d) => {
            // return d.color
            return "#fff";
        })
            .style("font-size", 10)
            .html(d => {
            var xDate = self.xScale.invert(mouse[0]);
            var bisect = d3.bisector(function (d) {
                return d["date"];
            }).left;
            var idx = bisect(d.values, xDate);
            idx = idx - 1;
            if (d.values[idx]) {
                console.log(`line chart :: tool tip :: if value    ${idx}   ,
						${d.values[idx]}`);
                self.tooltip.style("min-width", "220px");
                self.tooltip.style("display", "block");
                // self.tooltip.style("padding", "10px 15px");
                index += 1;
                const values = index == 1
                    ? `<div class='multiLine-top'> ${d.values[idx].displayDate} </div>`
                    : ``;
                return `<div class = 'multiLine-tooltip'>${values}
					<div class='daily-info'> 
					<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:
					${d.values[idx].color}
					'></span><span class='multiLine-left'> 
					${d.values[idx].name}
					</span><span class = 'multiLine-right'> 
					${d.values[idx].count}
					</span> 
					</div></div>`;
            }
            else {
                self.tooltip.style("min-width", "0");
                self.tooltip.style("padding", "0");
            }
        });
    }
}
D3StackedLineChartComponent.ɵfac = function D3StackedLineChartComponent_Factory(t) { return new (t || D3StackedLineChartComponent)(); };
D3StackedLineChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3StackedLineChartComponent, selectors: [["lib-d3-stacked-line-chart"]], viewQuery: function D3StackedLineChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$M, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart-new"], ["chart", ""]], template: function D3StackedLineChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3StackedLineChartComponent, [{
        type: Component,
        args: [{
                selector: 'lib-d3-stacked-line-chart',
                templateUrl: './d3-stacked-line-chart.component.html',
                styleUrls: ['./d3-stacked-line-chart.component.scss']
            }]
    }], function () { return []; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

function DatePickerComponent_my_date_picker_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "my-date-picker", 1);
    i0.ɵɵlistener("ngModelChange", function DatePickerComponent_my_date_picker_0_Template_my_date_picker_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.model = $event; })("dateChanged", function DatePickerComponent_my_date_picker_0_Template_my_date_picker_dateChanged_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.onDateChanged($event); })("onCalendarToggle", function DatePickerComponent_my_date_picker_0_Template_my_date_picker_onCalendarToggle_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.onCalendarToggle($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("options", ctx_r0.myDatePickerOptions)("ngModel", ctx_r0.model)("placeholder", ctx_r0.placeholder);
} }
class DatePickerComponent {
    constructor() {
        this.placeholder = "Select a date";
        this.selectedDate = new EventEmitter();
        this.myDatePickerOptions = {
        // other options...
        };
        // Initialized to specific date (09.10.2018).
        this.model = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    ngOnInit() {
    }
    set setDate(value) {
        if (value) {
            this.result = Object.assign(value);
        }
        if (!value.date) {
            return;
        }
        this.result = Object.assign(value);
        this.model = { jsdate: value.date };
        this.myDatePickerOptions = {
            // other options...
            editableDateField: value.editableDateField,
            dateFormat: value.dateFormat,
            showTodayBtn: value.showTodayBtn,
            inline: value.inline,
            allowDeselectDate: value.allowDeselectDate
        };
        if (value.disableUntil) {
            this.myDatePickerOptions.disableUntil = {
                year: value.disableUntil.getFullYear(),
                month: value.disableUntil.getMonth() + 1,
                day: value.disableUntil.getDate()
            };
        }
        if (value.disableSince) {
            this.myDatePickerOptions.disableSince = {
                year: value.disableSince.getFullYear(),
                month: value.disableSince.getMonth() + 1,
                day: value.disableSince.getDate()
            };
        }
    }
    set disableUntil(value) {
        if (value != null) {
            this.myDatePickerOptions = {
                // other options...
                dateFormat: this.result.dateFormat,
                showTodayBtn: this.result.showTodayBtn,
                inline: this.result.inline,
                allowDeselectDate: this.result.allowDeselectDate
            };
            this.myDatePickerOptions.disableUntil = {
                year: value.getFullYear(),
                month: value.getMonth() + 1,
                day: value.getDate()
            };
            if (this.result.disableSince) {
                const disableSince = this.result.disableSince;
                this.myDatePickerOptions.disableSince = {
                    year: disableSince.getFullYear(),
                    month: disableSince.getMonth() + 1,
                    day: disableSince.getDate()
                };
            }
        }
    }
    set changeDate(value) {
        if (value) {
            this.model = { jsdate: value };
        }
    }
    onDateChanged(event) {
        // event properties are: event.date, event.jsdate, event.formatted and event.epoc
        // console.log('onDateChanged :: ',event);
        const dateObj = {
            date: event.date,
            jsdate: event.jsdate,
            formatted: event.formatted,
            epoc: event.epoc
        };
        this.selectedDate.emit(dateObj);
    }
    onCalendarToggle(event) {
        console.log("onCalendarToggle");
    }
}
DatePickerComponent.ɵfac = function DatePickerComponent_Factory(t) { return new (t || DatePickerComponent)(); };
DatePickerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DatePickerComponent, selectors: [["lib-app-date-picker"]], inputs: { setDate: "setDate", disableUntil: "disableUntil", changeDate: "changeDate" }, outputs: { selectedDate: "selectedDate" }, decls: 1, vars: 1, consts: [["name", "mydate", "required", "", 3, "options", "ngModel", "placeholder", "ngModelChange", "dateChanged", "onCalendarToggle", 4, "ngIf"], ["name", "mydate", "required", "", 3, "options", "ngModel", "placeholder", "ngModelChange", "dateChanged", "onCalendarToggle"]], template: function DatePickerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DatePickerComponent_my_date_picker_0_Template, 1, 3, "my-date-picker", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.model);
    } }, directives: [i1$2.NgIf, i2$3.MyDatePicker, i2$1.RequiredValidator, i2$1.NgControlStatus, i2$1.NgModel], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatePickerComponent, [{
        type: Component,
        args: [{
                selector: "lib-app-date-picker",
                templateUrl: "./date-picker.component.html",
                styleUrls: ["./date-picker.component.css"]
            }]
    }], function () { return []; }, { selectedDate: [{
            type: Output
        }], setDate: [{
            type: Input
        }], disableUntil: [{
            type: Input
        }], changeDate: [{
            type: Input
        }] }); })();

function DateFilterPopupComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.dateRestrictionMsg, " ");
} }
function DateFilterPopupComponent_lib_app_date_picker_26_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-app-date-picker", 22);
    i0.ɵɵlistener("selectedDate", function DateFilterPopupComponent_lib_app_date_picker_26_Template_lib_app_date_picker_selectedDate_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.startSelectedDate($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("setDate", ctx_r1.startDate);
} }
function DateFilterPopupComponent_lib_app_date_picker_31_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-app-date-picker", 23);
    i0.ɵɵlistener("selectedDate", function DateFilterPopupComponent_lib_app_date_picker_31_Template_lib_app_date_picker_selectedDate_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.endSelectedDate($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("setDate", ctx_r2.endDate)("changeDate", ctx_r2.endDate.date)("disableUntil", ctx_r2.endDate.disableUntil);
} }
const moment$c = moment_; // A fix for Cannot call a namespace ('moment'). An unhandled exception occurred: Cannot call a namespace ('moment')
class DateFilterPopupComponent {
    // eslint-disable-next-line no-unused-vars
    constructor(dataService, translate) {
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.closeDatePopup = new EventEmitter();
        this.atApplyDate = new EventEmitter();
        this.startDate = new DateFilter();
        this.endDate = new DateFilter();
        this.allDateRange = [];
        this.selDateRangeItem = {};
        this.appliedDate = false;
        this.isFirstTime = false;
        this.dateRestrictionMsg = null;
        this.backupSelectedItem = {
            selDateRangeItem: null,
            selStartDate: null,
            selEndDate: null
        };
        this.isSelectedFromDropDown = false;
        this.dateFilterKeys = [];
        // ngOnInit = (): void => {
        // 		this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange: string) => {
        // 		// Add all fetching of localized string here
        // 		this.getStaticText();
        // 	});
        // };
        this.getStaticText = () => {
            this.translate.get('shared-lib.date-filter-popup').subscribe((res) => {
                this.dateFilterKeys = res;
                this.setAllDateRange();
            });
        };
    }
    set isApplyFirstTime(value) {
        this.isFirstTime = value;
    }
    set date(value) {
        setTimeout(() => {
            this.result = value;
            this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
                // Add all fetching of localized string here
                this.getStaticText();
                this.setRangeAndDate(value);
            });
        }, 500);
    }
    setRangeAndDate(value) {
        if (!value || !value["minDate"] || !value["maxDate"])
            return;
        const minDate = value["minDate"];
        const maxDate = value["maxDate"];
        let selMinDate = value["selMinDate"];
        let selMaxDate = value["selMaxDate"];
        this.dateRestrictionMsg = value["dateRestrictionMsg"]
            ? value["dateRestrictionMsg"]
            : null;
        let isSessionRequired = value["isSessionRequired"];
        if (isSessionRequired == null)
            isSessionRequired = true;
        if (!selMinDate)
            selMinDate = minDate;
        if (!selMaxDate)
            selMaxDate = maxDate;
        this.allDateRange = [];
        this.setAllDateRange();
        this.setDefaultDateRange(minDate, maxDate, selMinDate, selMaxDate, isSessionRequired);
    }
    closeDateFilterPopup() {
        // this.setRangeAndDate(this.result);
        this.isSelectedFromDropDown = false;
        this.selDateRangeItem = this.backupSelectedItem.selDateRangeItem;
        const copyStartDate = Object.assign(new DateFilter(), this.startDate);
        const copyEndDate = Object.assign(new DateFilter(), this.endDate);
        this.startDate = copyStartDate;
        this.endDate = copyEndDate;
        this.startDate.date = this.backupSelectedItem.selStartDate;
        this.endDate.date = this.backupSelectedItem.selEndDate;
        this.setDateDifference();
        this.closeDatePopup.emit(false);
    }
    setStartDate(minDate, maxDate, selMinDate) {
        this.startDate = new DateFilter();
        this.startDate.date = selMinDate;
        const miDate = moment$c(minDate.getTime()).toDate();
        if (this.isFirstTime)
            this.startDate.disableUntil = moment$c(miDate.setDate(miDate.getDate() - 1)).toDate();
        const mxDate = moment$c(maxDate.getTime()).toDate();
        if (this.isFirstTime)
            this.startDate.disableSince = moment$c(mxDate.setDate(mxDate.getDate() + 1)).toDate();
        this.selStartDate = selMinDate;
        this.setDateDifference();
        // console.log('this.startDate :: ',this.startDate);
    }
    setEndDate(minDate, maxDate, selMaxDate) {
        this.endDate = new DateFilter();
        this.endDate.date = selMaxDate;
        // this.endDate.disableUntil = minDate;
        const mxDate = moment$c(maxDate.getTime()).toDate();
        if (this.isFirstTime) {
            this.endDate.disableSince = moment$c(mxDate.setDate(mxDate.getDate() + 1)).toDate();
            if (this.startDate.date.getTime() > minDate.getTime())
                this.endDate.disableUntil = moment$c(this.startDate.date).toDate();
            else
                this.endDate.disableUntil = minDate;
        }
        this.selEndDate = selMaxDate;
        this.setDateDifference();
        // console.log('this.endDate :: ',this.endDate);
    }
    setDateDifference() {
        if (this.selStartDate && this.selEndDate) {
            const sDate = moment$c(moment$c(this.selStartDate).format("YYYY-MM-DD") + "T00:00:00Z");
            const eDate = moment$c(moment$c(this.selEndDate).format("YYYY-MM-DD") + "T00:00:00Z");
            this.dateDifference = eDate.diff(sDate, "days") + 1;
        }
    }
    setAllDateRange() {
        this.today();
        this.yesterday();
        this.currentWeek();
        this.previousWeek();
        this.currentMonth();
        this.previousMonth();
        this.currentYear();
        this.previousYear();
        this.last15Days();
        this.last30Days();
        this.last3Months();
        this.last6Months();
        this.last12Months();
        this.last365Days();
        this.dateRangeOpt();
    }
    today() {
        const startDate = moment$c().startOf("day");
        const endDate = moment$c().startOf("day");
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.today,
            value: "Today"
        });
    }
    yesterday() {
        const startDate = moment$c().subtract(1, "days").startOf("day");
        const endDate = moment$c().subtract(1, "days").startOf("day");
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.yesterday,
            value: "Yesterday"
        });
    }
    currentWeek() {
        //  need to check this
        const today = moment$c();
        const daystoMonday = 0 - (1 - today.isoWeekday());
        const startDate = moment$c()
            .subtract("days", daystoMonday)
            .startOf("day");
        const endDate = moment$c().startOf("day");
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.currentWeek,
            value: "CurrentWeek"
        });
    }
    previousWeek() {
        const startDate = this.getLastWeekStart();
        const endDate = this.getLastWeekEnd();
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.prevWeek,
            value: "PreviousWeek"
        });
    }
    currentMonth() {
        const cDate = new Date();
        const y = cDate.getFullYear(), m = cDate.getMonth();
        const firstDayOfTheMonth = new Date(y, m, 1);
        const startDate = moment$c(firstDayOfTheMonth);
        const endDate = moment$c().startOf("day");
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.currentMonth,
            value: "CurrentMonth"
        });
    }
    previousMonth() {
        const startDate = moment$c()
            .subtract("1", "months")
            .date(1)
            .startOf("day");
        const endDate = moment$c().add(0, "months").date(0).startOf("day");
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.prevMonth,
            value: "PreviousMonth"
        });
    }
    currentYear() {
        const cDate = new Date();
        const y = cDate.getFullYear();
        // m = cDate.getMonth();
        const firstDayOfTheYear = new Date(y, 0, 1);
        const startDate = moment$c(firstDayOfTheYear);
        const endDate = moment$c();
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.currentYear,
            value: "CurrentYear"
        });
    }
    previousYear() {
        const cDate = new Date();
        const y = cDate.getFullYear();
        // m = cDate.getMonth();
        const firstDayOfTheYear = new Date(y - 1, 0, 1);
        const lasyDayOfTheYear = new Date(y - 1, 11, 31);
        const startDate = moment$c(firstDayOfTheYear);
        const endDate = moment$c(lasyDayOfTheYear);
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.prevYear,
            value: "PreviousYear"
        });
    }
    last15Days() {
        const startDate = moment$c().subtract(15, "days").startOf("day");
        const endDate = moment$c().subtract(1, "days").startOf("day");
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.last15Days,
            value: "Last15Days"
        });
    }
    last30Days() {
        const startDate = moment$c().subtract(30, "days").startOf("day");
        const endDate = moment$c().subtract(1, "days").startOf("day");
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.last30Days,
            value: "Last30Days"
        });
    }
    last3Months() {
        const startDate = moment$c().subtract(3, "months").date(1).startOf("day");
        const endDate = moment$c().add(0, "months").date(0).startOf("day");
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.last3Months,
            value: "Last3Months"
        });
    }
    last6Months() {
        const startDate = moment$c().subtract(6, "months").date(1).startOf("day");
        const endDate = moment$c().add(0, "months").date(0).startOf("day");
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.last6Months,
            value: "Last6Months"
        });
    }
    last12Months() {
        const startDate = moment$c()
            .subtract(12, "months")
            .date(1)
            .startOf("day");
        const endDate = moment$c().add(0, "months").date(0).startOf("day");
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.last12Months,
            value: "Last12Months"
        });
    }
    last365Days() {
        const startDate = moment$c().subtract(364, "days").startOf("day");
        const endDate = moment$c().startOf("day");
        this.setDateRange(startDate, endDate, {
            name: this.dateFilterKeys.last365Days,
            value: "Last365Days"
        });
    }
    dateRangeOpt() {
        let startDate = null;
        let endDate = null;
        const minDate = this.result["minDate"];
        const maxDate = this.result["maxDate"];
        if (minDate && maxDate) {
            const sDate = moment$c()
                .subtract(1, "years")
                .add("days", 1)
                .startOf("day")
                .toDate();
            const eDate = moment$c().startOf("day").toDate();
            const maxOfTwoDates = Math.max(sDate.getTime(), minDate.getTime());
            const minOfTwoDates = Math.min(eDate.getTime(), maxDate.getTime());
            startDate = moment$c(maxOfTwoDates);
            endDate = moment$c(minOfTwoDates);
            // startDate = moment(minDate);
            // endDate = moment(maxDate);
        }
        else {
            startDate = moment$c().subtract(1, "years");
            startDate = startDate.add("days", 1);
            endDate = moment$c();
        }
        this.allDateRange.push({
            name: this.dateFilterKeys.custom,
            value: "DateRange",
            startDate: startDate.toDate(),
            endDate: endDate.toDate()
        });
    }
    getLastWeekStart() {
        const today = moment$c();
        const daystoLastMonday = 0 - (1 - today.isoWeekday()) + 7;
        const lastMonday = today
            .subtract("days", daystoLastMonday)
            .startOf("day");
        return lastMonday;
    }
    getLastWeekEnd() {
        const lastMonday = this.getLastWeekStart();
        const lastSunday = lastMonday.add("days", 6).startOf("day");
        return lastSunday;
    }
    setDateRange(startDate, endDate, rangeOptions) {
        const fDate = moment$c(startDate).format("YYYY-MM-DD");
        const eDate = moment$c(endDate).format("YYYY-MM-DD");
        const minDate = this.result["minDate"];
        const maxDate = this.result["maxDate"];
        if (minDate && maxDate) {
            if (moment$c(fDate) >= minDate && maxDate >= moment$c(eDate))
                this.allDateRange.push({
                    name: rangeOptions["name"],
                    value: rangeOptions["value"],
                    startDate: startDate.toDate(),
                    endDate: endDate.toDate()
                });
        }
        else {
            this.allDateRange.push({
                name: rangeOptions["name"],
                value: rangeOptions["value"],
                startDate: startDate.toDate(),
                endDate: endDate.toDate()
            });
        }
    }
    setDefaultDateRange(minDate, maxDate, selMinDate, selMaxDate, isSessionRequired) {
        let dateRangeChanged = false;
        // let sDate = moment().subtract(364, "days").toDate();
        // let eDate = moment().toDate();
        const sDate = moment$c(maxDate.getTime()).subtract(364, "days").toDate();
        const eDate = moment$c(maxDate.getTime()).toDate();
        let miDate = Object.assign(new Date(), sDate);
        let mxDate = Object.assign(new Date(), eDate);
        if (minDate && maxDate) {
            miDate = moment$c(selMinDate).toDate();
            mxDate = moment$c(selMaxDate).toDate();
        }
        const sessionReportsFilter = this.dataService.getFromStorage("reportsFilter")
            ? JSON.parse(this.dataService.getFromStorage("reportsFilter"))
            : {};
        let maxOfTwoDates = Math.max(sDate.getTime(), miDate.getTime());
        let minOfTwoDates = Math.min(eDate.getTime(), mxDate.getTime());
        const sessionStartDate = sessionReportsFilter.startDate
            ? moment$c(sessionReportsFilter.startDate).toDate()
            : null;
        const sessionEndDate = sessionReportsFilter.endDate
            ? moment$c(sessionReportsFilter.endDate).toDate()
            : null;
        if (isSessionRequired && sessionStartDate) {
            if (minDate <= sessionStartDate)
                maxOfTwoDates = moment$c(sessionReportsFilter.startDate)
                    .toDate()
                    .getTime();
            else
                maxOfTwoDates = minDate.getTime();
        }
        if (isSessionRequired && sessionEndDate) {
            if (minDate >= sessionEndDate) {
                maxOfTwoDates = Math.max(sDate.getTime(), minDate.getTime());
                minOfTwoDates = Math.min(eDate.getTime(), maxDate.getTime());
            }
            else {
                minOfTwoDates = moment$c(sessionReportsFilter.endDate)
                    .toDate()
                    .getTime();
            }
        }
        this.allDateRange.forEach((obj) => {
            const rangeStartDate = moment$c(obj.startDate).format("YYYY-MM-DD");
            const rangeEndDate = moment$c(obj.endDate).format("YYYY-MM-DD");
            const minD = moment$c(maxOfTwoDates).format("YYYY-MM-DD");
            const maxD = moment$c(minOfTwoDates).format("YYYY-MM-DD");
            if (rangeStartDate == minD && rangeEndDate == maxD) {
                dateRangeChanged = true;
                this.selDateRangeItem = obj;
                this.setStartDate(minDate, maxDate, moment$c(maxOfTwoDates).toDate());
                this.setEndDate(minDate, maxDate, moment$c(minOfTwoDates).toDate());
                if (this.isFirstTime && !this.appliedDate) {
                    this.applyDate();
                }
            }
        });
        if (!dateRangeChanged) {
            this.selDateRangeItem =
                this.allDateRange[this.allDateRange.length - 1];
            this.setStartDate(minDate, maxDate, moment$c(maxOfTwoDates).toDate());
            this.setEndDate(minDate, maxDate, moment$c(minOfTwoDates).toDate());
            if (this.isFirstTime)
                this.applyDate();
        }
    }
    setSelectedItem() {
        let dateRangeChaged = false;
        this.allDateRange.forEach((obj) => {
            const rangeStartDate = moment$c(obj.startDate).format("YYYY-MM-DD");
            const rangeEndDate = moment$c(obj.endDate).format("YYYY-MM-DD");
            const minD = moment$c(this.selStartDate).format("YYYY-MM-DD");
            const maxD = moment$c(this.selEndDate).format("YYYY-MM-DD");
            if (rangeStartDate == minD && rangeEndDate == maxD) {
                this.selDateRangeItem = obj;
                dateRangeChaged = true;
                return;
            }
        });
        if (!dateRangeChaged)
            this.selDateRangeItem =
                this.allDateRange[this.allDateRange.length - 1];
    }
    startSelectedDate(selectedDateObj) {
        if (selectedDateObj && selectedDateObj["jsdate"] != null) {
            this.isFirstTime = false;
            const selDate = selectedDateObj["jsdate"];
            const seDate = moment$c(selDate.getTime()).toDate();
            this.endDate.disableUntil = moment$c(seDate.setDate(seDate.getDate() - 1)).toDate();
            this.selStartDate = selDate;
            if (selDate.getTime() > this.selEndDate.getTime()) {
                this.endDate.date = selDate;
                this.selEndDate = selDate;
            }
            this.setDateDifference();
            if (!this.isSelectedFromDropDown)
                this.setSelectedItem();
        }
    }
    endSelectedDate(selectedDateObj) {
        if (selectedDateObj && selectedDateObj["jsdate"] != null) {
            this.isFirstTime = false;
            this.selEndDate = selectedDateObj["jsdate"];
            this.setDateDifference();
            if (!this.isSelectedFromDropDown)
                this.setSelectedItem();
        }
    }
    onDropdownSelect(event) {
        this.selDateRangeItem = event;
        if (event.value != "DateRange") {
            this.isSelectedFromDropDown = true;
            this.setStartDate(this.result["minDate"], this.result["maxDate"], event["startDate"]);
            this.setEndDate(this.result["minDate"], this.result["maxDate"], event["endDate"]);
            this.isSelectedFromDropDown = false;
        }
    }
    applyDate() {
        this.appliedDate = true;
        if (this.selStartDate && this.selEndDate) {
            // this.result = {minDate:this.selStartDate, maxDate:this.selEndDate, selMinDate: this.selStartDate, selMaxDate: this.selEndDate};
            this.backupSelectedItem = {
                selDateRangeItem: Object.assign({}, this.selDateRangeItem),
                selStartDate: moment$c(this.selStartDate.getTime()),
                selEndDate: moment$c(this.selEndDate.getTime())
            };
            this.closeDatePopup.emit(false);
            this.atApplyDate.emit({
                startDate: this.selStartDate,
                endDate: this.selEndDate,
                selectedRange: this.selDateRangeItem["name"],
                dateDifference: this.dateDifference,
                firstTime: this.isFirstTime
            });
        }
    }
}
DateFilterPopupComponent.ɵfac = function DateFilterPopupComponent_Factory(t) { return new (t || DateFilterPopupComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
DateFilterPopupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DateFilterPopupComponent, selectors: [["lib-date-filter-popup"]], inputs: { isApplyFirstTime: "isApplyFirstTime", date: "date" }, outputs: { closeDatePopup: "closeDatePopup", atApplyDate: "atApplyDate" }, decls: 40, vars: 24, consts: [[1, "dateFilterModal"], ["_ngcontent-c5", "", 1, "popupOverlay"], [1, "dateFilterContent"], ["_ngcontent-c5", "", 1, "dateFilterHeader"], [1, "dateFilterClose", 3, "click"], [1, "innerContent"], ["class", "dateFilterInnerHeader", 4, "ngIf"], [1, "date-selection"], [3, "listItems", "selectedItem", "atDropdownSelect"], [1, "date-diff"], [1, "dateDifference"], [1, "dateDiffUnit"], [1, "clear"], [1, "date-picker", "left"], [1, "date-header"], [3, "setDate", "selectedDate", 4, "ngIf"], [1, "date-picker", "right"], [3, "setDate", "changeDate", "disableUntil", "selectedDate", 4, "ngIf"], [1, "datePopupFooter"], [1, "squareButtonPrimary", 3, "click"], [1, "cancelButton", 3, "click"], [1, "dateFilterInnerHeader"], [3, "setDate", "selectedDate"], [3, "setDate", "changeDate", "disableUntil", "selectedDate"]], template: function DateFilterPopupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4);
        i0.ɵɵpipe(5, "translate");
        i0.ɵɵelementStart(6, "span", 4);
        i0.ɵɵlistener("click", function DateFilterPopupComponent_Template_span_click_6_listener() { return ctx.closeDateFilterPopup(); });
        i0.ɵɵtext(7, "\uE909");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 5);
        i0.ɵɵelementStart(9, "div");
        i0.ɵɵtemplate(10, DateFilterPopupComponent_div_10_Template, 2, 1, "div", 6);
        i0.ɵɵelementStart(11, "div");
        i0.ɵɵelementStart(12, "div", 7);
        i0.ɵɵelementStart(13, "lib-generic-dropdown", 8);
        i0.ɵɵlistener("atDropdownSelect", function DateFilterPopupComponent_Template_lib_generic_dropdown_atDropdownSelect_13_listener($event) { return ctx.onDropdownSelect($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 9);
        i0.ɵɵelementStart(15, "div", 10);
        i0.ɵɵtext(16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 11);
        i0.ɵɵtext(18);
        i0.ɵɵpipe(19, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(20, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div");
        i0.ɵɵelementStart(22, "div", 13);
        i0.ɵɵelementStart(23, "div", 14);
        i0.ɵɵtext(24);
        i0.ɵɵpipe(25, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(26, DateFilterPopupComponent_lib_app_date_picker_26_Template, 1, 1, "lib-app-date-picker", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 16);
        i0.ɵɵelementStart(28, "div", 14);
        i0.ɵɵtext(29);
        i0.ɵɵpipe(30, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(31, DateFilterPopupComponent_lib_app_date_picker_31_Template, 1, 3, "lib-app-date-picker", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(32, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 18);
        i0.ɵɵelementStart(34, "button", 19);
        i0.ɵɵlistener("click", function DateFilterPopupComponent_Template_button_click_34_listener() { return ctx.applyDate(); });
        i0.ɵɵtext(35);
        i0.ɵɵpipe(36, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "button", 20);
        i0.ɵɵlistener("click", function DateFilterPopupComponent_Template_button_click_37_listener() { return ctx.closeDateFilterPopup(); });
        i0.ɵɵtext(38);
        i0.ɵɵpipe(39, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 12, "shared-lib.date-filter-popup.date-range"), " ");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.dateRestrictionMsg);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("listItems", ctx.allDateRange)("selectedItem", ctx.selDateRangeItem);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.dateDifference);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 14, "shared-lib.date-filter-popup.days"));
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(25, 16, "shared-lib.date-filter-popup.start-date"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.startDate);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(30, 18, "shared-lib.date-filter-popup.end-date"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.endDate);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(36, 20, "shared-lib.date-filter-popup.apply"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(39, 22, "shared-lib.date-filter-popup.cancel"), " ");
    } }, directives: [i1$2.NgIf, GenericDropdownComponent, DatePickerComponent], pipes: [i2.TranslatePipe], styles: [".dateFilterModal[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:1000;left:0;top:0}.popupOverlay[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:1000;background-color:#0009}.dateFilterContent[_ngcontent-%COMP%]{position:absolute;top:60px;left:50%;transform:translate(-50%);width:50%;height:70%;margin:0 auto;background-color:#fff;box-shadow:0 4px 8px #0000001a;border-radius:5px;border:0;z-index:1001;min-width:600px}.dateFilterHeader[_ngcontent-%COMP%]{padding:18px 30px;color:#000;font-size:18px;font-family:\"ciscoSansLight\";font-weight:600;position:relative;height:60px;border-bottom:1px solid #EAEAEA}.dateFilterClose[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.innerContent[_ngcontent-%COMP%]{padding:20px}.dateFilterInnerHeader[_ngcontent-%COMP%]{font-size:12px;font-weight:normal;font-family:\"ciscoSansLight\";color:#6a6b6c;padding-bottom:10px}.date-picker[_ngcontent-%COMP%]{padding-top:10px}.date-header[_ngcontent-%COMP%]{font-family:ciscoSansThin;font-size:12px;color:#6a6b6c;padding:10px 10px 5px}.datePopupFooter[_ngcontent-%COMP%]{padding:7px 30px;color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:relative;height:60px;position:absolute;bottom:0;left:0;width:100%;border-top:1px solid #EAEAEA;background-color:#fff}.date-selection[_ngcontent-%COMP%]{float:left;width:30%}.date-diff[_ngcontent-%COMP%]{float:left;width:10%;display:table-cell;vertical-align:middle;padding-left:20px;margin:10px 0}.dateDifference[_ngcontent-%COMP%]{font-size:22px;font-weight:bold;color:#414f5f;font-family:ciscoSansBold}.dateDiffUnit[_ngcontent-%COMP%]{font-size:13px;font-weight:500;color:#414f5f;font-family:ciscoSansLight}[_nghost-%COMP%]     app-date-picker .mydp .header{background-color:#fff!important;padding:10px 0}[_nghost-%COMP%]     app-date-picker .mydp .headermonthtxt, [_nghost-%COMP%]     app-date-picker .mydp .headeryeartxt{color:#000!important;font-family:ciscoSansRegular!important;font-weight:500;font-size:14px!important}[_nghost-%COMP%]     app-date-picker .mydp .weekdaytitle{background-color:#fff!important;font-size:12px!important;font-family:ciscoSansLight!important;font-weight:500;text-transform:uppercase}[_nghost-%COMP%]     app-date-picker .mydp .daycell, [_nghost-%COMP%]     app-date-picker .mydp .inputnoteditable, [_nghost-%COMP%]     app-date-picker .mydp .monthcell, [_nghost-%COMP%]     app-date-picker .mydp .yearcell{border:1px solid #dddfe2;background-color:#fff;font-family:sans-serif;font-size:12px}[_nghost-%COMP%]     app-date-picker .mydp .disabled{cursor:default!important;color:#babec3}[_nghost-%COMP%]     app-date-picker .mydp .tablesingleday{color:#4a4a4a}[_nghost-%COMP%]     app-date-picker .mydp .selectedday{background-color:#3273e1;color:#fff}[_nghost-%COMP%]     app-date-picker .mydp .selectedday .datevalue, [_nghost-%COMP%]     app-date-picker .mydp .selectedmonth .monthvalue, [_nghost-%COMP%]     app-date-picker .mydp .selectedyear .yearvalue{background-color:transparent;border-radius:0}[_nghost-%COMP%]     app-date-picker .mydp .disabled .highlight{color:#babec3}[_nghost-%COMP%]     app-date-picker .mydp .tablesingleday .highlight{color:#4a4a4a}[_nghost-%COMP%]     app-date-picker .mydp .dimday{opacity:1}[_nghost-%COMP%]     app-date-picker .mydp .markcurrday, [_nghost-%COMP%]     app-date-picker .mydp .markcurrmonth, .mydp[_ngcontent-%COMP%]   .markcurryear[_ngcontent-%COMP%]{text-decoration:none}[_nghost-%COMP%]     app-date-picker .datevalue.nextmonth.highlight{color:#babec3}[_nghost-%COMP%]     app-date-picker table.caltable tr td:first-child{border-left:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateFilterPopupComponent, [{
        type: Component,
        args: [{
                selector: "lib-date-filter-popup",
                templateUrl: "./date-filter-popup.component.html",
                styleUrls: ["./date-filter-popup.component.css"]
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }]; }, { closeDatePopup: [{
            type: Output
        }], atApplyDate: [{
            type: Output
        }], isApplyFirstTime: [{
            type: Input
        }], date: [{
            type: Input
        }] }); })();

function DatePickerModalComponent_div_0_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.date-filter-popup.error-msg"));
} }
function DatePickerModalComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 3);
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "lib-app-date-picker", 6);
    i0.ɵɵlistener("selectedDate", function DatePickerModalComponent_div_0_Template_lib_app_date_picker_selectedDate_9_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.onSelectedStartDate($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 7);
    i0.ɵɵelementStart(11, "div", 5);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "lib-app-date-picker", 8);
    i0.ɵɵlistener("selectedDate", function DatePickerModalComponent_div_0_Template_lib_app_date_picker_selectedDate_14_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.onSelectedEndDate($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, DatePickerModalComponent_div_0_span_16_Template, 3, 3, "span", 10);
    i0.ɵɵelementStart(17, "div", 11);
    i0.ɵɵelementStart(18, "button", 12);
    i0.ɵɵlistener("click", function DatePickerModalComponent_div_0_Template_button_click_18_listener() { i0.ɵɵrestoreView(_r3); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5._onApply(); });
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "button", 13);
    i0.ɵɵlistener("click", function DatePickerModalComponent_div_0_Template_button_click_21_listener() { i0.ɵɵrestoreView(_r3); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6._onClose(); });
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 11, "shared-lib.date-filter-popup.date-range"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 13, "shared-lib.date-filter-popup.start-date"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("setDate", ctx_r0.startDate);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 15, "shared-lib.date-filter-popup.end-date"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("setDate", ctx_r0.endDate)("changeDate", ctx_r0.endDate.date)("disableUntil", ctx_r0.endDate.disableUntil);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isError);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.isError);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 17, "shared-lib.date-filter-popup.apply"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 19, "shared-lib.date-filter-popup.cancel"));
} }
const moment$b = moment_; // A fix for Cannot call a namespace ('moment'). An unhandled exception occurred: Cannot call a namespace ('moment')
class DatePickerModalComponent {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() {
        this.isError = false;
        this.dates = {
            startDate: {},
            endDate: {}
        };
        this.isOpen = false;
        this.forClose = new EventEmitter();
        this.forApply = new EventEmitter();
    }
    set data({ startDate, endDate, minDate, maxDate }) {
        this.startDate = Object.assign(Object.assign({}, new DateFilter()), { date: startDate, disableUntil: minDate, disableSince: maxDate });
        this.endDate = Object.assign(Object.assign({}, new DateFilter()), { date: endDate, disableUntil: minDate, disableSince: maxDate });
    }
    onSelectedStartDate(startDate) {
        const isAfterDate = moment$b(startDate.formatted).isAfter(this.dates.endDate.jsdate);
        if (isAfterDate) {
            this.isError = true;
            return false;
        }
        this.isError = false;
        this.dates = Object.assign(Object.assign({}, this.dates), { startDate });
    }
    onSelectedEndDate(endDate) {
        const isBeforeDate = moment$b(endDate.formatted).isBefore(this.dates.startDate.jsdate);
        if (isBeforeDate) {
            this.isError = true;
            return false;
        }
        this.isError = false;
        this.dates = Object.assign(Object.assign({}, this.dates), { endDate });
    }
    _onClose() {
        this.isOpen = false;
        this.forClose.emit({});
    }
    _onApply() {
        this.isOpen = false;
        this.forApply.emit(Object.assign({}, this.dates));
    }
}
DatePickerModalComponent.ɵfac = function DatePickerModalComponent_Factory(t) { return new (t || DatePickerModalComponent)(); };
DatePickerModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DatePickerModalComponent, selectors: [["lib-date-picker-modal"]], inputs: { isOpen: "isOpen", data: "data" }, outputs: { forClose: "forClose", forApply: "forApply" }, decls: 1, vars: 1, consts: [["class", "date-picker", 4, "ngIf"], [1, "date-picker"], [1, "date-picker__header"], [1, "date-picker__body"], [1, "date-picker__body__left"], [1, "date-header"], [3, "setDate", "selectedDate"], [1, "date-picker__body__right"], [3, "setDate", "changeDate", "disableUntil", "selectedDate"], [1, "clear"], ["class", "date-picker__error", 4, "ngIf"], [1, "date-picker__footer"], [1, "squareButtonPrimary", 3, "disabled", "click"], [1, "cancelButton", 3, "click"], [1, "date-picker__error"]], template: function DatePickerModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DatePickerModalComponent_div_0_Template, 24, 21, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, directives: [i1$2.NgIf, DatePickerComponent], pipes: [i2.TranslatePipe], styles: [".date-picker[_ngcontent-%COMP%]{position:absolute;display:flex;flex-direction:column;padding:5px;top:calc(100% + 15px);background-color:#fff;box-shadow:0 0 6px -2px #0003;transform:translate(-50%)}.date-picker__header[_ngcontent-%COMP%]{color:#1d3243;font-size:14px;line-height:30px;font-family:ciscoSans}.date-picker__body[_ngcontent-%COMP%]{display:flex}.date-picker__body[_ngcontent-%COMP%]   .date-header[_ngcontent-%COMP%]{font-size:12px;font-weight:bold;line-height:18px}.date-picker__body__right[_ngcontent-%COMP%]{margin:0 0 0 5px}.date-picker__error[_ngcontent-%COMP%]{display:flex;font-size:12px;font-family:ciscoSansLight;color:#ff7070;justify-content:center}.date-picker__footer[_ngcontent-%COMP%]{display:flex}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatePickerModalComponent, [{
        type: Component,
        args: [{
                selector: "lib-date-picker-modal",
                templateUrl: "./date-picker-modal.component.html",
                styleUrls: ["./date-picker-modal.component.scss"]
            }]
    }], function () { return []; }, { isOpen: [{
            type: Input
        }], data: [{
            type: Input
        }], forClose: [{
            type: Output
        }], forApply: [{
            type: Output
        }] }); })();

class DropdownFilterPipe {
    transform(values, filter) {
        if (!values || !values.length)
            return [];
        if (!filter)
            return values;
        return values.filter((v) => v.toLowerCase().indexOf(filter.toLowerCase()) >= 0);
    }
}
DropdownFilterPipe.ɵfac = function DropdownFilterPipe_Factory(t) { return new (t || DropdownFilterPipe)(); };
DropdownFilterPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "dropdownFilter", type: DropdownFilterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownFilterPipe, [{
        type: Pipe,
        args: [{
                name: "dropdownFilter"
            }]
    }], null, null); })();

function DropdownComboTextComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 6);
    i0.ɵɵlistener("click", function DropdownComboTextComponent_div_2_Template_span_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const selectItem_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.deleteSelects(selectItem_r2); });
    i0.ɵɵtext(4, "x");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selectItem_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(selectItem_r2);
} }
function DropdownComboTextComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function DropdownComboTextComponent_div_4_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r8); const item_r6 = restoredCtx.$implicit; const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.selectSuggestion(item_r6); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r5.isSelected(item_r6) ? "selected-suggestion" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r6);
} }
function DropdownComboTextComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, DropdownComboTextComponent_div_4_div_1_Template, 4, 2, "div", 8);
    i0.ɵɵpipe(2, "dropdownFilter");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(2, 1, ctx_r1.listObj, ctx_r1.filterString));
} }
const _c0$L = function (a0) { return { "dropdownExpand": a0 }; };
class DropdownComboTextComponent {
    constructor() {
        this.selectOption = new EventEmitter();
        this.filterString = "";
        this.show = false;
        this.userSelects = [];
        this.onKeyDownPress = (event) => {
            if (event.keyCode == 9 || event.keyCode == 32 || event.keyCode == 13) {
                this.userSelects.push(this.filterString);
                this.selectOption.emit(this.userSelects);
                this.filterString = "";
            }
        };
    }
    set selected(value) {
        if (!value) {
            return;
        }
        this.userSelects = value;
    }
    ngOnInit() {
        console.log("Entered Dropdown Combo Text Component");
    }
    event(event) {
        let that = this;
        let elementClicked = event.target;
        if (jQuery(elementClicked).closest(".chips-input-container").length === 0 && jQuery(elementClicked).attr("class") != undefined && (!jQuery(elementClicked).hasClass("chips-input-container") && (!jQuery(elementClicked).hasClass("selected-suggestion")))) {
            that.show = false;
        }
    }
    suggest() {
        this.show = !this.show;
    }
    focusFunction() {
        this.show = true;
    }
    selectSuggestion(selItem) {
        this.userSelects.find((item) => item === selItem) ?
            this.userSelects = this.userSelects.filter((item) => item !== selItem) :
            this.userSelects.push(selItem);
        this.selectOption.emit(this.userSelects);
        this.filterString = "";
    }
    isSelected(selItem) {
        return this.userSelects.findIndex((item) => item === selItem) > -1 ? true : false;
    }
    deleteSelects(selItem) {
        this.userSelects = this.userSelects.filter((item) => item !== selItem);
        this.selectOption.emit(this.userSelects);
    }
}
DropdownComboTextComponent.ɵfac = function DropdownComboTextComponent_Factory(t) { return new (t || DropdownComboTextComponent)(); };
DropdownComboTextComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DropdownComboTextComponent, selectors: [["lib-dropdown-combo-text"]], hostBindings: function DropdownComboTextComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function DropdownComboTextComponent_click_HostBindingHandler($event) { return ctx.event($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { listObj: "listObj", selected: "selected" }, outputs: { selectOption: "selectOption" }, decls: 5, vars: 6, consts: [[1, "autocomplete"], [1, "chips-input-container", 3, "ngClass", "click"], ["class", "user-chip", 4, "ngFor", "ngForOf"], ["type", "text", "name", "searchValue", "autocomplete", "off", 1, "userInput", 3, "ngModel", "ngModelChange", "keydown", "focus"], ["class", "autocomplete-items", 4, "ngIf"], [1, "user-chip"], [1, "delete-icon-chip", 3, "click"], [1, "autocomplete-items"], [3, "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "click"], [1, "check-mark"]], template: function DropdownComboTextComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵlistener("click", function DropdownComboTextComponent_Template_div_click_1_listener() { return ctx.suggest(); });
        i0.ɵɵtemplate(2, DropdownComboTextComponent_div_2_Template, 5, 1, "div", 2);
        i0.ɵɵelementStart(3, "input", 3);
        i0.ɵɵlistener("ngModelChange", function DropdownComboTextComponent_Template_input_ngModelChange_3_listener($event) { return ctx.filterString = $event; })("keydown", function DropdownComboTextComponent_Template_input_keydown_3_listener($event) { return ctx.onKeyDownPress($event); })("focus", function DropdownComboTextComponent_Template_input_focus_3_listener() { return ctx.focusFunction(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, DropdownComboTextComponent_div_4_Template, 3, 4, "div", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$L, ctx.listObj.length > 0));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.userSelects);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.filterString);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.show && ctx.listObj.length > 0);
    } }, directives: [i1$2.NgClass, i1$2.NgForOf, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$2.NgIf], pipes: [DropdownFilterPipe], styles: ["@charset \"UTF-8\";.autocomplete[_ngcontent-%COMP%]{position:relative;width:100%}.chips-input-container[_ngcontent-%COMP%]{display:inline-flex;background-color:#fff;border-bottom:2px solid #dddfe2;width:100%;border-radius:0;cursor:pointer;z-index:101;position:relative;color:#333439;font-family:ciscoSans;font-size:14px;margin:10px 0;flex-direction:row;flex-wrap:wrap}.chips-input-container[_ngcontent-%COMP%]:before{width:12px;height:12px;color:#6a6b6c;font-family:icomoon-new;position:absolute;top:6px;right:4px;padding:4px;font-size:14px;display:block;z-index:100}.chips-input-container.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{content:\"\\e908\"}input[_ngcontent-%COMP%]{font-weight:600;border:none;outline:none;margin:0}input[_ngcontent-%COMP%]:hover{border:none;border-radius:0}.autocomplete-items[_ngcontent-%COMP%]{position:absolute;border:1px solid #d4d4d4;border-radius:4px;top:80%;left:0;right:50%;background:#fff;width:100%;z-index:1001;font-size:14px;cursor:pointer;background-color:#fff;font-family:\"ciscoSansLight\";font-weight:600;max-height:200px;overflow-y:auto;line-height:20px;letter-spacing:.5px;color:#00a0d1}.selected-suggestion[_ngcontent-%COMP%]{background:#fff;color:#545454}.selected-suggestion[_ngcontent-%COMP%]   .check-mark[_ngcontent-%COMP%]{position:relative;display:inline-block;right:20px;font-style:normal;font-weight:500;line-height:1;top:1;--borderWidth: 1px;--height: 12px;--width: 6px;--borderColor: #545454;float:right}.selected-suggestion[_ngcontent-%COMP%]   .check-mark[_ngcontent-%COMP%]:before{content:\"\";transform:rotate(45deg);height:var(--height);width:var(--width);border-bottom:var(--borderWidth) solid var(--borderColor);border-right:var(--borderWidth) solid var(--borderColor);display:inline-block}.autocomplete-items[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:10px;cursor:pointer;background-color:#fff;border-bottom:1px solid #d4d4d41a}.autocomplete-items[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:hover{background:#E0F1F9!important;color:#007aa3!important}.user-chip[_ngcontent-%COMP%]{background:#f7f7f7;padding:0 6px;border-radius:20px;text-align:center;color:#545454;display:flex;font-size:14px;margin:0 4px 4px 0}.user-chip[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:flex;padding:5px}.delete-icon-chip[_ngcontent-%COMP%]{color:#545454;opacity:.7;cursor:pointer;display:flex;position:relative;right:0px;font-size:14px;padding:5px;font-weight:normal}.delete-icon-chip[_ngcontent-%COMP%]:hover{opacity:1}.userInput[_ngcontent-%COMP%]{pointer-events:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownComboTextComponent, [{
        type: Component,
        args: [{
                selector: "lib-dropdown-combo-text",
                templateUrl: "./dropdown-combo-text.component.html",
                styleUrls: ["./dropdown-combo-text.component.scss"]
            }]
    }], function () { return []; }, { listObj: [{
            type: Input
        }], selected: [{
            type: Input
        }], selectOption: [{
            type: Output
        }], event: [{
            type: HostListener,
            args: ["window:click", ["$event"]]
        }] }); })();

function DropdownFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function DropdownFilterComponent_div_6_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const time_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.selectTimezone(time_r2); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const time_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", time_r2, " ");
} }
function DropdownFilterComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function DropdownFilterComponent_div_8_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.expandDropdown(false); });
    i0.ɵɵelementEnd();
} }
const _c0$K = function (a0) { return { "dropdownExpand": a0 }; };
class DropdownFilterComponent {
    constructor() {
        this.onTimeZoneSelect = new EventEmitter();
        this.dropdownExpand = false;
        this.dropdownFilterText = "";
        this.filterString = "";
        this.expandDropdown = (event) => {
            this.dropdownExpand = event;
        };
        this.selectTimezone = (timeZone) => {
            this.selectedTimeZone = timeZone;
            this.placeholder = timeZone;
            this.filterString = "";
            this.onTimeZoneSelect.emit(timeZone);
            this.dropdownExpand = false;
        };
    }
}
DropdownFilterComponent.ɵfac = function DropdownFilterComponent_Factory(t) { return new (t || DropdownFilterComponent)(); };
DropdownFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DropdownFilterComponent, selectors: [["dropdown-filter"]], inputs: { placeholder: "placeholder", timeZoneObj: "timeZoneObj" }, outputs: { onTimeZoneSelect: "onTimeZoneSelect" }, decls: 9, vars: 11, consts: [[1, "dropdownFilterContainer"], [1, "dropdownInput", 3, "ngClass"], [1, "arrow", 3, "click"], ["type", "text", "name", "dropdownFilter", 1, "formControl", 3, "ngModel", "placeholder", "ngModelChange", "click"], [1, "dropdownFilterList"], ["class", "eachElement", 3, "click", 4, "ngFor", "ngForOf"], ["class", "dropdownFilterOverlay", 3, "click", 4, "ngIf"], [1, "eachElement", 3, "click"], [1, "dropdownFilterOverlay", 3, "click"]], template: function DropdownFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵlistener("click", function DropdownFilterComponent_Template_span_click_2_listener() { return ctx.expandDropdown(!ctx.dropdownExpand); });
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "input", 3);
        i0.ɵɵlistener("ngModelChange", function DropdownFilterComponent_Template_input_ngModelChange_4_listener($event) { return ctx.filterString = $event; })("click", function DropdownFilterComponent_Template_input_click_4_listener() { return ctx.expandDropdown(!ctx.dropdownExpand); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtemplate(6, DropdownFilterComponent_div_6_Template, 2, 1, "div", 5);
        i0.ɵɵpipe(7, "dropdownFilter");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, DropdownFilterComponent_div_8_Template, 1, 0, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$K, ctx.dropdownExpand));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.dropdownExpand ? "\uE908" : "\uE905");
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
        i0.ɵɵproperty("ngModel", ctx.filterString);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(7, 6, ctx.timeZoneObj.timeZone, ctx.filterString));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.dropdownExpand);
    } }, directives: [i1$2.NgClass, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$2.NgForOf, i1$2.NgIf], pipes: [DropdownFilterPipe], styles: [".dropdownFilterContainer{display:block;max-width:340px;margin:10px 0;position:relative}.dropdownInput span.arrow{color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;bottom:6px;right:0;padding:4px;font-size:14px;display:block;z-index:1003}.dropdownFilterContainer input[type=text]{border:0;border-bottom:2px solid #dddfe2;font-size:14px;color:#909090;font-family:\"ciscoSansRegular\";padding:6px 10px;margin-bottom:0;border-radius:0;z-index:1003}.dropdownFilterContainer input[type=text]:focus{border-bottom:2px solid #049fd9}.dropdownFilterList{display:none;width:100%;position:absolute;top:100%;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:1003;box-shadow:0 0 3px #0000004d}.dropdownInput.dropdownExpand .dropdownFilterList{display:block;background-color:#fff}.dropdownFilterContainer .eachElement{display:block;padding:8px 10px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.dropdownFilterContainer .eachElement:hover{color:#666;background-color:#39393b1a}.dropdownFilterOverlay{position:fixed;top:0;left:0;width:100%;height:100%;z-index:1000;background-color:#ffffff1a}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownFilterComponent, [{
        type: Component,
        args: [{
                selector: "dropdown-filter",
                templateUrl: "./dropdown-filter.component.html",
                styleUrls: ["./dropdown-filter.component.css"],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { placeholder: [{
            type: Input
        }], timeZoneObj: [{
            type: Input
        }], onTimeZoneSelect: [{
            type: Output
        }] }); })();

function DropdownRoleSimpleComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function DropdownRoleSimpleComponent_div_1_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.expandDropdown($event); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedItem, " ");
} }
function DropdownRoleSimpleComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function DropdownRoleSimpleComponent_div_2_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.expandDropdown($event); });
    i0.ɵɵtext(1, " Select ");
    i0.ɵɵelementEnd();
} }
function DropdownRoleSimpleComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function DropdownRoleSimpleComponent_div_3_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r12); const item_r10 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.selectItem(item_r10); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r10, " ");
} }
function DropdownRoleSimpleComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, DropdownRoleSimpleComponent_div_3_div_1_Template, 2, 1, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.listItems);
} }
function DropdownRoleSimpleComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1, " List unavilable ");
    i0.ɵɵelementEnd();
} }
function DropdownRoleSimpleComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function DropdownRoleSimpleComponent_div_5_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.expandDropdown($event); });
    i0.ɵɵelementEnd();
} }
const _c0$J = function (a0) { return { "dropdownExpand": a0 }; };
class DropdownRoleSimpleComponent {
    constructor() {
        this.listItems = ["Read only", "Read/Write"];
        this.onDropdownSelect = new EventEmitter();
        this.dropdownExpand = false;
        this.expandDropdown = (event) => {
            this.dropdownExpand = !this.dropdownExpand;
        };
        this.selectItem = (selectedItem) => {
            this.selectedItem = selectedItem;
            this.onDropdownSelect.emit(selectedItem);
            this.expandDropdown(false);
        };
    }
}
DropdownRoleSimpleComponent.ɵfac = function DropdownRoleSimpleComponent_Factory(t) { return new (t || DropdownRoleSimpleComponent)(); };
DropdownRoleSimpleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DropdownRoleSimpleComponent, selectors: [["app-dropdown-role-simple"]], inputs: { selectedItem: "selectedItem" }, outputs: { onDropdownSelect: "onDropdownSelect" }, decls: 6, vars: 8, consts: [[1, "simpleDropdownContainer", 3, "ngClass"], ["class", "selectedDropdown", 3, "click", 4, "ngIf"], ["class", "simpleDropdownList", 4, "ngIf"], ["class", "dropdownFilterOverlay", 3, "click", 4, "ngIf"], [1, "selectedDropdown", 3, "click"], [1, "simpleDropdownList"], ["class", "eachElement", 3, "click", 4, "ngFor", "ngForOf"], [1, "eachElement", 3, "click"], [1, "dropdownFilterOverlay", 3, "click"]], template: function DropdownRoleSimpleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, DropdownRoleSimpleComponent_div_1_Template, 2, 1, "div", 1);
        i0.ɵɵtemplate(2, DropdownRoleSimpleComponent_div_2_Template, 2, 0, "div", 1);
        i0.ɵɵtemplate(3, DropdownRoleSimpleComponent_div_3_Template, 2, 1, "div", 2);
        i0.ɵɵtemplate(4, DropdownRoleSimpleComponent_div_4_Template, 2, 0, "div", 2);
        i0.ɵɵtemplate(5, DropdownRoleSimpleComponent_div_5_Template, 1, 0, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$J, ctx.dropdownExpand));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listItems && ctx.listItems.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listItems === undefined || ctx.listItems.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownExpand);
    } }, directives: [i1$2.NgClass, i1$2.NgIf, i1$2.NgForOf], styles: ["@charset \"UTF-8\";.simpleDropdownContainer[_ngcontent-%COMP%]{width:100%;display:block;margin:10px 0;position:relative}.simpleDropdownContainer[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{width:12px;height:12px;color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;top:6px;right:4px;padding:4px;font-size:14px;display:block;content:\"\\e905\";z-index:100}.simpleDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{content:\"\\e908\"}.selectedDropdown[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #9E9EA2;width:100%;border-radius:0;cursor:pointer;padding:8px 10px;z-index:101;position:relative}.simpleDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]{border-color:#049fd9}.simpleDropdownList[_ngcontent-%COMP%]{display:none;width:100%;position:absolute;top:38px;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:103;box-shadow:0 0 3px #0000004d}.simpleDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .simpleDropdownList[_ngcontent-%COMP%]{display:block;background-color:#fff}.simpleDropdownContainer[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]{display:block;padding:12px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.simpleDropdownContainer[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]:hover{color:#666;background-color:#39393b1a}.dropdownFilterOverlay[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:100;background-color:#ffffff1a}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownRoleSimpleComponent, [{
        type: Component,
        args: [{
                selector: 'app-dropdown-role-simple',
                templateUrl: './dropdown-role-simple.component.html',
                styleUrls: ['./dropdown-role-simple.component.scss']
            }]
    }], function () { return []; }, { selectedItem: [{
            type: Input
        }], onDropdownSelect: [{
            type: Output
        }] }); })();

function DropdownWithCheckboxComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "-Select-");
    i0.ɵɵelementEnd();
} }
function DropdownWithCheckboxComponent_span_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "span", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵlistener("click", function DropdownWithCheckboxComponent_span_3_div_1_Template_span_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const selectItem_r6 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.removeSelectedItem(selectItem_r6); });
    i0.ɵɵtext(4, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selectItem_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", selectItem_r6.name, " ");
} }
function DropdownWithCheckboxComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, DropdownWithCheckboxComponent_span_3_div_1_Template, 5, 1, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.dropDownSelectedList);
} }
function DropdownWithCheckboxComponent_div_4_ol_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ol", 11);
    i0.ɵɵelementStart(1, "li", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 13);
    i0.ɵɵelementStart(4, "input", 14);
    i0.ɵɵlistener("ngModelChange", function DropdownWithCheckboxComponent_div_4_ol_1_Template_input_ngModelChange_4_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r14); const dropList_r11 = restoredCtx.$implicit; return dropList_r11.selected = $event; })("change", function DropdownWithCheckboxComponent_div_4_ol_1_Template_input_change_4_listener() { const restoredCtx = i0.ɵɵrestoreView(_r14); const dropList_r11 = restoredCtx.$implicit; const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.selectedFrom(dropList_r11); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "label", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const dropList_r11 = ctx.$implicit;
    const i_r12 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", dropList_r11.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "dropcheck", i_r12, "");
    i0.ɵɵproperty("ngModel", dropList_r11.selected)("checked", dropList_r11.selected);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "dropcheck", i_r12, "");
} }
function DropdownWithCheckboxComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, DropdownWithCheckboxComponent_div_4_ol_1_Template, 6, 5, "ol", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.droDownList);
} }
function DropdownWithCheckboxComponent_div_5_ol_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ol", 11);
    i0.ɵɵelementStart(1, "li", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 13);
    i0.ɵɵelementStart(4, "input", 14);
    i0.ɵɵlistener("ngModelChange", function DropdownWithCheckboxComponent_div_5_ol_1_Template_input_ngModelChange_4_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r20); const dropList_r17 = restoredCtx.$implicit; return dropList_r17.selected = $event; })("change", function DropdownWithCheckboxComponent_div_5_ol_1_Template_input_change_4_listener() { const restoredCtx = i0.ɵɵrestoreView(_r20); const dropList_r17 = restoredCtx.$implicit; const ctx_r21 = i0.ɵɵnextContext(2); return ctx_r21.selectedFrom(dropList_r17); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "label", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const dropList_r17 = ctx.$implicit;
    const i_r18 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", dropList_r17.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "dropcheck", i_r18, "");
    i0.ɵɵproperty("ngModel", dropList_r17.selected)("checked", dropList_r17.selected);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "dropcheck", i_r18, "");
} }
function DropdownWithCheckboxComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, DropdownWithCheckboxComponent_div_5_ol_1_Template, 6, 5, "ol", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.droDownList);
} }
function DropdownWithCheckboxComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵlistener("click", function DropdownWithCheckboxComponent_div_6_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.expandDropdown($event); });
    i0.ɵɵelementEnd();
} }
const _c0$I = function (a0) { return { "dropdownExpand": a0 }; };
class DropdownWithCheckboxComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.addSDKConsortium = new EventEmitter();
        this.removeSDKConsortium = new EventEmitter();
        this.dropdownExpand = false;
        this.dropDownSelectedList = [];
        this.appTypeDrop = '';
        this.expandDropdown = (typeOfApp) => {
            this.dropdownExpand = !this.dropdownExpand;
            this.appTypeDrop = typeOfApp;
            // if (this.dropdownExpand) {
            //   this.checkForSelection();
            // }
        };
        this.selectedFrom = (dropItem) => {
            console.log("Selected items :: " + dropItem);
            if (dropItem.selected) {
                this.dropDownSelectedList.push(dropItem);
                this.emitSelectedList();
            }
            else {
                let index = this.dropDownSelectedList.indexOf(dropItem);
                this.dropDownSelectedList.splice(index, 1);
                this.emitRemoveItem(dropItem);
            }
        };
        this.removeSelectedItem = (removeItem) => {
            this.dropdownExpand = true;
            let index = this.dropDownSelectedList.indexOf(removeItem);
            this.dropDownSelectedList.splice(index, 1);
            this.droDownList.forEach(item => {
                if (item.name == removeItem.name) {
                    item.selected = false;
                }
            });
            this.emitRemoveItem(removeItem);
        };
        this.emitSelectedList = () => {
            this.addSDKConsortium.emit(this.dropDownSelectedList);
        };
        this.emitRemoveItem = (list) => {
            this.removeSDKConsortium.emit(list);
        };
        this.checkForSelectionList = () => {
            this.dropDownSelectedList = [];
            let itemsList = this.selectedItemList.consortium.split(',');
            itemsList.forEach((selected, index) => {
                this.droDownList.forEach(dropItem => {
                    if ((dropItem.WBA_OI == selected || dropItem.Cisco_OI == selected) && selected != 'Not defined') {
                        dropItem.selected = true;
                        if (this.dropDownSelectedList.findIndex((dropIdem => dropIdem.WBA_OI == selected || dropIdem.Cisco_OI == selected)) < 0) {
                            this.dropDownSelectedList.push(dropItem);
                        }
                    }
                });
            });
            this.dataService.display(false);
        };
    }
    ngOnInit() {
        this.dataService.display(true);
        setTimeout(() => {
            this.checkForSelectionList();
        }, 2000);
    }
}
DropdownWithCheckboxComponent.ɵfac = function DropdownWithCheckboxComponent_Factory(t) { return new (t || DropdownWithCheckboxComponent)(i0.ɵɵdirectiveInject(DataService)); };
DropdownWithCheckboxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DropdownWithCheckboxComponent, selectors: [["app-dropdown-with-checkbox"]], inputs: { droDownList: "droDownList", appType: "appType", selectedItemList: "selectedItemList" }, outputs: { addSDKConsortium: "addSDKConsortium", removeSDKConsortium: "removeSDKConsortium" }, decls: 7, vars: 8, consts: [[1, "dropDown-with-checkbox", 3, "ngClass"], [1, "selectedDropdown", 3, "click"], [4, "ngIf"], ["class", "dropDownBody", 4, "ngIf"], ["class", "dropdownFilterOverlay", 3, "click", 4, "ngIf"], ["class", "drop_selected", 4, "ngFor", "ngForOf"], [1, "drop_selected"], [1, "backgroud"], [1, "removeItem", 3, "click"], [1, "dropDownBody"], ["class", "dropOl", 4, "ngFor", "ngForOf"], [1, "dropOl"], [1, "dropList"], [1, "checkBox"], ["type", "checkbox", 3, "ngModel", "checked", "id", "ngModelChange", "change"], [3, "for"], [1, "dropdownFilterOverlay", 3, "click"]], template: function DropdownWithCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵlistener("click", function DropdownWithCheckboxComponent_Template_div_click_1_listener() { return ctx.expandDropdown(ctx.appType); });
        i0.ɵɵtemplate(2, DropdownWithCheckboxComponent_span_2_Template, 2, 0, "span", 2);
        i0.ɵɵtemplate(3, DropdownWithCheckboxComponent_span_3_Template, 2, 1, "span", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, DropdownWithCheckboxComponent_div_4_Template, 2, 1, "div", 3);
        i0.ɵɵtemplate(5, DropdownWithCheckboxComponent_div_5_Template, 2, 1, "div", 3);
        i0.ɵɵtemplate(6, DropdownWithCheckboxComponent_div_6_Template, 1, 0, "div", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$I, ctx.dropdownExpand));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.dropDownSelectedList.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropDownSelectedList.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownExpand && ctx.appTypeDrop === "ios");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownExpand && ctx.appTypeDrop === "droid");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownExpand);
    } }, directives: [i1$2.NgClass, i1$2.NgIf, i1$2.NgForOf, i2$1.CheckboxControlValueAccessor, i2$1.NgControlStatus, i2$1.NgModel], styles: ["@charset \"UTF-8\";.dropDown-with-checkbox[_ngcontent-%COMP%]{width:100%;display:block;margin:10px 0;position:relative}.dropDown-with-checkbox[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{width:12px;height:12px;color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;top:6px;right:4px;padding:4px;font-size:14px;display:block;content:\"\\e905\";z-index:100}.dropDown-with-checkbox[_ngcontent-%COMP%]   .dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{content:\"\\e908\"}.dropdownFilterOverlay[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:100;background-color:#ffffff1a}.selectedDropdown[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #9E9EA2;width:100%;border-radius:0;cursor:pointer;padding:8px 10px;z-index:101;position:relative}.dropDown-with-checkbox[_ngcontent-%COMP%]   .dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]{border-color:#049fd9}.simpleDropdownList[_ngcontent-%COMP%]{display:none;width:100%;position:absolute;top:38px;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:103;box-shadow:0 0 3px #0000004d}.dropDown-with-checkbox.dropdownExpand[_ngcontent-%COMP%]   .simpleDropdownList[_ngcontent-%COMP%]{display:block;background-color:#fff}.dropDown-with-checkbox[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]{display:block;padding:12px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.dropDown-with-checkbox[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]:hover{color:#666;background-color:#39393b1a}.dropDownBody[_ngcontent-%COMP%]{position:absolute;display:inline-block;height:400px;width:100%;overflow-y:scroll;z-index:10000;background-color:#fff;border-left:1px solid #9E9EA2;padding-bottom:15px}span.checkBox[_ngcontent-%COMP%]{position:absolute;right:15px}ol.dropOl[_ngcontent-%COMP%]{margin:2px 0;border-bottom:1px solid #9E9EA2}.removeItem[_ngcontent-%COMP%]{font-family:\"icomoon-new\";font-size:7px;position:relative;top:-5px}span.backgroud[_ngcontent-%COMP%]{background:#9e9ea257;border-radius:10px;margin-left:2px;padding:0 5px}.drop_selected[_ngcontent-%COMP%]{display:inline-block}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownWithCheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'app-dropdown-with-checkbox',
                templateUrl: './dropdown-with-checkbox.component.html',
                styleUrls: ['./dropdown-with-checkbox.component.scss']
            }]
    }], function () { return [{ type: DataService }]; }, { droDownList: [{
            type: Input
        }], appType: [{
            type: Input
        }], selectedItemList: [{
            type: Input
        }], addSDKConsortium: [{
            type: Output
        }], removeSDKConsortium: [{
            type: Output
        }] }); })();

function DropdownWithSearchoptionComponent_input_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 9);
    i0.ɵɵlistener("click", function DropdownWithSearchoptionComponent_input_4_Template_input_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.expandDropdown(!ctx_r5.dropdownExpand); })("keydown", function DropdownWithSearchoptionComponent_input_4_Template_input_keydown_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.restrictCharacter($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r0.placeholder);
} }
function DropdownWithSearchoptionComponent_input_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 10);
    i0.ɵɵlistener("ngModelChange", function DropdownWithSearchoptionComponent_input_5_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.filterString = $event; })("click", function DropdownWithSearchoptionComponent_input_5_Template_input_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.expandDropdown(!ctx_r10.dropdownExpand); })("keydown", function DropdownWithSearchoptionComponent_input_5_Template_input_keydown_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.restrictCharacter($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r1.placeholder);
    i0.ɵɵproperty("ngModel", ctx_r1.filterString);
} }
function DropdownWithSearchoptionComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "span", 12);
    i0.ɵɵelement(2, "img", 13);
    i0.ɵɵelementStart(3, "input", 14);
    i0.ɵɵlistener("ngModelChange", function DropdownWithSearchoptionComponent_div_7_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.filterString = $event; })("keydown", function DropdownWithSearchoptionComponent_div_7_Template_input_keydown_3_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.allowCharacters($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r2.filterString);
} }
function DropdownWithSearchoptionComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function DropdownWithSearchoptionComponent_div_8_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const obj_r15 = restoredCtx.$implicit; const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.selectOptions(obj_r15); });
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵelementStart(2, "span", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 18);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const obj_r15 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(obj_r15.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(obj_r15.dataType);
} }
function DropdownWithSearchoptionComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function DropdownWithSearchoptionComponent_div_10_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.expandDropdown(false); });
    i0.ɵɵelementEnd();
} }
const _c0$H = function (a0) { return { "dropdownExpand": a0 }; };
class DropdownWithSearchoptionComponent {
    constructor() {
        this.selectOption = new EventEmitter();
        this.dropdDownExpand = new EventEmitter();
        this.filterString = "";
        this.dropdownExpand = false;
        this.sharedLabel = "Across Use Cases";
        this.expandDropdown = (event) => {
            this.dropdownExpand = event;
            this.filterString = "";
            this.dropdDownExpand.emit(event);
        };
        this.selectOptions = (optionObj) => {
            this.selectedOption = optionObj;
            this.placeholder = optionObj.name;
            this.filterString = "";
            optionObj.visibleType = this.sharedLabel;
            this.selectOption.emit(optionObj);
            this.dropdownExpand = false;
        };
        this.restrictCharacter = (event) => {
            if (this.isSearchSeparate) {
                return false;
            }
            else {
                if (this.setTimeoutObj) {
                    clearTimeout(this.setTimeoutObj);
                }
                this.setTimeoutObj = setTimeout(() => {
                    this.placeholder = this.filterString;
                    let jsonObj = {
                        name: this.placeholder,
                    };
                    this.selectOption.emit(jsonObj);
                }, 1);
            }
        };
        this.allowCharacters = ($event) => {
            if ($event.keyCode === 13) {
                this.placeholder = this.filterString;
                let jsonObj = {
                    name: this.placeholder,
                };
                this.selectOption.emit(jsonObj);
                this.dropdownExpand = false;
            }
        };
    }
    // constructor() { }
    ngOnInit() {
        console.log("Entered  Dropdown With Search option Component");
    }
}
DropdownWithSearchoptionComponent.ɵfac = function DropdownWithSearchoptionComponent_Factory(t) { return new (t || DropdownWithSearchoptionComponent)(); };
DropdownWithSearchoptionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DropdownWithSearchoptionComponent, selectors: [["lib-dropdown-with-searchoption"]], inputs: { placeholder: "placeholder", optionObj: "optionObj", isSearchSeparate: "isSearchSeparate" }, outputs: { selectOption: "selectOption", dropdDownExpand: "dropdDownExpand" }, decls: 11, vars: 12, consts: [[1, "dropdownFilterContainer"], [1, "dropdownInput", 3, "ngClass"], [1, "arrow", 3, "click"], ["type", "text", "class", "formControl", "name", "dropdownFilter", "autocomplete", "off", 3, "placeholder", "click", "keydown", 4, "ngIf"], ["type", "text", "class", "formControl", "name", "dropdownFilter", "autocomplete", "off", 3, "placeholder", "ngModel", "ngModelChange", "click", "keydown", 4, "ngIf"], [1, "dropdownFilterList"], ["class", "user-search-container", 4, "ngIf"], ["class", "eachElement", 3, "click", 4, "ngFor", "ngForOf"], ["class", "dropdownFilterOverlay", 3, "click", 4, "ngIf"], ["type", "text", "name", "dropdownFilter", "autocomplete", "off", 1, "formControl", 3, "placeholder", "click", "keydown"], ["type", "text", "name", "dropdownFilter", "autocomplete", "off", 1, "formControl", 3, "placeholder", "ngModel", "ngModelChange", "click", "keydown"], [1, "user-search-container"], [1, "user-search-icon"], ["src", "/assets/images/search_icon.svg", "alt", "Search Icon", 1, "img-text"], ["name", "userSearch", "autocomplete", "off", 1, "searchInput", 3, "ngModel", "ngModelChange", "keydown"], [1, "eachElement", 3, "click"], [1, "dropdown-content"], [1, "nameValue"], [1, "typeValue"], [1, "dropdownFilterOverlay", 3, "click"]], template: function DropdownWithSearchoptionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵlistener("click", function DropdownWithSearchoptionComponent_Template_span_click_2_listener() { return ctx.expandDropdown(!ctx.dropdownExpand); });
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, DropdownWithSearchoptionComponent_input_4_Template, 1, 1, "input", 3);
        i0.ɵɵtemplate(5, DropdownWithSearchoptionComponent_input_5_Template, 1, 2, "input", 4);
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵtemplate(7, DropdownWithSearchoptionComponent_div_7_Template, 4, 1, "div", 6);
        i0.ɵɵtemplate(8, DropdownWithSearchoptionComponent_div_8_Template, 6, 2, "div", 7);
        i0.ɵɵpipe(9, "genericDropdownFilter");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, DropdownWithSearchoptionComponent_div_10_Template, 1, 0, "div", 8);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0$H, ctx.dropdownExpand));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.dropdownExpand ? "\uE908" : "\uE905");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSearchSeparate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isSearchSeparate);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isSearchSeparate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(9, 7, ctx.optionObj, ctx.filterString));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.dropdownExpand);
    } }, directives: [i1$2.NgClass, i1$2.NgIf, i1$2.NgForOf, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel], pipes: [GenericDropdownFilterPipe], styles: [".dropdownFilterContainer{display:block;max-width:340px;margin:10px 0;position:relative}.dropdownInput span.arrow{color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;bottom:6px;right:0;padding:4px;font-size:14px;display:block;z-index:1003}.dropdownFilterContainer input[type=text]{border:0;border-bottom:2px solid #dddfe2;font-size:14px;color:#909090;font-family:\"ciscoSansRegular\";padding:6px 10px;margin-bottom:0;border-radius:0;z-index:1003}.dropdownFilterContainer input[type=text]:focus{border-bottom:2px solid #049fd9}.dropdownFilterList{display:none;width:100%;position:absolute;top:100%;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:1003;box-shadow:0 0 3px #0000004d}.dropdownInput.dropdownExpand .dropdownFilterList{display:block;background-color:#fff}.dropdownFilterContainer .eachElement{display:block;padding:8px 10px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.dropdownFilterOverlay{position:fixed;top:0;left:0;width:100%;height:100%;z-index:1000;background-color:#ffffff1a}.user-search-container{border:1px solid #f7f7f7;background:#f7f7f7;border-radius:10px;padding:5px 10px;margin:5px 10px}.user-search-container .searchInput{margin-left:5px;border:none;background:#f7f7f7;width:85%}.typeValue{float:right}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownWithSearchoptionComponent, [{
        type: Component,
        args: [{
                selector: "lib-dropdown-with-searchoption",
                templateUrl: "./dropdown-with-searchoption.component.html",
                styleUrls: ["./dropdown-with-searchoption.component.scss"],
                encapsulation: ViewEncapsulation.None
            }]
    }], null, { placeholder: [{
            type: Input
        }], optionObj: [{
            type: Input
        }], selectOption: [{
            type: Output
        }], dropdDownExpand: [{
            type: Output
        }], isSearchSeparate: [{
            type: Input
        }] }); })();

const _c0$G = function (a0) { return { "showError": a0 }; };
function DropdownWithSubtextComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function DropdownWithSubtextComponent_div_1_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.expandDropdown($event); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$G, ctx_r0.isError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r0.selectedItem.name, " (", ctx_r0.selectedItem.usersCount, ") ");
} }
const _c1$j = function (a0, a1) { return { "placeHolderColor": a0, "showError": a1 }; };
function DropdownWithSubtextComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function DropdownWithSubtextComponent_div_2_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.expandDropdown($event); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c1$j, ctx_r1.placeHolder != "Select", ctx_r1.isError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.placeHolder, " ");
} }
function DropdownWithSubtextComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function DropdownWithSubtextComponent_div_3_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r12); const item_r10 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.selectItem(item_r10); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", item_r10.name, " (", item_r10.usersCount, ") ");
} }
function DropdownWithSubtextComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, DropdownWithSubtextComponent_div_3_div_1_Template, 2, 2, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.listItems);
} }
function DropdownWithSubtextComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵtext(2, "List Unavailable");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function DropdownWithSubtextComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function DropdownWithSubtextComponent_div_5_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.expandDropdown($event); });
    i0.ɵɵelementEnd();
} }
const _c2$d = function (a0) { return { "dropdownExpand": a0 }; };
class DropdownWithSubtextComponent {
    constructor() {
        this.dropdownSelectEmitter = new EventEmitter();
        this.dropdownExpand = false;
        this.expandDropdown = (event) => {
            this.dropdownExpand = !this.dropdownExpand;
        };
        this.selectItem = (selectedItem) => {
            this.selectedItem = selectedItem;
            this.dropdownSelectEmitter.emit(selectedItem);
            this.expandDropdown(false);
        };
    }
    set inputlistItems(listItems) {
        this.listItems = listItems;
    }
    ngOnInit() {
        this.placeHolder = this.placeHolder ? this.placeHolder : "Select";
        if (this.isError == undefined) {
            this.isError = false;
        }
    }
}
DropdownWithSubtextComponent.ɵfac = function DropdownWithSubtextComponent_Factory(t) { return new (t || DropdownWithSubtextComponent)(); };
DropdownWithSubtextComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DropdownWithSubtextComponent, selectors: [["lib-dropdown-with-subtext"]], inputs: { selectedItem: "selectedItem", placeHolder: "placeHolder", inputlistItems: ["listItems", "inputlistItems"], isError: "isError" }, outputs: { dropdownSelectEmitter: "dropdownSelectEmitter" }, decls: 6, vars: 8, consts: [[1, "genericDropdownContainer", 3, "ngClass"], ["class", "selectedDropdown", 3, "ngClass", "click", 4, "ngIf"], ["class", "genericDropdownList", 4, "ngIf"], ["class", "dropdownFilterOverlay", 3, "click", 4, "ngIf"], [1, "selectedDropdown", 3, "ngClass", "click"], [1, "genericDropdownList"], ["class", "eachElement", 3, "click", 4, "ngFor", "ngForOf"], [1, "eachElement", 3, "click"], [1, "eachElement"], [1, "dropdownFilterOverlay", 3, "click"]], template: function DropdownWithSubtextComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, DropdownWithSubtextComponent_div_1_Template, 2, 5, "div", 1);
        i0.ɵɵtemplate(2, DropdownWithSubtextComponent_div_2_Template, 2, 5, "div", 1);
        i0.ɵɵtemplate(3, DropdownWithSubtextComponent_div_3_Template, 2, 1, "div", 2);
        i0.ɵɵtemplate(4, DropdownWithSubtextComponent_div_4_Template, 3, 0, "div", 2);
        i0.ɵɵtemplate(5, DropdownWithSubtextComponent_div_5_Template, 1, 0, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c2$d, ctx.dropdownExpand));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listItems && ctx.listItems.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listItems === undefined || ctx.listItems.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownExpand);
    } }, directives: [i1$2.NgClass, i1$2.NgIf, i1$2.NgForOf], styles: ["@charset \"UTF-8\";.genericDropdownContainer[_ngcontent-%COMP%]{width:200px;display:block;margin:10px 0;position:relative}.genericDropdownContainer[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{width:12px;height:12px;color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;top:6px;right:4px;padding:4px;font-size:14px;display:block;content:\"\\e905\";z-index:100}.genericDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{content:\"\\e908\"}.selectedDropdown[_ngcontent-%COMP%]{background-color:#fff;border-bottom:2px solid #dddfe2;width:100%;border-radius:0;cursor:pointer;padding:8px 24px 8px 10px;z-index:101;position:relative;color:#333439;font-family:ciscoSans;font-size:14px}.genericDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]{border-color:#049fd9}.genericDropdownList[_ngcontent-%COMP%]{display:none;width:100%;position:absolute;top:38px;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:103;border-bottom:1px solid rgba(0,0,0,.3);box-shadow:0 0 3px #0000004d}.genericDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .genericDropdownList[_ngcontent-%COMP%]{display:block;background-color:#fff}.genericDropdownContainer[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]{display:block;padding:12px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.genericDropdownContainer[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]:hover{color:#666;background-color:#39393b1a}.dropdownFilterOverlay[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:100;background-color:#ffffff1a}.placeHolderColor[_ngcontent-%COMP%]{color:#898989}.showError[_ngcontent-%COMP%]{border-bottom:2px solid red!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownWithSubtextComponent, [{
        type: Component,
        args: [{
                selector: "lib-dropdown-with-subtext",
                templateUrl: "./dropdown-with-subtext.component.html",
                styleUrls: ["./dropdown-with-subtext.component.scss"]
            }]
    }], null, { selectedItem: [{
            type: Input
        }], placeHolder: [{
            type: Input
        }], inputlistItems: [{
            type: Input,
            args: ["listItems"]
        }], isError: [{
            type: Input
        }], dropdownSelectEmitter: [{
            type: Output
        }] }); })();

function DropdownWithTextfieldComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r0.emptyStateText, i0.ɵɵsanitizeHtml);
} }
function DropdownWithTextfieldComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r1.selectedItem.url, i0.ɵɵsanitizeHtml);
} }
function DropdownWithTextfieldComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r2.emptyStateText, i0.ɵɵsanitizeHtml);
} }
function DropdownWithTextfieldComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r3.selectedItem.url, i0.ɵɵsanitizeHtml);
} }
function DropdownWithTextfieldComponent_li_12_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 11);
    i0.ɵɵlistener("click", function DropdownWithTextfieldComponent_li_12_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const item_r7 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.itemSelected(item_r7); });
    i0.ɵɵelement(1, "span", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", item_r7.url, i0.ɵɵsanitizeHtml);
} }
const _c0$F = function (a0) { return { "disabled": a0 }; };
function DropdownWithTextfieldComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵelementStart(2, "input", 14);
    i0.ɵɵlistener("ngModelChange", function DropdownWithTextfieldComponent_div_13_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.customDomain = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵelementStart(5, "img", 16);
    i0.ɵɵlistener("click", function DropdownWithTextfieldComponent_div_13_Template_img_click_5_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.closebtnClicked(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "button", 17);
    i0.ɵɵlistener("click", function DropdownWithTextfieldComponent_div_13_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r11); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.saveBtnClick(); });
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r5.customDomain);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$F, ctx_r5.customDomain == ""));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 3, "shared-lib.dropdown-with-textfield.save-add"), " ");
} }
function DropdownWithTextfieldComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵlistener("click", function DropdownWithTextfieldComponent_div_14_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.genericBtnClicked(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", ctx_r6.genericBtnText, i0.ɵɵsanitizeHtml);
} }
const _c1$i = function (a0, a1) { return { "hidden-d": a0, "visible-d": a1 }; };
const jQuery$2 = jQuery_;
class DropdownWithTextfieldComponent {
    constructor(dataService, translate) {
        this.dataService = dataService;
        this.translate = translate;
        this.emitGenericBtn = new EventEmitter();
        this.emitSelectedItem = new EventEmitter();
        this.isExpanded = false;
        this.translateKeys = [];
        this.emptyStateText = this.translateKeys["select"];
        this.genericBtnText = null;
        this.showTextField = false;
        this.customDomain = "";
        this.itemSelected = (item) => {
            this.selectedItem = item;
            this.emitSelectedItem.emit(this.selectedItem);
        };
        this.genericBtnClicked = () => {
            this.customDomain = "";
            this.showTextField = true;
            this.genericBtnText = null;
            // this.emitGenericBtn.emit(true);
        };
        this.saveBtnClick = () => {
            if (this.customDomain != null && this.customDomain != "") {
                this.showTextField = false;
                this.genericBtnText = this.translateKeys["add_custom_domain"];
                this.emitGenericBtn.emit(this.customDomain);
            }
            else {
                this.dataService.setToastMessage(this.translateKeys["enter_domain"], 4000, null, null, "error");
            }
        };
        this.closebtnClicked = () => {
            this.showTextField = false;
            this.genericBtnText = this.translateKeys["add_custom_domain"];
        };
        this.toggleDropDown = () => {
            this.isExpanded = !this.isExpanded;
            this.isExpanded
                ? jQuery$2("#gddExpand").slideDown(100)
                : jQuery$2("#gddExpand").slideUp(100);
        };
        this.getTextKeys = () => {
            this.translate.get('shared-lib.dropdown-with-textfield').subscribe((res) => {
                this.translateKeys = res;
            });
        };
    }
    clickout($evt) {
        console.log($evt);
        if (jQuery$2("#gddExpand").is(":visible") &&
            $evt.offsetParent != null &&
            $evt.offsetParent.className != "gdd-wrapper" &&
            $evt.offsetParent.className != "customDomain-field") {
            this.isExpanded = false;
            jQuery$2("#gddExpand").slideUp(200);
            this.showTextField = false;
            this.genericBtnText = this.translateKeys["add_custom_domain"];
        }
    }
    set list(values) {
        this.listItems = values;
    }
    set config(value) {
        this.emptyStateText =
            value.emptyStateText != undefined
                ? value.emptyStateText
                : this.emptyStateText;
        this.genericBtnText =
            value.genericBtnText != undefined ? value.genericBtnText : null;
        if (value.selectedItem != null) {
            this.selectedItem = value.selectedItem;
            setTimeout(() => {
                this.emitSelectedItem.emit(this.selectedItem);
            }, 100);
        }
    }
    ngOnInit() { this.getTextKeys(); this.genericBtnText = this.translateKeys["add_custom_domain"]; }
}
DropdownWithTextfieldComponent.ɵfac = function DropdownWithTextfieldComponent_Factory(t) { return new (t || DropdownWithTextfieldComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
DropdownWithTextfieldComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DropdownWithTextfieldComponent, selectors: [["app-dropdown-with-textfield"]], hostBindings: function DropdownWithTextfieldComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function DropdownWithTextfieldComponent_click_HostBindingHandler($event) { return ctx.clickout($event.target); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { list: "list", config: "config" }, outputs: { emitGenericBtn: "emitGenericBtn", emitSelectedItem: "emitSelectedItem" }, decls: 15, vars: 11, consts: [[1, "gdd-wrapper"], [1, "gdd-collapsed", "noselect", 3, "ngClass"], [1, "gdd-selected", 3, "click"], [3, "innerHtml", 4, "ngIf"], [1, "arrow_down"], ["id", "gddExpand", 1, "gdd-expanded", "noselect"], [1, "arrow_up"], [3, "click", 4, "ngFor", "ngForOf"], ["class", "customDomain-div gdd-footer", 4, "ngIf"], ["class", "gdd-footer", 4, "ngIf"], [3, "innerHtml"], [3, "click"], [1, "customDomain-div", "gdd-footer"], [1, "customDomain-field"], ["type", "text", "id", "customDomain", "name", "customDomain", "required", "", 1, "inputText", "input-text", "customStyle", 3, "ngModel", "ngModelChange"], ["id", "customDomainWrapper", 1, "customDomain-wrapper"], ["src", "/assets/images/close_popup_icon.svg", "width", "30", 3, "click"], [1, "modalSecondaryButton", "canceledButton", 3, "ngClass", "click"], [1, "gdd-footer"], [1, "gdd-footer-btn", 3, "innerHtml", "click"]], template: function DropdownWithTextfieldComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵlistener("click", function DropdownWithTextfieldComponent_Template_div_click_2_listener() { return ctx.toggleDropDown(); });
        i0.ɵɵtemplate(3, DropdownWithTextfieldComponent_div_3_Template, 1, 1, "div", 3);
        i0.ɵɵtemplate(4, DropdownWithTextfieldComponent_div_4_Template, 1, 1, "div", 3);
        i0.ɵɵelement(5, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 2);
        i0.ɵɵlistener("click", function DropdownWithTextfieldComponent_Template_div_click_7_listener() { return ctx.toggleDropDown(); });
        i0.ɵɵtemplate(8, DropdownWithTextfieldComponent_div_8_Template, 1, 1, "div", 3);
        i0.ɵɵtemplate(9, DropdownWithTextfieldComponent_div_9_Template, 1, 1, "div", 3);
        i0.ɵɵelement(10, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "ul");
        i0.ɵɵtemplate(12, DropdownWithTextfieldComponent_li_12_Template, 2, 1, "li", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, DropdownWithTextfieldComponent_div_13_Template, 10, 7, "div", 8);
        i0.ɵɵtemplate(14, DropdownWithTextfieldComponent_div_14_Template, 2, 1, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c1$i, ctx.isExpanded, !ctx.isExpanded));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selectedItem == null && ctx.emptyStateText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedItem != null);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.selectedItem == null && ctx.emptyStateText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedItem != null);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.listItems);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showTextField);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.genericBtnText != null);
    } }, directives: [i1$2.NgClass, i1$2.NgIf, i1$2.NgForOf, i2$1.DefaultValueAccessor, i2$1.RequiredValidator, i2$1.NgControlStatus, i2$1.NgModel], pipes: [i2.TranslatePipe], styles: [".gdd-wrapper[_ngcontent-%COMP%]{width:320px;position:relative}.gdd-selected[_ngcontent-%COMP%]{font-size:14px;color:#6b6b6b;font-family:ciscoSans;padding:15px;cursor:pointer;letter-spacing:1px;display:flex}.gdd-collapsed[_ngcontent-%COMP%]   .gdd-selected[_ngcontent-%COMP%]{border-bottom:1px solid #efefef}.gdd-expanded[_ngcontent-%COMP%]{box-shadow:0 1px 3px 1px #bdbdbd3d;border:1px solid #efefef;display:none;padding:0;margin:0;position:absolute;background:#fff;width:320px;max-height:220px;overflow-y:auto;top:0;z-index:1}.gdd-expanded[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0}.gdd-expanded[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:10px 15px;cursor:pointer;font-size:16px;font-family:ciscoSansLight;color:#1f1f1f}.gdd-expanded[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{background:#efefef}.gdd-expanded[_ngcontent-%COMP%]   .gdd-selected[_ngcontent-%COMP%]{position:sticky;width:320px;background:#fff;border-bottom:1px solid #ececec;padding:15px}.arrow_down[_ngcontent-%COMP%]{background:url(/assets/images/basic/generic/arrow_down.svg) no-repeat;height:20px;width:20px;background-position-y:center;position:absolute;right:0}.arrow_up[_ngcontent-%COMP%]{background:url(/assets/images/basic/generic/arrow_up.svg) no-repeat #fff;height:20px;width:20px;background-position:center;position:absolute;right:5px}.down[_ngcontent-%COMP%]{transform:rotate(90deg)}.hidden-d[_ngcontent-%COMP%]{visibility:hidden}.visible-d[_ngcontent-%COMP%]{visibility:visible}.gdd-footer[_ngcontent-%COMP%]{border-top:1px solid #efefef;padding:10px;display:block;bottom:0;width:100%;background:#fff;position:sticky}.gdd-footer-btn[_ngcontent-%COMP%]{border:1px solid #049fd9;padding:5px;width:230px;color:#049fd9;margin:0 auto;text-align:center;font-family:ciscoSans;font-size:15px;cursor:pointer}.noselect[_ngcontent-%COMP%]{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.customDomain-field[_ngcontent-%COMP%]{display:flex;position:relative;align-items:center}.customDomain-inp-wrp[_ngcontent-%COMP%]{width:80%}.customDomain-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;border-bottom:1px solid #9e9ea2;align-items:center;cursor:pointer}.customDomain-wrapper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(1){margin-right:5px;width:17px}.customDomain-wrapper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(1):hover{opacity:.8;transition:all .3s ease-in;transition-delay:.2s}.customDomain-wrapper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(2){font-size:11px;font-family:ciscoSans;color:#059fd9;font-weight:normal;letter-spacing:.4px;width:35px}.customDomain-wrapper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(2):hover{opacity:.8;transition:all .2s ease-in;transition-delay:.1s}.canceledButton[_ngcontent-%COMP%]{float:right!important}.customDomain-div[_ngcontent-%COMP%]{padding:0 30px 15px 15px;border-top:1px solid #efefef}.disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.5}img[_ngcontent-%COMP%]{max-width:80%!important}.customStyle[_ngcontent-%COMP%]{margin-top:4px!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownWithTextfieldComponent, [{
        type: Component,
        args: [{
                selector: "app-dropdown-with-textfield",
                templateUrl: "./dropdown-with-textfield.component.html",
                styleUrls: ["./dropdown-with-textfield.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }]; }, { clickout: [{
            type: HostListener,
            args: ["document:click", ["$event.target"]]
        }], list: [{
            type: Input
        }], config: [{
            type: Input
        }], emitGenericBtn: [{
            type: Output
        }], emitSelectedItem: [{
            type: Output
        }] }); })();

const _c0$E = function (a0) { return { "disabled": a0 }; };
class EmailInputComponent {
    constructor() {
        this.emitEmailData = new EventEmitter();
        this.disabled = false;
        this.onBlur = ($event) => {
            console.log($event.which);
            const emitData = {
                email: null,
                error: true
            };
            const indexArr = [0, 32, 13];
            if (indexArr.indexOf($event.which) > -1 &&
                this.emailData != null &&
                this.emailData.trim().length > 0) {
                if (this.validateEmail(this.emailData)) {
                    emitData.email = this.emailData;
                    emitData.error = false;
                }
                else {
                    emitData.email = null;
                    emitData.error = true;
                }
                this.emitEmailData.emit(emitData);
            }
            else if (this.emailData.trim().length == 0) {
                emitData.email = null;
                emitData.error = true;
                this.emitEmailData.emit(emitData);
            }
        };
        this.onKeyUp = ($event) => {
            const emitData = {
                email: null,
                error: false
            };
            const indexArr = [0, 32, 13];
            if (indexArr.indexOf($event.which) > -1 ||
                this.emailData.trim().length == 0) {
                emitData.email = null;
                emitData.error = true;
            }
            this.emitEmailData.emit(emitData);
        };
        this.validateEmail = (email) => {
            const mailformat = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
            if (mailformat.test(email)) {
                return true;
            }
            else {
                return false;
            }
        };
    }
    set inputValue(value) {
        this.emailData = value;
    }
    set isDisabled(value) {
        this.disabled = value;
    }
    ngOnInit() { }
}
EmailInputComponent.ɵfac = function EmailInputComponent_Factory(t) { return new (t || EmailInputComponent)(); };
EmailInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EmailInputComponent, selectors: [["email-input"]], inputs: { inputValue: "inputValue", isDisabled: "isDisabled" }, outputs: { emitEmailData: "emitEmailData" }, decls: 2, vars: 4, consts: [[3, "ngClass"], [1, "inputField", 3, "ngModel", "keyup", "blur", "ngModelChange"]], template: function EmailInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "input", 1);
        i0.ɵɵlistener("keyup", function EmailInputComponent_Template_input_keyup_1_listener($event) { return ctx.onKeyUp($event); })("blur", function EmailInputComponent_Template_input_blur_1_listener($event) { return ctx.onBlur($event); })("ngModelChange", function EmailInputComponent_Template_input_ngModelChange_1_listener($event) { return ctx.emailData = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$E, ctx.disabled));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.emailData);
    } }, directives: [i1$2.NgClass, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel], styles: [".inputField[_ngcontent-%COMP%]{display:inline-block;width:300px;outline:none;border:none;border-bottom:1px solid #efefef;border-radius:0;font-size:16px;padding:8px}.chip-mask-wrpper[_ngcontent-%COMP%]{display:flex}.chip-mask-wrpper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background:#ddd;position:relative;top:-27px}.disabled[_ngcontent-%COMP%]{cursor:not-allowed}.disabled[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{opacity:.5;pointer-events:none;background-color:#cfcfcf;border-radius:3px}.emailError[_ngcontent-%COMP%]{color:red;font-family:ciscoSans;font-size:14px;padding:10px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EmailInputComponent, [{
        type: Component,
        args: [{
                selector: "email-input",
                templateUrl: "./email-input.component.html",
                styleUrls: ["./email-input.component.scss"]
            }]
    }], function () { return []; }, { inputValue: [{
            type: Input
        }], isDisabled: [{
            type: Input
        }], emitEmailData: [{
            type: Output
        }] }); })();

function FooterLogoComponent_div_0_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵlistener("click", function FooterLogoComponent_div_0_div_1_span_1_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(3); return ctx_r7.openLink(ctx_r7.properties.icpLogoFirstUrl); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r5.properties.icpLogoFirstText, i0.ɵɵsanitizeHtml);
} }
function FooterLogoComponent_div_0_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r6.properties.icpLogoFirstText, i0.ɵɵsanitizeHtml);
} }
function FooterLogoComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, FooterLogoComponent_div_0_div_1_span_1_Template, 1, 1, "span", 5);
    i0.ɵɵtemplate(2, FooterLogoComponent_div_0_div_1_span_2_Template, 1, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.properties.icpLogoFirstText !== false && ctx_r1.properties.icpLogoFirstUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.properties.icpLogoFirstText !== false && ctx_r1.properties.icpLogoFirstUrl === false);
} }
function FooterLogoComponent_div_0_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 9);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r2.properties["icpLogoLink"], i0.ɵɵsanitizeUrl);
} }
function FooterLogoComponent_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵlistener("click", function FooterLogoComponent_div_0_span_4_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.openLink(ctx_r9.properties.icpLogoSecondUrl); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r3.properties.icpLogoSecondText, i0.ɵɵsanitizeHtml);
} }
function FooterLogoComponent_div_0_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r4.properties.icpLogoSecondText, i0.ɵɵsanitizeHtml);
} }
function FooterLogoComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, FooterLogoComponent_div_0_div_1_Template, 3, 2, "div", 2);
    i0.ɵɵtemplate(2, FooterLogoComponent_div_0_img_2_Template, 1, 1, "img", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, FooterLogoComponent_div_0_span_4_Template, 1, 1, "span", 5);
    i0.ɵɵtemplate(5, FooterLogoComponent_div_0_span_5_Template, 1, 1, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.properties.icpLogoVisible !== undefined);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.properties.icpLogoLink !== false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.properties.icpLogoSecondText !== false && ctx_r0.properties.icpLogoSecondUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.properties.icpLogoSecondText !== false && ctx_r0.properties.icpLogoSecondUrl === false);
} }
class FooterLogoComponent {
    constructor() {
        this.openLink = ($link) => {
            window.open($link, "_blank");
        };
    }
    ngOnInit() { }
}
FooterLogoComponent.ɵfac = function FooterLogoComponent_Factory(t) { return new (t || FooterLogoComponent)(); };
FooterLogoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FooterLogoComponent, selectors: [["footer-logo"]], inputs: { properties: "properties" }, decls: 1, vars: 1, consts: [["class", "footer-logo-wrapper", 4, "ngIf"], [1, "footer-logo-wrapper"], ["class", "footer-link-texts", 4, "ngIf"], ["height", "25", 3, "src", 4, "ngIf"], [1, "footer-link-texts"], [3, "innerHTML", "click", 4, "ngIf"], ["class", "no-pointer", 3, "innerHTML", 4, "ngIf"], [3, "innerHTML", "click"], [1, "no-pointer", 3, "innerHTML"], ["height", "25", 3, "src"]], template: function FooterLogoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FooterLogoComponent_div_0_Template, 6, 4, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.properties);
    } }, directives: [i1$2.NgIf], styles: [".footer-logo-wrapper[_ngcontent-%COMP%]{height:40px;background:#fff;width:100%;position:relative;padding-top:7px;text-align:center;bottom:0;left:0;display:flex;justify-content:center;align-items:center}.footer-link-texts[_ngcontent-%COMP%]{font-size:13px;color:#0e274d;font-weight:bold;padding:0 20px;cursor:pointer}.no-pointer[_ngcontent-%COMP%]{cursor:default!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterLogoComponent, [{
        type: Component,
        args: [{
                selector: "footer-logo",
                templateUrl: "./footer-logo.component.html",
                styleUrls: ["./footer-logo.component.css"]
            }]
    }], function () { return []; }, { properties: [{
            type: Input
        }] }); })();

const _c0$D = function (a0) { return { "active": a0 }; };
function GeneralPaginationComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function GeneralPaginationComponent_button_13_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const pageNum_r1 = restoredCtx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.onPage(pageNum_r1); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const pageNum_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$D, pageNum_r1 === ctx_r0.currentPage));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(pageNum_r1);
} }
const _c1$h = function (a0) { return { "disabled": a0 }; };
class GeneralPaginationComponent {
    constructor(dataService, translate) {
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.clickEvent = new EventEmitter();
        this.currentPage = 1;
        this.perPage = 10;
        this.recordPerPageList = [10, 25, 50, 100];
        this.messageKeys = {};
        this.pageDetail = () => {
            let min = this.perPage * this.currentPage - this.perPage + 1;
            let max = this.totalRecords <= this.perPage * this.currentPage
                ? this.totalRecords
                : this.perPage * this.currentPage;
            return min.toString() + "-" + max.toString();
        };
        this.currentPageItems = () => {
            this.clickEvent.emit({
                showRecord: this.perPage,
                currentPage: this.currentPage
            });
        };
        this.onChangeShowRecord = ($event) => {
            this.currentPage = 1;
            this.perPage = $event;
            this.currentPageItems();
        };
        this.getTotalRecords = () => {
            return this.totalRecords > 1 ? this.totalRecords + ' ' + this.messageKeys["records"] : this.totalRecords + ' ' + this.messageKeys["record"];
        };
    }
    set records(records) {
        this.totalItems = records;
        this.currentPage = this.currentPage ? this.currentPage : 1;
        this.perPage = this.perPage ? this.perPage : 10;
        this.currentPageItems();
    }
    set totalRecord(totalRecord) {
        this.totalRecords = totalRecord;
        this.getPages();
    }
    ngOnInit() {
        console.log("Entered Iot Pagination Component");
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            this.translate.get('shared-lib.general-pagination.records').subscribe((val) => {
                this.messageKeys["records"] = val;
            });
            this.translate.get('shared-lib.general-pagination.record').subscribe((val) => {
                this.messageKeys["record"] = val;
            });
        });
    }
    getMin() {
        return this.perPage * this.currentPage - this.perPage + 1;
    }
    totalPages() {
        return Math.ceil(this.totalRecords / this.perPage) || 0;
    }
    lastPage() {
        return this.perPage * this.currentPage >= this.totalRecords;
    }
    getMax() {
        let max = this.perPage * this.currentPage;
        max = this.totalRecords;
        return max;
    }
    getPages() {
        const totPage = Math.ceil(this.totalRecords / this.perPage);
        const curPage = this.currentPage || 1;
        const pagesToShow = this.perPage || 10;
        let startPage;
        let endPage;
        let pages = [];
        if (totPage <= 3) {
            startPage = 1;
            endPage = totPage;
        }
        else {
            if (curPage < 3) {
                startPage = 1;
                endPage =
                    curPage == totPage
                        ? totPage
                        : curPage + 1 == totPage - 1
                            ? totPage
                            : curPage + 1;
            }
            else if (curPage + 2 >= totPage) {
                startPage = curPage - 1;
                endPage = curPage + 1 <= totPage ? curPage + 1 : curPage;
            }
            else {
                startPage = curPage - 1;
                endPage = curPage + 1;
            }
        }
        pages = Array.from(Array(endPage + 1 - startPage).keys()).map((i) => startPage + i);
        pages.sort((a, b) => a - b);
        return pages;
    }
    onPage(n) {
        this.currentPage = n;
        this.currentPageItems();
    }
    onPrev() {
        if (this.currentPage !== 1) {
            this.onPage(this.currentPage - 1);
        }
    }
    onNext() {
        if (this.currentPage !== this.totalPages()) {
            this.onPage(this.currentPage + 1);
        }
    }
    ngOnDestroy() {
        console.log('destory App Component');
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
GeneralPaginationComponent.ɵfac = function GeneralPaginationComponent_Factory(t) { return new (t || GeneralPaginationComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
GeneralPaginationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GeneralPaginationComponent, selectors: [["lib-general-pagination"]], inputs: { records: "records", totalRecord: "totalRecord" }, outputs: { clickEvent: "clickEvent" }, decls: 16, vars: 16, consts: [[1, "pagination-wrapper"], [1, "count-div", "commonFont"], [1, "pagination-div", "commonFont"], [1, "record-text", "commonFont"], [1, "dropdown-div"], [3, "selectedItem", "listItems", "onDropdownSelect"], [1, "commonFont", "detailsDiv"], [1, "link", 3, "disabled", "ngClass", "click"], ["class", "numericButton", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "numericButton", 3, "ngClass", "click"]], template: function GeneralPaginationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵelementStart(8, "dropdown-simple", 5);
        i0.ɵɵlistener("onDropdownSelect", function GeneralPaginationComponent_Template_dropdown_simple_onDropdownSelect_8_listener($event) { return ctx.onChangeShowRecord($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "button", 7);
        i0.ɵɵlistener("click", function GeneralPaginationComponent_Template_button_click_11_listener() { return ctx.onPrev(); });
        i0.ɵɵtext(12, " < ");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, GeneralPaginationComponent_button_13_Template, 2, 4, "button", 8);
        i0.ɵɵelementStart(14, "button", 7);
        i0.ɵɵlistener("click", function GeneralPaginationComponent_Template_button_click_14_listener() { return ctx.onNext(); });
        i0.ɵɵtext(15, " > ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.getTotalRecords(), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 10, "shared-lib.general-pagination.show-records"), ":");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("selectedItem", ctx.perPage)("listItems", ctx.recordPerPageList);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.pageDetail());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.currentPage === 1)("ngClass", i0.ɵɵpureFunction1(12, _c1$h, ctx.currentPage === 1));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.getPages());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.lastPage())("ngClass", i0.ɵɵpureFunction1(14, _c1$h, ctx.lastPage()));
    } }, directives: [DropdownSimpleComponent, i1$2.NgClass, i1$2.NgForOf], pipes: [i2.TranslatePipe], styles: [".pagination-wrapper[_ngcontent-%COMP%]{background:#FFFFFF;padding:20px 20px 35px}.pagination-wrapper[_ngcontent-%COMP%]   .count-div[_ngcontent-%COMP%]{float:left}.pagination-wrapper[_ngcontent-%COMP%]   .pagination-div[_ngcontent-%COMP%]{float:right;display:flex;justify-content:right;width:50%}.pagination-wrapper[_ngcontent-%COMP%]   .record-text[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:12px;line-height:18px;letter-spacing:.5px;color:#545454}.detailsDiv[_ngcontent-%COMP%]{padding-right:5px}.commonFont[_ngcontent-%COMP%]{font-family:\"ciscoSansLight\";font-weight:600;font-size:12px;line-height:18px;letter-spacing:.5px;color:#545454}.pagination-div[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{margin:2px 0;border:0;background-color:transparent;display:inline-block;height:100%;padding:0 4px 0 10px;outline:none;color:#4d4d4d;font-size:12px}.pagination-div[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]:last-child{padding-right:10px}.pagination-div[_ngcontent-%COMP%] > button.disabled[_ngcontent-%COMP%]{color:#ccc;cursor:not-allowed}.pagination-div[_ngcontent-%COMP%] > button.numericButton[_ngcontent-%COMP%]{padding:0 10px;color:#049fd9}.pagination-div[_ngcontent-%COMP%] > button.numericButton.active[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;margin:-4px 0 0;padding-top:5px;padding-bottom:5px;border-radius:50px;border:0;cursor:default}.pagination-div[_ngcontent-%COMP%] > button.numericButton.active[_ngcontent-%COMP%] + button[_ngcontent-%COMP%]{border-left:0}.dropdown-div[_ngcontent-%COMP%]{width:11%}[_nghost-%COMP%]     dropdown-simple .simpleDropdownContainer{margin:0!important}[_nghost-%COMP%]     dropdown-simple .simpleDropdownContainer .selectedDropdown{font-size:12px;border:none!important;color:#00a0d1;font-family:\"ciscoSansLight\";font-weight:600;padding:0 10px!important}[_nghost-%COMP%]     dropdown-simple .simpleDropdownContainer .selectedDropdown:before{top:-3px!important;right:15px!important;padding:3px!important;color:#00a0d1!important}[_nghost-%COMP%]     dropdown-simple .simpleDropdownList{bottom:100%;top:auto}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GeneralPaginationComponent, [{
        type: Component,
        args: [{
                selector: 'lib-general-pagination',
                templateUrl: './general-pagination.component.html',
                styleUrls: ['./general-pagination.component.scss']
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }]; }, { records: [{
            type: Input
        }], totalRecord: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }] }); })();

function GenericDropdownFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function GenericDropdownFilterComponent_div_6_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const objName_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.selectObjName(objName_r2); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const objName_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", objName_r2.name, " ");
} }
function GenericDropdownFilterComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function GenericDropdownFilterComponent_div_8_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.expandDropdown(false); });
    i0.ɵɵelementEnd();
} }
const _c0$C = function (a0) { return { "dropdownExpand": a0 }; };
class GenericDropdownFilterComponent {
    constructor() {
        this.onDropdownSelect = new EventEmitter();
        this.dropdownExpand = false;
        this.dropdownFilterText = "";
        this.filterString = "";
        this.expandDropdown = (event) => {
            this.dropdownExpand = event;
        };
        this.selectObjName = (objName) => {
            this.selectedObjName = objName.name;
            this.placeholder = objName.name;
            this.filterString = "";
            this.onDropdownSelect.emit(objName);
            this.dropdownExpand = false;
        };
    }
    ngOnInit() {
        console.log("arrayObj is" + this.arrayObj);
        console.log("placeholder is" + this.placeholder);
    }
}
GenericDropdownFilterComponent.ɵfac = function GenericDropdownFilterComponent_Factory(t) { return new (t || GenericDropdownFilterComponent)(); };
GenericDropdownFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GenericDropdownFilterComponent, selectors: [["app-generic-dropdown-filter"]], inputs: { placeholder: "placeholder", arrayObj: "arrayObj" }, outputs: { onDropdownSelect: "onDropdownSelect" }, decls: 9, vars: 11, consts: [[1, "genericDropdownFilterContainer"], [1, "genericDropdownInput", 3, "ngClass"], [1, "arrow", 3, "click"], ["type", "text", "name", "dropdownFilter", "autocomplete", "off", 1, "formControl", 3, "ngModel", "placeholder", "ngModelChange", "click"], [1, "genericDropdownFilterList"], ["class", "eachElement", 3, "click", 4, "ngFor", "ngForOf"], ["class", "genericDropdownFilterOverlay", 3, "click", 4, "ngIf"], [1, "eachElement", 3, "click"], [1, "genericDropdownFilterOverlay", 3, "click"]], template: function GenericDropdownFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵlistener("click", function GenericDropdownFilterComponent_Template_span_click_2_listener() { return ctx.expandDropdown(!ctx.dropdownExpand); });
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "input", 3);
        i0.ɵɵlistener("ngModelChange", function GenericDropdownFilterComponent_Template_input_ngModelChange_4_listener($event) { return ctx.filterString = $event; })("click", function GenericDropdownFilterComponent_Template_input_click_4_listener() { return ctx.expandDropdown(!ctx.dropdownExpand); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtemplate(6, GenericDropdownFilterComponent_div_6_Template, 2, 1, "div", 5);
        i0.ɵɵpipe(7, "genericDropdownFilter");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, GenericDropdownFilterComponent_div_8_Template, 1, 0, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$C, ctx.dropdownExpand));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.dropdownExpand ? "\uE908" : "\uE905");
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
        i0.ɵɵproperty("ngModel", ctx.filterString);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(7, 6, ctx.arrayObj, ctx.filterString));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.dropdownExpand);
    } }, directives: [i1$2.NgClass, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$2.NgForOf, i1$2.NgIf], pipes: [GenericDropdownFilterPipe], styles: [".genericDropdownFilterContainer{display:block;max-width:340px;margin:10px 0;position:relative}.genericDropdownInput span.arrow{color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;bottom:6px;right:0;padding:4px;font-size:14px;display:block}.genericDropdownFilterContainer input[type=text]{border:0;border-bottom:2px solid #dddfe2;font-size:14px;color:#909090;font-family:\"ciscoSansRegular\";padding:6px 10px;margin-bottom:0;border-radius:0;z-index:1003}.genericDropdownFilterContainer input[type=text]:focus{border-bottom:2px solid #049fd9}.genericDropdownFilterList{display:none;width:100%;position:absolute;top:100%;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:1003;box-shadow:0 0 3px #0000004d}.genericDropdownInput.dropdownExpand .genericDropdownFilterList{display:block;background-color:#fff}.genericDropdownFilterContainer .eachElement{display:block;padding:8px 10px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.genericDropdownFilterContainer .eachElement:hover{color:#666;background-color:#39393b1a}.genericDropdownFilterOverlay{position:fixed;top:0;left:0;width:100%;height:100%;z-index:1000;background-color:#ffffff1a}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericDropdownFilterComponent, [{
        type: Component,
        args: [{
                selector: "app-generic-dropdown-filter",
                templateUrl: "./generic-dropdown-filter.component.html",
                styleUrls: ["./generic-dropdown-filter.component.scss"],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { placeholder: [{
            type: Input
        }], arrayObj: [{
            type: Input
        }], onDropdownSelect: [{
            type: Output
        }] }); })();

const _c0$B = function (a0) { return { "showError": a0 }; };
function GenericDropdownSearchComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function GenericDropdownSearchComponent_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.expandDropdown(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$B, ctx_r0.isError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedItem.name, " ");
} }
const _c1$g = function (a0, a1) { return { "placeHolderColor": a0, "showError": a1 }; };
function GenericDropdownSearchComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function GenericDropdownSearchComponent_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.expandDropdown(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c1$g, ctx_r1.placeHolder !== "Select", ctx_r1.isError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.placeHolder, " ");
} }
function GenericDropdownSearchComponent_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function GenericDropdownSearchComponent_div_3_div_3_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r12); const item_r10 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.selectItem(item_r10); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r10.name, " ");
} }
function GenericDropdownSearchComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "input", 7);
    i0.ɵɵlistener("keyup", function GenericDropdownSearchComponent_div_3_Template_input_keyup_2_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onSearch($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenericDropdownSearchComponent_div_3_div_3_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.filteredListItems);
} }
function GenericDropdownSearchComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵtext(2, "List Unavailable");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericDropdownSearchComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("click", function GenericDropdownSearchComponent_div_5_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.expandDropdown(); });
    i0.ɵɵelementEnd();
} }
const _c2$c = function (a0) { return { "dropdownExpand": a0 }; };
class GenericDropdownSearchComponent {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() {
        this.filteredListItems = [];
        this.atDropdownSelect = new EventEmitter();
        this.atDropdownExpand = new EventEmitter();
        this.dropdownExpand = false;
        this.expandDropdown = () => {
            this.dropdownExpand = !this.dropdownExpand;
            if (this.dropdownExpand) {
                this.atDropdownExpand.emit(true);
            }
        };
        this.selectItem = (selectedItem) => {
            this.selectedItem = selectedItem;
            this.atDropdownSelect.emit(selectedItem);
            this.expandDropdown();
        };
        this.onSearch = (event) => {
            let input = event.target.value;
            input = input.toLowerCase();
            if (input.length === 0) {
                this.filteredListItems = [...this.listItems];
            }
            else {
                this.filteredListItems = this.listItems.filter((e) => {
                    return e[this.propForSearch] && e[this.propForSearch].toLowerCase().includes(input);
                });
            }
        };
    }
    set setListItems(items) {
        this.listItems = items;
        this.filteredListItems = items;
    }
    ngOnInit() {
        this.placeHolder = this.placeHolder ? this.placeHolder : "Select";
        if (this.isError == undefined) {
            this.isError = false;
        }
    }
}
GenericDropdownSearchComponent.ɵfac = function GenericDropdownSearchComponent_Factory(t) { return new (t || GenericDropdownSearchComponent)(); };
GenericDropdownSearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GenericDropdownSearchComponent, selectors: [["lib-generic-dropdown-search"]], inputs: { selectedItem: "selectedItem", placeHolder: "placeHolder", propForSearch: "propForSearch", setListItems: "setListItems", isError: "isError" }, outputs: { atDropdownSelect: "atDropdownSelect", atDropdownExpand: "atDropdownExpand" }, decls: 6, vars: 8, consts: [[1, "genericDropdownContainer", 3, "ngClass"], ["class", "selectedDropdown", 3, "ngClass", "click", 4, "ngIf"], ["class", "genericDropdownList", 4, "ngIf"], ["class", "dropdownFilterOverlay", 3, "click", 4, "ngIf"], [1, "selectedDropdown", 3, "ngClass", "click"], [1, "genericDropdownList"], [1, "searchBox"], ["type", "text", "placeholder", "Search Timezone", 1, "searchInput", 3, "keyup"], ["class", "eachElement", 3, "click", 4, "ngFor", "ngForOf"], [1, "eachElement", 3, "click"], [1, "eachElement"], [1, "dropdownFilterOverlay", 3, "click"]], template: function GenericDropdownSearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, GenericDropdownSearchComponent_div_1_Template, 2, 4, "div", 1);
        i0.ɵɵtemplate(2, GenericDropdownSearchComponent_div_2_Template, 2, 5, "div", 1);
        i0.ɵɵtemplate(3, GenericDropdownSearchComponent_div_3_Template, 4, 1, "div", 2);
        i0.ɵɵtemplate(4, GenericDropdownSearchComponent_div_4_Template, 3, 0, "div", 2);
        i0.ɵɵtemplate(5, GenericDropdownSearchComponent_div_5_Template, 1, 0, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c2$c, ctx.dropdownExpand));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listItems && ctx.listItems.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.listItems === undefined || ctx.listItems.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownExpand);
    } }, directives: [i1$2.NgClass, i1$2.NgIf, i1$2.NgForOf], styles: [".genericDropdownContainer[_ngcontent-%COMP%]{width:200px;display:block;margin:10px 0;position:relative}.genericDropdownContainer[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{width:12px;height:12px;color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;top:6px;right:4px;padding:4px;font-size:14px;display:block;content:\"\\e905\";z-index:100}.genericDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{content:\"\\e908\"}.selectedDropdown[_ngcontent-%COMP%]{background-color:#fff;border-bottom:2px solid #dddfe2;width:100%;border-radius:0;cursor:pointer;padding:8px 24px 8px 10px;z-index:101;position:relative;color:#333439;font-family:ciscoSans;font-size:14px}.genericDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]{border-color:#049fd9}.genericDropdownList[_ngcontent-%COMP%]{display:none;width:100%;position:absolute;top:38px;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:103;border-bottom:1px solid rgba(0,0,0,.3);box-shadow:0 0 3px #0000004d}.genericDropdownContainer.dropdownExpand[_ngcontent-%COMP%]   .genericDropdownList[_ngcontent-%COMP%]{display:block;background-color:#fff;padding-top:50px;border-left:1px solid #DFDFDF}.genericDropdownContainer[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]{display:block;padding:12px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.genericDropdownContainer[_ngcontent-%COMP%]   .eachElement[_ngcontent-%COMP%]:hover{color:#666;background-color:#39393b1a}.dropdownFilterOverlay[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:100;background-color:#ffffff1a}.placeHolderColor[_ngcontent-%COMP%]{color:#898989}.showError[_ngcontent-%COMP%]{border-bottom:2px solid red!important}.searchBox[_ngcontent-%COMP%]{position:absolute;top:0;width:100%;padding:0 5px}.searchBox[_ngcontent-%COMP%]   .searchInput[_ngcontent-%COMP%]{background-color:#f7f7f7;border-radius:16.5px;padding:7px 7px 7px 10px;border:1px solid #DFDFDF;position:relative;margin:5px 0 0;font-size:12px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericDropdownSearchComponent, [{
        type: Component,
        args: [{
                selector: "lib-generic-dropdown-search",
                templateUrl: "./generic-dropdown-search.component.html",
                styleUrls: ["./generic-dropdown-search.component.css"]
            }]
    }], function () { return []; }, { selectedItem: [{
            type: Input
        }], placeHolder: [{
            type: Input
        }], propForSearch: [{
            type: Input
        }], setListItems: [{
            type: Input
        }], isError: [{
            type: Input
        }], atDropdownSelect: [{
            type: Output
        }], atDropdownExpand: [{
            type: Output
        }] }); })();

/* eslint-disable @typescript-eslint/restrict-plus-operands */
class GoogleMapForIotComponent {
    constructor(logger, dataService) {
        this.logger = logger;
        this.dataService = dataService;
        this.selectLocation = new EventEmitter();
        this.markers = [];
        this.infowindow = null;
        this.clusterInfowindow = null;
        this.mapStyle = [
            {
                featureType: "administrative.all",
                elementType: "labels.text.fill"
                // stylers: [{ color: '#A7A7A7' }]
            },
            {
                featureType: "administrative",
                elementType: "geometry.stroke",
                stylers: [{ color: "#bfcfd4" }]
            },
            {
                featureType: "landscape",
                elementType: "geometry",
                stylers: [{ visibility: "on" } /*{ 'color': '#FBFBFB' }*/]
            },
            {
                featureType: "landscape",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "transit",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "water",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "water",
                elementType: "geometry"
                //   stylers: [{ color: '#C7C7C7' }]
            },
            {
                featureType: "road",
                elementType: "labels.icon",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            /*{
            "stylers": [
                {
                    "hue": "#ff0000"
                },
                {
                    "saturation": -100
                },
                {
                    "gamma": 2.15
                },
                {
                    "lightness": 12
                }
            ]
        },*/
            {
                featureType: "road",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        visibility: "on"
                    },
                    {
                        lightness: 24
                    }
                ]
            },
            {
                featureType: "road",
                elementType: "geometry",
                stylers: [
                    {
                        lightness: 57
                    }
                ]
            }
        ];
        this.mcOptions = {
            styles: [
                {
                    url: "../assets/images/reports/m1.svg",
                    width: 52,
                    height: 52,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                },
                {
                    url: "../assets/images/reports/m2.svg",
                    width: 56,
                    height: 56,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                },
                {
                    url: "../assets/images/reports/m3.svg",
                    width: 66,
                    height: 66,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                },
                {
                    url: "../assets/images/reports/m4.svg",
                    width: 78,
                    height: 78,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                },
                {
                    url: "../assets/images/reports/m5.svg",
                    width: 90,
                    height: 90,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                }
            ]
        };
        // markerImage =  "/assets/images/iot-explorer/auto_sensor_repos.svg";
        this.markerImage = "/assets/images/iot-explorer/locator-building.svg";
        this.isgoogleEnabled = false;
        this.isFirstTime = false;
        this.onFloorClick = (floorObj) => {
            if (this.markerCluster != null)
                this.markerCluster.clearMarkers();
            if (this.infowindow != null)
                this.infowindow.close();
            if (this.clusterInfowindow != null)
                this.clusterInfowindow.close();
            this.selectLocation.emit(floorObj);
        };
    }
    ngOnInit() {
        setTimeout(() => {
            this.isFirstTimeLoading = true;
            this.map = new google.maps.Map(document.getElementById("iot_google_map"), {
                center: { lat: 12.9165413, lng: 77.62203120000004 },
                mapTypeControl: true,
                zoom: 2,
                minZoom: 2,
                maxZoom: 21,
                scrollwheel: false,
                scaleControl: true,
                rotateControl: true,
                fullscreenControl: true,
                streetViewControl: false,
                styles: this.mapStyle
            });
            this.isgoogleEnabled = true;
            // console.log("Entered into settimeout of google map oninit function :: ",this.map);
        }, 1000);
    }
    set setCoordinates(value) {
        this.isFirstTimeLoading = false;
        if (!value || !value.coordinatesData) {
            if (this.markerCluster != null)
                this.markerCluster.clearMarkers();
            return;
        }
        else if (value &&
            value.coordinatesData &&
            value.coordinatesData.length > 0) {
            this.isFirstTime = value.isFirstTime;
            this.data = value;
            var interval = setInterval(() => {
                if (this.isgoogleEnabled) {
                    this.setMapCoordinates(value.coordinatesData);
                    clearInterval(interval);
                }
            }, 1);
        }
    }
    setMapCoordinates(coordinates) {
        var that = this;
        if (this.markerCluster != null)
            this.markerCluster.clearMarkers();
        this.markers = [];
        if (this.infowindow != null)
            this.infowindow.close();
        if (this.clusterInfowindow != null)
            this.clusterInfowindow.close();
        this.infowindow = new google.maps.InfoWindow({
            content: ""
        });
        this.clusterInfowindow = new google.maps.InfoWindow({
            content: ""
        });
        let iWindow = this.infowindow;
        let ciWindow = this.clusterInfowindow;
        let lat = null;
        let lng = null;
        var bounds = new google.maps.LatLngBounds();
        let toolTipTimer = null;
        for (var i = 0; i < coordinates.length; i++) {
            let lat = coordinates[i].latitude;
            let lng = coordinates[i].longitude;
            bounds.extend(new google.maps.LatLng(lat, lng));
            var marker = new google.maps.Marker({
                position: { lat: lat, lng: lng },
                locationId: coordinates[i].locationId,
                locationName: coordinates[i].location,
                // locationPath: coordinates[i].locationPath,
                childLocations: coordinates[i].childLocations,
                count: coordinates[i].count,
                // map: this.map,
                icon: this.markerImage,
            });
            //   circle.bindTo('center', marker, 'position');
            this.markers.push(marker);
            //   let imgsrc = circle;
            //   let selectedImgsrc = circle;
            google.maps.event.addListener(marker, "mouseover", (function (marker) {
                return function () {
                };
            })(marker));
            google.maps.event.addListener(marker, "click", (function (marker) {
                return function () {
                    if (iWindow.getMap()) {
                        iWindow.close();
                    }
                    marker.setIcon(that.markerImage);
                    iWindow.setContent(that.getPopupContent(marker));
                    iWindow.open(this.map, marker);
                    $(".gm-style-iw")
                        .parent()
                        .find(" > div:first-child > div:last-child")
                        .css("background-color", "#fff");
                    $(".gm-style-iw")
                        .parent()
                        .find(" > div")
                        .find("div:nth-child(3) div div")
                        .css("background-color", "#fff");
                    $(".gm-style-iw").next().remove();
                };
            })(marker));
            google.maps.event.addListener(marker, "mouseout", (function (marker) {
                return function () {
                    setTimeout(() => {
                        /*if (iWindow.getMap()){
                            iWindow.close();
                        }*/
                    }, 1000);
                };
            })(marker));
        }
        // this.map.setCenter(new google.maps.LatLng(lat, lng));
        // this.map.panToBounds(bounds);
        this.map.fitBounds(bounds);
        this.map.setZoom(7);
        // this.setMarkerCluster(iWindow, ciWindow, that, toolTipTimer);
        let zLevel = this.dataService.getFromStorage("zoomLevel");
        let mapCenter = this.dataService.getFromStorage("mapCenter");
        this.setMarkerCluster(iWindow, ciWindow, that, toolTipTimer);
    }
    setMarkerCluster(iWindow, ciWindow, that, toolTipTimer) {
        let cToolTipTimer = null;
        this.markerCluster = new MarkerClusterer(this.map, this.markers, this.mcOptions);
        google.maps.event.addListener(this.markerCluster, "mouseover", function (mCluster) {
            cToolTipTimer = setTimeout(() => {
                ciWindow.setContent(that.getPopupContentForCluster(mCluster));
                ciWindow.setPosition(mCluster.getCenter());
                ciWindow.open(this.map);
                let top = $(".gm-style-iw").parent().css("top");
                if (top) {
                    top = top.replace("px", "");
                    $(".gm-style-iw")
                        .parent()
                        .css("top", parseInt(top) - 22 + "px");
                }
                $(".gm-style-iw")
                    .parent()
                    .find(" > div:first-child > div:last-child")
                    .css("background-color", "#000");
                $(".gm-style-iw")
                    .parent()
                    .find(" > div")
                    .find("div:nth-child(3) div div")
                    .css("background-color", "#000");
                $(".gm-style-iw").next().remove();
            }, 1000);
        });
        google.maps.event.addListener(this.markerCluster, "mouseout", function (mCluster) {
            ciWindow.close();
            if (cToolTipTimer)
                clearTimeout(cToolTipTimer);
        });
        google.maps.event.addListener(this.map, "zoom_changed", function () {
            // var zoomLevel = this.map.getZoom();
            let zoomLevel = that.map.getZoom();
            console.log("zoomLevel changed::: " + zoomLevel);
            that.dataService.setInStorage("zoomLevel", zoomLevel);
            iWindow.close();
            ciWindow.close();
            if (toolTipTimer)
                clearTimeout(toolTipTimer);
            if (cToolTipTimer)
                clearTimeout(cToolTipTimer);
        });
        google.maps.event.addListener(this.map, "center_changed", function () {
            let center = that.map.getCenter();
            that.dataService.setInStorage("mapCenter", JSON.stringify({ lat: center.lat(), lng: center.lng() }));
        });
    }
    getPopupContent(event) {
        let count = event.count;
        let locationString = "";
        let locationId = event.locationId;
        let locationName = event.locationName;
        let childLocations = event.childLocations;
        var that = this;
        var infoDiv = document.createElement("div");
        infoDiv.setAttribute("class", "asset-locator-map-info-window");
        let topInfo = "<div class='top'>";
        topInfo += "<div class='left-side-img'> <img class='icon' src='" + that.markerImage + "'/>";
        topInfo += "</div>";
        topInfo += "<div class='right-side-content'> <div class='loc-name bottom-common'>" +
            locationName + "</div> <div class='count-div'>" + count + " assets | " + childLocations[0].floorDetails.floorCount +
            " floors </div> <div class='address-div'>" + childLocations[0].address + "</div>";
        topInfo += "</div>";
        topInfo += "</div>";
        infoDiv.innerHTML = topInfo;
        let bottomInfo = document.createElement("div");
        bottomInfo.setAttribute("class", "bottom");
        for (var i = 0; i < childLocations[0].floorDetails.floorInfo.length; i++) {
            let floorDiv = document.createElement("div");
            floorDiv.setAttribute("class", "floor-div");
            floorDiv.innerHTML = childLocations[0].floorDetails.floorInfo[i].name;
            floorDiv.addEventListener("click", this.onFloorClick.bind(this, childLocations[0].floorDetails.floorInfo[i].locNode));
            bottomInfo.appendChild(floorDiv);
        }
        infoDiv.appendChild(bottomInfo);
        return infoDiv;
    }
}
GoogleMapForIotComponent.ɵfac = function GoogleMapForIotComponent_Factory(t) { return new (t || GoogleMapForIotComponent)(i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(DataService)); };
GoogleMapForIotComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GoogleMapForIotComponent, selectors: [["lib-google-map-for-iot"]], inputs: { reportType: "reportType", rootLocationObj: "rootLocationObj", setCoordinates: "setCoordinates" }, outputs: { selectLocation: "selectLocation" }, decls: 1, vars: 0, consts: [["id", "iot_google_map"]], template: function GoogleMapForIotComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0);
    } }, styles: ["#iot_google_map[_ngcontent-%COMP%]{height:540px}  .gm-ui-hover-effect{display:none!important}  .gm-style .gm-style-iw-c{background-color:#fff!important;width:370px!important;color:#000!important;min-height:100px!important;height:220px!important;top:290px!important;padding:0!important;overflow-y:auto}  .gm-style .gm-style-iw-t:after{background:#fff!important;top:70px!important;box-shadow:none!important}  .gm-style-iw-d .asset-locator-map-info-window{color:#dddfe2}  .gm-style-iw-d .asset-locator-map-info-window .top{padding:15px;display:flex;width:100%}  .gm-style-iw-d .asset-locator-map-info-window .left-side-img{width:10%}  .gm-style-iw-d .asset-locator-map-info-window .icon{width:20px;height:20px}  .gm-style-iw-d .asset-locator-map-info-window .right-side-content{width:85%}  .gm-style-iw-d .asset-locator-map-info-window .bottom-common{padding-bottom:5px}  .gm-style-iw-d .asset-locator-map-info-window .loc-name{font-family:\"ciscoSansLight\";font-weight:600;font-size:18px;line-height:26px;align-items:center;letter-spacing:.5px;color:#121212;background-color:#fff!important}  .gm-style-iw-d .asset-locator-map-info-window .count-div{font-family:\"ciscoSansLight\";font-weight:600;font-size:14px;line-height:20px;letter-spacing:.5px;color:#434343}  .gm-style-iw-d .asset-locator-map-info-window .address-div{font-family:\"ciscoSansLight\";font-weight:600;font-size:12px;line-height:20px;letter-spacing:.5px;color:#121212}  .gm-style-iw-d .asset-locator-map-info-window .bottom{border-top:1px solid #DFDFDF;max-height:100px;display:flex;flex-direction:row;width:100%;flex-wrap:wrap;padding:10px}  .gm-style-iw-d .asset-locator-map-info-window .floor-div{font-family:\"ciscoSansLight\";font-weight:600;font-size:12px;line-height:18px;letter-spacing:.5px;width:auto;cursor:pointer;color:#00a0d1;background:#F7F7F7;border-radius:12px;padding:5px;margin:0 5px 5px 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleMapForIotComponent, [{
        type: Component,
        args: [{
                selector: "lib-google-map-for-iot",
                templateUrl: "./google-map-for-iot.component.html",
                styleUrls: ["./google-map-for-iot.component.scss"]
            }]
    }], function () { return [{ type: LoggerService }, { type: DataService }]; }, { reportType: [{
            type: Input
        }], selectLocation: [{
            type: Output
        }], rootLocationObj: [{
            type: Input
        }], setCoordinates: [{
            type: Input
        }] }); })();

class GoogleMapNewComponent {
    constructor(logger, dataService, translate) {
        this.logger = logger;
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.markers = [];
        this.infowindow = null;
        this.clusterInfowindow = null;
        this.mapStyle = [
            {
                featureType: "administrative.all",
                elementType: "labels.text.fill",
                stylers: [{ color: "#A7A7A7" }]
            },
            {
                featureType: "administrative",
                elementType: "geometry.stroke",
                stylers: [{ color: "#bfcfd4" }]
            },
            {
                featureType: "landscape",
                elementType: "geometry",
                stylers: [{ visibility: "on" }, { color: "#FBFBFB" }]
            },
            {
                featureType: "landscape",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "transit",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "water",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [{ color: "#C7C7C7" }]
            },
            {
                featureType: "road",
                elementType: "labels.icon",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            /*{
            "stylers": [
                {
                    "hue": "#ff0000"
                },
                {
                    "saturation": -100
                },
                {
                    "gamma": 2.15
                },
                {
                    "lightness": 12
                }
            ]
        },*/
            {
                featureType: "road",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        visibility: "on"
                    },
                    {
                        lightness: 24
                    }
                ]
            },
            {
                featureType: "road",
                elementType: "geometry",
                stylers: [
                    {
                        lightness: 57
                    }
                ]
            }
        ];
        this.mcOptions = {
            styles: [
                {
                    url: "../assets/images/reports/m1.svg",
                    width: 52,
                    height: 52,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                },
                {
                    url: "../assets/images/reports/m2.svg",
                    width: 56,
                    height: 56,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                },
                {
                    url: "../assets/images/reports/m3.svg",
                    width: 66,
                    height: 66,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                },
                {
                    url: "../assets/images/reports/m4.svg",
                    width: 78,
                    height: 78,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                },
                {
                    url: "../assets/images/reports/m5.svg",
                    width: 90,
                    height: 90,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                }
            ]
        };
        this.markerImage = "../assets/images/reports/poi-pin.svg";
        this.markerSelectedImage = "../assets/images/reports/poi-pin-hover.svg";
        this.isgoogleEnabled = false;
        this.isFirstTime = false;
        this.labelKeys = [];
        this.rootLocationObj = {};
        this.getStaticText = () => {
            this.translate.get('shared-lib.google-map').subscribe((res) => {
                this.labelKeys = res;
            });
        };
    }
    ngOnInit() {
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localized string here
            this.getStaticText();
        });
        setTimeout(() => {
            this.isFirstTimeLoading = true;
            this.map = new google.maps.Map(document.getElementById('all_visitors_locations'), {
                center: { lat: 12.9165413, lng: 77.62203120000004 },
                mapTypeControl: true,
                zoom: 2,
                minZoom: 2,
                maxZoom: 21,
                scrollwheel: false,
                scaleControl: true,
                rotateControl: true,
                fullscreenControl: true,
                streetViewControl: false,
                styles: this.mapStyle
            });
            this.isgoogleEnabled = true;
            // console.log("Entered into settimeout of google map oninit function :: ",this.map);
        }, 1000);
    }
    set setCoordinates(value) {
        this.isFirstTimeLoading = false;
        if (!value || !value.coordinatesData) {
            if (this.markerCluster != null)
                this.markerCluster.clearMarkers();
            return;
        }
        else if (value &&
            value.coordinatesData &&
            value.coordinatesData.length > 0) {
            this.isFirstTime = value.isFirstTime;
            this.data = value;
            const interval = setInterval(() => {
                if (this.isgoogleEnabled) {
                    this.setMapCoordinates(value.coordinatesData);
                    clearInterval(interval);
                }
            }, 1);
        }
    }
    setMapCoordinates(coordinates) {
        const that = this;
        if (this.markerCluster != null)
            this.markerCluster.clearMarkers();
        this.markers = [];
        if (this.infowindow != null)
            this.infowindow.close();
        if (this.clusterInfowindow != null)
            this.clusterInfowindow.close();
        this.infowindow = new google.maps.InfoWindow({
            content: ""
        });
        this.clusterInfowindow = new google.maps.InfoWindow({
            content: ""
        });
        const iWindow = this.infowindow;
        const ciWindow = this.clusterInfowindow;
        const lat = null;
        const lng = null;
        const bounds = new google.maps.LatLngBounds();
        let toolTipTimer = null;
        for (let i = 0; i < coordinates.length; i++) {
            const lat = coordinates[i].latitude;
            const lng = coordinates[i].longitude;
            bounds.extend(new google.maps.LatLng(lat, lng));
            const marker = new google.maps.Marker({
                position: { lat: lat, lng: lng },
                locationId: coordinates[i].locationId,
                locationName: coordinates[i].location,
                locationPath: coordinates[i].locationPath,
                total: 0,
                count: coordinates[i].count,
                visitors: coordinates[i].visitorsCount,
                visits: coordinates[i].visitsCount,
                // map: this.map,
                icon: this.markerImage
            });
            this.markers.push(marker);
            const imgsrc = this.markerImage;
            const selectedImgsrc = this.markerSelectedImage;
            google.maps.event.addListener(marker, "mouseover", (function (marker) {
                return function () {
                    marker.setIcon(selectedImgsrc);
                    toolTipTimer = setTimeout(() => {
                        iWindow.setContent(that.getPopupContent(marker));
                        iWindow.open(this.map, marker);
                        $(".gm-style-iw")
                            .parent()
                            .find(" > div:first-child > div:last-child")
                            .css("background-color", "#000");
                        $(".gm-style-iw")
                            .parent()
                            .find(" > div")
                            .find("div:nth-child(3) div div")
                            .css("background-color", "#000");
                        $(".gm-style-iw").next().remove();
                    }, 1000);
                };
            })(marker));
            google.maps.event.addListener(marker, "click", (function (marker) {
                return function () {
                    return __awaiter(this, void 0, void 0, function* () {
                        console.log("google map click enabled for the report ", that.reportType);
                        if (that.reportType == "REALTIME_REPORTS" ||
                            that.reportType == "REALTIME_REPORTS_CAMERA") {
                            let data = yield that.dataService.getLocationObject(marker.locationId);
                            if (data) {
                                let rightNowObj = JSON.parse(sessionStorage.getItem("rightNowObj"));
                                if (data.type == "network" ||
                                    data.type == "root") {
                                    // delete rightNowObj['realtimeLocation'];
                                    rightNowObj["rightNowObj"] = {
                                        id: data.id,
                                        name: data.name,
                                        type: data.type == "root"
                                            ? "all"
                                            : data.type,
                                        path: data["path"],
                                        locationType: data["type"]
                                    };
                                }
                                else if (that.rootLocationObj &&
                                    Object.keys(that.rootLocationObj).length > 0) {
                                    // rightNowObj['realtimeLocation'] = {id: data.id};
                                    rightNowObj["rightNowObj"] = {
                                        id: that.rootLocationObj["id"],
                                        name: that.rootLocationObj["name"],
                                        type: "all",
                                        path: that.rootLocationObj["path"],
                                        locationType: that.rootLocationObj["type"]
                                    };
                                }
                                that.dataService.setSpacesObject(rightNowObj);
                            }
                        }
                    });
                };
            })(marker));
            google.maps.event.addListener(marker, "mouseout", (function (marker) {
                return function () {
                    marker.setIcon(imgsrc);
                    iWindow.close();
                    if (toolTipTimer)
                        clearTimeout(toolTipTimer);
                };
            })(marker));
        }
        // this.map.setCenter(new google.maps.LatLng(lat, lng));
        // this.map.panToBounds(bounds);
        // this.setMarkerCluster(iWindow, ciWindow, that, toolTipTimer);
        const zLevel = this.dataService.getFromStorage("zoomLevel");
        const mapCenter = this.dataService.getFromStorage("mapCenter");
        this.map.zoom = zLevel ? parseInt(zLevel) : 2;
        if (mapCenter)
            this.map.setCenter(JSON.parse(mapCenter));
        setTimeout(() => {
            // console.log("Before Bounds ::: ", this.map.getBounds(), "Center :::: Lat ::",this.map.getCenter().lat(), " Lon :: ",this.map.getCenter().lng())
            this.map.maxZoom = 15;
            if (this.isFirstTime ||
                this.isFirstTimeLoading ||
                this.dataService.isPageRefresh) {
                //this.map.fitBounds(bounds);
                this.map.zoom = 2;
                this.map.setCenter(new google.maps.LatLng(lat, lng));
                //this.map.setCenter(bounds.getCenter());
                //bounds.extend(new google.maps.LatLng(lat, lng));
            }
            // console.log("After Bounds ::: ", this.map.getBounds(), "Center :::: Lat ::",this.map.getCenter().lat(), " Lon :: ",this.map.getCenter().lng())
            setTimeout(() => {
                this.map.maxZoom = 21;
            }, 100);
        }, 1500);
        // console.log(this.markers);
        this.setMarkerCluster(iWindow, ciWindow, that, toolTipTimer);
    }
    ;
    setMarkerCluster(iWindow, ciWindow, that, toolTipTimer) {
        let cToolTipTimer = null;
        this.markerCluster = new MarkerClusterer(this.map, this.markers, this.mcOptions);
        google.maps.event.addListener(this.markerCluster, "mouseover", function (mCluster) {
            cToolTipTimer = setTimeout(() => {
                ciWindow.setContent(that.getPopupContentForCluster(mCluster));
                ciWindow.setPosition(mCluster.getCenter());
                ciWindow.open(this.map);
                let top = $(".gm-style-iw").parent().css("top");
                if (top) {
                    top = top.replace("px", "");
                    $(".gm-style-iw")
                        .parent()
                        .css("top", String(parseInt(top) - 22) + "px");
                }
                $(".gm-style-iw")
                    .parent()
                    .find(" > div:first-child > div:last-child")
                    .css("background-color", "#000");
                $(".gm-style-iw")
                    .parent()
                    .find(" > div")
                    .find("div:nth-child(3) div div")
                    .css("background-color", "#000");
                $(".gm-style-iw").next().remove();
            }, 1000);
        });
        google.maps.event.addListener(this.markerCluster, "mouseout", function (mCluster) {
            ciWindow.close();
            if (cToolTipTimer)
                clearTimeout(cToolTipTimer);
        });
        google.maps.event.addListener(this.map, "zoom_changed", function () {
            // var zoomLevel = this.map.getZoom();
            const zoomLevel = that.map.getZoom();
            console.log("zoomLevel changed::: ", zoomLevel);
            that.dataService.setInStorage("zoomLevel", zoomLevel);
            iWindow.close();
            ciWindow.close();
            if (toolTipTimer)
                clearTimeout(toolTipTimer);
            if (cToolTipTimer)
                clearTimeout(cToolTipTimer);
        });
        google.maps.event.addListener(this.map, "center_changed", function () {
            const center = that.map.getCenter();
            that.dataService.setInStorage("mapCenter", JSON.stringify({ lat: center.lat(), lng: center.lng() }));
        });
    }
    ;
    getPopupContent(event) {
        const count = event.count;
        const locPath = event.locationPath;
        let locationString = "";
        const locationId = event.locationId;
        const locationName = event.locationName;
        const visitorsCount = event.visitors.toLocaleString();
        const visitsCount = event.visits.toLocaleString();
        if (locPath) {
            for (let j = 0; j < locPath.length; j++) {
                if (j != locPath.length - 1)
                    locationString +=
                        "<span class='popup_location_path'>" +
                            String(locPath[j]) +
                            "</span>";
                if (j < locPath.length - 2)
                    locationString +=
                        "<span class='popup_location_path'>></span>";
            }
        }
        let totalCount = event.total;
        if (this.reportType === "REALTIME_REPORTS" ||
            this.reportType === "REALTIME_REPORTS_CAMERA") {
            totalCount = count.total;
        }
        else if (this.reportType == "VISITOR_BEHAVIOUR") {
            totalCount = count.visitors;
        }
        let info = "<div id='loc-map-info-window'>";
        info += "<div style='width:220px;'>";
        info += "<div class='popup_details'>";
        // info += "<div class='popup_data numberBoldFont'>" + totalCount + "</div>";
        info += "<div class='popup_desc'>";
        info +=
            "<div class='popup_location_name wordBoldFont'>" +
                String(locationName) +
                "</div>";
        info += "<div class='popup_location_path_details'>";
        info += locationString;
        info += "</div></div>";
        info += "<div class='clear'></div>";
        info += "</div>";
        if (this.reportType == "REALTIME_REPORTS") {
            info += "<div class='popup_visitors_details'>";
            info +=
                "<div class='popup_visitors_seperate'><span class='popup_new_visitors_text'>" + this.labelKeys.tootlipLabel.currentVisitors + "</span><span class='popup_new_visitors_text numberBoldFont right'>";
            info += count.firstTime.toLocaleString();
            info += "</span></div>";
            // info += "<div class='popup_visitors_seperate'><span class='popup_new_visitors_text'>Total Visitors :</span><span class='popup_new_visitors_text numberBoldFont right'>";
            // info += count.total.toLocaleString();
            // info += "</span></div>";
            info += "<div class='clear'></div>";
            info += "</div>";
        }
        else if (this.reportType == "REALTIME_REPORTS_CAMERA") {
            info += "<div class='popup_visitors_details'>";
            // info += "<div class='popup_visitors_seperate'><span class='popup_new_visitors_text'>Active Visitors :</span><span class='popup_new_visitors_text numberBoldFont right'>";
            // info += count.firstTime.toLocaleString();
            info += "</span></div>";
            info +=
                "<div class='popup_visitors_seperate'><span class='popup_new_visitors_text'>" + this.labelKeys.tootlipLabel.noOfPeople + "</span><span class='popup_new_visitors_text numberBoldFont right'>";
            info += count.total.toLocaleString();
            info += "</span></div>";
            info += "<div class='clear'></div>";
            info += "</div>";
        }
        else if (this.reportType == "VISITOR_BEHAVIOUR") {
            info += "<div class='popup_visitors_details'>";
            info +=
                "<div class='left popup_visitors_seperate'><span class='popup_new_visitors_text'>" + this.labelKeys.tootlipLabel.visitors + "</span><span class='popup_new_visitors_text numberBoldFont'>";
            info += count.visitors.toLocaleString();
            info += "</span></div>";
            info += "<div class='left popup_separator'></div>";
            info +=
                "<div class='right popup_visitors_seperate'><span class='popup_new_visitors_text'>" + this.labelKeys.tootlipLabel.visits + "</span><span class='popup_new_visitors_text numberBoldFont'>";
            info += count.visits.toLocaleString();
            info += "</span></div>";
            info += "<div class='clear'></div>";
            info += "</div>";
        }
        info += "</div></div>";
        return info;
    }
    getPopupContentForCluster(cluster) {
        let totalCount = 0;
        let visitorsCount = 0;
        let visitsCount = 0;
        const markers = cluster.getMarkers();
        for (let i = 0; i < markers.length; i++) {
            totalCount += markers[i].total;
            if (this.reportType == "REALTIME_REPORTS") {
                visitorsCount += markers[i].count.firstTime;
                visitsCount += markers[i].count.total;
            }
            else if (this.reportType == "REALTIME_REPORTS_CAMERA") {
                visitorsCount += markers[i].count.firstTime;
                visitsCount += markers[i].count.total;
            }
            else if (this.reportType == "VISITOR_BEHAVIOUR") {
                visitorsCount += markers[i].count.visitors;
                visitsCount += markers[i].count.visits;
            }
            else {
                visitorsCount += markers[i].visitors;
                visitsCount += markers[i].visits;
            }
        }
        let info = "<div id='loc-map-info-window'>";
        info += "<div style='width:220px;'>";
        info += "<div class='popup_details'>";
        info += "<div class='popup_data' style='float:none;'>";
        // info += "<span class='map_cluser_number numberBoldFont'>"+totalCount+"</span>";
        // info += "<span class='map_cluster_header_text'> users in </span>"
        info +=
            "<span class='map_cluser_number numberBoldFont'>" +
                String(markers.length) +
                "</span>";
        info += "<span class='map_cluster_header_text'>" + this.labelKeys.tootlipLabel.locations + "</span>";
        /*info += "<div class='popup_desc'>users in";
    info += "<span class='numberBoldFont'>&nbsp;15&nbsp;</span>";
    info += "locations</div>"
    info += "<div class='clear'></div>";*/
        info += "</div></div>";
        if (this.reportType == "REALTIME_REPORTS") {
            info += "<div class='popup_visitors_details'>";
            info +=
                "<div class='popup_visitors_seperate'><span class='popup_new_visitors_text'>" + this.labelKeys.tootlipLabel.currentVisitors + "</span><span class='popup_new_visitors_data numberBoldFont right'>";
            info += visitorsCount.toLocaleString();
            info += "</span></div>";
            // info += "<div class='popup_visitors_seperate'><span class='popup_new_visitors_text'>Total Visitors :</span><span class='popup_new_visitors_data numberBoldFont right'>";
            // info += visitsCount.toLocaleString();
            // info += "</span></div>";
            info += "<div class='clear'></div>";
            info += "</div>";
        }
        else if (this.reportType == "REALTIME_REPORTS_CAMERA") {
            info += "<div class='popup_visitors_details'>";
            // info += "<div class='popup_visitors_seperate'><span class='popup_new_visitors_text'>Active Visitors :</span><span class='popup_new_visitors_data numberBoldFont right'>";
            // info += visitorsCount.toLocaleString();
            info += "</span></div>";
            info +=
                "<div class='popup_visitors_seperate'><span class='popup_new_visitors_text'>" + this.labelKeys.tootlipLabel.noOfPeople + "</span><span class='popup_new_visitors_data numberBoldFont right'>";
            info += visitsCount.toLocaleString();
            info += "</span></div>";
            info += "<div class='clear'></div>";
            info += "</div>";
        }
        else if (this.reportType == "VISITOR_BEHAVIOUR") {
            info += "<div class='popup_visitors_details'>";
            info +=
                "<div class='popup_visitors_seperate'><span class='popup_new_visitors_text'>" + this.labelKeys.tootlipLabel.visitors + "</span><span class='popup_new_visitors_data numberBoldFont'>";
            info += visitorsCount.toLocaleString();
            info += "</span></div>";
            info += "<div class=popup_separator'></div>";
            info +=
                "<div class='right popup_visitors_seperate'><span class='popup_new_visitors_text'>" + this.labelKeys.tootlipLabel.visits + "</span><span class='popup_new_visitors_data numberBoldFont'>";
            info += visitsCount.toLocaleString();
            info += "</span></div>";
            info += "<div class='clear'></div>";
            info += "</div>";
        }
        info += "</div></div>";
        return info;
    }
}
GoogleMapNewComponent.ɵfac = function GoogleMapNewComponent_Factory(t) { return new (t || GoogleMapNewComponent)(i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
GoogleMapNewComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GoogleMapNewComponent, selectors: [["lib-google-map-new"]], inputs: { reportType: "reportType", rootLocationObj: "rootLocationObj", setCoordinates: "setCoordinates" }, decls: 1, vars: 0, consts: [["id", "all_visitors_locations"]], template: function GoogleMapNewComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0);
    } }, styles: ["#all_visitors_locations[_ngcontent-%COMP%]{height:400px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleMapNewComponent, [{
        type: Component,
        args: [{
                selector: "lib-google-map-new",
                templateUrl: "./google-map-new.component.html",
                styleUrls: ["./google-map-new.component.css"]
            }]
    }], function () { return [{ type: LoggerService }, { type: DataService }, { type: i2.TranslateService }]; }, { reportType: [{
            type: Input
        }], rootLocationObj: [{
            type: Input
        }], setCoordinates: [{
            type: Input
        }] }); })();

class GoogleMapComponent {
    constructor(logger, dataService) {
        this.logger = logger;
        this.dataService = dataService;
        this.markers = [];
        this.infowindow = null;
        this.clusterInfowindow = null;
        this.mapStyle = [
            {
                featureType: 'administrative.all',
                elementType: 'labels.text.fill',
                // stylers: [{ color: '#A7A7A7' }]
            },
            {
                featureType: 'administrative',
                elementType: 'geometry.stroke',
                stylers: [{ color: '#bfcfd4' }]
            },
            {
                'featureType': 'landscape',
                'elementType': 'geometry',
                'stylers': [{ 'visibility': 'on' }, /*{ 'color': '#FBFBFB' }*/]
            },
            {
                "featureType": "landscape",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                featureType: 'water',
                elementType: 'geometry',
                //   stylers: [{ color: '#C7C7C7' }]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            /*{
                "stylers": [
                    {
                        "hue": "#ff0000"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "gamma": 2.15
                    },
                    {
                        "lightness": 12
                    }
                ]
            },*/
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "lightness": 24
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "lightness": 57
                    }
                ]
            }
        ];
        this.mcOptions = {
            styles: [
                {
                    url: "../assets/images/reports/m1.svg",
                    width: 52,
                    height: 52,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                },
                {
                    url: "../assets/images/reports/m2.svg",
                    width: 56,
                    height: 56,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                },
                {
                    url: "../assets/images/reports/m3.svg",
                    width: 66,
                    height: 66,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                },
                {
                    url: "../assets/images/reports/m4.svg",
                    width: 78,
                    height: 78,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                },
                {
                    url: "../assets/images/reports/m5.svg",
                    width: 90,
                    height: 90,
                    fontFamily: "ciscoSansBold",
                    fontWeight: "normal",
                    textSize: 14,
                    textColor: "#ffffff"
                }
            ]
        };
        this.markerImage = '../assets/images/reports/poi-pin.svg';
        this.markerSelectedImage = '../assets/images/reports/poi-pin-hover.svg';
        this.isgoogleEnabled = false;
        this.isFirstTime = false;
    }
    ngOnInit() {
        setTimeout(() => {
            this.isFirstTimeLoading = true;
            this.map = new google.maps.Map(document.getElementById('all_visitors_locations'), {
                center: { lat: 12.9165413, lng: 77.62203120000004 },
                mapTypeControl: true,
                zoom: 2,
                minZoom: 2,
                maxZoom: 21,
                scrollwheel: false,
                scaleControl: true,
                rotateControl: true,
                fullscreenControl: true,
                streetViewControl: false,
                styles: this.mapStyle
            });
            this.isgoogleEnabled = true;
            // console.log("Entered into settimeout of google map oninit function :: ",this.map);
        }, 1000);
    }
    set setCoordinates(value) {
        this.isFirstTimeLoading = false;
        if (!value || !value.coordinatesData) {
            if (this.markerCluster != null)
                this.markerCluster.clearMarkers();
            return;
        }
        else if (value && value.coordinatesData && value.coordinatesData.length > 0) {
            this.isFirstTime = value.isFirstTime;
            this.data = value;
            var interval = setInterval(() => {
                if (this.isgoogleEnabled) {
                    this.setMapCoordinates(value.coordinatesData);
                    clearInterval(interval);
                }
            }, 1);
        }
    }
    setMapCoordinates(coordinates) {
        var that = this;
        if (this.markerCluster != null)
            this.markerCluster.clearMarkers();
        this.markers = [];
        if (this.infowindow != null)
            this.infowindow.close();
        if (this.clusterInfowindow != null)
            this.clusterInfowindow.close();
        this.infowindow = new google.maps.InfoWindow({
            content: ""
        });
        this.clusterInfowindow = new google.maps.InfoWindow({
            content: ""
        });
        let iWindow = this.infowindow;
        let ciWindow = this.clusterInfowindow;
        let lat = null;
        let lng = null;
        var bounds = new google.maps.LatLngBounds();
        let toolTipTimer = null;
        for (var i = 0; i < coordinates.length; i++) {
            let lat = coordinates[i].latitude;
            let lng = coordinates[i].longitude;
            bounds.extend(new google.maps.LatLng(lat, lng));
            var marker = new google.maps.Marker({
                position: { lat: lat, lng: lng },
                locationId: coordinates[i].locationId,
                locationName: coordinates[i].location,
                // locationPath: coordinates[i].locationPath,
                childLocations: coordinates[i].childLocations,
                count: coordinates[i].count,
                // map: this.map,
                //  icon: this.markerImage,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 15,
                    fillColor: "#6C84E6",
                    fillOpacity: 1,
                    strokeColor: "#2A4BD5",
                    strokeWeight: 1,
                },
                label: {
                    text: coordinates[i].childLocations.length.toLocaleString(),
                    color: '#fff',
                },
            });
            //   circle.bindTo('center', marker, 'position');
            this.markers.push(marker);
            //   let imgsrc = circle;
            //   let selectedImgsrc = circle;
            google.maps.event.addListener(marker, 'mouseover', (function (marker) {
                return function () {
                    marker.setIcon({
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 15,
                        fillColor: "#6C84E6",
                        fillOpacity: 1,
                        strokeWeight: 1,
                        strokeColor: '#2A4BD5'
                    });
                    toolTipTimer = setTimeout(() => {
                        iWindow.setContent(that.getPopupContent(marker));
                        iWindow.open(this.map, marker);
                        $('.gm-style-iw').parent().find(' > div:first-child > div:last-child').css('background-color', '#fff');
                        $('.gm-style-iw').parent().find(' > div').find('div:nth-child(3) div div').css('background-color', '#fff');
                        $('.gm-style-iw').next().remove();
                    }, 1000);
                };
            })(marker));
            google.maps.event.addListener(marker, 'click', (function (marker) {
                return function () {
                    return __awaiter(this, void 0, void 0, function* () {
                        console.log("google map click enabled for the report ", that.reportType);
                    });
                };
            })(marker));
            google.maps.event.addListener(marker, 'mouseout', (function (marker) {
                return function () {
                    marker.setIcon({
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 15,
                        fillColor: "#6C84E6",
                        fillOpacity: 1,
                        strokeWeight: 1,
                        strokeColor: '#2A4BD5'
                    });
                    iWindow.close();
                    if (toolTipTimer)
                        clearTimeout(toolTipTimer);
                };
            })(marker));
        }
        // this.map.setCenter(new google.maps.LatLng(lat, lng));
        // this.map.panToBounds(bounds);
        // this.setMarkerCluster(iWindow, ciWindow, that, toolTipTimer);
        let zLevel = this.dataService.getFromStorage("zoomLevel");
        let mapCenter = this.dataService.getFromStorage("mapCenter");
        this.map.zoom = zLevel ? parseInt(zLevel) : 2;
        if (mapCenter)
            this.map.setCenter(JSON.parse(mapCenter));
        setTimeout(() => {
            // console.log("Before Bounds ::: ", this.map.getBounds(), "Center :::: Lat ::",this.map.getCenter().lat(), " Lon :: ",this.map.getCenter().lng())
            this.map.maxZoom = 15;
            if (this.isFirstTime || this.isFirstTimeLoading || this.dataService.isPageRefresh) {
                //this.map.fitBounds(bounds);
                this.map.zoom = 2;
                this.map.setCenter(new google.maps.LatLng(lat, lng));
                //this.map.setCenter(bounds.getCenter());
                //bounds.extend(new google.maps.LatLng(lat, lng));
            }
            // console.log("After Bounds ::: ", this.map.getBounds(), "Center :::: Lat ::",this.map.getCenter().lat(), " Lon :: ",this.map.getCenter().lng())
            setTimeout(() => {
                this.map.maxZoom = 21;
            }, 100);
        }, 1500);
        // console.log(this.markers);
        this.setMarkerCluster(iWindow, ciWindow, that, toolTipTimer);
    }
    setMarkerCluster(iWindow, ciWindow, that, toolTipTimer) {
        let cToolTipTimer = null;
        this.markerCluster = new MarkerClusterer(this.map, this.markers, this.mcOptions);
        google.maps.event.addListener(this.markerCluster, "mouseover", function (mCluster) {
            cToolTipTimer = setTimeout(() => {
                ciWindow.setContent(that.getPopupContentForCluster(mCluster));
                ciWindow.setPosition(mCluster.getCenter());
                ciWindow.open(this.map);
                let top = $('.gm-style-iw').parent().css('top');
                if (top) {
                    top = top.replace("px", "");
                    $('.gm-style-iw').parent().css('top', (parseInt(top) - 22) + "px");
                }
                $('.gm-style-iw').parent().find(' > div:first-child > div:last-child').css('background-color', '#000');
                $('.gm-style-iw').parent().find(' > div').find('div:nth-child(3) div div').css('background-color', '#000');
                $('.gm-style-iw').next().remove();
            }, 1000);
        });
        google.maps.event.addListener(this.markerCluster, "mouseout", function (mCluster) {
            ciWindow.close();
            if (cToolTipTimer)
                clearTimeout(cToolTipTimer);
        });
        google.maps.event.addListener(this.map, 'zoom_changed', function () {
            // var zoomLevel = this.map.getZoom();
            let zoomLevel = that.map.getZoom();
            console.log("zoomLevel changed::: " + zoomLevel);
            that.dataService.setInStorage("zoomLevel", zoomLevel);
            iWindow.close();
            ciWindow.close();
            if (toolTipTimer)
                clearTimeout(toolTipTimer);
            if (cToolTipTimer)
                clearTimeout(cToolTipTimer);
        });
        google.maps.event.addListener(this.map, 'center_changed', function () {
            let center = that.map.getCenter();
            that.dataService.setInStorage("mapCenter", JSON.stringify({ lat: center.lat(), lng: center.lng() }));
        });
    }
    getPopupContent(event) {
        let count = event.count;
        // let locPath = event.locationPath;
        let locationString = "";
        let locationId = event.locationId;
        let locationName = event.locationName;
        let childLocations = event.childLocations;
        var info = "<div id='loc-map-info-window'>";
        info += "<div style='width:220px;'>";
        info += "<div class='popup_details'>";
        // info += "<div class='popup_data numberBoldFont'>" + totalCount + "</div>";
        info += "<div class='popup_desc'>";
        for (var i = 0; i < childLocations.length; i++) {
            info += "<div class='popup_location_name wordBoldFont'> <span style='float:left'>" + childLocations[i].location + "</span>" + "<span style='float:right'> (" + childLocations[i].count + ") </span>" + "</div>";
        }
        info += "</div>";
        info += "<div class='clear'></div>";
        info += "</div>";
        info += "</div></div>";
        return info;
    }
}
GoogleMapComponent.ɵfac = function GoogleMapComponent_Factory(t) { return new (t || GoogleMapComponent)(i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(DataService)); };
GoogleMapComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GoogleMapComponent, selectors: [["google-map"]], inputs: { reportType: "reportType", rootLocationObj: "rootLocationObj", setCoordinates: "setCoordinates" }, decls: 1, vars: 0, consts: [["id", "all_visitors_locations"]], template: function GoogleMapComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0);
    } }, styles: ["#all_visitors_locations[_ngcontent-%COMP%]{height:540px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleMapComponent, [{
        type: Component,
        args: [{
                selector: 'google-map',
                templateUrl: './google-map.component.html',
                styleUrls: ['./google-map.component.css']
            }]
    }], function () { return [{ type: LoggerService }, { type: DataService }]; }, { reportType: [{
            type: Input
        }], rootLocationObj: [{
            type: Input
        }], setCoordinates: [{
            type: Input
        }] }); })();

class IdleTimeoutComponent {
    constructor(locationService, dataService, authService) {
        this.locationService = locationService;
        this.dataService = dataService;
        this.authService = authService;
        this.unsubscribe$ = new Subject();
        this.properties = null;
        this.minute = 5;
        this.seconds = 0;
        this.timer = { "minute": 5, "seconds": 0 };
        this.notification = "INACTIVE:: You will be logged out in " + this.timer.minute + " mins.";
        this.timeOut = 20 * 60 * 1000 - 300000;
        this.alreadywarned = false;
        this.getProperties = () => {
            this.dataService.display(true);
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$)
                .then((properties) => {
                this.properties = properties["value"];
                this.timeOut =
                    parseInt(this.properties.sessionIdleTimeout) * 1000 -
                        300000;
                this.resetTimer();
            });
        };
        this.logout = () => {
            this.alreadywarned = false;
            // alert("You are now logged out.")
            console.log("logout due to idle timeout");
            clearTimeout(this.time);
            clearInterval(this.timerTitle);
            clearInterval(this.timerInterval);
            //clearTimeout(this.timeWarning);
            document.title = this.originalTitle;
            this.dataService.setToastMessage("Since you are idle, you are logged out.", 3000, null, null, "error");
            this.locationService.signOut();
        };
        this.startTimer = () => {
            if (this.timer.minute == 0 && this.timer.seconds == 0) {
                // console.log("start timer :: ", this.timer.minute, " : ", this.timer.seconds);
                return;
            }
            else {
                // console.log("start timer :: ", this.timer.minute, " : ", this.timer.seconds);
                this.timer.seconds = this.checkSecond(this.timer.seconds - 5);
                if (this.timer.seconds == 55) {
                    this.timer.minute = this.timer.minute - 1;
                }
                /*if(!(this.timer.minute == 0 && this.timer.seconds ==0)){
                    this.dataService.setToastMessage(
                        "Your session has become inactive. It will expire in "+ this.timer.minute +":"+ this.timer.seconds +" mins.",
                         5000,
                         null,
                         null,
                         "error"
                     );
                 }*/
            }
        };
        this.checkSecond = (sec) => {
            // console.log("checkseconds :: ", sec);
            if (sec < 10 && sec >= 0) {
                sec = "0" + sec;
            }
            ;
            if (sec < 0) {
                sec = 55;
            }
            ;
            return sec;
        };
        this.warning = () => {
            // console.log('start warning toast.');
            this.timer = { "minute": 5, "seconds": 0 };
            this.alreadywarned = true;
            this.dataService.setToastMessage("Since you are idle, your Session is going to expire in " + this.timer.minute + " : " + this.timer.seconds + " mins.", 5000, null, null, "error");
            // console.log("warning for idle timeout",this.minute , this.seconds);
            clearTimeout(this.time);
            clearInterval(this.timerTitle);
            clearInterval(this.timerInterval);
            // clearTimeout(this.timeWarning);
            this.originalTitle = document.title;
            const _that = this;
            const notify = this.notification;
            this.timerTitle = setInterval(function () {
                console.log("changing title", _that.originalTitle == document.title
                    ? notify
                    : _that.originalTitle);
                document.title =
                    _that.originalTitle == document.title
                        ? notify
                        : _that.originalTitle;
            }, 1000);
            // console.log("warning :: ", this.timer.minute , " : " ,this.timer.seconds);
            var that = this;
            this.timerInterval = setInterval(function () {
                // const sec = that.timer.seconds - 5;
                // that.timer.seconds = sec;
                that.timer.seconds = that.checkSecond(that.timer.seconds - 5);
                if (that.timer.seconds < 0 && that.timer.minute > 0) {
                    that.timer.seconds = 55;
                }
                ;
                //if (sec < 10 && sec >= 0) {that.timer.seconds = "0" + sec;};
                if (that.timer.seconds === 55) {
                    that.timer.minute = that.timer.minute - 1;
                }
                if (that.timer.minute == 0 && that.timer.seconds == 0) {
                    clearInterval(that.timerInterval);
                    console.log("start timer :: ", that.timer.minute, " : ", that.timer.seconds);
                    return 0;
                }
                else {
                    if (!(that.timer.minute == 0 && that.timer.seconds == 0)) {
                        that.dataService.setToastMessage("Since you are idle, your Session is going to expire in " + that.timer.minute + ":" + that.timer.seconds + " mins.", 5000, null, null, "error");
                    }
                    // console.log("start timer :: ", that.timer.minute , " : " ,that.timer.seconds);
                    // console.log("checkseconds :: ", that.timer.seconds);
                    //if (that.timer.second<s == 5) {that.timer.seconds = 0;}
                }
            }, 5000);
            // console.log("warning :: ", this.timer.minute , " : " ,this.timer.seconds);
            this.time = setTimeout(this.logout, 300000);
            // console.log("warning :: ", this.timer.minute , " : " ,this.timer.seconds);
        };
        this.resetTimer = () => {
            clearTimeout(this.time);
            clearInterval(this.timerTitle);
            clearInterval(this.timerInterval);
            // clearTimeout(this.timeWarning);
            document.title = this.originalTitle;
            // console.log('WARN: set time out at reset timer :',this.timeOut);
            this.time = setTimeout(this.warning, this.timeOut);
        };
    }
    ngOnInit() {
        this.getProperties();
        this.originalTitle = document.title;
        this.alreadywarned = false;
        console.log('ngOn init idle tmeout:', this.timeOut);
    }
    // @HostListener('document:keydown.escape', ['$event'])
    onMovement(e) {
        // console.log(e);
        this.resetTimer();
        document.title = this.originalTitle;
        if (this.alreadywarned) {
            this.timer = { "minute": 5, "seconds": 0 };
            this.dataService.setToastMessage("You can continue with current session.", 1000, null, null, "error");
            this.alreadywarned = false;
        }
    }
    ngOnDestroy() {
        console.log("IdleTimeout component destroyed!!!");
        clearTimeout(this.time);
        // clearTimeout(this.timeWarning);
        clearInterval(this.timerTitle);
        clearInterval(this.timerInterval);
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        // this.shutdownIntercom();
    }
}
IdleTimeoutComponent.ɵfac = function IdleTimeoutComponent_Factory(t) { return new (t || IdleTimeoutComponent)(i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(AuthService)); };
IdleTimeoutComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IdleTimeoutComponent, selectors: [["lib-idle-timeout"]], hostBindings: function IdleTimeoutComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("mousemove", function IdleTimeoutComponent_mousemove_HostBindingHandler($event) { return ctx.onMovement($event); }, false, i0.ɵɵresolveDocument)("mousedown", function IdleTimeoutComponent_mousedown_HostBindingHandler($event) { return ctx.onMovement($event); }, false, i0.ɵɵresolveDocument)("scroll", function IdleTimeoutComponent_scroll_HostBindingHandler($event) { return ctx.onMovement($event); }, false, i0.ɵɵresolveDocument)("click", function IdleTimeoutComponent_click_HostBindingHandler($event) { return ctx.onMovement($event); }, false, i0.ɵɵresolveDocument)("keypress", function IdleTimeoutComponent_keypress_HostBindingHandler($event) { return ctx.onMovement($event); }, false, i0.ɵɵresolveDocument);
    } }, decls: 0, vars: 0, template: function IdleTimeoutComponent_Template(rf, ctx) { }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IdleTimeoutComponent, [{
        type: Component,
        args: [{
                selector: "lib-idle-timeout",
                templateUrl: "./idle-timeout.component.html",
                styleUrls: ["./idle-timeout.component.scss"]
            }]
    }], function () { return [{ type: LocationService }, { type: DataService }, { type: AuthService }]; }, { 
    // @HostListener('document:keydown.escape', ['$event'])
    onMovement: [{
            type: HostListener,
            args: ["document:mousemove", ["$event"]]
        }, {
            type: HostListener,
            args: ["document:mousedown", ["$event"]]
        }, {
            type: HostListener,
            args: ["document:scroll", ["$event"]]
        }, {
            type: HostListener,
            args: ["document:click", ["$event"]]
        }, {
            type: HostListener,
            args: ["document:keypress", ["$event"]]
        }] }); })();

/* eslint-disable prefer-const */
const _c0$A = function (a0) { return { "active": a0 }; };
function IotPaginationComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function IotPaginationComponent_button_12_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const pageNum_r1 = restoredCtx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.onPage(pageNum_r1); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const pageNum_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$A, pageNum_r1 === ctx_r0.currentPage));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(pageNum_r1);
} }
const _c1$f = function (a0) { return { "disabled": a0 }; };
class IotPaginationComponent {
    constructor() {
        this.unsubscribe$ = new Subject();
        this.isFromEvents = false;
        this.clickEvent = new EventEmitter();
        this.currentPage = 1;
        this.perPage = 25;
        this.recordPerPageList = [10, 25, 50, 100];
        this.pageDetail = () => {
            let min = this.perPage * this.currentPage - this.perPage + 1;
            let max = this.totalRecords <= this.perPage * this.currentPage
                ? this.totalRecords
                : this.perPage * this.currentPage;
            return min.toString() + "-" + max.toString();
        };
        this.currentPageItems = () => {
            this.clickEvent.emit({
                showRecord: this.perPage,
                currentPage: this.currentPage
            });
        };
        this.onChangeShowRecord = ($event) => {
            this.currentPage = 1;
            this.perPage = $event;
            this.currentPageItems();
        };
    }
    set records(records) {
        this.totalItems = records;
        this.currentPage = 1;
        this.perPage = 25;
        this.currentPageItems();
    }
    set totalRecord(totalRecord) {
        this.currentPage = 1;
        this.totalRecords = totalRecord;
        this.getPages();
    }
    ngOnInit() {
        console.log("Entered Iot Pagination Component");
        if (this.isFromEvents) {
            this.recordPerPageList = [10, 25, 50, 100, 500, 1000]; // adding extra options only for IoT events page
        }
    }
    getMin() {
        return this.perPage * this.currentPage - this.perPage + 1;
    }
    totalPages() {
        return Math.ceil(this.totalRecords / this.perPage) || 0;
    }
    lastPage() {
        return this.perPage * this.currentPage >= this.totalRecords;
    }
    getMax() {
        let max = this.perPage * this.currentPage;
        max = this.totalRecords;
        return max;
    }
    getPages() {
        const totPage = Math.ceil(this.totalRecords / this.perPage);
        const curPage = this.currentPage || 1;
        const pagesToShow = this.perPage || 10;
        let startPage;
        let endPage;
        let pages = [];
        if (totPage <= 3) {
            startPage = 1;
            endPage = totPage;
        }
        else {
            if (curPage < 3) {
                startPage = 1;
                endPage =
                    curPage == totPage
                        ? totPage
                        : curPage + 1 == totPage - 1
                            ? totPage
                            : curPage + 1;
            }
            else if (curPage + 2 >= totPage) {
                startPage = curPage - 1;
                endPage = curPage + 1 <= totPage ? curPage + 1 : curPage;
            }
            else {
                startPage = curPage - 1;
                endPage = curPage + 1;
            }
        }
        pages = Array.from(Array(endPage + 1 - startPage).keys()).map((i) => startPage + i);
        pages.sort((a, b) => a - b);
        return pages;
    }
    onPage(n) {
        this.currentPage = n;
        this.currentPageItems();
    }
    onPrev() {
        if (this.currentPage !== 1) {
            this.onPage(this.currentPage - 1);
        }
    }
    onNext() {
        if (this.currentPage !== this.totalPages()) {
            this.onPage(this.currentPage + 1);
        }
    }
    ngOnDestroy() {
        console.log('destory App Component');
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
IotPaginationComponent.ɵfac = function IotPaginationComponent_Factory(t) { return new (t || IotPaginationComponent)(); };
IotPaginationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IotPaginationComponent, selectors: [["lib-iot-pagination"]], inputs: { records: "records", totalRecord: "totalRecord", isFromEvents: "isFromEvents" }, outputs: { clickEvent: "clickEvent" }, decls: 15, vars: 13, consts: [[1, "pagination-wrapper"], [1, "count-div", "commonFont"], [1, "pagination-div", "commonFont"], [1, "record-text", "commonFont"], [1, "dropdown-div"], [3, "selectedItem", "listItems", "onDropdownSelect"], [1, "commonFont", "detailsDiv"], [1, "link", 3, "disabled", "ngClass", "click"], ["class", "numericButton", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "numericButton", 3, "ngClass", "click"]], template: function IotPaginationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtext(5, "Show Records:");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "dropdown-simple", 5);
        i0.ɵɵlistener("onDropdownSelect", function IotPaginationComponent_Template_dropdown_simple_onDropdownSelect_7_listener($event) { return ctx.onChangeShowRecord($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "button", 7);
        i0.ɵɵlistener("click", function IotPaginationComponent_Template_button_click_10_listener() { return ctx.onPrev(); });
        i0.ɵɵtext(11, " < ");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, IotPaginationComponent_button_12_Template, 2, 4, "button", 8);
        i0.ɵɵelementStart(13, "button", 7);
        i0.ɵɵlistener("click", function IotPaginationComponent_Template_button_click_13_listener() { return ctx.onNext(); });
        i0.ɵɵtext(14, " > ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("", ctx.totalRecords, " Record(s)");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("selectedItem", ctx.perPage)("listItems", ctx.recordPerPageList);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.pageDetail());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.currentPage === 1)("ngClass", i0.ɵɵpureFunction1(9, _c1$f, ctx.currentPage === 1));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.getPages());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.lastPage())("ngClass", i0.ɵɵpureFunction1(11, _c1$f, ctx.lastPage()));
    } }, directives: [DropdownSimpleComponent, i1$2.NgClass, i1$2.NgForOf], styles: [".pagination-wrapper[_ngcontent-%COMP%]{background:#FFFFFF;padding:20px}.pagination-wrapper[_ngcontent-%COMP%]   .count-div[_ngcontent-%COMP%]{float:left}.pagination-wrapper[_ngcontent-%COMP%]   .pagination-div[_ngcontent-%COMP%]{float:right;display:flex;width:25%}.pagination-wrapper[_ngcontent-%COMP%]   .record-text[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:12px;line-height:18px;letter-spacing:.5px;color:#545454}.detailsDiv[_ngcontent-%COMP%]{padding:0 10px}.commonFont[_ngcontent-%COMP%]{font-family:\"ciscoSansLight\";font-weight:600;font-size:12px;line-height:18px;letter-spacing:.5px;color:#545454}.pagination-div[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{margin:2px 0;border:0;background-color:transparent;display:inline-block;height:100%;padding:0 4px 0 10px;outline:none;color:#4d4d4d;font-size:12px}.pagination-div[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]:last-child{padding-right:10px}.pagination-div[_ngcontent-%COMP%] > button.disabled[_ngcontent-%COMP%]{color:#ccc;cursor:not-allowed}.pagination-div[_ngcontent-%COMP%] > button.numericButton[_ngcontent-%COMP%]{padding:0 10px;color:#049fd9}.pagination-div[_ngcontent-%COMP%] > button.numericButton.active[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;margin:-4px 0 0;padding-top:6px;padding-bottom:6px;border-radius:50px;border:0;cursor:default}.pagination-div[_ngcontent-%COMP%] > button.numericButton.active[_ngcontent-%COMP%] + button[_ngcontent-%COMP%]{border-left:0}.dropdown-div[_ngcontent-%COMP%]{width:22%}[_nghost-%COMP%]     dropdown-simple .simpleDropdownContainer{margin:0!important}[_nghost-%COMP%]     dropdown-simple .simpleDropdownContainer .selectedDropdown{font-size:12px;border:none!important;color:#00a0d1;font-family:\"ciscoSansLight\";font-weight:600;padding:0 10px!important}[_nghost-%COMP%]     dropdown-simple .simpleDropdownContainer .selectedDropdown:before{top:-3px!important;right:15px!important;padding:3px!important;color:#00a0d1!important}[_nghost-%COMP%]     dropdown-simple .simpleDropdownList{bottom:100%;top:auto}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IotPaginationComponent, [{
        type: Component,
        args: [{
                selector: "lib-iot-pagination",
                templateUrl: "./iot-pagination.component.html",
                styleUrls: ["./iot-pagination.component.scss"]
            }]
    }], null, { records: [{
            type: Input
        }], totalRecord: [{
            type: Input
        }], isFromEvents: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }] }); })();

class IoTUsersFilterPipe {
    transform(values, filter) {
        if (!values || !values.length)
            return [];
        if (!filter)
            return values;
        return values.filter(v => v.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0 || v.email.toLowerCase().indexOf(filter.toLowerCase()) >= 0);
    }
}
IoTUsersFilterPipe.ɵfac = function IoTUsersFilterPipe_Factory(t) { return new (t || IoTUsersFilterPipe)(); };
IoTUsersFilterPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "iotUsersFilter", type: IoTUsersFilterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IoTUsersFilterPipe, [{
        type: Pipe,
        args: [{
                name: 'iotUsersFilter'
            }]
    }], null, null); })();

/* eslint-disable prefer-const */
function IotUserDropdownFilterComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 6);
    i0.ɵɵlistener("click", function IotUserDropdownFilterComponent_div_2_Template_span_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const selectItem_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.deleteSelects(selectItem_r2); });
    i0.ɵɵtext(4, "x");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selectItem_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(selectItem_r2.name);
} }
function IotUserDropdownFilterComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function IotUserDropdownFilterComponent_div_4_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r8); const item_r6 = restoredCtx.$implicit; const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.selectSuggestion(item_r6); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r5.isSelected(item_r6) ? "selected-suggestion" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r6.name);
} }
function IotUserDropdownFilterComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, IotUserDropdownFilterComponent_div_4_div_1_Template, 4, 2, "div", 8);
    i0.ɵɵpipe(2, "iotUsersFilter");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(2, 1, ctx_r1.listObj, ctx_r1.filterString));
} }
const _c0$z = function (a0) { return { "dropdownExpand": a0 }; };
class IotUserDropdownFilterComponent {
    constructor() {
        this.selectOptionEmitter = new EventEmitter();
        this.filterString = "";
        this.show = false;
        this.userSelects = [];
    }
    set selected(value) {
        if (!value) {
            return;
        }
        this.userSelects = value;
    }
    ngOnInit() {
        console.log("Iot User Dropdown Filter Component");
    }
    event(event) {
        let that = this;
        let elementClicked = event.target;
        if (jQuery(elementClicked).closest(".chips-input-container").length ===
            0 &&
            jQuery(elementClicked).attr("class") != undefined &&
            !jQuery(elementClicked).hasClass("chips-input-container") &&
            !jQuery(elementClicked).hasClass("selected-suggestion")) {
            that.show = false;
        }
    }
    suggest() {
        this.show = !this.show;
    }
    selectSuggestion(selItem) {
        this.userSelects.find((item) => item.email === selItem.email)
            ? (this.userSelects = this.userSelects.filter((item) => item.email !== selItem.email))
            : this.userSelects.push(selItem);
        this.selectOptionEmitter.emit(this.userSelects);
        this.filterString = "";
    }
    isSelected(selItem) {
        return this.userSelects.findIndex((item) => item.email === selItem.email) > -1
            ? true
            : false;
    }
    deleteSelects(selItem) {
        this.userSelects = this.userSelects.filter((item) => item.email !== selItem.email);
        this.selectOptionEmitter.emit(this.userSelects);
    }
}
IotUserDropdownFilterComponent.ɵfac = function IotUserDropdownFilterComponent_Factory(t) { return new (t || IotUserDropdownFilterComponent)(); };
IotUserDropdownFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IotUserDropdownFilterComponent, selectors: [["lib-iot-user-dropdown-filter"]], hostBindings: function IotUserDropdownFilterComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function IotUserDropdownFilterComponent_click_HostBindingHandler($event) { return ctx.event($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { listObj: "listObj", selected: "selected" }, outputs: { selectOptionEmitter: "selectOptionEmitter" }, decls: 5, vars: 6, consts: [[1, "autocomplete"], [1, "chips-input-container", 3, "ngClass", "click"], ["class", "user-chip", 4, "ngFor", "ngForOf"], ["type", "text", "name", "searchValue", "autocomplete", "off", 1, "userInput", 3, "ngModel", "ngModelChange"], ["class", "autocomplete-items", 4, "ngIf"], [1, "user-chip"], [1, "delete-icon-chip", 3, "click"], [1, "autocomplete-items"], [3, "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "click"], [1, "check-mark"]], template: function IotUserDropdownFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵlistener("click", function IotUserDropdownFilterComponent_Template_div_click_1_listener() { return ctx.suggest(); });
        i0.ɵɵtemplate(2, IotUserDropdownFilterComponent_div_2_Template, 5, 1, "div", 2);
        i0.ɵɵelementStart(3, "input", 3);
        i0.ɵɵlistener("ngModelChange", function IotUserDropdownFilterComponent_Template_input_ngModelChange_3_listener($event) { return ctx.filterString = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, IotUserDropdownFilterComponent_div_4_Template, 3, 4, "div", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$z, ctx.listObj.length > 0));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.userSelects);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.filterString);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.show && ctx.listObj.length > 0);
    } }, directives: [i1$2.NgClass, i1$2.NgForOf, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$2.NgIf], pipes: [IoTUsersFilterPipe], styles: ["@charset \"UTF-8\";.autocomplete[_ngcontent-%COMP%]{position:relative;width:100%}.chips-input-container[_ngcontent-%COMP%]{display:inline-flex;background-color:#fff;border-bottom:2px solid #dddfe2;width:100%;border-radius:0;cursor:pointer;z-index:101;position:relative;color:#333439;font-family:ciscoSans;font-size:14px;margin:10px 0;flex-direction:row;flex-wrap:wrap}.chips-input-container[_ngcontent-%COMP%]:before{width:12px;height:12px;color:#6a6b6c;font-family:icomoon-new;position:absolute;top:6px;right:4px;padding:4px;font-size:14px;display:block;z-index:100}.chips-input-container.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{content:\"\\e908\"}input[_ngcontent-%COMP%]{font-weight:600;border:none;outline:none;margin:0}input[_ngcontent-%COMP%]:hover{border:none;border-radius:0}.autocomplete-items[_ngcontent-%COMP%]{position:absolute;border:1px solid #d4d4d4;border-radius:4px;top:80%;left:0;right:50%;background:#fff;width:100%;z-index:1001;font-size:14px;cursor:pointer;background-color:#fff;font-family:\"ciscoSansLight\";font-weight:600;max-height:200px;overflow-y:auto;line-height:20px;letter-spacing:.5px;color:#00a0d1}.selected-suggestion[_ngcontent-%COMP%]{background:#fff;color:#545454}.selected-suggestion[_ngcontent-%COMP%]   .check-mark[_ngcontent-%COMP%]{position:relative;display:inline-block;right:20px;font-style:normal;font-weight:500;line-height:1;top:1;--borderWidth: 1px;--height: 12px;--width: 6px;--borderColor: #545454;float:right}.selected-suggestion[_ngcontent-%COMP%]   .check-mark[_ngcontent-%COMP%]:before{content:\"\";transform:rotate(45deg);height:var(--height);width:var(--width);border-bottom:var(--borderWidth) solid var(--borderColor);border-right:var(--borderWidth) solid var(--borderColor);display:inline-block}.autocomplete-items[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:10px;cursor:pointer;background-color:#fff;border-bottom:1px solid #d4d4d41a}.autocomplete-items[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:hover{background:#E0F1F9!important;color:#007aa3!important}.user-chip[_ngcontent-%COMP%]{background:#f7f7f7;padding:0 6px;border-radius:20px;text-align:center;color:#545454;display:flex;font-size:14px;margin:0 4px 4px 0}.user-chip[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:flex;padding:5px}.delete-icon-chip[_ngcontent-%COMP%]{color:#545454;opacity:.7;cursor:pointer;display:flex;position:relative;right:0px;font-size:14px;padding:5px;font-weight:normal}.delete-icon-chip[_ngcontent-%COMP%]:hover{opacity:1}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IotUserDropdownFilterComponent, [{
        type: Component,
        args: [{
                selector: "lib-iot-user-dropdown-filter",
                templateUrl: "./iot-user-dropdown-filter.component.html",
                styleUrls: ["./iot-user-dropdown-filter.component.scss"]
            }]
    }], function () { return []; }, { listObj: [{
            type: Input
        }], selected: [{
            type: Input
        }], selectOptionEmitter: [{
            type: Output
        }], event: [{
            type: HostListener,
            args: ["window:click", ["$event"]]
        }] }); })();

class LicenseAdoptionComponent {
    constructor() {
        this.onCloseLicenseAdoptionPopup = new EventEmitter();
        this.modalPopupClose = () => {
            this.onCloseLicenseAdoptionPopup.emit();
        };
    }
    ngOnInit() {
        // only for right now for testing
        if (!this.licenseObj) {
            this.licenseObj = {
                title: "Density Rule",
                description: "Density Rule allows users to set limits beyond which a trigger is activated. A feature that is becoming increasingly important in the post Covid world. Learn more about Right Now app and it features"
            };
        }
    }
}
LicenseAdoptionComponent.ɵfac = function LicenseAdoptionComponent_Factory(t) { return new (t || LicenseAdoptionComponent)(); };
LicenseAdoptionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LicenseAdoptionComponent, selectors: [["app-license-adoption"]], inputs: { licenseObj: "licenseObj" }, outputs: { onCloseLicenseAdoptionPopup: "onCloseLicenseAdoptionPopup" }, decls: 35, vars: 2, consts: [[1, "modalPopup"], [1, "modalOverlay"], [1, "modalContent"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], [1, "divTable"], [1, "divTableRow"], [1, "divTableCell", "width10"], ["src", "/assets/images/TileRedesign/right_now.svg", "alt", "Tile Info - Right Now"], [1, "divTableCell", "width60"], [1, "paddingTB10"], [1, "title"], [1, "subTitle"], [1, "actLabel"], [1, "descClickHere"], ["src", "/assets/images/profile_openroaming/new_window_16.svg", 1, "img-link"], [1, "divTableCell", "width30"], ["src", "/assets/images/profile_openroaming/upsell_light.svg"], [1, "modalFooter"], [1, "modalSecondaryButton"], [1, "primaryButton"]], template: function LicenseAdoptionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵlistener("click", function LicenseAdoptionComponent_Template_span_click_4_listener() { return ctx.modalPopupClose(); });
        i0.ɵɵtext(5, "\uE909");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵelement(10, "img", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 10);
        i0.ɵɵelementStart(12, "div", 11);
        i0.ɵɵelementStart(13, "span", 12);
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "span", 13);
        i0.ɵɵtext(16, "This feature is availeble in ");
        i0.ɵɵelementStart(17, "span", 14);
        i0.ɵɵtext(18, "ACT");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(19, " license only");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div");
        i0.ɵɵelementStart(21, "span");
        i0.ɵɵtext(22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "span", 15);
        i0.ɵɵtext(24, "Click Here ");
        i0.ɵɵelement(25, "img", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 17);
        i0.ɵɵelement(27, "img", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 19);
        i0.ɵɵelementStart(29, "button", 20);
        i0.ɵɵtext(30, " Compare License ");
        i0.ɵɵelementStart(31, "span");
        i0.ɵɵelement(32, "img", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "button", 21);
        i0.ɵɵtext(34, "Contact Support");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(14);
        i0.ɵɵtextInterpolate(ctx.licenseObj.title);
        i0.ɵɵadvance(8);
        i0.ɵɵtextInterpolate(ctx.licenseObj.description);
    } }, styles: [".modalPopup[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{z-index:1001;position:absolute;left:50%;top:25%;transform:translate(-50%);width:80%;height:50%;background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden;margin-bottom:50px}.divTable[_ngcontent-%COMP%]   .width10[_ngcontent-%COMP%]{width:10%;vertical-align:top;padding:10px}.divTable[_ngcontent-%COMP%]   .width60[_ngcontent-%COMP%]{width:60%;vertical-align:top;padding:10px}.divTable[_ngcontent-%COMP%]   .width30[_ngcontent-%COMP%]{width:30%;vertical-align:top;padding:10px;border-left:1px solid #eaeaea}.modalPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{text-align:right;padding-right:20px}.paddingTB10[_ngcontent-%COMP%]{padding:10px 0}.title[_ngcontent-%COMP%]{font-family:\"ciscoSans\";padding-right:10px}.subTitle[_ngcontent-%COMP%]{font-size:12px}.actLabel[_ngcontent-%COMP%]{font-family:\"ciscoSans\"}.descClickHere[_ngcontent-%COMP%]{padding-left:10px;color:#049fd9}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LicenseAdoptionComponent, [{
        type: Component,
        args: [{
                selector: "app-license-adoption",
                templateUrl: "./license-adoption.component.html",
                styleUrls: ["./license-adoption.component.scss"]
            }]
    }], function () { return []; }, { licenseObj: [{
            type: Input
        }], onCloseLicenseAdoptionPopup: [{
            type: Output
        }] }); })();

const _c0$y = function (a0, a1, a2, a3) { return { "child-border": a0, "child-no-border": a1, "child-no-width": a2, "parent-hover": a3 }; };
function LocationRowV2Component_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtext(1, " \u00A0 ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ipath_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "spacer-", ipath_r8, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(2, _c0$y, i_r9 >= 2, i_r9 <= 1, i_r9 < 1, ctx_r0.isHoverParent(ipath_r8)));
} }
function LocationRowV2Component_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵlistener("click", function LocationRowV2Component_div_4_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.expandChild($event); });
    i0.ɵɵelement(1, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", "Toggle " + ctx_r1.node.name);
} }
function LocationRowV2Component_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 28);
} }
function LocationRowV2Component_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 29);
} }
function LocationRowV2Component_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 30);
} }
function LocationRowV2Component_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 31);
    i0.ɵɵelement(1, "span", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", ctx_r5.node.apsMatched, i0.ɵɵsanitizeHtml);
} }
function LocationRowV2Component_div_52_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵlistener("click", function LocationRowV2Component_div_52_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.toggleMenu($event, ctx_r12.node); });
    i0.ɵɵelement(1, "img", 34);
    i0.ɵɵelementEnd();
} }
function LocationRowV2Component_lib_row_menu_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-row-menu", 35);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("node", ctx_r7.node);
} }
const _c1$e = function (a0, a1) { return { "location-collapsed": a0, "location-expanded": a1 }; };
const _c2$b = function (a0) { return { "row-hover": a0 }; };
const _c3$9 = function (a0, a1, a2) { return { "disabledClick": a0, "tool-tip-css": a1, "tool-tip-css-first": a2 }; };
const _c4$4 = function (a0, a1) { return { "tool-tip-css": a0, "tool-tip-css-first": a1 }; };
const _c5$1 = function (a1) { return { showAccessCode: true, displayInlineBlock: a1 }; };
class LocationRowV2Component {
    constructor(router, dataService, locationService, cdRef) {
        this.router = router;
        this.dataService = dataService;
        this.locationService = locationService;
        this.cdRef = cdRef;
        this.unsubscribe$ = new Subject();
        this.syncError = {};
        this.expandChildren = false;
        this.emitHover = new EventEmitter();
        this.nodeValue = new EventEmitter();
        this.childHighlighter = {};
        this.selectedLocationEvt = new EventEmitter();
        this.expandCollapseEvt = new EventEmitter();
        this.selectedLocation = [];
        this.navigateToDetails = (section, nodeSel) => {
            switch (section) {
                case "access-points":
                    if (nodeSel.accessPointClickable)
                        this.router.navigate([
                            "/location/details",
                            nodeSel.id,
                            section
                        ]);
                    break;
                case "ble-beacons":
                    if (nodeSel.bleBeaconClickable)
                        this.router.navigate([
                            "/location/details",
                            nodeSel.id,
                            section
                        ]);
                    break;
                case "proximity-rules":
                    if (nodeSel.proximityClickable)
                        this.router.navigate([
                            "/location/details",
                            nodeSel.id,
                            "rules",
                            "captive-portal"
                        ]);
                    break;
                case "networks":
                    if (nodeSel.networkClickable)
                        this.router.navigate([
                            "/location/details",
                            nodeSel.id,
                            section
                        ]);
                    break;
                case "team":
                    if (nodeSel.userClickable)
                        this.router.navigate([
                            "/location/details",
                            nodeSel.id,
                            section
                        ]);
                    break;
                case "access-codes":
                    if (nodeSel.accessCodeClickable)
                        this.router.navigate([
                            "/location/details",
                            nodeSel.id,
                            section
                        ]);
                    break;
                case "camera":
                    if (nodeSel.camerasClickable)
                        this.router.navigate([
                            "/location/details",
                            nodeSel.id,
                            section
                        ]);
                    break;
                default:
                    if (nodeSel.accessPointClickable)
                        this.router.navigate(["/location/details", nodeSel.id]);
                    break;
            }
        };
        this.getPadding = () => {
            const marginLeft = this.node.path.length > 1 ? 20 * (this.node.path.length - 1) : 0;
            const style = { "margin-left": marginLeft + "px" };
            return style;
        };
        this.countReadable = (numberCount) => {
            if (!numberCount)
                return 0;
            let i = 0;
            while (numberCount > 1000) {
                numberCount /= 1000;
                i++;
            }
            return Math.round(numberCount) + ["", "k", "m", "b"][i];
        };
        this.toggleMenu = ($event, node) => {
            console.log("toggleMenu::", $event, node);
            const prevSelectedNode = this.dataService.getPrevSelectedNode()
                ? this.dataService.getPrevSelectedNode()
                : null;
            if (prevSelectedNode) {
                prevSelectedNode.showMenu = false;
            }
            if (this.node)
                this.node.showMenu = false;
            if (node)
                node.showMenu = !node.showMenu;
            if (node.showMenu) {
                this.dataService.setOpenLocationMenu(true);
            }
            this.dataService.setPrevSelectedNode(node);
            this.node = node;
            this.nodeValue.emit(node);
        };
        // toggleMenu = ($event) => {
        //   console.log('toggleMenu::', $event);
        //   if (this.node)
        //     this.node.showMenu = !this.node.showMenu;
        //   if (this.node.showMenu) {
        //     this.dataService.setOpenLocationMenu(true);
        //   }
        //   // this.node = node;
        //   // this.nodeValue.emit(node);
        // }
        this.showLocationDetailsPage = ($event) => {
            if (!this.isPopup) {
                this.dataService.display(true);
                this.dataService.setLocationId(this.node.id);
                //this.dataService.setLocationNode(node);
                this.router.navigate(["/location/details", this.node.id]);
            }
        };
        this.expandChild = ($event) => {
            this.node.expandChildren = !this.node.expandChildren;
            this.expandCollapseEvt.emit({ loc: this.node });
        };
        this.onMouseOver = ($event, isMouseOver) => {
            const locId = this.node.id;
            this.emitHover.emit({ locId, isMouseOver });
        };
        this.onMouseOverNode = (nodeData) => {
            if (!this.isPopup && nodeData.access === 'Full') {
                if (!nodeData.showMenu) {
                    nodeData.showMenu = true;
                    setTimeout(() => {
                        nodeData.showMenu = false;
                    }, 2000);
                }
            }
        };
        this.onMouseOutNode = (nodeData) => {
            if (!this.isPopup) {
                nodeData.showMenu = false;
            }
        };
        this.isHoverParent = (ipath) => {
            const key = Object.keys(this.childHighlighter)[0];
            const next = this.node.path[this.node.path.indexOf(key) + 1];
            return this.node.path.includes(key) && ipath === next;
        };
        this.getCount = (location, countType) => {
            if (this.locationCountResponse && this.locationCountResponse[location.id]) {
                if (this.locationCountResponse[location.id][countType]) {
                    return this.locationCountResponse[location.id][countType];
                }
            }
            return 0;
        };
        // console.log('Constructing the manage locations row ts.');
    }
    set childHighlight(childHighlight) {
        if (childHighlight) {
            this.childHighlighter = childHighlight;
        }
        else {
            this.childHighlighter = {};
        }
    }
    set locationData(locationDataobj) {
        // console.log("Location row ", locationData);
        // this.node = Object.assign({}, loc);
        // this.node.expandChildren = loc.expandChildren
        this.node = locationDataobj.loc;
        this.searchTimestamp = locationDataobj.searchTimestamp;
        // this.children = loc.children;
        if (!this.node.search) {
            this.node.search = {
                foundChild: false,
                timestamp: this.searchTimestamp
            };
        }
        if (!this.node.scrollParam) {
            this.node.scrollParam = {
                hasExpanded: false,
                netChild: 0,
                openChild: []
            };
        }
        if (this.searchTimestamp !== this.node.search.timestamp) {
            this.node.scrollParam.hasExpanded = false;
            this.node.search.timestamp = this.searchTimestamp;
        }
        if (this.node.expandChildren ||
            (this.node.search && this.node.search.foundChild)) {
            this.node.expandChildren = true;
            this.expandCollapseEvt.emit({ loc: this.node });
        }
        // console.log("Location row converted: ", this.node);
    }
    ngAfterViewChecked() {
        // console.log("called after view checked App Component");
        // this.showLoader = false;
        if (this.cdRef)
            this.cdRef.detectChanges();
    }
    ngOnInit() {
        // console.log('Constructing the manage locations row ts in init.');
        // this.expandChildren = (this.level === 0);
        this.nextLevel = this.level + 1;
        this.syncError = {};
        // this.dataService.display(false);
        this.dataService
            .getOnSyncStatusUpdate(this.unsubscribe$)
            .subscribe((updateTimestamp) => {
            if (!updateTimestamp)
                return;
            this.syncError = this.dataService.getSyncError();
        });
        if (this.node.expandChildren ||
            (this.node.search && this.node.search.foundChild)) {
            this.expandCollapseEvt.emit({ loc: this.node });
        }
        // if (this.isSearch && this.node && this.children && this.node.foundChild) {
        //   setTimeout(() => {
        //     this.expandChildren = true;
        //   }, 100);
        // }
    }
    trackByFn(childItem, index) {
        // console.log('here', item, index)
        return childItem;
    }
    ngOnDestroy() {
        console.log("destory location row 2 page");
        // this.treeComponent = null;
        // this.subscribeSearchText("");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
LocationRowV2Component.ɵfac = function LocationRowV2Component_Factory(t) { return new (t || LocationRowV2Component)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
LocationRowV2Component.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LocationRowV2Component, selectors: [["lib-location-row-v2"]], inputs: { childHighlight: "childHighlight", locationData: "locationData", level: "level", showAccessCode: "showAccessCode", isFirst: "isFirst", isPopup: "isPopup", locationCountResponse: "locationCountResponse", userCount: "userCount" }, outputs: { emitHover: "emitHover", nodeValue: "nodeValue", selectedLocationEvt: "selectedLocationEvt", expandCollapseEvt: "expandCollapseEvt" }, decls: 54, vars: 74, consts: [[3, "id", "ngClass"], [1, "location-slab"], ["class", "spacer-child", 3, "id", "ngClass", 4, "ngFor", "ngForOf"], [1, "location-row", 3, "ngClass"], ["class", "location-expander-icon", 3, "click", 4, "ngIf"], ["class", "toggle-children-placeholder", 4, "ngIf"], [1, "location-content", 3, "mouseover", "mouseout"], [1, "location-node-name", 3, "mouseover", "mouseout"], ["href", "javascript:void(0);", 1, "location-name-icon"], [1, "loc-type-icon"], ["id", "link-locdetails", 1, "location-name", 3, "innerHTML", "click"], ["class", "two-factor-icon", 4, "ngIf"], ["class", "sync-error-icon yellow-triangle", 4, "ngIf"], ["class", "matchedApDetails", 4, "ngIf"], [1, "flex-fill-space"], [1, "location-info-list"], [1, "round-icon", "networks-template", 3, "ngClass"], [1, "round-icon", "access-point-template", 3, "ngClass", "click"], [1, "round-icon", "ble-beacons-template", 3, "ngClass", "click"], [1, "round-icon", "proximity-rules-template", 3, "ngClass", "click"], [1, "round-icon", "users-template", 3, "ngClass", "click"], [1, "round-icon", "accesscode-template", 3, "ngClass", "click"], [3, "ngClass"], ["class", "loc-menu-toggle", 3, "click", 4, "ngIf"], [3, "node", 4, "ngIf"], [1, "spacer-child", 3, "id", "ngClass"], [1, "location-expander-icon", 3, "click"], [1, "toggle-children"], [1, "toggle-children-placeholder"], [1, "two-factor-icon"], [1, "sync-error-icon", "yellow-triangle"], [1, "matchedApDetails"], [3, "innerHTML"], [1, "loc-menu-toggle", 3, "click"], ["src", "/assets/images/menu-white.svg", "alt", ".", 1, "menu-open-img"], [3, "node"]], template: function LocationRowV2Component_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, LocationRowV2Component_div_2_Template, 2, 7, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, LocationRowV2Component_div_4_Template, 2, 1, "div", 4);
        i0.ɵɵtemplate(5, LocationRowV2Component_div_5_Template, 1, 0, "div", 5);
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵlistener("mouseover", function LocationRowV2Component_Template_div_mouseover_6_listener($event) { return ctx.onMouseOver($event, true); })("mouseout", function LocationRowV2Component_Template_div_mouseout_6_listener($event) { return ctx.onMouseOver($event, false); });
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵlistener("mouseover", function LocationRowV2Component_Template_div_mouseover_7_listener() { return ctx.onMouseOverNode(ctx.node); })("mouseout", function LocationRowV2Component_Template_div_mouseout_7_listener() { return ctx.onMouseOutNode(ctx.node); });
        i0.ɵɵelementStart(8, "a", 8);
        i0.ɵɵelement(9, "span", 9);
        i0.ɵɵelementStart(10, "span", 10);
        i0.ɵɵlistener("click", function LocationRowV2Component_Template_span_click_10_listener($event) { return ctx.showLocationDetailsPage($event); });
        i0.ɵɵpipe(11, "safeHtml");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, LocationRowV2Component_span_12_Template, 1, 0, "span", 11);
        i0.ɵɵtemplate(13, LocationRowV2Component_span_13_Template, 1, 0, "span", 12);
        i0.ɵɵtemplate(14, LocationRowV2Component_span_14_Template, 2, 1, "span", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(15, "span", 14);
        i0.ɵɵelementStart(16, "div", 15);
        i0.ɵɵelementStart(17, "span");
        i0.ɵɵelementStart(18, "span", 16);
        i0.ɵɵtext(19);
        i0.ɵɵelementStart(20, "span");
        i0.ɵɵtext(21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "span");
        i0.ɵɵelementStart(23, "span", 17);
        i0.ɵɵlistener("click", function LocationRowV2Component_Template_span_click_23_listener() { return ctx.navigateToDetails("access-points", ctx.node); });
        i0.ɵɵtext(24);
        i0.ɵɵelementStart(25, "span");
        i0.ɵɵtext(26);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "span");
        i0.ɵɵelementStart(28, "span", 18);
        i0.ɵɵlistener("click", function LocationRowV2Component_Template_span_click_28_listener() { return ctx.navigateToDetails("ble-beacons", ctx.node); });
        i0.ɵɵtext(29);
        i0.ɵɵelementStart(30, "span");
        i0.ɵɵtext(31);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "span");
        i0.ɵɵelementStart(33, "span", 19);
        i0.ɵɵlistener("click", function LocationRowV2Component_Template_span_click_33_listener() { return ctx.navigateToDetails("proximity-rules", ctx.node); });
        i0.ɵɵtext(34);
        i0.ɵɵelementStart(35, "span");
        i0.ɵɵtext(36);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "span");
        i0.ɵɵelementStart(38, "span", 20);
        i0.ɵɵlistener("click", function LocationRowV2Component_Template_span_click_38_listener() { return ctx.navigateToDetails("team", ctx.node); });
        i0.ɵɵtext(39);
        i0.ɵɵelementStart(40, "span");
        i0.ɵɵtext(41);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(42, "span");
        i0.ɵɵelementStart(43, "span", 21);
        i0.ɵɵlistener("click", function LocationRowV2Component_Template_span_click_43_listener() { return ctx.navigateToDetails("camera", ctx.node); });
        i0.ɵɵtext(44);
        i0.ɵɵelementStart(45, "span");
        i0.ɵɵtext(46);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "span", 22);
        i0.ɵɵelementStart(48, "span", 21);
        i0.ɵɵlistener("click", function LocationRowV2Component_Template_span_click_48_listener() { return ctx.navigateToDetails("access-codes", ctx.node); });
        i0.ɵɵtext(49);
        i0.ɵɵelementStart(50, "span");
        i0.ɵɵtext(51);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(52, LocationRowV2Component_div_52_Template, 2, 0, "div", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(53, LocationRowV2Component_lib_row_menu_53_Template, 1, 1, "lib-row-menu", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate2("location-block location-level-", ctx.level, " type-", ctx.node.type, "");
        i0.ɵɵpropertyInterpolate("id", ctx.node.id);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(40, _c1$e, !ctx.node.expandChildren, ctx.node.expandChildren));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.node.path);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(43, _c2$b, ctx.node.showMenu));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.node.children && ctx.node.children.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.node.children || ctx.node.children.length <= 0);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(11, 38, ctx.node.name), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.node.useAPI);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.syncError[ctx.node.id]);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.node.apsMatched);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(45, _c3$9, !ctx.node.networkClickable, !ctx.isFirst, ctx.isFirst));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.countReadable(ctx.node.networkCount));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("", ctx.node.networkCount, " Locations");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(49, _c3$9, !ctx.node.accessPointClickable, !ctx.isFirst, ctx.isFirst));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.countReadable(ctx.node.accessPointCount));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("", ctx.node.accessPointCount, " Access Points");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(53, _c3$9, !ctx.node.bleBeaconClickable, !ctx.isFirst, ctx.isFirst));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.countReadable(ctx.node.bleBeaconCount));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("", ctx.node.bleBeaconCount, " Ble Beacons");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(57, _c3$9, !ctx.node.proximityClickable, !ctx.isFirst, ctx.isFirst));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.countReadable(ctx.node.proximityCount));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("", ctx.node.proximityCount, " Proximity Rules");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(61, _c3$9, !ctx.node.userClickable, !ctx.isFirst, ctx.isFirst));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.userCount);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("", ctx.userCount, " Users");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(65, _c4$4, !ctx.isFirst, ctx.isFirst));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.countReadable(ctx.node.camerasCount), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("", ctx.node.camerasCount, " Cameras");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(68, _c5$1, ctx.showAccessCode));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(70, _c3$9, !ctx.node.accessCodeClickable, !ctx.isFirst, ctx.isFirst));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.countReadable(ctx.node.accessCodeCount));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("", ctx.node.accessCodeCount, " Access codes");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isPopup && ctx.node.access === "Full");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.node.showMenu && !ctx.isPopup);
    } }, directives: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, RowMenuComponent], pipes: [SafeHtmlPipe], styles: [".disabledClick[_ngcontent-%COMP%]{cursor:default}input[type=checkbox][_ngcontent-%COMP%]:hover ~ .childSelected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -18px;content:\"\"}input[type=checkbox][_ngcontent-%COMP%] ~ .childSelected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -72px;content:\"\"}.hideNode[_ngcontent-%COMP%]{display:none}.flex-fill-space[_ngcontent-%COMP%]{flex:1 1 auto}div.location-block.location-collapsed[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-expander-icon[_ngcontent-%COMP%]{background:url(/assets/images/expand_plus.svg) no-repeat 10px center}div.location-block.location-expanded[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-expander-icon[_ngcontent-%COMP%]{background:url(/assets/images/collapse_minus.svg) no-repeat 10px center}div.location-block.location-collapsed[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-expander-icon[_ngcontent-%COMP%]:hover{background:url(/assets/images/expand_plus_hover.svg) no-repeat 10px center}div.location-block.location-expanded[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-expander-icon[_ngcontent-%COMP%]:hover{background:url(/assets/images/collapse_minus_hover.svg) no-repeat 10px center}div.location-expander-icon[_ngcontent-%COMP%]{width:40px;height:40px}div[_ngcontent-%COMP%]:not(.location-level-0) > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%]{margin-top:10px}div.location-row[_ngcontent-%COMP%]{display:flex;flex:1 1 auto;position:relative}div.location-level-0[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-expander-icon[_ngcontent-%COMP%]{display:none}div[_ngcontent-%COMP%]:not(.location-level-0) > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%]:hover{background-color:#f9f9f9;border-top-left-radius:100px;border-bottom-left-radius:100px;box-shadow:0 0 2px #acacac}div.parent-hover[_ngcontent-%COMP%]{border-left:1px solid #049fd9}div.parent-hover[_ngcontent-%COMP%]:before{background-color:#049fd9}div.location-expanded[_ngcontent-%COMP%]:not(.location-level-0) > div.location-slab[_ngcontent-%COMP%] > div.location-children[_ngcontent-%COMP%]{border-left:1px solid #dddfe2}div.location-children[_ngcontent-%COMP%]{margin-left:20px}div.location-expanded[_ngcontent-%COMP%]:not(.location-level-0) > div.location-slab[_ngcontent-%COMP%] > div.location-children[_ngcontent-%COMP%]:before{position:absolute;content:\"\";bottom:0;background-color:#dddfe2;width:4px;height:1px;left:21px}div.location-content[_ngcontent-%COMP%]{display:flex;width:100%;height:45px;padding-top:10px}.location-block[_ngcontent-%COMP%]{position:relative}div[_ngcontent-%COMP%]:not(.location-level-0) > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%]:not(:hover) > div.location-content[_ngcontent-%COMP%]{border-bottom:1px solid #dddfe2}div.location-node-name[_ngcontent-%COMP%]{vertical-align:middle;padding-left:0;position:relative}div.location-level-0[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > span.location-name[_ngcontent-%COMP%]{font-size:18px;color:#000;border-color:#000;font-family:ciscoSansRegular;font-weight:normal}div.location-level-0[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%]{background-color:#f6f6f6;-webkit-box-shadow:0 1px 0 0 #e9e9e9;transform:translate(0);box-shadow:0 1px #e9e9e9;padding-left:20px}.loc-menu-toggle[_ngcontent-%COMP%]{display:none;position:absolute;left:100%;height:45px;top:0;-webkit-box-shadow:1px 0 1px 0 #acacac;-webkit-transform:translate3d(0,0,0);box-shadow:1px 0 1px #acacac;cursor:pointer;background-color:#f9f9f9;width:40px;border-top-right-radius:100px;border-bottom-right-radius:100px;padding:5px}div.location-block[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%]:hover   .loc-menu-toggle[_ngcontent-%COMP%]{display:block}.loc-menu-toggle[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{background:#049fd9;border-radius:100%}.location-row[_ngcontent-%COMP%]:hover   .loc-menu-toggle[_ngcontent-%COMP%]{display:block}.location-row[_ngcontent-%COMP%]:hover   .round-icon[_ngcontent-%COMP%]{background-color:#049fd9;border:solid 0 #979797;color:#fff}.two-factor-icon[_ngcontent-%COMP%]{display:inline-block;width:18px;height:18px;content:\"\";vertical-align:middle;background:url(/assets/images/two_factor.svg) no-repeat center center;background-size:contain}.sync-error-icon[_ngcontent-%COMP%]{display:inline-block;width:12px;height:12px;content:\"\";vertical-align:middle}.sync-error-icon.yellow-triangle[_ngcontent-%COMP%]{background:url(/assets/images/error_icon.svg) no-repeat center center}.sync-error-icon.red-circle[_ngcontent-%COMP%]{background:url(/assets/images/error_icon.svg) no-repeat center center}.toggle-children-placeholder[_ngcontent-%COMP%]{vertical-align:middle;width:40px;height:40px;display:inline-block;position:relative;background:url(/assets/images/building_noLocations.svg) no-repeat 10px center;cursor:default}.loc-type-icon[_ngcontent-%COMP%]{width:20px;height:20px;content:\"\";display:inline-block;vertical-align:middle}div.location-level-0[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .loc-type-icon[_ngcontent-%COMP%]{display:none}.type-network[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .loc-type-icon[_ngcontent-%COMP%]{background:url(/assets/images/building_icon.svg) no-repeat center center}.type-wlc_network[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .loc-type-icon[_ngcontent-%COMP%]{background:url(/assets/images/wlc.svg) no-repeat center center}.type-mse[_ngcontent-%COMP%]   .type-network[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .loc-type-icon[_ngcontent-%COMP%]{background:url(/assets/images/building_location_icon.svg) no-repeat center center}.type-mse[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .loc-type-icon[_ngcontent-%COMP%]{background:url(/assets/images/cuwn.svg) no-repeat center center}.type-meraki[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .loc-type-icon[_ngcontent-%COMP%]{background:url(/assets/images/meraki.svg) no-repeat center center}.type-wlc[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .loc-type-icon[_ngcontent-%COMP%]{background:url(/assets/images/wlc.svg) no-repeat center center}.type-zone[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .loc-type-icon[_ngcontent-%COMP%]{background:url(/assets/images/zone_icon.svg) no-repeat center center}.type-campus[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .loc-type-icon[_ngcontent-%COMP%]{background:url(/assets/images/campus_icon.svg) no-repeat center center}.type-campus_wlc[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .loc-type-icon[_ngcontent-%COMP%]{background:url(/assets/images/campus_icon.svg) no-repeat center center}.type-meraki_campus[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .loc-type-icon[_ngcontent-%COMP%]{background:url(/assets/images/campus_icon.svg) no-repeat center center}.type-floor[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .loc-type-icon[_ngcontent-%COMP%]{background:url(/assets/images/floor_icon.svg) no-repeat center center}.type-group[_ngcontent-%COMP%] > div.location-slab[_ngcontent-%COMP%] > div.location-row[_ngcontent-%COMP%] > div.location-content[_ngcontent-%COMP%] > div.location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .loc-type-icon[_ngcontent-%COMP%]{background:url(/assets/images/group_icon.svg) no-repeat center center}.spacer-child[_ngcontent-%COMP%]{width:20px}.child-border[_ngcontent-%COMP%]{border-left:1px solid #dddfe2;margin-left:20px}.child-no-border[_ngcontent-%COMP%]{border-left:0;margin-left:0}.child-no-width[_ngcontent-%COMP%]{width:0px}.location-slab[_ngcontent-%COMP%]{position:relative;display:flex}.spacer-child[_ngcontent-%COMP%]:first-child{width:0px!important;margin-left:0;border:0px}.type-network[_ngcontent-%COMP%] > .location-slab[_ngcontent-%COMP%] > .location-row[_ngcontent-%COMP%] > .location-content[_ngcontent-%COMP%] > .location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .location-name[_ngcontent-%COMP%]{font-size:14px;font-weight:normal;color:#ab825d}.type-mse[_ngcontent-%COMP%]   .type-network[_ngcontent-%COMP%] > .node-wrapper[_ngcontent-%COMP%]   .location-name[_ngcontent-%COMP%]{font-size:14px;font-weight:normal;color:#666}.type-mse[_ngcontent-%COMP%] > .location-slab[_ngcontent-%COMP%] > .location-row[_ngcontent-%COMP%] > .location-content[_ngcontent-%COMP%] > .location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .location-name[_ngcontent-%COMP%], .type-meraki[_ngcontent-%COMP%] > .location-slab[_ngcontent-%COMP%] > .location-row[_ngcontent-%COMP%] > .location-content[_ngcontent-%COMP%] > .location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .location-name[_ngcontent-%COMP%]{font-size:16px;color:#636363}.type-zone[_ngcontent-%COMP%] > .location-slab[_ngcontent-%COMP%] > .location-row[_ngcontent-%COMP%] > .location-content[_ngcontent-%COMP%] > .location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .location-name[_ngcontent-%COMP%]{font-size:10px;font-weight:normal;color:#666}.type-zone[_ngcontent-%COMP%] > .location-slab[_ngcontent-%COMP%] > .location-row[_ngcontent-%COMP%] > .location-content[_ngcontent-%COMP%] > .location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .location-name[_ngcontent-%COMP%]{width:auto}.type-campus[_ngcontent-%COMP%] > .location-slab[_ngcontent-%COMP%] > .location-row[_ngcontent-%COMP%] > .location-content[_ngcontent-%COMP%] > .location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .location-name[_ngcontent-%COMP%]{font-size:14px;font-weight:normal;color:#666}.type-group[_ngcontent-%COMP%] > .location-slab[_ngcontent-%COMP%] > .location-row[_ngcontent-%COMP%] > .location-content[_ngcontent-%COMP%] > .location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .location-name[_ngcontent-%COMP%]{font-size:18px;font-weight:500;color:#4a90e2}.type-floor[_ngcontent-%COMP%] > .location-slab[_ngcontent-%COMP%] > .location-row[_ngcontent-%COMP%] > .location-content[_ngcontent-%COMP%] > .location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .location-name[_ngcontent-%COMP%]{font-size:12px;font-weight:normal;color:#666;margin-left:10px}.type-zone[_ngcontent-%COMP%] > .location-slab[_ngcontent-%COMP%] > .location-row[_ngcontent-%COMP%] > .location-content[_ngcontent-%COMP%] > .location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .location-name[_ngcontent-%COMP%], .type-cmx_zone[_ngcontent-%COMP%] > .location-slab[_ngcontent-%COMP%] > .location-row[_ngcontent-%COMP%] > .location-content[_ngcontent-%COMP%] > .location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .location-name[_ngcontent-%COMP%], .type-polygon_zone[_ngcontent-%COMP%] > .location-slab[_ngcontent-%COMP%] > .location-row[_ngcontent-%COMP%] > .location-content[_ngcontent-%COMP%] > .location-node-name[_ngcontent-%COMP%] > a[_ngcontent-%COMP%] > .location-name[_ngcontent-%COMP%]{font-size:12px;font-weight:normal;color:#666}.tool-tip-css-first[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{width:auto;padding:7px 10px;bottom:-35px;z-index:10;position:absolute;font-family:sans-serif;font-size:12px;font-style:normal;border-radius:5px;font-weight:normal;color:#fff;background:#414f5f;transform:translate(-50%);white-space:nowrap;display:none}.tool-tip-css-first[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]:after{content:\"\";position:absolute;bottom:100%;left:50%;margin-left:-8px;width:0;height:0;border-bottom:8px solid #414f5f;border-right:8px solid transparent;border-left:8px solid transparent}.tool-tip-css-first[_ngcontent-%COMP%]:hover > span[_ngcontent-%COMP%]{opacity:1;text-decoration:none;visibility:visible;overflow:visible;display:inline}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocationRowV2Component, [{
        type: Component,
        args: [{
                selector: "lib-location-row-v2",
                templateUrl: "./location-row-v2.component.html",
                styleUrls: ["./location-row-v2.component.css"]
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: LocationService }, { type: i0.ChangeDetectorRef }]; }, { emitHover: [{
            type: Output
        }], nodeValue: [{
            type: Output
        }], childHighlight: [{
            type: Input
        }], locationData: [{
            type: Input
        }], level: [{
            type: Input
        }], showAccessCode: [{
            type: Input
        }], isFirst: [{
            type: Input
        }], isPopup: [{
            type: Input
        }], locationCountResponse: [{
            type: Input
        }], userCount: [{
            type: Input
        }], selectedLocationEvt: [{
            type: Output
        }], expandCollapseEvt: [{
            type: Output
        }] }); })();

function LocationSearchComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1, " Please enter more than 4 characters to search.\n");
    i0.ɵɵelementEnd();
} }
function LocationSearchComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1, "Searching Locations ...");
    i0.ɵɵelementEnd();
} }
function LocationSearchComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1, "Searching Accesspoints ...");
    i0.ɵɵelementEnd();
} }
class LocationSearchComponent {
    constructor(router, dataService, locationService, cdRef) {
        this.router = router;
        this.dataService = dataService;
        this.locationService = locationService;
        this.cdRef = cdRef;
        this.unsubscribe$ = new Subject();
        this.unsubscribe_1$ = new Subject();
        this.filteredLocations = new EventEmitter();
        this.makeSearchAPICall = true;
        this.searchTimestamp = 0;
        this.errorText = false;
        this.searchingLocations = false;
        this.searchingAPs = false;
        this.startSearchTree = () => {
            clearTimeout(this.searchTimeoutObject);
            this.searchTimeoutObject = setTimeout(() => {
                this.searchTimestamp = new Date().getTime();
                this.searchTree(this.searchTimestamp);
            }, 700);
        };
        this.searchTree = (localSearchTimestamp) => {
            console.log("search tree", this.searchString);
            if (this.locationOrginal === undefined ||
                this.locationOrginal === null ||
                this.searchString === null ||
                this.searchString === undefined ||
                this.searchString === '') {
                console.log("this.locationOrginal === undefined || this.locationOrginal === null", this.locationOrginal);
                this.resetList();
                return;
            }
            const makeServerCall = true;
            const tokensTemp = this.searchString.trim().split(" ");
            const tokens = [];
            for (let tokCount = 0, max = tokensTemp.length; tokCount < max; tokCount++) {
                if (!this.validToken(tokensTemp[tokCount]))
                    continue;
                tokens.push(tokensTemp[tokCount]);
            }
            if (tokens && tokens.length > 0) {
                this.searchingLocations = true;
                if (localSearchTimestamp !== this.searchTimestamp) {
                    return;
                }
                const regexTokenStr = "root|" + tokens.join("|");
                const regexStr = "(" + regexTokenStr + ")";
                const regexp = new RegExp(regexStr, "gi");
                // console.log('tokens', tokens, tokens.join('|'), "regexp", regexp, "this.locationSearchString", this.locationSearchString);
                setTimeout(() => {
                    this.findNodes(tokens, regexp, localSearchTimestamp, null, true);
                    this.searchingLocations = false;
                }, 5);
                const apMatches = [];
                if (makeServerCall && this.makeSearchAPICall) {
                    this.unsubscribe_1$.next();
                    this.unsubscribe_1$.complete();
                    this.unsubscribe_1$ = new Subject();
                    this.searchingAPs = true;
                    for (let tokn = 0, max = tokens.length; tokn < max; tokn++) {
                        setTimeout(() => {
                            if (tokens[tokn].length > 2) {
                                if (localSearchTimestamp !== this.searchTimestamp) {
                                    return;
                                }
                                this.locationService
                                    .searchAPs(tokens[tokn], localSearchTimestamp)
                                    .pipe(takeUntil(this.unsubscribe$), takeUntil(this.unsubscribe_1$))
                                    .subscribe((searchData) => {
                                    // if (!searchData.status) {
                                    //   return;
                                    // }
                                    //searchData
                                    // console.log('searchData', searchData, this.searchTimestamp, this.searchTimestamp === searchData.timestamp)
                                    this.dataService.display(true);
                                    if (this.searchTimestamp ===
                                        searchData.timestamp) {
                                        this.updateSearchAps(apMatches, searchData.result);
                                        this.findNodes(tokens, regexp, searchData.timestamp, apMatches, false);
                                    }
                                    this.dataService.display(false);
                                }, (error) => {
                                    console.log("search error:: login", error);
                                    if (error.status == 401) {
                                        this.locationService.signOut();
                                    }
                                    this.dataService.display(false);
                                }, () => {
                                    this.searchingAPs = false;
                                    this.dataService.display(false);
                                });
                            }
                        }, 0);
                    }
                }
                this.dataService.display(false);
            }
            else {
                this.resetList();
                this.dataService.display(false);
            }
        };
        this.resetList = () => {
            //emit
            this.searchTimestamp = new Date().getTime();
            this.isSearch = false;
            this.searchString = "";
            const emitObj = {
                filteredLocations: this.locationOrginal,
                isSearch: this.isSearch,
                timestamp: this.searchTimestamp
            };
            this.filteredLocations.emit(emitObj);
            this.unsubscribe_1$.next();
            this.unsubscribe_1$.complete();
            this.unsubscribe_1$ = new Subject();
            this.searchingLocations = false;
            this.searchingAPs = false;
        };
        this.validToken = (token) => {
            if (token == "" || token == ".") {
                return false;
            }
            return true;
        };
        this.findNodes = (tokens, regexp, searchTimestamp, apMatches, firstCall) => {
            let filteredLocation = null;
            let node;
            if (searchTimestamp !== this.searchTimestamp) {
                return;
            }
            //console.log('searchRegex', regexp, 'firstCall', firstCall);
            if (this.locationOrginal && this.locationOrginal.length > 0)
                filteredLocation = this.matchToken(this.locationOrginal[0], tokens, apMatches, false, regexp, searchTimestamp);
            if (filteredLocation && filteredLocation.location) {
                node = [filteredLocation.location];
                this.isSearch = true;
            }
            else {
                node = this.locationOrginal;
                this.isSearch = false;
            }
            if (searchTimestamp !== this.searchTimestamp) {
                return;
            }
            //emit
            const emitObj = {
                filteredLocations: node,
                isSearch: this.isSearch,
                timestamp: searchTimestamp
            };
            this.filteredLocations.emit(emitObj);
        };
        this.updateSearchAps = (apMatches, newMatches) => {
            //console.log( 'updateSearchAps', apMatches, newMatches );
            Object.keys(newMatches).map((key) => {
                apMatches[key] = newMatches[key];
            });
        };
        this.matchToken = (location, searchTokens, apMatches, isParent, searchRegex, searchTimestamp) => {
            if (searchTimestamp !== this.searchTimestamp) {
                return;
            }
            let found = false;
            // console.log(location.name, location.path, searchRegex.test(location.name.toLowerCase()))
            if (searchRegex.test(location.name.toLowerCase())) {
                found = true;
                // console.log('Location matched:', location.name, location.path);
            }
            const newLoc = Object.assign({}, location);
            // initialize
            newLoc.children = [];
            newLoc.location = [];
            newLoc.expandChildren = false;
            newLoc.scrollParam = { hasExpanded: false, netChild: 0, openChild: [] };
            if (apMatches && apMatches[newLoc.id]) {
                found = true;
                newLoc.apsMatched = apMatches[newLoc.id] + " AP(s) matched";
            }
            else
                newLoc.apsMatched = "";
            // let newLoc = location.clone();
            newLoc.expanded = false;
            if (location.type === "root" || found)
                newLoc.expanded = true;
            if (found) {
                newLoc.name = newLoc.name
                    .replace(/&amp;/g, "&")
                    .replace(/&lt;/g, "<")
                    .replace(/&gt;/g, ">");
                newLoc.name = newLoc.name.replace(searchRegex, '<span class="highlighted">$&</span>');
            }
            let foundChild = false;
            const currentNav = this.dataService.getCurrentNav();
            if (location.type === "network" &&
                currentNav &&
                (currentNav.indexOf("business") !== -1 ||
                    currentNav.indexOf("impactanalysis") !== -1)) {
                return { location: newLoc, foundChild: foundChild, found: found };
            }
            else {
                if (location.children) {
                    for (let index = 0, max = location.children.length; index < max; index++) {
                        if (searchTimestamp !== this.searchTimestamp) {
                            return;
                        }
                        const childLoc = location.children[index];
                        const resChild = this.matchToken(childLoc, searchTokens, apMatches, isParent || found, searchRegex, searchTimestamp);
                        if (resChild &&
                            (resChild["foundChild"] || resChild["found"])) {
                            foundChild = true;
                            // console.log('Location matched:', resChild['location'].name, resChild['location'].path);
                        }
                        if (isParent ||
                            found ||
                            (resChild &&
                                (resChild["foundChild"] || resChild["found"]))) {
                            if (foundChild) {
                                newLoc.search = {
                                    foundChild: true,
                                    timestamp: searchTimestamp
                                };
                            }
                            if (resChild)
                                newLoc.children.push(resChild["location"]);
                        }
                    }
                }
                //
                return { location: newLoc, foundChild: foundChild, found: found };
            }
        };
        console.log("Search the manage locations ts.");
    }
    set customSearchText(customSearchText) {
        console.log("custom search string", customSearchText);
        this.searchTimestamp = new Date().getTime();
        if (customSearchText && customSearchText !== '') {
            if (customSearchText.trim().length >= 4) {
                this.errorText = false;
                this.searchString = customSearchText.trim();
                this.startSearchTree();
            }
            else {
                this.errorText = true;
                this.resetList();
            }
        }
        else {
            this.errorText = false;
            this.searchString = null;
            this.resetList();
        }
    }
    set location(loc) {
        console.log("Location hierarchy to be searched ", loc);
        this.locationOrginal = loc;
        this.startSearchTree();
    }
    ngAfterViewChecked() {
        // console.log("called after view checked App Component");
        // this.showLoader = false;
        if (this.cdRef)
            this.cdRef.detectChanges();
    }
    ngOnInit() {
        console.log("Search the manage locations hiierarchy ts in init.");
    }
    ngOnDestroy() {
        console.log("destory manageLocations page");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
LocationSearchComponent.ɵfac = function LocationSearchComponent_Factory(t) { return new (t || LocationSearchComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
LocationSearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LocationSearchComponent, selectors: [["lib-location-search"]], inputs: { isSearch: "isSearch", customSearchText: "customSearchText", location: "location" }, outputs: { filteredLocations: "filteredLocations" }, decls: 3, vars: 3, consts: [["class", "error", 4, "ngIf"], [1, "error"]], template: function LocationSearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LocationSearchComponent_div_0_Template, 2, 0, "div", 0);
        i0.ɵɵtemplate(1, LocationSearchComponent_div_1_Template, 2, 0, "div", 0);
        i0.ɵɵtemplate(2, LocationSearchComponent_div_2_Template, 2, 0, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.errorText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.searchingLocations);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.searchingAPs);
    } }, directives: [i1$2.NgIf], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocationSearchComponent, [{
        type: Component,
        args: [{
                selector: "lib-location-search",
                templateUrl: "./location-search.component.html",
                styleUrls: ["./location-search.component.css"]
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: LocationService }, { type: i0.ChangeDetectorRef }]; }, { filteredLocations: [{
            type: Output
        }], isSearch: [{
            type: Input
        }], customSearchText: [{
            type: Input
        }], location: [{
            type: Input
        }] }); })();

/* eslint-disable @typescript-eslint/no-unused-vars */
function LocationSelectionDropdownComponent_div_0_div_4_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵelement(1, "img", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r3 = i0.ɵɵnextContext().index;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i_r3 === ctx_r4.currentSelected ? "tick" : "noTick");
} }
function LocationSelectionDropdownComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵlistener("click", function LocationSelectionDropdownComponent_div_0_div_4_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r7); const country_r2 = restoredCtx.$implicit; const i_r3 = restoredCtx.index; const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.selectCountryItem(country_r2, i_r3); });
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, LocationSelectionDropdownComponent_div_0_div_4_span_3_Template, 2, 1, "span", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const country_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", country_r2.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.currentSelected === i_r3);
} }
function LocationSelectionDropdownComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "input", 2);
    i0.ɵɵlistener("ngModelChange", function LocationSelectionDropdownComponent_div_0_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.searchInCountry = $event; })("keyup", function LocationSelectionDropdownComponent_div_0_Template_input_keyup_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.onCountrySearchKeyUp(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "lib-search-basic", 3);
    i0.ɵɵlistener("filtered", function LocationSelectionDropdownComponent_div_0_Template_lib_search_basic_filtered_2_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.onCountrySearchFilter($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, LocationSelectionDropdownComponent_div_0_div_4_Template, 4, 2, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r0.searchInCountry);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", ctx_r0.itemList)("customSearchText", ctx_r0.searchText)("shouldUseGlobalSearch", false)("searchSkeleton", ctx_r0.countrySearchSkeleton);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.countryList_filtered);
} }
class LocationSelectionDropdownComponent {
    constructor() {
        this.emitSelection = new EventEmitter();
        this.emitDisableSave = new EventEmitter();
        this.displayOptions = false;
        this.filterString = "";
        this.placeholder = "";
        this.dropdownExpand = false;
        this.countrySearchSkeleton = {
            name: "string",
        };
        this.currentSelected = -1;
        this.lastSelected = -1;
        this.countryList_filtered = [];
        this.showCustomerOptions = () => {
            this.displayOptions = !this.displayOptions;
            this.countryList_filtered = this.itemList;
        };
        this.selectCountryItem = (item, index) => {
            this.lastSelected = this.currentSelected;
            this.currentSelected = index;
            if (item.selectable || item.selectable == undefined) {
                this.placeholder = item.name;
                this.filterString = "";
                this.displayOptions = false;
                this.emitSelection.emit(item);
            }
        };
        this.onCountrySearchKeyUp = () => {
            this.searchText = this.searchInCountry.toLowerCase();
            this.currentSelected = -1;
            this.emitDisableSave.emit();
        };
        this.onCountrySearchFilter = (data) => {
            //if (this.searchText && this.searchText.length > 0) {
            this.countryList_filtered = data;
            //	}
        };
    }
    ngOnInit() { }
}
LocationSelectionDropdownComponent.ɵfac = function LocationSelectionDropdownComponent_Factory(t) { return new (t || LocationSelectionDropdownComponent)(); };
LocationSelectionDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LocationSelectionDropdownComponent, selectors: [["lib-location-selection-dropdown"]], inputs: { itemList: "itemList" }, outputs: { emitSelection: "emitSelection", emitDisableSave: "emitDisableSave" }, decls: 1, vars: 1, consts: [["class", "dropdown", 4, "ngIf"], [1, "dropdown"], ["name", "userSearch", "placeholder", "Search", 1, "countrySearchInput", 3, "ngModel", "ngModelChange", "keyup"], [3, "data", "customSearchText", "shouldUseGlobalSearch", "searchSkeleton", "filtered"], [1, "country-section"], ["class", "country", 4, "ngFor", "ngForOf"], [1, "country"], [1, "countryline", 3, "click"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], ["src", "/assets/images/tick.svg"]], template: function LocationSelectionDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LocationSelectionDropdownComponent_div_0_Template, 5, 6, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.itemList);
    } }, directives: [i1$2.NgIf, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, SearchBasicComponent, i1$2.NgForOf, i1$2.NgClass], styles: [".dropdown{position:relative;height:100%}.arrow{color:#6a6b6c;font-family:\"icomoon-new\";position:absolute;right:0;padding:4px;display:block}.options{width:100%;position:absolute;top:70%;max-height:200px;overflow-y:auto;padding:0;margin:0;z-index:1003;background-color:#fff;box-shadow:5px 5px 20px #888}.each-option{display:block;padding:8px 10px;font-size:13px;color:#909090;font-family:\"ciscoSansRegular\";background-color:#fff;cursor:pointer}.each-option:hover{background-color:#eaeaea}.item-name{font-size:18px}.item-message{font-size:x-small;font-style:italic}.active{cursor:pointer}.inactive{cursor:not-allowed}.active .item-message{color:green}.inactive .item-message{color:red}.inactive-clickable{cursor:pointer}.inactive-clickable .item-message{color:red}.selectedItem{display:table-cell;width:40px;height:40px;vertical-align:middle}.paddingLeft{padding-left:40px}.unSelectedItem{display:table-cell;height:40px;vertical-align:middle;padding-left:40px}.tableCell{display:table-cell;vertical-align:middle}.paddingEmpty{padding:0!important}input.countrySearchInput{color:#909090!important;width:100%;height:42px;flex-shrink:0;border-radius:28px;background:#F7F7F7;border:1px solid;padding:16px;text-indent:30px;background-position:14px;background-repeat:no-repeat;background-image:url(../../../../../assets/images/business/search_dropdown.svg)}input:focus::placeholder{color:transparent;background-image:none}.country{padding:10px;border-bottom:1px solid #DADADA;color:#000;font-family:CiscoSans;font-size:15px;font-style:normal;font-weight:400;line-height:22px;cursor:pointer}.country-section{overflow-y:scroll;margin-top:20px;height:88%}.tick{float:right}.noTick{background-color:#fff}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocationSelectionDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'lib-location-selection-dropdown',
                templateUrl: './location-selection-dropdown.component.html',
                styleUrls: ['./location-selection-dropdown.component.scss'],
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { itemList: [{
            type: Input
        }], emitSelection: [{
            type: Output
        }], emitDisableSave: [{
            type: Output
        }] }); })();

function LoginHistoryComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Last Login: ", ctx_r0.lastLoginDate, " ");
} }
function LoginHistoryComponent_div_15_tbody_13_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 26);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span", 27);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "span", 27);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵelementStart(8, "span", 27);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const loginHistory_r8 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", loginHistory_r8.ipAddress, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(loginHistory_r8.lastLogin);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", loginHistory_r8.userAgent, ". v ", loginHistory_r8.version, "");
} }
function LoginHistoryComponent_div_15_tbody_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 17);
    i0.ɵɵtemplate(1, LoginHistoryComponent_div_15_tbody_13_tr_1_Template, 10, 4, "tr", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.temp_failure_list);
} }
function LoginHistoryComponent_div_15_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵelementStart(1, "td", 28);
    i0.ɵɵelementStart(2, "span", 27);
    i0.ɵɵelementStart(3, "p", 29);
    i0.ɵɵtext(4, " No Data Available ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LoginHistoryComponent_div_15_div_16_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵlistener("click", function LoginHistoryComponent_div_15_div_16_div_3_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(3); return ctx_r10.showMoreClickFailure(); });
    i0.ɵɵtext(1, " Show More ");
    i0.ɵɵelementEnd();
} }
function LoginHistoryComponent_div_15_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LoginHistoryComponent_div_15_div_16_div_3_Template, 2, 0, "div", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" Showing ", ctx_r6.temp_failure_list.length, " of ", ctx_r6.loginFailureHistoryList.length, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.showMoreBtnFailure);
} }
function LoginHistoryComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵtext(2, "Failed Attempt");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "lib-app-search", 15);
    i0.ɵɵlistener("searchTextChange", function LoginHistoryComponent_div_15_Template_lib_app_search_searchTextChange_3_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.onSearchFailStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "table", 16);
    i0.ɵɵelementStart(5, "thead", 17);
    i0.ɵɵelementStart(6, "tr", 18);
    i0.ɵɵelementStart(7, "th", 19);
    i0.ɵɵtext(8, "IP Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 20);
    i0.ɵɵtext(10, "Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th", 21);
    i0.ɵɵtext(12, "Browser");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, LoginHistoryComponent_div_15_tbody_13_Template, 2, 1, "tbody", 22);
    i0.ɵɵtemplate(14, LoginHistoryComponent_div_15_ng_template_14_Template, 5, 0, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, LoginHistoryComponent_div_15_div_16_Template, 4, 3, "div", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r4 = i0.ɵɵreference(15);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("section", "Failed Items")("emitSearch", true);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngIf", ctx_r1.temp_failure_list)("ngIfElse", _r4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.temp_failure_list !== null && ctx_r1.temp_failure_list.length > 0);
} }
function LoginHistoryComponent_div_16_tbody_13_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 26);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span", 27);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "span", 27);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵelementStart(8, "span", 27);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const loginHistory_r17 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", loginHistory_r17.ipAddress, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(loginHistory_r17.lastLogin);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", loginHistory_r17.userAgent, ". v ", loginHistory_r17.version, "");
} }
function LoginHistoryComponent_div_16_tbody_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 17);
    i0.ɵɵtemplate(1, LoginHistoryComponent_div_16_tbody_13_tr_1_Template, 10, 4, "tr", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r14.temp_success_list);
} }
function LoginHistoryComponent_div_16_div_14_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵlistener("click", function LoginHistoryComponent_div_16_div_14_div_3_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(3); return ctx_r19.showMoreClickSuccess(); });
    i0.ɵɵtext(1, " Show More ");
    i0.ɵɵelementEnd();
} }
function LoginHistoryComponent_div_16_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LoginHistoryComponent_div_16_div_14_div_3_Template, 2, 0, "div", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" Showing ", ctx_r15.temp_success_list.length, " of ", ctx_r15.loginSuccessHistoryList.length, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.showMoreBtnSuccess);
} }
function LoginHistoryComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵtext(2, "Recent Login");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "lib-app-search", 15);
    i0.ɵɵlistener("searchTextChange", function LoginHistoryComponent_div_16_Template_lib_app_search_searchTextChange_3_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.onSearchSuccessStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "table", 16);
    i0.ɵɵelementStart(5, "thead", 17);
    i0.ɵɵelementStart(6, "tr", 18);
    i0.ɵɵelementStart(7, "th", 19);
    i0.ɵɵtext(8, "IP Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 20);
    i0.ɵɵtext(10, "Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th", 21);
    i0.ɵɵtext(12, "Browser");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, LoginHistoryComponent_div_16_tbody_13_Template, 2, 1, "tbody", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, LoginHistoryComponent_div_16_div_14_Template, 4, 3, "div", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("section", "Success Items")("emitSearch", true);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngIf", ctx_r2.temp_success_list);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.temp_success_list !== null && ctx_r2.temp_success_list.length > 0);
} }
const moment$a = moment_;
class LoginHistoryComponent {
    constructor(locationService, dataService, translate) {
        this.locationService = locationService;
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.loginSuccessHistoryList = [];
        this.loginFailureHistoryList = [];
        this.userEmail = "";
        this.customerName = "";
        this.failureItems = null;
        this.temp_failure_list = null;
        this.successItems = null;
        this.temp_success_list = null;
        // Pagination
        this.page = 1;
        this.limit = 10;
        this.countForSuccess = 10;
        this.countForFailure = 10;
        this.showMoreBtnSuccess = false;
        this.showMoreBtnFailure = false;
        this.messageKeys = {};
        this.setFullWidth = () => {
            let appPage = false;
            if (location.pathname.indexOf('/captiveportal/') == -1 && location.pathname.indexOf('/openroaming/') == -1 && location.pathname.indexOf('/iotexplorer/') == -1
                && location.pathname.indexOf('/personas/') == -1 && location.pathname.indexOf('/engagements/') == -1 && location.pathname.indexOf('/right-now') == -1 && location.pathname.indexOf('/location-analytics-v2/') == -1) {
                appPage = false;
            }
            else if (location.pathname.indexOf('/captiveportal/') >= 0) {
                appPage = true;
            }
            else if (location.pathname.indexOf('/openroaming/') >= 0) {
                appPage = true;
            }
            else if (location.pathname.indexOf('/personas/') >= 0) {
                appPage = true;
            }
            else if (location.pathname.indexOf('/iotexplorer/') >= 0) {
                appPage = true;
            }
            else if (location.pathname.indexOf('/engagements/') >= 0) {
                appPage = true;
            }
            else if (location.pathname.indexOf('/iotexplorer/') >= 0) {
                appPage = true;
            }
            else if (location.pathname.indexOf('/right-now') >= 0) {
                appPage = true;
            }
            else if (location.pathname.indexOf('/location-analytics-v2/') >= 0) {
                appPage = true;
            }
            if (!appPage) {
                $('#right80').addClass('showFullPage');
                $('#left20').hide();
            }
        };
        this.getSuccessLoginHistory = () => {
            this.dataService.display(true);
            this.locationService
                .getSuccessLoginHistory()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status && response.data.loginHistory) {
                    this.loginSuccessHistoryList =
                        response.data.loginHistory;
                    if (this.loginSuccessHistoryList &&
                        this.loginSuccessHistoryList.length > 0) {
                        const lastLoginVal = this.loginSuccessHistoryList[0].lastLogin;
                        this.lastLoginDate = moment$a
                            .utc(lastLoginVal)
                            .local()
                            .format("Do MMM YYYY, hh:mm A");
                        // Convert all last login values
                        this.loginSuccessHistoryList.forEach((loginHistory) => {
                            const lastLoginVal1 = loginHistory.lastLogin;
                            loginHistory.lastLogin = moment$a
                                .utc(lastLoginVal1)
                                .local()
                                .format("Do MMM YYYY, hh:mm A");
                        });
                    }
                    this.initiateSuccessList();
                    this.dataService.display(false);
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys[response.message], 4000, null, null, "error");
                }
                this.setFullWidth();
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["loginHistoryError"], 4000, null, null, "error");
            });
        };
        this.getFailureLoginHistory = () => {
            this.dataService.display(true);
            this.locationService
                .getFailureLoginHistory()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status && response.data.loginHistory) {
                    this.loginFailureHistoryList =
                        response.data.loginHistory;
                    if (this.loginFailureHistoryList &&
                        this.loginFailureHistoryList.length > 0) {
                        // Convert all last login values
                        this.loginFailureHistoryList.forEach((loginHistory) => {
                            const lastLoginVal1 = loginHistory.lastLogin;
                            loginHistory.lastLogin = moment$a
                                .utc(lastLoginVal1)
                                .local()
                                .format("Do MMM YYYY, hh:mm A");
                        });
                    }
                    this.initiateFailureList();
                    this.dataService.display(false);
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(this.messageKeys[response.message], 4000, null, null, "error");
                }
                this.setFullWidth();
            }, (error) => {
                this.dataService.display(false);
                this.dataService.setToastMessage(this.messageKeys["loginHistoryError"], 4000, null, null, "error");
            });
        };
        this.onSearchFailStatus = (searchText) => {
            if (searchText !== "") {
                this.failureItems = [];
                const failureList = this.loginFailureHistoryList;
                for (const key in failureList) {
                    if (this.searchInString(searchText, failureList[key].ipAddress, failureList[key].version, failureList[key].deviceType, failureList[key].userAgent, failureList[key].lastLogin)) {
                        if (failureList[key].isHidden === undefined) {
                            this.failureItems.push(failureList[key]);
                        }
                    }
                }
                this.temp_failure_list = this.failureItems;
            }
            else {
                this.temp_failure_list = this.loginFailureHistoryList;
            }
        };
        this.onSearchSuccessStatus = (searchText) => {
            if (searchText !== "") {
                this.successItems = [];
                const successList = this.loginSuccessHistoryList;
                for (const key in successList) {
                    if (this.searchInString(searchText, successList[key].ipAddress, successList[key].version, successList[key].deviceType, successList[key].userAgent, successList[key].lastLogin)) {
                        if (successList[key].isHidden === undefined) {
                            this.successItems.push(successList[key]);
                        }
                    }
                }
                this.temp_success_list = this.successItems;
            }
            else {
                this.temp_success_list = this.loginSuccessHistoryList;
            }
        };
        this.searchInString = (txt, ipAddress, version, deviceType, userAgent, formattedDate) => {
            for (let index = 0; index < ipAddress.length; index++) {
                if (ipAddress.toLowerCase().indexOf(txt) > -1) {
                    return true;
                }
                if (version.toLowerCase().indexOf(txt) > -1) {
                    return true;
                }
                if (deviceType.toLowerCase().indexOf(txt) > -1) {
                    return true;
                }
                if (userAgent.toLowerCase().indexOf(txt) > -1) {
                    return true;
                }
                if (formattedDate.toLowerCase().indexOf(txt) > -1) {
                    return true;
                }
            }
        };
        this.initiateSuccessList = () => {
            if (this.loginSuccessHistoryList &&
                this.loginSuccessHistoryList.length > 0) {
                this.countForSuccess = 10;
                this.temp_success_list = [];
                for (let i = 0; i < this.countForSuccess; i++) {
                    if (this.loginSuccessHistoryList[i] != null) {
                        this.temp_success_list.push(this.loginSuccessHistoryList[i]);
                    }
                }
                this.checkShowMoreForSuccess();
            }
        };
        this.checkShowMoreForSuccess = () => {
            if (this.temp_success_list.length == this.loginSuccessHistoryList.length)
                this.showMoreBtnSuccess = false;
            else
                this.showMoreBtnSuccess = true;
        };
        this.showMoreClickSuccess = () => {
            this.countForSuccess = this.countForSuccess + 10;
            this.temp_success_list = [];
            for (let i = 0; i < this.countForSuccess; i++) {
                if (this.loginSuccessHistoryList[i] != null) {
                    this.temp_success_list.push(this.loginSuccessHistoryList[i]);
                }
            }
            this.checkShowMoreForSuccess();
        };
        this.initiateFailureList = () => {
            if (this.loginFailureHistoryList &&
                this.loginFailureHistoryList.length > 0) {
                this.countForFailure = 10;
                this.temp_failure_list = [];
                for (let i = 0; i < this.countForFailure; i++) {
                    if (this.loginFailureHistoryList[i] != null) {
                        this.temp_failure_list.push(this.loginFailureHistoryList[i]);
                    }
                }
                this.checkShowMoreForFailure();
            }
        };
        this.showMoreClickFailure = () => {
            this.countForFailure = this.countForFailure + 10;
            this.temp_failure_list = [];
            for (let i = 0; i < this.countForFailure; i++) {
                if (this.loginFailureHistoryList[i] != null) {
                    this.temp_failure_list.push(this.loginFailureHistoryList[i]);
                }
            }
            this.checkShowMoreForFailure();
        };
        this.checkShowMoreForFailure = () => {
            if (this.temp_failure_list.length == this.loginFailureHistoryList.length)
                this.showMoreBtnFailure = false;
            else
                this.showMoreBtnFailure = true;
        };
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.user-api-management.login-history.invalid-input').subscribe((res) => {
                this.messageKeys["user.loginhistory.list.input.invalid.error"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.login-history.no-details').subscribe((res) => {
                this.messageKeys["user.loginhistory.list.notavailable.error"] = res;
            });
            this.translate.get('dashboard-lib.user-api-management.login-history.error-occured').subscribe((res) => {
                this.messageKeys["loginHistoryError"] = res;
            });
        };
    }
    ngOnInit() {
        this.setFullWidth();
        this.getSuccessLoginHistory();
        this.getFailureLoginHistory();
        this.userEmail = this.dataService.getUserName();
        this.customerName = this.dataService.getCustomerName();
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
    }
    ngOnDestroy() {
        console.log("destory login history page");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
LoginHistoryComponent.ɵfac = function LoginHistoryComponent_Factory(t) { return new (t || LoginHistoryComponent)(i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
LoginHistoryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoginHistoryComponent, selectors: [["lib-app-login-history"]], decls: 17, vars: 5, consts: [[1, "loginHistoryMainWrapper"], [1, "myAccountLabel"], [1, "loginHistoryWrapper", "boxShadowBlur"], [1, "userDetails"], [1, "divTableLoginHistory"], [1, "divTableCell1LocHistory"], [1, "userProfileIcon_grey"], [1, "divTableCell2LocHistory"], [1, "customerName"], [1, "userName"], ["class", "lastLogin", 4, "ngIf"], ["class", "userTableWrapper", 4, "ngIf"], [1, "lastLogin"], [1, "userTableWrapper"], [1, "loginHeader"], [3, "section", "emitSearch", "searchTextChange"], [1, "table", "userTable"], [1, "table-border"], [1, "rules-list-header"], [1, "h-col-1"], [1, "h-col-2"], [1, "h-col-3"], ["class", "table-border", 4, "ngIf", "ngIfElse"], ["emptyItems", ""], ["class", "show_more_div", 4, "ngIf"], ["class", "tableTr", 4, "ngFor", "ngForOf"], [1, "tableTr"], [1, "userAccess"], ["colspan", "3"], [2, "text-align", "center"], [1, "show_more_div"], [1, "show_count"], ["class", "show-more", "id", "btn-expiry-showmore", 3, "click", 4, "ngIf"], ["id", "btn-expiry-showmore", 1, "show-more", 3, "click"], ["class", "table-border", 4, "ngIf"]], template: function LoginHistoryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2, "My Account");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵtext(8, "\uE930");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 9);
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(14, LoginHistoryComponent_div_14_Template, 2, 1, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, LoginHistoryComponent_div_15_Template, 17, 5, "div", 11);
        i0.ɵɵtemplate(16, LoginHistoryComponent_div_16_Template, 15, 4, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(11);
        i0.ɵɵtextInterpolate(ctx.customerName);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.userEmail);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.loginSuccessHistoryList && ctx.loginSuccessHistoryList.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.loginFailureHistoryList && ctx.loginFailureHistoryList.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.loginSuccessHistoryList && ctx.loginSuccessHistoryList.length > 0);
    } }, directives: [i1$2.NgIf, SearchComponent, i1$2.NgForOf], styles: [".userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:30%;padding-left:15px}.table.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:30%}.circularCheckbox[_ngcontent-%COMP%]{vertical-align:middle;padding-right:15px;display:inline-block}.userDetailLabel[_ngcontent-%COMP%]{display:inline-block}.userNameLink[_ngcontent-%COMP%]{font-size:12px;color:#000;font-family:\"ciscoSansRegular\"}.userListEmail[_ngcontent-%COMP%]{opacity:.8;font-family:\"ciscoSansRegular\";font-size:11px;color:#333;display:block}.userAccess[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.userLocations[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.statusPending[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.confirmResendLink[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";font-size:12px;font-weight:600;color:#049fd9;text-decoration:underline}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%]{text-align:center;display:none}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   div.userActionsMenu[_ngcontent-%COMP%]{display:block}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative;padding:0 10px;text-decoration:none;outline:none}.userEditIcon[_ngcontent-%COMP%]:after{position:absolute;left:100%;height:17px;width:1px;background-color:#c7c7c7;top:0;content:\"\"}.userListLabel[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}.userListName[_ngcontent-%COMP%]{display:block}.userPendingStatus[_ngcontent-%COMP%]{display:block}.width35[_ngcontent-%COMP%]{min-width:35px;display:inline-block;height:20px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0;height:30px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:auto;margin-bottom:0}.warningPopupHeading[_ngcontent-%COMP%]{margin-bottom:15px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{padding:0 20px 20px;border-top:none;position:relative;height:auto}.loginHistoryMainWrapper[_ngcontent-%COMP%]{margin:60px}.myAccountLabel[_ngcontent-%COMP%]{padding:10px 0;font-size:20px;font-family:ciscoSans}.loginHistoryWrapper[_ngcontent-%COMP%]{padding:20px;background-color:#fff}.userDetails[_ngcontent-%COMP%]{padding-bottom:20px;border-bottom:1px solid #eeeeee}.divTableLoginHistory[_ngcontent-%COMP%]{display:table;width:100%;font-size:12px;padding:2% 0}.divTableCell1LocHistory[_ngcontent-%COMP%]{display:table-cell;width:110px;vertical-align:middle}.divTableCell2LocHistory[_ngcontent-%COMP%]   .customerName[_ngcontent-%COMP%]{text-align:left;font-size:16px;font-weight:bold;color:#000;padding-bottom:5px;font-family:ciscoSans}.divTableCell2LocHistory[_ngcontent-%COMP%]   .userName[_ngcontent-%COMP%]{text-align:left;font-weight:bold;color:#000;padding-bottom:5px;font-size:14px;font-family:ciscoSansThin}.divTableCell2LocHistory[_ngcontent-%COMP%]   .lastLogin[_ngcontent-%COMP%]{text-align:left;color:#000;padding-bottom:5px;font-size:12px}.divTableCell2LocHistory[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.userProfileIcon_grey[_ngcontent-%COMP%]{font-size:100px;color:#d8d8d8;margin-bottom:5px;display:inline-block;font-family:icomoon-new}.userTableWrapper[_ngcontent-%COMP%]{padding-top:40px}.loginHeader[_ngcontent-%COMP%]{padding:10px 0;font-size:16px;font-weight:bold}.boxShadowBlur[_ngcontent-%COMP%]{box-shadow:0 0 2px #00000080}.rules-list-header[_ngcontent-%COMP%]{background:#ffffff;border-bottom:1px solid #dddfe2}.table-border[_ngcontent-%COMP%]{box-shadow:0 0 1px #0003}.h-col-1[_ngcontent-%COMP%]{width:25%;padding:0 25px}.h-col-2[_ngcontent-%COMP%]{width:25%}.h-col-3[_ngcontent-%COMP%]{width:25%}.show_more_div[_ngcontent-%COMP%]{display:flex;padding:10px 0 10px 5px}.show_count[_ngcontent-%COMP%]{font-size:12px;color:#000;font-family:\"ciscoSansRegular\"}.show-more[_ngcontent-%COMP%]{color:#049fd9;cursor:pointer;font-size:12px;font-family:\"ciscoSansRegular\";margin-left:40px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginHistoryComponent, [{
        type: Component,
        args: [{
                selector: "lib-app-login-history",
                templateUrl: "./login-history.component.html",
                styleUrls: ["./login-history.component.scss"]
            }]
    }], function () { return [{ type: LocationService }, { type: DataService }, { type: i2.TranslateService }]; }, null); })();

function LocationBetaSwitchComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "span", 8);
    i0.ɵɵlistener("click", function LocationBetaSwitchComponent_div_7_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.closeInfo(); });
    i0.ɵɵtext(5, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 9);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementStart(9, "div", 10);
    i0.ɵɵelementStart(10, "span", 11);
    i0.ɵɵelementStart(11, "input", 12);
    i0.ɵɵlistener("change", function LocationBetaSwitchComponent_div_7_Template_input_change_11_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.hideInfoChecked($event); })("ngModelChange", function LocationBetaSwitchComponent_div_7_Template_input_ngModelChange_11_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.locationViewPreferenceObj.hasViewed = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "label", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 14);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "dashboard-lib.location-details.tryNewLocationHeading"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 6, "dashboard-lib.location-details.tryNewLocationDesc"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r0.locationViewPreferenceObj.hasViewed);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 8, "dashboard-lib.location-details.dontShowAgainLabel"));
} }
const _c0$x = function (a0) { return { "switchon": a0 }; };
const _c1$d = function (a0, a1) { return { "left": a0, "right": a1 }; };
class LocationBetaSwitchComponent {
    constructor(router, dataService, authService, businessHierarchyService) {
        this.router = router;
        this.dataService = dataService;
        this.authService = authService;
        this.businessHierarchyService = businessHierarchyService;
        this.locationViewPreferenceObj = {
            hasViewed: false,
            newLocationView: false
        };
        this.showInfoOnLoad = false;
        this.toggleSwitch = () => {
            // this.locationViewPreferenceObj.hasViewed = true;
            this.locationViewPreferenceObj.newLocationView = !this.locationViewPreferenceObj.newLocationView;
            this.showInfoOnLoad = false;
            this.dataService.display(true);
            this.businessHierarchyService.setLocationViewPreference(this.locationViewPreferenceObj).subscribe(data => {
                if (data.status) {
                    if (this.locationViewPreferenceObj.newLocationView) {
                        this.router.navigate(['/hierarchy/business']);
                    }
                    else {
                        this.router.navigate(['/location']);
                    }
                }
            }, error => {
                this.dataService.setToastMessage("An error occurred while switching UI", 4000, null, null, 'error');
                this.dataService.display(false);
            });
        };
        this.closeInfo = () => {
            this.showInfoOnLoad = false;
        };
        this.hideInfoChecked = (evt) => {
            this.locationViewPreferenceObj.hasViewed = evt.target.checked;
            this.businessHierarchyService.setLocationViewPreference(this.locationViewPreferenceObj).subscribe(data => {
                if (data.status) {
                    console.log('Saved preference');
                }
            }, error => {
                console.log('Error while saving preference');
            });
        };
    }
    ngOnInit() {
        this.businessHierarchyService.getLocationViewPreference().subscribe(data => {
            if (data.status && data.data) {
                this.locationViewPreferenceObj = data.data;
                if (this.locationViewPreferenceObj && this.locationViewPreferenceObj.newLocationView) {
                    this.router.navigate(['/hierarchy/business']);
                }
                else {
                    if (!this.locationViewPreferenceObj.hasViewed)
                        this.showInfoOnLoad = true;
                    else
                        this.showInfoOnLoad = false;
                }
            }
            else {
                // stay here
                this.showInfoOnLoad = false;
            }
        }, error => {
            // stay here
            this.showInfoOnLoad = false;
        });
    }
}
LocationBetaSwitchComponent.ɵfac = function LocationBetaSwitchComponent_Factory(t) { return new (t || LocationBetaSwitchComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(BusinessHierarchyService)); };
LocationBetaSwitchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LocationBetaSwitchComponent, selectors: [["app-location-beta-switch"]], decls: 8, vars: 11, consts: [[1, "beta-switch-box"], [1, "beta-text"], [1, "beta-switch"], [1, "outerblock", 3, "ngClass", "click"], [1, "innerblock", 3, "ngClass"], ["class", "beta-switch-info", 4, "ngIf"], [1, "beta-switch-info"], [1, "switch-info-heading"], [1, "close-info", 3, "click"], [1, "switch-info-desc"], [1, "info-checkbox-wrapper"], [1, "circularCheckbox"], ["type", "checkbox", "id", "info-checkbox", 3, "ngModel", "change", "ngModelChange"], ["for", "info-checkbox", 1, "checkboxLabel"], [1, "checkbox-message"]], template: function LocationBetaSwitchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "span", 0);
        i0.ɵɵelementStart(1, "span", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "span", 2);
        i0.ɵɵelementStart(5, "span", 3);
        i0.ɵɵlistener("click", function LocationBetaSwitchComponent_Template_span_click_5_listener() { return ctx.toggleSwitch(); });
        i0.ɵɵelement(6, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, LocationBetaSwitchComponent_div_7_Template, 16, 10, "div", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "dashboard-lib.location-details.betaSwitchBoxText"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$x, ctx.locationViewPreferenceObj.newLocationView));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c1$d, !ctx.locationViewPreferenceObj.newLocationView, ctx.locationViewPreferenceObj.newLocationView));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showInfoOnLoad);
    } }, directives: [i1$2.NgClass, i1$2.NgIf, i2$1.CheckboxControlValueAccessor, i2$1.NgControlStatus, i2$1.NgModel], pipes: [i2.TranslatePipe], styles: [".beta-switch-box[_ngcontent-%COMP%]{display:inline-block;margin-right:20px;width:150px;position:fixed;top:20px;right:180px;z-index:999}.beta-switch-box[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;margin-left:5px}.beta-switch-box[_ngcontent-%COMP%]   .beta-text[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;line-height:20px;text-align:right;letter-spacing:.5px;color:#000;display:inline-block;vertical-align:middle}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch[_ngcontent-%COMP%]   .outerblock[_ngcontent-%COMP%]{background:#DEDEDE;border-radius:4px;width:36px;height:15px;cursor:pointer;position:relative}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch[_ngcontent-%COMP%]   .outerblock.switchon[_ngcontent-%COMP%]{background:#00A0D1}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch[_ngcontent-%COMP%]   .outerblock[_ngcontent-%COMP%]   .innerblock[_ngcontent-%COMP%]{background:#fff;border-radius:2px;width:16px;height:11px;position:absolute;top:2px}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch[_ngcontent-%COMP%]   .outerblock[_ngcontent-%COMP%]   .innerblock.left[_ngcontent-%COMP%]{left:0px}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch[_ngcontent-%COMP%]   .outerblock[_ngcontent-%COMP%]   .innerblock.right[_ngcontent-%COMP%]{right:1px}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch-info[_ngcontent-%COMP%]{position:absolute;left:0;top:130%;width:330px;height:180px;background:#049FD9;box-shadow:0 4px 8px #0000001a;border-radius:2px;color:#fff;padding:24px;z-index:1}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch-info[_ngcontent-%COMP%]:before{z-index:1;width:0;height:0;border-top:8px solid transparent;border-right:8px solid transparent;border-bottom:8px solid #049FD9;border-left:8px solid transparent;bottom:100%;left:74px;content:\"\";position:absolute}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch-info[_ngcontent-%COMP%]   .switch-info-heading[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:18px;line-height:30px;letter-spacing:.5px;color:#fff}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch-info[_ngcontent-%COMP%]   .switch-info-desc[_ngcontent-%COMP%]{margin:15px 0 0;font-family:CiscoSansLight;font-size:14px;line-height:20px;letter-spacing:.5px;color:#fff}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch-info[_ngcontent-%COMP%]   .info-checkbox-wrapper[_ngcontent-%COMP%]{margin:10px 0}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch-info[_ngcontent-%COMP%]   .info-checkbox-wrapper[_ngcontent-%COMP%]   .circularCheckbox[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch-info[_ngcontent-%COMP%]   .info-checkbox-wrapper[_ngcontent-%COMP%]   .circularCheckbox[_ngcontent-%COMP%]   .checkboxLabel[_ngcontent-%COMP%]{width:16px;height:16px;background:#fff}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch-info[_ngcontent-%COMP%]   .info-checkbox-wrapper[_ngcontent-%COMP%]   .checkbox-message[_ngcontent-%COMP%]{vertical-align:middle;font-size:12px;line-height:20px;padding-left:5px;display:inline-block}.beta-switch-box[_ngcontent-%COMP%]   .beta-switch-info[_ngcontent-%COMP%]   .close-info[_ngcontent-%COMP%]{position:absolute;top:5px;right:5px;font-family:\"icomoon-new\";color:#fff;font-size:9px;line-height:20px;padding:5px;cursor:pointer}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocationBetaSwitchComponent, [{
        type: Component,
        args: [{
                selector: 'app-location-beta-switch',
                templateUrl: './location-beta-switch.component.html',
                styleUrls: ['./location-beta-switch.component.scss']
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: AuthService }, { type: BusinessHierarchyService }]; }, null); })();

function MagneticAppSwitcherComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "mat-dialog-actions");
    i0.ɵɵelementStart(2, "a", 6);
    i0.ɵɵlistener("click", function MagneticAppSwitcherComponent_div_4_Template_a_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const app_r1 = restoredCtx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.tileClicked(app_r1); });
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵelement(4, "img", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 9);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const app_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("mat-dialog-close", ctx_r0.getLocalizationText(app_r1));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("src", "/assets/images/basic/app-switcher/", app_r1.iconName, ".svg", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 3, ctx_r0.getLocalizationText(app_r1)));
} }
const _c0$w = function () { return { "openSearch": true, "showCancel": false }; };
function getBaseUrl$4() {
    return document.getElementsByTagName("base")[0].href;
}
class MagneticAppSwitcherComponent {
    // @Input()
    // selectedApp: { icon: string, name: string } | null = null
    constructor(baseUrl, router, homeService, translate, dataService, data) {
        this.router = router;
        this.homeService = homeService;
        this.translate = translate;
        this.dataService = dataService;
        this.data = data;
        this.unsubscribe$ = new Subject();
        this.baseUrl = "/";
        this.hiddenKeys = [
            "location_analytics_engine",
            "calendar",
            "experience_manager"
        ];
        this.messageKeys = {};
        this.configReady = false;
        this.heightAt = 200;
        this.init = () => {
            this.dataService
                .getTilesData(this.unsubscribe$)
                .subscribe((data) => {
                // this.getLocalizationText(data);
                this.appConfig = data;
                console.log("magnetic app switcher", JSON.stringify(this.appConfig));
                console.log("this.appConfig >>>>", this.appConfig);
                (this.appConfig && this.appConfig.length == 0)
                    ? this.getTileConfig()
                    : this.filterAppConfig("");
            });
            this.currentNav = this.dataService.getCurrentNav();
            if (this.currentNav && this.currentNav[0] != "/") {
                this.currentNav = "/" + this.currentNav;
            }
        };
        this.getTileConfig = () => {
            this.homeService
                .homeTileConfigService()
                .pipe(takeUntil$1(this.unsubscribe$))
                .subscribe((data) => {
                if (data) {
                    const config = data.data;
                    console.log("this.config >>>>", config);
                    this.dataService.setTilesData(config.myApps);
                    // this.filterAppConfig();
                }
            });
        };
        // getLocalizationTextForTiles = (tiles: any) => {
        //   tiles.forEach(tile => {
        //     if (tile.displayTitle.indexOf("dashboard-lib.") == -1)
        //       tile.displayTitle = `dashboard-lib.${tile.displayTitle}`;
        //   });
        // }
        this.getLocalizationText = (tile) => {
            if (tile && tile.displayTitle && tile.displayTitle.indexOf("dashboard-lib.") === -1) {
                return `dashboard-lib.${tile.displayTitle}`;
            }
            else {
                return tile.displayTitle;
            }
        };
        this.calculateClass = (className) => {
            if (className == null) {
                return "cp-rule";
            }
            else {
                const type = className.split("-")[0];
                if (type != "icon") {
                    // to handle for custom images
                }
                else {
                    return className;
                }
            }
        };
        this.tileClicked = ($event) => {
            if ($event.contactSupportPopup || $event.isDisabled) {
                this.dataService.setToastMessage("You do not have access to " +
                    $event.title +
                    " app. Please contact your administrator to request access.", 5000, null, null, "error");
            }
            else if (this.currentNav == $event.contextUrl) {
                this.dataService.setToastMessage("You are already in " + $event.title + " app page", 5000, null, null, "error");
            }
            else if (this.currentNav == "/captiveportal/portal" &&
                $event.contextUrl == "/captiveportal") {
                this.dataService.setToastMessage("You are already in " + $event.title + " app page", 5000, null, null, "error");
            }
            else if ((this.currentNav == "/openroaming/statistics" ||
                this.currentNav == "/openroaming/getstarted") &&
                $event.contextUrl == "/openroaming/statistics") {
                this.dataService.setToastMessage("You are already in " + $event.title + " app page", 5000, null, null, "error");
            }
            else {
                if ($event.isDashboardApp) {
                    // this.emitState.emit(false);
                    this.dataService.display(true);
                    switch ($event.contextUrl) {
                        case "/location-analytics":
                            sessionStorage.removeItem("analyticsFilter");
                            break;
                        case "/business":
                            localStorage.removeItem("spacesObj");
                            break;
                        case "/rules/engagement":
                        case "/rules/profile":
                        case "/apps":
                            break;
                    }
                    let urlValue;
                    if ($event.contextUrl === "/captiveportalapp/portal") {
                        urlValue = "/captiveportal";
                    }
                    else {
                        urlValue = $event.contextUrl;
                    }
                    this.dataService.setCurrentNav(urlValue);
                    window.history.pushState({}, $event.title, this.baseUrl + urlValue);
                    this.router.navigateByUrl(urlValue);
                    this.dataService.setMagneticMenu([]);
                }
                else {
                    if ($event.contextUrl) {
                        setTimeout(() => {
                            const getUrl = window.location;
                            window.location.href =
                                getUrl.protocol +
                                    "//" +
                                    getUrl.host +
                                    $event.contextUrl;
                        }, 5);
                    }
                    else {
                        console.log("Context url is not found. Please contact support to access this app.", $event.title);
                        this.dataService.setToastMessage("Please contact support to access " +
                            $event.title +
                            " app.", 5000, null, null, "error");
                    }
                }
            }
        };
        this.getStaticText = () => {
            // // business_insights starts
            // this.translate.get('dashboard-lib.homepage.tiles.business_insights.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.business_insights.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.business_insights.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.business_insights.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.business_insights.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.business_insights.footer.main.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.business_insights.footer.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.business_insights.footer.sub.title"] = res;
            // });
            // // business_insights starts
            // // right_now starts
            // this.translate.get('dashboard-lib.homepage.tiles.right_now.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.right_now.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.right_now.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.right_now.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.right_now.upgradelicense.license').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.right_now.upgradelicense.license"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.right_now.upgradelicense.footertext').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.right_now.upgradelicense.footertext"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.right_now.upgradelicense.features.densityrule.displayTitle').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.right_now.upgradelicense.features.densityrule.displayTitle"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.right_now.upgradelicense.features.densityrule.desc').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.right_now.upgradelicense.features.densityrule.desc"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.right_now.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.right_now.footer.main.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.right_now.footer.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.right_now.footer.sub.title"] = res;
            // });
            // // right_now starts
            // // camera_metrics starts
            // this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.camera_metrics.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.camera_metrics.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.tilecap.bannerdisplaytext').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.camera_metrics.tilecap.bannerdisplaytext"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.camera_metrics.footer.main.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.footer.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.camera_metrics.footer.sub.title"] = res;
            // });
            // // camera_metrics starts
            // // open_roaming starts
            // this.translate.get('dashboard-lib.homepage.tiles.open_roaming.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.open_roaming.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.open_roaming.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.open_roaming.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradelicense.license').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.open_roaming.upgradelicense.license"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradelicense.footertext').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.open_roaming.upgradelicense.footertext"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradelicense.features.orsdk.displayTitle').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.open_roaming.upgradelicense.features.orsdk.displayTitle"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradelicense.features.orsdk.desc').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.open_roaming.upgradelicense.features.orsdk.desc"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradeextlicense.license').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.open_roaming.upgradeextlicense.license"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradeextlicense.footertext').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.open_roaming.upgradeextlicense.footertext"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradeextlicense.features.carrier-offloading.displayTitle').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.open_roaming.upgradeextlicense.features.carrier-offloading.displayTitle"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradeextlicense.features.carrier-offloading.desc').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.open_roaming.upgradeextlicense.features.carrier-offloading.desc"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.open_roaming.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.open_roaming.footer.main.title"] = res;
            // });
            // // open_roaming starts
            // // location_analytics starts
            // this.translate.get('dashboard-lib.homepage.tiles.location_analytics.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.location_analytics.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.location_analytics.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.location_analytics.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.location_analytics.upgradelicense.license').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.location_analytics.upgradelicense.license"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.location_analytics.upgradelicense.footertext').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.location_analytics.upgradelicense.footertext"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.location_analytics.upgradelicense.features.floors.displayTitle').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.location_analytics.upgradelicense.features.floors.displayTitle"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.location_analytics.upgradelicense.features.floors.desc').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.location_analytics.upgradelicense.features.floors.desc"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.location_analytics.tilecap.bannerdisplaytext').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.location_analytics.tilecap.bannerdisplaytext"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.location_analytics.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.location_analytics.footer.main.title"] = res;
            // });
            // // location_analytics starts
            // // detect_locate starts
            // this.translate.get('dashboard-lib.homepage.tiles.detect_locate.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.detect_locate.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.detect_locate.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.detect_locate.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.detect_locate.upgradelicense.license').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.detect_locate.upgradelicense.license"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.detect_locate.upgradelicense.footertext').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.detect_locate.upgradelicense.footertext"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.detect_locate.upgradelicense.features.floors.displayTitle').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.detect_locate.upgradelicense.features.floors.displayTitle"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.detect_locate.upgradelicense.features.floors.desc').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.detect_locate.upgradelicense.features.floors.desc"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.detect_locate.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.detect_locate.footer.main.title"] = res;
            // });
            // // detect_locate starts
            // // impact_analysis starts
            // this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.impact_analysis.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.impact_analysis.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.tilecap.subtitle').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.impact_analysis.tilecap.subtitle"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.tilecap.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.impact_analysis.tilecap.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.impact_analysis.footer.main.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.footer.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.impact_analysis.footer.sub.title"] = res;
            // });
            // // impact_analysis starts
            // // captive_portal starts
            // this.translate.get('dashboard-lib.homepage.tiles.captive_portal.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.captive_portal.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.captive_portal.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.captive_portal.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.captive_portal.tilecap.subtitle').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.captive_portal.tilecap.subtitle"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.captive_portal.tilecap.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.captive_portal.tilecap.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.captive_portal.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.captive_portal.footer.main.title"] = res;
            // });
            // // captive_portal starts
            // // engagements starts
            // this.translate.get('dashboard-lib.homepage.tiles.engagements.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.engagements.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.engagements.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.engagements.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.engagements.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.engagements.footer.main.title"] = res;
            // });
            // // engagements starts
            // // profile_rules starts
            // this.translate.get('dashboard-lib.homepage.tiles.profile_rules.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.profile_rules.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.profile_rules.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.profile_rules.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.profile_rules.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.profile_rules.footer.main.title"] = res;
            // });
            // // profile_rules starts
            // // operational_insights starts
            // this.translate.get('dashboard-lib.homepage.tiles.operational_insights.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.operational_insights.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.operational_insights.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.operational_insights.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.operational_insights.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.operational_insights.footer.main.title"] = res;
            // });
            // // operational_insights ends
            // // iot_explorer starts
            // this.translate.get('dashboard-lib.homepage.tiles.iot_explorer.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.iot_explorer.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.iot_explorer.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.iot_explorer.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.iot_explorer.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.iot_explorer.footer.main.title"] = res;
            // });
            // // iot_explorer ends
            // // calendar starts
            // this.translate.get('dashboard-lib.homepage.tiles.calendar.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.calendar.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.calendar.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.calendar.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.calendar.footer.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.calendar.footer.sub.title"] = res;
            // });
            // // calendar ends
            // // experience_manager starts
            // this.translate.get('dashboard-lib.homepage.tiles.experience_manager.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.experience_manager.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.experience_manager.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.experience_manager.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.experience_manager.footer.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.experience_manager.footer.sub.title"] = res;
            // });
            // // experience_manager ends
            // // location_analytics_engine starts
            // this.translate.get('dashboard-lib.homepage.tiles.location_analytics_engine.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.location_analytics_engine.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.location_analytics_engine.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.location_analytics_engine.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.location_analytics_engine.tilecap.bannerdisplaytext').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.location_analytics_engine.tilecap.bannerdisplaytext"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.location_analytics_engine.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.location_analytics_engine.footer.main.title"] = res;
            // });
            // // location_analytics_engine ends
            // // proximity_tracing starts
            // this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.proximity_tracing.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.proximity_tracing.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.tilecap.subtitle').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.proximity_tracing.tilecap.subtitle"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.tilecap.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.proximity_tracing.tilecap.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.proximity_tracing.footer.main.title"] = res;
            // });
            // // proximity_tracing ends
            // // device_market_place starts
            // this.translate.get('dashboard-lib.homepage.tiles.device_market_place.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.device_market_place.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.device_market_place.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.device_market_place.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.device_market_place.tilecap.bannerdisplaytext').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.device_market_place.tilecap.bannerdisplaytext"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.device_market_place.footer.main.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.device_market_place.footer.main.title"] = res;
            // });
            // // device_market_place ends
            // // partner_apps starts
            // this.translate.get('dashboard-lib.homepage.tiles.partner_apps.display.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.partner_apps.display.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.partner_apps.sub.title').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.partner_apps.sub.title"] = res;
            // });
            // this.translate.get('dashboard-lib.homepage.tiles.partner_apps.tilecap.bannerdisplaytext').subscribe((res: string) => {
            // 	this.messageKeys["homepage.tiles.partner_apps.tilecap.bannerdisplaytext"] = res;
            // });
            // // partner_apps ends
        };
        this.filterAppConfig = (customSearchText) => {
            const that = this;
            console.log(">>>>>>>>>>>>>>>>>>>customSearchText>>>>>>>>>", customSearchText);
            let initialItem = {
                "key": "dashboard",
                "iconName": 'dashboard',
                "title": "Dashboard",
                "displayTitle": "homepage.tiles.dashboard.display.title",
                'contextUrl': '/base'
            };
            that.appConfigDisplay = Object.assign([], that.appConfig.filter((e) => {
                const shouldHide = that.hiddenKeys.indexOf(e.key) === -1;
                const isSelectedApp = that.data.selectedApp !== null && that.data.selectedApp.name === e.name;
                const matchSearch = customSearchText === null || customSearchText === "" ||
                    (customSearchText !== null && customSearchText !== "" && e.title.toLowerCase().includes(customSearchText.toLowerCase().trim()));
                return shouldHide && !isSelectedApp && matchSearch;
            }));
            if (!this.data.isRootLayout) {
                that.appConfigDisplay.splice(0, 0, initialItem);
            }
            that.configReady = true;
        };
        this.onSearchTextChangeEmit = ($event) => {
            const searchText = $event;
            console.log(">>>>>>>>>>>>>>>>>>>searchText>>>>>>>>>", searchText);
            // if (searchText && searchText.length > 2)
            // this.customSearchText = searchText;
            this.filterAppConfig(searchText);
            // else
            //     this.customSearchText = "";
        };
        console.log("MagneticAppSwitcherComponent::constructor");
        this.baseUrl = baseUrl;
    }
    ngOnInit() {
        this.getStaticText();
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
        this.init();
        // setTimeout(() => {
        //   console.log("this.appConfig >>>>", this.appConfig)
        //   if (!this.appConfig || this.appConfig.length === 0 || !this.data.isRootLayout) {
        //     this.getTileConfig()
        //   }
        // }, 1000);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        // this.mobileQuery.removeListener(this._mobileQueryListener);
        console.log("destory Magnetic app Switcher");
    }
}
MagneticAppSwitcherComponent.ɵfac = function MagneticAppSwitcherComponent_Factory(t) { return new (t || MagneticAppSwitcherComponent)(i0.ɵɵdirectiveInject("BASE_URL"), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(HomeService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
MagneticAppSwitcherComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MagneticAppSwitcherComponent, selectors: [["app-magnetic-app-switcher"]], features: [i0.ɵɵProvidersFeature([
            { provide: "BASE_URL", useFactory: getBaseUrl$4 }
        ])], decls: 5, vars: 7, consts: [[1, "nav-app-sel"], [1, "menu-app-sel"], [1, "mag-menu-app-search"], [3, "section", "emitSearch", "options", "searchTextChange"], ["class", "magnetic-side-nav-list", 4, "ngFor", "ngForOf"], [1, "magnetic-side-nav-list"], [1, "mat-app-list-item-a", 3, "mat-dialog-close", "click"], [1, "nav-icon"], ["width", "50", 3, "src"], [1, "nav-label"]], template: function MagneticAppSwitcherComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-dialog-content", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "lib-app-search", 3);
        i0.ɵɵlistener("searchTextChange", function MagneticAppSwitcherComponent_Template_lib_app_search_searchTextChange_3_listener($event) { return ctx.onSearchTextChangeEmit($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, MagneticAppSwitcherComponent_div_4_Template, 8, 5, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("height", ctx.data.heightAt, "px");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("section", "Apps")("emitSearch", true)("options", i0.ɵɵpureFunction0(6, _c0$w));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.appConfigDisplay);
    } }, directives: [i4$2.MatDialogContent, SearchComponent, i1$2.NgForOf, i4$2.MatDialogActions, i4$2.MatDialogClose], pipes: [i2.TranslatePipe], styles: [".magnetic-side-nav-item-sel[_ngcontent-%COMP%]{background:rgba(224,224,224,.6);border-radius:8px;width:-webkit-fill-available}.nav-app-sel[_ngcontent-%COMP%]   .mat-list-item-a[_ngcontent-%COMP%]{height:40px;margin:0 12px;transition:margin .6s cubic-bezier(.7,0,.3,1),opacity .6s cubic-bezier(.7,0,.3,1);width:-webkit-fill-available!important}.nav-app-sel[_ngcontent-%COMP%]   .mat-list-item-a[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]{width:2vw;text-align:center;display:inline-block}.nav-app-sel[_ngcontent-%COMP%]   .mat-list-item-a[_ngcontent-%COMP%]   .nav-label[_ngcontent-%COMP%]{margin-left:1vw;font-family:\"Inter\";font-style:normal;font-weight:600;font-size:.81vw;line-height:4vw;color:#464c54;flex:none;order:0;flex-grow:1}.nav-app-sel[_ngcontent-%COMP%]   .mat-list-item-a[_ngcontent-%COMP%]   .arrow-down[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;padding:20px;background:url(/assets/images/magnetic/menu/arrow_down.svg);background-position:center;width:16px;height:16px;background-repeat:no-repeat;cursor:pointer;position:relative;flex:none;order:1;flex-grow:0}.nav-app-sel[_ngcontent-%COMP%]   .mat-list-item-a[_ngcontent-%COMP%]   .arrow-up[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;padding:20px;background:url(/assets/images/magnetic/menu/arrow_up.svg);background-position:center;width:16px;height:16px;background-repeat:no-repeat;cursor:pointer;position:relative;flex:none;order:1;flex-grow:0}.nav-app-sel[_ngcontent-%COMP%]   .menu-app-sel[_ngcontent-%COMP%]{width:257px;position:absolute;display:inline-grid;padding:15px 0 5px;z-index:1;filter:drop-shadow(0px 4px 12px rgba(0,0,0,.12));border-radius:8px;background:#FFFFFF;overflow:hidden;overflow-y:auto;align-content:flex-start;left:5px}.nav-app-sel[_ngcontent-%COMP%]   .menu-app-sel[_ngcontent-%COMP%]   .mag-menu-app-search[_ngcontent-%COMP%]{margin:0 10px;padding:0 10px;line-height:30px;height:34px;background:#FFFFFF;border:2px solid #889099;border-radius:6px;box-sizing:border-box;overflow:hidden}.nav-app-sel[_ngcontent-%COMP%]   .menu-app-sel[_ngcontent-%COMP%]   .magnetic-side-nav-list[_ngcontent-%COMP%]{display:flex;padding:4px 10px;height:40px!important;border-radius:6px;align-self:stretch}.nav-app-sel[_ngcontent-%COMP%]   .menu-app-sel[_ngcontent-%COMP%]   .magnetic-side-nav-list[_ngcontent-%COMP%]   .mat-app-list-item-a[_ngcontent-%COMP%]{margin:0 12px;transition:margin .6s cubic-bezier(.7,0,.3,1),opacity .6s cubic-bezier(.7,0,.3,1);width:-webkit-fill-available;cursor:pointer}.nav-app-sel[_ngcontent-%COMP%]   .menu-app-sel[_ngcontent-%COMP%]   .magnetic-side-nav-list[_ngcontent-%COMP%]   .mat-app-list-item-a[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]{width:2vw;text-align:center;display:inline-block}.nav-app-sel[_ngcontent-%COMP%]   .menu-app-sel[_ngcontent-%COMP%]   .magnetic-side-nav-list[_ngcontent-%COMP%]   .mat-app-list-item-a[_ngcontent-%COMP%]   .nav-label[_ngcontent-%COMP%]{margin-left:1vw;font-family:\"Inter\";font-style:normal;font-weight:600;font-size:12px;color:#464c54;flex:none;order:0;flex-grow:1}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MagneticAppSwitcherComponent, [{
        type: Component,
        args: [{
                selector: "app-magnetic-app-switcher",
                templateUrl: "./magnetic-app-switcher.component.html",
                providers: [
                    { provide: "BASE_URL", useFactory: getBaseUrl$4 }
                ],
                styleUrls: ["./magnetic-app-switcher.component.scss"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ["BASE_URL"]
            }] }, { type: i1.Router }, { type: HomeService }, { type: i2.TranslateService }, { type: DataService }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

const _c0$v = function (a0, a1) { return { "arrow-down": a0, "arrow-up": a1 }; };
function MagneticAppSelectionComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("display", ctx_r0.isAppExpanded ? "inline-block" : "none");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c0$v, !ctx_r0.isAppSelectExpanded, ctx_r0.isAppSelectExpanded));
} }
class MagneticAppSelectionComponent {
    constructor(router, authService, dialog, translate, dataService) {
        this.router = router;
        this.authService = authService;
        this.dialog = dialog;
        this.translate = translate;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.hiddenKeys = [
            "location_analytics_engine",
            "calendar",
            "experience_manager"
        ];
        this.messageKeys = {};
        this.configReady = false;
        this.selectedApp = null;
        this.isAppExpanded = true;
        this.isRootLayout = false;
        this.isAppSelectExpanded = false;
        this.isDashboardUser = false;
        this.init = () => {
            this.dataService
                .getTilesData(this.unsubscribe$)
                .subscribe((data) => {
                this.getLocalizationText(data);
                this.appConfig = data;
                console.log("magnetic app selection", JSON.stringify(this.appConfig));
                // (this.appConfig && this.appConfig.length == 0)
                // 	? this.getTileConfig()
                // 	: this.filterAppConfig("");
                this.filterAppConfig("");
            });
            this.getUserRole();
            this.currentNav = this.dataService.getCurrentNav();
            if (this.currentNav && this.currentNav[0] != "/") {
                this.currentNav = "/" + this.currentNav;
            }
        };
        this.getUserRole = () => {
            this.authService.getRole(this.unsubscribe$).subscribe((roleBehavior) => {
                if (roleBehavior && roleBehavior.appRole) {
                    this.isDashboardUser = this.dataService.getIsDashboardUser();
                }
                else {
                    this.isDashboardUser = false;
                }
            }, (error) => {
                console.log(error);
            });
        };
        // getTileConfig = () => {
        // 	this.homeService
        // 		.homeTileConfigService()
        // 		.pipe(takeUntil(this.unsubscribe$))
        // 		.subscribe(
        // 			(data: any) => {
        // 				if (data) {
        // 					const config = data.data;
        // 					this.dataService.setTilesData(config.myApps);
        // 					this.filterAppConfig();
        // 				}
        // 			}
        // 		);
        // };
        // getLocalizationText = (tiles: any) => {
        //   tiles.forEach(tile => {
        //     tile.displayTitle = this.messageKeys[`homepage.tiles.${tile['key']}.display.title`];
        //   });
        // }
        this.getLocalizationText = (tile) => {
            if (tile && tile.displayTitle && tile.displayTitle.indexOf("dashboard-lib.") === -1) {
                return `dashboard-lib.${tile.displayTitle}`;
            }
            else {
                return tile.displayTitle;
            }
        };
        this.calculateClass = (className) => {
            // if (className == null) {
            // 	return "cp-rule";
            // } else {
            const type = className.split("-")[0];
            switch (type) {
                case "icon":
                    return className;
                case "app":
                    let cssClassName = className.replace('app-', '');
                    return cssClassName;
                default:
                    return className;
            }
            // if (type != "icon") {
            // 	// to handle for custom images
            // } else {
            // 	return className;
            // }
            // }
        };
        this.tileClicked = ($event) => {
            if ($event.contactSupportPopup || $event.isDisabled) {
                this.dataService.setToastMessage("You do not have access to " +
                    $event.title +
                    " app. Please contact your administrator to request access.", 5000, null, null, "error");
            }
            else if (this.currentNav == $event.contextUrl) {
                this.dataService.setToastMessage("You are already in " + $event.title + " app page", 5000, null, null, "error");
            }
            else if (this.currentNav == "/captiveportal/portal" &&
                $event.contextUrl == "/captiveportal") {
                this.dataService.setToastMessage("You are already in " + $event.title + " app page", 5000, null, null, "error");
            }
            else if ((this.currentNav == "/openroaming/statistics" ||
                this.currentNav == "/openroaming/getstarted") &&
                $event.contextUrl == "/openroaming/statistics") {
                this.dataService.setToastMessage("You are already in " + $event.title + " app page", 5000, null, null, "error");
            }
            else {
                if ($event.isDashboardApp) {
                    // this.emitState.emit(false);
                    this.dataService.display(true);
                    switch ($event.contextUrl) {
                        case "/location-analytics":
                            sessionStorage.removeItem("analyticsFilter");
                            break;
                        case "/business":
                            localStorage.removeItem("spacesObj");
                            break;
                        case "/rules/engagement":
                        case "/rules/profile":
                        case "/apps":
                            break;
                    }
                    let urlValue;
                    if ($event.contextUrl === "/captiveportalapp/portal") {
                        urlValue = "/captiveportal";
                    }
                    else {
                        urlValue = $event.contextUrl;
                    }
                    this.dataService.setCurrentNav(urlValue);
                    this.router.navigate([urlValue]);
                }
                else {
                    if ($event.contextUrl) {
                        setTimeout(() => {
                            const getUrl = window.location;
                            window.location.href =
                                getUrl.protocol +
                                    "//" +
                                    getUrl.host +
                                    $event.contextUrl;
                        }, 5);
                    }
                    else {
                        console.log("Context url is not found. Please contact support to access this app.", $event.title);
                        this.dataService.setToastMessage("Please contact support to access " +
                            $event.title +
                            " app.", 5000, null, null, "error");
                    }
                }
            }
        };
        this.getStaticText = () => {
            // business_insights starts
            this.translate.get('dashboard-lib.homepage.tiles.business_insights.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.business_insights.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.business_insights.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.business_insights.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.business_insights.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.business_insights.footer.main.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.business_insights.footer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.business_insights.footer.sub.title"] = res;
            });
            // business_insights starts
            // right_now starts
            this.translate.get('dashboard-lib.homepage.tiles.right_now.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.upgradelicense.license').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.upgradelicense.license"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.upgradelicense.footertext').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.upgradelicense.footertext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.upgradelicense.features.densityrule.displayTitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.upgradelicense.features.densityrule.displayTitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.upgradelicense.features.densityrule.desc').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.upgradelicense.features.densityrule.desc"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.footer.main.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.right_now.footer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.right_now.footer.sub.title"] = res;
            });
            // right_now starts
            // camera_metrics starts
            this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.camera_metrics.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.camera_metrics.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.tilecap.bannerdisplaytext').subscribe((res) => {
                this.messageKeys["homepage.tiles.camera_metrics.tilecap.bannerdisplaytext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.camera_metrics.footer.main.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.camera_metrics.footer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.camera_metrics.footer.sub.title"] = res;
            });
            // camera_metrics starts
            // open_roaming starts
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradelicense.license').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradelicense.license"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradelicense.footertext').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradelicense.footertext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradelicense.features.orsdk.displayTitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradelicense.features.orsdk.displayTitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradelicense.features.orsdk.desc').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradelicense.features.orsdk.desc"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradeextlicense.license').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradeextlicense.license"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradeextlicense.footertext').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradeextlicense.footertext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradeextlicense.features.carrier-offloading.displayTitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradeextlicense.features.carrier-offloading.displayTitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.upgradeextlicense.features.carrier-offloading.desc').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.upgradeextlicense.features.carrier-offloading.desc"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.open_roaming.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.open_roaming.footer.main.title"] = res;
            });
            // open_roaming starts
            // location_analytics starts
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.upgradelicense.license').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.upgradelicense.license"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.upgradelicense.footertext').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.upgradelicense.footertext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.upgradelicense.features.floors.displayTitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.upgradelicense.features.floors.displayTitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.upgradelicense.features.floors.desc').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.upgradelicense.features.floors.desc"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.tilecap.bannerdisplaytext').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.tilecap.bannerdisplaytext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics.footer.main.title"] = res;
            });
            // location_analytics starts
            // detect_locate starts
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.upgradelicense.license').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.upgradelicense.license"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.upgradelicense.footertext').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.upgradelicense.footertext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.upgradelicense.features.floors.displayTitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.upgradelicense.features.floors.displayTitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.upgradelicense.features.floors.desc').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.upgradelicense.features.floors.desc"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.detect_locate.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.detect_locate.footer.main.title"] = res;
            });
            // detect_locate starts
            // impact_analysis starts
            this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.impact_analysis.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.impact_analysis.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.tilecap.subtitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.impact_analysis.tilecap.subtitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.tilecap.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.impact_analysis.tilecap.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.impact_analysis.footer.main.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.impact_analysis.footer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.impact_analysis.footer.sub.title"] = res;
            });
            // impact_analysis starts
            // captive_portal starts
            this.translate.get('dashboard-lib.homepage.tiles.captive_portal.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.captive_portal.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.captive_portal.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.captive_portal.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.captive_portal.tilecap.subtitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.captive_portal.tilecap.subtitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.captive_portal.tilecap.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.captive_portal.tilecap.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.captive_portal.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.captive_portal.footer.main.title"] = res;
            });
            // captive_portal starts
            // engagements starts
            this.translate.get('dashboard-lib.homepage.tiles.engagements.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.engagements.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.engagements.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.engagements.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.engagements.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.engagements.footer.main.title"] = res;
            });
            // engagements starts
            // profile_rules starts
            this.translate.get('dashboard-lib.homepage.tiles.profile_rules.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.profile_rules.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.profile_rules.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.profile_rules.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.profile_rules.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.profile_rules.footer.main.title"] = res;
            });
            // profile_rules starts
            // operational_insights starts
            this.translate.get('dashboard-lib.homepage.tiles.operational_insights.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.operational_insights.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.operational_insights.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.operational_insights.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.operational_insights.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.operational_insights.footer.main.title"] = res;
            });
            // operational_insights ends
            // iot_explorer starts
            this.translate.get('dashboard-lib.homepage.tiles.iot_explorer.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.iot_explorer.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.iot_explorer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.iot_explorer.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.iot_explorer.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.iot_explorer.footer.main.title"] = res;
            });
            // iot_explorer ends
            // calendar starts
            this.translate.get('dashboard-lib.homepage.tiles.calendar.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.calendar.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.calendar.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.calendar.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.calendar.footer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.calendar.footer.sub.title"] = res;
            });
            // calendar ends
            // experience_manager starts
            this.translate.get('dashboard-lib.homepage.tiles.experience_manager.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.experience_manager.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.experience_manager.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.experience_manager.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.experience_manager.footer.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.experience_manager.footer.sub.title"] = res;
            });
            // experience_manager ends
            // location_analytics_engine starts
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics_engine.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics_engine.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics_engine.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics_engine.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics_engine.tilecap.bannerdisplaytext').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics_engine.tilecap.bannerdisplaytext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.location_analytics_engine.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.location_analytics_engine.footer.main.title"] = res;
            });
            // location_analytics_engine ends
            // proximity_tracing starts
            this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.proximity_tracing.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.proximity_tracing.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.tilecap.subtitle').subscribe((res) => {
                this.messageKeys["homepage.tiles.proximity_tracing.tilecap.subtitle"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.tilecap.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.proximity_tracing.tilecap.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.proximity_tracing.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.proximity_tracing.footer.main.title"] = res;
            });
            // proximity_tracing ends
            // device_market_place starts
            this.translate.get('dashboard-lib.homepage.tiles.device_market_place.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.device_market_place.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.device_market_place.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.device_market_place.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.device_market_place.tilecap.bannerdisplaytext').subscribe((res) => {
                this.messageKeys["homepage.tiles.device_market_place.tilecap.bannerdisplaytext"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.device_market_place.footer.main.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.device_market_place.footer.main.title"] = res;
            });
            // device_market_place ends
            // partner_apps starts
            this.translate.get('dashboard-lib.homepage.tiles.partner_apps.display.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.partner_apps.display.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.partner_apps.sub.title').subscribe((res) => {
                this.messageKeys["homepage.tiles.partner_apps.sub.title"] = res;
            });
            this.translate.get('dashboard-lib.homepage.tiles.partner_apps.tilecap.bannerdisplaytext').subscribe((res) => {
                this.messageKeys["homepage.tiles.partner_apps.tilecap.bannerdisplaytext"] = res;
            });
            // partner_apps ends
        };
        this.filterAppConfig = (customSearchText) => {
            const that = this;
            console.log(">>>>>>>>>>>>>>>>>>>customSearchText>>>>>>>>>", customSearchText);
            that.appConfigDisplay = Object.assign([], that.appConfig.filter((e) => {
                const shouldHide = that.hiddenKeys.indexOf(e.key) === -1;
                const isSelectedApp = that.selectedApp !== null && that.selectedApp.name === e.name;
                const matchSearch = customSearchText === null || customSearchText === "" ||
                    (customSearchText !== null && customSearchText !== "" && e.title.toLowerCase().includes(customSearchText.toLowerCase().trim()));
                return shouldHide && !isSelectedApp && matchSearch;
            }));
            that.configReady = true;
        };
        this.onSearchTextChangeEmit = ($event) => {
            const searchText = $event;
            console.log(">>>>>>>>>>>>>>>>>>>searchText>>>>>>>>>", searchText);
            // if (searchText && searchText.length > 2)
            // this.customSearchText = searchText;
            this.filterAppConfig(searchText);
            // else
            //     this.customSearchText = "";
        };
        console.log("MagneticAppSelectionComponent::constructor");
    }
    ngOnInit() {
        this.getStaticText();
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
        this.init();
    }
    openAppSwitcher($event) {
        if (!this.isDashboardUser) {
            return;
        }
        console.log($event.target.getBoundingClientRect());
        let appSelEl = $event.target.getBoundingClientRect();
        console.log('appSelEl', appSelEl);
        const appDialogConfig = new MatDialogConfig();
        appDialogConfig.autoFocus = true;
        const startAt = appSelEl.y + appSelEl.height;
        appDialogConfig.data = {
            isRootLayout: this.isRootLayout,
            selectedApp: this.selectedApp,
            heightAt: (window.innerHeight - startAt)
        };
        appDialogConfig.panelClass = 'app-sel-dialog-container';
        appDialogConfig.position = {
            left: '5',
            top: startAt + "px"
        };
        const dialogRef = this.dialog.open(MagneticAppSwitcherComponent, appDialogConfig);
        this.isAppSelectExpanded = true;
        dialogRef.afterClosed().subscribe(result => {
            console.log(`Dialog result: ${result}`);
            this.isAppSelectExpanded = false;
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        this.dialog.closeAll();
        // this.mobileQuery.removeListener(this._mobileQueryListener);
        console.log("destory Magnetic app");
    }
}
MagneticAppSelectionComponent.ɵfac = function MagneticAppSelectionComponent_Factory(t) { return new (t || MagneticAppSelectionComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(i4$2.MatDialog), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(DataService)); };
MagneticAppSelectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MagneticAppSelectionComponent, selectors: [["app-magnetic-app-selection"]], inputs: { selectedApp: "selectedApp", isAppExpanded: "isAppExpanded", isRootLayout: "isRootLayout" }, decls: 9, vars: 7, consts: [[1, "nav-app-sel"], [1, "magnetic-side-nav-list", 3, "click"], ["mat-list-item", "", 1, "mat-list-item-a", "mat-app-sel-a"], [1, "nav-icon"], ["width", "50", 3, "src"], [1, "nav-label"], [3, "ngClass", "display", 4, "ngIf"], [3, "ngClass"]], template: function MagneticAppSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "mat-nav-list", 1);
        i0.ɵɵlistener("click", function MagneticAppSelectionComponent_Template_mat_nav_list_click_1_listener($event) { return ctx.openAppSwitcher($event); });
        i0.ɵɵelementStart(2, "a", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵelement(4, "img", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "span", 5);
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, MagneticAppSelectionComponent_span_8_Template, 1, 6, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate1("src", "/assets/images/basic/app-switcher/", ctx.selectedApp.icon, ".svg", i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("display", ctx.isAppExpanded ? "inline-block" : "none");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 5, ctx.selectedApp.name));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isDashboardUser);
    } }, directives: [i6.MatNavList, i6.MatListItem, i1$2.NgIf, i1$2.NgClass], pipes: [i2.TranslatePipe], styles: [".magnetic-side-nav-item-sel[_ngcontent-%COMP%]{background:rgba(224,224,224,.6);border-radius:8px;width:-webkit-fill-available}.mat-list-base[_ngcontent-%COMP%]{margin:5px 10px 13px;padding:22px 0}.mat-nav-list[_ngcontent-%COMP%]:first-child{padding-top:24px}.nav-app-sel[_ngcontent-%COMP%]   .mat-list-item-a[_ngcontent-%COMP%]{height:40px;transition:margin .6s cubic-bezier(.7,0,.3,1),opacity .6s cubic-bezier(.7,0,.3,1);width:-webkit-fill-available!important;padding:0 6px}.nav-app-sel[_ngcontent-%COMP%]   .mat-list-item-a[_ngcontent-%COMP%]   .dashboard-icon[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;background:url(/assets/images/magnetic/app/dashboard.svg);background-position:center;width:24px;height:24px;background-repeat:no-repeat;cursor:pointer;position:relative;flex:none;order:1;flex-grow:0}.nav-app-sel[_ngcontent-%COMP%]   .mat-list-item-a[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]{width:24px;text-align:center}.nav-app-sel[_ngcontent-%COMP%]   .mat-list-item-a[_ngcontent-%COMP%]   .nav-label[_ngcontent-%COMP%]{margin-left:1vw;font-family:\"Inter\";font-style:normal;font-weight:600;font-size:.81vw;line-height:4vw;color:#464c54;flex:none;order:0;flex-grow:1;white-space:nowrap;text-overflow:ellipsis;width:120px;display:block;overflow:hidden}.nav-app-sel[_ngcontent-%COMP%]   .mat-list-item-a[_ngcontent-%COMP%]   .arrow-down[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;padding:20px;background:url(/assets/images/magnetic/menu/arrow_down.svg);background-position:center;width:16px;height:16px;background-repeat:no-repeat;cursor:pointer;position:relative;flex:none;order:1;flex-grow:0}.nav-app-sel[_ngcontent-%COMP%]   .mat-list-item-a[_ngcontent-%COMP%]   .arrow-up[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;padding:20px;background:url(/assets/images/magnetic/menu/arrow_up.svg);background-position:center;width:16px;height:16px;background-repeat:no-repeat;cursor:pointer;position:relative;flex:none;order:1;flex-grow:0}.nav-app-sel[_ngcontent-%COMP%]   .menu-app-sel[_ngcontent-%COMP%]{position:absolute;display:inline-grid;padding:15px 0 5px;z-index:1;filter:drop-shadow(0px 4px 12px rgba(0,0,0,.12));border-radius:8px;background:#FFFFFF;min-height:min-content;overflow:hidden;width:-webkit-fill-available}.nav-app-sel[_ngcontent-%COMP%]   .menu-app-sel[_ngcontent-%COMP%]   .mag-menu-app-search[_ngcontent-%COMP%]{margin:0 10px 10px;padding:8px 10px;line-height:27px;height:45px;background:#FFFFFF;border:2px solid #889099;border-radius:6px;box-sizing:border-box}.nav-app-sel[_ngcontent-%COMP%]   .menu-app-sel[_ngcontent-%COMP%]   .magnetic-side-nav-list[_ngcontent-%COMP%]{display:flex;padding:4px 10px;height:60px;border-radius:6px;align-self:stretch}.nav-app-sel[_ngcontent-%COMP%]   .menu-app-sel[_ngcontent-%COMP%]   .magnetic-side-nav-list[_ngcontent-%COMP%]   .mat-app-list-item-a[_ngcontent-%COMP%]{margin:0 12px;transition:margin .6s cubic-bezier(.7,0,.3,1),opacity .6s cubic-bezier(.7,0,.3,1);width:-webkit-fill-available;cursor:pointer}.nav-app-sel[_ngcontent-%COMP%]   .menu-app-sel[_ngcontent-%COMP%]   .magnetic-side-nav-list[_ngcontent-%COMP%]   .mat-app-list-item-a[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]{width:2vw;text-align:center}.nav-app-sel[_ngcontent-%COMP%]   .menu-app-sel[_ngcontent-%COMP%]   .magnetic-side-nav-list[_ngcontent-%COMP%]   .mat-app-list-item-a[_ngcontent-%COMP%]   .nav-label[_ngcontent-%COMP%]{margin-left:1vw;font-family:\"Inter\";font-style:normal;font-weight:600;font-size:12px;color:#464c54;flex:none;order:0;flex-grow:1}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MagneticAppSelectionComponent, [{
        type: Component,
        args: [{
                selector: "app-magnetic-app-selection",
                templateUrl: "./magnetic-app-selection.component.html",
                styleUrls: ["./magnetic-app-selection.component.scss"]
            }]
    }], function () { return [{ type: i1.Router }, { type: AuthService }, { type: i4$2.MatDialog }, { type: i2.TranslateService }, { type: DataService }]; }, { selectedApp: [{
            type: Input
        }], isAppExpanded: [{
            type: Input
        }], isRootLayout: [{
            type: Input
        }] }); })();

function MagneticLicenseInfoComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared-lib.header-navigation-home.seeLabel"), " ");
} }
function MagneticLicenseInfoComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared-lib.header-navigation-home.actLabel"), " ");
} }
function MagneticLicenseInfoComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared-lib.header-navigation-home.extendLabel"), " ");
} }
function MagneticLicenseInfoComponent_span_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.header-navigation-home.activeUntilLabel"));
} }
function MagneticLicenseInfoComponent_span_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, "shared-lib.header-navigation-home.expiringSoonLabel"), " ");
} }
function MagneticLicenseInfoComponent_span_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, "shared-lib.header-navigation-home.licenseExpiredLabel"), " ");
} }
function MagneticLicenseInfoComponent_div_32_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r10.data.duration.years, " ", ctx_r10.data.duration.years === 1 ? "Year" : "Years", " ");
} }
function MagneticLicenseInfoComponent_div_32_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "&");
    i0.ɵɵelementEnd();
} }
function MagneticLicenseInfoComponent_div_32_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r12.data.duration.months, " ", ctx_r12.data.duration.months === 1 ? "Month" : "Months", " ");
} }
function MagneticLicenseInfoComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelement(1, "img", 23);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtemplate(3, MagneticLicenseInfoComponent_div_32_span_3_Template, 2, 2, "span", 24);
    i0.ɵɵtemplate(4, MagneticLicenseInfoComponent_div_32_span_4_Template, 2, 0, "span", 24);
    i0.ɵɵtemplate(5, MagneticLicenseInfoComponent_div_32_span_5_Template, 2, 2, "span", 24);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r6.data.duration.years !== 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.data.duration.months !== 0 && ctx_r6.data.duration.years > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.data.duration.months !== 0);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 4, "shared-lib.header-navigation-home.licenseLabel"), " ");
} }
function MagneticLicenseInfoComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelement(1, "div", 26);
    i0.ɵɵelementStart(2, "div", 27);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "shared-lib.header-navigation-home.renewLicenseMessageLabel"), " ");
} }
function MagneticLicenseInfoComponent_div_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelement(1, "div", 26);
    i0.ɵɵelementStart(2, "div", 27);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "shared-lib.header-navigation-home.apLimitReachedMessageLabel"), " ");
} }
function MagneticLicenseInfoComponent_div_47_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 30);
    i0.ɵɵelementStart(5, "a", 31);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "shared-lib.header-navigation-home.contactEnquiryLabel"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("href", "mailto:", ctx_r9.supportMail, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r9.supportMail);
} }
const moment$9 = moment_;
class MagneticLicenseInfoComponent {
    constructor(authService, translate, dataService) {
        this.authService = authService;
        this.translate = translate;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.progressBarClass = "p-bar";
        this.isAdminUser = false;
        this.licenseError = false;
        this.licenseInfoVisible = false;
        this.isLicenseInfoReady = false;
        this.messageKeys = {};
        this.init = () => {
            this.getLoginPageLinks();
            this.progressBarClass =
                this.data.warn.apLimit == true ? "p-bar-complete" : "p-bar";
            this.isAdminUser = this.dataService.getIsDashboardAdmin();
            if (!this.isAdminUser) {
                this.dataService
                    .getLicenseDetails(this.unsubscribe$)
                    .subscribe((val) => {
                    if (val.tenantId) {
                        if (moment$9(val.startDate, "YYYY-MM-DDTHH:mm:ss.sssZ", true).isValid()) {
                            val.startDate = String(moment$9(val.startDate).valueOf());
                        }
                        this.licenseInfo = val;
                        this.data = this.getLicenseDates(val);
                        this.isLicenseInfoReady = true;
                    }
                    else {
                        this.isLicenseInfoReady = false;
                    }
                });
            }
        };
        this.getLicenseDates = (data) => {
            // data.licenseDuration = 24;
            // data.consumedAps = 300;
            // data.totalAps = 300;
            const duration = {
                months: null,
                years: null
            };
            const warn = {
                licenseStatus: "active",
                apLimit: false
            };
            const endDate = moment$9(Number(data.startDate)).add(data.licenseDuration, "M");
            const preMonth = moment$9(endDate).subtract(1, "M");
            if (moment$9().isAfter(endDate)) {
                this.licenseError = true;
                warn.licenseStatus = "expired";
            }
            else if (moment$9().isAfter(preMonth)) {
                this.licenseError = true;
                warn.licenseStatus = "soon";
            }
            if (data.consumedAps == data.totalAps) {
                this.licenseError = true;
                warn.apLimit = true;
            }
            const formattedEndDate = moment$9(endDate).format("MMM Do, YYYY");
            if (data.licenseDuration > 11) {
                duration.years = (data.licenseDuration / 12)
                    .toString()
                    .split(".")[0];
                duration.months = Number(Math.round(data.licenseDuration % 12));
            }
            else {
                duration.years = 0;
                duration.months = data.licenseDuration;
            }
            data.endDate = formattedEndDate;
            data.duration = duration;
            data.warn = warn;
            return data;
        };
        this.calculateProgressPercentage = () => {
            this.progressPercentage =
                (this.data.consumedAps / this.data.totalAps) * 100;
        };
        this.getLoginPageLinks = () => {
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$)
                .then((properties) => {
                this.supportMail = properties["value"]["supportMail"];
            });
        };
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-success').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.meraki.success"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-failed').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.meraki.error.failed"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-empty').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.error.input.empty"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-invalid').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.error.input.invalid"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-empty').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.meraki.error.input.empty"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-exists').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.meraki.error.exists"] = res;
            });
        };
        console.log("MagneticLicenseInfoComponent::constructor");
    }
    ngOnInit() {
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
        this.init();
        this.calculateProgressPercentage();
        console.log(this.data);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        console.log("destory Magnetic License Info");
    }
}
MagneticLicenseInfoComponent.ɵfac = function MagneticLicenseInfoComponent_Factory(t) { return new (t || MagneticLicenseInfoComponent)(i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(DataService)); };
MagneticLicenseInfoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MagneticLicenseInfoComponent, selectors: [["app-magnetic-license-info"]], decls: 48, vars: 41, consts: [[1, "mat-typography"], [1, "modalContent"], [1, "modalHeader"], ["mat-dialog-close", "", 1, "modalCloseIcon"], [1, "modalBody"], [1, "blockElement"], [1, "blockHeader"], [1, "blockValue"], [1, "blockElement", "hidden"], ["class", "blockValue", 4, "ngIf"], ["class", "active-indicator", 4, "ngIf"], ["class", "expiry-indicator", 4, "ngIf"], ["class", "expired-indicator", 4, "ngIf"], ["class", "duration-block", 4, "ngIf"], ["class", "notice-block", 4, "ngIf"], [1, "bold-txt"], [3, "value", "showValue", "styleClass"], [1, "modalFooter"], ["class", "support-block", 4, "ngIf"], [1, "active-indicator"], [1, "expiry-indicator"], [1, "expired-indicator"], [1, "duration-block"], ["src", "/assets/cisco/images/dashboard/time_icon.svg", "width", "18"], [4, "ngIf"], [1, "notice-block"], [1, "notice-img"], [1, "notice-msg"], [1, "support-block"], [1, "support-message"], [1, "support-email"], [3, "href"]], template: function MagneticLicenseInfoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-dialog-content", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementStart(5, "mat-dialog-actions");
        i0.ɵɵelementStart(6, "span", 3);
        i0.ɵɵtext(7, "\uE909");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 4);
        i0.ɵɵelementStart(9, "div", 5);
        i0.ɵɵelementStart(10, "div", 6);
        i0.ɵɵtext(11);
        i0.ɵɵpipe(12, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 7);
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 8);
        i0.ɵɵelementStart(16, "div", 6);
        i0.ɵɵtext(17);
        i0.ɵɵpipe(18, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(19, MagneticLicenseInfoComponent_div_19_Template, 3, 3, "div", 9);
        i0.ɵɵtemplate(20, MagneticLicenseInfoComponent_div_20_Template, 3, 3, "div", 9);
        i0.ɵɵtemplate(21, MagneticLicenseInfoComponent_div_21_Template, 3, 3, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 5);
        i0.ɵɵelementStart(23, "div", 6);
        i0.ɵɵtext(24);
        i0.ɵɵpipe(25, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 7);
        i0.ɵɵtemplate(27, MagneticLicenseInfoComponent_span_27_Template, 3, 3, "span", 10);
        i0.ɵɵtemplate(28, MagneticLicenseInfoComponent_span_28_Template, 3, 3, "span", 11);
        i0.ɵɵtemplate(29, MagneticLicenseInfoComponent_span_29_Template, 3, 3, "span", 12);
        i0.ɵɵelementStart(30, "span");
        i0.ɵɵtext(31);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(32, MagneticLicenseInfoComponent_div_32_Template, 8, 6, "div", 13);
        i0.ɵɵtemplate(33, MagneticLicenseInfoComponent_div_33_Template, 5, 3, "div", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "div");
        i0.ɵɵelementStart(35, "div", 6);
        i0.ɵɵtext(36);
        i0.ɵɵpipe(37, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 7);
        i0.ɵɵelementStart(39, "span", 15);
        i0.ɵɵtext(40);
        i0.ɵɵelementEnd();
        i0.ɵɵtext(41);
        i0.ɵɵpipe(42, "translate");
        i0.ɵɵpipe(43, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(44, "p-progressBar", 16);
        i0.ɵɵtemplate(45, MagneticLicenseInfoComponent_div_45_Template, 5, 3, "div", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "div", 17);
        i0.ɵɵtemplate(47, MagneticLicenseInfoComponent_div_47_Template, 7, 5, "div", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 27, "shared-lib.header-navigation-home.licenseInfoLabel"), " ");
        i0.ɵɵadvance(8);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 29, "shared-lib.header-navigation-home.accountNameLabel"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.data.accountName);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 31, "shared-lib.header-navigation-home.licenseTypeLabel"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.data.licenseType === "Base Subscription");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.data.licenseType === "Advanced Subscription");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.data.licenseType === "Extend");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(25, 33, "shared-lib.header-navigation-home.licenseValidityLabel"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.data.warn.licenseStatus === "active");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.data.warn.licenseStatus === "soon");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.data.warn.licenseStatus === "expired");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.data.endDate, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.data.warn.licenseStatus === "soon");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.data.warn.licenseStatus === "soon");
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("blockElement ", ctx.progressBarClass, " hidden");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(37, 35, "shared-lib.header-navigation-home.accessPointsLimitLabel"), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.data.consumedAps);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate3(" ", i0.ɵɵpipeBind1(42, 37, "shared-lib.header-navigation-home.outOfLabel"), " ", ctx.data.totalAps, " ", i0.ɵɵpipeBind1(43, 39, "shared-lib.header-navigation-home.usedLabel"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("styleClass", ctx.progressBarClass);
        i0.ɵɵproperty("value", ctx.progressPercentage)("showValue", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.data.warn.apLimit === true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.supportMail !== undefined);
    } }, directives: [i4$2.MatDialogContent, i4$2.MatDialogActions, i4$2.MatDialogClose, i1$2.NgIf, i4$1.ProgressBar], pipes: [i2.TranslatePipe], styles: [".modalContent[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.blockElement[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";border-bottom:1px solid #EAEAEA;padding:15px 0 0}.blockHeader[_ngcontent-%COMP%]{font-size:13px}.blockValue[_ngcontent-%COMP%]{font-size:16px;padding:10px 0;color:#000}.support-block[_ngcontent-%COMP%]{text-align:center;padding:20px}.support-message[_ngcontent-%COMP%]{font-size:12px}.support-email[_ngcontent-%COMP%]{font-size:13px;font-weight:bold}.modalFooter[_ngcontent-%COMP%]{line-height:20px}.modalBody[_ngcontent-%COMP%]{padding:10px 35px;min-height:360px;max-height:500px;overflow-y:auto;margin-bottom:50px}.active-indicator[_ngcontent-%COMP%]{color:#00b58e;font-family:ciscoSansBold;font-size:17px}.expiry-indicator[_ngcontent-%COMP%]{color:#f5a623;font-family:ciscoSansBold;font-size:17px}.expired-indicator[_ngcontent-%COMP%]{color:red;font-family:ciscoSansBold;font-size:17px}.duration-block[_ngcontent-%COMP%]{font-size:12px;color:#787878;padding-top:5px}.notice-block[_ngcontent-%COMP%]{background:#fffdf3;border:1px solid #FDDFAF;max-width:400px;padding:10px;margin:10px 0}.notice-img[_ngcontent-%COMP%]{width:10%;height:30px;float:left;background:url(/assets/images/error_icon.svg);background-size:20px;background-repeat:no-repeat;margin:0 5px}.notice-msg[_ngcontent-%COMP%]{font-size:12px;font-family:\"ciscoSansLight\"}.bold-txt[_ngcontent-%COMP%]{font-family:\"ciscoSansBold\"}[_nghost-%COMP%]    >  >  > .ui-progressbar[_ngcontent-%COMP%]{border:1px solid #d9d9d9!important}.hidden[_ngcontent-%COMP%]{display:none!important}.modalContent[_ngcontent-%COMP%]{width:400px!important}.mat-typography[_ngcontent-%COMP%]{top:50%;left:50%;transform:translate(-50%,-50%);width:30%;height:100%;z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #abc233}.mat-typography[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0 30px;color:#545454;font-size:26px;height:100px;line-height:100px}.mat-typography[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{margin:20px 0 20px 20px;padding-right:20px}.mat-typography[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{width:30%;height:100%;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #abc233}.modalCloseIcon[_ngcontent-%COMP%]{position:absolute;right:0;top:0;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MagneticLicenseInfoComponent, [{
        type: Component,
        args: [{
                selector: "app-magnetic-license-info",
                templateUrl: "./magnetic-license-info.component.html",
                styleUrls: ["./magnetic-license-info.component.scss"]
            }]
    }], function () { return [{ type: AuthService }, { type: i2.TranslateService }, { type: DataService }]; }, null); })();

function MagneticProfileDialogComponent_div_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 17);
} }
function MagneticProfileDialogComponent_div_46_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵlistener("click", function MagneticProfileDialogComponent_div_46_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.toggleLicenseInfo(); });
    i0.ɵɵelement(1, "span", 29);
    i0.ɵɵelementStart(2, "span", 30);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "shared-lib.navigation-user-info.licenseInformation"));
} }
function MagneticProfileDialogComponent_div_47_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelement(1, "span", 32);
    i0.ɵɵelementStart(2, "div", 30);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("mat-dialog-close", "smartLicense");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "shared-lib.navigation-user-info.activateSmartLicense"));
} }
function MagneticProfileDialogComponent_div_48_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelement(1, "span", 32);
    i0.ɵɵelementStart(2, "div", 34);
    i0.ɵɵlistener("click", function MagneticProfileDialogComponent_div_48_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.goToLicenseInfoPage(); });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 35);
    i0.ɵɵelementStart(6, "div", 36);
    i0.ɵɵelementStart(7, "div", 37);
    i0.ɵɵelementStart(8, "div", 38);
    i0.ɵɵelementStart(9, "div", 39);
    i0.ɵɵelementStart(10, "span", 40);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "br");
    i0.ɵɵelementStart(14, "span", 41);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementStart(18, "a", 42);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r3.smartLicenseObj["enforceMode"] == "OutOfCompliance" ? "OutOfCompliance" : "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, "shared-lib.navigation-user-info.licenseInfo"), " ");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 9, "shared-lib.navigation-user-info.outOfCompliance"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(16, 11, "shared-lib.navigation-user-info.outOfComplianceMsg"), " ", i0.ɵɵpipeBind1(17, 13, "shared-lib.navigation-user-info.outOfComplianceMsg01"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 15, "shared-lib.navigation-user-info.outOfComplianceMsg02"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(22, 17, "shared-lib.navigation-user-info.outOfComplianceMsg03"), "");
} }
const moment$8 = moment_;
const momentTz = moment_time_;
class MagneticProfileDialogComponent {
    constructor(router, translate, locationService, dialog, authService, userService, interactionService, dataService) {
        this.router = router;
        this.translate = translate;
        this.locationService = locationService;
        this.dialog = dialog;
        this.authService = authService;
        this.userService = userService;
        this.interactionService = interactionService;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.userEmail = "";
        this.customerName = "";
        this.messageKeys = {};
        this.lastLogin = '--';
        this.isAdminUser = false;
        this.userRole = null;
        this.smartLicenseObj = null;
        this.isUserRoleAvailable = null;
        this.currentNav = '';
        this.selectedApp = null;
        this.init = () => __awaiter(this, void 0, void 0, function* () {
            this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
                // Add all fetching of localised string here
                this.getStaticText();
            });
            this.customerName = this.dataService.getCustomerName();
            this.userEmail = this.dataService.getUserName();
            this.isAdminUser = this.dataService.getIsDashboardAdmin();
            this.isSmartLicenseRegistered = this.dataService.getSmartLicenseRegistered();
            this.getLastLogin();
            this.getProperties();
            this.getUserRole();
            setTimeout(() => {
                if (this.smartLicenseEnableFeature && this.userRole == 'Admin' && this.isSmartLicenseRegistered) {
                    this.getSmartLicenseDetail();
                }
            }, 2000);
            this.dataService.getSelectedApp(this.unsubscribe$).subscribe((selectedApp) => {
                if (selectedApp.name)
                    this.selectedApp = selectedApp;
            });
        });
        this.getSmartLicenseDetail = () => {
            this.userService.getSmartLicenseDetail().pipe(takeUntil$1(this.unsubscribe$)).subscribe(response => {
                if (response && response.status && response.data) {
                    if (response.data.status) {
                        if (response.data.status == "completed") {
                            this.smartLicenseObj = response.data.details;
                        }
                    }
                }
                this.smartLicenseObjLoaded = true;
            }, error => {
                console.log('ERROR :: Base component getSmartLicenseDetail call ', error);
            });
        };
        this.getLastLogin = () => {
            // login History
            this.locationService
                .getLoginHistory()
                .pipe(takeUntil$1(this.unsubscribe$))
                .subscribe((response) => {
                if (response && response.data && response.data.loginHistory) {
                    const loginHistoryList = response.data.loginHistory;
                    if (loginHistoryList &&
                        loginHistoryList.length > 1) {
                        const lastLoginVal = loginHistoryList[loginHistoryList.length - 2 // get previous login and not current
                        ].lastLogin;
                        let lastLoginS = moment$8
                            .utc(lastLoginVal)
                            .local()
                            .format("Do MMM YYYY, hh:mm A");
                        const zone = momentTz.tz.guess();
                        const timezoneName = momentTz.tz(zone).zoneAbbr();
                        this.lastLogin = lastLoginS + " " + timezoneName;
                    }
                    else {
                        this.lastLogin = '--';
                    }
                }
                else {
                    this.lastLogin = '--';
                }
            });
        };
        this.getUserRole = () => {
            this.authService.getRole(this.unsubscribe$).subscribe((roleBehavior) => {
                if (roleBehavior && roleBehavior.appRole) {
                    this.userRole = roleBehavior.appRole;
                    this.isUserRoleAvailable = true;
                    // RBAC changes starts
                    if (this.userRole == "RW") {
                        this.userRole = "Admin";
                    }
                    else if (this.userRole == "RO") {
                        this.userRole = "ReadOnlyAccess";
                    }
                }
            }, (error) => {
                console.log(error);
            });
        };
        this.getStaticText = () => {
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-success').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.meraki.success"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-failed').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.meraki.error.failed"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-empty').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.error.input.empty"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-invalid').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.error.input.invalid"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-empty').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.meraki.error.input.empty"] = res;
            });
            this.translate.get('dashboard-lib.wireless-provider.authenticate.meraki-exists').subscribe((res) => {
                this.messageKeys["wirelessprovider.authenticate.meraki.error.exists"] = res;
            });
        };
        this.signOut = ($event) => {
            this.dataService.display(true);
            const userNameForInteractionLog = this.dataService.getUserName();
            const logStr = "LOGOUT: User " + userNameForInteractionLog + " has signed out";
            // set value as null in dataservice
            this.dataService.setSetupTaskObserver(null);
            this.interactionService.doInteractionLog(new InteractionLog(TYPE.LOGOUT, this.dataService.getPosition(), "{}", SECTION.SIGN_OUT, ITEM_TYPE.POPUP, ITEM.SIGN_OUT, logStr, this.dataService.getCurrentNav()));
            // app user's logout issue - fixed
            try {
                if (pendo) {
                    pendo.setGuidesDisabled(true);
                    pendo.loadGuides();
                }
            }
            catch (e) {
                console.log(e);
            }
            finally {
                this.locationService.signOut();
            }
        };
        this.viewLoginHistory = () => {
            console.log('location.pathname.', location.pathname, this.selectedApp.contextUrl);
            const basePath = this.selectedApp.contextUrl.replace('/base', '');
            let currentNav = `${basePath}/loginhistory`;
            this.dataService.setCurrentNav(currentNav);
            this.router.navigate([currentNav]);
        };
        this.goToChangeLogPage = () => {
            this.dataService.setShowChangeLogPage(true);
            this.showAccountPreferences();
        };
        this.goToLicenseInfoPage = () => {
            this.dataService.setShowSLPage(true);
            this.showAccountPreferences();
        };
        this.showAccountPreferences = () => {
            console.log('location.pathname.', location.pathname, this.selectedApp.contextUrl);
            const basePath = this.selectedApp.contextUrl.replace('/base', '');
            let currentNav = `${basePath}/accountpreference`;
            this.dataService.setCurrentNav(currentNav);
            this.router.navigate([currentNav]);
        };
        this.toggleLicenseInfo = () => {
            const dialogRef = this.dialog.open(MagneticLicenseInfoComponent);
            dialogRef.afterClosed().subscribe(result => {
                console.log(`Dialog result: ${result}`);
            });
        };
        this.getProperties = () => {
            this.authService.getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$).then(properties => {
                this.smartLicenseEnableFeature = properties['value'].smartLicenseEnableFeature;
            });
        };
        console.log("MagneticProfileDialogComponent::constructor");
    }
    ngOnInit() {
        this.getStaticText();
        this.init();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        // this.dialog.closeAll();
        // this.mobileQuery.removeListener(this._mobileQueryListener);
        console.log("destory Magnetic Profile Dialog");
    }
}
MagneticProfileDialogComponent.ɵfac = function MagneticProfileDialogComponent_Factory(t) { return new (t || MagneticProfileDialogComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i4$2.MatDialog), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(UserService), i0.ɵɵdirectiveInject(InteractionService), i0.ɵɵdirectiveInject(DataService)); };
MagneticProfileDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MagneticProfileDialogComponent, selectors: [["app-magnetic-profile-dialog"]], inputs: { selectedApp: "selectedApp" }, decls: 49, vars: 25, consts: [[1, "header-profile-card"], [1, "header-profile-wrpr"], [1, "user-profile-wrp"], [1, "user-profile"], [1, "profile-icon"], [1, "profile-details"], [1, "logged-in-as"], [1, "customer-name"], [1, "customer-email"], ["mat-button", "", "mat-dialog-close", "", 1, "user-logout", 3, "click"], [1, "login-history"], [1, "user-last-login-wrp"], [1, "last-login-on"], [1, "last-login"], [1, "user-history-spacer"], [1, "user-history-sep"], ["mat-button", "", "mat-dialog-close", "", 1, "user-login-history", 3, "click"], [1, "profile-separator"], ["mat-button", "", "mat-dialog-close", "", 1, "user-account", 3, "click"], [1, "account-icon"], [1, "my-account"], ["mat-button", "", "mat-dialog-close", "", 1, "change-log", 3, "click"], [1, "change-log-icon"], [1, "view-change-log"], ["class", "profile-separator", 4, "ngIf"], ["class", "smart-license", "mat-button", "", "mat-dialog-close", "", 3, "click", 4, "ngIf"], ["class", "smart-license", "mat-button", "", 3, "mat-dialog-close", 4, "ngIf"], ["class", "smart-license", "mat-button", "", "mat-dialog-close", "", 3, "ngClass", 4, "ngIf"], ["mat-button", "", "mat-dialog-close", "", 1, "smart-license", 3, "click"], [1, "smart-license-icon"], [1, "smart-license-text"], ["mat-button", "", 1, "smart-license", 3, "mat-dialog-close"], [1, "smart-license-activate"], ["mat-button", "", "mat-dialog-close", "", 1, "smart-license", 3, "ngClass"], [1, "smart-license-text", 3, "click"], [1, "showDiv-on-Mousehover"], [1, "modalContent-act"], [1, "modalBody"], [1, "act-popup-div"], [1, "popup-title-div"], [1, "popup-title-red"], [1, "popup-subtitle"], ["href", "https://www.cisco.com/c/en_in/products/software/smart-accounts/software-licensing.html", "target", "_blank"]], template: function MagneticProfileDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-dialog-content", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵelement(4, "span", 4);
        i0.ɵɵelementStart(5, "span", 5);
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵtext(7);
        i0.ɵɵpipe(8, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "mat-dialog-actions");
        i0.ɵɵelementStart(14, "span", 9);
        i0.ɵɵlistener("click", function MagneticProfileDialogComponent_Template_span_click_14_listener($event) { return ctx.signOut($event); });
        i0.ɵɵtext(15);
        i0.ɵɵpipe(16, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 10);
        i0.ɵɵelementStart(18, "span", 11);
        i0.ɵɵelementStart(19, "div", 12);
        i0.ɵɵtext(20);
        i0.ɵɵpipe(21, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 13);
        i0.ɵɵtext(23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(24, "span", 14);
        i0.ɵɵelement(25, "span", 15);
        i0.ɵɵelementStart(26, "mat-dialog-actions");
        i0.ɵɵelementStart(27, "span", 16);
        i0.ɵɵlistener("click", function MagneticProfileDialogComponent_Template_span_click_27_listener() { return ctx.viewLoginHistory(); });
        i0.ɵɵtext(28);
        i0.ɵɵpipe(29, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(30, "div", 17);
        i0.ɵɵelementStart(31, "mat-dialog-actions");
        i0.ɵɵelementStart(32, "div", 18);
        i0.ɵɵlistener("click", function MagneticProfileDialogComponent_Template_div_click_32_listener() { return ctx.showAccountPreferences(); });
        i0.ɵɵelement(33, "span", 19);
        i0.ɵɵelementStart(34, "span", 20);
        i0.ɵɵtext(35);
        i0.ɵɵpipe(36, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(37, "div", 17);
        i0.ɵɵelementStart(38, "mat-dialog-actions");
        i0.ɵɵelementStart(39, "div", 21);
        i0.ɵɵlistener("click", function MagneticProfileDialogComponent_Template_div_click_39_listener() { return ctx.goToChangeLogPage(); });
        i0.ɵɵelement(40, "span", 22);
        i0.ɵɵelementStart(41, "span", 23);
        i0.ɵɵtext(42);
        i0.ɵɵpipe(43, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(44, MagneticProfileDialogComponent_div_44_Template, 1, 0, "div", 24);
        i0.ɵɵelementStart(45, "mat-dialog-actions");
        i0.ɵɵtemplate(46, MagneticProfileDialogComponent_div_46_Template, 5, 3, "div", 25);
        i0.ɵɵtemplate(47, MagneticProfileDialogComponent_div_47_Template, 5, 4, "div", 26);
        i0.ɵɵtemplate(48, MagneticProfileDialogComponent_div_48_Template, 23, 19, "div", 27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 13, "shared-lib.navigation-user-info.loggedInAs"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.customerName);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.userEmail);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 15, "shared-lib.navigation-user-info.logout"));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 17, "shared-lib.navigation-user-info.lastLogin"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.lastLogin);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(29, 19, "shared-lib.navigation-user-info.viewHistory"));
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(36, 21, "shared-lib.navigation-user-info.myAccount"));
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(43, 23, "shared-lib.navigation-user-info.viewChangeLog"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.smartLicenseEnableFeature && !ctx.isAdminUser && ctx.userRole !== "AccessCodeManager" || ctx.smartLicenseEnableFeature && ctx.userRole == "Admin" && !ctx.isSmartLicenseRegistered || ctx.smartLicenseEnableFeature && ctx.userRole == "Admin" && ctx.isSmartLicenseRegistered && ctx.smartLicenseObj);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.smartLicenseEnableFeature && !ctx.isAdminUser && ctx.userRole !== "AccessCodeManager");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.smartLicenseEnableFeature && ctx.userRole == "Admin" && !ctx.isSmartLicenseRegistered);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.smartLicenseEnableFeature && ctx.userRole == "Admin" && ctx.isSmartLicenseRegistered && ctx.smartLicenseObj);
    } }, directives: [i4$2.MatDialogContent, i4$2.MatDialogActions, i4$2.MatDialogClose, i1$2.NgIf, i1$2.NgClass], pipes: [i2.TranslatePipe], styles: [".magnetic-side-nav-item-sel[_ngcontent-%COMP%]{background:rgba(224,224,224,.6);border-radius:8px;width:-webkit-fill-available}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]{position:absolute;display:inline-grid;padding:15px 0 5px;z-index:1;filter:drop-shadow(0px 4px 12px rgba(0,0,0,.12));background:#FFFFFF;overflow:hidden;min-width:362px;right:10px;top:56px;border:2px solid #D0D4D9;box-shadow:0 2px 5px #0000000d;border-radius:6px}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .user-profile-wrp[_ngcontent-%COMP%]{margin:10px 0}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .user-profile-wrp[_ngcontent-%COMP%]   .user-profile[_ngcontent-%COMP%]{height:79px}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .user-profile-wrp[_ngcontent-%COMP%]   .user-profile[_ngcontent-%COMP%]   .profile-icon[_ngcontent-%COMP%]{background:url(/assets/images/magnetic/header/profile-dark.svg);background-position:center;width:38px;height:38px;background-repeat:no-repeat;cursor:pointer;position:relative;display:inline-block;padding:0 22px}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .user-profile-wrp[_ngcontent-%COMP%]   .user-profile[_ngcontent-%COMP%]   .profile-details[_ngcontent-%COMP%]{min-width:183px;height:59px;display:inline-block}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .user-profile-wrp[_ngcontent-%COMP%]   .user-profile[_ngcontent-%COMP%]   .profile-details[_ngcontent-%COMP%]   .logged-in-as[_ngcontent-%COMP%]{height:20px;font-family:\"Inter\";font-style:normal;font-weight:400;font-size:10px;line-height:20px;color:#596069}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .user-profile-wrp[_ngcontent-%COMP%]   .user-profile[_ngcontent-%COMP%]   .profile-details[_ngcontent-%COMP%]   .customer-name[_ngcontent-%COMP%]{min-width:183px;height:20px;font-family:\"Inter\";font-style:normal;font-weight:700;font-size:14px;line-height:20px;color:#464c54}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .user-profile-wrp[_ngcontent-%COMP%]   .user-profile[_ngcontent-%COMP%]   .profile-details[_ngcontent-%COMP%]   .customer-email[_ngcontent-%COMP%]{min-width:160px;height:20px;font-family:\"Inter\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;color:#464c54}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .user-profile-wrp[_ngcontent-%COMP%]   .user-logout[_ngcontent-%COMP%]{box-sizing:border-box;display:inline-flex;padding:5px 12px;width:78px;height:34px;background:#FFFFFF;border:2px solid #326CD1;border-radius:6px;margin:10px 20px;vertical-align:bottom;cursor:pointer}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .login-history[_ngcontent-%COMP%]{padding:10px;display:flex}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .login-history[_ngcontent-%COMP%]   .user-last-login-wrp[_ngcontent-%COMP%]{width:215.5px;height:40px;margin:6px 0;display:inline-block}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .login-history[_ngcontent-%COMP%]   .user-last-login-wrp[_ngcontent-%COMP%]   .last-login[_ngcontent-%COMP%]{width:215.5px;height:18px;font-family:\"Inter\";font-style:normal;font-weight:700;font-size:12px;line-height:18px;color:#464c54}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .login-history[_ngcontent-%COMP%]   .user-last-login-wrp[_ngcontent-%COMP%]   .last-login-on[_ngcontent-%COMP%]{width:188.42px;height:18px;font-family:\"Inter\";font-style:normal;font-weight:400;font-size:12px;line-height:18px;color:#6f7680}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .login-history[_ngcontent-%COMP%]   .user-history-spacer[_ngcontent-%COMP%]{flex:1 0 auto}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .login-history[_ngcontent-%COMP%]   .user-history-sep[_ngcontent-%COMP%]{width:1px;margin:15px 0;border:1px solid #E1E4E8;display:inline-block}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .login-history[_ngcontent-%COMP%]   .user-login-history[_ngcontent-%COMP%]{display:inline-flex;padding:0 10px;height:18px;font-family:\"Inter\";font-style:normal;font-weight:700;font-size:12px;line-height:6px;text-align:right;align-items:flex-end;color:#326cd1;order:0;margin:0;vertical-align:middle;cursor:pointer}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .profile-separator[_ngcontent-%COMP%]{height:1px;background:#E1E4E8;flex:none;order:0;align-self:stretch;flex-grow:0}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .user-account[_ngcontent-%COMP%]{cursor:pointer}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .user-account[_ngcontent-%COMP%]   .account-icon[_ngcontent-%COMP%]{background:url(/assets/images/magnetic/header/profile-grey.svg);background-position:center;width:38px;height:38px;background-repeat:no-repeat;cursor:pointer;position:relative;padding:0 22px;display:inline-block;vertical-align:middle}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .user-account[_ngcontent-%COMP%]   .my-account[_ngcontent-%COMP%]{width:183px;height:58px;font-family:\"Inter\";font-style:normal;font-weight:700;font-size:14px;line-height:20px;color:#464c54;display:inline-block;padding:20px 10px}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .change-log[_ngcontent-%COMP%]{cursor:pointer}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .change-log[_ngcontent-%COMP%]   .change-log-icon[_ngcontent-%COMP%]{background:url(/assets/images/view_change_log.svg);background-position:center;width:38px;height:38px;background-repeat:no-repeat;cursor:pointer;position:relative;padding:0 22px;display:inline-block;vertical-align:middle}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .change-log[_ngcontent-%COMP%]   .view-change-log[_ngcontent-%COMP%]{width:183px;height:58px;font-family:\"Inter\";font-style:normal;font-weight:700;font-size:14px;line-height:20px;color:#464c54;display:inline-block;padding:20px 10px}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .smart-license[_ngcontent-%COMP%]{cursor:pointer}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .smart-license[_ngcontent-%COMP%]   .smart-license-icon[_ngcontent-%COMP%]{background:url(/assets/images/magnetic/header/smart-license.svg);background-position:center;width:38px;height:38px;background-repeat:no-repeat;cursor:pointer;position:relative;display:inline-flex;padding:0 22px;vertical-align:middle}.header-profile-card[_ngcontent-%COMP%]   .header-profile-wrpr[_ngcontent-%COMP%]   .smart-license[_ngcontent-%COMP%]   .smart-license-text[_ngcontent-%COMP%]{width:183px;height:58px;font-family:\"Inter\";font-style:normal;font-weight:700;font-size:14px;line-height:20px;color:#464c54;display:inline-block;padding:20px 10px}.mat-dialog-actions[_ngcontent-%COMP%]{display:inline-block;min-height:0px;margin-bottom:0}.OutOfCompliance[_ngcontent-%COMP%]   .smart-license-text[_ngcontent-%COMP%]{color:red!important}.showDiv-on-Mousehover[_ngcontent-%COMP%]{display:none}.OutOfCompliance[_ngcontent-%COMP%]:hover   .showDiv-on-Mousehover[_ngcontent-%COMP%]{display:block}.modalContent-act[_ngcontent-%COMP%]{width:330px;left:185px;top:190px;position:absolute;background:white;padding:5px;box-shadow:0 0 20px #0000004d;transform:translate(-50%);-webkit-transform:translateX(-50%);-webkit-box-shadow:0 0 20px rgba(0,0,0,.3);opacity:1}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{margin:0;opacity:1!important}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]{display:flex;height:115px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 10px 10px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-red[_ngcontent-%COMP%]{color:red;font-family:CiscoSans;font-size:18px;line-height:26px;letter-spacing:.5px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#000;font-family:CiscoSansLight;font-size:12px;opacity:.7}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]:hover{opacity:1!important}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]{width:100%;border-top:1px solid #b2a6a6;text-align:center;padding-top:5px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]   .popup-footer-text[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:13px;color:#fff}.smart-license-activate[_ngcontent-%COMP%]{background:url(/assets/images/magnetic/header/smart-license.svg);background-position:center;width:38px;height:38px;background-repeat:no-repeat;cursor:pointer;position:relative;display:inline-flex;padding:0 22px;vertical-align:middle}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MagneticProfileDialogComponent, [{
        type: Component,
        args: [{
                selector: "app-magnetic-profile-dialog",
                templateUrl: "./magnetic-profile-dialog.component.html",
                styleUrls: ["./magnetic-profile-dialog.component.scss"]
            }]
    }], function () { return [{ type: i1.Router }, { type: i2.TranslateService }, { type: LocationService }, { type: i4$2.MatDialog }, { type: AuthService }, { type: UserService }, { type: InteractionService }, { type: DataService }]; }, { selectedApp: [{
            type: Input
        }] }); })();

class MagneticTacSupportComponent {
    constructor(router, authService, dataService) {
        this.router = router;
        this.authService = authService;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.getProperties = () => {
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$)
                .then((properties) => {
                this.data = properties["value"];
            });
        };
        this.openLink = ($link) => {
            window.open($link, "_blank");
        };
        console.log("MagneticTacSupportComponent::constructor");
    }
    ngOnInit() {
        this.getProperties();
        // this.getLocaleText();
        // this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange: string) => {
        // 	// Add all fetching of localised string here
        // 	this.getLocaleText();
        // });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        // this.mobileQuery.removeListener(this._mobileQueryListener);
        console.log("destory Magnetic Tac Support");
    }
}
MagneticTacSupportComponent.ɵfac = function MagneticTacSupportComponent_Factory(t) { return new (t || MagneticTacSupportComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(DataService)); };
MagneticTacSupportComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MagneticTacSupportComponent, selectors: [["app-magnetic-tac-support"]], decls: 76, vars: 61, consts: [[1, "mat-typography"], [1, "tac-mpopup-header"], [1, "tac-mpopup-header_left"], [1, "tac-mpopup-header_right"], ["mat-button", "", "mat-dialog-close", "", 1, "close-btn"], [1, "tac-mpopup-notice"], ["target", "_blank", 3, "href"], [1, "tac-mpopup-body"], [1, "tac-mpopup-body_header"], [1, "tac-mpopup-body_ul"], [1, "tac-mpopup-body_li"], ["src", "/assets/images/basic/support/phone.svg", "width", "50"], [1, "tac-mpopup-body_li_header"], [3, "href"], [1, "tac-mpopup-body_li_or"], ["src", "/assets/images/basic/support/email.svg", "width", "50"], ["src", "/assets/images/basic/support/ticket.svg", "width", "50"], [1, "tac-mpopup-body_footer"], [1, "tac-mpopup-body_footer_header"]], template: function MagneticTacSupportComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-dialog-content", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "span", 3);
        i0.ɵɵelementStart(6, "mat-dialog-actions");
        i0.ɵɵelementStart(7, "span", 4);
        i0.ɵɵtext(8, "\uE909");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 5);
        i0.ɵɵelementStart(10, "p");
        i0.ɵɵtext(11);
        i0.ɵɵpipe(12, "translate");
        i0.ɵɵelementStart(13, "a", 6);
        i0.ɵɵtext(14);
        i0.ɵɵpipe(15, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 7);
        i0.ɵɵelementStart(17, "div", 8);
        i0.ɵɵtext(18);
        i0.ɵɵpipe(19, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "ul", 9);
        i0.ɵɵelementStart(21, "li", 10);
        i0.ɵɵelement(22, "img", 11);
        i0.ɵɵelementStart(23, "div", 12);
        i0.ɵɵtext(24, "Phone");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "p");
        i0.ɵɵtext(26);
        i0.ɵɵpipe(27, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "a", 13);
        i0.ɵɵtext(29);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "a", 13);
        i0.ɵɵtext(31);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "a", 6);
        i0.ɵɵtext(33);
        i0.ɵɵpipe(34, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "li", 14);
        i0.ɵɵtext(36);
        i0.ɵɵpipe(37, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "li", 10);
        i0.ɵɵelement(39, "img", 15);
        i0.ɵɵelementStart(40, "div", 12);
        i0.ɵɵtext(41, "Email");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(42, "p");
        i0.ɵɵtext(43);
        i0.ɵɵpipe(44, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "a", 13);
        i0.ɵɵtext(46);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "a", 6);
        i0.ɵɵtext(48);
        i0.ɵɵpipe(49, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "li", 14);
        i0.ɵɵtext(51);
        i0.ɵɵpipe(52, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(53, "li", 10);
        i0.ɵɵelement(54, "img", 16);
        i0.ɵɵelementStart(55, "div", 12);
        i0.ɵɵtext(56);
        i0.ɵɵpipe(57, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(58, "p");
        i0.ɵɵtext(59);
        i0.ɵɵpipe(60, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(61, "a", 6);
        i0.ɵɵtext(62);
        i0.ɵɵpipe(63, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(64, "a", 6);
        i0.ɵɵtext(65);
        i0.ɵɵpipe(66, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(67, "div", 17);
        i0.ɵɵelementStart(68, "span", 18);
        i0.ɵɵtext(69);
        i0.ɵɵpipe(70, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(71, "p");
        i0.ɵɵtext(72);
        i0.ɵɵpipe(73, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(74, "a", 13);
        i0.ɵɵtext(75);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 29, "shared-lib.support-section.support"));
        i0.ɵɵadvance(8);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 31, "shared-lib.support-section.subscriptionCharge"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("href", ctx.data.supportPopupNoticeUrl, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 33, "shared-lib.support-section.subscriptionChargeClickHereKnow"));
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 35, "shared-lib.support-section.ciscoTechinicalAssist"), " ");
        i0.ɵɵadvance(8);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 37, "shared-lib.support-section.callTac"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate1("href", "tel:", ctx.data.supportPopupPhoneOne, "", i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.data.supportPopupPhoneOne);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate1("href", "tel:", ctx.data.supportPopupPhoneTwo, "", i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.data.supportPopupPhoneTwo);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("href", ctx.data.supportPopupPhoneKnowmore, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(34, 39, "shared-lib.support-section.knowMore"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(37, 41, "shared-lib.support-section.or"));
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(44, 43, "shared-lib.support-section.sendEmail"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate1("href", "mailto:", ctx.data.supportPopupEmailId, "", i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.data.supportPopupEmailId);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("href", ctx.data.supportPopupEmailKnowmoreUrl, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(49, 45, "shared-lib.support-section.knowMore"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(52, 47, "shared-lib.support-section.or"));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(57, 49, "shared-lib.support-section.raiseATicket"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(60, 51, "shared-lib.support-section.raiseATicketDesc"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("href", ctx.data.supportPopupTicketUrlOne, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(63, 53, "shared-lib.support-section.openACase"));
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("href", ctx.data.supportPopupTicketKnowmoreUrl, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(66, 55, "shared-lib.support-section.knowMore"));
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(70, 57, "shared-lib.support-section.contactEmailOther"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(73, 59, "shared-lib.support-section.contactEmailOtherDesc"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate1("href", "mailto:", ctx.data.supportPopupContactEmail, "", i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.data.supportPopupContactEmail);
    } }, directives: [i4$2.MatDialogContent, i4$2.MatDialogActions, i4$2.MatDialogClose], pipes: [i2.TranslatePipe], styles: [".mat-typography[_ngcontent-%COMP%]{background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:4px;padding:0;max-height:90vh}.tac-spopup[_ngcontent-%COMP%]:before{content:\"\";position:absolute;bottom:100%;right:0;width:45px;height:0;border-bottom:5px solid #049fd9}.tac-spopup[_ngcontent-%COMP%]{width:300px;padding:20px;background:#fff;z-index:999;position:absolute;left:calc(100% - 370px);top:60px;box-shadow:0 0 3px #85858580;color:#323b48;-webkit-user-select:none;user-select:none}.tac-spopup-header[_ngcontent-%COMP%]{text-align:center;font-size:18px;font-family:ciscoSans;padding-bottom:15px;margin-bottom:15px;border-bottom:1px solid #DFDFDF}.tac-spopup-item[_ngcontent-%COMP%]{padding:8px;font-family:ciscoSans;display:flex;cursor:pointer;transition:.2s linear}.tac-spopup-item_icon[_ngcontent-%COMP%]{padding-right:5px}.tac-spopup-item_externalLink[_ngcontent-%COMP%]{margin-left:8px}.tac-spopup-item[_ngcontent-%COMP%]:hover{background:#dfdfdf}.tac-spopup[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none;color:#323b48}.tac-spopup[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:none;color:#323b48}.tac-spopup-seperator[_ngcontent-%COMP%]{border-top:1px solid #ddd;margin:10px}.tac-mpopup[_ngcontent-%COMP%]   .modalPopup[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;top:0;left:0;z-index:99999;background:rgba(0,0,0,.5);overflow:auto}.tac-mpopup[_ngcontent-%COMP%]   .modalOverlay[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.7);z-index:99999}.tac-mpopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{z-index:999999;position:absolute;width:1280px;background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:4px;overflow:hidden;left:50%;top:5%}.tac-mpopup[_ngcontent-%COMP%]   .close-btn[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.tac-mpopup-header[_ngcontent-%COMP%]{display:inline-block;width:-webkit-fill-available;width:-moz-available;padding:20px;border-bottom:1px solid #b9b9b980}.tac-mpopup-header_left[_ngcontent-%COMP%]{width:80%;font-family:ciscoSans;font-size:20px;display:inline-block;float:left;padding:8px 20px}.tac-mpopup-header_right[_ngcontent-%COMP%]{width:2%;padding:5px 5px 0 0;float:right;display:inline-block}.tac-mpopup-header_right[_ngcontent-%COMP%]   .mat-dialog-actions[_ngcontent-%COMP%]{min-height:0px}.tac-mpopup-body[_ngcontent-%COMP%]{padding:40px 0}.tac-mpopup-body[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#049fd9;font-size:15px;font-family:ciscoSans;padding:5px 0;text-decoration:none}.tac-mpopup-body[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:none;opacity:.8}.tac-mpopup-body_header[_ngcontent-%COMP%]{font-size:20px;font-family:ciscoSansLight;padding:0 130px;text-align:left}.tac-mpopup-body_ul[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:center}.tac-mpopup-body_li[_ngcontent-%COMP%]{min-height:400px;width:300px;border:1px solid #ddd;border-radius:5px;margin:0 30px;display:flex;justify-content:center;flex-direction:column;padding:30px}.tac-mpopup-body_li_header[_ngcontent-%COMP%]{font-size:20px;font-family:ciscoSansRegular;text-align:center}.tac-mpopup-body_li[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{display:flex;align-self:center;margin:20px}.tac-mpopup-body_li[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-family:ciscoSansLight}.tac-mpopup-body_li_or[_ngcontent-%COMP%]{display:flex;align-items:center;color:#000;font-family:ciscoSansLight}.tac-mpopup-body_footer[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:20px 130px}.tac-mpopup-body_footer[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-family:ciscoSansLight;font-size:19px}.tac-mpopup-notice[_ngcontent-%COMP%]{padding:10px 150px;background:#FAFAFA;font-size:15px;font-family:ciscoSansLight}.tac-mpopup-notice[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#049fd9;font-size:15px;font-family:ciscoSans;text-decoration:none}.tac-mpopup-notice[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:none;opacity:.8}.close-btn[_ngcontent-%COMP%]{font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MagneticTacSupportComponent, [{
        type: Component,
        args: [{
                selector: "app-magnetic-tac-support",
                templateUrl: "./magnetic-tac-support.component.html",
                styleUrls: ["./magnetic-tac-support.component.scss"]
            }]
    }], function () { return [{ type: i1.Router }, { type: AuthService }, { type: DataService }]; }, null); })();

class MagneticHelpSectionComponent {
    constructor(authService, dialog, dataService) {
        this.authService = authService;
        this.dialog = dialog;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.getProperties = () => {
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$)
                .then((properties) => {
                this.data = properties["value"];
            });
        };
        this.openLink = ($link) => {
            window.open($link, "_blank");
        };
        console.log("MagneticHelpSectionComponent::constructor");
    }
    ngOnInit() {
        this.getProperties();
        // this.getLocaleText();
        // this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange: string) => {
        // 	// Add all fetching of localised string here
        // 	this.getLocaleText();
        // });
    }
    openTacSupport() {
        const dialogRef = this.dialog.open(MagneticTacSupportComponent);
        dialogRef.afterClosed().subscribe(result => {
            console.log(`Dialog result: ${result}`);
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        this.dialog.closeAll();
        // this.mobileQuery.removeListener(this._mobileQueryListener);
        console.log("destory Magnetic Help");
    }
}
MagneticHelpSectionComponent.ɵfac = function MagneticHelpSectionComponent_Factory(t) { return new (t || MagneticHelpSectionComponent)(i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(i4$2.MatDialog), i0.ɵɵdirectiveInject(DataService)); };
MagneticHelpSectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MagneticHelpSectionComponent, selectors: [["app-magnetic-help-section"]], decls: 33, vars: 16, consts: [["mat-button", "", 1, "header-help", 3, "matMenuTriggerFor"], ["backdropClass", "support-mat-menu", "yPosition", "below", "xPosition", "before"], ["headerHelp", "matMenu"], ["mat-menu-item", "", 1, "support-button", 3, "click"], ["src", "/assets/images/basic/support/help.svg", "width", "30", 1, "tac-spopup-item_icon"], ["href", "javascript:void(0)"], ["src", "/assets/images/basic/support/external_link.svg", "width", "13", 1, "tac-spopup-item_externalLink"], ["src", "/assets/images/basic/support/documentation.svg", "width", "30", 1, "tac-spopup-item_icon"], ["src", "/assets/images/basic/support/support.svg", "width", "30", 1, "tac-spopup-item_icon"], ["vertical", "true", 1, "nav-divider-v"], ["src", "/assets/images/basic/support/release_notes.svg", "width", "30", 1, "tac-spopup-item_icon"], ["src", "/assets/images/basic/support/release_notes_history.svg", "width", "30", 1, "tac-spopup-item_icon"]], template: function MagneticHelpSectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0);
        i0.ɵɵelementStart(1, "mat-menu", 1, 2);
        i0.ɵɵelementStart(3, "button", 3);
        i0.ɵɵlistener("click", function MagneticHelpSectionComponent_Template_button_click_3_listener() { return ctx.openLink(ctx.data.supportLinkOneUrl); });
        i0.ɵɵelement(4, "img", 4);
        i0.ɵɵelementStart(5, "a", 5);
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "img", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "button", 3);
        i0.ɵɵlistener("click", function MagneticHelpSectionComponent_Template_button_click_9_listener() { return ctx.openLink(ctx.data.supportLinkTwoUrl); });
        i0.ɵɵelement(10, "img", 7);
        i0.ɵɵelementStart(11, "a", 5);
        i0.ɵɵtext(12);
        i0.ɵɵpipe(13, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "img", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "button", 3);
        i0.ɵɵlistener("click", function MagneticHelpSectionComponent_Template_button_click_15_listener() { return ctx.openTacSupport(); });
        i0.ɵɵelement(16, "img", 8);
        i0.ɵɵelementStart(17, "span");
        i0.ɵɵtext(18);
        i0.ɵɵpipe(19, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(20, "mat-divider", 9);
        i0.ɵɵelementStart(21, "button", 3);
        i0.ɵɵlistener("click", function MagneticHelpSectionComponent_Template_button_click_21_listener() { return ctx.openLink(ctx.data.supportLinkFourUrl); });
        i0.ɵɵelement(22, "img", 10);
        i0.ɵɵelementStart(23, "span");
        i0.ɵɵtext(24);
        i0.ɵɵpipe(25, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(26, "img", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "button", 3);
        i0.ɵɵlistener("click", function MagneticHelpSectionComponent_Template_button_click_27_listener() { return ctx.openLink(ctx.data.supportLinkFiveUrl); });
        i0.ɵɵelement(28, "img", 11);
        i0.ɵɵelementStart(29, "span");
        i0.ɵɵtext(30);
        i0.ɵɵpipe(31, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(32, "img", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(2);
        i0.ɵɵproperty("matMenuTriggerFor", _r0);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 6, "shared-lib.support-section.supportLinkOneLabel"));
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 8, "shared-lib.support-section.supportLinkTwoLabel"));
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 10, "shared-lib.support-section.supportLinkThreeLabel"));
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(25, 12, "shared-lib.support-section.supportLinkFourLabel"));
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(31, 14, "shared-lib.support-section.supportLinkFiveLabel"));
    } }, directives: [i4$3.MatMenuTrigger, i4$3.MatMenu, i4$3.MatMenuItem, i5$2.MatDivider], pipes: [i2.TranslatePipe], styles: [".header-help[_ngcontent-%COMP%]{background:url(/assets/images/magnetic/header/help.svg);background-position:center;width:24px;height:24px;background-repeat:no-repeat;cursor:pointer;position:relative;display:inline-block;padding:0 16px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MagneticHelpSectionComponent, [{
        type: Component,
        args: [{
                selector: "app-magnetic-help-section",
                templateUrl: "./magnetic-help-section.component.html",
                styleUrls: ["./magnetic-help-section.component.scss"]
            }]
    }], function () { return [{ type: AuthService }, { type: i4$2.MatDialog }, { type: DataService }]; }, null); })();

function MagneticMenuItemComponent_mat_nav_list_0_span_3_img_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 9);
} if (rf & 2) {
    const nav_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("src", "/assets/images/magnetic/menu/apps/v0/", nav_r1.iconClassName, ".svg", i0.ɵɵsanitizeUrl);
} }
function MagneticMenuItemComponent_mat_nav_list_0_span_3_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 9);
} if (rf & 2) {
    const nav_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("src", "/assets/images/magnetic/menu/apps/v0/", nav_r1.iconClassName, "-focus.svg", i0.ɵɵsanitizeUrl);
} }
function MagneticMenuItemComponent_mat_nav_list_0_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtemplate(1, MagneticMenuItemComponent_mat_nav_list_0_span_3_img_1_Template, 1, 1, "img", 8);
    i0.ɵɵtemplate(2, MagneticMenuItemComponent_mat_nav_list_0_span_3_img_2_Template, 1, 1, "img", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const nav_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !nav_r1.selected);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", nav_r1.selected);
} }
const _c0$u = function (a0, a1) { return { "overlay-menu-item-mini": a0, "overlay-menu-item-max": a1 }; };
const _c1$c = function (a0) { return { "magnetic-side-nav-item-sel": a0 }; };
const _c2$a = function (a0) { return { "nav-label-padd": a0 }; };
function MagneticMenuItemComponent_mat_nav_list_0_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "a", 11);
    i0.ɵɵlistener("click", function MagneticMenuItemComponent_mat_nav_list_0_div_7_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r12); const nav_r1 = i0.ɵɵnextContext().$implicit; const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.navClicked(nav_r1); });
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵelement(3, "img", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 4);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const nav_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c0$u, !ctx_r3.isExpanded && nav_r1.childNodes && nav_r1.childNodes.length > 0, !ctx_r3.isExpanded && (!nav_r1.childNodes || nav_r1.childNodes.length === 0)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c1$c, !nav_r1.childNodes && nav_r1.selected));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("src", "/assets/images/magnetic/menu/apps/v0/", nav_r1.iconClassName, "-focus.svg", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("display", ctx_r3.isExpanded || !ctx_r3.isExpanded && (!nav_r1.childNodes || nav_r1.childNodes.length === 0) ? "inline-block" : "none");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c2$a, nav_r1.iconClassName));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 7, nav_r1.label));
} }
function MagneticMenuItemComponent_mat_nav_list_0_div_8_mat_nav_list_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵelement(1, "img", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const navChilds_r15 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("src", "/assets/images/magnetic/menu/apps/", navChilds_r15.iconClassName, ".svg", i0.ɵɵsanitizeUrl);
} }
function MagneticMenuItemComponent_mat_nav_list_0_div_8_mat_nav_list_4_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵelement(1, "img", 17);
    i0.ɵɵelementEnd();
} }
function MagneticMenuItemComponent_mat_nav_list_0_div_8_mat_nav_list_4_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-nav-list");
    i0.ɵɵelementStart(1, "a", 14);
    i0.ɵɵlistener("click", function MagneticMenuItemComponent_mat_nav_list_0_div_8_mat_nav_list_4_Template_a_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r20); const navChilds_r15 = restoredCtx.$implicit; const ctx_r19 = i0.ɵɵnextContext(3); return ctx_r19.navClicked(navChilds_r15); });
    i0.ɵɵtemplate(2, MagneticMenuItemComponent_mat_nav_list_0_div_8_mat_nav_list_4_span_2_Template, 2, 1, "span", 3);
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, MagneticMenuItemComponent_mat_nav_list_0_div_8_mat_nav_list_4_span_6_Template, 2, 0, "span", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const navChilds_r15 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$c, navChilds_r15.selected));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", navChilds_r15.iconClassName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c2$a, navChilds_r15.iconClassName));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, navChilds_r15.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", navChilds_r15.selected);
} }
const _c3$8 = function (a0) { return { "overlay-sub-menu-item-mini": a0 }; };
function MagneticMenuItemComponent_mat_nav_list_0_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MagneticMenuItemComponent_mat_nav_list_0_div_8_mat_nav_list_4_Template, 7, 11, "mat-nav-list", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const nav_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", "overlay-sub-menu-box-" + nav_r1._id);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c3$8, !ctx_r4.isExpanded));
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("display", !ctx_r4.isExpanded ? "inline-block" : "none");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c2$a, nav_r1.iconClassName));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 7, nav_r1.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", nav_r1.childNodes);
} }
const _c4$3 = function (a0, a1, a2) { return { "magnetic-side-nav-main-item-sel": a0, "div-fill-width": a1, "div-min-width": a2 }; };
function MagneticMenuItemComponent_mat_nav_list_0_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-nav-list");
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵlistener("mouseover", function MagneticMenuItemComponent_mat_nav_list_0_Template_div_mouseover_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r23); const nav_r1 = restoredCtx.$implicit; const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.mouseenter(nav_r1.label, nav_r1); })("mouseout", function MagneticMenuItemComponent_mat_nav_list_0_Template_div_mouseout_1_listener() { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.mouseleave(); });
    i0.ɵɵelementStart(2, "a", 2);
    i0.ɵɵlistener("click", function MagneticMenuItemComponent_mat_nav_list_0_Template_a_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r23); const nav_r1 = restoredCtx.$implicit; const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.navClicked(nav_r1); });
    i0.ɵɵtemplate(3, MagneticMenuItemComponent_mat_nav_list_0_span_3_Template, 3, 2, "span", 3);
    i0.ɵɵelementStart(4, "span", 4);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, MagneticMenuItemComponent_mat_nav_list_0_div_7_Template, 7, 16, "div", 5);
    i0.ɵɵtemplate(8, MagneticMenuItemComponent_mat_nav_list_0_div_8_Template, 5, 13, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const nav_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(10, _c4$3, nav_r1.selected && ctx_r0.displayMenuItem !== nav_r1.label, ctx_r0.isExpanded, !ctx_r0.isExpanded));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", nav_r1.iconClassName);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("display", ctx_r0.isExpanded ? "inline-block" : "none");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c2$a, nav_r1.iconClassName));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 8, nav_r1.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.displayMenuItem === nav_r1.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", nav_r1.childNodes && nav_r1.childNodes.length > 0 && ctx_r0.displayMenuItem === nav_r1.label);
} }
function getBaseUrl$3() {
    return document.getElementsByTagName("base")[0].href;
}
class MagneticMenuItemComponent {
    constructor(baseUrl, router, dataService) {
        this.router = router;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.baseUrl = "/";
        this.isExpanded = true;
        this.selectedItem = new EventEmitter();
        this.displayMenuItem = '';
        this.highlightMenu = (doRouting = true) => {
            if (this.menuItemArray) {
                this.menuItemArray.forEach(menuI => {
                    // console.log("menuItemArray>>", menuItemArray)
                    menuI.selected = false;
                    const magRoute = this.dataService.getMagneticMenuRouteUrl();
                    if (magRoute === '/base') {
                        return;
                    }
                    if (this.matchRouteUrl(magRoute, menuI.routeUrl)) {
                        menuI.selected = doRouting ? this.routerNavigate(menuI, magRoute) : true;
                    }
                    else if (menuI.childNodes) {
                        menuI.childNodes.forEach(item => {
                            item.selected = false;
                            if (this.matchRouteUrl(magRoute, item.routeUrl)) {
                                item.selected = doRouting ? this.routerNavigate(item, magRoute) : true;
                            }
                            if (item.selected)
                                menuI.selected = true;
                        });
                    }
                });
            }
        };
        this.calculateClass = (className) => {
            if (className == null) {
                return "cp-rule";
            }
            else {
                const type = className.split("-")[0];
                if (type != "icon") {
                    // to handle for custom images
                }
                else {
                    return className;
                }
            }
        };
        this.navClicked = (nav) => {
            if (!nav.clickable) {
                return;
            }
            if (nav.externalUrl) {
                window.open(nav.routeUrl, '_blank').focus();
            }
            else if (!nav.externalUrl && nav.routeUrl) {
                // if (nav.routeUrl) {
                this.currentNav = nav.routeUrl;
                this.dataService.setCurrentNav(this.currentNav);
                window.history.pushState({}, nav.label, this.baseUrl + this.currentNav.substring(1));
                this.dataService.setLAHomeNavIsSelected(true);
                this.router.navigateByUrl(nav.routeUrl);
                nav.selected = true;
                this.selectedItem.emit({ routeUrl: nav.routeUrl, magRoute: nav.routeUrl });
            }
        };
        this.onSelectedItem = ($event, nav) => {
            if ($event) {
                nav.selected = true;
                this.selectedItem.emit({ routeUrl: nav.routeUrl, magRoute: nav.routeUrl });
            }
        };
        console.log("MagneticMenuItemComponent::constructor");
        this.baseUrl = baseUrl;
    }
    set menuItems(menuItemArray) {
        this.menuItemArray = menuItemArray;
        const doRouting = true;
        this.highlightMenu(doRouting);
    }
    routerNavigate(menuI, magRoute) {
        this.selectedItem.emit({ routeUrl: menuI.routeUrl, magRoute });
        this.router.navigateByUrl(magRoute);
        console.log('matched!');
        return true;
    }
    matchRouteUrl(magRoute, routeUrl) {
        return (routeUrl !== undefined && magRoute !== undefined && routeUrl !== "")
            && (magRoute === routeUrl || (magRoute.indexOf(`${routeUrl}/`) === 0));
    }
    ngOnInit() {
        // this.getLocaleText();
        // this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange: string) => {
        // 	// Add all fetching of localised string here
        // 	this.getLocaleText();
        // });
        this.dataService
            .getCurrentNavObervable(this.unsubscribe$)
            .subscribe((val) => {
            if (val) {
                setTimeout(() => {
                    this.currentNav = val;
                    console.log("current val", val);
                    const doRouting = false;
                    this.highlightMenu(doRouting);
                    this.dataService.closeMagneticPopup();
                });
            }
        });
        fromEvent(window, 'popstate').subscribe((popItem) => {
            var _a;
            console.log('history pop state called', popItem);
            const historyNav = (_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname;
            console.log('history pop state called', historyNav);
            this.dataService.setCurrentNav(historyNav);
            // console.log("going back to menu:, ", this.currentNav)
            const doRouting = false;
            this.highlightMenu(doRouting);
            console.log('this.menuItemArray', this.menuItemArray);
            this.dataService.closeMagneticPopup();
            // }, 1000);
        });
    }
    mouseenter(navLabel, nav) {
        // console.log("mouseEnter >>>>>")
        this.displayMenuItem = navLabel;
        if (this.timeoutObj) {
            clearTimeout(this.timeoutObj);
        }
        try {
            const navId = "overlay-sub-menu-box-" + nav._id;
            const menuObj = document.getElementById(navId);
            console.log(menuObj.getBoundingClientRect());
            let appSelEl = menuObj.getBoundingClientRect();
            console.log('appSelEl', appSelEl);
            const bottomAt = appSelEl.top + appSelEl.height;
            if (window.innerHeight <= bottomAt) {
                menuObj.style.bottom = "0";
            }
            else {
                menuObj.style.bottom = "auto";
            }
        }
        catch (e) {
            console.log("error while setting sub menu bottom");
        }
    }
    mouseleave() {
        // console.log("mouseLeave >>>>>")
        clearTimeout(this.timeoutObj);
        this.timeoutObj = setTimeout(() => {
            this.displayMenuItem = '';
        }, 1000);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        // this.mobileQuery.removeListener(this._mobileQueryListener);
        console.log("destory Magnetic Menu Item");
    }
}
MagneticMenuItemComponent.ɵfac = function MagneticMenuItemComponent_Factory(t) { return new (t || MagneticMenuItemComponent)(i0.ɵɵdirectiveInject("BASE_URL"), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService)); };
MagneticMenuItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MagneticMenuItemComponent, selectors: [["app-magnetic-menu-item"]], inputs: { isExpanded: "isExpanded", menuItems: ["menuItemArray", "menuItems"] }, outputs: { selectedItem: "selectedItem" }, features: [i0.ɵɵProvidersFeature([
            Location$1,
            { provide: LocationStrategy, useClass: PathLocationStrategy },
            { provide: "BASE_URL", useFactory: getBaseUrl$3 }
        ])], decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [3, "ngClass", "mouseover", "mouseout"], ["mat-list-item", "", 1, "mat-list-item-a", 3, "click"], ["class", "nav-icon", 4, "ngIf"], [1, "nav-label", 3, "ngClass"], ["class", "overlay-menu-item", 3, "ngClass", 4, "ngIf"], ["class", "overlay-sub-menu-item", 3, "ngClass", "id", 4, "ngIf"], [1, "nav-icon"], [3, "src", 4, "ngIf"], [3, "src"], [1, "overlay-menu-item", 3, "ngClass"], ["mat-list-item", "", 1, "mat-list-item-a", 3, "ngClass", "click"], [1, "overlay-sub-menu-item", 3, "ngClass", "id"], [1, "nav-label-mini", 3, "ngClass"], ["mat-list-item", "", 1, "mat-list-item-a", "mat-sub-list-item-a", 3, "ngClass", "click"], ["class", "nav-selected-icon", 4, "ngIf"], [1, "nav-selected-icon"], ["src", "/assets/images/magnetic/menu/selected_arrow.svg"]], template: function MagneticMenuItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MagneticMenuItemComponent_mat_nav_list_0_Template, 9, 16, "mat-nav-list", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.menuItemArray);
    } }, directives: [i1$2.NgForOf, i6.MatNavList, i1$2.NgClass, i6.MatListItem, i1$2.NgIf], pipes: [i2.TranslatePipe], styles: [".mat-list-item-a[_ngcontent-%COMP%]{height:40px!important;margin:0 6px;transition:width .6s cubic-bezier(.7,0,.3,1),opacity .6s cubic-bezier(.7,0,.3,1);width:-webkit-fill-available!important;width:-moz-available!important}.mat-list-item-a[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]{width:24px;text-align:center;order:0}.mat-list-item-a[_ngcontent-%COMP%]   .nav-label-padd[_ngcontent-%COMP%]{margin-left:1vw}.mat-list-item-a[_ngcontent-%COMP%]   .nav-label[_ngcontent-%COMP%]{font-family:\"Inter\";font-size:14px;color:#23282e;flex:none;order:1;flex-grow:1}.mat-list-item-a[_ngcontent-%COMP%]   .nav-selected-icon[_ngcontent-%COMP%]{width:24px;text-align:center;order:2;margin-right:10px}.mat-sub-list-item-a[_ngcontent-%COMP%]{padding-left:10px!important;margin:0}.mat-sub-list-item-a[_ngcontent-%COMP%]:hover{background:#CCE1FF;border-radius:8px;color:#0d5cbd;font-size:14px}.mat-list-base[_ngcontent-%COMP%]{margin:0 16px}.mat-list-base[_ngcontent-%COMP%]:first-child{margin-top:16px}.div-fill-width[_ngcontent-%COMP%]{width:-webkit-fill-available!important;width:-moz-fill-available!important}.div-min-width[_ngcontent-%COMP%]{width:36px!important}.magnetic-side-nav-item-sel[_ngcontent-%COMP%]{background:#ECEDEF;border-radius:8px;color:#23282e;font-size:14px;font-weight:600;width:-webkit-fill-available!important}.magnetic-side-nav-main-item-sel[_ngcontent-%COMP%]:not(:hover){background:#ECEDEF;border-radius:8px;color:#23282e;font-size:14px;width:-webkit-fill-available!important}.magnetic-side-nav-main-item-sel[_ngcontent-%COMP%]:not(:hover)   span.nav-label[_ngcontent-%COMP%]{font-weight:600}.overlay-menu-item[_ngcontent-%COMP%]{position:relative;width:-webkit-fill-available;background:#FFFFFF;box-shadow:0 4px 12px #0000001f;border-radius:8px;margin-top:-40px;transition:width .6s cubic-bezier(.7,0,.3,1),opacity .6s cubic-bezier(.7,0,.3,1)}.overlay-menu-item-mini[_ngcontent-%COMP%]{width:50px}.overlay-menu-item-max[_ngcontent-%COMP%]{width:273px;position:fixed}.overlay-sub-menu-item[_ngcontent-%COMP%]{position:fixed;overflow:visible;left:200px;margin-top:-40px;background:#FFFFFF;box-shadow:10px 4px 12px #0000001f;border-radius:8px;padding-top:8px;padding-bottom:16px;width:240px;transition:left .6s cubic-bezier(.7,0,.3,1),opacity .6s cubic-bezier(.7,0,.3,1)}.overlay-sub-menu-item[_ngcontent-%COMP%]   .nav-label-mini[_ngcontent-%COMP%]{display:block;font-family:\"Inter\";font-size:14px;font-weight:600;color:#23282e;flex:none;order:1;flex-grow:1;padding-top:10px;padding-bottom:15px;margin:0 26px}.overlay-sub-menu-item-mini[_ngcontent-%COMP%]{left:50px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MagneticMenuItemComponent, [{
        type: Component,
        args: [{
                selector: "app-magnetic-menu-item",
                providers: [
                    Location$1,
                    { provide: LocationStrategy, useClass: PathLocationStrategy },
                    { provide: "BASE_URL", useFactory: getBaseUrl$3 }
                ],
                templateUrl: "./magnetic-menu-item.component.html",
                styleUrls: ["./magnetic-menu-item.component.scss"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ["BASE_URL"]
            }] }, { type: i1.Router }, { type: DataService }]; }, { isExpanded: [{
            type: Input
        }], selectedItem: [{
            type: Output
        }], menuItems: [{
            type: Input,
            args: ["menuItemArray"]
        }] }); })();

function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 19);
} }
function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 20);
} }
function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 21);
} }
function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_5_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "span", 27);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_5_div_4_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(6); return ctx_r19.showMerakiPopupFn(true); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r16.merakiUserName);
} }
function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_5_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 28);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_5_div_5_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(6); return ctx_r21.showMerakiPopupFn(true); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "shared-lib.navigation-user-info.disconnected"));
} }
function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_5_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "span", 30);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "shared-lib.navigation-user-info.connected"));
} }
function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "a", 23);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_5_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(5); return ctx_r23.showMerakiPopupFn(true); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_5_div_4_Template, 3, 1, "div", 24);
    i0.ɵɵtemplate(5, NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_5_div_5_Template, 4, 3, "div", 1);
    i0.ɵɵtemplate(6, NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_5_div_6_Template, 4, 3, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "shared-lib.navigation-user-info.ciscoMeraki"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r12.merakiAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r12.merakiAuthenticated && !ctx_r12.merakiAPIAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r12.merakiAuthenticated && ctx_r12.merakiAPIAuthenticated);
} }
function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const network_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", network_r8.name, " ");
} }
function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const network_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", network_r8.name, " ");
} }
function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelementStart(1, "div", 33);
    i0.ɵɵelement(2, "img", 34);
    i0.ɵɵelementStart(3, "div", 35);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 36);
    i0.ɵɵtext(6, "|");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 37);
    i0.ɵɵelement(8, "img", 38);
    i0.ɵɵelementStart(9, "div", 39);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const network_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", network_r8.success, " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", network_r8.failed, " ");
} }
function NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵtemplate(2, NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_img_2_Template, 1, 0, "img", 13);
    i0.ɵɵtemplate(3, NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_img_3_Template, 1, 0, "img", 14);
    i0.ɵɵtemplate(4, NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_img_4_Template, 1, 0, "img", 15);
    i0.ɵɵtemplate(5, NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_5_Template, 7, 6, "div", 16);
    i0.ɵɵtemplate(6, NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_6_Template, 2, 1, "div", 17);
    i0.ɵɵtemplate(7, NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_7_Template, 2, 1, "div", 17);
    i0.ɵɵtemplate(8, NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_div_8_Template, 11, 2, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const network_r8 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", network_r8.name === "Cisco Meraki");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", network_r8.name === "CMX On Prem");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", network_r8.name === "Cisco AireOS Controller Direct Connect");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", network_r8.name === "Cisco Meraki");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", network_r8.name === "CMX On Prem");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", network_r8.name === "Cisco AireOS Controller Direct Connect");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", network_r8.success > 0 || network_r8.failed > 0);
} }
function NetworkSyncStatusComponent_div_0_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NetworkSyncStatusComponent_div_0_div_2_div_1_div_4_Template, 9, 7, "div", 8);
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_0_div_2_div_1_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(3); return ctx_r28.toggleNetworkStatPopup(true); });
    i0.ɵɵelementStart(6, "a", 10);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 3, "shared-lib.navigation-user-info.wirelessNetworks"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r5.wpNetworkDetails.wirelessProvidersCount);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 5, "shared-lib.navigation-user-info.wirelessNetworkStatus"));
} }
function NetworkSyncStatusComponent_div_0_div_2_div_2_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 42);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_0_div_2_div_2_div_11_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(4); return ctx_r33.showMerakiPopupFn(true); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r30.merakiUserName);
} }
function NetworkSyncStatusComponent_div_0_div_2_div_2_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 28);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_0_div_2_div_2_div_12_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(4); return ctx_r35.showMerakiPopupFn(true); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "shared-lib.navigation-user-info.disconnected"));
} }
function NetworkSyncStatusComponent_div_0_div_2_div_2_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 30);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "shared-lib.navigation-user-info.connected"));
} }
function NetworkSyncStatusComponent_div_0_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 11);
    i0.ɵɵelementStart(5, "div", 12);
    i0.ɵɵelement(6, "img", 19);
    i0.ɵɵelementStart(7, "div", 22);
    i0.ɵɵelementStart(8, "a", 23);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_0_div_2_div_2_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(3); return ctx_r37.showMerakiPopupFn(true); });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, NetworkSyncStatusComponent_div_0_div_2_div_2_div_11_Template, 3, 1, "div", 1);
    i0.ɵɵtemplate(12, NetworkSyncStatusComponent_div_0_div_2_div_2_div_12_Template, 4, 3, "div", 1);
    i0.ɵɵtemplate(13, NetworkSyncStatusComponent_div_0_div_2_div_2_div_13_Template, 4, 3, "div", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 32);
    i0.ɵɵelementStart(15, "div", 33);
    i0.ɵɵelement(16, "img", 34);
    i0.ɵɵelementStart(17, "div", 35);
    i0.ɵɵtext(18, "0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "span", 36);
    i0.ɵɵtext(20, "|");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 37);
    i0.ɵɵelement(22, "img", 38);
    i0.ɵɵelementStart(23, "div", 39);
    i0.ɵɵtext(24, "0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 41);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_0_div_2_div_2_Template_div_click_25_listener() { i0.ɵɵrestoreView(_r38); const ctx_r39 = i0.ɵɵnextContext(3); return ctx_r39.toggleNetworkStatPopup(true); });
    i0.ɵɵelementStart(26, "a", 10);
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 6, "shared-lib.navigation-user-info.wirelessNetworks"), " ");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 8, "shared-lib.navigation-user-info.ciscoMeraki"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.merakiAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.merakiAuthenticated && !ctx_r6.merakiAPIAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.merakiAuthenticated && ctx_r6.merakiAPIAuthenticated);
    i0.ɵɵadvance(14);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(28, 10, "shared-lib.navigation-user-info.wirelessNetworkStatus"));
} }
function NetworkSyncStatusComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NetworkSyncStatusComponent_div_0_div_2_div_1_Template, 9, 7, "div", 4);
    i0.ɵɵtemplate(2, NetworkSyncStatusComponent_div_0_div_2_div_2_Template, 29, 12, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.wpNetworkDetails.wirelessProvidersCount.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.wpNetworkDetails.wirelessProvidersCount.length === 0);
} }
function NetworkSyncStatusComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 11);
    i0.ɵɵelementStart(6, "div", 12);
    i0.ɵɵelement(7, "img", 19);
    i0.ɵɵelementStart(8, "div", 22);
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵelementStart(13, "span", 43);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 32);
    i0.ɵɵelementStart(17, "div", 44);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 41);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_0_div_3_Template_div_click_20_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(2); return ctx_r40.toggleNetworkStatPopup(true); });
    i0.ɵɵelementStart(21, "a", 10);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 5, "shared-lib.navigation-user-info.wirelessNetworks"), " ");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 7, "shared-lib.navigation-user-info.ciscoMeraki"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 9, "shared-lib.navigation-user-info.disconnected"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 11, "shared-lib.navigation-user-info.connecting"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 13, "shared-lib.navigation-user-info.wirelessNetworkStatus"));
} }
function NetworkSyncStatusComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtemplate(2, NetworkSyncStatusComponent_div_0_div_2_Template, 3, 2, "div", 1);
    i0.ɵɵtemplate(3, NetworkSyncStatusComponent_div_0_div_3_Template, 24, 15, "div", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.disableStatus);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.disableStatus);
} }
function NetworkSyncStatusComponent_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 62);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_1_div_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r50); const ctx_r49 = i0.ɵɵnextContext(2); return ctx_r49.goBackToConnectors(); });
    i0.ɵɵelement(1, "img", 63);
    i0.ɵɵelementEnd();
} }
function NetworkSyncStatusComponent_div_1_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 64);
    i0.ɵɵelement(1, "img", 65);
    i0.ɵɵelementStart(2, "div", 66);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 67);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "ol", 68);
    i0.ɵɵelementStart(9, "li");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementStart(12, "a", 69);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_1_div_12_Template_a_click_12_listener() { i0.ɵɵrestoreView(_r52); const ctx_r51 = i0.ɵɵnextContext(2); return ctx_r51.navigateToLocation(); });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "li");
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "li");
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "li");
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "li");
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 70);
    i0.ɵɵelementStart(28, "a", 71);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_1_div_12_Template_a_click_28_listener() { i0.ɵɵrestoreView(_r52); const ctx_r53 = i0.ɵɵnextContext(2); return ctx_r53.navigateToLocation(); });
    i0.ɵɵtext(29);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 9, "shared-lib.navigation-user-info.noNetworksConfigured"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 11, "shared-lib.navigation-user-info.noNetworksConfiguredMessage"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 13, "shared-lib.navigation-user-info.manageLocationSteps00"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 15, "shared-lib.navigation-user-info.manageLocation"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 17, "shared-lib.navigation-user-info.manageLocationSteps01"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 19, "shared-lib.navigation-user-info.manageLocationSteps02"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 21, "shared-lib.navigation-user-info.manageLocationSteps03"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 23, "shared-lib.navigation-user-info.manageLocationSteps04"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(30, 25, "shared-lib.navigation-user-info.gotoManageLocation"), "");
} }
function NetworkSyncStatusComponent_div_1_div_16_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵelementStart(1, "div", 74);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_1_div_16_div_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r58); const network1_r55 = restoredCtx.$implicit; const ctx_r57 = i0.ɵɵnextContext(3); return ctx_r57.changeSelectedNetwork(network1_r55.name); });
    i0.ɵɵelementStart(2, "div", 75);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const network1_r55 = ctx.$implicit;
    const ctx_r54 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r54.activeNetworkName === network1_r55.name ? "active-network" : "default-network");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(network1_r55.name);
} }
function NetworkSyncStatusComponent_div_1_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NetworkSyncStatusComponent_div_1_div_16_div_1_Template, 5, 2, "div", 72);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r44.wpNetworkDetails.wirelessProvidersCount);
} }
function NetworkSyncStatusComponent_div_1_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 58);
    i0.ɵɵelementStart(1, "div", 76);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_1_div_17_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r60); const ctx_r59 = i0.ɵɵnextContext(2); return ctx_r59.selectCMXConnector(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r45.activeNetworkName === "connector" ? "active-network" : "default-network");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r45.dashboardSetupName, " ", i0.ɵɵpipeBind1(3, 3, "shared-lib.navigation-user-info.connectors"), " ");
} }
function NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_2_img_1_Template(rf, ctx) { if (rf & 1) {
    const _r76 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 100);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_2_img_1_Template_img_click_0_listener() { i0.ɵɵrestoreView(_r76); const n_r65 = i0.ɵɵnextContext(2).index; const ctx_r74 = i0.ɵɵnextContext(4); return ctx_r74.expandOrganizationNode(n_r65); });
    i0.ɵɵelementEnd();
} }
function NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_2_img_2_Template(rf, ctx) { if (rf & 1) {
    const _r79 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 101);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_2_img_2_Template_img_click_0_listener() { i0.ɵɵrestoreView(_r79); const n_r65 = i0.ɵɵnextContext(2).index; const ctx_r77 = i0.ɵɵnextContext(4); return ctx_r77.collapseOrganizationNode(n_r65); });
    i0.ɵɵelementEnd();
} }
function NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵtemplate(1, NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_2_img_1_Template, 1, 0, "img", 98);
    i0.ɵɵtemplate(2, NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_2_img_2_Template, 1, 0, "img", 99);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r66 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r66.expandIconState);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r66.expandIconState);
} }
function NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 102);
} }
function NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_img_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 20);
} }
function NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_img_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 21);
} }
function NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 103);
    i0.ɵɵelement(1, "img", 104);
    i0.ɵɵelementEnd();
} }
function NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_14_li_2_img_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 113);
} }
function NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_14_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 108);
    i0.ɵɵtemplate(1, NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_14_li_2_img_1_Template, 1, 0, "img", 109);
    i0.ɵɵelementStart(2, "div", 110);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 111);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 94);
    i0.ɵɵelement(7, "span", 112);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const networkInfo_r81 = ctx.$implicit;
    const networkStatus_r62 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", networkStatus_r62.name === "Cisco Meraki");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", networkInfo_r81.locationName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", networkInfo_r81.errorMessage, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", networkInfo_r81.errorMessage ? "netStat-failure" : "netStat-success");
} }
function NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 105);
    i0.ɵɵelementStart(1, "ul", 106);
    i0.ɵɵtemplate(2, NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_14_li_2_Template, 8, 4, "li", 107);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r84 = i0.ɵɵnextContext();
    const n_r65 = ctx_r84.index;
    const location_r64 = ctx_r84.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "innerNetworkUl_", n_r65, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", location_r64.networks);
} }
function NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 86);
    i0.ɵɵelementStart(1, "div", 87);
    i0.ɵɵtemplate(2, NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_2_Template, 3, 2, "div", 88);
    i0.ɵɵelementStart(3, "div", 89);
    i0.ɵɵtemplate(4, NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_img_4_Template, 1, 0, "img", 90);
    i0.ɵɵtemplate(5, NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_img_5_Template, 1, 0, "img", 14);
    i0.ɵɵtemplate(6, NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_img_6_Template, 1, 0, "img", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 91);
    i0.ɵɵtext(8);
    i0.ɵɵtemplate(9, NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_span_9_Template, 2, 0, "span", 92);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 93);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 94);
    i0.ɵɵelement(13, "span", 95);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_div_14_Template, 3, 2, "div", 96);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const location_r64 = ctx.$implicit;
    const n_r65 = ctx.index;
    const networkStatus_r62 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "org_", n_r65, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", networkStatus_r62.name === "Cisco Meraki");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", networkStatus_r62.name === "Cisco Meraki");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", networkStatus_r62.name === "CMX On Prem");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", networkStatus_r62.name === "Cisco AireOS Controller Direct Connect");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", location_r64.locationName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", networkStatus_r62.name === "Cisco Meraki" && location_r64.useAPI);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", networkStatus_r62.name === "Cisco Meraki" ? "errorWidth" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", location_r64.errorMessage, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", location_r64.errorMessage ? "netStat-failure" : "netStat-success");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", networkStatus_r62.name === "Cisco Meraki" && location_r64.networks.length > 0);
} }
function NetworkSyncStatusComponent_div_1_div_22_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵelementStart(1, "div", 80);
    i0.ɵɵelementStart(2, "div", 81);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "span", 82);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementStart(11, "span", 82);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 83);
    i0.ɵɵelementStart(14, "ul", 84);
    i0.ɵɵtemplate(15, NetworkSyncStatusComponent_div_1_div_22_div_1_li_15_Template, 15, 11, "li", 85);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const networkStatus_r62 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 5, "shared-lib.navigation-user-info.wirelessNetwork"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", networkStatus_r62.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 7, "shared-lib.navigation-user-info.status"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", networkStatus_r62.syncStatus, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", networkStatus_r62.data);
} }
function NetworkSyncStatusComponent_div_1_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 77);
    i0.ɵɵtemplate(1, NetworkSyncStatusComponent_div_1_div_22_div_1_Template, 16, 9, "div", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r46.wpNetworkDetails.locationSyncNotificationsList);
} }
function NetworkSyncStatusComponent_div_1_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r87 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 114);
    i0.ɵɵelementStart(1, "app-cmx-connector", 115);
    i0.ɵɵlistener("showControllers", function NetworkSyncStatusComponent_div_1_div_23_Template_app_cmx_connector_showControllers_1_listener() { i0.ɵɵrestoreView(_r87); const ctx_r86 = i0.ɵɵnextContext(2); return ctx_r86.showControllers(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("userRole", ctx_r47.userRole)("showConnectorsUpdate", ctx_r47.showConnectors);
} }
function NetworkSyncStatusComponent_div_1_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 114);
    i0.ɵɵelement(1, "app-cisco-cmx", 116);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("userRole", ctx_r48.userRole);
} }
function NetworkSyncStatusComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r89 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 45);
    i0.ɵɵelement(2, "div", 46);
    i0.ɵɵelementStart(3, "div", 47);
    i0.ɵɵelementStart(4, "div", 48);
    i0.ɵɵelementStart(5, "div", 49);
    i0.ɵɵtemplate(6, NetworkSyncStatusComponent_div_1_div_6_Template, 2, 0, "div", 50);
    i0.ɵɵelementStart(7, "div", 49);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 51);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_1_Template_span_click_9_listener() { i0.ɵɵrestoreView(_r89); const ctx_r88 = i0.ɵɵnextContext(); return ctx_r88.toggleNetworkStatPopup(false); });
    i0.ɵɵtext(10, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 52);
    i0.ɵɵtemplate(12, NetworkSyncStatusComponent_div_1_div_12_Template, 31, 27, "div", 53);
    i0.ɵɵelementStart(13, "div", 54);
    i0.ɵɵelementStart(14, "div", 55);
    i0.ɵɵelementStart(15, "div", 56);
    i0.ɵɵtemplate(16, NetworkSyncStatusComponent_div_1_div_16_Template, 2, 1, "div", 1);
    i0.ɵɵtemplate(17, NetworkSyncStatusComponent_div_1_div_17_Template, 4, 5, "div", 57);
    i0.ɵɵelementStart(18, "div", 58);
    i0.ɵɵelementStart(19, "div", 59);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_1_Template_div_click_19_listener() { i0.ɵɵrestoreView(_r89); const ctx_r90 = i0.ɵɵnextContext(); return ctx_r90.selectCMXOnPrem(); });
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, NetworkSyncStatusComponent_div_1_div_22_Template, 2, 1, "div", 60);
    i0.ɵɵtemplate(23, NetworkSyncStatusComponent_div_1_div_23_Template, 2, 2, "div", 61);
    i0.ɵɵtemplate(24, NetworkSyncStatusComponent_div_1_div_24_Template, 2, 1, "div", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r1.networkStatusHeader === "Controllers");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.networkStatusHeader);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.showCMXConnector === false && ctx_r1.showCMXOnPrem === true && ctx_r1.wpNetworkDetails.wirelessProvidersCount.length === 0);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.wpNetworkDetails.wirelessProvidersCount.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.displayCMXConnector === true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r1.activeNetworkName === "cmxOnPrem" ? "active-network" : "default-network");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r1.dashboardSetupName, " ", i0.ɵɵpipeBind1(21, 11, "shared-lib.navigation-user-info.ciscoCMX"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showCMXConnector === false && ctx_r1.showCMXOnPrem === false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.displayCMXConnectorContent === true && ctx_r1.showCMXConnector === true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showCMXOnPrem === true);
} }
function NetworkSyncStatusComponent_div_2_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 128);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r93 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r93.merakiFormError, " ");
} }
function NetworkSyncStatusComponent_div_2_div_3_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h4", 129);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 130);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "shared-lib.navigation-user-info.unableToConnectMeraki"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "shared-lib.navigation-user-info.unableToConnectMerakiPasswordIssue"), " ");
} }
function NetworkSyncStatusComponent_div_2_div_3_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 131);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 132);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "shared-lib.navigation-user-info.unableToConnectMerakiAllowCiscoAccount"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "shared-lib.navigation-user-info.unableToConnectMerakiCiscoAccountInfo"), " ");
} }
function NetworkSyncStatusComponent_div_2_div_3_div_13_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r101 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 140);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_2_div_3_div_13_div_8_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r101); const ctx_r100 = i0.ɵɵnextContext(4); return ctx_r100.doMerakiAuthentication(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared-lib.navigation-user-info.connectAccount"), " ");
} }
function NetworkSyncStatusComponent_div_2_div_3_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r103 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 133);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵelement(2, "input", 134);
    i0.ɵɵelementStart(3, "input", 135);
    i0.ɵɵlistener("ngModelChange", function NetworkSyncStatusComponent_div_2_div_3_div_13_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r102 = i0.ɵɵnextContext(3); return ctx_r102.merakiFormData.userName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵelement(5, "input", 136);
    i0.ɵɵelementStart(6, "input", 137);
    i0.ɵɵlistener("ngModelChange", function NetworkSyncStatusComponent_div_2_div_3_div_13_Template_input_ngModelChange_6_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r104 = i0.ɵɵnextContext(3); return ctx_r104.merakiFormData.password = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "p");
    i0.ɵɵtemplate(8, NetworkSyncStatusComponent_div_2_div_3_div_13_div_8_Template, 3, 3, "div", 138);
    i0.ɵɵelementStart(9, "div", 139);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_2_div_3_div_13_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r103); const ctx_r105 = i0.ɵɵnextContext(3); return ctx_r105.showMerakiPopupFn(false); });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "p");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r96 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r96.merakiFormData.userName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r96.merakiFormData.password);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r96.isUserRoleAvailable && ctx_r96.userRole !== "ReadOnlyAccess");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 4, "shared-lib.navigation-user-info.cancel"), " ");
} }
function NetworkSyncStatusComponent_div_2_div_3_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r107 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 141);
    i0.ɵɵelementStart(1, "label", 142);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 143);
    i0.ɵɵelement(4, "img", 144);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 145);
    i0.ɵɵelementStart(8, "button", 146);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_2_div_3_div_14_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r107); const ctx_r106 = i0.ɵɵnextContext(3); return ctx_r106.disconnectFromMeraki(); });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r97 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r97.merakiUserName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(6, 3, "shared-lib.navigation-user-info.isConnected"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 5, "shared-lib.navigation-user-info.disconnected"), " ");
} }
function NetworkSyncStatusComponent_div_2_div_3_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r109 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 147);
    i0.ɵɵelementStart(1, "a", 23);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_2_div_3_div_15_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r109); const ctx_r108 = i0.ɵɵnextContext(3); return ctx_r108.showRemoveMerakiFormFn(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "shared-lib.navigation-user-info.clickHere"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 4, "shared-lib.navigation-user-info.toRemoveCredentials"), " Spaces. ");
} }
function NetworkSyncStatusComponent_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r111 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "div", 48);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "span", 51);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_2_div_3_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r111); const ctx_r110 = i0.ɵɵnextContext(2); return ctx_r110.showMerakiPopupFn(false); });
    i0.ɵɵtext(5, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 120);
    i0.ɵɵtemplate(7, NetworkSyncStatusComponent_div_2_div_3_div_7_Template, 2, 1, "div", 121);
    i0.ɵɵelementStart(8, "div", 122);
    i0.ɵɵelement(9, "img", 123);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, NetworkSyncStatusComponent_div_2_div_3_div_10_Template, 7, 6, "div", 1);
    i0.ɵɵtemplate(11, NetworkSyncStatusComponent_div_2_div_3_div_11_Template, 7, 6, "div", 1);
    i0.ɵɵelementStart(12, "form", 124);
    i0.ɵɵtemplate(13, NetworkSyncStatusComponent_div_2_div_3_div_13_Template, 13, 6, "div", 125);
    i0.ɵɵtemplate(14, NetworkSyncStatusComponent_div_2_div_3_div_14_Template, 11, 7, "div", 126);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, NetworkSyncStatusComponent_div_2_div_3_div_15_Template, 6, 6, "div", 127);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r91 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 7, "shared-lib.navigation-user-info.ciscoMerakiAccountSettings"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r91.merakiFormError !== "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r91.isShowRemoveLabel());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r91.isShowRemoveLabel());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r91.merakiAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r91.merakiAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r91.isShowRemoveLabel());
} }
function NetworkSyncStatusComponent_div_2_div_4_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 128);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r114 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r114.merakiFormError, " ");
} }
function NetworkSyncStatusComponent_div_2_div_4_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r116 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 153);
    i0.ɵɵtemplate(1, NetworkSyncStatusComponent_div_2_div_4_div_9_div_1_Template, 2, 1, "div", 121);
    i0.ɵɵelementStart(2, "div", 154);
    i0.ɵɵelement(3, "img", 155);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 156);
    i0.ɵɵelementStart(5, "h4");
    i0.ɵɵtext(6, "Are you sure you want to remove");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "h4", 157);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "h5");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 158);
    i0.ɵɵelementStart(13, "button", 159);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_2_div_4_div_9_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r116); const ctx_r115 = i0.ɵɵnextContext(3); return ctx_r115.removeFromMerakiFn(); });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 158);
    i0.ɵɵelementStart(17, "button", 160);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_2_div_4_div_9_Template_button_click_17_listener() { i0.ɵɵrestoreView(_r116); const ctx_r117 = i0.ɵɵnextContext(3); return ctx_r117.hideRemoveMerakiFormFn(); });
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r112 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r112.merakiFormError !== "");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" \"", ctx_r112.userNameToRemove, "\" ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 5, "shared-lib.navigation-user-info.networksWillStopSyncing"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 7, "shared-lib.navigation-user-info.confirm"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 9, "shared-lib.navigation-user-info.cancel"), " ");
} }
function NetworkSyncStatusComponent_div_2_div_4_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r119 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 161);
    i0.ɵɵelementStart(1, "div", 162);
    i0.ɵɵelement(2, "img", 163);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 164);
    i0.ɵɵelementStart(4, "h4");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "h5");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 158);
    i0.ɵɵelementStart(10, "button", 159);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_2_div_4_div_10_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r119); const ctx_r118 = i0.ɵɵnextContext(3); return ctx_r118.hideRemoveMerakiFormFn(); });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r113 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("\"", ctx_r113.removedMerakiUsername, "\"");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 3, "shared-lib.navigation-user-info.removedSuccess"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 5, "shared-lib.navigation-user-info.continue"), " ");
} }
function NetworkSyncStatusComponent_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r121 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 148);
    i0.ɵɵelementStart(1, "div", 48);
    i0.ɵɵelementStart(2, "span", 149);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_2_div_4_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r121); const ctx_r120 = i0.ɵɵnextContext(2); return ctx_r120.hideRemoveMerakiFormFn(); });
    i0.ɵɵelement(3, "img", 150);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "span", 51);
    i0.ɵɵlistener("click", function NetworkSyncStatusComponent_div_2_div_4_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r121); const ctx_r122 = i0.ɵɵnextContext(2); return ctx_r122.showMerakiPopupFn(false); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 120);
    i0.ɵɵtemplate(9, NetworkSyncStatusComponent_div_2_div_4_div_9_Template, 20, 11, "div", 151);
    i0.ɵɵtemplate(10, NetworkSyncStatusComponent_div_2_div_4_div_10_Template, 13, 7, "div", 152);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r92 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 3, "shared-lib.navigation-user-info.removeCredentials"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", !ctx_r92.showConfirm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r92.showConfirm);
} }
function NetworkSyncStatusComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 45);
    i0.ɵɵelement(2, "div", 46);
    i0.ɵɵtemplate(3, NetworkSyncStatusComponent_div_2_div_3_Template, 16, 9, "div", 117);
    i0.ɵɵtemplate(4, NetworkSyncStatusComponent_div_2_div_4_Template, 11, 5, "div", 118);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r2.removeFromMeraki);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.removeFromMeraki);
} }
class NetworkSyncStatusComponent {
    constructor(router, locationService, interactionService, dataService) {
        this.router = router;
        this.locationService = locationService;
        this.interactionService = interactionService;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.showSyncStatusFromSetup = false;
        this.showNetworkStatus = false;
        this.wpNetworkDetails = {};
        this.activeNetworkName = "";
        this.showCMXOnPrem = false;
        this.showCMXConnector = false;
        this.networkStatusDiv = {};
        this.displayCMXConnectorContent = false;
        this.showConnectors = true;
        this.networkStatusHeader = "WIRELESS NETWORK STATUS";
        this.disableStatus = false;
        this.showMerakiPopup = false;
        this.appSwitcherVisible = false;
        this.removedMerakiUsername = "";
        this.removeFromMeraki = false;
        this.showConfirm = false;
        this.merakiAuthenticated = false;
        this.merakiAPIAuthenticated = false;
        this.merakiUserName = "";
        this.currentNav = "/dashboard";
        this.displayCMXConnector = false;
        this.userRole = null;
        this.merakiFormError = "";
        this.userNameToRemove = "";
        this.merakiFormData = {};
        this.isUserRoleAvailable = null;
        this.messageKeys = {};
        this.disconnectFromDataService = false;
        this.merakiLoginFromDataService = false;
        this.erroneousWirelessProviders = {};
        this.subscribeSyncStatus = () => {
            this.timeoutCMXConnector = setTimeout(() => {
                this.displayCMXConnector = this.dataService.getShowCMXConnector();
                this.displayCMXConnectorContent = this.displayCMXConnector;
                console.log("displayCMXConnector :: from dna-spaces : " +
                    this.displayCMXConnector);
            }, 3000);
            this.dataService
                .getDisconnectFromMeraki(this.unsubscribe$)
                .subscribe((val) => {
                if (val) {
                    this.disconnectFromDataService = true;
                    this.disconnectFromMerakiLogin();
                }
            });
            this.dataService
                .getDisconnectFromMerakiAPIKey(this.unsubscribe$)
                .subscribe((val) => {
                if (val) {
                    this.disconnectFromDataService = true;
                    this.disconnectFromMerakiAPIKey();
                }
            });
            this.dataService
                .getLoginFromMeraki(this.unsubscribe$)
                .subscribe((val) => {
                if (val) {
                    this.merakiLoginFromDataService = true;
                    this.dataService
                        .getMerakiUserName(this.unsubscribe$)
                        .subscribe((data) => {
                        if (data) {
                            this.merakiUserName = data;
                        }
                    });
                    this.loginMerakiFromDataService();
                    this.dataService.setLoginFromMeraki(false);
                }
            });
            this.dataService
                .getShowSyncStatus(this.unsubscribe$)
                .subscribe((val) => {
                console.log('getShowSyncStatus>>>', val);
                if (val) {
                    this.showSyncStatusFromSetup = true;
                    this.dataService.openMagneticPopup();
                    this.toggleNetworkStatPopup(true);
                }
            });
        };
        this.loginMerakiFromDataService = () => {
            this.erroneousWirelessProviders.list = [];
            this.merakiAuthenticated = true;
        };
        this.disconnectFromMerakiLogin = () => {
            this.dataService.display(true);
            const authObj = {
                type: "MERAKI_LOGIN"
            };
            this.locationService
                .disconnectMerakiLogin(authObj)
                .pipe(takeUntil$1(this.unsubscribe$))
                .subscribe((authResp) => {
                if (authResp.status) {
                    this.dataService.display(false);
                    this.makeWirelessProviderAuthStatusCall(1000);
                    if (this.removeFromMeraki) {
                        this.removedMerakiUsername = this.userNameToRemove;
                        this.showConfirm = true;
                    }
                    else {
                        this.showMerakiPopup = false;
                        if (this.showMerakiPopup) {
                            this.dataService.openMagneticPopup();
                        }
                        else {
                            this.dataService.closeMagneticPopup();
                        }
                        if (!this.disconnectFromDataService) {
                            this.showNetworkStatus = true;
                            this.dataService.openMagneticPopup();
                        }
                        else {
                            this.merakiAuthenticated = false;
                        }
                        this.dataService.setToastMessage("Successfully removed meraki", 4000, null, null, "success");
                        this.dataService.setIsMerakiAuth(false);
                    }
                }
                else {
                    if (this.removeFromMeraki) {
                        this.merakiFormError = authResp.message;
                        this.showConfirm = false;
                    }
                    this.dataService.setToastMessage("Failed to disconnect", 4000, null, null, "error");
                    this.dataService.display(false);
                }
                if (this.disconnectFromDataService) {
                    this.disconnectFromDataService = false;
                    this.dataService.setDisconnectFromMeraki(false);
                }
            }, (error) => {
                console.log("Error", error);
                this.dataService.setToastMessage(error.status, 4000, null, null, "error");
                this.dataService.closeMagneticPopup();
                this.dataService.display(false);
            });
        };
        this.disconnectFromMerakiAPIKey = () => {
            this.dataService.display(true);
            const authObj = {
                type: "MERAKI_APIKEY"
            };
            this.locationService
                .disconnectMerakiLogin(authObj)
                .pipe(takeUntil$1(this.unsubscribe$))
                .subscribe((authResp) => {
                if (authResp.status) {
                    this.dataService.display(false);
                    this.makeWirelessProviderAuthStatusCall(1000);
                    if (this.removeFromMeraki) {
                        this.removedMerakiUsername = this.userNameToRemove;
                        this.showConfirm = true;
                    }
                    else {
                        this.showMerakiPopup = false;
                        if (this.showMerakiPopup) {
                            this.dataService.openMagneticPopup();
                        }
                        else {
                            this.dataService.closeMagneticPopup();
                        }
                        if (!this.disconnectFromDataService) {
                            this.showNetworkStatus = true;
                            this.dataService.openMagneticPopup();
                        }
                        else {
                            this.merakiAPIAuthenticated = false;
                        }
                        this.dataService.setToastMessage("Successfully removed meraki", 4000, null, null, "success");
                        this.dataService.setIsMerakiAuth(false);
                    }
                }
                else {
                    if (this.removeFromMeraki) {
                        this.merakiFormError = authResp.message;
                        this.showConfirm = false;
                    }
                    this.dataService.setToastMessage("Failed to disconnect", 4000, null, null, "error");
                    this.dataService.display(false);
                }
                if (this.disconnectFromDataService) {
                    this.disconnectFromDataService = false;
                    this.dataService.setDisconnectFromMerakiAPIKey(false);
                }
            }, (error) => {
                console.log("Error", error);
                this.dataService.setToastMessage(error.status, 4000, null, null, "error");
                this.dataService.closeMagneticPopup();
                this.dataService.display(false);
            });
        };
        this.disconnectFromMeraki = () => {
            this.dataService.display(true);
            const authObj = {
                type: "meraki"
            };
            this.locationService
                .disconnectMerakiLogin(authObj)
                .pipe(takeUntil$1(this.unsubscribe$))
                .subscribe((authResp) => {
                if (authResp.status) {
                    this.dataService.display(false);
                    this.makeWirelessProviderAuthStatusCall(1000);
                    if (this.removeFromMeraki) {
                        this.removedMerakiUsername = this.userNameToRemove;
                        this.showConfirm = true;
                    }
                    else {
                        this.showMerakiPopup = false;
                        if (this.showMerakiPopup) {
                            this.dataService.openMagneticPopup();
                        }
                        else {
                            this.dataService.closeMagneticPopup();
                        }
                        if (!this.disconnectFromDataService) {
                            this.showNetworkStatus = true;
                            this.dataService.openMagneticPopup();
                            this.dataService.setDisconnectFromMerakiLogin(true);
                            this.merakiAuthenticated = false;
                            this.merakiAPIAuthenticated = false;
                        }
                        else {
                            this.merakiAuthenticated = false;
                            this.merakiAPIAuthenticated = false;
                        }
                        this.dataService.setToastMessage("Successfully meraki authenticated", 4000, null, null, "success");
                        this.dataService.setIsMerakiAuth(false);
                    }
                    this.dataService.setMerakiLoginAuthenticated(false);
                }
                else {
                    if (this.removeFromMeraki) {
                        this.merakiFormError = authResp.message;
                        this.showConfirm = false;
                    }
                    this.dataService.setToastMessage(authResp.message, 4000, null, null, "error");
                    this.dataService.display(false);
                }
                if (this.disconnectFromDataService) {
                    this.disconnectFromDataService = false;
                }
            }, (error) => {
                console.log("Error", error);
                this.dataService.setToastMessage(error.status, 4000, null, null, "error");
                this.dataService.closeMagneticPopup();
                this.dataService.display(false);
            });
        };
        this.toggleNetworkStatPopup = (e) => {
            if (this.showNetworkStatus) {
                this.showNetworkStatus = false;
                this.dataService.closeMagneticPopup();
            }
            this.expandIconState = true;
            this.wpNetworkDetails.status = "updating";
            if (e) {
                this.dataService.display(true);
                this.locationService
                    .getLocationSyncStatus()
                    .pipe(takeUntil$1(this.unsubscribe$))
                    .subscribe((data) => {
                    this.wpNetworkDetails.wirelessProvidersCount =
                        data.wirelessProvidersCount;
                    this.activeNetworkName =
                        this.wpNetworkDetails.wirelessProvidersCount !=
                            null &&
                            this.wpNetworkDetails.wirelessProvidersCount
                                .length > 0
                            ? this.wpNetworkDetails
                                .wirelessProvidersCount[0].name
                            : "";
                    if (this.activeNetworkName) {
                        this.showCMXConnector = false;
                        this.showCMXOnPrem = false;
                        // this.dataService.display(true);
                        this.locationService
                            .getWPLocationSyncStatus(this.activeNetworkName)
                            .pipe(takeUntil$1(this.unsubscribe$))
                            .subscribe((data) => {
                            // console.log("getWPLocationSyncStatus :: data :: " + JSON.stringify(data));
                            this.wpNetworkDetails.locationSyncNotificationsList =
                                data.locationSyncNotificationsList;
                            this.dataService.display(false);
                            this.wpNetworkDetails.error = false;
                            this.wpNetworkDetails.status =
                                "updated";
                            this.networkStatusDiv.visible = e;
                            if (e) {
                                this.dataService.openMagneticPopup();
                            }
                            else {
                                this.dataService.closeMagneticPopup();
                            }
                        }, (error) => {
                            console.log("getWPLocationSyncStatus :: error :: " +
                                error.status);
                            this.dataService.closeMagneticPopup();
                            this.dataService.display(false);
                        });
                        if (this.wpNetworkDetails.status == "updating") {
                            this.wpNetworkDetails.error = true;
                            this.wpNetworkDetails.status = "updated";
                        }
                    }
                    else {
                        this.networkStatusDiv.visible = e;
                        if (e) {
                            this.dataService.openMagneticPopup();
                        }
                        else {
                            this.dataService.closeMagneticPopup();
                        }
                        if (this.wpNetworkDetails.wirelessProvidersCount
                            .length == 0) {
                            this.dataService.display(false);
                            this.selectCMXConnector();
                        }
                    }
                    this.dataService.setShowSyncStatus(false);
                }, (error) => {
                    console.log("getLocationSyncStatus :: error :: " + error.status);
                    this.dataService.closeMagneticPopup();
                    this.dataService.display(false);
                });
            }
            else {
                this.networkStatusDiv.visible = e;
                this.showSyncStatusFromSetup = false;
                if (e) {
                    this.dataService.openMagneticPopup();
                }
                else {
                    this.dataService.closeMagneticPopup();
                }
                // this.dataService.setShowSyncStatus(false);
            }
        };
        this.selectCMXConnector = () => {
            this.showCMXOnPrem = false;
            this.showCMXConnector = true;
            this.displayCMXConnectorContent = true;
            this.activeNetworkName = "connector";
            this.goBackToConnectors();
        };
        this.goBackToConnectors = () => {
            this.showConnectors = true;
            this.networkStatusHeader = "WIRELESS NETWORK STATUS";
        };
        this.showMerakiPopupFn = (show) => {
            this.showMerakiPopup = show;
            if (this.showMerakiPopup) {
                this.dataService.openMagneticPopup();
            }
            else {
                this.dataService.closeMagneticPopup();
            }
            this.appSwitcherVisible = false;
            this.removedMerakiUsername = "";
            this.hideRemoveMerakiFormFn();
        };
        this.hideRemoveMerakiFormFn = () => {
            this.removeFromMeraki = false;
            this.showConfirm = false;
        };
        this.navigateToLocation = () => {
            this.currentNav = "/location";
            this.router.navigate([this.currentNav]);
            this.dataService.setCurrentNav(this.currentNav);
            this.networkStatusDiv.visible = !this.networkStatusDiv.visible;
            this.toggleNetworkStatPopup(false);
        };
        this.changeSelectedNetwork = (networkName) => {
            this.showCMXConnector = false;
            this.showCMXOnPrem = false;
            this.networkStatusHeader = "WIRELESS NETWORK STATUS";
            this.wpNetworkDetails.status = "updating";
            this.activeNetworkName = networkName;
            if (this.activeNetworkName) {
                this.dataService.display(true);
                this.locationService
                    .getWPLocationSyncStatus(this.activeNetworkName)
                    .pipe(takeUntil$1(this.unsubscribe$))
                    .subscribe((data) => {
                    // console.log("getWPLocationSyncStatus :: data :: " + JSON.stringify(data));
                    this.wpNetworkDetails.locationSyncNotificationsList =
                        data.locationSyncNotificationsList;
                    this.dataService.display(false);
                    this.wpNetworkDetails.error = false;
                    this.wpNetworkDetails.status = "updated";
                    // Reset to meraki location as collapsed state
                    if (this.activeNetworkName == "Meraki") {
                        if (this.wpNetworkDetails
                            .locationSyncNotificationsList &&
                            this.wpNetworkDetails
                                .locationSyncNotificationsList[0].data) {
                            this.wpNetworkDetails.locationSyncNotificationsList[0].data.forEach((element, index) => {
                                this.collapseOrganizationNode(index);
                            });
                        }
                    }
                }, (error) => {
                    console.log("getWPLocationSyncStatus :: error :: " +
                        error.status);
                    this.dataService.closeMagneticPopup();
                    this.dataService.display(false);
                });
                if (this.wpNetworkDetails.status == "updating") {
                    this.wpNetworkDetails.error = true;
                    this.wpNetworkDetails.status = "updated";
                }
            }
        };
        this.collapseOrganizationNode = function (id) {
            this.expandIconState = true;
            $("#innerNetworkUl_" + id).css("display", "none");
        };
        this.selectCMXOnPrem = () => {
            this.showCMXOnPrem = true;
            this.displayCMXConnectorContent = false;
            this.activeNetworkName = "cmxOnPrem";
        };
        this.expandOrganizationNode = function (id) {
            this.expandIconState = false;
            $("#innerNetworkUl_" + id).css("display", "block");
        };
        this.showControllers = () => {
            this.networkStatusHeader = "Controllers";
            this.showConnectors = false;
        };
        this.isShowRemoveLabel = () => {
            if (!this.merakiAuthenticated &&
                this.userNameToRemove &&
                this.userNameToRemove.length > 0) {
                return true;
            }
            else {
                return false;
            }
        };
        this.validCredentialInput = () => {
            if (this.merakiFormData.userName == "") {
                this.merakiFormError = "Please enter email";
                return false;
            }
            if (this.merakiFormData.userName) {
                const filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                if (!filter.test(this.merakiFormData.userName)) {
                    this.merakiFormError = "Please enter valid email";
                    return false;
                }
            }
            if (this.merakiFormData.password == "") {
                this.merakiFormError = "Please enter password";
                return false;
            }
            return true;
        };
        this.makeWirelessProviderAuthStatusCall = (delay) => {
            this.timeoutWirelessProviderStatus = setTimeout(() => {
                if (this.dataService.locationTreeArrayExists)
                    this.getWirelessProviderAuthStatus();
                else
                    this.makeWirelessProviderAuthStatusCall(5000);
            }, delay);
        };
        this.getWirelessProviderAuthStatus = () => {
            if (this.dataService.getWirelessProviderAuthStatusCallInProgress()) {
                return;
            }
            this.dataService.setMerakiWirelessProviderAuthStatusCallInProgress(true);
            this.locationService
                .getWirelessProviderAuthStatus()
                .pipe(takeUntil$1(this.unsubscribe$))
                .subscribe((data) => {
                this.dataService.setMerakiWirelessProviderAuthStatusCallInProgress(false);
                if (data.status == "completed" ||
                    data.status == "unavailable") {
                    this.disableStatus = false;
                    // this.getLocationSyncStatus();
                    if (data.authStatus && data.isUserAuthenticated) {
                        if (data.wirelessUserName == null ||
                            data.wirelessUserName == "" ||
                            data.wirelessUserName == undefined) {
                            data.wirelessUserName = this.merakiUserName;
                        }
                    }
                    this.dataService.setMerakiWPAuthResponse(data);
                    // data.authStatus = false;
                    if (data.authStatus) {
                        if (data.isUserAuthenticated) {
                            this.merakiAuthenticated = true;
                            this.merakiUserName = data.wirelessUserName;
                            this.merakiFormData.userName =
                                this.merakiUserName;
                            this.dataService.setLoginFromMeraki(true);
                            this.dataService.setMerakiUserName(this.merakiUserName);
                        }
                        else {
                            this.merakiAuthenticated = false;
                        }
                        if (data.isAPIKeyAuthenticated) {
                            this.merakiAPIAuthenticated = true;
                            this.dataService.setLoginAPIFromMeraki(true);
                        }
                        else {
                            this.merakiAPIAuthenticated = false;
                        }
                        this.dataService.setIsMerakiAuth(true);
                        this.dataService.setMerakiLoginAuthenticated(true);
                    }
                    else {
                        this.userNameToRemove = data.wirelessUserName;
                        this.merakiFormData.userName =
                            data.wirelessUserName;
                        this.merakiAuthenticated = false;
                        this.merakiAPIAuthenticated = false;
                    }
                }
                if (data.status == "progress") {
                    this.disableStatus = true;
                    this.makeWirelessProviderAuthStatusCall(5000);
                }
            }, (error) => {
                console.log("getWirelessProviderAuthStatus :: error:: " +
                    error.status);
                this.dataService.closeMagneticPopup();
            });
        };
        this.doMerakiAuthentication = () => {
            const valid = this.validCredentialInput();
            if (valid) {
                this.dataService.display(true, 50000);
                const authObj = {
                    type: "meraki",
                    userName: this.merakiFormData.userName,
                    password: this.merakiFormData.password,
                    useAPI: false
                };
                this.locationService
                    .loginToMerakiWireless(authObj)
                    .pipe(takeUntil$1(this.unsubscribe$))
                    .subscribe((authResp) => {
                    if (authResp.status) {
                        this.dataService.display(false);
                        this.makeWirelessProviderAuthStatusCall(1000);
                        this.showMerakiPopup = false;
                        this.showNetworkStatus = true;
                        this.dataService.openMagneticPopup();
                        this.dataService.setMerakiLoginAuthenticated(true);
                        this.dataService.setToastMessage("Successfully meraki authenticated", 4000, null, null, "success");
                        const userNameForInteractionLog = this.dataService.getUserName();
                        const logStr = "CONNECT: User " +
                            userNameForInteractionLog +
                            " has connected to meraki account";
                        this.interactionService.doInteractionLog(new InteractionLog(TYPE.CONNECT, this.dataService.getPosition(), "{}", SECTION.ACCOUNT_SETTINGS, ITEM_TYPE.POPUP, ITEM.MERAKI_ACCOUNT_SETTINGS_CONNECT, logStr, this.dataService.getCurrentNav()));
                    }
                    else {
                        this.dataService.setToastMessage(this.messageKeys[authResp.message], 4000, null, null, "error");
                        this.dataService.display(false);
                        const userNameForInteractionLog = this.dataService.getUserName();
                        const logStr = "ERROR: While connecting meraki account by User " +
                            userNameForInteractionLog;
                        this.interactionService.doInteractionLog(new InteractionLog(TYPE.ERROR, this.dataService.getPosition(), "{}", SECTION.ACCOUNT_SETTINGS, ITEM_TYPE.POPUP, ITEM.MERAKI_ACCOUNT_SETTINGS_CONNECT, logStr, this.dataService.getCurrentNav()));
                    }
                }, (error) => {
                    console.log("Error", error);
                    this.dataService.setToastMessage(this.messageKeys[error.status], 4000, null, null, "error");
                    this.dataService.display(false);
                    this.dataService.closeMagneticPopup();
                });
            }
        };
        this.showRemoveMerakiFormFn = () => {
            this.removeFromMeraki = true;
        };
        this.removeFromMerakiFn = () => {
            this.disconnectFromMeraki();
        };
        console.log("NetworkSyncStatusComponent::constructor");
    }
    ngOnInit() {
        // this.getLocaleText();
        // this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange: string) => {
        // 	// Add all fetching of localised string here
        // 	this.getLocaleText();
        // });
        this.networkStatusDiv = { visible: false, showPageLoader: false };
        this.subscribeSyncStatus();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        clearTimeout(this.timeoutCMXConnector);
        clearTimeout(this.timeoutWirelessProviderStatus);
        console.log("destory Network Sync status");
    }
}
NetworkSyncStatusComponent.ɵfac = function NetworkSyncStatusComponent_Factory(t) { return new (t || NetworkSyncStatusComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(InteractionService), i0.ɵɵdirectiveInject(DataService)); };
NetworkSyncStatusComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NetworkSyncStatusComponent, selectors: [["app-network-sync-status"]], decls: 3, vars: 3, consts: [["class", "networkProvider", 4, "ngIf"], [4, "ngIf"], [1, "networkProvider"], [1, "arrow_box_spaces"], ["class", "wirnet-active-status-block", 4, "ngIf"], ["class", "wirnet-active-status-block", "style", "min-height: 90px", 4, "ngIf"], [1, "wirnet-active-status-block"], [1, "wirnet-active-header"], ["class", "wirnet-list", 4, "ngFor", "ngForOf"], ["id", "btn-wirelessnetwork-status", 1, "connectBtnWNS", "wirnet-active-button", 3, "click"], ["href", "javascript:void(0);"], [1, "wirnet-list"], [1, "wirnet-list-inner"], ["style", "float: left", "src", "/assets/images/meraki.svg", 4, "ngIf"], ["src", "/assets/images/cuwn.svg", 4, "ngIf"], ["src", "/assets/images/wlc.svg", 4, "ngIf"], ["class", "wirnet-active-name", "style", "height: 30px", 4, "ngIf"], ["class", "wirnet-active-name", 4, "ngIf"], ["class", "wirnet-active-counter-block", 4, "ngIf"], ["src", "/assets/images/meraki.svg", 2, "float", "left"], ["src", "/assets/images/cuwn.svg"], ["src", "/assets/images/wlc.svg"], [1, "wirnet-active-name", 2, "height", "30px"], ["href", "javascript:void(0);", 3, "click"], ["class", "merakiAuthenticated", 4, "ngIf"], ["class", "merakiAPIAuthenticated", 4, "ngIf"], [1, "merakiAuthenticated"], [2, "font-size", "10px", "color", "#03b88c", "cursor", "pointer", "display", "block", "width", "100%", "white-space", "nowrap", "overflow", "hidden", "text-overflow", "ellipsis", 3, "click"], [2, "font-size", "10px", "color", "#f96969", "cursor", "pointer", 3, "click"], [1, "merakiAPIAuthenticated"], [2, "font-size", "10px", "color", "#03b88c", "cursor", "pointer", "display", "block", "width", "100px", "white-space", "nowrap", "overflow", "hidden", "text-overflow", "ellipsis"], [1, "wirnet-active-name"], [1, "wirnet-active-counter-block"], [1, "wirnet-active-success-count-block"], ["src", "/assets/images/tick_mark_green.svg", 1, "paddingRight5"], [1, "wirnet-active-success-count"], [1, "vertical-seperator", "paddingLR5"], [1, "wirnet-active-fail-count-block"], ["src", "/assets/images/notification_icon.svg", 1, "paddingRight5"], [1, "wirnet-active-fail-count"], [1, "wirnet-active-status-block", 2, "min-height", "90px"], [1, "connectBtnWNS", "wirnet-active-button", 3, "click"], [2, "font-size", "10px", "color", "#03b88c", "cursor", "pointer", "display", "block", "width", "100px", "white-space", "nowrap", "overflow", "hidden", "text-overflow", "ellipsis", 3, "click"], [2, "font-size", "10px", "color", "#f96969"], [1, "syncProgressLabel"], [1, "modalPopup"], [1, "modalOverlay"], [1, "modalContent", "netStat-container"], [1, "modalHeader"], [1, "divTable"], ["class", "divTableCell", "style", "width: 30px", 3, "click", 4, "ngIf"], [1, "modalCloseIcon", 3, "click"], ["id", "padding0", 1, "modalBody"], ["class", "netStat-nonet-container", 4, "ngIf"], [1, "netStat-active-container"], [1, "netStat-active-header-container"], [1, "netStat-active-header"], ["class", "netStat-network-names", 4, "ngIf"], [1, "netStat-network-names"], ["id", "navlink-wirelessnetwork-cmxconnector", 3, "ngClass", "click"], ["style", "height: 90vh; overflow-y: auto; text-align: left", "class", "netStat-block", 4, "ngIf"], ["style", "height: 90vh; overflow-y: auto", 4, "ngIf"], [1, "divTableCell", 2, "width", "30px", 3, "click"], ["src", "/assets/images/god-dashboard/go-back-left-arrow.svg", 2, "padding-right", "10px"], [1, "netStat-nonet-container"], ["src", "/assets/images/network_status_wifi_icon_grey.svg"], [1, "netStat-nonet-header"], [1, "netStat-nonet-notice"], [1, "netStat-nonet-message-box"], ["href", "javascript:void(0)", 2, "text-decoration", "underline", 3, "click"], [1, "connectBtn", "wirnet-active-button", 2, "width", "40%", "margin", "20px auto", "border", "2px solid #a9a9a9"], ["href", "javascript:void(0)", 1, "goto-loc", 2, "text-decoration", "none", "color", "#333", 3, "click"], ["class", "netStat-network noselect", 4, "ngFor", "ngForOf"], [1, "netStat-network", "noselect"], [1, "netStat-network-names", 3, "click"], [3, "ngClass"], ["id", "navlink-wirelessnetwork-connector", 3, "ngClass", "click"], [1, "netStat-block", 2, "height", "90vh", "overflow-y", "auto", "text-align", "left"], ["class", "netStat-a", 4, "ngFor", "ngForOf"], [1, "netStat-a"], [1, "netStat-active-block"], [1, "netStat-network-header"], [2, "font-weight", "bold", "text-transform", "uppercase", "color", "#000", "font-size", "13px"], [1, "netStat-network-list-container"], [2, "padding-left", "0px"], ["class", "netStat-network-list", 4, "ngFor", "ngForOf"], [1, "netStat-network-list"], [1, "organization-wrapper", 3, "id"], ["class", "org-expcol-wrapper", 4, "ngIf"], [1, "netStat-network-list-wipr-logo"], ["src", "/assets/images/meraki.svg", 4, "ngIf"], [1, "netStat-network-list-wipr-name"], ["style", "margin-left: 5px", 4, "ngIf"], [1, "netStat-network-list-wipr-error-message", 3, "ngClass"], [1, "netStat-network-status-indicator"], [1, "netStat-network-status-icon", 3, "ngClass"], ["class", "\n\t\t\t\t\t\t\t\t\t\t\t\t\t  netStat-inner-network-container\n\t\t\t\t\t\t\t\t\t\t\t\t  ", 4, "ngIf"], [1, "org-expcol-wrapper"], ["src", "/assets/images/expand_plus.svg", "height", "25", 3, "click", 4, "ngIf"], ["ng-mouseover", "highlightUl(n,true);", "ng-mouseleave", "highlightUl(n,false);", "src", "/assets/images/collapse_minus.svg", "height", "25", 3, "click", 4, "ngIf"], ["src", "/assets/images/expand_plus.svg", "height", "25", 3, "click"], ["ng-mouseover", "highlightUl(n,true);", "ng-mouseleave", "highlightUl(n,false);", "src", "/assets/images/collapse_minus.svg", "height", "25", 3, "click"], ["src", "/assets/images/meraki.svg"], [2, "margin-left", "5px"], ["src", "/assets/images/two_factor_icon.svg", "height", "15"], [1, "netStat-inner-network-container"], [1, "wir-network-list", 2, "display", "none", 3, "id"], ["class", "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  netStat-inner-network-wrapper\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t  ", 4, "ngFor", "ngForOf"], [1, "netStat-inner-network-wrapper"], ["src", "/assets/images/building_icon.svg", "style", "float: left", 4, "ngIf"], [1, "innerNetwork-name"], [1, "netStat-network-list-wipr-error-message", "innerNetwork-errorMessage"], [1, "netStat-network-status-icon", "innerIconRight", 3, "ngClass"], ["src", "/assets/images/building_icon.svg", 2, "float", "left"], [2, "height", "90vh", "overflow-y", "auto"], [3, "userRole", "showConnectorsUpdate", "showControllers"], [3, "userRole"], ["class", "modalContent merakiAuthPopup", 4, "ngIf"], ["class", "modalContent merakiAuthPopup textCenter", 4, "ngIf"], [1, "modalContent", "merakiAuthPopup"], [1, "modalBody"], ["class", "alertMsg", 4, "ngIf"], [1, "textCenter"], ["src", "/assets/images/dnaspaces_meraki.svg", "alt", "", "width", "312px"], [1, "ng-pristine", "ng-valid", "ng-valid-email", 2, "text-align", "center"], ["class", "ng-scope", 4, "ngIf"], ["style", "border: 1px solid rgb(169, 169, 169)", 4, "ngIf"], ["class", "removeMerakiLabel", 4, "ngIf"], [1, "alertMsg"], [1, "redErrorLabel"], [1, "removedMessage"], [2, "font-weight", "bold", "margin-top", "20px"], [2, "margin-top", "10px", "margin-bottom", "20px"], [1, "ng-scope"], ["type", "text", "id", "userdummy", "autocomplete", "off", 2, "display", "none"], ["type", "email", "id", "userName", "name", "userName", "autocomplete", "off", "placeholder", "Email", 1, "ng-pristine", "ng-valid", "ng-valid-email", 2, "text-align", "center", "background-color", "#fff !important", "color", "#000", 3, "ngModel", "ngModelChange"], ["type", "password", "id", "pwd", "autocomplete", "off", "placeholder", "", 2, "display", "none"], ["type", "password", "id", "passpwd", "name", "password", "autocomplete", "off", "placeholder", "Password", 1, "ng-pristine", "ng-valid", 2, "text-align", "center", "background-color", "#fff !important", "color", "#000", 3, "ngModel", "ngModelChange"], ["class", "primaryButton", "style", "display: inline-block", 3, "click", 4, "ngIf"], [1, "secondaryButton", 2, "display", "inline-block", 3, "click"], [1, "primaryButton", 2, "display", "inline-block", 3, "click"], [2, "border", "1px solid rgb(169, 169, 169)"], [2, "padding", "0", "margin-bottom", "0", "margin-left", "10px"], [2, "margin-top", "10px", "margin-bottom", "15px", "width", "auto"], ["src", "/assets/images/configure.png", 2, "float", "left", "width", "20px", "margin-left", "10px"], [2, "display", "inline-block", "margin-bottom", "10px"], [1, "primaryButton", 3, "click"], [1, "removeMerakiLabel"], [1, "modalContent", "merakiAuthPopup", "textCenter"], [1, "backArrowIcon", 3, "click"], ["src", "/assets/images/back_arrow_btn.svg", "alt", "Back"], ["class", "confirmContent", 4, "ngIf"], ["class", "successContent", 4, "ngIf"], [1, "confirmContent"], [1, "warningImage"], ["src", "/assets/images/notification_icon.svg", "alt", "Warning"], [1, "removeWarningMessage"], [1, "usernameToRemove"], [1, "removeAction"], [1, "primaryButton2", 3, "click"], [1, "cancelButton", 3, "click"], [1, "successContent"], [1, "successImage"], ["src", "/assets/images/successf_icon.svg", "alt", "Success"], [1, "successMessage"]], template: function NetworkSyncStatusComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NetworkSyncStatusComponent_div_0_Template, 4, 2, "div", 0);
        i0.ɵɵtemplate(1, NetworkSyncStatusComponent_div_1_Template, 25, 13, "div", 1);
        i0.ɵɵtemplate(2, NetworkSyncStatusComponent_div_2_Template, 5, 2, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showNetworkStatus);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.networkStatusDiv.visible);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showMerakiPopup);
    } }, directives: [i1$2.NgIf, i1$2.NgForOf, i1$2.NgClass, CmxConnectorComponent, CiscoCmxComponent, i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i2$1.NgForm, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel], pipes: [i2.TranslatePipe], styles: ["@charset \"UTF-8\";.navigation[_ngcontent-%COMP%]{height:100%;background-color:#059fd9}.navigationWidth[_ngcontent-%COMP%]{display:flex;flex-direction:row;width:100%}div.navigation[_ngcontent-%COMP%]::-webkit-scrollbar{width:8px}div.navigation[_ngcontent-%COMP%]::-webkit-scrollbar-track{box-shadow:none;border-radius:10px;background-color:#088cbe}div.navigation[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{border-radius:10px;box-shadow:none;background-color:#fff6;border:1px solid rgba(0,0,0,0);background-clip:padding-box}.brandLogo[_ngcontent-%COMP%]{text-align:center;font-size:18px;font-weight:bold;background-color:#088cbe;color:#097dbc}.brandLogo[_ngcontent-%COMP%]   a.brandLink[_ngcontent-%COMP%]{display:block;padding:14px 0;height:65px;text-align:center;color:#e2eff7;font-family:\"ciscoSansRegular\";font-size:16px;text-decoration:none;border-bottom:1px solid rgba(255,255,255,.2);cursor:pointer}.brandImg[_ngcontent-%COMP%]{height:35px}.userProfile[_ngcontent-%COMP%]{display:block;box-shadow:inset 0 0 39px 66px #0000}.userName[_ngcontent-%COMP%]{cursor:pointer}.userName[_ngcontent-%COMP%]{display:table-cell;width:230px}.settingsDisplayIcons[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;justify-content:center;width:150px;position:relative;left:6px;top:-5px}.settingsDisplayIcons[_ngcontent-%COMP%]   .help-icon-wrap[_ngcontent-%COMP%]{position:relative;top:4px;right:8px}.settingsDisplayIcons[_ngcontent-%COMP%]   .app-switcher[_ngcontent-%COMP%]{position:relative;right:35px;top:6px}.settingsDisplayIcons[_ngcontent-%COMP%]   .userNameSpaces[_ngcontent-%COMP%]{position:relative;top:4px;left:20px;cursor:pointer}.userEmailContainer[_ngcontent-%COMP%]{display:inline;padding-right:10px}.userProfileIcon[_ngcontent-%COMP%]{font-size:28px;vertical-align:middle;display:inline;color:#fff;font-family:\"icomoon-new\";padding:5px 5px 5px 6px}.userEmail[_ngcontent-%COMP%]{font-size:16px;vertical-align:middle;display:inline-block;color:#999;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100px;font-family:\"ciscoSansRegular\"}.userProfileArrow[_ngcontent-%COMP%]{font-size:12px;vertical-align:middle;display:inline-block;color:#fff;font-family:\"icomoon-new\";padding:0 12px}.userSettings[_ngcontent-%COMP%]{display:table;width:100%;cursor:pointer;position:relative;height:60px;background-color:#059fd9;border-bottom:1px solid rgba(255,255,255,.2)}.userConnect[_ngcontent-%COMP%]{cursor:pointer;display:table-cell;vertical-align:middle;width:50%;text-align:center;padding:10px 0}.userConnect[_ngcontent-%COMP%]:first-of-type{border-right:1px solid rgba(255,255,255,.2)}.userConnectIcon[_ngcontent-%COMP%]{position:relative;width:100%;color:#fff;font-size:30px;font-family:\"icomoon-new\"}.userSettingIcon[_ngcontent-%COMP%]{position:relative;width:100%;color:#fff;font-size:30px;font-family:\"icomoon\"}.navigationList[_ngcontent-%COMP%]{max-height:80%;overflow-y:auto;background:#059fd9;margin-top:0;padding-bottom:60px}.navigationLink[_ngcontent-%COMP%]{display:block;font-weight:300;border-bottom:1px solid rgba(255,255,255,.2)}.selectedLink[_ngcontent-%COMP%]{font-weight:600;opacity:1;background:#088cbe;border-left:4px solid #FFFFFF}.navigationLink[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{opacity:.75;display:block;color:#fff;height:60px;font-size:16px;cursor:pointer;padding:18px 20px}.navigationLink[_ngcontent-%COMP%]   .boldLinks[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\"}.navigationLink[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#fff;opacity:1;text-decoration:none;background:rgba(8,140,190,.42)}.expandNavList[_ngcontent-%COMP%]{border-left:2px solid rgba(255,255,255,.2);margin-left:20px}.expandNavList[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{border-bottom:none;padding:8px 0 8px 20px;color:#fff;border-left:4px solid #059fd9;display:block;cursor:pointer;opacity:.75;font-size:14px;font-weight:300;height:auto}.expandNavLink[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative}.expandNavLink[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:before{position:absolute;right:10px;top:20px;font-size:12px;color:#fff;font-family:\"icomoon-new\"}.navLinkClose.expandNavLink[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:before{content:\"\\e905\"}.navLinkOpen.expandNavLink[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:before{content:\"\\e908\"}.navLinkClose[_ngcontent-%COMP%]   .expandNavList[_ngcontent-%COMP%]{display:none}.navLinkOpen[_ngcontent-%COMP%]   .expandNavList[_ngcontent-%COMP%]{display:block}.expandNavList[_ngcontent-%COMP%]   a.selectedSubLink[_ngcontent-%COMP%]{font-weight:600;opacity:1;background:#088cbe;border-left:4px solid #FFFFFF}.pageHeadingLink[_ngcontent-%COMP%]{color:#6a6b6c;font-weight:normal;font-size:16px;font-family:\"ciscoSansLight\"}.signOutPopup[_ngcontent-%COMP%]{display:none}.signOutVisible[_ngcontent-%COMP%]{display:block}.signOutPopupContainer[_ngcontent-%COMP%]{height:auto;width:300px;background:#fff;position:absolute;top:77px;box-shadow:0 0 3px #00000080;left:calc(100% - 320px);z-index:1;padding-top:15px}.signOutPopupContainer[_ngcontent-%COMP%]:before{content:\"\";position:absolute;bottom:100%;right:0;width:45px;height:0;border-bottom:5px solid #049fd9}.userProfileIcon_grey[_ngcontent-%COMP%]{font-size:60px;color:#d8d8d8;display:block;font-family:\"icomoon-new\"}.signOutButton[_ngcontent-%COMP%]{font-size:14px;font-weight:bold;cursor:pointer;border:1px solid #d2d2d2;width:75%;margin:0 auto;border-radius:20px;position:relative;top:10px;height:30px;line-height:30px}.signOutPopupInner[_ngcontent-%COMP%]{text-align:center}.userEmailPopup[_ngcontent-%COMP%]{font-size:13px;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:calc(100% - 34px);font-family:\"ciscoSansRegular\";margin:0 auto;color:#414f5f}.navUserActions[_ngcontent-%COMP%]{width:90%;margin:0 auto;padding:15px 0;border-top:1px solid #dfdfdf}.vertical-line[_ngcontent-%COMP%]{height:25px;width:1px;background-color:#9a9a9a;position:relative;top:15px}.rotateDiv[_ngcontent-%COMP%]{transform:rotate(180deg);-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg)}.navigationLink.cursorDisabled[_ngcontent-%COMP%], .navigationLink.cursorDisabled[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{cursor:not-allowed}.has-children-open[_ngcontent-%COMP%]{background:url(/assets/images/navigation_collapse_icon.svg) no-repeat 96% center!important;background-size:30px;opacity:.75}.has-children-closed[_ngcontent-%COMP%]{background:url(/assets/images/navigation_expand_icon.svg) no-repeat 96% center!important;background-size:30px;opacity:.75}.children[_ngcontent-%COMP%]{padding-bottom:10px;border-bottom:1px solid rgba(255,255,255,.2);overflow:hidden;border-bottom:none;width:100%}.location-border-left[_ngcontent-%COMP%]{border-left:2px solid rgba(255,255,255,.2);margin-left:20px}a.child-label[_ngcontent-%COMP%]{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;font-size:14px!important;line-height:40px;padding:0 24px!important;height:40px!important}.settingsNavigation[_ngcontent-%COMP%]{height:60px;display:table;width:100%;background-color:#059fd9;text-align:center;border-bottom:1px solid rgba(255,255,255,.2)}.settingsNavigationWidth[_ngcontent-%COMP%]   .monitor-ico[_ngcontent-%COMP%]{cursor:pointer;position:relative;top:5px;right:5px}.app-switcher-icon[_ngcontent-%COMP%]{background:url(/assets/images/app_switcher.svg) no-repeat center!important;background-size:contain!important;height:17px;width:17px;margin:0 auto;border-left:none;cursor:pointer}.help-icon[_ngcontent-%COMP%]{background:url(/assets/images/basic/support/help_icon.svg) no-repeat center!important;background-size:contain!important;height:21px;width:21px;border-left:none;cursor:pointer}.network-error-status-icon[_ngcontent-%COMP%]{background:url(/assets/images/wifi_off.svg) no-repeat center!important;background-size:contain!important;height:26px;width:26px;margin:0 auto;border-left:none}.network-success-status-icon[_ngcontent-%COMP%]{background:url(/assets/images/wifi_on.svg) no-repeat center!important;background-size:contain!important;height:26px;width:26px;margin:0 auto;border-left:none}.settingsLink[_ngcontent-%COMP%]:hover{opacity:.9;background:rgba(8,140,190,.42)}.changePasswordBtn[_ngcontent-%COMP%]{display:block;width:75%;margin:20px auto;height:44px}.navPopupButton[_ngcontent-%COMP%]{background-color:#fff;text-align:left;display:flex;vertical-align:middle;font-size:15px;font-family:\"ciscoSansLight\";padding:10px 18px;color:#414f5f;outline:none;width:100%}.navPopupButton[_ngcontent-%COMP%]:hover{opacity:.8}.navPopupLinks[_ngcontent-%COMP%]{padding-left:10px;cursor:pointer}.logOutBtn[_ngcontent-%COMP%]{height:35px;line-height:35px;width:85%;background:#00a1df;color:#fff;margin:10px auto 15px;font-family:ciscoSansLight;font-weight:700;font-size:14px;border-radius:5px;cursor:pointer}.logOutBtn[_ngcontent-%COMP%]:hover{opacity:.8}.logOutBtn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#fff}.networkProvider[_ngcontent-%COMP%]{position:absolute;top:75px;left:calc(100% - 490px);width:400px!important;overflow:visible!important;z-index:9999}.arrow_box[_ngcontent-%COMP%]{z-index:1001;background:#fff;border:1px solid #fff;border-radius:10px;box-shadow:-1px 1px 5px #000000bf;text-align:center;padding:20px}.arrow_box[_ngcontent-%COMP%]:after, .arrow_box[_ngcontent-%COMP%]:before{bottom:100%;left:20%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.wirnet-active-status-block[_ngcontent-%COMP%]{min-height:150px}.wirnet-active-header[_ngcontent-%COMP%]{text-transform:uppercase;font-size:12px;text-align:left;padding-bottom:7px;border-bottom:1px solid #ccc;font-weight:bold}.wirnet-list[_ngcontent-%COMP%]{text-align:left;border-bottom:1px solid #ccc;height:50px}.wirnet-list-inner[_ngcontent-%COMP%]{padding:12px 0}.wirnet-active-name[_ngcontent-%COMP%]{display:inline-block;font-weight:bold;font-size:13px;padding-left:5px;width:50%}.wirnet-active-counter-block[_ngcontent-%COMP%]{display:inline-block;float:right}.connectBtnWNS[_ngcontent-%COMP%]{border:1px solid #c4c4c4;padding:10px 0;width:80%;margin:30px auto 0;border-radius:20px;font-size:14px;font-weight:bold;cursor:pointer}.wirnet-active-success-count-block[_ngcontent-%COMP%], .wirnet-active-fail-count-block[_ngcontent-%COMP%]{display:inline-block}.wirnet-active-success-count-block[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{display:inline-block;height:15px}.wirnet-active-success-count[_ngcontent-%COMP%], .wirnet-active-fail-count[_ngcontent-%COMP%]{display:inline-block;font-weight:bold;font-size:12px}.wirnet-active-fail-count-block[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{height:17px;display:inline-block}.netStat-container[_ngcontent-%COMP%]{height:96vh;width:98%;background:#f7f9fb;margin:2vh auto auto;top:0}.wirnet-error-status-icon[_ngcontent-%COMP%]{background:url(/assets/images/network_status_wifi_icon_white.svg) no-repeat center!important;height:50px;width:50px;margin:0 auto}.wirnet-nonet-status-block[_ngcontent-%COMP%]{min-height:200px}.wirnet-nonet-status-message[_ngcontent-%COMP%]{padding:10px 10px 20px;font-weight:bold;border-bottom:1px solid #ccc}.wirnet-nonet-icon[_ngcontent-%COMP%]{background:url(/assets/images/network_status_wifi_icon_grey.svg) no-repeat center!important;height:50px;width:50px;margin:20px auto}a#switchAccount[_ngcontent-%COMP%]{padding:13px;color:#000}#switchAccount[_ngcontent-%COMP%]{text-decoration:none!important}.wirnet-active-status-block[_ngcontent-%COMP%]{min-height:150px}.wirnet-active-header[_ngcontent-%COMP%]{text-transform:uppercase;font-size:12px;text-align:left;padding-bottom:7px;border-bottom:1px solid #ccc;font-weight:bold}.arrow_box[_ngcontent-%COMP%]{padding:20px}.wirnet-list[_ngcontent-%COMP%]{text-align:left;border-bottom:1px solid #ccc;height:50px}.wirnet-list-inner[_ngcontent-%COMP%]{padding:12px 0}.wirnet-active-name[_ngcontent-%COMP%]{display:inline-block;font-weight:bold;font-size:13px;padding-left:5px;width:50%}.wirnet-active-counter-block[_ngcontent-%COMP%]{display:inline-block;float:right}.wirnet-active-success-count-block[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{display:inline-block;height:15px}.wirnet-active-fail-count-block[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{height:17px;display:inline-block}.wirnet-active-success-count-block[_ngcontent-%COMP%], .wirnet-active-fail-count-block[_ngcontent-%COMP%]{display:inline-block}.wirnet-active-success-count[_ngcontent-%COMP%], .wirnet-active-fail-count[_ngcontent-%COMP%]{display:inline-block;font-weight:bold;font-size:12px}.vertical-seperator[_ngcontent-%COMP%]{color:#ccc}.img-hidden[_ngcontent-%COMP%]{display:none}#blackOverlay[_ngcontent-%COMP%]{z-index:9999}.netStat-popup[_ngcontent-%COMP%]{display:block}.netStat-active-container[_ngcontent-%COMP%]{height:85vh;width:100%;display:table}.netStat-container[_ngcontent-%COMP%]{height:96vh;width:98%;background:#f7f9fb;margin:2vh auto auto}.netStat-header[_ngcontent-%COMP%]{background:#fff;border-bottom:1px solid #e6e6e6;height:10vh}.netStat-header-left[_ngcontent-%COMP%]{line-height:80px;width:50%;float:left;font-size:20px;font-weight:bold;padding-left:30px}.netStat-header-right[_ngcontent-%COMP%]{text-align:right}.netStat-header-right[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{position:relative;right:25px;top:20px;line-height:5vh;font-size:15px;color:#6a6b6c;font-family:\"icomoon-new\";padding:12px;cursor:pointer}.netStat-header-right[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:none}.netStat-nonet-container[_ngcontent-%COMP%]{width:50%;margin:10px auto;text-align:center;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.netStat-nonet-container[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{margin:0 auto;height:80px;border:none}.netStat-nonet-header[_ngcontent-%COMP%]{font-size:27px;font-weight:bold}.netStat-nonet-notice[_ngcontent-%COMP%]{font-weight:bold;padding:17px 100px;font-size:14px}.netStat-nonet-message-box[_ngcontent-%COMP%]{text-align:left;border:2px solid #a9a9a9;padding:20px 40px;width:80%;margin:0 auto}.netStat-nonet-message-box[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{font-size:13px;list-style-type:decimal;font-weight:bold;padding:3px}.netStat-active-header-container[_ngcontent-%COMP%]{background-color:#f6f9fb;width:20%;display:table-cell;vertical-align:top;box-shadow:0 0 2px #00000080}.netStat-network-names[_ngcontent-%COMP%]{font-size:15px;font-weight:bold;cursor:pointer;border-bottom:1px solid #c4c4c4}.netStat-network-names[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:18px}.default-network[_ngcontent-%COMP%]{padding:20px 30px}.active-network[_ngcontent-%COMP%]{padding:20px 30px;background-color:#fff;color:#009eea;border-left:4px solid #009eea}.noselect[_ngcontent-%COMP%]{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.netStat-block[_ngcontent-%COMP%]{height:72vh;width:80%;display:flex}.netStat-a[_ngcontent-%COMP%]{width:100%}.netStat-active-block[_ngcontent-%COMP%]{padding:50px 10px;height:100%;width:100%;margin:0 auto;overflow-y:auto}.netStat-network-list-container[_ngcontent-%COMP%]{background:#fff;border:1px solid #e4e4e4;overflow-y:auto;width:80%;margin:0 auto;max-height:calc(100vh - 200px)}.netStat-network-header[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:50%;float:left;color:#939494}.netStat-network-header[_ngcontent-%COMP%]{padding-bottom:30px;font-size:13px;width:80%;margin:0 auto}.netStat-network-header[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-of-type(2){text-align:right}.netStat-network-list-wipr-logo[_ngcontent-%COMP%]{width:3%;float:left;text-align:center}.netStat-network-list-wipr-name[_ngcontent-%COMP%]{width:45%;float:left;font-weight:bold;line-height:25px}.netStat-network-list[_ngcontent-%COMP%]{width:100%;padding:14px;overflow:auto}.netStat-network-list-wipr-error-message[_ngcontent-%COMP%]{width:49%;height:25px;line-height:25px;float:left;color:#f26968;font-size:14px;font-weight:bold;text-align:right;padding-right:20px;overflow:hidden}.netStat-network-status-indicator[_ngcontent-%COMP%]{width:2%;float:right}.netStat-network-status-icon[_ngcontent-%COMP%]{width:13px;height:13px;border-radius:100px;-webkit-border-radius:100px;-moz-border-radius:100px;float:right;position:relative;top:3px;right:10px}.netStat-success[_ngcontent-%COMP%]{background:url(/assets/images/tick_mark_green.svg) center no-repeat;background-size:contain;height:17px;width:17px}.netStat-failure[_ngcontent-%COMP%]{background:url(/assets/images/notification_icon.svg) center no-repeat;background-size:contain;height:17px;width:17px}.netStat-error-icon[_ngcontent-%COMP%]{position:relative;top:-10px;left:27px;z-index:999}.netStat-wipr-icon[_ngcontent-%COMP%]{position:relative;left:-10px}.netStat-hide-error-icon[_ngcontent-%COMP%]{visibility:hidden}.netStat-loader[_ngcontent-%COMP%]{position:absolute;text-align:center;z-index:10011;width:70%;height:100%}.organization-wrapper[_ngcontent-%COMP%]{overflow:auto}.netStat-inner-network-wrapper[_ngcontent-%COMP%]{width:98%;border:1px solid #e4e4e4;padding:10px;height:43px;margin:10px 5% 10px 26px}.org-expcol-wrapper[_ngcontent-%COMP%]{width:6%;text-align:right;float:left}.org-expcol-wrapper[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{cursor:pointer}.org-expcol-wrapper[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]:hover{cursor:pointer;opacity:.8}.innerNetwork-name[_ngcontent-%COMP%]{display:inline-block;width:43%;float:left;font-weight:bold;padding-left:10px}.innerNetwork-errorMessage[_ngcontent-%COMP%]{width:52%}.innerIconRight[_ngcontent-%COMP%]{right:4px}.errorWidth[_ngcontent-%COMP%]{width:43%}.wir-network-list[_ngcontent-%COMP%]{display:none;border-left:1px solid #138cd2;margin-left:50px;padding-left:10px;transition-duration:.1s;transition-timing-function:linear;margin-top:-2px;background-image:url(/assets/images/lh-hline-hover.svg);background-repeat:no-repeat;background-position-y:bottom}.activeLine[_ngcontent-%COMP%]{background:url(/assets/images/lh-hline-hover.svg) no-repeat left bottom;border-left:1px solid #138cd2}.inActiveLine[_ngcontent-%COMP%]{background-image:url(/assets/images/lh-line.svg);background-repeat:no-repeat;background-position-y:bottom;border-left:1px solid #e4e4e4}.notification-error-overlay[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;background:rgba(0,0,0,.3);display:none;z-index:9999}.notification-error-overlay.show[_ngcontent-%COMP%]{display:block}.notification-errors.slide-in[_ngcontent-%COMP%]{animation:slide-in .5s forwards;-webkit-animation:slide-in .5s forwards}@keyframes slide-in{to{transform:translate(0)}}.notification-errors.slide-out[_ngcontent-%COMP%]{animation:slide-out .5s forwards}@keyframes slide-out{to{transform:translate(100%)}}.notification-errors[_ngcontent-%COMP%]{width:30%;position:absolute;right:0;top:0;height:100%;overflow-y:auto;background-color:#fff;transform:translate(100%)}.notification-error-header[_ngcontent-%COMP%]{background-color:#414f5f;width:100%;padding:20px}.notification-error-heading[_ngcontent-%COMP%]{color:#fff;font-weight:500}.notification-error-close[_ngcontent-%COMP%]{font-size:14px;color:#eaeaea;float:right;cursor:pointer}.notification-error-list[_ngcontent-%COMP%]{padding:20px}.notification-name[_ngcontent-%COMP%]{color:#000;margin:5px 0}.notification-time[_ngcontent-%COMP%]{color:#ccc;float:right;font-size:12px;font-weight:normal}.notification-path[_ngcontent-%COMP%]{color:#ccc;margin:5px 0}.notification-path[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{position:relative;display:inline-block}.notification-desc[_ngcontent-%COMP%]{color:#666;line-height:18px}.notification-right-arrow[_ngcontent-%COMP%]{padding-right:5px}.notification-path[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:last-child   .notification-right-arrow[_ngcontent-%COMP%]{display:none}.notification-list-item[_ngcontent-%COMP%]{padding-bottom:10px;margin-bottom:10px;border-bottom:1px solid #dddfe2}.disabledBtn[_ngcontent-%COMP%]{cursor:not-allowed!important;opacity:.5}.disabledBtn[_ngcontent-%COMP%]:hover, .disabledBtn[_ngcontent-%COMP%]:focus{text-decoration:none}.syncErrorDiv[_ngcontent-%COMP%]{position:fixed;top:0;right:146px;margin-top:4px;height:45px}.floatRight[_ngcontent-%COMP%]{float:right}.notification-sync[_ngcontent-%COMP%]{padding:10px}.notification-link[_ngcontent-%COMP%]{padding:12px 15px;display:inline;position:relative}.syncProgress[_ngcontent-%COMP%], .syncComplete[_ngcontent-%COMP%], .syncCheck[_ngcontent-%COMP%]{display:none}.notification-link[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{padding:10px 0;position:relative}.notification-error-number[_ngcontent-%COMP%]{background-color:#f86969;position:relative;top:-50px;display:block!important;right:-30px;color:#fff;font-weight:normal;font-size:10px;width:28px;height:28px;border-radius:50%;text-align:center;padding:5px 4px;border:2px solid #fff}.notification-error-number[_ngcontent-%COMP%]:hover{color:#fff;font-weight:bold}.vertical-line-left[_ngcontent-%COMP%]{height:18px;position:relative;top:5px;left:-10px;width:1px;background-color:#cecece;display:inline-block}.vertical-line-right[_ngcontent-%COMP%]{height:18px;position:relative;top:5px;right:-15px;width:1px;background-color:#cecece;display:inline-block}@keyframes rotating{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.rotating[_ngcontent-%COMP%]{animation:rotating 3s linear infinite}.notification-error-overlay[_ngcontent-%COMP%]{position:fixed;top:0;width:100%;height:100%;background:rgba(0,0,0,.3);display:none;z-index:9999}.show[_ngcontent-%COMP%]{display:block!important}.notification-error-empty[_ngcontent-%COMP%]{width:70%;height:100%}.merakiAuthPopup[_ngcontent-%COMP%]{width:40%;left:50%;top:80px}.alertMsg[_ngcontent-%COMP%]{padding:10px 0;color:red;font-size:12px}.redErrorLabel[_ngcontent-%COMP%]{color:#f26968;font-family:\"ciscoSansRegular\";font-size:14px;text-align:center}.removedMessage[_ngcontent-%COMP%]{color:#6a6b6c;font-size:12px;font-family:\"ciscoSansLight\"}.removeMerakiLabel[_ngcontent-%COMP%]{font-size:12px;text-align:center;font-family:\"ciscoSansRegular\";margin-top:20px;color:#4d4d4d}.removeMerakiLabel[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:underline;color:#4d4d4d}.backArrowIcon[_ngcontent-%COMP%]{position:absolute;cursor:pointer;top:12px;left:30px}.warningImage[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:60px;margin-top:20px;height:auto}.removeWarningMessage[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-bottom:0;margin-top:5px;color:#000;font-family:\"ciscoSansLight\";font-size:14px}.removeWarningMessage[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin-bottom:20px;margin-top:5px;font-size:12px;color:#6a6b6c;font-family:\"ciscoSansLight\"}.removeWarningMessage[_ngcontent-%COMP%]   h4.usernameToRemove[_ngcontent-%COMP%]{font-weight:bold;font-family:\"ciscoSansRegular\"}.successMessage[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-bottom:0;font-family:\"ciscoSansRegular\";font-weight:bold}.successMessage[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin-top:5px;margin-bottom:20px;font-family:\"ciscoSansLight\"}.syncProgressLabel[_ngcontent-%COMP%]{font-size:12px;margin-top:5px}.arrow_box_spaces[_ngcontent-%COMP%]{z-index:1001;background:#fff;border:1px solid #fff;border-radius:10px;box-shadow:-1px 1px 5px #000000bf;text-align:center;padding:20px}.arrow_box_spaces[_ngcontent-%COMP%]:after, .arrow_box_spaces[_ngcontent-%COMP%]:before{bottom:100%;right:35px;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.arrow_box_spaces[_ngcontent-%COMP%]:before, .arrow_box_userAccount[_ngcontent-%COMP%]:before{border-color:#c2e1f500;border-bottom-color:#000;border-width:20px;margin-left:-20px}.arrow_box_spaces[_ngcontent-%COMP%]:after, .arrow_box_userAccount[_ngcontent-%COMP%]:after{border-color:#88b7d500;border-bottom-color:#fff;border-width:20px;margin-left:-20px}.paddingRight5[_ngcontent-%COMP%]{padding-right:5px}.paddingLR5[_ngcontent-%COMP%]{padding:0 5px}#padding0[_ngcontent-%COMP%]{padding:0}.divTableLoginHistory[_ngcontent-%COMP%]{display:table;width:100%;font-size:12px;padding:2% 5%}.divTableCell1LocHistory[_ngcontent-%COMP%]{display:table-cell;width:65%;vertical-align:middle;padding:10px}.divTableCell1LocHistory[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:11px;padding-bottom:5px;text-align:left;color:#939393;font-family:ciscoSans}.divTableCell1LocHistory[_ngcontent-%COMP%]   .lastLogin[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:11px;text-align:left;color:#353535}.divTableCell2LocHistory[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.divTableCell2LocHistory[_ngcontent-%COMP%]   .viewHistory[_ngcontent-%COMP%]{font-weight:bold;color:#3986e2;font-family:ciscoSans;cursor:pointer}.userInfoWrapper[_ngcontent-%COMP%]{text-align:left;padding:10px;display:flex;flex-direction:row}.userInfoWrapper[_ngcontent-%COMP%]   .userProfile[_ngcontent-%COMP%]{width:80%}.userInfoWrapper[_ngcontent-%COMP%]   .userProfile[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(1){font-size:20px}.userInfoWrapper[_ngcontent-%COMP%]   .userProfile[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(2){font-family:\"ciscoSansLight\";color:#606060}.userLicenseInfoWrapper[_ngcontent-%COMP%]{display:flex;flex-direction:row;padding:15px;border-top:1px solid #DFDFDF;width:95%;margin:0 auto}.userLicenseInfoWrapper[_ngcontent-%COMP%]   .licenseText[_ngcontent-%COMP%]{padding:0 20px;display:flex;flex-direction:column;text-align:left}.userLicenseInfoWrapper[_ngcontent-%COMP%]   .licenseText[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(1){font-size:12px;font-family:\"ciscoSansLight\"}.userLicenseInfoWrapper[_ngcontent-%COMP%]   .licenseText[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-of-type(2){font-size:15px;font-family:\"ciscoSans\"}.userLicenseInfoWrapper[_ngcontent-%COMP%]   .licenseText[_ngcontent-%COMP%]   .see[_ngcontent-%COMP%]{color:#069ddd}.userLicenseInfoWrapper[_ngcontent-%COMP%]   .licenseText[_ngcontent-%COMP%]   .act[_ngcontent-%COMP%]{color:#fbab18}.userLicenseInfoWrapper[_ngcontent-%COMP%]   .licenseText[_ngcontent-%COMP%]   .extend[_ngcontent-%COMP%]{color:#6ebe4a}.appSwitcher[_ngcontent-%COMP%]{animation:fadein .5s}.hideDiv[_ngcontent-%COMP%]{display:none}.showDiv[_ngcontent-%COMP%]{display:block}@keyframes fadein{0%{opacity:0}to{opacity:1}}.OutOfCompliance[_ngcontent-%COMP%]{color:red}.showDiv-on-Mousehover[_ngcontent-%COMP%]{display:none}.OutOfCompliance[_ngcontent-%COMP%]:hover + .showDiv-on-Mousehover[_ngcontent-%COMP%]{display:block}.modalContent-act[_ngcontent-%COMP%]{width:360px;left:-180px;top:180px;position:absolute;background:white;padding:5px;box-shadow:0 0 20px #0000004d;transform:translate(-50%);-webkit-transform:translateX(-50%);-webkit-box-shadow:0 0 20px rgba(0,0,0,.3);opacity:1}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{margin:0;opacity:1!important}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]{display:flex;height:115px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 10px 10px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-red[_ngcontent-%COMP%]{color:red;font-family:CiscoSans;font-size:18px;line-height:26px;letter-spacing:.5px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#000;font-family:CiscoSansLight;font-size:12px;opacity:.7}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]:hover{opacity:1!important}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]{width:100%;border-top:1px solid #b2a6a6;text-align:center;padding-top:5px}.modalContent-act[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]   .popup-footer-text[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:13px;color:#fff}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NetworkSyncStatusComponent, [{
        type: Component,
        args: [{
                selector: "app-network-sync-status",
                templateUrl: "./network-sync-status.component.html",
                styleUrls: ["./network-sync-status.component.scss"]
            }]
    }], function () { return [{ type: i1.Router }, { type: LocationService }, { type: InteractionService }, { type: DataService }]; }, null); })();

function MagneticBaseComponent_lib_app_open_roaming_global_stats_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-app-open-roaming-global-stats");
} }
function MagneticBaseComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "app-footer-icp-logo", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("properties", ctx_r2.properties);
} }
function MagneticBaseComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "app-smart-license-popup", 20);
    i0.ɵɵlistener("hideActivationPopup", function MagneticBaseComponent_div_22_Template_app_smart_license_popup_hideActivationPopup_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.hideActivationPopup($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fromPage", "welcome");
} }
function getBaseUrl$2() {
    return document.getElementsByTagName("base")[0].href;
}
class MagneticBaseComponent {
    constructor(dataService, translate, _location, authService, browserlocation, dialog, router, baseUrl) {
        this.dataService = dataService;
        this.translate = translate;
        this._location = _location;
        this.authService = authService;
        this.browserlocation = browserlocation;
        this.dialog = dialog;
        this.router = router;
        this.unsubscribe$ = new Subject();
        this.baseUrl = "/";
        // showFullScreen;
        // isUserLoggedIn;
        this.menuItems = [];
        this.selectedMenuItem = null;
        this.previousState = null;
        // enableWiredNetwork = false;
        this.isBackPressed = false;
        this.properties = null;
        // @ViewChild('sidenav') sidenav: MatSidenav;
        this.isExpanded = true;
        this.supportSectionVisible = false;
        // showSubmenu: boolean = false;
        // isShowing = false;
        // showSubSubMenu: boolean = false;
        this.selectedApp = {
            icon: 'icon-home',
            name: 'Dashboard',
            contextUrl: '/base'
        };
        // openroaming stats
        this.isOpenRoamingEnable = false;
        this.showReports = false;
        this.isDashboardUser = false;
        this.isRootLayout = true;
        this.smartLicensePopupVisible = false;
        this.showSyncStatusFromSetup = false;
        this.showNetworkStatus = false;
        this.isMatchedMenu = (menuItems) => {
            let isMatched = false;
            menuItems.forEach(menu => {
                if (menu.childNodes) {
                    menu.childNodes.forEach(child => {
                        if (location.href.indexOf(child["routeUrl"]) > -1) {
                            isMatched = true;
                        }
                    });
                }
                if (location.href.indexOf(menu['routeUrl']) > -1) {
                    isMatched = true;
                }
            });
            return isMatched;
        };
        this.toggleMagneticAppMenu = () => {
            this.isExpanded = !this.isExpanded;
            this.dataService.setMagneticAppIsExpanded(this.isExpanded);
        };
        this.goToSmartLicensePopup = () => {
            this.smartLicensePopupVisible = true;
        };
        this.hideActivationPopup = ($event) => {
            this.smartLicensePopupVisible = $event;
        };
        this.onSelectedItem = ($event) => {
            if ($event) {
                // show openroaming reports only statistics page
                this.showReports = false;
                if ($event.routeUrl == "/openroaming/statistics") {
                    this.showReports = true;
                }
                //unselect previous item
                this.unSelectMenu($event.routeUrl, this.menuItems);
                this.selectedMenuItem = $event.routeUrl;
                this.dataService.setMagneticMenuRouteUrl($event.magRoute !== undefined || $event.magRoute !== 'null' ? $event.magRoute : $event.routeUrl);
            }
        };
        this.unSelectMenu = (selRouteUrl, menuItems) => {
            if (menuItems) {
                menuItems.forEach(menuItem => {
                    if (menuItem.routeUrl !== selRouteUrl) {
                        menuItem.selected = false;
                        if (menuItem.childNodes) {
                            this.unSelectMenu(selRouteUrl, menuItem.childNodes);
                        }
                    }
                });
            }
        };
        this.getLocaleText = () => {
            // this.translate.get('dashboard-lib.base-component.menu.menuEngagementRules').subscribe((res: string) => {
            // 	this.messageKeys["menuEngagementRulesKey"] = res;
            // });
            // this.translate.get('dashboard-lib.base-component.menu.menuVisitorEngagement').subscribe((res: string) => {
            // 	this.messageKeys["menuVisitorEngagementKey"] = res;
            // });
        };
        this.setMenu = () => {
            let home = new NavigationHomeModel('home', 'nav', 'dashboard-lib.base-component.menu.menuHome', 'icon-dashboard-home', true, true, '/home', {}, []);
            let location = new NavigationHomeModel('location', 'nav', 'dashboard-lib.base-component.menu.menuLocationHierarchy', 'icon-dashboard-location-hierarchy', true, false, '/location', {}, []);
            let monitor = new NavigationHomeModel('monitoring', 'nav', 'dashboard-lib.base-component.menu.menuMonitor', 'icon-dashboard-monitor', true, false, '/monitor', {}, []);
            let admin_management = new NavigationHomeModel('admin-management', 'nav', 'dashboard-lib.base-component.menu.menuAdminManagement', 'icon-dashboard-admin-management', true, false, '/team', {}, []);
            let wireless = new NavigationHomeModel('wireless', 'nav', 'dashboard-lib.base-component.menu.menuWirelessNetwork', "", true, false, '/setup/wirelessnetwork', {}, []);
            let wired = new NavigationHomeModel('wired', 'nav', 'dashboard-lib.base-component.menu.menuWiredNetwork', "", true, false, '/setup/wirednetwork', {}, []);
            let maps = new NavigationHomeModel('maps', 'nav', 'dashboard-lib.base-component.menu.menuMapService', "", true, false, '/setup/maps', {}, []);
            let meraki_camera = new NavigationHomeModel('meraki-camera', 'nav', 'dashboard-lib.base-component.menu.menuCamera', "", true, false, '/setup/camera', {}, []);
            let sensors = new NavigationHomeModel('sensors', 'nav', 'dashboard-lib.base-component.menu.menuSensors', "", true, false, '/setup/sensors', {}, []);
            let data_export = new NavigationHomeModel('data-export', 'nav', 'dashboard-lib.base-component.menu.dataExport', "", true, false, '/setup/dataexport', {}, []);
            let webex = new NavigationHomeModel('webex', 'nav', 'dashboard-lib.base-component.menu.menuWebex', "", true, false, '/setup/webex', {}, []);
            let pxGrid = new NavigationHomeModel('pxgrid', 'nav', 'dashboard-lib.base-component.menu.menuPxGridCloud', "", true, false, '/setup/pxgrid', {}, []);
            let devicePlacement = new NavigationHomeModel('device-placement', 'nav', 'dashboard-lib.base-component.menu.menuDevicePlacement', "", true, false, '/setup/device-placement', {}, []);
            let locations_maps = new NavigationHomeModel('locations-maps', 'nav', 'dashboard-lib.base-component.menu.locationsMaps', "", true, false, '/setup/locations-maps', {}, []);
            let plugins = new NavigationHomeModel('plugins-home', 'nav', 'dashboard-lib.base-component.menu.plugins', "", true, false, '/setup/plugins', {}, []);
            const setup_sub_menu = [];
            setup_sub_menu.push(wireless);
            setup_sub_menu.push(wired);
            setup_sub_menu.push(maps);
            setup_sub_menu.push(locations_maps);
            setup_sub_menu.push(meraki_camera);
            // adding sensors menu
            setup_sub_menu.push(sensors);
            // Adding Data Export menu
            setup_sub_menu.push(data_export);
            if (this.dataService.getWebexEnableMenu()) {
                // adding webex menu
                setup_sub_menu.push(webex);
            }
            setup_sub_menu.push(pxGrid);
            // adding device placement navigation link
            if (this.dataService.getDevicePlacementNavEnabled()) {
                setup_sub_menu.push(devicePlacement);
            }
            if (this.dataService.getDevicePlacementNavEnabled()) {
                setup_sub_menu.push(plugins);
            }
            let setup = new NavigationHomeModel('setup', 'nav', 'dashboard-lib.base-component.menu.menuSetup', 'icon-dashboard-setup', true, false, "/setup", {}, setup_sub_menu);
            let iot_about = new NavigationHomeModel('iot_about', 'nav', 'dashboard-lib.base-component.menu.menuIotAbout', "", true, false, '/devices/about', {}, []);
            let iot_gateways = new NavigationHomeModel('iot_gateways', 'nav', 'dashboard-lib.base-component.menu.menuIoTGateways', "", true, false, '/devices/iot-gateway-management', {}, []);
            let device_management = new NavigationHomeModel('device_management', 'nav', 'dashboard-lib.base-component.menu.menuDeviceManagement', "", true, false, '/devices/device_management', {}, []);
            let device_monitoring = new NavigationHomeModel('device_monitoring', 'nav', 'dashboard-lib.base-component.menu.menuDeviceMonitoring', "", true, false, '/devices/device_monitoring', {}, []);
            let iot_services = new NavigationHomeModel('devices', 'nav', 'dashboard-lib.base-component.menu.menuIoTServices', 'icon-dashboard-iot-services', true, false, "", {}, [iot_about, iot_gateways, device_management, device_monitoring]);
            let integrations_base = new NavigationHomeModel('integrations', 'nav', 'dashboard-lib.base-component.menu.menuIntegrationsBase', 'integrations-icon-plug', true, false, '/integrations', null, []);
            let dnac = new NavigationHomeModel('dnac', 'nav', 'dashboard-lib.base-component.menu.menuCiscoDNACenter', "", true, false, '/integrations/dnac', {}, []);
            let sdk = new NavigationHomeModel('sdk', 'nav', 'dashboard-lib.base-component.menu.menuCiscoDNASpacesSDK', null, true, false, '/configure/sdk', null, []);
            let navigations = [home, location];
            let configureLinksArray = [];
            configureLinksArray.push(sdk);
            if (this.dataService.getShowIntegrations()) {
                // Add servicenow menu under Integrations only if customer has ACT(Advanced Subscription) license
                let configure = new NavigationHomeModel('configure', 'nav', 'dashboard-lib.base-component.menu.menuConfigure', 'icon-configure-bar', true, false, null, null, configureLinksArray);
                navigations.push(integrations_base);
                navigations.push(configure);
            }
            navigations.push(monitor);
            navigations.push(admin_management);
            if (this.dataService.getAccountServices("EdgeDeviceManager")) {
                navigations.push(iot_services);
            }
            navigations.push(setup);
            this.dataService.setMagneticMenu(navigations);
        };
        this.getUserRole = () => {
            this.authService.getRole(this.unsubscribe$).subscribe((roleBehavior) => {
                if (roleBehavior && roleBehavior.appRole) {
                    this.isDashboardUser = this.dataService.getIsDashboardUser();
                }
                else {
                    this.isDashboardUser = false;
                }
            }, (error) => {
                console.log(error);
            });
        };
        this.goToHomePage = () => {
            this.currentNav = this.isDashboardUser ? "base" : this.selectedApp.contextUrl;
            this.router.navigate(["/" + this.currentNav + "/"]);
            this.dataService.setCurrentNav(this.currentNav);
        };
        this.getDashboardProperties = () => {
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$)
                .then((properties) => {
                this.properties = properties['value'];
            });
        };
        this.navChange = ($event) => {
            this.currentNav = $event;
            this.currentNavLabel = $event.label;
            if (this.previousState !== this.currentNav.id &&
                this._location.path() === this.currentNav.id) {
                let currentNavValue = this.currentNav.id;
                // if (
                // 	location.pathname.indexOf("captiveportal") > -1 &&
                // 	currentNavValue.toString().startsWith("/")
                // ) {
                // 	currentNavValue = this.currentNav.id
                // 		.toString()
                // 		.substring(1, this.currentNav.id.length);
                // }
                // if (
                // 	location.pathname.indexOf("setup/wirelessnetwork") > -1 &&
                // 	currentNavValue.toString().startsWith("/")
                // ) {
                // 	currentNavValue = this.currentNav.id
                // 		.toString()
                // 		.substring(1, this.currentNav.id.length);
                // }
                window.history.pushState({}, this.currentNavLabel, this.baseUrl + currentNavValue);
                this.previousState = this.currentNav.id;
                console.log("nav changed", $event);
            }
        };
        console.log("MagneticBaseComponent::constructor");
        this.baseUrl = baseUrl;
    }
    ngOnInit() {
        this.getLocaleText();
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getLocaleText();
        });
        this.getUserRole();
        this.isOpenRoamingEnable = location.pathname.indexOf("openroaming") > -1 ? true : false;
        // this.isUserLoggedIn = this.dataService.getAccessToken() != null;
        this.getDashboardProperties();
        // this.isDashboardUser = this.dataService.getIsDashboardAdmin();
        // this.dataService.setHamburgerPage("base");
        // this.dataService
        // 	.getHamburgerPage(this.unsubscribe$)
        // 	.subscribe((hamObj) => {
        // 		switch (hamObj.page) {
        // 			case "": {
        // 				this.initializeBaseNav();
        // 				break;
        // 			}
        // 			case "base": {
        // 				this.initializeBaseNav();
        // 				break;
        // 			}
        // 			case "engagement": {
        // 				this.initializeEngagementNav();
        // 				break;
        // 			}
        // 			default: {
        // 				this.initializeBaseNav();
        // 				break;
        // 			}
        // 		}
        // 	});
        // this.enableWiredNetwork = this.dataService.getEnableWiredNetwork();
        this.browserlocation.onPopState(() => {
            console.log("pressed back!");
            this.isBackPressed = true;
        });
        this.dataService.getSelectedApp(this.unsubscribe$).subscribe((selectedApp) => {
            if (selectedApp.name)
                this.selectedApp = selectedApp;
        });
        if (this.dataService.getCurrentNav() === '/base') {
            this.dataService.setMagneticMenuRouteUrl(this.dataService.getCurrentNav());
        }
        this.dataService.getMagneticMenu(this.unsubscribe$).subscribe((menuItems) => {
            if (!menuItems || menuItems.length === 0)
                return;
            console.log('menuItems>>>>>>>', menuItems);
            // if (location && location.pathname != '/' && menuItems.length > 0) {
            //   if (location.href.indexOf(menuItems[0].routeUrl) == -1) {
            //     return;
            //   }
            // }
            if (location && location.pathname != '/' && menuItems.length > 0) {
                if (!this.isMatchedMenu(menuItems)) {
                    return;
                }
            }
            this.menuItems = menuItems;
            setTimeout(() => {
                if (!this.selectedMenuItem) {
                    // Set route to first menu tem
                    this.currentNav = this.menuItems[0].routeUrl;
                    this.dataService.setCurrentNav(this.currentNav);
                    this.router.navigate([this.currentNav]);
                    this.dataService.getDashLandingUrl(this.unsubscribe$).subscribe((setDashLandingUrl) => {
                        if (setDashLandingUrl) {
                            this.dataService.setDashLandingUrl("");
                            setTimeout(() => {
                                this.dataService.setCurrentNav(setDashLandingUrl);
                                this.router.navigate([setDashLandingUrl]);
                            }, 700);
                        }
                    });
                }
            }, 1500);
        });
        if (this.isRootLayout) {
            setTimeout(() => {
                this.dataService.setSelectedApp({
                    "key": "dashboard",
                    icon: 'dashboard',
                    name: "dashboard-lib.homepage.tiles.dashboard.display.title",
                    contextUrl: '/base'
                });
                this.setMenu();
            }, 500);
        }
        else {
            this.dataService.setMagneticMenu([]);
        }
        this.dataService.getMagneticAppIsExpanded(this.unsubscribe$).subscribe((isExpanded) => {
            this.isExpanded = isExpanded;
        });
        this.dataService.closeMagneticPopup();
    }
    openProfileDialog() {
        const dialogRef = this.dialog.open(MagneticProfileDialogComponent);
        dialogRef.afterClosed().subscribe(result => {
            console.log(`Dialog result: ${result}`);
            if (result === 'smartLicense') {
                this.goToSmartLicensePopup();
            }
        });
        $(".cdk-overlay-dark-backdrop").css("background", "rgb(255 255 255 / 0%)");
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        this.dialog.closeAll();
        console.log("destory Magnetic Base");
    }
}
MagneticBaseComponent.ɵfac = function MagneticBaseComponent_Factory(t) { return new (t || MagneticBaseComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i1$2.Location), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(i1$2.PlatformLocation), i0.ɵɵdirectiveInject(i4$2.MatDialog), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject("BASE_URL")); };
MagneticBaseComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MagneticBaseComponent, selectors: [["app-magnetic-base"]], inputs: { isUserCurrentStatusLoaded: "isUserCurrentStatusLoaded", isRootLayout: "isRootLayout" }, features: [i0.ɵɵProvidersFeature([
            Location$1,
            { provide: LocationStrategy, useClass: PathLocationStrategy },
            { provide: "BASE_URL", useFactory: getBaseUrl$2 }
        ])], decls: 23, vars: 12, consts: [["id", "appContainer", 1, "appContainer"], ["color", "primary", 1, "container-toolbar"], ["mat-icon-button", "", 1, "nav-toggler", 3, "click"], [1, "container-app-name", 3, "click"], [1, "spacer-flex"], [1, "align-left-icons"], [1, "header-divider-v"], ["vertical", "true", 1, "nav-divider-v"], [1, "header-profile", 3, "click"], [1, "container-sidenav-container"], ["mode", "side", "opened", "true", "disableClose", "true", 1, "magnetic-side-nav"], ["snav", ""], [3, "selectedApp", "isRootLayout", "isAppExpanded"], ["inset", "true", 1, "nav-divider"], [3, "menuItemArray", "isExpanded", "selectedItem"], [1, "magnetic-side-content"], [4, "ngIf"], ["class", "footerICPLogo", 4, "ngIf"], [1, "footerICPLogo"], [3, "properties"], [3, "fromPage", "hideActivationPopup"]], template: function MagneticBaseComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "lib-setup-notify");
        i0.ɵɵelementStart(2, "mat-toolbar", 1);
        i0.ɵɵelementStart(3, "a", 2);
        i0.ɵɵlistener("click", function MagneticBaseComponent_Template_a_click_3_listener() { return ctx.toggleMagneticAppMenu(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "h1", 3);
        i0.ɵɵlistener("click", function MagneticBaseComponent_Template_h1_click_4_listener() { return ctx.goToHomePage(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "div", 4);
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelement(7, "app-magnetic-help-section");
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelement(9, "mat-divider", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵlistener("click", function MagneticBaseComponent_Template_div_click_10_listener() { return ctx.openProfileDialog(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "mat-sidenav-container", 9);
        i0.ɵɵelementStart(12, "mat-sidenav", 10, 11);
        i0.ɵɵelement(14, "app-magnetic-app-selection", 12);
        i0.ɵɵelement(15, "mat-divider", 13);
        i0.ɵɵelementStart(16, "app-magnetic-menu-item", 14);
        i0.ɵɵlistener("selectedItem", function MagneticBaseComponent_Template_app_magnetic_menu_item_selectedItem_16_listener($event) { return ctx.onSelectedItem($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "mat-sidenav-content", 15);
        i0.ɵɵtemplate(18, MagneticBaseComponent_lib_app_open_roaming_global_stats_18_Template, 1, 0, "lib-app-open-roaming-global-stats", 16);
        i0.ɵɵelement(19, "router-outlet");
        i0.ɵɵtemplate(20, MagneticBaseComponent_div_20_Template, 2, 1, "div", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(21, "app-network-sync-status");
        i0.ɵɵtemplate(22, MagneticBaseComponent_div_22_Template, 2, 1, "div", 16);
    } if (rf & 2) {
        i0.ɵɵadvance(12);
        i0.ɵɵstyleProp("width", ctx.isExpanded ? 262 : 69, "px");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("selectedApp", ctx.selectedApp)("isRootLayout", ctx.isRootLayout)("isAppExpanded", ctx.isExpanded);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("menuItemArray", ctx.menuItems)("isExpanded", ctx.isExpanded);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("margin-left", ctx.isExpanded ? 262 : 69, "px");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isOpenRoamingEnable && ctx.showReports);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.properties && ctx.properties.icpLogoVisible);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.smartLicensePopupVisible);
    } }, directives: [SetupNotifyComponent, i8$1.MatToolbar, MagneticHelpSectionComponent, i5$2.MatDivider, i11.MatSidenavContainer, i11.MatSidenav, MagneticAppSelectionComponent, MagneticMenuItemComponent, i11.MatSidenavContent, i1$2.NgIf, i1.RouterOutlet, NetworkSyncStatusComponent, OpenRoamingGlobalStatsComponent, FooterIcpLogoComponent, SmartLicensePopupComponent], styles: ["@font-face{font-family:\"ciscoSansRegular\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansBold\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Bold.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansThin\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Thin.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansExtraLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansLight\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_ExtraLight.svg) format(\"svg\")}@font-face{font-family:\"ciscoSansCondensed\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans_Condensed.svg) format(\"svg\")}@font-face{font-family:\"ciscoSans\";font-display:auto;src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot);src:url(/assets/fonts/Cisco_Sans/CiscoSans.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff2) format(\"woff2\"),url(/assets/fonts/Cisco_Sans/CiscoSans.woff) format(\"woff\"),url(/assets/fonts/Cisco_Sans/CiscoSans.ttf) format(\"truetype\"),url(/assets/fonts/Cisco_Sans/CiscoSans.svg) format(\"svg\")}@font-face{font-family:\"icomoon\";font-display:auto;src:url(/assets/fonts/icomoon.eot?llzbkh);src:url(/assets/fonts/icomoon.eot?llzbkh#iefix) format(\"embedded-opentype\"),url(/assets/fonts/icomoon.ttf?llzbkh) format(\"truetype\"),url(/assets/fonts/icomoon.woff?llzbkh) format(\"woff\"),url(/assets/fonts/icomoon.svg?llzbkh#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"icomoon-new\";font-display:auto;src:url(/assets/fonts/icomoonnew/icomoon.eot?-psryvp);src:url(/assets/fonts/icomoonnew/icomoon.eot?#iefix-psryvp) format(\"embedded-opentype\"),url(/assets/fonts/icomoonnew/icomoon.ttf?-psryvp) format(\"truetype\"),url(/assets/fonts/icomoonnew/icomoon.woff?-psryvp) format(\"woff\"),url(/assets/fonts/icomoonnew/icomoon.svg?-psryvp#icomoon) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"Roboto-Bold\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Bold.eot);src:url(/assets/fonts/Roboto/Roboto-Bold.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Bold.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Bold.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Bold.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Bold.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Light\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Light.eot);src:url(/assets/fonts/Roboto/Roboto-Light.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Light.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Light.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Light.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Light.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Medium\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Medium.eot);src:url(/assets/fonts/Roboto/Roboto-Medium.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Medium.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Medium.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Medium.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Medium.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Roboto-Regular\";font-display:auto;src:url(/assets/fonts/Roboto/Roboto-Regular.eot);src:url(/assets/fonts/Roboto/Roboto-Regular.eot) format(\"embedded-opentype\"),url(/assets/fonts/Roboto/Roboto-Regular.ttf) format(\"truetype\"),url(/assets/fonts/Roboto/Roboto-Regular.woff?llzbkh) format(\"woff\"),url(/assets/fonts/Roboto/Roboto-Regular.woff2?llzbkh) format(\"woff2\"),url(/assets/fonts/Roboto/Roboto-Regular.svg?llzbkh#icomoon) format(\"svg\")}@font-face{font-family:\"Inter\";font-display:auto;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}.appContainer[_ngcontent-%COMP%]{display:flex;flex-direction:column;position:absolute;top:0;bottom:0;left:0;right:0;padding:0;margin:0;height:100vh;overflow-y:auto;color:#f6f6f7}.magnetic-side-nav[_ngcontent-%COMP%]{transition:width .6s cubic-bezier(.7,0,.3,1),opacity .6s cubic-bezier(.7,0,.3,1);border-right:1px solid #D1D1D2}.magnetic-side-nav[_ngcontent-%COMP%]   .nav-divider[_ngcontent-%COMP%]{width:-webkit-fill-available;margin:0 16px;color:#d1d1d2}.magnetic-side-nav-item-sel[_ngcontent-%COMP%]{background:rgba(224,224,224,.6);border-radius:8px;width:-webkit-fill-available}.magnetic-side-content[_ngcontent-%COMP%]{transition:margin-left .6s cubic-bezier(.7,0,.3,1),opacity .6s cubic-bezier(.7,0,.3,1);color:#464c54}.appContainer[_ngcontent-%COMP%]   .container-toolbar[_ngcontent-%COMP%]{position:sticky;z-index:0!important;padding-left:22px;width:100vw;height:56px;top:0px;background:linear-gradient(90deg,#0D274D .29%,#1E4471 100%)}.appContainer[_ngcontent-%COMP%]   .container-toolbar[_ngcontent-%COMP%]   .nav-toggler[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;margin-right:8px;background:url(/assets/images/magnetic/header/menu_icon.svg);background-position:center;width:24px;height:24px;background-repeat:no-repeat;cursor:pointer;position:relative}.appContainer[_ngcontent-%COMP%]   .container-toolbar[_ngcontent-%COMP%]   .nav-toggler[_ngcontent-%COMP%]:hover{opacity:.9}.appContainer[_ngcontent-%COMP%]   .container-toolbar[_ngcontent-%COMP%]   .nav-toggler[_ngcontent-%COMP%]:active{transform:translateY(4px);transition:transform .3s linear}.appContainer[_ngcontent-%COMP%]   .container-toolbar[_ngcontent-%COMP%]   .align-left-icons[_ngcontent-%COMP%]{width:min-content;height:24px}.appContainer[_ngcontent-%COMP%]   .container-toolbar[_ngcontent-%COMP%]   .align-left-icons[_ngcontent-%COMP%]   .header-divider-v[_ngcontent-%COMP%]{display:inline-block;color:#d0d4d9;padding:0 10px}.appContainer[_ngcontent-%COMP%]   .container-toolbar[_ngcontent-%COMP%]   .align-left-icons[_ngcontent-%COMP%]   .header-divider-v[_ngcontent-%COMP%]   .nav-divider-v[_ngcontent-%COMP%]{height:23px}.appContainer[_ngcontent-%COMP%]   .container-toolbar[_ngcontent-%COMP%]   .align-left-icons[_ngcontent-%COMP%]   .header-profile[_ngcontent-%COMP%]{background:url(/assets/images/magnetic/header/profile.svg);background-position:center;width:24px;height:24px;background-repeat:no-repeat;cursor:pointer;position:relative;display:inline-block;padding:0 16px}.appContainer[_ngcontent-%COMP%]   .container-toolbar[_ngcontent-%COMP%]   .align-left-icons[_ngcontent-%COMP%]   .header-global-switcher[_ngcontent-%COMP%]{background:url(/assets/images/magnetic/header/global_switcher.svg);background-position:center;width:24px;height:24px;background-repeat:no-repeat;cursor:pointer;position:relative;display:inline-block;padding:0 22px}h1.container-app-name[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;background:url(/assets/images/cisco-spaces-logo.svg);background-position:center;width:150px;height:24px;background-repeat:no-repeat;cursor:pointer;position:relative}.container-sidenav-container[_ngcontent-%COMP%]{flex:1;margin-top:0;position:sticky}.container-is-mobile[_ngcontent-%COMP%]   .container-sidenav-container[_ngcontent-%COMP%], .spacer-flex[_ngcontent-%COMP%]{flex:1 0 auto}.footerICPLogo[_ngcontent-%COMP%]{width:100%;background-color:#262e39;position:fixed;bottom:0;left:50%;transform:translate(-50%)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MagneticBaseComponent, [{
        type: Component,
        args: [{
                selector: "app-magnetic-base",
                providers: [
                    Location$1,
                    { provide: LocationStrategy, useClass: PathLocationStrategy },
                    { provide: "BASE_URL", useFactory: getBaseUrl$2 }
                ],
                templateUrl: "./magnetic-base.component.html",
                styleUrls: ["./magnetic-base.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }, { type: i1$2.Location }, { type: AuthService }, { type: i1$2.PlatformLocation }, { type: i4$2.MatDialog }, { type: i1.Router }, { type: undefined, decorators: [{
                type: Inject,
                args: ["BASE_URL"]
            }] }]; }, { isUserCurrentStatusLoaded: [{
            type: Input
        }], isRootLayout: [{
            type: Input
        }] }); })();

function MagneticConfirmationDialogComponent_div_8_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.reports-rules.liveEngagementRule"), " ");
} }
function MagneticConfirmationDialogComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MagneticConfirmationDialogComponent_div_8_div_4_Template, 3, 3, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "dashboard-lib.reports-rules.confirmationPauseHeader"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r0.data == null ? null : ctx_r0.data.customData.currentSelectedTab) === "Engagement");
} }
function MagneticConfirmationDialogComponent_div_9_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "dashboard-lib.reports-rules.confirmationDeleteEngagement"), " ");
} }
function MagneticConfirmationDialogComponent_div_9_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MagneticConfirmationDialogComponent_div_9_div_3_div_1_Template, 3, 3, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r14.data == null ? null : ctx_r14.data.customData.currentSelectedTab) === "Engagement");
} }
function MagneticConfirmationDialogComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MagneticConfirmationDialogComponent_div_9_div_3_Template, 2, 1, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.data == null ? null : ctx_r1.data.message, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r1.data == null ? null : ctx_r1.data.customData == null ? null : ctx_r1.data.customData.ruleCurrentState) === "LIVE" || (ctx_r1.data == null ? null : ctx_r1.data.customData == null ? null : ctx_r1.data.customData.selectedRules.pause.length) > 0);
} }
function MagneticConfirmationDialogComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.data == null ? null : ctx_r2.data.message, " ");
} }
function MagneticConfirmationDialogComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 18);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, "dashboard-lib.reports-rules.confirmationPopupMainText"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 4, "dashboard-lib.reports-rules.confirmationPopupSubText"), " ");
} }
function MagneticConfirmationDialogComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.data == null ? null : ctx_r4.data.message, " ");
} }
function MagneticConfirmationDialogComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("mat-dialog-close", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.reports-rules.confirmationPauseBtn"), " ");
} }
function MagneticConfirmationDialogComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("mat-dialog-close", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.reports-rules.confirmationDeleteBtn"), " ");
} }
function MagneticConfirmationDialogComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("mat-dialog-close", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.reports-rules.confirmationDeleteuserBtn"), " ");
} }
function MagneticConfirmationDialogComponent_span_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵtext(1, "|");
    i0.ɵɵelementEnd();
} }
function MagneticConfirmationDialogComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("mat-dialog-close", false);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.reports-rules.confirmationCancelBtn"), " ");
} }
function MagneticConfirmationDialogComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("mat-dialog-close", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.reports-rules.resend"), " ");
} }
function MagneticConfirmationDialogComponent_button_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("mat-dialog-close", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "dashboard-lib.reports-rules.ok"), " ");
} }
function MagneticConfirmationDialogComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 24);
    i0.ɵɵtext(5, "|");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 21);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 24);
    i0.ɵɵtext(10, "|");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 21);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("mat-dialog-close", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, "dashboard-lib.reports-rules.confirmationPopupSaveChangesBtn"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("mat-dialog-close", "DISCARD");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 8, "dashboard-lib.reports-rules.confirmationPopupDiscardChangesBtn"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("mat-dialog-close", false);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 10, "dashboard-lib.reports-rules.confirmationPopupCancelBtn"), " ");
} }
class MagneticConfirmationDialogComponent {
    // materialDialogData: ConfirmDialogData;
    constructor(data, dataService) {
        this.data = data;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.getStaticText = () => {
        };
        console.log("MagneticConfirmationDialogComponent:: dialog");
    }
    ngOnInit() {
        setTimeout(() => {
            $(".cdk-overlay-container").css("position", "unset");
        }, 2000);
        this.getStaticText();
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        // this.mobileQuery.removeListener(this._mobileQueryListener);
        console.log("destory Magnetic confirm dialog");
    }
}
MagneticConfirmationDialogComponent.ɵfac = function MagneticConfirmationDialogComponent_Factory(t) { return new (t || MagneticConfirmationDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(DataService)); };
MagneticConfirmationDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MagneticConfirmationDialogComponent, selectors: [["app-magnetic-confirmation-dialog"]], decls: 24, vars: 14, consts: [[1, "confirmation-popup"], [1, "exclamation-icon"], ["src", "/assets/images/notification_icon.svg", "width", "70", "alt", "exclamation-icon"], [1, "confirmation-popup-close", 3, "mat-dialog-close"], [1, "confirmation-message"], [4, "ngIf"], [2, "align-self", "center"], [1, "confirmation-button-wrapper"], ["class", "confirmation-primary-button", 3, "mat-dialog-close", 4, "ngIf"], ["style", "position: relative; left: -10px", 4, "ngIf"], ["class", "confirmation-cancel", 3, "mat-dialog-close", 4, "ngIf"], ["class", "squareButtonPrimary modalPrimaryButton", 3, "mat-dialog-close", 4, "ngIf"], [1, "confirmation-button-wrapper_rule"], ["class", "confirmation-button", 4, "ngIf"], [1, "conf-header"], ["class", "conf-subheader", 4, "ngIf"], [1, "conf-subheader"], [1, "conf-main-text"], [1, "conf-sub-text"], [1, "confirmation-primary-button", 3, "mat-dialog-close"], [2, "position", "relative", "left", "-10px"], [1, "confirmation-cancel", 3, "mat-dialog-close"], [1, "squareButtonPrimary", "modalPrimaryButton", 3, "mat-dialog-close"], [1, "confirmation-button"], [1, "vertical-line"]], template: function MagneticConfirmationDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-dialog-content");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelement(3, "img", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "mat-dialog-actions");
        i0.ɵɵelementStart(5, "span", 3);
        i0.ɵɵtext(6, " \uE909 ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵtemplate(8, MagneticConfirmationDialogComponent_div_8_Template, 5, 4, "div", 5);
        i0.ɵɵtemplate(9, MagneticConfirmationDialogComponent_div_9_Template, 4, 2, "div", 5);
        i0.ɵɵtemplate(10, MagneticConfirmationDialogComponent_div_10_Template, 3, 1, "div", 5);
        i0.ɵɵtemplate(11, MagneticConfirmationDialogComponent_div_11_Template, 8, 6, "div", 5);
        i0.ɵɵtemplate(12, MagneticConfirmationDialogComponent_div_12_Template, 4, 1, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "mat-dialog-actions", 6);
        i0.ɵɵelementStart(14, "div", 7);
        i0.ɵɵtemplate(15, MagneticConfirmationDialogComponent_div_15_Template, 3, 4, "div", 8);
        i0.ɵɵtemplate(16, MagneticConfirmationDialogComponent_div_16_Template, 3, 4, "div", 8);
        i0.ɵɵtemplate(17, MagneticConfirmationDialogComponent_div_17_Template, 3, 4, "div", 8);
        i0.ɵɵtemplate(18, MagneticConfirmationDialogComponent_span_18_Template, 2, 0, "span", 9);
        i0.ɵɵtemplate(19, MagneticConfirmationDialogComponent_div_19_Template, 3, 4, "div", 10);
        i0.ɵɵtemplate(20, MagneticConfirmationDialogComponent_div_20_Template, 3, 4, "div", 8);
        i0.ɵɵtemplate(21, MagneticConfirmationDialogComponent_button_21_Template, 3, 4, "button", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 12);
        i0.ɵɵtemplate(23, MagneticConfirmationDialogComponent_div_23_Template, 14, 12, "div", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("mat-dialog-close", false);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.confirmationType) === "pause");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.confirmationType) === "delete");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.confirmationType) !== "delete" && (ctx.data == null ? null : ctx.data.confirmationType) !== "pause" && (ctx.data == null ? null : ctx.data.confirmationType) !== "backPress" && (ctx.data == null ? null : ctx.data.confirmationType) !== "inviteSuccessPrompt");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.confirmationType) === "backPress");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.confirmationType) === "inviteSuccessPrompt");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.confirmationType) === "pause");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.confirmationType) === "delete");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.confirmationType) === "deletemultipleUser");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.confirmationType) !== "inviteSuccessPrompt" && (ctx.data == null ? null : ctx.data.confirmationType) !== "backPress");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.confirmationType) !== "inviteSuccessPrompt" && (ctx.data == null ? null : ctx.data.confirmationType) !== "backPress");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.confirmationType) === "resendInvite");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.confirmationType) === "inviteSuccessPrompt");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.confirmationType) === "backPress");
    } }, directives: [i4$2.MatDialogContent, i4$2.MatDialogActions, i4$2.MatDialogClose, i1$2.NgIf], pipes: [i2.TranslatePipe], styles: [".confirmation-popup[_ngcontent-%COMP%]{position:fixed;top:33%;left:50%;transform:translate(-50%);width:40%;height:30%;margin:0 auto;background-color:#fff;box-shadow:0 4px 8px #0000001a;border:0;z-index:1001;display:flex;justify-content:center;flex-direction:column;border-radius:5px}.confirmation-popup-close[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.confirmation-popup-close[_ngcontent-%COMP%]:hover{opacity:.8}.confirmation-button-wrapper[_ngcontent-%COMP%]{margin:0 auto;width:220px;text-align:center}.confirmation-button-wrapper_rule[_ngcontent-%COMP%]{margin:0 auto;width:70%;text-align:center}.confirmation-button[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}.confirmation-primary-button[_ngcontent-%COMP%]{border-radius:1.3em;background-color:#09c;color:#fff;font-family:ciscoSansLight;padding:0 18px;font-size:14px;height:34px;line-height:34px;cursor:pointer;float:left}.confirmation-primary-button[_ngcontent-%COMP%]:hover{opacity:.8}.confirmation-cancel[_ngcontent-%COMP%]{color:#848484!important;font-size:14px;text-decoration:none;cursor:pointer;line-height:30px;font-family:\"ciscoSansRegular\";padding:0 10px}.confirmation-cancel[_ngcontent-%COMP%]:hover{font-weight:bold}.conf-header[_ngcontent-%COMP%]{font-family:ciscoSansBold;font-size:17px;color:#353535}.conf-subheader[_ngcontent-%COMP%]{font-size:12px;padding-top:5px}.rule-status-message[_ngcontent-%COMP%]{position:fixed;top:-5px;left:40%;width:400px;height:50px;background:#06aa00;margin:0 auto;border-radius:5px;color:#fff;font-weight:bold;text-align:center;padding:15px 0}.confirmation-cancel[_ngcontent-%COMP%]{padding-left:15px;display:inline-block}.exclamation-icon[_ngcontent-%COMP%]{min-height:70px;min-width:70px;text-align:center;padding:0;position:absolute;left:50%;transform:translate(-50%);top:-20%;border:5px solid #fff;border-radius:50%;background:#fff;box-shadow:0 0 2px #84848480}.confirmation-message[_ngcontent-%COMP%]{text-align:center;padding:25px 0;font-size:15px;display:block;width:82%;margin:0 auto;color:#848484;font-family:\"ciscoSansRegular\"}.conf-sub-text[_ngcontent-%COMP%]{font-family:\"ciscoSansLight\";margin-top:10px;font-size:14px}.conf-main-text[_ngcontent-%COMP%]{font-size:15px;color:#484848}.confirmation-popup[_ngcontent-%COMP%]{align-self:center;margin-top:5px!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MagneticConfirmationDialogComponent, [{
        type: Component,
        args: [{
                selector: 'app-magnetic-confirmation-dialog',
                templateUrl: './magnetic-confirmation-dialog.component.html',
                styleUrls: ['./magnetic-confirmation-dialog.component.scss']
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: DataService }]; }, null); })();

function MagneticLocationPopupComponent_lib_manage_location_tree_26_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-manage-location-tree", 23);
    i0.ɵɵlistener("selectedLocationEvt", function MagneticLocationPopupComponent_lib_manage_location_tree_26_Template_lib_manage_location_tree_selectedLocationEvt_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.onSelectedLocation($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("permittedLocationTypes", ctx_r0.permittedLocationTypes)("isRichMapAvailable", ctx_r0.isRichMapAvailable)("multiLocationSelect", ctx_r0.multiSelect)("location", ctx_r0.locationTreeArray.location)("showAccessCode", false)("setSelectedLocation", ctx_r0.selectedLocation)("isPopup", true)("isReportsLocation", ctx_r0.isReportsLocation)("disableLicenseType", ctx_r0.disableLicenseType)("showAllLocations", ctx_r0.showAllLocations);
} }
function MagneticLocationPopupComponent_div_31_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "span", 30);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 31);
    i0.ɵɵlistener("click", function MagneticLocationPopupComponent_div_31_div_1_div_1_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r10); const location_r6 = i0.ɵɵnextContext().$implicit; const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.removeSelectedLocation(location_r6); });
    i0.ɵɵtext(4, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const location_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(location_r6.data.name);
} }
function MagneticLocationPopupComponent_div_31_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, MagneticLocationPopupComponent_div_31_div_1_div_1_Template, 5, 1, "div", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const location_r6 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", location_r6.data && location_r6.data.name);
} }
function MagneticLocationPopupComponent_div_31_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" - ", i0.ɵɵpipeBind1(2, 1, "shared-lib.location-popup.any"), " - ");
} }
function MagneticLocationPopupComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, MagneticLocationPopupComponent_div_31_div_1_Template, 2, 1, "div", 25);
    i0.ɵɵtemplate(2, MagneticLocationPopupComponent_div_31_div_2_Template, 3, 3, "div", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.selectedLocation);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r1.selectedLocation !== undefined && ctx_r1.selectedLocation !== null && ctx_r1.selectedLocation.length > 0 && ctx_r1.selectedLocation[0].data));
} }
class MagneticLocationPopupComponent {
    constructor(data, dataService, dialogRef) {
        this.data = data;
        this.dataService = dataService;
        this.dialogRef = dialogRef;
        this.unsubscribe$ = new Subject();
        this.isLocationPopupShown = false;
        this.preselectedLocation = [];
        // split license changes
        this.disableLicenseType = 'SEE';
        this.showAllLocations = true;
        /*
        to handle remove , select dialog to parent
          @Output()
          removeLocationEvt: EventEmitter<any> = new EventEmitter<any>();
      
          @Output()
          selectLocationPopupEvt: EventEmitter<any> = new EventEmitter<any>();
      
          @Output()
          cancelLocationPopupEvt: EventEmitter<any> = new EventEmitter<any>();
        */
        this.setMultiSelect = (multiSelect) => {
            this.multiSelect = multiSelect;
        };
        this.onSelectedLocation = ($event) => {
            //console.log( "Selected Location:: location popup::", $event );
            this.selectedLocation = $event;
            //console.log("Preselected after change::",this.preselectedLocation);
        };
        this.removeSelectedLocation = (node) => {
            let index = null;
            this.selectedLocation.filter(function (n, i) {
                if (n.data.id === node.data.id) {
                    index = i;
                    return i;
                }
                return null;
            });
            if (index !== null) {
                //console.log("Removing::",this.selectedLocation);
                this.selectedLocation.splice(index, 1);
                node.setIsExpanded(true);
            }
            else {
                //console.log("Selecting Location::",node);
                this.selectedLocation.push(node);
                node.setIsExpanded(false);
            }
            //console.log("Preselected after change::",this.preselectedLocation);
        };
        this.isEmptyObject = (obj) => {
            if (obj !== undefined && obj !== null) {
                const isEmptyObj = obj && Object.keys(obj).length === 0;
                //console.log( "Empty Object Check::", obj, isEmptyObj );
                return isEmptyObj;
            }
            else {
                return false;
            }
        };
        this.applySelectedLocations = () => {
            this.closeDialog(this.selectedLocation);
            //this.selectLocationPopupEvt.emit(this.selectedLocation);
            //close the dialog with true and this.selectedLocation to refresh the selection/deselection;
        };
        this.hideLocationPopup = () => {
            this.selectedLocation = [];
            //console.log('hiding locations popup',this.preselectedLocation);
            /*if (!this.isReportsLocation){
                //this.selectLocationPopupEvt.emit(this.preselectedLocation);
                this.closeDialog(stubFalse);
            }
            else this.closeDialog(false);*/
        };
        this.selectAllLocTypes = ($event) => {
            this.showAllLocations = $event.target.checked;
        };
        this.permittedLocationTypes = data.permittedLocationTypes;
        this.isRichMapAvailable = data.isRichMapAvailable;
        this.isReportsLocation = data.isReportsLocation;
        this.multiLocationSelect = data.multiLocationSelect;
        this.preSelectLocation = data.preSelectLocation;
        console.log("MagneticLocationDialogComponent:: dialog");
        this.dataService.getLocationWrap().then((val) => {
            //console.log(val);
            this.locationTreeArray = val;
            this.setMultiSelect(this.multiLocationSelect);
        });
    }
    set preSelectLocation($event) {
        this.selectedLocation = $event;
        this.preselectedLocation = $event.map((x) => Object.assign({}, x));
    }
    ngOnInit() {
        //console.log( 'location popup initialisation done',this.preselectedLocation );
        /*this.dataService.getLocationWrap().then((val: LocationWrap) => {
            //console.log(val);
            this.locationTreeArray = val;
            this.setMultiSelect(this.multiLocationSelect);
        });*/
    }
    ngOnDestroy() {
        this.isLocationPopupShown = false;
        this.locationTreeArray = null;
        this.selectedLocation = [];
        this.removeLocation = null;
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    closeDialog(selectedLocations) {
        //Write your stuff here
        this.dialogRef.close(selectedLocations); // <- Closes the dialog
    }
}
MagneticLocationPopupComponent.ɵfac = function MagneticLocationPopupComponent_Factory(t) { return new (t || MagneticLocationPopupComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i4$2.MatDialogRef)); };
MagneticLocationPopupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MagneticLocationPopupComponent, selectors: [["app-magnetic-location-popup"]], decls: 39, vars: 23, consts: [[1, "locationsPopupModal"], [1, "popupOverlay"], [1, "locationPopupContent"], [1, "locationPopupHeader"], [1, "locationPopupClose", 3, "mat-dialog-close", "click"], [1, "locationPopupBody"], [1, "locationPopupLeft"], [1, "divTable"], [1, "divTableCell"], [1, "divTableCell", 2, "text-align", "-webkit-right"], [1, "divTableCell", 2, "width", "20px"], [1, "circularCheckbox"], ["type", "checkbox", "id", "portalCheckbox-showAllLocations", 3, "checked", "click"], ["for", "portalCheckbox-showAllLocations", 1, "checkboxLabel"], [1, "portalNameLabel", "enableLabel"], [1, "locationHierarchyContainer"], ["class", "locPopup", 3, "permittedLocationTypes", "isRichMapAvailable", "multiLocationSelect", "location", "showAccessCode", "setSelectedLocation", "isPopup", "isReportsLocation", "disableLicenseType", "showAllLocations", "selectedLocationEvt", 4, "ngIf"], [1, "locationPopupRight"], [1, "selectedLocationsLabel"], ["class", "selectedLocationsList", 4, "ngIf"], [1, "locationPopupFooter"], ["mat-dialog-close", "", 1, "squareButtonPrimary", 3, "click"], [1, "cancelButton", 3, "mat-dialog-close"], [1, "locPopup", 3, "permittedLocationTypes", "isRichMapAvailable", "multiLocationSelect", "location", "showAccessCode", "setSelectedLocation", "isPopup", "isReportsLocation", "disableLicenseType", "showAllLocations", "selectedLocationEvt"], [1, "selectedLocationsList"], ["style", "display: inline-block", 4, "ngFor", "ngForOf"], ["class", "emptyLabel", 4, "ngIf"], [2, "display", "inline-block"], ["class", "labelChip", 4, "ngIf"], [1, "labelChip"], [1, "labelName"], [1, "labelClose", 3, "click"], [1, "emptyLabel"]], template: function MagneticLocationPopupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-dialog-content");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵelement(2, "div", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementStart(7, "span", 4);
        i0.ɵɵlistener("click", function MagneticLocationPopupComponent_Template_span_click_7_listener() { return ctx.hideLocationPopup(); });
        i0.ɵɵtext(8, "\uE909");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 5);
        i0.ɵɵelementStart(10, "div", 6);
        i0.ɵɵelementStart(11, "div", 7);
        i0.ɵɵelementStart(12, "div", 8);
        i0.ɵɵelementStart(13, "h4");
        i0.ɵɵtext(14);
        i0.ɵɵpipe(15, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 9);
        i0.ɵɵelementStart(17, "div", 10);
        i0.ɵɵelementStart(18, "span", 11);
        i0.ɵɵelementStart(19, "input", 12);
        i0.ɵɵlistener("click", function MagneticLocationPopupComponent_Template_input_click_19_listener($event) { return ctx.selectAllLocTypes($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(20, "label", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 8);
        i0.ɵɵelementStart(22, "span", 14);
        i0.ɵɵtext(23);
        i0.ɵɵpipe(24, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 15);
        i0.ɵɵtemplate(26, MagneticLocationPopupComponent_lib_manage_location_tree_26_Template, 1, 10, "lib-manage-location-tree", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 17);
        i0.ɵɵelementStart(28, "h4", 18);
        i0.ɵɵtext(29);
        i0.ɵɵpipe(30, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(31, MagneticLocationPopupComponent_div_31_Template, 3, 2, "div", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 20);
        i0.ɵɵelementStart(33, "button", 21);
        i0.ɵɵlistener("click", function MagneticLocationPopupComponent_Template_button_click_33_listener() { return ctx.applySelectedLocations(); });
        i0.ɵɵtext(34);
        i0.ɵɵpipe(35, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "button", 22);
        i0.ɵɵtext(37);
        i0.ɵɵpipe(38, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 11, "shared-lib.location-popup.choose-locs"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("mat-dialog-close", false);
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 13, "shared-lib.location-popup.loc-hierarchy"));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("checked", ctx.showAllLocations);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 15, "shared-lib.location-popup.show-all-locs"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.locationTreeArray && ctx.locationTreeArray.location && ctx.locationTreeArray.location.length > 0);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(30, 17, "shared-lib.location-popup.selected-locs"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selectedLocation);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(35, 19, "shared-lib.location-popup.done"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("mat-dialog-close", false);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(38, 21, "shared-lib.location-popup.cancel"), " ");
    } }, directives: [i4$2.MatDialogContent, i4$2.MatDialogClose, i1$2.NgIf, ManageLocationTreeComponent, i1$2.NgForOf], pipes: [i2.TranslatePipe], styles: ["[_nghost-%COMP%]{display:inline-block}.locationsPopupModal[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:1000;left:0;top:0}.popupOverlay[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:1000;background-color:#0009}.locationPopupContent[_ngcontent-%COMP%]{position:absolute;top:60px;left:50%;transform:translate(-50%);width:90%;height:80%;margin:0 auto;background-color:#fff;box-shadow:0 4px 8px #0000001a;border-radius:5px;border:0;z-index:1001}.locationPopupHeader[_ngcontent-%COMP%]{padding:18px 30px;color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:relative;height:60px;border-bottom:1px solid #EAEAEA}.locationPopupFooter[_ngcontent-%COMP%]{padding:7px 30px;color:#000;font-size:20px;font-family:\"ciscoSansRegular\";position:relative;height:60px;position:absolute;bottom:0;left:0;width:100%;border-top:1px solid #EAEAEA;background-color:#fff}.locationPopupClose[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.locationPopupLeft[_ngcontent-%COMP%]{width:60%;display:inline-block;padding:0 30px 10px}.locationPopupRight[_ngcontent-%COMP%]{width:39%;display:inline-block;padding:0 10px 10px 0;vertical-align:top}.locationPopupRight[_ngcontent-%COMP%]   .labelChip[_ngcontent-%COMP%]{margin-bottom:15px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MagneticLocationPopupComponent, [{
        type: Component,
        args: [{
                selector: 'app-magnetic-location-popup',
                templateUrl: './magnetic-location-popup.component.html',
                styleUrls: ['./magnetic-location-popup.component.scss']
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: DataService }, { type: i4$2.MatDialogRef }]; }, null); })();

const _c0$t = function (a0, a1) { return { loc: a0, searchTimestamp: a1 }; };
function ManageLocationTreeV3Component_lib_location_row_v2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-location-row-v2", 4);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("locationData", i0.ɵɵpureFunction2(6, _c0$t, ctx_r0.hierarchyLocations[0], ctx_r0.searchTimestamp))("level", 0)("showAccessCode", ctx_r0.showAccessCode)("isPopup", ctx_r0.isPopup)("locationCountResponse", ctx_r0.locationCountResponse)("userCount", ctx_r0.userCount);
} }
function ManageLocationTreeV3Component_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function ManageLocationTreeV3Component_div_2_div_2_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r7); const loc_r4 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.scrollToLocation(loc_r4); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const loc_r4 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", loc_r4.name, i0.ɵɵsanitizeHtml);
} }
function ManageLocationTreeV3Component_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1, " Jump to : ");
    i0.ɵɵtemplate(2, ManageLocationTreeV3Component_div_2_div_2_Template, 1, 1, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.openLocsHidden);
} }
function ManageLocationTreeV3Component_cdk_virtual_scroll_viewport_3_lib_location_row_v2_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-location-row-v2", 11);
    i0.ɵɵlistener("expandCollapseEvt", function ManageLocationTreeV3Component_cdk_virtual_scroll_viewport_3_lib_location_row_v2_2_Template_lib_location_row_v2_expandCollapseEvt_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.onExpandCollapse($event); })("emitHover", function ManageLocationTreeV3Component_cdk_virtual_scroll_viewport_3_lib_location_row_v2_2_Template_lib_location_row_v2_emitHover_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.onHover($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const loc_r10 = ctx.$implicit;
    const first_r12 = ctx.first;
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("locationData", i0.ɵɵpureFunction2(8, _c0$t, loc_r10, ctx_r9.searchTimestamp))("level", loc_r10.path.length)("showAccessCode", ctx_r9.showAccessCode)("isPopup", ctx_r9.isPopup)("isFirst", first_r12)("childHighlight", ctx_r9.childHighlight)("locationCountResponse", ctx_r9.locationCountResponse)("userCount", ctx_r9.userCount);
} }
function ManageLocationTreeV3Component_cdk_virtual_scroll_viewport_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cdk-virtual-scroll-viewport", 8, 9);
    i0.ɵɵlistener("scroll", function ManageLocationTreeV3Component_cdk_virtual_scroll_viewport_3_Template_cdk_virtual_scroll_viewport_scroll_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.scrollHandler($event); });
    i0.ɵɵtemplate(2, ManageLocationTreeV3Component_cdk_virtual_scroll_viewport_3_lib_location_row_v2_2_Template, 1, 11, "lib-location-row-v2", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("minBufferPx", 55 * 15)("maxBufferPx", 55 * 50);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cdkVirtualForOf", ctx_r2.hierarchyChildren);
} }
class ManageLocationTreeV3Component {
    constructor(router, dataService, locationService, cdRef) {
        this.router = router;
        this.dataService = dataService;
        this.locationService = locationService;
        this.cdRef = cdRef;
        this.unsubscribe$ = new Subject();
        this.locationArray = new BehaviorSubject(new Location());
        this.syncError = {};
        this.setLocationPath = true;
        this.isSearch = false;
        this.searchTimestamp = 0;
        this.openLocs = [];
        this.openLocsHidden = [];
        this.childHighlight = {};
        this.isReportsLocation = false;
        this.nodeValue = new EventEmitter();
        this.navChange = new EventEmitter();
        this.selectedLocationEvt = new EventEmitter();
        this.selectedLocation = [];
        this.getPadding = (node) => {
            const paddingLeft = node.path.length > 2 ? 20 * (node.path.length - 2) : 0;
            const style = { "padding-left": paddingLeft + "px" };
            return style;
        };
        this.onMouseOverNode = (nodeData) => {
            if (!this.isPopup) {
                if (!nodeData.showMenu) {
                    nodeData.showMenu = true;
                    setTimeout(() => {
                        nodeData.showMenu = false;
                    }, 2000);
                }
            }
        };
        this.onMouseOutNode = (nodeData) => {
            if (!this.isPopup) {
                nodeData.showMenu = false;
            }
        };
        this.countReadable = (numberCount) => {
            if (!numberCount)
                return 0;
            let i = 0;
            while (numberCount > 1000) {
                numberCount /= 1000;
                i++;
            }
            return Math.round(numberCount) + ["", "k", "m", "b"][i];
        };
        this.onFilteredLocations = ($event) => {
            console.log("from search output emmit", $event);
            // { filteredLocations: any, isSearch: boolean };
            this.hierarchyChildren = [];
            if ($event.isSearch) {
                this.hierarchyLocations = this.filteredLocations =
                    $event.filteredLocations;
                if (this.hierarchyLocations) {
                    this.hierarchyChildren =
                        this.hierarchyLocations[0].children || [];
                }
            }
            else {
                this.hierarchyLocations = this.locationOrginal;
                this.hierarchyChildren = this.locationOrginal[0].children || [];
            }
            this.searchTimestamp = $event.timestamp;
            this.isSearch = $event.isSearch;
            this.openLocs = [];
            this.refreshOpenLocs();
            this.scrollHandler("dummy event");
            if (this.locationList) {
                this.locationList.checkViewportSize();
                this.locationList.scrollToIndex(0, "smooth");
            }
        };
        this.scrollToLocation = (loc) => {
            if (this.locationList) {
                this.locationList.checkViewportSize();
                this.locationList.scrollToIndex(loc.position, "smooth");
            }
        };
        this.isVisible = (elemId, wrapperId) => {
            const offset_wrapper = $("#" + wrapperId).offset();
            const offset_wrapper_height = $("#" + wrapperId).height();
            const offset_elem = $("#" + elemId).offset();
            const offset_elem_height = $("#" + elemId).height();
            if (!offset_elem ||
                !offset_wrapper_height ||
                !offset_elem_height ||
                !offset_wrapper)
                return false;
            const wrapperViewTop = offset_wrapper.top;
            const wrapperViewBottom = wrapperViewTop + offset_wrapper_height;
            const elemTop = offset_elem.top;
            const elemBottom = elemTop + offset_elem_height;
            return elemBottom <= wrapperViewBottom && elemTop >= wrapperViewTop;
        };
        this.toggleMenu = ($event, node) => {
            console.log("toggleMenu::", $event, node);
            if (this.node)
                this.node.showMenu = false;
            if (node)
                node.showMenu = !node.showMenu;
            if (node.showMenu) {
                this.dataService.setOpenLocationMenu(true);
            }
            this.node = node;
            this.nodeValue.emit(node);
        };
        this.showLocationDetailsPage = ($event, node) => {
            if (!this.isPopup) {
                this.dataService.display(true);
                this.dataService.setLocationId(node.id);
                //this.dataService.setLocationNode(node);
                this.router.navigate(["/location/details", node.id]);
            }
        };
        this.refreshOpenLocs = () => {
            this.openLocs.forEach((locItem) => {
                locItem.position = this.findIndex(locItem.id);
            });
        };
        this.findIndex = (locId) => {
            const index = this.hierarchyChildren.findIndex((loc, index) => {
                if (loc.id === locId) {
                    return true;
                }
            });
            return index;
        };
        this.addInHierarchy = (index, children, $event, isInit) => {
            const scrollParam = $event.loc.scrollParam;
            if (!scrollParam || !scrollParam.hasExpanded) {
                return;
            }
            const bufferSpliceLength = isInit ? 10 : 50;
            let thisChildren = children;
            const arr1 = this.hierarchyChildren.slice(0, index + 1);
            console.log("isInit", isInit, "open arr1::", arr1);
            const arr3 = this.hierarchyChildren.slice(index + 1);
            console.log("isInit", isInit, "open arr3::", arr3);
            if (children.length > bufferSpliceLength) {
                thisChildren = children.slice(0, bufferSpliceLength);
                const pendingChildren = children.slice(bufferSpliceLength);
                this.hierarchyChildren = arr1.concat(thisChildren, arr3);
                setTimeout(() => {
                    this.addInHierarchy(index + thisChildren.length, pendingChildren, $event, false);
                }, 25);
            }
            else {
                thisChildren = children;
                this.hierarchyChildren = arr1.concat(children, arr3);
            }
            // scrollParam.netChild += $event.loc.children.length;
            scrollParam.netChild += thisChildren.length;
            // add the count in net child until parent
            let parent = $event.loc.parent;
            const openChildren = [$event.loc.id];
            while (parent != "-1") {
                const parentIndex = this.findIndex(parent);
                if (parentIndex == -1)
                    break;
                const parentLoc = this.hierarchyChildren[parentIndex];
                const parentScrollParam = parentLoc.scrollParam;
                if (parentScrollParam) {
                    parentScrollParam.netChild += thisChildren.length;
                    if (isInit) {
                        parentScrollParam.openChild =
                            parentScrollParam.openChild.concat(openChildren);
                        openChildren.push(parentLoc.id);
                    }
                }
                parent = parentLoc.parent;
            }
            if (!isInit) {
                this.refreshOpenLocs();
            }
        };
        this.onExpandCollapse = ($event) => {
            console.log("loc:::", $event.loc);
            if (!$event.loc.scrollParam) {
                $event.loc.scrollParam = {
                    hasExpanded: false,
                    netChild: 0,
                    openChild: []
                };
            }
            console.log("check condtion:: ", "$event.loc.expandChildren", $event.loc.expandChildren, "$event.loc.scrollParam.hasExpanded)", $event.loc.scrollParam.hasExpanded);
            if ($event.loc.expandChildren && !$event.loc.scrollParam.hasExpanded) {
                $event.loc.scrollParam.hasExpanded = true;
                const index = this.findIndex($event.loc.id);
                if (index === -1)
                    return;
                // setTimeout(() => {
                const locChidren = $event.loc.children;
                if (locChidren)
                    this.addInHierarchy(index, locChidren, $event, true);
                // }, 100);
                // console.log("open this.hierarchyChildren::", this.hierarchyChildren);
                this.openLocs.push({
                    id: $event.loc.id,
                    name: $event.loc.name,
                    position: index
                });
                this.refreshOpenLocs();
                // console.log(this.hierarchyChildren, $event, index);
            }
            else if (!$event.loc.expandChildren &&
                $event.loc.scrollParam.hasExpanded) {
                //close children first
                $event.loc.scrollParam.openChild.map((value, index, openChild) => {
                    const childIndex = this.findIndex(value);
                    if (childIndex === -1)
                        return;
                    const childLoc = this.hierarchyChildren[childIndex];
                    childLoc.scrollParam = {
                        hasExpanded: false,
                        netChild: 0,
                        openChild: []
                    };
                    childLoc.search = {
                        foundChild: true,
                        timestamp: 0
                    };
                    childLoc.expandChildren = false;
                    this.openLocs = this.openLocs.filter(function (loc) {
                        return loc.id !== value;
                    });
                }, this);
                //end
                const index = this.findIndex($event.loc.id);
                if (index === -1)
                    return;
                const arr1 = this.hierarchyChildren.slice(0, index + 1);
                console.log("close arr1::", arr1);
                const arr3 = this.hierarchyChildren.slice(index + $event.loc.scrollParam.netChild + 1); //, this.hierarchyChildren.length + 1);
                // const arr3 = this.hierarchyChildren.slice((index + $event.loc.children.length + 1))//, this.hierarchyChildren.length + 1);
                console.log("close arr3::", arr3);
                this.hierarchyChildren = arr1.concat(arr3);
                // console.log("close this.hierarchyChildren::", this.hierarchyChildren);
                $event.loc.scrollParam.hasExpanded = false;
                const netChild = $event.loc.scrollParam.netChild;
                $event.loc.scrollParam.netChild -= netChild;
                // substract the count in net child until parent
                let parent = $event.loc.parent;
                while (parent != "-1") {
                    const parentIndex = this.findIndex(parent);
                    if (parentIndex == -1)
                        break;
                    const parentLoc = this.hierarchyChildren[parentIndex];
                    const parentLocScrollParam = parentLoc.scrollParam;
                    if (parentLocScrollParam) {
                        parentLocScrollParam.netChild -= netChild;
                        const locParam = $event.loc.scrollParam;
                        parentLocScrollParam.openChild =
                            parentLocScrollParam.openChild.filter((locid) => !locParam.openChild.includes(locid));
                    }
                    parent = parentLoc.parent;
                }
                $event.loc.scrollParam.openChild = [];
                this.openLocs = this.openLocs.filter(function (loc) {
                    return loc.id !== $event.loc.id;
                });
                this.refreshOpenLocs();
                // console.log(this.hierarchyChildren, $event, index);
            }
            else {
                console.log("No Expand / Collapse for this node", $event);
            }
            this.scrollHandler("dummy event");
        };
        this.onHover = ($event) => {
            if ($event.isMouseOver) {
                this.childHighlight[$event.locId] = $event.isMouseOver;
            }
            else {
                delete this.childHighlight[$event.locId];
            }
        };
        console.log("Constructing the manage locations V2 ts.");
    }
    set location(loc) {
        this.locationOrginal = loc;
    }
    set isPinnedPopup(isPinnedPopup) {
        this.isPinnedPopupVal = isPinnedPopup;
    }
    set setSelectedLocation(selectedLocations) { }
    ngAfterViewChecked() {
        // console.log("called after view checked App Component");
        // this.showLoader = false;
        if (this.cdRef)
            this.cdRef.detectChanges();
    }
    ngOnInit() {
        console.log("Constructing the manage locations v2 ts in init.");
        this.syncError = {};
        this.dataService.display(false);
        this.dataService
            .getOnSyncStatusUpdate(this.unsubscribe$)
            .subscribe((updateTimestamp) => {
            if (!updateTimestamp)
                return;
            this.syncError = this.dataService.getSyncError();
        });
    }
    scrollHandler(event) {
        console.debug("Scroll Event");
        this.openLocsHidden = [];
        this.openLocs.forEach((locItem) => {
            if (!this.isVisible(locItem.id, "loc-srol-vewprt")) {
                this.openLocsHidden.push(locItem);
            }
        });
    }
    ngOnDestroy() {
        console.log("destory manageLocations page");
        // this.treeComponent = null;
        // this.subscribeSearchText("");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
ManageLocationTreeV3Component.ɵfac = function ManageLocationTreeV3Component_Factory(t) { return new (t || ManageLocationTreeV3Component)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
ManageLocationTreeV3Component.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ManageLocationTreeV3Component, selectors: [["lib-manage-location-tree-v3"]], viewQuery: function ManageLocationTreeV3Component_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(CdkVirtualScrollViewport, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.locationList = _t.first);
    } }, hostBindings: function ManageLocationTreeV3Component_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("scroll", function ManageLocationTreeV3Component_scroll_HostBindingHandler($event) { return ctx.scrollHandler($event); });
    } }, inputs: { location: "location", showAccessCode: "showAccessCode", isPopup: "isPopup", isPinnedPopup: "isPinnedPopup", multiLocationSelect: "multiLocationSelect", locationCountResponse: "locationCountResponse", userCount: "userCount", permittedLocationTypes: "permittedLocationTypes", isReportsLocation: "isReportsLocation", setSelectedLocation: "setSelectedLocation", customSearchText: "customSearchText" }, outputs: { nodeValue: "nodeValue", navChange: "navChange", selectedLocationEvt: "selectedLocationEvt" }, decls: 4, vars: 5, consts: [[3, "customSearchText", "location", "filteredLocations"], [3, "locationData", "level", "showAccessCode", "isPopup", "locationCountResponse", "userCount", 4, "ngIf"], ["class", "loc-path", 4, "ngIf"], ["id", "loc-srol-vewprt", "itemSize", "55", "style", "height:80vh", "class", "cdk-scroll", 3, "minBufferPx", "maxBufferPx", "scroll", 4, "ngIf"], [3, "locationData", "level", "showAccessCode", "isPopup", "locationCountResponse", "userCount"], [1, "loc-path"], ["class", "round-icon", 3, "innerHTML", "click", 4, "ngFor", "ngForOf"], [1, "round-icon", 3, "innerHTML", "click"], ["id", "loc-srol-vewprt", "itemSize", "55", 1, "cdk-scroll", 2, "height", "80vh", 3, "minBufferPx", "maxBufferPx", "scroll"], ["locationList", ""], [3, "locationData", "level", "showAccessCode", "isPopup", "isFirst", "childHighlight", "locationCountResponse", "userCount", "expandCollapseEvt", "emitHover", 4, "cdkVirtualFor", "cdkVirtualForOf"], [3, "locationData", "level", "showAccessCode", "isPopup", "isFirst", "childHighlight", "locationCountResponse", "userCount", "expandCollapseEvt", "emitHover"]], template: function ManageLocationTreeV3Component_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "lib-location-search", 0);
        i0.ɵɵlistener("filteredLocations", function ManageLocationTreeV3Component_Template_lib_location_search_filteredLocations_0_listener($event) { return ctx.onFilteredLocations($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, ManageLocationTreeV3Component_lib_location_row_v2_1_Template, 1, 9, "lib-location-row-v2", 1);
        i0.ɵɵtemplate(2, ManageLocationTreeV3Component_div_2_Template, 3, 1, "div", 2);
        i0.ɵɵtemplate(3, ManageLocationTreeV3Component_cdk_virtual_scroll_viewport_3_Template, 3, 3, "cdk-virtual-scroll-viewport", 3);
    } if (rf & 2) {
        i0.ɵɵproperty("customSearchText", ctx.customSearchText)("location", ctx.locationOrginal);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hierarchyLocations);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.openLocsHidden && ctx.openLocsHidden.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hierarchyChildren);
    } }, directives: [LocationSearchComponent, i1$2.NgIf, LocationRowV2Component, i1$2.NgForOf, i7$1.CdkVirtualScrollViewport, i7$1.CdkFixedSizeVirtualScroll, i7$1.CdkVirtualForOf], styles: [".cdk-scroll[_ngcontent-%COMP%]{overflow-y:overlay;overflow-x:hidden;width:75vw}cdk-virtual-scroll-viewport[_ngcontent-%COMP%]{-ms-overflow-style:none;-moz-scrollbar-width:none;scrollbar-width:none;overflow:-moz-scrollbars-none;background:linear-gradient(#ffffff 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),#ffffff 66%) 0 100%,radial-gradient(farthest-side at 50% 0,rgba(34,34,34,.5),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,rgba(34,34,34,.5),rgba(0,0,0,0)) 0 100%;background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:60vw 42px,60vw 42px,60vw 14px,60vw 14px;flex:1}[_ngcontent-%COMP%]::-webkit-scrollbar{width:0px;background:transparent;height:4px;background-color:transparent}.loc-path[_ngcontent-%COMP%]{display:inline-block;width:auto;height:auto;margin-left:3px;font-size:10px;cursor:pointer;min-height:20px;min-width:20px;vertical-align:middle;color:#abacacbf;font-family:sans-serif}.loc-path[_ngcontent-%COMP%] > .round-icon[_ngcontent-%COMP%]{display:inline-block;width:auto;height:auto;padding:3px 8px 4px;margin:3px 2px;font-size:10px;cursor:pointer;min-height:20px;min-width:20px;vertical-align:middle;text-align:center;background-color:#fff;border:1px solid #dddfe2;color:#abacacbf;border-radius:50px;font-family:sans-serif}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ManageLocationTreeV3Component, [{
        type: Component,
        args: [{
                selector: "lib-manage-location-tree-v3",
                templateUrl: "./manage-location-tree-v3.component.html",
                styleUrls: ["./manage-location-tree-v3.component.css"],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: LocationService }, { type: i0.ChangeDetectorRef }]; }, { locationList: [{
            type: ViewChild,
            args: [CdkVirtualScrollViewport, { static: false }]
        }], location: [{
            type: Input
        }], showAccessCode: [{
            type: Input
        }], isPopup: [{
            type: Input
        }], isPinnedPopup: [{
            type: Input
        }], multiLocationSelect: [{
            type: Input
        }], locationCountResponse: [{
            type: Input
        }], userCount: [{
            type: Input
        }], permittedLocationTypes: [{
            type: Input
        }], isReportsLocation: [{
            type: Input
        }], nodeValue: [{
            type: Output
        }], navChange: [{
            type: Output
        }], selectedLocationEvt: [{
            type: Output
        }], setSelectedLocation: [{
            type: Input
        }], customSearchText: [{
            type: Input
        }], scrollHandler: [{
            type: HostListener,
            args: ["scroll", ["$event"]]
        }] }); })();

const _c0$s = function (a0) { return { "selected": a0 }; };
function MonthPickerComponent_div_0_div_5_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵlistener("click", function MonthPickerComponent_div_0_div_5_div_8_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r6); const i_r4 = restoredCtx.index; const ctx_r5 = i0.ɵɵnextContext(3); return ctx_r5.selectItem(i_r4); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$s, ctx_r2.getSelectedMonth() === item_r3.name && ctx_r2.tileType !== "envMetrics"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r3.name, " ");
} }
const _c1$b = function (a0) { return { "disabledYear": a0 }; };
function MonthPickerComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelementStart(2, "div", 8);
    i0.ɵɵlistener("click", function MonthPickerComponent_div_0_div_5_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.prevYear(); });
    i0.ɵɵtext(3, " \uE906 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 10);
    i0.ɵɵlistener("click", function MonthPickerComponent_div_0_div_5_Template_div_click_6_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.nextYear(); });
    i0.ɵɵtext(7, " \uE907 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, MonthPickerComponent_div_0_div_5_div_8_Template, 3, 4, "div", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1$b, ctx_r1.isDisabled("prev")));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.year);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$b, ctx_r1.isDisabled("next")));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.monthData);
} }
const _c2$9 = function (a0) { return { "show": a0 }; };
function MonthPickerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵlistener("click", function MonthPickerComponent_div_0_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); ctx_r10.selectPeriod(); return ctx_r10.showDropdown(true); });
    i0.ɵɵelementStart(2, "span", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵlistener("click", function MonthPickerComponent_div_0_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.showDropdown(false); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, MonthPickerComponent_div_0_div_5_Template, 9, 8, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c2$9, ctx_r0.show));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.getSelectedMonthFull());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.show);
} }
const moment$7 = moment_;
class MonthPickerComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.show = false;
        this.currentDate = new Date();
        this.yearData = [];
        this.months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        this.monthData = [];
        this.year = null;
        this.spacesObj = null;
        this.isDummy = false;
        this.fromDate = null;
        this.monthUntil = null;
        this.prepareMonthData = () => {
            this.monthData = [];
            const addCurrentMonth = false;
            let i;
            let j;
            this.year = this.year.toString();
            if (this.year === this.startYear) {
                i = this.monthStart; // start index
                j = 12; // upper limit
                if (this.endYear === this.startYear) {
                    j = this.monthEnd;
                }
            }
            else if (this.year === this.endYear) {
                i = 1;
                j = this.monthEnd;
            }
            else {
                i = 1;
                j = 12;
            }
            for (let n = i; n <= j; n++) {
                const fromToDate = new Date(this.year, n - 1, 1);
                const monthNameFull = moment$7(new Date(this.year, n - 1, 1)).format("MMMM"); // this.months[new Date(this.year,n-1,1).getMonth()];
                const monthYear = monthNameFull + " " + this.year;
                const monthObj = {
                    name: monthYear,
                    fromDate: fromToDate,
                    toDate: fromToDate
                };
                this.monthData.push(monthObj);
            }
        };
        this.getSelectedMonthFull = () => {
            if (this.tileType === 'envMetrics') {
                return (this.spacesObj.spacesPeriod.selectedMonth);
            }
            else {
                return (moment$7(this.spacesPeriod.reportDate).format("MMMM") +
                    " " +
                    moment$7(this.spacesPeriod.reportDate).format("YYYY"));
            }
        };
        this.getSelectedMonth = () => {
            return (this.firstThreeLetters(this.spacesPeriod.month) +
                " " +
                this.selectedYear);
        };
        this.firstThreeLetters = (str) => {
            return str.substring(0, 3);
        };
        this.showDropdown = (evt) => {
            this.show = evt;
        };
        this.selectItem = (index) => {
            const selectedMonth = this.monthData[index];
            const newPeriod = Object.assign({}, this.spacesPeriod);
            const fromYear = selectedMonth.fromDate.getFullYear();
            let fromMonth = selectedMonth.fromDate.getMonth() + 1;
            const monthName = this.months[selectedMonth.fromDate.getMonth()];
            if (fromMonth < 10) {
                fromMonth = "0" + fromMonth;
            }
            const toYear = selectedMonth.toDate.getFullYear();
            let toMonth = selectedMonth.toDate.getMonth() + 1;
            if (toMonth < 10) {
                toMonth = "0" + toMonth;
            }
            newPeriod.type = "month";
            newPeriod.month = monthName;
            newPeriod.year = fromYear;
            newPeriod.fromDate = fromYear + "-" + fromMonth;
            newPeriod.toDate = toYear + "-" + toMonth;
            newPeriod.reportDate =
                newPeriod.fromDate +
                    "-" +
                    moment$7(this.spacesPeriod.fromDate).format("DD");
            this.spacesObj.spacesPeriod = Object.assign({}, newPeriod);
            if (this.tileType === "cameraMetrics") {
                this.dataService.display(true);
                this.dataService.setVideoAnalyticsObject(this.spacesObj);
            }
            else if (this.tileType === 'envMetrics') {
                this.spacesObj.spacesPeriod.selectedMonth = selectedMonth.name;
                let spacesPeriod = this.spacesObj.spacesPeriod;
                // const date = moment(spacesPeriod.fromDate , 'YYYY-MM').add(1, 'month');
                // moment("2023-01" , 'YYYY-MM').toDate()
                // const month = date.month();
                // const year = date.year();
                // spacesPeriod.firstDayOfMonth = moment().year(year).month(month - 1).startOf('month');
                // spacesPeriod.lastDayOfMonth = moment().year(year).month(month - 1).endOf('month');
                const date = moment$7(spacesPeriod.fromDate, 'YYYY-MM');
                // spacesPeriod.firstDayOfMonth = date.format("YYYY-MM-DD")
                // spacesPeriod.lastDayOfMonth = date.endOf("month").format("YYYY-MM-DD")
                spacesPeriod.startDate = date.format("YYYY-MM-DD");
                spacesPeriod.endDate = date.endOf("month").format("YYYY-MM-DD");
                this.dataService.setEnvMetricsObject(this.spacesObj);
            }
            else {
                this.dataService.setSpacesObject(this.spacesObj);
            }
            this.showDropdown(false);
        };
        this.isDisabled = (action) => {
            if (action === "prev" &&
                this.year === this.spacesPeriod.prevYearLimit) {
                return true;
            }
            if (action === "next" && this.year === this.spacesPeriod.currentYear) {
                return true;
            }
            return false;
        };
        this.nextYear = () => {
            const newYear = Number(this.year) + 1;
            if (newYear > this.spacesPeriod.currentYear) {
                return false;
            }
            else {
                this.year = newYear;
                this.prepareMonthData();
            }
        };
        this.prevYear = () => {
            const newYear = Number(this.year) - 1;
            if (newYear < this.spacesPeriod.prevYearLimit) {
                return false;
            }
            else {
                this.year = newYear;
                this.prepareMonthData();
            }
        };
        this.selectPeriod = () => {
            const newPeriod = this.spacesPeriod;
            if (this.spacesPeriod.type === "month") {
                return;
            }
            for (let i = 0; i < this.monthData.length; i++) {
                if (this.monthData[i].name === this.getSelectedMonth()) {
                    this.selectItem(i);
                }
            }
        };
    }
    ngOnInit() {
        this.isDummy = this.dataService.getIsDummy();
        if (this.tileType === "cameraMetrics") {
            this.dataService
                .getVideoAnalyticsObject(this.unsubscribe$)
                .subscribe((vaObj) => {
                if (vaObj != null && vaObj.spacesPeriod != null) {
                    this.spacesObj = vaObj;
                    this.spacesPeriod = vaObj.spacesPeriod;
                    if (this.spacesPeriod) {
                        this.currentYear = this.spacesPeriod.currentYear;
                        this.monthStart = this.spacesPeriod.monthStart;
                        this.monthEnd = this.spacesPeriod.monthEnd;
                        this.startYear = this.spacesPeriod.startYear;
                        this.endYear = this.spacesPeriod.endYear;
                        this.fromDate = this.spacesPeriod.fromDate;
                        this.monthUntil = this.spacesPeriod.monthEnd;
                        this.selectedYear = this.spacesPeriod.year;
                        this.year = this.spacesPeriod.year;
                        this.prepareMonthData();
                    }
                }
            });
        }
        else if (this.tileType === 'envMetrics') {
            this.dataService.getEnvMetricsObject(this.unsubscribe$)
                .subscribe((spacesObj) => {
                if (spacesObj != null && spacesObj.spacesPeriod != null) {
                    this.spacesObj = spacesObj;
                    this.spacesPeriod = this.spacesObj.spacesPeriod;
                    if (this.spacesPeriod) {
                        this.currentYear = this.spacesPeriod.currentYear;
                        this.monthStart = parseInt(this.spacesPeriod.monthStart);
                        this.monthEnd = parseInt(this.spacesPeriod.monthEnd);
                        this.startYear = this.spacesPeriod.startYear;
                        this.endYear = this.spacesPeriod.endYear;
                        this.fromDate = this.spacesPeriod.fromDate;
                        this.monthUntil = this.spacesPeriod.monthEnd;
                        this.selectedYear = this.spacesPeriod.year;
                        this.year = this.spacesPeriod.year;
                        this.prepareMonthData();
                    }
                }
            });
            this.spacesPeriod = this.spacesObj && this.spacesObj.spacesPeriod ? this.spacesObj.spacesPeriod : null;
            if (this.spacesPeriod) {
                this.currentYear = this.spacesPeriod.currentYear;
                this.monthStart = parseInt(this.spacesPeriod.monthStart);
                this.monthEnd = parseInt(this.spacesPeriod.monthEnd);
                this.startYear = this.spacesPeriod.startYear;
                this.endYear = this.spacesPeriod.endYear;
                this.fromDate = this.spacesPeriod.fromDate;
                this.monthUntil = this.spacesPeriod.monthEnd;
                this.selectedYear = this.spacesPeriod.year;
                this.year = this.spacesPeriod.year;
                this.prepareMonthData();
                if (this.spacesObj.spacesPeriod.selectedMonth === undefined) {
                    this.selectedMonthAndYear = this.monthData[moment$7().month()].name;
                    this.spacesObj.spacesPeriod.selectedMonth = this.selectedMonthAndYear;
                }
            }
        }
        else {
            this.dataService
                .getSpacesObject(this.unsubscribe$)
                .subscribe((spacesObj) => {
                if (spacesObj != null && spacesObj.spacesPeriod != null) {
                    this.spacesObj = spacesObj;
                    this.spacesPeriod = spacesObj.spacesPeriod;
                    if (this.spacesPeriod) {
                        this.currentYear = this.spacesPeriod.currentYear;
                        this.monthStart = this.spacesPeriod.monthStart;
                        this.monthEnd = this.spacesPeriod.monthEnd;
                        this.startYear = this.spacesPeriod.startYear;
                        this.endYear = this.spacesPeriod.endYear;
                        this.fromDate = this.spacesPeriod.fromDate;
                        this.monthUntil = this.spacesPeriod.monthEnd;
                        this.selectedYear = this.spacesPeriod.year;
                        this.year = this.spacesPeriod.year;
                        this.prepareMonthData();
                    }
                }
            });
        }
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
MonthPickerComponent.ɵfac = function MonthPickerComponent_Factory(t) { return new (t || MonthPickerComponent)(i0.ɵɵdirectiveInject(DataService)); };
MonthPickerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MonthPickerComponent, selectors: [["lib-month-picker"]], inputs: { spacesSettings: "spacesSettings", tileType: "tileType" }, decls: 1, vars: 1, consts: [["class", "monthPicker", 3, "ngClass", 4, "ngIf"], [1, "monthPicker", 3, "ngClass"], [1, "selectedItem", 3, "click"], [1, "itemName"], [1, "dropdownOverlay", 3, "click"], ["class", "dropdownList", 4, "ngIf"], [1, "dropdownList"], [1, "yearPickerWrapper"], [1, "prev", 3, "ngClass", "click"], [1, "year"], [1, "next", 3, "ngClass", "click"], ["class", "list", 4, "ngFor", "ngForOf"], [1, "list"], [1, "listItem", 3, "ngClass", "click"]], template: function MonthPickerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MonthPickerComponent_div_0_Template, 6, 5, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.spacesObj && ctx.spacesObj["spacesPeriod"]);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i1$2.NgForOf], styles: ["", ".spacesListWrapper[_ngcontent-%COMP%]{margin-top:60px;padding:40px 5%}.selectedItem[_ngcontent-%COMP%]{border:1px solid transparent;border-bottom:1px solid rgba(0,0,0,.1);background-color:#fff;border-radius:0;color:#7f7f86;padding:10px 20px 10px 10px;font-size:14px;font-family:\"ciscoSansRegular\";position:relative;cursor:pointer;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.selectedItem[_ngcontent-%COMP%]:before{position:absolute;right:10px;top:12px;font-family:\"icomoon-new\";content:\"\\e905\";font-size:14px;color:#bbb}.show[_ngcontent-%COMP%]   .selectedItem[_ngcontent-%COMP%]:before{content:\"\\e908\"}.itemName[_ngcontent-%COMP%]{width:90%;display:inline-block;cursor:pointer}.dropdownList[_ngcontent-%COMP%]{position:absolute;width:100%;top:100%;margin-top:5px;border-radius:0;max-height:200px;box-shadow:0 0 8px -2px #00000080}.list[_ngcontent-%COMP%]{position:relative}.listItem[_ngcontent-%COMP%]{font-size:14px;color:#999;font-family:\"Roboto-Regular\";background-color:#fff;padding:10px 20px 10px 10px;cursor:pointer}.listItem.selected[_ngcontent-%COMP%]{background-color:#f5f5f5}.listItem[_ngcontent-%COMP%]:hover{background-color:#eee}.listItem.selected[_ngcontent-%COMP%]:before{position:absolute;right:0;top:0;width:20px;height:auto;font-size:24px;content:\"\\e93b\";font-family:\"icomoon-new\";padding:4px 10px;color:#467fad;text-align:center}.monthPicker[_ngcontent-%COMP%], .yearPicker[_ngcontent-%COMP%], .quarterPicker[_ngcontent-%COMP%]{position:relative}.dropdownOverlay[_ngcontent-%COMP%]{position:fixed;left:0;top:0;width:100%;height:100%;background-color:#0000001a;z-index:100;display:none}.show[_ngcontent-%COMP%]   .dropdownOverlay[_ngcontent-%COMP%]{display:block}.dropdownList[_ngcontent-%COMP%]{z-index:101}.yearPickerWrapper[_ngcontent-%COMP%]{padding:10px;display:table;width:100%;background:#fff;border-bottom:1px solid #dddfe2}.yearPickerWrapper[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:table-cell;text-align:center}.yearPickerWrapper[_ngcontent-%COMP%] > .year[_ngcontent-%COMP%]{color:#999;width:calc(100% - 40px)}.yearPickerWrapper[_ngcontent-%COMP%] > .prev[_ngcontent-%COMP%], .yearPickerWrapper[_ngcontent-%COMP%] > .next[_ngcontent-%COMP%]{width:20px;height:20px;background-color:#f5f5f5;color:#999;font-family:\"icomoon-new\";font-size:14px;padding:5px;cursor:pointer}.yearPickerWrapper[_ngcontent-%COMP%] > .prev[_ngcontent-%COMP%]{content:\"\\e906\"}.yearPickerWrapper[_ngcontent-%COMP%] > .next[_ngcontent-%COMP%]{content:\"\\e907\"}.yearPickerWrapper[_ngcontent-%COMP%] > .prev.disabledYear[_ngcontent-%COMP%], .yearPickerWrapper[_ngcontent-%COMP%] > .next.disabledYear[_ngcontent-%COMP%]{cursor:not-allowed;pointer-events:none;background-color:#ccc}.retailMetricHeading[_ngcontent-%COMP%]{font-size:22px;font-family:\"Roboto-Regular\";font-weight:normal;margin-top:10px;margin-bottom:15px;padding-left:20px}.retailMetric[_ngcontent-%COMP%]{margin-bottom:20px}.metricList[_ngcontent-%COMP%]{display:table;width:100%;margin-top:40px}.retailMetricContainer[_ngcontent-%COMP%]{display:table-cell;width:100%;vertical-align:top}.buildingMetricContainer[_ngcontent-%COMP%]{display:table-cell;width:40%;vertical-align:top;padding-left:20px}.spacesOverviewTabs[_ngcontent-%COMP%]{position:absolute;top:50px;left:0;width:100%;height:50px;display:table;background-color:#fff;box-shadow:0 2px 2px #0000000d}.spacesOverviewTabs[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:table-cell}.selectedOvTab[_ngcontent-%COMP%]{width:80%;background-color:#fff;padding:10px 30px 10px 7%;font-family:\"Roboto-Medium\";font-size:22px;font-weight:500;color:#1d3243}.otherOvTab[_ngcontent-%COMP%]{width:20%;padding:10px 30px 10px 50px;background-color:#e9e9e9;vertical-align:middle;font-family:\"Roboto-Regular\";font-size:22px;color:#6b6b6b99;cursor:pointer;position:relative}.otherOvTab[_ngcontent-%COMP%]:before{position:absolute;top:0;right:90%;width:40px;height:100%;background-color:#fff;box-shadow:2px 0 #0000000d;transform:skew(-25deg);content:\"\";border-bottom-right-radius:40%}.dropdownList[_ngcontent-%COMP%]   .searchBarDiv[_ngcontent-%COMP%]   .searchInputIcon[_ngcontent-%COMP%]{position:absolute;left:5px;top:2px;padding-top:10px;width:14px;height:auto}.dropdownList[_ngcontent-%COMP%]   .searchBarDiv[_ngcontent-%COMP%]   input.searchInput[_ngcontent-%COMP%]{width:100%;padding-left:25px;padding-right:100px;border:none;border-bottom:1px solid #dddfe2;border-radius:0;margin-bottom:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonthPickerComponent, [{
        type: Component,
        args: [{
                selector: "lib-month-picker",
                templateUrl: "./month-picker.component.html",
                styleUrls: ["./month-picker.component.css", "./spaces.component.css"]
            }]
    }], function () { return [{ type: DataService }]; }, { spacesSettings: [{
            type: Input
        }], tileType: [{
            type: Input
        }] }); })();

class IoTExplorerService extends BaseService {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.getSampleStatusResponse = "/assets/data/engagements-status.json?"; // for testing needs to remove this line and also file
        this.getAppCurrentStatus = (appName) => {
            let url = this.apiConfig.getCurrentAppStatusUrl(appName);
            return this.get(url)
                .pipe(map(this.extractCompleteResponse));
        };
        this.searchFieldValue = (useCaseId, data) => {
            let serverUrl = this.apiConfig.getSearchValue(useCaseId);
            return this.post(serverUrl, data)
                .pipe(map(this.extractCompleteResponse));
        };
        this.extractCompleteResponse = (res) => {
            return res;
        };
    }
    static getInstance() {
        if (IoTExplorerService.instance === null) {
            IoTExplorerService.instance = new IoTExplorerService(null);
        }
        return IoTExplorerService.instance;
    }
}
IoTExplorerService.instance = null;
IoTExplorerService.ɵfac = function IoTExplorerService_Factory(t) { return new (t || IoTExplorerService)(i0.ɵɵinject(i0.Injector)); };
IoTExplorerService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IoTExplorerService, factory: IoTExplorerService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IoTExplorerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i0.Injector }]; }, null); })();
const iotServiceFactory = () => {
    return IoTExplorerService.getInstance();
};
const IOT_EXPLORER_SERVICE_PROVIDER = [
    {
        provide: IoTExplorerService,
        deps: [],
        useFactory: iotServiceFactory
    }
];

function MuiltiselectDropdownComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵlistener("click", function MuiltiselectDropdownComponent_div_3_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const item_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return ctx_r3.selectSuggestion(item_r2); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r2);
} }
function MuiltiselectDropdownComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, MuiltiselectDropdownComponent_div_3_div_1_Template, 3, 1, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.itemList);
} }
const _c0$r = function (a0) { return { "dropdownExpand": a0 }; };
class MuiltiselectDropdownComponent {
    constructor(dataService, iotExplorerService) {
        this.dataService = dataService;
        this.iotExplorerService = iotExplorerService;
        this.userSelectsString = "";
        this.show = false;
        this.itemList = [];
        this.itemSelected = false;
        this.multiSelectDropdownItem = new EventEmitter();
        this.deleteMultiSelectItem = new EventEmitter();
        this.clickDropdownInput = new EventEmitter();
        this.unsubscribe$ = new Subject();
        this.searchText = "";
        this.searchTimestamp = 0;
        // onSearchBlur(event: FocusEvent) {
        //   if(!this.itemSelected) {
        //       const eventObj = event.target as HTMLInputElement;
        //       const selItem = eventObj.value
        //       if(selItem != null && selItem != "") {
        //         this.userSelects.find((item) => item === selItem) ?
        //         this.userSelects = this.userSelects.filter((item) => item !== selItem):this.userSelects.push(selItem.trim());
        //         const emitItem = { index: this.index, selected: this.userSelects }
        //         this.searchText = selItem;
        //         this.multiSelectDropdownItem.emit(emitItem)
        //       } else {
        //         console.log("selItem is empty, printing event ::", event, event.target as HTMLInputElement);
        //       }
        //   }
        // }
        // deleteSelects(selItem) {
        //   this.userSelects = this.userSelects.filter((item) => item !== selItem);
        //   const emitItem = { index: this.index, selected: this.userSelects }
        //   this.deleteMultiSelectItem.emit(emitItem)
        //   // this.assignToNgModel();
        // }
        // isSelected(selItem) {
        // 	return this.userSelects.findIndex((item) => item === selItem) > -1
        // 		? true
        // 		: false;
        // }
        // assignToNgModel() {
        // 	this.userSelectsString = "";
        // 	this.userSelects.map(
        // 		(item) => (this.userSelectsString += item.name + " ")
        // 	);
        // }
        // ################ SEARCH TEXT STARTS ################
        this.onSearchText = ($event) => {
            let searchText = $event.target.value;
            this.subscribeSearchText(searchText);
        };
        this.subscribeSearchText = (val) => {
            this.searchText = val;
            if (this.searchText &&
                this.searchText.length > 1 &&
                this.prevSearchString !== this.searchText) {
                this.dataService.display(true);
                if (this.prevSearchString !== this.searchText) {
                    this.searchTimestamp = new Date().getTime();
                    this.prevSearchString = this.searchText;
                }
                if (this.setTimeoutObj)
                    clearTimeout(this.setTimeoutObj);
                this.setTimeoutObj = setTimeout(() => {
                    this.searchTree(this.searchTimestamp);
                }, 1200);
            }
            else {
                this.prevSearchString = "";
            }
        };
        this.searchTree = (searchTimestamp) => {
            let tokensTemp = this.prevSearchString.trim();
            let tokens = [];
            tokens.push(tokensTemp);
            if (tokens && tokens.length > 0) {
                for (let tokn = 0, max = tokens.length; tokn < max; tokn++) {
                    setTimeout(() => {
                        if (tokens[tokn].length > 2) {
                            let json = {
                                attributeName: this.esName,
                                value: tokens[tokn]
                            };
                            this.dataService.display(true);
                            this.iotExplorerService
                                .searchFieldValue(this.useCaseId, json)
                                .pipe(takeUntil(this.unsubscribe$))
                                .subscribe((response) => {
                                this.show = true;
                                this.itemList = response.data.searchResults;
                                this.dataService.display(false);
                            }, (error) => {
                                this.dataService.display(false);
                            });
                        }
                    }, 0);
                }
                this.dataService.display(false);
            }
            else {
                this.dataService.display(false);
            }
        };
        this.validToken = (token) => {
            if (token === "") {
                return false;
            }
            return true;
        };
    }
    set items(value) {
        if (!value) {
            return;
        }
    }
    set selected(value) {
        if (value == null || value === "") {
            return;
        }
        this.searchText = value;
    }
    set expand(value) {
        this.show = value;
    }
    event(event) {
        let that = this;
        let elementClicked = event.target;
        if (jQuery(elementClicked).closest(".chips-input-container").length ===
            0 &&
            jQuery(elementClicked).attr("class") !== undefined &&
            !jQuery(elementClicked).hasClass("chips-input-container") &&
            !jQuery(elementClicked).hasClass("selected-suggestion")) {
            that.show = false;
        }
    }
    ngOnInit() {
        console.log("Entered  Muiltiselect Dropdown Component");
    }
    suggest() {
        this.show = !this.show;
        this.clickDropdownInput.emit({ index: this.index, show: this.show });
    }
    selectSuggestion(selItem) {
        this.itemSelected = true;
        if (selItem) {
            const emitItem = { index: this.index, selected: selItem };
            this.searchText = selItem;
            this.multiSelectDropdownItem.emit(emitItem);
            this.show = false;
        }
    }
    onSearchBlur(event) {
        if (this.itemSelected)
            return;
        setTimeout(() => {
            const inputElement = event.target;
            const inputValue = inputElement.value.trim();
            if (inputValue) {
                const emitItem = {
                    index: this.index,
                    selected: inputValue
                };
                this.multiSelectDropdownItem.emit(emitItem);
                this.searchText = inputValue;
            }
            else {
                console.log("Input is empty; no action taken.");
            }
        }, 100);
    }
    focusFunction() {
        this.itemSelected = false;
        this.show = true;
    }
    // ################ SEARCH TEXT ENDS ################
    ngOnDestroy() { }
}
MuiltiselectDropdownComponent.ɵfac = function MuiltiselectDropdownComponent_Factory(t) { return new (t || MuiltiselectDropdownComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(IoTExplorerService)); };
MuiltiselectDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MuiltiselectDropdownComponent, selectors: [["lib-muiltiselect-dropdown"]], hostBindings: function MuiltiselectDropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function MuiltiselectDropdownComponent_click_HostBindingHandler($event) { return ctx.event($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { useCaseId: "useCaseId", esName: "esName", items: "items", selected: "selected", index: "index", expand: "expand" }, outputs: { multiSelectDropdownItem: "multiSelectDropdownItem", deleteMultiSelectItem: "deleteMultiSelectItem", clickDropdownInput: "clickDropdownInput" }, decls: 4, vars: 5, consts: [[1, "autocomplete"], [1, "chips-input-container", 3, "ngClass", "click"], ["type", "text", "placeholder", "Enter the value", "name", "searchValue", "autocomplete", "off", 1, "userInput", 3, "ngModel", "ngModelChange", "keyup", "focus", "blur"], ["class", "autocomplete-items", 4, "ngIf"], [1, "autocomplete-items"], [3, "click", 4, "ngFor", "ngForOf"], [3, "click"]], template: function MuiltiselectDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵlistener("click", function MuiltiselectDropdownComponent_Template_div_click_1_listener() { return ctx.suggest(); });
        i0.ɵɵelementStart(2, "input", 2);
        i0.ɵɵlistener("ngModelChange", function MuiltiselectDropdownComponent_Template_input_ngModelChange_2_listener($event) { return ctx.searchText = $event; })("keyup", function MuiltiselectDropdownComponent_Template_input_keyup_2_listener($event) { return ctx.onSearchText($event); })("focus", function MuiltiselectDropdownComponent_Template_input_focus_2_listener() { return ctx.focusFunction(); })("blur", function MuiltiselectDropdownComponent_Template_input_blur_2_listener($event) { return ctx.onSearchBlur($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, MuiltiselectDropdownComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$r, ctx.itemList.length > 0));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.searchText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.show && ctx.itemList.length > 0);
    } }, directives: [i1$2.NgClass, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$2.NgIf, i1$2.NgForOf], styles: [".autocomplete[_ngcontent-%COMP%]{position:relative;width:100%}.chips-input-container[_ngcontent-%COMP%]{display:inline-flex;background-color:#fff;border-bottom:2px solid #dddfe2;width:100%;border-radius:0;cursor:pointer;z-index:101;position:relative;color:#333439;font-family:ciscoSans;font-size:14px;margin:10px 0;flex-direction:row;flex-wrap:wrap}.chips-input-container[_ngcontent-%COMP%]:before{width:12px;height:12px;color:#6a6b6c;font-family:icomoon-new;position:absolute;top:6px;right:4px;padding:4px;font-size:14px;display:block;z-index:100}input[_ngcontent-%COMP%]{font-weight:600;border:none;outline:none;margin:0}input[_ngcontent-%COMP%]:hover{border:none;border-radius:0}.autocomplete-items[_ngcontent-%COMP%]{position:absolute;border:1px solid #d4d4d4;border-radius:4px;top:80%;left:0;right:50%;background:#fff;width:100%;z-index:1001;font-size:14px;cursor:pointer;background-color:#fff;font-family:\"ciscoSansLight\";font-weight:600;max-height:200px;overflow-y:auto}.selected-suggestion[_ngcontent-%COMP%]{background:#fff;color:#545454}.selected-suggestion[_ngcontent-%COMP%]   .check-mark[_ngcontent-%COMP%]{position:relative;display:inline-block;right:20px;font-style:normal;font-weight:500;line-height:1;top:1;--borderWidth: 1px;--height: 12px;--width: 6px;--borderColor: #545454;float:right}.selected-suggestion[_ngcontent-%COMP%]   .check-mark[_ngcontent-%COMP%]:before{content:\"\";transform:rotate(45deg);height:var(--height);width:var(--width);border-bottom:var(--borderWidth) solid var(--borderColor);border-right:var(--borderWidth) solid var(--borderColor);display:inline-block}.autocomplete-items[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:10px;cursor:pointer;background-color:#fff;border-bottom:1px solid #d4d4d41a}.autocomplete-items[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:hover{background-color:#f2f3f5}.user-chip[_ngcontent-%COMP%]{background:#f7f7f7;padding:0 6px;border-radius:20px;text-align:center;color:#545454;display:flex;font-size:14px;margin:0 4px 4px 0}.user-chip[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:flex;padding:5px}.delete-icon-chip[_ngcontent-%COMP%]{color:#545454;opacity:.7;cursor:pointer;display:flex;position:relative;right:0px;font-size:14px;padding:5px;font-weight:normal}.delete-icon-chip[_ngcontent-%COMP%]:hover{opacity:1}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MuiltiselectDropdownComponent, [{
        type: Component,
        args: [{
                selector: "lib-muiltiselect-dropdown",
                templateUrl: "./muiltiselect-dropdown.component.html",
                styleUrls: ["./muiltiselect-dropdown.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: IoTExplorerService }]; }, { useCaseId: [{
            type: Input
        }], esName: [{
            type: Input
        }], items: [{
            type: Input
        }], selected: [{
            type: Input
        }], index: [{
            type: Input
        }], expand: [{
            type: Input
        }], multiSelectDropdownItem: [{
            type: Output
        }], deleteMultiSelectItem: [{
            type: Output
        }], clickDropdownInput: [{
            type: Output
        }], event: [{
            type: HostListener,
            args: ["window:click", ["$event"]]
        }] }); })();

function MultiselectDropdownNoApisearchComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 6);
    i0.ɵɵlistener("click", function MultiselectDropdownNoApisearchComponent_div_2_Template_span_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const item_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.deleteSelects(item_r2); });
    i0.ɵɵtext(4, "x");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r2);
} }
function MultiselectDropdownNoApisearchComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function MultiselectDropdownNoApisearchComponent_div_4_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r8); const item_r6 = restoredCtx.$implicit; const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.selectSuggestion(item_r6); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r5.isSelected(item_r6) ? "selected-suggestion" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r6);
} }
function MultiselectDropdownNoApisearchComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, MultiselectDropdownNoApisearchComponent_div_4_div_1_Template, 4, 2, "div", 8);
    i0.ɵɵpipe(2, "dropdownFilter");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(2, 1, ctx_r1.itemList, ctx_r1.filterString));
} }
const _c0$q = function (a0) { return { "dropdownExpand": a0 }; };
class MultiselectDropdownNoApisearchComponent {
    constructor() {
        this.selectedItem = [];
        this.filterString = "";
        this.show = false;
        this.itemList = [];
        this.multiSelectDropdownItem = new EventEmitter();
    }
    set selected(value) {
        if (!value) {
            return;
        }
        this.selectedItem = value;
    }
    event(event) {
        let that = this;
        let elementClicked = event.target;
        if (jQuery(elementClicked).closest(".chips-input-container").length === 0 && jQuery(elementClicked).attr("class") != undefined && (!jQuery(elementClicked).hasClass("chips-input-container") && (!jQuery(elementClicked).hasClass("selected-suggestion")))) {
            that.show = false;
        }
    }
    // constructor() { }
    ngOnInit() {
        console.log("Entered Multiselec tDropdown No Api search Component");
    }
    focusFunction() {
        this.show = true;
    }
    suggest() {
        this.show = !this.show;
    }
    deleteSelects(selItem) {
        this.selectedItem = this.selectedItem.filter((item) => item !== selItem);
        this.multiSelectDropdownItem.emit(this.selectedItem);
    }
    isSelected(selItem) {
        return this.selectedItem.findIndex((item) => item === selItem) > -1 ? true : false;
    }
    selectSuggestion(selItem) {
        this.selectedItem.find((item) => item === selItem) ?
            this.selectedItem = this.selectedItem.filter((item) => item !== selItem) :
            this.selectedItem.push(selItem);
        this.multiSelectDropdownItem.emit(this.selectedItem);
        this.filterString = "";
    }
}
MultiselectDropdownNoApisearchComponent.ɵfac = function MultiselectDropdownNoApisearchComponent_Factory(t) { return new (t || MultiselectDropdownNoApisearchComponent)(); };
MultiselectDropdownNoApisearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultiselectDropdownNoApisearchComponent, selectors: [["lib-multiselect-dropdown-no-apisearch"]], hostBindings: function MultiselectDropdownNoApisearchComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function MultiselectDropdownNoApisearchComponent_click_HostBindingHandler($event) { return ctx.event($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { selected: "selected", itemList: "itemList" }, outputs: { multiSelectDropdownItem: "multiSelectDropdownItem" }, decls: 5, vars: 6, consts: [[1, "autocomplete"], [1, "chips-input-container", 3, "ngClass", "click"], ["class", "user-chip", 4, "ngFor", "ngForOf"], ["type", "text", "name", "searchValue", "autocomplete", "off", 1, "userInput", 3, "ngModel", "ngModelChange", "focus"], ["class", "autocomplete-items", 4, "ngIf"], [1, "user-chip"], [1, "delete-icon-chip", 3, "click"], [1, "autocomplete-items"], [3, "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "click"], [1, "check-mark"]], template: function MultiselectDropdownNoApisearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵlistener("click", function MultiselectDropdownNoApisearchComponent_Template_div_click_1_listener() { return ctx.suggest(); });
        i0.ɵɵtemplate(2, MultiselectDropdownNoApisearchComponent_div_2_Template, 5, 1, "div", 2);
        i0.ɵɵelementStart(3, "input", 3);
        i0.ɵɵlistener("ngModelChange", function MultiselectDropdownNoApisearchComponent_Template_input_ngModelChange_3_listener($event) { return ctx.filterString = $event; })("focus", function MultiselectDropdownNoApisearchComponent_Template_input_focus_3_listener() { return ctx.focusFunction(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, MultiselectDropdownNoApisearchComponent_div_4_Template, 3, 4, "div", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$q, ctx.itemList.length > 0));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.selectedItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.filterString);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.show && ctx.itemList.length > 0);
    } }, directives: [i1$2.NgClass, i1$2.NgForOf, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$2.NgIf], pipes: [DropdownFilterPipe], styles: ["@charset \"UTF-8\";.autocomplete[_ngcontent-%COMP%]{position:relative;width:100%}.chips-input-container[_ngcontent-%COMP%]{display:inline-flex;background-color:#fff;border-bottom:2px solid #dddfe2;width:100%;border-radius:0;cursor:pointer;z-index:101;position:relative;color:#333439;font-family:ciscoSans;font-size:14px;margin:10px 0;flex-direction:row;flex-wrap:wrap}.chips-input-container[_ngcontent-%COMP%]:before{width:12px;height:12px;color:#6a6b6c;font-family:icomoon-new;position:absolute;top:6px;right:4px;padding:4px;font-size:14px;display:block;content:\"\\e905\";z-index:100}.chips-input-container.dropdownExpand[_ngcontent-%COMP%]   .selectedDropdown[_ngcontent-%COMP%]:before{content:\"\\e908\"}input[_ngcontent-%COMP%]{font-weight:600;border:none;outline:none;margin:0}input[_ngcontent-%COMP%]:hover{border:none;border-radius:0}.autocomplete-items[_ngcontent-%COMP%]{position:absolute;border:1px solid #d4d4d4;border-radius:4px;top:80%;left:0;right:50%;background:#fff;width:100%;z-index:1001;font-size:14px;cursor:pointer;background-color:#fff;font-family:\"ciscoSansLight\";font-weight:600;max-height:200px;overflow-y:auto}.selected-suggestion[_ngcontent-%COMP%]{background:#fff;color:#545454}.selected-suggestion[_ngcontent-%COMP%]   .check-mark[_ngcontent-%COMP%]{position:relative;display:inline-block;right:20px;font-style:normal;font-weight:500;line-height:1;top:1;--borderWidth: 1px;--height: 12px;--width: 6px;--borderColor: #545454;float:right}.selected-suggestion[_ngcontent-%COMP%]   .check-mark[_ngcontent-%COMP%]:before{content:\"\";transform:rotate(45deg);height:var(--height);width:var(--width);border-bottom:var(--borderWidth) solid var(--borderColor);border-right:var(--borderWidth) solid var(--borderColor);display:inline-block}.autocomplete-items[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:10px;cursor:pointer;background-color:#fff;border-bottom:1px solid #d4d4d41a}.autocomplete-items[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:hover{background-color:#f2f3f5}.user-chip[_ngcontent-%COMP%]{background:#f7f7f7;padding:0 6px;border-radius:20px;text-align:center;color:#545454;display:flex;font-size:14px;margin:0 4px 4px 0}.user-chip[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:flex;padding:5px}.delete-icon-chip[_ngcontent-%COMP%]{color:#545454;opacity:.7;cursor:pointer;display:flex;position:relative;right:0px;font-size:14px;padding:5px;font-weight:normal}.delete-icon-chip[_ngcontent-%COMP%]:hover{opacity:1}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiselectDropdownNoApisearchComponent, [{
        type: Component,
        args: [{
                selector: "lib-multiselect-dropdown-no-apisearch",
                templateUrl: "./multiselect-dropdown-no-apisearch.component.html",
                styleUrls: ["./multiselect-dropdown-no-apisearch.component.scss"]
            }]
    }], null, { selected: [{
            type: Input
        }], itemList: [{
            type: Input
        }], multiSelectDropdownItem: [{
            type: Output
        }], event: [{
            type: HostListener,
            args: ["window:click", ["$event"]]
        }] }); })();

function NavigationAppComponent_div_0_li_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "div", 11);
    i0.ɵɵelementStart(2, "span", 12);
    i0.ɵɵelement(3, "i", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", node_r2.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r4.calculateClass(node_r2.iconClassName));
} }
function NavigationAppComponent_div_0_li_3_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "img", 20);
    i0.ɵɵelementEnd();
} }
const _c0$p = function (a0) { return { "activeParentNode": a0 }; };
function NavigationAppComponent_div_0_li_3_div_3_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵelement(1, "i", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const pi_r3 = i0.ɵɵnextContext(2).index;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$p, ctx_r10.childDisplayIndex == pi_r3));
} }
const _c1$a = function (a0, a1) { return { "notAllowed": a0, "activeCNode": a1 }; };
function NavigationAppComponent_div_0_li_3_div_3_div_7_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 25);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵlistener("click", function NavigationAppComponent_div_0_li_3_div_3_div_7_li_2_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const childNode_r14 = restoredCtx.$implicit; const ci_r15 = restoredCtx.index; const ctx_r16 = i0.ɵɵnextContext(5); return ctx_r16.childNavClicked(childNode_r14, ci_r15); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const childNode_r14 = ctx.$implicit;
    const ctx_r13 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c1$a, !childNode_r14.clickable, ctx_r13.currentNav == childNode_r14.routeUrl))("innerHtml", childNode_r14.label, i0.ɵɵsanitizeHtml);
} }
function NavigationAppComponent_div_0_li_3_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "ul", 23);
    i0.ɵɵtemplate(2, NavigationAppComponent_div_0_li_3_div_3_div_7_li_2_Template, 2, 5, "li", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", node_r2.childNodes);
} }
const _c2$8 = function (a0, a1, a2) { return { "notAllowed": a0, "activePNode": a1, "activePNodeWithChild": a2 }; };
const _c3$7 = function (a0) { return { "label-width": a0 }; };
function NavigationAppComponent_div_0_li_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵlistener("click", function NavigationAppComponent_div_0_li_3_div_3_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); const node_r2 = ctx_r20.$implicit; const pi_r3 = ctx_r20.index; const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.parentNavClicked(node_r2, pi_r3); });
    i0.ɵɵelementStart(2, "span", 12);
    i0.ɵɵelement(3, "i", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 15);
    i0.ɵɵtemplate(5, NavigationAppComponent_div_0_li_3_div_3_div_5_Template, 2, 0, "div", 16);
    i0.ɵɵtemplate(6, NavigationAppComponent_div_0_li_3_div_3_span_6_Template, 2, 3, "span", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, NavigationAppComponent_div_0_li_3_div_3_div_7_Template, 3, 1, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext();
    const node_r2 = ctx_r22.$implicit;
    const pi_r3 = ctx_r22.index;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(7, _c2$8, !node_r2.clickable, ctx_r5.currentNav == node_r2.routeUrl, ctx_r5.childDisplayIndex == pi_r3));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r5.calculateClass(node_r2.iconClassName));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", node_r2.label, i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(11, _c3$7, node_r2.label === "Right Now on Camera"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r2.label === "Right Now on Camera");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r2.childNodes.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r2.childNodes.length > 0 && ctx_r5.childDisplayIndex == pi_r3);
} }
function NavigationAppComponent_div_0_li_3_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 27);
} }
function NavigationAppComponent_div_0_li_3_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵlistener("click", function NavigationAppComponent_div_0_li_3_div_5_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r25); const node_r2 = i0.ɵɵnextContext().$implicit; const ctx_r23 = i0.ɵɵnextContext(2); return ctx_r23.linkNavClicked(node_r2); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", node_r2.label, i0.ɵɵsanitizeHtml);
} }
function NavigationAppComponent_div_0_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 4);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtemplate(2, NavigationAppComponent_div_0_li_3_div_2_Template, 4, 2, "div", 6);
    i0.ɵɵtemplate(3, NavigationAppComponent_div_0_li_3_div_3_Template, 8, 13, "div", 7);
    i0.ɵɵtemplate(4, NavigationAppComponent_div_0_li_3_div_4_Template, 1, 0, "div", 8);
    i0.ɵɵtemplate(5, NavigationAppComponent_div_0_li_3_div_5_Template, 2, 1, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", node_r2.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "header");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "nav");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "separator");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "link");
} }
function NavigationAppComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "nav");
    i0.ɵɵelementStart(2, "ul", 2);
    i0.ɵɵtemplate(3, NavigationAppComponent_div_0_li_3_Template, 6, 5, "li", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.config);
} }
function getBaseUrl$1() {
    return document.getElementsByTagName('base')[0].href;
}
class NavigationAppComponent {
    constructor(dataService, router, baseUrl) {
        this.dataService = dataService;
        this.router = router;
        this.unsubscribe$ = new Subject();
        this.onNavigationChanged = new EventEmitter();
        this.atReportNavigationChanged = new EventEmitter();
        this.visible = true;
        this.currentNav = 'NA';
        this.baseUrl = "/";
        this.childDisplayIndex = -1;
        this.parentNavClicked = (node, index) => {
            if (node.childNodes && node.childNodes.length > 0) {
                this.currentNav = 'NA';
                this.childDisplayIndex == index ? this.childDisplayIndex = -1 : this.childDisplayIndex = index;
            }
            else {
                if (node.routeUrl) {
                    this.childDisplayIndex = -1;
                    this.currentNav = node.routeUrl;
                    this.dataService.setCurrentNav(this.currentNav);
                    this.router.navigate([this.currentNav]);
                    this.atReportNavigationChanged.emit(node);
                }
            }
        };
        this.childNavClicked = (node, cindex) => {
            if (node.routeUrl) {
                this.currentNav = node.routeUrl;
                this.dataService.setCurrentNav(this.currentNav);
                this.router.navigate([this.currentNav]);
            }
        };
        this.linkNavClicked = (node) => {
            if (node.externalUrl) {
                window.open(node.routeUrl, '_blank').focus();
            }
            else if (!node.externalUrl && node.routeUrl) {
                const currentNav = node.routeUrl;
                this.dataService.setCurrentNav(currentNav);
                this.router.navigate([currentNav]);
            }
        };
        this.closeHamburger = () => {
            this.dataService.navigation(false);
        };
        this.calculateClass = (className) => {
            if (className != null) {
                let type = className.split('-')[0];
                if (type == 'icon') {
                    return className;
                }
                else {
                    // to handle for custom images
                }
            }
        };
        // code needs to be reviewed
        this.navActionClicked = (data, action) => {
            if (data && action) {
                if (action === 'edit' || action === 'delete') {
                    data['action'] = action;
                }
                else {
                    data['action'] = 'link';
                }
                this.closeHamburger();
                this.onNavigationChanged.emit(data);
            }
        };
        this.updateCurrentSelection = (currentUrl) => {
            let i = 0;
            for (let pNode of this.config) {
                if (pNode.childNodes && pNode.childNodes.length > 0) {
                    for (let cNode of pNode.childNodes) {
                        if (cNode.routeUrl == currentUrl) {
                            this.childDisplayIndex = i;
                            break;
                        }
                    }
                }
                i++;
            }
        };
        this.baseUrl = baseUrl;
    }
    set selectedNode(value) {
        if (!value) {
            return;
        }
        this.updateCurrentSelection(this.currentNav);
    }
    ngOnInit() {
    }
    ngOnChanges() {
        this.currentNav = this.dataService.getCurrentNav();
        this.updateCurrentSelection(this.currentNav);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
NavigationAppComponent.ɵfac = function NavigationAppComponent_Factory(t) { return new (t || NavigationAppComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject('BASE_URL')); };
NavigationAppComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NavigationAppComponent, selectors: [["navigation-app"]], inputs: { selectedNode: "selectedNode", config: "config" }, outputs: { onNavigationChanged: "onNavigationChanged", atReportNavigationChanged: "atReportNavigationChanged" }, features: [i0.ɵɵProvidersFeature([
            { provide: 'BASE_URL', useFactory: getBaseUrl$1 }
        ]), i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["id", "appNavigation", "class", "nav-panel", 4, "ngIf"], ["id", "appNavigation", 1, "nav-panel"], [1, "nav-wrapper"], ["class", "nav-node", 4, "ngFor", "ngForOf"], [1, "nav-node"], [3, "ngSwitch"], ["class", "nav-header", 4, "ngSwitchCase"], [4, "ngSwitchCase"], ["class", "nav-seperator", 4, "ngSwitchCase"], ["class", "nav-link", 4, "ngSwitchCase"], [1, "nav-header"], [1, "nav-header-label", 3, "innerHtml"], [1, "nav-icon"], [3, "ngClass"], [1, "nav-navigation", 3, "ngClass", "click"], [1, "nav-navigation-label", 3, "innerHtml", "ngClass"], ["class", "beta-tag", 4, "ngIf"], ["class", "nav-arrow", 3, "ngClass", 4, "ngIf"], [4, "ngIf"], [1, "beta-tag"], ["src", "/assets/images/beta-tag-icon.svg", "width", "40"], [1, "nav-arrow", 3, "ngClass"], [1, "icon-arrow"], [1, "sub-navigation"], ["class", "sub-navigation-node", 4, "ngFor", "ngForOf"], [1, "sub-navigation-node"], [1, "sub-navigation-label", 3, "ngClass", "innerHtml", "click"], [1, "nav-seperator"], [1, "nav-link"], [1, "nav-link-node", 3, "innerHtml", "click"]], template: function NavigationAppComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NavigationAppComponent_div_0_Template, 4, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.visible);
    } }, directives: [i1$2.NgIf, i1$2.NgForOf, i1$2.NgSwitch, i1$2.NgSwitchCase, i1$2.NgClass], styles: ["@charset \"UTF-8\";@font-face{font-family:\"icomoon-nav\";src:url(/assets/fonts/icomoonnav/icomoon-nav.eot?64tqqn);src:url(/assets/fonts/icomoonnav/icomoon-nav.eot?64tqqn#iefix) format(\"embedded-opentype\"),url(/assets/fonts/icomoonnav/icomoon-nav.ttf?64tqqn) format(\"truetype\"),url(/assets/fonts/icomoonnav/icomoon-nav.woff?64tqqn) format(\"woff\"),url(/assets/fonts/icomoonnav/icomoon-nav.svg?64tqqn#icomoon-nav) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"icomoon\";src:url(/assets/fonts/icomoonconfigure/icomoon.eot?uaz206);src:url(/assets/fonts/icomoonconfigure/icomoon.eot?uaz206#iefix) format(\"embedded-opentype\"),url(/assets/fonts/icomoonconfigure/icomoon.ttf?uaz206) format(\"truetype\"),url(/assets/fonts/icomoonconfigure/icomoon.woff?uaz206) format(\"woff\"),url(/assets/fonts/icomoonconfigure/icomoon.svg?uaz206#icomoon) format(\"svg\");font-weight:normal;font-style:normal;font-display:block}i[_ngcontent-%COMP%]{font-family:\"icomoon-nav\"!important;speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-dockarrow[_ngcontent-%COMP%]:before{content:\"\\e901\";color:#9a9a9a;font-size:23px}.icon-report[_ngcontent-%COMP%]:before{content:\"\\e909\";color:#9a9a9a;font-size:20px}.icon-app_header[_ngcontent-%COMP%]:before{content:\"\\e90a\";color:#9a9a9a;font-size:17px}.icon-hamburger[_ngcontent-%COMP%]:before{content:\"\\e904\";color:#9a9a9a;font-size:20px}.icon-accesscode[_ngcontent-%COMP%]:before{content:\"\\e900\";color:#9a9a9a;font-size:30px}.icon-admin[_ngcontent-%COMP%]:before{content:\"\\e928\";color:#9a9a9a;font-size:30px}.icon-arrow[_ngcontent-%COMP%]:before{content:\"\\e906\";color:#9a9a9a;font-size:23px}.icon-back[_ngcontent-%COMP%]:before{content:\"\\e907\";color:#9a9a9a;font-size:30px}.icon-captive-portal[_ngcontent-%COMP%]:before{content:\"\\e914\";color:#9a9a9a;font-size:30px}.icon-close[_ngcontent-%COMP%]:before{content:\"\\e915\";color:#9a9a9a;font-size:23px;font-weight:bold}.icon-cp-rule[_ngcontent-%COMP%]:before{content:\"\\e916\";color:#9a9a9a;font-size:23px}.icon-delete[_ngcontent-%COMP%]:before{content:\"\\e919\";color:#9a9a9a;font-size:30px}.icon-engagement-rule[_ngcontent-%COMP%]:before{content:\"\\e91d\";color:#9a9a9a;font-size:30px}.icon-home[_ngcontent-%COMP%]:before{content:\"\\e91e\";color:#9a9a9a;font-size:30px}.icon-location[_ngcontent-%COMP%]:before{content:\"\\e91f\";color:#9a9a9a;font-size:23px}.icon-mobile-apps[_ngcontent-%COMP%]:before{content:\"\\e920\";color:#9a9a9a;font-size:23px}.icon-monitoring[_ngcontent-%COMP%]:before{content:\"\\e921\";color:#9a9a9a;font-size:23px}.icon-more[_ngcontent-%COMP%]:before{content:\"\\e923\";color:#9a9a9a;font-size:30px}.icon-profile-rule[_ngcontent-%COMP%]:before{content:\"\\e924\";color:#9a9a9a;font-size:30px}.icon-reports[_ngcontent-%COMP%]:before{content:\"\\e925\";color:#9a9a9a;font-size:30px}.icon-right-now[_ngcontent-%COMP%]:before{content:\"\\e926\";color:#9a9a9a;font-size:30px}.icon-settings[_ngcontent-%COMP%]:before{content:\"\\e927\";color:#9a9a9a;font-size:23px}.icon-user[_ngcontent-%COMP%]:before{content:\"\\e928\";color:#9a9a9a;font-size:17px}.icon-wifi[_ngcontent-%COMP%]:before{content:\"\\e929\";color:#9a9a9a;font-size:23px}.icon-camera[_ngcontent-%COMP%]:before{content:\"\\e902\";color:#9a9a9a;font-size:23px}.icon-edge-device[_ngcontent-%COMP%]:before{content:\"\\e905\";color:#9a9a9a;font-size:23px}.icon-integrations[_ngcontent-%COMP%]:before{content:\"\\e908\";color:#9a9a9a;font-size:30px}.icon-workspace-devices[_ngcontent-%COMP%]:before{content:\"\\e931\";color:#9a9a9a;font-size:30px}.icon-workspace-home[_ngcontent-%COMP%]:before{content:\"\\e932\";color:#9a9a9a;font-size:30px}.icon-workspace-management[_ngcontent-%COMP%]:before{content:\"\\e933\";color:#9a9a9a;font-size:30px}.icon-configure[_ngcontent-%COMP%]:before{content:\"\\e500\";color:#9a9a9a;font-size:21px;font-family:\"icomoon\"!important}.icon-density[_ngcontent-%COMP%]:before{content:\"\\e903\";color:#9a9a9a;font-size:23px}.icon-all-metrics[_ngcontent-%COMP%]:before{content:\"\\e949\";color:#9a9a9a;font-size:23px}.icon-history[_ngcontent-%COMP%]:before{content:\"\\e950\";color:#9a9a9a;font-size:23px}.icon-eu-app-icon[_ngcontent-%COMP%]:before{content:\"\\e951\";color:#9a9a9a;font-size:23px;font-size:30px}.icon-ambient[_ngcontent-%COMP%]:before{content:\"\\e944\";color:#9a9a9a;font-size:30px}.icon-tvoc[_ngcontent-%COMP%]:before{content:\"\\e945\";color:#9a9a9a;font-size:30px}.icon-temp[_ngcontent-%COMP%]:before{content:\"\\e946\";color:#9a9a9a;font-size:30px}.icon-humidity[_ngcontent-%COMP%]:before{content:\"\\e947\";color:#9a9a9a;font-size:30px}.icon-co2[_ngcontent-%COMP%]:before{content:\"\\e948\";color:#9a9a9a;font-size:30px}.nav-icon[_ngcontent-%COMP%]{font-family:\"icomoon-nav\"}.nav-panel[_ngcontent-%COMP%]{height:100%;width:300px;position:fixed;top:6px;left:0;z-index:99999;margin-top:70px;background:#FFFFFF;color:#545454;border-right:1px solid #DFDFDF}nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin:0;padding:0}.nav-header[_ngcontent-%COMP%]{line-height:58px;display:flex;flex-direction:row;padding:5px 20px}.nav-header-label[_ngcontent-%COMP%]{min-width:235px;font-family:\"ciscoSansBold\";font-size:12px;color:#949494;padding-left:10px;text-transform:uppercase;letter-spacing:1.1px;user-select:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none}.nav-navigation[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:stretch;padding:15px 20px;cursor:pointer;font-family:\"ciscoSansLight\"}.nav-navigation-label[_ngcontent-%COMP%]{display:flex;align-items:center;min-width:210px;font-size:14px;color:#545454;padding-left:20px;letter-spacing:.5px;transition:color background .5s;user-select:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none}.nav-navigation[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]{min-width:30px;display:flex;justify-content:center}.nav-navigation[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]:before{transition:color background .5s}.nav-navigation[_ngcontent-%COMP%]   .icon-arrow[_ngcontent-%COMP%]:before{font-size:14px;position:relative;top:3px;color:#545454;transition:color background .5s}.nav-navigation[_ngcontent-%COMP%]:hover{background:#F7F7F7}.nav-navigation[_ngcontent-%COMP%]:hover   .nav-navigation-label[_ngcontent-%COMP%]{color:#312f2f}.nav-navigation[_ngcontent-%COMP%]:hover   .icon-arrow[_ngcontent-%COMP%]:before{color:#312f2f}.nav-navigation[_ngcontent-%COMP%]:hover   .nav-icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:before{color:#312f2f}.nav-seperator[_ngcontent-%COMP%]{width:100%;height:1px;background:#DFDFDF}.nav-link[_ngcontent-%COMP%]{padding-bottom:15px}.nav-link-node[_ngcontent-%COMP%]{color:#00a0d1;font-family:\"ciscoSans\";font-size:13px;cursor:pointer;padding-left:30px}.sub-navigation-label[_ngcontent-%COMP%]{padding:10px 10px 10px 80px;text-align:left;cursor:pointer;font-size:14px;color:#545454;letter-spacing:.5px;font-family:\"ciscoSansLight\";user-select:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none}.nav-arrow[_ngcontent-%COMP%]{transform:rotate(0);transition:transform .5s}.activeParentNode[_ngcontent-%COMP%]{transform:rotate(90deg)}.separator[_ngcontent-%COMP%]{position:relative;left:-22px;width:300px;margin-bottom:20px;border-bottom:1px solid #5d5c5c}.activePNode[_ngcontent-%COMP%]{background:#F7F7F7;border-left:5px solid #00A0D1;font-family:\"ciscoSans\"!important;color:#000}.activePNode[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:before{color:#312f2f}.activePNodeWithChild[_ngcontent-%COMP%]{background:#F7F7F7;color:#000;font-weight:bold}.activeCNode[_ngcontent-%COMP%]{background:#F7F7F7;border-left:5px solid #00A0D1;color:#000;font-weight:bold}.notAllowed[_ngcontent-%COMP%]{opacity:.5;pointer-events:none}.label-width[_ngcontent-%COMP%]{min-width:175px!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationAppComponent, [{
        type: Component,
        args: [{
                selector: 'navigation-app',
                providers: [
                    { provide: 'BASE_URL', useFactory: getBaseUrl$1 }
                ],
                templateUrl: './navigation-app.component.html',
                styleUrls: ['./navigation-app.component.scss']
            }]
    }], function () { return [{ type: DataService }, { type: i1.Router }, { type: undefined, decorators: [{
                type: Inject,
                args: ['BASE_URL']
            }] }]; }, { selectedNode: [{
            type: Input
        }], config: [{
            type: Input
        }], onNavigationChanged: [{
            type: Output
        }], atReportNavigationChanged: [{
            type: Output
        }] }); })();

function NavigationV2AppComponent_div_0_li_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "div", 11);
    i0.ɵɵelementStart(2, "span", 12);
    i0.ɵɵelement(3, "i", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", node_r2.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r4.calculateClass(node_r2.iconClassName));
} }
function NavigationV2AppComponent_div_0_li_3_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "img", 20);
    i0.ɵɵelementEnd();
} }
const _c0$o = function (a0) { return { "activeParentNode": a0 }; };
function NavigationV2AppComponent_div_0_li_3_div_3_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵelement(1, "i", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const pi_r3 = i0.ɵɵnextContext(2).index;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$o, ctx_r10.childDisplayIndex == pi_r3));
} }
const _c1$9 = function (a0, a1) { return { "notAllowed": a0, "activeCNode": a1 }; };
function NavigationV2AppComponent_div_0_li_3_div_3_div_7_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 25);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵlistener("click", function NavigationV2AppComponent_div_0_li_3_div_3_div_7_li_2_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const childNode_r14 = restoredCtx.$implicit; const ci_r15 = restoredCtx.index; const ctx_r16 = i0.ɵɵnextContext(5); return ctx_r16.childNavClicked(childNode_r14, ci_r15); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const childNode_r14 = ctx.$implicit;
    const ctx_r13 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c1$9, !childNode_r14.clickable, ctx_r13.currentNav == childNode_r14.routeUrl))("innerHtml", childNode_r14.label, i0.ɵɵsanitizeHtml);
} }
function NavigationV2AppComponent_div_0_li_3_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "ul", 23);
    i0.ɵɵtemplate(2, NavigationV2AppComponent_div_0_li_3_div_3_div_7_li_2_Template, 2, 5, "li", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", node_r2.childNodes);
} }
const _c2$7 = function (a0, a1, a2) { return { "notAllowed": a0, "activePNode": a1, "activePNodeWithChild": a2 }; };
const _c3$6 = function (a0) { return { "label-width": a0 }; };
function NavigationV2AppComponent_div_0_li_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵlistener("click", function NavigationV2AppComponent_div_0_li_3_div_3_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); const node_r2 = ctx_r20.$implicit; const pi_r3 = ctx_r20.index; const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.parentNavClicked(node_r2, pi_r3); });
    i0.ɵɵelementStart(2, "span", 12);
    i0.ɵɵelement(3, "i", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 15);
    i0.ɵɵtemplate(5, NavigationV2AppComponent_div_0_li_3_div_3_div_5_Template, 2, 0, "div", 16);
    i0.ɵɵtemplate(6, NavigationV2AppComponent_div_0_li_3_div_3_span_6_Template, 2, 3, "span", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, NavigationV2AppComponent_div_0_li_3_div_3_div_7_Template, 3, 1, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext();
    const node_r2 = ctx_r22.$implicit;
    const pi_r3 = ctx_r22.index;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(7, _c2$7, !node_r2.clickable, ctx_r5.currentNav == node_r2.routeUrl, ctx_r5.childDisplayIndex == pi_r3));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r5.calculateClass(node_r2.iconClassName));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", node_r2.label, i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(11, _c3$6, node_r2.label === "Right Now on Camera"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r2.label === "Right Now on Camera");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r2.childNodes.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r2.childNodes.length > 0 && ctx_r5.childDisplayIndex == pi_r3);
} }
function NavigationV2AppComponent_div_0_li_3_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 27);
} }
function NavigationV2AppComponent_div_0_li_3_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵlistener("click", function NavigationV2AppComponent_div_0_li_3_div_5_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r25); const node_r2 = i0.ɵɵnextContext().$implicit; const ctx_r23 = i0.ɵɵnextContext(2); return ctx_r23.linkNavClicked(node_r2); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", node_r2.label, i0.ɵɵsanitizeHtml);
} }
function NavigationV2AppComponent_div_0_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 4);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtemplate(2, NavigationV2AppComponent_div_0_li_3_div_2_Template, 4, 2, "div", 6);
    i0.ɵɵtemplate(3, NavigationV2AppComponent_div_0_li_3_div_3_Template, 8, 13, "div", 7);
    i0.ɵɵtemplate(4, NavigationV2AppComponent_div_0_li_3_div_4_Template, 1, 0, "div", 8);
    i0.ɵɵtemplate(5, NavigationV2AppComponent_div_0_li_3_div_5_Template, 2, 1, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", node_r2.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "header");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "nav");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "separator");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "link");
} }
function NavigationV2AppComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "nav");
    i0.ɵɵelementStart(2, "ul", 2);
    i0.ɵɵtemplate(3, NavigationV2AppComponent_div_0_li_3_Template, 6, 5, "li", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.config);
} }
function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}
class NavigationV2AppComponent {
    constructor(dataService, router, baseUrl) {
        this.dataService = dataService;
        this.router = router;
        this.unsubscribe$ = new Subject();
        this.onNavigationChanged = new EventEmitter();
        this.visible = true;
        this.currentNav = 'NA';
        this.baseUrl = "/";
        this.childDisplayIndex = -1;
        this.parentNavClicked = (node, index) => {
            if (node.childNodes && node.childNodes.length > 0) {
                this.currentNav = 'NA';
                this.childDisplayIndex == index ? this.childDisplayIndex = -1 : this.childDisplayIndex = index;
            }
            else {
                if (node.routeUrl) {
                    this.childDisplayIndex = -1;
                    this.currentNav = node.routeUrl;
                    this.dataService.setCurrentNav(this.currentNav);
                    this.router.navigate([this.currentNav]);
                }
            }
        };
        this.childNavClicked = (node, cindex) => {
            if (node.routeUrl) {
                this.currentNav = node.routeUrl;
                this.dataService.setCurrentNav(this.currentNav);
                this.router.navigate([this.currentNav]);
            }
        };
        this.linkNavClicked = (node) => {
            if (node.externalUrl) {
                window.open(node.routeUrl, '_blank').focus();
            }
            else if (!node.externalUrl && node.routeUrl) {
                const currentNav = node.routeUrl;
                this.dataService.setCurrentNav(currentNav);
                this.router.navigate([currentNav]);
            }
        };
        this.closeHamburger = () => {
            this.dataService.navigation(false);
        };
        this.calculateClass = (className) => {
            if (className != null) {
                let type = className.split('-')[0];
                if (type == 'icon') {
                    return className;
                }
                else {
                    // to handle for custom images
                }
            }
        };
        // code needs to be reviewed
        this.navActionClicked = (data, action) => {
            if (data && action) {
                if (action === 'edit' || action === 'delete') {
                    data['action'] = action;
                }
                else {
                    data['action'] = 'link';
                }
                this.closeHamburger();
                this.onNavigationChanged.emit(data);
            }
        };
        this.updateCurrentSelection = (currentUrl) => {
            let i = 0;
            for (let pNode of this.config) {
                if (pNode.childNodes && pNode.childNodes.length > 0) {
                    for (let cNode of pNode.childNodes) {
                        if (cNode.routeUrl == currentUrl) {
                            this.childDisplayIndex = i;
                            break;
                        }
                    }
                }
                i++;
            }
        };
        this.baseUrl = baseUrl;
    }
    ngOnInit() {
    }
    ngOnChanges() {
        this.currentNav = this.dataService.getCurrentNav();
        this.updateCurrentSelection(this.currentNav);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
NavigationV2AppComponent.ɵfac = function NavigationV2AppComponent_Factory(t) { return new (t || NavigationV2AppComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject('BASE_URL')); };
NavigationV2AppComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NavigationV2AppComponent, selectors: [["navigation-v2-app"]], inputs: { config: "config" }, outputs: { onNavigationChanged: "onNavigationChanged" }, features: [i0.ɵɵProvidersFeature([
            { provide: 'BASE_URL', useFactory: getBaseUrl }
        ]), i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["id", "appNavigation", "class", "nav-panel", 4, "ngIf"], ["id", "appNavigation", 1, "nav-panel"], [1, "nav-wrapper"], ["class", "nav-node", 4, "ngFor", "ngForOf"], [1, "nav-node"], [3, "ngSwitch"], ["class", "nav-header", 4, "ngSwitchCase"], [4, "ngSwitchCase"], ["class", "nav-seperator", 4, "ngSwitchCase"], ["class", "nav-link", 4, "ngSwitchCase"], [1, "nav-header"], [1, "nav-header-label", 3, "innerHtml"], [1, "nav-icon"], [3, "ngClass"], [1, "nav-navigation", 3, "ngClass", "click"], [1, "nav-navigation-label", 3, "innerHtml", "ngClass"], ["class", "beta-tag", 4, "ngIf"], ["class", "nav-arrow", 3, "ngClass", 4, "ngIf"], [4, "ngIf"], [1, "beta-tag"], ["src", "/assets/images/beta-tag-icon.svg", "width", "40"], [1, "nav-arrow", 3, "ngClass"], [1, "icon-arrow"], [1, "sub-navigation"], ["class", "sub-navigation-node", 4, "ngFor", "ngForOf"], [1, "sub-navigation-node"], [1, "sub-navigation-label", 3, "ngClass", "innerHtml", "click"], [1, "nav-seperator"], [1, "nav-link"], [1, "nav-link-node", 3, "innerHtml", "click"]], template: function NavigationV2AppComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NavigationV2AppComponent_div_0_Template, 4, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.visible);
    } }, directives: [i1$2.NgIf, i1$2.NgForOf, i1$2.NgSwitch, i1$2.NgSwitchCase, i1$2.NgClass], styles: ["@charset \"UTF-8\";@font-face{font-family:\"icomoon-nav\";src:url(/assets/fonts/icomoonnav/icomoon-nav.eot?64tqqn);src:url(/assets/fonts/icomoonnav/icomoon-nav.eot?64tqqn#iefix) format(\"embedded-opentype\"),url(/assets/fonts/icomoonnav/icomoon-nav.ttf?64tqqn) format(\"truetype\"),url(/assets/fonts/icomoonnav/icomoon-nav.woff?64tqqn) format(\"woff\"),url(/assets/fonts/icomoonnav/icomoon-nav.svg?64tqqn#icomoon-nav) format(\"svg\");font-weight:normal;font-style:normal}@font-face{font-family:\"icomoon\";src:url(/assets/fonts/icomoonconfigure/icomoon.eot?uaz206);src:url(/assets/fonts/icomoonconfigure/icomoon.eot?uaz206#iefix) format(\"embedded-opentype\"),url(/assets/fonts/icomoonconfigure/icomoon.ttf?uaz206) format(\"truetype\"),url(/assets/fonts/icomoonconfigure/icomoon.woff?uaz206) format(\"woff\"),url(/assets/fonts/icomoonconfigure/icomoon.svg?uaz206#icomoon) format(\"svg\");font-weight:normal;font-style:normal;font-display:block}i[_ngcontent-%COMP%]{font-family:\"icomoon-nav\"!important;speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-dockarrow[_ngcontent-%COMP%]:before{content:\"\\e901\";color:#9a9a9a;font-size:23px}.icon-report[_ngcontent-%COMP%]:before{content:\"\\e909\";color:#9a9a9a;font-size:20px}.icon-app_header[_ngcontent-%COMP%]:before{content:\"\\e90a\";color:#9a9a9a;font-size:17px}.icon-hamburger[_ngcontent-%COMP%]:before{content:\"\\e904\";color:#9a9a9a;font-size:20px}.icon-accesscode[_ngcontent-%COMP%]:before{content:\"\\e900\";color:#9a9a9a;font-size:30px}.icon-admin[_ngcontent-%COMP%]:before{content:\"\\e928\";color:#9a9a9a;font-size:30px}.icon-arrow[_ngcontent-%COMP%]:before{content:\"\\e906\";color:#9a9a9a;font-size:23px}.icon-back[_ngcontent-%COMP%]:before{content:\"\\e907\";color:#9a9a9a;font-size:30px}.icon-captive-portal[_ngcontent-%COMP%]:before{content:\"\\e914\";color:#9a9a9a;font-size:30px}.icon-close[_ngcontent-%COMP%]:before{content:\"\\e915\";color:#9a9a9a;font-size:23px;font-weight:bold}.icon-cp-rule[_ngcontent-%COMP%]:before{content:\"\\e916\";color:#9a9a9a;font-size:23px}.icon-delete[_ngcontent-%COMP%]:before{content:\"\\e919\";color:#9a9a9a;font-size:30px}.icon-engagement-rule[_ngcontent-%COMP%]:before{content:\"\\e91d\";color:#9a9a9a;font-size:30px}.icon-home[_ngcontent-%COMP%]:before{content:\"\\e91e\";color:#9a9a9a;font-size:30px}.icon-location[_ngcontent-%COMP%]:before{content:\"\\e91f\";color:#9a9a9a;font-size:23px}.icon-mobile-apps[_ngcontent-%COMP%]:before{content:\"\\e920\";color:#9a9a9a;font-size:23px}.icon-monitoring[_ngcontent-%COMP%]:before{content:\"\\e921\";color:#9a9a9a;font-size:23px}.icon-more[_ngcontent-%COMP%]:before{content:\"\\e923\";color:#9a9a9a;font-size:30px}.icon-profile-rule[_ngcontent-%COMP%]:before{content:\"\\e924\";color:#9a9a9a;font-size:30px}.icon-reports[_ngcontent-%COMP%]:before{content:\"\\e925\";color:#9a9a9a;font-size:30px}.icon-right-now[_ngcontent-%COMP%]:before{content:\"\\e926\";color:#9a9a9a;font-size:30px}.icon-settings[_ngcontent-%COMP%]:before{content:\"\\e927\";color:#9a9a9a;font-size:23px}.icon-user[_ngcontent-%COMP%]:before{content:\"\\e928\";color:#9a9a9a;font-size:17px}.icon-wifi[_ngcontent-%COMP%]:before{content:\"\\e929\";color:#9a9a9a;font-size:23px}.icon-camera[_ngcontent-%COMP%]:before{content:\"\\e902\";color:#9a9a9a;font-size:23px}.icon-edge-device[_ngcontent-%COMP%]:before{content:\"\\e905\";color:#9a9a9a;font-size:23px}.icon-integrations[_ngcontent-%COMP%]:before{content:\"\\e908\";color:#9a9a9a;font-size:30px}.icon-workspace-devices[_ngcontent-%COMP%]:before{content:\"\\e931\";color:#9a9a9a;font-size:30px}.icon-workspace-home[_ngcontent-%COMP%]:before{content:\"\\e932\";color:#9a9a9a;font-size:30px}.icon-workspace-management[_ngcontent-%COMP%]:before{content:\"\\e933\";color:#9a9a9a;font-size:30px}.icon-configure[_ngcontent-%COMP%]:before{content:\"\\e500\";color:#9a9a9a;font-size:21px;font-family:\"icomoon\"!important}.icon-density[_ngcontent-%COMP%]:before{content:\"\\e903\";color:#9a9a9a;font-size:23px}.icon-all-metrics[_ngcontent-%COMP%]:before{content:\"\\e949\";color:#9a9a9a;font-size:23px}.icon-history[_ngcontent-%COMP%]:before{content:\"\\e950\";color:#9a9a9a;font-size:23px}.icon-eu-app-icon[_ngcontent-%COMP%]:before{content:\"\\e951\";color:#9a9a9a;font-size:23px;font-size:30px}.icon-ambient[_ngcontent-%COMP%]:before{content:\"\\e944\";color:#9a9a9a;font-size:30px}.icon-tvoc[_ngcontent-%COMP%]:before{content:\"\\e945\";color:#9a9a9a;font-size:30px}.icon-temp[_ngcontent-%COMP%]:before{content:\"\\e946\";color:#9a9a9a;font-size:30px}.icon-humidity[_ngcontent-%COMP%]:before{content:\"\\e947\";color:#9a9a9a;font-size:30px}.icon-co2[_ngcontent-%COMP%]:before{content:\"\\e948\";color:#9a9a9a;font-size:30px}.nav-icon[_ngcontent-%COMP%]{font-family:\"icomoon-nav\"}.nav-panel[_ngcontent-%COMP%]{height:100%;width:76px;position:fixed;top:6px;left:0;z-index:99999;margin-top:70px;background:#FFFFFF;color:#545454;border-right:1px solid #DFDFDF;z-index:9999}div#appNavigation[_ngcontent-%COMP%]:hover{width:300px}nav[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin:0;padding:0}div#appNavigation[_ngcontent-%COMP%]:hover   ul[_ngcontent-%COMP%]   div.nav-navigation-label[_ngcontent-%COMP%]{display:block}.nav-header[_ngcontent-%COMP%]{line-height:58px;display:flex;flex-direction:row;padding:5px 20px}.nav-header-label[_ngcontent-%COMP%]{min-width:235px;font-family:\"ciscoSansBold\";font-size:12px;color:#949494;padding-left:10px;text-transform:uppercase;letter-spacing:1.1px;user-select:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none}.nav-navigation[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:stretch;padding:10px 20px;height:50px;cursor:pointer}.nav-navigation-label[_ngcontent-%COMP%]{display:flex;align-items:center;min-width:210px;font-family:\"ciscoSansLight\";font-size:14px;color:#545454;padding:4px 14px;letter-spacing:.5px;transition:color background .5s;user-select:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;display:none}.nav-navigation[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]{min-width:30px;display:flex;justify-content:center}.nav-navigation[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]:before{transition:color background .5s}.nav-navigation[_ngcontent-%COMP%]   .icon-arrow[_ngcontent-%COMP%]:before{font-size:14px;position:relative;top:3px;color:#545454;transition:color background .5s}.nav-navigation[_ngcontent-%COMP%]:hover{background:#F7F7F7}.nav-navigation[_ngcontent-%COMP%]:hover   .nav-navigation-label[_ngcontent-%COMP%]{color:#312f2f}.nav-navigation[_ngcontent-%COMP%]:hover   .icon-arrow[_ngcontent-%COMP%]:before{color:#312f2f}.nav-navigation[_ngcontent-%COMP%]:hover   .nav-icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:before{color:#312f2f}.nav-seperator[_ngcontent-%COMP%]{width:100%;height:1px;background:#DFDFDF}.nav-link[_ngcontent-%COMP%]{padding-bottom:15px}.nav-link-node[_ngcontent-%COMP%]{color:#00a0d1;font-family:\"ciscoSans\";font-size:13px;cursor:pointer;padding-left:30px}.sub-navigation-label[_ngcontent-%COMP%]{padding:10px 10px 10px 80px;text-align:left;cursor:pointer;font-size:14px;color:#545454;letter-spacing:.5px;font-family:\"ciscoSansLight\";user-select:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none}.nav-arrow[_ngcontent-%COMP%]{transform:rotate(0);transition:transform .5s}.activeParentNode[_ngcontent-%COMP%]{transform:rotate(90deg)}.separator[_ngcontent-%COMP%]{position:relative;left:-22px;width:300px;margin-bottom:20px;border-bottom:1px solid #5d5c5c}.activePNode[_ngcontent-%COMP%]{background:#F7F7F7;border-left:5px solid #00A0D1;color:#000;font-weight:bold}.activePNode[_ngcontent-%COMP%]   .nav-icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:before{color:#312f2f}.activePNodeWithChild[_ngcontent-%COMP%]{background:#F7F7F7;color:#000;font-weight:bold}.activeCNode[_ngcontent-%COMP%]{background:#F7F7F7;border-left:5px solid #00A0D1;color:#000;font-weight:bold}.notAllowed[_ngcontent-%COMP%]{opacity:.5;pointer-events:none}.label-width[_ngcontent-%COMP%]{min-width:175px!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationV2AppComponent, [{
        type: Component,
        args: [{
                selector: 'navigation-v2-app',
                providers: [
                    { provide: 'BASE_URL', useFactory: getBaseUrl }
                ],
                templateUrl: './navigation-v2-app.component.html',
                styleUrls: ['./navigation-v2-app.component.scss']
            }]
    }], function () { return [{ type: DataService }, { type: i1.Router }, { type: undefined, decorators: [{
                type: Inject,
                args: ['BASE_URL']
            }] }]; }, { config: [{
            type: Input
        }], onNavigationChanged: [{
            type: Output
        }] }); })();

class OpenroamingHotspotListComponent {
    constructor() { }
}
OpenroamingHotspotListComponent.ɵfac = function OpenroamingHotspotListComponent_Factory(t) { return new (t || OpenroamingHotspotListComponent)(); };
OpenroamingHotspotListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OpenroamingHotspotListComponent, selectors: [["lib-app-openroaming-hotspot-list"]], decls: 2, vars: 0, template: function OpenroamingHotspotListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p");
        i0.ɵɵtext(1, "openroaming-hotspot-list works!");
        i0.ɵɵelementEnd();
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OpenroamingHotspotListComponent, [{
        type: Component,
        args: [{
                selector: "lib-app-openroaming-hotspot-list",
                templateUrl: "./openroaming-hotspot-list.component.html",
                styleUrls: ["./openroaming-hotspot-list.component.scss"]
            }]
    }], function () { return []; }, null); })();

function PinCameraPopupComponent_div_0_div_1_div_16_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "form", 16);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵelement(3, "span", 18);
    i0.ɵɵelementStart(4, "input", 19);
    i0.ɵɵlistener("ngModelChange", function PinCameraPopupComponent_div_0_div_1_div_16_div_1_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(4); return ctx_r8.searchTxt = $event; })("keyup", function PinCameraPopupComponent_div_0_div_1_div_16_div_1_Template_input_keyup_4_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(4); return ctx_r10.searchCameraValue($event); });
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(5, 2, "shared-lib.pin-camera.search-cam"));
    i0.ɵɵproperty("ngModel", ctx_r5.searchTxt);
} }
function PinCameraPopupComponent_div_0_div_1_div_16_div_2_li_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 29);
    i0.ɵɵlistener("change", function PinCameraPopupComponent_div_0_div_1_div_16_div_2_li_3_div_3_Template_input_change_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r19); const metaData_r16 = restoredCtx.$implicit; const key_r14 = i0.ɵɵnextContext().$implicit; const ctx_r17 = i0.ɵɵnextContext(5); return ctx_r17.selectMultipleCameras(key_r14, metaData_r16); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "label", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const metaData_r16 = ctx.$implicit;
    const key_r14 = i0.ɵɵnextContext().$implicit;
    const ctx_r15 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(metaData_r16["value"]);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "tag-check-", key_r14, "-", metaData_r16["value"], "");
    i0.ɵɵproperty("disabled", !ctx_r15.selectedCheckedCameras[key_r14 + "~~~" + metaData_r16["value"]] && ctx_r15.pinnedCamerasCount === ctx_r15.limitNumber)("checked", ctx_r15.selectedCheckedCameras[key_r14 + "~~~" + metaData_r16["value"]]);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("for", "tag-check-", key_r14, "-", metaData_r16["value"], "");
} }
function PinCameraPopupComponent_div_0_div_1_div_16_div_2_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "span", 26);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PinCameraPopupComponent_div_0_div_1_div_16_div_2_li_3_div_3_Template, 5, 7, "div", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const key_r14 = ctx.$implicit;
    const ctx_r11 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r11.getKey(key_r14));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r11.cameraObj_searched[key_r14]);
} }
function PinCameraPopupComponent_div_0_div_1_div_16_div_2_li_10_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "i", 31);
    i0.ɵɵlistener("click", function PinCameraPopupComponent_div_0_div_1_div_16_div_2_li_10_span_1_Template_i_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r26); const camera_r23 = restoredCtx.$implicit; const key_r21 = i0.ɵɵnextContext().$implicit; const ctx_r24 = i0.ɵɵnextContext(5); return ctx_r24.removeCamera(key_r21, camera_r23); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const camera_r23 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", camera_r23["value"], " ");
} }
function PinCameraPopupComponent_div_0_div_1_div_16_div_2_li_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, PinCameraPopupComponent_div_0_div_1_div_16_div_2_li_10_span_1_Template, 3, 1, "span", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const key_r21 = ctx.$implicit;
    const ctx_r12 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r12.pinnedCameras[key_r21]);
} }
function PinCameraPopupComponent_div_0_div_1_div_16_div_2_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelement(1, "span", 33);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelement(8, "br");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "shared-lib.pin-camera.no-pinned-camera"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 5, "shared-lib.pin-camera.cam-select"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(10, 7, "shared-lib.pin-camera.cam-note"), " ");
} }
function PinCameraPopupComponent_div_0_div_1_div_16_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵelementStart(2, "ul");
    i0.ɵɵtemplate(3, PinCameraPopupComponent_div_0_div_1_div_16_div_2_li_3_Template, 4, 2, "li", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 23);
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 24);
    i0.ɵɵelementStart(9, "ul");
    i0.ɵɵtemplate(10, PinCameraPopupComponent_div_0_div_1_div_16_div_2_li_10_Template, 2, 1, "li", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, PinCameraPopupComponent_div_0_div_1_div_16_div_2_div_11_Template, 11, 9, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r6.cameraKeys);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 4, "shared-lib.pin-camera.pinned_cam"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r6.pinnedCamerasKeys);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.showCamData && !ctx_r6.noCamData);
} }
function PinCameraPopupComponent_div_0_div_1_div_16_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵelement(2, "img", 36);
    i0.ɵɵelementStart(3, "span", 37);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 38);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementStart(9, "a", 39);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 3, "shared-lib.pin-camera.no-camera"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 5, "shared-lib.pin-camera.no-cam-body"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 7, "shared-lib.pin-camera.learn-more"));
} }
function PinCameraPopupComponent_div_0_div_1_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, PinCameraPopupComponent_div_0_div_1_div_16_div_1_Template, 6, 4, "div", 12);
    i0.ɵɵtemplate(2, PinCameraPopupComponent_div_0_div_1_div_16_div_2_Template, 12, 6, "div", 13);
    i0.ɵɵtemplate(3, PinCameraPopupComponent_div_0_div_1_div_16_div_3_Template, 12, 9, "div", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.noCamData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.noCamData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.noCamData);
} }
function PinCameraPopupComponent_div_0_div_1_div_17_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "form", 16);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵelement(3, "span", 18);
    i0.ɵɵelementStart(4, "input", 19);
    i0.ɵɵlistener("ngModelChange", function PinCameraPopupComponent_div_0_div_1_div_17_div_1_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(4); return ctx_r30.searchTxt = $event; })("keyup", function PinCameraPopupComponent_div_0_div_1_div_17_div_1_Template_input_keyup_4_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(4); return ctx_r32.searchCameraValue($event); });
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(5, 2, "shared-lib.pin-camera.search-cam-zones"));
    i0.ɵɵproperty("ngModel", ctx_r27.searchTxt);
} }
function PinCameraPopupComponent_div_0_div_1_div_17_div_2_li_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 41);
    i0.ɵɵlistener("click", function PinCameraPopupComponent_div_0_div_1_div_17_div_2_li_3_div_3_Template_input_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r42); const metaData_r39 = restoredCtx.$implicit; const key_r37 = i0.ɵɵnextContext().$implicit; const ctx_r40 = i0.ɵɵnextContext(5); return ctx_r40.selectMultipleCameraZones(key_r37, metaData_r39); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "label", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const metaData_r39 = ctx.$implicit;
    const key_r37 = i0.ɵɵnextContext().$implicit;
    const ctx_r38 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(metaData_r39["value"]);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "tag-check-", key_r37, "-", metaData_r39["value"], "");
    i0.ɵɵproperty("disabled", !ctx_r38.selectedCheckedCameraZones[key_r37 + "~~~" + metaData_r39["value"]] && ctx_r38.pinnedCameraZonesCount === ctx_r38.limitNumber)("checked", ctx_r38.selectedCheckedCameraZones[key_r37 + "~~~" + metaData_r39["value"]]);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("for", "tag-check-", key_r37, "-", metaData_r39["value"], "");
} }
function PinCameraPopupComponent_div_0_div_1_div_17_div_2_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "span", 26);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PinCameraPopupComponent_div_0_div_1_div_17_div_2_li_3_div_3_Template, 5, 7, "div", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const key_r37 = ctx.$implicit;
    const ctx_r33 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r33.getKey(key_r37));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r33.cameraObj_searched[key_r37]);
} }
function PinCameraPopupComponent_div_0_div_1_div_17_div_2_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.pin-camera.cam-zones"));
} }
function PinCameraPopupComponent_div_0_div_1_div_17_div_2_li_8_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "i", 31);
    i0.ɵɵlistener("click", function PinCameraPopupComponent_div_0_div_1_div_17_div_2_li_8_span_1_Template_i_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r49); const zone_r46 = restoredCtx.$implicit; const key_r44 = i0.ɵɵnextContext().$implicit; const ctx_r47 = i0.ɵɵnextContext(5); return ctx_r47.removeCameraZone(key_r44, zone_r46); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const zone_r46 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", zone_r46["value"], " ");
} }
function PinCameraPopupComponent_div_0_div_1_div_17_div_2_li_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, PinCameraPopupComponent_div_0_div_1_div_17_div_2_li_8_span_1_Template, 3, 1, "span", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const key_r44 = ctx.$implicit;
    const ctx_r35 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r35.pinnedCameraZones[key_r44]);
} }
function PinCameraPopupComponent_div_0_div_1_div_17_div_2_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelement(1, "span", 33);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelement(8, "br");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "shared-lib.pin-camera.no-pinned-zones"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 5, "shared-lib.pin-camera.zone-select"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(10, 7, "shared-lib.pin-camera.zone-note"), " ");
} }
function PinCameraPopupComponent_div_0_div_1_div_17_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵelementStart(2, "ul");
    i0.ɵɵtemplate(3, PinCameraPopupComponent_div_0_div_1_div_17_div_2_li_3_Template, 4, 2, "li", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 23);
    i0.ɵɵtemplate(5, PinCameraPopupComponent_div_0_div_1_div_17_div_2_p_5_Template, 3, 3, "p", 40);
    i0.ɵɵelementStart(6, "div", 24);
    i0.ɵɵelementStart(7, "ul");
    i0.ɵɵtemplate(8, PinCameraPopupComponent_div_0_div_1_div_17_div_2_li_8_Template, 2, 1, "li", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, PinCameraPopupComponent_div_0_div_1_div_17_div_2_div_9_Template, 11, 9, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r28.cameraZoneKeys);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r28.noCamZoneData);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r28.pinnedCameraZonesKeys);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r28.showCamZoneData && !ctx_r28.noCamZoneData);
} }
function PinCameraPopupComponent_div_0_div_1_div_17_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵelement(2, "img", 36);
    i0.ɵɵelementStart(3, "span", 42);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 38);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementStart(9, "a", 39);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 3, "shared-lib.pin-camera.no-camera"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(8, 5, "shared-lib.pin-camera.no-cam-body"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 7, "shared-lib.pin-camera.learn-more"));
} }
function PinCameraPopupComponent_div_0_div_1_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, PinCameraPopupComponent_div_0_div_1_div_17_div_1_Template, 6, 4, "div", 12);
    i0.ɵɵtemplate(2, PinCameraPopupComponent_div_0_div_1_div_17_div_2_Template, 10, 4, "div", 13);
    i0.ɵɵtemplate(3, PinCameraPopupComponent_div_0_div_1_div_17_div_3_Template, 12, 9, "div", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.noCamZoneData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.noCamZoneData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.noCamZoneData);
} }
function PinCameraPopupComponent_div_0_div_1_div_18_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", ctx_r50.pinnedCamerasCount, " ", i0.ɵɵpipeBind1(2, 2, "shared-lib.pin-camera.selected-cam"), " ");
} }
function PinCameraPopupComponent_div_0_div_1_div_18_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r51.pinnedCameraZonesCount, " ", i0.ɵɵpipeBind1(2, 2, "shared-lib.pin-camera.selected-zones"), "");
} }
function PinCameraPopupComponent_div_0_div_1_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelementStart(1, "div", 44);
    i0.ɵɵelementStart(2, "button", 45);
    i0.ɵɵlistener("click", function PinCameraPopupComponent_div_0_div_1_div_18_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r53); const ctx_r52 = i0.ɵɵnextContext(3); return ctx_r52.closePinnedCameraPopup(false); });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 46);
    i0.ɵɵlistener("click", function PinCameraPopupComponent_div_0_div_1_div_18_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r53); const ctx_r54 = i0.ɵɵnextContext(3); return ctx_r54.applyPinnedCameras(); });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 47);
    i0.ɵɵtemplate(9, PinCameraPopupComponent_div_0_div_1_div_18_span_9_Template, 3, 4, "span", 40);
    i0.ɵɵtemplate(10, PinCameraPopupComponent_div_0_div_1_div_18_span_10_Template, 3, 4, "span", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "shared-lib.date-filter-popup.cancel"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 6, "shared-lib.date-filter-popup.apply"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.pinnedCamerasCount > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.pinnedCameraZonesCount > 0);
} }
const _c0$n = function (a0) { return { "selectedTab": a0 }; };
function PinCameraPopupComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵlistener("click", function PinCameraPopupComponent_div_0_div_1_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(2); return ctx_r55.selectTab("cameras"); });
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 6);
    i0.ɵɵlistener("click", function PinCameraPopupComponent_div_0_div_1_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r56); const ctx_r57 = i0.ɵɵnextContext(2); return ctx_r57.selectTab("cameraZones"); });
    i0.ɵɵelementStart(10, "span");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 7);
    i0.ɵɵlistener("click", function PinCameraPopupComponent_div_0_div_1_Template_span_click_13_listener() { i0.ɵɵrestoreView(_r56); const ctx_r58 = i0.ɵɵnextContext(2); return ctx_r58.closePinnedCameraPopup(false); });
    i0.ɵɵtext(14, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 8);
    i0.ɵɵtemplate(16, PinCameraPopupComponent_div_0_div_1_div_16_Template, 4, 3, "div", 9);
    i0.ɵɵtemplate(17, PinCameraPopupComponent_div_0_div_1_div_17_Template, 4, 3, "div", 9);
    i0.ɵɵtemplate(18, PinCameraPopupComponent_div_0_div_1_div_18_Template, 11, 8, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 8, "shared-lib.pin-camera.title"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c0$n, "cameras" === ctx_r1.selectedTab));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 10, "shared-lib.pin-camera.cameras"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c0$n, "cameraZones" === ctx_r1.selectedTab));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 12, "shared-lib.pin-camera.cam_zones"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", "cameras" === ctx_r1.selectedTab);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", "cameraZones" === ctx_r1.selectedTab);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", "cameras" === ctx_r1.selectedTab && !ctx_r1.noCamData || "cameraZones" === ctx_r1.selectedTab && !ctx_r1.noCamZoneData);
} }
function PinCameraPopupComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, PinCameraPopupComponent_div_0_div_1_Template, 19, 18, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.show);
} }
class PinCameraPopupComponent {
    // eslint-disable-next-line no-unused-vars
    constructor(dataService, translate, dialog, dialogRef, data) {
        this.dataService = dataService;
        this.translate = translate;
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.data = data;
        this.unsubscribe$ = new Subject();
        this.rightNowsObj = null;
        this.showCamData = true;
        this.showCamZoneData = true;
        this.show = true;
        this.isSampleData = false;
        this.showOnHover = false;
        this.disableTags = false;
        this.cameraKeys = [];
        this.cameraZoneKeys = [];
        this.pinnedCamerasKeys = [];
        this.pinnedCameras = {};
        this.backupSelectedTags = "{}";
        this.noData = false;
        this.noCamZoneData = false;
        this.selectedCheckedCameras = {};
        this.selectedCheckedCamerasKeys = [];
        this.backupSelectedCheckedTags = "{}";
        this.locationList = [];
        this.isFilteredByTags = false;
        this.selectedTab = "cameras";
        this.selectedCheckedCameraZones = {};
        this.selectedCheckedCameraZonesKeys = [];
        this.pinnedCameraZonesKeys = [];
        this.pinnedCameraZones = {};
        this.pinnedCamerasCount = 0;
        this.pinnedCameraZonesCount = 0;
        this.pinnedCount = 0;
        this.limitNumber = 3;
        this.checkedNumber = 0;
        this.noCamData = false;
        this.translateKeys = [];
        this.searchTxt = "";
        this.applyPinnedCamerasEvt = false;
        this.showEmitter = new EventEmitter();
        this.getTextKeys = () => {
            this.translate.get('shared-lib.pin-camera.CameraId').subscribe((res) => {
                this.translateKeys["CameraId"] = res;
            });
            this.translate.get('shared-lib.pin-camera.CameraZones').subscribe((res) => {
                this.translateKeys["CameraZones"] = res;
            });
        };
        this.searchCameraValue = (searchText) => {
            this.searchTxt = searchText !== "" ? searchText.target.value : searchText;
            if (!this.searchTxt ||
                this.searchTxt == "" ||
                this.searchTxt.length < 2) {
                this.cameraObj_searched = this.cameraObj;
            }
            else {
                const cameraObj_local = {};
                for (const key in this.cameraObj) {
                    if (Object.prototype.hasOwnProperty.call(this.cameraObj, key.toString())) {
                        let matched = false;
                        let val = this.cameraObj["CameraId"];
                        if (this.selectedTab == "cameras") {
                            val = this.cameraObj["CameraId"];
                        }
                        else if (this.selectedTab == "cameraZones") {
                            // console.log("tag iterate", key, val);
                            val = this.cameraObj["CameraZones"];
                        }
                        const childArr = [];
                        val.forEach((keyId) => {
                            const keyVal = keyId.value.toLowerCase();
                            if (keyId.value &&
                                keyVal.indexOf(this.searchTxt.toLowerCase()) > -1) {
                                matched = true;
                                console.log("tag iterate", keyId, keyId.value);
                                childArr.push(JSON.parse(JSON.stringify(keyId)));
                            }
                        });
                        if (matched) {
                            cameraObj_local[key] = childArr;
                        }
                    }
                }
                this.cameraObj_searched = cameraObj_local;
                console.log("$text Searched", cameraObj_local);
            }
            this.getCameraKeys(this.cameraObj_searched);
            this.getCameraZoneKeys(this.cameraObj_searched);
        };
        this.getCameraKeys = (cameras) => {
            let keys = [];
            if (cameras) {
                keys = Object.keys(cameras).sort();
            }
            this.cameraKeys = [keys[0]];
        };
        this.getCameraZoneKeys = (cameras) => {
            let keys = [];
            if (cameras) {
                keys = Object.keys(cameras).sort();
            }
            this.cameraZoneKeys = [keys[1]];
        };
        this.showDropdown = () => {
            if (this.cameraObj.CameraId && this.cameraObj.CameraId.length === 0) {
                this.noCamData = true;
            }
            else {
                this.noCamData = false;
            }
            if (this.cameraObj.CameraZones &&
                this.cameraObj.CameraZones.length === 0) {
                this.noCamZoneData = true;
            }
            else {
                this.noCamZoneData = false;
            }
            if (!this.disablePinCameras) {
                this.show = !this.show;
                if (!this.show) {
                    this.dialogRef.close(this.data);
                }
                this.showEmitter.emit(this.show);
                if (this.show &&
                    this.pinnedCameras &&
                    this.pinnedCameras.CameraId &&
                    this.pinnedCameras.CameraId.length > 0) {
                    this.showCamData = false;
                }
                else {
                    this.showCamData = true;
                }
                if (this.show &&
                    this.pinnedCameras &&
                    this.pinnedCameraZones.CameraZones &&
                    this.pinnedCameraZones.CameraZones.length > 0) {
                    this.showCamZoneData = false;
                }
                else {
                    this.showCamZoneData = true;
                }
            }
        };
        // customTrackBy(index: number, obj: any): any {
        // 	return index;
        // }
        this.closePinnedCameraPopup = (show) => {
            this.show = show;
            this.showEmitter.emit(this.show);
            this.searchTxt = "";
            this.searchCameraValue(this.searchTxt);
            if (!this.show) {
                this.dialogRef.close(this.data);
            }
        };
        this.removeCamera = (key, metaData) => {
            this.pinnedCameras[key] = this.pinnedCameras[key].filter((item) => item.value !== metaData.value);
            delete this.selectedCheckedCameras[key + "~~~" + metaData.value];
            setTimeout(() => {
                this.selectedCheckedCamerasKeys = Object.keys(this.selectedCheckedCameras);
                if (Object.keys(this.pinnedCameras.CameraId).length === 0) {
                    this.showCamData = true;
                }
                else {
                    if (this.pinnedCameras[key].length === 0)
                        delete this.pinnedCameras[key];
                    else
                        this.pinnedCamerasKeys = Object.keys(this.pinnedCameras);
                }
                this.pinnedCamerasCount = this.pinnedCameras[key]
                    ? this.pinnedCameras[key].length
                    : 0;
            }, 100);
        };
        this.removeCameraZone = (key, metaData) => {
            this.pinnedCameraZones[key] = this.pinnedCameraZones[key].filter((item) => item.value !== metaData.value);
            delete this.selectedCheckedCameraZones[key + "~~~" + metaData.value];
            setTimeout(() => {
                this.selectedCheckedCameraZonesKeys = Object.keys(this.selectedCheckedCameraZones);
                if (Object.keys(this.pinnedCameraZones.CameraZones).length === 0) {
                    this.showCamZoneData = true;
                }
                else {
                    if (this.pinnedCameraZones[key].length === 0)
                        delete this.pinnedCameraZones[key];
                    else
                        this.pinnedCameraZonesKeys = Object.keys(this.pinnedCameraZones);
                }
                this.pinnedCameraZonesCount = this.pinnedCameraZones[key].length;
            }, 100);
        };
        this.selectMultipleCameras = (key, metaData) => {
            this.selectedCheckedCameras[key + "~~~" + metaData.value] = this
                .selectedCheckedCameras[key + "~~~" + metaData.value]
                ? !this.selectedCheckedCameras[key + "~~~" + metaData.value]
                : true;
            // if (this.pinnedCameras[key] && this.pinnedCameras[key].length > 2) {
            //   this.selectedCheckedCameras[key + '~~~' + metaData.value] = false ;
            //   setTimeout(() => {
            //   this.dataService.setToastMessage('You can pin a maximum of 3 Cameras', 2000, null, null, 'error')
            //   },1);
            // } else {
            // this.selectedCheckedCameras[key + '~~~' + metaData.value] = true;
            // this.checkedNumber += 1;
            // }
            if (this.selectedCheckedCameras[key + "~~~" + metaData.value]) {
                this.showCamData = false;
                if (this.pinnedCameras[key])
                    this.pinnedCameras[key].push({
                        id: metaData.id,
                        value: metaData.value
                    });
                else
                    this.pinnedCameras[key] = [
                        { id: metaData.id, value: metaData.value }
                    ];
            }
            else {
                this.pinnedCameras[key] = this.pinnedCameras[key].filter((item) => item.value !== metaData.value);
                this.selectedCheckedCameras[key + "~~~" + metaData.value] = false;
                // this.checkedNumber -= 1;
                if (Object.keys(this.pinnedCameras.CameraId).length === 0) {
                    this.showCamData = true;
                }
                else {
                    if (this.pinnedCameras[key].length === 0)
                        delete this.pinnedCameras[key];
                }
            }
            // console.log('this.pinnedCameras :: ', this.pinnedCameras);
            this.pinnedCamerasKeys =
                isUndefined(this.pinnedCameras) || isEmpty(this.pinnedCameras)
                    ? 0
                    : Object.keys(this.pinnedCameras);
            this.selectedCheckedCamerasKeys =
                isUndefined(this.selectedCheckedCameras) ||
                    isEmpty(this.selectedCheckedCameras)
                    ? 0
                    : Object.keys(this.selectedCheckedCameras);
            this.pinnedCamerasCount =
                isUndefined(this.pinnedCameras) || isEmpty(this.pinnedCameras)
                    ? 0
                    : this.pinnedCameras[key].length;
        };
        this.selectMultipleCameraZones = (key, metaData) => {
            this.selectedCheckedCameraZones[key + "~~~" + metaData.value] = this
                .selectedCheckedCameraZones[key + "~~~" + metaData.value]
                ? !this.selectedCheckedCameraZones[key + "~~~" + metaData.value]
                : true;
            if (this.selectedCheckedCameraZones[key + "~~~" + metaData.value]) {
                // if (this.pinnedCameraZones[key] && this.pinnedCameraZones[key].length > 2) {
                //   this.selectedCheckedCameraZones[key + '~~~' + metaData.value] = false;
                //   delete this.selectedCheckedCameraZones[key + '~~~' + metaData.value];
                //   // this.dataService.setToastMessage('You can pin a maximum of 3 Camera Zones', 50, null, null, 'error');
                //   return;
                // }
                this.showCamZoneData = false;
                if (this.pinnedCameraZones[key])
                    this.pinnedCameraZones[key].push({
                        id: metaData.id,
                        value: metaData.value
                    });
                else
                    this.pinnedCameraZones[key] = [
                        { id: metaData.id, value: metaData.value }
                    ];
            }
            else {
                this.pinnedCameraZones[key] = this.pinnedCameraZones[key].filter((item) => item.value !== metaData.value);
                delete this.selectedCheckedCameraZones[key + "~~~" + metaData.value];
                if (Object.keys(this.pinnedCameraZones.CameraZones).length === 0) {
                    this.showCamZoneData = true;
                }
                else {
                    if (this.pinnedCameraZones[key].length === 0)
                        delete this.pinnedCameraZones[key];
                }
            }
            // console.log('this.pinnedCameras :: ', this.pinnedCameras);
            this.pinnedCameraZonesKeys =
                isUndefined(this.pinnedCameraZones) ||
                    isEmpty(this.pinnedCameraZones)
                    ? 0
                    : Object.keys(this.pinnedCameraZones);
            this.selectedCheckedCameraZonesKeys =
                isUndefined(this.selectedCheckedCameraZones) ||
                    isEmpty(this.selectedCheckedCameraZones)
                    ? 0
                    : Object.keys(this.selectedCheckedCameraZones);
            this.pinnedCameraZonesCount =
                isUndefined(this.pinnedCameraZones) ||
                    isEmpty(this.pinnedCameraZones)
                    ? 0
                    : this.pinnedCameraZones[key].length;
        };
        this.applyPinnedCameras = () => {
            this.rightNowsObj["pinnedCameras"] = this.pinnedCameras;
            this.rightNowsObj["pinnedCameraZones"] = this.pinnedCameraZones;
            this.rightNowsObj["selectedCheckedCameras"] =
                this.selectedCheckedCameras;
            this.rightNowsObj["selectedCheckedCameraZones"] =
                this.selectedCheckedCameraZones;
            this.pinnedCount =
                this.pinnedCamerasCount + this.pinnedCameraZonesCount;
            this.dataService.setRightNowObject(this.rightNowsObj);
            this.data["applyPinnedCamerasEvt"] = true;
            // this.applyPinnedCamerasEvt.emit();
            this.closePinnedCameraPopup(false);
        };
        this.getSelectedTagKeys = () => {
            return Object.keys(this.selectedCheckedCameras);
        };
        this.getSelectedValue = (selectedTag) => {
            return selectedTag.split("~~~")[1].trim();
        };
        this.mouseOver = () => {
            if (!this.disablePinCameras) {
                this.showOnHover = true;
                $(".tags-on-hover").fadeIn(500);
            }
        };
        this.mouseOut = () => {
            if (!this.disablePinCameras) {
                this.showOnHover = false;
                $(".tags-on-hover").fadeOut(500);
            }
        };
        this.selectTab = (tab) => {
            this.selectedTab = tab;
        };
        this.getKey = (key) => {
            return this.translateKeys[key];
        };
        this.data["applyPinnedCamerasEvt"] = false;
        const value = data.cameraData;
        if (value && Object.keys(value).length > 0) {
            //  this.cameraObj = { "CameraId": [{ "id": 22, "value": "Camera Id 2" }, { "id": 9, "value": "Camera Id 1" }], "CameraZones": [{ "id": 6, "value": "Camera Id 2_1" }, { "id": 3, "value": "Camera Id 1_1" }] }
            this.cameraObj = value;
            this.searchCameraValue(this.searchTxt);
        }
        this.disablePinCameras = data.disablePinCameras;
        this.metricGroup = data.metricGroup;
        this.pinnedCamerasCount = 0;
        this.showCamData = true;
        this.showCamZoneData = true;
        this.dataService
            .getRightNowObject(this.unsubscribe$)
            .subscribe((spacesObj) => {
            if (spacesObj != null) {
                if (spacesObj["pinnedCameras"] ||
                    spacesObj["pinnedCameraZones"]) {
                    this.pinnedCameras = spacesObj["pinnedCameras"];
                    this.pinnedCamerasKeys = Object.keys(this.pinnedCameras);
                    this.pinnedCameraZones = spacesObj["pinnedCameraZones"];
                    this.pinnedCameraZonesKeys = Object.keys(this.pinnedCameraZones);
                    const camCnt = this.pinnedCameras[this.pinnedCamerasKeys[0]]
                        ? this.pinnedCameras[this.pinnedCamerasKeys[0]]
                            .length
                        : 0;
                    const camZoneCnt = this.pinnedCameraZones[this.pinnedCameraZonesKeys[0]]
                        ? this.pinnedCameraZones[this.pinnedCameraZonesKeys[0]].length
                        : 0;
                    this.pinnedCount =
                        parseInt(camCnt) + parseInt(camZoneCnt);
                    this.setPinnedCameras();
                    this.setPinnedCameraZones();
                }
                this.rightNowsObj = spacesObj;
            }
        });
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe(() => {
            // Add all fetching of localized string here
            this.getTextKeys();
        });
    }
    // @Output()
    // applyPinnedCamerasEvt = new EventEmitter();
    // @Input()
    // set cameraData(value: any) {
    // 	if (value && Object.keys(value).length > 0) {
    // 		//  this.cameraObj = { "CameraId": [{ "id": 22, "value": "Camera Id 2" }, { "id": 9, "value": "Camera Id 1" }], "CameraZones": [{ "id": 6, "value": "Camera Id 2_1" }, { "id": 3, "value": "Camera Id 1_1" }] }
    // 		this.cameraObj = value;
    // 		this.searchCameraValue(this.searchTxt);
    // 	}
    // }
    // @Input()
    // metricGroup: any;
    // @Input()
    // disablePinCameras: any;
    ngOnInit() {
    }
    setPinnedCameras() {
        if (this.pinnedCamerasKeys.length > 0) {
            this.pinnedCamerasKeys.forEach((selMetaDataKey) => {
                this.pinnedCameras[selMetaDataKey].forEach((selMetaValue) => {
                    this.selectedCheckedCameras[selMetaDataKey + "~~~" + selMetaValue.value] = true;
                });
            });
            this.selectedCheckedCamerasKeys = Object.keys(this.selectedCheckedCameras);
        }
        else {
            this.selectedCheckedCamerasKeys = {};
            this.selectedCheckedCameras = {};
        }
    }
    setPinnedCameraZones() {
        if (this.pinnedCameraZonesKeys.length > 0) {
            this.pinnedCameraZonesKeys.forEach((selMetaDataKey) => {
                this.pinnedCameraZones[selMetaDataKey].forEach((selMetaValue) => {
                    this.selectedCheckedCameraZones[selMetaDataKey + "~~~" + selMetaValue.value] = true;
                });
            });
            this.selectedCheckedCameraZonesKeys = Object.keys(this.selectedCheckedCameraZones);
        }
        else {
            this.selectedCheckedCameraZonesKeys = {};
            this.selectedCheckedCameraZones = {};
        }
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
PinCameraPopupComponent.ɵfac = function PinCameraPopupComponent_Factory(t) { return new (t || PinCameraPopupComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i4$2.MatDialog), i0.ɵɵdirectiveInject(i4$2.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
PinCameraPopupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PinCameraPopupComponent, selectors: [["pin-camera-popup"]], outputs: { showEmitter: "showEmitter" }, decls: 1, vars: 1, consts: [["class", "modalPopup modalPopupLg tagsPopup", 4, "ngIf"], [1, "modalPopup", "modalPopupLg", "tagsPopup"], ["class", "modalContent", 4, "ngIf"], [1, "modalContent"], [1, "modalHeader"], [1, "metric-sub-menu"], [1, "sub-menu", 3, "ngClass", "click"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], ["class", "tagsData", 4, "ngIf"], ["class", "modalFooter", 4, "ngIf"], [1, "tagsData"], ["class", "searchBarDiv searchSlide", 4, "ngIf"], ["class", "tagsSelection", 4, "ngIf"], ["class", "noData", 4, "ngIf"], [1, "searchBarDiv", "searchSlide"], ["autocomplete", "off", "novalidate", "", 1, "ng-untouched", "ng-pristine", "ng-valid"], [1, "tag-search-container"], ["id", "tag-search-icon"], ["name", "blahblah", "type", "text", 1, "searchInput", 3, "placeholder", "ngModel", "ngModelChange", "keyup"], [1, "tagsSelection"], [1, "tagsList"], [4, "ngFor", "ngForOf"], [1, "selected-tags-list"], [1, "selected-tags"], ["class", "no-tags", 4, "ngIf"], [1, "tag-key"], ["class", "tag-list", 4, "ngFor", "ngForOf"], [1, "tag-list"], ["type", "checkbox", "name", "tagCheckbox", 3, "disabled", "checked", "id", "change"], [1, "tag-label", 3, "for"], [1, "close-tag", "pointer", 3, "click"], [1, "no-tags"], ["id", "no-tag-image"], [1, "noData"], [1, "noCamDataContainer"], ["src", "/assets/images/camera_d.svg"], [2, "font-size", "24px", "display", "block"], [2, "font-size", "13px", "display", "block"], ["href", "https://www.cisco.com/c/en/us/td/docs/solutions/Enterprise/Mobility/DNA-Spaces/cisco-dna-spaces-config/dnaspaces-configuration-guide/setup.html?bookSearch=true#merakicamera", 2, "color", "#049fd9"], [4, "ngIf"], ["type", "checkbox", "name", "tagCheckbox", 3, "disabled", "checked", "id", "click"], [2, "font-size", "20px", "display", "block"], [1, "modalFooter"], [1, "button-sec"], [1, "commonButton", 3, "click"], [1, "primaryButton", 3, "click"], [1, "selected-count"]], template: function PinCameraPopupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PinCameraPopupComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.show);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i2$1.NgForm, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i1$2.NgForOf], pipes: [i2.TranslatePipe], styles: ["@charset \"UTF-8\";.modalPopup[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;top:0;left:160px;z-index:99999;overflow:auto}.dropdownContainer[_ngcontent-%COMP%]{display:block;width:100%;position:relative}.selectedTags[_ngcontent-%COMP%]{border:1px solid transparent;border-bottom:1px solid rgba(0,0,0,.1);background-color:#fff;border-radius:0;color:#7f7f86;padding:4px 20px 10px 10px;font-size:14px;font-family:\"ciscoSansRegular\";position:relative;cursor:pointer;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.rn-tags[_ngcontent-%COMP%]{font-size:12px;font-family:ciscoSansLight}.selectedTags[_ngcontent-%COMP%]:before{position:absolute;right:10px;top:6px;font-family:\"icomoon-new\";content:\"\\e905\";font-size:14px;color:#bbb}.selectedTags.greenBg[_ngcontent-%COMP%]{background-color:#03b88c}.tagsPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{text-align:center;color:#565659;font-family:CiscoSans;font-size:24px;height:auto!important;padding:18px 30px 0!important}.selected-tags-list[_ngcontent-%COMP%]{width:49%;padding:0 10px 10px 0;float:right;height:300px;overflow-y:auto}.tagsList[_ngcontent-%COMP%]{height:300px;border:1px solid #e9e9e9;overflow-y:auto;text-transform:capitalize;width:50%;display:inline-block;text-align:left}.tagsPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{border-radius:2px;box-shadow:0 1px 3px #b1b1b140;width:60%!important}.tag-search-container[_ngcontent-%COMP%]{position:relative;margin-bottom:10px}.tag-search-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{margin-bottom:0;text-indent:30px;border-bottom:1px solid #a7a9ab!important;width:47%!important}#tag-search-icon[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/search_dropdown.svg);width:24px;height:24px;display:inline-block;background-repeat:no-repeat;background-position:center;vertical-align:middle;position:absolute;bottom:0;top:0;margin:auto}.tagsList[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{color:#9d9d9d;font-family:CiscoSans;font-size:10px}.tag-list[_ngcontent-%COMP%]{padding:12px 0;position:relative}.tagsList[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0 0 0 15px}.tag-list[_ngcontent-%COMP%]:hover{background-color:#f5f5f5;cursor:pointer}.tag-list[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;color:#58585b;font-size:14px}.tag-list[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{vertical-align:middle;float:right;margin-right:30px}label.tag-label[_ngcontent-%COMP%]{position:absolute;right:30px}label.tag-label[_ngcontent-%COMP%]:before{content:\"\";width:20px;height:20px;vertical-align:middle;float:right;margin-right:0}.modalPopup[_ngcontent-%COMP%]{background:rgba(0,0,0,0)!important}.tag-key[_ngcontent-%COMP%]{padding-bottom:10px}.tagsPopup[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{color:#049fd9;border:0 none;font-family:CiscoSans!important;font-size:14px}#no-tag-image[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/no-tag-selected.svg);width:120px;height:120px;display:block;margin:auto auto 30px}.selected-tags[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0}.selected-tags[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-radius:3px;background-color:#f6f6f6;padding:5px 8px;margin-right:10px;margin-bottom:10px;display:inline-block}.no-tags[_ngcontent-%COMP%]{text-align:center}.no-tags[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:24px;line-height:1.25;letter-spacing:.5px;color:#58585b}.no-tags[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#565659;font-family:CiscoSans;line-height:1.43;letter-spacing:.5px}.close-tag[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/popup_close.svg);width:9px;height:9px;display:inline-block;background-repeat:no-repeat;background-position:center;margin-left:20px}.selected-tags-list[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:12px;color:#626469;margin:0}.tagsPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{border:0 none!important;text-align:center}.selTagsInDD[_ngcontent-%COMP%]{background-color:#f6f6f6;display:inline-block;margin-right:10px}.moreTags[_ngcontent-%COMP%]{color:#869ad6;background-color:#f6f6f6;display:inline-block}.tags-on-hover[_ngcontent-%COMP%]{background-color:#fff;padding:10px;border:1px solid #d7d9da;position:absolute;width:90%;left:0;right:0;margin:8px auto auto}.tags-on-hover[_ngcontent-%COMP%]:before{background:url(../../../../../assets/images/business/tooltip_arrow_up.svg);content:\"\";position:absolute;top:-12px;right:25px;width:20px;height:12px;background-position:center}.tags-on-hover[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px;font-family:CiscoSans;color:#58585b;letter-spacing:.58px;line-height:20px;display:inline-block;margin-right:5px}.selected-tag-title[_ngcontent-%COMP%]{display:block!important}.disableFilterByTags[_ngcontent-%COMP%]{opacity:.3}.defaultCursor[_ngcontent-%COMP%]{cursor:default!important}.metric-sub-menu[_ngcontent-%COMP%]{line-height:3.7}.metric-sub-menu[_ngcontent-%COMP%]   .sub-menu[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;padding-left:48px;font-family:CiscoSans;font-size:15px;color:#58585b;letter-spacing:1.1px;padding-top:6px}.metric-sub-menu[_ngcontent-%COMP%]   .sub-menu[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{cursor:pointer}.sub-menu.selectedTab[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-bottom:4px solid #abc233;padding-bottom:25px}.pin-locations-button[_ngcontent-%COMP%]{cursor:pointer;border:1px solid #d7d9da;border-radius:4px;height:36px;width:46px;text-align:center}.pin-locations-button[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;position:absolute;margin-left:2px}.pin-locations-button.filled-bg[_ngcontent-%COMP%]{background-color:#abc233;border-color:#abc233;padding:2px 5px}.pin-locations-button.filled-bg[_ngcontent-%COMP%]   i.pin-icon[_ngcontent-%COMP%]{background-repeat:no-repeat!important;background-position:center!important;background:url(../../../../../assets/images/business/pin_selected.svg)}i.pin-icon[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/pin_unselected.svg);width:15px;height:100%;display:inline-block;vertical-align:middle;background-position:center;margin:auto;background-repeat:no-repeat}.selected-count[_ngcontent-%COMP%]{font-size:14px;color:#58585b;display:inline-block;width:50%;text-align:center}.button-sec[_ngcontent-%COMP%]{display:inline-block;width:50%;text-align:center}.noData[_ngcontent-%COMP%]{font-family:CiscoSansLight;text-align:center;margin:110px}.noCamDataContainer[_ngcontent-%COMP%]{width:500px;margin:auto;color:#979797;text-align:center}.noCamDataContainer[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{display:block;margin:auto}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PinCameraPopupComponent, [{
        type: Component,
        args: [{
                selector: 'pin-camera-popup',
                templateUrl: './pin-camera-popup.component.html',
                styleUrls: ['./pin-camera-popup.component.scss']
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }, { type: i4$2.MatDialog }, { type: i4$2.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, { showEmitter: [{
            type: Output
        }] }); })();

function PinCamerasComponent_sup_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.pinnedCount);
} }
const _c0$m = function (a0) { return { "filled-bg": a0 }; };
class PinCamerasComponent {
    // eslint-disable-next-line no-unused-vars
    constructor(dataService, translate, dialog) {
        this.dataService = dataService;
        this.translate = translate;
        this.dialog = dialog;
        this.unsubscribe$ = new Subject();
        this.rightNowsObj = null;
        this.showCamData = true;
        this.showCamZoneData = true;
        this.show = false;
        this.isSampleData = false;
        this.showOnHover = false;
        this.disableTags = false;
        this.cameraKeys = [];
        this.cameraZoneKeys = [];
        this.pinnedCamerasKeys = [];
        this.pinnedCameras = {};
        this.backupSelectedTags = "{}";
        this.noData = false;
        this.noCamZoneData = false;
        this.selectedCheckedCameras = {};
        this.selectedCheckedCamerasKeys = [];
        this.backupSelectedCheckedTags = "{}";
        this.locationList = [];
        this.isFilteredByTags = false;
        this.selectedTab = "cameras";
        this.selectedCheckedCameraZones = {};
        this.selectedCheckedCameraZonesKeys = [];
        this.pinnedCameraZonesKeys = [];
        this.pinnedCameraZones = {};
        this.pinnedCamerasCount = 0;
        this.pinnedCameraZonesCount = 0;
        this.pinnedCount = 0;
        this.limitNumber = 3;
        this.checkedNumber = 0;
        this.noCamData = false;
        this.translateKeys = [];
        this.showEmitter = new EventEmitter();
        this.applyPinnedCamerasEvt = new EventEmitter();
        this.getTextKeys = () => {
            this.translate.get('shared-lib.pin-camera.CameraId').subscribe((res) => {
                this.translateKeys["CameraId"] = res;
            });
            this.translate.get('shared-lib.pin-camera.CameraZones').subscribe((res) => {
                this.translateKeys["CameraZones"] = res;
            });
        };
        this.searchTxt = "";
        this.searchCameraValue = (searchText) => {
            this.searchTxt = searchText !== "" ? searchText.target.value : searchText;
            if (!this.searchTxt ||
                this.searchTxt == "" ||
                this.searchTxt.length < 2) {
                this.cameraObj_searched = this.cameraObj;
            }
            else {
                const cameraObj_local = {};
                for (const key in this.cameraObj) {
                    if (Object.prototype.hasOwnProperty.call(this.cameraObj, key.toString())) {
                        let matched = false;
                        let val = this.cameraObj["CameraId"];
                        if (this.selectedTab == "cameras") {
                            val = this.cameraObj["CameraId"];
                        }
                        else if (this.selectedTab == "cameraZones") {
                            // console.log("tag iterate", key, val);
                            val = this.cameraObj["CameraZones"];
                        }
                        const childArr = [];
                        val.forEach((keyId) => {
                            const keyVal = keyId.value.toLowerCase();
                            if (keyId.value &&
                                keyVal.indexOf(this.searchTxt.toLowerCase()) > -1) {
                                matched = true;
                                console.log("tag iterate", keyId, keyId.value);
                                childArr.push(JSON.parse(JSON.stringify(keyId)));
                            }
                        });
                        if (matched) {
                            cameraObj_local[key] = childArr;
                        }
                    }
                }
                this.cameraObj_searched = cameraObj_local;
                console.log("$text Searched", cameraObj_local);
            }
            this.getCameraKeys(this.cameraObj_searched);
            this.getCameraZoneKeys(this.cameraObj_searched);
        };
        this.getCameraKeys = (cameras) => {
            let keys = [];
            if (cameras) {
                keys = Object.keys(cameras).sort();
            }
            this.cameraKeys = [keys[0]];
        };
        this.getCameraZoneKeys = (cameras) => {
            let keys = [];
            if (cameras) {
                keys = Object.keys(cameras).sort();
            }
            this.cameraZoneKeys = [keys[1]];
        };
        this.showDropdown = () => {
            if (this.cameraObj.CameraId && this.cameraObj.CameraId.length === 0) {
                this.noCamData = true;
            }
            else {
                this.noCamData = false;
            }
            if (this.cameraObj.CameraZones &&
                this.cameraObj.CameraZones.length === 0) {
                this.noCamZoneData = true;
            }
            else {
                this.noCamZoneData = false;
            }
            if (!this.disablePinCameras) {
                this.show = !this.show;
                this.showEmitter.emit(this.show);
                if (this.show &&
                    this.pinnedCameras &&
                    this.pinnedCameras.CameraId &&
                    this.pinnedCameras.CameraId.length > 0) {
                    this.showCamData = false;
                }
                else {
                    this.showCamData = true;
                }
                if (this.show &&
                    this.pinnedCameras &&
                    this.pinnedCameraZones.CameraZones &&
                    this.pinnedCameraZones.CameraZones.length > 0) {
                    this.showCamZoneData = false;
                }
                else {
                    this.showCamZoneData = true;
                }
            }
            if (this.show) {
                const dialogRef = this.dialog.open(PinCameraPopupComponent, {
                    data: { metricGroup: this.metricGroup, disablePinCameras: this.disablePinCameras, cameraData: this.cameradata }
                });
                dialogRef.afterClosed().subscribe(result => {
                    if (result.applyPinnedCamerasEvt)
                        this.applyPinnedCamerasEvt.emit();
                    console.log(`iot usecase detail popup closed with :: ${result}`);
                    this.show = false;
                    // if( result && result.event && result.event === "getStartedClick"){
                    //         this.getStartedBtnClick();
                    // }
                });
            }
        };
        // customTrackBy(index: number, obj: any): any {
        // 	return index;
        // }
        this.closePinnedCameraPopup = (show) => {
            this.show = show;
            this.showEmitter.emit(this.show);
            this.searchTxt = "";
            this.searchCameraValue(this.searchTxt);
        };
        this.removeCamera = (key, metaData) => {
            this.pinnedCameras[key] = this.pinnedCameras[key].filter((item) => item.value !== metaData.value);
            delete this.selectedCheckedCameras[key + "~~~" + metaData.value];
            setTimeout(() => {
                this.selectedCheckedCamerasKeys = Object.keys(this.selectedCheckedCameras);
                if (Object.keys(this.pinnedCameras.CameraId).length === 0) {
                    this.showCamData = true;
                }
                else {
                    if (this.pinnedCameras[key].length === 0)
                        delete this.pinnedCameras[key];
                    else
                        this.pinnedCamerasKeys = Object.keys(this.pinnedCameras);
                }
                this.pinnedCamerasCount = this.pinnedCameras[key]
                    ? this.pinnedCameras[key].length
                    : 0;
            }, 100);
        };
        this.removeCameraZone = (key, metaData) => {
            this.pinnedCameraZones[key] = this.pinnedCameraZones[key].filter((item) => item.value !== metaData.value);
            delete this.selectedCheckedCameraZones[key + "~~~" + metaData.value];
            setTimeout(() => {
                this.selectedCheckedCameraZonesKeys = Object.keys(this.selectedCheckedCameraZones);
                if (Object.keys(this.pinnedCameraZones.CameraZones).length === 0) {
                    this.showCamZoneData = true;
                }
                else {
                    if (this.pinnedCameraZones[key].length === 0)
                        delete this.pinnedCameraZones[key];
                    else
                        this.pinnedCameraZonesKeys = Object.keys(this.pinnedCameraZones);
                }
                this.pinnedCameraZonesCount = this.pinnedCameraZones[key].length;
            }, 100);
        };
        this.selectMultipleCameras = (key, metaData) => {
            this.selectedCheckedCameras[key + "~~~" + metaData.value] = this
                .selectedCheckedCameras[key + "~~~" + metaData.value]
                ? !this.selectedCheckedCameras[key + "~~~" + metaData.value]
                : true;
            // if (this.pinnedCameras[key] && this.pinnedCameras[key].length > 2) {
            //   this.selectedCheckedCameras[key + '~~~' + metaData.value] = false ;
            //   setTimeout(() => {
            //   this.dataService.setToastMessage('You can pin a maximum of 3 Cameras', 2000, null, null, 'error')
            //   },1);
            // } else {
            // this.selectedCheckedCameras[key + '~~~' + metaData.value] = true;
            // this.checkedNumber += 1;
            // }
            if (this.selectedCheckedCameras[key + "~~~" + metaData.value]) {
                this.showCamData = false;
                if (this.pinnedCameras[key])
                    this.pinnedCameras[key].push({
                        id: metaData.id,
                        value: metaData.value
                    });
                else
                    this.pinnedCameras[key] = [
                        { id: metaData.id, value: metaData.value }
                    ];
            }
            else {
                this.pinnedCameras[key] = this.pinnedCameras[key].filter((item) => item.value !== metaData.value);
                this.selectedCheckedCameras[key + "~~~" + metaData.value] = false;
                // this.checkedNumber -= 1;
                if (Object.keys(this.pinnedCameras.CameraId).length === 0) {
                    this.showCamData = true;
                }
                else {
                    if (this.pinnedCameras[key].length === 0)
                        delete this.pinnedCameras[key];
                }
            }
            // console.log('this.pinnedCameras :: ', this.pinnedCameras);
            this.pinnedCamerasKeys =
                isUndefined(this.pinnedCameras) || isEmpty(this.pinnedCameras)
                    ? 0
                    : Object.keys(this.pinnedCameras);
            this.selectedCheckedCamerasKeys =
                isUndefined(this.selectedCheckedCameras) ||
                    isEmpty(this.selectedCheckedCameras)
                    ? 0
                    : Object.keys(this.selectedCheckedCameras);
            this.pinnedCamerasCount =
                isUndefined(this.pinnedCameras) || isEmpty(this.pinnedCameras)
                    ? 0
                    : this.pinnedCameras[key].length;
        };
        this.selectMultipleCameraZones = (key, metaData) => {
            this.selectedCheckedCameraZones[key + "~~~" + metaData.value] = this
                .selectedCheckedCameraZones[key + "~~~" + metaData.value]
                ? !this.selectedCheckedCameraZones[key + "~~~" + metaData.value]
                : true;
            if (this.selectedCheckedCameraZones[key + "~~~" + metaData.value]) {
                // if (this.pinnedCameraZones[key] && this.pinnedCameraZones[key].length > 2) {
                //   this.selectedCheckedCameraZones[key + '~~~' + metaData.value] = false;
                //   delete this.selectedCheckedCameraZones[key + '~~~' + metaData.value];
                //   // this.dataService.setToastMessage('You can pin a maximum of 3 Camera Zones', 50, null, null, 'error');
                //   return;
                // }
                this.showCamZoneData = false;
                if (this.pinnedCameraZones[key])
                    this.pinnedCameraZones[key].push({
                        id: metaData.id,
                        value: metaData.value
                    });
                else
                    this.pinnedCameraZones[key] = [
                        { id: metaData.id, value: metaData.value }
                    ];
            }
            else {
                this.pinnedCameraZones[key] = this.pinnedCameraZones[key].filter((item) => item.value !== metaData.value);
                delete this.selectedCheckedCameraZones[key + "~~~" + metaData.value];
                if (Object.keys(this.pinnedCameraZones.CameraZones).length === 0) {
                    this.showCamZoneData = true;
                }
                else {
                    if (this.pinnedCameraZones[key].length === 0)
                        delete this.pinnedCameraZones[key];
                }
            }
            // console.log('this.pinnedCameras :: ', this.pinnedCameras);
            this.pinnedCameraZonesKeys =
                isUndefined(this.pinnedCameraZones) ||
                    isEmpty(this.pinnedCameraZones)
                    ? 0
                    : Object.keys(this.pinnedCameraZones);
            this.selectedCheckedCameraZonesKeys =
                isUndefined(this.selectedCheckedCameraZones) ||
                    isEmpty(this.selectedCheckedCameraZones)
                    ? 0
                    : Object.keys(this.selectedCheckedCameraZones);
            this.pinnedCameraZonesCount =
                isUndefined(this.pinnedCameraZones) ||
                    isEmpty(this.pinnedCameraZones)
                    ? 0
                    : this.pinnedCameraZones[key].length;
        };
        this.applyPinnedCameras = () => {
            this.rightNowsObj["pinnedCameras"] = this.pinnedCameras;
            this.rightNowsObj["pinnedCameraZones"] = this.pinnedCameraZones;
            this.rightNowsObj["selectedCheckedCameras"] =
                this.selectedCheckedCameras;
            this.rightNowsObj["selectedCheckedCameraZones"] =
                this.selectedCheckedCameraZones;
            this.pinnedCount =
                this.pinnedCamerasCount + this.pinnedCameraZonesCount;
            this.dataService.setRightNowObject(this.rightNowsObj);
            this.applyPinnedCamerasEvt.emit();
            this.closePinnedCameraPopup(false);
        };
        this.getSelectedTagKeys = () => {
            return Object.keys(this.selectedCheckedCameras);
        };
        this.getSelectedValue = (selectedTag) => {
            return selectedTag.split("~~~")[1].trim();
        };
        this.mouseOver = () => {
            if (!this.disablePinCameras) {
                this.showOnHover = true;
                $(".tags-on-hover").fadeIn(500);
            }
        };
        this.mouseOut = () => {
            if (!this.disablePinCameras) {
                this.showOnHover = false;
                $(".tags-on-hover").fadeOut(500);
            }
        };
        this.selectTab = (tab) => {
            this.selectedTab = tab;
        };
        this.getKey = (key) => {
            return this.translateKeys[key];
        };
    }
    set cameraData(value) {
        this.cameradata = value;
        if (value && Object.keys(value).length > 0) {
            //  this.cameraObj = { "CameraId": [{ "id": 22, "value": "Camera Id 2" }, { "id": 9, "value": "Camera Id 1" }], "CameraZones": [{ "id": 6, "value": "Camera Id 2_1" }, { "id": 3, "value": "Camera Id 1_1" }] }
            this.cameraObj = value;
            this.searchCameraValue(this.searchTxt);
        }
    }
    ngOnInit() {
        this.pinnedCamerasCount = 0;
        this.showCamData = true;
        this.showCamZoneData = true;
        this.dataService
            .getRightNowObject(this.unsubscribe$)
            .subscribe((spacesObj) => {
            if (spacesObj != null) {
                if (spacesObj["pinnedCameras"] ||
                    spacesObj["pinnedCameraZones"]) {
                    this.pinnedCameras = spacesObj["pinnedCameras"];
                    this.pinnedCamerasKeys = Object.keys(this.pinnedCameras);
                    this.pinnedCameraZones = spacesObj["pinnedCameraZones"];
                    this.pinnedCameraZonesKeys = Object.keys(this.pinnedCameraZones);
                    const camCnt = this.pinnedCameras[this.pinnedCamerasKeys[0]]
                        ? this.pinnedCameras[this.pinnedCamerasKeys[0]]
                            .length
                        : 0;
                    const camZoneCnt = this.pinnedCameraZones[this.pinnedCameraZonesKeys[0]]
                        ? this.pinnedCameraZones[this.pinnedCameraZonesKeys[0]].length
                        : 0;
                    this.pinnedCount =
                        parseInt(camCnt) + parseInt(camZoneCnt);
                    this.setPinnedCameras();
                    this.setPinnedCameraZones();
                }
                this.rightNowsObj = spacesObj;
            }
        });
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe(() => {
            // Add all fetching of localized string here
            this.getTextKeys();
        });
    }
    setPinnedCameras() {
        if (this.pinnedCamerasKeys.length > 0) {
            this.pinnedCamerasKeys.forEach((selMetaDataKey) => {
                this.pinnedCameras[selMetaDataKey].forEach((selMetaValue) => {
                    this.selectedCheckedCameras[selMetaDataKey + "~~~" + selMetaValue.value] = true;
                });
            });
            this.selectedCheckedCamerasKeys = Object.keys(this.selectedCheckedCameras);
        }
        else {
            this.selectedCheckedCamerasKeys = {};
            this.selectedCheckedCameras = {};
        }
    }
    setPinnedCameraZones() {
        if (this.pinnedCameraZonesKeys.length > 0) {
            this.pinnedCameraZonesKeys.forEach((selMetaDataKey) => {
                this.pinnedCameraZones[selMetaDataKey].forEach((selMetaValue) => {
                    this.selectedCheckedCameraZones[selMetaDataKey + "~~~" + selMetaValue.value] = true;
                });
            });
            this.selectedCheckedCameraZonesKeys = Object.keys(this.selectedCheckedCameraZones);
        }
        else {
            this.selectedCheckedCameraZonesKeys = {};
            this.selectedCheckedCameraZones = {};
        }
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
PinCamerasComponent.ɵfac = function PinCamerasComponent_Factory(t) { return new (t || PinCamerasComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i4$2.MatDialog)); };
PinCamerasComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PinCamerasComponent, selectors: [["lib-pin-cameras"]], inputs: { cameraData: "cameraData", metricGroup: "metricGroup", disablePinCameras: "disablePinCameras" }, outputs: { showEmitter: "showEmitter", applyPinnedCamerasEvt: "applyPinnedCamerasEvt" }, decls: 4, vars: 4, consts: [[1, "dropdownContainer"], [1, "pin-locations-button", 3, "ngClass", "mouseover", "mouseout", "click"], [1, "pin-icon"], [4, "ngIf"]], template: function PinCamerasComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵlistener("mouseover", function PinCamerasComponent_Template_div_mouseover_1_listener() { return ctx.mouseOver(); })("mouseout", function PinCamerasComponent_Template_div_mouseout_1_listener() { return ctx.mouseOut(); })("click", function PinCamerasComponent_Template_div_click_1_listener() { return ctx.showDropdown(); });
        i0.ɵɵelement(2, "i", 2);
        i0.ɵɵtemplate(3, PinCamerasComponent_sup_3_Template, 2, 1, "sup", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$m, ctx.pinnedCount > 0));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.pinnedCount > 0);
    } }, directives: [i1$2.NgClass, i1$2.NgIf], styles: ["@charset \"UTF-8\";.modalPopup[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;top:0;left:160px;z-index:99999;overflow:auto}.dropdownContainer[_ngcontent-%COMP%]{display:block;width:100%;position:relative}.selectedTags[_ngcontent-%COMP%]{border:1px solid transparent;border-bottom:1px solid rgba(0,0,0,.1);background-color:#fff;border-radius:0;color:#7f7f86;padding:4px 20px 10px 10px;font-size:14px;font-family:\"ciscoSansRegular\";position:relative;cursor:pointer;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.rn-tags[_ngcontent-%COMP%]{font-size:12px;font-family:ciscoSansLight}.selectedTags[_ngcontent-%COMP%]:before{position:absolute;right:10px;top:6px;font-family:\"icomoon-new\";content:\"\\e905\";font-size:14px;color:#bbb}.selectedTags.greenBg[_ngcontent-%COMP%]{background-color:#03b88c}.tagsPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{text-align:center;color:#565659;font-family:CiscoSans;font-size:24px;height:auto!important;padding:18px 30px 0!important}.selected-tags-list[_ngcontent-%COMP%]{width:49%;padding:0 10px 10px 0;float:right;height:300px;overflow-y:auto}.tagsList[_ngcontent-%COMP%]{height:300px;border:1px solid #e9e9e9;overflow-y:auto;text-transform:capitalize;width:50%;display:inline-block;text-align:left}.tagsPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{border-radius:2px;box-shadow:0 1px 3px #b1b1b140;width:60%!important}.tag-search-container[_ngcontent-%COMP%]{position:relative;margin-bottom:10px}.tag-search-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{margin-bottom:0;text-indent:30px;border-bottom:1px solid #a7a9ab!important;width:47%!important}#tag-search-icon[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/search_dropdown.svg);width:24px;height:24px;display:inline-block;background-repeat:no-repeat;background-position:center;vertical-align:middle;position:absolute;bottom:0;top:0;margin:auto}.tagsList[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{color:#9d9d9d;font-family:CiscoSans;font-size:10px}.tag-list[_ngcontent-%COMP%]{padding:12px 0;position:relative}.tagsList[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0 0 0 15px}.tag-list[_ngcontent-%COMP%]:hover{background-color:#f5f5f5;cursor:pointer}.tag-list[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;color:#58585b;font-size:14px}.tag-list[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{vertical-align:middle;float:right;margin-right:30px}label.tag-label[_ngcontent-%COMP%]{position:absolute;right:30px}label.tag-label[_ngcontent-%COMP%]:before{content:\"\";width:20px;height:20px;vertical-align:middle;float:right;margin-right:0}.tag-key[_ngcontent-%COMP%]{padding-bottom:10px}.tagsPopup[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{color:#049fd9;border:0 none;font-family:CiscoSans!important;font-size:14px}#no-tag-image[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/no-tag-selected.svg);width:120px;height:120px;display:block;margin:auto auto 30px}.selected-tags[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0}.selected-tags[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-radius:3px;background-color:#f6f6f6;padding:5px 8px;margin-right:10px;margin-bottom:10px;display:inline-block}.no-tags[_ngcontent-%COMP%]{text-align:center}.no-tags[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:24px;line-height:1.25;letter-spacing:.5px;color:#58585b}.no-tags[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#565659;font-family:CiscoSans;line-height:1.43;letter-spacing:.5px}.close-tag[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/popup_close.svg);width:9px;height:9px;display:inline-block;background-repeat:no-repeat;background-position:center;margin-left:20px}.selected-tags-list[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:12px;color:#626469;margin:0}.tagsPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{border:0 none!important;text-align:center}.selTagsInDD[_ngcontent-%COMP%]{background-color:#f6f6f6;display:inline-block;margin-right:10px}.moreTags[_ngcontent-%COMP%]{color:#869ad6;background-color:#f6f6f6;display:inline-block}.tags-on-hover[_ngcontent-%COMP%]{background-color:#fff;padding:10px;border:1px solid #d7d9da;position:absolute;width:90%;left:0;right:0;margin:8px auto auto}.tags-on-hover[_ngcontent-%COMP%]:before{background:url(../../../../../assets/images/business/tooltip_arrow_up.svg);content:\"\";position:absolute;top:-12px;right:25px;width:20px;height:12px;background-position:center}.tags-on-hover[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px;font-family:CiscoSans;color:#58585b;letter-spacing:.58px;line-height:20px;display:inline-block;margin-right:5px}.selected-tag-title[_ngcontent-%COMP%]{display:block!important}.disableFilterByTags[_ngcontent-%COMP%]{opacity:.3}.defaultCursor[_ngcontent-%COMP%]{cursor:default!important}.metric-sub-menu[_ngcontent-%COMP%]{line-height:3.7}.metric-sub-menu[_ngcontent-%COMP%]   .sub-menu[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;padding-left:48px;font-family:CiscoSans;font-size:15px;color:#58585b;letter-spacing:1.1px;padding-top:6px}.metric-sub-menu[_ngcontent-%COMP%]   .sub-menu[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{cursor:pointer}.sub-menu.selectedTab[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-bottom:4px solid #abc233;padding-bottom:25px}.pin-locations-button[_ngcontent-%COMP%]{cursor:pointer;border:1px solid #d7d9da;border-radius:4px;height:36px;width:46px;text-align:center}.pin-locations-button[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;position:absolute;margin-left:2px}.pin-locations-button.filled-bg[_ngcontent-%COMP%]{background-color:#abc233;border-color:#abc233;padding:2px 5px}.pin-locations-button.filled-bg[_ngcontent-%COMP%]   i.pin-icon[_ngcontent-%COMP%]{background-repeat:no-repeat!important;background-position:center!important;background:url(../../../../../assets/images/business/pin_selected.svg)}i.pin-icon[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/pin_unselected.svg);width:15px;height:100%;display:inline-block;vertical-align:middle;background-position:center;margin:auto;background-repeat:no-repeat}.selected-count[_ngcontent-%COMP%]{font-size:14px;color:#58585b;display:inline-block;width:50%;text-align:center}.button-sec[_ngcontent-%COMP%]{display:inline-block;width:50%;text-align:center}.noData[_ngcontent-%COMP%]{font-family:CiscoSansLight;text-align:center;margin:110px}.noCamDataContainer[_ngcontent-%COMP%]{width:500px;margin:auto;color:#979797;text-align:center}.noCamDataContainer[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{display:block;margin:auto}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PinCamerasComponent, [{
        type: Component,
        args: [{
                selector: "lib-pin-cameras",
                templateUrl: "./pin-cameras.component.html",
                styleUrls: ["./pin-cameras.component.scss"]
            }]
    }], function () { return [{ type: DataService }, { type: i2.TranslateService }, { type: i4$2.MatDialog }]; }, { showEmitter: [{
            type: Output
        }], applyPinnedCamerasEvt: [{
            type: Output
        }], cameraData: [{
            type: Input
        }], metricGroup: [{
            type: Input
        }], disablePinCameras: [{
            type: Input
        }] }); })();

const _c0$l = function (a0) { return { "row-hover": a0 }; };
function SpacesLocationHierarchyComponent_ng_template_2_tree_node_wrapper_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tree-node-wrapper", 9);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    const node_r7 = ctx_r13.$implicit;
    const index_r8 = ctx_r13.index;
    const templates_r9 = ctx_r13.templates;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r10.getPadding(node_r7, ctx_r10.isPopup));
    i0.ɵɵproperty("node", node_r7)("index", index_r8)("templates", templates_r9)("ngClass", i0.ɵɵpureFunction1(7, _c0$l, node_r7.data.showMenu));
} }
function SpacesLocationHierarchyComponent_ng_template_2_tree_node_wrapper_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tree-node-wrapper", 9);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    const node_r7 = ctx_r14.$implicit;
    const index_r8 = ctx_r14.index;
    const templates_r9 = ctx_r14.templates;
    i0.ɵɵproperty("node", node_r7)("index", index_r8)("templates", templates_r9)("ngClass", i0.ɵɵpureFunction1(4, _c0$l, node_r7.data.showMenu));
} }
function SpacesLocationHierarchyComponent_ng_template_2_lib_row_menu_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-row-menu", 10);
} if (rf & 2) {
    const node_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("node", node_r7);
} }
function SpacesLocationHierarchyComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SpacesLocationHierarchyComponent_ng_template_2_tree_node_wrapper_1_Template, 1, 9, "tree-node-wrapper", 5);
    i0.ɵɵtemplate(2, SpacesLocationHierarchyComponent_ng_template_2_tree_node_wrapper_2_Template, 1, 6, "tree-node-wrapper", 6);
    i0.ɵɵtemplate(3, SpacesLocationHierarchyComponent_ng_template_2_lib_row_menu_3_Template, 1, 1, "lib-row-menu", 7);
    i0.ɵɵelement(4, "tree-node-children", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r7 = ctx.$implicit;
    const templates_r9 = ctx.templates;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2.getClass(node_r7));
    i0.ɵɵclassProp("tree-node", true)("tree-node-expanded", node_r7.isExpanded && node_r7.hasChildren)("tree-node-collapsed", node_r7.isCollapsed && node_r7.hasChildren)("tree-node-leaf", node_r7.isLeaf)("tree-node-active", node_r7.isActive)("tree-node-focused", node_r7.isFocused);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r7.data.showMenu);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("node", ctx_r2.sortChildren(node_r7))("templates", templates_r9);
} }
function SpacesLocationHierarchyComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "Loading, please hold....");
} }
function SpacesLocationHierarchyComponent_ng_template_6_div_0_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵlistener("mouseover", function SpacesLocationHierarchyComponent_ng_template_6_div_0_span_6_Template_span_mouseover_0_listener() { i0.ɵɵrestoreView(_r31); const node_r16 = i0.ɵɵnextContext(2).$implicit; const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.onMouseOverNodeFn(node_r16.data); })("mouseout", function SpacesLocationHierarchyComponent_ng_template_6_div_0_span_6_Template_span_mouseout_0_listener() { i0.ɵɵrestoreView(_r31); const node_r16 = i0.ɵɵnextContext(2).$implicit; const ctx_r32 = i0.ɵɵnextContext(); return ctx_r32.onMouseOutNodeFn(node_r16.data); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" (", node_r16.data.total, " out of ", node_r16.data.permitted, ") ");
} }
function SpacesLocationHierarchyComponent_ng_template_6_div_0_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵelement(1, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r16.apsMatched, i0.ɵɵsanitizeHtml);
} }
const _c1$8 = function (a0) { return { "disable-location": a0 }; };
const _c2$6 = function (a0) { return { "highlightLocation": a0 }; };
function SpacesLocationHierarchyComponent_ng_template_6_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function SpacesLocationHierarchyComponent_ng_template_6_div_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r38); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.selectNode(node_r16); })("mouseover", function SpacesLocationHierarchyComponent_ng_template_6_div_0_Template_div_mouseover_0_listener() { i0.ɵɵrestoreView(_r38); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r39 = i0.ɵɵnextContext(); return ctx_r39.onMouseOverNodeFn(node_r16.data); })("mouseout", function SpacesLocationHierarchyComponent_ng_template_6_div_0_Template_div_mouseout_0_listener() { i0.ɵɵrestoreView(_r38); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r41 = i0.ɵɵnextContext(); return ctx_r41.onMouseOutNodeFn(node_r16.data); });
    i0.ɵɵelementStart(1, "a", 20);
    i0.ɵɵelement(2, "span", 21);
    i0.ɵɵelementStart(3, "span", 22);
    i0.ɵɵlistener("click", function SpacesLocationHierarchyComponent_ng_template_6_div_0_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r38); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r43 = i0.ɵɵnextContext(); return ctx_r43.clickedLocation(node_r16.data); });
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, SpacesLocationHierarchyComponent_ng_template_6_div_0_span_6_Template, 2, 2, "span", 23);
    i0.ɵɵtemplate(7, SpacesLocationHierarchyComponent_ng_template_6_div_0_span_7_Template, 2, 1, "span", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$8, !ctx_r18.multiLocationSelect && ctx_r18.showCameraCountAlert(node_r16) || ctx_r18.rightNowPage && (node_r16.data.type === "zone" || node_r16.data.type === "cmxzone" || node_r16.data.type === "polygon_zone")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 5, node_r16.data.name), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(9, _c2$6, ctx_r18.reportType === "REAL_TIME"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", node_r16.data.permitted != node_r16.data.total);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r16.apsMatched);
} }
function SpacesLocationHierarchyComponent_ng_template_6_div_1_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵlistener("mouseover", function SpacesLocationHierarchyComponent_ng_template_6_div_1_span_6_Template_span_mouseover_0_listener() { i0.ɵɵrestoreView(_r50); const node_r16 = i0.ɵɵnextContext(2).$implicit; const ctx_r48 = i0.ɵɵnextContext(); return ctx_r48.onMouseOverNodeFn(node_r16.data); })("mouseout", function SpacesLocationHierarchyComponent_ng_template_6_div_1_span_6_Template_span_mouseout_0_listener() { i0.ɵɵrestoreView(_r50); const node_r16 = i0.ɵɵnextContext(2).$implicit; const ctx_r51 = i0.ɵɵnextContext(); return ctx_r51.onMouseOutNodeFn(node_r16.data); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" (", node_r16.data.total, " out of ", node_r16.data.permitted, ") ");
} }
function SpacesLocationHierarchyComponent_ng_template_6_div_1_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵelement(1, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r16.apsMatched, i0.ɵɵsanitizeHtml);
} }
function SpacesLocationHierarchyComponent_ng_template_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "a", 20);
    i0.ɵɵelement(2, "span", 21);
    i0.ɵɵelement(3, "span", 29);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelement(5, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, SpacesLocationHierarchyComponent_ng_template_6_div_1_span_6_Template, 2, 2, "span", 23);
    i0.ɵɵtemplate(7, SpacesLocationHierarchyComponent_ng_template_6_div_1_span_7_Template, 2, 1, "span", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$8, !ctx_r19.multiLocationSelect && ctx_r19.showCameraCountAlert(node_r16) || ctx_r19.rightNowPage && (node_r16.data.type === "zone" || node_r16.data.type === "cmxzone" || node_r16.data.type === "polygon_zone")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 5, node_r16.data.name), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(9, _c2$6, ctx_r19.reportType === "REAL_TIME"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", node_r16.data.permitted != node_r16.data.total);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r16.apsMatched);
} }
function SpacesLocationHierarchyComponent_ng_template_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "loc_tooltip_", node_r16.data.id, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "shared-lib.spaces-loc-hierarchy.rightnow-zone-alert"), " ");
} }
function SpacesLocationHierarchyComponent_ng_template_6_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelementStart(1, "div", 33);
    i0.ɵɵelementStart(2, "img", 34);
    i0.ɵɵlistener("mouseover", function SpacesLocationHierarchyComponent_ng_template_6_div_3_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r59); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r57 = i0.ɵɵnextContext(); return ctx_r57.cameraCountAlertMouseOver($event, node_r16.data.id); })("mouseover", function SpacesLocationHierarchyComponent_ng_template_6_div_3_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r59); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r60 = i0.ɵɵnextContext(); return ctx_r60.cameraCountAlertMouseOut($event, node_r16.data.id); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 35);
    i0.ɵɵtext(4, " No camera(s) available at this location ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "camera-count_", node_r16.data.id, "");
} }
function SpacesLocationHierarchyComponent_ng_template_6_div_4_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵelement(1, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r16.apsMatched, i0.ɵɵsanitizeHtml);
} }
function SpacesLocationHierarchyComponent_ng_template_6_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelementStart(1, "a", 20);
    i0.ɵɵelement(2, "span", 21);
    i0.ɵɵelement(3, "span", 29);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SpacesLocationHierarchyComponent_ng_template_6_div_4_span_5_Template, 2, 1, "span", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 3, node_r16.data.name), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(5, _c2$6, ctx_r22.reportType === "REAL_TIME"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r16.apsMatched);
} }
function SpacesLocationHierarchyComponent_ng_template_6_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r68 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelementStart(1, "input", 38);
    i0.ɵɵlistener("click", function SpacesLocationHierarchyComponent_ng_template_6_div_5_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r68); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r66 = i0.ɵɵnextContext(); return ctx_r66.selectNode(node_r16); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r23 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r16.data.id, "");
    i0.ɵɵproperty("checked", ctx_r23.selectedLocation && ctx_r23.selectedLocation.length > 0 && node_r16.id === ctx_r23.selectedLocation[0].id)("value", node_r16.data.id);
} }
function SpacesLocationHierarchyComponent_ng_template_6_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r72 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelementStart(1, "input", 38);
    i0.ɵɵlistener("click", function SpacesLocationHierarchyComponent_ng_template_6_div_6_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r72); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r70 = i0.ɵɵnextContext(); return ctx_r70.selectNode(node_r16); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 39);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r24 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r16.data.id, "");
    i0.ɵɵproperty("checked", ctx_r24.selectedLocation && ctx_r24.selectedLocation.length > 0 && node_r16.id === ctx_r24.selectedLocation[0].id)("value", node_r16.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r16.data.id, "");
} }
function SpacesLocationHierarchyComponent_ng_template_6_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r76 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelementStart(1, "input", 41);
    i0.ɵɵlistener("click", function SpacesLocationHierarchyComponent_ng_template_6_div_7_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r76); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r74 = i0.ɵɵnextContext(); return ctx_r74.selectMultipleNode($event, node_r16); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r25 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r16.data.id, "");
    i0.ɵɵproperty("checked", ctx_r25.isNodeSelected)("value", node_r16.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r16.data.id, "");
} }
function SpacesLocationHierarchyComponent_ng_template_6_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r80 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelementStart(1, "div", 33);
    i0.ɵɵelementStart(2, "img", 34);
    i0.ɵɵlistener("mouseover", function SpacesLocationHierarchyComponent_ng_template_6_div_8_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r80); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r78 = i0.ɵɵnextContext(); return ctx_r78.locationInfoMouseOver($event, node_r16.data.id); })("mouseover", function SpacesLocationHierarchyComponent_ng_template_6_div_8_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r80); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r81 = i0.ɵɵnextContext(); return ctx_r81.locationInfoMouseOut($event, node_r16.data.id); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 44);
    i0.ɵɵtext(4, " Location does not have sufficient data ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "loc_info_", node_r16.data.id, "");
} }
function SpacesLocationHierarchyComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SpacesLocationHierarchyComponent_ng_template_6_div_0_Template, 8, 11, "div", 11);
    i0.ɵɵtemplate(1, SpacesLocationHierarchyComponent_ng_template_6_div_1_Template, 8, 11, "div", 12);
    i0.ɵɵtemplate(2, SpacesLocationHierarchyComponent_ng_template_6_div_2_Template, 4, 4, "div", 13);
    i0.ɵɵtemplate(3, SpacesLocationHierarchyComponent_ng_template_6_div_3_Template, 5, 1, "div", 14);
    i0.ɵɵtemplate(4, SpacesLocationHierarchyComponent_ng_template_6_div_4_Template, 6, 7, "div", 15);
    i0.ɵɵtemplate(5, SpacesLocationHierarchyComponent_ng_template_6_div_5_Template, 2, 3, "div", 16);
    i0.ɵɵtemplate(6, SpacesLocationHierarchyComponent_ng_template_6_div_6_Template, 3, 4, "div", 16);
    i0.ɵɵtemplate(7, SpacesLocationHierarchyComponent_ng_template_6_div_7_Template, 3, 4, "div", 17);
    i0.ɵɵtemplate(8, SpacesLocationHierarchyComponent_ng_template_6_div_8_Template, 5, 1, "div", 18);
} if (rf & 2) {
    const node_r16 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && (node_r16.data.access === "Full" || node_r16.data.reportAccess));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && node_r16.data.access !== "Full" && !node_r16.data.reportAccess);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.rightNowPage && (node_r16.data.type === "zone" || node_r16.data.type === "cmxzone" || node_r16.data.type === "polygon_zone"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && ctx_r6.showCameraCountAlert(node_r16));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.multiLocationSelect);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (node_r16.data.access === "Full" || node_r16.data.reportAccess) && (!ctx_r6.multiLocationSelect && !ctx_r6.rightNowPage || ctx_r6.rightNowPage && (node_r16.data.type !== "zone" && node_r16.data.type !== "cmxzone" && node_r16.data.type !== "polygon_zone")));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && !ctx_r6.isRichMapAvailable && (!ctx_r6.rightNowPage || !ctx_r6.energyUtilPage) || (ctx_r6.energyUtilPage || ctx_r6.rightNowPage) && (node_r16.data.type !== "zone" && node_r16.data.type !== "cmxzone" && node_r16.data.type !== "polygon_zone"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.multiLocationSelect && node_r16.data.type === "network" && ctx_r6.isIncluded(node_r16) || ctx_r6.multiLocationSelect && ctx_r6.dataExportPage && node_r16.data.type !== "root" && ctx_r6.checkFloorZoneDisabling(node_r16));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.multiLocationSelect && node_r16.data.type === "network" && !ctx_r6.isIncluded(node_r16));
} }
class SpacesLocationHierarchyComponent extends ManageLocationTreeComponent {
    constructor(router_, dataService_, locationService_, cdRef_) {
        super(router_, dataService_, locationService_, cdRef_);
        this.router_ = router_;
        this.dataService_ = dataService_;
        this.locationService_ = locationService_;
        this.cdRef_ = cdRef_;
        this.rightNowPage = false;
        this.energyUtilPage = false;
        this.mysignagePage = false;
        this.rootLocationObj = {};
        this.maxSelectionNumber = 3;
        this.prevSearchString = "";
        this.excludedLocs = [];
        this.dataExportPage = false;
        this.onEvent = ($event) => {
            console.log('onEvent from tree::', $event);
            switch ($event.eventName) {
                case "initialized":
                    console.log("location loading done", new Date().getTime() - this.startTime);
                    this.isTreeInitialised = true;
                    this.treeComponent.treeModel.roots.forEach((root) => {
                        this.rootLocationObj = root.data;
                        if (root.isCollapsed)
                            root.expand();
                    });
                    this.initLocationNodes();
                    setTimeout(() => {
                        if (this.treeComponent) {
                            this.treeComponent.sizeChanged();
                        }
                    }, 100);
                    break;
                case "toggleExpanded":
                    setTimeout(() => {
                        if (this.treeComponent) {
                            this.treeComponent.sizeChanged();
                        }
                    }, 100);
                    break;
            }
            // this.searchTree(this.searchTimestamp);
        };
        this.initLocationNodes = () => {
            if (this.currentFilterLocations &&
                this.currentFilterLocations.length > 0) {
                this.filterLocationIds(this.currentFilterLocations);
            }
            else {
                this.location = this.locationOrginal;
            }
            this.prevFilterLocations = this.currentFilterLocations;
        };
        this.sortChildren = (node) => {
            return node;
        };
        this.clickedLocation = (data) => {
            // if (this.reportType == "REAL_TIME"){
            //   let spacesObj = JSON.parse(sessionStorage.getItem('spacesObj'));
            //   if(data.type == "network" || data.type == "root"){
            //     delete spacesObj['realtimeLocation'];
            //     spacesObj['spacesLocation'] = {id: data.id, name: data.name, type: data.type == "root" ? 'all' : data.type};
            //   }else{
            //     spacesObj['realtimeLocation'] = {id: data.id};
            //     spacesObj['spacesLocation'] = {id: this.rootLocationObj["id"], name: this.rootLocationObj["name"], type: 'all'};
            //   }
            //   this.dataService.setSpacesObject(spacesObj);
            // }
        };
        this.isIncluded = (node) => {
            if (this.excludedLocs && this.excludedLocs.length > 0) {
                if (this.excludedLocs.indexOf(node.data.id) != -1)
                    return false;
                else
                    return true;
            }
            return true;
        };
        this.checkFloorZoneDisabling = (node) => {
            if (this.exportDisableNode && this.exportDisableNode !== '') {
                if (this.exportDisableNode === 'network' && (node.data.type === 'floor' || node.data.type === 'zone' || node.data.type === 'cmxzone' || node.data.type === 'polygon_zone')) {
                    return false;
                }
                else if (this.exportDisableNode === 'floor' && (node.data.type === 'zone' || node.data.type === 'cmxzone' || node.data.type === 'polygon_zone')) {
                    return false;
                }
                else if (this.exportDisableNode === 'network_floor' && (node.data.type === 'zone' || node.data.type === 'cmxzone' || node.data.type === 'polygon_zone')) {
                    return false;
                }
                else {
                    return true;
                }
            }
            return true;
        };
        this.locationInfoMouseOver = (event, id) => {
            $("#loc_info_" + id).addClass("loc-info-show");
        };
        this.locationInfoMouseOut = (event, id) => {
            setTimeout(() => {
                $("#loc_info_" + id).removeClass("loc-info-show");
            }, 2000);
        };
        this.showCameraCountAlert = (node) => {
            const currentNav = this.dataService.getCurrentNav();
            if (node.data.camerasCount === 0 &&
                currentNav != null &&
                currentNav.indexOf("camera-metrics") !== -1) {
                return true;
            }
            else {
                return false;
            }
        };
        this.cameraCountAlertMouseOver = (event, id) => {
            $("#camera-count_" + id).addClass("camera-count-alert-show");
        };
        this.onMouseOverNodeFn = (nodeData) => {
            this.onMouseOverNode(nodeData, 0);
        };
        this.onMouseOutNodeFn = (nodeData) => {
            this.onMouseOutNode(nodeData, 0);
        };
        this.cameraCountAlertMouseOut = (event, id) => {
            setTimeout(() => {
                $("#camera-count_" + id).removeClass("camera-count-alert-show");
            }, 2000);
        };
        this.isRichMapStatus = (node) => {
            let enableCheck = false;
            if (this.permittedLocationTypes !== undefined &&
                this.permittedLocationTypes !== null &&
                this.permittedLocationTypes.length > 0) {
                // check group or org
                if (this.permittedLocationTypes.indexOf(node.data.type) > -1) {
                    if (node.data.type === "organization" ||
                        node.data.type === "meraki" ||
                        node.data.type === "mse") {
                        enableCheck = true;
                    }
                    else if (node.data.type === "group" &&
                        node.data.locationBit & this.locationFlag.Flags.ADD_NETWORK) {
                        enableCheck = true;
                    }
                    else if (node.data.type !== "organization" &&
                        node.data.type !== "group") {
                        enableCheck = true;
                    }
                    // we need to add the richmap flag check
                }
                else {
                    enableCheck = false;
                }
            }
            else {
                enableCheck = true;
            }
            if (this.isRichMapAvailable) {
                if (enableCheck) {
                    if (node.data.richMapStatus) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
            else {
                return enableCheck;
            }
        };
        this.selectNodeFn = (node) => {
            if (this.isRichMapAvailable) {
                if (this.isRichMapStatus(node)) {
                    this.selectNode(node);
                }
            }
            else {
                this.selectNode(node);
            }
        };
    }
    ngOnInit() {
        this.makeSearchAPICall = false;
        super.ngOnInit();
        if (this.dataService.getCurrentNav().indexOf('right-now') !== -1) {
            this.rightNowPage = true;
        }
        else {
            this.rightNowPage = false;
        }
        if (this.dataService.getCurrentNav().indexOf('energy-util') !== -1) {
            this.energyUtilPage = true;
        }
        else {
            this.energyUtilPage = false;
        }
        if (this.dataService.getCurrentNav().indexOf('dataexport') !== -1) {
            this.dataExportPage = true;
        }
        else {
            this.dataExportPage = false;
        }
        if (this.dataService.getCurrentNav().indexOf('mysignage') !== -1) {
            this.mysignagePage = true;
        }
        else {
            this.mysignagePage = false;
        }
    }
    set disableNode(value) {
        if (value) {
            if (this.dataService.getCurrentNav().indexOf('dataexport') !== -1) {
                this.dataExportPage = true;
            }
            else {
                this.dataExportPage = false;
            }
            this.exportDisableNode = value;
        }
    }
    set searchLocation(value) {
        // this.searchTimestamp = new Date().getTime();
        // if (!value || value.trim() == "")
        //   this.prevSearchString = "";
        // else
        //   this.prevSearchString = value;
        // this.searchTree(this.searchTimestamp);
        // this.subscribeSearchText(value);
        this.enableCustomSearch = true;
        if (value) {
            // this.prevSearchString = customSearchText;
            // this.searchTree(new Date().getTime());
            this.subscribeSearchText(value);
        }
    }
    set filterLocations(filterLocations) {
        this.currentFilterLocations = filterLocations;
        if (this.isTreeInitialised)
            this.initLocationNodes();
    }
    set excludedLocations(excludedLocs) {
        if (excludedLocs)
            this.excludedLocs = excludedLocs;
        else
            this.excludedLocs = [];
    }
    ngOnDestroy() {
        console.log("destory spaces location hierarchy page");
        super.ngOnDestroy();
    }
    selectMultipleNode($event, node) {
        if (this.selectedLocation) {
            // var existingNodeId: number[] = null;
            let index = null;
            this.selectedLocation.filter(function (n, i) {
                if (n.data.id === node.data.id) {
                    index = i;
                    return;
                }
            });
            if (index !== null) {
                super.selectMultipleNode($event, node);
            }
            else {
                if (this.dataExportPage) {
                    super.selectMultipleNode($event, node);
                }
                else if (this.selectedLocation.length < this.maxSelectionNumber) {
                    super.selectMultipleNode($event, node);
                }
                else {
                    // Show error message to user about max selected
                    this.dataService.setToastMessage("You can pin a maximum of 3 locations", 2000, null, null, "error");
                    this.isNodeSelected = false;
                    $event.target["checked"] = false;
                }
            }
        }
        else {
            super.selectMultipleNode($event, node);
        }
    }
}
SpacesLocationHierarchyComponent.ɵfac = function SpacesLocationHierarchyComponent_Factory(t) { return new (t || SpacesLocationHierarchyComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
SpacesLocationHierarchyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SpacesLocationHierarchyComponent, selectors: [["lib-spaces-location-hierarchy"]], inputs: { disableRootCheckbox: "disableRootCheckbox", isRichMapAvailable: "isRichMapAvailable", permittedLocationTypes: "permittedLocationTypes", disableNode: "disableNode", searchLocation: "searchLocation", filterLocations: "filterLocations", excludedLocations: "excludedLocations" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 2, consts: [[3, "nodes", "options", "event", "stateChange"], ["tree", ""], ["treeNodeFullTemplate", ""], ["loadingTemplate", ""], ["treeNodeTemplate", ""], ["class", "pointer", 3, "node", "index", "templates", "ngClass", "style", 4, "ngIf"], ["class", "pointer", 3, "node", "index", "templates", "ngClass", 4, "ngIf"], [3, "node", 4, "ngIf"], [3, "node", "templates"], [1, "pointer", 3, "node", "index", "templates", "ngClass"], [3, "node"], ["class", "location-node-name", 3, "ngClass", "click", "mouseover", "mouseout", 4, "ngIf"], ["class", "location-node-name", 3, "ngClass", 4, "ngIf"], ["class", "zone-alert", 4, "ngIf"], ["class", "camera-count-alert", 4, "ngIf"], ["class", "location-node-name", 4, "ngIf"], ["class", "repotLocationPopupRadio", 4, "ngIf"], ["class", "circularCheckbox", 4, "ngIf"], ["class", "location-info", 4, "ngIf"], [1, "location-node-name", 3, "ngClass", "click", "mouseover", "mouseout"], ["href", "javascript:void(0);", 1, "location-name-icon"], [1, "loc-type-icon"], [1, "location-name", 3, "innerHTML", "ngClass", "click"], ["class", "location-count", 3, "mouseover", "mouseout", 4, "ngIf"], ["class", "matchedApDetails", 4, "ngIf"], [1, "location-count", 3, "mouseover", "mouseout"], [1, "matchedApDetails"], [3, "innerHTML"], [1, "location-node-name", 3, "ngClass"], [1, "location-name", 3, "innerHTML", "ngClass"], [1, "zone-alert"], [1, "zone-alert-message", 3, "id"], [1, "camera-count-alert"], [1, "locationInfo"], ["src", "/assets/images/notification_icon.svg", 3, "mouseover"], [1, "camera-count-alert-message", 3, "id"], [1, "location-node-name"], [1, "repotLocationPopupRadio"], ["type", "radio", "name", "locationRadio", 3, "checked", "id", "value", "click"], [1, "radioButtonLabel", 3, "for"], [1, "circularCheckbox"], ["type", "checkbox", "name", "locationChecbox", 3, "checked", "id", "value", "click"], [1, "checkboxLabel", 3, "for"], [1, "location-info"], [1, "loc-info", 3, "id"]], template: function SpacesLocationHierarchyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "tree-root", 0, 1);
        i0.ɵɵlistener("event", function SpacesLocationHierarchyComponent_Template_tree_root_event_0_listener($event) { return ctx.onEvent($event); })("stateChange", function SpacesLocationHierarchyComponent_Template_tree_root_stateChange_0_listener($event) { return ctx.setState($event); });
        i0.ɵɵtemplate(2, SpacesLocationHierarchyComponent_ng_template_2_Template, 5, 19, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, SpacesLocationHierarchyComponent_ng_template_4_Template, 1, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, SpacesLocationHierarchyComponent_ng_template_6_Template, 9, 9, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("nodes", ctx.location)("options", ctx.options);
    } }, directives: [i4.TreeComponent, i1$2.NgIf, i4.TreeNodeChildrenComponent, i4.TreeNodeWrapperComponent, i1$2.NgClass, RowMenuComponent], pipes: [SafeHtmlPipe, i2.TranslatePipe], styles: [".locationInfo[_ngcontent-%COMP%]{width:20px}.locationInfo[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:15px}.loc-info[_ngcontent-%COMP%], .camera-count-alert-message[_ngcontent-%COMP%], .zone-alert-message[_ngcontent-%COMP%]{display:none;position:absolute;right:0;left:20px;font-size:12px;color:#fff;background:#565659;width:180px;padding:5px 8px;font-family:CiscoSans;text-transform:initial;z-index:9;margin:5px auto auto}.camera-count-alert-message[_ngcontent-%COMP%]{left:-13em}.zone-alert-message[_ngcontent-%COMP%]{left:-30em}.loc-info[_ngcontent-%COMP%]:before, .camera-count-alert-message[_ngcontent-%COMP%]:before{content:\"\";border-left:7px solid transparent;border-bottom:7px solid #565659;border-right:7px solid transparent;position:absolute;right:11px;top:-7px}.loc-info-show[_ngcontent-%COMP%], .camera-count-alert-show[_ngcontent-%COMP%], .zone-alert-show[_ngcontent-%COMP%]{display:block}.camera-count-alert[_ngcontent-%COMP%], .zone-alert[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle;position:relative}.location-node-name.disable-location[_ngcontent-%COMP%], .location-node-name.disable-location[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:default!important}.location-node-name.disable-location[_ngcontent-%COMP%]   .location-name[_ngcontent-%COMP%]:hover{border:0 none!important;font-family:ciscoSansRegular!important}.location-node-name.disable-location[_ngcontent-%COMP%]{opacity:.5}.modalContent-beta[_ngcontent-%COMP%]{width:300px;left:47%;top:-50%;position:absolute;padding:5px;box-shadow:0 0 20px #0000004d;transform:translate(-50%);-webkit-transform:translateX(-50%);-webkit-box-shadow:0 0 20px rgba(0,0,0,.3);background:#7a7a7a;opacity:1}.modalBody1[_ngcontent-%COMP%]{margin:0;cursor:pointer;opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]{display:flex;height:115px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 10px 10px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:12px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .modalBody1[_ngcontent-%COMP%]:hover{opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]{width:100%;border-top:1px solid #b2a6a6;text-align:center;padding-top:5px}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]   .popup-footer-text[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:13px;color:#fff}.location-count[_ngcontent-%COMP%]{font-size:11px;color:#7a7a7a}.showDiv-on-Mousehover[_ngcontent-%COMP%]{z-index:1001;position:fixed;background-color:#000;margin-left:-75px;margin-top:-85px}.circularCheckbox[_ngcontent-%COMP%]{padding-right:20px;position:relative;float:right;display:block}.richMapRadio[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]{opacity:1!important}.richMapRadio[_ngcontent-%COMP%]{float:right!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpacesLocationHierarchyComponent, [{
        type: Component,
        args: [{
                selector: "lib-spaces-location-hierarchy",
                templateUrl: "./spaces-location-hierarchy.component.html",
                styleUrls: ["./spaces-location-hierarchy.component.scss"]
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: LocationService }, { type: i0.ChangeDetectorRef }]; }, { disableRootCheckbox: [{
            type: Input
        }], isRichMapAvailable: [{
            type: Input
        }], permittedLocationTypes: [{
            type: Input
        }], disableNode: [{
            type: Input
        }], searchLocation: [{
            type: Input
        }], filterLocations: [{
            type: Input
        }], excludedLocations: [{
            type: Input
        }] }); })();

function PinLocationsComponent_sup_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.pinnedLocations.length);
} }
function PinLocationsComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "behavior-metrics-lib.vertical-base.legendName.pinVisitsText"), "\n");
} }
function PinLocationsComponent_div_5_p_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "behavior-metrics-lib.spaces-header.selected-location-title"));
} }
function PinLocationsComponent_div_5_ul_21_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "i", 29);
    i0.ɵɵlistener("click", function PinLocationsComponent_div_5_ul_21_li_1_Template_i_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r10); const location_r8 = restoredCtx.$implicit; const ctx_r9 = i0.ɵɵnextContext(3); return ctx_r9.removeSelectedLocation(location_r8); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const location_r8 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", location_r8.data.name, " ");
} }
function PinLocationsComponent_div_5_ul_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtemplate(1, PinLocationsComponent_div_5_ul_21_li_1_Template, 4, 1, "li", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.pinnedLocations);
} }
function PinLocationsComponent_div_5_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "span", 31);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "p");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "behavior-metrics-lib.pin-locations.showNoLocations.subTitle"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 5, "behavior-metrics-lib.pin-locations.showNoLocations.subTitle1"), ".");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 7, "behavior-metrics-lib.pin-locations.showNoLocations.subTitle2"));
} }
function PinLocationsComponent_div_5_span_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", ctx_r6.pinnedLocations.length, " ", i0.ɵɵpipeBind1(2, 2, "behavior-metrics-lib.pin-locations.selected-title"), "");
} }
function PinLocationsComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "div", 8);
    i0.ɵɵelementStart(2, "div", 9);
    i0.ɵɵelementStart(3, "div", 10);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "span", 11);
    i0.ɵɵlistener("click", function PinLocationsComponent_div_5_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.closeLocationPopup(false); });
    i0.ɵɵtext(7, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 12);
    i0.ɵɵelementStart(9, "div", 13);
    i0.ɵɵelementStart(10, "div", 14);
    i0.ɵɵelementStart(11, "div", 15);
    i0.ɵɵelementStart(12, "div", 16);
    i0.ɵɵelementStart(13, "form", 17);
    i0.ɵɵelementStart(14, "div", 18);
    i0.ɵɵelement(15, "span", 19);
    i0.ɵɵelementStart(16, "input", 20);
    i0.ɵɵlistener("ngModelChange", function PinLocationsComponent_div_5_Template_input_ngModelChange_16_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.searchTxt = $event; })("keyup", function PinLocationsComponent_div_5_Template_input_keyup_16_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.onSearchKeyUp($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "lib-spaces-location-hierarchy", 21);
    i0.ɵɵlistener("selectedLocationEvt", function PinLocationsComponent_div_5_Template_lib_spaces_location_hierarchy_selectedLocationEvt_17_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.selectedLocation($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 22);
    i0.ɵɵtemplate(19, PinLocationsComponent_div_5_p_19_Template, 3, 3, "p", 3);
    i0.ɵɵelementStart(20, "div", 23);
    i0.ɵɵtemplate(21, PinLocationsComponent_div_5_ul_21_Template, 2, 1, "ul", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, PinLocationsComponent_div_5_div_22_Template, 11, 9, "div", 24);
    i0.ɵɵelementStart(23, "div", 25);
    i0.ɵɵelementStart(24, "button", 26);
    i0.ɵɵlistener("click", function PinLocationsComponent_div_5_Template_button_click_24_listener() { i0.ɵɵrestoreView(_r12); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.applyLocationssFilter(); });
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "button", 27);
    i0.ɵɵlistener("click", function PinLocationsComponent_div_5_Template_button_click_27_listener() { i0.ɵɵrestoreView(_r12); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.closeLocationPopup(false); });
    i0.ɵɵtext(28);
    i0.ɵɵpipe(29, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(30, PinLocationsComponent_div_5_span_30_Template, 3, 4, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 17, "behavior-metrics-lib.spaces-header.showPinLocations"), " ");
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("ngModel", ctx_r2.searchTxt);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disableRootCheckbox", true)("multiLocationSelect", true)("location", ctx_r2.locationList)("filterLocations", ctx_r2.filteredLocations)("showAccessCode", false)("setSelectedLocation", ctx_r2.selLocation)("isPopup", false)("searchLocation", ctx_r2.searchText)("excludedLocations", ctx_r2.excludedLocs);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.showNoLocations);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.pinnedLocations.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showNoLocations);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 19, "behavior-metrics-lib.spaces-header.primary-button-title"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(29, 21, "behavior-metrics-lib.spaces-header.common-button-title"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.pinnedLocations.length > 0);
} }
const _c0$k = function (a0) { return { "filled-bg": a0 }; };
class PinLocationsComponent {
    // eslint-disable-next-line no-unused-vars
    constructor(dataService) {
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.spacesObj = null;
        this.showNoLocations = true;
        this.show = false;
        this.isSampleData = false;
        this.disableLocations = false;
        this.locationKeys = [];
        this.pinnedLocationKeys = [];
        this.pinnedLocations = [];
        this.pinnedLocationIds = [];
        // backupPinnedLocations = "{}";
        this.checkedLocations = {};
        this.checkedLocationKeys = [];
        this.backupcheckedLocations = "{}";
        this.selectedNetwork = {};
        this.locationList = [];
        this.selLocation = [];
        this.searchText = null;
        this.backupSelectedLocation = [];
        this.backupPinnedLocations = [];
        this.backupPinnedLocationIds = [];
        this.showOnHover = false;
        this.excludedLocs = [];
        this.showEmitter = new EventEmitter();
        this.applyPinnedLocationsFilter = new EventEmitter();
        this.searchTxt = "";
        this.showLocations = (show) => {
            if (!this.disableLocations && !this.disableReportCategory) {
                this.show = !this.show;
                this.showEmitter.emit(this.show);
                if (this.show && this.pinnedLocations.length > 0)
                    this.showNoLocations = false;
                else
                    this.showNoLocations = true;
            }
        };
        this.closeLocationPopup = (show) => {
            this.show = show;
            this.showEmitter.emit(this.show);
            this.searchTxt = "";
            this.pinnedLocationIds = this.backupPinnedLocationIds;
            this.selLocation = this.backupSelectedLocation;
            this.pinnedLocations = this.backupPinnedLocations;
        };
        this.removeSelectedLocation = (node) => {
            // let existingNodeId: number[];
            const index = null;
            // existingNodeId = this.selLocation.filter((n, i) => {
            // 	if (n.data.id === node.data.id) {
            // 		index = i;
            // 		return i;
            // 	}
            // });
            if (index !== null) {
                this.selLocation.splice(index, 1);
                this.pinnedLocationIds.splice(index, 1);
                this.pinnedLocations.splice(index, 1);
                // node.setIsExpanded(true);
            }
            else {
                this.selLocation.push(node);
                // node.setIsExpanded(false);
            }
            if (this.show && this.pinnedLocations.length > 0)
                this.showNoLocations = false;
            else
                this.showNoLocations = true;
        };
        this.applyLocationssFilter = () => {
            // if (Object.keys(this.pinnedLocationIds).length > 0)
            this.spacesObj["pinnedLocations"] = this.pinnedLocationIds;
            this.dataService.setRightNowObject(this.spacesObj);
            // } else {
            //   delete this.spacesObj["pinnedLocations"];
            // }
            this.searchTxt = "";
            this.show = false;
            this.showEmitter.emit(this.show);
            this.applyPinnedLocationsFilter.emit();
            // this.searchPinLocationsValue(this.searchTxt);
        };
        this.selectedLocation = (event) => {
            // let locIds = [];
            this.pinnedLocations = [];
            this.pinnedLocationIds = [];
            this.selLocation = [];
            if (event && event.length > 0) {
                this.showNoLocations = false;
                event.forEach((loc) => {
                    let locName = loc.data.name;
                    if (locName.indexOf("span") != -1)
                        locName = locName
                            .replace('<span class="highlighted">', "")
                            .replace("</span>", "");
                    this.pinnedLocationIds.push(loc.data.id);
                    this.pinnedLocations.push({
                        data: {
                            id: loc.data.id,
                            name: locName,
                            type: loc.data.type
                        }
                    });
                    this.selLocation.push({
                        data: {
                            id: loc.data.id,
                            name: locName,
                            type: loc.data.type
                        }
                    });
                });
            }
            else {
                this.showNoLocations = true;
            }
        };
        this.onSearchKeyUp = ($event) => {
            //    console.log( this.searchText, $event.target.value, ( this.searchText == null && $event.target.value ), ( this.searchText !== $event.target.value ) );
            if ((this.searchText == null && $event.target["value"]) ||
                this.searchText !== $event.target["value"]) {
                this.searchText = $event.target["value"].toLowerCase();
            }
        };
        this.mouseOver = () => {
            if (!this.disableReportCategory) {
                this.showOnHover = true;
                $(".pin-hover-state").fadeIn(500);
            }
        };
        this.mouseOut = () => {
            if (!this.disableReportCategory) {
                this.showOnHover = false;
                $(".pin-hover-state").fadeOut(500);
            }
        };
    }
    ngOnInit() {
        this.dataService
            .getRightNowObject(this.unsubscribe$)
            .subscribe((spacesObj) => {
            if (spacesObj != null &&
                spacesObj["rightNowLocation"] != null) {
                this.selectedNetwork = spacesObj["rightNowLocation"];
                // this.selLocation = [this.selectedNetwork];
                if (spacesObj["rightNowLocation"].type != "all")
                    this.disableLocations = true;
                else {
                    this.disableLocations = false;
                    // let locObj = this.dataService.getLocationObject(locationId);
                    if (spacesObj["pinnedLocations"]) {
                        const spacesPinnedLocs = spacesObj["pinnedLocations"];
                        // console.log(":::spacesPinnedLocs:::", spacesPinnedLocs);
                        this.selLocation = [];
                        this.pinnedLocations = [];
                        this.pinnedLocationIds = [];
                        this.backupSelectedLocation = [];
                        this.backupPinnedLocations = [];
                        this.backupPinnedLocationIds = [];
                        if (spacesPinnedLocs.length > 0) {
                            spacesPinnedLocs.forEach((loc) => __awaiter(this, void 0, void 0, function* () {
                                const storedLocObj = yield this.dataService.getLocationObject(loc);
                                // console.log(":::locName:::", storedLocObj.name);
                                if (storedLocObj) {
                                    this.pinnedLocationIds.push(storedLocObj.id);
                                    this.pinnedLocations.push({
                                        data: {
                                            id: storedLocObj.id,
                                            name: storedLocObj.name,
                                            type: storedLocObj.type
                                        }
                                    });
                                    this.selLocation.push({
                                        data: {
                                            id: storedLocObj.id,
                                            name: storedLocObj.name,
                                            type: storedLocObj.type
                                        }
                                    });
                                    this.backupPinnedLocationIds.push(storedLocObj.id);
                                    this.backupPinnedLocations.push({
                                        data: {
                                            id: storedLocObj.id,
                                            name: storedLocObj.name,
                                            type: storedLocObj.type
                                        }
                                    });
                                    this.backupSelectedLocation.push({
                                        data: {
                                            id: storedLocObj.id,
                                            name: storedLocObj.name,
                                            type: storedLocObj.type
                                        }
                                    });
                                }
                            }));
                        }
                        this.showNoLocations = false;
                    }
                }
                this.spacesObj = spacesObj;
            }
        });
        this.dataService
            .getIsSampleData(this.unsubscribe$)
            .subscribe((isSampleData) => {
            if (isSampleData !== null) {
                setTimeout(() => {
                    this.isSampleData = isSampleData;
                });
            }
        });
        this.dataService
            .getBiExcludedLocObj(this.unsubscribe$)
            .subscribe((excludedLocs) => {
            if (excludedLocs && excludedLocs.length > 0) {
                this.excludedLocs = excludedLocs;
            }
            else {
                this.excludedLocs = [];
            }
            // console.log("pin locs exclude locs :: ",this.excludedLocs);
        });
    }
    set locationTreeArray(value) {
        if (value && value.location) {
            this.locationList = value.location;
        }
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
PinLocationsComponent.ɵfac = function PinLocationsComponent_Factory(t) { return new (t || PinLocationsComponent)(i0.ɵɵdirectiveInject(DataService)); };
PinLocationsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PinLocationsComponent, selectors: [["lib-pin-locations"]], inputs: { disableReportCategory: "disableReportCategory", locationTreeArray: "locationTreeArray", filteredLocations: "filteredLocations" }, outputs: { showEmitter: "showEmitter", applyPinnedLocationsFilter: "applyPinnedLocationsFilter" }, decls: 6, vars: 6, consts: [[1, "dropdownContainer"], [1, "pin-locations-button", 3, "ngClass", "mouseover", "mouseout", "click"], [1, "pin-icon"], [4, "ngIf"], ["class", "pin-hover-state rn-pin-hover", 4, "ngIf"], ["class", "modalPopup modalPopupLg pin-locations-popup", 4, "ngIf"], [1, "pin-hover-state", "rn-pin-hover"], [1, "modalPopup", "modalPopupLg", "pin-locations-popup"], [1, "modalOverlay"], [1, "modalContent"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], [1, "pin-location-section"], [1, "location-list"], [1, "padding-20"], [1, "searchBarDiv", "searchSlide"], ["autocomplete", "off", "novalidate", "", 1, "ng-untouched", "ng-pristine", "ng-valid"], [1, "pin-location-search-container"], ["id", "tag-search-icon"], ["name", "blahblah", "type", "text", "placeholder", "Search Locations", 1, "searchInput", 3, "ngModel", "ngModelChange", "keyup"], [1, "reportLocPopup", 3, "disableRootCheckbox", "multiLocationSelect", "location", "filterLocations", "showAccessCode", "setSelectedLocation", "isPopup", "searchLocation", "excludedLocations", "selectedLocationEvt"], [1, "selected-location-list"], [1, "selected-locations"], ["class", "no-tags", 4, "ngIf"], [1, "modalFooter"], [1, "primaryButton", 3, "click"], [1, "commonButton", 3, "click"], [4, "ngFor", "ngForOf"], [1, "close-tag", "pointer", 3, "click"], [1, "no-tags"], ["id", "no-tag-image"]], template: function PinLocationsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵlistener("mouseover", function PinLocationsComponent_Template_div_mouseover_1_listener() { return ctx.mouseOver(); })("mouseout", function PinLocationsComponent_Template_div_mouseout_1_listener() { return ctx.mouseOut(); })("click", function PinLocationsComponent_Template_div_click_1_listener() { return ctx.showLocations(true); });
        i0.ɵɵelement(2, "i", 2);
        i0.ɵɵtemplate(3, PinLocationsComponent_sup_3_Template, 2, 1, "sup", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, PinLocationsComponent_div_4_Template, 3, 3, "div", 4);
        i0.ɵɵtemplate(5, PinLocationsComponent_div_5_Template, 31, 23, "div", 5);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$k, ctx.pinnedLocations.length > 0));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.pinnedLocations.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showOnHover);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.show);
    } }, directives: [i1$2.NgClass, i1$2.NgIf, i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i2$1.NgForm, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, SpacesLocationHierarchyComponent, i1$2.NgForOf], pipes: [i2.TranslatePipe], styles: ["@charset \"UTF-8\";.dropdownContainer[_ngcontent-%COMP%]{display:block;width:100%;position:relative}.pin-locations-button[_ngcontent-%COMP%]{cursor:pointer;border:1px solid #d7d9da;border-radius:4px;height:36px;width:46px;text-align:center}.pin-locations-button.filled-bg[_ngcontent-%COMP%]{background-color:#abc233;border-color:#abc233;padding:2px 5px}.pin-locations-button.filled-bg[_ngcontent-%COMP%]   i.pin-icon[_ngcontent-%COMP%]{background-repeat:no-repeat!important;background-position:center!important;background:url(../../../../../assets/images/business/pin_selected.svg)}i.pin-icon[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/pin_unselected.svg);width:15px;height:100%;display:inline-block;vertical-align:middle;background-position:center;margin:auto;background-repeat:no-repeat}.selectedTags[_ngcontent-%COMP%]{border:1px solid transparent;border-bottom:1px solid rgba(0,0,0,.1);background-color:#fff;border-radius:0;color:#7f7f86;padding:4px 20px 10px 10px;font-size:14px;font-family:\"ciscoSansRegular\";position:relative;cursor:pointer;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.selectedTags[_ngcontent-%COMP%]:before{position:absolute;right:10px;top:6px;font-family:\"icomoon-new\";content:\"\\e905\";font-size:14px;color:#bbb}.selectedTags.greenBg[_ngcontent-%COMP%]{background-color:#03b88c}.pin-location-section[_ngcontent-%COMP%]{height:400px}.pin-locations-popup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{text-align:center;color:#565659;font-family:CiscoSans;font-size:24px;height:auto}.pin-locations-popup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{padding:0!important;margin:0!important}.selected-location-list[_ngcontent-%COMP%]{width:50%;float:right;position:relative;height:100%}.location-list[_ngcontent-%COMP%]{height:100%;border-right:1px solid #e9e9e9;overflow-y:auto;text-transform:capitalize;width:50%;display:inline-block}.pin-locations-popup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{border-radius:2px;box-shadow:0 1px 3px #b1b1b140;width:70%!important}.pin-location-search-container[_ngcontent-%COMP%]{position:relative;margin:15px auto auto;width:80%}.pin-location-search-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{margin-bottom:0;text-indent:30px;border-bottom:1px solid #EAEAEA!important}#tag-search-icon[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/search_dropdown.svg);width:24px;height:24px;display:inline-block;background-repeat:no-repeat;background-position:center;vertical-align:middle;position:absolute;bottom:0;top:0;margin:auto}.location-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{color:#9d9d9d;font-family:CiscoSans;font-size:10px}.tag-list[_ngcontent-%COMP%]{padding:12px 0;position:relative}.location-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:20px 0;width:80%;margin:auto}.tag-list[_ngcontent-%COMP%]:hover{background-color:#f5f5f5;cursor:pointer}.tag-list[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;color:#58585b;font-size:14px}.tag-list[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{vertical-align:middle;float:right;margin-right:30px;opacity:0}label.tag-label[_ngcontent-%COMP%]{position:absolute;right:30px}label.tag-label[_ngcontent-%COMP%]:before{content:\"\";width:20px;height:20px;vertical-align:middle;float:right;margin-right:0}.tag-list[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:checked ~ label.tag-label[_ngcontent-%COMP%]:before{background:url(../../../../../assets/images/business/tick-mark.svg)}.tag-key[_ngcontent-%COMP%]{padding-bottom:10px}.pin-locations-popup[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{color:#049fd9;border:0 none;font-family:CiscoSans!important;font-size:14px}#no-tag-image[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/no-tag-selected.svg);width:120px;height:120px;display:block;margin:auto auto 30px}.selected-locations[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0 20px}.selected-locations[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-radius:3px;background-color:#f6f6f6;padding:5px 8px;margin-right:10px;margin-bottom:10px;display:inline-block;font-size:14px}.selected-locations[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px;font-family:CiscoSansLight;color:#626469}.no-tags[_ngcontent-%COMP%]{text-align:center;padding-top:20px}.no-tags[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:24px;line-height:1.25;letter-spacing:.5px;color:#58585b}.no-tags[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#565659;font-family:CiscoSans;line-height:1.43;letter-spacing:.5px}.close-tag[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/popup_close.svg);width:9px;height:9px;display:inline-block;background-repeat:no-repeat;background-position:center;margin-left:20px}.selected-location-list[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:12px;color:#626469;margin:0;padding:35px 20px 0}.pin-locations-popup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{border-top:1px solid #EAEAEA;text-align:center;height:auto;bottom:0}.selTagsInDD[_ngcontent-%COMP%]{background-color:#f6f6f6;display:inline-block;margin-right:10px}.moreTags[_ngcontent-%COMP%]{color:#869ad6;background-color:#f6f6f6;display:inline-block}.tags-on-hover[_ngcontent-%COMP%]{background-color:#fff;padding:10px;border:1px solid #d7d9da;position:absolute;width:90%;left:0;right:0;margin:8px auto auto}.tags-on-hover[_ngcontent-%COMP%]:before{background:url(../../../../../assets/images/business/tooltip_arrow_up.svg);content:\"\";position:absolute;top:-12px;right:25px;width:20px;height:12px;background-position:center}.tags-on-hover[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px;font-family:CiscoSans;color:#58585b;letter-spacing:.58px;line-height:20px;display:inline-block;margin-right:5px}.selected-tag-title[_ngcontent-%COMP%]{display:block!important}.disableFilterByTags[_ngcontent-%COMP%]{opacity:.3}.defaultCursor[_ngcontent-%COMP%]{cursor:default!important}.pin-locations-button[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;position:absolute;margin-left:2px}.pin-locations-popup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px;color:#000;font-family:CiscoSansLight;float:right}lib-spaces-location-hierarchy.reportLocPopup[_ngcontent-%COMP%]{width:80%;margin:auto;display:block}.pin-hover-state[_ngcontent-%COMP%]{background-color:#565659;padding:10px;position:absolute;width:70%;left:0;right:-40%;margin:8px auto auto;font-family:CiscoSans;font-size:14px;text-align:center;color:#fff;border-radius:3px;letter-spacing:.5px}.rn-pin-hover[_ngcontent-%COMP%]{width:100%;left:40%;right:0px}.pin-hover-state[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:-9px;right:45%;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-bottom:9px solid #565659}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PinLocationsComponent, [{
        type: Component,
        args: [{
                selector: "lib-pin-locations",
                templateUrl: "./pin-locations.component.html",
                styleUrls: ["./pin-locations.component.scss"]
            }]
    }], function () { return [{ type: DataService }]; }, { disableReportCategory: [{
            type: Input
        }], showEmitter: [{
            type: Output
        }], applyPinnedLocationsFilter: [{
            type: Output
        }], locationTreeArray: [{
            type: Input
        }], filteredLocations: [{
            type: Input
        }] }); })();

class PortalService extends BaseService {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.getDefaultConfigUrl = "/assets/data/portal-default-config.json?";
        this.getSMSGatewayListUrl = "/assets/data/smsgateway-list.json?";
        this.getAuthTypeListUrl = "/assets/data/auth-types.json?";
        this.getCountryListUrl = "/assets/data/countries.json?";
        this.getPortalListData = () => {
            return this.get(this.apiConfig.getPortalListUrl()).pipe(map(this.extractResponseData));
        };
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getDefaultConfig = () => {
            return this.get(this.getDefaultConfigUrl).pipe(map(this.extractResponseData));
        };
        this.getCountryList = () => {
            return this.get(this.getCountryListUrl).pipe(map(this.extractResponse));
        };
        this.getAuthTypeMapping = () => {
            return this.get(this.getAuthTypeListUrl).pipe(map(this.extractResponse));
        };
        this.getPortal = (portalUniqueId) => {
            const url = this.apiConfig.getPortalUrl() + "/" + portalUniqueId;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getConfig = (portalUniqueId) => {
            const url = this.apiConfig.getPortalConfigUrl() + "/" + portalUniqueId;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getSMSGatewayList = () => {
            return this.get(this.getSMSGatewayListUrl).pipe(map(this.extractResponseData));
        };
        this.createPortal = (createPortalObj) => {
            return this.post(this.apiConfig.getCreatePortalUrl(), createPortalObj).pipe(map(this.extractResponseData));
        };
        this.createSamplePortal = (destPortalConfig, sourcePortalConfig) => {
            const payload = {
                destPortal: destPortalConfig,
                sourcePortal: sourcePortalConfig
            };
            return this.post(this.apiConfig.getCreateSamplePortalUrl(), payload).pipe(map(this.extractResponseData));
        };
        this.checkPortalAvailable = (portalObj) => {
            return this.post(this.apiConfig.getCheckPortalAvailableUrl(), portalObj).pipe(map(this.extractResponse));
        };
        this.updatePortal = (updatePortalObj, portalUniqueId) => {
            const url = this.apiConfig.getUpdatePortalUrl() + "/" + portalUniqueId;
            return this.post(url, updatePortalObj).pipe(map(this.extractResponseData));
        };
        this.publishPortal = (publishPortalObj, portalUniqueId) => {
            const url = this.apiConfig.getPublishPortalUrl() + "/" + portalUniqueId;
            return this.post(url, publishPortalObj).pipe(map(this.extractResponseData));
        };
        this.updatePortalLanguages = (updatePortalLangObj, portalUniqueId) => {
            const url = this.apiConfig.getUpdatePortalLanguagesUrl() + "/" + portalUniqueId;
            return this.post(url, updatePortalLangObj).pipe(map(this.extractResponseData));
        };
        this.addLocation = (locationObj, portalUniqueId) => {
            const url = this.apiConfig.getAddLocationUrl() + "/" + portalUniqueId;
            return this.post(url, locationObj).pipe(map(this.extractResponseData));
        };
        this.addLocations = (updateLocations) => {
            return this.post(this.apiConfig.getAddLocationsUrl(), updateLocations).pipe(map(this.extractResponseData));
        };
        this.renamePortal = (portalName, portalUniqueId) => {
            const url = this.apiConfig.getRenamePortalUrl() + "/" + portalUniqueId;
            return this.post(url, { portalName: portalName }).pipe(map(this.extractResponse));
        };
        this.deletePortals = (deletePortalsObj) => {
            return this.post(this.apiConfig.getDeletePortalUrl(), deletePortalsObj).pipe(map(this.extractResponse));
        };
        this.importPortal = (portalName, selectedLocations, files) => {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append("upload", files[i]); // , files[i].name;//
            }
            formData.append("portalName", portalName);
            formData.append("selectedLocations", selectedLocations);
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            this.logger.debug("getting portal: headers", this.apiConfig.getImportPortalUrl());
            return this.post(this.apiConfig.getImportPortalUrl(), formData, options).pipe(map(this.extractResponse));
        };
        this.exportPortal = (portalUniqueId) => {
            return (this.apiConfig.getExportPortalUrl() +
                "/" +
                portalUniqueId +
                "?connectId=" +
                btoa(this.dataService.getAccessToken()));
        };
        this.getAssetList = (path, portalId) => {
            const urlObject = { assetsPath: path };
            urlObject["portalId"] = portalId;
            const url = this.apiConfig.getAssetListUrl();
            return this.post(url, urlObject).pipe(map(this.extractResponseData));
        };
        this.getCssFile = (path, defaultPath, portalId) => {
            const urlObject = { cssPath: path };
            urlObject["defaultPath"] = defaultPath;
            urlObject["portalId"] = portalId;
            const url = this.apiConfig.getCssFileUrl();
            return this.post(url, urlObject).pipe(map(this.extractResponseData));
        };
        this.uploadCssFile = (cssPath, files, portalId) => {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append("upload", files[i]); // , files[i].name;//
            }
            formData.append("cssPath", cssPath);
            formData.append("portalId", portalId);
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            return this.post(this.apiConfig.getUploadCssFileUrl(), formData, options).pipe(map(this.extractResponse));
        };
        this.sendEmail = (email, portalId) => {
            const urlObject = {};
            urlObject["toEmail"] = email;
            urlObject["portalId"] = portalId;
            const url = this.apiConfig.getSendPreviewUrl();
            return this.post(url, urlObject).pipe(map(this.extractResponseData));
        };
        // Portal Upload File option
        this.uploadFileByDND = (filePath, files, portalId) => {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append("upload", files[i].nativeFile); // , files[i].name;//
            }
            formData.append("filePath", filePath);
            formData.append("portalId", portalId);
            console.log("formData from portal service :: ", formData);
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            this.logger.debug("upload file: headers", this.apiConfig.getUploadFileByDNDUrl());
            return this.post(this.apiConfig.getUploadFileByDNDUrl(), formData, options).pipe(map(this.extractResponse));
        };
        // Portal Upload File option
        this.uploadFile = (filePath, files, portalId, section) => {
            //console.log("filePath :: from portal service :: ", filePath);
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append("upload", files[i]); // , files[i].name;//
            }
            formData.append("filePath", filePath);
            formData.append("portalId", portalId);
            formData.append("section", section);
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            this.logger.debug("upload file: headers", this.apiConfig.getUploadFileUrl());
            return this.post(this.apiConfig.getUploadFileUrl(), formData, options).pipe(map(this.extractResponse));
        };
        this.extractAndUploadAssetsZipByDND = (filePath, files, portalId) => {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append("upload", files[i].nativeFile); // , files[i].name;//
            }
            formData.append("filePath", filePath);
            formData.append("portalId", portalId);
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            this.logger.debug("upload file: headers", this.apiConfig.getExtractAndUploadAssetsZipFileByDNDUrl());
            return this.post(this.apiConfig.getExtractAndUploadAssetsZipFileByDNDUrl(), formData, options).pipe(map(this.extractResponse), catchError(this.handleErrorObservable));
        };
        this.extractAndUploadAssetsZip = (filePath, files, portalId) => {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append("upload", files[i]); // , files[i].name;//
            }
            formData.append("filePath", filePath);
            formData.append("portalId", portalId);
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            this.logger.debug("upload file: headers", this.apiConfig.getExtractAndUploadAssetsZipFileUrl());
            return this.post(this.apiConfig.getExtractAndUploadAssetsZipFileUrl(), formData, options).pipe(map(this.extractResponse));
        };
        this.extractAndUploadZip = (filePath, files, portalId) => {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append("upload", files[i]); // , files[i].name;//
            }
            formData.append("filePath", filePath);
            formData.append("portalId", portalId);
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            this.logger.debug("upload file: headers", this.apiConfig.getExtractAndUploadZipFileUrl());
            return this.post(this.apiConfig.getExtractAndUploadZipFileUrl(), formData, options).pipe(map(this.extractResponse));
        };
        this.copyAssets = (currentAssetPath, relativePath, portalId) => {
            const copyObject = {};
            copyObject["currentAssetPath"] = currentAssetPath;
            copyObject["relativePath"] = relativePath;
            copyObject["portalId"] = portalId;
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            return this.post(this.apiConfig.getCopyAssetsUrl(), copyObject, options).pipe(map(this.extractResponse));
        };
        this.copyCss = (currentAssetPath, relativePath, portalId) => {
            const copyObject = {};
            copyObject["currentAssetPath"] = currentAssetPath;
            copyObject["relativePath"] = relativePath;
            copyObject["portalId"] = portalId;
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            return this.post(this.apiConfig.getCopyCssUrl(), copyObject, options).pipe(map(this.extractResponse));
        };
        this.uploadFileForModules = (filePath, files, portalId, moduleName) => {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append("upload", files[i]); // , files[i].name;//
            }
            formData.append("filePath", filePath);
            formData.append("portalId", portalId);
            formData.append("moduleName", moduleName);
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            return this.post(this.apiConfig.getUploadFileForModulesUrl(), formData, options).pipe(map(this.extractResponse));
        };
        this.saveCssFile = (cssPath, content, portalId) => {
            const cssObject = { cssPath: cssPath };
            cssObject["content"] = content;
            cssObject["portalId"] = portalId;
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            return this.post(this.apiConfig.getSaveCssFileUrl(), cssObject, options).pipe(map(this.extractResponse));
        };
        this.deleteAsset = (filePath, portalId) => {
            const urlObject = {};
            urlObject["filePath"] = filePath;
            urlObject["portalId"] = portalId;
            const url = this.apiConfig.getDeleteAssetUrl();
            return this.post(url, urlObject).pipe(map(this.extractResponseData));
        };
        this.replaceAsset = (filePath, files, fileName, portalId) => {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append("upload", files[i]); // , files[i].name;//
            }
            formData.append("filePath", filePath);
            formData.append("fileName", fileName);
            formData.append("portalId", portalId);
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            this.logger.debug("upload file: headers", this.apiConfig.getReplaceAssetUrl());
            return this.post(this.apiConfig.getReplaceAssetUrl(), formData, options).pipe(map(this.extractResponse));
        };
        this.updateLanguageRecord = (data, id) => {
            const body = data;
            const serverUrl = this.apiConfig.updateLanguageAssetUrl() + "/" + id;
            return this.post(serverUrl, body).pipe(map(this.extractCompleteResponse));
        };
        this.getPortalLocaleValues = (currentEditLang, portalUniqueId) => {
            const langObject = { langCode: currentEditLang };
            const url = this.apiConfig.getPortalLocaleValuesUrl() + "/" + portalUniqueId;
            //console.log("url ::" + url);
            return this.post(url, langObject).pipe(map(this.extractResponse));
        };
        this.getAppDetails = (currentEditLang, platform, appUrl) => {
            const appDetail = { lang: currentEditLang };
            appDetail["url"] = appUrl;
            appDetail["platform"] = platform;
            const url = this.apiConfig.getAppDetailsUrl();
            return this.post(url, appDetail).pipe(map(this.extractResponse));
        };
        this.downloadLanguageRecord = (id) => {
            return (this.apiConfig.downloadLanguageAssetUrl() +
                "/" +
                id +
                "?connectId=" +
                btoa(this.dataService.getAccessToken()));
        };
        this.extractCompleteResponse = (res) => {
            return res;
        };
        // Captive Portal API Calls starts
        this.getRulesList = (locationId, ruleType) => {
            const bodyPayload = {
                locationId: locationId.toString(),
                ruleType: ruleType
            };
            const serverUrl = this.apiConfig.getCPRuleslistUrl();
            return this.post(serverUrl, bodyPayload).pipe(map(this.extractResponseData));
        };
        this.getRuleDetails = (ruleId) => {
            const serverUrl = this.apiConfig.getCPRuleDetailsUrl() + "/" + ruleId;
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.pauseRule = (ruleObj) => {
            const serverUrl = this.apiConfig.getCPPauseRuleUrl();
            return this.post(serverUrl, ruleObj).pipe(map(this.extractCompleteResponse));
        };
        this.setRuleLive = (ruleObj) => {
            const serverUrl = this.apiConfig.getCPMakeRuleLiveUrl();
            return this.post(serverUrl, ruleObj).pipe(map(this.extractCompleteResponse));
        };
        this.deleteRule = (ruleObj) => {
            const serverUrl = this.apiConfig.getCPDeleteRuleUrl();
            const options = {
                body: ruleObj
            };
            return this.delete(serverUrl, options).pipe(map(this.extractCompleteResponse));
        };
        this.getMetadataList = () => {
            const url = this.apiConfig.getCPMetadataListUrl();
            return this.get(url).pipe(map(this.extractCompleteResponse));
        };
        this.getTagList = (tagType) => {
            const serverUrl = this.apiConfig.getCPTagListUrl() + (tagType ? "/" + tagType : "");
            return this.get(serverUrl).pipe(map(this.extractCompleteResponse));
        };
        this.saveRule = (saveConfig) => {
            const body = saveConfig;
            const serverUrl = this.apiConfig.getCPSaveRuleUrl();
            return this.post(serverUrl, body).pipe(map(this.extractCompleteResponse));
        };
        this.getSSIDList = () => {
            const url = this.apiConfig.getCPSSIDListUrl();
            return this.get(url).pipe(map(this.extractCompleteResponse));
        };
        this.getPortalList = () => {
            const url = this.apiConfig.getCPRulePortalListUrl();
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getCPSMSGatewayList = () => {
            const url = this.apiConfig.getCPRuleSmsGatewayListUrl();
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getNotificationChannelList = () => {
            const url = this.apiConfig.getCPNotificationListUrl();
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getBusinessTagsList = () => {
            const url = this.apiConfig.getCPBusinessTagsListUrl();
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getAppCurrentStatus = () => {
            const url = this.apiConfig.getAppCurrentStatusUrl();
            return this.get(url).pipe(map(this.extractResponse));
        };
    }
}
PortalService.ɵfac = function PortalService_Factory(t) { return new (t || PortalService)(i0.ɵɵinject(i0.Injector)); };
PortalService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PortalService, factory: PortalService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PortalService, [{
        type: Injectable
    }], function () { return [{ type: i0.Injector }]; }, null); })();

class QrCodeComponent {
    constructor(dataService, portalService, router, activatedRoute) {
        this.dataService = dataService;
        this.portalService = portalService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.unsubscribe$ = new Subject();
        this.elementType = 'url';
        this.errorCorrectionLevel = 'L';
        this.tooltips = {
            preview: new Tooltip()
                .setId("tip-034")
                .setPosition(POSITION.BOTTOM_LEFT)
        };
        this.response = new EventEmitter();
        this.sendEmail = () => {
            const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
            if (!this.emailAddress || !EMAIL_REGEXP.test(this.emailAddress)) {
                this.dataService.setToastMessage("Please enter valid email address", 4000, null, null, "error");
                return false;
            }
            else {
                this.portalService
                    .sendEmail(this.emailAddress, this.portalUniqueId)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((data) => {
                    // console.log("updatePortal service call :: success" + JSON.stringify(data));
                    // console.log("sendEmail   :: ", data);
                    if (data) {
                        if (data.error_code && data.err_desc) {
                            this.dataService.setToastMessage("Failed to send the preview url", 4000, null, null, "error");
                        }
                        else {
                            this.dataService.setToastMessage("Successfully sent the preview url", 4000, null, null, "success");
                        }
                    }
                    this.dataService.display(false);
                    this.response.emit(false);
                }, (error) => {
                    console.log("css read error", error.status);
                    this.dataService.display(false);
                    this.dataService.setToastMessage("Failed to send the preview url", 4000, null, null, "error");
                    this.response.emit(false);
                });
                return;
            }
        };
    }
    ngOnInit() {
        console.log("QR code :: preview url :: ", this.portalPreviewUrl);
    }
    ngOnDestroy() {
        console.log("destory QR Code page");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
QrCodeComponent.ɵfac = function QrCodeComponent_Factory(t) { return new (t || QrCodeComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(PortalService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i1.ActivatedRoute)); };
QrCodeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QrCodeComponent, selectors: [["lib-app-qr-code"]], inputs: { portalPreviewUrl: "portalPreviewUrl", portalUniqueId: "portalUniqueId" }, outputs: { response: "response" }, decls: 10, vars: 5, consts: [["cssClass", "aclass", 3, "elementType", "value", "errorCorrectionLevel"], ["pmx-tooltip", "", 3, "tooltip"], [1, "form-container"], ["type", "text", "placeholder", "Email Address", "maxlength", "50", 1, "qr-code-text", 3, "ngModel", "ngModelChange"], [1, "customizedPrimaryButton", 3, "click"]], template: function QrCodeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵelementStart(1, "p");
        i0.ɵɵtext(2, "Scan with QR code reader on your mobile device");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "ngx-qrcode", 0);
        i0.ɵɵelementStart(4, "p", 1);
        i0.ɵɵtext(5, "Email Portal URL");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 2);
        i0.ɵɵelementStart(7, "input", 3);
        i0.ɵɵlistener("ngModelChange", function QrCodeComponent_Template_input_ngModelChange_7_listener($event) { return ctx.emailAddress = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "button", 4);
        i0.ɵɵlistener("click", function QrCodeComponent_Template_button_click_8_listener() { return ctx.sendEmail(); });
        i0.ɵɵtext(9, " Send ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("elementType", ctx.elementType)("value", ctx.portalPreviewUrl)("errorCorrectionLevel", ctx.errorCorrectionLevel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("tooltip", ctx.tooltips["preview"]);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngModel", ctx.emailAddress);
    } }, directives: [i4$4.QrcodeComponent, TooltipDirective, i2$1.DefaultValueAccessor, i2$1.MaxLengthValidator, i2$1.NgControlStatus, i2$1.NgModel], styles: [".customizedPrimaryButton[_ngcontent-%COMP%]{background-color:#049fd9;color:#fff;font-family:ciscoSansRegular;border:0;border-radius:50px;padding:10px;width:41%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QrCodeComponent, [{
        type: Component,
        args: [{
                selector: "lib-app-qr-code",
                templateUrl: "./qr-code.component.html",
                styleUrls: ["./qr-code.component.css"]
            }]
    }], function () { return [{ type: DataService }, { type: PortalService }, { type: i1.Router }, { type: i1.ActivatedRoute }]; }, { portalPreviewUrl: [{
            type: Input
        }], portalUniqueId: [{
            type: Input
        }], response: [{
            type: Output
        }] }); })();

function QuillRteComponent_span_28_option_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", opt_r2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r1.dropDownPrefix, "", opt_r2, " ");
} }
function QuillRteComponent_span_28_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵelementStart(1, "select", 25);
    i0.ɵɵlistener("change", function QuillRteComponent_span_28_Template_select_change_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.dropdownSelected(); })("ngModelChange", function QuillRteComponent_span_28_Template_select_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.selectedOption = $event; });
    i0.ɵɵtemplate(2, QuillRteComponent_span_28_option_2_Template, 2, 3, "option", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r0.selectedOption)("title", "values");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.dropdownOptions);
} }
const _c0$j = function () { return { "min-height": "250px", "max-height": "300px", "overflow": "auto" }; };
let Block = Quill.import('blots/block');
Block.tagName = 'P';
Quill.register(Block, true);
const BlockEmbed = Quill.import('blots/embed');
//Custom blot for smartlink dropdown
class Variable extends BlockEmbed {
    static create(value) {
        if (typeof value === 'string') {
            const node = super.create(typeof value === 'string' ? value : value);
            node.innerText = typeof value === 'string' ? value : value;
            node.setAttribute('contenteditable', false);
            return node;
        }
        return null;
    }
    static value(node) {
        return {
            style: node.getAttribute('contenteditable'),
            text: node.innerText
        };
    }
}
Variable['blotName'] = 'custom_tag';
Variable['className'] = 'quill_tag';
Variable['tagName'] = 'span';
Quill.register('formats/marker', Variable);
class QuillRteComponent {
    constructor() {
        this.smartVariableSupport = false;
        this.dropDownPrefix = '';
        this.editorChanged = new EventEmitter();
        this.emitEditorContent = new EventEmitter();
        this.urlFoundEmitter = new EventEmitter();
        this.dropdownOptions = [];
        this.dropDownVisible = false;
        this.selectedOption = '';
        this.urlFound = false;
        this.formatContent = () => {
            let indexItrerator = 0;
            var matches = this.mainData.match(/[^{\}]+(?=})/g);
            var self = this;
            setTimeout(() => {
                if (matches) {
                    matches.forEach((item) => {
                        const matchedItem = '${' + item + '}';
                        const len = matchedItem.length;
                        const formattedItem = '$' + item;
                        if (self.editor) {
                            const content = self.editor.getText();
                            const svIndex = content.indexOf(matchedItem) + indexItrerator;
                            self.editor.deleteText(svIndex, len, 'silent');
                            self.editor.insertEmbed(svIndex, 'custom_tag', formattedItem, 'silent');
                            indexItrerator++;
                        }
                    });
                }
            }, 500);
        };
        this.editorChangeDetected = ($event) => {
            if (this.smartVariableSupport) {
                const domContent = this.editor.root.innerHTML;
                const value = domContent.toLowerCase();
                const check = value.indexOf("$url") > -1 ? true : false;
                if (this.urlFound && !check) {
                    this.urlFound = false;
                    this.urlFoundEmitter.emit(false);
                }
                else if (!this.urlFound && check) {
                    this.urlFound = true;
                    this.urlFoundEmitter.emit(true);
                }
            }
            // this.editorChanged.emit(domContent);
        };
        this.emitContent = () => {
            let domContent = this.editor.root.innerHTML.replace(/[\u200B-\u200D\uFEFF]/g, '');
            if (this.smartVariableSupport) {
                var matches = domContent.match(/\$\w+/g);
                if (matches) {
                    matches.forEach((sVariable) => {
                        const spanFormat = '<span class="quill_tag" contenteditable="false"><span contenteditable="false">' + sVariable + '</span></span>';
                        console.log(spanFormat);
                        const newSVariable = '${' + sVariable.slice(1) + '}';
                        domContent = domContent.replace(spanFormat, newSVariable);
                    });
                }
            }
            domContent = domContent.substring(3, domContent.length - 4);
            this.emitEditorContent.emit(domContent);
        };
        this.dropdownSelected = () => {
            const range = this.editor.getSelection(true);
            const value = '$' + this.selectedOption;
            this.editor.insertEmbed(range.index, 'custom_tag', value, 'silent');
            const selectIndex = this.editor.getSelection();
            this.editor.setSelection(selectIndex.index + 1, 'silent');
            // if(this.selectedOption == 'URL') {
            //   this.urlFoundEmitter.emit(true);
            // }
        };
    }
    set editorData(value) {
        this.mainData = value;
        setTimeout(() => {
            if (this.smartVariableSupport) {
                this.formatContent();
            }
        }, 500);
    }
    set customMenuData(value) {
        if (value) {
            this.dropdownOptions = value;
            this.dropDownVisible = true;
        }
    }
    ngOnInit() {
    }
    onEditorCreated($event) {
        this.editor = $event;
    }
}
QuillRteComponent.ɵfac = function QuillRteComponent_Factory(t) { return new (t || QuillRteComponent)(); };
QuillRteComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QuillRteComponent, selectors: [["lib-quill-rte"]], inputs: { editorData: "editorData", smartVariableSupport: "smartVariableSupport", dropDownPrefix: "dropDownPrefix", customMenuData: "customMenuData" }, outputs: { editorChanged: "editorChanged", emitEditorContent: "emitEditorContent", urlFoundEmitter: "urlFoundEmitter" }, decls: 29, vars: 8, consts: [[3, "styles", "ngModel", "sanitize", "ngModelChange", "onEditorChanged", "onEditorCreated"], ["quill-editor-toolbar", ""], [1, "ql-formats"], [1, "ql-bold"], [1, "ql-italic"], [1, "ql-underline"], [1, "ql-strike"], [1, "ql-blockquote"], [1, "ql-code"], [1, "ql-align", 3, "title"], ["selected", ""], ["value", "center"], ["value", "right"], ["value", "justify"], [1, "ql-color", 3, "title"], [1, "ql-background", 3, "title"], [1, "ql-font"], ["value", "serif"], ["value", "monospace"], [1, "ql-size"], ["value", "small"], ["value", "large"], ["value", "huge"], ["class", "ql-formats custom-dd-ql", 4, "ngIf"], [1, "ql-formats", "custom-dd-ql"], [1, "ql-customDropDown", 3, "ngModel", "title", "change", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function QuillRteComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "quill-editor", 0);
        i0.ɵɵlistener("ngModelChange", function QuillRteComponent_Template_quill_editor_ngModelChange_0_listener($event) { return ctx.mainData = $event; })("onEditorChanged", function QuillRteComponent_Template_quill_editor_onEditorChanged_0_listener($event) { return ctx.editorChangeDetected($event); })("onEditorCreated", function QuillRteComponent_Template_quill_editor_onEditorCreated_0_listener($event) { return ctx.onEditorCreated($event); });
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵelement(3, "button", 3);
        i0.ɵɵelement(4, "button", 4);
        i0.ɵɵelement(5, "button", 5);
        i0.ɵɵelement(6, "button", 6);
        i0.ɵɵelement(7, "button", 7);
        i0.ɵɵelement(8, "button", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "span", 2);
        i0.ɵɵelementStart(10, "select", 9);
        i0.ɵɵelement(11, "option", 10);
        i0.ɵɵelement(12, "option", 11);
        i0.ɵɵelement(13, "option", 12);
        i0.ɵɵelement(14, "option", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(15, "select", 14);
        i0.ɵɵelement(16, "select", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "span", 2);
        i0.ɵɵelementStart(18, "select", 16);
        i0.ɵɵelement(19, "option", 10);
        i0.ɵɵelement(20, "option", 17);
        i0.ɵɵelement(21, "option", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "span", 2);
        i0.ɵɵelementStart(23, "select", 19);
        i0.ɵɵelement(24, "option", 20);
        i0.ɵɵelement(25, "option", 10);
        i0.ɵɵelement(26, "option", 21);
        i0.ɵɵelement(27, "option", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(28, QuillRteComponent_span_28_Template, 3, 3, "span", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("styles", i0.ɵɵpureFunction0(7, _c0$j))("ngModel", ctx.mainData)("sanitize", true);
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("title", "Text Aligment");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("title", "Color");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("title", "Background Color");
        i0.ɵɵadvance(12);
        i0.ɵɵproperty("ngIf", ctx.dropDownVisible);
    } }, directives: [i1$5.QuillEditorComponent, i2$1.NgControlStatus, i2$1.NgModel, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i1$2.NgIf, i2$1.SelectControlValueAccessor, i1$2.NgForOf], styles: [".custom-dd-ql[_ngcontent-%COMP%] > .ql-picker[_ngcontent-%COMP%]{width:150px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuillRteComponent, [{
        type: Component,
        args: [{
                selector: 'lib-quill-rte',
                templateUrl: './quill-rte.component.html',
                styleUrls: ['./quill-rte.component.scss']
            }]
    }], function () { return []; }, { editorData: [{
            type: Input
        }], smartVariableSupport: [{
            type: Input
        }], dropDownPrefix: [{
            type: Input
        }], customMenuData: [{
            type: Input
        }], editorChanged: [{
            type: Output
        }], emitEditorContent: [{
            type: Output
        }], urlFoundEmitter: [{
            type: Output
        }] }); })();

class RangeBarChartOptions {
    constructor() {
        this.outerPadding = 0;
        this.margin = { top: 20, right: 30, bottom: 20, left: 30 };
    }
}

/* eslint-disable prefer-const */
const _c0$i = ["chart"];
class RangeBarChartComponent {
    constructor() {
        this.sourceData = [];
        this.timeFormat = d3.timeFormat("%I:%M %p");
        this.getHeight = (margin) => {
            if (this.sourceData.length > 18) {
                this.height = 600;
            }
            else if (this.sourceData.length < 7) {
                this.height = 250;
            }
            else {
                this.height = this.element.clientHeight - margin.top - margin.bottom;
            }
        };
        this.convertHoursFormat = (timeStamp) => {
            var now = new Date(new Date().toLocaleString("en-US", { timeZone: `${this.dateTimeZone}` }));
            // console.log("SAMPLE SAMPLE now :: "+ now);
            var date = now.getDate();
            var month = now.getMonth();
            var year = now.getFullYear();
            var hours = new Date((new Date(timeStamp * 1000).toLocaleString("en-US", { timeZone: `${this.dateTimeZone}` }))).getHours();
            var minutes = new Date((new Date(timeStamp * 1000).toLocaleString("en-US", { timeZone: `${this.dateTimeZone}` }))).getMinutes();
            // console.log("SAMPLE SAMPLE hours :: "+ hours);
            // console.log("SAMPLE SAMPLE minutes :: "+ minutes);
            // console.log("SAMPLE SAMPLE return current :: "+ new Date(year, month, date, hours, minutes, 0, 0));
            return new Date(year, month, date, hours, minutes, 0, 0);
        };
        window.addEventListener("resize", this.reDraw.bind(this));
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.initSvg();
            this.drawChart();
        }
    }
    set data(value) {
        if (!value || value.length == 0)
            return;
        this.sourceData = value;
        if (this.chartOptions) {
            this.initSvg();
            this.drawChart();
        }
    }
    set timeZone(value) {
        if (value === null || value === undefined || value === "") {
            this.dateTimeZone = "UTC";
        }
        else {
            this.dateTimeZone = value;
        }
    }
    reDraw() {
        if (this.sourceData && this.sourceData.length > 0) {
            this.initSvg();
            this.drawChart();
        }
    }
    ngOnInit() {
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    ngOnChanges(changes) {
        let { currentValue } = changes.data;
        if (!currentValue)
            return;
        this.initSvg();
        this.drawChart();
    }
    initSvg() {
        this.todayXmin = new Date(new Date().toLocaleString("en-US", { timeZone: `${this.dateTimeZone}` }));
        this.todayXmin.setHours(0, 0, 0, 0);
        this.todayXmax = new Date(new Date().toLocaleString("en-US", { timeZone: `${this.dateTimeZone}` }));
        this.todayXmax.setHours(23, 59, 59, 999);
        // formatting the response value
        // console.log( "Range Bar Chart :: response :: " + JSON.stringify(this.sourceData));
        this.element = this.chartContainer.nativeElement;
        if (!this.chartOptions)
            this.chartOptions = new RangeBarChartOptions();
        let { clientWidth, clientHeight } = this.element;
        let { margin, paddingInner } = this.chartOptions;
        if (!this.chartOptions.margin)
            this.chartOptions.margin = { top: 20, right: 30, bottom: 20, left: 30 };
        this.width = this.element.clientWidth - margin.left - margin.right;
        this.getHeight(margin);
        if (this.svg) {
            this.svg.remove();
        }
        let svg = d3.select(this.element).append("svg");
        this.svg = svg.attr("width", "100%").attr("height", this.height + 20);
        //set x scale
        this.xScale = d3.scaleTime()
            .domain([this.todayXmin, this.todayXmax])
            .nice(d3.timeDay)
            .range([0, this.width - 120]);
        // set y scale
        this.yScale = d3.scaleLinear()
            .domain([0, this.sourceData.length])
            .range([0, this.height])
            .nice();
        this.tip = d3Tip()
            .attr("class", "bi-tooltip rangebar-tooltip")
            .offset([-10, 0])
            .html(function () {
            return "<div id='bi-tooltip line-chart'></div>";
        });
        this.svg.call(this.tip);
    }
    drawChart() {
        const self = this;
        var xItems = [];
        var yItems = [];
        this.sourceData.forEach(element => {
            var json = {
                "day": element.day,
                // "occupied": `${element.totalOccupiedTimeHrs} / ${element.totalHours} hr occupied`
                "occupied": `${element.totalOccupiedTimeHrs} / 24 hr occupied`
            };
            yItems.push(json);
            xItems.push(element.records);
        });
        var translateY = 30;
        var translateBar = 23;
        var barHeight = 15;
        // X axis
        this.svg
            .append("g")
            .attr("class", "x-axis")
            .attr("width", "100%")
            .attr("transform", `translate(
        ${this.chartOptions.margin.left + 35},20)`)
            .call(d3
            .axisTop(this.xScale)
            .scale(this.xScale)
            .ticks(d3.timeHour.every(2))
            .tickPadding(2)
            .tickFormat(this.timeFormat)
            .tickSizeInner(-this.height)
            .tickSizeOuter(0))
            .call(g => g.selectAll(".tick line")
            .attr("class", "x-axis-grid-tick")
            .attr("stroke", "#e6e8e8")
            .attr("y2", this.yScale(xItems.length - 1) + 20));
        // Y axis  
        this.svg
            .append("g")
            .attr("class", "y-axis")
            .attr("transform", `translate(
        ${(this.chartOptions.margin.left + 35)},${translateY})`)
            .attr("height", this.height)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(2)
            .tickFormat(function (d, i) {
            return yItems[i].day;
        })
            .tickValues(d3.range(yItems.length)))
            .call(path => path.selectAll(".domain")
            .attr("class", "y-axis-domain")
            .attr("stroke", "transparent"));
        //grid lines
        this.svg
            .append("g")
            .attr("class", "y-axis-grid")
            .attr("transform", `translate(
            ${(this.chartOptions.margin.left + 35)},${translateY})`)
            .attr("stroke", '#adadad')
            .attr("stroke-width", 1)
            .attr("stroke-dasharray", "5 5")
            .attr("fill", "none")
            .call(d3.axisRight(this.yScale)
            .scale(this.yScale)
            .tickSize(this.width - 110)
            .tickFormat(function (d, i) {
            // console.log("GRID :: " + yItems[i].occupied)
            return yItems[i].occupied;
        })
            .tickValues(d3.range(yItems.length)))
            .call(g => g.selectAll(".tick line")
            .attr("class", "y-axis-grid-tick")
            .attr("stroke", "#545454"))
            .call(g => g.selectAll(".tick text")
            .attr("class", "y-axis-grid-text")
            .attr("fill", "#545454"))
            .call(path => path.selectAll(".domain")
            .attr("class", "y-axis-grid-domain")
            .attr("stroke", "transparent"));
        // Main bars   
        let chart = this.svg.append('g')
            .attr("transform", `translate(
        ${(this.chartOptions.margin.left + 35)},${translateBar})`)
            .attr('id', 'bars')
            .selectAll('rect');
        xItems.forEach((item, i) => {
            // console.log("xItems :: "+ item);
            chart
                .data(item)
                .enter()
                .append('rect')
                .attr('height', barHeight)
                .attr("x", (d) => {
                // console.log("X new start date :: "+ this.timeFormat(new Date(d.from*1000)));
                // console.log("X new end date :: "+ this.timeFormat(new Date(d.to*1000)));
                let result = this.convertHoursFormat(d.from);
                // console.log("X new result :: "+ result);
                return this.xScale(result);
            })
                .attr("y", (d) => {
                // console.log("Y d :: "+ d);
                return this.yScale(i);
            })
                .attr("width", (d) => {
                let fromTime = this.convertHoursFormat(d.from);
                let toTime = this.convertHoursFormat(d.to);
                // console.log("Width fromTime:: "+ fromTime);
                // console.log("Width toTime:: "+ toTime);
                return this.xScale(toTime) - this.xScale(fromTime);
            })
                .attr("fill", (d) => {
                if (d.value === 1) { // occupied
                    return "#D4371C";
                }
                else if (d.value === 0) { // unoccupied
                    return "#00AB50";
                }
                else { // 2 means Data N/A
                    return "none";
                }
            })
                .on("mouseover", function (d) {
                self.showTooltip(d);
                self.tip.show(d, this);
            })
                .on("mouseout", function () {
                self.tip.hide();
            });
        });
    }
    // eslint-disable-next-line no-unused-vars
    showTooltip(value) {
        const self = this;
        let tipContainer = "";
        self.tip.html(function (d) {
            tipContainer += "<div class = 'rangeBar-toolbar'>";
            tipContainer += `<span class='rangebar-left'>
				${self.timeFormat(new Date(new Date(d.srcElement.__data__.from * 1000).toLocaleString("en-US", { timeZone: `${self.dateTimeZone}` })))}
				</span> - <span class = 'rangebar-right'>
				${self.timeFormat(new Date(new Date(d.srcElement.__data__.to * 1000).toLocaleString("en-US", { timeZone: `${self.dateTimeZone}` })))}
				</span>`;
            tipContainer += "</div>";
            return tipContainer;
        });
    }
}
RangeBarChartComponent.ɵfac = function RangeBarChartComponent_Factory(t) { return new (t || RangeBarChartComponent)(); };
RangeBarChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RangeBarChartComponent, selectors: [["lib-range-bar-chart"]], viewQuery: function RangeBarChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$i, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data", timeZone: "timeZone" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [[1, "d3-chart-range"], ["chart", ""]], template: function RangeBarChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [".d3-chart-range[_ngcontent-%COMP%]{height:500px!important;overflow:auto!important}.x-axis[_ngcontent-%COMP%]   .domain[_ngcontent-%COMP%]{stroke:transparent!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeBarChartComponent, [{
        type: Component,
        args: [{
                selector: 'lib-range-bar-chart',
                templateUrl: './range-bar-chart.component.html',
                styleUrls: ['./range-bar-chart.component.scss']
            }]
    }], function () { return []; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }], timeZone: [{
            type: Input
        }] }); })();

class DefaultFormatter {
    to(value) {
        // formatting with http://stackoverflow.com/a/26463364/478584
        return String(parseFloat(parseFloat(String(value)).toFixed(2)));
    }
    ;
    from(value) {
        return parseFloat(value);
    }
}
class NouisliderComponent {
    constructor(ngZone, el, renderer) {
        this.ngZone = ngZone;
        this.el = el;
        this.renderer = renderer;
        this.config = {};
        this.change = new EventEmitter(true);
        this.update = new EventEmitter(true);
        this.slide = new EventEmitter(true);
        this.set = new EventEmitter(true);
        this.start = new EventEmitter(true);
        this.end = new EventEmitter(true);
        this.onChange = Function.prototype;
        this.cleanups = [];
        this.eventHandler = (emitter, values, handle, unencoded) => {
            let v = this.toValues(values);
            let emitEvents = false;
            if (this.value === undefined) {
                this.value = v;
                return;
            }
            if (Array.isArray(v) && this.value[handle] != v[handle]) {
                emitEvents = true;
            }
            if (!Array.isArray(v) && this.value != v) {
                emitEvents = true;
            }
            if (emitEvents) {
                this.ngZone.run(() => {
                    if (emitter.observers.length > 0) {
                        emitter.emit(v);
                    }
                    this.onChange(v);
                });
            }
            if (Array.isArray(v)) {
                this.value[handle] = v[handle];
            }
            else {
                this.value = v;
            }
        };
        this.defaultKeyHandler = (e) => {
            let stepSize = this.slider.steps();
            let index = parseInt(e.target.getAttribute('data-handle'));
            let sign = 1;
            let multiplier = 1;
            let step = 0;
            let delta = 0;
            switch (e.which) {
                case 34: // PageDown
                    multiplier = this.config.pageSteps;
                case 40: // ArrowDown
                case 37: // ArrowLeft
                    sign = -1;
                    step = stepSize[index][0];
                    e.preventDefault();
                    break;
                case 33: // PageUp
                    multiplier = this.config.pageSteps;
                case 38: // ArrowUp
                case 39: // ArrowRight
                    step = stepSize[index][1];
                    e.preventDefault();
                    break;
                default:
                    break;
            }
            delta = sign * multiplier * step;
            let newValue;
            if (Array.isArray(this.value)) {
                newValue = [].concat(this.value);
                newValue[index] = newValue[index] + delta;
            }
            else {
                newValue = this.value + delta;
            }
            this.slider.set(newValue);
        };
    }
    ngOnInit() {
        let inputsConfig = JSON.parse(JSON.stringify({
            behaviour: this.behaviour,
            connect: this.connect,
            limit: this.limit,
            start: this.formControl !== undefined ? this.formControl.value : this.ngModel,
            step: this.step,
            pageSteps: this.pageSteps,
            keyboard: this.keyboard,
            onKeydown: this.onKeydown,
            range: this.range || this.config.range || { min: this.min, max: this.max },
            tooltips: this.tooltips,
            snap: this.snap,
            animate: this.animate,
        }));
        inputsConfig.tooltips = this.tooltips || this.config.tooltips;
        inputsConfig.format = this.format || this.config.format || new DefaultFormatter();
        this.ngZone.runOutsideAngular(() => {
            this.slider = noUiSlider.create(this.el.nativeElement.querySelector('div'), Object.assign(this.config, inputsConfig));
        });
        this.handles = [].slice.call(this.el.nativeElement.querySelectorAll('.noUi-handle'));
        if (this.config.keyboard) {
            if (this.config.pageSteps === undefined) {
                this.config.pageSteps = 10;
            }
            for (const handle of this.handles) {
                handle.setAttribute('tabindex', 0);
                const onKeydown = this.config.onKeydown || this.defaultKeyHandler;
                this.ngZone.runOutsideAngular(() => {
                    this.cleanups.push(this.renderer.listen(handle, 'keydown', onKeydown), this.renderer.listen(handle, 'click', () => {
                        handle.focus();
                    }));
                });
            }
        }
        this.slider.on('set', (values, handle, unencoded) => {
            this.eventHandler(this.set, values, handle, unencoded);
        });
        this.slider.on('update', (values, handle, unencoded) => {
            if (this.update.observers.length > 0) {
                this.ngZone.run(() => {
                    this.update.emit(this.toValues(values));
                });
            }
        });
        this.slider.on('change', (values, handle, unencoded) => {
            if (this.change.observers.length > 0) {
                this.ngZone.run(() => {
                    this.change.emit(this.toValues(values));
                });
            }
        });
        this.slider.on('slide', (values, handle, unencoded) => {
            this.eventHandler(this.slide, values, handle, unencoded);
        });
        this.slider.on('start', (values, handle, unencoded) => {
            if (this.start.observers.length > 0) {
                this.ngZone.run(() => {
                    this.start.emit(this.toValues(values));
                });
            }
        });
        this.slider.on('end', (values, handle, unencoded) => {
            if (this.end.observers.length > 0) {
                this.ngZone.run(() => {
                    this.end.emit(this.toValues(values));
                });
            }
        });
    }
    ngOnChanges(changes) {
        if (this.slider && (changes.min || changes.max || changes.step || changes.range)) {
            this.ngZone.runOutsideAngular(() => {
                setTimeout(() => {
                    this.slider.updateOptions({
                        range: Object.assign({}, {
                            min: this.min,
                            max: this.max
                        }, this.range || {}),
                        step: this.step
                    });
                });
            });
        }
    }
    ngOnDestroy() {
        this.slider.destroy();
        while (this.cleanups.length) {
            this.cleanups.pop()();
        }
    }
    toValues(values) {
        let v = values.map(this.config.format.from);
        return (v.length == 1 ? v[0] : v);
    }
    writeValue(value) {
        if (this.slider) {
            this.ngZone.runOutsideAngular(() => {
                setTimeout(() => {
                    this.slider.set(value);
                });
            });
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) { }
    setDisabledState(isDisabled) {
        isDisabled
            ? this.renderer.setAttribute(this.el.nativeElement.childNodes[0], 'disabled', 'true')
            : this.renderer.removeAttribute(this.el.nativeElement.childNodes[0], 'disabled');
    }
}
NouisliderComponent.ɵfac = function NouisliderComponent_Factory(t) { return new (t || NouisliderComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); };
NouisliderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NouisliderComponent, selectors: [["nouislider"]], hostVars: 2, hostBindings: function NouisliderComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("ng2-nouislider", true);
    } }, inputs: { disabled: "disabled", behaviour: "behaviour", connect: "connect", limit: "limit", min: "min", max: "max", snap: "snap", animate: "animate", range: "range", step: "step", format: "format", pageSteps: "pageSteps", config: "config", ngModel: "ngModel", keyboard: "keyboard", onKeydown: "onKeydown", formControl: "formControl", tooltips: "tooltips" }, outputs: { change: "change", update: "update", slide: "slide", set: "set", start: "start", end: "end" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => NouisliderComponent),
                multi: true
            }
        ]), i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, template: function NouisliderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div");
    } if (rf & 2) {
        i0.ɵɵattribute("disabled", ctx.disabled ? true : undefined);
    } }, styles: ["[_nghost-%COMP%] {\n      display: block;\n      margin-top: 1rem;\n      margin-bottom: 1rem;\n    }"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NouisliderComponent, [{
        type: Component,
        args: [{
                selector: 'nouislider',
                host: {
                    '[class.ng2-nouislider]': 'true'
                },
                template: '<div [attr.disabled]="disabled ? true : undefined"></div>',
                styles: [`
    :host {
      display: block;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
  `],
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => NouisliderComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: i0.NgZone }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, { disabled: [{
            type: Input
        }], behaviour: [{
            type: Input
        }], connect: [{
            type: Input
        }], limit: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], snap: [{
            type: Input
        }], animate: [{
            type: Input
        }], range: [{
            type: Input
        }], step: [{
            type: Input
        }], format: [{
            type: Input
        }], pageSteps: [{
            type: Input
        }], config: [{
            type: Input
        }], ngModel: [{
            type: Input
        }], keyboard: [{
            type: Input
        }], onKeydown: [{
            type: Input
        }], formControl: [{
            type: Input
        }], tooltips: [{
            type: Input
        }], change: [{
            type: Output
        }], update: [{
            type: Output
        }], slide: [{
            type: Output
        }], set: [{
            type: Output
        }], start: [{
            type: Output
        }], end: [{
            type: Output
        }] }); })();

class RangeSliderComponent {
    constructor() {
        this.sliderValue = 0;
        this.timeSliderEmit = new EventEmitter();
        this.weekValiditySliderEmit = new EventEmitter();
        this.monthValiditySliderEmit = new EventEmitter();
        this.bandWidthSliderEmit = new EventEmitter();
        this.ruleBandWidthSliderEmit = new EventEmitter();
        this.rotationAngleSliderEmit = new EventEmitter();
        this.timeConfig = {
            step: 1,
            range: {
                min: 0,
                max: 12
            }
        };
        this.bandwidthConfig = {
            start: 0,
            step: 1,
            range: {
                min: 0,
                max: 7
            }
        };
        this.weekValidityConfig = {
            start: 1,
            step: 1,
            range: {
                min: 1,
                max: 52
            }
        };
        this.monthValidityConfig = {
            start: 1,
            step: 1,
            range: {
                min: 1,
                max: 12
            }
        };
        this.ruleBandWidthConfig = {
            start: 1,
            step: 1,
            range: {
                min: 1,
                max: 20
            }
        };
        this.rotationAngleConfig = {
            start: 0,
            step: 0.39269908169872414,
            range: {
                min: 0,
                max: 6.28
            }
        };
        this.onSliderValueChange = (e) => {
            if (this.type == "time") {
                this.timeSliderEmit.emit(e.value);
            }
            else if (this.type == "bandwidth") {
                this.bandWidthSliderEmit.emit(e.value);
            }
            else if (this.type == "weekValidity") {
                this.weekValiditySliderEmit.emit(e.value);
            }
            else if (this.type == "monthValidity") {
                this.monthValiditySliderEmit.emit(e.value);
            }
            else if (this.type == "rule-bandwidth") {
                this.ruleBandWidthSliderEmit.emit(e.value);
            }
            else if (this.type == "rotation-angle") {
                this.rotationAngleSliderEmit.emit(e.value);
            }
        };
    }
    ngOnInit() {
        if (this.type == "time") {
            this.rangeConfig = this.timeConfig;
        }
        else if (this.type == "bandwidth") {
            this.rangeConfig = this.bandwidthConfig;
        }
        else if (this.type == "weekValidity") {
            this.rangeConfig = this.weekValidityConfig;
        }
        else if (this.type == "monthValidity") {
            this.rangeConfig = this.monthValidityConfig;
        }
        else if (this.type == "rule-bandwidth") {
            this.rangeConfig = this.ruleBandWidthConfig;
        }
        else if (this.type == "rotation-angle") {
            this.rangeConfig = this.rotationAngleConfig;
        }
        if (this.preValue != null) {
            this.sliderValue = this.preValue;
        }
    }
}
RangeSliderComponent.ɵfac = function RangeSliderComponent_Factory(t) { return new (t || RangeSliderComponent)(); };
RangeSliderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RangeSliderComponent, selectors: [["lib-range-slider"]], inputs: { type: "type", preValue: "preValue" }, outputs: { timeSliderEmit: "timeSliderEmit", weekValiditySliderEmit: "weekValiditySliderEmit", monthValiditySliderEmit: "monthValiditySliderEmit", bandWidthSliderEmit: "bandWidthSliderEmit", ruleBandWidthSliderEmit: "ruleBandWidthSliderEmit", rotationAngleSliderEmit: "rotationAngleSliderEmit" }, decls: 3, vars: 5, consts: [[1, "range-slider"], [1, "slider"], [3, "tickInterval", "step", "min", "max", "value", "ngModelChange", "input"]], template: function RangeSliderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "mat-slider", 2);
        i0.ɵɵlistener("ngModelChange", function RangeSliderComponent_Template_mat_slider_ngModelChange_2_listener($event) { return ctx.onSliderValueChange($event); })("input", function RangeSliderComponent_Template_mat_slider_input_2_listener($event) { return ctx.onSliderValueChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("tickInterval", ctx.rangeConfig.step);
        i0.ɵɵpropertyInterpolate("step", ctx.rangeConfig.step);
        i0.ɵɵpropertyInterpolate("min", ctx.rangeConfig.range.min);
        i0.ɵɵpropertyInterpolate("max", ctx.rangeConfig.range.max);
        i0.ɵɵproperty("value", ctx.sliderValue);
    } }, directives: [i1$6.MatSlider], styles: ["mat-slider[_ngcontent-%COMP%]{width:100%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeSliderComponent, [{
        type: Component,
        args: [{
                selector: "lib-range-slider",
                templateUrl: "./range-slider.component.html",
                styleUrls: ["./range-slider.component.css"]
            }]
    }], function () { return []; }, { type: [{
            type: Input
        }], preValue: [{
            type: Input
        }], timeSliderEmit: [{
            type: Output
        }], weekValiditySliderEmit: [{
            type: Output
        }], monthValiditySliderEmit: [{
            type: Output
        }], bandWidthSliderEmit: [{
            type: Output
        }], ruleBandWidthSliderEmit: [{
            type: Output
        }], rotationAngleSliderEmit: [{
            type: Output
        }] }); })();

class ReportDescriptionComponent {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() { }
}
ReportDescriptionComponent.ɵfac = function ReportDescriptionComponent_Factory(t) { return new (t || ReportDescriptionComponent)(); };
ReportDescriptionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportDescriptionComponent, selectors: [["lib-report-description"]], inputs: { description: "description" }, decls: 6, vars: 4, consts: [[1, "desc-wrapper"], [1, "header"], [1, "description", "boxShadowBlur"]], template: function ReportDescriptionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "shared-lib.report-filter.report-desc"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.description);
    } }, pipes: [i2.TranslatePipe], styles: [".desc-wrapper[_ngcontent-%COMP%]{margin-top:20px}.header[_ngcontent-%COMP%]{display:inline;font-family:ciscoSans;font-size:18 px;color:#000}.description[_ngcontent-%COMP%]{margin-top:10px;padding:17px 0 17px 15px;background-color:#fff;font-family:CiscoSans;font-size:14px;opacity:.6}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportDescriptionComponent, [{
        type: Component,
        args: [{
                selector: "lib-report-description",
                templateUrl: "./report-description.component.html",
                styleUrls: ["./report-description.component.css"]
            }]
    }], function () { return []; }, { description: [{
            type: Input
        }] }); })();

class ReportEmptyComponent {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() { }
    ngOnInit() {
        console.log("inside report empty component");
    }
}
ReportEmptyComponent.ɵfac = function ReportEmptyComponent_Factory(t) { return new (t || ReportEmptyComponent)(); };
ReportEmptyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportEmptyComponent, selectors: [["lib-report-empty"]], inputs: { message: "message" }, decls: 9, vars: 4, consts: [["id", "report-empty", 1, "boxShadowBlur"], [1, "report_empty"], ["src", "/assets/images/reports/report-no-data.svg"], [1, "report_empty_overall"], [1, "report_empty_message", 2, "padding-top", "10px"]], template: function ReportEmptyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div");
        i0.ɵɵelement(3, "img", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 2, "shared-lib.no-data"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.message, " ");
    } }, pipes: [i2.TranslatePipe], styles: ["#report-empty[_ngcontent-%COMP%]{background-color:#fff;margin-top:40px}.report_empty[_ngcontent-%COMP%]{padding:80px;text-align:center}.report_empty_overall[_ngcontent-%COMP%]{padding-top:15px;font-size:18px;font-weight:500;color:#000;font-family:\"ciscoSans\"}.report_empty_message[_ngcontent-%COMP%]{padding-top:10px;font-size:14px;font-weight:500;color:#414f5f;font-family:\"ciscoSans\"}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportEmptyComponent, [{
        type: Component,
        args: [{
                selector: "lib-report-empty",
                templateUrl: "./report-empty.component.html",
                styleUrls: ["./report-empty.component.css"]
            }]
    }], function () { return []; }, { message: [{
            type: Input
        }] }); })();

class ReportFilter {
    constructor() {
        this.locationFilter = [];
        this.selectedLocationNames = [];
    }
}

function ReportFilterComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.report-filter.filters"));
} }
function ReportFilterComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.getReportName(ctx_r1.showReportName));
} }
function ReportFilterComponent_div_5_div_5_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵelement(1, "img", 20);
    i0.ɵɵelementEnd();
} }
function ReportFilterComponent_div_5_div_5_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵelement(1, "img", 21);
    i0.ɵɵelementEnd();
} }
function ReportFilterComponent_div_5_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function ReportFilterComponent_div_5_div_5_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.showUserLocationPopup(); })("mouseover", function ReportFilterComponent_div_5_div_5_Template_div_mouseover_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.onMouseOverLoc(); })("mouseout", function ReportFilterComponent_div_5_div_5_Template_div_mouseout_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.onMouseOutLoc(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, ReportFilterComponent_div_5_div_5_span_3_Template, 2, 0, "span", 18);
    i0.ɵɵtemplate(4, ReportFilterComponent_div_5_div_5_span_4_Template, 2, 0, "span", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "shared-lib.report-filter.all-loc"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r6.showLocSelEditIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.showLocSelEditIcon);
} }
function ReportFilterComponent_div_5_div_6_span_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, ", ");
    i0.ɵɵelementEnd();
} }
function ReportFilterComponent_div_5_div_6_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ReportFilterComponent_div_5_div_6_span_1_span_3_Template, 2, 0, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selectedLocation_r18 = ctx.$implicit;
    const i_r19 = ctx.index;
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(selectedLocation_r18);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r19 < ctx_r14.selectedLocations.length - 1);
} }
function ReportFilterComponent_div_5_div_6_span_2_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selectedLocation_r22 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", selectedLocation_r22, " ");
} }
function ReportFilterComponent_div_5_div_6_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, ",");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 23);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtemplate(7, ReportFilterComponent_div_5_div_6_span_2_div_7_Template, 2, 1, "div", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" + ", ctx_r15.selectedLocationsMore.length, " ", i0.ɵɵpipeBind1(5, 4, "shared-lib.report-filter.more"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r15.selectedLocationsMore)("ngForTrackBy", ctx_r15.customTrackBy);
} }
function ReportFilterComponent_div_5_div_6_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵelement(1, "img", 20);
    i0.ɵɵelementEnd();
} }
function ReportFilterComponent_div_5_div_6_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵelement(1, "img", 21);
    i0.ɵɵelementEnd();
} }
function ReportFilterComponent_div_5_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function ReportFilterComponent_div_5_div_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.showUserLocationPopup(); })("mouseover", function ReportFilterComponent_div_5_div_6_Template_div_mouseover_0_listener() { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.onMouseOverLoc(); })("mouseout", function ReportFilterComponent_div_5_div_6_Template_div_mouseout_0_listener() { i0.ɵɵrestoreView(_r25); const ctx_r27 = i0.ɵɵnextContext(2); return ctx_r27.onMouseOutLoc(); });
    i0.ɵɵtemplate(1, ReportFilterComponent_div_5_div_6_span_1_Template, 4, 2, "span", 22);
    i0.ɵɵtemplate(2, ReportFilterComponent_div_5_div_6_span_2_Template, 8, 6, "span", 4);
    i0.ɵɵtemplate(3, ReportFilterComponent_div_5_div_6_span_3_Template, 2, 0, "span", 18);
    i0.ɵɵtemplate(4, ReportFilterComponent_div_5_div_6_span_4_Template, 2, 0, "span", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r7.selectedLocations)("ngForTrackBy", ctx_r7.customTrackBy);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.selectedLocationsMore.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.showLocSelEditIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.showLocSelEditIcon);
} }
function ReportFilterComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ReportFilterComponent_div_5_div_5_Template, 5, 5, "div", 16);
    i0.ɵɵtemplate(6, ReportFilterComponent_div_5_div_6_Template, 5, 5, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "shared-lib.report-filter.loc"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.selectedLocations.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.selectedLocations.length > 0);
} }
function ReportFilterComponent_div_6_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵelement(1, "img", 20);
    i0.ɵɵelementEnd();
} }
function ReportFilterComponent_div_6_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵelement(1, "img", 21);
    i0.ɵɵelementEnd();
} }
function ReportFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 26);
    i0.ɵɵlistener("click", function ReportFilterComponent_div_6_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.showDateFilterPopup(); })("mouseover", function ReportFilterComponent_div_6_Template_div_mouseover_5_listener() { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(); return ctx_r32.onMouseOverDate(); })("mouseout", function ReportFilterComponent_div_6_Template_div_mouseout_5_listener() { i0.ɵɵrestoreView(_r31); const ctx_r33 = i0.ɵɵnextContext(); return ctx_r33.onMouseOutDate(); });
    i0.ɵɵtext(6);
    i0.ɵɵtemplate(7, ReportFilterComponent_div_6_span_7_Template, 2, 0, "span", 18);
    i0.ɵɵtemplate(8, ReportFilterComponent_div_6_span_8_Template, 2, 0, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "shared-lib.report-filter.date-range"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.selectedDateString, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.showDateSelEditIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.showDateSelEditIcon);
} }
function ReportFilterComponent_div_8_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r34.description, " ");
} }
function ReportFilterComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ReportFilterComponent_div_8_div_3_Template, 2, 1, "div", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.count);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.reportHeader);
} }
function ReportFilterComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "lib-location-popup", 31);
    i0.ɵɵlistener("selectLocationPopupEvt", function ReportFilterComponent_div_9_Template_lib_location_popup_selectLocationPopupEvt_1_listener($event) { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(); return ctx_r35.onSelectLocationPopup($event); })("cancelLocationPopupEvt", function ReportFilterComponent_div_9_Template_lib_location_popup_cancelLocationPopupEvt_1_listener() { i0.ɵɵrestoreView(_r36); const ctx_r37 = i0.ɵɵnextContext(); return ctx_r37.cancelLocationPopup(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("preSelectLocation", ctx_r5.selectedLocationsTreeNode)("multiLocationSelect", ctx_r5.multiLocationSelect)("isReportsLocation", true)("setAppName", "captivePortal");
} }
const _c0$h = function (a0) { return { "hide": a0 }; };
const moment$6 = moment_; // A fix for Cannot call a namespace ('moment'). An unhandled exception occurred: Cannot call a namespace ('moment')
class ReportFilterComponent {
    constructor(logger, 
    // eslint-disable-next-line no-unused-vars
    dataService, translate) {
        this.logger = logger;
        this.dataService = dataService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.dateApplied = new EventEmitter();
        this.locationApplied = new EventEmitter();
        this.selectedLocations = [];
        this.selectedLocationsMore = [];
        this.selectedLocationsTreeNode = [];
        this.prevSelectedTreeNode = [];
        this.isShowDatePopup = false;
        this.isShowUserLocationPopup = false;
        this.isApplyDateFirstTime = true;
        this.showDateSelEditIcon = false;
        this.showLocSelEditIcon = false;
        this.showDownload = true;
        this.showDownloadProgress = false;
        this.showDownloadComplete = false;
        this.showDownloadError = false;
        this.mainDisplayDateFormat = "MMM DD, YYYY";
        this.translateKeys = [];
        this.getStaticText = () => {
            this.translate.get('shared-lib.report-filter.cust-acq').subscribe((res) => {
                this.translateKeys["cust-acq"] = res;
            });
            this.translate.get('shared-lib.report-filter.dev-onb').subscribe((res) => {
                this.translateKeys["dev-onb"] = res;
            });
        };
        this.showUserLocationPopup = () => {
            this.isShowUserLocationPopup = true;
            this.dataService.openMagneticPopup();
        };
        this.closeLocationPopup = () => {
            this.isShowUserLocationPopup = false;
            this.dataService.closeMagneticPopup();
        };
        this.showDateFilterPopup = () => {
            if (this.selectedDateString) {
                this.isApplyDateFirstTime = false;
                this.isShowDatePopup = true;
                this.dataService.openMagneticPopup();
            }
        };
        this.closeDatePopup = () => {
            this.isShowDatePopup = false;
            this.dataService.closeMagneticPopup();
        };
        this.onSelectLocationPopup = (event) => {
            this.prevSelectedTreeNode = this.selectedLocationsTreeNode;
            this.selectedLocations = [];
            // this.selectedLocationsMore = [];
            this.selectedLocationsTreeNode = [];
            // let selLocations = {selectedLocations: [], selectedLocationsWithChild: [-1]};
            // setting the default as root location
            let selectedLocation = this.rootLoctionId;
            let selectedLocationType = "root";
            let locationPath = [this.rootLoctionId];
            const sessionReportsFilter = this.dataService.getFromStorage("reportsFilter")
                ? JSON.parse(this.dataService.getFromStorage("reportsFilter") || "{}")
                : {};
            if (sessionReportsFilter && sessionReportsFilter.selectedLocations) {
                this.selectedLocations = [];
                selectedLocation = sessionReportsFilter.selLocationNames;
                selectedLocationType = sessionReportsFilter.selectedLocationType;
                locationPath = sessionReportsFilter.selectedLocationPath;
                this.selectedLocations.push(selectedLocation);
                this.selectedLocationsTreeNode = this.prevSelectedTreeNode;
            }
            if (event && event["length"] > 0) {
                this.selectedLocations = [];
                this.selectedLocationsTreeNode = [];
                selectedLocation = event[0].data.id;
                selectedLocationType = event[0].data.type;
                this.selectedLocationsTreeNode.push(event[0]);
                this.selectedLocations.push(event[0].data.name);
                locationPath = event[0].data.path;
            }
            // let type = null;
            // event.forEach((item, index) => {
            //   if(index <= 1)
            //     this.selectedLocations.push(item.data.name);
            //   else
            //     this.selectedLocationsMore.push(item.data.name);
            //   type = item.data.type;
            //   if(type != 'root')
            //     selLocations.selectedLocations.push(item.data.id);
            //   else
            //     selLocations.selectedLocations.push(-1);
            //   this.selectedLocationsTreeNode.push(item);
            // });
            // if(selLocations.selectedLocations.length == 0){
            //   selLocations.selectedLocations = [this.rootLoctionId];
            //   this.selectedLocationsTreeNode = [];
            // }
            this.closeLocationPopup();
            // if(type != 'root')
            //   selLocations.selectedLocationsWithChild = this.utils.locationUtil.getLocationIds(event, null);
            // console.log('selLocations ::: ',selLocations);
            const selectedLocationObj = {
                locationId: selectedLocation,
                locationType: selectedLocationType,
                selectedLocations: this.selectedLocations,
                selectedLocationPath: locationPath
            };
            this.locationApplied.emit(selectedLocationObj);
        };
        this.cancelLocationPopup = () => {
            this.closeLocationPopup();
        };
        this.onMouseOverDate = () => {
            this.showDateSelEditIcon = true;
        };
        this.onMouseOutDate = () => {
            this.showDateSelEditIcon = false;
        };
        this.onMouseOverLoc = () => {
            this.showLocSelEditIcon = true;
        };
        this.onMouseOutLoc = () => {
            this.showLocSelEditIcon = false;
        };
        this.downloadPDF = () => {
            this.showDownload = false;
            this.showDownloadProgress = true;
            const reportContentNode = document.getElementById("report_content");
            const doc = new jsPDF("p", "mm", "a4");
            const width = doc.internal.pageSize.width;
            const height = doc.internal.pageSize.height;
            // const that = this;
            domtoimage
                .toPng(reportContentNode)
                .then(function (dataUrl) {
                this.showDownload = false;
                this.showDownloadProgress = false;
                this.showDownloadComplete = true;
                doc.addImage(dataUrl, "PNG", 20, 5, width - 50, height - 10);
                doc.save("reports.pdf");
            })
                .catch(function (error) {
                this.showDownload = false;
                this.showDownloadProgress = false;
                this.showDownloadComplete = false;
                this.showDownloadError = true;
                console.error("oops, something went wrong!", error);
            });
        };
        this.getReportName = (name) => {
            if (name === "Device Onboarding")
                return this.translateKeys["dev-onb"];
            else if (name === "Customer Acquisition")
                return this.translateKeys["cust-acq"];
            return this.translateKeys[name];
        };
        // Magnetic UI popup
        this.openMagneticPopup = () => {
            $('.mat-drawer.mat-drawer-side').css('z-index', 0);
            $('.appContainer .container-toolbar').css('position', 'fixed');
            $('mat-sidenav-content').css('marginLeft', '0');
        };
        this.closeMagneticPopup = () => {
            $('.mat-drawer.mat-drawer-side').css('z-index', 4);
            $('.appContainer .container-toolbar').css('position', 'sticky');
            $('mat-sidenav-content').css('marginLeft', '15.5vw');
        };
        this.utils = new Utils(logger);
    }
    set setOverallReportCount(value) {
        if (!value)
            return;
        this.reportHeader = value;
        this.count = value.count;
        this.description = value.description;
        this.imageUrl = value.image;
    }
    set setPrefiledLocation(value) {
        this.selectedLocationsTreeNode = value;
    }
    ngOnInit() {
        void this.dataService.getLocationWrap().then((val) => {
            if (val && val.location)
                this.rootLoctionId = val.location[0]["id"];
        });
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localized string here
            this.getStaticText();
        });
    }
    set setData(value) {
        if (!value)
            return;
        if (value.dateFilter)
            this.minAndMaxDate = value.dateFilter;
        if (value.locationFilter.length > 0)
            this.selectedLocationsTreeNode = value.locationFilter;
        else
            this.selectedLocationsTreeNode = [];
        if (value.selectedLocationNames.length > 0)
            this.selectedLocations = value.selectedLocationNames;
        else
            this.selectedLocations = [];
    }
    onApplyDate(event) {
        // console.log('Apply Date Filter ::: ',event);
        const selDateRange = event["selectedRange"];
        const sDate = event["startDate"];
        const eDate = event["endDate"];
        const dateDiff = event["dateDifference"];
        // const isFirstTime = event["isFirstTime"];
        if (selDateRange != "Custom") {
            this.selectedDateString =
                selDateRange.toString() +
                    " (" +
                    moment$6(sDate).format(this.mainDisplayDateFormat) +
                    " - " +
                    moment$6(eDate).format(this.mainDisplayDateFormat) +
                    ")";
        }
        else {
            this.selectedDateString =
                moment$6(sDate).format(this.mainDisplayDateFormat) +
                    " - " +
                    moment$6(eDate).format(this.mainDisplayDateFormat) +
                    " (" +
                    dateDiff +
                    " Days)";
        }
        this.dateApplied.emit(event);
    }
    customTrackBy(index) {
        return index;
    }
    ngOnDestroy() {
        console.log("destory Report Filter page");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
ReportFilterComponent.ɵfac = function ReportFilterComponent_Factory(t) { return new (t || ReportFilterComponent)(i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
ReportFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportFilterComponent, selectors: [["lib-report-filter"]], inputs: { isShowLocationFilter: "isShowLocationFilter", isShowDateFilter: "isShowDateFilter", multiLocationSelect: "multiLocationSelect", showReportName: "showReportName", setOverallReportCount: "setOverallReportCount", setPrefiledLocation: "setPrefiledLocation", setData: "setData" }, outputs: { dateApplied: "dateApplied", locationApplied: "locationApplied" }, decls: 12, vars: 11, consts: [[1, "display-table", "report-filter"], [1, "display-table-row"], [1, "display-table-cell", "filter-text"], ["class", "wordBoldFont", 4, "ngIf"], [4, "ngIf"], ["class", "display-table-cell filter-location pointer", 4, "ngIf"], ["class", "display-table-cell filter-date pointer", 4, "ngIf"], ["id", "download", 1, "display-table-cell", "download"], ["id", "reportOverallCount", "class", "display-table-cell reportOverallCount", 4, "ngIf"], ["class", "userLocationPopup", 4, "ngIf"], [1, "datePopup", 3, "ngClass"], [3, "date", "isApplyFirstTime", "closeDatePopup", "atApplyDate"], [1, "wordBoldFont"], [1, "display-table-cell", "filter-location", "pointer"], [2, "display", "inline"], [1, "loc-header"], ["class", "sel-location", 3, "click", "mouseover", "mouseout", 4, "ngIf"], [1, "sel-location", 3, "click", "mouseover", "mouseout"], ["class", "edit-icon", 4, "ngIf"], [1, "edit-icon"], ["src", "/assets/images/reports/edit-normal.svg"], ["src", "/assets/images/reports/edit-on-hover.svg"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "underline", "tool-tip-css"], [1, "display-table-cell", "filter-date", "pointer"], [1, "date-header"], [1, "sel-date", 3, "click", "mouseover", "mouseout"], ["id", "reportOverallCount", 1, "display-table-cell", "reportOverallCount"], ["id", "reportOverallCountDescription", "class", "reportOverallCountDescription", 4, "ngIf"], ["id", "reportOverallCountDescription", 1, "reportOverallCountDescription"], [1, "userLocationPopup"], [3, "preSelectLocation", "multiLocationSelect", "isReportsLocation", "setAppName", "selectLocationPopupEvt", "cancelLocationPopupEvt"]], template: function ReportFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, ReportFilterComponent_span_3_Template, 3, 3, "span", 3);
        i0.ɵɵtemplate(4, ReportFilterComponent_span_4_Template, 2, 1, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, ReportFilterComponent_div_5_Template, 7, 5, "div", 5);
        i0.ɵɵtemplate(6, ReportFilterComponent_div_6_Template, 9, 6, "div", 6);
        i0.ɵɵelement(7, "div", 7);
        i0.ɵɵtemplate(8, ReportFilterComponent_div_8_Template, 4, 2, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, ReportFilterComponent_div_9_Template, 2, 4, "div", 9);
        i0.ɵɵelementStart(10, "div", 10);
        i0.ɵɵelementStart(11, "lib-date-filter-popup", 11);
        i0.ɵɵlistener("closeDatePopup", function ReportFilterComponent_Template_lib_date_filter_popup_closeDatePopup_11_listener() { return ctx.closeDatePopup(); })("atApplyDate", function ReportFilterComponent_Template_lib_date_filter_popup_atApplyDate_11_listener($event) { return ctx.onApplyDate($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.showReportName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showReportName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isShowLocationFilter);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isShowDateFilter);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.reportHeader);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isShowUserLocationPopup);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$h, !ctx.isShowDatePopup));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("date", ctx.minAndMaxDate)("isApplyFirstTime", ctx.isApplyDateFirstTime);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, DateFilterPopupComponent, i1$2.NgForOf, LocationPopupComponent], pipes: [i2.TranslatePipe], styles: [".wordBoldFont[_ngcontent-%COMP%]{font-family:ciscoSansBold}.numberBoldFont[_ngcontent-%COMP%]{font-family:ciscoSansCondensed}.report-filter[_ngcontent-%COMP%]{padding:12px 40px;background-color:#fff;font-family:ciscoSansLight;box-shadow:0 0 4px #0000001a;margin-bottom:1px}.filter-text[_ngcontent-%COMP%]{width:15%;vertical-align:middle;font-family:ciscoSans;font-size:16px}.filter-location[_ngcontent-%COMP%]{width:15%;vertical-align:middle;padding-right:15px}.filter-date[_ngcontent-%COMP%]{width:30%;vertical-align:middle}.download[_ngcontent-%COMP%]{width:10%;text-align:right;padding-right:10px}.reportOverallCount[_ngcontent-%COMP%]{width:12%;text-align:center;padding-right:10px;vertical-align:middle}.reportOverallCount[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{vertical-align:top!important}.reportOverallCount[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding-left:3px;font-family:CiscoSans;font-size:30px;color:#414f5f}.reportOverallCountDescription[_ngcontent-%COMP%]{padding-right:10px;font-family:ciscoSansLight;font-size:12px;color:#6a6b6c}.sel-location[_ngcontent-%COMP%]:hover, .sel-date[_ngcontent-%COMP%]:hover{color:#00a1d7}.loc-header[_ngcontent-%COMP%], .date-header[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:12px;font-weight:300;color:#58585b;letter-spacing:.5px}.sel-location[_ngcontent-%COMP%], .sel-date[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;font-weight:500;color:#00a1d7}.edit-icon[_ngcontent-%COMP%]{padding-left:5px}#download[_ngcontent-%COMP%]   .more_tags[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:14px;color:#4a4a4a;text-align:center;display:inline-block;padding:8px 30px;border:1px solid #c4c4c4;border-radius:20px}.showDownloadProgress[_ngcontent-%COMP%], .showDownloadComplete[_ngcontent-%COMP%], .showDownloadError[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:15px;color:#000;opacity:.6;padding:8px 20px}", ".wordBoldFont[_ngcontent-%COMP%]{font-family:ciscoSansBold}.numberBoldFont[_ngcontent-%COMP%]{font-family:ciscoSansCondensed}#report_content[_ngcontent-%COMP%]{background-color:#f1f4f9}.reportsContent[_ngcontent-%COMP%]{margin:20px 0;padding:0 40px}.header[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:18px;color:#000}.chart[_ngcontent-%COMP%]{background-color:#fff;margin-top:10px;padding:10px 20px}.overall-count[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:first-child{font-size:28px;font-family:ciscoSans;color:#414f5f}.overall-count[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(2){font-family:ciscoSans;padding-left:3px;font-size:18px;color:#7b7b7b}.overall-count-text[_ngcontent-%COMP%]{font-size:14px;color:#6a6b6c;font-family:ciscoSans}.popupModal[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:1000;left:0;top:0}.popupOverlay[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;z-index:1000;background-color:#0009}.popupContent[_ngcontent-%COMP%]{position:absolute;top:60px;bottom:60px;left:50%;transform:translate(-50%);width:80%;margin:0 auto;background-color:#fff;box-shadow:0 4px 8px #0000001a;border-radius:5px;border:0;z-index:1001}.popupHeader[_ngcontent-%COMP%]{padding:18px 30px;color:#000;font-size:18px;font-family:\"ciscoSansRegular\";position:relative;height:60px;border-bottom:1px solid #EAEAEA}.popupClose[_ngcontent-%COMP%]{position:absolute;right:0;top:0;padding:22px 30px;font-family:\"icomoon-new\";color:#999;font-size:14px;cursor:pointer}.innerContent[_ngcontent-%COMP%]{padding:0 20px;overflow-y:auto;height:85%}.hide[_ngcontent-%COMP%]{display:none!important}.legendDetails[_ngcontent-%COMP%]{text-align:right;padding:15px 0}.legendRect[_ngcontent-%COMP%]{display:inline-block;padding:6px;border-radius:3px}.legendTitle[_ngcontent-%COMP%]{font-size:12px;color:#000;font-family:CiscoSans;padding-left:3px;font-weight:300;letter-spacing:.43px}.visitorsViewType[_ngcontent-%COMP%]{border:1px solid #ddd;border-radius:100px;padding:5px 15px;display:inline-block;margin:10px 0 20px}.visit-dist-tab[_ngcontent-%COMP%]{text-align:center}.visit-dist-view[_ngcontent-%COMP%]{display:inline;font-size:12px;color:#000;font-weight:bold}#mapView[_ngcontent-%COMP%]{padding-right:10px}.visitorsViewSep[_ngcontent-%COMP%]{display:inline;opacity:.2;padding:0 3px;color:#979797}#listView[_ngcontent-%COMP%]{padding-left:10px}.viewTypeOpacity[_ngcontent-%COMP%]{opacity:.5}.total-menu[_ngcontent-%COMP%]{padding-top:10px}.total-menu-buttons[_ngcontent-%COMP%]{position:relative}.total-menu-buttons[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:last-child{padding-right:23px}.total-menu[_ngcontent-%COMP%]   .total-menu-buttons[_ngcontent-%COMP%]:after{position:absolute;width:1px;height:15px;background-color:#9f9f9f;opacity:.5;top:10px;content:\"\"}.total-left[_ngcontent-%COMP%]{float:left;width:49%;text-align:right}.total-right[_ngcontent-%COMP%]{float:right;width:49%;text-align:left}.total-menu-buttons[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:first-child, .total-menu-clicks[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:first-child{font-weight:bold;font-size:26px;font-family:ciscoSansBold;color:#414f5f}.total-menu-buttons[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(2), .total-menu-clicks[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(2){font-size:16px;font-family:ciscoSans;color:#6a6b6c}.menusWrapper[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]{float:left;width:20%;position:relative}.menusWrapper[_ngcontent-%COMP%]   .legend[_ngcontent-%COMP%]{text-align:center;position:relative}.menusWrapper[_ngcontent-%COMP%]   .menus[_ngcontent-%COMP%]:after{position:absolute;width:1px;height:30px;background-color:#9f9f9fa1;opacity:.5;right:0;top:60px;content:\"\"}.menusWrapper[_ngcontent-%COMP%]   .menus[_ngcontent-%COMP%]:nth-of-type(5):after, .menusWrapper[_ngcontent-%COMP%]   .menus[_ngcontent-%COMP%]:nth-last-child(2):after{display:none}.menusWrapper[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]:nth-child(5n+1) > .overAggSeparator[_ngcontent-%COMP%]{display:none}.menusWrapper[_ngcontent-%COMP%]   .legend[_ngcontent-%COMP%]   .count[_ngcontent-%COMP%]{font-size:22px;font-family:ciscoSans}.menusWrapper[_ngcontent-%COMP%]   .legend[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{word-break:break-word;min-width:120px;display:block;font-size:12px;font-family:ciscoSans;padding-top:5px 0px}#menu-clicks[_ngcontent-%COMP%]   .more_wrapper[_ngcontent-%COMP%], #profile-rule-tags[_ngcontent-%COMP%]   .more_wrapper[_ngcontent-%COMP%], #user-profile[_ngcontent-%COMP%]   .more_wrapper[_ngcontent-%COMP%], #visitors_tags[_ngcontent-%COMP%]   .more_wrapper[_ngcontent-%COMP%], .customer-dist-left[_ngcontent-%COMP%]   .more_wrapper[_ngcontent-%COMP%]{width:100%;text-align:center;padding-top:20px;padding-bottom:5px}#menu-clicks[_ngcontent-%COMP%]   .more_tags[_ngcontent-%COMP%], #eng-promo-offers-performance[_ngcontent-%COMP%]   .more_tags[_ngcontent-%COMP%], #profile-rule-tags[_ngcontent-%COMP%]   .more_tags[_ngcontent-%COMP%], #user-profile[_ngcontent-%COMP%]   .more_tags[_ngcontent-%COMP%], #visitors_tags[_ngcontent-%COMP%]   .more_tags[_ngcontent-%COMP%]{font-family:ciscoSansLight;font-size:12px;color:#6a6b6c;text-align:center;display:inline-block;padding:8px 30px;border:1px solid #c4c4c4;border-radius:20px}#user-profile[_ngcontent-%COMP%]   .more_tags[_ngcontent-%COMP%]{color:#049fd9;border:1px solid #049FD9;border-radius:10px}.reportLocHierarchy[_ngcontent-%COMP%]{height:auto!important;max-height:400px!important;overflow-y:auto;padding:0}.dwell-left[_ngcontent-%COMP%]{float:left;width:49%;margin-right:9px}.visit-right[_ngcontent-%COMP%]{float:left;width:49%;margin-left:9px}.count-details[_ngcontent-%COMP%]{padding-bottom:10px;text-align:center}.count[_ngcontent-%COMP%]{font-size:22px;color:#000;font-family:ciscoSans;font-weight:300}.caption[_ngcontent-%COMP%]{font-size:12px;color:#000;font-family:CiscoSans;letter-spacing:.43px}.underline[_ngcontent-%COMP%]{text-decoration:underline}#daily-engagements[_ngcontent-%COMP%]   .overall_wrapper[_ngcontent-%COMP%], #tagging-trends[_ngcontent-%COMP%]   .overall_wrapper[_ngcontent-%COMP%]{text-align:center;width:100%}#daily-engagements[_ngcontent-%COMP%]   .overall_data[_ngcontent-%COMP%], #tagging-trends[_ngcontent-%COMP%]   .overall_data[_ngcontent-%COMP%]{display:inline-block;text-align:center;padding:10px 30px}#daily-engagements[_ngcontent-%COMP%]   .overall_data[_ngcontent-%COMP%]   .count[_ngcontent-%COMP%], #tagging-trends[_ngcontent-%COMP%]   .overall_data[_ngcontent-%COMP%]   .count[_ngcontent-%COMP%]{font-size:30px;padding-top:5px;font-family:CiscoSans;color:#000}#daily-engagements[_ngcontent-%COMP%]   .overall_data[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%], #tagging-trends[_ngcontent-%COMP%]   .overall_data[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{font-size:12px;color:#000;padding-top:5px;letter-spacing:.43px}.equals[_ngcontent-%COMP%], .plus[_ngcontent-%COMP%], .cross[_ngcontent-%COMP%]{position:relative;text-align:center}.equals[_ngcontent-%COMP%]:before, .plus[_ngcontent-%COMP%]:before, .cross[_ngcontent-%COMP%]:before{position:absolute;right:95%;top:50%;transform:translateY(-50%);width:20px;height:20px;color:#414f5f;background-color:transparent;font-family:\"icomoon-new\"}.equals[_ngcontent-%COMP%]:before{font-size:18px;content:\"\\e910\"}.plus[_ngcontent-%COMP%]:before{font-size:12px;content:\"\\e913\"}.cross[_ngcontent-%COMP%]:before{font-size:12px;content:\"\\e909\"}.hover[_ngcontent-%COMP%]{position:relative}.toolTip[_ngcontent-%COMP%]   .textRight[_ngcontent-%COMP%]{float:right;font-family:ciscoSansBold;font-size:13px;color:#fff}.toolTip[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:11px;color:#fff}.toolTip[_ngcontent-%COMP%]{position:absolute;color:#fff;right:calc(100% + 20px);top:50%;transform:translateY(-50%);width:auto;height:auto;min-width:240px;background-color:#000000e6;padding:10px;display:none;font-size:14px;border-radius:4px}.toolTip[_ngcontent-%COMP%]:after{position:absolute;left:100%;top:50%;transform:translateY(-50%);width:0;height:0;border-top:10px solid transparent;border-bottom:10px solid transparent;border-left:10px solid rgba(0,0,0,.9);content:\"\"}.hover[_ngcontent-%COMP%]:hover   .toolTip[_ngcontent-%COMP%]{display:block}.toolTipHeading[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;color:#fff;padding-bottom:5px;text-align:center}.list[_ngcontent-%COMP%]{padding:4px 0}.beta_desc[_ngcontent-%COMP%]{padding:10px;background-color:#fffde9;color:#000;font-size:12px;font-family:ciscoSansRegular}[_nghost-%COMP%]     .xAxisLabels, [_nghost-%COMP%]     .yAxisLabels{fill:#1d3243;color:#1d3243;font-size:10px;font-family:CiscoSans}#real-time-wrapper[_ngcontent-%COMP%]{font-family:ciscoSansRegular}#real-time-wrapper[_ngcontent-%COMP%]   .robotoLight[_ngcontent-%COMP%]{font-family:ciscoSansLight}#real-time-wrapper[_ngcontent-%COMP%]   .robotoMedium[_ngcontent-%COMP%]{font-family:ciscoSansRegular}#real-time-wrapper[_ngcontent-%COMP%]   .robotoBold[_ngcontent-%COMP%]{font-family:ciscoSansBold}[_nghost-%COMP%]     google-new-map #loc-map-info-window .popup_location_path{font-size:10px;color:#dddfe2}[_nghost-%COMP%]     google-new-map #loc-map-info-window .popup_location_path_details span:nth-child(even){padding:0 5px}[_nghost-%COMP%]     google-new-map #loc-map-info-window .popup_details{padding-bottom:10px;border-bottom:1px solid #979797}[_nghost-%COMP%]     google-new-map #loc-map-info-window .popup_data{font-size:19px;float:left;color:#fff}[_nghost-%COMP%]     google-new-map #loc-map-info-window .popup_desc{font-size:13px;float:left;padding-left:10px;color:#fff;width:auto}[_nghost-%COMP%]     google-new-map #loc-map-info-window .popup_location_name{font-size:13px;color:#dddfe2}[_nghost-%COMP%]     google-new-map #loc-map-info-window .popup_visitors_details{padding-top:5px}[_nghost-%COMP%]     google-new-map #loc-map-info-window .popup_visitors_seperate{white-space:nowrap;width:46%}[_nghost-%COMP%]     google-new-map #loc-map-info-window .popup_new_visitors_text{font-size:13px;color:#dddfe2;padding-left:3px}[_nghost-%COMP%]     google-new-map #loc-map-info-window .popup_new_visitors_data{font-size:13px;color:#dddfe2}[_nghost-%COMP%]     google-new-map #loc-map-info-window .popup_separator{width:1%;height:15px;margin-top:5px;border-right:1px solid #979797}[_nghost-%COMP%]     google-new-map #loc-map-info-window .popup_visitors_seperate.left{width:43%}[_nghost-%COMP%]     google-new-map #loc-map-info-window .popup_visitors_seperate.right{width:46%}[_nghost-%COMP%]     google-new-map #loc-map-info-window .map_cluster_header_text{font-size:13px;color:#fff}[_nghost-%COMP%]     google-new-map #loc-map-info-window .map_cluser_number{font-size:19px;color:#fff}.cal-month-view[_ngcontent-%COMP%]   .cal-header[_ngcontent-%COMP%]{text-align:center;font-weight:bolder}.cal-month-view[_ngcontent-%COMP%]   .cal-header[_ngcontent-%COMP%]   .cal-cell[_ngcontent-%COMP%]{padding:5px 0;overflow:hidden;text-overflow:ellipsis;display:block;white-space:nowrap}.cal-month-view[_ngcontent-%COMP%]   .cal-days[_ngcontent-%COMP%]{border:solid 1px;border-bottom:0}.cal-month-view[_ngcontent-%COMP%]   .cal-cell-top[_ngcontent-%COMP%]{min-height:78px;flex:1}.cal-month-view[_ngcontent-%COMP%]   .cal-cell-row[_ngcontent-%COMP%]{display:flex}.cal-month-view[_ngcontent-%COMP%]   .cal-cell[_ngcontent-%COMP%]{float:left;flex:1;display:flex;flex-direction:column;align-items:stretch}.cal-month-view[_ngcontent-%COMP%]   .cal-cell[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%]{pointer-events:all!important}.cal-month-view[_ngcontent-%COMP%]   .cal-day-cell[_ngcontent-%COMP%]{min-height:100px}@media all{.cal-month-view[_ngcontent-%COMP%]   .cal-day-cell[_ngcontent-%COMP%]{display:block}}.cal-month-view[_ngcontent-%COMP%]   .cal-day-cell[_ngcontent-%COMP%]:not(:last-child){border-right:1px solid}.cal-month-view[_ngcontent-%COMP%]   .cal-days[_ngcontent-%COMP%]   .cal-cell-row[_ngcontent-%COMP%]{border-bottom:1px solid}.cal-month-view[_ngcontent-%COMP%]   .cal-day-badge[_ngcontent-%COMP%]{margin-top:18px;margin-left:10px;display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:middle;border-radius:10px}.cal-month-view[_ngcontent-%COMP%]   .cal-day-number[_ngcontent-%COMP%]{font-size:1.2em;font-weight:400;opacity:.5;margin-top:15px;margin-right:15px;float:right;margin-bottom:10px}.cal-month-view[_ngcontent-%COMP%]   .cal-events[_ngcontent-%COMP%]{flex:1;align-items:flex-end;margin:3px;line-height:10px;display:flex;flex-wrap:wrap}.cal-month-view[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%]{width:10px;height:10px;border-radius:50%;display:inline-block;margin:2px}.cal-month-view[_ngcontent-%COMP%]   .cal-day-cell.cal-in-month.cal-has-events[_ngcontent-%COMP%]{cursor:pointer}.cal-month-view[_ngcontent-%COMP%]   .cal-day-cell.cal-out-month[_ngcontent-%COMP%]   .cal-day-number[_ngcontent-%COMP%]{opacity:.1;cursor:default}.cal-month-view[_ngcontent-%COMP%]   .cal-day-cell.cal-today[_ngcontent-%COMP%]   .cal-day-number[_ngcontent-%COMP%]{font-size:1.9em}.cal-month-view[_ngcontent-%COMP%]   .cal-open-day-events[_ngcontent-%COMP%]{padding:15px}.cal-month-view[_ngcontent-%COMP%]   .cal-open-day-events[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%]{position:relative;top:2px}.cal-month-view[_ngcontent-%COMP%]   .cal-out-month[_ngcontent-%COMP%]   .cal-day-badge[_ngcontent-%COMP%], .cal-month-view[_ngcontent-%COMP%]   .cal-out-month[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%]{opacity:.3}.cal-month-view[_ngcontent-%COMP%]   .cal-draggable[_ngcontent-%COMP%]{cursor:move}.cal-month-view[_ngcontent-%COMP%]   .cal-drag-active[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{pointer-events:none}.cal-month-view[_ngcontent-%COMP%]   .cal-event-title[_ngcontent-%COMP%]{cursor:pointer}.cal-month-view[_ngcontent-%COMP%]   .cal-event-title[_ngcontent-%COMP%]:hover{text-decoration:underline}.cal-month-view[_ngcontent-%COMP%]{background-color:#fff}.cal-month-view[_ngcontent-%COMP%]   .cal-cell-row[_ngcontent-%COMP%]:hover{background-color:#fafafa}.cal-month-view[_ngcontent-%COMP%]   .cal-cell-row[_ngcontent-%COMP%]   .cal-cell[_ngcontent-%COMP%]:hover, .cal-month-view[_ngcontent-%COMP%]   .cal-cell.cal-has-events.cal-open[_ngcontent-%COMP%]{background-color:#ededed}.cal-month-view[_ngcontent-%COMP%]   .cal-days[_ngcontent-%COMP%]{border-color:#e1e1e1}.cal-month-view[_ngcontent-%COMP%]   .cal-day-cell[_ngcontent-%COMP%]:not(:last-child){border-right-color:#e1e1e1}.cal-month-view[_ngcontent-%COMP%]   .cal-days[_ngcontent-%COMP%]   .cal-cell-row[_ngcontent-%COMP%]{border-bottom-color:#e1e1e1}.cal-month-view[_ngcontent-%COMP%]   .cal-day-badge[_ngcontent-%COMP%]{background-color:#b94a48;color:#fff}.cal-month-view[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%]{background-color:#1e90ff;border-color:#d1e8ff;color:#fff}.cal-month-view[_ngcontent-%COMP%]   .cal-day-cell.cal-weekend[_ngcontent-%COMP%]   .cal-day-number[_ngcontent-%COMP%]{color:#8b0000}.cal-month-view[_ngcontent-%COMP%]   .cal-day-cell.cal-today[_ngcontent-%COMP%]{background-color:#e8fde7}.cal-month-view[_ngcontent-%COMP%]   .cal-day-cell.cal-drag-over[_ngcontent-%COMP%]{background-color:#e0e0e0!important}.cal-month-view[_ngcontent-%COMP%]   .cal-open-day-events[_ngcontent-%COMP%]{color:#fff;background-color:#555;box-shadow:0 0 15px #00000080 inset}.cal-week-view[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{box-sizing:border-box}.cal-week-view[_ngcontent-%COMP%]   .cal-day-headers[_ngcontent-%COMP%]{display:flex;padding-left:70px;border:solid 1px}.cal-week-view[_ngcontent-%COMP%]   .cal-day-headers[_ngcontent-%COMP%]   .cal-header[_ngcontent-%COMP%]{flex:1;text-align:center;padding:5px}.cal-week-view[_ngcontent-%COMP%]   .cal-day-headers[_ngcontent-%COMP%]   .cal-header[_ngcontent-%COMP%]:not(:last-child){border-right:1px solid}.cal-week-view[_ngcontent-%COMP%]   .cal-day-headers[_ngcontent-%COMP%]   .cal-header[_ngcontent-%COMP%]:first-child{border-left:1px solid}.cal-week-view[_ngcontent-%COMP%]   .cal-day-headers[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:400;opacity:.5}.cal-week-view[_ngcontent-%COMP%]   .cal-day-column[_ngcontent-%COMP%]{flex-grow:1;border-left:1px solid}.cal-week-view[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%]{font-size:12px;border:solid 1px}.cal-week-view[_ngcontent-%COMP%]   .cal-time-label-column[_ngcontent-%COMP%]{width:70px;height:100%}.cal-week-view[_ngcontent-%COMP%]   .cal-current-time-marker[_ngcontent-%COMP%]{position:absolute;width:100%;height:2px;z-index:2}.cal-week-view[_ngcontent-%COMP%]   .cal-all-day-events[_ngcontent-%COMP%]{border:solid 1px;border-top:0;border-bottom-width:3px;padding-top:3px;position:relative}.cal-week-view[_ngcontent-%COMP%]   .cal-all-day-events[_ngcontent-%COMP%]   .cal-day-columns[_ngcontent-%COMP%]{height:100%;width:100%;display:flex;position:absolute;top:0;z-index:0}.cal-week-view[_ngcontent-%COMP%]   .cal-all-day-events[_ngcontent-%COMP%]   .cal-events-row[_ngcontent-%COMP%]{position:relative;height:31px;margin-left:70px}.cal-week-view[_ngcontent-%COMP%]   .cal-all-day-events[_ngcontent-%COMP%]   .cal-event-container[_ngcontent-%COMP%]{display:inline-block;position:absolute}.cal-week-view[_ngcontent-%COMP%]   .cal-all-day-events[_ngcontent-%COMP%]   .cal-event-container.resize-active[_ngcontent-%COMP%]{z-index:1;pointer-events:none}.cal-week-view[_ngcontent-%COMP%]   .cal-all-day-events[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%]{padding:0 5px;margin-left:2px;margin-right:2px;height:28px;line-height:28px}.cal-week-view[_ngcontent-%COMP%]   .cal-all-day-events[_ngcontent-%COMP%]   .cal-starts-within-week[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%]{border-top-left-radius:5px;border-bottom-left-radius:5px}.cal-week-view[_ngcontent-%COMP%]   .cal-all-day-events[_ngcontent-%COMP%]   .cal-ends-within-week[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%]{border-top-right-radius:5px;border-bottom-right-radius:5px}.cal-week-view[_ngcontent-%COMP%]   .cal-all-day-events[_ngcontent-%COMP%]   .cal-time-label-column[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;font-size:14px}.cal-week-view[_ngcontent-%COMP%]   .cal-all-day-events[_ngcontent-%COMP%]   .cal-resize-handle[_ngcontent-%COMP%]{width:6px;height:100%;cursor:col-resize;position:absolute;top:0}.cal-week-view[_ngcontent-%COMP%]   .cal-all-day-events[_ngcontent-%COMP%]   .cal-resize-handle.cal-resize-handle-after-end[_ngcontent-%COMP%]{right:0}.cal-week-view[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%], .cal-week-view[_ngcontent-%COMP%]   .cal-header[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cal-week-view[_ngcontent-%COMP%]   .cal-drag-active[_ngcontent-%COMP%]{pointer-events:none;z-index:1}.cal-week-view[_ngcontent-%COMP%]   .cal-drag-active[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{pointer-events:none}.cal-week-view[_ngcontent-%COMP%]   .cal-time-events[_ngcontent-%COMP%]{position:relative;border:solid 1px;border-top:0;display:flex}.cal-week-view[_ngcontent-%COMP%]   .cal-time-events[_ngcontent-%COMP%]   .cal-day-columns[_ngcontent-%COMP%]{display:flex;flex-grow:1}.cal-week-view[_ngcontent-%COMP%]   .cal-time-events[_ngcontent-%COMP%]   .cal-day-column[_ngcontent-%COMP%]{position:relative}.cal-week-view[_ngcontent-%COMP%]   .cal-time-events[_ngcontent-%COMP%]   .cal-events-container[_ngcontent-%COMP%]{position:relative}.cal-week-view[_ngcontent-%COMP%]   .cal-time-events[_ngcontent-%COMP%]   .cal-event-container[_ngcontent-%COMP%]{position:absolute;z-index:1}.cal-week-view[_ngcontent-%COMP%]   .cal-time-events[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%]{width:calc(100% - 2px);height:calc(100% - 2px);margin:1px;padding:0 5px;line-height:25px}.cal-week-view[_ngcontent-%COMP%]   .cal-time-events[_ngcontent-%COMP%]   .cal-resize-handle[_ngcontent-%COMP%]{width:100%;height:4px;cursor:row-resize;position:absolute}.cal-week-view[_ngcontent-%COMP%]   .cal-time-events[_ngcontent-%COMP%]   .cal-resize-handle.cal-resize-handle-after-end[_ngcontent-%COMP%]{bottom:0}.cal-week-view[_ngcontent-%COMP%]   .cal-hour-segment[_ngcontent-%COMP%]{position:relative}.cal-week-view[_ngcontent-%COMP%]   .cal-hour-segment[_ngcontent-%COMP%]:after{content:\"\\a0\"}.cal-week-view[_ngcontent-%COMP%]   .cal-event-container[_ngcontent-%COMP%]:not(.cal-draggable){cursor:pointer}.cal-week-view[_ngcontent-%COMP%]   .cal-draggable[_ngcontent-%COMP%]{cursor:move}.cal-week-view[_ngcontent-%COMP%]   mwl-calendar-week-view-hour-segment[_ngcontent-%COMP%], .cal-week-view[_ngcontent-%COMP%]   .cal-hour-segment[_ngcontent-%COMP%]{display:block}.cal-week-view[_ngcontent-%COMP%]   .cal-hour[_ngcontent-%COMP%]:not(:last-child)   .cal-hour-segment[_ngcontent-%COMP%], .cal-week-view[_ngcontent-%COMP%]   .cal-hour[_ngcontent-%COMP%]:last-child   [_ngcontent-%COMP%]:not(:last-child)   .cal-hour-segment[_ngcontent-%COMP%]{border-bottom:thin dashed}.cal-week-view[_ngcontent-%COMP%]   .cal-time[_ngcontent-%COMP%]{font-weight:bold;padding-top:5px;width:70px;text-align:center}.cal-week-view[_ngcontent-%COMP%]   .cal-hour-segment.cal-after-hour-start[_ngcontent-%COMP%]   .cal-time[_ngcontent-%COMP%]{display:none}.cal-week-view[_ngcontent-%COMP%]   .cal-starts-within-day[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%]{border-top-left-radius:5px;border-top-right-radius:5px}.cal-week-view[_ngcontent-%COMP%]   .cal-ends-within-day[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%]{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.cal-week-view[_ngcontent-%COMP%]{background-color:#fff;border-top:1px solid #e1e1e1}.cal-week-view[_ngcontent-%COMP%]   .cal-day-headers[_ngcontent-%COMP%]{border-color:#e1e1e1;border-top:0}.cal-week-view[_ngcontent-%COMP%]   .cal-day-headers[_ngcontent-%COMP%]   .cal-header[_ngcontent-%COMP%]:not(:last-child){border-right-color:#e1e1e1}.cal-week-view[_ngcontent-%COMP%]   .cal-day-headers[_ngcontent-%COMP%]   .cal-header[_ngcontent-%COMP%]:first-child{border-left-color:#e1e1e1}.cal-week-view[_ngcontent-%COMP%]   .cal-day-headers[_ngcontent-%COMP%]   .cal-header[_ngcontent-%COMP%]:hover, .cal-week-view[_ngcontent-%COMP%]   .cal-day-headers[_ngcontent-%COMP%]   .cal-drag-over[_ngcontent-%COMP%]{background-color:#ededed}.cal-week-view[_ngcontent-%COMP%]   .cal-day-column[_ngcontent-%COMP%]{border-left-color:#e1e1e1}.cal-week-view[_ngcontent-%COMP%]   .cal-event[_ngcontent-%COMP%]{background-color:#d1e8ff;border-color:#1e90ff;color:#1e90ff}.cal-week-view[_ngcontent-%COMP%]   .cal-all-day-events[_ngcontent-%COMP%]{border-color:#e1e1e1}.cal-week-view[_ngcontent-%COMP%]   .cal-header.cal-today[_ngcontent-%COMP%]{background-color:#e8fde7}.cal-week-view[_ngcontent-%COMP%]   .cal-header.cal-weekend[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#8b0000}.cal-week-view[_ngcontent-%COMP%]   .cal-time-events[_ngcontent-%COMP%]{border-color:#e1e1e1}.cal-week-view[_ngcontent-%COMP%]   .cal-time-events[_ngcontent-%COMP%]   .cal-day-columns[_ngcontent-%COMP%]:not(.cal-resize-active)   .cal-hour-segment[_ngcontent-%COMP%]:hover{background-color:#ededed}.cal-week-view[_ngcontent-%COMP%]   .cal-hour-odd[_ngcontent-%COMP%]{background-color:#fafafa}.cal-week-view[_ngcontent-%COMP%]   .cal-drag-over[_ngcontent-%COMP%]   .cal-hour-segment[_ngcontent-%COMP%]{background-color:#ededed}.cal-week-view[_ngcontent-%COMP%]   .cal-hour[_ngcontent-%COMP%]:not(:last-child)   .cal-hour-segment[_ngcontent-%COMP%], .cal-week-view[_ngcontent-%COMP%]   .cal-hour[_ngcontent-%COMP%]:last-child   [_ngcontent-%COMP%]:not(:last-child)   .cal-hour-segment[_ngcontent-%COMP%]{border-bottom-color:#e1e1e1}.cal-week-view[_ngcontent-%COMP%]   .cal-current-time-marker[_ngcontent-%COMP%]{background-color:#ea4334}.cal-day-view[_ngcontent-%COMP%]   mwl-calendar-week-view-header[_ngcontent-%COMP%]{display:none}.cal-day-view[_ngcontent-%COMP%]   .cal-events-container[_ngcontent-%COMP%]{margin-left:70px}.cal-day-view[_ngcontent-%COMP%]   .cal-day-column[_ngcontent-%COMP%]{border-left:0}.cal-day-view[_ngcontent-%COMP%]   .cal-current-time-marker[_ngcontent-%COMP%]{margin-left:70px;width:calc(100% - 70px)}.cal-tooltip[_ngcontent-%COMP%]{position:absolute;z-index:1070;display:block;font-style:normal;font-weight:normal;letter-spacing:normal;line-break:auto;line-height:1.5;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;font-size:11px;overflow-wrap:break-word;opacity:.9}.cal-tooltip.cal-tooltip-top[_ngcontent-%COMP%]{padding:5px 0;margin-top:-3px}.cal-tooltip.cal-tooltip-top[_ngcontent-%COMP%]   .cal-tooltip-arrow[_ngcontent-%COMP%]{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0}.cal-tooltip.cal-tooltip-right[_ngcontent-%COMP%]{padding:0 5px;margin-left:3px}.cal-tooltip.cal-tooltip-right[_ngcontent-%COMP%]   .cal-tooltip-arrow[_ngcontent-%COMP%]{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0}.cal-tooltip.cal-tooltip-bottom[_ngcontent-%COMP%]{padding:5px 0;margin-top:3px}.cal-tooltip.cal-tooltip-bottom[_ngcontent-%COMP%]   .cal-tooltip-arrow[_ngcontent-%COMP%]{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px}.cal-tooltip.cal-tooltip-left[_ngcontent-%COMP%]{padding:0 5px;margin-left:-3px}.cal-tooltip.cal-tooltip-left[_ngcontent-%COMP%]   .cal-tooltip-arrow[_ngcontent-%COMP%]{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px}.cal-tooltip-inner[_ngcontent-%COMP%]{max-width:200px;padding:3px 8px;text-align:center;border-radius:.25rem}.cal-tooltip-arrow[_ngcontent-%COMP%]{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.cal-tooltip.cal-tooltip-top[_ngcontent-%COMP%]   .cal-tooltip-arrow[_ngcontent-%COMP%]{border-top-color:#000}.cal-tooltip.cal-tooltip-right[_ngcontent-%COMP%]   .cal-tooltip-arrow[_ngcontent-%COMP%]{border-right-color:#000}.cal-tooltip.cal-tooltip-bottom[_ngcontent-%COMP%]   .cal-tooltip-arrow[_ngcontent-%COMP%]{border-bottom-color:#000}.cal-tooltip.cal-tooltip-left[_ngcontent-%COMP%]   .cal-tooltip-arrow[_ngcontent-%COMP%]{border-left-color:#000}.cal-tooltip-inner[_ngcontent-%COMP%]{color:#fff;background-color:#000}[_nghost-%COMP%]     google-map #loc-map-info-window .popup_desc{font-size:13px;float:left;padding-left:10px;padding-right:10px;color:#fff;width:100%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportFilterComponent, [{
        type: Component,
        args: [{
                selector: "lib-report-filter",
                templateUrl: "./report-filter.component.html",
                styleUrls: [
                    "./report-filter.component.css",
                    "../../common/report.shared.style.css"
                ]
            }]
    }], function () { return [{ type: LoggerService }, { type: DataService }, { type: i2.TranslateService }]; }, { dateApplied: [{
            type: Output
        }], locationApplied: [{
            type: Output
        }], isShowLocationFilter: [{
            type: Input
        }], isShowDateFilter: [{
            type: Input
        }], multiLocationSelect: [{
            type: Input
        }], showReportName: [{
            type: Input
        }], setOverallReportCount: [{
            type: Input
        }], setPrefiledLocation: [{
            type: Input
        }], setData: [{
            type: Input
        }] }); })();

function ReportHeaderComponent_span_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, ">");
    i0.ɵɵelementEnd();
} }
function ReportHeaderComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, ReportHeaderComponent_span_4_span_2_Template, 2, 0, "span", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const breadCrumb_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", breadCrumb_r3.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r4 < ctx_r0.breadCrumbs.length - 1);
} }
function ReportHeaderComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Beta");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ReportHeaderComponent_img_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 16);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r2.imageUrl, i0.ɵɵsanitizeUrl);
} }
class ReportHeaderComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
    }
    ngOnInit() {
        //this.currentNav.label = "Report";
        this.dataService
            .getReportsHeader(this.unsubscribe$)
            .subscribe((val) => {
            //console.log("ngOnInit Report Header ::: ",val);
            this.setReportsHeader(val);
        });
    }
    setReportsHeader(value) {
        if (!value)
            return;
        this.breadCrumbs = value.breadCrumb;
        this.count = value.count;
        this.description = value.description;
        this.imageUrl = value.image;
        this.isBeta = value.isBeta;
    }
    ngOnDestroy() {
        console.log("destory Report Header page");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
ReportHeaderComponent.ɵfac = function ReportHeaderComponent_Factory(t) { return new (t || ReportHeaderComponent)(i0.ɵɵdirectiveInject(DataService)); };
ReportHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportHeaderComponent, selectors: [["lib-app-report-header"]], inputs: { currentNav: "currentNav" }, decls: 15, vars: 5, consts: [[1, "header"], [1, "top-container"], [1, "left"], [1, "pageHeaderLabel"], ["class", "currentHeading", 4, "ngFor", "ngForOf"], ["class", "beta", 4, "ngIf"], [1, "right"], [1, "count"], [3, "src", 4, "ngIf"], [2, "padding-left", "3px"], [1, "description"], [1, "clear"], [1, "bottom-container"], [1, "currentHeading"], [4, "ngIf"], [1, "beta"], [3, "src"]], template: function ReportHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵtemplate(4, ReportHeaderComponent_span_4_Template, 3, 2, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, ReportHeaderComponent_span_5_Template, 3, 0, "span", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵtemplate(8, ReportHeaderComponent_img_8_Template, 1, 1, "img", 8);
        i0.ɵɵelementStart(9, "span", 9);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 10);
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(13, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "div", 12);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.breadCrumbs);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isBeta);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.imageUrl);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.count);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.description);
    } }, directives: [i1$2.NgForOf, i1$2.NgIf], styles: [".header[_ngcontent-%COMP%]{display:block;padding:14px;background-color:#fff;height:72px;margin-bottom:1px;box-shadow:0 2px 5px -1px #1414141a}.header.dashboardHeader[_ngcontent-%COMP%]{padding:14px}.showFullPage[_ngcontent-%COMP%]   .header.dashboardHeader[_ngcontent-%COMP%]{padding:14px 100px!important}.pageHeaderLabel[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";color:#000;font-weight:500;font-size:18px;padding:6px 0 8px;display:inline-block}.showFullPage[_ngcontent-%COMP%]   .pageHeaderLabel[_ngcontent-%COMP%]{padding:6px 0 8px}.pageHeadingLink[_ngcontent-%COMP%]{color:#6a6b6c;font-weight:normal;font-size:16px;font-family:\"ciscoSansLight\"}.breadCrumbSeparator[_ngcontent-%COMP%]{color:#abacac99;padding:0 5px;font-family:\"icomoon-new\";font-weight:normal;font-size:14px;vertical-align:middle}.currentHeading[_ngcontent-%COMP%]{font-size:18px;line-height:30px;color:#000;vertical-align:middle;font-family:\"ciscoSansRegular\"}.count[_ngcontent-%COMP%]{text-align:right;font-family:ciscoSansBold;font-size:30px;color:#414f5f}.description[_ngcontent-%COMP%]{text-align:right;font-family:ciscoSansLight;font-size:12px;color:#6a6b6c}.beta[_ngcontent-%COMP%]{margin-left:5px;padding:1px 10px;background-color:#059fd9;color:#fff;display:inline-block;font-size:12px;font-family:ciscoSansLight;border-radius:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportHeaderComponent, [{
        type: Component,
        args: [{
                selector: "lib-app-report-header",
                templateUrl: "./report-header.component.html",
                styleUrls: ["./report-header.component.css"]
            }]
    }], function () { return [{ type: DataService }]; }, { currentNav: [{
            type: Input
        }] }); })();

function ReportLocationTreeComponent_ng_template_2_lib_row_menu_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-row-menu", 8);
} if (rf & 2) {
    const node_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("node", node_r7);
} }
const _c0$g = function (a0) { return { "row-hover": a0 }; };
function ReportLocationTreeComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "tree-node-wrapper", 5);
    i0.ɵɵtemplate(2, ReportLocationTreeComponent_ng_template_2_lib_row_menu_2_Template, 1, 1, "lib-row-menu", 6);
    i0.ɵɵelement(3, "tree-node-children", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r7 = ctx.$implicit;
    const index_r8 = ctx.index;
    const templates_r9 = ctx.templates;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2.getClass(node_r7));
    i0.ɵɵclassProp("tree-node", true)("tree-node-expanded", node_r7.isExpanded && node_r7.hasChildren)("tree-node-collapsed", node_r7.isCollapsed && node_r7.hasChildren)("tree-node-leaf", node_r7.isLeaf)("tree-node-active", node_r7.isActive)("tree-node-focused", node_r7.isFocused);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleMap(ctx_r2.getPadding(node_r7, ctx_r2.isPopup));
    i0.ɵɵproperty("node", node_r7)("index", index_r8)("templates", templates_r9)("ngClass", i0.ɵɵpureFunction1(24, _c0$g, node_r7.data.showMenu));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r7.data.showMenu);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("node", ctx_r2.sortChildren(node_r7))("templates", templates_r9);
} }
function ReportLocationTreeComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "Loading, please hold....");
} }
function ReportLocationTreeComponent_ng_template_6_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵelement(1, "span", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r12.apsMatched, i0.ɵɵsanitizeHtml);
} }
const _c1$7 = function (a0) { return { "highlightLocation": a0 }; };
function ReportLocationTreeComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "a", 10);
    i0.ɵɵelement(2, "span", 11);
    i0.ɵɵelementStart(3, "span", 12);
    i0.ɵɵlistener("click", function ReportLocationTreeComponent_ng_template_6_Template_span_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const node_r12 = restoredCtx.$implicit; const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.clickedLocation(node_r12.data); });
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ReportLocationTreeComponent_ng_template_6_span_5_Template, 2, 1, "span", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 14);
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵelement(8, "span", 15);
    i0.ɵɵpipe(9, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r12 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 4, node_r12.data.name), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(8, _c1$7, ctx_r6.reportType === "REAL_TIME"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r12.apsMatched);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(9, 6, ctx_r6.calculateCount(node_r12.data)), i0.ɵɵsanitizeHtml);
} }
class ReportLocationTreeComponent extends ManageLocationTreeComponent {
    constructor(router_, dataService_, locationService_, cdRef_) {
        super(router_, dataService_, locationService_, cdRef_);
        this.router_ = router_;
        this.dataService_ = dataService_;
        this.locationService_ = locationService_;
        this.cdRef_ = cdRef_;
        this.rootLocationObj = {};
        this.selectedLocation = [];
        /*popoverHtml(locObj: any) {
            if (this.reportType == "REAL_TIME") {
                return "<span>Heading</span>";
                // return  "<div class='popup_visitors_details'>"
                //           +"<div class='left popup_visitors_seperate'>"
                //             + "<span class='popup_new_visitors_text'>New Visitors:</span>"
                //             + "<span class='popup_new_visitors_data numberBoldFont'>"+"559"+"</span>"
                //           +"</div>"
                //           +"<div class='left popup_separator'></div>"
                //           +"<div class='right popup_visitors_seperate'>"
                //             +"<span class='popup_new_visitors_text'>Returning Visitors:</span>"
                //             +"<span class='popup_new_visitors_data numberBoldFont'>"+"5297"+"</span>"
                //           +"</div>"
                //           +"<div class='clear'>"
                //         +"</div>";
            }
        }*/
        this.onEvent = ($event) => {
            // console.log('onEvent from tree::', $event);
            switch ($event.eventName) {
                case 'initialized':
                    console.log("location loading done", new Date().getTime() - this.startTime);
                    this.isTreeInitialised = true;
                    this.treeComponent.treeModel.roots.forEach(root => {
                        this.rootLocationObj = root.data;
                        if (root.isCollapsed)
                            root.expand();
                    });
                    this.initLocationNodes();
                    break;
                case 'toggleExpanded':
                    clearTimeout(this.treeComponentTimer);
                    this.treeComponentTimer = setTimeout(() => {
                        if (this.treeComponent) {
                            this.treeComponent.sizeChanged();
                        }
                    }, 100);
                    break;
            }
        };
        this.initLocationNodes = () => {
            if (this.currentFilterLocations &&
                this.currentFilterLocations.length > 0) {
                this.filterLocationIds(this.currentFilterLocations);
            }
            else {
                this.location = this.locationOrginal;
                setTimeout(() => {
                    if (this.isTreeInitialised && this.treeComponent) {
                        this.treeComponent.treeModel.update();
                        this.treeComponent.treeModel.roots.forEach((root) => {
                            root.expand();
                        });
                        this.treeComponent.sizeChanged();
                    }
                }, 200);
            }
            // this.prevFilterLocations = this.currentFilterLocations;
        };
        this.sortChildren = (node) => {
            if (this.filteredLocationCount < 10000) {
                //  console.log(">>>>>>>>>>>>>>>>>>>>>>>>>   " +  node.data.children  + " >>>>>>>>>     " + this.locationCountMap)
                if (this.reportType == "REAL_TIME" && this.locationCountMap && Object.keys(this.locationCountMap).length > 0) {
                    //   console.log("#########################  inside if   " +  node.data.children  + " >>>>>>>>>     " + this.locationCountMap)
                    if (node.data.children) {
                        node.data.children.sort((a, b) => {
                            let aLocCount = this.locationCountMap["Loc-" + a.id] ? this.locationCountMap["Loc-" + a.id][4] : 0;
                            let bLocCount = this.locationCountMap["Loc-" + b.id] ? this.locationCountMap["Loc-" + b.id][4] : 0;
                            if (aLocCount > bLocCount)
                                return -1;
                            if (aLocCount < bLocCount)
                                return 1;
                            return 0;
                        });
                        // if (this.filteredLocationCount < 10000) {
                        node.data.children.forEach(child => {
                            this.sortTillLastChild(child);
                        });
                        // }
                    }
                }
            }
            return node;
        };
        this.sortTillLastChild = (children) => {
            if (children) {
                if (children.children && this.filteredLocationCount < 10000) {
                    children.children.sort((a, b) => {
                        const aLocCount = this.locationCountMap["Loc-" + a.id]
                            ? this.locationCountMap["Loc-" + a.id][4]
                            : 0;
                        const bLocCount = this.locationCountMap["Loc-" + b.id]
                            ? this.locationCountMap["Loc-" + b.id][4]
                            : 0;
                        if (aLocCount > bLocCount)
                            return -1;
                        if (aLocCount < bLocCount)
                            return 1;
                        return 0;
                    });
                    children.children.forEach((child) => {
                        this.sortTillLastChild(child);
                    });
                }
            }
            return;
        };
        this.clickedLocation = (data) => {
            if (this.reportType == "REAL_TIME") {
                const spacesObj = JSON.parse(sessionStorage.getItem("spacesObj") || "{}");
                if (data.type == "network" || data.type == "root") {
                    delete spacesObj["realtimeLocation"];
                    spacesObj["spacesLocation"] = {
                        id: data.id,
                        name: data.name,
                        type: data.type == "root" ? "all" : data.type
                    };
                }
                else {
                    spacesObj["realtimeLocation"] = { id: data.id };
                    spacesObj["spacesLocation"] = {
                        id: this.rootLocationObj["id"],
                        name: this.rootLocationObj["name"],
                        type: "all"
                    };
                }
                this.dataService.setSpacesObject(spacesObj);
            }
        };
    }
    ngOnInit() {
        this.setLocationPath = false;
        super.ngOnInit();
    }
    set filterLocations(filterLocations) {
        this.currentFilterLocations = filterLocations;
        if (this.isTreeInitialised)
            this.initLocationNodes();
    }
    set setReportType(value) {
        this.reportType = value;
    }
    set showMapView(value) {
        if (!value) {
            clearTimeout(this.treeComponentTimer);
            this.treeComponentTimer = setTimeout(() => {
                if (this.treeComponent) {
                    this.treeComponent.sizeChanged();
                }
            }, 100);
        }
    }
    set setSelectedLocation(selectedLocations) {
        //console.log('set selected location', selectedLocations);
        this.selectedLocation = selectedLocations;
        if (!selectedLocations || selectedLocations.length == 0)
            for (let id in this.selectedLocation) {
                try {
                    this.selectedLocation[id].setIsExpanded(true);
                }
                catch (e) {
                    console.log('location id not available', this.selectedLocation[id]);
                }
            }
        else {
            // setTimeout(() => {
            //     for(var i=0;i<selectedLocations.length;i++) {
            //         selectedLocations[i].setIsExpanded( false );
            //         console.log(selectedLocations[i].data.name,": expanded?:",selectedLocations[i].isExpanded, this.selectedLocation[i].isExpanded);
            //     }
            // }, 500);
            setTimeout(() => {
                for (var i = 0; i < this.selectedLocation.length; i++) {
                    try {
                        if (this.selectedLocation[i].data) {
                            var nodeF = this.treeComponent.treeModel.getNodeById(this.selectedLocation[i].data.id);
                            this.selectedLocation[i] = nodeF;
                        }
                        else {
                            this.selectedLocation[i].path.forEach(locId => {
                                const nodeF = this.treeComponent.treeModel.getNodeById(locId);
                                nodeF.focus();
                                nodeF.setIsExpanded(true);
                            });
                        }
                    }
                    catch (e) {
                        console.log('location id not available', this.selectedLocation[i]);
                    }
                    if (!this.selectedLocation[i]) {
                        this.selectedLocation.splice(i, 1);
                    }
                }
                for (var i = 0; i < this.selectedLocation.length; i++) {
                    try {
                        this.selectedLocation[i].setIsExpanded(true);
                    }
                    catch (e) {
                        console.log('location id not available');
                    }
                }
            }, 500);
        }
    }
    calculateCount(locObj) {
        if (this.reportType == "DEVICE_ONBOARDING") {
            const connToSsid = locObj.connectedToSsidCount;
            const provisionedInternet = locObj.provisionedInternetCount;
            const percentage = Math.round((provisionedInternet / connToSsid) * 100);
            return percentage.toString() + "%";
        }
        else if (this.reportType == "CUSTOMER_ACQUISITION") {
            const connToSsid = locObj.connectedToSsidCount;
            const custIdentified = locObj.customersIdentified;
            const percentage = Math.round((custIdentified / connToSsid) * 100);
            return percentage.toString() + "%";
        }
        else if (this.reportType == "VISITOR_BEHAVIOUR") {
            const visitors = locObj.visitors;
            // const visits = locObj.visits;
            return visitors.toLocaleString();
        }
        else if (this.reportType == "VISITOR_ENGAGEMENT") {
            const sms = locObj.smsCount;
            const email = locObj.emailCount;
            const pushNotification = locObj.pushNotificationCount;
            const totalCount = parseInt(sms) + parseInt(email) + parseInt(pushNotification);
            return totalCount.toLocaleString();
        }
        else if (this.reportType == "ENGAGEMENT_RULE" ||
            this.reportType == "PROFILE_RULE") {
            if (this.locationCountMap["Loc-" + locObj.id]) {
                const count = this.locationCountMap["Loc-" + locObj.id];
                // return this.locationCountMap[
                // 	"Loc-" + locObj.id
                // ].toLocaleString();
                return count.toLocaleString();
            }
        }
        else if (this.reportType == "REAL_TIME") {
            if (this.locationCountMap &&
                this.locationCountMap["Loc-" + locObj.id] && this.locationCountMap["Loc-" + locObj.id][4]) {
                const count = this.locationCountMap["Loc-" + locObj.id][4];
                return count.toLocaleString();
                // return this.locationCountMap[
                // 	"Loc-" + locObj.id
                // ][4].toLocaleString();
            }
        }
        return "0";
    }
}
ReportLocationTreeComponent.ɵfac = function ReportLocationTreeComponent_Factory(t) { return new (t || ReportLocationTreeComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
ReportLocationTreeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportLocationTreeComponent, selectors: [["lib-app-report-location-tree"]], inputs: { locationCountMap: "locationCountMap", filteredLocationCount: "filteredLocationCount", filterLocations: "filterLocations", setReportType: "setReportType", showMapView: "showMapView", setSelectedLocation: "setSelectedLocation" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 2, consts: [[3, "nodes", "options", "event", "stateChange"], ["tree", ""], ["treeNodeFullTemplate", ""], ["loadingTemplate", ""], ["treeNodeTemplate", ""], [3, "node", "index", "templates", "ngClass"], [3, "node", 4, "ngIf"], [3, "node", "templates"], [3, "node"], [1, "location-node-name"], ["href", "javascript:void(0);", 1, "location-name-icon"], [1, "loc-type-icon"], [1, "location-name", 3, "innerHTML", "ngClass", "click"], ["class", "matchedApDetails", 4, "ngIf"], [1, "right", "reportCount"], [3, "innerHTML"], [1, "matchedApDetails"]], template: function ReportLocationTreeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "tree-root", 0, 1);
        i0.ɵɵlistener("event", function ReportLocationTreeComponent_Template_tree_root_event_0_listener($event) { return ctx.onEvent($event); })("stateChange", function ReportLocationTreeComponent_Template_tree_root_stateChange_0_listener($event) { return ctx.setState($event); });
        i0.ɵɵtemplate(2, ReportLocationTreeComponent_ng_template_2_Template, 4, 26, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, ReportLocationTreeComponent_ng_template_4_Template, 1, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, ReportLocationTreeComponent_ng_template_6_Template, 10, 10, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("nodes", ctx.location)("options", ctx.options);
    } }, directives: [i4.TreeComponent, i4.TreeNodeWrapperComponent, i1$2.NgClass, i1$2.NgIf, i4.TreeNodeChildrenComponent, RowMenuComponent], pipes: [SafeHtmlPipe], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportLocationTreeComponent, [{
        type: Component,
        args: [{
                selector: "lib-app-report-location-tree",
                templateUrl: "./report-location-tree.component.html",
                styleUrls: ["./report-location-tree.component.css"]
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: LocationService }, { type: i0.ChangeDetectorRef }]; }, { locationCountMap: [{
            type: Input
        }], filteredLocationCount: [{
            type: Input
        }], filterLocations: [{
            type: Input
        }], setReportType: [{
            type: Input
        }], showMapView: [{
            type: Input
        }], setSelectedLocation: [{
            type: Input
        }] }); })();

const _c0$f = function (a0) { return { "selectedPeriod": a0 }; };
function ReportPeriodComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelement(2, "lib-month-picker", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$f, ctx_r0.isSelected("month")));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("spacesSettings", ctx_r0.spacesSettings)("tileType", ctx_r0.tile);
} }
class ReportPeriodComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        this.selectedPeriod = "month";
        this.yearData = [];
        this.monthData = [];
        this.quarterData = [];
        this.prevYearLimit = 2016;
        this.spacesObj = null;
        this.spacesPeriod = null;
        this.getReportPeriod = () => {
            this.dataService
                .getSpacesObject(this.unsubscribe$)
                .subscribe((spacesObj) => {
                if (spacesObj != null && spacesObj.spacesPeriod != null) {
                    this.spacesObj = spacesObj;
                    this.spacesPeriod = spacesObj.spacesPeriod;
                    this.selectedPeriod = this.spacesPeriod.type;
                }
            });
        };
        this.prepareYearData = (year) => {
            this.selectedYearValue = year;
            const startYear = year;
            const endYear = this.prevYearLimit;
            for (let i = startYear; endYear <= i; i--) {
                const yearObj = {
                    name: i,
                    fromDate: new Date(i, 0, 1),
                    toDate: new Date(i, 11, 1)
                };
                this.yearData.push(yearObj);
            }
            this.selectedYear = this.yearData[0];
        };
        this.prepareMonthData = () => {
            for (let i = 0; i <= 11; i++) {
                const monthNameFull = this.months[new Date(this.selectedYearValue, i, 1).getMonth()];
                const monthYear = this.firstThreeLetters(monthNameFull) +
                    " " +
                    this.selectedYearValue;
                const monthObj = {
                    name: monthYear,
                    fromDate: new Date(this.selectedYearValue, i, 1),
                    toDate: new Date(this.selectedYearValue, i, 1)
                };
                this.monthData.push(monthObj);
            }
        };
        this.prepareQuarterData = () => {
            let q1;
            let q2;
            let q3;
            let q4 = {};
            const monthIndex = this.months.indexOf(this.financialYearStart);
            q1 = {
                fromDate: new Date(this.selectedYearValue, monthIndex, 1),
                toDate: new Date(this.selectedYearValue, monthIndex + 2, 1)
            };
            q2 = {
                fromDate: new Date(this.selectedYearValue, monthIndex + 3, 1),
                toDate: new Date(this.selectedYearValue, monthIndex + 5, 1)
            };
            q3 = {
                fromDate: new Date(this.selectedYearValue, monthIndex + 6, 1),
                toDate: new Date(this.selectedYearValue, monthIndex + 8, 1)
            };
            q4 = {
                fromDate: new Date(this.selectedYearValue, monthIndex + 9, 1),
                toDate: new Date(this.selectedYearValue, monthIndex + 11, 1)
            };
            this.quarterData.push(q1, q2, q3, q4);
            for (let i = 0; i < this.quarterData.length; i++) {
                const quarter = this.quarterData[i];
                const quarterName = this.getQuarterName(i, quarter);
                this.quarterData[i].name = quarterName;
            }
            this.selectedQuarter = this.quarterData[0].name;
        };
        this.getQuarterName = (i, quarter) => {
            const quarterPrefix = ["Q1", "Q2", "Q3", "Q4"];
            let fromMonth;
            let toMonth = "";
            fromMonth = this.firstThreeLetters(this.months[quarter.fromDate.getMonth()]);
            toMonth = this.firstThreeLetters(this.months[quarter.toDate.getMonth()]);
            return quarterPrefix[i] + " " + fromMonth + " - " + toMonth; // in the format 'Q1 Apr - Jun'
        };
        this.firstThreeLetters = (str) => {
            return str.substring(0, 3);
        };
        this.isSelected = (period) => {
            if (this.selectedPeriod === period) {
                return true;
            }
            return false;
        };
        this.onSelectYear = (index) => {
            if (this.selectedYearValue !== this.yearData[index].name) {
                this.selectedYear = this.yearData[index];
                this.selectedYearValue = this.yearData[index].name;
                this.monthData = [];
                this.quarterData = [];
                this.prepareMonthData();
                this.selectedMonth = this.monthData[0].name;
                this.prepareQuarterData();
                this.selectedQuarter = this.quarterData[0].name;
            }
        };
        this.onSelectMonth = (index) => {
            if (this.selectedMonth !== this.monthData[index].name) {
                this.selectedMonth = this.monthData[index].name;
            }
        };
        this.onSelectQuarter = (index) => {
            if (this.selectedQuarter !== this.quarterData[index].name) {
                this.selectedQuarter = this.quarterData[index].name;
            }
        };
        this.onSelectPeriod = (event) => {
            this.selectedPeriod = event;
        };
    }
    set tileType(value) {
        if (value) {
            this.tile = value;
        }
    }
    ngOnInit() {
        this.selectedYearValue = this.currentDate.getFullYear();
        const selectedYearValue = this.selectedYearValue;
        this.selectedMonth =
            this.firstThreeLetters(this.months[this.currentDate.getMonth()]) +
                " " +
                this.selectedYearValue;
        this.prepareYearData(selectedYearValue);
        this.prepareMonthData();
        if (this.spacesSettings) {
            this.financialYearStart = this.spacesSettings.financialYearStart;
            this.prepareQuarterData();
        }
        this.getReportPeriod();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
ReportPeriodComponent.ɵfac = function ReportPeriodComponent_Factory(t) { return new (t || ReportPeriodComponent)(i0.ɵɵdirectiveInject(DataService)); };
ReportPeriodComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportPeriodComponent, selectors: [["lib-report-period"]], inputs: { currentDate: "currentDate", spacesSettings: "spacesSettings", tileType: "tileType" }, decls: 2, vars: 1, consts: [[1, "dateSelectionWrapper"], ["class", "periodSelector", 4, "ngIf"], [1, "periodSelector"], [1, "monthWrapper", 3, "ngClass"], [3, "spacesSettings", "tileType"]], template: function ReportPeriodComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, ReportPeriodComponent_div_1_Template, 3, 5, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedPeriod && ctx.selectedPeriod !== null);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, MonthPickerComponent], styles: [".periodSelector[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:inline-block;margin:0}.yearWrapper[_ngcontent-%COMP%], .monthWrapper[_ngcontent-%COMP%], .quarterWrapper[_ngcontent-%COMP%]{width:100%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportPeriodComponent, [{
        type: Component,
        args: [{
                selector: "lib-report-period",
                templateUrl: "./report-period.component.html",
                styleUrls: ["./report-period.component.css"]
            }]
    }], function () { return [{ type: DataService }]; }, { currentDate: [{
            type: Input
        }], spacesSettings: [{
            type: Input
        }], tileType: [{
            type: Input
        }] }); })();

class SensorService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.getSensorList = () => {
            const serverUrl = this.apiConfig.getSensorListUrl();
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getSensorStatus = () => {
            const serverUrl = "/api/v1/sensor/status/list";
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.claimSensor = (macAddrObj) => {
            const serverUrl = this.apiConfig.getClaimSensorUrl();
            return this.post(serverUrl, macAddrObj).pipe(map(this.extractResponse));
        };
        this.unclaimSensor = (macAddrObj) => {
            const serverUrl = this.apiConfig.getUnclaimSensorUrl();
            return this.post(serverUrl, macAddrObj).pipe(map(this.extractResponse));
        };
        this.getORSSIDList = (macAddress) => {
            const url = this.apiConfig.getORSSIDListUrl() +
                "/" +
                macAddress +
                "/ssids/list";
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.connectSensorToSSID = (ssidObj) => {
            const serverUrl = this.apiConfig.getConnectSensorToSSIDUrl();
            return this.post(serverUrl, ssidObj).pipe(map(this.extractResponse));
        };
        this.getSensorDetails = (macAddress) => {
            const url = this.apiConfig.getSensorDetailsUrl() + "/" + macAddress;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
    }
}
SensorService.ɵfac = function SensorService_Factory(t) { return new (t || SensorService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
SensorService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SensorService, factory: SensorService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SensorService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

function SensorListComponent_div_0_div_1_th_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.used-by-apps"), " ");
} }
function SensorListComponent_div_0_div_1_th_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1, "SSID");
    i0.ɵɵelementEnd();
} }
function SensorListComponent_div_0_div_1_th_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.openRoaming-ssids"), " ");
} }
function SensorListComponent_div_0_div_1_tr_21_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sensor_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", sensor_r9.location.name, " ");
} }
function SensorListComponent_div_0_div_1_tr_21_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.none"), " ");
} }
function SensorListComponent_div_0_div_1_tr_21_span_11_img_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 16);
} }
function SensorListComponent_div_0_div_1_tr_21_span_11_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 17);
} }
function SensorListComponent_div_0_div_1_tr_21_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtemplate(1, SensorListComponent_div_0_div_1_tr_21_span_11_img_1_Template, 1, 0, "img", 14);
    i0.ɵɵtemplate(2, SensorListComponent_div_0_div_1_tr_21_span_11_img_2_Template, 1, 0, "img", 15);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sensor_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", sensor_r9.status === "Online" || sensor_r9.status === "online");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", sensor_r9.status === "Offline");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", sensor_r9.status, " ");
} }
function SensorListComponent_div_0_div_1_tr_21_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.offline"), " ");
} }
function SensorListComponent_div_0_div_1_tr_21_td_13_span_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const appObj_r26 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", appObj_r26, " ");
} }
function SensorListComponent_div_0_div_1_tr_21_td_13_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtemplate(1, SensorListComponent_div_0_div_1_tr_21_td_13_span_1_span_1_Template, 2, 1, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sensor_r9 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", sensor_r9.apps);
} }
function SensorListComponent_div_0_div_1_tr_21_td_13_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.none"), " ");
} }
function SensorListComponent_div_0_div_1_tr_21_td_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, SensorListComponent_div_0_div_1_tr_21_td_13_span_1_Template, 2, 1, "span", 18);
    i0.ɵɵtemplate(2, SensorListComponent_div_0_div_1_tr_21_td_13_span_2_Template, 3, 3, "span", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sensor_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", sensor_r9.apps);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !sensor_r9.apps);
} }
function SensorListComponent_div_0_div_1_tr_21_td_14_span_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ssidObj_r32 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ssidObj_r32, " ");
} }
function SensorListComponent_div_0_div_1_tr_21_td_14_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtemplate(1, SensorListComponent_div_0_div_1_tr_21_td_14_span_1_span_1_Template, 2, 1, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sensor_r9 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", sensor_r9.ssids);
} }
function SensorListComponent_div_0_div_1_tr_21_td_14_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵelementStart(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "shared-lib.sensor-list.N/A"), " ");
} }
function SensorListComponent_div_0_div_1_tr_21_td_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, SensorListComponent_div_0_div_1_tr_21_td_14_span_1_Template, 2, 1, "span", 18);
    i0.ɵɵtemplate(2, SensorListComponent_div_0_div_1_tr_21_td_14_span_2_Template, 4, 3, "span", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sensor_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", sensor_r9.ssids && sensor_r9.ssids.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !sensor_r9.ssids || sensor_r9.ssids.length === 0);
} }
function SensorListComponent_div_0_div_1_tr_21_span_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sensor_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, sensor_r9.lastContact, "medium"), " ");
} }
function SensorListComponent_div_0_div_1_tr_21_span_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.none"), " ");
} }
function SensorListComponent_div_0_div_1_tr_21_td_19_span_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ssidObj_r39 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ssidObj_r39, " ");
} }
function SensorListComponent_div_0_div_1_tr_21_td_19_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵlistener("click", function SensorListComponent_div_0_div_1_tr_21_td_19_span_1_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r42); const sensor_r9 = i0.ɵɵnextContext(2).$implicit; const ctx_r40 = i0.ɵɵnextContext(3); return ctx_r40.openSSIDListPopup(sensor_r9); });
    i0.ɵɵtemplate(1, SensorListComponent_div_0_div_1_tr_21_td_19_span_1_span_1_Template, 2, 1, "span", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sensor_r9 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", sensor_r9.ssids);
} }
function SensorListComponent_div_0_div_1_tr_21_td_19_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵlistener("click", function SensorListComponent_div_0_div_1_tr_21_td_19_span_2_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r46); const sensor_r9 = i0.ɵɵnextContext(2).$implicit; const ctx_r44 = i0.ɵɵnextContext(3); return ctx_r44.openSSIDListPopup(sensor_r9); });
    i0.ɵɵelementStart(1, "span", 23);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "shared-lib.sensor-list.connect"), " ");
} }
function SensorListComponent_div_0_div_1_tr_21_td_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, SensorListComponent_div_0_div_1_tr_21_td_19_span_1_Template, 2, 1, "span", 20);
    i0.ɵɵtemplate(2, SensorListComponent_div_0_div_1_tr_21_td_19_span_2_Template, 4, 3, "span", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sensor_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", sensor_r9.ssids && sensor_r9.ssids.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !sensor_r9.ssids || sensor_r9.ssids.length === 0);
} }
function SensorListComponent_div_0_div_1_tr_21_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 9);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span", 10);
    i0.ɵɵelementStart(3, "span", 11);
    i0.ɵɵlistener("click", function SensorListComponent_div_0_div_1_tr_21_Template_span_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r49); const sensor_r9 = restoredCtx.$implicit; const ctx_r48 = i0.ɵɵnextContext(3); return ctx_r48.openSensorDetailsPopup(sensor_r9); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵelementStart(6, "span", 10);
    i0.ɵɵtemplate(7, SensorListComponent_div_0_div_1_tr_21_span_7_Template, 2, 1, "span", 12);
    i0.ɵɵtemplate(8, SensorListComponent_div_0_div_1_tr_21_span_8_Template, 3, 3, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵelementStart(10, "span", 10);
    i0.ɵɵtemplate(11, SensorListComponent_div_0_div_1_tr_21_span_11_Template, 4, 3, "span", 12);
    i0.ɵɵtemplate(12, SensorListComponent_div_0_div_1_tr_21_span_12_Template, 3, 3, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, SensorListComponent_div_0_div_1_tr_21_td_13_Template, 3, 2, "td", 0);
    i0.ɵɵtemplate(14, SensorListComponent_div_0_div_1_tr_21_td_14_Template, 3, 2, "td", 0);
    i0.ɵɵelementStart(15, "td");
    i0.ɵɵelementStart(16, "span", 10);
    i0.ɵɵtemplate(17, SensorListComponent_div_0_div_1_tr_21_span_17_Template, 3, 4, "span", 12);
    i0.ɵɵtemplate(18, SensorListComponent_div_0_div_1_tr_21_span_18_Template, 3, 3, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, SensorListComponent_div_0_div_1_tr_21_td_19_Template, 3, 2, "td", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sensor_r9 = ctx.$implicit;
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", sensor_r9.macAddress, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", sensor_r9.location.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !sensor_r9.location.name);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", sensor_r9.status);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !sensor_r9.status);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.listFrom === "sensorOnboarding");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.listFrom === "sensorOnboarding");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", sensor_r9.lastContact);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !sensor_r9.lastContact);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.listFrom === "openRoamingSensor");
} }
function SensorListComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "table", 5);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr", 6);
    i0.ɵɵelementStart(4, "th");
    i0.ɵɵelementStart(5, "span", 7);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, SensorListComponent_div_0_div_1_th_14_Template, 3, 3, "th", 0);
    i0.ɵɵtemplate(15, SensorListComponent_div_0_div_1_th_15_Template, 2, 0, "th", 0);
    i0.ɵɵelementStart(16, "th");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, SensorListComponent_div_0_div_1_th_19_Template, 3, 3, "th", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "tbody");
    i0.ɵɵtemplate(21, SensorListComponent_div_0_div_1_tr_21_Template, 20, 10, "tr", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 8, "shared-lib.sensor-list.mac-addr"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 10, "shared-lib.sensor-list.location"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 12, "shared-lib.sensor-list.sensor-status"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.listFrom === "sensorOnboarding");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.listFrom === "sensorOnboarding");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 14, "shared-lib.sensor-list.last-heard"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.listFrom === "openRoamingSensor");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.sensorList);
} }
function SensorListComponent_div_0_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "span", 27);
    i0.ɵɵlistener("click", function SensorListComponent_div_0_div_2_div_6_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r52); const ctx_r51 = i0.ɵɵnextContext(3); return ctx_r51.goToSensorOnboarding(); });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "shared-lib.sensor-list.claim-sensor"));
} }
function SensorListComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "img", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 26);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, SensorListComponent_div_0_div_2_div_6_Template, 5, 3, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 2, "shared-lib.sensor-list.sensor-desc"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.listFrom === "openRoamingSensor");
} }
function SensorListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SensorListComponent_div_0_div_1_Template, 22, 16, "div", 2);
    i0.ɵɵtemplate(2, SensorListComponent_div_0_div_2_Template, 7, 4, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.sensorList && ctx_r0.sensorList.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.sensorList && ctx_r0.sensorList.length === 0);
} }
function SensorListComponent_div_1_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("- ", ctx_r53.selectedSensor.details.macAddress, "");
} }
function SensorListComponent_div_1_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("- ", ctx_r54.selectedSensor.apps.length, "");
} }
function SensorListComponent_div_1_span_12_img_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 16);
} }
function SensorListComponent_div_1_span_12_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 17);
} }
function SensorListComponent_div_1_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 45);
    i0.ɵɵtemplate(1, SensorListComponent_div_1_span_12_img_1_Template, 1, 0, "img", 14);
    i0.ɵɵtemplate(2, SensorListComponent_div_1_span_12_img_2_Template, 1, 0, "img", 15);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r55 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r55.selectedSensor.status === "online");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r55.selectedSensor.status === "Offline");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r55.selectedSensor.status, " ");
} }
function SensorListComponent_div_1_button_17_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵlistener("click", function SensorListComponent_div_1_button_17_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(2); return ctx_r61.unclaimSensor(ctx_r61.selectedSensor); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.unclaim"), " ");
} }
function SensorListComponent_div_1_div_28_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r64 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r64.selectedSensor.details.macAddress, " ");
} }
function SensorListComponent_div_1_div_28_div_1_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.none"));
} }
function SensorListComponent_div_1_div_28_div_1_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r67 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r67.selectedSensor.details.deviceName, " ");
} }
function SensorListComponent_div_1_div_28_div_1_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.none"));
} }
function SensorListComponent_div_1_div_28_div_1_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r70 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r70.selectedSensor.details.productId, " ");
} }
function SensorListComponent_div_1_div_28_div_1_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.none"));
} }
function SensorListComponent_div_1_div_28_div_1_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r73 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r73.selectedSensor.details.serialId, " ");
} }
function SensorListComponent_div_1_div_28_div_1_ng_template_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.none"));
} }
function SensorListComponent_div_1_div_28_div_1_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r76 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r76.selectedSensor.details.lastHeard, "medium"), " ");
} }
function SensorListComponent_div_1_div_28_div_1_ng_template_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.none"));
} }
function SensorListComponent_div_1_div_28_div_1_div_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r79.selectedSensor.details.onBoardingProgress, " ");
} }
function SensorListComponent_div_1_div_28_div_1_ng_template_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.none"));
} }
function SensorListComponent_div_1_div_28_div_1_div_47_img_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 16);
} }
function SensorListComponent_div_1_div_28_div_1_div_47_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 17);
} }
function SensorListComponent_div_1_div_28_div_1_div_47_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtemplate(1, SensorListComponent_div_1_div_28_div_1_div_47_img_1_Template, 1, 0, "img", 14);
    i0.ɵɵtemplate(2, SensorListComponent_div_1_div_28_div_1_div_47_img_2_Template, 1, 0, "img", 15);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r82 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.selectedSensor.status === "online");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.selectedSensor.status === "Offline");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r82.selectedSensor.status, " ");
} }
function SensorListComponent_div_1_div_28_div_1_ng_template_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.none"));
} }
function SensorListComponent_div_1_div_28_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 46);
    i0.ɵɵelementStart(2, "div", 47);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SensorListComponent_div_1_div_28_div_1_div_5_Template, 2, 1, "div", 48);
    i0.ɵɵtemplate(6, SensorListComponent_div_1_div_28_div_1_ng_template_6_Template, 3, 3, "ng-template", null, 49, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 46);
    i0.ɵɵelementStart(9, "div", 47);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, SensorListComponent_div_1_div_28_div_1_div_12_Template, 2, 1, "div", 48);
    i0.ɵɵtemplate(13, SensorListComponent_div_1_div_28_div_1_ng_template_13_Template, 3, 3, "ng-template", null, 50, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 46);
    i0.ɵɵelementStart(16, "div", 47);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, SensorListComponent_div_1_div_28_div_1_div_19_Template, 2, 1, "div", 48);
    i0.ɵɵtemplate(20, SensorListComponent_div_1_div_28_div_1_ng_template_20_Template, 3, 3, "ng-template", null, 51, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 46);
    i0.ɵɵelementStart(23, "div", 47);
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(26, SensorListComponent_div_1_div_28_div_1_div_26_Template, 2, 1, "div", 48);
    i0.ɵɵtemplate(27, SensorListComponent_div_1_div_28_div_1_ng_template_27_Template, 3, 3, "ng-template", null, 52, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 46);
    i0.ɵɵelementStart(30, "div", 47);
    i0.ɵɵtext(31);
    i0.ɵɵpipe(32, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(33, SensorListComponent_div_1_div_28_div_1_div_33_Template, 3, 4, "div", 48);
    i0.ɵɵtemplate(34, SensorListComponent_div_1_div_28_div_1_ng_template_34_Template, 3, 3, "ng-template", null, 53, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 46);
    i0.ɵɵelementStart(37, "div", 47);
    i0.ɵɵtext(38);
    i0.ɵɵpipe(39, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(40, SensorListComponent_div_1_div_28_div_1_div_40_Template, 2, 1, "div", 48);
    i0.ɵɵtemplate(41, SensorListComponent_div_1_div_28_div_1_ng_template_41_Template, 3, 3, "ng-template", null, 54, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "div", 46);
    i0.ɵɵelementStart(44, "div", 47);
    i0.ɵɵtext(45);
    i0.ɵɵpipe(46, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(47, SensorListComponent_div_1_div_28_div_1_div_47_Template, 4, 3, "div", 48);
    i0.ɵɵtemplate(48, SensorListComponent_div_1_div_28_div_1_ng_template_48_Template, 3, 3, "ng-template", null, 55, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r65 = i0.ɵɵreference(7);
    const _r68 = i0.ɵɵreference(14);
    const _r71 = i0.ɵɵreference(21);
    const _r74 = i0.ɵɵreference(28);
    const _r77 = i0.ɵɵreference(35);
    const _r80 = i0.ɵɵreference(42);
    const _r83 = i0.ɵɵreference(49);
    const ctx_r63 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 21, "shared-lib.sensor-list.mac-addr"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r63.selectedSensor.details.macAddress)("ngIfElse", _r65);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 23, "shared-lib.sensor-list.dev-name"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r63.selectedSensor.details.deviceName)("ngIfElse", _r68);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 25, "shared-lib.sensor-list.pdt-id"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r63.selectedSensor.details.productId)("ngIfElse", _r71);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(25, 27, "shared-lib.sensor-list.serial-no"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r63.selectedSensor.details.serialId)("ngIfElse", _r74);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(32, 29, "shared-lib.sensor-list.last-heard"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r63.selectedSensor.details.lastHeard)("ngIfElse", _r77);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(39, 31, "shared-lib.sensor-list.onboarding-progress"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r63.selectedSensor.details.onBoardingProgress)("ngIfElse", _r80);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(46, 33, "shared-lib.sensor-list.sensor-status"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r63.selectedSensor.status)("ngIfElse", _r83);
} }
function SensorListComponent_div_1_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SensorListComponent_div_1_div_28_div_1_Template, 50, 35, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r57.selectedSensor.details);
} }
function SensorListComponent_div_1_div_29_div_8_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const log_r89 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, log_r89.time, "medium"), " ");
} }
function SensorListComponent_div_1_div_29_div_8_div_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.none"));
} }
function SensorListComponent_div_1_div_29_div_8_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const log_r89 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", log_r89.state, " ");
} }
function SensorListComponent_div_1_div_29_div_8_div_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.none"));
} }
function SensorListComponent_div_1_div_29_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵtemplate(1, SensorListComponent_div_1_div_29_div_8_div_1_div_1_Template, 3, 4, "div", 58);
    i0.ɵɵtemplate(2, SensorListComponent_div_1_div_29_div_8_div_1_ng_template_2_Template, 3, 3, "ng-template", null, 59, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, SensorListComponent_div_1_div_29_div_8_div_1_div_4_Template, 2, 1, "div", 48);
    i0.ɵɵtemplate(5, SensorListComponent_div_1_div_29_div_8_div_1_ng_template_5_Template, 3, 3, "ng-template", null, 60, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const log_r89 = ctx.$implicit;
    const _r91 = i0.ɵɵreference(3);
    const _r94 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", log_r89.time)("ngIfElse", _r91);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", log_r89.state)("ngIfElse", _r94);
} }
function SensorListComponent_div_1_div_29_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SensorListComponent_div_1_div_29_div_8_div_1_Template, 7, 4, "div", 57);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r87 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r87.selectedSensor.logs);
} }
function SensorListComponent_div_1_div_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 46);
    i0.ɵɵelementStart(2, "div", 47);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 56);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, SensorListComponent_div_1_div_29_div_8_Template, 2, 1, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "shared-lib.sensor-list.time"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 5, "shared-lib.sensor-list.status"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r58.selectedSensor.logs && ctx_r58.selectedSensor.logs.length > 0);
} }
const _c0$e = function (a0) { return { "active-block": a0 }; };
function SensorListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r99 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "div", 30);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵtemplate(6, SensorListComponent_div_1_span_6_Template, 2, 1, "span", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 31);
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵtemplate(11, SensorListComponent_div_1_span_11_Template, 2, 1, "span", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, SensorListComponent_div_1_span_12_Template, 4, 3, "span", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 33);
    i0.ɵɵlistener("click", function SensorListComponent_div_1_Template_span_click_13_listener() { i0.ɵɵrestoreView(_r99); const ctx_r98 = i0.ɵɵnextContext(); return ctx_r98.closeSensorDetailsPopup(); });
    i0.ɵɵtext(14, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 34);
    i0.ɵɵelementStart(16, "div", 35);
    i0.ɵɵtemplate(17, SensorListComponent_div_1_button_17_Template, 3, 3, "button", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 37);
    i0.ɵɵelementStart(19, "ul", 38);
    i0.ɵɵelementStart(20, "li", 39);
    i0.ɵɵlistener("click", function SensorListComponent_div_1_Template_li_click_20_listener() { i0.ɵɵrestoreView(_r99); const ctx_r100 = i0.ɵɵnextContext(); return ctx_r100.showSensorDetailsTab("details"); });
    i0.ɵɵelementStart(21, "span", 40);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "li", 41);
    i0.ɵɵlistener("click", function SensorListComponent_div_1_Template_li_click_24_listener() { i0.ɵɵrestoreView(_r99); const ctx_r101 = i0.ɵɵnextContext(); return ctx_r101.showSensorDetailsTab("logs"); });
    i0.ɵɵelementStart(25, "span", 40);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(28, SensorListComponent_div_1_div_28_Template, 2, 1, "div", 0);
    i0.ɵɵtemplate(29, SensorListComponent_div_1_div_29_Template, 9, 7, "div", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 42);
    i0.ɵɵelementStart(31, "button", 43);
    i0.ɵɵlistener("click", function SensorListComponent_div_1_Template_button_click_31_listener() { i0.ɵɵrestoreView(_r99); const ctx_r102 = i0.ɵɵnextContext(); return ctx_r102.closeSensorDetailsPopup(); });
    i0.ɵɵtext(32);
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "button", 44);
    i0.ɵɵlistener("click", function SensorListComponent_div_1_Template_button_click_34_listener() { i0.ɵɵrestoreView(_r99); const ctx_r103 = i0.ɵɵnextContext(); return ctx_r103.closeSensorDetailsPopup(); });
    i0.ɵɵtext(35);
    i0.ɵɵpipe(36, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 14, "shared-lib.sensor-list.sensor"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.selectedSensor.details);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(10, 16, "shared-lib.sensor-list.used-by-apps"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.selectedSensor.apps);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.selectedSensor.status);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.userRole === "RW");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(26, _c0$e, ctx_r1.selectedTab === "details"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 18, "shared-lib.sensor-list.details"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(28, _c0$e, ctx_r1.selectedTab === "logs"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 20, "shared-lib.sensor-list.logs"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.selectedTab === "details");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.selectedTab === "logs");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(33, 22, "shared-lib.sensor-list.cancel"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(36, 24, "shared-lib.sensor-list.close"), " ");
} }
function SensorListComponent_div_2_tbody_35_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r109 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 9);
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "span", 70);
    i0.ɵɵelementStart(3, "input", 76);
    i0.ɵɵlistener("click", function SensorListComponent_div_2_tbody_35_tr_1_Template_input_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r109); const ssid_r107 = restoredCtx.$implicit; const ctx_r108 = i0.ɵɵnextContext(3); return ctx_r108.selectUser(ssid_r107); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "label", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 78);
    i0.ɵɵelementStart(6, "span", 10);
    i0.ɵɵelementStart(7, "span", 79);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ssid_r107 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "userCheckbox-", ssid_r107.name, "");
    i0.ɵɵproperty("checked", ssid_r107.status);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "userCheckbox-", ssid_r107.name, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ssid_r107.name, " ");
} }
function SensorListComponent_div_2_tbody_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, SensorListComponent_div_2_tbody_35_tr_1_Template, 9, 4, "tr", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r104 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r104.ssidList);
} }
function SensorListComponent_div_2_button_38_Template(rf, ctx) { if (rf & 1) {
    const _r111 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 80);
    i0.ɵɵlistener("click", function SensorListComponent_div_2_button_38_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r111); const ctx_r110 = i0.ɵɵnextContext(2); return ctx_r110.connectBtn(); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared-lib.sensor-list.connect"), " ");
} }
function SensorListComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r113 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 61);
    i0.ɵɵelement(2, "div", 62);
    i0.ɵɵelementStart(3, "div", 63);
    i0.ɵɵelementStart(4, "div", 30);
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 33);
    i0.ɵɵlistener("click", function SensorListComponent_div_2_Template_span_click_8_listener() { i0.ɵɵrestoreView(_r113); const ctx_r112 = i0.ɵɵnextContext(); return ctx_r112.closeIconBtnClick(); });
    i0.ɵɵtext(9, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 34);
    i0.ɵɵelementStart(11, "div", 64);
    i0.ɵɵelementStart(12, "div", 65);
    i0.ɵɵelementStart(13, "span", 66);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "span", 67);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 68);
    i0.ɵɵelementStart(19, "span", 66);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "span", 67);
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 69);
    i0.ɵɵelementStart(25, "table", 5);
    i0.ɵɵelementStart(26, "thead");
    i0.ɵɵelementStart(27, "tr", 9);
    i0.ɵɵelementStart(28, "th");
    i0.ɵɵelementStart(29, "span", 70);
    i0.ɵɵelementStart(30, "input", 71);
    i0.ɵɵlistener("click", function SensorListComponent_div_2_Template_input_click_30_listener() { i0.ɵɵrestoreView(_r113); const ctx_r114 = i0.ɵɵnextContext(); return ctx_r114.selectAllSSID(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(31, "label", 72);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "span", 73);
    i0.ɵɵtext(33);
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(35, SensorListComponent_div_2_tbody_35_Template, 2, 1, "tbody", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 42);
    i0.ɵɵelementStart(37, "div");
    i0.ɵɵtemplate(38, SensorListComponent_div_2_button_38_Template, 3, 3, "button", 74);
    i0.ɵɵelementStart(39, "button", 75);
    i0.ɵɵlistener("click", function SensorListComponent_div_2_Template_button_click_39_listener() { i0.ɵɵrestoreView(_r113); const ctx_r115 = i0.ɵɵnextContext(); return ctx_r115.closeIconBtnClick(); });
    i0.ɵɵtext(40);
    i0.ɵɵpipe(41, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 10, "shared-lib.sensor-list.connect-or"), "");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 12, "shared-lib.sensor-list.mac-addr"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.mac_address);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 14, "shared-lib.sensor-list.location"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.location);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("checked", ctx_r2.isSelectedAll());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(34, 16, "shared-lib.sensor-list.openRoaming-ssid"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.ssidList);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.userRole === "RW");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(41, 18, "shared-lib.sensor-list.cancel"), " ");
} }
class SensorListComponent {
    constructor(sensorService, router, authService, dataService) {
        this.sensorService = sensorService;
        this.router = router;
        this.authService = authService;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.isUserRoleAvailable = false;
        this.sensorListLoaded = false;
        this.showSensorDetailsPopup = false;
        this.selectedTab = "details";
        this.showSSIDPopup = false;
        this.selectedAllSSID = false;
        this.mac_address = "";
        this.location = "";
        this.jsonConfig = null;
        this.currentNav = "";
        this.sensorLearnMoreLink = "";
        this.getProperties = () => {
            this.authService
                .getProperties(this.dataService.getAccessToken() != null, this.unsubscribe$)
                .then((properties) => {
                this.sensorLearnMoreLink =
                    properties["value"].sensorLearnMore;
            });
        };
        this.getUserRole = () => {
            this.authService.getRole(this.unsubscribe$).subscribe((roleBehavior) => {
                if (roleBehavior && roleBehavior.appRole) {
                    this.userRole = roleBehavior.appRole;
                    this.isUserRoleAvailable = true;
                }
            }, (error) => {
                console.log(error);
            });
        };
        this.initializeJson = () => {
            this.jsonConfig = {};
            this.jsonConfig.macAddress = {};
            this.jsonConfig.ssids = [];
        };
        this.getSensorList = () => {
            this.dataService.display(true);
            this.sensorService
                .getSensorList()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status) {
                    if (response.data) {
                        this.sensorList = response.data;
                        this.getSensorStatus();
                    }
                    else {
                        this.sensorListLoaded = true;
                    }
                    this.dataService.display(false);
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(response.message, 4000, null, null, "error");
                }
            }, (error) => {
                console.log("sensor list api call error", error.status);
                this.dataService.display(false);
            });
        };
        this.getSensorStatus = () => {
            this.sensorService
                .getSensorStatus()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status) {
                    if (response.data) {
                        this.sensorStatusList = response.data;
                        if (this.sensorStatusList &&
                            this.sensorStatusList.length > 0) {
                            this.sensorList.forEach((sensor) => {
                                this.sensorStatusList.forEach((statusObj) => {
                                    if (statusObj.macAddress ==
                                        sensor.macAddress) {
                                        sensor.status =
                                            statusObj.status;
                                    }
                                });
                            });
                        }
                    }
                    if (this.listFrom == "openRoamingSensor") {
                        this.getOnlineSensorList(this.sensorList);
                    }
                    else if (this.listFrom == "sensorOnboarding") {
                        this.sensorListLoaded = true;
                    }
                }
                else {
                    this.dataService.setToastMessage(response.message, 4000, null, null, "error");
                }
                // refresh the sensor status for every 5 secs
                setTimeout(() => {
                    this.getSensorStatus();
                }, 5000);
            }, (error) => {
                console.log("sensor list api call error", error.status);
                this.dataService.display(false);
            });
        };
        this.getOnlineSensorList = (sensorList) => {
            this.sensorList = [];
            if (sensorList && sensorList.length > 0) {
                sensorList.forEach((sensor) => {
                    if (sensor.status == "Online" || sensor.status == "online") {
                        this.sensorList.push(sensor);
                    }
                });
            }
            this.sensorListLoaded = true;
        };
        this.openSensorDetailsPopup = (sensor) => {
            this.selectedTab = "details";
            this.dataService.display(true);
            this.sensorService
                .getSensorDetails(sensor.macAddress)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status) {
                    if (response.data) {
                        this.selectedSensor = response.data;
                        // assigning values
                        if (!this.selectedSensor.status) {
                            this.selectedSensor.status = sensor.status;
                        }
                        if (!this.selectedSensor.apps) {
                            this.selectedSensor.apps = sensor.apps
                                ? sensor.apps
                                : [];
                        }
                        else {
                            this.selectedSensor.apps = [];
                        }
                    }
                    this.showSensorDetailsPopup = true;
                    this.dataService.openMagneticPopup();
                    this.dataService.display(false);
                }
                else {
                    // set default values
                    this.selectedSensor = {
                        details: {},
                        logs: [],
                        apps: []
                    };
                    this.selectedSensor.details.macAddress =
                        sensor.macAddress;
                    this.dataService.setToastMessage(response.message, 4000, null, null, "error");
                    this.dataService.display(false);
                }
            }, (error) => {
                console.log("sensor details api call error", error.status);
                this.dataService.setToastMessage("An error occurred while getting sensor details.", 4000, null, null, "error");
                this.dataService.display(false);
            });
        };
        this.unclaimSensor = (sensor) => {
            this.sensorListLoaded = false;
            this.dataService.display(true);
            const macObj = { macAddress: sensor.details.macAddress };
            this.sensorService
                .unclaimSensor(macObj)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response.status) {
                    this.sensorList = response.data;
                    this.getSensorStatus();
                    this.dataService.display(false);
                    this.closeSensorDetailsPopup();
                    this.dataService.setToastMessage(response.message, 4000, null, null, "success");
                }
                else {
                    this.dataService.display(false);
                    this.dataService.setToastMessage(response.message, 4000, null, null, "error");
                }
            }, (error) => {
                console.log("sensor unclaim api call error", error.status);
                this.dataService.display(false);
            });
        };
        this.closeSensorDetailsPopup = () => {
            this.showSensorDetailsPopup = false;
            this.dataService.closeMagneticPopup();
            this.selectedSensor = {};
        };
        this.showSensorDetailsTab = (tab) => {
            this.selectedTab = tab;
        };
        this.openSSIDListPopup = (sensor) => {
            this.selectedAllSSID = false;
            this.selectedSSID = [{ status: false }];
            this.mac_address = sensor.macAddress;
            this.location = sensor.location.name;
            this.dataService.display(true);
            this.sensorService
                .getORSSIDList(sensor.macAddress)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                // for testing
                // response = {"status":true,"message":"Successfully created profile ","data":[{"name":"ssidname","status":true,"profileId":123},{"name":"ssidname12","status":false,"profileId":123},{"name":"ssidname345","status":true,"profileId":123}]};
                // for testing
                if (response.status) {
                    this.dataService.display(false);
                    this.ssidList = response.data;
                    this.showSSIDPopup = true;
                    this.dataService.openMagneticPopup();
                }
                else {
                    this.dataService.setToastMessage(response.message, 4000, null, null, "error");
                    this.dataService.display(false);
                }
            }, (error) => {
                this.dataService.display(false);
                console.log("Error while getting ssid list", error.status);
            });
        };
        this.connectBtn = () => {
            this.jsonConfig.macAddress = this.mac_address;
            this.jsonConfig.ssids = this.selectedSSID;
            this.dataService.display(true);
            this.sensorService
                .connectSensorToSSID(this.jsonConfig)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                // for testing
                // response = {"status":true,"message":"Successfully created profile ","data":[{"name":"ssidname","status":true,"profileId":123},{"name":"ssidname12","status":false,"profileId":123},{"name":"ssidname345","status":true,"profileId":123}]};
                // for testing
                if (response.status) {
                    this.dataService.display(false);
                    this.showSSIDPopup = false;
                    this.dataService.closeMagneticPopup();
                    this.dataService.setToastMessage(response.message, 4000, null, null, "success");
                    this.sensorListLoaded = false;
                    this.getSensorList();
                }
                else {
                    this.dataService.setToastMessage(response.message, 4000, null, null, "error");
                    this.dataService.display(false);
                }
            }, (error) => {
                this.dataService.display(false);
                console.log("Error while connecting ssid to sensor", error.status);
            });
        };
        this.closeIconBtnClick = () => {
            this.showSSIDPopup = false;
            this.dataService.closeMagneticPopup();
            this.initializeJson();
        };
        this.isSelectedAll = () => {
            return this.selectedAllSSID;
        };
        this.selectAllSSID = () => {
            this.selectedAllSSID = !this.selectedAllSSID;
            this.ssidList.forEach((ssid) => {
                ssid.status = this.selectedAllSSID;
                if (this.selectedAllSSID) {
                    if (this.selectedSSID)
                        this.selectedSSID.push(ssid);
                    else
                        this.selectedSSID = [ssid];
                }
            });
        };
        this.selectUser = (ssid) => {
            const userIndex = this.selectedSSID.indexOf(ssid);
            if (userIndex > -1) {
                this.selectedSSID.splice(userIndex, 1);
            }
            else {
                this.selectedSSID.push(ssid);
            }
            if (this.ssidList.length - 1 !== this.selectedSSID.length - 1) {
                this.selectedAllSSID = false;
            }
            else {
                this.selectedAllSSID = true;
            }
            if (ssid.status !== undefined)
                ssid.status = !ssid.status;
            else
                ssid.status = true;
        };
        this.goToSensorOnboarding = () => {
            this.currentNav = "/setup/sensors";
            this.router.navigate([this.currentNav]);
            this.dataService.setCurrentNav(this.currentNav);
        };
    }
    ngOnInit() {
        this.getProperties();
        if (!this.sensorList) {
            this.getSensorList();
        }
        else {
            this.getSensorStatus();
        }
        this.initializeJson();
        this.isUserRoleAvailable = false;
        if (this.userRole) {
            this.isUserRoleAvailable = true;
        }
        else if (!this.userRole) {
            this.getUserRole();
        }
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
SensorListComponent.ɵfac = function SensorListComponent_Factory(t) { return new (t || SensorListComponent)(i0.ɵɵdirectiveInject(SensorService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(DataService)); };
SensorListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SensorListComponent, selectors: [["lib-sensor-list"]], inputs: { sensorList: "sensorList", listFrom: "listFrom", userRole: "userRole" }, decls: 3, vars: 3, consts: [[4, "ngIf"], ["class", "modalPopup hotspotPopup connectorPopup", 4, "ngIf"], ["class", "userTableContainer", 4, "ngIf"], ["class", "emptyWrapper", 4, "ngIf"], [1, "userTableContainer"], [1, "table", "userTable"], [1, "tableTr", "textUppercase"], [1, "userDetailLabel"], ["class", "tableTr", 4, "ngFor", "ngForOf"], [1, "tableTr"], [1, "userListName"], [1, "profileNameLink", "pointer", 3, "click"], ["class", "userNameLink", 4, "ngIf"], [1, "userNameLink"], ["src", "/assets/images/tick_mark_green.svg", "width", "16px", 4, "ngIf"], ["src", "/assets/images/warning.svg", "width", "16px", 4, "ngIf"], ["src", "/assets/images/tick_mark_green.svg", "width", "16px"], ["src", "/assets/images/warning.svg", "width", "16px"], ["class", "userListName", 4, "ngIf"], ["class", "userNameLink", 4, "ngFor", "ngForOf"], ["class", "userNameLink clickableLink", 3, "click", 4, "ngIf"], [1, "userNameLink", "clickableLink", 3, "click"], ["class", "profileNameLink", 4, "ngFor", "ngForOf"], [1, "profileNameLink"], [1, "emptyWrapper"], ["src", "/assets/images/emptystates/empty-sensor-list.svg"], [1, "emptyStateDesc"], [1, "link", 3, "click"], [1, "modalPopup", "hotspotPopup", "connectorPopup"], ["id", "modalContent", 1, "modalContent-connector"], [1, "modalHeader"], [1, "modalSecondHeader"], ["class", "sensorStatusDiv", 4, "ngIf"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], [1, "unclaimDiv"], ["class", "commonButton", 3, "click", 4, "ngIf"], [1, "header"], [1, "header-inner"], ["id", "link-locdetails-rules", 1, "header-blocks", "noselect", 3, "ngClass", "click"], [1, "active-name"], ["id", "link-locdetails-maps", 1, "header-blocks", "noselect", 3, "ngClass", "click"], [1, "modalFooter"], [1, "commonButton", 3, "click"], [1, "primaryButton", 3, "click"], [1, "sensorStatusDiv"], [1, "fieldWrapper"], [1, "fieldLabel"], ["class", "fieldValue", 4, "ngIf", "ngIfElse"], ["NoMacAddress", ""], ["NoDeviceName", ""], ["NoProductId", ""], ["NoSerialId", ""], ["NoLastHeard", ""], ["NoOnBoardingProgress", ""], ["NoStatus", ""], [1, "fieldValue"], ["class", "fieldWrapper", 4, "ngFor", "ngForOf"], ["class", "fieldLabel", 4, "ngIf", "ngIfElse"], ["nologstime", ""], ["nologsstate", ""], [1, "modalPopup", "modalPopupOR", "ssidSelectionPopup"], [1, "modalOverlay"], [1, "openroaming-modalContent"], [1, "expand-div"], [1, "flex-div"], [1, "title"], [1, "value"], [1, "flex-div", "flex-div-top"], [1, "ssidScrollDiv"], [1, "circularCheckbox", "userCheckbox"], ["type", "checkbox", "name", "userSelectCheckbox", "id", "selectAllSSID", 3, "checked", "click"], ["for", "selectAllSSID", 1, "checkboxLabel"], [1, "table-titles"], ["class", "primaryButton2 btn", 3, "click", 4, "ngIf"], [1, "modalSecondaryButton", "canceledButton", 3, "click"], ["type", "checkbox", 3, "id", "checked", "click"], [1, "checkboxLabel", 3, "for"], [1, "userListLabel"], [1, "table-values"], [1, "primaryButton2", "btn", 3, "click"]], template: function SensorListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SensorListComponent_div_0_Template, 3, 2, "div", 0);
        i0.ɵɵtemplate(1, SensorListComponent_div_1_Template, 37, 30, "div", 1);
        i0.ɵɵtemplate(2, SensorListComponent_div_2_Template, 42, 20, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.sensorListLoaded && ctx.isUserRoleAvailable);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showSensorDetailsPopup === true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showSSIDPopup);
    } }, directives: [i1$2.NgIf, i1$2.NgForOf, i1$2.NgClass], pipes: [i2.TranslatePipe, i1$2.DatePipe], styles: [".userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:nth-child(5), .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-child(5){width:10%}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:20%}.userDetailLabel[_ngcontent-%COMP%]{display:inline-block}.userNameLink[_ngcontent-%COMP%]{font-size:12px;color:#000;font-family:\"ciscoSansRegular\"}.profileNameLink[_ngcontent-%COMP%]{color:#049fd9;font-size:12px;font-family:\"ciscoSansRegular\"}.userListEmail[_ngcontent-%COMP%]{opacity:.8;font-family:\"ciscoSansRegular\";font-size:11px;color:#333;display:block}.userAccess[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.userLocations[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.statusPending[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.confirmResendLink[_ngcontent-%COMP%]{font-family:\"ciscoSansRegular\";font-size:12px;font-weight:600;color:#049fd9;text-decoration:underline}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   div.userActionsMenu[_ngcontent-%COMP%]{display:block}.userPendingStatus[_ngcontent-%COMP%]{display:block}.width35[_ngcontent-%COMP%]{min-width:35px;display:inline-block;height:20px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{padding:0;height:30px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:auto;margin-bottom:0}.warningPopupHeading[_ngcontent-%COMP%]{margin-bottom:15px}.modalPopup.warningPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{padding:0 20px 20px;border-top:none;position:relative;height:auto;text-align:center!important}.user-action-container[_ngcontent-%COMP%]{display:flex}.user-action-container[_ngcontent-%COMP%]   .user-search-container[_ngcontent-%COMP%]{margin:0 10px}.user-action-container[_ngcontent-%COMP%]   .user-search-container[_ngcontent-%COMP%]   .searchInput[_ngcontent-%COMP%]{width:200px;height:35px;padding:5px 15px 0 30px;border:none;border-bottom:1px solid #ccc;font-size:15px}.user-action-container[_ngcontent-%COMP%]   .user-search-container[_ngcontent-%COMP%]   input.searchInput[_ngcontent-%COMP%]:focus{color:#000;border-color:#049fd9;border-width:2px}.user-action-container[_ngcontent-%COMP%]   .user-search-container[_ngcontent-%COMP%]   .user-search-icon[_ngcontent-%COMP%]{background:url(/assets/images/search_dropdown.svg);width:24px;height:24px;display:inline-block;background-repeat:no-repeat;background-position:center;vertical-align:middle;position:absolute;bottom:0;top:0;margin:auto}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%]{text-align:center;display:none}.userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover   div.userActionsMenu[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   div.userActionsMenu.selected[_ngcontent-%COMP%]{display:block}.userTable[_ngcontent-%COMP%]   div.userActionsMenu[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{position:relative;padding:0 10px;text-decoration:none;outline:none}.userListLabel[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}.userListName[_ngcontent-%COMP%]{display:block}.clickableLink[_ngcontent-%COMP%]{display:block;cursor:pointer}.userActionsMenu[_ngcontent-%COMP%]{position:relative;white-space:nowrap}.showMoreIcon[_ngcontent-%COMP%]{margin-left:-15px}.userEditIcon.configure[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:20px}.controllerEditIcon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:14px}.menu-l[_ngcontent-%COMP%]{position:absolute;right:20px;top:35px;border-radius:0;box-shadow:0 0 3px #0000004d}.menu-open-img[_ngcontent-%COMP%]{height:34px}.action-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0;margin:0}.warningIcon[_ngcontent-%COMP%]{margin-left:45%;margin-top:5%}.modalPopup.connectorPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:100%;overflow-y:auto;padding-bottom:200px;transition:.5s ease}.modalPopup.connectorPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{height:90px}.modalPopup[_ngcontent-%COMP%] > .modalContent-connector[_ngcontent-%COMP%]{width:50%;right:0;height:100%;z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #abc233;animation:slide .5s forwards;text-align:left}@keyframes slide{65%{right:0}}.headerLabel[_ngcontent-%COMP%]{font-size:14px;font-weight:bold;padding:10px 0;font-family:\"ciscoSans\"}.fieldLabel[_ngcontent-%COMP%], .fieldValue[_ngcontent-%COMP%], .fieldWrapper[_ngcontent-%COMP%]{padding:10px 0}.accessToken[_ngcontent-%COMP%]   .fieldWrapper[_ngcontent-%COMP%]{border-bottom:none}.controllerForm[_ngcontent-%COMP%]   .fieldWrapper[_ngcontent-%COMP%]{border-bottom:none}.fieldLabel[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans;width:50%;display:inline-block}.fieldValue[_ngcontent-%COMP%]{font-size:14px;color:#3e3e3e;font-family:ciscoSans;width:50%;display:inline-block;font-weight:bold}.emptyWrapper[_ngcontent-%COMP%]{text-align:center;padding:50px}.emptyWrapper[_ngcontent-%COMP%]   .emptyStateDesc[_ngcontent-%COMP%]{padding:10px 150px}.unclaimDiv[_ngcontent-%COMP%]{text-align:right}.header[_ngcontent-%COMP%]{margin-top:10px;min-height:60px;background:#fff;position:relative;border-bottom:1px solid #e9e9e9}.header-inner[_ngcontent-%COMP%]{margin:20px auto 0;padding:0;position:absolute;bottom:0;left:0;right:0}.header-blocks[_ngcontent-%COMP%]{width:16%;padding:10px;float:left;text-align:center;cursor:pointer;border-bottom:5px solid #ffffff}.header-blocks[_ngcontent-%COMP%]:hover{opacity:.8}.active-block[_ngcontent-%COMP%]   .active-name[_ngcontent-%COMP%]{color:#000;font-family:\"ciscoSansRegular\"}.active-name[_ngcontent-%COMP%]{color:#58585b;font-family:\"ciscoSansLight\"}.active-block[_ngcontent-%COMP%]{border-bottom:5px solid #059fd9;animation:border-animation .1s ease-in-out}@keyframes border-animation{0%{border-width:0}to{border-width:100%}}.modalSecondHeader[_ngcontent-%COMP%]{font-size:14px;padding:5px 0;color:#4e4e4e}.sensorStatusDiv[_ngcontent-%COMP%]{padding-left:10px;margin-left:10px;border-left:1px solid #dedede}.modalPopup[_ngcontent-%COMP%]   .modalCloseIcon[_ngcontent-%COMP%]{padding:0 30px;top:20px!important}.modalPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{align-items:center;justify-content:flex-end;background-color:#ffffffe6;z-index:9999}.openroaming-modalContent[_ngcontent-%COMP%]{width:50%;margin:10% 20%;z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0}.openroaming-modalContent[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{font-family:\"ciscoSans\";font-size:24px;line-height:28px;letter-spacing:1px;color:#39393b}.openroaming-modalContent[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{background-color:#fff;width:100%;height:90%;margin-bottom:40px;overflow:hidden;overflow-y:scroll}.expand-div[_ngcontent-%COMP%]{padding:0 10px 10px 0;width:70%}.expand-div[_ngcontent-%COMP%]   .flex-div[_ngcontent-%COMP%]{display:flex}.expand-div[_ngcontent-%COMP%]   .flex-div[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{width:30%;padding-right:10px;font-family:\"ciscoSans\";font-style:normal;font-weight:350;font-size:14px;line-height:20px;letter-spacing:.5px;color:#565659}.expand-div[_ngcontent-%COMP%]   .flex-div[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%]{width:50%;padding-right:10px;font-family:\"ciscoSans\";font-style:normal;font-weight:350;font-size:14px;line-height:20px;letter-spacing:.5px;color:#00090d}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:20%;padding-left:15px}.table.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-child:before{display:none}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:18%}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:nth-of-type(5), .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:nth-of-type(5){width:14%}.circularCheckbox[_ngcontent-%COMP%]   .checkboxLabel[_ngcontent-%COMP%]{height:5px!important;margin-top:-10px!important}.circularCheckbox[_ngcontent-%COMP%]{vertical-align:middle;padding-right:15px;display:inline-block}.table-titles[_ngcontent-%COMP%]{font-family:\"ciscoSans\";font-style:normal;font-weight:normal;font-size:12px;line-height:13px;letter-spacing:.35px;color:#000}.table-values[_ngcontent-%COMP%]{font-family:\"ciscoSans\";font-style:normal;font-weight:350;font-size:12px;line-height:14px;letter-spacing:.35px;color:#565659}.modalFooter[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-right:20px;float:right!important}.ssidSelectionPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{height:500px}.ssidSelectionPopup[_ngcontent-%COMP%]   .ssidScrollDiv[_ngcontent-%COMP%]{height:300px;overflow-y:auto;border:1px solid #c4c4c4}.link[_ngcontent-%COMP%]{color:#049fd9;font-size:14px;padding-right:5px;cursor:pointer}.learnmorelink[_ngcontent-%COMP%]{text-decoration:none!important;border-right:1px solid #049fd9;margin-right:10px;padding-right:10px!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SensorListComponent, [{
        type: Component,
        args: [{
                selector: "lib-sensor-list",
                templateUrl: "./sensor-list.component.html",
                styleUrls: ["./sensor-list.component.scss"]
            }]
    }], function () { return [{ type: SensorService }, { type: i1.Router }, { type: AuthService }, { type: DataService }]; }, { sensorList: [{
            type: Input
        }], listFrom: [{
            type: Input
        }], userRole: [{
            type: Input
        }] }); })();

class ShareReportsService extends BaseService {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.apiConfig = new ApiConfig(this.dataService);
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
    }
    shareReport(report) {
        const url = this.apiConfig.createShareReportUrl();
        return this.post(url, report).pipe(map(this.extractResponse));
    }
    reShareReport(report) {
        const url = this.apiConfig.reShareReportUrl();
        return this.post(url, report).pipe(map(this.extractResponse));
    }
    getSharedUserList(params) {
        // let url = "/assets/data/user-list.json";
        // return this.get(url)
        //   .pipe(map(this.extractResponse));
        const url = this.apiConfig.getSharedUsersListUrl();
        return this.post(url, params).pipe(map(this.extractResponse));
    }
    revokeUsers(users, guid) {
        const url = this.apiConfig.getRevokeUsersUrl(guid);
        return this.post(url, users).pipe(map(this.extractResponse));
    }
}
ShareReportsService.ɵfac = function ShareReportsService_Factory(t) { return new (t || ShareReportsService)(i0.ɵɵinject(i0.Injector)); };
ShareReportsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ShareReportsService, factory: ShareReportsService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShareReportsService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: i0.Injector }]; }, null); })();

function ShareReportDialogComponent_span_15_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵlistener("click", function ShareReportDialogComponent_span_15_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.openEditReportNamePopup(); });
    i0.ɵɵelementEnd();
} }
function ShareReportDialogComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.error);
} }
const _c0$d = function (a0, a1) { return { "valid-email": a0, "invalid-email": a1 }; };
function ShareReportDialogComponent_div_41_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 38);
    i0.ɵɵlistener("click", function ShareReportDialogComponent_div_41_div_1_span_1_Template_span_click_2_listener($event) { i0.ɵɵrestoreView(_r17); const i_r13 = i0.ɵɵnextContext().index; const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.removeEmail($event, i_r13); });
    i0.ɵɵtext(3, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const email_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0$d, email_r12.valid, !email_r12.valid));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", email_r12.email, " ");
} }
function ShareReportDialogComponent_div_41_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ShareReportDialogComponent_div_41_div_1_span_1_Template, 4, 5, "span", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const email_r12 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", email_r12);
} }
function ShareReportDialogComponent_div_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtemplate(1, ShareReportDialogComponent_div_41_div_1_Template, 2, 1, "div", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.emailList);
} }
function ShareReportDialogComponent_div_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵelement(2, "div");
    i0.ɵɵelement(3, "div");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ShareReportDialogComponent_div_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelementStart(1, "div", 42);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "shared-lib.share-reports.no-userTxt"));
} }
function ShareReportDialogComponent_div_57_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 3, "shared-lib.share-reports.noOfUsersTxt"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.noOfUsers, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 5, "shared-lib.share-reports.userTxt"), " ");
} }
function ShareReportDialogComponent_div_57_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 3, "shared-lib.share-reports.noOfUsersTxt"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r20.noOfUsers, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 5, "shared-lib.share-reports.usersTxt"), " ");
} }
const _c1$6 = function (a0) { return { "add-arrow": a0 }; };
function ShareReportDialogComponent_div_57_div_12_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 63);
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1$6, ctx_r23.showTooltip));
} }
function ShareReportDialogComponent_div_57_div_12_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 64);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared-lib.share-reports.email-tip-content"));
} }
const _c2$5 = function (a0) { return { "dnas-badge": a0 }; };
function ShareReportDialogComponent_div_57_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵelementStart(1, "div", 46);
    i0.ɵɵelementStart(2, "span", 47);
    i0.ɵɵelementStart(3, "input", 53);
    i0.ɵɵlistener("ngModelChange", function ShareReportDialogComponent_div_57_div_12_Template_input_ngModelChange_3_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r26); const user_r22 = restoredCtx.$implicit; return user_r22.selected = $event; })("change", function ShareReportDialogComponent_div_57_div_12_Template_input_change_3_listener() { i0.ɵɵrestoreView(_r26); const ctx_r27 = i0.ɵɵnextContext(2); return ctx_r27.checkIfAllSelected(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "label", 54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 55);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 56);
    i0.ɵɵelementStart(8, "div", 57);
    i0.ɵɵelementStart(9, "div", 58);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, ShareReportDialogComponent_div_57_div_12_span_11_Template, 1, 3, "span", 59);
    i0.ɵɵtemplate(12, ShareReportDialogComponent_div_57_div_12_span_12_Template, 3, 3, "span", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span", 61);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "span", 62);
    i0.ɵɵlistener("click", function ShareReportDialogComponent_div_57_div_12_Template_span_click_15_listener() { const restoredCtx = i0.ɵɵrestoreView(_r26); const user_r22 = restoredCtx.$implicit; const ctx_r28 = i0.ɵɵnextContext(2); return ctx_r28.openDeletePopup(user_r22, true); });
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const user_r22 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "user-checkbox-", user_r22.fullName, "");
    i0.ɵɵproperty("ngModel", user_r22.selected);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "user-checkbox-", user_r22.fullName, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(user_r22.shortName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c2$5, user_r22.isDnasUser));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(user_r22.userName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", user_r22.isDnasUser);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", user_r22.isDnasUser);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", user_r22.fullName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 10, "shared-lib.share-reports.sh-report-removeTxt"));
} }
function ShareReportDialogComponent_div_57_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtemplate(1, ShareReportDialogComponent_div_57_span_1_Template, 7, 7, "span", 43);
    i0.ɵɵtemplate(2, ShareReportDialogComponent_div_57_span_2_Template, 7, 7, "span", 43);
    i0.ɵɵelementStart(3, "div", 44);
    i0.ɵɵelementStart(4, "div", 45);
    i0.ɵɵelementStart(5, "div", 46);
    i0.ɵɵelementStart(6, "span", 47);
    i0.ɵɵelementStart(7, "input", 48);
    i0.ɵɵlistener("ngModelChange", function ShareReportDialogComponent_div_57_Template_input_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.selectedAll = $event; })("change", function ShareReportDialogComponent_div_57_Template_input_change_7_listener() { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(); return ctx_r31.selectAllUsers(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "label", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 50);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, ShareReportDialogComponent_div_57_div_12_Template, 18, 14, "div", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.noOfUsers === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.noOfUsers > 1);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r5.selectedAll);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 5, "shared-lib.share-reports.selectAllTxt"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r5.userList);
} }
const _c3$5 = function (a0) { return { "disabled-delete": a0 }; };
function ShareReportDialogComponent_div_66_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "div", 66);
    i0.ɵɵelementStart(2, "span", 67);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 68);
    i0.ɵɵlistener("click", function ShareReportDialogComponent_div_66_Template_div_click_6_listener() { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(); return ctx_r32.openDeletePopup(null, false); });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.selectedUsersCount, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r6.selectedUserText, " ", i0.ɵɵpipeBind1(5, 5, "shared-lib.share-reports.sh-report-selectedTxt"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c3$5, ctx_r6.selectedUsersCount === 0));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 7, "shared-lib.share-reports.sh-report-delTxt"), " ");
} }
const _c4$2 = function (a0) { return { "disabled-rreport-ename": a0 }; };
function ShareReportDialogComponent_div_67_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵelementStart(1, "div", 70);
    i0.ɵɵlistener("click", function ShareReportDialogComponent_div_67_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(); return ctx_r34.openEditReportNamePopup(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 71);
    i0.ɵɵelementStart(3, "div", 72);
    i0.ɵɵelementStart(4, "h4");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 73);
    i0.ɵɵlistener("click", function ShareReportDialogComponent_div_67_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r35); const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.closeEditReportNamePopup(); });
    i0.ɵɵtext(8, " \uE909 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 74);
    i0.ɵɵelementStart(10, "input", 75);
    i0.ɵɵlistener("ngModelChange", function ShareReportDialogComponent_div_67_Template_input_ngModelChange_10_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r37 = i0.ɵɵnextContext(); return ctx_r37.editreportName = $event; })("keyup", function ShareReportDialogComponent_div_67_Template_input_keyup_10_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r38 = i0.ɵɵnextContext(); return ctx_r38.reportNameChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 76);
    i0.ɵɵelementStart(12, "span", 77);
    i0.ɵɵlistener("click", function ShareReportDialogComponent_div_67_Template_span_click_12_listener() { i0.ɵɵrestoreView(_r35); const ctx_r39 = i0.ɵɵnextContext(); return !ctx_r39.disableRename && ctx_r39.editEventName(); });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "span", 78);
    i0.ɵɵlistener("click", function ShareReportDialogComponent_div_67_Template_span_click_15_listener() { i0.ɵɵrestoreView(_r35); const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.closeEditReportNamePopup(); });
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 5, "shared-lib.share-reports.sh-report-renameTxt"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r7.editreportName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c4$2, ctx_r7.disableRename));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 7, "shared-lib.share-reports.sh-report-renameTxt"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 9, "shared-lib.share-reports.sh-report-cancelTxt"));
} }
function ShareReportDialogComponent_div_68_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵlistener("click", function ShareReportDialogComponent_div_68_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r42); const ctx_r41 = i0.ɵɵnextContext(); return ctx_r41.closeDelete(); });
    i0.ɵɵelementStart(1, "div", 80);
    i0.ɵɵelement(2, "span", 81);
    i0.ɵɵelementStart(3, "h3", 82);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 83);
    i0.ɵɵelementStart(6, "span", 84);
    i0.ɵɵlistener("click", function ShareReportDialogComponent_div_68_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r42); const ctx_r43 = i0.ɵɵnextContext(); return ctx_r43.callDelete(); });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 85);
    i0.ɵɵlistener("click", function ShareReportDialogComponent_div_68_Template_span_click_9_listener() { i0.ɵɵrestoreView(_r42); const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.closeDelete(); });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate3("", ctx_r8.deleteWarning, " ", ctx_r8.appName, " ", ctx_r8.shareTitle, "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 5, "shared-lib.share-reports.sh-report-removeTxt"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 7, "shared-lib.share-reports.sh-report-cancelTxt"));
} }
const _c5 = function (a0) { return { "disabled-share": a0 }; };
class ShareReportDialogComponent {
    constructor(locationService, dataService, shareReportsService, router, formBuilder, translate, dialog, dialogRef, data) {
        this.locationService = locationService;
        this.dataService = dataService;
        this.shareReportsService = shareReportsService;
        this.router = router;
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.data = data;
        this.unsubscribe$ = new Subject();
        this.showModal = false;
        this.error = "";
        this.emailList = [];
        this.recipients = [];
        this.message = "Sharing Report";
        this.submittedFields = false;
        this.showReportNamePopup = false;
        this.disableRename = true;
        this.allowReshare = false;
        this.invalidEmail = true;
        this.emailError = false;
        this.userList = [];
        this.selectedUsers = [];
        this.selectedUserText = "";
        this.showDeletePopup = false;
        this.showTooltip = false;
        this.noOfUsers = 0;
        this.userText = "user";
        this.isDNASUser = false;
        this.messageKeys = [];
        this.emailPlaceholder = "";
        this.messagePlaceholder = "";
        this.deleteWarning = "";
        this.showPreviewLoader = true;
        this.onShowEmitter = new EventEmitter();
        this.selectAllUsers = () => {
            // select all checkbox
            this.selectedUsersCount = 0;
            for (let i = 0; i < this.userList.length; i++) {
                this.userList[i].selected = this.selectedAll;
                if (this.selectedAll) {
                    this.selectedUsersCount++;
                }
            }
            this.setUserText(this.selectedUsersCount, "selectedUsers");
        };
        this.closePopupModal = () => {
            this.emailError = false;
            this.showReportNamePopup = false;
            this.showModal = false;
            // document.getElementById("shareReportPopup").style.display = "none";
            this.emailList = [];
            $("#email-textarea").val("");
            this.dialogRef.close();
        };
        this.openEditReportNamePopup = () => {
            this.editreportName = this.shareTitle;
            this.showReportNamePopup = true;
        };
        this.closeEditReportNamePopup = () => {
            this.showReportNamePopup = false;
            //this.dialogRef.close();
        };
        this.removeEmail = (event, i) => {
            if (event && event.target && event.target.parentElement) {
                event.target.parentElement.remove();
                if (i > -1) {
                    this.emailList.splice(i, 1);
                }
                this.checkHasInvalidEmail();
            }
        };
        this.checkHasInvalidEmail = () => {
            if (this.emailList && this.emailList.length > 0) {
                this.emailError =
                    this.emailList.filter((e) => e.valid === false).length > 0;
            }
            else {
                this.error = this.messageKeys["emailErrorMsg"];
                this.emailError = true;
            }
        };
        this.openDeletePopup = (user, singleUser) => {
            this.showDeletePopup = true;
            if (singleUser) {
                this.userToDelete = user;
            }
        };
        this.shareReport = () => {
            this.checkHasInvalidEmail();
            if (!this.canvasData)
                this.onShowEmitter.emit(true);
            if (this.emailError || this.emailList.length <= 0) {
                return;
            }
            else {
                this.emailError = false;
                this.recipients = this.emailList.map((email) => {
                    return {
                        id: email.email.trim(),
                        name: this.getNameFromEmailAddress(email.email)
                    };
                });
                this.submittedFields = true;
                // if (this.eventForm.invalid) {
                // } else {
                this.dataService.display(true);
                if (this.allowReshare) {
                    this.prepareReshareReport();
                }
                else {
                    this.prepareReport();
                }
                // }
            }
        };
        this.prepareReshareReport = () => {
            const report = {
                recipients: this.recipients,
                message: this.message
            };
            this.shareReportsService
                .reShareReport(report)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((res) => {
                if (res) {
                    if (res.status &&
                        res.data &&
                        Object.keys(res.data).length > 0) {
                        this.getUserList();
                        this.showModal = false;
                        this.dialogRef.close();
                        // document.getElementById(
                        // 	"shareReportPopup"
                        // ).style.display = "none";
                        this.dataService.setToastMessage(this.messageKeys["sh-report-successMsg"], 2000, null, null, "success");
                        this.dataService.display(false);
                    }
                    else if (res.status === false) {
                        this.dataService.setToastMessage(res.message, 4000, null, null, "error");
                        this.dialogRef.close();
                        this.dataService.display(false);
                    }
                }
            }, (error) => {
                console.log("Detail error::", error);
                this.dialogRef.close();
            });
        };
        this.getUserList = () => {
            const params = {
                sharedPath: this.appPath,
                appName: this.appName,
                shareParams: this.sharedParams.appConfig
                    ? this.sharedParams.appConfig
                    : null,
                sender: {
                    id: this.sender,
                    name: this.getNameFromEmailAddress(this.sender)
                }
            };
            this.shareReportsService
                .getSharedUserList(params)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data && data.status && data.data !== null) {
                    const res = data.data;
                    this.userList = res.userList ? res.userList : null;
                    this.isDNASUser = res.isDnasUser;
                    if (!this.allowReshare) {
                        this.guid = res.guid ? res.guid : null;
                    }
                    this.noOfUsers = res.count;
                    this.userList.forEach((user) => {
                        if (/^ *$/.test(user.fullName)) {
                            user.fullName = this.getNameFromEmailAddress(user.userName);
                        }
                        if (user.fullName) {
                            user.shortName = this.getShortName(user.fullName, user.userName);
                        }
                    });
                }
                else {
                    this.userList = [];
                    this.noOfUsers = 0;
                }
                this.setUserText(this.noOfUsers, "noOfUsers");
            }, (error) => {
                console.log("::Error in user list API call::", error);
            });
        };
        this.setUserText = (count, type) => {
            if (type === "noOfUsers") {
                if (count > 1) {
                    this.userText = this.messageKeys["usersTxt"];
                }
                else {
                    this.userText = this.messageKeys["userTxt"];
                }
            }
            else {
                if (count > 1) {
                    this.selectedUserText = this.messageKeys["userscpsTxt"];
                }
                else {
                    this.selectedUserText = this.messageKeys["usercpsTxt"];
                }
            }
        };
        this.getShortName = (name, email) => {
            let matchChars;
            let chars;
            if (/^ *$/.test(name)) {
                chars = email.charAt(0);
            }
            else {
                matchChars = name.match(/\b(\w)/g);
                chars = matchChars.join("");
            }
            return chars.toUpperCase();
        };
        this.prepareReport = () => {
            const reqBody = this.prepareReportParams();
            this.shareReportsService
                .shareReport(reqBody)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((res) => {
                if (res) {
                    if (res.status &&
                        res.data &&
                        Object.keys(res.data).length > 0) {
                        this.emailList = [];
                        this.showModal = false;
                        // document.getElementById(
                        // 	"shareReportPopup"
                        // ).style.display = "none";
                        this.dialogRef.close();
                        this.dataService.setToastMessage(this.messageKeys["sh-report-successMsg"], 2000, null, null, "success");
                        this.dataService.display(false);
                    }
                    else if (res.status === false) {
                        this.dataService.setToastMessage(res.message, 4000, null, null, "error");
                        this.dialogRef.close();
                        this.dataService.display(false);
                    }
                }
            }, (error) => {
                console.log("Detail error::", error);
                this.dialogRef.close();
            });
        };
        this.prepareReportParams = () => {
            return {
                initiator: {
                    id: this.initiator,
                    name: this.getNameFromEmailAddress(this.initiator)
                },
                sender: {
                    id: this.sender,
                    name: this.getNameFromEmailAddress(this.sender)
                },
                reportName: this.shareTitle,
                recipients: this.recipients,
                sharedPath: this.appPath,
                canvasData: this.canvasData,
                filePath: "report/image/",
                shareParams: this.sharedParams.appConfig
                    ? this.sharedParams.appConfig
                    : null,
                appName: this.appName,
                message: this.message
            };
        };
        this.getNameFromEmailAddress = (email) => {
            const eNameMatch = email.match(/^([^@]*)@/);
            const name = eNameMatch
                ? eNameMatch[1].charAt(0).toUpperCase() + eNameMatch[1].slice(1)
                : email;
            return name;
        };
        this.reportNameChange = (event) => {
            this.editreportName = event.target.value;
            if (this.editreportName.replace(/\s/g, "").length === 0) {
                this.disableRename = true;
            }
            else {
                this.disableRename = false;
            }
        };
        this.editEventName = () => {
            this.shareTitle = this.editreportName;
            this.closeEditReportNamePopup();
        };
        this.closeDelete = () => {
            this.showDeletePopup = false;
            //this.dialogRef.close();
        };
        this.callDelete = () => {
            this.selectedUsers = [];
            this.userList.forEach((user) => {
                if (user.selected) {
                    this.selectedUsers.push(user.userName);
                }
            });
            this.deleteUser(this.selectedUsers);
        };
        this.onBlur = (event) => {
            event.keyCode = 999;
            this.validateEmail(event);
            event.preventDefault();
        };
        this.deleteUser = (user) => {
            let users = [];
            if (this.userToDelete) {
                users.push(this.userToDelete.userName);
            }
            else if (this.selectedUsers.length > 0) {
                users = this.selectedUsers;
            }
            else {
                users.push(user.userName);
            }
            const userObj = { recipients: users };
            this.shareReportsService
                .revokeUsers(userObj, this.guid)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data && data.status) {
                    this.userList = this.userList.filter((ar) => !users.find((rm) => rm === ar.userName));
                    this.noOfUsers = this.userList.length;
                    this.setUserText(this.noOfUsers, "noOfUsers");
                    this.selectedUsersCount = 0;
                    this.dataService.setToastMessage(this.messageKeys["revokeAlertMsg"], 4000, null, null, "success");
                    this.showDeletePopup = false;
                }
            }, (error) => {
                console.log("::Error in revoke API call::", error);
            });
        };
        this.validateOnPaste = (event) => {
            const clipboardData = event.clipboardData;
            const pastedText = clipboardData.getData("text");
            const email = pastedText;
            const pattern = new RegExp(",|;|:");
            // let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
            const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const tokens = email.split(pattern);
            tokens.map((token) => {
                if (token.indexOf("<") > -1) {
                    const match = /<(.*?)>/.exec(token);
                    match[1] = match[1].trim();
                    this.emailTest(EMAIL_REGEXP, match[1]);
                }
                else {
                    token = token.trim();
                    this.emailTest(EMAIL_REGEXP, token);
                }
            });
            $("#email-textarea").val("");
            // clipboardData.setData('text/plain', '');
            event.preventDefault();
            console.log(this.emailList);
        };
        this.validateEmail = (event) => {
            let email = event.target.value;
            email = email.trim();
            // let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
            const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (email &&
                (event.keyCode === 188 ||
                    email.includes(",") ||
                    email.includes(" ,"))) {
                // 188 = Comma
                event.preventDefault();
                const list = email.split(",");
                for (let i = 0; i < list.length; i++) {
                    list[i].trim();
                    if (list[i].length > 0) {
                        this.emailTest(EMAIL_REGEXP, list[i]);
                    }
                }
                event.target.value = "";
            }
            else if (email &&
                (event.keyCode === 999 ||
                    event.keyCode === 13 ||
                    event.keyCode === 32 ||
                    event.keyCode === 9 ||
                    event.keyCode === 186 ||
                    event.keyCode === 59)) {
                // 999 = blur, 186/59 = Semicolon, 9 = Tab, 32 = Space, 13 = enter
                if (event.preventDefault()) {
                    event.preventDefault();
                }
                else {
                    event.stopPropagation();
                }
                email = email.replace(/[,;]$/, "");
                this.emailTest(EMAIL_REGEXP, email);
                event.target.value = "";
                return false;
            }
            else if (email === "" && event.keyCode === 8) {
                // 8 = delete
                const idList = document.getElementById("ids1");
                if (idList) {
                    this.emailList.splice(-1, 1);
                    idList.removeChild(idList.lastChild);
                }
            }
            return true;
        };
        this.emailTest = (EMAIL_REGEXP, email) => {
            if (EMAIL_REGEXP.test(email)) {
                this.emailError = false;
                // this.emailList.push(email);
                this.emailList.push({ email: email, valid: true });
            }
            else {
                this.emailList.push({ email: email, valid: false });
            }
        };
        this.onClick = (el) => {
            const ele = el;
            if (ele && ele.parentElement) {
                ele.parentElement.remove();
            }
        };
        this.setMessage = (event) => {
            this.message = event.target.value;
        };
        if (this.data) {
            this.showModal = data.showModal,
                this.sender = data.sender,
                this.initiator = data.initiator,
                this.error = data.error,
                this.emailList = data.emailList,
                this.recipients = data.recipients,
                this.message = data.message,
                this.eventForm = data.eventForm,
                this.submittedFields = data.submittedFields,
                this.element = data.element,
                this.canvasData = data.canvasData,
                this.showReportNamePopup = data.showReportNamePopup,
                this.editreportName = data.editreportName,
                this.disableRename = data.disableRename,
                this.sharedParams = data.sharedParams,
                this.allowReshare = data.allowReshare,
                this.shareTitle = data.shareTitle,
                this.appPath = data.appPath,
                this.appName = data.appName,
                this.invalidEmail = data.invalidEmail,
                this.emailError = data.emailError,
                this.userList = data.userList,
                this.selectedUsers = data.selectedUsers,
                this.selectedUsersCount = data.selectedUsersCount,
                this.selectedUserText = data.selectedUserText,
                this.userToDelete = data.userToDelete,
                this.selectedAll = data.selectedAll,
                this.showDeletePopup = data.showDeletePopup,
                this.showTooltip = data.showTooltip,
                this.noOfUsers = data.noOfUsers,
                this.userText = data.userText,
                this.guid = data.guid,
                this.isDNASUser = data.isDNASUser,
                this.timer = data.timer,
                this.messageKeys = data.messageKeys;
        }
    }
    ngOnInit() {
        this.showPreviewLoader = false;
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localized string here
            this.translate.get('shared-lib.share-reports').subscribe((res) => {
                this.messageKeys = res;
                this.emailPlaceholder = this.messageKeys["emailPlaceholder"];
                this.error = this.messageKeys["emailInvalidAlertMsg"];
                this.messagePlaceholder = this.messageKeys["messagePlaceholder"];
                this.deleteWarning = this.messageKeys["deleteWarning"];
            });
        });
    }
    checkIfAllSelected() {
        // Individual checkbox
        this.selectedUsersCount = 0;
        const that = this;
        this.selectedAll = this.userList.every(function (user) {
            return user.selected === true;
        });
        this.userList.forEach((user) => {
            if (user.selected) {
                this.selectedUsersCount++;
            }
        });
        this.setUserText(this.selectedUsersCount, "selectedUsers");
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        this.dialogRef.close();
    }
}
ShareReportDialogComponent.ɵfac = function ShareReportDialogComponent_Factory(t) { return new (t || ShareReportDialogComponent)(i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(ShareReportsService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2$1.FormBuilder), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i4$2.MatDialog), i0.ɵɵdirectiveInject(i4$2.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
ShareReportDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ShareReportDialogComponent, selectors: [["lib-share-report-dialog"]], outputs: { onShowEmitter: "onShowEmitter" }, decls: 69, vars: 46, consts: [["id", "shareReportPopup", 1, "modalPopup", "modalPopupLg", "share-report-popup"], ["id", "modalContent", 1, "modalContent-connector"], [1, "modalHeader"], ["mat-dialog-title", "", 1, "modal-header-title"], [1, "modalCloseIcon", 3, "click"], [1, "report-basi-info"], ["class", "editReport", 3, "click", 4, "ngIf"], ["id", "modalContent"], [1, "modalBody"], [1, "share-report-warning"], [1, "Warning-icon"], [1, "event-label"], [1, "report-modalBody"], ["class", "invalid-eventForm", 4, "ngIf"], [1, "share-report-container", "mb10"], ["id", "full", 1, "email-wrapper", 2, "max-height", "694px", "text-align", "center", "display", "inline-block"], [1, "w0", 2, "text-align", "left"], ["class", "share-framework-mails", "id", "ids1", 4, "ngIf"], ["tabindex", "-1", "aria-hidden", "false", "type", "email", 1, "email-input", 3, "placeholder"], ["rows", "1", "id", "email-textarea", "name", "to", "spellcheck", "false", "autocomplete", "false", "autocapitalize", "false", "dir", "ltr", "role", "combobox", "autofocus", "", 1, "email-textarea", 2, "width", "471px", 3, "placeholder", "blur", "keydown", "paste"], ["type", "text", 1, "message", 3, "placeholder", "keyup"], [1, "share-report-container", "mb20"], [1, "preview-image"], ["id", "previewImage"], ["class", "preview-loader-container", 4, "ngIf"], ["class", "shared-users-list", 4, "ngIf"], [1, "modalFooter"], ["id", "shareBtn", 3, "ngClass", "click"], [1, "cancel-button", 3, "click"], ["class", "footer-right", 4, "ngIf"], ["class", "report-namepopup-wrap", 4, "ngIf"], ["class", "delete-popup-overlay", 3, "click", 4, "ngIf"], [1, "editReport", 3, "click"], [1, "invalid-eventForm"], ["id", "ids1", 1, "share-framework-mails"], [4, "ngFor", "ngForOf"], ["class", "share-framework-email-ids", 3, "ngClass", 4, "ngIf"], [1, "share-framework-email-ids", 3, "ngClass"], ["id", "i", 1, "share-framework-cancel-email", 3, "click"], [1, "preview-loader-container"], [1, "preview-loader"], [1, "shared-users-list"], [1, "no-user"], [4, "ngIf"], [1, "users-list"], [1, "select-all-section"], [1, "column", "checkbox-column"], [1, "user-checkbox"], ["type", "checkbox", "id", "selectallUsers", 3, "ngModel", "ngModelChange", "change"], ["for", "selectallUsers", 1, "checkbox-label"], [1, "column"], ["class", "user", 4, "ngFor", "ngForOf"], [1, "user"], ["type", "checkbox", 3, "id", "ngModel", "ngModelChange", "change"], [1, "checkbox-label", 3, "for"], [1, "column", "profile"], [1, "column", "email-name"], [1, "user-email", 3, "ngClass"], [1, "email"], ["class", "badge-icon", 3, "ngClass", 4, "ngIf"], ["class", "tip-content", 4, "ngIf"], [1, "user-name"], [1, "remove", 3, "click"], [1, "badge-icon", 3, "ngClass"], [1, "tip-content"], [1, "footer-right"], [1, "selected-users"], [1, "users-count"], [1, "revoke-button", 3, "ngClass", "click"], [1, "report-namepopup-wrap"], [1, "reportNameoverlay", 3, "click"], [1, "reportNamecontainer"], ["mat-dialog-title", "", 1, "reportNameheader"], [1, "close-rename-modal", "modalCloseIcon", 3, "click"], ["mat-dialog-content", "", 1, "reportNamebody"], ["name", "eventName", 3, "ngModel", "ngModelChange", "keyup"], ["mat-dialog-actions", "", 1, "reportNamefooter"], [3, "ngClass", "click"], [1, "cancel-rename", 3, "click"], [1, "delete-popup-overlay", 3, "click"], [1, "delete-popup"], [1, "delete-warning-icon"], [1, "delete-warning"], [1, "warning-buttons"], [1, "warn-delete-button", 3, "click"], [3, "click"]], template: function ShareReportDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "section", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div");
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "span", 4);
        i0.ɵɵlistener("click", function ShareReportDialogComponent_Template_span_click_7_listener() { return ctx.closePopupModal(); });
        i0.ɵɵtext(8, "\uE909");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 5);
        i0.ɵɵelementStart(10, "span");
        i0.ɵɵtext(11);
        i0.ɵɵpipe(12, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "span");
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, ShareReportDialogComponent_span_15_Template, 1, 0, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "mat-dialog-content");
        i0.ɵɵelementStart(17, "div");
        i0.ɵɵelementStart(18, "div");
        i0.ɵɵelementStart(19, "div", 7);
        i0.ɵɵelementStart(20, "div", 8);
        i0.ɵɵelementStart(21, "div", 9);
        i0.ɵɵelement(22, "div", 10);
        i0.ɵɵelementStart(23, "div");
        i0.ɵɵelementStart(24, "div", 11);
        i0.ɵɵtext(25);
        i0.ɵɵpipe(26, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "p");
        i0.ɵɵtext(28);
        i0.ɵɵpipe(29, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 12);
        i0.ɵɵtemplate(31, ShareReportDialogComponent_div_31_Template, 3, 1, "div", 13);
        i0.ɵɵelementStart(32, "form");
        i0.ɵɵelementStart(33, "div", 14);
        i0.ɵɵelementStart(34, "div", 11);
        i0.ɵɵtext(35);
        i0.ɵɵpipe(36, "translate");
        i0.ɵɵelementStart(37, "span");
        i0.ɵɵtext(38, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "div", 15);
        i0.ɵɵelementStart(40, "div", 16);
        i0.ɵɵtemplate(41, ShareReportDialogComponent_div_41_Template, 2, 1, "div", 17);
        i0.ɵɵelement(42, "input", 18);
        i0.ɵɵelementStart(43, "textarea", 19);
        i0.ɵɵlistener("blur", function ShareReportDialogComponent_Template_textarea_blur_43_listener($event) { return ctx.onBlur($event); })("keydown", function ShareReportDialogComponent_Template_textarea_keydown_43_listener($event) { return ctx.validateEmail($event); })("paste", function ShareReportDialogComponent_Template_textarea_paste_43_listener($event) { return ctx.validateOnPaste($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "div", 14);
        i0.ɵɵelementStart(45, "div", 11);
        i0.ɵɵtext(46);
        i0.ɵɵpipe(47, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(48, "input", 20);
        i0.ɵɵlistener("keyup", function ShareReportDialogComponent_Template_input_keyup_48_listener($event) { return ctx.setMessage($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(49, "div", 21);
        i0.ɵɵelementStart(50, "div", 11);
        i0.ɵɵtext(51);
        i0.ɵɵpipe(52, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(53, "div", 22);
        i0.ɵɵelement(54, "div", 23);
        i0.ɵɵtemplate(55, ShareReportDialogComponent_div_55_Template, 4, 0, "div", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(56, ShareReportDialogComponent_div_56_Template, 4, 3, "div", 25);
        i0.ɵɵtemplate(57, ShareReportDialogComponent_div_57_Template, 13, 7, "div", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(58, "mat-dialog-actions");
        i0.ɵɵelementStart(59, "div", 26);
        i0.ɵɵelementStart(60, "button", 27);
        i0.ɵɵlistener("click", function ShareReportDialogComponent_Template_button_click_60_listener() { return !ctx.emailError && !ctx.showPreviewLoader && ctx.shareReport(); });
        i0.ɵɵtext(61);
        i0.ɵɵpipe(62, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(63, "button", 28);
        i0.ɵɵlistener("click", function ShareReportDialogComponent_Template_button_click_63_listener() { return ctx.closePopupModal(); });
        i0.ɵɵtext(64);
        i0.ɵɵpipe(65, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(66, ShareReportDialogComponent_div_66_Template, 9, 11, "div", 29);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(67, ShareReportDialogComponent_div_67_Template, 18, 13, "div", 30);
        i0.ɵɵtemplate(68, ShareReportDialogComponent_div_68_Template, 12, 9, "div", 31);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 26, "shared-lib.share-reports.modal-header-title"));
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 28, "shared-lib.share-reports.shareTitle"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.shareTitle);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.allowReshare);
        i0.ɵɵadvance(10);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(26, 30, "shared-lib.share-reports.sh-report-warning"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(29, 32, "shared-lib.share-reports.sh-report-warning1"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.emailError);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(36, 34, "shared-lib.share-reports.sh-report-add-email"), " ");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.emailList && ctx.emailList.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("placeholder", ctx.emailPlaceholder);
        i0.ɵɵattribute("aria-label", ctx.emailPlaceholder);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("placeholder", ctx.emailPlaceholder);
        i0.ɵɵattribute("aria-label", ctx.emailPlaceholder);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(47, 36, "shared-lib.share-reports.sh-report-add-msg"));
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("placeholder", ctx.messagePlaceholder);
        i0.ɵɵattribute("aria-label", ctx.emailPlaceholder);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(52, 38, "shared-lib.share-reports.sh-report-preview"));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.showPreviewLoader);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.noOfUsers === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.noOfUsers > 0);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(44, _c5, ctx.emailError));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(62, 40, "shared-lib.share-reports.shareTxt"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(65, 42, "shared-lib.share-reports.sh-report-cancelTxt"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selectedUsersCount && ctx.selectedUsersCount > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showReportNamePopup);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showDeletePopup);
    } }, directives: [i4$2.MatDialogTitle, i1$2.NgIf, i4$2.MatDialogContent, i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i2$1.NgForm, i9.Dir, i4$2.MatDialogActions, i1$2.NgClass, i1$2.NgForOf, i2$1.CheckboxControlValueAccessor, i2$1.NgControlStatus, i2$1.NgModel, i2$1.DefaultValueAccessor], pipes: [i2.TranslatePipe], styles: ["button#shareBtn[_ngcontent-%COMP%]{cursor:pointer;padding:8px 50px;background:#049fd9;color:#fff;font-family:CiscoSans;font-size:14px;line-height:20px;text-align:center;border-radius:10px;border-color:transparent}.share-report-popup[_ngcontent-%COMP%], .edit-report-popup[_ngcontent-%COMP%]{background:rgba(0,0,0,.38);z-index:10001}.modalPopup[_ngcontent-%COMP%]   .modalContent-connector[_ngcontent-%COMP%]{width:30%;right:0;height:100%;z-index:1001;position:absolute;top:0px;background-color:#fff;box-shadow:0 0 10px #0000001a;border-radius:0;overflow:hidden;border-left:3px solid #049FD9;animation:slide .5s forwards}.modalFooter[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:15px 0 15px 24px!important;position:static!important}button.cancel-button[_ngcontent-%COMP%]{color:#049fd9;font-family:CiscoSans;font-size:14px;line-height:20px;text-align:center;border:0 none;background:transparent}.share-report-popup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{z-index:9999;padding-right:40px}.share-report-popup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{overflow-y:auto;height:76%}.edit-report-popup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{z-index:9999;padding-right:40px}.edit-report-popup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{overflow-y:auto;height:60%}.modalBody[_ngcontent-%COMP%]{padding:0!important}.share-report-container[_ngcontent-%COMP%]{position:relative;z-index:1000;padding-left:25px}.Warning-icon[_ngcontent-%COMP%]{width:21px;height:20px;background-image:url(../../../../assets/images/share-framework/warning.svg);background-size:contain;background-repeat:no-repeat;margin-right:10px}.share-report-warning[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}.share-report-warning[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0}input.event[_ngcontent-%COMP%]{padding-left:0;color:#565659;font-family:CiscoSansRegular;font-size:15px}.invalid-eventForm[_ngcontent-%COMP%]{border-radius:4px;background-color:#ff707042;color:#e00;font-family:CiscoSans;font-size:14px;padding:10px 15px;margin-bottom:25px;margin-left:25px}.is-invalid[_ngcontent-%COMP%]{border-bottom:1px solid #EE0000!important}.share-report-location[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#58585b;font-family:CiscoSansRegular;font-size:14px;letter-spacing:.03px}.share-report-popup[_ngcontent-%COMP%]   .modalContent-connector[_ngcontent-%COMP%]{width:70%!important;margin:auto!important;left:200px;height:75%!important;bottom:0;border:0!important}.report-modalBody[_ngcontent-%COMP%]{padding:0 50px 0 0;width:50%;border-right:2px solid rgba(0,0,0,.1);display:inline-block}.event-label[_ngcontent-%COMP%]{color:#565659;font-family:CiscoSansRegular;font-size:12px}.modalHeader[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{color:#39393b;font-family:CiscoSansLight;font-size:24px;font-weight:300;letter-spacing:1px;line-height:22px}.modalHeader[_ngcontent-%COMP%]{height:auto!important;padding:18px 30px 8px!important}.share-report-warning[_ngcontent-%COMP%]{border-bottom:1px solid #fbab18;margin-bottom:30px;padding:10px 30px;position:relative}.report-namepopup-wrap[_ngcontent-%COMP%]{position:relative;z-index:999999;width:100%;height:auto;left:0;right:0;margin:auto;top:250px}.reportNameoverlay[_ngcontent-%COMP%]{background-color:#0000004d;position:fixed;width:100%;height:100%;top:0;z-index:1001}.cancel-rename[_ngcontent-%COMP%]{color:#049fd9!important;background-color:transparent!important;font-size:12px!important}.report-basi-info[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:15px}.editReport[_ngcontent-%COMP%]:after{background:url(/assets/images/impact-analysis/edit.svg) no-repeat;content:\"\";width:15px;height:14px;position:absolute;bottom:0;top:43px;margin-left:15px;background-size:contain;background-position:center}.editReport[_ngcontent-%COMP%]:hover:before{cursor:pointer}.modalCloseIcon[_ngcontent-%COMP%]{color:#999999d1}input[type=text][_ngcontent-%COMP%], input[type=email][_ngcontent-%COMP%]{padding:10px 10px 10px 0!important}.name-of-campaign[_ngcontent-%COMP%]{display:inline-block;margin:15px 0;font-family:CiscoSansExtraLight;font-size:30px;position:relative}.reportNamecontainer[_ngcontent-%COMP%]{width:30%;margin:auto;background-color:#fff;z-index:9999!important;position:absolute;left:0;right:0;top:15%;box-shadow:0 0 10px #00004791}.reportNameheader[_ngcontent-%COMP%]{position:relative;border-bottom:1px solid #E9E9E9;display:inline-block;vertical-align:middle;width:100%}.reportNameheader[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{padding-left:1.33em}span.event-name-error[_ngcontent-%COMP%]{display:block;width:85%;margin:auto;padding:1.33em;font-size:14px;color:#e00;font-family:CiscoSansTT}.reportNamebody[_ngcontent-%COMP%]{padding:1.33em;display:flex;align-items:center;justify-content:center}.reportNamebody[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border:0 none;border-radius:2px;background-color:#fff;border-bottom:2px solid #00A1DF;padding:15px 5px;font-size:16px;text-align:center;width:85%}.reportNamefooter[_ngcontent-%COMP%]{padding:2em 1.33em;box-shadow:0 -1px #d7d9da;margin-top:50px}.reportNamefooter[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;letter-spacing:.5px;border-radius:6px;background-color:#049fd9;margin-right:20px;padding:.7em 1.8em;cursor:pointer}span.disabled-rreport-ename[_ngcontent-%COMP%]{opacity:.3;cursor:not-allowed!important}.edit-modalContent[_ngcontent-%COMP%]{width:30%;margin:auto;background-color:#fff;z-index:9999!important;position:absolute;left:0;right:0;top:20%}span.editReport[_ngcontent-%COMP%]{cursor:pointer}.email-wrapper[_ngcontent-%COMP%]{width:100%;border:none;border-bottom:1px solid #9e9ea2;line-height:20px;min-height:auto;padding:8px 0 3px;outline:none;justify-content:space-between;position:relative}input.email-input[_ngcontent-%COMP%]{position:absolute;width:1px;left:-10000px}.email-textarea[_ngcontent-%COMP%]{height:20px!important;line-height:20px;text-align:left;overflow:hidden;resize:none;color:#000;border:0!important;font-size:14px!important;font-family:CiscoSans}textarea[_ngcontent-%COMP%]:focus{direction:ltr;unicode-bidi:-webkit-isolate;unicode-bidi:isolate}.preview-image[_ngcontent-%COMP%]{position:relative}#previewImage[_ngcontent-%COMP%]{min-height:300px;width:100%;overflow-x:auto}.preview-loader-container[_ngcontent-%COMP%]{position:absolute;background:rgba(0,0,0,.1);height:100%;width:100%;overflow:hidden;z-index:100001;margin-top:20px;top:0}.preview-loader[_ngcontent-%COMP%]{position:absolute;width:75px;height:100%;left:0;right:0;top:35%;margin:auto}.preview-loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{position:absolute;border:4px solid #fff;opacity:1;border-radius:50%;animation:1s cubic-bezier(0,.2,.8,1) infinite lds-ripple}.preview-loader[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(2){animation-delay:-.5s}.shared-users-list[_ngcontent-%COMP%]{display:inline-block;width:49%;vertical-align:top}.shared-users-list[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:11px;line-height:13px;letter-spacing:.6px;padding-left:3em}.shared-users-list[_ngcontent-%COMP%] > span[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:12px}.users-list[_ngcontent-%COMP%]{padding-top:1em}.column[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}.select-all-section[_ngcontent-%COMP%]{padding-bottom:1em;padding-left:2em}.select-all-section[_ngcontent-%COMP%]   .column.checkbox-column[_ngcontent-%COMP%]{margin-right:1em}.select-all-section[_ngcontent-%COMP%]   .column[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;color:#000;line-height:19px}.column.profile[_ngcontent-%COMP%]{margin-right:1em;margin-left:1em;background:#e9e9e9;color:#39393b;font-family:CiscoSans;font-size:10px;border-radius:50%;width:30px;height:30px;display:inline-flex!important;justify-content:center;align-items:center}.user-email[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:13px;line-height:15px;letter-spacing:.583333px;color:#000}span.user-name[_ngcontent-%COMP%]{color:#0006!important;font-family:CiscoSans;font-size:10px;line-height:14px;letter-spacing:.6px}.user[_ngcontent-%COMP%]{padding:10px 0 10px 2em;border-top:1px solid #dddfe2;position:relative}.user[_ngcontent-%COMP%]:last-child{border-bottom:1px solid #DDDFE2}.footer-right[_ngcontent-%COMP%]{position:absolute;right:0;top:0;bottom:0;margin:auto;display:flex;align-items:center}.footer-right[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{margin-right:3em}.selected-users[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:12px;line-height:16px;letter-spacing:.583333px}.revoke-button[_ngcontent-%COMP%]{border:1px solid #049FD9;box-sizing:border-box;border-radius:6px;font-size:14px;line-height:19px;letter-spacing:.6px;color:#049fd9;font-family:CiscoSans;padding:8px 20px;cursor:pointer}span.users-count[_ngcontent-%COMP%]{color:#fff;font-size:14px;letter-spacing:.666667px;font-family:CiscoSans;background:#626469;text-align:center;border-radius:50%;display:inline-flex;width:30px;height:30px;align-items:center;margin-right:6px;justify-content:center}.user[_ngcontent-%COMP%]:hover{background-color:#f5f5f5}span.remove[_ngcontent-%COMP%]{cursor:pointer;font-family:CiscoSans;font-size:10px;line-height:12px;letter-spacing:.583333px;color:#049fd9;position:absolute;right:4em;top:0;display:none;height:100%}.delete-popup-overlay[_ngcontent-%COMP%]{position:fixed;background-color:#4d4d4dbf;top:0;bottom:0;width:100%;left:0;right:0;z-index:10000;text-align:center;display:flex;align-items:center}.delete-popup[_ngcontent-%COMP%]{width:42%;margin:auto;border-radius:2px;background-color:#fff;box-shadow:0 3px 1px -2px #00090d26,0 2px 2px #00090d1f,0 1px 5px #00090d1a;padding:40px}.delete-warning-icon[_ngcontent-%COMP%]{background:transparent url(../../../../assets/images/impact-analysis/alert-icon.svg) no-repeat;width:56px;height:56px;margin:auto}.delete-warning[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:24px;padding-top:15px;padding-bottom:14px;width:80%;margin:auto}.delete-popup[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#565659;font-family:CiscoSansLight;font-size:14px;display:block}.warning-buttons[_ngcontent-%COMP%]{margin-top:30px}.warning-buttons[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px;border:1px solid #049FD9;border-radius:6px;background-color:#fff;color:#049fd9;padding:8px 30px;margin:7px;display:inline-block!important;vertical-align:middle;cursor:pointer}.warn-delete-button[_ngcontent-%COMP%]{background-color:#049fd9!important;color:#fff!important}.user-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]{display:none}.user-checkbox[_ngcontent-%COMP%]   .checkbox-label[_ngcontent-%COMP%]{display:block;width:20px;height:20px;cursor:pointer;position:relative}.user-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%] ~ .checkbox-label[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px 0px;content:\"\"}.user-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:hover ~ .checkbox-label[_ngcontent-%COMP%]:before{background-position:0px -18px;content:\"\"}.user-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:checked ~ .checkbox-label[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -36px;content:\"\"}.user-checkbox[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:disabled ~ .checkbox-label[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -54px;content:\"\"}.no-user[_ngcontent-%COMP%]{text-align:center;padding-top:2em;color:#39393b;font-family:CiscoSansLight;font-size:18px;line-height:28px}.user-email.dnas-badge[_ngcontent-%COMP%]{position:relative}.email[_ngcontent-%COMP%], span.badge-icon[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}span.badge-icon[_ngcontent-%COMP%]{background:url(../../../../assets/images/share-framework/dnas-badge.svg) no-repeat;content:\"\";width:14px;height:14px;margin-left:5px}span.badge-icon[_ngcontent-%COMP%]:hover:before{content:\"\";border:6px solid black;border-color:transparent transparent #555559 #555559;position:absolute;width:0;height:0;box-sizing:border-box;transform-origin:0 0;transform:rotate(-45deg);top:-9px}.tip-content[_ngcontent-%COMP%]{position:absolute;background:#565659;box-shadow:0 4px 8px #0000001a;border-radius:2px;color:#fff;padding:1em;display:none;top:-5em;min-width:230px}.badge-icon[_ngcontent-%COMP%]:hover ~ .tip-content[_ngcontent-%COMP%]{display:block}.user[_ngcontent-%COMP%]:hover > .remove[_ngcontent-%COMP%]{display:flex!important;align-items:center}.disabled-share[_ngcontent-%COMP%]{cursor:default!important;opacity:.5}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShareReportDialogComponent, [{
        type: Component,
        args: [{
                selector: 'lib-share-report-dialog',
                templateUrl: './share-report-dialog.component.html',
                styleUrls: ['./share-report-dialog.component.scss']
            }]
    }], function () { return [{ type: LocationService }, { type: DataService }, { type: ShareReportsService }, { type: i1.Router }, { type: i2$1.FormBuilder }, { type: i2.TranslateService }, { type: i4$2.MatDialog }, { type: i4$2.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, { onShowEmitter: [{
            type: Output
        }] }); })();

/* eslint-disable @typescript-eslint/no-explicit-any */
function ShareComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "shared-lib.share-reports.shareBtn-tooltip-msg"));
} }
const _c0$c = function (a0) { return { "disabled": a0 }; };
const moment$5 = moment_;
class ShareComponent {
    constructor(locationService, dataService, shareReportsService, router, formBuilder, translate, dialog) {
        this.locationService = locationService;
        this.dataService = dataService;
        this.shareReportsService = shareReportsService;
        this.router = router;
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.dialog = dialog;
        this.unsubscribe$ = new Subject();
        this.showEditPopup = false;
        this.showModal = false;
        this.emailPlaceholder = "";
        this.messagePlaceholder = "";
        this.error = "";
        this.emailPattern = /^((\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)\s*[,]{0,1}\s*)+$/;
        this.emailList = [];
        this.recipients = [];
        this.message = "Sharing Report";
        this.submittedFields = false;
        this.emailInputEntered = false;
        this.showReportNamePopup = false;
        this.disableRename = true;
        this.allowReshare = false;
        this.appComponentId = "";
        this.invalidEmail = true;
        this.showPreviewLoader = true;
        this.emailError = false;
        this.userList = [];
        this.selectedUsers = [];
        this.selectedUserText = "";
        this.showDeletePopup = false;
        this.showTooltip = false;
        this.deleteWarning = "";
        this.noOfUsers = 0;
        this.userText = "user";
        this.isDNASUser = false;
        this.shareTimer = 0;
        this.disableShareButton = false;
        this.showTooltipMessage = false;
        this.messageKeys = [];
        this.onShowEmitter = new EventEmitter();
        this.convertHTMLToImage = () => {
            this.canvasData = null;
            const prevEleId = "preview-ele-wrapper";
            const div = document.getElementById(this.appComponentId);
            const newDiv = document.createElement("div"); // create new div to clone the entire html
            newDiv.setAttribute("id", "duplicateEleWrapper");
            if (div) {
                div.parentNode.insertBefore(newDiv, div.nextSibling);
                document.getElementById("duplicateEleWrapper").style.width = "100%";
                document.getElementById("duplicateEleWrapper").style.height = "1px";
                document.getElementById("duplicateEleWrapper").style.overflow =
                    "hidden";
                $("#" + this.appComponentId)
                    .clone()
                    .attr("id", prevEleId)
                    .appendTo("#duplicateEleWrapper");
                const baseEleId = document.getElementById(prevEleId);
                baseEleId
                    .querySelectorAll(".add-widget-wrapper")
                    .forEach((el) => el.remove());
                baseEleId
                    .querySelectorAll(".widget-action")
                    .forEach((el) => el.remove());
                const svgElements = baseEleId.querySelectorAll("svg");
                svgElements.forEach(function (item) {
                    item.setAttribute("width", item.getBoundingClientRect().width + "px");
                    item.setAttribute("height", item.getBoundingClientRect().height + "px");
                    item.style.width = null;
                });
                this.html2Canvas(baseEleId);
            }
        };
        this.html2Canvas = (baseEleId) => {
            const self = this;
            const options = { scrollY: -window.pageYOffset };
            html2canvas(baseEleId, options).then(function (imgData) {
                if (document.getElementById("previewImage")) {
                    document.getElementById("previewImage").innerHTML = "";
                }
                const imgsrc = imgData.toDataURL("image/jpeg");
                self.canvasData = imgsrc;
                $('<img src="' + imgsrc + '" />').appendTo("#previewImage");
                self.showPreviewLoader = false;
                if (document.getElementById("duplicateEleWrapper")) {
                    document.getElementById("duplicateEleWrapper").remove();
                }
            });
        };
        this.getNameFromEmailAddress = (email) => {
            const eNameMatch = email.match(/^([^@]*)@/);
            const name = eNameMatch
                ? eNameMatch[1].charAt(0).toUpperCase() + eNameMatch[1].slice(1)
                : email;
            return name;
        };
        this.getUserList = () => {
            const params = {
                sharedPath: this.appPath,
                appName: this.appName,
                shareParams: this.sharedParams.appConfig
                    ? this.sharedParams.appConfig
                    : null,
                sender: {
                    id: this.sender,
                    name: this.getNameFromEmailAddress(this.sender)
                }
            };
            this.shareReportsService
                .getSharedUserList(params)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((data) => {
                if (data && data.status && data.data !== null) {
                    const res = data.data;
                    this.userList = res.userList ? res.userList : null;
                    this.isDNASUser = res.isDnasUser;
                    if (!this.allowReshare) {
                        this.guid = res.guid ? res.guid : null;
                    }
                    this.noOfUsers = res.count;
                    this.userList.forEach((user) => {
                        if (/^ *$/.test(user.fullName)) {
                            user.fullName = this.getNameFromEmailAddress(user.userName);
                        }
                        if (user.fullName) {
                            user.shortName = this.getShortName(user.fullName, user.userName);
                        }
                    });
                }
                else {
                    this.userList = [];
                    this.noOfUsers = 0;
                }
                this.setUserText(this.noOfUsers, "noOfUsers");
            }, (error) => {
                console.log("::Error in user list API call::", error);
            });
        };
        this.getShortName = (name, email) => {
            let matchChars;
            let chars;
            if (/^ *$/.test(name)) {
                chars = email.charAt(0);
            }
            else {
                matchChars = name.match(/\b(\w)/g);
                chars = matchChars.join("");
            }
            return chars.toUpperCase();
        };
        this.mouseOver = () => {
            this.showTooltipMessage = true;
        };
        this.mouseOut = () => {
            setTimeout(() => {
                this.showTooltipMessage = false;
            }, 500);
        };
        this.multiEmails = (control) => {
            const emails = control.value.split(",");
            const forbidden = emails.some((email) => Validators.email(new FormControl(email)));
            return forbidden ? { email: { value: control.value } } : null;
        };
        this.checkHasInvalidEmail = () => {
            if (this.emailList && this.emailList.length > 0) {
                this.emailError =
                    this.emailList.filter((e) => e.valid === false).length > 0;
            }
            else {
                this.error = this.messageKeys["emailErrorMsg"];
                this.emailError = true;
            }
        };
        this.emailValidate = (event) => {
            const emailData = event.target.value;
            const eNameMatch = emailData.match(/^([^@]*)@/);
            this.submittedFields = false;
            if (emailData == "") {
                this.submittedFields = true;
                this.error = this.messageKeys["emailValidAlertMsg"];
            }
        };
        this.openModal = (show) => {
            if (!this.canvasData) {
                this.showPreviewLoader = true;
            }
            else {
                this.showPreviewLoader = false;
            }
            // document.getElementById("shareReportPopup").style.display = "block";
            this.getUserList();
            this.disableSharebutton = false;
            this.convertHTMLToImage();
            const dialogRef = this.dialog.open(ShareReportDialogComponent, {
                disableClose: true, maxWidth: '100vw', maxHeight: '100vh', height: '94%', width: '90%',
                data: {
                    showModal: this.showModal,
                    sender: this.sender,
                    initiator: this.initiator,
                    error: this.error,
                    emailList: this.emailList,
                    recipients: this.recipients,
                    message: "Sharing Report",
                    eventForm: this.eventForm,
                    submittedFields: this.submittedFields,
                    element: this.element,
                    canvasData: this.canvasData,
                    showReportNamePopup: this.showReportNamePopup,
                    editreportName: this.editreportName,
                    disableRename: this.disableRename,
                    sharedParams: this.sharedParams,
                    allowReshare: this.allowReshare,
                    shareTitle: this.shareTitle,
                    appPath: this.appPath,
                    appName: this.appName,
                    invalidEmail: this.invalidEmail,
                    emailError: this.emailError,
                    userList: this.userList,
                    selectedUsers: this.selectedUsers,
                    selectedUsersCount: this.selectedUsersCount,
                    selectedUserText: this.selectedUserText,
                    userToDelete: this.userToDelete,
                    selectedAll: this.selectedAll,
                    showDeletePopup: this.showDeletePopup,
                    showTooltip: this.showTooltip,
                    noOfUsers: this.noOfUsers,
                    userText: "user",
                    guid: this.guid,
                    isDNASUser: this.isDNASUser,
                    timer: this.timer,
                    messageKeys: this.messageKeys
                }
            });
            const subscribeDialog = dialogRef.componentInstance.onShowEmitter.subscribe((show) => {
                console.log('onShowEmitter::::::::::', show);
                dialogRef.componentInstance.canvasData = this.canvasData;
            });
            dialogRef.afterClosed().subscribe(result => {
                console.log(`Dialog result: ${result}`);
                subscribeDialog.unsubscribe();
            });
            this.showModal = show;
        };
        this.selectAllUsers = () => {
            // select all checkbox
            this.selectedUsersCount = 0;
            for (let i = 0; i < this.userList.length; i++) {
                this.userList[i].selected = this.selectedAll;
                if (this.selectedAll) {
                    this.selectedUsersCount++;
                }
            }
            this.setUserText(this.selectedUsersCount, "selectedUsers");
        };
        this.setUserText = (count, type) => {
            if (type === "noOfUsers") {
                if (count > 1) {
                    this.userText = this.messageKeys["usersTxt"];
                }
                else {
                    this.userText = this.messageKeys["userTxt"];
                }
            }
            else {
                if (count > 1) {
                    this.selectedUserText = this.messageKeys["userscpsTxt"];
                }
                else {
                    this.selectedUserText = this.messageKeys["usercpsTxt"];
                }
            }
        };
    }
    set shareParams(params) {
        if (params && Object.keys(params).length > 0) {
            this.sharedParams = params;
            this.appComponentId = params.appConfig.appEleId;
            this.allowReshare = params.allowReshare;
            this.appName = params.appName;
            this.appPath = params.appPath;
            this.shareTitle = params.shareTitle;
            this.guid = params.appConfig.guid ? params.appConfig.guid : null;
            this.initiator = this.dataService.getFromStorage("userName");
            this.sender = this.dataService.getFromStorage("shareReportSender")
                ? this.dataService.getFromStorage("shareReportSender")
                : this.dataService.getFromStorage("userName");
            this.getUserList();
            const self = this;
            const timerValue = 5;
        }
    }
    set disableSharebutton(value) {
        this.disableShareButton = value;
        if (!value) {
            if (document.getElementById("previewImage")) {
                document.getElementById("previewImage").innerHTML = "";
            }
            const self = this;
            setTimeout(() => {
                self.convertHTMLToImage();
            }, 34500);
        }
    }
    ngOnInit() {
        this.showPreviewLoader = false;
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localized string here
            this.translate.get('shared-lib.share-reports').subscribe((res) => {
                this.messageKeys = res;
                this.emailPlaceholder = this.messageKeys["emailPlaceholder"];
                this.error = this.messageKeys["emailInvalidAlertMsg"];
                this.messagePlaceholder = this.messageKeys["messagePlaceholder"];
                this.deleteWarning = this.messageKeys["deleteWarning"];
            });
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
ShareComponent.ɵfac = function ShareComponent_Factory(t) { return new (t || ShareComponent)(i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(ShareReportsService), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2$1.FormBuilder), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i4$2.MatDialog)); };
ShareComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ShareComponent, selectors: [["lib-app-share"]], inputs: { shareParams: "shareParams", disableSharebutton: "disableSharebutton", iconColor: "iconColor" }, outputs: { onShowEmitter: "onShowEmitter" }, decls: 6, vars: 10, consts: [["id", "shareReportDiv"], ["id", "shareReportbtn", 3, "ngClass", "mouseover", "mouseout"], ["href", "javascript:void(0)", 2, "color", "#049fd9", 3, "click"], ["class", "sharebutton-tooltip", 4, "ngIf"], [1, "sharebutton-tooltip"]], template: function ShareComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "span", 1);
        i0.ɵɵlistener("mouseover", function ShareComponent_Template_span_mouseover_1_listener() { return ctx.disableShareButton && ctx.mouseOver(); })("mouseout", function ShareComponent_Template_span_mouseout_1_listener() { return ctx.disableShareButton && ctx.mouseOut(); });
        i0.ɵɵelementStart(2, "a", 2);
        i0.ɵɵlistener("click", function ShareComponent_Template_a_click_2_listener() { return !ctx.disableShareButton && ctx.openModal(true); });
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, ShareComponent_div_5_Template, 4, 3, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassMap(ctx.iconColor);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$c, ctx.disableShareButton));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, "shared-lib.share-reports.shareTxt"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.disableShareButton && ctx.showTooltipMessage);
    } }, directives: [i1$2.NgClass, i1$2.NgIf], pipes: [i2.TranslatePipe], styles: ["div#shareReportDiv[_ngcontent-%COMP%]{position:relative}#shareReportbtn[_ngcontent-%COMP%]{font-weight:700;letter-spacing:.0417px;font-size:14px;line-height:19px;font-family:CiscoSans;cursor:pointer;display:inline-block;background-position:center;background-size:contain;color:#049fd9!important}#shareReportBtn[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#049fd9;text-decoration:none}.disabled[_ngcontent-%COMP%]{cursor:default!important;opacity:.5}.sharebutton-tooltip[_ngcontent-%COMP%]{background-color:#565659;letter-spacing:.5px;padding:10px 15px;position:absolute;margin:2em auto auto;font-family:CiscoSansRegular;font-size:13px;text-align:left;color:#fff;border-radius:3px;min-width:268px;top:-4em;right:2em}.sharebutton-tooltip[_ngcontent-%COMP%]:before{width:0;height:0;border-bottom:7px solid transparent;border-top:7px solid transparent;border-left:7px solid #565659;content:\"\";position:absolute;top:2.2em;right:-7px}.shareWhite[_ngcontent-%COMP%]{background-image:url(/assets/images/share-framework/share-white.svg)!important}.reportLocations[_ngcontent-%COMP%]{display:flex}.show[_ngcontent-%COMP%]   .selectedItem[_ngcontent-%COMP%]:before{display:none}.impact-selection[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#565659;font-family:CiscoSans;font-size:12px;line-height:18px}span.event[_ngcontent-%COMP%]{border-radius:4px 0 0 4px}span.change[_ngcontent-%COMP%]{border-radius:0 4px 4px 0}.event.event-selected[_ngcontent-%COMP%]{color:#fff!important;background-color:#049fd9}.mb40[_ngcontent-%COMP%]{margin-bottom:40px}.mb20[_ngcontent-%COMP%]{margin-bottom:20px}.mb10[_ngcontent-%COMP%]{margin-bottom:10px}.impact-selection[_ngcontent-%COMP%]{margin-bottom:20px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShareComponent, [{
        type: Component,
        args: [{
                selector: "lib-app-share",
                templateUrl: "./share.component.html",
                styleUrls: ["./share.component.css"]
            }]
    }], function () { return [{ type: LocationService }, { type: DataService }, { type: ShareReportsService }, { type: i1.Router }, { type: i2$1.FormBuilder }, { type: i2.TranslateService }, { type: i4$2.MatDialog }]; }, { onShowEmitter: [{
            type: Output
        }], shareParams: [{
            type: Input
        }], disableSharebutton: [{
            type: Input
        }], iconColor: [{
            type: Input
        }] }); })();

function SmartLicenseBannerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelement(2, "img", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵelementStart(4, "h1");
    i0.ɵɵtext(5, "Activate Cisco Smart License");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵtext(7, " The flexible licensing model that streamlines how you activate and manage software. The solution allows you to easily track the status of your license and software usage trends. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 7);
    i0.ɵɵelementStart(10, "div", 8);
    i0.ɵɵlistener("click", function SmartLicenseBannerComponent_div_0_Template_div_click_10_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.showSLPopup(); });
    i0.ɵɵtext(11, "Activate Smart License");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 9);
    i0.ɵɵlistener("click", function SmartLicenseBannerComponent_div_0_Template_div_click_12_listener() { i0.ɵɵrestoreView(_r2); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.toggleBanner(false); });
    i0.ɵɵtext(13, "Do it Later");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("@slideInOut", undefined);
} }
class SmartLicenseBannerComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.slBannerEmitter = new EventEmitter();
        this.visible = true;
        this.showSLPopup = () => {
            this.slBannerEmitter.emit(true);
        };
        this.toggleBanner = (state) => {
            this.visible = state;
            if (!state) {
                this.dataService.setInStorage('smartBannerState', 'hidden');
            }
        };
    }
    ngOnInit() {
    }
}
SmartLicenseBannerComponent.ɵfac = function SmartLicenseBannerComponent_Factory(t) { return new (t || SmartLicenseBannerComponent)(i0.ɵɵdirectiveInject(DataService)); };
SmartLicenseBannerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SmartLicenseBannerComponent, selectors: [["smart-license-banner"]], outputs: { slBannerEmitter: "slBannerEmitter" }, decls: 1, vars: 1, consts: [["class", "sl-banner", 4, "ngIf"], [1, "sl-banner"], [1, "sl-banner-left"], ["src", "/assets/images/smartlicense/upsell-img1.svg", "alt", "Smart License Upsell Image", "width", "350"], [1, "sl-banner-content"], [1, "sl-banner-note"], [1, "seperator"], [1, "sl-banner-right"], [1, "primaryButton", 3, "click"], [1, "commonButton", 3, "click"]], template: function SmartLicenseBannerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SmartLicenseBannerComponent_div_0_Template, 14, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.visible);
    } }, directives: [i1$2.NgIf], styles: [".sl-banner[_ngcontent-%COMP%]{background:#fff;display:flex;flex-direction:row;width:100%;padding:5px 30px;box-shadow:0 6px 18px #0000000f}.sl-banner-left[_ngcontent-%COMP%]{display:flex;flex-direction:row;width:80%}.sl-banner-content[_ngcontent-%COMP%]{display:flex;align-items:baseline;flex-direction:column;padding:40px 80px 0 20px}.sl-banner-right[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between;align-items:stretch;padding:50px;width:20%}.sl-banner-note[_ngcontent-%COMP%]{color:#77777b;font-family:\"ciscoSansLight\";font-size:16px}.sl-banner[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:25px;font-family:\"ciscoSansLight\";padding:0;margin:10px 0}.sl-banner[_ngcontent-%COMP%]   .seperator[_ngcontent-%COMP%]{width:1px;height:100px;background:#ddd;position:relative;top:55px}.sl-banner[_ngcontent-%COMP%]   .primaryButton[_ngcontent-%COMP%]{transition:all .3s}.sl-banner[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{transition:all .3s}"], data: { animation: [
            trigger('slideInOut', [
                transition(':enter', [
                    style({ transform: 'translateY(-100%)' }),
                    animate('500ms ease-in-out', style({ transform: 'translateY(0%)' }))
                ]),
                transition(':leave', [
                    animate('500ms ease-in-out', style({ transform: 'translateY(-100%)' }))
                ])
            ])
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmartLicenseBannerComponent, [{
        type: Component,
        args: [{
                selector: 'smart-license-banner',
                templateUrl: './smart-license-banner.component.html',
                styleUrls: ['./smart-license-banner.component.scss'],
                animations: [
                    trigger('slideInOut', [
                        transition(':enter', [
                            style({ transform: 'translateY(-100%)' }),
                            animate('500ms ease-in-out', style({ transform: 'translateY(0%)' }))
                        ]),
                        transition(':leave', [
                            animate('500ms ease-in-out', style({ transform: 'translateY(-100%)' }))
                        ])
                    ])
                ]
            }]
    }], function () { return [{ type: DataService }]; }, { slBannerEmitter: [{
            type: Output
        }] }); })();

function SmsHighlighterComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "div", 28);
    i0.ɵɵlistener("click", function SmsHighlighterComponent_div_8_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.showCustomVarPopup(true); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "shared-lib.sms-highlighter.add-custom-variable"), " ");
} }
const _c0$b = function (a1) { return { "smsCountPlugin": true, "singleLine": a1 }; };
const _c1$5 = function (a0) { return { "iot-customSmartLink": a0 }; };
const _c2$4 = function (a1, a2) { return { "editable": true, "singleLine": a1, "iot-editable": a2 }; };
const _c3$4 = function (a0) { return { "hidden": a0 }; };
const WINDOW = new InjectionToken("WINDOW");
function windowFactory() {
    return window;
}
class SmsHighlighterComponent {
    constructor(loggerService, window, document, elementRef, cdRef) {
        this.loggerService = loggerService;
        this.window = window;
        this.document = document;
        this.elementRef = elementRef;
        this.cdRef = cdRef;
        this.isFirefoxBrowser = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
        this.utils = new Utils(this.loggerService);
        this.customVarEnabled = false;
        this.data = [];
        this.showSmsCount = false;
        this.singleLine = false;
        this.fromIoTtriggerValue = false;
        this.hideVariables = true;
        this.listOfChips = [];
        this.updated = new EventEmitter();
        this.emitCustomPopupState = new EventEmitter();
        // prepate SMS count plugin
        this.smsData = [];
        this.smsDataNew = [];
        this.backupData = [];
        this.$tagInputPromise = false;
        //unique id count for editableInput
        this.editInputCount = 0;
        this.initializePlugin = () => {
            this.objId = this.utils.randomString(8, "aA");
            const options = {
                selectorId: this.objId,
                defaultMessage: this.defaultMessage,
                messageTemplate: this.messageText,
                data: this.data,
                showCount: this.showSmsCount,
                placeholder: JSON.stringify(this.placeHolderText)
            };
            if (this.placeHolderText != undefined) {
                options.placeholder = options.placeholder.replace(/^"(.*)"$/, "$1");
            }
            this.prepareSMSCountPlugin(options);
        };
        this.attachCloseTagEvents = () => {
            const elCloseTagList = this.elementRef.nativeElement.querySelectorAll(".closeTag");
            if (elCloseTagList) {
                elCloseTagList.forEach((item) => {
                    item.addEventListener("click", this.onClickCloseTag.bind(this));
                });
            }
        };
        this.attachInputTagEvents = () => {
            const elInputTagList = this.elementRef.nativeElement.querySelectorAll(".inputTag");
            if (elInputTagList.length > 0) {
                elInputTagList.forEach((item) => {
                    item.addEventListener("mousedown", this.onMouseDownInputTag.bind(this));
                });
            }
        };
        this.attachEditableInputEvents = () => {
            const elEditableInputList = this.elementRef.nativeElement.querySelectorAll(".editableInput");
            if (elEditableInputList) {
                elEditableInputList.forEach((item) => {
                    item.addEventListener("blur", this.onBlurEditableInput.bind(this));
                    item.addEventListener("keyup", this.onKeyUpEditableInput.bind(this));
                    item.addEventListener("keydown", this.onKeyDownEditableInput.bind(this));
                    item.addEventListener("focus", this.onFocusEditable.bind(this, true));
                    item.addEventListener("focusout", this.onFocusEditable.bind(this, false));
                });
            }
        };
        this.onFocusEditable = ($event, showVariables) => {
            setTimeout(() => {
                this.hideVariables = !showVariables;
            }, 300);
        };
        this.showCustomVarPopup = (state) => {
            this.emitCustomPopupState.emit(state);
        };
        this.onKeyPressEditable = ($event) => {
            const $this = jQuery($event.currentTarget);
            var ele = jQuery($event.target);
            let returnValue = true;
            if (!ele.hasClass("editableInput")) {
                if ($event.which == 36) {
                    // `$` pressed
                    //console.log('in');
                    this.initTagInput($this);
                    returnValue = false;
                }
                const s = String.fromCharCode($event.which);
                const checkASCII = this.checkAllASCII(s); // check for ascii character
                if (checkASCII == true && !this.isFirefoxBrowser) {
                    var ele = jQuery($event.target);
                    const specialHTML = "<span class='asciiChar' contenteditable='false'>" +
                        s +
                        "</span>";
                    this.pasteHtmlAtCaret(specialHTML);
                    returnValue = false;
                }
                else {
                    if ($event.which == 13) {
                        // enter entered
                        if (!this.singleLine) {
                            const space = "<br />";
                            this.pasteHtmlAtCaret(space);
                        }
                        // returnValue = false;
                    }
                    else {
                        var ele = jQuery($event.target);
                        const letters = /^[0-9a-zA-Z]+$/;
                        if (s.match(letters)) {
                            const notspecial = s;
                            this.pasteHtmlAtCaret(notspecial);
                            returnValue = false;
                        }
                    }
                }
            }
            this.onChangeUpdate();
            return returnValue;
        };
        this.inChildSelection = (selection) => {
            // we are in child selection. The characters of the text node is being deleted
            const curRange = selection.getRangeAt(selection.rangeCount - 1);
            return (curRange.commonAncestorContainer.nodeType == 3 &&
                curRange.startOffset > 0);
        };
        this.getArea = () => {
            return this.document.createRange();
        };
        this.expandAreaToEditableField = (area, currentTarget, anchorNode) => {
            // range is in character mode. expand it to the whole editable field
            area.selectNodeContents(currentTarget);
            area.setEndBefore(anchorNode);
        };
        this.setAreaEnd = (area, currentTarget, anchorOffset) => {
            area.setEnd(jQuery(currentTarget)[0], anchorOffset);
        };
        this.setAreaStart = (area, currentTarget, endOffset) => {
            area.setStart(jQuery(currentTarget)[0], endOffset - 1);
        };
        this.deleteLastChildOfArea = (area, $event) => {
            const previousNode = area.cloneContents().lastChild;
            // console.log('previousNode', previousNode);
            // console.log('firefox browser', navigator.userAgent.toLowerCase().indexOf('firefox') > -1);
            if (previousNode &&
                (this.isFirefoxBrowser || previousNode.contentEditable == "false")) {
                // this is some rich content, e.g. smile. We should help the user to delete it
                area.deleteContents();
                $event.preventDefault();
            }
        };
        this.onKeyDownEditable = ($event) => {
            // console.log("onKeyDownEditable");
            const range = this.window ? this.window.getSelection() : null;
            if (this.window && range && $event.which == 8) {
                // backspace
                if (!range.isCollapsed ||
                    !range.rangeCount ||
                    this.inChildSelection(range)) {
                    return;
                }
                const area = this.getArea();
                if (range.anchorNode != $event.currentTarget) {
                    this.expandAreaToEditableField(area, $event.currentTarget, range.anchorNode);
                }
                else if (range.anchorOffset > 0) {
                    this.setAreaEnd(area, $event.currentTarget, range.anchorOffset);
                }
                else {
                    return; // reached the beginning of editable field
                }
                if (area.endOffset > 0)
                    this.setAreaStart(area, $event.currentTarget, area.endOffset);
                this.deleteLastChildOfArea(area, $event);
                this.onChangeUpdate();
            }
        };
        this.onBlurEditableInput = ($event) => {
            // console.log("onBlurEditableInput");
            const input = jQuery($event.currentTarget);
            const editor = input.parents(".smsCountPlugin");
            const tagInputVal = input.val();
            setTimeout(() => {
                if (!this.$tagInputPromise && this.currentInput) {
                    const filterVal = this.filterTag(input, true);
                    if (input.val() !== "" &&
                        input.val().trim() !== "" &&
                        input.val() !== "$" &&
                        input.val().trim() !== "$" &&
                        filterVal != "") {
                        const appendTagHtml = "<div class='tagInput' contenteditable='false'><div class='tagName' contenteditable='false'>" +
                            filterVal +
                            "</div><div class='closeTag' contenteditable='false'>&#xe909;</div></div>";
                        input.hide();
                        jQuery(appendTagHtml).insertAfter(input);
                        //editor.find(".editable").append("&nbsp;");
                        input.remove();
                        editor
                            .find(".tagSuggestDiv")
                            .find("li")
                            .css("display", "inline");
                        this.setEndOfContenteditable(editor.find(".editable").get(0));
                        this.attachCloseTagEvents();
                    }
                    else {
                        input.replaceWith(tagInputVal);
                        //editor.find(".editable").append("&nbsp;");
                        input.remove();
                        editor
                            .find(".tagSuggestDiv")
                            .find("li")
                            .css("display", "inline");
                        this.setEndOfContenteditable(editor.find(".editable").get(0));
                    }
                    this.currentInput = null;
                    editor.find(".editable").keyup();
                }
                this.onChangeUpdate();
            }, 300);
        };
        this.onKeyUpEditableInput = ($event) => {
            // console.log("onKeyUpEditableInput");
            $event.stopPropagation();
            $event.preventDefault();
            const keypressed = $event.which;
            let status = false;
            if ($event.shiftKey && $event.keyCode === 52) {
                // '$' pressed
                status = false;
            }
            else {
                if (keypressed == 32) {
                    const trimmedstr = jQuery($event.currentTarget)
                        .val()
                        .replace(/\s+$/, "");
                    jQuery($event.currentTarget).val(trimmedstr);
                    jQuery($event.currentTarget).blur();
                    status = false;
                }
                else {
                    if (keypressed == 13 ||
                        jQuery($event.currentTarget).val() === "") {
                        // enter or space pressed
                        jQuery($event.currentTarget).blur();
                        status = false;
                    }
                    else {
                        const $input = jQuery($event.currentTarget);
                        this.filterTag($input, false);
                        status = true;
                    }
                }
            }
            this.onChangeUpdate();
            return status;
        };
        this.onClickCloseTag = ($event) => {
            const editor = jQuery($event.currentTarget).parents(".smsCountPlugin");
            jQuery($event.currentTarget).parent(".tagInput").remove();
            editor.find(".editable").keyup();
            this.onChangeUpdate();
        };
        this.onKeyDownEditableInput = ($event) => {
            // console.log("onKeyDownEditableInput");
            const $this = jQuery($event.currentTarget);
            const fontSize = parseInt($this.css("font-size")) / 2;
            const minWidth = parseInt($this.css("min-width"));
            const maxWidth = parseInt($this.css("max-width"));
            const newVal = $this.val().toString.length * fontSize; //compute the new width
            if (newVal > minWidth && newVal <= maxWidth)
                //check to see if it is within Min and Max
                $this.css("width", newVal + "px"); //update the value.
            this.onChangeUpdate();
        };
        this.onKeyUpEditable = ($event) => {
            // console.log("onKeyUpEditable");
            const editorText = jQuery($event.currentTarget).parents(".smsCountPlugin");
            let count = 0, smsCount = 0;
            let countObj = {
                count: 0,
                smsCount: 0
            };
            $.when(countObj = this.countCharacters(editorText)).then(function () {
                editorText.find(".characterCount").text(countObj.count);
                smsCount = countObj.smsCount;
                editorText.find(".smsCount").text(smsCount);
            });
            this.onChangeUpdate();
        };
        // createChipInEditable = (tagInputVal: string) => {
        // }
        this.onMouseDownInputTag = ($event) => {
            $event.preventDefault();
            if ($event.which == 1) {
                const editor = jQuery($event.currentTarget).parents(".smsCountPlugin");
                if (this.currentInput !== null) {
                    var tagInputVal = jQuery($event.currentTarget)
                        .find(".tagName")
                        .html();
                    var appendTagHtml = "<div class='tagInput' contenteditable='false'><div class='tagName' contenteditable='false'>" +
                        tagInputVal +
                        "</div><div class='closeTag' contenteditable='false'>&#xe909;</div></div>";
                    this.currentInput.replaceWith(appendTagHtml);
                    this.currentInput = null;
                    //jQuery(".editable").append("&nbsp;");
                    editor
                        .find(".filterTagList")
                        .find("li")
                        .css("display", "inline");
                    this.setEndOfContenteditable(editor.find(".editable").get(0));
                    this.$tagInputPromise = true;
                }
                else {
                    var tagInputVal = jQuery($event.currentTarget)
                        .find(".tagName")
                        .html();
                    var appendTagHtml = "<div class='tagInput' contenteditable='false'><div class='tagName' contenteditable='false'>" +
                        tagInputVal +
                        "</div><div class='closeTag' contenteditable='false'>&#xe909;</div></div>";
                    editor.find(".editable").focus();
                    this.pasteHtmlAtCaret(appendTagHtml);
                    this.setEndOfContenteditable(editor.find(".editable").get(0));
                }
                this.attachCloseTagEvents();
                editor.find(".editable").keyup();
                this.onChangeUpdate();
            }
        };
        this.onPasteEditable = ($event) => {
            const editorText = jQuery($event.currentTarget).parents(".smsCountPlugin");
            setTimeout(() => {
                editorText.find(".editable").focus();
                this.cleanAfterPaste(editorText);
                const editorTextContent = editorText.find(".editable").text();
                // if (this.checkAllASCII(editorTextContent[editorTextContent.length - 1])) {
                //   editorText.find(".editable").append("&nbsp;");
                // }
                this.setEndOfContenteditable(editorText.find(".editable").get(0));
                //editorText.find(".editable").last("&nbsp;").remove();
                editorText.find(".editable").trigger("keyup");
                this.onChangeUpdate();
            }, 300);
        };
        this.onChangeUpdate = () => {
            const fetchId = "#" + this.objId;
            this.messageText = this.prepareStr(fetchId);
            //console.log('keyup: jQuery(fetchId).val()', this.messageText);
            // console.log('keyup: jQuery(fetchId).find(".editable")[0].textContent', jQuery(fetchId).find(".editable")[0].textContent);
            // this.updated.emit(jQuery(fetchId).val());
            // this.updated.emit(jQuery(fetchId).find(".editable")[0].textContent);
            this.updated.emit(this.messageText);
        };
        /* SMS Count Custom Plugin*/
        //replace ascii characters with span
        this.replaceASCII = (newText) => {
            const newTextArr = newText.split("");
            const newTextStrArr = [];
            let isSpanStarted = false;
            for (let k = 0, len = newTextArr.length; k < len; k++) {
                if (this.checkAllASCII(newTextArr[k])) {
                    // console.log(newTextArr[k]);
                    //newText = newText.replace(newText[k],'<span class="asciiChar">'+newText[k]+'</span>');
                    const changedStr = "";
                    if (!isSpanStarted) {
                        newTextStrArr.push("<span class='asciiChar' contenteditable='false'>");
                        isSpanStarted = true;
                    }
                }
                else if (k > 0 && isSpanStarted) {
                    isSpanStarted = false;
                    newTextStrArr.push("</span>");
                }
                newTextStrArr.push(newTextArr[k]);
            }
            // console.log(newTextStrArr);
            return newTextStrArr.join("");
        };
        // prepopulate data for sms
        this.parseSMSData = (selectorId, data, text) => {
            let defaultHTML = "";
            let newText = text;
            if (!newText) {
                jQuery(selectorId).find(".editable").html("");
                return;
            }
            for (let i = 0; i < data.length; i++) {
                if (data[i].length > 1) {
                    const index = newText
                        .toLowerCase()
                        .indexOf(data[i].toLowerCase());
                    if (index > -1) {
                        const replaceStr = data[i].replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                        const re = new RegExp(replaceStr, "g");
                        newText = newText.replace(re, "<div class='tagInput' contenteditable='false'><div class='tagName' contenteditable='false'>" +
                            data[i].replace(/[{}\\]/g, "") +
                            "</div><div class='closeTag' contenteditable='false'>&#xe909;</div></div>");
                    }
                }
            }
            text = newText;
            text = this.replaceASCII(text);
            text = text.replace(/\n/g, "<br>");
            text = text.replace(/\/div> <div/g, "/div><div");
            defaultHTML = text;
            //console.log(defaultHTML);
            jQuery(selectorId).find(".editable").html(defaultHTML);
            this.attachCloseTagEvents();
            // jQuery(selectorId).find(".editable").find('br:last-child').remove();
            jQuery(selectorId).find(".editable").append(" ");
            //jQuery(selectorId).find(".editable").trigger("keyup");
            jQuery(selectorId).find(".editable").attr("spellcheck", "false");
            let countObj = {
                count: 0,
                smsCount: 0
            };
            $.when(countObj = this.countCharacters(jQuery(selectorId))).then(function () {
                jQuery(selectorId).find(".characterCount").text(countObj.count);
                const smsCount = countObj.smsCount;
                jQuery(selectorId).find(".smsCount").text(smsCount);
            });
        };
        // prepare tag suggest data
        this.prepareData = (selectorId, data) => {
            const defaultHTML = "";
            let listStr = "";
            for (let i = 0; i < data.length; i++) {
                if (data[i].length > 1) {
                    listStr +=
                        "<li><div class='inputTag' contenteditable='false'><div class='tagName'>" +
                            data[i] +
                            "</div></div></li>";
                }
            }
            const filterList = '<ul class="filterTagList">' + listStr + "</ul>";
            jQuery(selectorId).find(".tagSuggestDiv").html(filterList);
            this.attachInputTagEvents();
        };
        // filter tags based on str typed after '$' input
        this.filterTag = (inputElement, onBlur) => {
            // Declare variables
            let input, filter, ul, li, a, filterCount = 0, filterName = "";
            input = inputElement;
            const parentSelector = input.parents(".smsCountPlugin");
            filter = input.val().toUpperCase();
            filter = filter.substr(1, filter.length - 1);
            ul = parentSelector.find("ul.filterTagList");
            li = ul.find("li");
            li.each(function () {
                a = jQuery(this).find(".tagName").text();
                a = a.substr(1, a.length - 1);
                if (a.toUpperCase().indexOf(filter) > -1) {
                    jQuery(this).css("display", "inline-block");
                    if (onBlur == true) {
                        filterCount++;
                        if (a.toUpperCase() == filter) {
                            filterName = jQuery(this).find(".tagName").text();
                            return false;
                        }
                        else {
                            if (filterCount == 1) {
                                filterName = jQuery(this).find(".tagName").text();
                            }
                            else {
                                filterName = "";
                            }
                        }
                    }
                }
                else {
                    jQuery(this).fadeOut(300);
                }
            });
            if (onBlur == true) {
                return filterName;
            }
        };
        //check if inputval is a part of the available variables
        this.checkFilter = (inputVal) => {
            const match = this.smsData.filter(function (item) {
                return item === inputVal;
            });
            if (match.length > 0)
                return true;
            else
                return false;
        };
        this.getHTMLArea = (sel) => {
            return sel.getRangeAt(0);
        };
        this.doesSelctionAreaExists = (sel) => {
            return sel.getRangeAt && sel.rangeCount;
        };
        this.insertFragNode = (area, html) => {
            const el = this.document.createElement("div");
            el.innerHTML = html;
            let frag = this.document.createDocumentFragment(), node, lastNode;
            while ((node = el.firstChild)) {
                lastNode = frag.appendChild(node);
            }
            area.insertNode(frag);
            return lastNode;
        };
        this.collapseArea = (area, lastNode) => {
            area = area.cloneRange();
            area.setStartAfter(lastNode);
            area.collapse(true);
            return area;
        };
        this.addAreaToSection = (sel, area) => {
            sel.removeAllRanges();
            sel.addRange(area);
            return sel;
        };
        this.documentHasSelection = () => {
            const status = this.document.selection && this.document.selection.type != "Control";
            return status;
        };
        this.getDocumentSelectionRange = () => {
            return this.document.selection.addRange();
        };
        this.pasteHtmlAtCaret = (html) => {
            let sel, area;
            if (this.window && this.window.getSelection) {
                // IE9 and non-IE
                sel = this.window.getSelection();
                if (this.doesSelctionAreaExists(sel)) {
                    area = this.getHTMLArea(sel);
                    area.deleteContents();
                    const lastNode = this.insertFragNode(area, html);
                    // Need to preserve the selection
                    if (lastNode) {
                        area = this.collapseArea(area, lastNode);
                        sel = this.addAreaToSection(sel, area);
                    }
                }
            }
            else if (this.documentHasSelection()) {
                this.getDocumentSelectionRange().pasteHTML(html);
            }
        };
        // set cursor at the end of contenteditable div
        this.setEndOfContenteditable = (contentEditableElement) => {
            let range, selection;
            if (this.document.createRange && contentEditableElement != null) {
                //Firefox, Chrome, Opera, Safari, IE 9+
                range = this.document.createRange(); //Create a range (a range is a like the selection but invisible)
                range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
                range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
                selection = this.window.getSelection(); //get the selection object (allows you to change selection)
                selection.removeAllRanges(); //remove any selections already made
                selection.addRange(range); //make the range you have just created the visible selection
            }
            else if (this.document.getSelection()) {
                //IE 8 and lower
                range = this.document.body.createTextRange(); //Create a range (a range is a like the selection but invisible)
                range.moveToElementText(contentEditableElement); //Select the entire contents of the element with the range
                range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
                range.select(); //Select the range (make it the visible selection
            }
        };
        //initialize editableInput
        this.initTagInput = ($this) => {
            const editId = this.editInputCount++;
            const tagInput = "<input type='text' size='1' id='input-" +
                editId +
                "' class='editableInput' value='$' />";
            this.pasteHtmlAtCaret(tagInput);
            this.attachEditableInputEvents();
            setTimeout(() => {
                const newInputEl = jQuery("#input-" + editId);
                this.$tagInputPromise = false;
                this.currentInput = newInputEl;
                newInputEl.focus();
                const $thisVal = newInputEl.val();
                newInputEl.val('').val($thisVal);
            }, 100);
        };
        // function to check for ascii character entered
        this.checkAllASCII = (inputChar) => {
            // return /((?![A-Za-z0-9 \r\n@£‘$“´¥èéùìòÇçØøÅå•®<>\x{0394}_\x{03A6}\x{0393}\x{039B}\x{03A9}\x{03A0}\x{03A8}\x{03A3}\x{0398}\x{039E}ÆæßÉ!"#$%&amp;'()*+,\-.\/:;&lt;=&gt;?¡ÄÖÑÜ§¿äöñüà^{}\\\[~\]|\x{20AC}\S]).)/gim.test(inputChar);
            // return /[^\u0000-\u00ff]/.test(inputChar);
            const regexp = new RegExp("^[A-Za-z0-9 \\r\\n@£$¥èéùìòÇØøÅå\u0394_\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039EÆæßÉ!\"#$%&'()*+,\\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}\\\\\\[~\\]|\u20AC]*$");
            const retVal = !regexp.test(inputChar);
            // console.log('inputChar', inputChar, inputChar.charCodeAt(), retVal);
            return retVal;
        };
        // function to get character count
        this.countCharacters = (selectorId) => {
            let count = 0, smsCount = 0, hasASCII = false, hasVar = false;
            const countObj = {
                count: 0,
                smsCount: 0
            };
            const editorText = jQuery(selectorId).find(".editable");
            if (editorText.find(".asciiChar").length) {
                hasASCII = true;
            }
            count = count + editorText.not(editorText.children()).text().length;
            editorText.find("br").each(function () {
                count += 1;
            });
            if (editorText.find(".tagInput").length) {
                hasVar = true;
                count = count - editorText.find(".tagInput").length;
            }
            else {
                hasVar = false;
            }
            if (hasVar) {
                // update message and tooltip view if text has variables
                jQuery(selectorId).find(".variableNote").show();
                jQuery(selectorId).find(".nonGSMNote").hide();
                jQuery(selectorId).find(".approxLabel").show();
            }
            else {
                jQuery(selectorId).find(".approxLabel").hide();
                if (hasASCII) {
                    jQuery(selectorId).find(".nonGSMNote").show();
                }
                else {
                    jQuery(selectorId).find(".nonGSMNote").hide();
                }
                jQuery(selectorId).find(".variableNote").hide();
            }
            // SMS Count logic
            if (hasASCII) {
                // if has non-GSM characters
                if (count > 70) {
                    smsCount = Math.ceil(count / 63);
                }
                else {
                    smsCount = Math.ceil(count / 70);
                }
            }
            else {
                // has only GSM characters
                if (count > 160) {
                    smsCount = Math.ceil(count / 153);
                }
                else {
                    smsCount = Math.ceil(count / 160);
                }
            }
            // setting character count and sms count into countObj
            countObj.count = count;
            countObj.smsCount = smsCount;
            return countObj;
        };
        this.prepareSMSCountPlugin = (options) => {
            this.currentInput = null;
            this.$tagInputPromise = false;
            this.backupData = [];
            // declaration
            let dataObject = [], data = [], dataNew = [], selectorId = null, messageTemplate = null, showCount = true;
            this.smsData = [];
            this.currentInput = null;
            this.$tagInputPromise = false;
            // init
            if (options.data != null &&
                options.data != undefined &&
                options.data != "") {
                dataObject = options.data;
            }
            else {
                return;
            }
            if (options.selectorId != null) {
                selectorId = "#" + options.selectorId;
                jQuery(selectorId).html("");
            }
            else {
                return;
            }
            // if (options.messageTemplate != null) {
            messageTemplate = options.messageTemplate;
            // }
            // else if (options.defaultMessage != null) {
            //   messageTemplate = options.defaultMessage;
            //   // } else {
            //   //   return;
            // }
            if (options.showCount != null) {
                showCount = options.showCount;
            }
            jQuery(selectorId).html("<h4>Loading...</h4>");
            setTimeout(() => {
                jQuery(selectorId).find(".characterCount").text("0");
                jQuery(selectorId).find(".savedSMSTemplateData").html("");
                if (showCount) {
                    // show character/sms count
                    jQuery(selectorId).find(".characterCountContainer").show();
                    jQuery(selectorId)
                        .find(".characterCountContainer")
                        .removeClass("display-none");
                    jQuery(selectorId).find(".noteTemplateContainer").show();
                    jQuery(selectorId)
                        .find(".noteTemplateContainer")
                        .removeClass("display-none");
                }
                for (let i = 0; i < dataObject.length; i++) {
                    data.push("$" + dataObject[i]);
                    dataNew.push("${" + dataObject[i] + "}");
                }
                this.smsData = data;
                this.smsDataNew = dataNew;
                this.backupData = this.smsDataNew;
                this.prepareData(selectorId, data);
                this.parseSMSData(selectorId, this.smsDataNew, messageTemplate);
                if (options.placeholder != undefined &&
                    options.placeholder != null) {
                    jQuery(selectorId)
                        .find(".editable")
                        .attr("placeholder", options.placeholder);
                }
                if (showCount) {
                    jQuery(selectorId).find(".editable").trigger("keyup");
                }
            }, 1000);
        };
        this.prepareStr = (selectorId) => {
            //count display
            let countObj = {
                count: 0,
                smsCount: 0
            };
            $.when(countObj = this.countCharacters(jQuery(selectorId))).then(function () {
                jQuery(selectorId).find(".characterCount").text(countObj.count);
                const smsCount = countObj.smsCount;
                jQuery(selectorId).find(".smsCount").text(smsCount);
            });
            // count display
            jQuery(selectorId).find(".savedSMSTemplateData").html("");
            // console.log("jQuery(selectorId).find('.editable').html()",jQuery(selectorId).find(".editable").html())
            jQuery(selectorId)
                .find(".savedSMSTemplateData")
                .html(jQuery(selectorId).find(".editable").html());
            const editHTMLSel = jQuery(selectorId).find(".savedSMSTemplateData");
            editHTMLSel.find(".tagName").each(function () {
                let prepareStr = jQuery(this).text();
                prepareStr =
                    prepareStr.slice(0, 1) + "{" + prepareStr.slice(1) + "}";
                jQuery(this).parents(".tagInput").text(prepareStr);
            });
            // console.log("editHTMLSel.html()",editHTMLSel.html());
            const regex = /<br\s*[\/]?>/gi;
            editHTMLSel.html(editHTMLSel.html().replace(regex, "\n"));
            const regexSpace = /(&nbsp;)/gi;
            editHTMLSel.html(editHTMLSel.html().replace(regexSpace, " "));
            // console.log("jQuery(selectorId).find('.savedSMSTemplateData').text()====>>>>",jQuery(selectorId).find(".savedSMSTemplateData").text());
            return jQuery(selectorId).find(".savedSMSTemplateData").text();
        };
        this.cleanAfterPaste = (editorText) => {
            let text = "", editorNewText = "";
            editorText.find(".editable").find("*").removeAttr("style");
            editorText.find(".editable").find(".closeTag").html("");
            const regex = /\n/g;
            const regexSpace = /(&nbsp;)/gi;
            text = editorText
                .find(".editable")
                .html()
                .replace(regex, "<br>")
                .replace(regexSpace, " ");
            // text = editorText.find(".editable").html(temps).text();
            text = this.replaceASCII(text);
            let newText = text;
            const data = this.smsDataNew.slice(0);
            for (let i = 0; i < data.length; i++) {
                if (data[i].length > 1) {
                    const index = newText
                        .toLowerCase()
                        .indexOf(data[i].toLowerCase());
                    if (index > -1) {
                        const regexVal = data[i].replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                        const re = new RegExp(regexVal, "g");
                        newText = newText.replace(re, "<div class='tagInput' contenteditable='false'><div class='tagName' contenteditable='false'>" +
                            data[i].replace(/[{}\\]/g, "") +
                            "</div><div class='closeTag' contenteditable='false'>&#xe909;</div></div>");
                    }
                }
            }
            text = newText;
            // text = text.replace(/\n/g, "<br>");
            const defaultHTML = text;
            editorText.find(".editable").html(defaultHTML);
            editorText.find(".editable").find(".closeTag").html("&#xe909;");
            this.attachCloseTagEvents();
        };
    }
    set messageTemplate($messageText) {
        // console.log($messageText, this.messageText, (this.messageText === $messageText));
        if (this.messageText !== $messageText) {
            this.messageText = $messageText;
            this.initializePlugin();
        }
    }
    set getData(newData) {
        // console.log('setting new data', newData);
        if (!this.utils.isArrayEqual(this.data, newData)) {
            this.data = newData;
            this.initializePlugin();
        }
    }
    set customVariableState(value) {
        if (value === undefined) {
            this.customVarEnabled = false;
        }
        else {
            this.customVarEnabled = value;
        }
    }
    ngOnInit() {
        this.initializePlugin();
    }
}
SmsHighlighterComponent.ɵfac = function SmsHighlighterComponent_Factory(t) { return new (t || SmsHighlighterComponent)(i0.ɵɵdirectiveInject(LoggerService), i0.ɵɵdirectiveInject(WINDOW), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
SmsHighlighterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SmsHighlighterComponent, selectors: [["lib-sms-highlighter"]], inputs: { defaultMessage: "defaultMessage", messageTemplate: "messageTemplate", getData: "getData", showSmsCount: "showSmsCount", placeHolderText: "placeHolderText", customVariableState: "customVariableState", singleLine: "singleLine", fromIoTtriggerValue: "fromIoTtriggerValue", listOfChips: "listOfChips" }, outputs: { updated: "updated", emitCustomPopupState: "emitCustomPopupState" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: WINDOW,
                // useValue: window
                useFactory: windowFactory
            }
        ])], decls: 92, vars: 78, consts: [[3, "id", "ngClass"], [1, "customSmartLink", "showCharCount", 3, "ngClass"], ["contenteditable", "true", "spellcheck", "false", "contenteditable", "true", 3, "ngClass", "paste", "keyup", "keydown", "keypress", "focus", "focusout"], [1, "tagSuggest", "unselectable", 3, "ngClass"], [1, "suggestLabel"], [1, "tagSuggestDiv"], ["class", "customVarBtnContainer", 4, "ngIf"], [1, "noteTemplateContainer", "display-none"], [1, "noteTemplate", "nonGSMNote"], [1, "noteLabel"], [1, "noteMessage"], [1, "noteTemplate", "variableNote"], [1, "characterCountContainer", "display-none"], [1, "characterCountLabel"], [1, "approxLabel"], [1, "characterCount"], [1, "approxLabel", "note-tool-tip-css"], [1, "note-tool-tip-info"], ["src", "/assets/images/report_info.svg"], [1, "note-tool-tip"], [1, "note-tool-tip-heading"], [1, "note-tool-tip-message"], ["href", "javascript:void(0);", 2, "display", "none"], [1, "vertical-separator"], [1, "smsCountLabel"], [1, "smsCount"], [1, "savedSMSTemplateData"], [1, "customVarBtnContainer"], [1, "customVarBtn", 3, "click"]], template: function SmsHighlighterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵlistener("paste", function SmsHighlighterComponent_Template_div_paste_2_listener($event) { return ctx.onPasteEditable($event); })("keyup", function SmsHighlighterComponent_Template_div_keyup_2_listener($event) { return ctx.onKeyUpEditable($event); })("keydown", function SmsHighlighterComponent_Template_div_keydown_2_listener($event) { return ctx.onKeyDownEditable($event); })("keypress", function SmsHighlighterComponent_Template_div_keypress_2_listener($event) { return ctx.onKeyPressEditable($event); })("focus", function SmsHighlighterComponent_Template_div_focus_2_listener($event) { return ctx.onFocusEditable($event, true); })("focusout", function SmsHighlighterComponent_Template_div_focusout_2_listener($event) { return ctx.onFocusEditable($event, false); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "div", 5);
        i0.ɵɵtemplate(8, SmsHighlighterComponent_div_8_Template, 4, 3, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵelementStart(11, "h4", 9);
        i0.ɵɵtext(12);
        i0.ɵɵpipe(13, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "h5", 10);
        i0.ɵɵtext(15);
        i0.ɵɵpipe(16, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 11);
        i0.ɵɵelementStart(18, "h4", 9);
        i0.ɵɵtext(19);
        i0.ɵɵpipe(20, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "h5", 10);
        i0.ɵɵtext(22);
        i0.ɵɵpipe(23, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 12);
        i0.ɵɵelementStart(25, "span", 13);
        i0.ɵɵelementStart(26, "span", 14);
        i0.ɵɵtext(27);
        i0.ɵɵpipe(28, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(29);
        i0.ɵɵpipe(30, "translate");
        i0.ɵɵelement(31, "span", 15);
        i0.ɵɵelementStart(32, "span", 16);
        i0.ɵɵelementStart(33, "span", 17);
        i0.ɵɵelement(34, "img", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "span", 19);
        i0.ɵɵelementStart(36, "h4", 20);
        i0.ɵɵtext(37);
        i0.ɵɵpipe(38, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "p", 21);
        i0.ɵɵtext(40);
        i0.ɵɵpipe(41, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(42, "p", 21);
        i0.ɵɵtext(43);
        i0.ɵɵpipe(44, "translate");
        i0.ɵɵelementStart(45, "strong");
        i0.ɵɵtext(46, "$Firstname");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(47);
        i0.ɵɵpipe(48, "translate");
        i0.ɵɵelementStart(49, "strong");
        i0.ɵɵtext(50, "$Location");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(51);
        i0.ɵɵpipe(52, "translate");
        i0.ɵɵelementStart(53, "strong");
        i0.ɵɵtext(54, "John");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(55);
        i0.ɵɵpipe(56, "translate");
        i0.ɵɵelementStart(57, "strong");
        i0.ɵɵtext(58, "Location A");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(59);
        i0.ɵɵpipe(60, "translate");
        i0.ɵɵelementStart(61, "strong");
        i0.ɵɵtext(62, "26");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(63);
        i0.ɵɵpipe(64, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(65, "a", 22);
        i0.ɵɵtext(66);
        i0.ɵɵpipe(67, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(68, "span", 23);
        i0.ɵɵtext(69, "|");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(70, "span", 24);
        i0.ɵɵelementStart(71, "span", 14);
        i0.ɵɵtext(72);
        i0.ɵɵpipe(73, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(74);
        i0.ɵɵpipe(75, "translate");
        i0.ɵɵelementStart(76, "span", 25);
        i0.ɵɵtext(77, "1");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(78, "span", 16);
        i0.ɵɵelementStart(79, "span", 17);
        i0.ɵɵelement(80, "img", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(81, "span", 19);
        i0.ɵɵelementStart(82, "h4", 20);
        i0.ɵɵtext(83);
        i0.ɵɵpipe(84, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(85, "p", 21);
        i0.ɵɵtext(86);
        i0.ɵɵpipe(87, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(88, "p", 21);
        i0.ɵɵtext(89);
        i0.ɵɵpipe(90, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(91, "div", 26);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵpropertyInterpolate("id", ctx.objId);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(69, _c0$b, ctx.singleLine));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(71, _c1$5, ctx.fromIoTtriggerValue));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(73, _c2$4, ctx.singleLine, ctx.fromIoTtriggerValue));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(76, _c3$4, ctx.hideVariables));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 27, "shared-lib.sms-highlighter.suggest-label"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.customVarEnabled);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(13, 29, "shared-lib.sms-highlighter.note"), ":");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 31, "shared-lib.sms-highlighter.note-msg"), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(20, 33, "shared-lib.sms-highlighter.note"), ":");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 35, "shared-lib.sms-highlighter.note-msg-1"), " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(28, 37, "shared-lib.sms-highlighter.approximate"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(30, 39, "shared-lib.sms-highlighter.character-cnt"), ": ");
        i0.ɵɵadvance(8);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(38, 41, "shared-lib.sms-highlighter.character-cnt"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(41, 43, "shared-lib.sms-highlighter.tooltip-msg"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(44, 45, "shared-lib.sms-highlighter.example-1"), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(48, 47, "shared-lib.sms-highlighter.to"), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1("\" ", i0.ɵɵpipeBind1(52, 49, "shared-lib.sms-highlighter.for-visitor"), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(56, 51, "shared-lib.sms-highlighter.to"), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(60, 53, "shared-lib.sms-highlighter.example-2"), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(64, 55, "shared-lib.sms-highlighter.characters"), ". ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(67, 57, "shared-lib.sms-highlighter.know-more"));
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(73, 59, "shared-lib.sms-highlighter.approximate"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(75, 61, "shared-lib.sms-highlighter.sms-count"), ": ");
        i0.ɵɵadvance(9);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(84, 63, "shared-lib.sms-highlighter.sms-count"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(87, 65, "shared-lib.sms-highlighter.sms-cnt-msg"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(90, 67, "shared-lib.sms-highlighter.sms-cnt-msg-1"), " ");
    } }, directives: [i1$2.NgClass, i1$2.NgIf], pipes: [i2.TranslatePipe], styles: ["[_nghost-%COMP%]     .editable[contenteditable=true]:empty:before{content:attr(placeholder);display:block}@keyframes toggleHeight{to{height:0px!important;padding:0!important}}[_nghost-%COMP%]     .singleLine{min-height:36px!important;white-space:nowrap;overflow:auto;max-width:420px}[_nghost-%COMP%]     .hidden{height:0px!important;padding:0!important;-webkit-animation:toggleHeight .5s forwards;-webkit-animation-delay:.1s;animation:toggleHeight .5s forwards;animation-delay:.1s}[_nghost-%COMP%]     .editable{margin:10px 0 0;border:1px solid #ddd;border-bottom:none;min-height:100px;background-color:#fff;padding:8px 10px;position:relative;font-size:14px;line-height:24px;cursor:text;word-wrap:break-word}[_nghost-%COMP%]     input[type=text].editableInput.editableInput{border:1px solid #e5eaf2!important;border-bottom:1px solid #e5eaf2!important;color:#1d1d1d;border-radius:10px!important;display:inline;background-color:#f1f4f9;outline:none;padding:2px 4px!important;font-size:12px!important;line-height:12px;min-width:40px!important;max-width:200px!important}[_nghost-%COMP%]     input[type=text].editableInput:focus{border-bottom:1px solid #e5eaf2!important}[_nghost-%COMP%]     .tagInput, [_nghost-%COMP%]     .inputTag{border:1px solid #e5eaf2;color:#1d1d1d;border-radius:10px;display:inline;background-color:#f1f4f9;outline:none;padding:2px 4px;cursor:default;font-size:12px;line-height:14px}[_nghost-%COMP%]     .inputTag{cursor:pointer;margin-bottom:4px}[_nghost-%COMP%]     .closeTag{padding-left:4px;display:inline;font-family:\"icomoon-new\";font-size:8px!important;font-weight:normal;display:inline-block;cursor:pointer}[_nghost-%COMP%]     div.tagInput, [_nghost-%COMP%]     div.tagInput>div{display:inline-block}[_nghost-%COMP%]     div.inputTag, [_nghost-%COMP%]     div.inputTag>div{display:inline-block}[_nghost-%COMP%]     .tagSuggest{border:1px solid #dddfe2;background-color:#fff;padding:8px 10px;margin:0 0 10px;max-height:100px;overflow-x:auto}[_nghost-%COMP%]     .filterTagList{margin:0;padding:0;list-style-type:none;white-space:normal}[_nghost-%COMP%]     .filterTagList li{display:inline-block;margin-right:4px;margin-bottom:4px}[_nghost-%COMP%]     .suggestLabel{font-size:11px;display:block;color:#6a6b6c;padding-bottom:2px;font-family:ciscoSansLight}[_nghost-%COMP%]     span.unicodeHighlight{background-color:#ff0}[_nghost-%COMP%]     .customSmartLink{padding:5px 15px 10px 0;background-color:#fff;max-width:600px}[_nghost-%COMP%]     .characterCountContainer{padding:0;display:none}[_nghost-%COMP%]     .showCharCount .characterCountContainer{display:block}[_nghost-%COMP%]     .characterCountLabel{font-size:13px;color:#aaa}[_nghost-%COMP%]     .characterCount{color:#000;font-size:16px;font-weight:bold}[_nghost-%COMP%]     .vertical-separator{margin:0 30px;color:#aaa}[_nghost-%COMP%]     .smsCountLabel{font-size:13px;color:#aaa}[_nghost-%COMP%]     .smsCount{color:#000;font-size:16px;font-weight:bold}[_nghost-%COMP%]     .editable:focus{outline:none}[_nghost-%COMP%]     .actions{margin-top:20px;text-align:center}[_nghost-%COMP%]     .btn{height:30px;border-radius:0;background-color:#eee;border:solid 1px #c4c4c4;text-align:center;cursor:pointer;display:inline-table;vertical-align:middle;font-size:14px;padding:6px 18px;color:#6a6b6c}[_nghost-%COMP%]     .btn.saveSMSTemplate{background-color:#3273e1;color:#fff;font-weight:bold}[_nghost-%COMP%]     #savedSMSTemplateData{display:none;margin:10px 0;background-color:#eee;padding:10px}[_nghost-%COMP%]     .asciiChar{background-color:#f8e81c}[_nghost-%COMP%]     .noteTemplate{background-color:#fffef1;padding:12px 17px;display:none;border:solid 1px rgba(245,166,35,.31);margin-bottom:10px}[_nghost-%COMP%]     .noteLabel{margin:0;color:#d0021b}[_nghost-%COMP%]     .noteMessage{margin:10px 0;font-size:12px;line-height:1.33;color:#38393a;font-weight:normal}[_nghost-%COMP%]     .approxLabel{display:none}[_nghost-%COMP%]     .note-tool-tip-css{position:relative;overflow-y:visible;cursor:pointer;color:#000;margin:0 8px}[_nghost-%COMP%]     .note-tool-tip-info{opacity:.4;display:inline-block;vertical-align:top}[_nghost-%COMP%]     .note-tool-tip-info img{margin-top:-5px}[_nghost-%COMP%]     .note-tool-tip{display:none;position:absolute;bottom:24px;width:385px;box-shadow:0 0 4px #00000080,inset 0 3px #f96969;background-color:#fff;left:50%;transform:translate(-50%);opacity:1;padding:20px;transition:all .3s ease-in-out}[_nghost-%COMP%]     .note-tool-tip:before{content:\"\";display:block;position:absolute;top:100%;left:50%;transform:translate(-50%);border-top:8px solid #fff;border-left:8px solid transparent;border-right:8px solid transparent;z-index:2}[_nghost-%COMP%]     .note-tool-tip:after{content:\"\";display:block;position:absolute;top:100%;left:50%;transform:translate(-50%);border-top:9px solid rgba(0,0,0,.2);border-left:9px solid transparent;border-right:9px solid transparent;z-index:1}[_nghost-%COMP%]     .note-tool-tip-css:hover .note-tool-tip{display:block}[_nghost-%COMP%]     .note-tool-tip-heading{margin-top:0;font-size:13px;font-weight:800;color:#000;text-transform:uppercase}[_nghost-%COMP%]     .note-tool-tip-message{color:#414f5f;font-size:12px;font-weight:normal}[_nghost-%COMP%]     .unselectable{-webkit-user-select:none;user-select:none}[_nghost-%COMP%]     .savedSMSTemplateData{display:none}[contentEditable=true][_ngcontent-%COMP%]:empty:not(:focus):before{content:attr(placeholder);color:#969696}[contentEditable=true][_ngcontent-%COMP%]:empty:before{content:attr(placeholder);color:#fff}.customVarBtnContainer[_ngcontent-%COMP%]{border-top:1px solid #ddd;padding:15px;margin-top:10px}.customVarBtn[_ngcontent-%COMP%]{cursor:pointer;font-size:12px;border:1px solid #ddd;width:140px;text-align:center;height:30px;line-height:30px;border-radius:50px}[_nghost-%COMP%]     .iot-customSmartLink{margin-top:-18px!important}[_nghost-%COMP%]     .iot-editable{padding:10px 10px 0 0!important;border:none!important;margin:0!important;font-family:\"ciscoSansLight\";font-weight:600}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmsHighlighterComponent, [{
        type: Component,
        args: [{
                selector: "lib-sms-highlighter",
                providers: [
                    {
                        provide: WINDOW,
                        // useValue: window
                        useFactory: windowFactory
                    }
                ],
                templateUrl: "./sms-highlighter.component.html",
                styleUrls: ["./sms-highlighter.component.css"]
            }]
    }], function () { return [{ type: LoggerService }, { type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, { defaultMessage: [{
            type: Input
        }], messageTemplate: [{
            type: Input
        }], getData: [{
            type: Input
        }], showSmsCount: [{
            type: Input
        }], placeHolderText: [{
            type: Input
        }], customVariableState: [{
            type: Input
        }], singleLine: [{
            type: Input
        }], fromIoTtriggerValue: [{
            type: Input
        }], listOfChips: [{
            type: Input
        }], updated: [{
            type: Output
        }], emitCustomPopupState: [{
            type: Output
        }] }); })();

function SplitLicenseChangeComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵlistener("click", function SplitLicenseChangeComponent_span_6_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.toggleChangeLicensePopup(false); });
    i0.ɵɵtext(1, "\uE909");
    i0.ɵɵelementEnd();
} }
function SplitLicenseChangeComponent_div_7_div_1_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "div", 34);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 35);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const count_r24 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(count_r24.count);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(count_r24.label);
} }
function SplitLicenseChangeComponent_div_7_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SplitLicenseChangeComponent_div_7_div_1_div_4_div_1_Template, 5, 2, "div", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r9.countPattern);
} }
function SplitLicenseChangeComponent_div_7_div_1_img_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 36);
} }
function SplitLicenseChangeComponent_div_7_div_1_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 37);
    i0.ɵɵtext(1, "See");
    i0.ɵɵelementEnd();
} }
function SplitLicenseChangeComponent_div_7_div_1_img_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 38);
} }
function SplitLicenseChangeComponent_div_7_div_1_span_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 39);
    i0.ɵɵtext(1, "Act");
    i0.ɵɵelementEnd();
} }
function SplitLicenseChangeComponent_div_7_div_1_img_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 40);
} }
function SplitLicenseChangeComponent_div_7_div_1_span_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵtext(1, "Extend");
    i0.ɵɵelementEnd();
} }
function SplitLicenseChangeComponent_div_7_div_1_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 42);
    i0.ɵɵtext(1, "SMART VENUES");
    i0.ɵɵelementEnd();
} }
function SplitLicenseChangeComponent_div_7_div_1_span_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 43);
    i0.ɵɵtext(1, "SMART OPERATIONS");
    i0.ɵɵelementEnd();
} }
function SplitLicenseChangeComponent_div_7_div_1_span_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 44);
    i0.ɵɵtext(1, "UNLIMITED");
    i0.ɵɵelementEnd();
} }
function SplitLicenseChangeComponent_div_7_div_1_div_32_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r25.availableLicenseTypes[0].subtitle, "");
} }
function SplitLicenseChangeComponent_div_7_div_1_div_32_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r26.availableLicenseTypes[0].error, "");
} }
const _c0$a = function (a0) { return { "disabledLicense": a0 }; };
function SplitLicenseChangeComponent_div_7_div_1_div_32_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelementStart(1, "div", 46);
    i0.ɵɵelementStart(2, "div", 47);
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵelementStart(5, "div", 48);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "div", 49);
    i0.ɵɵlistener("click", function SplitLicenseChangeComponent_div_7_div_1_div_32_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(3); return ctx_r27.changeBaseLicenseCheck(ctx_r27.availableLicenseTypes[0], "upgrade"); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, SplitLicenseChangeComponent_div_7_div_1_div_32_div_9_Template, 2, 1, "div", 50);
    i0.ɵɵelementStart(10, "div", 51);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, SplitLicenseChangeComponent_div_7_div_1_div_32_div_12_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$a, ctx_r19.availableLicenseTypes[0].disabled));
    i0.ɵɵadvance(6);
    i0.ɵɵclassMapInterpolate1("license-tag ", ctx_r19.availableLicenseTypes[0].class, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.availableLicenseTypes[0].title, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.availableLicenseTypes[0].subtitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r19.availableLicenseTypes[0].desc, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.availableLicenseTypes[0].error);
} }
function SplitLicenseChangeComponent_div_7_div_1_div_33_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r29.availableLicenseTypes[1].subtitle, "");
} }
function SplitLicenseChangeComponent_div_7_div_1_div_33_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r30.availableLicenseTypes[1].error, "");
} }
function SplitLicenseChangeComponent_div_7_div_1_div_33_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelementStart(1, "div", 46);
    i0.ɵɵelementStart(2, "div", 47);
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵelementStart(5, "div", 48);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "div", 49);
    i0.ɵɵlistener("click", function SplitLicenseChangeComponent_div_7_div_1_div_33_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(3); return ctx_r31.changeBaseLicenseCheck(ctx_r31.availableLicenseTypes[1], "upgrade"); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, SplitLicenseChangeComponent_div_7_div_1_div_33_div_9_Template, 2, 1, "div", 50);
    i0.ɵɵelementStart(10, "div", 51);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, SplitLicenseChangeComponent_div_7_div_1_div_33_div_12_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$a, ctx_r20.availableLicenseTypes[1].disabled));
    i0.ɵɵadvance(6);
    i0.ɵɵclassMapInterpolate1("license-tag ", ctx_r20.availableLicenseTypes[1].class, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r20.availableLicenseTypes[1].title, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.availableLicenseTypes[1].subtitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r20.availableLicenseTypes[1].desc, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.availableLicenseTypes[1].error);
} }
function SplitLicenseChangeComponent_div_7_div_1_div_34_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r33.availableLicenseTypes[2].subtitle, "");
} }
function SplitLicenseChangeComponent_div_7_div_1_div_34_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r34.availableLicenseTypes[2].error, "");
} }
function SplitLicenseChangeComponent_div_7_div_1_div_34_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelementStart(1, "div", 46);
    i0.ɵɵelementStart(2, "div", 47);
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵelementStart(5, "div", 48);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "div", 49);
    i0.ɵɵlistener("click", function SplitLicenseChangeComponent_div_7_div_1_div_34_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(3); return ctx_r35.changeBaseLicenseCheck(ctx_r35.availableLicenseTypes[2], "upgrade"); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, SplitLicenseChangeComponent_div_7_div_1_div_34_div_9_Template, 2, 1, "div", 50);
    i0.ɵɵelementStart(10, "div", 51);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, SplitLicenseChangeComponent_div_7_div_1_div_34_div_12_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$a, ctx_r21.availableLicenseTypes[2].disabled));
    i0.ɵɵadvance(6);
    i0.ɵɵclassMapInterpolate1("license-tag ", ctx_r21.availableLicenseTypes[2].class, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.availableLicenseTypes[2].title, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.availableLicenseTypes[2].subtitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r21.availableLicenseTypes[2].desc, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.availableLicenseTypes[2].error);
} }
function SplitLicenseChangeComponent_div_7_div_1_div_35_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r39.availableLicenseTypes[3].subtitle, "");
} }
function SplitLicenseChangeComponent_div_7_div_1_div_35_div_1_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r40.availableLicenseTypes[3].error, "");
} }
function SplitLicenseChangeComponent_div_7_div_1_div_35_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelementStart(1, "div", 46);
    i0.ɵɵelementStart(2, "div", 47);
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵelementStart(5, "div", 48);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "div", 49);
    i0.ɵɵlistener("click", function SplitLicenseChangeComponent_div_7_div_1_div_35_div_1_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r42); const ctx_r41 = i0.ɵɵnextContext(4); return ctx_r41.changeBaseLicenseCheck(ctx_r41.availableLicenseTypes[3], "upgrade"); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, SplitLicenseChangeComponent_div_7_div_1_div_35_div_1_div_9_Template, 2, 1, "div", 50);
    i0.ɵɵelementStart(10, "div", 51);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, SplitLicenseChangeComponent_div_7_div_1_div_35_div_1_div_12_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$a, ctx_r37.availableLicenseTypes[3].disabled));
    i0.ɵɵadvance(6);
    i0.ɵɵclassMapInterpolate1("license-tag ", ctx_r37.availableLicenseTypes[3].class, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r37.availableLicenseTypes[3].title, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r37.availableLicenseTypes[3].subtitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r37.availableLicenseTypes[3].desc, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r37.availableLicenseTypes[3].error);
} }
function SplitLicenseChangeComponent_div_7_div_1_div_35_div_2_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r43.availableLicenseTypes[4].subtitle, "");
} }
function SplitLicenseChangeComponent_div_7_div_1_div_35_div_2_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r44.availableLicenseTypes[4].error, "");
} }
function SplitLicenseChangeComponent_div_7_div_1_div_35_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelementStart(1, "div", 46);
    i0.ɵɵelementStart(2, "div", 47);
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵelementStart(5, "div", 48);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "div", 49);
    i0.ɵɵlistener("click", function SplitLicenseChangeComponent_div_7_div_1_div_35_div_2_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r46); const ctx_r45 = i0.ɵɵnextContext(4); return ctx_r45.changeBaseLicenseCheck(ctx_r45.availableLicenseTypes[4], "upgrade"); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, SplitLicenseChangeComponent_div_7_div_1_div_35_div_2_div_9_Template, 2, 1, "div", 50);
    i0.ɵɵelementStart(10, "div", 51);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, SplitLicenseChangeComponent_div_7_div_1_div_35_div_2_div_12_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$a, ctx_r38.availableLicenseTypes[4].disabled));
    i0.ɵɵadvance(6);
    i0.ɵɵclassMapInterpolate1("license-tag ", ctx_r38.availableLicenseTypes[4].class, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r38.availableLicenseTypes[4].title, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r38.availableLicenseTypes[4].subtitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r38.availableLicenseTypes[4].desc, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r38.availableLicenseTypes[4].error);
} }
function SplitLicenseChangeComponent_div_7_div_1_div_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, SplitLicenseChangeComponent_div_7_div_1_div_35_div_1_Template, 13, 10, "div", 30);
    i0.ɵɵtemplate(2, SplitLicenseChangeComponent_div_7_div_1_div_35_div_2_Template, 13, 10, "div", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r22.availableLicenseTypes[3] && ctx_r22.availableLicenseTypes[3].type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r22.availableLicenseTypes[4] && ctx_r22.availableLicenseTypes[4].type);
} }
function SplitLicenseChangeComponent_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵelementStart(3, "div", 11);
    i0.ɵɵtemplate(4, SplitLicenseChangeComponent_div_7_div_1_div_4_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 12);
    i0.ɵɵelementStart(6, "div", 13);
    i0.ɵɵelementStart(7, "div", 14);
    i0.ɵɵtext(8, "Base License");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 15);
    i0.ɵɵelementStart(10, "div", 16);
    i0.ɵɵelementStart(11, "div", 17);
    i0.ɵɵelementStart(12, "div", 18);
    i0.ɵɵtemplate(13, SplitLicenseChangeComponent_div_7_div_1_img_13_Template, 1, 0, "img", 19);
    i0.ɵɵtemplate(14, SplitLicenseChangeComponent_div_7_div_1_span_14_Template, 2, 0, "span", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 18);
    i0.ɵɵtemplate(16, SplitLicenseChangeComponent_div_7_div_1_img_16_Template, 1, 0, "img", 21);
    i0.ɵɵtemplate(17, SplitLicenseChangeComponent_div_7_div_1_span_17_Template, 2, 0, "span", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 18);
    i0.ɵɵtemplate(19, SplitLicenseChangeComponent_div_7_div_1_img_19_Template, 1, 0, "img", 23);
    i0.ɵɵtemplate(20, SplitLicenseChangeComponent_div_7_div_1_span_20_Template, 2, 0, "span", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 18);
    i0.ɵɵtemplate(22, SplitLicenseChangeComponent_div_7_div_1_span_22_Template, 2, 0, "span", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 18);
    i0.ɵɵtemplate(24, SplitLicenseChangeComponent_div_7_div_1_span_24_Template, 2, 0, "span", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 18);
    i0.ɵɵtemplate(26, SplitLicenseChangeComponent_div_7_div_1_span_26_Template, 2, 0, "span", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 28);
    i0.ɵɵelementStart(28, "div", 29);
    i0.ɵɵtext(29, "Choose the License Tier");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 15);
    i0.ɵɵelementStart(31, "div", 16);
    i0.ɵɵtemplate(32, SplitLicenseChangeComponent_div_7_div_1_div_32_Template, 13, 10, "div", 30);
    i0.ɵɵtemplate(33, SplitLicenseChangeComponent_div_7_div_1_div_33_Template, 13, 10, "div", 30);
    i0.ɵɵtemplate(34, SplitLicenseChangeComponent_div_7_div_1_div_34_Template, 13, 10, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(35, SplitLicenseChangeComponent_div_7_div_1_div_35_Template, 3, 2, "div", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r4.countPattern && ctx_r4.countPattern.length);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", ctx_r4.licenseType == "SEE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.licenseType == "SEE");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.licenseType == "ACT");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.licenseType == "ACT");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.licenseType == "EXT");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.licenseType == "EXT");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.licenseType == "SMART_VENUES");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.licenseType == "SMART_OPERATIONS");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.licenseType == "UNLIMITED");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r4.availableLicenseTypes[0] && ctx_r4.availableLicenseTypes[0].type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.availableLicenseTypes[1] && ctx_r4.availableLicenseTypes[1].type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.availableLicenseTypes[2] && ctx_r4.availableLicenseTypes[2].type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.availableLicenseTypes.length > 3);
} }
function SplitLicenseChangeComponent_div_7_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("By change, you will not be able to use some of the features and Apps that you were enjoying with \"", ctx_r47.customerLicenseType, "\" license. You may also lose some of the data on the selected location. ");
} }
function SplitLicenseChangeComponent_div_7_div_2_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("By change, you will be able to use some of the extra features and Apps for changed ", ctx_r48.changeLicenseType, " license. ");
} }
function SplitLicenseChangeComponent_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 53);
    i0.ɵɵelement(2, "img", 54);
    i0.ɵɵelementStart(3, "div", 55);
    i0.ɵɵtext(4, "Warning");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 56);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 57);
    i0.ɵɵtemplate(8, SplitLicenseChangeComponent_div_7_div_2_div_8_Template, 2, 1, "div", 8);
    i0.ɵɵtemplate(9, SplitLicenseChangeComponent_div_7_div_2_div_9_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 58);
    i0.ɵɵelementStart(11, "div", 59);
    i0.ɵɵlistener("click", function SplitLicenseChangeComponent_div_7_div_2_Template_div_click_11_listener() { i0.ɵɵrestoreView(_r50); const ctx_r49 = i0.ɵɵnextContext(2); return ctx_r49.goToConfirmationStep(); });
    i0.ɵɵtext(12, " Change Anyway");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 60);
    i0.ɵɵlistener("click", function SplitLicenseChangeComponent_div_7_div_2_Template_div_click_13_listener() { i0.ɵɵrestoreView(_r50); const ctx_r51 = i0.ɵɵnextContext(2); return ctx_r51.goToLicenseStep(); });
    i0.ɵɵtext(14, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate3("You are about to change your current plan from \"", ctx_r5.customerLicenseType == "EXT" ? "EXTEND" : ctx_r5.customerLicenseType, "\" to \"", ctx_r5.changeLicenseType, "\" at ", ctx_r5.locationName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.changeLicenseOption == "downgrade");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.changeLicenseOption == "upgrade");
} }
function SplitLicenseChangeComponent_div_7_div_3_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 66);
    i0.ɵɵelementStart(1, "table", 67);
    i0.ɵɵelementStart(2, "thead", 68);
    i0.ɵɵelementStart(3, "tr", 69);
    i0.ɵɵelementStart(4, "th", 70);
    i0.ɵɵtext(5, "License");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 70);
    i0.ɵɵtext(7, "Access Points");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th", 70);
    i0.ɵɵtext(9, "Webex Devices");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 70);
    i0.ɵɵtext(11, "Meraki Camera");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th", 70);
    i0.ɵɵtext(13, "Locations");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "th", 70);
    i0.ɵɵtext(15, "Building Units");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "tbody", 68);
    i0.ɵɵelementStart(17, "tr", 71);
    i0.ɵɵelementStart(18, "td", 72);
    i0.ɵɵelementStart(19, "div", 73);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "td");
    i0.ɵɵtext(22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "td");
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "td");
    i0.ɵɵtext(26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "td");
    i0.ɵɵtext(28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "td");
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(18);
    i0.ɵɵclassMap(ctx_r52.getLocationClass(ctx_r52.changeLicenseType));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r52.changeLicenseType);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r52.changeLicenseObj.apCount, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r52.changeLicenseObj.webexDeviceCount, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r52.changeLicenseObj.cameraCount, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r52.changeLicenseObj.locCount, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r52.changeLicenseObj.buildingUnitsCount, " ");
} }
function SplitLicenseChangeComponent_div_7_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 61);
    i0.ɵɵelementStart(2, "div", 62);
    i0.ɵɵtext(3, "Confirmation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 63);
    i0.ɵɵtext(5, "The following locations will have a change in the licence, agree to make these changes effective");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, SplitLicenseChangeComponent_div_7_div_3_div_6_Template, 31, 8, "div", 64);
    i0.ɵɵelementStart(7, "div", 58);
    i0.ɵɵelementStart(8, "div", 65);
    i0.ɵɵlistener("click", function SplitLicenseChangeComponent_div_7_div_3_Template_div_click_8_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(2); return ctx_r53.changeBaseLicenseSL(ctx_r53.changeLicenseType); });
    i0.ɵɵtext(9, "Confirm ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 60);
    i0.ɵɵlistener("click", function SplitLicenseChangeComponent_div_7_div_3_Template_div_click_10_listener() { i0.ɵɵrestoreView(_r54); const ctx_r55 = i0.ɵɵnextContext(2); return ctx_r55.goToLicenseStep(); });
    i0.ɵɵtext(11, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r6.locLicenseObjLoaded);
} }
function SplitLicenseChangeComponent_div_7_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 53);
    i0.ɵɵelement(2, "img", 74);
    i0.ɵɵelementStart(3, "div", 55);
    i0.ɵɵtext(4, "Success");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 56);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 57);
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtext(9, "Please login again to view the changes.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 58);
    i0.ɵɵelementStart(11, "div", 65);
    i0.ɵɵlistener("click", function SplitLicenseChangeComponent_div_7_div_4_Template_div_click_11_listener() { i0.ɵɵrestoreView(_r57); const ctx_r56 = i0.ɵɵnextContext(2); return ctx_r56.signOut(); });
    i0.ɵɵtext(12, "login");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("Your license level changed to ", ctx_r7.changeLicenseType, " ");
} }
function SplitLicenseChangeComponent_div_7_div_5_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 76);
    i0.ɵɵtext(1, "\"");
    i0.ɵɵelementStart(2, "span", 78);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, "\u201D proximity rules associated with this location ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r58.ruleCount);
} }
function SplitLicenseChangeComponent_div_7_div_5_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 76);
    i0.ɵɵtext(1, "\"");
    i0.ɵɵelementStart(2, "span", 78);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, "\u201D portals linked with this location or it\u2019s child location. ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r59.portalCount);
} }
function SplitLicenseChangeComponent_div_7_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 53);
    i0.ɵɵelement(2, "img", 54);
    i0.ɵɵelementStart(3, "div", 55);
    i0.ɵɵtext(4, "Cannot downgrade the license");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 56);
    i0.ɵɵtext(6, "The selected locations cannot be downgraded because of the following reason(s):");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 75);
    i0.ɵɵelementStart(8, "div", 76);
    i0.ɵɵtext(9, "There are:");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, SplitLicenseChangeComponent_div_7_div_5_div_10_Template, 5, 1, "div", 77);
    i0.ɵɵtemplate(11, SplitLicenseChangeComponent_div_7_div_5_div_11_Template, 5, 1, "div", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 57);
    i0.ɵɵtext(13, "Please remove the from to downgrade the license");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 58);
    i0.ɵɵelementStart(15, "div", 65);
    i0.ɵɵlistener("click", function SplitLicenseChangeComponent_div_7_div_5_Template_div_click_15_listener() { i0.ɵɵrestoreView(_r61); const ctx_r60 = i0.ɵɵnextContext(2); return ctx_r60.goToLicenseStep(); });
    i0.ɵɵtext(16, "Okay");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 60);
    i0.ɵɵlistener("click", function SplitLicenseChangeComponent_div_7_div_5_Template_div_click_17_listener() { i0.ɵɵrestoreView(_r61); const ctx_r62 = i0.ɵɵnextContext(2); return ctx_r62.goToLicenseStep(); });
    i0.ɵɵtext(18, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngIf", ctx_r8.ruleCount > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.portalCount > 0);
} }
function SplitLicenseChangeComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, SplitLicenseChangeComponent_div_7_div_1_Template, 36, 14, "div", 8);
    i0.ɵɵtemplate(2, SplitLicenseChangeComponent_div_7_div_2_Template, 15, 5, "div", 8);
    i0.ɵɵtemplate(3, SplitLicenseChangeComponent_div_7_div_3_Template, 12, 1, "div", 8);
    i0.ɵɵtemplate(4, SplitLicenseChangeComponent_div_7_div_4_Template, 13, 1, "div", 8);
    i0.ɵɵtemplate(5, SplitLicenseChangeComponent_div_7_div_5_Template, 19, 2, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.step == "license");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.step == "warning");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.step == "confirmation");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.step == "success");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.step == "error" && ctx_r1.countValuesLoaded);
} }
class SplitLicenseChangeComponent {
    constructor(dataService, locationService, userService, businessHierarchyService, translate) {
        this.dataService = dataService;
        this.locationService = locationService;
        this.userService = userService;
        this.businessHierarchyService = businessHierarchyService;
        this.translate = translate;
        this.unsubscribe$ = new Subject();
        this.showChangeLicensePopup = false;
        this.acceptTandC = false;
        this.step = 'license';
        this.closePopup = new EventEmitter();
        this.latestLicenseType = new EventEmitter();
        this.afterChangeLicense = new EventEmitter();
        this.smartLicenseObj = { 'consumedAps': 0, 'locationsCount': 0 };
        this.apiGetCallStatus = '';
        this.retryCounter = 0;
        this.ruleCount = 0;
        this.portalCount = 0;
        this.countValuesLoaded = false;
        this.showCountLoader = true;
        this.allowedLicenseTypes = [];
        this.messageKeys = {};
        this.getSmartLicenseDetail = () => {
            this.userService
                .getSmartLicenseDetail()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                if (response && response.status && response.data) {
                    if (response.data.status) {
                        if (response.data.status == "completed") {
                            this.apiGetCallStatus = "completed";
                            this.smartLicenseObj = response.data.details;
                        }
                    }
                }
            }, (error) => {
                console.log("ERROR :: Split License change component getSmartLicenseDetail call ", error);
            });
        };
        this.getLocLicenseType = () => {
            this.smartLicenseObj = { 'consumedAps': 0, 'locationsCount': 0 };
            this.dataService.display(true);
            this.businessHierarchyService.getLocLicenseType(this.locationId).subscribe((response) => {
                console.log(JSON.stringify(response));
                // Location License Object 
                let licenseObj = response.data;
                if (licenseObj) {
                    this.allowedLicenseTypes = licenseObj.allowedLicenseTypes ? licenseObj.allowedLicenseTypes : [];
                    this.seeObject = Object.assign({}, licenseObj.see);
                    this.seeObject["apCount"] = this.seeObject["apCount"] ? this.seeObject["apCount"] : 0;
                    this.seeObject["locCount"] = this.seeObject["locCount"] ? this.seeObject["locCount"] : 0;
                    this.seeObject["cameraCount"] = this.seeObject["cameraCount"] ? this.seeObject["cameraCount"] : 0;
                    this.seeObject["webexDeviceCount"] = this.seeObject["webexDeviceCount"] ? this.seeObject["webexDeviceCount"] : 0;
                    this.seeObject["buildingUnitsCount"] = this.seeObject["buildingUnitsCount"] ? this.seeObject["buildingUnitsCount"] : 0;
                    this.actObject = Object.assign({}, licenseObj.act);
                    this.actObject["apCount"] = this.actObject["apCount"] ? this.actObject["apCount"] : 0;
                    this.actObject["locCount"] = this.actObject["locCount"] ? this.actObject["locCount"] : 0;
                    this.actObject["cameraCount"] = this.actObject["cameraCount"] ? this.actObject["cameraCount"] : 0;
                    this.actObject["webexDeviceCount"] = this.actObject["webexDeviceCount"] ? this.actObject["webexDeviceCount"] : 0;
                    this.actObject["buildingUnitsCount"] = this.actObject["buildingUnitsCount"] ? this.actObject["buildingUnitsCount"] : 0;
                    this.extendObject = Object.assign({}, licenseObj.extend);
                    this.extendObject["apCount"] = this.extendObject["apCount"] ? this.extendObject["apCount"] : 0;
                    this.extendObject["locCount"] = this.extendObject["locCount"] ? this.extendObject["locCount"] : 0;
                    this.extendObject["cameraCount"] = this.extendObject["cameraCount"] ? this.extendObject["cameraCount"] : 0;
                    this.extendObject["webexDeviceCount"] = this.extendObject["webexDeviceCount"] ? this.extendObject["webexDeviceCount"] : 0;
                    this.extendObject["buildingUnitsCount"] = this.extendObject["buildingUnitsCount"] ? this.extendObject["buildingUnitsCount"] : 0;
                    this.smartvenueObj = Object.assign({}, licenseObj.smartVenue);
                    this.smartvenueObj["apCount"] = this.smartvenueObj["apCount"] ? this.smartvenueObj["apCount"] : 0;
                    this.smartvenueObj["locCount"] = this.smartvenueObj["locCount"] ? this.smartvenueObj["locCount"] : 0;
                    this.smartvenueObj["cameraCount"] = this.smartvenueObj["cameraCount"] ? this.smartvenueObj["cameraCount"] : 0;
                    this.smartvenueObj["webexDeviceCount"] = this.smartvenueObj["webexDeviceCount"] ? this.smartvenueObj["webexDeviceCount"] : 0;
                    this.smartvenueObj["buildingUnitsCount"] = this.smartvenueObj["buildingUnitsCount"] ? this.smartvenueObj["buildingUnitsCount"] : 0;
                    this.smartopsObj = Object.assign({}, licenseObj.smartOps);
                    this.smartopsObj["apCount"] = this.smartopsObj["apCount"] ? this.smartopsObj["apCount"] : 0;
                    this.smartopsObj["locCount"] = this.smartopsObj["locCount"] ? this.smartopsObj["locCount"] : 0;
                    this.smartopsObj["cameraCount"] = this.smartopsObj["cameraCount"] ? this.smartopsObj["cameraCount"] : 0;
                    this.smartopsObj["webexDeviceCount"] = this.smartopsObj["webexDeviceCount"] ? this.smartopsObj["webexDeviceCount"] : 0;
                    this.smartopsObj["buildingUnitsCount"] = this.smartopsObj["buildingUnitsCount"] ? this.smartopsObj["buildingUnitsCount"] : 0;
                    this.unlimitedObj = Object.assign({}, licenseObj.unlimited);
                    this.unlimitedObj["apCount"] = this.unlimitedObj["apCount"] ? this.unlimitedObj["apCount"] : 0;
                    this.unlimitedObj["locCount"] = this.unlimitedObj["locCount"] ? this.unlimitedObj["locCount"] : 0;
                    this.unlimitedObj["cameraCount"] = this.unlimitedObj["cameraCount"] ? this.unlimitedObj["cameraCount"] : 0;
                    this.unlimitedObj["webexDeviceCount"] = this.unlimitedObj["webexDeviceCount"] ? this.unlimitedObj["webexDeviceCount"] : 0;
                    this.unlimitedObj["buildingUnitsCount"] = this.unlimitedObj["buildingUnitsCount"] ? this.unlimitedObj["buildingUnitsCount"] : 0;
                    this.getAvailableLicenseTypes();
                    this.dataService.display(false);
                }
            }, (error) => {
                this.locLicenseObjLoaded = true;
                console.log(JSON.stringify(error));
                this.dataService.display(false);
            });
        };
        this.isEmptyObject = (obj) => {
            if (obj !== undefined && obj !== null) {
                const isEmptyObj = obj && Object.keys(obj).length === 0;
                // console.log("Empty Object Check::", obj, isEmptyObj);
                return isEmptyObj;
            }
            else {
                return true;
            }
        };
        this.toggleChangeLicensePopup = (show) => {
            if (this.step == 'tnc') {
                this.step = 'warning';
            }
            else {
                if (show == false) {
                    this.closePopup.emit();
                    this.latestLicenseType.emit();
                }
            }
        };
        this.validateStep = (step) => {
            let validateStatus = 'warning';
            if (step == 'license') {
                this.nextStep(validateStatus);
            }
        };
        this.nextStep = (step) => {
            this.step = step;
            if (step == 'success' && this.changeLicenseType == 'EXT') {
                this.changeLicenseType = 'Extend';
            }
        };
        this.goToLicenseStep = () => {
            if (this.step == 'confirmation') {
                this.getLocLicenseType();
            }
            this.step = 'license';
        };
        this.goToConfirmationStep = () => {
            // this.seeObjectAfter = Object.assign({}, this.seeObject);
            // this.actObjectAfter = Object.assign({}, this.actObject);
            // this.extendObjectAfter = Object.assign({}, this.extendObject);
            // this.smartvenueObjAfter = Object.assign({}, this.smartvenueObj);
            // this.smartopsObjAfter = Object.assign({}, this.smartopsObj);
            // this.unlimitedObjAfter = Object.assign({}, this.unlimitedObj);
            // this.seeObjectAfterMinus = Object.assign({}, this.seeObject);
            // this.actObjectAfterMinus = Object.assign({}, this.actObject);
            // this.extendObjectAfterMinus = Object.assign({}, this.extendObject);
            // this.smartvenueObjAfterMinus = Object.assign({}, this.smartvenueObj);
            // this.smartopsObjAfterMinus = Object.assign({}, this.smartopsObj);
            // this.unlimitedObjAfterMinus = Object.assign({}, this.unlimitedObj);
            // this.seeObjectAfterPlus = Object.assign({}, this.seeObject);
            // this.actObjectAfterPlus = Object.assign({}, this.actObject);
            // this.extendObjectAfterPlus = Object.assign({}, this.extendObject);
            // this.smartvenueObjAfterPlus = Object.assign({}, this.smartvenueObj);
            // this.smartopsObjAfterPlus = Object.assign({}, this.smartopsObj);
            // this.unlimitedObjAfterPlus = Object.assign({}, this.unlimitedObj);
            // if (this.customerLicenseType == 'SEE') {
            //   this.seeObjectAfterMinus["apCount"] = this.seeObject["apCount"];
            //   this.seeObjectAfterMinus["locCount"] = this.seeObject["locCount"];
            //   this.seeObjectAfter["apCount"] = 0;
            //   this.seeObjectAfter["locCount"] = 0;
            // } else if (this.customerLicenseType == 'ACT') {
            //   this.actObjectAfterMinus["apCount"] = this.actObject["apCount"];
            //   this.actObjectAfterMinus["locCount"] = this.actObject["locCount"];
            //   this.actObjectAfter["apCount"] = 0;
            //   this.actObjectAfter["locCount"] = 0;
            // } else if (this.customerLicenseType == 'EXT') {
            //   this.extendObjectAfterMinus["apCount"] = this.extendObject["apCount"];
            //   this.extendObjectAfterMinus["locCount"] = this.extendObject["locCount"];
            //   this.extendObjectAfter["apCount"] = 0;
            //   this.extendObjectAfter["locCount"] = 0;
            // }
            if (this.changeLicenseType == 'EXTEND') {
                this.changeLicenseType = 'EXT';
            }
            if (this.customerLicenseType == 'EXTEND') {
                this.customerLicenseType = 'EXT';
            }
            this.changeLicenseObj = {};
            switch (this.changeLicenseType) {
                case "ACT": {
                    if (this.customerLicenseType == 'EXT') {
                        this.changeLicenseObj["apCount"] = this.actObject["apCount"] + this.extendObject["apCount"];
                        this.changeLicenseObj["locCount"] = this.actObject["locCount"] + this.extendObject["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.actObject["cameraCount"] + this.extendObject["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.actObject["webexDeviceCount"] + this.extendObject["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.actObject["buildingUnitsCount"] + this.extendObject["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'SMART_VENUES') {
                        this.changeLicenseObj["apCount"] = this.actObject["apCount"] + this.smartvenueObj["apCount"];
                        this.changeLicenseObj["locCount"] = this.actObject["locCount"] + this.smartvenueObj["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.actObject["cameraCount"] + this.smartvenueObj["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.actObject["webexDeviceCount"] + this.smartvenueObj["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.actObject["buildingUnitsCount"] + this.smartvenueObj["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'SMART_OPERATIONS') {
                        this.changeLicenseObj["apCount"] = this.actObject["apCount"] + this.smartopsObj["apCount"];
                        this.changeLicenseObj["locCount"] = this.actObject["locCount"] + this.smartopsObj["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.actObject["cameraCount"] + this.smartopsObj["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.actObject["webexDeviceCount"] + this.smartopsObj["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.actObject["buildingUnitsCount"] + this.smartopsObj["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'UNLIMITED') {
                        this.changeLicenseObj["apCount"] = this.actObject["apCount"] + this.unlimitedObj["apCount"];
                        this.changeLicenseObj["locCount"] = this.actObject["locCount"] + this.unlimitedObj["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.actObject["cameraCount"] + this.unlimitedObj["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.actObject["webexDeviceCount"] + this.unlimitedObj["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.actObject["buildingUnitsCount"] + this.unlimitedObj["buildingUnitsCount"];
                    }
                    break;
                }
                case "EXT": {
                    if (this.customerLicenseType == 'ACT') {
                        this.changeLicenseObj["apCount"] = this.extendObject["apCount"] + this.actObject["apCount"];
                        this.changeLicenseObj["locCount"] = this.extendObject["locCount"] + this.actObject["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.extendObject["cameraCount"] + this.actObject["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.extendObject["webexDeviceCount"] + this.actObject["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.extendObject["buildingUnitsCount"] + this.actObject["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'SMART_VENUES') {
                        this.changeLicenseObj["apCount"] = this.extendObject["apCount"] + this.smartvenueObj["apCount"];
                        this.changeLicenseObj["locCount"] = this.extendObject["locCount"] + this.smartvenueObj["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.extendObject["cameraCount"] + this.smartvenueObj["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.extendObject["webexDeviceCount"] + this.smartvenueObj["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.extendObject["buildingUnitsCount"] + this.smartvenueObj["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'SMART_OPERATIONS') {
                        this.changeLicenseObj["apCount"] = this.extendObject["apCount"] + this.smartopsObj["apCount"];
                        this.changeLicenseObj["locCount"] = this.extendObject["locCount"] + this.smartopsObj["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.extendObject["cameraCount"] + this.smartopsObj["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.extendObject["webexDeviceCount"] + this.smartopsObj["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.extendObject["buildingUnitsCount"] + this.smartopsObj["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'UNLIMITED') {
                        this.changeLicenseObj["apCount"] = this.extendObject["apCount"] + this.unlimitedObj["apCount"];
                        this.changeLicenseObj["locCount"] = this.extendObject["locCount"] + this.unlimitedObj["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.extendObject["cameraCount"] + this.unlimitedObj["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.extendObject["webexDeviceCount"] + this.unlimitedObj["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.extendObject["buildingUnitsCount"] + this.unlimitedObj["buildingUnitsCount"];
                    }
                    break;
                }
                case "SMART_VENUES": {
                    if (this.customerLicenseType == 'ACT') {
                        this.changeLicenseObj["apCount"] = this.smartvenueObj["apCount"] + this.actObject["apCount"];
                        this.changeLicenseObj["locCount"] = this.smartvenueObj["locCount"] + this.actObject["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.smartvenueObj["cameraCount"] + this.actObject["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.smartvenueObj["webexDeviceCount"] + this.actObject["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.smartvenueObj["buildingUnitsCount"] + this.actObject["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'EXT') {
                        this.changeLicenseObj["apCount"] = this.smartvenueObj["apCount"] + this.extendObject["apCount"];
                        this.changeLicenseObj["locCount"] = this.smartvenueObj["locCount"] + this.extendObject["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.smartvenueObj["cameraCount"] + this.extendObject["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.smartvenueObj["webexDeviceCount"] + this.extendObject["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.smartvenueObj["buildingUnitsCount"] + this.extendObject["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'SMART_OPERATIONS') {
                        this.changeLicenseObj["apCount"] = this.smartvenueObj["apCount"] + this.smartopsObj["apCount"];
                        this.changeLicenseObj["locCount"] = this.smartvenueObj["locCount"] + this.smartopsObj["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.smartvenueObj["cameraCount"] + this.smartopsObj["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.smartvenueObj["webexDeviceCount"] + this.smartopsObj["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.smartvenueObj["buildingUnitsCount"] + this.smartopsObj["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'UNLIMITED') {
                        this.changeLicenseObj["apCount"] = this.smartvenueObj["apCount"] + this.unlimitedObj["apCount"];
                        this.changeLicenseObj["locCount"] = this.smartvenueObj["locCount"] + this.unlimitedObj["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.smartvenueObj["cameraCount"] + this.unlimitedObj["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.smartvenueObj["webexDeviceCount"] + this.unlimitedObj["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.smartvenueObj["buildingUnitsCount"] + this.unlimitedObj["buildingUnitsCount"];
                    }
                    break;
                }
                case "SMART_OPERATIONS": {
                    if (this.customerLicenseType == 'ACT') {
                        this.changeLicenseObj["apCount"] = this.smartopsObj["apCount"] + this.actObject["apCount"];
                        this.changeLicenseObj["locCount"] = this.smartopsObj["locCount"] + this.actObject["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.smartopsObj["cameraCount"] + this.actObject["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.smartopsObj["webexDeviceCount"] + this.actObject["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.smartopsObj["buildingUnitsCount"] + this.actObject["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'EXT') {
                        this.changeLicenseObj["apCount"] = this.smartopsObj["apCount"] + this.extendObject["apCount"];
                        this.changeLicenseObj["locCount"] = this.smartopsObj["locCount"] + this.extendObject["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.smartopsObj["cameraCount"] + this.extendObject["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.smartopsObj["webexDeviceCount"] + this.extendObject["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.smartopsObj["buildingUnitsCount"] + this.extendObject["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'SMART_VENUES') {
                        this.changeLicenseObj["apCount"] = this.smartopsObj["apCount"] + this.smartvenueObj["apCount"];
                        this.changeLicenseObj["locCount"] = this.smartopsObj["locCount"] + this.smartvenueObj["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.smartopsObj["cameraCount"] + this.smartvenueObj["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.smartopsObj["webexDeviceCount"] + this.smartvenueObj["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.smartopsObj["buildingUnitsCount"] + this.smartvenueObj["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'UNLIMITED') {
                        this.changeLicenseObj["apCount"] = this.smartopsObj["apCount"] + this.unlimitedObj["apCount"];
                        this.changeLicenseObj["locCount"] = this.smartopsObj["locCount"] + this.unlimitedObj["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.smartopsObj["cameraCount"] + this.unlimitedObj["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.smartopsObj["webexDeviceCount"] + this.unlimitedObj["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.smartopsObj["buildingUnitsCount"] + this.unlimitedObj["buildingUnitsCount"];
                    }
                    break;
                }
                case "UNLIMITED": {
                    if (this.customerLicenseType == 'EXT') {
                        this.changeLicenseObj["apCount"] = this.unlimitedObj["apCount"] + this.extendObject["apCount"];
                        this.changeLicenseObj["locCount"] = this.unlimitedObj["locCount"] + this.extendObject["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.unlimitedObj["cameraCount"] + this.extendObject["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.unlimitedObj["webexDeviceCount"] + this.extendObject["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.unlimitedObj["buildingUnitsCount"] + this.extendObject["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'SMART_VENUES') {
                        this.changeLicenseObj["apCount"] = this.unlimitedObj["apCount"] + this.smartvenueObj["apCount"];
                        this.changeLicenseObj["locCount"] = this.unlimitedObj["locCount"] + this.smartvenueObj["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.unlimitedObj["cameraCount"] + this.smartvenueObj["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.unlimitedObj["webexDeviceCount"] + this.smartvenueObj["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.unlimitedObj["buildingUnitsCount"] + this.smartvenueObj["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'SMART_OPERATIONS') {
                        this.changeLicenseObj["apCount"] = this.unlimitedObj["apCount"] + this.smartopsObj["apCount"];
                        this.changeLicenseObj["locCount"] = this.unlimitedObj["locCount"] + this.smartopsObj["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.unlimitedObj["cameraCount"] + this.smartopsObj["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.unlimitedObj["webexDeviceCount"] + this.smartopsObj["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.unlimitedObj["buildingUnitsCount"] + this.smartopsObj["buildingUnitsCount"];
                    }
                    else if (this.customerLicenseType == 'ACT') {
                        this.changeLicenseObj["apCount"] = this.unlimitedObj["apCount"] + this.actObject["apCount"];
                        this.changeLicenseObj["locCount"] = this.unlimitedObj["locCount"] + this.actObject["locCount"];
                        this.changeLicenseObj["cameraCount"] = this.unlimitedObj["cameraCount"] + this.actObject["cameraCount"];
                        this.changeLicenseObj["webexDeviceCount"] = this.unlimitedObj["webexDeviceCount"] + this.actObject["webexDeviceCount"];
                        this.changeLicenseObj["buildingUnitsCount"] = this.unlimitedObj["buildingUnitsCount"] + this.actObject["buildingUnitsCount"];
                    }
                    break;
                }
                default: {
                    break;
                }
            }
            // // Change License calculations
            // if (this.changeLicenseType == 'ACT') {
            //   if (this.customerLicenseType == 'SEE') {
            //     this.actObjectAfterPlus["apCount"] = this.seeObjectAfterMinus["apCount"];
            //     this.actObjectAfterPlus["locCount"] = this.seeObjectAfterMinus["locCount"];
            //     this.actObjectAfter["apCount"] = this.actObject["apCount"] + this.actObjectAfterPlus["apCount"];
            //     this.actObjectAfter["locCount"] = this.actObject["locCount"] + this.actObjectAfterPlus["locCount"];
            //   } else if (this.customerLicenseType == 'EXT') {
            //     this.actObjectAfterPlus["apCount"] = this.extendObjectAfterMinus["apCount"];
            //     this.actObjectAfterPlus["locCount"] = this.extendObjectAfterMinus["locCount"];
            //     this.actObjectAfter["apCount"] = this.actObject["apCount"] + this.actObjectAfterPlus["apCount"];
            //     this.actObjectAfter["locCount"] = this.actObject["locCount"] + this.actObjectAfterPlus["locCount"];
            //   }
            // } else if (this.changeLicenseType == 'EXT') {
            //   if (this.customerLicenseType == 'SEE') {
            //     this.extendObjectAfterPlus["apCount"] = this.seeObjectAfterMinus["apCount"];
            //     this.extendObjectAfterPlus["locCount"] = this.seeObjectAfterMinus["locCount"];
            //     this.extendObjectAfter["apCount"] = this.extendObject["apCount"] + this.extendObjectAfterPlus["apCount"];
            //     this.extendObjectAfter["locCount"] = this.extendObject["locCount"] + this.extendObjectAfterPlus["locCount"];
            //   } else if (this.customerLicenseType == 'ACT') {
            //     this.extendObjectAfterPlus["apCount"] = this.actObjectAfterMinus["apCount"];
            //     this.extendObjectAfterPlus["locCount"] = this.actObjectAfterMinus["locCount"];
            //     this.extendObjectAfter["apCount"] = this.extendObject["apCount"] + this.extendObjectAfterPlus["apCount"];
            //     this.extendObjectAfter["locCount"] = this.extendObject["locCount"] + this.extendObjectAfterPlus["locCount"];
            //   }
            // }
            this.step = 'confirmation';
        };
        this.checkAcceptTandC = (event) => {
            console.log(" :: acceptTandC " + this.acceptTandC + " :: event " + event);
        };
        this.changeBaseLicenseCheck = (licenseObj, type) => {
            if (licenseObj && licenseObj.type)
                this.changeLicenseOption = type;
            if (type == 'upgrade' || type == 'downgrade') {
                this.step = 'warning';
                this.changeLicenseType = licenseObj.type;
            }
        };
        this.changeBaseLicenseSL = (licType) => {
            this.dataService.display(true);
            this.countValuesLoaded = false;
            let licenseObj = {
                "locationId": this.locationId,
                "licType": licType
            };
            this.businessHierarchyService.saveLocationLicenseInfo(licenseObj).pipe(takeUntil(this.unsubscribe$)).subscribe(response => {
                if (response && response.status) {
                    if (response.data && response.data.licenseChangeError) {
                        let responseData = response.data;
                        this.step = 'error';
                        this.ruleCount = responseData.captivePortalRulesCount + responseData.engagementCount + responseData.profileCount;
                        this.portalCount = responseData.captivePortalCount;
                        this.countValuesLoaded = true;
                    }
                    else {
                        this.dataService.setToastMessage(response.message, 4000, null, null, 'success');
                        this.latestLicenseType.emit();
                        this.afterChangeLicense.emit();
                    }
                }
                else {
                    this.dataService.setToastMessage(response.message, 4000, null, null, 'error');
                }
                this.dataService.display(false);
            }, error => {
                this.dataService.display(false);
                console.log("ERROR: changeBaseLicense post call ::: ", error);
            });
        };
        this.signOut = () => {
            this.dataService.display(true);
            this.locationService.signOut();
        };
        this.getAvailableLicenseTypes = () => {
            if (this.licenseType) {
                let actObj = { 'type': 'ACT', 'class': 'act-tag', 'title': 'ACT', 'subtitle': '', 'desc': this.messageKeys["actObjDesc"], 'error': '', 'tooltip': '', 'disabled': true };
                let extendObj = { 'type': 'EXTEND', 'class': 'extend-tag', 'title': 'EXTEND', 'subtitle': '', 'desc': this.messageKeys["extendObjDesc"], 'error': '', 'tooltip': '', 'disabled': true };
                let unlimitedObj = { 'type': 'UNLIMITED', 'class': 'unlimited-tag', 'title': 'UNLIMITED', 'subtitle': 'This plan will convert your devices to SQFT metering', 'desc': this.messageKeys["unlimitedObjDesc"], 'error': '', 'tooltip': '', 'disabled': true };
                let smartVenueObj = { 'type': 'SMART_VENUES', 'class': 'smartvenue-tag', 'title': 'SMART_VENUES', 'subtitle': '', 'desc': this.messageKeys["smartVenueObjDesc"], 'error': '', 'tooltip': '', 'disabled': true };
                let smartOpsObj = { 'type': 'SMART_OPERATIONS', 'class': 'smartops-tag', 'title': 'SMART_OPERATIONS', 'subtitle': '', 'desc': this.messageKeys["smartOpsObjDesc"], 'error': '', 'tooltip': '', 'disabled': true };
                // disable logic 
                // ["see", "act", "extend", "extend-sw", "smartVenues", "smartOperations", "unlimited"]
                this.allowedLicenseTypes.forEach(licType => {
                    switch (licType) {
                        case "act": {
                            actObj.disabled = false;
                            break;
                        }
                        case "extend": {
                            extendObj.disabled = false;
                            break;
                        }
                        case "smartVenues": {
                            smartVenueObj.disabled = false;
                            break;
                        }
                        case "smartOperations": {
                            smartOpsObj.disabled = false;
                            break;
                        }
                        case "unlimited": {
                            unlimitedObj.disabled = false;
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                });
                console.log('location license type :: ', this.licenseType);
                let licenseType = this.licenseType == 'EXT' ? 'EXTEND' : this.licenseType;
                switch (licenseType) {
                    case "ACT": {
                        this.availableLicenseTypes = [
                            extendObj, unlimitedObj, smartVenueObj, smartOpsObj
                        ];
                        break;
                    }
                    case "EXTEND": {
                        this.availableLicenseTypes = [
                            actObj, unlimitedObj, smartVenueObj, smartOpsObj
                        ];
                        break;
                    }
                    case "SMART_VENUES": {
                        this.availableLicenseTypes = [
                            actObj, extendObj, unlimitedObj, smartOpsObj
                        ];
                        break;
                    }
                    case "SMART_OPERATIONS": {
                        this.availableLicenseTypes = [
                            actObj, extendObj, unlimitedObj, smartVenueObj
                        ];
                        break;
                    }
                    case "UNLIMITED": {
                        this.availableLicenseTypes = [
                            actObj, extendObj, smartVenueObj, smartOpsObj
                        ];
                        break;
                    }
                    default: {
                        this.availableLicenseTypes = [actObj, extendObj, unlimitedObj, smartVenueObj, smartOpsObj];
                        break;
                    }
                }
                this.locLicenseObjLoaded = true;
            }
        };
        this.getLocationClass = (licenseType) => {
            let classString = '';
            if (licenseType) {
                classString = licenseType.toLowerCase() + '-tag';
                classString = classString.replace(' ', '');
                return classString;
            }
        };
        this.getStaticText = () => {
            this.translate.get('shared-lib.split-license.actObj.desc').subscribe((res) => {
                this.messageKeys["actObjDesc"] = res;
            });
            this.translate.get('shared-lib.split-license.extendObj.desc').subscribe((res) => {
                this.messageKeys["extendObjDesc"] = res;
            });
            this.translate.get('shared-lib.split-license.unlimitedObj.desc').subscribe((res) => {
                this.messageKeys["unlimitedObjDesc"] = res;
            });
            this.translate.get('shared-lib.split-license.smartVenueObj.desc').subscribe((res) => {
                this.messageKeys["smartVenueObjDesc"] = res;
            });
            this.translate.get('shared-lib.split-license.smartOpsObj.desc').subscribe((res) => {
                this.messageKeys["smartOpsObjDesc"] = res;
            });
        };
    }
    ngOnInit() {
        this.dataService.getI18nLangChange(this.unsubscribe$).subscribe((langChange) => {
            // Add all fetching of localised string here
            this.getStaticText();
        });
        this.dataService.display(false);
        let slLinkUrl = this.dataService.getSmartLicenseLearnMore();
        this.slLearnMoreLink = slLinkUrl ? slLinkUrl : 'https://www.cisco.com/c/en_in/products/software/smart-accounts/software-licensing.html';
        this.step = 'license';
        this.customerLicenseType = this.licenseType;
        this.getSmartLicenseDetail();
        this.getLocLicenseType();
    }
    ngOnDestroy() {
        console.log('destory Change Base License component');
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
SplitLicenseChangeComponent.ɵfac = function SplitLicenseChangeComponent_Factory(t) { return new (t || SplitLicenseChangeComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(UserService), i0.ɵɵdirectiveInject(BusinessHierarchyService), i0.ɵɵdirectiveInject(i2.TranslateService)); };
SplitLicenseChangeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SplitLicenseChangeComponent, selectors: [["app-split-license-change"]], inputs: { locationId: "locationId", locationName: "locationName", licenseType: "licenseType", countPattern: "countPattern" }, outputs: { closePopup: "closePopup", latestLicenseType: "latestLicenseType", afterChangeLicense: "afterChangeLicense" }, decls: 8, vars: 3, consts: [[1, "modalPopup"], [1, "modalOverlay"], [1, "wireless-network-modalContent"], [1, "modalHeader"], ["class", "modalCloseIcon", 3, "click", 4, "ngIf"], ["class", "modalBody", 4, "ngIf"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], [4, "ngIf"], [1, "loc-split"], [1, "left-split"], [1, "bh-loc-counts"], [1, "right-split"], [1, "license-border"], [1, "license-level-label"], [1, "divTable"], [1, "divTableRow"], [1, "divTableCell", "width150"], [1, "divTable150"], ["class", "divCell-img", "src", "/assets/images/basic/generic/see.svg", 4, "ngIf"], ["class", "see-label divCell-label", 4, "ngIf"], ["class", "divCell-img", "src", "/assets/images/basic/generic/act.svg", 4, "ngIf"], ["class", "act-label divCell-label", 4, "ngIf"], ["class", "divCell-img", "src", "/assets/images/basic/generic/extend.svg", 4, "ngIf"], ["class", "extend-label divCell-label", 4, "ngIf"], ["class", "smartvenue-label divCell-label", 4, "ngIf"], ["class", "smartops-label divCell-label", 4, "ngIf"], ["class", "unlimited-label divCell-label", 4, "ngIf"], [1, "license-types-wrapper"], [1, "choose-license-text"], ["class", "divTableCell width-33", 3, "ngClass", 4, "ngIf"], ["class", "divTableRow", 4, "ngIf"], ["class", "bh-count-pattern", 4, "ngFor", "ngForOf"], [1, "bh-count-pattern"], [1, "count-name"], [1, "count-label"], ["src", "/assets/images/basic/generic/see.svg", 1, "divCell-img"], [1, "see-label", "divCell-label"], ["src", "/assets/images/basic/generic/act.svg", 1, "divCell-img"], [1, "act-label", "divCell-label"], ["src", "/assets/images/basic/generic/extend.svg", 1, "divCell-img"], [1, "extend-label", "divCell-label"], [1, "smartvenue-label", "divCell-label"], [1, "smartops-label", "divCell-label"], [1, "unlimited-label", "divCell-label"], [1, "divTableCell", "width-33", 3, "ngClass"], [1, "license-wrapper-border"], [1, "license-header"], [1, "divTableCell"], [1, "license-label", 3, "click"], ["class", "license-subtitle", 4, "ngIf"], [1, "license-desc"], [1, "license-subtitle"], [1, "alertPopupMargin"], ["src", "/assets/images/warning.svg", "width", "60"], [1, "warningLabel"], [1, "alertHeader"], [1, "alertDesc"], [1, ""], [1, "marginTB10", "primaryButton", "capitalizeLabel", 3, "click"], [1, "modalSecondaryButton", 3, "click"], [1, "alertPopupMargin", "confirmationStep"], [1, "confirmation-title"], [1, "confirmation-desc"], ["class", "userTableContainer", 4, "ngIf"], [1, "marginTB10", "primaryButton", 3, "click"], [1, "userTableContainer"], [1, "table", "userTable"], [1, "table-border"], [1, "rules-list-header"], [1, "h-col"], [1, "tableTr"], [1, "license-tag"], [1, "license-label"], ["src", "/assets/images/dna-spaces/successfull.svg", "width", "60"], [1, "listingWrapper"], [1, "listingTwo"], ["class", "listingTwo", 4, "ngIf"], [2, "color", "#000", "font-weight", "bolder"]], template: function SplitLicenseChangeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "span");
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, SplitLicenseChangeComponent_span_6_Template, 2, 0, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, SplitLicenseChangeComponent_div_7_Template, 6, 5, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.locationName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.step != "success");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.locLicenseObjLoaded && ctx.availableLicenseTypes && ctx.availableLicenseTypes.length > 0);
    } }, directives: [i1$2.NgIf, i1$2.NgForOf, i1$2.NgClass], styles: [".wireless-network-modalContent[_ngcontent-%COMP%]{top:40px;bottom:40px;left:40px;right:40px;z-index:1001;position:absolute;background-color:#fff;box-shadow:0 0 20px #0000004d;border-radius:0;overflow:hidden}.wireless-network-modalContent[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{font-family:\"ciscoSansThin\";font-weight:bolder}.wireless-network-modalContent[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{background-color:#fff;width:100%;height:90%;overflow-y:scroll;margin-bottom:40px;padding:0}.wireless-network-modalContent[_ngcontent-%COMP%]   .width-33[_ngcontent-%COMP%]{width:33%;vertical-align:top}.wireless-network-modalContent[_ngcontent-%COMP%]   .license-wrapper-border[_ngcontent-%COMP%]{padding:20px;margin:20px 20px 20px 0;background:#FFFFFF;border:2px solid #F1F1F1;border-radius:6px;height:180px}.wireless-network-modalContent[_ngcontent-%COMP%]   .choose-license-text[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:14px;line-height:20px;letter-spacing:1px;text-transform:uppercase;color:#121212}.wireless-network-modalContent[_ngcontent-%COMP%]   .liecense-img[_ngcontent-%COMP%]{width:80px}.wireless-network-modalContent[_ngcontent-%COMP%]   .cisco-dna-spaces-label[_ngcontent-%COMP%]{font-size:17px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .see-label[_ngcontent-%COMP%]{color:#009edc;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .extend-label[_ngcontent-%COMP%]{color:#7cc242;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .act-label[_ngcontent-%COMP%]{color:#f8ab19;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .smartvenue-label[_ngcontent-%COMP%]{color:#436fb6;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .smartops-label[_ngcontent-%COMP%]{color:#8750a1;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .unlimited-label[_ngcontent-%COMP%]{color:#ff7c33;font-size:30px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .scroll-div[_ngcontent-%COMP%]{height:50vh;overflow-y:auto}.wireless-network-modalContent[_ngcontent-%COMP%]   .include-text[_ngcontent-%COMP%]{font-size:14px;font-family:CiscoSansLight;font-weight:bold}.wireless-network-modalContent[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:.5em 0 0 15px}.wireless-network-modalContent[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style-type:none;padding-bottom:10px}.wireless-network-modalContent[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:before{content:\"\";float:left;display:list-item;list-style-type:disc;list-style-position:inside;width:20px;margin-left:-15px}.wireless-network-modalContent[_ngcontent-%COMP%]   .paddingTB20[_ngcontent-%COMP%]{padding:20px 0}.wireless-network-modalContent[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{display:block}.wireless-network-modalContent[_ngcontent-%COMP%]   .alertPopupMargin[_ngcontent-%COMP%]{margin:100px 25%;text-align:center}.wireless-network-modalContent[_ngcontent-%COMP%]   .warningLabel[_ngcontent-%COMP%]{padding:10px;font-size:20px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .alertHeader[_ngcontent-%COMP%]{padding:10px;font-size:18px;font-family:CiscoSansLight}.wireless-network-modalContent[_ngcontent-%COMP%]   .alertDesc[_ngcontent-%COMP%]{padding:10px}.wireless-network-modalContent[_ngcontent-%COMP%]   .listingWrapper[_ngcontent-%COMP%]{border:1px solid rgba(171,172,172,.5);padding:25px 20px;text-align:left;display:block;margin:0 auto;width:-moz-fit-content;width:fit-content}.wireless-network-modalContent[_ngcontent-%COMP%]   .listingTwo[_ngcontent-%COMP%]{font-size:14px;line-height:20px;font-family:ciscoSansLight;color:#6a6b6c}.wireless-network-modalContent[_ngcontent-%COMP%]   .downgrade[_ngcontent-%COMP%]{color:#ff0c0c}.wireless-network-modalContent[_ngcontent-%COMP%]   .downgrade[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{border-color:#ff0c0c;color:#ff0c0c}.wireless-network-modalContent[_ngcontent-%COMP%]   .currentplan[_ngcontent-%COMP%]{color:#7cc242;text-align:center}.wireless-network-modalContent[_ngcontent-%COMP%]   .currentplan-span[_ngcontent-%COMP%]{padding-left:10px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:40%}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:30%}.columnData[_ngcontent-%COMP%]{font-family:ciscoSans;font-size:12px;text-align:left;color:#58585b}.changeLicenseDesc[_ngcontent-%COMP%]{font-size:12px;padding-top:5px}.link[_ngcontent-%COMP%]{color:#049fd9;font-weight:bold}.marginTop40[_ngcontent-%COMP%]{margin-top:40px}.tncMargin[_ngcontent-%COMP%]{margin-top:10px;margin-bottom:20px}.marginR10[_ngcontent-%COMP%]{margin-right:10px}.confirmationStep[_ngcontent-%COMP%]   table[_ngcontent-%COMP%], .confirmationStep[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .confirmationStep[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border:1px solid black;border-collapse:collapse;padding:10px;box-shadow:0 2px 5px #0000000d}.confirmationStep[_ngcontent-%COMP%]   .padding16[_ngcontent-%COMP%]{padding:16px}.confirmationStep[_ngcontent-%COMP%]   .bold-text[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:13px;line-height:18px;letter-spacing:.0417px;color:#1d3243}.confirmationStep[_ngcontent-%COMP%]   .red-label[_ngcontent-%COMP%]{color:red}.confirmationStep[_ngcontent-%COMP%]   .green-label[_ngcontent-%COMP%]{color:green}.capitalizeLabel[_ngcontent-%COMP%]{text-transform:capitalize}.loc-split[_ngcontent-%COMP%]{display:table;width:100%;padding:30px}.loc-split[_ngcontent-%COMP%]   .left-split[_ngcontent-%COMP%]{width:75%;display:table-cell;vertical-align:middle}.loc-split[_ngcontent-%COMP%]   .right-split[_ngcontent-%COMP%]{width:25%;display:table-cell;vertical-align:middle}.bh-loc-counts[_ngcontent-%COMP%]{margin:4px 0}.bh-loc-counts[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:inline-block}.bh-loc-counts[_ngcontent-%COMP%]   .bh-count-pattern[_ngcontent-%COMP%]{padding-right:50px;display:inline-block;vertical-align:middle}.bh-loc-counts[_ngcontent-%COMP%]   .bh-count-pattern[_ngcontent-%COMP%]   .count-name[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:24px;line-height:34px;letter-spacing:.5px;color:#121212}.bh-loc-counts[_ngcontent-%COMP%]   .bh-count-pattern[_ngcontent-%COMP%]   .count-label[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;line-height:22px;letter-spacing:.5px;color:#00bceb;opacity:.8}.bh-loc-counts[_ngcontent-%COMP%]   .bh-count-pattern.alert-count[_ngcontent-%COMP%]{cursor:pointer;vertical-align:middle}.bh-loc-counts[_ngcontent-%COMP%]   .bh-count-pattern.alert-count[_ngcontent-%COMP%]   .count-name[_ngcontent-%COMP%]{color:#f5a623}.bh-count-pattern[_ngcontent-%COMP%]{padding-right:50px;display:inline-block;vertical-align:middle}.bh-count-pattern[_ngcontent-%COMP%]   .count-name[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:24px;line-height:34px;letter-spacing:.5px;color:#121212}.bh-count-pattern[_ngcontent-%COMP%]   .count-label[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;line-height:22px;letter-spacing:.5px;color:#00bceb;opacity:.8}.bh-count-pattern.alert-count[_ngcontent-%COMP%]{cursor:pointer;vertical-align:middle}.bh-count-pattern.alert-count[_ngcontent-%COMP%]   .count-name[_ngcontent-%COMP%]{color:#f5a623}.count-loader-container[_ngcontent-%COMP%]{display:inline-block;width:320px;min-height:100px;vertical-align:middle}.placeholder-content[_ngcontent-%COMP%]{height:100px;overflow:hidden;background:#f6f7f8;position:relative;animation-duration:1.7s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-timing-function:linear;animation-name:placeholderAnimate;background:linear-gradient(to right,#eee 2%,#ddd 18%,#eee 33%);background-size:1000px}.placeholder-content_item[_ngcontent-%COMP%]{width:100%;height:20px;position:absolute;background:#fff;z-index:2}.placeholder-content_item[_ngcontent-%COMP%]:after, .placeholder-content_item[_ngcontent-%COMP%]:before{width:inherit;height:inherit;content:\"\";position:absolute}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(1){top:0;left:0}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(2){top:20px;left:0;width:0;height:90px}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(3){top:0;left:0;width:0;height:100%}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(4){top:0;width:15px;left:75px;height:102px}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(5){top:51px;left:80px;height:0}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(6){top:60px;left:90px;height:5px}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(7){top:20px;right:0;width:0;height:20px}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(8){top:0;right:0;width:10%;height:100%}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(9){top:85px;height:100px;left:0}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(10){top:149px;height:60px;left:0}.placeholder-content_item[_ngcontent-%COMP%]:nth-child(11){top:183px;left:0;height:100%}@keyframes placeholderAnimate{0%{background-position:-650px 0}to{background-position:650px 0}}.license-types-wrapper[_ngcontent-%COMP%]{padding:20px 30px;background-color:#f6f6f6}.license-types-wrapper[_ngcontent-%COMP%]   .license-tag[_ngcontent-%COMP%]{display:inline-block;padding:5px 10px;margin-bottom:10px;border-radius:50px}.license-types-wrapper[_ngcontent-%COMP%]   .see-tag[_ngcontent-%COMP%]{background-color:#009edc}.license-types-wrapper[_ngcontent-%COMP%]   .act-tag[_ngcontent-%COMP%]{background-color:#f8ab19}.license-types-wrapper[_ngcontent-%COMP%]   .extend-tag[_ngcontent-%COMP%], .license-types-wrapper[_ngcontent-%COMP%]   .ext-tag[_ngcontent-%COMP%]{background-color:#7cc242}.license-types-wrapper[_ngcontent-%COMP%]   .smartvenue-tag[_ngcontent-%COMP%], .license-types-wrapper[_ngcontent-%COMP%]   .smart_venues-tag[_ngcontent-%COMP%]{background-color:#436fb6}.license-types-wrapper[_ngcontent-%COMP%]   .smartops-tag[_ngcontent-%COMP%], .license-types-wrapper[_ngcontent-%COMP%]   .smart_operations-tag[_ngcontent-%COMP%]{background-color:#8750a1}.license-types-wrapper[_ngcontent-%COMP%]   .unlimited-tag[_ngcontent-%COMP%]{background-color:#ff7c33}.license-types-wrapper[_ngcontent-%COMP%]   .unlimited-subtitle[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:10px;line-height:16px;letter-spacing:.5px;color:#121212;padding-bottom:15px}.license-types-wrapper[_ngcontent-%COMP%]   .license-label[_ngcontent-%COMP%]{font-family:\"ciscoSansLight\";font-style:normal;font-weight:400;font-size:16px;text-align:center;color:#fff;cursor:pointer}.license-types-wrapper[_ngcontent-%COMP%]   .license-desc[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:12px;line-height:18px;letter-spacing:.5px;color:#565659}.license-types-wrapper[_ngcontent-%COMP%]   .license-subtitle[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:10px;line-height:16px;letter-spacing:.5px;color:#121212;margin-bottom:10px}.license-types-wrapper[_ngcontent-%COMP%]   .disabledLicense[_ngcontent-%COMP%]{opacity:.5;cursor:not-allowed;pointer-events:none}.confirmation-title[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:30px;line-height:41px;text-align:center;color:#39393b}.confirmation-desc[_ngcontent-%COMP%]{font-family:\"CiscoSansTT\";font-style:normal;font-weight:350;font-size:16px;line-height:24px;text-align:center;letter-spacing:.25px;color:#000;padding:10px 0 20px}.license-tag[_ngcontent-%COMP%]{display:inline-block;padding:5px 10px;margin-bottom:10px;border-radius:50px}.see-tag[_ngcontent-%COMP%]{background-color:#009edc}.act-tag[_ngcontent-%COMP%]{background-color:#f8ab19}.extend-tag[_ngcontent-%COMP%], .ext-tag[_ngcontent-%COMP%]{background-color:#7cc242}.smartvenue-tag[_ngcontent-%COMP%], .smart_venues-tag[_ngcontent-%COMP%]{background-color:#436fb6}.smartops-tag[_ngcontent-%COMP%], .smart_operations-tag[_ngcontent-%COMP%]{background-color:#8750a1}.unlimited-tag[_ngcontent-%COMP%]{background-color:#ff7c33}.unlimited-subtitle[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:10px;line-height:16px;letter-spacing:.5px;color:#121212;padding-bottom:15px}.license-label[_ngcontent-%COMP%]{font-family:\"ciscoSansLight\";font-style:normal;font-weight:400;font-size:16px;text-align:center;color:#fff;cursor:pointer}.license-desc[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:350;font-size:12px;line-height:18px;letter-spacing:.5px;color:#565659}.license-subtitle[_ngcontent-%COMP%]{font-family:\"CiscoSans\";font-style:normal;font-weight:400;font-size:10px;line-height:16px;letter-spacing:.5px;color:#121212;margin-bottom:10px}.disabledLicense[_ngcontent-%COMP%]{opacity:.5;cursor:not-allowed;pointer-events:none}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-child, .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:50%;margin:10px}.userTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .userTable[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:15%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SplitLicenseChangeComponent, [{
        type: Component,
        args: [{
                selector: 'app-split-license-change',
                templateUrl: './split-license-change.component.html',
                styleUrls: ['./split-license-change.component.scss']
            }]
    }], function () { return [{ type: DataService }, { type: LocationService }, { type: UserService }, { type: BusinessHierarchyService }, { type: i2.TranslateService }]; }, { locationId: [{
            type: Input
        }], locationName: [{
            type: Input
        }], licenseType: [{
            type: Input
        }], countPattern: [{
            type: Input
        }], closePopup: [{
            type: Output
        }], latestLicenseType: [{
            type: Output
        }], afterChangeLicense: [{
            type: Output
        }] }); })();

const _c0$9 = ["treev2"];
function StandardizedLocationHierachyV2Component_ng_template_3_tree_node_children_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tree-node-children", 7);
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    const node_r5 = ctx_r9.$implicit;
    const templates_r7 = ctx_r9.templates;
    i0.ɵɵproperty("node", node_r5)("templates", templates_r7);
} }
function StandardizedLocationHierachyV2Component_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "tree-node-wrapper", 5);
    i0.ɵɵtemplate(2, StandardizedLocationHierachyV2Component_ng_template_3_tree_node_children_2_Template, 1, 2, "tree-node-children", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r5 = ctx.$implicit;
    const index_r6 = ctx.index;
    const templates_r7 = ctx.templates;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2.getClass(node_r5));
    i0.ɵɵclassProp("tree-node", true)("tree-node-expanded", ctx_r2.getNodeExpanded(node_r5))("tree-node-collapsed", !node_r5.isExpanded && node_r5.hasChildren)("tree-node-leaf", node_r5.isLeaf)("tree-node-active", node_r5.isActive)("tree-node-focused", node_r5.isFocused);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("node", node_r5)("index", index_r6)("templates", templates_r7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r5.hasChildren);
} }
const _c1$4 = function (a0) { return { "custom-loc-node": a0 }; };
const _c2$3 = function (a0) { return { "custom-loc-name": a0 }; };
function StandardizedLocationHierachyV2Component_ng_template_5_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "a", 12);
    i0.ɵɵelement(2, "span", 13);
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyV2Component_ng_template_5_div_0_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r22); const node_r10 = i0.ɵɵnextContext().$implicit; const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.selectLocationClick(node_r10.data); });
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 15);
    i0.ɵɵlistener("mouseover", function StandardizedLocationHierachyV2Component_ng_template_5_div_0_Template_span_mouseover_5_listener() { i0.ɵɵrestoreView(_r22); const ctx_r24 = i0.ɵɵnextContext(); const node_r10 = ctx_r24.$implicit; const index_r11 = ctx_r24.index; const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.onMouseOverNode(node_r10.data, index_r11); })("mouseout", function StandardizedLocationHierachyV2Component_ng_template_5_div_0_Template_span_mouseout_5_listener() { i0.ɵɵrestoreView(_r22); const ctx_r26 = i0.ɵɵnextContext(); const node_r10 = ctx_r26.$implicit; const index_r11 = ctx_r26.index; const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.onMouseOutNode(node_r10.data, index_r11); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("tree-node", true);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$4, ctx_r12.isCheckBoxNeed));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c2$3, ctx_r12.isCheckBoxNeed));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 5, node_r10.data.name), i0.ɵɵsanitizeHtml);
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "a", 12);
    i0.ɵɵelement(2, "span", 13);
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyV2Component_ng_template_5_div_1_div_1_Template_span_click_3_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(3); return ctx_r30.showPopupMessage($event); });
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 15);
    i0.ɵɵlistener("mouseover", function StandardizedLocationHierachyV2Component_ng_template_5_div_1_div_1_Template_span_mouseover_5_listener() { i0.ɵɵrestoreView(_r31); const ctx_r33 = i0.ɵɵnextContext(2); const node_r10 = ctx_r33.$implicit; const index_r11 = ctx_r33.index; const ctx_r32 = i0.ɵɵnextContext(); return ctx_r32.onMouseOverNode(node_r10.data, index_r11); })("mouseout", function StandardizedLocationHierachyV2Component_ng_template_5_div_1_div_1_Template_span_mouseout_5_listener() { i0.ɵɵrestoreView(_r31); const ctx_r35 = i0.ɵɵnextContext(2); const node_r10 = ctx_r35.$implicit; const index_r11 = ctx_r35.index; const ctx_r34 = i0.ɵɵnextContext(); return ctx_r34.onMouseOutNode(node_r10.data, index_r11); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r28 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c2$3, ctx_r28.isCheckBoxNeed));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 2, node_r10.data.name), i0.ɵɵsanitizeHtml);
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "a", 12);
    i0.ɵɵelement(2, "span", 13);
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyV2Component_ng_template_5_div_1_div_2_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r39); const node_r10 = i0.ɵɵnextContext(2).$implicit; const ctx_r37 = i0.ɵɵnextContext(); return ctx_r37.selectLocationClick(node_r10.data); });
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 15);
    i0.ɵɵlistener("mouseover", function StandardizedLocationHierachyV2Component_ng_template_5_div_1_div_2_Template_span_mouseover_5_listener() { i0.ɵɵrestoreView(_r39); const ctx_r41 = i0.ɵɵnextContext(2); const node_r10 = ctx_r41.$implicit; const index_r11 = ctx_r41.index; const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.onMouseOverNode(node_r10.data, index_r11); })("mouseout", function StandardizedLocationHierachyV2Component_ng_template_5_div_1_div_2_Template_span_mouseout_5_listener() { i0.ɵɵrestoreView(_r39); const ctx_r43 = i0.ɵɵnextContext(2); const node_r10 = ctx_r43.$implicit; const index_r11 = ctx_r43.index; const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.onMouseOutNode(node_r10.data, index_r11); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r29 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c2$3, ctx_r29.isCheckBoxNeed));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 2, node_r10.data.name), i0.ɵɵsanitizeHtml);
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, StandardizedLocationHierachyV2Component_ng_template_5_div_1_div_1_Template, 6, 6, "div", 16);
    i0.ɵɵtemplate(2, StandardizedLocationHierachyV2Component_ng_template_5_div_1_div_2_Template, 6, 6, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("tree-node", true);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1$4, ctx_r13.isCheckBoxNeed));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r10.data.type !== "root" && node_r10.data.type !== "network");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r10.data.type === "root" || node_r10.data.type === "network");
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "a", 12);
    i0.ɵɵelement(2, "span", 13);
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyV2Component_ng_template_5_div_2_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r48); const node_r10 = i0.ɵɵnextContext().$implicit; const ctx_r46 = i0.ɵɵnextContext(); return ctx_r46.selectLocationClick(node_r10.data); });
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 15);
    i0.ɵɵlistener("mouseover", function StandardizedLocationHierachyV2Component_ng_template_5_div_2_Template_span_mouseover_5_listener() { i0.ɵɵrestoreView(_r48); const ctx_r50 = i0.ɵɵnextContext(); const node_r10 = ctx_r50.$implicit; const index_r11 = ctx_r50.index; const ctx_r49 = i0.ɵɵnextContext(); return ctx_r49.onMouseOverNode(node_r10.data, index_r11); })("mouseout", function StandardizedLocationHierachyV2Component_ng_template_5_div_2_Template_span_mouseout_5_listener() { i0.ɵɵrestoreView(_r48); const ctx_r52 = i0.ɵɵnextContext(); const node_r10 = ctx_r52.$implicit; const index_r11 = ctx_r52.index; const ctx_r51 = i0.ɵɵnextContext(); return ctx_r51.onMouseOutNode(node_r10.data, index_r11); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("tree-node", true);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$4, ctx_r14.isCheckBoxNeed));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c2$3, ctx_r14.isCheckBoxNeed));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 5, node_r10.data.name), i0.ɵɵsanitizeHtml);
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "a", 12);
    i0.ɵɵelement(2, "span", 13);
    i0.ɵɵelement(3, "span", 17);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 15);
    i0.ɵɵlistener("mouseover", function StandardizedLocationHierachyV2Component_ng_template_5_div_3_Template_span_mouseover_5_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(); const node_r10 = ctx_r55.$implicit; const index_r11 = ctx_r55.index; const ctx_r54 = i0.ɵɵnextContext(); return ctx_r54.onMouseOverNode(node_r10.data, index_r11); })("mouseout", function StandardizedLocationHierachyV2Component_ng_template_5_div_3_Template_span_mouseout_5_listener() { i0.ɵɵrestoreView(_r56); const ctx_r58 = i0.ɵɵnextContext(); const node_r10 = ctx_r58.$implicit; const index_r11 = ctx_r58.index; const ctx_r57 = i0.ɵɵnextContext(); return ctx_r57.onMouseOutNode(node_r10.data, index_r11); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("tree-node", true);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$4, ctx_r15.isCheckBoxNeed));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c2$3, ctx_r15.isCheckBoxNeed));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 5, node_r10.data.name), i0.ɵɵsanitizeHtml);
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "a", 12);
    i0.ɵɵelement(2, "span", 13);
    i0.ɵɵelement(3, "span", 17);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 15);
    i0.ɵɵlistener("mouseover", function StandardizedLocationHierachyV2Component_ng_template_5_div_4_Template_span_mouseover_5_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(); const node_r10 = ctx_r61.$implicit; const index_r11 = ctx_r61.index; const ctx_r60 = i0.ɵɵnextContext(); return ctx_r60.onMouseOverNode(node_r10.data, index_r11); })("mouseout", function StandardizedLocationHierachyV2Component_ng_template_5_div_4_Template_span_mouseout_5_listener() { i0.ɵɵrestoreView(_r62); const ctx_r64 = i0.ɵɵnextContext(); const node_r10 = ctx_r64.$implicit; const index_r11 = ctx_r64.index; const ctx_r63 = i0.ɵɵnextContext(); return ctx_r63.onMouseOutNode(node_r10.data, index_r11); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("tree-node", true);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$4, ctx_r16.isCheckBoxNeed));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c2$3, ctx_r16.isCheckBoxNeed));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 5, node_r10.data.name), i0.ɵɵsanitizeHtml);
} }
const _c3$3 = function (a0) { return { "disabledButton": a0 }; };
function StandardizedLocationHierachyV2Component_ng_template_5_div_5_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵelementStart(1, "input", 23);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyV2Component_ng_template_5_div_5_div_1_span_1_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r70); const ctx_r69 = i0.ɵɵnextContext(4); return ctx_r69.showPopupMessage($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r68 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$3, ctx_r68.isFilteredLocation && !ctx_r68.isLocationContains(node_r10.data)));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r68.isLocationChecked(node_r10))("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r68.isChildNodeSelectedClass(node_r10));
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r10.data.id, "");
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, StandardizedLocationHierachyV2Component_ng_template_5_div_5_div_1_span_1_Template, 3, 9, "span", 19);
    i0.ɵɵelementStart(2, "input", 20);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyV2Component_ng_template_5_div_5_div_1_Template_input_click_2_listener($event) { i0.ɵɵrestoreView(_r73); const ctx_r72 = i0.ɵɵnextContext(3); return ctx_r72.showPopupMessage($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r66 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r66.isCheckBoxNeed);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r66.selectedLocation && ctx_r66.selectedLocation.data && node_r10.id === ctx_r66.selectedLocation.data.id)("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r10.data.id, "");
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_5_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r78 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵelementStart(1, "input", 23);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyV2Component_ng_template_5_div_5_div_2_span_1_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r78); const node_r10 = i0.ɵɵnextContext(3).$implicit; const ctx_r76 = i0.ɵɵnextContext(); return ctx_r76.selectMultipleNode($event, node_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r75 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$3, ctx_r75.isFilteredLocation && !ctx_r75.isLocationContains(node_r10.data)));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r75.isLocationChecked(node_r10))("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r75.isChildNodeSelectedClass(node_r10));
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r10.data.id, "");
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r82 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, StandardizedLocationHierachyV2Component_ng_template_5_div_5_div_2_span_1_Template, 3, 9, "span", 19);
    i0.ɵɵelementStart(2, "input", 20);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyV2Component_ng_template_5_div_5_div_2_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r82); const node_r10 = i0.ɵɵnextContext(2).$implicit; const ctx_r80 = i0.ɵɵnextContext(); return ctx_r80.selectNode(node_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r67 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r67.isCheckBoxNeed);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r67.selectedLocation && ctx_r67.selectedLocation.data && node_r10.id === ctx_r67.selectedLocation.data.id)("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r10.data.id, "");
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, StandardizedLocationHierachyV2Component_ng_template_5_div_5_div_1_Template, 4, 5, "div", 16);
    i0.ɵɵtemplate(2, StandardizedLocationHierachyV2Component_ng_template_5_div_5_div_2_Template, 4, 5, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r10.data.type !== "root" && node_r10.data.type !== "network");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r10.data.type === "root" || node_r10.data.type === "network");
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_6_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r88 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵelementStart(1, "input", 23);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyV2Component_ng_template_5_div_6_span_1_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r88); const node_r10 = i0.ɵɵnextContext(2).$implicit; const ctx_r86 = i0.ɵɵnextContext(); return ctx_r86.selectMultipleNode($event, node_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r85 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$3, ctx_r85.isFilteredLocation && !ctx_r85.isLocationContains(node_r10.data)));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r85.isLocationChecked(node_r10))("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r85.isChildNodeSelectedClass(node_r10));
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r10.data.id, "");
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r92 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, StandardizedLocationHierachyV2Component_ng_template_5_div_6_span_1_Template, 3, 9, "span", 19);
    i0.ɵɵelementStart(2, "input", 20);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyV2Component_ng_template_5_div_6_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r92); const node_r10 = i0.ɵɵnextContext().$implicit; const ctx_r90 = i0.ɵɵnextContext(); return ctx_r90.selectNode(node_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.isCheckBoxNeed);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r18.selectedLocation && ctx_r18.selectedLocation.data && node_r10.id === ctx_r18.selectedLocation.data.id)("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r10.data.id, "");
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_7_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r97 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵelementStart(1, "input", 23);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyV2Component_ng_template_5_div_7_span_1_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r97); const node_r10 = i0.ɵɵnextContext(2).$implicit; const ctx_r95 = i0.ɵɵnextContext(); return ctx_r95.selectMultipleNode($event, node_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r94 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$3, ctx_r94.isFilteredLocation && !ctx_r94.isLocationContains(node_r10.data)));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r94.isLocationChecked(node_r10))("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r94.isChildNodeSelectedClass(node_r10));
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r10.data.id, "");
} }
function StandardizedLocationHierachyV2Component_ng_template_5_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r101 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, StandardizedLocationHierachyV2Component_ng_template_5_div_7_span_1_Template, 3, 9, "span", 19);
    i0.ɵɵelementStart(2, "input", 20);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyV2Component_ng_template_5_div_7_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r101); const node_r10 = i0.ɵɵnextContext().$implicit; const ctx_r99 = i0.ɵɵnextContext(); return ctx_r99.selectNode(node_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.isCheckBoxNeed);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r19.selectedLocation && ctx_r19.selectedLocation.data && node_r10.id === ctx_r19.selectedLocation.data.id)("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r10.data.id, "");
} }
function StandardizedLocationHierachyV2Component_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, StandardizedLocationHierachyV2Component_ng_template_5_div_0_Template, 6, 11, "div", 8);
    i0.ɵɵtemplate(1, StandardizedLocationHierachyV2Component_ng_template_5_div_1_Template, 3, 7, "div", 8);
    i0.ɵɵtemplate(2, StandardizedLocationHierachyV2Component_ng_template_5_div_2_Template, 6, 11, "div", 8);
    i0.ɵɵtemplate(3, StandardizedLocationHierachyV2Component_ng_template_5_div_3_Template, 6, 11, "div", 8);
    i0.ɵɵtemplate(4, StandardizedLocationHierachyV2Component_ng_template_5_div_4_Template, 6, 11, "div", 8);
    i0.ɵɵtemplate(5, StandardizedLocationHierachyV2Component_ng_template_5_div_5_Template, 3, 2, "div", 9);
    i0.ɵɵtemplate(6, StandardizedLocationHierachyV2Component_ng_template_5_div_6_Template, 4, 5, "div", 9);
    i0.ɵɵtemplate(7, StandardizedLocationHierachyV2Component_ng_template_5_div_7_Template, 4, 5, "div", 10);
} if (rf & 2) {
    const node_r10 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", (ctx_r4.licenseType === "Advanced Subscription" || ctx_r4.licenseType === "Unlimited Subscription") && (!ctx_r4.reportType || ctx_r4.reportType !== "path") && (node_r10.data.access === "Full" || node_r10.data.reportAccess));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.licenseType !== "Advanced Subscription" && ctx_r4.licenseType !== "Unlimited Subscription" && (!ctx_r4.reportType || ctx_r4.reportType !== "path") && (node_r10.data.access === "Full" || node_r10.data.reportAccess));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.reportType === "path" && (node_r10.data.type === "floor" || node_r10.data.type === "zone" || node_r10.data.type === "cmxzone" || node_r10.data.type === "polygon_zone") && (node_r10.data.access === "Full" || node_r10.data.reportAccess));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r10.data.access !== "Full" && !node_r10.data.reportAccess);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.reportType === "path" && (node_r10.data.type !== "floor" && node_r10.data.type !== "zone" && node_r10.data.type !== "cmxzone" && node_r10.data.type !== "polygon_zone") && (node_r10.data.access === "Full" || node_r10.data.reportAccess));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (!ctx_r4.reportType || ctx_r4.reportType !== "path") && (ctx_r4.licenseType !== "Advanced Subscription" && ctx_r4.licenseType !== "Unlimited Subscription") && (node_r10.data.access === "Full" || node_r10.data.reportAccess));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (!ctx_r4.reportType || ctx_r4.reportType !== "path") && ((ctx_r4.licenseType === "Advanced Subscription" || ctx_r4.licenseType === "Unlimited Subscription") && node_r10.data.access === "Full" || node_r10.data.reportAccess));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.reportType === "path" && (node_r10.data.type === "floor" || node_r10.data.type === "zone" || node_r10.data.type === "cmxzone" || node_r10.data.type === "polygon_zone") && (node_r10.data.access === "Full" || node_r10.data.reportAccess));
} }
class StandardizedLocationHierachyV2Component {
    constructor(dataService) {
        this.dataService = dataService;
        this.treeComponent = null;
        this.locations = [];
        this.locationOrginal = [];
        this.searchTimestamp = 0;
        this.locationSearchString = "";
        this.isTreeInitialised = false;
        this.filteredIds = [];
        this.isNodeSelected = false;
        this.searchedLocation = [];
        this.previousSearchedLocations = [];
        this.isOnlyMeraki = false;
        this.errorText = false;
        this.showTooltip = [];
        this.resultsFound = 0;
        this.selectLocation = new EventEmitter();
        this.multipleSelectLocation = new EventEmitter();
        this.showErrorText = new EventEmitter();
        this.searchResults = new EventEmitter();
        this.atLocationRestriction = new EventEmitter();
        this.isCheckBoxNeed = false;
        this.isRootNeed = false;
        this.isPopup = false;
        this.isFilteredLocation = false;
        this.options = {
            displayField: "name",
            isExpandedField: "expanded",
            idField: "id",
            actionMapping: {
                mouse: {
                //dblClick: (tree, node, $event) => {
                //  if (node.hasChildren) TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event);
                //},
                //click:(tree, node, $event) => {
                //this.logger.debug('mouse click', tree, node, $event);
                //}
                }
            },
            allowDrag: (node) => {
                return false;
            },
            allowDrop: (node) => {
                return false;
            },
            useVirtualScroll: false,
            animateExpand: false,
            animateSpeed: 10,
            animateAcceleration: 1.2,
            nodeHeight: 32,
            dropSlotHeight: 3
        };
        this.onTreeLoad = () => {
            setTimeout(() => {
                if (this.treeComponent) {
                    this.treeComponent.treeModel.update();
                    this.treeComponent.treeModel.roots[0].expand();
                }
            }, 100);
        };
        this.getNodeExpanded = (node) => {
            return node.isExpanded && node.hasChildren;
        };
        this.selectLocationCheckBox = ($event, locationNode) => {
            console.log("selected location is :: " + JSON.stringify(locationNode));
            let index = null;
            if (!this.selectedLocation)
                this.selectedLocation = [];
            this.selectedLocation.filter(function (n, i) {
                if (n.data.id === locationNode.data.id) {
                    index = i;
                    return i;
                }
            });
            if (index !== null) {
                this.selectedLocation.splice(index, 1);
                this.isNodeSelected = false;
                $event.target.checked = false;
            }
            else {
                this.selectedLocation.push(locationNode);
                $event.target.checked = true;
                this.isNodeSelected = true;
            }
        };
        this.onEvent = ($event) => {
            //   console.log('onEvent from tree::', $event);
            switch ($event.eventName) {
                case "initialized":
                    this.isTreeInitialised = true;
                    //this.treeComponent.treeModel.update();
                    if (this.treeComponent)
                        this.treeComponent.treeModel.roots.forEach((root) => {
                            if (root.isCollapsed)
                                root.expand();
                        });
                    break;
                case "changeFilter":
                    setTimeout(() => {
                        //    this.dataService.display(false);
                    }, 500);
                    break;
            }
        };
        this.getClass = (node) => {
            const selected = this.isSelectedLocation(node);
            let classString = "";
            if (node && (node.data.parent == "-1" || (node.parent && !node.isRoot)))
                classString = node.getClass();
            classString += " type-" + node.data.type;
            // if (selected)
            //   classString += ' tree-node isSelectedNode';
            if (this.isOnlyMeraki && node.data.type != "root") {
                if (node.data.type == "group" &&
                    (node.data.parentNode.type == "root" ||
                        node.data.parentNode.type == "meraki")) {
                    return classString;
                }
                else if (node.data.networkDetails.wirelessProvider != "MERAKI") {
                    return "hideNode";
                }
            }
            return classString;
        };
        //// Checkbox starts
        this.isSelectedLocation = (node) => {
            let index = null;
            //console.log(" isSelectedLocation :: node :: ", node.data.id)
            console.log(" isSelectedLocation :: node  :: selected :: ", this.selectedLocation.id);
            if (this.selectedLocation && this.selectedLocation.length > 0)
                this.selectedLocation.filter(function (n, i) {
                    if (n && n.id === node.data.id) {
                        index = i;
                        return i;
                    }
                });
            if (index !== null) {
                this.isNodeSelected = true;
                return true;
            }
            else {
                this.isNodeSelected = false;
                return false;
            }
        };
        this.isLocationChecked = (node) => {
            let result = false;
            if (this.selectedLocation && this.selectedLocation.length > 0) {
                this.selectedLocation.filter(function (n, i) {
                    if (n && n.id === node.data.id) {
                        result = true;
                    }
                });
            }
            return result;
        };
        this.isChildNodeSelectedClass = (node) => {
            let classString = "checkboxLabel";
            let parentPath;
            const parentPathArray = [];
            if (this.selectedLocation) {
                this.selectedLocation.filter(function (n, i) {
                    if (n.path && n.path.length > 0) {
                        parentPath = n.path.slice(0, n.path.length - 1);
                        parentPath.forEach((element) => {
                            parentPathArray.push(element);
                        });
                    }
                });
            }
            // remove duplicates
            const uniqueParentPaths = this.removeDuplicates(parentPathArray);
            // check the unique parent paths with node
            if (uniqueParentPaths && uniqueParentPaths.indexOf(node.data.id) > -1) {
                classString += " childSelected";
                return classString;
            }
            else {
                return classString;
            }
        };
        this.removeSelectedChildren = (selectedNode) => {
            if (selectedNode && selectedNode.data.path.length > 0) {
                var index = [];
                this.selectedLocation.filter(function (n, i) {
                    if (n.path && n.path.length > 0) {
                        var selectedLocParentPath = n.path.slice(0, n.path.length - 1);
                        if (selectedLocParentPath.indexOf(selectedNode.data.id) > -1) {
                            index.push(i);
                            return i;
                        }
                    }
                });
                if (index !== null) {
                    for (var j = index.length - 1; j >= 0; j--) {
                        this.selectedLocation.splice(index[j], 1);
                    }
                }
            }
        };
        this.removeSelectedParent = (selectedNode) => {
            if (selectedNode && selectedNode.data.path.length > 0) {
                var index = [];
                this.selectedLocation.filter(function (n, i) {
                    if (selectedNode.data && selectedNode.data.path) {
                        var parentPath = selectedNode.data.path.slice(0, selectedNode.data.path.length - 1);
                        if (parentPath.indexOf(n.id) > -1) {
                            index.push(i);
                            return i;
                        }
                    }
                });
                if (index !== null) {
                    for (var j = index.length - 1; j >= 0; j--) {
                        this.selectedLocation.splice(index[j], 1);
                    }
                }
            }
        };
        // remove duplicates from array
        this.removeDuplicates = (arr) => {
            const unique_array = [];
            for (let i = 0; i < arr.length; i++) {
                if (unique_array.indexOf(arr[i]) === -1) {
                    unique_array.push(arr[i]);
                }
            }
            return unique_array;
        };
        this.initLocationNodes = () => {
            // To be implemented in child component
            if (this.currentFilterLocations &&
                Object.keys(this.currentFilterLocations).length > 0) {
                this.filterLocationIds(this.currentFilterLocations);
            }
            else {
                this.locations = this.locationOrginal;
            }
            this.prevFilterLocations = this.currentFilterLocations;
        };
        this.subscribeSearchText = (val) => {
            console.log("search text", val);
            this.searchText = val;
            if (this.searchText &&
                this.searchText.length >= 3 &&
                this.isTreeInitialised &&
                this.prevSearchString !== this.searchText) {
                //  this.dataService.display(true);
                if (this.prevSearchString !== this.searchText) {
                    this.searchTimestamp = new Date().getTime();
                    this.prevSearchString = this.searchText;
                }
                if (this.setTimeoutObj)
                    clearTimeout(this.setTimeoutObj);
                this.setTimeoutObj = setTimeout(() => {
                    // console.log('search', this.searchText);
                    this.searchTree(this.searchTimestamp);
                }, 1200);
            }
            else {
                this.resultsFound = 0;
                this.searchResults.emit(this.resultsFound);
                if (this.searchText !== null || this.searchText === "") {
                    this.locations = this.locationOrginal;
                    this.initLocationNodes();
                    if (this.treeComponent) {
                        this.treeComponent.treeModel.setData({
                            nodes: this.locationOrginal,
                            options: this.options,
                            events: null
                        });
                        this.treeComponent.treeModel.roots.forEach((root) => {
                            root.expand();
                        });
                    }
                    this.prevSearchString = "";
                }
                // if(this.dataService.getCurrentNav().indexOf("business") > -1 && this.enableCustomSearch && this.dataService.getCurrentNav().indexOf("detail") > -1 )
                //     this.dataService.display(false);
            }
        };
        this.searchTree = (searchTimestamp) => {
            //console.log('search tree', this.searchText);
            const makeServerCall = true;
            const tokensTemp = this.prevSearchString.trim().split(" ");
            const tokens = [];
            this.resultsFound = 0;
            this.searchResults.emit(this.resultsFound);
            for (let tokCount = 0, max = tokensTemp.length; tokCount < max; tokCount++) {
                if (!this.validToken(tokensTemp[tokCount]))
                    continue;
                tokens.push(tokensTemp[tokCount]);
            }
            if (tokens && tokens.length > 0) {
                const regexTokenStr = "root|" + tokens.join("|");
                const regexStr = "(" + regexTokenStr + ")";
                const regexp = new RegExp(regexStr, "gi");
                // console.log('tokens', tokens, tokens.join('|'), "regexp", regexp, "this.locationSearchString", this.locationSearchString);
                this.findNodes(tokens, regexp, searchTimestamp, null, true);
                // this.dataService.display(false);
            }
            else {
                //this.dataService.display(false);
            }
        };
        this.validToken = (token) => {
            if (token === "" || token === ".") {
                return false;
            }
            return true;
        };
        this.findNodes = (tokens, regexp, searchTimestamp, apMatches, firstCall) => {
            let filteredLocation = null;
            //console.log('searchRegex', regexp, 'firstCall', firstCall);
            if (this.locationOrginal && this.locationOrginal.length > 0) {
                filteredLocation = this.matchToken(this.locationOrginal[0], tokens, apMatches, false, regexp);
                console.log("location tree :: matchToken ", filteredLocation);
            }
            if (filteredLocation.location && this.treeComponent) {
                // this.location = [filteredLocation.location];
                this.treeComponent.treeModel.setData({
                    nodes: [filteredLocation.location],
                    options: this.options,
                    events: null
                });
                if (filteredLocation.foundChild) {
                }
            }
            else {
                // this.location = this.locationOrginal;
                this.treeComponent.treeModel.setData({
                    nodes: this.locationOrginal,
                    options: this.options,
                    events: null
                });
            }
            let index = 0;
            setTimeout(() => {
                if (this.treeComponent)
                    this.treeComponent.treeModel.doForAll((node) => {
                        this.ensureNodeVisible(node, ++index);
                        // return true;
                    });
            }, 100);
        };
        this.ensureNodeVisible = (node, index) => {
            const delay = Math.round(index / 10) * 10;
            setTimeout(() => {
                if (node && node.data && node.data.expanded)
                    node.ensureVisible();
            }, delay);
        };
        this.matchToken = (location, searchTokens, apMatches, isParent, searchRegex) => {
            //TODO: implement search
            let found = false;
            // console.log(location.name, location.path, searchRegex.test(location.name.toLowerCase()))
            if (searchRegex.test(location["name"].toLowerCase())) {
                found = true;
                // console.log('Location matched:', location.name, location.path);
            }
            const newLoc = Object.assign({}, location);
            newLoc.children = [];
            newLoc.location = [];
            // let newLoc = location.clone();
            newLoc.expanded = false;
            if (location["type"] === "root" || found)
                newLoc.expanded = true;
            if (found) {
                this.resultsFound += 1;
                this.searchResults.emit(this.resultsFound);
                newLoc.name = newLoc.name
                    .replace(/&amp;/g, "&")
                    .replace(/&lt;/g, "<")
                    .replace(/&gt;/g, ">");
                newLoc.name = newLoc.name.replace(searchRegex, '<span class="highlighted-v2">$&</span>');
            }
            let foundChild = false;
            if (location["children"])
                for (let index = 0, max = location["children"].length; index < max; index++) {
                    const childLoc = location["children"][index];
                    const resChild = this.matchToken(childLoc, searchTokens, apMatches, isParent || found, searchRegex);
                    console.log("location tree :: matchToken ", resChild);
                    if (resChild["foundChild"] || resChild["found"]) {
                        foundChild = true;
                        // console.log('Location matched:', resChild['location'].name, resChild['location'].path);
                    }
                    if (isParent ||
                        found ||
                        resChild["foundChild"] ||
                        resChild["found"])
                        newLoc.children.push(resChild["location"]);
                }
            //
            return { location: newLoc, foundChild, found };
        };
        this.filterLocationIds = (filterLocations) => {
            if (filterLocations && Object.keys(filterLocations).length > 0) {
                if (this.locationOrginal) {
                    // let filteredLocations = [];
                    const filteredLocations = new Map();
                    let root = null;
                    root = this.filterLocationTree(this.locationOrginal, filteredLocations, filterLocations, root);
                    this.locations = [root];
                    // console.log("this.location after filter", this.location);
                }
                else {
                    console.log("Locations not available", location);
                }
            }
        };
        this.filterLocationTree = (locations, filteredLocations, filterLocations, root) => {
            locations.forEach((location) => {
                if (!filterLocations[location.mongoLocationId.toString()])
                    return;
                const newLoc = Object.assign({}, location);
                newLoc.children = [];
                filteredLocations.set(newLoc.id, newLoc);
                if (newLoc.parentId && newLoc.parentId !== "-1") {
                    const parent = filteredLocations.get(newLoc.parentId);
                    if (parent) {
                        if (!parent.children)
                            parent.children = [];
                        parent.children.push(newLoc);
                    }
                    else {
                        console.log("Parent " +
                            String(newLoc.parent) +
                            " not found for location " +
                            String(newLoc.id), newLoc);
                    }
                }
                else {
                    root = newLoc;
                }
                if (location.children)
                    root = this.filterLocationTree(location.children, filteredLocations, filterLocations, root);
            });
            return root;
        };
        this.isLocationContains = (locationObj) => {
            if (this.currentFilterLocations &&
                this.currentFilterLocations.length > 0 &&
                this.currentFilterLocations.includes(locationObj.id)) {
                return true;
            }
            else {
                return false;
            }
        };
        this.onMouseOverNode = (nodeData, index) => {
            if (this.dataService.getCurrentNav().indexOf("right-now") !== -1 &&
                (nodeData.type === "zone" ||
                    nodeData.type === "cmxzone" ||
                    nodeData.type === "polygon_zone")) {
                $("#loc_tooltip_" + nodeData.id).addClass("zone-alert-show");
            }
            else {
                if (!this.isPopup) {
                    if (!nodeData.showMenu) {
                        nodeData.showMenu = true;
                        setTimeout(() => {
                            nodeData.showMenu = false;
                        }, 2000);
                    }
                }
                else {
                    this.locName = nodeData.name;
                    this.totalLocations = nodeData.total;
                    this.permittedLocations = nodeData.permitted;
                    if (this.showTooltip) {
                        if (nodeData.total != nodeData.permitted) {
                            this.showTooltip[index] = true;
                        }
                        else {
                            this.showTooltip[index] = false;
                        }
                    }
                    // if (nodeData.licenseType && this.disableLicenseType == nodeData.licenseType) {
                    // 	this.showTooltip[index] = true;
                    // }
                }
            }
        };
        this.onMouseOutNode = (nodeData, index) => {
            setTimeout(() => {
                $("#loc_tooltip_" + nodeData.id).removeClass("zone-alert-show");
            }, 500);
            if (!this.isPopup) {
                nodeData.showMenu = false;
            }
            else {
                if (this.showTooltip) {
                    this.showTooltip[index] = false;
                }
            }
        };
        this.selectNode = (node) => {
            const currentNav = this.dataService.getCurrentNav();
            if ((currentNav &&
                currentNav.indexOf("right-now") !== -1 &&
                (node.data.type === "zone" ||
                    node.data.type === "cmxzone" ||
                    node.data.type === "polygon_zone")) ||
                (currentNav &&
                    currentNav.indexOf("camera-metrics") !== -1 &&
                    node.data.camerasCount === 0))
                return;
            this.doSelection(node);
            this.selectLocation.emit(node.data);
        };
        this.doSelection = (node) => {
            console.log("Select node:: manage location:", this.selectedLocation, node);
            if (this.selectedLocation !== undefined &&
                this.selectedLocation.length > 0 &&
                this.selectedLocation[0].data !== undefined &&
                this.selectedLocation[0].data.id === node.data.id) {
                this.selectedLocation = [];
                node.setIsExpanded(true);
            }
            else {
                if (node && node[0] && node[0].id == undefined) {
                    this.selectedLocation = node[0];
                    node.setIsExpanded(true);
                }
                else {
                    this.selectedLocation = [node];
                    node.setIsExpanded(true);
                }
            }
        };
        this.showPopupMessage = ($event) => {
            if ($event.target.checked)
                $event.target.checked = false;
            this.atLocationRestriction.emit(true);
        };
    }
    set locationTree(value) {
        if (!value || value.length === 0) {
            return;
        }
        this.locations = value;
        this.locationOrginal = value;
        this.clearPreviousSearch();
        setTimeout(() => {
            if (this.treeComponent) {
                this.treeComponent.treeModel.update();
                this.treeComponent.treeModel.roots[0].focus();
                this.treeComponent.treeModel.roots[0].expand();
            }
        }, 100);
    }
    set setSelectedLocation(selectedLocations) {
        //console.log('set selected location', selectedLocations);
        this.selectedLocation = selectedLocations;
        if (!selectedLocations || selectedLocations.length === 0)
            for (const id of this.selectedLocation) {
                try {
                    this.selectedLocation[id].setIsExpanded(true);
                }
                catch (e) {
                    console.log("location id not available", String(this.selectedLocation[id]));
                }
            }
        else {
            setTimeout(() => {
                // for (let i = 0; i < this.selectedLocation.length; i++) {
                try {
                    const nodeF = this.treeComponent.treeModel.getNodeById(this.selectedLocation[0].id);
                    this.selectedLocation = nodeF;
                    this.selectedLocation.setIsExpanded(true);
                    this.selectedLocation.focus();
                    this.getParentLocations(this.selectedLocation);
                }
                catch (e) {
                    console.log("location id not available", this.selectedLocation);
                }
                /* if (!this.selectedLocation[i]) {
                        this.selectedLocation.splice(i, 1);
                    }*/
                //	}
            }, 500);
        }
    }
    set searchLocation(customSearchText) {
        // this.enableCustomSearch = true;
        if (customSearchText) {
            if (customSearchText && customSearchText !== "") {
                if (customSearchText.trim().length >= 3) {
                    this.errorText = false;
                    this.showErrorText.emit(this.errorText);
                    // this.searchString = customSearchText.trim();
                }
                else {
                    this.errorText = true;
                    this.showErrorText.emit(this.errorText);
                    // this.resetList();
                }
            }
            else {
                this.errorText = false;
                this.showErrorText.emit(this.errorText);
                // this.searchString = null;
                // this.resetList();
            }
            this.subscribeSearchText(customSearchText);
            // this.prevSearchString = customSearchText;
            // this.searchTree(new Date().getTime());
        }
        else {
            this.errorText = false;
            this.showErrorText.emit(this.errorText);
        }
    }
    set filterLocations(filterLocations) {
        this.currentFilterLocations = filterLocations;
        if (this.isTreeInitialised)
            this.initLocationNodes();
    }
    ngOnInit() { }
    ngAfterInit() {
        if (this.treeComponent) {
            const treeModel = this.treeComponent.treeModel;
            const firstNode = treeModel.getFirstRoot();
            firstNode.setActiveAndVisible();
        }
    }
    clearPreviousSearch() {
        const clearLocations = [];
        if (this.previousSearchedLocations) {
            for (let i = 0; i < this.previousSearchedLocations.length; i++) {
                try {
                    const nodeF = this.treeComponent.treeModel.getNodeById(this.previousSearchedLocations[i].data.id);
                    clearLocations[i] = nodeF;
                }
                catch (e) {
                    console.log("location id not available", this.selectedLocation[i]);
                }
            }
            for (let i = 0; i < clearLocations.length; i++) {
                try {
                    clearLocations[i].setIsExpanded(false);
                }
                catch (e) {
                    console.log("location id not available");
                }
            }
        }
    }
    getParentLocations(node) {
        if (node.data.parent !== "-1") {
            const nodeF = this.treeComponent.treeModel.getNodeById(node.data.parent);
            nodeF.setIsExpanded(true);
            this.searchedLocation.push(nodeF);
            this.getParentLocations(nodeF);
        }
        return;
    }
    selectLocationClick(nodeData) {
        this.selectLocation.emit(nodeData);
    }
    getDeviceCount(nodeData) {
        return this.countMap[nodeData.mongoLocationId]
            ? "(" + String(this.countMap[nodeData.mongoLocationId]) + ")"
            : "";
    }
    getSensorCount(nodeData) {
        return this.countMap[nodeData.mongoLocationId]
            ? String(this.countMap[nodeData.mongoLocationId]) + " Sensors"
            : "";
    }
    selectMultipleNode($event, node) {
        let index = null;
        if (!this.selectedLocation)
            this.selectedLocation = [];
        this.selectedLocation.filter(function (n, i) {
            if (n.id === node.data.id) {
                index = i;
                return i;
            }
            return;
        });
        if (index !== null) {
            this.selectedLocation.splice(index, 1);
            this.isNodeSelected = false;
            $event.target.checked = false;
            node.setIsExpanded(true);
        }
        else {
            this.selectedLocation.push(node.data);
            node.setIsExpanded(true);
            this.removeSelectedChildren(node);
            this.removeSelectedParent(node);
            this.isNodeSelected = true;
            $event.target.checked = true;
        }
        //for testing
        // var result = [];
        // this.selectedLocation.forEach(loc => {
        // 	result.push(loc.mongoLocationId);
        // });
        // console.log("SELCTED LOCATION IDS :: " + JSON.stringify(result));
        this.multipleSelectLocation.emit(this.selectedLocation);
    }
    displayNode(node) {
        if (this.isAssetSearch) {
            return this.filteredIds.indexOf([node.data.mongoLocationId]) !== -1
                ? true
                : false;
        }
        else {
            return true;
        }
    }
}
StandardizedLocationHierachyV2Component.ɵfac = function StandardizedLocationHierachyV2Component_Factory(t) { return new (t || StandardizedLocationHierachyV2Component)(i0.ɵɵdirectiveInject(DataService)); };
StandardizedLocationHierachyV2Component.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StandardizedLocationHierachyV2Component, selectors: [["app-standardized-location-hierachy-v2"]], viewQuery: function StandardizedLocationHierachyV2Component_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$9, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.treeComponent = _t.first);
    } }, inputs: { reportType: "reportType", licenseType: "licenseType", locationTree: "locationTree", isCheckBoxNeed: "isCheckBoxNeed", isRootNeed: "isRootNeed", countMap: "countMap", type: "type", isPopup: "isPopup", filterLocationIdMap: "filterLocationIdMap", setSelectedLocation: "setSelectedLocation", searchLocation: "searchLocation", filterLocations: "filterLocations", isFilteredLocation: "isFilteredLocation", isAssetSearch: "isAssetSearch" }, outputs: { selectLocation: "selectLocation", multipleSelectLocation: "multipleSelectLocation", showErrorText: "showErrorText", searchResults: "searchResults", atLocationRestriction: "atLocationRestriction" }, decls: 7, vars: 2, consts: [[1, "location-hierarchy-v2"], [3, "nodes", "options", "event"], ["treev2", ""], ["treeNodeFullTemplate", ""], ["treeNodeTemplate", ""], [3, "node", "index", "templates"], [3, "node", "templates", 4, "ngIf"], [3, "node", "templates"], ["class", "location-node-name", 3, "ngClass", "tree-node", 4, "ngIf"], ["class", "location-right-content", 4, "ngIf"], ["class", "location-radio-content", 4, "ngIf"], [1, "location-node-name", 3, "ngClass"], ["href", "javascript:void(0);", 1, "location-name-icon", 3, "ngClass"], [1, "loc-type-icon"], ["id", "link-locdetails", 1, "location-name", 3, "innerHTML", "click"], [1, "location-count", 3, "mouseover", "mouseout"], [4, "ngIf"], ["id", "link-locdetails", 1, "location-name", 3, "innerHTML"], [1, "location-right-content"], ["class", "circularCheckbox iot-check-box userCheckbox", 3, "ngClass", 4, "ngIf"], ["type", "radio", "name", "locationRadio", 3, "checked", "id", "value", "click"], [1, "radioButtonLabel", 3, "for"], [1, "circularCheckbox", "iot-check-box", "userCheckbox", 3, "ngClass"], ["type", "checkbox", "name", "locationChecbox", 3, "checked", "id", "value", "click"], [1, "checkboxLabel", 3, "for"], [1, "location-radio-content"], [1, "radioButtonLabel", 2, "display", "table-column-group", 3, "for"]], template: function StandardizedLocationHierachyV2Component_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "tree-root", 1, 2);
        i0.ɵɵlistener("event", function StandardizedLocationHierachyV2Component_Template_tree_root_event_1_listener($event) { return ctx.onEvent($event); });
        i0.ɵɵtemplate(3, StandardizedLocationHierachyV2Component_ng_template_3_Template, 3, 18, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, StandardizedLocationHierachyV2Component_ng_template_5_Template, 8, 8, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("nodes", ctx.locations)("options", ctx.options);
    } }, directives: [i4.TreeComponent, i4.TreeNodeWrapperComponent, i1$2.NgIf, i4.TreeNodeChildrenComponent, i1$2.NgClass], pipes: [SafeHtmlPipe], styles: [".custom-loc-name[_ngcontent-%COMP%]{float:left}.node-wrapper[_ngcontent-%COMP%]{width:97%;padding:0;height:41px;display:table;position:relative;border:1px solid #dddfe2;border-width:0 0 1px 1px;top:-30px}.hideLocationDIv[_ngcontent-%COMP%]{background:#FF5733;color:#00f;display:none!important}input[type=checkbox][_ngcontent-%COMP%]:hover ~ .childSelected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -18px;content:\"\"}input[type=checkbox][_ngcontent-%COMP%] ~ .childSelected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -72px;content:\"\"}.hideNode[_ngcontent-%COMP%]{display:none}.highlighted[_ngcontent-%COMP%]{padding:2px;background:rgba(0,160,209,.2)!important;border-radius:8px}.location-radio-content[_ngcontent-%COMP%]   .radioButtonLabel[_ngcontent-%COMP%]{display:table-column-group}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StandardizedLocationHierachyV2Component, [{
        type: Component,
        args: [{
                selector: 'app-standardized-location-hierachy-v2',
                templateUrl: './standardized-location-hierachy-v2.component.html',
                styleUrls: ['./standardized-location-hierachy-v2.component.scss']
            }]
    }], function () { return [{ type: DataService }]; }, { treeComponent: [{
            type: ViewChild,
            args: ["treev2", { static: true }]
        }], reportType: [{
            type: Input
        }], licenseType: [{
            type: Input
        }], locationTree: [{
            type: Input
        }], selectLocation: [{
            type: Output
        }], multipleSelectLocation: [{
            type: Output
        }], showErrorText: [{
            type: Output
        }], searchResults: [{
            type: Output
        }], atLocationRestriction: [{
            type: Output
        }], isCheckBoxNeed: [{
            type: Input
        }], isRootNeed: [{
            type: Input
        }], countMap: [{
            type: Input
        }], type: [{
            type: Input
        }], isPopup: [{
            type: Input
        }], filterLocationIdMap: [{
            type: Input
        }], setSelectedLocation: [{
            type: Input
        }], searchLocation: [{
            type: Input
        }], filterLocations: [{
            type: Input
        }], isFilteredLocation: [{
            type: Input
        }], isAssetSearch: [{
            type: Input
        }] }); })();

const _c0$8 = ["tree"];
function StandardizedLocationHierachyComponent_ng_template_3_tree_node_children_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tree-node-children", 7);
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    const node_r5 = ctx_r9.$implicit;
    const templates_r7 = ctx_r9.templates;
    i0.ɵɵproperty("node", node_r5)("templates", templates_r7);
} }
function StandardizedLocationHierachyComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "tree-node-wrapper", 5);
    i0.ɵɵtemplate(2, StandardizedLocationHierachyComponent_ng_template_3_tree_node_children_2_Template, 1, 2, "tree-node-children", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r5 = ctx.$implicit;
    const index_r6 = ctx.index;
    const templates_r7 = ctx.templates;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2.getClass(node_r5));
    i0.ɵɵclassProp("tree-node", true)("tree-node-expanded", ctx_r2.getNodeExpanded(node_r5))("tree-node-collapsed", !node_r5.isExpanded && node_r5.hasChildren)("tree-node-leaf", node_r5.isLeaf)("tree-node-active", node_r5.isActive)("tree-node-focused", node_r5.isFocused);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("node", node_r5)("index", index_r6)("templates", templates_r7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r5.hasChildren);
} }
function StandardizedLocationHierachyComponent_ng_template_5_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵlistener("mouseover", function StandardizedLocationHierachyComponent_ng_template_5_span_5_Template_span_mouseover_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); const node_r10 = ctx_r15.$implicit; const index_r11 = ctx_r15.index; const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.onMouseOverNode(node_r10.data, index_r11); })("mouseout", function StandardizedLocationHierachyComponent_ng_template_5_span_5_Template_span_mouseout_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r18 = i0.ɵɵnextContext(); const node_r10 = ctx_r18.$implicit; const index_r11 = ctx_r18.index; const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.onMouseOutNode(node_r10.data, index_r11); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" (", node_r10.data.total, " out of ", node_r10.data.permitted, ") ");
} }
const _c1$3 = function (a0) { return { "disabledButton": a0 }; };
function StandardizedLocationHierachyComponent_ng_template_5_div_6_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵelementStart(1, "input", 20);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyComponent_ng_template_5_div_6_span_1_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r23); const node_r10 = i0.ɵɵnextContext(2).$implicit; const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.selectMultipleNode($event, node_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$3, ctx_r20.isFilteredLocation && !ctx_r20.isLocationContains(node_r10.data)));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r20.isLocationChecked(node_r10))("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r20.isChildNodeSelectedClass(node_r10));
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r10.data.id, "");
} }
function StandardizedLocationHierachyComponent_ng_template_5_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, StandardizedLocationHierachyComponent_ng_template_5_div_6_span_1_Template, 3, 9, "span", 16);
    i0.ɵɵelementStart(2, "input", 17);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyComponent_ng_template_5_div_6_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r27); const node_r10 = i0.ɵɵnextContext().$implicit; const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.selectNode(node_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.isCheckBoxNeed);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r10.data.id, "");
    i0.ɵɵproperty("checked", ctx_r13.selectedLocation && ctx_r13.selectedLocation.data && node_r10.id === ctx_r13.selectedLocation.data.id)("value", node_r10.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r10.data.id, "");
} }
const _c2$2 = function (a0, a1) { return { "custom-loc-node": a0, "disable-location": a1 }; };
const _c3$2 = function (a0) { return { "custom-loc-name": a0 }; };
function StandardizedLocationHierachyComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "a", 9);
    i0.ɵɵelement(2, "span", 10);
    i0.ɵɵelementStart(3, "span", 11);
    i0.ɵɵlistener("click", function StandardizedLocationHierachyComponent_ng_template_5_Template_span_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r30); const node_r10 = restoredCtx.$implicit; const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.selectLocationClick(node_r10.data); });
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, StandardizedLocationHierachyComponent_ng_template_5_span_5_Template, 2, 2, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, StandardizedLocationHierachyComponent_ng_template_5_div_6_Template, 4, 5, "div", 13);
} if (rf & 2) {
    const node_r10 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("tree-node", true);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c2$2, ctx_r4.isCheckBoxNeed, ctx_r4.envMetricPage && (node_r10.data.type === "floor" || node_r10.data.type === "zone" || node_r10.data.type === "cmxzone" || node_r10.data.type === "polygon_zone")));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c3$2, ctx_r4.isCheckBoxNeed));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 7, node_r10.data.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r10.data.permitted != node_r10.data.total);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r10.data.access === "Full" || node_r10.data.reportAccess);
} }
class StandardizedLocationHierachyComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.treeComponent = null;
        this.locations = [];
        this.locationOrginal = [];
        this.searchTimestamp = 0;
        this.locationSearchString = "";
        this.isTreeInitialised = false;
        this.filteredIds = [];
        this.isNodeSelected = false;
        this.searchedLocation = [];
        this.previousSearchedLocations = [];
        this.isOnlyMeraki = false;
        this.errorText = false;
        this.showTooltip = [];
        this.resultsFound = 0;
        this.envMetricPage = false;
        this.selectLocation = new EventEmitter();
        this.multipleSelectLocation = new EventEmitter();
        this.showErrorText = new EventEmitter();
        this.searchResults = new EventEmitter();
        this.isCheckBoxNeed = false;
        this.isRootNeed = false;
        this.isPopup = false;
        this.isFilteredLocation = false;
        this.options = {
            displayField: "name",
            isExpandedField: "expanded",
            idField: "id",
            actionMapping: {
                mouse: {
                //dblClick: (tree, node, $event) => {
                //  if (node.hasChildren) TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event);
                //},
                //click:(tree, node, $event) => {
                //this.logger.debug('mouse click', tree, node, $event);
                //}
                }
            },
            allowDrag: (node) => {
                return false;
            },
            allowDrop: (node) => {
                return false;
            },
            useVirtualScroll: false,
            animateExpand: false,
            animateSpeed: 10,
            animateAcceleration: 1.2,
            nodeHeight: 32,
            dropSlotHeight: 3
        };
        this.onTreeLoad = () => {
            setTimeout(() => {
                if (this.treeComponent) {
                    this.treeComponent.treeModel.update();
                    this.treeComponent.treeModel.roots[0].expand();
                }
            }, 100);
        };
        this.getNodeExpanded = (node) => {
            return node.isExpanded && node.hasChildren;
        };
        this.selectLocationCheckBox = ($event, locationNode) => {
            console.log("selected location is :: " + JSON.stringify(locationNode));
            let index = null;
            if (!this.selectedLocation)
                this.selectedLocation = [];
            this.selectedLocation.filter(function (n, i) {
                if (n.data.id === locationNode.data.id) {
                    index = i;
                    return i;
                }
            });
            if (index !== null) {
                this.selectedLocation.splice(index, 1);
                this.isNodeSelected = false;
                $event.target.checked = false;
            }
            else {
                this.selectedLocation.push(locationNode);
                $event.target.checked = true;
                this.isNodeSelected = true;
            }
        };
        this.onEvent = ($event) => {
            //   console.log('onEvent from tree::', $event);
            switch ($event.eventName) {
                case "initialized":
                    this.isTreeInitialised = true;
                    //this.treeComponent.treeModel.update();
                    if (this.treeComponent)
                        this.treeComponent.treeModel.roots.forEach((root) => {
                            if (root.isCollapsed)
                                root.expand();
                        });
                    break;
                case "changeFilter":
                    setTimeout(() => {
                        //    this.dataService.display(false);
                    }, 500);
                    break;
            }
        };
        this.getClass = (node) => {
            const selected = this.isSelectedLocation(node);
            let classString = "";
            if (node && (node.data.parent == "-1" || (node.parent && !node.isRoot)))
                classString = node.getClass();
            classString += " type-" + node.data.type;
            // if (selected)
            //   classString += ' tree-node isSelectedNode';
            if (this.isOnlyMeraki && node.data.type != "root") {
                if (node.data.type == "group" &&
                    (node.data.parentNode.type == "root" ||
                        node.data.parentNode.type == "meraki")) {
                    return classString;
                }
                else if (node.data.networkDetails.wirelessProvider != "MERAKI") {
                    return "hideNode";
                }
            }
            return classString;
        };
        //// Checkbox starts
        this.isSelectedLocation = (node) => {
            let index = null;
            if (this.selectedLocation && this.selectedLocation.length > 0)
                this.selectedLocation.filter(function (n, i) {
                    if (n && n.id === node.data.id) {
                        index = i;
                        return i;
                    }
                });
            if (index !== null) {
                this.isNodeSelected = true;
                return true;
            }
            else {
                this.isNodeSelected = false;
                return false;
            }
        };
        this.isLocationChecked = (node) => {
            let result = false;
            if (this.selectedLocation && this.selectedLocation.length > 0) {
                this.selectedLocation.filter(function (n, i) {
                    if (n && n.id === node.data.id) {
                        result = true;
                    }
                });
            }
            return result;
        };
        this.isChildNodeSelectedClass = (node) => {
            let classString = "checkboxLabel";
            let parentPath;
            const parentPathArray = [];
            if (this.selectedLocation) {
                this.selectedLocation.filter(function (n, i) {
                    if (n.path && n.path.length > 0) {
                        parentPath = n.path.slice(0, n.path.length - 1);
                        parentPath.forEach((element) => {
                            parentPathArray.push(element);
                        });
                    }
                });
            }
            // remove duplicates
            const uniqueParentPaths = this.removeDuplicates(parentPathArray);
            // check the unique parent paths with node
            if (uniqueParentPaths && uniqueParentPaths.indexOf(node.data.id) > -1) {
                classString += " childSelected";
                return classString;
            }
            else {
                return classString;
            }
        };
        this.removeSelectedChildren = (selectedNode) => {
            if (selectedNode && selectedNode.data.path.length > 0) {
                var index = [];
                this.selectedLocation.filter(function (n, i) {
                    if (n.path && n.path.length > 0) {
                        var selectedLocParentPath = n.path.slice(0, n.path.length - 1);
                        if (selectedLocParentPath.indexOf(selectedNode.data.id) > -1) {
                            index.push(i);
                            return i;
                        }
                    }
                });
                if (index !== null) {
                    for (var j = index.length - 1; j >= 0; j--) {
                        this.selectedLocation.splice(index[j], 1);
                    }
                }
            }
        };
        this.removeSelectedParent = (selectedNode) => {
            if (selectedNode && selectedNode.data.path.length > 0) {
                var index = [];
                this.selectedLocation.filter(function (n, i) {
                    if (selectedNode.data && selectedNode.data.path) {
                        var parentPath = selectedNode.data.path.slice(0, selectedNode.data.path.length - 1);
                        if (parentPath.indexOf(n.id) > -1) {
                            index.push(i);
                            return i;
                        }
                    }
                });
                if (index !== null) {
                    for (var j = index.length - 1; j >= 0; j--) {
                        this.selectedLocation.splice(index[j], 1);
                    }
                }
            }
        };
        // remove duplicates from array
        this.removeDuplicates = (arr) => {
            const unique_array = [];
            for (let i = 0; i < arr.length; i++) {
                if (unique_array.indexOf(arr[i]) === -1) {
                    unique_array.push(arr[i]);
                }
            }
            return unique_array;
        };
        this.initLocationNodes = () => {
            // To be implemented in child component
            if (this.currentFilterLocations &&
                Object.keys(this.currentFilterLocations).length > 0) {
                this.filterLocationIds(this.currentFilterLocations);
            }
            else {
                this.locations = this.locationOrginal;
            }
            this.prevFilterLocations = this.currentFilterLocations;
        };
        this.subscribeSearchText = (val) => {
            console.log("search text", val);
            this.searchText = val;
            if (this.searchText &&
                this.searchText.length >= 3 &&
                this.isTreeInitialised &&
                this.prevSearchString !== this.searchText) {
                //  this.dataService.display(true);
                if (this.prevSearchString !== this.searchText) {
                    this.searchTimestamp = new Date().getTime();
                    this.prevSearchString = this.searchText;
                }
                if (this.setTimeoutObj)
                    clearTimeout(this.setTimeoutObj);
                this.setTimeoutObj = setTimeout(() => {
                    // console.log('search', this.searchText);
                    this.searchTree(this.searchTimestamp);
                }, 1200);
            }
            else {
                this.resultsFound = 0;
                this.searchResults.emit(this.resultsFound);
                if (this.searchText !== null || this.searchText === "") {
                    this.locations = this.locationOrginal;
                    this.initLocationNodes();
                    if (this.treeComponent) {
                        this.treeComponent.treeModel.setData({
                            nodes: this.locationOrginal,
                            options: this.options,
                            events: null
                        });
                        this.treeComponent.treeModel.roots.forEach((root) => {
                            root.expand();
                        });
                    }
                    this.prevSearchString = "";
                }
                // if(this.dataService.getCurrentNav().indexOf("business") > -1 && this.enableCustomSearch && this.dataService.getCurrentNav().indexOf("detail") > -1 )
                //     this.dataService.display(false);
            }
        };
        this.searchTree = (searchTimestamp) => {
            //console.log('search tree', this.searchText);
            const makeServerCall = true;
            const tokensTemp = this.prevSearchString.trim().split(" ");
            const tokens = [];
            this.resultsFound = 0;
            this.searchResults.emit(this.resultsFound);
            for (let tokCount = 0, max = tokensTemp.length; tokCount < max; tokCount++) {
                if (!this.validToken(tokensTemp[tokCount]))
                    continue;
                tokens.push(tokensTemp[tokCount]);
            }
            if (tokens && tokens.length > 0) {
                const regexTokenStr = "root|" + tokens.join("|");
                const regexStr = "(" + regexTokenStr + ")";
                const regexp = new RegExp(regexStr, "gi");
                // console.log('tokens', tokens, tokens.join('|'), "regexp", regexp, "this.locationSearchString", this.locationSearchString);
                this.findNodes(tokens, regexp, searchTimestamp, null, true);
                // this.dataService.display(false);
            }
            else {
                //this.dataService.display(false);
            }
        };
        this.validToken = (token) => {
            if (token === "" || token === ".") {
                return false;
            }
            return true;
        };
        this.findNodes = (tokens, regexp, searchTimestamp, apMatches, firstCall) => {
            let filteredLocation = null;
            //console.log('searchRegex', regexp, 'firstCall', firstCall);
            if (this.locationOrginal && this.locationOrginal.length > 0) {
                filteredLocation = this.matchToken(this.locationOrginal[0], tokens, apMatches, false, regexp);
                console.log("location tree :: matchToken ", filteredLocation);
            }
            if (filteredLocation.location && this.treeComponent) {
                // this.location = [filteredLocation.location];
                this.treeComponent.treeModel.setData({
                    nodes: [filteredLocation.location],
                    options: this.options,
                    events: null
                });
                if (filteredLocation.foundChild) {
                }
            }
            else {
                // this.location = this.locationOrginal;
                this.treeComponent.treeModel.setData({
                    nodes: this.locationOrginal,
                    options: this.options,
                    events: null
                });
            }
            let index = 0;
            setTimeout(() => {
                if (this.treeComponent)
                    this.treeComponent.treeModel.doForAll((node) => {
                        this.ensureNodeVisible(node, ++index);
                        // return true;
                    });
            }, 100);
        };
        this.ensureNodeVisible = (node, index) => {
            const delay = Math.round(index / 10) * 10;
            setTimeout(() => {
                if (node && node.data && node.data.expanded)
                    node.ensureVisible();
            }, delay);
        };
        this.matchToken = (location, searchTokens, apMatches, isParent, searchRegex) => {
            //TODO: implement search
            let found = false;
            // console.log(location.name, location.path, searchRegex.test(location.name.toLowerCase()))
            if (searchRegex.test(location["name"].toLowerCase())) {
                found = true;
                // console.log('Location matched:', location.name, location.path);
            }
            const newLoc = Object.assign({}, location);
            newLoc.children = [];
            newLoc.location = [];
            // let newLoc = location.clone();
            newLoc.expanded = false;
            if (location["type"] === "root" || found)
                newLoc.expanded = true;
            if (found) {
                this.resultsFound += 1;
                this.searchResults.emit(this.resultsFound);
                newLoc.name = newLoc.name
                    .replace(/&amp;/g, "&")
                    .replace(/&lt;/g, "<")
                    .replace(/&gt;/g, ">");
                newLoc.name = newLoc.name.replace(searchRegex, '<span class="highlighted-v2">$&</span>');
            }
            let foundChild = false;
            if (location["children"])
                for (let index = 0, max = location["children"].length; index < max; index++) {
                    const childLoc = location["children"][index];
                    const resChild = this.matchToken(childLoc, searchTokens, apMatches, isParent || found, searchRegex);
                    console.log("location tree :: matchToken ", resChild);
                    if (resChild["foundChild"] || resChild["found"]) {
                        foundChild = true;
                        // console.log('Location matched:', resChild['location'].name, resChild['location'].path);
                    }
                    if (isParent ||
                        found ||
                        resChild["foundChild"] ||
                        resChild["found"])
                        newLoc.children.push(resChild["location"]);
                }
            //
            return { location: newLoc, foundChild, found };
        };
        this.filterLocationIds = (filterLocations) => {
            if (filterLocations && Object.keys(filterLocations).length > 0) {
                if (this.locationOrginal) {
                    // let filteredLocations = [];
                    const filteredLocations = new Map();
                    let root = null;
                    root = this.filterLocationTree(this.locationOrginal, filteredLocations, filterLocations, root);
                    this.locations = [root];
                    // console.log("this.location after filter", this.location);
                }
                else {
                    console.log("Locations not available", location);
                }
            }
        };
        this.filterLocationTree = (locations, filteredLocations, filterLocations, root) => {
            locations.forEach((location) => {
                if (!filterLocations[location.mongoLocationId.toString()])
                    return;
                const newLoc = Object.assign({}, location);
                newLoc.children = [];
                filteredLocations.set(newLoc.id, newLoc);
                if (newLoc.parentId && newLoc.parentId !== "-1") {
                    const parent = filteredLocations.get(newLoc.parentId);
                    if (parent) {
                        if (!parent.children)
                            parent.children = [];
                        parent.children.push(newLoc);
                    }
                    else {
                        console.log("Parent " +
                            String(newLoc.parent) +
                            " not found for location " +
                            String(newLoc.id), newLoc);
                    }
                }
                else {
                    root = newLoc;
                }
                if (location.children)
                    root = this.filterLocationTree(location.children, filteredLocations, filterLocations, root);
            });
            return root;
        };
        this.isLocationContains = (locationObj) => {
            if (this.currentFilterLocations &&
                this.currentFilterLocations.length > 0 &&
                this.currentFilterLocations.includes(locationObj.id)) {
                return true;
            }
            else {
                return false;
            }
        };
        this.onMouseOverNode = (nodeData, index) => {
            this.showTooltip = [];
            if ((this.dataService.getCurrentNav().indexOf('right-now') !== -1) && (nodeData.type === 'zone' || nodeData.type === 'cmxzone' || nodeData.type === 'polygon_zone')) {
                $('#loc_tooltip_' + nodeData.id).addClass('zone-alert-show');
            }
            else {
                if (!this.isPopup) {
                    if (!nodeData.showMenu) {
                        nodeData.showMenu = true;
                        setTimeout(() => {
                            nodeData.showMenu = false;
                        }, 2000);
                    }
                }
                else {
                    this.locName = nodeData.name;
                    this.totalLocations = nodeData.total;
                    this.permittedLocations = nodeData.permitted;
                    if (nodeData.total != nodeData.permitted) {
                        this.showTooltip[index] = true;
                    }
                    else {
                        this.showTooltip[index] = false;
                    }
                    // if (nodeData.licenseType && this.disableLicenseType == nodeData.licenseType) {
                    // 	this.showTooltip[index] = true;
                    // }
                }
            }
        };
        this.onMouseOutNode = (nodeData, index) => {
            setTimeout(() => {
                $('#loc_tooltip_' + nodeData.id).removeClass('zone-alert-show');
            }, 500);
            if (!this.isPopup) {
                nodeData.showMenu = false;
            }
            else {
                this.showTooltip[index] = false;
            }
        };
        this.selectNode = (node) => {
            const currentNav = this.dataService.getCurrentNav();
            if ((currentNav &&
                currentNav.indexOf("right-now") !== -1 &&
                (node.data.type === "zone" ||
                    node.data.type === "cmxzone" ||
                    node.data.type === "polygon_zone")) ||
                (currentNav &&
                    currentNav.indexOf("camera-metrics") !== -1 &&
                    node.data.camerasCount === 0))
                return;
            this.doSelection(node);
            this.selectLocation.emit(this.selectedLocation);
        };
        this.doSelection = (node) => {
            //console.log( "Select node:: manage location:", this.selectedLocation, node );
            if (this.selectedLocation !== undefined &&
                this.selectedLocation.length > 0 &&
                this.selectedLocation[0].data !== undefined &&
                this.selectedLocation[0].data.id === node.data.id) {
                this.selectedLocation = [];
                node.setIsExpanded(true);
            }
            else {
                if (node && node[0] && node[0].id == undefined) {
                    this.selectedLocation = node[0];
                    node.setIsExpanded(true);
                }
                else {
                    this.selectedLocation = [node];
                    node.setIsExpanded(true);
                }
            }
        };
    }
    set locationTree(value) {
        if (!value || value.length === 0) {
            return;
        }
        this.locations = value;
        this.locationOrginal = value;
        this.showTooltip = [];
        this.clearPreviousSearch();
        setTimeout(() => {
            if (this.treeComponent) {
                this.treeComponent.treeModel.update();
                this.treeComponent.treeModel.roots[0].focus();
                this.treeComponent.treeModel.roots[0].expand();
            }
        }, 100);
    }
    set setSelectedLocation(selectedLocations) {
        //console.log('set selected location', selectedLocations);
        this.selectedLocation = selectedLocations;
        if (!selectedLocations || selectedLocations.length === 0)
            for (const id of this.selectedLocation) {
                try {
                    this.selectedLocation[id].setIsExpanded(true);
                }
                catch (e) {
                    console.log("location id not available", String(this.selectedLocation[id]));
                }
            }
        else {
            setTimeout(() => {
                // for (let i = 0; i < this.selectedLocation.length; i++) {
                try {
                    const nodeF = this.treeComponent.treeModel.getNodeById(this.selectedLocation[0].id);
                    this.selectedLocation = nodeF;
                    this.selectedLocation.setIsExpanded(true);
                    this.selectedLocation.focus();
                    this.getParentLocations(this.selectedLocation);
                }
                catch (e) {
                    console.log("location id not available", this.selectedLocation);
                }
                /* if (!this.selectedLocation[i]) {
                        this.selectedLocation.splice(i, 1);
                    }*/
                //	}
            }, 500);
        }
    }
    set searchLocation(customSearchText) {
        // this.enableCustomSearch = true;
        if (customSearchText) {
            if (customSearchText && customSearchText !== '') {
                if (customSearchText.trim().length >= 3) {
                    this.errorText = false;
                    this.showErrorText.emit(this.errorText);
                    // this.searchString = customSearchText.trim();
                }
                else {
                    this.errorText = true;
                    this.showErrorText.emit(this.errorText);
                    // this.resetList();
                }
            }
            else {
                this.errorText = false;
                this.showErrorText.emit(this.errorText);
                // this.searchString = null;
                // this.resetList();
            }
            this.subscribeSearchText(customSearchText);
            // this.prevSearchString = customSearchText;
            // this.searchTree(new Date().getTime());
        }
        else {
            this.errorText = false;
            this.showErrorText.emit(this.errorText);
        }
    }
    set filterLocations(filterLocations) {
        this.currentFilterLocations = filterLocations;
        if (this.isTreeInitialised)
            this.initLocationNodes();
    }
    ngOnInit() {
        if (this.dataService.getCurrentNav().indexOf('environmental-metrics') !== -1) {
            this.envMetricPage = true;
        }
        else {
            this.envMetricPage = false;
        }
    }
    ngAfterInit() {
        if (this.treeComponent) {
            const treeModel = this.treeComponent.treeModel;
            const firstNode = treeModel.getFirstRoot();
            firstNode.setActiveAndVisible();
        }
    }
    clearPreviousSearch() {
        const clearLocations = [];
        if (this.previousSearchedLocations) {
            for (let i = 0; i < this.previousSearchedLocations.length; i++) {
                try {
                    const nodeF = this.treeComponent.treeModel.getNodeById(this.previousSearchedLocations[i].data.id);
                    clearLocations[i] = nodeF;
                }
                catch (e) {
                    console.log("location id not available", this.selectedLocation[i]);
                }
            }
            for (let i = 0; i < clearLocations.length; i++) {
                try {
                    clearLocations[i].setIsExpanded(false);
                }
                catch (e) {
                    console.log("location id not available");
                }
            }
        }
    }
    getParentLocations(node) {
        if (node.data.parent !== "-1") {
            const nodeF = this.treeComponent.treeModel.getNodeById(node.data.parent);
            nodeF.setIsExpanded(true);
            this.searchedLocation.push(nodeF);
            this.getParentLocations(nodeF);
        }
        return;
    }
    selectLocationClick(nodeData) {
        this.selectLocation.emit(nodeData);
    }
    getDeviceCount(nodeData) {
        return this.countMap[nodeData.mongoLocationId]
            ? "(" + String(this.countMap[nodeData.mongoLocationId]) + ")"
            : "";
    }
    getSensorCount(nodeData) {
        return this.countMap[nodeData.mongoLocationId]
            ? String(this.countMap[nodeData.mongoLocationId]) + " Sensors"
            : "";
    }
    selectMultipleNode($event, node) {
        let index = null;
        if (!this.selectedLocation)
            this.selectedLocation = [];
        this.selectedLocation.filter(function (n, i) {
            if (n.id === node.data.id) {
                index = i;
                return i;
            }
            return;
        });
        if (index !== null) {
            this.selectedLocation.splice(index, 1);
            this.isNodeSelected = false;
            $event.target.checked = false;
            node.setIsExpanded(true);
        }
        else {
            this.selectedLocation.push(node.data);
            node.setIsExpanded(true);
            this.removeSelectedChildren(node);
            this.removeSelectedParent(node);
            this.isNodeSelected = true;
            $event.target.checked = true;
        }
        //for testing
        // var result = [];
        // this.selectedLocation.forEach(loc => {
        // 	result.push(loc.mongoLocationId);
        // });
        // console.log("SELCTED LOCATION IDS :: " + JSON.stringify(result));
        this.multipleSelectLocation.emit(this.selectedLocation);
    }
    displayNode(node) {
        if (this.isAssetSearch) {
            return this.filteredIds.indexOf([node.data.mongoLocationId]) !== -1
                ? true
                : false;
        }
        else {
            return true;
        }
    }
}
StandardizedLocationHierachyComponent.ɵfac = function StandardizedLocationHierachyComponent_Factory(t) { return new (t || StandardizedLocationHierachyComponent)(i0.ɵɵdirectiveInject(DataService)); };
StandardizedLocationHierachyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StandardizedLocationHierachyComponent, selectors: [["app-standardized-location-hierachy"]], viewQuery: function StandardizedLocationHierachyComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$8, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.treeComponent = _t.first);
    } }, inputs: { locationTree: "locationTree", isCheckBoxNeed: "isCheckBoxNeed", isRootNeed: "isRootNeed", countMap: "countMap", type: "type", isPopup: "isPopup", filterLocationIdMap: "filterLocationIdMap", setSelectedLocation: "setSelectedLocation", searchLocation: "searchLocation", filterLocations: "filterLocations", isFilteredLocation: "isFilteredLocation", isAssetSearch: "isAssetSearch" }, outputs: { selectLocation: "selectLocation", multipleSelectLocation: "multipleSelectLocation", showErrorText: "showErrorText", searchResults: "searchResults" }, decls: 7, vars: 2, consts: [[1, "location-hierarchy-v2"], [3, "nodes", "options", "event"], ["tree", ""], ["treeNodeFullTemplate", ""], ["treeNodeTemplate", ""], [3, "node", "index", "templates"], [3, "node", "templates", 4, "ngIf"], [3, "node", "templates"], [1, "location-node-name", 3, "ngClass"], ["href", "javascript:void(0);", 1, "location-name-icon", 3, "ngClass"], [1, "loc-type-icon"], ["id", "link-locdetails", 1, "location-name", 3, "innerHTML", "click"], ["class", "location-count", 3, "mouseover", "mouseout", 4, "ngIf"], ["class", "location-right-content", 4, "ngIf"], [1, "location-count", 3, "mouseover", "mouseout"], [1, "location-right-content"], ["class", "circularCheckbox iot-check-box userCheckbox", 3, "ngClass", 4, "ngIf"], ["type", "radio", "name", "locationRadio", 3, "checked", "id", "value", "click"], [1, "radioButtonLabel", 3, "for"], [1, "circularCheckbox", "iot-check-box", "userCheckbox", 3, "ngClass"], ["type", "checkbox", "name", "locationChecbox", 3, "checked", "id", "value", "click"], [1, "checkboxLabel", 3, "for"]], template: function StandardizedLocationHierachyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "tree-root", 1, 2);
        i0.ɵɵlistener("event", function StandardizedLocationHierachyComponent_Template_tree_root_event_1_listener($event) { return ctx.onEvent($event); });
        i0.ɵɵtemplate(3, StandardizedLocationHierachyComponent_ng_template_3_Template, 3, 18, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, StandardizedLocationHierachyComponent_ng_template_5_Template, 7, 14, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("nodes", ctx.locations)("options", ctx.options);
    } }, directives: [i4.TreeComponent, i4.TreeNodeWrapperComponent, i1$2.NgIf, i4.TreeNodeChildrenComponent, i1$2.NgClass], pipes: [SafeHtmlPipe], styles: [".custom-loc-name[_ngcontent-%COMP%]{float:left}.node-wrapper[_ngcontent-%COMP%]{width:97%;padding:0;height:41px;display:table;position:relative;border:1px solid #dddfe2;border-width:0 0 1px 1px;top:-30px}.hideLocationDIv[_ngcontent-%COMP%]{background:#FF5733;color:#00f;display:none!important}input[type=checkbox][_ngcontent-%COMP%]:hover ~ .childSelected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -18px;content:\"\"}input[type=checkbox][_ngcontent-%COMP%] ~ .childSelected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -72px;content:\"\"}.hideNode[_ngcontent-%COMP%]{display:none}.highlighted[_ngcontent-%COMP%]{padding:2px;background:rgba(0,160,209,.2)!important;border-radius:8px}.location-node-name.disable-location[_ngcontent-%COMP%], .location-node-name.disable-location[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:default!important;pointer-events:none}.location-node-name.disable-location[_ngcontent-%COMP%]   .location-name[_ngcontent-%COMP%]:hover{border:0 none!important}.location-node-name.disable-location[_ngcontent-%COMP%]{opacity:.5}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StandardizedLocationHierachyComponent, [{
        type: Component,
        args: [{
                selector: 'app-standardized-location-hierachy',
                templateUrl: './standardized-location-hierachy.component.html',
                styleUrls: ['./standardized-location-hierachy.component.scss']
            }]
    }], function () { return [{ type: DataService }]; }, { treeComponent: [{
            type: ViewChild,
            args: ["tree", { static: true }]
        }], locationTree: [{
            type: Input
        }], selectLocation: [{
            type: Output
        }], multipleSelectLocation: [{
            type: Output
        }], showErrorText: [{
            type: Output
        }], searchResults: [{
            type: Output
        }], isCheckBoxNeed: [{
            type: Input
        }], isRootNeed: [{
            type: Input
        }], countMap: [{
            type: Input
        }], type: [{
            type: Input
        }], isPopup: [{
            type: Input
        }], filterLocationIdMap: [{
            type: Input
        }], setSelectedLocation: [{
            type: Input
        }], searchLocation: [{
            type: Input
        }], filterLocations: [{
            type: Input
        }], isFilteredLocation: [{
            type: Input
        }], isAssetSearch: [{
            type: Input
        }] }); })();

function StatsTooltipContentComponent_span_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function StatsTooltipContentComponent_span_0_div_5_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(2); return ctx_r3.onClick($event); });
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵtext(2, "Learn More");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function StatsTooltipContentComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "div", 2);
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelement(3, "div", 3);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵtemplate(5, StatsTooltipContentComponent_span_0_div_5_Template, 3, 0, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 3, ctx_r0.tooltip.title), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 5, ctx_r0.tooltip.desc), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.tooltip.url);
} }
function StatsTooltipContentComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
    i0.ɵɵpipe(1, "safeHtml");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r1.tooltip.html), i0.ɵɵsanitizeHtml);
} }
class StatsTooltipContentComponent {
    constructor(viewContainerRef, element, tooltipService) {
        this.viewContainerRef = viewContainerRef;
        this.element = element;
        this.tooltipService = tooltipService;
        this.overLappingPX = 10;
        this.overLappingPXLeft = 40;
        this.elLeft = 0;
        this.elRight = 0;
        this.elTop = 0;
        this.elBottom = 0;
        this.elWidth = 0;
        this.elHeight = 0;
        this.brWidth = 0;
        this.brHeight = 0;
        this.ttWidth = 0;
        this.ttHeight = 0;
        this.ttTop = 0;
        this.ttLeft = 0;
        this.elFixed = false;
        this.recalPositionArray = Object.keys(POSITION);
        this.recalPosition = 0;
        this.isRecalc = false;
        this.previousTooltipArrowClass = "";
        this.nextTooltipArrowClass = "";
        this.fixedClass = "element-fixed";
        this.findPositionEnum = (indexStr) => {
            switch (indexStr) {
                case POSITION.RIGHT_TOP:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.RIGHT_MIDDLE:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.RIGHT_BOTTOM:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.LEFT_TOP:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.LEFT_MIDDLE:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.LEFT_BOTTOM:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.TOP_RIGHT:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.TOP_LEFT:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.TOP_MIDDLE:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.BOTTOM_RIGHT:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.BOTTOM_LEFT:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.BOTTOM_MIDDLE:
                default:
                    return POSITION.BOTTOM_MIDDLE;
                    break;
            }
        };
        this.doInit = () => {
            const el = this.tooltip.ref.nativeElement.getBoundingClientRect();
            this.elLeft = el.left;
            this.elTop = el.top;
            this.elHeight = el.height;
            this.elWidth = el.width;
            this.ttHeight = this.element.nativeElement.offsetHeight;
            this.ttWidth = this.element.nativeElement.offsetWidth;
            this.brWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            this.brHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            this.recalPosition = 0;
        };
        this.doPosition = () => {
            //tooltip.position in POSITION
            this.setPosition();
            // console.log("tooltip", "this.elLeft", this.elLeft, "this.elTop", this.elTop,
            //   "this.elHeight", this.elHeight, "this.elWidth", this.elWidth, "this.ttHeight", this.ttHeight,
            //   "this.ttWidth", this.ttWidth, "this.ttTop", this.ttTop,
            //   "this.ttLeft", this.ttLeft, "this.brWidth", this.brWidth, "this.brHeight", this.brHeight,
            //   "this.tooltip.position", this.tooltip.position);
            this.animateTooltip();
        };
        this.animateTooltip = () => {
            const elmen = this.element.nativeElement;
            const prevClass = this.previousTooltipArrowClass;
            const nextClass = this.nextTooltipArrowClass;
            const fixedClass = this.fixedClass;
            const isFixed = this.fixedClass;
            // console.log('left', this.ttLeft, 'top', this.ttTop, 'position', (this.tooltip.isFixed ? 'fixed' : 'absolute'));
            jQuery(elmen).animate({
                left: this.ttLeft,
                top: this.ttTop
            }, 100, function () {
                // Animation complete.
                if (prevClass)
                    jQuery(elmen).removeClass(prevClass);
                if (nextClass)
                    jQuery(elmen).addClass(nextClass);
                jQuery(elmen).removeClass(fixedClass);
                if (isFixed) {
                    jQuery(elmen).addClass(fixedClass);
                    jQuery(elmen).css("width", "300px");
                }
            });
            if (!this.tooltip.forcePosition) {
                setTimeout(() => {
                    this.previousTooltipArrowClass = this.nextTooltipArrowClass;
                    this.checkIfToolTipInViewPort();
                }, 200);
            }
            else {
                this.displayTooltip();
            }
        };
        this.displayTooltip = () => {
            jQuery(this.element.nativeElement).removeClass("visibility-hidden");
        };
        this.checkIfToolTipInViewPort = () => {
            const viewportOffset = this.element.nativeElement.getBoundingClientRect();
            const topEdge = viewportOffset.top; //this.ttTop;
            const leftEdge = viewportOffset.left; //this.ttLeft;
            const rightEdge = leftEdge + this.ttWidth;
            const bottomEdge = topEdge + this.ttHeight;
            // console.log('topEdge', topEdge, 'leftEdge', leftEdge, 'rightEdge', rightEdge,
            //     'bottomEdge', bottomEdge, 'elLeft', this.elLeft, 'elTop', this.elTop);
            if (topEdge <= 0 ||
                leftEdge <= 0 ||
                rightEdge >= this.brWidth ||
                bottomEdge >= this.brHeight) {
                //recalc
                this.isRecalc = true;
                if (this.recalPosition < this.recalPositionArray.length - 1) {
                    this.recalPosition++;
                    this.doPosition();
                }
                else {
                    console.log("cant try more!!!");
                    this.displayTooltip();
                }
            }
            else {
                this.displayTooltip();
            }
        };
        this.setPosition = () => {
            this.tooltipPosition = this.findPositionEnum(this.recalPositionArray[this.recalPosition]);
            if ((this.tooltip.forcePosition && this.tooltip.position) ||
                (this.tooltip.position && !this.isRecalc)) {
                this.tooltipPosition = this.tooltip.position;
            }
            const styleStr = "";
            switch (this.tooltipPosition) {
                case POSITION.RIGHT_TOP:
                    this.positionRightTop();
                    this.nextTooltipArrowClass = "arrow-left-bottom";
                    break;
                case POSITION.RIGHT_MIDDLE:
                    this.positionRightMiddle();
                    this.nextTooltipArrowClass = "arrow-left-middle";
                    break;
                case POSITION.RIGHT_BOTTOM:
                    this.positionRightBottom();
                    this.nextTooltipArrowClass = "arrow-left-top";
                    break;
                case POSITION.LEFT_TOP:
                    this.positionLeftTop();
                    this.nextTooltipArrowClass = "arrow-right-bottom";
                    break;
                case POSITION.LEFT_MIDDLE:
                    this.positionLeftMiddle();
                    this.nextTooltipArrowClass = "arrow-right-middle";
                    break;
                case POSITION.LEFT_BOTTOM:
                    this.positionLeftBottom();
                    this.nextTooltipArrowClass = "arrow-right-top";
                    break;
                case POSITION.TOP_RIGHT:
                    this.positionTopRight();
                    this.nextTooltipArrowClass = "arrow-bottom-left";
                    break;
                case POSITION.TOP_LEFT:
                    this.positionTopLeft();
                    this.nextTooltipArrowClass = "arrow-bottom-right";
                    break;
                case POSITION.TOP_MIDDLE:
                    this.positionTopMiddle();
                    this.nextTooltipArrowClass = "arrow-bottom-middle";
                    break;
                case POSITION.BOTTOM_RIGHT:
                    this.positionBottomRight();
                    this.nextTooltipArrowClass = "arrow-top-left";
                    break;
                case POSITION.BOTTOM_LEFT:
                    this.positionBottomLeft();
                    this.nextTooltipArrowClass = "arrow-top-right";
                    break;
                case POSITION.BOTTOM_MIDDLE:
                default:
                    this.positionBottomMiddle();
                    this.nextTooltipArrowClass = "arrow-top-middle";
                    break;
            }
            return styleStr;
        };
        this.positionLeftTop = () => {
            this.ttTop = this.elTop - this.ttHeight + this.overLappingPX;
            this.ttLeft = this.elLeft - this.ttWidth;
        };
        this.positionLeftMiddle = () => {
            this.ttTop = this.elTop - this.ttHeight / 2 + this.elHeight / 2;
            this.ttLeft = this.elLeft - this.ttWidth;
        };
        this.positionLeftBottom = () => {
            this.ttTop = this.elTop + this.elHeight - this.overLappingPX;
            this.ttLeft = this.elLeft - this.ttWidth;
        };
        this.positionRightTop = () => {
            this.ttTop = this.elTop - this.ttHeight + this.overLappingPX;
            this.ttLeft = this.elLeft + this.elWidth;
        };
        this.positionRightMiddle = () => {
            this.ttTop = this.elTop - this.ttHeight / 2 + this.elHeight / 2;
            this.ttLeft = this.elLeft + this.elWidth;
        };
        this.positionRightBottom = () => {
            this.ttTop = this.elTop + this.elHeight - this.overLappingPX;
            this.ttLeft = this.elLeft + this.elWidth;
        };
        this.positionTopLeft = () => {
            this.ttTop = this.elTop - this.ttHeight - this.overLappingPX;
            this.ttLeft = this.elLeft + this.elWidth - this.ttWidth;
        };
        this.positionTopMiddle = () => {
            this.ttTop = this.elTop - this.ttHeight - this.overLappingPX;
            this.ttLeft = this.elLeft + this.elWidth / 2 - this.ttWidth / 2;
        };
        this.positionTopRight = () => {
            this.ttTop = this.elTop - this.ttHeight - this.overLappingPX;
            this.ttLeft = this.elLeft;
        };
        this.positionBottomLeft = () => {
            this.ttTop = this.elTop + this.elHeight + this.overLappingPX;
            this.ttLeft = this.elLeft + this.elWidth - this.ttWidth;
        };
        this.positionBottomMiddle = () => {
            this.ttTop = this.elTop + this.elHeight + this.overLappingPX;
            this.ttLeft = this.elLeft + this.elWidth / 2 - this.ttWidth / 2;
        };
        this.positionBottomRight = () => {
            this.ttTop = this.elTop + this.elHeight + this.overLappingPX;
            this.ttLeft = this.elLeft;
        };
        this.doDestroy = () => {
            setTimeout(() => {
                const tooltip = this.tooltipService.findByIndex(this.tooltip.id);
                if (tooltip) {
                    tooltip["popupMouseOut"] = true;
                    this.destroy(tooltip);
                }
            }, 500);
        };
        this.onClick = ($event) => {
            //open new page with tooltip.url
            let url = "";
            if (!/^http[s]?:\/\//.test(this.tooltip.url)) {
                url += "http://";
            }
            url += this.tooltip.url;
            window.open(url, "_blank");
        };
        this.tooltipPosition = this.findPositionEnum(this.recalPositionArray[this.recalPosition]);
    }
    ngAfterViewInit() {
        this.doInit();
        this.doPosition();
    }
    onWindowResize() {
        this.ngAfterViewInit();
    }
    onMouseOver() {
        const tooltip = this.tooltipService.findByIndex(this.tooltip.id);
        if (tooltip) {
            tooltip["popupMouseOut"] = false;
        }
    }
    onMouseLeave() {
        this.doDestroy();
    }
    onWindowScroll($event) {
        this.doDestroy();
    }
    destroy(tooltip) {
        if (tooltip && tooltip["elemMouseOut"] && tooltip["popupMouseOut"]) {
            this.tooltip.ref.nativeElement.setAttribute("tooltip-popup-id", "");
            this.tooltipService.removeTooltip(this.tooltip.id);
        }
    }
}
StatsTooltipContentComponent.ɵfac = function StatsTooltipContentComponent_Factory(t) { return new (t || StatsTooltipContentComponent)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(TooltipService)); };
StatsTooltipContentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StatsTooltipContentComponent, selectors: [["lib-stats-tooltip-content"]], hostBindings: function StatsTooltipContentComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function StatsTooltipContentComponent_resize_HostBindingHandler() { return ctx.onWindowResize(); }, false, i0.ɵɵresolveWindow)("mouseover", function StatsTooltipContentComponent_mouseover_HostBindingHandler() { return ctx.onMouseOver(); })("mouseleave", function StatsTooltipContentComponent_mouseleave_HostBindingHandler() { return ctx.onMouseLeave(); })("scroll", function StatsTooltipContentComponent_scroll_HostBindingHandler($event) { return ctx.onWindowScroll($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { tooltip: "tooltip" }, decls: 2, vars: 2, consts: [[4, "ngIf"], [3, "innerHTML", 4, "ngIf"], [1, "dynamic-stats-tooltip-header", 2, "font-family", "'ciscoSansLight' !important", "color", "red", "font-weight", "100 !important", 3, "innerHTML"], [1, "dynamic-stats-tooltip-desc", 3, "innerHTML"], ["ng-if", "tooltipLink", "class", "dynamic-stats-tooltip-link", 3, "click", 4, "ngIf"], ["ng-if", "tooltipLink", 1, "dynamic-stats-tooltip-link", 3, "click"], [1, "dynamic-stats-tooltip-learnmore"], [3, "innerHTML"]], template: function StatsTooltipContentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, StatsTooltipContentComponent_span_0_Template, 6, 7, "span", 0);
        i0.ɵɵtemplate(1, StatsTooltipContentComponent_span_1_Template, 2, 3, "span", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.tooltip.html);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.tooltip.html);
    } }, directives: [i1$2.NgIf], pipes: [SafeHtmlPipe], styles: ["[_nghost-%COMP%]{border-bottom:3px solid #565659}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StatsTooltipContentComponent, [{
        type: Component,
        args: [{
                selector: "lib-stats-tooltip-content",
                templateUrl: "./stats-tooltip-content.component.html",
                styleUrls: ["./stats-tooltip-content.component.scss"]
            }]
    }], function () { return [{ type: i0.ViewContainerRef }, { type: i0.ElementRef }, { type: TooltipService }]; }, { tooltip: [{
            type: Input
        }], onWindowResize: [{
            type: HostListener,
            args: ["window:resize"]
        }], onMouseOver: [{
            type: HostListener,
            args: ["mouseover"]
        }], onMouseLeave: [{
            type: HostListener,
            args: ["mouseleave"]
        }], onWindowScroll: [{
            type: HostListener,
            args: ["window:scroll", ["$event"]]
        }] }); })();

function StatsTooltipContainerComponent_lib_stats_tooltip_content_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-stats-tooltip-content", 2);
} if (rf & 2) {
    const tooltip_r1 = ctx.$implicit;
    i0.ɵɵproperty("tooltip", tooltip_r1);
} }
class StatsTooltipContainerComponent {
    constructor(tooltipService, dataService) {
        this.tooltipService = tooltipService;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.loginstatus = new EventEmitter();
    }
    ngOnInit() {
        console.log("inside stats tooltip container component");
        this.dataService.getLoggedIn(this.unsubscribe$)
            .subscribe((value) => {
            if (value != null && value != undefined) {
                this.loginStatusForTimeOut = value;
                this.loginstatus.emit(this.loginStatusForTimeOut);
            }
        });
        if (this.loginStatusForTimeOut == false) {
            this.loginStatusForTimeOut = this.dataService.getAccessToken() != null;
        }
        this.loginstatus.emit(this.loginStatusForTimeOut);
        console.log('received the event at loginBaseComponent - ', this.loginStatusForTimeOut);
    }
}
StatsTooltipContainerComponent.ɵfac = function StatsTooltipContainerComponent_Factory(t) { return new (t || StatsTooltipContainerComponent)(i0.ɵɵdirectiveInject(TooltipService), i0.ɵɵdirectiveInject(DataService)); };
StatsTooltipContainerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StatsTooltipContainerComponent, selectors: [["lib-stats-tooltip-container"]], outputs: { loginstatus: "loginstatus" }, decls: 2, vars: 1, consts: [["id", "stats-tooltip-container", 1, "stats-tooltip-container"], ["class", "dynamic-stats-tooltip visibility-hidden", 3, "tooltip", 4, "ngFor", "ngForOf"], [1, "dynamic-stats-tooltip", "visibility-hidden", 3, "tooltip"]], template: function StatsTooltipContainerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, StatsTooltipContainerComponent_lib_stats_tooltip_content_1_Template, 1, 1, "lib-stats-tooltip-content", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.tooltipService.getComponents());
    } }, directives: [i1$2.NgForOf, StatsTooltipContentComponent], styles: [".stats-tooltip-container[_ngcontent-%COMP%]{position:absolute;top:0px;left:0px}.dynamic-stats-tooltip[_ngcontent-%COMP%]:before, .dynamic-stats-tooltip[_ngcontent-%COMP%]:after{position:absolute;content:\"\";width:0;height:0;border-width:8px!important;border-color:#565659 transparent transparent transparent;background-color:transparent}.dynamic-stats-tooltip.arrow-top-left[_ngcontent-%COMP%]:before{left:2%;bottom:100%;border-bottom:14px solid #58595b!important;border-left:14px solid transparent;border-right:14px solid transparent;z-index:101}.dynamic-stats-tooltip.arrow-top-left[_ngcontent-%COMP%]:after{left:2%;margin-left:-1px;bottom:97%;border-bottom:15px solid rgba(0,0,0,.5);border-left:15px solid transparent;border-right:15px solid transparent;z-index:100}.dynamic-stats-tooltip.arrow-top-middle[_ngcontent-%COMP%]:before{left:8%;transform:translate(-50%);bottom:97%;border-bottom:14px solid #58595b!important;border-left:14px solid transparent;border-right:14px solid transparent;z-index:101}.dynamic-stats-tooltip.arrow-top-middle[_ngcontent-%COMP%]:after{left:8%;transform:translate(-50%);bottom:100%;border-bottom:15px solid rgba(0,0,0,.5);border-left:15px solid transparent;border-right:15px solid transparent;z-index:100}.dynamic-stats-tooltip.arrow-top-right[_ngcontent-%COMP%]:before{right:2%;bottom:100%;border-bottom:14px solid #58595b!important;border-left:14px solid transparent;border-right:14px solid transparent;z-index:101}.dynamic-stats-tooltip.arrow-top-right[_ngcontent-%COMP%]:after{right:2%;margin-right:-1px;bottom:100%;border-bottom:15px solid rgba(0,0,0,.5);border-left:15px solid transparent;border-right:15px solid transparent;z-index:100}.dynamic-stats-tooltip.arrow-right-top[_ngcontent-%COMP%]:before{top:2%;left:100%;border-left:14px solid #58595b!important;border-top:14px solid transparent;border-bottom:14px solid transparent;z-index:101}.dynamic-stats-tooltip.arrow-right-top[_ngcontent-%COMP%]:after{top:2%;margin-top:-1px;left:100%;border-left:15px solid rgba(0,0,0,.5);border-top:15px solid transparent;border-bottom:15px solid transparent;z-index:100}.dynamic-stats-tooltip.arrow-right-middle[_ngcontent-%COMP%]:before{top:50%;transform:translateY(-50%);left:100%;border-left:14px solid #58595b!important;border-top:14px solid transparent;border-bottom:14px solid transparent;z-index:101}.dynamic-stats-tooltip.arrow-right-middle[_ngcontent-%COMP%]:after{top:50%;transform:translateY(-50%);left:100%;border-left:15px solid rgba(0,0,0,.5);border-top:15px solid transparent;border-bottom:15px solid transparent;z-index:100}.dynamic-stats-tooltip.arrow-right-bottom[_ngcontent-%COMP%]:before{bottom:2%;left:100%;border-left:14px solid #58595b!important;border-top:14px solid transparent;border-bottom:14px solid transparent;z-index:101}.dynamic-stats-tooltip.arrow-right-bottom[_ngcontent-%COMP%]:after{bottom:2%;margin-bottom:-1px;left:100%;border-left:15px solid rgba(0,0,0,.5);border-top:15px solid transparent;border-bottom:15px solid transparent;z-index:100}.dynamic-stats-tooltip.arrow-bottom-right[_ngcontent-%COMP%]:before{right:2%;top:100%;border-top:14px solid #58595b!important;border-left:14px solid transparent;border-right:14px solid transparent;z-index:101}.dynamic-stats-tooltip.arrow-bottom-right[_ngcontent-%COMP%]:after{right:2%;margin-right:-1px;top:100%;border-top:15px solid rgba(0,0,0,.5);border-left:15px solid transparent;border-right:15px solid transparent;z-index:100}.dynamic-stats-tooltip.arrow-bottom-middle[_ngcontent-%COMP%]:before{left:50%;transform:translate(-50%);top:100%;border-top:14px solid #58595b!important;border-left:14px solid transparent;border-right:14px solid transparent;z-index:101}.dynamic-stats-tooltip.arrow-bottom-middle[_ngcontent-%COMP%]:after{left:50%;transform:translate(-50%);top:100%;border-top:15px solid rgba(0,0,0,.5);border-left:15px solid transparent;border-right:15px solid transparent;z-index:100}.dynamic-stats-tooltip.arrow-bottom-left[_ngcontent-%COMP%]:before{left:2%;top:100%;border-top:14px solid #58595b!important;border-left:14px solid transparent;border-right:14px solid transparent;z-index:101}.dynamic-stats-tooltip.arrow-bottom-left[_ngcontent-%COMP%]:after{left:2%;margin-left:-1px;top:100%;border-top:15px solid rgba(0,0,0,.5);border-left:15px solid transparent;border-right:15px solid transparent;z-index:100}.dynamic-stats-tooltip.arrow-left-top[_ngcontent-%COMP%]:before{top:2%;right:100%;border-right:14px solid #58595b!important;border-top:14px solid transparent;border-bottom:14px solid transparent;z-index:101}.dynamic-stats-tooltip.arrow-left-top[_ngcontent-%COMP%]:after{top:2%;margin-top:-1px;right:100%;border-right:15px solid rgba(0,0,0,.5);border-top:15px solid transparent;border-bottom:15px solid transparent;z-index:100}.dynamic-stats-tooltip.arrow-left-middle[_ngcontent-%COMP%]:before{top:50%;transform:translateY(-50%);right:100%;border-right:14px solid #58595b!important;border-top:14px solid transparent;border-bottom:14px solid transparent;z-index:101}.dynamic-stats-tooltip.arrow-left-middle[_ngcontent-%COMP%]:after{top:50%;transform:translateY(-50%);right:100%;border-right:14px solid #58595b rgba(0,0,0,.5);border-right:15px solid;border-top:15px solid transparent;border-bottom:15px solid transparent;z-index:100}.dynamic-stats-tooltip.arrow-left-bottom[_ngcontent-%COMP%]:before{bottom:2%;right:100%;border-right:14px solid #58595b!important;border-top:14px solid transparent;border-bottom:14px solid transparent;z-index:101}.dynamic-stats-tooltip.arrow-left-bottom[_ngcontent-%COMP%]:after{bottom:2%;margin-bottom:-1px;right:100%;border-right:15px solid rgba(0,0,0,.5);border-top:15px solid transparent;border-bottom:15px solid transparent;z-index:100}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StatsTooltipContainerComponent, [{
        type: Component,
        args: [{
                selector: "lib-stats-tooltip-container",
                templateUrl: "./stats-tooltip-container.component.html",
                styleUrls: ["./stats-tooltip-container.component.scss"]
            }]
    }], function () { return [{ type: TooltipService }, { type: DataService }]; }, { loginstatus: [{
            type: Output
        }] }); })();

class TableChart {
    constructor() {
        this.headers = [];
        this.tableData = [];
        this.show = -1;
        this.column = 3;
    }
}

function TableChartComponent_div_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const header_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", header_r2, " ");
} }
function TableChartComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, TableChartComponent_div_3_ng_template_1_Template, 1, 1, "ng-template", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r3 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r3 < ctx_r0.column);
} }
function TableChartComponent_div_4_ng_template_1_div_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const content_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", content_r11, " ");
} }
function TableChartComponent_div_4_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, TableChartComponent_div_4_ng_template_1_div_0_ng_template_1_Template, 1, 1, "ng-template", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const j_r12 = ctx.index;
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", j_r12 < ctx_r10.column);
} }
function TableChartComponent_div_4_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, TableChartComponent_div_4_ng_template_1_div_0_Template, 2, 1, "div", 8);
} if (rf & 2) {
    const data_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngForOf", data_r6);
} }
function TableChartComponent_div_4_ng_template_2_div_0_ng_template_1_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const content_r17 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" ", content_r17, " ");
} }
function TableChartComponent_div_4_ng_template_2_div_0_ng_template_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const content_r17 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" ", content_r17, " ");
} }
function TableChartComponent_div_4_ng_template_2_div_0_ng_template_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const content_r17 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" From ", content_r17.length, " Rules ");
} }
function TableChartComponent_div_4_ng_template_2_div_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, TableChartComponent_div_4_ng_template_2_div_0_ng_template_1_ng_template_0_Template, 1, 1, "ng-template", 6);
    i0.ɵɵtemplate(1, TableChartComponent_div_4_ng_template_2_div_0_ng_template_1_ng_template_1_Template, 1, 1, "ng-template", 6);
    i0.ɵɵtemplate(2, TableChartComponent_div_4_ng_template_2_div_0_ng_template_1_ng_template_2_Template, 1, 1, "ng-template", 6);
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext();
    const j_r18 = ctx_r26.index;
    const content_r17 = ctx_r26.$implicit;
    i0.ɵɵproperty("ngIf", j_r18 !== 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", j_r18 === 1 && content_r17.length === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", j_r18 === 1 && content_r17.length > 1);
} }
function TableChartComponent_div_4_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, TableChartComponent_div_4_ng_template_2_div_0_ng_template_1_Template, 3, 3, "ng-template", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const j_r18 = ctx.index;
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", j_r18 < ctx_r16.column);
} }
function TableChartComponent_div_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, TableChartComponent_div_4_ng_template_2_div_0_Template, 2, 1, "div", 8);
} if (rf & 2) {
    const data_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngForOf", data_r6);
} }
function TableChartComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, TableChartComponent_div_4_ng_template_1_Template, 1, 1, "ng-template", 6);
    i0.ɵɵtemplate(2, TableChartComponent_div_4_ng_template_2_Template, 1, 1, "ng-template", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r7 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r7 < ctx_r1.show && ctx_r1.reportType !== "VISITOR_BEHAVIOUR_TAGS");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r7 < ctx_r1.show && ctx_r1.reportType === "VISITOR_BEHAVIOUR_TAGS");
} }
class TableChartComponent {
    constructor() {
        this.headers = [];
        this.tableData = [];
    }
    ngOnInit() {
        console.log("inside table chart component");
    }
    set setData(value) {
        if (!value.tableData && value.tableData.length > 0)
            return;
        this.headers = value.headers;
        this.tableData = value.tableData;
        this.column = value.column;
        this.show = value.show;
        if (value.show == -1)
            this.show = value.tableData.length;
    }
}
TableChartComponent.ɵfac = function TableChartComponent_Factory(t) { return new (t || TableChartComponent)(); };
TableChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TableChartComponent, selectors: [["lib-table-chart"]], inputs: { reportType: "reportType", setData: "setData" }, decls: 5, vars: 2, consts: [[1, "tabular-wrapper"], [1, "table"], [1, "table-row"], ["class", "table-header", 4, "ngFor", "ngForOf"], ["class", "table-row data-row", 4, "ngFor", "ngForOf"], [1, "table-header"], [3, "ngIf"], [1, "table-row", "data-row"], ["class", "table-cell", 4, "ngFor", "ngForOf"], [1, "table-cell"]], template: function TableChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, TableChartComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, TableChartComponent_div_4_Template, 3, 2, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.headers);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.tableData);
    } }, directives: [i1$2.NgForOf, i1$2.NgIf], styles: [".tabular-wrapper[_ngcontent-%COMP%]{overflow-x:auto}.tabular-wrapper[_ngcontent-%COMP%]   .table[_ngcontent-%COMP%]{border-collapse:inherit}.table-header[_ngcontent-%COMP%]{display:table-cell;border:0;border-bottom:1px solid #eaeaea;padding:15px;font-family:ciscoSans;text-align:left;font-size:10px;color:#414f5f;float:none}.table-cell[_ngcontent-%COMP%]{display:table-cell;border:0;border-bottom:1px solid #eaeaea;padding:15px;font-family:ciscoSansRegular;color:#909090;float:none}.data-row[_ngcontent-%COMP%]{font-size:14px}.table-row[_ngcontent-%COMP%]:not(:first-child)   .table-cell[_ngcontent-%COMP%]:first-child{min-width:200px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableChartComponent, [{
        type: Component,
        args: [{
                selector: "lib-table-chart",
                templateUrl: "./table-chart.component.html",
                styleUrls: ["./table-chart.component.css"]
            }]
    }], function () { return []; }, { reportType: [{
            type: Input
        }], setData: [{
            type: Input
        }] }); })();

function TagsDropdownComponent_div_0_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "No Tags");
    i0.ɵɵelementEnd();
} }
function TagsDropdownComponent_div_0_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8.getSelectedValue(tag_r6));
} }
function TagsDropdownComponent_div_0_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, TagsDropdownComponent_div_0_span_3_ng_template_1_Template, 2, 1, "ng-template", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r7 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r7 < 2);
} }
function TagsDropdownComponent_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵlistener("mouseover", function TagsDropdownComponent_div_0_span_4_Template_span_mouseover_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.mouseOver(); })("mouseout", function TagsDropdownComponent_div_0_span_4_Template_span_mouseout_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.mouseOut(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("+", ctx_r4.selectedCheckedTagsKeys.length - 2, " more");
} }
function TagsDropdownComponent_div_0_div_5_span_3_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, ", ");
    i0.ɵɵelementEnd();
} }
function TagsDropdownComponent_div_0_div_5_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, TagsDropdownComponent_div_0_div_5_span_3_span_2_Template, 2, 0, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r14 = ctx.$implicit;
    const i_r15 = ctx.index;
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.getSelectedValue(tag_r14), "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r15 < ctx_r13.selectedCheckedTagsKeys.length - 1);
} }
function TagsDropdownComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "span", 12);
    i0.ɵɵtext(2, "Tags Selected:");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, TagsDropdownComponent_div_0_div_5_span_3_Template, 3, 2, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r5.selectedCheckedTagsKeys)("ngForTrackBy", ctx_r5.customTrackBy);
} }
const _c0$7 = function (a0, a1) { return { "show": a0, "disableFilterByTags": a1 }; };
const _c1$2 = function (a0) { return { "defaultCursor": a0 }; };
function TagsDropdownComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵlistener("click", function TagsDropdownComponent_div_0_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.showDropdown(true); });
    i0.ɵɵtemplate(2, TagsDropdownComponent_div_0_span_2_Template, 2, 0, "span", 4);
    i0.ɵɵtemplate(3, TagsDropdownComponent_div_0_span_3_Template, 2, 1, "span", 5);
    i0.ɵɵtemplate(4, TagsDropdownComponent_div_0_span_4_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, TagsDropdownComponent_div_0_div_5_Template, 4, 2, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$7, ctx_r0.show, ctx_r0.disableTags));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1$2, ctx_r0.disableTags));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedCheckedTagsKeys.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.selectedCheckedTagsKeys)("ngForTrackBy", ctx_r0.customTrackBy);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedCheckedTagsKeys.length > 2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedCheckedTagsKeys.length > 2 && ctx_r0.showOnHover);
} }
function TagsDropdownComponent_div_1_li_17_div_3_input_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 39);
} if (rf & 2) {
    const metaData_r24 = i0.ɵɵnextContext().$implicit;
    const key_r22 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate2("id", "tag-check-", key_r22, "-", metaData_r24["value"], "");
    i0.ɵɵproperty("checked", false);
} }
function TagsDropdownComponent_div_1_li_17_div_3_input_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 39);
} if (rf & 2) {
    const metaData_r24 = i0.ɵɵnextContext().$implicit;
    const key_r22 = i0.ɵɵnextContext().$implicit;
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate2("id", "tag-check-", key_r22, "-", metaData_r24["value"], "");
    i0.ɵɵproperty("checked", ctx_r26.selectedCheckedTags[key_r22 + "~~~" + metaData_r24["value"]]);
} }
function TagsDropdownComponent_div_1_li_17_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵlistener("click", function TagsDropdownComponent_div_1_li_17_div_3_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r33); const metaData_r24 = restoredCtx.$implicit; const key_r22 = i0.ɵɵnextContext().$implicit; const ctx_r31 = i0.ɵɵnextContext(2); return ctx_r31.selectMultipleTags(key_r22, metaData_r24); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, TagsDropdownComponent_div_1_li_17_div_3_input_3_Template, 1, 3, "input", 37);
    i0.ɵɵtemplate(4, TagsDropdownComponent_div_1_li_17_div_3_input_4_Template, 1, 3, "input", 37);
    i0.ɵɵelement(5, "label", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const metaData_r24 = ctx.$implicit;
    const key_r22 = i0.ɵɵnextContext().$implicit;
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(metaData_r24["value"]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r23.selectedCheckedTags[key_r22 + "~~~" + metaData_r24["value"]]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.selectedCheckedTags[key_r22 + "~~~" + metaData_r24["value"]]);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("for", "tag-check-", key_r22, "-", metaData_r24["value"], "");
} }
function TagsDropdownComponent_div_1_li_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "span", 34);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, TagsDropdownComponent_div_1_li_17_div_3_Template, 6, 5, "div", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const key_r22 = ctx.$implicit;
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(key_r22);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r19.tagsObj_searched[key_r22]);
} }
function TagsDropdownComponent_div_1_li_23_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "i", 40);
    i0.ɵɵlistener("click", function TagsDropdownComponent_div_1_li_23_span_1_Template_i_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r40); const tag_r37 = restoredCtx.$implicit; const key_r35 = i0.ɵɵnextContext().$implicit; const ctx_r38 = i0.ɵɵnextContext(2); return ctx_r38.removeLocation(key_r35, tag_r37); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r37 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", tag_r37["value"], " ");
} }
function TagsDropdownComponent_div_1_li_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, TagsDropdownComponent_div_1_li_23_span_1_Template, 3, 1, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const key_r35 = ctx.$implicit;
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r20.selectedTags[key_r35]);
} }
function TagsDropdownComponent_div_1_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelement(1, "span", 42);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "No Tags Selected");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵtext(5, "Select tags from the list to get started.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function TagsDropdownComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "div", 14);
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵtext(4, " Filter by Tags ");
    i0.ɵɵelementStart(5, "span", 17);
    i0.ɵɵlistener("click", function TagsDropdownComponent_div_1_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r42); const ctx_r41 = i0.ɵɵnextContext(); return ctx_r41.closeMetadataPopup(false); });
    i0.ɵɵtext(6, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 18);
    i0.ɵɵelementStart(8, "div", 19);
    i0.ɵɵelementStart(9, "div", 20);
    i0.ɵɵelementStart(10, "form", 21);
    i0.ɵɵelementStart(11, "div", 22);
    i0.ɵɵelement(12, "span", 23);
    i0.ɵɵelementStart(13, "input", 24);
    i0.ɵɵlistener("ngModelChange", function TagsDropdownComponent_div_1_Template_input_ngModelChange_13_listener($event) { i0.ɵɵrestoreView(_r42); const ctx_r43 = i0.ɵɵnextContext(); return ctx_r43.searchTxt = $event; })("keyup", function TagsDropdownComponent_div_1_Template_input_keyup_13_listener($event) { i0.ɵɵrestoreView(_r42); const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.searchTagValue($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 25);
    i0.ɵɵelementStart(15, "div", 26);
    i0.ɵɵelementStart(16, "ul");
    i0.ɵɵtemplate(17, TagsDropdownComponent_div_1_li_17_Template, 4, 2, "li", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 28);
    i0.ɵɵelementStart(19, "p");
    i0.ɵɵtext(20, "Selected Tags");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 29);
    i0.ɵɵelementStart(22, "ul");
    i0.ɵɵtemplate(23, TagsDropdownComponent_div_1_li_23_Template, 2, 1, "li", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(24, TagsDropdownComponent_div_1_div_24_Template, 6, 0, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 31);
    i0.ɵɵelementStart(26, "button", 32);
    i0.ɵɵlistener("click", function TagsDropdownComponent_div_1_Template_button_click_26_listener() { i0.ɵɵrestoreView(_r42); const ctx_r45 = i0.ɵɵnextContext(); return ctx_r45.closeMetadataPopup(false); });
    i0.ɵɵtext(27, " Cancel ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "button", 33);
    i0.ɵɵlistener("click", function TagsDropdownComponent_div_1_Template_button_click_28_listener() { i0.ɵɵrestoreView(_r42); const ctx_r46 = i0.ɵɵnextContext(); return ctx_r46.applyTagsFilter(); });
    i0.ɵɵtext(29, " Apply ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("ngModel", ctx_r1.searchTxt);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.tagKeys);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r1.selectedTagsKeys);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showNoTag);
} }
class TagsDropdownComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.spacesObj = null;
        this.showNoTag = true;
        this.show = false;
        this.isSampleData = false;
        this.showOnHover = false;
        this.disableTags = false;
        this.tagKeys = [];
        this.selectedTagsKeys = [];
        this.selectedTags = {};
        this.backupSelectedTags = "{}";
        this.selectedCheckedTags = {};
        this.selectedCheckedTagsKeys = [];
        this.backupSelectedCheckedTags = "{}";
        this.locationList = [];
        this.isFilteredByTags = false;
        this.showEmitter = new EventEmitter();
        this.applyTagFilter = new EventEmitter();
        this.metricGroup = null;
        this.searchTxt = "";
        this.searchTagValue = ($text) => {
            // console.log("$text", $text, $text.target.value);
            // console.log("$text", this.tagsObj);
            // console.log("$textV", $text, $text.target.value);
            if (!this.searchTxt ||
                this.searchTxt == "" ||
                this.searchTxt.length < 2) {
                this.tagsObj_searched = this.tagsObj;
            }
            else {
                const tagsObj_local = {};
                for (const key in this.tagsObj) {
                    if (this.tagsObj.hasOwnProperty(key)) {
                        let matched = false;
                        const val = this.tagsObj[key];
                        // console.log("tag iterate", key, val);
                        const childArr = [];
                        val.forEach((keyId) => {
                            const keyVal = keyId.value.toLowerCase();
                            if (keyId.value &&
                                keyVal.indexOf(this.searchTxt.toLowerCase()) > -1) {
                                matched = true;
                                console.log("tag iterate", keyId, keyId.value);
                                childArr.push(JSON.parse(JSON.stringify(keyId)));
                            }
                        });
                        if (matched) {
                            tagsObj_local[key] = childArr;
                        }
                    }
                }
                this.tagsObj_searched = tagsObj_local;
                console.log("$text Searched", tagsObj_local);
            }
            this.getKeys(this.tagsObj_searched);
        };
        this.getKeys = (tags) => {
            let keys = [];
            if (tags)
                keys = Object.keys(tags).sort();
            let cityIndex = -1;
            keys.forEach((k, index) => {
                if (k.toLowerCase() == "city" || k.toLowerCase() == "citycode")
                    cityIndex = index;
            });
            if (cityIndex != -1)
                keys.splice(cityIndex, 1);
            this.tagKeys = keys;
        };
        this.showDropdown = (show) => {
            if (!this.disableTags) {
                this.show = !this.show;
                this.showEmitter.emit(this.show);
                if (this.show && this.selectedTagsKeys.length > 0)
                    this.showNoTag = false;
                else
                    this.showNoTag = true;
            }
        };
        this.closeMetadataPopup = (show) => {
            this.show = show;
            this.showEmitter.emit(this.show);
            this.searchTagValue(this.searchTxt);
            this.selectedTags = JSON.parse(this.backupSelectedTags);
            this.selectedTagsKeys = Object.keys(this.selectedTags);
            this.selectedCheckedTags = JSON.parse(this.backupSelectedCheckedTags);
            this.selectedCheckedTagsKeys = Object.keys(this.selectedCheckedTags);
        };
        this.removeLocation = (key, metaData) => {
            this.selectedTags[key] = this.selectedTags[key].filter((item) => item.value !== metaData.value);
            delete this.selectedCheckedTags[key + "~~~" + metaData.value];
            this.selectedCheckedTagsKeys = Object.keys(this.selectedCheckedTags);
            if (Object.keys(this.selectedTags).length == 0) {
                this.showNoTag = true;
            }
            else {
                if (this.selectedTags[key].length == 0)
                    delete this.selectedTags[key];
                else
                    this.selectedTagsKeys = Object.keys(this.selectedTags);
            }
        };
        this.selectMultipleTags = (key, metaData) => {
            this.selectedCheckedTags[key + "~~~" + metaData.value] = this
                .selectedCheckedTags[key + "~~~" + metaData.value]
                ? !this.selectedCheckedTags[key + "~~~" + metaData.value]
                : true;
            if (this.selectedCheckedTags[key + "~~~" + metaData.value]) {
                this.showNoTag = false;
                if (this.selectedTags[key])
                    this.selectedTags[key].push({
                        id: metaData.id,
                        value: metaData.value
                    });
                else
                    this.selectedTags[key] = [
                        { id: metaData.id, value: metaData.value }
                    ];
            }
            else {
                this.selectedTags[key] = this.selectedTags[key].filter((item) => item.value !== metaData.value);
                delete this.selectedCheckedTags[key + "~~~" + metaData.value];
                if (Object.keys(this.selectedTags).length == 0) {
                    this.showNoTag = true;
                }
                else {
                    if (this.selectedTags[key].length == 0)
                        delete this.selectedTags[key];
                }
            }
            // console.log("this.selectedTags :: ", this.selectedTags);
            this.selectedTagsKeys = Object.keys(this.selectedTags);
            this.selectedCheckedTagsKeys = Object.keys(this.selectedCheckedTags);
        };
        this.applyTagsFilter = () => __awaiter(this, void 0, void 0, function* () {
            this.backupSelectedTags = JSON.stringify(this.selectedTags);
            this.backupSelectedCheckedTags = JSON.stringify(this.selectedCheckedTags);
            this.selectedCheckedTagsKeys = Object.keys(this.selectedCheckedTags);
            if (Object.keys(this.selectedTags).length > 0) {
                let selecteTagsLoc = [];
                const seletedTagsList = Object.keys(this.selectedTags);
                if (seletedTagsList.length > 0 && seletedTagsList.length <= 1) {
                    yield seletedTagsList.forEach((metadataKey) => __awaiter(this, void 0, void 0, function* () {
                        const metaArray = this.selectedTags[metadataKey];
                        yield metaArray.forEach((metaObj) => __awaiter(this, void 0, void 0, function* () {
                            const locId = metaObj.id;
                            yield locId.forEach((id) => __awaiter(this, void 0, void 0, function* () {
                                const storedLocation = yield this.dataService.getLocationObject(id);
                                if (storedLocation &&
                                    storedLocation.type == "network") {
                                    selecteTagsLoc.push(id);
                                }
                                else if (storedLocation &&
                                    storedLocation.type != "floor" &&
                                    storedLocation.type != "zone") {
                                    this.getNetworkLocations(this.locationList, selecteTagsLoc, id);
                                }
                            }));
                        }));
                    }));
                }
                else {
                    const selectedMultipleMetaKey = {};
                    yield seletedTagsList.forEach((metadataKey) => __awaiter(this, void 0, void 0, function* () {
                        const metaArray = this.selectedTags[metadataKey];
                        selectedMultipleMetaKey[metadataKey] = [];
                        yield metaArray.forEach((metaObj) => __awaiter(this, void 0, void 0, function* () {
                            const locId = metaObj.id;
                            yield locId.forEach((id) => __awaiter(this, void 0, void 0, function* () {
                                const storedLocation = yield this.dataService.getLocationObject(id);
                                if (storedLocation &&
                                    storedLocation.type == "network") {
                                    selectedMultipleMetaKey[metadataKey].push(id);
                                }
                                else if (storedLocation &&
                                    storedLocation.type != "floor" &&
                                    storedLocation.type != "zone") {
                                    this.getNetworkLocations(this.locationList, selectedMultipleMetaKey[metadataKey], id);
                                }
                            }));
                        }));
                    }));
                    // console.log("selectedMultipleMetaKey :: ",selectedMultipleMetaKey);
                    Object.keys(selectedMultipleMetaKey).forEach((metaKey) => {
                        const locIds = selectedMultipleMetaKey[metaKey];
                        if (selecteTagsLoc.length == 0)
                            selecteTagsLoc = locIds;
                        else
                            selecteTagsLoc = this.getFinalFilteredLocation(selecteTagsLoc, locIds);
                    });
                    // console.log("selecteTagsLoc :: ",selecteTagsLoc);
                }
                // let mergedSelLoc = [];
                // for(var i=0; i<selecteTagsLoc.length; i++)
                //   mergedSelLoc = mergedSelLoc.concat(selecteTagsLoc[i]);
                // console.log("mergedSelLoc :: ",mergedSelLoc);
                if (selecteTagsLoc.length < 15)
                    this.spacesObj["disableReportCategory"] = true;
                else
                    this.spacesObj["disableReportCategory"] = false;
                this.spacesObj["selectedTags"] = this.selectedTags;
                this.spacesObj["selectedTagsLocation"] = selecteTagsLoc;
                if (selecteTagsLoc.length > 1) {
                    let rootLocName = "";
                    let rootLocId = "";
                    let locationType = "";
                    this.dataService.getLocationObjectArray().then((data) => {
                        data.forEach((location) => {
                            if (location["type"] === "root") {
                                rootLocName = location["name"];
                                rootLocId = location["id"];
                                locationType = location["type"];
                            }
                        });
                    });
                    if (rootLocId && rootLocName) {
                        if (this.metricGroup != "realtime") {
                            this.spacesObj["spacesLocation"]["type"] = "all";
                            this.spacesObj["spacesLocation"]["id"] = rootLocId;
                            this.spacesObj["spacesLocation"]["name"] = rootLocName;
                        }
                        else {
                            this.spacesObj["rightNowLocation"]["type"] = "all";
                            this.spacesObj["rightNowLocation"]["id"] = rootLocId;
                            this.spacesObj["rightNowLocation"]["name"] =
                                rootLocName;
                            this.spacesObj["rightNowLocation"]["locationType"] =
                                locationType;
                        }
                    }
                }
            }
            else {
                let rootLocName = "";
                let rootLocId = "";
                const locationType = "";
                this.dataService.getLocationObjectArray().then((data) => {
                    data.forEach((location) => {
                        if (location["type"] === "root") {
                            rootLocName = location["name"];
                            rootLocId = location["id"];
                        }
                    });
                });
                if (this.metricGroup != "realtime") {
                    if (rootLocId && rootLocName) {
                        this.spacesObj["spacesLocation"]["type"] = "all";
                        this.spacesObj["spacesLocation"]["id"] = rootLocId;
                        this.spacesObj["spacesLocation"]["name"] = rootLocName;
                    }
                    delete this.spacesObj["selectedTags"];
                    delete this.spacesObj["selectedTagsLocation"];
                    delete this.spacesObj["disableReportCategory"];
                }
                else {
                    if (rootLocId && rootLocName) {
                        this.spacesObj["rightNowLocation"]["type"] = "all";
                        this.spacesObj["rightNowLocation"]["id"] = rootLocId;
                        this.spacesObj["rightNowLocation"]["name"] = rootLocName;
                        this.spacesObj["rightNowLocation"]["locationType"] =
                            locationType;
                    }
                    delete this.spacesObj["selectedTags"];
                    delete this.spacesObj["selectedTagsLocation"];
                    delete this.spacesObj["disableReportCategory"];
                }
            }
            this.show = false;
            this.showEmitter.emit(this.show);
            this.searchTagValue(this.searchTxt);
            if (this.metricGroup != "realtime") {
                this.dataService.setSpacesObject(this.spacesObj);
            }
            else {
                this.dataService.setRightNowObject(this.spacesObj);
            }
            this.applyTagFilter.emit();
        });
        this.getNetworkLocations = (children, locations, selLocId) => {
            if (children && children.length > 0) {
                children.forEach((item, index) => {
                    if (item.path.indexOf(selLocId) != -1 &&
                        item.type == "network") {
                        locations.push(item.id);
                    }
                    this.getNetworkLocations(item.children, locations, selLocId);
                });
            }
        };
        this.getSelectedTagKeys = () => {
            return Object.keys(this.selectedCheckedTags);
        };
        this.getSelectedValue = (selectedTag) => {
            return selectedTag.split("~~~")[1].trim();
        };
        this.mouseOver = () => {
            this.showOnHover = true;
            $(".tags-on-hover").fadeIn(500);
        };
        this.mouseOut = () => {
            this.showOnHover = false;
            $(".tags-on-hover").fadeOut(500);
        };
    }
    set showDummyReport($event) {
        this.showDummyData = $event;
        this.disableTags = $event;
    }
    ngOnInit() {
        this.dataService
            .getShowBITags(this.unsubscribe$)
            .subscribe((val) => {
            this.isFilteredByTags = val;
        });
        if (this.metricGroup != "realtime") {
            this.dataService
                .getSpacesObject(this.unsubscribe$)
                .subscribe((spacesObj) => {
                if (spacesObj != null &&
                    spacesObj["spacesLocation"] != null) {
                    if (this.isFilteredByTags ||
                        spacesObj["spacesLocation"].type == "all")
                        this.disableTags = false;
                    else
                        this.disableTags = true;
                    if (spacesObj["selectedTags"] &&
                        Object.keys(spacesObj["selectedTags"]).length > 0) {
                        this.selectedTags = spacesObj["selectedTags"];
                        this.selectedTagsKeys = Object.keys(this.selectedTags);
                        this.backupSelectedTags = JSON.stringify(this.selectedTags);
                        this.showNoTag = false;
                        this.setSelecetdTags();
                        this.backupSelectedCheckedTags = JSON.stringify(this.selectedCheckedTags);
                    }
                    this.spacesObj = spacesObj;
                }
            });
        }
        else {
            if (this.showDummyData) {
                this.disableTags = true;
            }
            else {
                this.dataService
                    .getRightNowObject(this.unsubscribe$)
                    .subscribe((spacesObj) => {
                    if (spacesObj != null &&
                        spacesObj["rightNowLocation"] != null) {
                        if (this.isFilteredByTags ||
                            spacesObj["rightNowLocation"].type == "all")
                            this.disableTags = false;
                        else
                            this.disableTags = true;
                        if (spacesObj["selectedTags"] &&
                            Object.keys(spacesObj["selectedTags"]).length >
                                0) {
                            this.selectedTags = spacesObj["selectedTags"];
                            this.selectedTagsKeys = Object.keys(this.selectedTags);
                            this.backupSelectedTags = JSON.stringify(this.selectedTags);
                            this.showNoTag = false;
                            this.setSelecetdTags();
                            this.backupSelectedCheckedTags = JSON.stringify(this.selectedCheckedTags);
                        }
                        this.spacesObj = spacesObj;
                    }
                });
            }
        }
        this.dataService
            .getIsSampleData(this.unsubscribe$)
            .subscribe((isSampleData) => {
            if (isSampleData !== null) {
                setTimeout(() => {
                    this.isSampleData = isSampleData;
                });
            }
        });
    }
    set tags(value) {
        if (value && Object.keys(value).length > 0) {
            this.tagsObj = value;
            this.searchTagValue(this.searchTxt);
        }
    }
    set locationTreeArray(value) {
        if (value && value.location) {
            this.locationList = value.location;
        }
    }
    setSelecetdTags() {
        this.selectedTagsKeys.forEach((selMetaDataKey) => {
            this.selectedTags[selMetaDataKey].forEach((selMetaValue) => {
                this.selectedCheckedTags[selMetaDataKey + "~~~" + selMetaValue.value] = true;
            });
        });
        this.selectedCheckedTagsKeys = Object.keys(this.selectedCheckedTags);
    }
    customTrackBy(index, obj) {
        return index;
    }
    getFinalFilteredLocation(locationObj, tagsLocation) {
        const finalLocResult = tagsLocation.filter(function (o1) {
            // filter out (!) items in result2
            return locationObj.some(function (o2) {
                return o1 === o2; // assumes unique id
            });
        });
        return finalLocResult;
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
TagsDropdownComponent.ɵfac = function TagsDropdownComponent_Factory(t) { return new (t || TagsDropdownComponent)(i0.ɵɵdirectiveInject(DataService)); };
TagsDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TagsDropdownComponent, selectors: [["lib-tags-dropdown"]], inputs: { metricGroup: "metricGroup", showDummyReport: "showDummyReport", tags: "tags", locationTreeArray: "locationTreeArray" }, outputs: { showEmitter: "showEmitter", applyTagFilter: "applyTagFilter" }, decls: 2, vars: 2, consts: [["class", "dropdownContainer", 3, "ngClass", 4, "ngIf"], ["class", "modalPopup modalPopupLg tagsPopup", 4, "ngIf"], [1, "dropdownContainer", 3, "ngClass"], [1, "selectedTags", "rn-tags", 3, "ngClass", "click"], [4, "ngIf"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "moreTags", 3, "mouseover", "mouseout", 4, "ngIf"], ["class", "tags-on-hover", 4, "ngIf"], [3, "ngIf"], [1, "selTagsInDD"], [1, "moreTags", 3, "mouseover", "mouseout"], [1, "tags-on-hover"], [1, "selected-tag-title"], [1, "modalPopup", "modalPopupLg", "tagsPopup"], [1, "modalOverlay"], [1, "modalContent"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], [1, "tagsData"], [1, "searchBarDiv", "searchSlide"], ["autocomplete", "off", "novalidate", "", 1, "ng-untouched", "ng-pristine", "ng-valid"], [1, "tag-search-container"], ["id", "tag-search-icon"], ["name", "blahblah", "type", "text", "placeholder", "Search Tags", 1, "searchInput", 3, "ngModel", "ngModelChange", "keyup"], [1, "tagsSelection"], [1, "tagsList"], [4, "ngFor", "ngForOf"], [1, "selected-tags-list"], [1, "selected-tags"], ["class", "no-tags", 4, "ngIf"], [1, "modalFooter"], [1, "commonButton", 3, "click"], [1, "primaryButton", 3, "click"], [1, "tag-key"], ["class", "tag-list", 3, "click", 4, "ngFor", "ngForOf"], [1, "tag-list", 3, "click"], ["type", "checkbox", "name", "tagCheckbox", 3, "checked", "id", 4, "ngIf"], [1, "tag-label", 3, "for"], ["type", "checkbox", "name", "tagCheckbox", 3, "checked", "id"], [1, "close-tag", "pointer", 3, "click"], [1, "no-tags"], ["id", "no-tag-image"]], template: function TagsDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, TagsDropdownComponent_div_0_Template, 6, 12, "div", 0);
        i0.ɵɵtemplate(1, TagsDropdownComponent_div_1_Template, 30, 4, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.tagsObj);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.show);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i1$2.NgForOf, i2$1.ɵNgNoValidate, i2$1.NgControlStatusGroup, i2$1.NgForm, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel], styles: ["@charset \"UTF-8\";.dropdownContainer[_ngcontent-%COMP%]{display:block;width:100%;position:relative}.selectedTags[_ngcontent-%COMP%]{border:1px solid transparent;border-bottom:1px solid rgba(0,0,0,.1);background-color:#fff;border-radius:0;color:#7f7f86;padding:4px 20px 10px 10px;font-size:14px;font-family:\"ciscoSansRegular\";position:relative;cursor:pointer;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.rn-tags[_ngcontent-%COMP%]{font-size:12px;font-family:ciscoSansLight}.selectedTags[_ngcontent-%COMP%]:before{position:absolute;right:10px;top:6px;font-family:\"icomoon-new\";content:\"\\e905\";font-size:14px;color:#bbb}.selectedTags.greenBg[_ngcontent-%COMP%]{background-color:#03b88c}.tagsPopup[_ngcontent-%COMP%]   .modalHeader[_ngcontent-%COMP%]{text-align:center;color:#565659;font-family:CiscoSans;font-size:24px}.selected-tags-list[_ngcontent-%COMP%]{width:49%;padding:0 10px 10px 0;float:right;height:300px;overflow-y:auto}.tagsList[_ngcontent-%COMP%]{height:300px;border:1px solid #e9e9e9;overflow-y:auto;text-transform:capitalize;width:50%;display:inline-block}.tagsPopup[_ngcontent-%COMP%]   .modalContent[_ngcontent-%COMP%]{border-radius:2px;box-shadow:0 1px 3px #b1b1b140;width:70%!important}.tag-search-container[_ngcontent-%COMP%]{position:relative;margin-bottom:10px}.tag-search-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{margin-bottom:0;text-indent:30px;border-bottom:1px solid #a7a9ab!important;width:47%!important}#tag-search-icon[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/search_dropdown.svg);width:24px;height:24px;display:inline-block;background-repeat:no-repeat;background-position:center;vertical-align:middle;position:absolute;bottom:0;top:0;margin:auto}.tagsList[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{color:#9d9d9d;font-family:CiscoSans;font-size:10px}.tag-list[_ngcontent-%COMP%]{padding:12px 0;position:relative}.tagsList[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0 0 0 15px}.tag-list[_ngcontent-%COMP%]:hover{background-color:#f5f5f5;cursor:pointer}.tag-list[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;color:#58585b;font-size:14px}.tag-list[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{vertical-align:middle;float:right;margin-right:30px;opacity:0}label.tag-label[_ngcontent-%COMP%]{position:absolute;right:30px}label.tag-label[_ngcontent-%COMP%]:before{content:\"\";width:20px;height:20px;vertical-align:middle;float:right;margin-right:0}.tag-list[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:checked ~ label.tag-label[_ngcontent-%COMP%]:before{background:url(../../../../../assets/images/business/tick-mark.svg)}.tag-key[_ngcontent-%COMP%]{padding-bottom:10px}.tagsPopup[_ngcontent-%COMP%]   .commonButton[_ngcontent-%COMP%]{color:#049fd9;border:0 none;font-family:CiscoSans!important;font-size:14px}#no-tag-image[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/no-tag-selected.svg);width:120px;height:120px;display:block;margin:auto auto 30px}.selected-tags[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0}.selected-tags[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-radius:3px;background-color:#f6f6f6;padding:5px 8px;margin-right:10px;margin-bottom:10px;display:inline-block}.no-tags[_ngcontent-%COMP%]{text-align:center}.no-tags[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:24px;line-height:1.25;letter-spacing:.5px;color:#58585b}.no-tags[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#565659;font-family:CiscoSans;line-height:1.43;letter-spacing:.5px}.close-tag[_ngcontent-%COMP%]{background:url(../../../../../assets/images/business/popup_close.svg);width:9px;height:9px;display:inline-block;background-repeat:no-repeat;background-position:center;margin-left:20px}.selected-tags-list[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:12px;color:#626469;margin:0}.tagsPopup[_ngcontent-%COMP%]   .modalFooter[_ngcontent-%COMP%]{border:0 none!important;text-align:center}.selTagsInDD[_ngcontent-%COMP%]{background-color:#f6f6f6;display:inline-block;margin-right:10px}.moreTags[_ngcontent-%COMP%]{color:#869ad6;background-color:#f6f6f6;display:inline-block}.tags-on-hover[_ngcontent-%COMP%]{background-color:#fff;padding:10px;border:1px solid #d7d9da;position:absolute;width:90%;left:0;right:0;margin:8px auto auto}.tags-on-hover[_ngcontent-%COMP%]:before{background:url(../../../../../assets/images/business/tooltip_arrow_up.svg);content:\"\";position:absolute;top:-12px;right:25px;width:20px;height:12px;background-position:center}.tags-on-hover[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px;font-family:CiscoSans;color:#58585b;letter-spacing:.58px;line-height:20px;display:inline-block;margin-right:5px}.selected-tag-title[_ngcontent-%COMP%]{display:block!important}.disableFilterByTags[_ngcontent-%COMP%]{opacity:.3}.defaultCursor[_ngcontent-%COMP%]{cursor:default!important}", ".spacesListWrapper[_ngcontent-%COMP%]{margin-top:60px;padding:40px 5%}.selectedItem[_ngcontent-%COMP%]{border:1px solid transparent;border-bottom:1px solid rgba(0,0,0,.1);background-color:#fff;border-radius:0;color:#7f7f86;padding:10px 20px 10px 10px;font-size:14px;font-family:\"ciscoSansRegular\";position:relative;cursor:pointer;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.selectedItem[_ngcontent-%COMP%]:before{position:absolute;right:10px;top:12px;font-family:\"icomoon-new\";content:\"\\e905\";font-size:14px;color:#bbb}.show[_ngcontent-%COMP%]   .selectedItem[_ngcontent-%COMP%]:before{content:\"\\e908\"}.itemName[_ngcontent-%COMP%]{width:90%;display:inline-block;cursor:pointer}.dropdownList[_ngcontent-%COMP%]{position:absolute;width:100%;top:100%;margin-top:5px;border-radius:0;max-height:200px;overflow-y:auto;box-shadow:0 0 8px -2px #00000080}.list[_ngcontent-%COMP%]{position:relative}.listItem[_ngcontent-%COMP%]{font-size:14px;color:#999;font-family:\"Roboto-Regular\";background-color:#fff;padding:10px 20px 10px 10px;cursor:pointer}.listItem.selected[_ngcontent-%COMP%]{background-color:#f5f5f5}.listItem[_ngcontent-%COMP%]:hover{background-color:#eee}.listItem.selected[_ngcontent-%COMP%]:before{position:absolute;right:0;top:0;width:20px;height:auto;font-size:24px;content:\"\\e93b\";font-family:\"icomoon-new\";padding:4px 10px;color:#467fad;text-align:center}.monthPicker[_ngcontent-%COMP%], .yearPicker[_ngcontent-%COMP%], .quarterPicker[_ngcontent-%COMP%]{position:relative}.dropdownOverlay[_ngcontent-%COMP%]{position:fixed;left:0;top:0;width:100%;height:100%;background-color:#0000001a;z-index:100;display:none}.show[_ngcontent-%COMP%]   .dropdownOverlay[_ngcontent-%COMP%]{display:block}.dropdownList[_ngcontent-%COMP%]{z-index:101}.yearPickerWrapper[_ngcontent-%COMP%]{padding:10px;display:table;width:100%;background:#fff;border-bottom:1px solid #dddfe2}.yearPickerWrapper[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:table-cell;text-align:center}.yearPickerWrapper[_ngcontent-%COMP%] > .year[_ngcontent-%COMP%]{color:#999;width:calc(100% - 40px)}.yearPickerWrapper[_ngcontent-%COMP%] > .prev[_ngcontent-%COMP%], .yearPickerWrapper[_ngcontent-%COMP%] > .next[_ngcontent-%COMP%]{width:20px;height:20px;background-color:#f5f5f5;color:#999;font-family:\"icomoon-new\";font-size:14px;padding:5px;cursor:pointer}.yearPickerWrapper[_ngcontent-%COMP%] > .prev[_ngcontent-%COMP%]{content:\"\\e906\"}.yearPickerWrapper[_ngcontent-%COMP%] > .next[_ngcontent-%COMP%]{content:\"\\e907\"}.yearPickerWrapper[_ngcontent-%COMP%] > .prev.disabledYear[_ngcontent-%COMP%], .yearPickerWrapper[_ngcontent-%COMP%] > .next.disabledYear[_ngcontent-%COMP%]{cursor:not-allowed;pointer-events:none;background-color:#ccc}.retailMetricHeading[_ngcontent-%COMP%]{font-size:22px;font-family:\"Roboto-Regular\";font-weight:normal;margin-top:10px;margin-bottom:15px;padding-left:20px}.retailMetric[_ngcontent-%COMP%]{margin-bottom:20px}.metricList[_ngcontent-%COMP%]{display:table;width:100%;margin-top:40px}.retailMetricContainer[_ngcontent-%COMP%]{display:table-cell;width:100%;vertical-align:top}.buildingMetricContainer[_ngcontent-%COMP%]{display:table-cell;width:40%;vertical-align:top;padding-left:20px}.spacesOverviewTabs[_ngcontent-%COMP%]{position:absolute;top:50px;left:0;width:100%;height:50px;display:table;background-color:#fff;box-shadow:0 2px 2px #0000000d}.spacesOverviewTabs[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:table-cell}.selectedOvTab[_ngcontent-%COMP%]{width:80%;background-color:#fff;padding:10px 30px 10px 7%;font-family:\"Roboto-Medium\";font-size:22px;font-weight:500;color:#1d3243}.otherOvTab[_ngcontent-%COMP%]{width:20%;padding:10px 30px 10px 50px;background-color:#e9e9e9;vertical-align:middle;font-family:\"Roboto-Regular\";font-size:22px;color:#6b6b6b99;cursor:pointer;position:relative}.otherOvTab[_ngcontent-%COMP%]:before{position:absolute;top:0;right:90%;width:40px;height:100%;background-color:#fff;box-shadow:2px 0 #0000000d;transform:skew(-25deg);content:\"\";border-bottom-right-radius:40%}.dropdownList[_ngcontent-%COMP%]   .searchBarDiv[_ngcontent-%COMP%]   .searchInputIcon[_ngcontent-%COMP%]{position:absolute;left:5px;top:2px;padding-top:10px;width:14px;height:auto}.dropdownList[_ngcontent-%COMP%]   .searchBarDiv[_ngcontent-%COMP%]   input.searchInput[_ngcontent-%COMP%]{width:100%;padding-left:25px;padding-right:100px;border:none;border-bottom:1px solid #dddfe2;border-radius:0;margin-bottom:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TagsDropdownComponent, [{
        type: Component,
        args: [{
                selector: "lib-tags-dropdown",
                templateUrl: "./tags-dropdown.component.html",
                styleUrls: [
                    "./tags-dropdown.component.scss",
                    "../../common/spaces.component.css"
                ]
            }]
    }], function () { return [{ type: DataService }]; }, { showEmitter: [{
            type: Output
        }], applyTagFilter: [{
            type: Output
        }], metricGroup: [{
            type: Input
        }], showDummyReport: [{
            type: Input
        }], tags: [{
            type: Input
        }], locationTreeArray: [{
            type: Input
        }] }); })();

function TeamGenericDropdownComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r0.emptyStateText, i0.ɵɵsanitizeHtml);
} }
function TeamGenericDropdownComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r1.selectedItem, i0.ɵɵsanitizeHtml);
} }
function TeamGenericDropdownComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r2.emptyStateText, i0.ɵɵsanitizeHtml);
} }
function TeamGenericDropdownComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r3.selectedItem, i0.ɵɵsanitizeHtml);
} }
function TeamGenericDropdownComponent_li_12_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 10);
    i0.ɵɵlistener("click", function TeamGenericDropdownComponent_li_12_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r8); const item_r6 = restoredCtx.$implicit; const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.itemSelected(item_r6); });
    i0.ɵɵelement(1, "span", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", item_r6, i0.ɵɵsanitizeHtml);
} }
function TeamGenericDropdownComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵlistener("click", function TeamGenericDropdownComponent_div_13_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.genericBtnClicked(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", ctx_r5.genericBtnText, i0.ɵɵsanitizeHtml);
} }
const _c0$6 = function (a0, a1) { return { "hidden-d": a0, "visible-d": a1 }; };
const jQuery$1 = jQuery_;
class TeamGenericDropdownComponent {
    constructor() {
        this.emitGenericBtn = new EventEmitter();
        this.emitSelectedItem = new EventEmitter();
        this.isExpanded = false;
        this.emptyStateText = "- Select -";
        this.genericBtnText = null;
        this.itemSelected = (item) => {
            this.selectedItem = item;
            this.emitSelectedItem.emit(this.selectedItem);
        };
        this.genericBtnClicked = () => {
            this.emitGenericBtn.emit(true);
        };
        this.toggleDropDown = () => {
            this.isExpanded = !this.isExpanded;
            this.isExpanded
                ? jQuery$1("#gddExpand").slideDown(100)
                : jQuery$1("#gddExpand").slideUp(100);
        };
    }
    clickout($evt) {
        console.log($evt);
        if (jQuery$1("#gddExpand").is(":visible") &&
            $evt.offsetParent.className != "gdd-wrapper") {
            this.isExpanded = false;
            jQuery$1("#gddExpand").slideUp(200);
        }
    }
    set list(values) {
        this.listItems = values;
    }
    set config(value) {
        this.emptyStateText =
            value.emptyStateText != undefined
                ? value.emptyStateText
                : this.emptyStateText;
        this.genericBtnText =
            value.genericBtnText != undefined ? value.genericBtnText : null;
        if (value.selectedItem != null) {
            this.selectedItem = value.selectedItem;
            setTimeout(() => {
                this.emitSelectedItem.emit(this.selectedItem);
            }, 100);
        }
    }
    ngOnInit() {
        console.log("inside team generic drop down component");
    }
}
TeamGenericDropdownComponent.ɵfac = function TeamGenericDropdownComponent_Factory(t) { return new (t || TeamGenericDropdownComponent)(); };
TeamGenericDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TeamGenericDropdownComponent, selectors: [["lib-team-generic-dropdown"]], hostBindings: function TeamGenericDropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function TeamGenericDropdownComponent_click_HostBindingHandler($event) { return ctx.clickout($event.target); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { list: "list", config: "config" }, outputs: { emitGenericBtn: "emitGenericBtn", emitSelectedItem: "emitSelectedItem" }, decls: 14, vars: 10, consts: [[1, "gdd-wrapper"], [1, "gdd-collapsed", "noselect", 3, "ngClass"], [1, "gdd-selected", 3, "click"], [3, "innerHtml", 4, "ngIf"], [1, "arrow_down"], ["id", "gddExpand", 1, "gdd-expanded", "noselect"], [1, "arrow_up"], [3, "click", 4, "ngFor", "ngForOf"], ["class", "gdd-footer", 4, "ngIf"], [3, "innerHtml"], [3, "click"], [1, "gdd-footer"], [1, "gdd-footer-btn", 3, "innerHtml", "click"]], template: function TeamGenericDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵlistener("click", function TeamGenericDropdownComponent_Template_div_click_2_listener() { return ctx.toggleDropDown(); });
        i0.ɵɵtemplate(3, TeamGenericDropdownComponent_div_3_Template, 1, 1, "div", 3);
        i0.ɵɵtemplate(4, TeamGenericDropdownComponent_div_4_Template, 1, 1, "div", 3);
        i0.ɵɵelement(5, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 2);
        i0.ɵɵlistener("click", function TeamGenericDropdownComponent_Template_div_click_7_listener() { return ctx.toggleDropDown(); });
        i0.ɵɵtemplate(8, TeamGenericDropdownComponent_div_8_Template, 1, 1, "div", 3);
        i0.ɵɵtemplate(9, TeamGenericDropdownComponent_div_9_Template, 1, 1, "div", 3);
        i0.ɵɵelement(10, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "ul");
        i0.ɵɵtemplate(12, TeamGenericDropdownComponent_li_12_Template, 2, 1, "li", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, TeamGenericDropdownComponent_div_13_Template, 2, 1, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$6, ctx.isExpanded, !ctx.isExpanded));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.selectedItem === null || ctx.selectedItem === undefined) && ctx.emptyStateText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedItem !== null);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", (ctx.selectedItem === null || ctx.selectedItem === undefined) && ctx.emptyStateText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedItem !== null);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.listItems);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.genericBtnText !== null);
    } }, directives: [i1$2.NgClass, i1$2.NgIf, i1$2.NgForOf], styles: [".gdd-wrapper[_ngcontent-%COMP%]{width:320px;position:relative}.gdd-selected[_ngcontent-%COMP%]{font-size:14px;color:#6b6b6b;font-family:ciscoSans;padding:15px;cursor:pointer;letter-spacing:1px;display:flex}.gdd-collapsed[_ngcontent-%COMP%]   .gdd-selected[_ngcontent-%COMP%]{border-bottom:1px solid #efefef}.gdd-expanded[_ngcontent-%COMP%]{box-shadow:0 1px 3px 1px #bdbdbd3d;border:1px solid #efefef;display:none;padding:0;margin:0;position:absolute;background:#fff;width:320px;max-height:220px;overflow-y:auto;top:0}.gdd-expanded[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0}.gdd-expanded[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:10px 15px;cursor:pointer;font-size:16px;font-family:ciscoSansLight;color:#1f1f1f}.gdd-expanded[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{background:#efefef}.gdd-expanded[_ngcontent-%COMP%]   .gdd-selected[_ngcontent-%COMP%]{position:sticky;width:320px;background:#fff;border-bottom:1px solid #ececec;padding:15px}.arrow_down[_ngcontent-%COMP%]{background:url(/assets/images/basic/generic/arrow_down.svg) no-repeat;height:20px;width:20px;background-position-y:center;position:absolute;right:0}.arrow_up[_ngcontent-%COMP%]{background:url(/assets/images/basic/generic/arrow_up.svg) no-repeat #fff;height:20px;width:20px;background-position:center;position:absolute;right:5px}.down[_ngcontent-%COMP%]{transform:rotate(90deg)}.hidden-d[_ngcontent-%COMP%]{visibility:hidden}.visible-d[_ngcontent-%COMP%]{visibility:visible}.gdd-footer[_ngcontent-%COMP%]{border-top:1px solid #efefef;padding:10px;display:block;bottom:0;width:100%;background:#fff;position:sticky}.gdd-footer-btn[_ngcontent-%COMP%]{border:1px solid #049fd9;padding:5px;width:230px;color:#049fd9;margin:0 auto;text-align:center;font-family:ciscoSans;font-size:15px;cursor:pointer}.noselect[_ngcontent-%COMP%]{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TeamGenericDropdownComponent, [{
        type: Component,
        args: [{
                selector: "lib-team-generic-dropdown",
                templateUrl: "./team-generic-dropdown.component.html",
                styleUrls: ["./team-generic-dropdown.component.scss"]
            }]
    }], function () { return []; }, { clickout: [{
            type: HostListener,
            args: ["document:click", ["$event.target"]]
        }], list: [{
            type: Input
        }], config: [{
            type: Input
        }], emitGenericBtn: [{
            type: Output
        }], emitSelectedItem: [{
            type: Output
        }] }); })();

function TimePickerComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.fTime);
} }
function TimePickerComponent_span_6_span_1_span_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, ",");
    i0.ɵɵelementEnd();
} }
function TimePickerComponent_span_6_span_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, TimePickerComponent_span_6_span_1_span_1_span_2_Template, 2, 0, "span", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const time_r5 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", time_r5, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.timeArray.length > 1);
} }
function TimePickerComponent_span_6_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, TimePickerComponent_span_6_span_1_span_1_Template, 3, 2, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.timeArray);
} }
function TimePickerComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtemplate(1, TimePickerComponent_span_6_span_1_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.timeArray.length > 0);
} }
function TimePickerComponent_div_7_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtext(1, "SELECT TIME");
    i0.ɵɵelementEnd();
} }
function TimePickerComponent_div_7_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵtext(1, " Please enter a valid time");
    i0.ɵɵelementEnd();
} }
function TimePickerComponent_div_7_div_21_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelementStart(1, "span", 33);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 34);
    i0.ɵɵlistener("click", function TimePickerComponent_div_7_div_21_div_6_Template_span_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r13); const item_r11 = restoredCtx.$implicit; const ctx_r12 = i0.ɵɵnextContext(3); return ctx_r12.removeTime(item_r11); });
    i0.ɵɵtext(4, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r11 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r11);
} }
function TimePickerComponent_div_7_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "div", 28);
    i0.ɵɵlistener("click", function TimePickerComponent_div_7_div_21_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.addTime(); });
    i0.ɵɵtext(2, "+");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 29);
    i0.ɵɵtext(4, "Click \u2018+\u2019 button to add multiple times");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 30);
    i0.ɵɵtemplate(6, TimePickerComponent_div_7_div_21_div_6_Template, 5, 1, "div", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r9.timeArray);
} }
function TimePickerComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, TimePickerComponent_div_7_span_1_Template, 2, 0, "span", 13);
    i0.ɵɵtemplate(2, TimePickerComponent_div_7_span_2_Template, 2, 0, "span", 14);
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵelementStart(5, "div", 17);
    i0.ɵɵlistener("click", function TimePickerComponent_div_7_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.timeChanged("h", "i"); });
    i0.ɵɵtext(6, " \uE908 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "input", 18);
    i0.ɵɵlistener("ngModelChange", function TimePickerComponent_div_7_Template_input_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.fHour = $event; })("blur", function TimePickerComponent_div_7_Template_input_blur_7_listener() { i0.ɵɵrestoreView(_r17); const ctx_r19 = i0.ɵɵnextContext(); return ctx_r19.timeChanged("h", "a"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 17);
    i0.ɵɵlistener("click", function TimePickerComponent_div_7_Template_div_click_8_listener() { i0.ɵɵrestoreView(_r17); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.timeChanged("h", "d"); });
    i0.ɵɵtext(9, " \uE905 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 19);
    i0.ɵɵtext(11, ":");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 20);
    i0.ɵɵelementStart(13, "div", 17);
    i0.ɵɵlistener("click", function TimePickerComponent_div_7_Template_div_click_13_listener() { i0.ɵɵrestoreView(_r17); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.timeChanged("m", "i"); });
    i0.ɵɵtext(14, " \uE908 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "input", 21);
    i0.ɵɵlistener("ngModelChange", function TimePickerComponent_div_7_Template_input_ngModelChange_15_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.fMinute = $event; })("blur", function TimePickerComponent_div_7_Template_input_blur_15_listener() { i0.ɵɵrestoreView(_r17); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.timeChanged("m", "a"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 17);
    i0.ɵɵlistener("click", function TimePickerComponent_div_7_Template_div_click_16_listener() { i0.ɵɵrestoreView(_r17); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.timeChanged("m", "d"); });
    i0.ɵɵtext(17, " \uE905 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 22);
    i0.ɵɵelementStart(19, "div", 23);
    i0.ɵɵlistener("click", function TimePickerComponent_div_7_Template_div_click_19_listener() { i0.ɵɵrestoreView(_r17); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.toggleMeridiem(ctx_r25.fPeriod); });
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(21, TimePickerComponent_div_7_div_21_Template, 7, 1, "div", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isError);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r2.fHour);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngModel", ctx_r2.fMinute);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.fPeriod, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.type === "sense");
} }
const moment$4 = moment_;
class TimePickerComponent {
    constructor() {
        this.fHour = "00";
        this.fMinute = "00";
        this.fPeriod = "am";
        this.selectorVisible = false;
        this.isError = false;
        this.dwellTime = [];
        this.timeArray = [];
        this.setTime = null;
        this.emitTime = new EventEmitter();
        this.emitTimeArray = new EventEmitter();
        this.initializeTime = () => {
            if (this.type == "sense") {
                if (this.setTime == null) {
                    this.setTime = [];
                }
                else {
                    this.dwellTime = Object.assign([], this.setTime);
                    if (this.setTimeArray(this.dwellTime)) {
                        // update required
                        this.correctTimeAndEmit(this.dwellTime);
                    }
                }
                this.time = "12:00:00.000";
                this.fTime = this.getFormattedTime(this.time);
            }
            else if (this.setTime == null) {
                this.fTime = "Select Time";
            }
            else {
                this.time = this.setTime;
                this.fTime = this.getFormattedTime(this.time);
            }
            //console.log("TIME", this.fTime);
        };
        this.correctTimeAndEmit = (timeArr) => {
            const updatedDwellTime = [];
            for (const t in timeArr) {
                const formatTime = moment$4(timeArr[t], "HH:mm:ss.sss").format("hh:mm A");
                const time = moment$4(formatTime, "hh:mm A").format("HH:mm:ss.sss");
                updatedDwellTime.push(time);
            }
            this.dwellTime = updatedDwellTime;
            this.emitTimeArray.emit(this.dwellTime);
        };
        this.setTimeArray = (timeArr) => {
            let needUpdate = false;
            for (const t in timeArr) {
                this.timeArray.push(moment$4(timeArr[t], "HH:mm:ss.sss").format("hh:mm A"));
                if (timeArr[t].indexOf(".") === -1) {
                    needUpdate = true;
                }
            }
            return needUpdate;
        };
        this.addTime = () => {
            if (this.timeArray.indexOf(this.fTime) == -1) {
                this.timeArray.push(this.fTime);
                this.dwellTime.push(moment$4(this.fTime, "hh:mm A").format("HH:mm:ss.sss"));
                this.emitTimeArray.emit(this.dwellTime);
            }
        };
        this.removeTime = (t) => {
            const i = this.timeArray.indexOf(t);
            this.timeArray.splice(i, 1);
            const time = moment$4(t, "hh:mm A").format("HH:mm:ss.sss");
            const j = this.dwellTime.indexOf(time);
            this.dwellTime.splice(j, 1);
            this.emitTimeArray.emit(this.dwellTime);
        };
        this.getFormattedTime = (t) => {
            const newTime = moment$4(t, "HH:mm:ss").format("hh:mm A");
            this.fHour = moment$4(newTime, "hh:mm A").format("hh");
            this.fMinute = moment$4(newTime, "hh:mm A").format("mm");
            this.fPeriod = moment$4(newTime, "hh:mm A").format("A");
            return newTime;
        };
        this.toggleSelector = () => {
            this.selectorVisible = !this.selectorVisible;
        };
        this.toggleMeridiem = (s) => {
            s.toUpperCase();
            s = s == "AM" ? "PM" : "AM";
            const ft = moment$4(this.fHour + ":" + this.fMinute + ":000 " + s, "hh:mm:ss A").format("HH:mm:ss");
            this.fTime = this.getFormattedTime(ft);
            this.emitTime.emit(ft);
        };
        this.timeChanged = (t, s) => {
            const ft = moment$4(this.fHour + ":" + this.fMinute + ":000 " + this.fPeriod, "hh:mm:ss a").format("HH:mm:ss");
            this.isError = false;
            let nt;
            if (t == "h") {
                if (s == "i") {
                    nt = moment$4(ft, "HH:mm:ss").add(1, "hours").format("HH:mm:ss");
                }
                else if (s == "d") {
                    nt = moment$4(ft, "HH:mm:ss")
                        .subtract(1, "hours")
                        .format("HH:mm:ss");
                }
            }
            else if (t == "m") {
                if (s == "i") {
                    nt = moment$4(ft, "HH:mm:ss")
                        .add(1, "minutes")
                        .format("HH:mm:ss");
                }
                else if (s == "d") {
                    nt = moment$4(ft, "HH:mm:ss")
                        .subtract(1, "minutes")
                        .format("HH:mm:ss");
                }
            }
            if (s == "a") {
                ft == "Invalid date" ? (this.isError = true) : (nt = ft);
            }
            if (!this.isError) {
                this.fTime = this.getFormattedTime(nt);
                if (this.type != "sense") {
                    this.emitTime.emit(nt);
                }
            }
        };
    }
    set doSetTime(value) {
        this.setTime = value;
        this.initializeTime();
    }
    ngOnInit() {
        this.initializeTime();
    }
}
TimePickerComponent.ɵfac = function TimePickerComponent_Factory(t) { return new (t || TimePickerComponent)(); };
TimePickerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TimePickerComponent, selectors: [["lib-time-picker"]], inputs: { doSetTime: ["setTime", "doSetTime"], type: "type" }, outputs: { emitTime: "emitTime", emitTimeArray: "emitTimeArray" }, decls: 8, vars: 3, consts: [[1, "time-picker"], [1, "time-a-block", "flex-b", "flex-r"], [1, "time-icon-block", 3, "click"], ["src", "/assets/cisco/images/dashboard/time_icon.svg", "width", "20"], [1, "time-display-block", "flex-b", 3, "click"], ["class", "time", 4, "ngIf"], ["class", "time truncate", 4, "ngIf"], ["class", "time-b-block flex-b flex-c", 4, "ngIf"], [1, "time"], [1, "time", "truncate"], [4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "time-b-block", "flex-b", "flex-c"], ["class", "time-header", 4, "ngIf"], ["class", "error-block", 4, "ngIf"], [1, "time-b-inner", "flex-b", "flex-r"], [1, "time-block", "flex-b", "flex-c"], [1, "ico-moon", 3, "click"], ["type", "text", "min", "0", "max", "12", 1, "time-inp", 3, "ngModel", "ngModelChange", "blur"], [1, "vertical-c"], [1, "time-block"], ["type", "text", "min", "0", "max", "59", 1, "time-inp", 3, "ngModel", "ngModelChange", "blur"], [1, "time-block", "vertical-c"], [1, "ampm-block", 3, "click"], ["class", "add-time-wrapper", 4, "ngIf"], [1, "time-header"], [1, "error-block"], [1, "add-time-wrapper"], [1, "add-time-btn", 3, "click"], [1, "info-text"], [1, "time-added-container"], ["class", "labelChip", 4, "ngFor", "ngForOf"], [1, "labelChip"], [1, "labelName"], [1, "labelClose", 3, "click"]], template: function TimePickerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵlistener("click", function TimePickerComponent_Template_div_click_2_listener() { return ctx.toggleSelector(); });
        i0.ɵɵelement(3, "img", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵlistener("click", function TimePickerComponent_Template_div_click_4_listener() { return ctx.toggleSelector(); });
        i0.ɵɵtemplate(5, TimePickerComponent_span_5_Template, 2, 1, "span", 5);
        i0.ɵɵtemplate(6, TimePickerComponent_span_6_Template, 2, 1, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, TimePickerComponent_div_7_Template, 22, 6, "div", 7);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.type !== "sense");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.type === "sense");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectorVisible);
    } }, directives: [i1$2.NgIf, i1$2.NgForOf, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel], styles: [".time-picker[_ngcontent-%COMP%]{width:250px;display:flex;flex-direction:column}.time-icon-block[_ngcontent-%COMP%]{height:30px;width:45px;background:#f1f4f9;border-radius:2px;text-align:center;display:flex;justify-content:center;cursor:pointer}.time-display-block[_ngcontent-%COMP%]{width:185px;border-bottom:1px solid #e0e0e0;font-size:14px;font-weight:bold;cursor:pointer}.time[_ngcontent-%COMP%]{align-self:center;padding-left:15px}.time-b-block[_ngcontent-%COMP%]{height:auto;width:230px;background:#ffffff;border:1px solid #e0e0e0;border-top:none}.time-header[_ngcontent-%COMP%]{font-family:\"ciscoSansLight\";font-size:13px;padding:10px;color:gray}.time-b-inner[_ngcontent-%COMP%]{background:#f1f4f9;padding:10px;height:100%}.time-block[_ngcontent-%COMP%]{width:33%;text-align:center}.ico-moon[_ngcontent-%COMP%]{font-family:\"icomoon-new\";cursor:pointer}.ico-moon[_ngcontent-%COMP%]:hover{opacity:.8}.time-inp[_ngcontent-%COMP%]{width:80%;font-size:14px;font-weight:bold;line-height:20px;margin:8px}.vertical-c[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.ampm-block[_ngcontent-%COMP%]{border:2px solid #fff;width:40px;height:35px;padding-top:7px;cursor:pointer;text-transform:uppercase}.error-block[_ngcontent-%COMP%]{color:red;text-align:left;position:relative;font-size:13px;padding:10px}.add-time-wrapper[_ngcontent-%COMP%]{margin-top:5px}.add-time-btn[_ngcontent-%COMP%]{width:30px;height:30px;border-radius:50%;background:#0198cd;line-height:32px;text-align:center;color:#fff;font-size:24px;margin:0 auto 5px;cursor:pointer;font-family:\"ciscoSansLight\"}.add-time-btn[_ngcontent-%COMP%]:hover{opacity:.7}.info-text[_ngcontent-%COMP%]{font-size:12px;text-align:center;border-bottom:1px solid #e0e0e0;width:90%;margin:0 auto;padding:5px 0}.time-added-container[_ngcontent-%COMP%]{padding-left:5px;padding-top:10px;height:100px;overflow-y:auto;overflow-x:hidden;display:flex;flex-wrap:wrap}.labelChip[_ngcontent-%COMP%]{margin:5px!important}.truncate[_ngcontent-%COMP%]{width:200px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimePickerComponent, [{
        type: Component,
        args: [{
                selector: "lib-time-picker",
                templateUrl: "./time-picker.component.html",
                styleUrls: ["./time-picker.component.css"]
            }]
    }], function () { return []; }, { doSetTime: [{
            type: Input,
            args: ['setTime']
        }], type: [{
            type: Input
        }], emitTime: [{
            type: Output
        }], emitTimeArray: [{
            type: Output
        }] }); })();

/* eslint-disable @typescript-eslint/no-explicit-any */
function TooltipContentComponent_span_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function TooltipContentComponent_span_0_div_5_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(2); return ctx_r3.onClick($event); });
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵtext(2, "Learn More");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function TooltipContentComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "div", 2);
    i0.ɵɵpipe(2, "safeHtml");
    i0.ɵɵelement(3, "div", 3);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵtemplate(5, TooltipContentComponent_span_0_div_5_Template, 3, 0, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 3, ctx_r0.tooltip.title), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 5, ctx_r0.tooltip.desc), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.tooltip.url);
} }
function TooltipContentComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
    i0.ɵɵpipe(1, "safeHtml");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r1.tooltip.html), i0.ɵɵsanitizeHtml);
} }
class TooltipContentComponent {
    constructor(viewContainerRef, element, tooltipService) {
        this.viewContainerRef = viewContainerRef;
        this.element = element;
        this.tooltipService = tooltipService;
        this.overLappingPX = 10;
        this.overLappingPXLeft = 40;
        this.elLeft = 0;
        this.elRight = 0;
        this.elTop = 0;
        this.elBottom = 0;
        this.elWidth = 0;
        this.elHeight = 0;
        this.brWidth = 0;
        this.brHeight = 0;
        this.ttWidth = 0;
        this.ttHeight = 0;
        this.ttTop = 0;
        this.ttLeft = 0;
        this.elFixed = false;
        this.recalPositionArray = Object.keys(POSITION).filter((key) => isNaN(+key));
        this.recalPosition = 0;
        this.isRecalc = false;
        this.previousTooltipArrowClass = "";
        this.nextTooltipArrowClass = "";
        this.fixedClass = "element-fixed";
        this.findPositionEnum = (indexStr) => {
            switch (indexStr) {
                case POSITION.RIGHT_TOP:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.RIGHT_MIDDLE:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.RIGHT_BOTTOM:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.LEFT_TOP:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.LEFT_MIDDLE:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.LEFT_BOTTOM:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.TOP_RIGHT:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.TOP_LEFT:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.TOP_MIDDLE:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.BOTTOM_RIGHT:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.BOTTOM_LEFT:
                    return POSITION.RIGHT_TOP;
                    break;
                case POSITION.BOTTOM_MIDDLE:
                default:
                    return POSITION.BOTTOM_MIDDLE;
                    break;
            }
        };
        this.doInit = () => {
            const el = this.tooltip.ref.nativeElement.getBoundingClientRect();
            this.elLeft = el.left;
            this.elTop = el.top;
            this.elHeight = el.height;
            this.elWidth = el.width;
            this.ttHeight = this.element.nativeElement.offsetHeight;
            this.ttWidth = this.element.nativeElement.offsetWidth;
            this.brWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            this.brHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            this.recalPosition = 0;
        };
        this.doPosition = () => {
            //tooltip.position in POSITION
            this.setPosition();
            // console.log("tooltip", "this.elLeft", this.elLeft, "this.elTop", this.elTop,
            //   "this.elHeight", this.elHeight, "this.elWidth", this.elWidth, "this.ttHeight", this.ttHeight,
            //   "this.ttWidth", this.ttWidth, "this.ttTop", this.ttTop,
            //   "this.ttLeft", this.ttLeft, "this.brWidth", this.brWidth, "this.brHeight", this.brHeight,
            //   "this.tooltip.position", this.tooltip.position);
            this.animateTooltip();
        };
        this.animateTooltip = () => {
            const elmen = this.element.nativeElement;
            const prevClass = this.previousTooltipArrowClass;
            const nextClass = this.nextTooltipArrowClass;
            const fixedClass = this.fixedClass;
            const isFixed = this.fixedClass;
            // console.log('left', this.ttLeft, 'top', this.ttTop, 'position', (this.tooltip.isFixed ? 'fixed' : 'absolute'));
            jQuery(elmen).animate({
                left: this.ttLeft,
                top: this.ttTop
            }, 100, function () {
                // Animation complete.
                if (prevClass)
                    jQuery(elmen).removeClass(prevClass);
                if (nextClass)
                    jQuery(elmen).addClass(nextClass);
                jQuery(elmen).removeClass(fixedClass);
                if (isFixed) {
                    jQuery(elmen).addClass(fixedClass);
                    jQuery(elmen).css("width", "300px");
                }
            });
            if (!this.tooltip.forcePosition) {
                setTimeout(() => {
                    this.previousTooltipArrowClass = this.nextTooltipArrowClass;
                    this.checkIfToolTipInViewPort();
                }, 200);
            }
            else {
                this.displayTooltip();
            }
        };
        this.displayTooltip = () => {
            jQuery(this.element.nativeElement).removeClass("visibility-hidden");
        };
        this.checkIfToolTipInViewPort = () => {
            const viewportOffset = this.element.nativeElement.getBoundingClientRect();
            const topEdge = viewportOffset.top; //this.ttTop;
            const leftEdge = viewportOffset.left; //this.ttLeft;
            const rightEdge = leftEdge + this.ttWidth;
            const bottomEdge = topEdge + this.ttHeight;
            // console.log('topEdge', topEdge, 'leftEdge', leftEdge, 'rightEdge', rightEdge,
            //     'bottomEdge', bottomEdge, 'elLeft', this.elLeft, 'elTop', this.elTop);
            if (topEdge <= 0 ||
                leftEdge <= 0 ||
                rightEdge >= this.brWidth ||
                bottomEdge >= this.brHeight) {
                //recalc
                this.isRecalc = true;
                if (this.recalPosition < this.recalPositionArray.length - 1) {
                    this.recalPosition++;
                    this.doPosition();
                }
                else {
                    console.log("cant try more!!!");
                    this.displayTooltip();
                }
            }
            else {
                this.displayTooltip();
            }
        };
        this.setPosition = () => {
            this.tooltipPosition = this.findPositionEnum(this.recalPositionArray[this.recalPosition]);
            if ((this.tooltip.forcePosition && this.tooltip.position) ||
                (this.tooltip.position && !this.isRecalc)) {
                this.tooltipPosition = this.tooltip.position;
            }
            const styleStr = "";
            switch (this.tooltipPosition) {
                case POSITION.RIGHT_TOP:
                    this.positionRightTop();
                    this.nextTooltipArrowClass = "arrow-left-bottom";
                    break;
                case POSITION.RIGHT_MIDDLE:
                    this.positionRightMiddle();
                    this.nextTooltipArrowClass = "arrow-left-middle";
                    break;
                case POSITION.RIGHT_BOTTOM:
                    this.positionRightBottom();
                    this.nextTooltipArrowClass = "arrow-left-top";
                    break;
                case POSITION.LEFT_TOP:
                    this.positionLeftTop();
                    this.nextTooltipArrowClass = "arrow-right-bottom";
                    break;
                case POSITION.LEFT_MIDDLE:
                    this.positionLeftMiddle();
                    this.nextTooltipArrowClass = "arrow-right-middle";
                    break;
                case POSITION.LEFT_BOTTOM:
                    this.positionLeftBottom();
                    this.nextTooltipArrowClass = "arrow-right-top";
                    break;
                case POSITION.TOP_RIGHT:
                    this.positionTopRight();
                    this.nextTooltipArrowClass = "arrow-bottom-left";
                    break;
                case POSITION.TOP_LEFT:
                    this.positionTopLeft();
                    this.nextTooltipArrowClass = "arrow-bottom-right";
                    break;
                case POSITION.TOP_MIDDLE:
                    this.positionTopMiddle();
                    this.nextTooltipArrowClass = "arrow-bottom-middle";
                    break;
                case POSITION.BOTTOM_RIGHT:
                    this.positionBottomRight();
                    this.nextTooltipArrowClass = "arrow-top-left";
                    break;
                case POSITION.BOTTOM_LEFT:
                    this.positionBottomLeft();
                    this.nextTooltipArrowClass = "arrow-top-right";
                    break;
                case POSITION.BOTTOM_MIDDLE:
                default:
                    this.positionBottomMiddle();
                    this.nextTooltipArrowClass = "arrow-top-middle";
                    break;
            }
            return styleStr;
        };
        this.positionLeftTop = () => {
            this.ttTop = this.elTop - this.ttHeight + this.overLappingPX;
            this.ttLeft = this.elLeft - this.ttWidth;
        };
        this.positionLeftMiddle = () => {
            this.ttTop = this.elTop - this.ttHeight / 2 + this.elHeight / 2;
            this.ttLeft = this.elLeft - this.ttWidth;
        };
        this.positionLeftBottom = () => {
            this.ttTop = this.elTop + this.elHeight - this.overLappingPX;
            this.ttLeft = this.elLeft - this.ttWidth;
        };
        this.positionRightTop = () => {
            this.ttTop = this.elTop - this.ttHeight + this.overLappingPX;
            this.ttLeft = this.elLeft + this.elWidth;
        };
        this.positionRightMiddle = () => {
            this.ttTop = this.elTop - this.ttHeight / 2 + this.elHeight / 2;
            this.ttLeft = this.elLeft + this.elWidth;
        };
        this.positionRightBottom = () => {
            this.ttTop = this.elTop + this.elHeight - this.overLappingPX;
            this.ttLeft = this.elLeft + this.elWidth;
        };
        this.positionTopLeft = () => {
            this.ttTop = this.elTop - this.ttHeight - this.overLappingPX;
            this.ttLeft = this.elLeft + this.elWidth - this.ttWidth;
        };
        this.positionTopMiddle = () => {
            this.ttTop = this.elTop - this.ttHeight - this.overLappingPX;
            this.ttLeft = this.elLeft + this.elWidth / 2 - this.ttWidth / 2;
        };
        this.positionTopRight = () => {
            this.ttTop = this.elTop - this.ttHeight - this.overLappingPX;
            this.ttLeft = this.elLeft;
        };
        this.positionBottomLeft = () => {
            this.ttTop = this.elTop + this.elHeight + this.overLappingPX;
            this.ttLeft = this.elLeft + this.elWidth - this.ttWidth;
        };
        this.positionBottomMiddle = () => {
            this.ttTop = this.elTop + this.elHeight + this.overLappingPX;
            this.ttLeft = this.elLeft + this.elWidth / 2 - this.ttWidth / 2;
        };
        this.positionBottomRight = () => {
            this.ttTop = this.elTop + this.elHeight + this.overLappingPX;
            this.ttLeft = this.elLeft;
        };
        this.doDestroy = () => {
            setTimeout(() => {
                const tooltip = this.tooltipService.findByIndex(this.tooltip.id);
                if (tooltip) {
                    tooltip["popupMouseOut"] = true;
                    this.destroy(tooltip);
                }
            }, 500);
        };
        this.onClick = ($event) => {
            //open new page with tooltip.url
            let url = "";
            if (!/^http[s]?:\/\//.test(this.tooltip.url)) {
                url += "http://";
            }
            url += this.tooltip.url;
            window.open(url, "_blank");
        };
        this.tooltipPosition = this.findPositionEnum(this.recalPositionArray[this.recalPosition]);
    }
    ngAfterViewInit() {
        this.doInit();
        this.doPosition();
    }
    onWindowResize() {
        this.ngAfterViewInit();
    }
    onMouseOver() {
        const tooltip = this.tooltipService.findByIndex(this.tooltip.id);
        if (tooltip) {
            tooltip["popupMouseOut"] = false;
        }
    }
    onMouseLeave() {
        this.doDestroy();
    }
    onWindowScroll($event) {
        this.doDestroy();
    }
    destroy(tooltip) {
        if (tooltip && tooltip["elemMouseOut"] && tooltip["popupMouseOut"]) {
            this.tooltip.ref.nativeElement.setAttribute("tooltip-popup-id", "");
            this.tooltipService.removeTooltip(this.tooltip.id);
        }
    }
}
TooltipContentComponent.ɵfac = function TooltipContentComponent_Factory(t) { return new (t || TooltipContentComponent)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(TooltipService)); };
TooltipContentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TooltipContentComponent, selectors: [["lib-tooltip-content"]], hostBindings: function TooltipContentComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function TooltipContentComponent_resize_HostBindingHandler() { return ctx.onWindowResize(); }, false, i0.ɵɵresolveWindow)("mouseover", function TooltipContentComponent_mouseover_HostBindingHandler() { return ctx.onMouseOver(); })("mouseleave", function TooltipContentComponent_mouseleave_HostBindingHandler() { return ctx.onMouseLeave(); })("scroll", function TooltipContentComponent_scroll_HostBindingHandler($event) { return ctx.onWindowScroll($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { tooltip: "tooltip" }, decls: 2, vars: 2, consts: [[4, "ngIf"], [3, "innerHTML", 4, "ngIf"], [1, "dynamic-tooltip-header", 3, "innerHTML"], [1, "dynamic-tooltip-desc", 3, "innerHTML"], ["ng-if", "tooltipLink", "class", "dynamic-tooltip-link", 3, "click", 4, "ngIf"], ["ng-if", "tooltipLink", 1, "dynamic-tooltip-link", 3, "click"], [1, "dynamic-tooltip-learnmore"], [3, "innerHTML"]], template: function TooltipContentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, TooltipContentComponent_span_0_Template, 6, 7, "span", 0);
        i0.ɵɵtemplate(1, TooltipContentComponent_span_1_Template, 2, 3, "span", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.tooltip.html);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.tooltip.html);
    } }, directives: [i1$2.NgIf], pipes: [SafeHtmlPipe], styles: ["[_nghost-%COMP%]{border-bottom:3px solid #049fd9}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipContentComponent, [{
        type: Component,
        args: [{
                selector: "lib-tooltip-content",
                templateUrl: "./tooltip-content.component.html",
                styleUrls: ["./tooltip-content.component.css"]
            }]
    }], function () { return [{ type: i0.ViewContainerRef }, { type: i0.ElementRef }, { type: TooltipService }]; }, { tooltip: [{
            type: Input
        }], onWindowResize: [{
            type: HostListener,
            args: ["window:resize"]
        }], onMouseOver: [{
            type: HostListener,
            args: ["mouseover"]
        }], onMouseLeave: [{
            type: HostListener,
            args: ["mouseleave"]
        }], onWindowScroll: [{
            type: HostListener,
            args: ["window:scroll", ["$event"]]
        }] }); })();

function TooltipContainerComponent_lib_tooltip_content_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-tooltip-content", 2);
} if (rf & 2) {
    const tooltip_r1 = ctx.$implicit;
    i0.ɵɵproperty("tooltip", tooltip_r1);
} }
class TooltipContainerComponent {
    constructor(tooltipService) {
        this.tooltipService = tooltipService;
    }
    ngOnInit() {
        console.log("inside tooltip container");
    }
}
TooltipContainerComponent.ɵfac = function TooltipContainerComponent_Factory(t) { return new (t || TooltipContainerComponent)(i0.ɵɵdirectiveInject(TooltipService)); };
TooltipContainerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TooltipContainerComponent, selectors: [["lib-tooltip-container"]], decls: 2, vars: 1, consts: [[1, "tooltip-container"], ["class", "dynamic-tooltip visibility-hidden", 3, "tooltip", 4, "ngFor", "ngForOf"], [1, "dynamic-tooltip", "visibility-hidden", 3, "tooltip"]], template: function TooltipContainerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, TooltipContainerComponent_lib_tooltip_content_1_Template, 1, 1, "lib-tooltip-content", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.tooltipService.getComponents());
    } }, directives: [i1$2.NgForOf, TooltipContentComponent], styles: [".tooltip-container[_ngcontent-%COMP%]{position:absolute;top:0px;left:0px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipContainerComponent, [{
        type: Component,
        args: [{
                selector: "lib-tooltip-container",
                templateUrl: "./tooltip-container.component.html",
                styleUrls: ["./tooltip-container.component.css"]
            }]
    }], function () { return [{ type: TooltipService }]; }, null); })();

class WelcomeComponent {
    constructor() {
        this.closeEvent = new EventEmitter();
        this.hideWelcome = () => {
            this.closeEvent.emit(false);
        };
    }
    ngOnInit() {
        console.log("welcome component");
    }
}
WelcomeComponent.ɵfac = function WelcomeComponent_Factory(t) { return new (t || WelcomeComponent)(); };
WelcomeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WelcomeComponent, selectors: [["lib-app-welcome"]], outputs: { closeEvent: "closeEvent" }, decls: 17, vars: 0, consts: [[1, "welcomeModalContainer"], [1, "modalOverlay"], [1, "welcomeModalBox"], [1, "welcomeModalHeading"], ["src", "/assets/cisco/images/dashboard/welcome-cmxinsight.PNG", "alt", "Welcome Image"], [1, "welcomeModalContent"], [1, "welcomeModalMessage1"], [1, "welcomeModalMessage2"], [1, "welcomeContinue"], [1, "squareButtonPrimary", 3, "click"], [1, "continueArrow"]], template: function WelcomeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelement(4, "img", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵelementStart(6, "h1", 6);
        i0.ɵɵtext(7, "Welcome to Cisco CMX Insights");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "h3", 7);
        i0.ɵɵtext(9, " Gain valuable location based insights. ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "h3", 7);
        i0.ɵɵtext(11, " Identify and know more about your customers. Get started. ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 8);
        i0.ɵɵelementStart(13, "button", 9);
        i0.ɵɵlistener("click", function WelcomeComponent_Template_button_click_13_listener() { return ctx.hideWelcome(); });
        i0.ɵɵelementStart(14, "span", 10);
        i0.ɵɵtext(15, "\uE941");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(16, " START DASHBOARD ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } }, styles: [".welcomeModalContainer[_ngcontent-%COMP%]{position:fixed;left:0;top:0;width:100%;height:100%;z-index:9999}.modalOverlay[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;background-color:#f8f8f899;z-index:100}.welcomeModalBox[_ngcontent-%COMP%]{z-index:101;position:absolute;left:55%;top:50px;transform:translate(-50%);width:55%;background-color:#fff;box-shadow:0 0 20px #dddfe2;border-radius:4px;overflow:hidden}.welcomeModalHeading[_ngcontent-%COMP%]{display:block;width:100%;padding:0;margin:0}.welcomeModalHeading[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%;height:auto}.welcomeModalContent[_ngcontent-%COMP%]{padding:40px 10px;text-align:center}.welcomeModalMessage1[_ngcontent-%COMP%]{margin-top:0;font-family:\"ciscoSansRegular\";color:#20162a;font-weight:bold}.welcomeModalMessage2[_ngcontent-%COMP%]{margin:0;font-family:\"ciscoSansRegular\";color:#20162a;font-weight:normal}.welcomeContinue[_ngcontent-%COMP%]{text-align:right;margin:20px 0 0;padding:0 10px}.welcomeContinue[_ngcontent-%COMP%]   .squareButtonPrimary[_ngcontent-%COMP%]{color:#fff}.continueArrow[_ngcontent-%COMP%]{font-family:\"icomoon-new\";color:inherit;font-weight:bold;margin-right:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WelcomeComponent, [{
        type: Component,
        args: [{
                selector: "lib-app-welcome",
                templateUrl: "./welcome.component.html",
                styleUrls: ["./welcome.component.css"]
            }]
    }], function () { return []; }, { closeEvent: [{
            type: Output
        }] }); })();

const _c0$5 = ["chart"];
const moment$3 = moment_;
class D3StreamLineChartComponent {
    constructor(dataService) {
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.sourceData = [];
        this.bmData = [];
        this.sData = [];
        this.ticks = [];
        this.dateTickValues = [];
        this.tickValues = [];
        this.showDetails = new EventEmitter();
        this.updateTooltipContent = (event, mouse) => {
            var self = this;
            var dist = { x: 20, y: 10 };
            var m = d3.pointer(event, self.svg.node());
            self.scr.x = window.scrollX;
            self.scr.y = window.scrollY;
            m[0] += self.svgpos.x;
            m[1] += self.svgpos.y;
            self.tooltip.selectAll("div").remove();
            var index = 0;
            self.tooltip.style("right", "");
            self.tooltip.style("left", "");
            self.tooltip.style("bottom", "");
            self.tooltip.style("top", "");
            if (self.chartOptions.isPopup) {
                if (m[0] > self.scr.x + self.elementAttr.w / 2) {
                    self.tooltip.style("right", (self.elementAttr.w - m[0] + dist.x) + "px");
                }
                else {
                    self.tooltip.style("left", (m[0] + dist.x) + "px");
                }
            }
            else {
                if (m[0] > self.scr.x + self.scr.w / 2) {
                    self.tooltip.style("right", (self.elementAttr.w - m[0] + 1.53 * dist.x) + "px");
                }
                else {
                    self.tooltip.style("left", (m[0] + dist.x) + 20 + "px");
                }
            }
            self.tooltip.style("top", "0px");
            self.tooltip
                .style('display', 'block')
                .style('font-size', 11.5)
                .style('z-index', "1000")
                .style('padding', '10px 15px')
                .style('min-width', '220px')
                .selectAll()
                .data(self.sourceData).enter() // for each vehicle category, list out name and price of premium
                .append('div')
                .style('color', d => {
                return "#545454";
            })
                .style('font-size', 10)
                .html(d => {
                let tipContainer = '';
                var xDate = self.xScale.invert(mouse[0]);
                var bisect = d3.bisector(function (d) { return d["date"]; }).left;
                var idx = bisect(d.values, xDate);
                if (d.values[idx]) {
                    this.tooltipValues = d.values[idx];
                    // index += 1
                    // return "<div class = 'streamLine-tooltip'> "
                    // 	+ "<div class='streamLine-info'>" + "<span style='vertical-align:middle; display:inline-block; padding:5px;margin-right: 6px; border-radius: 50%; height:4px; width: 4px; background-color:" + d.values[idx].color + "'></span><span class='streamLine-left'>" + d.values[idx].name + "</span><span class = 'multiLine-right'>" + d.values[idx].count + " " + d.values[idx].unit + "</span>"
                    // 	+ "</div>" +
                    // 	((d.values[idx].prefix1 && d.values[idx].name === "Average") ? "<div class='streamLine-info'>" + "<span style='vertical-align:middle;margin-right: 6px; display:inline-block; padding:5px; border-radius: 50%; height:4px; width: 4px; background-color:" + d.values[idx].areaColor + "'></span><span class='streamLine-left'>" + d.values[idx].prefix1 + "</span><span class = 'multiLine-right'>" + d.values[idx].min + " " + d.values[idx].unit + ", " + d.values[idx].max + " " + d.values[idx].unit + "</span>"
                    // 		+ "</div>" : "") +
                    // 	((d.values[idx].prefix1 && d.values[idx].name === "Avg. of a Day") ? "<div class='streamLine-info'>" + "<span style='vertical-align:middle;margin-right: 6px; display:inline-block; padding:5px; border-radius: 50%; height:4px; width: 4px; background-color:" + d.values[idx].areaColor + "'></span><span class='streamLine-left'>" + d.values[idx].prefix1 + "</span><span class = 'multiLine-right'>" + d.values[idx].min + " " + d.values[idx].unit + "</span>"
                    // 		+ "</div>" : "") +
                    // 	((d.values[idx].prefix2) ? "<div class='streamLine-info'>" + "<span style='vertical-align:middle; display:inline-block; padding:5px; margin-right: 6px;border-radius: 50%; height:4px; width: 4px; background-color:" + d.values[idx].areaColor + "'></span><span class='streamLine-left'>" + d.values[idx].prefix2 + "</span><span class = 'multiLine-right'>" + d.values[idx].max + " " + d.values[idx].unit + "</span>"
                    // 		+ "</div>" : "") +
                    // 	"<div class='streamLine-bottom'>" +
                    // 	d.values[idx].displayDate +
                    // 	"</div></div>";
                    index += 1;
                    return "<div class = 'streamLine-tooltip'> "
                        + "<div class='streamLine-header'>" + "<span class='streamLine-left label-padding'>" + d.values[idx].displayDate + "</span>"
                        + "</div>" +
                        ((d.values[idx].prefix2) ? "<div class='streamLine-info'>" + "<span style='vertical-align:middle; display:inline-block; padding:5px; margin-right: 6px;border-radius: 50%; height:4px; width: 4px; background-color:" + d.values[idx].areaColor + "'></span><span class='streamLine-left'>" + d.values[idx].prefix2 + "</span><span class = 'multiLine-right'>" + this.getTooltipValue(d.values[idx].max) + " " + d.values[idx].unit + "</span>"
                            + "</div>" : "") +
                        (((d.values[idx].name === "Average") || (d.values[idx].prefix1 && d.values[idx].name === "Avg. of a Day")) ? "<div class='streamLine-info'>" + "<span style='vertical-align:middle; display:inline-block; padding:5px;margin-right: 6px; border-radius: 50%; height:4px; width: 4px; background-color:" + d.values[idx].color + "'></span><span class='streamLine-left'>" + d.values[idx].name + "</span><span class = 'multiLine-right'>" + this.getTooltipValue(d.values[idx].count) + " " + d.values[idx].unit + "</span>"
                            + "</div>" : "") +
                        ((d.values[idx].prefix1 && d.values[idx].name === "Avg. of a Day") ? "<div class='streamLine-info'>" + "<span style='vertical-align:middle;margin-right: 6px; display:inline-block; padding:5px; border-radius: 50%; height:4px; width: 4px; background-color:" + d.values[idx].areaColor + "'></span><span class='streamLine-left'>" + d.values[idx].prefix1 + "</span><span class = 'multiLine-right'>" + this.getTooltipValue(d.values[idx].min) + " " + d.values[idx].unit + "</span>"
                            + "</div>" : "") +
                        "<div class='streamLine-info'>" + "<span style='vertical-align:middle;margin-right: 6px; display:inline-block; padding:5px; border-radius: 50%; height:4px; width: 4px; background-color:" + d.values[idx].color + "'></span><span class='streamLine-left'>" + d.values[idx].detailViewLabel + "</span>"
                        + "</div>" +
                        "</div>";
                    "</div>";
                }
                else {
                    // self.tooltip.style("display", "none");
                }
                return "";
            });
        };
        this.getTooltipValue = (value) => {
            if (this.sourceData[0].customTickFormat) {
                return this.sourceData[0].customTickValues ? this.sourceData[0].customTickValues.filter((obj) => obj.value === value)[0].name : "";
            }
            else {
                return value;
            }
        };
        this.closeTooltip = () => {
            setTimeout(() => {
                this.tooltip.style('opacity', 0);
                this.tooltip.style('display', "none");
            }, 3000);
        };
        window.addEventListener("resize", this.reDraw.bind(this));
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (this.tooltip) {
            this.tooltip.remove();
        }
        if ((!value || value.length == 0))
            return;
        this.sourceData = value;
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    reDraw() {
        // this.chartContainer.nativeElement.remove()
        if (this.tooltip) {
            this.tooltip.remove();
        }
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        document.getElementsByClassName('mat-drawer-content').item(0).addEventListener('scroll', () => {
            document.querySelectorAll(".bi-tooltip").forEach(e => {
                if (e["style"].opacity == 1)
                    e["style"].opacity = 0;
            });
        });
    }
    ngAfterViewInit() {
        this.dataService.getMagneticAppIsExpanded(this.unsubscribe$).subscribe((val) => {
            setTimeout(() => {
                // console.log("getMagneticAppIsExpanded", val);
                if (this.sourceData && this.sourceData.length > 0)
                    this.reDraw();
            }, 500);
        });
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg)
            this.svg.remove();
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("transform", `translate(0,
					${this.chartOptions.margin.top - 20})`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg.append("g").attr("transform", `translate(10,20)`);
        this.getxScale();
        this.getyScale();
        this.getLine();
        this.getArea();
        this.tip = d3Tip()
            .attr("class", "bi-tooltip")
            .offset([-10, 0])
            .html(function (d) {
            return "<div id='bi-tooltip line-chart'></div>";
        });
        this.svg.call(this.tip);
        const body = d3.select(element.closest("body"));
        const container = d3.select(element);
        this.scr = {
            x: window.scrollX,
            y: window.scrollY,
            w: window.innerWidth,
            h: window.innerHeight
        };
        if (!this.chartOptions.isPosTooltip) {
            this.elementAttr = {
                w: isNull(body.node()) ? 0 : body.node().offsetWidth,
                h: body.node().offsetHeight
            };
            this.svgpos = this.getNodePos(this.svg.node(), body);
        }
        else {
            this.elementAttr = {
                w: isNull(container.node()) ? 0 : container.node().offsetWidth,
                h: container.node().offsetHeight
            };
            this.svgpos = this.getNodePos(this.svg.node(), container);
        }
    }
    getNodePos(el, element) {
        var body = element.node();
        for (var lx = 0, ly = 0; el != null && el != body; lx += el.offsetLeft || el.clientLeft,
            ly += el.offsetTop || el.clientTop,
            el = el.offsetParent || el.parentNode)
            ;
        return { x: lx, y: ly };
    }
    draw() {
        let dateArray = [];
        let self = this;
        if (this.chartOptions.xAxisFormat == "date") {
            // const sortedTicks = this.nonRepeativeTicks();
            const sortedTicks = this.preparexAxisTicks();
            this.xAxis = d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickValues(sortedTicks)
                .tickFormat(d3.timeFormat("%b %d"));
        }
        else if (this.chartOptions.xAxisFormat == "hour_of_day") {
            const sortedTicks = this.prepareHourxAxisTicks();
            this.xAxis = d3
                .axisBottom(this.xScale)
                .scale(this.xScale)
                .tickValues(sortedTicks)
                .tickFormat(d3.timeFormat("%I %p"));
        }
        this.chart
            .append("g")
            .attr("class", "x axis")
            .attr("width", "100%")
            .attr("transform", `translate(
						${this.chartOptions.margin.left + 15},${this.height})`)
            .call(this.xAxis);
        this.chart
            .append("g")
            .attr("class", "y axis")
            .attr("transform", `translate(
						${(this.chartOptions.margin.left + 15)},0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(this.width + 35))
            .tickFormat(function (d, i) {
            if (self.sourceData[0].customTickFormat) {
                return self.sourceData[0].customTickValues[d] ? self.sourceData[0].customTickValues[d].name : "";
            }
            else {
                return self.readableNumber(d, 2);
            }
            // return d + ": " + data[i].val;
        }));
        this.chart
            .selectAll(".axis .tick text")
            .attr("fill", "#1d3243")
            .attr("font-size", "9px");
        this.chart.selectAll(".y.axis .tick line").attr("stroke", "#DEDEDE");
        this.chart
            .selectAll(".x.axis .tick line")
            .attr("stroke", "transparent");
        this.chart.selectAll(".axis .domain").attr("stroke", "transparent");
        this.chart
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - (this.chartOptions.margin.left - 15))
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .attr("fill", "#000000")
            .attr("text-anchor", "middle")
            .attr("font-size", "10px")
            .attr("font-family", "ciscoSans")
            .style("font-weight", "700")
            .style("line-height", "1.5")
            .text(this.chartOptions.yAxisLabel);
        // Adding x-axis and y-axis grid lines			
        this.chart
            .append("g")
            .attr("class", "grid")
            .attr("transform", `translate(
						${(this.chartOptions.margin.left + 20)},0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale)
            .tickSize(-(this.width + 35))
            .tickFormat(() => this.chartOptions.yAxisTickFormat));
        this.chart
            .append("g")
            .attr("class", "grid")
            .attr("transform", `translate(
						${this.chartOptions.margin.left - 5},${this.height})`)
            .call(d3
            .axisBottom(this.xScale)
            .scale(this.xScale)
            .tickSize(-(this.width + 35))
            .tickFormat(() => this.chartOptions.xAxisTickFormat));
        this.chart.selectAll(".grid .tick line").attr("stroke", "transparent");
        this.chart.selectAll(".grid .domain").attr("stroke", "transparent");
        this.chart
            .append("g")
            .attr("class", "x-axis-label")
            .append("text")
            .text(this.chartOptions.xAxisLabel)
            .attr("transform", `translate( 
					${((this.width / 2) + 40)} 
					, ${(this.height + 40)})`)
            .attr("text-anchor", "middle");
        if (this.chartOptions.chartType == "area") {
            let areaGroup = this.chart
                .append("g")
                .attr("class", "area-group");
            areaGroup
                .selectAll(".area-group")
                .data(this.sourceData)
                .enter()
                .append("g")
                .attr("class", "area-group")
                .attr("transform", `translate(
							${(this.chartOptions.margin.left + 5)},0)`)
                .append("path")
                .attr("class", "area")
                .attr("d", (d) => this.area(d.values))
                .attr("fill", (d) => d.areaColor)
                .style("fill", (d) => d.areaColor);
        }
        const lines = this.chart.append("g").attr("class", "lines");
        // Adding Acceptable range 
        if (this.sourceData[0].acceptableRange && this.sourceData[0].acceptableRange.length > 0) {
            const scaleMinValue = this.sourceData[0].scaleMinValue ? this.sourceData[0].scaleMinValue : 0;
            const acceptableRange = this.sourceData[0].acceptableRange;
            lines
                .append("line")
                .attr("class", "acceptable-range")
                .attr("transform", `translate(
							${(this.chartOptions.margin.left + 6)} 
							,0)`)
                .attr("x1", 15)
                .attr("y1", this.yScale(acceptableRange[1]))
                .attr("x2", this.width)
                .attr("y2", this.yScale(acceptableRange[1]))
                .style("stroke-dasharray", 3)
                .style("stroke", "#DEDEDE")
                .style("fill", "none");
            lines
                .append("rect")
                .attr("width", this.width)
                // .attr("height", this.yScale(acceptableRange[0]) - this.chartOptions.margin.bottom)
                .attr("height", function () {
                return self.height - self.yScale(acceptableRange[1] - acceptableRange[0] + scaleMinValue);
            })
                .attr("x", 43)
                .attr("y", function () {
                return self.yScale(acceptableRange[1]);
            })
                .style("fill", "rgba(0, 171, 80, 0.15)")
                .style("opacity", "0.3");
        }
        /*.on("mouseover", function (d) {
      d3.select(this).attr('fill', d.color);
      self.showTooltip(d);
      self.tip.show(d, this);
    })
    .on("mouseout", function (d) {
      d3.select(this).attr('fill', 'transparent');
      self.tip.hide();
    })*/
        lines
            .selectAll(".line-group")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "line-group")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left + 5)},0)`)
            .append("path")
            .attr("class", "line")
            .attr("d", (d) => this.valueline(d.values))
            .attr("stroke", (d) => d.color)
            .attr("fill", "none");
        if (!self.chartOptions.hideMouseOverEffects) {
            self.showMouseOverTooltip();
        }
    }
    showTooltip(value) {
        let self = this;
        let tipContainer = "";
        // const suffix = value.suffix ? value.suffix : "";
        self.tip.html(function (d) {
            tipContainer += "<div class = 'multiLine-tooltip'>";
            tipContainer +=
                "<div class='multiLine-top'>" + d.displayDate + "</div>";
            tipContainer += "<div class='daily-info'>";
            tipContainer +=
                "<span style='vertical-align:middle; display:table; padding:6px; border-radius: 3px; background-color:" +
                    d.color +
                    "'></span><span class='multiLine-left'>" +
                    d.name +
                    "</span><span class = 'multiLine-right'>" +
                    d.count +
                    "</span>";
            tipContainer += "</div></div>";
            return tipContainer;
        });
    }
    showCustomTooltip(i) {
        let self = this;
        let tipContainer = "";
        // const suffix = value.suffix ? value.suffix : "";
        self.tip.html(function (d) {
            tipContainer += "<div class = 'multiLine-custom-tip'>";
            tipContainer +=
                "<div class='top-left'>" +
                    i.displayKey +
                    "</div><div class='top-right'>" +
                    i.count +
                    "</div>";
            tipContainer += "</div>";
            return tipContainer;
        });
    }
    getxScale() {
        // var parseTime = d3.timeParse("%Y-%m-%dT%H:%M:%SZ"); // "2019-10-23T14:00:00.000Z
        let completeData = [];
        let keyValues = [];
        var self = this;
        this.ticks = [];
        this.dateTickValues = [];
        if (this.chartOptions.excludeZeroDataPointsDisplay) {
            this.sourceData.forEach(function (d) {
                keyValues = [];
                d["xAxisTickValues"].forEach(function (date) {
                    keyValues.push(date);
                    self.ticks.push(date);
                    if (self.tickValues.findIndex((i) => i.toString() == date) == -1) {
                        self.tickValues.push(date);
                    }
                    completeData.push(date);
                });
            });
        }
        else {
            this.sourceData.forEach(function (d) {
                keyValues = [];
                d["values"].forEach(function (obj) {
                    if (self.chartOptions.xAxisFormat === "date" ||
                        self.chartOptions.xAxisFormat === "dateTime") {
                        const parseTime = d3.timeParse(self.chartOptions.xAxisDateFormat);
                        const formatedDate = parseTime(obj.date);
                        if (formatedDate)
                            obj.date = parseTime(obj.date);
                        keyValues.push(obj.date);
                    }
                    else {
                        keyValues.push(obj.date);
                    }
                    //obj.count = +obj.count;
                    self.ticks.push(obj.date);
                    if (self.tickValues.findIndex((i) => i.toString() == obj.date) == -1) {
                        self.tickValues.push(obj.date);
                    }
                    completeData.push(obj);
                });
            });
        }
        this.dateTickValues = keyValues;
        this.xScale = d3
            .scaleTime()
            .range([
            this.chartOptions.margin.left,
            this.width - this.chartOptions.margin.right
        ])
            .domain(d3.extent(keyValues, function (d) {
            return d;
        }));
    }
    getyScale() {
        const scaleMaxValue = this.sourceData[0].scaleMaxValue;
        const scaleMinValue = this.sourceData[0].scaleMinValue ? this.sourceData[0].scaleMinValue : 0;
        this.yScale = d3
            .scaleLinear()
            .range([this.height, 0])
            .domain([
            scaleMinValue,
            d3.max(this.sourceData, function (d) {
                return d3.max(d["values"], function (obj) {
                    return parseFloat(obj["count"]) > scaleMaxValue
                        ? parseFloat(obj["count"])
                        : parseFloat(scaleMaxValue);
                });
            })
        ]);
    }
    getLine() {
        let self = this;
        this.valueline = d3
            .line()
            .x(d => this.xScale(d["date"]))
            .y(d => this.yScale(d["count"]));
        //.curve(d3.curveMonotoneX)
    }
    getArea() {
        this.area = d3
            .area()
            .x(d => this.xScale(d["date"]))
            .y0(d => this.yScale(d["min"]))
            .y1(d => this.yScale(d["max"]));
    }
    readableNumber(value, decimalPoint) {
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return "0";
        }
        decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
        var numCount = value.toPrecision(2).split("e"), // get power
        noOfK = numCount.length === 1
            ? 0
            : Math.floor(Math.min(numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        dividedValue = noOfK < 1
            ? value.toFixed(0 + decimalPoint)
            : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
        finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
        suffix = `${finalValue + ["", "K", "M", "B", "T"][noOfK]}`; // append power
        return suffix;
    }
    // to display alernative ticks
    preparexAxisTicks() {
        if (this.ticks.length > 10) {
            this.ticks.forEach((obj, i) => {
                this.ticks.splice(i + 1, 2);
            });
        }
        else if (this.ticks.length > 5) {
            this.ticks.forEach((obj, i) => {
                this.ticks.splice(i + 1, 1);
            });
        }
        return this.ticks;
    }
    prepareHourxAxisTicks() {
        if (this.ticks.length > 10) {
            this.ticks.forEach((obj, i) => {
                this.ticks.splice(i + 1, 11);
            });
        }
        else {
            this.ticks.forEach((obj, i) => {
                this.ticks.splice(i + 1, 5);
            });
        }
        return this.ticks;
    }
    // to display all ticks for 8 data points
    nonRepeativeTicks() {
        this.ticks.forEach((obj, i) => {
            this.ticks.splice(i, 0);
        });
        return this.ticks;
    }
    showMouseOverTooltip() {
        var self = this;
        const element = self.chartContainer.nativeElement;
        // CREATE HOVER TOOLTIP WITH VERTICAL LINE //
        self.tooltip = d3
            .select(element)
            .append("div")
            .attr("id", "tooltip")
            .style("position", "absolute")
            .style("background-color", "#fff")
            .style("filter", "drop-shadow(0px 0px 1px #b2b2b2)")
            .style("padding", 6)
            .style("border-radius", "8px")
            .style("display", "none");
        self.tooltip
            .transition()
            .duration(300)
            .style("opacity", 0);
        this.mouseG = this.chart
            .append("g")
            .attr("class", "mouse-over-effects");
        var res_nested = d3.group(this.sourceData, (d) => d["name"]);
        let tooltipElement = document.getElementById("tooltip");
        if (tooltipElement) {
            tooltipElement.addEventListener("mouseout", self.closeTooltip.bind(this));
        }
        this.mouseG
            .append("path") // create vertical line to follow mouse
            .attr("class", "mouse-line")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left + 5)},0)`)
            .style("stroke-width", 8)
            .style("stroke", "#DEDEDE")
            .style("cursor", "pointer")
            .style("opacity", "0")
            .style("fill", "none");
        var mousePerLine = this.mouseG
            .selectAll(".mouse-per-line")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "mouse-per-line");
        mousePerLine
            .append("circle")
            .attr("r", 4)
            .attr("transform", `translate(
						${(this.chartOptions.margin.left - 5)},0)`)
            .attr("stroke", function (d) {
            return d.color;
        })
            .attr("fill", function (d) {
            return d.color;
        })
            .style("opacity", "0");
        this.mouseG
            .append("svg:rect") // append a rect to catch mouse movements on canvas
            .attr("width", this.width)
            .attr("height", this.height)
            .attr("transform", `translate(
					${this.chartOptions.margin.left + 10},0)`)
            .attr("fill", "none")
            .attr("pointer-events", "all")
            .style("cursor", "pointer")
            .on("mouseout", function () {
            // on mouse out hide line, circles and text
            d3.select(element)
                .select(".mouse-line").style("opacity", "0");
            d3.select(element)
                .selectAll(".mouse-per-line circle")
                .style("opacity", "0");
            d3.select(element)
                .selectAll(".mouse-per-line text")
                .style("opacity", "0");
            setTimeout(() => {
                var displayAtrr = d3
                    .select(element)
                    .select("#tooltip")
                    .style("display");
                if (displayAtrr && displayAtrr === "block")
                    d3.select(element)
                        .select("#tooltip")
                        .style("display", "none");
                self.tooltip.style('opacity', 0);
            }, 100);
        })
            .on("mouseover", function () {
            // on mouse in show line, circles and text
            d3.select(element).select(".mouse-line").style("opacity", "1");
            d3.select(element)
                .selectAll(".mouse-per-line circle")
                .style("opacity", "1");
            d3.select(element).select("#tooltip").style("display", "block");
            self.tooltip
                .transition()
                .duration(300)
                .style("opacity", 1);
        })
            .on("mousemove", function (d) {
            // update tooltip content, line, circles and text when mouse moves
            const mouse = d3.pointer(d, this);
            d3.select(element)
                .selectAll(".mouse-per-line")
                .attr("transform", function (d) {
                const xDate = self.xScale.invert(mouse[0]); // use 'invert' to get date corresponding to distance from mouse position relative to svg
                const bisect = d3.bisector(function (d) {
                    return d["date"];
                }).left; // retrieve row index of date on parsed csv
                const idx = bisect(d["values"], xDate);
                d3.select(element)
                    .select(".mouse-line")
                    .attr("d", function () {
                    var data = "M" + self.xScale(d["values"][idx]["date"]) + "," + (self.height);
                    data += " " + self.xScale(d["values"][idx]["date"]) + "," + 0;
                    return data;
                });
                let xTrans;
                let yTrans = 0.0;
                if (d["values"][idx]) {
                    xTrans =
                        parseFloat(self.xScale(d["values"][idx]["date"])) +
                            (self.chartOptions.margin.left - 15);
                    yTrans = self.yScale(d["values"][idx]["count"]);
                }
                else {
                    d3.select(element)
                        .selectAll(".mouse-per-line circle")
                        .style("opacity", "0");
                    xTrans = self.chartOptions.margin.left;
                }
                return `translate(${xTrans},${yTrans})`;
            });
            if (self.chartOptions.defaultTooltipPos) {
                self.defaultTooltip(d, mouse);
            }
            else {
                self.updateTooltipContent(d, mouse);
            }
        })
            .on("mouseout", function (d, i) {
            if (d.relatedTarget !== null) {
                if (d.relatedTarget.localName === "svg") {
                    self.tooltip.style('opacity', 0);
                    self.tooltip.style('display', "none");
                }
            }
        })
            .on("click", function (d) {
            const mouse = d3.pointer(d, this);
            const xDate = self.xScale.invert(mouse[0]);
            const bisect = d3.bisector(function (d) {
                return d["date"];
            }).left; // retrieve row index of date on parsed csv
            const idx = bisect(self.sourceData[0].values, xDate);
            self.showDetails.emit(self.sourceData[0].values[idx]);
            self.tooltip.style('opacity', 0);
            self.tooltip.style('display', "none");
        });
    }
    defaultTooltip(event, mouse) {
        var self = this;
        self.tooltip.selectAll("div").remove();
        var pageX = `${(event.pageX + 20) / 2}px`;
        var pageY = `${(event.pageY - 20) / 10}px`;
        let index = 0;
        self.tooltip
            .style("display", "block")
            .style("left", pageX)
            .style("top", pageY)
            .style("font-size", 11.5)
            .style("z-index", "1000")
            // .style('min-width', '220px')
            .selectAll()
            .data(self.sourceData)
            .enter()
            .append("div")
            .style("color", (d) => {
            // return d.color
            return "#fff";
        })
            .style("font-size", 10)
            .html(d => {
            var xDate = self.xScale.invert(mouse[0]);
            var bisect = d3.bisector(function (d) {
                return d["date"];
            }).left;
            var idx = bisect(d.values, xDate);
            idx = idx - 1;
            if (d.values[idx]) {
                console.log(`line chart :: tool tip :: if value    ${idx}   ,
						${d.values[idx]}`);
                self.tooltip.style("min-width", "220px");
                self.tooltip.style("display", "block");
                // self.tooltip.style("padding", "10px 15px");
                index += 1;
                const values = index == 1
                    ? `<div class='multiLine-top'> ${d.values[idx].displayDate} </div>`
                    : ``;
                return `<div class = 'multiLine-tooltip'>${values}
					<div class='daily-info'> 
					<span style='vertical-align:middle; display:inline-block; padding:6px; border-radius: 3px; background-color:
					${d.values[idx].color}
					'></span><span class='multiLine-left'> 
					${d.values[idx].name}
					</span><span class = 'multiLine-right'> 
					${d.values[idx].count}
					</span> 
					</div></div>`;
            }
            else {
                self.tooltip.style("min-width", "0");
                self.tooltip.style("padding", "0");
            }
        });
    }
}
D3StreamLineChartComponent.ɵfac = function D3StreamLineChartComponent_Factory(t) { return new (t || D3StreamLineChartComponent)(i0.ɵɵdirectiveInject(DataService)); };
D3StreamLineChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3StreamLineChartComponent, selectors: [["lib-d3-stream-line-chart"]], viewQuery: function D3StreamLineChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$5, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, outputs: { showDetails: "showDetails" }, decls: 2, vars: 0, consts: [[1, "d3-chart"], ["chart", ""]], template: function D3StreamLineChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3StreamLineChartComponent, [{
        type: Component,
        args: [{
                selector: 'lib-d3-stream-line-chart',
                templateUrl: './d3-stream-line-chart.component.html',
                styleUrls: ['./d3-stream-line-chart.component.scss']
            }]
    }], function () { return [{ type: DataService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }], showDetails: [{
            type: Output
        }] }); })();

const _c0$4 = ["chart"];
class D3MinMaxChartComponent {
    constructor(logger) {
        this.sourceData = [];
        this.barPadding = 0.3;
        this.tickSize = 3;
        this.highLowGenerator = (d) => {
            var high = this.xScale(d.max);
            var low = this.xScale(d.min);
            var time = this.yScale(d.key);
            return this.line([[high, time], [low, time]]);
        };
        this.maxGenerator = (d) => {
            var open = this.xScale(d.max);
            var time = this.yScale(d.key);
            return this.line([[open, time - this.tickSize], [open, time + this.tickSize]]);
        };
        this.minGenerator = (d) => {
            var open = this.xScale(d.min);
            var time = this.yScale(d.key);
            return this.line([[open, time - this.tickSize], [open, time + this.tickSize]]);
        };
        this.getTooltipValue = (value) => {
            if (this.sourceData[0].customTickFormat && this.sourceData[0].customTickValues) {
                return this.sourceData[0].customTickValues.filter((obj) => obj.value === value)[0] ? this.sourceData[0].customTickValues.filter((obj) => obj.value === value)[0].name : "";
            }
            else {
                return value;
            }
        };
        this.getTruncated = (str, size, limit) => {
            if (str && str.length > size) {
                return str.substring(0, limit) + "...";
            }
            else {
                return str;
            }
        };
        this.utils = new Utils(logger);
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (!value || value.length == 0)
            return;
        this.sourceData = value;
        this.dataLength = this.sourceData.length;
        this.widgetType = this.sourceData[0].widgetType;
        if (this.tip) {
            this.tip.hide();
        }
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
        if (this.tip) {
            this.tip.hide();
        }
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg)
            this.svg.remove();
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("transform", `translate(0,
					${this.chartOptions.margin.top - 20} 
					)`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg.append("g").attr("transform", `translate(25,20)`);
        this.getxScale();
        this.getyScale();
        this.getLine();
        this.tip = d3Tip()
            .attr("class", "custom-tooltip")
            .offset([-10, 0])
            .html(function () {
            return "<div id='custom-tooltip line-chart'></div>";
        });
        this.svg.call(this.tip);
    }
    preparexAxisTicks() {
        const ticks = this.sourceData.map(function (d) {
            return d.key;
        });
        if (ticks.length > 31) {
            for (let i = 0; i < ticks.length; i++) {
                ticks.splice(i + 1, 5);
            }
        }
        else {
            if (this.widgetType.toLocaleString() !== "dwellTime") {
                for (let i = 0; i < ticks.length; i++) {
                    ticks.splice(i + 1, 1);
                }
            }
        }
        return ticks;
    }
    draw() {
        const self = this;
        this.xAxis = d3
            .axisBottom(this.xScale)
            .scale(this.xScale)
            .tickFormat(function (d, i) {
            if (self.sourceData[0].customTickFormat) {
                return self.sourceData[0].customTickValues[d] ? self.sourceData[0].customTickValues[d].name : "";
            }
            else {
                return self.readableNumber(d, 0);
            }
        });
        this.chart
            .append("g")
            .attr("class", "x-axis")
            .attr("transform", `translate(
						${this.chartOptions.margin.left + 5} 
						,${this.height})`, "rotate(90)")
            .call(this.xAxis)
            .append("text")
            .attr("class", "xAxis-label")
            .text(this.chartOptions.xAxisLabel)
            .style("fill", "#1D3243")
            .style("text-anchor", "middle")
            .attr("transform", `translate(
				${this.width / 2}, 
				${40})`);
        this.chart
            .append("g")
            .attr("class", "y axis")
            .attr("transform", `translate(
					${this.chartOptions.margin.left} 
					,0)`)
            .call(d3
            .axisLeft(this.yScale)
            .scale(this.yScale))
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - this.chartOptions.margin.left)
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .style("fill", "#1D3243")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
        this.chart
            .append("g")
            .attr("class", "grid")
            .attr("transform", `translate(
						${(this.chartOptions.margin.left + 6)},${this.height})`)
            .call(d3
            .axisBottom(this.xScale)
            .scale(this.xScale)
            .tickSize(-(this.height))
            .tickFormat(() => this.chartOptions.yAxisTickFormat));
        const ohlcs = this.chart.append("g").attr("class", "ohlcs").attr("transform", `translate(
        15,0)`);
        // Adding Acceptable range 
        if (this.sourceData[0].acceptableRange && this.sourceData[0].acceptableRange.length > 0) {
            const acceptableRange = this.sourceData[0].acceptableRange;
            ohlcs
                .append("line")
                .attr("class", "acceptable-range")
                .attr("transform", `translate(
          ${(this.chartOptions.margin.left - 10)} 
          ,0)`)
                .attr("y1", 15)
                .attr("x1", this.xScale(acceptableRange[1]))
                .attr("y2", this.height)
                .attr("x2", this.xScale(acceptableRange[1]))
                .style("stroke-dasharray", 3)
                .style("stroke", "#DEDEDE")
                .style("fill", "none");
            ohlcs
                .append("rect")
                .attr("width", function () {
                return self.xScale(acceptableRange[1] - acceptableRange[0]);
            })
                // .attr("height", this.yScale(acceptableRange[0]) - this.chartOptions.margin.bottom)
                .attr("height", function () {
                return self.height;
            })
                .attr("x", 100 + self.xScale(acceptableRange[0]))
                .attr("y", 0)
                .style("fill", "rgba(0, 171, 80, 0.15)")
                .style("opacity", "0.3");
        }
        ohlcs
            .selectAll(".ohlcs-group")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("class", "ohlcs")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left - 5)},0)`)
            .append("path")
            .attr("class", "high-low")
            .attr("d", (d) => this.highLowGenerator(d))
            .style("stroke-width", "2px")
            .attr("stroke", "#3B3B3B");
        ohlcs
            .selectAll("open-group")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left - 5)},0)`)
            .append("path")
            .attr("class", "open")
            .attr("d", (d) => this.maxGenerator(d))
            .style("stroke-width", "2px")
            .attr("stroke", "#000");
        ohlcs
            .selectAll("close-group")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left - 5)},0)`)
            .append("path")
            .attr("class", "close")
            .attr("d", (d) => this.minGenerator(d))
            .attr("stroke", "#000")
            .style("stroke-width", "2px");
        ohlcs
            .selectAll("circle-group")
            .data(this.sourceData)
            .enter()
            .append("g")
            .attr("transform", `translate(
					${(this.chartOptions.margin.left - 5)},0)`)
            .append("circle")
            .attr("class", "average")
            .style("stroke-width", "2px")
            .attr("r", 5)
            .attr("fill", (d) => d["color"])
            .attr("cy", (d) => this.yScale(d["key"]))
            .attr("cx", (d) => this.xScale(d["average"]))
            .style("cursor", "pointer")
            .on("mouseover", function (d, i) {
            self.showTooltip(d, i);
            self.tip.show(d, this);
        })
            .on("mouseout", function () {
            self.tip.hide();
        });
    }
    getLine() {
        let self = this;
        this.line = d3
            .line();
        this.movingAverageGenerator = d3.line()
            .y(d => this.yScale(d["key"]))
            .x(d => this.xScale(d["average"]));
    }
    showTooltip(value, i) {
        const self = this;
        let tipContainer = "";
        const avg = self.getTooltipValue(i.average);
        const min = self.getTooltipValue(i.min);
        const max = self.getTooltipValue(i.max);
        self.tip.html(function () {
            tipContainer += "<div class = 'streamLine-tooltip'> ";
            if (i.locName) {
                tipContainer += `<div class='streamLine-top'>
        ${i.locName}
        </div>`;
            }
            tipContainer += "<div class='streamLine-info'>";
            tipContainer += `<span style='vertical-align:middle; display:inline-block; padding:6px; margin-right: 6px; border-radius: 50%; height:4px; width: 4px; background-color:
				${i.color}
				'></span><span class='streamLine-left'>
				${i.prefix}
				</span><span class = 'streamLine-right'>
				${avg} ${i.unit}</span> </div>`;
            tipContainer += "<div class='streamLine-info'>";
            tipContainer += `<span style='vertical-align:middle; display:inline-block; padding:6px; margin-right: 6px; border-radius: 50%; height:4px; width: 4px; background-color:
				${i.color}
				'></span><span class='streamLine-left'>
				${i.prefix1}
				</span><span class = 'streamLine-right'>
        ${min} ${i.unit},${max} ${i.unit}</span> </div>`;
            tipContainer += "<div class='streamLine-bottom'>" + `${i.range}`;
            tipContainer += "</div></div>";
            return tipContainer;
        });
    }
    readableNumber(value, decimalPoint) {
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return "0";
        }
        decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
        const numCount = value.toPrecision(2).split("e"), // get power
        noOfK = numCount.length === 1
            ? 0
            : Math.floor(Math.min(numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        dividedValue = noOfK < 1
            ? value.toFixed(0 + decimalPoint)
            : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
        finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
        suffix = finalValue + ["", "K", "M", "B", "T"][noOfK]; // append power
        return suffix;
    }
    getxScale() {
        let paddingInner = 0.5;
        // this.xScale = d3
        //   .scaleBand()
        //   .range([0, this.width])
        //   .padding(1)
        //   .domain(this.sourceData.map((d) => d.key));
        this.xScale = d3
            .scaleLinear()
            .range([0, this.width])
            .domain([0,
            d3.max(this.sourceData, function (d) {
                return d.maxValue;
            })]);
    }
    getyScale() {
        // this.yScale = d3
        //   .scaleLinear()
        //   .range([this.height, 0])
        //   .domain([0,
        //     d3.max(this.sourceData, function (d) { return d.max; })])
        // .nice();;
        this.yScale = d3
            .scaleBand()
            .range([this.height, 0])
            .padding(1)
            .domain(this.sourceData.map((d) => d.key));
    }
}
D3MinMaxChartComponent.ɵfac = function D3MinMaxChartComponent_Factory(t) { return new (t || D3MinMaxChartComponent)(i0.ɵɵdirectiveInject(LoggerService)); };
D3MinMaxChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3MinMaxChartComponent, selectors: [["lib-d3-min-max-chart"]], viewQuery: function D3MinMaxChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$4, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart"], ["chart", ""]], template: function D3MinMaxChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3MinMaxChartComponent, [{
        type: Component,
        args: [{
                selector: 'lib-d3-min-max-chart',
                templateUrl: './d3-min-max-chart.component.html',
                styleUrls: ['./d3-min-max-chart.component.scss']
            }]
    }], function () { return [{ type: LoggerService }]; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

/* eslint-disable @typescript-eslint/no-unsafe-return */
const _c0$3 = ["chart"];
class D3HorizontalBarEnvChartComponent {
    constructor() {
        this.chartOptions = {};
        this.sourceData = [];
        this.bmData = [];
        this.sData = [];
        this.barPadding = 0.3;
    }
    set options(value) {
        if (!value)
            return;
        this.chartOptions = value;
        if (this.sourceData && this.sourceData.length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    set data(value) {
        if (!value || value.length == 0)
            return;
        this.sourceData = value;
        this.dataLength = this.sourceData.length;
        if (this.chartOptions && Object.keys(this.chartOptions).length > 0) {
            this.createSvg();
            this.draw();
        }
    }
    ngOnInit() {
        this.element = this.chartContainer.nativeElement;
    }
    createSvg() {
        const element = this.chartContainer.nativeElement;
        element.height = this.chartOptions.chartHeight;
        if (this.svg)
            this.svg.remove();
        this.svg = d3
            .select(element)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("transform", `translate(0,${this.chartOptions.margin.top - 20})`);
        this.width =
            element.clientWidth -
                this.chartOptions.margin.left -
                this.chartOptions.margin.right;
        this.height =
            element.clientHeight -
                this.chartOptions.margin.top -
                this.chartOptions.margin.bottom;
        this.chart = this.svg.append("g").attr("transform", `translate(25,20)`);
        this.getxScale();
        this.getyScale();
        this.tip = d3Tip()
            .attr("class", "custom-tooltip")
            .offset([-10, 0])
            .html(function () {
            return "<div id='custom-tooltip line-chart'></div>";
        });
        this.svg.call(this.tip);
    }
    getxScale() {
        this.xScale = d3
            .scaleLinear()
            .range([0, this.width])
            .domain([
            0,
            d3.max(this.sourceData, function (d) {
                return d.count;
            })
        ]);
    }
    getyScale() {
        this.sourceData = this.sourceData.sort(function (a, b) {
            return d3.ascending(a.order, b.order);
        });
        /*this.yScale = d3
            .scaleBand()
            .range([this.height, 0])
            .padding(0.1)
            .domain(
                this.sourceData.map(function (d) {
                    return d.xAxiskey;
                })
            );*/
        let paddingInner = 0.5;
        if (this.chartOptions.handleBarWidth) {
            if (this.dataLength == 1) {
                paddingInner = 0.9;
            }
            else if (this.dataLength < 1 && this.dataLength < 4) {
                paddingInner = 0.7;
            }
            if (this.dataLength < 8) {
                this.yScale = d3
                    .scaleBand()
                    .range([this.height, 0])
                    .padding(this.barPadding)
                    .paddingInner(paddingInner)
                    .domain(this.sourceData.map(function (d) {
                    return d.xAxiskey;
                }));
            }
            else {
                this.yScale = d3
                    .scaleBand()
                    .range([this.height, 0])
                    .padding(this.barPadding)
                    .domain(this.sourceData.map(function (d) {
                    return d.xAxiskey;
                }));
            }
        }
        else {
            this.yScale = d3
                .scaleBand()
                .range([this.height, 0])
                .padding(this.barPadding)
                .domain(this.sourceData.map(function (d) {
                return d.xAxiskey;
            }));
        }
        // this.yScale = d3.scaleBand();
    }
    // getyScale() {
    //   var barSize = 20;
    //   var xScaleRange = this.sourceData.length * 20
    //   this.sourceData = this.sourceData.sort(function (a, b) {
    //     return d3.ascending(a.order, b.order);
    //   })
    //   this.yScale = d3.scaleBand()
    //     // .range([this.height, 0])
    //     .range([barSize * this.sourceData.length, 0])
    //     .padding(0.1)
    //     // .rangeRound([this.width / 2 + xScaleRange, this.width / 2 - xScaleRange])
    //     .domain(this.sourceData.map(function (d) { return d.xAxiskey; }));
    // }
    draw() {
        const self = this;
        function make_x_gridlines() {
            return d3.axisBottom(self.xScale);
        }
        // add the x gridlines
        this.chart
            .append("g")
            .attr("class", "grid")
            .style("stroke", "#E9E9E9")
            .style("fill", "#E9E9E9")
            .style("stroke-width", "1px")
            .style("shape-rendering", "crispEdges")
            .attr("transform", `translate(${this.chartOptions.margin.left}, ${this.height})`)
            .call(make_x_gridlines()
            .tickSize(-this.height)
            .tickFormat(() => ""));
        this.chart
            .append("g")
            .attr("class", "x axis")
            .attr("width", "100%")
            .attr("transform", `translate(${this.chartOptions.margin.left}, ${this.height})`)
            .call(d3
            .axisBottom(this.xScale)
            .scale(this.xScale)
            .tickFormat((d) => this.readableNumber(d, 0)))
            .append("text")
            .attr("class", "xAxis-label")
            .text(this.chartOptions.xAxisLabel)
            .style("fill", "#1D3243")
            .style("text-anchor", "middle")
            .attr("transform", `translate(
				${this.width / 2}, 
				${40})`);
        this.chart
            .append("g")
            .attr("class", "y axis")
            // .attr("transform", "translate(" + (this.chartOptions.margin.left - 2) + "," + 0 + ")")
            .attr("transform", `translate(${this.chartOptions.margin.left},0)`)
            .call(d3.axisLeft(this.yScale).scale(this.yScale))
            .append("text")
            .attr("class", "yAxis-label")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - this.chartOptions.margin.left)
            .attr("x", 0 - this.height / 2)
            .attr("dy", "1em")
            .style("fill", "#1D3243")
            .style("text-anchor", "middle")
            .text(this.chartOptions.yAxisLabel);
        const bars = this.chart
            .append("g")
            .attr("class", "bar-group")
            .attr("transform", `translate(
					${this.chartOptions.margin.left} 
					,0)`);
        //append rects
        bars.selectAll(".bar")
            .data(this.sourceData)
            .enter()
            .append("rect")
            .attr("class", "bar")
            .attr("y", function (d) {
            return self.yScale(d.xAxiskey);
        })
            // .attr("height", this.yScale.bandwidth())
            .attr("height", function (d) {
            return d.barWidth;
        })
            .attr("transform", `translate(0,${this.yScale.bandwidth() / 2 - 7.5})`)
            .attr("x", 0)
            .attr("width", function (d) {
            return self.xScale(d.count);
        })
            .style("fill", (d) => d.color)
            .style("cursor", "pointer")
            .on("mouseover", function (d, i) {
            self.showTooltip(d, i);
            self.tip.show(d, this);
        })
            .on("mouseout", function () {
            self.tip.hide();
        });
        // add a value label to the right of each bar
        // bars.selectAll(".val-label")
        // 	.data(this.sourceData)
        // 	.enter()
        // 	.append("text")
        // 	.attr("class", "label")
        // 	.style("fill", "#1D3243")
        // 	.style("font-size", "10px")
        // 	.style("font-family", "CiscoSansRegular")
        // 	.attr("y", function (d) {
        // 		return self.yScale(d.xAxiskey) + self.yScale.bandwidth()/2 + 1;;
        // 	}) 
        // 	// .attr("y", function (d) { return self.yScale(d.xAxiskey) + self.yScale.bandwidth() / 2 + 4;})
        // 	.attr("x", function (d) {
        // 		if (d.count > this.width) return self.xScale(d.count) - 60;
        // 		else return +self.xScale(d.count) + 3;
        // 	})
        // 	.text((d) => this.readableNumber(d.count, 0));
    }
    readableNumber(value, decimalPoint) {
        if (value === null) {
            return null;
        }
        if (value === 0) {
            return "0";
        }
        decimalPoint = !decimalPoint || decimalPoint < 0 ? 0 : decimalPoint; // number of decimal places to show
        const numCount = value.toPrecision(2).split("e"), // get power
        noOfK = numCount.length === 1
            ? 0
            : Math.floor(Math.min(numCount[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        dividedValue = noOfK < 1
            ? value.toFixed(0 + decimalPoint)
            : (value / Math.pow(10, noOfK * 3)).toFixed(1 + decimalPoint), // divide by power
        finalValue = dividedValue < 0 ? dividedValue : Math.abs(dividedValue), // enforce -0 is 0
        suffix = finalValue + ["", "K", "M", "B", "T"][noOfK]; // append power
        return suffix;
    }
    // eslint-disable-next-line no-unused-vars
    showTooltip(event, i) {
        const self = this;
        let tipContainer = "";
        let envSuffix = i.sensorsCnt > 1 ? 'Sensors' : 'Sensor';
        self.tip.html(function () {
            tipContainer += "<div class = 'streamLine-tooltip'>";
            if (i.locName) {
                tipContainer += `<div class='streamLine-top'>
				${i.locName}
				</div>`;
            }
            tipContainer += "<div class='streamLine-info'>";
            tipContainer += `<span class='streamLine-left'>
					  ${i.tooltipLabel}
					  </span><span class = 'streamLine-right'>
					  ${i.count} Min (${i.sensorsCnt} ${envSuffix})</span> </div>`;
            tipContainer += "<div class='streamLine-bottom'>" + `${i.range}`;
            tipContainer += "</div></div>";
            return tipContainer;
        });
    }
}
D3HorizontalBarEnvChartComponent.ɵfac = function D3HorizontalBarEnvChartComponent_Factory(t) { return new (t || D3HorizontalBarEnvChartComponent)(); };
D3HorizontalBarEnvChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: D3HorizontalBarEnvChartComponent, selectors: [["lib-d3-horizontal-bar-env-chart"]], viewQuery: function D3HorizontalBarEnvChartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartContainer = _t.first);
    } }, inputs: { options: "options", data: "data" }, decls: 2, vars: 0, consts: [[1, "d3-chart"], ["chart", ""]], template: function D3HorizontalBarEnvChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D3HorizontalBarEnvChartComponent, [{
        type: Component,
        args: [{
                selector: 'lib-d3-horizontal-bar-env-chart',
                templateUrl: './d3-horizontal-bar-env-chart.component.html',
                styleUrls: ['./d3-horizontal-bar-env-chart.component.scss']
            }]
    }], function () { return []; }, { chartContainer: [{
            type: ViewChild,
            args: ["chart", { static: true }]
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

function UpdateCountryPopupComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "label", 14);
    i0.ɵɵtext(2, " To enhance your experience, please complete your profile by updating your country information. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function UpdateCountryPopupComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.errorMessage, " ");
} }
function UpdateCountryPopupComponent_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function UpdateCountryPopupComponent_button_15_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.onHidePopup($event); });
    i0.ɵɵtext(1, " Cancel ");
    i0.ɵɵelementEnd();
} }
function UpdateCountryPopupComponent_button_16_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function UpdateCountryPopupComponent_button_16_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.onHidePopup($event); });
    i0.ɵɵtext(1, " Skip & Continue ");
    i0.ɵɵelementEnd();
} }
const _c0$2 = function (a0) { return { "disabled": a0 }; };
class UpdateCountryPopupComponent {
    constructor(userService, dataService) {
        this.userService = userService;
        this.dataService = dataService;
        this.unsubscribe$ = new Subject();
        this.hideCountryPopup = new EventEmitter();
        this.updateCountryDetail = new EventEmitter();
        this.errorMessage = '';
        this.isvalidSelection = false;
        this.onHidePopup = ($event) => {
            this.hideCountryPopup.emit($event);
        };
        this.selectCountry = ($event) => {
            console.log("country selected", $event.countryCode);
            this.selectedCountry = $event.countryCode;
            this.isvalidSelection = true;
        };
        this.disableSave = () => {
            this.isvalidSelection = false;
        };
        this.onSave = ($event) => {
            this.updateCountryDetail.emit(this.selectedCountry);
        };
    }
    ngOnInit() {
        //call api to get list of country codes
        this.dataService.display(true);
        this.userService.getCountryCodeList().pipe(takeUntil$1(this.unsubscribe$)).subscribe(response => {
            if (response && response.data) {
                this.countryList = response.data.countryCode;
                console.log("country list is ", this.countryList);
                this.dataService.display(false);
            }
            else {
                //failed to fetch country list continue work flow??
            }
        });
        this.isvalidSelection = false;
    }
}
UpdateCountryPopupComponent.ɵfac = function UpdateCountryPopupComponent_Factory(t) { return new (t || UpdateCountryPopupComponent)(i0.ɵɵdirectiveInject(UserService), i0.ɵɵdirectiveInject(DataService)); };
UpdateCountryPopupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UpdateCountryPopupComponent, selectors: [["lib-update-country-popup"]], inputs: { fromPage: "fromPage" }, outputs: { hideCountryPopup: "hideCountryPopup", updateCountryDetail: "updateCountryDetail" }, decls: 17, vars: 8, consts: [[1, "modalPopup", "modalPopupSm", "updateProfilePopup"], [1, "modalOverlay"], [1, "modalContent"], [1, "modalHeader"], [1, "modalCloseIcon", 3, "click"], [1, "modalBody"], ["class", "mainTest", 4, "ngIf"], ["class", "formInlineError", 4, "ngIf"], [1, "sectionDiv"], [2, "height", "100%", 3, "itemList", "emitSelection", "emitDisableSave"], [1, "modalFooter"], [1, "primaryButton", 3, "ngClass", "click"], ["class", "cancelButton", 3, "click", 4, "ngIf"], [1, "mainTest"], [1, "mainTextlabel"], [1, "formInlineError"], [1, "cancelButton", 3, "click"]], template: function UpdateCountryPopupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4, " Update Country Information ");
        i0.ɵɵelementStart(5, "span", 4);
        i0.ɵɵlistener("click", function UpdateCountryPopupComponent_Template_span_click_5_listener($event) { return ctx.onHidePopup($event); });
        i0.ɵɵtext(6, "\uE909");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, UpdateCountryPopupComponent_div_8_Template, 3, 0, "div", 6);
        i0.ɵɵtemplate(9, UpdateCountryPopupComponent_div_9_Template, 2, 1, "div", 7);
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵelementStart(11, "lib-location-selection-dropdown", 9);
        i0.ɵɵlistener("emitSelection", function UpdateCountryPopupComponent_Template_lib_location_selection_dropdown_emitSelection_11_listener($event) { return ctx.selectCountry($event); })("emitDisableSave", function UpdateCountryPopupComponent_Template_lib_location_selection_dropdown_emitDisableSave_11_listener() { return ctx.disableSave(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 10);
        i0.ɵɵelementStart(13, "button", 11);
        i0.ɵɵlistener("click", function UpdateCountryPopupComponent_Template_button_click_13_listener($event) { return ctx.onSave($event); });
        i0.ɵɵtext(14, "Save");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, UpdateCountryPopupComponent_button_15_Template, 2, 0, "button", 12);
        i0.ɵɵtemplate(16, UpdateCountryPopupComponent_button_16_Template, 2, 0, "button", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", ctx.fromPage === "login");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errorMessage.length > 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("itemList", ctx.countryList);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$2, !ctx.isvalidSelection));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.fromPage === "account");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fromPage !== "account");
    } }, directives: [i1$2.NgIf, LocationSelectionDropdownComponent, i1$2.NgClass], styles: [".modalPopup.modalPopupSm[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{width:650px!important;height:75.5vh!important;flex-shrink:0!important}.modalPopup.updateProfilePopup[_ngcontent-%COMP%] > .modalContent[_ngcontent-%COMP%]{top:20%}.modalPopup.updateProfilePopup[_ngcontent-%COMP%] > div.modalContent[_ngcontent-%COMP%] > div.modalBody[_ngcontent-%COMP%]{height:80%;width:90%}.modalPopup[_ngcontent-%COMP%]   .modalBody[_ngcontent-%COMP%]{background-color:#fff;margin-bottom:45px}.modalBody[_ngcontent-%COMP%]{margin-left:57px;padding:10px 0!important}.mainTest[_ngcontent-%COMP%]{margin-top:25px;margin-bottom:10px;width:80%}label.mainTextlabel[_ngcontent-%COMP%]{display:block;font-size:18px;font-weight:700;margin-bottom:25px;font-family:\"ciscoSansThin\"}.sectionDiv[_ngcontent-%COMP%]{display:flex;flex-direction:column;width:80%;height:42vh}.sectionDiv[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{max-width:280px}.nameLabel[_ngcontent-%COMP%]{font-family:ciscoSansLight;color:#58585b;font-size:12px}.disabled[_ngcontent-%COMP%]{opacity:.3;cursor:not-allowed;pointer-events:none}.verifyNumber[_ngcontent-%COMP%]{display:flex;margin-left:100px}.phoneNumberDiv[_ngcontent-%COMP%]{width:310px}.textInput[_ngcontent-%COMP%]{font-family:ciscoSansLight;color:#000;font-size:16px;padding:2px}.form-control[_ngcontent-%COMP%]{width:90%!important}.intl-tel-input[_ngcontent-%COMP%]{display:block!important}.intlPhnoDiv[_ngcontent-%COMP%]{padding-top:10px}.errorDiv[_ngcontent-%COMP%]{color:red;font-size:12px}.cancelButton[_ngcontent-%COMP%]:disabled{opacity:.3;cursor:not-allowed;pointer-events:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateCountryPopupComponent, [{
        type: Component,
        args: [{
                selector: 'lib-update-country-popup',
                templateUrl: './update-country-popup.component.html',
                styleUrls: ['./update-country-popup.component.scss']
            }]
    }], function () { return [{ type: UserService }, { type: DataService }]; }, { fromPage: [{
            type: Input
        }], hideCountryPopup: [{
            type: Output
        }], updateCountryDetail: [{
            type: Output
        }] }); })();

const _c0$1 = function (a0, a1, a2) { return { "row-hover": a0, "workspacePage": a1, "displayNone": a2 }; };
function WorkspaceLocationHierarchyComponent_ng_template_2_tree_node_wrapper_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tree-node-wrapper", 9);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    const node_r7 = ctx_r13.$implicit;
    const index_r8 = ctx_r13.index;
    const templates_r9 = ctx_r13.templates;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r10.getPadding(node_r7, ctx_r10.isPopup));
    i0.ɵɵproperty("node", node_r7)("index", index_r8)("templates", templates_r9)("ngClass", i0.ɵɵpureFunction3(7, _c0$1, node_r7.data.showMenu, ctx_r10.workspacePage, node_r7.data.type === "floor" || node_r7.data.type === "zone" || node_r7.data.type === "cmxzone" || node_r7.data.type === "polygon_zone"));
} }
const _c1$1 = function (a0) { return { "row-hover": a0 }; };
function WorkspaceLocationHierarchyComponent_ng_template_2_tree_node_wrapper_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tree-node-wrapper", 9);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    const node_r7 = ctx_r14.$implicit;
    const index_r8 = ctx_r14.index;
    const templates_r9 = ctx_r14.templates;
    i0.ɵɵproperty("node", node_r7)("index", index_r8)("templates", templates_r9)("ngClass", i0.ɵɵpureFunction1(4, _c1$1, node_r7.data.showMenu));
} }
function WorkspaceLocationHierarchyComponent_ng_template_2_lib_row_menu_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-row-menu", 10);
} if (rf & 2) {
    const node_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("node", node_r7);
} }
const _c2$1 = function (a0) { return { "displayNone": a0 }; };
function WorkspaceLocationHierarchyComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, WorkspaceLocationHierarchyComponent_ng_template_2_tree_node_wrapper_1_Template, 1, 11, "tree-node-wrapper", 5);
    i0.ɵɵtemplate(2, WorkspaceLocationHierarchyComponent_ng_template_2_tree_node_wrapper_2_Template, 1, 6, "tree-node-wrapper", 6);
    i0.ɵɵtemplate(3, WorkspaceLocationHierarchyComponent_ng_template_2_lib_row_menu_3_Template, 1, 1, "lib-row-menu", 7);
    i0.ɵɵelement(4, "tree-node-children", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r7 = ctx.$implicit;
    const templates_r9 = ctx.templates;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2.getClass(node_r7));
    i0.ɵɵclassProp("tree-node", true)("tree-node-expanded", node_r7.isExpanded && node_r7.hasChildren)("tree-node-collapsed", node_r7.isCollapsed && node_r7.hasChildren)("tree-node-leaf", node_r7.isLeaf)("tree-node-active", node_r7.isActive)("tree-node-focused", node_r7.isFocused);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isPopup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r7.data.showMenu);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("node", ctx_r2.sortChildren(node_r7))("templates", templates_r9)("ngClass", i0.ɵɵpureFunction1(20, _c2$1, node_r7.data.type === "network"));
} }
function WorkspaceLocationHierarchyComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "Loading, please hold....");
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_0_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵlistener("mouseover", function WorkspaceLocationHierarchyComponent_ng_template_6_div_0_span_6_Template_span_mouseover_0_listener() { i0.ɵɵrestoreView(_r32); const node_r16 = i0.ɵɵnextContext(2).$implicit; const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.onMouseOverNodeFn(node_r16.data); })("mouseout", function WorkspaceLocationHierarchyComponent_ng_template_6_div_0_span_6_Template_span_mouseout_0_listener() { i0.ɵɵrestoreView(_r32); const node_r16 = i0.ɵɵnextContext(2).$implicit; const ctx_r33 = i0.ɵɵnextContext(); return ctx_r33.onMouseOutNodeFn(node_r16.data); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" (", node_r16.data.total, " out of ", node_r16.data.permitted, ") ");
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_0_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵelement(1, "span", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r16.apsMatched, i0.ɵɵsanitizeHtml);
} }
const _c3$1 = function (a0) { return { "disable-location": a0 }; };
const _c4$1 = function (a0) { return { "highlightLocation": a0 }; };
function WorkspaceLocationHierarchyComponent_ng_template_6_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵlistener("click", function WorkspaceLocationHierarchyComponent_ng_template_6_div_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r39); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r37 = i0.ɵɵnextContext(); return ctx_r37.selectNodeFn(node_r16); })("mouseover", function WorkspaceLocationHierarchyComponent_ng_template_6_div_0_Template_div_mouseover_0_listener() { i0.ɵɵrestoreView(_r39); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.onMouseOverNodeFn(node_r16.data); })("mouseout", function WorkspaceLocationHierarchyComponent_ng_template_6_div_0_Template_div_mouseout_0_listener() { i0.ɵɵrestoreView(_r39); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.onMouseOutNodeFn(node_r16.data); });
    i0.ɵɵelementStart(1, "a", 21);
    i0.ɵɵelement(2, "span", 22);
    i0.ɵɵelementStart(3, "span", 23);
    i0.ɵɵlistener("click", function WorkspaceLocationHierarchyComponent_ng_template_6_div_0_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r39); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.clickedLocation(node_r16.data); });
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, WorkspaceLocationHierarchyComponent_ng_template_6_div_0_span_6_Template, 2, 2, "span", 24);
    i0.ɵɵtemplate(7, WorkspaceLocationHierarchyComponent_ng_template_6_div_0_span_7_Template, 2, 1, "span", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$1, !ctx_r18.multiLocationSelect && ctx_r18.showCameraCountAlert(node_r16) || ctx_r18.rightNowPage && (node_r16.data.type === "zone" || node_r16.data.type === "cmxzone" || node_r16.data.type === "polygon_zone")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 5, node_r16.data.name), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(9, _c4$1, ctx_r18.reportType === "REAL_TIME"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", node_r16.data.permitted != node_r16.data.total);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r16.apsMatched);
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_1_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵlistener("mouseover", function WorkspaceLocationHierarchyComponent_ng_template_6_div_1_span_6_Template_span_mouseover_0_listener() { i0.ɵɵrestoreView(_r51); const node_r16 = i0.ɵɵnextContext(2).$implicit; const ctx_r49 = i0.ɵɵnextContext(); return ctx_r49.onMouseOverNodeFn(node_r16.data); })("mouseout", function WorkspaceLocationHierarchyComponent_ng_template_6_div_1_span_6_Template_span_mouseout_0_listener() { i0.ɵɵrestoreView(_r51); const node_r16 = i0.ɵɵnextContext(2).$implicit; const ctx_r52 = i0.ɵɵnextContext(); return ctx_r52.onMouseOutNodeFn(node_r16.data); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" (", node_r16.data.total, " out of ", node_r16.data.permitted, ") ");
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_1_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵelement(1, "span", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r16.apsMatched, i0.ɵɵsanitizeHtml);
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "a", 21);
    i0.ɵɵelement(2, "span", 22);
    i0.ɵɵelement(3, "span", 30);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelement(5, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, WorkspaceLocationHierarchyComponent_ng_template_6_div_1_span_6_Template, 2, 2, "span", 24);
    i0.ɵɵtemplate(7, WorkspaceLocationHierarchyComponent_ng_template_6_div_1_span_7_Template, 2, 1, "span", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$1, !ctx_r19.multiLocationSelect && ctx_r19.showCameraCountAlert(node_r16) || ctx_r19.rightNowPage && (node_r16.data.type === "zone" || node_r16.data.type === "cmxzone" || node_r16.data.type === "polygon_zone")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 5, node_r16.data.name), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(9, _c4$1, ctx_r19.reportType === "REAL_TIME"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", node_r16.data.permitted != node_r16.data.total);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r16.apsMatched);
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵtext(2, " Right now analytics not available at zone level. Please select a floor/building/campus. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "loc_tooltip_", node_r16.data.id, "");
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "div", 34);
    i0.ɵɵelementStart(2, "img", 35);
    i0.ɵɵlistener("mouseover", function WorkspaceLocationHierarchyComponent_ng_template_6_div_3_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r60); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r58 = i0.ɵɵnextContext(); return ctx_r58.cameraCountAlertMouseOver($event, node_r16.data.id); })("mouseover", function WorkspaceLocationHierarchyComponent_ng_template_6_div_3_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r60); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r61 = i0.ɵɵnextContext(); return ctx_r61.cameraCountAlertMouseOut($event, node_r16.data.id); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 36);
    i0.ɵɵtext(4, " No camera(s) available at this location ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "camera-count_", node_r16.data.id, "");
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_4_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵelement(1, "span", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", node_r16.apsMatched, i0.ɵɵsanitizeHtml);
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelementStart(1, "a", 21);
    i0.ɵɵelement(2, "span", 22);
    i0.ɵɵelement(3, "span", 30);
    i0.ɵɵpipe(4, "safeHtml");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, WorkspaceLocationHierarchyComponent_ng_template_6_div_4_span_5_Template, 2, 1, "span", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 3, node_r16.data.name), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(5, _c4$1, ctx_r22.reportType === "REAL_TIME"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r16.apsMatched);
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵelementStart(1, "input", 39);
    i0.ɵɵlistener("click", function WorkspaceLocationHierarchyComponent_ng_template_6_div_5_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r69); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r67 = i0.ɵɵnextContext(); return ctx_r67.selectNodeFn(node_r16); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r23 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r16.data.id, "");
    i0.ɵɵproperty("checked", ctx_r23.selectedLocation && ctx_r23.selectedLocation.length > 0 && node_r16.id === ctx_r23.selectedLocation[0].id)("value", node_r16.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r16.data.id, "");
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelementStart(1, "input", 39);
    i0.ɵɵlistener("click", function WorkspaceLocationHierarchyComponent_ng_template_6_div_6_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r73); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r71 = i0.ɵɵnextContext(); return ctx_r71.selectNode(node_r16); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r24 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r16.data.id, "");
    i0.ɵɵproperty("checked", ctx_r24.selectedLocation && ctx_r24.selectedLocation.length > 0 && node_r16.id === ctx_r24.selectedLocation[0].id)("value", node_r16.data.id);
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_7_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "label", 40);
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r16.data.id, "");
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_7_label_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "label", 40);
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r16.data.id, "");
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r81 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelementStart(1, "input", 39);
    i0.ɵɵlistener("click", function WorkspaceLocationHierarchyComponent_ng_template_6_div_7_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r81); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r79 = i0.ɵɵnextContext(); return ctx_r79.selectNode(node_r16); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, WorkspaceLocationHierarchyComponent_ng_template_6_div_7_label_2_Template, 1, 1, "label", 42);
    i0.ɵɵtemplate(3, WorkspaceLocationHierarchyComponent_ng_template_6_div_7_label_3_Template, 1, 1, "label", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r25 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r16.data.id, "");
    i0.ɵɵproperty("checked", ctx_r25.selectedLocation && ctx_r25.selectedLocation.length > 0 && node_r16.id === ctx_r25.selectedLocation[0].id)("value", node_r16.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r25.workspacePage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r25.workspacePage && node_r16.id === ctx_r25.selectedLocation[0].id);
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r85 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelementStart(1, "input", 44);
    i0.ɵɵlistener("click", function WorkspaceLocationHierarchyComponent_ng_template_6_div_8_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r85); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r83 = i0.ɵɵnextContext(); return ctx_r83.selectMultipleNode($event, node_r16); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r26 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r16.data.id, "");
    i0.ɵɵproperty("checked", ctx_r26.isNodeSelected)("value", node_r16.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r16.data.id, "");
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r89 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "div", 34);
    i0.ɵɵelementStart(2, "img", 35);
    i0.ɵɵlistener("mouseover", function WorkspaceLocationHierarchyComponent_ng_template_6_div_9_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r89); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r87 = i0.ɵɵnextContext(); return ctx_r87.locationInfoMouseOver($event, node_r16.data.id); })("mouseover", function WorkspaceLocationHierarchyComponent_ng_template_6_div_9_Template_img_mouseover_2_listener($event) { i0.ɵɵrestoreView(_r89); const node_r16 = i0.ɵɵnextContext().$implicit; const ctx_r90 = i0.ɵɵnextContext(); return ctx_r90.locationInfoMouseOut($event, node_r16.data.id); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 47);
    i0.ɵɵtext(4, " Location does not have sufficient data ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "loc_info_", node_r16.data.id, "");
} }
function WorkspaceLocationHierarchyComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, WorkspaceLocationHierarchyComponent_ng_template_6_div_0_Template, 8, 11, "div", 11);
    i0.ɵɵtemplate(1, WorkspaceLocationHierarchyComponent_ng_template_6_div_1_Template, 8, 11, "div", 12);
    i0.ɵɵtemplate(2, WorkspaceLocationHierarchyComponent_ng_template_6_div_2_Template, 3, 1, "div", 13);
    i0.ɵɵtemplate(3, WorkspaceLocationHierarchyComponent_ng_template_6_div_3_Template, 5, 1, "div", 14);
    i0.ɵɵtemplate(4, WorkspaceLocationHierarchyComponent_ng_template_6_div_4_Template, 6, 7, "div", 15);
    i0.ɵɵtemplate(5, WorkspaceLocationHierarchyComponent_ng_template_6_div_5_Template, 3, 4, "div", 16);
    i0.ɵɵtemplate(6, WorkspaceLocationHierarchyComponent_ng_template_6_div_6_Template, 2, 3, "div", 17);
    i0.ɵɵtemplate(7, WorkspaceLocationHierarchyComponent_ng_template_6_div_7_Template, 4, 5, "div", 17);
    i0.ɵɵtemplate(8, WorkspaceLocationHierarchyComponent_ng_template_6_div_8_Template, 3, 4, "div", 18);
    i0.ɵɵtemplate(9, WorkspaceLocationHierarchyComponent_ng_template_6_div_9_Template, 5, 1, "div", 19);
} if (rf & 2) {
    const node_r16 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && (node_r16.data.access === "Full" || node_r16.data.reportAccess));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && node_r16.data.access !== "Full" && !node_r16.data.reportAccess);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.rightNowPage && (node_r16.data.type === "zone" || node_r16.data.type === "cmxzone" || node_r16.data.type === "polygon_zone"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && ctx_r6.showCameraCountAlert(node_r16));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.multiLocationSelect);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r16.data.access === "Full" && (!ctx_r6.multiLocationSelect && ctx_r6.workspacePage && (node_r16.data.type == "network" || node_r16.data.type == "building") && node_r16.data.id != ctx_r6.selectedLocation[0].id));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (node_r16.data.access === "Full" || node_r16.data.reportAccess) && (!ctx_r6.multiLocationSelect && !ctx_r6.rightNowPage || ctx_r6.rightNowPage && (node_r16.data.type !== "zone" && node_r16.data.type !== "cmxzone" && node_r16.data.type !== "polygon_zone")));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.multiLocationSelect && !ctx_r6.isRichMapAvailable && (!ctx_r6.rightNowPage || !ctx_r6.energyUtilPage) || (ctx_r6.energyUtilPage || ctx_r6.rightNowPage) && (node_r16.data.type !== "zone" && node_r16.data.type !== "cmxzone" && node_r16.data.type !== "polygon_zone"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.multiLocationSelect && node_r16.data.type === "network" && ctx_r6.isIncluded(node_r16) || ctx_r6.multiLocationSelect && ctx_r6.dataExportPage && node_r16.data.type !== "root" && ctx_r6.checkFloorZoneDisabling(node_r16));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.multiLocationSelect && node_r16.data.type === "network" && !ctx_r6.isIncluded(node_r16));
} }
class WorkspaceLocationHierarchyComponent extends ManageLocationTreeComponent {
    constructor(router_, dataService_, locationService_, cdRef_) {
        super(router_, dataService_, locationService_, cdRef_);
        this.router_ = router_;
        this.dataService_ = dataService_;
        this.locationService_ = locationService_;
        this.cdRef_ = cdRef_;
        this.rightNowPage = false;
        this.energyUtilPage = false;
        this.mysignagePage = false;
        this.workspacePage = false;
        this.rootLocationObj = {};
        this.maxSelectionNumber = 3;
        this.prevSearchString = "";
        this.excludedLocs = [];
        this.dataExportPage = false;
        this.onEvent = ($event) => {
            console.log('onEvent from tree::', $event);
            switch ($event.eventName) {
                case "initialized":
                    console.log("location loading done", new Date().getTime() - this.startTime);
                    this.isTreeInitialised = true;
                    this.treeComponent.treeModel.roots.forEach((root) => {
                        this.rootLocationObj = root.data;
                        if (root.isCollapsed)
                            root.expand();
                    });
                    this.initLocationNodes();
                    setTimeout(() => {
                        if (this.treeComponent) {
                            this.treeComponent.sizeChanged();
                        }
                    }, 100);
                    break;
                case "toggleExpanded":
                    setTimeout(() => {
                        if (this.treeComponent) {
                            this.treeComponent.sizeChanged();
                        }
                    }, 100);
                    break;
            }
            // this.searchTree(this.searchTimestamp);
        };
        this.initLocationNodes = () => {
            if (this.currentFilterLocations &&
                this.currentFilterLocations.length > 0) {
                this.filterLocationIds(this.currentFilterLocations);
            }
            else {
                this.location = this.locationOrginal;
            }
            this.prevFilterLocations = this.currentFilterLocations;
        };
        this.sortChildren = (node) => {
            return node;
        };
        this.clickedLocation = (data) => {
            // if (this.reportType == "REAL_TIME"){
            //   let spacesObj = JSON.parse(sessionStorage.getItem('spacesObj'));
            //   if(data.type == "network" || data.type == "root"){
            //     delete spacesObj['realtimeLocation'];
            //     spacesObj['spacesLocation'] = {id: data.id, name: data.name, type: data.type == "root" ? 'all' : data.type};
            //   }else{
            //     spacesObj['realtimeLocation'] = {id: data.id};
            //     spacesObj['spacesLocation'] = {id: this.rootLocationObj["id"], name: this.rootLocationObj["name"], type: 'all'};
            //   }
            //   this.dataService.setSpacesObject(spacesObj);
            // }
        };
        this.isIncluded = (node) => {
            if (this.excludedLocs && this.excludedLocs.length > 0) {
                if (this.excludedLocs.indexOf(node.data.id) != -1)
                    return false;
                else
                    return true;
            }
            return true;
        };
        this.checkFloorZoneDisabling = (node) => {
            if (this.exportDisableNode && this.exportDisableNode !== '') {
                if (this.exportDisableNode === 'network' && (node.data.type === 'floor' || node.data.type === 'zone' || node.data.type === 'cmxzone' || node.data.type === 'polygon_zone')) {
                    return false;
                }
                else if (this.exportDisableNode === 'floor' && (node.data.type === 'zone' || node.data.type === 'cmxzone' || node.data.type === 'polygon_zone')) {
                    return false;
                }
                else if (this.exportDisableNode === 'network_floor' && (node.data.type === 'zone' || node.data.type === 'cmxzone' || node.data.type === 'polygon_zone')) {
                    return false;
                }
                else {
                    return true;
                }
            }
            return true;
        };
        this.locationInfoMouseOver = (event, id) => {
            $("#loc_info_" + id).addClass("loc-info-show");
        };
        this.locationInfoMouseOut = (event, id) => {
            setTimeout(() => {
                $("#loc_info_" + id).removeClass("loc-info-show");
            }, 2000);
        };
        this.showCameraCountAlert = (node) => {
            const currentNav = this.dataService.getCurrentNav();
            if (node.data.camerasCount === 0 &&
                currentNav != null &&
                currentNav.indexOf("camera-metrics") !== -1) {
                return true;
            }
            else {
                return false;
            }
        };
        this.cameraCountAlertMouseOver = (event, id) => {
            $("#camera-count_" + id).addClass("camera-count-alert-show");
        };
        this.onMouseOverNodeFn = (nodeData) => {
            this.onMouseOverNode(nodeData, 0);
        };
        this.onMouseOutNodeFn = (nodeData) => {
            this.onMouseOutNode(nodeData, 0);
        };
        this.cameraCountAlertMouseOut = (event, id) => {
            setTimeout(() => {
                $("#camera-count_" + id).removeClass("camera-count-alert-show");
            }, 2000);
        };
        this.isRichMapStatus = (node) => {
            let enableCheck = false;
            if (this.permittedLocationTypes !== undefined &&
                this.permittedLocationTypes !== null &&
                this.permittedLocationTypes.length > 0) {
                // check group or org
                if (this.permittedLocationTypes.indexOf(node.data.type) > -1) {
                    if (node.data.type === "organization" ||
                        node.data.type === "meraki" ||
                        node.data.type === "mse") {
                        enableCheck = true;
                    }
                    else if (node.data.type === "group" &&
                        node.data.locationBit & this.locationFlag.Flags.ADD_NETWORK) {
                        enableCheck = true;
                    }
                    else if (node.data.type !== "organization" &&
                        node.data.type !== "group") {
                        enableCheck = true;
                    }
                    // we need to add the richmap flag check
                }
                else {
                    enableCheck = false;
                }
            }
            else {
                enableCheck = true;
            }
            if (this.isRichMapAvailable) {
                if (enableCheck) {
                    if (node.data.richMapStatus) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
            else {
                return enableCheck;
            }
        };
        this.selectNodeFn = (node) => {
            const currentNav = this.dataService.getCurrentNav();
            // workspace manager
            if (currentNav &&
                currentNav.indexOf("space-manager") !== -1 &&
                (node.data.type === "network" || node.data.type === "building")) {
                this.selectNode(node);
            }
            else {
                return;
            }
        };
    }
    ngOnInit() {
        this.makeSearchAPICall = false;
        super.ngOnInit();
        if (this.dataService.getCurrentNav().indexOf('right-now') !== -1) {
            this.rightNowPage = true;
        }
        else {
            this.rightNowPage = false;
        }
        if (this.dataService.getCurrentNav().indexOf('energy-util') !== -1) {
            this.energyUtilPage = true;
        }
        else {
            this.energyUtilPage = false;
        }
        if (this.dataService.getCurrentNav().indexOf('dataexport') !== -1) {
            this.dataExportPage = true;
        }
        else {
            this.dataExportPage = false;
        }
        if (this.dataService.getCurrentNav().indexOf('mysignage') !== -1) {
            this.mysignagePage = true;
        }
        else {
            this.mysignagePage = false;
        }
        if (this.dataService.getCurrentNav().indexOf('space-manager') !== -1) {
            this.workspacePage = true;
        }
        else {
            this.workspacePage = false;
        }
    }
    set disableNode(value) {
        if (value) {
            if (this.dataService.getCurrentNav().indexOf('dataexport') !== -1) {
                this.dataExportPage = true;
            }
            else {
                this.dataExportPage = false;
            }
            this.exportDisableNode = value;
        }
    }
    set searchLocation(value) {
        // this.searchTimestamp = new Date().getTime();
        // if (!value || value.trim() == "")
        //   this.prevSearchString = "";
        // else
        //   this.prevSearchString = value;
        // this.searchTree(this.searchTimestamp);
        // this.subscribeSearchText(value);
        this.enableCustomSearch = true;
        if (value) {
            // this.prevSearchString = customSearchText;
            // this.searchTree(new Date().getTime());
            this.subscribeSearchText(value);
        }
    }
    set filterLocations(filterLocations) {
        this.currentFilterLocations = filterLocations;
        if (this.isTreeInitialised)
            this.initLocationNodes();
    }
    set excludedLocations(excludedLocs) {
        if (excludedLocs)
            this.excludedLocs = excludedLocs;
        else
            this.excludedLocs = [];
    }
    ngOnDestroy() {
        console.log("destory spaces location hierarchy page");
        super.ngOnDestroy();
    }
    selectMultipleNode($event, node) {
        if (this.selectedLocation) {
            // var existingNodeId: number[] = null;
            let index = null;
            this.selectedLocation.filter(function (n, i) {
                if (n.data.id === node.data.id) {
                    index = i;
                    return;
                }
            });
            if (index !== null) {
                super.selectMultipleNode($event, node);
            }
            else {
                if (this.dataExportPage) {
                    super.selectMultipleNode($event, node);
                }
                else if (this.selectedLocation.length < this.maxSelectionNumber) {
                    super.selectMultipleNode($event, node);
                }
                else {
                    // Show error message to user about max selected
                    this.dataService.setToastMessage("You can pin a maximum of 3 locations", 2000, null, null, "error");
                    this.isNodeSelected = false;
                    $event.target["checked"] = false;
                }
            }
        }
        else {
            super.selectMultipleNode($event, node);
        }
    }
}
WorkspaceLocationHierarchyComponent.ɵfac = function WorkspaceLocationHierarchyComponent_Factory(t) { return new (t || WorkspaceLocationHierarchyComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(LocationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
WorkspaceLocationHierarchyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WorkspaceLocationHierarchyComponent, selectors: [["lib-workspace-location-hierarchy"]], inputs: { disableRootCheckbox: "disableRootCheckbox", isRichMapAvailable: "isRichMapAvailable", permittedLocationTypes: "permittedLocationTypes", disableNode: "disableNode", searchLocation: "searchLocation", filterLocations: "filterLocations", excludedLocations: "excludedLocations" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 2, consts: [[3, "nodes", "options", "event", "stateChange"], ["tree", ""], ["treeNodeFullTemplate", ""], ["loadingTemplate", ""], ["treeNodeTemplate", ""], ["class", "pointer", 3, "node", "index", "templates", "ngClass", "style", 4, "ngIf"], ["class", "pointer", 3, "node", "index", "templates", "ngClass", 4, "ngIf"], [3, "node", 4, "ngIf"], [3, "node", "templates", "ngClass"], [1, "pointer", 3, "node", "index", "templates", "ngClass"], [3, "node"], ["class", "location-node-name", 3, "ngClass", "click", "mouseover", "mouseout", 4, "ngIf"], ["class", "location-node-name", 3, "ngClass", 4, "ngIf"], ["class", "zone-alert", 4, "ngIf"], ["class", "camera-count-alert", 4, "ngIf"], ["class", "location-node-name", 4, "ngIf"], ["class", "repotLocationPopupRadio workspacePageRadio", 4, "ngIf"], ["class", "repotLocationPopupRadio", 4, "ngIf"], ["class", "circularCheckbox", 4, "ngIf"], ["class", "location-info", 4, "ngIf"], [1, "location-node-name", 3, "ngClass", "click", "mouseover", "mouseout"], ["href", "javascript:void(0);", 1, "location-name-icon"], [1, "loc-type-icon"], [1, "location-name", 3, "innerHTML", "ngClass", "click"], ["class", "location-count", 3, "mouseover", "mouseout", 4, "ngIf"], ["class", "matchedApDetails", 4, "ngIf"], [1, "location-count", 3, "mouseover", "mouseout"], [1, "matchedApDetails"], [3, "innerHTML"], [1, "location-node-name", 3, "ngClass"], [1, "location-name", 3, "innerHTML", "ngClass"], [1, "zone-alert"], [1, "zone-alert-message", 3, "id"], [1, "camera-count-alert"], [1, "locationInfo"], ["src", "/assets/images/notification_icon.svg", 3, "mouseover"], [1, "camera-count-alert-message", 3, "id"], [1, "location-node-name"], [1, "repotLocationPopupRadio", "workspacePageRadio"], ["type", "radio", "name", "locationRadio", 3, "checked", "id", "value", "click"], [1, "radioButtonLabel", 3, "for"], [1, "repotLocationPopupRadio"], ["class", "radioButtonLabel", 3, "for", 4, "ngIf"], [1, "circularCheckbox"], ["type", "checkbox", "name", "locationChecbox", 3, "checked", "id", "value", "click"], [1, "checkboxLabel", 3, "for"], [1, "location-info"], [1, "loc-info", 3, "id"]], template: function WorkspaceLocationHierarchyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "tree-root", 0, 1);
        i0.ɵɵlistener("event", function WorkspaceLocationHierarchyComponent_Template_tree_root_event_0_listener($event) { return ctx.onEvent($event); })("stateChange", function WorkspaceLocationHierarchyComponent_Template_tree_root_stateChange_0_listener($event) { return ctx.setState($event); });
        i0.ɵɵtemplate(2, WorkspaceLocationHierarchyComponent_ng_template_2_Template, 5, 22, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, WorkspaceLocationHierarchyComponent_ng_template_4_Template, 1, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, WorkspaceLocationHierarchyComponent_ng_template_6_Template, 10, 10, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("nodes", ctx.location)("options", ctx.options);
    } }, directives: [i4.TreeComponent, i1$2.NgIf, i4.TreeNodeChildrenComponent, i1$2.NgClass, i4.TreeNodeWrapperComponent, RowMenuComponent], pipes: [SafeHtmlPipe], styles: ["@charset \"UTF-8\";.locationInfo[_ngcontent-%COMP%]{width:20px}.locationInfo[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:15px}.loc-info[_ngcontent-%COMP%], .camera-count-alert-message[_ngcontent-%COMP%], .zone-alert-message[_ngcontent-%COMP%]{display:none;position:absolute;right:0;left:20px;font-size:12px;color:#fff;background:#565659;width:180px;padding:5px 8px;font-family:CiscoSans;text-transform:initial;z-index:9;margin:5px auto auto}.camera-count-alert-message[_ngcontent-%COMP%]{left:-13em}.zone-alert-message[_ngcontent-%COMP%]{left:-30em}.loc-info[_ngcontent-%COMP%]:before, .camera-count-alert-message[_ngcontent-%COMP%]:before{content:\"\";border-left:7px solid transparent;border-bottom:7px solid #565659;border-right:7px solid transparent;position:absolute;right:11px;top:-7px}.loc-info-show[_ngcontent-%COMP%], .camera-count-alert-show[_ngcontent-%COMP%], .zone-alert-show[_ngcontent-%COMP%]{display:block}.camera-count-alert[_ngcontent-%COMP%], .zone-alert[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle;position:relative}.location-node-name.disable-location[_ngcontent-%COMP%], .location-node-name.disable-location[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:default!important}.location-node-name.disable-location[_ngcontent-%COMP%]   .location-name[_ngcontent-%COMP%]:hover{border:0 none!important;font-family:ciscoSansRegular!important}.location-node-name.disable-location[_ngcontent-%COMP%]{opacity:.5}.modalContent-beta[_ngcontent-%COMP%]{width:300px;left:47%;top:-50%;position:absolute;padding:5px;box-shadow:0 0 20px #0000004d;transform:translate(-50%);-webkit-transform:translateX(-50%);-webkit-box-shadow:0 0 20px rgba(0,0,0,.3);background:#7a7a7a;opacity:1}.modalBody1[_ngcontent-%COMP%]{margin:0;cursor:pointer;opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]{display:flex;height:115px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 10px 10px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .act-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:12px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .modalBody1[_ngcontent-%COMP%]:hover{opacity:1!important}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSansLight;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .beta-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]{display:flex}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title-div[_ngcontent-%COMP%]{margin:20px 0 10px 10px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-image[_ngcontent-%COMP%]{height:100px;width:90px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-title[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;line-height:26px;letter-spacing:.5px}.modalBody1[_ngcontent-%COMP%]   .tag-popup-div[_ngcontent-%COMP%]   .popup-subtitle[_ngcontent-%COMP%]{color:#fff;font-family:CiscoSans;font-size:14px;opacity:.7}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]{width:100%;border-top:1px solid #b2a6a6;text-align:center;padding-top:5px}.modalBody1[_ngcontent-%COMP%]   .popupFooter[_ngcontent-%COMP%]   .popup-footer-text[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:13px;color:#fff}.location-count[_ngcontent-%COMP%]{font-size:11px;color:#7a7a7a}.showDiv-on-Mousehover[_ngcontent-%COMP%]{z-index:1001;position:fixed;background-color:#000;margin-left:-75px;margin-top:-85px}.circularCheckbox[_ngcontent-%COMP%]{padding-right:20px;position:relative;float:right;display:block}.richMapRadio[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]{opacity:1!important}.richMapRadio[_ngcontent-%COMP%]{float:right!important}.workspacePage[_ngcontent-%COMP%]   .repotLocationPopupRadio[_ngcontent-%COMP%]{float:right!important}.workspacePage[_ngcontent-%COMP%]   .repotLocationPopupRadio[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]:checked ~ .radioButtonLabel[_ngcontent-%COMP%]:before{left:0;display:inline-block;vertical-align:middle;background-position:0px 0px;position:absolute;right:-10px;top:-20px;bottom:0;margin:auto;width:auto;height:20px;font-size:24px;content:\"\\e93b\";font-family:icomoon-new;text-align:right;padding-right:0}.workspacePageRadio[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]{opacity:1!important}.displayNone[_ngcontent-%COMP%]{display:none}.tree-node-collapsed.type-network[_ngcontent-%COMP%] > tree-node-wrapper.workspacePage[_ngcontent-%COMP%] > .node-wrapper[_ngcontent-%COMP%] > tree-node-expander[_ngcontent-%COMP%] > .toggle-children-wrapper[_ngcontent-%COMP%]{background:url(/assets/images/building_noLocations.svg) no-repeat 10px center;cursor:default}.tree-node-expanded.type-network[_ngcontent-%COMP%] > tree-node-wrapper.workspacePage[_ngcontent-%COMP%] > .node-wrapper[_ngcontent-%COMP%] > tree-node-expander[_ngcontent-%COMP%] > .toggle-children-wrapper[_ngcontent-%COMP%]{background:url(/assets/images/building_noLocations.svg) no-repeat 10px center;cursor:default}.tree-node-collapsed.type-network[_ngcontent-%COMP%] > tree-node-wrapper.workspacePage[_ngcontent-%COMP%] > .node-wrapper[_ngcontent-%COMP%] > tree-node-expander[_ngcontent-%COMP%] > .toggle-children-wrapper[_ngcontent-%COMP%]:hover{background:url(/assets/images/building_noLocations.svg) no-repeat 10px center;cursor:default}.tree-node-expanded.type-network[_ngcontent-%COMP%]:not(.tree-node-level-1) > tree-node-wrapper[_ngcontent-%COMP%] > .node-wrapper[_ngcontent-%COMP%] > tree-node-expander[_ngcontent-%COMP%] > .toggle-children-wrapper[_ngcontent-%COMP%]:hover{background:url(/assets/images/building_noLocations.svg) no-repeat 10px center;cursor:default}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WorkspaceLocationHierarchyComponent, [{
        type: Component,
        args: [{
                selector: 'lib-workspace-location-hierarchy',
                templateUrl: './workspace-location-hierarchy.component.html',
                styleUrls: ['./workspace-location-hierarchy.component.scss']
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: LocationService }, { type: i0.ChangeDetectorRef }]; }, { disableRootCheckbox: [{
            type: Input
        }], isRichMapAvailable: [{
            type: Input
        }], permittedLocationTypes: [{
            type: Input
        }], disableNode: [{
            type: Input
        }], searchLocation: [{
            type: Input
        }], filterLocations: [{
            type: Input
        }], excludedLocations: [{
            type: Input
        }] }); })();

function Lh2RightnowTreeComponent_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("click", function Lh2RightnowTreeComponent_div_2_div_5_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.clearInput(); });
    i0.ɵɵelementStart(1, "span", 15);
    i0.ɵɵtext(2, "\uE906");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "business-hierarchy-lib.business-location-details.back-text"), " ");
} }
function Lh2RightnowTreeComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "input", 11);
    i0.ɵɵlistener("focus", function Lh2RightnowTreeComponent_div_2_Template_input_focus_1_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.showRecentSearch(); })("focusout", function Lh2RightnowTreeComponent_div_2_Template_input_focusout_1_listener() { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.searchFocusOut(); })("keydown", function Lh2RightnowTreeComponent_div_2_Template_input_keydown_1_listener() { i0.ɵɵrestoreView(_r12); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.inputChanged(); })("keydown.enter", function Lh2RightnowTreeComponent_div_2_Template_input_keydown_enter_1_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.onSearch($event); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 12);
    i0.ɵɵlistener("click", function Lh2RightnowTreeComponent_div_2_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r12); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.clearInput(); });
    i0.ɵɵtext(4, "\uE909");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, Lh2RightnowTreeComponent_div_2_div_5_Template, 5, 3, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(2, 2, "business-hierarchy-lib.hierarchy-base.search-text"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.searchActive);
} }
function Lh2RightnowTreeComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "business-hierarchy-lib.hierarchy-base.enter-atleast-four-letters-to-search-text"), " ");
} }
function Lh2RightnowTreeComponent_div_3_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r19.searchResults && ctx_r19.searchResults.length ? ctx_r19.searchResults.length : ctx_r19.matchingText, " ", i0.ɵɵpipeBind1(2, 2, "business-hierarchy-lib.hierarchy-base.results-found-text"), " ");
} }
function Lh2RightnowTreeComponent_div_3_div_2_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "div", 27);
    i0.ɵɵlistener("click", function Lh2RightnowTreeComponent_div_3_div_2_div_2_div_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r24); const item_r22 = restoredCtx.$implicit; const ctx_r23 = i0.ɵɵnextContext(4); return ctx_r23.goToLocation(item_r22); });
    i0.ɵɵelement(2, "div", 28);
    i0.ɵɵelementStart(3, "div", 29);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r22 = ctx.$implicit;
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r21.getHighlightedName(item_r22.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.getLocationPath(item_r22), " ");
} }
function Lh2RightnowTreeComponent_div_3_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, Lh2RightnowTreeComponent_div_3_div_2_div_2_div_1_Template, 5, 2, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r20.searchResults);
} }
function Lh2RightnowTreeComponent_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, Lh2RightnowTreeComponent_div_3_div_2_div_1_Template, 3, 4, "div", 21);
    i0.ɵɵtemplate(2, Lh2RightnowTreeComponent_div_3_div_2_div_2_Template, 2, 1, "div", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.fourCharTyped());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.searchResults && ctx_r18.searchResults.length);
} }
function Lh2RightnowTreeComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, Lh2RightnowTreeComponent_div_3_div_1_Template, 3, 3, "div", 17);
    i0.ɵɵtemplate(2, Lh2RightnowTreeComponent_div_3_div_2_Template, 3, 2, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.fourCharTyped());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.showRecent && !ctx_r1.newInput);
} }
function Lh2RightnowTreeComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵelementStart(2, "input", 32);
    i0.ɵɵlistener("click", function Lh2RightnowTreeComponent_div_5_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.toggleAllLocations(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "label", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 34);
    i0.ɵɵtext(5, " Show all locations ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r2.showAllLocations);
} }
const _c0 = function (a0) { return { "hide-location": a0 }; };
function Lh2RightnowTreeComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "tree-node-wrapper", 35);
    i0.ɵɵelement(2, "tree-node-children", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r27 = ctx.$implicit;
    const index_r28 = ctx.index;
    const templates_r29 = ctx.templates;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(node_r27.getClass());
    i0.ɵɵclassProp("tree-node", true)("tree-node-expanded", node_r27.isExpanded && node_r27.hasChildren)("tree-node-collapsed", node_r27.isCollapsed && node_r27.hasChildren)("tree-node-leaf", node_r27.isLeaf)("tree-node-active", node_r27.isActive)("tree-node-focused", node_r27.isFocused);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c0, !ctx_r5.canShowLocationAction(node_r27)))("node", node_r27)("index", index_r28)("templates", templates_r29);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("node", node_r27)("templates", templates_r29);
} }
function Lh2RightnowTreeComponent_ng_template_10_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 42);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r32.messageKeys["location-permission-error"], " ");
} }
function Lh2RightnowTreeComponent_ng_template_10_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r30 = i0.ɵɵnextContext().$implicit;
    const ctx_r33 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r33.getRNAppData(node_r30.data.id), " ");
} }
const _c1 = function (a0, a1) { return { "right-now-loc-tooltip": a0, "la-loc-tooltip": a1 }; };
function Lh2RightnowTreeComponent_ng_template_10_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "span", 47);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r30 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r37 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c1, ctx_r37.rightNowApp, ctx_r37.laApp));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r37.getLocationTooltipMessage(node_r30), " ");
} }
function Lh2RightnowTreeComponent_ng_template_10_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵtemplate(1, Lh2RightnowTreeComponent_ng_template_10_div_4_div_1_Template, 3, 5, "div", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r34.showPermissionError && ctx_r34.showToolTipMessage);
} }
function Lh2RightnowTreeComponent_ng_template_10_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelementStart(1, "input", 52);
    i0.ɵɵlistener("click", function Lh2RightnowTreeComponent_ng_template_10_div_5_div_1_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r44); const node_r30 = i0.ɵɵnextContext(2).$implicit; const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.selectSingleNode(node_r30); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 53);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r30 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r39 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationTick-", node_r30.data.id, "");
    i0.ɵɵproperty("checked", ctx_r39.selectedLocation && ctx_r39.selectedLocation.length > 0 && node_r30.id === ctx_r39.selectedLocation[0].id)("value", node_r30.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationTick-", node_r30.data.id, "");
} }
function Lh2RightnowTreeComponent_ng_template_10_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵelementStart(1, "input", 52);
    i0.ɵɵlistener("click", function Lh2RightnowTreeComponent_ng_template_10_div_5_div_2_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r48); const node_r30 = i0.ɵɵnextContext(2).$implicit; const ctx_r46 = i0.ɵɵnextContext(); return ctx_r46.selectSingleNode(node_r30); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 55);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r30 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r40 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationRadio-", node_r30.data.id, "");
    i0.ɵɵproperty("checked", ctx_r40.selectedLocation && ctx_r40.selectedLocation.length > 0 && node_r30.id === ctx_r40.selectedLocation[0].id)("value", node_r30.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationRadio-", node_r30.data.id, "");
} }
const _c2 = function (a0, a1) { return { "location-selected": a0, "child-selected": a1 }; };
function Lh2RightnowTreeComponent_ng_template_10_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵelementStart(1, "input", 57);
    i0.ɵɵlistener("click", function Lh2RightnowTreeComponent_ng_template_10_div_5_div_3_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r52); const node_r30 = i0.ɵɵnextContext(2).$implicit; const ctx_r50 = i0.ɵɵnextContext(); return ctx_r50.selectMultipleNode($event, node_r30); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "label", 58);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r30 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r41 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "locationCheckbox-", node_r30.data.id, "");
    i0.ɵɵproperty("value", node_r30.data.id);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("for", "locationCheckbox-", node_r30.data.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c2, ctx_r41.isLocationSelected(node_r30), ctx_r41.isParentOfSelectedLocation(node_r30)));
} }
function Lh2RightnowTreeComponent_ng_template_10_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵtemplate(1, Lh2RightnowTreeComponent_ng_template_10_div_5_div_1_Template, 3, 4, "div", 48);
    i0.ɵɵtemplate(2, Lh2RightnowTreeComponent_ng_template_10_div_5_div_2_Template, 3, 4, "div", 49);
    i0.ɵɵtemplate(3, Lh2RightnowTreeComponent_ng_template_10_div_5_div_3_Template, 3, 7, "div", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r30 = i0.ɵɵnextContext().$implicit;
    const ctx_r35 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r30.data.access === "Full" && ctx_r35.treeConf.type === "tick" && ctx_r35.enableCheck(node_r30) || (node_r30.data.access === "Full" || node_r30.data.reportAccess) && ctx_r35.isReportsLocation && ctx_r35.treeConf.type === "tick");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r30.data.access === "Full" && ctx_r35.treeConf.type === "radio" && ctx_r35.enableCheck(node_r30) || (node_r30.data.access === "Full" || node_r30.data.reportAccess) && ctx_r35.isReportsLocation && ctx_r35.treeConf.type === "radio");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", node_r30.data.access === "Full" && ctx_r35.treeConf.type === "checkbox" && ctx_r35.enableCheck(node_r30) || (node_r30.data.access === "Full" || node_r30.data.reportAccess) && ctx_r35.isReportsLocation && ctx_r35.treeConf.type === "checkbox");
} }
const _c3 = function (a0) { return { "disabled-location": a0 }; };
function Lh2RightnowTreeComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtemplate(1, Lh2RightnowTreeComponent_ng_template_10_span_1_Template, 2, 1, "span", 38);
    i0.ɵɵelementStart(2, "business-hierarchy-node", 39);
    i0.ɵɵlistener("onhover", function Lh2RightnowTreeComponent_ng_template_10_Template_business_hierarchy_node_onhover_2_listener($event) { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(); return ctx_r55.hoverOnFunc($event); })("onout", function Lh2RightnowTreeComponent_ng_template_10_Template_business_hierarchy_node_onout_2_listener($event) { i0.ɵɵrestoreView(_r56); const ctx_r57 = i0.ɵɵnextContext(); return ctx_r57.hoverOutFunc($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, Lh2RightnowTreeComponent_ng_template_10_div_3_Template, 2, 1, "div", 40);
    i0.ɵɵtemplate(4, Lh2RightnowTreeComponent_ng_template_10_div_4_Template, 2, 1, "div", 41);
    i0.ɵɵtemplate(5, Lh2RightnowTreeComponent_ng_template_10_div_5_Template, 4, 3, "div", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r30 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3, !ctx_r7.checkRightNowActionAllowed(node_r30)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.showPermissionError && !ctx_r7.showToolTipMessage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("setNode", node_r30)("setWlcLocationData", ctx_r7.wlcLocationData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.hasAppData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.checkRightNowActionAllowed(node_r30));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.checkRightNowActionAllowed(node_r30));
} }
const _c4 = function (a0) { return { "hide-tree": a0 }; };
class Lh2RightnowTreeComponent extends ManageLh2TreeComponent {
    constructor(router_, dataService_, lh2Service_, authService_, translate_, cdRef_) {
        super(router_, dataService_, lh2Service_, authService_, translate_, cdRef_);
        this.router_ = router_;
        this.dataService_ = dataService_;
        this.lh2Service_ = lh2Service_;
        this.authService_ = authService_;
        this.translate_ = translate_;
        this.cdRef_ = cdRef_;
        this.showToolTipMessage = true;
        this.appName = "";
        this.rightNowApp = false;
        this.laApp = false;
        this.canShowLocationAction = (node) => {
            this.appName = this.treeConf.appName;
            if (this.appName === "rightNow")
                this.rightNowApp = true;
            else if (this.appName === "locationAnalytics")
                this.laApp = true;
            if (this.treeLoading) {
                return true;
            }
            if (this.treeConf.restrictedLocationId) {
                if (node.data.showLocation) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else if (this.treeConf.restrictedLocations && this.treeConf.restrictedLocations.length) {
                if (this.showAllLocations) {
                    return true;
                }
                if (!this.showAllLocationsSwitch)
                    return true;
                if (node.data.showLocation) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        };
        this.onSelectedNodeRightNow = (event) => {
            if (this.checkRightNowActionAllowed(event.node)) {
                this.onSelectedNode(event);
            }
            else {
                return false;
            }
        };
        this.getRNAppData = (id) => {
            if (this.appName === "rightNow") {
                return this.treeConf.appData[id] ? this.treeConf.appData[id] : "0";
            }
            return this.treeConf.appData[id] ? this.treeConf.appData[id] : "";
        };
        this.checkRightNowActionAllowed = (node) => {
            if (this.treeLoading) {
                return false;
            }
            // if(this.showAllLocationsSwitch)
            //   return true;
            if (!node
                || !node.data)
                return false;
            if (!this.requiredLicenses
                || this.requiredLicenses.length === 0)
                return true;
            if (node.data["licenseType"] &&
                this.requiredLicenses &&
                this.requiredLicenses.indexOf(node.data["licenseType"].toLowerCase()) > -1) {
                if (this.treeConf.permittedLocationTypes &&
                    this.treeConf.permittedLocationTypes.length) {
                    let type = node.data && node.data.type
                        && node.data.type[0] ? node.data.type[0].toLowerCase() : "";
                    if (this.treeConf.appName === "locationAnalytics") {
                        if ((type === "floor" || type === "ap_zone" || type === "polygon_zone" || type === "group" || type === "campus")) {
                            if (node.data.licenseType.indexOf('ACT') !== -1 || node.data.licenseType.indexOf('UNLIMITED') !== -1)
                                return true;
                            else
                                return false;
                        }
                        else {
                            if (this.treeConf.permittedLocationTypes.indexOf(node.data.type[0].toLowerCase()) > -1) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                    }
                    else {
                        if (node.data.type && node.data.type[0]) {
                            if (this.treeConf.permittedLocationTypes.indexOf(node.data.type[0].toLowerCase()) > -1) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                    }
                }
                else if (this.treeConf.restrictedLocations &&
                    this.treeConf.restrictedLocations.length) {
                    if (this.treeConf.restrictedLocations.indexOf(node.data.id) > -1) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        };
        this.getLocationTooltipMessage = (node) => {
            if (this.treeConf.showPermissionError === "false") {
                this.showToolTipMessage = false;
                return "";
            }
            else if (this.treeConf
                && this.treeConf.tooltipMessage
                && this.treeConf.tooltipMessage.length > 0
                && !this.checkRightNowActionAllowed(node)) {
                this.showToolTipMessage = true;
                return this.treeConf.tooltipMessage;
            }
            else {
                this.showToolTipMessage = false;
                return "";
            }
        };
    }
    ngOnInit() {
        super.ngOnInit();
        //   this.appName = this.treeConf.appName;
        // if(this.appName === "rightNow")
        //     this.rightNowApp = true;
        // else if (this.appName === "locationAnalytics")
        //     this.laApp = true;
    }
}
Lh2RightnowTreeComponent.ɵfac = function Lh2RightnowTreeComponent_Factory(t) { return new (t || Lh2RightnowTreeComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(Lh2Service), i0.ɵɵdirectiveInject(AuthService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
Lh2RightnowTreeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: Lh2RightnowTreeComponent, selectors: [["app-lh2-rightnow-tree"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 12, vars: 8, consts: [[1, "lhv2"], [1, "tree-wrapper"], ["class", "tree-search search-input", 4, "ngIf"], ["class", "tree-search-results search-box", 4, "ngIf"], [1, "lh2-tree", 3, "ngClass"], ["class", "all-location-switch", 4, "ngIf"], [3, "nodes", "options", "activate"], ["tree", ""], ["treeNodeFullTemplate", ""], ["treeNodeTemplate", ""], [1, "tree-search", "search-input"], ["type", "text", "id", "search-input", "autocomplete", "off", 3, "placeholder", "focus", "focusout", "keydown", "keydown.enter"], [1, "clear-input", 3, "click"], ["class", "back-link", 3, "click", 4, "ngIf"], [1, "back-link", 3, "click"], [1, "left-arrow"], [1, "tree-search-results", "search-box"], ["class", "search-count-min", 4, "ngIf"], ["class", "search-results", 4, "ngIf"], [1, "search-count-min"], [1, "search-results"], ["class", "search-count", 4, "ngIf"], ["class", "search-items-list", 4, "ngIf"], [1, "search-count"], [1, "search-items-list"], ["class", "search-item", 4, "ngFor", "ngForOf"], [1, "search-item"], [3, "click"], [1, "search-name", 3, "innerHTML"], [1, "search-path"], [1, "all-location-switch"], [1, "circularCheckbox", "displayInlineBlock", "verticalAlignMiddle"], ["type", "checkbox", "id", "all-location-checkbox", "name", "locationChecbox", 3, "checked", "click"], ["for", "all-location-checkbox", 1, "checkboxLabel"], [1, "displayInlineBlock"], [3, "ngClass", "node", "index", "templates"], [3, "node", "templates"], [1, "lh2-node-wrapper", 3, "ngClass"], ["class", "disabled-location-tooltip", 4, "ngIf"], [1, "lh2-loc-name", 3, "setNode", "setWlcLocationData", "onhover", "onout"], ["class", "app-data", 4, "ngIf"], ["class", "loc-action-container location-action", 4, "ngIf"], [1, "disabled-location-tooltip"], [1, "app-data"], [1, "loc-action-container", "location-action"], ["class", "loc-tooltip", 3, "ngClass", 4, "ngIf"], [1, "loc-tooltip", 3, "ngClass"], [1, ""], ["class", "locationPopupTick loc-selection-box", 4, "ngIf"], ["class", "locationPopupRadio loc-selection-box", 4, "ngIf"], ["class", "circularCheckbox loc-selection-box", 4, "ngIf"], [1, "locationPopupTick", "loc-selection-box"], ["type", "radio", "name", "locationRadio", 3, "checked", "id", "value", "click"], [1, "radioTickLabel", 3, "for"], [1, "locationPopupRadio", "loc-selection-box"], [1, "radioButtonLabel", 3, "for"], [1, "circularCheckbox", "loc-selection-box"], ["type", "checkbox", "name", "locationChecbox", 3, "id", "value", "click"], [1, "checkboxLabel", 3, "ngClass", "for"]], template: function Lh2RightnowTreeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, Lh2RightnowTreeComponent_div_2_Template, 6, 4, "div", 2);
        i0.ɵɵtemplate(3, Lh2RightnowTreeComponent_div_3_Template, 3, 2, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, Lh2RightnowTreeComponent_div_5_Template, 6, 1, "div", 5);
        i0.ɵɵelementStart(6, "tree-root", 6, 7);
        i0.ɵɵlistener("activate", function Lh2RightnowTreeComponent_Template_tree_root_activate_6_listener($event) { return ctx.onSelectedNodeRightNow($event); });
        i0.ɵɵtemplate(8, Lh2RightnowTreeComponent_ng_template_8_Template, 3, 22, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(10, Lh2RightnowTreeComponent_ng_template_10_Template, 6, 9, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.enableSearch);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.enableSearch && ctx.searchActive);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c4, ctx.searchActive));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showAllLocationsSwitch);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("nodes", ctx.nodes)("options", ctx.options);
    } }, directives: [i1$2.NgIf, i1$2.NgClass, i4.TreeComponent, i1$2.NgForOf, i4.TreeNodeWrapperComponent, i4.TreeNodeChildrenComponent, BusinessHierarchyNodeComponent], pipes: [i2.TranslatePipe], styles: ["@charset \"UTF-8\";.lh2-loc-name[_ngcontent-%COMP%]{display:table-cell;width:calc(100% - 40px)}.loc-selection-box[_ngcontent-%COMP%]{display:table-cell;width:40px;vertical-align:middle}input[type=checkbox][_ngcontent-%COMP%]:hover ~ .childSelected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -18px;content:\"\"}input[type=checkbox][_ngcontent-%COMP%] ~ .childSelected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -72px;content:\"\"}.locationPopupRadio[_ngcontent-%COMP%]{position:relative}.search-input[_ngcontent-%COMP%]{padding:10px 0;background-color:#fff;font-family:CiscoSans;font-size:14px;line-height:16px;letter-spacing:.5px;color:#000;border-bottom:1px solid #DFDFDF;position:relative}.search-input[_ngcontent-%COMP%]:before{position:absolute;left:12px;top:20px;content:\"\\e915\";font-family:icomoon-new;font-size:16px;width:16px;height:16px;z-index:1;color:#999}.search-input[_ngcontent-%COMP%]   .clear-input[_ngcontent-%COMP%]{position:absolute;right:32px;top:20px;font-family:icomoon-new;font-size:7px;width:15px;height:15px;border-radius:50%;z-index:1;color:#fff;cursor:pointer;padding:0 4px;background:#999;line-height:14px}.search-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{margin:0;background-color:#f7f7f7;border-radius:16.5px;padding:7px 30px 7px 35px;border:1px solid #DFDFDF;position:relative}.search-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{border:1px solid #049fd9}.search-input[_ngcontent-%COMP%]   .press-enter-text[_ngcontent-%COMP%]{margin:5px 0 2px;font-size:10px;line-height:14px;font-family:CiscoSans;text-align:right;color:#444;display:block}.hide-tree[_ngcontent-%COMP%]{display:none;visibility:hidden;opacity:0;height:0}.search-box[_ngcontent-%COMP%]{padding:25px}.search-box[_ngcontent-%COMP%]   .recent-search[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;line-height:16px;letter-spacing:.5px;color:#121212;margin:0}.search-box[_ngcontent-%COMP%]   .recent-search[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:12px;line-height:20px;letter-spacing:.5px;color:#545454;margin:20px 0}.search-items-list[_ngcontent-%COMP%]   .search-item[_ngcontent-%COMP%]{margin:15px 0;cursor:pointer}.search-items-list[_ngcontent-%COMP%]   .search-item[_ngcontent-%COMP%]:hover{background:#dfdfdf}.search-items-list[_ngcontent-%COMP%]   .search-item[_ngcontent-%COMP%]   .search-count[_ngcontent-%COMP%]{font-family:CiscoSans;font-size:14px;line-height:18px;letter-spacing:.5px;color:#121212}.search-items-list[_ngcontent-%COMP%]   .search-item[_ngcontent-%COMP%]   .search-name[_ngcontent-%COMP%]{font-family:\"ciscoSansBold\";font-size:12px;line-height:20px;letter-spacing:.5px;color:#545454}.search-items-list[_ngcontent-%COMP%]   .search-item[_ngcontent-%COMP%]   .search-path[_ngcontent-%COMP%]{font-family:CiscoSansLight;font-size:10px;line-height:18px;letter-spacing:.5px;color:#545454}.back-link[_ngcontent-%COMP%]{padding:15px 10px;font-size:14px;font-family:CiscoSans;line-height:24px;letter-spacing:.5px;color:#00a0d1;cursor:pointer}.back-link[_ngcontent-%COMP%]   .left-arrow[_ngcontent-%COMP%]{color:#00a0d1;font-size:14px;line-height:24px;letter-spacing:.5px;font-family:\"icomoon-new\";padding-right:5px}.app-data[_ngcontent-%COMP%]{text-align:right;padding-right:14px!important;font-family:\"ciscoSansLight\";font-weight:normal}.lh2-loc-name[_ngcontent-%COMP%]:hover ~ .loc-action-container[_ngcontent-%COMP%]   .loc-tooltip[_ngcontent-%COMP%]{display:block;right:100%}.loc-action-container[_ngcontent-%COMP%]{position:relative;display:table-cell;width:40px;vertical-align:middle;z-index:2000}.loc-action-container[_ngcontent-%COMP%]:hover   .loc-tooltip[_ngcontent-%COMP%]{display:block}.right-now-loc-tooltip[_ngcontent-%COMP%]{top:20px;position:absolute;right:0;left:-12em;font-size:12px;color:#fff;background:#565659;width:180px;padding:5px 8px;font-family:CiscoSans;text-transform:initial;z-index:9;margin:5px auto auto;display:none}.right-now-loc-tooltip[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{font-family:\"ciscoSansLight\";font-weight:normal;line-height:24px}.right-now-loc-tooltip[_ngcontent-%COMP%]:hover   .la-loc-tooltip[_ngcontent-%COMP%]{display:block;top:20px;position:absolute;right:0;left:-12em;font-size:12px;color:#fff;background:#565659;width:450px;padding:5px 8px;font-family:CiscoSans;text-transform:initial;z-index:9;margin:5px auto auto;z-index:1}.la-loc-tooltip[_ngcontent-%COMP%]{top:20px;position:absolute;display:none;right:0;left:-25em;font-size:12px;color:#fff;background:#565659;width:450px;padding:5px 8px;font-family:CiscoSans;text-transform:initial;z-index:9;margin:5px auto auto;opacity:1!important;z-index:1}.la-loc-tooltip[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{font-family:\"ciscoSansLight\";font-weight:normal;line-height:24px}.la-loc-tooltip[_ngcontent-%COMP%]:hover   .la-loc-tooltip[_ngcontent-%COMP%]{display:block;top:20px;position:absolute;right:0;left:-25em;font-size:12px;color:#fff;background:#565659;width:450px;padding:5px 8px;font-family:CiscoSans;text-transform:initial;z-index:9;margin:5px auto auto;z-index:1}.lh2-node-wrapper[_ngcontent-%COMP%]{vertical-align:middle;display:table;width:100%}.all-location-switch[_ngcontent-%COMP%]{font-size:14px;font-family:\"ciscoSans\";visibility:hidden}.hide-location[_ngcontent-%COMP%]{height:0!important;opacity:0!important;visibility:hidden!important}.disabled-location-tooltip[_ngcontent-%COMP%]{display:none;position:absolute;font-size:12px;background:#fff;top:35px;padding:4px 10px;opacity:1!important;z-index:1}.disabled-location-tooltip[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:-8px;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-bottom:8px solid #fff}.disabled-location[_ngcontent-%COMP%]:hover   .disabled-location-tooltip[_ngcontent-%COMP%], .disabled-location[_ngcontent-%COMP%]:hover   .la-loc-tooltip[_ngcontent-%COMP%], .disabled-location[_ngcontent-%COMP%]:hover   .right-now-loc-tooltip[_ngcontent-%COMP%], .disabled-location[_ngcontent-%COMP%]:hover   .loc-action-container[_ngcontent-%COMP%], .disabled-location[_ngcontent-%COMP%]:hover   .loc-tooltip[_ngcontent-%COMP%], .disabled-location[_ngcontent-%COMP%]:hover   .location-action[_ngcontent-%COMP%]{display:block}.disabled-location[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]:not(.loc-action-container){opacity:.5;cursor:default}.disabled-location[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]:not(.loc-action-container).location-action{display:none}.location-action[_ngcontent-%COMP%]{display:table-cell;width:40px;vertical-align:middle}input[type=checkbox][_ngcontent-%COMP%] ~ .location-selected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -36px!important;content:\"\"}input[type=checkbox][_ngcontent-%COMP%]:hover ~ .location-selected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -36px!important;content:\"\"}input[type=checkbox][_ngcontent-%COMP%]:hover ~ .child-selected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -72px!important;content:\"\"}input[type=checkbox][_ngcontent-%COMP%] ~ .child-selected[_ngcontent-%COMP%]:before{width:16px;height:16px;display:block;position:absolute;left:0;top:0;background:url(/assets/images/basic/check_boxes.svg) no-repeat center;background-position:0px -72px!important;content:\"\"}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Lh2RightnowTreeComponent, [{
        type: Component,
        args: [{
                selector: 'app-lh2-rightnow-tree',
                templateUrl: './lh2-rightnow-tree.component.html',
                styleUrls: ['./lh2-rightnow-tree.component.scss']
            }]
    }], function () { return [{ type: i1.Router }, { type: DataService }, { type: Lh2Service }, { type: AuthService }, { type: i2.TranslateService }, { type: i0.ChangeDetectorRef }]; }, null); })();

class FileDropDirective {
    constructor() {
        this.filesDropped = new EventEmitter();
        this.filesHovered = new EventEmitter();
    }
    onDrop($event) {
        $event.preventDefault();
        const transfer = $event.dataTransfer;
        this.filesDropped.emit(transfer.files);
        this.filesHovered.emit(false);
    }
    onDragOver($event) {
        $event.preventDefault();
        this.filesHovered.emit(true);
    }
    onDragLeave($event) {
        this.filesHovered.emit(false);
    }
}
FileDropDirective.ɵfac = function FileDropDirective_Factory(t) { return new (t || FileDropDirective)(); };
FileDropDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FileDropDirective, selectors: [["", "fileDrop", ""]], hostBindings: function FileDropDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("drop", function FileDropDirective_drop_HostBindingHandler($event) { return ctx.onDrop($event); })("dragover", function FileDropDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragleave", function FileDropDirective_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); });
    } }, outputs: { filesDropped: "filesDropped", filesHovered: "filesHovered" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileDropDirective, [{
        type: Directive,
        args: [{
                // eslint-disable-next-line @angular-eslint/directive-selector
                selector: "[fileDrop]"
            }]
    }], function () { return []; }, { filesDropped: [{
            type: Output
        }], filesHovered: [{
            type: Output
        }], onDrop: [{
            type: HostListener,
            args: ["drop", ["$event"]]
        }], onDragOver: [{
            type: HostListener,
            args: ["dragover", ["$event"]]
        }], onDragLeave: [{
            type: HostListener,
            args: ["dragleave", ["$event"]]
        }] }); })();

class StatstooltipDirective {
    constructor(tooltipService, element) {
        this.tooltipService = tooltipService;
        this.element = element;
        this.id = "";
        this.ngOnMouseOver = () => {
            if (this.element.nativeElement.getAttribute("tooltip-popup-id") &&
                this.id &&
                this.element.nativeElement.getAttribute("tooltip-popup-id") ===
                    this.id) {
                const tooltip = this.tooltipService.findByIndex(this.id);
                if (tooltip) {
                    tooltip["elemMouseOut"] = false;
                }
                else {
                    this.element.nativeElement.setAttribute("tooltip-popup-id", "");
                }
            }
            else {
                setTimeout(() => {
                    this.doCreate();
                }, 10);
            }
        };
        this.doCreate = () => {
            if (!this.id) {
                this.id = Math.random().toString();
            }
            this.element.nativeElement.setAttribute("tooltip-popup-id", this.id);
            this.tooltipService.pushTooltip(this.id, this.element, this.tooltip);
        };
        this.doDestroy = () => {
            setTimeout(() => {
                const tooltip = this.tooltipService.findByIndex(this.id);
                if (tooltip) {
                    tooltip["elemMouseOut"] = true;
                    this.destroy(tooltip);
                }
            }, 100);
        };
    }
    onMouseOver(e) {
        if (this.timeoutObj)
            clearTimeout(this.timeoutObj);
        this.timeoutObj = setTimeout(() => {
            this.ngOnMouseOver();
        }, 500);
    }
    // @HostListener('document:mousemove', ['$event'])
    // @HostListener('document:mousedown', ['$event'])
    // @HostListener('document:scroll', ['$event'])
    onMouseLeave(e) {
        // console.log('Detected move leave event', e.type);
        this.ngOnDestroy();
    }
    ngOnDestroy() {
        if (this.timeoutObj)
            clearTimeout(this.timeoutObj);
        this.doDestroy();
    }
    destroy(tooltip) {
        if (tooltip && tooltip["elemMouseOut"] && tooltip["popupMouseOut"]) {
            this.element.nativeElement.setAttribute("tooltip-popup-id", "");
            this.tooltipService.removeTooltip(this.id);
        }
    }
}
StatstooltipDirective.ɵfac = function StatstooltipDirective_Factory(t) { return new (t || StatstooltipDirective)(i0.ɵɵdirectiveInject(TooltipService), i0.ɵɵdirectiveInject(i0.ElementRef)); };
StatstooltipDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: StatstooltipDirective, selectors: [["", "pmx-stats-tooltip", ""]], hostBindings: function StatstooltipDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("mouseenter", function StatstooltipDirective_mouseenter_HostBindingHandler($event) { return ctx.onMouseOver($event); })("mouseleave", function StatstooltipDirective_mouseleave_HostBindingHandler($event) { return ctx.onMouseLeave($event); });
    } }, inputs: { tooltip: "tooltip" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StatstooltipDirective, [{
        type: Directive,
        args: [{
                // eslint-disable-next-line @angular-eslint/directive-selector
                selector: "[pmx-stats-tooltip]"
            }]
    }], function () { return [{ type: TooltipService }, { type: i0.ElementRef }]; }, { tooltip: [{
            type: Input
        }], onMouseOver: [{
            type: HostListener,
            args: ["mouseenter", ["$event"]]
        }], 
    // @HostListener('document:mousemove', ['$event'])
    // @HostListener('document:mousedown', ['$event'])
    // @HostListener('document:scroll', ['$event'])
    onMouseLeave: [{
            type: HostListener,
            args: ["mouseleave", ["$event"]]
        }] }); })();

class AuthResponse {
    constructor() { }
}
class AuthData {
    constructor() { }
}

class BreadCrumb {
    constructor() {
        this["label"] = "";
        this["link"] = "";
    }
}

class NavigationAppModel {
    constructor(id, type, label, iconClassName, customClassName, clickable, selected, routeUrl, dataNode, childNodes, badge, externalUrl = false) {
        this._id = id,
            this.type = type;
        this.label = label,
            this.iconClassName = iconClassName,
            this.customClassName = customClassName,
            this.clickable = clickable,
            this.selected = selected,
            this.routeUrl = routeUrl,
            this.dataNode = dataNode,
            this.childNodes = childNodes,
            this.badge = badge,
            this.externalUrl = externalUrl;
    }
}

class Chart {
    constructor() {
        (this.label = ""),
            (this.barSpacing = 10),
            (this.barWidth = 20),
            (this.values = []);
    }
}

class ReportDonut {
    constructor() {
        this.chartData = new DonutChart();
        this.title = "";
        this.count = "";
    }
}

const moment$2 = moment_;
class ReportRequestData {
    constructor() { }
    setData(action, item, filter) {
        this.action = action;
        this.item = item;
        this.filter = filter;
    }
    getAsJson() {
        return {
            data: {
                report: { action: this.action, item: this.item },
                filter: {
                    date: {
                        startLocalDate: this.filter.getConvertedDate(this.filter.startDate),
                        endLocalDate: this.filter.getConvertedDate(this.filter.endDate)
                    },
                    location: this.filter.location,
                    // locations: this.filter.locations,
                    // locationWithChildren: this.filter.locationWithChildren,
                    rootLocation: this.filter.rootLocation
                }
            }
        };
    }
}
class FilterData {
    constructor() {
        this.startDate = null;
        this.endDate = null;
        this.location = "-1";
        // this.locations = [-1];
        // this.locationWithChildren = [-1];
        this.rootLocation = "-1";
    }
    getConvertedDate(d) {
        if (!d)
            return "";
        return moment$2(d).format("YYYY-MM-DD");
    }
}

class VisitLocations {
    constructor() { }
    setFields(latitude, longitude, location, locationPath, visitorsCount, visitsCount) {
        this.latitude = latitude;
        this.longitude = longitude;
        this.location = location;
        this.locationPath = locationPath;
        this.visitorsCount = visitorsCount;
        this.visitsCount = visitsCount;
        return this;
    }
    setLocationId(id) {
        this.locationId = id;
        return this;
    }
}

class AssetLocations {
    constructor() { }
    setFields(latitude, longitude, location, locationPath, childLocations, count) {
        this.latitude = latitude;
        this.longitude = longitude;
        this.location = location;
        this.locationPath = locationPath;
        this.childLocations = childLocations;
        this.count = count;
        return this;
    }
    setLocationId(id) {
        this.locationId = id;
        return this;
    }
}

class AccesscodeFilterPipe {
    transform(values, filter) {
        if (!values || !values.length)
            return [];
        if (!filter)
            return values;
        return values.filter((v) => v.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0);
    }
}
AccesscodeFilterPipe.ɵfac = function AccesscodeFilterPipe_Factory(t) { return new (t || AccesscodeFilterPipe)(); };
AccesscodeFilterPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "accesscodeFilter", type: AccesscodeFilterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccesscodeFilterPipe, [{
        type: Pipe,
        args: [{
                name: "accesscodeFilter"
            }]
    }], null, null); })();

class FilterdataPipe {
    transform(items, value, label) {
        //console.log("FilterdataPipe ::");
        if (!items)
            return [];
        if (!value)
            return items;
        if (value == "" || value == null)
            return [];
        return items.filter((e) => e[label].toLowerCase().indexOf(value.toLowerCase()) > -1);
    }
}
FilterdataPipe.ɵfac = function FilterdataPipe_Factory(t) { return new (t || FilterdataPipe)(); };
FilterdataPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "filterdata", type: FilterdataPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterdataPipe, [{
        type: Pipe,
        args: [{
                name: "filterdata"
            }]
    }], null, null); })();

const moment$1 = moment_;
class ScheduleFilterPipe {
    constructor(translate) {
        this.translate = translate;
        this.months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];
        this.week = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        this.getStaticText = () => {
            this.translate.get('shared-lib').subscribe((res) => {
                this.messageKeys["everyday"] = res.domainListError;
                this.messageKeys["from"] = res.domainAddedSuccess;
                this.messageKeys["to"] = res.domainAddError;
                this.messageKeys["domainDeletedSuccess"] = res.domainDeletedSuccess;
                this.messageKeys["domainRemoveError"] = res.domainRemoveError;
                this.messageKeys["everyday"] = res.everyday;
                this.messageKeys["range_to"] = res.range_to;
                this.messageKeys["range_from"] = res.range_from;
                this.messageKeys["month_dec"] = res.month_dec;
                this.messageKeys["month_nov"] = res.month_nov;
                this.messageKeys["month_oct"] = res.month_oct;
                this.messageKeys["month_sep"] = res.month_sep;
                this.messageKeys["month_aug"] = res.month_aug;
                this.messageKeys["month_jul"] = res.month_jul;
                this.messageKeys["month_jun"] = res.month_jun;
                this.messageKeys["month_may"] = res.month_may;
                this.messageKeys["month_apr"] = res.month_apr;
                this.messageKeys["month_mar"] = res.month_mar;
                this.messageKeys["month_feb"] = res.month_feb;
                this.messageKeys["month_jan"] = res.month_jan;
                this.messageKeys["day_mon"] = res.day_mon;
                this.messageKeys["day_tue"] = res.day_tue;
                this.messageKeys["day_wed"] = res.day_wed;
                this.messageKeys["day_thu"] = res.day_thu;
                this.messageKeys["day_fri"] = res.day_fri;
                this.messageKeys["day_sat"] = res.day_sat;
                this.messageKeys["day_sun"] = res.day_sun;
            });
        };
        this.initializeMonthsWeeks = () => {
            this.months = [
                this.messageKeys["month_jan"],
                this.messageKeys["month_feb"],
                this.messageKeys["month_mar"],
                this.messageKeys["month_apr"],
                this.messageKeys["month_may"],
                this.messageKeys["month_jun"],
                this.messageKeys["month_jul"],
                this.messageKeys["month_aug"],
                this.messageKeys["month_sep"],
                this.messageKeys["month_oct"],
                this.messageKeys["month_nov"],
                this.messageKeys["month_dec"]
            ];
            this.week = [
                this.messageKeys["day_mon"],
                this.messageKeys["day_tue"],
                this.messageKeys["day_wed"],
                this.messageKeys["day_thu"],
                this.messageKeys["day_fri"],
                this.messageKeys["day_sat"],
                this.messageKeys["day_sun"]
            ];
        };
        this.suffixes = ["th", "st", "nd", "rd"];
        this.getDateFormat = (date) => {
            this.year = moment$1(date, "YYYY-MM-DD").format("YYYY");
            this.month = moment$1(date, "YYYY-MM-DD").format("MM");
            this.date = moment$1(date, "YYYY-MM-DD").format("DD");
            if (this.year && this.month && this.date) {
                this.date = this.getDaySuffix(this.date);
                this.month = this.months[Number(this.month) - 1];
                this.dateString = this.date + " " + this.month + " " + this.year;
            }
            else {
                this.dateString = "invalid date";
            }
            return this.dateString;
        };
        this.getDaySuffix = (day) => {
            if ((day) => 11 && day <= 13) {
                return day + "th";
            }
            else {
                switch (day % 10) {
                    case 1:
                        return day + "st";
                    case 2:
                        return day + "nd";
                    case 3:
                        return day + "rd";
                    default:
                        return day + "th";
                }
            }
        };
        this.getWeekDays = (weekIndex) => {
            let weekDays = "";
            const l = weekIndex.length;
            for (const day of weekIndex) {
                weekDays = weekDays.concat(this.week[day - 1]);
                day == 0 || l == 1 ? null : (weekDays += ", ");
            }
            return weekDays;
        };
    }
    transform(value) {
        let date = "";
        if (value.weekDaysSchedule) {
            if (value.weekDaysSchedule.length > 0) {
                this.weekdays = "Every ";
                this.weekdays = this.weekdays.concat(this.getWeekDays(value.weekDaysSchedule));
            }
            else {
                this.weekdays = this.messageKeys["everyday"];
            }
        }
        else {
            this.weekdays = this.messageKeys["everyday"];
        }
        date += this.weekdays;
        if (value.scheduleTimeFrom && value.scheduleTimeTo) {
            this.startDate = this.getDateFormat(value.scheduleTimeFrom);
            this.endDate = this.getDateFormat(value.scheduleTimeTo);
            date += this.messageKeys["from"];
            date += this.startDate;
            date += this.messageKeys["to"];
            date += this.endDate;
        }
        return date;
    }
}
ScheduleFilterPipe.ɵfac = function ScheduleFilterPipe_Factory(t) { return new (t || ScheduleFilterPipe)(i0.ɵɵdirectiveInject(i2.TranslateService, 16)); };
ScheduleFilterPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "scheduleFilter", type: ScheduleFilterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScheduleFilterPipe, [{
        type: Pipe,
        args: [{
                name: "scheduleFilter"
            }]
    }], function () { return [{ type: i2.TranslateService }]; }, null); })();

class SearchPipe {
    transform(values, filter) {
        if (!values || !values.length)
            return [];
        if (!filter)
            return values;
        return values.filter((searchText) => searchText.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0);
    }
}
SearchPipe.ɵfac = function SearchPipe_Factory(t) { return new (t || SearchPipe)(); };
SearchPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "search", type: SearchPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchPipe, [{
        type: Pipe,
        args: [{
                name: "search"
            }]
    }], null, null); })();

class WlcIpFilterPipe {
    transform(values, filter) {
        if (!values || !values.length)
            return [];
        if (!filter)
            return values;
        return values.filter((v) => v.ip.toLowerCase().indexOf(filter.toLowerCase()) >= 0);
    }
}
WlcIpFilterPipe.ɵfac = function WlcIpFilterPipe_Factory(t) { return new (t || WlcIpFilterPipe)(); };
WlcIpFilterPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "wlcIPFilter", type: WlcIpFilterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WlcIpFilterPipe, [{
        type: Pipe,
        args: [{
                name: "wlcIPFilter"
            }]
    }], null, null); })();

class DataexportService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.authenticateSFTP = (connDetails) => {
            const url = this.apiConfig.getAuthenticateSFTPUrl();
            return this.post(url, connDetails).pipe(map(this.extractResponse));
        };
        this.createExport = (configData) => {
            const url = this.apiConfig.getCreateExportUrl();
            return this.post(url, configData).pipe(map(this.extractResponse));
        };
        this.deleteExport = (configData) => {
            const url = this.apiConfig.getDeleteExportUrl();
            return this.post(url, configData).pipe(map(this.extractResponse));
        };
        this.getDataexportListData = () => {
            return this.get(this.apiConfig.getExportDataListUrl()).pipe(map(this.extractResponse));
        };
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
    }
}
DataexportService.ɵfac = function DataexportService_Factory(t) { return new (t || DataexportService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
DataexportService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DataexportService, factory: DataexportService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataexportService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class EngagementsService extends BaseService {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.getSampleStatusResponse = "/assets/data/engagements-status.json?"; // for testing needs to remove this line and also file
        this.getAppCurrentStatus = (appName) => {
            const url = this.apiConfig.getCurrentAppStatusUrl(appName);
            return this.get(url).pipe(map$1(this.extractResponse));
            // testing purpose
            //   return this.get(this.getSampleStatusResponse))
            //       .pipe(map(this.extractResponse));
        };
        this.inviteAppUser = (appName, userInfo) => {
            const serverUrl = this.apiConfig.getAppInviteUrl(appName);
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.deleteAppUser = (appName, userInfo) => {
            const opts = {
                body: userInfo
            };
            const serverUrl = this.apiConfig.getAppDeleteUrl(appName);
            return this.delete(serverUrl, opts).pipe(map$1(this.extractResponse));
        };
        this.getAppUserDeleteStatus = (appName, emailArr) => {
            const serverUrl = this.apiConfig.getAppDeleteStatusUrl(appName);
            return this.post(serverUrl, emailArr).pipe(map$1(this.extractResponse));
        };
        this.editAppUser = (appName, userInfo) => {
            const serverUrl = this.apiConfig.getAppEditUrl(appName);
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.getAppUserList = (appName) => {
            const serverUrl = this.apiConfig.getRBACAppUserListUrl(appName);
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getAppUserInfo = (appName, inviteUserEmail) => {
            const getUserInfoUrl = this.apiConfig.getRBACAppUserInfoUrl(appName, inviteUserEmail);
            return this.get(getUserInfoUrl).pipe(map$1(this.extractResponse));
        };
        this.resendAppInvite = (userInfo) => {
            const serverUrl = this.apiConfig.getResendAppInviteEmailUrl();
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.deleteRule = (ruleObj) => {
            const serverUrl = this.apiConfig.getEngagementsDeleteRuleUrl();
            const options = {
                body: ruleObj
            };
            return this.delete(serverUrl, options).pipe(map$1(this.extractCompleteResponse));
        };
        this.pauseRule = (ruleObj) => {
            const serverUrl = this.apiConfig.getEngagementsPauseRuleUrl();
            return this.post(serverUrl, ruleObj).pipe(map$1(this.extractCompleteResponse));
        };
        this.setRuleLive = (ruleObj) => {
            const serverUrl = this.apiConfig.getPEngagementsMakeRuleLiveUrl();
            return this.post(serverUrl, ruleObj).pipe(map$1(this.extractCompleteResponse));
        };
        this.getRuleDetails = (ruleId) => {
            const serverUrl = this.apiConfig.getEngagementsRuleDetailsUrl() + "/" + ruleId;
            return this.get(serverUrl).pipe(map$1(this.extractResponseData));
        };
        this.getRulesList = (locationId, ruleType) => {
            const bodyPayload = {
                locationId: locationId.toString(),
                ruleType: ruleType
            };
            const serverUrl = this.apiConfig.getEngagementsRulelistUrl();
            return this.post(serverUrl, bodyPayload).pipe(map$1(this.extractResponseData));
        };
        this.extractTreeData = (res) => {
            try {
                this.startTime = new Date().getTime();
                const responseString = res; //.text();
                // console.log("responseString :: ", responseString)
                const p1 = responseString.indexOf(LocationRow.locTableKey);
                if (p1 == -1)
                    return JSON.parse(responseString);
                const p2 = p1 + LocationRow.locTableKey.length;
                const p3 = responseString.indexOf('"', p2);
                const locationTableData = responseString.substring(p2, p3);
                const resp = JSON.parse(responseString.substring(0, p1) +
                    responseString.substring(p3 + 1));
                if (resp.status == true && resp.data != null) {
                    const locationWrapper = this.utils.locationUtil.convertTree(resp.data, locationTableData);
                    this.dataService.setLocationArray(locationWrapper.locationsMap); //locationsArray
                    // setting mongodb ids and graph db ids in dataservice
                    this.dataService.setMongoDBIdsMap(locationWrapper.locationsMap);
                    this.dataService.setGraphDBIdsMap(locationWrapper.locationsMap);
                    this.dataService.setLocationObjectArray(locationWrapper.locationsMap);
                    this.dataService.setLicenseDetails(locationWrapper.licenseDetails);
                    delete locationWrapper.locationsMap;
                    delete locationWrapper.locationsArray;
                    delete locationWrapper.licenseDetails;
                    this.dataService.setLocationTreeArray(locationWrapper);
                    setTimeout(() => {
                        let locWrapper;
                        let userCountResponse;
                        locWrapper = this.dataService.getLocationWrap();
                        userCountResponse = this.dataService.getUserCountResponse();
                        if (userCountResponse !== undefined &&
                            userCountResponse !== null &&
                            JSON.stringify(userCountResponse) !== "{}") {
                            this.updateCount(locWrapper, userCountResponse, "user");
                        }
                    }, 2000);
                    console.log("(extractTreeData) locations converted into tree", new Date().getTime() - this.startTime);
                    return locationWrapper;
                }
                else {
                    throw throwError(res.json().message);
                }
            }
            catch (e) {
                // an error occurred
                throw throwError(res.json());
            }
        };
        this.updateCount = (locationWrapper, userCountResponse, type) => {
            if (type === "user") {
                let locationUserCountMap;
                if (userCountResponse && userCountResponse.status) {
                    locationUserCountMap = userCountResponse.data.locations
                        ? userCountResponse.data.locations
                        : {};
                    const adminsCount = userCountResponse.data.admins;
                    const rootLocation = locationWrapper.location[0];
                    const rootLocationId = rootLocation.id;
                    const locationsMap = this.dataService.getLocationMap();
                    locationsMap.forEach((val, locationId) => {
                        let locationObj;
                        let locId;
                        locId = locationId;
                        locationObj = val;
                        // adminsCount to root location
                        if (locId === rootLocationId) {
                            locationObj.userCount = adminsCount;
                            locationObj.userClickable = locationObj.userCount > 0;
                            locationsMap.set(locId, locationObj);
                            locationWrapper.locationsMap = locationsMap;
                        }
                        Object.keys(locationUserCountMap).map((key) => {
                            if (rootLocationId != parseInt(key) &&
                                locId === parseInt(key)) {
                                locationObj.userCount = locationUserCountMap[key];
                                locationObj.userClickable =
                                    locationObj.userCount > 0;
                                locationsMap.set(locId, locationObj);
                                locationWrapper.locationsMap = locationsMap;
                            }
                        });
                    });
                    // update all the values in dataservice
                    this.dataService.setLocationArray(locationWrapper.locationsMap); //locationsArray
                    this.dataService.setLocationObjectArray(locationWrapper.locationsMap);
                }
            }
        };
        this.rulesList = (locationId, ruleType) => {
            const bodyPayload = {
                locationId: locationId.toString(),
                ruleType: ruleType
            };
            const serverUrl = this.apiConfig.getEngagementRuleslistUrl();
            return this.post(serverUrl, bodyPayload).pipe(map$1(this.extractCompleteResponse));
        };
        this.saveRule = (saveConfig) => {
            const body = saveConfig;
            const serverUrl = this.apiConfig.getEngagementRulesSaveUrl();
            return this.post(serverUrl, body).pipe(map$1(this.extractCompleteResponse));
        };
        this.updateRule = (saveConfig) => {
            const body = saveConfig;
            const serverUrl = this.apiConfig.getEngagementRulesUpdateUrl();
            return this.post(serverUrl, body).pipe(map$1(this.extractCompleteResponse));
        };
        this.extractCompleteResponse = (res) => {
            return res;
        };
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.utils = new Utils(this.logger);
    }
    static getInstance() {
        if (EngagementsService.instance === null) {
            EngagementsService.instance = new EngagementsService(null);
        }
        return EngagementsService.instance;
    }
    getLocationTree() {
        console.log("getting locations, in location service : getLocationTree");
        this.startTime = new Date().getTime();
        const options = {
            responseType: "text"
        };
        return this.get(this.apiConfig.getEngagementsLocationListUrl(), options).pipe(map$1(this.extractTreeData));
    }
}
EngagementsService.instance = null;
EngagementsService.ɵfac = function EngagementsService_Factory(t) { return new (t || EngagementsService)(i0.ɵɵinject(i0.Injector)); };
EngagementsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EngagementsService, factory: EngagementsService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EngagementsService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: i0.Injector }]; }, null); })();
const engagementsServiceFactory = () => {
    return EngagementsService.getInstance();
};
const ENGAGEMENTS_SERVICE_PROVIDER = [
    {
        provide: EngagementsService,
        deps: [],
        useFactory: engagementsServiceFactory
    }
];

class GodDashboardService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        //Reading from local config
        this.getRevenueConfigUrl = "";
        this.extractResponseData = (res) => {
            return res.json().data;
        };
        this.extractResponse = (res) => {
            return res.json();
        };
        this.getGodDashboardConfig = (locationId) => {
            let serverUrl;
            if (locationId != "-1")
                serverUrl =
                    this.apiConfig.getGodDashboardUrl() +
                        "/?locationId=" +
                        locationId;
            else
                serverUrl = this.apiConfig.getGodDashboardUrl();
            return this.get(serverUrl);
        };
        this.getGodCustomerStats = (locationId) => {
            let serverUrl;
            if (locationId != "-1")
                serverUrl =
                    this.apiConfig.getGodCustomerStatsUrl() +
                        "/?locationId=" +
                        locationId;
            else
                serverUrl = this.apiConfig.getGodCustomerStatsUrl();
            return this.get(serverUrl);
        };
        this.getRevenueConfig = () => {
            const headers = new HttpHeaders({
                "Content-Type": "multipart/form-data"
            });
            const options = {
                headers
            };
            //let serverUrl = this.apiConfig.getSpacesListUrl();
            return this.get(this.getRevenueConfigUrl, options);
        };
        this.extractCompleteResponse = (res) => {
            return res.json();
        };
    }
}
GodDashboardService.ɵfac = function GodDashboardService_Factory(t) { return new (t || GodDashboardService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
GodDashboardService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GodDashboardService, factory: GodDashboardService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GodDashboardService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class HTTPClientInterceptor {
    constructor() { }
    intercept(req, next) {
        return next.handle(req).pipe(tap((event) => {
            // console.log('intercept event', event);
            if (event instanceof HttpResponseBase) {
                const response = event;
                // const headers = response["headers"];
                // sessionStorage.setItem("showMagneticLayout", "false");
                // if (headers) {
                // console.log('headers magnetic-layout', headers.get('magnetic-layout'));
                // const showMagneticLayout = headers.get('magnetic-layout')
                // if (showMagneticLayout)
                // 	sessionStorage.setItem("showMagneticLayout", showMagneticLayout);
                // }
                if (response && response["body"]) {
                    let redirect_url = response["body"]["X-Redirect"];
                    if (response.status === 210 &&
                        !response["body"].status &&
                        redirect_url) {
                        if (redirect_url.indexOf("://") > 0) {
                            // Allow 's://' schema also
                            window.location.href = redirect_url;
                        }
                        else {
                            if (redirect_url.indexOf("/") !== 0) {
                                redirect_url = "/" + redirect_url;
                            }
                            const getUrl = window.location;
                            window.location.href =
                                getUrl.protocol +
                                    "//" +
                                    getUrl.host +
                                    redirect_url;
                        }
                        return;
                    }
                }
            }
        }));
    }
}
HTTPClientInterceptor.ɵfac = function HTTPClientInterceptor_Factory(t) { return new (t || HTTPClientInterceptor)(); };
HTTPClientInterceptor.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HTTPClientInterceptor, factory: HTTPClientInterceptor.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HTTPClientInterceptor, [{
        type: Injectable
    }], function () { return []; }, null); })();

class IntegrationService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.createNewActivationUrl = this.apiConfig.getCreateNewActivationUrl();
        this.getListActivationUrl = this.apiConfig.getListActivationUrl();
        this.getRegenerateTokenUrl = this.apiConfig.getRegenerateTokenUrl();
        this.getDeleteActivationUrl = this.apiConfig.getDeleteActivationUrl();
        this.getKnowMoreContentUrl = this.apiConfig.getKnowMoreContentUrl();
        this.getIntegrationActivationUrl = this.apiConfig.getIntegrationActivationUrl();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.createNewActivation = (nameObj) => {
            const url = this.createNewActivationUrl;
            return this.post(url, nameObj).pipe(map(this.extractResponse));
        };
        this.listActivation = () => {
            const url = this.getListActivationUrl;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.regenToken = (tokenId) => {
            const url = this.getRegenerateTokenUrl + tokenId;
            return this.post(url, {}).pipe(map(this.extractResponse));
        };
        this.deleteActivation = (tokenId) => {
            const url = this.getDeleteActivationUrl + tokenId;
            return this.delete(url).pipe(map(this.extractResponse));
        };
        this.getKnowMoreContent = () => {
            const url = this.getKnowMoreContentUrl;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getIntegrationActivation = (integrationId) => {
            const url = this.getIntegrationActivationUrl;
            return this.get(url + integrationId).pipe(map(this.extractResponse));
        };
        this.registerIntegrationActivation = (integrationId, data) => {
            const url = this.getIntegrationActivationUrl;
            return this.post(url + integrationId, data).pipe(map(this.extractResponse));
        };
        this.authenticateIntegrationActivation = (integrationId, data) => {
            const url = this.getIntegrationActivationUrl;
            return this.put(url + integrationId, data).pipe(map(this.extractResponse));
        };
        this.deleteIntegrationActivation = (integrationId) => {
            const url = this.getIntegrationActivationUrl;
            return this.delete(url + integrationId).pipe(map(this.extractResponse));
        };
    }
}
IntegrationService.ɵfac = function IntegrationService_Factory(t) { return new (t || IntegrationService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
IntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IntegrationService, factory: IntegrationService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IntegrationService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class IntegrationsBaseService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.activateCalendarUrl = this.apiConfig.activateCalendarUrl();
        this.removeCalendarActivationUrl = this.apiConfig.removeCalendarActivationUrl();
        this.getCalendarActivationInfoUrl = this.apiConfig.getCalendarActivationInfoUrl();
        this.clearCalendarActivationUrl = this.apiConfig.clearCalendarActivationUrl();
        this.mappedRoomsUrl = this.apiConfig.mappedRoomsUrl();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.activateCalendar = (activationInput) => {
            const url = this.activateCalendarUrl;
            return this.post(url, activationInput).pipe(map(this.extractResponse));
        };
        this.removeCalendarActivation = (spacesTenantId, clientId, accountId, appName) => {
            const url = this.removeCalendarActivationUrl + "?spacesTenantId=" + spacesTenantId + "&clientId=" + clientId + "&accountId=" + accountId + "&appName=" + appName;
            return this.delete(url).pipe(map(this.extractResponse));
        };
        this.clearCalendarActivation = (spacesTenantId, clientId, accountId, appName) => {
            const url = this.clearCalendarActivationUrl + "?spacesTenantId=" + spacesTenantId + "&clientId=" + clientId + "&accountId=" + accountId + "&appName=" + appName;
            return this.delete(url).pipe(map(this.extractResponse));
        };
        this.getCalendarActivationInfo = (spacesTenantId, clientId, accountId) => {
            const url = this.getCalendarActivationInfoUrl + "?spacesTenantId=" + spacesTenantId + "&clientId=" + clientId + "&accountId=" + accountId;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getMappedRooms = (spacesTenantId, clientId, accountId, appName) => {
            const url = this.mappedRoomsUrl + "?spacesTenantId=" + spacesTenantId + "&clientId=" + clientId + "&accountId=" + accountId + "&appName=" + appName;
            return this.get(url).pipe(map(this.extractResponse));
        };
    }
}
IntegrationsBaseService.ɵfac = function IntegrationsBaseService_Factory(t) { return new (t || IntegrationsBaseService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
IntegrationsBaseService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IntegrationsBaseService, factory: IntegrationsBaseService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IntegrationsBaseService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class IoTWebSocketService {
    constructor() {
        this.subject = null;
        this.connected = false;
    }
    connect(url) {
        if (!this.subject) {
            this.subject = this.create(url);
        }
        return this.subject;
    }
    disconnect() {
        if (this.subject) {
            this.subject.complete();
            this.subject = null;
            this.connected = false;
            console.log("WS-SERVICE :: Successfully disconnected: ");
        }
    }
    create(url) {
        this.ws = new WebSocket(url);
        console.log("WS-SERVICE :: create :: ready state:: " + this.ws.readyState);
        let observable = Rx.Observable.create((obs) => {
            this.ws.onopen = (event) => {
                console.log("WS-SERVICE :: opened :: ready state:: " + this.ws.readyState);
                console.log("WS-SERVICE :: Successfully connected ");
            };
            this.ws.onmessage = (event) => {
                obs.next(event);
            };
            this.ws.onerror = (event) => {
                console.log("WS-SERVICE :: on error :: " + event);
            };
            this.ws.onclose = (event) => {
                obs.complete();
                if (this.connected) {
                    console.log("WS-SERVICE :: Connection closed. Reconnecting..."); // The connection was open and it closed, try to reconnect
                    if (this.subject) {
                        this.subject.complete();
                        this.subject = null;
                    }
                    setTimeout(() => this.connect(url), 10000); // Reconnect after 10 seconds
                }
            };
        });
        let observer = {
            next: (data) => {
                console.log("WS-SERVICE :: CREATED observer :: ready state:: " + this.ws.readyState);
                if (this.ws.readyState === WebSocket.OPEN) {
                    console.log("WS-SERVICE :: CREATED data:: " + JSON.stringify(data));
                    this.ws.send(JSON.stringify(data));
                }
                else if (this.ws.readyState === WebSocket.CLOSED) {
                    console.log("WS-SERVICE :: trying to reconnect");
                    this.connected = false;
                    if (this.subject) {
                        this.subject.complete();
                        this.subject = null;
                    }
                    this.connect(url); // Reconnect immediately
                }
            },
            complete: () => {
                if (this.ws.readyState === WebSocket.OPEN) {
                    this.ws.close();
                }
            },
            error: (err) => {
                console.log("WS-SERVICE :: Error :: " + err);
            }
        };
        this.connected = true; // Mark the connection as established
        return Rx.Subject.create(observer, observable);
    }
}
IoTWebSocketService.ɵfac = function IoTWebSocketService_Factory(t) { return new (t || IoTWebSocketService)(); };
IoTWebSocketService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IoTWebSocketService, factory: IoTWebSocketService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IoTWebSocketService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class IoTWebSocketConnection {
    constructor(wsService) {
        this.wsService = wsService;
        this.ws_url = "";
        this.disconnect = () => {
            console.log("WS-CONNECTION :: Entering disconnect ");
            this.messages = this.wsService.disconnect();
            this.messages = null;
        };
        this.connect = (baseUrl, sysToken) => {
            this.ws_url = baseUrl + '&sys-token=' + sysToken;
            console.log("WS-CONNECTION :: Entering connect :: URL :: " + baseUrl);
            this.messages = this.wsService.connect(this.ws_url).pipe(map((response) => {
                console.log("WS-CONNECTION :: Entering connect :: response :: " + response);
                try {
                    if (typeof response.data === "string") {
                        let data = JSON.parse(response.data);
                        // console.log('JSON Parse Message', data);
                        return data;
                    }
                }
                catch (err) {
                    console.log("WS-CONNECTION :: Entering connect :: ERROR :: " + err);
                }
            }));
        };
        // this.messages = <Subject<Message>>wsService.connect(this.ws_url).map(
        //   (response: MessageEvent): Message => {
        //     // console.log('Message', response);
        //     let data = JSON.parse(response.data);
        //     // console.log('JSON Parse Message', data);
        //     return data
        //   }
        // );
    }
}
IoTWebSocketConnection.ɵfac = function IoTWebSocketConnection_Factory(t) { return new (t || IoTWebSocketConnection)(i0.ɵɵinject(IoTWebSocketService)); };
IoTWebSocketConnection.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IoTWebSocketConnection, factory: IoTWebSocketConnection.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IoTWebSocketConnection, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: IoTWebSocketService }]; }, null); })();

class MapService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        //apsAndFloorMapsUrl = "/assets/data/aps-floor-maps.json";
        this.getApsAndFloorMaps = (locationId) => {
            const serverUrl = this.apiConfig.getApsAndFloorMapsUrl() +
                "?locationId=" +
                locationId;
            return this.get(serverUrl).pipe(map(this.extractCompleteResponse));
        };
        this.getFloorMaps = (locationId) => {
            const serverUrl = this.apiConfig.getFloorMapsUrl() + "?locationId=" + locationId;
            return this.get(serverUrl).pipe(map(this.extractCompleteResponse));
        };
        this.getMapsImageAsByte = (payload) => {
            const serverUrl = this.apiConfig.getMapsImageAsByte();
            return this.post(serverUrl, payload).pipe(map(this.extractCompleteResponse));
        };
        this.getMapServiceFloorInfo = (locationId) => {
            const serverUrl = this.apiConfig.getMapServiceFloorInfoUrl() +
                "?locationId=" +
                locationId;
            return this.get(serverUrl).pipe(map(this.extractCompleteResponse));
        };
        this.uploadImageFile = (files, filePath, mc, locationId) => {
            const formData = new FormData();
            formData.append("upload", files[0]);
            formData.append("filePath", filePath);
            formData.append("locationId", locationId);
            formData.append("mapConfig", mc);
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            return this.post(this.apiConfig.getMapImageUploadUrl(), formData, options).pipe(map(this.extractCompleteResponse));
        };
        this.updateMerakiMap = (fid) => {
            const serverUrl = this.apiConfig.updateMerakiMapUrl() + "?floorMapId=" + fid;
            return this.get(serverUrl).pipe(map(this.extractCompleteResponse));
        };
        this.updateMseMap = (fid) => {
            const serverUrl = this.apiConfig.updateMseMapUrl() + "?floorMapId=" + fid;
            return this.get(serverUrl).pipe(map(this.extractCompleteResponse));
        };
        this.updateMicelloMap = (payload) => {
            const formData = new FormData();
            return this.post(this.apiConfig.updateMicelloMapUrl(), payload).pipe(map(this.extractCompleteResponse));
        };
        this.getMseMap = (id, locationId) => {
            const obj = {
                locationId: locationId,
                id: id
            };
            const serverUrl = this.apiConfig.getMSEImageUrl();
            return this.post(serverUrl, obj).pipe(map(this.extractCompleteResponse));
        };
        this.updateImageMap = (payload) => {
            const formData = new FormData();
            return this.post(this.apiConfig.updateImageMapUrl(), payload).pipe(map(this.extractCompleteResponse));
        };
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractCompleteResponse = (res) => {
            return res;
        };
        this.fetchCmxSites = (payload) => {
            const options = {
                responseType: "json",
                headers: new HttpHeaders({
                    Accept: "application/json",
                    "Content-Type": "application/json"
                })
            };
            const serverUrl = this.apiConfig.getCmxSitesUrl();
            return this.get(serverUrl, options).pipe(map(this.extractCompleteResponse));
        };
        this.importCmxSites = (file) => {
            const serverUrl = this.apiConfig.importCmxSitesUrl();
            const formData = new FormData();
            formData.append("file", file[0]);
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            return this.post(serverUrl, formData, options).pipe(map(this.extractCompleteResponse));
        };
        this.uploadPrimeMapsZipFile = (fileData) => {
            const formData = new FormData();
            formData.append("file", fileData[0], fileData[0].name);
            // formData.append('fileType', 'gz');
            const serverUrl = this.apiConfig.getUploadPrimeMapsZipFileURL();
            const date = new Date();
            // serverUrl = serverUrl + date.getMilliseconds();
            const option = {
                skipContentType: true,
                headers: new HttpHeaders({
                    responseType: "json"
                    // 'x-requested-with' : 'XMLHttpRequest'
                })
            };
            return this.post(serverUrl, formData, option).pipe(map(this.extractCompleteResponse));
        };
        this.uploadDNACMapsZipFile = (fileData) => {
            const formData = new FormData();
            formData.append("file", fileData[0], fileData[0].name);
            // formData.append('fileType', 'gz');
            const serverUrl = this.apiConfig.getUploadDNACMapsZipFileURL();
            const date = new Date();
            // serverUrl = serverUrl + date.getMilliseconds();
            const option = {
                skipContentType: true,
                headers: new HttpHeaders({
                    responseType: "json"
                    // 'x-requested-with' : 'XMLHttpRequest'
                })
            };
            return this.post(serverUrl, formData, option).pipe(map(this.extractCompleteResponse));
        };
        this.getUploadHistory = () => {
            const serverUrl = this.apiConfig.getUploadHistoyUrl();
            return this.get(serverUrl).pipe(map(this.extractCompleteResponse));
        };
        this.getUploadedStatus = (sessionId) => {
            const serverUrl = this.apiConfig.getMapsUploadedStatus();
            return this.get(serverUrl + sessionId).pipe(map(this.extractCompleteResponse));
        };
    }
}
MapService.ɵfac = function MapService_Factory(t) { return new (t || MapService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
MapService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MapService, factory: MapService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MapService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class MonitorService extends BaseService {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.extractCompleteResponse = (res) => {
            return res;
        };
        this.getMonitorResponse = (name) => {
            const serverUrl = this.apiConfig.getMonitorStatusUrl();
            const body = {};
            const options = {
                responseType: "json"
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractResponseData));
        };
        this.getSupportResponse = () => {
            const serverUrl = this.apiConfig.getSupportStatusUrl();
            const body = {};
            const options = {
                responseType: "json"
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractResponseData));
        };
        this.getAppDownDetailedList = (appName, appType) => {
            const serverUrl = this.apiConfig.getMonitoringAppsDownUrl();
            const body = {
                name: appName,
                type: appType
            };
            const options = {
                responseType: "json"
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractResponseData));
        };
        this.getReportDateAnomalyResponse = (repDate) => {
            const serverUrl = this.apiConfig.getReportDateAnomalyUrl(repDate);
            const body = {
                customer: name
            };
            const options = {
                responseType: "json"
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractResponseData));
        };
        this.getSummaryResponse = () => {
            const serverUrl = this.apiConfig.getMonitorSummaryUrl();
            const body = {};
            const options = {
                responseType: "json"
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractResponseData));
        };
        this.getLocUpdatesResponse = () => {
            const serverUrl = this.apiConfig.getMonitorLocUpdateUrl();
            const body = {};
            const options = {
                responseType: "json"
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractCompleteResponse));
        };
        this.getPartnerAppsDetailsResponse = () => {
            const serverUrl = this.apiConfig.getMonitorPartnerAppsDetailsUrl();
            const body = {};
            const options = {
                responseType: "json"
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractCompleteResponse));
        };
        this.getOneWeekAnomalyResponse = () => {
            const serverUrl = this.apiConfig.getMonitorOneWeekAnomalyUrl();
            const body = {};
            const options = {
                responseType: "json"
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractResponseData));
        };
        this.getAppsResponse = () => {
            const serverUrl = this.apiConfig.getMonitorAppsUrl();
            const body = {};
            const options = {
                responseType: "json"
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractResponseData));
        };
        this.getEnterpriseIntegResponse = () => {
            const serverUrl = this.apiConfig.getMonitorEnterpriseIntegUrl();
            const body = {};
            const options = {
                responseType: "json"
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractResponseData));
        };
        this.getAppLatencyResponse = () => {
            const serverUrl = this.apiConfig.getMonitorAppLatencyUrl();
            const body = {};
            const options = {
                responseType: "json"
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractResponseData));
        };
        this.getPartnerAppsResponse = () => {
            const serverUrl = this.apiConfig.getMonitorPartnerAppsUrl();
            const body = {};
            const options = {
                responseType: "json"
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractResponseData));
        };
        this.getConnectorDetails = (connectorId) => {
            const serverUrl = this.apiConfig.getConnectorDetailsUrl(connectorId);
            const body = {};
            const options = {
                responseType: "json"
            };
            return this.post(serverUrl, body, options).pipe(map(this.extractCompleteResponse));
        };
    }
}
MonitorService.ɵfac = function MonitorService_Factory(t) { return new (t || MonitorService)(i0.ɵɵinject(i0.Injector)); };
MonitorService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MonitorService, factory: MonitorService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonitorService, [{
        type: Injectable
    }], function () { return [{ type: i0.Injector }]; }, null); })();

class PartnerAppsService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.checkPartnerApi = this.apiConfig.getPartnerUrl() + "?tenantId=";
        this.listPartnerAppsApi = this.apiConfig.getPartnerApssListUrl();
        this.updatePartnerAppsApi = this.apiConfig.updatePartnerApps();
        this.getOauthCustomerInfo = this.apiConfig.getOauthCustomerInfo();
        this.activatePartnerApps = this.apiConfig.activatePartnerApps();
        this.savePartnerCustomerInfo = this.apiConfig.getSavePartnerCustomerInfo();
        this.getPartnerAppSSOLoginToken = this.apiConfig.getPartnerAppSSOLoginToken() + "?appId=";
        this.validateSSOLoginToken = this.apiConfig.validateSSOToken();
        this.createPartnerAppsApi = this.apiConfig.createPartnerApps();
        this.sandboxCustomerUrl = this.apiConfig.getSandboxCustomers();
        this.checkPartnerLicenseStatusApi = this.apiConfig.checkPartnerLicenseStatusUrl() + "?tenantId=";
        this.getPartnerLicenseInfoApi = this.apiConfig.getPartnerLicenseInfoUrl() + "?tenantId=";
        this.updatePartnerLicenseApi = this.apiConfig.updatePartnerLicenseApiUrl();
        this.getLicenseAgreementUrl = this.apiConfig.getLicenseAgreementUrl();
        this.deleteImgUrl = this.apiConfig.getDeleteImgUrl();
        this.getCustomEvents = this.apiConfig.getCustomEventsUrl();
        this.getAdvancePartnerUrl = this.apiConfig.getAdvancePartnerUrl();
        this.appCenterFiltersUrl = this.apiConfig.getAppCenterFiltersUrl();
        this.appActivationLicenseUrl = this.apiConfig.getAppActivationLicenseUrl();
        this.checkTNCAcceptedUrl = this.apiConfig.getCheckTNCAcceptedUrl();
        this.saveTNCAcceptedUrl = this.apiConfig.getSaveTNCAcceptedUrl();
        this.compatibleDevicesUrl = this.apiConfig.getCompatibleDevicesUrl();
        this.searchPartnerUrl = this.apiConfig.searchPartnerUrl();
        this.checkCustomTNCAcceptedUrl = this.apiConfig.getCheckCustomTNCAcceptedUrl();
        this.saveCustomTNCAcceptedUrl = this.apiConfig.getSaveCustomTNCAcceptedUrl();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getPartnerAppList = () => {
            const url = this.listPartnerAppsApi;
            //let url = this.listPartnerAppsApi + 129;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.checkPartnerApp = (tenantId) => {
            const url = this.checkPartnerApi + tenantId;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.checkPartnerLicenseAgreed = (tenantId) => {
            const url = this.checkPartnerLicenseStatusApi + tenantId;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getPartnerLicenseInfo = (tenantId) => {
            const url = this.getPartnerLicenseInfoApi + tenantId;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.updatePartnerLicense = (acceptedInfo) => {
            const url = this.updatePartnerLicenseApi;
            return this.post(url, acceptedInfo).pipe(map(this.extractResponse));
        };
        this.updatePartnerApps = (config) => {
            const url = this.updatePartnerAppsApi;
            return this.post(url, config).pipe(map(this.extractResponseData));
        };
        this.createPartnerApps = (config) => {
            const url = this.createPartnerAppsApi;
            return this.post(url, config).pipe(map(this.extractResponse));
        };
        this.uploadImage = (filePath, files) => {
            const formData = new FormData();
            formData.append("upload", files[0]);
            formData.append("filePath", filePath);
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            return this.post(this.apiConfig.getUploadImageFileForPartner(), formData, options).pipe(map(this.extractResponse));
        };
        this.deleteImage = (filePath) => {
            const url = this.deleteImgUrl;
            const options = {
                filePath: filePath
            };
            return this.post(url, options).pipe(map(this.extractResponse));
        };
        this.getUseCaseCategories = () => {
            const url = "/assets/data/partner/partner-categories.json";
            // let options = {
            //     "timeout": 20000
            // }
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getPartnerAppListData = (filterData) => {
            const url = this.apiConfig.getPartnerAppList();
            return this.post(url, filterData).pipe(map(this.extractResponse));
        };
        this.getActivatedPartnerAppListData = () => {
            const url = this.apiConfig.getActivatedPartnerAppList();
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getPartnerAppDetails = (id) => {
            const url = this.apiConfig.getPartnerAppDetailsUrl();
            const body = {
                appId: id
            };
            const options = {
                responseType: "json"
            };
            return this.post(url, body, options).pipe(map(this.extractResponseData));
        };
        this.getPartnerAppStatus = (id) => {
            let url = this.apiConfig.getPartnerAppStatusUrl();
            if (id) {
                url += "?appId=" + id;
            }
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getOauthAccessToken = (appId, code, state, redirect_uri) => {
            const url = this.apiConfig.getOauthAccessToken();
            const body = {
                appId: appId,
                code: code,
                state: state,
                redirect_uri: redirect_uri
            };
            const options = {
                responseType: "json"
            };
            return this.post(url, body, options).pipe(map(this.extractResponseData));
        };
        this.getOauthCustomerDetails = (accessToken, partnerTenantId, oAuthDomain) => {
            let url = "";
            if (partnerTenantId) {
                url =
                    this.getOauthCustomerInfo +
                        "?partnerTenantId=" +
                        partnerTenantId +
                        "&oAuthDomain=" +
                        oAuthDomain;
            }
            else {
                url = this.getOauthCustomerInfo + "?oAuthDomain=" + oAuthDomain;
            }
            const headers = new HttpHeaders({
                Authorization: "Bearer " + accessToken,
                Accept: "application/json"
            });
            const options = {
                headers,
                responseType: "json"
            };
            return this.get(url, options).pipe(map(this.extractResponseData));
        };
        this.validateSSOLogin = (token, version, appId, oAuthDomain) => {
            const url = this.validateSSOLoginToken;
            const body = {
                token: token,
                version: version,
                appId: appId,
                oAuthDomain: oAuthDomain
            };
            const options = {
                responseType: "json"
            };
            return this.post(url, body, options).pipe(map(this.extractResponseData));
        };
        this.activatePartnerApp = (config) => {
            const url = this.activatePartnerApps;
            return this.post(url, config).pipe(map(this.extractResponseData));
        };
        this.savePartnerCustomerInformation = (config) => {
            const url = this.savePartnerCustomerInfo;
            return this.post(url, config).pipe(map(this.extractResponseData));
        };
        this.getPartnerAppsSSOLoginToken = (appId, partnerTenantId) => {
            const url = this.getPartnerAppSSOLoginToken +
                appId +
                "&partnerTenantId=" +
                partnerTenantId;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getSandboxCustomer = () => {
            const url = this.sandboxCustomerUrl;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.locationList = () => {
            let url = this.apiConfig.getBusinessLocationListUrl();
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getLicenseAgreementData = () => {
            const url = this.getLicenseAgreementUrl;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getCustomEventsData = () => {
            const url = this.getCustomEvents;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getAdvancePartner = () => {
            const url = this.getAdvancePartnerUrl;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getAWSRegions = () => {
            const url = "/assets/data/partner/aws-regions.json";
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getAppCenterFilters = () => {
            const url = this.appCenterFiltersUrl;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getAppActivationLicense = () => {
            const url = this.appActivationLicenseUrl;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.checkTNCAccepted = (version) => {
            const url = this.checkTNCAcceptedUrl + "?version=" + version;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.saveTNCAccepted = (tncObject) => {
            const url = this.saveTNCAcceptedUrl;
            return this.post(url, tncObject).pipe(map(this.extractResponse));
        };
        this.getEndDeviceslist = (filterData) => {
            const url = this.apiConfig.getEndDeviceslist();
            return this.post(url, filterData).pipe(map(this.extractResponse));
        };
        this.getDeviceDetail = (deviceId) => {
            const url = this.apiConfig.deviceDetailUrl() + "/" + deviceId;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getCompatibleDevices = () => {
            const url = this.compatibleDevicesUrl;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.searchPartner = (partnerName) => {
            const url = this.searchPartnerUrl + "?partner=" + partnerName;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.autoActivateApp = () => { };
        this.getAppCenterActivatedPartnerAppData = (appId) => {
            const url = this.apiConfig.getAppCenterActivatedPartnerAppUrl(appId);
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getSTCPartnerAppsSSOLoginToken = (appId, partnerTenantId, applicationType) => {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            const url = `${this.getPartnerAppSSOLoginToken}${appId}&partnerTenantId=${partnerTenantId}&applicationType=${applicationType}`;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getIsPartner = () => {
            const url = this.apiConfig.getIsPartnerUrl();
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.checkCustomTNCAccepted = (appId) => {
            const url = this.checkCustomTNCAcceptedUrl + "?appId=" + appId;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.saveCustomTNCAccepted = (tncObject) => {
            const url = this.saveCustomTNCAcceptedUrl;
            return this.post(url, tncObject).pipe(map(this.extractResponse));
        };
    }
}
PartnerAppsService.ɵfac = function PartnerAppsService_Factory(t) { return new (t || PartnerAppsService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
PartnerAppsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PartnerAppsService, factory: PartnerAppsService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PartnerAppsService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class PartnerSandboxAppsService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.checkPartnerApi = this.apiConfig.getPartnerUrl() + "?tenantId=";
        this.listPartnerAppsApi = this.apiConfig.getPartnerApssListUrl() + "?tenantId=";
        this.updatePartnerAppsApi = this.apiConfig.updatePartnerApps();
        this.getOauthCustomerInfo = this.apiConfig.getOauthCustomerInfo() + "?access_token=";
        this.activatePartnerApps = this.apiConfig.activatePartnerApps();
        this.autoActivatePartnerAppUrl = this.apiConfig.autoActivatePartnerAppUrl();
        this.deleteAutoActivationUrl = this.apiConfig.deleteAutoActivationUrl();
        this.deleteAutoActivatedAppUrl = this.apiConfig.deleteAutoActivatedAppUrl();
        this.activateOnPremPartnerApps = this.apiConfig.activateOnPremPartnerApps();
        this.savePartnerCustomerInfo = this.apiConfig.getSavePartnerCustomerInfo();
        this.getPartnerAppSSOLoginToken = this.apiConfig.getPartnerAppSSOLoginToken() + "?appId=";
        this.validateSSOLoginToken = this.apiConfig.validateSSOToken();
        this.createPartnerAppsApi = this.apiConfig.createPartnerApps();
        this.sandboxCustomerUrl = "/assets/data/partner/sandboxCustomer.json";
        this.deactivateUrl = this.apiConfig.getDeactivateUrl();
        this.onPremAppActivationUrl = this.apiConfig.getOnPremAppActivationUrl();
        this.onPremTokenUrl = this.apiConfig.getOnPremAppTokenUrl();
        this.onNewPremTokenUrl = this.apiConfig.getNewOnPremAppTokenUrl();
        this.renewOnPremiseTokenUrl = this.apiConfig.getRegenOnPremiseTokenUrl();
        this.regenOnPremiseTokenUrl = this.apiConfig.getRegenOnPremiseTokenUrl();
        this.activatedAppDetailsUrl = this.apiConfig.getActivatedAppDetailsUrl();
        this.pendingActivationUrl = this.apiConfig.getPendingActivationUrl();
        this.updatePartnerAppsLocationsUrl = this.apiConfig.getUpdatePartnerAppsLocationsUrl();
        this.renewActivationKeyUrl = this.apiConfig.getRenewOnPremiseTokenUrl();
        this.deactivateActivationUrl = this.apiConfig.getDeactivateActivationUrl();
        this.getActivatedPartnerTenantsUrl = this.apiConfig.getActivatedPartnerTenantsUrl();
        this.showAppCenterUrl = this.apiConfig.getShowAppCenterUrl();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getPartnerAppList = () => {
            const url = this.listPartnerAppsApi + this.dataService.selectedTenantId;
            //let url = this.listPartnerAppsApi + 129;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.checkPartnerApp = (tenantId) => {
            const url = this.checkPartnerApi + tenantId;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.updatePartnerApps = (config) => {
            const url = this.updatePartnerAppsApi;
            return this.post(url, config).pipe(map(this.extractResponseData));
        };
        this.createPartnerApps = (config) => {
            const url = this.createPartnerAppsApi;
            return this.post(url, config).pipe(map(this.extractResponse));
        };
        this.uploadImage = (filePath, files) => {
            const formData = new FormData();
            formData.append("upload", files[0]);
            formData.append("filePath", filePath);
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            return this.post(this.apiConfig.getUploadImageFileForPartner(), formData, options).pipe(map(this.extractResponse));
        };
        this.getUseCaseCategories = () => {
            const url = "/assets/data/partner/partner-categories.json";
            // let options = {
            //     "timeout": 20000
            // }
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.getPartnerAppListData = () => {
            const url = this.apiConfig.getPartnerAppList();
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getActivatedPartnerAppListData = (isSandbox) => {
            const isSandboxUser = false;
            // if(isSandbox) {
            //   isSandboxUser = isSandbox;
            // }
            const url = this.apiConfig.getActivatedPartnerAppList() +
                "?sandbox=" +
                isSandboxUser;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getPartnerAppDetails = (id) => {
            const url = this.apiConfig.getPartnerAppDetailsUrl();
            const body = {
                appId: id
            };
            const options = {
                responseType: "json"
            };
            return this.post(url, body, options).pipe(map(this.extractResponseData));
        };
        this.getPartnerAppStatus = (id) => {
            let url = this.apiConfig.getPartnerAppStatusUrl();
            if (id) {
                url += "?appId=" + id;
            }
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getOauthAccessToken = (appId, code, state, redirect_uri) => {
            const url = this.apiConfig.getOauthAccessToken();
            const body = {
                appId: appId,
                code: code,
                state: state,
                redirect_uri: redirect_uri
            };
            const options = {
                responseType: "json"
            };
            return this.post(url, body, options).pipe(map(this.extractResponseData));
        };
        this.getOauthCustomerDetails = (accessToken) => {
            const url = this.getOauthCustomerInfo + accessToken;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.validateSSOLogin = (token) => {
            const url = this.validateSSOLoginToken;
            const body = {
                token: token
            };
            const options = {
                responseType: "json"
            };
            return this.post(url, body, options).pipe(map(this.extractResponseData));
        };
        this.activatePartnerApp = (config) => {
            const url = this.activatePartnerApps;
            return this.post(url, config).pipe(map(this.extractResponseData));
        };
        this.autoActivatePartnerApp = (config) => {
            const url = this.autoActivatePartnerAppUrl;
            return this.post(url, config).pipe(map(this.extractResponseData));
        };
        this.deleteAutoActivation = (config) => {
            const url = this.deleteAutoActivationUrl;
            return this.post(url, config).pipe(map(this.extractResponseData));
        };
        this.deleteAutoActivatedApp = (config) => {
            const url = this.deleteAutoActivatedAppUrl;
            return this.post(url, config).pipe(map(this.extractResponseData));
        };
        this.activateOnPremPartnerApp = (config) => {
            const url = this.activateOnPremPartnerApps;
            return this.post(url, config).pipe(map(this.extractResponseData));
        };
        this.savePartnerCustomerInformation = (config) => {
            const url = this.savePartnerCustomerInfo;
            return this.post(url, config).pipe(map(this.extractResponseData));
        };
        this.getPartnerAppsSSOLoginToken = (appId) => {
            const url = this.getPartnerAppSSOLoginToken + appId;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getSandboxCustomer = () => {
            const url = this.sandboxCustomerUrl;
            return this.get(url).pipe(map(this.extractResponse));
        };
        this.sandboxToken = () => {
            const serverUrl = this.apiConfig.sandboxTokenUrl() + "/" + new Date().getTime();
            //console.log( serverUrl );
            //return this.getLocationTree();
            return this.get(serverUrl).pipe(map(this.extractResponse), catchError(this.handleErrorObservable));
        };
        this.deactivatePartnerApp = (appInfo) => {
            const url = this.deactivateUrl;
            return this.post(url, appInfo).pipe(map(this.extractResponseData));
        };
        // updateToken = (newToken) => {
        //     let serverUrl = this.apiConfig.getUpdateTokenUrl();
        //     //console.log( serverUrl );
        //     //return this.getLocationTree();
        //     return this.post(serverUrl, newToken)
        //         .pipe(map(this.extractResponse)
        //         ,catchError(this.handleErrorObservable));
        // }
        this.getOnPremiseActivationKey = (appInfo) => {
            const url = this.onPremAppActivationUrl;
            return this.post(url, appInfo).pipe(map(this.extractResponse));
        };
        this.getOnPremiseToken = (appInfo) => {
            const url = this.onPremTokenUrl;
            return this.post(url, appInfo).pipe(map(this.extractResponse));
        };
        this.regenOnPremiseToken = (appInfo) => {
            const url = this.regenOnPremiseTokenUrl;
            return this.post(url, appInfo).pipe(map(this.extractResponse));
        };
        this.getActivatedAppDetails = (appId) => {
            const url = this.activatedAppDetailsUrl + "/" + appId;
            return this.get(url).pipe(map(this.extractResponse), catchError(this.handleErrorObservable));
        };
        this.pendingActivation = (activationObj) => {
            const url = this.pendingActivationUrl;
            return this.post(url, activationObj).pipe(map(this.extractResponse));
        };
        this.updatePartnerAppsLocations = (activationObj) => {
            const url = this.updatePartnerAppsLocationsUrl;
            return this.post(url, activationObj).pipe(map(this.extractResponse));
        };
        this.renewActivationKey = (appInfo) => {
            const url = this.renewActivationKeyUrl;
            return this.post(url, appInfo).pipe(map(this.extractResponse));
        };
        this.deactivatePartnerActivation = (appInfo) => {
            const url = this.deactivateActivationUrl;
            return this.post(url, appInfo).pipe(map(this.extractResponseData));
        };
        this.getNewOnPremiseToken = (appInfo) => {
            const url = this.onNewPremTokenUrl;
            return this.post(url, appInfo).pipe(map(this.extractResponse));
        };
        this.getActivatedPartnerTenants = (appId) => {
            const url = this.getActivatedPartnerTenantsUrl + "/" + appId;
            return this.get(url).pipe(map(this.extractResponse), catchError(this.handleErrorObservable));
        };
        this.showAppCenter = () => {
            const url = this.showAppCenterUrl;
            return this.get(url).pipe(map(this.extractResponse), catchError(this.handleErrorObservable));
        };
        this.getAppCenterActivatedPartnerAppListData = () => {
            const url = this.apiConfig.getAppCenterActivatedPartnerAppListUrl();
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getSTCPartnerAppsSSOLoginToken = (appId, partnerTenantId, applicationType) => {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            const url = `${this.getPartnerAppSSOLoginToken}${appId}&partnerTenantId=${partnerTenantId}&applicationType=${applicationType}`;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.deleteAppCenterAppActivations = (appId) => {
            const url = this.apiConfig.getAppCenterRemoveAppActivationsUrl(appId);
            return this.delete(url).pipe(map(this.extractResponseData));
        };
        this.updateAppCenterAcceptedPermissions = (appId, acceptedPermissions) => {
            const url = this.apiConfig.getAppCenterUpdateAcceptedPermissionsUrl(appId);
            const body = { acceptedPermissions: acceptedPermissions };
            return this.post(url, body).pipe(map(this.extractResponseData));
        };
        this.getAppCenterActivatedPartnerAppData = (appId) => {
            const url = this.apiConfig.getAppCenterActivatedPartnerAppUrl(appId);
            return this.get(url).pipe(map(this.extractResponseData));
        };
    }
}
PartnerSandboxAppsService.ɵfac = function PartnerSandboxAppsService_Factory(t) { return new (t || PartnerSandboxAppsService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
PartnerSandboxAppsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PartnerSandboxAppsService, factory: PartnerSandboxAppsService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PartnerSandboxAppsService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class PersonasService extends BaseService {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.getSampleStatusResponse = "/assets/data/personas-status.json?"; // for testing needs to remove this line and also file
        this.getAppCurrentStatus = (appName) => {
            const url = this.apiConfig.getCurrentAppStatusUrl(appName);
            return this.get(url).pipe(map$1(this.extractResponse));
            // testing purpose
            //   return this.get(this.getSampleStatusResponse)
            //       .pipe(map(this.extractResponse));
        };
        this.inviteAppUser = (appName, userInfo) => {
            const serverUrl = this.apiConfig.getAppInviteUrl(appName);
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.deleteAppUser = (appName, userInfo) => {
            const opts = {
                body: userInfo
            };
            const serverUrl = this.apiConfig.getAppDeleteUrl(appName);
            return this.delete(serverUrl, opts).pipe(map$1(this.extractResponse));
        };
        this.getAppUserDeleteStatus = (appName, emailArr) => {
            const serverUrl = this.apiConfig.getAppDeleteStatusUrl(appName);
            return this.post(serverUrl, emailArr).pipe(map$1(this.extractResponse));
        };
        this.editAppUser = (appName, userInfo) => {
            const serverUrl = this.apiConfig.getAppEditUrl(appName);
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.getAppUserList = (appName) => {
            const serverUrl = this.apiConfig.getRBACAppUserListUrl(appName);
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getAppUserInfo = (appName, inviteUserEmail) => {
            const getUserInfoUrl = this.apiConfig.getRBACAppUserInfoUrl(appName, inviteUserEmail);
            return this.get(getUserInfoUrl).pipe(map$1(this.extractResponse));
        };
        this.resendAppInvite = (userInfo) => {
            const serverUrl = this.apiConfig.getResendAppInviteEmailUrl();
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.deleteRule = (ruleObj) => {
            const serverUrl = this.apiConfig.getPersonasDeleteRuleUrl();
            const options = {
                body: ruleObj
            };
            return this.delete(serverUrl, options).pipe(map$1(this.extractCompleteResponse));
        };
        this.pauseRule = (ruleObj) => {
            const serverUrl = this.apiConfig.getPersonasPauseRuleUrl();
            return this.post(serverUrl, ruleObj).pipe(map$1(this.extractCompleteResponse));
        };
        this.setRuleLive = (ruleObj) => {
            const serverUrl = this.apiConfig.getPersonasMakeRuleLiveUrl();
            return this.post(serverUrl, ruleObj).pipe(map$1(this.extractCompleteResponse));
        };
        this.getRuleDetails = (ruleId) => {
            const serverUrl = this.apiConfig.getPersonasRuleDetailsUrl() + "/" + ruleId;
            return this.get(serverUrl).pipe(map$1(this.extractResponseData));
        };
        this.getRulesList = (locationId, ruleType) => {
            const bodyPayload = {
                locationId: locationId.toString(),
                ruleType: ruleType
            };
            const serverUrl = this.apiConfig.getPersonasRulelistUrl();
            return this.post(serverUrl, bodyPayload).pipe(map$1(this.extractResponseData));
        };
        this.extractTreeData = (res) => {
            try {
                this.startTime = new Date().getTime();
                const responseString = res; //.text();
                // console.log("responseString :: ", responseString)
                const p1 = responseString.indexOf(LocationRow.locTableKey);
                if (p1 == -1)
                    return JSON.parse(responseString);
                const p2 = p1 + LocationRow.locTableKey.length;
                const p3 = responseString.indexOf('"', p2);
                const locationTableData = responseString.substring(p2, p3);
                const resp = JSON.parse(responseString.substring(0, p1) +
                    responseString.substring(p3 + 1));
                if (resp.status == true && resp.data != null) {
                    const locationWrapper = this.utils.locationUtil.convertTree(resp.data, locationTableData);
                    this.dataService.setLocationArray(locationWrapper.locationsMap); //locationsArray
                    // setting mongodb ids and graph db ids in dataservice
                    this.dataService.setMongoDBIdsMap(locationWrapper.locationsMap);
                    this.dataService.setGraphDBIdsMap(locationWrapper.locationsMap);
                    this.dataService.setLocationObjectArray(locationWrapper.locationsMap);
                    this.dataService.setLicenseDetails(locationWrapper.licenseDetails);
                    delete locationWrapper.locationsMap;
                    delete locationWrapper.locationsArray;
                    delete locationWrapper.licenseDetails;
                    this.dataService.setLocationTreeArray(locationWrapper);
                    setTimeout(() => {
                        let locWrapper;
                        let userCountResponse;
                        locWrapper = this.dataService.getLocationWrap();
                        userCountResponse = this.dataService.getUserCountResponse();
                        if (userCountResponse !== undefined &&
                            userCountResponse !== null &&
                            JSON.stringify(userCountResponse) !== "{}") {
                            this.updateCount(locWrapper, userCountResponse, "user");
                        }
                    }, 2000);
                    console.log("(extractTreeData) locations converted into tree", new Date().getTime() - this.startTime);
                    return locationWrapper;
                }
                else {
                    throw throwError(res.json().message);
                }
            }
            catch (e) {
                // an error occurred
                throw throwError(res.json());
            }
        };
        this.updateCount = (locationWrapper, userCountResponse, type) => {
            if (type === "user") {
                let locationUserCountMap;
                if (userCountResponse && userCountResponse.status) {
                    locationUserCountMap = userCountResponse.data.locations
                        ? userCountResponse.data.locations
                        : {};
                    const adminsCount = userCountResponse.data.admins;
                    const rootLocation = locationWrapper.location[0];
                    const rootLocationId = rootLocation.id;
                    const locationsMap = this.dataService.getLocationMap();
                    locationsMap.forEach((val, locationId) => {
                        let locationObj;
                        let locId;
                        locId = locationId;
                        locationObj = val;
                        // adminsCount to root location
                        if (locId === rootLocationId) {
                            locationObj.userCount = adminsCount;
                            locationObj.userClickable = locationObj.userCount > 0;
                            locationsMap.set(locId, locationObj);
                            locationWrapper.locationsMap = locationsMap;
                        }
                        Object.keys(locationUserCountMap).map((key) => {
                            if (rootLocationId != parseInt(key) &&
                                locId === parseInt(key)) {
                                locationObj.userCount = locationUserCountMap[key];
                                locationObj.userClickable =
                                    locationObj.userCount > 0;
                                locationsMap.set(locId, locationObj);
                                locationWrapper.locationsMap = locationsMap;
                            }
                        });
                    });
                    // update all the values in dataservice
                    this.dataService.setLocationArray(locationWrapper.locationsMap); //locationsArray
                    this.dataService.setLocationObjectArray(locationWrapper.locationsMap);
                }
            }
        };
        this.rulesList = (locationId, ruleType) => {
            const bodyPayload = {
                locationId: locationId.toString(),
                ruleType: ruleType
            };
            const serverUrl = this.apiConfig.getPersonasRuleslistUrl();
            return this.post(serverUrl, bodyPayload).pipe(map$1(this.extractResponseData));
        };
        this.saveRule = (saveConfig) => {
            const body = saveConfig;
            const serverUrl = this.apiConfig.getPersonasRulesSaveUrl();
            return this.post(serverUrl, body).pipe(map$1(this.extractCompleteResponse));
        };
        this.updateRule = (saveConfig) => {
            const body = saveConfig;
            const serverUrl = this.apiConfig.getPersonasRulesUpdateUrl();
            return this.post(serverUrl, body).pipe(map$1(this.extractCompleteResponse));
        };
        this.extractCompleteResponse = (res) => {
            return res;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.utils = new Utils(this.logger);
    }
    static getInstance() {
        if (PersonasService.instance === null) {
            PersonasService.instance = new PersonasService(null);
        }
        return PersonasService.instance;
    }
    getLocationTree() {
        console.log("getting locations, in location service : getLocationTree");
        this.startTime = new Date().getTime();
        const options = {
            responseType: "text"
        };
        return this.get(this.apiConfig.getPersonasLocationListUrl(), options).pipe(map$1(this.extractTreeData));
    }
}
PersonasService.instance = null;
PersonasService.ɵfac = function PersonasService_Factory(t) { return new (t || PersonasService)(i0.ɵɵinject(i0.Injector)); };
PersonasService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PersonasService, factory: PersonasService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PersonasService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: i0.Injector }]; }, null); })();
const personasServiceFactory = () => {
    return PersonasService.getInstance();
};
const PERSONAS_SERVICE_PROVIDER = [
    {
        provide: PersonasService,
        deps: [],
        useFactory: personasServiceFactory
    }
];

class ReportService extends BaseService {
    /* End of new spaces api */
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig(this.dataService);
        // url = "/assets/data/reports.json";
        this.serverUrl = this.apiConfig.getReportServerUrl(); //"/api/v1/report/general/monthly?periodKey=";
        this.adminServerUrl = this.apiConfig.getReportAdminServerUrl(); //"/api/v1/report/admin/overview?";
        this.overallReportsUrl = this.apiConfig.getReportOverallReportsUrl(); //"/api/v1/report/overall?";
        this.realTimeReportsUrl = this.apiConfig.getReportRealTimeReportsUrl(); //"/api/v1/report/realtime?";
        this.getReportsUrl = this.apiConfig.getReportsUrl();
        this.locationAnalyticsDateUrl = this.apiConfig.getLocationAnalyticsDateUrl();
        this.locationAnalyticsUrl = this.apiConfig.getLocationAnalyticsUrl();
        this.analyticsReportsUrl = this.apiConfig.getAnalyticsReportsUrl();
        this.analyticsLAReportsUrl = this.apiConfig.getAnalyticsLAReportsUrl();
        this.analyticsReportsDeleteUrl = this.apiConfig.getAnalyticsReportsDeleteUrl();
        this.getAnalyticsSsidsUrl = this.apiConfig.getAnalyticsSsidsUrl();
        this.getAnalyticsDwellUrl = this.apiConfig.getAnalyticsDwellUrl();
        this.updateAnalyticsDwellUrl = this.apiConfig.getAnalyticsDwellUpdateUrl();
        this.analyticsCheckUrl = this.apiConfig.getAnalyticsCheckUrl();
        this.analyticsTop2LocationsUrl = this.apiConfig.getAnalyticsTop2LocationsUrl();
        this.analyticsTop2SSIDsUrl = this.apiConfig.getAnalyticsTop2SSIDsUrl();
        this.analyticsLocationByTypeUrl = this.apiConfig.getLocationByTypeUrl();
        this.analyticsAppCurrentStatusUrl = this.apiConfig.getAnalyticsAppCurrentStatusUrl();
        this.rightNowAppCurrentStatusUrl = this.apiConfig.getRightNowsAppCurrentStatusUrl();
        // spaceSettingsUrl = "/api/v1/spaces/settings?locationId="
        // spaceOverviewUrl = "/api/v1/spaces/overview/";
        // spaceDetailUrl = "/api/v1/business/detail/";
        this.spacesLocationsUrl = "/api/v1/report/spaces/location/list";
        this.spaceSettingsUrl = "/api/v1/report/spaces/settings";
        this.spaceBusinessSettingsUrl = "/api/v1/report/spaces/customer/settings/true";
        this.spaceOverviewUrl = "/api/v1/report/overview/";
        this.spaceDetailUrl = "/api/v1/report/detail/";
        this.wifiMetricsUrl = "/api/v1/report/wifimetrics/";
        this.allWifiMetricsUrl = "/api/v1/report/allwifimetrics/";
        // allRetailMetricsUrl = "/api/v1/report/spaces/businessmetrics/v1/retail/";
        this.locationMetadataUrl = "/api/v1/shared/location";
        /* new spaces apis */
        /* Spaces - wifiMetrics */
        // spacesOverviewUrl = "/api/v1/report/spaces/overview/";
        this.spacesWifiMetricsUrl = "/api/v1/report/spaces/businessmetrics/v1/wifimetrics/";
        // spacesWifiMetricsHistoricalUrl = "/api/v1/report/spaces/businessmetrics/wifimetrics/historical/";
        /* Spaces - retail/business */
        this.spacesRetailCurrentUrl = "/api/v1/report/spaces/retail/current/";
        this.spacesRetailDayOfWeekUrl = "/api/v1/report/spaces/retail/dayofweek/";
        this.spacesRetailHourOfDayUrl = "/api/v1/report/spaces/retail/hourofday/";
        this.spacesRetailDwellRangesUrl = "/api/v1/report/spaces/retail/dwellrange/";
        this.spacesRetailVisitNumberUrl = "/api/v1/report/spaces/retail/visitnumber/";
        this.spacesRetailCurrentHistoricalUrl = "/api/v1/report/spaces/retail/historical/current/";
        this.spacesRetailDayOfWeekHistoricalUrl = "/api/v1/report/spaces/retail/historical/dayofweek/";
        this.spacesRetailHourOfDayHistoricalUrl = "/api/v1/report/spaces/retail/historical/hourofday/";
        this.spacesRetailDwellRangesHistoricalUrl = "/api/v1/report/spaces/retail/historical/dwellrange/";
        this.spacesRetailVisitNumberHistoricalUrl = "/api/v1/report/spaces/retail/historical/visitnumber/";
        this.extractResponse = (res) => {
            return res;
        };
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.getFilterReportsData = (data) => {
            const serverUrl = "/api/v1/report/overview";
            return this.post(serverUrl, data);
        };
        this.getOverallReportsData = (data) => {
            const serverUrl = this.overallReportsUrl;
            return this.post(serverUrl, data);
        };
        this.getReportsDataFromApi = (path, queryParams) => {
            const serverUrl = this.getReportsUrl + path + "?" + queryParams;
            return this.get(serverUrl);
        };
        this.getRealTimeReportsData = (data, dummy) => {
            let serverUrl;
            if (dummy == true)
                serverUrl = this.realTimeReportsUrl + "?dummy=" + dummy;
            else
                serverUrl = this.realTimeReportsUrl;
            return this.post(serverUrl, data);
        };
        this.getSpacesLocations = () => {
            const url = this.spacesLocationsUrl;
            const options = {
                timeout: 20000
            };
            return this.get(url, options).pipe(map(this.extractResponse));
        };
        this.getLocationAnalyticsDateFromApi = (queryParams) => {
            const serverUrl = this.locationAnalyticsDateUrl + queryParams;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getLocationAnalyticsDataFromApi = (queryParams) => {
            const serverUrl = this.locationAnalyticsUrl + queryParams;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getAnalyticsReports = () => {
            const serverUrl = this.analyticsReportsUrl;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getAnalyticsLAReports = () => {
            const serverUrl = this.analyticsLAReportsUrl;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getAnalyticsLocationByTypeUrl = (locationType) => {
            const serverUrl = this.analyticsLocationByTypeUrl + "/" + locationType;
            return this.get(serverUrl);
        };
        this.addAnalyticsReportsUrl = (reportConfig) => {
            const serverUrl = this.analyticsReportsUrl;
            return this.post(serverUrl, reportConfig).pipe(map(this.extractResponse));
        };
        this.addAnalyticsLAReportsUrl = (reportConfig) => {
            const serverUrl = this.analyticsLAReportsUrl;
            return this.post(serverUrl, reportConfig).pipe(map(this.extractResponse));
        };
        this.updateAnalyticsLAReportsUrl = (reportId, reportConfig) => {
            const serverUrl = this.analyticsLAReportsUrl + "/" + reportId;
            return this.put(serverUrl, reportConfig).pipe(map(this.extractResponse));
        };
        this.updateAnalyticsReportsUrl = (reportId, reportConfig) => {
            const serverUrl = this.analyticsReportsUrl + "/" + reportId;
            return this.put(serverUrl, reportConfig).pipe(map(this.extractResponse));
        };
        this.deleteAnalyticsReportsUrl = (reportId) => {
            const serverUrl = this.analyticsReportsUrl + "/" + reportId;
            return this.delete(serverUrl).pipe(map(this.extractResponse));
        };
        this.deleteAnalyticsLAReportsUrl = (reportId) => {
            const serverUrl = this.analyticsLAReportsUrl + "/" + reportId;
            return this.delete(serverUrl).pipe(map(this.extractResponse));
        };
        this.deleteAnalyticsMultipleReportsUrl = (reports) => {
            const serverUrl = this.analyticsReportsDeleteUrl;
            return this.post(serverUrl, reports).pipe(map(this.extractResponse));
        };
        this.addAnalyticsWidgetUrl = (reportId, widgetConfig) => {
            const serverUrl = this.analyticsReportsUrl + "/" + reportId + "/widgets";
            return this.post(serverUrl, widgetConfig).pipe(map(this.extractResponse));
        };
        this.addAnalyticsLAWidgetUrl = (reportId, widgetConfig) => {
            const serverUrl = this.analyticsLAReportsUrl + "/" + reportId + "/widgets";
            return this.post(serverUrl, widgetConfig).pipe(map(this.extractResponse));
        };
        this.updateAnalyticsWidgetUrl = (reportId, widgetId, widgetConfig) => {
            const serverUrl = this.analyticsReportsUrl +
                "/" +
                reportId +
                "/widgets" +
                "/" +
                widgetId;
            return this.put(serverUrl, widgetConfig).pipe(map(this.extractResponse));
        };
        this.updateAnalyticsLAWidgetUrl = (reportId, widgetId, widgetConfig) => {
            const serverUrl = this.analyticsLAReportsUrl +
                "/" +
                reportId +
                "/widgets" +
                "/" +
                widgetId;
            return this.put(serverUrl, widgetConfig).pipe(map(this.extractResponse));
        };
        this.deleteAnalyticsWidgetUrl = (reportId, widgetId) => {
            const serverUrl = this.analyticsReportsUrl +
                "/" +
                reportId +
                "/widgets" +
                "/" +
                widgetId;
            return this.delete(serverUrl).pipe(map(this.extractResponse));
        };
        this.deleteAnalyticsLAWidgetUrl = (reportId, widgetId) => {
            const serverUrl = this.analyticsLAReportsUrl +
                "/" +
                reportId +
                "/widgets" +
                "/" +
                widgetId;
            return this.delete(serverUrl).pipe(map(this.extractResponse));
        };
        this.getAnalyticsSsidList = () => {
            const serverUrl = this.getAnalyticsSsidsUrl;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getAnalyticsDwellDetails = () => {
            const serverUrl = this.getAnalyticsDwellUrl;
            return this.get(serverUrl);
        };
        this.updateAnalyticsDwellThresholdUrl = (dwellMin, dwellMax, noFilter) => {
            const serverUrl = this.updateAnalyticsDwellUrl +
                "dwellMin=" +
                dwellMin +
                "&dwellMax=" +
                dwellMax +
                "&noFilter=" +
                noFilter;
            return this.put(serverUrl, null).pipe(map(this.extractResponse));
        };
        this.getAnalyticsCheckUrl = () => {
            const serverUrl = this.analyticsCheckUrl;
            return this.get(serverUrl);
        };
        this.getAnalyticsTop2LocationsUrl = () => {
            const serverUrl = this.analyticsTop2LocationsUrl;
            return this.get(serverUrl);
        };
        this.getAnalyticsTop2SSIDsUrl = () => {
            const serverUrl = this.analyticsTop2SSIDsUrl;
            return this.get(serverUrl);
        };
        this.getAnalyticsAppCurrentStatusUrl = () => {
            const serverUrl = this.analyticsAppCurrentStatusUrl;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getRightNowsAppCurrentStatusUrl = () => {
            const serverUrl = this.rightNowAppCurrentStatusUrl;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getConnector = () => {
            const proxyURL = this.apiConfig.getDMSProxyUrl();
            const paramObject = {
                method: "GET",
                path: 'config/connector',
                responseType: "array"
            };
            return this.post(proxyURL, paramObject).pipe(map(this.extractResponse));
        };
        this.getAnalyticsReportsById = (id) => {
            const serverUrl = this.analyticsLAReportsUrl + "/" + id;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
    }
    getReportsData(periodKey, mallName) {
        const server = this.serverUrl + periodKey + "&mall=" + mallName;
        return this.get(server);
    }
    getAdminReportsData(locationId) {
        let url = this.adminServerUrl;
        if (locationId)
            url = url + "locationId=" + locationId;
        return this.get(url);
    }
    getMetrics() {
        const url = "/assets/data/spaces/spaces-categories.json";
        return this.get(url).pipe(map(this.extractResponse));
    }
    getSettings(locationId) {
        const url = this.spaceSettingsUrl;
        const options = {
            timeout: 20000
        };
        return this.get(url, options).pipe(map(this.extractResponse));
    }
    getBusinessSettings(locationId) {
        const url = this.spaceBusinessSettingsUrl + "?locId=" + locationId;
        const options = {
            timeout: 20000
        };
        return this.get(url, options).pipe(map(this.extractResponse));
    }
    getSpacesOverview(selectedLocations, duration) {
        const url = this.spaceOverviewUrl + duration;
        return this.post(url, selectedLocations).pipe(map(this.extractResponse));
    }
    getSpacesDetailReport(locationId, duration) {
        const url = this.spaceDetailUrl + locationId + "/" + duration;
        return this.get(url).pipe(map(this.extractResponse));
    }
    getSpacesDetailReportAll(locations, duration, dummy, metricGroup) {
        let url;
        // url = "/assets/data/spaces/bi-campus.json";
        if (dummy === true) {
            url =
                this.apiConfig.getBIReportUrl() + duration + "?dummy=" + dummy;
            if (["workspaces", "education"].includes(metricGroup)) {
                url =
                    this.apiConfig.getBIReportUrlForWorkspaces() +
                        duration +
                        "?dummy=" +
                        dummy;
            }
            else if (metricGroup == "education") {
                url =
                    this.apiConfig.getBIReportUrlForEducation() +
                        duration +
                        "?dummy=" +
                        dummy;
            }
            else {
                url =
                    this.apiConfig.getBIReportUrl() +
                        duration +
                        "?dummy=" +
                        dummy;
            }
        }
        else {
            url = this.apiConfig.getBIReportUrl() + duration;
            if (["workspaces", "education"].includes(metricGroup)) {
                url = this.apiConfig.getBIReportUrlForWorkspaces() + duration;
            }
            else if (metricGroup == "education") {
                url = this.apiConfig.getBIReportUrlForEducation() + duration;
            }
            else {
                url = this.apiConfig.getBIReportUrl() + duration;
            }
        }
        return this.post(url, locations).pipe(map(this.extractResponse));
        // return this.get(url, locations)
        // .pipe(map(this.extractResponse));
    }
    getlocationMetadataForShareReport(locId) {
        const url = this.apiConfig.getLocationMetadataUrl() + "?locationId=" + locId;
        return this.get(url).pipe(map(this.extractResponse));
    }
    getWifiMetrics(locations, duration, dummy) {
        let url;
        if (dummy == true)
            url = this.spacesWifiMetricsUrl + duration + "?dummy=" + dummy;
        else
            url = this.spacesWifiMetricsUrl + duration;
        return this.post(url, locations).pipe(map(this.extractResponse));
    }
    getReportDetails(locations, duration, type) {
        let apiTypeUrl = "";
        switch (type) {
            case "current":
                apiTypeUrl = this.spacesRetailCurrentUrl;
                break;
            case "dayOfWeek":
                apiTypeUrl = this.spacesRetailDayOfWeekUrl;
                break;
            case "hourOfDay":
                apiTypeUrl = this.spacesRetailHourOfDayUrl;
                break;
            case "dwellRanges":
                apiTypeUrl = this.spacesRetailDwellRangesUrl;
                break;
            case "visitNumber":
                apiTypeUrl = this.spacesRetailVisitNumberUrl;
                break;
        }
        const url = apiTypeUrl + duration;
        return this.post(url, locations).pipe(map(this.extractResponse));
    }
    getReportDetailsHistorical(locations, duration, type) {
        let apiTypeUrl = "";
        switch (type) {
            case "current":
                apiTypeUrl = this.spacesRetailCurrentHistoricalUrl;
                break;
            case "dayOfWeek":
                apiTypeUrl = this.spacesRetailDayOfWeekHistoricalUrl;
                break;
            case "hourOfDay":
                apiTypeUrl = this.spacesRetailHourOfDayHistoricalUrl;
                break;
            case "dwellRanges":
                apiTypeUrl = this.spacesRetailDwellRangesHistoricalUrl;
                break;
            case "visitNumber":
                apiTypeUrl = this.spacesRetailVisitNumberHistoricalUrl;
                break;
        }
        const url = apiTypeUrl + duration;
        return this.post(url, locations).pipe(map(this.extractResponse));
    }
    getWidgetProperties() {
        const url = "/assets/data/spaces/widget-properties.json";
        return this.get(url).pipe(map(this.extractResponse));
    }
}
ReportService.ɵfac = function ReportService_Factory(t) { return new (t || ReportService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
ReportService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ReportService, factory: ReportService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class RightnowService extends BaseService {
    //realTimeReportsLocationGroupUrl = this.apiConfig.getRightNowTimeReportsLocationGroupUrl();
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.realTimeReportsUrl = this.apiConfig.getRightNowTimeReportsUrl();
        this.realTimeReportsMapViewUrl = this.apiConfig.getRightNowReportsMapViewUrl();
        this.realTimeCamReportsUrl = this.apiConfig.getRightNowCameraReportsUrl();
        this.rightNowSettings = this.apiConfig.getRightNowSettingsUrl();
        this.saveSettings = this.apiConfig.saveRightNowSettingsUrl();
        this.ssidList = this.apiConfig.getRightNowSSIDListUrl();
        this.bleList = this.apiConfig.getRightNowBLEListUrl();
        this.saveCategorySettings = this.apiConfig.saveRightNowCategorySettingsUrl();
        this.videoMapViewUrl = this.apiConfig.getRightNowVideoMapUrl();
        this.rightNowLocationUrl = this.apiConfig.getRightNowFirstPermittedLocationUrl();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getRightNowSettings = () => {
            // let url = "/assets/data/rightnow/settings.json";
            // return this.get(url)
            //   .pipe(map(this.extractResponse));
            const serverUrl = this.rightNowSettings;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getDensityOverallAPI = (ruleId) => {
            const serverUrl = this.apiConfig.getDensityOverallUrl() + "?ruleId=" + ruleId;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getDensityRecentActivityAPI = (ruleId) => {
            const serverUrl = this.apiConfig.getDensityRecentActivityUrl() + "?ruleId=" + ruleId;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getDensityRecentActivityCountAPI = (ruleId) => {
            const serverUrl = this.apiConfig.getDensityRecentActivityCountUrl() +
                "?ruleId=" +
                ruleId;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getDensityRecentActivityAPIWithParam = (ruleId, limit, offset) => {
            const serverUrl = this.apiConfig.getDensityRecentActivityUrl() +
                "?ruleId=" +
                ruleId +
                "&limit=" +
                limit +
                "&offset=" +
                offset;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getDensityTriggerHistoryDayAPI = (ruleId, localDate) => {
            const serverUrl = this.apiConfig.getDensityTriggerHistoryDayUrl() +
                "?ruleId=" +
                ruleId +
                "&date=" +
                localDate;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getDensityTriggerHistoryDayLocationCountAPI = (ruleId, localDate) => {
            const serverUrl = this.apiConfig.getDensityTriggerHistoryDayLocationCountUrl() +
                "?ruleId=" +
                ruleId +
                "&date=" +
                localDate;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getDensityTriggerHistoryDayCountAPI = (ruleId, localDate) => {
            const serverUrl = this.apiConfig.getDensityTriggerHistoryDayCountUrl() +
                "?ruleId=" +
                ruleId +
                "&date=" +
                localDate;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getDensityTriggerHistoryDayAPIWithParam = (ruleId, localDate, limit, offset) => {
            const serverUrl = this.apiConfig.getDensityTriggerHistoryDayUrl() +
                "?ruleId=" +
                ruleId +
                "&date=" +
                localDate +
                "&limit=" +
                limit +
                "&offset=" +
                offset;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
        this.getDensityTriggerHistoryMonthAPI = (ruleId, localDate) => {
            const serverUrl = this.apiConfig.getDensityTriggerHistoryMonthUrl() +
                "?ruleId=" +
                ruleId +
                "&date=" +
                localDate;
            return this.get(serverUrl).pipe(map(this.extractResponse));
        };
    }
    getRightNowWidgetProperties() {
        const url = "/assets/data/rightnow/rnow-widget-properties.json?v=1";
        return this.get(url).pipe(map(this.extractResponse));
    }
    getRightNowFirstLocationAPI(id) {
        const serverUrl = this.rightNowLocationUrl + "/" + id;
        return this.get(serverUrl).pipe(map(this.extractResponse));
    }
    getRightNowReportAPI(data) {
        // let url = "/assets/data/rightnow/active_visitors.json";
        // return this.get(url)
        //   .pipe(map(this.extractResponse));
        const serverUrl = this.realTimeReportsUrl;
        return this.post(serverUrl, data).pipe(map(this.extractResponse));
    }
    getMapViewRightNowReportAPI(data) {
        /* let url = "/assets/data/rightnow/active_visitors.json";
     return this.get(url)
       .pipe(map(this.extractResponse));*/
        const serverUrl = this.realTimeReportsMapViewUrl;
        return this.post(serverUrl, data).pipe(map(this.extractResponse));
    }
    getRightNowCamReportAPI(data) {
        //  let url = "/assets/data/rightnow/active_visitors_camera.json";
        //  return this.get(url)
        //    .pipe(map(this.extractResponse));
        const serverUrl = this.realTimeCamReportsUrl;
        return this.post(serverUrl, data).pipe(map(this.extractResponse));
    }
    getRightNowCamMapAPI(data) {
        // let url = "/assets/data/rightnow/active_visitors_camera.json";
        // return this.get(url)
        //   .map(this.extractResponse);
        const serverUrl = this.videoMapViewUrl;
        return this.post(serverUrl, data).pipe(map(this.extractResponse));
    }
    saveRightNowSettings(data) {
        const serverUrl = this.saveSettings;
        return this.post(serverUrl, data).pipe(map(this.extractResponse));
    }
    getSSIDList() {
        // let url = '/assets/data/rightnow/rnow-ssid.json'
        // return this.get(url)
        //   .pipe(map(this.extractResponse));
        const serverUrl = this.ssidList;
        return this.get(serverUrl).pipe(map(this.extractResponse));
    }
    saveRightNowCategorySettings(data) {
        const serverUrl = this.saveCategorySettings;
        return this.post(serverUrl, data).pipe(map(this.extractResponse));
    }
    getBLEList() {
        const serverUrl = this.bleList;
        return this.get(serverUrl).pipe(map(this.extractResponse));
        // let proxyUrl = this.apiConfig.getDMSProxyUrl();
        // let paramObject = { "method": "GET", "path": 'edm/v1/device/meta/group/', "responseType": "object" };
        // return this.post(proxyUrl, paramObject)
        //   .pipe(map(this.extractResponseData));
    }
}
RightnowService.ɵfac = function RightnowService_Factory(t) { return new (t || RightnowService)(i0.ɵɵinject(i0.Injector)); };
RightnowService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RightnowService, factory: RightnowService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RightnowService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: i0.Injector }]; }, null); })();

class RuleService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.metadataListFileUrl = "/assets/data/metadataList.json?";
        this.portalListFilerUrl = "/assets/data/portalList.json?";
        this.getRuleDetails = (ruleId) => {
            const serverUrl = this.apiConfig.getRuleDetailsUrl() + "/" + ruleId;
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.pauseRule = (ruleObj) => {
            const serverUrl = this.apiConfig.getPauseRuleUrl();
            return this.post(serverUrl, ruleObj).pipe(map(this.extractCompleteResponse));
        };
        this.setRuleLive = (ruleObj) => {
            const serverUrl = this.apiConfig.getMakeRuleLiveUrl();
            return this.post(serverUrl, ruleObj).pipe(map(this.extractCompleteResponse));
        };
        this.deleteRule = (ruleObj) => {
            const serverUrl = this.apiConfig.getDeleteRuleUrl();
            const options = {
                body: ruleObj
            };
            return this.delete(serverUrl, options).pipe(map(this.extractCompleteResponse));
        };
        this.getMetadataList = () => {
            const url = this.apiConfig.getMetadataListUrl();
            return this.get(url).pipe(map(this.extractCompleteResponse));
        };
        this.getTagList = (tagType) => {
            const serverUrl = this.apiConfig.getTagListUrl() + (tagType ? "/" + tagType : "");
            return this.get(serverUrl).pipe(map(this.extractCompleteResponse));
        };
        this.saveRule = (saveConfig) => {
            const body = saveConfig;
            const serverUrl = this.apiConfig.getSaveRuleUrl();
            return this.post(serverUrl, body).pipe(map(this.extractCompleteResponse));
        };
        this.getSSIDList = () => {
            const url = this.apiConfig.getSSIDListUrl();
            return this.get(url).pipe(map(this.extractCompleteResponse));
        };
        this.getPortalList = () => {
            const url = this.apiConfig.getRulePortalListUrl();
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getSMSGatewayList = () => {
            const url = this.apiConfig.getRuleSmsGatewayListUrl();
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getNotificationChannelList = () => {
            const url = this.apiConfig.getNotificationListUrl();
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.getBusinessTagsList = () => {
            const url = this.apiConfig.getBusinessTagsListUrl();
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.initiateTestRule = (id) => {
            const url = this.apiConfig.getTestRuleUrl() + "/" + id;
            return this.get(url).pipe(map(this.extractResponseData));
        };
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractCompleteResponse = (res) => {
            return res;
        };
        this.getDensityRuleDetails = (ruleId) => {
            const serverUrl = this.apiConfig.getRuleDetailsUrl() + "/density/" + ruleId;
            return this.get(serverUrl).pipe(map(this.extractResponseData));
        };
        this.pauseDensityRule = (ruleObj) => {
            const serverUrl = this.apiConfig.getPauseDensityRuleUrl();
            return this.post(serverUrl, ruleObj).pipe(map(this.extractCompleteResponse));
        };
        this.setDensityRuleLive = (ruleObj) => {
            const serverUrl = this.apiConfig.getMakeDensityRuleLiveUrl();
            return this.post(serverUrl, ruleObj).pipe(map(this.extractCompleteResponse));
        };
        this.deleteDensityRule = (ruleObj) => {
            const serverUrl = this.apiConfig.getDeleteDensityRuleUrl();
            const options = {
                body: ruleObj
            };
            return this.delete(serverUrl, options).pipe(map(this.extractCompleteResponse));
        };
        this.saveDensityRule = (saveConfig) => {
            const body = saveConfig;
            const serverUrl = this.apiConfig.getSaveDensityRuleUrl();
            return this.post(serverUrl, body).pipe(map(this.extractCompleteResponse));
        };
    }
}
RuleService.ɵfac = function RuleService_Factory(t) { return new (t || RuleService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
RuleService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RuleService, factory: RuleService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RuleService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class SsidService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getSSIDList = () => {
            const getSsidListUrl = this.apiConfig.getSsidListUrl();
            return this.get(getSsidListUrl).pipe(map(this.extractResponseData));
        };
        this.getSSIDListV2 = () => {
            const getSsidListUrl = this.apiConfig.getSsidListV2Url();
            return this.get(getSsidListUrl).pipe(map(this.extractResponseData));
        };
        this.getSSIDDetail = (ssidId) => {
            const getSsidDetailUrl = this.apiConfig.getSsidDetailUrl() +
                "/" +
                encodeURIComponent(ssidId);
            return this.get(getSsidDetailUrl).pipe(map(this.extractResponse));
        };
        this.updateSSID = (ssidData) => {
            const serverUrl = this.apiConfig.updateSSIDUrl();
            return this.post(serverUrl, ssidData).pipe(map(this.extractResponse));
        };
        this.getSSIDStatus = (ssidId) => {
            const getSSIDStatusUrl = this.apiConfig.getSSIDStatusUrl() +
                "/" +
                encodeURIComponent(ssidId);
            return this.get(getSSIDStatusUrl).pipe(map(this.extractResponseData));
        };
        this.deleteSSID = (ssidConfig) => {
            const opts = {
                body: ssidConfig
            };
            const serverUrl = this.apiConfig.getSsidDeleteUrl();
            return this.delete(serverUrl, opts).pipe(map(this.extractResponse));
        };
        this.deleteSSIDConfig = (ssidConfig) => {
            const opts = {
                body: ssidConfig
            };
            const serverUrl = this.apiConfig.getSsidConfigDeleteUrl();
            return this.delete(serverUrl, opts).pipe(map(this.extractResponse));
        };
        this.addMSESsid = (mseSSID) => {
            const serverUrl = this.apiConfig.getAddMSESsidUrl();
            return this.post(serverUrl, mseSSID).pipe(map(this.extractResponse));
        };
        this.importMerakiSsid = (merakiSSIDs) => {
            const serverUrl = this.apiConfig.getImportMerakiSSIDUrl();
            return this.post(serverUrl, merakiSSIDs).pipe(map(this.extractResponse));
        };
        this.getImportSSIDOrg = () => {
            const getImportSSIDOrgUrl = this.apiConfig.getImportSSIDOrgUrl();
            return this.get(getImportSSIDOrgUrl).pipe(map(this.extractResponse));
        };
        this.getNetworkSSID = (selectedMerakiOrg) => {
            const getNetworkSSIDUrl = this.apiConfig.getNetworkSSIDUrl();
            return this.post(getNetworkSSIDUrl, selectedMerakiOrg).pipe(map(this.extractResponse));
        };
        this.getSSIDWalledGardenDomains = (ssidData) => {
            const getSSIDWalledGardenDomainsUrl = this.apiConfig.getSSIDWalledGardenDomainsUrl();
            return this.post(getSSIDWalledGardenDomainsUrl, ssidData).pipe(map(this.extractResponseData));
        };
        this.getSSIDWalledGardenRanges = () => {
            const getSSIDWalledGardenRangesUrl = this.apiConfig.getSSIDWalledGardenRangesUrl();
            return this.get(getSSIDWalledGardenRangesUrl).pipe(map(this.extractResponseData));
        };
        this.getSSIDManualConfigInfo = () => {
            const getSSIDManualConfigInfoUrl = this.apiConfig.getSSIDManualConfigInfoUrl();
            return this.get(getSSIDManualConfigInfoUrl).pipe(map(this.extractResponseData));
        };
        this.getNetworkStatusInfo = () => {
            const getNetworkStatusInfoUrl = this.apiConfig.getNetworkStatusInfoUrl();
            return this.get(getNetworkStatusInfoUrl).pipe(map(this.extractResponseData));
        };
    }
}
SsidService.ɵfac = function SsidService_Factory(t) { return new (t || SsidService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
SsidService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SsidService, factory: SsidService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SsidService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class TilesService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getRuleCount = () => {
            const url = this.apiConfig.getTileRuleCount();
            return this.get(url).pipe(map(this.extractResponseData));
        };
    }
}
TilesService.ɵfac = function TilesService_Factory(t) { return new (t || TilesService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
TilesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TilesService, factory: TilesService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TilesService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

const moment = moment_;
class TmsAuthService {
    constructor(logger, dataService, authService, userService, injector, httpClientWrapper) {
        this.logger = logger;
        this.dataService = dataService;
        this.authService = authService;
        this.userService = userService;
        this.injector = injector;
        this.httpClientWrapper = httpClientWrapper;
        this.apiConfig = new ApiConfig();
        this.util = new Utils(this.logger);
        this.isSsoLogin = false;
        this.isManageUser = true;
        this.customerAccountNo = null;
        this.extractHttpResponse = (res) => {
            return res;
        };
        this.handleErrorObservable = (error) => {
            return throwError(error);
        };
        this.loginAccountSSO = (isSSOLogin, username, unsubscribe$) => {
            const promise = new Promise((resolve, reject) => {
                this.logger.debug("Going to login user into tenant management server");
                const options = {};
                this.logger.debug("getting locations: headers", options, this.apiConfig.getFetchAccountsSSOLogintUrl());
                this.httpClientWrapper
                    .get(this.apiConfig.getFetchAccountsSSOLogintUrl(), options)
                    .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable))
                    .subscribe((authResponse) => {
                    this.getCustomerList(authResponse, username, resolve, reject);
                }, (error) => {
                    console.log(error);
                    const responseObj = {
                        data: {}
                    };
                    responseObj["data"]["error"] = error.error;
                    responseObj["status"] = false;
                    reject(responseObj);
                    return;
                });
            });
            return promise;
        };
        this.shareLoginType = (guid, userName, role, unsubscribe$) => {
            const promise = new Promise((resolve, reject) => {
                this.logger.debug("Going to login user into tenant management server");
                const options = {};
                this.logger.debug("getting locations: headers", options, this.apiConfig.getFetchAccountsSSOLogintUrl());
                this.httpClientWrapper
                    .get(this.apiConfig.getSharedLoginTypeUrl(guid, userName, role), options)
                    .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable))
                    .subscribe((authResponse) => {
                    console.log("Got success from share shareLoginType api", authResponse);
                    resolve(authResponse);
                    return;
                }, (error) => {
                    console.log("Got error from share login api", error);
                    reject(error);
                    return;
                });
            });
            return promise;
        };
        this.getReportDataBySysToken = (guid, role, unsubscribe$) => {
            const promise = new Promise((resolve, reject) => {
                this.logger.debug("Going to call get report data by sysToken api from tenant management server");
                const options = {};
                this.logger.debug("getting locations: headers", options, this.apiConfig.getFetchAccountsSSOLogintUrl());
                this.httpClientWrapper
                    .get(this.apiConfig.getReportDataBySysTokenUrl(guid, role), options)
                    .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable))
                    .subscribe((authResponse) => {
                    console.log("Got success from get report data by sysToken api", authResponse);
                    resolve(authResponse);
                    return;
                }, (error) => {
                    console.log("Got error from get report data by sysToken api", error);
                    reject(error);
                    return;
                });
            });
            return promise;
        };
        this.loginSupportAccountSSO = (isSSOLogin, username, unsubscribe$) => {
            const promise = new Promise((resolve, reject) => {
                this.logger.debug("Going to login user into tenant management server");
                const options = {};
                this.logger.debug("getting locations: headers", options, this.apiConfig.getFetchAccountsSSOLogintUrl());
                this.httpClientWrapper
                    .get(this.apiConfig.getFetchAccountsSSOLogintUrl(), options)
                    .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable))
                    .subscribe((authResponse) => {
                    this.getSupportCustomerList(authResponse, username, resolve, reject);
                }, (error) => {
                    console.log(error);
                    const responseObj = {
                        data: {}
                    };
                    responseObj["data"]["error"] = error.error;
                    responseObj["status"] = false;
                    reject(responseObj);
                    return;
                });
            });
            return promise;
        };
        this.fetchUserCustomer = (unsubscribe$) => {
            const promise = new Promise((resolve, reject) => {
                this.httpClientWrapper
                    .get(this.apiConfig.getFetchUserCustomerUrl(), {})
                    .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable))
                    .subscribe((authResponse) => {
                    console.log(authResponse);
                    if (authResponse) {
                        const responseObj = {
                            data: {}
                        };
                        responseObj["data"] = authResponse;
                        responseObj["status"] = true;
                        resolve(responseObj);
                    }
                    else {
                        const responseObj = {
                            data: {}
                        };
                        responseObj["data"]["error"] = authResponse.message;
                        responseObj["status"] = false;
                        reject(responseObj);
                        return;
                    }
                }, (error) => {
                    console.log(error);
                    const responseObj = {
                        data: {}
                    };
                    responseObj["data"]["error"] = error.error;
                    responseObj["status"] = false;
                    reject(responseObj);
                    return;
                });
            });
            return promise;
        };
        this.shareLogin = (username, password, guid, isPinLogin, role, unsubscribe$) => {
            username = username.trim();
            const promise = new Promise((resolve, reject) => {
                this.logger.debug("Going to login user into tenant management server");
                const headers = new HttpHeaders({
                    "Content-Type": "application/json",
                    Authorization: "Basic " + btoa(username + ":" + password)
                });
                const options = {
                    headers
                };
                const body = { shareId: guid };
                const apiURL = isPinLogin
                    ? this.apiConfig.getSharePINTenantEndpointUrl(role)
                    : this.apiConfig.getShareTenantEndpointUrl(role);
                this.logger.debug("getting locations: headers", options, apiURL);
                this.httpClientWrapper
                    .post(apiURL, body, options)
                    .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable))
                    .subscribe((authResponse) => {
                    console.log("Got success from share login api", authResponse);
                    const responseObj = {
                        status: true,
                        data: authResponse
                    };
                    resolve(responseObj);
                    return;
                }, (error) => {
                    console.log("Got error from share login api", error);
                    const responseObj = {
                        status: false,
                        data: error
                    };
                    resolve(responseObj);
                    return;
                });
            });
            return promise;
        };
        this.login = (username, password, unsubscribe$) => {
            username = username.trim();
            const promise = new Promise((resolve, reject) => {
                this.logger.debug("Going to login user into tenant management server");
                const headers = new HttpHeaders({
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: "Basic " +
                        btoa(unescape(encodeURIComponent(username + ":" + password)))
                });
                const options = {
                    headers
                };
                this.logger.debug("getting locations: headers", options, this.apiConfig.getTenantEndpointUrl());
                this.httpClientWrapper
                    .post(this.apiConfig.getTenantEndpointUrl(), {}, options)
                    .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable))
                    .subscribe((authResponse) => {
                    this.getCustomerList(authResponse, username, resolve, reject);
                }, (error) => {
                    console.log(error);
                    const responseObj = {
                        data: {}
                    };
                    responseObj["data"]["error"] = error.error;
                    responseObj["status"] = false;
                    reject(responseObj);
                    return;
                });
            });
            return promise;
        };
        this.loginEmailStatus = (username, appName, unsubscribe$) => {
            username = username.trim();
            const promise = new Promise((resolve, reject) => {
                this.logger.debug("Going to check whether email has sso login or not");
                const headers = new HttpHeaders({
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: "Basic " + btoa(username)
                });
                const options = {
                    headers
                };
                this.logger.debug("getting locations: headers", options, this.apiConfig.getEmailStatusEndPointUrl());
                // for get call
                const url = this.apiConfig.getEmailStatusEndPointUrl() +
                    "/" +
                    username +
                    "?app=" +
                    appName;
                this.httpClientWrapper
                    .get(url, {})
                    .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable))
                    .subscribe((authResponse) => {
                    console.log(authResponse);
                    this.getLoginEmailStatusResponse(authResponse, username, resolve, reject);
                }, (error) => {
                    console.log(error);
                    const responseObj = {
                        data: {}
                    };
                    responseObj["data"]["error"] = error.error;
                    responseObj["status"] = false;
                    reject(responseObj);
                    return;
                });
            });
            return promise;
        };
        this.getLoginEmailStatusResponse = (authResponse, username, resolve, reject) => {
            console.log(authResponse);
            const error = null;
            if (authResponse) {
                const responseObj = {
                    data: {
                        status: authResponse.enabled || authResponse.cci,
                        userName: username
                    }
                };
                resolve(responseObj);
                return;
            }
            else {
                const responseObj = {
                    data: {}
                };
                responseObj["data"]["error"] = authResponse.message;
                responseObj["status"] = false;
                reject(responseObj);
                return;
            }
        };
        this.getCustomerList = (authResponse, username, resolve, reject) => {
            console.log(authResponse);
            const error = null;
            const customerDetails = {};
            const customerJsonArray = [];
            if (authResponse && authResponse.userDetails) {
                authResponse.accountDetails.forEach((tenant) => {
                    const customerJson = {};
                    let isAccountActive = false;
                    const licenses = tenant.licenses;
                    //Pending, Deleted, Accepted
                    customerJson["tenantId"] = tenant.tenantId;
                    customerJson["customerName"] = tenant.accountName;
                    customerJson["accountNumber"] = tenant.accountNumber;
                    // customerJson["token"] = tenant.token;
                    const now = moment();
                    if (licenses != null &&
                        !licenses.isEmpty &&
                        tenant.status === "Accepted") {
                        // for (let licenseIndex = 0, licenseMax = licenses.length; licenseIndex < licenseMax; licenseIndex++) {
                        const licenseItem = licenses[0]; // It is understood that TMS will provide only one License which is DNASpaces
                        const startdate = licenseItem.startDate;
                        const enddate = licenseItem.endDate;
                        if (startdate != null && enddate != null) {
                            try {
                                const customerEndDate = moment(enddate);
                                if (customerEndDate != null &&
                                    customerEndDate >= now) {
                                    isAccountActive = true;
                                    customerJson["accountStatus"] = "ACTIVE";
                                }
                                else {
                                    customerJson["accountStatus"] = "EXPIRED";
                                }
                            }
                            catch (e) {
                                isAccountActive = true;
                                customerJson["accountStatus"] = "ACTIVE";
                                console.log("error while checking license", e);
                            }
                            try {
                                customerJson["startDate"] = startdate;
                                const customerStartDate = moment(startdate);
                                const customerEndDate = moment(enddate);
                                const termMonths = (customerEndDate - customerStartDate) /
                                    1000 /
                                    60 /
                                    60 /
                                    24 /
                                    30;
                                customerJson["termMonths"] = termMonths;
                            }
                            catch (e) {
                                console.log("error while checking getting the terms months", e);
                            }
                        }
                        // }
                        const customerString = tenant.accountName + " (" + tenant.accountNumber + ")";
                        customerDetails[customerString] =
                            customerJson["accountStatus"];
                        customerJsonArray.push(customerJson);
                    }
                    else if (licenses == null || licenses.isEmpty) {
                        customerJson["accountStatus"] = "EXPIRED";
                        customerJsonArray.push(customerJson);
                        const customerString = tenant.accountName + " (" + tenant.accountNumber + ")";
                        customerDetails[customerString] = "EXPIRED";
                    }
                    else if (tenant.status === "Pending") {
                        customerJson["accountStatus"] = "INACTIVE";
                        customerJsonArray.push(customerJson);
                        const customerString = tenant.accountName + " (" + tenant.accountNumber + ")";
                        customerDetails[customerString] = "INACTIVE";
                    }
                    else if (tenant.status === "Deleted") {
                        customerJson["accountStatus"] = "DELETED";
                        customerJsonArray.push(customerJson);
                        const customerString = tenant.accountName + " (" + tenant.accountNumber + ")";
                        customerDetails[customerString] = "DELETED";
                    }
                    else {
                        customerJson["accountStatus"] = (tenant.status).toUpperCase;
                        customerJsonArray.push(customerJson);
                        const customerString = tenant.accountName + " (" + tenant.accountNumber + ")";
                        customerDetails[customerString] = (tenant.status).toUpperCase;
                    }
                });
                username = username == '' ? authResponse.userDetails.userName : username;
                const responseObj = {
                    data: {
                        customers: customerDetails,
                        userName: username,
                        firstName: authResponse.userDetails.firstName,
                        lastName: authResponse.userDetails.lastName
                    }
                };
                if (error) {
                    responseObj["data"]["error"] = error;
                    responseObj["status"] = false;
                }
                else {
                    responseObj["status"] = true;
                    responseObj["message"] = "Logging in";
                    const loginRedisKey = username + "_login";
                    authResponse["customerJsonArray"] = customerJsonArray;
                    this.dataService.getLoginTemp()[loginRedisKey] =
                        JSON.stringify(authResponse);
                    const customerListRedisKey = username + "_customerlist";
                    this.dataService.getLoginTemp()[customerListRedisKey] =
                        JSON.stringify(customerDetails);
                }
                resolve(responseObj);
                return;
                // authResponse["cookieHeaders"] = authResponse.headers["set-cookie"];
                // let accData = authResponse.accountDetails;
                // let index = 0;
                // let accountRedisKey = username + '_accountdetails';
                // this.dataService.getLoginTemp()[accountRedisKey] = JSON.stringify(accData);
                // this.getLicenseDetails(username, index, accData, customerDetails, resolve, reject, error, customerJsonArray, authResponse, isSSOLogin);
            }
            else {
                const responseObj = {
                    data: {}
                };
                responseObj["data"]["error"] = authResponse.message;
                responseObj["status"] = false;
                reject(responseObj);
                return;
            }
        };
        this.getSupportCustomerList = (authResponse, username, resolve, reject) => {
            console.log(authResponse);
            const error = null;
            const customerDetails = {};
            const customerJsonArray = [];
            if (authResponse && authResponse.userDetails) {
                authResponse.accountDetails.forEach((tenant) => {
                    const customerJson = {};
                    let isAccountActive = false;
                    const licenses = tenant.licenses;
                    //Pending, Deleted, Accepted
                    customerJson["tenantId"] = tenant.tenantId;
                    customerJson["customerName"] = tenant.accountName;
                    customerJson["accountNumber"] = tenant.accountNumber;
                    // customerJson["token"] = tenant.token;
                    const now = moment();
                    if (licenses != null &&
                        !licenses.isEmpty &&
                        tenant.status === "Accepted") {
                        // for (let licenseIndex = 0, licenseMax = licenses.length; licenseIndex < licenseMax; licenseIndex++) {
                        const licenseItem = licenses[0]; // It is understood that TMS will provide only one License which is DNASpaces
                        const startdate = licenseItem.startDate;
                        const enddate = licenseItem.endDate;
                        if (startdate != null && enddate != null) {
                            try {
                                const customerEndDate = moment(enddate);
                                if (customerEndDate != null &&
                                    customerEndDate >= now) {
                                    isAccountActive = true;
                                    customerJson["accountStatus"] = "ACTIVE";
                                }
                                else {
                                    customerJson["accountStatus"] = "EXPIRED";
                                }
                            }
                            catch (e) {
                                isAccountActive = true;
                                customerJson["accountStatus"] = "ACTIVE";
                                console.log("error while checking license", e);
                            }
                            try {
                                customerJson["startDate"] = startdate;
                                const customerStartDate = moment(startdate);
                                const customerEndDate = moment(enddate);
                                const termMonths = (customerEndDate - customerStartDate) /
                                    1000 /
                                    60 /
                                    60 /
                                    24 /
                                    30;
                                customerJson["termMonths"] = termMonths;
                            }
                            catch (e) {
                                console.log("error while checking getting the terms months", e);
                            }
                        }
                        // }
                        const customerString = tenant.accountName +
                            " (" +
                            tenant.accountNumber +
                            "-" +
                            tenant.tenantId +
                            ")";
                        customerDetails[customerString] =
                            customerJson["accountStatus"];
                        customerJsonArray.push(customerJson);
                    }
                    else if (licenses == null || licenses.isEmpty) {
                        customerJson["accountStatus"] = "EXPIRED";
                        customerJsonArray.push(customerJson);
                        const customerString = tenant.accountName + " (" + tenant.accountNumber + ")";
                        customerDetails[customerString] = "EXPIRED";
                    }
                    else if (tenant.status === "Pending") {
                        customerJson["accountStatus"] = "INACTIVE";
                        customerJsonArray.push(customerJson);
                        const customerString = tenant.accountName + " (" + tenant.accountNumber + ")";
                        customerDetails[customerString] = "INACTIVE";
                    }
                    else if (tenant.status === "Deleted") {
                        customerJson["accountStatus"] = "DELETED";
                        customerJsonArray.push(customerJson);
                        const customerString = tenant.accountName + " (" + tenant.accountNumber + ")";
                        customerDetails[customerString] = "DELETED";
                    }
                    else {
                        customerJson["accountStatus"] = (tenant.status).toUpperCase;
                        customerJsonArray.push(customerJson);
                        const customerString = tenant.accountName + " (" + tenant.accountNumber + ")";
                        customerDetails[customerString] = (tenant.status).toUpperCase;
                    }
                });
                const responseObj = {
                    data: {
                        customers: customerDetails,
                        userName: username
                    }
                };
                if (error) {
                    responseObj["data"]["error"] = error;
                    responseObj["status"] = false;
                }
                else {
                    responseObj["status"] = true;
                    responseObj["message"] = "Logging in";
                    const loginRedisKey = username + "_login";
                    authResponse["customerJsonArray"] = customerJsonArray;
                    this.dataService.getLoginTemp()[loginRedisKey] =
                        JSON.stringify(authResponse);
                    const customerListRedisKey = username + "_customerlist";
                    this.dataService.getLoginTemp()[customerListRedisKey] =
                        JSON.stringify(customerDetails);
                }
                resolve(responseObj);
                return;
                // authResponse["cookieHeaders"] = authResponse.headers["set-cookie"];
                // let accData = authResponse.accountDetails;
                // let index = 0;
                // let accountRedisKey = username + '_accountdetails';
                // this.dataService.getLoginTemp()[accountRedisKey] = JSON.stringify(accData);
                // this.getLicenseDetails(username, index, accData, customerDetails, resolve, reject, error, customerJsonArray, authResponse, isSSOLogin);
            }
            else {
                const responseObj = {
                    data: {}
                };
                responseObj["data"]["error"] = authResponse.message;
                responseObj["status"] = false;
                reject(responseObj);
                return;
            }
        };
        this.selectCustomer = (username, customerDisplay, unsubscribe$, cciDate = "", isSSOLogin = false, isTenantReq = false) => {
            const regex = /\W\((\d*)\)$/gm;
            const accountNumber = parseInt(customerDisplay
                .match(regex)[customerDisplay.match(regex).length - 1].trim()
                .replace("(", "")
                .replace(")", ""));
            const customer = customerDisplay.replace(customerDisplay.match(regex)[customerDisplay.match(regex).length - 1], "");
            const promise = new Promise((resolve, reject) => {
                this.logger.debug("generating user customer token");
                if (!username) {
                    reject({
                        status: false,
                        message: "No username selected. Please try again or contact support."
                    });
                    return;
                }
                if (!customer) {
                    reject({
                        status: false,
                        message: "No Customer selected. Please try again or contact support."
                    });
                    return;
                }
                const loginRedisKey = username + "_login";
                const accountMapString = this.dataService.getLoginTemp()[loginRedisKey];
                if (accountMapString) {
                    // console.log(accountMapString);
                    const accountMap = JSON.parse(accountMapString);
                    // console.log("accountMap", accountMap);
                    // let userCustomerListRedisKey = accountMap.customerJsonArray;
                    const customerListObj = accountMap.customerJsonArray.filter(function (accDetails) {
                        return (accDetails.customerName === customer &&
                            accDetails.accountNumber == accountNumber);
                    });
                    if (!customerListObj[0]) {
                        reject({
                            status: false,
                            message: "No username selected. Please try again or contact support."
                        });
                        return;
                    }
                    const customerSelectedObj = accountMap.accountDetails.filter(function (tena) {
                        console.log(tena.accountName);
                        return (tena.accountName === customer &&
                            tena.accountNumber == accountNumber);
                    });
                    console.log("Customer selection done. Going to select Apps for user from TM system::", customerSelectedObj);
                    const tenantId = customerSelectedObj[0].tenantId;
                    this.dataService.setTenantId(tenantId);
                    if (isTenantReq)
                        resolve(true);
                    const selectAppEndpoint = this.apiConfig.getSelectAppEndpointUrl() +
                        "/" +
                        customerSelectedObj[0].tenantId;
                    this.httpClientWrapper
                        .get(selectAppEndpoint, {})
                        .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable))
                        .subscribe((responseObj) => {
                        console.log("responseObj for selecting apps, before verify account ::", responseObj);
                        this.dataService.setAccountServices(responseObj.services);
                        //cci country code required -start
                        this.dataService.setCountryCodeRequired(responseObj.isCountryReqiured);
                        console.log("responseObj for selecting apps, setting country required ::", responseObj);
                        //cci country code required -end
                        this.userService
                            .getUserCurrentStatus()
                            .pipe(takeUntil(unsubscribe$))
                            .subscribe((responseData) => {
                            if (responseData) {
                                this.isSsoLogin =
                                    responseData.isSSOLogin !=
                                        null &&
                                        responseData.isSSOLogin !=
                                            undefined
                                        ? responseData.isSSOLogin
                                        : false;
                                this.dataService.setIsAuthSSO(this.isSsoLogin);
                                this.isManageUser =
                                    responseData.isManageUser !=
                                        null &&
                                        responseData.isManageUser !=
                                            undefined
                                        ? responseData.isManageUser
                                        : true;
                                this.dataService.setIsManageUser(this.isManageUser);
                                if (responseData.licenseDetails) {
                                    this.customerAccountNo =
                                        responseData.licenseDetails
                                            .customerAccountNo !=
                                            null &&
                                            responseData.licenseDetails
                                                .customerAccountNo !=
                                                undefined
                                            ? responseData
                                                .licenseDetails
                                                .customerAccountNo
                                            : null;
                                    this.dataService.setCustomerAccNo(this.customerAccountNo);
                                }
                                const isDashboardUser = responseData.isDashboardUser;
                                this.dataService.setIsAdminUser(isDashboardUser);
                                console.log("user current status response is recieved", JSON.stringify(responseData));
                                this.dataService.setAccessToken(responseData.token);
                                if (responseData["apps"] &&
                                    responseData["isDashboardUser"]) {
                                    // user role:
                                    const dnaSpacesObj = responseData["apps"].filter(function (appObj) {
                                        return (appObj.appName ===
                                            "DNASpaces");
                                    });
                                    if (dnaSpacesObj &&
                                        dnaSpacesObj.length == 1) {
                                        this.dataService.setUserRole(new UserRole(dnaSpacesObj[0].appName, dnaSpacesObj[0].appRole, dnaSpacesObj[0].contextUrl));
                                    }
                                }
                                if (responseData.licenseDetails) {
                                    this.dataService.setLicenseDetails(responseData.licenseDetails);
                                }
                                resolve(responseData);
                                return;
                            }
                            else {
                                reject({
                                    status: false,
                                    message: "Not able to login using selected Customer account. Please contact support.",
                                    data: null
                                });
                                return;
                            }
                        }, (error) => {
                            reject({
                                status: false,
                                message: "Not able to current user status in Customer account. Please contact support.",
                                data: null
                            });
                            return;
                        });
                    }, (error) => {
                        if (error.status == 401 ||
                            error.message == undefined ||
                            error.message == null) {
                            reject({
                                status: false,
                                message: "Not able to login using selected Customer account. Please login again.",
                                data: null
                            });
                        }
                        else if (error.message) {
                            reject({
                                status: false,
                                message: error.message,
                                data: null
                            });
                        }
                        return;
                    });
                }
            });
            return promise;
        };
        this.ssoAUserActivateRedirection = (tenantId, contextUrl, unsubscribe$, isSSOLogin = false) => {
            const promise = new Promise((resolve, reject) => {
                console.log("ssoAUserActivateRedirection :: tenantId :: " +
                    tenantId +
                    " :: contextUrl :: " +
                    contextUrl);
                const selectAppEndpoint = this.apiConfig.getSelectAppEndpointUrl() + "/" + tenantId;
                this.httpClientWrapper
                    .get(selectAppEndpoint, {})
                    .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable))
                    .subscribe((responseObj) => {
                    console.log("ssoAUserActivateRedirection :: selectAppEndpoint get call ::", responseObj);
                    setTimeout(() => {
                        const getUrl = window.location;
                        window.location.href =
                            getUrl.protocol +
                                "//" +
                                getUrl.host +
                                contextUrl +
                                "/";
                    }, 200);
                }, (error) => {
                    if (error.status == 401 ||
                        error.message == undefined ||
                        error.message == null) {
                        reject({
                            status: false,
                            message: "Not able to login using selected Customer account. Please login again.",
                            data: null
                        });
                    }
                    else if (error.message) {
                        reject({
                            status: false,
                            message: error.message,
                            data: null
                        });
                    }
                    return;
                });
            });
            return promise;
        };
        this.extractData = (res) => {
            const array = [];
            let key, count = 0;
            for (key in res.body) {
                array.push(res.body[count++]);
            }
            return array;
        };
        this.oauthAuthentication = (object, unsubscribe$) => {
            const promise = new Promise((resolve, reject) => {
                this.logger.debug("Going to make oauth Authentication call");
                const headers = new HttpHeaders({
                    "Content-Type": "application/x-www-form-urlencoded",
                    // Authorization:
                    // 	"Basic " +
                    // 	btoa(
                    // 		unescape(encodeURIComponent(username + ":" + password))
                    // 	)
                });
                const options = {
                    skipContentType: true,
                    headers
                };
                this.httpClientWrapper
                    .post(this.apiConfig.getTenantOauthAuthenticationURL(), object, options)
                    .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable))
                    .subscribe((authResponse) => {
                    this.logger.debug("got the response for oauth authentication call :: " + authResponse);
                }, (error) => {
                    console.log(error);
                    const responseObj = {
                        data: {}
                    };
                    if (error.status == 302) {
                        responseObj["data"]["status"] = true;
                        let locationUrl = error.headers.get("Location");
                        if (locationUrl != null && locationUrl != '')
                            responseObj["data"]["location"] = locationUrl;
                        resolve(responseObj);
                        return;
                    }
                    responseObj["data"]["error"] = error.error;
                    responseObj["status"] = false;
                    reject(responseObj);
                    return;
                });
            });
            return promise;
        };
    }
}
TmsAuthService.ɵfac = function TmsAuthService_Factory(t) { return new (t || TmsAuthService)(i0.ɵɵinject(LoggerService), i0.ɵɵinject(DataService), i0.ɵɵinject(AuthService), i0.ɵɵinject(UserService), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(HttpClientWrapperService)); };
TmsAuthService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TmsAuthService, factory: TmsAuthService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TmsAuthService, [{
        type: Injectable
    }], function () { return [{ type: LoggerService }, { type: DataService }, { type: AuthService }, { type: UserService }, { type: i0.Injector }, { type: HttpClientWrapperService }]; }, null); })();

class BleUuidsService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getBleUuids = () => {
            const getBleUuidsUrl = this.apiConfig.getBleUuidsUrl();
            return this.get(getBleUuidsUrl).pipe(map(this.extractResponseData));
        };
        this.deleteBleUuid = (uuid) => {
            const serverUrl = this.apiConfig.deleteBleUuidsUrl();
            const deleteUUID = {
                uuid: uuid
            };
            const opts = {
                body: deleteUUID
            };
            return this.delete(serverUrl, opts).pipe(map(this.extractResponse));
        };
        this.addBleUuid = (uuid) => {
            const serverUrl = this.apiConfig.addBleUuidsUrl();
            const addUUID = {
                uuid: uuid
            };
            return this.post(serverUrl, addUUID).pipe(map(this.extractResponse));
        };
    }
}
BleUuidsService.ɵfac = function BleUuidsService_Factory(t) { return new (t || BleUuidsService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
BleUuidsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BleUuidsService, factory: BleUuidsService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BleUuidsService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class NotificationChannelService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.getNotificationChannels = () => {
            const getNotificationChannelsUrl = this.apiConfig.getNotificationChannelsUrl();
            return this.get(getNotificationChannelsUrl).pipe(map(this.extractResponseData));
        };
        this.savePushConfiguration = (pushConfigurationJson, apnsCertificateP12, apnsCertificateCert) => {
            const formData = new FormData();
            if (apnsCertificateP12) {
                formData.append("apnsCertificateP12", apnsCertificateP12[0]);
            }
            if (apnsCertificateCert) {
                formData.append("apnsCertificateCert", apnsCertificateCert[0]);
            }
            if (pushConfigurationJson)
                formData.append("pushConfigurationJson", JSON.stringify(pushConfigurationJson));
            const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization: "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json"
            };
            this.logger.debug("save push configuration", this.apiConfig.getSaveNotificationChannelUrl());
            return this.post(this.apiConfig.getSaveNotificationChannelUrl(), formData, options).pipe(map(this.extractResponseData));
        };
        this.deleteNotificationChannel = (data) => {
            const opts = {
                body: data
            };
            const serverUrl = this.apiConfig.getDeleteNotificationChannelUrl() + "/" + data.id;
            return this.delete(serverUrl, opts).pipe(map(this.extractResponseData));
        };
        this.renameNotification = (data) => {
            const serverUrl = this.apiConfig.getRenameNotification();
            return this.post(serverUrl, data).pipe(map(this.extractResponseData));
        };
    }
}
NotificationChannelService.ɵfac = function NotificationChannelService_Factory(t) { return new (t || NotificationChannelService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
NotificationChannelService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NotificationChannelService, factory: NotificationChannelService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationChannelService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class SdkService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.getSdkList = () => {
            const getSdkUrl = this.apiConfig.getSdkUrl();
            return this.get(getSdkUrl).pipe(map(this.extractResponseData));
        };
    }
}
SdkService.ɵfac = function SdkService_Factory(t) { return new (t || SdkService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
SdkService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SdkService, factory: SdkService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdkService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class SmsGatewayService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getSMSGatewayList = () => {
            const getSMSGatewayListUrl = this.apiConfig.getSmsGatewayListUrl();
            return this.get(getSMSGatewayListUrl).pipe(map(this.extractResponseData));
        };
        this.getSMSGatewayTypes = () => {
            const getSmsGatewayTypesUrl = this.apiConfig.getSmsGatewayTypesUrl();
            return this.get(getSmsGatewayTypesUrl).pipe(map(this.extractResponseData));
        };
        this.addSMSGatewayAccount = (data) => {
            const serverUrl = this.apiConfig.getSaveSMSGatewayUrl();
            return this.post(serverUrl, data).pipe(map(this.extractResponse));
        };
        this.editSMSGatewayAccount = (data) => {
            const serverUrl = this.apiConfig.getUpdateSMSGatewayUrl();
            return this.post(serverUrl, data).pipe(map(this.extractResponse));
        };
        this.deleteSMSGateway = (data) => {
            const opts = {
                body: data
            };
            const serverUrl = this.apiConfig.getDeleteSMSGatewayUrl();
            return this.delete(serverUrl, opts).pipe(map(this.extractResponse));
        };
        this.getSMSLimitList = () => {
            const getSMSLimitListUrl = this.apiConfig.getSMSLimitUrl();
            return this.get(getSMSLimitListUrl).pipe(map(this.extractResponseData));
        };
        this.saveSMSLimit = (data) => {
            const serverUrl = this.apiConfig.saveSMSLimitUrl();
            return this.post(serverUrl, data).pipe(map(this.extractResponse));
        };
    }
}
SmsGatewayService.ɵfac = function SmsGatewayService_Factory(t) { return new (t || SmsGatewayService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
SmsGatewayService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SmsGatewayService, factory: SmsGatewayService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SmsGatewayService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class SocialAppService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.getSocialAppsList = () => {
            const getSocialAppsListUrl = this.apiConfig.getSocialAppListUrl();
            return this.get(getSocialAppsListUrl).pipe(map(this.extractResponseData));
        };
        this.updateAppSettings = (data, appName) => {
            let updateUrl = null;
            if (appName.toLowerCase() === "facebook") {
                updateUrl = this.apiConfig.getUpdateFacebookAppUrl();
            }
            if (appName.toLowerCase() === "twitter") {
                updateUrl = this.apiConfig.getUpdateTwitterAppUrl();
            }
            if (appName.toLowerCase() === "linkedin") {
                updateUrl = this.apiConfig.getUpdateLinkedinAppUrl();
            }
            return this.post(updateUrl, data).pipe(map(this.extractResponseData));
        };
    }
}
SocialAppService.ɵfac = function SocialAppService_Factory(t) { return new (t || SocialAppService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
SocialAppService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SocialAppService, factory: SocialAppService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SocialAppService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class WebexTeamService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getWebexAccountList = () => {
            const getWebexAccountListUrl = this.apiConfig.getWebexAccountListUrl();
            return this.get(getWebexAccountListUrl).pipe(map(this.extractResponseData));
        };
        this.getWebexRoomList = (data) => {
            if (data) {
                const accessToken = data.accessToken;
                // if (accessToken != undefined && accessToken != "") {
                return this.post(this.apiConfig.getWebexRoomListUrl(), data).pipe(map(this.extractResponse));
                // }
            }
        };
        this.getWebexEmail = (data) => {
            if (data) {
                const accessToken = data.webexAccount.accessToken;
                // if (accessToken != undefined && accessToken != "") {
                return this.post(this.apiConfig.getWebexCheckEmailUrl(), data).pipe(map(this.extractResponse));
                // }
            }
        };
        this.authenticateAccount = (data) => {
            if (data) {
                // need to do the validation for access token
                const accessToken = data.accessToken;
                if (accessToken != undefined && accessToken != "") {
                    return this.post(this.apiConfig.getWebexAuthenticateUrl(), data).pipe(map(this.extractResponse));
                }
            }
        };
        this.addWebexAccount = (data) => {
            if (data) {
                const serverUrl = this.apiConfig.getSaveWebexAccountUrl();
                return this.post(serverUrl, data).pipe(map(this.extractResponse));
            }
        };
        this.editWebexAccount = (data) => {
            const serverUrl = this.apiConfig.getUpdateWebexAccountUrl();
            return this.post(serverUrl, data).pipe(map(this.extractResponse));
        };
        this.deleteWebexAccount = (data) => {
            const opts = {
                body: data
            };
            const serverUrl = this.apiConfig.getDeleteWebexAccountUrl() + "/" + data.webexTeamId;
            return this.delete(serverUrl, opts).pipe(map(this.extractResponse));
        };
    }
}
WebexTeamService.ɵfac = function WebexTeamService_Factory(t) { return new (t || WebexTeamService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
WebexTeamService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WebexTeamService, factory: WebexTeamService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WebexTeamService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class CciIdService {
    // constructor(public dataService: DataService, public injector: Injector) {
    // 	super(injector);
    // }
    constructor(logger, dataService, authService, userService, injector, httpClientWrapper) {
        this.logger = logger;
        this.dataService = dataService;
        this.authService = authService;
        this.userService = userService;
        this.injector = injector;
        this.httpClientWrapper = httpClientWrapper;
        this.apiConfig = new ApiConfig();
        this.extractHttpResponse = (res) => {
            return res;
        };
        this.handleErrorObservable = (error) => {
            return throwError(error);
        };
        // extractResponseData = (res) => {
        // 	return res.data;
        // };
        // extractResponse = (res) => {
        // 	return res;
        // };
        this.getCCISessionDetailsClient = (cciSessionURL) => {
            // const promise = new Promise((resolve, reject) => {
            console.log("Going to make CCI Session call for :: ");
            const headers = new HttpHeaders({
                "Content-Type": "application/json",
                // 'X-Requested-With': 'undefined'
            });
            const options = {
                headers
            };
            // let apiCallURL = this.apiConfig.getClientCCICallURL();
            // let apiCallURL = "https://dev-id.cisco.com/api/v1/users/me"
            return this.httpClientWrapper
                .get(cciSessionURL, options)
                .pipe(map(this.extractHttpResponse), catchError(this.handleErrorObservable));
        };
    }
}
CciIdService.ɵfac = function CciIdService_Factory(t) { return new (t || CciIdService)(i0.ɵɵinject(LoggerService), i0.ɵɵinject(DataService), i0.ɵɵinject(AuthService), i0.ɵɵinject(UserService), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(HttpClientWrapperService)); };
CciIdService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CciIdService, factory: CciIdService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CciIdService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LoggerService }, { type: DataService }, { type: AuthService }, { type: UserService }, { type: i0.Injector }, { type: HttpClientWrapperService }]; }, null); })();

// declare var dashboardExtObj: any;
class VersionCheckService {
    constructor(http) {
        this.http = http;
        // To be replaced by actual hash by post build scripts
        this.currentHash = "{{POST_BUILD_MAIN_HASH_HERE}}";
        this.currentFile = null;
        this.counter = 0;
    }
    /**
     * Checks in every set frequency the version of frontend application
     * @param url
     * @param unsubscribe$
     * @param frequency - in milliseconds, defaults to 2 minutes
     */
    doVersionCheck(url, unsubscribe$, frequency = 1000 * 60 * 2) {
        this.checkVersion(url, unsubscribe$);
        setInterval(() => {
            this.checkVersion(url, unsubscribe$);
        }, frequency);
    }
    /**
     * Will do the call and check if the hash has changed or not
     * @param url
     */
    checkVersion(url, unsubscribe$) {
        // timestamp these requests to invalidate caches
        this.http
            .get(url + "?t=" + new Date().getTime())
            .pipe(first(), takeUntil(unsubscribe$))
            .subscribe((response) => {
            const newHash = response.hash;
            console.log("response.forceReload?", response.forceReload, response.forceReload === "true" ? true : false);
            const hashChanged = this.hasHashChanged(this.currentHash, newHash);
            console.log("Is there any update in code on server?", hashChanged, "number of UI updates done [max allowed: 3] ?", this.counter);
            // If new version, increament counter a d try to load main script else reload
            if (hashChanged) {
                this.counter++;
                if (response.forceReload === "true")
                    location.reload();
                try {
                    const loadFile = response.file + "?t=" + new Date().getTime();
                    // dashboardExtObj.loadScript(loadFile, dashboardExtObj.hasLoaded, dashboardExtObj.hasError);
                    const currentScriptToRemove = "script[src='" + this.currentFile + "']";
                    jQuery(currentScriptToRemove).remove();
                }
                catch (e) {
                    location.reload();
                }
            }
            // store the new hash so we wouldn't trigger versionChange again
            // only necessary in case you did not force refresh
            this.currentHash = newHash;
            this.currentFile = response.file;
            if (this.counter > 3)
                location.reload();
        }, (err) => {
            console.error(err, "Could not get version");
        });
    }
    /**
     * Checks if hash has changed.
     * This file has the JS hash, if it is a different one than in the version.json
     * we are dealing with version change
     * @param currentHash
     * @param newHash
     * @returns boolean
     */
    hasHashChanged(currentHash, newHash) {
        if (!currentHash || currentHash === "{{POST_BUILD_MAIN_HASH_HERE}}") {
            return false;
        }
        return currentHash !== newHash;
    }
}
VersionCheckService.ɵfac = function VersionCheckService_Factory(t) { return new (t || VersionCheckService)(i0.ɵɵinject(i1$1.HttpClient)); };
VersionCheckService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: VersionCheckService, factory: VersionCheckService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VersionCheckService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: i1$1.HttpClient }]; }, null); })();

class WebsocketService {
    constructor() {
        this.environment = {
            production: false,
            SOCKET_ENDPOINT: "https://local.dev-dnaspaces.io/socket"
        };
    }
    setupSocketConnection() {
        this.socket = io(this.environment.SOCKET_ENDPOINT, {
            transports: ["websocket", "polling", "flashsocket"]
        });
        this.socket.emit("message", "Hello there from Angular.");
        this.socket.on("broadcast", (data) => {
            console.log("broadcast message from server", data);
        });
    }
    sendMessage() {
        this.socket.emit({
            msg: "Client to server, can you hear me server?"
        });
    }
}
WebsocketService.ɵfac = function WebsocketService_Factory(t) { return new (t || WebsocketService)(); };
WebsocketService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WebsocketService, factory: WebsocketService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WebsocketService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return []; }, null); })();

class SdkAppService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.extractResponse = (res) => {
            return res;
        };
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.getSDKAppList = () => {
            let url = this.apiConfig.getSDKlListUrl();
            return this.get(url)
                .pipe(map(this.extractResponse));
        };
        this.getSDKProfileDetails = (appName) => {
            let url = this.apiConfig.getSDKProfileDetailsURL() + '/' + appName;
            return this.get(url)
                .pipe(map(this.extractResponse));
        };
        this.getSDKConsortiumDetails = () => {
            let url = this.apiConfig.getConsortiumDetailsURL();
            return this.get(url)
                .pipe(map(this.extractResponse));
        };
        this.updateSDKProfile = (sdkName, updateJson) => {
            let url = this.apiConfig.getUpdateSDKPrfileURL() + '/' + sdkName;
            return this.post(url, updateJson)
                .pipe(map(this.extractResponse));
        };
        this.getSDKAppDetails = (appName) => {
            let url = this.apiConfig.getSDKDetailsUrl() + "/" + appName;
            return this.get(url)
                .pipe(map(this.extractResponse));
        };
        this.createSDKApp = (sdkObj) => {
            let url = this.apiConfig.getCreateSDKUrl();
            return this.post(url, sdkObj)
                .pipe(map(this.extractResponse));
        };
        this.updateSDKApp = (appName, sdkObj) => {
            let url = this.apiConfig.getUpdateSDKUrl() + "/" + appName;
            return this.post(url, sdkObj)
                .pipe(map(this.extractResponse));
        };
        this.deleteSDKApp = (appName) => {
            let url = this.apiConfig.getDeleteSDKUrl() + "/" + appName;
            return this.delete(url)
                .pipe(map(this.extractResponse));
        };
        this.uploadFileForSDK = (filePath, files) => {
            //console.log("filePath :: from portal service :: ", filePath);
            let formData = new FormData();
            for (var i = 0; i < files.length; i++) {
                formData.append("upload", files[i]); // , files[i].name;//
            }
            formData.append("filePath", filePath);
            let params = new HttpParams();
            let headers = new HttpHeaders({
                'Authorization': "Bearer " + this.dataService.getAccessToken(),
                // 'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            });
            let options = {
                headers,
                params,
                reportProgress: true,
                responseType: 'json'
            };
            this.logger.debug('upload file: headers', this.apiConfig.getUploadFileForSDKUrl());
            return this.post(this.apiConfig.getUploadFileForSDKUrl(), formData, options)
                .pipe(map(this.extractResponse));
        };
        this.getDeleteFileForSDK = (filePath) => {
            let url = this.apiConfig.getDeleteFileForSDKUrl();
            let options = {
                filePath: filePath
            };
            return this.post(url, options)
                .pipe(map(this.extractResponse));
        };
    }
}
SdkAppService.ɵfac = function SdkAppService_Factory(t) { return new (t || SdkAppService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
SdkAppService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SdkAppService, factory: SdkAppService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdkAppService, [{
        type: Injectable
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class SpaceManagerWsService {
    constructor() { }
    connect(url) {
        if (!this.subject) {
            this.subject = this.create(url);
            console.log("Successfully connected to CSW WS" + url);
        }
        return this.subject;
    }
    disconnect() {
        if (this.subject) {
            this.subject.complete();
            this.subject = null;
        }
    }
    create(url) {
        let ws = new WebSocket(url);
        let observable = Rx.Observable.create((obs) => {
            ws.onmessage = obs.next.bind(obs);
            ws.onerror = obs.error.bind(obs);
            ws.onclose = obs.complete.bind(obs);
            return ws.close.bind(ws);
        });
        let observer = {
            next: (data) => {
                if (ws.readyState === WebSocket.OPEN) {
                    ws.send(JSON.stringify(data));
                }
            }
        };
        return Rx.Subject.create(observer, observable);
    }
}
SpaceManagerWsService.ɵfac = function SpaceManagerWsService_Factory(t) { return new (t || SpaceManagerWsService)(); };
SpaceManagerWsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SpaceManagerWsService, factory: SpaceManagerWsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpaceManagerWsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class SpaceManagerWsConnService {
    constructor(spaceMangerWsService, dataService) {
        this.spaceMangerWsService = spaceMangerWsService;
        this.dataService = dataService;
        this.space_manager_url = "";
        this.disconnect = () => {
            if (this.messages)
                this.messages.unsubscribe();
            if (this.spaceMangerWsService)
                this.spaceMangerWsService.disconnect();
            this.messages = null;
        };
        this.connect = (baseUrl, generatedToken, timestamp) => {
            this.space_manager_url = baseUrl + generatedToken;
            if (timestamp) {
                this.space_manager_url += '&timestamp=' + timestamp;
            }
            this.messages = this.spaceMangerWsService.connect(this.space_manager_url).pipe(map$1((response) => {
                console.log('Message for webSocket :: ', response);
                this.dataService.setSpacesWSConnectionStatus(true);
                try {
                    if (response.data instanceof Blob) {
                        let reader = new FileReader();
                        reader.readAsText(response.data);
                        let res = '';
                        return reader.onloadend = () => {
                            // console.log(":: :: :: Result :: :: :: " + reader.result);
                            if (reader.result != null && reader.result != undefined) {
                                let res = reader.result != null ? reader.result : "";
                                this.dataService.setSpacesWSResponse(res);
                                return res;
                            }
                        };
                        // return JSON.parse("");
                    }
                    else {
                        console.log("The websocket response is not blob :: ");
                        return JSON.parse("");
                    }
                }
                catch (err) {
                    console.log('Exception Happened :: ' + err);
                }
            }, error => {
                console.log("error message for response :: " + error);
            }));
        };
    }
}
SpaceManagerWsConnService.ɵfac = function SpaceManagerWsConnService_Factory(t) { return new (t || SpaceManagerWsConnService)(i0.ɵɵinject(SpaceManagerWsService), i0.ɵɵinject(DataService)); };
SpaceManagerWsConnService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SpaceManagerWsConnService, factory: SpaceManagerWsConnService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpaceManagerWsConnService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: SpaceManagerWsService }, { type: DataService }]; }, null); })();

class SignageService extends BaseService {
    constructor(dataService, spacesManagerWsConnService, injector) {
        super(injector);
        this.dataService = dataService;
        this.spacesManagerWsConnService = spacesManagerWsConnService;
        this.injector = injector;
        this.unsubscribe$ = new Subject();
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getSignageLaunchUrl = () => {
            const serverUrl = this.apiConfig.getSignageLaunchUrl();
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getAllSignageDeviceList = () => {
            const serverUrl = this.apiConfig.getAllSignageDeviceListUrl();
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getSignageDevicesList = (locationId, signageType) => {
            const serverUrl = this.apiConfig.getSignageDevicesListUrl() + "/" + locationId + "/" + signageType;
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getSignageDeviceDetails = (deviceId) => {
            const serverUrl = this.apiConfig.getSignageDeviceDetailsUrl() + "/" + deviceId;
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.addSignageDevice = (signageObj) => {
            const serverUrl = this.apiConfig.addSignageDeviceUrl();
            return this.post(serverUrl, signageObj).pipe(map$1(this.extractResponse));
        };
        this.deleteSignageDevices = (signageObj) => {
            const serverUrl = this.apiConfig.deleteSignageDeviceUrl();
            const options = {
                body: signageObj
            };
            return this.delete(serverUrl, options).pipe(map$1(this.extractResponse));
        };
        this.getWorkSpacesDeviceDetails = (locationId, macAddress) => {
            const serverUrl = this.apiConfig.getWorkSpaceDeviceDetailsURL(locationId, macAddress);
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getWorkSpacesDeviceList = (locationId) => {
            const serverUrl = this.apiConfig.getWorkSpaceDeviceListURL(locationId);
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getSignageDeviceImage = (body) => {
            const serverUrl = this.apiConfig.getDeviceImageFromS3();
            return this.post(serverUrl, body).pipe(map$1(this.extractResponse));
        };
        this.getWebexDeviceList = () => {
            const serverUrl = this.apiConfig.getWebexDeviceListUrl();
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.configureSignageDevice = (signageObj) => {
            const serverUrl = this.apiConfig.configureSignageDeviceUrl();
            return this.post(serverUrl, signageObj).pipe(map$1(this.extractResponse));
        };
        this.getDefaultFloor = (locationId) => {
            const serverUrl = this.apiConfig.getDefaultFloorUrl() + "/" + locationId + "/defaultFloor";
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getAppCurrentStatus = (appName) => {
            const url = this.apiConfig.getCurrentAppStatusUrl(appName);
            return this.get(url).pipe(map$1(this.extractResponse));
        };
        this.inviteAppUser = (appName, userInfo) => {
            const serverUrl = this.apiConfig.getAppInviteUrl(appName);
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.deleteAppUser = (appName, userInfo) => {
            const opts = {
                body: userInfo
            };
            const serverUrl = this.apiConfig.getAppDeleteUrl(appName);
            return this.delete(serverUrl, opts).pipe(map$1(this.extractResponse));
        };
        this.getAppUserDeleteStatus = (appName, emailArr) => {
            const serverUrl = this.apiConfig.getAppDeleteStatusUrl(appName);
            return this.post(serverUrl, emailArr).pipe(map$1(this.extractResponse));
        };
        this.editAppUser = (appName, userInfo) => {
            const serverUrl = this.apiConfig.getAppEditUrl(appName);
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.getAppUserList = (appName) => {
            const serverUrl = this.apiConfig.getRBACAppUserListUrl(appName);
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getAppUserInfo = (appName, inviteUserEmail) => {
            const getUserInfoUrl = this.apiConfig.getRBACAppUserInfoUrl(appName, inviteUserEmail);
            return this.get(getUserInfoUrl).pipe(map$1(this.extractResponse));
        };
        this.resendAppInvite = (userInfo) => {
            const serverUrl = this.apiConfig.getResendAppInviteEmailUrl();
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.getLocRoomListData = (locationId) => {
            const serverUrl = this.apiConfig.getLocRoomListDataURL(locationId);
            console.log('serverUrl:', serverUrl);
            return this.get(serverUrl).pipe(map$1(this.extractResponseData));
        };
        this.getWebexRoomListData = (locationId) => {
            const serverUrl = this.apiConfig.getWebexRoomListDataURL(locationId);
            console.log('serverUrl:', serverUrl);
            return this.get(serverUrl).pipe(map$1(this.extractResponseData));
        };
        this.connectWebexRoom = (signageObj, locationId) => {
            const serverUrl = this.apiConfig.connectWebexRoomURL(locationId);
            console.log('serverUrl:', serverUrl);
            let payload = {
                "webexRoomId": signageObj.webexRoomId,
                "locRoomId": signageObj.locRoomId
            };
            return this.post(serverUrl, payload).pipe(map$1(this.extractResponseData));
        };
        this.disconnectLocRoom = (signageObj, locationId) => {
            const serverUrl = this.apiConfig.disconnectLocRoomURL(signageObj.locRoomId, locationId);
            console.log('serverUrl:', serverUrl);
            return this.get(serverUrl).pipe(map$1(this.extractResponseData));
        };
        this.disconnectWebexRoom = (locRoomId, locationId) => {
            const serverUrl = this.apiConfig.disconnectLocRoomURL(locRoomId, locationId);
            console.log('serverUrl:', serverUrl);
            return this.get(serverUrl).pipe(map$1(this.extractResponseData));
        };
        this.clearLocRoom = (signageObj, locationId) => {
            const serverUrl = this.apiConfig.clearLocRoomURL(signageObj.locRoomId, locationId);
            console.log('serverUrl:', serverUrl);
            return this.delete(serverUrl).pipe(map$1(this.extractResponseData));
        };
        this.fetchLocRoomDetailsData = (locRoomId, locationId) => {
            const serverUrl = this.apiConfig.fetchLocRoomDetailsURL(locRoomId, locationId);
            console.log('serverUrl:', serverUrl);
            return this.get(serverUrl).pipe(map$1(this.extractResponseData));
        };
        this.fetchLocRoomDevicesListData = (locRoomId, locationId) => {
            const serverUrl = this.apiConfig.fetchLocRoomDevicesListDataURL(locRoomId, locationId);
            console.log('serverUrl:', serverUrl);
            return this.get(serverUrl).pipe(map$1(this.extractResponseData));
        };
        this.fetchLoc2dMap = (locationId) => {
            const serverUrl = this.apiConfig.fetchLoc2dMapUrl(locationId);
            console.log('serverUrl:', serverUrl);
            return this.get(serverUrl).pipe(map$1(this.extractResponseData));
        };
        this.get2DMapByteImage = (locationId, imageUrl) => {
            const serverUrl = this.apiConfig.get2DMapByteImageUrl(locationId);
            console.log('serverUrl:', serverUrl);
            const payload = {
                imageUrl,
                locationId
            };
            return this.post(serverUrl, payload).pipe(map$1(this.extractResponseData));
        };
        this.addLocRoomDevicesListData = (locRoomId, locationId, devices) => {
            const serverUrl = this.apiConfig.addLocRoomDevicesListDataURL(locRoomId, locationId);
            console.log('serverUrl:', serverUrl);
            let payload = {
                devices
            };
            return this.post(serverUrl, payload).pipe(map$1(this.extractResponseData));
        };
        this.disassociateLocRoomDevicesListData = (locRoomId, locationId, devices) => {
            const serverUrl = this.apiConfig.disassociateLocRoomDevicesListDataURL(locRoomId, locationId);
            console.log('serverUrl:', serverUrl);
            let payload = {
                devices
            };
            return this.post(serverUrl, payload).pipe(map$1(this.extractResponseData));
        };
        // meta data apis
        this.getSignageMetaData = (locationId) => {
            const serverUrl = this.apiConfig.getSignageMetaDataUrl() + "/" + locationId + "/metadata";
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.updateSignageMetaData = (locationId, metaDataObj) => {
            const serverUrl = this.apiConfig.addSignageDeviceUrl() + "/" + locationId + "/metadata";
            return this.post(serverUrl, metaDataObj).pipe(map$1(this.extractResponse));
        };
        this.getSensorDetails = (locationId, macAddress) => {
            const serverUrl = this.apiConfig.getSensorDetailsURL(locationId, macAddress);
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.updateSensorDetails = (locationId, macAddress, payLoad) => {
            const serverUrl = this.apiConfig.updateSensorDetailsURL(locationId, macAddress);
            return this.post(serverUrl, payLoad).pipe(map$1(this.extractResponse));
        };
        this.saveOccupancyDetails = (locationId, locRoomId, payload) => {
            const serverUrl = this.apiConfig.updateOccupancyDetailsURL(locationId, locRoomId);
            return this.post(serverUrl, payload).pipe(map$1(this.extractResponse));
        };
        this.getCalenderServiceList = (locationId) => {
            const serverUrl = this.apiConfig.getCalenderServiceListURL(locationId);
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.updateCalenderService = (updateJson) => {
            const serverUrl = this.apiConfig.saveCalenderServiceURL(updateJson.locationId);
            return this.post(serverUrl, updateJson).pipe(map$1(this.extractResponse));
        };
        this.removeCalenderService = (locationId, locRoomId, type) => {
            const serverUrl = this.apiConfig.removeCalenderServiceURL(locationId, locRoomId, type);
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.extractTreeData = (res) => {
            try {
                this.startTime = new Date().getTime();
                const responseString = res; //.text();
                // console.log("responseString :: ", responseString)
                const p1 = responseString.indexOf(LocationRow.locTableKey);
                if (p1 == -1)
                    return JSON.parse(responseString);
                const p2 = p1 + LocationRow.locTableKey.length;
                const p3 = responseString.indexOf('"', p2);
                const locationTableData = responseString.substring(p2, p3);
                const resp = JSON.parse(responseString.substring(0, p1) +
                    responseString.substring(p3 + 1));
                if (resp.status == true && resp.data != null) {
                    const locationWrapper = this.utils.locationUtil.convertTree(resp.data, locationTableData);
                    this.dataService.setLocationArray(locationWrapper.locationsMap); //locationsArray
                    // setting mongodb ids and graph db ids in dataservice
                    this.dataService.setMongoDBIdsMap(locationWrapper.locationsMap);
                    this.dataService.setGraphDBIdsMap(locationWrapper.locationsMap);
                    this.dataService.setLocationObjectArray(locationWrapper.locationsMap);
                    this.dataService.setLicenseDetails(locationWrapper.licenseDetails);
                    delete locationWrapper.locationsMap;
                    delete locationWrapper.locationsArray;
                    delete locationWrapper.licenseDetails;
                    this.dataService.setLocationTreeArray(locationWrapper);
                    setTimeout(() => {
                        let locWrapper;
                        let userCountResponse;
                        locWrapper = this.dataService.getLocationWrap();
                        userCountResponse = this.dataService.getUserCountResponse();
                        if (userCountResponse !== undefined &&
                            userCountResponse !== null &&
                            JSON.stringify(userCountResponse) !== "{}") {
                            this.updateCount(locWrapper, userCountResponse, "user");
                        }
                    }, 2000);
                    console.log("(extractTreeData) locations converted into tree", new Date().getTime() - this.startTime);
                    return locationWrapper;
                }
                else {
                    throw throwError(res.json().message);
                }
            }
            catch (e) {
                // an error occurred
                throw throwError(res.json());
            }
        };
        this.updateCount = (locationWrapper, userCountResponse, type) => {
            if (type === "user") {
                let locationUserCountMap;
                if (userCountResponse && userCountResponse.status) {
                    locationUserCountMap = userCountResponse.data.locations
                        ? userCountResponse.data.locations
                        : {};
                    const adminsCount = userCountResponse.data.admins;
                    const rootLocation = locationWrapper.location[0];
                    const rootLocationId = rootLocation.id;
                    const locationsMap = this.dataService.getLocationMap();
                    locationsMap.forEach((val, locationId) => {
                        let locationObj;
                        let locId;
                        locId = locationId;
                        locationObj = val;
                        // adminsCount to root location
                        if (locId === rootLocationId) {
                            locationObj.userCount = adminsCount;
                            locationObj.userClickable = locationObj.userCount > 0;
                            locationsMap.set(locId, locationObj);
                            locationWrapper.locationsMap = locationsMap;
                        }
                        Object.keys(locationUserCountMap).map((key) => {
                            if (rootLocationId != parseInt(key) &&
                                locId === parseInt(key)) {
                                locationObj.userCount = locationUserCountMap[key];
                                locationObj.userClickable =
                                    locationObj.userCount > 0;
                                locationsMap.set(locId, locationObj);
                                locationWrapper.locationsMap = locationsMap;
                            }
                        });
                    });
                    // update all the values in dataservice
                    this.dataService.setLocationArray(locationWrapper.locationsMap); //locationsArray
                    this.dataService.setLocationObjectArray(locationWrapper.locationsMap);
                }
            }
        };
        this.getGeneratedSpacesToken = (locationId) => {
            const serverUrl = this.apiConfig.getTokenForSpacesMangerURL(locationId);
            return this.post(serverUrl, {}).pipe(map$1(this.extractResponse));
        };
        // todo : the changes for websocket calls
        this.spaceMangerWebSocket = (locationId) => {
            if (locationId != null && locationId != '' && typeof locationId == 'string') {
                this.getGeneratedSpacesToken(locationId).pipe(takeUntil$1(this.unsubscribe$))
                    .subscribe(response => {
                    console.log('got the token response :: ' + response.data);
                    if (response.status) {
                        console.log("successfully generated the token");
                        let token = response.data;
                        if (this.dataService.getSpacesWSConnectionStatus()) {
                            this.spacesManagerWsConnService.disconnect();
                            this.dataService.setSpacesWSConnectionStatus(false);
                        }
                        this.connectWebsoket(token);
                    }
                    else {
                        console.log("Failed to generate the token");
                        // let token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYnkiOiJkYXNoYm9hcmQtYXBpLXNlcnZlciIsImJ1c2luZXNzTG9jYXRpb24iOiI0MWNhMDRkZC0yODliLTQ1MTUtYjk4Yy1mZTM5MTY3NjA4NzYiLCJ0ZW5hbnRJZCI6MTYzMDUsInR5cGUiOiJhcHBfYWNjZXNzX3Rva2VuIiwiZXhwIjoxNjk3MDg2NTk5LCJpYXQiOjE2OTQ0OTQ1OTl9.eNnMJBy6tZOkQpKKrQsrNHMBBxw_Uf4T0gniQRDHanY';
                        // if (this.dataService.getSpacesWSConnectionStatus()) {
                        // 	this.spacesManagerWsConnService.disconnect();
                        // 	this.dataService.setSpacesWSConnectionStatus(false);
                        // }
                        // this.connectWebsoket(token);
                    }
                }, error => {
                    console.log('Got error while processing');
                });
            }
            else {
                console.log("LocationId is empty :: " + locationId);
                setTimeout(() => {
                    this.spaceMangerWebSocket(this.dataService.getSpacesLocationId());
                }, 15000);
            }
        };
        this.connectWebsoket = (token) => {
            const properties = this.dataService.getDashboardProperties();
            console.log("dashboard properties :: " + properties.signageWesocketUrl);
            let endPoint = properties.signageWesocketUrl;
            this.spacesManagerWsConnService.connect(endPoint, token);
            setInterval(() => {
                this.dataService.getSpacesWSConnectionStatus();
                this.spacesManagerWsConnService.messages.next({ "event": "heartbeat", "locationId": this.dataService.getSpacesLocationId() });
            }, 30000);
        };
        this.utils = new Utils(this.logger);
    }
    // getSignageLocationListUrl
    getLocationTree() {
        console.log("getting locations, in location service : getLocationTree");
        this.startTime = new Date().getTime();
        const options = {
            responseType: "text"
        };
        return this.get(this.apiConfig.getSignageLocationListUrl(), options).pipe(map$1(this.extractTreeData));
    }
}
SignageService.ɵfac = function SignageService_Factory(t) { return new (t || SignageService)(i0.ɵɵinject(DataService), i0.ɵɵinject(SpaceManagerWsConnService), i0.ɵɵinject(i0.Injector)); };
SignageService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SignageService, factory: SignageService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DataService }, { type: SpaceManagerWsConnService }, { type: i0.Injector }]; }, null); })();

class WorkspaceExperienceService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
        this.getAppCurrentStatus = (appName) => {
            const url = this.apiConfig.getCurrentAppStatusUrl(appName);
            return this.get(url).pipe(map$1(this.extractResponse));
        };
        this.inviteAppUser = (appName, userInfo) => {
            const serverUrl = this.apiConfig.getAppInviteUrl(appName);
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.deleteAppUser = (appName, userInfo) => {
            const opts = {
                body: userInfo
            };
            const serverUrl = this.apiConfig.getAppDeleteUrl(appName);
            return this.delete(serverUrl, opts).pipe(map$1(this.extractResponse));
        };
        this.getAppUserDeleteStatus = (appName, emailArr) => {
            const serverUrl = this.apiConfig.getAppDeleteStatusUrl(appName);
            return this.post(serverUrl, emailArr).pipe(map$1(this.extractResponse));
        };
        this.editAppUser = (appName, userInfo) => {
            const serverUrl = this.apiConfig.getAppEditUrl(appName);
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.getAppUserList = (appName) => {
            const serverUrl = this.apiConfig.getRBACAppUserListUrl(appName);
            return this.get(serverUrl).pipe(map$1(this.extractResponse));
        };
        this.getAppUserInfo = (appName, inviteUserEmail) => {
            const getUserInfoUrl = this.apiConfig.getRBACAppUserInfoUrl(appName, inviteUserEmail);
            return this.get(getUserInfoUrl).pipe(map$1(this.extractResponse));
        };
        this.resendAppInvite = (userInfo) => {
            const serverUrl = this.apiConfig.getResendAppInviteEmailUrl();
            return this.post(serverUrl, userInfo).pipe(map$1(this.extractResponse));
        };
        this.extractTreeData = (res) => {
            try {
                this.startTime = new Date().getTime();
                const responseString = res; //.text();
                // console.log("responseString :: ", responseString)
                const p1 = responseString.indexOf(LocationRow.locTableKey);
                if (p1 == -1)
                    return JSON.parse(responseString);
                const p2 = p1 + LocationRow.locTableKey.length;
                const p3 = responseString.indexOf('"', p2);
                const locationTableData = responseString.substring(p2, p3);
                const resp = JSON.parse(responseString.substring(0, p1) +
                    responseString.substring(p3 + 1));
                if (resp.status == true && resp.data != null) {
                    const locationWrapper = this.utils.locationUtil.convertTree(resp.data, locationTableData);
                    this.dataService.setLocationArray(locationWrapper.locationsMap); //locationsArray
                    // setting mongodb ids and graph db ids in dataservice
                    this.dataService.setMongoDBIdsMap(locationWrapper.locationsMap);
                    this.dataService.setGraphDBIdsMap(locationWrapper.locationsMap);
                    this.dataService.setLocationObjectArray(locationWrapper.locationsMap);
                    this.dataService.setLicenseDetails(locationWrapper.licenseDetails);
                    delete locationWrapper.locationsMap;
                    delete locationWrapper.locationsArray;
                    delete locationWrapper.licenseDetails;
                    this.dataService.setLocationTreeArray(locationWrapper);
                    setTimeout(() => {
                        let locWrapper;
                        let userCountResponse;
                        locWrapper = this.dataService.getLocationWrap();
                        userCountResponse = this.dataService.getUserCountResponse();
                        if (userCountResponse !== undefined &&
                            userCountResponse !== null &&
                            JSON.stringify(userCountResponse) !== "{}") {
                            this.updateCount(locWrapper, userCountResponse, "user");
                        }
                    }, 2000);
                    console.log("(extractTreeData) locations converted into tree", new Date().getTime() - this.startTime);
                    return locationWrapper;
                }
                else {
                    throw throwError(res.json().message);
                }
            }
            catch (e) {
                // an error occurred
                throw throwError(res.json());
            }
        };
        this.updateCount = (locationWrapper, userCountResponse, type) => {
            if (type === "user") {
                let locationUserCountMap;
                if (userCountResponse && userCountResponse.status) {
                    locationUserCountMap = userCountResponse.data.locations
                        ? userCountResponse.data.locations
                        : {};
                    const adminsCount = userCountResponse.data.admins;
                    const rootLocation = locationWrapper.location[0];
                    const rootLocationId = rootLocation.id;
                    const locationsMap = this.dataService.getLocationMap();
                    locationsMap.forEach((val, locationId) => {
                        let locationObj;
                        let locId;
                        locId = locationId;
                        locationObj = val;
                        // adminsCount to root location
                        if (locId === rootLocationId) {
                            locationObj.userCount = adminsCount;
                            locationObj.userClickable = locationObj.userCount > 0;
                            locationsMap.set(locId, locationObj);
                            locationWrapper.locationsMap = locationsMap;
                        }
                        Object.keys(locationUserCountMap).map((key) => {
                            if (rootLocationId != parseInt(key) &&
                                locId === parseInt(key)) {
                                locationObj.userCount = locationUserCountMap[key];
                                locationObj.userClickable =
                                    locationObj.userCount > 0;
                                locationsMap.set(locId, locationObj);
                                locationWrapper.locationsMap = locationsMap;
                            }
                        });
                    });
                    // update all the values in dataservice
                    this.dataService.setLocationArray(locationWrapper.locationsMap); //locationsArray
                    this.dataService.setLocationObjectArray(locationWrapper.locationsMap);
                }
            }
        };
        this.utils = new Utils(this.logger);
    }
    // getWorkSpaceLocationListUrl
    getLocationTree() {
        console.log("getting locations, in location service : getLocationTree");
        this.startTime = new Date().getTime();
        const options = {
            responseType: "text"
        };
        return this.get(this.apiConfig.getWorkSpaceLocationListUrl(), options).pipe(map$1(this.extractTreeData));
    }
}
WorkspaceExperienceService.ɵfac = function WorkspaceExperienceService_Factory(t) { return new (t || WorkspaceExperienceService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
WorkspaceExperienceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WorkspaceExperienceService, factory: WorkspaceExperienceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WorkspaceExperienceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class ReportsDataexportService extends BaseService {
    constructor(dataService, injector) {
        super(injector);
        this.dataService = dataService;
        this.injector = injector;
        this.apiConfig = new ApiConfig();
        this.reportsAuthenticateSFTP = (connDetails) => {
            const url = this.apiConfig.getReportsAuthenticateSFTPUrl();
            return this.post(url, connDetails).pipe(map$1(this.extractResponse));
        };
        this.reportsAuthenticateDestination = (connDetails) => {
            const url = this.apiConfig.getReportsAuthenticateSFTPUrl();
            return this.post(url, connDetails).pipe(map$1(this.extractResponse));
        };
        this.reportsCreateDataExport = (configData) => {
            const url = this.apiConfig.getCreateDataExportUrl();
            return this.post(url, configData).pipe(map$1(this.extractResponse));
        };
        this.deleteDataExport = (configData) => {
            const url = this.apiConfig.getDeleteDataExportUrl();
            return this.post(url, configData).pipe(map$1(this.extractResponse));
        };
        this.getReportsDataExportListData = () => {
            return this.get(this.apiConfig.getReportsExportDataListUrl()).pipe(map$1(this.extractResponse));
        };
        this.reportsUpdateDataExport = (configData) => {
            const url = this.apiConfig.getReportsUpdateExportListUrl();
            return this.post(url, configData).pipe(map$1(this.extractResponse));
        };
        this.uploadPublicKey = (connectDetails, files) => {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append("upload", files[i]); // , files[i].name;//
            }
            formData.append("sftpDetails", JSON.stringify(connectDetails));
            /*const params = new HttpParams();
            const headers = new HttpHeaders({
                Authorization:
                    "Bearer " + String(this.dataService.getAccessToken()),
                // 'Content-Type': 'multipart/form-data',
                Accept: "application/json"
            });
            const options = {
                headers,
                params,
                reportProgress: true,
                responseType: "json",
                observe: "events" as "body"
            };
            const serverUrl = `${String(this.apiConfig.getUploadKeyUrl())}`;
            
            return this.post(serverUrl, formData, options).pipe(
                map(this.extractResponse)
            );*/
            const headersOptions = {
                Pragma: "no-cache",
                Authorization: ""
            };
            // TODO: move to httpclient wraper
            if (this.dataService.getAccessToken()) {
                headersOptions.Authorization =
                    "Bearer " + this.dataService.getAccessToken();
            }
            const headers = new HttpHeaders(headersOptions);
            headers.append('Content-Type', 'multipart/form-data');
            headers.append('Accept', 'application/json');
            let options = { headers: headers };
            const serverUrl = this.apiConfig.getUploadKeyUrl();
            return this.post(serverUrl, formData, options).pipe(map$1(this.extractResponse));
        };
        this.extractResponseData = (res) => {
            return res.data;
        };
        this.extractResponse = (res) => {
            return res;
        };
    }
}
ReportsDataexportService.ɵfac = function ReportsDataexportService_Factory(t) { return new (t || ReportsDataexportService)(i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector)); };
ReportsDataexportService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ReportsDataexportService, factory: ReportsDataexportService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportsDataexportService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DataService }, { type: i0.Injector }]; }, null); })();

class WebexService {
    constructor(logger, dataService, injector, httpClientWrapper) {
        this.logger = logger;
        this.dataService = dataService;
        this.injector = injector;
        this.httpClientWrapper = httpClientWrapper;
        this.apiConfig = new ApiConfig();
        this.util = new Utils(this.logger);
        this.extractHttpResponse = (res) => {
            return res;
        };
        //  extractRoleHttpResponse = (res) => {
        //      if (res && res.role) {
        //          this.dataService.setUserRoleString(res.role);
        //      }
        //      return res;
        //  }
        this.handleErrorObservable = (error) => {
            this.dataService.setApiResponseErrorHandler(error);
            return throwError(error);
        };
        this.getWebexSetupStatus = () => {
            const serverUrl = this.apiConfig.getWebexSetupStatusUrl();
            return this.httpClientWrapper.get(serverUrl)
                .pipe(map(this.extractHttpResponse))
                .pipe(catchError$1(this.handleErrorObservable));
        };
        this.saveWebExToken = (webexToken) => {
            const serverUrl = this.apiConfig.getSaveWebExTokenUrl();
            return this.httpClientWrapper.post(serverUrl, { webexToken })
                .pipe(map(this.extractHttpResponse))
                .pipe(catchError$1(this.handleErrorObservable));
        };
        this.getWebexList = () => {
            const serverUrl = this.apiConfig.getWebexListUrl();
            return this.httpClientWrapper.get(serverUrl)
                .pipe(map(this.extractHttpResponse))
                .pipe(catchError$1(this.handleErrorObservable));
        };
        this.getDisconnectWebex = (webexObj) => {
            const serverUrl = this.apiConfig.getDisconnectWebexUrl();
            return this.httpClientWrapper.post(serverUrl, webexObj)
                .pipe(map(this.extractHttpResponse))
                .pipe(catchError$1(this.handleErrorObservable));
        };
    }
}
WebexService.ɵfac = function WebexService_Factory(t) { return new (t || WebexService)(i0.ɵɵinject(LoggerService), i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(HttpClientWrapperService)); };
WebexService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WebexService, factory: WebexService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WebexService, [{
        type: Injectable
    }], function () { return [{ type: LoggerService }, { type: DataService }, { type: i0.Injector }, { type: HttpClientWrapperService }]; }, null); })();

class PxgridService {
    constructor(logger, dataService, injector, httpClientWrapper) {
        this.logger = logger;
        this.dataService = dataService;
        this.injector = injector;
        this.httpClientWrapper = httpClientWrapper;
        this.apiConfig = new ApiConfig();
        this.util = new Utils(this.logger);
        this.extractHttpResponse = (res) => {
            return res;
        };
        this.handleErrorObservable = (error) => {
            this.dataService.setApiResponseErrorHandler(error);
            return throwError(error);
        };
        this.activatePxGrid = (body) => {
            const serverUrl = this.apiConfig.getActivatePxGridUrl();
            return this.httpClientWrapper.post(serverUrl, body)
                .pipe(map(this.extractHttpResponse))
                .pipe(catchError$1(this.handleErrorObservable));
        };
        this.getActivatedPxGridDeviceDetails = () => {
            const serverUrl = this.apiConfig.getActivatedPxGridDeviceURL();
            return this.httpClientWrapper.get(serverUrl)
                .pipe(map(this.extractHttpResponse))
                .pipe(catchError$1(this.handleErrorObservable));
        };
    }
}
PxgridService.ɵfac = function PxgridService_Factory(t) { return new (t || PxgridService)(i0.ɵɵinject(LoggerService), i0.ɵɵinject(DataService), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(HttpClientWrapperService)); };
PxgridService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PxgridService, factory: PxgridService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PxgridService, [{
        type: Injectable
    }], function () { return [{ type: LoggerService }, { type: DataService }, { type: i0.Injector }, { type: HttpClientWrapperService }]; }, null); })();

class SharedLibComponent {
    constructor() { }
}
SharedLibComponent.ɵfac = function SharedLibComponent_Factory(t) { return new (t || SharedLibComponent)(); };
SharedLibComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SharedLibComponent, selectors: [["lib-shared-lib"]], decls: 2, vars: 0, template: function SharedLibComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p");
        i0.ɵɵtext(1, "shared-lib works!");
        i0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharedLibComponent, [{
        type: Component,
        args: [{
                selector: "lib-shared-lib",
                template: `<p>shared-lib works!</p>
`,
                styles: []
            }]
    }], function () { return []; }, null); })();

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
const pipes = [
    AccesscodeFilterPipe,
    ByteToUnit,
    ByteToUnitWithRoundOff,
    Commarize,
    FilterdataPipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    ScheduleFilterPipe,
    SearchPipe,
    DropdownFilterPipe,
    GenericDropdownFilterPipe,
    WlcIpFilterPipe,
    IoTUsersFilterPipe
];
const directives = [
    FileDropDirective,
    FocusDirective,
    TooltipDirective,
    StatstooltipDirective
];
const components = [
    SharedLibComponent,
    SmartLicenseBaseComponent,
    SmartLicensePopupComponent,
    SmartLicenseBannerComponent,
    CircularLoaderComponent,
    TooltipContainerComponent,
    StatsTooltipContainerComponent,
    TooltipContentComponent,
    StatsTooltipContentComponent,
    HeaderSpacesComponent,
    LicenceInfoSpacesComponent,
    LicenseInfoComponent,
    LicenseAdoptionComponent,
    LicenseInfoSpacesPopupComponent,
    NavigationUserInfoComponent,
    OpenRoamingGlobalStatsComponent,
    ChangePasswordComponent,
    NavigationHomeComponent,
    NavigationAppComponent,
    NavigationV2AppComponent,
    AppSwitcherComponent,
    ChangeBaseLicenseComponent,
    DropdownWithSubtitleComponent,
    GenericDropdownComponent,
    ManageLocationTreeComponent,
    ManageLocationTreeV3Component,
    LocationRowV2Component,
    LocationSearchComponent,
    SensorListComponent,
    RowMenuComponent,
    WelcomeComponent,
    TokenGenerationComponent,
    TokenGenerationV3Component,
    EmailInputComponent,
    TeamGenericDropdownComponent,
    ReportLocationTreeComponent,
    DropdownSimpleComponent,
    DropdownWithCheckboxComponent,
    DropdownRoleSimpleComponent,
    SmsHighlighterComponent,
    AnalyticsDropdownComponent,
    AnalyticsLocationHierarchyComponent,
    DropdownFilterComponent,
    GenericDropdownFilterComponent,
    TimePickerComponent,
    RangeSliderComponent,
    NouisliderComponent,
    FooterLogoComponent,
    SpacesLocationHierarchyComponent,
    WorkspaceLocationHierarchyComponent,
    SplitLicenseChangeComponent,
    SplitLicenseUsageComponent,
    CurrentUserStatusComponent,
    AbsoluteRedirectComponent,
    SearchBasicComponent,
    PaginationComponent,
    ChangeLogPaginationComponent,
    QrCodeComponent,
    QuillRteComponent,
    DatePickerComponent,
    LocationPopupComponent,
    SearchComponent,
    ReportFilterComponent,
    DateFilterPopupComponent,
    ReportHeaderComponent,
    TableChartComponent,
    GoogleMapNewComponent,
    ReportDescriptionComponent,
    ReportEmptyComponent,
    D3DonutChartComponent,
    D3DoubleDonutChartComponent,
    DatePickerModalComponent,
    D3GroupChartComponent,
    D3GroupNewChartComponent,
    D3MultilineChartComponent,
    D3HorizontalBarChartComponent,
    RangeBarChartComponent,
    D3CustomStackedBarChartComponent,
    D3NewCustomStackedBarChartComponent,
    D3ChartComponent,
    D3ScrollbarChartComponent,
    D3ColumnChartComponent,
    LoginHistoryComponent,
    D3PieChartComponent,
    SetupNotifyComponent,
    CiscoCmxComponent,
    CmxConnectorComponent,
    ConnectorServicesComponent,
    ConnectorServiceItemComponent,
    ConnectorTroubleshootComponent,
    CmxConnectorInstancesComponent,
    CmxConnectorSwitchesComponent,
    OpenroamingHotspotListComponent,
    SupportSectionComponent,
    AccountPreferenceComponent,
    UpdateProfilePopupComponent,
    UpdateCountryPopupComponent,
    VerifyPhoneNumberComponent,
    D3CustomColumnChartComponent,
    D3SankeyDiagramComponent,
    D3SankeyDiagramV2Component,
    D3SimplePieChartComponent,
    D3LineComponent,
    D3ScatterPlotComponent,
    D3NegativeBarChartComponent,
    ReportPeriodComponent,
    MonthPickerComponent,
    D3StackedBarComponent,
    TagsDropdownComponent,
    PinLocationsComponent,
    IdleTimeoutComponent,
    ShareComponent,
    ShareReportDialogComponent,
    BusinessHierarchyComponent,
    BusinessHierarchyNodeComponent,
    ChangeLogDetailComponent,
    ChangeLogFilterComponent,
    ChangeLogUserFilterComponent,
    CustomPaginationComponent,
    D3ScrollbarChartComponent,
    PinCamerasComponent,
    D3CumulativeChartComponent,
    AngularCalendarViewComponent,
    CustomTooltipComponent,
    DropdownWithTextfieldComponent,
    D3CumulativeChartComponent,
    D3RightnowStackedbarComponent,
    D3LineBarChartComponent,
    CustomLocationHierarchyFilterComponent,
    CustomPaginationComponent,
    StandardizedLocationHierachyComponent,
    GeneralPaginationComponent,
    BusinessHierarchyComponent,
    BusinessHierarchyNodeComponent,
    GenericDropdownSearchComponent,
    GoogleMapComponent,
    GoogleMapForIotComponent,
    DropdownWithSearchoptionComponent,
    MuiltiselectDropdownComponent,
    MultiselectDropdownNoApisearchComponent,
    DropdownComboTextComponent,
    IotUserDropdownFilterComponent,
    IotPaginationComponent,
    DropdownWithSubtextComponent,
    GeneralPaginationComponent,
    StandardizedLocationHierachyComponent,
    D3StackedLineChartComponent,
    D3MultilineNewChartComponent,
    StandardizedLocationHierachyV2Component,
    IotPaginationComponent,
    DropdownWithSubtextComponent,
    D3StackedLineChartComponent,
    D3MultilineNewChartComponent,
    MigrateConnectorComponent,
    FooterIcpLogoComponent,
    CommonBaseComponent,
    MagneticBaseComponent,
    MagneticMenuItemComponent,
    MagneticAppSelectionComponent,
    MagneticHelpSectionComponent,
    MagneticTacSupportComponent,
    MagneticAppSwitcherComponent,
    MagneticProfileDialogComponent,
    MagneticLicenseInfoComponent,
    MagneticConfirmationDialogComponent,
    MagneticLocationPopupComponent,
    NetworkSyncStatusComponent,
    PinCameraPopupComponent,
    LocationBetaSwitchComponent,
    ConfigureLocationHierarchyComponent,
    D3HorizontalBarEnvChartComponent,
    D3StreamLineChartComponent,
    D3MinMaxChartComponent,
    LocationSelectionDropdownComponent,
    ManageLh2TreeComponent,
    Lh2RightnowTreeComponent
];
const services = [
    AuthService,
    BaseService,
    CookieService,
    DataService,
    DataexportService,
    GodDashboardService,
    HomeService,
    HttpClientWrapperService,
    InteractionService,
    LocationService,
    LoggerService,
    MapService,
    MonitorService,
    OpenRoamingService,
    PersonasService,
    EngagementsService,
    PartnerAppsService,
    PartnerSandboxAppsService,
    PortalService,
    ReportService,
    ShareReportsService,
    RuleService,
    SensorService,
    SetupPlatformAppService,
    SsidService,
    TilesService,
    TmsAuthService,
    BleUuidsService,
    CMXConnectorsService,
    CmxOnpremService,
    NotificationChannelService,
    SdkService,
    SmsGatewayService,
    SocialAppService,
    WebexTeamService,
    CciIdService,
    TooltipService,
    UserService,
    VersionCheckService,
    OpenRoamingGlobalStateService,
    IntegrationsBaseService,
    IntegrationService,
    RightnowService,
    IoTExplorerService,
    WebsocketService,
    SdkAppService,
    BusinessHierarchyService,
    Lh2Service,
    ReportsDataexportService,
    IoTWebSocketService,
    IoTWebSocketConnection,
    WebexService,
    SignageService,
    WorkspaceExperienceService,
    PxgridService,
    WsService,
    WsconnectService,
    SpaceManagerWsService,
    SpaceManagerWsConnService,
    {
        provide: MatDialogRef,
        useValue: {}
    },
    {
        provide: MAT_DIALOG_DATA,
        useValue: {} // Add any data you wish to test if it is passed/used correctly
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: HTTPClientInterceptor,
        multi: true
    }
];
const importModules = [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ProgressBarModule,
    InternationalPhoneNumberModule,
    NgxQRCodeModule,
    TranslateModule,
    TreeModule,
    ClipboardModule,
    TagInputModule,
    // NouisliderModule,
    MatSliderModule,
    MatSidenavModule,
    MatIconModule,
    MatToolbarModule,
    MatListModule,
    MatDividerModule,
    MatDialogModule,
    MatMenuModule,
    //QRCodeModule,
    MyDatePickerModule,
    // NgbModalModule,
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory
    }),
    CalendarModule$1,
    Ng2TelInputModule,
    BsDropdownModule.forRoot(),
    // NgxIntlTelInputModule,
    RoundProgressModule,
    ScrollingModule,
    CarouselModule,
    QuillModule
];
const declarations = [pipes, directives, components];
class SharedLibModule {
    constructor(parentModule) {
        if (parentModule) {
            console.log("SharedLibModule is already loaded. Import it in the AppModule only", parentModule);
            // throw new Error(
            // 	"SharedLibModule is already loaded. Import it in the AppModule only"
            // );
        }
    }
    static forRoot() {
        return {
            ngModule: SharedLibModule,
            providers: [
            // {provide: Injector, useValue: injector }
            ]
        };
    }
}
SharedLibModule.ɵfac = function SharedLibModule_Factory(t) { return new (t || SharedLibModule)(i0.ɵɵinject(SharedLibModule, 12)); };
SharedLibModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SharedLibModule });
SharedLibModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: services, imports: [importModules] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharedLibModule, [{
        type: NgModule,
        args: [{
                declarations: declarations,
                // entryComponents: components,
                providers: services,
                exports: declarations,
                imports: importModules
            }]
    }], function () { return [{ type: SharedLibModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SharedLibModule, { declarations: [AccesscodeFilterPipe,
        ByteToUnit,
        ByteToUnitWithRoundOff,
        Commarize,
        FilterdataPipe,
        SafeHtmlPipe,
        SafeUrlPipe,
        ScheduleFilterPipe,
        SearchPipe,
        DropdownFilterPipe,
        GenericDropdownFilterPipe,
        WlcIpFilterPipe,
        IoTUsersFilterPipe, FileDropDirective,
        FocusDirective,
        TooltipDirective,
        StatstooltipDirective, SharedLibComponent,
        SmartLicenseBaseComponent,
        SmartLicensePopupComponent,
        SmartLicenseBannerComponent,
        CircularLoaderComponent,
        TooltipContainerComponent,
        StatsTooltipContainerComponent,
        TooltipContentComponent,
        StatsTooltipContentComponent,
        HeaderSpacesComponent,
        LicenceInfoSpacesComponent,
        LicenseInfoComponent,
        LicenseAdoptionComponent,
        LicenseInfoSpacesPopupComponent,
        NavigationUserInfoComponent,
        OpenRoamingGlobalStatsComponent,
        ChangePasswordComponent,
        NavigationHomeComponent,
        NavigationAppComponent,
        NavigationV2AppComponent,
        AppSwitcherComponent,
        ChangeBaseLicenseComponent,
        DropdownWithSubtitleComponent,
        GenericDropdownComponent,
        ManageLocationTreeComponent,
        ManageLocationTreeV3Component,
        LocationRowV2Component,
        LocationSearchComponent,
        SensorListComponent,
        RowMenuComponent,
        WelcomeComponent,
        TokenGenerationComponent,
        TokenGenerationV3Component,
        EmailInputComponent,
        TeamGenericDropdownComponent,
        ReportLocationTreeComponent,
        DropdownSimpleComponent,
        DropdownWithCheckboxComponent,
        DropdownRoleSimpleComponent,
        SmsHighlighterComponent,
        AnalyticsDropdownComponent,
        AnalyticsLocationHierarchyComponent,
        DropdownFilterComponent,
        GenericDropdownFilterComponent,
        TimePickerComponent,
        RangeSliderComponent,
        NouisliderComponent,
        FooterLogoComponent,
        SpacesLocationHierarchyComponent,
        WorkspaceLocationHierarchyComponent,
        SplitLicenseChangeComponent,
        SplitLicenseUsageComponent,
        CurrentUserStatusComponent,
        AbsoluteRedirectComponent,
        SearchBasicComponent,
        PaginationComponent,
        ChangeLogPaginationComponent,
        QrCodeComponent,
        QuillRteComponent,
        DatePickerComponent,
        LocationPopupComponent,
        SearchComponent,
        ReportFilterComponent,
        DateFilterPopupComponent,
        ReportHeaderComponent,
        TableChartComponent,
        GoogleMapNewComponent,
        ReportDescriptionComponent,
        ReportEmptyComponent,
        D3DonutChartComponent,
        D3DoubleDonutChartComponent,
        DatePickerModalComponent,
        D3GroupChartComponent,
        D3GroupNewChartComponent,
        D3MultilineChartComponent,
        D3HorizontalBarChartComponent,
        RangeBarChartComponent,
        D3CustomStackedBarChartComponent,
        D3NewCustomStackedBarChartComponent,
        D3ChartComponent,
        D3ScrollbarChartComponent,
        D3ColumnChartComponent,
        LoginHistoryComponent,
        D3PieChartComponent,
        SetupNotifyComponent,
        CiscoCmxComponent,
        CmxConnectorComponent,
        ConnectorServicesComponent,
        ConnectorServiceItemComponent,
        ConnectorTroubleshootComponent,
        CmxConnectorInstancesComponent,
        CmxConnectorSwitchesComponent,
        OpenroamingHotspotListComponent,
        SupportSectionComponent,
        AccountPreferenceComponent,
        UpdateProfilePopupComponent,
        UpdateCountryPopupComponent,
        VerifyPhoneNumberComponent,
        D3CustomColumnChartComponent,
        D3SankeyDiagramComponent,
        D3SankeyDiagramV2Component,
        D3SimplePieChartComponent,
        D3LineComponent,
        D3ScatterPlotComponent,
        D3NegativeBarChartComponent,
        ReportPeriodComponent,
        MonthPickerComponent,
        D3StackedBarComponent,
        TagsDropdownComponent,
        PinLocationsComponent,
        IdleTimeoutComponent,
        ShareComponent,
        ShareReportDialogComponent,
        BusinessHierarchyComponent,
        BusinessHierarchyNodeComponent,
        ChangeLogDetailComponent,
        ChangeLogFilterComponent,
        ChangeLogUserFilterComponent,
        CustomPaginationComponent,
        D3ScrollbarChartComponent,
        PinCamerasComponent,
        D3CumulativeChartComponent,
        AngularCalendarViewComponent,
        CustomTooltipComponent,
        DropdownWithTextfieldComponent,
        D3CumulativeChartComponent,
        D3RightnowStackedbarComponent,
        D3LineBarChartComponent,
        CustomLocationHierarchyFilterComponent,
        CustomPaginationComponent,
        StandardizedLocationHierachyComponent,
        GeneralPaginationComponent,
        BusinessHierarchyComponent,
        BusinessHierarchyNodeComponent,
        GenericDropdownSearchComponent,
        GoogleMapComponent,
        GoogleMapForIotComponent,
        DropdownWithSearchoptionComponent,
        MuiltiselectDropdownComponent,
        MultiselectDropdownNoApisearchComponent,
        DropdownComboTextComponent,
        IotUserDropdownFilterComponent,
        IotPaginationComponent,
        DropdownWithSubtextComponent,
        GeneralPaginationComponent,
        StandardizedLocationHierachyComponent,
        D3StackedLineChartComponent,
        D3MultilineNewChartComponent,
        StandardizedLocationHierachyV2Component,
        IotPaginationComponent,
        DropdownWithSubtextComponent,
        D3StackedLineChartComponent,
        D3MultilineNewChartComponent,
        MigrateConnectorComponent,
        FooterIcpLogoComponent,
        CommonBaseComponent,
        MagneticBaseComponent,
        MagneticMenuItemComponent,
        MagneticAppSelectionComponent,
        MagneticHelpSectionComponent,
        MagneticTacSupportComponent,
        MagneticAppSwitcherComponent,
        MagneticProfileDialogComponent,
        MagneticLicenseInfoComponent,
        MagneticConfirmationDialogComponent,
        MagneticLocationPopupComponent,
        NetworkSyncStatusComponent,
        PinCameraPopupComponent,
        LocationBetaSwitchComponent,
        ConfigureLocationHierarchyComponent,
        D3HorizontalBarEnvChartComponent,
        D3StreamLineChartComponent,
        D3MinMaxChartComponent,
        LocationSelectionDropdownComponent,
        ManageLh2TreeComponent,
        Lh2RightnowTreeComponent], imports: [CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ProgressBarModule,
        InternationalPhoneNumberModule,
        NgxQRCodeModule,
        TranslateModule,
        TreeModule,
        ClipboardModule,
        TagInputModule,
        // NouisliderModule,
        MatSliderModule,
        MatSidenavModule,
        MatIconModule,
        MatToolbarModule,
        MatListModule,
        MatDividerModule,
        MatDialogModule,
        MatMenuModule,
        //QRCodeModule,
        MyDatePickerModule, i1$7.FlatpickrModule, i1$4.CalendarModule, CalendarModule$1,
        Ng2TelInputModule, i3.BsDropdownModule, 
        // NgxIntlTelInputModule,
        RoundProgressModule,
        ScrollingModule,
        CarouselModule,
        QuillModule], exports: [AccesscodeFilterPipe,
        ByteToUnit,
        ByteToUnitWithRoundOff,
        Commarize,
        FilterdataPipe,
        SafeHtmlPipe,
        SafeUrlPipe,
        ScheduleFilterPipe,
        SearchPipe,
        DropdownFilterPipe,
        GenericDropdownFilterPipe,
        WlcIpFilterPipe,
        IoTUsersFilterPipe, FileDropDirective,
        FocusDirective,
        TooltipDirective,
        StatstooltipDirective, SharedLibComponent,
        SmartLicenseBaseComponent,
        SmartLicensePopupComponent,
        SmartLicenseBannerComponent,
        CircularLoaderComponent,
        TooltipContainerComponent,
        StatsTooltipContainerComponent,
        TooltipContentComponent,
        StatsTooltipContentComponent,
        HeaderSpacesComponent,
        LicenceInfoSpacesComponent,
        LicenseInfoComponent,
        LicenseAdoptionComponent,
        LicenseInfoSpacesPopupComponent,
        NavigationUserInfoComponent,
        OpenRoamingGlobalStatsComponent,
        ChangePasswordComponent,
        NavigationHomeComponent,
        NavigationAppComponent,
        NavigationV2AppComponent,
        AppSwitcherComponent,
        ChangeBaseLicenseComponent,
        DropdownWithSubtitleComponent,
        GenericDropdownComponent,
        ManageLocationTreeComponent,
        ManageLocationTreeV3Component,
        LocationRowV2Component,
        LocationSearchComponent,
        SensorListComponent,
        RowMenuComponent,
        WelcomeComponent,
        TokenGenerationComponent,
        TokenGenerationV3Component,
        EmailInputComponent,
        TeamGenericDropdownComponent,
        ReportLocationTreeComponent,
        DropdownSimpleComponent,
        DropdownWithCheckboxComponent,
        DropdownRoleSimpleComponent,
        SmsHighlighterComponent,
        AnalyticsDropdownComponent,
        AnalyticsLocationHierarchyComponent,
        DropdownFilterComponent,
        GenericDropdownFilterComponent,
        TimePickerComponent,
        RangeSliderComponent,
        NouisliderComponent,
        FooterLogoComponent,
        SpacesLocationHierarchyComponent,
        WorkspaceLocationHierarchyComponent,
        SplitLicenseChangeComponent,
        SplitLicenseUsageComponent,
        CurrentUserStatusComponent,
        AbsoluteRedirectComponent,
        SearchBasicComponent,
        PaginationComponent,
        ChangeLogPaginationComponent,
        QrCodeComponent,
        QuillRteComponent,
        DatePickerComponent,
        LocationPopupComponent,
        SearchComponent,
        ReportFilterComponent,
        DateFilterPopupComponent,
        ReportHeaderComponent,
        TableChartComponent,
        GoogleMapNewComponent,
        ReportDescriptionComponent,
        ReportEmptyComponent,
        D3DonutChartComponent,
        D3DoubleDonutChartComponent,
        DatePickerModalComponent,
        D3GroupChartComponent,
        D3GroupNewChartComponent,
        D3MultilineChartComponent,
        D3HorizontalBarChartComponent,
        RangeBarChartComponent,
        D3CustomStackedBarChartComponent,
        D3NewCustomStackedBarChartComponent,
        D3ChartComponent,
        D3ScrollbarChartComponent,
        D3ColumnChartComponent,
        LoginHistoryComponent,
        D3PieChartComponent,
        SetupNotifyComponent,
        CiscoCmxComponent,
        CmxConnectorComponent,
        ConnectorServicesComponent,
        ConnectorServiceItemComponent,
        ConnectorTroubleshootComponent,
        CmxConnectorInstancesComponent,
        CmxConnectorSwitchesComponent,
        OpenroamingHotspotListComponent,
        SupportSectionComponent,
        AccountPreferenceComponent,
        UpdateProfilePopupComponent,
        UpdateCountryPopupComponent,
        VerifyPhoneNumberComponent,
        D3CustomColumnChartComponent,
        D3SankeyDiagramComponent,
        D3SankeyDiagramV2Component,
        D3SimplePieChartComponent,
        D3LineComponent,
        D3ScatterPlotComponent,
        D3NegativeBarChartComponent,
        ReportPeriodComponent,
        MonthPickerComponent,
        D3StackedBarComponent,
        TagsDropdownComponent,
        PinLocationsComponent,
        IdleTimeoutComponent,
        ShareComponent,
        ShareReportDialogComponent,
        BusinessHierarchyComponent,
        BusinessHierarchyNodeComponent,
        ChangeLogDetailComponent,
        ChangeLogFilterComponent,
        ChangeLogUserFilterComponent,
        CustomPaginationComponent,
        D3ScrollbarChartComponent,
        PinCamerasComponent,
        D3CumulativeChartComponent,
        AngularCalendarViewComponent,
        CustomTooltipComponent,
        DropdownWithTextfieldComponent,
        D3CumulativeChartComponent,
        D3RightnowStackedbarComponent,
        D3LineBarChartComponent,
        CustomLocationHierarchyFilterComponent,
        CustomPaginationComponent,
        StandardizedLocationHierachyComponent,
        GeneralPaginationComponent,
        BusinessHierarchyComponent,
        BusinessHierarchyNodeComponent,
        GenericDropdownSearchComponent,
        GoogleMapComponent,
        GoogleMapForIotComponent,
        DropdownWithSearchoptionComponent,
        MuiltiselectDropdownComponent,
        MultiselectDropdownNoApisearchComponent,
        DropdownComboTextComponent,
        IotUserDropdownFilterComponent,
        IotPaginationComponent,
        DropdownWithSubtextComponent,
        GeneralPaginationComponent,
        StandardizedLocationHierachyComponent,
        D3StackedLineChartComponent,
        D3MultilineNewChartComponent,
        StandardizedLocationHierachyV2Component,
        IotPaginationComponent,
        DropdownWithSubtextComponent,
        D3StackedLineChartComponent,
        D3MultilineNewChartComponent,
        MigrateConnectorComponent,
        FooterIcpLogoComponent,
        CommonBaseComponent,
        MagneticBaseComponent,
        MagneticMenuItemComponent,
        MagneticAppSelectionComponent,
        MagneticHelpSectionComponent,
        MagneticTacSupportComponent,
        MagneticAppSwitcherComponent,
        MagneticProfileDialogComponent,
        MagneticLicenseInfoComponent,
        MagneticConfirmationDialogComponent,
        MagneticLocationPopupComponent,
        NetworkSyncStatusComponent,
        PinCameraPopupComponent,
        LocationBetaSwitchComponent,
        ConfigureLocationHierarchyComponent,
        D3HorizontalBarEnvChartComponent,
        D3StreamLineChartComponent,
        D3MinMaxChartComponent,
        LocationSelectionDropdownComponent,
        ManageLh2TreeComponent,
        Lh2RightnowTreeComponent] }); })();

class SharedLibService {
    constructor() { }
}
SharedLibService.ɵfac = function SharedLibService_Factory(t) { return new (t || SharedLibService)(); };
SharedLibService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SharedLibService, factory: SharedLibService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharedLibService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return []; }, null); })();

class Constants {
}
Constants.DEVICE_ONBOARDING_HEADER_DESCRIPTION = "Total Unique Devices Provisioned Internet";
Constants.DEVICE_ONBOARDING_DESCRIPTION = "Device Onboarding provides insights about devices connecting to SSIDs and then accessing internet.";
Constants.CUSTOMER_ACQUISITION_HEADER_DESCRIPTION = "Total Customers Identified";
Constants.CUSTOMER_ACQUISITION_DESCRIPTION = "Customer Acquisition reports is insights and demographic data collected about new customers who are coming to your location for the first time.";
Constants.VISITOR_BEHAVIOUR_HEADER_DESCRIPTION = "Total Time Spent by Visitors";
Constants.VISITOR_BEHAVIOUR_DESCRIPTION = "Visitor Behaviour report is metrics and profile information derived from visitor behaviour at location after they have been provisioned internet.";
Constants.VISITOR_ENGAGEMENT_HEADER_DESCRIPTION = "Total Engagements with Visitors";
Constants.VISITOR_ENGAGEMENT_DESCRIPTION = "Visitor Engagement report is metrics related to engagement via various notification channels and captive portal promotions.";
Constants.REPORTS_QUERY_ID = {
    device_onboarding: {
        overall_aggregates: "DEVICE_ONBOARDING_OVERALL_AGGREGATES",
        aggreates: "DEVICE_ONBOARDING_AGGREGATES",
        new_vs_repeat_device_ssid_connected: "DEVICE_ONBOARDING_NEW_VS_REPEAT_CONNECT_SSID",
        provisioned_internet_by_location: "DEVICE_ONBOARDING_PROVISIONED_INTERNET_BY_LOCATION",
        cp_menu_clicks: "DEVICE_ONBOARDING_CP_MENU_CLICKS",
        promos_offers_cliks: "DEVICE_ONBOARDING_PROMOS_OFFERS_TREND",
        promo_offers_clicks_performance: "DEVICE_ONBOARDING_PROMOS_OFFERS_PERFORMANCE"
    }
};
Constants.DEVICE_ONBOARDING_EMPTY_DATA_DESCRIPTION = "This report is not available as there were no devices connected to the SSID during the selected date range and at the selected locations.";
Constants.CUSTOMER_ACQUISITION_EMPTY_DATA_DESCRIPTION = "This report is not available as there were no customers acquired during the selected date range and at the selected locations.";
Constants.PROFILE_RULE_EMPTY_DATA_DESCRIPTION = "This report is not available as there were not rules created during the selected date range and for the selected locations.";
Constants.ENGAGEMENT_RULE_EMPTY_DATA_DESCRIPTION = "This report is not available as there was no engagement rule active during the selected date range and at the selected locations.";
Constants.VISITOR_BEHAVIOUR_EMPTY_DATA_DESCRIPTION = "This report is not available as there no visitor visited at the selected locations and during a selected date range.";
Constants.VISITOR_ENGAGEMENT_EMPTY_DATA_DESCRIPTION = "This report is not available as there was no visitor engagement during the selected date range and at the selected locations.";

class FileUtils {
    getHeaderArray(csvRecordsArr, tokenDelimeter) {
        const headers = csvRecordsArr[0].split(tokenDelimeter);
        const headerArray = [];
        for (let j = 0; j < headers.length; j++) {
            headerArray.push(headers[j]);
        }
        return headerArray;
    }
    validateHeaders(origHeaders, fileHeaaders) {
        if (origHeaders.length != fileHeaaders.length) {
            return false;
        }
        let fileHeaderMatchFlag = true;
        for (let j = 0; j < origHeaders.length; j++) {
            if (origHeaders[j] != fileHeaaders[j]) {
                fileHeaderMatchFlag = false;
                break;
            }
        }
        return fileHeaderMatchFlag;
    }
    getDataRecordsArrayFromCSVFile(csvRecordsArray, headerLength, validateHeaderAndRecordLengthFlag, tokenDelimeter) {
        const dataArr = [];
        for (let i = 0; i < csvRecordsArray.length; i++) {
            const data = csvRecordsArray[i].split(tokenDelimeter);
            if (validateHeaderAndRecordLengthFlag &&
                data.length != headerLength) {
                if (data == "") {
                    //console.log("Extra blank line is present at line number " + i + ", please remove it.");
                    return null;
                }
                else {
                    //console.log("Record at line number " + i + " contain " + data.length + " tokens, and is not matching with header length of :" + headerLength);
                    return null;
                }
            }
            const col = [];
            for (let j = 0; j < data.length; j++) {
                col.push(data[j]);
            }
            dataArr.push(col);
        }
        return dataArr;
    }
}
FileUtils.ɵfac = function FileUtils_Factory(t) { return new (t || FileUtils)(); };
FileUtils.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FileUtils, factory: FileUtils.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileUtils, [{
        type: Injectable
    }], null, null); })();

/*
 * Public API Surface of shared-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbsoluteRedirectComponent, AccesscodeFilterPipe, AccountPreferenceComponent, AnalyticsDropdownComponent, AnalyticsLocationHierarchyComponent, AngularCalendarViewComponent, Annotations, ApiConfig, AppSwitcherComponent, AssetLocations, AuthData, AuthResponse, AuthService, BarChart, BaseService, BleUuidsService, BreadCrumb, BusinessHierarchyComponent, BusinessHierarchyNodeComponent, BusinessHierarchyService, ByteToUnit, ByteToUnitWithRoundOff, CMXConnectorsService, CciIdService, ChangeBaseLicenseComponent, ChangeLogDetailComponent, ChangeLogFilterComponent, ChangeLogPaginationComponent, ChangeLogUserFilterComponent, ChangePasswordComponent, Chart, ChartBand, ChartOptions, ChartRangeSelector, ChartSeries, ChartSeriesGroup, CircularLoaderComponent, CircularLoaderStatus, CiscoCmxComponent, CmxConnectorComponent, CmxConnectorInstancesComponent, CmxConnectorSwitchesComponent, CmxOnpremService, Commarize, CommonBaseComponent, ConfigureLocationHierarchyComponent, ConnectorServiceItemComponent, ConnectorServicesComponent, ConnectorTroubleshootComponent, Constants, CookieService, CurrentUserStatusComponent, CustomLocationHierarchyFilterComponent, CustomPaginationComponent, CustomTooltipComponent, D3ChartComponent, D3ColumnChartComponent, D3CumulativeChartComponent, D3CustomColumnChartComponent, D3CustomStackedBarChartComponent, D3DonutChartComponent, D3DonutChartOptions, D3DoubleDonutChartComponent, D3GroupChartComponent, D3GroupNewChartComponent, D3HorizontalBarChartComponent, D3HorizontalBarEnvChartComponent, D3LineBarChartComponent, D3LineComponent, D3MinMaxChartComponent, D3MultilineChartComponent, D3MultilineNewChartComponent, D3NegativeBarChartComponent, D3NewCustomStackedBarChartComponent, D3PieChartComponent, D3PieChartOptions, D3RightnowStackedbarComponent, D3SankeyDiagramChartOptions, D3SankeyDiagramComponent, D3SankeyDiagramV2ChartOptions, D3SankeyDiagramV2Component, D3ScatterPlotComponent, D3ScrollbarChartComponent, D3SimplePieChartComponent, D3StackedBarChartOptions$1 as D3StackedBarChartOptions, D3StackedBarComponent, D3StackedLineChartComponent, D3StreamLineChartComponent, DataService, DataexportService, DateFilter, DateFilterPopupComponent, DatePickerComponent, DatePickerModalComponent, DonutChart, DropdownComboTextComponent, DropdownFilterComponent, DropdownFilterPipe, DropdownRoleSimpleComponent, DropdownSimpleComponent, DropdownWithCheckboxComponent, DropdownWithSearchoptionComponent, DropdownWithSubtextComponent, DropdownWithSubtitleComponent, DropdownWithTextfieldComponent, EmailInputComponent, EngagementsService, FileDropDirective, FileUtils, FilterData, FilterdataPipe, FocusDirective, FooterIcpLogoComponent, FooterLogoComponent, GeneralPaginationComponent, GenericDropdownComponent, GenericDropdownFilterComponent, GenericDropdownFilterPipe, GenericDropdownSearchComponent, GodDashboardService, GoogleMapComponent, GoogleMapForIotComponent, GoogleMapNewComponent, HTTPClientInterceptor, HeaderSpacesComponent, HomeService, HttpClientWrapperService, ITEM, ITEM_TYPE, IdleTimeoutComponent, IntegrationService, IntegrationsBaseService, InteractionLog, InteractionService, IoTExplorerService, IoTUsersFilterPipe, IoTWebSocketConnection, IoTWebSocketService, IotPaginationComponent, IotUserDropdownFilterComponent, Lh2RightnowTreeComponent, Lh2Service, LicenceInfoSpacesComponent, LicenseAdoptionComponent, LicenseDetails, LicenseInfoComponent, LicenseInfoSpacesPopupComponent, LineChart, Location, LocationAction, LocationBetaSwitchComponent, LocationFlag, LocationPopupComponent, LocationRow, LocationRowV2Component, LocationSearchComponent, LocationSelectionDropdownComponent, LocationService, LocationUtils, LocationWrap, LoggerService, LoginHistoryComponent, MagneticAppSelectionComponent, MagneticAppSwitcherComponent, MagneticBaseComponent, MagneticConfirmationDialogComponent, MagneticHelpSectionComponent, MagneticLicenseInfoComponent, MagneticLocationPopupComponent, MagneticMenuItemComponent, MagneticProfileDialogComponent, MagneticTacSupportComponent, ManageLh2TreeComponent, ManageLocationTreeComponent, ManageLocationTreeV3Component, MapService, MigrateConnectorComponent, MonitorService, MonthPickerComponent, MuiltiselectDropdownComponent, MultiselectDropdownNoApisearchComponent, NavToggler, NavigationAppComponent, NavigationAppModel, NavigationHomeComponent, NavigationHomeModel, NavigationUserInfoComponent, NavigationV2AppComponent, NetworkSyncStatusComponent, NewlocationUtils, NotificationChannelService, NouisliderComponent, OpenRoamingGlobalStatsComponent, OpenRoamingService, OpenroamingHotspotListComponent, POSITION, PaginationComponent, PartnerAppsService, PartnerSandboxAppsService, PersonasService, PinCameraPopupComponent, PinCamerasComponent, PinLocationsComponent, PortalService, PxgridService, QrCodeComponent, QuillRteComponent, RangeBarChartComponent, RangeSliderComponent, ReportDescriptionComponent, ReportDonut, ReportEmptyComponent, ReportFilter, ReportFilterComponent, ReportHeader, BreadCrumb$1 as ReportHeaderBreadCrumb, ReportHeaderComponent, ReportLocationTreeComponent, ReportPeriodComponent, ReportRequestData, ReportService, ReportUtils, ReportsDataexportService, RightnowService, RowMenuComponent, RuleReportHeader, RuleService, SECTION, SafeHtmlPipe, SafeUrlPipe, ScheduleFilterPipe, SdkAppService, SdkService, SearchBasicComponent, SearchComponent, SearchPipe, SensorListComponent, SensorService, SetupNotifyComponent, SetupPlatformAppService, ShareComponent, ShareReportDialogComponent, SharedLibComponent, SharedLibModule, SharedLibService, SignageService, SmartLicenseBannerComponent, SmartLicenseBaseComponent, SmartLicensePopupComponent, SmsGatewayService, SmsHighlighterComponent, SocialAppService, SpaceManagerWsConnService, SpaceManagerWsService, SpacesLocationHierarchyComponent, SpacesPeriod, SplitLicenseChangeComponent, SplitLicenseUsageComponent, SsidService, StandardizedLocationHierachyComponent, StandardizedLocationHierachyV2Component, StatsTooltipContainerComponent, StatsTooltipContentComponent, StatstooltipDirective, SupportSectionComponent, TYPE, TableChart, TableChartComponent, TagsDropdownComponent, TeamGenericDropdownComponent, TilesService, TimePickerComponent, TmsAuthService, ToastMessage, TokenGenerationComponent, TokenGenerationV3Component, Tooltip, TooltipContainerComponent, TooltipContentComponent, TooltipDirective, TooltipService, UpdateCountryPopupComponent, UpdateProfilePopupComponent, UserRole, UserRoleForEngagements, UserRoleForIoT, UserRoleForOpenRoaming, UserRoleForPersonas, UserRoleForSignage, UserRoleForWorkspace, UserService, Utils, VerifyPhoneNumberComponent, VersionCheckService, VisitLocations, WebexService, WebexTeamService, WebsocketService, WelcomeComponent, WlcIpFilterPipe, WorkspaceExperienceService, WorkspaceLocationHierarchyComponent, WsService, WsconnectService, XAxis, YAxis, YAxisTickFormatter, _byteToUnit };
